(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    root.repo = factory(typeof repo === 'undefined' ? {} : repo);
}(this, function (_) {
  'use strict';
  _no_name_provided__3.prototype = Object.create(AbstractCollection.prototype);
  _no_name_provided__3.prototype.constructor = _no_name_provided__3;
  SequenceBuilderIterator.prototype = Object.create(SequenceScope.prototype);
  SequenceBuilderIterator.prototype.constructor = SequenceBuilderIterator;
  CoroutineSingletons.prototype = Object.create(Enum.prototype);
  CoroutineSingletons.prototype.constructor = CoroutineSingletons;
  Default.prototype = Object.create(Random.prototype);
  Default.prototype.constructor = Default;
  XorWowRandom.prototype = Object.create(Random.prototype);
  XorWowRandom.prototype.constructor = XorWowRandom;
  LazyThreadSafetyMode.prototype = Object.create(Enum.prototype);
  LazyThreadSafetyMode.prototype.constructor = LazyThreadSafetyMode;
  Error_0.prototype = Object.create(Error.prototype);
  Error_0.prototype.constructor = Error_0;
  NotImplementedError.prototype = Object.create(Error_0.prototype);
  NotImplementedError.prototype.constructor = NotImplementedError;
  Iterator.prototype = Object.create(UByteIterator.prototype);
  Iterator.prototype.constructor = Iterator;
  Iterator_0.prototype = Object.create(UIntIterator.prototype);
  Iterator_0.prototype.constructor = Iterator_0;
  Iterator_1.prototype = Object.create(ULongIterator.prototype);
  Iterator_1.prototype.constructor = Iterator_1;
  Iterator_2.prototype = Object.create(UShortIterator.prototype);
  Iterator_2.prototype.constructor = Iterator_2;
  IntProgressionIterator.prototype = Object.create(IntIterator.prototype);
  IntProgressionIterator.prototype.constructor = IntProgressionIterator;
  LongProgressionIterator.prototype = Object.create(LongIterator.prototype);
  LongProgressionIterator.prototype.constructor = LongProgressionIterator;
  CharProgressionIterator.prototype = Object.create(CharIterator.prototype);
  CharProgressionIterator.prototype.constructor = CharProgressionIterator;
  IntRange.prototype = Object.create(IntProgression.prototype);
  IntRange.prototype.constructor = IntRange;
  LongRange.prototype = Object.create(LongProgression.prototype);
  LongRange.prototype.constructor = LongRange;
  CharRange.prototype = Object.create(CharProgression.prototype);
  CharRange.prototype.constructor = CharRange;
  AbstractMutableCollection.prototype = Object.create(AbstractCollection.prototype);
  AbstractMutableCollection.prototype.constructor = AbstractMutableCollection;
  ListIteratorImpl.prototype = Object.create(IteratorImpl.prototype);
  ListIteratorImpl.prototype.constructor = ListIteratorImpl;
  AbstractMutableList.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableList.prototype.constructor = AbstractMutableList;
  AbstractMutableSet.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableSet.prototype.constructor = AbstractMutableSet;
  AbstractEntrySet.prototype = Object.create(AbstractMutableSet.prototype);
  AbstractEntrySet.prototype.constructor = AbstractEntrySet;
  _no_name_provided__14.prototype = Object.create(AbstractMutableSet.prototype);
  _no_name_provided__14.prototype.constructor = _no_name_provided__14;
  _no_name_provided__15.prototype = Object.create(AbstractMutableCollection.prototype);
  _no_name_provided__15.prototype.constructor = _no_name_provided__15;
  AbstractMutableMap.prototype = Object.create(AbstractMap.prototype);
  AbstractMutableMap.prototype.constructor = AbstractMutableMap;
  ArrayList.prototype = Object.create(AbstractMutableList.prototype);
  ArrayList.prototype.constructor = ArrayList;
  EntrySet.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet.prototype.constructor = EntrySet;
  HashMap.prototype = Object.create(AbstractMutableMap.prototype);
  HashMap.prototype.constructor = HashMap;
  HashSet.prototype = Object.create(AbstractMutableSet.prototype);
  HashSet.prototype.constructor = HashSet;
  ChainEntry.prototype = Object.create(SimpleEntry.prototype);
  ChainEntry.prototype.constructor = ChainEntry;
  EntrySet_0.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet_0.prototype.constructor = EntrySet_0;
  LinkedHashMap.prototype = Object.create(HashMap.prototype);
  LinkedHashMap.prototype.constructor = LinkedHashMap;
  LinkedHashSet.prototype = Object.create(HashSet.prototype);
  LinkedHashSet.prototype.constructor = LinkedHashSet;
  NodeJsOutput_0.prototype = Object.create(BaseOutput.prototype);
  NodeJsOutput_0.prototype.constructor = NodeJsOutput_0;
  BufferedOutput_0.prototype = Object.create(BaseOutput.prototype);
  BufferedOutput_0.prototype.constructor = BufferedOutput_0;
  BufferedOutputToConsoleLog_0.prototype = Object.create(BufferedOutput_0.prototype);
  BufferedOutputToConsoleLog_0.prototype.constructor = BufferedOutputToConsoleLog_0;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  IllegalStateException.prototype = Object.create(RuntimeException.prototype);
  IllegalStateException.prototype.constructor = IllegalStateException;
  CancellationException.prototype = Object.create(IllegalStateException.prototype);
  CancellationException.prototype.constructor = CancellationException;
  PrimitiveKClassImpl.prototype = Object.create(KClassImpl.prototype);
  PrimitiveKClassImpl.prototype.constructor = PrimitiveKClassImpl;
  NothingKClassImpl.prototype = Object.create(KClassImpl.prototype);
  NothingKClassImpl.prototype.constructor = NothingKClassImpl;
  SimpleKClassImpl.prototype = Object.create(KClassImpl.prototype);
  SimpleKClassImpl.prototype.constructor = SimpleKClassImpl;
  _no_name_provided__41.prototype = Object.create(AbstractCollection.prototype);
  _no_name_provided__41.prototype.constructor = _no_name_provided__41;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  _no_name_provided__1_3.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__1_3.prototype.constructor = _no_name_provided__1_3;
  _no_name_provided__1_4.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__1_4.prototype.constructor = _no_name_provided__1_4;
  IllegalArgumentException.prototype = Object.create(RuntimeException.prototype);
  IllegalArgumentException.prototype.constructor = IllegalArgumentException;
  NoSuchElementException.prototype = Object.create(RuntimeException.prototype);
  NoSuchElementException.prototype.constructor = NoSuchElementException;
  UnsupportedOperationException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;
  IndexOutOfBoundsException.prototype = Object.create(RuntimeException.prototype);
  IndexOutOfBoundsException.prototype.constructor = IndexOutOfBoundsException;
  NumberFormatException.prototype = Object.create(IllegalArgumentException.prototype);
  NumberFormatException.prototype.constructor = NumberFormatException;
  ArithmeticException.prototype = Object.create(RuntimeException.prototype);
  ArithmeticException.prototype.constructor = ArithmeticException;
  AssertionError.prototype = Object.create(Error_0.prototype);
  AssertionError.prototype.constructor = AssertionError;
  NullPointerException.prototype = Object.create(RuntimeException.prototype);
  NullPointerException.prototype.constructor = NullPointerException;
  NoWhenBranchMatchedException.prototype = Object.create(RuntimeException.prototype);
  NoWhenBranchMatchedException.prototype.constructor = NoWhenBranchMatchedException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  UninitializedPropertyAccessException.prototype = Object.create(RuntimeException.prototype);
  UninitializedPropertyAccessException.prototype.constructor = UninitializedPropertyAccessException;
  DatePart.prototype = Object.create(Enum.prototype);
  DatePart.prototype.constructor = DatePart;
  DayOfWeek.prototype = Object.create(Enum.prototype);
  DayOfWeek.prototype.constructor = DayOfWeek;
  English.prototype = Object.create(KlockLocale.prototype);
  English.prototype.constructor = English;
  Companion_22.prototype = Object.create(English.prototype);
  Companion_22.prototype.constructor = Companion_22;
  Month.prototype = Object.create(Enum.prototype);
  Month.prototype.constructor = Month;
  RingBuffer.prototype = Object.create(ByteRingBuffer.prototype);
  RingBuffer.prototype.constructor = RingBuffer;
  FastArrayList.prototype = Object.create(AbstractMutableList.prototype);
  FastArrayList.prototype.constructor = FastArrayList;
  Fast32BufferF.prototype = Object.create(Fast32Buffer.prototype);
  Fast32BufferF.prototype.constructor = Fast32BufferF;
  _no_name_provided__58.prototype = Object.create(KmemGCImpl.prototype);
  _no_name_provided__58.prototype.constructor = _no_name_provided__58;
  Kind.prototype = Object.create(Enum.prototype);
  Kind.prototype.constructor = Kind;
  Color.prototype = Object.create(Enum.prototype);
  Color.prototype.constructor = Color;
  Level.prototype = Object.create(Enum.prototype);
  Level.prototype.constructor = Level;
  Console_0.prototype = Object.create(BaseConsole.prototype);
  Console_0.prototype.constructor = Console_0;
  None.prototype = Object.create(TraceBase.prototype);
  None.prototype.constructor = None;
  AbstractCoroutine.prototype = Object.create(JobSupport.prototype);
  AbstractCoroutine.prototype.constructor = AbstractCoroutine;
  StandaloneCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  StandaloneCoroutine.prototype.constructor = StandaloneCoroutine;
  LazyStandaloneCoroutine.prototype = Object.create(StandaloneCoroutine.prototype);
  LazyStandaloneCoroutine.prototype.constructor = LazyStandaloneCoroutine;
  $awaitCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitCOROUTINE$0.prototype.constructor = $awaitCOROUTINE$0;
  DeferredCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  DeferredCoroutine.prototype.constructor = DeferredCoroutine;
  LazyDeferredCoroutine.prototype = Object.create(DeferredCoroutine.prototype);
  LazyDeferredCoroutine.prototype.constructor = LazyDeferredCoroutine;
  ScopeCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  ScopeCoroutine.prototype.constructor = ScopeCoroutine;
  DispatchedCoroutine.prototype = Object.create(ScopeCoroutine.prototype);
  DispatchedCoroutine.prototype.constructor = DispatchedCoroutine;
  CancelHandler.prototype = Object.create(CancelHandlerBase.prototype);
  CancelHandler.prototype.constructor = CancelHandler;
  DisposeOnCancel.prototype = Object.create(CancelHandler.prototype);
  DisposeOnCancel.prototype.constructor = DisposeOnCancel;
  BeforeResumeCancelHandler.prototype = Object.create(CancelHandler.prototype);
  BeforeResumeCancelHandler.prototype.constructor = BeforeResumeCancelHandler;
  RemoveOnCancel.prototype = Object.create(BeforeResumeCancelHandler.prototype);
  RemoveOnCancel.prototype.constructor = RemoveOnCancel;
  DispatchedTask.prototype = Object.create(SchedulerTask.prototype);
  DispatchedTask.prototype.constructor = DispatchedTask;
  CancellableContinuationImpl.prototype = Object.create(DispatchedTask.prototype);
  CancellableContinuationImpl.prototype.constructor = CancellableContinuationImpl;
  InvokeOnCancel.prototype = Object.create(CancelHandler.prototype);
  InvokeOnCancel.prototype.constructor = InvokeOnCancel;
  $awaitCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $awaitCOROUTINE$1.prototype.constructor = $awaitCOROUTINE$1;
  CompletableDeferredImpl.prototype = Object.create(JobSupport.prototype);
  CompletableDeferredImpl.prototype.constructor = CompletableDeferredImpl;
  CancelledContinuation.prototype = Object.create(CompletedExceptionally.prototype);
  CancelledContinuation.prototype.constructor = CancelledContinuation;
  Key_1.prototype = Object.create(AbstractCoroutineContextKey.prototype);
  Key_1.prototype.constructor = Key_1;
  CoroutineDispatcher.prototype = Object.create(AbstractCoroutineContextElement.prototype);
  CoroutineDispatcher.prototype.constructor = CoroutineDispatcher;
  CoroutineStart.prototype = Object.create(Enum.prototype);
  CoroutineStart.prototype.constructor = CoroutineStart;
  EventLoop.prototype = Object.create(CoroutineDispatcher.prototype);
  EventLoop.prototype.constructor = EventLoop;
  CompletionHandlerException.prototype = Object.create(RuntimeException.prototype);
  CompletionHandlerException.prototype.constructor = CompletionHandlerException;
  CoroutinesInternalError.prototype = Object.create(Error_0.prototype);
  CoroutinesInternalError.prototype.constructor = CoroutinesInternalError;
  LinkedListHead.prototype = Object.create(LinkedListNode.prototype);
  LinkedListHead.prototype.constructor = LinkedListHead;
  NodeList_0.prototype = Object.create(LinkedListHead.prototype);
  NodeList_0.prototype.constructor = NodeList_0;
  CompletionHandlerBase.prototype = Object.create(LinkedListNode.prototype);
  CompletionHandlerBase.prototype.constructor = CompletionHandlerBase;
  JobNode.prototype = Object.create(CompletionHandlerBase.prototype);
  JobNode.prototype.constructor = JobNode;
  ChildCompletion.prototype = Object.create(JobNode.prototype);
  ChildCompletion.prototype.constructor = ChildCompletion;
  AwaitContinuation.prototype = Object.create(CancellableContinuationImpl.prototype);
  AwaitContinuation.prototype.constructor = AwaitContinuation;
  _no_name_provided__61.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__61.prototype.constructor = _no_name_provided__61;
  JobCancellingNode.prototype = Object.create(JobNode.prototype);
  JobCancellingNode.prototype.constructor = JobCancellingNode;
  ChildHandleNode.prototype = Object.create(JobCancellingNode.prototype);
  ChildHandleNode.prototype.constructor = ChildHandleNode;
  InvokeOnCancelling.prototype = Object.create(JobCancellingNode.prototype);
  InvokeOnCancelling.prototype.constructor = InvokeOnCancelling;
  InvokeOnCompletion.prototype = Object.create(JobNode.prototype);
  InvokeOnCompletion.prototype.constructor = InvokeOnCompletion;
  ResumeOnCompletion.prototype = Object.create(JobNode.prototype);
  ResumeOnCompletion.prototype.constructor = ResumeOnCompletion;
  ResumeAwaitOnCompletion.prototype = Object.create(JobNode.prototype);
  ResumeAwaitOnCompletion.prototype.constructor = ResumeAwaitOnCompletion;
  ChildContinuation.prototype = Object.create(JobCancellingNode.prototype);
  ChildContinuation.prototype.constructor = ChildContinuation;
  JobImpl.prototype = Object.create(JobSupport.prototype);
  JobImpl.prototype.constructor = JobImpl;
  DisposeOnCompletion.prototype = Object.create(JobNode.prototype);
  DisposeOnCompletion.prototype.constructor = DisposeOnCompletion;
  MainCoroutineDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  MainCoroutineDispatcher.prototype.constructor = MainCoroutineDispatcher;
  SupervisorJobImpl.prototype = Object.create(JobImpl.prototype);
  SupervisorJobImpl.prototype.constructor = SupervisorJobImpl;
  CancellationException_0.prototype = Object.create(IllegalStateException.prototype);
  CancellationException_0.prototype.constructor = CancellationException_0;
  TimeoutCancellationException.prototype = Object.create(CancellationException_0.prototype);
  TimeoutCancellationException.prototype.constructor = TimeoutCancellationException;
  TimeoutCoroutine.prototype = Object.create(ScopeCoroutine.prototype);
  TimeoutCoroutine.prototype.constructor = TimeoutCoroutine;
  Unconfined.prototype = Object.create(CoroutineDispatcher.prototype);
  Unconfined.prototype.constructor = Unconfined;
  RemoveReceiveOnCancel.prototype = Object.create(BeforeResumeCancelHandler.prototype);
  RemoveReceiveOnCancel.prototype.constructor = RemoveReceiveOnCancel;
  Receive.prototype = Object.create(LinkedListNode.prototype);
  Receive.prototype.constructor = Receive;
  ReceiveElement.prototype = Object.create(Receive.prototype);
  ReceiveElement.prototype.constructor = ReceiveElement;
  ReceiveElementWithUndeliveredHandler.prototype = Object.create(ReceiveElement.prototype);
  ReceiveElementWithUndeliveredHandler.prototype.constructor = ReceiveElementWithUndeliveredHandler;
  AbstractChannel.prototype = Object.create(AbstractSendChannel.prototype);
  AbstractChannel.prototype.constructor = AbstractChannel;
  Send.prototype = Object.create(LinkedListNode.prototype);
  Send.prototype.constructor = Send;
  SendBuffered.prototype = Object.create(Send.prototype);
  SendBuffered.prototype.constructor = SendBuffered;
  Closed.prototype = Object.create(Send.prototype);
  Closed.prototype.constructor = Closed;
  SendElement.prototype = Object.create(Send.prototype);
  SendElement.prototype.constructor = SendElement;
  SendElementWithUndeliveredHandler.prototype = Object.create(SendElement.prototype);
  SendElementWithUndeliveredHandler.prototype.constructor = SendElementWithUndeliveredHandler;
  ArrayChannel.prototype = Object.create(AbstractChannel.prototype);
  ArrayChannel.prototype.constructor = ArrayChannel;
  BufferOverflow.prototype = Object.create(Enum.prototype);
  BufferOverflow.prototype.constructor = BufferOverflow;
  ClosedReceiveChannelException.prototype = Object.create(NoSuchElementException.prototype);
  ClosedReceiveChannelException.prototype.constructor = ClosedReceiveChannelException;
  ClosedSendChannelException.prototype = Object.create(IllegalStateException.prototype);
  ClosedSendChannelException.prototype.constructor = ClosedSendChannelException;
  ChannelCoroutine.prototype = Object.create(AbstractCoroutine.prototype);
  ChannelCoroutine.prototype.constructor = ChannelCoroutine;
  ConflatedChannel.prototype = Object.create(AbstractChannel.prototype);
  ConflatedChannel.prototype.constructor = ConflatedChannel;
  LinkedListChannel.prototype = Object.create(AbstractChannel.prototype);
  LinkedListChannel.prototype.constructor = LinkedListChannel;
  ProducerCoroutine.prototype = Object.create(ChannelCoroutine.prototype);
  ProducerCoroutine.prototype.constructor = ProducerCoroutine;
  RendezvousChannel.prototype = Object.create(AbstractChannel.prototype);
  RendezvousChannel.prototype.constructor = RendezvousChannel;
  SafeFlow.prototype = Object.create(AbstractFlow.prototype);
  SafeFlow.prototype.constructor = SafeFlow;
  $collect_2COROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $collect_2COROUTINE$3.prototype.constructor = $collect_2COROUTINE$3;
  $emitAllImplCOROUTINE$4.prototype = Object.create(CoroutineImpl_0.prototype);
  $emitAllImplCOROUTINE$4.prototype.constructor = $emitAllImplCOROUTINE$4;
  $collectCOROUTINE$5.prototype = Object.create(CoroutineImpl_0.prototype);
  $collectCOROUTINE$5.prototype.constructor = $collectCOROUTINE$5;
  $toCollectionCOROUTINE$11.prototype = Object.create(CoroutineImpl_0.prototype);
  $toCollectionCOROUTINE$11.prototype.constructor = $toCollectionCOROUTINE$11;
  $firstOrNullCOROUTINE$12.prototype = Object.create(CoroutineImpl_0.prototype);
  $firstOrNullCOROUTINE$12.prototype.constructor = $firstOrNullCOROUTINE$12;
  DispatchedContinuation.prototype = Object.create(DispatchedTask.prototype);
  DispatchedContinuation.prototype.constructor = DispatchedContinuation;
  UndeliveredElementException.prototype = Object.create(RuntimeException.prototype);
  UndeliveredElementException.prototype.constructor = UndeliveredElementException;
  UndispatchedCoroutine.prototype = Object.create(ScopeCoroutine.prototype);
  UndispatchedCoroutine.prototype.constructor = UndispatchedCoroutine;
  JsMainDispatcher.prototype = Object.create(MainCoroutineDispatcher.prototype);
  JsMainDispatcher.prototype.constructor = JsMainDispatcher;
  UnconfinedEventLoop.prototype = Object.create(EventLoop.prototype);
  UnconfinedEventLoop.prototype.constructor = UnconfinedEventLoop;
  JobCancellationException.prototype = Object.create(CancellationException_0.prototype);
  JobCancellationException.prototype.constructor = JobCancellationException;
  SetTimeoutBasedDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  SetTimeoutBasedDispatcher.prototype.constructor = SetTimeoutBasedDispatcher;
  NodeDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  NodeDispatcher.prototype.constructor = NodeDispatcher;
  SetTimeoutDispatcher.prototype = Object.create(SetTimeoutBasedDispatcher.prototype);
  SetTimeoutDispatcher.prototype.constructor = SetTimeoutDispatcher;
  MessageQueue.prototype = Object.create(ArrayQueue.prototype);
  MessageQueue.prototype.constructor = MessageQueue;
  ScheduledMessageQueue.prototype = Object.create(MessageQueue.prototype);
  ScheduledMessageQueue.prototype.constructor = ScheduledMessageQueue;
  ClearTimeout.prototype = Object.create(CancelHandler.prototype);
  ClearTimeout.prototype.constructor = ClearTimeout;
  WindowDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  WindowDispatcher.prototype.constructor = WindowDispatcher;
  WindowMessageQueue.prototype = Object.create(MessageQueue.prototype);
  WindowMessageQueue.prototype.constructor = WindowMessageQueue;
  AbortFlowException.prototype = Object.create(CancellationException_0.prototype);
  AbortFlowException.prototype.constructor = AbortFlowException;
  _no_name_provided__73.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__73.prototype.constructor = _no_name_provided__73;
  _no_name_provided__74.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__74.prototype.constructor = _no_name_provided__74;
  _no_name_provided__75.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__75.prototype.constructor = _no_name_provided__75;
  $invokeCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $invokeCOROUTINE$2.prototype.constructor = $invokeCOROUTINE$2;
  _no_name_provided__76.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__76.prototype.constructor = _no_name_provided__76;
  Signal.prototype = Object.create(BaseSignal.prototype);
  Signal.prototype.constructor = Signal;
  $invokeCOROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $invokeCOROUTINE$3.prototype.constructor = $invokeCOROUTINE$3;
  AsyncSignal.prototype = Object.create(BaseSignal.prototype);
  AsyncSignal.prototype.constructor = AsyncSignal;
  _no_name_provided__79.prototype = Object.create(AbstractCoroutineContextElement.prototype);
  _no_name_provided__79.prototype.constructor = _no_name_provided__79;
  _no_name_provided__81.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__81.prototype.constructor = _no_name_provided__81;
  _no_name_provided__82.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__82.prototype.constructor = _no_name_provided__82;
  $flushCOROUTINE$8.prototype = Object.create(CoroutineImpl_0.prototype);
  $flushCOROUTINE$8.prototype.constructor = $flushCOROUTINE$8;
  Companion_42.prototype = Object.create(DeflatePortable.prototype);
  Companion_42.prototype.constructor = Companion_42;
  $compressCOROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $compressCOROUTINE$6.prototype.constructor = $compressCOROUTINE$6;
  $uncompressCOROUTINE$7.prototype = Object.create(CoroutineImpl_0.prototype);
  $uncompressCOROUTINE$7.prototype.constructor = $uncompressCOROUTINE$7;
  $writeCOROUTINE$16.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$16.prototype.constructor = $writeCOROUTINE$16;
  $readCOROUTINE$17.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$17.prototype.constructor = $readCOROUTINE$17;
  Companion_43.prototype = Object.create(ZLib.prototype);
  Companion_43.prototype.constructor = Companion_43;
  $uncompressCOROUTINE$14.prototype = Object.create(CoroutineImpl_0.prototype);
  $uncompressCOROUTINE$14.prototype.constructor = $uncompressCOROUTINE$14;
  $compressCOROUTINE$15.prototype = Object.create(CoroutineImpl_0.prototype);
  $compressCOROUTINE$15.prototype.constructor = $compressCOROUTINE$15;
  $prepareBytesUpToCOROUTINE$19.prototype = Object.create(CoroutineImpl_0.prototype);
  $prepareBytesUpToCOROUTINE$19.prototype.constructor = $prepareBytesUpToCOROUTINE$19;
  $abytesCOROUTINE$20.prototype = Object.create(CoroutineImpl_0.prototype);
  $abytesCOROUTINE$20.prototype.constructor = $abytesCOROUTINE$20;
  $readCOROUTINE$21.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$21.prototype.constructor = $readCOROUTINE$21;
  $invokeCOROUTINE$24.prototype = Object.create(CoroutineImpl_0.prototype);
  $invokeCOROUTINE$24.prototype.constructor = $invokeCOROUTINE$24;
  $readCOROUTINE$25.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$25.prototype.constructor = $readCOROUTINE$25;
  Companion_47.prototype = Object.create(KDynamic.prototype);
  Companion_47.prototype.constructor = Companion_47;
  TypeContext.prototype = Object.create(KDynamic.prototype);
  TypeContext.prototype.constructor = TypeContext;
  $emit_2COROUTINE$51.prototype = Object.create(CoroutineImpl_0.prototype);
  $emit_2COROUTINE$51.prototype.constructor = $emit_2COROUTINE$51;
  _no_name_provided__99.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__99.prototype.constructor = _no_name_provided__99;
  $getUnderlyingUnscapedFileCOROUTINE$36.prototype = Object.create(CoroutineImpl_0.prototype);
  $getUnderlyingUnscapedFileCOROUTINE$36.prototype.constructor = $getUnderlyingUnscapedFileCOROUTINE$36;
  $initOnceCOROUTINE$37.prototype = Object.create(CoroutineImpl_0.prototype);
  $initOnceCOROUTINE$37.prototype.constructor = $initOnceCOROUTINE$37;
  $openCOROUTINE$39.prototype = Object.create(CoroutineImpl_0.prototype);
  $openCOROUTINE$39.prototype.constructor = $openCOROUTINE$39;
  $readRangeCOROUTINE$40.prototype = Object.create(CoroutineImpl_0.prototype);
  $readRangeCOROUTINE$40.prototype.constructor = $readRangeCOROUTINE$40;
  $statCOROUTINE$43.prototype = Object.create(CoroutineImpl_0.prototype);
  $statCOROUTINE$43.prototype.constructor = $statCOROUTINE$43;
  $listSimpleCOROUTINE$44.prototype = Object.create(CoroutineImpl_0.prototype);
  $listSimpleCOROUTINE$44.prototype.constructor = $listSimpleCOROUTINE$44;
  Kind_0.prototype = Object.create(Enum.prototype);
  Kind_0.prototype.constructor = Kind_0;
  Proxy.prototype = Object.create(Vfs.prototype);
  Proxy.prototype.constructor = Proxy;
  _no_name_provided__100.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__100.prototype.constructor = _no_name_provided__100;
  $readRangeCOROUTINE$29.prototype = Object.create(CoroutineImpl_0.prototype);
  $readRangeCOROUTINE$29.prototype.constructor = $readRangeCOROUTINE$29;
  $listSimpleCOROUTINE$34.prototype = Object.create(CoroutineImpl_0.prototype);
  $listSimpleCOROUTINE$34.prototype.constructor = $listSimpleCOROUTINE$34;
  VfsOpenMode.prototype = Object.create(Enum.prototype);
  VfsOpenMode.prototype.constructor = VfsOpenMode;
  VfsV2.prototype = Object.create(Vfs.prototype);
  VfsV2.prototype.constructor = VfsV2;
  $emit_2COROUTINE$71.prototype = Object.create(CoroutineImpl_0.prototype);
  $emit_2COROUTINE$71.prototype.constructor = $emit_2COROUTINE$71;
  _no_name_provided__102.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__102.prototype.constructor = _no_name_provided__102;
  $readStringCOROUTINE$58.prototype = Object.create(CoroutineImpl_0.prototype);
  $readStringCOROUTINE$58.prototype.constructor = $readStringCOROUTINE$58;
  VfsFile.prototype = Object.create(VfsNamed.prototype);
  VfsFile.prototype.constructor = VfsFile;
  _no_name_provided__103.prototype = Object.create(Proxy.prototype);
  _no_name_provided__103.prototype.constructor = _no_name_provided__103;
  LocalVfs.prototype = Object.create(Vfs.prototype);
  LocalVfs.prototype.constructor = LocalVfs;
  $updateInfoCOROUTINE$81.prototype = Object.create(CoroutineImpl_0.prototype);
  $updateInfoCOROUTINE$81.prototype.constructor = $updateInfoCOROUTINE$81;
  $writeCOROUTINE$82.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$82.prototype.constructor = $writeCOROUTINE$82;
  _no_name_provided__104.prototype = Object.create(AsyncStreamBase.prototype);
  _no_name_provided__104.prototype.constructor = _no_name_provided__104;
  $initOnceCOROUTINE$73.prototype = Object.create(CoroutineImpl_0.prototype);
  $initOnceCOROUTINE$73.prototype.constructor = $initOnceCOROUTINE$73;
  $statCOROUTINE$75.prototype = Object.create(CoroutineImpl_0.prototype);
  $statCOROUTINE$75.prototype.constructor = $statCOROUTINE$75;
  $ensureParentDirectoryCOROUTINE$76.prototype = Object.create(CoroutineImpl_0.prototype);
  $ensureParentDirectoryCOROUTINE$76.prototype.constructor = $ensureParentDirectoryCOROUTINE$76;
  $listFlowCOROUTINE$78.prototype = Object.create(CoroutineImpl_0.prototype);
  $listFlowCOROUTINE$78.prototype.constructor = $listFlowCOROUTINE$78;
  $openCOROUTINE$79.prototype = Object.create(CoroutineImpl_0.prototype);
  $openCOROUTINE$79.prototype.constructor = $openCOROUTINE$79;
  MapLikeStorageVfs.prototype = Object.create(VfsV2.prototype);
  MapLikeStorageVfs.prototype.constructor = MapLikeStorageVfs;
  $setEntryInfoCOROUTINE$83.prototype = Object.create(CoroutineImpl_0.prototype);
  $setEntryInfoCOROUTINE$83.prototype.constructor = $setEntryInfoCOROUTINE$83;
  $hasEntryInfoCOROUTINE$84.prototype = Object.create(CoroutineImpl_0.prototype);
  $hasEntryInfoCOROUTINE$84.prototype.constructor = $hasEntryInfoCOROUTINE$84;
  $getEntryInfoCOROUTINE$85.prototype = Object.create(CoroutineImpl_0.prototype);
  $getEntryInfoCOROUTINE$85.prototype.constructor = $getEntryInfoCOROUTINE$85;
  $setFileChunkCOROUTINE$87.prototype = Object.create(CoroutineImpl_0.prototype);
  $setFileChunkCOROUTINE$87.prototype.constructor = $setFileChunkCOROUTINE$87;
  $getFileChunkCOROUTINE$88.prototype = Object.create(CoroutineImpl_0.prototype);
  $getFileChunkCOROUTINE$88.prototype.constructor = $getFileChunkCOROUTINE$88;
  $writeDataCOROUTINE$89.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeDataCOROUTINE$89.prototype.constructor = $writeDataCOROUTINE$89;
  $readDataCOROUTINE$90.prototype = Object.create(CoroutineImpl_0.prototype);
  $readDataCOROUTINE$90.prototype.constructor = $readDataCOROUTINE$90;
  $closeCOROUTINE$92.prototype = Object.create(CoroutineImpl_0.prototype);
  $closeCOROUTINE$92.prototype.constructor = $closeCOROUTINE$92;
  MountableVfs_0.prototype = Object.create(Proxy.prototype);
  MountableVfs_0.prototype.constructor = MountableVfs_0;
  $MountableVfsCOROUTINE$91.prototype = Object.create(CoroutineImpl_0.prototype);
  $MountableVfsCOROUTINE$91.prototype.constructor = $MountableVfsCOROUTINE$91;
  _no_name_provided__107.prototype = Object.create(AsyncStreamBase.prototype);
  _no_name_provided__107.prototype.constructor = _no_name_provided__107;
  _no_name_provided__108.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__108.prototype.constructor = _no_name_provided__108;
  $statCOROUTINE$93.prototype = Object.create(CoroutineImpl_0.prototype);
  $statCOROUTINE$93.prototype.constructor = $statCOROUTINE$93;
  NodeVfs.prototype = Object.create(VfsV2.prototype);
  NodeVfs.prototype.constructor = NodeVfs;
  $readCOROUTINE$100.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$100.prototype.constructor = $readCOROUTINE$100;
  _no_name_provided__112.prototype = Object.create(AsyncStreamBase.prototype);
  _no_name_provided__112.prototype.constructor = _no_name_provided__112;
  $openCOROUTINE$94.prototype = Object.create(CoroutineImpl_0.prototype);
  $openCOROUTINE$94.prototype.constructor = $openCOROUTINE$94;
  $_readRangeBaseCOROUTINE$96.prototype = Object.create(CoroutineImpl_0.prototype);
  $_readRangeBaseCOROUTINE$96.prototype.constructor = $_readRangeBaseCOROUTINE$96;
  $readRangeCOROUTINE$97.prototype = Object.create(CoroutineImpl_0.prototype);
  $readRangeCOROUTINE$97.prototype.constructor = $readRangeCOROUTINE$97;
  $statCOROUTINE$99.prototype = Object.create(CoroutineImpl_0.prototype);
  $statCOROUTINE$99.prototype.constructor = $statCOROUTINE$99;
  UrlVfs_0.prototype = Object.create(Vfs.prototype);
  UrlVfs_0.prototype.constructor = UrlVfs_0;
  _no_name_provided__113.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__113.prototype.constructor = _no_name_provided__113;
  $closeCOROUTINE$104.prototype = Object.create(CoroutineImpl_0.prototype);
  $closeCOROUTINE$104.prototype.constructor = $closeCOROUTINE$104;
  $openCOROUTINE$105.prototype = Object.create(CoroutineImpl_0.prototype);
  $openCOROUTINE$105.prototype.constructor = $openCOROUTINE$105;
  Impl.prototype = Object.create(VfsV2.prototype);
  Impl.prototype.constructor = Impl;
  $openAsZipCOROUTINE$101.prototype = Object.create(CoroutineImpl_0.prototype);
  $openAsZipCOROUTINE$101.prototype.constructor = $openAsZipCOROUTINE$101;
  $openAsZipCOROUTINE$102.prototype = Object.create(CoroutineImpl_0.prototype);
  $openAsZipCOROUTINE$102.prototype.constructor = $openAsZipCOROUTINE$102;
  $ZipVfsCOROUTINE$103.prototype = Object.create(CoroutineImpl_0.prototype);
  $ZipVfsCOROUTINE$103.prototype.constructor = $ZipVfsCOROUTINE$103;
  BaseSingleByteCharset.prototype = Object.create(Charset.prototype);
  BaseSingleByteCharset.prototype.constructor = BaseSingleByteCharset;
  SingleByteCharset.prototype = Object.create(BaseSingleByteCharset.prototype);
  SingleByteCharset.prototype.constructor = SingleByteCharset;
  ISO_8859_1.prototype = Object.create(SingleByteCharset.prototype);
  ISO_8859_1.prototype.constructor = ISO_8859_1;
  UTF16Charset.prototype = Object.create(Charset.prototype);
  UTF16Charset.prototype.constructor = UTF16Charset;
  UTC8CharsetBase.prototype = Object.create(Charset.prototype);
  UTC8CharsetBase.prototype.constructor = UTC8CharsetBase;
  ASCII.prototype = Object.create(BaseSingleByteCharset.prototype);
  ASCII.prototype.constructor = ASCII;
  InvalidOperationException.prototype = Object.create(Exception.prototype);
  InvalidOperationException.prototype.constructor = InvalidOperationException;
  _no_name_provided__120.prototype = Object.create(NativeThreadLocal.prototype);
  _no_name_provided__120.prototype.constructor = _no_name_provided__120;
  Methods.prototype = Object.create(Enum.prototype);
  Methods.prototype.constructor = Methods;
  IOException.prototype = Object.create(Exception.prototype);
  IOException.prototype.constructor = IOException;
  HttpException.prototype = Object.create(IOException.prototype);
  HttpException.prototype.constructor = HttpException;
  $readAllBytesCOROUTINE$108.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAllBytesCOROUTINE$108.prototype.constructor = $readAllBytesCOROUTINE$108;
  $readAllStringCOROUTINE$109.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAllStringCOROUTINE$109.prototype.constructor = $readAllStringCOROUTINE$109;
  $checkErrorsCOROUTINE$110.prototype = Object.create(CoroutineImpl_0.prototype);
  $checkErrorsCOROUTINE$110.prototype.constructor = $checkErrorsCOROUTINE$110;
  $requestCOROUTINE$111.prototype = Object.create(CoroutineImpl_0.prototype);
  $requestCOROUTINE$111.prototype.constructor = $requestCOROUTINE$111;
  $requestAsBytesCOROUTINE$113.prototype = Object.create(CoroutineImpl_0.prototype);
  $requestAsBytesCOROUTINE$113.prototype.constructor = $requestAsBytesCOROUTINE$113;
  $readBytesCOROUTINE$114.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesCOROUTINE$114.prototype.constructor = $readBytesCOROUTINE$114;
  ProcessingInstructionTag.prototype = Object.create(Element_1.prototype);
  ProcessingInstructionTag.prototype.constructor = ProcessingInstructionTag;
  OpenCloseTag.prototype = Object.create(Element_1.prototype);
  OpenCloseTag.prototype.constructor = OpenCloseTag;
  OpenTag.prototype = Object.create(Element_1.prototype);
  OpenTag.prototype.constructor = OpenTag;
  CommentTag.prototype = Object.create(Element_1.prototype);
  CommentTag.prototype.constructor = CommentTag;
  CloseTag.prototype = Object.create(Element_1.prototype);
  CloseTag.prototype.constructor = CloseTag;
  Text_0.prototype = Object.create(Element_1.prototype);
  Text_0.prototype.constructor = Text_0;
  _no_name_provided__128.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__128.prototype.constructor = _no_name_provided__128;
  Type.prototype = Object.create(Enum.prototype);
  Type.prototype.constructor = Type;
  _no_name_provided__131.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__131.prototype.constructor = _no_name_provided__131;
  _no_name_provided__132.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__132.prototype.constructor = _no_name_provided__132;
  $readCOROUTINE$129.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$129.prototype.constructor = $readCOROUTINE$129;
  $writeCOROUTINE$130.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$130.prototype.constructor = $writeCOROUTINE$130;
  $readInternalCOROUTINE$131.prototype = Object.create(CoroutineImpl_0.prototype);
  $readInternalCOROUTINE$131.prototype.constructor = $readInternalCOROUTINE$131;
  $writeInternalCOROUTINE$132.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeInternalCOROUTINE$132.prototype.constructor = $writeInternalCOROUTINE$132;
  $getAvailableCOROUTINE$133.prototype = Object.create(CoroutineImpl_0.prototype);
  $getAvailableCOROUTINE$133.prototype.constructor = $getAvailableCOROUTINE$133;
  $eofCOROUTINE$134.prototype = Object.create(CoroutineImpl_0.prototype);
  $eofCOROUTINE$134.prototype.constructor = $eofCOROUTINE$134;
  $readCOROUTINE$135.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$135.prototype.constructor = $readCOROUTINE$135;
  $writeCOROUTINE$137.prototype = Object.create(CoroutineImpl_0.prototype);
  $writeCOROUTINE$137.prototype.constructor = $writeCOROUTINE$137;
  $_readCOROUTINE$138.prototype = Object.create(CoroutineImpl_0.prototype);
  $_readCOROUTINE$138.prototype.constructor = $_readCOROUTINE$138;
  BufferedStreamBase.prototype = Object.create(AsyncStreamBase.prototype);
  BufferedStreamBase.prototype.constructor = BufferedStreamBase;
  MemoryAsyncStreamBase.prototype = Object.create(AsyncStreamBase.prototype);
  MemoryAsyncStreamBase.prototype.constructor = MemoryAsyncStreamBase;
  SyncAsyncStreamBase.prototype = Object.create(AsyncStreamBase.prototype);
  SyncAsyncStreamBase.prototype.constructor = SyncAsyncStreamBase;
  $closeCOROUTINE$163.prototype = Object.create(CoroutineImpl_0.prototype);
  $closeCOROUTINE$163.prototype.constructor = $closeCOROUTINE$163;
  SliceAsyncStreamBase.prototype = Object.create(AsyncStreamBase.prototype);
  SliceAsyncStreamBase.prototype.constructor = SliceAsyncStreamBase;
  $getPositionCOROUTINE$168.prototype = Object.create(CoroutineImpl_0.prototype);
  $getPositionCOROUTINE$168.prototype.constructor = $getPositionCOROUTINE$168;
  $getLengthCOROUTINE$169.prototype = Object.create(CoroutineImpl_0.prototype);
  $getLengthCOROUTINE$169.prototype.constructor = $getLengthCOROUTINE$169;
  $readAllCOROUTINE$136.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAllCOROUTINE$136.prototype.constructor = $readAllCOROUTINE$136;
  $readBytesExactCOROUTINE$139.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesExactCOROUTINE$139.prototype.constructor = $readBytesExactCOROUTINE$139;
  $hasAvailableCOROUTINE$140.prototype = Object.create(CoroutineImpl_0.prototype);
  $hasAvailableCOROUTINE$140.prototype.constructor = $hasAvailableCOROUTINE$140;
  $readBytesCOROUTINE$141.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesCOROUTINE$141.prototype.constructor = $readBytesCOROUTINE$141;
  $readExactCOROUTINE$142.prototype = Object.create(CoroutineImpl_0.prototype);
  $readExactCOROUTINE$142.prototype.constructor = $readExactCOROUTINE$142;
  $readBytesUpToCOROUTINE$144.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesUpToCOROUTINE$144.prototype.constructor = $readBytesUpToCOROUTINE$144;
  $readBytesUpToCopyCOROUTINE$146.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesUpToCopyCOROUTINE$146.prototype.constructor = $readBytesUpToCopyCOROUTINE$146;
  $getAvailableCOROUTINE$147.prototype = Object.create(CoroutineImpl_0.prototype);
  $getAvailableCOROUTINE$147.prototype.constructor = $getAvailableCOROUTINE$147;
  $readBytesUpToCOROUTINE$148.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBytesUpToCOROUTINE$148.prototype.constructor = $readBytesUpToCOROUTINE$148;
  $getAvailableCOROUTINE$149.prototype = Object.create(CoroutineImpl_0.prototype);
  $getAvailableCOROUTINE$149.prototype.constructor = $getAvailableCOROUTINE$149;
  $write16LECOROUTINE$150.prototype = Object.create(CoroutineImpl_0.prototype);
  $write16LECOROUTINE$150.prototype.constructor = $write16LECOROUTINE$150;
  $hasAvailableCOROUTINE$151.prototype = Object.create(CoroutineImpl_0.prototype);
  $hasAvailableCOROUTINE$151.prototype.constructor = $hasAvailableCOROUTINE$151;
  $readStringCOROUTINE$152.prototype = Object.create(CoroutineImpl_0.prototype);
  $readStringCOROUTINE$152.prototype.constructor = $readStringCOROUTINE$152;
  $readS8COROUTINE$153.prototype = Object.create(CoroutineImpl_0.prototype);
  $readS8COROUTINE$153.prototype.constructor = $readS8COROUTINE$153;
  $readS64LECOROUTINE$154.prototype = Object.create(CoroutineImpl_0.prototype);
  $readS64LECOROUTINE$154.prototype.constructor = $readS64LECOROUTINE$154;
  $readS32LECOROUTINE$155.prototype = Object.create(CoroutineImpl_0.prototype);
  $readS32LECOROUTINE$155.prototype.constructor = $readS32LECOROUTINE$155;
  $readS16LECOROUTINE$157.prototype = Object.create(CoroutineImpl_0.prototype);
  $readS16LECOROUTINE$157.prototype.constructor = $readS16LECOROUTINE$157;
  $readU32LECOROUTINE$158.prototype = Object.create(CoroutineImpl_0.prototype);
  $readU32LECOROUTINE$158.prototype.constructor = $readU32LECOROUTINE$158;
  $readSliceCOROUTINE$159.prototype = Object.create(CoroutineImpl_0.prototype);
  $readSliceCOROUTINE$159.prototype.constructor = $readSliceCOROUTINE$159;
  $sliceWithBoundsCOROUTINE$162.prototype = Object.create(CoroutineImpl_0.prototype);
  $sliceWithBoundsCOROUTINE$162.prototype.constructor = $sliceWithBoundsCOROUTINE$162;
  $write32BECOROUTINE$164.prototype = Object.create(CoroutineImpl_0.prototype);
  $write32BECOROUTINE$164.prototype.constructor = $write32BECOROUTINE$164;
  $sliceStartCOROUTINE$165.prototype = Object.create(CoroutineImpl_0.prototype);
  $sliceStartCOROUTINE$165.prototype.constructor = $sliceStartCOROUTINE$165;
  $readS32BECOROUTINE$166.prototype = Object.create(CoroutineImpl_0.prototype);
  $readS32BECOROUTINE$166.prototype.constructor = $readS32BECOROUTINE$166;
  $readU16LECOROUTINE$167.prototype = Object.create(CoroutineImpl_0.prototype);
  $readU16LECOROUTINE$167.prototype.constructor = $readU16LECOROUTINE$167;
  MemorySyncStreamBase.prototype = Object.create(SyncStreamBase.prototype);
  MemorySyncStreamBase.prototype.constructor = MemorySyncStreamBase;
  SliceSyncStreamBase.prototype = Object.create(SyncStreamBase.prototype);
  SliceSyncStreamBase.prototype.constructor = SliceSyncStreamBase;
  Language.prototype = Object.create(Enum.prototype);
  Language.prototype.constructor = Language;
  BlobAsyncBaseStream.prototype = Object.create(AsyncStreamBase.prototype);
  BlobAsyncBaseStream.prototype.constructor = BlobAsyncBaseStream;
  _no_name_provided__156.prototype = Object.create(Vfs.prototype);
  _no_name_provided__156.prototype.constructor = _no_name_provided__156;
  FileNotFoundException.prototype = Object.create(IOException.prototype);
  FileNotFoundException.prototype.constructor = FileNotFoundException;
  EOFException.prototype = Object.create(IOException.prototype);
  EOFException.prototype.constructor = EOFException;
  _no_name_provided__167.prototype = Object.create(UTC8CharsetBase.prototype);
  _no_name_provided__167.prototype.constructor = _no_name_provided__167;
  _no_name_provided__168.prototype = Object.create(AsyncSocketFactory.prototype);
  _no_name_provided__168.prototype.constructor = _no_name_provided__168;
  $requestInternalCOROUTINE$170.prototype = Object.create(CoroutineImpl_0.prototype);
  $requestInternalCOROUTINE$170.prototype.constructor = $requestInternalCOROUTINE$170;
  HttpClientBrowserJs.prototype = Object.create(HttpClient.prototype);
  HttpClientBrowserJs.prototype.constructor = HttpClientBrowserJs;
  $tryReadInfoCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $tryReadInfoCOROUTINE$0.prototype.constructor = $tryReadInfoCOROUTINE$0;
  $decodeStreamCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeStreamCOROUTINE$1.prototype.constructor = $decodeStreamCOROUTINE$1;
  $decodeStreamOrErrorCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeStreamOrErrorCOROUTINE$2.prototype.constructor = $decodeStreamOrErrorCOROUTINE$2;
  AudioFormats.prototype = Object.create(AudioFormat.prototype);
  AudioFormats.prototype.constructor = AudioFormats;
  InvalidAudioFormatException.prototype = Object.create(RuntimeException.prototype);
  InvalidAudioFormatException.prototype.constructor = InvalidAudioFormatException;
  MP3Base.prototype = Object.create(AudioFormat.prototype);
  MP3Base.prototype.constructor = MP3Base;
  MP3.prototype = Object.create(MP3Base.prototype);
  MP3.prototype.constructor = MP3;
  Companion_65.prototype = Object.create(MP3.prototype);
  Companion_65.prototype.constructor = Companion_65;
  ChannelMode.prototype = Object.create(Enum.prototype);
  ChannelMode.prototype.constructor = ChannelMode;
  $_getDurationCOROUTINE$8.prototype = Object.create(CoroutineImpl_0.prototype);
  $_getDurationCOROUTINE$8.prototype.constructor = $_getDurationCOROUTINE$8;
  $skipID3v2TagCOROUTINE$9.prototype = Object.create(CoroutineImpl_0.prototype);
  $skipID3v2TagCOROUTINE$9.prototype.constructor = $skipID3v2TagCOROUTINE$9;
  $tryReadInfoCOROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $tryReadInfoCOROUTINE$6.prototype.constructor = $tryReadInfoCOROUTINE$6;
  OggBase.prototype = Object.create(AudioFormat.prototype);
  OggBase.prototype.constructor = OggBase;
  OGG.prototype = Object.create(OggBase.prototype);
  OGG.prototype.constructor = OGG;
  Companion_68.prototype = Object.create(OGG.prototype);
  Companion_68.prototype.constructor = Companion_68;
  $tryReadInfoCOROUTINE$11.prototype = Object.create(CoroutineImpl_0.prototype);
  $tryReadInfoCOROUTINE$11.prototype.constructor = $tryReadInfoCOROUTINE$11;
  $parseCOROUTINE$12.prototype = Object.create(CoroutineImpl_0.prototype);
  $parseCOROUTINE$12.prototype.constructor = $parseCOROUTINE$12;
  $readCOROUTINE$15.prototype = Object.create(CoroutineImpl_0.prototype);
  $readCOROUTINE$15.prototype.constructor = $readCOROUTINE$15;
  $cloneCOROUTINE$16.prototype = Object.create(CoroutineImpl_0.prototype);
  $cloneCOROUTINE$16.prototype.constructor = $cloneCOROUTINE$16;
  WAV.prototype = Object.create(AudioFormat.prototype);
  WAV.prototype.constructor = WAV;
  Companion_69.prototype = Object.create(WAV.prototype);
  Companion_69.prototype.constructor = Companion_69;
  WavAudioStream.prototype = Object.create(AudioStream.prototype);
  WavAudioStream.prototype.constructor = WavAudioStream;
  _no_name_provided__180.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__180.prototype.constructor = _no_name_provided__180;
  $tryReadInfoCOROUTINE$13.prototype = Object.create(CoroutineImpl_0.prototype);
  $tryReadInfoCOROUTINE$13.prototype.constructor = $tryReadInfoCOROUTINE$13;
  $decodeStreamCOROUTINE$14.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeStreamCOROUTINE$14.prototype.constructor = $decodeStreamCOROUTINE$14;
  $parseCOROUTINE$18.prototype = Object.create(CoroutineImpl_0.prototype);
  $parseCOROUTINE$18.prototype.constructor = $parseCOROUTINE$18;
  $riffCOROUTINE$19.prototype = Object.create(CoroutineImpl_0.prototype);
  $riffCOROUTINE$19.prototype.constructor = $riffCOROUTINE$19;
  AudioDataStream.prototype = Object.create(AudioStream.prototype);
  AudioDataStream.prototype.constructor = AudioDataStream;
  $toDataCOROUTINE$21.prototype = Object.create(CoroutineImpl_0.prototype);
  $toDataCOROUTINE$21.prototype.constructor = $toDataCOROUTINE$21;
  _no_name_provided__183.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__183.prototype.constructor = _no_name_provided__183;
  $createSoundCOROUTINE$23.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$23.prototype.constructor = $createSoundCOROUTINE$23;
  $createSoundCOROUTINE$24.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$24.prototype.constructor = $createSoundCOROUTINE$24;
  $createSoundCOROUTINE$25.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$25.prototype.constructor = $createSoundCOROUTINE$25;
  _no_name_provided__184.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__184.prototype.constructor = _no_name_provided__184;
  _no_name_provided__185.prototype = Object.create(SoundChannel.prototype);
  _no_name_provided__185.prototype.constructor = _no_name_provided__185;
  SoundAudioStream.prototype = Object.create(Sound.prototype);
  SoundAudioStream.prototype.constructor = SoundAudioStream;
  $createSoundCOROUTINE$32.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$32.prototype.constructor = $createSoundCOROUTINE$32;
  $createSoundCOROUTINE$33.prototype = Object.create(CoroutineImpl_0.prototype);
  $createSoundCOROUTINE$33.prototype.constructor = $createSoundCOROUTINE$33;
  HtmlNativeSoundProvider.prototype = Object.create(NativeSoundProvider.prototype);
  HtmlNativeSoundProvider.prototype.constructor = HtmlNativeSoundProvider;
  _no_name_provided__187.prototype = Object.create(SoundChannel.prototype);
  _no_name_provided__187.prototype.constructor = _no_name_provided__187;
  AudioBufferSound.prototype = Object.create(Sound.prototype);
  AudioBufferSound.prototype.constructor = AudioBufferSound;
  _no_name_provided__192.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__192.prototype.constructor = _no_name_provided__192;
  $loadSoundCOROUTINE$36.prototype = Object.create(CoroutineImpl_0.prototype);
  $loadSoundCOROUTINE$36.prototype.constructor = $loadSoundCOROUTINE$36;
  $loadSoundCOROUTINE$37.prototype = Object.create(CoroutineImpl_0.prototype);
  $loadSoundCOROUTINE$37.prototype.constructor = $loadSoundCOROUTINE$37;
  $addCOROUTINE$38.prototype = Object.create(CoroutineImpl_0.prototype);
  $addCOROUTINE$38.prototype.constructor = $addCOROUTINE$38;
  JsPlatformAudioOutput.prototype = Object.create(PlatformAudioOutput.prototype);
  JsPlatformAudioOutput.prototype.constructor = JsPlatformAudioOutput;
  Type_0.prototype = Object.create(Enum.prototype);
  Type_0.prototype.constructor = Type_0;
  MajorOrder.prototype = Object.create(Enum.prototype);
  MajorOrder.prototype.constructor = MajorOrder;
  LineCap.prototype = Object.create(Enum.prototype);
  LineCap.prototype.constructor = LineCap;
  LineJoin.prototype = Object.create(Enum.prototype);
  LineJoin.prototype.constructor = LineJoin;
  IntArrayListSort.prototype = Object.create(SortOps.prototype);
  IntArrayListSort.prototype.constructor = IntArrayListSort;
  PolygonScanline.prototype = Object.create(RastScale.prototype);
  PolygonScanline.prototype.constructor = PolygonScanline;
  EdgePoint.prototype = Object.create(Enum.prototype);
  EdgePoint.prototype.constructor = EdgePoint;
  Winding.prototype = Object.create(Enum.prototype);
  Winding.prototype.constructor = Winding;
  Easings.prototype = Object.create(Enum.prototype);
  Easings.prototype.constructor = Easings;
  SMOOTH.prototype = Object.create(Easings.prototype);
  SMOOTH.prototype.constructor = SMOOTH;
  EASE_IN_ELASTIC.prototype = Object.create(Easings.prototype);
  EASE_IN_ELASTIC.prototype.constructor = EASE_IN_ELASTIC;
  EASE_OUT_ELASTIC.prototype = Object.create(Easings.prototype);
  EASE_OUT_ELASTIC.prototype.constructor = EASE_OUT_ELASTIC;
  EASE_OUT_BOUNCE.prototype = Object.create(Easings.prototype);
  EASE_OUT_BOUNCE.prototype.constructor = EASE_OUT_BOUNCE;
  LINEAR.prototype = Object.create(Easings.prototype);
  LINEAR.prototype.constructor = LINEAR;
  EASE_IN.prototype = Object.create(Easings.prototype);
  EASE_IN.prototype.constructor = EASE_IN;
  EASE_OUT.prototype = Object.create(Easings.prototype);
  EASE_OUT.prototype.constructor = EASE_OUT;
  EASE_IN_OUT.prototype = Object.create(Easings.prototype);
  EASE_IN_OUT.prototype.constructor = EASE_IN_OUT;
  EASE_OUT_IN.prototype = Object.create(Easings.prototype);
  EASE_OUT_IN.prototype.constructor = EASE_OUT_IN;
  EASE_IN_BACK.prototype = Object.create(Easings.prototype);
  EASE_IN_BACK.prototype.constructor = EASE_IN_BACK;
  EASE_OUT_BACK.prototype = Object.create(Easings.prototype);
  EASE_OUT_BACK.prototype.constructor = EASE_OUT_BACK;
  EASE_IN_OUT_BACK.prototype = Object.create(Easings.prototype);
  EASE_IN_OUT_BACK.prototype.constructor = EASE_IN_OUT_BACK;
  EASE_OUT_IN_BACK.prototype = Object.create(Easings.prototype);
  EASE_OUT_IN_BACK.prototype.constructor = EASE_OUT_IN_BACK;
  EASE_IN_OUT_ELASTIC.prototype = Object.create(Easings.prototype);
  EASE_IN_OUT_ELASTIC.prototype.constructor = EASE_IN_OUT_ELASTIC;
  EASE_OUT_IN_ELASTIC.prototype = Object.create(Easings.prototype);
  EASE_OUT_IN_ELASTIC.prototype.constructor = EASE_OUT_IN_ELASTIC;
  EASE_IN_BOUNCE.prototype = Object.create(Easings.prototype);
  EASE_IN_BOUNCE.prototype.constructor = EASE_IN_BOUNCE;
  EASE_IN_OUT_BOUNCE.prototype = Object.create(Easings.prototype);
  EASE_IN_OUT_BOUNCE.prototype.constructor = EASE_IN_OUT_BOUNCE;
  EASE_OUT_IN_BOUNCE.prototype = Object.create(Easings.prototype);
  EASE_OUT_IN_BOUNCE.prototype.constructor = EASE_OUT_IN_BOUNCE;
  EASE_IN_QUAD.prototype = Object.create(Easings.prototype);
  EASE_IN_QUAD.prototype.constructor = EASE_IN_QUAD;
  EASE_OUT_QUAD.prototype = Object.create(Easings.prototype);
  EASE_OUT_QUAD.prototype.constructor = EASE_OUT_QUAD;
  EASE_IN_OUT_QUAD.prototype = Object.create(Easings.prototype);
  EASE_IN_OUT_QUAD.prototype.constructor = EASE_IN_OUT_QUAD;
  EASE_SINE.prototype = Object.create(Easings.prototype);
  EASE_SINE.prototype.constructor = EASE_SINE;
  Bitmap32.prototype = Object.create(Bitmap.prototype);
  Bitmap32.prototype.constructor = Bitmap32;
  BitmapIndexed.prototype = Object.create(Bitmap.prototype);
  BitmapIndexed.prototype.constructor = BitmapIndexed;
  Bitmap8.prototype = Object.create(BitmapIndexed.prototype);
  Bitmap8.prototype.constructor = Bitmap8;
  BitmapChannel.prototype = Object.create(Enum.prototype);
  BitmapChannel.prototype.constructor = BitmapChannel;
  BitmapSlice.prototype = Object.create(BmpSlice.prototype);
  BitmapSlice.prototype.constructor = BitmapSlice;
  NativeImage.prototype = Object.create(Bitmap.prototype);
  NativeImage.prototype.constructor = NativeImage;
  RGB.prototype = Object.create(ColorFormat24.prototype);
  RGB.prototype.constructor = RGB;
  Companion_104.prototype = Object.create(RGB.prototype);
  Companion_104.prototype.constructor = Companion_104;
  BGR.prototype = Object.create(RGB.prototype);
  BGR.prototype.constructor = BGR;
  Companion_105.prototype = Object.create(ColorFormat32.prototype);
  Companion_105.prototype.constructor = Companion_105;
  $readBitmapFontCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapFontCOROUTINE$1.prototype.constructor = $readBitmapFontCOROUTINE$1;
  $readBitmapFontXmlCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapFontXmlCOROUTINE$2.prototype.constructor = $readBitmapFontXmlCOROUTINE$2;
  $readBitmapFontTxtCOROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapFontTxtCOROUTINE$3.prototype.constructor = $readBitmapFontTxtCOROUTINE$3;
  _no_name_provided__228.prototype = Object.create(TextRendererActions.prototype);
  _no_name_provided__228.prototype.constructor = _no_name_provided__228;
  $emit_2_8_4_4COROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $emit_2_8_4_4COROUTINE$6.prototype.constructor = $emit_2_8_4_4COROUTINE$6;
  $collect_2_2_2COROUTINE$5.prototype = Object.create(CoroutineImpl_0.prototype);
  $collect_2_2_2COROUTINE$5.prototype.constructor = $collect_2_2_2COROUTINE$5;
  _no_name_provided__230.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__230.prototype.constructor = _no_name_provided__230;
  $readFontCOROUTINE$4.prototype = Object.create(CoroutineImpl_0.prototype);
  $readFontCOROUTINE$4.prototype.constructor = $readFontCOROUTINE$4;
  SystemFontRegistry.prototype = Object.create(DefaultFontRegistry.prototype);
  SystemFontRegistry.prototype.constructor = SystemFontRegistry;
  TtfNativeSystemFontProvider.prototype = Object.create(NativeSystemFontProvider.prototype);
  TtfNativeSystemFontProvider.prototype.constructor = TtfNativeSystemFontProvider;
  FallbackNativeSystemFontProvider.prototype = Object.create(TtfNativeSystemFontProvider.prototype);
  FallbackNativeSystemFontProvider.prototype.constructor = FallbackNativeSystemFontProvider;
  NameId.prototype = Object.create(Enum.prototype);
  NameId.prototype.constructor = NameId;
  CompositeGlyph.prototype = Object.create(Glyph_0.prototype);
  CompositeGlyph.prototype.constructor = CompositeGlyph;
  SimpleGlyph.prototype = Object.create(Glyph_0.prototype);
  SimpleGlyph.prototype.constructor = SimpleGlyph;
  $readTtfFontCOROUTINE$7.prototype = Object.create(CoroutineImpl_0.prototype);
  $readTtfFontCOROUTINE$7.prototype.constructor = $readTtfFontCOROUTINE$7;
  BmImageInfo.prototype = Object.create(ImageInfo.prototype);
  BmImageInfo.prototype.constructor = BmImageInfo;
  BMP.prototype = Object.create(ImageFormat.prototype);
  BMP.prototype.constructor = BMP;
  ImageFormats.prototype = Object.create(ImageFormat.prototype);
  ImageFormats.prototype.constructor = ImageFormats;
  $readBitmapOptimizedCOROUTINE$11.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapOptimizedCOROUTINE$11.prototype.constructor = $readBitmapOptimizedCOROUTINE$11;
  $readBitmapSliceCOROUTINE$12.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapSliceCOROUTINE$12.prototype.constructor = $readBitmapSliceCOROUTINE$12;
  $readBitmapCOROUTINE$13.prototype = Object.create(CoroutineImpl_0.prototype);
  $readBitmapCOROUTINE$13.prototype.constructor = $readBitmapCOROUTINE$13;
  $decodeCOROUTINE$14.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeCOROUTINE$14.prototype.constructor = $decodeCOROUTINE$14;
  $decodeCOROUTINE$15.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeCOROUTINE$15.prototype.constructor = $decodeCOROUTINE$15;
  $decodeCOROUTINE$16.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeCOROUTINE$16.prototype.constructor = $decodeCOROUTINE$16;
  BaseNativeImageFormatProvider.prototype = Object.create(NativeImageFormatProvider.prototype);
  BaseNativeImageFormatProvider.prototype.constructor = BaseNativeImageFormatProvider;
  BitmapNativeImage.prototype = Object.create(NativeImage.prototype);
  BitmapNativeImage.prototype.constructor = BitmapNativeImage;
  Colorspace.prototype = Object.create(Enum.prototype);
  Colorspace.prototype.constructor = Colorspace;
  PNG.prototype = Object.create(ImageFormat.prototype);
  PNG.prototype.constructor = PNG;
  RegisteredImageFormats.prototype = Object.create(ImageFormat.prototype);
  RegisteredImageFormats.prototype.constructor = RegisteredImageFormats;
  TGA.prototype = Object.create(ImageFormat.prototype);
  TGA.prototype.constructor = TGA;
  ColorFiller.prototype = Object.create(BaseFiller.prototype);
  ColorFiller.prototype.constructor = ColorFiller;
  GradientFiller.prototype = Object.create(BaseFiller.prototype);
  GradientFiller.prototype.constructor = GradientFiller;
  BitmapFiller.prototype = Object.create(BaseFiller.prototype);
  BitmapFiller.prototype.constructor = BitmapFiller;
  NoneFiller.prototype = Object.create(BaseFiller.prototype);
  NoneFiller.prototype.constructor = NoneFiller;
  GradientKind.prototype = Object.create(Enum.prototype);
  GradientKind.prototype.constructor = GradientKind;
  GradientInterpolationMethod.prototype = Object.create(Enum.prototype);
  GradientInterpolationMethod.prototype.constructor = GradientInterpolationMethod;
  GradientUnits.prototype = Object.create(Enum.prototype);
  GradientUnits.prototype.constructor = GradientUnits;
  BoundBuilderTextRendererActions.prototype = Object.create(TextRendererActions.prototype);
  BoundBuilderTextRendererActions.prototype.constructor = BoundBuilderTextRendererActions;
  Text2TextRendererActions.prototype = Object.create(TextRendererActions.prototype);
  Text2TextRendererActions.prototype.constructor = Text2TextRendererActions;
  Bitmap32Context2d.prototype = Object.create(Renderer.prototype);
  Bitmap32Context2d.prototype.constructor = Bitmap32Context2d;
  BitmapVector.prototype = Object.create(Bitmap.prototype);
  BitmapVector.prototype.constructor = BitmapVector;
  CompositeMode.prototype = Object.create(Enum.prototype);
  CompositeMode.prototype.constructor = CompositeMode;
  BlendMode.prototype = Object.create(Enum.prototype);
  BlendMode.prototype.constructor = BlendMode;
  CycleMethod.prototype = Object.create(Enum.prototype);
  CycleMethod.prototype.constructor = CycleMethod;
  GraphicsPath.prototype = Object.create(VectorPath.prototype);
  GraphicsPath.prototype.constructor = GraphicsPath;
  LineScaleMode.prototype = Object.create(Enum.prototype);
  LineScaleMode.prototype.constructor = LineScaleMode;
  Rasterizer.prototype = Object.create(RastScale.prototype);
  Rasterizer.prototype.constructor = Rasterizer;
  NodeJsNativeImageFormatProvider.prototype = Object.create(BaseNativeImageFormatProvider.prototype);
  NodeJsNativeImageFormatProvider.prototype.constructor = NodeJsNativeImageFormatProvider;
  $decodeCOROUTINE$18.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeCOROUTINE$18.prototype.constructor = $decodeCOROUTINE$18;
  $decodeCOROUTINE$19.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeCOROUTINE$19.prototype.constructor = $decodeCOROUTINE$19;
  HtmlNativeImageFormatProvider.prototype = Object.create(NativeImageFormatProvider.prototype);
  HtmlNativeImageFormatProvider.prototype.constructor = HtmlNativeImageFormatProvider;
  HtmlNativeImage.prototype = Object.create(NativeImage.prototype);
  HtmlNativeImage.prototype.constructor = HtmlNativeImage;
  $decodeToCanvasCOROUTINE$20.prototype = Object.create(CoroutineImpl_0.prototype);
  $decodeToCanvasCOROUTINE$20.prototype.constructor = $decodeToCanvasCOROUTINE$20;
  $loadCanvasCOROUTINE$21.prototype = Object.create(CoroutineImpl_0.prototype);
  $loadCanvasCOROUTINE$21.prototype.constructor = $loadCanvasCOROUTINE$21;
  CanvasContext2dRenderer.prototype = Object.create(Renderer.prototype);
  CanvasContext2dRenderer.prototype.constructor = CanvasContext2dRenderer;
  _no_name_provided__259.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__259.prototype.constructor = _no_name_provided__259;
  Kind_1.prototype = Object.create(Enum.prototype);
  Kind_1.prototype.constructor = Kind_1;
  BlendEquation.prototype = Object.create(Enum.prototype);
  BlendEquation.prototype.constructor = BlendEquation;
  BlendFactor.prototype = Object.create(Enum.prototype);
  BlendFactor.prototype.constructor = BlendFactor;
  DrawType.prototype = Object.create(Enum.prototype);
  DrawType.prototype.constructor = DrawType;
  IndexType.prototype = Object.create(Enum.prototype);
  IndexType.prototype.constructor = IndexType;
  StencilOp.prototype = Object.create(Enum.prototype);
  StencilOp.prototype.constructor = StencilOp;
  TriangleFace.prototype = Object.create(Enum.prototype);
  TriangleFace.prototype.constructor = TriangleFace;
  CompareMode.prototype = Object.create(Enum.prototype);
  CompareMode.prototype.constructor = CompareMode;
  FrontFace.prototype = Object.create(Enum.prototype);
  FrontFace.prototype.constructor = FrontFace;
  RenderBuffer.prototype = Object.create(BaseRenderBufferImpl.prototype);
  RenderBuffer.prototype.constructor = RenderBuffer;
  ShaderException.prototype = Object.create(RuntimeException.prototype);
  ShaderException.prototype.constructor = ShaderException;
  GlRenderBuffer.prototype = Object.create(RenderBuffer.prototype);
  GlRenderBuffer.prototype.constructor = GlRenderBuffer;
  TextureGeneric.prototype = Object.create(Texture.prototype);
  TextureGeneric.prototype.constructor = TextureGeneric;
  GlBuffer.prototype = Object.create(Buffer.prototype);
  GlBuffer.prototype.constructor = GlBuffer;
  GlTexture.prototype = Object.create(Texture.prototype);
  GlTexture.prototype.constructor = GlTexture;
  _no_name_provided__277.prototype = Object.create(BaseRenderBufferImpl.prototype);
  _no_name_provided__277.prototype.constructor = _no_name_provided__277;
  AGOpengl.prototype = Object.create(AG.prototype);
  AGOpengl.prototype.constructor = AGOpengl;
  LogBaseAG.prototype = Object.create(AG.prototype);
  LogBaseAG.prototype.constructor = LogBaseAG;
  PrintAG.prototype = Object.create(LogBaseAG.prototype);
  PrintAG.prototype.constructor = PrintAG;
  LogAG.prototype = Object.create(LogBaseAG.prototype);
  LogAG.prototype.constructor = LogAG;
  LogTexture.prototype = Object.create(Texture.prototype);
  LogTexture.prototype.constructor = LogTexture;
  LogBuffer.prototype = Object.create(Buffer.prototype);
  LogBuffer.prototype.constructor = LogBuffer;
  LogRenderBuffer.prototype = Object.create(RenderBuffer.prototype);
  LogRenderBuffer.prototype.constructor = LogRenderBuffer;
  GlslGenerator.prototype = Object.create(Visitor.prototype);
  GlslGenerator.prototype.constructor = GlslGenerator;
  Stms.prototype = Object.create(Stm.prototype);
  Stms.prototype.constructor = Stms;
  Set_0.prototype = Object.create(Stm.prototype);
  Set_0.prototype.constructor = Set_0;
  Discard.prototype = Object.create(Stm.prototype);
  Discard.prototype.constructor = Discard;
  If.prototype = Object.create(Stm.prototype);
  If.prototype.constructor = If;
  Binop.prototype = Object.create(Operand.prototype);
  Binop.prototype.constructor = Binop;
  IntLiteral.prototype = Object.create(Operand.prototype);
  IntLiteral.prototype.constructor = IntLiteral;
  FloatLiteral.prototype = Object.create(Operand.prototype);
  FloatLiteral.prototype.constructor = FloatLiteral;
  BoolLiteral.prototype = Object.create(Operand.prototype);
  BoolLiteral.prototype.constructor = BoolLiteral;
  Vector.prototype = Object.create(Operand.prototype);
  Vector.prototype.constructor = Vector;
  Swizzle.prototype = Object.create(Operand.prototype);
  Swizzle.prototype.constructor = Swizzle;
  ArrayAccess.prototype = Object.create(Operand.prototype);
  ArrayAccess.prototype.constructor = ArrayAccess;
  Func.prototype = Object.create(Operand.prototype);
  Func.prototype.constructor = Func;
  Variable.prototype = Object.create(Operand.prototype);
  Variable.prototype.constructor = Variable;
  Uniform.prototype = Object.create(Variable.prototype);
  Uniform.prototype.constructor = Uniform;
  Attribute.prototype = Object.create(Variable.prototype);
  Attribute.prototype.constructor = Attribute;
  VarType.prototype = Object.create(Enum.prototype);
  VarType.prototype.constructor = VarType;
  Varying.prototype = Object.create(Variable.prototype);
  Varying.prototype.constructor = Varying;
  VertexShader.prototype = Object.create(Shader.prototype);
  VertexShader.prototype.constructor = VertexShader;
  Output_0.prototype = Object.create(Variable.prototype);
  Output_0.prototype.constructor = Output_0;
  FragmentShader.prototype = Object.create(Shader.prototype);
  FragmentShader.prototype.constructor = FragmentShader;
  ShaderType.prototype = Object.create(Enum.prototype);
  ShaderType.prototype.constructor = ShaderType;
  _no_name_provided__284.prototype = Object.create(Visitor.prototype);
  _no_name_provided__284.prototype.constructor = _no_name_provided__284;
  _no_name_provided__285.prototype = Object.create(Visitor.prototype);
  _no_name_provided__285.prototype.constructor = _no_name_provided__285;
  Temp_0.prototype = Object.create(Variable.prototype);
  Temp_0.prototype.constructor = Temp_0;
  Precision.prototype = Object.create(Enum.prototype);
  Precision.prototype.constructor = Precision;
  VarKind.prototype = Object.create(Enum.prototype);
  VarKind.prototype.constructor = VarKind;
  PreventDefaultException.prototype = Object.create(Exception.prototype);
  PreventDefaultException.prototype.constructor = PreventDefaultException;
  Type_1.prototype = Object.create(Enum.prototype);
  Type_1.prototype.constructor = Type_1;
  MouseEvent_0.prototype = Object.create(Event_0.prototype);
  MouseEvent_0.prototype.constructor = MouseEvent_0;
  ReshapeEvent.prototype = Object.create(Event_0.prototype);
  ReshapeEvent.prototype.constructor = ReshapeEvent;
  Type_2.prototype = Object.create(Enum.prototype);
  Type_2.prototype.constructor = Type_2;
  KeyEvent.prototype = Object.create(Event_0.prototype);
  KeyEvent.prototype.constructor = KeyEvent;
  GamePadUpdateEvent.prototype = Object.create(Event_0.prototype);
  GamePadUpdateEvent.prototype.constructor = GamePadUpdateEvent;
  GamePadStickEvent.prototype = Object.create(Event_0.prototype);
  GamePadStickEvent.prototype.constructor = GamePadStickEvent;
  Type_3.prototype = Object.create(Enum.prototype);
  Type_3.prototype.constructor = Type_3;
  GamePadButtonEvent.prototype = Object.create(Event_0.prototype);
  GamePadButtonEvent.prototype.constructor = GamePadButtonEvent;
  Type_4.prototype = Object.create(Enum.prototype);
  Type_4.prototype.constructor = Type_4;
  GamePadConnectionEvent.prototype = Object.create(Event_0.prototype);
  GamePadConnectionEvent.prototype.constructor = GamePadConnectionEvent;
  Type_5.prototype = Object.create(Enum.prototype);
  Type_5.prototype.constructor = Type_5;
  TouchEvent_0.prototype = Object.create(Event_0.prototype);
  TouchEvent_0.prototype.constructor = TouchEvent_0;
  Status.prototype = Object.create(Enum.prototype);
  Status.prototype.constructor = Status;
  ResumeEvent.prototype = Object.create(Event_0.prototype);
  ResumeEvent.prototype.constructor = ResumeEvent;
  PauseEvent.prototype = Object.create(Event_0.prototype);
  PauseEvent.prototype.constructor = PauseEvent;
  StopEvent.prototype = Object.create(Event_0.prototype);
  StopEvent.prototype.constructor = StopEvent;
  DestroyEvent.prototype = Object.create(Event_0.prototype);
  DestroyEvent.prototype.constructor = DestroyEvent;
  RenderEvent.prototype = Object.create(Event_0.prototype);
  RenderEvent.prototype.constructor = RenderEvent;
  InitEvent.prototype = Object.create(Event_0.prototype);
  InitEvent.prototype.constructor = InitEvent;
  DisposeEvent.prototype = Object.create(Event_0.prototype);
  DisposeEvent.prototype.constructor = DisposeEvent;
  FullScreenEvent.prototype = Object.create(Event_0.prototype);
  FullScreenEvent.prototype.constructor = FullScreenEvent;
  Type_6.prototype = Object.create(Enum.prototype);
  Type_6.prototype.constructor = Type_6;
  DropFileEvent.prototype = Object.create(Event_0.prototype);
  DropFileEvent.prototype.constructor = DropFileEvent;
  StandardGamepadMapping.prototype = Object.create(GamepadMapping.prototype);
  StandardGamepadMapping.prototype.constructor = StandardGamepadMapping;
  Companion_130.prototype = Object.create(StandardGamepadMapping.prototype);
  Companion_130.prototype.constructor = Companion_130;
  GameButton.prototype = Object.create(Enum.prototype);
  GameButton.prototype.constructor = GameButton;
  MouseButton.prototype = Object.create(Enum.prototype);
  MouseButton.prototype.constructor = MouseButton;
  Key_5.prototype = Object.create(Enum.prototype);
  Key_5.prototype.constructor = Key_5;
  GameStick.prototype = Object.create(Enum.prototype);
  GameStick.prototype.constructor = GameStick;
  Cursor.prototype = Object.create(Enum.prototype);
  Cursor.prototype.constructor = Cursor;
  Quality.prototype = Object.create(Enum.prototype);
  Quality.prototype.constructor = Quality;
  _no_name_provided__290.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__290.prototype.constructor = _no_name_provided__290;
  $waitCloseCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $waitCloseCOROUTINE$0.prototype.constructor = $waitCloseCOROUTINE$0;
  $loopCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $loopCOROUTINE$1.prototype.constructor = $loopCOROUTINE$1;
  GameWindow.prototype = Object.create(Mixin_1.prototype);
  GameWindow.prototype.constructor = GameWindow;
  GameWindowCoroutineDispatcher.prototype = Object.create(CoroutineDispatcher.prototype);
  GameWindowCoroutineDispatcher.prototype.constructor = GameWindowCoroutineDispatcher;
  Fixed.prototype = Object.create(Length.prototype);
  Fixed.prototype.constructor = Fixed;
  PT.prototype = Object.create(Fixed.prototype);
  PT.prototype.constructor = PT;
  KmlGlJsCanvas.prototype = Object.create(KmlGl.prototype);
  KmlGlJsCanvas.prototype.constructor = KmlGlJsCanvas;
  AGWebgl.prototype = Object.create(AGOpengl.prototype);
  AGWebgl.prototype.constructor = AGWebgl;
  Nimbus_111_1420_Safari_GamepadMapping.prototype = Object.create(GamepadMapping.prototype);
  Nimbus_111_1420_Safari_GamepadMapping.prototype.constructor = Nimbus_111_1420_Safari_GamepadMapping;
  NodeJsGameWindow.prototype = Object.create(GameWindow.prototype);
  NodeJsGameWindow.prototype.constructor = NodeJsGameWindow;
  _no_name_provided__310.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__310.prototype.constructor = _no_name_provided__310;
  _no_name_provided__311.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__311.prototype.constructor = _no_name_provided__311;
  $loopCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $loopCOROUTINE$2.prototype.constructor = $loopCOROUTINE$2;
  BrowserGameWindow.prototype = Object.create(GameWindow.prototype);
  BrowserGameWindow.prototype.constructor = BrowserGameWindow;
  NotMappedException.prototype = Object.create(RuntimeException.prototype);
  NotMappedException.prototype.constructor = NotMappedException;
  _no_name_provided__330.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__330.prototype.constructor = _no_name_provided__330;
  $getProviderOrNullCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $getProviderOrNullCOROUTINE$0.prototype.constructor = $getProviderOrNullCOROUTINE$0;
  $getProviderCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $getProviderCOROUTINE$1.prototype.constructor = $getProviderCOROUTINE$1;
  $getCOROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $getCOROUTINE$3.prototype.constructor = $getCOROUTINE$3;
  $createdCOROUTINE$5.prototype = Object.create(CoroutineImpl_0.prototype);
  $createdCOROUTINE$5.prototype.constructor = $createdCOROUTINE$5;
  $deinitCOROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $deinitCOROUTINE$6.prototype.constructor = $deinitCOROUTINE$6;
  $deinitCOROUTINE$7.prototype = Object.create(CoroutineImpl_0.prototype);
  $deinitCOROUTINE$7.prototype.constructor = $deinitCOROUTINE$7;
  $getCOROUTINE$9.prototype = Object.create(CoroutineImpl_0.prototype);
  $getCOROUTINE$9.prototype.constructor = $getCOROUTINE$9;
  $deinitCOROUTINE$10.prototype = Object.create(CoroutineImpl_0.prototype);
  $deinitCOROUTINE$10.prototype.constructor = $deinitCOROUTINE$10;
  $getCOROUTINE$11.prototype = Object.create(CoroutineImpl_0.prototype);
  $getCOROUTINE$11.prototype.constructor = $getCOROUTINE$11;
  JsObjectMapper2.prototype = Object.create(ObjectMapper2.prototype);
  JsObjectMapper2.prototype.constructor = JsObjectMapper2;
  _no_name_provided__336.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__336.prototype.constructor = _no_name_provided__336;
  _no_name_provided__337.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__337.prototype.constructor = _no_name_provided__337;
  _no_name_provided__338.prototype = Object.create(Module.prototype);
  _no_name_provided__338.prototype.constructor = _no_name_provided__338;
  _no_name_provided__339.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__339.prototype.constructor = _no_name_provided__339;
  _no_name_provided__340.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__340.prototype.constructor = _no_name_provided__340;
  _no_name_provided__341.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__341.prototype.constructor = _no_name_provided__341;
  _no_name_provided__342.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__342.prototype.constructor = _no_name_provided__342;
  _no_name_provided__343.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__343.prototype.constructor = _no_name_provided__343;
  _no_name_provided__344.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__344.prototype.constructor = _no_name_provided__344;
  $invokeCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $invokeCOROUTINE$0.prototype.constructor = $invokeCOROUTINE$0;
  $invokeCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $invokeCOROUTINE$1.prototype.constructor = $invokeCOROUTINE$1;
  $prepareViewsCOROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $prepareViewsCOROUTINE$3.prototype.constructor = $prepareViewsCOROUTINE$3;
  AnSymbolEmpty.prototype = Object.create(AnSymbol.prototype);
  AnSymbolEmpty.prototype.constructor = AnSymbolEmpty;
  AnSymbolSound.prototype = Object.create(AnSymbol.prototype);
  AnSymbolSound.prototype.constructor = AnSymbolSound;
  AnTextFieldSymbol.prototype = Object.create(AnSymbol.prototype);
  AnTextFieldSymbol.prototype.constructor = AnTextFieldSymbol;
  AnSymbolBaseShape.prototype = Object.create(AnSymbol.prototype);
  AnSymbolBaseShape.prototype.constructor = AnSymbolBaseShape;
  AnSymbolShape.prototype = Object.create(AnSymbolBaseShape.prototype);
  AnSymbolShape.prototype.constructor = AnSymbolShape;
  AnSymbolMorphShape.prototype = Object.create(AnSymbolBaseShape.prototype);
  AnSymbolMorphShape.prototype.constructor = AnSymbolMorphShape;
  AnSymbolBitmap.prototype = Object.create(AnSymbol.prototype);
  AnSymbolBitmap.prototype.constructor = AnSymbolBitmap;
  AnSymbolMovieClip.prototype = Object.create(AnSymbol.prototype);
  AnSymbolMovieClip.prototype.constructor = AnSymbolMovieClip;
  AnDepthTimeline.prototype = Object.create(Timed.prototype);
  AnDepthTimeline.prototype.constructor = AnDepthTimeline;
  _no_name_provided__356.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__356.prototype.constructor = _no_name_provided__356;
  _no_name_provided__357.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__357.prototype.constructor = _no_name_provided__357;
  $readLibraryCOROUTINE$7.prototype = Object.create(CoroutineImpl_0.prototype);
  $readLibraryCOROUTINE$7.prototype.constructor = $readLibraryCOROUTINE$7;
  _no_name_provided__359.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__359.prototype.constructor = _no_name_provided__359;
  _no_name_provided__360.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__360.prototype.constructor = _no_name_provided__360;
  $readAniCOROUTINE$6.prototype = Object.create(CoroutineImpl_0.prototype);
  $readAniCOROUTINE$6.prototype.constructor = $readAniCOROUTINE$6;
  _no_name_provided__366.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__366.prototype.constructor = _no_name_provided__366;
  _no_name_provided__367.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__367.prototype.constructor = _no_name_provided__367;
  _no_name_provided__368.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__368.prototype.constructor = _no_name_provided__368;
  $configureLoggerFromPropertiesCOROUTINE$9.prototype = Object.create(CoroutineImpl_0.prototype);
  $configureLoggerFromPropertiesCOROUTINE$9.prototype.constructor = $configureLoggerFromPropertiesCOROUTINE$9;
  _no_name_provided__398.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__398.prototype.constructor = _no_name_provided__398;
  $initCOROUTINE$14.prototype = Object.create(CoroutineImpl_0.prototype);
  $initCOROUTINE$14.prototype.constructor = $initCOROUTINE$14;
  $initCOROUTINE$17.prototype = Object.create(CoroutineImpl_0.prototype);
  $initCOROUTINE$17.prototype.constructor = $initCOROUTINE$17;
  $sceneAfterDestroyInternalCOROUTINE$18.prototype = Object.create(CoroutineImpl_0.prototype);
  $sceneAfterDestroyInternalCOROUTINE$18.prototype.constructor = $sceneAfterDestroyInternalCOROUTINE$18;
  EmptyScene.prototype = Object.create(Scene.prototype);
  EmptyScene.prototype.constructor = EmptyScene;
  _no_name_provided__402.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__402.prototype.constructor = _no_name_provided__402;
  _no_name_provided__403.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__403.prototype.constructor = _no_name_provided__403;
  _no_name_provided__404.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__404.prototype.constructor = _no_name_provided__404;
  _no_name_provided__405.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__405.prototype.constructor = _no_name_provided__405;
  _no_name_provided__407.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__407.prototype.constructor = _no_name_provided__407;
  _no_name_provided__408.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__408.prototype.constructor = _no_name_provided__408;
  _no_name_provided__409.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__409.prototype.constructor = _no_name_provided__409;
  $_changeToCOROUTINE$20.prototype = Object.create(CoroutineImpl_0.prototype);
  $_changeToCOROUTINE$20.prototype.constructor = $_changeToCOROUTINE$20;
  View.prototype = Object.create(BaseView.prototype);
  View.prototype.constructor = View;
  Container.prototype = Object.create(View.prototype);
  Container.prototype.constructor = Container;
  SceneContainer.prototype = Object.create(Container.prototype);
  SceneContainer.prototype.constructor = SceneContainer;
  TransitionView.prototype = Object.create(Container.prototype);
  TransitionView.prototype.constructor = TransitionView;
  _no_name_provided__420.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__420.prototype.constructor = _no_name_provided__420;
  $tweenCOROUTINE$26.prototype = Object.create(CoroutineImpl_0.prototype);
  $tweenCOROUTINE$26.prototype.constructor = $tweenCOROUTINE$26;
  _no_name_provided__422.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__422.prototype.constructor = _no_name_provided__422;
  _no_name_provided__423.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__423.prototype.constructor = _no_name_provided__423;
  _no_name_provided__424.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__424.prototype.constructor = _no_name_provided__424;
  _no_name_provided__425.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__425.prototype.constructor = _no_name_provided__425;
  _no_name_provided__430.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__430.prototype.constructor = _no_name_provided__430;
  _no_name_provided__432.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__432.prototype.constructor = _no_name_provided__432;
  _no_name_provided__434.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__434.prototype.constructor = _no_name_provided__434;
  _no_name_provided__436.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__436.prototype.constructor = _no_name_provided__436;
  UIView.prototype = Object.create(Container.prototype);
  UIView.prototype.constructor = UIView;
  UIButton.prototype = Object.create(UIView.prototype);
  UIButton.prototype.constructor = UIButton;
  _no_name_provided__440.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__440.prototype.constructor = _no_name_provided__440;
  _no_name_provided__441.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__441.prototype.constructor = _no_name_provided__441;
  _no_name_provided__442.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__442.prototype.constructor = _no_name_provided__442;
  _no_name_provided__443.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__443.prototype.constructor = _no_name_provided__443;
  _no_name_provided__444.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__444.prototype.constructor = _no_name_provided__444;
  Serializer.prototype = Object.create(KTreeSerializerExt.prototype);
  Serializer.prototype.constructor = Serializer;
  _no_name_provided__452.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__452.prototype.constructor = _no_name_provided__452;
  _no_name_provided__454.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__454.prototype.constructor = _no_name_provided__454;
  _no_name_provided__456.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__456.prototype.constructor = _no_name_provided__456;
  _no_name_provided__458.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__458.prototype.constructor = _no_name_provided__458;
  _no_name_provided__460.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__460.prototype.constructor = _no_name_provided__460;
  UICheckBox.prototype = Object.create(UIView.prototype);
  UICheckBox.prototype.constructor = UICheckBox;
  Serializer_0.prototype = Object.create(KTreeSerializerExt.prototype);
  Serializer_0.prototype.constructor = Serializer_0;
  UIProgressBar.prototype = Object.create(UIView.prototype);
  UIProgressBar.prototype.constructor = UIProgressBar;
  Serializer_1.prototype = Object.create(KTreeSerializerExt.prototype);
  Serializer_1.prototype.constructor = Serializer_1;
  UITextButton.prototype = Object.create(UIButton.prototype);
  UITextButton.prototype.constructor = UITextButton;
  RectBase.prototype = Object.create(View.prototype);
  RectBase.prototype.constructor = RectBase;
  BaseImage.prototype = Object.create(RectBase.prototype);
  BaseImage.prototype.constructor = BaseImage;
  BaseGraphics.prototype = Object.create(BaseImage.prototype);
  BaseGraphics.prototype.constructor = BaseGraphics;
  BlendMode_0.prototype = Object.create(Enum.prototype);
  BlendMode_0.prototype.constructor = BlendMode_0;
  Graphics.prototype = Object.create(BaseGraphics.prototype);
  Graphics.prototype.constructor = Graphics;
  ShapeView.prototype = Object.create(Graphics.prototype);
  ShapeView.prototype.constructor = ShapeView;
  Circle.prototype = Object.create(ShapeView.prototype);
  Circle.prototype.constructor = Circle;
  DummyView.prototype = Object.create(View.prototype);
  DummyView.prototype.constructor = DummyView;
  $forceLoadSourceFileCOROUTINE$28.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadSourceFileCOROUTINE$28.prototype.constructor = $forceLoadSourceFileCOROUTINE$28;
  Image.prototype = Object.create(BaseImage.prototype);
  Image.prototype.constructor = Image;
  NinePatch.prototype = Object.create(View.prototype);
  NinePatch.prototype.constructor = NinePatch;
  RoundRect.prototype = Object.create(ShapeView.prototype);
  RoundRect.prototype.constructor = RoundRect;
  SolidRect.prototype = Object.create(RectBase.prototype);
  SolidRect.prototype.constructor = SolidRect;
  Stage.prototype = Object.create(Container.prototype);
  Stage.prototype.constructor = Stage;
  Serializer_2.prototype = Object.create(KTreeSerializerExt.prototype);
  Serializer_2.prototype.constructor = Serializer_2;
  _no_name_provided__514.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__514.prototype.constructor = _no_name_provided__514;
  $forceLoadFontSourceCOROUTINE$31.prototype = Object.create(CoroutineImpl_0.prototype);
  $forceLoadFontSourceCOROUTINE$31.prototype.constructor = $forceLoadFontSourceCOROUTINE$31;
  Text_2.prototype = Object.create(Container.prototype);
  Text_2.prototype.constructor = Text_2;
  CollisionKind.prototype = Object.create(Enum.prototype);
  CollisionKind.prototype.constructor = CollisionKind;
  _no_name_provided__522.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__522.prototype.constructor = _no_name_provided__522;
  $closeCOROUTINE$34.prototype = Object.create(CoroutineImpl_0.prototype);
  $closeCOROUTINE$34.prototype.constructor = $closeCOROUTINE$34;
  _no_name_provided__528.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__528.prototype.constructor = _no_name_provided__528;
  _no_name_provided__529.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__529.prototype.constructor = _no_name_provided__529;
  _no_name_provided__530.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__530.prototype.constructor = _no_name_provided__530;
  _no_name_provided__531.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__531.prototype.constructor = _no_name_provided__531;
  _no_name_provided__532.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__532.prototype.constructor = _no_name_provided__532;
  _no_name_provided__534.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__534.prototype.constructor = _no_name_provided__534;
  _no_name_provided__536.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__536.prototype.constructor = _no_name_provided__536;
  _no_name_provided__538.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__538.prototype.constructor = _no_name_provided__538;
  _no_name_provided__540.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__540.prototype.constructor = _no_name_provided__540;
  _no_name_provided__543.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__543.prototype.constructor = _no_name_provided__543;
  _no_name_provided__544.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__544.prototype.constructor = _no_name_provided__544;
  _no_name_provided__546.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__546.prototype.constructor = _no_name_provided__546;
  _no_name_provided__547.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__547.prototype.constructor = _no_name_provided__547;
  $sceneInitCOROUTINE$0.prototype = Object.create(CoroutineImpl_0.prototype);
  $sceneInitCOROUTINE$0.prototype.constructor = $sceneInitCOROUTINE$0;
  Scene3.prototype = Object.create(Scene.prototype);
  Scene3.prototype.constructor = Scene3;
  _no_name_provided__548.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__548.prototype.constructor = _no_name_provided__548;
  _no_name_provided__549.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__549.prototype.constructor = _no_name_provided__549;
  _no_name_provided__550.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__550.prototype.constructor = _no_name_provided__550;
  _no_name_provided__551.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__551.prototype.constructor = _no_name_provided__551;
  _no_name_provided__552.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__552.prototype.constructor = _no_name_provided__552;
  _no_name_provided__553.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__553.prototype.constructor = _no_name_provided__553;
  _no_name_provided__555.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__555.prototype.constructor = _no_name_provided__555;
  _no_name_provided__557.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__557.prototype.constructor = _no_name_provided__557;
  _no_name_provided__559.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__559.prototype.constructor = _no_name_provided__559;
  _no_name_provided__562.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__562.prototype.constructor = _no_name_provided__562;
  _no_name_provided__563.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__563.prototype.constructor = _no_name_provided__563;
  _no_name_provided__565.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__565.prototype.constructor = _no_name_provided__565;
  $sceneInitCOROUTINE$1.prototype = Object.create(CoroutineImpl_0.prototype);
  $sceneInitCOROUTINE$1.prototype.constructor = $sceneInitCOROUTINE$1;
  $createTreasureObjectsCOROUTINE$2.prototype = Object.create(CoroutineImpl_0.prototype);
  $createTreasureObjectsCOROUTINE$2.prototype.constructor = $createTreasureObjectsCOROUTINE$2;
  Scene2.prototype = Object.create(Scene.prototype);
  Scene2.prototype.constructor = Scene2;
  _no_name_provided__566.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__566.prototype.constructor = _no_name_provided__566;
  _no_name_provided__567.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__567.prototype.constructor = _no_name_provided__567;
  _no_name_provided__568.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__568.prototype.constructor = _no_name_provided__568;
  ConfigModule.prototype = Object.create(Module.prototype);
  ConfigModule.prototype.constructor = ConfigModule;
  _no_name_provided__569.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__569.prototype.constructor = _no_name_provided__569;
  _no_name_provided__570.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__570.prototype.constructor = _no_name_provided__570;
  _no_name_provided__576.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__576.prototype.constructor = _no_name_provided__576;
  _no_name_provided__578.prototype = Object.create(CoroutineImpl_0.prototype);
  _no_name_provided__578.prototype.constructor = _no_name_provided__578;
  $sceneInitCOROUTINE$3.prototype = Object.create(CoroutineImpl_0.prototype);
  $sceneInitCOROUTINE$3.prototype.constructor = $sceneInitCOROUTINE$3;
  Scene1.prototype = Object.create(Scene.prototype);
  Scene1.prototype.constructor = Scene1;
  function indexOf(_this_, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last_1 = _this_.length - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this_[index] == null) {
            return index;
          }}
         while (inductionVariable <= last_1);
    } else {
      var inductionVariable_0 = 0;
      var last_2 = _this_.length - 1 | 0;
      if (inductionVariable_0 <= last_2)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals_1(element, _this_[index_0])) {
            return index_0;
          }}
         while (inductionVariable_0 <= last_2);
    }
    return -1;
  }
  function toList(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList(_this_);
    }
  }
  function toCollection(_this_, destination) {
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      destination.add_39(item);
      Unit_getInstance();
    }
    return destination;
  }
  function joinToString(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo(_this_, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function getOrNull(_this_, index) {
    return (index >= 0 ? index <= _get_lastIndex_(_this_) : false) ? _this_[index] : null;
  }
  function getOrNull_0(_this_, index) {
    return (index >= 0 ? index <= _get_lastIndex__0(_this_) : false) ? _this_[index] : null;
  }
  function lastOrNull(_this_) {
    var tmp;
    if (_this_.length === 0) {
      tmp = null;
    } else {
      {
        tmp = _this_[_this_.length - 1 | 0];
      }
    }
    return tmp;
  }
  function contains(_this_, element) {
    return indexOf_0(_this_, element) >= 0;
  }
  function indexOf_0(_this_, element) {
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this_[index]) {
          return index;
        }}
       while (inductionVariable <= last_1);
    return -1;
  }
  function contains_0(_this_, element) {
    return indexOf(_this_, element) >= 0;
  }
  function toSet(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf_0(_this_[0]);
      default:return toCollection(_this_, LinkedHashSet_init_$Create$_1(mapCapacity(_this_.length)));
    }
  }
  function toMutableList(_this_) {
    return ArrayList_init_$Create$_1(asCollection(_this_));
  }
  function joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count_0 = 0;
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    $l$break: while (inductionVariable < last_1) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count_0 = count_0 + 1 | 0;
      if (count_0 > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count_0 <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count_0 > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function joinTo$default(_this_, buffer, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      separator = ', ';
    if (!(($mask0 & 4) === 0))
      prefix = '';
    if (!(($mask0 & 8) === 0))
      postfix = '';
    if (!(($mask0 & 16) === 0))
      limit = -1;
    if (!(($mask0 & 32) === 0))
      truncated = '...';
    if (!(($mask0 & 64) === 0))
      transform = null;
    return joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform);
  }
  function _get_lastIndex_(_this_) {
    return _this_.length - 1 | 0;
  }
  function _get_lastIndex__0(_this_) {
    return _this_.length - 1 | 0;
  }
  function _get_lastIndex__1(_this_) {
    return _this_.length - 1 | 0;
  }
  function contains_1(_this_, element) {
    return indexOf_1(_this_, element) >= 0;
  }
  function single(_this_) {
    var tmp0_subject = _this_.length;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('Array is empty.');
      case 1:
        tmp = _this_[0];
        break;
      default:throw IllegalArgumentException_init_$Create$('Array has more than one element.');
    }
    return tmp;
  }
  function contains_2(_this_, element) {
    return indexOf_2(_this_, element) >= 0;
  }
  function indexOf_1(_this_, element) {
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element.equals(_this_[index])) {
          return index;
        }}
       while (inductionVariable <= last_1);
    return -1;
  }
  function indexOf_2(_this_, element) {
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this_[index]) {
          return index;
        }}
       while (inductionVariable <= last_1);
    return -1;
  }
  function _get_indices_(_this_) {
    return new IntRange(0, _get_lastIndex__2(_this_));
  }
  function _get_lastIndex__2(_this_) {
    return _this_.length - 1 | 0;
  }
  function contains_3(_this_, element) {
    return indexOf_3(_this_, element) >= 0;
  }
  function contains_4(_this_, element) {
    return indexOf_4(_this_, element) >= 0;
  }
  function indexOf_3(_this_, element) {
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this_[index]) {
          return index;
        }}
       while (inductionVariable <= last_1);
    return -1;
  }
  function indexOf_4(_this_, element) {
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element.equals(_this_[index])) {
          return index;
        }}
       while (inductionVariable <= last_1);
    return -1;
  }
  function take(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }if (n === 0)
      return emptyList();
    if (n >= _this_.length)
      return toList_0(_this_);
    if (n === 1)
      return listOf_0(_this_[0]);
    var count_0 = 0;
    var list = ArrayList_init_$Create$_0(n);
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    $l$break: while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      list.add_39(item);
      Unit_getInstance();
      count_0 = count_0 + 1 | 0;
      if (count_0 === n)
        break $l$break;
      else {
      }
    }
    return list;
  }
  function take_0(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }if (n === 0)
      return emptyList();
    if (n >= _this_.length)
      return toList_1(_this_);
    if (n === 1)
      return listOf_0(_this_[0]);
    var count_0 = 0;
    var list = ArrayList_init_$Create$_0(n);
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    $l$break: while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      list.add_39(item);
      Unit_getInstance();
      count_0 = count_0 + 1 | 0;
      if (count_0 === n)
        break $l$break;
      else {
      }
    }
    return list;
  }
  function toList_0(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList_0(_this_);
    }
  }
  function toList_1(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_[0]);
      default:return toMutableList_1(_this_);
    }
  }
  function toMutableList_0(_this_) {
    var list = ArrayList_init_$Create$_0(_this_.length);
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      list.add_39(item);
      Unit_getInstance();
    }
    return list;
  }
  function toMutableList_1(_this_) {
    var list = ArrayList_init_$Create$_0(_this_.length);
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      list.add_39(item);
      Unit_getInstance();
    }
    return list;
  }
  function sliceArray(_this_, indices) {
    if (indices.isEmpty_53())
      return new Int8Array(0);
    return copyOfRange(_this_, indices._get_start__0(), indices._get_endInclusive__0() + 1 | 0);
  }
  function toList_2(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__60();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyList();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_137(0);
          } else {
            {
              tmp_0 = _this_.iterator_67().next_37();
            }
          }

          tmp = listOf_0(tmp_0);
          break;
        default:tmp = toMutableList_2(_this_);
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyList(toMutableList_3(_this_));
  }
  function joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo_0(_this_, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default_0(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function zip(_this_, other) {
    var first_1_0 = _this_.iterator_67();
    var second_2 = other.iterator_67();
    var tmp0_minOf_0 = collectionSizeOrDefault(_this_, 10);
    var tmp1_minOf_0 = collectionSizeOrDefault(other, 10);
    var list_3 = ArrayList_init_$Create$_0(function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_minOf_0, tmp1_minOf_0]))));
    }.call(this));
    while (first_1_0.hasNext_33() ? second_2.hasNext_33() : false) {
      var tmp2__anonymous__4 = first_1_0.next_37();
      var tmp3__anonymous__4 = second_2.next_37();
      list_3.add_39(to(tmp2__anonymous__4, tmp3__anonymous__4));
      Unit_getInstance();
    }
    return list_3;
  }
  function reversed(_this_) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__60() <= 1;
    } else {
      {
        tmp = false;
      }
    }
    if (tmp)
      return toList_2(_this_);
    else {
    }
    var list = toMutableList_3(_this_);
    reverse(list);
    return list;
  }
  function toSet_0(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__60();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptySet();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_137(0);
          } else {
            {
              tmp_0 = _this_.iterator_67().next_37();
            }
          }

          tmp = setOf_0(tmp_0);
          break;
        default:tmp = toCollection_0(_this_, LinkedHashSet_init_$Create$_1(mapCapacity(_this_._get_size__60())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlySet(toCollection_0(_this_, LinkedHashSet_init_$Create$()));
  }
  function toMutableList_2(_this_) {
    return ArrayList_init_$Create$_1(_this_);
  }
  function first(_this_) {
    if (_this_.isEmpty_53())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_137(0);
  }
  function plus(_this_, elements) {
    if (isInterface(elements, Collection)) {
      var result = ArrayList_init_$Create$_0(_this_._get_size__60() + elements._get_size__60() | 0);
      result.addAll_24(_this_);
      Unit_getInstance();
      result.addAll_24(elements);
      Unit_getInstance();
      return result;
    } else {
      {
        var result_0 = ArrayList_init_$Create$_1(_this_);
        addAll(result_0, elements);
        Unit_getInstance();
        return result_0;
      }
    }
  }
  function filterNotNull(_this_) {
    return filterNotNullTo(_this_, ArrayList_init_$Create$());
  }
  function distinct(_this_) {
    return toList_2(toMutableSet(_this_));
  }
  function sorted(_this_) {
    if (isInterface(_this_, Collection)) {
      if (_this_._get_size__60() <= 1)
        return toList_2(_this_);
      var tmp0_toTypedArray_0 = _this_;
      var tmp = copyToArray_0(tmp0_toTypedArray_0);
      var tmp1_apply_0 = isArray(tmp) ? tmp : THROW_CCE();
      sort_0(tmp1_apply_0);
      return asList(tmp1_apply_0);
    } else {
    }
    var tmp2_apply_0 = toMutableList_3(_this_);
    sort(tmp2_apply_0);
    return tmp2_apply_0;
  }
  function firstOrNull(_this_) {
    return _this_.isEmpty_53() ? null : _this_.get_137(0);
  }
  function plus_0(_this_, element) {
    var result = ArrayList_init_$Create$_0(_this_._get_size__60() + 1 | 0);
    result.addAll_24(_this_);
    Unit_getInstance();
    result.add_39(element);
    Unit_getInstance();
    return result;
  }
  function toIntArray(_this_) {
    var result = new Int32Array(_this_._get_size__60());
    var index = 0;
    var tmp0_iterator = _this_.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var element = tmp0_iterator.next_37();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function maxOrNull(_this_) {
    var iterator_0 = _this_.iterator_67();
    if (!iterator_0.hasNext_33())
      return null;
    var max = iterator_0.next_37();
    while (iterator_0.hasNext_33()) {
      var e = iterator_0.next_37();
      if (compareTo(max, e) < 0)
        max = e;
    }
    return max;
  }
  function last(_this_) {
    if (_this_.isEmpty_53())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_137(_get_lastIndex__3(_this_));
  }
  function first_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return first(_this_);
    else {
      {
        var iterator_0 = _this_.iterator_67();
        if (!iterator_0.hasNext_33())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        return iterator_0.next_37();
      }
    }
  }
  function last_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return last(_this_);
    else {
      {
        var iterator_0 = _this_.iterator_67();
        if (!iterator_0.hasNext_33())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        var last_1 = iterator_0.next_37();
        while (iterator_0.hasNext_33())
          last_1 = iterator_0.next_37();
        return last_1;
      }
    }
  }
  function count(_this_) {
    if (isInterface(_this_, Collection))
      return _this_._get_size__60();
    else {
    }
    var count_0 = 0;
    var tmp0_iterator = _this_.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var element = tmp0_iterator.next_37();
      count_0 = count_0 + 1 | 0;
      checkCountOverflow(count_0);
      Unit_getInstance();
    }
    return count_0;
  }
  function maxOrNull_0(_this_) {
    var iterator_0 = _this_.iterator_67();
    if (!iterator_0.hasNext_33())
      return null;
    var max = iterator_0.next_37();
    while (iterator_0.hasNext_33()) {
      var e = iterator_0.next_37();
      var tmp0_maxOf_0 = max;
      max = function () {
        var $externalVarargReceiverTmp = Math;
        return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp0_maxOf_0, e]))));
      }.call(this);
    }
    return max;
  }
  function toMutableList_3(_this_) {
    if (isInterface(_this_, Collection))
      return toMutableList_2(_this_);
    else {
    }
    return toCollection_0(_this_, ArrayList_init_$Create$());
  }
  function joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count_0 = 0;
    var tmp0_iterator = _this_.iterator_67();
    $l$break: while (tmp0_iterator.hasNext_33()) {
      var element = tmp0_iterator.next_37();
      count_0 = count_0 + 1 | 0;
      if (count_0 > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count_0 <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count_0 > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function toCollection_0(_this_, destination) {
    var tmp0_iterator = _this_.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var item = tmp0_iterator.next_37();
      destination.add_39(item);
      Unit_getInstance();
    }
    return destination;
  }
  function sortedWith(_this_, comparator) {
    if (isInterface(_this_, Collection)) {
      if (_this_._get_size__60() <= 1)
        return toList_2(_this_);
      var tmp0_toTypedArray_0 = _this_;
      var tmp = copyToArray_0(tmp0_toTypedArray_0);
      var tmp1_apply_0 = isArray(tmp) ? tmp : THROW_CCE();
      sortWith_0(tmp1_apply_0, comparator);
      return asList(tmp1_apply_0);
    } else {
    }
    var tmp2_apply_0 = toMutableList_3(_this_);
    sortWith(tmp2_apply_0, comparator);
    return tmp2_apply_0;
  }
  function filterNotNullTo(_this_, destination) {
    var tmp0_iterator = _this_.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var element = tmp0_iterator.next_37();
      if (!(element == null)) {
        destination.add_39(element);
        Unit_getInstance();
      }}
    return destination;
  }
  function toMutableSet(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (isInterface(tmp0_subject, Collection)) {
      tmp = LinkedHashSet_init_$Create$_0(_this_);
    } else {
      {
        tmp = toCollection_0(_this_, LinkedHashSet_init_$Create$());
      }
    }
    return tmp;
  }
  function single_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return single_1(_this_);
    else {
      {
        var iterator_0 = _this_.iterator_67();
        if (!iterator_0.hasNext_33())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        var single_2 = iterator_0.next_37();
        if (iterator_0.hasNext_33())
          throw IllegalArgumentException_init_$Create$('Collection has more than one element.');
        return single_2;
      }
    }
  }
  function asSequence(_this_) {
    return new _no_name_provided__1(_this_);
  }
  function single_1(_this_) {
    var tmp0_subject = _this_._get_size__60();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('List is empty.');
      case 1:
        tmp = _this_.get_137(0);
        break;
      default:throw IllegalArgumentException_init_$Create$('List has more than one element.');
    }
    return tmp;
  }
  function firstOrNull_0(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List)) {
      if (_this_.isEmpty_53())
        return null;
      else
        return _this_.get_137(0);
    } else {
      {
        var iterator_0 = _this_.iterator_67();
        if (!iterator_0.hasNext_33())
          return null;
        return iterator_0.next_37();
      }
    }
  }
  function sum(_this_) {
    var sum_0 = 0.0;
    var tmp0_iterator = _this_.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var element = tmp0_iterator.next_37();
      sum_0 = sum_0 + element;
    }
    return sum_0;
  }
  function minus(_this_, elements) {
    var other = convertToSetForSetOperationWith(elements, _this_);
    if (other.isEmpty_53())
      return toList_2(_this_);
    var tmp0_filterNotTo_0 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = _this_.iterator_67();
    while (tmp0_iterator_1.hasNext_33()) {
      var element_2 = tmp0_iterator_1.next_37();
      if (!other.contains_58(element_2)) {
        tmp0_filterNotTo_0.add_39(element_2);
        Unit_getInstance();
      } else {
      }
    }
    return tmp0_filterNotTo_0;
  }
  function toHashSet(_this_) {
    return toCollection_0(_this_, HashSet_init_$Create$(mapCapacity(collectionSizeOrDefault(_this_, 12))));
  }
  function _no_name_provided__1($this_asSequence) {
    this._$this_asSequence = $this_asSequence;
  }
  _no_name_provided__1.prototype.iterator_2_3 = function () {
    return this._$this_asSequence.iterator_67();
  };
  _no_name_provided__1.prototype.iterator_67 = function () {
    return this.iterator_2_3();
  };
  _no_name_provided__1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Sequence]
  };
  function toList_3(_this_) {
    if (_this_._get_size__60() === 0)
      return emptyList();
    var iterator_0 = _this_._get_entries__10().iterator_67();
    if (!iterator_0.hasNext_33())
      return emptyList();
    var first_2 = iterator_0.next_37();
    if (!iterator_0.hasNext_33()) {
      return listOf_0(new Pair(first_2._get_key__37(), first_2._get_value__10()));
    }var result = ArrayList_init_$Create$_0(_this_._get_size__60());
    result.add_39(new Pair(first_2._get_key__37(), first_2._get_value__10()));
    Unit_getInstance();
    do {
      var tmp0_toPair_0 = iterator_0.next_37();
      result.add_39(new Pair(tmp0_toPair_0._get_key__37(), tmp0_toPair_0._get_value__10()));
      Unit_getInstance();
    }
     while (iterator_0.hasNext_33());
    return result;
  }
  function until(_this_, to_0) {
    if (to_0 <= IntCompanionObject_getInstance()._MIN_VALUE_4)
      return Companion_getInstance_10()._EMPTY;
    return numberRangeToNumber(_this_, to_0 - 1 | 0);
  }
  function coerceAtMost(_this_, maximumValue) {
    return _this_ > maximumValue ? maximumValue : _this_;
  }
  function until_0(_this_, to_0) {
    if (to_0.compareTo_137(new Long(0, -2147483648)) <= 0)
      return Companion_getInstance_11()._EMPTY_0;
    var tmp0_minus_0 = 1;
    return _this_.rangeTo_12(to_0.minus_29(toLong(tmp0_minus_0)).toLong_6());
  }
  function step(_this_, step_0) {
    checkStepIsPositive(step_0 > 0, step_0);
    return Companion_getInstance_7().fromClosedRange(_this_._first_0, _this_._last, _this_._step_2 > 0 ? step_0 : -step_0 | 0);
  }
  function downTo(_this_, to_0) {
    return Companion_getInstance_7().fromClosedRange(_this_, to_0, -1);
  }
  function coerceIn(_this_, minimumValue, maximumValue) {
    if (minimumValue > maximumValue)
      throw IllegalArgumentException_init_$Create$('' + 'Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this_ < minimumValue)
      return minimumValue;
    if (_this_ > maximumValue)
      return maximumValue;
    return _this_;
  }
  function coerceAtLeast(_this_, minimumValue) {
    return _this_ < minimumValue ? minimumValue : _this_;
  }
  function reversed_0(_this_) {
    return Companion_getInstance_7().fromClosedRange(_this_._last, _this_._first_0, -_this_._step_2 | 0);
  }
  function coerceIn_0(_this_, minimumValue, maximumValue) {
    if (minimumValue.compareTo_137(maximumValue) > 0)
      throw IllegalArgumentException_init_$Create$('' + 'Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this_.compareTo_137(minimumValue) < 0)
      return minimumValue;
    if (_this_.compareTo_137(maximumValue) > 0)
      return maximumValue;
    return _this_;
  }
  function asIterable(_this_) {
    return new _no_name_provided__1_0(_this_);
  }
  function map(_this_, transform) {
    return new TransformingSequence(_this_, transform);
  }
  function toList_4(_this_) {
    return optimizeReadOnlyList(toMutableList_4(_this_));
  }
  function toMutableList_4(_this_) {
    return toCollection_1(_this_, ArrayList_init_$Create$());
  }
  function toCollection_1(_this_, destination) {
    var tmp0_iterator = _this_.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var item = tmp0_iterator.next_37();
      destination.add_39(item);
      Unit_getInstance();
    }
    return destination;
  }
  function _no_name_provided__1_0($this_asIterable) {
    this._$this_asIterable = $this_asIterable;
  }
  _no_name_provided__1_0.prototype.iterator_2_3 = function () {
    return this._$this_asIterable.iterator_67();
  };
  _no_name_provided__1_0.prototype.iterator_67 = function () {
    return this.iterator_2_3();
  };
  _no_name_provided__1_0.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Iterable]
  };
  function plus_1(_this_, elements) {
    var tmp0_safe_receiver = collectionSizeOrNull(elements);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = _this_._get_size__60() + tmp0_safe_receiver | 0;
    }
    var tmp1_elvis_lhs = tmp;
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(tmp1_elvis_lhs == null ? imul(_this_._get_size__60(), 2) : tmp1_elvis_lhs));
    result.addAll_24(_this_);
    Unit_getInstance();
    addAll(result, elements);
    Unit_getInstance();
    return result;
  }
  function plus_2(_this_, elements) {
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(_this_._get_size__60() + elements.length | 0));
    result.addAll_24(_this_);
    Unit_getInstance();
    addAll_0(result, elements);
    Unit_getInstance();
    return result;
  }
  function minus_0(_this_, elements) {
    var other = convertToSetForSetOperationWith(elements, _this_);
    if (other.isEmpty_53())
      return toSet_0(_this_);
    if (isInterface(other, Set)) {
      var tmp0_filterNotTo_0 = LinkedHashSet_init_$Create$();
      var tmp0_iterator_1 = _this_.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (!other.contains_58(element_2)) {
          tmp0_filterNotTo_0.add_39(element_2);
          Unit_getInstance();
        } else {
        }
      }
      return tmp0_filterNotTo_0;
    } else {
    }
    var result = LinkedHashSet_init_$Create$_0(_this_);
    result.removeAll_0(other);
    Unit_getInstance();
    return result;
  }
  function first_1(_this_) {
    if (charSequenceLength(_this_) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    else {
    }
    return charSequenceGet(_this_, 0);
  }
  function take_1(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_substring_0 = 0;
    var tmp2_substring_0 = coerceAtMost(n, _this_.length);
    return _this_.substring(tmp1_substring_0, tmp2_substring_0);
  }
  function dropLast(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return take_1(_this_, coerceAtLeast(_this_.length - n | 0, 0));
  }
  function contentHashCode(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new UByteArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UByteArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentHashCode_5(tmp);
  }
  function contentHashCode_0(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new UShortArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UShortArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentHashCode_6(tmp);
  }
  function contentHashCode_1(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new UIntArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UIntArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentHashCode_4(tmp);
  }
  function contentHashCode_2(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new ULongArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _ULongArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentHashCode_7(tmp);
  }
  function contentEquals(_this_, other) {
    var tmp1_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new UByteArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UByteArray___get_storage__impl_(tmp1_safe_receiver);
      }
    }
    var tmp_1 = tmp;
    var tmp0_safe_receiver = other;
    var tmp_2;
    var tmp_3 = tmp0_safe_receiver;
    if ((tmp_3 == null ? null : new UByteArray(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      {
        tmp_2 = _UByteArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentEquals_5(tmp_1, tmp_2);
  }
  function contentEquals_0(_this_, other) {
    var tmp1_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new UShortArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UShortArray___get_storage__impl_(tmp1_safe_receiver);
      }
    }
    var tmp_1 = tmp;
    var tmp0_safe_receiver = other;
    var tmp_2;
    var tmp_3 = tmp0_safe_receiver;
    if ((tmp_3 == null ? null : new UShortArray(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      {
        tmp_2 = _UShortArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentEquals_6(tmp_1, tmp_2);
  }
  function contentEquals_1(_this_, other) {
    var tmp1_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new UIntArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _UIntArray___get_storage__impl_(tmp1_safe_receiver);
      }
    }
    var tmp_1 = tmp;
    var tmp0_safe_receiver = other;
    var tmp_2;
    var tmp_3 = tmp0_safe_receiver;
    if ((tmp_3 == null ? null : new UIntArray(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      {
        tmp_2 = _UIntArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentEquals_4(tmp_1, tmp_2);
  }
  function contentEquals_2(_this_, other) {
    var tmp1_safe_receiver = _this_;
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new ULongArray(tmp_0)) == null) {
      tmp = null;
    } else {
      {
        tmp = _ULongArray___get_storage__impl_(tmp1_safe_receiver);
      }
    }
    var tmp_1 = tmp;
    var tmp0_safe_receiver = other;
    var tmp_2;
    var tmp_3 = tmp0_safe_receiver;
    if ((tmp_3 == null ? null : new ULongArray(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      {
        tmp_2 = _ULongArray___get_storage__impl_(tmp0_safe_receiver);
      }
    }
    return contentEquals_7(tmp_1, tmp_2);
  }
  function _no_name_provided_(this$0) {
    this._this$0 = this$0;
  }
  _no_name_provided_.prototype.invoke_14 = function (it) {
    return it === this._this$0 ? '(this Collection)' : toString_0(it);
  };
  _no_name_provided_.prototype.invoke_1015 = function (p1) {
    return this.invoke_14((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided_.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractCollection() {
  }
  AbstractCollection.prototype.contains_58 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = this.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (equals_1(element_2, element)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.containsAll_49 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (!this.contains_58(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.isEmpty_53 = function () {
    return this._get_size__60() === 0;
  };
  AbstractCollection.prototype.toString = function () {
    return joinToString$default_0(this, ', ', '[', ']', 0, null, _no_name_provided_$factory(this), 24, null);
  };
  AbstractCollection.prototype.toArray = function () {
    return copyToArrayImpl_0(this);
  };
  AbstractCollection.$metadata$ = {
    simpleName: 'AbstractCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function _no_name_provided_$factory(this$0) {
    var i = new _no_name_provided_(this$0);
    return function (p1) {
      return i.invoke_14(p1);
    };
  }
  function Companion_0() {
    Companion_instance = this;
  }
  Companion_0.prototype.checkElementIndex = function (index, size_1) {
    if (index < 0 ? true : index >= size_1) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index + ', size: ' + size_1);
    }};
  Companion_0.prototype.checkPositionIndex = function (index, size_1) {
    if (index < 0 ? true : index > size_1) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index + ', size: ' + size_1);
    }};
  Companion_0.prototype.checkRangeIndexes = function (fromIndex, toIndex, size_1) {
    if (fromIndex < 0 ? true : toIndex > size_1) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size_1);
    }if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$('' + 'fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }};
  Companion_0.prototype.checkBoundsIndexes = function (startIndex, endIndex, size_1) {
    if (startIndex < 0 ? true : endIndex > size_1) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size_1);
    }if (startIndex > endIndex) {
      throw IllegalArgumentException_init_$Create$('' + 'startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
    }};
  Companion_0.prototype.orderedHashCode = function (c) {
    var hashCode_1 = 1;
    var tmp0_iterator = c.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var e = tmp0_iterator.next_37();
      var tmp = imul(31, hashCode_1);
      var tmp1_safe_receiver = e;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_0.prototype.orderedEquals = function (c, other) {
    if (!(c._get_size__60() === other._get_size__60()))
      return false;
    var otherIterator = other.iterator_67();
    var tmp0_iterator = c.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var elem = tmp0_iterator.next_37();
      var elemOther = otherIterator.next_37();
      if (!equals_1(elem, elemOther)) {
        return false;
      }}
    return true;
  };
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion_0();
    return Companion_instance;
  }
  function _no_name_provided__0($entryIterator) {
    this._$entryIterator = $entryIterator;
  }
  _no_name_provided__0.prototype.hasNext_33 = function () {
    return this._$entryIterator.hasNext_33();
  };
  _no_name_provided__0.prototype.next_37 = function () {
    return this._$entryIterator.next_37()._get_value__10();
  };
  _no_name_provided__0.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function toString($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = $this._get_entries__10();
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (equals_1(element_2._get_key__37(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function Companion_1() {
    Companion_instance_0 = this;
  }
  Companion_1.prototype.entryHashCode = function (e) {
    var tmp2_safe_receiver_4 = e._get_key__37();
    var tmp3_elvis_lhs_3 = tmp2_safe_receiver_4 == null ? null : hashCode(tmp2_safe_receiver_4);
    var tmp = tmp3_elvis_lhs_3 == null ? 0 : tmp3_elvis_lhs_3;
    var tmp0_safe_receiver_6 = e._get_value__10();
    var tmp1_elvis_lhs_5 = tmp0_safe_receiver_6 == null ? null : hashCode(tmp0_safe_receiver_6);
    return tmp ^ (tmp1_elvis_lhs_5 == null ? 0 : tmp1_elvis_lhs_5);
  };
  Companion_1.prototype.entryToString = function (e) {
    return '' + e._get_key__37() + '=' + e._get_value__10();
  };
  Companion_1.prototype.entryEquals = function (e, other) {
    if (!(!(other == null) ? isInterface(other, Entry) : false))
      return false;
    else {
    }
    return equals_1(e._get_key__37(), other._get_key__37()) ? equals_1(e._get_value__10(), other._get_value__10()) : false;
  };
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_1();
    return Companion_instance_0;
  }
  function _no_name_provided__2(this$0) {
    this._this$0_0 = this$0;
  }
  _no_name_provided__2.prototype.invoke_2 = function (it) {
    return this._this$0_0.toString_0(it);
  };
  _no_name_provided__2.prototype.invoke_1015 = function (p1) {
    return this.invoke_2((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__2.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3(this$0) {
    this._this$0_1 = this$0;
    AbstractCollection.call(this);
  }
  _no_name_provided__3.prototype.contains_22 = function (element) {
    return this._this$0_1.containsValue_2(element);
  };
  _no_name_provided__3.prototype.contains_58 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_22((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__3.prototype.iterator_67 = function () {
    var entryIterator = this._this$0_1._get_entries__10().iterator_67();
    return new _no_name_provided__0(entryIterator);
  };
  _no_name_provided__3.prototype._get_size__60 = function () {
    return this._this$0_1._get_size__60();
  };
  _no_name_provided__3.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMap() {
    Companion_getInstance_0();
    this.__keys = null;
    this.__values = null;
  }
  AbstractMap.prototype.containsKey_11 = function (key) {
    return !(implFindEntry(this, key) == null);
  };
  AbstractMap.prototype.containsValue_2 = function (value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._get_entries__10();
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (equals_1(element_2._get_value__10(), value)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.containsEntry_5 = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    else {
    }
    var key = entry._get_key__37();
    var value = entry._get_value__10();
    var ourValue = (isInterface(this, Map_0) ? this : THROW_CCE()).get_116(key);
    if (!equals_1(value, ourValue)) {
      return false;
    }var tmp;
    if (ourValue == null) {
      tmp = !(isInterface(this, Map_0) ? this : THROW_CCE()).containsKey_11(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
    }
    return true;
  };
  AbstractMap.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Map_0) : false))
      return false;
    else {
    }
    if (!(this._get_size__60() === other._get_size__60()))
      return false;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = other._get_entries__10();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (!this.containsEntry_5(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.get_116 = function (key) {
    var tmp0_safe_receiver = implFindEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__10();
  };
  AbstractMap.prototype.hashCode = function () {
    return hashCode(this._get_entries__10());
  };
  AbstractMap.prototype.isEmpty_53 = function () {
    return this._get_size__60() === 0;
  };
  AbstractMap.prototype._get_size__60 = function () {
    return this._get_entries__10()._get_size__60();
  };
  AbstractMap.prototype.toString = function () {
    var tmp = this._get_entries__10();
    return joinToString$default_0(tmp, ', ', '{', '}', 0, null, _no_name_provided_$factory_0(this), 24, null);
  };
  AbstractMap.prototype.toString_0 = function (entry) {
    return toString(this, entry._get_key__37()) + '=' + toString(this, entry._get_value__10());
  };
  AbstractMap.prototype._get_values__9 = function () {
    if (this.__values == null) {
      var tmp = this;
      tmp.__values = new _no_name_provided__3(this);
    }return ensureNotNull(this.__values);
  };
  AbstractMap.$metadata$ = {
    simpleName: 'AbstractMap',
    kind: 'class',
    interfaces: [Map_0]
  };
  function _no_name_provided_$factory_0(this$0) {
    var i = new _no_name_provided__2(this$0);
    return function (p1) {
      return i.invoke_2(p1);
    };
  }
  function Companion_2() {
    Companion_instance_1 = this;
  }
  Companion_2.prototype.unorderedHashCode = function (c) {
    var hashCode_1 = 0;
    var tmp0_iterator = c.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var element = tmp0_iterator.next_37();
      var tmp = hashCode_1;
      var tmp1_safe_receiver = element;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_2.prototype.setEquals = function (c, other) {
    if (!(c._get_size__60() === other._get_size__60()))
      return false;
    return c.containsAll_49(other);
  };
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_2();
    return Companion_instance_1;
  }
  function contentDeepEqualsImpl_0(_this_, other) {
    if (_this_ === other)
      return true;
    if ((_this_ == null ? true : other == null) ? true : !(_this_.length === other.length))
      return false;
    var inductionVariable = 0;
    var last_1 = _this_.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v1 = _this_[i];
        var v2 = other[i];
        if (v1 === v2) {
          continue;
        } else if (v1 == null ? true : v2 == null) {
          return false;
        }var tmp;
        if (!(v1 == null) ? isArray(v1) : false) {
          tmp = !(v2 == null) ? isArray(v2) : false;
        } else {
          {
            tmp = false;
          }
        }
        if (tmp) {
          if (!contentDeepEquals(v1, v2))
            return false;
        } else {
          var tmp_0;
          if (!(v1 == null) ? isByteArray(v1) : false) {
            tmp_0 = !(v2 == null) ? isByteArray(v2) : false;
          } else {
            {
              tmp_0 = false;
            }
          }
          if (tmp_0) {
            if (!contentEquals_5(v1, v2))
              return false;
          } else {
            var tmp_1;
            if (!(v1 == null) ? isShortArray(v1) : false) {
              tmp_1 = !(v2 == null) ? isShortArray(v2) : false;
            } else {
              {
                tmp_1 = false;
              }
            }
            if (tmp_1) {
              if (!contentEquals_6(v1, v2))
                return false;
            } else {
              var tmp_2;
              if (!(v1 == null) ? isIntArray(v1) : false) {
                tmp_2 = !(v2 == null) ? isIntArray(v2) : false;
              } else {
                {
                  tmp_2 = false;
                }
              }
              if (tmp_2) {
                if (!contentEquals_4(v1, v2))
                  return false;
              } else {
                var tmp_3;
                if (!(v1 == null) ? isLongArray(v1) : false) {
                  tmp_3 = !(v2 == null) ? isLongArray(v2) : false;
                } else {
                  {
                    tmp_3 = false;
                  }
                }
                if (tmp_3) {
                  if (!contentEquals_7(v1, v2))
                    return false;
                } else {
                  var tmp_4;
                  if (!(v1 == null) ? isFloatArray(v1) : false) {
                    tmp_4 = !(v2 == null) ? isFloatArray(v2) : false;
                  } else {
                    {
                      tmp_4 = false;
                    }
                  }
                  if (tmp_4) {
                    if (!contentEquals_3(v1, v2))
                      return false;
                  } else {
                    var tmp_5;
                    if (!(v1 == null) ? isDoubleArray(v1) : false) {
                      tmp_5 = !(v2 == null) ? isDoubleArray(v2) : false;
                    } else {
                      {
                        tmp_5 = false;
                      }
                    }
                    if (tmp_5) {
                      if (!contentEquals_8(v1, v2))
                        return false;
                    } else {
                      var tmp_6;
                      if (!(v1 == null) ? isCharArray(v1) : false) {
                        tmp_6 = !(v2 == null) ? isCharArray(v2) : false;
                      } else {
                        {
                          tmp_6 = false;
                        }
                      }
                      if (tmp_6) {
                        if (!contentEquals_9(v1, v2))
                          return false;
                      } else {
                        var tmp_7;
                        if (!(v1 == null) ? isBooleanArray(v1) : false) {
                          tmp_7 = !(v2 == null) ? isBooleanArray(v2) : false;
                        } else {
                          {
                            tmp_7 = false;
                          }
                        }
                        if (tmp_7) {
                          if (!contentEquals_10(v1, v2))
                            return false;
                        } else {
                          var tmp_8;
                          if (v1 instanceof UByteArray) {
                            tmp_8 = v2 instanceof UByteArray;
                          } else {
                            {
                              tmp_8 = false;
                            }
                          }
                          if (tmp_8) {
                            var tmp_9 = v1;
                            var tmp_10 = tmp_9 == null ? null : tmp_9._storage;
                            var tmp_11 = v2;
                            if (!contentEquals(tmp_10, tmp_11 == null ? null : tmp_11._storage))
                              return false;
                            else {
                            }
                          } else {
                            var tmp_12;
                            if (v1 instanceof UShortArray) {
                              tmp_12 = v2 instanceof UShortArray;
                            } else {
                              {
                                tmp_12 = false;
                              }
                            }
                            if (tmp_12) {
                              var tmp_13 = v1;
                              var tmp_14 = tmp_13 == null ? null : tmp_13._storage_2;
                              var tmp_15 = v2;
                              if (!contentEquals_0(tmp_14, tmp_15 == null ? null : tmp_15._storage_2))
                                return false;
                              else {
                              }
                            } else {
                              var tmp_16;
                              if (v1 instanceof UIntArray) {
                                tmp_16 = v2 instanceof UIntArray;
                              } else {
                                {
                                  tmp_16 = false;
                                }
                              }
                              if (tmp_16) {
                                var tmp_17 = v1;
                                var tmp_18 = tmp_17 == null ? null : tmp_17._storage_0;
                                var tmp_19 = v2;
                                if (!contentEquals_1(tmp_18, tmp_19 == null ? null : tmp_19._storage_0))
                                  return false;
                                else {
                                }
                              } else {
                                var tmp_20;
                                if (v1 instanceof ULongArray) {
                                  tmp_20 = v2 instanceof ULongArray;
                                } else {
                                  {
                                    tmp_20 = false;
                                  }
                                }
                                if (tmp_20) {
                                  var tmp_21 = v1;
                                  var tmp_22 = tmp_21 == null ? null : tmp_21._storage_1;
                                  var tmp_23 = v2;
                                  if (!contentEquals_2(tmp_22, tmp_23 == null ? null : tmp_23._storage_1))
                                    return false;
                                  else {
                                  }
                                } else {
                                  if (!equals_1(v1, v2))
                                    return false;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
       while (inductionVariable <= last_1);
    return true;
  }
  function listOf(elements) {
    return elements.length > 0 ? asList(elements) : emptyList();
  }
  function arrayListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function emptyList() {
    return EmptyList_getInstance();
  }
  function _get_indices__0(_this_) {
    return numberRangeToNumber(0, _this_._get_size__60() - 1 | 0);
  }
  function mutableListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function optimizeReadOnlyList(_this_) {
    var tmp0_subject = _this_._get_size__60();
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_.get_137(0));
      default:return _this_;
    }
  }
  function _get_lastIndex__3(_this_) {
    return _this_._get_size__60() - 1 | 0;
  }
  function asCollection(_this_) {
    return new ArrayAsCollection(_this_, false);
  }
  function ArrayAsCollection(values_10, isVarargs) {
    this._values = values_10;
    this._isVarargs = isVarargs;
  }
  ArrayAsCollection.prototype._get_size__60 = function () {
    return this._values.length;
  };
  ArrayAsCollection.prototype.isEmpty_53 = function () {
    var tmp0_isEmpty_0 = this._values;
    return tmp0_isEmpty_0.length === 0;
  };
  ArrayAsCollection.prototype.contains_3 = function (element) {
    return contains_0(this._values, element);
  };
  ArrayAsCollection.prototype.contains_58 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_3((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  ArrayAsCollection.prototype.containsAll_1 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (!this.contains_3(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ArrayAsCollection.prototype.containsAll_49 = function (elements) {
    return this.containsAll_1(elements);
  };
  ArrayAsCollection.prototype.iterator_67 = function () {
    return arrayIterator(this._values);
  };
  ArrayAsCollection.$metadata$ = {
    simpleName: 'ArrayAsCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function EmptyList() {
    EmptyList_instance = this;
    this._serialVersionUID = new Long(-1478467534, -1720727600);
  }
  EmptyList.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, List) : false) {
      tmp = other.isEmpty_53();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyList.prototype.hashCode = function () {
    return 1;
  };
  EmptyList.prototype.toString = function () {
    return '[]';
  };
  EmptyList.prototype._get_size__60 = function () {
    return 0;
  };
  EmptyList.prototype.isEmpty_53 = function () {
    return true;
  };
  EmptyList.prototype.contains_7 = function (element) {
    return false;
  };
  EmptyList.prototype.contains_58 = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_7(tmp);
  };
  EmptyList.prototype.containsAll_5 = function (elements) {
    return elements.isEmpty_53();
  };
  EmptyList.prototype.containsAll_49 = function (elements) {
    return this.containsAll_5(elements);
  };
  EmptyList.prototype.get_137 = function (index) {
    throw IndexOutOfBoundsException_init_$Create$_0('' + "Empty list doesn't contain element at index " + index + '.');
  };
  EmptyList.prototype.iterator_67 = function () {
    return EmptyIterator_getInstance();
  };
  EmptyList.prototype.listIterator_6 = function (index) {
    if (!(index === 0))
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'Index: ' + index);
    return EmptyIterator_getInstance();
  };
  EmptyList.$metadata$ = {
    simpleName: 'EmptyList',
    kind: 'object',
    interfaces: [List, Serializable, RandomAccess]
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function EmptyIterator() {
    EmptyIterator_instance = this;
  }
  EmptyIterator.prototype.hasNext_33 = function () {
    return false;
  };
  EmptyIterator.prototype.next_37 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.$metadata$ = {
    simpleName: 'EmptyIterator',
    kind: 'object',
    interfaces: [ListIterator]
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    if (EmptyIterator_instance == null)
      new EmptyIterator();
    return EmptyIterator_instance;
  }
  function throwCountOverflow() {
    throw ArithmeticException_init_$Create$('Count overflow has happened.');
  }
  function throwIndexOverflow() {
    throw ArithmeticException_init_$Create$('Index overflow has happened.');
  }
  function collectionSizeOrDefault(_this_, default_0) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__60();
    } else {
      {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function collectionSizeOrNull(_this_) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__60();
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function convertToSetForSetOperationWith(_this_, source) {
    var tmp0_subject = _this_;
    var tmp;
    if (isInterface(tmp0_subject, Set)) {
      tmp = _this_;
    } else {
      if (isInterface(tmp0_subject, Collection)) {
        var tmp_0;
        var tmp_1;
        if (isInterface(source, Collection)) {
          tmp_1 = source._get_size__60() < 2;
        } else {
          {
            tmp_1 = false;
          }
        }
        if (tmp_1) {
          tmp_0 = _this_;
        } else {
          {
            tmp_0 = safeToConvertToSet(_this_) ? toHashSet(_this_) : _this_;
          }
        }
        tmp = tmp_0;
      } else {
        {
          tmp = toHashSet(_this_);
        }
      }
    }
    return tmp;
  }
  function safeToConvertToSet(_this_) {
    var tmp;
    if (_this_._get_size__60() > 2) {
      tmp = _this_ instanceof ArrayList;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function toMap(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyMap();
      case 1:
        return mapOf_0(_this_[0]);
      default:return toMap_1(_this_, LinkedHashMap_init_$Create$_1(mapCapacity(_this_.length)));
    }
  }
  function plus_3(_this_, map_0) {
    var tmp0_apply_0 = LinkedHashMap_init_$Create$_2(_this_);
    tmp0_apply_0.putAll_7(map_0);
    return tmp0_apply_0;
  }
  function toMap_0(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__60();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyMap();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_137(0);
          } else {
            {
              tmp_0 = _this_.iterator_67().next_37();
            }
          }

          tmp = mapOf_0(tmp_0);
          break;
        default:tmp = toMap_2(_this_, LinkedHashMap_init_$Create$_1(mapCapacity(_this_._get_size__60())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyMap(toMap_2(_this_, LinkedHashMap_init_$Create$()));
  }
  function linkedMapOf(pairs) {
    return toMap_1(pairs, LinkedHashMap_init_$Create$_1(mapCapacity(pairs.length)));
  }
  function hashMapOf(pairs) {
    var tmp0_apply_0 = HashMap_init_$Create$_1(mapCapacity(pairs.length));
    putAll(tmp0_apply_0, pairs);
    return tmp0_apply_0;
  }
  function mapOf(pairs) {
    return pairs.length > 0 ? toMap_1(pairs, LinkedHashMap_init_$Create$_1(mapCapacity(pairs.length))) : emptyMap();
  }
  function toMutableMap(_this_) {
    return LinkedHashMap_init_$Create$_2(_this_);
  }
  function emptyMap() {
    var tmp = EmptyMap_getInstance();
    return isInterface(tmp, Map_0) ? tmp : THROW_CCE();
  }
  function toMap_1(_this_, destination) {
    putAll(destination, _this_);
    return destination;
  }
  function toMap_2(_this_, destination) {
    putAll_0(destination, _this_);
    return destination;
  }
  function optimizeReadOnlyMap(_this_) {
    var tmp0_subject = _this_._get_size__60();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        tmp = _this_;
        break;
      default:tmp = _this_;
        break;
    }
    return tmp;
  }
  function putAll(_this_, pairs) {
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var tmp1_loop_parameter = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key = tmp1_loop_parameter.component1_1();
      var value = tmp1_loop_parameter.component2_1();
      _this_.put_18(key, value);
      Unit_getInstance();
    }
  }
  function EmptyMap() {
    EmptyMap_instance = this;
    this._serialVersionUID_0 = new Long(-888910638, 1920087921);
  }
  EmptyMap.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Map_0) : false) {
      tmp = other.isEmpty_53();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyMap.prototype.hashCode = function () {
    return 0;
  };
  EmptyMap.prototype.toString = function () {
    return '{}';
  };
  EmptyMap.prototype._get_size__60 = function () {
    return 0;
  };
  EmptyMap.prototype.isEmpty_53 = function () {
    return true;
  };
  EmptyMap.prototype.containsKey_0 = function (key) {
    return false;
  };
  EmptyMap.prototype.containsKey_11 = function (key) {
    if (!(key == null ? true : isObject(key)))
      return false;
    else {
    }
    return this.containsKey_0((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype.get_2 = function (key) {
    return null;
  };
  EmptyMap.prototype.get_116 = function (key) {
    if (!(key == null ? true : isObject(key)))
      return null;
    else {
    }
    return this.get_2((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype._get_entries__10 = function () {
    return EmptySet_getInstance();
  };
  EmptyMap.prototype._get_values__9 = function () {
    return EmptyList_getInstance();
  };
  EmptyMap.$metadata$ = {
    simpleName: 'EmptyMap',
    kind: 'object',
    interfaces: [Map_0, Serializable]
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    if (EmptyMap_instance == null)
      new EmptyMap();
    return EmptyMap_instance;
  }
  function putAll_0(_this_, pairs) {
    var tmp0_iterator = pairs.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var tmp1_loop_parameter = tmp0_iterator.next_37();
      var key = tmp1_loop_parameter.component1_1();
      var value = tmp1_loop_parameter.component2_1();
      _this_.put_18(key, value);
      Unit_getInstance();
    }
  }
  function minus_1(_this_, key) {
    var tmp0_apply_0 = toMutableMap(_this_);
    tmp0_apply_0.remove_72(key);
    Unit_getInstance();
    return optimizeReadOnlyMap(tmp0_apply_0);
  }
  function removeAll(_this_, predicate) {
    return filterInPlace(_this_, predicate, true);
  }
  function removeLast(_this_) {
    var tmp;
    if (_this_.isEmpty_53()) {
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    } else {
      tmp = _this_.removeAt_6(_get_lastIndex__3(_this_));
    }
    return tmp;
  }
  function addAll(_this_, elements) {
    var tmp0_subject = elements;
    if (isInterface(tmp0_subject, Collection))
      return _this_.addAll_24(elements);
    else {
      {
        var result = false;
        var tmp1_iterator = elements.iterator_67();
        while (tmp1_iterator.hasNext_33()) {
          var item = tmp1_iterator.next_37();
          if (_this_.add_39(item))
            result = true;
        }
        return result;
      }
    }
  }
  function filterInPlace(_this_, predicate, predicateResultToRemove) {
    if (!isInterface(_this_, RandomAccess)) {
      return filterInPlace_0(isInterface(_this_, MutableIterable) ? _this_ : THROW_CCE(), predicate, predicateResultToRemove);
    } else {
    }
    var writeIndex = 0;
    var inductionVariable = 0;
    var last_1 = _get_lastIndex__3(_this_);
    if (inductionVariable <= last_1)
      do {
        var readIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = _this_.get_137(readIndex);
        if (predicate(element) === predicateResultToRemove)
          continue;
        if (!(writeIndex === readIndex)) {
          _this_.set_8(writeIndex, element);
          Unit_getInstance();
        }var tmp1 = writeIndex;
        writeIndex = tmp1 + 1 | 0;
        Unit_getInstance();
      }
       while (!(readIndex === last_1));
    if (writeIndex < _this_._get_size__60()) {
      var inductionVariable_0 = _get_lastIndex__3(_this_);
      if (writeIndex <= inductionVariable_0)
        do {
          var removeIndex = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          _this_.removeAt_6(removeIndex);
          Unit_getInstance();
        }
         while (!(removeIndex === writeIndex));
      return true;
    } else {
      return false;
    }
  }
  function addAll_0(_this_, elements) {
    return _this_.addAll_24(asList(elements));
  }
  function filterInPlace_0(_this_, predicate, predicateResultToRemove) {
    var result = false;
    var tmp0_with_0 = _this_.iterator_67();
    while (tmp0_with_0.hasNext_33())
      if (predicate(tmp0_with_0.next_37()) === predicateResultToRemove) {
        tmp0_with_0.remove_46();
        result = true;
      }return result;
  }
  function removeAll_0(_this_, predicate) {
    return filterInPlace_0(_this_, predicate, true);
  }
  function Sequence() {
  }
  Sequence.$metadata$ = {
    simpleName: 'Sequence',
    kind: 'interface',
    interfaces: []
  };
  function sequence(block) {
    return new _no_name_provided__1_1(block);
  }
  function SequenceScope() {
  }
  SequenceScope.$metadata$ = {
    simpleName: 'SequenceScope',
    kind: 'class',
    interfaces: []
  };
  function iterator(block) {
    var iterator_0 = new SequenceBuilderIterator();
    iterator_0._nextStep = createCoroutineUnintercepted(block, iterator_0, iterator_0);
    return iterator_0;
  }
  function nextNotReady($this) {
    if (!$this.hasNext_33())
      throw NoSuchElementException_init_$Create$();
    else
      return $this.next_37();
  }
  function exceptionalState($this) {
    var tmp0_subject = $this._state;
    switch (tmp0_subject) {
      case 4:
        return NoSuchElementException_init_$Create$();
      case 5:
        return IllegalStateException_init_$Create$_0('Iterator has failed.');
      default:return IllegalStateException_init_$Create$_0('' + 'Unexpected state of the iterator: ' + $this._state);
    }
  }
  function SequenceBuilderIterator() {
    SequenceScope.call(this);
    this._state = 0;
    this._nextValue = null;
    this._nextIterator = null;
    this._nextStep = null;
  }
  SequenceBuilderIterator.prototype.hasNext_33 = function () {
    while (true) {
      var tmp0_subject = this._state;
      switch (tmp0_subject) {
        case 0:
          break;
        case 1:
          if (ensureNotNull(this._nextIterator).hasNext_33()) {
            this._state = 2;
            return true;
          } else {
            this._nextIterator = null;
          }

          break;
        case 4:
          return false;
        case 3:
        case 2:
          return true;
        default:throw exceptionalState(this);
      }
      this._state = 5;
      var step_0 = ensureNotNull(this._nextStep);
      this._nextStep = null;
      var tmp1_resume_0 = Unit_getInstance();
      var tmp0_success_0 = Companion_getInstance_2();
      step_0.resumeWith_196(_Result___init__impl_(Unit_getInstance()));
    }
  };
  SequenceBuilderIterator.prototype.next_37 = function () {
    var tmp0_subject = this._state;
    switch (tmp0_subject) {
      case 0:
      case 1:
        return nextNotReady(this);
      case 2:
        this._state = 1;
        return ensureNotNull(this._nextIterator).next_37();
      case 3:
        this._state = 0;
        var tmp = this._nextValue;
        var result = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
        this._nextValue = null;
        return result;
      default:throw exceptionalState(this);
    }
  };
  SequenceBuilderIterator.prototype.yield_0 = function (value, $cont) {
    this._nextValue = value;
    this._state = 3;
    var tmp0__anonymous__1 = $cont;
    this._nextStep = tmp0__anonymous__1;
    return _get_COROUTINE_SUSPENDED_();
  };
  SequenceBuilderIterator.prototype.resumeWith_23 = function (result) {
    throwOnFailure(result);
    var tmp = _Result___get_value__impl_(result);
    if (tmp == null ? true : isObject(tmp))
      tmp;
    else
      THROW_CCE();
    this._state = 4;
  };
  SequenceBuilderIterator.prototype.resumeWith_196 = function (result) {
    return this.resumeWith_23(result);
  };
  SequenceBuilderIterator.prototype._get_context__296 = function () {
    return EmptyCoroutineContext_getInstance();
  };
  SequenceBuilderIterator.$metadata$ = {
    simpleName: 'SequenceBuilderIterator',
    kind: 'class',
    interfaces: [Iterator_3, Continuation]
  };
  function _no_name_provided__1_1($block) {
    this._$block = $block;
  }
  _no_name_provided__1_1.prototype.iterator_2_3 = function () {
    return iterator(this._$block);
  };
  _no_name_provided__1_1.prototype.iterator_67 = function () {
    return this.iterator_2_3();
  };
  _no_name_provided__1_1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Sequence]
  };
  function _no_name_provided__4(this$0) {
    this._this$0_2 = this$0;
    this._iterator = this._this$0_2._sequence.iterator_67();
  }
  _no_name_provided__4.prototype.next_37 = function () {
    return this._this$0_2._transformer(this._iterator.next_37());
  };
  _no_name_provided__4.prototype.hasNext_33 = function () {
    return this._iterator.hasNext_33();
  };
  _no_name_provided__4.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function TransformingSequence(sequence_0, transformer) {
    this._sequence = sequence_0;
    this._transformer = transformer;
  }
  TransformingSequence.prototype.iterator_67 = function () {
    return new _no_name_provided__4(this);
  };
  TransformingSequence.$metadata$ = {
    simpleName: 'TransformingSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function setOf(elements) {
    return elements.length > 0 ? toSet(elements) : emptySet();
  }
  function emptySet() {
    return EmptySet_getInstance();
  }
  function optimizeReadOnlySet(_this_) {
    var tmp0_subject = _this_._get_size__60();
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf_0(_this_.iterator_67().next_37());
      default:return _this_;
    }
  }
  function EmptySet() {
    EmptySet_instance = this;
    this._serialVersionUID_1 = new Long(1993859828, 793161749);
  }
  EmptySet.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Set) : false) {
      tmp = other.isEmpty_53();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptySet.prototype.hashCode = function () {
    return 0;
  };
  EmptySet.prototype.toString = function () {
    return '[]';
  };
  EmptySet.prototype._get_size__60 = function () {
    return 0;
  };
  EmptySet.prototype.isEmpty_53 = function () {
    return true;
  };
  EmptySet.prototype.contains_7 = function (element) {
    return false;
  };
  EmptySet.prototype.contains_58 = function (element) {
    if (!false)
      return false;
    else {
    }
    var tmp;
    if (false) {
      tmp = element;
    } else {
      {
        tmp = THROW_CCE();
      }
    }
    return this.contains_7(tmp);
  };
  EmptySet.prototype.containsAll_5 = function (elements) {
    return elements.isEmpty_53();
  };
  EmptySet.prototype.containsAll_49 = function (elements) {
    return this.containsAll_5(elements);
  };
  EmptySet.prototype.iterator_67 = function () {
    return EmptyIterator_getInstance();
  };
  EmptySet.$metadata$ = {
    simpleName: 'EmptySet',
    kind: 'object',
    interfaces: [Set, Serializable]
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    if (EmptySet_instance == null)
      new EmptySet();
    return EmptySet_instance;
  }
  function hashSetOf(elements) {
    return toCollection(elements, HashSet_init_$Create$(mapCapacity(elements.length)));
  }
  function naturalOrder() {
    var tmp = NaturalOrderComparator_getInstance();
    return isInterface(tmp, Comparator) ? tmp : THROW_CCE();
  }
  function NaturalOrderComparator() {
    NaturalOrderComparator_instance = this;
  }
  NaturalOrderComparator.prototype.compare_1 = function (a, b) {
    return compareTo(a, b);
  };
  NaturalOrderComparator.prototype.compare = function (a, b) {
    var tmp = (!(a == null) ? isComparable(a) : false) ? a : THROW_CCE();
    return this.compare_1(tmp, (!(b == null) ? isComparable(b) : false) ? b : THROW_CCE());
  };
  NaturalOrderComparator.$metadata$ = {
    simpleName: 'NaturalOrderComparator',
    kind: 'object',
    interfaces: [Comparator]
  };
  var NaturalOrderComparator_instance;
  function NaturalOrderComparator_getInstance() {
    if (NaturalOrderComparator_instance == null)
      new NaturalOrderComparator();
    return NaturalOrderComparator_instance;
  }
  function compareValues(a, b) {
    if (a === b)
      return 0;
    if (a == null)
      return -1;
    if (b == null)
      return 1;
    return compareTo((!(a == null) ? isComparable(a) : false) ? a : THROW_CCE(), b);
  }
  function ReverseOrderComparator() {
    ReverseOrderComparator_instance = this;
  }
  ReverseOrderComparator.prototype.compare_1 = function (a, b) {
    return compareTo(b, a);
  };
  ReverseOrderComparator.prototype.compare = function (a, b) {
    var tmp = (!(a == null) ? isComparable(a) : false) ? a : THROW_CCE();
    return this.compare_1(tmp, (!(b == null) ? isComparable(b) : false) ? b : THROW_CCE());
  };
  ReverseOrderComparator.$metadata$ = {
    simpleName: 'ReverseOrderComparator',
    kind: 'object',
    interfaces: [Comparator]
  };
  var ReverseOrderComparator_instance;
  function ReverseOrderComparator_getInstance() {
    if (ReverseOrderComparator_instance == null)
      new ReverseOrderComparator();
    return ReverseOrderComparator_instance;
  }
  function reversed_1(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof ReversedComparator) {
      tmp = _this_._comparator;
    } else {
      if (equals_1(tmp0_subject, NaturalOrderComparator_getInstance())) {
        var tmp_0 = ReverseOrderComparator_getInstance();
        tmp = isInterface(tmp_0, Comparator) ? tmp_0 : THROW_CCE();
      } else {
        if (equals_1(tmp0_subject, ReverseOrderComparator_getInstance())) {
          var tmp_1 = NaturalOrderComparator_getInstance();
          tmp = isInterface(tmp_1, Comparator) ? tmp_1 : THROW_CCE();
        } else {
          {
            tmp = new ReversedComparator(_this_);
          }
        }
      }
    }
    return tmp;
  }
  function ReversedComparator(comparator) {
    this._comparator = comparator;
  }
  ReversedComparator.prototype.compare_10 = function (a, b) {
    return this._comparator.compare(b, a);
  };
  ReversedComparator.prototype.compare = function (a, b) {
    var tmp = (a == null ? true : isObject(a)) ? a : THROW_CCE();
    return this.compare_10(tmp, (b == null ? true : isObject(b)) ? b : THROW_CCE());
  };
  ReversedComparator.$metadata$ = {
    simpleName: 'ReversedComparator',
    kind: 'class',
    interfaces: [Comparator]
  };
  function Continuation() {
  }
  Continuation.$metadata$ = {
    simpleName: 'Continuation',
    kind: 'interface',
    interfaces: []
  };
  function startCoroutine(_this_, completion) {
    var tmp0_resume_0 = intercepted(createCoroutineUnintercepted_0(_this_, completion));
    var tmp1_resume_0 = Unit_getInstance();
    var tmp0_success_0_1 = Companion_getInstance_2();
    tmp0_resume_0.resumeWith_196(_Result___init__impl_(Unit_getInstance()));
  }
  function startCoroutine_0(_this_, receiver, completion) {
    var tmp0_resume_0 = intercepted(createCoroutineUnintercepted(_this_, receiver, completion));
    var tmp1_resume_0 = Unit_getInstance();
    var tmp0_success_0_1 = Companion_getInstance_2();
    tmp0_resume_0.resumeWith_196(_Result___init__impl_(Unit_getInstance()));
  }
  function Key() {
    Key_instance = this;
  }
  Key.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance;
  function Key_getInstance() {
    if (Key_instance == null)
      new Key();
    return Key_instance;
  }
  function ContinuationInterceptor() {
  }
  ContinuationInterceptor.prototype.releaseInterceptedContinuation_11 = function (continuation) {
  };
  ContinuationInterceptor.prototype.get_113 = function (key) {
    if (key instanceof AbstractCoroutineContextKey) {
      var tmp;
      if (key.isSubKey_0(this._get_key__37())) {
        var tmp_0 = key.tryCast_0(this);
        tmp = (!(tmp_0 == null) ? isInterface(tmp_0, Element_0) : false) ? tmp_0 : null;
      } else {
        tmp = null;
      }
      return tmp;
    } else {
    }
    var tmp_1;
    if (Key_getInstance() === key) {
      tmp_1 = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  };
  ContinuationInterceptor.prototype.minusKey_35 = function (key) {
    if (key instanceof AbstractCoroutineContextKey) {
      return (key.isSubKey_0(this._get_key__37()) ? !(key.tryCast_0(this) == null) : false) ? EmptyCoroutineContext_getInstance() : this;
    } else {
    }
    return Key_getInstance() === key ? EmptyCoroutineContext_getInstance() : this;
  };
  ContinuationInterceptor.$metadata$ = {
    simpleName: 'ContinuationInterceptor',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function Key_0() {
  }
  Key_0.$metadata$ = {
    simpleName: 'Key',
    kind: 'interface',
    interfaces: []
  };
  function Element_0() {
  }
  Element_0.prototype.get_113 = function (key) {
    var tmp;
    if (equals_1(this._get_key__37(), key)) {
      tmp = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  };
  Element_0.prototype.fold_34 = function (initial, operation) {
    return operation(initial, this);
  };
  Element_0.prototype.minusKey_35 = function (key) {
    return equals_1(this._get_key__37(), key) ? EmptyCoroutineContext_getInstance() : this;
  };
  Element_0.$metadata$ = {
    simpleName: 'Element',
    kind: 'interface',
    interfaces: [CoroutineContext]
  };
  function _no_name_provided__5() {
  }
  _no_name_provided__5.prototype.invoke_4 = function (acc, element) {
    var removed = acc.minusKey_35(element._get_key__37());
    var tmp;
    if (removed === EmptyCoroutineContext_getInstance()) {
      tmp = element;
    } else {
      var interceptor = removed.get_113(Key_getInstance());
      var tmp_0;
      if (interceptor == null) {
        tmp_0 = new CombinedContext(removed, element);
      } else {
        var left = removed.minusKey_35(Key_getInstance());
        tmp_0 = left === EmptyCoroutineContext_getInstance() ? new CombinedContext(element, interceptor) : new CombinedContext(new CombinedContext(left, element), interceptor);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  _no_name_provided__5.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineContext) : false) ? p1 : THROW_CCE();
    return this.invoke_4(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__5.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CoroutineContext() {
  }
  CoroutineContext.prototype.plus_36 = function (context) {
    var tmp;
    if (context === EmptyCoroutineContext_getInstance()) {
      tmp = this;
    } else {
      tmp = context.fold_34(this, _no_name_provided_$factory_1());
    }
    return tmp;
  };
  CoroutineContext.$metadata$ = {
    simpleName: 'CoroutineContext',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_1() {
    var i = new _no_name_provided__5();
    return function (p1, p2) {
      return i.invoke_4(p1, p2);
    };
  }
  function EmptyCoroutineContext() {
    EmptyCoroutineContext_instance = this;
    this._serialVersionUID_2 = new Long(0, 0);
  }
  EmptyCoroutineContext.prototype.get_113 = function (key) {
    return null;
  };
  EmptyCoroutineContext.prototype.fold_34 = function (initial, operation) {
    return initial;
  };
  EmptyCoroutineContext.prototype.plus_36 = function (context) {
    return context;
  };
  EmptyCoroutineContext.prototype.minusKey_35 = function (key) {
    return this;
  };
  EmptyCoroutineContext.prototype.hashCode = function () {
    return 0;
  };
  EmptyCoroutineContext.prototype.toString = function () {
    return 'EmptyCoroutineContext';
  };
  EmptyCoroutineContext.$metadata$ = {
    simpleName: 'EmptyCoroutineContext',
    kind: 'object',
    interfaces: [CoroutineContext, Serializable]
  };
  var EmptyCoroutineContext_instance;
  function EmptyCoroutineContext_getInstance() {
    if (EmptyCoroutineContext_instance == null)
      new EmptyCoroutineContext();
    return EmptyCoroutineContext_instance;
  }
  function size($this) {
    var cur = $this;
    var size_1 = 2;
    while (true) {
      var tmp = cur._left;
      var tmp0_elvis_lhs = tmp instanceof CombinedContext ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return size_1;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      cur = tmp_0;
      var tmp1 = size_1;
      size_1 = tmp1 + 1 | 0;
      Unit_getInstance();
    }
  }
  function contains_5($this, element) {
    return equals_1($this.get_113(element._get_key__37()), element);
  }
  function containsAll($this, context) {
    var cur = context;
    while (true) {
      if (!contains_5($this, cur._element))
        return false;
      var next_0 = cur._left;
      if (next_0 instanceof CombinedContext) {
        cur = next_0;
      } else {
        {
          return contains_5($this, isInterface(next_0, Element_0) ? next_0 : THROW_CCE());
        }
      }
    }
  }
  function _no_name_provided__6() {
  }
  _no_name_provided__6.prototype.invoke_6 = function (acc, element) {
    var tmp;
    if (charSequenceLength(acc) === 0) {
      tmp = toString_1(element);
    } else {
      {
        tmp = '' + acc + ', ' + element;
      }
    }
    return tmp;
  };
  _no_name_provided__6.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE();
    return this.invoke_6(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__6.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CombinedContext(left, element) {
    this._left = left;
    this._element = element;
  }
  CombinedContext.prototype.get_113 = function (key) {
    var cur = this;
    while (true) {
      var tmp0_safe_receiver = cur._element.get_113(key);
      if (tmp0_safe_receiver == null)
        null;
      else {
        return tmp0_safe_receiver;
      }
      Unit_getInstance();
      var next_0 = cur._left;
      if (next_0 instanceof CombinedContext) {
        cur = next_0;
      } else {
        {
          return next_0.get_113(key);
        }
      }
    }
  };
  CombinedContext.prototype.fold_34 = function (initial, operation) {
    return operation(this._left.fold_34(initial, operation), this._element);
  };
  CombinedContext.prototype.minusKey_35 = function (key) {
    var tmp0_safe_receiver = this._element.get_113(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      return this._left;
    }
    Unit_getInstance();
    var newLeft = this._left.minusKey_35(key);
    return newLeft === this._left ? this : newLeft === EmptyCoroutineContext_getInstance() ? this._element : new CombinedContext(newLeft, this._element);
  };
  CombinedContext.prototype.equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof CombinedContext) {
        tmp_1 = size(other) === size(this);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = containsAll(other, this);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  CombinedContext.prototype.hashCode = function () {
    return hashCode(this._left) + hashCode(this._element) | 0;
  };
  CombinedContext.prototype.toString = function () {
    return '[' + this.fold_34('', _no_name_provided_$factory_2()) + ']';
  };
  CombinedContext.$metadata$ = {
    simpleName: 'CombinedContext',
    kind: 'class',
    interfaces: [CoroutineContext, Serializable]
  };
  function AbstractCoroutineContextKey(baseKey, safeCast) {
    this._safeCast = safeCast;
    var tmp = this;
    var tmp_0;
    if (baseKey instanceof AbstractCoroutineContextKey) {
      tmp_0 = baseKey._topmostKey;
    } else {
      {
        tmp_0 = baseKey;
      }
    }
    tmp._topmostKey = tmp_0;
  }
  AbstractCoroutineContextKey.prototype.tryCast_0 = function (element) {
    return this._safeCast(element);
  };
  AbstractCoroutineContextKey.prototype.isSubKey_0 = function (key) {
    return key === this ? true : this._topmostKey === key;
  };
  AbstractCoroutineContextKey.$metadata$ = {
    simpleName: 'AbstractCoroutineContextKey',
    kind: 'class',
    interfaces: [Key_0]
  };
  function AbstractCoroutineContextElement(key) {
    this._key = key;
  }
  AbstractCoroutineContextElement.prototype._get_key__37 = function () {
    return this._key;
  };
  AbstractCoroutineContextElement.$metadata$ = {
    simpleName: 'AbstractCoroutineContextElement',
    kind: 'class',
    interfaces: [Element_0]
  };
  function _no_name_provided_$factory_2() {
    var i = new _no_name_provided__6();
    return function (p1, p2) {
      return i.invoke_6(p1, p2);
    };
  }
  function _get_COROUTINE_SUSPENDED_() {
    return CoroutineSingletons_COROUTINE_SUSPENDED_getInstance();
  }
  var CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  var CoroutineSingletons_UNDECIDED_instance;
  var CoroutineSingletons_RESUMED_instance;
  var CoroutineSingletons_entriesInitialized;
  function CoroutineSingletons_initEntries() {
    if (CoroutineSingletons_entriesInitialized)
      return Unit_getInstance();
    CoroutineSingletons_entriesInitialized = true;
    CoroutineSingletons_COROUTINE_SUSPENDED_instance = new CoroutineSingletons('COROUTINE_SUSPENDED', 0);
    CoroutineSingletons_UNDECIDED_instance = new CoroutineSingletons('UNDECIDED', 1);
    CoroutineSingletons_RESUMED_instance = new CoroutineSingletons('RESUMED', 2);
  }
  function CoroutineSingletons(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineSingletons.$metadata$ = {
    simpleName: 'CoroutineSingletons',
    kind: 'class',
    interfaces: []
  };
  function CoroutineSingletons_COROUTINE_SUSPENDED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  }
  function CoroutineSingletons_UNDECIDED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_UNDECIDED_instance;
  }
  function CoroutineSingletons_RESUMED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_RESUMED_instance;
  }
  function Default() {
    Default_instance = this;
    Random.call(this);
    this._defaultRandom = defaultPlatformRandom();
  }
  Default.prototype.nextBits_1 = function (bitCount) {
    return this._defaultRandom.nextBits_1(bitCount);
  };
  Default.prototype.nextInt_9 = function () {
    return this._defaultRandom.nextInt_9();
  };
  Default.prototype.nextInt_6 = function (until_1) {
    return this._defaultRandom.nextInt_6(until_1);
  };
  Default.prototype.nextInt_7 = function (from, until_1) {
    return this._defaultRandom.nextInt_7(from, until_1);
  };
  Default.prototype.nextDouble_5 = function () {
    return this._defaultRandom.nextDouble_5();
  };
  Default.prototype.nextDouble_6 = function (until_1) {
    return this._defaultRandom.nextDouble_6(until_1);
  };
  Default.prototype.nextDouble_7 = function (from, until_1) {
    return this._defaultRandom.nextDouble_7(from, until_1);
  };
  Default.$metadata$ = {
    simpleName: 'Default',
    kind: 'object',
    interfaces: []
  };
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Random() {
    Default_getInstance();
  }
  Random.prototype.nextInt_9 = function () {
    return this.nextBits_1(32);
  };
  Random.prototype.nextInt_6 = function (until_1) {
    return this.nextInt_7(0, until_1);
  };
  Random.prototype.nextInt_7 = function (from, until_1) {
    checkRangeBounds(from, until_1);
    var n = until_1 - from | 0;
    if (n > 0 ? true : n === IntCompanionObject_getInstance()._MIN_VALUE_4) {
      var tmp;
      if ((n & (-n | 0)) === n) {
        var bitCount = fastLog2(n);
        tmp = this.nextBits_1(bitCount);
      } else {
        var v;
        do {
          var bits = this.nextInt_9() >>> 1;
          v = bits % n;
        }
         while (((bits - v | 0) + (n - 1 | 0) | 0) < 0);
        tmp = v;
      }
      var rnd = tmp;
      return from + rnd | 0;
    } else {
      while (true) {
        var rnd_0 = this.nextInt_9();
        if (from <= rnd_0 ? rnd_0 < until_1 : false)
          return rnd_0;
      }
    }
  };
  Random.prototype.nextDouble_5 = function () {
    return doubleFromParts(this.nextBits_1(26), this.nextBits_1(27));
  };
  Random.prototype.nextDouble_6 = function (until_1) {
    return this.nextDouble_7(0.0, until_1);
  };
  Random.prototype.nextDouble_7 = function (from, until_1) {
    checkRangeBounds_0(from, until_1);
    var size_1 = until_1 - from;
    var tmp;
    if ((isInfinite(size_1) ? isFinite(from) : false) ? isFinite(until_1) : false) {
      var r1 = this.nextDouble_5() * (until_1 / 2 - from / 2);
      tmp = from + r1 + r1;
    } else {
      tmp = from + this.nextDouble_5() * size_1;
    }
    var r = tmp;
    return r >= until_1 ? nextDown(until_1) : r;
  };
  Random.$metadata$ = {
    simpleName: 'Random',
    kind: 'class',
    interfaces: []
  };
  function checkRangeBounds(from, until_1) {
    var tmp0_require_0 = until_1 > from;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_1);
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return tmp;
  }
  function fastLog2(value) {
    return 31 - Math.clz32(value) | 0;
  }
  function checkRangeBounds_0(from, until_1) {
    var tmp0_require_0 = until_1 > from;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_1);
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return tmp;
  }
  function boundsErrorMessage(from, until_1) {
    return '' + 'Random range is empty: [' + from + ', ' + until_1 + ').';
  }
  function Random_0(seed) {
    return XorWowRandom_init_$Create$(seed, seed >> 31);
  }
  function takeUpperBits(_this_, bitCount) {
    return _this_ >>> (32 - bitCount | 0) & (-bitCount | 0) >> 31;
  }
  function XorWowRandom_init_$Init$(seed1, seed2, $this) {
    XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ seed2 >>> 4);
    return $this;
  }
  function XorWowRandom_init_$Create$(seed1, seed2) {
    return XorWowRandom_init_$Init$(seed1, seed2, Object.create(XorWowRandom.prototype));
  }
  function XorWowRandom(x, y, z, w, v, addend) {
    Random.call(this);
    this._x_0 = x;
    this._y_0 = y;
    this._z = z;
    this._w = w;
    this._v = v;
    this._addend = addend;
    var tmp0_require_0 = !((this._x_0 | this._y_0 | this._z | this._w | this._v) === 0);
    if (!tmp0_require_0) {
      var message_2 = 'Initial state must have at least one non-zero element.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_repeat_0 = 64;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_repeat_0)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.nextInt_9();
        Unit_getInstance();
      }
       while (inductionVariable < tmp1_repeat_0);
  }
  XorWowRandom.prototype.nextInt_9 = function () {
    var t = this._x_0;
    t = t ^ t >>> 2;
    this._x_0 = this._y_0;
    this._y_0 = this._z;
    this._z = this._w;
    var v0 = this._v;
    this._w = v0;
    t = t ^ t << 1 ^ v0 ^ v0 << 4;
    this._v = t;
    var tmp0_this = this;
    tmp0_this._addend = tmp0_this._addend + 362437 | 0;
    return t + this._addend | 0;
  };
  XorWowRandom.prototype.nextBits_1 = function (bitCount) {
    return takeUpperBits(this.nextInt_9(), bitCount);
  };
  XorWowRandom.$metadata$ = {
    simpleName: 'XorWowRandom',
    kind: 'class',
    interfaces: []
  };
  function checkStepIsPositive(isPositive, step_0) {
    if (!isPositive)
      throw IllegalArgumentException_init_$Create$('' + 'Step must be positive, was: ' + step_0 + '.');
  }
  function KClassifier() {
  }
  KClassifier.$metadata$ = {
    simpleName: 'KClassifier',
    kind: 'interface',
    interfaces: []
  };
  function appendElement(_this_, element, transform) {
    if (!(transform == null)) {
      _this_.append_3(transform(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this_.append_3(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this_.append_2(element);
          Unit_getInstance();
        } else {
          {
            _this_.append_3(toString_0(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  function equals(_this_, other, ignoreCase) {
    if (_this_.equals(other))
      return true;
    if (!ignoreCase)
      return false;
    if (uppercaseChar(_this_).equals(uppercaseChar(other)))
      return true;
    var tmp0_asDynamic_0 = _this_.toString();
    var tmp1_unsafeCast_0 = tmp0_asDynamic_0.toLowerCase().charCodeAt(0);
    var tmp = numberToChar(tmp1_unsafeCast_0);
    var tmp2_asDynamic_0 = other.toString();
    var tmp3_unsafeCast_0 = tmp2_asDynamic_0.toLowerCase().charCodeAt(0);
    if (tmp.equals(numberToChar(tmp3_unsafeCast_0)))
      return true;
    else {
    }
    return false;
  }
  function toIntOrNull(_this_) {
    return toIntOrNull_0(_this_, 10);
  }
  function toLongOrNull(_this_) {
    return toLongOrNull_0(_this_, 10);
  }
  function toIntOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var start;
    var isNegative_0;
    var limit;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_10(new Char(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar.equals(new Char(45))) {
        isNegative_0 = true;
        limit = IntCompanionObject_getInstance()._MIN_VALUE_4;
      } else if (firstChar.equals(new Char(43))) {
        isNegative_0 = false;
        limit = -IntCompanionObject_getInstance()._MAX_VALUE_4 | 0;
      } else
        return null;
    } else {
      start = 0;
      isNegative_0 = false;
      limit = -IntCompanionObject_getInstance()._MAX_VALUE_4 | 0;
    }
    var limitForMaxRadix = (-IntCompanionObject_getInstance()._MAX_VALUE_4 | 0) / 36 | 0;
    var limitBeforeMul = limitForMaxRadix;
    var result = 0;
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        if (result < limitBeforeMul) {
          if (limitBeforeMul === limitForMaxRadix) {
            limitBeforeMul = limit / radix | 0;
            if (result < limitBeforeMul) {
              return null;
            }} else {
            return null;
          }
        }result = imul(result, radix);
        if (result < (limit + digit | 0))
          return null;
        result = result - digit | 0;
      }
       while (inductionVariable < length);
    return isNegative_0 ? result : -result | 0;
  }
  function toLongOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var start;
    var isNegative_0;
    var limit;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_10(new Char(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar.equals(new Char(45))) {
        isNegative_0 = true;
        limit = new Long(0, -2147483648);
      } else if (firstChar.equals(new Char(43))) {
        isNegative_0 = false;
        limit = new Long(1, -2147483648);
      } else
        return null;
    } else {
      start = 0;
      isNegative_0 = false;
      limit = new Long(1, -2147483648);
    }
    var tmp0_div_0 = new Long(1, -2147483648);
    var tmp1_div_0 = 36;
    var limitForMaxRadix = tmp0_div_0.div_28(toLong(tmp1_div_0));
    var limitBeforeMul = limitForMaxRadix;
    var result = new Long(0, 0);
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        if (result.compareTo_137(limitBeforeMul) < 0) {
          if (limitBeforeMul.equals(limitForMaxRadix)) {
            limitBeforeMul = limit.div_28(toLong(radix));
            if (result.compareTo_137(limitBeforeMul) < 0) {
              return null;
            }} else {
            return null;
          }
        }var tmp2_times_0 = result;
        result = tmp2_times_0.times_28(toLong(radix));
        var tmp = result;
        if (tmp.compareTo_137(limit.plus_64(toLong(digit))) < 0)
          return null;
        else {
        }
        var tmp3_minus_0 = result;
        result = tmp3_minus_0.minus_29(toLong(digit));
      }
       while (inductionVariable < length);
    return isNegative_0 ? result : result.unaryMinus_4();
  }
  function numberFormatError(input) {
    throw NumberFormatException_init_$Create$('' + "Invalid number format: '" + input + "'");
  }
  function startsWith(_this_, char, ignoreCase) {
    return charSequenceLength(_this_) > 0 ? equals(charSequenceGet(_this_, 0), char, ignoreCase) : false;
  }
  function startsWith$default(_this_, char, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith(_this_, char, ignoreCase);
  }
  function substringBefore(_this_, delimiter, missingDelimiterValue) {
    var index = indexOf$default(_this_, delimiter, 0, false, 6, null);
    var tmp;
    if (index === -1) {
      tmp = missingDelimiterValue;
    } else {
      var tmp0_substring_0 = 0;
      tmp = _this_.substring(tmp0_substring_0, index);
    }
    return tmp;
  }
  function substringBefore$default(_this_, delimiter, missingDelimiterValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      missingDelimiterValue = _this_;
    return substringBefore(_this_, delimiter, missingDelimiterValue);
  }
  function substringAfter(_this_, delimiter, missingDelimiterValue) {
    var index = indexOf$default(_this_, delimiter, 0, false, 6, null);
    var tmp;
    if (index === -1) {
      tmp = missingDelimiterValue;
    } else {
      var tmp0_substring_0 = index + 1 | 0;
      var tmp1_substring_0 = _this_.length;
      tmp = _this_.substring(tmp0_substring_0, tmp1_substring_0);
    }
    return tmp;
  }
  function substringAfter$default(_this_, delimiter, missingDelimiterValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      missingDelimiterValue = _this_;
    return substringAfter(_this_, delimiter, missingDelimiterValue);
  }
  function padStart(_this_, length, padChar) {
    return toString_1(padStart_0(isCharSequence(_this_) ? _this_ : THROW_CCE(), length, padChar));
  }
  function removeSuffix(_this_, suffix) {
    if (endsWith$default_0(_this_, suffix, false, 2, null)) {
      var tmp0_substring_0 = 0;
      var tmp1_substring_0 = _this_.length - charSequenceLength(suffix) | 0;
      return _this_.substring(tmp0_substring_0, tmp1_substring_0);
    } else {
    }
    return _this_;
  }
  function trim(_this_, chars) {
    var tmp0_trim_0 = isCharSequence(_this_) ? _this_ : THROW_CCE();
    var startIndex_1 = 0;
    var endIndex_2 = charSequenceLength(tmp0_trim_0) - 1 | 0;
    var startFound_3 = false;
    $l$break: while (startIndex_1 <= endIndex_2) {
      var index_4 = !startFound_3 ? startIndex_1 : endIndex_2;
      var tmp1__anonymous__1 = charSequenceGet(tmp0_trim_0, index_4);
      var match_5 = contains_1(chars, tmp1__anonymous__1);
      if (!startFound_3) {
        if (!match_5)
          startFound_3 = true;
        else
          startIndex_1 = startIndex_1 + 1 | 0;
      } else {
        if (!match_5)
          break $l$break;
        else
          endIndex_2 = endIndex_2 - 1 | 0;
      }
    }
    return toString_1(charSequenceSubSequence(tmp0_trim_0, startIndex_1, endIndex_2 + 1 | 0));
  }
  function trimStart(_this_, chars) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_trimStart_0 = isCharSequence(_this_) ? _this_ : THROW_CCE();
      var inductionVariable = 0;
      var last_1 = charSequenceLength(tmp0_trimStart_0) - 1 | 0;
      if (inductionVariable <= last_1)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1__anonymous__1 = charSequenceGet(tmp0_trimStart_0, index_2);
          if (!contains_1(chars, tmp1__anonymous__1)) {
            tmp$ret$0 = charSequenceSubSequence(tmp0_trimStart_0, index_2, charSequenceLength(tmp0_trimStart_0));
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable <= last_1);
      tmp$ret$0 = '';
    }
     while (false);
    return toString_1(tmp$ret$0);
  }
  function substringBeforeLast(_this_, delimiter, missingDelimiterValue) {
    var index = lastIndexOf$default(_this_, delimiter, 0, false, 6, null);
    var tmp;
    if (index === -1) {
      tmp = missingDelimiterValue;
    } else {
      var tmp0_substring_0 = 0;
      tmp = _this_.substring(tmp0_substring_0, index);
    }
    return tmp;
  }
  function substringBeforeLast$default(_this_, delimiter, missingDelimiterValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      missingDelimiterValue = _this_;
    return substringBeforeLast(_this_, delimiter, missingDelimiterValue);
  }
  function split(_this_, delimiters, ignoreCase, limit) {
    if (delimiters.length === 1) {
      return split_1(_this_, delimiters[0].toString(), ignoreCase, limit);
    }var tmp0_map_0 = asIterable(rangesDelimitedBy$default(_this_, delimiters, 0, ignoreCase, limit, 2, null));
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(substring(_this_, item_2_3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  }
  function split$default(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return split(_this_, delimiters, ignoreCase, limit);
  }
  function split_0(_this_, delimiters, ignoreCase, limit) {
    if (delimiters.length === 1) {
      var delimiter = delimiters[0];
      if (!(charSequenceLength(delimiter) === 0)) {
        return split_1(_this_, delimiter, ignoreCase, limit);
      } else {
      }
    }var tmp0_map_0 = asIterable(rangesDelimitedBy$default_0(_this_, delimiters, 0, ignoreCase, limit, 2, null));
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(substring(_this_, item_2_3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  }
  function split$default_0(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return split_0(_this_, delimiters, ignoreCase, limit);
  }
  function indexOf_5(_this_, char, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      var tmp0_charArrayOf_0 = charArrayOf([char]);
      tmp = indexOfAny(_this_, tmp0_charArrayOf_0, startIndex, ignoreCase);
    } else {
      {
        var tmp2_nativeIndexOf_0 = _this_;
        var tmp1_nativeIndexOf_0 = char.toString();
        tmp = tmp2_nativeIndexOf_0.indexOf(tmp1_nativeIndexOf_0, startIndex);
      }
    }
    return tmp;
  }
  function indexOf$default(_this_, char, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return indexOf_5(_this_, char, startIndex, ignoreCase);
  }
  function indexOf_6(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      var tmp_1 = charSequenceLength(_this_);
      tmp = indexOf$default_1(_this_, string, startIndex, tmp_1, ignoreCase, false, 16, null);
    } else {
      {
        var tmp0_nativeIndexOf_0 = _this_;
        tmp = tmp0_nativeIndexOf_0.indexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function indexOf$default_0(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return indexOf_6(_this_, string, startIndex, ignoreCase);
  }
  function contains_6(_this_, char, ignoreCase) {
    return indexOf$default(_this_, char, 0, ignoreCase, 2, null) >= 0;
  }
  function contains$default(_this_, char, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return contains_6(_this_, char, ignoreCase);
  }
  function lineSequence(_this_) {
    var tmp = ['\r\n', '\n', '\r'];
    return splitToSequence$default(_this_, tmp, false, 0, 6, null);
  }
  function trimEnd(_this_, chars) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_trimEnd_0 = isCharSequence(_this_) ? _this_ : THROW_CCE();
      var inductionVariable = charSequenceLength(tmp0_trimEnd_0) - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp1__anonymous__1 = charSequenceGet(tmp0_trimEnd_0, index_2);
          if (!contains_1(chars, tmp1__anonymous__1)) {
            tmp$ret$0 = charSequenceSubSequence(tmp0_trimEnd_0, 0, index_2 + 1 | 0);
            break l$ret$1;
          } else {
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$0 = '';
    }
     while (false);
    return toString_1(tmp$ret$0);
  }
  function substringAfterLast(_this_, delimiter, missingDelimiterValue) {
    var index = lastIndexOf$default(_this_, delimiter, 0, false, 6, null);
    var tmp;
    if (index === -1) {
      tmp = missingDelimiterValue;
    } else {
      var tmp0_substring_0 = index + 1 | 0;
      var tmp1_substring_0 = _this_.length;
      tmp = _this_.substring(tmp0_substring_0, tmp1_substring_0);
    }
    return tmp;
  }
  function substringAfterLast$default(_this_, delimiter, missingDelimiterValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      missingDelimiterValue = _this_;
    return substringAfterLast(_this_, delimiter, missingDelimiterValue);
  }
  function _get_lastIndex__4(_this_) {
    return charSequenceLength(_this_) - 1 | 0;
  }
  function lastIndexOf(_this_, char, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      var tmp0_charArrayOf_0 = charArrayOf([char]);
      tmp = lastIndexOfAny(_this_, tmp0_charArrayOf_0, startIndex, ignoreCase);
    } else {
      {
        var tmp2_nativeLastIndexOf_0 = _this_;
        var tmp1_nativeLastIndexOf_0 = char.toString();
        tmp = tmp2_nativeLastIndexOf_0.lastIndexOf(tmp1_nativeLastIndexOf_0, startIndex);
      }
    }
    return tmp;
  }
  function lastIndexOf$default(_this_, char, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__4(_this_);
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return lastIndexOf(_this_, char, startIndex, ignoreCase);
  }
  function contains_7(_this_, other, ignoreCase) {
    var tmp;
    if (typeof other === 'string') {
      var tmp_0 = other;
      tmp = indexOf$default_0(_this_, tmp_0, 0, ignoreCase, 2, null) >= 0;
    } else {
      {
        var tmp_1 = charSequenceLength(_this_);
        tmp = indexOf$default_1(_this_, other, 0, tmp_1, ignoreCase, false, 16, null) >= 0;
      }
    }
    return tmp;
  }
  function contains$default_0(_this_, other, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return contains_7(_this_, other, ignoreCase);
  }
  function removePrefix(_this_, prefix) {
    if (startsWith$default_0(_this_, prefix, false, 2, null)) {
      var tmp0_substring_0 = charSequenceLength(prefix);
      return _this_.substring(tmp0_substring_0);
    } else {
    }
    return _this_;
  }
  function endsWith(_this_, char, ignoreCase) {
    return charSequenceLength(_this_) > 0 ? equals(charSequenceGet(_this_, _get_lastIndex__4(_this_)), char, ignoreCase) : false;
  }
  function endsWith$default(_this_, char, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith(_this_, char, ignoreCase);
  }
  function padStart_0(_this_, length, padChar) {
    if (length < 0)
      throw IllegalArgumentException_init_$Create$('' + 'Desired length ' + length + ' is less than zero.');
    if (length <= charSequenceLength(_this_))
      return charSequenceSubSequence(_this_, 0, charSequenceLength(_this_));
    var sb = StringBuilder_init_$Create$(length);
    var inductionVariable = 1;
    var last_1 = length - charSequenceLength(_this_) | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.append_2(padChar);
        Unit_getInstance();
      }
       while (!(i === last_1));
    sb.append_3(_this_);
    Unit_getInstance();
    return sb;
  }
  function endsWith_0(_this_, suffix, ignoreCase) {
    var tmp;
    var tmp_0;
    if (!ignoreCase) {
      tmp_0 = typeof _this_ === 'string';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = typeof suffix === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var tmp_1 = _this_;
      var tmp_2 = suffix;
      return endsWith$default_1(tmp_1, tmp_2, false, 2, null);
    } else {
      return regionMatchesImpl(_this_, charSequenceLength(_this_) - charSequenceLength(suffix) | 0, suffix, 0, charSequenceLength(suffix), ignoreCase);
    }
  }
  function endsWith$default_0(_this_, suffix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith_0(_this_, suffix, ignoreCase);
  }
  function trim_0(_this_) {
    var startIndex_1 = 0;
    var endIndex_2 = charSequenceLength(_this_) - 1 | 0;
    var startFound_3 = false;
    $l$break: while (startIndex_1 <= endIndex_2) {
      var index_4 = !startFound_3 ? startIndex_1 : endIndex_2;
      var match_5 = isWhitespace(charSequenceGet(_this_, index_4));
      if (!startFound_3) {
        if (!match_5)
          startFound_3 = true;
        else
          startIndex_1 = startIndex_1 + 1 | 0;
      } else {
        if (!match_5)
          break $l$break;
        else
          endIndex_2 = endIndex_2 - 1 | 0;
      }
    }
    return charSequenceSubSequence(_this_, startIndex_1, endIndex_2 + 1 | 0);
  }
  function split_1(_this_, delimiter, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var currentOffset = 0;
    var nextIndex = indexOf_6(_this_, delimiter, currentOffset, ignoreCase);
    if (nextIndex === -1 ? true : limit === 1) {
      return listOf_0(toString_1(_this_));
    }var isLimited = limit > 0;
    var result = ArrayList_init_$Create$_0(isLimited ? coerceAtMost(limit, 10) : 10);
    $l$break: do {
      var tmp1_substring_0 = currentOffset;
      var tmp2_substring_0 = nextIndex;
      result.add_39(toString_1(charSequenceSubSequence(_this_, tmp1_substring_0, tmp2_substring_0)));
      Unit_getInstance();
      currentOffset = nextIndex + delimiter.length | 0;
      if (isLimited ? result._get_size__60() === (limit - 1 | 0) : false)
        break $l$break;
      nextIndex = indexOf_6(_this_, delimiter, currentOffset, ignoreCase);
    }
     while (!(nextIndex === -1));
    var tmp3_substring_0 = currentOffset;
    var tmp4_substring_0 = charSequenceLength(_this_);
    result.add_39(toString_1(charSequenceSubSequence(_this_, tmp3_substring_0, tmp4_substring_0)));
    Unit_getInstance();
    return result;
  }
  function substring(_this_, range) {
    return toString_1(charSequenceSubSequence(_this_, range._get_start__0(), range._get_endInclusive__0() + 1 | 0));
  }
  function rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return new DelimitedRangesSequence(_this_, startIndex, limit, _no_name_provided_$factory_3(delimiters, ignoreCase));
  }
  function rangesDelimitedBy$default(_this_, delimiters, startIndex, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    if (!(($mask0 & 8) === 0))
      limit = 0;
    return rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit);
  }
  function rangesDelimitedBy_0(_this_, delimiters, startIndex, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var delimitersList = asList(delimiters);
    return new DelimitedRangesSequence(_this_, startIndex, limit, _no_name_provided_$factory_4(delimitersList, ignoreCase));
  }
  function rangesDelimitedBy$default_0(_this_, delimiters, startIndex, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    if (!(($mask0 & 8) === 0))
      limit = 0;
    return rangesDelimitedBy_0(_this_, delimiters, startIndex, ignoreCase, limit);
  }
  function indexOfAny(_this_, chars, startIndex, ignoreCase) {
    var tmp;
    if (!ignoreCase ? chars.length === 1 : false) {
      tmp = typeof _this_ === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var char = single(chars);
      var tmp1_nativeIndexOf_0 = _this_;
      var tmp0_nativeIndexOf_0 = char.toString();
      return tmp1_nativeIndexOf_0.indexOf(tmp0_nativeIndexOf_0, startIndex);
    } else {
    }
    var inductionVariable = coerceAtLeast(startIndex, 0);
    var last_1 = _get_lastIndex__4(_this_);
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var charAtIndex = charSequenceGet(_this_, index);
        var tmp$ret$0;
        l$ret$1: do {
          var indexedObject = chars;
          var inductionVariable_0 = 0;
          var last_2 = indexedObject.length;
          while (inductionVariable_0 < last_2) {
            var element_2 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (equals(element_2, charAtIndex, ignoreCase)) {
              tmp$ret$0 = true;
              break l$ret$1;
            } else {
            }
          }
          tmp$ret$0 = false;
        }
         while (false);
        if (tmp$ret$0)
          return index;
        else {
        }
      }
       while (!(index === last_1));
    return -1;
  }
  function indexOf_7(_this_, other, startIndex, endIndex, ignoreCase, last_1) {
    var indices = !last_1 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), coerceAtMost(endIndex, charSequenceLength(_this_))) : downTo(coerceAtMost(startIndex, _get_lastIndex__4(_this_)), coerceAtLeast(endIndex, 0));
    var tmp;
    if (typeof _this_ === 'string') {
      tmp = typeof other === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var inductionVariable = indices._first_0;
      var last_2 = indices._last;
      var step_0 = indices._step_2;
      if ((step_0 > 0 ? inductionVariable <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable : false)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          if (regionMatches(other, 0, _this_, index, charSequenceLength(other), ignoreCase))
            return index;
        }
         while (!(index === last_2));
    } else {
      {
        var inductionVariable_0 = indices._first_0;
        var last_3 = indices._last;
        var step_1 = indices._step_2;
        if ((step_1 > 0 ? inductionVariable_0 <= last_3 : false) ? true : step_1 < 0 ? last_3 <= inductionVariable_0 : false)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            if (regionMatchesImpl(other, 0, _this_, index_0, charSequenceLength(other), ignoreCase))
              return index_0;
          }
           while (!(index_0 === last_3));
      }
    }
    return -1;
  }
  function indexOf$default_1(_this_, other, startIndex, endIndex, ignoreCase, last_1, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      last_1 = false;
    return indexOf_7(_this_, other, startIndex, endIndex, ignoreCase, last_1);
  }
  function splitToSequence(_this_, delimiters, ignoreCase, limit) {
    var tmp = rangesDelimitedBy$default_0(_this_, delimiters, 0, ignoreCase, limit, 2, null);
    return map(tmp, _no_name_provided_$factory_5(_this_));
  }
  function splitToSequence$default(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return splitToSequence(_this_, delimiters, ignoreCase, limit);
  }
  function lastIndexOfAny(_this_, chars, startIndex, ignoreCase) {
    var tmp;
    if (!ignoreCase ? chars.length === 1 : false) {
      tmp = typeof _this_ === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var char = single(chars);
      var tmp1_nativeLastIndexOf_0 = _this_;
      var tmp0_nativeLastIndexOf_0 = char.toString();
      return tmp1_nativeLastIndexOf_0.lastIndexOf(tmp0_nativeLastIndexOf_0, startIndex);
    } else {
    }
    var inductionVariable = coerceAtMost(startIndex, _get_lastIndex__4(_this_));
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var charAtIndex = charSequenceGet(_this_, index);
        var tmp$ret$0;
        l$ret$1: do {
          var indexedObject = chars;
          var inductionVariable_0 = 0;
          var last_1 = indexedObject.length;
          while (inductionVariable_0 < last_1) {
            var element_2 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (equals(element_2, charAtIndex, ignoreCase)) {
              tmp$ret$0 = true;
              break l$ret$1;
            } else {
            }
          }
          tmp$ret$0 = false;
        }
         while (false);
        if (tmp$ret$0)
          return index;
        else {
        }
      }
       while (0 <= inductionVariable);
    return -1;
  }
  function startsWith_0(_this_, prefix, ignoreCase) {
    var tmp;
    var tmp_0;
    if (!ignoreCase) {
      tmp_0 = typeof _this_ === 'string';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = typeof prefix === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var tmp_1 = _this_;
      var tmp_2 = prefix;
      return startsWith$default_1(tmp_1, tmp_2, false, 2, null);
    } else {
      return regionMatchesImpl(_this_, 0, prefix, 0, charSequenceLength(prefix), ignoreCase);
    }
  }
  function startsWith$default_0(_this_, prefix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith_0(_this_, prefix, ignoreCase);
  }
  function trimEnd_0(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var inductionVariable = charSequenceLength(_this_) - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (!isWhitespace(charSequenceGet(_this_, index_2))) {
            tmp$ret$0 = charSequenceSubSequence(_this_, 0, index_2 + 1 | 0);
            break l$ret$1;
          }}
         while (0 <= inductionVariable);
      tmp$ret$0 = '';
    }
     while (false);
    return tmp$ret$0;
  }
  function regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    if (((otherOffset < 0 ? true : thisOffset < 0) ? true : thisOffset > (charSequenceLength(_this_) - length | 0)) ? true : otherOffset > (charSequenceLength(other) - length | 0)) {
      return false;
    }var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(charSequenceGet(_this_, thisOffset + index | 0), charSequenceGet(other, otherOffset + index | 0), ignoreCase))
          return false;
      }
       while (inductionVariable < length);
    return true;
  }
  function calcNext($this) {
    if ($this._nextSearchIndex < 0) {
      $this._nextState = 0;
      $this._nextItem = null;
    } else {
      var tmp;
      var tmp_0;
      if ($this._this$0_3._limit > 0) {
        var tmp0_this = $this;
        tmp0_this._counter = tmp0_this._counter + 1 | 0;
        tmp_0 = tmp0_this._counter >= $this._this$0_3._limit;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        {
          tmp = $this._nextSearchIndex > charSequenceLength($this._this$0_3._input);
        }
      }
      if (tmp) {
        $this._nextItem = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__4($this._this$0_3._input));
        $this._nextSearchIndex = -1;
      } else {
        {
          var match = $this._this$0_3._getNextMatch($this._this$0_3._input, $this._nextSearchIndex);
          if (match == null) {
            $this._nextItem = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__4($this._this$0_3._input));
            $this._nextSearchIndex = -1;
          } else {
            var tmp1_container = match;
            var index = tmp1_container.component1_1();
            var length = tmp1_container.component2_1();
            $this._nextItem = until($this._currentStartIndex, index);
            $this._currentStartIndex = index + length | 0;
            $this._nextSearchIndex = $this._currentStartIndex + (length === 0 ? 1 : 0) | 0;
          }
        }
      }
      $this._nextState = 1;
    }
  }
  function _no_name_provided__7(this$0) {
    this._this$0_3 = this$0;
    this._nextState = -1;
    this._currentStartIndex = coerceIn(this._this$0_3._startIndex, 0, charSequenceLength(this._this$0_3._input));
    this._nextSearchIndex = this._currentStartIndex;
    this._nextItem = null;
    this._counter = 0;
  }
  _no_name_provided__7.prototype.next_37 = function () {
    if (this._nextState === -1)
      calcNext(this);
    if (this._nextState === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem;
    var result = tmp instanceof IntRange ? tmp : THROW_CCE();
    this._nextItem = null;
    this._nextState = -1;
    return result;
  };
  _no_name_provided__7.prototype.hasNext_33 = function () {
    if (this._nextState === -1)
      calcNext(this);
    return this._nextState === 1;
  };
  _no_name_provided__7.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function DelimitedRangesSequence(input, startIndex, limit, getNextMatch) {
    this._input = input;
    this._startIndex = startIndex;
    this._limit = limit;
    this._getNextMatch = getNextMatch;
  }
  DelimitedRangesSequence.prototype.iterator_67 = function () {
    return new _no_name_provided__7(this);
  };
  DelimitedRangesSequence.$metadata$ = {
    simpleName: 'DelimitedRangesSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function findAnyOf(_this_, strings, startIndex, ignoreCase, last_1) {
    if (!ignoreCase ? strings._get_size__60() === 1 : false) {
      var string = single_0(strings);
      var tmp;
      if (!last_1) {
        tmp = indexOf$default_0(_this_, string, startIndex, false, 4, null);
      } else {
        tmp = lastIndexOf$default_0(_this_, string, startIndex, false, 4, null);
      }
      var index = tmp;
      return index < 0 ? null : to(index, string);
    }var indices = !last_1 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), charSequenceLength(_this_)) : downTo(coerceAtMost(startIndex, _get_lastIndex__4(_this_)), 0);
    if (typeof _this_ === 'string') {
      var inductionVariable = indices._first_0;
      var last_2 = indices._last;
      var step_0 = indices._step_2;
      if ((step_0 > 0 ? inductionVariable <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable : false)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var tmp$ret$0;
          l$ret$1: do {
            var tmp0_iterator_1 = strings.iterator_67();
            while (tmp0_iterator_1.hasNext_33()) {
              var element_2 = tmp0_iterator_1.next_37();
              if (regionMatches(element_2, 0, _this_, index_0, element_2.length, ignoreCase)) {
                tmp$ret$0 = element_2;
                break l$ret$1;
              } else {
              }
            }
            tmp$ret$0 = null;
          }
           while (false);
          var matchingString = tmp$ret$0;
          if (!(matchingString == null))
            return to(index_0, matchingString);
        }
         while (!(index_0 === last_2));
    } else {
      {
        var inductionVariable_0 = indices._first_0;
        var last_3 = indices._last;
        var step_1 = indices._step_2;
        if ((step_1 > 0 ? inductionVariable_0 <= last_3 : false) ? true : step_1 < 0 ? last_3 <= inductionVariable_0 : false)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            var tmp$ret$2;
            l$ret$3: do {
              var tmp0_iterator_1_0 = strings.iterator_67();
              while (tmp0_iterator_1_0.hasNext_33()) {
                var element_2_0 = tmp0_iterator_1_0.next_37();
                if (regionMatchesImpl(element_2_0, 0, _this_, index_1, element_2_0.length, ignoreCase)) {
                  tmp$ret$2 = element_2_0;
                  break l$ret$3;
                } else {
                }
              }
              tmp$ret$2 = null;
            }
             while (false);
            var matchingString_0 = tmp$ret$2;
            if (!(matchingString_0 == null))
              return to(index_1, matchingString_0);
          }
           while (!(index_1 === last_3));
      }
    }
    return null;
  }
  function lastIndexOf_0(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      tmp = indexOf_7(_this_, string, startIndex, 0, ignoreCase, true);
    } else {
      {
        var tmp0_nativeLastIndexOf_0 = _this_;
        tmp = tmp0_nativeLastIndexOf_0.lastIndexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function lastIndexOf$default_0(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__4(_this_);
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return lastIndexOf_0(_this_, string, startIndex, ignoreCase);
  }
  function lines(_this_) {
    return toList_4(lineSequence(_this_));
  }
  function _no_name_provided__8($delimiters, $ignoreCase) {
    this._$delimiters = $delimiters;
    this._$ignoreCase = $ignoreCase;
  }
  _no_name_provided__8.prototype.invoke_10 = function (_this__0, currentIndex) {
    var tmp0_let_0 = indexOfAny(_this__0, this._$delimiters, currentIndex, this._$ignoreCase);
    return tmp0_let_0 < 0 ? null : to(tmp0_let_0, 1);
  };
  _no_name_provided__8.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isCharSequence(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_10(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__8.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__9($delimitersList, $ignoreCase) {
    this._$delimitersList = $delimitersList;
    this._$ignoreCase_0 = $ignoreCase;
  }
  _no_name_provided__9.prototype.invoke_10 = function (_this__0, currentIndex) {
    var tmp0_safe_receiver = findAnyOf(_this__0, this._$delimitersList, currentIndex, this._$ignoreCase_0, false);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = to(tmp0_safe_receiver._first, tmp0_safe_receiver._second.length);
    }
    return tmp;
  };
  _no_name_provided__9.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isCharSequence(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_10(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__9.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__10($this_splitToSequence) {
    this._$this_splitToSequence = $this_splitToSequence;
  }
  _no_name_provided__10.prototype.invoke_12 = function (it) {
    return substring(this._$this_splitToSequence, it);
  };
  _no_name_provided__10.prototype.invoke_1015 = function (p1) {
    return this.invoke_12(p1 instanceof IntRange ? p1 : THROW_CCE());
  };
  _no_name_provided__10.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_3($delimiters, $ignoreCase) {
    var i = new _no_name_provided__8($delimiters, $ignoreCase);
    return function (p1, p2) {
      return i.invoke_10(p1, p2);
    };
  }
  function _no_name_provided_$factory_4($delimitersList, $ignoreCase) {
    var i = new _no_name_provided__9($delimitersList, $ignoreCase);
    return function (p1, p2) {
      return i.invoke_10(p1, p2);
    };
  }
  function _no_name_provided_$factory_5($this_splitToSequence) {
    var i = new _no_name_provided__10($this_splitToSequence);
    return function (p1) {
      return i.invoke_12(p1);
    };
  }
  function MatchResult() {
  }
  MatchResult.$metadata$ = {
    simpleName: 'MatchResult',
    kind: 'interface',
    interfaces: []
  };
  function MatchGroupCollection() {
  }
  MatchGroupCollection.$metadata$ = {
    simpleName: 'MatchGroupCollection',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Lazy() {
  }
  Lazy.$metadata$ = {
    simpleName: 'Lazy',
    kind: 'interface',
    interfaces: []
  };
  function UnsafeLazyImpl(initializer) {
    this._initializer = initializer;
    this.__value = UNINITIALIZED_VALUE_getInstance();
  }
  UnsafeLazyImpl.prototype._get_value__10 = function () {
    if (this.__value === UNINITIALIZED_VALUE_getInstance()) {
      this.__value = ensureNotNull(this._initializer)();
      this._initializer = null;
    }var tmp = this.__value;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  UnsafeLazyImpl.prototype.isInitialized = function () {
    return !(this.__value === UNINITIALIZED_VALUE_getInstance());
  };
  UnsafeLazyImpl.prototype.toString = function () {
    return this.isInitialized() ? toString_0(this._get_value__10()) : 'Lazy value not initialized yet.';
  };
  UnsafeLazyImpl.$metadata$ = {
    simpleName: 'UnsafeLazyImpl',
    kind: 'class',
    interfaces: [Lazy, Serializable]
  };
  function UNINITIALIZED_VALUE() {
    UNINITIALIZED_VALUE_instance = this;
  }
  UNINITIALIZED_VALUE.$metadata$ = {
    simpleName: 'UNINITIALIZED_VALUE',
    kind: 'object',
    interfaces: []
  };
  var UNINITIALIZED_VALUE_instance;
  function UNINITIALIZED_VALUE_getInstance() {
    if (UNINITIALIZED_VALUE_instance == null)
      new UNINITIALIZED_VALUE();
    return UNINITIALIZED_VALUE_instance;
  }
  var LazyThreadSafetyMode_SYNCHRONIZED_instance;
  var LazyThreadSafetyMode_PUBLICATION_instance;
  var LazyThreadSafetyMode_NONE_instance;
  var LazyThreadSafetyMode_entriesInitialized;
  function LazyThreadSafetyMode_initEntries() {
    if (LazyThreadSafetyMode_entriesInitialized)
      return Unit_getInstance();
    LazyThreadSafetyMode_entriesInitialized = true;
    LazyThreadSafetyMode_SYNCHRONIZED_instance = new LazyThreadSafetyMode('SYNCHRONIZED', 0);
    LazyThreadSafetyMode_PUBLICATION_instance = new LazyThreadSafetyMode('PUBLICATION', 1);
    LazyThreadSafetyMode_NONE_instance = new LazyThreadSafetyMode('NONE', 2);
  }
  function LazyThreadSafetyMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  LazyThreadSafetyMode.$metadata$ = {
    simpleName: 'LazyThreadSafetyMode',
    kind: 'class',
    interfaces: []
  };
  function LazyThreadSafetyMode_PUBLICATION_getInstance() {
    LazyThreadSafetyMode_initEntries();
    return LazyThreadSafetyMode_PUBLICATION_instance;
  }
  function _Result___init__impl_(value) {
    return value;
  }
  function _Result___get_value__impl_(this_0) {
    return this_0;
  }
  function _Result___get_isFailure__impl_(this_0) {
    var tmp = _Result___get_value__impl_(this_0);
    return tmp instanceof Failure;
  }
  function Result__exceptionOrNull_impl(this_0) {
    var tmp0_subject = _Result___get_value__impl_(this_0);
    var tmp;
    if (tmp0_subject instanceof Failure) {
      tmp = _Result___get_value__impl_(this_0)._exception;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function Companion_3() {
    Companion_instance_2 = this;
  }
  Companion_3.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_3();
    return Companion_instance_2;
  }
  function Failure(exception) {
    this._exception = exception;
  }
  Failure.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Failure) {
      tmp = equals_1(this._exception, other._exception);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Failure.prototype.hashCode = function () {
    return hashCode(this._exception);
  };
  Failure.prototype.toString = function () {
    return '' + 'Failure(' + this._exception + ')';
  };
  Failure.$metadata$ = {
    simpleName: 'Failure',
    kind: 'class',
    interfaces: [Serializable]
  };
  function createFailure(exception) {
    return new Failure(exception);
  }
  function throwOnFailure(_this_) {
    var tmp = _Result___get_value__impl_(_this_);
    if (tmp instanceof Failure)
      throw _Result___get_value__impl_(_this_)._exception;
    else {
    }
  }
  function NotImplementedError_init_$Init$(message, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      message = 'An operation is not implemented.';
    NotImplementedError.call($this, message);
    return $this;
  }
  function NotImplementedError_init_$Create$(message, $mask0, $marker) {
    var tmp = NotImplementedError_init_$Init$(message, $mask0, $marker, Object.create(NotImplementedError.prototype));
    captureStack(tmp, NotImplementedError_init_$Create$);
    return tmp;
  }
  function NotImplementedError(message) {
    Error_init_$Init$_0(message, this);
    captureStack(this, NotImplementedError);
  }
  NotImplementedError.$metadata$ = {
    simpleName: 'NotImplementedError',
    kind: 'class',
    interfaces: []
  };
  function Pair(first_2, second) {
    this._first = first_2;
    this._second = second;
  }
  Pair.prototype.toString = function () {
    return '' + '(' + this._first + ', ' + this._second + ')';
  };
  Pair.prototype.component1_1 = function () {
    return this._first;
  };
  Pair.prototype.component2_1 = function () {
    return this._second;
  };
  Pair.prototype.hashCode = function () {
    var result = this._first == null ? 0 : hashCode(this._first);
    result = imul(result, 31) + (this._second == null ? 0 : hashCode(this._second)) | 0;
    return result;
  };
  Pair.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
    if (!equals_1(this._first, tmp0_other_with_cast._first))
      return false;
    if (!equals_1(this._second, tmp0_other_with_cast._second))
      return false;
    return true;
  };
  Pair.$metadata$ = {
    simpleName: 'Pair',
    kind: 'class',
    interfaces: [Serializable]
  };
  function to(_this_, that) {
    return new Pair(_this_, that);
  }
  function _UByte___init__impl_(data) {
    return data;
  }
  function _UByte___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_4() {
    Companion_instance_3 = this;
    this._MIN_VALUE = _UByte___init__impl_(0);
    this._MAX_VALUE = _UByte___init__impl_(-1);
    this._SIZE_BYTES = 1;
    this._SIZE_BITS = 8;
  }
  Companion_4.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_4();
    return Companion_instance_3;
  }
  function UByte__compareTo_impl(this_0, other) {
    var tmp = _UByte___get_data__impl_(this_0) & 255;
    return compareTo(tmp, _UByte___get_data__impl_(other) & 255);
  }
  function UByte__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data;
    return UByte__compareTo_impl(tmp, other instanceof UByte ? other._data : THROW_CCE());
  }
  function UByte__toString_impl(this_0) {
    return (_UByte___get_data__impl_(this_0) & 255).toString();
  }
  function UByte__hashCode_impl(this_0) {
    return this_0;
  }
  function UByte__equals_impl(this_0, other) {
    if (!(other instanceof UByte))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UByte ? other._data : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function UByte(data) {
    Companion_getInstance_3();
    this._data = data;
  }
  UByte.prototype.compareTo_1 = function (other) {
    return UByte__compareTo_impl(this._data, other);
  };
  UByte.prototype.compareTo_71 = function (other) {
    return UByte__compareTo_impl_0(this, other);
  };
  UByte.prototype.toString = function () {
    return UByte__toString_impl(this._data);
  };
  UByte.prototype.hashCode = function () {
    return UByte__hashCode_impl(this._data);
  };
  UByte.prototype.equals = function (other) {
    return UByte__equals_impl(this._data, other);
  };
  UByte.$metadata$ = {
    simpleName: 'UByte',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _UByteArray___get_storage__impl_(this_0) {
    return this_0;
  }
  function _UByteArray___get_size__impl_(this_0) {
    return _UByteArray___get_storage__impl_(this_0).length;
  }
  function UByteArray__iterator_impl(this_0) {
    return new Iterator(_UByteArray___get_storage__impl_(this_0));
  }
  function Iterator(array) {
    UByteIterator.call(this);
    this._array = array;
    this._index = 0;
  }
  Iterator.prototype.hasNext_33 = function () {
    return this._index < this._array.length;
  };
  Iterator.prototype.nextUByte_0 = function () {
    var tmp;
    if (this._index < this._array.length) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index;
      tmp0_this._index = tmp1 + 1 | 0;
      var tmp0_toUByte_0 = this._array[tmp1];
      tmp = _UByte___init__impl_(tmp0_toUByte_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this._index.toString());
    }
    return tmp;
  };
  Iterator.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'class',
    interfaces: []
  };
  function UByteArray__contains_impl(this_0, element) {
    var tmp = isObject(new UByte(element)) ? new UByte(element) : THROW_CCE();
    if (!(tmp instanceof UByte))
      return false;
    else {
    }
    var tmp_0 = _UByteArray___get_storage__impl_(this_0);
    return contains_2(tmp_0, _UByte___get_data__impl_(element));
  }
  function UByteArray__contains_impl_0(this_0, element) {
    if (!(element instanceof UByte))
      return false;
    else {
    }
    var tmp = this_0._storage;
    return UByteArray__contains_impl(tmp, element instanceof UByte ? element._data : THROW_CCE());
  }
  function UByteArray__containsAll_impl(this_0, elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        var tmp_0;
        if (element_2 instanceof UByte) {
          var tmp_1 = _UByteArray___get_storage__impl_(this_0);
          var tmp0_toByte_0_4 = element_2._data;
          tmp_0 = contains_2(tmp_1, _UByte___get_data__impl_(tmp0_toByte_0_4));
        } else {
          {
            tmp_0 = false;
          }
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function UByteArray__containsAll_impl_0(this_0, elements) {
    return UByteArray__containsAll_impl(this_0._storage, elements);
  }
  function UByteArray__isEmpty_impl(this_0) {
    return _UByteArray___get_storage__impl_(this_0).length === 0;
  }
  function UByteArray__toString_impl(this_0) {
    return '' + 'UByteArray(storage=' + toString_1(this_0) + ')';
  }
  function UByteArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function UByteArray__equals_impl(this_0, other) {
    if (!(other instanceof UByteArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UByteArray ? other._storage : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UByteArray(storage) {
    this._storage = storage;
  }
  UByteArray.prototype._get_size__60 = function () {
    return _UByteArray___get_size__impl_(this._storage);
  };
  UByteArray.prototype.iterator_67 = function () {
    return UByteArray__iterator_impl(this._storage);
  };
  UByteArray.prototype.contains_9 = function (element) {
    return UByteArray__contains_impl(this._storage, element);
  };
  UByteArray.prototype.contains_58 = function (element) {
    return UByteArray__contains_impl_0(this, element);
  };
  UByteArray.prototype.containsAll_7 = function (elements) {
    return UByteArray__containsAll_impl(this._storage, elements);
  };
  UByteArray.prototype.containsAll_49 = function (elements) {
    return UByteArray__containsAll_impl_0(this, elements);
  };
  UByteArray.prototype.isEmpty_53 = function () {
    return UByteArray__isEmpty_impl(this._storage);
  };
  UByteArray.prototype.toString = function () {
    return UByteArray__toString_impl(this._storage);
  };
  UByteArray.prototype.hashCode = function () {
    return UByteArray__hashCode_impl(this._storage);
  };
  UByteArray.prototype.equals = function (other) {
    return UByteArray__equals_impl(this._storage, other);
  };
  UByteArray.$metadata$ = {
    simpleName: 'UByteArray',
    kind: 'class',
    interfaces: [Collection]
  };
  function _UInt___init__impl_(data) {
    return data;
  }
  function _UInt___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_5() {
    Companion_instance_4 = this;
    this._MIN_VALUE_0 = _UInt___init__impl_(0);
    this._MAX_VALUE_0 = _UInt___init__impl_(-1);
    this._SIZE_BYTES_0 = 4;
    this._SIZE_BITS_0 = 32;
  }
  Companion_5.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_5();
    return Companion_instance_4;
  }
  function UInt__compareTo_impl(this_0, other) {
    return uintCompare(_UInt___get_data__impl_(this_0), _UInt___get_data__impl_(other));
  }
  function UInt__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data_0;
    return UInt__compareTo_impl(tmp, other instanceof UInt ? other._data_0 : THROW_CCE());
  }
  function UInt__toString_impl(this_0) {
    return toLong(_UInt___get_data__impl_(this_0)).and(new Long(-1, 0)).toString();
  }
  function UInt__hashCode_impl(this_0) {
    return this_0;
  }
  function UInt__equals_impl(this_0, other) {
    if (!(other instanceof UInt))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UInt ? other._data_0 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function UInt(data) {
    Companion_getInstance_4();
    this._data_0 = data;
  }
  UInt.prototype.compareTo_3 = function (other) {
    return UInt__compareTo_impl(this._data_0, other);
  };
  UInt.prototype.compareTo_71 = function (other) {
    return UInt__compareTo_impl_0(this, other);
  };
  UInt.prototype.toString = function () {
    return UInt__toString_impl(this._data_0);
  };
  UInt.prototype.hashCode = function () {
    return UInt__hashCode_impl(this._data_0);
  };
  UInt.prototype.equals = function (other) {
    return UInt__equals_impl(this._data_0, other);
  };
  UInt.$metadata$ = {
    simpleName: 'UInt',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _UIntArray___get_storage__impl_(this_0) {
    return this_0;
  }
  function _UIntArray___get_size__impl_(this_0) {
    return _UIntArray___get_storage__impl_(this_0).length;
  }
  function UIntArray__iterator_impl(this_0) {
    return new Iterator_0(_UIntArray___get_storage__impl_(this_0));
  }
  function Iterator_0(array) {
    UIntIterator.call(this);
    this._array_0 = array;
    this._index_0 = 0;
  }
  Iterator_0.prototype.hasNext_33 = function () {
    return this._index_0 < this._array_0.length;
  };
  Iterator_0.prototype.nextUInt_0 = function () {
    var tmp;
    if (this._index_0 < this._array_0.length) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_0;
      tmp0_this._index_0 = tmp1 + 1 | 0;
      var tmp0_toUInt_0 = this._array_0[tmp1];
      tmp = _UInt___init__impl_(tmp0_toUInt_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this._index_0.toString());
    }
    return tmp;
  };
  Iterator_0.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'class',
    interfaces: []
  };
  function UIntArray__contains_impl(this_0, element) {
    var tmp = isObject(new UInt(element)) ? new UInt(element) : THROW_CCE();
    if (!(tmp instanceof UInt))
      return false;
    else {
    }
    var tmp_0 = _UIntArray___get_storage__impl_(this_0);
    return contains(tmp_0, _UInt___get_data__impl_(element));
  }
  function UIntArray__contains_impl_0(this_0, element) {
    if (!(element instanceof UInt))
      return false;
    else {
    }
    var tmp = this_0._storage_0;
    return UIntArray__contains_impl(tmp, element instanceof UInt ? element._data_0 : THROW_CCE());
  }
  function UIntArray__containsAll_impl(this_0, elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        var tmp_0;
        if (element_2 instanceof UInt) {
          var tmp_1 = _UIntArray___get_storage__impl_(this_0);
          var tmp0_toInt_0_4 = element_2._data_0;
          tmp_0 = contains(tmp_1, _UInt___get_data__impl_(tmp0_toInt_0_4));
        } else {
          {
            tmp_0 = false;
          }
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function UIntArray__containsAll_impl_0(this_0, elements) {
    return UIntArray__containsAll_impl(this_0._storage_0, elements);
  }
  function UIntArray__isEmpty_impl(this_0) {
    return _UIntArray___get_storage__impl_(this_0).length === 0;
  }
  function UIntArray__toString_impl(this_0) {
    return '' + 'UIntArray(storage=' + toString_1(this_0) + ')';
  }
  function UIntArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function UIntArray__equals_impl(this_0, other) {
    if (!(other instanceof UIntArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UIntArray ? other._storage_0 : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UIntArray(storage) {
    this._storage_0 = storage;
  }
  UIntArray.prototype._get_size__60 = function () {
    return _UIntArray___get_size__impl_(this._storage_0);
  };
  UIntArray.prototype.iterator_67 = function () {
    return UIntArray__iterator_impl(this._storage_0);
  };
  UIntArray.prototype.contains_11 = function (element) {
    return UIntArray__contains_impl(this._storage_0, element);
  };
  UIntArray.prototype.contains_58 = function (element) {
    return UIntArray__contains_impl_0(this, element);
  };
  UIntArray.prototype.containsAll_9 = function (elements) {
    return UIntArray__containsAll_impl(this._storage_0, elements);
  };
  UIntArray.prototype.containsAll_49 = function (elements) {
    return UIntArray__containsAll_impl_0(this, elements);
  };
  UIntArray.prototype.isEmpty_53 = function () {
    return UIntArray__isEmpty_impl(this._storage_0);
  };
  UIntArray.prototype.toString = function () {
    return UIntArray__toString_impl(this._storage_0);
  };
  UIntArray.prototype.hashCode = function () {
    return UIntArray__hashCode_impl(this._storage_0);
  };
  UIntArray.prototype.equals = function (other) {
    return UIntArray__equals_impl(this._storage_0, other);
  };
  UIntArray.$metadata$ = {
    simpleName: 'UIntArray',
    kind: 'class',
    interfaces: [Collection]
  };
  function UIntIterator() {
  }
  UIntIterator.prototype.next_7 = function () {
    return this.nextUInt_0();
  };
  UIntIterator.prototype.next_37 = function () {
    return new UInt(this.next_7());
  };
  UIntIterator.$metadata$ = {
    simpleName: 'UIntIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function ULongIterator() {
  }
  ULongIterator.prototype.next_15 = function () {
    return this.nextULong_0();
  };
  ULongIterator.prototype.next_37 = function () {
    return new ULong(this.next_15());
  };
  ULongIterator.$metadata$ = {
    simpleName: 'ULongIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function UByteIterator() {
  }
  UByteIterator.prototype.next_11 = function () {
    return this.nextUByte_0();
  };
  UByteIterator.prototype.next_37 = function () {
    return new UByte(this.next_11());
  };
  UByteIterator.$metadata$ = {
    simpleName: 'UByteIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function UShortIterator() {
  }
  UShortIterator.prototype.next_16 = function () {
    return this.nextUShort_0();
  };
  UShortIterator.prototype.next_37 = function () {
    return new UShort(this.next_16());
  };
  UShortIterator.$metadata$ = {
    simpleName: 'UShortIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function _ULong___init__impl_(data) {
    return data;
  }
  function _ULong___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_6() {
    Companion_instance_5 = this;
    this._MIN_VALUE_1 = _ULong___init__impl_(new Long(0, 0));
    this._MAX_VALUE_1 = _ULong___init__impl_(new Long(-1, -1));
    this._SIZE_BYTES_1 = 8;
    this._SIZE_BITS_1 = 64;
  }
  Companion_6.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_6();
    return Companion_instance_5;
  }
  function ULong__compareTo_impl(this_0, other) {
    return ulongCompare(_ULong___get_data__impl_(this_0), _ULong___get_data__impl_(other));
  }
  function ULong__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data_1;
    return ULong__compareTo_impl(tmp, other instanceof ULong ? other._data_1 : THROW_CCE());
  }
  function ULong__toString_impl(this_0) {
    return ulongToString(_ULong___get_data__impl_(this_0));
  }
  function ULong__hashCode_impl(this_0) {
    return this_0.hashCode();
  }
  function ULong__equals_impl(this_0, other) {
    if (!(other instanceof ULong))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ULong ? other._data_1 : THROW_CCE();
    if (!this_0.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function ULong(data) {
    Companion_getInstance_5();
    this._data_1 = data;
  }
  ULong.prototype.compareTo_5 = function (other) {
    return ULong__compareTo_impl(this._data_1, other);
  };
  ULong.prototype.compareTo_71 = function (other) {
    return ULong__compareTo_impl_0(this, other);
  };
  ULong.prototype.toString = function () {
    return ULong__toString_impl(this._data_1);
  };
  ULong.prototype.hashCode = function () {
    return ULong__hashCode_impl(this._data_1);
  };
  ULong.prototype.equals = function (other) {
    return ULong__equals_impl(this._data_1, other);
  };
  ULong.$metadata$ = {
    simpleName: 'ULong',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _ULongArray___get_storage__impl_(this_0) {
    return this_0;
  }
  function _ULongArray___get_size__impl_(this_0) {
    return _ULongArray___get_storage__impl_(this_0).length;
  }
  function ULongArray__iterator_impl(this_0) {
    return new Iterator_1(_ULongArray___get_storage__impl_(this_0));
  }
  function Iterator_1(array) {
    ULongIterator.call(this);
    this._array_1 = array;
    this._index_1 = 0;
  }
  Iterator_1.prototype.hasNext_33 = function () {
    return this._index_1 < this._array_1.length;
  };
  Iterator_1.prototype.nextULong_0 = function () {
    var tmp;
    if (this._index_1 < this._array_1.length) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_1;
      tmp0_this._index_1 = tmp1 + 1 | 0;
      var tmp0_toULong_0 = this._array_1[tmp1];
      tmp = _ULong___init__impl_(tmp0_toULong_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this._index_1.toString());
    }
    return tmp;
  };
  Iterator_1.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'class',
    interfaces: []
  };
  function ULongArray__contains_impl(this_0, element) {
    var tmp = isObject(new ULong(element)) ? new ULong(element) : THROW_CCE();
    if (!(tmp instanceof ULong))
      return false;
    else {
    }
    var tmp_0 = _ULongArray___get_storage__impl_(this_0);
    return contains_4(tmp_0, _ULong___get_data__impl_(element));
  }
  function ULongArray__contains_impl_0(this_0, element) {
    if (!(element instanceof ULong))
      return false;
    else {
    }
    var tmp = this_0._storage_1;
    return ULongArray__contains_impl(tmp, element instanceof ULong ? element._data_1 : THROW_CCE());
  }
  function ULongArray__containsAll_impl(this_0, elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        var tmp_0;
        if (element_2 instanceof ULong) {
          var tmp_1 = _ULongArray___get_storage__impl_(this_0);
          var tmp0_toLong_0_4 = element_2._data_1;
          tmp_0 = contains_4(tmp_1, _ULong___get_data__impl_(tmp0_toLong_0_4));
        } else {
          {
            tmp_0 = false;
          }
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function ULongArray__containsAll_impl_0(this_0, elements) {
    return ULongArray__containsAll_impl(this_0._storage_1, elements);
  }
  function ULongArray__isEmpty_impl(this_0) {
    return _ULongArray___get_storage__impl_(this_0).length === 0;
  }
  function ULongArray__toString_impl(this_0) {
    return '' + 'ULongArray(storage=' + toString_1(this_0) + ')';
  }
  function ULongArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function ULongArray__equals_impl(this_0, other) {
    if (!(other instanceof ULongArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ULongArray ? other._storage_1 : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ULongArray(storage) {
    this._storage_1 = storage;
  }
  ULongArray.prototype._get_size__60 = function () {
    return _ULongArray___get_size__impl_(this._storage_1);
  };
  ULongArray.prototype.iterator_67 = function () {
    return ULongArray__iterator_impl(this._storage_1);
  };
  ULongArray.prototype.contains_13 = function (element) {
    return ULongArray__contains_impl(this._storage_1, element);
  };
  ULongArray.prototype.contains_58 = function (element) {
    return ULongArray__contains_impl_0(this, element);
  };
  ULongArray.prototype.containsAll_11 = function (elements) {
    return ULongArray__containsAll_impl(this._storage_1, elements);
  };
  ULongArray.prototype.containsAll_49 = function (elements) {
    return ULongArray__containsAll_impl_0(this, elements);
  };
  ULongArray.prototype.isEmpty_53 = function () {
    return ULongArray__isEmpty_impl(this._storage_1);
  };
  ULongArray.prototype.toString = function () {
    return ULongArray__toString_impl(this._storage_1);
  };
  ULongArray.prototype.hashCode = function () {
    return ULongArray__hashCode_impl(this._storage_1);
  };
  ULongArray.prototype.equals = function (other) {
    return ULongArray__equals_impl(this._storage_1, other);
  };
  ULongArray.$metadata$ = {
    simpleName: 'ULongArray',
    kind: 'class',
    interfaces: [Collection]
  };
  function _UShort___init__impl_(data) {
    return data;
  }
  function _UShort___get_data__impl_(this_0) {
    return this_0;
  }
  function Companion_7() {
    Companion_instance_6 = this;
    this._MIN_VALUE_2 = _UShort___init__impl_(0);
    this._MAX_VALUE_2 = _UShort___init__impl_(-1);
    this._SIZE_BYTES_2 = 2;
    this._SIZE_BITS_2 = 16;
  }
  Companion_7.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_7();
    return Companion_instance_6;
  }
  function UShort__compareTo_impl(this_0, other) {
    var tmp = _UShort___get_data__impl_(this_0) & 65535;
    return compareTo(tmp, _UShort___get_data__impl_(other) & 65535);
  }
  function UShort__compareTo_impl_0(this_0, other) {
    var tmp = this_0._data_2;
    return UShort__compareTo_impl(tmp, other instanceof UShort ? other._data_2 : THROW_CCE());
  }
  function UShort__toString_impl(this_0) {
    return (_UShort___get_data__impl_(this_0) & 65535).toString();
  }
  function UShort__hashCode_impl(this_0) {
    return this_0;
  }
  function UShort__equals_impl(this_0, other) {
    if (!(other instanceof UShort))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UShort ? other._data_2 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function UShort(data) {
    Companion_getInstance_6();
    this._data_2 = data;
  }
  UShort.prototype.compareTo_7 = function (other) {
    return UShort__compareTo_impl(this._data_2, other);
  };
  UShort.prototype.compareTo_71 = function (other) {
    return UShort__compareTo_impl_0(this, other);
  };
  UShort.prototype.toString = function () {
    return UShort__toString_impl(this._data_2);
  };
  UShort.prototype.hashCode = function () {
    return UShort__hashCode_impl(this._data_2);
  };
  UShort.prototype.equals = function (other) {
    return UShort__equals_impl(this._data_2, other);
  };
  UShort.$metadata$ = {
    simpleName: 'UShort',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _UShortArray___get_storage__impl_(this_0) {
    return this_0;
  }
  function _UShortArray___get_size__impl_(this_0) {
    return _UShortArray___get_storage__impl_(this_0).length;
  }
  function UShortArray__iterator_impl(this_0) {
    return new Iterator_2(_UShortArray___get_storage__impl_(this_0));
  }
  function Iterator_2(array) {
    UShortIterator.call(this);
    this._array_2 = array;
    this._index_2 = 0;
  }
  Iterator_2.prototype.hasNext_33 = function () {
    return this._index_2 < this._array_2.length;
  };
  Iterator_2.prototype.nextUShort_0 = function () {
    var tmp;
    if (this._index_2 < this._array_2.length) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_2;
      tmp0_this._index_2 = tmp1 + 1 | 0;
      var tmp0_toUShort_0 = this._array_2[tmp1];
      tmp = _UShort___init__impl_(tmp0_toUShort_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this._index_2.toString());
    }
    return tmp;
  };
  Iterator_2.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'class',
    interfaces: []
  };
  function UShortArray__contains_impl(this_0, element) {
    var tmp = isObject(new UShort(element)) ? new UShort(element) : THROW_CCE();
    if (!(tmp instanceof UShort))
      return false;
    else {
    }
    var tmp_0 = _UShortArray___get_storage__impl_(this_0);
    return contains_3(tmp_0, _UShort___get_data__impl_(element));
  }
  function UShortArray__contains_impl_0(this_0, element) {
    if (!(element instanceof UShort))
      return false;
    else {
    }
    var tmp = this_0._storage_2;
    return UShortArray__contains_impl(tmp, element instanceof UShort ? element._data_2 : THROW_CCE());
  }
  function UShortArray__containsAll_impl(this_0, elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        var tmp_0;
        if (element_2 instanceof UShort) {
          var tmp_1 = _UShortArray___get_storage__impl_(this_0);
          var tmp0_toShort_0_4 = element_2._data_2;
          tmp_0 = contains_3(tmp_1, _UShort___get_data__impl_(tmp0_toShort_0_4));
        } else {
          {
            tmp_0 = false;
          }
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function UShortArray__containsAll_impl_0(this_0, elements) {
    return UShortArray__containsAll_impl(this_0._storage_2, elements);
  }
  function UShortArray__isEmpty_impl(this_0) {
    return _UShortArray___get_storage__impl_(this_0).length === 0;
  }
  function UShortArray__toString_impl(this_0) {
    return '' + 'UShortArray(storage=' + toString_1(this_0) + ')';
  }
  function UShortArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function UShortArray__equals_impl(this_0, other) {
    if (!(other instanceof UShortArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UShortArray ? other._storage_2 : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UShortArray(storage) {
    this._storage_2 = storage;
  }
  UShortArray.prototype._get_size__60 = function () {
    return _UShortArray___get_size__impl_(this._storage_2);
  };
  UShortArray.prototype.iterator_67 = function () {
    return UShortArray__iterator_impl(this._storage_2);
  };
  UShortArray.prototype.contains_15 = function (element) {
    return UShortArray__contains_impl(this._storage_2, element);
  };
  UShortArray.prototype.contains_58 = function (element) {
    return UShortArray__contains_impl_0(this, element);
  };
  UShortArray.prototype.containsAll_13 = function (elements) {
    return UShortArray__containsAll_impl(this._storage_2, elements);
  };
  UShortArray.prototype.containsAll_49 = function (elements) {
    return UShortArray__containsAll_impl_0(this, elements);
  };
  UShortArray.prototype.isEmpty_53 = function () {
    return UShortArray__isEmpty_impl(this._storage_2);
  };
  UShortArray.prototype.toString = function () {
    return UShortArray__toString_impl(this._storage_2);
  };
  UShortArray.prototype.hashCode = function () {
    return UShortArray__hashCode_impl(this._storage_2);
  };
  UShortArray.prototype.equals = function (other) {
    return UShortArray__equals_impl(this._storage_2, other);
  };
  UShortArray.$metadata$ = {
    simpleName: 'UShortArray',
    kind: 'class',
    interfaces: [Collection]
  };
  function uintCompare(v1, v2) {
    return compareTo(v1 ^ IntCompanionObject_getInstance()._MIN_VALUE_4, v2 ^ IntCompanionObject_getInstance()._MIN_VALUE_4);
  }
  function ulongCompare(v1, v2) {
    return v1.xor(new Long(0, -2147483648)).compareTo_137(v2.xor(new Long(0, -2147483648)));
  }
  function ulongToString(v) {
    return ulongToString_0(v, 10);
  }
  function ulongToString_0(v, base) {
    if (v.compareTo_137(new Long(0, 0)) >= 0)
      return toString_2(v, base);
    var tmp0_div_0 = v.ushr_0(1);
    var quotient = tmp0_div_0.div_28(toLong(base)).shl_0(1);
    var tmp1_times_0 = quotient;
    var rem = v.minus_29(tmp1_times_0.times_28(toLong(base)));
    if (rem.compareTo_137(toLong(base)) >= 0) {
      var tmp2_minus_0 = rem;
      rem = tmp2_minus_0.minus_29(toLong(base));
      var tmp3_plus_0 = quotient;
      var tmp4_plus_0 = 1;
      quotient = tmp3_plus_0.plus_64(toLong(tmp4_plus_0));
    }return toString_2(quotient, base) + toString_2(rem, base);
  }
  function CharSequence() {
  }
  CharSequence.$metadata$ = {
    simpleName: 'CharSequence',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Iterator_3() {
  }
  Iterator_3.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'interface',
    interfaces: []
  };
  function MutableIterator() {
  }
  MutableIterator.$metadata$ = {
    simpleName: 'MutableIterator',
    kind: 'interface',
    interfaces: [Iterator_3]
  };
  function ListIterator() {
  }
  ListIterator.$metadata$ = {
    simpleName: 'ListIterator',
    kind: 'interface',
    interfaces: [Iterator_3]
  };
  function MutableListIterator() {
  }
  MutableListIterator.$metadata$ = {
    simpleName: 'MutableListIterator',
    kind: 'interface',
    interfaces: [ListIterator, MutableIterator]
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function IntIterator() {
  }
  IntIterator.prototype.next_37 = function () {
    return this.nextInt_9();
  };
  IntIterator.$metadata$ = {
    simpleName: 'IntIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function LongIterator() {
  }
  LongIterator.prototype.next_37 = function () {
    return this.nextLong_0();
  };
  LongIterator.$metadata$ = {
    simpleName: 'LongIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function CharIterator() {
  }
  CharIterator.prototype.next_37 = function () {
    return this.nextChar_0();
  };
  CharIterator.$metadata$ = {
    simpleName: 'CharIterator',
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function IntProgressionIterator(first_2, last_1, step_0) {
    IntIterator.call(this);
    this._step = step_0;
    this._finalElement = last_1;
    this._hasNext = this._step > 0 ? first_2 <= last_1 : first_2 >= last_1;
    this._next_0 = this._hasNext ? first_2 : this._finalElement;
  }
  IntProgressionIterator.prototype.hasNext_33 = function () {
    return this._hasNext;
  };
  IntProgressionIterator.prototype.nextInt_9 = function () {
    var value = this._next_0;
    if (value === this._finalElement) {
      if (!this._hasNext)
        throw NoSuchElementException_init_$Create$();
      this._hasNext = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_0 = tmp0_this._next_0 + this._step | 0;
    }
    return value;
  };
  IntProgressionIterator.$metadata$ = {
    simpleName: 'IntProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function LongProgressionIterator(first_2, last_1, step_0) {
    LongIterator.call(this);
    this._step_0 = step_0;
    this._finalElement_0 = last_1;
    this._hasNext_0 = this._step_0.compareTo_137(new Long(0, 0)) > 0 ? first_2.compareTo_137(last_1) <= 0 : first_2.compareTo_137(last_1) >= 0;
    this._next_1 = this._hasNext_0 ? first_2 : this._finalElement_0;
  }
  LongProgressionIterator.prototype.hasNext_33 = function () {
    return this._hasNext_0;
  };
  LongProgressionIterator.prototype.nextLong_0 = function () {
    var value = this._next_1;
    if (value.equals(this._finalElement_0)) {
      if (!this._hasNext_0)
        throw NoSuchElementException_init_$Create$();
      this._hasNext_0 = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_1 = tmp0_this._next_1.plus_64(this._step_0);
    }
    return value;
  };
  LongProgressionIterator.$metadata$ = {
    simpleName: 'LongProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function CharProgressionIterator(first_2, last_1, step_0) {
    CharIterator.call(this);
    this._step_1 = step_0;
    this._finalElement_1 = last_1.toInt_8();
    this._hasNext_1 = this._step_1 > 0 ? first_2.compareTo_10(last_1) <= 0 : first_2.compareTo_10(last_1) >= 0;
    this._next_2 = this._hasNext_1 ? first_2.toInt_8() : this._finalElement_1;
  }
  CharProgressionIterator.prototype.hasNext_33 = function () {
    return this._hasNext_1;
  };
  CharProgressionIterator.prototype.nextChar_0 = function () {
    var value = this._next_2;
    if (value === this._finalElement_1) {
      if (!this._hasNext_1)
        throw NoSuchElementException_init_$Create$();
      this._hasNext_1 = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next_2 = tmp0_this._next_2 + this._step_1 | 0;
    }
    return numberToChar(value);
  };
  CharProgressionIterator.$metadata$ = {
    simpleName: 'CharProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function Companion_8() {
    Companion_instance_7 = this;
  }
  Companion_8.prototype.fromClosedRange = function (rangeStart, rangeEnd, step_0) {
    return new IntProgression(rangeStart, rangeEnd, step_0);
  };
  Companion_8.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_8();
    return Companion_instance_7;
  }
  function IntProgression(start, endInclusive, step_0) {
    Companion_getInstance_7();
    if (step_0 === 0)
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step_0 === IntCompanionObject_getInstance()._MIN_VALUE_4)
      throw IllegalArgumentException_init_$Create$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_0 = start;
    this._last = getProgressionLastElement(start, endInclusive, step_0);
    this._step_2 = step_0;
  }
  IntProgression.prototype._get_first__6 = function () {
    return this._first_0;
  };
  IntProgression.prototype._get_last__6 = function () {
    return this._last;
  };
  IntProgression.prototype.iterator_67 = function () {
    return new IntProgressionIterator(this._first_0, this._last, this._step_2);
  };
  IntProgression.prototype.isEmpty_53 = function () {
    return this._step_2 > 0 ? this._first_0 > this._last : this._first_0 < this._last;
  };
  IntProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntProgression) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : (this._first_0 === other._first_0 ? this._last === other._last : false) ? this._step_2 === other._step_2 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntProgression.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : imul(31, imul(31, this._first_0) + this._last | 0) + this._step_2 | 0;
  };
  IntProgression.prototype.toString = function () {
    return this._step_2 > 0 ? '' + this._first_0 + '..' + this._last + ' step ' + this._step_2 : '' + this._first_0 + ' downTo ' + this._last + ' step ' + (-this._step_2 | 0);
  };
  IntProgression.$metadata$ = {
    simpleName: 'IntProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function Companion_9() {
    Companion_instance_8 = this;
  }
  Companion_9.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_9();
    return Companion_instance_8;
  }
  function LongProgression(start, endInclusive, step_0) {
    Companion_getInstance_8();
    if (step_0.equals(new Long(0, 0)))
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step_0.equals(new Long(0, -2147483648)))
      throw IllegalArgumentException_init_$Create$('Step must be greater than Long.MIN_VALUE to avoid overflow on negation.');
    this._first_1 = start;
    this._last_0 = getProgressionLastElement_0(start.toLong_6(), endInclusive.toLong_6(), step_0).toLong_6();
    this._step_3 = step_0;
  }
  LongProgression.prototype._get_first__6 = function () {
    return this._first_1;
  };
  LongProgression.prototype._get_last__6 = function () {
    return this._last_0;
  };
  LongProgression.prototype.iterator_67 = function () {
    return new LongProgressionIterator(this._first_1, this._last_0, this._step_3);
  };
  LongProgression.prototype.isEmpty_53 = function () {
    return this._step_3.compareTo_137(new Long(0, 0)) > 0 ? this._first_1.compareTo_137(this._last_0) > 0 : this._first_1.compareTo_137(this._last_0) < 0;
  };
  LongProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof LongProgression) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : (this._first_1.equals(other._first_1) ? this._last_0.equals(other._last_0) : false) ? this._step_3.equals(other._step_3) : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  LongProgression.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : numberToLong(31).times_28(numberToLong(31).times_28(this._first_1.xor(this._first_1.ushr_0(32))).plus_64(this._last_0.xor(this._last_0.ushr_0(32)))).plus_64(this._step_3.xor(this._step_3.ushr_0(32))).toInt_8();
  };
  LongProgression.prototype.toString = function () {
    return this._step_3.compareTo_137(new Long(0, 0)) > 0 ? '' + this._first_1 + '..' + this._last_0 + ' step ' + this._step_3 : '' + this._first_1 + ' downTo ' + this._last_0 + ' step ' + this._step_3.unaryMinus_4();
  };
  LongProgression.$metadata$ = {
    simpleName: 'LongProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function Companion_10() {
    Companion_instance_9 = this;
  }
  Companion_10.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_10();
    return Companion_instance_9;
  }
  function CharProgression(start, endInclusive, step_0) {
    Companion_getInstance_9();
    if (step_0 === 0)
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step_0 === IntCompanionObject_getInstance()._MIN_VALUE_4)
      throw IllegalArgumentException_init_$Create$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_2 = start;
    this._last_1 = numberToChar(getProgressionLastElement(start.toInt_8(), endInclusive.toInt_8(), step_0));
    this._step_4 = step_0;
  }
  CharProgression.prototype._get_first__6 = function () {
    return this._first_2;
  };
  CharProgression.prototype._get_last__6 = function () {
    return this._last_1;
  };
  CharProgression.prototype.iterator_67 = function () {
    return new CharProgressionIterator(this._first_2, this._last_1, this._step_4);
  };
  CharProgression.prototype.isEmpty_53 = function () {
    return this._step_4 > 0 ? this._first_2.compareTo_10(this._last_1) > 0 : this._first_2.compareTo_10(this._last_1) < 0;
  };
  CharProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof CharProgression) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : (this._first_2.equals(other._first_2) ? this._last_1.equals(other._last_1) : false) ? this._step_4 === other._step_4 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  CharProgression.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : imul(31, imul(31, this._first_2.toInt_8()) + this._last_1.toInt_8() | 0) + this._step_4 | 0;
  };
  CharProgression.prototype.toString = function () {
    return this._step_4 > 0 ? '' + this._first_2 + '..' + this._last_1 + ' step ' + this._step_4 : '' + this._first_2 + ' downTo ' + this._last_1 + ' step ' + (-this._step_4 | 0);
  };
  CharProgression.$metadata$ = {
    simpleName: 'CharProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function ClosedRange() {
  }
  ClosedRange.$metadata$ = {
    simpleName: 'ClosedRange',
    kind: 'interface',
    interfaces: []
  };
  function Companion_11() {
    Companion_instance_10 = this;
    this._EMPTY = new IntRange(1, 0);
  }
  Companion_11.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_11();
    return Companion_instance_10;
  }
  function IntRange(start, endInclusive) {
    Companion_getInstance_10();
    IntProgression.call(this, start, endInclusive, 1);
  }
  IntRange.prototype._get_start__0 = function () {
    return this._get_first__6();
  };
  IntRange.prototype._get_endInclusive__0 = function () {
    return this._get_last__6();
  };
  IntRange.prototype.isEmpty_53 = function () {
    return this._get_first__6() > this._get_last__6();
  };
  IntRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntRange) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : this._get_first__6() === other._get_first__6() ? this._get_last__6() === other._get_last__6() : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntRange.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : imul(31, this._get_first__6()) + this._get_last__6() | 0;
  };
  IntRange.prototype.toString = function () {
    return '' + this._get_first__6() + '..' + this._get_last__6();
  };
  IntRange.$metadata$ = {
    simpleName: 'IntRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Companion_12() {
    Companion_instance_11 = this;
    this._EMPTY_0 = new LongRange(new Long(1, 0), new Long(0, 0));
  }
  Companion_12.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_12();
    return Companion_instance_11;
  }
  function LongRange(start, endInclusive) {
    Companion_getInstance_11();
    LongProgression.call(this, start, endInclusive, new Long(1, 0));
  }
  LongRange.prototype._get_start__0 = function () {
    return this._get_first__6();
  };
  LongRange.prototype._get_endInclusive__0 = function () {
    return this._get_last__6();
  };
  LongRange.prototype.isEmpty_53 = function () {
    return this._get_first__6().compareTo_137(this._get_last__6()) > 0;
  };
  LongRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof LongRange) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : this._get_first__6().equals(other._get_first__6()) ? this._get_last__6().equals(other._get_last__6()) : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  LongRange.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : numberToLong(31).times_28(this._get_first__6().xor(this._get_first__6().ushr_0(32))).plus_64(this._get_last__6().xor(this._get_last__6().ushr_0(32))).toInt_8();
  };
  LongRange.prototype.toString = function () {
    return '' + this._get_first__6() + '..' + this._get_last__6();
  };
  LongRange.$metadata$ = {
    simpleName: 'LongRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Companion_13() {
    Companion_instance_12 = this;
    this._EMPTY_1 = new CharRange(new Char(1), new Char(0));
  }
  Companion_13.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_13();
    return Companion_instance_12;
  }
  function CharRange(start, endInclusive) {
    Companion_getInstance_12();
    CharProgression.call(this, start, endInclusive, 1);
  }
  CharRange.prototype.isEmpty_53 = function () {
    return this._get_first__6().compareTo_10(this._get_last__6()) > 0;
  };
  CharRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof CharRange) {
      tmp = (this.isEmpty_53() ? other.isEmpty_53() : false) ? true : this._get_first__6().equals(other._get_first__6()) ? this._get_last__6().equals(other._get_last__6()) : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  CharRange.prototype.hashCode = function () {
    return this.isEmpty_53() ? -1 : imul(31, this._get_first__6().toInt_8()) + this._get_last__6().toInt_8() | 0;
  };
  CharRange.prototype.toString = function () {
    return '' + this._get_first__6() + '..' + this._get_last__6();
  };
  CharRange.$metadata$ = {
    simpleName: 'CharRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function getProgressionLastElement(start, end, step_0) {
    var tmp;
    if (step_0 > 0) {
      tmp = start >= end ? end : end - differenceModulo(end, start, step_0) | 0;
    } else if (step_0 < 0) {
      tmp = start <= end ? end : end + differenceModulo(start, end, -step_0 | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function getProgressionLastElement_0(start, end, step_0) {
    var tmp;
    if (step_0.compareTo_137(new Long(0, 0)) > 0) {
      tmp = start.compareTo_137(end) >= 0 ? end : end.minus_29(differenceModulo_0(end, start, step_0));
    } else if (step_0.compareTo_137(new Long(0, 0)) < 0) {
      tmp = start.compareTo_137(end) <= 0 ? end : end.plus_64(differenceModulo_0(start, end, step_0.unaryMinus_4()));
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function differenceModulo_0(a, b, c) {
    return mod_0(mod_0(a, c).minus_29(mod_0(b, c)), c);
  }
  function mod(a, b) {
    var mod_1 = a % b;
    return mod_1 >= 0 ? mod_1 : mod_1 + b | 0;
  }
  function mod_0(a, b) {
    var mod_1 = a.rem_27(b);
    return mod_1.compareTo_137(new Long(0, 0)) >= 0 ? mod_1 : mod_1.plus_64(b);
  }
  function ShortCompanionObject_0() {
    ShortCompanionObject_instance = this;
    this._MIN_VALUE_3 = -32768;
    this._MAX_VALUE_3 = 32767;
    this._SIZE_BYTES_3 = 2;
    this._SIZE_BITS_3 = 16;
  }
  ShortCompanionObject_0.prototype._get_MIN_VALUE__2 = function () {
    return this._MIN_VALUE_3;
  };
  ShortCompanionObject_0.prototype._get_MAX_VALUE__2 = function () {
    return this._MAX_VALUE_3;
  };
  ShortCompanionObject_0.prototype._get_SIZE_BYTES__2 = function () {
    return this._SIZE_BYTES_3;
  };
  ShortCompanionObject_0.prototype._get_SIZE_BITS__2 = function () {
    return this._SIZE_BITS_3;
  };
  ShortCompanionObject_0.$metadata$ = {
    simpleName: 'ShortCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(ShortCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_MIN_VALUE__2
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_MAX_VALUE__2
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_SIZE_BYTES__2
  });
  Object.defineProperty(ShortCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: ShortCompanionObject_0.prototype._get_SIZE_BITS__2
  });
  var ShortCompanionObject_instance;
  function ShortCompanionObject_getInstance() {
    if (ShortCompanionObject_instance == null)
      new ShortCompanionObject_0();
    return ShortCompanionObject_instance;
  }
  function IntCompanionObject_0() {
    IntCompanionObject_instance = this;
    this._MIN_VALUE_4 = -2147483648;
    this._MAX_VALUE_4 = 2147483647;
    this._SIZE_BYTES_4 = 4;
    this._SIZE_BITS_4 = 32;
  }
  IntCompanionObject_0.prototype._get_MIN_VALUE__2 = function () {
    return this._MIN_VALUE_4;
  };
  IntCompanionObject_0.prototype._get_MAX_VALUE__2 = function () {
    return this._MAX_VALUE_4;
  };
  IntCompanionObject_0.prototype._get_SIZE_BYTES__2 = function () {
    return this._SIZE_BYTES_4;
  };
  IntCompanionObject_0.prototype._get_SIZE_BITS__2 = function () {
    return this._SIZE_BITS_4;
  };
  IntCompanionObject_0.$metadata$ = {
    simpleName: 'IntCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(IntCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MIN_VALUE__2
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MAX_VALUE__2
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BYTES__2
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BITS__2
  });
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    if (IntCompanionObject_instance == null)
      new IntCompanionObject_0();
    return IntCompanionObject_instance;
  }
  function FloatCompanionObject_0() {
    FloatCompanionObject_instance = this;
    this._MIN_VALUE_5 = 1.4E-45;
    this._MAX_VALUE_5 = 3.4028235E38;
    this._POSITIVE_INFINITY = Infinity;
    this._NEGATIVE_INFINITY = -Infinity;
    this._NaN = NaN;
    this._SIZE_BYTES_5 = 4;
    this._SIZE_BITS_5 = 32;
  }
  FloatCompanionObject_0.prototype._get_MIN_VALUE__2 = function () {
    return this._MIN_VALUE_5;
  };
  FloatCompanionObject_0.prototype._get_MAX_VALUE__2 = function () {
    return this._MAX_VALUE_5;
  };
  FloatCompanionObject_0.prototype._get_POSITIVE_INFINITY__0 = function () {
    return this._POSITIVE_INFINITY;
  };
  FloatCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0 = function () {
    return this._NEGATIVE_INFINITY;
  };
  FloatCompanionObject_0.prototype._get_NaN__0 = function () {
    return this._NaN;
  };
  FloatCompanionObject_0.prototype._get_SIZE_BYTES__2 = function () {
    return this._SIZE_BYTES_5;
  };
  FloatCompanionObject_0.prototype._get_SIZE_BITS__2 = function () {
    return this._SIZE_BITS_5;
  };
  FloatCompanionObject_0.$metadata$ = {
    simpleName: 'FloatCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(FloatCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_MIN_VALUE__2
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_MAX_VALUE__2
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_POSITIVE_INFINITY__0
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_NaN__0
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_SIZE_BYTES__2
  });
  Object.defineProperty(FloatCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: FloatCompanionObject_0.prototype._get_SIZE_BITS__2
  });
  var FloatCompanionObject_instance;
  function FloatCompanionObject_getInstance() {
    if (FloatCompanionObject_instance == null)
      new FloatCompanionObject_0();
    return FloatCompanionObject_instance;
  }
  function DoubleCompanionObject_0() {
    DoubleCompanionObject_instance = this;
    this._MIN_VALUE_6 = 4.9E-324;
    this._MAX_VALUE_6 = 1.7976931348623157E308;
    this._POSITIVE_INFINITY_0 = Infinity;
    this._NEGATIVE_INFINITY_0 = -Infinity;
    this._NaN_0 = NaN;
    this._SIZE_BYTES_6 = 8;
    this._SIZE_BITS_6 = 64;
  }
  DoubleCompanionObject_0.prototype._get_MIN_VALUE__2 = function () {
    return this._MIN_VALUE_6;
  };
  DoubleCompanionObject_0.prototype._get_MAX_VALUE__2 = function () {
    return this._MAX_VALUE_6;
  };
  DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY__0 = function () {
    return this._POSITIVE_INFINITY_0;
  };
  DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0 = function () {
    return this._NEGATIVE_INFINITY_0;
  };
  DoubleCompanionObject_0.prototype._get_NaN__0 = function () {
    return this._NaN_0;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BYTES__2 = function () {
    return this._SIZE_BYTES_6;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BITS__2 = function () {
    return this._SIZE_BITS_6;
  };
  DoubleCompanionObject_0.$metadata$ = {
    simpleName: 'DoubleCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MIN_VALUE__2
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MAX_VALUE__2
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NaN__0
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BYTES__2
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BITS__2
  });
  var DoubleCompanionObject_instance;
  function DoubleCompanionObject_getInstance() {
    if (DoubleCompanionObject_instance == null)
      new DoubleCompanionObject_0();
    return DoubleCompanionObject_instance;
  }
  function Comparator() {
  }
  Comparator.$metadata$ = {
    simpleName: 'Comparator',
    kind: 'interface',
    interfaces: []
  };
  function listOf_0(element) {
    return arrayListOf([element]);
  }
  function setOf_0(element) {
    return hashSetOf([element]);
  }
  function sortWith(_this_, comparator) {
    collectionsSort(_this_, comparator);
  }
  function mapCapacity(expectedSize) {
    return expectedSize;
  }
  function sort(_this_) {
    collectionsSort(_this_, naturalOrder());
  }
  function checkCountOverflow(count_0) {
    if (count_0 < 0) {
      throwCountOverflow();
    }return count_0;
  }
  function checkIndexOverflow(index) {
    if (index < 0) {
      throwIndexOverflow();
    }return index;
  }
  function mapOf_0(pair) {
    return hashMapOf([pair]);
  }
  function arrayCopy_0(source, destination, destinationOffset, startIndex, endIndex) {
    Companion_getInstance().checkRangeIndexes(startIndex, endIndex, source.length);
    var rangeSize = endIndex - startIndex | 0;
    Companion_getInstance().checkRangeIndexes(destinationOffset, destinationOffset + rangeSize | 0, destination.length);
    if (ArrayBuffer.isView(destination) && ArrayBuffer.isView(source)) {
      var subrange = source.subarray(startIndex, endIndex);
      destination.set(subrange, destinationOffset);
    } else {
      if (!(source === destination) ? true : destinationOffset <= startIndex) {
        var inductionVariable = 0;
        if (inductionVariable < rangeSize)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            destination[destinationOffset + index | 0] = source[startIndex + index | 0];
          }
           while (inductionVariable < rangeSize);
      } else {
        var inductionVariable_0 = rangeSize - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            destination[destinationOffset + index_0 | 0] = source[startIndex + index_0 | 0];
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  function copyToArray_0(collection) {
    var tmp;
    if (collection.toArray !== undefined) {
      var tmp0_unsafeCast_0 = collection.toArray();
      tmp = tmp0_unsafeCast_0;
    } else {
      {
        var tmp1_unsafeCast_0 = copyToArrayImpl_0(collection);
        tmp = tmp1_unsafeCast_0;
      }
    }
    return tmp;
  }
  function collectionsSort(list, comparator) {
    if (list._get_size__60() <= 1)
      return Unit_getInstance();
    var array = copyToArray_0(list);
    sortArrayWith(array, comparator);
    var inductionVariable = 0;
    var last_1 = array.length;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.set_8(i, array[i]);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
  }
  function copyToArrayImpl_0(collection) {
    var array = [];
    var iterator_0 = collection.iterator_67();
    while (iterator_0.hasNext_33()) {
      array.push(iterator_0.next_37());
    }
    return array;
  }
  function _no_name_provided__11($elements) {
    this._$elements = $elements;
  }
  _no_name_provided__11.prototype.invoke_14 = function (it) {
    return this._$elements.contains_58(it);
  };
  _no_name_provided__11.prototype.invoke_1015 = function (p1) {
    return this.invoke_14((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__11.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  AbstractMutableCollection.prototype.remove_47 = function (element) {
    this.checkIsMutable_13();
    var iterator_0 = this.iterator_67();
    while (iterator_0.hasNext_33()) {
      if (equals_1(iterator_0.next_37(), element)) {
        iterator_0.remove_46();
        return true;
      }}
    return false;
  };
  AbstractMutableCollection.prototype.addAll_24 = function (elements) {
    this.checkIsMutable_13();
    var modified = false;
    var tmp0_iterator = elements.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var element = tmp0_iterator.next_37();
      if (this.add_39(element))
        modified = true;
    }
    return modified;
  };
  AbstractMutableCollection.prototype.removeAll_0 = function (elements) {
    this.checkIsMutable_13();
    var tmp = isInterface(this, MutableIterable) ? this : THROW_CCE();
    return removeAll_0(tmp, _no_name_provided_$factory_6(elements));
  };
  AbstractMutableCollection.prototype.toJSON = function () {
    return this.toArray();
  };
  AbstractMutableCollection.prototype.checkIsMutable_13 = function () {
  };
  AbstractMutableCollection.$metadata$ = {
    simpleName: 'AbstractMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function _no_name_provided_$factory_6($elements) {
    var i = new _no_name_provided__11($elements);
    return function (p1) {
      return i.invoke_14(p1);
    };
  }
  function IteratorImpl($outer) {
    this._$this = $outer;
    this._index_3 = 0;
    this._last_2 = -1;
  }
  IteratorImpl.prototype._set_index__0 = function (_set___) {
    this._index_3 = _set___;
  };
  IteratorImpl.prototype.hasNext_33 = function () {
    return this._index_3 < this._$this._get_size__60();
  };
  IteratorImpl.prototype.next_37 = function () {
    if (!this.hasNext_33())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_3;
    tmp0_this._index_3 = tmp1 + 1 | 0;
    tmp._last_2 = tmp1;
    return this._$this.get_137(this._last_2);
  };
  IteratorImpl.prototype.remove_46 = function () {
    var tmp0_check_0 = !(this._last_2 === -1);
    if (!tmp0_check_0) {
      var message_1 = 'Call next() or previous() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }this._$this.removeAt_6(this._last_2);
    Unit_getInstance();
    this._index_3 = this._last_2;
    this._last_2 = -1;
  };
  IteratorImpl.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ListIteratorImpl($outer, index) {
    this._$this_0 = $outer;
    IteratorImpl.call(this, $outer);
    Companion_getInstance().checkPositionIndex(index, this._$this_0._get_size__60());
    this._set_index__0(index);
  }
  ListIteratorImpl.$metadata$ = {
    simpleName: 'ListIteratorImpl',
    kind: 'class',
    interfaces: [MutableListIterator]
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this._modCount = 0;
  }
  AbstractMutableList.prototype._set_modCount__1 = function (_set___) {
    this._modCount = _set___;
  };
  AbstractMutableList.prototype._get_modCount__1 = function () {
    return this._modCount;
  };
  AbstractMutableList.prototype.add_39 = function (element) {
    this.checkIsMutable_13();
    this.add_40(this._get_size__60(), element);
    return true;
  };
  AbstractMutableList.prototype.iterator_67 = function () {
    return new IteratorImpl(this);
  };
  AbstractMutableList.prototype.contains_58 = function (element) {
    return this.indexOf_4(element) >= 0;
  };
  AbstractMutableList.prototype.indexOf_4 = function (element) {
    var inductionVariable = 0;
    var last_1 = _get_lastIndex__3(this);
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this.get_137(index), element)) {
          return index;
        }}
       while (!(index === last_1));
    return -1;
  };
  AbstractMutableList.prototype.listIterator_6 = function (index) {
    return new ListIteratorImpl(this, index);
  };
  AbstractMutableList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  AbstractMutableList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  AbstractMutableList.$metadata$ = {
    simpleName: 'AbstractMutableList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function _no_name_provided__12($entryIterator) {
    this._$entryIterator_0 = $entryIterator;
  }
  _no_name_provided__12.prototype.hasNext_33 = function () {
    return this._$entryIterator_0.hasNext_33();
  };
  _no_name_provided__12.prototype.next_37 = function () {
    return this._$entryIterator_0.next_37()._get_key__37();
  };
  _no_name_provided__12.prototype.remove_46 = function () {
    return this._$entryIterator_0.remove_46();
  };
  _no_name_provided__12.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function _no_name_provided__13($entryIterator) {
    this._$entryIterator_1 = $entryIterator;
  }
  _no_name_provided__13.prototype.hasNext_33 = function () {
    return this._$entryIterator_1.hasNext_33();
  };
  _no_name_provided__13.prototype.next_37 = function () {
    return this._$entryIterator_1.next_37()._get_value__10();
  };
  _no_name_provided__13.prototype.remove_46 = function () {
    return this._$entryIterator_1.remove_46();
  };
  _no_name_provided__13.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function SimpleEntry(key, value) {
    this._key_0 = key;
    this.__value_0 = value;
  }
  SimpleEntry.prototype._get_key__37 = function () {
    return this._key_0;
  };
  SimpleEntry.prototype._get_value__10 = function () {
    return this.__value_0;
  };
  SimpleEntry.prototype.setValue_2 = function (newValue) {
    var oldValue = this.__value_0;
    this.__value_0 = newValue;
    return oldValue;
  };
  SimpleEntry.prototype.hashCode = function () {
    return Companion_getInstance_0().entryHashCode(this);
  };
  SimpleEntry.prototype.toString = function () {
    return Companion_getInstance_0().entryToString(this);
  };
  SimpleEntry.prototype.equals = function (other) {
    return Companion_getInstance_0().entryEquals(this, other);
  };
  SimpleEntry.$metadata$ = {
    simpleName: 'SimpleEntry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function AbstractEntrySet() {
    AbstractMutableSet.call(this);
  }
  AbstractEntrySet.prototype.contains_58 = function (element) {
    return this.containsEntry_4(element);
  };
  AbstractEntrySet.$metadata$ = {
    simpleName: 'AbstractEntrySet',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__14(this$0) {
    this._this$0_4 = this$0;
    AbstractMutableSet.call(this);
  }
  _no_name_provided__14.prototype.add_35 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
  };
  _no_name_provided__14.prototype.add_39 = function (element) {
    return this.add_35((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__14.prototype.contains_50 = function (element) {
    return this._this$0_4.containsKey_11(element);
  };
  _no_name_provided__14.prototype.contains_58 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_50((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__14.prototype.iterator_67 = function () {
    var entryIterator = this._this$0_4._get_entries__10().iterator_67();
    return new _no_name_provided__12(entryIterator);
  };
  _no_name_provided__14.prototype.remove_72 = function (element) {
    this.checkIsMutable_13();
    if (this._this$0_4.containsKey_11(element)) {
      this._this$0_4.remove_72(element);
      Unit_getInstance();
      return true;
    }return false;
  };
  _no_name_provided__14.prototype.remove_47 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.remove_72((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__14.prototype._get_size__60 = function () {
    return this._this$0_4._get_size__60();
  };
  _no_name_provided__14.prototype.checkIsMutable_13 = function () {
    return this._this$0_4.checkIsMutable_13();
  };
  _no_name_provided__14.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__15(this$0) {
    this._this$0_5 = this$0;
    AbstractMutableCollection.call(this);
  }
  _no_name_provided__15.prototype.add_6 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on values');
  };
  _no_name_provided__15.prototype.add_39 = function (element) {
    return this.add_6((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__15.prototype.contains_22 = function (element) {
    return this._this$0_5.containsValue_2(element);
  };
  _no_name_provided__15.prototype.contains_58 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_22((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__15.prototype.iterator_67 = function () {
    var entryIterator = this._this$0_5._get_entries__10().iterator_67();
    return new _no_name_provided__13(entryIterator);
  };
  _no_name_provided__15.prototype._get_size__60 = function () {
    return this._this$0_5._get_size__60();
  };
  _no_name_provided__15.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(!(other == null) ? isInterface(other, Collection) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  _no_name_provided__15.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  _no_name_provided__15.prototype.checkIsMutable_13 = function () {
    return this._this$0_5.checkIsMutable_13();
  };
  _no_name_provided__15.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.__keys_0 = null;
    this.__values_0 = null;
  }
  AbstractMutableMap.prototype._get_keys__3 = function () {
    if (this.__keys_0 == null) {
      var tmp = this;
      tmp.__keys_0 = new _no_name_provided__14(this);
    }return ensureNotNull(this.__keys_0);
  };
  AbstractMutableMap.prototype.putAll_7 = function (from) {
    this.checkIsMutable_13();
    var tmp0_iterator = from._get_entries__10().iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var tmp1_loop_parameter = tmp0_iterator.next_37();
      var key = tmp1_loop_parameter._get_key__37();
      var value = tmp1_loop_parameter._get_value__10();
      this.put_18(key, value);
      Unit_getInstance();
    }
  };
  AbstractMutableMap.prototype._get_values__9 = function () {
    if (this.__values_0 == null) {
      var tmp = this;
      tmp.__values_0 = new _no_name_provided__15(this);
    }return ensureNotNull(this.__values_0);
  };
  AbstractMutableMap.prototype.remove_72 = function (key) {
    this.checkIsMutable_13();
    var iter = this._get_entries__10().iterator_67();
    while (iter.hasNext_33()) {
      var entry = iter.next_37();
      var k = entry._get_key__37();
      if (equals_1(key, k)) {
        var value = entry._get_value__10();
        iter.remove_46();
        return value;
      }}
    return null;
  };
  AbstractMutableMap.prototype.checkIsMutable_13 = function () {
  };
  AbstractMutableMap.$metadata$ = {
    simpleName: 'AbstractMutableMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  AbstractMutableSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals(this, other);
  };
  AbstractMutableSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode(this);
  };
  AbstractMutableSet.$metadata$ = {
    simpleName: 'AbstractMutableSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function ArrayList_init_$Init$($this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    ArrayList.call($this, copyToArray_0(elements));
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, Object.create(ArrayList.prototype));
  }
  function rangeCheck($this, index) {
    Companion_getInstance().checkElementIndex(index, $this._get_size__60());
    return index;
  }
  function insertionRangeCheck($this, index) {
    Companion_getInstance().checkPositionIndex(index, $this._get_size__60());
    return index;
  }
  function ArrayList(array) {
    AbstractMutableList.call(this);
    this._array_3 = array;
    this._isReadOnly = false;
  }
  ArrayList.prototype._get_size__60 = function () {
    return this._array_3.length;
  };
  ArrayList.prototype.get_137 = function (index) {
    var tmp = this._array_3[rangeCheck(this, index)];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.set_8 = function (index, element) {
    this.checkIsMutable_13();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_apply_0 = this._array_3[index];
    this._array_3[index] = element;
    var tmp = tmp0_apply_0;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.add_39 = function (element) {
    this.checkIsMutable_13();
    var tmp0_asDynamic_0 = this._array_3;
    tmp0_asDynamic_0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__1();
    tmp0_this._set_modCount__1(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.add_40 = function (index, element) {
    this.checkIsMutable_13();
    var tmp0_asDynamic_0 = this._array_3;
    tmp0_asDynamic_0.splice(insertionRangeCheck(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__1();
    tmp0_this._set_modCount__1(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.addAll_24 = function (elements) {
    this.checkIsMutable_13();
    if (elements.isEmpty_53())
      return false;
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._array_3;
    var tmp1_plus_0 = copyToArray_0(elements);
    tmp._array_3 = tmp0_plus_0.concat(tmp1_plus_0);
    var tmp1_this = this;
    var tmp2 = tmp1_this._get_modCount__1();
    tmp1_this._set_modCount__1(tmp2 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.removeAt_6 = function (index) {
    this.checkIsMutable_13();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__1();
    tmp0_this._set_modCount__1(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp;
    if (index === _get_lastIndex__3(this)) {
      var tmp0_asDynamic_0 = this._array_3;
      tmp = tmp0_asDynamic_0.pop();
    } else {
      var tmp1_asDynamic_0 = this._array_3;
      tmp = tmp1_asDynamic_0.splice(index, 1)[0];
    }
    return tmp;
  };
  ArrayList.prototype.remove_47 = function (element) {
    this.checkIsMutable_13();
    var inductionVariable = 0;
    var last_1 = this._array_3.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this._array_3[index], element)) {
          var tmp0_asDynamic_0 = this._array_3;
          tmp0_asDynamic_0.splice(index, 1);
          var tmp1_this = this;
          var tmp2 = tmp1_this._get_modCount__1();
          tmp1_this._set_modCount__1(tmp2 + 1 | 0);
          Unit_getInstance();
          return true;
        }}
       while (inductionVariable <= last_1);
    return false;
  };
  ArrayList.prototype.clear_33 = function () {
    this.checkIsMutable_13();
    var tmp = this;
    tmp._array_3 = [];
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__1();
    tmp0_this._set_modCount__1(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.indexOf_4 = function (element) {
    return indexOf(this._array_3, element);
  };
  ArrayList.prototype.toString = function () {
    return arrayToString(this._array_3);
  };
  ArrayList.prototype.toArray_1 = function () {
    return [].slice.call(this._array_3);
  };
  ArrayList.prototype.toArray = function () {
    return this.toArray_1();
  };
  ArrayList.prototype.checkIsMutable_13 = function () {
    if (this._isReadOnly)
      throw UnsupportedOperationException_init_$Create$();
  };
  ArrayList.$metadata$ = {
    simpleName: 'ArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  var _stableSortingIsSupported;
  function sortArray(array) {
    if (getStableSortingIsSupported()) {
      var comparison = _no_name_provided_$factory_7();
      array.sort(comparison);
    } else {
      mergeSort(array, 0, _get_lastIndex_(array), naturalOrder());
    }
  }
  function sortArrayWith(array, comparator) {
    if (getStableSortingIsSupported()) {
      var comparison = _no_name_provided_$factory_8(comparator);
      array.sort(comparison);
    } else {
      mergeSort(array, 0, _get_lastIndex_(array), comparator);
    }
  }
  function getStableSortingIsSupported() {
    var tmp0_safe_receiver = _stableSortingIsSupported;
    if (tmp0_safe_receiver == null)
      null;
    else {
      return tmp0_safe_receiver;
    }
    Unit_getInstance();
    _stableSortingIsSupported = false;
    var tmp0_unsafeCast_0 = [];
    var array = tmp0_unsafeCast_0;
    var inductionVariable = 0;
    if (inductionVariable < 600)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array.push(index);
      }
       while (inductionVariable < 600);
    var comparison = _no_name_provided_$factory_9();
    array.sort(comparison);
    var inductionVariable_0 = 1;
    var last_1 = array.length;
    if (inductionVariable_0 < last_1)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var a = array[index_0 - 1 | 0];
        var b = array[index_0];
        if ((a & 3) === (b & 3) ? a >= b : false)
          return false;
      }
       while (inductionVariable_0 < last_1);
    _stableSortingIsSupported = true;
    return true;
  }
  function mergeSort(array, start, endInclusive, comparator) {
    var tmp0_arrayOfNulls_0 = array.length;
    var tmp1_unsafeCast_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    var buffer = tmp1_unsafeCast_0;
    var result = mergeSort_0(array, buffer, start, endInclusive, comparator);
    if (!(result === array)) {
      var inductionVariable = start;
      if (inductionVariable <= endInclusive)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          array[i] = result[i];
        }
         while (!(i === endInclusive));
    }}
  function mergeSort_0(array, buffer, start, end, comparator) {
    if (start === end) {
      return array;
    }var median = (start + end | 0) / 2 | 0;
    var left = mergeSort_0(array, buffer, start, median, comparator);
    var right = mergeSort_0(array, buffer, median + 1 | 0, end, comparator);
    var target = left === buffer ? array : buffer;
    var leftIndex = start;
    var rightIndex = median + 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (leftIndex <= median ? rightIndex <= end : false) {
          var leftValue = left[leftIndex];
          var rightValue = right[rightIndex];
          if (comparator.compare(leftValue, rightValue) <= 0) {
            target[i] = leftValue;
            var tmp1 = leftIndex;
            leftIndex = tmp1 + 1 | 0;
            Unit_getInstance();
          } else {
            target[i] = rightValue;
            var tmp2 = rightIndex;
            rightIndex = tmp2 + 1 | 0;
            Unit_getInstance();
          }
        } else if (leftIndex <= median) {
          target[i] = left[leftIndex];
          var tmp3 = leftIndex;
          leftIndex = tmp3 + 1 | 0;
          Unit_getInstance();
        } else {
          target[i] = right[rightIndex];
          var tmp4 = rightIndex;
          rightIndex = tmp4 + 1 | 0;
          Unit_getInstance();
          Unit_getInstance();
        }
      }
       while (!(i === end));
    return target;
  }
  function _no_name_provided__16() {
  }
  _no_name_provided__16.prototype.invoke_18 = function (a, b) {
    return compareTo(a, b);
  };
  _no_name_provided__16.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isComparable(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_18(tmp, (!(p2 == null) ? isComparable(p2) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__16.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__17($comparator) {
    this._$comparator = $comparator;
  }
  _no_name_provided__17.prototype.invoke_18 = function (a, b) {
    return this._$comparator.compare(a, b);
  };
  _no_name_provided__17.prototype.invoke_925 = function (p1, p2) {
    var tmp = (p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE();
    return this.invoke_18(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__17.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__18() {
  }
  _no_name_provided__18.prototype.invoke_395 = function (a, b) {
    return (a & 3) - (b & 3) | 0;
  };
  _no_name_provided__18.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_395(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__18.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_7() {
    var i = new _no_name_provided__16();
    return function (p1, p2) {
      return i.invoke_18(p1, p2);
    };
  }
  function _no_name_provided_$factory_8($comparator) {
    var i = new _no_name_provided__17($comparator);
    return function (p1, p2) {
      return i.invoke_18(p1, p2);
    };
  }
  function _no_name_provided_$factory_9() {
    var i = new _no_name_provided__18();
    return function (p1, p2) {
      return i.invoke_395(p1, p2);
    };
  }
  function HashCode() {
    HashCode_instance = this;
  }
  HashCode.prototype.equals_1 = function (value1, value2) {
    return equals_1(value1, value2);
  };
  HashCode.prototype.getHashCode_0 = function (value) {
    var tmp0_safe_receiver = value;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  HashCode.$metadata$ = {
    simpleName: 'HashCode',
    kind: 'object',
    interfaces: [EqualityComparator]
  };
  var HashCode_instance;
  function HashCode_getInstance() {
    if (HashCode_instance == null)
      new HashCode();
    return HashCode_instance;
  }
  function EqualityComparator() {
  }
  EqualityComparator.$metadata$ = {
    simpleName: 'EqualityComparator',
    kind: 'interface',
    interfaces: []
  };
  function EntrySet($outer) {
    this._$this_1 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet.prototype.add_37 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet.prototype.add_39 = function (element) {
    return this.add_37((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype.containsEntry_4 = function (element) {
    return this._$this_1.containsEntry_5(element);
  };
  EntrySet.prototype.iterator_67 = function () {
    return this._$this_1._internalMap.iterator_67();
  };
  EntrySet.prototype.remove_43 = function (element) {
    if (this.contains_58(element)) {
      this._$this_1.remove_72(element._get_key__37());
      Unit_getInstance();
      return true;
    }return false;
  };
  EntrySet.prototype.remove_47 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.remove_43((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype._get_size__60 = function () {
    return this._$this_1._get_size__60();
  };
  EntrySet.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this._internalMap = internalMap;
    $this._equality = internalMap._get_equality__0();
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(new InternalHashCodeMap(HashCode_getInstance()), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_0($this);
    var tmp0_require_0 = initialCapacity >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Negative initial capacity: ' + initialCapacity;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_require_0 = loadFactor >= 0;
    if (!tmp1_require_0) {
      var message_1_0 = '' + 'Non-positive load factor: ' + loadFactor;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
    }return $this;
  }
  function HashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return HashMap_init_$Init$_1(initialCapacity, loadFactor, Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_2(initialCapacity, $this) {
    HashMap_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashMap_init_$Create$_1(initialCapacity) {
    return HashMap_init_$Init$_2(initialCapacity, Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_3(original, $this) {
    HashMap_init_$Init$_0($this);
    $this.putAll_7(original);
    return $this;
  }
  function HashMap_init_$Create$_2(original) {
    return HashMap_init_$Init$_3(original, Object.create(HashMap.prototype));
  }
  HashMap.prototype.clear_33 = function () {
    this._internalMap.clear_33();
  };
  HashMap.prototype.containsKey_11 = function (key) {
    return this._internalMap.contains_50(key);
  };
  HashMap.prototype.containsValue_2 = function (value) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = this._internalMap;
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_any_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (this._equality.equals_1(element_2._get_value__10(), value)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  HashMap.prototype._get_entries__10 = function () {
    if (this.__entries == null) {
      this.__entries = this.createEntrySet_0();
    }return ensureNotNull(this.__entries);
  };
  HashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet(this);
  };
  HashMap.prototype.get_116 = function (key) {
    return this._internalMap.get_116(key);
  };
  HashMap.prototype.put_18 = function (key, value) {
    return this._internalMap.put_18(key, value);
  };
  HashMap.prototype.remove_72 = function (key) {
    return this._internalMap.remove_72(key);
  };
  HashMap.prototype._get_size__60 = function () {
    return this._internalMap._get_size__60();
  };
  function HashMap() {
    this.__entries = null;
  }
  HashMap.$metadata$ = {
    simpleName: 'HashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function HashSet_init_$Init$(initialCapacity, loadFactor, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$_0(initialCapacity, loadFactor);
    return $this;
  }
  function HashSet_init_$Init$_0(initialCapacity, $this) {
    HashSet_init_$Init$(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashSet_init_$Create$(initialCapacity) {
    return HashSet_init_$Init$_0(initialCapacity, Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_1(map_0, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = map_0;
    return $this;
  }
  HashSet.prototype._get_map__0 = function () {
    return this._map;
  };
  HashSet.prototype.add_39 = function (element) {
    var old = this._map.put_18(element, this);
    return old == null;
  };
  HashSet.prototype.clear_33 = function () {
    this._map.clear_33();
  };
  HashSet.prototype.contains_58 = function (element) {
    return this._map.containsKey_11(element);
  };
  HashSet.prototype.isEmpty_53 = function () {
    return this._map.isEmpty_53();
  };
  HashSet.prototype.iterator_67 = function () {
    return this._map._get_keys__3().iterator_67();
  };
  HashSet.prototype.remove_47 = function (element) {
    return !(this._map.remove_72(element) == null);
  };
  HashSet.prototype._get_size__60 = function () {
    return this._map._get_size__60();
  };
  function HashSet() {
  }
  HashSet.$metadata$ = {
    simpleName: 'HashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function computeNext($this) {
    if ($this._chainOrEntry != null ? $this._isChain : false) {
      var tmp0_unsafeCast_0 = $this._chainOrEntry;
      var chainSize = tmp0_unsafeCast_0.length;
      var tmp0_this = $this;
      tmp0_this._itemIndex = tmp0_this._itemIndex + 1 | 0;
      if (tmp0_this._itemIndex < chainSize)
        return 0;
      else {
      }
    }var tmp1_this = $this;
    tmp1_this._keyIndex = tmp1_this._keyIndex + 1 | 0;
    if (tmp1_this._keyIndex < $this._keys.length) {
      $this._chainOrEntry = $this._this$0_6._backingMap[$this._keys[$this._keyIndex]];
      var tmp = $this;
      var tmp_0 = $this._chainOrEntry;
      tmp._isChain = !(tmp_0 == null) ? isArray(tmp_0) : false;
      $this._itemIndex = 0;
      return 0;
    } else {
      {
        $this._chainOrEntry = null;
        return 1;
      }
    }
  }
  function getEntry($this, key) {
    var tmp0_elvis_lhs = getChainOrEntryOrNull($this, $this._equality_0.getHashCode_0(key));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if ($this._equality_0.equals_1(entry._get_key__37(), key)) {
        return entry;
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        return findEntryInChain(chain, $this, key);
      }
    }
  }
  function findEntryInChain(_this_, $this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = _this_;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var element_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if ($this._equality_0.equals_1(element_2._get_key__37(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function getChainOrEntryOrNull($this, hashCode_1) {
    var chainOrEntry = $this._backingMap[hashCode_1];
    return chainOrEntry === undefined ? null : chainOrEntry;
  }
  function _no_name_provided__19(this$0) {
    this._this$0_6 = this$0;
    this._state_0 = -1;
    this._keys = Object.keys(this._this$0_6._backingMap);
    this._keyIndex = -1;
    this._chainOrEntry = null;
    this._isChain = false;
    this._itemIndex = -1;
    this._lastEntry = null;
  }
  _no_name_provided__19.prototype.hasNext_33 = function () {
    if (this._state_0 === -1)
      this._state_0 = computeNext(this);
    return this._state_0 === 0;
  };
  _no_name_provided__19.prototype.next_37 = function () {
    if (!this.hasNext_33())
      throw NoSuchElementException_init_$Create$();
    var tmp;
    if (this._isChain) {
      var tmp0_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp0_unsafeCast_0[this._itemIndex];
    } else {
      var tmp1_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp1_unsafeCast_0;
    }
    var lastEntry = tmp;
    this._lastEntry = lastEntry;
    this._state_0 = -1;
    return lastEntry;
  };
  _no_name_provided__19.prototype.remove_46 = function () {
    var tmp0_checkNotNull_0 = this._lastEntry;
    var tmp$ret$0;
    l$ret$1: do {
      if (tmp0_checkNotNull_0 == null) {
        var message_2_1 = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
      } else {
        tmp$ret$0 = tmp0_checkNotNull_0;
        break l$ret$1;
      }
    }
     while (false);
    Unit_getInstance();
    this._this$0_6.remove_72(ensureNotNull(this._lastEntry)._get_key__37());
    Unit_getInstance();
    this._lastEntry = null;
    var tmp0_this = this;
    var tmp1 = tmp0_this._itemIndex;
    tmp0_this._itemIndex = tmp1 - 1 | 0;
    Unit_getInstance();
  };
  _no_name_provided__19.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function InternalHashCodeMap(equality) {
    this._equality_0 = equality;
    this._backingMap = this.createJsMap_0();
    this._size = 0;
  }
  InternalHashCodeMap.prototype._get_equality__0 = function () {
    return this._equality_0;
  };
  InternalHashCodeMap.prototype._get_size__60 = function () {
    return this._size;
  };
  InternalHashCodeMap.prototype.put_18 = function (key, value) {
    var hashCode_1 = this._equality_0.getHashCode_0(key);
    var chainOrEntry = getChainOrEntryOrNull(this, hashCode_1);
    if (chainOrEntry == null) {
      this._backingMap[hashCode_1] = new SimpleEntry(key, value);
    } else {
      if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
        var entry = chainOrEntry;
        if (this._equality_0.equals_1(entry._get_key__37(), key)) {
          return entry.setValue_2(value);
        } else {
          var tmp0_arrayOf_0 = [entry, new SimpleEntry(key, value)];
          this._backingMap[hashCode_1] = tmp0_arrayOf_0;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size;
          tmp0_this._size = tmp1 + 1 | 0;
          Unit_getInstance();
          return null;
        }
      } else {
        {
          var chain = chainOrEntry;
          var entry_0 = findEntryInChain(chain, this, key);
          if (!(entry_0 == null)) {
            return entry_0.setValue_2(value);
          }chain.push(new SimpleEntry(key, value));
        }
      }
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this._size;
    tmp2_this._size = tmp3 + 1 | 0;
    Unit_getInstance();
    return null;
  };
  InternalHashCodeMap.prototype.remove_72 = function (key) {
    var hashCode_1 = this._equality_0.getHashCode_0(key);
    var tmp0_elvis_lhs = getChainOrEntryOrNull(this, hashCode_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if (this._equality_0.equals_1(entry._get_key__37(), key)) {
        jsDeleteProperty(this._backingMap, hashCode_1);
        var tmp1_this = this;
        var tmp2 = tmp1_this._size;
        tmp1_this._size = tmp2 - 1 | 0;
        Unit_getInstance();
        return entry._get_value__10();
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        var inductionVariable = 0;
        var last_1 = chain.length - 1 | 0;
        if (inductionVariable <= last_1)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var entry_0 = chain[index];
            if (this._equality_0.equals_1(key, entry_0._get_key__37())) {
              if (chain.length === 1) {
                chain.length = 0;
                jsDeleteProperty(this._backingMap, hashCode_1);
              } else {
                chain.splice(index, 1);
              }
              var tmp4_this = this;
              var tmp5 = tmp4_this._size;
              tmp4_this._size = tmp5 - 1 | 0;
              Unit_getInstance();
              return entry_0._get_value__10();
            }}
           while (inductionVariable <= last_1);
      }
    }
    return null;
  };
  InternalHashCodeMap.prototype.clear_33 = function () {
    this._backingMap = this.createJsMap_0();
    this._size = 0;
  };
  InternalHashCodeMap.prototype.contains_50 = function (key) {
    return !(getEntry(this, key) == null);
  };
  InternalHashCodeMap.prototype.get_116 = function (key) {
    var tmp0_safe_receiver = getEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__10();
  };
  InternalHashCodeMap.prototype.iterator_67 = function () {
    return new _no_name_provided__19(this);
  };
  InternalHashCodeMap.$metadata$ = {
    simpleName: 'InternalHashCodeMap',
    kind: 'class',
    interfaces: [InternalMap]
  };
  function InternalMap() {
  }
  InternalMap.prototype.createJsMap_0 = function () {
    var result = Object.create(null);
    result['foo'] = 1;
    jsDeleteProperty(result, 'foo');
    return result;
  };
  InternalMap.$metadata$ = {
    simpleName: 'InternalMap',
    kind: 'interface',
    interfaces: [MutableIterable]
  };
  function EntryIterator($outer) {
    this._$this_2 = $outer;
    this._last_3 = null;
    this._next_3 = null;
    this._next_3 = this._$this_2._$this_4._head;
  }
  EntryIterator.prototype.hasNext_33 = function () {
    return !(this._next_3 === null);
  };
  EntryIterator.prototype.next_37 = function () {
    if (!this.hasNext_33())
      throw NoSuchElementException_init_$Create$();
    var current = ensureNotNull(this._next_3);
    this._last_3 = current;
    var tmp = this;
    var tmp0_takeIf_0 = current._next_4;
    var tmp_0;
    if (!(tmp0_takeIf_0 === this._$this_2._$this_4._head)) {
      tmp_0 = tmp0_takeIf_0;
    } else {
      {
        tmp_0 = null;
      }
    }
    tmp._next_3 = tmp_0;
    return current;
  };
  EntryIterator.prototype.remove_46 = function () {
    var tmp0_check_0 = !(this._last_3 == null);
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }this._$this_2.checkIsMutable_13();
    remove(ensureNotNull(this._last_3), this._$this_2._$this_4);
    this._$this_2._$this_4._map_0.remove_72(ensureNotNull(this._last_3)._get_key__37());
    Unit_getInstance();
    this._last_3 = null;
  };
  EntryIterator.$metadata$ = {
    simpleName: 'EntryIterator',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ChainEntry($outer, key, value) {
    this._$this_3 = $outer;
    SimpleEntry.call(this, key, value);
    this._next_4 = null;
    this._prev = null;
  }
  ChainEntry.prototype.setValue_2 = function (newValue) {
    this._$this_3.checkIsMutable_13();
    return SimpleEntry.prototype.setValue_2.call(this, newValue);
  };
  ChainEntry.$metadata$ = {
    simpleName: 'ChainEntry',
    kind: 'class',
    interfaces: []
  };
  function EntrySet_0($outer) {
    this._$this_4 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet_0.prototype.add_37 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet_0.prototype.add_39 = function (element) {
    return this.add_37((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype.containsEntry_4 = function (element) {
    return this._$this_4.containsEntry_5(element);
  };
  EntrySet_0.prototype.iterator_67 = function () {
    return new EntryIterator(this);
  };
  EntrySet_0.prototype.remove_43 = function (element) {
    this.checkIsMutable_13();
    if (this.contains_58(element)) {
      this._$this_4.remove_72(element._get_key__37());
      Unit_getInstance();
      return true;
    }return false;
  };
  EntrySet_0.prototype.remove_47 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.remove_43((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype._get_size__60 = function () {
    return this._$this_4._get_size__60();
  };
  EntrySet_0.prototype.checkIsMutable_13 = function () {
    return this._$this_4.checkIsMutable_13();
  };
  EntrySet_0.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function addToEnd(_this_, $this) {
    var tmp0_check_0 = _this_._next_4 == null ? _this_._prev == null : false;
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2_1));
    }var _head = $this._head;
    if (_head == null) {
      $this._head = _this_;
      _this_._next_4 = _this_;
      _this_._prev = _this_;
    } else {
      var tmp1_checkNotNull_0 = _head._prev;
      var tmp$ret$0;
      l$ret$1: do {
        if (tmp1_checkNotNull_0 == null) {
          var message_2_1_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_0));
        } else {
          tmp$ret$0 = tmp1_checkNotNull_0;
          break l$ret$1;
        }
      }
       while (false);
      var _tail = tmp$ret$0;
      _this_._prev = _tail;
      _this_._next_4 = _head;
      _head._prev = _this_;
      _tail._next_4 = _this_;
    }
  }
  function remove(_this_, $this) {
    if (_this_._next_4 === _this_) {
      $this._head = null;
    } else {
      if ($this._head === _this_) {
        $this._head = _this_._next_4;
      }ensureNotNull(_this_._next_4)._prev = _this_._prev;
      ensureNotNull(_this_._prev)._next_4 = _this_._next_4;
    }
    _this_._next_4 = null;
    _this_._prev = null;
  }
  function LinkedHashMap_init_$Init$($this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$() {
    return LinkedHashMap_init_$Init$(Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_1(initialCapacity, loadFactor, $this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_1(initialCapacity, $this) {
    LinkedHashMap_init_$Init$_0(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_1(initialCapacity) {
    return LinkedHashMap_init_$Init$_1(initialCapacity, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_2(original, $this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    $this.putAll_7(original);
    return $this;
  }
  function LinkedHashMap_init_$Create$_2(original) {
    return LinkedHashMap_init_$Init$_2(original, Object.create(LinkedHashMap.prototype));
  }
  LinkedHashMap.prototype.clear_33 = function () {
    this.checkIsMutable_13();
    this._map_0.clear_33();
    this._head = null;
  };
  LinkedHashMap.prototype.containsKey_11 = function (key) {
    return this._map_0.containsKey_11(key);
  };
  LinkedHashMap.prototype.containsValue_2 = function (value) {
    var tmp0_elvis_lhs = this._head;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node = tmp;
    do {
      if (equals_1(node._get_value__10(), value)) {
        return true;
      }node = ensureNotNull(node._next_4);
    }
     while (!(node === this._head));
    return false;
  };
  LinkedHashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet_0(this);
  };
  LinkedHashMap.prototype.get_116 = function (key) {
    var tmp0_safe_receiver = this._map_0.get_116(key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__10();
  };
  LinkedHashMap.prototype.put_18 = function (key, value) {
    this.checkIsMutable_13();
    var old = this._map_0.get_116(key);
    if (old == null) {
      var newEntry = new ChainEntry(this, key, value);
      this._map_0.put_18(key, newEntry);
      Unit_getInstance();
      addToEnd(newEntry, this);
      return null;
    } else {
      return old.setValue_2(value);
    }
  };
  LinkedHashMap.prototype.remove_72 = function (key) {
    this.checkIsMutable_13();
    var entry = this._map_0.remove_72(key);
    if (!(entry == null)) {
      remove(entry, this);
      return entry._get_value__10();
    }return null;
  };
  LinkedHashMap.prototype._get_size__60 = function () {
    return this._map_0._get_size__60();
  };
  LinkedHashMap.prototype.checkIsMutable_13 = function () {
    if (this._isReadOnly_0)
      throw UnsupportedOperationException_init_$Create$();
  };
  function LinkedHashMap() {
    this._head = null;
    this._isReadOnly_0 = false;
  }
  LinkedHashMap.$metadata$ = {
    simpleName: 'LinkedHashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function LinkedHashSet_init_$Init$($this) {
    HashSet_init_$Init$_1(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$() {
    return LinkedHashSet_init_$Init$(Object.create(LinkedHashSet.prototype));
  }
  function LinkedHashSet_init_$Init$_0(elements, $this) {
    HashSet_init_$Init$_1(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    $this.addAll_24(elements);
    Unit_getInstance();
    return $this;
  }
  function LinkedHashSet_init_$Create$_0(elements) {
    return LinkedHashSet_init_$Init$_0(elements, Object.create(LinkedHashSet.prototype));
  }
  function LinkedHashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashSet_init_$Init$_1(LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Init$_2(initialCapacity, $this) {
    LinkedHashSet_init_$Init$_1(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_1(initialCapacity) {
    return LinkedHashSet_init_$Init$_2(initialCapacity, Object.create(LinkedHashSet.prototype));
  }
  LinkedHashSet.prototype.checkIsMutable_13 = function () {
    return this._get_map__0().checkIsMutable_13();
  };
  function LinkedHashSet() {
  }
  LinkedHashSet.$metadata$ = {
    simpleName: 'LinkedHashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function RandomAccess() {
  }
  RandomAccess.$metadata$ = {
    simpleName: 'RandomAccess',
    kind: 'interface',
    interfaces: []
  };
  var output;
  function BaseOutput() {
  }
  BaseOutput.prototype.println_5 = function () {
    this.print_3('\n');
  };
  BaseOutput.prototype.println_6 = function (message) {
    this.print_3(message);
    this.println_5();
  };
  BaseOutput.$metadata$ = {
    simpleName: 'BaseOutput',
    kind: 'class',
    interfaces: []
  };
  function NodeJsOutput_0(outputStream) {
    BaseOutput.call(this);
    this._outputStream = outputStream;
  }
  NodeJsOutput_0.prototype.print_3 = function (message) {
    var messageString = String(message);
    this._outputStream.write(messageString);
  };
  NodeJsOutput_0.$metadata$ = {
    simpleName: 'NodeJsOutput',
    kind: 'class',
    interfaces: []
  };
  function BufferedOutputToConsoleLog_0() {
    BufferedOutput_0.call(this);
  }
  BufferedOutputToConsoleLog_0.prototype.print_3 = function (message) {
    var s = String(message);
    var tmp0_nativeLastIndexOf_0 = s;
    var tmp1_nativeLastIndexOf_0 = '\n';
    var tmp2_nativeLastIndexOf_0 = 0;
    var i = tmp0_nativeLastIndexOf_0.lastIndexOf(tmp1_nativeLastIndexOf_0, tmp2_nativeLastIndexOf_0);
    if (i >= 0) {
      var tmp0_this = this;
      var tmp = tmp0_this._get_buffer__1();
      var tmp3_substring_0 = s;
      var tmp4_substring_0 = 0;
      tmp0_this._set_buffer__0(tmp + tmp3_substring_0.substring(tmp4_substring_0, i));
      this.flush_8();
      var tmp5_substring_0 = s;
      var tmp6_substring_0 = i + 1 | 0;
      s = tmp5_substring_0.substring(tmp6_substring_0);
    }var tmp1_this = this;
    tmp1_this._set_buffer__0(tmp1_this._get_buffer__1() + s);
  };
  BufferedOutputToConsoleLog_0.prototype.flush_8 = function () {
    (function () {
      var $externalVarargReceiverTmp = console;
      return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].concat([this._get_buffer__1()]));
    }.call(this));
    this._set_buffer__0('');
  };
  BufferedOutputToConsoleLog_0.$metadata$ = {
    simpleName: 'BufferedOutputToConsoleLog',
    kind: 'class',
    interfaces: []
  };
  function BufferedOutput_0() {
    BaseOutput.call(this);
    this._buffer = '';
  }
  BufferedOutput_0.prototype._set_buffer__0 = function (_set___) {
    this._buffer = _set___;
  };
  BufferedOutput_0.prototype._get_buffer__1 = function () {
    return this._buffer;
  };
  BufferedOutput_0.prototype.print_3 = function (message) {
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._buffer;
    tmp._buffer = tmp_0 + String(message);
  };
  BufferedOutput_0.$metadata$ = {
    simpleName: 'BufferedOutput',
    kind: 'class',
    interfaces: []
  };
  function println(message) {
    output.println_6(message);
  }
  function output$init$() {
    var isNode_2 = typeof process !== 'undefined' && process.versions && !!process.versions.node;
    return isNode_2 ? new NodeJsOutput_0(process.stdout) : new BufferedOutputToConsoleLog_0();
  }
  function SafeContinuation_init_$Init$(delegate, $this) {
    SafeContinuation.call($this, delegate, CoroutineSingletons_UNDECIDED_getInstance());
    return $this;
  }
  function SafeContinuation_init_$Create$(delegate) {
    return SafeContinuation_init_$Init$(delegate, Object.create(SafeContinuation.prototype));
  }
  function SafeContinuation(delegate, initialResult) {
    this._delegate = delegate;
    this._result = initialResult;
  }
  SafeContinuation.prototype._get_context__296 = function () {
    return this._delegate._get_context__296();
  };
  SafeContinuation.prototype.resumeWith_196 = function (result) {
    var cur = this._result;
    if (cur === CoroutineSingletons_UNDECIDED_getInstance()) {
      this._result = _Result___get_value__impl_(result);
    } else if (cur === _get_COROUTINE_SUSPENDED_()) {
      this._result = CoroutineSingletons_RESUMED_getInstance();
      this._delegate.resumeWith_196(result);
    } else
      throw IllegalStateException_init_$Create$_0('Already resumed');
  };
  SafeContinuation.prototype.getOrThrow = function () {
    if (this._result === CoroutineSingletons_UNDECIDED_getInstance()) {
      this._result = _get_COROUTINE_SUSPENDED_();
      return _get_COROUTINE_SUSPENDED_();
    }var result = this._result;
    var tmp;
    if (result === CoroutineSingletons_RESUMED_getInstance()) {
      tmp = _get_COROUTINE_SUSPENDED_();
    } else {
      if (result instanceof Failure) {
        throw result._exception;
      } else {
        {
          tmp = result;
        }
      }
    }
    return tmp;
  };
  SafeContinuation.$metadata$ = {
    simpleName: 'SafeContinuation',
    kind: 'class',
    interfaces: [Continuation]
  };
  function CancellationException() {
  }
  CancellationException.$metadata$ = {
    simpleName: 'CancellationException',
    kind: 'class',
    interfaces: []
  };
  function _get_EmptyContinuation_() {
    return EmptyContinuation;
  }
  var EmptyContinuation;
  function _no_name_provided__1_2($tmp0_Continuation_0) {
    this._$tmp0_Continuation_0 = $tmp0_Continuation_0;
  }
  _no_name_provided__1_2.prototype._get_context__2 = function () {
    return this._$tmp0_Continuation_0;
  };
  _no_name_provided__1_2.prototype._get_context__296 = function () {
    return this._get_context__2();
  };
  _no_name_provided__1_2.prototype.resumeWith_3 = function (result) {
    throwOnFailure(result);
    var tmp = _Result___get_value__impl_(result);
    if (tmp == null ? true : isObject(tmp))
      tmp;
    else
      THROW_CCE();
    return Unit_getInstance();
  };
  _no_name_provided__1_2.prototype.resumeWith_196 = function (result) {
    return this.resumeWith_3(result);
  };
  _no_name_provided__1_2.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Continuation]
  };
  function EmptyContinuation$init$() {
    var tmp0_Continuation_0 = EmptyCoroutineContext_getInstance();
    return new _no_name_provided__1_2(tmp0_Continuation_0);
  }
  function Serializable() {
  }
  Serializable.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function abs(n) {
    return n < 0 ? -n | 0 | 0 : n;
  }
  function round(x) {
    if (!(x % 0.5 === 0.0)) {
      var tmp0_unsafeCast_0 = Math.round(x);
      return tmp0_unsafeCast_0;
    }var tmp0_unsafeCast_0_1 = Math.floor(x);
    var floor = tmp0_unsafeCast_0_1;
    var tmp;
    if (floor % 2 === 0.0) {
      tmp = floor;
    } else {
      var tmp1_unsafeCast_0 = Math.ceil(x);
      tmp = tmp1_unsafeCast_0;
    }
    return tmp;
  }
  function roundToInt(_this_) {
    var tmp;
    if (isNaN_0(_this_)) {
      throw IllegalArgumentException_init_$Create$('Cannot round NaN value.');
    } else if (_this_ > IntCompanionObject_getInstance()._MAX_VALUE_4) {
      tmp = IntCompanionObject_getInstance()._MAX_VALUE_4;
    } else if (_this_ < IntCompanionObject_getInstance()._MIN_VALUE_4) {
      tmp = IntCompanionObject_getInstance()._MIN_VALUE_4;
    } else {
      var tmp0_unsafeCast_0 = Math.round(_this_);
      tmp = numberToInt(tmp0_unsafeCast_0);
    }
    return tmp;
  }
  function nextDown(_this_) {
    var tmp;
    if (isNaN_0(_this_) ? true : _this_ === -Infinity) {
      tmp = _this_;
    } else if (_this_ === 0.0) {
      tmp = -4.9E-324;
    } else {
      var tmp2_fromBits_0 = DoubleCompanionObject_getInstance();
      var tmp0_plus_0 = toRawBits(_this_);
      var tmp1_plus_0 = _this_ > 0.0 ? -1 : 1;
      var tmp3_fromBits_0 = tmp0_plus_0.plus_64(toLong(tmp1_plus_0));
      tmp = doubleFromBits(tmp3_fromBits_0);
    }
    return tmp;
  }
  function isNaN_0(_this_) {
    return !(_this_ === _this_);
  }
  function isInfinite(_this_) {
    return _this_ === Infinity ? true : _this_ === -Infinity;
  }
  function isFinite(_this_) {
    return !isInfinite(_this_) ? !isNaN_0(_this_) : false;
  }
  function isNaN_1(_this_) {
    return !(_this_ === _this_);
  }
  var INV_2_26;
  var INV_2_53;
  function doubleFromParts(hi26, low27) {
    return hi26 * INV_2_26 + low27 * INV_2_53;
  }
  function defaultPlatformRandom() {
    var tmp0_unsafeCast_0 = Math.random() * Math.pow(2, 32) | 0;
    return Random_0(tmp0_unsafeCast_0);
  }
  function INV_2_26$init$() {
    var tmp0_pow_0 = 2.0;
    var tmp1_pow_0 = -26;
    return Math.pow(tmp0_pow_0, tmp1_pow_0);
  }
  function INV_2_53$init$() {
    var tmp0_pow_0 = 2.0;
    var tmp1_pow_0 = -53;
    return Math.pow(tmp0_pow_0, tmp1_pow_0);
  }
  function _get_js_(_this_) {
    return (_this_ instanceof KClassImpl ? _this_ : THROW_CCE())._get_jClass__2();
  }
  function KCallable() {
  }
  KCallable.$metadata$ = {
    simpleName: 'KCallable',
    kind: 'interface',
    interfaces: []
  };
  function KClass() {
  }
  KClass.$metadata$ = {
    simpleName: 'KClass',
    kind: 'interface',
    interfaces: [KClassifier]
  };
  function KClassImpl(jClass) {
    this._jClass = jClass;
  }
  KClassImpl.prototype._get_jClass__2 = function () {
    return this._jClass;
  };
  KClassImpl.prototype.equals = function (other) {
    var tmp;
    if (other instanceof KClassImpl) {
      tmp = equals_1(this._get_jClass__2(), other._get_jClass__2());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KClassImpl.prototype.hashCode = function () {
    var tmp0_safe_receiver = this._get_simpleName__4();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  KClassImpl.prototype.toString = function () {
    return '' + 'class ' + this._get_simpleName__4();
  };
  KClassImpl.$metadata$ = {
    simpleName: 'KClassImpl',
    kind: 'class',
    interfaces: [KClass]
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this._givenSimpleName = givenSimpleName;
    this._isInstanceFunction = isInstanceFunction;
  }
  PrimitiveKClassImpl.prototype.equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    else {
    }
    return KClassImpl.prototype.equals.call(this, other) ? this._givenSimpleName === other._givenSimpleName : false;
  };
  PrimitiveKClassImpl.prototype._get_simpleName__4 = function () {
    return this._givenSimpleName;
  };
  PrimitiveKClassImpl.$metadata$ = {
    simpleName: 'PrimitiveKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this._simpleName = 'Nothing';
  }
  NothingKClassImpl.prototype._get_simpleName__4 = function () {
    return this._simpleName;
  };
  NothingKClassImpl.prototype._get_jClass__2 = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  NothingKClassImpl.prototype.equals = function (other) {
    return other === this;
  };
  NothingKClassImpl.prototype.hashCode = function () {
    return 0;
  };
  NothingKClassImpl.$metadata$ = {
    simpleName: 'NothingKClassImpl',
    kind: 'object',
    interfaces: []
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  ErrorKClass.prototype._get_simpleName__4 = function () {
    var tmp0_error_0 = 'Unknown simpleName for ErrorKClass';
    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
  };
  ErrorKClass.prototype.equals = function (other) {
    return other === this;
  };
  ErrorKClass.prototype.hashCode = function () {
    return 0;
  };
  ErrorKClass.$metadata$ = {
    simpleName: 'ErrorKClass',
    kind: 'class',
    interfaces: [KClass]
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    var tmp0_safe_receiver = jClass.$metadata$;
    var tmp0_unsafeCast_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
    tmp._simpleName_0 = tmp0_unsafeCast_0;
  }
  SimpleKClassImpl.prototype._get_simpleName__4 = function () {
    return this._simpleName_0;
  };
  SimpleKClassImpl.$metadata$ = {
    simpleName: 'SimpleKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function KFunction() {
  }
  KFunction.$metadata$ = {
    simpleName: 'KFunction',
    kind: 'interface',
    interfaces: [KCallable]
  };
  function KProperty1() {
  }
  KProperty1.$metadata$ = {
    simpleName: 'KProperty1',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KProperty0() {
  }
  KProperty0.$metadata$ = {
    simpleName: 'KProperty0',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KProperty() {
  }
  KProperty.$metadata$ = {
    simpleName: 'KProperty',
    kind: 'interface',
    interfaces: [KCallable]
  };
  function KMutableProperty1() {
  }
  KMutableProperty1.$metadata$ = {
    simpleName: 'KMutableProperty1',
    kind: 'interface',
    interfaces: [KProperty1, KMutableProperty]
  };
  function KMutableProperty0() {
  }
  KMutableProperty0.$metadata$ = {
    simpleName: 'KMutableProperty0',
    kind: 'interface',
    interfaces: [KProperty0, KMutableProperty]
  };
  function KMutableProperty2() {
  }
  KMutableProperty2.$metadata$ = {
    simpleName: 'KMutableProperty2',
    kind: 'interface',
    interfaces: [KProperty2, KMutableProperty]
  };
  function KProperty2() {
  }
  KProperty2.$metadata$ = {
    simpleName: 'KProperty2',
    kind: 'interface',
    interfaces: [KProperty]
  };
  function KMutableProperty() {
  }
  KMutableProperty.$metadata$ = {
    simpleName: 'KMutableProperty',
    kind: 'interface',
    interfaces: [KProperty]
  };
  var functionClasses;
  function _no_name_provided__20() {
  }
  _no_name_provided__20.prototype.invoke_64 = function (it) {
    return isObject(it);
  };
  _no_name_provided__20.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__20.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__21() {
  }
  _no_name_provided__21.prototype.invoke_64 = function (it) {
    return isNumber(it);
  };
  _no_name_provided__21.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__21.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__22() {
  }
  _no_name_provided__22.prototype.invoke_64 = function (it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  };
  _no_name_provided__22.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__22.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__23() {
  }
  _no_name_provided__23.prototype.invoke_64 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__23.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__23.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__24() {
  }
  _no_name_provided__24.prototype.invoke_64 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__24.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__24.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__25() {
  }
  _no_name_provided__25.prototype.invoke_64 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__25.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__25.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__26() {
  }
  _no_name_provided__26.prototype.invoke_64 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__26.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__26.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__27() {
  }
  _no_name_provided__27.prototype.invoke_64 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__27.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__27.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__28() {
  }
  _no_name_provided__28.prototype.invoke_64 = function (it) {
    return !(it == null) ? isArray(it) : false;
  };
  _no_name_provided__28.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__28.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__29() {
  }
  _no_name_provided__29.prototype.invoke_64 = function (it) {
    return !(it == null) ? typeof it === 'string' : false;
  };
  _no_name_provided__29.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__29.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__30() {
  }
  _no_name_provided__30.prototype.invoke_64 = function (it) {
    return it instanceof Error;
  };
  _no_name_provided__30.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__30.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__31() {
  }
  _no_name_provided__31.prototype.invoke_64 = function (it) {
    return !(it == null) ? isBooleanArray(it) : false;
  };
  _no_name_provided__31.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__31.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__32() {
  }
  _no_name_provided__32.prototype.invoke_64 = function (it) {
    return !(it == null) ? isCharArray(it) : false;
  };
  _no_name_provided__32.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__32.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__33() {
  }
  _no_name_provided__33.prototype.invoke_64 = function (it) {
    return !(it == null) ? isByteArray(it) : false;
  };
  _no_name_provided__33.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__33.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__34() {
  }
  _no_name_provided__34.prototype.invoke_64 = function (it) {
    return !(it == null) ? isShortArray(it) : false;
  };
  _no_name_provided__34.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__34.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__35() {
  }
  _no_name_provided__35.prototype.invoke_64 = function (it) {
    return !(it == null) ? isIntArray(it) : false;
  };
  _no_name_provided__35.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__35.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__36() {
  }
  _no_name_provided__36.prototype.invoke_64 = function (it) {
    return !(it == null) ? isLongArray(it) : false;
  };
  _no_name_provided__36.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__36.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__37() {
  }
  _no_name_provided__37.prototype.invoke_64 = function (it) {
    return !(it == null) ? isFloatArray(it) : false;
  };
  _no_name_provided__37.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__37.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__38() {
  }
  _no_name_provided__38.prototype.invoke_64 = function (it) {
    return !(it == null) ? isDoubleArray(it) : false;
  };
  _no_name_provided__38.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__38.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__39($arity) {
    this._$arity = $arity;
  }
  _no_name_provided__39.prototype.invoke_64 = function (it) {
    var tmp;
    if (typeof it === 'function') {
      tmp = it.length === this._$arity;
    } else {
      tmp = false;
    }
    return tmp;
  };
  _no_name_provided__39.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__39.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PrimitiveClasses_0() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    var tmp0_unsafeCast_0 = Object;
    var tmp_0 = tmp0_unsafeCast_0;
    tmp._anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', _no_name_provided_$factory_10());
    var tmp_1 = this;
    var tmp0_unsafeCast_0_0 = Number;
    var tmp_2 = tmp0_unsafeCast_0_0;
    tmp_1._numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', _no_name_provided_$factory_11());
    this._nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    var tmp0_unsafeCast_0_1 = Boolean;
    var tmp_4 = tmp0_unsafeCast_0_1;
    tmp_3._booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', _no_name_provided_$factory_12());
    var tmp_5 = this;
    var tmp0_unsafeCast_0_2 = Number;
    var tmp_6 = tmp0_unsafeCast_0_2;
    tmp_5._byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', _no_name_provided_$factory_13());
    var tmp_7 = this;
    var tmp0_unsafeCast_0_3 = Number;
    var tmp_8 = tmp0_unsafeCast_0_3;
    tmp_7._shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', _no_name_provided_$factory_14());
    var tmp_9 = this;
    var tmp0_unsafeCast_0_4 = Number;
    var tmp_10 = tmp0_unsafeCast_0_4;
    tmp_9._intClass = new PrimitiveKClassImpl(tmp_10, 'Int', _no_name_provided_$factory_15());
    var tmp_11 = this;
    var tmp0_unsafeCast_0_5 = Number;
    var tmp_12 = tmp0_unsafeCast_0_5;
    tmp_11._floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', _no_name_provided_$factory_16());
    var tmp_13 = this;
    var tmp0_unsafeCast_0_6 = Number;
    var tmp_14 = tmp0_unsafeCast_0_6;
    tmp_13._doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', _no_name_provided_$factory_17());
    var tmp_15 = this;
    var tmp0_unsafeCast_0_7 = Array;
    var tmp_16 = tmp0_unsafeCast_0_7;
    tmp_15._arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', _no_name_provided_$factory_18());
    var tmp_17 = this;
    var tmp0_unsafeCast_0_8 = String;
    var tmp_18 = tmp0_unsafeCast_0_8;
    tmp_17._stringClass = new PrimitiveKClassImpl(tmp_18, 'String', _no_name_provided_$factory_19());
    var tmp_19 = this;
    var tmp0_unsafeCast_0_9 = Error;
    var tmp_20 = tmp0_unsafeCast_0_9;
    tmp_19._throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', _no_name_provided_$factory_20());
    var tmp_21 = this;
    var tmp0_unsafeCast_0_10 = Array;
    var tmp_22 = tmp0_unsafeCast_0_10;
    tmp_21._booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', _no_name_provided_$factory_21());
    var tmp_23 = this;
    var tmp0_unsafeCast_0_11 = Uint16Array;
    var tmp_24 = tmp0_unsafeCast_0_11;
    tmp_23._charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', _no_name_provided_$factory_22());
    var tmp_25 = this;
    var tmp0_unsafeCast_0_12 = Int8Array;
    var tmp_26 = tmp0_unsafeCast_0_12;
    tmp_25._byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', _no_name_provided_$factory_23());
    var tmp_27 = this;
    var tmp0_unsafeCast_0_13 = Int16Array;
    var tmp_28 = tmp0_unsafeCast_0_13;
    tmp_27._shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', _no_name_provided_$factory_24());
    var tmp_29 = this;
    var tmp0_unsafeCast_0_14 = Int32Array;
    var tmp_30 = tmp0_unsafeCast_0_14;
    tmp_29._intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', _no_name_provided_$factory_25());
    var tmp_31 = this;
    var tmp0_unsafeCast_0_15 = Array;
    var tmp_32 = tmp0_unsafeCast_0_15;
    tmp_31._longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', _no_name_provided_$factory_26());
    var tmp_33 = this;
    var tmp0_unsafeCast_0_16 = Float32Array;
    var tmp_34 = tmp0_unsafeCast_0_16;
    tmp_33._floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', _no_name_provided_$factory_27());
    var tmp_35 = this;
    var tmp0_unsafeCast_0_17 = Float64Array;
    var tmp_36 = tmp0_unsafeCast_0_17;
    tmp_35._doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', _no_name_provided_$factory_28());
  }
  PrimitiveClasses_0.prototype._get_anyClass_ = function () {
    return this._anyClass;
  };
  PrimitiveClasses_0.prototype._get_numberClass_ = function () {
    return this._numberClass;
  };
  PrimitiveClasses_0.prototype._get_nothingClass_ = function () {
    return this._nothingClass;
  };
  PrimitiveClasses_0.prototype._get_booleanClass_ = function () {
    return this._booleanClass;
  };
  PrimitiveClasses_0.prototype._get_byteClass_ = function () {
    return this._byteClass;
  };
  PrimitiveClasses_0.prototype._get_shortClass_ = function () {
    return this._shortClass;
  };
  PrimitiveClasses_0.prototype._get_intClass_ = function () {
    return this._intClass;
  };
  PrimitiveClasses_0.prototype._get_floatClass_ = function () {
    return this._floatClass;
  };
  PrimitiveClasses_0.prototype._get_doubleClass_ = function () {
    return this._doubleClass;
  };
  PrimitiveClasses_0.prototype._get_arrayClass_ = function () {
    return this._arrayClass;
  };
  PrimitiveClasses_0.prototype._get_stringClass_ = function () {
    return this._stringClass;
  };
  PrimitiveClasses_0.prototype._get_throwableClass_ = function () {
    return this._throwableClass;
  };
  PrimitiveClasses_0.prototype._get_booleanArrayClass_ = function () {
    return this._booleanArrayClass;
  };
  PrimitiveClasses_0.prototype._get_charArrayClass_ = function () {
    return this._charArrayClass;
  };
  PrimitiveClasses_0.prototype._get_byteArrayClass_ = function () {
    return this._byteArrayClass;
  };
  PrimitiveClasses_0.prototype._get_shortArrayClass_ = function () {
    return this._shortArrayClass;
  };
  PrimitiveClasses_0.prototype._get_intArrayClass_ = function () {
    return this._intArrayClass;
  };
  PrimitiveClasses_0.prototype._get_longArrayClass_ = function () {
    return this._longArrayClass;
  };
  PrimitiveClasses_0.prototype._get_floatArrayClass_ = function () {
    return this._floatArrayClass;
  };
  PrimitiveClasses_0.prototype._get_doubleArrayClass_ = function () {
    return this._doubleArrayClass;
  };
  PrimitiveClasses_0.prototype.functionClass = function (arity) {
    var tmp0_elvis_lhs = functionClasses[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_unsafeCast_0_3 = Function;
      var tmp_0 = tmp0_unsafeCast_0_3;
      var tmp_1 = '' + 'Function' + arity;
      var result_2 = new PrimitiveKClassImpl(tmp_0, tmp_1, _no_name_provided_$factory_29(arity));
      var tmp1_asDynamic_0_5 = functionClasses;
      tmp1_asDynamic_0_5[arity] = result_2;
      tmp = result_2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  PrimitiveClasses_0.$metadata$ = {
    simpleName: 'PrimitiveClasses',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(PrimitiveClasses_0.prototype, 'anyClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_anyClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'numberClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_numberClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'nothingClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_nothingClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'arrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_arrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'stringClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_stringClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'throwableClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_throwableClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'charArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_charArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'longArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_longArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleArrayClass_
  });
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses_0();
    return PrimitiveClasses_instance;
  }
  function _no_name_provided_$factory_10() {
    var i = new _no_name_provided__20();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_11() {
    var i = new _no_name_provided__21();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_12() {
    var i = new _no_name_provided__22();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_13() {
    var i = new _no_name_provided__23();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_14() {
    var i = new _no_name_provided__24();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_15() {
    var i = new _no_name_provided__25();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_16() {
    var i = new _no_name_provided__26();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_17() {
    var i = new _no_name_provided__27();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_18() {
    var i = new _no_name_provided__28();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_19() {
    var i = new _no_name_provided__29();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_20() {
    var i = new _no_name_provided__30();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_21() {
    var i = new _no_name_provided__31();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_22() {
    var i = new _no_name_provided__32();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_23() {
    var i = new _no_name_provided__33();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_24() {
    var i = new _no_name_provided__34();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_25() {
    var i = new _no_name_provided__35();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_26() {
    var i = new _no_name_provided__36();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_27() {
    var i = new _no_name_provided__37();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_28() {
    var i = new _no_name_provided__38();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function _no_name_provided_$factory_29($arity) {
    var i = new _no_name_provided__39($arity);
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function functionClasses$init$() {
    var tmp0_arrayOfNulls_0 = 0;
    return fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
  }
  function getKClass_0(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      tmp = getKClassM_0(jClass);
    } else {
      tmp = getKClass1_0(jClass);
    }
    return tmp;
  }
  function getKClassM_0(jClasses) {
    var tmp0_subject = jClasses.length;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = getKClass1_0(jClasses[0]);
        break;
      case 0:
        var tmp0_unsafeCast_0 = NothingKClassImpl_getInstance();
        tmp = tmp0_unsafeCast_0;
        break;
      default:var tmp1_unsafeCast_0 = new ErrorKClass();
        tmp = tmp1_unsafeCast_0;
        break;
    }
    return tmp;
  }
  function getKClass1_0(jClass) {
    if (jClass === String) {
      var tmp0_unsafeCast_0 = PrimitiveClasses_getInstance()._stringClass;
      return tmp0_unsafeCast_0;
    }var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function getKClassFromExpression_0(e) {
    var tmp0_subject = typeof e;
    var tmp;
    switch (tmp0_subject) {
      case 'string':
        tmp = PrimitiveClasses_getInstance()._stringClass;
        break;
      case 'number':
        var tmp_0;
        var tmp0_asDynamic_0 = jsBitwiseOr(e, 0);
        if (tmp0_asDynamic_0 === e) {
          tmp_0 = PrimitiveClasses_getInstance()._intClass;
        } else {
          {
            tmp_0 = PrimitiveClasses_getInstance()._doubleClass;
          }
        }

        tmp = tmp_0;
        break;
      case 'boolean':
        tmp = PrimitiveClasses_getInstance()._booleanClass;
        break;
      case 'function':
        var tmp_1 = PrimitiveClasses_getInstance();
        tmp = tmp_1.functionClass(e.length);
        break;
      default:var tmp_2;
        if (isBooleanArray(e)) {
          tmp_2 = PrimitiveClasses_getInstance()._booleanArrayClass;
        } else {
          if (isCharArray(e)) {
            tmp_2 = PrimitiveClasses_getInstance()._charArrayClass;
          } else {
            if (isByteArray(e)) {
              tmp_2 = PrimitiveClasses_getInstance()._byteArrayClass;
            } else {
              if (isShortArray(e)) {
                tmp_2 = PrimitiveClasses_getInstance()._shortArrayClass;
              } else {
                if (isIntArray(e)) {
                  tmp_2 = PrimitiveClasses_getInstance()._intArrayClass;
                } else {
                  if (isLongArray(e)) {
                    tmp_2 = PrimitiveClasses_getInstance()._longArrayClass;
                  } else {
                    if (isFloatArray(e)) {
                      tmp_2 = PrimitiveClasses_getInstance()._floatArrayClass;
                    } else {
                      if (isDoubleArray(e)) {
                        tmp_2 = PrimitiveClasses_getInstance()._doubleArrayClass;
                      } else {
                        if (isInterface(e, KClass)) {
                          tmp_2 = getKClass_0(KClass);
                        } else {
                          if (isArray(e)) {
                            tmp_2 = PrimitiveClasses_getInstance()._arrayClass;
                          } else {
                            {
                              var constructor = Object.getPrototypeOf(e).constructor;
                              var tmp_3;
                              if (constructor === Object) {
                                tmp_3 = PrimitiveClasses_getInstance()._anyClass;
                              } else if (constructor === Error) {
                                tmp_3 = PrimitiveClasses_getInstance()._throwableClass;
                              } else {
                                var jsClass_0 = constructor;
                                tmp_3 = getKClass1_0(jsClass_0);
                              }
                              tmp_2 = tmp_3;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        tmp = tmp_2;
        break;
    }
    var tmp1_unsafeCast_0 = tmp;
    return tmp1_unsafeCast_0;
  }
  function Appendable() {
  }
  Appendable.$metadata$ = {
    simpleName: 'Appendable',
    kind: 'interface',
    interfaces: []
  };
  function StringBuilder_init_$Init$(capacity, $this) {
    StringBuilder_init_$Init$_0($this);
    return $this;
  }
  function StringBuilder_init_$Create$(capacity) {
    return StringBuilder_init_$Init$(capacity, Object.create(StringBuilder.prototype));
  }
  function StringBuilder_init_$Init$_0($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$_0() {
    return StringBuilder_init_$Init$_0(Object.create(StringBuilder.prototype));
  }
  function StringBuilder(content) {
    this._string = !(content === undefined) ? content : '';
  }
  StringBuilder.prototype._get_length__5 = function () {
    var tmp0_asDynamic_0 = this._string;
    return tmp0_asDynamic_0.length;
  };
  StringBuilder.prototype.get_137 = function (index) {
    var tmp0_getOrElse_0 = this._string;
    var tmp;
    if (index >= 0 ? index <= _get_lastIndex__4(tmp0_getOrElse_0) : false) {
      tmp = charSequenceGet(tmp0_getOrElse_0, index);
    } else {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index + ', length: ' + this._get_length__5() + '}');
    }
    return tmp;
  };
  StringBuilder.prototype.subSequence_1 = function (startIndex, endIndex) {
    var tmp0_substring_0 = this._string;
    return tmp0_substring_0.substring(startIndex, endIndex);
  };
  StringBuilder.prototype.append_2 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + value;
    return this;
  };
  StringBuilder.prototype.append_3 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.append_4 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.append_5 = function (value) {
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._string;
    var tmp1_elvis_lhs = value;
    tmp._string = tmp_0 + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
    return this;
  };
  StringBuilder.prototype.toString = function () {
    return this._string;
  };
  StringBuilder.$metadata$ = {
    simpleName: 'StringBuilder',
    kind: 'class',
    interfaces: [Appendable, CharSequence]
  };
  function isWhitespace(_this_) {
    return matches(_this_.toString(), '[\\s\\xA0]');
  }
  function uppercaseChar(_this_) {
    var tmp0_asDynamic_0 = _this_.toString();
    var tmp = tmp0_asDynamic_0.toUpperCase();
    var uppercase = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    return uppercase.length > 1 ? _this_ : charSequenceGet(uppercase, 0);
  }
  function checkRadix(radix) {
    if (!(2 <= radix ? radix <= 36 : false)) {
      throw IllegalArgumentException_init_$Create$('' + 'radix ' + radix + ' was not in valid range 2..36');
    }return radix;
  }
  function toInt(_this_) {
    var tmp0_elvis_lhs = toIntOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toDouble(_this_) {
    var tmp0_unsafeCast_0 = +_this_;
    var tmp1_also_0 = tmp0_unsafeCast_0;
    if ((isNaN_0(tmp1_also_0) ? !isNaN_2(_this_) : false) ? true : tmp1_also_0 === 0.0 ? isBlank(_this_) : false) {
      numberFormatError(_this_);
    }return tmp1_also_0;
  }
  function toDoubleOrNull(_this_) {
    var tmp0_unsafeCast_0 = +_this_;
    var tmp1_takeIf_0 = tmp0_unsafeCast_0;
    var tmp;
    if (!((isNaN_0(tmp1_takeIf_0) ? !isNaN_2(_this_) : false) ? true : tmp1_takeIf_0 === 0.0 ? isBlank(_this_) : false)) {
      tmp = tmp1_takeIf_0;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function toInt_0(_this_, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this_, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function isNaN_2(_this_) {
    var tmp0_subject = _this_.toLowerCase();
    switch (tmp0_subject) {
      case 'nan':
      case '+nan':
      case '-nan':
        return true;
      default:return false;
    }
  }
  function digitOf(char, radix) {
    var tmp0_let_0 = (char.compareTo_10(new Char(48)) >= 0 ? char.compareTo_10(new Char(57)) <= 0 : false) ? char.minus(new Char(48)) : (char.compareTo_10(new Char(65)) >= 0 ? char.compareTo_10(new Char(90)) <= 0 : false) ? char.minus(new Char(65)) + 10 | 0 : (char.compareTo_10(new Char(97)) >= 0 ? char.compareTo_10(new Char(122)) <= 0 : false) ? char.minus(new Char(97)) + 10 | 0 : -1;
    return tmp0_let_0 >= radix ? -1 : tmp0_let_0;
  }
  function Regex_init_$Init$(pattern, $this) {
    Regex.call($this, pattern, emptySet());
    return $this;
  }
  function Regex_init_$Create$(pattern) {
    return Regex_init_$Init$(pattern, Object.create(Regex.prototype));
  }
  function Companion_14() {
    Companion_instance_13 = this;
    this._patternEscape = new RegExp('[-\\\\^$*+?.()|[\\]{}]', 'g');
    this._replacementEscape = new RegExp('\\$', 'g');
  }
  Companion_14.prototype.escape = function (literal) {
    var tmp0_nativeReplace_0 = this._patternEscape;
    var tmp1_nativeReplace_0 = '\\$&';
    return literal.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  };
  Companion_14.prototype.escapeReplacement = function (literal) {
    var tmp0_nativeReplace_0 = this._replacementEscape;
    var tmp1_nativeReplace_0 = '$$$$';
    return literal.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  };
  Companion_14.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_13;
  function Companion_getInstance_13() {
    if (Companion_instance_13 == null)
      new Companion_14();
    return Companion_instance_13;
  }
  function Regex(pattern, options) {
    Companion_getInstance_13();
    this._pattern = pattern;
    this._options = toSet_0(options);
    var tmp = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(options, 10));
    var tmp0_iterator_1_2 = options.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(item_2_3.value__error);
      Unit_getInstance();
    }
    tmp._nativePattern = new RegExp(pattern, joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, null, 62, null) + 'g');
  }
  Regex.prototype.find = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }return findNext(this._nativePattern, toString_1(input), startIndex);
  };
  Regex.prototype.find$default = function (input, startIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    return this.find(input, startIndex);
  };
  Regex.prototype.replace_0 = function (input, replacement) {
    var tmp0_nativeReplace_0 = toString_1(input);
    var tmp1_nativeReplace_0 = this._nativePattern;
    return tmp0_nativeReplace_0.replace(tmp1_nativeReplace_0, replacement);
  };
  Regex.prototype.toString = function () {
    return this._nativePattern.toString();
  };
  Regex.$metadata$ = {
    simpleName: 'Regex',
    kind: 'class',
    interfaces: []
  };
  function MatchGroup(value) {
    this._value = value;
  }
  MatchGroup.prototype.toString = function () {
    return '' + 'MatchGroup(value=' + this._value + ')';
  };
  MatchGroup.prototype.hashCode = function () {
    return getStringHashCode(this._value);
  };
  MatchGroup.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MatchGroup))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MatchGroup ? other : THROW_CCE();
    if (!(this._value === tmp0_other_with_cast._value))
      return false;
    return true;
  };
  MatchGroup.$metadata$ = {
    simpleName: 'MatchGroup',
    kind: 'class',
    interfaces: []
  };
  function findNext(_this_, input, from) {
    _this_.lastIndex = from;
    var match = _this_.exec(input);
    if (match == null)
      return null;
    var range = numberRangeToNumber(match.index, _this_.lastIndex - 1 | 0);
    return new _no_name_provided__42(range, match, _this_, input);
  }
  function _no_name_provided__40(this$0) {
    this._this$0_7 = this$0;
  }
  _no_name_provided__40.prototype.invoke_874 = function (it) {
    return this._this$0_7.get_137(it);
  };
  _no_name_provided__40.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__40.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__41($match) {
    this._$match = $match;
    AbstractCollection.call(this);
  }
  _no_name_provided__41.prototype._get_size__60 = function () {
    return this._$match.length;
  };
  _no_name_provided__41.prototype.iterator_67 = function () {
    var tmp = asSequence(_get_indices__0(this));
    return map(tmp, _no_name_provided_$factory_30(this)).iterator_67();
  };
  _no_name_provided__41.prototype.get_137 = function (index) {
    var tmp0_safe_receiver = this._$match[index];
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = new MatchGroup(tmp0_safe_receiver);
    }
    return tmp;
  };
  _no_name_provided__41.$metadata$ = {
    kind: 'class',
    interfaces: [MatchGroupCollection]
  };
  function _no_name_provided__42($range, $match, $this_findNext, $input) {
    this._$range = $range;
    this._$match_0 = $match;
    this._$this_findNext = $this_findNext;
    this._$input = $input;
    this._range = this._$range;
    var tmp = this;
    tmp._groups = new _no_name_provided__41(this._$match_0);
    this._groupValues_ = null;
  }
  _no_name_provided__42.prototype._get_groups__0 = function () {
    return this._groups;
  };
  _no_name_provided__42.$metadata$ = {
    kind: 'class',
    interfaces: [MatchResult]
  };
  function _no_name_provided_$factory_30(this$0) {
    var i = new _no_name_provided__40(this$0);
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function concatToString(_this_, startIndex, endIndex) {
    Companion_getInstance().checkBoundsIndexes(startIndex, endIndex, _this_.length);
    var result = '';
    var inductionVariable = startIndex;
    if (inductionVariable < endIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result + _this_[index];
      }
       while (inductionVariable < endIndex);
    return result;
  }
  function startsWith_1(_this_, prefix, ignoreCase) {
    if (!ignoreCase) {
      var tmp0_nativeStartsWith_0 = 0;
      return _this_.startsWith(prefix, tmp0_nativeStartsWith_0);
    } else
      return regionMatches(_this_, 0, prefix, 0, prefix.length, ignoreCase);
  }
  function startsWith$default_1(_this_, prefix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith_1(_this_, prefix, ignoreCase);
  }
  function replace(_this_, oldChar, newChar, ignoreCase) {
    var tmp0_nativeReplace_0 = new RegExp(Companion_getInstance_13().escape(oldChar.toString()), ignoreCase ? 'gi' : 'g');
    var tmp1_nativeReplace_0 = newChar.toString();
    return _this_.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  }
  function replace$default(_this_, oldChar, newChar, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return replace(_this_, oldChar, newChar, ignoreCase);
  }
  function replace_0(_this_, oldValue, newValue, ignoreCase) {
    var tmp0_nativeReplace_0 = new RegExp(Companion_getInstance_13().escape(oldValue), ignoreCase ? 'gi' : 'g');
    var tmp1_nativeReplace_0 = Companion_getInstance_13().escapeReplacement(newValue);
    return _this_.replace(tmp0_nativeReplace_0, tmp1_nativeReplace_0);
  }
  function replace$default_0(_this_, oldValue, newValue, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return replace_0(_this_, oldValue, newValue, ignoreCase);
  }
  function equals_0(_this_, other, ignoreCase) {
    var tmp;
    if (_this_ == null) {
      tmp = other == null;
    } else if (!ignoreCase) {
      tmp = _this_ == other;
    } else {
      var tmp_0;
      if (!(other == null)) {
        var tmp_1 = _this_.toLowerCase();
        tmp_0 = tmp_1 === other.toLowerCase();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function endsWith_1(_this_, suffix, ignoreCase) {
    if (!ignoreCase) {
      return _this_.endsWith(suffix);
    } else
      return regionMatches(_this_, _this_.length - suffix.length | 0, suffix, 0, suffix.length, ignoreCase);
  }
  function endsWith$default_1(_this_, suffix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith_1(_this_, suffix, ignoreCase);
  }
  function repeat(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + "Count 'n' must be non-negative, but was " + n + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp0_subject = n;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = '';
        break;
      case 1:
        tmp = toString_1(_this_);
        break;
      default:var result = '';
        if (!(charSequenceLength(_this_) === 0)) {
          var s = toString_1(_this_);
          var count_0 = n;
          $l$break: while (true) {
            if ((count_0 & 1) === 1) {
              result = result + s;
            }count_0 = count_0 >>> 1;
            if (count_0 === 0) {
              break $l$break;
            }s = s + s;
          }
        } else {
        }

        return result;
    }
    return tmp;
  }
  function isBlank(_this_) {
    var tmp;
    if (charSequenceLength(_this_) === 0) {
      tmp = true;
    } else {
      var tmp_0;
      if (typeof _this_ === 'string') {
        tmp_0 = _this_;
      } else {
        {
          tmp_0 = toString_1(_this_);
        }
      }
      tmp = matches(tmp_0, '^[\\s\\xA0]+$');
    }
    return tmp;
  }
  function regionMatches(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    return regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase);
  }
  function matches(_this_, regex) {
    var result = _this_.match(regex);
    return !(result == null) ? !(result.length === 0) : false;
  }
  function addSuppressed(_this_, exception) {
    if (!(_this_ === exception)) {
      var tmp0_unsafeCast_0 = _this_._suppressed;
      var suppressed = tmp0_unsafeCast_0;
      if (suppressed == null) {
        _this_._suppressed = mutableListOf([exception]);
      } else {
        suppressed.add_39(exception);
        Unit_getInstance();
      }
    }}
  function Companion_15() {
    Companion_instance_14 = this;
    this._MIN_VALUE_7 = new Char(0);
    this._MAX_VALUE_7 = new Char(65535);
    this._MIN_HIGH_SURROGATE = new Char(55296);
    this._MAX_HIGH_SURROGATE = new Char(56319);
    this._MIN_LOW_SURROGATE = new Char(56320);
    this._MAX_LOW_SURROGATE = new Char(57343);
    this._MIN_SURROGATE = new Char(55296);
    this._MAX_SURROGATE = new Char(57343);
    this._SIZE_BYTES_7 = 2;
    this._SIZE_BITS_7 = 16;
  }
  Companion_15.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_14;
  function Companion_getInstance_14() {
    if (Companion_instance_14 == null)
      new Companion_15();
    return Companion_instance_14;
  }
  function Char(code) {
    Companion_getInstance_14();
    var tmp = this;
    tmp._value_0 = _UShort___get_data__impl_(code) & 65535;
  }
  Char.prototype.compareTo_10 = function (other) {
    return this._value_0 - other._value_0 | 0;
  };
  Char.prototype.compareTo_71 = function (other) {
    return this.compareTo_10(other instanceof Char ? other : THROW_CCE());
  };
  Char.prototype.minus = function (other) {
    return this._value_0 - other._value_0 | 0;
  };
  Char.prototype.rangeTo = function (other) {
    return new CharRange(this, other);
  };
  Char.prototype.toByte_6 = function () {
    return toByte(this._value_0);
  };
  Char.prototype.toInt_8 = function () {
    return this._value_0;
  };
  Char.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Char))
      return false;
    else {
    }
    return this._value_0 === other._value_0;
  };
  Char.prototype.hashCode = function () {
    return this._value_0;
  };
  Char.prototype.toString = function () {
    var tmp0_unsafeCast_0 = String.fromCharCode(this._value_0);
    return tmp0_unsafeCast_0;
  };
  Char.$metadata$ = {
    simpleName: 'Char',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  function List() {
  }
  List.$metadata$ = {
    simpleName: 'List',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Entry() {
  }
  Entry.$metadata$ = {
    simpleName: 'Entry',
    kind: 'interface',
    interfaces: []
  };
  function Map_0() {
  }
  Map_0.$metadata$ = {
    simpleName: 'Map',
    kind: 'interface',
    interfaces: []
  };
  function MutableEntry() {
  }
  MutableEntry.$metadata$ = {
    simpleName: 'MutableEntry',
    kind: 'interface',
    interfaces: [Entry]
  };
  function MutableMap() {
  }
  MutableMap.$metadata$ = {
    simpleName: 'MutableMap',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function MutableSet() {
  }
  MutableSet.$metadata$ = {
    simpleName: 'MutableSet',
    kind: 'interface',
    interfaces: [Set, MutableCollection]
  };
  function Set() {
  }
  Set.$metadata$ = {
    simpleName: 'Set',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableList() {
  }
  MutableList.$metadata$ = {
    simpleName: 'MutableList',
    kind: 'interface',
    interfaces: [List, MutableCollection]
  };
  function Collection() {
  }
  Collection.$metadata$ = {
    simpleName: 'Collection',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableCollection() {
  }
  MutableCollection.$metadata$ = {
    simpleName: 'MutableCollection',
    kind: 'interface',
    interfaces: [Collection, MutableIterable]
  };
  function MutableIterable() {
  }
  MutableIterable.$metadata$ = {
    simpleName: 'MutableIterable',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function Companion_16() {
    Companion_instance_15 = this;
  }
  Companion_16.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_15;
  function Companion_getInstance_15() {
    if (Companion_instance_15 == null)
      new Companion_16();
    return Companion_instance_15;
  }
  function Enum(name, ordinal) {
    Companion_getInstance_15();
    this._name = name;
    this._ordinal = ordinal;
  }
  Enum.prototype._get_name__50 = function () {
    return this._name;
  };
  Enum.prototype._get_ordinal__2 = function () {
    return this._ordinal;
  };
  Enum.prototype.compareTo_12 = function (other) {
    return compareTo(this._ordinal, other._ordinal);
  };
  Enum.prototype.compareTo_71 = function (other) {
    return this.compareTo_12(other instanceof Enum ? other : THROW_CCE());
  };
  Enum.prototype.equals = function (other) {
    return this === other;
  };
  Enum.prototype.hashCode = function () {
    return identityHashCode(this);
  };
  Enum.prototype.toString = function () {
    return this._name;
  };
  Enum.$metadata$ = {
    simpleName: 'Enum',
    kind: 'class',
    interfaces: [Comparable]
  };
  function toString_0(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last_1 = array.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last_1));
    return array;
  }
  function arrayIterator(array) {
    return new _no_name_provided__43(array);
  }
  function booleanArray(size_1) {
    var tmp0_withType_0 = 'BooleanArray';
    var tmp1_withType_0 = fillArrayVal(Array(size_1), false);
    tmp1_withType_0.$type$ = tmp0_withType_0;
    var tmp2_unsafeCast_0 = tmp1_withType_0;
    return tmp2_unsafeCast_0;
  }
  function charArray(size_1) {
    var tmp1_withType_0 = 'CharArray';
    var tmp = Array(size_1);
    var tmp0_Char_0 = 0;
    var tmp_0;
    var tmp0__get_code__0_1 = new Char(0);
    if (tmp0_Char_0 < tmp0__get_code__0_1.toInt_8()) {
      tmp_0 = true;
    } else {
      {
        var tmp1__get_code__0_2 = new Char(65535);
        tmp_0 = tmp0_Char_0 > tmp1__get_code__0_2.toInt_8();
      }
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$('' + 'Invalid Char code: ' + tmp0_Char_0);
    } else {
    }
    var tmp2_withType_0 = fillArrayVal(tmp, new Char(_UShort___init__impl_(toShort(tmp0_Char_0))));
    tmp2_withType_0.$type$ = tmp1_withType_0;
    var tmp3_unsafeCast_0 = tmp2_withType_0;
    return tmp3_unsafeCast_0;
  }
  function charArrayOf(arr) {
    var tmp0_withType_0 = 'CharArray';
    var tmp1_withType_0 = arr.slice();
    tmp1_withType_0.$type$ = tmp0_withType_0;
    var tmp2_unsafeCast_0 = tmp1_withType_0;
    return tmp2_unsafeCast_0;
  }
  function _no_name_provided__43($array) {
    this._$array = $array;
    this._index_4 = 0;
  }
  _no_name_provided__43.prototype.hasNext_33 = function () {
    return !(this._index_4 === this._$array.length);
  };
  _no_name_provided__43.prototype.next_37 = function () {
    var tmp;
    if (!(this._index_4 === this._$array.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_4;
      tmp0_this._index_4 = tmp1 + 1 | 0;
      tmp = this._$array[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this._index_4);
    }
    return tmp;
  };
  _no_name_provided__43.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  var buf;
  var bufFloat64;
  var bufFloat32;
  var bufInt32;
  var lowIndex;
  var highIndex;
  function getNumberHashCode(obj) {
    var tmp0_unsafeCast_0 = jsBitwiseOr(obj, 0);
    if (tmp0_unsafeCast_0 === obj) {
      return numberToInt(obj);
    } else {
    }
    bufFloat64[0] = obj;
    return imul(bufInt32[highIndex], 31) + bufInt32[lowIndex] | 0;
  }
  function doubleFromBits(value) {
    bufInt32[lowIndex] = value._low;
    bufInt32[highIndex] = value._high;
    return bufFloat64[0];
  }
  function doubleToRawBits(value) {
    bufFloat64[0] = value;
    return new Long(bufInt32[lowIndex], bufInt32[highIndex]);
  }
  function floatToRawBits(value) {
    bufFloat32[0] = value;
    return bufInt32[0];
  }
  function floatFromBits(value) {
    bufInt32[0] = value;
    return bufFloat32[0];
  }
  function bufFloat64$init$() {
    var tmp0_unsafeCast_0 = new Float64Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufFloat32$init$() {
    var tmp0_unsafeCast_0 = new Float32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufInt32$init$() {
    var tmp0_unsafeCast_0 = new Int32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function lowIndex$init$() {
    bufFloat64[0] = -1.0;
    return !(bufInt32[0] === 0) ? 1 : 0;
  }
  function charSequenceGet(a, index) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.charCodeAt(index);
      var tmp1_Char_0 = tmp0_unsafeCast_0;
      var tmp_0;
      var tmp0__get_code__0_1 = new Char(0);
      if (tmp1_Char_0 < tmp0__get_code__0_1.toInt_8()) {
        tmp_0 = true;
      } else {
        {
          var tmp1__get_code__0_2 = new Char(65535);
          tmp_0 = tmp1_Char_0 > tmp1__get_code__0_2.toInt_8();
        }
      }
      if (tmp_0) {
        throw IllegalArgumentException_init_$Create$('' + 'Invalid Char code: ' + tmp1_Char_0);
      } else {
      }
      tmp = new Char(_UShort___init__impl_(toShort(tmp1_Char_0)));
    } else {
      tmp = a.get_137(index);
    }
    return tmp;
  }
  function isString(a) {
    return typeof a === 'string';
  }
  function charSequenceLength(a) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.length;
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a._get_length__5();
    }
    return tmp;
  }
  function charSequenceSubSequence(a, startIndex, endIndex) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.substring(startIndex, endIndex);
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a.subSequence_1(startIndex, endIndex);
    }
    return tmp;
  }
  function arrayToString(array) {
    return joinToString$default(array, ', ', '[', ']', 0, null, _no_name_provided_$factory_31(), 24, null);
  }
  function contentDeepHashCodeInternal(_this_) {
    if (_this_ == null)
      return 0;
    var result = 1;
    var tmp0_iterator = arrayIterator(_this_);
    while (tmp0_iterator.hasNext_33()) {
      var element = tmp0_iterator.next_37();
      var tmp;
      if (element == null) {
        tmp = 0;
      } else {
        if (isArrayish(element)) {
          tmp = contentDeepHashCodeInternal(element);
        } else {
          if (element instanceof UByteArray) {
            var tmp_0 = element;
            tmp = contentHashCode(tmp_0 == null ? null : tmp_0._storage);
          } else {
            if (element instanceof UShortArray) {
              var tmp_1 = element;
              tmp = contentHashCode_0(tmp_1 == null ? null : tmp_1._storage_2);
            } else {
              if (element instanceof UIntArray) {
                var tmp_2 = element;
                tmp = contentHashCode_1(tmp_2 == null ? null : tmp_2._storage_0);
              } else {
                if (element instanceof ULongArray) {
                  var tmp_3 = element;
                  tmp = contentHashCode_2(tmp_3 == null ? null : tmp_3._storage_1);
                } else {
                  {
                    tmp = hashCode(element);
                  }
                }
              }
            }
          }
        }
      }
      var elementHash = tmp;
      result = imul(31, result) + elementHash | 0;
    }
    return result;
  }
  function contentEqualsInternal(_this_, other) {
    var a = _this_;
    var b = other;
    if (a === b)
      return true;
    if (((a == null ? true : b == null) ? true : !isArrayish(b)) ? true : a.length != b.length)
      return false;
    var inductionVariable = 0;
    var last_1 = a.length;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals_1(a[i], b[i])) {
          return false;
        }}
       while (inductionVariable < last_1);
    return true;
  }
  function contentHashCodeInternal(_this_) {
    var a = _this_;
    if (a == null)
      return 0;
    var result = 1;
    var inductionVariable = 0;
    var last_1 = a.length;
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = imul(result, 31) + hashCode(a[i]) | 0;
      }
       while (inductionVariable < last_1);
    return result;
  }
  function _no_name_provided__44() {
  }
  _no_name_provided__44.prototype.invoke_64 = function (it) {
    return toString_1(it);
  };
  _no_name_provided__44.prototype.invoke_1015 = function (p1) {
    return this.invoke_64((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__44.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_31() {
    var i = new _no_name_provided__44();
    return function (p1) {
      return i.invoke_64(p1);
    };
  }
  function compareTo(a, b) {
    var tmp0_subject = typeof a;
    var tmp;
    switch (tmp0_subject) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.toDouble_6());
          } else {
            {
              tmp_0 = primitiveCompareTo(a, b);
            }
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        var tmp0_asDynamic_0 = 1;
        var ia = tmp0_asDynamic_0 / a;
        var tmp_1;
        var tmp1_asDynamic_0 = 1;
        if (ia === tmp1_asDynamic_0 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            {
              tmp_1 = 1;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.compareTo_71(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    if (!jsIn('kotlinHashCodeValue$', obj)) {
      var hash = jsBitwiseOr(Math.random() * 4.294967296E9, 0);
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }var tmp0_unsafeCast_0 = obj['kotlinHashCodeValue$'];
    return tmp0_unsafeCast_0;
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp0_unsafeCast_0 = o.toString();
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function equals_1(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }if (obj2 == null) {
      return false;
    }if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
      return obj1.equals(obj2);
    }if (obj1 !== obj1) {
      return obj2 !== obj2;
    }if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          var tmp0_asDynamic_0 = 1;
          var tmp_1 = tmp0_asDynamic_0 / obj1;
          var tmp1_asDynamic_0 = 1;
          tmp_0 = tmp_1 === tmp1_asDynamic_0 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }return obj1 === obj2;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var tmp0_subject = typeof obj;
    var tmp;
    switch (tmp0_subject) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        var tmp_0;
        if (obj) {
          tmp_0 = 1;
        } else {
          {
            tmp_0 = 0;
          }
        }

        tmp = tmp_0;
        break;
      default:tmp = getStringHashCode(String(obj));
        break;
    }
    return tmp;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last_1 = length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last_1));
    return hash;
  }
  function anyToString(o) {
    return Object.prototype.toString.call(o);
  }
  function boxIntrinsic(x) {
    var tmp0_error_0 = 'Should be lowered';
    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
  }
  function unboxIntrinsic(x) {
    var tmp0_error_0 = 'Should be lowered';
    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      instance.stack = (new Error()).stack;
    }
  }
  function newThrowable(message, cause) {
    var throwable = new Error();
    var tmp;
    if (isUndefined(message)) {
      var tmp_0;
      if (isUndefined(cause)) {
        tmp_0 = message;
      } else {
        var tmp0_safe_receiver = cause;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
        tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      var tmp2_elvis_lhs = message;
      tmp = tmp2_elvis_lhs == null ? undefined : tmp2_elvis_lhs;
    }
    throwable.message = tmp;
    throwable.cause = cause;
    throwable.name = 'Throwable';
    return throwable;
  }
  function isUndefined(value) {
    return value === undefined;
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp0_safe_receiver = cause;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
          tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
        } else {
          tmp_0 = undefined;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
    return tmp0_unsafeCast_0;
  }
  function getContinuation() {
    throw Exception_init_$Create$('Implemented as intrinsic');
  }
  function returnIfSuspended(argument, $cont) {
    throw Exception_init_$Create$('Implemented as intrinsic');
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function noWhenBranchMatchedException() {
    throw NoWhenBranchMatchedException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function throwUninitializedPropertyAccessException(name) {
    throw UninitializedPropertyAccessException_init_$Create$('' + 'lateinit property ' + name + ' has not been initialized');
  }
  function THROW_ISE() {
    throw IllegalStateException_init_$Create$();
  }
  function lazy(initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function fillFrom(src, dst) {
    var srcLen = src.length;
    var dstLen = dst.length;
    var index = 0;
    var arr = dst;
    while (index < srcLen ? index < dstLen : false) {
      var tmp = index;
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      arr[tmp] = src[tmp0];
    }
    return dst;
  }
  function arrayPlusCollection(array, collection) {
    var tmp0_unsafeCast_0 = array.slice();
    var result = tmp0_unsafeCast_0;
    result.length = result.length + collection._get_size__60() | 0;
    if (array.$type$ !== undefined) {
      result.$type$ = array.$type$;
    }var index = array.length;
    var tmp0_iterator = collection.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var element = tmp0_iterator.next_37();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      result[tmp1] = element;
    }
    return result;
  }
  function arrayCopyResize(source, newSize, defaultValue) {
    var tmp0_unsafeCast_0 = source.slice(0, newSize);
    var result = tmp0_unsafeCast_0;
    if (source.$type$ !== undefined) {
      result.$type$ = source.$type$;
    }var index = source.length;
    if (newSize > index) {
      result.length = newSize;
      while (index < newSize) {
        var tmp0 = index;
        index = tmp0 + 1 | 0;
        result[tmp0] = defaultValue;
      }
    }return result;
  }
  function lazy_0(mode, initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function Companion_17() {
    Companion_instance_16 = this;
    this._MIN_VALUE_8 = new Long(0, -2147483648);
    this._MAX_VALUE_8 = new Long(-1, 2147483647);
    this._SIZE_BYTES_8 = 8;
    this._SIZE_BITS_8 = 64;
  }
  Companion_17.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_16;
  function Companion_getInstance_16() {
    if (Companion_instance_16 == null)
      new Companion_17();
    return Companion_instance_16;
  }
  function Long(low, high) {
    Companion_getInstance_16();
    Number_0.call(this);
    this._low = low;
    this._high = high;
  }
  Long.prototype.compareTo_137 = function (other) {
    return compare(this, other);
  };
  Long.prototype.compareTo_71 = function (other) {
    return this.compareTo_137(other instanceof Long ? other : THROW_CCE());
  };
  Long.prototype.plus_64 = function (other) {
    return add(this, other);
  };
  Long.prototype.minus_29 = function (other) {
    return subtract(this, other);
  };
  Long.prototype.times_28 = function (other) {
    return multiply(this, other);
  };
  Long.prototype.div_28 = function (other) {
    return divide(this, other);
  };
  Long.prototype.rem_27 = function (other) {
    return modulo(this, other);
  };
  Long.prototype.unaryMinus_4 = function () {
    return this.inv_0().plus_64(new Long(1, 0));
  };
  Long.prototype.rangeTo_12 = function (other) {
    return new LongRange(this, other);
  };
  Long.prototype.shl_0 = function (bitCount) {
    return shiftLeft(this, bitCount);
  };
  Long.prototype.ushr_0 = function (bitCount) {
    return shiftRightUnsigned(this, bitCount);
  };
  Long.prototype.and = function (other) {
    return new Long(this._low & other._low, this._high & other._high);
  };
  Long.prototype.or = function (other) {
    return new Long(this._low | other._low, this._high | other._high);
  };
  Long.prototype.xor = function (other) {
    return new Long(this._low ^ other._low, this._high ^ other._high);
  };
  Long.prototype.inv_0 = function () {
    return new Long(~this._low, ~this._high);
  };
  Long.prototype.toInt_8 = function () {
    return this._low;
  };
  Long.prototype.toLong_6 = function () {
    return this;
  };
  Long.prototype.toFloat_6 = function () {
    return this.toDouble_6();
  };
  Long.prototype.toDouble_6 = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_6();
  };
  Long.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Long.prototype.hashCode = function () {
    return hashCode_0(this);
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  var ZERO;
  var ONE;
  var NEG_ONE;
  var MAX_VALUE;
  var MIN_VALUE;
  var TWO_PWR_24_;
  function compare(_this_, other) {
    if (equalsLong(_this_, other)) {
      return 0;
    }var thisNeg = isNegative(_this_);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this_, other)) ? -1 : 1;
  }
  function add(_this_, other) {
    var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this_, other) {
    return add(_this_, other.unaryMinus_4());
  }
  function multiply(_this_, other) {
    if (isZero(_this_)) {
      return ZERO;
    } else if (isZero(other)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      return isOdd(other) ? MIN_VALUE : ZERO;
    } else if (equalsLong(other, MIN_VALUE)) {
      return isOdd(_this_) ? MIN_VALUE : ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this_), negate(other));
      } else {
        tmp = negate(multiply(negate(_this_), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this_, negate(other)));
    }if (lessThan(_this_, TWO_PWR_24_) ? lessThan(other, TWO_PWR_24_) : false) {
      return fromNumber(toNumber(_this_) * toNumber(other));
    }var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this_, other) {
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this_)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      if (equalsLong(other, ONE) ? true : equalsLong(other, NEG_ONE)) {
        return MIN_VALUE;
      } else if (equalsLong(other, MIN_VALUE)) {
        return ONE;
      } else {
        var halfThis = shiftRight(_this_, 1);
        var approx = shiftLeft(halfThis.div_28(other), 1);
        if (equalsLong(approx, ZERO)) {
          return isNegative(other) ? ONE : NEG_ONE;
        } else {
          var rem = subtract(_this_, multiply(other, approx));
          return add(approx, rem.div_28(other));
        }
      }
    } else if (equalsLong(other, MIN_VALUE)) {
      return ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this_).div_28(negate(other));
      } else {
        tmp = negate(negate(_this_).div_28(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this_.div_28(negate(other)));
    }var res = ZERO;
    var rem_0 = _this_;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta_0 = log2 <= 48.0 ? 1.0 : Math.pow(2, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta_0;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = ONE;
      }res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function modulo(_this_, other) {
    return subtract(_this_, multiply(_this_.div_28(other), other));
  }
  function shiftLeft(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low << numBits_0, _this_._high << numBits_0 | _this_._low >>> (32 - numBits_0 | 0));
      } else {
        return new Long(0, _this_._low << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >> numBits_0);
      } else {
        return new Long(_this_._high >> (numBits_0 - 32 | 0), _this_._high >= 0 ? 0 : -1);
      }
    }
  }
  function shiftRightUnsigned(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >>> numBits_0);
      } else {
        var tmp;
        if (numBits_0 === 32) {
          tmp = new Long(_this_._high, 0);
        } else {
          tmp = new Long(_this_._high >>> (numBits_0 - 32 | 0), 0);
        }
        return tmp;
      }
    }
  }
  function toNumber(_this_) {
    return _this_._high * 4.294967296E9 + getLowBitsUnsigned(_this_);
  }
  function equalsLong(_this_, other) {
    return _this_._high === other._high ? _this_._low === other._low : false;
  }
  function hashCode_0(l) {
    return l._low ^ l._high;
  }
  function toStringImpl(_this_, radix) {
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('' + 'radix out of range: ' + radix);
    }if (isZero(_this_)) {
      return '0';
    }if (isNegative(_this_)) {
      if (equalsLong(_this_, MIN_VALUE)) {
        var radixLong = fromInt(radix);
        var div_1 = _this_.div_28(radixLong);
        var rem = subtract(multiply(div_1, radixLong), _this_).toInt_8();
        var tmp = toStringImpl(div_1, radix);
        var tmp0_unsafeCast_0 = rem.toString(radix);
        return tmp + tmp0_unsafeCast_0;
      } else {
        return '' + '-' + toStringImpl(negate(_this_), radix);
      }
    }var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this_;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_28(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_8();
      var tmp1_unsafeCast_0 = intval.toString(radix);
      var digits = tmp1_unsafeCast_0;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value) {
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this_) {
    return _this_._high < 0;
  }
  function isZero(_this_) {
    return _this_._high === 0 ? _this_._low === 0 : false;
  }
  function isOdd(_this_) {
    return (_this_._low & 1) === 1;
  }
  function negate(_this_) {
    return _this_.unaryMinus_4();
  }
  function lessThan(_this_, other) {
    return compare(_this_, other) < 0;
  }
  function fromNumber(value) {
    if (isNaN_0(value)) {
      return ZERO;
    } else if (value <= -9.223372036854776E18) {
      return MIN_VALUE;
    } else if (value + 1 >= 9.223372036854776E18) {
      return MAX_VALUE;
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this_, other) {
    return compare(_this_, other) > 0;
  }
  function greaterThanOrEqual(_this_, other) {
    return compare(_this_, other) >= 0;
  }
  function getLowBitsUnsigned(_this_) {
    return _this_._low >= 0 ? _this_._low : 4.294967296E9 + _this_._low;
  }
  function imul(a_local, b_local) {
    var lhs = jsBitwiseAnd(a_local, 4.29490176E9) * jsBitwiseAnd(b_local, 65535);
    var rhs = jsBitwiseAnd(a_local, 65535) * b_local;
    return jsBitwiseOr(lhs + rhs, 0);
  }
  function primitiveArrayConcat(args) {
    var size_local = 0;
    var inductionVariable = 0;
    var last_1 = args.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = size_local;
        var tmp0_unsafeCast_0 = args[i];
        size_local = tmp + tmp0_unsafeCast_0.length | 0;
      }
       while (!(i === last_1));
    var a = args[0];
    var tmp1_unsafeCast_0 = new a.constructor(size_local);
    var result = tmp1_unsafeCast_0;
    if (a.$type$ != null) {
      var tmp2_withType_0 = a.$type$;
      result.$type$ = tmp2_withType_0;
    } else {
    }
    size_local = 0;
    var inductionVariable_0 = 0;
    var last_2 = args.length - 1 | 0;
    if (inductionVariable_0 <= last_2)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp3_unsafeCast_0 = args[i_0];
        var arr = tmp3_unsafeCast_0;
        var inductionVariable_1 = 0;
        var last_3 = arr.length - 1 | 0;
        if (inductionVariable_1 <= last_3)
          do {
            var j = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp3 = size_local;
            size_local = tmp3 + 1 | 0;
            result[tmp3] = arr[j];
          }
           while (!(j === last_3));
      }
       while (!(i_0 === last_2));
    return result;
  }
  function numberToByte(a) {
    return toByte(numberToInt(a));
  }
  function toByte(a) {
    var tmp0_unsafeCast_0 = a << 24 >> 24;
    return tmp0_unsafeCast_0;
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_8();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function numberToDouble(a) {
    var tmp0_unsafeCast_0 = +a;
    return tmp0_unsafeCast_0;
  }
  function numberToShort(a) {
    return toShort(numberToInt(a));
  }
  function toShort(a) {
    var tmp0_unsafeCast_0 = a << 16 >> 16;
    return tmp0_unsafeCast_0;
  }
  function numberToLong(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a;
    } else {
      {
        tmp = fromNumber(a);
      }
    }
    return tmp;
  }
  function numberToChar(a) {
    var tmp0_Char_0 = numberToInt(a) & 65535;
    var tmp;
    var tmp0__get_code__0_1 = new Char(0);
    if (tmp0_Char_0 < tmp0__get_code__0_1.toInt_8()) {
      tmp = true;
    } else {
      {
        var tmp1__get_code__0_2 = new Char(65535);
        tmp = tmp0_Char_0 > tmp1__get_code__0_2.toInt_8();
      }
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$('' + 'Invalid Char code: ' + tmp0_Char_0);
    } else {
    }
    return new Char(_UShort___init__impl_(toShort(tmp0_Char_0)));
  }
  function toLong(a) {
    return fromInt(a);
  }
  function numberRangeToNumber(start, endInclusive) {
    return new IntRange(start, endInclusive);
  }
  var propertyRefClassMetadataCache;
  function getPropertyCallableRef(name, paramCount, type, getter, setter) {
    getter.get = getter;
    getter.set = setter;
    getter.callableName = name;
    var tmp0_unsafeCast_0 = getPropertyRefClass(getter, getKPropMetadata(paramCount, setter, type));
    return tmp0_unsafeCast_0;
  }
  function getPropertyRefClass(obj, metadata) {
    obj.$metadata$ = metadata;
    obj.constructor = obj;
    return obj;
  }
  function getKPropMetadata(paramCount, setter, type) {
    var mdata = propertyRefClassMetadataCache[paramCount][setter == null ? 0 : 1];
    if (mdata.interfaces.length == 0) {
      mdata.interfaces.push(type);
    }return mdata;
  }
  function propertyRefClassMetadataCache$init$() {
    var tmp = {kind: 'class', interfaces: []};
    var tmp0_arrayOf_0 = [tmp, {kind: 'class', interfaces: []}];
    var tmp_0 = tmp0_arrayOf_0;
    var tmp_1 = {kind: 'class', interfaces: []};
    var tmp1_arrayOf_0 = [tmp_1, {kind: 'class', interfaces: []}];
    var tmp_2 = tmp1_arrayOf_0;
    var tmp_3 = {kind: 'class', interfaces: []};
    var tmp2_arrayOf_0 = [tmp_3, {kind: 'class', interfaces: []}];
    var tmp3_arrayOf_0 = [tmp_0, tmp_2, tmp2_arrayOf_0];
    return tmp3_arrayOf_0;
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp0_unsafeCast_0 = Array.isArray(obj);
    return tmp0_unsafeCast_0;
  }
  function isInterface(obj, iface) {
    var tmp0_elvis_lhs = obj.constructor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctor = tmp;
    return isInterfaceImpl(ctor, iface);
  }
  function isInterfaceImpl(ctor, iface) {
    if (ctor === iface)
      return true;
    var metadata = ctor.$metadata$;
    if (!(metadata == null)) {
      var interfaces = metadata.interfaces;
      var indexedObject = interfaces;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var i = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (isInterfaceImpl(i, iface)) {
          return true;
        }}
    }var superPrototype = !(ctor.prototype == null) ? Object.getPrototypeOf(ctor.prototype) : null;
    var superConstructor = superPrototype != null ? superPrototype.constructor : null;
    return !(superConstructor == null) ? isInterfaceImpl(superConstructor, iface) : false;
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isObject(obj) {
    var objTypeOf = typeof obj;
    var tmp0_subject = objTypeOf;
    switch (tmp0_subject) {
      case 'string':
        return true;
      case 'number':
        return true;
      case 'boolean':
        return true;
      case 'function':
        return true;
      default:return jsInstanceOf(obj, Object);
    }
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isComparable(value) {
    var type = typeof value;
    return ((type === 'string' ? true : type === 'boolean') ? true : isNumber(value)) ? true : isInterface(value, _get_js_(getKClass_0(Comparable)));
  }
  function isCharSequence(value) {
    return typeof value === 'string' ? true : isInterface(value, _get_js_(getKClass_0(CharSequence)));
  }
  function isBooleanArray(a) {
    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
  }
  function isByteArray(a) {
    return jsInstanceOf(a, Int8Array);
  }
  function isShortArray(a) {
    return jsInstanceOf(a, Int16Array);
  }
  function isCharArray(a) {
    return isJsArray(a) ? a.$type$ === 'CharArray' : false;
  }
  function isIntArray(a) {
    return jsInstanceOf(a, Int32Array);
  }
  function isFloatArray(a) {
    return jsInstanceOf(a, Float32Array);
  }
  function isLongArray(a) {
    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
  }
  function isDoubleArray(a) {
    return jsInstanceOf(a, Float64Array);
  }
  function copyOf(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Int8Array(newSize));
  }
  function asList(_this_) {
    return new ArrayList(_this_);
  }
  function contentDeepHashCode(_this_) {
    return contentDeepHashCodeInternal(_this_);
  }
  function contentDeepEquals(_this_, other) {
    return contentDeepEqualsImpl_0(_this_, other);
  }
  function contentEquals_3(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentHashCode_3(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function contentEquals_4(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentHashCode_4(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function fill(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function fill_0(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function plus_4(_this_, elements) {
    return arrayPlusCollection(_this_, elements);
  }
  function sort_0(_this_) {
    if (_this_.length > 1)
      sortArray(_this_);
  }
  function sortWith_0(_this_, comparator) {
    if (_this_.length > 1)
      sortArrayWith(_this_, comparator);
  }
  function copyOf_0(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return arrayCopyResize(_this_, newSize, null);
  }
  function fill_1(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function fill$default(_this_, element, fromIndex, toIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      fromIndex = 0;
    if (!(($mask0 & 4) === 0))
      toIndex = _this_.length;
    return fill_1(_this_, element, fromIndex, toIndex);
  }
  function contentEquals_5(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentEquals_6(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentEquals_7(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentEquals_8(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentEquals_9(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentEquals_10(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentHashCode_5(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function contentHashCode_6(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function contentHashCode_7(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function copyOf_1(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Int32Array(newSize));
  }
  function copyOf_2(_this_, newSize) {
    var tmp0_require_0 = newSize >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }return fillFrom(_this_, new Float64Array(newSize));
  }
  function fill_2(_this_, element, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes(fromIndex, toIndex, _this_.length);
    _this_.fill(element, fromIndex, toIndex);
  }
  function copyOfRange(_this_, fromIndex, toIndex) {
    Companion_getInstance().checkRangeIndexes(fromIndex, toIndex, _this_.length);
    return _this_.slice(fromIndex, toIndex);
  }
  function contentEquals_11(_this_, other) {
    return contentEqualsInternal(_this_, other);
  }
  function contentHashCode_8(_this_) {
    return contentHashCodeInternal(_this_);
  }
  function reverse(_this_) {
    var midPoint = (_this_._get_size__60() / 2 | 0) - 1 | 0;
    if (midPoint < 0)
      return Unit_getInstance();
    var reverseIndex = _get_lastIndex__3(_this_);
    var inductionVariable = 0;
    if (inductionVariable <= midPoint)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = _this_.get_137(index);
        _this_.set_8(index, _this_.get_137(reverseIndex));
        Unit_getInstance();
        _this_.set_8(reverseIndex, tmp);
        Unit_getInstance();
        var tmp1 = reverseIndex;
        reverseIndex = tmp1 - 1 | 0;
        Unit_getInstance();
      }
       while (!(index === midPoint));
  }
  function releaseIntercepted($this) {
    var intercepted_0 = $this._intercepted_;
    if (!(intercepted_0 == null) ? !(intercepted_0 === $this) : false) {
      ensureNotNull($this._get_context__296().get_113(Key_getInstance())).releaseInterceptedContinuation_11(intercepted_0);
    }$this._intercepted_ = CompletedContinuation_getInstance();
  }
  function CoroutineImpl_0(resultContinuation) {
    this._resultContinuation = resultContinuation;
    this._state_1 = 0;
    this._exceptionState = 0;
    this._result_0 = null;
    this._exception_0 = null;
    this._finallyPath = null;
    var tmp = this;
    var tmp0_safe_receiver = this._resultContinuation;
    tmp.__context = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_context__296();
    this._intercepted_ = null;
  }
  CoroutineImpl_0.prototype._get_exception_ = function () {
    return this._exception_0;
  };
  CoroutineImpl_0.prototype._get_context__296 = function () {
    return ensureNotNull(this.__context);
  };
  CoroutineImpl_0.prototype.intercepted_273 = function () {
    var tmp2_elvis_lhs = this._intercepted_;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp0_safe_receiver = this._get_context__296().get_113(Key_getInstance());
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.interceptContinuation_11(this);
      var tmp0_also_0 = tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
      this._intercepted_ = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    return tmp;
  };
  CoroutineImpl_0.prototype.resumeWith_299 = function (result) {
    var current = this;
    var tmp;
    if (_Result___get_isFailure__impl_(result)) {
      tmp = null;
    } else {
      var tmp_0 = _Result___get_value__impl_(result);
      tmp = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    }
    var currentResult = tmp;
    var currentException = Result__exceptionOrNull_impl(result);
    while (true) {
      var tmp0_with_0 = current;
      if (currentException == null) {
        tmp0_with_0._result_0 = currentResult;
      } else {
        tmp0_with_0._state_1 = tmp0_with_0._exceptionState;
        tmp0_with_0._exception_0 = currentException;
      }
      try {
        var outcome_2 = tmp0_with_0.doResume_275();
        if (outcome_2 === _get_COROUTINE_SUSPENDED_())
          return Unit_getInstance();
        currentResult = outcome_2;
        currentException = null;
      } catch ($p) {
        currentResult = null;
        currentException = $p;
      }
      releaseIntercepted(tmp0_with_0);
      var completion_4 = ensureNotNull(tmp0_with_0._resultContinuation);
      if (completion_4 instanceof CoroutineImpl_0) {
        current = completion_4;
      } else {
        {
          if (!(currentException == null)) {
            var tmp0_resumeWithException_0_5 = ensureNotNull(currentException);
            var tmp0_failure_0_1_6 = Companion_getInstance_2();
            completion_4.resumeWith_196(_Result___init__impl_(createFailure(tmp0_resumeWithException_0_5)));
          } else {
            var tmp1_resume_0_7 = currentResult;
            var tmp0_success_0_1_8 = Companion_getInstance_2();
            completion_4.resumeWith_196(_Result___init__impl_(tmp1_resume_0_7));
          }
          return Unit_getInstance();
        }
      }
    }
  };
  CoroutineImpl_0.prototype.resumeWith_196 = function (result) {
    return this.resumeWith_299(result);
  };
  CoroutineImpl_0.$metadata$ = {
    simpleName: 'CoroutineImpl',
    kind: 'class',
    interfaces: [Continuation]
  };
  function CompletedContinuation() {
    CompletedContinuation_instance = this;
  }
  CompletedContinuation.prototype._get_context__296 = function () {
    var tmp0_error_0 = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
  };
  CompletedContinuation.prototype.resumeWith_299 = function (result) {
    var tmp0_error_0 = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
  };
  CompletedContinuation.prototype.resumeWith_196 = function (result) {
    return this.resumeWith_299(result);
  };
  CompletedContinuation.prototype.toString = function () {
    return 'This continuation is already complete';
  };
  CompletedContinuation.$metadata$ = {
    simpleName: 'CompletedContinuation',
    kind: 'object',
    interfaces: [Continuation]
  };
  var CompletedContinuation_instance;
  function CompletedContinuation_getInstance() {
    if (CompletedContinuation_instance == null)
      new CompletedContinuation();
    return CompletedContinuation_instance;
  }
  function intercepted(_this_) {
    var tmp0_safe_receiver = _this_ instanceof CoroutineImpl_0 ? _this_ : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.intercepted_273();
    return tmp1_elvis_lhs == null ? _this_ : tmp1_elvis_lhs;
  }
  function createCoroutineUnintercepted(_this_, receiver, completion) {
    return new _no_name_provided__1_3(_this_, receiver, completion);
  }
  function createCoroutineUnintercepted_0(_this_, completion) {
    return new _no_name_provided__1_4(_this_, completion);
  }
  function _no_name_provided__1_3($this_createCoroutineUnintercepted, $receiver, $completion) {
    this._$this_createCoroutineUnintercepted = $this_createCoroutineUnintercepted;
    this._$receiver = $receiver;
    this._$completion = $completion;
    CoroutineImpl_0.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  _no_name_provided__1_3.prototype.doResume_2_0 = function () {
    if (this._get_exception_() != null)
      throw this._get_exception_();
    return this._$this_createCoroutineUnintercepted(this._$receiver, this._$completion);
  };
  _no_name_provided__1_3.prototype.doResume_275 = function () {
    return this.doResume_2_0();
  };
  _no_name_provided__1_3.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_4($this_createCoroutineUnintercepted, $completion) {
    this._$this_createCoroutineUnintercepted_0 = $this_createCoroutineUnintercepted;
    this._$completion_0 = $completion;
    CoroutineImpl_0.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  _no_name_provided__1_4.prototype.doResume_2_0 = function () {
    if (this._get_exception_() != null)
      throw this._get_exception_();
    return this._$this_createCoroutineUnintercepted_0(this._$completion_0);
  };
  _no_name_provided__1_4.prototype.doResume_275 = function () {
    return this.doResume_2_0();
  };
  _no_name_provided__1_4.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: []
  };
  function Exception_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Exception.call($this);
    return $this;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function Error_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Error_0.call($this);
    return $this;
  }
  function Error_0() {
    captureStack(this, Error_0);
  }
  Error_0.$metadata$ = {
    simpleName: 'Error',
    kind: 'class',
    interfaces: []
  };
  function IllegalArgumentException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$(message) {
    var tmp = IllegalArgumentException_init_$Init$(message, Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  IllegalArgumentException.$metadata$ = {
    simpleName: 'IllegalArgumentException',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$(message) {
    var tmp = RuntimeException_init_$Init$_0(message, Object.create(RuntimeException.prototype));
    captureStack(tmp, RuntimeException_init_$Create$);
    return tmp;
  }
  function RuntimeException_init_$Init$_1(message, cause, $this) {
    Exception_init_$Init$_1(message, cause, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$_0(message, cause) {
    var tmp = RuntimeException_init_$Init$_1(message, cause, Object.create(RuntimeException.prototype));
    captureStack(tmp, RuntimeException_init_$Create$_0);
    return tmp;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  NoSuchElementException.$metadata$ = {
    simpleName: 'NoSuchElementException',
    kind: 'class',
    interfaces: []
  };
  function IllegalStateException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$() {
    var tmp = IllegalStateException_init_$Init$(Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_0(message) {
    var tmp = IllegalStateException_init_$Init$_0(message, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$_0);
    return tmp;
  }
  function IllegalStateException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_1(message, cause) {
    var tmp = IllegalStateException_init_$Init$_1(message, cause, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$_1);
    return tmp;
  }
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  IllegalStateException.$metadata$ = {
    simpleName: 'IllegalStateException',
    kind: 'class',
    interfaces: []
  };
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  UnsupportedOperationException.$metadata$ = {
    simpleName: 'UnsupportedOperationException',
    kind: 'class',
    interfaces: []
  };
  function IndexOutOfBoundsException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$() {
    var tmp = IndexOutOfBoundsException_init_$Init$(Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$_0(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$_0(message, Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$_0);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  IndexOutOfBoundsException.$metadata$ = {
    simpleName: 'IndexOutOfBoundsException',
    kind: 'class',
    interfaces: []
  };
  function NumberFormatException_init_$Init$(message, $this) {
    IllegalArgumentException_init_$Init$(message, $this);
    NumberFormatException.call($this);
    return $this;
  }
  function NumberFormatException_init_$Create$(message) {
    var tmp = NumberFormatException_init_$Init$(message, Object.create(NumberFormatException.prototype));
    captureStack(tmp, NumberFormatException_init_$Create$);
    return tmp;
  }
  function NumberFormatException() {
    captureStack(this, NumberFormatException);
  }
  NumberFormatException.$metadata$ = {
    simpleName: 'NumberFormatException',
    kind: 'class',
    interfaces: []
  };
  function ArithmeticException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ArithmeticException.call($this);
    return $this;
  }
  function ArithmeticException_init_$Create$(message) {
    var tmp = ArithmeticException_init_$Init$(message, Object.create(ArithmeticException.prototype));
    captureStack(tmp, ArithmeticException_init_$Create$);
    return tmp;
  }
  function ArithmeticException() {
    captureStack(this, ArithmeticException);
  }
  ArithmeticException.$metadata$ = {
    simpleName: 'ArithmeticException',
    kind: 'class',
    interfaces: []
  };
  function AssertionError_init_$Init$($this) {
    Error_init_$Init$($this);
    AssertionError.call($this);
    return $this;
  }
  function AssertionError_init_$Create$() {
    var tmp = AssertionError_init_$Init$(Object.create(AssertionError.prototype));
    captureStack(tmp, AssertionError_init_$Create$);
    return tmp;
  }
  function AssertionError() {
    captureStack(this, AssertionError);
  }
  AssertionError.$metadata$ = {
    simpleName: 'AssertionError',
    kind: 'class',
    interfaces: []
  };
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(Object.create(NullPointerException.prototype));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  NullPointerException.$metadata$ = {
    simpleName: 'NullPointerException',
    kind: 'class',
    interfaces: []
  };
  function NoWhenBranchMatchedException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoWhenBranchMatchedException.call($this);
    return $this;
  }
  function NoWhenBranchMatchedException_init_$Create$() {
    var tmp = NoWhenBranchMatchedException_init_$Init$(Object.create(NoWhenBranchMatchedException.prototype));
    captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
    return tmp;
  }
  function NoWhenBranchMatchedException() {
    captureStack(this, NoWhenBranchMatchedException);
  }
  NoWhenBranchMatchedException.$metadata$ = {
    simpleName: 'NoWhenBranchMatchedException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function UninitializedPropertyAccessException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$(message) {
    var tmp = UninitializedPropertyAccessException_init_$Init$(message, Object.create(UninitializedPropertyAccessException.prototype));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
    return tmp;
  }
  function UninitializedPropertyAccessException() {
    captureStack(this, UninitializedPropertyAccessException);
  }
  UninitializedPropertyAccessException.$metadata$ = {
    simpleName: 'UninitializedPropertyAccessException',
    kind: 'class',
    interfaces: []
  };
  function jsIn(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack in rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack | rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsTypeOf(value_hack) {
    var tmp0_unsafeCast_0 = typeof value_hack;
    return tmp0_unsafeCast_0;
  }
  function jsDeleteProperty(obj_hack, property_hack) {
    delete obj_hack[property_hack];
  }
  function jsInstanceOf(obj_hack, jsClass_hack) {
    var tmp0_unsafeCast_0 = obj_hack instanceof jsClass_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseAnd(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack & rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function toRawBits(_this_) {
    return doubleToRawBits(_this_);
  }
  function toBits(_this_) {
    return floatToRawBits(isNaN_1(_this_) ? NaN : _this_);
  }
  function toString_2(_this_, radix) {
    return toStringImpl(_this_, checkRadix(radix));
  }
  function Companion_18() {
    Companion_instance_17 = this;
    this._DEFAULT_FORMAT = Companion_getInstance_17().invoke_203('EEE, dd MMM yyyy HH:mm:ss z');
    this._FORMAT1 = Companion_getInstance_17().invoke_203("yyyy-MM-dd'T'HH:mm:ssXXX");
    this._FORMAT2 = Companion_getInstance_17().invoke_203("yyyy-MM-dd'T'HH:mm:ss.SSSZ");
    this._FORMAT_DATE = Companion_getInstance_17().invoke_203('yyyy-MM-dd');
    this._FORMATS = listOf([this._DEFAULT_FORMAT, this._FORMAT1, this._FORMAT2, this._FORMAT_DATE]);
  }
  Companion_18.prototype.invoke_203 = function (pattern) {
    return PatternDateFormat_init_$Create$(pattern, null, null, null, 14, null);
  };
  Companion_18.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_17;
  function Companion_getInstance_17() {
    if (Companion_instance_17 == null)
      new Companion_18();
    return Companion_instance_17;
  }
  function DateFormat() {
  }
  DateFormat.$metadata$ = {
    simpleName: 'DateFormat',
    kind: 'interface',
    interfaces: []
  };
  function format(_this_, dd) {
    var tmp0__get_minutes__0 = 0;
    return _this_.format_3(DateTime__toOffsetUnadjusted_impl(dd, Companion_getInstance_27().fromMinutes(tmp0__get_minutes__0)));
  }
  var DatePart_Year_instance;
  var DatePart_DayOfYear_instance;
  var DatePart_Month_instance;
  var DatePart_Day_instance;
  var DatePart_entriesInitialized;
  function DatePart_initEntries() {
    if (DatePart_entriesInitialized)
      return Unit_getInstance();
    DatePart_entriesInitialized = true;
    DatePart_Year_instance = new DatePart('Year', 0);
    DatePart_DayOfYear_instance = new DatePart('DayOfYear', 1);
    DatePart_Month_instance = new DatePart('Month', 2);
    DatePart_Day_instance = new DatePart('Day', 3);
  }
  function DatePart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  DatePart.$metadata$ = {
    simpleName: 'DatePart',
    kind: 'class',
    interfaces: []
  };
  function timeToMillisUnchecked($this, hour, minute, second) {
    return hour * 3600000 + minute * 60000 + second * 1000;
  }
  function DatePart_Year_getInstance() {
    DatePart_initEntries();
    return DatePart_Year_instance;
  }
  function DatePart_DayOfYear_getInstance() {
    DatePart_initEntries();
    return DatePart_DayOfYear_instance;
  }
  function DatePart_Month_getInstance() {
    DatePart_initEntries();
    return DatePart_Month_instance;
  }
  function DatePart_Day_getInstance() {
    DatePart_initEntries();
    return DatePart_Day_instance;
  }
  function _DateTime___init__impl_(unixMillis) {
    return unixMillis;
  }
  function _DateTime___get_unixMillis__impl_(this_0) {
    return this_0;
  }
  function Companion_19() {
    Companion_instance_18 = this;
    this._serialVersionUID_3 = new Long(1, 0);
    this._EPOCH = _DateTime___init__impl_(0.0);
    this._EPOCH_INTERNAL_MILLIS = 6.21355968E13;
  }
  Companion_19.prototype.createAdjusted = function (year, month, day, hour, minute, second, milliseconds) {
    var dy = year;
    var dm = month;
    var dd = day;
    var th = hour;
    var tm = minute;
    var ts = second;
    tm = tm + cycleSteps(ts, 0, 59) | 0;
    ts = cycle(ts, 0, 59);
    th = th + cycleSteps(tm, 0, 59) | 0;
    tm = cycle(tm, 0, 59);
    dd = dd + cycleSteps(th, 0, 23) | 0;
    th = cycle(th, 0, 23);
    $l$break: while (true) {
      var dup = Companion_getInstance_23().invoke_874(dm).days_0(dy);
      dm = dm + cycleSteps(dd, 1, dup) | 0;
      dd = cycle(dd, 1, dup);
      dy = dy + cycleSteps(dm, 1, 12) | 0;
      dm = cycle(dm, 1, 12);
      if (cycle(dd, 1, Companion_getInstance_23().invoke_874(dm).days_0(dy)) === dd) {
        break $l$break;
      }}
    return this.createUnchecked(dy, dm, dd, th, tm, ts, milliseconds);
  };
  Companion_19.prototype.createAdjusted$default = function (year, month, day, hour, minute, second, milliseconds, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      hour = 0;
    if (!(($mask0 & 16) === 0))
      minute = 0;
    if (!(($mask0 & 32) === 0))
      second = 0;
    if (!(($mask0 & 64) === 0))
      milliseconds = 0;
    return this.createAdjusted(year, month, day, hour, minute, second, milliseconds);
  };
  Companion_19.prototype.createUnchecked = function (year, month, day, hour, minute, second, milliseconds) {
    return _DateTime___init__impl_(Companion_getInstance_18().dateToMillisUnchecked(year, month, day) + timeToMillisUnchecked(Companion_getInstance_18(), hour, minute, second) + milliseconds);
  };
  Companion_19.prototype.fromUnix = function (unix) {
    return _DateTime___init__impl_(unix);
  };
  Companion_19.prototype.now_2 = function () {
    return _DateTime___init__impl_(KlockInternal_getInstance()._get_currentTime_());
  };
  Companion_19.prototype.dateToMillisUnchecked = function (year, month, day) {
    return (((_Year___get_daysSinceOne__impl_(_Year___init__impl_(year)) + Companion_getInstance_23().invoke_874(month).daysToStart_0(year) | 0) + day | 0) - 1 | 0) * 8.64E7 - 6.21355968E13;
  };
  Companion_19.prototype.getDatePart = function (millis, part) {
    var totalDays = toInt2(millis / 86400000);
    var year = Companion_getInstance_30().fromDays(totalDays);
    if (part.equals(DatePart_Year_getInstance()))
      return _Year___get_year__impl_(year);
    var isLeap = _Year___get_isLeap__impl_(year);
    var startYearDays = _Year___get_daysSinceOne__impl_(year);
    var dayOfYear = 1 + umod(totalDays - startYearDays | 0, _Year___get_days__impl_(year)) | 0;
    if (part.equals(DatePart_DayOfYear_getInstance()))
      return dayOfYear;
    var tmp0_elvis_lhs = Companion_getInstance_23().fromDayOfYear(dayOfYear, isLeap);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = '' + 'Invalid dayOfYear=' + dayOfYear + ', isLeap=' + isLeap;
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var month = tmp;
    if (part.equals(DatePart_Month_getInstance()))
      return month._index1;
    var dayOfMonth = dayOfYear - month.daysToStart(isLeap) | 0;
    if (part.equals(DatePart_Day_getInstance()))
      return dayOfMonth;
    var tmp1_error_0 = 'Invalid DATE_PART';
    throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
  };
  Companion_19.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_18;
  function Companion_getInstance_18() {
    if (Companion_instance_18 == null)
      new Companion_19();
    return Companion_instance_18;
  }
  function _DateTime___get_yearOneMillis__impl_(this_0) {
    return 6.21355968E13 + _DateTime___get_unixMillis__impl_(this_0);
  }
  function _DateTime___get_unixMillisDouble__impl_(this_0) {
    return _DateTime___get_unixMillis__impl_(this_0);
  }
  function _DateTime___get_year__impl_(this_0) {
    return _Year___init__impl_(_DateTime___get_yearInt__impl_(this_0));
  }
  function _DateTime___get_yearInt__impl_(this_0) {
    return Companion_getInstance_18().getDatePart(_DateTime___get_yearOneMillis__impl_(this_0), DatePart_Year_getInstance());
  }
  function _DateTime___get_month__impl_(this_0) {
    return Companion_getInstance_23().get_137(_DateTime___get_month1__impl_(this_0));
  }
  function _DateTime___get_month1__impl_(this_0) {
    return Companion_getInstance_18().getDatePart(_DateTime___get_yearOneMillis__impl_(this_0), DatePart_Month_getInstance());
  }
  function _DateTime___get_dayOfMonth__impl_(this_0) {
    return Companion_getInstance_18().getDatePart(_DateTime___get_yearOneMillis__impl_(this_0), DatePart_Day_getInstance());
  }
  function _DateTime___get_dayOfWeek__impl_(this_0) {
    return Companion_getInstance_20().get_137(_DateTime___get_dayOfWeekInt__impl_(this_0));
  }
  function _DateTime___get_dayOfWeekInt__impl_(this_0) {
    return toIntMod(_DateTime___get_yearOneMillis__impl_(this_0) / 86400000 + 1, 7);
  }
  function _DateTime___get_hours__impl_(this_0) {
    return toIntMod(_DateTime___get_yearOneMillis__impl_(this_0) / 3600000, 24);
  }
  function _DateTime___get_minutes__impl_(this_0) {
    return toIntMod(_DateTime___get_yearOneMillis__impl_(this_0) / 60000, 60);
  }
  function _DateTime___get_seconds__impl_(this_0) {
    return toIntMod(_DateTime___get_yearOneMillis__impl_(this_0) / 1000, 60);
  }
  function _DateTime___get_milliseconds__impl_(this_0) {
    return toIntMod(_DateTime___get_yearOneMillis__impl_(this_0), 1000);
  }
  function DateTime__toOffsetUnadjusted_impl(this_0, offset) {
    return DateTime__toOffsetUnadjusted_impl_0(this_0, _get_offset_(offset));
  }
  function DateTime__toOffsetUnadjusted_impl_0(this_0, offset) {
    return Companion_getInstance_19().local_0(this_0, offset);
  }
  function DateTime__plus_impl(this_0, delta_0) {
    return DateTime__add_impl(this_0, 0, _TimeSpan___get_milliseconds__impl_(delta_0));
  }
  function DateTime__minus_impl(this_0, delta_0) {
    return DateTime__plus_impl(this_0, TimeSpan__unaryMinus_impl(delta_0));
  }
  function DateTime__minus_impl_0(this_0, other) {
    var tmp0__get_milliseconds__0 = _DateTime___get_unixMillisDouble__impl_(this_0) - _DateTime___get_unixMillisDouble__impl_(other);
    return Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0);
  }
  function DateTime__compareTo_impl(this_0, other) {
    return compareTo(_DateTime___get_unixMillis__impl_(this_0), _DateTime___get_unixMillis__impl_(other));
  }
  function DateTime__compareTo_impl_0(this_0, other) {
    var tmp = this_0._unixMillis;
    return DateTime__compareTo_impl(tmp, other instanceof DateTime ? other._unixMillis : THROW_CCE());
  }
  function DateTime__add_impl(this_0, deltaMonths, deltaMilliseconds) {
    var tmp;
    if (deltaMonths === 0 ? deltaMilliseconds === 0.0 : false) {
      tmp = this_0;
    } else if (deltaMonths === 0) {
      tmp = _DateTime___init__impl_(_DateTime___get_unixMillis__impl_(this_0) + deltaMilliseconds);
    } else {
      var year = _DateTime___get_year__impl_(this_0);
      var month = _DateTime___get_month__impl_(this_0)._index1;
      var day = _DateTime___get_dayOfMonth__impl_(this_0);
      var i = (month - 1 | 0) + deltaMonths | 0;
      if (i >= 0) {
        month = i % 12 + 1 | 0;
        year = Year__plus_impl(year, i / 12 | 0);
      } else {
        month = 12 + (i + 1 | 0) % 12 | 0;
        year = Year__plus_impl(year, (i - 11 | 0) / 12 | 0);
      }
      var days = Companion_getInstance_23().invoke_874(month).days_1(year);
      if (day > days)
        day = days;
      tmp = _DateTime___init__impl_(Companion_getInstance_18().dateToMillisUnchecked(_Year___get_year__impl_(year), month, day) + _DateTime___get_yearOneMillis__impl_(this_0) % 86400000 + deltaMilliseconds);
    }
    return tmp;
  }
  function DateTime__toString_impl(this_0) {
    return format(Companion_getInstance_17()._DEFAULT_FORMAT, this_0);
  }
  function DateTime__hashCode_impl(this_0) {
    return getNumberHashCode(this_0);
  }
  function DateTime__equals_impl(this_0, other) {
    if (!(other instanceof DateTime))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DateTime ? other._unixMillis : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function DateTime(unixMillis) {
    Companion_getInstance_18();
    this._unixMillis = unixMillis;
  }
  DateTime.prototype.compareTo_17 = function (other) {
    return DateTime__compareTo_impl(this._unixMillis, other);
  };
  DateTime.prototype.compareTo_71 = function (other) {
    return DateTime__compareTo_impl_0(this, other);
  };
  DateTime.prototype.toString = function () {
    return DateTime__toString_impl(this._unixMillis);
  };
  DateTime.prototype.hashCode = function () {
    return DateTime__hashCode_impl(this._unixMillis);
  };
  DateTime.prototype.equals = function (other) {
    return DateTime__equals_impl(this._unixMillis, other);
  };
  DateTime.$metadata$ = {
    simpleName: 'DateTime',
    kind: 'class',
    interfaces: [Comparable, Serializable_0]
  };
  function Companion_20() {
    Companion_instance_19 = this;
    this._serialVersionUID_4 = new Long(1, 0);
  }
  Companion_20.prototype.local_0 = function (local, offset) {
    return new DateTimeTz(local, offset);
  };
  Companion_20.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_19;
  function Companion_getInstance_19() {
    if (Companion_instance_19 == null)
      new Companion_20();
    return Companion_instance_19;
  }
  function DateTimeTz(adjusted, offset) {
    Companion_getInstance_19();
    this._adjusted = adjusted;
    this._offset = offset;
  }
  DateTimeTz.prototype._get_local_ = function () {
    return this._adjusted;
  };
  DateTimeTz.prototype._get_utc_ = function () {
    return DateTime__minus_impl(this._adjusted, _TimezoneOffset___get_time__impl_(this._offset));
  };
  DateTimeTz.prototype.hashCode = function () {
    return DateTime__hashCode_impl(this._get_local_()) + _TimezoneOffset___get_totalMinutesInt__impl_(this._offset) | 0;
  };
  DateTimeTz.prototype.equals = function (other) {
    var tmp;
    if (other instanceof DateTimeTz) {
      tmp = _DateTime___get_unixMillisDouble__impl_(this._get_utc_()) === _DateTime___get_unixMillisDouble__impl_(other._get_utc_());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  DateTimeTz.prototype.compareTo_19 = function (other) {
    return compareTo(_DateTime___get_unixMillis__impl_(this._get_utc_()), _DateTime___get_unixMillis__impl_(other._get_utc_()));
  };
  DateTimeTz.prototype.compareTo_71 = function (other) {
    return this.compareTo_19(other instanceof DateTimeTz ? other : THROW_CCE());
  };
  DateTimeTz.prototype.toString = function () {
    return Companion_getInstance_17()._DEFAULT_FORMAT.format_3(this);
  };
  DateTimeTz.$metadata$ = {
    simpleName: 'DateTimeTz',
    kind: 'class',
    interfaces: [Comparable, Serializable_0]
  };
  var DayOfWeek_Sunday_instance;
  var DayOfWeek_Monday_instance;
  var DayOfWeek_Tuesday_instance;
  var DayOfWeek_Wednesday_instance;
  var DayOfWeek_Thursday_instance;
  var DayOfWeek_Friday_instance;
  var DayOfWeek_Saturday_instance;
  function Companion_21() {
    Companion_instance_20 = this;
    this._serialVersionUID_5 = new Long(1, 0);
    this._Count = 7;
    this._BY_INDEX0 = values();
  }
  Companion_21.prototype.get_137 = function (index0) {
    return this._BY_INDEX0[umod(index0, 7)];
  };
  Companion_21.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_20;
  function Companion_getInstance_20() {
    if (Companion_instance_20 == null)
      new Companion_21();
    return Companion_instance_20;
  }
  function values() {
    return [DayOfWeek_Sunday_getInstance(), DayOfWeek_Monday_getInstance(), DayOfWeek_Tuesday_getInstance(), DayOfWeek_Wednesday_getInstance(), DayOfWeek_Thursday_getInstance(), DayOfWeek_Friday_getInstance(), DayOfWeek_Saturday_getInstance()];
  }
  var DayOfWeek_entriesInitialized;
  function DayOfWeek_initEntries() {
    if (DayOfWeek_entriesInitialized)
      return Unit_getInstance();
    DayOfWeek_entriesInitialized = true;
    DayOfWeek_Sunday_instance = new DayOfWeek('Sunday', 0, 0);
    DayOfWeek_Monday_instance = new DayOfWeek('Monday', 1, 1);
    DayOfWeek_Tuesday_instance = new DayOfWeek('Tuesday', 2, 2);
    DayOfWeek_Wednesday_instance = new DayOfWeek('Wednesday', 3, 3);
    DayOfWeek_Thursday_instance = new DayOfWeek('Thursday', 4, 4);
    DayOfWeek_Friday_instance = new DayOfWeek('Friday', 5, 5);
    DayOfWeek_Saturday_instance = new DayOfWeek('Saturday', 6, 6);
    Companion_getInstance_20();
  }
  function DayOfWeek(name, ordinal, index0) {
    Enum.call(this, name, ordinal);
    this._index0 = index0;
  }
  DayOfWeek.prototype.localName_1 = function (locale) {
    return locale._get_daysOfWeek__1().get_137(this._index0);
  };
  DayOfWeek.prototype.localShortName = function (locale) {
    return locale._get_daysOfWeekShort__1().get_137(this._index0);
  };
  DayOfWeek.$metadata$ = {
    simpleName: 'DayOfWeek',
    kind: 'class',
    interfaces: [Serializable_0]
  };
  function DayOfWeek_Sunday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Sunday_instance;
  }
  function DayOfWeek_Monday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Monday_instance;
  }
  function DayOfWeek_Tuesday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Tuesday_instance;
  }
  function DayOfWeek_Wednesday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Wednesday_instance;
  }
  function DayOfWeek_Thursday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Thursday_instance;
  }
  function DayOfWeek_Friday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Friday_instance;
  }
  function DayOfWeek_Saturday_getInstance() {
    DayOfWeek_initEntries();
    return DayOfWeek_Saturday_instance;
  }
  function _Frequency___init__impl_(hertz) {
    return hertz;
  }
  function _Frequency___get_hertz__impl_(this_0) {
    return this_0;
  }
  function _Frequency___get_timeSpan__impl_(this_0) {
    var tmp0__get_seconds__0 = 1.0 / _Frequency___get_hertz__impl_(this_0);
    return Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
  }
  function toFrequency(_this_) {
    return _get_timesPerSecond__0(_this_);
  }
  function _get_timesPerSecond_(_this_) {
    return _Frequency___init__impl_(_this_);
  }
  function _get_timesPerSecond__0(_this_) {
    return _Frequency___init__impl_(1.0 / _TimeSpan___get_seconds__impl_(_this_));
  }
  var KlockLocale_default;
  function Companion_22() {
    Companion_instance_21 = this;
    English.call(this);
  }
  Companion_22.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_21;
  function Companion_getInstance_21() {
    if (Companion_instance_21 == null)
      new Companion_22();
    return Companion_instance_21;
  }
  function Companion_23() {
    Companion_instance_22 = this;
  }
  Companion_23.prototype._get_default_ = function () {
    return KlockLocale_default;
  };
  Companion_23.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_23();
    return Companion_instance_22;
  }
  function English() {
    Companion_getInstance_21();
    KlockLocale.call(this);
    this._ISO639_1 = 'en';
    this._firstDayOfWeek = DayOfWeek_Sunday_getInstance();
    this._daysOfWeek = listOf(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']);
    this._months = listOf(['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']);
    this._formatTimeMedium = this.format_2('h:mm:ss a');
    this._formatTimeShort = this.format_2('h:mm a');
  }
  English.prototype._get_daysOfWeek__1 = function () {
    return this._daysOfWeek;
  };
  English.prototype._get_months__1 = function () {
    return this._months;
  };
  English.$metadata$ = {
    simpleName: 'English',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__45(this$0) {
    this._this$0_8 = this$0;
  }
  _no_name_provided__45.prototype.invoke_1005 = function () {
    var tmp0_map_0 = this._this$0_8._get_months__1();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(substr(item_2_3, 0, 3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  };
  _no_name_provided__45.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__46(this$0) {
    this._this$0_9 = this$0;
  }
  _no_name_provided__46.prototype.invoke_1005 = function () {
    var tmp0_map_0 = this._this$0_9._get_daysOfWeek__1();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(substr(item_2_3, 0, 3));
      Unit_getInstance();
    }
    return tmp0_mapTo_0_1;
  };
  _no_name_provided__46.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function KlockLocale() {
    Companion_getInstance_22();
    var tmp = this;
    tmp._monthsShort$delegate = klockLazyOrGet(_no_name_provided_$factory_32(this));
    var tmp_0 = this;
    tmp_0._daysOfWeekShort$delegate = klockLazyOrGet(_no_name_provided_$factory_33(this));
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = 32;
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp_6;
      if (11 <= tmp_5 ? tmp_5 <= 13 : false) {
        tmp_6 = '' + tmp_5 + 'th';
      } else {
        var tmp0_subject = tmp_5 % 10;
        switch (tmp0_subject) {
          case 1:
            tmp_6 = '' + tmp_5 + 'st';
            break;
          case 2:
            tmp_6 = '' + tmp_5 + 'nd';
            break;
          case 3:
            tmp_6 = '' + tmp_5 + 'rd';
            break;
          default:tmp_6 = '' + tmp_5 + 'th';
            break;
        }
      }
      tmp_4[tmp_5] = tmp_6;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1._ordinals = tmp_4;
    this._h12Marker = listOf(['AM', 'OM']);
    this._formatDateTimeMedium = this.format_2('MMM d, y h:mm:ss a');
    this._formatDateTimeShort = this.format_2('M/d/yy h:mm a');
    this._formatDateFull = this.format_2('EEEE, MMMM d, y');
    this._formatDateLong = this.format_2('MMMM d, y');
    this._formatDateMedium = this.format_2('MMM d, y');
    this._formatDateShort = this.format_2('M/d/yy');
    this._formatTimeMedium_0 = this.format_2('HH:mm:ss');
    this._formatTimeShort_0 = this.format_2('HH:mm');
  }
  KlockLocale.prototype._get_daysOfWeekShort__1 = function () {
    var tmp0_getValue_0 = this._daysOfWeekShort$delegate;
    var tmp1_getValue_0 = daysOfWeekShort$factory();
    return tmp0_getValue_0._get_value__10();
  };
  KlockLocale.prototype._get_ordinals__1 = function () {
    return this._ordinals;
  };
  KlockLocale.prototype.getOrdinalByDay_1 = function (day) {
    return this._get_ordinals__1()[day];
  };
  KlockLocale.prototype.format_2 = function (str) {
    return PatternDateFormat_init_$Create$(str, this, null, null, 12, null);
  };
  KlockLocale.$metadata$ = {
    simpleName: 'KlockLocale',
    kind: 'class',
    interfaces: []
  };
  function daysOfWeekShort$factory() {
    return getPropertyCallableRef('daysOfWeekShort', 1, KProperty1, function (receiver) {
      return receiver._get_daysOfWeekShort__1();
    }, null);
  }
  function _no_name_provided_$factory_32(this$0) {
    var i = new _no_name_provided__45(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_33(this$0) {
    var i = new _no_name_provided__46(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function TimedResult(result, time) {
    this._result_1 = result;
    this._time = time;
  }
  TimedResult.prototype.component1_1 = function () {
    return this._result_1;
  };
  TimedResult.prototype.component2_0 = function () {
    return this._time;
  };
  TimedResult.prototype.toString = function () {
    return '' + 'TimedResult(result=' + this._result_1 + ', time=' + new TimeSpan(this._time) + ')';
  };
  TimedResult.prototype.hashCode = function () {
    var result = this._result_1 == null ? 0 : hashCode(this._result_1);
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._time) | 0;
    return result;
  };
  TimedResult.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TimedResult))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TimedResult ? other : THROW_CCE();
    if (!equals_1(this._result_1, tmp0_other_with_cast._result_1))
      return false;
    if (!equals_1(new TimeSpan(this._time), new TimeSpan(tmp0_other_with_cast._time)))
      return false;
    return true;
  };
  TimedResult.$metadata$ = {
    simpleName: 'TimedResult',
    kind: 'class',
    interfaces: []
  };
  function YEAR_DAYS($this, isLeap) {
    return isLeap ? $this._YEAR_DAYS_LEAP : $this._YEAR_DAYS_COMMON;
  }
  function generateDaysToStart($this, leap) {
    var total = 0;
    var tmp = 0;
    var tmp_0 = 13;
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      total = total + (tmp_2 === 0 ? 0 : Companion_getInstance_23()._BY_INDEX0_0[tmp_2 - 1 | 0].days_2(leap)) | 0;
      tmp_1[tmp_2] = total;
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function Month_init_$Init$(name, ordinal, index1, daysCommon, daysLeap, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0))
      daysLeap = daysCommon;
    Month.call($this, name, ordinal, index1, daysCommon, daysLeap);
    return $this;
  }
  function Month_init_$Create$(name, ordinal, index1, daysCommon, daysLeap, $mask0, $marker) {
    return Month_init_$Init$(name, ordinal, index1, daysCommon, daysLeap, $mask0, $marker, Object.create(Month.prototype));
  }
  var Month_January_instance;
  var Month_February_instance;
  var Month_March_instance;
  var Month_April_instance;
  var Month_May_instance;
  var Month_June_instance;
  var Month_July_instance;
  var Month_August_instance;
  var Month_September_instance;
  var Month_October_instance;
  var Month_November_instance;
  var Month_December_instance;
  function Companion_24() {
    Companion_instance_23 = this;
    this._serialVersionUID_6 = new Long(1, 0);
    this._Count_0 = 12;
    this._BY_INDEX0_0 = values_0();
    this._YEAR_DAYS_LEAP = generateDaysToStart(this, true);
    this._YEAR_DAYS_COMMON = generateDaysToStart(this, false);
  }
  Companion_24.prototype.invoke_874 = function (index1) {
    return this.adjusted(index1);
  };
  Companion_24.prototype.get_137 = function (index1) {
    return this.adjusted(index1);
  };
  Companion_24.prototype.adjusted = function (index1) {
    return this._BY_INDEX0_0[umod(index1 - 1 | 0, 12)];
  };
  Companion_24.prototype.fromDayOfYear = function (dayOfYear, leap) {
    var days = YEAR_DAYS(this, leap);
    var day0 = dayOfYear - 1 | 0;
    var guess = day0 / 32 | 0;
    var tmp;
    if (0 <= guess ? guess <= 11 : false) {
      var containsLower = days[guess];
      tmp = day0 < days[guess + 1 | 0] ? containsLower <= day0 : false;
    } else {
      tmp = false;
    }
    if (tmp)
      return Companion_getInstance_23().get_137(guess + 1 | 0);
    else {
    }
    var tmp_0;
    if (0 <= guess ? guess <= 10 : false) {
      var containsLower_0 = days[guess + 1 | 0];
      tmp_0 = day0 < days[guess + 2 | 0] ? containsLower_0 <= day0 : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0)
      return Companion_getInstance_23().get_137(guess + 2 | 0);
    else {
    }
    return null;
  };
  Companion_24.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_23;
  function Companion_getInstance_23() {
    if (Companion_instance_23 == null)
      new Companion_24();
    return Companion_instance_23;
  }
  function values_0() {
    return [Month_January_getInstance(), Month_February_getInstance(), Month_March_getInstance(), Month_April_getInstance(), Month_May_getInstance(), Month_June_getInstance(), Month_July_getInstance(), Month_August_getInstance(), Month_September_getInstance(), Month_October_getInstance(), Month_November_getInstance(), Month_December_getInstance()];
  }
  var Month_entriesInitialized;
  function Month_initEntries() {
    if (Month_entriesInitialized)
      return Unit_getInstance();
    Month_entriesInitialized = true;
    Month_January_instance = Month_init_$Create$('January', 0, 1, 31, 0, 16, null);
    Month_February_instance = new Month('February', 1, 2, 28, 29);
    Month_March_instance = Month_init_$Create$('March', 2, 3, 31, 0, 16, null);
    Month_April_instance = Month_init_$Create$('April', 3, 4, 30, 0, 16, null);
    Month_May_instance = Month_init_$Create$('May', 4, 5, 31, 0, 16, null);
    Month_June_instance = Month_init_$Create$('June', 5, 6, 30, 0, 16, null);
    Month_July_instance = Month_init_$Create$('July', 6, 7, 31, 0, 16, null);
    Month_August_instance = Month_init_$Create$('August', 7, 8, 31, 0, 16, null);
    Month_September_instance = Month_init_$Create$('September', 8, 9, 30, 0, 16, null);
    Month_October_instance = Month_init_$Create$('October', 9, 10, 31, 0, 16, null);
    Month_November_instance = Month_init_$Create$('November', 10, 11, 30, 0, 16, null);
    Month_December_instance = Month_init_$Create$('December', 11, 12, 31, 0, 16, null);
    Companion_getInstance_23();
  }
  function Month(name, ordinal, index1, daysCommon, daysLeap) {
    Enum.call(this, name, ordinal);
    this._index1 = index1;
    this._daysCommon = daysCommon;
    this._daysLeap = daysLeap;
  }
  Month.prototype._get_index0_ = function () {
    return this._index1 - 1 | 0;
  };
  Month.prototype.days_2 = function (leap) {
    return leap ? this._daysLeap : this._daysCommon;
  };
  Month.prototype.days_0 = function (year) {
    return this.days_2(_Year___get_isLeap__impl_(_Year___init__impl_(year)));
  };
  Month.prototype.days_1 = function (year) {
    return this.days_2(_Year___get_isLeap__impl_(year));
  };
  Month.prototype.daysToStart = function (leap) {
    return YEAR_DAYS(Companion_getInstance_23(), leap)[this._get_index0_()];
  };
  Month.prototype.daysToStart_0 = function (year) {
    return this.daysToStart(_Year___get_isLeap__impl_(_Year___init__impl_(year)));
  };
  Month.prototype.localName_1 = function (locale) {
    return locale._get_months__1().get_137(this._get_index0_());
  };
  Month.$metadata$ = {
    simpleName: 'Month',
    kind: 'class',
    interfaces: [Serializable_0]
  };
  function Month_January_getInstance() {
    Month_initEntries();
    return Month_January_instance;
  }
  function Month_February_getInstance() {
    Month_initEntries();
    return Month_February_instance;
  }
  function Month_March_getInstance() {
    Month_initEntries();
    return Month_March_instance;
  }
  function Month_April_getInstance() {
    Month_initEntries();
    return Month_April_instance;
  }
  function Month_May_getInstance() {
    Month_initEntries();
    return Month_May_instance;
  }
  function Month_June_getInstance() {
    Month_initEntries();
    return Month_June_instance;
  }
  function Month_July_getInstance() {
    Month_initEntries();
    return Month_July_instance;
  }
  function Month_August_getInstance() {
    Month_initEntries();
    return Month_August_instance;
  }
  function Month_September_getInstance() {
    Month_initEntries();
    return Month_September_instance;
  }
  function Month_October_getInstance() {
    Month_initEntries();
    return Month_October_instance;
  }
  function Month_November_getInstance() {
    Month_initEntries();
    return Month_November_instance;
  }
  function Month_December_getInstance() {
    Month_initEntries();
    return Month_December_instance;
  }
  function Companion_25() {
    Companion_instance_24 = this;
    this._serialVersionUID_7 = new Long(1, 0);
    this._DEFAULT = new Options(false);
    this._WITH_OPTIONAL = new Options(true);
  }
  Companion_25.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_24;
  function Companion_getInstance_24() {
    if (Companion_instance_24 == null)
      new Companion_25();
    return Companion_instance_24;
  }
  function PatternDateFormat_init_$Init$(format_0, locale, tzNames, options, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      locale = null;
    if (!(($mask0 & 4) === 0))
      tzNames = Companion_getInstance_28()._DEFAULT_0;
    if (!(($mask0 & 8) === 0))
      options = Companion_getInstance_24()._DEFAULT;
    PatternDateFormat.call($this, format_0, locale, tzNames, options);
    return $this;
  }
  function PatternDateFormat_init_$Create$(format_0, locale, tzNames, options, $mask0, $marker) {
    return PatternDateFormat_init_$Init$(format_0, locale, tzNames, options, $mask0, $marker, Object.create(PatternDateFormat.prototype));
  }
  function Companion_26() {
    Companion_instance_25 = this;
    this._serialVersionUID_8 = new Long(1, 0);
  }
  Companion_26.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_25;
  function Companion_getInstance_25() {
    if (Companion_instance_25 == null)
      new Companion_26();
    return Companion_instance_25;
  }
  function Options(optionalSupport) {
    Companion_getInstance_24();
    this._optionalSupport = optionalSupport;
  }
  Options.prototype.toString = function () {
    return '' + 'Options(optionalSupport=' + this._optionalSupport + ')';
  };
  Options.prototype.hashCode = function () {
    return this._optionalSupport | 0;
  };
  Options.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Options))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Options ? other : THROW_CCE();
    if (!(this._optionalSupport === tmp0_other_with_cast._optionalSupport))
      return false;
    return true;
  };
  Options.$metadata$ = {
    simpleName: 'Options',
    kind: 'class',
    interfaces: [Serializable_0]
  };
  function PatternDateFormat(format_0, locale, tzNames, options) {
    Companion_getInstance_25();
    this._format = format_0;
    this._locale = locale;
    this._tzNames = tzNames;
    this._options_0 = options;
    this._openOffsets = LinkedHashMap_init_$Create$();
    this._closeOffsets = LinkedHashMap_init_$Create$();
    var tmp = this;
    var tmp0_also_0 = ArrayList_init_$Create$();
    var s_2 = MicroStrReader_init_$Create$(this._format, 0, 2, null);
    while (s_2._get_hasMore__0()) {
      if (s_2.peekChar_0().equals(new Char(39))) {
        var start_1_4 = s_2._offset_0;
        s_2.tryRead(new Char(39));
        Unit_getInstance();
        while (s_2._get_hasMore__0() ? !s_2.readChar_0().equals(new Char(39)) : false)
          Unit_getInstance();
        var end_2_5 = s_2._offset_0;
        var tmp0_substring_0_6 = s_2._str;
        var escapedChunk_3 = tmp0_substring_0_6.substring(start_1_4, end_2_5);
        tmp0_also_0.add_39(escapedChunk_3);
        Unit_getInstance();
        continue;
      }if (this._options_0._optionalSupport) {
        var offset_7 = tmp0_also_0._get_size__60();
        if (s_2.tryRead(new Char(91))) {
          increment(this._openOffsets, offset_7);
          continue;
        }if (s_2.tryRead(new Char(93))) {
          increment(this._closeOffsets, offset_7 - 1 | 0);
          continue;
        }}var tmp0_elvis_lhs_8 = s_2.tryReadOrNull('do');
      tmp0_also_0.add_39(tmp0_elvis_lhs_8 == null ? readRepeatedChar(s_2) : tmp0_elvis_lhs_8);
      Unit_getInstance();
    }
    tmp._chunks = toList_2(tmp0_also_0);
    var tmp_0 = this;
    var tmp0_map_0 = this._chunks;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      var tmp0_subject_5 = item_2_3;
      var tmp_1;
      switch (tmp0_subject_5) {
        case 'E':
        case 'EE':
        case 'EEE':
        case 'EEEE':
        case 'EEEEE':
        case 'EEEEEE':
          tmp_1 = '(\\w+)';
          break;
        case 'z':
        case 'zzz':
          tmp_1 = '([\\w\\s\\-\\+\\:]+)';
          break;
        case 'do':
          tmp_1 = '(\\d{1,2}\\w+)';
          break;
        case 'd':
          tmp_1 = '(\\d{1,2})';
          break;
        case 'dd':
          tmp_1 = '(\\d{2})';
          break;
        case 'M':
          tmp_1 = '(\\d{1,5})';
          break;
        case 'MM':
          tmp_1 = '(\\d{2})';
          break;
        case 'MMM':
        case 'MMMM':
        case 'MMMMM':
          tmp_1 = '(\\w+)';
          break;
        case 'y':
          tmp_1 = '(\\d{1,5})';
          break;
        case 'yy':
          tmp_1 = '(\\d{2})';
          break;
        case 'yyy':
          tmp_1 = '(\\d{3})';
          break;
        case 'yyyy':
          tmp_1 = '(\\d{4})';
          break;
        case 'YYYY':
          tmp_1 = '(\\d{4})';
          break;
        case 'H':
        case 'k':
          tmp_1 = '(\\d{1,2})';
          break;
        case 'HH':
        case 'kk':
          tmp_1 = '(\\d{2})';
          break;
        case 'h':
        case 'K':
          tmp_1 = '(\\d{1,2})';
          break;
        case 'hh':
        case 'KK':
          tmp_1 = '(\\d{2})';
          break;
        case 'm':
          tmp_1 = '(\\d{1,2})';
          break;
        case 'mm':
          tmp_1 = '(\\d{2})';
          break;
        case 's':
          tmp_1 = '(\\d{1,2})';
          break;
        case 'ss':
          tmp_1 = '(\\d{2})';
          break;
        case 'S':
          tmp_1 = '(\\d{1,6})';
          break;
        case 'SS':
          tmp_1 = '(\\d{2})';
          break;
        case 'SSS':
          tmp_1 = '(\\d{3})';
          break;
        case 'SSSS':
          tmp_1 = '(\\d{4})';
          break;
        case 'SSSSS':
          tmp_1 = '(\\d{5})';
          break;
        case 'SSSSSS':
          tmp_1 = '(\\d{6})';
          break;
        case 'SSSSSSS':
          tmp_1 = '(\\d{7})';
          break;
        case 'SSSSSSSS':
          tmp_1 = '(\\d{8})';
          break;
        case 'SSSSSSSSS':
          tmp_1 = '(\\d{9})';
          break;
        case 'X':
        case 'XX':
        case 'XXX':
        case 'x':
        case 'xx':
        case 'xxx':
          tmp_1 = '([\\w:\\+\\-]+)';
          break;
        case 'a':
          tmp_1 = '(\\w+)';
          break;
        case ' ':
          tmp_1 = '(\\s+)';
          break;
        default:var tmp_2;
          var tmp_3 = new Char(39);
          if (startsWith$default(item_2_3, tmp_3, false, 2, null)) {
            tmp_2 = '(' + Companion_getInstance_13().escapeReplacement(substr(item_2_3, 1, item_2_3.length - 2 | 0)) + ')';
          } else {
            {
              tmp_2 = '(' + Companion_getInstance_13().escapeReplacement(item_2_3) + ')';
            }
          }

          tmp_1 = tmp_2;
          break;
      }
      tmp0_mapTo_0_1.add_39(tmp_1);
      Unit_getInstance();
    }
    tmp_0._regexChunks = tmp0_mapTo_0_1;
    var tmp_4 = this;
    var tmp0_mapIndexed_0 = this._regexChunks;
    var tmp0_mapIndexedTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_mapIndexed_0, 10));
    var index_1_2 = 0;
    var tmp0_iterator_2_3 = tmp0_mapIndexed_0.iterator_67();
    while (tmp0_iterator_2_3.hasNext_33()) {
      var item_3_4 = tmp0_iterator_2_3.next_37();
      var tmp1_4_5 = index_1_2;
      index_1_2 = tmp1_4_5 + 1 | 0;
      var tmp1__anonymous__6 = checkIndexOverflow(tmp1_4_5);
      var tmp_5;
      if (this._options_0._optionalSupport) {
        var tmp0_getOrElse_0_8 = this._openOffsets;
        var tmp0_elvis_lhs_1_9 = tmp0_getOrElse_0_8.get_116(tmp1__anonymous__6);
        var tmp_6;
        if (tmp0_elvis_lhs_1_9 == null) {
          tmp_6 = 0;
        } else {
          tmp_6 = tmp0_elvis_lhs_1_9;
        }
        var opens_7 = tmp_6;
        var tmp1_getOrElse_0_11 = this._closeOffsets;
        var tmp0_elvis_lhs_1_12 = tmp1_getOrElse_0_11.get_116(tmp1__anonymous__6);
        var tmp_7;
        if (tmp0_elvis_lhs_1_12 == null) {
          tmp_7 = 0;
        } else {
          tmp_7 = tmp0_elvis_lhs_1_12;
        }
        var closes_10 = tmp_7;
        var tmp0_apply_0_1_13 = StringBuilder_init_$Create$_0();
        var inductionVariable = 0;
        if (inductionVariable < opens_7)
          do {
            var index_2_4_15 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            tmp0_apply_0_1_13.append_5('(?:');
            Unit_getInstance();
          }
           while (inductionVariable < opens_7);
        tmp0_apply_0_1_13.append_5(item_3_4);
        Unit_getInstance();
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < closes_10)
          do {
            var index_2_6_17 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            tmp0_apply_0_1_13.append_5(')?');
            Unit_getInstance();
          }
           while (inductionVariable_0 < closes_10);
        tmp_5 = tmp0_apply_0_1_13.toString();
      } else {
        tmp_5 = item_3_4;
      }
      tmp0_mapIndexedTo_0_1.add_39(tmp_5);
      Unit_getInstance();
    }
    tmp_4._rx2 = Regex_init_$Create$('^' + joinToString$default_0(tmp0_mapIndexedTo_0_1, '', null, null, 0, null, null, 62, null) + '$');
  }
  PatternDateFormat.prototype._get_realLocale_ = function () {
    var tmp0_elvis_lhs = this._locale;
    return tmp0_elvis_lhs == null ? Companion_getInstance_22()._get_default_() : tmp0_elvis_lhs;
  };
  PatternDateFormat.prototype.format_3 = function (dd) {
    var utc_0 = dd._get_local_();
    var out = '';
    var tmp0_iterator = this._chunks.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var name = tmp0_iterator.next_37();
      var nlen = name.length;
      var tmp = out;
      var tmp1_subject = name;
      var tmp_0;
      switch (tmp1_subject) {
        case 'E':
        case 'EE':
        case 'EEE':
          tmp_0 = Companion_getInstance_20().get_137(_DateTime___get_dayOfWeek__impl_(utc_0)._index0).localShortName(this._get_realLocale_());
          break;
        case 'EEEE':
        case 'EEEEE':
        case 'EEEEEE':
          tmp_0 = Companion_getInstance_20().get_137(_DateTime___get_dayOfWeek__impl_(utc_0)._index0).localName_1(this._get_realLocale_());
          break;
        case 'z':
        case 'zzz':
          tmp_0 = _TimezoneOffset___get_timeZone__impl_(dd._offset);
          break;
        case 'd':
        case 'dd':
          tmp_0 = padded(_DateTime___get_dayOfMonth__impl_(utc_0), nlen);
          break;
        case 'do':
          tmp_0 = this._get_realLocale_().getOrdinalByDay_1(_DateTime___get_dayOfMonth__impl_(utc_0));
          break;
        case 'M':
        case 'MM':
          tmp_0 = padded(_DateTime___get_month1__impl_(utc_0), nlen);
          break;
        case 'MMM':
          tmp_0 = substr(Companion_getInstance_23().get_137(_DateTime___get_month1__impl_(utc_0)).localName_1(this._get_realLocale_()), 0, 3);
          break;
        case 'MMMM':
          tmp_0 = Companion_getInstance_23().get_137(_DateTime___get_month1__impl_(utc_0)).localName_1(this._get_realLocale_());
          break;
        case 'MMMMM':
          tmp_0 = substr(Companion_getInstance_23().get_137(_DateTime___get_month1__impl_(utc_0)).localName_1(this._get_realLocale_()), 0, 1);
          break;
        case 'y':
          tmp_0 = _DateTime___get_yearInt__impl_(utc_0);
          break;
        case 'yy':
          tmp_0 = padded(_DateTime___get_yearInt__impl_(utc_0) % 100, 2);
          break;
        case 'yyy':
          tmp_0 = padded(_DateTime___get_yearInt__impl_(utc_0) % 1000, 3);
          break;
        case 'yyyy':
          tmp_0 = padded(_DateTime___get_yearInt__impl_(utc_0), 4);
          break;
        case 'YYYY':
          tmp_0 = padded(_DateTime___get_yearInt__impl_(utc_0), 4);
          break;
        case 'H':
        case 'HH':
          tmp_0 = padded(mconvertRangeZero(_DateTime___get_hours__impl_(utc_0), 24), nlen);
          break;
        case 'k':
        case 'kk':
          tmp_0 = padded(mconvertRangeNonZero(_DateTime___get_hours__impl_(utc_0), 24), nlen);
          break;
        case 'h':
        case 'hh':
          tmp_0 = padded(mconvertRangeNonZero(_DateTime___get_hours__impl_(utc_0), 12), nlen);
          break;
        case 'K':
        case 'KK':
          tmp_0 = padded(mconvertRangeZero(_DateTime___get_hours__impl_(utc_0), 12), nlen);
          break;
        case 'm':
        case 'mm':
          tmp_0 = padded(_DateTime___get_minutes__impl_(utc_0), nlen);
          break;
        case 's':
        case 'ss':
          tmp_0 = padded(_DateTime___get_seconds__impl_(utc_0), nlen);
          break;
        case 'S':
        case 'SS':
        case 'SSS':
        case 'SSSS':
        case 'SSSSS':
        case 'SSSSSS':
        case 'SSSSSSS':
        case 'SSSSSSSS':
        case 'SSSSSSSSS':
          var milli = _DateTime___get_milliseconds__impl_(utc_0);
          var tmp0_log10_0 = _DateTime___get_milliseconds__impl_(utc_0);
          var base10length = numberToInt(Math.log10(tmp0_log10_0)) + 1 | 0;
          var tmp_1;
          if (base10length > name.length) {
            var tmp_2 = milli;
            var tmp1_pow_0 = 10.0;
            var tmp2_pow_0 = imul(-1, base10length - name.length | 0);
            tmp_1 = numberToInt(tmp_2 * Math.pow(tmp1_pow_0, tmp2_pow_0));
          } else {
            tmp_1 = substr('' + padded(milli, 3) + '000000', 0, name.length);
          }

          tmp_0 = tmp_1;
          break;
        case 'X':
        case 'XX':
        case 'XXX':
        case 'x':
        case 'xx':
        case 'xxx':
          var tmp_3;
          var tmp_4;
          if (startsWith$default_1(name, 'X', false, 2, null)) {
            tmp_4 = _TimezoneOffset___get_totalMinutesInt__impl_(dd._offset) === 0;
          } else {
            {
              tmp_4 = false;
            }
          }

          if (tmp_4) {
            tmp_3 = 'Z';
          } else {
            {
              var p = _TimezoneOffset___get_totalMinutesInt__impl_(dd._offset) >= 0 ? '+' : '-';
              var tmp3__get_absoluteValue__0 = _TimezoneOffset___get_totalMinutesInt__impl_(dd._offset) / 60 | 0;
              var hours = abs(tmp3__get_absoluteValue__0);
              var tmp4__get_absoluteValue__0 = _TimezoneOffset___get_totalMinutesInt__impl_(dd._offset) % 60;
              var minutes = abs(tmp4__get_absoluteValue__0);
              var tmp2_subject = name;
              switch (tmp2_subject) {
                case 'X':
                case 'x':
                  tmp_3 = '' + p + padded(hours, 2);
                  break;
                case 'XX':
                case 'xx':
                  tmp_3 = '' + p + padded(hours, 2) + padded(minutes, 2);
                  break;
                case 'XXX':
                case 'xxx':
                  tmp_3 = '' + p + padded(hours, 2) + ':' + padded(minutes, 2);
                  break;
                default:tmp_3 = name;
                  break;
              }
            }
          }

          tmp_0 = tmp_3;
          break;
        case 'a':
          tmp_0 = _DateTime___get_hours__impl_(utc_0) < 12 ? 'am' : 'pm';
          break;
        default:var tmp_5;
          var tmp_6 = new Char(39);
          if (startsWith$default(name, tmp_6, false, 2, null)) {
            var tmp5_substring_0 = 1;
            var tmp6_substring_0 = name.length - 1 | 0;
            tmp_5 = name.substring(tmp5_substring_0, tmp6_substring_0);
          } else {
            {
              tmp_5 = name;
            }
          }

          tmp_0 = tmp_5;
          break;
      }
      out = tmp + tmp_0;
    }
    return out;
  };
  PatternDateFormat.prototype.toString = function () {
    return this._format;
  };
  PatternDateFormat.prototype.hashCode = function () {
    var result = getStringHashCode(this._format);
    result = imul(result, 31) + (this._locale == null ? 0 : hashCode(this._locale)) | 0;
    result = imul(result, 31) + this._tzNames.hashCode() | 0;
    result = imul(result, 31) + this._options_0.hashCode() | 0;
    return result;
  };
  PatternDateFormat.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PatternDateFormat))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PatternDateFormat ? other : THROW_CCE();
    if (!(this._format === tmp0_other_with_cast._format))
      return false;
    if (!equals_1(this._locale, tmp0_other_with_cast._locale))
      return false;
    if (!this._tzNames.equals(tmp0_other_with_cast._tzNames))
      return false;
    if (!this._options_0.equals(tmp0_other_with_cast._options_0))
      return false;
    return true;
  };
  PatternDateFormat.$metadata$ = {
    simpleName: 'PatternDateFormat',
    kind: 'class',
    interfaces: [DateFormat, Serializable_0]
  };
  function readRepeatedChar(_this_) {
    var start_1 = _this_._offset_0;
    var c_4 = _this_.readChar_0();
    while (_this_._get_hasMore__0() ? _this_.tryRead(c_4) : false)
      Unit_getInstance();
    var end_2 = _this_._offset_0;
    var tmp0_substring_0 = _this_._str;
    return tmp0_substring_0.substring(start_1, end_2);
  }
  function mconvertRangeZero(value, size_1) {
    return umod(value, size_1);
  }
  function mconvertRangeNonZero(value, size_1) {
    var res = umod(value, size_1);
    return res === 0 ? size_1 : res;
  }
  function PerformanceCounter() {
    PerformanceCounter_instance = this;
  }
  PerformanceCounter.prototype._get_microseconds_ = function () {
    return _HRTimeSpan___get_microsecondsDouble__impl_(KlockInternal_getInstance()._get_hrNow_());
  };
  PerformanceCounter.prototype._get_reference_ = function () {
    return _get_timeSpan_(KlockInternal_getInstance()._get_hrNow_());
  };
  PerformanceCounter.$metadata$ = {
    simpleName: 'PerformanceCounter',
    kind: 'object',
    interfaces: []
  };
  var PerformanceCounter_instance;
  function PerformanceCounter_getInstance() {
    if (PerformanceCounter_instance == null)
      new PerformanceCounter();
    return PerformanceCounter_instance;
  }
  function Companion_27() {
    Companion_instance_26 = this;
  }
  Companion_27.prototype.now_2 = function () {
    return Companion_getInstance_18().now_2();
  };
  Companion_27.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: [TimeProvider]
  };
  var Companion_instance_26;
  function Companion_getInstance_26() {
    if (Companion_instance_26 == null)
      new Companion_27();
    return Companion_instance_26;
  }
  function TimeProvider() {
  }
  TimeProvider.$metadata$ = {
    simpleName: 'TimeProvider',
    kind: 'interface',
    interfaces: []
  };
  function _TimeSpan___init__impl_(milliseconds) {
    return milliseconds;
  }
  function _TimeSpan___get_milliseconds__impl_(this_0) {
    return this_0;
  }
  function _TimeSpan___get_nanoseconds__impl_(this_0) {
    return _TimeSpan___get_milliseconds__impl_(this_0) / 1.0E-6;
  }
  function _TimeSpan___get_microsecondsInt__impl_(this_0) {
    return numberToInt(_TimeSpan___get_milliseconds__impl_(this_0) / 0.001);
  }
  function _TimeSpan___get_seconds__impl_(this_0) {
    return _TimeSpan___get_milliseconds__impl_(this_0) / 1000;
  }
  function _TimeSpan___get_millisecondsLong__impl_(this_0) {
    return numberToLong(_TimeSpan___get_milliseconds__impl_(this_0));
  }
  function TimeSpan__compareTo_impl(this_0, other) {
    return compareTo(_TimeSpan___get_milliseconds__impl_(this_0), _TimeSpan___get_milliseconds__impl_(other));
  }
  function TimeSpan__compareTo_impl_0(this_0, other) {
    var tmp = this_0._milliseconds;
    return TimeSpan__compareTo_impl(tmp, other instanceof TimeSpan ? other._milliseconds : THROW_CCE());
  }
  function TimeSpan__unaryMinus_impl(this_0) {
    return _TimeSpan___init__impl_(-_TimeSpan___get_milliseconds__impl_(this_0));
  }
  function TimeSpan__plus_impl(this_0, other) {
    return _TimeSpan___init__impl_(_TimeSpan___get_milliseconds__impl_(this_0) + _TimeSpan___get_milliseconds__impl_(other));
  }
  function TimeSpan__minus_impl(this_0, other) {
    return TimeSpan__plus_impl(this_0, TimeSpan__unaryMinus_impl(other));
  }
  function TimeSpan__times_impl(this_0, scale_1) {
    return _TimeSpan___init__impl_(_TimeSpan___get_milliseconds__impl_(this_0) * scale_1);
  }
  function TimeSpan__times_impl_0(this_0, scale_1) {
    return _TimeSpan___init__impl_(_TimeSpan___get_milliseconds__impl_(this_0) * scale_1);
  }
  function TimeSpan__div_impl(this_0, scale_1) {
    return _TimeSpan___init__impl_(_TimeSpan___get_milliseconds__impl_(this_0) / scale_1);
  }
  function TimeSpan__div_impl_0(this_0, other) {
    return _TimeSpan___get_milliseconds__impl_(this_0) / _TimeSpan___get_milliseconds__impl_(other);
  }
  function Companion_28() {
    Companion_instance_27 = this;
    this._serialVersionUID_9 = new Long(1, 0);
    this._MILLIS_PER_MICROSECOND = 0.001;
    this._MILLIS_PER_NANOSECOND = 1.0E-6;
    this._ZERO = _TimeSpan___init__impl_(0.0);
    this._NIL = _TimeSpan___init__impl_(NaN);
    this._timeSteps = listOf([60, 60, 24]);
  }
  Companion_28.prototype.fromMilliseconds = function (ms) {
    var tmp0_subject = ms;
    return tmp0_subject === 0.0 ? this._ZERO : _TimeSpan___init__impl_(ms);
  };
  Companion_28.prototype.fromNanoseconds = function (s) {
    return this.fromMilliseconds(s * 1.0E-6);
  };
  Companion_28.prototype.fromMicroseconds = function (s) {
    return this.fromMilliseconds(s * 0.001);
  };
  Companion_28.prototype.fromSeconds = function (s) {
    return this.fromMilliseconds(s * 1000);
  };
  Companion_28.prototype.fromMinutes = function (s) {
    return this.fromMilliseconds(s * 60000);
  };
  Companion_28.prototype.fromHours = function (s) {
    return this.fromMilliseconds(s * 3600000);
  };
  Companion_28.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_27;
  function Companion_getInstance_27() {
    if (Companion_instance_27 == null)
      new Companion_28();
    return Companion_instance_27;
  }
  function TimeSpan__toString_impl(this_0) {
    return '' + _get_niceStr_(_TimeSpan___get_milliseconds__impl_(this_0)) + 'ms';
  }
  function TimeSpan__hashCode_impl(this_0) {
    return getNumberHashCode(this_0);
  }
  function TimeSpan__equals_impl(this_0, other) {
    if (!(other instanceof TimeSpan))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TimeSpan ? other._milliseconds : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function TimeSpan(milliseconds) {
    Companion_getInstance_27();
    this._milliseconds = milliseconds;
  }
  TimeSpan.prototype.compareTo_23 = function (other) {
    return TimeSpan__compareTo_impl(this._milliseconds, other);
  };
  TimeSpan.prototype.compareTo_71 = function (other) {
    return TimeSpan__compareTo_impl_0(this, other);
  };
  TimeSpan.prototype.toString = function () {
    return TimeSpan__toString_impl(this._milliseconds);
  };
  TimeSpan.prototype.hashCode = function () {
    return TimeSpan__hashCode_impl(this._milliseconds);
  };
  TimeSpan.prototype.equals = function (other) {
    return TimeSpan__equals_impl(this._milliseconds, other);
  };
  TimeSpan.$metadata$ = {
    simpleName: 'TimeSpan',
    kind: 'class',
    interfaces: [Comparable, Serializable_0]
  };
  function clamp(_this_, min, max) {
    return TimeSpan__compareTo_impl(_this_, min) < 0 ? min : TimeSpan__compareTo_impl(_this_, max) > 0 ? max : _this_;
  }
  function TimezoneNames_init_$Init$(tz, $this) {
    TimezoneNames.call($this, toMap(tz));
    return $this;
  }
  function TimezoneNames_init_$Create$(tz) {
    return TimezoneNames_init_$Init$(tz, Object.create(TimezoneNames.prototype));
  }
  function Companion_29() {
    Companion_instance_28 = this;
    this._serialVersionUID_10 = new Long(1, 0);
    var tmp = this;
    var tmp0__get_hours__0 = -7;
    var tmp_0 = to('PDT', new TimeSpan(Companion_getInstance_27().fromHours(tmp0__get_hours__0)));
    var tmp1__get_hours__0 = -8;
    var tmp_1 = to('PST', new TimeSpan(Companion_getInstance_27().fromHours(tmp1__get_hours__0)));
    var tmp2__get_hours__0 = 0;
    var tmp_2 = to('GMT', new TimeSpan(Companion_getInstance_27().fromHours(tmp2__get_hours__0)));
    var tmp3__get_hours__0 = 0;
    tmp._DEFAULT_0 = TimezoneNames_init_$Create$([tmp_0, tmp_1, tmp_2, to('UTC', new TimeSpan(Companion_getInstance_27().fromHours(tmp3__get_hours__0)))]);
  }
  Companion_29.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_28;
  function Companion_getInstance_28() {
    if (Companion_instance_28 == null)
      new Companion_29();
    return Companion_instance_28;
  }
  function TimezoneNames(namesToOffsets) {
    Companion_getInstance_28();
    this._namesToOffsets = namesToOffsets;
  }
  TimezoneNames.prototype.toString = function () {
    return '' + 'TimezoneNames(namesToOffsets=' + this._namesToOffsets + ')';
  };
  TimezoneNames.prototype.hashCode = function () {
    return hashCode(this._namesToOffsets);
  };
  TimezoneNames.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TimezoneNames))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TimezoneNames ? other : THROW_CCE();
    if (!equals_1(this._namesToOffsets, tmp0_other_with_cast._namesToOffsets))
      return false;
    return true;
  };
  TimezoneNames.$metadata$ = {
    simpleName: 'TimezoneNames',
    kind: 'class',
    interfaces: [Serializable_0]
  };
  function _TimezoneOffset___init__impl_(totalMilliseconds) {
    return totalMilliseconds;
  }
  function _TimezoneOffset___get_totalMilliseconds__impl_(this_0) {
    return this_0;
  }
  function _TimezoneOffset___get_positive__impl_(this_0) {
    return _TimezoneOffset___get_totalMilliseconds__impl_(this_0) >= 0.0;
  }
  function _TimezoneOffset___get_time__impl_(this_0) {
    var tmp0__get_milliseconds__0 = _TimezoneOffset___get_totalMilliseconds__impl_(this_0);
    return Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0);
  }
  function _TimezoneOffset___get_totalMinutes__impl_(this_0) {
    return _TimezoneOffset___get_totalMilliseconds__impl_(this_0) / 60000;
  }
  function _TimezoneOffset___get_totalMinutesInt__impl_(this_0) {
    return numberToInt(_TimezoneOffset___get_totalMinutes__impl_(this_0));
  }
  function _TimezoneOffset___get_timeZone__impl_(this_0) {
    var sign = _TimezoneOffset___get_positive__impl_(this_0) ? '+' : '-';
    var hour = padded(_TimezoneOffset___get_deltaHoursAbs__impl_(this_0), 2);
    var minute = padded(_TimezoneOffset___get_deltaMinutesAbs__impl_(this_0), 2);
    var tmp;
    var tmp_0 = new TimeSpan(_TimezoneOffset___get_time__impl_(this_0));
    var tmp0__get_minutes__0 = 0;
    if (equals_1(tmp_0, new TimeSpan(Companion_getInstance_27().fromMinutes(tmp0__get_minutes__0)))) {
      tmp = 'UTC';
    } else {
      {
        tmp = '' + 'GMT' + sign + hour + minute;
      }
    }
    return tmp;
  }
  function _get_deltaTotalMinutesAbs_($this) {
    return abs(numberToInt(_TimezoneOffset___get_totalMinutes__impl_($this)));
  }
  function _TimezoneOffset___get_deltaHoursAbs__impl_(this_0) {
    return _get_deltaTotalMinutesAbs_(this_0) / 60 | 0;
  }
  function _TimezoneOffset___get_deltaMinutesAbs__impl_(this_0) {
    return _get_deltaTotalMinutesAbs_(this_0) % 60;
  }
  function Companion_30() {
    Companion_instance_29 = this;
    this._serialVersionUID_11 = new Long(1, 0);
  }
  Companion_30.prototype.invoke_70 = function (time) {
    return _TimezoneOffset___init__impl_(_TimeSpan___get_milliseconds__impl_(time));
  };
  Companion_30.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_29;
  function Companion_getInstance_29() {
    if (Companion_instance_29 == null)
      new Companion_30();
    return Companion_instance_29;
  }
  function _get_offset_(_this_) {
    return Companion_getInstance_29().invoke_70(_this_);
  }
  function _Year___init__impl_(year) {
    return year;
  }
  function _Year___get_year__impl_(this_0) {
    return this_0;
  }
  function Companion_31() {
    Companion_instance_30 = this;
    this._serialVersionUID_12 = new Long(1, 0);
    this._DAYS_COMMON = 365;
    this._DAYS_LEAP = 366;
    this._LEAP_PER_4_YEARS = 1;
    this._LEAP_PER_100_YEARS = 24;
    this._LEAP_PER_400_YEARS = 97;
    this._DAYS_PER_4_YEARS = 1461;
    this._DAYS_PER_100_YEARS = 36524;
    this._DAYS_PER_400_YEARS = 146097;
  }
  Companion_31.prototype.isLeap = function (year) {
    return year % 4 === 0 ? !(year % 100 === 0) ? true : year % 400 === 0 : false;
  };
  Companion_31.prototype.fromDays = function (days) {
    var v400 = days / 146097 | 0;
    var r400 = days - imul(v400, 146097) | 0;
    var tmp0_min_0 = r400 / 36524 | 0;
    var tmp1_min_0 = 3;
    var v100 = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_min_0, tmp1_min_0]))));
    }.call(this);
    var r100 = r400 - imul(v100, 36524) | 0;
    var v4 = r100 / 1461 | 0;
    var r4 = r100 - imul(v4, 1461) | 0;
    var tmp2_min_0 = r4 / 365 | 0;
    var tmp3_min_0 = 3;
    var v1 = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp2_min_0, tmp3_min_0]))));
    }.call(this);
    var extra = days < 0 ? 0 : 1;
    return _Year___init__impl_((((extra + v1 | 0) + imul(v4, 4) | 0) + imul(v100, 100) | 0) + imul(v400, 400) | 0);
  };
  Companion_31.prototype.days_2 = function (isLeap) {
    return isLeap ? 366 : 365;
  };
  Companion_31.prototype.leapCountSinceOne = function (year) {
    if (year < 1) {
      var leapCount = 0;
      var y = 1;
      while (y >= year) {
        if (_Year___get_isLeap__impl_(_Year___init__impl_(y))) {
          var tmp0 = leapCount;
          leapCount = tmp0 - 1 | 0;
          Unit_getInstance();
        }var tmp1 = y;
        y = tmp1 - 1 | 0;
        Unit_getInstance();
      }
      return leapCount;
    }var y1 = year - 1 | 0;
    var res = ((y1 / 4 | 0) - (y1 / 100 | 0) | 0) + (y1 / 400 | 0) | 0;
    return res;
  };
  Companion_31.prototype.daysSinceOne = function (year) {
    return imul(365, year - 1 | 0) + this.leapCountSinceOne(year) | 0;
  };
  Companion_31.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_30;
  function Companion_getInstance_30() {
    if (Companion_instance_30 == null)
      new Companion_31();
    return Companion_instance_30;
  }
  function _Year___get_isLeap__impl_(this_0) {
    return Companion_getInstance_30().isLeap(_Year___get_year__impl_(this_0));
  }
  function _Year___get_days__impl_(this_0) {
    return Companion_getInstance_30().days_2(_Year___get_isLeap__impl_(this_0));
  }
  function _Year___get_daysSinceOne__impl_(this_0) {
    return Companion_getInstance_30().daysSinceOne(_Year___get_year__impl_(this_0));
  }
  function Year__plus_impl(this_0, delta_0) {
    return _Year___init__impl_(_Year___get_year__impl_(this_0) + delta_0 | 0);
  }
  function _HRTimeSpan___init__impl_(nanosecondsRaw) {
    return nanosecondsRaw;
  }
  function _HRTimeSpan___get_nanosecondsRaw__impl_(this_0) {
    return this_0;
  }
  function Companion_32() {
    Companion_instance_31 = this;
    this._ZERO_0 = _HRTimeSpan___init__impl_(0.0);
    this._NIL_0 = _HRTimeSpan___init__impl_(NaN);
  }
  Companion_32.prototype.fromSeconds_0 = function (value) {
    return _HRTimeSpan___init__impl_(round(value * 1000000000));
  };
  Companion_32.prototype.fromMilliseconds_0 = function (value) {
    return _HRTimeSpan___init__impl_(round(value * 1000000));
  };
  Companion_32.prototype.fromNanoseconds_0 = function (value) {
    return _HRTimeSpan___init__impl_(round(value));
  };
  Companion_32.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_31;
  function Companion_getInstance_31() {
    if (Companion_instance_31 == null)
      new Companion_32();
    return Companion_instance_31;
  }
  function _HRTimeSpan___get_microsecondsDouble__impl_(this_0) {
    return _HRTimeSpan___get_nanosecondsRaw__impl_(this_0) / 1000;
  }
  function HRTimeSpan__plus_impl(this_0, other) {
    return Companion_getInstance_31().fromNanoseconds_0(_HRTimeSpan___get_nanosecondsRaw__impl_(this_0) + _HRTimeSpan___get_nanosecondsRaw__impl_(other));
  }
  function _get_timeSpan_(_this_) {
    var tmp0__get_nanoseconds__0 = _HRTimeSpan___get_nanosecondsRaw__impl_(_this_);
    return Companion_getInstance_27().fromNanoseconds(tmp0__get_nanoseconds__0);
  }
  function increment(_this_, key) {
    var value_1 = _this_.get_116(key);
    if (value_1 == null) {
      var answer_2 = 0;
      _this_.put_18(key, answer_2);
      Unit_getInstance();
    } else {
    }
    Unit_getInstance();
    var tmp0_set_0 = ensureNotNull(_this_.get_116(key)) + 1 | 0;
    _this_.put_18(key, tmp0_set_0);
    Unit_getInstance();
  }
  function MicroStrReader_init_$Init$(str, offset, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    MicroStrReader.call($this, str, offset);
    return $this;
  }
  function MicroStrReader_init_$Create$(str, offset, $mask0, $marker) {
    return MicroStrReader_init_$Init$(str, offset, $mask0, $marker, Object.create(MicroStrReader.prototype));
  }
  function MicroStrReader(str, offset) {
    this._str = str;
    this._offset_0 = offset;
  }
  MicroStrReader.prototype._get_available__3 = function () {
    return this._str.length - this._offset_0 | 0;
  };
  MicroStrReader.prototype._get_hasMore__0 = function () {
    return this._offset_0 < this._str.length;
  };
  MicroStrReader.prototype._get_eof__0 = function () {
    return !this._get_hasMore__0();
  };
  MicroStrReader.prototype.peekChar_0 = function () {
    return charSequenceGet(this._str, this._offset_0);
  };
  MicroStrReader.prototype.readChar_0 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._offset_0;
    tmp0_this._offset_0 = tmp1 + 1 | 0;
    return charSequenceGet(this._str, tmp1);
  };
  MicroStrReader.prototype.tryRead = function (expected) {
    if (this._get_eof__0() ? true : !this.peekChar_0().equals(expected))
      return false;
    this.readChar_0();
    Unit_getInstance();
    return true;
  };
  MicroStrReader.prototype.tryReadOrNull = function (expected) {
    return this.tryRead_1(expected) ? expected : null;
  };
  MicroStrReader.prototype.tryRead_1 = function (expected) {
    if (expected.length > this._get_available__3())
      return false;
    var inductionVariable = 0;
    var last_1 = charSequenceLength(expected) - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!charSequenceGet(this._str, this._offset_0 + n | 0).equals(charSequenceGet(expected, n)))
          return false;
      }
       while (inductionVariable <= last_1);
    var tmp1_this = this;
    tmp1_this._offset_0 = tmp1_this._offset_0 + expected.length | 0;
    return true;
  };
  MicroStrReader.$metadata$ = {
    simpleName: 'MicroStrReader',
    kind: 'class',
    interfaces: []
  };
  function _get_niceStr_(_this_) {
    var tmp;
    var tmp0_unsafeCast_0_1 = Math.floor(_this_);
    if (tmp0_unsafeCast_0_1 === _this_) {
      tmp = '' + numberToInt(_this_);
    } else {
      {
        tmp = '' + _this_;
      }
    }
    return tmp;
  }
  function substr(_this_, start, length) {
    var low = clamp_0(start >= 0 ? start : _this_.length + start | 0, 0, _this_.length);
    var high = clamp_0(length >= 0 ? low + length | 0 : _this_.length + length | 0, 0, _this_.length);
    var tmp;
    if (high < low) {
      tmp = '';
    } else {
      tmp = _this_.substring(low, high);
    }
    return tmp;
  }
  function padded(_this_, count_0) {
    var res = padStart(abs(_this_).toString(), count_0, new Char(48));
    var tmp;
    if (_this_ < 0) {
      return '' + '-' + res;
    } else {
      tmp = res;
    }
    return tmp;
  }
  function umod(_this_, that) {
    var remainder = _this_ % that;
    return remainder < 0 ? remainder + that | 0 : remainder;
  }
  function clamp_0(_this_, min, max) {
    return _this_ < min ? min : _this_ > max ? max : _this_;
  }
  function cycleSteps(_this_, min, max) {
    return (_this_ - min | 0) / ((max - min | 0) + 1 | 0) | 0;
  }
  function cycle(_this_, min, max) {
    return umod(_this_ - min | 0, (max - min | 0) + 1 | 0) + min | 0;
  }
  function toInt2(_this_) {
    var tmp;
    if (_this_ < 0.0) {
      var tmp0_unsafeCast_0_1 = Math.floor(_this_);
      tmp = numberToInt(tmp0_unsafeCast_0_1);
    } else {
      tmp = numberToInt(_this_);
    }
    return tmp;
  }
  function toIntMod(_this_, mod_1) {
    return toInt2(umod_0(_this_, mod_1));
  }
  function umod_0(_this_, that) {
    var remainder = _this_ % that;
    return remainder < 0.0 ? remainder + that : remainder;
  }
  var ExtendedTimezoneNames;
  function utc(hours, minutes) {
    var tmp = Companion_getInstance_27().fromHours(hours);
    return TimeSpan__plus_impl(tmp, Companion_getInstance_27().fromMinutes(minutes));
  }
  function utc$default(hours, minutes, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      minutes = 0;
    return utc(hours, minutes);
  }
  function ExtendedTimezoneNames$init$() {
    var tmp = to('ACDT', new TimeSpan(utc(10, 30)));
    var tmp_0 = to('ACST', new TimeSpan(utc(9, 30)));
    var tmp_1 = to('ACT', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_2 = to('ACWST', new TimeSpan(utc(8, 45)));
    var tmp_3 = to('ADT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_4 = to('AEDT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_5 = to('AEST', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_6 = to('AFT', new TimeSpan(utc(4, 30)));
    var tmp_7 = to('AKDT', new TimeSpan(utc$default(-8, 0, 2, null)));
    var tmp_8 = to('AKST', new TimeSpan(utc$default(-9, 0, 2, null)));
    var tmp_9 = to('ALMT', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_10 = to('AMST', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_11 = to('AMT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_12 = to('AMT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_13 = to('ANAT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_14 = to('AQTT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_15 = to('ART', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_16 = to('AST', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_17 = to('AST', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_18 = to('AWST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_19 = to('AZOST', new TimeSpan(utc$default(0, 0, 2, null)));
    var tmp_20 = to('AZOT', new TimeSpan(utc$default(-1, 0, 2, null)));
    var tmp_21 = to('AZT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_22 = to('BDT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_23 = to('BIOT', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_24 = to('BIT', new TimeSpan(utc$default(-12, 0, 2, null)));
    var tmp_25 = to('BOT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_26 = to('BRST', new TimeSpan(utc$default(-2, 0, 2, null)));
    var tmp_27 = to('BRT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_28 = to('BST', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_29 = to('BST', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_30 = to('BST', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_31 = to('BTT', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_32 = to('CAT', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_33 = to('CCT', new TimeSpan(utc(6, 30)));
    var tmp_34 = to('CDT', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_35 = to('CDT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_36 = to('CEST', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_37 = to('CET', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_38 = to('CHADT', new TimeSpan(utc(13, 45)));
    var tmp_39 = to('CHAST', new TimeSpan(utc(12, 45)));
    var tmp_40 = to('CHOT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_41 = to('CHOST', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_42 = to('CHST', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_43 = to('CHUT', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_44 = to('CIST', new TimeSpan(utc$default(-8, 0, 2, null)));
    var tmp_45 = to('CIT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_46 = to('CKT', new TimeSpan(utc$default(-10, 0, 2, null)));
    var tmp_47 = to('CLST', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_48 = to('CLT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_49 = to('COST', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_50 = to('COT', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_51 = to('CST', new TimeSpan(utc$default(-6, 0, 2, null)));
    var tmp_52 = to('CST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_53 = to('CST', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_54 = to('CT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_55 = to('CVT', new TimeSpan(utc$default(-1, 0, 2, null)));
    var tmp_56 = to('CWST', new TimeSpan(utc(8, 45)));
    var tmp_57 = to('CXT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_58 = to('DAVT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_59 = to('DDUT', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_60 = to('DFT', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_61 = to('EASST', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_62 = to('EAST', new TimeSpan(utc$default(-6, 0, 2, null)));
    var tmp_63 = to('EAT', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_64 = to('ECT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_65 = to('ECT', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_66 = to('EDT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_67 = to('EEST', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_68 = to('EET', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_69 = to('EGST', new TimeSpan(utc$default(0, 0, 2, null)));
    var tmp_70 = to('EGT', new TimeSpan(utc$default(-1, 0, 2, null)));
    var tmp_71 = to('EIT', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_72 = to('EST', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_73 = to('FET', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_74 = to('FJT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_75 = to('FKST', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_76 = to('FKT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_77 = to('FNT', new TimeSpan(utc$default(-2, 0, 2, null)));
    var tmp_78 = to('GALT', new TimeSpan(utc$default(-6, 0, 2, null)));
    var tmp_79 = to('GAMT', new TimeSpan(utc$default(-9, 0, 2, null)));
    var tmp_80 = to('GET', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_81 = to('GFT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_82 = to('GILT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_83 = to('GIT', new TimeSpan(utc$default(-9, 0, 2, null)));
    var tmp_84 = to('GMT', new TimeSpan(utc$default(0, 0, 2, null)));
    var tmp_85 = to('GST', new TimeSpan(utc$default(-2, 0, 2, null)));
    var tmp_86 = to('GST', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_87 = to('GYT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_88 = to('HDT', new TimeSpan(utc$default(-9, 0, 2, null)));
    var tmp_89 = to('HAEC', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_90 = to('HST', new TimeSpan(utc$default(-10, 0, 2, null)));
    var tmp_91 = to('HKT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_92 = to('HMT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_93 = to('HOVST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_94 = to('HOVT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_95 = to('ICT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_96 = to('IDLW', new TimeSpan(utc$default(-12, 0, 2, null)));
    var tmp_97 = to('IDT', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_98 = to('IOT', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_99 = to('IRDT', new TimeSpan(utc(4, 30)));
    var tmp_100 = to('IRKT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_101 = to('IRST', new TimeSpan(utc(3, 30)));
    var tmp_102 = to('IST', new TimeSpan(utc(5, 30)));
    var tmp_103 = to('IST', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_104 = to('IST', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_105 = to('JST', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_106 = to('KALT', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_107 = to('KGT', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_108 = to('KOST', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_109 = to('KRAT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_110 = to('KST', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_111 = to('LHST', new TimeSpan(utc(10, 30)));
    var tmp_112 = to('LHST', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_113 = to('LINT', new TimeSpan(utc$default(14, 0, 2, null)));
    var tmp_114 = to('MAGT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_115 = to('MART', new TimeSpan(utc(-9, 30)));
    var tmp_116 = to('MAWT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_117 = to('MDT', new TimeSpan(utc$default(-6, 0, 2, null)));
    var tmp_118 = to('MET', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_119 = to('MEST', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_120 = to('MHT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_121 = to('MIST', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_122 = to('MIT', new TimeSpan(utc(-9, 30)));
    var tmp_123 = to('MMT', new TimeSpan(utc(6, 30)));
    var tmp_124 = to('MSK', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_125 = to('MST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_126 = to('MST', new TimeSpan(utc$default(-7, 0, 2, null)));
    var tmp_127 = to('MUT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_128 = to('MVT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_129 = to('MYT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_130 = to('NCT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_131 = to('NDT', new TimeSpan(utc(-2, 30)));
    var tmp_132 = to('NFT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_133 = to('NOVT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_134 = to('NPT', new TimeSpan(utc(5, 45)));
    var tmp_135 = to('NST', new TimeSpan(utc(-3, 30)));
    var tmp_136 = to('NT', new TimeSpan(utc(-3, 30)));
    var tmp_137 = to('NUT', new TimeSpan(utc$default(-11, 0, 2, null)));
    var tmp_138 = to('NZDT', new TimeSpan(utc$default(13, 0, 2, null)));
    var tmp_139 = to('NZST', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_140 = to('OMST', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_141 = to('ORAT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_142 = to('PDT', new TimeSpan(utc$default(-7, 0, 2, null)));
    var tmp_143 = to('PET', new TimeSpan(utc$default(-5, 0, 2, null)));
    var tmp_144 = to('PETT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_145 = to('PGT', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_146 = to('PHOT', new TimeSpan(utc$default(13, 0, 2, null)));
    var tmp_147 = to('PHT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_148 = to('PKT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_149 = to('PMDT', new TimeSpan(utc$default(-2, 0, 2, null)));
    var tmp_150 = to('PMST', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_151 = to('PONT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_152 = to('PST', new TimeSpan(utc$default(-8, 0, 2, null)));
    var tmp_153 = to('PST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_154 = to('PYST', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_155 = to('PYT', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_156 = to('RET', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_157 = to('ROTT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_158 = to('SAKT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_159 = to('SAMT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_160 = to('SAST', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_161 = to('SBT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_162 = to('SCT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_163 = to('SDT', new TimeSpan(utc$default(-10, 0, 2, null)));
    var tmp_164 = to('SGT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_165 = to('SLST', new TimeSpan(utc(5, 30)));
    var tmp_166 = to('SRET', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_167 = to('SRT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_168 = to('SST', new TimeSpan(utc$default(-11, 0, 2, null)));
    var tmp_169 = to('SST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_170 = to('SYOT', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_171 = to('TAHT', new TimeSpan(utc$default(-10, 0, 2, null)));
    var tmp_172 = to('THA', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_173 = to('TFT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_174 = to('TJT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_175 = to('TKT', new TimeSpan(utc$default(13, 0, 2, null)));
    var tmp_176 = to('TLT', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_177 = to('TMT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_178 = to('TRT', new TimeSpan(utc$default(3, 0, 2, null)));
    var tmp_179 = to('TOT', new TimeSpan(utc$default(13, 0, 2, null)));
    var tmp_180 = to('TVT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_181 = to('ULAST', new TimeSpan(utc$default(9, 0, 2, null)));
    var tmp_182 = to('ULAT', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_183 = to('UTC', new TimeSpan(utc$default(0, 0, 2, null)));
    var tmp_184 = to('UYST', new TimeSpan(utc$default(-2, 0, 2, null)));
    var tmp_185 = to('UYT', new TimeSpan(utc$default(-3, 0, 2, null)));
    var tmp_186 = to('UZT', new TimeSpan(utc$default(5, 0, 2, null)));
    var tmp_187 = to('VET', new TimeSpan(utc$default(-4, 0, 2, null)));
    var tmp_188 = to('VLAT', new TimeSpan(utc$default(10, 0, 2, null)));
    var tmp_189 = to('VOLT', new TimeSpan(utc$default(4, 0, 2, null)));
    var tmp_190 = to('VOST', new TimeSpan(utc$default(6, 0, 2, null)));
    var tmp_191 = to('VUT', new TimeSpan(utc$default(11, 0, 2, null)));
    var tmp_192 = to('WAKT', new TimeSpan(utc$default(12, 0, 2, null)));
    var tmp_193 = to('WAST', new TimeSpan(utc$default(2, 0, 2, null)));
    var tmp_194 = to('WAT', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_195 = to('WEST', new TimeSpan(utc$default(1, 0, 2, null)));
    var tmp_196 = to('WET', new TimeSpan(utc$default(0, 0, 2, null)));
    var tmp_197 = to('WIT', new TimeSpan(utc$default(7, 0, 2, null)));
    var tmp_198 = to('WST', new TimeSpan(utc$default(8, 0, 2, null)));
    var tmp_199 = to('YAKT', new TimeSpan(utc$default(9, 0, 2, null)));
    return TimezoneNames_init_$Create$([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, tmp_49, tmp_50, tmp_51, tmp_52, tmp_53, tmp_54, tmp_55, tmp_56, tmp_57, tmp_58, tmp_59, tmp_60, tmp_61, tmp_62, tmp_63, tmp_64, tmp_65, tmp_66, tmp_67, tmp_68, tmp_69, tmp_70, tmp_71, tmp_72, tmp_73, tmp_74, tmp_75, tmp_76, tmp_77, tmp_78, tmp_79, tmp_80, tmp_81, tmp_82, tmp_83, tmp_84, tmp_85, tmp_86, tmp_87, tmp_88, tmp_89, tmp_90, tmp_91, tmp_92, tmp_93, tmp_94, tmp_95, tmp_96, tmp_97, tmp_98, tmp_99, tmp_100, tmp_101, tmp_102, tmp_103, tmp_104, tmp_105, tmp_106, tmp_107, tmp_108, tmp_109, tmp_110, tmp_111, tmp_112, tmp_113, tmp_114, tmp_115, tmp_116, tmp_117, tmp_118, tmp_119, tmp_120, tmp_121, tmp_122, tmp_123, tmp_124, tmp_125, tmp_126, tmp_127, tmp_128, tmp_129, tmp_130, tmp_131, tmp_132, tmp_133, tmp_134, tmp_135, tmp_136, tmp_137, tmp_138, tmp_139, tmp_140, tmp_141, tmp_142, tmp_143, tmp_144, tmp_145, tmp_146, tmp_147, tmp_148, tmp_149, tmp_150, tmp_151, tmp_152, tmp_153, tmp_154, tmp_155, tmp_156, tmp_157, tmp_158, tmp_159, tmp_160, tmp_161, tmp_162, tmp_163, tmp_164, tmp_165, tmp_166, tmp_167, tmp_168, tmp_169, tmp_170, tmp_171, tmp_172, tmp_173, tmp_174, tmp_175, tmp_176, tmp_177, tmp_178, tmp_179, tmp_180, tmp_181, tmp_182, tmp_183, tmp_184, tmp_185, tmp_186, tmp_187, tmp_188, tmp_189, tmp_190, tmp_191, tmp_192, tmp_193, tmp_194, tmp_195, tmp_196, tmp_197, tmp_198, tmp_199, to('YEKT', new TimeSpan(utc$default(5, 0, 2, null)))]);
  }
  var klockIsKotlinNative;
  function klockLazyOrGet(initializer) {
    return lazy(initializer);
  }
  function klockAtomicLazy(initializer) {
    return lazy(initializer);
  }
  var isNode;
  function _get_initialHrTime_() {
    var tmp0_getValue_0 = initialHrTime$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = initialHrTime$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var initialHrTime$delegate;
  function Serializable_0() {
  }
  Serializable_0.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function KlockInternal() {
    KlockInternal_instance = this;
  }
  KlockInternal.prototype._get_currentTime_ = function () {
    var tmp0_unsafeCast_0 = Date.now();
    return tmp0_unsafeCast_0;
  };
  KlockInternal.prototype._get_hrNow_ = function () {
    var tmp;
    if (isNode) {
      var tmp0_unsafeCast_0 = process.hrtime(_get_initialHrTime_());
      var result = tmp0_unsafeCast_0;
      tmp = HRTimeSpan__plus_impl(Companion_getInstance_31().fromSeconds_0(result[0]), Companion_getInstance_31().fromNanoseconds_0(result[1]));
    } else {
      tmp = Companion_getInstance_31().fromMilliseconds_0(window.performance.now());
    }
    return tmp;
  };
  KlockInternal.$metadata$ = {
    simpleName: 'KlockInternal',
    kind: 'object',
    interfaces: []
  };
  var KlockInternal_instance;
  function KlockInternal_getInstance() {
    if (KlockInternal_instance == null)
      new KlockInternal();
    return KlockInternal_instance;
  }
  function _no_name_provided__47() {
  }
  _no_name_provided__47.prototype.invoke_1005 = function () {
    return process.hrtime();
  };
  _no_name_provided__47.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function initialHrTime$factory() {
    return getPropertyCallableRef('initialHrTime', 0, KProperty0, function () {
      return _get_initialHrTime_();
    }, null);
  }
  function _no_name_provided_$factory_34() {
    var i = new _no_name_provided__47();
    return function () {
      return i.invoke_1005();
    };
  }
  function ByteArrayDeque_init_$Init$(initialBits, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialBits = 10;
    ByteArrayDeque.call($this, initialBits);
    return $this;
  }
  function ByteArrayDeque_init_$Create$(initialBits, $mask0, $marker) {
    return ByteArrayDeque_init_$Init$(initialBits, $mask0, $marker, Object.create(ByteArrayDeque.prototype));
  }
  function ensureWrite($this, count_0) {
    if (count_0 > $this._ring._get_availableWrite__0()) {
      var minNewSize = $this._ring._get_availableRead__4() + count_0 | 0;
      var newBits = ilog2(minNewSize) + 2 | 0;
      var newRing = new RingBuffer(newBits);
      while ($this._ring._get_availableRead__4() > 0) {
        var read_1 = $this._ring.read_30($this._tempBuffer, 0, $this._tempBuffer.length);
        newRing.write_6($this._tempBuffer, 0, read_1);
        Unit_getInstance();
      }
      $this._ring = newRing;
    }return $this;
  }
  function ByteArrayDeque(initialBits) {
    this._initialBits = initialBits;
    this._ring = new RingBuffer(this._initialBits);
    this._tempBuffer = new Int8Array(1024);
    this._written = new Long(0, 0);
    this._read = new Long(0, 0);
  }
  ByteArrayDeque.prototype._get_availableRead__4 = function () {
    return this._ring._get_availableRead__4();
  };
  ByteArrayDeque.prototype.write_6 = function (buffer, offset, size_1) {
    var out = ensureWrite(this, size_1)._ring.write_6(buffer, offset, size_1);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._written;
      tmp._written = tmp0_plus_0.plus_64(toLong(out));
    }return out;
  };
  ByteArrayDeque.prototype.read_30 = function (buffer, offset, size_1) {
    var out = this._ring.read_30(buffer, offset, size_1);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._read;
      tmp._read = tmp0_plus_0.plus_64(toLong(out));
    }return out;
  };
  ByteArrayDeque.prototype.readByte_1 = function () {
    return this._ring.readByte_1();
  };
  ByteArrayDeque.prototype.hashCode = function () {
    return this._ring.contentHashCode_2();
  };
  ByteArrayDeque.prototype.equals = function (other) {
    var tmp;
    if (other instanceof ByteArrayDeque) {
      tmp = this._ring.equals(other._ring);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ByteArrayDeque.$metadata$ = {
    simpleName: 'ByteArrayDeque',
    kind: 'class',
    interfaces: []
  };
  function ShortArrayDeque_init_$Init$(initialBits, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialBits = 10;
    ShortArrayDeque.call($this, initialBits);
    return $this;
  }
  function ShortArrayDeque_init_$Create$(initialBits, $mask0, $marker) {
    return ShortArrayDeque_init_$Init$(initialBits, $mask0, $marker, Object.create(ShortArrayDeque.prototype));
  }
  function ensureWrite_0($this, count_0) {
    if (count_0 > $this._ring_0._availableWrite) {
      var minNewSize = $this._ring_0._availableRead + count_0 | 0;
      var newBits = ilog2(minNewSize) + 2 | 0;
      var newRing = new ShortRingBuffer(newBits);
      while ($this._ring_0._availableRead > 0) {
        var read_1 = $this._ring_0.read_4($this._tempBuffer_0, 0, $this._tempBuffer_0.length);
        newRing.write_4($this._tempBuffer_0, 0, read_1);
        Unit_getInstance();
      }
      $this._ring_0 = newRing;
    }return $this;
  }
  function ShortArrayDeque(initialBits) {
    this._initialBits_0 = initialBits;
    this._ring_0 = new ShortRingBuffer(this._initialBits_0);
    this._tempBuffer_0 = new Int16Array(1024);
    this._written_0 = new Long(0, 0);
    this._read_0 = new Long(0, 0);
  }
  ShortArrayDeque.prototype._get_availableRead__4 = function () {
    return this._ring_0._availableRead;
  };
  ShortArrayDeque.prototype.write_4 = function (buffer, offset, size_1) {
    var out = ensureWrite_0(this, size_1)._ring_0.write_4(buffer, offset, size_1);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._written_0;
      tmp._written_0 = tmp0_plus_0.plus_64(toLong(out));
    }return out;
  };
  ShortArrayDeque.prototype.read_4 = function (buffer, offset, size_1) {
    var out = this._ring_0.read_4(buffer, offset, size_1);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._read_0;
      tmp._read_0 = tmp0_plus_0.plus_64(toLong(out));
    }return out;
  };
  ShortArrayDeque.prototype.hashCode = function () {
    return this._ring_0.contentHashCode_2();
  };
  ShortArrayDeque.prototype.equals = function (other) {
    var tmp;
    if (other instanceof ShortArrayDeque) {
      tmp = this._ring_0.equals(other._ring_0);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ShortArrayDeque.$metadata$ = {
    simpleName: 'ShortArrayDeque',
    kind: 'class',
    interfaces: []
  };
  function FloatArrayDeque_init_$Init$(initialBits, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialBits = 10;
    FloatArrayDeque.call($this, initialBits);
    return $this;
  }
  function FloatArrayDeque_init_$Create$(initialBits, $mask0, $marker) {
    return FloatArrayDeque_init_$Init$(initialBits, $mask0, $marker, Object.create(FloatArrayDeque.prototype));
  }
  function ensureWrite_1($this, count_0) {
    if (count_0 > $this._ring_1._availableWrite_0) {
      var minNewSize = $this._ring_1._availableRead_0 + count_0 | 0;
      var newBits = ilog2(minNewSize) + 2 | 0;
      var newRing = new FloatRingBuffer(newBits);
      while ($this._ring_1._availableRead_0 > 0) {
        var read_1 = $this._ring_1.read_5($this._tempBuffer_1, 0, $this._tempBuffer_1.length);
        newRing.write_5($this._tempBuffer_1, 0, read_1);
        Unit_getInstance();
      }
      $this._ring_1 = newRing;
    }return $this;
  }
  function FloatArrayDeque(initialBits) {
    this._initialBits_1 = initialBits;
    this._ring_1 = new FloatRingBuffer(this._initialBits_1);
    this._tempBuffer_1 = new Float32Array(1024);
    this._written_1 = new Long(0, 0);
    this._read_1 = new Long(0, 0);
  }
  FloatArrayDeque.prototype._get_availableRead__4 = function () {
    return this._ring_1._availableRead_0;
  };
  FloatArrayDeque.prototype.write_5 = function (buffer, offset, size_1) {
    var out = ensureWrite_1(this, size_1)._ring_1.write_5(buffer, offset, size_1);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._written_1;
      tmp._written_1 = tmp0_plus_0.plus_64(toLong(out));
    }return out;
  };
  FloatArrayDeque.prototype.read_5 = function (buffer, offset, size_1) {
    var out = this._ring_1.read_5(buffer, offset, size_1);
    if (out > 0) {
      var tmp0_this = this;
      var tmp = tmp0_this;
      var tmp0_plus_0 = tmp0_this._read_1;
      tmp._read_1 = tmp0_plus_0.plus_64(toLong(out));
    }return out;
  };
  FloatArrayDeque.prototype.read$default = function (buffer, offset, size_1, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      size_1 = buffer.length - offset | 0;
    return this.read_5(buffer, offset, size_1);
  };
  FloatArrayDeque.prototype.hashCode = function () {
    return this._ring_1.contentHashCode_2();
  };
  FloatArrayDeque.prototype.equals = function (other) {
    var tmp;
    if (other instanceof FloatArrayDeque) {
      tmp = this._ring_1.equals(other._ring_1);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  FloatArrayDeque.$metadata$ = {
    simpleName: 'FloatArrayDeque',
    kind: 'class',
    interfaces: []
  };
  function DoubleArrayList_init_$Init$(capacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      capacity = 7;
    DoubleArrayList.call($this, capacity);
    return $this;
  }
  function DoubleArrayList_init_$Create$(capacity, $mask0, $marker) {
    return DoubleArrayList_init_$Init$(capacity, $mask0, $marker, Object.create(DoubleArrayList.prototype));
  }
  function Companion_33() {
    Companion_instance_32 = this;
  }
  Companion_33.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_32;
  function Companion_getInstance_32() {
    if (Companion_instance_32 == null)
      new Companion_33();
    return Companion_instance_32;
  }
  function DoubleArrayList_init_$Init$_0(other, $this) {
    DoubleArrayList_init_$Init$(0, 1, null, $this);
    $this.add$default(other, 0, 0, 6, null);
    return $this;
  }
  function DoubleArrayList_init_$Create$_0(other) {
    return DoubleArrayList_init_$Init$_0(other, Object.create(DoubleArrayList.prototype));
  }
  function ensure($this, count_0) {
    if (($this._length + count_0 | 0) > $this._data_3.length) {
      var tmp = $this;
      var tmp_0 = copyOf_2($this._data_3, max2($this._length + count_0 | 0, imul($this._data_3.length, 3)));
      tmp._data_3 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    }}
  function DoubleArrayList(capacity) {
    Companion_getInstance_32();
    var tmp = this;
    var tmp_0 = new Float64Array(capacity);
    tmp._data_3 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    this._length = 0;
  }
  DoubleArrayList.prototype._set_size__1 = function (value) {
    ensure(this, value);
    this._length = value;
  };
  DoubleArrayList.prototype._get_size__60 = function () {
    return this._length;
  };
  DoubleArrayList.prototype.clear_33 = function () {
    this._length = 0;
    return Unit_getInstance();
  };
  DoubleArrayList.prototype.add_20 = function (v0) {
    ensure(this, 1);
    var tmp = this._data_3;
    var tmp0_this = this;
    var tmp1 = tmp0_this._length;
    tmp0_this._length = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
  };
  DoubleArrayList.prototype.add_21 = function (v0, v1) {
    ensure(this, 2);
    var tmp = this._data_3;
    var tmp0_this = this;
    var tmp1 = tmp0_this._length;
    tmp0_this._length = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this._data_3;
    var tmp2_this = this;
    var tmp3 = tmp2_this._length;
    tmp2_this._length = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
  };
  DoubleArrayList.prototype.add_22 = function (v0, v1, v2, v3) {
    ensure(this, 4);
    var tmp = this._data_3;
    var tmp0_this = this;
    var tmp1 = tmp0_this._length;
    tmp0_this._length = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this._data_3;
    var tmp2_this = this;
    var tmp3 = tmp2_this._length;
    tmp2_this._length = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
    var tmp_1 = this._data_3;
    var tmp4_this = this;
    var tmp5 = tmp4_this._length;
    tmp4_this._length = tmp5 + 1 | 0;
    tmp_1[tmp5] = v2;
    var tmp_2 = this._data_3;
    var tmp6_this = this;
    var tmp7 = tmp6_this._length;
    tmp6_this._length = tmp7 + 1 | 0;
    tmp_2[tmp7] = v3;
  };
  DoubleArrayList.prototype.add_23 = function (v0, v1, v2, v3, v4, v5) {
    ensure(this, 6);
    var tmp = this._data_3;
    var tmp0_this = this;
    var tmp1 = tmp0_this._length;
    tmp0_this._length = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this._data_3;
    var tmp2_this = this;
    var tmp3 = tmp2_this._length;
    tmp2_this._length = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
    var tmp_1 = this._data_3;
    var tmp4_this = this;
    var tmp5 = tmp4_this._length;
    tmp4_this._length = tmp5 + 1 | 0;
    tmp_1[tmp5] = v2;
    var tmp_2 = this._data_3;
    var tmp6_this = this;
    var tmp7 = tmp6_this._length;
    tmp6_this._length = tmp7 + 1 | 0;
    tmp_2[tmp7] = v3;
    var tmp_3 = this._data_3;
    var tmp8_this = this;
    var tmp9 = tmp8_this._length;
    tmp8_this._length = tmp9 + 1 | 0;
    tmp_3[tmp9] = v4;
    var tmp_4 = this._data_3;
    var tmp10_this = this;
    var tmp11 = tmp10_this._length;
    tmp10_this._length = tmp11 + 1 | 0;
    tmp_4[tmp11] = v5;
  };
  DoubleArrayList.prototype.plusAssign = function (value) {
    return this.add_20(value);
  };
  DoubleArrayList.prototype.plusAssign_0 = function (value) {
    return this.add_25(value);
  };
  DoubleArrayList.prototype.add_24 = function (values_10, offset, length) {
    ensure(this, length);
    arraycopy(isDoubleArray(values_10) ? values_10 : THROW_CCE(), offset, this._data_3, this._get_size__60(), length);
    Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._set_size__1(tmp0_this._get_size__60() + length | 0);
  };
  DoubleArrayList.prototype.add$default = function (values_10, offset, length, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      length = values_10.length;
    return this.add_24(values_10, offset, length);
  };
  DoubleArrayList.prototype.add_25 = function (values_10) {
    return this.add_24(values_10._data_3, 0, values_10._get_size__60());
  };
  DoubleArrayList.prototype.get_137 = function (index) {
    return this._data_3[index];
  };
  DoubleArrayList.prototype.getAt_0 = function (index) {
    return this._data_3[index];
  };
  DoubleArrayList.prototype.iterator_67 = function () {
    return this.listIterator_6(0);
  };
  DoubleArrayList.prototype.contains_35 = function (element) {
    var inductionVariable = 0;
    var last_1 = this._length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this._data_3[n] === element)
          return true;
      }
       while (inductionVariable < last_1);
    return false;
  };
  DoubleArrayList.prototype.contains_58 = function (element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    else {
    }
    return this.contains_35((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  DoubleArrayList.prototype.containsAll_29 = function (elements) {
    var tmp0_iterator = elements.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var e = tmp0_iterator.next_37();
      if (!this.contains_35(e))
        return false;
    }
    return true;
  };
  DoubleArrayList.prototype.containsAll_49 = function (elements) {
    return this.containsAll_29(elements);
  };
  DoubleArrayList.prototype.isEmpty_53 = function () {
    return this._get_size__60() === 0;
  };
  DoubleArrayList.prototype.listIterator_6 = function (index) {
    return take(this._data_3, this._length).listIterator_6(index);
  };
  DoubleArrayList.prototype.hashCode = function () {
    return contentHashCode_9(this._data_3, 0, this._get_size__60());
  };
  DoubleArrayList.prototype.equals = function (other) {
    if (other instanceof DoubleArrayList)
      return this._get_size__60() === other._get_size__60() ? contentEquals_12(this._data_3, other._data_3, 0, this._get_size__60()) : false;
    else {
    }
    if (!(other == null) ? isInterface(other, List) : false)
      return equals_1(other, this);
    else {
    }
    return false;
  };
  DoubleArrayList.prototype.toString = function () {
    var tmp0_also_0 = StringBuilder_init_$Create$(2 + imul(5, this._get_size__60()) | 0);
    tmp0_also_0.append_2(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n_3 === 0)) {
          tmp0_also_0.append_5(', ');
          Unit_getInstance();
        }tmp0_also_0.append_4(this.getAt_0(n_3));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp0_also_0.append_2(new Char(93));
    Unit_getInstance();
    return tmp0_also_0.toString();
  };
  DoubleArrayList.$metadata$ = {
    simpleName: 'DoubleArrayList',
    kind: 'class',
    interfaces: [Collection]
  };
  function IntArrayList_init_$Init$(capacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      capacity = 7;
    IntArrayList.call($this, capacity);
    return $this;
  }
  function IntArrayList_init_$Create$(capacity, $mask0, $marker) {
    return IntArrayList_init_$Init$(capacity, $mask0, $marker, Object.create(IntArrayList.prototype));
  }
  function Companion_34() {
    Companion_instance_33 = this;
  }
  Companion_34.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_33;
  function Companion_getInstance_33() {
    if (Companion_instance_33 == null)
      new Companion_34();
    return Companion_instance_33;
  }
  function IntArrayList_init_$Init$_0(other, $this) {
    IntArrayList_init_$Init$(0, 1, null, $this);
    $this.add$default_0(other, 0, 0, 6, null);
    return $this;
  }
  function IntArrayList_init_$Create$_0(other) {
    return IntArrayList_init_$Init$_0(other, Object.create(IntArrayList.prototype));
  }
  function IntArrayList(capacity) {
    Companion_getInstance_33();
    var tmp = this;
    var tmp_0 = new Int32Array(capacity);
    tmp._data_4 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    this._length_0 = 0;
  }
  IntArrayList.prototype._set_size__1 = function (value) {
    this.ensure(value);
    this._length_0 = value;
  };
  IntArrayList.prototype._get_size__60 = function () {
    return this._length_0;
  };
  IntArrayList.prototype.ensure = function (count_0) {
    if ((this._length_0 + count_0 | 0) > this._data_4.length) {
      var tmp = this;
      var tmp_0 = copyOf_1(this._data_4, max2(this._length_0 + count_0 | 0, imul(this._data_4.length, 3)));
      tmp._data_4 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    }};
  IntArrayList.prototype.clear_33 = function () {
    this._length_0 = 0;
    return Unit_getInstance();
  };
  IntArrayList.prototype.add_26 = function (v0) {
    this.ensure(1);
    var tmp = this._data_4;
    var tmp0_this = this;
    var tmp1 = tmp0_this._length_0;
    tmp0_this._length_0 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
  };
  IntArrayList.prototype.plusAssign_1 = function (value) {
    return this.add_26(value);
  };
  IntArrayList.prototype.plusAssign_2 = function (value) {
    return this.add_28(value);
  };
  IntArrayList.prototype.add_27 = function (values_10, offset, length) {
    this.ensure(length);
    arraycopy_0(isIntArray(values_10) ? values_10 : THROW_CCE(), offset, this._data_4, this._get_size__60(), length);
    Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._set_size__1(tmp0_this._get_size__60() + length | 0);
  };
  IntArrayList.prototype.add$default_0 = function (values_10, offset, length, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      length = values_10.length;
    return this.add_27(values_10, offset, length);
  };
  IntArrayList.prototype.add_28 = function (values_10) {
    return this.add_27(values_10._data_4, 0, values_10._get_size__60());
  };
  IntArrayList.prototype.get_137 = function (index) {
    return this._data_4[index];
  };
  IntArrayList.prototype.getAt_0 = function (index) {
    return this._data_4[index];
  };
  IntArrayList.prototype.set_35 = function (index, value) {
    if (index >= this._length_0) {
      this.ensure(index + 1 | 0);
      this._length_0 = index + 1 | 0;
    }return this._data_4[index] = value;
  };
  IntArrayList.prototype.iterator_67 = function () {
    return this.listIterator_6(0);
  };
  IntArrayList.prototype.contains_56 = function (element) {
    var inductionVariable = 0;
    var last_1 = this._length_0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this._data_4[n] === element)
          return true;
      }
       while (inductionVariable < last_1);
    return false;
  };
  IntArrayList.prototype.contains_58 = function (element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    else {
    }
    return this.contains_56((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  IntArrayList.prototype.containsAll_33 = function (elements) {
    var tmp0_iterator = elements.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var e = tmp0_iterator.next_37();
      if (!this.contains_56(e))
        return false;
    }
    return true;
  };
  IntArrayList.prototype.containsAll_49 = function (elements) {
    return this.containsAll_33(elements);
  };
  IntArrayList.prototype.isEmpty_53 = function () {
    return this._get_size__60() === 0;
  };
  IntArrayList.prototype.insertAt = function (index, value) {
    this.ensure(1);
    if (!this.isEmpty_53()) {
      arraycopy_0(this._data_4, index, this._data_4, index + 1 | 0, this._length_0 - index | 0);
      Unit_getInstance();
    } else {
    }
    this._data_4[index] = value;
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2._length_0;
    tmp0_this_2._length_0 = tmp1_3 + 1 | 0;
    Unit_getInstance();
    return this;
  };
  IntArrayList.prototype.swap = function (indexA, indexB) {
    var l = this.getAt_0(indexA);
    var r = this.getAt_0(indexB);
    this.set_35(indexA, r);
    this.set_35(indexB, l);
  };
  IntArrayList.prototype.removeAt_2 = function (index, count_0) {
    if ((index < 0 ? true : index >= this._length_0) ? true : (index + count_0 | 0) > this._length_0)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this._data_4[index];
    if (count_0 > 0) {
      if (index < (this._length_0 - count_0 | 0)) {
        arraycopy_0(this._data_4, index + count_0 | 0, this._data_4, index, (this._length_0 - index | 0) - count_0 | 0);
        Unit_getInstance();
      }var tmp0_this = this;
      tmp0_this._length_0 = tmp0_this._length_0 - count_0 | 0;
    }return out;
  };
  IntArrayList.prototype.toIntArray = function () {
    return copyOf_1(this._data_4, this._length_0);
  };
  IntArrayList.prototype.listIterator_6 = function (index) {
    return take_0(this._data_4, this._length_0).listIterator_6(index);
  };
  IntArrayList.prototype.hashCode = function () {
    return contentHashCode_10(this._data_4, 0, this._get_size__60());
  };
  IntArrayList.prototype.equals = function (other) {
    if (other instanceof IntArrayList)
      return this._get_size__60() === other._get_size__60() ? contentEquals_13(this._data_4, other._data_4, 0, this._get_size__60()) : false;
    else {
    }
    if (!(other == null) ? isInterface(other, List) : false)
      return equals_1(other, this);
    else {
    }
    return false;
  };
  IntArrayList.prototype.toString = function () {
    var tmp0_also_0 = StringBuilder_init_$Create$(2 + imul(5, this._get_size__60()) | 0);
    tmp0_also_0.append_2(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n_3 === 0)) {
          tmp0_also_0.append_5(', ');
          Unit_getInstance();
        }tmp0_also_0.append_4(this.getAt_0(n_3));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp0_also_0.append_2(new Char(93));
    Unit_getInstance();
    return tmp0_also_0.toString();
  };
  IntArrayList.$metadata$ = {
    simpleName: 'IntArrayList',
    kind: 'class',
    interfaces: [Collection]
  };
  function intArrayListOf(values_10) {
    return IntArrayList_init_$Create$_0(values_10.slice());
  }
  function doubleArrayListOf(values_10) {
    return DoubleArrayList_init_$Create$_0(values_10.slice());
  }
  function toCaseInsensitiveMap(_this_) {
    var tmp0_also_0 = CaseInsensitiveStringMap_init_$Create$();
    tmp0_also_0.putAll_3(_this_);
    return tmp0_also_0;
  }
  function CaseInsensitiveStringMap_init_$Init$($this) {
    CaseInsensitiveStringMap.call($this, LinkedHashMap_init_$Create$(), LinkedHashMap_init_$Create$(), LinkedHashMap_init_$Create$());
    return $this;
  }
  function CaseInsensitiveStringMap_init_$Create$() {
    return CaseInsensitiveStringMap_init_$Init$(Object.create(CaseInsensitiveStringMap.prototype));
  }
  function CaseInsensitiveStringMap(mapOrig, lcToOrig, mapLC) {
    this._mapOrig = mapOrig;
    this._lcToOrig = lcToOrig;
    this._mapLC = mapLC;
  }
  CaseInsensitiveStringMap.prototype.isEmpty_53 = function () {
    return this._mapOrig.isEmpty_53();
  };
  CaseInsensitiveStringMap.prototype._get_entries__10 = function () {
    return this._mapOrig._get_entries__10();
  };
  CaseInsensitiveStringMap.prototype._get_size__60 = function () {
    return this._mapOrig._get_size__60();
  };
  CaseInsensitiveStringMap.prototype._get_values__9 = function () {
    return this._mapOrig._get_values__9();
  };
  CaseInsensitiveStringMap.prototype.containsKey_10 = function (key) {
    return this._mapLC.containsKey_11(key.toLowerCase());
  };
  CaseInsensitiveStringMap.prototype.containsKey_11 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_10((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  CaseInsensitiveStringMap.prototype.get_115 = function (key) {
    return this._mapLC.get_116(key.toLowerCase());
  };
  CaseInsensitiveStringMap.prototype.get_116 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_115((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  CaseInsensitiveStringMap.prototype.put_6 = function (key, value) {
    this.remove_71(key);
    Unit_getInstance();
    var tmp0_set_0 = this._mapOrig;
    tmp0_set_0.put_18(key, value);
    Unit_getInstance();
    var tmp1_set_0 = this._lcToOrig;
    var tmp2_set_0 = key.toLowerCase();
    tmp1_set_0.put_18(tmp2_set_0, key);
    Unit_getInstance();
    return this._mapLC.put_18(key.toLowerCase(), value);
  };
  CaseInsensitiveStringMap.prototype.put_18 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.put_6(tmp, (value == null ? true : isObject(value)) ? value : THROW_CCE());
  };
  CaseInsensitiveStringMap.prototype.putAll_3 = function (from) {
    var tmp0_iterator = from._get_entries__10().iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var v = tmp0_iterator.next_37();
      this.put_6(v._get_key__37(), v._get_value__10());
      Unit_getInstance();
    }
  };
  CaseInsensitiveStringMap.prototype.putAll_7 = function (from) {
    return this.putAll_3(from);
  };
  CaseInsensitiveStringMap.prototype.remove_71 = function (key) {
    var lkey = key.toLowerCase();
    var okey = this._lcToOrig.get_116(lkey);
    var tmp0_remove_0 = this._mapOrig;
    (isInterface(tmp0_remove_0, MutableMap) ? tmp0_remove_0 : THROW_CCE()).remove_72(okey);
    Unit_getInstance();
    var res = this._mapLC.remove_72(lkey);
    this._lcToOrig.remove_72(lkey);
    Unit_getInstance();
    return res;
  };
  CaseInsensitiveStringMap.prototype.remove_72 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.remove_71((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  CaseInsensitiveStringMap.prototype.equals = function (other) {
    var tmp;
    if (other instanceof CaseInsensitiveStringMap) {
      tmp = equals_1(this._mapLC, other._mapLC);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  CaseInsensitiveStringMap.prototype.hashCode = function () {
    return hashCode(this._mapLC);
  };
  CaseInsensitiveStringMap.$metadata$ = {
    simpleName: 'CaseInsensitiveStringMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function CopyOnWriteFrozenMap() {
    var tmp = this;
    tmp._map_1 = new KdsAtomicRef(emptyMap());
  }
  CopyOnWriteFrozenMap.prototype._get_size__60 = function () {
    return this._map_1._value_2._get_size__60();
  };
  CopyOnWriteFrozenMap.prototype.containsKey_11 = function (key) {
    return this._map_1._value_2.containsKey_11(key);
  };
  CopyOnWriteFrozenMap.prototype.get_116 = function (key) {
    return this._map_1._value_2.get_116(key);
  };
  CopyOnWriteFrozenMap.prototype.isEmpty_53 = function () {
    return this._map_1._value_2.isEmpty_53();
  };
  CopyOnWriteFrozenMap.prototype._get_entries__10 = function () {
    return asFakeMutable(this._map_1._value_2._get_entries__10());
  };
  CopyOnWriteFrozenMap.prototype._get_values__9 = function () {
    return asFakeMutable_0(this._map_1._value_2._get_values__9());
  };
  CopyOnWriteFrozenMap.prototype.put_18 = function (key, value) {
    var tmp0_also_0 = this._map_1._value_2.get_116(key);
    this._map_1._value_2 = plus_3(this._map_1._value_2, mapOf_0(to(key, value)));
    return tmp0_also_0;
  };
  CopyOnWriteFrozenMap.prototype.putAll_7 = function (from) {
    this._map_1._value_2 = plus_3(this._map_1._value_2, from);
    return Unit_getInstance();
  };
  CopyOnWriteFrozenMap.prototype.remove_72 = function (key) {
    var tmp0_also_0 = this._map_1._value_2.get_116(key);
    this._map_1._value_2 = minus_1(this._map_1._value_2, key);
    return tmp0_also_0;
  };
  CopyOnWriteFrozenMap.$metadata$ = {
    simpleName: 'CopyOnWriteFrozenMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function _get_capacity_($this) {
    return $this._data_5.length;
  }
  function resizeIfRequiredFor($this, count_0) {
    if (($this._get_size__60() + count_0 | 0) > _get_capacity_($this)) {
      var i = $this._data_5;
      var istart = $this.__start;
      var tmp = new Int32Array(imul($this._data_5.length, 2));
      var o = isIntArray(tmp) ? tmp : THROW_CCE();
      copyCyclic($this, i, istart, o, $this.__size);
      $this._data_5 = o;
      $this.__start = 0;
    }}
  function copyCyclic($this, i, istart, o, count_0) {
    var size1 = min2(i.length - istart | 0, count_0);
    var size2 = count_0 - size1 | 0;
    arraycopy_0(i, istart, o, 0, size1);
    Unit_getInstance();
    if (size2 > 0) {
      arraycopy_0(i, 0, o, size1, size2);
      Unit_getInstance();
    }}
  function internalIndex($this, index) {
    return umod_1($this.__start + index | 0, _get_capacity_($this));
  }
  function _no_name_provided__48($that, this$0) {
    this._$that = $that;
    this._this$0_10 = this$0;
    this._index_5 = 0;
  }
  _no_name_provided__48.prototype.next_37 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_5;
    tmp0_this._index_5 = tmp1 + 1 | 0;
    return this._$that.get_137(tmp1);
  };
  _no_name_provided__48.prototype.hasNext_33 = function () {
    return this._index_5 < this._this$0_10._get_size__60();
  };
  _no_name_provided__48.prototype.remove_46 = function () {
    var tmp0_this_2 = this;
    tmp0_this_2._index_5 = tmp0_this_2._index_5 - 1 | 0;
    this._this$0_10.removeAt_6(tmp0_this_2._index_5);
    return Unit_getInstance();
  };
  _no_name_provided__48.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function IntDeque(initialCapacity) {
    this.__start = 0;
    this.__size = 0;
    var tmp = this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp._data_5 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
  IntDeque.prototype._get_size__60 = function () {
    return this.__size;
  };
  IntDeque.prototype.isEmpty_53 = function () {
    return this._get_size__60() === 0;
  };
  IntDeque.prototype.addAll_12 = function (items) {
    resizeIfRequiredFor(this, count(items));
    var tmp0_iterator_2 = items.iterator_67();
    while (tmp0_iterator_2.hasNext_33()) {
      var i_3 = tmp0_iterator_2.next_37();
      this.addLast(i_3);
    }
    return Unit_getInstance();
  };
  IntDeque.prototype.addLast = function (item) {
    resizeIfRequiredFor(this, 1);
    this._data_5[umod_1(this.__start + this._get_size__60() | 0, _get_capacity_(this))] = item;
    var tmp0_this = this;
    var tmp1 = tmp0_this.__size;
    tmp0_this.__size = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  IntDeque.prototype.removeFirst_0 = function () {
    if (this.__size <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var tmp0_apply_0 = this._get_first__6();
    this.__start = umod_1(this.__start + 1 | 0, _get_capacity_(this));
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2.__size;
    tmp0_this_2.__size = tmp1_3 - 1 | 0;
    Unit_getInstance();
    return tmp0_apply_0;
  };
  IntDeque.prototype.removeLast_0 = function () {
    if (this.__size <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var tmp0_apply_0 = this._get_last__6();
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2.__size;
    tmp0_this_2.__size = tmp1_3 - 1 | 0;
    Unit_getInstance();
    return tmp0_apply_0;
  };
  IntDeque.prototype.removeAt_6 = function (index) {
    if (index < 0 ? true : index >= this._get_size__60())
      throw IndexOutOfBoundsException_init_$Create$();
    if (index === 0)
      return this.removeFirst_0();
    if (index === (this._get_size__60() - 1 | 0))
      return this.removeLast_0();
    var old = this.get_137(index);
    if (index < (this._get_size__60() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.set_35(n, this.get_137(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.__start = umod_1(this.__start + 1 | 0, _get_capacity_(this));
    } else {
      var inductionVariable_0 = index;
      var last_1 = this._get_size__60() - 1 | 0;
      if (inductionVariable_0 < last_1)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.set_35(n_0, this.get_137(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last_1);
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this.__size;
    tmp2_this.__size = tmp3 - 1 | 0;
    Unit_getInstance();
    return old;
  };
  IntDeque.prototype.add_29 = function (element) {
    var tmp0_apply_0 = true;
    this.addLast(element);
    return tmp0_apply_0;
  };
  IntDeque.prototype.add_39 = function (element) {
    return this.add_29((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  IntDeque.prototype.addAll_13 = function (elements) {
    var tmp0_apply_0 = true;
    this.addAll_12(isInterface(elements, Iterable) ? elements : THROW_CCE());
    return tmp0_apply_0;
  };
  IntDeque.prototype.addAll_24 = function (elements) {
    return this.addAll_13(elements);
  };
  IntDeque.prototype.remove_32 = function (element) {
    var index = this.indexOf_1(element);
    if (index >= 0) {
      this.removeAt_6(index);
      Unit_getInstance();
    }return index >= 0;
  };
  IntDeque.prototype.remove_47 = function (element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    else {
    }
    return this.remove_32((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  IntDeque.prototype._get_first__6 = function () {
    return this._data_5[this.__start];
  };
  IntDeque.prototype._get_last__6 = function () {
    return this._data_5[internalIndex(this, this._get_size__60() - 1 | 0)];
  };
  IntDeque.prototype.set_35 = function (index, value) {
    return this._data_5[internalIndex(this, index)] = value;
  };
  IntDeque.prototype.get_137 = function (index) {
    return this._data_5[internalIndex(this, index)];
  };
  IntDeque.prototype.contains_56 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = until(0, this._get_size__60());
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var inductionVariable = tmp0_any_0._get_first__6();
      var last_1 = tmp0_any_0._get_last__6();
      if (inductionVariable <= last_1)
        do {
          var element_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.get_137(element_2) === element) {
            tmp$ret$0 = true;
            break l$ret$1;
          } else {
          }
        }
         while (!(element_2 === last_1));
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  IntDeque.prototype.contains_58 = function (element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    else {
    }
    return this.contains_56((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  IntDeque.prototype.indexOf_1 = function (element) {
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.get_137(n) === element)
          return n;
      }
       while (inductionVariable < last_1);
    return -1;
  };
  IntDeque.prototype.containsAll_33 = function (elements) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator_1_2 = elements.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(to(item_2_3, 0));
      Unit_getInstance();
    }
    var emap = toLinkedMap(tmp0_mapTo_0_1);
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.get_137(it);
        if ((isInterface(emap, Map_0) ? emap : THROW_CCE()).containsKey_11(e)) {
          var tmp0_set_0 = 1;
          emap.put_18(e, tmp0_set_0);
          Unit_getInstance();
        } else {
        }
      }
       while (inductionVariable < last_1);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_all_0 = emap._get_values__9();
      var tmp;
      if (isInterface(tmp1_all_0, Collection)) {
        tmp = tmp1_all_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp1_all_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (!(element_2 === 1)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  IntDeque.prototype.containsAll_49 = function (elements) {
    return this.containsAll_33(elements);
  };
  IntDeque.prototype.iterator_67 = function () {
    var that = this;
    return new _no_name_provided__48(that, this);
  };
  IntDeque.prototype.hashCode = function () {
    var tmp1_contentHashCode_0 = this._get_size__60();
    var result_1 = 1;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_contentHashCode_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result_1);
        var tmp0_hashCode_0 = this.get_137(n_3);
        var tmp0_safe_receiver_2 = tmp0_hashCode_0;
        var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
        result_1 = tmp + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
      }
       while (inductionVariable < tmp1_contentHashCode_0);
    return result_1;
  };
  IntDeque.prototype.equals = function (other) {
    if (!(other instanceof IntDeque))
      return false;
    else {
    }
    if (!(other._get_size__60() === this._get_size__60()))
      return false;
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.get_137(n) === other.get_137(n)))
          return false;
      }
       while (inductionVariable < last_1);
    return true;
  };
  IntDeque.prototype.toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.append_2(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.append_4(this.get_137(n));
        Unit_getInstance();
        if (!(n === (this._get_size__60() - 1 | 0))) {
          sb.append_5(', ');
          Unit_getInstance();
        }}
       while (inductionVariable < last_1);
    sb.append_2(new Char(93));
    Unit_getInstance();
    return sb.toString();
  };
  IntDeque.$metadata$ = {
    simpleName: 'IntDeque',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function _get_capacity__0($this) {
    return $this._data_6.length;
  }
  function TGenDeque_init_$Init$($this) {
    TGenDeque.call($this, 16);
    return $this;
  }
  function TGenDeque_init_$Create$() {
    return TGenDeque_init_$Init$(Object.create(TGenDeque.prototype));
  }
  function resizeIfRequiredFor_0($this, count_0) {
    if (($this._get_size__60() + count_0 | 0) > _get_capacity__0($this)) {
      var i = $this._data_6;
      var istart = $this.__start_0;
      var tmp0_arrayOfNulls_0 = imul($this._data_6.length, 2);
      var tmp = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
      var o = isArray(tmp) ? tmp : THROW_CCE();
      copyCyclic_0($this, i, istart, o, $this.__size_0);
      $this._data_6 = o;
      $this.__start_0 = 0;
    }}
  function copyCyclic_0($this, i, istart, o, count_0) {
    var size1 = min2(i.length - istart | 0, count_0);
    var size2 = count_0 - size1 | 0;
    arraycopy_1(i, istart, o, 0, size1);
    Unit_getInstance();
    if (size2 > 0) {
      arraycopy_1(i, 0, o, size1, size2);
      Unit_getInstance();
    }}
  function internalIndex_0($this, index) {
    return umod_1($this.__start_0 + index | 0, _get_capacity__0($this));
  }
  function _no_name_provided__49($that, this$0) {
    this._$that_0 = $that;
    this._this$0_11 = this$0;
    this._index_6 = 0;
  }
  _no_name_provided__49.prototype.next_37 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_6;
    tmp0_this._index_6 = tmp1 + 1 | 0;
    return this._$that_0.get_137(tmp1);
  };
  _no_name_provided__49.prototype.hasNext_33 = function () {
    return this._index_6 < this._this$0_11._get_size__60();
  };
  _no_name_provided__49.prototype.remove_46 = function () {
    var tmp0_this_2 = this;
    tmp0_this_2._index_6 = tmp0_this_2._index_6 - 1 | 0;
    this._this$0_11.removeAt_6(tmp0_this_2._index_6);
    return Unit_getInstance();
  };
  _no_name_provided__49.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function TGenDeque(initialCapacity) {
    this.__start_0 = 0;
    this.__size_0 = 0;
    var tmp = this;
    var tmp_0 = fillArrayVal(Array(initialCapacity), null);
    tmp._data_6 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
  TGenDeque.prototype._get_size__60 = function () {
    return this.__size_0;
  };
  TGenDeque.prototype.isEmpty_53 = function () {
    return this._get_size__60() === 0;
  };
  TGenDeque.prototype.addAll_15 = function (items) {
    resizeIfRequiredFor_0(this, count(items));
    var tmp0_iterator_2 = items.iterator_67();
    while (tmp0_iterator_2.hasNext_33()) {
      var i_3 = tmp0_iterator_2.next_37();
      this.addLast_0(i_3);
    }
    return Unit_getInstance();
  };
  TGenDeque.prototype.addLast_0 = function (item) {
    resizeIfRequiredFor_0(this, 1);
    this._data_6[umod_1(this.__start_0 + this._get_size__60() | 0, _get_capacity__0(this))] = item;
    var tmp0_this = this;
    var tmp1 = tmp0_this.__size_0;
    tmp0_this.__size_0 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  TGenDeque.prototype.removeFirst_0 = function () {
    if (this.__size_0 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var tmp0_apply_0 = this._get_first__6();
    this.__start_0 = umod_1(this.__start_0 + 1 | 0, _get_capacity__0(this));
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2.__size_0;
    tmp0_this_2.__size_0 = tmp1_3 - 1 | 0;
    Unit_getInstance();
    return tmp0_apply_0;
  };
  TGenDeque.prototype.removeLast_0 = function () {
    if (this.__size_0 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var tmp0_apply_0 = this._get_last__6();
    var tmp0_this_2 = this;
    var tmp1_3 = tmp0_this_2.__size_0;
    tmp0_this_2.__size_0 = tmp1_3 - 1 | 0;
    Unit_getInstance();
    return tmp0_apply_0;
  };
  TGenDeque.prototype.removeAt_6 = function (index) {
    if (index < 0 ? true : index >= this._get_size__60())
      throw IndexOutOfBoundsException_init_$Create$();
    if (index === 0)
      return this.removeFirst_0();
    if (index === (this._get_size__60() - 1 | 0))
      return this.removeLast_0();
    var old = this.get_137(index);
    if (index < (this._get_size__60() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.set_5(n, this.get_137(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.__start_0 = umod_1(this.__start_0 + 1 | 0, _get_capacity__0(this));
    } else {
      var inductionVariable_0 = index;
      var last_1 = this._get_size__60() - 1 | 0;
      if (inductionVariable_0 < last_1)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.set_5(n_0, this.get_137(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last_1);
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this.__size_0;
    tmp2_this.__size_0 = tmp3 - 1 | 0;
    Unit_getInstance();
    return old;
  };
  TGenDeque.prototype.add_33 = function (element) {
    var tmp0_apply_0 = true;
    this.addLast_0(element);
    return tmp0_apply_0;
  };
  TGenDeque.prototype.add_39 = function (element) {
    return this.add_33((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenDeque.prototype.addAll_18 = function (elements) {
    var tmp0_apply_0 = true;
    this.addAll_15(isInterface(elements, Iterable) ? elements : THROW_CCE());
    return tmp0_apply_0;
  };
  TGenDeque.prototype.addAll_24 = function (elements) {
    return this.addAll_18(elements);
  };
  TGenDeque.prototype.remove_39 = function (element) {
    var index = this.indexOf_3(element);
    if (index >= 0) {
      this.removeAt_6(index);
      Unit_getInstance();
    }return index >= 0;
  };
  TGenDeque.prototype.remove_47 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.remove_39((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenDeque.prototype._get_first__6 = function () {
    return this._data_6[this.__start_0];
  };
  TGenDeque.prototype._get_last__6 = function () {
    return this._data_6[internalIndex_0(this, this._get_size__60() - 1 | 0)];
  };
  TGenDeque.prototype.set_5 = function (index, value) {
    return this._data_6[internalIndex_0(this, index)] = value;
  };
  TGenDeque.prototype.get_137 = function (index) {
    return this._data_6[internalIndex_0(this, index)];
  };
  TGenDeque.prototype.contains_48 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = until(0, this._get_size__60());
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var inductionVariable = tmp0_any_0._get_first__6();
      var last_1 = tmp0_any_0._get_last__6();
      if (inductionVariable <= last_1)
        do {
          var element_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals_1(this.get_137(element_2), element)) {
            tmp$ret$0 = true;
            break l$ret$1;
          } else {
          }
        }
         while (!(element_2 === last_1));
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  TGenDeque.prototype.contains_58 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_48((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenDeque.prototype.indexOf_3 = function (element) {
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this.get_137(n), element))
          return n;
      }
       while (inductionVariable < last_1);
    return -1;
  };
  TGenDeque.prototype.containsAll_41 = function (elements) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator_1_2 = elements.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(to(item_2_3, 0));
      Unit_getInstance();
    }
    var emap = toLinkedMap(tmp0_mapTo_0_1);
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.get_137(it);
        if ((isInterface(emap, Map_0) ? emap : THROW_CCE()).containsKey_11(e)) {
          var tmp0_set_0 = 1;
          emap.put_18(e, tmp0_set_0);
          Unit_getInstance();
        } else {
        }
      }
       while (inductionVariable < last_1);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_all_0 = emap._get_values__9();
      var tmp;
      if (isInterface(tmp1_all_0, Collection)) {
        tmp = tmp1_all_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp1_all_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (!(element_2 === 1)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  TGenDeque.prototype.containsAll_49 = function (elements) {
    return this.containsAll_41(elements);
  };
  TGenDeque.prototype.iterator_67 = function () {
    var that = this;
    return new _no_name_provided__49(that, this);
  };
  TGenDeque.prototype.hashCode = function () {
    var tmp1_contentHashCode_0 = this._get_size__60();
    var result_1 = 1;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_contentHashCode_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result_1);
        var tmp0_hashCode_0 = this.get_137(n_3);
        var tmp0_safe_receiver_2 = tmp0_hashCode_0;
        var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
        result_1 = tmp + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
      }
       while (inductionVariable < tmp1_contentHashCode_0);
    return result_1;
  };
  TGenDeque.prototype.equals = function (other) {
    if (!(other instanceof TGenDeque))
      return false;
    else {
    }
    if (!(other._get_size__60() === this._get_size__60()))
      return false;
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals_1(this.get_137(n), other.get_137(n)))
          return false;
      }
       while (inductionVariable < last_1);
    return true;
  };
  TGenDeque.prototype.toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.append_2(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.append_4(this.get_137(n));
        Unit_getInstance();
        if (!(n === (this._get_size__60() - 1 | 0))) {
          sb.append_5(', ');
          Unit_getInstance();
        }}
       while (inductionVariable < last_1);
    sb.append_2(new Char(93));
    Unit_getInstance();
    return sb.toString();
  };
  TGenDeque.$metadata$ = {
    simpleName: 'TGenDeque',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function toFastList(_this_) {
    var tmp0_also_0 = FastArrayList_init_$Create$_0(_this_.length);
    var n_1_2 = 0;
    while (n_1_2 < _this_.length) {
      var tmp0_2_4 = n_1_2;
      n_1_2 = tmp0_2_4 + 1 | 0;
      var tmp0__anonymous__3_3 = _this_[tmp0_2_4];
      tmp0_also_0.add_39(tmp0__anonymous__3_3);
      Unit_getInstance();
    }
    return tmp0_also_0;
  }
  function GenericListIterator(list, iindex) {
    this._list = list;
    this._iindex = iindex;
    var containsUpper = this._list._get_size__60();
    var containsArg = this._iindex;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException_init_$Create$_0('' + this._iindex);
    else {
    }
    this._index_7 = this._iindex;
  }
  GenericListIterator.prototype.hasNext_33 = function () {
    return this._index_7 < this._list._get_size__60();
  };
  GenericListIterator.prototype.next_37 = function () {
    if (!this.hasNext_33())
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    var tmp1 = tmp0_this._index_7;
    tmp0_this._index_7 = tmp1 + 1 | 0;
    return this._list.get_137(tmp1);
  };
  GenericListIterator.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals_1(this._list, other._list);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._index_7 === other._index_7;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  GenericListIterator.prototype.hashCode = function () {
    return hashCode(this._list) + this._index_7 | 0;
  };
  GenericListIterator.$metadata$ = {
    simpleName: 'GenericListIterator',
    kind: 'class',
    interfaces: [ListIterator]
  };
  function IntIntMap_init_$Init$(initialCapacity, loadFactor, $this) {
    IntIntMap.call($this, max2(4, ilog2Ceil(initialCapacity)), loadFactor, true);
    return $this;
  }
  function IntIntMap_init_$Init$_0(initialCapacity, loadFactor, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialCapacity = 16;
    if (!(($mask0 & 2) === 0))
      loadFactor = 0.75;
    IntIntMap_init_$Init$(initialCapacity, loadFactor, $this);
    return $this;
  }
  function IntIntMap_init_$Create$(initialCapacity, loadFactor, $mask0, $marker) {
    return IntIntMap_init_$Init$_0(initialCapacity, loadFactor, $mask0, $marker, Object.create(IntIntMap.prototype));
  }
  function Companion_35() {
    Companion_instance_34 = this;
    this._EOF = 2147483646;
    this._ZERO_INDEX = 2147483647;
    this._EMPTY_2 = 0;
  }
  Companion_35.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_34;
  function Companion_getInstance_34() {
    if (Companion_instance_34 == null)
      new Companion_35();
    return Companion_instance_34;
  }
  function _get_stashStart_($this) {
    return $this.__keys_1.length - $this._stashSize | 0;
  }
  function grow($this) {
    var inc = $this._nbits < 20 ? 3 : 1;
    var newnbits = $this._nbits + inc | 0;
    var new_0 = new IntIntMap(newnbits, $this._loadFactor, true);
    var inductionVariable = 0;
    var last_1 = $this.__keys_1.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = $this.__keys_1[n];
        if (!(k === 0)) {
          new_0.set_6(k, $this.__values_1[n]);
          Unit_getInstance();
        }}
       while (inductionVariable <= last_1);
    $this._nbits = new_0._nbits;
    $this._capacity = new_0._capacity;
    $this._mask = new_0._mask;
    $this._stashSize = new_0._stashSize;
    $this.__keys_1 = new_0.__keys_1;
    $this.__values_1 = new_0.__values_1;
    $this._growSize = new_0._growSize;
  }
  function growStash($this) {
    $this._stashSize = imul($this._stashSize, 2);
    $this.__keys_1 = copyOf_1($this.__keys_1, $this._get_backSize__0());
    $this.__values_1 = copyOf_1($this.__values_1, $this._get_backSize__0());
  }
  function _getKeyIndex($this, key) {
    if (key === 0)
      return $this._hasZero ? 2147483647 : -1;
    var index1 = hash1($this, key);
    if ($this.__keys_1[index1] === key)
      return index1;
    var index2 = hash2($this, key);
    if ($this.__keys_1[index2] === key)
      return index2;
    var index3 = hash3($this, key);
    if ($this.__keys_1[index3] === key)
      return index3;
    var inductionVariable = _get_stashStart_($this);
    var last_1 = $this.__keys_1.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ($this.__keys_1[n] === key)
          return n;
      }
       while (inductionVariable < last_1);
    return -1;
  }
  function setEmptySlot($this, index, key, value) {
    if (!($this.__keys_1[index] === 0))
      throw IllegalStateException_init_$Create$();
    $this.__keys_1[index] = key;
    $this.__values_1[index] = value;
    var tmp0_this = $this;
    var tmp1 = tmp0_this._size_0;
    tmp0_this._size_0 = tmp1 + 1 | 0;
    Unit_getInstance();
    return 0;
  }
  function hash1($this, key) {
    return _hash1(key, $this._mask);
  }
  function hash2($this, key) {
    return _hash2(key, $this._mask);
  }
  function hash3($this, key) {
    return _hash3(key, $this._mask);
  }
  function IntIntMap(nbits, loadFactor, dummy) {
    Companion_getInstance_34();
    this._nbits = nbits;
    this._loadFactor = loadFactor;
    this._capacity = 1 << this._nbits;
    this._hasZero = false;
    this._zeroValue = 0;
    this._mask = this._capacity - 1 | 0;
    this._stashSize = 1 + imul(this._nbits, this._nbits) | 0;
    this.__keys_1 = new Int32Array(this._get_backSize__0());
    this.__values_1 = new Int32Array(this._get_backSize__0());
    this._growSize = numberToInt(this._capacity * this._loadFactor);
    this._size_0 = 0;
  }
  IntIntMap.prototype._get_backSize__0 = function () {
    return this._capacity + this._stashSize | 0;
  };
  IntIntMap.prototype.contains_56 = function (key) {
    return _getKeyIndex(this, key) >= 0;
  };
  IntIntMap.prototype.get_137 = function (key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return 0;
    if (index === 2147483647)
      return this._zeroValue;
    return this.__values_1[index];
  };
  IntIntMap.prototype.set_6 = function (key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this._hasZero = true;
          this._zeroValue = value;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size_0;
          tmp0_this._size_0 = tmp1 + 1 | 0;
          Unit_getInstance();
          return 0;
        }if (this._size_0 >= this._growSize)
          grow(this);
        var index1 = hash1(this, key);
        if (this.__keys_1[index1] === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        if (this.__keys_1[index2] === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        if (this.__keys_1[index3] === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart_(this);
        var last_1 = this.__keys_1.length;
        if (inductionVariable < last_1)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.__keys_1[n] === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last_1);
        if (this._stashSize > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        var tmp0_apply_0 = this._zeroValue;
        this._zeroValue = value;
        return tmp0_apply_0;
      } else {
        var tmp1_apply_0 = this.__values_1[index];
        this.__values_1[index] = value;
        return tmp1_apply_0;
      }
    }
  };
  IntIntMap.prototype.nextNonEmptyIndex_0 = function (keys, offset) {
    var inductionVariable = offset;
    var last_1 = keys.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last_1);
    return 2147483646;
  };
  IntIntMap.prototype.equals = function (other) {
    if (!(other instanceof IntMap))
      return false;
    else {
    }
    var index_1_1 = this._hasZero ? 2147483647 : this.nextNonEmptyIndex_0(this.__keys_1, 0);
    while (!(index_1_1 === 2147483646)) {
      var tmp0_subject_2_3 = index_1_1;
      {
        var tmp0__anonymous__3_2;
        switch (tmp0_subject_2_3) {
          case 2147483647:
          case 2147483646:
            tmp0__anonymous__3_2 = 0;
            break;
          default:tmp0__anonymous__3_2 = this.__keys_1[index_1_1];
            break;
        }
      }
      var tmp0__anonymous__4 = this.get_137(tmp0__anonymous__3_2);
      if (!equals_1(other.get_137(tmp0__anonymous__3_2), tmp0__anonymous__4))
        return false;
      index_1_1 = this.nextNonEmptyIndex_0(this.__keys_1, index_1_1 === 2147483647 ? 0 : index_1_1 + 1 | 0);
    }
    return true;
  };
  IntIntMap.prototype.hashCode = function () {
    var out = 0;
    var index_1_1 = this._hasZero ? 2147483647 : this.nextNonEmptyIndex_0(this.__keys_1, 0);
    while (!(index_1_1 === 2147483646)) {
      var tmp0_subject_2_3 = index_1_1;
      {
        var tmp0__anonymous__3_2;
        switch (tmp0_subject_2_3) {
          case 2147483647:
          case 2147483646:
            tmp0__anonymous__3_2 = 0;
            break;
          default:tmp0__anonymous__3_2 = this.__keys_1[index_1_1];
            break;
        }
      }
      var tmp0__anonymous__4 = this.get_137(tmp0__anonymous__3_2);
      out = out + (tmp0__anonymous__3_2 + tmp0__anonymous__4 | 0) | 0;
      index_1_1 = this.nextNonEmptyIndex_0(this.__keys_1, index_1_1 === 2147483647 ? 0 : index_1_1 + 1 | 0);
    }
    return out;
  };
  IntIntMap.$metadata$ = {
    simpleName: 'IntIntMap',
    kind: 'class',
    interfaces: []
  };
  function currentKey($this) {
    var tmp0_subject = $this._index_8;
    switch (tmp0_subject) {
      case 2147483647:
      case 2147483646:
        return 0;
      default:return $this._map_2.__keys_2[$this._index_8];
    }
  }
  function currentValue($this) {
    var tmp0_subject = $this._index_8;
    switch (tmp0_subject) {
      case 2147483647:
        return $this._map_2._zeroValue_0;
      case 2147483646:
        return null;
      default:return $this._map_2.__values_2[$this._index_8];
    }
  }
  function nextNonEmptyIndex($this, keys, offset) {
    var inductionVariable = offset;
    var last_1 = keys.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last_1);
    return 2147483646;
  }
  function next($this) {
    if (!($this._index_8 === 2147483646))
      $this._index_8 = nextNonEmptyIndex($this, $this._map_2.__keys_2, $this._index_8 === 2147483647 ? 0 : $this._index_8 + 1 | 0);
  }
  function _no_name_provided__50($tmp0_let_0_7) {
    this._$tmp0_let_0_7 = $tmp0_let_0_7;
  }
  _no_name_provided__50.prototype.invoke_1005 = function () {
    return this._$tmp0_let_0_7.hasNext_33();
  };
  _no_name_provided__50.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__51($tmp0_let_0_7) {
    this._$tmp0_let_0_7_0 = $tmp0_let_0_7;
  }
  _no_name_provided__51.prototype.invoke_1005 = function () {
    return this._$tmp0_let_0_7_0.nextKey();
  };
  _no_name_provided__51.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__52($tmp0_let_0_7) {
    this._$tmp0_let_0_7_1 = $tmp0_let_0_7;
  }
  _no_name_provided__52.prototype.invoke_1005 = function () {
    return this._$tmp0_let_0_7_1.hasNext_33();
  };
  _no_name_provided__52.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__53($tmp0_let_0_7) {
    this._$tmp0_let_0_7_2 = $tmp0_let_0_7;
  }
  _no_name_provided__53.prototype.invoke_1005 = function () {
    return this._$tmp0_let_0_7_2.nextValue();
  };
  _no_name_provided__53.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function IntMap_init_$Init$(initialCapacity, loadFactor, $this) {
    IntMap.call($this, max2(4, ilog2Ceil(initialCapacity)), loadFactor, true);
    return $this;
  }
  function IntMap_init_$Init$_0(initialCapacity, loadFactor, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialCapacity = 16;
    if (!(($mask0 & 2) === 0))
      loadFactor = 0.75;
    IntMap_init_$Init$(initialCapacity, loadFactor, $this);
    return $this;
  }
  function IntMap_init_$Create$(initialCapacity, loadFactor, $mask0, $marker) {
    return IntMap_init_$Init$_0(initialCapacity, loadFactor, $mask0, $marker, Object.create(IntMap.prototype));
  }
  function Companion_36() {
    Companion_instance_35 = this;
    this._EOF_0 = 2147483646;
    this._ZERO_INDEX_0 = 2147483647;
    this._EMPTY_3 = 0;
  }
  Companion_36.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_35;
  function Companion_getInstance_35() {
    if (Companion_instance_35 == null)
      new Companion_36();
    return Companion_instance_35;
  }
  function _get_stashStart__0($this) {
    return $this.__keys_2.length - $this._stashSize_0 | 0;
  }
  function grow_0($this) {
    var inc = $this._nbits_0 < 20 ? 3 : 1;
    var newnbits = $this._nbits_0 + inc | 0;
    var new_0 = new IntMap(newnbits, $this._loadFactor_0, true);
    var inductionVariable = 0;
    var last_1 = $this.__keys_2.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = $this.__keys_2[n];
        if (!(k === 0)) {
          new_0.set_7(k, $this.__values_2[n]);
          Unit_getInstance();
        }}
       while (inductionVariable <= last_1);
    $this._nbits_0 = new_0._nbits_0;
    $this._capacity_0 = new_0._capacity_0;
    $this._mask_0 = new_0._mask_0;
    $this._stashSize_0 = new_0._stashSize_0;
    $this.__keys_2 = new_0.__keys_2;
    $this.__values_2 = new_0.__values_2;
    $this._growSize_0 = new_0._growSize_0;
  }
  function growStash_0($this) {
    $this._stashSize_0 = imul($this._stashSize_0, 2);
    $this.__keys_2 = copyOf_1($this.__keys_2, $this._get_backSize__0());
    $this.__values_2 = copyOf_0($this.__values_2, $this._get_backSize__0());
  }
  function _getKeyIndex_0($this, key) {
    if (key === 0)
      return $this._hasZero_0 ? 2147483647 : -1;
    var index1 = hash1_0($this, key);
    if ($this.__keys_2[index1] === key)
      return index1;
    var index2 = hash2_0($this, key);
    if ($this.__keys_2[index2] === key)
      return index2;
    var index3 = hash3_0($this, key);
    if ($this.__keys_2[index3] === key)
      return index3;
    var inductionVariable = _get_stashStart__0($this);
    var last_1 = $this.__keys_2.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ($this.__keys_2[n] === key)
          return n;
      }
       while (inductionVariable < last_1);
    return -1;
  }
  function setEmptySlot_0($this, index, key, value) {
    if (!($this.__keys_2[index] === 0))
      throw IllegalStateException_init_$Create$();
    $this.__keys_2[index] = key;
    $this.__values_2[index] = value;
    var tmp0_this = $this;
    var tmp1 = tmp0_this._size_1;
    tmp0_this._size_1 = tmp1 + 1 | 0;
    Unit_getInstance();
    return null;
  }
  function hash1_0($this, key) {
    return _hash1(key, $this._mask_0);
  }
  function hash2_0($this, key) {
    return _hash2(key, $this._mask_0);
  }
  function hash3_0($this, key) {
    return _hash3(key, $this._mask_0);
  }
  function Entry_0(key, value) {
    this._key_1 = key;
    this._value_1 = value;
  }
  Entry_0.prototype.toString = function () {
    return '' + 'Entry(key=' + this._key_1 + ', value=' + this._value_1 + ')';
  };
  Entry_0.prototype.hashCode = function () {
    var result = this._key_1;
    result = imul(result, 31) + (this._value_1 == null ? 0 : hashCode(this._value_1)) | 0;
    return result;
  };
  Entry_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!(this._key_1 === tmp0_other_with_cast._key_1))
      return false;
    if (!equals_1(this._value_1, tmp0_other_with_cast._value_1))
      return false;
    return true;
  };
  Entry_0.$metadata$ = {
    simpleName: 'Entry',
    kind: 'class',
    interfaces: []
  };
  function Iterator_4(map_0) {
    this._map_2 = map_0;
    this._index_8 = this._map_2._hasZero_0 ? 2147483647 : nextNonEmptyIndex(this, this._map_2.__keys_2, 0);
    this._entry = new Entry_0(0, null);
  }
  Iterator_4.prototype.hasNext_33 = function () {
    return !(this._index_8 === 2147483646);
  };
  Iterator_4.prototype.nextKey = function () {
    var tmp0_apply_0 = currentKey(this);
    next(this);
    return tmp0_apply_0;
  };
  Iterator_4.prototype.nextValue = function () {
    var tmp0_apply_0 = currentValue(this);
    next(this);
    return tmp0_apply_0;
  };
  Iterator_4.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_5(this$0) {
    this._this$0_12 = this$0;
  }
  _no_name_provided__1_5.prototype.iterator_2_3 = function () {
    var tmp0_let_0_7 = new Iterator_4(this._this$0_12);
    var tmp = _no_name_provided_$factory_35(tmp0_let_0_7);
    return Iterator_5(tmp, _no_name_provided_$factory_36(tmp0_let_0_7));
  };
  _no_name_provided__1_5.prototype.iterator_67 = function () {
    return this.iterator_2_3();
  };
  _no_name_provided__1_5.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Iterable]
  };
  function _no_name_provided__1_6(this$0) {
    this._this$0_13 = this$0;
  }
  _no_name_provided__1_6.prototype.iterator_2_3 = function () {
    var tmp0_let_0_7 = new Iterator_4(this._this$0_13);
    var tmp = _no_name_provided_$factory_37(tmp0_let_0_7);
    return Iterator_5(tmp, _no_name_provided_$factory_38(tmp0_let_0_7));
  };
  _no_name_provided__1_6.prototype.iterator_67 = function () {
    return this.iterator_2_3();
  };
  _no_name_provided__1_6.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Iterable]
  };
  function IntMap(nbits, loadFactor, dummy) {
    Companion_getInstance_35();
    this._nbits_0 = nbits;
    this._loadFactor_0 = loadFactor;
    this._capacity_0 = 1 << this._nbits_0;
    this._hasZero_0 = false;
    this._zeroValue_0 = null;
    this._mask_0 = this._capacity_0 - 1 | 0;
    this._stashSize_0 = 1 + imul(this._nbits_0, this._nbits_0) | 0;
    this.__keys_2 = new Int32Array(this._get_backSize__0());
    var tmp = this;
    var tmp0_arrayOfNulls_0 = this._get_backSize__0();
    var tmp_0 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    tmp.__values_2 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    this._growSize_0 = numberToInt(this._capacity_0 * this._loadFactor_0);
    this._size_1 = 0;
  }
  IntMap.prototype._get_backSize__0 = function () {
    return this._capacity_0 + this._stashSize_0 | 0;
  };
  IntMap.prototype.get_137 = function (key) {
    var index = _getKeyIndex_0(this, key);
    if (index < 0)
      return null;
    if (index === 2147483647)
      return this._zeroValue_0;
    return this.__values_2[index];
  };
  IntMap.prototype.set_7 = function (key, value) {
    retry: while (true) {
      var index = _getKeyIndex_0(this, key);
      if (index < 0) {
        if (key === 0) {
          this._hasZero_0 = true;
          this._zeroValue_0 = value;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size_1;
          tmp0_this._size_1 = tmp1 + 1 | 0;
          Unit_getInstance();
          return null;
        }if (this._size_1 >= this._growSize_0)
          grow_0(this);
        var index1 = hash1_0(this, key);
        if (this.__keys_2[index1] === 0)
          return setEmptySlot_0(this, index1, key, value);
        var index2 = hash2_0(this, key);
        if (this.__keys_2[index2] === 0)
          return setEmptySlot_0(this, index2, key, value);
        var index3 = hash3_0(this, key);
        if (this.__keys_2[index3] === 0)
          return setEmptySlot_0(this, index3, key, value);
        var inductionVariable = _get_stashStart__0(this);
        var last_1 = this.__keys_2.length;
        if (inductionVariable < last_1)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.__keys_2[n] === 0)
              return setEmptySlot_0(this, n, key, value);
          }
           while (inductionVariable < last_1);
        if (this._stashSize_0 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        var tmp0_apply_0 = this._zeroValue_0;
        this._zeroValue_0 = value;
        return tmp0_apply_0;
      } else {
        var tmp1_apply_0 = this.__values_2[index];
        this.__values_2[index] = value;
        return tmp1_apply_0;
      }
    }
  };
  IntMap.prototype._get_keys__3 = function () {
    return new _no_name_provided__1_5(this);
  };
  IntMap.prototype._get_values__9 = function () {
    return new _no_name_provided__1_6(this);
  };
  IntMap.prototype.nextNonEmptyIndex_0 = function (keys, offset) {
    var inductionVariable = offset;
    var last_1 = keys.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last_1);
    return 2147483646;
  };
  IntMap.prototype.equals = function (other) {
    if (!(other instanceof IntMap))
      return false;
    else {
    }
    var index_1_1 = this._hasZero_0 ? 2147483647 : this.nextNonEmptyIndex_0(this.__keys_2, 0);
    while (!(index_1_1 === 2147483646)) {
      var tmp0_subject_2_3 = index_1_1;
      {
        var tmp0__anonymous__3_2;
        switch (tmp0_subject_2_3) {
          case 2147483647:
          case 2147483646:
            tmp0__anonymous__3_2 = 0;
            break;
          default:tmp0__anonymous__3_2 = this.__keys_2[index_1_1];
            break;
        }
      }
      var tmp0__anonymous__4 = this.get_137(tmp0__anonymous__3_2);
      if (!equals_1(other.get_137(tmp0__anonymous__3_2), tmp0__anonymous__4))
        return false;
      index_1_1 = this.nextNonEmptyIndex_0(this.__keys_2, index_1_1 === 2147483647 ? 0 : index_1_1 + 1 | 0);
    }
    return true;
  };
  IntMap.prototype.hashCode = function () {
    var out = 0;
    var index_1_1 = this._hasZero_0 ? 2147483647 : this.nextNonEmptyIndex_0(this.__keys_2, 0);
    while (!(index_1_1 === 2147483646)) {
      var tmp0_subject_2_3 = index_1_1;
      {
        var tmp0__anonymous__3_2;
        switch (tmp0_subject_2_3) {
          case 2147483647:
          case 2147483646:
            tmp0__anonymous__3_2 = 0;
            break;
          default:tmp0__anonymous__3_2 = this.__keys_2[index_1_1];
            break;
        }
      }
      var tmp0__anonymous__4 = this.get_137(tmp0__anonymous__3_2);
      var tmp = out;
      var tmp_0 = tmp0__anonymous__3_2;
      var tmp0_safe_receiver_2_6 = tmp0__anonymous__4;
      var tmp1_elvis_lhs_1_5 = tmp0_safe_receiver_2_6 == null ? null : hashCode(tmp0_safe_receiver_2_6);
      out = tmp + (tmp_0 + (tmp1_elvis_lhs_1_5 == null ? 0 : tmp1_elvis_lhs_1_5) | 0) | 0;
      index_1_1 = this.nextNonEmptyIndex_0(this.__keys_2, index_1_1 === 2147483647 ? 0 : index_1_1 + 1 | 0);
    }
    return out;
  };
  IntMap.$metadata$ = {
    simpleName: 'IntMap',
    kind: 'class',
    interfaces: []
  };
  function toIntMap(_this_) {
    var tmp = numberToInt(_this_._get_size__60() * 1.25);
    var out = IntMap_init_$Create$(tmp, 0.0, 2, null);
    var tmp0_iterator = _this_._get_entries__10().iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var tmp1_loop_parameter = tmp0_iterator.next_37();
      var k = tmp1_loop_parameter._get_key__37();
      var v = tmp1_loop_parameter._get_value__10();
      out.set_7(k, v);
      Unit_getInstance();
    }
    return out;
  }
  function _hash1(key, mask_0) {
    return _mask(key, mask_0);
  }
  function _hash2(key, mask_0) {
    return _mask(imul(key, 1294968109), mask_0);
  }
  function _hash3(key, mask_0) {
    return _mask(imul(key, 294969449), mask_0);
  }
  function _mask(value, mask_0) {
    return (((value + (value >>> 8 & 255) | 0) + (value >>> 16 & 255) | 0) + (value >> 24 & 255) | 0) & mask_0;
  }
  function associateByInt(_this_, block) {
    var n = 0;
    var out = IntMap_init_$Create$(0, 0.0, 3, null);
    var tmp0_iterator = _this_.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var it = tmp0_iterator.next_37();
      var tmp1 = n;
      n = tmp1 + 1 | 0;
      out.set_7(block(tmp1, it), it);
      Unit_getInstance();
    }
    return out;
  }
  function _no_name_provided_$factory_35($tmp0_let_0_7) {
    var i = new _no_name_provided__50($tmp0_let_0_7);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_36($tmp0_let_0_7) {
    var i = new _no_name_provided__51($tmp0_let_0_7);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_37($tmp0_let_0_7) {
    var i = new _no_name_provided__52($tmp0_let_0_7);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_38($tmp0_let_0_7) {
    var i = new _no_name_provided__53($tmp0_let_0_7);
    return function () {
      return i.invoke_1005();
    };
  }
  function Iterator_5(hasNext, next_0) {
    return new _no_name_provided__54(hasNext, next_0);
  }
  function _no_name_provided__54($hasNext, $next) {
    this._$hasNext = $hasNext;
    this._$next = $next;
  }
  _no_name_provided__54.prototype.hasNext_33 = function () {
    return this._$hasNext();
  };
  _no_name_provided__54.prototype.next_37 = function () {
    return this._$next();
  };
  _no_name_provided__54.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator_3]
  };
  function Pool_init_$Init$(reset, preallocate, gen, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      reset = _no_name_provided_$factory_39();
    }if (!(($mask0 & 2) === 0))
      preallocate = 0;
    Pool.call($this, reset, preallocate, gen);
    return $this;
  }
  function Pool_init_$Create$(reset, preallocate, gen, $mask0, $marker) {
    return Pool_init_$Init$(reset, preallocate, gen, $mask0, $marker, Object.create(Pool.prototype));
  }
  function Companion_37() {
    Companion_instance_36 = this;
  }
  Companion_37.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_36;
  function Companion_getInstance_36() {
    if (Companion_instance_36 == null)
      new Companion_37();
    return Companion_instance_36;
  }
  function Pool_init_$Init$_0(preallocate, gen, $this) {
    Pool.call($this, _no_name_provided_$factory_40(), preallocate, gen);
    return $this;
  }
  function Pool_init_$Create$_0(preallocate, gen) {
    return Pool_init_$Init$_0(preallocate, gen, Object.create(Pool.prototype));
  }
  function Pool_init_$Init$_1(preallocate, gen, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      preallocate = 0;
    Pool_init_$Init$_0(preallocate, gen, $this);
    return $this;
  }
  function Pool_init_$Create$_1(preallocate, gen, $mask0, $marker) {
    return Pool_init_$Init$_1(preallocate, gen, $mask0, $marker, Object.create(Pool.prototype));
  }
  function _no_name_provided__55() {
  }
  _no_name_provided__55.prototype.invoke_137 = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__55.prototype.invoke_1015 = function (p1) {
    this.invoke_137((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__55.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__56() {
  }
  _no_name_provided__56.prototype.invoke_137 = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__56.prototype.invoke_1015 = function (p1) {
    this.invoke_137((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__56.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Pool(reset, preallocate, gen) {
    Companion_getInstance_36();
    this._reset = reset;
    this._gen = gen;
    this._items = new TGenStack();
    this._lastId = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_this = this;
        var tmp2 = tmp1_this._lastId;
        tmp1_this._lastId = tmp2 + 1 | 0;
        this._items.push(this._gen(tmp2));
      }
       while (inductionVariable < preallocate);
  }
  Pool.prototype._get_itemsInPool_ = function () {
    return this._items._get_size__60();
  };
  Pool.prototype.alloc = function () {
    var tmp;
    var tmp0_isNotEmpty_0 = this._items;
    if (!tmp0_isNotEmpty_0.isEmpty_53()) {
      tmp = this._items.pop();
    } else {
      {
        var tmp0_this = this;
        var tmp1 = tmp0_this._lastId;
        tmp0_this._lastId = tmp1 + 1 | 0;
        tmp = this._gen(tmp1);
      }
    }
    return tmp;
  };
  Pool.prototype.free = function (element) {
    this._reset(element);
    this._items.push(element);
  };
  Pool.prototype.free_0 = function (elements) {
    var tmp0_iterator = elements.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var element = tmp0_iterator.next_37();
      this.free(element);
    }
  };
  Pool.prototype.hashCode = function () {
    return this._items.hashCode();
  };
  Pool.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = this._items.equals(other._items);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._get_itemsInPool_() === other._get_itemsInPool_();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Pool.$metadata$ = {
    simpleName: 'Pool',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_39() {
    var i = new _no_name_provided__55();
    return function (p1) {
      i.invoke_137(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_40() {
    var i = new _no_name_provided__56();
    return function (p1) {
      i.invoke_137(p1);
      return Unit_getInstance();
    };
  }
  function Companion_38() {
    Companion_instance_37 = this;
  }
  Companion_38.prototype.invoke_80 = function (comparator, reversed_2) {
    var tmp0_arrayOfNulls_0 = 16;
    var tmp = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_2 ? reversed_1(comparator) : comparator);
  };
  Companion_38.prototype.invoke_81 = function (reversed_2, comparator) {
    return Companion_getInstance_37().invoke_80(new sam$kotlin_Comparator$0(comparator), reversed_2);
  };
  Companion_38.prototype.invoke$default = function (reversed_2, comparator, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      reversed_2 = false;
    return this.invoke_81(reversed_2, comparator);
  };
  Companion_38.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_37;
  function Companion_getInstance_37() {
    if (Companion_instance_37 == null)
      new Companion_38();
    return Companion_instance_37;
  }
  function _set_value_(_this_, $this, value) {
    return $this._data_7[_this_] = value;
  }
  function _get_value_(_this_, $this) {
    return $this._data_7[_this_];
  }
  function _get_isRoot_(_this_, $this) {
    return _this_ === 0;
  }
  function _get_parent_(_this_, $this) {
    return (_this_ - 1 | 0) / 2 | 0;
  }
  function _get_left_(_this_, $this) {
    return imul(2, _this_) + 1 | 0;
  }
  function _get_right_(_this_, $this) {
    return imul(2, _this_) + 2 | 0;
  }
  function gt($this, a, b) {
    return $this._comparator_0.compare(a, b) > 0;
  }
  function lt($this, a, b) {
    return $this._comparator_0.compare(a, b) < 0;
  }
  function _get_capacity__1($this) {
    return $this._data_7.length;
  }
  function ensure_0($this, index) {
    if (index >= _get_capacity__1($this)) {
      var tmp = $this;
      var tmp_0 = copyOf_0($this._data_7, 2 + imul(_get_capacity__1($this), 2) | 0);
      tmp._data_7 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    }}
  function minHeapify($this, index) {
    var i = index;
    $l$break: while (true) {
      var left = _get_left_(i, $this);
      var right = _get_right_(i, $this);
      var smallest = i;
      if (left < $this._size_2 ? lt($this, _get_value_(left, $this), _get_value_(i, $this)) : false)
        smallest = left;
      if (right < $this._size_2 ? lt($this, _get_value_(right, $this), _get_value_(smallest, $this)) : false)
        smallest = right;
      if (!(smallest === i)) {
        swap($this, i, smallest);
        i = smallest;
      } else {
        break $l$break;
      }
    }
  }
  function swap($this, l, r) {
    var temp_0 = _get_value_(r, $this);
    _set_value_(r, $this, _get_value_(l, $this));
    _set_value_(l, $this, temp_0);
  }
  function sam$kotlin_Comparator$0(function_0) {
    this._function = function_0;
  }
  sam$kotlin_Comparator$0.prototype.compare_10 = function (a, b) {
    return this._function(a, b);
  };
  sam$kotlin_Comparator$0.prototype.compare = function (a, b) {
    return this.compare_10(a, b);
  };
  sam$kotlin_Comparator$0.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__57($index, this$0) {
    this._$index = $index;
    this._this$0_14 = this$0;
  }
  _no_name_provided__57.prototype.hasNext_33 = function () {
    return this._$index._v < this._this$0_14._size_2;
  };
  _no_name_provided__57.prototype.next_37 = function () {
    var tmp0 = this._$index._v;
    this._$index._v = tmp0 + 1 | 0;
    return _get_value_(tmp0, this._this$0_14);
  };
  _no_name_provided__57.prototype.remove_69 = function () {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  _no_name_provided__57.prototype.remove_46 = function () {
    return this.remove_69();
  };
  _no_name_provided__57.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function TGenPriorityQueue(data, comparator) {
    Companion_getInstance_37();
    this._data_7 = data;
    this._comparator_0 = comparator;
    this._size_2 = 0;
  }
  TGenPriorityQueue.prototype._get_size__60 = function () {
    return this._size_2;
  };
  TGenPriorityQueue.prototype._get_head_ = function () {
    if (this._size_2 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    return this._data_7[0];
  };
  TGenPriorityQueue.prototype.add_33 = function (element) {
    var tmp0_this = this;
    var tmp1 = tmp0_this._size_2;
    tmp0_this._size_2 = tmp1 + 1 | 0;
    Unit_getInstance();
    ensure_0(this, this._size_2);
    var i = this._size_2 - 1 | 0;
    _set_value_(i, this, element);
    while (!_get_isRoot_(i, this) ? gt(this, _get_value_(_get_parent_(i, this), this), _get_value_(i, this)) : false) {
      swap(this, i, _get_parent_(i, this));
      i = _get_parent_(i, this);
    }
    return true;
  };
  TGenPriorityQueue.prototype.add_39 = function (element) {
    return this.add_33((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenPriorityQueue.prototype.removeHead = function () {
    if (this._size_2 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    if (this._size_2 === 1) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._size_2;
      tmp0_this._size_2 = tmp1 - 1 | 0;
      Unit_getInstance();
      return _get_value_(0, this);
    }var root = _get_value_(0, this);
    _set_value_(0, this, _get_value_(this._size_2 - 1 | 0, this));
    var tmp2_this = this;
    var tmp3 = tmp2_this._size_2;
    tmp2_this._size_2 = tmp3 - 1 | 0;
    Unit_getInstance();
    minHeapify(this, 0);
    return root;
  };
  TGenPriorityQueue.prototype.indexOf_3 = function (element) {
    var inductionVariable = 0;
    var last_1 = this._size_2;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this._data_7[n], element))
          return n;
      }
       while (inductionVariable < last_1);
    return -1;
  };
  TGenPriorityQueue.prototype.remove_39 = function (element) {
    var index = this.indexOf_3(element);
    if (index >= 0)
      this.removeAt_5(index);
    return index >= 0;
  };
  TGenPriorityQueue.prototype.remove_47 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.remove_39((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenPriorityQueue.prototype.removeAt_5 = function (index) {
    var i = index;
    while (!(i === 0)) {
      swap(this, i, _get_parent_(i, this));
      i = _get_parent_(i, this);
    }
    this.removeHead();
    Unit_getInstance();
  };
  TGenPriorityQueue.prototype.contains_48 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_any_0 = until(0, this._size_2);
      var tmp;
      if (isInterface(tmp0_any_0, Collection)) {
        tmp = tmp0_any_0.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var inductionVariable = tmp0_any_0._get_first__6();
      var last_1 = tmp0_any_0._get_last__6();
      if (inductionVariable <= last_1)
        do {
          var element_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals_1(_get_value_(element_2, this), element)) {
            tmp$ret$0 = true;
            break l$ret$1;
          } else {
          }
        }
         while (!(element_2 === last_1));
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  TGenPriorityQueue.prototype.contains_58 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_48((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenPriorityQueue.prototype.containsAll_41 = function (elements) {
    var thisSet = toSet_0(this);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (!thisSet.contains_58(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  TGenPriorityQueue.prototype.containsAll_49 = function (elements) {
    return this.containsAll_41(elements);
  };
  TGenPriorityQueue.prototype.isEmpty_53 = function () {
    return this._size_2 === 0;
  };
  TGenPriorityQueue.prototype.addAll_18 = function (elements) {
    var tmp0_iterator_2 = elements.iterator_67();
    while (tmp0_iterator_2.hasNext_33()) {
      var e_3 = tmp0_iterator_2.next_37();
      this.add_33(e_3);
      Unit_getInstance();
    }
    return !elements.isEmpty_53();
  };
  TGenPriorityQueue.prototype.addAll_24 = function (elements) {
    return this.addAll_18(elements);
  };
  TGenPriorityQueue.prototype.iterator_67 = function () {
    var index = {_v: 0};
    return new _no_name_provided__57(index, this);
  };
  TGenPriorityQueue.prototype.toString = function () {
    return toString_1(toList_2(this));
  };
  TGenPriorityQueue.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_11(this._data_7, other._data_7);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = equals_1(this._comparator_0, other._comparator_0);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  TGenPriorityQueue.prototype.hashCode = function () {
    return contentHashCode_8(this._data_7);
  };
  TGenPriorityQueue.$metadata$ = {
    simpleName: 'TGenPriorityQueue',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function TGenQueue() {
    this._items_0 = TGenDeque_init_$Create$();
  }
  TGenQueue.prototype._get_size__60 = function () {
    return this._items_0._get_size__60();
  };
  TGenQueue.prototype.isEmpty_53 = function () {
    return this._get_size__60() === 0;
  };
  TGenQueue.prototype.enqueue = function (v) {
    return this._items_0.addLast_0(v);
  };
  TGenQueue.prototype.dequeue = function () {
    return this._items_0.removeFirst_0();
  };
  TGenQueue.prototype.contains_48 = function (element) {
    return this._items_0.contains_48(element);
  };
  TGenQueue.prototype.contains_58 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_48((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenQueue.prototype.containsAll_41 = function (elements) {
    return this._items_0.containsAll_41(elements);
  };
  TGenQueue.prototype.containsAll_49 = function (elements) {
    return this.containsAll_41(elements);
  };
  TGenQueue.prototype.iterator_67 = function () {
    return this._items_0.iterator_67();
  };
  TGenQueue.prototype.hashCode = function () {
    return this._items_0.hashCode();
  };
  TGenQueue.prototype.equals = function (other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this._items_0.equals(other._items_0);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  TGenQueue.$metadata$ = {
    simpleName: 'TGenQueue',
    kind: 'class',
    interfaces: [Collection]
  };
  function RingBuffer(bits) {
    ByteRingBuffer.call(this, bits);
  }
  RingBuffer.$metadata$ = {
    simpleName: 'RingBuffer',
    kind: 'class',
    interfaces: []
  };
  function ShortRingBuffer(bits) {
    this._bits = bits;
    this._totalSize = 1 << this._bits;
    this._mask_1 = this._totalSize - 1 | 0;
    this._buffer_0 = new Int16Array(this._totalSize);
    this._readPos = 0;
    this._writePos = 0;
    this._availableWrite = this._totalSize;
    this._availableRead = 0;
  }
  ShortRingBuffer.prototype.write_4 = function (data, offset, size_1) {
    var toWrite = min2(this._availableWrite, size_1);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._buffer_0[this._writePos] = data[offset + n | 0];
        this._writePos = (this._writePos + 1 | 0) & this._mask_1;
      }
       while (inductionVariable < toWrite);
    var tmp1_this = this;
    tmp1_this._availableRead = tmp1_this._availableRead + toWrite | 0;
    var tmp2_this = this;
    tmp2_this._availableWrite = tmp2_this._availableWrite - toWrite | 0;
    return toWrite;
  };
  ShortRingBuffer.prototype.read_4 = function (data, offset, size_1) {
    var toRead = min2(this._availableRead, size_1);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset + n | 0] = this._buffer_0[this._readPos];
        this._readPos = (this._readPos + 1 | 0) & this._mask_1;
      }
       while (inductionVariable < toRead);
    var tmp1_this = this;
    tmp1_this._availableWrite = tmp1_this._availableWrite + toRead | 0;
    var tmp2_this = this;
    tmp2_this._availableRead = tmp2_this._availableRead - toRead | 0;
    return toRead;
  };
  ShortRingBuffer.prototype.peek_3 = function (offset) {
    return this._buffer_0[(this._readPos + offset | 0) & this._mask_1];
  };
  ShortRingBuffer.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ShortRingBuffer) {
      tmp_0 = this._availableRead === other._availableRead;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_equaler_0 = this._availableRead;
        var inductionVariable = 0;
        if (inductionVariable < tmp0_equaler_0)
          do {
            var n_2 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(this.peek_3(n_2) === other.peek_3(n_2))) {
              tmp$ret$0 = false;
              break l$ret$1;
            } else {
            }
          }
           while (inductionVariable < tmp0_equaler_0);
        tmp$ret$0 = true;
      }
       while (false);
      tmp = tmp$ret$0;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ShortRingBuffer.prototype.hashCode = function () {
    return this.contentHashCode_2();
  };
  ShortRingBuffer.prototype.contentHashCode_2 = function () {
    var tmp0_hashCoder_0 = this._availableRead;
    var out_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_1 = imul(out_1, 7);
        var tmp = out_1;
        out_1 = tmp + this.peek_3(n_3) | 0;
      }
       while (inductionVariable < tmp0_hashCoder_0);
    return out_1;
  };
  ShortRingBuffer.$metadata$ = {
    simpleName: 'ShortRingBuffer',
    kind: 'class',
    interfaces: []
  };
  function FloatRingBuffer(bits) {
    this._bits_0 = bits;
    this._totalSize_0 = 1 << this._bits_0;
    this._mask_2 = this._totalSize_0 - 1 | 0;
    this._buffer_1 = new Float32Array(this._totalSize_0);
    this._readPos_0 = 0;
    this._writePos_0 = 0;
    this._availableWrite_0 = this._totalSize_0;
    this._availableRead_0 = 0;
  }
  FloatRingBuffer.prototype.write_5 = function (data, offset, size_1) {
    var toWrite = min2(this._availableWrite_0, size_1);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._buffer_1[this._writePos_0] = data[offset + n | 0];
        this._writePos_0 = (this._writePos_0 + 1 | 0) & this._mask_2;
      }
       while (inductionVariable < toWrite);
    var tmp1_this = this;
    tmp1_this._availableRead_0 = tmp1_this._availableRead_0 + toWrite | 0;
    var tmp2_this = this;
    tmp2_this._availableWrite_0 = tmp2_this._availableWrite_0 - toWrite | 0;
    return toWrite;
  };
  FloatRingBuffer.prototype.read_5 = function (data, offset, size_1) {
    var toRead = min2(this._availableRead_0, size_1);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset + n | 0] = this._buffer_1[this._readPos_0];
        this._readPos_0 = (this._readPos_0 + 1 | 0) & this._mask_2;
      }
       while (inductionVariable < toRead);
    var tmp1_this = this;
    tmp1_this._availableWrite_0 = tmp1_this._availableWrite_0 + toRead | 0;
    var tmp2_this = this;
    tmp2_this._availableRead_0 = tmp2_this._availableRead_0 - toRead | 0;
    return toRead;
  };
  FloatRingBuffer.prototype.peek_3 = function (offset) {
    return this._buffer_1[(this._readPos_0 + offset | 0) & this._mask_2];
  };
  FloatRingBuffer.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof FloatRingBuffer) {
      tmp_0 = this._availableRead_0 === other._availableRead_0;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_equaler_0 = this._availableRead_0;
        var inductionVariable = 0;
        if (inductionVariable < tmp0_equaler_0)
          do {
            var n_2 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(this.peek_3(n_2) === other.peek_3(n_2))) {
              tmp$ret$0 = false;
              break l$ret$1;
            } else {
            }
          }
           while (inductionVariable < tmp0_equaler_0);
        tmp$ret$0 = true;
      }
       while (false);
      tmp = tmp$ret$0;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  FloatRingBuffer.prototype.hashCode = function () {
    return this.contentHashCode_2();
  };
  FloatRingBuffer.prototype.contentHashCode_2 = function () {
    var tmp0_hashCoder_0 = this._availableRead_0;
    var out_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_1 = imul(out_1, 7);
        var tmp = out_1;
        out_1 = tmp + toBits(this.peek_3(n_3)) | 0;
      }
       while (inductionVariable < tmp0_hashCoder_0);
    return out_1;
  };
  FloatRingBuffer.$metadata$ = {
    simpleName: 'FloatRingBuffer',
    kind: 'class',
    interfaces: []
  };
  function ByteRingBuffer(bits) {
    this._bits_1 = bits;
    this._totalSize_1 = 1 << this._bits_1;
    this._mask_3 = this._totalSize_1 - 1 | 0;
    this._buffer_2 = new Int8Array(this._totalSize_1);
    this._readPos_1 = 0;
    this._writePos_1 = 0;
    this._availableWrite_1 = this._totalSize_1;
    this._availableRead_1 = 0;
  }
  ByteRingBuffer.prototype._get_availableWrite__0 = function () {
    return this._availableWrite_1;
  };
  ByteRingBuffer.prototype._get_availableRead__4 = function () {
    return this._availableRead_1;
  };
  ByteRingBuffer.prototype.write_6 = function (data, offset, size_1) {
    var toWrite = min2(this._availableWrite_1, size_1);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._buffer_2[this._writePos_1] = data[offset + n | 0];
        this._writePos_1 = (this._writePos_1 + 1 | 0) & this._mask_3;
      }
       while (inductionVariable < toWrite);
    var tmp1_this = this;
    tmp1_this._availableRead_1 = tmp1_this._availableRead_1 + toWrite | 0;
    var tmp2_this = this;
    tmp2_this._availableWrite_1 = tmp2_this._availableWrite_1 - toWrite | 0;
    return toWrite;
  };
  ByteRingBuffer.prototype.read_30 = function (data, offset, size_1) {
    var toRead = min2(this._availableRead_1, size_1);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset + n | 0] = this._buffer_2[this._readPos_1];
        this._readPos_1 = (this._readPos_1 + 1 | 0) & this._mask_3;
      }
       while (inductionVariable < toRead);
    var tmp1_this = this;
    tmp1_this._availableWrite_1 = tmp1_this._availableWrite_1 + toRead | 0;
    var tmp2_this = this;
    tmp2_this._availableRead_1 = tmp2_this._availableRead_1 - toRead | 0;
    return toRead;
  };
  ByteRingBuffer.prototype.readByte_1 = function () {
    if (this._availableRead_1 <= 0)
      return -1;
    var out = this._buffer_2[this._readPos_1] & 255;
    this._readPos_1 = (this._readPos_1 + 1 | 0) & this._mask_3;
    var tmp0_this = this;
    var tmp1 = tmp0_this._availableRead_1;
    tmp0_this._availableRead_1 = tmp1 - 1 | 0;
    Unit_getInstance();
    var tmp2_this = this;
    var tmp3 = tmp2_this._availableWrite_1;
    tmp2_this._availableWrite_1 = tmp3 + 1 | 0;
    Unit_getInstance();
    return out;
  };
  ByteRingBuffer.prototype.peek_3 = function (offset) {
    return this._buffer_2[(this._readPos_1 + offset | 0) & this._mask_3];
  };
  ByteRingBuffer.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ByteRingBuffer) {
      tmp_0 = this._availableRead_1 === other._availableRead_1;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_equaler_0 = this._availableRead_1;
        var inductionVariable = 0;
        if (inductionVariable < tmp0_equaler_0)
          do {
            var n_2 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(this.peek_3(n_2) === other.peek_3(n_2))) {
              tmp$ret$0 = false;
              break l$ret$1;
            } else {
            }
          }
           while (inductionVariable < tmp0_equaler_0);
        tmp$ret$0 = true;
      }
       while (false);
      tmp = tmp$ret$0;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ByteRingBuffer.prototype.hashCode = function () {
    return this.contentHashCode_2();
  };
  ByteRingBuffer.prototype.contentHashCode_2 = function () {
    var tmp0_hashCoder_0 = this._availableRead_1;
    var out_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_1 = imul(out_1, 7);
        var tmp = out_1;
        out_1 = tmp + this.peek_3(n_3) | 0;
      }
       while (inductionVariable < tmp0_hashCoder_0);
    return out_1;
  };
  ByteRingBuffer.$metadata$ = {
    simpleName: 'ByteRingBuffer',
    kind: 'class',
    interfaces: []
  };
  function TGenStack() {
    this._items_1 = FastArrayList_init_$Create$();
  }
  TGenStack.prototype._get_size__60 = function () {
    return this._items_1._get_size__60();
  };
  TGenStack.prototype.isEmpty_53 = function () {
    return this._get_size__60() === 0;
  };
  TGenStack.prototype.push = function (v) {
    this._items_1.add_39(v);
    Unit_getInstance();
  };
  TGenStack.prototype.pop = function () {
    return this._items_1.removeAt_6(this._items_1._get_size__60() - 1 | 0);
  };
  TGenStack.prototype.contains_48 = function (element) {
    return this._items_1.contains_58(element);
  };
  TGenStack.prototype.contains_58 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_48((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  TGenStack.prototype.containsAll_41 = function (elements) {
    return this._items_1.containsAll_49(elements);
  };
  TGenStack.prototype.containsAll_49 = function (elements) {
    return this.containsAll_41(elements);
  };
  TGenStack.prototype.iterator_67 = function () {
    return this._items_1.iterator_67();
  };
  TGenStack.prototype.hashCode = function () {
    return this._items_1.hashCode();
  };
  TGenStack.prototype.equals = function (other) {
    var tmp;
    if (other instanceof TGenStack) {
      tmp = this._items_1.equals(other._items_1);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  TGenStack.$metadata$ = {
    simpleName: 'TGenStack',
    kind: 'class',
    interfaces: [Collection]
  };
  function Mixin_init_$Init$(extra, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      extra = null;
    Mixin.call($this, extra);
    return $this;
  }
  function Mixin_init_$Create$(extra, $mask0, $marker) {
    return Mixin_init_$Init$(extra, $mask0, $marker, Object.create(Mixin.prototype));
  }
  function Property_init_$Init$(name, defaultGen, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      name = null;
    Property.call($this, name, defaultGen);
    return $this;
  }
  function Property_init_$Create$(name, defaultGen, $mask0, $marker) {
    return Property_init_$Init$(name, defaultGen, $mask0, $marker, Object.create(Property.prototype));
  }
  function PropertyThis_init_$Init$(name, defaultGen, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      name = null;
    PropertyThis.call($this, name, defaultGen);
    return $this;
  }
  function PropertyThis_init_$Create$(name, defaultGen, $mask0, $marker) {
    return PropertyThis_init_$Init$(name, defaultGen, $mask0, $marker, Object.create(PropertyThis.prototype));
  }
  function Mixin(extra) {
    this._extra = extra;
  }
  Mixin.prototype._set_extra__71 = function (_set___) {
    this._extra = _set___;
  };
  Mixin.prototype._get_extra__71 = function () {
    return this._extra;
  };
  Mixin.$metadata$ = {
    simpleName: 'Mixin',
    kind: 'class',
    interfaces: [Extra]
  };
  function Property(name, defaultGen) {
    this._name_0 = name;
    this._defaultGen = defaultGen;
  }
  Property.$metadata$ = {
    simpleName: 'Property',
    kind: 'class',
    interfaces: []
  };
  function PropertyThis(name, defaultGen) {
    this._name_1 = name;
    this._defaultGen_0 = defaultGen;
  }
  PropertyThis.$metadata$ = {
    simpleName: 'PropertyThis',
    kind: 'class',
    interfaces: []
  };
  function Extra() {
  }
  Extra.$metadata$ = {
    simpleName: 'Extra',
    kind: 'interface',
    interfaces: []
  };
  function getExtra(_this_, name) {
    var tmp0_safe_receiver = _this_._get_extra__71();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_116(name);
  }
  function setExtra(_this_, name, value) {
    if (_this_._get_extra__71() == null)
      _this_._set_extra__71(LinkedHashMap_init_$Create$());
    var tmp0_safe_receiver = _this_._get_extra__71();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.put_18(name, value);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function toLinkedMap(_this_) {
    var tmp0_also_0 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_2 = _this_.iterator_67();
    while (tmp0_iterator_2.hasNext_33()) {
      var tmp1_loop_parameter_3 = tmp0_iterator_2.next_37();
      var key_4 = tmp1_loop_parameter_3.component1_1();
      var value_5 = tmp1_loop_parameter_3.component2_1();
      tmp0_also_0.put_18(key_4, value_5);
      Unit_getInstance();
    }
    return tmp0_also_0;
  }
  function linkedHashMapOf(pairs) {
    var tmp0_also_0 = LinkedHashMap_init_$Create$();
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var tmp1_loop_parameter_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key_4 = tmp1_loop_parameter_3.component1_1();
      var value_5 = tmp1_loop_parameter_3.component2_1();
      tmp0_also_0.put_18(key_4, value_5);
      Unit_getInstance();
    }
    return tmp0_also_0;
  }
  function _BSearchResult___init__impl_(raw) {
    return raw;
  }
  function _BSearchResult___get_raw__impl_(this_0) {
    return this_0;
  }
  function _BSearchResult___get_found__impl_(this_0) {
    return _BSearchResult___get_raw__impl_(this_0) >= 0;
  }
  function getCyclic(_this_, index) {
    return _this_[umod_1(index, _this_.length)];
  }
  function flip(_this_) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(_this_._get_size__60());
    var tmp0_iterator_1_2 = _this_._get_entries__10().iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(new Pair(item_2_3._get_value__10(), item_2_3._get_key__37()));
      Unit_getInstance();
    }
    return toMap_0(tmp0_mapTo_0_1);
  }
  function genericSort(subject, left, right, ops) {
    return genericSort_0(subject, left, right, ops, false);
  }
  function SortOps() {
  }
  SortOps.prototype.shiftLeft = function (subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last_1 = indexL + 1 | 0;
    if (last_1 <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.swap_2(subject, n - 1 | 0, n);
      }
       while (!(n === last_1));
  };
  SortOps.$metadata$ = {
    simpleName: 'SortOps',
    kind: 'class',
    interfaces: []
  };
  function genericSort_0(subject, left, right, ops, reversed_2) {
    timSort(subject, left, right, ops, reversed_2);
    return subject;
  }
  function timSort(arr, l, r, ops, reversed_2) {
    var RUN = 32;
    var n = (r - l | 0) + 1 | 0;
    var progression = step(until(0, n), RUN);
    var inductionVariable = progression._first_0;
    var last_1 = progression._last;
    var step_0 = progression._step_2;
    if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        insertionSort(arr, l + i | 0, l + min2(i + 31 | 0, n - 1 | 0) | 0, ops, reversed_2);
      }
       while (!(i === last_1));
    var size_1 = RUN;
    while (size_1 < n) {
      var progression_0 = step(until(0, n), imul(2, size_1));
      var inductionVariable_0 = progression_0._first_0;
      var last_2 = progression_0._last;
      var step_1 = progression_0._step_2;
      if ((step_1 > 0 ? inductionVariable_0 <= last_2 : false) ? true : step_1 < 0 ? last_2 <= inductionVariable_0 : false)
        do {
          var left = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_1 | 0;
          var mid = (left + size_1 | 0) - 1 | 0;
          var right = min2((left + imul(2, size_1) | 0) - 1 | 0, n - 1 | 0);
          merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed_2);
        }
         while (!(left === last_2));
      size_1 = imul(size_1, 2);
    }
  }
  function insertionSort(arr, left, right, ops, reversed_2) {
    var inductionVariable = left + 1 | 0;
    if (inductionVariable <= right)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var m = n - 1 | 0;
        $l$break: while (m >= left) {
          if (negateIf(ops.compare_9(arr, m, n), reversed_2) <= 0)
            break $l$break;
          var tmp1 = m;
          m = tmp1 - 1 | 0;
          Unit_getInstance();
        }
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        Unit_getInstance();
        if (!(m === n))
          ops.shiftLeft(arr, m, n);
      }
       while (!(n === right));
  }
  function merge(arr, start, mid, end, ops, reversed_2) {
    var s = start;
    var m = mid;
    var s2 = m + 1 | 0;
    if (negateIf(ops.compare_9(arr, m, s2), reversed_2) <= 0)
      return Unit_getInstance();
    while (s <= m ? s2 <= end : false) {
      if (negateIf(ops.compare_9(arr, s, s2), reversed_2) <= 0) {
        var tmp0 = s;
        s = tmp0 + 1 | 0;
        Unit_getInstance();
      } else {
        ops.shiftLeft(arr, s, s2);
        var tmp1 = s;
        s = tmp1 + 1 | 0;
        Unit_getInstance();
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        Unit_getInstance();
        var tmp3 = s2;
        s2 = tmp3 + 1 | 0;
        Unit_getInstance();
      }
    }
  }
  function negateIf(_this_, doNegate) {
    return doNegate ? -_this_ | 0 : _this_;
  }
  function asFakeMutable(_this_) {
    return new FakeMutableSetMapEntry(_this_);
  }
  function FakeMutableCollection(collection) {
    this._collection = collection;
  }
  FakeMutableCollection.prototype.contains_50 = function (element) {
    return this._collection.contains_58(element);
  };
  FakeMutableCollection.prototype.contains_58 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_50((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  FakeMutableCollection.prototype.containsAll_43 = function (elements) {
    return this._collection.containsAll_49(elements);
  };
  FakeMutableCollection.prototype.containsAll_49 = function (elements) {
    return this.containsAll_43(elements);
  };
  FakeMutableCollection.prototype.isEmpty_53 = function () {
    return this._collection.isEmpty_53();
  };
  FakeMutableCollection.prototype._get_size__60 = function () {
    return this._collection._get_size__60();
  };
  FakeMutableCollection.prototype.add_35 = function (element) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableCollection.prototype.add_39 = function (element) {
    return this.add_35((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  FakeMutableCollection.prototype.addAll_20 = function (elements) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableCollection.prototype.addAll_24 = function (elements) {
    return this.addAll_20(elements);
  };
  FakeMutableCollection.prototype.remove_72 = function (element) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableCollection.prototype.remove_47 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.remove_72((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  FakeMutableCollection.prototype.iterator_67 = function () {
    return asFakeMutable_1(this._collection.iterator_67());
  };
  FakeMutableCollection.$metadata$ = {
    simpleName: 'FakeMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection, Collection]
  };
  function asFakeMutable_0(_this_) {
    return new FakeMutableCollection(_this_);
  }
  function FakeMutableSetMapEntry(set_0) {
    this._set = set_0;
  }
  FakeMutableSetMapEntry.prototype.add_37 = function (element) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableSetMapEntry.prototype.add_39 = function (element) {
    return this.add_37((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  FakeMutableSetMapEntry.prototype.addAll_22 = function (elements) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableSetMapEntry.prototype.addAll_24 = function (elements) {
    return this.addAll_22(elements);
  };
  FakeMutableSetMapEntry.prototype.iterator_67 = function () {
    var tmp0_map_0 = this._set;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(new FakeMutableMapEntry(item_2_3));
      Unit_getInstance();
    }
    return asFakeMutable_1(tmp0_mapTo_0_1.iterator_67());
  };
  FakeMutableSetMapEntry.prototype.remove_43 = function (element) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableSetMapEntry.prototype.remove_47 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.remove_43((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  FakeMutableSetMapEntry.prototype._get_size__60 = function () {
    return this._set._get_size__60();
  };
  FakeMutableSetMapEntry.prototype.contains_52 = function (element) {
    return this._set.contains_58(element);
  };
  FakeMutableSetMapEntry.prototype.contains_58 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    else {
    }
    return this.contains_52((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  FakeMutableSetMapEntry.prototype.containsAll_45 = function (elements) {
    return this._set.containsAll_49(elements);
  };
  FakeMutableSetMapEntry.prototype.containsAll_49 = function (elements) {
    return this.containsAll_45(elements);
  };
  FakeMutableSetMapEntry.prototype.isEmpty_53 = function () {
    return this._set.isEmpty_53();
  };
  FakeMutableSetMapEntry.$metadata$ = {
    simpleName: 'FakeMutableSetMapEntry',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function FakeMutableIterator(iterator_0) {
    this._iterator_0 = iterator_0;
  }
  FakeMutableIterator.prototype.hasNext_33 = function () {
    return this._iterator_0.hasNext_33();
  };
  FakeMutableIterator.prototype.next_37 = function () {
    return this._iterator_0.next_37();
  };
  FakeMutableIterator.prototype.remove_69 = function () {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableIterator.prototype.remove_46 = function () {
    return this.remove_69();
  };
  FakeMutableIterator.$metadata$ = {
    simpleName: 'FakeMutableIterator',
    kind: 'class',
    interfaces: [MutableIterator, Iterator_3]
  };
  function asFakeMutable_1(_this_) {
    return new FakeMutableIterator(_this_);
  }
  function FakeMutableMapEntry(entry) {
    this._entry_0 = entry;
  }
  FakeMutableMapEntry.prototype._get_key__37 = function () {
    return this._entry_0._get_key__37();
  };
  FakeMutableMapEntry.prototype._get_value__10 = function () {
    return this._entry_0._get_value__10();
  };
  FakeMutableMapEntry.prototype.setValue_2 = function (newValue) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  FakeMutableMapEntry.$metadata$ = {
    simpleName: 'FakeMutableMapEntry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function umod_1(_this_, other) {
    var remainder = _this_ % other;
    return remainder < 0 ? remainder + other | 0 : remainder;
  }
  function max2(a, b) {
    return a > b ? a : b;
  }
  function ilog2Ceil(v) {
    var tmp0_log2_0 = v;
    var tmp1_ceil_0 = Math.log2(tmp0_log2_0);
    var tmp0_unsafeCast_0_1 = Math.ceil(tmp1_ceil_0);
    return numberToInt(tmp0_unsafeCast_0_1);
  }
  function arraycopy(src, srcPos, dst, dstPos, size_1) {
    var tmp0_copyInto_0 = srcPos + size_1 | 0;
    var tmp = src;
    arrayCopy_0(tmp, dst, dstPos, srcPos, tmp0_copyInto_0);
    return dst;
  }
  function contentHashCode_9(_this_, src, dst) {
    var tmp0_hashCoder_0 = dst - src | 0;
    var out_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_1 = imul(out_1, 7);
        var tmp = out_1;
        out_1 = tmp + numberToInt(_this_[src + n_3 | 0]) | 0;
      }
       while (inductionVariable < tmp0_hashCoder_0);
    return out_1;
  }
  function contentEquals_12(_this_, that, src, dst) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_equaler_0 = dst - src | 0;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_equaler_0)
        do {
          var n_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(_this_[src + n_2 | 0] === that[src + n_2 | 0])) {
            tmp$ret$0 = false;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable < tmp0_equaler_0);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function arraycopy_0(src, srcPos, dst, dstPos, size_1) {
    var tmp0_copyInto_0 = srcPos + size_1 | 0;
    var tmp = src;
    arrayCopy_0(tmp, dst, dstPos, srcPos, tmp0_copyInto_0);
    return dst;
  }
  function contentHashCode_10(_this_, src, dst) {
    var tmp0_hashCoder_0 = dst - src | 0;
    var out_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_hashCoder_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_1 = imul(out_1, 7);
        var tmp = out_1;
        out_1 = tmp + _this_[src + n_3 | 0] | 0;
      }
       while (inductionVariable < tmp0_hashCoder_0);
    return out_1;
  }
  function contentEquals_13(_this_, that, src, dst) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_equaler_0 = dst - src | 0;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_equaler_0)
        do {
          var n_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(_this_[src + n_2 | 0] === that[src + n_2 | 0])) {
            tmp$ret$0 = false;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable < tmp0_equaler_0);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function ilog2(v) {
    var tmp0_log2_0 = v;
    return numberToInt(Math.log2(tmp0_log2_0));
  }
  function min2(a, b) {
    return a < b ? a : b;
  }
  function arraycopy_1(src, srcPos, dst, dstPos, size_1) {
    var tmp0_copyInto_0 = srcPos + size_1 | 0;
    arrayCopy_0(src, dst, dstPos, srcPos, tmp0_copyInto_0);
    return dst;
  }
  function FastArrayList_init_$Init$($this) {
    FastArrayList.call($this, []);
    return $this;
  }
  function FastArrayList_init_$Create$() {
    return FastArrayList_init_$Init$(Object.create(FastArrayList.prototype));
  }
  function FastArrayList_init_$Init$_0(initialCapacity, $this) {
    FastArrayList.call($this, []);
    return $this;
  }
  function FastArrayList_init_$Create$_0(initialCapacity) {
    return FastArrayList_init_$Init$_0(initialCapacity, Object.create(FastArrayList.prototype));
  }
  function rangeCheck_0($this, index) {
    if (index < 0 ? true : index >= $this._get_size__60()) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index + ', size: ' + $this._get_size__60());
    }return index;
  }
  function insertionRangeCheck_0($this, index) {
    if (index < 0 ? true : index > $this._get_size__60()) {
      throw IndexOutOfBoundsException_init_$Create$_0('' + 'index: ' + index + ', size: ' + $this._get_size__60());
    }return index;
  }
  function FastArrayList(array) {
    AbstractMutableList.call(this);
    this._array_4 = array;
    this._isReadOnly_1 = false;
  }
  FastArrayList.prototype._get_size__60 = function () {
    return this._array_4.length;
  };
  FastArrayList.prototype.get_137 = function (index) {
    var tmp0_asDynamic_0 = this._array_4[rangeCheck_0(this, index)];
    return tmp0_asDynamic_0;
  };
  FastArrayList.prototype.set_8 = function (index, element) {
    rangeCheck_0(this, index);
    Unit_getInstance();
    var tmp0_apply_0 = this._array_4[index];
    this._array_4[index] = element;
    var tmp1_asDynamic_0 = tmp0_apply_0;
    return tmp1_asDynamic_0;
  };
  FastArrayList.prototype.add_39 = function (element) {
    var tmp0_asDynamic_0 = this._array_4;
    tmp0_asDynamic_0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__1();
    tmp0_this._set_modCount__1(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  FastArrayList.prototype.add_40 = function (index, element) {
    var tmp0_asDynamic_0 = this._array_4;
    tmp0_asDynamic_0.splice(insertionRangeCheck_0(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__1();
    tmp0_this._set_modCount__1(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  FastArrayList.prototype.addAll_24 = function (elements) {
    if (elements.isEmpty_53())
      return false;
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._array_4;
    var tmp1_plus_0 = copyToArray_0(elements);
    tmp._array_4 = tmp0_plus_0.concat(tmp1_plus_0);
    var tmp1_this = this;
    var tmp2 = tmp1_this._get_modCount__1();
    tmp1_this._set_modCount__1(tmp2 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  FastArrayList.prototype.removeAt_6 = function (index) {
    rangeCheck_0(this, index);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__1();
    tmp0_this._set_modCount__1(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp;
    if (index === _get_lastIndex__3(this)) {
      var tmp0_asDynamic_0 = this._array_4;
      tmp = tmp0_asDynamic_0.pop();
    } else {
      var tmp1_asDynamic_0 = this._array_4;
      tmp = tmp1_asDynamic_0.splice(index, 1)[0];
    }
    return tmp;
  };
  FastArrayList.prototype.remove_47 = function (element) {
    var inductionVariable = 0;
    var last_1 = this._array_4.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_1(this._array_4[index], element)) {
          var tmp0_asDynamic_0 = this._array_4;
          tmp0_asDynamic_0.splice(index, 1);
          var tmp1_this = this;
          var tmp2 = tmp1_this._get_modCount__1();
          tmp1_this._set_modCount__1(tmp2 + 1 | 0);
          Unit_getInstance();
          return true;
        }}
       while (inductionVariable <= last_1);
    return false;
  };
  FastArrayList.prototype.clear_33 = function () {
    var tmp = this;
    tmp._array_4 = [];
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__1();
    tmp0_this._set_modCount__1(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  FastArrayList.prototype.indexOf_4 = function (element) {
    return indexOf(this._array_4, element);
  };
  FastArrayList.prototype.toString = function () {
    var tmp = this._array_4;
    return '[' + joinToString$default(tmp, ', ', null, null, 0, null, null, 62, null) + ']';
  };
  FastArrayList.prototype.toArray_1 = function () {
    return [].slice.call(this._array_4);
  };
  FastArrayList.prototype.toArray = function () {
    return this.toArray_1();
  };
  FastArrayList.$metadata$ = {
    simpleName: 'FastArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  function FastIdentityMap() {
    var tmp0_asDynamic_0 = new Map();
    return tmp0_asDynamic_0;
  }
  function clear(_this_) {
    return _this_.clear();
  }
  function remove_0(_this_, key) {
    return _this_.delete(key);
  }
  function get(_this_, key) {
    return _this_.get(key);
  }
  function set(_this_, key, value) {
    return _this_.set(key, value);
  }
  function FastIntMap() {
    var tmp0_asDynamic_0 = new Map();
    return tmp0_asDynamic_0;
  }
  function _get_size_(_this_) {
    return _this_.size;
  }
  function FastStringMap() {
    var tmp0_asDynamic_0 = new Map();
    return tmp0_asDynamic_0;
  }
  function KdsAtomicRef(initial) {
    this._value_2 = initial;
  }
  KdsAtomicRef.$metadata$ = {
    simpleName: 'KdsAtomicRef',
    kind: 'class',
    interfaces: []
  };
  var CONCURRENCY_COUNT;
  function arraycopy_2(src, srcPos, dst, dstPos, size_1) {
    var tmp0_copyInto_0 = srcPos + size_1 | 0;
    var tmp = src;
    arrayCopy_0(tmp, dst, dstPos, srcPos, tmp0_copyInto_0);
    Unit_getInstance();
  }
  function arraycopy_3(src, srcPos, dst, dstPos, size_1) {
    var tmp0_copyInto_0 = srcPos + size_1 | 0;
    var tmp = src;
    arrayCopy_0(tmp, dst, dstPos, srcPos, tmp0_copyInto_0);
    Unit_getInstance();
  }
  function arraycopy_4(src, srcPos, dst, dstPos, size_1) {
    var tmp0_copyInto_0 = srcPos + size_1 | 0;
    var tmp = src;
    arrayCopy_0(tmp, dst, dstPos, srcPos, tmp0_copyInto_0);
    Unit_getInstance();
  }
  function arraycopy_5(src, srcPos, dst, dstPos, size_1) {
    var tmp0_copyInto_0 = isArray(dst) ? dst : THROW_CCE();
    var tmp1_copyInto_0 = srcPos + size_1 | 0;
    arrayCopy_0(src, tmp0_copyInto_0, dstPos, srcPos, tmp1_copyInto_0);
    Unit_getInstance();
  }
  function arraycopy_6(src, srcPos, dst, dstPos, size_1) {
    var tmp0_copyInto_0 = srcPos + size_1 | 0;
    var tmp = src;
    arrayCopy_0(tmp, dst, dstPos, srcPos, tmp0_copyInto_0);
    Unit_getInstance();
  }
  function arraycopy_7(src, srcPos, dst, dstPos, size_1) {
    var tmp0_copyInto_0 = srcPos + size_1 | 0;
    var tmp = src;
    arrayCopy_0(tmp, dst, dstPos, srcPos, tmp0_copyInto_0);
    Unit_getInstance();
  }
  function arrayfill(array, value, start, end) {
    return fill_2(array, value, start, end);
  }
  function _UByteArrayInt___init__impl_(bytes) {
    return bytes;
  }
  function _UByteArrayInt___get_bytes__impl_(this_0) {
    return this_0;
  }
  function _UByteArrayInt___get_size__impl_(this_0) {
    return _UByteArrayInt___get_bytes__impl_(this_0).length;
  }
  function UByteArrayInt__get_impl(this_0, index) {
    return _UByteArrayInt___get_bytes__impl_(this_0)[index] & 255;
  }
  function UByteArrayInt__set_impl(this_0, index, value) {
    return _UByteArrayInt___get_bytes__impl_(this_0)[index] = toByte(value);
  }
  function UByteArrayInt(size_1) {
    return _UByteArrayInt___init__impl_(new Int8Array(size_1));
  }
  function asByteArray(_this_) {
    return _UByteArrayInt___get_bytes__impl_(_this_);
  }
  function extract(_this_, offset, count_0) {
    return _this_ >>> offset & mask(count_0);
  }
  function insert(_this_, value, offset, count_0) {
    var mask_0 = mask(count_0);
    var clearValue = _this_ & ~(mask_0 << offset);
    return clearValue | (value & mask_0) << offset;
  }
  function extract_0(_this_, offset) {
    return !((_this_ >>> offset & 1) === 0);
  }
  function extractScaledFF(_this_, offset, count_0) {
    return extractScaled(_this_, offset, count_0, 255);
  }
  function extractScaledFFDefault(_this_, offset, count_0, default_0) {
    return count_0 === 0 ? default_0 : extractScaled(_this_, offset, count_0, 255);
  }
  function insertScaledFF(_this_, value, offset, count_0) {
    return count_0 === 0 ? _this_ : insertScaled(_this_, value, offset, count_0, 255);
  }
  function extract8(_this_, offset) {
    return _this_ >>> offset & 255;
  }
  function insert8(_this_, value, offset) {
    return insert(_this_, value, offset, 8);
  }
  function extractByte(_this_, offset) {
    return toByte(_this_ >>> offset);
  }
  function signExtend(_this_, bits) {
    return _this_ << (32 - bits | 0) >> (32 - bits | 0);
  }
  function mask(_this_) {
    return (1 << _this_) - 1 | 0;
  }
  function extractScaled(_this_, offset, count_0, scale_1) {
    return imul(extract(_this_, offset, count_0), scale_1) / mask(count_0) | 0;
  }
  function insertScaled(_this_, value, offset, count_0, scale_1) {
    return insert(_this_, imul(value, mask(count_0)) / scale_1 | 0, offset, count_0);
  }
  function asInt32Buffer(_this_) {
    return sliceInt32Buffer$default(_this_, 0, 0, 3, null);
  }
  function sliceInt32Buffer(_this_, offset, size_1) {
    return new Int32Array(_this_, imul(offset, 4), size_1);
  }
  function sliceInt32Buffer$default(_this_, offset, size_1, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset = 0;
    if (!(($mask0 & 2) === 0)) {
      size_1 = (_this_.byteLength / 4 | 0) - offset | 0;
    }return sliceInt32Buffer(_this_, offset, size_1);
  }
  function asInt8Buffer(_this_) {
    return sliceInt8Buffer$default(_this_, 0, 0, 3, null);
  }
  function asInt16Buffer(_this_) {
    return sliceInt16Buffer$default(_this_, 0, 0, 3, null);
  }
  function asFloat32Buffer(_this_) {
    return sliceFloat32Buffer$default(_this_, 0, 0, 3, null);
  }
  function asFloat64Buffer(_this_) {
    return sliceFloat64Buffer$default(_this_, 0, 0, 3, null);
  }
  function sliceInt8Buffer(_this_, offset, size_1) {
    return new Int8Array(_this_, imul(offset, 1), size_1);
  }
  function sliceInt8Buffer$default(_this_, offset, size_1, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset = 0;
    if (!(($mask0 & 2) === 0)) {
      size_1 = (_this_.byteLength / 1 | 0) - offset | 0;
    }return sliceInt8Buffer(_this_, offset, size_1);
  }
  function sliceInt16Buffer(_this_, offset, size_1) {
    return new Int16Array(_this_, imul(offset, 2), size_1);
  }
  function sliceInt16Buffer$default(_this_, offset, size_1, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset = 0;
    if (!(($mask0 & 2) === 0)) {
      size_1 = (_this_.byteLength / 2 | 0) - offset | 0;
    }return sliceInt16Buffer(_this_, offset, size_1);
  }
  function sliceFloat32Buffer(_this_, offset, size_1) {
    return new Float32Array(_this_, imul(offset, 4), size_1);
  }
  function sliceFloat32Buffer$default(_this_, offset, size_1, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset = 0;
    if (!(($mask0 & 2) === 0)) {
      size_1 = (_this_.byteLength / 4 | 0) - offset | 0;
    }return sliceFloat32Buffer(_this_, offset, size_1);
  }
  function sliceFloat64Buffer(_this_, offset, size_1) {
    return new Float64Array(_this_, imul(offset, 8), size_1);
  }
  function sliceFloat64Buffer$default(_this_, offset, size_1, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset = 0;
    if (!(($mask0 & 2) === 0)) {
      size_1 = (_this_.byteLength / 8 | 0) - offset | 0;
    }return sliceFloat64Buffer(_this_, offset, size_1);
  }
  function arraycopy_8(src, srcPos, dst, dstPos, size_1) {
    var tmp = src.buffer;
    var tmp_0 = imul(srcPos, 4);
    return arraycopy_11(tmp, tmp_0, dst.buffer, imul(dstPos, 4), imul(size_1, 4));
  }
  function arraycopy_9(src, srcPos, dst, dstPos, size_1) {
    return arraycopy_12(src, srcPos, dst.buffer, dstPos, size_1);
  }
  function arraycopy_10(src, srcPos, dst, dstPos, size_1) {
    return arraycopy_13(src, srcPos, dst.buffer, dstPos, size_1);
  }
  function ByteArrayBuilder_init_$Init$(data, size_1, allowGrow, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      size_1 = data.length;
    if (!(($mask0 & 4) === 0))
      allowGrow = true;
    ByteArrayBuilder.call($this, data, size_1, allowGrow);
    return $this;
  }
  function ByteArrayBuilder_init_$Create$(data, size_1, allowGrow, $mask0, $marker) {
    return ByteArrayBuilder_init_$Init$(data, size_1, allowGrow, $mask0, $marker, Object.create(ByteArrayBuilder.prototype));
  }
  function ByteArrayBuilder_init_$Init$_0(initialCapacity, $this) {
    var tmp = new Int8Array(initialCapacity);
    ByteArrayBuilder_init_$Init$(tmp, 0, false, 4, null, $this);
    return $this;
  }
  function ByteArrayBuilder_init_$Create$_0(initialCapacity) {
    return ByteArrayBuilder_init_$Init$_0(initialCapacity, Object.create(ByteArrayBuilder.prototype));
  }
  function ByteArrayBuilder_init_$Init$_1(initialCapacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialCapacity = 4096;
    ByteArrayBuilder_init_$Init$_0(initialCapacity, $this);
    return $this;
  }
  function ByteArrayBuilder_init_$Create$_1(initialCapacity, $mask0, $marker) {
    return ByteArrayBuilder_init_$Init$_1(initialCapacity, $mask0, $marker, Object.create(ByteArrayBuilder.prototype));
  }
  function ensure_1($this, expected) {
    if ($this._data_8.length < expected) {
      if (!$this._allowGrow)
        throw RuntimeException_init_$Create$('ByteArrayBuffer configured to not grow!');
      $this._data_8 = copyOf($this._data_8, max2_0(expected, imul($this._data_8.length + 7 | 0, 5)));
    }}
  function ByteArrayBuilder(data, size_1, allowGrow) {
    this._data_8 = data;
    this._allowGrow = allowGrow;
    this.__size_1 = size_1;
  }
  ByteArrayBuilder.prototype._set_size__1 = function (value) {
    var oldPosition = this.__size_1;
    var newPosition = value;
    ensure_1(this, newPosition);
    this.__size_1 = newPosition;
    if (newPosition > oldPosition) {
      arrayfill(this._data_8, 0, oldPosition, newPosition);
    }};
  ByteArrayBuilder.prototype._get_size__60 = function () {
    return this.__size_1;
  };
  ByteArrayBuilder.prototype.append_6 = function (array, offset, len) {
    ensure_1(this, this.__size_1 + len | 0);
    var tmp0_also_0_1 = arraycopy_2(array, offset, this._data_8, this.__size_1, len);
    var tmp0_this_2_2 = this;
    tmp0_this_2_2.__size_1 = tmp0_this_2_2.__size_1 + len | 0;
  };
  ByteArrayBuilder.prototype.append$default = function (array, offset, len, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      len = array.length - offset | 0;
    return this.append_6(array, offset, len);
  };
  ByteArrayBuilder.prototype.append_7 = function (v) {
    var tmp0_prepare_0_2 = 1;
    ensure_1(this, this.__size_1 + tmp0_prepare_0_2 | 0);
    var tmp0_also_0_1_3 = this._data_8[this.__size_1] = v;
    var tmp0_this_2_2_4 = this;
    tmp0_this_2_2_4.__size_1 = tmp0_this_2_2_4.__size_1 + tmp0_prepare_0_2 | 0;
    return this;
  };
  ByteArrayBuilder.prototype.clear_33 = function () {
    this.__size_1 = 0;
  };
  ByteArrayBuilder.prototype.toByteArray = function () {
    return copyOf(this._data_8, this.__size_1);
  };
  ByteArrayBuilder.$metadata$ = {
    simpleName: 'ByteArrayBuilder',
    kind: 'class',
    interfaces: []
  };
  function readS16(_this_, o, little) {
    return little ? readS16LE(_this_, o) : readS16BE(_this_, o);
  }
  function write16(_this_, o, v, little) {
    return little ? write16LE(_this_, o, v) : write16BE(_this_, o, v);
  }
  function readU16LE(_this_, o) {
    return u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8;
  }
  function readS32LE(_this_, o) {
    return u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 2 | 0) << 16 | u8(_this_, o + 3 | 0) << 24;
  }
  function readS32BE(_this_, o) {
    return u8(_this_, o + 3 | 0) << 0 | u8(_this_, o + 2 | 0) << 8 | u8(_this_, o + 1 | 0) << 16 | u8(_this_, o + 0 | 0) << 24;
  }
  function write16LE(_this_, o, v) {
    _this_[o + 0 | 0] = extractByte(v, 0);
    return _this_[o + 1 | 0] = extractByte(v, 8);
  }
  function readU8(_this_, o) {
    return _this_[o] & 255;
  }
  function readS16LE(_this_, o) {
    return signExtend(u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8, 16);
  }
  function readS24LE(_this_, o) {
    return signExtend(u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 2 | 0) << 16, 24);
  }
  function readU16BE(_this_, o) {
    return u8(_this_, o + 1 | 0) << 0 | u8(_this_, o + 0 | 0) << 8;
  }
  function readU24LE(_this_, o) {
    return u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 2 | 0) << 16;
  }
  function readU24BE(_this_, o) {
    return u8(_this_, o + 2 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 0 | 0) << 16;
  }
  function write16BE(_this_, o, v) {
    _this_[o + 1 | 0] = extractByte(v, 0);
    return _this_[o + 0 | 0] = extractByte(v, 8);
  }
  function write24LE(_this_, o, v) {
    _this_[o + 0 | 0] = extractByte(v, 0);
    _this_[o + 1 | 0] = extractByte(v, 8);
    return _this_[o + 2 | 0] = extractByte(v, 16);
  }
  function write24BE(_this_, o, v) {
    _this_[o + 2 | 0] = extractByte(v, 0);
    _this_[o + 1 | 0] = extractByte(v, 8);
    return _this_[o + 0 | 0] = extractByte(v, 16);
  }
  function write32LE(_this_, o, v) {
    _this_[o + 0 | 0] = extractByte(v, 0);
    _this_[o + 1 | 0] = extractByte(v, 8);
    _this_[o + 2 | 0] = extractByte(v, 16);
    return _this_[o + 3 | 0] = extractByte(v, 24);
  }
  function write32BE(_this_, o, v) {
    _this_[o + 3 | 0] = extractByte(v, 0);
    _this_[o + 2 | 0] = extractByte(v, 8);
    _this_[o + 1 | 0] = extractByte(v, 16);
    return _this_[o + 0 | 0] = extractByte(v, 24);
  }
  function write8(_this_, o, v) {
    return _this_[o] = toByte(v);
  }
  function readS16BE(_this_, o) {
    return signExtend(u8(_this_, o + 1 | 0) << 0 | u8(_this_, o + 0 | 0) << 8, 16);
  }
  function u8(_this_, o) {
    return _this_[o] & 255;
  }
  function readS64LE(_this_, o) {
    var tmp0_read32LE_0 = o + 0 | 0;
    var tmp1__get_unsigned__0 = u8(_this_, tmp0_read32LE_0 + 0 | 0) << 0 | u8(_this_, tmp0_read32LE_0 + 1 | 0) << 8 | u8(_this_, tmp0_read32LE_0 + 2 | 0) << 16 | u8(_this_, tmp0_read32LE_0 + 3 | 0) << 24;
    var tmp = toLong(tmp1__get_unsigned__0).and(new Long(-1, 0)).shl_0(0);
    var tmp2_read32LE_0 = o + 4 | 0;
    var tmp3__get_unsigned__0 = u8(_this_, tmp2_read32LE_0 + 0 | 0) << 0 | u8(_this_, tmp2_read32LE_0 + 1 | 0) << 8 | u8(_this_, tmp2_read32LE_0 + 2 | 0) << 16 | u8(_this_, tmp2_read32LE_0 + 3 | 0) << 24;
    return tmp.or(toLong(tmp3__get_unsigned__0).and(new Long(-1, 0)).shl_0(32));
  }
  function readU32LE(_this_, o) {
    var tmp0__get_unsigned__0 = u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 2 | 0) << 16 | u8(_this_, o + 3 | 0) << 24;
    return toLong(tmp0__get_unsigned__0).and(new Long(-1, 0));
  }
  function readS8(_this_, o) {
    return _this_[o];
  }
  function readF32LE(_this_, o) {
    var tmp0_fromBits_0 = FloatCompanionObject_getInstance();
    var tmp1_fromBits_0 = u8(_this_, o + 0 | 0) << 0 | u8(_this_, o + 1 | 0) << 8 | u8(_this_, o + 2 | 0) << 16 | u8(_this_, o + 3 | 0) << 24;
    return floatFromBits(tmp1_fromBits_0);
  }
  function readS64BE(_this_, o) {
    var tmp0_read32BE_0 = o + 4 | 0;
    var tmp1__get_unsigned__0 = u8(_this_, tmp0_read32BE_0 + 3 | 0) << 0 | u8(_this_, tmp0_read32BE_0 + 2 | 0) << 8 | u8(_this_, tmp0_read32BE_0 + 1 | 0) << 16 | u8(_this_, tmp0_read32BE_0 + 0 | 0) << 24;
    var tmp = toLong(tmp1__get_unsigned__0).and(new Long(-1, 0)).shl_0(0);
    var tmp2_read32BE_0 = o + 0 | 0;
    var tmp3__get_unsigned__0 = u8(_this_, tmp2_read32BE_0 + 3 | 0) << 0 | u8(_this_, tmp2_read32BE_0 + 2 | 0) << 8 | u8(_this_, tmp2_read32BE_0 + 1 | 0) << 16 | u8(_this_, tmp2_read32BE_0 + 0 | 0) << 24;
    return tmp.or(toLong(tmp3__get_unsigned__0).and(new Long(-1, 0)).shl_0(32));
  }
  function readByteArray(_this_, o, count_0) {
    return copyOfRange(_this_, o, o + count_0 | 0);
  }
  function readShortArrayBE(_this_, o, count_0) {
    var tmp0_readTypedArray_0 = 2;
    var tmp1_readTypedArray_0 = new Int16Array(count_0);
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n_3_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2__anonymous__3 = o + imul(n_3_2, tmp0_readTypedArray_0) | 0;
        tmp1_readTypedArray_0[n_3_2] = toShort(readS16BE(_this_, tmp2__anonymous__3));
      }
       while (inductionVariable < count_0);
    return tmp1_readTypedArray_0;
  }
  function readCharArrayBE(_this_, o, count_0) {
    var tmp0_readTypedArray_0 = 2;
    var tmp1_readTypedArray_0 = charArray(count_0);
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n_3_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2__anonymous__3 = o + imul(n_3_2, tmp0_readTypedArray_0) | 0;
        tmp1_readTypedArray_0[n_3_2] = numberToChar(readS16BE(_this_, tmp2__anonymous__3));
      }
       while (inductionVariable < count_0);
    return tmp1_readTypedArray_0;
  }
  function sizeAligned(_this_, $this) {
    return (_this_ + 15 | 0) & -16;
  }
  function Companion_39() {
    Companion_instance_38 = this;
  }
  Companion_39.prototype.allocUnaligned = function (size_1) {
    return new FBuffer(new ArrayBuffer(size_1), size_1);
  };
  Companion_39.prototype.alloc_0 = function (size_1) {
    return this.allocUnaligned(sizeAligned(size_1, this));
  };
  Companion_39.prototype.allocNoDirectUnaligned = function (size_1) {
    return new FBuffer(new ArrayBuffer(size_1), size_1);
  };
  Companion_39.prototype.allocNoDirect = function (size_1) {
    return this.allocNoDirectUnaligned(sizeAligned(size_1, this));
  };
  Companion_39.prototype.invoke_874 = function (size_1) {
    var tmp0_MemBufferAlloc_0 = sizeAligned(size_1, this);
    return new FBuffer(new ArrayBuffer(tmp0_MemBufferAlloc_0), size_1);
  };
  Companion_39.prototype.copy = function (src, srcPos, dst, dstPos, length) {
    return arraycopy_11(src._get_buffer__1(), srcPos, dst._get_buffer__1(), dstPos, length);
  };
  Companion_39.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_38;
  function Companion_getInstance_38() {
    if (Companion_instance_38 == null)
      new Companion_39();
    return Companion_instance_38;
  }
  function FBuffer(mem, size_1) {
    Companion_getInstance_38();
    this._mem = mem;
    this._size_3 = size_1;
    this._data_9 = getData(this._mem);
    this._arrayByte = asInt8Buffer(this._mem);
    this._arrayShort = asInt16Buffer(this._mem);
    this._arrayInt = asInt32Buffer(this._mem);
    this._arrayFloat = asFloat32Buffer(this._mem);
    this._arrayDouble = asFloat64Buffer(this._mem);
    this._fast32 = NewFast32Buffer(this._mem);
  }
  FBuffer.prototype._get_buffer__1 = function () {
    return this._mem;
  };
  FBuffer.prototype.set_35 = function (index, value) {
    var tmp0_set_0 = this._arrayByte;
    var tmp1_set_0 = toByte(value);
    tmp0_set_0[index] = tmp1_set_0;
  };
  FBuffer.prototype.getByte = function (index) {
    var tmp0_get_0 = this._arrayByte;
    return tmp0_get_0[index];
  };
  FBuffer.prototype.getInt = function (index) {
    var tmp0_get_0 = this._arrayInt;
    return tmp0_get_0[index];
  };
  FBuffer.prototype.setByte = function (index, value) {
    var tmp0_set_0 = this._arrayByte;
    tmp0_set_0[index] = value;
  };
  FBuffer.prototype.setInt = function (index, value) {
    var tmp0_set_0 = this._arrayInt;
    tmp0_set_0[index] = value;
  };
  FBuffer.prototype.setFloat = function (index, value) {
    var tmp0_set_0 = this._arrayFloat;
    tmp0_set_0[index] = value;
  };
  FBuffer.prototype.getAlignedInt16 = function (index) {
    var tmp0_get_0 = this._arrayShort;
    return tmp0_get_0[index];
  };
  FBuffer.prototype.setAlignedInt32 = function (index, value) {
    var tmp0_set_0 = this._arrayInt;
    tmp0_set_0[index] = value;
  };
  FBuffer.prototype.setAlignedFloat32 = function (index, value) {
    var tmp0_set_0 = this._arrayFloat;
    tmp0_set_0[index] = value;
  };
  FBuffer.prototype.getUnalignedInt32 = function (index) {
    return getInt(this._data_9, index);
  };
  FBuffer.prototype.getUnalignedFloat32 = function (index) {
    return getFloat(this._data_9, index);
  };
  FBuffer.$metadata$ = {
    simpleName: 'FBuffer',
    kind: 'class',
    interfaces: []
  };
  function arrayinterleave(out, outPos, array1, array1Pos, array2, array2Pos, size_1, temp_0) {
    try {
      temp_0._ptr = out;
      var m_2 = outPos;
      var inductionVariable = 0;
      if (inductionVariable < size_1)
        do {
          var n_4 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp1_6 = m_2;
          m_2 = tmp1_6 + 1 | 0;
          var tmp0_set_0_5 = tmp1_6;
          var tmp1_set_0_7 = array1[array1Pos + n_4 | 0];
          temp_0._ptr[tmp0_set_0_5] = tmp1_set_0_7;
          var tmp2_9 = m_2;
          m_2 = tmp2_9 + 1 | 0;
          var tmp2_set_0_8 = tmp2_9;
          var tmp3_set_0_10 = array2[array2Pos + n_4 | 0];
          temp_0._ptr[tmp2_set_0_8] = tmp3_set_0_10;
        }
         while (inductionVariable < size_1);
    }finally {
      temp_0._ptr = EmptyShortArray;
    }
  }
  function KmemGCImpl() {
    this._threshold = 0;
    this._thresholdAllocations = new Long(0, 0);
    this._autotune = true;
    this._cyclicCollectorEnabled = true;
  }
  KmemGCImpl.$metadata$ = {
    simpleName: 'KmemGCImpl',
    kind: 'class',
    interfaces: []
  };
  function clamp_1(_this_, min, max) {
    return _this_ < min ? min : _this_ > max ? max : _this_;
  }
  function toIntClamp(_this_, min, max) {
    if (_this_.compareTo_137(toLong(min)) < 0)
      return min;
    if (_this_.compareTo_137(toLong(max)) > 0)
      return max;
    return _this_.toInt_8();
  }
  function toIntClamp$default(_this_, min, max, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      min = IntCompanionObject_getInstance()._MIN_VALUE_4;
    if (!(($mask0 & 2) === 0))
      max = IntCompanionObject_getInstance()._MAX_VALUE_4;
    return toIntClamp(_this_, min, max);
  }
  function clamp01(_this_) {
    return clamp_2(_this_, 0.0, 1.0);
  }
  function toIntRound(_this_) {
    return numberToLong(round(_this_)).toInt_8();
  }
  function clamp01_0(_this_) {
    return clamp_3(_this_, 0.0, 1.0);
  }
  function toIntFloor(_this_) {
    var tmp0_unsafeCast_0_1 = Math.floor(_this_);
    return numberToInt(tmp0_unsafeCast_0_1);
  }
  function toIntCeil(_this_) {
    var tmp0_unsafeCast_0_1 = Math.ceil(_this_);
    return numberToInt(tmp0_unsafeCast_0_1);
  }
  function clamp_2(_this_, min, max) {
    return _this_ < min ? min : _this_ > max ? max : _this_;
  }
  function convertRangeClamped(_this_, srcMin, srcMax, dstMin, dstMax) {
    return clamp_2(convertRange_0(_this_, srcMin, srcMax, dstMin, dstMax), dstMin, dstMax);
  }
  function ilog2_0(v) {
    var tmp;
    if (v === 0) {
      tmp = -1;
    } else {
      tmp = 31 - Math.clz32(v) | 0;
    }
    return tmp;
  }
  function convertRange(_this_, srcMin, srcMax, dstMin, dstMax) {
    return numberToInt(dstMin + (dstMax - dstMin | 0) * ((_this_ - srcMin | 0) / (srcMax - srcMin | 0)));
  }
  function convertRange_0(_this_, srcMin, srcMax, dstMin, dstMax) {
    return dstMin + (dstMax - dstMin) * ((_this_ - srcMin) / (srcMax - srcMin));
  }
  function _get_nextPowerOfTwo_(_this_) {
    var v = _this_;
    var tmp0 = v;
    v = tmp0 - 1 | 0;
    Unit_getInstance();
    v = v | v >> 1;
    v = v | v >> 2;
    v = v | v >> 4;
    v = v | v >> 8;
    v = v | v >> 16;
    var tmp1 = v;
    v = tmp1 + 1 | 0;
    Unit_getInstance();
    return v;
  }
  function clamp_3(_this_, min, max) {
    return _this_ < min ? min : _this_ > max ? max : _this_;
  }
  function clamp_4(_this_, min, max) {
    return _this_.compareTo_137(min) < 0 ? min : _this_.compareTo_137(max) > 0 ? max : _this_;
  }
  function nextAlignedTo(_this_, align) {
    return isAlignedTo(_this_, align) ? _this_ : imul((_this_ / align | 0) + 1 | 0, align);
  }
  function isNanOrInfinite(_this_) {
    return isNaN_0(_this_) ? true : isInfinite(_this_);
  }
  function _get_isPowerOfTwo_(_this_) {
    return _get_nextPowerOfTwo_(_this_) === _this_;
  }
  function isAlignedTo(_this_, alignment) {
    return alignment === 0 ? true : _this_ % alignment === 0;
  }
  function max2_0(a, b) {
    return a > b ? a : b;
  }
  function Fast32Buffer(buffer) {
    this._buffer_3 = buffer;
    this._f32 = new Float32Array(this._buffer_3);
    this._i32 = new Int32Array(this._buffer_3);
  }
  Fast32Buffer.$metadata$ = {
    simpleName: 'Fast32Buffer',
    kind: 'class',
    interfaces: []
  };
  function getData(_this_) {
    return new DataView(_this_);
  }
  function NewFast32Buffer(mem) {
    return new Fast32BufferF(mem);
  }
  function arraycopy_11(src, srcPos, dst, dstPos, size_1) {
    return (new Int8Array(dst, dstPos, size_1)).set(new Int8Array(src, srcPos, size_1), 0);
  }
  function arraycopy_12(src, srcPos, dst, dstPos, size_1) {
    var tmp = new Int8Array(dst);
    return tmp.set(src.subarray(srcPos, srcPos + size_1 | 0), dstPos);
  }
  function arraycopy_13(src, srcPos, dst, dstPos, size_1) {
    var tmp = new Int32Array(dst);
    return tmp.set(src.subarray(srcPos, srcPos + size_1 | 0), dstPos);
  }
  function getInt(_this_, index) {
    return _this_.getInt32(index, true);
  }
  function getFloat(_this_, index) {
    return _this_.getFloat32(index, true);
  }
  function Fast32BufferF(buffer) {
    Fast32Buffer.call(this, buffer);
  }
  Fast32BufferF.$metadata$ = {
    simpleName: 'Fast32BufferF',
    kind: 'class',
    interfaces: []
  };
  var KmemGC;
  function _no_name_provided__58() {
    KmemGCImpl.call(this);
  }
  _no_name_provided__58.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function KmemGC$init$() {
    return new _no_name_provided__58();
  }
  var EmptyByteArray;
  var EmptyShortArray;
  var EmptyIntArray;
  var EmptyFloatArray;
  function FastShortTransfer() {
    this._ptr = EmptyShortArray;
  }
  FastShortTransfer.$metadata$ = {
    simpleName: 'FastShortTransfer',
    kind: 'class',
    interfaces: []
  };
  var randomUnittesting;
  function fromBase64(_this_, ignoreSpaces) {
    return ignoreSpaces ? Base64_getInstance().decodeIgnoringSpaces(_this_) : Base64_getInstance().decode_11(_this_);
  }
  function fromBase64$default(_this_, ignoreSpaces, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      ignoreSpaces = false;
    return fromBase64(_this_, ignoreSpaces);
  }
  function toBase64(_this_) {
    return Base64_getInstance().encode_0(_this_);
  }
  function readU8_0(_this_, $this, index) {
    return _this_[index] & 255;
  }
  function readU24BE_0(_this_, $this, index) {
    return readU8_0(_this_, $this, index + 0 | 0) << 16 | readU8_0(_this_, $this, index + 1 | 0) << 8 | readU8_0(_this_, $this, index + 2 | 0) << 0;
  }
  function Base64() {
    Base64_instance = this;
    this._TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var tmp = this;
    var tmp0_apply_0 = new Int32Array(256);
    var inductionVariable = 0;
    if (inductionVariable <= 255)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0[n_3] = -1;
      }
       while (inductionVariable <= 255);
    var inductionVariable_0 = 0;
    var last_1 = Base64_getInstance()._TABLE.length;
    if (inductionVariable_0 < last_1)
      do {
        var n_5 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        tmp0_apply_0[charSequenceGet(Base64_getInstance()._TABLE, n_5).toInt_8()] = n_5;
      }
       while (inductionVariable_0 < last_1);
    tmp._DECODE = tmp0_apply_0;
  }
  Base64.prototype.decode_11 = function (str) {
    var tmp = 0;
    var tmp_0 = str.length;
    var tmp_1 = new Int8Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = charSequenceGet(str, tmp_2).toByte_6();
      tmp = tmp + 1 | 0;
    }
    var src = tmp_1;
    var dst = new Int8Array(src.length);
    return copyOf(dst, this.decode_1(src, dst));
  };
  Base64.prototype.decodeIgnoringSpaces = function (str) {
    var tmp = replace$default_0(str, ' ', '', false, 4, null);
    var tmp_0 = replace$default_0(tmp, '\n', '', false, 4, null);
    return this.decode_11(replace$default_0(tmp_0, '\r', '', false, 4, null));
  };
  Base64.prototype.decode_1 = function (src, dst) {
    var m = 0;
    var n = 0;
    while (n < src.length) {
      var d = this._DECODE[readU8_0(src, this, n)];
      if (d < 0) {
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        Unit_getInstance();
        continue;
      }var tmp;
      if (n < src.length) {
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        tmp = this._DECODE[readU8_0(src, this, tmp1)];
      } else {
        tmp = 64;
      }
      var b0 = tmp;
      var tmp_0;
      if (n < src.length) {
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        tmp_0 = this._DECODE[readU8_0(src, this, tmp2)];
      } else {
        tmp_0 = 64;
      }
      var b1 = tmp_0;
      var tmp_1;
      if (n < src.length) {
        var tmp3 = n;
        n = tmp3 + 1 | 0;
        tmp_1 = this._DECODE[readU8_0(src, this, tmp3)];
      } else {
        tmp_1 = 64;
      }
      var b2 = tmp_1;
      var tmp_2;
      if (n < src.length) {
        var tmp4 = n;
        n = tmp4 + 1 | 0;
        tmp_2 = this._DECODE[readU8_0(src, this, tmp4)];
      } else {
        tmp_2 = 64;
      }
      var b3 = tmp_2;
      var tmp5 = m;
      m = tmp5 + 1 | 0;
      dst[tmp5] = toByte(b0 << 2 | b1 >> 4);
      if (b2 < 64) {
        var tmp6 = m;
        m = tmp6 + 1 | 0;
        dst[tmp6] = toByte(b1 << 4 | b2 >> 2);
        if (b3 < 64) {
          var tmp7 = m;
          m = tmp7 + 1 | 0;
          dst[tmp7] = toByte(b2 << 6 | b3);
        }}}
    return m;
  };
  Base64.prototype.encode_0 = function (src) {
    var out = StringBuilder_init_$Create$((imul(src.length, 4) / 3 | 0) + 4 | 0);
    var ipos = 0;
    var extraBytes = src.length % 3;
    while (ipos < (src.length - 2 | 0)) {
      var num = readU24BE_0(src, this, ipos);
      ipos = ipos + 3 | 0;
      out.append_2(charSequenceGet(this._TABLE, num >>> 18 & 63));
      Unit_getInstance();
      out.append_2(charSequenceGet(this._TABLE, num >>> 12 & 63));
      Unit_getInstance();
      out.append_2(charSequenceGet(this._TABLE, num >>> 6 & 63));
      Unit_getInstance();
      out.append_2(charSequenceGet(this._TABLE, num >>> 0 & 63));
      Unit_getInstance();
    }
    if (extraBytes === 1) {
      var tmp0 = ipos;
      ipos = tmp0 + 1 | 0;
      var num_0 = readU8_0(src, this, tmp0);
      out.append_2(charSequenceGet(this._TABLE, num_0 >>> 2));
      Unit_getInstance();
      out.append_2(charSequenceGet(this._TABLE, num_0 << 4 & 63));
      Unit_getInstance();
      out.append_2(new Char(61));
      Unit_getInstance();
      out.append_2(new Char(61));
      Unit_getInstance();
    } else if (extraBytes === 2) {
      var tmp2 = ipos;
      ipos = tmp2 + 1 | 0;
      var tmp = readU8_0(src, this, tmp2) << 8;
      var tmp1 = ipos;
      ipos = tmp1 + 1 | 0;
      var tmp_0 = tmp | readU8_0(src, this, tmp1);
      out.append_2(charSequenceGet(this._TABLE, tmp_0 >>> 10));
      Unit_getInstance();
      out.append_2(charSequenceGet(this._TABLE, tmp_0 >>> 4 & 63));
      Unit_getInstance();
      out.append_2(charSequenceGet(this._TABLE, tmp_0 << 2 & 63));
      Unit_getInstance();
      out.append_2(new Char(61));
      Unit_getInstance();
    }return out.toString();
  };
  Base64.$metadata$ = {
    simpleName: 'Base64',
    kind: 'object',
    interfaces: []
  };
  var Base64_instance;
  function Base64_getInstance() {
    if (Base64_instance == null)
      new Base64();
    return Base64_instance;
  }
  function encode($this, src, dst, digits) {
    var inductionVariable = 0;
    var last_1 = src.length - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = src[n] & 255;
        dst.append_2(charSequenceGet(digits, v >>> 4 & 15));
        Unit_getInstance();
        dst.append_2(charSequenceGet(digits, v >>> 0 & 15));
        Unit_getInstance();
      }
       while (inductionVariable <= last_1);
  }
  function encodeBase($this, data, digits) {
    var tmp0_buildString_0 = imul(data.length, 2);
    var tmp0_apply_0_1 = StringBuilder_init_$Create$(tmp0_buildString_0);
    encode(Hex_getInstance(), data, tmp0_apply_0_1, digits);
    return tmp0_apply_0_1.toString();
  }
  function Hex() {
    Hex_instance = this;
    this._DIGITS = '0123456789ABCDEF';
    var tmp = this;
    var tmp0_toUpperCase_0 = '0123456789ABCDEF';
    tmp._DIGITS_UPPER = tmp0_toUpperCase_0.toUpperCase();
    var tmp_0 = this;
    var tmp0_toLowerCase_0 = '0123456789ABCDEF';
    tmp_0._DIGITS_LOWER = tmp0_toLowerCase_0.toLowerCase();
  }
  Hex.prototype.decodeHexDigit = function (c) {
    var result = this.decodeChar(c);
    if (result < 0) {
      var tmp0_error_0 = '' + "Invalid hex digit '" + c + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }return result;
  };
  Hex.prototype.decodeChar = function (c) {
    var tmp0_subject = c;
    return (new Char(48) <= tmp0_subject ? tmp0_subject <= new Char(57) : false) ? c.minus(new Char(48)) : (new Char(97) <= tmp0_subject ? tmp0_subject <= new Char(102) : false) ? c.minus(new Char(97)) + 10 | 0 : (new Char(65) <= tmp0_subject ? tmp0_subject <= new Char(70) : false) ? c.minus(new Char(65)) + 10 | 0 : -1;
  };
  Hex.prototype.encodeCharLower = function (v) {
    return charSequenceGet(this._DIGITS_LOWER, v);
  };
  Hex.prototype.encodeCharUpper = function (v) {
    return charSequenceGet(this._DIGITS_UPPER, v);
  };
  Hex.prototype.appendHexByte = function (appender, value) {
    appender.append_2(this.encodeCharLower(value >>> 4 & 15));
    Unit_getInstance();
    appender.append_2(this.encodeCharLower(value >>> 0 & 15));
    Unit_getInstance();
  };
  Hex.prototype.decode_2 = function (str, out) {
    var tmp0_decode_0_2 = Hex_getInstance();
    var inductionVariable = 0;
    var last_1 = str.length / 2 | 0;
    if (inductionVariable < last_1)
      do {
        var n_2_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0_3_5 = tmp0_decode_0_2.decodeHexDigit(charSequenceGet(str, imul(n_2_4, 2) + 0 | 0));
        var c1_4_6 = tmp0_decode_0_2.decodeHexDigit(charSequenceGet(str, imul(n_2_4, 2) + 1 | 0));
        var tmp1__anonymous__5_7 = toByte(c0_3_5 << 4 | c1_4_6);
        out[n_2_4] = tmp1__anonymous__5_7;
      }
       while (inductionVariable < last_1);
    return out;
  };
  Hex.prototype.decode$default = function (str, out, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      out = new Int8Array(str.length / 2 | 0);
    return this.decode_2(str, out);
  };
  Hex.prototype.encodeLower = function (src) {
    return encodeBase(this, src, this._DIGITS_LOWER);
  };
  Hex.$metadata$ = {
    simpleName: 'Hex',
    kind: 'object',
    interfaces: []
  };
  var Hex_instance;
  function Hex_getInstance() {
    if (Hex_instance == null)
      new Hex();
    return Hex_instance;
  }
  function _get_hex_(_this_) {
    return Hex_getInstance().encodeLower(_this_);
  }
  function _get_unhex_(_this_) {
    var tmp = Hex_getInstance();
    return tmp.decode$default(_this_, null, 2, null);
  }
  function _get_hex__0(_this_) {
    return '' + '0x' + _get_shex_(_this_);
  }
  function appendHexByte(_this_, value) {
    return Hex_getInstance().appendHexByte(_this_, value);
  }
  function _get_shex_(_this_) {
    var out = '';
    var inductionVariable = 0;
    if (inductionVariable < 8)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = _this_ >>> imul(7 - n | 0, 4) & 15;
        out = out + Hex_getInstance().encodeCharUpper(v);
      }
       while (inductionVariable < 8);
    return out;
  }
  var isNodeJs$delegate;
  var _global;
  function _no_name_provided__59() {
  }
  _no_name_provided__59.prototype.invoke_1005 = function () {
    var tmp0_unsafeCast_0 = typeof process === 'object' && typeof require === 'function';
    return tmp0_unsafeCast_0;
  };
  _no_name_provided__59.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_41() {
    var i = new _no_name_provided__59();
    return function () {
      return i.invoke_1005();
    };
  }
  var Kind_ERROR_instance;
  var Kind_WARN_instance;
  var Kind_INFO_instance;
  var Kind_DEBUG_instance;
  var Kind_TRACE_instance;
  var Kind_LOG_instance;
  var Kind_entriesInitialized;
  function Kind_initEntries() {
    if (Kind_entriesInitialized)
      return Unit_getInstance();
    Kind_entriesInitialized = true;
    Kind_ERROR_instance = new Kind('ERROR', 0, 0, Color_RED_getInstance());
    Kind_WARN_instance = new Kind('WARN', 1, 1, Color_YELLOW_getInstance());
    Kind_INFO_instance = new Kind('INFO', 2, 2, Color_BLUE_getInstance());
    Kind_DEBUG_instance = new Kind('DEBUG', 3, 3, Color_CYAN_getInstance());
    Kind_TRACE_instance = new Kind('TRACE', 4, 4, Color_GREEN_getInstance());
    Kind_LOG_instance = new Kind('LOG', 5, 5, null);
  }
  function Kind(name, ordinal, level, color_0) {
    Enum.call(this, name, ordinal);
    this._level = level;
    this._color = color_0;
  }
  Kind.$metadata$ = {
    simpleName: 'Kind',
    kind: 'class',
    interfaces: []
  };
  function Kind_ERROR_getInstance() {
    Kind_initEntries();
    return Kind_ERROR_instance;
  }
  function Kind_WARN_getInstance() {
    Kind_initEntries();
    return Kind_WARN_instance;
  }
  function Kind_INFO_getInstance() {
    Kind_initEntries();
    return Kind_INFO_instance;
  }
  function Kind_DEBUG_getInstance() {
    Kind_initEntries();
    return Kind_DEBUG_instance;
  }
  function Kind_TRACE_getInstance() {
    Kind_initEntries();
    return Kind_TRACE_instance;
  }
  function Kind_LOG_getInstance() {
    Kind_initEntries();
    return Kind_LOG_instance;
  }
  function BaseConsole() {
  }
  BaseConsole.prototype.log_2 = function (kind, msg) {
    println(this.logToString_0(kind, msg.slice()));
  };
  BaseConsole.prototype.logToString_0 = function (kind, msg) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var color_3 = kind._color;
    if (!(color_3 == null)) {
      this.appendFgColor$default_1(tmp0_apply_0_1, color_3, false, 2, null);
      Unit_getInstance();
    }joinTo$default(msg, tmp0_apply_0_1, ', ', null, null, 0, null, null, 124, null);
    Unit_getInstance();
    if (!(color_3 == null)) {
      this.appendReset_1(tmp0_apply_0_1);
      Unit_getInstance();
    }return tmp0_apply_0_1.toString();
  };
  BaseConsole.prototype.log_3 = function (msg) {
    return this.log_2(Kind_LOG_getInstance(), msg.slice());
  };
  BaseConsole.prototype.trace_0 = function (msg) {
    return this.log_2(Kind_TRACE_getInstance(), msg.slice());
  };
  BaseConsole.prototype.debug_1 = function (msg) {
    return this.log_2(Kind_DEBUG_getInstance(), msg.slice());
  };
  BaseConsole.prototype.info_1 = function (msg) {
    return this.log_2(Kind_INFO_getInstance(), msg.slice());
  };
  BaseConsole.prototype.warn_1 = function (msg) {
    return this.log_2(Kind_WARN_getInstance(), msg.slice());
  };
  BaseConsole.prototype.error_1 = function (msg) {
    return this.log_2(Kind_ERROR_getInstance(), msg.slice());
  };
  BaseConsole.$metadata$ = {
    simpleName: 'BaseConsole',
    kind: 'class',
    interfaces: [AnsiEscape]
  };
  var Color_BLACK_instance;
  var Color_RED_instance;
  var Color_GREEN_instance;
  var Color_YELLOW_instance;
  var Color_BLUE_instance;
  var Color_PURPLE_instance;
  var Color_CYAN_instance;
  var Color_WHITE_instance;
  var Color_entriesInitialized;
  function Color_initEntries() {
    if (Color_entriesInitialized)
      return Unit_getInstance();
    Color_entriesInitialized = true;
    Color_BLACK_instance = new Color('BLACK', 0, 0);
    Color_RED_instance = new Color('RED', 1, 1);
    Color_GREEN_instance = new Color('GREEN', 2, 2);
    Color_YELLOW_instance = new Color('YELLOW', 3, 3);
    Color_BLUE_instance = new Color('BLUE', 4, 4);
    Color_PURPLE_instance = new Color('PURPLE', 5, 5);
    Color_CYAN_instance = new Color('CYAN', 6, 6);
    Color_WHITE_instance = new Color('WHITE', 7, 7);
  }
  function Color(name, ordinal, index) {
    Enum.call(this, name, ordinal);
    this._index_9 = index;
  }
  Color.$metadata$ = {
    simpleName: 'Color',
    kind: 'class',
    interfaces: []
  };
  function Color_RED_getInstance() {
    Color_initEntries();
    return Color_RED_instance;
  }
  function Color_GREEN_getInstance() {
    Color_initEntries();
    return Color_GREEN_instance;
  }
  function Color_YELLOW_getInstance() {
    Color_initEntries();
    return Color_YELLOW_instance;
  }
  function Color_BLUE_getInstance() {
    Color_initEntries();
    return Color_BLUE_instance;
  }
  function Color_CYAN_getInstance() {
    Color_initEntries();
    return Color_CYAN_instance;
  }
  function AnsiEscape() {
  }
  AnsiEscape.prototype.appendAnsiScape_1 = function (_this__0, code, extra, char) {
    _this__0.append_2(new Char(27));
    Unit_getInstance();
    _this__0.append_2(new Char(91));
    Unit_getInstance();
    _this__0.append_4(code);
    Unit_getInstance();
    if (!(extra == null)) {
      _this__0.append_5(extra);
      Unit_getInstance();
    }_this__0.append_2(char);
    Unit_getInstance();
    return _this__0;
  };
  AnsiEscape.prototype.appendAnsiScape$default_1 = function (_this__0, code, extra, char, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      extra = null;
    if (!(($mask0 & 4) === 0))
      char = new Char(109);
    return $handler == null ? this.appendAnsiScape_1(_this__0, code, extra, char) : $handler(code, extra, char);
  };
  AnsiEscape.prototype.appendReset_1 = function (_this__0) {
    return this.appendAnsiScape$default_1(_this__0, 0, null, new Char(0), 6, null);
  };
  AnsiEscape.prototype.appendFgColor_1 = function (_this__0, color_0, bright) {
    var tmp = 30 + color_0._index_9 | 0;
    var tmp_0 = bright ? ';1' : null;
    return this.appendAnsiScape$default_1(_this__0, tmp, tmp_0, new Char(0), 4, null);
  };
  AnsiEscape.prototype.appendFgColor$default_1 = function (_this__0, color_0, bright, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      bright = false;
    return $handler == null ? this.appendFgColor_1(_this__0, color_0, bright) : $handler(color_0, bright);
  };
  AnsiEscape.$metadata$ = {
    simpleName: 'AnsiEscape',
    kind: 'interface',
    interfaces: []
  };
  var Level_NONE_instance;
  var Level_FATAL_instance;
  var Level_ERROR_instance;
  var Level_WARN_instance;
  var Level_INFO_instance;
  var Level_DEBUG_instance;
  var Level_TRACE_instance;
  function valueOf(value) {
    switch (value) {
      case 'NONE':
        return Level_NONE_getInstance();
      case 'FATAL':
        return Level_FATAL_getInstance();
      case 'ERROR':
        return Level_ERROR_getInstance();
      case 'WARN':
        return Level_WARN_getInstance();
      case 'INFO':
        return Level_INFO_getInstance();
      case 'DEBUG':
        return Level_DEBUG_getInstance();
      case 'TRACE':
        return Level_TRACE_getInstance();
      default:return THROW_ISE();
    }
  }
  var Level_entriesInitialized;
  function Level_initEntries() {
    if (Level_entriesInitialized)
      return Unit_getInstance();
    Level_entriesInitialized = true;
    Level_NONE_instance = new Level('NONE', 0, 0);
    Level_FATAL_instance = new Level('FATAL', 1, 1);
    Level_ERROR_instance = new Level('ERROR', 2, 2);
    Level_WARN_instance = new Level('WARN', 3, 3);
    Level_INFO_instance = new Level('INFO', 4, 4);
    Level_DEBUG_instance = new Level('DEBUG', 5, 5);
    Level_TRACE_instance = new Level('TRACE', 6, 6);
  }
  function Companion_40() {
    Companion_instance_39 = this;
    this._Logger_loggers = new KloggerAtomicRef(emptyMap());
    this._Logger_levels = new KloggerAtomicRef(emptyMap());
    this._Logger_outputs = new KloggerAtomicRef(emptyMap());
    this._defaultLevel$delegate = new KloggerAtomicRef(null);
    this._defaultOutput$delegate = new KloggerAtomicRef(DefaultLogOutput_getInstance());
  }
  Companion_40.prototype._set_defaultLevel_ = function (_set___) {
    return setValue(this._defaultLevel$delegate, this, defaultLevel$factory(), _set___);
  };
  Companion_40.prototype._get_defaultLevel_ = function () {
    return getValue(this._defaultLevel$delegate, this, defaultLevel$factory_0());
  };
  Companion_40.prototype._set_defaultOutput_ = function (_set___) {
    return setValue(this._defaultOutput$delegate, this, defaultOutput$factory(), _set___);
  };
  Companion_40.prototype._get_defaultOutput_ = function () {
    return getValue(this._defaultOutput$delegate, this, defaultOutput$factory_0());
  };
  Companion_40.prototype.invoke_203 = function (name) {
    var tmp0_get_0 = this._Logger_loggers;
    var tmp0_elvis_lhs = tmp0_get_0._value_3.get_116(name);
    return tmp0_elvis_lhs == null ? new Logger(name, true) : tmp0_elvis_lhs;
  };
  Companion_40.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_39;
  function Companion_getInstance_39() {
    if (Companion_instance_39 == null)
      new Companion_40();
    return Companion_instance_39;
  }
  function Level(name, ordinal, index) {
    Enum.call(this, name, ordinal);
    this._index_10 = index;
  }
  Level.$metadata$ = {
    simpleName: 'Level',
    kind: 'class',
    interfaces: []
  };
  function Output() {
  }
  Output.$metadata$ = {
    simpleName: 'Output',
    kind: 'interface',
    interfaces: []
  };
  function ConsoleLogOutput() {
    ConsoleLogOutput_instance = this;
  }
  ConsoleLogOutput.prototype.output_2 = function (logger_1, level, msg) {
    var tmp0_subject = level;
    if (tmp0_subject.equals(Level_ERROR_getInstance()))
      Console_getInstance().error_1([logger_1._name_2, msg]);
    else if (tmp0_subject.equals(Level_WARN_getInstance()))
      Console_getInstance().warn_1([logger_1._name_2, msg]);
    else
      Console_getInstance().log_3([logger_1._name_2, msg]);
  };
  ConsoleLogOutput.$metadata$ = {
    simpleName: 'ConsoleLogOutput',
    kind: 'object',
    interfaces: [Output]
  };
  var ConsoleLogOutput_instance;
  function ConsoleLogOutput_getInstance() {
    if (ConsoleLogOutput_instance == null)
      new ConsoleLogOutput();
    return ConsoleLogOutput_instance;
  }
  function Level_NONE_getInstance() {
    Level_initEntries();
    return Level_NONE_instance;
  }
  function Level_FATAL_getInstance() {
    Level_initEntries();
    return Level_FATAL_instance;
  }
  function Level_ERROR_getInstance() {
    Level_initEntries();
    return Level_ERROR_instance;
  }
  function Level_WARN_getInstance() {
    Level_initEntries();
    return Level_WARN_instance;
  }
  function Level_INFO_getInstance() {
    Level_initEntries();
    return Level_INFO_instance;
  }
  function Level_DEBUG_getInstance() {
    Level_initEntries();
    return Level_DEBUG_instance;
  }
  function Level_TRACE_getInstance() {
    Level_initEntries();
    return Level_TRACE_instance;
  }
  function Logger(name, dummy) {
    Companion_getInstance_39();
    this._name_2 = name;
    this._dummy = dummy;
    var tmp1_set_0 = Companion_getInstance_39()._Logger_loggers;
    var tmp2_set_0 = this._name_2;
    var tmp = tmp1_set_0;
    var tmp0__anonymous__1_1 = tmp1_set_0._value_3;
    var tmp0_also_0_2 = HashMap_init_$Create$_2(tmp0__anonymous__1_1);
    tmp0_also_0_2.put_18(tmp2_set_0, this);
    Unit_getInstance();
    tmp._value_3 = tmp0_also_0_2;
    var tmp4_set_0 = Companion_getInstance_39()._Logger_levels;
    var tmp5_set_0 = this._name_2;
    var tmp6_set_0 = null;
    var tmp_0 = tmp4_set_0;
    var tmp3__anonymous__1_1 = tmp4_set_0._value_3;
    var tmp0_also_0_2_0 = HashMap_init_$Create$_2(tmp3__anonymous__1_1);
    tmp0_also_0_2_0.put_18(tmp5_set_0, tmp6_set_0);
    Unit_getInstance();
    tmp_0._value_3 = tmp0_also_0_2_0;
    var tmp8_set_0 = Companion_getInstance_39()._Logger_outputs;
    var tmp9_set_0 = this._name_2;
    var tmp10_set_0 = null;
    var tmp_1 = tmp8_set_0;
    var tmp7__anonymous__1_1 = tmp8_set_0._value_3;
    var tmp0_also_0_2_1 = HashMap_init_$Create$_2(tmp7__anonymous__1_1);
    tmp0_also_0_2_1.put_18(tmp9_set_0, tmp10_set_0);
    Unit_getInstance();
    tmp_1._value_3 = tmp0_also_0_2_1;
  }
  Logger.prototype._set_level_ = function (value) {
    var tmp1_set_0_2 = Companion_getInstance_39()._Logger_levels;
    var tmp2_set_0_3 = this._name_2;
    var tmp = tmp1_set_0_2;
    var tmp0__anonymous__1_1_4 = tmp1_set_0_2._value_3;
    var tmp0_also_0_2_5 = HashMap_init_$Create$_2(tmp0__anonymous__1_1_4);
    tmp0_also_0_2_5.put_18(tmp2_set_0_3, value);
    Unit_getInstance();
    tmp._value_3 = tmp0_also_0_2_5;
    return Unit_getInstance();
  };
  Logger.prototype._get_level_ = function () {
    var tmp0_get_0 = Companion_getInstance_39()._Logger_levels;
    var tmp1_get_0 = this._name_2;
    var tmp0_elvis_lhs = tmp0_get_0._value_3.get_116(tmp1_get_0);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? Companion_getInstance_39()._get_defaultLevel_() : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? Level_WARN_getInstance() : tmp1_elvis_lhs;
  };
  Logger.prototype._get_output_ = function () {
    var tmp0_get_0 = Companion_getInstance_39()._Logger_outputs;
    var tmp1_get_0 = this._name_2;
    var tmp0_elvis_lhs = tmp0_get_0._value_3.get_116(tmp1_get_0);
    return tmp0_elvis_lhs == null ? Companion_getInstance_39()._get_defaultOutput_() : tmp0_elvis_lhs;
  };
  Logger.prototype.isEnabled_0 = function (level) {
    return level._index_10 <= this._get_level_()._index_10;
  };
  Logger.prototype.actualLog = function (level, msg) {
    return this._get_output_().output_2(this, level, msg);
  };
  Logger.$metadata$ = {
    simpleName: 'Logger',
    kind: 'class',
    interfaces: []
  };
  function defaultLevel$factory() {
    return getPropertyCallableRef('defaultLevel', 1, KMutableProperty1, function (receiver) {
      return receiver._get_defaultLevel_();
    }, function (receiver_0, value) {
      return receiver_0._set_defaultLevel_(value);
    });
  }
  function defaultLevel$factory_0() {
    return getPropertyCallableRef('defaultLevel', 1, KMutableProperty1, function (receiver) {
      return receiver._get_defaultLevel_();
    }, function (receiver_0, value) {
      return receiver_0._set_defaultLevel_(value);
    });
  }
  function defaultOutput$factory() {
    return getPropertyCallableRef('defaultOutput', 1, KMutableProperty1, function (receiver) {
      return receiver._get_defaultOutput_();
    }, function (receiver_0, value) {
      return receiver_0._set_defaultOutput_(value);
    });
  }
  function defaultOutput$factory_0() {
    return getPropertyCallableRef('defaultOutput', 1, KMutableProperty1, function (receiver) {
      return receiver._get_defaultOutput_();
    }, function (receiver_0, value) {
      return receiver_0._set_defaultOutput_(value);
    });
  }
  function getValue(_this_, receiver, property) {
    return _this_._value_3;
  }
  function setValue(_this_, receiver, property, value) {
    _this_._value_3 = value;
  }
  function Console_0() {
    Console_instance = this;
    BaseConsole.call(this);
  }
  Console_0.prototype.log_2 = function (kind, msg) {
    var tmp0_subject = kind;
    if (tmp0_subject.equals(Kind_ERROR_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].concat([].slice.call(msg.slice())));
      }.call(this));
    else if (tmp0_subject.equals(Kind_WARN_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.warn.apply($externalVarargReceiverTmp, [].concat([].slice.call(msg.slice())));
      }.call(this));
    else if (tmp0_subject.equals(Kind_INFO_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.info.apply($externalVarargReceiverTmp, [].concat([].slice.call(msg.slice())));
      }.call(this));
    else if (tmp0_subject.equals(Kind_DEBUG_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].concat([].slice.call(msg.slice())));
      }.call(this));
    else if (tmp0_subject.equals(Kind_TRACE_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].concat([].slice.call(msg.slice())));
      }.call(this));
    else if (tmp0_subject.equals(Kind_LOG_getInstance()))
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].concat([].slice.call(msg.slice())));
      }.call(this));
  };
  Console_0.$metadata$ = {
    simpleName: 'Console',
    kind: 'object',
    interfaces: []
  };
  var Console_instance;
  function Console_getInstance() {
    if (Console_instance == null)
      new Console_0();
    return Console_instance;
  }
  function DefaultLogOutput() {
    DefaultLogOutput_instance = this;
  }
  DefaultLogOutput.prototype.output_2 = function (logger_1, level, msg) {
    return ConsoleLogOutput_getInstance().output_2(logger_1, level, msg);
  };
  DefaultLogOutput.$metadata$ = {
    simpleName: 'DefaultLogOutput',
    kind: 'object',
    interfaces: [Output]
  };
  var DefaultLogOutput_instance;
  function DefaultLogOutput_getInstance() {
    if (DefaultLogOutput_instance == null)
      new DefaultLogOutput();
    return DefaultLogOutput_instance;
  }
  function KloggerAtomicRef(initial) {
    this._value_3 = initial;
  }
  KloggerAtomicRef.$metadata$ = {
    simpleName: 'KloggerAtomicRef',
    kind: 'class',
    interfaces: []
  };
  var isNative;
  function None() {
    None_instance = this;
    TraceBase.call(this);
  }
  None.$metadata$ = {
    simpleName: 'None',
    kind: 'object',
    interfaces: []
  };
  var None_instance;
  function None_getInstance() {
    if (None_instance == null)
      new None();
    return None_instance;
  }
  function TraceBase() {
  }
  TraceBase.prototype.atomicfu$Trace$append$1 = function (event) {
  };
  TraceBase.prototype.atomicfu$Trace$append$2 = function (event1, event2) {
  };
  TraceBase.prototype.atomicfu$Trace$append$3 = function (event1, event2, event3) {
  };
  TraceBase.prototype.atomicfu$Trace$append$4 = function (event1, event2, event3, event4) {
  };
  TraceBase.$metadata$ = {
    simpleName: 'TraceBase',
    kind: 'class',
    interfaces: []
  };
  function AtomicRef(value) {
    this._value_4 = value;
  }
  AtomicRef.prototype._set_value_ = function (_set___) {
    this._value_4 = _set___;
  };
  AtomicRef.prototype._get_value__10 = function () {
    return this._value_4;
  };
  AtomicRef.prototype.atomicfu$compareAndSet = function (expect, update) {
    if (!(this._value_4 === expect))
      return false;
    this._value_4 = update;
    return true;
  };
  AtomicRef.prototype.atomicfu$getAndSet = function (value) {
    var oldValue = this._value_4;
    this._value_4 = value;
    return oldValue;
  };
  AtomicRef.prototype.toString = function () {
    return toString_0(this._value_4);
  };
  AtomicRef.$metadata$ = {
    simpleName: 'AtomicRef',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicRef.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicRef.prototype._get_value__10,
    set: AtomicRef.prototype._set_value_
  });
  function atomic(initial) {
    return atomic_2(initial, None_getInstance());
  }
  function AtomicBoolean(value) {
    this._value_5 = value;
  }
  AtomicBoolean.prototype._set_value__2 = function (_set___) {
    this._value_5 = _set___;
  };
  AtomicBoolean.prototype._get_value__10 = function () {
    return this._value_5;
  };
  AtomicBoolean.prototype.atomicfu$compareAndSet = function (expect, update) {
    if (!(this._value_5 === expect))
      return false;
    this._value_5 = update;
    return true;
  };
  AtomicBoolean.prototype.atomicfu$getAndSet = function (value) {
    var oldValue = this._value_5;
    this._value_5 = value;
    return oldValue;
  };
  AtomicBoolean.prototype.toString = function () {
    return this._value_5.toString();
  };
  AtomicBoolean.$metadata$ = {
    simpleName: 'AtomicBoolean',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicBoolean.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicBoolean.prototype._get_value__10,
    set: AtomicBoolean.prototype._set_value__2
  });
  function atomic_0(initial) {
    return atomic_3(initial, None_getInstance());
  }
  function AtomicInt(value) {
    this._value_6 = value;
  }
  AtomicInt.prototype._set_value__1 = function (_set___) {
    this._value_6 = _set___;
  };
  AtomicInt.prototype._get_value__10 = function () {
    return this._value_6;
  };
  AtomicInt.prototype.atomicfu$compareAndSet = function (expect, update) {
    if (!(this._value_6 === expect))
      return false;
    this._value_6 = update;
    return true;
  };
  AtomicInt.prototype.atomicfu$getAndSet = function (value) {
    var oldValue = this._value_6;
    this._value_6 = value;
    return oldValue;
  };
  AtomicInt.prototype.atomicfu$getAndIncrement = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_6;
    tmp0_this._value_6 = tmp1 + 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.atomicfu$getAndDecrement = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._value_6;
    tmp0_this._value_6 = tmp1 - 1 | 0;
    return tmp1;
  };
  AtomicInt.prototype.atomicfu$getAndAdd = function (delta_0) {
    var oldValue = this._value_6;
    var tmp0_this = this;
    tmp0_this._value_6 = tmp0_this._value_6 + delta_0 | 0;
    return oldValue;
  };
  AtomicInt.prototype.atomicfu$addAndGet = function (delta_0) {
    var tmp0_this = this;
    tmp0_this._value_6 = tmp0_this._value_6 + delta_0 | 0;
    return this._value_6;
  };
  AtomicInt.prototype.atomicfu$incrementAndGet = function () {
    var tmp0_this = this;
    tmp0_this._value_6 = tmp0_this._value_6 + 1 | 0;
    return tmp0_this._value_6;
  };
  AtomicInt.prototype.atomicfu$decrementAndGet = function () {
    var tmp0_this = this;
    tmp0_this._value_6 = tmp0_this._value_6 - 1 | 0;
    return tmp0_this._value_6;
  };
  AtomicInt.prototype.toString = function () {
    return this._value_6.toString();
  };
  AtomicInt.$metadata$ = {
    simpleName: 'AtomicInt',
    kind: 'class',
    interfaces: []
  };
  Object.defineProperty(AtomicInt.prototype, 'kotlinx$atomicfu$value', {
    configurable: true,
    get: AtomicInt.prototype._get_value__10,
    set: AtomicInt.prototype._set_value__1
  });
  function atomic_1(initial) {
    return atomic_4(initial, None_getInstance());
  }
  function atomic_2(initial, trace) {
    return new AtomicRef(initial);
  }
  function atomic_3(initial, trace) {
    return new AtomicBoolean(initial);
  }
  function atomic_4(initial, trace) {
    return new AtomicInt(initial);
  }
  function AbstractCoroutine(parentContext, active) {
    JobSupport.call(this, active);
    this._parentContext = parentContext;
    this._context = this._parentContext.plus_36(this);
  }
  AbstractCoroutine.prototype._get_parentContext__3 = function () {
    return this._parentContext;
  };
  AbstractCoroutine.prototype._get_context__296 = function () {
    return this._context;
  };
  AbstractCoroutine.prototype._get_coroutineContext__22 = function () {
    return this._context;
  };
  AbstractCoroutine.prototype._get_isActive__29 = function () {
    return JobSupport.prototype._get_isActive__29.call(this);
  };
  AbstractCoroutine.prototype.initParentJob_9 = function () {
    this.initParentJobInternal_13(this._parentContext.get_113(Key_getInstance_2()));
  };
  AbstractCoroutine.prototype.onStart_9 = function () {
  };
  AbstractCoroutine.prototype.onStartInternal_13 = function () {
    this.onStart_9();
  };
  AbstractCoroutine.prototype.onCompleted_10 = function (value) {
  };
  AbstractCoroutine.prototype.onCancelled_9 = function (cause, handled) {
  };
  AbstractCoroutine.prototype.cancellationExceptionMessage_13 = function () {
    return '' + _get_classSimpleName_(this) + ' was cancelled';
  };
  AbstractCoroutine.prototype.onCompletionInternal_13 = function (state) {
    if (state instanceof CompletedExceptionally)
      this.onCancelled_9(state._cause, state._get_handled__0());
    else {
      {
        this.onCompleted_10((state == null ? true : isObject(state)) ? state : THROW_CCE());
      }
    }
  };
  AbstractCoroutine.prototype.resumeWith_196 = function (result) {
    var state = this.makeCompletingOnce_10(toState$default(result, null, 1, null));
    if (state === COMPLETING_WAITING_CHILDREN)
      return Unit_getInstance();
    this.afterResume_9(state);
  };
  AbstractCoroutine.prototype.afterResume_9 = function (state) {
    return this.afterCompletion_13(state);
  };
  AbstractCoroutine.prototype.handleOnCompletionException_13 = function (exception) {
    handleCoroutineException(this._context, exception);
  };
  AbstractCoroutine.prototype.nameString_15 = function () {
    var tmp0_elvis_lhs = _get_coroutineName_(this._context);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return JobSupport.prototype.nameString_15.call(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '' + '"' + coroutineName + '":' + JobSupport.prototype.nameString_15.call(this);
  };
  AbstractCoroutine.prototype.start_8 = function (start, receiver, block) {
    this.initParentJob_9();
    start.invoke_90(block, receiver, this);
  };
  AbstractCoroutine.$metadata$ = {
    simpleName: 'AbstractCoroutine',
    kind: 'class',
    interfaces: [Job, Continuation, CoroutineScope]
  };
  function launch(_this_, context, start, block) {
    var newContext = newCoroutineContext(_this_, context);
    var coroutine = start._get_isLazy_() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
    coroutine.start_8(start, coroutine, block);
    return coroutine;
  }
  function async(_this_, context, start, block) {
    var newContext = newCoroutineContext(_this_, context);
    var coroutine = start._get_isLazy_() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
    coroutine.start_8(start, coroutine, block);
    return coroutine;
  }
  function withContext(context, block, $cont) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0__anonymous__1 = $cont;
      var oldContext_2 = tmp0__anonymous__1._get_context__296();
      var newContext_3 = oldContext_2.plus_36(context);
      checkCompletion(newContext_3);
      if (newContext_3 === oldContext_2) {
        var coroutine_4 = new ScopeCoroutine(newContext_3, tmp0__anonymous__1);
        tmp$ret$0 = startUndispatchedOrReturn(coroutine_4, coroutine_4, block);
        break l$ret$1;
      }if (equals_1(newContext_3.get_113(Key_getInstance()), oldContext_2.get_113(Key_getInstance()))) {
        var coroutine_5 = new UndispatchedCoroutine(newContext_3, tmp0__anonymous__1);
        var tmp0_withCoroutineContext_0_6 = null;
        tmp$ret$0 = startUndispatchedOrReturn(coroutine_5, coroutine_5, block);
        break l$ret$1;
      }var coroutine_7 = new DispatchedCoroutine(newContext_3, tmp0__anonymous__1);
      coroutine_7.initParentJob_9();
      startCoroutineCancellable$default(block, coroutine_7, coroutine_7, null, 4, null);
      tmp$ret$0 = coroutine_7.getResult_1();
    }
     while (false);
    return tmp$ret$0;
  }
  function StandaloneCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, active);
  }
  StandaloneCoroutine.prototype.handleJobException_13 = function (exception) {
    handleCoroutineException(this._get_context__296(), exception);
    return true;
  };
  StandaloneCoroutine.$metadata$ = {
    simpleName: 'StandaloneCoroutine',
    kind: 'class',
    interfaces: []
  };
  function LazyStandaloneCoroutine(parentContext, block) {
    StandaloneCoroutine.call(this, parentContext, false);
    this._continuation = createCoroutineUnintercepted(block, this, this);
  }
  LazyStandaloneCoroutine.prototype.onStart_9 = function () {
    startCoroutineCancellable_0(this._continuation, this);
  };
  LazyStandaloneCoroutine.$metadata$ = {
    simpleName: 'LazyStandaloneCoroutine',
    kind: 'class',
    interfaces: []
  };
  function $awaitCOROUTINE$0(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this_ = _this_;
  }
  $awaitCOROUTINE$0.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this_.awaitInternal_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp_0 = suspendResult;
            return (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitCOROUTINE$0.$metadata$ = {
    simpleName: '$awaitCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function DeferredCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, active);
  }
  DeferredCoroutine.prototype.await_3 = function ($cont) {
    var tmp = new $awaitCOROUTINE$0(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  DeferredCoroutine.$metadata$ = {
    simpleName: 'DeferredCoroutine',
    kind: 'class',
    interfaces: [Deferred, SelectClause1]
  };
  function LazyDeferredCoroutine(parentContext, block) {
    DeferredCoroutine.call(this, parentContext, false);
    this._continuation_0 = createCoroutineUnintercepted(block, this, this);
  }
  LazyDeferredCoroutine.prototype.onStart_9 = function () {
    startCoroutineCancellable_0(this._continuation_0, this);
  };
  LazyDeferredCoroutine.$metadata$ = {
    simpleName: 'LazyDeferredCoroutine',
    kind: 'class',
    interfaces: []
  };
  function trySuspend($this) {
    var tmp0_loop_0 = $this.__decision;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_6;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision.atomicfu$compareAndSet(0, 1))
            return true;
          break;
        case 2:
          return false;
        default:var tmp0_error_0_3 = 'Already suspended';
          throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function tryResume($this) {
    var tmp0_loop_0 = $this.__decision;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_6;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision.atomicfu$compareAndSet(0, 2))
            return true;
          break;
        case 1:
          return false;
        default:var tmp0_error_0_3 = 'Already resumed';
          throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function DispatchedCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
    this.__decision = atomic_1(0);
  }
  DispatchedCoroutine.prototype.afterCompletion_13 = function (state) {
    this.afterResume_9(state);
  };
  DispatchedCoroutine.prototype.afterResume_9 = function (state) {
    if (tryResume(this))
      return Unit_getInstance();
    var tmp = intercepted(this._get_uCont__2());
    var tmp_0 = recoverResult(state, this._get_uCont__2());
    resumeCancellableWith$default(tmp, tmp_0, null, 2, null);
  };
  DispatchedCoroutine.prototype.getResult_1 = function () {
    if (trySuspend(this))
      return _get_COROUTINE_SUSPENDED_();
    var state = unboxState(this._get_state__15());
    if (state instanceof CompletedExceptionally)
      throw state._cause;
    else {
    }
    return (state == null ? true : isObject(state)) ? state : THROW_CCE();
  };
  DispatchedCoroutine.$metadata$ = {
    simpleName: 'DispatchedCoroutine',
    kind: 'class',
    interfaces: []
  };
  function CancellableContinuation() {
  }
  CancellableContinuation.$metadata$ = {
    simpleName: 'CancellableContinuation',
    kind: 'interface',
    interfaces: [Continuation]
  };
  function disposeOnCancellation(_this_, handle) {
    var tmp0__get_asHandler__0 = new DisposeOnCancel(handle);
    return _this_.invokeOnCancellation_1(tmp0__get_asHandler__0);
  }
  function DisposeOnCancel(handle) {
    CancelHandler.call(this);
    this._handle = handle;
  }
  DisposeOnCancel.prototype.invoke_725 = function (cause) {
    return this._handle.dispose_18();
  };
  DisposeOnCancel.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  DisposeOnCancel.prototype.toString = function () {
    return '' + 'DisposeOnCancel[' + this._handle + ']';
  };
  DisposeOnCancel.$metadata$ = {
    simpleName: 'DisposeOnCancel',
    kind: 'class',
    interfaces: []
  };
  function removeOnCancellation(_this_, node) {
    var tmp0__get_asHandler__0 = new RemoveOnCancel(node);
    return _this_.invokeOnCancellation_1(tmp0__get_asHandler__0);
  }
  function getOrCreateCancellableContinuation(delegate) {
    if (!(delegate instanceof DispatchedContinuation)) {
      return new CancellableContinuationImpl(delegate, 2);
    } else {
    }
    var tmp0_safe_receiver = delegate.claimReusableCancellableContinuation();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0;
      if (tmp0_safe_receiver.resetStateReusable_0()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        {
          tmp_0 = null;
        }
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return new CancellableContinuationImpl(delegate, 2);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  function RemoveOnCancel(node) {
    BeforeResumeCancelHandler.call(this);
    this._node = node;
  }
  RemoveOnCancel.prototype.invoke_725 = function (cause) {
    this._node.remove_69();
    Unit_getInstance();
  };
  RemoveOnCancel.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  RemoveOnCancel.prototype.toString = function () {
    return '' + 'RemoveOnCancel[' + this._node + ']';
  };
  RemoveOnCancel.$metadata$ = {
    simpleName: 'RemoveOnCancel',
    kind: 'class',
    interfaces: []
  };
  var RESUME_TOKEN;
  function _set_parentHandle_($this, value) {
    $this.__parentHandle._value_4 = value;
  }
  function _get_parentHandle_($this) {
    return $this.__parentHandle._value_4;
  }
  function _get_stateDebugRepresentation_($this) {
    var tmp0_subject = $this._get_state__15();
    var tmp;
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) {
      tmp = 'Active';
    } else {
      if (tmp0_subject instanceof CancelledContinuation) {
        tmp = 'Cancelled';
      } else {
        {
          tmp = 'Completed';
        }
      }
    }
    return tmp;
  }
  function isReusable($this) {
    var tmp;
    var tmp_0 = $this._delegate_0;
    if (tmp_0 instanceof DispatchedContinuation) {
      tmp = $this._delegate_0.isReusable($this);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  }
  function setupCancellation($this) {
    if (checkCompleted($this))
      return Unit_getInstance();
    if (!(_get_parentHandle_($this) === null))
      return Unit_getInstance();
    var tmp0_elvis_lhs = $this._delegate_0._get_context__296().get_113(Key_getInstance_2());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var tmp0__get_asHandler__0 = new ChildContinuation($this);
    var handle = parent.invokeOnCompletion$default_14(true, false, tmp0__get_asHandler__0, 2, null);
    _set_parentHandle_($this, handle);
    if ($this._get_isCompleted__16() ? !isReusable($this) : false) {
      handle.dispose_18();
      _set_parentHandle_($this, NonDisposableHandle_getInstance());
    }}
  function checkCompleted($this) {
    var completed = $this._get_isCompleted__16();
    if (!_get_isReusableMode_($this._get_resumeMode__1()))
      return completed;
    var tmp = $this._delegate_0;
    var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return completed;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var dispatched = tmp_0;
    var tmp1_elvis_lhs = dispatched.checkPostponedCancellation($this);
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return completed;
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var cause = tmp_1;
    if (!completed) {
      $this.cancel_8(cause);
      Unit_getInstance();
    }return true;
  }
  function cancelLater($this, cause) {
    if (!_get_isReusableMode_($this._get_resumeMode__1()))
      return false;
    var tmp = $this._delegate_0;
    var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var dispatched = tmp_0;
    return dispatched.postponeCancellation(cause);
  }
  function callCancelHandler($this, handler, cause) {
    var tmp;
    try {
      tmp = invokeIt(handler, cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = handleCoroutineException($this._get_context__296(), new CompletionHandlerException('' + 'Exception in invokeOnCancellation handler for ' + $this, $p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function trySuspend_0($this) {
    var tmp0_loop_0 = $this.__decision_0;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_6;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision_0.atomicfu$compareAndSet(0, 1))
            return true;
          break;
        case 2:
          return false;
        default:var tmp0_error_0_3 = 'Already suspended';
          throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function tryResume_0($this) {
    var tmp0_loop_0 = $this.__decision_0;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_6;
      var tmp0_subject_2 = tmp1__anonymous__1;
      switch (tmp0_subject_2) {
        case 0:
          if ($this.__decision_0.atomicfu$compareAndSet(0, 2))
            return true;
          break;
        case 1:
          return false;
        default:var tmp0_error_0_3 = 'Already resumed';
          throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_3));
      }
    }
    Unit_getInstance();
  }
  function multipleHandlersError($this, handler, state) {
    var tmp0_error_0 = '' + "It's prohibited to register multiple handlers, tried to register " + handler + ', already has ' + state;
    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
  }
  function makeCancelHandler($this, handler) {
    var tmp;
    if (handler instanceof CancelHandler) {
      tmp = handler;
    } else {
      {
        tmp = new InvokeOnCancel(handler);
      }
    }
    return tmp;
  }
  function dispatchResume($this, mode) {
    if (tryResume_0($this))
      return Unit_getInstance();
    dispatch($this, mode);
  }
  function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
    var tmp;
    if (proposedUpdate instanceof CompletedExceptionally) {
      tmp = proposedUpdate;
    } else {
      if (!_get_isCancellableMode_(resumeMode) ? idempotent == null : false) {
        tmp = proposedUpdate;
      } else {
        var tmp_0;
        var tmp_1;
        if (!(onCancellation == null)) {
          tmp_1 = true;
        } else {
          var tmp_2;
          if (state instanceof CancelHandler) {
            tmp_2 = !(state instanceof BeforeResumeCancelHandler);
          } else {
            {
              tmp_2 = false;
            }
          }
          tmp_1 = tmp_2;
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          {
            tmp_0 = !(idempotent == null);
          }
        }
        if (tmp_0) {
          var tmp_3 = state instanceof CancelHandler ? state : null;
          tmp = CompletedContinuation_init_$Create$(proposedUpdate, tmp_3, onCancellation, idempotent, null, 16, null);
        } else {
          {
            tmp = proposedUpdate;
          }
        }
      }
    }
    return tmp;
  }
  function resumeImpl($this, proposedUpdate, resumeMode, onCancellation) {
    var tmp0_loop_0 = $this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_4;
        var tmp0_subject_2 = tmp1__anonymous__1;
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
          var update_3 = resumedState($this, tmp1__anonymous__1, proposedUpdate, resumeMode, onCancellation, null);
          if (!$this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_3)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }detachChildIfNonResuable($this);
          dispatchResume($this, resumeMode);
          return Unit_getInstance();
        } else {
          if (tmp0_subject_2 instanceof CancelledContinuation) {
            if (tmp1__anonymous__1.makeResumed()) {
              var tmp1_safe_receiver_4 = onCancellation;
              if (tmp1_safe_receiver_4 == null)
                null;
              else {
                $this.callOnCancellation_0(tmp1_safe_receiver_4, tmp1__anonymous__1._get_cause__34());
                Unit_getInstance();
              }
              Unit_getInstance();
              return Unit_getInstance();
            }} else {
          }
        }
        alreadyResumedError($this, proposedUpdate);
      }
       while (false);
    }
    Unit_getInstance();
  }
  function resumeImpl$default($this, proposedUpdate, resumeMode, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      onCancellation = null;
    return resumeImpl($this, proposedUpdate, resumeMode, onCancellation);
  }
  function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
    var tmp0_loop_0 = $this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_4;
        var tmp0_subject_2 = tmp1__anonymous__1;
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
          var update_3 = resumedState($this, tmp1__anonymous__1, proposedUpdate, $this._get_resumeMode__1(), onCancellation, idempotent);
          if (!$this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_3)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }detachChildIfNonResuable($this);
          return RESUME_TOKEN;
        } else {
          if (tmp0_subject_2 instanceof CompletedContinuation_0) {
            var tmp;
            if (!(idempotent == null) ? tmp1__anonymous__1._idempotentResume === idempotent : false) {
              tmp = RESUME_TOKEN;
            } else {
              tmp = null;
            }
            return tmp;
          } else {
            return null;
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  }
  function alreadyResumedError($this, proposedUpdate) {
    var tmp0_error_0 = '' + 'Already resumed, but proposed with update ' + proposedUpdate;
    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
  }
  function detachChildIfNonResuable($this) {
    if (!isReusable($this))
      $this.detachChild_0();
  }
  function CancellableContinuationImpl(delegate, resumeMode) {
    DispatchedTask.call(this, resumeMode);
    this._delegate_0 = delegate;
    this._context_0 = this._delegate_0._get_context__296();
    this.__decision_0 = atomic_1(0);
    this.__state = atomic(Active_getInstance());
    this.__parentHandle = atomic(null);
  }
  CancellableContinuationImpl.prototype._get_delegate__2 = function () {
    return this._delegate_0;
  };
  CancellableContinuationImpl.prototype._get_context__296 = function () {
    return this._context_0;
  };
  CancellableContinuationImpl.prototype._get_state__15 = function () {
    return this.__state._value_4;
  };
  CancellableContinuationImpl.prototype._get_isCompleted__16 = function () {
    var tmp = this._get_state__15();
    return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
  };
  CancellableContinuationImpl.prototype.initCancellability_0 = function () {
    setupCancellation(this);
  };
  CancellableContinuationImpl.prototype.resetStateReusable_0 = function () {
    var state = this.__state._value_4;
    var tmp;
    if (state instanceof CompletedContinuation_0) {
      tmp = !(state._idempotentResume == null);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      this.detachChild_0();
      return false;
    } else {
    }
    this.__decision_0._value_6 = 0;
    this.__state._value_4 = Active_getInstance();
    return true;
  };
  CancellableContinuationImpl.prototype.takeState_2 = function () {
    return this._get_state__15();
  };
  CancellableContinuationImpl.prototype.cancelCompletedResult_2 = function (takenState, cause) {
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_4;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, NotCompleted) : false) {
        var tmp0_error_0_3 = 'Not completed';
        throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_3));
      } else {
        if (tmp0_subject_2 instanceof CompletedExceptionally)
          return Unit_getInstance();
        else {
          if (tmp0_subject_2 instanceof CompletedContinuation_0) {
            var tmp1_check_0_4 = !tmp1__anonymous__1._get_cancelled_();
            if (!tmp1_check_0_4) {
              var message_1_5 = 'Must be called at most once';
              throw IllegalStateException_init_$Create$_0(toString_1(message_1_5));
            }var tmp = tmp1__anonymous__1;
            var update_6 = tmp.copy$default(null, null, null, null, cause, 15, null);
            if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_6)) {
              tmp1__anonymous__1.invokeHandlers(this, cause);
              return Unit_getInstance();
            }} else {
            {
              if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, CompletedContinuation_init_$Create$(tmp1__anonymous__1, null, null, null, cause, 14, null))) {
                return Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.cancel_8 = function (cause) {
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp1__anonymous__1 = tmp0_loop_0._value_4;
        if (!(!(tmp1__anonymous__1 == null) ? isInterface(tmp1__anonymous__1, NotCompleted) : false))
          return false;
        else {
        }
        var update_2 = new CancelledContinuation(this, cause, tmp1__anonymous__1 instanceof CancelHandler);
        if (!this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_2)) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }var tmp0_safe_receiver_3 = tmp1__anonymous__1 instanceof CancelHandler ? tmp1__anonymous__1 : null;
        if (tmp0_safe_receiver_3 == null)
          null;
        else {
          this.callCancelHandler_0(tmp0_safe_receiver_3, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
        detachChildIfNonResuable(this);
        dispatchResume(this, this._get_resumeMode__1());
        return true;
      }
       while (false);
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.parentCancelled_8 = function (cause) {
    if (cancelLater(this, cause))
      return Unit_getInstance();
    this.cancel_8(cause);
    Unit_getInstance();
    detachChildIfNonResuable(this);
  };
  CancellableContinuationImpl.prototype.callCancelHandler_0 = function (handler, cause) {
    var tmp;
    try {
      tmp = handler.invoke(cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        tmp_0 = handleCoroutineException(this._get_context__296(), new CompletionHandlerException('' + 'Exception in invokeOnCancellation handler for ' + this, $p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.callOnCancellation_0 = function (onCancellation, cause) {
    try {
      onCancellation(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineException(this._get_context__296(), new CompletionHandlerException('' + 'Exception in resume onCancellation handler for ' + this, $p));
      } else {
        {
          throw $p;
        }
      }
    }
  };
  CancellableContinuationImpl.prototype.getContinuationCancellationCause_0 = function (parent) {
    return parent.getCancellationException_14();
  };
  CancellableContinuationImpl.prototype.getResult_1 = function () {
    setupCancellation(this);
    if (trySuspend_0(this))
      return _get_COROUTINE_SUSPENDED_();
    var state = this._get_state__15();
    if (state instanceof CompletedExceptionally)
      throw recoverStackTrace(state._cause, this);
    else {
    }
    if (_get_isCancellableMode_(this._get_resumeMode__1())) {
      var job = this._get_context__296().get_113(Key_getInstance_2());
      if (!(job == null) ? !job._get_isActive__29() : false) {
        var cause = job.getCancellationException_14();
        this.cancelCompletedResult_2(state, cause);
        throw recoverStackTrace(cause, this);
      }}return this.getSuccessfulResult_2(state);
  };
  CancellableContinuationImpl.prototype.resumeWith_196 = function (result) {
    var tmp = toState(result, this);
    var tmp_0 = this._get_resumeMode__1();
    return resumeImpl$default(this, tmp, tmp_0, null, 8, null);
  };
  CancellableContinuationImpl.prototype.resume_2 = function (value, onCancellation) {
    return resumeImpl(this, value, this._get_resumeMode__1(), onCancellation);
  };
  CancellableContinuationImpl.prototype.invokeOnCancellation_1 = function (handler) {
    var cancelHandler = makeCancelHandler(this, handler);
    var tmp0_loop_0 = this.__state;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_4;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (tmp0_subject_2 instanceof Active) {
        if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, cancelHandler))
          return Unit_getInstance();
      } else {
        if (tmp0_subject_2 instanceof CancelHandler)
          multipleHandlersError(this, handler, tmp1__anonymous__1);
        else {
          if (tmp0_subject_2 instanceof CompletedExceptionally) {
            if (!tmp1__anonymous__1.makeHandled_0())
              multipleHandlersError(this, handler, tmp1__anonymous__1);
            if (tmp1__anonymous__1 instanceof CancelledContinuation) {
              var tmp1_safe_receiver_3 = tmp1__anonymous__1 instanceof CompletedExceptionally ? tmp1__anonymous__1 : null;
              callCancelHandler(this, handler, tmp1_safe_receiver_3 == null ? null : tmp1_safe_receiver_3._cause);
            } else {
            }
            return Unit_getInstance();
          } else {
            if (tmp0_subject_2 instanceof CompletedContinuation_0) {
              if (!(tmp1__anonymous__1._cancelHandler == null))
                multipleHandlersError(this, handler, tmp1__anonymous__1);
              if (cancelHandler instanceof BeforeResumeCancelHandler)
                return Unit_getInstance();
              else {
              }
              if (tmp1__anonymous__1._get_cancelled_()) {
                callCancelHandler(this, handler, tmp1__anonymous__1._cancelCause);
                return Unit_getInstance();
              }var tmp = tmp1__anonymous__1;
              var update_4 = tmp.copy$default(null, cancelHandler, null, null, null, 29, null);
              if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_4))
                return Unit_getInstance();
            } else {
              {
                if (cancelHandler instanceof BeforeResumeCancelHandler)
                  return Unit_getInstance();
                else {
                }
                var update_5 = CompletedContinuation_init_$Create$(tmp1__anonymous__1, cancelHandler, null, null, null, 28, null);
                if (this.__state.atomicfu$compareAndSet(tmp1__anonymous__1, update_5))
                  return Unit_getInstance();
              }
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  CancellableContinuationImpl.prototype.detachChild_0 = function () {
    var handle = _get_parentHandle_(this);
    var tmp0_safe_receiver = handle;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dispose_18();
      Unit_getInstance();
    }
    Unit_getInstance();
    _set_parentHandle_(this, NonDisposableHandle_getInstance());
  };
  CancellableContinuationImpl.prototype.tryResume_3 = function (value, idempotent) {
    return tryResumeImpl(this, value, idempotent, null);
  };
  CancellableContinuationImpl.prototype.tryResume_4 = function (value, idempotent, onCancellation) {
    return tryResumeImpl(this, value, idempotent, onCancellation);
  };
  CancellableContinuationImpl.prototype.completeResume_1 = function (token) {
    dispatchResume(this, this._get_resumeMode__1());
  };
  CancellableContinuationImpl.prototype.resumeUndispatched_1 = function (_this__0, value) {
    var tmp = this._delegate_0;
    var dc = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    var tmp0_safe_receiver = dc;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver._dispatcher) === _this__0) {
      tmp_0 = 4;
    } else {
      {
        tmp_0 = this._get_resumeMode__1();
      }
    }
    var tmp_1 = tmp_0;
    resumeImpl$default(this, value, tmp_1, null, 8, null);
  };
  CancellableContinuationImpl.prototype.getSuccessfulResult_2 = function (state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof CompletedContinuation_0) {
      var tmp_0 = state._result_2;
      tmp = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
    } else {
      {
        tmp = (state == null ? true : isObject(state)) ? state : THROW_CCE();
      }
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.getExceptionalResult_2 = function (state) {
    var tmp0_safe_receiver = DispatchedTask.prototype.getExceptionalResult_2.call(this, state);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = recoverStackTrace(tmp0_safe_receiver, this._delegate_0);
    }
    return tmp;
  };
  CancellableContinuationImpl.prototype.toString = function () {
    return '' + this.nameString_15() + '(' + toDebugString(this._delegate_0) + '){' + _get_stateDebugRepresentation_(this) + '}@' + _get_hexAddress_(this);
  };
  CancellableContinuationImpl.prototype.nameString_15 = function () {
    return 'CancellableContinuation';
  };
  CancellableContinuationImpl.$metadata$ = {
    simpleName: 'CancellableContinuationImpl',
    kind: 'class',
    interfaces: [CancellableContinuation, CoroutineStackFrame]
  };
  function CancelHandler() {
    CancelHandlerBase.call(this);
  }
  CancelHandler.$metadata$ = {
    simpleName: 'CancelHandler',
    kind: 'class',
    interfaces: [NotCompleted]
  };
  function Active() {
    Active_instance = this;
  }
  Active.prototype.toString = function () {
    return 'Active';
  };
  Active.$metadata$ = {
    simpleName: 'Active',
    kind: 'object',
    interfaces: [NotCompleted]
  };
  var Active_instance;
  function Active_getInstance() {
    if (Active_instance == null)
      new Active();
    return Active_instance;
  }
  function NotCompleted() {
  }
  NotCompleted.$metadata$ = {
    simpleName: 'NotCompleted',
    kind: 'interface',
    interfaces: []
  };
  function CompletedContinuation_init_$Init$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      cancelHandler = null;
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    if (!(($mask0 & 8) === 0))
      idempotentResume = null;
    if (!(($mask0 & 16) === 0))
      cancelCause = null;
    CompletedContinuation_0.call($this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
    return $this;
  }
  function CompletedContinuation_init_$Create$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker) {
    return CompletedContinuation_init_$Init$(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $marker, Object.create(CompletedContinuation_0.prototype));
  }
  function CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    this._result_2 = result;
    this._cancelHandler = cancelHandler;
    this._onCancellation = onCancellation;
    this._idempotentResume = idempotentResume;
    this._cancelCause = cancelCause;
  }
  CompletedContinuation_0.prototype._get_cancelled_ = function () {
    return !(this._cancelCause == null);
  };
  CompletedContinuation_0.prototype.invokeHandlers = function (cont, cause) {
    var tmp0_safe_receiver = this._cancelHandler;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cont.callCancelHandler_0(tmp0_safe_receiver, cause);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._onCancellation;
    if (tmp1_safe_receiver == null)
      null;
    else {
      cont.callOnCancellation_0(tmp1_safe_receiver, cause);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  CompletedContinuation_0.prototype.copy_0 = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    return new CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  CompletedContinuation_0.prototype.copy$default = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      result = this._result_2;
    if (!(($mask0 & 2) === 0))
      cancelHandler = this._cancelHandler;
    if (!(($mask0 & 4) === 0))
      onCancellation = this._onCancellation;
    if (!(($mask0 & 8) === 0))
      idempotentResume = this._idempotentResume;
    if (!(($mask0 & 16) === 0))
      cancelCause = this._cancelCause;
    return this.copy_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  CompletedContinuation_0.prototype.toString = function () {
    return '' + 'CompletedContinuation(result=' + this._result_2 + ', cancelHandler=' + this._cancelHandler + ', onCancellation=' + this._onCancellation + ', idempotentResume=' + this._idempotentResume + ', cancelCause=' + this._cancelCause + ')';
  };
  CompletedContinuation_0.prototype.hashCode = function () {
    var result = this._result_2 == null ? 0 : hashCode(this._result_2);
    result = imul(result, 31) + (this._cancelHandler == null ? 0 : hashCode(this._cancelHandler)) | 0;
    result = imul(result, 31) + (this._onCancellation == null ? 0 : hashCode(this._onCancellation)) | 0;
    result = imul(result, 31) + (this._idempotentResume == null ? 0 : hashCode(this._idempotentResume)) | 0;
    result = imul(result, 31) + (this._cancelCause == null ? 0 : hashCode(this._cancelCause)) | 0;
    return result;
  };
  CompletedContinuation_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedContinuation_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedContinuation_0 ? other : THROW_CCE();
    if (!equals_1(this._result_2, tmp0_other_with_cast._result_2))
      return false;
    if (!equals_1(this._cancelHandler, tmp0_other_with_cast._cancelHandler))
      return false;
    if (!equals_1(this._onCancellation, tmp0_other_with_cast._onCancellation))
      return false;
    if (!equals_1(this._idempotentResume, tmp0_other_with_cast._idempotentResume))
      return false;
    if (!equals_1(this._cancelCause, tmp0_other_with_cast._cancelCause))
      return false;
    return true;
  };
  CompletedContinuation_0.$metadata$ = {
    simpleName: 'CompletedContinuation',
    kind: 'class',
    interfaces: []
  };
  function BeforeResumeCancelHandler() {
    CancelHandler.call(this);
  }
  BeforeResumeCancelHandler.$metadata$ = {
    simpleName: 'BeforeResumeCancelHandler',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCancel(handler) {
    CancelHandler.call(this);
    this._handler = handler;
  }
  InvokeOnCancel.prototype.invoke_725 = function (cause) {
    this._handler(cause);
  };
  InvokeOnCancel.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  InvokeOnCancel.prototype.toString = function () {
    return '' + 'InvokeOnCancel[' + _get_classSimpleName_(this._handler) + '@' + _get_hexAddress_(this) + ']';
  };
  InvokeOnCancel.$metadata$ = {
    simpleName: 'InvokeOnCancel',
    kind: 'class',
    interfaces: []
  };
  function CompletableDeferred() {
  }
  CompletableDeferred.$metadata$ = {
    simpleName: 'CompletableDeferred',
    kind: 'interface',
    interfaces: [Deferred]
  };
  function CompletableDeferred_0(parent) {
    return new CompletableDeferredImpl(parent);
  }
  function CompletableDeferred$default(parent, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    return CompletableDeferred_0(parent);
  }
  function $awaitCOROUTINE$1(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__0 = _this_;
  }
  $awaitCOROUTINE$1.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__0.awaitInternal_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp_0 = suspendResult;
            return (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $awaitCOROUTINE$1.$metadata$ = {
    simpleName: '$awaitCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function CompletableDeferredImpl(parent) {
    JobSupport.call(this, true);
    this.initParentJobInternal_13(parent);
  }
  CompletableDeferredImpl.prototype._get_onCancelComplete__13 = function () {
    return true;
  };
  CompletableDeferredImpl.prototype.await_3 = function ($cont) {
    var tmp = new $awaitCOROUTINE$1(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  CompletableDeferredImpl.prototype.complete_1 = function (value) {
    return this.makeCompleting_0(value);
  };
  CompletableDeferredImpl.prototype.completeExceptionally_0 = function (exception) {
    return this.makeCompleting_0(CompletedExceptionally_init_$Create$(exception, false, 2, null));
  };
  CompletableDeferredImpl.$metadata$ = {
    simpleName: 'CompletableDeferredImpl',
    kind: 'class',
    interfaces: [CompletableDeferred, SelectClause1]
  };
  function CompletableJob() {
  }
  CompletableJob.$metadata$ = {
    simpleName: 'CompletableJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      handled = false;
    CompletedExceptionally.call($this, cause, handled);
    return $this;
  }
  function CompletedExceptionally_init_$Create$(cause, handled, $mask0, $marker) {
    return CompletedExceptionally_init_$Init$(cause, handled, $mask0, $marker, Object.create(CompletedExceptionally.prototype));
  }
  function CompletedExceptionally(cause, handled) {
    this._cause = cause;
    this.__handled = atomic_0(handled);
  }
  CompletedExceptionally.prototype._get_cause__34 = function () {
    return this._cause;
  };
  CompletedExceptionally.prototype._get_handled__0 = function () {
    return this.__handled._value_5;
  };
  CompletedExceptionally.prototype.makeHandled_0 = function () {
    return this.__handled.atomicfu$compareAndSet(false, true);
  };
  CompletedExceptionally.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '[' + this._cause + ']';
  };
  CompletedExceptionally.$metadata$ = {
    simpleName: 'CompletedExceptionally',
    kind: 'class',
    interfaces: []
  };
  function CancelledContinuation(continuation, cause, handled) {
    var tmp0_elvis_lhs = cause;
    CompletedExceptionally.call(this, tmp0_elvis_lhs == null ? CancellationException_init_$Create$('' + 'Continuation ' + continuation + ' was cancelled normally') : tmp0_elvis_lhs, handled);
    this.__resumed = atomic_0(false);
  }
  CancelledContinuation.prototype.makeResumed = function () {
    return this.__resumed.atomicfu$compareAndSet(false, true);
  };
  CancelledContinuation.$metadata$ = {
    simpleName: 'CancelledContinuation',
    kind: 'class',
    interfaces: []
  };
  function toState(_this_, caller) {
    var exception_1 = Result__exceptionOrNull_impl(_this_);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _Result___get_value__impl_(_this_);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = tmp0__anonymous__2;
    } else {
      var tmp_1 = recoverStackTrace(exception_1, caller);
      tmp = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
    }
    return tmp;
  }
  function toState_0(_this_, onCancellation) {
    var exception_1 = Result__exceptionOrNull_impl(_this_);
    var tmp;
    if (exception_1 == null) {
      var tmp_0 = _Result___get_value__impl_(_this_);
      var tmp0__anonymous__2 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      tmp = !(onCancellation == null) ? new CompletedWithCancellation(tmp0__anonymous__2, onCancellation) : tmp0__anonymous__2;
    } else {
      tmp = CompletedExceptionally_init_$Create$(exception_1, false, 2, null);
    }
    return tmp;
  }
  function toState$default(_this_, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancellation = null;
    return toState_0(_this_, onCancellation);
  }
  function CompletedWithCancellation(result, onCancellation) {
    this._result_3 = result;
    this._onCancellation_0 = onCancellation;
  }
  CompletedWithCancellation.prototype.toString = function () {
    return '' + 'CompletedWithCancellation(result=' + this._result_3 + ', onCancellation=' + this._onCancellation_0 + ')';
  };
  CompletedWithCancellation.prototype.hashCode = function () {
    var result = this._result_3 == null ? 0 : hashCode(this._result_3);
    result = imul(result, 31) + hashCode(this._onCancellation_0) | 0;
    return result;
  };
  CompletedWithCancellation.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedWithCancellation))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedWithCancellation ? other : THROW_CCE();
    if (!equals_1(this._result_3, tmp0_other_with_cast._result_3))
      return false;
    if (!equals_1(this._onCancellation_0, tmp0_other_with_cast._onCancellation_0))
      return false;
    return true;
  };
  CompletedWithCancellation.$metadata$ = {
    simpleName: 'CompletedWithCancellation',
    kind: 'class',
    interfaces: []
  };
  function recoverResult(state, uCont) {
    var tmp;
    if (state instanceof CompletedExceptionally) {
      var tmp0_failure_0 = Companion_getInstance_2();
      var tmp1_failure_0 = recoverStackTrace(state._cause, uCont);
      tmp = _Result___init__impl_(createFailure(tmp1_failure_0));
    } else {
      {
        var tmp2_success_0 = Companion_getInstance_2();
        var tmp3_success_0 = (state == null ? true : isObject(state)) ? state : THROW_CCE();
        tmp = _Result___init__impl_(tmp3_success_0);
      }
    }
    return tmp;
  }
  function _no_name_provided__60() {
  }
  _no_name_provided__60.prototype.invoke_88 = function (it) {
    return it instanceof CoroutineDispatcher ? it : null;
  };
  _no_name_provided__60.prototype.invoke_1015 = function (p1) {
    return this.invoke_88((!(p1 == null) ? isInterface(p1, Element_0) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__60.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Key_1() {
    Key_instance_0 = this;
    var tmp = Key_getInstance();
    AbstractCoroutineContextKey.call(this, tmp, _no_name_provided_$factory_42());
  }
  Key_1.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: []
  };
  var Key_instance_0;
  function Key_getInstance_0() {
    if (Key_instance_0 == null)
      new Key_1();
    return Key_instance_0;
  }
  function CoroutineDispatcher() {
    Key_getInstance_0();
    AbstractCoroutineContextElement.call(this, Key_getInstance());
  }
  CoroutineDispatcher.prototype.isDispatchNeeded_9 = function (context) {
    return true;
  };
  CoroutineDispatcher.prototype.interceptContinuation_11 = function (continuation) {
    return new DispatchedContinuation(this, continuation);
  };
  CoroutineDispatcher.prototype.releaseInterceptedContinuation_11 = function (continuation) {
    var tmp0_safe_receiver = (continuation instanceof DispatchedContinuation ? continuation : THROW_CCE())._get_reusableCancellableContinuation_();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.detachChild_0();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  CoroutineDispatcher.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this);
  };
  CoroutineDispatcher.$metadata$ = {
    simpleName: 'CoroutineDispatcher',
    kind: 'class',
    interfaces: [ContinuationInterceptor]
  };
  function _no_name_provided_$factory_42() {
    var i = new _no_name_provided__60();
    return function (p1) {
      return i.invoke_88(p1);
    };
  }
  function Key_2() {
    Key_instance_1 = this;
  }
  Key_2.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_1;
  function Key_getInstance_1() {
    if (Key_instance_1 == null)
      new Key_2();
    return Key_instance_1;
  }
  function handleCoroutineException(context, exception) {
    try {
      var tmp0_safe_receiver = context.get_113(Key_getInstance_1());
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.handleException__error(context, exception);
        return Unit_getInstance();
      }
      Unit_getInstance();
    } catch ($p) {
      if ($p instanceof Error) {
        handleCoroutineExceptionImpl(context, handlerException(exception, $p));
        return Unit_getInstance();
      } else {
        {
          throw $p;
        }
      }
    }
    handleCoroutineExceptionImpl(context, exception);
  }
  function handlerException(originalException, thrownException) {
    if (originalException === thrownException)
      return originalException;
    var tmp0_apply_0 = RuntimeException_init_$Create$_0('Exception while trying to handle coroutine exception', thrownException);
    return tmp0_apply_0;
  }
  function CoroutineScope() {
  }
  CoroutineScope.$metadata$ = {
    simpleName: 'CoroutineScope',
    kind: 'interface',
    interfaces: []
  };
  function CoroutineScope_0(context) {
    var tmp;
    if (!(context.get_113(Key_getInstance_2()) == null)) {
      tmp = context;
    } else {
      tmp = context.plus_36(Job$default(null, 1, null));
    }
    return new ContextScope(tmp);
  }
  function coroutineScope(block, $cont) {
    var tmp0__anonymous__1 = $cont;
    var coroutine_2 = new ScopeCoroutine(tmp0__anonymous__1._get_context__296(), tmp0__anonymous__1);
    return startUndispatchedOrReturn(coroutine_2, coroutine_2, block);
  }
  var CoroutineStart_DEFAULT_instance;
  var CoroutineStart_LAZY_instance;
  var CoroutineStart_ATOMIC_instance;
  var CoroutineStart_UNDISPATCHED_instance;
  var CoroutineStart_entriesInitialized;
  function CoroutineStart_initEntries() {
    if (CoroutineStart_entriesInitialized)
      return Unit_getInstance();
    CoroutineStart_entriesInitialized = true;
    CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
    CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
    CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
    CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
  }
  function CoroutineStart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CoroutineStart.prototype.invoke_90 = function (block, receiver, completion) {
    var tmp0_subject = this;
    var tmp;
    if (tmp0_subject.equals(CoroutineStart_DEFAULT_getInstance())) {
      tmp = startCoroutineCancellable$default(block, receiver, completion, null, 4, null);
    } else if (tmp0_subject.equals(CoroutineStart_ATOMIC_getInstance())) {
      tmp = startCoroutine_0(block, receiver, completion);
    } else if (tmp0_subject.equals(CoroutineStart_UNDISPATCHED_getInstance())) {
      tmp = startCoroutineUndispatched(block, receiver, completion);
    } else if (tmp0_subject.equals(CoroutineStart_LAZY_getInstance())) {
      tmp = Unit_getInstance();
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CoroutineStart.prototype._get_isLazy_ = function () {
    return this === CoroutineStart_LAZY_getInstance();
  };
  CoroutineStart.$metadata$ = {
    simpleName: 'CoroutineStart',
    kind: 'class',
    interfaces: []
  };
  function CoroutineStart_DEFAULT_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_DEFAULT_instance;
  }
  function CoroutineStart_LAZY_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_LAZY_instance;
  }
  function CoroutineStart_ATOMIC_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_ATOMIC_instance;
  }
  function CoroutineStart_UNDISPATCHED_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_UNDISPATCHED_instance;
  }
  function CopyableThrowable() {
  }
  CopyableThrowable.$metadata$ = {
    simpleName: 'CopyableThrowable',
    kind: 'interface',
    interfaces: []
  };
  function Deferred() {
  }
  Deferred.$metadata$ = {
    simpleName: 'Deferred',
    kind: 'interface',
    interfaces: [Job]
  };
  function Delay() {
  }
  Delay.prototype.invokeOnTimeout_5 = function (timeMillis, block, context) {
    return _get_DefaultDelay_().invokeOnTimeout_5(timeMillis, block, context);
  };
  Delay.$metadata$ = {
    simpleName: 'Delay',
    kind: 'interface',
    interfaces: []
  };
  function _get_delay_(_this_) {
    var tmp = _this_.get_113(Key_getInstance());
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? _get_DefaultDelay_() : tmp0_elvis_lhs;
  }
  function delay(timeMillis, $cont) {
    if (timeMillis.compareTo_137(new Long(0, 0)) <= 0)
      return Unit_getInstance();
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_0();
    if (timeMillis.compareTo_137(new Long(-1, 2147483647)) < 0) {
      _get_delay_(cancellable_2_2._get_context__296()).scheduleResumeAfterDelay_5(timeMillis, cancellable_2_2);
    }return cancellable_2_2.getResult_1();
  }
  function delta($this, unconfined) {
    return unconfined ? new Long(0, 1) : new Long(1, 0);
  }
  function EventLoop() {
    CoroutineDispatcher.call(this);
    this._useCount = new Long(0, 0);
    this._shared = false;
    this._unconfinedQueue = null;
  }
  EventLoop.prototype.processUnconfinedEvent_0 = function () {
    var tmp0_elvis_lhs = this._unconfinedQueue;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.removeFirstOrNull_2();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.run_5();
    return true;
  };
  EventLoop.prototype.dispatchUnconfined_0 = function (task) {
    var tmp0_elvis_lhs = this._unconfinedQueue;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new ArrayQueue();
      this._unconfinedQueue = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.addLast_20(task);
  };
  EventLoop.prototype._get_isUnconfinedLoopActive__0 = function () {
    return this._useCount.compareTo_137(delta(this, true)) >= 0;
  };
  EventLoop.prototype._get_isUnconfinedQueueEmpty__0 = function () {
    var tmp0_safe_receiver = this._unconfinedQueue;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_isEmpty__2();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  };
  EventLoop.prototype.incrementUseCount_0 = function (unconfined) {
    var tmp0_this = this;
    tmp0_this._useCount = tmp0_this._useCount.plus_64(delta(this, unconfined));
    if (!unconfined)
      this._shared = true;
  };
  EventLoop.prototype.decrementUseCount_0 = function (unconfined) {
    var tmp0_this = this;
    tmp0_this._useCount = tmp0_this._useCount.minus_29(delta(this, unconfined));
    if (this._useCount.compareTo_137(new Long(0, 0)) > 0)
      return Unit_getInstance();
    if (this._shared) {
      this.shutdown_0();
    }};
  EventLoop.prototype.shutdown_0 = function () {
  };
  EventLoop.$metadata$ = {
    simpleName: 'EventLoop',
    kind: 'class',
    interfaces: []
  };
  function ThreadLocalEventLoop() {
    ThreadLocalEventLoop_instance = this;
    this._ref = new CommonThreadLocal();
  }
  ThreadLocalEventLoop.prototype._get_eventLoop_ = function () {
    var tmp0_elvis_lhs = this._ref.get_85();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = createEventLoop();
      ThreadLocalEventLoop_getInstance()._ref.set_10(tmp0_also_0);
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  ThreadLocalEventLoop.$metadata$ = {
    simpleName: 'ThreadLocalEventLoop',
    kind: 'object',
    interfaces: []
  };
  var ThreadLocalEventLoop_instance;
  function ThreadLocalEventLoop_getInstance() {
    if (ThreadLocalEventLoop_instance == null)
      new ThreadLocalEventLoop();
    return ThreadLocalEventLoop_instance;
  }
  function CompletionHandlerException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, CompletionHandlerException);
  }
  CompletionHandlerException.$metadata$ = {
    simpleName: 'CompletionHandlerException',
    kind: 'class',
    interfaces: []
  };
  function CoroutinesInternalError(message, cause) {
    Error_init_$Init$_1(message, cause, this);
    captureStack(this, CoroutinesInternalError);
  }
  CoroutinesInternalError.$metadata$ = {
    simpleName: 'CoroutinesInternalError',
    kind: 'class',
    interfaces: []
  };
  function DisposableHandle() {
  }
  DisposableHandle.$metadata$ = {
    simpleName: 'DisposableHandle',
    kind: 'interface',
    interfaces: []
  };
  function Key_3() {
    Key_instance_2 = this;
    Key_getInstance_1();
    Unit_getInstance();
  }
  Key_3.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_2;
  function Key_getInstance_2() {
    if (Key_instance_2 == null)
      new Key_3();
    return Key_instance_2;
  }
  function Job() {
  }
  Job.prototype.cancel$default_14 = function (cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return $handler == null ? this.cancel_23(cause) : $handler(cause);
  };
  Job.prototype.invokeOnCompletion$default_14 = function (onCancelling, invokeImmediately, handler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      onCancelling = false;
    if (!(($mask0 & 2) === 0))
      invokeImmediately = true;
    return $handler == null ? this.invokeOnCompletion_32(onCancelling, invokeImmediately, handler) : $handler(onCancelling, invokeImmediately, handler);
  };
  Job.$metadata$ = {
    simpleName: 'Job',
    kind: 'interface',
    interfaces: [Element_0]
  };
  function ChildJob() {
  }
  ChildJob.$metadata$ = {
    simpleName: 'ChildJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ParentJob() {
  }
  ParentJob.$metadata$ = {
    simpleName: 'ParentJob',
    kind: 'interface',
    interfaces: [Job]
  };
  function ChildHandle() {
  }
  ChildHandle.$metadata$ = {
    simpleName: 'ChildHandle',
    kind: 'interface',
    interfaces: [DisposableHandle]
  };
  function NonDisposableHandle() {
    NonDisposableHandle_instance = this;
  }
  NonDisposableHandle.prototype.dispose_18 = function () {
  };
  NonDisposableHandle.prototype.childCancelled_16 = function (cause) {
    return false;
  };
  NonDisposableHandle.prototype.toString = function () {
    return 'NonDisposableHandle';
  };
  NonDisposableHandle.$metadata$ = {
    simpleName: 'NonDisposableHandle',
    kind: 'object',
    interfaces: [DisposableHandle, ChildHandle]
  };
  var NonDisposableHandle_instance;
  function NonDisposableHandle_getInstance() {
    if (NonDisposableHandle_instance == null)
      new NonDisposableHandle();
    return NonDisposableHandle_instance;
  }
  function Job_0(parent) {
    return new JobImpl(parent);
  }
  function Job$default(parent, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    return Job_0(parent);
  }
  function _get_job_(_this_) {
    var tmp0_elvis_lhs = _this_.get_113(Key_getInstance_2());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = '' + "Current context doesn't contain Job in it: " + _this_;
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function cancel(_this_, cause) {
    var tmp0_safe_receiver = _this_.get_113(Key_getInstance_2());
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel_23(cause);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function cancel$default(_this_, cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return cancel(_this_, cause);
  }
  function disposeOnCompletion(_this_, handle) {
    var tmp0__get_asHandler__0 = new DisposeOnCompletion(handle);
    return _this_.invokeOnCompletion_31(tmp0__get_asHandler__0);
  }
  function ensureActive(_this_) {
    var tmp0_safe_receiver = _this_.get_113(Key_getInstance_2());
    if (tmp0_safe_receiver == null)
      null;
    else {
      ensureActive_0(tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function ensureActive_0(_this_) {
    if (!_this_._get_isActive__29())
      throw _this_.getCancellationException_14();
  }
  function cancelChildren(_this_, cause) {
    var tmp0_safe_receiver = _this_.get_113(Key_getInstance_2());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_children__24();
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp0_iterator_1 = tmp1_safe_receiver.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        element_2.cancel_23(cause);
      }
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function cancelChildren$default(_this_, cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return cancelChildren(_this_, cause);
  }
  function cancelAndJoin(_this_, $cont) {
    _this_.cancel$default_14(null, 1, null);
    return _this_.join_14($cont);
  }
  var COMPLETING_ALREADY;
  var COMPLETING_WAITING_CHILDREN;
  var COMPLETING_RETRY;
  var TOO_LATE_TO_CANCEL;
  var SEALED;
  var EMPTY_NEW;
  var EMPTY_ACTIVE;
  function Empty(isActive) {
    this._isActive = isActive;
  }
  Empty.prototype._get_isActive__29 = function () {
    return this._isActive;
  };
  Empty.prototype._get_list__13 = function () {
    return null;
  };
  Empty.prototype.toString = function () {
    return '' + 'Empty{' + (this._isActive ? 'Active' : 'New') + '}';
  };
  Empty.$metadata$ = {
    simpleName: 'Empty',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function Incomplete() {
  }
  Incomplete.$metadata$ = {
    simpleName: 'Incomplete',
    kind: 'interface',
    interfaces: []
  };
  function NodeList_0() {
    LinkedListHead.call(this);
  }
  NodeList_0.prototype._get_isActive__29 = function () {
    return true;
  };
  NodeList_0.prototype._get_list__13 = function () {
    return this;
  };
  NodeList_0.prototype.getString = function (state) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_5('List{');
    Unit_getInstance();
    tmp0_apply_0_1.append_5(state);
    Unit_getInstance();
    tmp0_apply_0_1.append_5('}[');
    Unit_getInstance();
    var first_3 = true;
    var cur_1_4 = this._get__next__1();
    while (!equals_1(cur_1_4, this)) {
      if (cur_1_4 instanceof JobNode) {
        var tmp0__anonymous__2_5 = cur_1_4;
        if (first_3)
          first_3 = false;
        else {
          tmp0_apply_0_1.append_5(', ');
          Unit_getInstance();
        }
        tmp0_apply_0_1.append_4(tmp0__anonymous__2_5);
        Unit_getInstance();
      } else {
      }
      cur_1_4 = cur_1_4.__next;
    }
    tmp0_apply_0_1.append_5(']');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  NodeList_0.prototype.toString = function () {
    return DEBUG ? this.getString('Active') : anyToString(this);
  };
  NodeList_0.$metadata$ = {
    simpleName: 'NodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function JobNode() {
    CompletionHandlerBase.call(this);
  }
  JobNode.prototype._get_job__8 = function () {
    var tmp = this._job;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('job');
    }
  };
  JobNode.prototype._get_isActive__29 = function () {
    return true;
  };
  JobNode.prototype._get_list__13 = function () {
    return null;
  };
  JobNode.prototype.dispose_18 = function () {
    return this._get_job__8().removeNode_13(this);
  };
  JobNode.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '[job@' + _get_hexAddress_(this._get_job__8()) + ']';
  };
  JobNode.$metadata$ = {
    simpleName: 'JobNode',
    kind: 'class',
    interfaces: [DisposableHandle, Incomplete]
  };
  function _set_exceptionsHolder_($this, value) {
    $this.__exceptionsHolder._value_4 = value;
  }
  function _get_exceptionsHolder_($this) {
    return $this.__exceptionsHolder._value_4;
  }
  function allocateList($this) {
    return ArrayList_init_$Create$_0(4);
  }
  function finalizeFinishingState($this, state, proposedUpdate) {
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
    var wasCancelling = false;
    wasCancelling = state._get_isCancelling_();
    var exceptions_2 = state.sealLocked(proposedException);
    var finalCause_3 = getFinalRootCause($this, state, exceptions_2);
    if (!(finalCause_3 == null))
      addSuppressedExceptions($this, finalCause_3, exceptions_2);
    var finalException = finalCause_3;
    var tmp;
    if (finalException == null) {
      tmp = proposedUpdate;
    } else if (finalException === proposedException) {
      tmp = proposedUpdate;
    } else {
      tmp = CompletedExceptionally_init_$Create$(finalException, false, 2, null);
    }
    var finalState = tmp;
    if (!(finalException == null)) {
      var handled = cancelParent($this, finalException) ? true : $this.handleJobException_13(finalException);
      if (handled) {
        (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).makeHandled_0();
        Unit_getInstance();
      }}if (!wasCancelling)
      $this.onCancelling_13(finalException);
    $this.onCompletionInternal_13(finalState);
    var casSuccess = $this.__state_0.atomicfu$compareAndSet(state, boxIncomplete(finalState));
    completeStateFinalization($this, state, finalState);
    return finalState;
  }
  function getFinalRootCause($this, state, exceptions) {
    if (exceptions.isEmpty_53()) {
      if (state._get_isCancelling_()) {
        var tmp0_defaultCancellationException_0 = null;
        var tmp1_defaultCancellationException_0 = null;
        var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
        return new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_13() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, $this);
      }return null;
    }var tmp$ret$0;
    l$ret$1: do {
      var tmp0_iterator_1 = exceptions.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (!(element_2 instanceof CancellationException_0)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var firstNonCancellation = tmp$ret$0;
    if (!(firstNonCancellation == null))
      return firstNonCancellation;
    var first_2 = exceptions.get_137(0);
    if (first_2 instanceof TimeoutCancellationException) {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp0_iterator_1_0 = exceptions.iterator_67();
        while (tmp0_iterator_1_0.hasNext_33()) {
          var element_2_0 = tmp0_iterator_1_0.next_37();
          var tmp;
          if (!(element_2_0 === first_2)) {
            tmp = element_2_0 instanceof TimeoutCancellationException;
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$2 = element_2_0;
            break l$ret$3;
          } else {
          }
        }
        tmp$ret$2 = null;
      }
       while (false);
      var detailedTimeoutException = tmp$ret$2;
      if (!(detailedTimeoutException == null))
        return detailedTimeoutException;
    } else {
    }
    return first_2;
  }
  function addSuppressedExceptions($this, rootCause, exceptions) {
    if (exceptions._get_size__60() <= 1)
      return Unit_getInstance();
    var seenExceptions = identitySet(exceptions._get_size__60());
    var unwrappedCause = unwrap(rootCause);
    var tmp0_iterator = exceptions.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var exception = tmp0_iterator.next_37();
      var unwrapped = unwrap(exception);
      var tmp;
      var tmp_0;
      if (!(unwrapped === rootCause) ? !(unwrapped === unwrappedCause) : false) {
        tmp_0 = !(unwrapped instanceof CancellationException_0);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = seenExceptions.add_39(unwrapped);
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
      } else {
      }
    }
  }
  function tryFinalizeSimpleState($this, state, update) {
    if (!$this.__state_0.atomicfu$compareAndSet(state, boxIncomplete(update)))
      return false;
    $this.onCancelling_13(null);
    $this.onCompletionInternal_13(update);
    completeStateFinalization($this, state, update);
    return true;
  }
  function completeStateFinalization($this, state, update) {
    var tmp0_safe_receiver = $this._get_parentHandle__13();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dispose_18();
      $this._set_parentHandle__13(NonDisposableHandle_getInstance());
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
    var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._cause;
    if (state instanceof JobNode) {
      try {
        state.invoke(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          $this.handleOnCompletionException_13(new CompletionHandlerException('' + 'Exception in completion handler ' + state + ' for ' + $this, $p));
        } else {
          {
            throw $p;
          }
        }
      }
    } else {
      {
        var tmp2_safe_receiver = state._get_list__13();
        if (tmp2_safe_receiver == null)
          null;
        else {
          notifyCompletion(tmp2_safe_receiver, $this, cause);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
    }
  }
  function notifyCancelling($this, list, cause) {
    $this.onCancelling_13(cause);
    var exception_1 = null;
    var cur_1 = list._get__next__1();
    while (!equals_1(cur_1, list)) {
      if (cur_1 instanceof JobCancellingNode) {
        var tmp0__anonymous__2_2 = cur_1;
        try {
          tmp0__anonymous__2_2.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_safe_receiver_5_5 = exception_1;
            var tmp;
            if (tmp0_safe_receiver_5_5 == null) {
              tmp = null;
            } else {
              tmp = tmp0_safe_receiver_5_5;
            }
            var tmp1_elvis_lhs_4_4 = tmp;
            if (tmp1_elvis_lhs_4_4 == null) {
              exception_1 = new CompletionHandlerException('' + 'Exception in completion handler ' + tmp0__anonymous__2_2 + ' for ' + $this, $p);
              Unit_getInstance();
            } else
              tmp1_elvis_lhs_4_4;
            Unit_getInstance();
          } else {
            {
              throw $p;
            }
          }
        }
      } else {
      }
      cur_1 = cur_1.__next;
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      $this.handleOnCompletionException_13(tmp0_safe_receiver_8);
      Unit_getInstance();
    }
    Unit_getInstance();
    cancelParent($this, cause);
    Unit_getInstance();
  }
  function cancelParent($this, cause) {
    if ($this._get_isScopedCoroutine__13())
      return true;
    var isCancellation = cause instanceof CancellationException_0;
    var parent = $this._get_parentHandle__13();
    if (parent === null ? true : parent === NonDisposableHandle_getInstance()) {
      return isCancellation;
    }return parent.childCancelled_16(cause) ? true : isCancellation;
  }
  function notifyCompletion(_this_, $this, cause) {
    var exception_1 = null;
    var cur_1 = _this_._get__next__1();
    while (!equals_1(cur_1, _this_)) {
      if (cur_1 instanceof JobNode) {
        var tmp0__anonymous__2_2 = cur_1;
        try {
          tmp0__anonymous__2_2.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var tmp0_safe_receiver_5_5 = exception_1;
            var tmp;
            if (tmp0_safe_receiver_5_5 == null) {
              tmp = null;
            } else {
              tmp = tmp0_safe_receiver_5_5;
            }
            var tmp1_elvis_lhs_4_4 = tmp;
            if (tmp1_elvis_lhs_4_4 == null) {
              exception_1 = new CompletionHandlerException('' + 'Exception in completion handler ' + tmp0__anonymous__2_2 + ' for ' + $this, $p);
              Unit_getInstance();
            } else
              tmp1_elvis_lhs_4_4;
            Unit_getInstance();
          } else {
            {
              throw $p;
            }
          }
        }
      } else {
      }
      cur_1 = cur_1.__next;
    }
    var tmp0_safe_receiver_8 = exception_1;
    if (tmp0_safe_receiver_8 == null)
      null;
    else {
      $this.handleOnCompletionException_13(tmp0_safe_receiver_8);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function startInternal($this, state) {
    var tmp0_subject = state;
    if (tmp0_subject instanceof Empty) {
      if (state._isActive)
        return 0;
      if (!$this.__state_0.atomicfu$compareAndSet(state, EMPTY_ACTIVE))
        return -1;
      $this.onStartInternal_13();
      return 1;
    } else {
      if (tmp0_subject instanceof InactiveNodeList) {
        if (!$this.__state_0.atomicfu$compareAndSet(state, state._list_1))
          return -1;
        $this.onStartInternal_13();
        return 1;
      } else {
        return 0;
      }
    }
  }
  function makeNode($this, handler, onCancelling) {
    var tmp;
    if (onCancelling) {
      var tmp0_elvis_lhs = handler instanceof JobCancellingNode ? handler : null;
      tmp = tmp0_elvis_lhs == null ? new InvokeOnCancelling(handler) : tmp0_elvis_lhs;
    } else {
      var tmp1_safe_receiver = handler instanceof JobNode ? handler : null;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = tmp1_safe_receiver;
      }
      var tmp2_elvis_lhs = tmp_0;
      tmp = tmp2_elvis_lhs == null ? new InvokeOnCompletion(handler) : tmp2_elvis_lhs;
    }
    var node = tmp;
    node._job = $this;
    return node;
  }
  function addLastAtomic($this, expect, list, node) {
    var tmp$ret$0;
    l$ret$1: do {
      if (!($this._get_state__15() === expect)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      list.addLast_26(node);
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function promoteEmptyToNodeList($this, state) {
    var list = new NodeList_0();
    var update = state._isActive ? list : new InactiveNodeList(list);
    $this.__state_0.atomicfu$compareAndSet(state, update);
    Unit_getInstance();
  }
  function promoteSingleToNodeList($this, state) {
    state.addOneIfEmpty_9(new NodeList_0());
    Unit_getInstance();
    var list = state.__next;
    $this.__state_0.atomicfu$compareAndSet(state, list);
    Unit_getInstance();
  }
  function joinInternal($this) {
    while (true) {
      var tmp0__anonymous__1 = $this._get_state__15();
      if (!(!(tmp0__anonymous__1 == null) ? isInterface(tmp0__anonymous__1, Incomplete) : false))
        return false;
      else {
      }
      if (startInternal($this, tmp0__anonymous__1) >= 0)
        return true;
    }
    Unit_getInstance();
  }
  function joinSuspend($this, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_0();
    var tmp0__get_asHandler__0_4 = new ResumeOnCompletion(cancellable_2_2);
    disposeOnCancellation(cancellable_2_2, $this.invokeOnCompletion_31(tmp0__get_asHandler__0_4));
    return cancellable_2_2.getResult_1();
  }
  function cancelMakeCompleting($this, cause) {
    while (true) {
      var tmp0__anonymous__1 = $this._get_state__15();
      var tmp;
      if (!(!(tmp0__anonymous__1 == null) ? isInterface(tmp0__anonymous__1, Incomplete) : false)) {
        tmp = true;
      } else {
        {
          var tmp_0;
          if (tmp0__anonymous__1 instanceof Finishing) {
            tmp_0 = tmp0__anonymous__1._get_isCompleting_();
          } else {
            {
              tmp_0 = false;
            }
          }
          tmp = tmp_0;
        }
      }
      if (tmp) {
        return COMPLETING_ALREADY;
      } else {
      }
      var tmp_1 = createCauseException($this, cause);
      var proposedUpdate_2 = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
      var finalState_3 = tryMakeCompleting($this, tmp0__anonymous__1, proposedUpdate_2);
      if (!(finalState_3 === COMPLETING_RETRY))
        return finalState_3;
    }
    Unit_getInstance();
  }
  function createCauseException($this, cause) {
    var tmp0_subject = cause;
    var tmp;
    if (tmp0_subject == null ? true : tmp0_subject instanceof Error) {
      var tmp1_elvis_lhs = cause;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_defaultCancellationException_0 = null;
        var tmp1_defaultCancellationException_0 = null;
        var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
        tmp_0 = new JobCancellationException(tmp0_elvis_lhs_1 == null ? $this.cancellationExceptionMessage_13() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, $this);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      {
        tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).getChildJobCancellationCause_14();
      }
    }
    return tmp;
  }
  function makeCancelling($this, cause) {
    var causeExceptionCache = null;
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = $this._get_state__15();
        var tmp0_subject_2 = tmp0__anonymous__1;
        if (tmp0_subject_2 instanceof Finishing) {
          if (tmp0__anonymous__1._get_isSealed_())
            return TOO_LATE_TO_CANCEL;
          var wasCancelling_2_4 = tmp0__anonymous__1._get_isCancelling_();
          if (!(cause == null) ? true : !wasCancelling_2_4) {
            var tmp0_elvis_lhs_4_6 = causeExceptionCache;
            var tmp;
            if (tmp0_elvis_lhs_4_6 == null) {
              var tmp0_also_0_5_7 = createCauseException($this, cause);
              causeExceptionCache = tmp0_also_0_5_7;
              tmp = tmp0_also_0_5_7;
            } else {
              tmp = tmp0_elvis_lhs_4_6;
            }
            var causeException_3_5 = tmp;
            tmp0__anonymous__1.addExceptionLocked(causeException_3_5);
          }var tmp1_takeIf_0_6_8 = tmp0__anonymous__1._get_rootCause_();
          var tmp_0;
          if (!wasCancelling_2_4) {
            tmp_0 = tmp1_takeIf_0_6_8;
          } else {
            {
              tmp_0 = null;
            }
          }
          var notifyRootCause_3 = tmp_0;
          var tmp1_safe_receiver_9 = notifyRootCause_3;
          if (tmp1_safe_receiver_9 == null)
            null;
          else {
            notifyCancelling($this, tmp0__anonymous__1._list_0, tmp1_safe_receiver_9);
            Unit_getInstance();
          }
          Unit_getInstance();
          return COMPLETING_ALREADY;
        } else {
          if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
            var tmp2_elvis_lhs_11 = causeExceptionCache;
            var tmp_1;
            if (tmp2_elvis_lhs_11 == null) {
              var tmp0_also_0_12 = createCauseException($this, cause);
              causeExceptionCache = tmp0_also_0_12;
              tmp_1 = tmp0_also_0_12;
            } else {
              tmp_1 = tmp2_elvis_lhs_11;
            }
            var causeException_10 = tmp_1;
            if (tmp0__anonymous__1._get_isActive__29()) {
              if (tryMakeCancelling($this, tmp0__anonymous__1, causeException_10))
                return COMPLETING_ALREADY;
            } else {
              var finalState_13 = tryMakeCompleting($this, tmp0__anonymous__1, CompletedExceptionally_init_$Create$(causeException_10, false, 2, null));
              if (finalState_13 === COMPLETING_ALREADY) {
                var tmp1_error_0_14 = '' + 'Cannot happen in ' + tmp0__anonymous__1;
                throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0_14));
              } else if (finalState_13 === COMPLETING_RETRY) {
                tmp$ret$0 = Unit_getInstance();
                break l$ret$1;
              } else
                return finalState_13;
            }
          } else {
            return TOO_LATE_TO_CANCEL;
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  }
  function getOrPromoteCancellingList($this, state) {
    var tmp1_elvis_lhs = state._get_list__13();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_subject = state;
      var tmp_0;
      if (tmp0_subject instanceof Empty) {
        tmp_0 = new NodeList_0();
      } else {
        if (tmp0_subject instanceof JobNode) {
          promoteSingleToNodeList($this, state);
          tmp_0 = null;
        } else {
          {
            var tmp0_error_0 = '' + 'State should have list: ' + state;
            throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
          }
        }
      }
      tmp = tmp_0;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryMakeCancelling($this, state, rootCause) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var cancelling = new Finishing(list, false, rootCause);
    if (!$this.__state_0.atomicfu$compareAndSet(state, cancelling))
      return false;
    notifyCancelling($this, list, rootCause);
    return true;
  }
  function tryMakeCompleting($this, state, proposedUpdate) {
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return COMPLETING_ALREADY;
    else {
    }
    var tmp;
    var tmp_0;
    var tmp_1;
    if (state instanceof Empty) {
      tmp_1 = true;
    } else {
      {
        tmp_1 = state instanceof JobNode;
      }
    }
    if (tmp_1) {
      tmp_0 = !(state instanceof ChildHandleNode);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = !(proposedUpdate instanceof CompletedExceptionally);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
        return proposedUpdate;
      }return COMPLETING_RETRY;
    } else {
    }
    return tryMakeCompletingSlowPath($this, state, proposedUpdate);
  }
  function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return COMPLETING_RETRY;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
    var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
    var notifyRootCause = null;
    if (finishing._get_isCompleting_())
      return COMPLETING_ALREADY;
    finishing._set_isCompleting_(true);
    if (!(finishing === state)) {
      if (!$this.__state_0.atomicfu$compareAndSet(state, finishing))
        return COMPLETING_RETRY;
    }var wasCancelling_2 = finishing._get_isCancelling_();
    var tmp0_safe_receiver_3 = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    if (tmp0_safe_receiver_3 == null)
      null;
    else {
      finishing.addExceptionLocked(tmp0_safe_receiver_3._cause);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp0_takeIf_0_4 = finishing._get_rootCause_();
    var tmp_0;
    if (!wasCancelling_2) {
      tmp_0 = tmp0_takeIf_0_4;
    } else {
      {
        tmp_0 = null;
      }
    }
    notifyRootCause = tmp_0;
    var tmp2_safe_receiver = notifyRootCause;
    if (tmp2_safe_receiver == null)
      null;
    else {
      notifyCancelling($this, list, tmp2_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    var child = firstChild($this, state);
    if (!(child == null) ? tryWaitForChild($this, finishing, child, proposedUpdate) : false)
      return COMPLETING_WAITING_CHILDREN;
    return finalizeFinishingState($this, finishing, proposedUpdate);
  }
  function _get_exceptionOrNull_(_this_, $this) {
    var tmp0_safe_receiver = _this_ instanceof CompletedExceptionally ? _this_ : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
  }
  function firstChild($this, state) {
    var tmp1_elvis_lhs = state instanceof ChildHandleNode ? state : null;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = state._get_list__13();
      tmp = tmp0_safe_receiver == null ? null : nextChild(tmp0_safe_receiver, $this);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryWaitForChild($this, state, child, proposedUpdate) {
    var $this_0 = $this;
    var state_0 = state;
    var child_0 = child;
    var proposedUpdate_0 = proposedUpdate;
    while (true) {
      var $this_1 = $this_0;
      var state_1 = state_0;
      var child_1 = child_0;
      var proposedUpdate_1 = proposedUpdate_0;
      var tmp0__get_asHandler__0 = new ChildCompletion($this_1, state_1, child_1, proposedUpdate_1);
      var handle = child_1._childJob.invokeOnCompletion$default_14(false, false, tmp0__get_asHandler__0, 1, null);
      if (!(handle === NonDisposableHandle_getInstance()))
        return true;
      var tmp0_elvis_lhs = nextChild(child_1, $this_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      $this_0 = $this_1;
      state_0 = state_1;
      child_0 = nextChild_0;
      proposedUpdate_0 = proposedUpdate_1;
      continue;
    }
  }
  function continueCompleting($this, state, lastChild, proposedUpdate) {
    var waitChild = nextChild(lastChild, $this);
    if (!(waitChild == null) ? tryWaitForChild($this, state, waitChild, proposedUpdate) : false)
      return Unit_getInstance();
    var finalState = finalizeFinishingState($this, state, proposedUpdate);
    $this.afterCompletion_13(finalState);
  }
  function nextChild(_this_, $this) {
    var cur = _this_;
    $l$break: while (true) {
      var tmp0__get_isRemoved__0 = cur;
      if (!tmp0__get_isRemoved__0.__removed) {
        break $l$break;
      }var tmp1__get_prevNode__0 = cur;
      cur = tmp1__get_prevNode__0.__prev;
    }
    while (true) {
      var tmp2__get_nextNode__0 = cur;
      cur = tmp2__get_nextNode__0.__next;
      var tmp3__get_isRemoved__0 = cur;
      if (tmp3__get_isRemoved__0.__removed)
        continue;
      else {
      }
      if (cur instanceof ChildHandleNode)
        return cur;
      else {
      }
      if (cur instanceof NodeList_0)
        return null;
      else {
      }
    }
  }
  function stateString($this, state) {
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_isCancelling_() ? 'Cancelling' : state._get_isCompleting_() ? 'Completing' : 'Active';
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
        tmp = state._get_isActive__29() ? 'Active' : 'New';
      } else {
        if (tmp0_subject instanceof CompletedExceptionally) {
          tmp = 'Cancelled';
        } else {
          {
            tmp = 'Completed';
          }
        }
      }
    }
    return tmp;
  }
  function Finishing(list, isCompleting, rootCause) {
    this._list_0 = list;
    this.__isCompleting = atomic_0(isCompleting);
    this.__rootCause = atomic(rootCause);
    this.__exceptionsHolder = atomic(null);
  }
  Finishing.prototype._get_list__13 = function () {
    return this._list_0;
  };
  Finishing.prototype._set_isCompleting_ = function (value) {
    this.__isCompleting._value_5 = value;
  };
  Finishing.prototype._get_isCompleting_ = function () {
    return this.__isCompleting._value_5;
  };
  Finishing.prototype._set_rootCause_ = function (value) {
    this.__rootCause._value_4 = value;
  };
  Finishing.prototype._get_rootCause_ = function () {
    return this.__rootCause._value_4;
  };
  Finishing.prototype._get_isSealed_ = function () {
    return _get_exceptionsHolder_(this) === SEALED;
  };
  Finishing.prototype._get_isCancelling_ = function () {
    return !(this._get_rootCause_() == null);
  };
  Finishing.prototype._get_isActive__29 = function () {
    return this._get_rootCause_() == null;
  };
  Finishing.prototype.sealLocked = function (proposedException) {
    var eh = _get_exceptionsHolder_(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        var tmp0_also_0 = allocateList(this);
        tmp0_also_0.add_39(eh);
        Unit_getInstance();
        tmp = tmp0_also_0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          {
            var tmp1_error_0 = '' + 'State is ' + eh;
            throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
          }
        }
      }
    }
    var list = tmp;
    var rootCause = this._get_rootCause_();
    var tmp0_safe_receiver = rootCause;
    if (tmp0_safe_receiver == null)
      null;
    else {
      list.add_40(0, tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    if (!(proposedException == null) ? !equals_1(proposedException, rootCause) : false) {
      list.add_39(proposedException);
      Unit_getInstance();
    }_set_exceptionsHolder_(this, SEALED);
    return list;
  };
  Finishing.prototype.addExceptionLocked = function (exception) {
    var rootCause = this._get_rootCause_();
    if (rootCause == null) {
      this._set_rootCause_(exception);
      return Unit_getInstance();
    }if (exception === rootCause)
      return Unit_getInstance();
    var eh = _get_exceptionsHolder_(this);
    if (eh == null)
      _set_exceptionsHolder_(this, exception);
    else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_getInstance();
        var tmp0_apply_0 = allocateList(this);
        tmp0_apply_0.add_39(eh);
        Unit_getInstance();
        tmp0_apply_0.add_39(exception);
        Unit_getInstance();
        _set_exceptionsHolder_(this, tmp0_apply_0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).add_39(exception);
          Unit_getInstance();
        } else {
          {
            var tmp1_error_0 = '' + 'State is ' + eh;
            throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
          }
        }
      }
    }
  };
  Finishing.prototype.toString = function () {
    return '' + 'Finishing[cancelling=' + this._get_isCancelling_() + ', completing=' + this._get_isCompleting_() + ', rootCause=' + this._get_rootCause_() + ', exceptions=' + _get_exceptionsHolder_(this) + ', list=' + this._list_0 + ']';
  };
  Finishing.$metadata$ = {
    simpleName: 'Finishing',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildCompletion(parent, state, child, proposedUpdate) {
    JobNode.call(this);
    this._parent = parent;
    this._state_2 = state;
    this._child = child;
    this._proposedUpdate = proposedUpdate;
  }
  ChildCompletion.prototype.invoke_725 = function (cause) {
    continueCompleting(this._parent, this._state_2, this._child, this._proposedUpdate);
  };
  ChildCompletion.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  ChildCompletion.$metadata$ = {
    simpleName: 'ChildCompletion',
    kind: 'class',
    interfaces: []
  };
  function AwaitContinuation(delegate, job) {
    CancellableContinuationImpl.call(this, delegate, 1);
    this._job_0 = job;
  }
  AwaitContinuation.prototype.getContinuationCancellationCause_0 = function (parent) {
    var state = this._job_0._get_state__15();
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state._get_rootCause_();
      if (tmp0_safe_receiver == null)
        null;
      else {
        return tmp0_safe_receiver;
      }
      Unit_getInstance();
    } else {
    }
    if (state instanceof CompletedExceptionally)
      return state._cause;
    else {
    }
    return parent.getCancellationException_14();
  };
  AwaitContinuation.prototype.nameString_15 = function () {
    return 'AwaitContinuation';
  };
  AwaitContinuation.$metadata$ = {
    simpleName: 'AwaitContinuation',
    kind: 'class',
    interfaces: []
  };
  function awaitSuspend($this, $cont) {
    var tmp0__anonymous__1 = $cont;
    var cont_2 = new AwaitContinuation(intercepted(tmp0__anonymous__1), $this);
    var tmp0__get_asHandler__0_3 = new ResumeAwaitOnCompletion(cont_2);
    disposeOnCancellation(cont_2, $this.invokeOnCompletion_31(tmp0__get_asHandler__0_3));
    return cont_2.getResult_1();
  }
  function _no_name_provided__61(this$0, resultContinuation) {
    this._this$0_15 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__61.prototype.invoke_92 = function ($this$sequence, $cont) {
    var tmp = this.create($this$sequence, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__61.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_92(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__61.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            this._state0 = this._this$0_15._get_state__15();
            var tmp_0 = this._state0;
            if (tmp_0 instanceof ChildHandleNode) {
              this._state_1 = 6;
              suspendResult = this._$this$sequence.yield_0(this._state0._childJob, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                var tmp_1 = this._state0;
                if (!(tmp_1 == null) ? isInterface(tmp_1, Incomplete) : false) {
                  this._tmp0_safe_receiver1 = this._state0._get_list__13();
                  if (this._tmp0_safe_receiver1 == null) {
                    this._WHEN_RESULT2 = null;
                    this._state_1 = 5;
                    continue $sm;
                  } else {
                    this._cur_1_23 = this._tmp0_safe_receiver1._get__next__1();
                    this._state_1 = 1;
                    continue $sm;
                  }
                } else {
                  {
                    this._state_1 = 7;
                    continue $sm;
                  }
                }
              }
            }

            break;
          case 1:
            if (!!equals_1(this._cur_1_23, this._tmp0_safe_receiver1)) {
              this._state_1 = 4;
              continue $sm;
            }
            var tmp_2 = this._cur_1_23;
            if (tmp_2 instanceof ChildHandleNode) {
              var tmp_3 = this;
              tmp_3._tmp0__anonymous__2_34 = this._cur_1_23;
              this._state_1 = 2;
              suspendResult = this._$this$sequence.yield_0(this._tmp0__anonymous__2_34._childJob, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 3;
                continue $sm;
              }
            }

            break;
          case 2:
            suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._cur_1_23 = this._cur_1_23.__next;
            this._state_1 = 1;
            continue $sm;
          case 4:
            this._WHEN_RESULT2 = Unit_getInstance();
            this._state_1 = 5;
            continue $sm;
          case 5:
            Unit_getInstance();
            this._state_1 = 7;
            continue $sm;
          case 6:
            suspendResult;
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 8) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__61.prototype.create = function ($this$sequence, completion) {
    var i = new _no_name_provided__61(this._this$0_15, completion);
    i._$this$sequence = $this$sequence;
    return i;
  };
  _no_name_provided__61.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function JobSupport(active) {
    this.__state_0 = atomic(active ? EMPTY_ACTIVE : EMPTY_NEW);
    this.__parentHandle_0 = atomic(null);
  }
  JobSupport.prototype._get_key__37 = function () {
    return Key_getInstance_2();
  };
  JobSupport.prototype._set_parentHandle__13 = function (value) {
    this.__parentHandle_0._value_4 = value;
  };
  JobSupport.prototype._get_parentHandle__13 = function () {
    return this.__parentHandle_0._value_4;
  };
  JobSupport.prototype.initParentJobInternal_13 = function (parent) {
    if (parent == null) {
      this._set_parentHandle__13(NonDisposableHandle_getInstance());
      return Unit_getInstance();
    }parent.start_21();
    Unit_getInstance();
    var handle = parent.attachChild_14(this);
    this._set_parentHandle__13(handle);
    if (this._get_isCompleted__16()) {
      handle.dispose_18();
      this._set_parentHandle__13(NonDisposableHandle_getInstance());
    }};
  JobSupport.prototype._get_state__15 = function () {
    var tmp0_loop_0 = this.__state_0;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_4;
      if (!(tmp1__anonymous__1 instanceof OpDescriptor))
        return tmp1__anonymous__1;
      else {
      }
      tmp1__anonymous__1.perform(this);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_isActive__29 = function () {
    var state = this._get_state__15();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state._get_isActive__29();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  JobSupport.prototype._get_isCompleted__16 = function () {
    var tmp = this._get_state__15();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  };
  JobSupport.prototype._get_isCancelled__3 = function () {
    var state = this._get_state__15();
    var tmp;
    if (state instanceof CompletedExceptionally) {
      tmp = true;
    } else {
      {
        var tmp_0;
        if (state instanceof Finishing) {
          tmp_0 = state._get_isCancelling_();
        } else {
          {
            tmp_0 = false;
          }
        }
        tmp = tmp_0;
      }
    }
    return tmp;
  };
  JobSupport.prototype.start_21 = function () {
    while (true) {
      var tmp0__anonymous__1 = this._get_state__15();
      var tmp0_subject_2 = startInternal(this, tmp0__anonymous__1);
      if (tmp0_subject_2 === 0)
        return false;
      else if (tmp0_subject_2 === 1)
        return true;
    }
    Unit_getInstance();
  };
  JobSupport.prototype.onStartInternal_13 = function () {
  };
  JobSupport.prototype.getCancellationException_14 = function () {
    var state = this._get_state__15();
    var tmp;
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state._get_rootCause_();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.toCancellationException_13(tmp0_safe_receiver, '' + _get_classSimpleName_(this) + ' is cancelling');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var tmp0_error_0 = '' + 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var tmp1_error_0 = '' + 'Job is still new or active: ' + this;
        throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          var tmp_1 = state._cause;
          tmp = this.toCancellationException$default_13(tmp_1, null, 1, null);
        } else {
          {
            tmp = new JobCancellationException('' + _get_classSimpleName_(this) + ' has completed normally', null, this);
          }
        }
      }
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException_13 = function (_this__0, message) {
    var tmp0_elvis_lhs = _this__0 instanceof CancellationException_0 ? _this__0 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_elvis_lhs_1 = message;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_13() : tmp0_elvis_lhs_1, _this__0, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  JobSupport.prototype.toCancellationException$default_13 = function (_this__0, message, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      message = null;
    return this.toCancellationException_13(_this__0, message);
  };
  JobSupport.prototype.invokeOnCompletion_31 = function (handler) {
    return this.invokeOnCompletion_32(false, true, handler);
  };
  JobSupport.prototype.invokeOnCompletion_32 = function (onCancelling, invokeImmediately, handler) {
    var node = makeNode(this, handler, onCancelling);
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__15();
        var tmp0_subject_2 = tmp0__anonymous__1;
        if (tmp0_subject_2 instanceof Empty) {
          if (tmp0__anonymous__1._isActive) {
            if (this.__state_0.atomicfu$compareAndSet(tmp0__anonymous__1, node))
              return node;
          } else
            promoteEmptyToNodeList(this, tmp0__anonymous__1);
        } else {
          if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
            var list_3 = tmp0__anonymous__1._get_list__13();
            if (list_3 == null) {
              promoteSingleToNodeList(this, tmp0__anonymous__1 instanceof JobNode ? tmp0__anonymous__1 : THROW_CCE());
            } else {
              var rootCause_4 = null;
              var handle_5 = NonDisposableHandle_getInstance();
              var tmp;
              if (onCancelling) {
                tmp = tmp0__anonymous__1 instanceof Finishing;
              } else {
                tmp = false;
              }
              if (tmp) {
                rootCause_4 = tmp0__anonymous__1._get_rootCause_();
                var tmp_0;
                if (rootCause_4 == null) {
                  tmp_0 = true;
                } else {
                  var tmp_1;
                  if (handler instanceof ChildHandleNode) {
                    tmp_1 = !tmp0__anonymous__1._get_isCompleting_();
                  } else {
                    {
                      tmp_1 = false;
                    }
                  }
                  tmp_0 = tmp_1;
                }
                if (tmp_0) {
                  if (!addLastAtomic(this, tmp0__anonymous__1, list_3, node)) {
                    tmp$ret$0 = Unit_getInstance();
                    break l$ret$1;
                  }if (rootCause_4 == null)
                    return node;
                  handle_5 = node;
                } else {
                }
              } else {
              }
              if (!(rootCause_4 == null)) {
                if (invokeImmediately)
                  invokeIt(handler, rootCause_4);
                return handle_5;
              } else {
                if (addLastAtomic(this, tmp0__anonymous__1, list_3, node))
                  return node;
              }
            }
          } else {
            {
              if (invokeImmediately) {
                var tmp1_safe_receiver_6 = tmp0__anonymous__1 instanceof CompletedExceptionally ? tmp0__anonymous__1 : null;
                invokeIt(handler, tmp1_safe_receiver_6 == null ? null : tmp1_safe_receiver_6._cause);
              }return NonDisposableHandle_getInstance();
            }
          }
        }
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype.join_14 = function ($cont) {
    if (!joinInternal(this)) {
      checkCompletion($cont._get_context__296());
      return Unit_getInstance();
    }return joinSuspend(this, $cont);
  };
  JobSupport.prototype.removeNode_13 = function (node) {
    while (true) {
      var tmp0__anonymous__1 = this._get_state__15();
      var tmp0_subject_2 = tmp0__anonymous__1;
      if (tmp0_subject_2 instanceof JobNode) {
        if (!(tmp0__anonymous__1 === node))
          return Unit_getInstance();
        if (this.__state_0.atomicfu$compareAndSet(tmp0__anonymous__1, EMPTY_ACTIVE))
          return Unit_getInstance();
      } else {
        if (!(tmp0_subject_2 == null) ? isInterface(tmp0_subject_2, Incomplete) : false) {
          if (!(tmp0__anonymous__1._get_list__13() == null)) {
            node.remove_69();
            Unit_getInstance();
          }return Unit_getInstance();
        } else {
          return Unit_getInstance();
        }
      }
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_onCancelComplete__13 = function () {
    return false;
  };
  JobSupport.prototype.cancel_23 = function (cause) {
    var tmp0_elvis_lhs = cause;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_defaultCancellationException_0 = null;
      var tmp1_defaultCancellationException_0 = null;
      var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_13() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    this.cancelInternal_18(tmp);
  };
  JobSupport.prototype.cancellationExceptionMessage_13 = function () {
    return 'Job was cancelled';
  };
  JobSupport.prototype.cancelInternal_18 = function (cause) {
    this.cancelImpl_13(cause);
    Unit_getInstance();
  };
  JobSupport.prototype.parentCancelled_16 = function (parentJob) {
    this.cancelImpl_13(parentJob);
    Unit_getInstance();
  };
  JobSupport.prototype.childCancelled_16 = function (cause) {
    if (cause instanceof CancellationException_0)
      return true;
    else {
    }
    return this.cancelImpl_13(cause) ? this._get_handlesException__13() : false;
  };
  JobSupport.prototype.cancelCoroutine_2 = function (cause) {
    return this.cancelImpl_13(cause);
  };
  JobSupport.prototype.cancelImpl_13 = function (cause) {
    var finalState = COMPLETING_ALREADY;
    if (this._get_onCancelComplete__13()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === COMPLETING_WAITING_CHILDREN)
        return true;
    }if (finalState === COMPLETING_ALREADY) {
      finalState = makeCancelling(this, cause);
    }var tmp;
    if (finalState === COMPLETING_ALREADY) {
      tmp = true;
    } else if (finalState === COMPLETING_WAITING_CHILDREN) {
      tmp = true;
    } else if (finalState === TOO_LATE_TO_CANCEL) {
      tmp = false;
    } else {
      this.afterCompletion_13(finalState);
      tmp = true;
    }
    return tmp;
  };
  JobSupport.prototype.getChildJobCancellationCause_14 = function () {
    var state = this._get_state__15();
    var tmp0_subject = state;
    var tmp;
    if (tmp0_subject instanceof Finishing) {
      tmp = state._get_rootCause_();
    } else {
      if (tmp0_subject instanceof CompletedExceptionally) {
        tmp = state._cause;
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Incomplete) : false) {
          var tmp0_error_0 = '' + 'Cannot be cancelling child in this state: ' + state;
          throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
        } else {
          {
            tmp = null;
          }
        }
      }
    }
    var rootCause = tmp;
    var tmp1_elvis_lhs = rootCause instanceof CancellationException_0 ? rootCause : null;
    return tmp1_elvis_lhs == null ? new JobCancellationException('' + 'Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
  };
  JobSupport.prototype.makeCompleting_0 = function (proposedUpdate) {
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__15();
        var finalState_2 = tryMakeCompleting(this, tmp0__anonymous__1, proposedUpdate);
        if (finalState_2 === COMPLETING_ALREADY)
          return false;
        else if (finalState_2 === COMPLETING_WAITING_CHILDREN)
          return true;
        else if (finalState_2 === COMPLETING_RETRY) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          this.afterCompletion_13(finalState_2);
          return true;
        }
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype.makeCompletingOnce_10 = function (proposedUpdate) {
    while (true) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0__anonymous__1 = this._get_state__15();
        var finalState_2 = tryMakeCompleting(this, tmp0__anonymous__1, proposedUpdate);
        if (finalState_2 === COMPLETING_ALREADY)
          throw IllegalStateException_init_$Create$_1('' + 'Job ' + this + ' is already complete or completing, ' + ('' + 'but is being completed with ' + proposedUpdate), _get_exceptionOrNull_(proposedUpdate, this));
        else if (finalState_2 === COMPLETING_RETRY) {
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else
          return finalState_2;
      }
       while (false);
    }
    Unit_getInstance();
  };
  JobSupport.prototype._get_children__24 = function () {
    return sequence(_no_name_provided_$factory_43(this, null));
  };
  JobSupport.prototype.attachChild_14 = function (child) {
    var tmp0__get_asHandler__0 = new ChildHandleNode(child);
    var tmp = this.invokeOnCompletion$default_14(true, false, tmp0__get_asHandler__0, 2, null);
    return isInterface(tmp, ChildHandle) ? tmp : THROW_CCE();
  };
  JobSupport.prototype.handleOnCompletionException_13 = function (exception) {
    throw exception;
  };
  JobSupport.prototype.onCancelling_13 = function (cause) {
  };
  JobSupport.prototype._get_isScopedCoroutine__13 = function () {
    return false;
  };
  JobSupport.prototype._get_handlesException__13 = function () {
    return true;
  };
  JobSupport.prototype.handleJobException_13 = function (exception) {
    return false;
  };
  JobSupport.prototype.onCompletionInternal_13 = function (state) {
  };
  JobSupport.prototype.afterCompletion_13 = function (state) {
  };
  JobSupport.prototype.toString = function () {
    return '' + this.toDebugString_13() + '@' + _get_hexAddress_(this);
  };
  JobSupport.prototype.toDebugString_13 = function () {
    return '' + this.nameString_15() + '{' + stateString(this, this._get_state__15()) + '}';
  };
  JobSupport.prototype.nameString_15 = function () {
    return _get_classSimpleName_(this);
  };
  JobSupport.prototype.awaitInternal_2 = function ($cont) {
    $l$break: while (true) {
      var state = this._get_state__15();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        if (state instanceof CompletedExceptionally) {
          var tmp0_recoverAndThrow_0 = state._cause;
          throw tmp0_recoverAndThrow_0;
        } else {
        }
        return unboxState(state);
      } else {
      }
      if (startInternal(this, state) >= 0)
        break $l$break;
    }
    return awaitSuspend(this, $cont);
  };
  JobSupport.$metadata$ = {
    simpleName: 'JobSupport',
    kind: 'class',
    interfaces: [Job, ChildJob, ParentJob, SelectClause0]
  };
  function boxIncomplete(_this_) {
    var tmp;
    if (!(_this_ == null) ? isInterface(_this_, Incomplete) : false) {
      tmp = new IncompleteStateBox(_this_);
    } else {
      {
        tmp = _this_;
      }
    }
    return tmp;
  }
  function JobCancellingNode() {
    JobNode.call(this);
  }
  JobCancellingNode.$metadata$ = {
    simpleName: 'JobCancellingNode',
    kind: 'class',
    interfaces: []
  };
  function InactiveNodeList(list) {
    this._list_1 = list;
  }
  InactiveNodeList.prototype._get_list__13 = function () {
    return this._list_1;
  };
  InactiveNodeList.prototype._get_isActive__29 = function () {
    return false;
  };
  InactiveNodeList.prototype.toString = function () {
    return DEBUG ? this._list_1.getString('New') : anyToString(this);
  };
  InactiveNodeList.$metadata$ = {
    simpleName: 'InactiveNodeList',
    kind: 'class',
    interfaces: [Incomplete]
  };
  function ChildHandleNode(childJob) {
    JobCancellingNode.call(this);
    this._childJob = childJob;
  }
  ChildHandleNode.prototype.invoke_725 = function (cause) {
    return this._childJob.parentCancelled_16(this._get_job__8());
  };
  ChildHandleNode.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  ChildHandleNode.prototype.childCancelled_16 = function (cause) {
    return this._get_job__8().childCancelled_16(cause);
  };
  ChildHandleNode.$metadata$ = {
    simpleName: 'ChildHandleNode',
    kind: 'class',
    interfaces: [ChildHandle]
  };
  function InvokeOnCancelling(handler) {
    JobCancellingNode.call(this);
    this._handler_0 = handler;
    this.__invoked = atomic_1(0);
  }
  InvokeOnCancelling.prototype.invoke_725 = function (cause) {
    if (this.__invoked.atomicfu$compareAndSet(0, 1))
      this._handler_0(cause);
  };
  InvokeOnCancelling.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  InvokeOnCancelling.$metadata$ = {
    simpleName: 'InvokeOnCancelling',
    kind: 'class',
    interfaces: []
  };
  function InvokeOnCompletion(handler) {
    JobNode.call(this);
    this._handler_1 = handler;
  }
  InvokeOnCompletion.prototype.invoke_725 = function (cause) {
    return this._handler_1(cause);
  };
  InvokeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  InvokeOnCompletion.$metadata$ = {
    simpleName: 'InvokeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function ResumeOnCompletion(continuation) {
    JobNode.call(this);
    this._continuation_1 = continuation;
  }
  ResumeOnCompletion.prototype.invoke_725 = function (cause) {
    var tmp0_resume_0 = this._continuation_1;
    var tmp1_resume_0 = Unit_getInstance();
    var tmp0_success_0_1 = Companion_getInstance_2();
    return tmp0_resume_0.resumeWith_196(_Result___init__impl_(Unit_getInstance()));
  };
  ResumeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  ResumeOnCompletion.$metadata$ = {
    simpleName: 'ResumeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function unboxState(_this_) {
    var tmp0_safe_receiver = _this_ instanceof IncompleteStateBox ? _this_ : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._state_3;
    return tmp1_elvis_lhs == null ? _this_ : tmp1_elvis_lhs;
  }
  function ResumeAwaitOnCompletion(continuation) {
    JobNode.call(this);
    this._continuation_2 = continuation;
  }
  ResumeAwaitOnCompletion.prototype.invoke_725 = function (cause) {
    var state = this._get_job__8()._get_state__15();
    if (state instanceof CompletedExceptionally) {
      var tmp0_resumeWithException_0 = this._continuation_2;
      var tmp1_resumeWithException_0 = state._cause;
      var tmp0_failure_0_1 = Companion_getInstance_2();
      tmp0_resumeWithException_0.resumeWith_196(_Result___init__impl_(createFailure(tmp1_resumeWithException_0)));
    } else {
      {
        var tmp2_resume_0 = this._continuation_2;
        var tmp = unboxState(state);
        var tmp3_resume_0 = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
        var tmp0_success_0_1 = Companion_getInstance_2();
        tmp2_resume_0.resumeWith_196(_Result___init__impl_(tmp3_resume_0));
      }
    }
  };
  ResumeAwaitOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  ResumeAwaitOnCompletion.$metadata$ = {
    simpleName: 'ResumeAwaitOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function IncompleteStateBox(state) {
    this._state_3 = state;
  }
  IncompleteStateBox.$metadata$ = {
    simpleName: 'IncompleteStateBox',
    kind: 'class',
    interfaces: []
  };
  function ChildContinuation(child) {
    JobCancellingNode.call(this);
    this._child_0 = child;
  }
  ChildContinuation.prototype.invoke_725 = function (cause) {
    this._child_0.parentCancelled_8(this._child_0.getContinuationCancellationCause_0(this._get_job__8()));
  };
  ChildContinuation.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  ChildContinuation.$metadata$ = {
    simpleName: 'ChildContinuation',
    kind: 'class',
    interfaces: []
  };
  function handlesException($this) {
    var tmp = $this._get_parentHandle__13();
    var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_job__8();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parentJob = tmp_0;
    while (true) {
      if (parentJob._get_handlesException__13())
        return true;
      var tmp_1 = parentJob._get_parentHandle__13();
      var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._get_job__8();
      var tmp_2;
      if (tmp3_elvis_lhs == null) {
        return false;
      } else {
        tmp_2 = tmp3_elvis_lhs;
      }
      parentJob = tmp_2;
    }
  }
  function JobImpl(parent) {
    JobSupport.call(this, true);
    this.initParentJobInternal_13(parent);
    this._handlesException = handlesException(this);
  }
  JobImpl.prototype._get_onCancelComplete__13 = function () {
    return true;
  };
  JobImpl.prototype._get_handlesException__13 = function () {
    return this._handlesException;
  };
  JobImpl.$metadata$ = {
    simpleName: 'JobImpl',
    kind: 'class',
    interfaces: [CompletableJob]
  };
  function DisposeOnCompletion(handle) {
    JobNode.call(this);
    this._handle_0 = handle;
  }
  DisposeOnCompletion.prototype.invoke_725 = function (cause) {
    return this._handle_0.dispose_18();
  };
  DisposeOnCompletion.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  DisposeOnCompletion.$metadata$ = {
    simpleName: 'DisposeOnCompletion',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_43(this$0, resultContinuation) {
    var i = new _no_name_provided__61(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_92(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function MainCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
  }
  MainCoroutineDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_0();
    return tmp0_elvis_lhs == null ? '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) : tmp0_elvis_lhs;
  };
  MainCoroutineDispatcher.prototype.toStringInternalImpl_0 = function () {
    var main_0 = Dispatchers_getInstance()._Main;
    if (this === main_0)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main_0._get_immediate__0();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        tmp_0 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  };
  MainCoroutineDispatcher.$metadata$ = {
    simpleName: 'MainCoroutineDispatcher',
    kind: 'class',
    interfaces: []
  };
  function SupervisorJob(parent) {
    return new SupervisorJobImpl(parent);
  }
  function SupervisorJob$default(parent, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    return SupervisorJob(parent);
  }
  function SupervisorJobImpl(parent) {
    JobImpl.call(this, parent);
  }
  SupervisorJobImpl.prototype.childCancelled_16 = function (cause) {
    return false;
  };
  SupervisorJobImpl.$metadata$ = {
    simpleName: 'SupervisorJobImpl',
    kind: 'class',
    interfaces: []
  };
  function TimeoutCancellationException_init_$Init$(message, $this) {
    TimeoutCancellationException.call($this, message, null);
    return $this;
  }
  function TimeoutCancellationException_init_$Create$(message) {
    var tmp = TimeoutCancellationException_init_$Init$(message, Object.create(TimeoutCancellationException.prototype));
    captureStack(tmp, TimeoutCancellationException_init_$Create$);
    return tmp;
  }
  function TimeoutCancellationException(message, coroutine) {
    CancellationException_init_$Init$(message, this);
    this._coroutine = coroutine;
    captureStack(this, TimeoutCancellationException);
  }
  TimeoutCancellationException.$metadata$ = {
    simpleName: 'TimeoutCancellationException',
    kind: 'class',
    interfaces: [CopyableThrowable]
  };
  function withTimeout(timeMillis, block, $cont) {
    if (timeMillis.compareTo_137(new Long(0, 0)) <= 0)
      throw TimeoutCancellationException_init_$Create$('Timed out immediately');
    var tmp0__anonymous__1 = $cont;
    return setupTimeout(new TimeoutCoroutine(timeMillis, tmp0__anonymous__1), block);
  }
  function setupTimeout(coroutine, block) {
    var cont = coroutine._get_uCont__2();
    var context = cont._get_context__296();
    disposeOnCompletion(coroutine, _get_delay_(context).invokeOnTimeout_5(coroutine._time_0, coroutine, coroutine._get_context__296()));
    Unit_getInstance();
    return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
  }
  function TimeoutCoroutine(time, uCont) {
    ScopeCoroutine.call(this, uCont._get_context__296(), uCont);
    this._time_0 = time;
  }
  TimeoutCoroutine.prototype.run_5 = function () {
    this.cancelCoroutine_2(TimeoutCancellationException_0(this._time_0, this));
    Unit_getInstance();
  };
  TimeoutCoroutine.prototype.nameString_15 = function () {
    return '' + ScopeCoroutine.prototype.nameString_15.call(this) + '(timeMillis=' + this._time_0 + ')';
  };
  TimeoutCoroutine.$metadata$ = {
    simpleName: 'TimeoutCoroutine',
    kind: 'class',
    interfaces: [Runnable]
  };
  function TimeoutCancellationException_0(time, coroutine) {
    return new TimeoutCancellationException('' + 'Timed out waiting for ' + time + ' ms', coroutine);
  }
  function Unconfined() {
    Unconfined_instance = this;
    CoroutineDispatcher.call(this);
  }
  Unconfined.prototype.isDispatchNeeded_9 = function (context) {
    return false;
  };
  Unconfined.prototype.dispatch_12 = function (context, block) {
    var yieldContext = context.get_113(Key_getInstance_3());
    if (!(yieldContext == null)) {
      yieldContext.dispatcherWasUnconfined__error = true;
      return Unit_getInstance();
    }throw UnsupportedOperationException_init_$Create$_0('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  };
  Unconfined.prototype.toString = function () {
    return 'Dispatchers.Unconfined';
  };
  Unconfined.$metadata$ = {
    simpleName: 'Unconfined',
    kind: 'object',
    interfaces: []
  };
  var Unconfined_instance;
  function Unconfined_getInstance() {
    if (Unconfined_instance == null)
      new Unconfined();
    return Unconfined_instance;
  }
  function Key_4() {
    Key_instance_3 = this;
  }
  Key_4.$metadata$ = {
    simpleName: 'Key',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Key_instance_3;
  function Key_getInstance_3() {
    if (Key_instance_3 == null)
      new Key_4();
    return Key_instance_3;
  }
  function checkCompletion(_this_) {
    var job = _this_.get_113(Key_getInstance_2());
    if (!(job == null) ? !job._get_isActive__29() : false)
      throw job.getCancellationException_14();
  }
  var EMPTY;
  var OFFER_SUCCESS;
  var OFFER_FAILED;
  var POLL_FAILED;
  var ENQUEUE_FAILED;
  var HANDLER_INVOKED;
  function receiveSuspend($this, receiveMode, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = getOrCreateCancellableContinuation(intercepted(tmp0__anonymous__1_1));
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if ($this._get_onUndeliveredElement__4() == null) {
        tmp = new ReceiveElement(isInterface(cancellable_2_2, CancellableContinuation) ? cancellable_2_2 : THROW_CCE(), receiveMode);
      } else {
        tmp = new ReceiveElementWithUndeliveredHandler(isInterface(cancellable_2_2, CancellableContinuation) ? cancellable_2_2 : THROW_CCE(), receiveMode, $this._get_onUndeliveredElement__4());
      }
      var receive_4 = tmp;
      while (true) {
        if (enqueueReceive($this, receive_4)) {
          removeReceiveOnCancel($this, cancellable_2_2, receive_4);
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }var result_5 = $this.pollInternal_3();
        if (result_5 instanceof Closed) {
          receive_4.resumeReceiveClosed_1(result_5);
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
        }
        if (!(result_5 === POLL_FAILED)) {
          var tmp_0 = cancellable_2_2;
          var tmp_1 = receive_4.resumeValue_0((result_5 == null ? true : isObject(result_5)) ? result_5 : THROW_CCE());
          tmp_0.resume_2(tmp_1, receive_4.resumeOnCancellationFun_1((result_5 == null ? true : isObject(result_5)) ? result_5 : THROW_CCE()));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        }}
    }
     while (false);
    return cancellable_2_2.getResult_1();
  }
  function enqueueReceive($this, receive) {
    var tmp0_also_0 = $this.enqueueReceiveInternal_3(receive);
    if (tmp0_also_0)
      $this.onReceiveEnqueued_3();
    return tmp0_also_0;
  }
  function removeReceiveOnCancel($this, cont, receive) {
    var tmp0__get_asHandler__0 = new RemoveReceiveOnCancel($this, receive);
    return cont.invokeOnCancellation_1(tmp0__get_asHandler__0);
  }
  function RemoveReceiveOnCancel($outer, receive) {
    this._$this_5 = $outer;
    BeforeResumeCancelHandler.call(this);
    this._receive = receive;
  }
  RemoveReceiveOnCancel.prototype.invoke_725 = function (cause) {
    if (this._receive.remove_69())
      this._$this_5.onReceiveDequeued_3();
  };
  RemoveReceiveOnCancel.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  RemoveReceiveOnCancel.prototype.toString = function () {
    return '' + 'RemoveReceiveOnCancel[' + this._receive + ']';
  };
  RemoveReceiveOnCancel.$metadata$ = {
    simpleName: 'RemoveReceiveOnCancel',
    kind: 'class',
    interfaces: []
  };
  function ReceiveElement(cont, receiveMode) {
    Receive.call(this);
    this._cont = cont;
    this._receiveMode = receiveMode;
  }
  ReceiveElement.prototype._get_cont__2 = function () {
    return this._cont;
  };
  ReceiveElement.prototype.resumeValue_0 = function (value) {
    var tmp0_subject = this._receiveMode;
    var tmp;
    if (tmp0_subject === 2) {
      var tmp0_value_0 = Companion_getInstance_40();
      tmp = new ValueOrClosed(_ValueOrClosed___init__impl_(value));
    } else {
      tmp = value;
    }
    return tmp;
  };
  ReceiveElement.prototype.tryResumeReceive_3 = function (value, otherOp) {
    var tmp = this.resumeValue_0(value);
    var tmp0_safe_receiver = otherOp;
    var tmp1_elvis_lhs = this._cont.tryResume_4(tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.desc__error, this.resumeOnCancellationFun_1(value));
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var token = tmp_0;
    var tmp2_safe_receiver = otherOp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.finishPrepare__error();
      Unit_getInstance();
    }
    Unit_getInstance();
    return RESUME_TOKEN;
  };
  ReceiveElement.prototype.completeResumeReceive_3 = function (value) {
    return this._cont.completeResume_1(RESUME_TOKEN);
  };
  ReceiveElement.prototype.resumeReceiveClosed_1 = function (closed) {
    if (this._receiveMode === 1 ? closed._closeCause == null : false) {
      var tmp0_resume_0 = this._cont;
      var tmp1_resume_0 = null;
      var tmp0_success_0_1 = Companion_getInstance_2();
      tmp0_resume_0.resumeWith_196(_Result___init__impl_(tmp1_resume_0));
    } else if (this._receiveMode === 2) {
      var tmp4_resume_0 = this._cont;
      var tmp2_closed_0 = Companion_getInstance_40();
      var tmp3_closed_0 = closed._closeCause;
      var tmp5_resume_0 = _ValueOrClosed___init__impl_(new Closed_0(tmp3_closed_0));
      var tmp0_success_0_1_0 = Companion_getInstance_2();
      tmp4_resume_0.resumeWith_196(_Result___init__impl_(new ValueOrClosed(tmp5_resume_0)));
    } else {
      var tmp6_resumeWithException_0 = this._cont;
      var tmp7_resumeWithException_0 = closed._get_receiveException_();
      var tmp0_failure_0_1 = Companion_getInstance_2();
      tmp6_resumeWithException_0.resumeWith_196(_Result___init__impl_(createFailure(tmp7_resumeWithException_0)));
    }
  };
  ReceiveElement.prototype.toString = function () {
    return '' + 'ReceiveElement@' + _get_hexAddress_(this) + '[receiveMode=' + this._receiveMode + ']';
  };
  ReceiveElement.$metadata$ = {
    simpleName: 'ReceiveElement',
    kind: 'class',
    interfaces: []
  };
  function ReceiveElementWithUndeliveredHandler(cont, receiveMode, onUndeliveredElement) {
    ReceiveElement.call(this, cont, receiveMode);
    this._onUndeliveredElement = onUndeliveredElement;
  }
  ReceiveElementWithUndeliveredHandler.prototype.resumeOnCancellationFun_1 = function (value) {
    return bindCancellationFun(this._onUndeliveredElement, value, this._get_cont__2()._get_context__296());
  };
  ReceiveElementWithUndeliveredHandler.$metadata$ = {
    simpleName: 'ReceiveElementWithUndeliveredHandler',
    kind: 'class',
    interfaces: []
  };
  function AbstractChannel(onUndeliveredElement) {
    AbstractSendChannel.call(this, onUndeliveredElement);
  }
  AbstractChannel.prototype.pollInternal_3 = function () {
    while (true) {
      var tmp0_elvis_lhs = this.takeFirstSendOrPeekClosed_4();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return POLL_FAILED;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var send = tmp;
      var token = send.tryResumeSend_3(null);
      if (!(token == null)) {
        send.completeResumeSend_3();
        return send._get_pollResult__3();
      }send.undeliveredElement_3();
    }
  };
  AbstractChannel.prototype._get_isClosedForReceive__3 = function () {
    return !(this._get_closedForReceive__4() == null) ? this._get_isBufferEmpty__3() : false;
  };
  AbstractChannel.prototype.enqueueReceiveInternal_3 = function (receive) {
    var tmp;
    if (this._get_isBufferAlwaysEmpty__3()) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_addLastIfPrev_0 = this._get_queue__4();
        var tmp1__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
        if (!!(tmp1__anonymous__1 instanceof Send)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
        tmp0_addLastIfPrev_0.addLast_26(receive);
        tmp$ret$0 = true;
      }
       while (false);
      tmp = tmp$ret$0;
    } else {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp2_addLastIfPrevAndIf_0 = this._get_queue__4();
        var tmp3__anonymous__1 = tmp2_addLastIfPrevAndIf_0.__prev;
        if (!!(tmp3__anonymous__1 instanceof Send)) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        if (!this._get_isBufferEmpty__3()) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        tmp2_addLastIfPrevAndIf_0.addLast_26(receive);
        tmp$ret$2 = true;
      }
       while (false);
      tmp = tmp$ret$2;
    }
    return tmp;
  };
  AbstractChannel.prototype.receiveOrClosed_7 = function ($cont) {
    var result = this.pollInternal_3();
    if (!(result === POLL_FAILED)) {
      var tmp;
      if (result instanceof Closed) {
        var tmp0_closed_0 = Companion_getInstance_40();
        var tmp1_closed_0 = result._closeCause;
        tmp = _ValueOrClosed___init__impl_(new Closed_0(tmp1_closed_0));
      } else {
        {
          var tmp2_value_0 = Companion_getInstance_40();
          var tmp3_value_0 = (result == null ? true : isObject(result)) ? result : THROW_CCE();
          tmp = _ValueOrClosed___init__impl_(tmp3_value_0);
        }
      }
      return tmp;
    }var tmp_0 = receiveSuspend(this, 2, $cont);
    if (tmp_0 === _get_COROUTINE_SUSPENDED_())
      return tmp_0;
    return tmp_0._holder;
  };
  AbstractChannel.prototype.cancel_23 = function (cause) {
    if (this._get_isClosedForReceive__3())
      return Unit_getInstance();
    var tmp0_elvis_lhs = cause;
    this.cancelInternal_16(tmp0_elvis_lhs == null ? CancellationException_init_$Create$('' + _get_classSimpleName_(this) + ' was cancelled') : tmp0_elvis_lhs);
    Unit_getInstance();
  };
  AbstractChannel.prototype.cancelInternal_16 = function (cause) {
    var tmp0_also_0 = this.close_9(cause);
    this.onCancelIdempotent_3(tmp0_also_0);
    return tmp0_also_0;
  };
  AbstractChannel.prototype.onCancelIdempotent_3 = function (wasClosed) {
    var tmp0_elvis_lhs = this._get_closedForSend__4();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error_0 = 'Cannot happen';
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var closed = tmp;
    var list = _InlineList___init__impl__0(null, 1, null);
    $l$break: while (true) {
      var previous = closed.__prev;
      if (previous instanceof LinkedListHead) {
        break $l$break;
      } else {
      }
      if (!previous.remove_69()) {
        previous.helpRemove_20();
        continue $l$break;
      }var tmp_0 = list;
      list = InlineList__plus_impl(tmp_0, previous instanceof Send ? previous : THROW_CCE());
    }
    this.onCancelIdempotentList_3(list, closed);
  };
  AbstractChannel.prototype.onCancelIdempotentList_3 = function (list, closed) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_subject_1 = _get_holder__0(list);
      if (tmp0_subject_1 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        if (!(tmp0_subject_1 instanceof ArrayList)) {
          var tmp = _get_holder__0(list);
          var tmp0__anonymous__5 = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
          tmp0__anonymous__5.resumeSendClosed_3(closed);
        } else {
          {
            var tmp_0 = _get_holder__0(list);
            var list_2 = tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE();
            var inductionVariable = list_2._get_size__60() - 1 | 0;
            if (0 <= inductionVariable)
              do {
                var i_4 = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                var tmp1__anonymous__5 = list_2.get_137(i_4);
                tmp1__anonymous__5.resumeSendClosed_3(closed);
              }
               while (0 <= inductionVariable);
          }
        }
      }
    }
     while (false);
  };
  AbstractChannel.prototype.takeFirstReceiveOrPeekClosed_4 = function () {
    var tmp0_also_0 = AbstractSendChannel.prototype.takeFirstReceiveOrPeekClosed_4.call(this);
    var tmp;
    if (!(tmp0_also_0 == null)) {
      tmp = !(tmp0_also_0 instanceof Closed);
    } else {
      tmp = false;
    }
    if (tmp)
      this.onReceiveDequeued_3();
    else {
    }
    return tmp0_also_0;
  };
  AbstractChannel.prototype.onReceiveEnqueued_3 = function () {
  };
  AbstractChannel.prototype.onReceiveDequeued_3 = function () {
  };
  AbstractChannel.$metadata$ = {
    simpleName: 'AbstractChannel',
    kind: 'class',
    interfaces: [Channel]
  };
  function sendSuspend($this, element, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = getOrCreateCancellableContinuation(intercepted(tmp0__anonymous__1_1));
    var tmp$ret$0;
    l$ret$1: do {
      loop: while (true) {
        if ($this._get_isFullImpl__4()) {
          var send_4 = $this._onUndeliveredElement_0 == null ? new SendElement(element, cancellable_2_2) : new SendElementWithUndeliveredHandler(element, cancellable_2_2, $this._onUndeliveredElement_0);
          var enqueueResult_5 = $this.enqueueSend_4(send_4);
          if (enqueueResult_5 == null) {
            removeOnCancellation(cancellable_2_2, send_4);
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          } else {
            if (enqueueResult_5 instanceof Closed) {
              helpCloseAndResumeWithSendException(cancellable_2_2, $this, element, enqueueResult_5);
              tmp$ret$0 = Unit_getInstance();
              break l$ret$1;
            } else {
              if (enqueueResult_5 === ENQUEUE_FAILED) {
              } else {
                if (enqueueResult_5 instanceof Receive) {
                } else {
                  {
                    var tmp0_error_0_6 = '' + 'enqueueSend returned ' + enqueueResult_5;
                    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_6));
                  }
                }
              }
            }
          }
        }var offerResult_7 = $this.offerInternal_4(element);
        if (offerResult_7 === OFFER_SUCCESS) {
          var tmp1_resume_0_8 = Unit_getInstance();
          var tmp0_success_0_1_9 = Companion_getInstance_2();
          cancellable_2_2.resumeWith_196(_Result___init__impl_(Unit_getInstance()));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          if (offerResult_7 === OFFER_FAILED)
            continue loop;
          else {
            if (offerResult_7 instanceof Closed) {
              helpCloseAndResumeWithSendException(cancellable_2_2, $this, element, offerResult_7);
              tmp$ret$0 = Unit_getInstance();
              break l$ret$1;
            } else {
              {
                var tmp2_error_0_10 = '' + 'offerInternal returned ' + offerResult_7;
                throw IllegalStateException_init_$Create$_0(toString_1(tmp2_error_0_10));
              }
            }
          }
        }
      }
    }
     while (false);
    return cancellable_2_2.getResult_1();
  }
  function helpCloseAndResumeWithSendException(_this_, $this, element, closed) {
    helpClose($this, closed);
    var sendException = closed._get_sendException_();
    var tmp0_safe_receiver = $this._onUndeliveredElement_0;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = callUndeliveredElementCatchingException$default(tmp0_safe_receiver, element, null, 2, null);
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      addSuppressed(tmp1_safe_receiver, sendException);
      var tmp0_failure_0_1_2 = Companion_getInstance_2();
      _this_.resumeWith_196(_Result___init__impl_(createFailure(tmp1_safe_receiver)));
      return Unit_getInstance();
    }
    Unit_getInstance();
    var tmp0_failure_0_1 = Companion_getInstance_2();
    _this_.resumeWith_196(_Result___init__impl_(createFailure(sendException)));
  }
  function invokeOnCloseHandler($this, cause) {
    var handler = $this._onCloseHandler._value_4;
    if ((!(handler === null) ? !(handler === HANDLER_INVOKED) : false) ? $this._onCloseHandler.atomicfu$compareAndSet(handler, HANDLER_INVOKED) : false) {
      ((!(handler == null) ? typeof handler === 'function' : false) ? handler : THROW_CCE())(cause);
    }}
  function helpClose($this, closed) {
    var closedList = _InlineList___init__impl__0(null, 1, null);
    $l$break: while (true) {
      var tmp = closed.__prev;
      var tmp0_elvis_lhs = tmp instanceof Receive ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$break;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var previous = tmp_0;
      if (!previous.remove_69()) {
        previous.helpRemove_20();
        continue $l$break;
      }closedList = InlineList__plus_impl(closedList, previous);
    }
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_forEachReversed_0 = closedList;
      var tmp0_subject_1 = _get_holder__0(tmp0_forEachReversed_0);
      if (tmp0_subject_1 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        if (!(tmp0_subject_1 instanceof ArrayList)) {
          var tmp_1 = _get_holder__0(tmp0_forEachReversed_0);
          var tmp1__anonymous__5 = (tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE();
          tmp1__anonymous__5.resumeReceiveClosed_1(closed);
        } else {
          {
            var tmp_2 = _get_holder__0(tmp0_forEachReversed_0);
            var list_2 = tmp_2 instanceof ArrayList ? tmp_2 : THROW_CCE();
            var inductionVariable = list_2._get_size__60() - 1 | 0;
            if (0 <= inductionVariable)
              do {
                var i_4 = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                var tmp2__anonymous__5 = list_2.get_137(i_4);
                tmp2__anonymous__5.resumeReceiveClosed_1(closed);
              }
               while (0 <= inductionVariable);
          }
        }
      }
    }
     while (false);
    $this.onClosedIdempotent_4(closed);
  }
  function _get_queueDebugStateString_($this) {
    var tmp0__get_nextNode__0 = $this._queue;
    var head = tmp0__get_nextNode__0.__next;
    if (head === $this._queue)
      return 'EmptyQueue';
    var tmp0_subject = head;
    var tmp;
    if (tmp0_subject instanceof Closed) {
      tmp = toString_1(head);
    } else {
      if (tmp0_subject instanceof Receive) {
        tmp = 'ReceiveQueued';
      } else {
        if (tmp0_subject instanceof Send) {
          tmp = 'SendQueued';
        } else {
          {
            tmp = '' + 'UNEXPECTED:' + head;
          }
        }
      }
    }
    var result = tmp;
    var tmp1__get_prevNode__0 = $this._queue;
    var tail = tmp1__get_prevNode__0.__prev;
    if (!(tail === head)) {
      result = result + ('' + ',queueSize=' + countQueueSize($this));
      if (tail instanceof Closed)
        result = result + ('' + ',closedForSend=' + tail);
      else {
      }
    }return result;
  }
  function countQueueSize($this) {
    var size_1 = 0;
    var tmp0_forEach_0 = $this._queue;
    var cur_1 = tmp0_forEach_0._get__next__1();
    while (!equals_1(cur_1, tmp0_forEach_0)) {
      if (cur_1 instanceof LinkedListNode) {
        var tmp1__anonymous__2 = cur_1;
        var tmp0_3 = size_1;
        size_1 = tmp0_3 + 1 | 0;
        Unit_getInstance();
      } else {
      }
      cur_1 = cur_1.__next;
    }
    return size_1;
  }
  function SendBuffered(element) {
    Send.call(this);
    this._element_0 = element;
  }
  SendBuffered.prototype._get_pollResult__3 = function () {
    return this._element_0;
  };
  SendBuffered.prototype.tryResumeSend_3 = function (otherOp) {
    var tmp0_also_0 = RESUME_TOKEN;
    var tmp0_safe_receiver_2 = otherOp;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.finishPrepare__error();
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_also_0;
  };
  SendBuffered.prototype.completeResumeSend_3 = function () {
  };
  SendBuffered.prototype.resumeSendClosed_3 = function (closed) {
  };
  SendBuffered.prototype.toString = function () {
    return '' + 'SendBuffered@' + _get_hexAddress_(this) + '(' + this._element_0 + ')';
  };
  SendBuffered.$metadata$ = {
    simpleName: 'SendBuffered',
    kind: 'class',
    interfaces: []
  };
  function AbstractSendChannel(onUndeliveredElement) {
    this._onUndeliveredElement_0 = onUndeliveredElement;
    this._queue = new LinkedListHead();
    this._onCloseHandler = atomic(null);
  }
  AbstractSendChannel.prototype._get_onUndeliveredElement__4 = function () {
    return this._onUndeliveredElement_0;
  };
  AbstractSendChannel.prototype._get_queue__4 = function () {
    return this._queue;
  };
  AbstractSendChannel.prototype.offerInternal_4 = function (element) {
    while (true) {
      var tmp0_elvis_lhs = this.takeFirstReceiveOrPeekClosed_4();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return OFFER_FAILED;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var receive = tmp;
      var token = receive.tryResumeReceive_3(element, null);
      if (!(token == null)) {
        receive.completeResumeReceive_3(element);
        return receive._get_offerResult__3();
      }}
  };
  AbstractSendChannel.prototype._get_closedForSend__4 = function () {
    var tmp0__get_prevNode__0 = this._queue;
    var tmp = tmp0__get_prevNode__0.__prev;
    var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      helpClose(this, tmp0_safe_receiver);
      tmp_0 = tmp0_safe_receiver;
    }
    return tmp_0;
  };
  AbstractSendChannel.prototype._get_closedForReceive__4 = function () {
    var tmp0__get_nextNode__0 = this._queue;
    var tmp = tmp0__get_nextNode__0.__next;
    var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      helpClose(this, tmp0_safe_receiver);
      tmp_0 = tmp0_safe_receiver;
    }
    return tmp_0;
  };
  AbstractSendChannel.prototype.takeFirstSendOrPeekClosed_4 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_removeFirstIfIsInstanceOfOrPeekIf_0 = this._queue;
      var next_1 = tmp1_removeFirstIfIsInstanceOfOrPeekIf_0.__next;
      if (next_1 === tmp1_removeFirstIfIsInstanceOfOrPeekIf_0) {
        tmp$ret$0 = null;
        break l$ret$1;
      }if (!(next_1 instanceof Send)) {
        tmp$ret$0 = null;
        break l$ret$1;
      } else {
      }
      var tmp2__anonymous__3 = next_1;
      if (tmp2__anonymous__3 instanceof Closed) {
        tmp$ret$0 = next_1;
        break l$ret$1;
      } else {
      }
      var tmp0_check_0 = next_1.remove_69();
      if (!tmp0_check_0) {
        var message_1 = 'Should remove';
        throw IllegalStateException_init_$Create$_0(toString_1(message_1));
      }tmp$ret$0 = next_1;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractSendChannel.prototype.sendBuffered_0 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_addLastIfPrev_0 = this._queue;
      var tmp1_addLastIfPrev_0 = new SendBuffered(element);
      var tmp2__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
      if (isInterface(tmp2__anonymous__1, ReceiveOrClosed))
        return tmp2__anonymous__1;
      else {
      }
      if (!true) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      tmp0_addLastIfPrev_0.addLast_26(tmp1_addLastIfPrev_0);
      tmp$ret$0 = true;
    }
     while (false);
    Unit_getInstance();
    return null;
  };
  AbstractSendChannel.prototype._get_isFullImpl__4 = function () {
    var tmp;
    var tmp0__get_nextNode__0 = this._queue;
    var tmp_0 = tmp0__get_nextNode__0.__next;
    if (!isInterface(tmp_0, ReceiveOrClosed)) {
      tmp = this._get_isBufferFull__4();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  AbstractSendChannel.prototype.send_9 = function (element, $cont) {
    if (this.offerInternal_4(element) === OFFER_SUCCESS)
      return Unit_getInstance();
    return sendSuspend(this, element, $cont);
  };
  AbstractSendChannel.prototype.enqueueSend_4 = function (send) {
    if (this._get_isBufferAlwaysFull__4()) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_addLastIfPrev_0 = this._queue;
        var tmp1__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
        if (isInterface(tmp1__anonymous__1, ReceiveOrClosed))
          return tmp1__anonymous__1;
        else {
        }
        if (!true) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
        tmp0_addLastIfPrev_0.addLast_26(send);
        tmp$ret$0 = true;
      }
       while (false);
      Unit_getInstance();
    } else {
      var tmp$ret$2;
      l$ret$3: do {
        var tmp2_addLastIfPrevAndIf_0 = this._queue;
        var tmp3__anonymous__1 = tmp2_addLastIfPrevAndIf_0.__prev;
        if (isInterface(tmp3__anonymous__1, ReceiveOrClosed))
          return tmp3__anonymous__1;
        else {
        }
        if (!true) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        if (!this._get_isBufferFull__4()) {
          tmp$ret$2 = false;
          break l$ret$3;
        } else {
        }
        tmp2_addLastIfPrevAndIf_0.addLast_26(send);
        tmp$ret$2 = true;
      }
       while (false);
      if (!tmp$ret$2)
        return ENQUEUE_FAILED;
      else {
      }
    }
    return null;
  };
  AbstractSendChannel.prototype.close_9 = function (cause) {
    var closed = new Closed(cause);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_addLastIfPrev_0 = this._queue;
      var tmp1__anonymous__1 = tmp0_addLastIfPrev_0.__prev;
      if (!!(tmp1__anonymous__1 instanceof Closed)) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      tmp0_addLastIfPrev_0.addLast_26(closed);
      tmp$ret$0 = true;
    }
     while (false);
    var closeAdded = tmp$ret$0;
    var tmp;
    if (closeAdded) {
      tmp = closed;
    } else {
      var tmp2__get_prevNode__0 = this._queue;
      var tmp_0 = tmp2__get_prevNode__0.__prev;
      tmp = tmp_0 instanceof Closed ? tmp_0 : THROW_CCE();
    }
    var actuallyClosed = tmp;
    helpClose(this, actuallyClosed);
    if (closeAdded)
      invokeOnCloseHandler(this, cause);
    return closeAdded;
  };
  AbstractSendChannel.prototype.onClosedIdempotent_4 = function (closed) {
  };
  AbstractSendChannel.prototype.takeFirstReceiveOrPeekClosed_4 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_removeFirstIfIsInstanceOfOrPeekIf_0 = this._queue;
      var next_1 = tmp1_removeFirstIfIsInstanceOfOrPeekIf_0.__next;
      if (next_1 === tmp1_removeFirstIfIsInstanceOfOrPeekIf_0) {
        tmp$ret$0 = null;
        break l$ret$1;
      }if (!isInterface(next_1, ReceiveOrClosed)) {
        tmp$ret$0 = null;
        break l$ret$1;
      } else {
      }
      var tmp2__anonymous__3 = next_1;
      if (tmp2__anonymous__3 instanceof Closed) {
        tmp$ret$0 = next_1;
        break l$ret$1;
      } else {
      }
      var tmp0_check_0 = next_1.remove_69();
      if (!tmp0_check_0) {
        var message_1 = 'Should remove';
        throw IllegalStateException_init_$Create$_0(toString_1(message_1));
      }tmp$ret$0 = next_1;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractSendChannel.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '{' + _get_queueDebugStateString_(this) + '}' + this._get_bufferDebugString__4();
  };
  AbstractSendChannel.prototype._get_bufferDebugString__4 = function () {
    return '';
  };
  AbstractSendChannel.$metadata$ = {
    simpleName: 'AbstractSendChannel',
    kind: 'class',
    interfaces: [SendChannel]
  };
  function Send() {
    LinkedListNode.call(this);
  }
  Send.prototype.undeliveredElement_3 = function () {
  };
  Send.$metadata$ = {
    simpleName: 'Send',
    kind: 'class',
    interfaces: []
  };
  function ReceiveOrClosed() {
  }
  ReceiveOrClosed.$metadata$ = {
    simpleName: 'ReceiveOrClosed',
    kind: 'interface',
    interfaces: []
  };
  function Closed(closeCause) {
    Send.call(this);
    this._closeCause = closeCause;
  }
  Closed.prototype._get_sendException_ = function () {
    var tmp0_elvis_lhs = this._closeCause;
    return tmp0_elvis_lhs == null ? new ClosedSendChannelException('Channel was closed') : tmp0_elvis_lhs;
  };
  Closed.prototype._get_receiveException_ = function () {
    var tmp0_elvis_lhs = this._closeCause;
    return tmp0_elvis_lhs == null ? new ClosedReceiveChannelException('Channel was closed') : tmp0_elvis_lhs;
  };
  Closed.prototype._get_offerResult__3 = function () {
    return this;
  };
  Closed.prototype._get_pollResult__3 = function () {
    return this;
  };
  Closed.prototype.tryResumeSend_3 = function (otherOp) {
    var tmp0_also_0 = RESUME_TOKEN;
    var tmp0_safe_receiver_2 = otherOp;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.finishPrepare__error();
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_also_0;
  };
  Closed.prototype.completeResumeSend_3 = function () {
  };
  Closed.prototype.tryResumeReceive_3 = function (value, otherOp) {
    var tmp0_also_0 = RESUME_TOKEN;
    var tmp0_safe_receiver_2 = otherOp;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.finishPrepare__error();
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_also_0;
  };
  Closed.prototype.completeResumeReceive_3 = function (value) {
  };
  Closed.prototype.resumeSendClosed_3 = function (closed) {
    return Unit_getInstance();
  };
  Closed.prototype.toString = function () {
    return '' + 'Closed@' + _get_hexAddress_(this) + '[' + this._closeCause + ']';
  };
  Closed.$metadata$ = {
    simpleName: 'Closed',
    kind: 'class',
    interfaces: [ReceiveOrClosed]
  };
  function Receive() {
    LinkedListNode.call(this);
  }
  Receive.prototype._get_offerResult__3 = function () {
    return OFFER_SUCCESS;
  };
  Receive.prototype.resumeOnCancellationFun_1 = function (value) {
    return null;
  };
  Receive.$metadata$ = {
    simpleName: 'Receive',
    kind: 'class',
    interfaces: [ReceiveOrClosed]
  };
  function SendElement(pollResult, cont) {
    Send.call(this);
    this._pollResult = pollResult;
    this._cont_0 = cont;
  }
  SendElement.prototype._get_pollResult__3 = function () {
    return this._pollResult;
  };
  SendElement.prototype._get_cont__2 = function () {
    return this._cont_0;
  };
  SendElement.prototype.tryResumeSend_3 = function (otherOp) {
    var tmp0_safe_receiver = otherOp;
    var tmp1_elvis_lhs = this._cont_0.tryResume_3(Unit_getInstance(), tmp0_safe_receiver == null ? null : tmp0_safe_receiver.desc__error);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var token = tmp;
    var tmp2_safe_receiver = otherOp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.finishPrepare__error();
      Unit_getInstance();
    }
    Unit_getInstance();
    return RESUME_TOKEN;
  };
  SendElement.prototype.completeResumeSend_3 = function () {
    return this._cont_0.completeResume_1(RESUME_TOKEN);
  };
  SendElement.prototype.resumeSendClosed_3 = function (closed) {
    var tmp0_resumeWithException_0 = this._cont_0;
    var tmp1_resumeWithException_0 = closed._get_sendException_();
    var tmp0_failure_0_1 = Companion_getInstance_2();
    return tmp0_resumeWithException_0.resumeWith_196(_Result___init__impl_(createFailure(tmp1_resumeWithException_0)));
  };
  SendElement.prototype.toString = function () {
    return '' + _get_classSimpleName_(this) + '@' + _get_hexAddress_(this) + '(' + this._get_pollResult__3() + ')';
  };
  SendElement.$metadata$ = {
    simpleName: 'SendElement',
    kind: 'class',
    interfaces: []
  };
  function SendElementWithUndeliveredHandler(pollResult, cont, onUndeliveredElement) {
    SendElement.call(this, pollResult, cont);
    this._onUndeliveredElement_1 = onUndeliveredElement;
  }
  SendElementWithUndeliveredHandler.prototype.remove_69 = function () {
    if (!SendElement.prototype.remove_69.call(this))
      return false;
    this.undeliveredElement_3();
    return true;
  };
  SendElementWithUndeliveredHandler.prototype.undeliveredElement_3 = function () {
    callUndeliveredElement(this._onUndeliveredElement_1, this._get_pollResult__3(), this._get_cont__2()._get_context__296());
  };
  SendElementWithUndeliveredHandler.$metadata$ = {
    simpleName: 'SendElementWithUndeliveredHandler',
    kind: 'class',
    interfaces: []
  };
  function updateBufferSize($this, currentSize) {
    if (currentSize < $this._capacity_1) {
      $this._size_4._value_6 = currentSize + 1 | 0;
      return null;
    }var tmp0_subject = $this._onBufferOverflow;
    var tmp;
    if (tmp0_subject.equals(BufferOverflow_SUSPEND_getInstance())) {
      tmp = OFFER_FAILED;
    } else if (tmp0_subject.equals(BufferOverflow_DROP_LATEST_getInstance())) {
      tmp = OFFER_SUCCESS;
    } else if (tmp0_subject.equals(BufferOverflow_DROP_OLDEST_getInstance())) {
      tmp = null;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function enqueueElement($this, currentSize, element) {
    if (currentSize < $this._capacity_1) {
      ensureCapacity($this, currentSize);
      $this._buffer_4[($this._head_0 + currentSize | 0) % $this._buffer_4.length] = element;
    } else {
      $this._buffer_4[$this._head_0 % $this._buffer_4.length] = null;
      $this._buffer_4[($this._head_0 + currentSize | 0) % $this._buffer_4.length] = element;
      $this._head_0 = ($this._head_0 + 1 | 0) % $this._buffer_4.length;
    }
  }
  function ensureCapacity($this, currentSize) {
    if (currentSize >= $this._buffer_4.length) {
      var tmp0_min_0 = imul($this._buffer_4.length, 2);
      var tmp1_min_0 = $this._capacity_1;
      var newSize = function () {
        var $externalVarargReceiverTmp = Math;
        return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_min_0, tmp1_min_0]))));
      }.call(this);
      var newBuffer = fillArrayVal(Array(newSize), null);
      var inductionVariable = 0;
      if (inductionVariable < currentSize)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          newBuffer[i] = $this._buffer_4[($this._head_0 + i | 0) % $this._buffer_4.length];
        }
         while (inductionVariable < currentSize);
      fill_1(newBuffer, EMPTY, currentSize, newSize);
      $this._buffer_4 = newBuffer;
      $this._head_0 = 0;
    }}
  function ArrayChannel(capacity, onBufferOverflow, onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
    this._capacity_1 = capacity;
    this._onBufferOverflow = onBufferOverflow;
    var tmp0_require_0 = this._capacity_1 >= 1;
    if (!tmp0_require_0) {
      var message_1 = '' + 'ArrayChannel capacity must be at least 1, but ' + this._capacity_1 + ' was specified';
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }this._lock = new NoOpLock();
    var tmp = this;
    var tmp0_min_0 = this._capacity_1;
    var tmp1_min_0 = 8;
    var tmp2_arrayOfNulls_0 = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Int32Array([tmp0_min_0, tmp1_min_0]))));
    }.call(this);
    var tmp3_apply_0 = fillArrayVal(Array(tmp2_arrayOfNulls_0), null);
    fill$default(tmp3_apply_0, EMPTY, 0, 0, 6, null);
    tmp._buffer_4 = tmp3_apply_0;
    this._head_0 = 0;
    this._size_4 = atomic_1(0);
  }
  ArrayChannel.prototype._get_isBufferAlwaysEmpty__3 = function () {
    return false;
  };
  ArrayChannel.prototype._get_isBufferEmpty__3 = function () {
    return this._size_4._value_6 === 0;
  };
  ArrayChannel.prototype._get_isBufferAlwaysFull__4 = function () {
    return false;
  };
  ArrayChannel.prototype._get_isBufferFull__4 = function () {
    return this._size_4._value_6 === this._capacity_1 ? this._onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) : false;
  };
  ArrayChannel.prototype._get_isClosedForReceive__3 = function () {
    var tmp0_withLock_0 = this._lock;
    return AbstractChannel.prototype._get_isClosedForReceive__3.call(this);
  };
  ArrayChannel.prototype.offerInternal_4 = function (element) {
    var receive = null;
    var tmp0_withLock_0 = this._lock;
    var tmp$ret$0;
    l$ret$1: do {
      var size_2 = this._size_4._value_6;
      var tmp0_safe_receiver_3 = this._get_closedForSend__4();
      if (tmp0_safe_receiver_3 == null)
        null;
      else {
        return tmp0_safe_receiver_3;
      }
      Unit_getInstance();
      var tmp1_safe_receiver_4 = updateBufferSize(this, size_2);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        return tmp1_safe_receiver_4;
      }
      Unit_getInstance();
      if (size_2 === 0) {
        loop: while (true) {
          var tmp2_elvis_lhs_5 = this.takeFirstReceiveOrPeekClosed_4();
          var tmp;
          if (tmp2_elvis_lhs_5 == null) {
            break loop;
          } else {
            tmp = tmp2_elvis_lhs_5;
          }
          receive = tmp;
          if (receive instanceof Closed) {
            this._size_4._value_6 = size_2;
            return ensureNotNull(receive);
          } else {
          }
          var token_6 = ensureNotNull(receive).tryResumeReceive_3(element, null);
          if (!(token_6 == null)) {
            this._size_4._value_6 = size_2;
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }}
      }enqueueElement(this, size_2, element);
      return OFFER_SUCCESS;
    }
     while (false);
    ensureNotNull(receive).completeResumeReceive_3(element);
    return ensureNotNull(receive)._get_offerResult__3();
  };
  ArrayChannel.prototype.enqueueSend_4 = function (send) {
    var tmp0_withLock_0 = this._lock;
    return AbstractChannel.prototype.enqueueSend_4.call(this, send);
  };
  ArrayChannel.prototype.pollInternal_3 = function () {
    var send = null;
    var resumed = false;
    var result = null;
    var tmp0_withLock_0 = this._lock;
    var size_2 = this._size_4._value_6;
    if (size_2 === 0) {
      var tmp0_elvis_lhs_3 = this._get_closedForSend__4();
      return tmp0_elvis_lhs_3 == null ? POLL_FAILED : tmp0_elvis_lhs_3;
    }result = this._buffer_4[this._head_0];
    this._buffer_4[this._head_0] = null;
    this._size_4._value_6 = size_2 - 1 | 0;
    var replacement_4 = POLL_FAILED;
    if (size_2 === this._capacity_1) {
      loop: while (true) {
        var tmp1_elvis_lhs_5 = this.takeFirstSendOrPeekClosed_4();
        var tmp;
        if (tmp1_elvis_lhs_5 == null) {
          break loop;
        } else {
          tmp = tmp1_elvis_lhs_5;
        }
        send = tmp;
        var token_6 = ensureNotNull(send).tryResumeSend_3(null);
        if (!(token_6 == null)) {
          resumed = true;
          replacement_4 = ensureNotNull(send)._get_pollResult__3();
          break loop;
        }ensureNotNull(send).undeliveredElement_3();
      }
    }var tmp_0;
    if (!(replacement_4 === POLL_FAILED)) {
      tmp_0 = !(replacement_4 instanceof Closed);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      this._size_4._value_6 = size_2;
      this._buffer_4[(this._head_0 + size_2 | 0) % this._buffer_4.length] = replacement_4;
    } else {
    }
    this._head_0 = (this._head_0 + 1 | 0) % this._buffer_4.length;
    if (resumed)
      ensureNotNull(send).completeResumeSend_3();
    return result;
  };
  ArrayChannel.prototype.enqueueReceiveInternal_3 = function (receive) {
    var tmp0_withLock_0 = this._lock;
    return AbstractChannel.prototype.enqueueReceiveInternal_3.call(this, receive);
  };
  ArrayChannel.prototype.onCancelIdempotent_3 = function (wasClosed) {
    var onUndeliveredElement = this._get_onUndeliveredElement__4();
    var undeliveredElementException = null;
    var tmp0_withLock_0 = this._lock;
    var tmp0_repeat_0_2 = this._size_4._value_6;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat_0_2)
      do {
        var index_2_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var value_4_5 = this._buffer_4[this._head_0];
        if (!(onUndeliveredElement == null) ? !(value_4_5 === EMPTY) : false) {
          undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, (value_4_5 == null ? true : isObject(value_4_5)) ? value_4_5 : THROW_CCE(), undeliveredElementException);
        }this._buffer_4[this._head_0] = EMPTY;
        this._head_0 = (this._head_0 + 1 | 0) % this._buffer_4.length;
      }
       while (inductionVariable < tmp0_repeat_0_2);
    this._size_4._value_6 = 0;
    AbstractChannel.prototype.onCancelIdempotent_3.call(this, wasClosed);
    var tmp0_safe_receiver = undeliveredElementException;
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
  };
  ArrayChannel.prototype._get_bufferDebugString__4 = function () {
    return '' + '(buffer:capacity=' + this._capacity_1 + ',size=' + this._size_4._value_6 + ')';
  };
  ArrayChannel.$metadata$ = {
    simpleName: 'ArrayChannel',
    kind: 'class',
    interfaces: []
  };
  var BufferOverflow_SUSPEND_instance;
  var BufferOverflow_DROP_OLDEST_instance;
  var BufferOverflow_DROP_LATEST_instance;
  var BufferOverflow_entriesInitialized;
  function BufferOverflow_initEntries() {
    if (BufferOverflow_entriesInitialized)
      return Unit_getInstance();
    BufferOverflow_entriesInitialized = true;
    BufferOverflow_SUSPEND_instance = new BufferOverflow('SUSPEND', 0);
    BufferOverflow_DROP_OLDEST_instance = new BufferOverflow('DROP_OLDEST', 1);
    BufferOverflow_DROP_LATEST_instance = new BufferOverflow('DROP_LATEST', 2);
  }
  function BufferOverflow(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  BufferOverflow.$metadata$ = {
    simpleName: 'BufferOverflow',
    kind: 'class',
    interfaces: []
  };
  function BufferOverflow_SUSPEND_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_SUSPEND_instance;
  }
  function BufferOverflow_DROP_OLDEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_OLDEST_instance;
  }
  function BufferOverflow_DROP_LATEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_LATEST_instance;
  }
  function ReceiveChannel() {
  }
  ReceiveChannel.$metadata$ = {
    simpleName: 'ReceiveChannel',
    kind: 'interface',
    interfaces: []
  };
  function _ValueOrClosed___init__impl_(holder) {
    return holder;
  }
  function _get_holder_($this) {
    return $this;
  }
  function _ValueOrClosed___get_isClosed__impl_(this_0) {
    var tmp = _get_holder_(this_0);
    return tmp instanceof Closed_0;
  }
  function _ValueOrClosed___get_value__impl_(this_0) {
    var tmp;
    var tmp_0 = _get_holder_(this_0);
    if (tmp_0 instanceof Closed_0) {
      var tmp0_error_0 = 'Channel was closed';
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    } else {
      {
        var tmp_1 = _get_holder_(this_0);
        tmp = (tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE();
      }
    }
    return tmp;
  }
  function _ValueOrClosed___get_closeCause__impl_(this_0) {
    var tmp;
    var tmp_0 = _get_holder_(this_0);
    if (tmp_0 instanceof Closed_0) {
      tmp = _get_holder_(this_0)._cause_0;
    } else {
      {
        var tmp0_error_0 = 'Channel was not closed';
        throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
      }
    }
    return tmp;
  }
  function ValueOrClosed__toString_impl(this_0) {
    var tmp0_subject = _get_holder_(this_0);
    var tmp;
    if (tmp0_subject instanceof Closed_0) {
      tmp = toString_1(_get_holder_(this_0));
    } else {
      {
        tmp = '' + 'Value(' + _get_holder_(this_0) + ')';
      }
    }
    return tmp;
  }
  function Closed_0(cause) {
    this._cause_0 = cause;
  }
  Closed_0.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Closed_0) {
      tmp = equals_1(this._cause_0, other._cause_0);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Closed_0.prototype.hashCode = function () {
    var tmp0_hashCode_0 = this._cause_0;
    var tmp0_safe_receiver_2 = tmp0_hashCode_0;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    return tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1;
  };
  Closed_0.prototype.toString = function () {
    return '' + 'Closed(' + this._cause_0 + ')';
  };
  Closed_0.$metadata$ = {
    simpleName: 'Closed',
    kind: 'class',
    interfaces: []
  };
  function Companion_41() {
    Companion_instance_40 = this;
  }
  Companion_41.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_40;
  function Companion_getInstance_40() {
    if (Companion_instance_40 == null)
      new Companion_41();
    return Companion_instance_40;
  }
  function ValueOrClosed__hashCode_impl(this_0) {
    return this_0 == null ? 0 : hashCode(this_0);
  }
  function ValueOrClosed__equals_impl(this_0, other) {
    if (!(other instanceof ValueOrClosed))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ValueOrClosed ? other._holder : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ValueOrClosed(holder) {
    Companion_getInstance_40();
    this._holder = holder;
  }
  ValueOrClosed.prototype.toString = function () {
    return ValueOrClosed__toString_impl(this._holder);
  };
  ValueOrClosed.prototype.hashCode = function () {
    return ValueOrClosed__hashCode_impl(this._holder);
  };
  ValueOrClosed.prototype.equals = function (other) {
    return ValueOrClosed__equals_impl(this._holder, other);
  };
  ValueOrClosed.$metadata$ = {
    simpleName: 'ValueOrClosed',
    kind: 'class',
    interfaces: []
  };
  function ClosedReceiveChannelException(message) {
    NoSuchElementException_init_$Init$_0(message, this);
    captureStack(this, ClosedReceiveChannelException);
  }
  ClosedReceiveChannelException.$metadata$ = {
    simpleName: 'ClosedReceiveChannelException',
    kind: 'class',
    interfaces: []
  };
  function SendChannel() {
  }
  SendChannel.prototype.close$default_7 = function (cause, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      cause = null;
    return $handler == null ? this.close_9(cause) : $handler(cause);
  };
  SendChannel.$metadata$ = {
    simpleName: 'SendChannel',
    kind: 'interface',
    interfaces: []
  };
  function Factory() {
    Factory_instance = this;
    this._UNLIMITED = 2147483647;
    this._RENDEZVOUS = 0;
    this._CONFLATED = -1;
    this._BUFFERED = -2;
    this._OPTIONAL_CHANNEL = -3;
    this._DEFAULT_BUFFER_PROPERTY_NAME = 'kotlinx.coroutines.channels.defaultBuffer';
    this._CHANNEL_DEFAULT_CAPACITY = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
  }
  Factory.$metadata$ = {
    simpleName: 'Factory',
    kind: 'object',
    interfaces: []
  };
  var Factory_instance;
  function Factory_getInstance() {
    if (Factory_instance == null)
      new Factory();
    return Factory_instance;
  }
  function Channel() {
  }
  Channel.$metadata$ = {
    simpleName: 'Channel',
    kind: 'interface',
    interfaces: [SendChannel, ReceiveChannel]
  };
  function Channel_0(capacity, onBufferOverflow, onUndeliveredElement) {
    var tmp0_subject = capacity;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new RendezvousChannel(onUndeliveredElement) : new ArrayChannel(1, onBufferOverflow, onUndeliveredElement);
        break;
      case -1:
        var tmp0_require_0 = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance());
        if (!tmp0_require_0) {
          var message_1 = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
          throw IllegalArgumentException_init_$Create$(toString_1(message_1));
        }
        tmp = new ConflatedChannel(onUndeliveredElement);
        break;
      case 2147483647:
        tmp = new LinkedListChannel(onUndeliveredElement);
        break;
      case -2:
        tmp = new ArrayChannel(onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? Factory_getInstance()._CHANNEL_DEFAULT_CAPACITY : 1, onBufferOverflow, onUndeliveredElement);
        break;
      default:tmp = (capacity === 1 ? onBufferOverflow.equals(BufferOverflow_DROP_OLDEST_getInstance()) : false) ? new ConflatedChannel(onUndeliveredElement) : new ArrayChannel(capacity, onBufferOverflow, onUndeliveredElement);
        break;
    }
    return tmp;
  }
  function Channel$default(capacity, onBufferOverflow, onUndeliveredElement, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      capacity = 0;
    if (!(($mask0 & 2) === 0))
      onBufferOverflow = BufferOverflow_SUSPEND_getInstance();
    if (!(($mask0 & 4) === 0))
      onUndeliveredElement = null;
    return Channel_0(capacity, onBufferOverflow, onUndeliveredElement);
  }
  function ClosedSendChannelException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, ClosedSendChannelException);
  }
  ClosedSendChannelException.$metadata$ = {
    simpleName: 'ClosedSendChannelException',
    kind: 'class',
    interfaces: []
  };
  function ChannelCoroutine(parentContext, _channel, active) {
    AbstractCoroutine.call(this, parentContext, active);
    this.__channel = _channel;
  }
  ChannelCoroutine.prototype._get__channel__0 = function () {
    return this.__channel;
  };
  ChannelCoroutine.prototype.receiveOrClosed_7 = function ($cont) {
    return this.__channel.receiveOrClosed_7($cont);
  };
  ChannelCoroutine.prototype.close_9 = function (cause) {
    return this.__channel.close_9(cause);
  };
  ChannelCoroutine.prototype.send_9 = function (element, $cont) {
    return this.__channel.send_9(element, $cont);
  };
  ChannelCoroutine.prototype.cancel_23 = function (cause) {
    if (this._get_isCancelled__3())
      return Unit_getInstance();
    var tmp0_elvis_lhs = cause;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_defaultCancellationException_0 = null;
      var tmp1_defaultCancellationException_0 = null;
      var tmp0_elvis_lhs_1 = tmp0_defaultCancellationException_0;
      tmp = new JobCancellationException(tmp0_elvis_lhs_1 == null ? this.cancellationExceptionMessage_13() : tmp0_elvis_lhs_1, tmp1_defaultCancellationException_0, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    this.cancelInternal_18(tmp);
  };
  ChannelCoroutine.prototype.cancelInternal_18 = function (cause) {
    var exception = this.toCancellationException$default_13(cause, null, 1, null);
    this.__channel.cancel_23(exception);
    this.cancelCoroutine_2(exception);
    Unit_getInstance();
  };
  ChannelCoroutine.$metadata$ = {
    simpleName: 'ChannelCoroutine',
    kind: 'class',
    interfaces: [Channel]
  };
  function cancelConsumed(_this_, cause) {
    var tmp0_safe_receiver = cause;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp0_elvis_lhs_2 = tmp0_safe_receiver instanceof CancellationException_0 ? tmp0_safe_receiver : null;
      tmp = tmp0_elvis_lhs_2 == null ? new CancellationException_0('Channel was consumed, consumer had failed', tmp0_safe_receiver) : tmp0_elvis_lhs_2;
    }
    _this_.cancel_23(tmp);
  }
  function updateValueLocked($this, element) {
    var old = $this._value_7;
    var tmp;
    if (old === EMPTY) {
      tmp = null;
    } else {
      var tmp0_safe_receiver = $this._get_onUndeliveredElement__4();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        var tmp_1 = (old == null ? true : isObject(old)) ? old : THROW_CCE();
        tmp_0 = callUndeliveredElementCatchingException$default(tmp0_safe_receiver, tmp_1, null, 2, null);
      }
      tmp = tmp_0;
    }
    var undeliveredElementException = tmp;
    $this._value_7 = element;
    return undeliveredElementException;
  }
  function ConflatedChannel(onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
    this._lock_0 = new NoOpLock();
    this._value_7 = EMPTY;
  }
  ConflatedChannel.prototype._get_isBufferAlwaysEmpty__3 = function () {
    return false;
  };
  ConflatedChannel.prototype._get_isBufferEmpty__3 = function () {
    return this._value_7 === EMPTY;
  };
  ConflatedChannel.prototype._get_isBufferAlwaysFull__4 = function () {
    return false;
  };
  ConflatedChannel.prototype._get_isBufferFull__4 = function () {
    return false;
  };
  ConflatedChannel.prototype.offerInternal_4 = function (element) {
    var receive = null;
    var tmp0_withLock_0 = this._lock_0;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_safe_receiver_2 = this._get_closedForSend__4();
      if (tmp0_safe_receiver_2 == null)
        null;
      else {
        return tmp0_safe_receiver_2;
      }
      Unit_getInstance();
      if (this._value_7 === EMPTY) {
        loop: while (true) {
          var tmp1_elvis_lhs_3 = this.takeFirstReceiveOrPeekClosed_4();
          var tmp;
          if (tmp1_elvis_lhs_3 == null) {
            break loop;
          } else {
            tmp = tmp1_elvis_lhs_3;
          }
          receive = tmp;
          if (receive instanceof Closed) {
            return ensureNotNull(receive);
          } else {
          }
          var token_4 = ensureNotNull(receive).tryResumeReceive_3(element, null);
          if (!(token_4 == null)) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }}
      }var tmp2_safe_receiver_5 = updateValueLocked(this, element);
      if (tmp2_safe_receiver_5 == null)
        null;
      else {
        throw tmp2_safe_receiver_5;
      }
      Unit_getInstance();
      return OFFER_SUCCESS;
    }
     while (false);
    ensureNotNull(receive).completeResumeReceive_3(element);
    return ensureNotNull(receive)._get_offerResult__3();
  };
  ConflatedChannel.prototype.pollInternal_3 = function () {
    var result = null;
    var tmp0_withLock_0 = this._lock_0;
    if (this._value_7 === EMPTY) {
      var tmp0_elvis_lhs_2 = this._get_closedForSend__4();
      return tmp0_elvis_lhs_2 == null ? POLL_FAILED : tmp0_elvis_lhs_2;
    }result = this._value_7;
    this._value_7 = EMPTY;
    return result;
  };
  ConflatedChannel.prototype.onCancelIdempotent_3 = function (wasClosed) {
    var undeliveredElementException = null;
    var tmp0_withLock_0 = this._lock_0;
    undeliveredElementException = updateValueLocked(this, EMPTY);
    AbstractChannel.prototype.onCancelIdempotent_3.call(this, wasClosed);
    var tmp0_safe_receiver = undeliveredElementException;
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
  };
  ConflatedChannel.prototype.enqueueReceiveInternal_3 = function (receive) {
    var tmp0_withLock_0 = this._lock_0;
    return AbstractChannel.prototype.enqueueReceiveInternal_3.call(this, receive);
  };
  ConflatedChannel.prototype._get_bufferDebugString__4 = function () {
    return '' + '(value=' + this._value_7 + ')';
  };
  ConflatedChannel.$metadata$ = {
    simpleName: 'ConflatedChannel',
    kind: 'class',
    interfaces: []
  };
  function LinkedListChannel(onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
  }
  LinkedListChannel.prototype._get_isBufferAlwaysEmpty__3 = function () {
    return true;
  };
  LinkedListChannel.prototype._get_isBufferEmpty__3 = function () {
    return true;
  };
  LinkedListChannel.prototype._get_isBufferAlwaysFull__4 = function () {
    return false;
  };
  LinkedListChannel.prototype._get_isBufferFull__4 = function () {
    return false;
  };
  LinkedListChannel.prototype.offerInternal_4 = function (element) {
    while (true) {
      var result = AbstractChannel.prototype.offerInternal_4.call(this, element);
      if (result === OFFER_SUCCESS)
        return OFFER_SUCCESS;
      else {
        if (result === OFFER_FAILED) {
          var sendResult = this.sendBuffered_0(element);
          if (sendResult == null)
            return OFFER_SUCCESS;
          else {
            if (sendResult instanceof Closed)
              return sendResult;
            else {
            }
          }
        } else {
          if (result instanceof Closed)
            return result;
          else {
            {
              var tmp0_error_0 = '' + 'Invalid offerInternal result ' + result;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
            }
          }
        }
      }
    }
  };
  LinkedListChannel.prototype.onCancelIdempotentList_3 = function (list, closed) {
    var undeliveredElementException = null;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_subject_1 = _get_holder__0(list);
      if (tmp0_subject_1 == null) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      } else {
        if (!(tmp0_subject_1 instanceof ArrayList)) {
          var tmp = _get_holder__0(list);
          var tmp0__anonymous__5 = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
          var tmp0_subject_6 = tmp0__anonymous__5;
          if (tmp0_subject_6 instanceof SendBuffered) {
            var tmp1_safe_receiver_7 = this._get_onUndeliveredElement__4();
            var tmp_0;
            if (tmp1_safe_receiver_7 == null) {
              tmp_0 = null;
            } else {
              var tmp_1 = tmp0__anonymous__5._element_0;
              tmp_0 = callUndeliveredElementCatchingException(tmp1_safe_receiver_7, (tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE(), undeliveredElementException);
            }
            undeliveredElementException = tmp_0;
          } else {
            tmp0__anonymous__5.resumeSendClosed_3(closed);
          }
        } else {
          {
            var tmp_2 = _get_holder__0(list);
            var list_2 = tmp_2 instanceof ArrayList ? tmp_2 : THROW_CCE();
            var inductionVariable = list_2._get_size__60() - 1 | 0;
            if (0 <= inductionVariable)
              do {
                var i_4 = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                var tmp1__anonymous__5 = list_2.get_137(i_4);
                var tmp0_subject_6_0 = tmp1__anonymous__5;
                if (tmp0_subject_6_0 instanceof SendBuffered) {
                  var tmp1_safe_receiver_7_0 = this._get_onUndeliveredElement__4();
                  var tmp_3;
                  if (tmp1_safe_receiver_7_0 == null) {
                    tmp_3 = null;
                  } else {
                    var tmp_4 = tmp1__anonymous__5._element_0;
                    tmp_3 = callUndeliveredElementCatchingException(tmp1_safe_receiver_7_0, (tmp_4 == null ? true : isObject(tmp_4)) ? tmp_4 : THROW_CCE(), undeliveredElementException);
                  }
                  undeliveredElementException = tmp_3;
                } else {
                  tmp1__anonymous__5.resumeSendClosed_3(closed);
                }
              }
               while (0 <= inductionVariable);
          }
        }
      }
    }
     while (false);
    var tmp0_safe_receiver = undeliveredElementException;
    if (tmp0_safe_receiver == null)
      null;
    else {
      throw tmp0_safe_receiver;
    }
    Unit_getInstance();
  };
  LinkedListChannel.$metadata$ = {
    simpleName: 'LinkedListChannel',
    kind: 'class',
    interfaces: []
  };
  function produce(_this_, context, capacity, block) {
    return produce_0(_this_, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
  }
  function ProducerScope() {
  }
  ProducerScope.$metadata$ = {
    simpleName: 'ProducerScope',
    kind: 'interface',
    interfaces: [CoroutineScope, SendChannel]
  };
  function produce_0(_this_, context, capacity, onBufferOverflow, start, onCompletion, block) {
    var channel = Channel$default(capacity, onBufferOverflow, null, 4, null);
    var newContext = newCoroutineContext(_this_, context);
    var coroutine = new ProducerCoroutine(newContext, channel);
    if (!(onCompletion == null)) {
      coroutine.invokeOnCompletion_31(onCompletion);
      Unit_getInstance();
    }coroutine.start_8(start, coroutine, block);
    return coroutine;
  }
  function ProducerCoroutine(parentContext, channel) {
    ChannelCoroutine.call(this, parentContext, channel, true);
  }
  ProducerCoroutine.prototype._get_isActive__29 = function () {
    return ChannelCoroutine.prototype._get_isActive__29.call(this);
  };
  ProducerCoroutine.prototype.onCompleted_7 = function (value) {
    var tmp = this._get__channel__0();
    tmp.close$default_7(null, 1, null);
    Unit_getInstance();
  };
  ProducerCoroutine.prototype.onCompleted_10 = function (value) {
    return this.onCompleted_7(value instanceof Unit ? value : THROW_CCE());
  };
  ProducerCoroutine.prototype.onCancelled_9 = function (cause, handled) {
    var processed = this._get__channel__0().close_9(cause);
    if (!processed ? !handled : false)
      handleCoroutineException(this._get_context__296(), cause);
  };
  ProducerCoroutine.$metadata$ = {
    simpleName: 'ProducerCoroutine',
    kind: 'class',
    interfaces: [ProducerScope]
  };
  function RendezvousChannel(onUndeliveredElement) {
    AbstractChannel.call(this, onUndeliveredElement);
  }
  RendezvousChannel.prototype._get_isBufferAlwaysEmpty__3 = function () {
    return true;
  };
  RendezvousChannel.prototype._get_isBufferEmpty__3 = function () {
    return true;
  };
  RendezvousChannel.prototype._get_isBufferAlwaysFull__4 = function () {
    return true;
  };
  RendezvousChannel.prototype._get_isBufferFull__4 = function () {
    return true;
  };
  RendezvousChannel.$metadata$ = {
    simpleName: 'RendezvousChannel',
    kind: 'class',
    interfaces: []
  };
  function flow(block) {
    return new SafeFlow(block);
  }
  function asFlow(_this_) {
    return new _no_name_provided__1_7(_this_);
  }
  function emptyFlow() {
    return EmptyFlow_getInstance();
  }
  function SafeFlow(block) {
    AbstractFlow.call(this);
    this._block = block;
  }
  SafeFlow.prototype.collectSafely_0 = function (collector, $cont) {
    return this._block(collector, $cont);
  };
  SafeFlow.$metadata$ = {
    simpleName: 'SafeFlow',
    kind: 'class',
    interfaces: []
  };
  function EmptyFlow() {
    EmptyFlow_instance = this;
  }
  EmptyFlow.prototype.collect_0 = function (collector, $cont) {
    return Unit_getInstance();
  };
  EmptyFlow.prototype.collect_6 = function (collector, $cont) {
    return this.collect_0(collector, $cont);
  };
  EmptyFlow.$metadata$ = {
    simpleName: 'EmptyFlow',
    kind: 'object',
    interfaces: [Flow]
  };
  var EmptyFlow_instance;
  function EmptyFlow_getInstance() {
    if (EmptyFlow_instance == null)
      new EmptyFlow();
    return EmptyFlow_instance;
  }
  function $collect_2COROUTINE$3(_this_, collector, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__1 = _this_;
    this._collector = collector;
  }
  $collect_2COROUTINE$3.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._tmp0_iterator_1_70 = this.__this__1._$this_asFlow.iterator_67();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator_1_70.hasNext_33()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._element_2_81 = this._tmp0_iterator_1_70.next_37();
            this._state_1 = 2;
            suspendResult = this._collector.emit_8(this._element_2_81, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $collect_2COROUTINE$3.$metadata$ = {
    simpleName: '$collect_2COROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_7($this_asFlow) {
    this._$this_asFlow = $this_asFlow;
  }
  _no_name_provided__1_7.prototype.collect_2 = function (collector, $cont) {
    var tmp = new $collect_2COROUTINE$3(this, collector, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__1_7.prototype.collect_6 = function (collector, $cont) {
    return this.collect_2(collector, $cont);
  };
  _no_name_provided__1_7.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Flow]
  };
  function emitAll(_this_, channel, $cont) {
    return emitAllImpl(_this_, channel, true, $cont);
  }
  function emitAllImpl(_this_, channel, consume, $cont) {
    var tmp = new $emitAllImplCOROUTINE$4(_this_, channel, consume, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function $emitAllImplCOROUTINE$4(_this_, channel, consume, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__2 = _this_;
    this._channel_0 = channel;
    this._consume = consume;
  }
  $emitAllImplCOROUTINE$4.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._cause0 = null;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 9;
            this._exceptionState = 8;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (false) {
              this._state_1 = 7;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = this._channel_0.receiveOrClosed_7(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._unboxed2 = suspendResult._holder;
            suspendResult = this._unboxed2;
            this._state_1 = 4;
            continue $sm;
          case 4:
            this._result3 = suspendResult;
            if (_ValueOrClosed___get_isClosed__impl_(this._result3)) {
              var tmp0_safe_receiver = _ValueOrClosed___get_closeCause__impl_(this._result3);
              if (tmp0_safe_receiver == null)
                null;
              else {
                throw tmp0_safe_receiver;
              }
              Unit_getInstance();
              this._state_1 = 7;
              continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._state_1 = 6;
            suspendResult = this.__this__2.emit_8(_ValueOrClosed___get_value__impl_(this._result3), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 7:
            this._tmp$ret$01 = Unit_getInstance();
            this._exceptionState = 10;
            this._state_1 = 11;
            continue $sm;
          case 8:
            this._exceptionState = 9;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              var tmp_1 = this;
              this._cause0 = e;
              throw e;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 9:
            this._exceptionState = 10;
            var t = this._exception_0;
            if (this._consume)
              cancelConsumed(this._channel_0, this._cause0);
            throw t;
          case 10:
            throw this._exception_0;
          case 11:
            if (this._consume)
              cancelConsumed(this._channel_0, this._cause0);
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $emitAllImplCOROUTINE$4.$metadata$ = {
    simpleName: '$emitAllImplCOROUTINE$4',
    kind: 'class',
    interfaces: []
  };
  function Flow() {
  }
  Flow.$metadata$ = {
    simpleName: 'Flow',
    kind: 'interface',
    interfaces: []
  };
  function $collectCOROUTINE$5(_this_, collector, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__3 = _this_;
    this._collector_0 = collector;
  }
  $collectCOROUTINE$5.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            var tmp_0 = this;
            tmp_0._safeCollector0 = new SafeCollector(this._collector_0, this._get_context__296());
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 4;
            this._state_1 = 2;
            suspendResult = this.__this__3.collectSafely_0(this._safeCollector0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._tmp$ret$01_0 = suspendResult;
            this._exceptionState = 5;
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._safeCollector0.releaseIntercepted();
            return Unit_getInstance();
          case 4:
            this._exceptionState = 5;
            var t = this._exception_0;
            this._safeCollector0.releaseIntercepted();
            throw t;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $collectCOROUTINE$5.$metadata$ = {
    simpleName: '$collectCOROUTINE$5',
    kind: 'class',
    interfaces: []
  };
  function AbstractFlow() {
  }
  AbstractFlow.prototype.collect_6 = function (collector, $cont) {
    var tmp = new $collectCOROUTINE$5(this, collector, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AbstractFlow.$metadata$ = {
    simpleName: 'AbstractFlow',
    kind: 'class',
    interfaces: [Flow, CancellableFlow]
  };
  function FlowCollector() {
  }
  FlowCollector.$metadata$ = {
    simpleName: 'FlowCollector',
    kind: 'interface',
    interfaces: []
  };
  function checkOwnership(_this_, owner) {
    if (!(_this_._owner === owner))
      throw _this_;
  }
  function checkContext(_this_, currentContext) {
    var result = currentContext.fold_34(0, _no_name_provided_$factory_44(_this_));
    if (!(result === _this_._collectContextSize)) {
      var tmp0_error_0 = 'Flow invariant is violated:\n' + ('' + '\t\tFlow was collected in ' + _this_._collectContext + ',\n') + ('' + '\t\tbut emission happened in ' + currentContext + '.\n') + "\t\tPlease refer to 'flow' documentation or use 'flowOn' instead";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }}
  function transitiveCoroutineParent(_this_, collectJob) {
    var $this = _this_;
    var collectJob_0 = collectJob;
    while (true) {
      var $this_0 = $this;
      var collectJob_1 = collectJob_0;
      if ($this_0 === null)
        return null;
      if ($this_0 === collectJob_1)
        return $this_0;
      if (!($this_0 instanceof ScopeCoroutine))
        return $this_0;
      else {
      }
      $this = $this_0._get_parent__14();
      collectJob_0 = collectJob_1;
      continue;
    }
  }
  function _no_name_provided__62($this_checkContext) {
    this._$this_checkContext = $this_checkContext;
  }
  _no_name_provided__62.prototype.invoke_121 = function (count_0, element) {
    var key = element._get_key__37();
    var collectElement = this._$this_checkContext._collectContext.get_113(key);
    if (!(key === Key_getInstance_2())) {
      return !(element === collectElement) ? IntCompanionObject_getInstance()._MIN_VALUE_4 : count_0 + 1 | 0;
    }var collectJob = (collectElement == null ? true : isInterface(collectElement, Job)) ? collectElement : THROW_CCE();
    var emissionParentJob = transitiveCoroutineParent(isInterface(element, Job) ? element : THROW_CCE(), collectJob);
    if (!(emissionParentJob === collectJob)) {
      var tmp0_error_0 = 'Flow invariant is violated:\n\t\tEmission from another coroutine is detected.\n' + ('' + '\t\tChild of ' + emissionParentJob + ', expected child of ' + collectJob + '.\n') + '\t\tFlowCollector is not thread-safe and concurrent emissions are prohibited.\n' + "\t\tTo mitigate this restriction please use 'channelFlow' builder instead of 'flow'";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }return collectJob == null ? count_0 : count_0 + 1 | 0;
  };
  _no_name_provided__62.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_121(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__62.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_44($this_checkContext) {
    var i = new _no_name_provided__62($this_checkContext);
    return function (p1, p2) {
      return i.invoke_121(p1, p2);
    };
  }
  function CancellableFlow() {
  }
  CancellableFlow.$metadata$ = {
    simpleName: 'CancellableFlow',
    kind: 'interface',
    interfaces: [Flow]
  };
  function toList_5(_this_, destination, $cont) {
    return toCollection_2(_this_, destination, $cont);
  }
  function toList$default(_this_, destination, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      destination = ArrayList_init_$Create$();
    return toList_5(_this_, destination, $cont);
  }
  function toCollection_2(_this_, destination, $cont) {
    var tmp = new $toCollectionCOROUTINE$11(_this_, destination, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function _no_name_provided__1_8($destination) {
    this._$destination = $destination;
  }
  _no_name_provided__1_8.prototype.emit_2 = function (value, $cont) {
    this._$destination.add_39(value);
    return Unit_getInstance();
  };
  _no_name_provided__1_8.prototype.emit_8 = function (value, $cont) {
    return this.emit_2((value == null ? true : isObject(value)) ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__1_8.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function $toCollectionCOROUTINE$11(_this_, destination, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__4 = _this_;
    this._destination = destination;
  }
  $toCollectionCOROUTINE$11.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__4.collect_6(new _no_name_provided__1_8(this._destination), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return this._destination;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $toCollectionCOROUTINE$11.$metadata$ = {
    simpleName: '$toCollectionCOROUTINE$11',
    kind: 'class',
    interfaces: []
  };
  function firstOrNull_1(_this_, $cont) {
    var tmp = new $firstOrNullCOROUTINE$12(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function _no_name_provided__2_0($result) {
    this._$result = $result;
  }
  _no_name_provided__2_0.prototype.emit_3 = function (value, $cont) {
    this._$result._v = value;
    if (!false) {
      throw new AbortFlowException(this);
    } else {
    }
  };
  _no_name_provided__2_0.prototype.emit_8 = function (value, $cont) {
    return this.emit_3((value == null ? true : isObject(value)) ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__2_0.$metadata$ = {
    simpleName: '<no name provided>_2',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function $firstOrNullCOROUTINE$12(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__5 = _this_;
  }
  $firstOrNullCOROUTINE$12.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._result0 = {_v: null};
            var tmp_0 = this;
            tmp_0._collector_11 = new _no_name_provided__2_0(this._result0);
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__5.collect_6(this._collector_11, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._exceptionState = 4;
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._exceptionState = 4;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof AbortFlowException) {
              var e_7 = this._exception_0;
              checkOwnership(e_7, this._collector_11);
              this._state_1 = 3;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            this._exceptionState = 4;
            return this._result0._v;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $firstOrNullCOROUTINE$12.$metadata$ = {
    simpleName: '$firstOrNullCOROUTINE$12',
    kind: 'class',
    interfaces: []
  };
  function ensureCapacity_0($this) {
    var currentSize = $this._elements.length;
    var newCapacity = currentSize << 1;
    var newElements = fillArrayVal(Array(newCapacity), null);
    var tmp0_copyInto_0 = $this._elements;
    var tmp1_copyInto_0 = $this._head_1;
    var tmp2_copyInto_0 = 0;
    var tmp3_copyInto_0 = tmp0_copyInto_0.length;
    arrayCopy_0(tmp0_copyInto_0, newElements, tmp2_copyInto_0, tmp1_copyInto_0, tmp3_copyInto_0);
    Unit_getInstance();
    var tmp4_copyInto_0 = $this._elements;
    var tmp5_copyInto_0 = $this._elements.length - $this._head_1 | 0;
    var tmp6_copyInto_0 = $this._head_1;
    var tmp7_copyInto_0 = 0;
    arrayCopy_0(tmp4_copyInto_0, newElements, tmp5_copyInto_0, tmp7_copyInto_0, tmp6_copyInto_0);
    Unit_getInstance();
    $this._elements = newElements;
    $this._head_1 = 0;
    $this._tail = currentSize;
  }
  function ArrayQueue() {
    var tmp = this;
    var tmp0_arrayOfNulls_0 = 16;
    tmp._elements = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._head_1 = 0;
    this._tail = 0;
  }
  ArrayQueue.prototype._get_isEmpty__2 = function () {
    return this._head_1 === this._tail;
  };
  ArrayQueue.prototype.addLast_20 = function (element) {
    this._elements[this._tail] = element;
    this._tail = (this._tail + 1 | 0) & (this._elements.length - 1 | 0);
    if (this._tail === this._head_1)
      ensureCapacity_0(this);
  };
  ArrayQueue.prototype.removeFirstOrNull_2 = function () {
    if (this._head_1 === this._tail)
      return null;
    var element = this._elements[this._head_1];
    this._elements[this._head_1] = null;
    this._head_1 = (this._head_1 + 1 | 0) & (this._elements.length - 1 | 0);
    return isObject(element) ? element : THROW_CCE();
  };
  ArrayQueue.$metadata$ = {
    simpleName: 'ArrayQueue',
    kind: 'class',
    interfaces: []
  };
  function OpDescriptor() {
  }
  OpDescriptor.$metadata$ = {
    simpleName: 'OpDescriptor',
    kind: 'class',
    interfaces: []
  };
  var UNDEFINED;
  var REUSABLE_CLAIMED;
  function resumeCancellableWith(_this_, result, onCancellation) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof DispatchedContinuation) {
      var tmp2_resumeCancellableWith_0 = _this_;
      var state_1 = toState_0(result, onCancellation);
      var tmp_0;
      if (tmp2_resumeCancellableWith_0._dispatcher.isDispatchNeeded_9(tmp2_resumeCancellableWith_0._get_context__296())) {
        tmp2_resumeCancellableWith_0.__state_1 = state_1;
        tmp2_resumeCancellableWith_0._set_resumeMode__0(1);
        tmp_0 = tmp2_resumeCancellableWith_0._dispatcher.dispatch_12(tmp2_resumeCancellableWith_0._get_context__296(), tmp2_resumeCancellableWith_0);
      } else {
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_executeUnconfined_0 = 1;
          var tmp1_executeUnconfined_0 = false;
          var eventLoop_2 = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
          if (tmp1_executeUnconfined_0 ? eventLoop_2._get_isUnconfinedQueueEmpty__0() : false) {
            tmp$ret$0 = false;
            break l$ret$1;
          }var tmp_1;
          if (eventLoop_2._get_isUnconfinedLoopActive__0()) {
            tmp2_resumeCancellableWith_0.__state_1 = state_1;
            tmp2_resumeCancellableWith_0._set_resumeMode__0(tmp0_executeUnconfined_0);
            eventLoop_2.dispatchUnconfined_0(tmp2_resumeCancellableWith_0);
            tmp_1 = true;
          } else {
            eventLoop_2.incrementUseCount_0(true);
            try {
              var tmp$ret$2;
              l$ret$3: do {
                var job_1_4 = tmp2_resumeCancellableWith_0._get_context__296().get_113(Key_getInstance_2());
                if (!(job_1_4 == null) ? !job_1_4._get_isActive__29() : false) {
                  var cause_2_5 = job_1_4.getCancellationException_14();
                  tmp2_resumeCancellableWith_0.cancelCompletedResult_2(state_1, cause_2_5);
                  var tmp0_failure_0_1_6 = Companion_getInstance_2();
                  tmp2_resumeCancellableWith_0.resumeWith_196(_Result___init__impl_(createFailure(cause_2_5)));
                  tmp$ret$2 = true;
                  break l$ret$3;
                }tmp$ret$2 = false;
              }
               while (false);
              if (!tmp$ret$2) {
                var tmp0_withContinuationContext_0_7 = tmp2_resumeCancellableWith_0._continuation_3;
                var tmp1_withContinuationContext_0_8 = tmp2_resumeCancellableWith_0._countOrElement;
                tmp2_resumeCancellableWith_0._continuation_3.resumeWith_196(result);
              } else {
              }
              $l$break: while (true) {
                if (!eventLoop_2.processUnconfinedEvent_0())
                  break $l$break;
              }
            } catch ($p) {
              if ($p instanceof Error) {
                tmp2_resumeCancellableWith_0.handleFatalException_2($p, null);
              } else {
                {
                  throw $p;
                }
              }
            }
            finally {
              eventLoop_2.decrementUseCount_0(true);
            }
            tmp_1 = false;
          }
          tmp$ret$0 = tmp_1;
        }
         while (false);
        tmp_0 = Unit_getInstance();
      }
      tmp = tmp_0;
    } else {
      {
        tmp = _this_.resumeWith_196(result);
      }
    }
    return tmp;
  }
  function resumeCancellableWith$default(_this_, result, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      onCancellation = null;
    return resumeCancellableWith(_this_, result, onCancellation);
  }
  function DispatchedContinuation(dispatcher, continuation) {
    DispatchedTask.call(this, -1);
    this._dispatcher = dispatcher;
    this._continuation_3 = continuation;
    this.__state_1 = UNDEFINED;
    this._countOrElement = threadContextElements(this._get_context__296());
    this.__reusableCancellableContinuation = atomic(null);
  }
  DispatchedContinuation.prototype._get_context__296 = function () {
    return this._continuation_3._get_context__296();
  };
  DispatchedContinuation.prototype._get_reusableCancellableContinuation_ = function () {
    var tmp = this.__reusableCancellableContinuation._value_4;
    return tmp instanceof CancellableContinuationImpl ? tmp : null;
  };
  DispatchedContinuation.prototype.isReusable = function (requester) {
    var tmp0_elvis_lhs = this.__reusableCancellableContinuation._value_4;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    if (value instanceof CancellableContinuationImpl)
      return value === requester;
    else {
    }
    return true;
  };
  DispatchedContinuation.prototype.claimReusableCancellableContinuation = function () {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_4;
      if (tmp1__anonymous__1 === null) {
        this.__reusableCancellableContinuation._value_4 = REUSABLE_CLAIMED;
        return null;
      } else {
        if (tmp1__anonymous__1 instanceof CancellableContinuationImpl) {
          if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(tmp1__anonymous__1, REUSABLE_CLAIMED)) {
            return tmp1__anonymous__1 instanceof CancellableContinuationImpl ? tmp1__anonymous__1 : THROW_CCE();
          }} else {
          {
            var tmp0_error_0_2 = '' + 'Inconsistent state ' + tmp1__anonymous__1;
            throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_2));
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.checkPostponedCancellation = function (continuation) {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_4;
      if (tmp1__anonymous__1 === REUSABLE_CLAIMED) {
        if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(REUSABLE_CLAIMED, continuation))
          return null;
      } else {
        if (tmp1__anonymous__1 === null)
          return null;
        else {
          if (tmp1__anonymous__1 instanceof Error) {
            var tmp0_require_0_2 = this.__reusableCancellableContinuation.atomicfu$compareAndSet(tmp1__anonymous__1, null);
            if (!tmp0_require_0_2) {
              var message_2_1_3 = 'Failed requirement.';
              throw IllegalArgumentException_init_$Create$(toString_1(message_2_1_3));
            }return tmp1__anonymous__1;
          } else {
            {
              var tmp1_error_0_4 = '' + 'Inconsistent state ' + tmp1__anonymous__1;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0_4));
            }
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.postponeCancellation = function (cause) {
    var tmp0_loop_0 = this.__reusableCancellableContinuation;
    while (true) {
      var tmp1__anonymous__1 = tmp0_loop_0._value_4;
      var tmp0_subject_2 = tmp1__anonymous__1;
      if (equals_1(tmp0_subject_2, REUSABLE_CLAIMED)) {
        if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(REUSABLE_CLAIMED, cause))
          return true;
      } else {
        if (tmp0_subject_2 instanceof Error)
          return true;
        else {
          {
            if (this.__reusableCancellableContinuation.atomicfu$compareAndSet(tmp1__anonymous__1, null))
              return false;
          }
        }
      }
    }
    Unit_getInstance();
  };
  DispatchedContinuation.prototype.takeState_2 = function () {
    var state = this.__state_1;
    this.__state_1 = UNDEFINED;
    return state;
  };
  DispatchedContinuation.prototype._get_delegate__2 = function () {
    return this;
  };
  DispatchedContinuation.prototype.resumeWith_196 = function (result) {
    var context = this._continuation_3._get_context__296();
    var state = toState$default(result, null, 1, null);
    if (this._dispatcher.isDispatchNeeded_9(context)) {
      this.__state_1 = state;
      this._set_resumeMode__0(0);
      this._dispatcher.dispatch_12(context, this);
    } else {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_executeUnconfined_0 = 0;
        var tmp1_executeUnconfined_0 = false;
        var eventLoop_2 = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
        if (tmp1_executeUnconfined_0 ? eventLoop_2._get_isUnconfinedQueueEmpty__0() : false) {
          tmp$ret$0 = false;
          break l$ret$1;
        }var tmp;
        if (eventLoop_2._get_isUnconfinedLoopActive__0()) {
          this.__state_1 = state;
          this._set_resumeMode__0(tmp0_executeUnconfined_0);
          eventLoop_2.dispatchUnconfined_0(this);
          tmp = true;
        } else {
          eventLoop_2.incrementUseCount_0(true);
          try {
            var tmp0_withCoroutineContext_0_4 = this._get_context__296();
            var tmp1_withCoroutineContext_0_5 = this._countOrElement;
            this._continuation_3.resumeWith_196(result);
            $l$break: while (true) {
              if (!eventLoop_2.processUnconfinedEvent_0())
                break $l$break;
            }
          } catch ($p) {
            if ($p instanceof Error) {
              this.handleFatalException_2($p, null);
            } else {
              {
                throw $p;
              }
            }
          }
          finally {
            eventLoop_2.decrementUseCount_0(true);
          }
          tmp = false;
        }
        tmp$ret$0 = tmp;
      }
       while (false);
      Unit_getInstance();
    }
  };
  DispatchedContinuation.prototype.cancelCompletedResult_2 = function (takenState, cause) {
    if (takenState instanceof CompletedWithCancellation) {
      takenState._onCancellation_0(cause);
    } else {
    }
  };
  DispatchedContinuation.prototype.toString = function () {
    return '' + 'DispatchedContinuation[' + this._dispatcher + ', ' + toDebugString(this._continuation_3) + ']';
  };
  DispatchedContinuation.$metadata$ = {
    simpleName: 'DispatchedContinuation',
    kind: 'class',
    interfaces: [CoroutineStackFrame, Continuation]
  };
  function DispatchedTask(resumeMode) {
    SchedulerTask.call(this);
    this._resumeMode = resumeMode;
  }
  DispatchedTask.prototype._set_resumeMode__0 = function (_set___) {
    this._resumeMode = _set___;
  };
  DispatchedTask.prototype._get_resumeMode__1 = function () {
    return this._resumeMode;
  };
  DispatchedTask.prototype.cancelCompletedResult_2 = function (takenState, cause) {
  };
  DispatchedTask.prototype.getSuccessfulResult_2 = function (state) {
    return (state == null ? true : isObject(state)) ? state : THROW_CCE();
  };
  DispatchedTask.prototype.getExceptionalResult_2 = function (state) {
    var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._cause;
  };
  DispatchedTask.prototype.run_5 = function () {
    var taskContext = _get_taskContext_(this);
    var fatalException = null;
    try {
      var tmp = this._get_delegate__2();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate._continuation_3;
      var tmp0_withContinuationContext_0 = delegate._countOrElement;
      var context_2 = continuation._get_context__296();
      var state_3 = this.takeState_2();
      var exception_4 = this.getExceptionalResult_2(state_3);
      var job_5 = (exception_4 == null ? _get_isCancellableMode_(this._resumeMode) : false) ? context_2.get_113(Key_getInstance_2()) : null;
      if (!(job_5 == null) ? !job_5._get_isActive__29() : false) {
        var cause_6 = job_5.getCancellationException_14();
        this.cancelCompletedResult_2(state_3, cause_6);
        var tmp0_failure_0_7 = Companion_getInstance_2();
        var tmp1_failure_0_8 = recoverStackTrace(cause_6, continuation);
        continuation.resumeWith_196(_Result___init__impl_(createFailure(tmp1_failure_0_8)));
      } else {
        if (!(exception_4 == null)) {
          var tmp0_failure_0_1_9 = Companion_getInstance_2();
          continuation.resumeWith_196(_Result___init__impl_(createFailure(exception_4)));
        } else {
          var tmp2_resume_0_10 = this.getSuccessfulResult_2(state_3);
          var tmp0_success_0_1_11 = Companion_getInstance_2();
          continuation.resumeWith_196(_Result___init__impl_(tmp2_resume_0_10));
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        fatalException = $p;
      } else {
        {
          throw $p;
        }
      }
    }
    finally {
      var tmp_0;
      try {
        var tmp0_success_0_1 = Companion_getInstance_2();
        var tmp1_success_0_2 = Unit_getInstance();
        tmp_0 = _Result___init__impl_(Unit_getInstance());
      } catch ($p_0) {
        var tmp_1;
        if ($p_0 instanceof Error) {
          var tmp2_failure_0_4 = Companion_getInstance_2();
          tmp_1 = _Result___init__impl_(createFailure($p_0));
        } else {
          {
            throw $p_0;
          }
        }
        tmp_0 = tmp_1;
      }
      var result = tmp_0;
      this.handleFatalException_2(fatalException, Result__exceptionOrNull_impl(result));
    }
  };
  DispatchedTask.prototype.handleFatalException_2 = function (exception, finallyException) {
    if (exception === null ? finallyException === null : false)
      return Unit_getInstance();
    if (!(exception === null) ? !(finallyException === null) : false) {
    }var tmp0_elvis_lhs = exception;
    var cause = tmp0_elvis_lhs == null ? finallyException : tmp0_elvis_lhs;
    var reason = new CoroutinesInternalError('' + 'Fatal exception in coroutines machinery for ' + this + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", ensureNotNull(cause));
    handleCoroutineException(this._get_delegate__2()._get_context__296(), reason);
  };
  DispatchedTask.$metadata$ = {
    simpleName: 'DispatchedTask',
    kind: 'class',
    interfaces: []
  };
  function _get_isReusableMode_(_this_) {
    return _this_ === 2;
  }
  function _get_isCancellableMode_(_this_) {
    return _this_ === 1 ? true : _this_ === 2;
  }
  function dispatch(_this_, mode) {
    var delegate = _this_._get_delegate__2();
    var undispatched = mode === 4;
    var tmp;
    var tmp_0;
    if (!undispatched) {
      tmp_0 = delegate instanceof DispatchedContinuation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = _get_isCancellableMode_(mode) === _get_isCancellableMode_(_this_._resumeMode);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var dispatcher = delegate._dispatcher;
      var context = delegate._get_context__296();
      if (dispatcher.isDispatchNeeded_9(context)) {
        dispatcher.dispatch_12(context, _this_);
      } else {
        resumeUnconfined(_this_);
      }
    } else {
      {
        resume(_this_, delegate, undispatched);
      }
    }
  }
  function resumeUnconfined(_this_) {
    var eventLoop = ThreadLocalEventLoop_getInstance()._get_eventLoop_();
    if (eventLoop._get_isUnconfinedLoopActive__0()) {
      eventLoop.dispatchUnconfined_0(_this_);
    } else {
      eventLoop.incrementUseCount_0(true);
      try {
        resume(_this_, _this_._get_delegate__2(), true);
        $l$break: while (true) {
          if (!eventLoop.processUnconfinedEvent_0())
            break $l$break;
        }
      } catch ($p) {
        if ($p instanceof Error) {
          _this_.handleFatalException_2($p, null);
        } else {
          {
            throw $p;
          }
        }
      }
      finally {
        eventLoop.decrementUseCount_0(true);
      }
    }
  }
  function resume(_this_, delegate, undispatched) {
    var state = _this_.takeState_2();
    var exception = _this_.getExceptionalResult_2(state);
    var tmp;
    if (!(exception == null)) {
      var tmp0_failure_0 = Companion_getInstance_2();
      tmp = _Result___init__impl_(createFailure(exception));
    } else {
      var tmp1_success_0 = Companion_getInstance_2();
      var tmp2_success_0 = _this_.getSuccessfulResult_2(state);
      tmp = _Result___init__impl_(tmp2_success_0);
    }
    var result = tmp;
    if (undispatched) {
      var tmp3_resumeUndispatchedWith_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
      var tmp0_withContinuationContext_0_1 = tmp3_resumeUndispatchedWith_0._continuation_3;
      var tmp1_withContinuationContext_0_2 = tmp3_resumeUndispatchedWith_0._countOrElement;
      tmp3_resumeUndispatchedWith_0._continuation_3.resumeWith_196(result);
    } else
      delegate.resumeWith_196(result);
  }
  function _InlineList___init__impl_(holder) {
    return holder;
  }
  function _InlineList___init__impl__0(holder, $mask0, $marker) {
    if (!(($mask0 & 1) === 0))
      holder = null;
    var tmp = _InlineList___init__impl_(holder);
    return tmp;
  }
  function _get_holder__0($this) {
    return $this;
  }
  function InlineList__plus_impl(this_0, element) {
    var tmp0_subject = _get_holder__0(this_0);
    var tmp;
    if (tmp0_subject == null) {
      tmp = _InlineList___init__impl_(element);
    } else {
      if (tmp0_subject instanceof ArrayList) {
        var tmp_0 = _get_holder__0(this_0);
        (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).add_39(element);
        Unit_getInstance();
        tmp = _InlineList___init__impl_(_get_holder__0(this_0));
      } else {
        {
          var list = ArrayList_init_$Create$_0(4);
          var tmp_1 = _get_holder__0(this_0);
          list.add_39((tmp_1 == null ? true : isObject(tmp_1)) ? tmp_1 : THROW_CCE());
          Unit_getInstance();
          list.add_39(element);
          Unit_getInstance();
          tmp = _InlineList___init__impl_(list);
        }
      }
    }
    return tmp;
  }
  function bindCancellationFun(_this_, element, context) {
    return _no_name_provided_$factory_45(_this_, element, context);
  }
  function UndeliveredElementException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, UndeliveredElementException);
  }
  UndeliveredElementException.$metadata$ = {
    simpleName: 'UndeliveredElementException',
    kind: 'class',
    interfaces: []
  };
  function callUndeliveredElementCatchingException(_this_, element, undeliveredElementException) {
    try {
      _this_(element);
    } catch ($p) {
      if ($p instanceof Error) {
        if (!(undeliveredElementException == null) ? !(undeliveredElementException.cause === $p) : false) {
        } else {
          return new UndeliveredElementException('' + 'Exception in undelivered element handler for ' + element, $p);
        }
      } else {
        {
          throw $p;
        }
      }
    }
    return undeliveredElementException;
  }
  function callUndeliveredElementCatchingException$default(_this_, element, undeliveredElementException, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      undeliveredElementException = null;
    return callUndeliveredElementCatchingException(_this_, element, undeliveredElementException);
  }
  function callUndeliveredElement(_this_, element, context) {
    var tmp0_safe_receiver = callUndeliveredElementCatchingException(_this_, element, null);
    if (tmp0_safe_receiver == null)
      null;
    else {
      handleCoroutineException(context, tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
  }
  function _no_name_provided__63($this_bindCancellationFun, $element, $context) {
    this._$this_bindCancellationFun = $this_bindCancellationFun;
    this._$element = $element;
    this._$context = $context;
  }
  _no_name_provided__63.prototype.invoke_903 = function (_anonymous_parameter_0_) {
    callUndeliveredElement(this._$this_bindCancellationFun, this._$element, this._$context);
  };
  _no_name_provided__63.prototype.invoke_1015 = function (p1) {
    this.invoke_903(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__63.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_45($this_bindCancellationFun, $element, $context) {
    var i = new _no_name_provided__63($this_bindCancellationFun, $element, $context);
    return function (p1) {
      i.invoke_903(p1);
      return Unit_getInstance();
    };
  }
  function ContextScope(context) {
    this._coroutineContext = context;
  }
  ContextScope.prototype._get_coroutineContext__22 = function () {
    return this._coroutineContext;
  };
  ContextScope.prototype.toString = function () {
    return '' + 'CoroutineScope(coroutineContext=' + this._coroutineContext + ')';
  };
  ContextScope.$metadata$ = {
    simpleName: 'ContextScope',
    kind: 'class',
    interfaces: [CoroutineScope]
  };
  function ScopeCoroutine(context, uCont) {
    AbstractCoroutine.call(this, context, true);
    this._uCont = uCont;
  }
  ScopeCoroutine.prototype._get_uCont__2 = function () {
    return this._uCont;
  };
  ScopeCoroutine.prototype._get_isScopedCoroutine__13 = function () {
    return true;
  };
  ScopeCoroutine.prototype._get_parent__14 = function () {
    return this._get_parentContext__3().get_113(Key_getInstance_2());
  };
  ScopeCoroutine.prototype.afterCompletion_13 = function (state) {
    var tmp = intercepted(this._uCont);
    var tmp_0 = recoverResult(state, this._uCont);
    resumeCancellableWith$default(tmp, tmp_0, null, 2, null);
  };
  ScopeCoroutine.prototype.afterResume_9 = function (state) {
    this._uCont.resumeWith_196(recoverResult(state, this._uCont));
  };
  ScopeCoroutine.$metadata$ = {
    simpleName: 'ScopeCoroutine',
    kind: 'class',
    interfaces: [CoroutineStackFrame]
  };
  function Symbol(symbol) {
    this._symbol = symbol;
  }
  Symbol.prototype.toString = function () {
    return '' + '<' + this._symbol + '>';
  };
  Symbol.$metadata$ = {
    simpleName: 'Symbol',
    kind: 'class',
    interfaces: []
  };
  function systemProp(propertyName, defaultValue, minValue, maxValue) {
    return systemProp_0(propertyName, toLong(defaultValue), toLong(minValue), toLong(maxValue)).toInt_8();
  }
  function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
    var tmp0_elvis_lhs = systemProp_1(propertyName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return defaultValue;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp1_elvis_lhs = toLongOrNull(value);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp0_error_0 = '' + "System property '" + propertyName + "' has unrecognized value '" + value + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parsed = tmp_0;
    if (!(minValue.compareTo_137(parsed) <= 0 ? parsed.compareTo_137(maxValue) <= 0 : false)) {
      var tmp1_error_0 = '' + "System property '" + propertyName + "' should be in range " + minValue + '..' + maxValue + ", but is '" + parsed + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
    }return parsed;
  }
  function startCoroutineCancellable(_this_, receiver, completion, onCancellation) {
    var tmp;
    try {
      var tmp_0 = intercepted(createCoroutineUnintercepted(_this_, receiver, completion));
      var tmp0_success_0_3 = Companion_getInstance_2();
      var tmp1_success_0_4 = Unit_getInstance();
      tmp = resumeCancellableWith(tmp_0, _Result___init__impl_(Unit_getInstance()), onCancellation);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var tmp0_failure_0 = Companion_getInstance_2();
        tmp_1 = completion.resumeWith_196(_Result___init__impl_(createFailure($p)));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function startCoroutineCancellable$default(_this_, receiver, completion, onCancellation, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      onCancellation = null;
    return startCoroutineCancellable(_this_, receiver, completion, onCancellation);
  }
  function startCoroutineCancellable_0(_this_, fatalCompletion) {
    var tmp;
    try {
      var tmp_0 = intercepted(_this_);
      var tmp0_success_0_4 = Companion_getInstance_2();
      var tmp1_success_0_5 = Unit_getInstance();
      var tmp_1 = _Result___init__impl_(Unit_getInstance());
      tmp = resumeCancellableWith$default(tmp_0, tmp_1, null, 2, null);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var tmp0_failure_0_2 = Companion_getInstance_2();
        tmp_2 = fatalCompletion.resumeWith_196(_Result___init__impl_(createFailure($p)));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function startUndispatchedOrReturn(_this_, receiver, block) {
    _this_.initParentJob_9();
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      try {
        tmp = block(receiver, _this_);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp_1 = $p;
          tmp_0 = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var result_1 = tmp;
      if (result_1 === _get_COROUTINE_SUSPENDED_()) {
        tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
        break l$ret$1;
      }var state_3 = _this_.makeCompletingOnce_10(result_1);
      if (state_3 === COMPLETING_WAITING_CHILDREN) {
        tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
        break l$ret$1;
      }var tmp_2;
      if (state_3 instanceof CompletedExceptionally) {
        var tmp_3;
        var tmp0__anonymous__5 = state_3._cause;
        {
          throw recoverStackTrace(state_3._cause, _this_._uCont);
        }
        tmp_2 = tmp_3;
      } else {
        {
          tmp_2 = unboxState(state_3);
        }
      }
      tmp$ret$0 = tmp_2;
    }
     while (false);
    return tmp$ret$0;
  }
  function startCoroutineUndispatched(_this_, receiver, completion) {
    var tmp$ret$0;
    l$ret$1: do {
      var actualCompletion_1 = completion;
      var tmp;
      try {
        var tmp0_withCoroutineContext_0_8 = completion._get_context__296();
        var tmp1_withCoroutineContext_0_9 = null;
        tmp = _this_(receiver, actualCompletion_1);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp0_failure_0_1_4 = Companion_getInstance_2();
          actualCompletion_1.resumeWith_196(_Result___init__impl_(createFailure($p)));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var value_2 = tmp;
      if (!(value_2 === _get_COROUTINE_SUSPENDED_())) {
        var tmp0_resume_0_5 = (value_2 == null ? true : isObject(value_2)) ? value_2 : THROW_CCE();
        var tmp0_success_0_1_6 = Companion_getInstance_2();
        actualCompletion_1.resumeWith_196(_Result___init__impl_(tmp0_resume_0_5));
      }}
     while (false);
  }
  function startUndispatchedOrReturnIgnoreTimeout(_this_, receiver, block) {
    _this_.initParentJob_9();
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      try {
        tmp = block(receiver, _this_);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp_1 = $p;
          tmp_0 = CompletedExceptionally_init_$Create$(tmp_1, false, 2, null);
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var result_1 = tmp;
      if (result_1 === _get_COROUTINE_SUSPENDED_()) {
        tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
        break l$ret$1;
      }var state_3 = _this_.makeCompletingOnce_10(result_1);
      if (state_3 === COMPLETING_WAITING_CHILDREN) {
        tmp$ret$0 = _get_COROUTINE_SUSPENDED_();
        break l$ret$1;
      }var tmp_2;
      if (state_3 instanceof CompletedExceptionally) {
        var tmp_3;
        var tmp0__anonymous__5 = state_3._cause;
        var tmp_4;
        if (tmp0__anonymous__5 instanceof TimeoutCancellationException) {
          tmp_4 = tmp0__anonymous__5._coroutine === _this_;
        } else {
          {
            tmp_4 = false;
          }
        }
        if (!tmp_4) {
          throw recoverStackTrace(state_3._cause, _this_._uCont);
        } else {
          if (result_1 instanceof CompletedExceptionally) {
            throw recoverStackTrace(result_1._cause, _this_._uCont);
          } else {
            {
              tmp_3 = result_1;
            }
          }
        }
        tmp_2 = tmp_3;
      } else {
        {
          tmp_2 = unboxState(state_3);
        }
      }
      tmp$ret$0 = tmp_2;
    }
     while (false);
    return tmp$ret$0;
  }
  function SelectClause0() {
  }
  SelectClause0.$metadata$ = {
    simpleName: 'SelectClause0',
    kind: 'interface',
    interfaces: []
  };
  function SelectClause1() {
  }
  SelectClause1.$metadata$ = {
    simpleName: 'SelectClause1',
    kind: 'interface',
    interfaces: []
  };
  function CompletionHandlerBase() {
    LinkedListNode.call(this);
  }
  CompletionHandlerBase.$metadata$ = {
    simpleName: 'CompletionHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function invokeIt(_this_, cause) {
    var tmp0_subject = typeof _this_;
    if (tmp0_subject === 'function')
      _this_(cause);
    else {
      _this_.invoke(cause);
    }
  }
  function CancelHandlerBase() {
  }
  CancelHandlerBase.$metadata$ = {
    simpleName: 'CancelHandlerBase',
    kind: 'class',
    interfaces: []
  };
  function toDebugString(_this_) {
    return toString_1(_this_);
  }
  function newCoroutineContext(_this_, context) {
    var combined = _this_._get_coroutineContext__22().plus_36(context);
    return (!(combined === Dispatchers_getInstance()._Default) ? combined.get_113(Key_getInstance()) == null : false) ? combined.plus_36(Dispatchers_getInstance()._Default) : combined;
  }
  function UndispatchedCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
  }
  UndispatchedCoroutine.prototype.afterResume_9 = function (state) {
    return this._get_uCont__2().resumeWith_196(recoverResult(state, this._get_uCont__2()));
  };
  UndispatchedCoroutine.$metadata$ = {
    simpleName: 'UndispatchedCoroutine',
    kind: 'class',
    interfaces: []
  };
  function _get_coroutineName_(_this_) {
    return null;
  }
  function _get_DefaultDelay_() {
    var tmp = Dispatchers_getInstance()._Default;
    return isInterface(tmp, Delay) ? tmp : THROW_CCE();
  }
  function createDefaultDispatcher() {
    var tmp;
    if ((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.product == 'ReactNative' : false) {
      tmp = NodeDispatcher_getInstance();
    } else {
      if (isJsdom()) {
        tmp = NodeDispatcher_getInstance();
      } else {
        var tmp_0;
        var tmp_1;
        if (!(typeof window === 'undefined')) {
          var tmp0_asDynamic_0 = window;
          tmp_1 = tmp0_asDynamic_0 != null;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var tmp1_asDynamic_0 = window;
          tmp_0 = !(typeof tmp1_asDynamic_0.addEventListener === 'undefined');
        } else {
          {
            tmp_0 = false;
          }
        }
        if (tmp_0) {
          tmp = asCoroutineDispatcher(window);
        } else {
          if (typeof process === 'undefined') {
            tmp = SetTimeoutDispatcher_getInstance();
          } else {
            {
              tmp = NodeDispatcher_getInstance();
            }
          }
        }
      }
    }
    return tmp;
  }
  function isJsdom() {
    return ((((!(typeof navigator === 'undefined') ? navigator != null : false) ? navigator.userAgent != null : false) ? !(typeof navigator.userAgent === 'undefined') : false) ? !(typeof navigator.userAgent.match === 'undefined') : false) ? navigator.userAgent.match('\\bjsdom\\b') : false;
  }
  function handleCoroutineExceptionImpl(context, exception) {
    (function () {
      var $externalVarargReceiverTmp = console;
      return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].concat([exception]));
    }.call(this));
  }
  var counter;
  var DEBUG;
  function _get_classSimpleName_(_this_) {
    var tmp0_elvis_lhs = getKClassFromExpression_0(_this_)._get_simpleName__4();
    return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
  }
  function _get_hexAddress_(_this_) {
    var result = _this_.__debug_counter;
    if (!(typeof result === 'number')) {
      counter = counter + 1 | 0;
      result = counter;
      _this_.__debug_counter = result;
    }return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
  }
  function Dispatchers() {
    Dispatchers_instance = this;
    this._Default = createDefaultDispatcher();
    this._Main = new JsMainDispatcher(this._Default, false);
    this._Unconfined = Unconfined_getInstance();
  }
  Dispatchers.$metadata$ = {
    simpleName: 'Dispatchers',
    kind: 'object',
    interfaces: []
  };
  var Dispatchers_instance;
  function Dispatchers_getInstance() {
    if (Dispatchers_instance == null)
      new Dispatchers();
    return Dispatchers_instance;
  }
  function JsMainDispatcher(delegate, invokeImmediately) {
    MainCoroutineDispatcher.call(this);
    this._delegate_1 = delegate;
    this._invokeImmediately = invokeImmediately;
    this._immediate = this._invokeImmediately ? this : new JsMainDispatcher(this._delegate_1, true);
  }
  JsMainDispatcher.prototype._get_immediate__0 = function () {
    return this._immediate;
  };
  JsMainDispatcher.prototype.isDispatchNeeded_9 = function (context) {
    return !this._invokeImmediately;
  };
  JsMainDispatcher.prototype.dispatch_12 = function (context, block) {
    return this._delegate_1.dispatch_12(context, block);
  };
  JsMainDispatcher.prototype.toString = function () {
    var tmp0_elvis_lhs = this.toStringInternalImpl_0();
    return tmp0_elvis_lhs == null ? this._delegate_1.toString() : tmp0_elvis_lhs;
  };
  JsMainDispatcher.$metadata$ = {
    simpleName: 'JsMainDispatcher',
    kind: 'class',
    interfaces: []
  };
  function createEventLoop() {
    return new UnconfinedEventLoop();
  }
  function UnconfinedEventLoop() {
    EventLoop.call(this);
  }
  UnconfinedEventLoop.prototype.dispatch_12 = function (context, block) {
    unsupported();
  };
  UnconfinedEventLoop.$metadata$ = {
    simpleName: 'UnconfinedEventLoop',
    kind: 'class',
    interfaces: []
  };
  function unsupported() {
    throw UnsupportedOperationException_init_$Create$_0('runBlocking event loop is not supported');
  }
  function JobCancellationException(message, cause, job) {
    CancellationException_0.call(this, message, cause);
    this._job_1 = job;
    captureStack(this, JobCancellationException);
  }
  JobCancellationException.prototype.toString = function () {
    return '' + CancellationException_0.prototype.toString.call(this) + '; job=' + this._job_1;
  };
  JobCancellationException.prototype.equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        {
          tmp_2 = false;
        }
      }
      if (tmp_2) {
        tmp_1 = equals_1(other._job_1, this._job_1);
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp_0 = equals_1(other.cause, this.cause);
      } else {
        {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  JobCancellationException.prototype.hashCode = function () {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this._job_1) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  JobCancellationException.$metadata$ = {
    simpleName: 'JobCancellationException',
    kind: 'class',
    interfaces: []
  };
  function CancellationException_init_$Init$(message, $this) {
    CancellationException_0.call($this, message, null);
    return $this;
  }
  function CancellationException_init_$Create$(message) {
    var tmp = CancellationException_init_$Init$(message, Object.create(CancellationException_0.prototype));
    captureStack(tmp, CancellationException_init_$Create$);
    return tmp;
  }
  function CancellationException_0(message, cause) {
    IllegalStateException_init_$Init$_1(message, cause, this);
    captureStack(this, CancellationException_0);
  }
  CancellationException_0.$metadata$ = {
    simpleName: 'CancellationException',
    kind: 'class',
    interfaces: []
  };
  function NodeDispatcher() {
    NodeDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  NodeDispatcher.prototype.scheduleQueueProcessing_1 = function () {
    process.nextTick(this._get_messageQueue__1()._processQueue);
  };
  NodeDispatcher.$metadata$ = {
    simpleName: 'NodeDispatcher',
    kind: 'object',
    interfaces: []
  };
  var NodeDispatcher_instance;
  function NodeDispatcher_getInstance() {
    if (NodeDispatcher_instance == null)
      new NodeDispatcher();
    return NodeDispatcher_instance;
  }
  function SetTimeoutDispatcher() {
    SetTimeoutDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  SetTimeoutDispatcher.prototype.scheduleQueueProcessing_1 = function () {
    setTimeout(this._get_messageQueue__1()._processQueue, 0);
    Unit_getInstance();
  };
  SetTimeoutDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutDispatcher',
    kind: 'object',
    interfaces: []
  };
  var SetTimeoutDispatcher_instance;
  function SetTimeoutDispatcher_getInstance() {
    if (SetTimeoutDispatcher_instance == null)
      new SetTimeoutDispatcher();
    return SetTimeoutDispatcher_instance;
  }
  function _no_name_provided__64(this$0) {
    this._this$0_16 = this$0;
  }
  _no_name_provided__64.prototype.invoke_998 = function () {
    this._this$0_16.process_1();
  };
  _no_name_provided__64.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__64.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ScheduledMessageQueue($outer) {
    this._$this_6 = $outer;
    MessageQueue.call(this);
    var tmp = this;
    tmp._processQueue = _no_name_provided_$factory_46(this);
  }
  ScheduledMessageQueue.prototype.schedule_1 = function () {
    this._$this_6.scheduleQueueProcessing_1();
  };
  ScheduledMessageQueue.prototype.reschedule_1 = function () {
    setTimeout(this._processQueue, 0);
    Unit_getInstance();
  };
  ScheduledMessageQueue.$metadata$ = {
    simpleName: 'ScheduledMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__65($block) {
    this._$block_0 = $block;
  }
  _no_name_provided__65.prototype.invoke_998 = function () {
    this._$block_0.run_5();
  };
  _no_name_provided__65.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__65.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__66($continuation, this$0) {
    this._$continuation = $continuation;
    this._this$0_17 = this$0;
  }
  _no_name_provided__66.prototype.invoke_998 = function () {
    this._$continuation.resumeUndispatched_1(this._this$0_17, Unit_getInstance());
  };
  _no_name_provided__66.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__66.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SetTimeoutBasedDispatcher() {
    CoroutineDispatcher.call(this);
    this._messageQueue = new ScheduledMessageQueue(this);
  }
  SetTimeoutBasedDispatcher.prototype._get_messageQueue__1 = function () {
    return this._messageQueue;
  };
  SetTimeoutBasedDispatcher.prototype.dispatch_12 = function (context, block) {
    this._messageQueue.enqueue_2(block);
  };
  SetTimeoutBasedDispatcher.prototype.invokeOnTimeout_5 = function (timeMillis, block, context) {
    var handle = setTimeout(_no_name_provided_$factory_47(block), delayToInt(timeMillis));
    return new ClearTimeout(handle);
  };
  SetTimeoutBasedDispatcher.prototype.scheduleResumeAfterDelay_5 = function (timeMillis, continuation) {
    var handle = setTimeout(_no_name_provided_$factory_48(continuation, this), delayToInt(timeMillis));
    var tmp0__get_asHandler__0 = new ClearTimeout(handle);
    continuation.invokeOnCancellation_1(tmp0__get_asHandler__0);
  };
  SetTimeoutBasedDispatcher.$metadata$ = {
    simpleName: 'SetTimeoutBasedDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function MessageQueue() {
    ArrayQueue.call(this);
    this._yieldEvery = 16;
    this._scheduled = false;
  }
  MessageQueue.prototype.enqueue_2 = function (element) {
    this.addLast_20(element);
    if (!this._scheduled) {
      this._scheduled = true;
      this.schedule_1();
    }};
  MessageQueue.prototype.process_1 = function () {
    try {
      var tmp0_repeat_0 = this._yieldEvery;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_repeat_0)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_elvis_lhs_5 = this.removeFirstOrNull_2();
          var tmp;
          if (tmp0_elvis_lhs_5 == null) {
            return Unit_getInstance();
          } else {
            tmp = tmp0_elvis_lhs_5;
          }
          var element_4 = tmp;
          element_4.run_5();
        }
         while (inductionVariable < tmp0_repeat_0);
    }finally {
      if (this._get_isEmpty__2()) {
        this._scheduled = false;
      } else {
        this.reschedule_1();
      }
    }
  };
  MessageQueue.$metadata$ = {
    simpleName: 'MessageQueue',
    kind: 'class',
    interfaces: []
  };
  function delayToInt(timeMillis) {
    return coerceIn_0(timeMillis, new Long(0, 0), new Long(2147483647, 0)).toInt_8();
  }
  function ClearTimeout(handle) {
    CancelHandler.call(this);
    this._handle_1 = handle;
  }
  ClearTimeout.prototype.dispose_18 = function () {
    clearTimeout(this._handle_1);
  };
  ClearTimeout.prototype.invoke_725 = function (cause) {
    this.dispose_18();
  };
  ClearTimeout.prototype.invoke = function (cause) {
    return this.invoke_725(cause);
  };
  ClearTimeout.prototype.toString = function () {
    return '' + 'ClearTimeout[' + this._handle_1 + ']';
  };
  ClearTimeout.$metadata$ = {
    simpleName: 'ClearTimeout',
    kind: 'class',
    interfaces: [DisposableHandle]
  };
  function _no_name_provided__67($continuation, this$0) {
    this._$continuation_0 = $continuation;
    this._this$0_18 = this$0;
  }
  _no_name_provided__67.prototype.invoke_998 = function () {
    this._$continuation_0.resumeUndispatched_1(this._this$0_18, Unit_getInstance());
  };
  _no_name_provided__67.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__67.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__68($block) {
    this._$block_1 = $block;
  }
  _no_name_provided__68.prototype.invoke_998 = function () {
    this._$block_1.run_5();
  };
  _no_name_provided__68.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__68.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__69(this$0, $handle) {
    this._this$0_19 = this$0;
    this._$handle = $handle;
  }
  _no_name_provided__69.prototype.dispose_18 = function () {
    this._this$0_19._window.clearTimeout(this._$handle);
  };
  _no_name_provided__69.$metadata$ = {
    kind: 'class',
    interfaces: [DisposableHandle]
  };
  function WindowDispatcher(window_0) {
    CoroutineDispatcher.call(this);
    this._window = window_0;
    this._queue_0 = new WindowMessageQueue(this._window);
  }
  WindowDispatcher.prototype.dispatch_12 = function (context, block) {
    return this._queue_0.enqueue_2(block);
  };
  WindowDispatcher.prototype.scheduleResumeAfterDelay_5 = function (timeMillis, continuation) {
    (function () {
      var $externalVarargReceiverTmp = this._window;
      return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_49(continuation, this), delayToInt(timeMillis)]);
    }.call(this));
    Unit_getInstance();
  };
  WindowDispatcher.prototype.invokeOnTimeout_5 = function (timeMillis, block, context) {
    var handle = function () {
      var $externalVarargReceiverTmp = this._window;
      return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_50(block), delayToInt(timeMillis)]);
    }.call(this);
    return new _no_name_provided__69(this, handle);
  };
  WindowDispatcher.$metadata$ = {
    simpleName: 'WindowDispatcher',
    kind: 'class',
    interfaces: [Delay]
  };
  function _no_name_provided__70(this$0) {
    this._this$0_20 = this$0;
  }
  _no_name_provided__70.prototype.invoke_117 = function (event) {
    if (event.source == this._this$0_20._window_0 ? event.data == this._this$0_20._messageName : false) {
      event.stopPropagation();
      this._this$0_20.process_1();
    }};
  _no_name_provided__70.prototype.invoke_1015 = function (p1) {
    this.invoke_117((p1 == null ? true : p1) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__70.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__71(this$0) {
    this._this$0_21 = this$0;
  }
  _no_name_provided__71.prototype.invoke_660 = function (it) {
    this._this$0_21.process_1();
  };
  _no_name_provided__71.prototype.invoke_1015 = function (p1) {
    this.invoke_660(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__71.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function WindowMessageQueue(window_0) {
    MessageQueue.call(this);
    this._window_0 = window_0;
    this._messageName = 'dispatchCoroutine';
    this._window_0.addEventListener('message', _no_name_provided_$factory_51(this), true);
  }
  WindowMessageQueue.prototype.schedule_1 = function () {
    var tmp = Promise.resolve(Unit_getInstance());
    tmp.then(_no_name_provided_$factory_52(this));
    Unit_getInstance();
  };
  WindowMessageQueue.prototype.reschedule_1 = function () {
    this._window_0.postMessage(this._messageName, '*');
  };
  WindowMessageQueue.$metadata$ = {
    simpleName: 'WindowMessageQueue',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_46(this$0) {
    var i = new _no_name_provided__64(this$0);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_47($block) {
    var i = new _no_name_provided__65($block);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_48($continuation, this$0) {
    var i = new _no_name_provided__66($continuation, this$0);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_49($continuation, this$0) {
    var i = new _no_name_provided__67($continuation, this$0);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_50($block) {
    var i = new _no_name_provided__68($block);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_51(this$0) {
    var i = new _no_name_provided__70(this$0);
    return function (p1) {
      i.invoke_117(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_52(this$0) {
    var i = new _no_name_provided__71(this$0);
    return function (p1) {
      i.invoke_660(p1);
      return Unit_getInstance();
    };
  }
  function Runnable() {
  }
  Runnable.$metadata$ = {
    simpleName: 'Runnable',
    kind: 'interface',
    interfaces: []
  };
  function SchedulerTask() {
  }
  SchedulerTask.$metadata$ = {
    simpleName: 'SchedulerTask',
    kind: 'class',
    interfaces: [Runnable]
  };
  function _get_taskContext_(_this_) {
    return Unit_getInstance();
  }
  function asCoroutineDispatcher(_this_) {
    var tmp0_elvis_lhs = _this_.coroutineDispatcher;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_also_0 = new WindowDispatcher(_this_);
      _this_.coroutineDispatcher = tmp0_also_0;
      tmp = tmp0_also_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function AbortFlowException(owner) {
    CancellationException_init_$Init$('Flow was aborted, no more elements needed', this);
    this._owner = owner;
    captureStack(this, AbortFlowException);
  }
  AbortFlowException.$metadata$ = {
    simpleName: 'AbortFlowException',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__72() {
  }
  _no_name_provided__72.prototype.invoke_121 = function (count_0, _anonymous_parameter_1_) {
    return count_0 + 1 | 0;
  };
  _no_name_provided__72.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_121(tmp, (!(p2 == null) ? isInterface(p2, Element_0) : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__72.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SafeCollector(collector, collectContext) {
    this._collector_1 = collector;
    this._collectContext = collectContext;
    var tmp = this;
    tmp._collectContextSize = this._collectContext.fold_34(0, _no_name_provided_$factory_53());
    this._lastEmissionContext = null;
  }
  SafeCollector.prototype.emit_8 = function (value, $cont) {
    var currentContext = $cont._get_context__296();
    ensureActive(currentContext);
    if (!(this._lastEmissionContext === currentContext)) {
      checkContext(this, currentContext);
      this._lastEmissionContext = currentContext;
    }return this._collector_1.emit_8(value, $cont);
  };
  SafeCollector.prototype.releaseIntercepted = function () {
  };
  SafeCollector.$metadata$ = {
    simpleName: 'SafeCollector',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function _no_name_provided_$factory_53() {
    var i = new _no_name_provided__72();
    return function (p1, p2) {
      return i.invoke_121(p1, p2);
    };
  }
  function identitySet(expectedSize) {
    return HashSet_init_$Create$(expectedSize);
  }
  function NoOpLock() {
  }
  NoOpLock.$metadata$ = {
    simpleName: 'NoOpLock',
    kind: 'class',
    interfaces: []
  };
  function LinkedListHead() {
    LinkedListNode.call(this);
  }
  LinkedListHead.prototype.remove_69 = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  LinkedListHead.$metadata$ = {
    simpleName: 'LinkedListHead',
    kind: 'class',
    interfaces: []
  };
  function LinkedListNode() {
    this.__next = this;
    this.__prev = this;
    this.__removed = false;
  }
  LinkedListNode.prototype._get__next__1 = function () {
    return this.__next;
  };
  LinkedListNode.prototype.addLast_26 = function (node) {
    var prev = this.__prev;
    node.__next = this;
    node.__prev = prev;
    prev.__next = node;
    this.__prev = node;
  };
  LinkedListNode.prototype.remove_69 = function () {
    if (this.__removed)
      return false;
    var prev = this.__prev;
    var next_0 = this.__next;
    prev.__next = next_0;
    next_0.__prev = prev;
    this.__removed = true;
    return true;
  };
  LinkedListNode.prototype.addOneIfEmpty_9 = function (node) {
    if (!(this.__next === this))
      return false;
    this.addLast_26(node);
    return true;
  };
  LinkedListNode.prototype.helpRemove_20 = function () {
  };
  LinkedListNode.$metadata$ = {
    simpleName: 'LinkedListNode',
    kind: 'class',
    interfaces: []
  };
  function unwrap(exception) {
    return exception;
  }
  function CoroutineStackFrame() {
  }
  CoroutineStackFrame.$metadata$ = {
    simpleName: 'CoroutineStackFrame',
    kind: 'interface',
    interfaces: []
  };
  function recoverStackTrace(exception, continuation) {
    return exception;
  }
  function systemProp_1(propertyName) {
    return null;
  }
  function threadContextElements(context) {
    return 0;
  }
  function CommonThreadLocal() {
    this._value_8 = null;
  }
  CommonThreadLocal.prototype.get_85 = function () {
    var tmp = this._value_8;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  CommonThreadLocal.prototype.set_10 = function (value) {
    this._value_8 = value;
  };
  CommonThreadLocal.$metadata$ = {
    simpleName: 'CommonThreadLocal',
    kind: 'class',
    interfaces: []
  };
  function AsyncCloseable() {
  }
  AsyncCloseable.$metadata$ = {
    simpleName: 'AsyncCloseable',
    kind: 'interface',
    interfaces: []
  };
  var DEFAULT_SUSPEND_TEST_TIMEOUT;
  function launchImmediately(context, callback) {
    return launchImmediately_0(CoroutineScope_0(context), callback);
  }
  function launchImmediately_0(_this_, callback) {
    return _launch(_this_, CoroutineStart_UNDISPATCHED_getInstance(), callback);
  }
  function _launch(_this_, start, callback) {
    var tmp = _this_._get_coroutineContext__22();
    return launch(_this_, tmp, start, _no_name_provided_$factory_54(callback, null));
  }
  function asyncImmediately(context, callback) {
    return asyncImmediately_0(CoroutineScope_0(context), callback);
  }
  function asyncImmediately_0(_this_, callback) {
    return _async(_this_, CoroutineStart_UNDISPATCHED_getInstance(), callback);
  }
  function _async(_this_, start, callback) {
    var tmp = _this_._get_coroutineContext__22();
    return async(_this_, tmp, start, _no_name_provided_$factory_55(callback, null));
  }
  function _no_name_provided__73($callback, resultContinuation) {
    this._$callback = $callback;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__73.prototype.invoke_729 = function ($this$launch, $cont) {
    var tmp = this.create_51($this$launch, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__73.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_729((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__73.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$callback(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof CancellationException_0) {
              var e = this._exception_0;
              throw e;
            } else {
              {
                var tmp_1 = this._exception_0;
                if (tmp_1 instanceof Error) {
                  var e_0 = this._exception_0;
                  printStackTrace(e_0);
                  throw e_0;
                } else {
                  {
                    throw this._exception_0;
                  }
                }
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__73.prototype.create_51 = function ($this$launch, completion) {
    var i = new _no_name_provided__73(this._$callback, completion);
    i._$this$launch = $this$launch;
    return i;
  };
  _no_name_provided__73.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__74($callback, resultContinuation) {
    this._$callback_0 = $callback;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__74.prototype.invoke_697 = function ($this$async, $cont) {
    var tmp = this.create_51($this$async, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__74.prototype.invoke_1015 = function (p1, $cont) {
    return this.invoke_697((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__74.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$callback_0(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._TRY_RESULT0 = suspendResult;
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof CancellationException_0) {
              var e = this._exception_0;
              var tmp_1 = this;
              throw e;
            } else {
              {
                var tmp_2 = this._exception_0;
                if (tmp_2 instanceof Error) {
                  var e_0 = this._exception_0;
                  var tmp_3 = this;
                  printStackTrace(e_0);
                  throw e_0;
                } else {
                  {
                    throw this._exception_0;
                  }
                }
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return this._TRY_RESULT0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__74.prototype.create_51 = function ($this$async, completion) {
    var i = new _no_name_provided__74(this._$callback_0, completion);
    i._$this$async = $this$async;
    return i;
  };
  _no_name_provided__74.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided_$factory_54($callback, resultContinuation) {
    var i = new _no_name_provided__73($callback, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_729(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_55($callback, resultContinuation) {
    var i = new _no_name_provided__74($callback, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_697(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function DEFAULT_SUSPEND_TEST_TIMEOUT$init$() {
    var tmp0__get_seconds__0 = 20;
    return Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
  }
  function _no_name_provided__75($oldPromise, $func, resultContinuation) {
    this._$oldPromise = $oldPromise;
    this._$func = $func;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__75.prototype.invoke_1005 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__75.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._tmp0_safe_receiver0 = this._$oldPromise;
            if (this._tmp0_safe_receiver0 == null) {
              this._WHEN_RESULT1 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0.await_3(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            Unit_getInstance();
            this._state_1 = 3;
            suspendResult = this._$func(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__75.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__75(this._$oldPromise, this._$func, completion);
    return i;
  };
  _no_name_provided__75.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $invokeCOROUTINE$2(_this_, func, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__6 = _this_;
    this._func = func;
  }
  $invokeCOROUTINE$2.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            tmp_0._task0 = this.__this__6.sync(this._get_context__296(), this._func);
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._task0.await_3(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var res = suspendResult;
            return res;
          case 2:
            this._exceptionState = 3;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e = this._exception_0;
              throw e;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $invokeCOROUTINE$2.$metadata$ = {
    simpleName: '$invokeCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function AsyncThread() {
    this._lastPromise = null;
  }
  AsyncThread.prototype.invoke_128 = function (func, $cont) {
    var tmp = new $invokeCOROUTINE$2(this, func, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncThread.prototype.sync = function (context, func) {
    var oldPromise = this._lastPromise;
    var promise = asyncImmediately(context, _no_name_provided_$factory_56(oldPromise, func, null));
    this._lastPromise = promise;
    return promise;
  };
  AsyncThread.$metadata$ = {
    simpleName: 'AsyncThread',
    kind: 'class',
    interfaces: [AsyncInvokable]
  };
  function AsyncInvokable() {
  }
  AsyncInvokable.$metadata$ = {
    simpleName: 'AsyncInvokable',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_56($oldPromise, $func, resultContinuation) {
    var i = new _no_name_provided__75($oldPromise, $func, resultContinuation);
    var l = function ($cont) {
      return i.invoke_1005($cont);
    };
    l.$arity = 0;
    return l;
  }
  function toChannel(_this_, $cont) {
    return produce$default(0, _no_name_provided_$factory_57(_this_, null), 1, null, $cont);
  }
  function produce_1(capacity, block, $cont) {
    var tmp = CoroutineScope_0($cont._get_context__296());
    return produce(tmp, $cont._get_context__296(), capacity, block);
  }
  function produce$default(capacity, block, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      capacity = 0;
    return produce_1(capacity, block, $cont);
  }
  function _no_name_provided__76($this_toChannel, resultContinuation) {
    this._$this_toChannel = $this_toChannel;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__76.prototype.invoke_129 = function ($this$produce, $cont) {
    var tmp = this.create_3($this$produce, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__76.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_129((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__76.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._tmp0_iterator0 = this._$this_toChannel.iterator_67();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator0.hasNext_33()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._v1 = this._tmp0_iterator0.next_37();
            this._state_1 = 2;
            suspendResult = this._$this$produce.send_9(this._v1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__76.prototype.create_3 = function ($this$produce, completion) {
    var i = new _no_name_provided__76(this._$this_toChannel, completion);
    i._$this$produce = $this$produce;
    return i;
  };
  _no_name_provided__76.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided_$factory_57($this_toChannel, resultContinuation) {
    var i = new _no_name_provided__76($this_toChannel, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_129(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function delay_0(time, $cont) {
    return delay(_TimeSpan___get_millisecondsLong__impl_(time), $cont);
  }
  function delay_1(_this_, time, $cont) {
    return delay(_TimeSpan___get_millisecondsLong__impl_(time), $cont);
  }
  function Signal_init_$Init$(onRegister, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      onRegister = _no_name_provided_$factory_58();
    }Signal.call($this, onRegister);
    return $this;
  }
  function Signal_init_$Create$(onRegister, $mask0, $marker) {
    return Signal_init_$Init$(onRegister, $mask0, $marker, Object.create(Signal.prototype));
  }
  function _no_name_provided__77() {
  }
  _no_name_provided__77.prototype.invoke_998 = function () {
    return Unit_getInstance();
  };
  _no_name_provided__77.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__77.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Signal(onRegister) {
    BaseSignal.call(this, onRegister);
  }
  Signal.prototype.add_41 = function (handler) {
    return this._add_0(false, handler);
  };
  Signal.prototype.invoke_133 = function (handler) {
    return this.add_41(handler);
  };
  Signal.prototype.invoke_137 = function (value) {
    var tmp$ret$0;
    l$ret$1: do {
      if (this._handlers.isEmpty_53()) {
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      }try {
        var tmp0_this_1 = this;
        var tmp1_2 = tmp0_this_1._iterating;
        tmp0_this_1._iterating = tmp1_2 + 1 | 0;
        Unit_getInstance();
        var tmp0_fastIterateRemove_0 = this._handlers;
        var n_1 = 0;
        var m_2 = 0;
        while (n_1 < tmp0_fastIterateRemove_0._get_size__60()) {
          if (m_2 >= 0 ? !(m_2 === n_1) : false) {
            tmp0_fastIterateRemove_0.set_8(m_2, tmp0_fastIterateRemove_0.get_137(n_1));
            Unit_getInstance();
          }var tmp1__anonymous__3_6 = tmp0_fastIterateRemove_0.get_137(n_1);
          var remove_4_7 = tmp1__anonymous__3_6._once;
          var tmp5__anonymous__8 = tmp1__anonymous__3_6._item;
          tmp5__anonymous__8(value);
          if (remove_4_7) {
            var tmp0_3 = m_2;
            m_2 = tmp0_3 - 1 | 0;
            Unit_getInstance();
          } else {
          }
          var tmp1_4 = n_1;
          n_1 = tmp1_4 + 1 | 0;
          Unit_getInstance();
          var tmp2_5 = m_2;
          m_2 = tmp2_5 + 1 | 0;
          Unit_getInstance();
        }
        while (tmp0_fastIterateRemove_0._get_size__60() > m_2) {
          tmp0_fastIterateRemove_0.removeAt_6(tmp0_fastIterateRemove_0._get_size__60() - 1 | 0);
          Unit_getInstance();
        }
        Unit_getInstance();
      }finally {
        var tmp2_this_5 = this;
        var tmp3_6 = tmp2_this_5._iterating;
        tmp2_this_5._iterating = tmp3_6 - 1 | 0;
        Unit_getInstance();
        var tmp2_isNotEmpty_0 = this._handlersToRemove;
        if (!tmp2_isNotEmpty_0.isEmpty_53()) {
          var tmp3_fastIterateRemove_0 = this._handlersToRemove;
          var n_1_0 = 0;
          var m_2_0 = 0;
          while (n_1_0 < tmp3_fastIterateRemove_0._get_size__60()) {
            if (m_2_0 >= 0 ? !(m_2_0 === n_1_0) : false) {
              tmp3_fastIterateRemove_0.set_8(m_2_0, tmp3_fastIterateRemove_0.get_137(n_1_0));
              Unit_getInstance();
            }var tmp4__anonymous__7_6 = tmp3_fastIterateRemove_0.get_137(n_1_0);
            this._handlers.remove_47(tmp4__anonymous__7_6);
            Unit_getInstance();
            {
              var tmp0_3_0 = m_2_0;
              m_2_0 = tmp0_3_0 - 1 | 0;
              Unit_getInstance();
            }
            var tmp1_4_0 = n_1_0;
            n_1_0 = tmp1_4_0 + 1 | 0;
            Unit_getInstance();
            var tmp2_5_0 = m_2_0;
            m_2_0 = tmp2_5_0 + 1 | 0;
            Unit_getInstance();
          }
          while (tmp3_fastIterateRemove_0._get_size__60() > m_2_0) {
            tmp3_fastIterateRemove_0.removeAt_6(tmp3_fastIterateRemove_0._get_size__60() - 1 | 0);
            Unit_getInstance();
          }
          Unit_getInstance();
        } else {
        }
      }
    }
     while (false);
    return tmp$ret$0;
  };
  Signal.$metadata$ = {
    simpleName: 'Signal',
    kind: 'class',
    interfaces: []
  };
  function Node_0($outer, once, item) {
    this._$this_7 = $outer;
    this._once = once;
    this._item = item;
  }
  Node_0.prototype.close_77 = function () {
    if (this._$this_7._iterating > 0) {
      this._$this_7._handlersToRemove.add_39(this);
      Unit_getInstance();
    } else {
      this._$this_7._handlers.remove_47(this);
      Unit_getInstance();
    }
  };
  Node_0.$metadata$ = {
    simpleName: 'Node',
    kind: 'class',
    interfaces: [Closeable]
  };
  function BaseSignal(onRegister) {
    this._onRegister = onRegister;
    this._handlers = ArrayList_init_$Create$();
    this._handlersToRemove = ArrayList_init_$Create$();
    this._iterating = 0;
  }
  BaseSignal.prototype._get_listenerCount__0 = function () {
    return this._handlers._get_size__60();
  };
  BaseSignal.prototype._add_0 = function (once, handler) {
    this._onRegister();
    var node = new Node_0(this, once, handler);
    this._handlers.add_39(node);
    Unit_getInstance();
    return node;
  };
  BaseSignal.$metadata$ = {
    simpleName: 'BaseSignal',
    kind: 'class',
    interfaces: []
  };
  function AsyncSignal_init_$Init$(onRegister, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      onRegister = _no_name_provided_$factory_59();
    }AsyncSignal.call($this, onRegister);
    return $this;
  }
  function AsyncSignal_init_$Create$(onRegister, $mask0, $marker) {
    return AsyncSignal_init_$Init$(onRegister, $mask0, $marker, Object.create(AsyncSignal.prototype));
  }
  function _no_name_provided__78() {
  }
  _no_name_provided__78.prototype.invoke_998 = function () {
    return Unit_getInstance();
  };
  _no_name_provided__78.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__78.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $invokeCOROUTINE$3(_this_, value, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__7 = _this_;
    this._value_9 = value;
  }
  $invokeCOROUTINE$3.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (this.__this__7._handlers.isEmpty_53()) {
              this._tmp$ret$00 = Unit_getInstance();
              this._state_1 = 10;
              continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 9;
            var tmp0_this_1 = this.__this__7;
            var tmp1_2 = tmp0_this_1._iterating;
            tmp0_this_1._iterating = tmp1_2 + 1 | 0;
            Unit_getInstance();
            var tmp_0 = this;
            tmp_0._tmp0_fastIterateRemove_0_32 = this.__this__7._handlers;
            this._n_1_43 = 0;
            this._m_2_54 = 0;
            this._state_1 = 4;
            continue $sm;
          case 4:
            if (!(this._n_1_43 < this._tmp0_fastIterateRemove_0_32._get_size__60())) {
              this._state_1 = 7;
              continue $sm;
            }
            if (this._m_2_54 >= 0 ? !(this._m_2_54 === this._n_1_43) : false) {
              this._tmp0_fastIterateRemove_0_32.set_8(this._m_2_54, this._tmp0_fastIterateRemove_0_32.get_137(this._n_1_43));
              Unit_getInstance();
            }
            var tmp_1 = this;
            tmp_1._tmp1__anonymous__6_65 = this._tmp0_fastIterateRemove_0_32.get_137(this._n_1_43);
            this._remove_7_76 = this._tmp1__anonymous__6_65._once;
            var tmp_2 = this;
            tmp_2._tmp0__anonymous__217 = this._tmp1__anonymous__6_65._item;
            this._state_1 = 5;
            suspendResult = this._tmp0__anonymous__217(this._value_9, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            suspendResult;
            if (this._remove_7_76) {
              var tmp0_3_8 = this._m_2_54;
              this._m_2_54 = tmp0_3_8 - 1 | 0;
              Unit_getInstance();
              this._state_1 = 6;
              continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 6:
            var tmp1_4_9 = this._n_1_43;
            this._n_1_43 = tmp1_4_9 + 1 | 0;
            Unit_getInstance();
            var tmp2_5_10 = this._m_2_54;
            this._m_2_54 = tmp2_5_10 + 1 | 0;
            Unit_getInstance();
            this._state_1 = 4;
            continue $sm;
          case 7:
            while (this._tmp0_fastIterateRemove_0_32._get_size__60() > this._m_2_54) {
              this._tmp0_fastIterateRemove_0_32.removeAt_6(this._tmp0_fastIterateRemove_0_32._get_size__60() - 1 | 0);
              Unit_getInstance();
            }

            var tmp_3 = this;
            tmp_3._tmp$ret$21 = Unit_getInstance();
            this._exceptionState = 11;
            this._state_1 = 8;
            continue $sm;
          case 8:
            var tmp2_this_11 = this.__this__7;
            var tmp3_12 = tmp2_this_11._iterating;
            tmp2_this_11._iterating = tmp3_12 - 1 | 0;
            Unit_getInstance();
            var tmp2_isNotEmpty_0_13 = this.__this__7._handlersToRemove;
            if (!tmp2_isNotEmpty_0_13.isEmpty_53()) {
              var tmp3_fastIterateRemove_0_14 = this.__this__7._handlersToRemove;
              var n_1_15 = 0;
              var m_2_16 = 0;
              while (n_1_15 < tmp3_fastIterateRemove_0_14._get_size__60()) {
                if (m_2_16 >= 0 ? !(m_2_16 === n_1_15) : false) {
                  tmp3_fastIterateRemove_0_14.set_8(m_2_16, tmp3_fastIterateRemove_0_14.get_137(n_1_15));
                  Unit_getInstance();
                }var tmp4__anonymous__6_17 = tmp3_fastIterateRemove_0_14.get_137(n_1_15);
                this.__this__7._handlers.remove_47(tmp4__anonymous__6_17);
                Unit_getInstance();
                {
                  var tmp0_3_18 = m_2_16;
                  m_2_16 = tmp0_3_18 - 1 | 0;
                  Unit_getInstance();
                }
                var tmp1_4_19 = n_1_15;
                n_1_15 = tmp1_4_19 + 1 | 0;
                Unit_getInstance();
                var tmp2_5_20 = m_2_16;
                m_2_16 = tmp2_5_20 + 1 | 0;
                Unit_getInstance();
              }
              while (tmp3_fastIterateRemove_0_14._get_size__60() > m_2_16) {
                tmp3_fastIterateRemove_0_14.removeAt_6(tmp3_fastIterateRemove_0_14._get_size__60() - 1 | 0);
                Unit_getInstance();
              }
              Unit_getInstance();
            } else {
            }

            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 10;
            continue $sm;
          case 9:
            this._exceptionState = 11;
            var t = this._exception_0;
            var tmp2_this_11_0 = this.__this__7;
            var tmp3_12_0 = tmp2_this_11_0._iterating;
            tmp2_this_11_0._iterating = tmp3_12_0 - 1 | 0;
            Unit_getInstance();
            var tmp2_isNotEmpty_0_13_0 = this.__this__7._handlersToRemove;
            if (!tmp2_isNotEmpty_0_13_0.isEmpty_53()) {
              var tmp3_fastIterateRemove_0_14_0 = this.__this__7._handlersToRemove;
              var n_1_15_0 = 0;
              var m_2_16_0 = 0;
              while (n_1_15_0 < tmp3_fastIterateRemove_0_14_0._get_size__60()) {
                if (m_2_16_0 >= 0 ? !(m_2_16_0 === n_1_15_0) : false) {
                  tmp3_fastIterateRemove_0_14_0.set_8(m_2_16_0, tmp3_fastIterateRemove_0_14_0.get_137(n_1_15_0));
                  Unit_getInstance();
                }var tmp4__anonymous__6_17_0 = tmp3_fastIterateRemove_0_14_0.get_137(n_1_15_0);
                this.__this__7._handlers.remove_47(tmp4__anonymous__6_17_0);
                Unit_getInstance();
                {
                  var tmp0_3_18_0 = m_2_16_0;
                  m_2_16_0 = tmp0_3_18_0 - 1 | 0;
                  Unit_getInstance();
                }
                var tmp1_4_19_0 = n_1_15_0;
                n_1_15_0 = tmp1_4_19_0 + 1 | 0;
                Unit_getInstance();
                var tmp2_5_20_0 = m_2_16_0;
                m_2_16_0 = tmp2_5_20_0 + 1 | 0;
                Unit_getInstance();
              }
              while (tmp3_fastIterateRemove_0_14_0._get_size__60() > m_2_16_0) {
                tmp3_fastIterateRemove_0_14_0.removeAt_6(tmp3_fastIterateRemove_0_14_0._get_size__60() - 1 | 0);
                Unit_getInstance();
              }
              Unit_getInstance();
            } else {
            }

            throw t;
          case 10:
            return Unit_getInstance();
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $invokeCOROUTINE$3.$metadata$ = {
    simpleName: '$invokeCOROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function AsyncSignal(onRegister) {
    BaseSignal.call(this, onRegister);
  }
  AsyncSignal.prototype.invoke_137 = function (value, $cont) {
    var tmp = new $invokeCOROUTINE$3(this, value, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncSignal.$metadata$ = {
    simpleName: 'AsyncSignal',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_58() {
    var i = new _no_name_provided__77();
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_59() {
    var i = new _no_name_provided__78();
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function runBlockingNoSuspensions(callback) {
    var completed = {_v: false};
    var rresult = {_v: null};
    var resultEx = {_v: null};
    var suspendCount = {_v: 0};
    startCoroutineUndispatched_0(callback, new _no_name_provided__80(suspendCount, resultEx, completed, rresult));
    if (!completed._v) {
      invalidOp('' + 'runBlockingNoSuspensions was not completed synchronously! suspendCount=' + suspendCount._v);
    }if (!(resultEx._v == null))
      throw ensureNotNull(resultEx._v);
    var tmp;
    if (rresult._v == null) {
      throwUninitializedPropertyAccessException('rresult');
    } else {
      tmp = rresult._v;
    }
    return tmp;
  }
  function startCoroutineUndispatched_0(_this_, completion) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      try {
        var tmp0_withCoroutineContext_0_4 = completion._get_context__296();
        var tmp1_withCoroutineContext_0_5 = null;
        tmp = _this_(completion);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var tmp0_failure_0_1 = Companion_getInstance_2();
          completion.resumeWith_196(_Result___init__impl_(createFailure($p)));
          tmp$ret$0 = Unit_getInstance();
          break l$ret$1;
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_0;
      }
      var value_1 = tmp;
      if (!(value_1 === _get_COROUTINE_SUSPENDED_())) {
        var tmp0_resume_0 = (value_1 == null ? true : isObject(value_1)) ? value_1 : THROW_CCE();
        var tmp0_success_0_1 = Companion_getInstance_2();
        completion.resumeWith_196(_Result___init__impl_(tmp0_resume_0));
      }}
     while (false);
  }
  function _get_unitInstance_($this) {
    return Unit_getInstance();
  }
  function _no_name_provided__79($suspendCount) {
    this._$suspendCount = $suspendCount;
    AbstractCoroutineContextElement.call(this, Key_getInstance());
    this._key_2 = Key_getInstance();
  }
  _no_name_provided__79.prototype._get_key__37 = function () {
    return this._key_2;
  };
  _no_name_provided__79.prototype.interceptContinuation_11 = function (continuation) {
    var tmp0_2 = this._$suspendCount._v;
    this._$suspendCount._v = tmp0_2 + 1 | 0;
    Unit_getInstance();
    return continuation;
  };
  _no_name_provided__79.prototype.scheduleResumeAfterDelay_5 = function (timeMillis, continuation) {
    var tmp0_resume_0 = Unit_getInstance();
    var tmp0_success_0_1 = Companion_getInstance_2();
    return continuation.resumeWith_196(_Result___init__impl_(Unit_getInstance()));
  };
  _no_name_provided__79.$metadata$ = {
    kind: 'class',
    interfaces: [ContinuationInterceptor, Delay]
  };
  function _no_name_provided__80($suspendCount, $resultEx, $completed, $rresult) {
    this._$suspendCount_0 = $suspendCount;
    this._$resultEx = $resultEx;
    this._$completed = $completed;
    this._$rresult = $rresult;
    var tmp = this;
    tmp._context_1 = new _no_name_provided__79(this._$suspendCount_0);
  }
  _no_name_provided__80.prototype._get_context__296 = function () {
    return this._context_1;
  };
  _no_name_provided__80.prototype.resumeWith_38 = function (result) {
    var exception = Result__exceptionOrNull_impl(result);
    if (!(exception == null)) {
      this._$resultEx._v = exception;
      this._$completed._v = true;
      printStackTrace(exception);
    } else {
      throwOnFailure(result);
      var tmp = _Result___get_value__impl_(result);
      var tmp0_elvis_lhs = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp_1 = _get_unitInstance_(this);
        var tmp_2;
        if (isObject(Unit_getInstance())) {
          tmp_2 = Unit_getInstance();
        } else {
          {
            tmp_2 = THROW_CCE();
          }
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var rvalue = tmp_0;
      this._$rresult._v = rvalue;
      this._$completed._v = true;
    }
  };
  _no_name_provided__80.prototype.resumeWith_196 = function (result) {
    return this.resumeWith_38(result);
  };
  _no_name_provided__80.$metadata$ = {
    kind: 'class',
    interfaces: [Continuation]
  };
  function CompressionMethod() {
  }
  CompressionMethod.prototype.uncompress_3 = function (reader, out, $cont) {
    unsupported_0();
  };
  CompressionMethod.prototype.compress_3 = function (i, o, context, $cont) {
    unsupported_0();
  };
  CompressionMethod.$metadata$ = {
    simpleName: 'CompressionMethod',
    kind: 'interface',
    interfaces: []
  };
  function CompressionContext_init_$Init$(level, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      level = 6;
    CompressionContext.call($this, level);
    return $this;
  }
  function CompressionContext_init_$Create$(level, $mask0, $marker) {
    return CompressionContext_init_$Init$(level, $mask0, $marker, Object.create(CompressionContext.prototype));
  }
  function CompressionContext(level) {
    this._level_0 = level;
    this._name_3 = null;
    this._custom = null;
  }
  CompressionContext.$metadata$ = {
    simpleName: 'CompressionContext',
    kind: 'class',
    interfaces: []
  };
  function uncompress(_this_, method, outputSizeHint) {
    var buffer_1 = ByteArrayBuilder_init_$Create$_0(outputSizeHint);
    var s_2 = MemorySyncStream_0(buffer_1);
    uncompress_0(method, openSync$default(_this_, null, 1, null), s_2);
    return buffer_1.toByteArray();
  }
  function uncompress$default(_this_, method, outputSizeHint, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      outputSizeHint = imul(_this_.length, 2);
    return uncompress(_this_, method, outputSizeHint);
  }
  function compress(_this_, method, context, outputSizeHint) {
    var buffer_1 = ByteArrayBuilder_init_$Create$_0(outputSizeHint);
    var s_2 = MemorySyncStream_0(buffer_1);
    compress_0(method, openSync$default(_this_, null, 1, null), s_2, context);
    return buffer_1.toByteArray();
  }
  function compress$default(_this_, method, context, outputSizeHint, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      context = CompressionContext_init_$Create$(0, 1, null);
    }if (!(($mask0 & 4) === 0))
      outputSizeHint = numberToInt(_this_.length * 1.1);
    return compress(_this_, method, context, outputSizeHint);
  }
  function uncompress_0(_this_, i, o) {
    return runBlockingNoSuspensions(_no_name_provided_$factory_60(_this_, i, o, null));
  }
  function compress_0(_this_, i, o, context) {
    return runBlockingNoSuspensions(_no_name_provided_$factory_61(_this_, i, o, context, null));
  }
  function uncompress_1(_this_, i, o, $cont) {
    return _this_.uncompress_3(new BitReader(i), o, $cont);
  }
  function compress_1(_this_, i, o, context, $cont) {
    return _this_.compress_3(new BitReader(i), o, context, $cont);
  }
  function _no_name_provided__81($this_uncompress, $i, $o, resultContinuation) {
    this._$this_uncompress = $this_uncompress;
    this._$i = $i;
    this._$o = $o;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__81.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__81.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__81.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = uncompress_1(this._$this_uncompress, toAsyncInputStream(this._$i), toAsyncOutputStream(this._$o), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__81.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__81(this._$this_uncompress, this._$i, this._$o, completion);
    return i;
  };
  _no_name_provided__81.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__82($this_compress, $i, $o, $context, resultContinuation) {
    this._$this_compress = $this_compress;
    this._$i_0 = $i;
    this._$o_0 = $o;
    this._$context_0 = $context;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__82.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__82.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__82.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = compress_1(this._$this_compress, toAsyncInputStream(this._$i_0), toAsyncOutputStream(this._$o_0), this._$context_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__82.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__82(this._$this_compress, this._$i_0, this._$o_0, this._$context_0, completion);
    return i;
  };
  _no_name_provided__82.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided_$factory_60($this_uncompress, $i, $o, resultContinuation) {
    var i = new _no_name_provided__81($this_uncompress, $i, $o, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_61($this_compress, $i, $o, $context, resultContinuation) {
    var i = new _no_name_provided__82($this_compress, $i, $o, $context, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _get_Deflate_() {
    var tmp0_getValue_0 = Deflate$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = Deflate$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var Deflate$delegate;
  function $flushCOROUTINE$8(_this_, finish, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__8 = _this_;
    this._finish = finish;
  }
  $flushCOROUTINE$8.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (this._finish ? true : this.__this__8._get_mustFlush_()) {
              this._state_1 = 1;
              suspendResult = this.__this__8._out.write_25(this.__this__8._bab._data_8, 0, this.__this__8._bab._get_size__60(), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this.__this__8._bab.clear_33();
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $flushCOROUTINE$8.$metadata$ = {
    simpleName: '$flushCOROUTINE$8',
    kind: 'class',
    interfaces: []
  };
  function read(_this_, $this, tree) {
    return tree.read_11(_this_);
  }
  function SlidingWindowWithOutput(sliding, out) {
    this._sliding = sliding;
    this._out = out;
    this._bab = ByteArrayBuilder_init_$Create$_0(8192);
  }
  SlidingWindowWithOutput.prototype._get_mustFlush_ = function () {
    return this._bab._get_size__60() >= 4096;
  };
  SlidingWindowWithOutput.prototype.getPutCopyOut = function (distance, length) {
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var v = this._sliding.getPut(distance);
        this._bab.append_7(toByte(v));
        Unit_getInstance();
      }
       while (inductionVariable < length);
  };
  SlidingWindowWithOutput.prototype.putOut = function (bytes, offset, len) {
    this._bab.append_6(bytes, offset, len);
    this._sliding.putBytes(bytes, offset, len);
  };
  SlidingWindowWithOutput.prototype.putOut_0 = function (byte) {
    this._bab.append_7(byte);
    Unit_getInstance();
    this._sliding.put_14(byte & 255);
    Unit_getInstance();
  };
  SlidingWindowWithOutput.prototype.flush_1 = function (finish, $cont) {
    var tmp = new $flushCOROUTINE$8(this, finish, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  SlidingWindowWithOutput.$metadata$ = {
    simpleName: 'SlidingWindowWithOutput',
    kind: 'class',
    interfaces: []
  };
  function Companion_42() {
    Companion_instance_41 = this;
    DeflatePortable.call(this, 15);
    var tmp = this;
    var tmp_0 = new HuffmanTree();
    var tmp0_apply_0 = new Int32Array(288);
    var inductionVariable = 0;
    if (inductionVariable <= 143)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0[n_3] = 8;
      }
       while (inductionVariable <= 143);
    var inductionVariable_0 = 144;
    if (inductionVariable_0 <= 255)
      do {
        var n_5 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        tmp0_apply_0[n_5] = 9;
      }
       while (inductionVariable_0 <= 255);
    var inductionVariable_1 = 256;
    if (inductionVariable_1 <= 279)
      do {
        var n_7 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        tmp0_apply_0[n_7] = 7;
      }
       while (inductionVariable_1 <= 279);
    var inductionVariable_2 = 280;
    if (inductionVariable_2 <= 287)
      do {
        var n_9 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        tmp0_apply_0[n_9] = 8;
      }
       while (inductionVariable_2 <= 287);
    tmp._FIXED_TREE = tmp_0.fromLengths$default(tmp0_apply_0, 0, 0, 6, null);
    var tmp_1 = this;
    var tmp_2 = new HuffmanTree();
    var tmp_3 = 0;
    var tmp_4 = 32;
    var tmp_5 = new Int32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      var tmp_6 = tmp_3;
      tmp_5[tmp_6] = 5;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_1._FIXED_DIST = tmp_2.fromLengths$default(tmp_5, 0, 0, 6, null);
    var tmp_7 = this;
    var tmp0_intArrayOf_0 = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0]);
    tmp_7._LEN_EXTRA = tmp0_intArrayOf_0;
    var tmp_8 = this;
    var tmp0_intArrayOf_0_0 = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]);
    tmp_8._LEN_BASE = tmp0_intArrayOf_0_0;
    var tmp_9 = this;
    var tmp0_intArrayOf_0_1 = new Int32Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
    tmp_9._DIST_EXTRA = tmp0_intArrayOf_0_1;
    var tmp_10 = this;
    var tmp0_intArrayOf_0_2 = new Int32Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]);
    tmp_10._DIST_BASE = tmp0_intArrayOf_0_2;
    var tmp_11 = this;
    var tmp0_intArrayOf_0_3 = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
    tmp_11._HCLENPOS = tmp0_intArrayOf_0_3;
  }
  Companion_42.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_41;
  function Companion_getInstance_41() {
    if (Companion_instance_41 == null)
      new Companion_42();
    return Companion_instance_41;
  }
  function $compressCOROUTINE$6(_this_, i, o, context, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__9 = _this_;
    this._i = i;
    this._o = o;
    this._context_2 = context;
  }
  $compressCOROUTINE$6.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._state_1 = 2;
            suspendResult = hasAvailable_0(this._i, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            if (!suspendResult) {
              this._state_1 = 9;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = getAvailable_0(this._i, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._available0 = suspendResult;
            this._chunkSize1 = min2_1(this._available0, new Long(65535, 0)).toInt_8();
            this._state_1 = 4;
            suspendResult = write8_0(this._o, toLong(this._chunkSize1).compareTo_137(this._available0) >= 0 ? 1 : 0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            suspendResult;
            this._state_1 = 5;
            suspendResult = write16LE_0(this._o, this._chunkSize1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            suspendResult;
            this._state_1 = 6;
            suspendResult = write16LE_0(this._o, ~this._chunkSize1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            suspendResult;
            this._state_1 = 7;
            suspendResult = readBytesExact(this._i, this._chunkSize1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._ARGUMENT2 = suspendResult;
            this._state_1 = 8;
            suspendResult = writeBytes(this._o, this._ARGUMENT2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 9:
            return Unit_getInstance();
          case 10:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $compressCOROUTINE$6.$metadata$ = {
    simpleName: '$compressCOROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function $uncompressCOROUTINE$7(_this_, reader, out, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__10 = _this_;
    this._reader = reader;
    this._out_0 = out;
  }
  $uncompressCOROUTINE$7.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 19;
            this._sout0 = new SlidingWindowWithOutput(new SlidingWindow(this.__this__10._windowBits), this._out_0);
            this._lastBlock1 = false;
            this._tempTree2 = new HuffmanTree();
            this._tempDist3 = new HuffmanTree();
            this._codeLenCodeLen4 = new Int32Array(32);
            this._lengths5 = new Int32Array(512);
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!!this._lastBlock1) {
              this._state_1 = 16;
              continue $sm;
            }
            if (this._reader._get_requirePrepare_()) {
              this._state_1 = 2;
              suspendResult = this._reader.prepareBigChunk(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._lastBlock1 = this._reader.sreadBit();
            this._blockType6 = this._reader.readBits(2);
            var containsArg = this._blockType6;
            if (!(0 <= containsArg ? containsArg <= 2 : false)) {
              var tmp_0 = this;
              tmp_0._tmp0_error_07 = 'invalid bit';
              throw IllegalStateException_init_$Create$_0(toString_1(this._tmp0_error_07));
            } else {
            }

            if (this._blockType6 === 0) {
              this._reader._bitdata = 0;
              this._reader._bitsavailable = 0;
              Unit_getInstance();
              this._len8 = this._reader.su16LE();
              this._nlen9 = this._reader.su16LE();
              this._nnlen10 = ~this._nlen9 & 65535;
              if (!(this._len8 === this._nnlen10)) {
                var tmp_1 = this;
                tmp_1._tmp1_error_011 = '' + 'Invalid deflate stream: len(' + this._len8 + ') != ~nlen(' + this._nnlen10 + ') :: nlen=' + this._nlen9;
                throw IllegalStateException_init_$Create$_0(toString_1(this._tmp1_error_011));
              }this._state_1 = 14;
              suspendResult = this._reader.abytes$default(this._len8, null, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              if (this._blockType6 === 1) {
                this._tree12 = Companion_getInstance_41()._FIXED_TREE;
                this._dist13 = Companion_getInstance_41()._FIXED_DIST;
              } else {
                var hlit = this._reader.readBits(5) + 257 | 0;
                var hdist = this._reader.readBits(5) + 1 | 0;
                var hclen = this._reader.readBits(4) + 4 | 0;
                var tmp2_fill_0 = 0;
                var tmp3_fill_0 = 0;
                var tmp4_fill_0 = this._codeLenCodeLen4.length;
                fill_0(this._codeLenCodeLen4, tmp2_fill_0, tmp3_fill_0, tmp4_fill_0);
                var inductionVariable = 0;
                if (inductionVariable < hclen)
                  do {
                    var i = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    this._codeLenCodeLen4[Companion_getInstance_41()._HCLENPOS[i]] = this._reader.readBits(3);
                  }
                   while (inductionVariable < hclen);
                var codeLen = this._tempTree2.fromLengths$default(this._codeLenCodeLen4, 0, 0, 6, null);
                var hlithdist = hlit + hdist | 0;
                var n = 0;
                var tmp5_fill_0 = 0;
                var tmp6_fill_0 = 0;
                var tmp7_fill_0 = this._lengths5.length;
                fill_0(this._lengths5, tmp5_fill_0, tmp6_fill_0, tmp7_fill_0);
                while (n < hlithdist) {
                  var value = read(this._reader, this.__this__10, codeLen);
                  if (!(0 <= value ? value <= 18 : false)) {
                    var tmp8_error_0 = 'Invalid';
                    throw IllegalStateException_init_$Create$_0(toString_1(tmp8_error_0));
                  }var tmp1_subject = value;
                  {
                    var len;
                    switch (tmp1_subject) {
                      case 16:
                        len = this._reader.readBits(2) + 3 | 0;
                        break;
                      case 17:
                        len = this._reader.readBits(3) + 3 | 0;
                        break;
                      case 18:
                        len = this._reader.readBits(7) + 11 | 0;
                        break;
                      default:len = 1;
                        break;
                    }
                  }
                  var tmp2_subject = value;
                  {
                    var vv;
                    switch (tmp2_subject) {
                      case 16:
                        vv = this._lengths5[n - 1 | 0];
                        break;
                      case 17:
                        vv = 0;
                        break;
                      case 18:
                        vv = 0;
                        break;
                      default:vv = value;
                        break;
                    }
                  }
                  var tmp9_fill_0 = n;
                  var tmp10_fill_0 = n + len | 0;
                  fill_0(this._lengths5, vv, tmp9_fill_0, tmp10_fill_0);
                  n = n + len | 0;
                }
                this._tree12 = this._tempTree2.fromLengths(this._lengths5, 0, hlit);
                this._dist13 = this._tempDist3.fromLengths(this._lengths5, hlit, hlithdist);
              }
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            if (false) {
              this._state_1 = 13;
              continue $sm;
            }
            if (this._reader._get_requirePrepare_()) {
              this._state_1 = 5;
              suspendResult = this._reader.prepareBigChunk(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 5:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 6;
            continue $sm;
          case 6:
            this._value14 = this._tree12.read_11(this._reader);
            if (this._value14 === 256) {
              this._state_1 = 13;
              continue $sm;
            } else {
              this._state_1 = 7;
              continue $sm;
            }

            break;
          case 7:
            if (this._value14 < 256) {
              this._sout0.putOut_0(toByte(this._value14));
              this._state_1 = 10;
              continue $sm;
            } else {
              if (this._reader._get_requirePrepare_()) {
                this._state_1 = 8;
                suspendResult = this._reader.prepareBigChunk(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                this._state_1 = 9;
                continue $sm;
              }
            }

            break;
          case 8:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 9;
            continue $sm;
          case 9:
            this._zlenof15 = this._value14 - 257 | 0;
            this._lengthExtra16 = this._reader.readBits(Companion_getInstance_41()._LEN_EXTRA[this._zlenof15]);
            this._distanceData17 = read(this._reader, this.__this__10, this._dist13);
            this._distanceExtra18 = this._reader.readBits(Companion_getInstance_41()._DIST_EXTRA[this._distanceData17]);
            this._distance19 = Companion_getInstance_41()._DIST_BASE[this._distanceData17] + this._distanceExtra18 | 0;
            this._length20 = Companion_getInstance_41()._LEN_BASE[this._zlenof15] + this._lengthExtra16 | 0;
            this._sout0.getPutCopyOut(this._distance19, this._length20);
            this._state_1 = 10;
            continue $sm;
          case 10:
            var tmp_2 = this;
            tmp_2._tmp11_flushIfRequired_021 = false;
            if (this._tmp11_flushIfRequired_021 ? true : this._sout0._get_mustFlush_()) {
              this._state_1 = 11;
              suspendResult = this._sout0.flush_1(this._tmp11_flushIfRequired_021, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 12;
              continue $sm;
            }

            break;
          case 11:
            suspendResult;
            this._state_1 = 12;
            continue $sm;
          case 12:
            this._state_1 = 4;
            continue $sm;
          case 13:
            this._state_1 = 15;
            continue $sm;
          case 14:
            this._bytes22 = suspendResult;
            this._sout0.putOut(this._bytes22, 0, this._len8);
            this._state_1 = 15;
            continue $sm;
          case 15:
            this._state_1 = 1;
            continue $sm;
          case 16:
            var tmp_3 = this;
            tmp_3._tmp12_flushIfRequired_023 = true;
            if (this._tmp12_flushIfRequired_023 ? true : this._sout0._get_mustFlush_()) {
              this._state_1 = 17;
              suspendResult = this._sout0.flush_1(this._tmp12_flushIfRequired_023, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 18;
              continue $sm;
            }

            break;
          case 17:
            suspendResult;
            this._state_1 = 18;
            continue $sm;
          case 18:
            return Unit_getInstance();
          case 19:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 19) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $uncompressCOROUTINE$7.$metadata$ = {
    simpleName: '$uncompressCOROUTINE$7',
    kind: 'class',
    interfaces: []
  };
  function DeflatePortable(windowBits) {
    Companion_getInstance_41();
    this._windowBits = windowBits;
  }
  DeflatePortable.prototype.compress_3 = function (i, o, context, $cont) {
    var tmp = new $compressCOROUTINE$6(this, i, o, context, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  DeflatePortable.prototype.uncompress_3 = function (reader, out, $cont) {
    var tmp = new $uncompressCOROUTINE$7(this, reader, out, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  DeflatePortable.$metadata$ = {
    simpleName: 'DeflatePortable',
    kind: 'class',
    interfaces: [CompressionMethod]
  };
  function _no_name_provided__83() {
  }
  _no_name_provided__83.prototype.invoke_1005 = function () {
    return Deflate(15);
  };
  _no_name_provided__83.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Deflate$factory() {
    return getPropertyCallableRef('Deflate', 0, KProperty0, function () {
      return _get_Deflate_();
    }, null);
  }
  function _no_name_provided_$factory_62() {
    var i = new _no_name_provided__83();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided__84() {
  }
  _no_name_provided__84.prototype.invoke_874 = function (it) {
    return Deflate(it);
  };
  _no_name_provided__84.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__84.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $writeCOROUTINE$16(_this_, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__11 = _this_;
    this._buffer_5 = buffer;
    this._offset_1 = offset;
    this._len = len;
  }
  $writeCOROUTINE$16.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__11._$o_1.write_25(this._buffer_5, this._offset_1, this._len, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this.__this__11._$chash._v = Adler32_getInstance().update_2(this.__this__11._$chash._v, this._buffer_5, this._offset_1, this._len);
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$16.$metadata$ = {
    simpleName: '$writeCOROUTINE$16',
    kind: 'class',
    interfaces: []
  };
  function $readCOROUTINE$17(_this_, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__12 = _this_;
    this._buffer_6 = buffer;
    this._offset_2 = offset;
    this._len_0 = len;
  }
  $readCOROUTINE$17.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__12._$i_1.read_30(this._buffer_6, this._offset_2, this._len_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var read_1 = suspendResult;
            if (read_1 > 0) {
              this.__this__12._$adler._v = Adler32_getInstance().update_2(this.__this__12._$adler._v, this._buffer_6, this._offset_2, read_1);
            }
            return read_1;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$17.$metadata$ = {
    simpleName: '$readCOROUTINE$17',
    kind: 'class',
    interfaces: []
  };
  function Companion_43() {
    Companion_instance_42 = this;
    ZLib.call(this, _no_name_provided_$factory_63());
  }
  Companion_43.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_42;
  function Companion_getInstance_42() {
    if (Companion_instance_42 == null)
      new Companion_43();
    return Companion_instance_42;
  }
  function _no_name_provided__85($o, $chash) {
    this._$o_1 = $o;
    this._$chash = $chash;
  }
  _no_name_provided__85.prototype.close_77 = function ($cont) {
    return this._$o_1.close_77($cont);
  };
  _no_name_provided__85.prototype.write_25 = function (buffer, offset, len, $cont) {
    var tmp = new $writeCOROUTINE$16(this, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__85.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncOutputStream]
  };
  function _no_name_provided__86($i, $adler) {
    this._$i_1 = $i;
    this._$adler = $adler;
    this._$$delegate_0 = this._$i_1;
  }
  _no_name_provided__86.prototype.close_77 = function ($cont) {
    return this._$$delegate_0.close_77($cont);
  };
  _no_name_provided__86.prototype.getLength_14 = function ($cont) {
    return this._$$delegate_0.getLength_14($cont);
  };
  _no_name_provided__86.prototype.getPosition_5 = function ($cont) {
    return this._$$delegate_0.getPosition_5($cont);
  };
  _no_name_provided__86.prototype.read_36 = function ($cont) {
    return this._$$delegate_0.read_36($cont);
  };
  _no_name_provided__86.prototype.read_30 = function (buffer, offset, len, $cont) {
    var tmp = new $readCOROUTINE$17(this, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__86.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncInputStreamWithLength]
  };
  function $uncompressCOROUTINE$14(_this_, reader, out, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__13 = _this_;
    this._reader_0 = reader;
    this._out_1 = out;
  }
  $uncompressCOROUTINE$14.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._r0 = this._reader_0;
            this._o1 = this._out_1;
            if (this._r0._get_requirePrepare_()) {
              this._state_1 = 1;
              suspendResult = this._r0.prepareBigChunk(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._cmf2 = this._r0.su8();
            this._flg3 = this._r0.su8();
            if (!((imul(this._cmf2, 256) + this._flg3 | 0) % 31 === 0)) {
              var tmp_0 = this;
              tmp_0._tmp0_error_04 = 'bad zlib header';
              throw IllegalStateException_init_$Create$_0(toString_1(this._tmp0_error_04));
            }
            this._compressionMethod5 = extract(this._cmf2, 0, 4);
            if (!(this._compressionMethod5 === 8)) {
              var tmp_1 = this;
              tmp_1._tmp1_error_06 = '' + 'Invalid zlib stream compressionMethod=' + this._compressionMethod5;
              throw IllegalStateException_init_$Create$_0(toString_1(this._tmp1_error_06));
            }
            this._windowBits7 = extract(this._cmf2, 4, 4) + 8 | 0;
            this._fcheck8 = extract(this._flg3, 0, 5);
            this._hasDict9 = extract_0(this._flg3, 5);
            this._flevel10 = extract(this._flg3, 6, 2);
            this._dictid11 = 0;
            if (this._hasDict9) {
              this._dictid11 = this._r0.su32LE();
              var tmp2_TODO_0 = '' + 'Unsupported custom dictionaries (Provided DICTID=' + this._dictid11 + ')';
              throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp2_TODO_0);
            }
            this._chash12 = {_v: Adler32_getInstance()._initialValue};
            this._state_1 = 3;
            var tmp_2 = this.__this__13._deflater(this._windowBits7);
            suspendResult = tmp_2.uncompress_3(this._r0, new _no_name_provided__85(this._o1, this._chash12), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            if (this._r0._get_requirePrepare_()) {
              this._state_1 = 4;
              suspendResult = this._r0.prepareBigChunk(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 4:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 5;
            continue $sm;
          case 5:
            var adler32 = this._r0.su32BE();
            if (!(this._chash12._v === adler32)) {
              invalidOp('' + "Adler32 doesn't match " + _get_hex__0(this._chash12._v) + ' != ' + _get_hex__0(adler32));
            }
            return Unit_getInstance();
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $uncompressCOROUTINE$14.$metadata$ = {
    simpleName: '$uncompressCOROUTINE$14',
    kind: 'class',
    interfaces: []
  };
  function $compressCOROUTINE$15(_this_, i, o, context, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__14 = _this_;
    this._i_0 = i;
    this._o_0 = o;
    this._context_3 = context;
  }
  $compressCOROUTINE$15.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._slidingBits0 = 15;
            this._clevel1 = this._context_3._level_0 <= 0 ? 0 : this._context_3._level_0 < 6 ? 1 : this._context_3._level_0 < 9 ? 2 : 3;
            this._cmf2_0 = 8 | (this._slidingBits0 - 8 | 0) << 4;
            this._flg3_0 = 0 | this._clevel1 << 6;
            this._fcheck4 = 0;
            var inductionVariable = 0;
            if (inductionVariable < 32)
              $l$break: do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                if ((imul(this._cmf2_0, 256) + (this._flg3_0 | n) | 0) % 31 === 0) {
                  this._fcheck4 = n;
                  break $l$break;
                }}
               while (inductionVariable < 32);
            this._state_1 = 1;
            suspendResult = write8_0(this._o_0, this._cmf2_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._state_1 = 2;
            suspendResult = write8_0(this._o_0, this._flg3_0 | this._fcheck4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._adler5 = {_v: Adler32_getInstance()._initialValue};
            this._state_1 = 3;
            var tmp_0 = this.__this__14._deflater(this._slidingBits0);
            suspendResult = compress_1(tmp_0, new _no_name_provided__86(this._i_0, this._adler5), this._o_0, this._context_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            this._state_1 = 4;
            suspendResult = write32BE_0(this._o_0, this._adler5._v, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            suspendResult;
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $compressCOROUTINE$15.$metadata$ = {
    simpleName: '$compressCOROUTINE$15',
    kind: 'class',
    interfaces: []
  };
  function ZLib(deflater) {
    Companion_getInstance_42();
    this._deflater = deflater;
  }
  ZLib.prototype.uncompress_3 = function (reader, out, $cont) {
    var tmp = new $uncompressCOROUTINE$14(this, reader, out, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  ZLib.prototype.compress_3 = function (i, o, context, $cont) {
    var tmp = new $compressCOROUTINE$15(this, i, o, context, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  ZLib.$metadata$ = {
    simpleName: 'ZLib',
    kind: 'class',
    interfaces: [CompressionMethod]
  };
  function _no_name_provided_$factory_63() {
    var i = new _no_name_provided__84();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function _su8($this) {
    return $this._sbuffers.readByte_1();
  }
  function $prepareBytesUpToCOROUTINE$19(_this_, expectedBytes, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__15 = _this_;
    this._expectedBytes = expectedBytes;
  }
  $prepareBytesUpToCOROUTINE$19.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!(this.__this__15._sbuffers._get_availableRead__4() < this._expectedBytes)) {
              this._state_1 = 4;
              continue $sm;
            }
            this._state_1 = 2;
            suspendResult = this.__this__15._s.read_30(this.__this__15._tempBA, 0, min2_0(this.__this__15._tempBA.length, this._expectedBytes), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var read_1 = suspendResult;
            if (read_1 <= 0) {
              this._state_1 = 4;
              continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            this.__this__15._sbuffers.write_6(this.__this__15._tempBA, 0, read_1);
            Unit_getInstance();
            this._state_1 = 1;
            continue $sm;
          case 4:
            return this.__this__15;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $prepareBytesUpToCOROUTINE$19.$metadata$ = {
    simpleName: '$prepareBytesUpToCOROUTINE$19',
    kind: 'class',
    interfaces: []
  };
  function $abytesCOROUTINE$20(_this_, count_0, out, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__16 = _this_;
    this._count = count_0;
    this._out_2 = out;
  }
  $abytesCOROUTINE$20.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__16.prepareBytesUpTo(this._count, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.sbytes(this._count, this._out_2);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $abytesCOROUTINE$20.$metadata$ = {
    simpleName: '$abytesCOROUTINE$20',
    kind: 'class',
    interfaces: []
  };
  function $readCOROUTINE$21(_this_, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__17 = _this_;
    this._buffer_7 = buffer;
    this._offset_3 = offset;
    this._len_1 = len;
  }
  $readCOROUTINE$21.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__17.prepareBytesUpTo(this._len_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT._sbuffers;
            return ARGUMENT_0.read_30(this._buffer_7, this._offset_3, this._len_1);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$21.$metadata$ = {
    simpleName: '$readCOROUTINE$21',
    kind: 'class',
    interfaces: []
  };
  function BitReader(s) {
    this._s = s;
    this._bitdata = 0;
    this._bitsavailable = 0;
    var tmp = this;
    tmp._sbuffers = ByteArrayDeque_init_$Create$(0, 1, null);
    this._BIG_CHUNK_SIZE = 8192;
    this._tempBA = new Int8Array(this._BIG_CHUNK_SIZE);
    this._temp = new Int8Array(4);
  }
  BitReader.prototype._get_requirePrepare_ = function () {
    return this._sbuffers._get_availableRead__4() < this._BIG_CHUNK_SIZE;
  };
  BitReader.prototype.prepareBigChunk = function ($cont) {
    return this.prepareBytesUpTo(this._BIG_CHUNK_SIZE, $cont);
  };
  BitReader.prototype.prepareBytesUpTo = function (expectedBytes, $cont) {
    var tmp = new $prepareBytesUpToCOROUTINE$19(this, expectedBytes, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  BitReader.prototype.readBits = function (bitcount) {
    while (this._bitsavailable < bitcount) {
      this._bitdata = this._bitdata | _su8(this) << this._bitsavailable;
      var tmp0_this = this;
      tmp0_this._bitsavailable = tmp0_this._bitsavailable + 8 | 0;
    }
    var readed = this._bitdata & ((1 << bitcount) - 1 | 0);
    this._bitdata = this._bitdata >>> bitcount;
    var tmp1_this = this;
    tmp1_this._bitsavailable = tmp1_this._bitsavailable - bitcount | 0;
    return readed;
  };
  BitReader.prototype.sreadBit = function () {
    return !(this.readBits(1) === 0);
  };
  BitReader.prototype.sbytes_noalign = function (count_0, out) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = toByte(_su8(this));
      }
       while (inductionVariable < count_0);
    return out;
  };
  BitReader.prototype.sbytes = function (count_0, out) {
    this._bitdata = 0;
    this._bitsavailable = 0;
    return this.sbytes_noalign(count_0, out);
  };
  BitReader.prototype.su8 = function () {
    this._bitdata = 0;
    this._bitsavailable = 0;
    return _su8(this);
  };
  BitReader.prototype.su16LE = function () {
    return readU16LE(this.sbytes(2, this._temp), 0);
  };
  BitReader.prototype.su32LE = function () {
    return readS32LE(this.sbytes(4, this._temp), 0);
  };
  BitReader.prototype.su32BE = function () {
    return readS32BE(this.sbytes(4, this._temp), 0);
  };
  BitReader.prototype.abytes = function (count_0, out, $cont) {
    var tmp = new $abytesCOROUTINE$20(this, count_0, out, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  BitReader.prototype.abytes$default = function (count_0, out, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      out = new Int8Array(count_0);
    return this.abytes(count_0, out, $cont);
  };
  BitReader.prototype.read_30 = function (buffer, offset, len, $cont) {
    var tmp = new $readCOROUTINE$21(this, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  BitReader.prototype.close_77 = function ($cont) {
    return this._s.close_77($cont);
  };
  BitReader.prototype.getPosition_5 = function ($cont) {
    return this._sbuffers._read;
  };
  BitReader.prototype.getLength_14 = function ($cont) {
    return this._s.getLength_14($cont);
  };
  BitReader.$metadata$ = {
    simpleName: 'BitReader',
    kind: 'class',
    interfaces: [AsyncInputStreamWithLength]
  };
  function Companion_44() {
    Companion_instance_43 = this;
    this._INVALID_VALUE = -1;
    this._NIL_1 = 1023;
    this._FAST_BITS = 9;
    this._MAX_LEN = 16;
    this._MAX_CODES = 288;
  }
  Companion_44.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_43;
  function Companion_getInstance_43() {
    if (Companion_instance_43 == null)
      new Companion_44();
    return Companion_instance_43;
  }
  function resetAlloc($this) {
    $this._nodeOffset = 0;
  }
  function alloc($this, value, left, right) {
    var tmp0_this = $this;
    var tmp1 = tmp0_this._nodeOffset;
    tmp0_this._nodeOffset = tmp1 + 1 | 0;
    var tmp0_apply_0 = tmp1;
    $this._value_10[tmp0_apply_0] = value;
    $this._left_0[tmp0_apply_0] = left;
    $this._right[tmp0_apply_0] = right;
    return tmp0_apply_0;
  }
  function allocLeaf($this, value) {
    return alloc($this, value, 1023, 1023);
  }
  function allocNode($this, left, right) {
    return alloc($this, -1, left, right);
  }
  function HuffmanTree() {
    Companion_getInstance_43();
    this._value_10 = new Int32Array(1024);
    this._left_0 = new Int32Array(1024);
    this._right = new Int32Array(1024);
    this._nodeOffset = 0;
    this._root = 1023;
    this._ncodes = 0;
    this._COUNTS = new Int32Array(17);
    this._OFFSETS = new Int32Array(17);
    this._COFFSET = new Int32Array(17);
    this._CODES = new Int32Array(288);
    this._ENCODED_VAL = new Int32Array(288);
    this._ENCODED_LEN = new Int8Array(288);
  }
  HuffmanTree.prototype.read_11 = function (reader) {
    var node = this._root;
    $l$1: do {
      $l$0: do {
        var tmp;
        if (reader.sreadBit()) {
          var tmp0__get_right__0 = node;
          tmp = this._right[tmp0__get_right__0];
        } else {
          var tmp1__get_left__0 = node;
          tmp = this._left_0[tmp1__get_left__0];
        }
        node = tmp;
      }
       while (false);
      var tmp_0;
      if (!(node === 1023)) {
        var tmp2__get_value__0 = node;
        tmp_0 = this._value_10[tmp2__get_value__0] === -1;
      } else {
        tmp_0 = false;
      }
    }
     while (tmp_0);
    var tmp3__get_value__0 = node;
    return this._value_10[tmp3__get_value__0];
  };
  HuffmanTree.prototype.fromLengths = function (codeLengths, start, end) {
    var oldOffset = 0;
    var oldCount = 0;
    var ncodes = end - start | 0;
    resetAlloc(this);
    var tmp0_fill_0 = this._COUNTS;
    var tmp1_fill_0 = 0;
    var tmp2_fill_0 = 0;
    var tmp3_fill_0 = tmp0_fill_0.length;
    fill_0(tmp0_fill_0, tmp1_fill_0, tmp2_fill_0, tmp3_fill_0);
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var codeLen = codeLengths[n];
        if (!(0 <= codeLen ? codeLen <= 16 : false)) {
          var tmp4_error_0 = '' + 'Invalid HuffmanTree.codeLengths ' + codeLen;
          throw IllegalStateException_init_$Create$_0(toString_1(tmp4_error_0));
        }var tmp1_array = this._COUNTS;
        var tmp2_index0 = codeLen;
        var tmp3 = tmp1_array[tmp2_index0];
        tmp1_array[tmp2_index0] = tmp3 + 1 | 0;
        Unit_getInstance();
      }
       while (inductionVariable < end);
    var currentOffset = 0;
    var inductionVariable_0 = 0;
    var last_1 = 16;
    if (inductionVariable_0 < last_1)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var count_0 = this._COUNTS[n_0];
        this._OFFSETS[n_0] = currentOffset;
        this._COFFSET[n_0] = currentOffset;
        currentOffset = currentOffset + count_0 | 0;
      }
       while (inductionVariable_0 < last_1);
    var inductionVariable_1 = start;
    if (inductionVariable_1 < end)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var codeLen_0 = codeLengths[n_1];
        var tmp6_array = this._COFFSET;
        var tmp7_index0 = codeLen_0;
        var tmp8 = tmp6_array[tmp7_index0];
        tmp6_array[tmp7_index0] = tmp8 + 1 | 0;
        this._CODES[tmp8] = n_1 - start | 0;
      }
       while (inductionVariable_1 < end);
    var inductionVariable_2 = 16;
    if (1 <= inductionVariable_2)
      do {
        var i = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + -1 | 0;
        var newOffset = this._nodeOffset;
        var OFFSET = this._OFFSETS[i];
        var SIZE = this._COUNTS[i];
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < SIZE)
          do {
            var j = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            allocLeaf(this, this._CODES[OFFSET + j | 0]);
            Unit_getInstance();
          }
           while (inductionVariable_3 < SIZE);
        var progression = step(until(0, oldCount), 2);
        var inductionVariable_4 = progression._first_0;
        var last_2 = progression._last;
        var step_0 = progression._step_2;
        if ((step_0 > 0 ? inductionVariable_4 <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable_4 : false)
          do {
            var j_0 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + step_0 | 0;
            allocNode(this, oldOffset + j_0 | 0, (oldOffset + j_0 | 0) + 1 | 0);
            Unit_getInstance();
          }
           while (!(j_0 === last_2));
        oldOffset = newOffset;
        oldCount = SIZE + (oldCount / 2 | 0) | 0;
        if (oldCount >= 2 ? !(oldCount % 2 === 0) : false) {
          var tmp5_error_0 = '' + 'This canonical code does not represent a Huffman code tree: ' + oldCount;
          throw IllegalStateException_init_$Create$_0(toString_1(tmp5_error_0));
        }}
       while (1 <= inductionVariable_2);
    if (!(oldCount === 2)) {
      var tmp6_error_0 = 'This canonical code does not represent a Huffman code tree';
      throw IllegalStateException_init_$Create$_0(toString_1(tmp6_error_0));
    }this._root = allocNode(this, this._nodeOffset - 2 | 0, this._nodeOffset - 1 | 0);
    this._ncodes = ncodes;
    return this;
  };
  HuffmanTree.prototype.fromLengths$default = function (codeLengths, start, end, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      start = 0;
    if (!(($mask0 & 4) === 0))
      end = codeLengths.length;
    return this.fromLengths(codeLengths, start, end);
  };
  HuffmanTree.$metadata$ = {
    simpleName: 'HuffmanTree',
    kind: 'class',
    interfaces: []
  };
  function SlidingWindow(nbits) {
    this._nbits_1 = nbits;
    this._data_10 = new Int8Array(1 << this._nbits_1);
    this._mask_4 = this._data_10.length - 1 | 0;
    this._pos = 0;
  }
  SlidingWindow.prototype.get_137 = function (offset) {
    return this._data_10[(this._pos - offset | 0) & this._mask_4] & 255;
  };
  SlidingWindow.prototype.getPut = function (offset) {
    return this.put_14(this.get_137(offset));
  };
  SlidingWindow.prototype.put_14 = function (value) {
    this._data_10[this._pos] = toByte(value);
    this._pos = (this._pos + 1 | 0) & this._mask_4;
    return value;
  };
  SlidingWindow.prototype.putBytes = function (bytes, offset, len) {
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__get_unsigned__0 = bytes[offset + n | 0];
        this.put_14(tmp0__get_unsigned__0 & 255);
        Unit_getInstance();
      }
       while (inductionVariable < len);
  };
  SlidingWindow.$metadata$ = {
    simpleName: 'SlidingWindow',
    kind: 'class',
    interfaces: []
  };
  function $invokeCOROUTINE$24(_this_, s, caseSensitive, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__18 = _this_;
    this._s_0 = s;
    this._caseSensitive = caseSensitive;
  }
  $invokeCOROUTINE$24.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_also_00 = new ZipFile(false, this._s_0, this._caseSensitive);
            this._state_1 = 1;
            suspendResult = read_0(this._tmp0_also_00, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return this._tmp0_also_00;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $invokeCOROUTINE$24.$metadata$ = {
    simpleName: '$invokeCOROUTINE$24',
    kind: 'class',
    interfaces: []
  };
  function Companion_45() {
    Companion_instance_44 = this;
    var tmp = this;
    var tmp0_byteArrayOf_0 = new Int8Array([80, 75, 5, 6]);
    tmp._PK_END = tmp0_byteArrayOf_0;
  }
  Companion_45.prototype.invoke_145 = function (s, caseSensitive, $cont) {
    var tmp = new $invokeCOROUTINE$24(this, s, caseSensitive, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Companion_45.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_44;
  function Companion_getInstance_44() {
    if (Companion_instance_44 == null)
      new Companion_45();
    return Companion_instance_44;
  }
  function read_0($this, $cont) {
    var tmp = new $readCOROUTINE$25($this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function $readCOROUTINE$25(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__19 = _this_;
  }
  $readCOROUTINE$25.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 18;
            this._endBytes0 = EMPTY_BYTE_ARRAY;
            this._state_1 = 1;
            suspendResult = this.__this__19._s_1.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1 = suspendResult;
            if (this._ARGUMENT1.compareTo_137(new Long(8, 0)) <= 0) {
              this._state_1 = 17;
              suspendResult = this.__this__19._s_1.getLength_14(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this._pk_endIndex2 = -1;
            this._state_1 = 3;
            suspendResult = this.__this__19._s_1.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._fileLength3 = suspendResult;
            this._tmp0_iterator4 = listOf([22, 256, 4096, 65536]).iterator_67();
            this._state_1 = 4;
            continue $sm;
          case 4:
            if (!this._tmp0_iterator4.hasNext_33()) {
              this._state_1 = 9;
              continue $sm;
            }
            this._chunkSize5 = this._tmp0_iterator4.next_37();
            var tmp_0 = this;
            var tmp_1 = new Long(0, 0);
            tmp_0._pos6 = max2_2(tmp_1, this._fileLength3.minus_29(toLong(this._chunkSize5)));
            this._state_1 = 5;
            suspendResult = this.__this__19._s_1.setPosition_0(this._pos6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            suspendResult;
            this._state_1 = 6;
            suspendResult = this.__this__19._s_1.getAvailable(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._ARGUMENT7 = suspendResult;
            var tmp_2 = this;
            tmp_2._ARGUMENT8 = toIntClamp$default(this._ARGUMENT7, 0, 0, 3, null);
            this._bytesLen9 = max2_1(this._chunkSize5, this._ARGUMENT8);
            this._state_1 = 7;
            suspendResult = readBytesExact(this.__this__19._s_1, this._bytesLen9, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._ebytes10 = suspendResult;
            this._endBytes0 = this._ebytes10;
            this._pk_endIndex2 = indexOf_8(this._endBytes0, Companion_getInstance_44()._PK_END);
            if (this._pk_endIndex2 >= 0) {
              this._state_1 = 9;
              continue $sm;
            } else {
              this._state_1 = 8;
              continue $sm;
            }

            break;
          case 8:
            this._state_1 = 4;
            continue $sm;
          case 9:
            if (this._pk_endIndex2 < 0) {
              this._ARGUMENT11 = this._pk_endIndex2;
              this._ARGUMENT12 = _get_hex_(sliceArray(this._endBytes0, until(this._endBytes0.length - 32 | 0, this._endBytes0.length)));
              this._state_1 = 16;
              suspendResult = this.__this__19._s_1.getLength_14(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 10;
              continue $sm;
            }

            break;
          case 10:
            var tmp_3 = this;
            var tmp_4 = copyOfRange(this._endBytes0, this._pk_endIndex2, this._endBytes0.length);
            tmp_3._data13 = openSync$default(tmp_4, null, 1, null);
            this._magic_214 = readS32BE_1(this._data13);
            if (!(this._magic_214 === 1347093766))
              throw IllegalStateException_init_$Create$_0('' + 'Not a zip file ' + _get_hex__0(this._magic_214) + ' instead of ' + _get_hex__0(1347092738));
            this._diskNumber_315 = readU16LE_1(this._data13);
            this._startDiskNumber_416 = readU16LE_1(this._data13);
            this._entriesOnDisk_517 = readU16LE_1(this._data13);
            this._entriesInDirectory_618 = readU16LE_1(this._data13);
            this._directorySize_719 = readS32LE_1(this._data13);
            this._directoryOffset_820 = readS32LE_1(this._data13);
            this._commentLength_921 = readU16LE_1(this._data13);
            this._state_1 = 11;
            var tmp_5 = toLong(this._directoryOffset_820);
            var tmp_6 = toLong(this._directorySize_719);
            suspendResult = sliceWithSize$default(this.__this__19._s_1, tmp_5, tmp_6, false, 4, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._ARGUMENT22 = suspendResult;
            this._state_1 = 12;
            suspendResult = readAvailable(this._ARGUMENT22, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 12:
            this._ARGUMENT23 = suspendResult;
            var tmp_7 = this;
            tmp_7._ds_1024 = openSync$default(this._ARGUMENT23, null, 1, null);
            this._tmp0_iterator_1125 = until(0, this._entriesInDirectory_618).iterator_67();
            this._state_1 = 13;
            continue $sm;
          case 13:
            if (!this._tmp0_iterator_1125.hasNext_33()) {
              this._state_1 = 15;
              continue $sm;
            }
            this._n_1226 = this._tmp0_iterator_1125.next_37();
            this._magic_2_1327 = readS32BE_1(this._ds_1024);
            if (!(this._magic_2_1327 === 1347092738))
              throw IllegalStateException_init_$Create$_0('' + 'Not a zip file record ' + _get_hex__0(this._magic_2_1327) + ' instead of ' + _get_hex__0(1347092738));
            this._versionMade_3_1428 = readU16LE_1(this._ds_1024);
            this._versionExtract_4_1529 = readU16LE_1(this._ds_1024);
            this._flags_5_1630 = readU16LE_1(this._ds_1024);
            this._compressionMethod_6_1731 = readU16LE_1(this._ds_1024);
            this._fileTime_7_1832 = readU16LE_1(this._ds_1024);
            this._fileDate_8_1933 = readU16LE_1(this._ds_1024);
            this._crc_9_2034 = readS32LE_1(this._ds_1024);
            this._compressedSize_10_2135 = readS32LE_1(this._ds_1024);
            this._uncompressedSize_11_2236 = readS32LE_1(this._ds_1024);
            this._fileNameLength_12_2337 = readU16LE_1(this._ds_1024);
            this._extraLength_13_2438 = readU16LE_1(this._ds_1024);
            this._fileCommentLength_14_2539 = readU16LE_1(this._ds_1024);
            this._diskNumberStart_15_2640 = readU16LE_1(this._ds_1024);
            this._internalAttributes_16_2741 = readU16LE_1(this._ds_1024);
            this._externalAttributes_17_2842 = readS32LE_1(this._ds_1024);
            this._headerOffset_18_2943 = readU32LE_1(this._ds_1024);
            var tmp_8 = this;
            tmp_8._name_19_3044 = readString$default_0(this._ds_1024, this._fileNameLength_12_2337, null, 2, null);
            this._extra_20_3145 = readBytes_0(this._ds_1024, this._extraLength_13_2438);
            var tmp_9 = this;
            tmp_9._isDirectory_21_3246 = endsWith$default_1(this._name_19_3044, '/', false, 2, null);
            this._normalizedName_22_3347 = this.__this__19.normalizeName_1(this._name_19_3044);
            this._baseFolder_23_3448 = substringBeforeLast(this._normalizedName_22_3347, new Char(47), '');
            var tmp_10 = this;
            var tmp_11 = new Char(47);
            tmp_10._baseName_24_3549 = substringAfterLast$default(this._normalizedName_22_3347, tmp_11, null, 2, null);
            var tmp_12 = this;
            var tmp_13 = this;
            tmp_13._tmp0_getOrPut_0_26_3750 = this.__this__19._filesPerFolder;
            this._value_1_27_3851 = this._tmp0_getOrPut_0_26_3750.get_116(this._baseFolder_23_3448);
            var tmp_14;
            if (this._value_1_27_3851 == null) {
              var answer_2_28_39 = LinkedHashMap_init_$Create$();
              this._tmp0_getOrPut_0_26_3750.put_18(this._baseFolder_23_3448, answer_2_28_39);
              Unit_getInstance();
              tmp_14 = answer_2_28_39;
            } else {
              tmp_14 = this._value_1_27_3851;
            }

            tmp_12._folder_25_3652 = tmp_14;
            this._state_1 = 14;
            suspendResult = sliceStart$default(this.__this__19._s_1, this._headerOffset_18_2943, false, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 14:
            var headerEntry_29_40 = suspendResult;
            var tmp0_time_31_42 = new DosFileDateTime(this._fileTime_7_1832, this._fileDate_8_1933);
            var tmp1_inode_32_43 = toLong(this._n_1226);
            var tmp2_offset_33_44 = this._headerOffset_18_2943.toInt_8();
            var tmp3_compressedSize_34_45 = toLong(this._compressedSize_10_2135).and(new Long(-1, 0));
            var tmp4_uncompressedSize_35_46 = toLong(this._uncompressedSize_11_2236).and(new Long(-1, 0));
            var entry_30_41 = new ZipEntry2(this._name_19_3044, this._compressionMethod_6_1731, this._isDirectory_21_3246, tmp0_time_31_42, tmp2_offset_33_44, tmp1_inode_32_43, headerEntry_29_40, tmp3_compressedSize_34_45, tmp4_uncompressedSize_35_46);
            var components_36_47 = plus(listOf_0(''), getPathFullComponents(_PathInfo___init__impl_(this._normalizedName_22_3347)));
            var inductionVariable = 1;
            var last_1 = components_36_47._get_size__60();
            if (inductionVariable < last_1)
              do {
                var m_38_49 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var f_39_50 = components_36_47.get_137(m_38_49 - 1 | 0);
                var c_40_51 = components_36_47.get_137(m_38_49);
                var tmp1_contains_0_41_52 = this.__this__19._files;
                if (!(isInterface(tmp1_contains_0_41_52, Map_0) ? tmp1_contains_0_41_52 : THROW_CCE()).containsKey_11(c_40_51)) {
                  var tmp2_getOrPut_0_43_54 = this.__this__19._filesPerFolder;
                  var value_1_44_55 = tmp2_getOrPut_0_43_54.get_116(f_39_50);
                  var tmp_15;
                  if (value_1_44_55 == null) {
                    var answer_2_45_56 = LinkedHashMap_init_$Create$();
                    tmp2_getOrPut_0_43_54.put_18(f_39_50, answer_2_45_56);
                    Unit_getInstance();
                    tmp_15 = answer_2_45_56;
                  } else {
                    tmp_15 = value_1_44_55;
                  }
                  var folder2_42_53 = tmp_15;
                  var tmp6_time_47_58 = new DosFileDateTime(0, 0);
                  var tmp3_byteArrayOf_0_49_60 = new Int8Array([]);
                  var tmp7_headerEntry_48_59 = openAsync$default(tmp3_byteArrayOf_0_49_60, null, 1, null);
                  var entry2_46_57 = new ZipEntry2(c_40_51, 0, true, tmp6_time_47_58, 0, new Long(0, 0), tmp7_headerEntry_48_59, new Long(0, 0), new Long(0, 0));
                  var tmp4_set_0_50_61 = _get_baseName__0(_PathInfo___init__impl_(c_40_51));
                  folder2_42_53.put_18(tmp4_set_0_50_61, entry2_46_57);
                  Unit_getInstance();
                  var tmp5_set_0_51_62 = this.__this__19._files;
                  tmp5_set_0_51_62.put_18(c_40_51, entry2_46_57);
                  Unit_getInstance();
                } else {
                }
              }
               while (inductionVariable < last_1);
            this._folder_25_3652.put_18(this._baseName_24_3549, entry_30_41);
            Unit_getInstance();
            var tmp6_set_0_52_63 = this.__this__19._files;
            tmp6_set_0_52_63.put_18(this._normalizedName_22_3347, entry_30_41);
            Unit_getInstance();
            Unit_getInstance();
            this._state_1 = 13;
            continue $sm;
          case 15:
            var tmp1_set_0_64 = this.__this__19._files;
            var tmp2_set_0_65 = '';
            var tmp1_time_67 = new DosFileDateTime(0, 0);
            var tmp0_byteArrayOf_0_69 = new Int8Array([]);
            var tmp2_headerEntry_68 = openAsync$default(tmp0_byteArrayOf_0_69, null, 1, null);
            var tmp3_set_0_66 = new ZipEntry2('', 0, true, tmp1_time_67, 0, new Long(0, 0), tmp2_headerEntry_68, new Long(0, 0), new Long(0, 0));
            tmp1_set_0_64.put_18(tmp2_set_0_65, tmp3_set_0_66);
            Unit_getInstance();
            Unit_getInstance();
            Unit_getInstance();
            return Unit_getInstance();
          case 16:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = '' + 'Not a zip file (pk_endIndex < 0) : pk_endIndex=' + this._ARGUMENT11 + ' : ' + this._ARGUMENT12 + ' : ' + ARGUMENT;
            throw IllegalArgumentException_init_$Create$(ARGUMENT_0);
          case 17:
            var ARGUMENT_1 = suspendResult;
            var ARGUMENT_2 = '' + 'Zip file is too small length=' + ARGUMENT_1;
            throw IllegalArgumentException_init_$Create$(ARGUMENT_2);
          case 18:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 18) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$25.$metadata$ = {
    simpleName: '$readCOROUTINE$25',
    kind: 'class',
    interfaces: []
  };
  function ZipFile(dummy, s, caseSensitive) {
    Companion_getInstance_44();
    this._dummy_0 = dummy;
    this._s_1 = s;
    this._caseSensitive_0 = caseSensitive;
    this._files = LinkedHashMap_init_$Create$();
    this._filesPerFolder = LinkedHashMap_init_$Create$();
  }
  ZipFile.prototype.normalizeName_1 = function (name) {
    var tmp;
    if (this._caseSensitive_0) {
      tmp = trim(name, charArrayOf([new Char(47)]));
    } else {
      var tmp0_toLowerCase_0 = trim(name, charArrayOf([new Char(47)]));
      tmp = tmp0_toLowerCase_0.toLowerCase();
    }
    return tmp;
  };
  ZipFile.$metadata$ = {
    simpleName: 'ZipFile',
    kind: 'class',
    interfaces: []
  };
  function ZipEntry2(path_0, compressionMethod, isDirectory, time, offset, inode, headerEntry, compressedSize, uncompressedSize) {
    this._path = path_0;
    this._compressionMethod = compressionMethod;
    this._isDirectory = isDirectory;
    this._time_1 = time;
    this._offset_4 = offset;
    this._inode = inode;
    this._headerEntry = headerEntry;
    this._compressedSize = compressedSize;
    this._uncompressedSize = uncompressedSize;
  }
  ZipEntry2.prototype.toString = function () {
    return '' + 'ZipEntry2(path=' + this._path + ', compressionMethod=' + this._compressionMethod + ', isDirectory=' + this._isDirectory + ', time=' + this._time_1 + ', offset=' + this._offset_4 + ', inode=' + this._inode + ', headerEntry=' + this._headerEntry + ', compressedSize=' + this._compressedSize + ', uncompressedSize=' + this._uncompressedSize + ')';
  };
  ZipEntry2.prototype.hashCode = function () {
    var result = getStringHashCode(this._path);
    result = imul(result, 31) + this._compressionMethod | 0;
    result = imul(result, 31) + (this._isDirectory | 0) | 0;
    result = imul(result, 31) + this._time_1.hashCode() | 0;
    result = imul(result, 31) + this._offset_4 | 0;
    result = imul(result, 31) + this._inode.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._headerEntry) | 0;
    result = imul(result, 31) + this._compressedSize.hashCode() | 0;
    result = imul(result, 31) + this._uncompressedSize.hashCode() | 0;
    return result;
  };
  ZipEntry2.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ZipEntry2))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ZipEntry2 ? other : THROW_CCE();
    if (!(this._path === tmp0_other_with_cast._path))
      return false;
    if (!(this._compressionMethod === tmp0_other_with_cast._compressionMethod))
      return false;
    if (!(this._isDirectory === tmp0_other_with_cast._isDirectory))
      return false;
    if (!this._time_1.equals(tmp0_other_with_cast._time_1))
      return false;
    if (!(this._offset_4 === tmp0_other_with_cast._offset_4))
      return false;
    if (!this._inode.equals(tmp0_other_with_cast._inode))
      return false;
    if (!equals_1(this._headerEntry, tmp0_other_with_cast._headerEntry))
      return false;
    if (!this._compressedSize.equals(tmp0_other_with_cast._compressedSize))
      return false;
    if (!this._uncompressedSize.equals(tmp0_other_with_cast._uncompressedSize))
      return false;
    return true;
  };
  ZipEntry2.$metadata$ = {
    simpleName: 'ZipEntry2',
    kind: 'class',
    interfaces: []
  };
  function DosFileDateTime(dosTime, dosDate) {
    this._dosTime = dosTime;
    this._dosDate = dosDate;
    var tmp = this;
    var tmp_0 = Companion_getInstance_18();
    var tmp_1 = this._get_fullYear_();
    var tmp_2 = this._get_month1_();
    var tmp_3 = this._get_day_();
    var tmp_4 = this._get_hours_();
    var tmp_5 = this._get_minutes_();
    var tmp_6 = this._get_seconds_();
    tmp._utc = tmp_0.createAdjusted$default(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, 0, 64, null);
  }
  DosFileDateTime.prototype._get_seconds_ = function () {
    return imul(2, extract(this._dosTime, 0, 5));
  };
  DosFileDateTime.prototype._get_minutes_ = function () {
    return extract(this._dosTime, 5, 6);
  };
  DosFileDateTime.prototype._get_hours_ = function () {
    return extract(this._dosTime, 11, 5);
  };
  DosFileDateTime.prototype._get_day_ = function () {
    return extract(this._dosDate, 0, 5);
  };
  DosFileDateTime.prototype._get_month1_ = function () {
    return extract(this._dosDate, 5, 4);
  };
  DosFileDateTime.prototype._get_fullYear_ = function () {
    return 1980 + extract(this._dosDate, 9, 7) | 0;
  };
  DosFileDateTime.prototype.toString = function () {
    return '' + 'DosFileDateTime(dosTime=' + this._dosTime + ', dosDate=' + this._dosDate + ')';
  };
  DosFileDateTime.prototype.hashCode = function () {
    var result = this._dosTime;
    result = imul(result, 31) + this._dosDate | 0;
    return result;
  };
  DosFileDateTime.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DosFileDateTime))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DosFileDateTime ? other : THROW_CCE();
    if (!(this._dosTime === tmp0_other_with_cast._dosTime))
      return false;
    if (!(this._dosDate === tmp0_other_with_cast._dosDate))
      return false;
    return true;
  };
  DosFileDateTime.$metadata$ = {
    simpleName: 'DosFileDateTime',
    kind: 'class',
    interfaces: []
  };
  function KorAtomicRef(initial, dummy) {
    this._value_11 = initial;
  }
  KorAtomicRef.prototype._get_value__10 = function () {
    return this._value_11;
  };
  KorAtomicRef.$metadata$ = {
    simpleName: 'KorAtomicRef',
    kind: 'class',
    interfaces: [KorAtomicBase]
  };
  function KorAtomicRef_0(initial) {
    return korAtomic(initial);
  }
  function KorAtomicBase() {
  }
  KorAtomicBase.$metadata$ = {
    simpleName: 'KorAtomicBase',
    kind: 'interface',
    interfaces: []
  };
  function KorAtomicBoolean(initial, dummy) {
    this._value_12 = initial;
  }
  KorAtomicBoolean.prototype._set_value__2 = function (_set___) {
    this._value_12 = _set___;
  };
  KorAtomicBoolean.prototype._get_value__10 = function () {
    return this._value_12;
  };
  KorAtomicBoolean.$metadata$ = {
    simpleName: 'KorAtomicBoolean',
    kind: 'class',
    interfaces: [KorAtomicBase]
  };
  function _Dyn___init__impl_(value) {
    return value;
  }
  function _Dyn___get_value__impl_(this_0) {
    return this_0;
  }
  function Companion_46() {
    Companion_instance_45 = this;
  }
  Companion_46.prototype._get_global_ = function () {
    return _get_dyn_(dynApi._get_global__4());
  };
  Companion_46.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_45;
  function Companion_getInstance_45() {
    if (Companion_instance_45 == null)
      new Companion_46();
    return Companion_instance_45;
  }
  function Dyn__set_impl(this_0, key, value) {
    var tmp0_subject = value;
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, MutableMap) : false) {
      var tmp = _Dyn___get_value__impl_(this_0);
      var tmp0_set_0 = (!(tmp == null) ? isInterface(tmp, MutableMap) : false) ? tmp : THROW_CCE();
      tmp0_set_0.put_18(key, value);
      Unit_getInstance();
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, MutableList) : false) {
        var tmp_0 = _Dyn___get_value__impl_(this_0);
        ((!(tmp_0 == null) ? isInterface(tmp_0, MutableList) : false) ? tmp_0 : THROW_CCE()).set_8(Dyn__toInt_impl(_get_dyn_(key)), value);
        Unit_getInstance();
      } else {
        dynApi.set_17(_Dyn___get_value__impl_(this_0), toString_0(key), value);
      }
    }
  }
  function _Dyn___get_listAny__impl_(this_0) {
    var tmp;
    if (_Dyn___get_value__impl_(this_0) == null) {
      tmp = emptyList();
    } else {
      var tmp_0 = _Dyn___get_value__impl_(this_0);
      if (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) {
        tmp = _Dyn___get_value__impl_(this_0);
      } else {
        var tmp_1 = _Dyn___get_value__impl_(this_0);
        if (!(tmp_1 == null) ? isInterface(tmp_1, Iterable) : false) {
          tmp = toList_2(_Dyn___get_value__impl_(this_0));
        } else {
          {
            tmp = listOf_0(_Dyn___get_value__impl_(this_0));
          }
        }
      }
    }
    return tmp;
  }
  function Dyn__toNumber_impl(this_0, receiver) {
    var tmp = toIntOrNull(receiver);
    var tmp0_elvis_lhs = (tmp == null ? true : isNumber(tmp)) ? tmp : null;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? toDoubleOrNull(receiver) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? NaN : tmp1_elvis_lhs;
  }
  function Dyn__toBool_impl(this_0, extraStrings) {
    var tmp0_subject = _Dyn___get_value__impl_(this_0);
    var tmp;
    if (tmp0_subject == null) {
      tmp = false;
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
        tmp = _Dyn___get_value__impl_(this_0);
      } else {
        {
          var tmp1_elvis_lhs = Dyn__toBoolOrNull_impl(this_0, extraStrings);
          tmp = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
        }
      }
    }
    return tmp;
  }
  function Dyn__toBool$default_impl(this_0, extraStrings, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      extraStrings = true;
    return Dyn__toBool_impl(this_0, extraStrings);
  }
  function Dyn__toBoolOrNull_impl(this_0, extraStrings) {
    var tmp0_subject = _Dyn___get_value__impl_(this_0);
    var tmp;
    if (tmp0_subject == null) {
      tmp = null;
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
        tmp = _Dyn___get_value__impl_(this_0);
      } else {
        if (isNumber(tmp0_subject)) {
          tmp = !(Dyn__toDouble_impl(this_0) === 0.0);
        } else {
          if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
            var tmp_0;
            if (extraStrings) {
              var tmp0_toLowerCase_0 = _Dyn___get_value__impl_(this_0);
              var tmp1_subject = tmp0_toLowerCase_0.toLowerCase();
              switch (tmp1_subject) {
                case '':
                case '0':
                case 'false':
                case 'NaN':
                case 'null':
                case 'undefined':
                case 'ko':
                case 'no':
                  tmp_0 = false;
                  break;
                default:tmp_0 = true;
                  break;
              }
            } else {
              var tmp_1;
              var tmp_2;
              var tmp1_isNotEmpty_0 = _Dyn___get_value__impl_(this_0);
              if (charSequenceLength(tmp1_isNotEmpty_0) > 0) {
                tmp_2 = !equals_1(_Dyn___get_value__impl_(this_0), '0');
              } else {
                {
                  tmp_2 = false;
                }
              }
              if (tmp_2) {
                tmp_1 = !equals_1(_Dyn___get_value__impl_(this_0), 'false');
              } else {
                {
                  tmp_1 = false;
                }
              }
              tmp_0 = tmp_1;
            }
            tmp = tmp_0;
          } else {
            {
              tmp = null;
            }
          }
        }
      }
    }
    return tmp;
  }
  function Dyn__toNumber_impl_0(this_0) {
    var tmp0_subject = _Dyn___get_value__impl_(this_0);
    var tmp;
    if (tmp0_subject == null) {
      tmp = 0;
    } else {
      if (isNumber(tmp0_subject)) {
        tmp = _Dyn___get_value__impl_(this_0);
      } else {
        if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
          tmp = _Dyn___get_value__impl_(this_0) ? 1 : 0;
        } else {
          if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
            var tmp_0 = _Dyn___get_value__impl_(this_0);
            var tmp1_elvis_lhs = toIntSafe$default(tmp_0, 0, 1, null);
            var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? toDoubleSafe(_Dyn___get_value__impl_(this_0)) : tmp1_elvis_lhs;
            tmp = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
          } else {
            {
              tmp = Dyn__toNumber_impl(this_0, toString_1(_Dyn___get_value__impl_(this_0)));
            }
          }
        }
      }
    }
    return tmp;
  }
  function Dyn__toByte_impl(this_0) {
    return numberToByte(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toChar_impl(this_0) {
    var tmp;
    var tmp_0 = _Dyn___get_value__impl_(this_0);
    if (tmp_0 instanceof Char) {
      tmp = _Dyn___get_value__impl_(this_0);
    } else {
      var tmp_1;
      var tmp_2 = _Dyn___get_value__impl_(this_0);
      if (!(tmp_2 == null) ? typeof tmp_2 === 'string' : false) {
        tmp_1 = _Dyn___get_value__impl_(this_0).length === 1;
      } else {
        {
          tmp_1 = false;
        }
      }
      if (tmp_1) {
        tmp = first_1(_Dyn___get_value__impl_(this_0));
      } else {
        {
          tmp = numberToChar(Dyn__toNumber_impl_0(this_0));
        }
      }
    }
    return tmp;
  }
  function Dyn__toShort_impl(this_0) {
    return numberToShort(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toInt_impl(this_0) {
    return numberToInt(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toLong_impl(this_0) {
    return numberToLong(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toFloat_impl(this_0) {
    return numberToDouble(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toDouble_impl(this_0) {
    return numberToDouble(Dyn__toNumber_impl_0(this_0));
  }
  function Dyn__toIntDefault_impl(this_0, default_0) {
    var tmp0_subject = _Dyn___get_value__impl_(this_0);
    var tmp;
    if (isNumber(tmp0_subject)) {
      tmp = Dyn__toInt_impl(this_0);
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
        var tmp1_elvis_lhs = toIntSafe(_Dyn___get_value__impl_(this_0), 10);
        tmp = tmp1_elvis_lhs == null ? default_0 : tmp1_elvis_lhs;
      } else {
        {
          tmp = default_0;
        }
      }
    }
    return tmp;
  }
  function Dyn__toIntDefault$default_impl(this_0, default_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      default_0 = 0;
    return Dyn__toIntDefault_impl(this_0, default_0);
  }
  function _Dyn___get_int__impl_(this_0) {
    return Dyn__toIntDefault$default_impl(this_0, 0, 1, null);
  }
  function _get_dyn_(_this_) {
    return _Dyn___init__impl_(_this_);
  }
  function toIntSafe(_this_, radix) {
    return toIntOrNull_0(_this_, radix);
  }
  function toIntSafe$default(_this_, radix, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      radix = 10;
    return toIntSafe(_this_, radix);
  }
  function toDoubleSafe(_this_) {
    return toDoubleOrNull(_this_);
  }
  var defaultDynApi;
  var dynApi;
  function DynApi() {
  }
  DynApi.prototype._get_global__4 = function () {
    return null;
  };
  DynApi.$metadata$ = {
    simpleName: 'DynApi',
    kind: 'interface',
    interfaces: []
  };
  function Companion_47() {
    Companion_instance_46 = this;
    KDynamic.call(this);
  }
  Companion_47.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_46;
  function Companion_getInstance_46() {
    if (Companion_instance_46 == null)
      new Companion_47();
    return Companion_instance_46;
  }
  function KDynamic() {
    Companion_getInstance_46();
  }
  KDynamic.prototype._get_global__4 = function () {
    return _Dyn___get_value__impl_(Companion_getInstance_45()._get_global_());
  };
  KDynamic.prototype.set_14 = function (_this__0, key, value) {
    return Dyn__set_impl(_get_dyn_(_this__0), key, value);
  };
  KDynamic.prototype._get_list__15 = function (_this__0) {
    return _Dyn___get_listAny__impl_(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toBool_0 = function (_this__0) {
    var tmp = _get_dyn_(_this__0);
    return Dyn__toBool$default_impl(tmp, false, 1, null);
  };
  KDynamic.prototype.toByte_1 = function (_this__0) {
    return Dyn__toByte_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toChar_0 = function (_this__0) {
    return Dyn__toChar_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toShort_0 = function (_this__0) {
    return Dyn__toShort_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toInt_2 = function (_this__0) {
    return Dyn__toInt_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toLong_1 = function (_this__0) {
    return Dyn__toLong_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toFloat_1 = function (_this__0) {
    return Dyn__toFloat_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype.toDouble_1 = function (_this__0) {
    return Dyn__toDouble_impl(_get_dyn_(_this__0));
  };
  KDynamic.prototype._get_int__1 = function (_this__0) {
    return _Dyn___get_int__impl_(_get_dyn_(_this__0));
  };
  KDynamic.$metadata$ = {
    simpleName: 'KDynamic',
    kind: 'class',
    interfaces: []
  };
  var Mapper;
  function TypeContext(mapper) {
    KDynamic.call(this);
    this._mapper = mapper;
  }
  TypeContext.$metadata$ = {
    simpleName: 'TypeContext',
    kind: 'class',
    interfaces: []
  };
  function UntypeContext(map_0) {
    this._map_3 = map_0;
  }
  UntypeContext.$metadata$ = {
    simpleName: 'UntypeContext',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__87() {
  }
  _no_name_provided__87.prototype.invoke_168 = function ($this$registerType, it) {
    return $this$registerType.toBool_0(it);
  };
  _no_name_provided__87.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__87.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__88() {
  }
  _no_name_provided__88.prototype.invoke_168 = function ($this$registerType, it) {
    return $this$registerType.toByte_1(it);
  };
  _no_name_provided__88.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__88.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__89() {
  }
  _no_name_provided__89.prototype.invoke_168 = function ($this$registerType, it) {
    return $this$registerType.toChar_0(it);
  };
  _no_name_provided__89.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__89.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__90() {
  }
  _no_name_provided__90.prototype.invoke_168 = function ($this$registerType, it) {
    return $this$registerType.toShort_0(it);
  };
  _no_name_provided__90.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__90.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__91() {
  }
  _no_name_provided__91.prototype.invoke_168 = function ($this$registerType, it) {
    return $this$registerType.toInt_2(it);
  };
  _no_name_provided__91.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__91.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__92() {
  }
  _no_name_provided__92.prototype.invoke_168 = function ($this$registerType, it) {
    return $this$registerType.toLong_1(it);
  };
  _no_name_provided__92.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__92.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__93() {
  }
  _no_name_provided__93.prototype.invoke_168 = function ($this$registerType, it) {
    return $this$registerType.toFloat_1(it);
  };
  _no_name_provided__93.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__93.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__94() {
  }
  _no_name_provided__94.prototype.invoke_168 = function ($this$registerType, it) {
    return $this$registerType.toDouble_1(it);
  };
  _no_name_provided__94.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__94.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__95() {
  }
  _no_name_provided__95.prototype.invoke_168 = function ($this$registerType, it) {
    return toSet_0($this$registerType._get_list__15(it));
  };
  _no_name_provided__95.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__95.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__96() {
  }
  _no_name_provided__96.prototype.invoke_168 = function ($this$registerType, it) {
    return $this$registerType._get_list__15(it);
  };
  _no_name_provided__96.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__96.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__97() {
  }
  _no_name_provided__97.prototype.invoke_168 = function ($this$registerType, it) {
    return toMutableList_2($this$registerType._get_list__15(it));
  };
  _no_name_provided__97.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__97.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__98() {
  }
  _no_name_provided__98.prototype.invoke_168 = function ($this$registerType, it) {
    var tmp0_safe_receiver = it;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  };
  _no_name_provided__98.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TypeContext ? p1 : THROW_CCE();
    return this.invoke_168(tmp, (p2 == null ? true : isObject(p2)) ? p2 : THROW_CCE());
  };
  _no_name_provided__98.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ObjectMapper() {
    var tmp = this;
    tmp.__typers = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    tmp_0.__untypers = LinkedHashMap_init_$Create$();
    this._fallbackTyper = null;
    this._fallbackUntyper = null;
    this._typeCtx = new TypeContext(this);
    this._untypeCtx = new UntypeContext(this);
    var tmp_1 = PrimitiveClasses_getInstance()._get_booleanClass_();
    this.registerType(tmp_1, _no_name_provided_$factory_64());
    Unit_getInstance();
    var tmp_2 = PrimitiveClasses_getInstance()._get_byteClass_();
    this.registerType(tmp_2, _no_name_provided_$factory_65());
    Unit_getInstance();
    var tmp_3 = getKClass_0(Char);
    this.registerType(tmp_3, _no_name_provided_$factory_66());
    Unit_getInstance();
    var tmp_4 = PrimitiveClasses_getInstance()._get_shortClass_();
    this.registerType(tmp_4, _no_name_provided_$factory_67());
    Unit_getInstance();
    var tmp_5 = PrimitiveClasses_getInstance()._get_intClass_();
    this.registerType(tmp_5, _no_name_provided_$factory_68());
    Unit_getInstance();
    var tmp_6 = getKClass_0(Long);
    this.registerType(tmp_6, _no_name_provided_$factory_69());
    Unit_getInstance();
    var tmp_7 = PrimitiveClasses_getInstance()._get_floatClass_();
    this.registerType(tmp_7, _no_name_provided_$factory_70());
    Unit_getInstance();
    var tmp_8 = PrimitiveClasses_getInstance()._get_doubleClass_();
    this.registerType(tmp_8, _no_name_provided_$factory_71());
    Unit_getInstance();
    var tmp_9 = getKClass_0(Set);
    this.registerType(tmp_9, _no_name_provided_$factory_72());
    Unit_getInstance();
    var tmp_10 = getKClass_0(List);
    this.registerType(tmp_10, _no_name_provided_$factory_73());
    Unit_getInstance();
    var tmp_11 = getKClass_0(MutableList);
    this.registerType(tmp_11, _no_name_provided_$factory_74());
    Unit_getInstance();
    var tmp_12 = PrimitiveClasses_getInstance()._get_stringClass_();
    this.registerType(tmp_12, _no_name_provided_$factory_75());
    Unit_getInstance();
  }
  ObjectMapper.prototype.registerType = function (clazz, generate) {
    var tmp0_set_0_2 = this.__typers;
    tmp0_set_0_2.put_18(clazz, generate);
    Unit_getInstance();
    return this;
  };
  ObjectMapper.$metadata$ = {
    simpleName: 'ObjectMapper',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_64() {
    var i = new _no_name_provided__87();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_65() {
    var i = new _no_name_provided__88();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_66() {
    var i = new _no_name_provided__89();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_67() {
    var i = new _no_name_provided__90();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_68() {
    var i = new _no_name_provided__91();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_69() {
    var i = new _no_name_provided__92();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_70() {
    var i = new _no_name_provided__93();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_71() {
    var i = new _no_name_provided__94();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_72() {
    var i = new _no_name_provided__95();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_73() {
    var i = new _no_name_provided__96();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_74() {
    var i = new _no_name_provided__97();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function _no_name_provided_$factory_75() {
    var i = new _no_name_provided__98();
    return function (p1, p2) {
      return i.invoke_168(p1, p2);
    };
  }
  function normalize(_this_) {
    var path_0 = _PathInfo___get_fullPath__impl_(_this_);
    var schemeIndex = indexOf$default_0(path_0, ':', 0, false, 6, null);
    var tmp;
    if (schemeIndex >= 0) {
      var tmp_0;
      var tmp_1 = path_0.substring(schemeIndex);
      if (startsWith$default_1(tmp_1, '://', false, 2, null)) {
        tmp_0 = 3;
      } else {
        {
          tmp_0 = 1;
        }
      }
      var take_2 = tmp_0;
      var tmp0_substring_0 = 0;
      var tmp1_substring_0 = schemeIndex + take_2 | 0;
      var tmp_2 = path_0.substring(tmp0_substring_0, tmp1_substring_0);
      var tmp2_substring_0 = schemeIndex + take_2 | 0;
      tmp = tmp_2 + normalize(_get_pathInfo_(path_0.substring(tmp2_substring_0)));
    } else {
      var tmp_3 = new Char(92);
      var tmp_4 = new Char(47);
      var path2 = replace$default(path_0, tmp_3, tmp_4, false, 4, null);
      var out = ArrayList_init_$Create$();
      var tmp_5 = ['/'];
      var tmp3_fastForEach_0 = split$default_0(path2, tmp_5, false, 0, 6, null);
      var n_1 = 0;
      while (n_1 < tmp3_fastForEach_0._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp4__anonymous__3 = tmp3_fastForEach_0.get_137(tmp0_2);
        var tmp0_subject_4 = tmp4__anonymous__3;
        switch (tmp0_subject_4) {
          case '':
          case '.':
            if (out.isEmpty_53()) {
              var tmp0_plusAssign_0_5 = '';
              out.add_39(tmp0_plusAssign_0_5);
              Unit_getInstance();
            } else
              Unit_getInstance();
            break;
          case '..':
            if (!out.isEmpty_53()) {
              out.removeAt_6(out._get_size__60() - 1 | 0);
              Unit_getInstance();
            } else {
            }

            break;
          default:out.add_39(tmp4__anonymous__3);
            Unit_getInstance();
            break;
        }
      }
      tmp = joinToString$default_0(out, '/', null, null, 0, null, null, 62, null);
    }
    return tmp;
  }
  function _PathInfo___init__impl_(fullPath) {
    return fullPath;
  }
  function _PathInfo___get_fullPath__impl_(this_0) {
    return this_0;
  }
  function _get_pathInfo_(_this_) {
    return _PathInfo___init__impl_(_this_);
  }
  function VfsNamed(pathInfo) {
    this._pathInfo = pathInfo;
  }
  VfsNamed.prototype._get_pathInfo__2 = function () {
    return this._pathInfo;
  };
  VfsNamed.$metadata$ = {
    simpleName: 'VfsNamed',
    kind: 'class',
    interfaces: [Path]
  };
  function _get_folder_(_this_) {
    return _get_folder__0(_this_._get_pathInfo__2());
  }
  function combine(_this_, access) {
    var base = _PathInfo___get_fullPath__impl_(_this_);
    var access_0 = _PathInfo___get_fullPath__impl_(access);
    return _get_pathInfo_(isAbsolute(_get_pathInfo_(access_0)) ? normalize(_get_pathInfo_(access_0)) : normalize(_get_pathInfo_('' + base + '/' + access_0)));
  }
  function _get_baseName_(_this_) {
    return _get_baseName__0(_this_._get_pathInfo__2());
  }
  function _get_fullNameWithoutExtension_(_this_) {
    return _get_fullNameWithoutExtension__0(_this_._get_pathInfo__2());
  }
  function lightCombine(_this_, access) {
    var base = _PathInfo___get_fullPath__impl_(_this_);
    var access_0 = _PathInfo___get_fullPath__impl_(access);
    var tmp;
    if (charSequenceLength(base) > 0) {
      tmp = trimEnd(base, charArrayOf([new Char(47)])) + '/' + trim(access_0, charArrayOf([new Char(47)]));
    } else {
      {
        tmp = access_0;
      }
    }
    var res = tmp;
    return _get_pathInfo_(res);
  }
  function Path() {
  }
  Path.$metadata$ = {
    simpleName: 'Path',
    kind: 'interface',
    interfaces: []
  };
  function parts(_this_) {
    var tmp = _PathInfo___get_fullPath__impl_(_this_);
    var tmp_0 = charArrayOf([new Char(47)]);
    return split$default(tmp, tmp_0, false, 0, 6, null);
  }
  function _get_folder__0(_this_) {
    var tmp0_substring_0 = _PathInfo___get_fullPath__impl_(_this_);
    var tmp1_substring_0 = 0;
    var tmp = _get_fullPathNormalized_(_this_);
    var tmp_0 = new Char(47);
    var tmp0_elvis_lhs = lastIndexOfOrNull$default(tmp, tmp_0, 0, 2, null);
    var tmp2_substring_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    return tmp0_substring_0.substring(tmp1_substring_0, tmp2_substring_0);
  }
  function isAbsolute(_this_) {
    var base = _PathInfo___get_fullPath__impl_(_this_);
    if (charSequenceLength(base) === 0)
      return false;
    else {
    }
    var tmp = new Char(92);
    var tmp_0 = new Char(47);
    var tmp_1 = replace$default(base, tmp, tmp_0, false, 4, null);
    var tmp_2 = new Char(47);
    var b = substringBefore$default(tmp_1, tmp_2, null, 2, null);
    if (charSequenceLength(b) === 0)
      return true;
    else {
    }
    var tmp_3 = new Char(58);
    if (contains$default(b, tmp_3, false, 2, null))
      return true;
    else {
    }
    return false;
  }
  function _get_baseName__0(_this_) {
    var tmp = _get_fullPathNormalized_(_this_);
    var tmp_0 = new Char(47);
    return substringAfterLast$default(tmp, tmp_0, null, 2, null);
  }
  function _get_fullNameWithoutExtension__0(_this_) {
    return '' + _get_folderWithSlash_(_this_) + _get_baseNameWithoutExtension_(_this_);
  }
  function _get_fullPathNormalized_(_this_) {
    var tmp = _PathInfo___get_fullPath__impl_(_this_);
    var tmp_0 = new Char(92);
    var tmp_1 = new Char(47);
    return replace$default(tmp, tmp_0, tmp_1, false, 4, null);
  }
  function _get_folderWithSlash_(_this_) {
    var tmp0_substring_0 = _PathInfo___get_fullPath__impl_(_this_);
    var tmp1_substring_0 = 0;
    var tmp = _get_fullPathNormalized_(_this_);
    var tmp_0 = new Char(47);
    var tmp0_safe_receiver = lastIndexOfOrNull$default(tmp, tmp_0, 0, 2, null);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver + 1 | 0;
    var tmp2_substring_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return tmp0_substring_0.substring(tmp1_substring_0, tmp2_substring_0);
  }
  function _get_baseNameWithoutExtension_(_this_) {
    return substringBeforeLast(_get_baseName__0(_this_), new Char(46), _get_baseName__0(_this_));
  }
  function _get_extensionLC_(_this_) {
    var tmp0_toLowerCase_0 = _get_extension_(_this_);
    return tmp0_toLowerCase_0.toLowerCase();
  }
  function _get_extensionLC__0(_this_) {
    return _get_extensionLC_(_this_._get_pathInfo__2());
  }
  function _get_extension_(_this_) {
    return substringAfterLast(_get_baseName__0(_this_), new Char(46), '');
  }
  function getPathFullComponents(_this_) {
    var out = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last_1 = _get_fullPathNormalized_(_this_).length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_subject = charSequenceGet(_get_fullPathNormalized_(_this_), n);
        if (tmp1_subject.equals(new Char(47)) ? true : tmp1_subject.equals(new Char(92))) {
          var tmp0_substring_0 = _get_fullPathNormalized_(_this_);
          var tmp1_substring_0 = 0;
          var tmp2_plusAssign_0 = tmp0_substring_0.substring(tmp1_substring_0, n);
          out.add_39(tmp2_plusAssign_0);
          Unit_getInstance();
        }}
       while (inductionVariable < last_1);
    var tmp3_plusAssign_0 = _get_fullPathNormalized_(_this_);
    out.add_39(tmp3_plusAssign_0);
    Unit_getInstance();
    return out;
  }
  function SimpleStorage() {
  }
  SimpleStorage.$metadata$ = {
    simpleName: 'SimpleStorage',
    kind: 'interface',
    interfaces: []
  };
  function $emit_2COROUTINE$51(_this_, value, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__20 = _this_;
    this._value_13 = value;
  }
  $emit_2COROUTINE$51.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__20._this$0_22.transform_2(this._value_13, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__20._$this_flow.emit_8(this._ARGUMENT0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $emit_2COROUTINE$51.$metadata$ = {
    simpleName: '$emit_2COROUTINE$51',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_9($this_flow, this$0) {
    this._$this_flow = $this_flow;
    this._this$0_22 = this$0;
  }
  _no_name_provided__1_9.prototype.emit_2_1 = function (value, $cont) {
    var tmp = new $emit_2COROUTINE$51(this, value, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__1_9.prototype.emit_8 = function (value, $cont) {
    return this.emit_2_1(value instanceof VfsFile ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__1_9.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function initOnce($this, $cont) {
    var tmp = new $initOnceCOROUTINE$37($this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function _no_name_provided__99(this$0, $path, resultContinuation) {
    this._this$0_23 = this$0;
    this._$path = $path;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__99.prototype.invoke_191 = function ($this$flow, $cont) {
    var tmp = this.create_10($this$flow, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__99.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_191((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__99.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            suspendResult = initOnce(this._this$0_23, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 2;
            suspendResult = this._this$0_23.access_1(this._$path, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT0_0 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT0_0.list_0(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._tmp0_collect_01 = suspendResult;
            this._state_1 = 4;
            suspendResult = this._tmp0_collect_01.collect_6(new _no_name_provided__1_9(this._$this$flow, this._this$0_23), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            suspendResult;
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__99.prototype.create_10 = function ($this$flow, completion) {
    var i = new _no_name_provided__99(this._this$0_23, this._$path, completion);
    i._$this$flow = $this$flow;
    return i;
  };
  _no_name_provided__99.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $getUnderlyingUnscapedFileCOROUTINE$36(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__21 = _this_;
    this._path_0 = path_0;
  }
  $getUnderlyingUnscapedFileCOROUTINE$36.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = initOnce(this.__this__21, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_1 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_1.access_1(this._path_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_0 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT1_0.getUnderlyingUnscapedFile_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getUnderlyingUnscapedFileCOROUTINE$36.$metadata$ = {
    simpleName: '$getUnderlyingUnscapedFileCOROUTINE$36',
    kind: 'class',
    interfaces: []
  };
  function $initOnceCOROUTINE$37(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__22 = _this_;
  }
  $initOnceCOROUTINE$37.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (!this.__this__22._initialized) {
              this.__this__22._initialized = true;
              this._state_1 = 1;
              suspendResult = this.__this__22.init_15(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            return this.__this__22;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $initOnceCOROUTINE$37.$metadata$ = {
    simpleName: '$initOnceCOROUTINE$37',
    kind: 'class',
    interfaces: []
  };
  function $openCOROUTINE$39(_this_, path_0, mode, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__23 = _this_;
    this._path_1 = path_0;
    this._mode = mode;
  }
  $openCOROUTINE$39.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = initOnce(this.__this__23, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_2 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_2.access_1(this._path_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_1 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT1_1.open_3(this._mode, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openCOROUTINE$39.$metadata$ = {
    simpleName: '$openCOROUTINE$39',
    kind: 'class',
    interfaces: []
  };
  function $readRangeCOROUTINE$40(_this_, path_0, range, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__24 = _this_;
    this._path_2 = path_0;
    this._range_0 = range;
  }
  $readRangeCOROUTINE$40.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = initOnce(this.__this__24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_3 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_3.access_1(this._path_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_2 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT1_2.readRangeBytes(this._range_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readRangeCOROUTINE$40.$metadata$ = {
    simpleName: '$readRangeCOROUTINE$40',
    kind: 'class',
    interfaces: []
  };
  function $statCOROUTINE$43(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__25 = _this_;
    this._path_3 = path_0;
  }
  $statCOROUTINE$43.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = initOnce(this.__this__25, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_4 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_4.access_1(this._path_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_3 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT1_3.stat_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            var tmp_0 = this.__this__25.file_8(this._path_3);
            var tmp_1 = new Long(0, 0);
            var tmp_2 = new Long(0, 0);
            var tmp_3 = new Long(0, 0);
            return ARGUMENT.copy$default_0(tmp_0, false, false, tmp_1, tmp_2, tmp_3, 0, null, null, null, null, null, null, null, 16382, null);
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $statCOROUTINE$43.$metadata$ = {
    simpleName: '$statCOROUTINE$43',
    kind: 'class',
    interfaces: []
  };
  function $listSimpleCOROUTINE$44(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__26 = _this_;
    this._path_4 = path_0;
  }
  $listSimpleCOROUTINE$44.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = initOnce(this.__this__26, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_5 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_5.access_1(this._path_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_4 = suspendResult;
            this._state_1 = 3;
            suspendResult = this._ARGUMENT1_4.listSimple_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $listSimpleCOROUTINE$44.$metadata$ = {
    simpleName: '$listSimpleCOROUTINE$44',
    kind: 'class',
    interfaces: []
  };
  var Kind_DELETED_instance;
  var Kind_MODIFIED_instance;
  var Kind_CREATED_instance;
  var Kind_RENAMED_instance;
  var Kind_entriesInitialized_0;
  function Kind_initEntries_0() {
    if (Kind_entriesInitialized_0)
      return Unit_getInstance();
    Kind_entriesInitialized_0 = true;
    Kind_DELETED_instance = new Kind_0('DELETED', 0);
    Kind_MODIFIED_instance = new Kind_0('MODIFIED', 1);
    Kind_CREATED_instance = new Kind_0('CREATED', 2);
    Kind_RENAMED_instance = new Kind_0('RENAMED', 3);
  }
  function FileEvent_init_$Init$(kind, file, other, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      other = null;
    FileEvent.call($this, kind, file, other);
    return $this;
  }
  function FileEvent_init_$Create$(kind, file, other, $mask0, $marker) {
    return FileEvent_init_$Init$(kind, file, other, $mask0, $marker, Object.create(FileEvent.prototype));
  }
  function Kind_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Kind_0.$metadata$ = {
    simpleName: 'Kind',
    kind: 'class',
    interfaces: []
  };
  function Kind_MODIFIED_getInstance() {
    Kind_initEntries_0();
    return Kind_MODIFIED_instance;
  }
  function Proxy() {
    Vfs.call(this);
    this._initialized = false;
  }
  Proxy.prototype.transform_2 = function (_this__0, $cont) {
    return this.file_8(_this__0._path_7);
  };
  Proxy.prototype.getUnderlyingUnscapedFile_9 = function (path_0, $cont) {
    var tmp = new $getUnderlyingUnscapedFileCOROUTINE$36(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Proxy.prototype.init_15 = function ($cont) {
  };
  Proxy.prototype.open_10 = function (path_0, mode, $cont) {
    var tmp = new $openCOROUTINE$39(this, path_0, mode, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Proxy.prototype.readRange_8 = function (path_0, range, $cont) {
    var tmp = new $readRangeCOROUTINE$40(this, path_0, range, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Proxy.prototype.stat_9 = function (path_0, $cont) {
    var tmp = new $statCOROUTINE$43(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Proxy.prototype.listSimple_9 = function (path_0, $cont) {
    var tmp = new $listSimpleCOROUTINE$44(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Proxy.prototype.listFlow_8 = function (path_0, $cont) {
    return flow(_no_name_provided_$factory_77(this, path_0, null));
  };
  Proxy.$metadata$ = {
    simpleName: 'Proxy',
    kind: 'class',
    interfaces: []
  };
  function FileEvent(kind, file, other) {
    this._kind = kind;
    this._file = file;
    this._other = other;
  }
  FileEvent.prototype.toString = function () {
    return !(this._other == null) ? '' + this._kind + '(' + this._file + ', ' + this._other + ')' : '' + this._kind + '(' + this._file + ')';
  };
  FileEvent.prototype.hashCode = function () {
    var result = this._kind.hashCode();
    result = imul(result, 31) + this._file.hashCode() | 0;
    result = imul(result, 31) + (this._other == null ? 0 : this._other.hashCode()) | 0;
    return result;
  };
  FileEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FileEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FileEvent ? other : THROW_CCE();
    if (!this._kind.equals(tmp0_other_with_cast._kind))
      return false;
    if (!this._file.equals(tmp0_other_with_cast._file))
      return false;
    if (!equals_1(this._other, tmp0_other_with_cast._other))
      return false;
    return true;
  };
  FileEvent.$metadata$ = {
    simpleName: 'FileEvent',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__100(this$0, $path, resultContinuation) {
    this._this$0_24 = this$0;
    this._$path_0 = $path;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__100.prototype.invoke_191 = function ($this$flow, $cont) {
    var tmp = this.create_10($this$flow, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__100.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_191((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__100.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this._this$0_24.listSimple_9(this._$path_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_6 = suspendResult;
            this._state_1 = 2;
            suspendResult = toChannel(this._ARGUMENT0_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_5 = suspendResult;
            this._state_1 = 3;
            suspendResult = emitAll(this._$this$flow_0, this._ARGUMENT1_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__100.prototype.create_10 = function ($this$flow, completion) {
    var i = new _no_name_provided__100(this._this$0_24, this._$path_0, completion);
    i._$this$flow_0 = $this$flow;
    return i;
  };
  _no_name_provided__100.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $readRangeCOROUTINE$29(_this_, path_0, range, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__27 = _this_;
    this._path_5 = path_0;
    this._range_1 = range;
  }
  $readRangeCOROUTINE$29.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            this._state_1 = 1;
            suspendResult = this.__this__27.open_10(this._path_5, VfsOpenMode_READ_getInstance(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._s0 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 9;
            this._s0._position_3 = this._range_1._get_start__0();
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_minus_03 = toLong(IntCompanionObject_getInstance()._MAX_VALUE_4);
            var tmp_2 = this;
            tmp_2._tmp1_minus_04 = 1;
            tmp_0._readCount5 = min2_1(this._tmp0_minus_03.minus_29(toLong(this._tmp1_minus_04)), this._range_1._get_endInclusive__0().minus_29(this._range_1._get_start__0())).toInt_8() + 1 | 0;
            this._state_1 = 4;
            suspendResult = readBytesUpTo(this._s0, this._readCount5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$02 = suspendResult;
            this._exceptionState = 11;
            this._state_1 = 5;
            var tmp_3 = this;
            continue $sm;
          case 5:
            this._tmp6 = this._tmp$ret$02;
            this._state_1 = 6;
            suspendResult = this._s0.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            suspendResult;
            return this._tmp6;
          case 7:
            this._state_1 = 8;
            suspendResult = this._s0.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            suspendResult;
            return Unit_getInstance();
          case 9:
            this._exceptionState = 11;
            this._t7 = this._exception_0;
            this._state_1 = 10;
            suspendResult = this._s0.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            suspendResult;
            throw this._t7;
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readRangeCOROUTINE$29.$metadata$ = {
    simpleName: '$readRangeCOROUTINE$29',
    kind: 'class',
    interfaces: []
  };
  function $listSimpleCOROUTINE$34(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__28 = _this_;
    this._path_6 = path_0;
  }
  $listSimpleCOROUTINE$34.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__28.listFlow_8(this._path_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_7 = suspendResult;
            this._state_1 = 2;
            suspendResult = toList$default(this._ARGUMENT0_7, null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $listSimpleCOROUTINE$34.$metadata$ = {
    simpleName: '$listSimpleCOROUTINE$34',
    kind: 'class',
    interfaces: []
  };
  function Vfs() {
  }
  Vfs.prototype._get_absolutePath__9 = function () {
    return '';
  };
  Vfs.prototype.getAbsolutePath_8 = function (path_0) {
    return _PathInfo___get_fullPath__impl_(lightCombine(_get_pathInfo_(this._get_absolutePath__9()), _get_pathInfo_(path_0)));
  };
  Vfs.prototype._get_root__33 = function () {
    return new VfsFile(this, '');
  };
  Vfs.prototype.get_115 = function (path_0) {
    return this._get_root__33().get_115(path_0);
  };
  Vfs.prototype.file_8 = function (path_0) {
    return this._get_root__33().get_115(path_0);
  };
  Vfs.prototype.close_77 = function ($cont) {
    return Unit_getInstance();
  };
  Vfs.prototype.createExistsStat_8 = function (path_0, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id) {
    return new VfsStat(this.file_8(path_0), true, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id);
  };
  Vfs.prototype.createExistsStat$default_0 = function (path_0, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      device = new Long(-1, -1);
    if (!(($mask0 & 16) === 0))
      inode = new Long(-1, -1);
    if (!(($mask0 & 32) === 0))
      mode = 511;
    if (!(($mask0 & 64) === 0))
      owner = 'nobody';
    if (!(($mask0 & 128) === 0))
      group = 'nobody';
    if (!(($mask0 & 256) === 0))
      createTime = Companion_getInstance_18()._EPOCH;
    if (!(($mask0 & 512) === 0))
      modifiedTime = Companion_getInstance_18()._EPOCH;
    if (!(($mask0 & 1024) === 0))
      lastAccessTime = modifiedTime;
    if (!(($mask0 & 2048) === 0))
      extraInfo = null;
    if (!(($mask0 & 4096) === 0))
      id = null;
    return this.createExistsStat_8(path_0, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id);
  };
  Vfs.prototype.createNonExistsStat_8 = function (path_0, extraInfo) {
    var tmp = this.file_8(path_0);
    var tmp_0 = new Long(0, 0);
    var tmp_1 = new Long(-1, -1);
    var tmp_2 = new Long(-1, -1);
    var tmp_3 = Companion_getInstance_18()._EPOCH;
    var tmp_4 = Companion_getInstance_18()._EPOCH;
    var tmp_5 = Companion_getInstance_18()._EPOCH;
    return VfsStat_init_$Create$(tmp, false, false, tmp_0, tmp_1, tmp_2, 511, 'nobody', 'nobody', tmp_3, tmp_4, tmp_5, extraInfo, null, 8192, null);
  };
  Vfs.prototype.createNonExistsStat$default_8 = function (path_0, extraInfo, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      extraInfo = null;
    return this.createNonExistsStat_8(path_0, extraInfo);
  };
  Vfs.prototype.open_10 = function (path_0, mode, $cont) {
    unsupported_0();
  };
  Vfs.prototype.readRange_8 = function (path_0, range, $cont) {
    var tmp = new $readRangeCOROUTINE$29(this, path_0, range, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Vfs.prototype.stat_9 = function (path_0, $cont) {
    return this.createNonExistsStat$default_8(path_0, null, 2, null);
  };
  Vfs.prototype.listSimple_9 = function (path_0, $cont) {
    var tmp = new $listSimpleCOROUTINE$34(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Vfs.prototype.listFlow_8 = function (path_0, $cont) {
    return flow(_no_name_provided_$factory_76(this, path_0, null));
  };
  Vfs.prototype.getUnderlyingUnscapedFile_9 = function (path_0, $cont) {
    return FinalVfsFile_init_$Create$(this, path_0);
  };
  Vfs.prototype.toString = function () {
    return _get_portableSimpleName_(getKClassFromExpression_0(this));
  };
  Vfs.$metadata$ = {
    simpleName: 'Vfs',
    kind: 'class',
    interfaces: [AsyncCloseable]
  };
  function VfsOpenMode_init_$Init$(name, ordinal, cmode, write_2, createIfNotExists, truncate, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0))
      createIfNotExists = false;
    if (!(($mask0 & 32) === 0))
      truncate = false;
    VfsOpenMode.call($this, name, ordinal, cmode, write_2, createIfNotExists, truncate);
    return $this;
  }
  function VfsOpenMode_init_$Create$(name, ordinal, cmode, write_2, createIfNotExists, truncate, $mask0, $marker) {
    return VfsOpenMode_init_$Init$(name, ordinal, cmode, write_2, createIfNotExists, truncate, $mask0, $marker, Object.create(VfsOpenMode.prototype));
  }
  var VfsOpenMode_READ_instance;
  var VfsOpenMode_WRITE_instance;
  var VfsOpenMode_APPEND_instance;
  var VfsOpenMode_CREATE_OR_TRUNCATE_instance;
  var VfsOpenMode_CREATE_instance;
  var VfsOpenMode_CREATE_NEW_instance;
  var VfsOpenMode_entriesInitialized;
  function VfsOpenMode_initEntries() {
    if (VfsOpenMode_entriesInitialized)
      return Unit_getInstance();
    VfsOpenMode_entriesInitialized = true;
    VfsOpenMode_READ_instance = VfsOpenMode_init_$Create$('READ', 0, 'rb', false, false, false, 48, null);
    VfsOpenMode_WRITE_instance = VfsOpenMode_init_$Create$('WRITE', 1, 'r+b', true, true, false, 32, null);
    VfsOpenMode_APPEND_instance = VfsOpenMode_init_$Create$('APPEND', 2, 'a+b', true, true, false, 32, null);
    VfsOpenMode_CREATE_OR_TRUNCATE_instance = new VfsOpenMode('CREATE_OR_TRUNCATE', 3, 'w+b', true, true, true);
    VfsOpenMode_CREATE_instance = VfsOpenMode_init_$Create$('CREATE', 4, 'w+b', true, true, false, 32, null);
    VfsOpenMode_CREATE_NEW_instance = VfsOpenMode_init_$Create$('CREATE_NEW', 5, 'w+b', true, false, false, 48, null);
  }
  function VfsOpenMode(name, ordinal, cmode, write_2, createIfNotExists, truncate) {
    Enum.call(this, name, ordinal);
    this._cmode = cmode;
    this._write = write_2;
    this._createIfNotExists = createIfNotExists;
    this._truncate = truncate;
  }
  VfsOpenMode.$metadata$ = {
    simpleName: 'VfsOpenMode',
    kind: 'class',
    interfaces: []
  };
  function VfsStat_init_$Init$(file, exists, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0))
      device = new Long(-1, -1);
    if (!(($mask0 & 32) === 0))
      inode = new Long(-1, -1);
    if (!(($mask0 & 64) === 0))
      mode = 511;
    if (!(($mask0 & 128) === 0))
      owner = 'nobody';
    if (!(($mask0 & 256) === 0))
      group = 'nobody';
    if (!(($mask0 & 512) === 0))
      createTime = Companion_getInstance_18()._EPOCH;
    if (!(($mask0 & 1024) === 0))
      modifiedTime = createTime;
    if (!(($mask0 & 2048) === 0))
      lastAccessTime = modifiedTime;
    if (!(($mask0 & 4096) === 0))
      extraInfo = null;
    if (!(($mask0 & 8192) === 0))
      id = null;
    VfsStat.call($this, file, exists, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id);
    return $this;
  }
  function VfsStat_init_$Create$(file, exists, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, $mask0, $marker) {
    return VfsStat_init_$Init$(file, exists, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, $mask0, $marker, Object.create(VfsStat.prototype));
  }
  function VfsStat(file, exists, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id) {
    this._file_0 = file;
    this._exists = exists;
    this._isDirectory_0 = isDirectory;
    this._size_5 = size_1;
    this._device = device;
    this._inode_0 = inode;
    this._mode_0 = mode;
    this._owner_0 = owner;
    this._group = group;
    this._createTime = createTime;
    this._modifiedTime = modifiedTime;
    this._lastAccessTime = lastAccessTime;
    this._extraInfo = extraInfo;
    this._id = id;
  }
  VfsStat.prototype._get_pathInfo__2 = function () {
    return this._file_0._get_pathInfo__2();
  };
  VfsStat.prototype.toString_1 = function (showFile) {
    var tmp0_also_0 = ArrayList_init_$Create$_0(16);
    if (showFile) {
      tmp0_also_0.add_39('' + 'file=' + this._file_0);
      Unit_getInstance();
    } else {
      tmp0_also_0.add_39('' + 'file=' + this._file_0._get_absolutePath__9());
      Unit_getInstance();
    }
    tmp0_also_0.add_39('' + 'exists=' + this._exists);
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'isDirectory=' + this._isDirectory_0);
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'size=' + this._size_5);
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'device=' + this._device);
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'inode=' + this._inode_0);
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'mode=' + this._mode_0);
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'owner=' + this._owner_0);
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'group=' + this._group);
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'createTime=' + new DateTime(this._createTime));
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'modifiedTime=' + new DateTime(this._modifiedTime));
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'lastAccessTime=' + new DateTime(this._lastAccessTime));
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'extraInfo=' + this._extraInfo);
    Unit_getInstance();
    tmp0_also_0.add_39('' + 'id=' + this._id);
    Unit_getInstance();
    return 'VfsStat(' + joinToString$default_0(tmp0_also_0, ', ', null, null, 0, null, null, 62, null) + ')';
  };
  VfsStat.prototype.toString = function () {
    return this.toString_1(true);
  };
  VfsStat.prototype.copy_1 = function (file, exists, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id) {
    return new VfsStat(file, exists, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id);
  };
  VfsStat.prototype.copy$default_0 = function (file, exists, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      file = this._file_0;
    if (!(($mask0 & 2) === 0))
      exists = this._exists;
    if (!(($mask0 & 4) === 0))
      isDirectory = this._isDirectory_0;
    if (!(($mask0 & 8) === 0))
      size_1 = this._size_5;
    if (!(($mask0 & 16) === 0))
      device = this._device;
    if (!(($mask0 & 32) === 0))
      inode = this._inode_0;
    if (!(($mask0 & 64) === 0))
      mode = this._mode_0;
    if (!(($mask0 & 128) === 0))
      owner = this._owner_0;
    if (!(($mask0 & 256) === 0))
      group = this._group;
    if (!(($mask0 & 512) === 0))
      createTime = this._createTime;
    if (!(($mask0 & 1024) === 0))
      modifiedTime = this._modifiedTime;
    if (!(($mask0 & 2048) === 0))
      lastAccessTime = this._lastAccessTime;
    if (!(($mask0 & 4096) === 0))
      extraInfo = this._extraInfo;
    if (!(($mask0 & 8192) === 0))
      id = this._id;
    return this.copy_1(file, exists, isDirectory, size_1, device, inode, mode, owner, group, createTime, modifiedTime, lastAccessTime, extraInfo, id);
  };
  VfsStat.prototype.hashCode = function () {
    var result = this._file_0.hashCode();
    result = imul(result, 31) + (this._exists | 0) | 0;
    result = imul(result, 31) + (this._isDirectory_0 | 0) | 0;
    result = imul(result, 31) + this._size_5.hashCode() | 0;
    result = imul(result, 31) + this._device.hashCode() | 0;
    result = imul(result, 31) + this._inode_0.hashCode() | 0;
    result = imul(result, 31) + this._mode_0 | 0;
    result = imul(result, 31) + getStringHashCode(this._owner_0) | 0;
    result = imul(result, 31) + getStringHashCode(this._group) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._createTime) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._modifiedTime) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._lastAccessTime) | 0;
    result = imul(result, 31) + (this._extraInfo == null ? 0 : hashCode(this._extraInfo)) | 0;
    result = imul(result, 31) + (this._id == null ? 0 : getStringHashCode(this._id)) | 0;
    return result;
  };
  VfsStat.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsStat))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VfsStat ? other : THROW_CCE();
    if (!this._file_0.equals(tmp0_other_with_cast._file_0))
      return false;
    if (!(this._exists === tmp0_other_with_cast._exists))
      return false;
    if (!(this._isDirectory_0 === tmp0_other_with_cast._isDirectory_0))
      return false;
    if (!this._size_5.equals(tmp0_other_with_cast._size_5))
      return false;
    if (!this._device.equals(tmp0_other_with_cast._device))
      return false;
    if (!this._inode_0.equals(tmp0_other_with_cast._inode_0))
      return false;
    if (!(this._mode_0 === tmp0_other_with_cast._mode_0))
      return false;
    if (!(this._owner_0 === tmp0_other_with_cast._owner_0))
      return false;
    if (!(this._group === tmp0_other_with_cast._group))
      return false;
    if (!equals_1(new DateTime(this._createTime), new DateTime(tmp0_other_with_cast._createTime)))
      return false;
    if (!equals_1(new DateTime(this._modifiedTime), new DateTime(tmp0_other_with_cast._modifiedTime)))
      return false;
    if (!equals_1(new DateTime(this._lastAccessTime), new DateTime(tmp0_other_with_cast._lastAccessTime)))
      return false;
    if (!equals_1(this._extraInfo, tmp0_other_with_cast._extraInfo))
      return false;
    if (!(this._id == tmp0_other_with_cast._id))
      return false;
    return true;
  };
  VfsStat.$metadata$ = {
    simpleName: 'VfsStat',
    kind: 'class',
    interfaces: [Path]
  };
  function VfsV2() {
    Vfs.call(this);
  }
  VfsV2.prototype.listFlow_8 = function (path_0, $cont) {
    return emptyFlow();
  };
  VfsV2.$metadata$ = {
    simpleName: 'VfsV2',
    kind: 'class',
    interfaces: []
  };
  function VfsOpenMode_READ_getInstance() {
    VfsOpenMode_initEntries();
    return VfsOpenMode_READ_instance;
  }
  function _no_name_provided_$factory_76(this$0, $path, resultContinuation) {
    var i = new _no_name_provided__100(this$0, $path, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_191(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_77(this$0, $path, resultContinuation) {
    var i = new _no_name_provided__99(this$0, $path, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_191(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided__1_9_0($this_flow) {
    this._$this_flow_0 = $this_flow;
  }
  _no_name_provided__1_9_0.prototype.emit_2_10 = function (value, $cont) {
    return this._$this_flow_0.emit_8(value, $cont);
  };
  _no_name_provided__1_9_0.prototype.emit_8 = function (value, $cont) {
    return this.emit_2_10(value instanceof VfsFile ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__1_9_0.$metadata$ = {
    simpleName: '<no name provided>_1_9',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function $emit_2COROUTINE$71(_this_, value, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__29 = _this_;
    this._value_14 = value;
  }
  $emit_2COROUTINE$71.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            if (this.__this__29._$filter(this._value_14)) {
              this._state_1 = 1;
              suspendResult = this.__this__29._$this_flow_1.emit_8(this._value_14, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_1 = 2;
            suspendResult = this._value_14.stat_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._stat_70 = suspendResult;
            if (this._stat_70._isDirectory_0) {
              this._state_1 = 3;
              suspendResult = this._value_14.listRecursive(this.__this__29._$filter, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 3:
            this._tmp0_collect_0_81 = suspendResult;
            this._state_1 = 4;
            suspendResult = this._tmp0_collect_0_81.collect_6(new _no_name_provided__1_9_0(this.__this__29._$this_flow_1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._state_1 = 6;
            continue $sm;
          case 6:
            return Unit_getInstance();
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $emit_2COROUTINE$71.$metadata$ = {
    simpleName: '$emit_2COROUTINE$71',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_10($filter, $this_flow) {
    this._$filter = $filter;
    this._$this_flow_1 = $this_flow;
  }
  _no_name_provided__1_10.prototype.emit_2_1 = function (value, $cont) {
    var tmp = new $emit_2COROUTINE$71(this, value, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__1_10.prototype.emit_8 = function (value, $cont) {
    return this.emit_2_1(value instanceof VfsFile ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__1_10.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function _no_name_provided__101() {
  }
  _no_name_provided__101.prototype.invoke_392 = function (it) {
    return true;
  };
  _no_name_provided__101.prototype.invoke_1015 = function (p1) {
    return this.invoke_392(p1 instanceof VfsFile ? p1 : THROW_CCE());
  };
  _no_name_provided__101.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__102(this$0, $filter, resultContinuation) {
    this._this$0_25 = this$0;
    this._$filter_0 = $filter;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__102.prototype.invoke_191 = function ($this$flow, $cont) {
    var tmp = this.create_10($this$flow, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__102.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_191((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__102.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._this$0_25.list_0(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_collect_00 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._tmp0_collect_00.collect_6(new _no_name_provided__1_10(this._$filter_0, this._$this$flow_1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__102.prototype.create_10 = function ($this$flow, completion) {
    var i = new _no_name_provided__102(this._this$0_25, this._$filter_0, completion);
    i._$this$flow_1 = $this$flow;
    return i;
  };
  _no_name_provided__102.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $readStringCOROUTINE$58(_this_, charset, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__30 = _this_;
    this._charset = charset;
  }
  $readStringCOROUTINE$58.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__30.read_36(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return toString_3(ARGUMENT, this._charset);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readStringCOROUTINE$58.$metadata$ = {
    simpleName: '$readStringCOROUTINE$58',
    kind: 'class',
    interfaces: []
  };
  function VfsFile(vfs, path_0) {
    VfsNamed.call(this, _get_pathInfo_(path_0));
    this._vfs = vfs;
    this._path_7 = path_0;
    var tmp = this;
    tmp._$$delegate_0_0 = Mixin_init_$Create$(null, 1, null);
  }
  VfsFile.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_0._extra = _set___;
  };
  VfsFile.prototype._get_extra__71 = function () {
    return this._$$delegate_0_0._extra;
  };
  VfsFile.prototype._get_parent__14 = function () {
    return new VfsFile(this._vfs, _get_folder_(this));
  };
  VfsFile.prototype._get_absolutePath__9 = function () {
    return this._vfs.getAbsolutePath_8(this._path_7);
  };
  VfsFile.prototype.get_115 = function (path_0) {
    return new VfsFile(this._vfs, _PathInfo___get_fullPath__impl_(combine(_get_pathInfo_(this._path_7), _get_pathInfo_(path_0))));
  };
  VfsFile.prototype.withExtension = function (ext) {
    var tmp = _get_fullNameWithoutExtension_(this);
    var tmp_0;
    if (charSequenceLength(ext) > 0) {
      tmp_0 = '' + '.' + ext;
    } else {
      {
        tmp_0 = '';
      }
    }
    return new VfsFile(this._vfs, tmp + tmp_0);
  };
  VfsFile.prototype.open_3 = function (mode, $cont) {
    return this._vfs.open_10(this._path_7, mode, $cont);
  };
  VfsFile.prototype.open$default = function (mode, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      mode = VfsOpenMode_READ_getInstance();
    return this.open_3(mode, $cont);
  };
  VfsFile.prototype.readRangeBytes = function (range, $cont) {
    return this._vfs.readRange_8(this._path_7, range, $cont);
  };
  VfsFile.prototype.readRangeBytes_0 = function (range, $cont) {
    return this._vfs.readRange_8(this._path_7, toLongRange(range), $cont);
  };
  VfsFile.prototype.readAll_0 = function ($cont) {
    return this._vfs.readRange_8(this._path_7, LONG_ZERO_TO_MAX_RANGE, $cont);
  };
  VfsFile.prototype.read_36 = function ($cont) {
    return this.readAll_0($cont);
  };
  VfsFile.prototype.readBytes = function ($cont) {
    return this.readAll_0($cont);
  };
  VfsFile.prototype.readString = function (charset, $cont) {
    var tmp = new $readStringCOROUTINE$58(this, charset, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  VfsFile.prototype.readString$default = function (charset, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      charset = UTF8;
    return this.readString(charset, $cont);
  };
  VfsFile.prototype.stat_2 = function ($cont) {
    return this._vfs.stat_9(this._path_7, $cont);
  };
  VfsFile.prototype.listSimple_2 = function ($cont) {
    return this._vfs.listSimple_9(this._path_7, $cont);
  };
  VfsFile.prototype.list_0 = function ($cont) {
    return this._vfs.listFlow_8(this._path_7, $cont);
  };
  VfsFile.prototype.listRecursive = function (filter, $cont) {
    return flow(_no_name_provided_$factory_79(this, filter, null));
  };
  VfsFile.prototype.listRecursive$default = function (filter, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0)) {
      filter = _no_name_provided_$factory_78();
    }return this.listRecursive(filter, $cont);
  };
  VfsFile.prototype.jail = function () {
    return JailVfs(this);
  };
  VfsFile.prototype.getUnderlyingUnscapedFile_2 = function ($cont) {
    return this._vfs.getUnderlyingUnscapedFile_9(this._path_7, $cont);
  };
  VfsFile.prototype.toString = function () {
    return '' + this._vfs + '[' + this._path_7 + ']';
  };
  VfsFile.prototype.hashCode = function () {
    var result = hashCode(this._vfs);
    result = imul(result, 31) + getStringHashCode(this._path_7) | 0;
    return result;
  };
  VfsFile.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VfsFile))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VfsFile ? other : THROW_CCE();
    if (!equals_1(this._vfs, tmp0_other_with_cast._vfs))
      return false;
    if (!(this._path_7 === tmp0_other_with_cast._path_7))
      return false;
    return true;
  };
  VfsFile.$metadata$ = {
    simpleName: 'VfsFile',
    kind: 'class',
    interfaces: [AsyncInputOpenable, Extra]
  };
  function FinalVfsFile_init_$Init$(vfs, path_0, $this) {
    FinalVfsFile.call($this, vfs.get_115(path_0));
    return $this;
  }
  function FinalVfsFile_init_$Create$(vfs, path_0) {
    return FinalVfsFile_init_$Init$(vfs, path_0, Object.create(FinalVfsFile.prototype));
  }
  function FinalVfsFile(file) {
    this._file_1 = file;
  }
  FinalVfsFile.prototype._get_vfs_ = function () {
    return this._file_1._vfs;
  };
  FinalVfsFile.prototype._get_path__5 = function () {
    return this._file_1._path_7;
  };
  FinalVfsFile.prototype.toString = function () {
    return '' + 'FinalVfsFile(file=' + this._file_1 + ')';
  };
  FinalVfsFile.prototype.hashCode = function () {
    return this._file_1.hashCode();
  };
  FinalVfsFile.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FinalVfsFile))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FinalVfsFile ? other : THROW_CCE();
    if (!this._file_1.equals(tmp0_other_with_cast._file_1))
      return false;
    return true;
  };
  FinalVfsFile.$metadata$ = {
    simpleName: 'FinalVfsFile',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_78() {
    var i = new _no_name_provided__101();
    return function (p1) {
      return i.invoke_392(p1);
    };
  }
  function _no_name_provided_$factory_79(this$0, $filter, resultContinuation) {
    var i = new _no_name_provided__102(this$0, $filter, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_191(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function JailVfs(jailRoot) {
    return (new _no_name_provided__103(jailRoot))._get_root__33();
  }
  function _no_name_provided__103($jailRoot) {
    this._$jailRoot = $jailRoot;
    Proxy.call(this);
    this._baseJail = normalize(this._$jailRoot._get_pathInfo__2());
  }
  _no_name_provided__103.prototype.access_1 = function (path_0, $cont) {
    return this._$jailRoot.get_115(trim(normalize(_get_pathInfo_(path_0)), charArrayOf([new Char(47)])));
  };
  _no_name_provided__103.prototype.transform_2 = function (_this__0, $cont) {
    var outPath = normalize(_get_pathInfo_(_this__0._path_7));
    if (!startsWith$default_1(outPath, this._baseJail, false, 2, null))
      throw UnsupportedOperationException_init_$Create$_0('' + 'Jail not base root : ' + _this__0._path_7 + ' | ' + this._baseJail);
    else {
    }
    var tmp0_substring_0 = this._baseJail.length;
    return this.file_8(outPath.substring(tmp0_substring_0));
  };
  _no_name_provided__103.prototype._get_absolutePath__9 = function () {
    return this._$jailRoot._get_absolutePath__9();
  };
  _no_name_provided__103.prototype.toString = function () {
    return '' + 'JailVfs(' + this._$jailRoot + ')';
  };
  _no_name_provided__103.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var resourcesVfsDebug;
  function LocalVfs() {
  }
  LocalVfs.$metadata$ = {
    simpleName: 'LocalVfs',
    kind: 'class',
    interfaces: []
  };
  function _get_localCurrentDirVfs_() {
    return _get_applicationVfs_();
  }
  function updateInfo($this, newInfo, $cont) {
    var tmp = new $updateInfoCOROUTINE$81($this, newInfo, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function $updateInfoCOROUTINE$81(_this_, newInfo, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__31 = _this_;
    this._newInfo = newInfo;
  }
  $updateInfoCOROUTINE$81.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (!this.__this__31._$info._v.equals(this._newInfo)) {
              this.__this__31._$info._v = this._newInfo;
              this._state_1 = 1;
              suspendResult = this.__this__31._this$0_26._files_0.setEntryInfo(this.__this__31._$npath, this.__this__31._$info._v, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $updateInfoCOROUTINE$81.$metadata$ = {
    simpleName: '$updateInfoCOROUTINE$81',
    kind: 'class',
    interfaces: []
  };
  function $writeCOROUTINE$82(_this_, position_1, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__32 = _this_;
    this._position = position_1;
    this._buffer_8 = buffer;
    this._offset_5 = offset;
    this._len_2 = len;
  }
  $writeCOROUTINE$82.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__32._this$0_26._files_0.writeData(this.__this__32._$npath, this._position, this._buffer_8, this._offset_5, this._len_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._state_1 = 2;
            var tmp_0 = this.__this__32._$info._v;
            var tmp_1 = this.__this__32._$info._v._size_6;
            var tmp_2 = max2_2(tmp_1, this._position.plus_64(toLong(this._len_2)));
            suspendResult = updateInfo(this.__this__32, tmp_0.copy$default_1(false, tmp_2, null, null, null, 29, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$82.$metadata$ = {
    simpleName: '$writeCOROUTINE$82',
    kind: 'class',
    interfaces: []
  };
  function initOnce_0($this, $cont) {
    var tmp = new $initOnceCOROUTINE$73($this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function ensureParentDirectory($this, nparent, npath, $cont) {
    var tmp = new $ensureParentDirectoryCOROUTINE$76($this, nparent, npath, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function _no_name_provided__104($info, this$0, $npath) {
    this._$info = $info;
    this._this$0_26 = this$0;
    this._$npath = $npath;
    AsyncStreamBase.call(this);
  }
  _no_name_provided__104.prototype.read_37 = function (position_1, buffer, offset, len, $cont) {
    return this._this$0_26._files_0.readData(this._$npath, position_1, buffer, offset, len, $cont);
  };
  _no_name_provided__104.prototype.write_30 = function (position_1, buffer, offset, len, $cont) {
    var tmp = new $writeCOROUTINE$82(this, position_1, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__104.prototype.getLength_14 = function ($cont) {
    return this._$info._v._size_6;
  };
  _no_name_provided__104.prototype.close_77 = function ($cont) {
  };
  _no_name_provided__104.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $initOnceCOROUTINE$73(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__33 = _this_;
  }
  $initOnceCOROUTINE$73.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            if (!this.__this__33._initialized_0) {
              this.__this__33._initialized_0 = true;
              this._state_1 = 1;
              suspendResult = this.__this__33._files_0.hasEntryInfo('/', this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT0_8 = suspendResult;
            if (!this._ARGUMENT0_8) {
              this._state_1 = 2;
              var tmp_0 = new Long(0, 0);
              suspendResult = this.__this__33._files_0.setEntryInfo('/', EntryInfo_init_$Create$(false, tmp_0, null, null, null, 28, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._state_1 = 4;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $initOnceCOROUTINE$73.$metadata$ = {
    simpleName: '$initOnceCOROUTINE$73',
    kind: 'class',
    interfaces: []
  };
  function $statCOROUTINE$75(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__34 = _this_;
    this._path_8 = path_0;
  }
  $statCOROUTINE$75.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = initOnce_0(this.__this__34, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._npath0 = this.__this__34.normalizePath(this._path_8);
            this._state_1 = 2;
            suspendResult = this.__this__34._files_0.getEntryInfo(this._npath0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return this.__this__34.createNonExistsStat$default_8(this._path_8, null, 2, null);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var entry = tmp_0;
            var tmp_1 = entry._get_isDirectory_();
            var tmp_2 = new Long(0, 0);
            var tmp_3 = new Long(0, 0);
            return this.__this__34.createExistsStat$default_0(this._path_8, tmp_1, entry._size_6, tmp_2, tmp_3, 0, null, null, entry._createdTime, entry._modifiedTime_0, null, null, null, 7416, null);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $statCOROUTINE$75.$metadata$ = {
    simpleName: '$statCOROUTINE$75',
    kind: 'class',
    interfaces: []
  };
  function $ensureParentDirectoryCOROUTINE$76(_this_, nparent, npath, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__35 = _this_;
    this._nparent = nparent;
    this._npath = npath;
  }
  $ensureParentDirectoryCOROUTINE$76.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this.__this__35._files_0.hasEntryInfo(this._nparent, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_9 = suspendResult;
            if (!this._ARGUMENT0_9) {
              throw new IOException('' + "Parent directory '" + this._nparent + "' for file '" + this._npath + "' doesn't exists");
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this._state_1 = 3;
            suspendResult = this.__this__35._files_0.getEntryInfo(this._nparent, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            var parent = ensureNotNull(ARGUMENT);
            if (parent._isFile)
              throw new IOException('' + "'" + this._nparent + "' is a file");
            return parent;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $ensureParentDirectoryCOROUTINE$76.$metadata$ = {
    simpleName: '$ensureParentDirectoryCOROUTINE$76',
    kind: 'class',
    interfaces: []
  };
  function $listFlowCOROUTINE$78(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__36 = _this_;
    this._path_9 = path_0;
  }
  $listFlowCOROUTINE$78.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = initOnce_0(this.__this__36, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._npath0_0 = this.__this__36.normalizePath(this._path_9);
            this._state_1 = 2;
            suspendResult = this.__this__36._files_0.getEntryInfo(this._npath0_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              throw new IOException('' + "Can't find '" + this._path_9 + "'");
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var entry = tmp_0;
            var tmp0_map_0 = entry._children_0;
            var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
            var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
            while (tmp0_iterator_1_2.hasNext_33()) {
              var item_2_3 = tmp0_iterator_1_2.next_37();
              tmp0_mapTo_0_1.add_39(new VfsFile(this.__this__36, item_2_3));
              Unit_getInstance();
            }

            return asFlow(tmp0_mapTo_0_1);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $listFlowCOROUTINE$78.$metadata$ = {
    simpleName: '$listFlowCOROUTINE$78',
    kind: 'class',
    interfaces: []
  };
  function $openCOROUTINE$79(_this_, path_0, mode, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__37 = _this_;
    this._path_10 = path_0;
    this._mode_1 = mode;
  }
  $openCOROUTINE$79.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            this._state_1 = 1;
            suspendResult = initOnce_0(this.__this__37, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._npath0_1 = this.__this__37.normalizePath(this._path_10);
            this._nparent1 = this.__this__37.normalizePath(_get_folder__0(_PathInfo___init__impl_(this._npath0_1)));
            this._state_1 = 2;
            suspendResult = ensureParentDirectory(this.__this__37, this._nparent1, this._npath0_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._parent2 = suspendResult;
            this._state_1 = 3;
            suspendResult = this.__this__37._files_0.hasEntryInfo(this._npath0_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._ARGUMENT3 = suspendResult;
            if (!this._ARGUMENT3) {
              if (!this._mode_1._createIfNotExists)
                throw new IOException('' + "File '" + this._npath0_1 + "' doesn't exists");
              this._state_1 = 4;
              var tmp_0 = new Long(0, 0);
              var tmp_1 = plus_0(this._parent2._children_0, this._npath0_1);
              suspendResult = this.__this__37._files_0.setEntryInfo(this._nparent1, this._parent2.copy$default_1(false, tmp_0, tmp_1, null, null, 27, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 4:
            suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._now4 = Companion_getInstance_18().now_2();
            this._state_1 = 6;
            suspendResult = this.__this__37._files_0.getEntryInfo(this._npath0_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              var tmp_3 = new Long(0, 0);
              tmp_2 = new EntryInfo(true, tmp_3, emptyList(), this._now4, this._now4);
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            var ARGUMENT = tmp_2;
            var info = {_v: ARGUMENT};
            if (info._v._get_isDirectory_())
              throw new IOException("Can't open a directory");
            var tmp_4 = new _no_name_provided__104(info, this.__this__37, this._npath0_1);
            return toAsyncStream$default(tmp_4, new Long(0, 0), 1, null);
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openCOROUTINE$79.$metadata$ = {
    simpleName: '$openCOROUTINE$79',
    kind: 'class',
    interfaces: []
  };
  function MapLikeStorageVfs(storage) {
    VfsV2.call(this);
    this._storage_3 = storage;
    this._files_0 = new StorageFiles(this._storage_3);
    this._initialized_0 = false;
  }
  MapLikeStorageVfs.prototype.normalizePath = function (_this__0) {
    var tmp = trim(_this__0, charArrayOf([new Char(47)]));
    var tmp_0 = new Char(92);
    var tmp_1 = new Char(47);
    return '/' + replace$default(tmp, tmp_0, tmp_1, false, 4, null);
  };
  MapLikeStorageVfs.prototype.stat_9 = function (path_0, $cont) {
    var tmp = new $statCOROUTINE$75(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  MapLikeStorageVfs.prototype.listFlow_8 = function (path_0, $cont) {
    var tmp = new $listFlowCOROUTINE$78(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  MapLikeStorageVfs.prototype.open_10 = function (path_0, mode, $cont) {
    var tmp = new $openCOROUTINE$79(this, path_0, mode, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  MapLikeStorageVfs.prototype.toString = function () {
    return 'MapLikeStorageVfs';
  };
  MapLikeStorageVfs.$metadata$ = {
    simpleName: 'MapLikeStorageVfs',
    kind: 'class',
    interfaces: []
  };
  function EntryInfo_init_$Init$(isFile, size_1, children_0, createdTime, modifiedTime, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      size_1 = new Long(0, 0);
    if (!(($mask0 & 4) === 0)) {
      children_0 = emptyList();
    }if (!(($mask0 & 8) === 0))
      createdTime = Companion_getInstance_18()._EPOCH;
    if (!(($mask0 & 16) === 0))
      modifiedTime = Companion_getInstance_18()._EPOCH;
    EntryInfo.call($this, isFile, size_1, children_0, createdTime, modifiedTime);
    return $this;
  }
  function EntryInfo_init_$Create$(isFile, size_1, children_0, createdTime, modifiedTime, $mask0, $marker) {
    return EntryInfo_init_$Init$(isFile, size_1, children_0, createdTime, modifiedTime, $mask0, $marker, Object.create(EntryInfo.prototype));
  }
  function Companion_48() {
    Companion_instance_47 = this;
    this._CHUNK_SIZE = 16384;
  }
  Companion_48.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_47;
  function Companion_getInstance_47() {
    if (Companion_instance_47 == null)
      new Companion_48();
    return Companion_instance_47;
  }
  function EntryInfo(isFile, size_1, children_0, createdTime, modifiedTime) {
    this._isFile = isFile;
    this._size_6 = size_1;
    this._children_0 = children_0;
    this._createdTime = createdTime;
    this._modifiedTime_0 = modifiedTime;
  }
  EntryInfo.prototype._get_isDirectory_ = function () {
    return !this._isFile;
  };
  EntryInfo.prototype.copy_2 = function (isFile, size_1, children_0, createdTime, modifiedTime) {
    return new EntryInfo(isFile, size_1, children_0, createdTime, modifiedTime);
  };
  EntryInfo.prototype.copy$default_1 = function (isFile, size_1, children_0, createdTime, modifiedTime, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      isFile = this._isFile;
    if (!(($mask0 & 2) === 0))
      size_1 = this._size_6;
    if (!(($mask0 & 4) === 0))
      children_0 = this._children_0;
    if (!(($mask0 & 8) === 0))
      createdTime = this._createdTime;
    if (!(($mask0 & 16) === 0))
      modifiedTime = this._modifiedTime_0;
    return this.copy_2(isFile, size_1, children_0, createdTime, modifiedTime);
  };
  EntryInfo.prototype.toString = function () {
    return '' + 'EntryInfo(isFile=' + this._isFile + ', size=' + this._size_6 + ', children=' + this._children_0 + ', createdTime=' + new DateTime(this._createdTime) + ', modifiedTime=' + new DateTime(this._modifiedTime_0) + ')';
  };
  EntryInfo.prototype.hashCode = function () {
    var result = this._isFile | 0;
    result = imul(result, 31) + this._size_6.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._children_0) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._createdTime) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._modifiedTime_0) | 0;
    return result;
  };
  EntryInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntryInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof EntryInfo ? other : THROW_CCE();
    if (!(this._isFile === tmp0_other_with_cast._isFile))
      return false;
    if (!this._size_6.equals(tmp0_other_with_cast._size_6))
      return false;
    if (!equals_1(this._children_0, tmp0_other_with_cast._children_0))
      return false;
    if (!equals_1(new DateTime(this._createdTime), new DateTime(tmp0_other_with_cast._createdTime)))
      return false;
    if (!equals_1(new DateTime(this._modifiedTime_0), new DateTime(tmp0_other_with_cast._modifiedTime_0)))
      return false;
    return true;
  };
  EntryInfo.$metadata$ = {
    simpleName: 'EntryInfo',
    kind: 'class',
    interfaces: []
  };
  function $setEntryInfoCOROUTINE$83(_this_, fileName, isFile, size_1, children_0, createdTime, modifiedTime, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__38 = _this_;
    this._fileName = fileName;
    this._isFile_0 = isFile;
    this._size_7 = size_1;
    this._children_1 = children_0;
    this._createdTime_0 = createdTime;
    this._modifiedTime_1 = modifiedTime;
  }
  $setEntryInfoCOROUTINE$83.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__38.getEntryInfo(this._fileName, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._oldEntry0 = suspendResult;
            if (!(this._oldEntry0 == null)) {
            }
            this._state_1 = 2;
            var tmp_0 = this.__this__38.getStatsKey(this._fileName);
            var tmp_1 = Json_getInstance();
            var tmp_2 = hashMapOf([to(isFile$factory().callableName, this._isFile_0), to(size$factory().callableName, this._size_7.toDouble_6()), to(children$factory().callableName, this._children_1), to(createdTime$factory().callableName, _DateTime___get_unixMillisDouble__impl_(this._createdTime_0)), to(modifiedTime$factory().callableName, _DateTime___get_unixMillisDouble__impl_(this._modifiedTime_1))]);
            suspendResult = this.__this__38._storage_4.set_16(tmp_0, tmp_1.stringify$default(tmp_2, false, 2, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $setEntryInfoCOROUTINE$83.$metadata$ = {
    simpleName: '$setEntryInfoCOROUTINE$83',
    kind: 'class',
    interfaces: []
  };
  function $hasEntryInfoCOROUTINE$84(_this_, fileName, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__39 = _this_;
    this._fileName_0 = fileName;
  }
  $hasEntryInfoCOROUTINE$84.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__39.getEntryInfo(this._fileName_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT == null;
            return !ARGUMENT_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $hasEntryInfoCOROUTINE$84.$metadata$ = {
    simpleName: '$hasEntryInfoCOROUTINE$84',
    kind: 'class',
    interfaces: []
  };
  function $getEntryInfoCOROUTINE$85(_this_, fileName, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__40 = _this_;
    this._fileName_1 = fileName;
  }
  $getEntryInfoCOROUTINE$85.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__40._storage_4.get_115(this.__this__40.getStatsKey(this._fileName_1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var info = tmp_0;
            var tmp_1 = Json_getInstance();
            var tmp_2 = tmp_1.parse$default(info, null, 2, null);
            var di = (!(tmp_2 == null) ? isInterface(tmp_2, Map_0) : false) ? tmp_2 : THROW_CCE();
            var tmp_3 = ensureNotNull(di.get_116(isFile$factory_0().callableName));
            var tmp_4 = typeof tmp_3 === 'boolean' ? tmp_3 : THROW_CCE();
            var tmp_5 = ensureNotNull(di.get_116(size$factory_0().callableName));
            var tmp_6 = numberToLong(isNumber(tmp_5) ? tmp_5 : THROW_CCE());
            var tmp_7 = di.get_116(children$factory_0().callableName);
            var tmp_8 = toList_2((!(tmp_7 == null) ? isInterface(tmp_7, Iterable) : false) ? tmp_7 : THROW_CCE());
            var tmp_9 = Companion_getInstance_18();
            var tmp_10 = di.get_116(createdTime$factory_0().callableName);
            var tmp_11 = tmp_9.fromUnix(numberToDouble(isNumber(tmp_10) ? tmp_10 : THROW_CCE()));
            var tmp_12 = Companion_getInstance_18();
            var tmp_13 = di.get_116(modifiedTime$factory_0().callableName);
            return new EntryInfo(tmp_4, tmp_6, tmp_8, tmp_11, tmp_12.fromUnix(numberToDouble(isNumber(tmp_13) ? tmp_13 : THROW_CCE())));
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getEntryInfoCOROUTINE$85.$metadata$ = {
    simpleName: '$getEntryInfoCOROUTINE$85',
    kind: 'class',
    interfaces: []
  };
  function $setFileChunkCOROUTINE$87(_this_, fileName, chunk, data, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__41 = _this_;
    this._fileName_2 = fileName;
    this._chunk = chunk;
    this._data_11 = data;
  }
  $setFileChunkCOROUTINE$87.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__41._storage_4.set_16(this.__this__41.getChunkKey(this._fileName_2, this._chunk), _get_hex_(this._data_11), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $setFileChunkCOROUTINE$87.$metadata$ = {
    simpleName: '$setFileChunkCOROUTINE$87',
    kind: 'class',
    interfaces: []
  };
  function $getFileChunkCOROUTINE$88(_this_, fileName, chunk, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__42 = _this_;
    this._fileName_3 = fileName;
    this._chunk_0 = chunk;
  }
  $getFileChunkCOROUTINE$88.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__42._storage_4.get_115(this.__this__42.getChunkKey(this._fileName_3, this._chunk_0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            return tmp0_safe_receiver == null ? null : _get_unhex_(tmp0_safe_receiver);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getFileChunkCOROUTINE$88.$metadata$ = {
    simpleName: '$getFileChunkCOROUTINE$88',
    kind: 'class',
    interfaces: []
  };
  function $writeDataCOROUTINE$89(_this_, fileName, position_1, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__43 = _this_;
    this._fileName_4 = fileName;
    this._position_0 = position_1;
    this._buffer_9 = buffer;
    this._offset_6 = offset;
    this._len_3 = len;
  }
  $writeDataCOROUTINE$89.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._pending0 = this._len_3;
            this._apos1 = this._position_0;
            this._aoffset2 = this._offset_6;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!(this._pending0 > 0)) {
              this._state_1 = 4;
              continue $sm;
            }
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_div_03 = this._apos1;
            var tmp_2 = this;
            tmp_2._tmp1_div_04 = Companion_getInstance_47()._CHUNK_SIZE;
            tmp_0._chunk5 = this._tmp0_div_03.div_28(toLong(this._tmp1_div_04)).toInt_8();
            var tmp_3 = this;
            var tmp_4 = this;
            tmp_4._tmp2_rem_06 = this._apos1;
            var tmp_5 = this;
            tmp_5._tmp3_rem_07 = Companion_getInstance_47()._CHUNK_SIZE;
            tmp_3._inChunk8 = this._tmp2_rem_06.rem_27(toLong(this._tmp3_rem_07)).toInt_8();
            this._state_1 = 2;
            suspendResult = this.__this__43.getFileChunk(this._fileName_4, this._chunk5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._tmp0_elvis_lhs9 = suspendResult;
            var tmp_6 = this;
            var tmp_7;
            if (this._tmp0_elvis_lhs9 == null) {
              var tmp_8 = this;
              tmp_8._tmp4_byteArrayOf_010 = new Int8Array([]);
              tmp_7 = this._tmp4_byteArrayOf_010;
            } else {
              tmp_7 = this._tmp0_elvis_lhs9;
            }

            tmp_6._c11 = tmp_7;
            this._available12 = Companion_getInstance_47()._CHUNK_SIZE - this._inChunk8 | 0;
            this._written13 = min2_0(this._available12, this._pending0);
            if (this._written13 <= 0) {
              invalidOp('Unexpected written');
            }
            this._cc14 = copyOf(this._c11, this._inChunk8 + this._written13 | 0);
            arraycopy_2(this._buffer_9, this._aoffset2, this._cc14, this._inChunk8, this._written13);
            this._state_1 = 3;
            suspendResult = this.__this__43.setFileChunk(this._fileName_4, this._chunk5, this._cc14, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            this._pending0 = this._pending0 - this._written13 | 0;
            var tmp_9 = this;
            var tmp5_plus_0 = this._apos1;
            tmp_9._apos1 = tmp5_plus_0.plus_64(toLong(this._written13));
            this._aoffset2 = this._aoffset2 + this._written13 | 0;
            this._state_1 = 1;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeDataCOROUTINE$89.$metadata$ = {
    simpleName: '$writeDataCOROUTINE$89',
    kind: 'class',
    interfaces: []
  };
  function $readDataCOROUTINE$90(_this_, fileName, position_1, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__44 = _this_;
    this._fileName_5 = fileName;
    this._position_1 = position_1;
    this._buffer_10 = buffer;
    this._offset_7 = offset;
    this._len_4 = len;
  }
  $readDataCOROUTINE$90.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__44.getEntryInfo(this._fileName_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_elvis_lhs0 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (this._tmp0_elvis_lhs0 == null) {
              return -1;
            } else {
              tmp_1 = this._tmp0_elvis_lhs0;
            }

            tmp_0._info1 = tmp_1;
            if (this._position_1.compareTo_137(this._info1._size_6) >= 0)
              return 0;
            var tmp_2 = this;
            var tmp_3 = this;
            tmp_3._tmp0_div_02 = Companion_getInstance_47()._CHUNK_SIZE;
            tmp_2._chunk3 = this._position_1.div_28(toLong(this._tmp0_div_02)).toInt_8();
            var tmp_4 = this;
            var tmp_5 = this;
            tmp_5._tmp1_rem_04 = Companion_getInstance_47()._CHUNK_SIZE;
            tmp_4._inChunk5 = this._position_1.rem_27(toLong(this._tmp1_rem_04)).toInt_8();
            this._state_1 = 2;
            suspendResult = this.__this__44.getFileChunk(this._fileName_5, this._chunk3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_6;
            if (tmp1_elvis_lhs == null) {
              return 0;
            } else {
              tmp_6 = tmp1_elvis_lhs;
            }

            var c = tmp_6;
            var available = c.length - this._inChunk5 | 0;
            var read_1 = min2_0(available, this._len_4);
            arraycopy_2(c, this._inChunk5, this._buffer_10, this._offset_7, read_1);
            return read_1;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readDataCOROUTINE$90.$metadata$ = {
    simpleName: '$readDataCOROUTINE$90',
    kind: 'class',
    interfaces: []
  };
  function StorageFiles(storage) {
    Companion_getInstance_47();
    this._storage_4 = storage;
  }
  StorageFiles.prototype.getStatsKey = function (fileName) {
    return '' + 'korio_stats_v1_' + fileName;
  };
  StorageFiles.prototype.getChunkKey = function (fileName, chunk) {
    return '' + 'korio_chunk' + chunk + '_v1_' + fileName;
  };
  StorageFiles.prototype.setEntryInfo = function (fileName, info, $cont) {
    return this.setEntryInfo_0(fileName, info._isFile, info._size_6, info._children_0, info._createdTime, info._modifiedTime_0, $cont);
  };
  StorageFiles.prototype.setEntryInfo_0 = function (fileName, isFile, size_1, children_0, createdTime, modifiedTime, $cont) {
    var tmp = new $setEntryInfoCOROUTINE$83(this, fileName, isFile, size_1, children_0, createdTime, modifiedTime, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  StorageFiles.prototype.hasEntryInfo = function (fileName, $cont) {
    var tmp = new $hasEntryInfoCOROUTINE$84(this, fileName, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  StorageFiles.prototype.getEntryInfo = function (fileName, $cont) {
    var tmp = new $getEntryInfoCOROUTINE$85(this, fileName, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  StorageFiles.prototype.setFileChunk = function (fileName, chunk, data, $cont) {
    var tmp = new $setFileChunkCOROUTINE$87(this, fileName, chunk, data, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  StorageFiles.prototype.getFileChunk = function (fileName, chunk, $cont) {
    var tmp = new $getFileChunkCOROUTINE$88(this, fileName, chunk, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  StorageFiles.prototype.writeData = function (fileName, position_1, buffer, offset, len, $cont) {
    var tmp = new $writeDataCOROUTINE$89(this, fileName, position_1, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  StorageFiles.prototype.readData = function (fileName, position_1, buffer, offset, len, $cont) {
    var tmp = new $readDataCOROUTINE$90(this, fileName, position_1, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  StorageFiles.$metadata$ = {
    simpleName: 'StorageFiles',
    kind: 'class',
    interfaces: []
  };
  function isFile$factory() {
    return getPropertyCallableRef('isFile', 1, KProperty1, function (receiver) {
      return receiver._isFile;
    }, null);
  }
  function size$factory() {
    return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
      return receiver._size_6;
    }, null);
  }
  function children$factory() {
    return getPropertyCallableRef('children', 1, KProperty1, function (receiver) {
      return receiver._children_0;
    }, null);
  }
  function createdTime$factory() {
    return getPropertyCallableRef('createdTime', 1, KProperty1, function (receiver) {
      return new DateTime(receiver._createdTime);
    }, null);
  }
  function modifiedTime$factory() {
    return getPropertyCallableRef('modifiedTime', 1, KProperty1, function (receiver) {
      return new DateTime(receiver._modifiedTime_0);
    }, null);
  }
  function isFile$factory_0() {
    return getPropertyCallableRef('isFile', 1, KProperty1, function (receiver) {
      return receiver._isFile;
    }, null);
  }
  function size$factory_0() {
    return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
      return receiver._size_6;
    }, null);
  }
  function children$factory_0() {
    return getPropertyCallableRef('children', 1, KProperty1, function (receiver) {
      return receiver._children_0;
    }, null);
  }
  function createdTime$factory_0() {
    return getPropertyCallableRef('createdTime', 1, KProperty1, function (receiver) {
      return new DateTime(receiver._createdTime);
    }, null);
  }
  function modifiedTime$factory_0() {
    return getPropertyCallableRef('modifiedTime', 1, KProperty1, function (receiver) {
      return new DateTime(receiver._modifiedTime_0);
    }, null);
  }
  function MemoryVfs(items, caseSensitive) {
    var vfs = new NodeVfs(caseSensitive);
    var tmp0_iterator = items._get_entries__10().iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var tmp1_loop_parameter = tmp0_iterator.next_37();
      var path_0 = tmp1_loop_parameter._get_key__37();
      var stream = tmp1_loop_parameter._get_value__10();
      var info = _PathInfo___init__impl_(path_0);
      var folderNode = vfs._rootNode.access_2(_get_folder__0(info), true);
      var fileNode = folderNode.createChild(_get_baseName__0(info), false);
      fileNode._stream = stream;
    }
    return vfs._get_root__33();
  }
  function MemoryVfs$default(items, caseSensitive, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      items = LinkedHashMap_init_$Create$();
    if (!(($mask0 & 2) === 0))
      caseSensitive = true;
    return MemoryVfs(items, caseSensitive);
  }
  function Mountable() {
  }
  Mountable.$metadata$ = {
    simpleName: 'Mountable',
    kind: 'interface',
    interfaces: []
  };
  function MountableVfs(closeMounts, callback, $cont) {
    var tmp = new $MountableVfsCOROUTINE$91(closeMounts, callback, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function MountableVfs$default(closeMounts, callback, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      closeMounts = false;
    return MountableVfs(closeMounts, callback, $cont);
  }
  function unmountInternal($this, folder) {
    removeAll($this._mounts, _no_name_provided_$factory_80(folder));
    Unit_getInstance();
  }
  function resort($this) {
    var tmp0_sortByDescending_0 = $this._mounts;
    if (tmp0_sortByDescending_0._get_size__60() > 1) {
      var tmp = _no_name_provided_$factory_81();
      sortWith(tmp0_sortByDescending_0, new sam$kotlin_Comparator$0_0(tmp));
    }}
  function sam$kotlin_Comparator$0_0(function_0) {
    this._function_0 = function_0;
  }
  sam$kotlin_Comparator$0_0.prototype.compare_10 = function (a, b) {
    return this._function_0(a, b);
  };
  sam$kotlin_Comparator$0_0.prototype.compare = function (a, b) {
    return this.compare_10(a, b);
  };
  sam$kotlin_Comparator$0_0.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__105($folder) {
    this._$folder = $folder;
  }
  _no_name_provided__105.prototype.invoke_178 = function (it) {
    return equals_1(it._first, normalize(_get_pathInfo_(this._$folder)));
  };
  _no_name_provided__105.prototype.invoke_1015 = function (p1) {
    return this.invoke_178(p1 instanceof Pair ? p1 : THROW_CCE());
  };
  _no_name_provided__105.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__106() {
  }
  _no_name_provided__106.prototype.invoke_180 = function (a, b) {
    var tmp = b._first.length;
    return compareValues(tmp, a._first.length);
  };
  _no_name_provided__106.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof Pair ? p1 : THROW_CCE();
    return this.invoke_180(tmp, p2 instanceof Pair ? p2 : THROW_CCE());
  };
  _no_name_provided__106.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $closeCOROUTINE$92(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__45 = _this_;
  }
  $closeCOROUTINE$92.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            if (this.__this__45._closeMounts) {
              var tmp_0 = this;
              tmp_0._tmp0_fastForEach_00 = this.__this__45._mounts;
              this._n_11 = 0;
              this._state_1 = 1;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 1:
            if (!(this._n_11 < this._tmp0_fastForEach_00._get_size__60())) {
              this._state_1 = 3;
              continue $sm;
            }
            var tmp_1 = this;
            var tmp0_2 = this._n_11;
            this._n_11 = tmp0_2 + 1 | 0;
            tmp_1._tmp1__anonymous__32 = this._tmp0_fastForEach_00.get_137(tmp0_2);
            this._state_1 = 2;
            suspendResult = this._tmp1__anonymous__32._second._vfs.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            this._state_1 = 4;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $closeCOROUTINE$92.$metadata$ = {
    simpleName: '$closeCOROUTINE$92',
    kind: 'class',
    interfaces: []
  };
  function MountableVfs_0(closeMounts) {
    Proxy.call(this);
    this._closeMounts = closeMounts;
    this._mounts = ArrayList_init_$Create$();
  }
  MountableVfs_0.prototype.close_77 = function ($cont) {
    var tmp = new $closeCOROUTINE$92(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  MountableVfs_0.prototype.mount_0 = function (folder, file) {
    unmountInternal(this, folder);
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._mounts;
    var tmp1_plusAssign_0_4 = to(normalize(_get_pathInfo_(folder)), file);
    tmp0_plusAssign_0_3.add_39(tmp1_plusAssign_0_4);
    Unit_getInstance();
    resort(this);
    return this;
  };
  MountableVfs_0.prototype.access_1 = function (path_0, $cont) {
    var rpath = normalize(_get_pathInfo_(path_0));
    var tmp0_fastForEach_0 = this._mounts;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      var base_4 = tmp1__anonymous__3.component1_1();
      var file_5 = tmp1__anonymous__3.component2_1();
      if (startsWith$default_1(rpath, base_4, false, 2, null)) {
        var tmp0_substring_0_6 = base_4.length;
        return file_5.get_115(rpath.substring(tmp0_substring_0_6));
      } else {
      }
    }
    throw new FileNotFoundException(path_0);
  };
  MountableVfs_0.prototype.toString = function () {
    return 'MountableVfs';
  };
  MountableVfs_0.$metadata$ = {
    simpleName: 'MountableVfs',
    kind: 'class',
    interfaces: [Mountable]
  };
  function $MountableVfsCOROUTINE$91(closeMounts, callback, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._closeMounts_0 = closeMounts;
    this._callback = callback;
  }
  $MountableVfsCOROUTINE$91.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_also_00_0 = new MountableVfs_0(this._closeMounts_0);
            this._state_1 = 1;
            suspendResult = this._callback(this._tmp0_also_00_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            var ARGUMENT = this._tmp0_also_00_0;
            return ARGUMENT._get_root__33();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $MountableVfsCOROUTINE$91.$metadata$ = {
    simpleName: '$MountableVfsCOROUTINE$91',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_80($folder) {
    var i = new _no_name_provided__105($folder);
    return function (p1) {
      return i.invoke_178(p1);
    };
  }
  function _no_name_provided_$factory_81() {
    var i = new _no_name_provided__106();
    return function (p1, p2) {
      return i.invoke_180(p1, p2);
    };
  }
  function Node_init_$Init$($outer, name, isDirectory, parent, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      isDirectory = false;
    if (!(($mask0 & 8) === 0))
      parent = null;
    Node_1.call($this, $outer, name, isDirectory, parent);
    return $this;
  }
  function Node_init_$Create$($outer, name, isDirectory, parent, $mask0, $marker) {
    return Node_init_$Init$($outer, name, isDirectory, parent, $mask0, $marker, Object.create(Node_1.prototype));
  }
  function Node_1($outer, name, isDirectory, parent) {
    this._$this_8 = $outer;
    this._name_4 = name;
    this._isDirectory_1 = isDirectory;
    var tmp = this;
    var tmp0_toLowerCase_0 = this._name_4;
    tmp._nameLC = tmp0_toLowerCase_0.toLowerCase();
    this._parent_0 = null;
    this._set_parent_(parent);
    this._data_12 = null;
    var tmp_0 = this;
    tmp_0._children_2 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    tmp_1._childrenLC = LinkedHashMap_init_$Create$();
    this._stream = null;
  }
  Node_1.prototype.iterator_67 = function () {
    return this._children_2._get_values__9().iterator_67();
  };
  Node_1.prototype._set_parent_ = function (value) {
    if (!(this._parent_0 == null)) {
      ensureNotNull(this._parent_0)._children_2.remove_72(this._name_4);
      Unit_getInstance();
      ensureNotNull(this._parent_0)._childrenLC.remove_72(this._nameLC);
      Unit_getInstance();
    }this._parent_0 = value;
    var tmp0_safe_receiver = this._parent_0;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._children_2;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp0_set_0 = this._name_4;
      tmp1_safe_receiver.put_18(tmp0_set_0, this);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp2_safe_receiver = this._parent_0;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._childrenLC;
    if (tmp3_safe_receiver == null)
      null;
    else {
      var tmp1_set_0 = this._nameLC;
      tmp3_safe_receiver.put_18(tmp1_set_0, this);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  Node_1.prototype._get_root__33 = function () {
    var tmp0_safe_receiver = this._parent_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_root__33();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  };
  Node_1.prototype.child = function (name) {
    var tmp0_subject = name;
    var tmp;
    switch (tmp0_subject) {
      case '':
      case '.':
        tmp = this;
        break;
      case '..':
        tmp = this._parent_0;
        break;
      default:var tmp_0;
        if (this._$this_8._caseSensitive_1) {
          tmp_0 = this._children_2.get_116(name);
        } else {
          tmp_0 = this._childrenLC.get_116(name.toLowerCase());
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  };
  Node_1.prototype.createChild = function (name, isDirectory) {
    return new Node_1(this._$this_8, name, isDirectory, this);
  };
  Node_1.prototype.get_115 = function (path_0) {
    return this.access_2(path_0, false);
  };
  Node_1.prototype.access_2 = function (path_0, createFolders) {
    var tmp;
    var tmp_0 = new Char(47);
    if (startsWith$default(path_0, tmp_0, false, 2, null)) {
      tmp = this._get_root__33();
    } else {
      {
        tmp = this;
      }
    }
    var node = tmp;
    var tmp0_fastForEach_0 = parts(_get_pathInfo_(path_0));
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      var child_4 = node.child(tmp1__anonymous__3);
      if (child_4 == null ? createFolders : false)
        child_4 = node.createChild(tmp1__anonymous__3, true);
      var tmp0_elvis_lhs_5 = child_4;
      var tmp_1;
      if (tmp0_elvis_lhs_5 == null) {
        throw new FileNotFoundException('' + "Can't find '" + tmp1__anonymous__3 + "' in " + path_0);
      } else {
        tmp_1 = tmp0_elvis_lhs_5;
      }
      node = tmp_1;
    }
    return node;
  };
  Node_1.prototype.access$default = function (path_0, createFolders, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      createFolders = false;
    return this.access_2(path_0, createFolders);
  };
  Node_1.$metadata$ = {
    simpleName: 'Node',
    kind: 'class',
    interfaces: [Iterable]
  };
  function createStream($this, s, vfsFile) {
    var tmp = new _no_name_provided__107(s, $this, vfsFile);
    return toAsyncStream$default(tmp, new Long(0, 0), 1, null);
  }
  function _no_name_provided__107($s, this$0, $vfsFile) {
    this._$s = $s;
    this._this$0_27 = this$0;
    this._$vfsFile = $vfsFile;
    AsyncStreamBase.call(this);
  }
  _no_name_provided__107.prototype.read_37 = function (position_1, buffer, offset, len, $cont) {
    return this._$s.read_37(position_1, buffer, offset, len);
  };
  _no_name_provided__107.prototype.write_30 = function (position_1, buffer, offset, len, $cont) {
    this._$s.write_30(position_1, buffer, offset, len);
    var tmp = Kind_MODIFIED_getInstance();
    this._this$0_27._events.invoke_137(FileEvent_init_$Create$(tmp, this._$vfsFile, null, 4, null));
  };
  _no_name_provided__107.prototype.getLength_14 = function ($cont) {
    return this._$s._get_length__5();
  };
  _no_name_provided__107.prototype.close_77 = function ($cont) {
    return this._$s.close_77();
  };
  _no_name_provided__107.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__108(this$0, $path, resultContinuation) {
    this._this$0_28 = this$0;
    this._$path_1 = $path;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__108.prototype.invoke_191 = function ($this$flow, $cont) {
    var tmp = this.create_10($this$flow, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__108.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_191((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__108.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._node0 = this._this$0_28._rootNode.get_115(this._$path_1);
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_iterator_01 = this._node0._children_2;
            tmp_0._tmp0_iterator2 = this._tmp0_iterator_01._get_entries__10().iterator_67();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator2.hasNext_33()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._tmp1_loop_parameter3 = this._tmp0_iterator2.next_37();
            var tmp_2 = this;
            tmp_2._name4 = this._tmp1_loop_parameter3._get_key__37();
            this._state_1 = 2;
            suspendResult = this._$this$flow_2.emit_8(this._this$0_28.file_8('' + this._$path_1 + '/' + this._name4), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__108.prototype.create_10 = function ($this$flow, completion) {
    var i = new _no_name_provided__108(this._this$0_28, this._$path_1, completion);
    i._$this$flow_2 = $this$flow;
    return i;
  };
  _no_name_provided__108.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $statCOROUTINE$93(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__46 = _this_;
    this._path_11 = path_0;
  }
  $statCOROUTINE$93.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._exceptionState = 3;
            var tmp_0 = this;
            tmp_0._node1 = this.__this__46._rootNode.access$default(this._path_11, false, 2, null);
            this._tmp0_safe_receiver2 = this._node1._stream;
            if (this._tmp0_safe_receiver2 == null) {
              this._WHEN_RESULT3 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver2.getLength_14(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT3 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = this._WHEN_RESULT3;
            var length = tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs;
            var tmp_1 = this;
            var tmp_2 = new Long(0, 0);
            var tmp_3 = new Long(0, 0);
            tmp_1._TRY_RESULT0_0 = this.__this__46.createExistsStat$default_0(this._path_11, this._node1._isDirectory_1, length, tmp_2, tmp_3, 0, null, null, null, null, null, null, null, 8184, null);
            this._exceptionState = 4;
            this._state_1 = 5;
            continue $sm;
          case 3:
            this._exceptionState = 4;
            var tmp_4 = this._exception_0;
            if (tmp_4 instanceof Error) {
              var e = this._exception_0;
              var tmp_5 = this;
              tmp_5._TRY_RESULT0_0 = this.__this__46.createNonExistsStat$default_8(this._path_11, null, 2, null);
              this._state_1 = 5;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            throw this._exception_0;
          case 5:
            this._exceptionState = 4;
            return this._TRY_RESULT0_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $statCOROUTINE$93.$metadata$ = {
    simpleName: '$statCOROUTINE$93',
    kind: 'class',
    interfaces: []
  };
  function NodeVfs(caseSensitive) {
    VfsV2.call(this);
    this._caseSensitive_1 = caseSensitive;
    var tmp = this;
    tmp._events = Signal_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._rootNode = Node_init_$Create$(this, '', true, null, 8, null);
  }
  NodeVfs.prototype.open_10 = function (path_0, mode, $cont) {
    var pathInfo = _PathInfo___init__impl_(path_0);
    var tmp = _get_folder__0(pathInfo);
    var folder = this._rootNode.access$default(tmp, false, 2, null);
    var node = folder.child(_get_baseName__0(pathInfo));
    var vfsFile = this.get_115(path_0);
    if (node == null ? mode._createIfNotExists : false) {
      node = folder.createChild(_get_baseName__0(pathInfo), false);
      var tmp_0 = node;
      tmp_0._stream = createStream(this, MemorySyncStream$default(null, 1, null)._base_2, vfsFile);
    } else if (mode._truncate) {
      var tmp0_safe_receiver = node;
      if (tmp0_safe_receiver == null) {
        Unit_getInstance();
      } else {
        var tmp_1 = tmp0_safe_receiver;
        tmp_1._stream = createStream(this, MemorySyncStream$default(null, 1, null)._base_2, vfsFile);
      }
    }var tmp1_safe_receiver = node;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._stream;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.duplicate();
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      throw new FileNotFoundException(path_0);
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    return tmp_2;
  };
  NodeVfs.prototype.stat_9 = function (path_0, $cont) {
    var tmp = new $statCOROUTINE$93(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  NodeVfs.prototype.listFlow_8 = function (path_0, $cont) {
    return flow(_no_name_provided_$factory_82(this, path_0, null));
  };
  NodeVfs.prototype.toString = function () {
    return 'NodeVfs';
  };
  NodeVfs.$metadata$ = {
    simpleName: 'NodeVfs',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_82(this$0, $path, resultContinuation) {
    var i = new _no_name_provided__108(this$0, $path, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_191(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  var defaultUniSchema;
  function UniSchemaProviders_init_$Init$(providers, $this) {
    var capacity_1 = coerceAtLeast(mapCapacity(providers.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = providers;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_18(element_2_4._name_5, element_2_4);
      Unit_getInstance();
    }
    UniSchemaProviders.call($this, tmp0_associateByTo_0_2);
    return $this;
  }
  function UniSchemaProviders_init_$Create$(providers) {
    return UniSchemaProviders_init_$Init$(providers, Object.create(UniSchemaProviders.prototype));
  }
  function UniSchemaProviders(providers) {
    this._providers = providers;
  }
  UniSchemaProviders.$metadata$ = {
    simpleName: 'UniSchemaProviders',
    kind: 'class',
    interfaces: []
  };
  function UniSchema(name, provider) {
    this._name_5 = name;
    this._provider = provider;
  }
  UniSchema.$metadata$ = {
    simpleName: 'UniSchema',
    kind: 'class',
    interfaces: []
  };
  function _get_uniVfs_(_this_) {
    var tmp = UniversalVfs_getInstance();
    var tmp_0 = defaultUniSchema;
    return tmp.invoke$default_0(_this_, tmp_0, null, 4, null);
  }
  function UniversalVfs() {
    UniversalVfs_instance = this;
  }
  UniversalVfs.prototype.invoke_184 = function (uri, providers, base) {
    var tmp;
    if (Companion_getInstance_50().isAbsolute(uri)) {
      var uriUri = Companion_getInstance_50().invoke_203(uri);
      var tmp0_get_0 = providers._providers;
      var tmp1_get_0 = uriUri._scheme;
      var builder = (isInterface(tmp0_get_0, Map_0) ? tmp0_get_0 : THROW_CCE()).get_116(tmp1_get_0);
      var tmp_0;
      if (!(builder == null)) {
        tmp_0 = builder._provider(uriUri);
      } else {
        invalidOp('' + "Unsupported scheme '" + uriUri._scheme + "'");
      }
      tmp = tmp_0;
    } else if (!(base == null)) {
      tmp = base.get_115(uri);
    } else {
      tmp = _get_localCurrentDirVfs_().get_115(uri);
    }
    return tmp;
  };
  UniversalVfs.prototype.invoke$default_0 = function (uri, providers, base, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      base = null;
    return this.invoke_184(uri, providers, base);
  };
  UniversalVfs.$metadata$ = {
    simpleName: 'UniversalVfs',
    kind: 'object',
    interfaces: []
  };
  var UniversalVfs_instance;
  function UniversalVfs_getInstance() {
    if (UniversalVfs_instance == null)
      new UniversalVfs();
    return UniversalVfs_instance;
  }
  function _no_name_provided__109() {
  }
  _no_name_provided__109.prototype.invoke_189 = function (it) {
    return UrlVfs$default(it, null, false, 6, null);
  };
  _no_name_provided__109.prototype.invoke_1015 = function (p1) {
    return this.invoke_189(p1 instanceof URL_0 ? p1 : THROW_CCE());
  };
  _no_name_provided__109.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__110() {
  }
  _no_name_provided__110.prototype.invoke_189 = function (it) {
    return UrlVfs$default(it, null, false, 6, null);
  };
  _no_name_provided__110.prototype.invoke_1015 = function (p1) {
    return this.invoke_189(p1 instanceof URL_0 ? p1 : THROW_CCE());
  };
  _no_name_provided__110.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__111() {
  }
  _no_name_provided__111.prototype.invoke_189 = function (it) {
    return _get_rootLocalVfs_().get_115(it._path_16);
  };
  _no_name_provided__111.prototype.invoke_1015 = function (p1) {
    return this.invoke_189(p1 instanceof URL_0 ? p1 : THROW_CCE());
  };
  _no_name_provided__111.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_83() {
    var i = new _no_name_provided__109();
    return function (p1) {
      return i.invoke_189(p1);
    };
  }
  function _no_name_provided_$factory_84() {
    var i = new _no_name_provided__110();
    return function (p1) {
      return i.invoke_189(p1);
    };
  }
  function _no_name_provided_$factory_85() {
    var i = new _no_name_provided__111();
    return function (p1) {
      return i.invoke_189(p1);
    };
  }
  function defaultUniSchema$init$() {
    var tmp = new UniSchema('http', _no_name_provided_$factory_83());
    var tmp_0 = new UniSchema('https', _no_name_provided_$factory_84());
    return UniSchemaProviders_init_$Create$([tmp, tmp_0, new UniSchema('file', _no_name_provided_$factory_85())]);
  }
  function UrlVfs(url, client, failFromStatus) {
    return (new UrlVfs_0(url.copy$default_2(false, null, null, null, '', null, null, 0, 207, null)._get_fullUrl_(), Unit_getInstance(), client, failFromStatus)).get_115(url._path_16);
  }
  function UrlVfs$default(url, client, failFromStatus, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      client = createHttpClient();
    if (!(($mask0 & 4) === 0))
      failFromStatus = true;
    return UrlVfs(url, client, failFromStatus);
  }
  function $readCOROUTINE$100(_this_, position_1, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__47 = _this_;
    this._position_2 = position_1;
    this._buffer_11 = buffer;
    this._offset_8 = offset;
    this._len_5 = len;
  }
  $readCOROUTINE$100.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            if (this._len_5 === 0)
              return 0;
            this._state_1 = 1;
            suspendResult = _readRangeBase(this.__this__47._this$0_29, this.__this__47._$fullUrl, until_0(this._position_2, this._position_2.plus_64(toLong(this._len_5))), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._res0 = suspendResult;
            this._s1 = this._res0._content;
            this._coffset2 = this._offset_8;
            this._pending3 = this._len_5;
            this._totalRead4 = 0;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!(this._pending3 > 0)) {
              this._state_1 = 5;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = this._s1.read_30(this._buffer_11, this._coffset2, this._pending3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var read_1 = suspendResult;
            if (read_1 < 0 ? this._totalRead4 === 0 : false)
              return read_1;
            if (read_1 <= 0) {
              this._state_1 = 5;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            this._pending3 = this._pending3 - read_1 | 0;
            this._totalRead4 = this._totalRead4 + read_1 | 0;
            this._coffset2 = this._coffset2 + read_1 | 0;
            this._state_1 = 2;
            continue $sm;
          case 5:
            return this._totalRead4;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$100.$metadata$ = {
    simpleName: '$readCOROUTINE$100',
    kind: 'class',
    interfaces: []
  };
  function _readRangeBase($this, fullUrl, range, $cont) {
    var tmp = new $_readRangeBaseCOROUTINE$96($this, fullUrl, range, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function _no_name_provided__112(this$0, $fullUrl, $stat) {
    this._this$0_29 = this$0;
    this._$fullUrl = $fullUrl;
    this._$stat = $stat;
    AsyncStreamBase.call(this);
  }
  _no_name_provided__112.prototype.read_37 = function (position_1, buffer, offset, len, $cont) {
    var tmp = new $readCOROUTINE$100(this, position_1, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__112.prototype.getLength_14 = function ($cont) {
    return this._$stat._size_5;
  };
  _no_name_provided__112.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $openCOROUTINE$94(_this_, path_0, mode, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__48 = _this_;
    this._path_12 = path_0;
    this._mode_2 = mode;
  }
  $openCOROUTINE$94.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._exceptionState = 4;
            this._fullUrl0 = this.__this__48.getFullUrl(this._path_12);
            if (startsWith$default_1(this._fullUrl0, 'file:', false, 2, null)) {
              this._state_1 = 3;
              suspendResult = this.__this__48._client.readBytes$default(this._fullUrl0, null, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 1;
                continue $sm;
              }
            }

            break;
          case 1:
            this._state_1 = 2;
            suspendResult = this.__this__48.stat_9(this._path_12, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var stat = suspendResult;
            var tmp_0 = stat._extraInfo;
            var response = tmp_0 instanceof Response_0 ? tmp_0 : null;
            if (!stat._exists) {
              throw new FileNotFoundException('' + 'Unexistant ' + this._fullUrl0 + ' : ' + response);
            }
            var tmp_1 = new _no_name_provided__112(this.__this__48, this._fullUrl0, stat);
            var tmp_2 = toAsyncStream$default(tmp_1, new Long(0, 0), 1, null);
            return buffered$default(tmp_2, 0, 0, 3, null);
          case 3:
            var ARGUMENT = suspendResult;
            return openAsync$default(ARGUMENT, null, 1, null);
          case 4:
            this._exceptionState = 5;
            var tmp_3 = this._exception_0;
            if (tmp_3 instanceof RuntimeException) {
              var e = this._exception_0;
              var tmp0_elvis_lhs = e.message;
              throw new FileNotFoundException(tmp0_elvis_lhs == null ? 'error' : tmp0_elvis_lhs);
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 5:
            throw this._exception_0;
          case 6:
            this._exceptionState = 5;
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openCOROUTINE$94.$metadata$ = {
    simpleName: '$openCOROUTINE$94',
    kind: 'class',
    interfaces: []
  };
  function $_readRangeBaseCOROUTINE$96(_this_, fullUrl, range, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__49 = _this_;
    this._fullUrl = fullUrl;
    this._range_2 = range;
  }
  $_readRangeBaseCOROUTINE$96.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            var tmp_0 = Companion_getInstance_51()._GET;
            var tmp_1 = Headers_init_$Create$_0(this._range_2.equals(LONG_ZERO_TO_MAX_RANGE) ? LinkedHashMap_init_$Create$() : linkedHashMapOf([to('range', '' + 'bytes=' + this._range_2._get_start__0() + '-' + this._range_2._get_endInclusive__0())]));
            suspendResult = this.__this__49._client.request$default(tmp_0, this._fullUrl, tmp_1, null, null, 24, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_also_00_1 = suspendResult;
            if (this.__this__49._failFromStatus) {
              if (this._tmp0_also_00_1._status === 404)
                throw new FileNotFoundException('' + this._fullUrl + ' not found');
              this._state_1 = 2;
              suspendResult = this._tmp0_also_00_1.checkErrors(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 3;
            continue $sm;
          case 3:
            return this._tmp0_also_00_1;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $_readRangeBaseCOROUTINE$96.$metadata$ = {
    simpleName: '$_readRangeBaseCOROUTINE$96',
    kind: 'class',
    interfaces: []
  };
  function $readRangeCOROUTINE$97(_this_, path_0, range, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__50 = _this_;
    this._path_13 = path_0;
    this._range_3 = range;
  }
  $readRangeCOROUTINE$97.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = _readRangeBase(this.__this__50, this.__this__50.getFullUrl(this._path_13), this._range_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_10 = suspendResult;
            this._ARGUMENT1_6 = this._ARGUMENT0_10._content;
            this._state_1 = 2;
            suspendResult = readAll(this._ARGUMENT1_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readRangeCOROUTINE$97.$metadata$ = {
    simpleName: '$readRangeCOROUTINE$97',
    kind: 'class',
    interfaces: []
  };
  function $statCOROUTINE$99(_this_, path_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__51 = _this_;
    this._path_14 = path_0;
  }
  $statCOROUTINE$99.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._fullUrl0_0 = this.__this__51.getFullUrl(this._path_14);
            if (startsWith$default_1(this._fullUrl0_0, 'file:', false, 2, null)) {
              this._exceptionState = 3;
              this._state_1 = 2;
              suspendResult = this.__this__51._client.readBytes$default(this._fullUrl0_0, null, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 1;
                var tmp_0 = Companion_getInstance_51()._HEAD;
                suspendResult = this.__this__51._client.request$default(tmp_0, this._fullUrl0_0, null, null, null, 28, null, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            }

            break;
          case 1:
            var result = suspendResult;
            var tmp_1 = this;
            var tmp_2;
            if (result._success) {
              var tmp0_safe_receiver = result._headers_0.get_115(Companion_getInstance_53()._ContentLength);
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toLongOrNull(tmp0_safe_receiver);
              var tmp_3 = tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs;
              var tmp_4 = new Long(0, 0);
              var tmp_5 = new Long(0, 0);
              tmp_2 = this.__this__51.createExistsStat$default_0(this._path_14, false, tmp_3, tmp_4, tmp_5, 0, null, null, null, null, null, result, null, 6136, null);
            } else {
              tmp_2 = this.__this__51.createNonExistsStat_8(this._path_14, result);
            }

            tmp_1._WHEN_RESULT1_0 = tmp_2;
            this._state_1 = 5;
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT.length;
            var size_1 = toLong(ARGUMENT_0);
            var tmp_6 = this;
            var tmp_7 = new Long(0, 0);
            var tmp_8 = new Long(0, 0);
            tmp_6._TRY_RESULT2 = this.__this__51.createExistsStat$default_0(this._path_14, false, size_1, tmp_7, tmp_8, 0, null, null, null, null, null, null, null, 6136, null);
            this._exceptionState = 6;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._exceptionState = 6;
            var tmp_9 = this._exception_0;
            if (tmp_9 instanceof Error) {
              var e = this._exception_0;
              var tmp_10 = this;
              printStackTrace(e);
              tmp_10._TRY_RESULT2 = this.__this__51.createNonExistsStat$default_8(this._path_14, null, 2, null);
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 6;
            this._WHEN_RESULT1_0 = this._TRY_RESULT2;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._WHEN_RESULT1_0;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $statCOROUTINE$99.$metadata$ = {
    simpleName: '$statCOROUTINE$99',
    kind: 'class',
    interfaces: []
  };
  function UrlVfs_0(url, dummy, client, failFromStatus) {
    Vfs.call(this);
    this._url = url;
    this._dummy_1 = dummy;
    this._client = client;
    this._failFromStatus = failFromStatus;
    this._absolutePath = this._url;
  }
  UrlVfs_0.prototype._get_absolutePath__9 = function () {
    return this._absolutePath;
  };
  UrlVfs_0.prototype.getFullUrl = function (path_0) {
    var result = trim(this._url, charArrayOf([new Char(47)])) + new Char(47) + trim(path_0, charArrayOf([new Char(47)]));
    return result;
  };
  UrlVfs_0.prototype.open_10 = function (path_0, mode, $cont) {
    var tmp = new $openCOROUTINE$94(this, path_0, mode, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  UrlVfs_0.prototype.readRange_8 = function (path_0, range, $cont) {
    var tmp = new $readRangeCOROUTINE$97(this, path_0, range, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  UrlVfs_0.prototype.stat_9 = function (path_0, $cont) {
    var tmp = new $statCOROUTINE$99(this, path_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  UrlVfs_0.prototype.toString = function () {
    return 'UrlVfs';
  };
  UrlVfs_0.$metadata$ = {
    simpleName: 'UrlVfs',
    kind: 'class',
    interfaces: []
  };
  function UrlVfs_1(url, client, failFromStatus) {
    return UrlVfs(Companion_getInstance_50().invoke_203(url), client, failFromStatus);
  }
  function UrlVfs$default_0(url, client, failFromStatus, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      client = createHttpClient();
    if (!(($mask0 & 4) === 0))
      failFromStatus = true;
    return UrlVfs_1(url, client, failFromStatus);
  }
  function openAsZip(_this_, caseSensitive, callback, $cont) {
    var tmp = new $openAsZipCOROUTINE$101(_this_, caseSensitive, callback, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function openAsZip$default(_this_, caseSensitive, callback, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      caseSensitive = true;
    return openAsZip(_this_, caseSensitive, callback, $cont);
  }
  function openAsZip_0(_this_, caseSensitive, $cont) {
    var tmp = new $openAsZipCOROUTINE$102(_this_, caseSensitive, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function ZipVfs(s, zipFile, caseSensitive, closeStream, $cont) {
    var tmp = new $ZipVfsCOROUTINE$103(s, zipFile, caseSensitive, closeStream, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function toStat(_this_, file) {
    var vfs = file._vfs;
    var tmp;
    if (!(_this_ == null)) {
      var tmp_0 = new Long(0, 0);
      tmp = vfs.createExistsStat$default_0(file._path_7, _this_._isDirectory, _this_._uncompressedSize, tmp_0, _this_._inode, 0, null, null, _this_._time_1._utc, null, null, null, null, 7912, null);
    } else {
      tmp = vfs.createNonExistsStat$default_8(file._path_7, null, 2, null);
    }
    return tmp;
  }
  function _no_name_provided__113($zipFile, $path, this$0, resultContinuation) {
    this._$zipFile = $zipFile;
    this._$path_2 = $path;
    this._this$0_30 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__113.prototype.invoke_191 = function ($this$flow, $cont) {
    var tmp = this.create_10($this$flow, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__113.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_191((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__113.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            var tmp_1 = this;
            var tmp0_elvis_lhs = this._$zipFile._filesPerFolder.get_116(this._$zipFile.normalizeName_1(this._$path_2));
            tmp_1._tmp0_iterator_00 = tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$() : tmp0_elvis_lhs;
            tmp_0._tmp1_iterator1 = this._tmp0_iterator_00._get_entries__10().iterator_67();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp1_iterator1.hasNext_33()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._tmp2_loop_parameter2 = this._tmp1_iterator1.next_37();
            var tmp_2 = this;
            tmp_2._entry3 = this._tmp2_loop_parameter2._get_value__10();
            this._state_1 = 2;
            suspendResult = this._$this$flow_3.emit_8(this._this$0_30._vfs_0.get_115(this._entry3._path), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__113.prototype.create_10 = function ($this$flow, completion) {
    var i = new _no_name_provided__113(this._$zipFile, this._$path_2, this._this$0_30, completion);
    i._$this$flow_3 = $this$flow;
    return i;
  };
  _no_name_provided__113.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $closeCOROUTINE$104(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__52 = _this_;
  }
  $closeCOROUTINE$104.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (this.__this__52._$closeStream) {
              this._state_1 = 1;
              suspendResult = this.__this__52._$s_0.close_77(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $closeCOROUTINE$104.$metadata$ = {
    simpleName: '$closeCOROUTINE$104',
    kind: 'class',
    interfaces: []
  };
  function $openCOROUTINE$105(_this_, path_0, mode, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__53 = _this_;
    this._path_15 = path_0;
    this._mode_3 = mode;
  }
  $openCOROUTINE$105.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 21;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.__this__53._$zipFile_0._files.get_116(this.__this__53._$zipFile_0.normalizeName_1(this._path_15));
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              throw new FileNotFoundException('' + "Path: '" + this._path_15 + "'");
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0._entry0 = tmp_1;
            if (this._entry0._isDirectory)
              throw new IOException('' + "Can't open a zip directory for " + this._mode_3);
            this._state_1 = 1;
            var tmp_2 = new Long(0, 0);
            suspendResult = sliceStart$default(this._entry0._headerEntry, tmp_2, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._base1 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._base1.getAvailable(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT2_0 = suspendResult;
            if (this._ARGUMENT2_0.compareTo_137(new Long(16, 0)) < 0) {
              throw IllegalStateException_init_$Create$_0('Chunk to small to be a ZIP chunk');
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            this._state_1 = 4;
            suspendResult = readS32BE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._ARGUMENT3_0 = suspendResult;
            this._ARGUMENT4 = this._ARGUMENT3_0 === 1347093252;
            if (!this._ARGUMENT4) {
              throw IllegalStateException_init_$Create$_0('Not a zip file (readS32BE() != 0x504B_0304)');
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._state_1 = 6;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._version_25 = suspendResult;
            this._state_1 = 7;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._flags_36 = suspendResult;
            this._state_1 = 8;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._compressionType_47 = suspendResult;
            this._state_1 = 9;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._fileTime_58 = suspendResult;
            this._state_1 = 10;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            this._fileDate_69 = suspendResult;
            this._state_1 = 11;
            suspendResult = readS32LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._crc_710 = suspendResult;
            this._state_1 = 12;
            suspendResult = readS32LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 12:
            this._compressedSize_811 = suspendResult;
            this._state_1 = 13;
            suspendResult = readS32LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 13:
            this._uncompressedSize_912 = suspendResult;
            this._state_1 = 14;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 14:
            this._fileNameLength_1013 = suspendResult;
            this._state_1 = 15;
            suspendResult = readU16LE_0(this._base1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 15:
            this._extraLength_1114 = suspendResult;
            this._state_1 = 16;
            suspendResult = readString$default(this._base1, this._fileNameLength_1013, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 16:
            this._name_1215 = suspendResult;
            this._state_1 = 17;
            suspendResult = readBytesExact(this._base1, this._extraLength_1114, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 17:
            this._extra_1316 = suspendResult;
            this._state_1 = 18;
            suspendResult = readSlice(this._base1, this._entry0._compressedSize, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 18:
            this._compressedData_1417 = suspendResult;
            this._tmp0_subject_1518 = this._entry0._compressionMethod;
            if (this._tmp0_subject_1518 === 0) {
              this._WHEN_RESULT19 = this._compressedData_1417;
              this._state_1 = 20;
              continue $sm;
            } else {
              var tmp_3 = this;
              var tmp1_subject_17 = this._entry0._compressionMethod;
              var tmp_4;
              if (tmp1_subject_17 === 8) {
                tmp_4 = _get_Deflate_();
              } else {
                var tmp0_TODO_0_18 = '' + 'Not implemented zip method ' + this._entry0._compressionMethod;
                throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0_18);
              }
              tmp_3._method_1620 = tmp_4;
              this._state_1 = 19;
              suspendResult = readAll(this._compressedData_1417, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 19:
            var ARGUMENT = suspendResult;
            var compressed_19 = uncompress$default(ARGUMENT, this._method_1620, 0, 2, null);
            if (!(this._crc_710 === 0)) {
              var tmp_5 = CRC32_getInstance();
              var computedCrc_20 = compute$default(tmp_5, compressed_19, 0, 0, 6, null);
              if (!(computedCrc_20 === this._crc_710)) {
                var tmp1_error_0_21 = '' + "Uncompressed file crc doesn't match: expected=" + _get_hex__0(this._crc_710) + ', actual=' + _get_hex__0(computedCrc_20);
                throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0_21));
              }}
            var tmp_6 = this;
            tmp_6._WHEN_RESULT19 = openAsync$default(compressed_19, null, 1, null);
            this._state_1 = 20;
            continue $sm;
          case 20:
            return this._WHEN_RESULT19;
          case 21:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 21) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openCOROUTINE$105.$metadata$ = {
    simpleName: '$openCOROUTINE$105',
    kind: 'class',
    interfaces: []
  };
  function Impl($closeStream, $s, $zipFile) {
    this._$closeStream = $closeStream;
    this._$s_0 = $s;
    this._$zipFile_0 = $zipFile;
    VfsV2.call(this);
    this._vfs_0 = this;
  }
  Impl.prototype.close_77 = function ($cont) {
    var tmp = new $closeCOROUTINE$104(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Impl.prototype.open_10 = function (path_0, mode, $cont) {
    var tmp = new $openCOROUTINE$105(this, path_0, mode, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Impl.prototype.stat_9 = function (path_0, $cont) {
    return toStat(this._$zipFile_0._files.get_116(this._$zipFile_0.normalizeName_1(path_0)), this.get_115(path_0));
  };
  Impl.prototype.listFlow_8 = function (path_0, $cont) {
    return flow(_no_name_provided_$factory_86(this._$zipFile_0, path_0, this, null));
  };
  Impl.prototype.toString = function () {
    return '' + 'ZipVfs(' + this._$zipFile_0 + ')';
  };
  Impl.$metadata$ = {
    simpleName: 'Impl',
    kind: 'class',
    interfaces: []
  };
  function $openAsZipCOROUTINE$101(_this_, caseSensitive, callback, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__54 = _this_;
    this._caseSensitive_2 = caseSensitive;
    this._callback_0 = callback;
  }
  $openAsZipCOROUTINE$101.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 11;
            this._state_1 = 1;
            suspendResult = openAsZip_0(this.__this__54, this._caseSensitive_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._file0 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 9;
            this._state_1 = 4;
            suspendResult = this._callback_0(this._file0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$02_0 = suspendResult;
            this._exceptionState = 11;
            this._state_1 = 5;
            var tmp_0 = this;
            continue $sm;
          case 5:
            this._tmp3 = this._tmp$ret$02_0;
            this._state_1 = 6;
            suspendResult = this._file0._vfs.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            suspendResult;
            return this._tmp3;
          case 7:
            this._state_1 = 8;
            suspendResult = this._file0._vfs.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            suspendResult;
            return Unit_getInstance();
          case 9:
            this._exceptionState = 11;
            this._t4 = this._exception_0;
            this._state_1 = 10;
            suspendResult = this._file0._vfs.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 10:
            suspendResult;
            throw this._t4;
          case 11:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 11) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openAsZipCOROUTINE$101.$metadata$ = {
    simpleName: '$openAsZipCOROUTINE$101',
    kind: 'class',
    interfaces: []
  };
  function $openAsZipCOROUTINE$102(_this_, caseSensitive, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__55 = _this_;
    this._caseSensitive_3 = caseSensitive;
  }
  $openAsZipCOROUTINE$102.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__55.open_3(VfsOpenMode_READ_getInstance(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_11 = suspendResult;
            this._state_1 = 2;
            suspendResult = ZipVfs(this._ARGUMENT0_11, this.__this__55, this._caseSensitive_3, true, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $openAsZipCOROUTINE$102.$metadata$ = {
    simpleName: '$openAsZipCOROUTINE$102',
    kind: 'class',
    interfaces: []
  };
  function $ZipVfsCOROUTINE$103(s, zipFile, caseSensitive, closeStream, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._s_2 = s;
    this._zipFile = zipFile;
    this._caseSensitive_4 = caseSensitive;
    this._closeStream = closeStream;
  }
  $ZipVfsCOROUTINE$103.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = Companion_getInstance_44().invoke_145(this._s_2, this._caseSensitive_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var zipFile = suspendResult;
            return (new Impl(this._closeStream, this._s_2, zipFile))._get_root__33();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $ZipVfsCOROUTINE$103.$metadata$ = {
    simpleName: '$ZipVfsCOROUTINE$103',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_86($zipFile, $path, this$0, resultContinuation) {
    var i = new _no_name_provided__113($zipFile, $path, this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_191(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function indexOf_8(_this_, other) {
    var full = _this_;
    var inductionVariable = 0;
    var last_1 = full.length - other.length | 0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0;
        l$ret$1: do {
          var tmp0_all_0 = _get_indices_(other);
          var tmp;
          if (isInterface(tmp0_all_0, Collection)) {
            tmp = tmp0_all_0.isEmpty_53();
          } else {
            {
              tmp = false;
            }
          }
          if (tmp) {
            tmp$ret$0 = true;
            break l$ret$1;
          } else {
          }
          var inductionVariable_0 = tmp0_all_0._get_first__6();
          var last_2 = tmp0_all_0._get_last__6();
          if (inductionVariable_0 <= last_2)
            do {
              var element_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (!(full[n + element_2 | 0] === other[element_2])) {
                tmp$ret$0 = false;
                break l$ret$1;
              } else {
              }
            }
             while (!(element_2 === last_2));
          tmp$ret$0 = true;
        }
         while (false);
        if (tmp$ret$0)
          return n;
        else {
        }
      }
       while (inductionVariable < last_1);
    return -1;
  }
  var bytesTempPool$delegate;
  function _get_smallBytesPool_() {
    var tmp0_getValue_0 = smallBytesPool$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = smallBytesPool$factory();
    return tmp0_getValue_0._local.get_85();
  }
  var smallBytesPool$delegate;
  function _no_name_provided__114() {
  }
  _no_name_provided__114.prototype.invoke_874 = function (it) {
    return new Int8Array(65536);
  };
  _no_name_provided__114.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__114.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__115() {
  }
  _no_name_provided__115.prototype.invoke_1005 = function () {
    return Pool_init_$Create$_0(1, _no_name_provided_$factory_89());
  };
  _no_name_provided__115.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__116() {
  }
  _no_name_provided__116.prototype.invoke_874 = function (it) {
    return new Int8Array(16);
  };
  _no_name_provided__116.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__116.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__117() {
  }
  _no_name_provided__117.prototype.invoke_1005 = function () {
    return Pool_init_$Create$_0(16, _no_name_provided_$factory_90());
  };
  _no_name_provided__117.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function smallBytesPool$factory() {
    return getPropertyCallableRef('smallBytesPool', 0, KProperty0, function () {
      return _get_smallBytesPool_();
    }, null);
  }
  function _no_name_provided_$factory_87() {
    var i = new _no_name_provided__115();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_88() {
    var i = new _no_name_provided__117();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_89() {
    var i = new _no_name_provided__114();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function _no_name_provided_$factory_90() {
    var i = new _no_name_provided__116();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function min2_0(a, b) {
    return a < b ? a : b;
  }
  function max2_1(a, b) {
    return a > b ? a : b;
  }
  function min2_1(a, b) {
    return a.compareTo_137(b) < 0 ? a : b;
  }
  function max2_2(a, b) {
    return a.compareTo_137(b) > 0 ? a : b;
  }
  var LATIN1;
  var UTF16_LE;
  var UTF16_BE;
  function ISO_8859_1() {
    ISO_8859_1_instance = this;
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0_1.append_2(numberToChar(n_4));
        Unit_getInstance();
      }
       while (inductionVariable < 256);
    SingleByteCharset.call(this, 'ISO-8859-1', tmp0_apply_0_1.toString());
  }
  ISO_8859_1.$metadata$ = {
    simpleName: 'ISO_8859_1',
    kind: 'object',
    interfaces: []
  };
  var ISO_8859_1_instance;
  function ISO_8859_1_getInstance() {
    if (ISO_8859_1_instance == null)
      new ISO_8859_1();
    return ISO_8859_1_instance;
  }
  function UTF16Charset(le) {
    Charset.call(this, 'UTF-16-' + (le ? 'LE' : 'BE'));
    this._le = le;
  }
  UTF16Charset.prototype.estimateNumberOfCharactersForBytes_6 = function (nbytes) {
    return imul(nbytes, 2);
  };
  UTF16Charset.prototype.estimateNumberOfBytesForCharacters_6 = function (nchars) {
    return imul(nchars, 2);
  };
  UTF16Charset.prototype.decode_13 = function (out, src, start, end) {
    var progression = step(until(start, end), 2);
    var inductionVariable = progression._first_0;
    var last_1 = progression._last;
    var step_0 = progression._step_2;
    if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        out.append_2(numberToChar(readS16(src, n, this._le)));
        Unit_getInstance();
      }
       while (!(n === last_1));
  };
  UTF16Charset.prototype.encode_9 = function (out, src, start, end) {
    var temp_0 = new Int8Array(2);
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        write16(temp_0, 0, charSequenceGet(src, n).toInt_8(), this._le);
        out.append$default(temp_0, 0, 0, 6, null);
      }
       while (inductionVariable < end);
  };
  UTF16Charset.$metadata$ = {
    simpleName: 'UTF16Charset',
    kind: 'class',
    interfaces: []
  };
  function SingleByteCharset(name, conv) {
    BaseSingleByteCharset.call(this, name);
    this._conv = conv;
    var tmp = this;
    var tmp0_apply_0 = IntIntMap_init_$Create$(0, 0.0, 3, null);
    var inductionVariable = 0;
    var last_1 = this._conv.length;
    if (inductionVariable < last_1)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0.set_6(charSequenceGet(this._conv, n_3).toInt_8(), n_3);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp._v_0 = tmp0_apply_0;
  }
  SingleByteCharset.prototype.encode_9 = function (out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(src, n).toInt_8();
        out.append_7(this._v_0.contains_56(c) ? toByte(this._v_0.get_137(c)) : 63);
        Unit_getInstance();
      }
       while (inductionVariable < end);
  };
  SingleByteCharset.prototype.decode_13 = function (out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out.append_2(charSequenceGet(this._conv, src[n] & 255));
        Unit_getInstance();
      }
       while (inductionVariable < end);
  };
  SingleByteCharset.$metadata$ = {
    simpleName: 'SingleByteCharset',
    kind: 'class',
    interfaces: []
  };
  function Companion_49() {
    Companion_instance_48 = this;
  }
  Companion_49.prototype.appendCodePointV = function (_this__0, codePoint) {
    if ((55296 <= codePoint ? codePoint <= 57343 : false) ? true : codePoint > 65535) {
      var U0 = codePoint - 65536 | 0;
      var hs = extract(U0, 10, 10);
      var ls = extract(U0, 0, 10);
      _this__0.append_2(numberToChar(55296 | hs));
      Unit_getInstance();
      _this__0.append_2(numberToChar(56320 | ls));
      Unit_getInstance();
    } else {
      _this__0.append_2(numberToChar(codePoint));
      Unit_getInstance();
    }
  };
  Companion_49.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_48;
  function Companion_getInstance_48() {
    if (Companion_instance_48 == null)
      new Companion_49();
    return Companion_instance_48;
  }
  function Charset(name) {
    Companion_getInstance_48();
    this._name_6 = name;
  }
  Charset.prototype.estimateNumberOfCharactersForBytes_6 = function (nbytes) {
    return imul(nbytes, 2);
  };
  Charset.prototype.estimateNumberOfBytesForCharacters_6 = function (nchars) {
    return imul(nchars, 2);
  };
  Charset.prototype.encode$default_6 = function (out, src, start, end, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      start = 0;
    if (!(($mask0 & 8) === 0))
      end = charSequenceLength(src);
    return $handler == null ? this.encode_9(out, src, start, end) : $handler(out, src, start, end);
  };
  Charset.prototype.decode$default_7 = function (out, src, start, end, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      start = 0;
    if (!(($mask0 & 8) === 0))
      end = src.length;
    return $handler == null ? this.decode_13(out, src, start, end) : $handler(out, src, start, end);
  };
  Charset.$metadata$ = {
    simpleName: 'Charset',
    kind: 'class',
    interfaces: []
  };
  function BaseSingleByteCharset(name) {
    Charset.call(this, name);
  }
  BaseSingleByteCharset.prototype.estimateNumberOfCharactersForBytes_6 = function (nbytes) {
    return nbytes;
  };
  BaseSingleByteCharset.prototype.estimateNumberOfBytesForCharacters_6 = function (nchars) {
    return nchars;
  };
  BaseSingleByteCharset.$metadata$ = {
    simpleName: 'BaseSingleByteCharset',
    kind: 'class',
    interfaces: []
  };
  function toString_3(_this_, charset) {
    var out = StringBuilder_init_$Create$(charset.estimateNumberOfCharactersForBytes_6(_this_.length));
    charset.decode$default_7(out, _this_, 0, 0, 12, null);
    return out.toString();
  }
  function toByteArray(_this_, charset) {
    var out = ByteArrayBuilder_init_$Create$_0(charset.estimateNumberOfBytesForCharacters_6(_this_.length));
    charset.encode$default_6(out, _this_, 0, 0, 12, null);
    return out.toByteArray();
  }
  function toByteArray$default(_this_, charset, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      charset = UTF8;
    return toByteArray(_this_, charset);
  }
  function createByte($this, codePoint, shift) {
    return codePoint >> shift & 63 | 128;
  }
  function UTC8CharsetBase(name) {
    Charset.call(this, name);
  }
  UTC8CharsetBase.prototype.estimateNumberOfCharactersForBytes_6 = function (nbytes) {
    return imul(nbytes, 2);
  };
  UTC8CharsetBase.prototype.estimateNumberOfBytesForCharacters_6 = function (nchars) {
    return imul(nchars, 2);
  };
  UTC8CharsetBase.prototype.encode_9 = function (out, src, start, end) {
    var tmp0_decodeCodePoints_0 = Companion_getInstance_48();
    var highSurrogate_1 = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      loop: do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var char_4 = charSequenceGet(src, n_3).toInt_8();
        var tmp;
        if (55296 <= char_4 ? char_4 <= 57343 : false) {
          var tmp1_subject_6 = extract(char_4, 10, 6);
          var tmp_0;
          switch (tmp1_subject_6) {
            case 54:
              highSurrogate_1 = char_4 & 1023;
              continue loop;
            case 55:
              tmp_0 = 65536 + (highSurrogate_1 << 10 | char_4 & 1023) | 0;
              break;
            default:var tmp0_error_0_7 = '' + 'Unknown ' + char_4;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_7));
          }
          tmp = tmp_0;
        } else {
          tmp = char_4;
        }
        var codePoint_5 = tmp;
        if ((codePoint_5 & -128) === 0) {
          out.append_7(toByte(codePoint_5));
          Unit_getInstance();
        } else {
          if ((codePoint_5 & -2048) === 0) {
            out.append_7(toByte(codePoint_5 >> 6 & 31 | 192));
            Unit_getInstance();
          } else if ((codePoint_5 & -65536) === 0) {
            out.append_7(toByte(codePoint_5 >> 12 & 15 | 224));
            Unit_getInstance();
            out.append_7(toByte(createByte(this, codePoint_5, 6)));
            Unit_getInstance();
          } else if ((codePoint_5 & -2097152) === 0) {
            out.append_7(toByte(codePoint_5 >> 18 & 7 | 240));
            Unit_getInstance();
            out.append_7(toByte(createByte(this, codePoint_5, 12)));
            Unit_getInstance();
            out.append_7(toByte(createByte(this, codePoint_5, 6)));
            Unit_getInstance();
          }out.append_7(toByte(codePoint_5 & 63 | 128));
          Unit_getInstance();
        }
      }
       while (inductionVariable < end);
  };
  UTC8CharsetBase.prototype.decode_13 = function (out, src, start, end) {
    if ((start < 0 ? true : start > src.length) ? true : end < 0 ? true : end > src.length) {
      var tmp0_error_0 = 'Out of bounds';
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }var i = start;
    while (i < end) {
      var c = src[i] & 255;
      var tmp0_subject = c >> 4;
      if (0 <= tmp0_subject ? tmp0_subject <= 7 : false) {
        Companion_getInstance_48().appendCodePointV(out, c);
        i = i + 1 | 0;
      } else if (12 <= tmp0_subject ? tmp0_subject <= 13 : false) {
        Companion_getInstance_48().appendCodePointV(out, (c & 31) << 6 | src[i + 1 | 0] & 63);
        i = i + 2 | 0;
      } else if (tmp0_subject === 14) {
        Companion_getInstance_48().appendCodePointV(out, (c & 15) << 12 | (src[i + 1 | 0] & 63) << 6 | src[i + 2 | 0] & 63);
        i = i + 3 | 0;
      } else if (tmp0_subject === 15) {
        Companion_getInstance_48().appendCodePointV(out, insert(insert(insert(insert(0, extract(src[i + 0 | 0], 0, 3), 18, 3), extract(src[i + 1 | 0], 0, 6), 12, 6), extract(src[i + 2 | 0], 0, 6), 6, 6), extract(src[i + 3 | 0], 0, 6), 0, 6));
        i = i + 4 | 0;
      } else {
        out.append_2(new Char(65533));
        Unit_getInstance();
        i = i + 1 | 0;
      }
    }
  };
  UTC8CharsetBase.$metadata$ = {
    simpleName: 'UTC8CharsetBase',
    kind: 'class',
    interfaces: []
  };
  function ASCII() {
    ASCII_instance = this;
    BaseSingleByteCharset.call(this, 'ASCII');
  }
  ASCII.prototype.encode_9 = function (out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out.append_7(charSequenceGet(src, n).toByte_6());
        Unit_getInstance();
      }
       while (inductionVariable < end);
  };
  ASCII.prototype.decode_13 = function (out, src, start, end) {
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out.append_2(numberToChar(src[n]));
        Unit_getInstance();
      }
       while (inductionVariable < end);
  };
  ASCII.$metadata$ = {
    simpleName: 'ASCII',
    kind: 'object',
    interfaces: []
  };
  var ASCII_instance;
  function ASCII_getInstance() {
    if (ASCII_instance == null)
      new ASCII();
    return ASCII_instance;
  }
  function Charsets() {
    Charsets_instance = this;
  }
  Charsets.prototype._get_LATIN1_ = function () {
    return LATIN1;
  };
  Charsets.$metadata$ = {
    simpleName: 'Charsets',
    kind: 'object',
    interfaces: []
  };
  var Charsets_instance;
  function Charsets_getInstance() {
    if (Charsets_instance == null)
      new Charsets();
    return Charsets_instance;
  }
  function _no_name_provided__118($callback) {
    this._$callback_1 = $callback;
  }
  _no_name_provided__118.prototype.close_77 = function () {
    return this._$callback_1();
  };
  _no_name_provided__118.$metadata$ = {
    kind: 'class',
    interfaces: [Closeable]
  };
  function Companion_50() {
    Companion_instance_49 = this;
  }
  Companion_50.prototype.invoke_199 = function (callback) {
    return new _no_name_provided__118(callback);
  };
  Companion_50.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_49;
  function Companion_getInstance_49() {
    if (Companion_instance_49 == null)
      new Companion_50();
    return Companion_instance_49;
  }
  function Closeable() {
  }
  Closeable.$metadata$ = {
    simpleName: 'Closeable',
    kind: 'interface',
    interfaces: []
  };
  function OptionalCloseable() {
  }
  OptionalCloseable.$metadata$ = {
    simpleName: 'OptionalCloseable',
    kind: 'interface',
    interfaces: [Closeable]
  };
  function Disposable() {
  }
  Disposable.$metadata$ = {
    simpleName: 'Disposable',
    kind: 'interface',
    interfaces: []
  };
  function Cancellable() {
  }
  Cancellable.$metadata$ = {
    simpleName: 'Cancellable',
    kind: 'interface',
    interfaces: []
  };
  function cancel_0(_this_) {
    return _this_.cancel_27(CancellationException_init_$Create$(''));
  }
  function cancel_1(_this_, e) {
    var tmp0_iterator_2 = _this_.iterator_67();
    while (tmp0_iterator_2.hasNext_33()) {
      var c_3 = tmp0_iterator_2.next_37();
      c_3.cancel_27(e);
    }
    return Unit_getInstance();
  }
  var customEnvironments;
  function Environment() {
    Environment_instance = this;
  }
  Environment.prototype.get_115 = function (key) {
    var tmp0_safe_receiver = customEnvironments;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_116(key);
    return tmp1_elvis_lhs == null ? EnvironmentInternal_getInstance().get_115(key) : tmp1_elvis_lhs;
  };
  Environment.$metadata$ = {
    simpleName: 'Environment',
    kind: 'object',
    interfaces: []
  };
  var Environment_instance;
  function Environment_getInstance() {
    if (Environment_instance == null)
      new Environment();
    return Environment_instance;
  }
  function invalidOp(msg) {
    throw new InvalidOperationException(msg);
  }
  function InvalidOperationException_init_$Init$(str, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      str = 'Invalid Operation';
    InvalidOperationException.call($this, str);
    return $this;
  }
  function InvalidOperationException_init_$Create$(str, $mask0, $marker) {
    var tmp = InvalidOperationException_init_$Init$(str, $mask0, $marker, Object.create(InvalidOperationException.prototype));
    captureStack(tmp, InvalidOperationException_init_$Create$);
    return tmp;
  }
  function InvalidOperationException(str) {
    Exception_init_$Init$_0(str, this);
    captureStack(this, InvalidOperationException);
  }
  InvalidOperationException.$metadata$ = {
    simpleName: 'InvalidOperationException',
    kind: 'class',
    interfaces: []
  };
  function unsupported_0() {
    throw UnsupportedOperationException_init_$Create$_0('unsupported');
  }
  function _get_invalidOp_() {
    throw InvalidOperationException_init_$Create$(null, 1, null);
  }
  function unsupported_1(msg) {
    throw UnsupportedOperationException_init_$Create$_0(msg);
  }
  var formatRegex;
  var replaceNonPrintableCharactersRegex$delegate;
  function substr_0(_this_, start, length) {
    var low = clamp_1(start >= 0 ? start : _this_.length + start | 0, 0, _this_.length);
    var high = clamp_1(length >= 0 ? low + length | 0 : _this_.length + length | 0, 0, _this_.length);
    var tmp;
    if (high >= low) {
      tmp = _this_.substring(low, high);
    } else {
      tmp = '';
    }
    return tmp;
  }
  function String_fromCharArray(arrays, offset, size_1) {
    return concatToString(arrays, offset, offset + size_1 | 0);
  }
  function lastIndexOfOrNull(_this_, char, startIndex) {
    var tmp0_takeIf_0 = lastIndexOf$default(_this_, char, startIndex, false, 4, null);
    var tmp;
    if (tmp0_takeIf_0 >= 0) {
      tmp = tmp0_takeIf_0;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function lastIndexOfOrNull$default(_this_, char, startIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__4(_this_);
    return lastIndexOfOrNull(_this_, char, startIndex);
  }
  function substr_1(_this_, start) {
    return substr_0(_this_, start, _this_.length);
  }
  function _no_name_provided__119() {
  }
  _no_name_provided__119.prototype.invoke_1005 = function () {
    return Regex_init_$Create$('[^ -~]');
  };
  _no_name_provided__119.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_91() {
    var i = new _no_name_provided__119();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided__120(this$0) {
    this._this$0_31 = this$0;
    NativeThreadLocal.call(this);
  }
  _no_name_provided__120.prototype.initialValue_1 = function () {
    return this._this$0_31._gen_0();
  };
  _no_name_provided__120.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function threadLocal(gen) {
    this._gen_0 = gen;
    var tmp = this;
    tmp._local = new _no_name_provided__120(this);
  }
  threadLocal.$metadata$ = {
    simpleName: 'threadLocal',
    kind: 'class',
    interfaces: []
  };
  function AsyncSocketFactory() {
  }
  AsyncSocketFactory.$metadata$ = {
    simpleName: 'AsyncSocketFactory',
    kind: 'class',
    interfaces: []
  };
  var MimeType_byExtensions$delegate;
  function _no_name_provided__121() {
  }
  _no_name_provided__121.prototype.invoke_1005 = function () {
    return LinkedHashMap_init_$Create$();
  };
  _no_name_provided__121.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_92() {
    var i = new _no_name_provided__121();
    return function () {
      return i.invoke_1005();
    };
  }
  function QueryString() {
    QueryString_instance = this;
  }
  QueryString.prototype.decode_10 = function (str) {
    var out = LinkedHashMap_init_$Create$();
    var tmp = charArrayOf([new Char(38)]);
    var tmp0_fastForEach_0 = split$default(str, tmp, false, 0, 6, null);
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      var tmp_0 = charArrayOf([new Char(61)]);
      var parts_4 = split$default(tmp1__anonymous__3, tmp_0, false, 2, 2, null);
      var key_5 = Companion_getInstance_50().decodeComponent(parts_4.get_137(0), UTF8, true);
      var tmp_1 = Companion_getInstance_50();
      var tmp0_getOrElse_0_7 = 1;
      var tmp_2;
      if (tmp0_getOrElse_0_7 >= 0 ? tmp0_getOrElse_0_7 <= _get_lastIndex__3(parts_4) : false) {
        tmp_2 = parts_4.get_137(tmp0_getOrElse_0_7);
      } else {
        tmp_2 = key_5;
      }
      var value_6 = tmp_1.decodeComponent(tmp_2, UTF8, true);
      var value_1_9 = out.get_116(key_5);
      var tmp_3;
      if (value_1_9 == null) {
        var answer_2_10 = ArrayList_init_$Create$();
        out.put_18(key_5, answer_2_10);
        Unit_getInstance();
        tmp_3 = answer_2_10;
      } else {
        tmp_3 = value_1_9;
      }
      var list_8 = tmp_3;
      list_8.add_39(value_6);
      Unit_getInstance();
    }
    return out;
  };
  QueryString.$metadata$ = {
    simpleName: 'QueryString',
    kind: 'object',
    interfaces: []
  };
  var QueryString_instance;
  function QueryString_getInstance() {
    if (QueryString_instance == null)
      new QueryString();
    return QueryString_instance;
  }
  function Companion_51() {
    Companion_instance_50 = this;
    this._DEFAULT_PORT = 0;
    this._schemeRegex = Regex_init_$Create$('\\w+:');
  }
  Companion_51.prototype.defaultPortForScheme = function (scheme) {
    var tmp0_subject = scheme;
    switch (tmp0_subject) {
      case 'ftp':
        return 21;
      case 'ftps':
        return 990;
      case 'http':
      case 'ws':
        return 80;
      case 'https':
      case 'wss':
        return 443;
      default:return -1;
    }
  };
  Companion_51.prototype.invoke_202 = function (scheme, userInfo, host, path_0, query, fragment, opaque, port) {
    return new URL_0(opaque, scheme, userInfo, host, path_0, query, fragment, port);
  };
  Companion_51.prototype.invoke$default_1 = function (scheme, userInfo, host, path_0, query, fragment, opaque, port, $mask0, $handler) {
    if (!(($mask0 & 64) === 0))
      opaque = false;
    if (!(($mask0 & 128) === 0))
      port = this._DEFAULT_PORT;
    return this.invoke_202(scheme, userInfo, host, path_0, query, fragment, opaque, port);
  };
  Companion_51.prototype.invoke_203 = function (url) {
    var r = StrReader_init_$Create$(url, null, 0, 6, null);
    var schemeColon = r.tryRegex(this._schemeRegex);
    var tmp;
    if (!(schemeColon == null)) {
      var isHierarchical = !(r.tryLit('//') == null);
      var nonScheme = r.readRemaining();
      var scheme = dropLast(schemeColon, 1);
      var tmp_0 = new Char(35);
      var nonFragment = substringBefore$default(nonScheme, tmp_0, null, 2, null);
      var fragment = substringAfterOrNull(nonScheme, new Char(35));
      var tmp_1 = new Char(63);
      var nonQuery = substringBefore$default(nonFragment, tmp_1, null, 2, null);
      var query = substringAfterOrNull(nonFragment, new Char(63));
      var tmp_2 = new Char(47);
      var authority = substringBefore$default(nonQuery, tmp_2, null, 2, null);
      var path_0 = substringAfterOrNull(nonQuery, new Char(47));
      var tmp_3 = new Char(64);
      var hostWithPort = substringAfter$default(authority, tmp_3, null, 2, null);
      var userInfo = substringBeforeOrNull(authority, new Char(64));
      var tmp_4 = new Char(58);
      var host = substringBefore$default(hostWithPort, tmp_4, null, 2, null);
      var port = substringAfterOrNull(hostWithPort, new Char(58));
      var tmp2_opaque = !isHierarchical;
      var tmp_5;
      if (charSequenceLength(host) > 0) {
        tmp_5 = host;
      } else {
        {
          tmp_5 = null;
        }
      }
      var tmp3_host = tmp_5;
      var tmp4_path = !(path_0 == null) ? '' + '/' + path_0 : '';
      var tmp0_safe_receiver = port;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
      var tmp5_port = tmp1_elvis_lhs == null ? this._DEFAULT_PORT : tmp1_elvis_lhs;
      tmp = Companion_getInstance_50().invoke_202(scheme, userInfo, tmp3_host, tmp4_path, query, fragment, tmp2_opaque, tmp5_port);
    } else {
      var tmp_6 = new Char(35);
      var nonFragment_0 = substringBefore$default(url, tmp_6, null, 2, null);
      var fragment_0 = substringAfterOrNull(url, new Char(35));
      var tmp_7 = new Char(63);
      var path_1 = substringBefore$default(nonFragment_0, tmp_7, null, 2, null);
      var query_0 = substringAfterOrNull(nonFragment_0, new Char(63));
      var tmp_8 = Companion_getInstance_50();
      tmp = tmp_8.invoke$default_1(null, null, null, path_1, query_0, fragment_0, false, 0, 128, null);
    }
    return tmp;
  };
  Companion_51.prototype.isAbsolute = function (url) {
    return !(StrReader_init_$Create$(url, null, 0, 6, null).tryRegex(this._schemeRegex) == null);
  };
  Companion_51.prototype.resolve_0 = function (base, access) {
    var tmp;
    if (this.isAbsolute(access)) {
      tmp = access;
    } else {
      if (startsWith$default_1(access, '/', false, 2, null)) {
        var tmp_0 = Companion_getInstance_50().invoke_203(base);
        tmp = tmp_0.copy$default_2(false, null, null, null, access, null, null, 0, 239, null)._get_fullUrl_();
      } else {
        {
          var tmp0_run_0 = Companion_getInstance_50().invoke_203(base);
          var tmp_1 = new Char(47);
          var tmp_2 = '' + '/' + trimStart(normalize(_get_pathInfo_('' + substringBeforeLast$default(tmp0_run_0._path_16, tmp_1, null, 2, null) + '/' + access)), charArrayOf([new Char(47)]));
          tmp = tmp0_run_0.copy$default_2(false, null, null, null, tmp_2, null, null, 0, 239, null)._get_fullUrl_();
        }
      }
    }
    return tmp;
  };
  Companion_51.prototype.decodeComponent = function (s, charset, formUrlEncoded) {
    var bos = ByteArrayBuilder_init_$Create$_1(0, 1, null);
    var len = s.length;
    var n = 0;
    while (n < len) {
      var c = charSequenceGet(s, n);
      var tmp0_subject = c;
      if (tmp0_subject.equals(new Char(37))) {
        bos.append_7(toByte(toInt_0(substr_0(s, n + 1 | 0, 2), 16)));
        Unit_getInstance();
        n = n + 2 | 0;
      } else if (tmp0_subject.equals(new Char(43)))
        if (formUrlEncoded) {
          bos.append_7(32);
          Unit_getInstance();
        } else {
          bos.append_7(43);
          Unit_getInstance();
        }
       else {
        bos.append_7(c.toByte_6());
        Unit_getInstance();
      }
      var tmp1 = n;
      n = tmp1 + 1 | 0;
      Unit_getInstance();
    }
    return toString_3(bos.toByteArray(), charset);
  };
  Companion_51.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_50;
  function Companion_getInstance_50() {
    if (Companion_instance_50 == null)
      new Companion_51();
    return Companion_instance_50;
  }
  function _no_name_provided__122(this$0) {
    this._this$0_32 = this$0;
  }
  _no_name_provided__122.prototype.invoke_1005 = function () {
    return this._this$0_32.toUrlString$default(false, null, 3, null).toString();
  };
  _no_name_provided__122.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__123(this$0) {
    this._this$0_33 = this$0;
  }
  _no_name_provided__123.prototype.invoke_1005 = function () {
    return this._this$0_33.toUrlString$default(false, null, 2, null).toString();
  };
  _no_name_provided__123.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__124(this$0) {
    this._this$0_34 = this$0;
  }
  _no_name_provided__124.prototype.invoke_1005 = function () {
    var tmp;
    if (!(this._this$0_34._query == null)) {
      tmp = '' + this._this$0_34._path_16 + '?' + this._this$0_34._query;
    } else {
      tmp = this._this$0_34._path_16;
    }
    return tmp;
  };
  _no_name_provided__124.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function URL_0(isOpaque, scheme, userInfo, host, path_0, query, fragment, defaultPort) {
    Companion_getInstance_50();
    this._isOpaque = isOpaque;
    this._scheme = scheme;
    this._userInfo = userInfo;
    this._host = host;
    this._path_16 = path_0;
    this._query = query;
    this._fragment = fragment;
    this._defaultPort = defaultPort;
    var tmp = this;
    tmp._fullUrl$delegate = lazy(_no_name_provided_$factory_93(this));
    var tmp_0 = this;
    tmp_0._fullUrlWithoutScheme$delegate = lazy(_no_name_provided_$factory_94(this));
    var tmp_1 = this;
    tmp_1._pathWithQuery$delegate = lazy(_no_name_provided_$factory_95(this));
  }
  URL_0.prototype._get_defaultSchemePort_ = function () {
    return Companion_getInstance_50().defaultPortForScheme(this._scheme);
  };
  URL_0.prototype._get_port_ = function () {
    return this._defaultPort === Companion_getInstance_50()._DEFAULT_PORT ? this._get_defaultSchemePort_() : this._defaultPort;
  };
  URL_0.prototype._get_fullUrl_ = function () {
    var tmp0_getValue_0 = this._fullUrl$delegate;
    var tmp1_getValue_0 = fullUrl$factory();
    return tmp0_getValue_0._get_value__10();
  };
  URL_0.prototype.toUrlString = function (includeScheme, out) {
    if (includeScheme ? !(this._scheme == null) : false) {
      out.append_5('' + this._scheme + ':');
      Unit_getInstance();
      if (!this._isOpaque) {
        out.append_5('//');
        Unit_getInstance();
      }}if (!(this._userInfo == null)) {
      out.append_5('' + this._userInfo + '@');
      Unit_getInstance();
    }if (!(this._host == null)) {
      out.append_5(this._host);
      Unit_getInstance();
    }if (!(this._get_port_() === Companion_getInstance_50()._DEFAULT_PORT) ? !(this._get_port_() === this._get_defaultSchemePort_()) : false) {
      out.append_2(new Char(58)).append_4(this._get_port_());
      Unit_getInstance();
    }out.append_5(this._path_16);
    Unit_getInstance();
    if (!(this._query == null)) {
      out.append_5('' + '?' + this._query);
      Unit_getInstance();
    }if (!(this._fragment == null)) {
      out.append_5('' + '#' + this._fragment);
      Unit_getInstance();
    }return out;
  };
  URL_0.prototype.toUrlString$default = function (includeScheme, out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      includeScheme = true;
    if (!(($mask0 & 2) === 0))
      out = StringBuilder_init_$Create$_0();
    return this.toUrlString(includeScheme, out);
  };
  URL_0.prototype.toString = function () {
    return this._get_fullUrl_();
  };
  URL_0.prototype.copy_3 = function (isOpaque, scheme, userInfo, host, path_0, query, fragment, defaultPort) {
    return new URL_0(isOpaque, scheme, userInfo, host, path_0, query, fragment, defaultPort);
  };
  URL_0.prototype.copy$default_2 = function (isOpaque, scheme, userInfo, host, path_0, query, fragment, defaultPort, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      isOpaque = this._isOpaque;
    if (!(($mask0 & 2) === 0))
      scheme = this._scheme;
    if (!(($mask0 & 4) === 0))
      userInfo = this._userInfo;
    if (!(($mask0 & 8) === 0))
      host = this._host;
    if (!(($mask0 & 16) === 0))
      path_0 = this._path_16;
    if (!(($mask0 & 32) === 0))
      query = this._query;
    if (!(($mask0 & 64) === 0))
      fragment = this._fragment;
    if (!(($mask0 & 128) === 0))
      defaultPort = this._defaultPort;
    return this.copy_3(isOpaque, scheme, userInfo, host, path_0, query, fragment, defaultPort);
  };
  URL_0.prototype.hashCode = function () {
    var result = this._isOpaque | 0;
    result = imul(result, 31) + (this._scheme == null ? 0 : getStringHashCode(this._scheme)) | 0;
    result = imul(result, 31) + (this._userInfo == null ? 0 : getStringHashCode(this._userInfo)) | 0;
    result = imul(result, 31) + (this._host == null ? 0 : getStringHashCode(this._host)) | 0;
    result = imul(result, 31) + getStringHashCode(this._path_16) | 0;
    result = imul(result, 31) + (this._query == null ? 0 : getStringHashCode(this._query)) | 0;
    result = imul(result, 31) + (this._fragment == null ? 0 : getStringHashCode(this._fragment)) | 0;
    result = imul(result, 31) + this._defaultPort | 0;
    return result;
  };
  URL_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof URL_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof URL_0 ? other : THROW_CCE();
    if (!(this._isOpaque === tmp0_other_with_cast._isOpaque))
      return false;
    if (!(this._scheme == tmp0_other_with_cast._scheme))
      return false;
    if (!(this._userInfo == tmp0_other_with_cast._userInfo))
      return false;
    if (!(this._host == tmp0_other_with_cast._host))
      return false;
    if (!(this._path_16 === tmp0_other_with_cast._path_16))
      return false;
    if (!(this._query == tmp0_other_with_cast._query))
      return false;
    if (!(this._fragment == tmp0_other_with_cast._fragment))
      return false;
    if (!(this._defaultPort === tmp0_other_with_cast._defaultPort))
      return false;
    return true;
  };
  URL_0.$metadata$ = {
    simpleName: 'URL',
    kind: 'class',
    interfaces: []
  };
  function fullUrl$factory() {
    return getPropertyCallableRef('fullUrl', 1, KProperty1, function (receiver) {
      return receiver._get_fullUrl_();
    }, null);
  }
  function _no_name_provided_$factory_93(this$0) {
    var i = new _no_name_provided__122(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_94(this$0) {
    var i = new _no_name_provided__123(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_95(this$0) {
    var i = new _no_name_provided__124(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  var Methods_ALL_instance;
  var Methods_OPTIONS_instance;
  var Methods_GET_instance;
  var Methods_HEAD_instance;
  var Methods_POST_instance;
  var Methods_PUT_instance;
  var Methods_DELETE_instance;
  var Methods_TRACE_instance;
  var Methods_CONNECT_instance;
  var Methods_PATCH_instance;
  var Methods_entriesInitialized;
  function Methods_initEntries() {
    if (Methods_entriesInitialized)
      return Unit_getInstance();
    Methods_entriesInitialized = true;
    Methods_ALL_instance = new Methods('ALL', 0);
    Methods_OPTIONS_instance = new Methods('OPTIONS', 1);
    Methods_GET_instance = new Methods('GET', 2);
    Methods_HEAD_instance = new Methods('HEAD', 3);
    Methods_POST_instance = new Methods('POST', 4);
    Methods_PUT_instance = new Methods('PUT', 5);
    Methods_DELETE_instance = new Methods('DELETE', 6);
    Methods_TRACE_instance = new Methods('TRACE', 7);
    Methods_CONNECT_instance = new Methods('CONNECT', 8);
    Methods_PATCH_instance = new Methods('PATCH', 9);
  }
  function Companion_52() {
    Companion_instance_51 = this;
    this._OPTIONS = Methods_OPTIONS_getInstance();
    this._GET = Methods_GET_getInstance();
    this._HEAD = Methods_HEAD_getInstance();
    this._POST = Methods_POST_getInstance();
    this._PUT = Methods_PUT_getInstance();
    this._DELETE = Methods_DELETE_getInstance();
    this._TRACE = Methods_TRACE_getInstance();
    this._CONNECT = Methods_CONNECT_getInstance();
    this._PATCH = Methods_PATCH_getInstance();
    this.__values_3 = listOf([this._OPTIONS, this._GET, this._HEAD, this._POST, this._PUT, this._DELETE, this._TRACE, this._CONNECT, this._PATCH]);
    var tmp = this;
    var tmp0_map_0 = this.__values_3;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(to(item_2_3._get_name__50(), item_2_3));
      Unit_getInstance();
    }
    tmp._valuesMap = toMap_0(tmp0_mapTo_0_1);
  }
  Companion_52.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_51;
  function Companion_getInstance_51() {
    if (Companion_instance_51 == null)
      new Companion_52();
    return Companion_instance_51;
  }
  function HttpException_init_$Init$(statusCode, msg, statusText, headers, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      msg = '' + 'Error' + statusCode;
    if (!(($mask0 & 4) === 0)) {
      var tmp0_elvis_lhs = HttpStatusMessage_getInstance()._CODES_0.get_116(statusCode);
      statusText = tmp0_elvis_lhs == null ? '' + 'Error' + statusCode : tmp0_elvis_lhs;
    }if (!(($mask0 & 8) === 0))
      headers = Headers_init_$Create$([]);
    HttpException.call($this, statusCode, msg, statusText, headers);
    return $this;
  }
  function HttpException_init_$Create$(statusCode, msg, statusText, headers, $mask0, $marker) {
    var tmp = HttpException_init_$Init$(statusCode, msg, statusText, headers, $mask0, $marker, Object.create(HttpException.prototype));
    captureStack(tmp, HttpException_init_$Create$);
    return tmp;
  }
  function Companion_53() {
    Companion_instance_52 = this;
  }
  Companion_53.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_52;
  function Companion_getInstance_52() {
    if (Companion_instance_52 == null)
      new Companion_53();
    return Companion_instance_52;
  }
  function Headers_init_$Init$(items, $this) {
    Headers_0.call($this, toList(items));
    return $this;
  }
  function Headers_init_$Create$(items) {
    return Headers_init_$Init$(items, Object.create(Headers_0.prototype));
  }
  function Headers_init_$Init$_0(map_0, $this) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(map_0._get_size__60());
    var tmp0_iterator_1_2 = map_0._get_entries__10().iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(to(item_2_3._get_key__37(), item_2_3._get_value__10()));
      Unit_getInstance();
    }
    Headers_0.call($this, tmp0_mapTo_0_1);
    return $this;
  }
  function Headers_init_$Create$_0(map_0) {
    return Headers_init_$Init$_0(map_0, Object.create(Headers_0.prototype));
  }
  function Headers_init_$Init$_1(str, $this) {
    Headers_0.call($this, Companion_getInstance_53().parse(str)._items_2);
    return $this;
  }
  function Headers_init_$Create$_1(str) {
    return Headers_init_$Init$_1(str, Object.create(Headers_0.prototype));
  }
  function Companion_54() {
    Companion_instance_53 = this;
    this._ContentLength = 'Content-Length';
    this._ContentType = 'Content-Type';
  }
  Companion_54.prototype.parse = function (str) {
    if (str == null)
      return Headers_init_$Create$([]);
    var tmp = ['\n'];
    var tmp0_map_0 = split$default_0(str, tmp, false, 0, 6, null);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      var tmp_0 = toString_1(trim_0(isCharSequence(item_2_3) ? item_2_3 : THROW_CCE()));
      var tmp_1 = charArrayOf([new Char(58)]);
      var parts_5 = split$default(tmp_0, tmp_1, false, 2, 2, null);
      var tmp_2;
      if (parts_5._get_size__60() >= 2) {
        var tmp0_trim_0_6 = parts_5.get_137(0);
        var tmp_3 = toString_1(trim_0(isCharSequence(tmp0_trim_0_6) ? tmp0_trim_0_6 : THROW_CCE()));
        var tmp1_trim_0_7 = parts_5.get_137(1);
        tmp_2 = to(tmp_3, toString_1(trim_0(isCharSequence(tmp1_trim_0_7) ? tmp1_trim_0_7 : THROW_CCE())));
      } else {
        tmp_2 = null;
      }
      tmp0_mapTo_0_1.add_39(tmp_2);
      Unit_getInstance();
    }
    return new Headers_0(filterNotNull(tmp0_mapTo_0_1));
  };
  Companion_54.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_53;
  function Companion_getInstance_53() {
    if (Companion_instance_53 == null)
      new Companion_54();
    return Companion_instance_53;
  }
  function _no_name_provided__125() {
  }
  _no_name_provided__125.prototype.invoke_207 = function (a, b) {
    var tmp0_toLowerCase_0_3 = a._first;
    var tmp = tmp0_toLowerCase_0_3.toLowerCase();
    var tmp0_toLowerCase_0_3_0 = b._first;
    return compareValues(tmp, tmp0_toLowerCase_0_3_0.toLowerCase());
  };
  _no_name_provided__125.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof Pair ? p1 : THROW_CCE();
    return this.invoke_207(tmp, p2 instanceof Pair ? p2 : THROW_CCE());
  };
  _no_name_provided__125.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Methods(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Methods.$metadata$ = {
    simpleName: 'Methods',
    kind: 'class',
    interfaces: [Method]
  };
  function Method() {
  }
  Method.$metadata$ = {
    simpleName: 'Method',
    kind: 'interface',
    interfaces: []
  };
  function HttpException(statusCode, msg, statusText, headers) {
    Companion_getInstance_52();
    IOException.call(this, '' + statusCode + ' ' + statusText + ' - ' + msg);
    this._statusCode = statusCode;
    this._msg = msg;
    this._statusText = statusText;
    this._headers = headers;
    captureStack(this, HttpException);
  }
  HttpException.$metadata$ = {
    simpleName: 'HttpException',
    kind: 'class',
    interfaces: []
  };
  function Headers_0(items) {
    Companion_getInstance_53();
    this._items_2 = items;
  }
  Headers_0.prototype.iterator_67 = function () {
    return this._items_2.iterator_67();
  };
  Headers_0.prototype.get_115 = function (key) {
    return this.getFirst(key);
  };
  Headers_0.prototype.getFirst = function (key) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._items_2;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (equals_0(element_2._first, key, true)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_safe_receiver = tmp$ret$0;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._second;
  };
  Headers_0.prototype.toListGrouped = function () {
    var tmp0_groupBy_0 = this._items_2;
    var tmp0_groupByTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_groupBy_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var element_2_3 = tmp0_iterator_1_2.next_37();
      var tmp0_toLowerCase_0_9 = element_2_3._first;
      var key_3_4 = tmp0_toLowerCase_0_9.toLowerCase();
      var value_1_6 = tmp0_groupByTo_0_1.get_116(key_3_4);
      var tmp;
      if (value_1_6 == null) {
        var answer_2_7 = ArrayList_init_$Create$();
        tmp0_groupByTo_0_1.put_18(key_3_4, answer_2_7);
        Unit_getInstance();
        tmp = answer_2_7;
      } else {
        tmp = value_1_6;
      }
      var list_4_5 = tmp;
      list_4_5.add_39(element_2_3);
      Unit_getInstance();
    }
    var tmp1_map_0 = tmp0_groupByTo_0_1;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp1_map_0._get_size__60());
    var tmp0_iterator_1_2_0 = tmp1_map_0._get_entries__10().iterator_67();
    while (tmp0_iterator_1_2_0.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_37();
      var tmp_0 = first(item_2_3._get_value__10())._first;
      var tmp0_map_0_5 = item_2_3._get_value__10();
      var tmp0_mapTo_0_1_6 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_5, 10));
      var tmp0_iterator_1_2_7 = tmp0_map_0_5.iterator_67();
      while (tmp0_iterator_1_2_7.hasNext_33()) {
        var item_2_3_8 = tmp0_iterator_1_2_7.next_37();
        tmp0_mapTo_0_1_6.add_39(item_2_3_8._second);
        Unit_getInstance();
      }
      tmp0_mapTo_0_1.add_39(to(tmp_0, tmp0_mapTo_0_1_6));
      Unit_getInstance();
    }
    var tmp2_sortedBy_0 = tmp0_mapTo_0_1;
    var tmp_1 = _no_name_provided_$factory_96();
    return sortedWith(tmp2_sortedBy_0, new sam$kotlin_Comparator$0_1(tmp_1));
  };
  Headers_0.prototype.withReplaceHeaders = function (newHeaders) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(newHeaders, 10));
    var tmp0_iterator_1_2 = newHeaders.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      var tmp0_toLowerCase_0_5 = item_2_3._first;
      tmp0_mapTo_0_1.add_39(tmp0_toLowerCase_0_5.toLowerCase());
      Unit_getInstance();
    }
    var replaceKeys = toSet_0(tmp0_mapTo_0_1);
    var tmp0_filter_0 = this._items_2;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2_0 = tmp0_filter_0.iterator_67();
    while (tmp0_iterator_1_2_0.hasNext_33()) {
      var element_2_3 = tmp0_iterator_1_2_0.next_37();
      var tmp0_toLowerCase_0_5_0 = element_2_3._first;
      if (!replaceKeys.contains_58(tmp0_toLowerCase_0_5_0.toLowerCase())) {
        tmp0_filterTo_0_1.add_39(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    return new Headers_0(plus(tmp0_filterTo_0_1, toList_2(newHeaders)));
  };
  Headers_0.prototype.withReplaceHeaders_0 = function (newHeaders) {
    return this.withReplaceHeaders(toList(newHeaders));
  };
  Headers_0.prototype.withReplaceHeaders_1 = function (newHeaders) {
    return this.withReplaceHeaders(toList_2(newHeaders));
  };
  Headers_0.prototype.toString = function () {
    var tmp = this.toListGrouped();
    return '' + 'Headers(' + joinToString$default_0(tmp, ', ', null, null, 0, null, null, 62, null) + ')';
  };
  Headers_0.prototype.hashCode = function () {
    return hashCode(this._items_2);
  };
  Headers_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Headers_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Headers_0 ? other : THROW_CCE();
    if (!equals_1(this._items_2, tmp0_other_with_cast._items_2))
      return false;
    return true;
  };
  Headers_0.$metadata$ = {
    simpleName: 'Headers',
    kind: 'class',
    interfaces: [Iterable]
  };
  function sam$kotlin_Comparator$0_1(function_0) {
    this._function_1 = function_0;
  }
  sam$kotlin_Comparator$0_1.prototype.compare_10 = function (a, b) {
    return this._function_1(a, b);
  };
  sam$kotlin_Comparator$0_1.prototype.compare = function (a, b) {
    return this.compare_10(a, b);
  };
  sam$kotlin_Comparator$0_1.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function Methods_OPTIONS_getInstance() {
    Methods_initEntries();
    return Methods_OPTIONS_instance;
  }
  function Methods_GET_getInstance() {
    Methods_initEntries();
    return Methods_GET_instance;
  }
  function Methods_HEAD_getInstance() {
    Methods_initEntries();
    return Methods_HEAD_instance;
  }
  function Methods_POST_getInstance() {
    Methods_initEntries();
    return Methods_POST_instance;
  }
  function Methods_PUT_getInstance() {
    Methods_initEntries();
    return Methods_PUT_instance;
  }
  function Methods_DELETE_getInstance() {
    Methods_initEntries();
    return Methods_DELETE_instance;
  }
  function Methods_TRACE_getInstance() {
    Methods_initEntries();
    return Methods_TRACE_instance;
  }
  function Methods_CONNECT_getInstance() {
    Methods_initEntries();
    return Methods_CONNECT_instance;
  }
  function Methods_PATCH_getInstance() {
    Methods_initEntries();
    return Methods_PATCH_instance;
  }
  function _no_name_provided_$factory_96() {
    var i = new _no_name_provided__125();
    return function (p1, p2) {
      return i.invoke_207(p1, p2);
    };
  }
  function _get__defaultHttpFactory_() {
    var tmp0_getValue_0 = _defaultHttpFactory$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = _defaultHttpFactory$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var _defaultHttpFactory$delegate;
  function _no_name_provided__126() {
  }
  _no_name_provided__126.prototype.invoke_1005 = function () {
    return UTF8;
  };
  _no_name_provided__126.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $readAllBytesCOROUTINE$108(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__56 = _this_;
  }
  $readAllBytesCOROUTINE$108.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readAll(this.__this__56._content, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var allContent = suspendResult;
            return allContent;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAllBytesCOROUTINE$108.$metadata$ = {
    simpleName: '$readAllBytesCOROUTINE$108',
    kind: 'class',
    interfaces: []
  };
  function $readAllStringCOROUTINE$109(_this_, charset, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__57 = _this_;
    this._charset_0 = charset;
  }
  $readAllStringCOROUTINE$109.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__57.readAllBytes(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var bytes = suspendResult;
            return toString_3(bytes, this._charset_0);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAllStringCOROUTINE$109.$metadata$ = {
    simpleName: '$readAllStringCOROUTINE$109',
    kind: 'class',
    interfaces: []
  };
  function $checkErrorsCOROUTINE$110(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__58 = _this_;
  }
  $checkErrorsCOROUTINE$110.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (!this.__this__58._success) {
              this._ARGUMENT0_12 = this.__this__58._status;
              this._state_1 = 2;
              suspendResult = this.__this__58.readAllString$default(null, 1, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            return this.__this__58;
          case 2:
            var ARGUMENT = suspendResult;
            throw HttpException_init_$Create$(this._ARGUMENT0_12, ARGUMENT, this.__this__58._statusText_0, null, 8, null);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $checkErrorsCOROUTINE$110.$metadata$ = {
    simpleName: '$checkErrorsCOROUTINE$110',
    kind: 'class',
    interfaces: []
  };
  function RequestConfig_init_$Init$(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      followRedirects = true;
    if (!(($mask0 & 2) === 0))
      throwErrors = false;
    if (!(($mask0 & 4) === 0))
      maxRedirects = 10;
    if (!(($mask0 & 8) === 0))
      referer = null;
    if (!(($mask0 & 16) === 0))
      simulateBrowser = false;
    RequestConfig.call($this, followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
    return $this;
  }
  function RequestConfig_init_$Create$(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $mask0, $marker) {
    return RequestConfig_init_$Init$(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $mask0, $marker, Object.create(RequestConfig.prototype));
  }
  function Response_0(status, statusText, headers, content) {
    this._status = status;
    this._statusText_0 = statusText;
    this._headers_0 = headers;
    this._content = content;
    this._success = this._status < 400;
    var tmp = this;
    tmp._responseCharset$delegate = lazy(_no_name_provided_$factory_98());
  }
  Response_0.prototype.readAllBytes = function ($cont) {
    var tmp = new $readAllBytesCOROUTINE$108(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Response_0.prototype._get_responseCharset_ = function () {
    var tmp0_getValue_0 = this._responseCharset$delegate;
    var tmp1_getValue_0 = responseCharset$factory();
    return tmp0_getValue_0._get_value__10();
  };
  Response_0.prototype.readAllString = function (charset, $cont) {
    var tmp = new $readAllStringCOROUTINE$109(this, charset, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Response_0.prototype.readAllString$default = function (charset, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      charset = this._get_responseCharset_();
    return this.readAllString(charset, $cont);
  };
  Response_0.prototype.checkErrors = function ($cont) {
    var tmp = new $checkErrorsCOROUTINE$110(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Response_0.prototype.toCompletedResponse = function (content) {
    return new CompletedResponse(this._status, this._statusText_0, this._headers_0, content);
  };
  Response_0.prototype.toString = function () {
    return '' + 'Response(status=' + this._status + ', statusText=' + this._statusText_0 + ', headers=' + this._headers_0 + ', content=' + this._content + ')';
  };
  Response_0.prototype.hashCode = function () {
    var result = this._status;
    result = imul(result, 31) + getStringHashCode(this._statusText_0) | 0;
    result = imul(result, 31) + this._headers_0.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._content) | 0;
    return result;
  };
  Response_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Response_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Response_0 ? other : THROW_CCE();
    if (!(this._status === tmp0_other_with_cast._status))
      return false;
    if (!(this._statusText_0 === tmp0_other_with_cast._statusText_0))
      return false;
    if (!this._headers_0.equals(tmp0_other_with_cast._headers_0))
      return false;
    if (!equals_1(this._content, tmp0_other_with_cast._content))
      return false;
    return true;
  };
  Response_0.$metadata$ = {
    simpleName: 'Response',
    kind: 'class',
    interfaces: []
  };
  function CompletedResponse(status, statusText, headers, content) {
    this._status_0 = status;
    this._statusText_1 = statusText;
    this._headers_1 = headers;
    this._content_0 = content;
    this._success_0 = this._status_0 < 400;
  }
  CompletedResponse.prototype.toString = function () {
    return '' + 'CompletedResponse(status=' + this._status_0 + ', statusText=' + this._statusText_1 + ', headers=' + this._headers_1 + ', content=' + this._content_0 + ')';
  };
  CompletedResponse.prototype.hashCode = function () {
    var result = this._status_0;
    result = imul(result, 31) + getStringHashCode(this._statusText_1) | 0;
    result = imul(result, 31) + this._headers_1.hashCode() | 0;
    result = imul(result, 31) + (this._content_0 == null ? 0 : hashCode(this._content_0)) | 0;
    return result;
  };
  CompletedResponse.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedResponse))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CompletedResponse ? other : THROW_CCE();
    if (!(this._status_0 === tmp0_other_with_cast._status_0))
      return false;
    if (!(this._statusText_1 === tmp0_other_with_cast._statusText_1))
      return false;
    if (!this._headers_1.equals(tmp0_other_with_cast._headers_1))
      return false;
    if (!equals_1(this._content_0, tmp0_other_with_cast._content_0))
      return false;
    return true;
  };
  CompletedResponse.$metadata$ = {
    simpleName: 'CompletedResponse',
    kind: 'class',
    interfaces: []
  };
  function RequestConfig(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    this._followRedirects = followRedirects;
    this._throwErrors = throwErrors;
    this._maxRedirects = maxRedirects;
    this._referer = referer;
    this._simulateBrowser = simulateBrowser;
  }
  RequestConfig.prototype.copy_4 = function (followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    return new RequestConfig(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  };
  RequestConfig.prototype.copy$default_3 = function (followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      followRedirects = this._followRedirects;
    if (!(($mask0 & 2) === 0))
      throwErrors = this._throwErrors;
    if (!(($mask0 & 4) === 0))
      maxRedirects = this._maxRedirects;
    if (!(($mask0 & 8) === 0))
      referer = this._referer;
    if (!(($mask0 & 16) === 0))
      simulateBrowser = this._simulateBrowser;
    return this.copy_4(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  };
  RequestConfig.prototype.toString = function () {
    return '' + 'RequestConfig(followRedirects=' + this._followRedirects + ', throwErrors=' + this._throwErrors + ', maxRedirects=' + this._maxRedirects + ', referer=' + this._referer + ', simulateBrowser=' + this._simulateBrowser + ')';
  };
  RequestConfig.prototype.hashCode = function () {
    var result = this._followRedirects | 0;
    result = imul(result, 31) + (this._throwErrors | 0) | 0;
    result = imul(result, 31) + this._maxRedirects | 0;
    result = imul(result, 31) + (this._referer == null ? 0 : getStringHashCode(this._referer)) | 0;
    result = imul(result, 31) + (this._simulateBrowser | 0) | 0;
    return result;
  };
  RequestConfig.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestConfig))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RequestConfig ? other : THROW_CCE();
    if (!(this._followRedirects === tmp0_other_with_cast._followRedirects))
      return false;
    if (!(this._throwErrors === tmp0_other_with_cast._throwErrors))
      return false;
    if (!(this._maxRedirects === tmp0_other_with_cast._maxRedirects))
      return false;
    if (!(this._referer == tmp0_other_with_cast._referer))
      return false;
    if (!(this._simulateBrowser === tmp0_other_with_cast._simulateBrowser))
      return false;
    return true;
  };
  RequestConfig.$metadata$ = {
    simpleName: 'RequestConfig',
    kind: 'class',
    interfaces: []
  };
  function mergeUrls($this, base, append) {
    return Companion_getInstance_50().resolve_0(base, append);
  }
  function Companion_55() {
    Companion_instance_54 = this;
    this._DEFAULT_USER_AGENT = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.81 Safari/537.36';
    this._DEFAULT_ACCEPT = 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8';
    this._DEFAULT_LANGUAGE = 'en-us';
    this._DEFAULT_ENCODING = 'gzip, deflate';
    this._DEFAULT_CONNECTION = 'Close';
  }
  Companion_55.prototype.combineHeadersForHost = function (headers, host) {
    var out = Headers_init_$Create$([to('User-Agent', this._DEFAULT_USER_AGENT), to('Accept', this._DEFAULT_ACCEPT), to('Accept-Language', this._DEFAULT_LANGUAGE), to('Accept-Encoding', this._DEFAULT_ENCODING), to('Connection', this._DEFAULT_CONNECTION)]).withReplaceHeaders_1(headers);
    return !(host == null) ? out.withReplaceHeaders_0([to('Host', host)]) : out;
  };
  Companion_55.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_54;
  function Companion_getInstance_54() {
    if (Companion_instance_54 == null)
      new Companion_55();
    return Companion_instance_54;
  }
  function $requestCOROUTINE$111(_this_, method, url, headers, content, config, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__59 = _this_;
    this._method = method;
    this._url_0 = url;
    this._headers_2 = headers;
    this._content_1 = content;
    this._config = config;
  }
  $requestCOROUTINE$111.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._tmp0_safe_receiver0_0 = this._content_1;
            if (this._tmp0_safe_receiver0_0 == null) {
              this._WHEN_RESULT1_1 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0_0.getLength_14(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1_1 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._tmp1_elvis_lhs2 = this._WHEN_RESULT1_1;
            this._contentLength3 = this._tmp1_elvis_lhs2 == null ? new Long(0, 0) : this._tmp1_elvis_lhs2;
            this._actualHeaders4 = this._headers_2;
            var tmp_0;
            if (!(this._content_1 == null)) {
              l$ret$1: do {
                var tmp_1;
                var tmp_2 = this._headers_2;
                if (isInterface(tmp_2, Collection)) {
                  tmp_1 = this._headers_2.isEmpty_53();
                } else {
                  {
                    tmp_1 = false;
                  }
                }
                if (tmp_1) {
                  this._tmp$ret$05 = false;
                  break l$ret$1;
                } else {
                }
                var tmp0_iterator_1 = this._headers_2.iterator_67();
                while (tmp0_iterator_1.hasNext_33()) {
                  var element_2 = tmp0_iterator_1.next_37();
                  if (equals_0(element_2._first, Companion_getInstance_53()._ContentLength, true)) {
                    this._tmp$ret$05 = true;
                    break l$ret$1;
                  } else {
                  }
                }
                this._tmp$ret$05 = false;
              }
               while (false);
              tmp_0 = !this._tmp$ret$05;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this._actualHeaders4 = this._actualHeaders4.withReplaceHeaders_0([to(Companion_getInstance_53()._ContentLength, '' + this._contentLength3)]);
            } else {
            }

            if (this._config._simulateBrowser) {
              this._actualHeaders4 = Companion_getInstance_54().combineHeadersForHost(this._actualHeaders4, null);
            }
            this._state_1 = 3;
            suspendResult = this.__this__59.requestInternal_0(this._method, this._url_0, this._actualHeaders4, this._content_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._tmp0_apply_06 = suspendResult;
            if (this._config._throwErrors) {
              this._state_1 = 4;
              suspendResult = this._tmp0_apply_06.checkErrors(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 4:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._response7 = this._tmp0_apply_06;
            if (this._config._followRedirects ? this._config._maxRedirects >= 0 : false) {
              this._redirectLocation8 = this._response7._headers_0.get_115('location');
              if (!(this._redirectLocation8 == null)) {
                this._state_1 = 8;
                var tmp_3 = mergeUrls(this.__this__59, this._url_0, this._redirectLocation8);
                var tmp_4 = this._headers_2.withReplaceHeaders_0([to('Referer', this._url_0)]);
                var tmp_5 = this._config._maxRedirects - 1 | 0;
                suspendResult = this.__this__59.request_0(this._method, tmp_3, tmp_4, this._content_1, this._config.copy$default_3(false, false, tmp_5, null, false, 27, null), this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                this._state_1 = 6;
                continue $sm;
              }
            } else {
              this._state_1 = 7;
              continue $sm;
            }

            break;
          case 6:
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._response7;
          case 8:
            return suspendResult;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $requestCOROUTINE$111.$metadata$ = {
    simpleName: '$requestCOROUTINE$111',
    kind: 'class',
    interfaces: []
  };
  function $requestAsBytesCOROUTINE$113(_this_, method, url, headers, content, config, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__60 = _this_;
    this._method_0 = method;
    this._url_1 = url;
    this._headers_3 = headers;
    this._content_2 = content;
    this._config_0 = config;
  }
  $requestAsBytesCOROUTINE$113.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__60.request_0(this._method_0, this._url_1, this._headers_3, this._content_2, this._config_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._res0_0 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._res0_0.readAllBytes(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this._res0_0.toCompletedResponse(ARGUMENT);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $requestAsBytesCOROUTINE$113.$metadata$ = {
    simpleName: '$requestAsBytesCOROUTINE$113',
    kind: 'class',
    interfaces: []
  };
  function $readBytesCOROUTINE$114(_this_, url, config, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__61 = _this_;
    this._url_2 = url;
    this._config_1 = config;
  }
  $readBytesCOROUTINE$114.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = Companion_getInstance_51()._GET;
            suspendResult = this.__this__61.requestAsBytes$default(tmp_0, this._url_2, null, null, this._config_1.copy$default_3(false, true, 0, null, false, 29, null), 12, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT._content_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesCOROUTINE$114.$metadata$ = {
    simpleName: '$readBytesCOROUTINE$114',
    kind: 'class',
    interfaces: []
  };
  function HttpClient() {
    Companion_getInstance_54();
    this._ignoreSslCertificates = false;
  }
  HttpClient.prototype.request_0 = function (method, url, headers, content, config, $cont) {
    var tmp = new $requestCOROUTINE$111(this, method, url, headers, content, config, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  HttpClient.prototype.request$default = function (method, url, headers, content, config, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      headers = Headers_init_$Create$([]);
    if (!(($mask0 & 8) === 0))
      content = null;
    if (!(($mask0 & 16) === 0)) {
      config = RequestConfig_init_$Create$(false, false, 0, null, false, 31, null);
    }return this.request_0(method, url, headers, content, config, $cont);
  };
  HttpClient.prototype.requestAsBytes_0 = function (method, url, headers, content, config, $cont) {
    var tmp = new $requestAsBytesCOROUTINE$113(this, method, url, headers, content, config, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  HttpClient.prototype.requestAsBytes$default = function (method, url, headers, content, config, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      headers = Headers_init_$Create$([]);
    if (!(($mask0 & 8) === 0))
      content = null;
    if (!(($mask0 & 16) === 0)) {
      config = RequestConfig_init_$Create$(false, false, 0, null, false, 31, null);
    }return this.requestAsBytes_0(method, url, headers, content, config, $cont);
  };
  HttpClient.prototype.readBytes_2 = function (url, config, $cont) {
    var tmp = new $readBytesCOROUTINE$114(this, url, config, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  HttpClient.prototype.readBytes$default = function (url, config, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0)) {
      config = RequestConfig_init_$Create$(false, false, 0, null, false, 31, null);
    }return this.readBytes_2(url, config, $cont);
  };
  HttpClient.$metadata$ = {
    simpleName: 'HttpClient',
    kind: 'class',
    interfaces: []
  };
  function createHttpClient() {
    return _get_defaultHttpFactory_().createClient_1();
  }
  function HttpStatusMessage() {
    HttpStatusMessage_instance = this;
    this._CODES_0 = linkedMapOf([to(100, 'Continue'), to(101, 'Switching Protocols'), to(200, 'OK'), to(201, 'Created'), to(202, 'Accepted'), to(203, 'Non-Authoritative Information'), to(204, 'No Content'), to(205, 'Reset Content'), to(206, 'Partial Content'), to(300, 'Multiple Choices'), to(301, 'Moved Permanently'), to(302, 'Found'), to(303, 'See Other'), to(304, 'Not Modified'), to(305, 'Use Proxy'), to(307, 'Temporary Redirect'), to(400, 'Bad Request'), to(401, 'Unauthorized'), to(402, 'Payment Required'), to(403, 'Forbidden'), to(404, 'Not Found'), to(405, 'Method Not Allowed'), to(406, 'Not Acceptable'), to(407, 'Proxy Authentication Required'), to(408, 'Request Timeout'), to(409, 'Conflict'), to(410, 'Gone'), to(411, 'Length Required'), to(412, 'Precondition Failed'), to(413, 'Request Entity Too Large'), to(414, 'Request-URI Too Long'), to(415, 'Unsupported Media Type'), to(416, 'Requested Range Not Satisfiable'), to(417, 'Expectation Failed'), to(418, "I'm a teapot"), to(422, 'Unprocessable Entity (WebDAV - RFC 4918)'), to(423, 'Locked (WebDAV - RFC 4918)'), to(424, 'Failed Dependency (WebDAV) (RFC 4918)'), to(425, 'Unassigned'), to(426, 'Upgrade Required (RFC 7231)'), to(428, 'Precondition Required'), to(429, 'Too Many Requests'), to(431, 'Request Header Fileds Too Large)'), to(449, 'Error449'), to(451, 'Unavailable for Legal Reasons'), to(500, 'Internal Server Error'), to(501, 'Not Implemented'), to(502, 'Bad Gateway'), to(503, 'Service Unavailable'), to(504, 'Gateway Timeout'), to(505, 'HTTP Version Not Supported'), to(506, 'Variant Also Negotiates (RFC 2295)'), to(507, 'Insufficient Storage (WebDAV - RFC 4918)'), to(508, 'Loop Detected (WebDAV)'), to(509, 'Bandwidth Limit Exceeded'), to(510, 'Not Extended (RFC 2774)'), to(511, 'Network Authentication Required')]);
  }
  HttpStatusMessage.$metadata$ = {
    simpleName: 'HttpStatusMessage',
    kind: 'object',
    interfaces: []
  };
  var HttpStatusMessage_instance;
  function HttpStatusMessage_getInstance() {
    if (HttpStatusMessage_instance == null)
      new HttpStatusMessage();
    return HttpStatusMessage_instance;
  }
  function ProxiedHttpFactory(parent) {
    this._parent_1 = parent;
    this._$$delegate_0_1 = parent;
  }
  ProxiedHttpFactory.prototype.createClient_1 = function () {
    return this._$$delegate_0_1.createClient_1();
  };
  ProxiedHttpFactory.$metadata$ = {
    simpleName: 'ProxiedHttpFactory',
    kind: 'class',
    interfaces: [HttpFactory]
  };
  function HttpFactory() {
  }
  HttpFactory.$metadata$ = {
    simpleName: 'HttpFactory',
    kind: 'interface',
    interfaces: []
  };
  function _get_defaultHttpFactory_() {
    return _get__defaultHttpFactory_();
  }
  function _no_name_provided__127() {
  }
  _no_name_provided__127.prototype.invoke_1005 = function () {
    return new ProxiedHttpFactory(_get_httpFactory_());
  };
  _no_name_provided__127.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _defaultHttpFactory$factory() {
    return getPropertyCallableRef('_defaultHttpFactory', 0, KProperty0, function () {
      return _get__defaultHttpFactory_();
    }, null);
  }
  function responseCharset$factory() {
    return getPropertyCallableRef('responseCharset', 1, KProperty1, function (receiver) {
      return receiver._get_responseCharset_();
    }, null);
  }
  function _no_name_provided_$factory_97() {
    var i = new _no_name_provided__127();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_98() {
    var i = new _no_name_provided__126();
    return function () {
      return i.invoke_1005();
    };
  }
  function Resourceable() {
  }
  Resourceable.$metadata$ = {
    simpleName: 'Resourceable',
    kind: 'interface',
    interfaces: []
  };
  function ResourcesContainer() {
  }
  ResourcesContainer.$metadata$ = {
    simpleName: 'ResourcesContainer',
    kind: 'interface',
    interfaces: []
  };
  function Resources_init_$Init$(coroutineContext, root, parent, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      root = _get_resourcesVfs_();
    if (!(($mask0 & 4) === 0))
      parent = null;
    Resources.call($this, coroutineContext, root, parent);
    return $this;
  }
  function Resources_init_$Create$(coroutineContext, root, parent, $mask0, $marker) {
    return Resources_init_$Init$(coroutineContext, root, parent, $mask0, $marker, Object.create(Resources.prototype));
  }
  function Resources(coroutineContext, root, parent) {
    this._coroutineContext_0 = coroutineContext;
    this._root_0 = root;
    this._parent_2 = parent;
    this._map_4 = LinkedHashMap_init_$Create$();
  }
  Resources.$metadata$ = {
    simpleName: 'Resources',
    kind: 'class',
    interfaces: [ResourcesContainer]
  };
  function Companion_56() {
    Companion_instance_55 = this;
    this._DEFAULT_1 = new Context(false);
  }
  Companion_56.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_55;
  function Companion_getInstance_55() {
    if (Companion_instance_55 == null)
      new Companion_56();
    return Companion_instance_55;
  }
  function CustomSerializer() {
  }
  CustomSerializer.$metadata$ = {
    simpleName: 'CustomSerializer',
    kind: 'interface',
    interfaces: []
  };
  function Context(optimizedNumericLists) {
    Companion_getInstance_55();
    this._optimizedNumericLists = optimizedNumericLists;
  }
  Context.$metadata$ = {
    simpleName: 'Context',
    kind: 'class',
    interfaces: []
  };
  function parseNumber($this, s) {
    var start = s._pos_0;
    $l$break: while (true) {
      var tmp;
      if (s._get_hasMore__0()) {
        var tmp0__anonymous__1 = s.peekChar_0();
        tmp = (((((tmp0__anonymous__1.compareTo_10(new Char(48)) >= 0 ? tmp0__anonymous__1.compareTo_10(new Char(57)) <= 0 : false) ? true : tmp0__anonymous__1.equals(new Char(46))) ? true : tmp0__anonymous__1.equals(new Char(101))) ? true : tmp0__anonymous__1.equals(new Char(69))) ? true : tmp0__anonymous__1.equals(new Char(45))) ? true : tmp0__anonymous__1.equals(new Char(43));
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$break;
      }s.readChar_0();
      Unit_getInstance();
    }
    var end = s._pos_0;
    return NumberParser_getInstance().parseDouble(s._str_2, start, end);
  }
  function encodeString($this, str) {
    var tmp0_apply_0 = StringBuilder_init_$Create$_0();
    encodeString_0(Json_getInstance(), str, tmp0_apply_0);
    return tmp0_apply_0.toString();
  }
  function encodeString_0($this, str, b) {
    b.append_2(new Char(34));
    Unit_getInstance();
    var indexedObject = str;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var c = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp1_subject = c;
      if (tmp1_subject.equals(new Char(92))) {
        b.append_5('\\\\');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(47))) {
        b.append_5('\\/');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(39))) {
        b.append_5("\\'");
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(34))) {
        b.append_5('\\"');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(8))) {
        b.append_5('\\b');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(12))) {
        b.append_5('\\f');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(10))) {
        b.append_5('\\n');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(13))) {
        b.append_5('\\r');
        Unit_getInstance();
      } else if (tmp1_subject.equals(new Char(9))) {
        b.append_5('\\t');
        Unit_getInstance();
      } else {
        b.append_2(c);
        Unit_getInstance();
      }
    }
    b.append_2(new Char(34));
    Unit_getInstance();
  }
  function invalidJson($this, msg) {
    throw new IOException(msg);
  }
  function invalidJson$default($this, msg, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      msg = 'Invalid JSON';
    return invalidJson($this, msg);
  }
  function Json() {
    Json_instance = this;
  }
  Json.prototype.parse_0 = function (s, context) {
    return this.parse_1(StrReader_init_$Create$(s, null, 0, 6, null), context);
  };
  Json.prototype.parse$default = function (s, context, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      context = Companion_getInstance_55()._DEFAULT_1;
    return this.parse_0(s, context);
  };
  Json.prototype.stringify = function (obj, pretty) {
    var tmp;
    if (pretty) {
      var tmp0_apply_0 = Indenter_init_$Create$(null, 1, null);
      Json_getInstance().stringifyPretty(obj, tmp0_apply_0);
      tmp = tmp0_apply_0.toString_3(true, '\t');
    } else {
      var tmp1_apply_0 = StringBuilder_init_$Create$_0();
      Json_getInstance().stringify_0(obj, tmp1_apply_0);
      tmp = tmp1_apply_0.toString();
    }
    return tmp;
  };
  Json.prototype.stringify$default = function (obj, pretty, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      pretty = false;
    return this.stringify(obj, pretty);
  };
  Json.prototype.parse_1 = function (s, context) {
    var ic = s.skipSpaces().read_36();
    var tmp;
    if (ic.equals(new Char(123))) {
      var tmp0_apply_0 = LinkedHashMap_init_$Create$();
      obj: while (true) {
        var tmp0_subject_2 = s.skipSpaces().read_36();
        if (tmp0_subject_2.equals(new Char(125)))
          break obj;
        else if (tmp0_subject_2.equals(new Char(44)))
          continue obj;
        else {
          s.unread$default(0, 1, null);
          Unit_getInstance();
        }
        var tmp_0 = Json_getInstance().parse_1(s, context);
        var key_3 = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
        s.skipSpaces().skipExpect(new Char(58));
        var value_4 = Json_getInstance().parse_1(s, context);
        tmp0_apply_0.put_18(key_3, value_4);
        Unit_getInstance();
      }
      tmp = tmp0_apply_0;
    } else if (ic.equals(new Char(91))) {
      var out = null;
      var outNumber = null;
      array: while (true) {
        var tmp0_subject = s.skipSpaces().read_36();
        if (tmp0_subject.equals(new Char(93)))
          break array;
        else if (tmp0_subject.equals(new Char(44)))
          continue array;
        else {
          s.unread$default(0, 1, null);
          Unit_getInstance();
        }
        var tmp_1;
        if (out == null ? context._optimizedNumericLists : false) {
          var containsArg = s.peek_4();
          tmp_1 = new Char(48) <= containsArg ? containsArg <= new Char(57) : false;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          if (outNumber == null) {
            outNumber = DoubleArrayList_init_$Create$(0, 1, null);
          }outNumber.add_20(parseNumber(this, s));
        } else {
          {
            if (out == null) {
              out = ArrayList_init_$Create$();
            }if (!(outNumber == null)) {
              var tmp1_fastForEach_0 = outNumber;
              var n_1 = 0;
              while (n_1 < tmp1_fastForEach_0._get_size__60()) {
                var tmp0_2 = n_1;
                n_1 = tmp0_2 + 1 | 0;
                var tmp2__anonymous__3 = tmp1_fastForEach_0.getAt_0(tmp0_2);
                out.add_39(tmp2__anonymous__3);
                Unit_getInstance();
              }
              outNumber = null;
            }out.add_39(this.parse_1(s, context));
            Unit_getInstance();
          }
        }
      }
      var tmp1_elvis_lhs = outNumber;
      var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? out : tmp1_elvis_lhs;
      var tmp_2;
      if (tmp2_elvis_lhs == null) {
        tmp_2 = ArrayList_init_$Create$();
      } else {
        tmp_2 = tmp2_elvis_lhs;
      }
      tmp = tmp_2;
    } else if (((((((((((ic.equals(new Char(45)) ? true : ic.equals(new Char(43))) ? true : ic.equals(new Char(48))) ? true : ic.equals(new Char(49))) ? true : ic.equals(new Char(50))) ? true : ic.equals(new Char(51))) ? true : ic.equals(new Char(52))) ? true : ic.equals(new Char(53))) ? true : ic.equals(new Char(54))) ? true : ic.equals(new Char(55))) ? true : ic.equals(new Char(56))) ? true : ic.equals(new Char(57))) {
      s.unread$default(0, 1, null);
      Unit_getInstance();
      var dres = parseNumber(this, s);
      tmp = numberToInt(dres) === dres ? numberToInt(dres) : dres;
    } else if ((ic.equals(new Char(116)) ? true : ic.equals(new Char(102))) ? true : ic.equals(new Char(110))) {
      s.unread$default(0, 1, null);
      Unit_getInstance();
      var tmp_3;
      if (s.tryRead_1('true')) {
        tmp_3 = true;
      } else if (s.tryRead_1('false')) {
        tmp_3 = false;
      } else if (s.tryRead_1('null')) {
        tmp_3 = null;
      } else {
        invalidJson$default(this, null, 2, null);
      }
      tmp = tmp_3;
    } else if (ic.equals(new Char(34))) {
      s.unread$default(0, 1, null);
      Unit_getInstance();
      tmp = s.readStringLit$default(false, 1, null);
    } else {
      invalidJson(this, '' + "Not expected '" + ic + "'");
    }
    return tmp;
  };
  Json.prototype.stringify_0 = function (obj, b) {
    var tmp0_subject = obj;
    if (tmp0_subject == null) {
      b.append_5('null');
      Unit_getInstance();
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
        b.append_5(obj ? 'true' : 'false');
        Unit_getInstance();
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Map_0) : false) {
          b.append_2(new Char(123));
          Unit_getInstance();
          var iterator_0 = obj._get_entries__10().iterator_67();
          var index = 0;
          while (iterator_0.hasNext_33()) {
            var i = index;
            index = index + 1 | 0;
            var v = iterator_0.next_37();
            if (!(i === 0)) {
              b.append_2(new Char(44));
              Unit_getInstance();
            }this.stringify_0(v._get_key__37(), b);
            b.append_2(new Char(58));
            Unit_getInstance();
            this.stringify_0(v._get_value__10(), b);
          }
          b.append_2(new Char(125));
          Unit_getInstance();
        } else {
          if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Iterable) : false) {
            b.append_2(new Char(91));
            Unit_getInstance();
            var iterator_1 = obj.iterator_67();
            var index_0 = 0;
            while (iterator_1.hasNext_33()) {
              var i_0 = index_0;
              index_0 = index_0 + 1 | 0;
              var v_0 = iterator_1.next_37();
              if (!(i_0 === 0)) {
                b.append_2(new Char(44));
                Unit_getInstance();
              }this.stringify_0(v_0, b);
            }
            b.append_2(new Char(93));
            Unit_getInstance();
          } else {
            if (tmp0_subject instanceof Enum)
              encodeString_0(this, obj._name, b);
            else {
              if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false)
                encodeString_0(this, obj, b);
              else {
                if (isNumber(tmp0_subject)) {
                  b.append_5('' + obj);
                  Unit_getInstance();
                } else {
                  if (!(tmp0_subject == null) ? isInterface(tmp0_subject, CustomSerializer) : false)
                    obj.encodeToJson(b);
                  else {
                    {
                      invalidOp('' + "Don't know how to serialize " + obj);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  Json.prototype.stringifyPretty = function (obj, b) {
    var tmp0_subject = obj;
    if (tmp0_subject == null) {
      b.inline('null');
      Unit_getInstance();
    } else {
      if (!(tmp0_subject == null) ? typeof tmp0_subject === 'boolean' : false) {
        b.inline(obj ? 'true' : 'false');
        Unit_getInstance();
      } else {
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Map_0) : false) {
          b.line_0('{');
          Unit_getInstance();
          b._indent();
          try {
            var entries_2 = obj._get_entries__10();
            var iterator_0 = entries_2.iterator_67();
            var index = 0;
            while (iterator_0.hasNext_33()) {
              var i_5 = index;
              index = index + 1 | 0;
              var v_6 = iterator_0.next_37();
              if (!(i_5 === 0)) {
                b.line_0(',');
                Unit_getInstance();
              }b.inline(encodeString(Json_getInstance(), '' + v_6._get_key__37()));
              Unit_getInstance();
              b.inline(': ');
              Unit_getInstance();
              Json_getInstance().stringifyPretty(v_6._get_value__10(), b);
              if (i_5 === (entries_2._get_size__60() - 1 | 0)) {
                b.line_0('');
                Unit_getInstance();
              }}
          }finally {
            b._unindent();
          }
          Unit_getInstance();
          b.inline('}');
          Unit_getInstance();
        } else {
          if (!(tmp0_subject == null) ? isInterface(tmp0_subject, Iterable) : false) {
            b.line_0('[');
            Unit_getInstance();
            b._indent();
            try {
              var entries_2_0 = toList_2(obj);
              var iterator_1 = entries_2_0.iterator_67();
              var index_0 = 0;
              while (iterator_1.hasNext_33()) {
                var i_5_0 = index_0;
                index_0 = index_0 + 1 | 0;
                var v_6_0 = iterator_1.next_37();
                if (!(i_5_0 === 0)) {
                  b.line_0(',');
                  Unit_getInstance();
                }Json_getInstance().stringifyPretty(v_6_0, b);
                if (i_5_0 === (entries_2_0._get_size__60() - 1 | 0)) {
                  b.line_0('');
                  Unit_getInstance();
                }}
            }finally {
              b._unindent();
            }
            Unit_getInstance();
            b.inline(']');
            Unit_getInstance();
          } else {
            if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
              b.inline(encodeString(this, obj));
              Unit_getInstance();
            } else {
              if (isNumber(tmp0_subject)) {
                b.inline('' + obj);
                Unit_getInstance();
              } else {
                if (!(tmp0_subject == null) ? isInterface(tmp0_subject, CustomSerializer) : false) {
                  var tmp0_apply_0 = StringBuilder_init_$Create$_0();
                  obj.encodeToJson(tmp0_apply_0);
                  b.inline(tmp0_apply_0.toString());
                  Unit_getInstance();
                } else {
                  {
                    invalidOp('' + "Don't know how to serialize " + obj);
                  }
                }
              }
            }
          }
        }
      }
    }
  };
  Json.$metadata$ = {
    simpleName: 'Json',
    kind: 'object',
    interfaces: []
  };
  var Json_instance;
  function Json_getInstance() {
    if (Json_instance == null)
      new Json();
    return Json_instance;
  }
  function parse$level($stream) {
    var children_0 = ArrayList_init_$Create$();
    while ($stream.hasNext_33()) {
      var tag = $stream.next_37();
      var tmp0_subject = tag;
      if (tmp0_subject instanceof ProcessingInstructionTag)
        Unit_getInstance();
      else {
        if (tmp0_subject instanceof CommentTag) {
          children_0.add_39(Companion_getInstance_56().Comment(tag._text));
          Unit_getInstance();
        } else {
          if (tmp0_subject instanceof Text_0) {
            children_0.add_39(tag._cdata ? Companion_getInstance_56().CData(tag._text_0) : Companion_getInstance_56().Text(tag._text_0));
            Unit_getInstance();
          } else {
            if (tmp0_subject instanceof OpenCloseTag) {
              var tmp = Companion_getInstance_56();
              var tmp_0 = tag._name_8;
              var tmp_1 = tag._attributes_0;
              children_0.add_39(tmp.Tag(tmp_0, tmp_1, emptyList()));
              Unit_getInstance();
            } else {
              if (tmp0_subject instanceof OpenTag) {
                var out = parse$level($stream);
                var tmp1_safe_receiver = out._close;
                if (!((tmp1_safe_receiver == null ? null : tmp1_safe_receiver._name_10) === tag._name_9)) {
                  var tmp_2 = tag._name_9;
                  var tmp2_safe_receiver = out._close;
                  throw IllegalArgumentException_init_$Create$('' + 'Expected ' + tmp_2 + ' but was ' + (tmp2_safe_receiver == null ? null : tmp2_safe_receiver._name_10));
                } else {
                }
                children_0.add_39(new Xml(Type_NODE_getInstance(), tag._name_9, tag._attributes_1, out._children_3, ''));
                Unit_getInstance();
              } else {
                if (tmp0_subject instanceof CloseTag)
                  return new Level_0(children_0, tag);
                else {
                  throw IllegalArgumentException_init_$Create$('' + 'Unhandled ' + tag);
                }
              }
            }
          }
        }
      }
    }
    return new Level_0(children_0, null);
  }
  function Level_0(children_0, close) {
    this._children_3 = children_0;
    this._close = close;
  }
  Level_0.prototype.toString = function () {
    return '' + 'Level(children=' + this._children_3 + ', close=' + this._close + ')';
  };
  Level_0.prototype.hashCode = function () {
    var result = hashCode(this._children_3);
    result = imul(result, 31) + (this._close == null ? 0 : hashCode(this._close)) | 0;
    return result;
  };
  Level_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Level_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Level_0 ? other : THROW_CCE();
    if (!equals_1(this._children_3, tmp0_other_with_cast._children_3))
      return false;
    if (!equals_1(this._close, tmp0_other_with_cast._close))
      return false;
    return true;
  };
  Level_0.$metadata$ = {
    simpleName: 'Level',
    kind: 'class',
    interfaces: []
  };
  var Type_NODE_instance;
  var Type_TEXT_instance;
  var Type_COMMENT_instance;
  var Type_entriesInitialized;
  function Type_initEntries() {
    if (Type_entriesInitialized)
      return Unit_getInstance();
    Type_entriesInitialized = true;
    Type_NODE_instance = new Type('NODE', 0);
    Type_TEXT_instance = new Type('TEXT', 1);
    Type_COMMENT_instance = new Type('COMMENT', 2);
  }
  function ProcessingInstructionTag(name, attributes) {
    Element_1.call(this);
    this._name_7 = name;
    this._attributes = attributes;
  }
  ProcessingInstructionTag.$metadata$ = {
    simpleName: 'ProcessingInstructionTag',
    kind: 'class',
    interfaces: []
  };
  function OpenCloseTag(name, attributes) {
    Element_1.call(this);
    this._name_8 = name;
    this._attributes_0 = attributes;
  }
  OpenCloseTag.$metadata$ = {
    simpleName: 'OpenCloseTag',
    kind: 'class',
    interfaces: []
  };
  function OpenTag(name, attributes) {
    Element_1.call(this);
    this._name_9 = name;
    this._attributes_1 = attributes;
  }
  OpenTag.$metadata$ = {
    simpleName: 'OpenTag',
    kind: 'class',
    interfaces: []
  };
  function CommentTag(text) {
    Element_1.call(this);
    this._text = text;
  }
  CommentTag.$metadata$ = {
    simpleName: 'CommentTag',
    kind: 'class',
    interfaces: []
  };
  function CloseTag(name) {
    Element_1.call(this);
    this._name_10 = name;
  }
  CloseTag.$metadata$ = {
    simpleName: 'CloseTag',
    kind: 'class',
    interfaces: []
  };
  function Text_0(text) {
    Element_1.call(this);
    this._text_0 = text;
    this._cdata = false;
  }
  Text_0.$metadata$ = {
    simpleName: 'Text',
    kind: 'class',
    interfaces: []
  };
  function matchStringOrId(_this_, $this) {
    var tmp0_elvis_lhs = _this_.matchSingleOrDoubleQuoteString();
    return tmp0_elvis_lhs == null ? _this_.matchIdentifier() : tmp0_elvis_lhs;
  }
  function xmlSequence($this, r) {
    return sequence(_no_name_provided_$factory_99(r, null));
  }
  function Xml2Iterable(reader2) {
    this._reader2 = reader2;
    this._reader_1 = this._reader2.clone_8();
  }
  Xml2Iterable.prototype.iterator_67 = function () {
    return xmlSequence(Stream_getInstance(), this._reader_1).iterator_67();
  };
  Xml2Iterable.$metadata$ = {
    simpleName: 'Xml2Iterable',
    kind: 'class',
    interfaces: [Iterable]
  };
  function Element_1() {
  }
  Element_1.$metadata$ = {
    simpleName: 'Element',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__128($r, resultContinuation) {
    this._$r = $r;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__128.prototype.invoke_211 = function ($this$sequence, $cont) {
    var tmp = this.create_11($this$sequence, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__128.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_211(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__128.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!!this._$r._get_eof__0()) {
              this._state_1 = 7;
              continue $sm;
            }
            var tmp_0 = this;
            var tmp0_elvis_lhs = this._$r.readUntil(new Char(60));
            tmp_0._str0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            if (charSequenceLength(this._str0) > 0) {
              this._state_1 = 2;
              suspendResult = this._$this$sequence_0.yield_0(new Text_0(Entities_getInstance().decode_11(this._str0)), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 3;
                continue $sm;
              }
            }

            break;
          case 2:
            suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            if (this._$r._get_eof__0()) {
              this._state_1 = 7;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            this._$r.skipExpect(new Char(60));
            this._res1 = null;
            if (this._$r.tryExpect('![CDATA[')) {
              var start = this._$r._pos_0;
              $l$break: while (!this._$r._get_eof__0()) {
                var end = this._$r._pos_0;
                if (this._$r.tryExpect(']]>')) {
                  var tmp_1 = this;
                  var tmp0_also_0 = new Text_0(this._$r.createRange_0(start, end)._get_text__2());
                  tmp0_also_0._cdata = true;
                  tmp_1._res1 = tmp0_also_0;
                  break $l$break;
                }this._$r.readChar_0();
                Unit_getInstance();
              }
            } else if (this._$r.tryExpect('!--')) {
              var start_0 = this._$r._pos_0;
              $l$break_0: while (!this._$r._get_eof__0()) {
                var end_0 = this._$r._pos_0;
                if (this._$r.tryExpect('-->')) {
                  this._res1 = new CommentTag(this._$r.createRange_0(start_0, end_0)._get_text__2());
                  break $l$break_0;
                }this._$r.readChar_0();
                Unit_getInstance();
              }
            } else {
              this._$r.skipSpaces();
              Unit_getInstance();
              var processingInstruction = this._$r.tryExpect_0(new Char(63));
              var processingEntityOrDocType = this._$r.tryExpect_0(new Char(33));
              var close = this._$r.tryExpect_0(new Char(47)) ? true : processingEntityOrDocType;
              this._$r.skipSpaces();
              Unit_getInstance();
              var tmp1_elvis_lhs = this._$r.matchIdentifier();
              var tmp_2;
              if (tmp1_elvis_lhs == null) {
                var tmp1_error_0 = '' + "Couldn't match identifier after '<', offset=" + this._$r._pos_0 + ", around='" + this._$r.peek_3(10) + "'";
                throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
              } else {
                tmp_2 = tmp1_elvis_lhs;
              }
              var name = tmp_2;
              this._$r.skipSpaces();
              Unit_getInstance();
              var attributes = LinkedHashMap_init_$Create$();
              while ((!this._$r.peekChar_0().equals(new Char(63)) ? !this._$r.peekChar_0().equals(new Char(47)) : false) ? !this._$r.peekChar_0().equals(new Char(62)) : false) {
                var tmp2_elvis_lhs = matchStringOrId(this._$r, Stream_getInstance());
                var tmp_3;
                if (tmp2_elvis_lhs == null) {
                  throw IllegalArgumentException_init_$Create$('' + 'Malformed document or unsupported xml construct around ~' + this._$r.peek_3(10) + "~ for name '" + name + "'");
                } else {
                  tmp_3 = tmp2_elvis_lhs;
                }
                var key = tmp_3;
                this._$r.skipSpaces();
                Unit_getInstance();
                if (this._$r.tryExpect('=')) {
                  this._$r.skipSpaces();
                  Unit_getInstance();
                  var argsQuote = matchStringOrId(this._$r, Stream_getInstance());
                  var tmp_4;
                  if (!(argsQuote == null)) {
                    var tmp_5 = Entities_getInstance();
                    var tmp2_substring_0 = 1;
                    var tmp3_substring_0 = argsQuote.length - 1 | 0;
                    tmp_4 = tmp_5.decode_11(argsQuote.substring(tmp2_substring_0, tmp3_substring_0));
                  } else {
                    tmp_4 = Entities_getInstance().decode_11(ensureNotNull(this._$r.matchIdentifier()));
                  }
                  var tmp4_set_0 = tmp_4;
                  attributes.put_18(key, tmp4_set_0);
                  Unit_getInstance();
                } else {
                  attributes.put_18(key, key);
                  Unit_getInstance();
                }
                this._$r.skipSpaces();
                Unit_getInstance();
              }
              var openclose = this._$r.tryExpect_0(new Char(47));
              var processingInstructionEnd = this._$r.tryExpect_0(new Char(63));
              this._$r.skipExpect(new Char(62));
              this._res1 = (processingInstruction ? true : processingEntityOrDocType) ? new ProcessingInstructionTag(name, attributes) : openclose ? new OpenCloseTag(name, attributes) : close ? new CloseTag(name) : new OpenTag(name, attributes);
            }

            if (!(this._res1 == null)) {
              this._state_1 = 5;
              suspendResult = this._$this$sequence_0.yield_0(this._res1, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 5:
            suspendResult;
            this._state_1 = 6;
            continue $sm;
          case 6:
            this._state_1 = 1;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 8) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__128.prototype.create_11 = function ($this$sequence, completion) {
    var i = new _no_name_provided__128(this._$r, completion);
    i._$this$sequence_0 = $this$sequence;
    return i;
  };
  _no_name_provided__128.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function Companion_57() {
    Companion_instance_56 = this;
    this._NAME_RAW = '_raw_';
    this._NAME_TEXT = '_text_';
    this._NAME_CDATA = '_cdata_';
    this._NAME_COMMENT = '_comment_';
  }
  Companion_57.prototype.Tag = function (tagName, attributes, children_0) {
    var tmp = Type_NODE_getInstance();
    var tmp0_filterTo_0_1 = LinkedHashMap_init_$Create$();
    var tmp0_iterator_1_2 = attributes._get_entries__10().iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var element_2_3 = tmp0_iterator_1_2.next_37();
      if (!(element_2_3._get_value__10() == null)) {
        tmp0_filterTo_0_1.put_18(element_2_3._get_key__37(), element_2_3._get_value__10());
        Unit_getInstance();
      } else {
      }
    }
    var tmp0_map_0 = tmp0_filterTo_0_1;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0._get_size__60());
    var tmp0_iterator_1_2_0 = tmp0_map_0._get_entries__10().iterator_67();
    while (tmp0_iterator_1_2_0.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_37();
      tmp0_mapTo_0_1.add_39(to(item_2_3._get_key__37(), toString_0(item_2_3._get_value__10())));
      Unit_getInstance();
    }
    return new Xml(tmp, tagName, toMap_0(tmp0_mapTo_0_1), children_0, '');
  };
  Companion_57.prototype.Text = function (text) {
    var tmp = Type_TEXT_getInstance();
    var tmp_0 = LinkedHashMap_init_$Create$();
    return new Xml(tmp, '_text_', tmp_0, emptyList(), text);
  };
  Companion_57.prototype.CData = function (text) {
    var tmp = Type_TEXT_getInstance();
    var tmp_0 = LinkedHashMap_init_$Create$();
    return new Xml(tmp, '_cdata_', tmp_0, emptyList(), text);
  };
  Companion_57.prototype.Comment = function (text) {
    var tmp = Type_COMMENT_getInstance();
    var tmp_0 = LinkedHashMap_init_$Create$();
    return new Xml(tmp, '_comment_', tmp_0, emptyList(), text);
  };
  Companion_57.prototype.parse_3 = function (str) {
    try {
      var stream = Stream_getInstance().parse_3(str).iterator_67();
      var children_0 = parse$level(stream)._children_3;
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_iterator_1 = children_0.iterator_67();
        while (tmp0_iterator_1.hasNext_33()) {
          var element_2 = tmp0_iterator_1.next_37();
          if (element_2._type.equals(Type_NODE_getInstance())) {
            tmp$ret$0 = element_2;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = null;
      }
       while (false);
      var tmp0_elvis_lhs = tmp$ret$0;
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(children_0) : tmp0_elvis_lhs;
      return tmp1_elvis_lhs == null ? Companion_getInstance_56().Text('') : tmp1_elvis_lhs;
    } catch ($p) {
      if ($p instanceof NoSuchElementException) {
        println('' + 'ERROR: XML: ' + str + ' thrown a NoSuchElementException');
        return Companion_getInstance_56().Text('!!ERRORED!!');
      } else {
        {
          throw $p;
        }
      }
    }
  };
  Companion_57.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_56;
  function Companion_getInstance_56() {
    if (Companion_instance_56 == null)
      new Companion_57();
    return Companion_instance_56;
  }
  function Type(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Entities() {
    Entities_instance = this;
    this._charToEntity = linkedMapOf([to(new Char(34), '&quot;'), to(new Char(39), '&apos;'), to(new Char(60), '&lt;'), to(new Char(62), '&gt;'), to(new Char(38), '&amp;')]);
    var tmp = this;
    var tmp_0 = Companion_getInstance_58();
    var tmp0_toTypedArray_0 = this._charToEntity._get_values__9();
    tmp._entities = tmp_0.fromList(copyToArray_0(tmp0_toTypedArray_0));
    this._entityToChar = flip(this._charToEntity);
  }
  Entities.prototype.encode_8 = function (str) {
    var tmp0_apply_0_1_1 = StringBuilder_init_$Create$_0();
    var inductionVariable = 0;
    var last_1 = str.length;
    if (inductionVariable < last_1)
      do {
        var n_4_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__anonymous__4 = charSequenceGet(str, n_4_3);
        var entry_5 = Entities_getInstance()._charToEntity.get_116(tmp0__anonymous__4);
        if (!(entry_5 == null)) {
          tmp0_apply_0_1_1.append_5(entry_5);
          Unit_getInstance();
        } else {
          tmp0_apply_0_1_1.append_2(tmp0__anonymous__4);
          Unit_getInstance();
        }
      }
       while (inductionVariable < last_1);
    return tmp0_apply_0_1_1.toString();
  };
  Entities.prototype.decode_11 = function (str) {
    return this.decode_12(StrReader_init_$Create$(str, null, 0, 6, null));
  };
  Entities.prototype.decode_12 = function (r) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    $l$break: while (!r._get_eof__0()) {
      var plain_3 = r.readUntil(new Char(38));
      if (!(plain_3 == null)) {
        tmp0_apply_0_1.append_5(plain_3);
        Unit_getInstance();
      }if (r._get_eof__0())
        break $l$break;
      r.skipExpect(new Char(38));
      var tmp0_elvis_lhs_5 = r.readUntilIncluded(new Char(59));
      var value_4 = tmp0_elvis_lhs_5 == null ? '' : tmp0_elvis_lhs_5;
      var full_6 = '' + '&' + value_4;
      var tmp = new Char(35);
      if (startsWith$default(value_4, tmp, false, 2, null)) {
        var tmp0_substring_0_7 = 1;
        var tmp1_substring_0_8 = value_4.length - 1 | 0;
        tmp0_apply_0_1.append_2(numberToChar(toInt(value_4.substring(tmp0_substring_0_7, tmp1_substring_0_8))));
        Unit_getInstance();
      } else {
        var tmp2_contains_0_9 = Entities_getInstance()._entityToChar;
        if ((isInterface(tmp2_contains_0_9, Map_0) ? tmp2_contains_0_9 : THROW_CCE()).containsKey_11(full_6)) {
          tmp0_apply_0_1.append_4(Entities_getInstance()._entityToChar.get_116(full_6));
          Unit_getInstance();
        } else {
          {
            tmp0_apply_0_1.append_5(full_6);
            Unit_getInstance();
          }
        }
      }
    }
    return tmp0_apply_0_1.toString();
  };
  Entities.$metadata$ = {
    simpleName: 'Entities',
    kind: 'object',
    interfaces: []
  };
  var Entities_instance;
  function Entities_getInstance() {
    if (Entities_instance == null)
      new Entities();
    return Entities_instance;
  }
  function Stream() {
    Stream_instance = this;
  }
  Stream.prototype.parse_3 = function (str) {
    return this.parse_4(StrReader_init_$Create$(str, null, 0, 6, null));
  };
  Stream.prototype.parse_4 = function (r) {
    return new Xml2Iterable(r);
  };
  Stream.$metadata$ = {
    simpleName: 'Stream',
    kind: 'object',
    interfaces: []
  };
  var Stream_instance;
  function Stream_getInstance() {
    if (Stream_instance == null)
      new Stream();
    return Stream_instance;
  }
  function Type_NODE_getInstance() {
    Type_initEntries();
    return Type_NODE_instance;
  }
  function Type_TEXT_getInstance() {
    Type_initEntries();
    return Type_TEXT_instance;
  }
  function Type_COMMENT_getInstance() {
    Type_initEntries();
    return Type_COMMENT_instance;
  }
  function Xml(type, name, attributes, allChildren, content) {
    Companion_getInstance_56();
    this._type = type;
    this._name_11 = name;
    this._attributes_2 = attributes;
    this._allChildren = allChildren;
    this._content_3 = content;
    this._attributesLC = toCaseInsensitiveMap(this._attributes_2);
    var tmp = this;
    var tmp0_toLowerCase_0 = this._name_11;
    var tmp1_trim_0 = tmp0_toLowerCase_0.toLowerCase();
    tmp._nameLC_0 = toString_1(trim_0(isCharSequence(tmp1_trim_0) ? tmp1_trim_0 : THROW_CCE()));
  }
  Xml.prototype._get_attributesStr_ = function () {
    var tmp0_map_0 = toList_3(this._attributes_2);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39('' + ' ' + item_2_3._first + '="' + item_2_3._second + '"');
      Unit_getInstance();
    }
    return joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, null, 62, null);
  };
  Xml.prototype._get_outerXml_ = function () {
    var tmp0_subject = this._type;
    var tmp;
    if (tmp0_subject.equals(Type_NODE_getInstance())) {
      var tmp_0;
      if (this._allChildren.isEmpty_53()) {
        tmp_0 = '' + '<' + this._name_11 + this._get_attributesStr_() + '/>';
      } else {
        var tmp0_map_0 = this._allChildren;
        var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
        var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
        while (tmp0_iterator_1_2.hasNext_33()) {
          var item_2_3 = tmp0_iterator_1_2.next_37();
          tmp0_mapTo_0_1.add_39(item_2_3._get_outerXml_());
          Unit_getInstance();
        }
        var children_0 = joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, null, 62, null);
        tmp_0 = '' + '<' + this._name_11 + this._get_attributesStr_() + '>' + children_0 + '<\/' + this._name_11 + '>';
      }
      tmp = tmp_0;
    } else if (tmp0_subject.equals(Type_TEXT_getInstance())) {
      var tmp1_subject = this._name_11;
      switch (tmp1_subject) {
        case '_text_':
          tmp = Entities_getInstance().encode_8(this._content_3);
          break;
        case '_cdata_':
          tmp = '' + '<![CDATA[' + this._content_3 + ']]>';
          break;
        case '_raw_':
          tmp = this._content_3;
          break;
        default:tmp = this._content_3;
          break;
      }
    } else if (tmp0_subject.equals(Type_COMMENT_getInstance())) {
      tmp = '' + '<!--' + this._content_3 + '-->';
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  Xml.prototype.get_115 = function (name) {
    return this.children_0(name);
  };
  Xml.prototype.children_0 = function (name) {
    var tmp0_filter_0 = this._allChildren;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_filter_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var element_2_3 = tmp0_iterator_1_2.next_37();
      if (equals_0(element_2_3._name_11, name, true)) {
        tmp0_filterTo_0_1.add_39(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    return tmp0_filterTo_0_1;
  };
  Xml.prototype.double = function (name, defaultValue) {
    var tmp0_safe_receiver = this._attributesLC.get_116(name);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toDoubleOrNull(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? defaultValue : tmp1_elvis_lhs;
  };
  Xml.prototype.int_0 = function (name, defaultValue) {
    var tmp0_safe_receiver = this._attributesLC.get_116(name);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toIntOrNull(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? defaultValue : tmp1_elvis_lhs;
  };
  Xml.prototype.int$default = function (name, defaultValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      defaultValue = 0;
    return this.int_0(name, defaultValue);
  };
  Xml.prototype.str_0 = function (name, defaultValue) {
    var tmp0_elvis_lhs = this._attributesLC.get_116(name);
    return tmp0_elvis_lhs == null ? defaultValue : tmp0_elvis_lhs;
  };
  Xml.prototype.str$default = function (name, defaultValue, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      defaultValue = '';
    return this.str_0(name, defaultValue);
  };
  Xml.prototype.toString = function () {
    return this._get_outerXml_();
  };
  Xml.prototype.hashCode = function () {
    var result = this._type.hashCode();
    result = imul(result, 31) + getStringHashCode(this._name_11) | 0;
    result = imul(result, 31) + hashCode(this._attributes_2) | 0;
    result = imul(result, 31) + hashCode(this._allChildren) | 0;
    result = imul(result, 31) + getStringHashCode(this._content_3) | 0;
    return result;
  };
  Xml.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Xml))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Xml ? other : THROW_CCE();
    if (!this._type.equals(tmp0_other_with_cast._type))
      return false;
    if (!(this._name_11 === tmp0_other_with_cast._name_11))
      return false;
    if (!equals_1(this._attributes_2, tmp0_other_with_cast._attributes_2))
      return false;
    if (!equals_1(this._allChildren, tmp0_other_with_cast._allChildren))
      return false;
    if (!(this._content_3 === tmp0_other_with_cast._content_3))
      return false;
    return true;
  };
  Xml.$metadata$ = {
    simpleName: 'Xml',
    kind: 'class',
    interfaces: []
  };
  function Xml_0(str) {
    return Companion_getInstance_56().parse_3(str);
  }
  function children(_this_, name) {
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = _this_.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var element_2_3 = tmp0_iterator_1_2.next_37();
      var list_3_4 = element_2_3.children_0(name);
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    return tmp0_flatMapTo_0_1;
  }
  function get_0(_this_, name) {
    return children(_this_, name);
  }
  function _no_name_provided_$factory_99($r, resultContinuation) {
    var i = new _no_name_provided__128($r, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_211(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  var EMPTY_BYTE_ARRAY;
  function AsyncStream_init_$Init$(base, position_1, queue, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      position_1 = new Long(0, 0);
    if (!(($mask0 & 4) === 0))
      queue = false;
    AsyncStream.call($this, base, position_1, queue);
    return $this;
  }
  function AsyncStream_init_$Create$(base, position_1, queue, $mask0, $marker) {
    return AsyncStream_init_$Init$(base, position_1, queue, $mask0, $marker, Object.create(AsyncStream.prototype));
  }
  function _get_readQueue_($this) {
    var tmp0_getValue_0 = $this._readQueue$delegate;
    var tmp1_getValue_0 = readQueue$factory();
    return tmp0_getValue_0._get_value__10();
  }
  function _get_writeQueue_($this) {
    var tmp0_getValue_0 = $this._writeQueue$delegate;
    var tmp1_getValue_0 = writeQueue$factory();
    return tmp0_getValue_0._get_value__10();
  }
  function readInternal($this, buffer, offset, len, $cont) {
    var tmp = new $readInternalCOROUTINE$131($this, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function writeInternal($this, buffer, offset, len, $cont) {
    var tmp = new $writeInternalCOROUTINE$132($this, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function _no_name_provided__129() {
  }
  _no_name_provided__129.prototype.invoke_1005 = function () {
    return new AsyncThread();
  };
  _no_name_provided__129.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__130() {
  }
  _no_name_provided__130.prototype.invoke_1005 = function () {
    return new AsyncThread();
  };
  _no_name_provided__130.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__131(this$0, $buffer, $offset, $len, resultContinuation) {
    this._this$0_35 = this$0;
    this._$buffer = $buffer;
    this._$offset = $offset;
    this._$len = $len;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__131.prototype.invoke_1005 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__131.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readInternal(this._this$0_35, this._$buffer, this._$offset, this._$len, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__131.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__131(this._this$0_35, this._$buffer, this._$offset, this._$len, completion);
    return i;
  };
  _no_name_provided__131.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__132(this$0, $buffer, $offset, $len, resultContinuation) {
    this._this$0_36 = this$0;
    this._$buffer_0 = $buffer;
    this._$offset_0 = $offset;
    this._$len_0 = $len;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__132.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__132.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__132.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = writeInternal(this._this$0_36, this._$buffer_0, this._$offset_0, this._$len_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__132.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__132(this._this$0_36, this._$buffer_0, this._$offset_0, this._$len_0, completion);
    return i;
  };
  _no_name_provided__132.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $readCOROUTINE$129(_this_, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__62 = _this_;
    this._buffer_12 = buffer;
    this._offset_9 = offset;
    this._len_6 = len;
  }
  $readCOROUTINE$129.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            if (this.__this__62._queue_1) {
              this._state_1 = 2;
              var tmp_0 = _get_readQueue_(this.__this__62);
              suspendResult = tmp_0.invoke_128(_no_name_provided_$factory_102(this.__this__62, this._buffer_12, this._offset_9, this._len_6, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = readInternal(this.__this__62, this._buffer_12, this._offset_9, this._len_6, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT0 = suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._WHEN_RESULT0 = suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            return this._WHEN_RESULT0;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$129.$metadata$ = {
    simpleName: '$readCOROUTINE$129',
    kind: 'class',
    interfaces: []
  };
  function $writeCOROUTINE$130(_this_, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__63 = _this_;
    this._buffer_13 = buffer;
    this._offset_10 = offset;
    this._len_7 = len;
  }
  $writeCOROUTINE$130.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            if (this.__this__63._queue_1) {
              this._state_1 = 2;
              var tmp_0 = _get_writeQueue_(this.__this__63);
              suspendResult = tmp_0.invoke_128(_no_name_provided_$factory_103(this.__this__63, this._buffer_13, this._offset_10, this._len_7, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = writeInternal(this.__this__63, this._buffer_13, this._offset_10, this._len_7, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$130.$metadata$ = {
    simpleName: '$writeCOROUTINE$130',
    kind: 'class',
    interfaces: []
  };
  function $readInternalCOROUTINE$131(_this_, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__64 = _this_;
    this._buffer_14 = buffer;
    this._offset_11 = offset;
    this._len_8 = len;
  }
  $readInternalCOROUTINE$131.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__64._base.read_37(this.__this__64._position_3, this._buffer_14, this._offset_11, this._len_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var read_1 = suspendResult;
            if (read_1 >= 0) {
              var tmp0_this = this.__this__64;
              var tmp_0 = tmp0_this;
              var tmp0_plus_0 = tmp0_this._position_3;
              tmp_0._position_3 = tmp0_plus_0.plus_64(toLong(read_1));
            }
            return read_1;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readInternalCOROUTINE$131.$metadata$ = {
    simpleName: '$readInternalCOROUTINE$131',
    kind: 'class',
    interfaces: []
  };
  function $writeInternalCOROUTINE$132(_this_, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__65 = _this_;
    this._buffer_15 = buffer;
    this._offset_12 = offset;
    this._len_9 = len;
  }
  $writeInternalCOROUTINE$132.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__65._base.write_30(this.__this__65._position_3, this._buffer_15, this._offset_12, this._len_9, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            var tmp0_this = this.__this__65;
            var tmp_0 = tmp0_this;
            var tmp0_plus_0 = tmp0_this._position_3;
            tmp_0._position_3 = tmp0_plus_0.plus_64(toLong(this._len_9));
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeInternalCOROUTINE$132.$metadata$ = {
    simpleName: '$writeInternalCOROUTINE$132',
    kind: 'class',
    interfaces: []
  };
  function $getAvailableCOROUTINE$133(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__66 = _this_;
  }
  $getAvailableCOROUTINE$133.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__66.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_13 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__66.getPosition_5(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this._ARGUMENT0_13.minus_29(ARGUMENT);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getAvailableCOROUTINE$133.$metadata$ = {
    simpleName: '$getAvailableCOROUTINE$133',
    kind: 'class',
    interfaces: []
  };
  function $eofCOROUTINE$134(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__67 = _this_;
  }
  $eofCOROUTINE$134.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__67.getAvailable(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.compareTo_137(new Long(0, 0)) <= 0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $eofCOROUTINE$134.$metadata$ = {
    simpleName: '$eofCOROUTINE$134',
    kind: 'class',
    interfaces: []
  };
  function AsyncStream(base, position_1, queue) {
    this._base = base;
    this._position_3 = position_1;
    this._queue_1 = queue;
    var tmp = this;
    tmp._$$delegate_0_2 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._readQueue$delegate = lazy(_no_name_provided_$factory_100());
    var tmp_1 = this;
    tmp_1._writeQueue$delegate = lazy(_no_name_provided_$factory_101());
  }
  AsyncStream.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_2._extra = _set___;
  };
  AsyncStream.prototype._get_extra__71 = function () {
    return this._$$delegate_0_2._extra;
  };
  AsyncStream.prototype.read_30 = function (buffer, offset, len, $cont) {
    var tmp = new $readCOROUTINE$129(this, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncStream.prototype.write_25 = function (buffer, offset, len, $cont) {
    var tmp = new $writeCOROUTINE$130(this, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncStream.prototype.setPosition_0 = function (value, $cont) {
    this._position_3 = value;
  };
  AsyncStream.prototype.getPosition_5 = function ($cont) {
    return this._position_3;
  };
  AsyncStream.prototype.getLength_14 = function ($cont) {
    return this._base.getLength_14($cont);
  };
  AsyncStream.prototype.getAvailable = function ($cont) {
    var tmp = new $getAvailableCOROUTINE$133(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncStream.prototype.eof_0 = function ($cont) {
    var tmp = new $eofCOROUTINE$134(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncStream.prototype.close_77 = function ($cont) {
    return this._base.close_77($cont);
  };
  AsyncStream.prototype.duplicate = function () {
    var tmp = this._position_3;
    return AsyncStream_init_$Create$(this._base, tmp, false, 4, null);
  };
  AsyncStream.$metadata$ = {
    simpleName: 'AsyncStream',
    kind: 'class',
    interfaces: [Extra, AsyncInputStream, AsyncInputStreamWithLength, AsyncOutputStream, AsyncPositionLengthStream, AsyncCloseable]
  };
  function buffered(_this_, blockSize, blocksToRead) {
    return toAsyncStream(new BufferedStreamBase(_this_._base, blockSize, blocksToRead), _this_._position_3);
  }
  function buffered$default(_this_, blockSize, blocksToRead, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      blockSize = 2048;
    if (!(($mask0 & 2) === 0))
      blocksToRead = 16;
    return buffered(_this_, blockSize, blocksToRead);
  }
  function toAsyncStream(_this_, position_1) {
    return AsyncStream_init_$Create$(_this_, position_1, false, 4, null);
  }
  function toAsyncStream$default(_this_, position_1, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      position_1 = new Long(0, 0);
    return toAsyncStream(_this_, position_1);
  }
  function AsyncStreamBase() {
  }
  AsyncStreamBase.prototype.read_37 = function (position_1, buffer, offset, len, $cont) {
    throw UnsupportedOperationException_init_$Create$();
  };
  AsyncStreamBase.prototype.write_30 = function (position_1, buffer, offset, len, $cont) {
    throw UnsupportedOperationException_init_$Create$();
  };
  AsyncStreamBase.prototype.getLength_14 = function ($cont) {
    throw UnsupportedOperationException_init_$Create$();
  };
  AsyncStreamBase.prototype.close_77 = function ($cont) {
    return Unit_getInstance();
  };
  AsyncStreamBase.$metadata$ = {
    simpleName: 'AsyncStreamBase',
    kind: 'class',
    interfaces: [AsyncCloseable, AsyncRAInputStream, AsyncRAOutputStream, AsyncLengthStream]
  };
  function $readCOROUTINE$135(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__68 = _this_;
  }
  $readCOROUTINE$135.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_alloc_01 = _get_smallBytesPool_();
            this._temp_12 = this._tmp0_alloc_01.alloc();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 9;
            this._state_1 = 4;
            suspendResult = this.__this__68.read_30(this._temp_12, 0, 1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var ARGUMENT = suspendResult;
            if (ARGUMENT > 0) {
              var tmp_1 = this;
              var tmp0__get_unsigned__0_3 = this._temp_12[0];
              tmp_1._WHEN_RESULT5 = tmp0__get_unsigned__0_3 & 255;
              this._state_1 = 5;
              continue $sm;
            } else {
              this._WHEN_RESULT5 = -1;
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._tmp$ret$04 = this._WHEN_RESULT5;
            this._exceptionState = 10;
            this._state_1 = 6;
            var tmp_2 = this;
            continue $sm;
          case 6:
            var tmp_3 = this._tmp$ret$04;
            this._tmp0_alloc_01.free(this._temp_12);
            this._tmp$ret$40 = tmp_3;
            this._state_1 = 8;
            continue $sm;
          case 7:
            this._tmp0_alloc_01.free(this._temp_12);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 8;
            continue $sm;
          case 8:
            return this._tmp$ret$40;
          case 9:
            this._exceptionState = 10;
            var t = this._exception_0;
            this._tmp0_alloc_01.free(this._temp_12);
            throw t;
          case 10:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$135.$metadata$ = {
    simpleName: '$readCOROUTINE$135',
    kind: 'class',
    interfaces: []
  };
  function AsyncInputStream() {
  }
  AsyncInputStream.prototype.read_36 = function ($cont) {
    var tmp = new $readCOROUTINE$135(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncInputStream.$metadata$ = {
    simpleName: 'AsyncInputStream',
    kind: 'interface',
    interfaces: [AsyncBaseStream]
  };
  function readAll(_this_, $cont) {
    var tmp = new $readAllCOROUTINE$136(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function $writeCOROUTINE$137(_this_, byte, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__69 = _this_;
    this._byte = byte;
  }
  $writeCOROUTINE$137.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_alloc_01_0 = _get_smallBytesPool_();
            this._temp_12_0 = this._tmp0_alloc_01_0.alloc();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._temp_12_0[0] = toByte(this._byte);
            this._state_1 = 4;
            suspendResult = this.__this__69.write_25(this._temp_12_0, 0, 1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$04_0 = suspendResult;
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_1 = this;
            continue $sm;
          case 5:
            var tmp_2 = this;
            tmp_2._tmp$ret$40_0 = this._tmp0_alloc_01_0.free(this._temp_12_0);
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_alloc_01_0.free(this._temp_12_0);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_alloc_01_0.free(this._temp_12_0);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $writeCOROUTINE$137.$metadata$ = {
    simpleName: '$writeCOROUTINE$137',
    kind: 'class',
    interfaces: []
  };
  function AsyncOutputStream() {
  }
  AsyncOutputStream.prototype.write_26 = function (byte, $cont) {
    var tmp = new $writeCOROUTINE$137(this, byte, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncOutputStream.$metadata$ = {
    simpleName: 'AsyncOutputStream',
    kind: 'interface',
    interfaces: [AsyncBaseStream]
  };
  function AsyncInputStreamWithLength() {
  }
  AsyncInputStreamWithLength.$metadata$ = {
    simpleName: 'AsyncInputStreamWithLength',
    kind: 'interface',
    interfaces: [AsyncInputStream, AsyncGetPositionStream, AsyncGetLengthStream]
  };
  function AsyncPositionLengthStream() {
  }
  AsyncPositionLengthStream.$metadata$ = {
    simpleName: 'AsyncPositionLengthStream',
    kind: 'interface',
    interfaces: [AsyncPositionStream, AsyncLengthStream]
  };
  function $_readCOROUTINE$138(_this_, position_1, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__70 = _this_;
    this._position_4 = position_1;
    this._buffer_16 = buffer;
    this._offset_13 = offset;
    this._len_10 = len;
  }
  $_readCOROUTINE$138.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            suspendResult = this.__this__70._base_0.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_14 = suspendResult;
            if (this._position_4.compareTo_137(this._ARGUMENT0_14) >= 0) {
              return -1;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_div_01 = this.__this__70._bsize;
            tmp_0._sector2 = this._position_4.div_28(toLong(this._tmp0_div_01));
            if (!this.__this__70._cachedSector.equals(this._sector2)) {
              this._state_1 = 3;
              var tmp_2 = this;
              tmp_2._tmp1_times_03 = this.__this__70._bsize;
              suspendResult = readBytes(this.__this__70._base_0, this._sector2.times_28(toLong(this._tmp1_times_03)), this.__this__70._bsize, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 3:
            var ARGUMENT = suspendResult;
            this.__this__70._cachedData = ARGUMENT;
            this.__this__70._cachedSector = this._sector2;
            this._state_1 = 4;
            continue $sm;
          case 4:
            var tmp2_rem_0 = this.__this__70._bsize;
            var soffset = this._position_4.rem_27(toLong(tmp2_rem_0)).toInt_8();
            var available = this.__this__70._cachedData.length - soffset | 0;
            var toRead = min2_0(available, this._len_10);
            arraycopy_2(this.__this__70._cachedData, soffset, this._buffer_16, this._offset_13, toRead);
            return toRead;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $_readCOROUTINE$138.$metadata$ = {
    simpleName: '$_readCOROUTINE$138',
    kind: 'class',
    interfaces: []
  };
  function BufferedStreamBase(base, blockSize, blocksToRead) {
    AsyncStreamBase.call(this);
    this._base_0 = base;
    this._blockSize = blockSize;
    this._blocksToRead = blocksToRead;
    this._bsize = imul(this._blockSize, this._blocksToRead);
    var tmp = this;
    var tmp0_byteArrayOf_0 = new Int8Array([]);
    tmp._cachedData = tmp0_byteArrayOf_0;
    this._cachedSector = new Long(-1, -1);
  }
  BufferedStreamBase.prototype.read_37 = function (position_1, buffer, offset, len, $cont) {
    return this._read_2(position_1, buffer, offset, len, $cont);
  };
  BufferedStreamBase.prototype._read_2 = function (position_1, buffer, offset, len, $cont) {
    var tmp = new $_readCOROUTINE$138(this, position_1, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  BufferedStreamBase.prototype.write_30 = function (position_1, buffer, offset, len, $cont) {
    return this._base_0.write_30(position_1, buffer, offset, len, $cont);
  };
  BufferedStreamBase.prototype.getLength_14 = function ($cont) {
    return this._base_0.getLength_14($cont);
  };
  BufferedStreamBase.prototype.close_77 = function ($cont) {
    return this._base_0.close_77($cont);
  };
  BufferedStreamBase.$metadata$ = {
    simpleName: 'BufferedStreamBase',
    kind: 'class',
    interfaces: []
  };
  function AsyncRAInputStream() {
  }
  AsyncRAInputStream.$metadata$ = {
    simpleName: 'AsyncRAInputStream',
    kind: 'interface',
    interfaces: []
  };
  function AsyncRAOutputStream() {
  }
  AsyncRAOutputStream.$metadata$ = {
    simpleName: 'AsyncRAOutputStream',
    kind: 'interface',
    interfaces: []
  };
  function AsyncLengthStream() {
  }
  AsyncLengthStream.$metadata$ = {
    simpleName: 'AsyncLengthStream',
    kind: 'interface',
    interfaces: [AsyncGetLengthStream]
  };
  function AsyncBaseStream() {
  }
  AsyncBaseStream.$metadata$ = {
    simpleName: 'AsyncBaseStream',
    kind: 'interface',
    interfaces: [AsyncCloseable]
  };
  function AsyncGetPositionStream() {
  }
  AsyncGetPositionStream.prototype.getPosition_5 = function ($cont) {
    throw UnsupportedOperationException_init_$Create$();
  };
  AsyncGetPositionStream.$metadata$ = {
    simpleName: 'AsyncGetPositionStream',
    kind: 'interface',
    interfaces: [AsyncBaseStream]
  };
  function AsyncGetLengthStream() {
  }
  AsyncGetLengthStream.prototype.getLength_14 = function ($cont) {
    throw UnsupportedOperationException_init_$Create$();
  };
  AsyncGetLengthStream.$metadata$ = {
    simpleName: 'AsyncGetLengthStream',
    kind: 'interface',
    interfaces: [AsyncBaseStream]
  };
  function readBytesExact(_this_, len, $cont) {
    var tmp = new $readBytesExactCOROUTINE$139(_this_, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function hasAvailable(_this_, $cont) {
    var tmp = new $hasAvailableCOROUTINE$140(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function AsyncPositionStream() {
  }
  AsyncPositionStream.$metadata$ = {
    simpleName: 'AsyncPositionStream',
    kind: 'interface',
    interfaces: [AsyncGetPositionStream]
  };
  function readBytes(_this_, position_1, count_0, $cont) {
    var tmp = new $readBytesCOROUTINE$141(_this_, position_1, count_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readExact(_this_, buffer, offset, len, $cont) {
    var tmp = new $readExactCOROUTINE$142(_this_, buffer, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function MemoryAsyncStreamBase(data) {
    AsyncStreamBase.call(this);
    this._data_13 = data;
  }
  MemoryAsyncStreamBase.prototype._get_ilength__0 = function () {
    return this._data_13._get_size__60();
  };
  MemoryAsyncStreamBase.prototype.getLength_14 = function ($cont) {
    return toLong(this._get_ilength__0());
  };
  MemoryAsyncStreamBase.prototype.checkPosition_0 = function (position_1) {
    var tmp;
    if (position_1.compareTo_137(new Long(0, 0)) < 0) {
      invalidOp('' + 'Invalid position ' + position_1);
    }return tmp;
  };
  MemoryAsyncStreamBase.prototype.read_37 = function (position_1, buffer, offset, len, $cont) {
    this.checkPosition_0(position_1);
    if (!((new Long(0, 0)).compareTo_137(position_1) <= 0 ? position_1.compareTo_137(toLong(this._get_ilength__0())) < 0 : false))
      return 0;
    var tmp = toLong(this._get_ilength__0());
    var end = min2_1(tmp, position_1.plus_64(toLong(len)));
    var actualLen = max2_1(end.minus_29(position_1).toInt_8(), 0);
    arraycopy_2(this._data_13._data_8, position_1.toInt_8(), buffer, offset, actualLen);
    return actualLen;
  };
  MemoryAsyncStreamBase.prototype.write_30 = function (position_1, buffer, offset, len, $cont) {
    this.checkPosition_0(position_1);
    var tmp = this._data_13;
    var tmp_0 = this._data_13._get_size__60();
    tmp._set_size__1(max2_1(tmp_0, position_1.plus_64(toLong(len)).toInt_8()));
    arraycopy_2(buffer, offset, this._data_13._data_8, position_1.toInt_8(), len);
  };
  MemoryAsyncStreamBase.prototype.close_77 = function ($cont) {
    return Unit_getInstance();
  };
  MemoryAsyncStreamBase.prototype.toString = function () {
    return '' + 'MemoryAsyncStreamBase(' + this._data_13._get_size__60() + ')';
  };
  MemoryAsyncStreamBase.$metadata$ = {
    simpleName: 'MemoryAsyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function AsyncInputOpenable() {
  }
  AsyncInputOpenable.$metadata$ = {
    simpleName: 'AsyncInputOpenable',
    kind: 'interface',
    interfaces: []
  };
  function readBytesUpTo(_this_, len, $cont) {
    var tmp = new $readBytesUpToCOROUTINE$144(_this_, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function writeBytes(_this_, data, $cont) {
    return _this_.write_25(data, 0, data.length, $cont);
  }
  function readBytesUpToCopy(_this_, out, $cont) {
    var tmp = new $readBytesUpToCopyCOROUTINE$146(_this_, out, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function getAvailable(_this_, $cont) {
    var tmp = new $getAvailableCOROUTINE$147(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readBytesUpTo_0(_this_, out, offset, len, $cont) {
    var tmp = new $readBytesUpToCOROUTINE$148(_this_, out, offset, len, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function getAvailable_0(_this_, $cont) {
    var tmp = new $getAvailableCOROUTINE$149(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function write8_0(_this_, v, $cont) {
    return _this_.write_26(v, $cont);
  }
  function write16LE_0(_this_, v, $cont) {
    var tmp = new $write16LECOROUTINE$150(_this_, v, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function hasAvailable_0(_this_, $cont) {
    var tmp = new $hasAvailableCOROUTINE$151(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function toAsync(_this_) {
    return toAsyncStream(toAsync_0(_this_._base_2), _this_._position_6);
  }
  function readStream(_this_, length, $cont) {
    return readSlice(_this_, toLong(length), $cont);
  }
  function toSyncOrNull(_this_) {
    var tmp0_safe_receiver = _this_ instanceof SyncAsyncStreamBase ? _this_ : null;
    var tmp2_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._sync;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver = _this_ instanceof MemoryAsyncStreamBase ? _this_ : null;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = new MemorySyncStreamBase(tmp1_safe_receiver._data_13);
      }
      tmp = tmp_0;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    return tmp;
  }
  function readString(_this_, len, charset, $cont) {
    var tmp = new $readStringCOROUTINE$152(_this_, len, charset, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readString$default(_this_, len, charset, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return readString(_this_, len, charset, $cont);
  }
  function readS8_0(_this_, $cont) {
    var tmp = new $readS8COROUTINE$153(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readS64LE_0(_this_, $cont) {
    var tmp = new $readS64LECOROUTINE$154(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readS32LE_0(_this_, $cont) {
    var tmp = new $readS32LECOROUTINE$155(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readU8_1(_this_, $cont) {
    return _this_.read_36($cont);
  }
  function readS16LE_0(_this_, $cont) {
    var tmp = new $readS16LECOROUTINE$157(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readU32LE_0(_this_, $cont) {
    var tmp = new $readU32LECOROUTINE$158(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function toAsync_0(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof MemorySyncStreamBase) {
      tmp = new MemoryAsyncStreamBase(_this_._data_14);
    } else {
      {
        tmp = new SyncAsyncStreamBase(_this_);
      }
    }
    return tmp;
  }
  function readSlice(_this_, length, $cont) {
    var tmp = new $readSliceCOROUTINE$159(_this_, length, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function SyncAsyncStreamBase(sync) {
    AsyncStreamBase.call(this);
    this._sync = sync;
  }
  SyncAsyncStreamBase.prototype.read_37 = function (position_1, buffer, offset, len, $cont) {
    return this._sync.read_37(position_1, buffer, offset, len);
  };
  SyncAsyncStreamBase.prototype.write_30 = function (position_1, buffer, offset, len, $cont) {
    return this._sync.write_30(position_1, buffer, offset, len);
  };
  SyncAsyncStreamBase.prototype.getLength_14 = function ($cont) {
    return this._sync._get_length__5();
  };
  SyncAsyncStreamBase.$metadata$ = {
    simpleName: 'SyncAsyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function sliceWithSize(_this_, start, length, closeParent, $cont) {
    return sliceWithBounds(_this_, start, start.plus_64(length), closeParent, $cont);
  }
  function sliceWithSize$default(_this_, start, length, closeParent, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      closeParent = false;
    return sliceWithSize(_this_, start, length, closeParent, $cont);
  }
  function sliceWithBounds(_this_, start, end, closeParent, $cont) {
    var tmp = new $sliceWithBoundsCOROUTINE$162(_this_, start, end, closeParent, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function clampPosition($this, position_1) {
    return clamp_4(position_1, $this._baseStart, $this._baseEnd);
  }
  function clampPositionLen($this, position_1, len) {
    if (position_1.compareTo_137(new Long(0, 0)) < 0)
      throw IllegalArgumentException_init_$Create$('Invalid position');
    var targetStartPosition = clampPosition($this, $this._baseStart.plus_64(position_1));
    var targetEndPosition = clampPosition($this, targetStartPosition.plus_64(toLong(len)));
    var targetLen = targetEndPosition.minus_29(targetStartPosition).toInt_8();
    return new Pair(targetStartPosition, targetLen);
  }
  function $closeCOROUTINE$163(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__71 = _this_;
  }
  $closeCOROUTINE$163.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            if (this.__this__71._closeParent) {
              this._state_1 = 1;
              suspendResult = this.__this__71._base_1.close_77(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $closeCOROUTINE$163.$metadata$ = {
    simpleName: '$closeCOROUTINE$163',
    kind: 'class',
    interfaces: []
  };
  function SliceAsyncStreamBase(base, baseStart, baseEnd, closeParent) {
    AsyncStreamBase.call(this);
    this._base_1 = base;
    this._baseStart = baseStart;
    this._baseEnd = baseEnd;
    this._closeParent = closeParent;
    this._baseLength = this._baseEnd.minus_29(this._baseStart);
  }
  SliceAsyncStreamBase.prototype.read_37 = function (position_1, buffer, offset, len, $cont) {
    var tmp0_container = clampPositionLen(this, position_1, len);
    var targetStartPosition = tmp0_container.component1_1();
    var targetLen = tmp0_container.component2_1();
    return this._base_1.read_37(targetStartPosition, buffer, offset, targetLen, $cont);
  };
  SliceAsyncStreamBase.prototype.write_30 = function (position_1, buffer, offset, len, $cont) {
    var tmp0_container = clampPositionLen(this, position_1, len);
    var targetStartPosition = tmp0_container.component1_1();
    var targetLen = tmp0_container.component2_1();
    return this._base_1.write_30(targetStartPosition, buffer, offset, targetLen, $cont);
  };
  SliceAsyncStreamBase.prototype.getLength_14 = function ($cont) {
    return this._baseLength;
  };
  SliceAsyncStreamBase.prototype.close_77 = function ($cont) {
    var tmp = new $closeCOROUTINE$163(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  SliceAsyncStreamBase.prototype.toString = function () {
    return '' + 'SliceAsyncStreamBase(' + this._base_1 + ', ' + this._baseStart + ', ' + this._baseEnd + ')';
  };
  SliceAsyncStreamBase.$metadata$ = {
    simpleName: 'SliceAsyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function toAsyncInputStream(_this_) {
    return new _no_name_provided__133(_this_);
  }
  function toAsyncOutputStream(_this_) {
    return new _no_name_provided__134(_this_);
  }
  function write32BE_0(_this_, v, $cont) {
    var tmp = new $write32BECOROUTINE$164(_this_, v, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function sliceStart(_this_, start, closeParent, $cont) {
    var tmp = new $sliceStartCOROUTINE$165(_this_, start, closeParent, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function sliceStart$default(_this_, start, closeParent, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      start = new Long(0, 0);
    if (!(($mask0 & 2) === 0))
      closeParent = false;
    return sliceStart(_this_, start, closeParent, $cont);
  }
  function readS32BE_0(_this_, $cont) {
    var tmp = new $readS32BECOROUTINE$166(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readU16LE_0(_this_, $cont) {
    var tmp = new $readU16LECOROUTINE$167(_this_, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readAvailable(_this_, $cont) {
    return readAll(_this_, $cont);
  }
  function $getPositionCOROUTINE$168(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__72 = _this_;
  }
  $getPositionCOROUTINE$168.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this.__this__72._sync_0;
            var tmp0_safe_receiver = isInterface(tmp_1, SyncPositionStream) ? tmp_1 : null;
            tmp_0._tmp1_elvis_lhs0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_position__1();
            if (this._tmp1_elvis_lhs0 == null) {
              this._state_1 = 1;
              suspendResult = AsyncGetPositionStream.prototype.getPosition_5.call(this.__this__72, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT1_2 = this._tmp1_elvis_lhs0;
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1_2 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            return this._WHEN_RESULT1_2;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getPositionCOROUTINE$168.$metadata$ = {
    simpleName: '$getPositionCOROUTINE$168',
    kind: 'class',
    interfaces: []
  };
  function $getLengthCOROUTINE$169(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__73 = _this_;
  }
  $getLengthCOROUTINE$169.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this.__this__73._sync_0;
            var tmp0_safe_receiver = isInterface(tmp_1, SyncLengthStream) ? tmp_1 : null;
            tmp_0._tmp1_elvis_lhs0_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_length__5();
            if (this._tmp1_elvis_lhs0_0 == null) {
              this._state_1 = 1;
              suspendResult = AsyncGetLengthStream.prototype.getLength_14.call(this.__this__73, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT1_3 = this._tmp1_elvis_lhs0_0;
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT1_3 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            return this._WHEN_RESULT1_3;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getLengthCOROUTINE$169.$metadata$ = {
    simpleName: '$getLengthCOROUTINE$169',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__133($this_toAsyncInputStream) {
    this._$this_toAsyncInputStream = $this_toAsyncInputStream;
    this._sync_0 = this._$this_toAsyncInputStream;
  }
  _no_name_provided__133.prototype.read_30 = function (buffer, offset, len, $cont) {
    return this._sync_0.read_30(buffer, offset, len);
  };
  _no_name_provided__133.prototype.close_77 = function ($cont) {
    var tmp = this._sync_0;
    var tmp0_safe_receiver_2 = isInterface(tmp, Closeable) ? tmp : null;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.close_77();
      Unit_getInstance();
    }
    return Unit_getInstance();
  };
  _no_name_provided__133.prototype.getPosition_5 = function ($cont) {
    var tmp = new $getPositionCOROUTINE$168(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__133.prototype.getLength_14 = function ($cont) {
    var tmp = new $getLengthCOROUTINE$169(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__133.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncInputStreamWithLength]
  };
  function _no_name_provided__134($this_toAsyncOutputStream) {
    this._$this_toAsyncOutputStream = $this_toAsyncOutputStream;
  }
  _no_name_provided__134.prototype.write_25 = function (buffer, offset, len, $cont) {
    return this._$this_toAsyncOutputStream.write_25(buffer, offset, len);
  };
  _no_name_provided__134.prototype.close_77 = function ($cont) {
    var tmp = this._$this_toAsyncOutputStream;
    var tmp0_safe_receiver_2 = isInterface(tmp, Closeable) ? tmp : null;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      tmp0_safe_receiver_2.close_77();
      Unit_getInstance();
    }
    return Unit_getInstance();
  };
  _no_name_provided__134.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncOutputStream]
  };
  function $readAllCOROUTINE$136(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__74 = _this_;
  }
  $readAllCOROUTINE$136.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 18;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 16;
            var tmp_0;
            var tmp_1 = this.__this__74;
            if (isInterface(tmp_1, AsyncGetPositionStream)) {
              var tmp_2 = this.__this__74;
              tmp_0 = isInterface(tmp_2, AsyncGetLengthStream);
            } else {
              {
                tmp_0 = false;
              }
            }

            if (tmp_0) {
              this._state_1 = 10;
              suspendResult = this.__this__74.getLength_14(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                var tmp_3 = this.__this__74;
                if (tmp_3 instanceof AsyncStream) {
                  this._state_1 = 2;
                  suspendResult = hasAvailable(this.__this__74, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  {
                    this._WHEN_RESULT2_0 = false;
                    this._state_1 = 3;
                    continue $sm;
                  }
                }
                Unit_getInstance();
              }
            }

            break;
          case 2:
            this._WHEN_RESULT2_0 = suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            if (this._WHEN_RESULT2_0) {
              this._state_1 = 8;
              suspendResult = this.__this__74.getAvailable(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              var tmp_4 = this;
              tmp_4._out3 = ByteArrayBuilder_init_$Create$_1(0, 1, null);
              this._temp4 = new Int8Array(4096);
              this._state_1 = 4;
              continue $sm;
            }

            Unit_getInstance();
            break;
          case 4:
            if (false) {
              this._state_1 = 7;
              continue $sm;
            }
            this._state_1 = 5;
            suspendResult = this.__this__74.read_30(this._temp4, 0, this._temp4.length, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._r5 = suspendResult;
            if (this._r5 <= 0) {
              this._state_1 = 7;
              continue $sm;
            } else {
              this._state_1 = 6;
              continue $sm;
            }

            break;
          case 6:
            this._out3.append_6(this._temp4, 0, this._r5);
            this._state_1 = 4;
            continue $sm;
          case 7:
            this._WHEN_RESULT1_4 = this._out3.toByteArray();
            this._state_1 = 13;
            continue $sm;
          case 8:
            this._ARGUMENT6 = suspendResult;
            this._available7 = this._ARGUMENT6.toInt_8();
            this._state_1 = 9;
            suspendResult = readBytesExact(this.__this__74, this._available7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._WHEN_RESULT1_4 = suspendResult;
            this._state_1 = 13;
            continue $sm;
          case 10:
            this._ARGUMENT8_0 = suspendResult;
            this._state_1 = 11;
            suspendResult = this.__this__74.getPosition_5(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._ARGUMENT9 = suspendResult;
            this._available10 = this._ARGUMENT8_0.minus_29(this._ARGUMENT9);
            this._state_1 = 12;
            suspendResult = readBytesExact(this.__this__74, this._available10.toInt_8(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 12:
            this._WHEN_RESULT1_4 = suspendResult;
            this._state_1 = 13;
            continue $sm;
          case 13:
            this._tmp$ret$00_0 = this._WHEN_RESULT1_4;
            this._exceptionState = 18;
            this._state_1 = 14;
            continue $sm;
          case 14:
            this._tmp11 = this._tmp$ret$00_0;
            this._state_1 = 15;
            suspendResult = this.__this__74.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 15:
            suspendResult;
            return this._tmp11;
          case 16:
            this._exceptionState = 18;
            this._t12 = this._exception_0;
            this._state_1 = 17;
            suspendResult = this.__this__74.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 17:
            suspendResult;
            throw this._t12;
          case 18:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 18) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAllCOROUTINE$136.$metadata$ = {
    simpleName: '$readAllCOROUTINE$136',
    kind: 'class',
    interfaces: []
  };
  function $readBytesExactCOROUTINE$139(_this_, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__75 = _this_;
    this._len_11 = len;
  }
  $readBytesExactCOROUTINE$139.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_apply_00 = new Int8Array(this._len_11);
            this._state_1 = 1;
            suspendResult = readExact(this.__this__75, this._tmp0_apply_00, 0, this._len_11, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return this._tmp0_apply_00;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesExactCOROUTINE$139.$metadata$ = {
    simpleName: '$readBytesExactCOROUTINE$139',
    kind: 'class',
    interfaces: []
  };
  function $hasAvailableCOROUTINE$140(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__76 = _this_;
  }
  $hasAvailableCOROUTINE$140.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__76.getAvailable(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            this._TRY_RESULT0_1 = true;
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var t = this._exception_0;
              var tmp_1 = this;
              tmp_1._TRY_RESULT0_1 = false;
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return this._TRY_RESULT0_1;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $hasAvailableCOROUTINE$140.$metadata$ = {
    simpleName: '$hasAvailableCOROUTINE$140',
    kind: 'class',
    interfaces: []
  };
  function $readBytesCOROUTINE$141(_this_, position_1, count_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__77 = _this_;
    this._position_5 = position_1;
    this._count_0 = count_0;
  }
  $readBytesCOROUTINE$141.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._out0 = new Int8Array(this._count_0);
            this._state_1 = 1;
            suspendResult = this.__this__77.read_37(this._position_5, this._out0, 0, this._out0.length, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var readLen = suspendResult;
            return copyOf(this._out0, readLen);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesCOROUTINE$141.$metadata$ = {
    simpleName: '$readBytesCOROUTINE$141',
    kind: 'class',
    interfaces: []
  };
  function $readExactCOROUTINE$142(_this_, buffer, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__78 = _this_;
    this._buffer_17 = buffer;
    this._offset_14 = offset;
    this._len_12 = len;
  }
  $readExactCOROUTINE$142.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._remaining0 = this._len_12;
            this._coffset1 = this._offset_14;
            this._reader2_0 = this.__this__78;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!(this._remaining0 > 0)) {
              this._state_1 = 4;
              continue $sm;
            }
            this._state_1 = 2;
            suspendResult = this._reader2_0.read_30(this._buffer_17, this._coffset1, this._remaining0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var read_1 = suspendResult;
            if (read_1 < 0) {
              this._state_1 = 4;
              continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            if (read_1 === 0)
              throw new EOFException('' + 'Not enough data. Expected=' + this._len_12 + ', Read=' + (this._len_12 - this._remaining0 | 0) + ', Remaining=' + this._remaining0);
            this._coffset1 = this._coffset1 + read_1 | 0;
            this._remaining0 = this._remaining0 - read_1 | 0;
            this._state_1 = 1;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readExactCOROUTINE$142.$metadata$ = {
    simpleName: '$readExactCOROUTINE$142',
    kind: 'class',
    interfaces: []
  };
  function $readBytesUpToCOROUTINE$144(_this_, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__79 = _this_;
    this._len_13 = len;
  }
  $readBytesUpToCOROUTINE$144.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._BYTES_TEMP_SIZE0 = 4096;
            if (this._len_13 <= this._BYTES_TEMP_SIZE0) {
              this._state_1 = 9;
              suspendResult = readBytesUpToCopy(this.__this__79, new Int8Array(this._len_13), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            var tmp_0 = this.__this__79;
            if (isInterface(tmp_0, AsyncPositionLengthStream)) {
              this._state_1 = 7;
              suspendResult = getAvailable(this.__this__79, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 2;
                continue $sm;
              }
            }

            break;
          case 2:
            this._pending1 = this._len_13;
            this._temp2 = new Int8Array(this._BYTES_TEMP_SIZE0);
            var tmp_1 = this;
            tmp_1._bout3 = ByteArrayBuilder_init_$Create$_1(0, 1, null);
            this._state_1 = 3;
            continue $sm;
          case 3:
            if (!(this._pending1 > 0)) {
              this._state_1 = 6;
              continue $sm;
            }
            this._state_1 = 4;
            suspendResult = this.__this__79.read_30(this._temp2, 0, min2_0(this._temp2.length, this._pending1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._read4 = suspendResult;
            if (this._read4 <= 0) {
              this._state_1 = 6;
              continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._bout3.append_6(this._temp2, 0, this._read4);
            this._pending1 = this._pending1 - this._read4 | 0;
            this._state_1 = 3;
            continue $sm;
          case 6:
            return this._bout3.toByteArray();
          case 7:
            this._ARGUMENT5 = suspendResult;
            var tmp_2 = this;
            tmp_2._ARGUMENT6_0 = toIntClamp$default(this._ARGUMENT5, 0, 0, 3, null);
            this._ARGUMENT7_0 = min2_0(this._len_13, this._ARGUMENT6_0);
            this._ARGUMENT8_1 = new Int8Array(this._ARGUMENT7_0);
            this._state_1 = 8;
            suspendResult = readBytesUpToCopy(this.__this__79, this._ARGUMENT8_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            return suspendResult;
          case 9:
            return suspendResult;
          case 10:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesUpToCOROUTINE$144.$metadata$ = {
    simpleName: '$readBytesUpToCOROUTINE$144',
    kind: 'class',
    interfaces: []
  };
  function $readBytesUpToCopyCOROUTINE$146(_this_, out, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__80 = _this_;
    this._out_3 = out;
  }
  $readBytesUpToCopyCOROUTINE$146.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readBytesUpTo_0(this.__this__80, this._out_3, 0, this._out_3.length, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var pos = suspendResult;
            return this._out_3.length === pos ? this._out_3 : copyOf(this._out_3, pos);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesUpToCopyCOROUTINE$146.$metadata$ = {
    simpleName: '$readBytesUpToCopyCOROUTINE$146',
    kind: 'class',
    interfaces: []
  };
  function $getAvailableCOROUTINE$147(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__81 = _this_;
  }
  $getAvailableCOROUTINE$147.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__81.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_15 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__81.getPosition_5(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this._ARGUMENT0_15.minus_29(ARGUMENT);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getAvailableCOROUTINE$147.$metadata$ = {
    simpleName: '$getAvailableCOROUTINE$147',
    kind: 'class',
    interfaces: []
  };
  function $readBytesUpToCOROUTINE$148(_this_, out, offset, len, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__82 = _this_;
    this._out_4 = out;
    this._offset_15 = offset;
    this._len_14 = len;
  }
  $readBytesUpToCOROUTINE$148.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._total0 = 0;
            this._pending1_0 = this._len_14;
            this._offset2 = this._offset_15;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (false) {
              this._state_1 = 5;
              continue $sm;
            }
            this._state_1 = 2;
            suspendResult = this.__this__82.read_30(this._out_4, this._offset2, this._pending1_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var result = suspendResult;
            if (result <= 0) {
              this._state_1 = 5;
              continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            this._offset2 = this._offset2 + result | 0;
            this._pending1_0 = this._pending1_0 - result | 0;
            this._total0 = this._total0 + result | 0;
            this._state_1 = 1;
            continue $sm;
          case 4:
            throw this._exception_0;
          case 5:
            return this._total0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBytesUpToCOROUTINE$148.$metadata$ = {
    simpleName: '$readBytesUpToCOROUTINE$148',
    kind: 'class',
    interfaces: []
  };
  function $getAvailableCOROUTINE$149(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__83 = _this_;
  }
  $getAvailableCOROUTINE$149.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__83.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_16 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__83.getPosition_5(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return this._ARGUMENT0_16.minus_29(ARGUMENT);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getAvailableCOROUTINE$149.$metadata$ = {
    simpleName: '$getAvailableCOROUTINE$149',
    kind: 'class',
    interfaces: []
  };
  function $write16LECOROUTINE$150(_this_, v, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__84 = _this_;
    this._v_1 = v;
  }
  $write16LECOROUTINE$150.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_alloc_01_1 = _get_smallBytesPool_();
            this._temp_12_1 = this._tmp0_alloc_01_1.alloc();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            write16LE(this._temp_12_1, 0, this._v_1);
            this._state_1 = 4;
            suspendResult = this.__this__84.write_25(this._temp_12_1, 0, 2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$04_1 = suspendResult;
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_1 = this;
            continue $sm;
          case 5:
            var tmp_2 = this;
            tmp_2._tmp$ret$40_1 = this._tmp0_alloc_01_1.free(this._temp_12_1);
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_alloc_01_1.free(this._temp_12_1);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_alloc_01_1.free(this._temp_12_1);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $write16LECOROUTINE$150.$metadata$ = {
    simpleName: '$write16LECOROUTINE$150',
    kind: 'class',
    interfaces: []
  };
  function $hasAvailableCOROUTINE$151(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__85 = _this_;
  }
  $hasAvailableCOROUTINE$151.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = getAvailable_0(this.__this__85, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.compareTo_137(new Long(0, 0)) > 0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $hasAvailableCOROUTINE$151.$metadata$ = {
    simpleName: '$hasAvailableCOROUTINE$151',
    kind: 'class',
    interfaces: []
  };
  function $readStringCOROUTINE$152(_this_, len, charset, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__86 = _this_;
    this._len_15 = len;
    this._charset_1 = charset;
  }
  $readStringCOROUTINE$152.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readBytesExact(this.__this__86, this._len_15, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return toString_3(ARGUMENT, this._charset_1);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readStringCOROUTINE$152.$metadata$ = {
    simpleName: '$readStringCOROUTINE$152',
    kind: 'class',
    interfaces: []
  };
  function $readS8COROUTINE$153(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__87 = _this_;
  }
  $readS8COROUTINE$153.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__87.read_36(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = toByte(ARGUMENT);
            return ARGUMENT_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readS8COROUTINE$153.$metadata$ = {
    simpleName: '$readS8COROUTINE$153',
    kind: 'class',
    interfaces: []
  };
  function $readS64LECOROUTINE$154(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__88 = _this_;
  }
  $readS64LECOROUTINE$154.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            var tmp_0 = this;
            tmp_0._tmp1_readSmallTempExact_00 = 8;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_1 = this;
            tmp_1._tmp0_allocThis_02 = _get_smallBytesPool_();
            this._temp_13 = this._tmp0_allocThis_02.alloc();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__88.read_30(this._temp_13, 0, this._tmp1_readSmallTempExact_00, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_2_3 = suspendResult;
            if (!(read_2_3 === this._tmp1_readSmallTempExact_00)) {
              var tmp0_error_0_4 = '' + "Couldn't read exact size=" + this._tmp1_readSmallTempExact_00 + ' but read=' + read_2_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4));
            }
            var tmp_2 = this;
            tmp_2._tmp$ret$05_0 = readS64LE(this._temp_13, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_3 = this;
            continue $sm;
          case 5:
            var tmp_4 = this._tmp$ret$05_0;
            this._tmp0_allocThis_02.free(this._temp_13);
            this._tmp$ret$41 = tmp_4;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_02.free(this._temp_13);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$41;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_02.free(this._temp_13);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readS64LECOROUTINE$154.$metadata$ = {
    simpleName: '$readS64LECOROUTINE$154',
    kind: 'class',
    interfaces: []
  };
  function $readS32LECOROUTINE$155(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__89 = _this_;
  }
  $readS32LECOROUTINE$155.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            var tmp_0 = this;
            tmp_0._tmp1_readSmallTempExact_00_0 = 4;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_1 = this;
            tmp_1._tmp0_allocThis_02_0 = _get_smallBytesPool_();
            this._temp_13_0 = this._tmp0_allocThis_02_0.alloc();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__89.read_30(this._temp_13_0, 0, this._tmp1_readSmallTempExact_00_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_2_3 = suspendResult;
            if (!(read_2_3 === this._tmp1_readSmallTempExact_00_0)) {
              var tmp0_error_0_4 = '' + "Couldn't read exact size=" + this._tmp1_readSmallTempExact_00_0 + ' but read=' + read_2_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4));
            }
            var tmp_2 = this;
            tmp_2._tmp$ret$05_1 = readS32LE(this._temp_13_0, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_3 = this;
            continue $sm;
          case 5:
            var tmp_4 = this._tmp$ret$05_1;
            this._tmp0_allocThis_02_0.free(this._temp_13_0);
            this._tmp$ret$41_0 = tmp_4;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_02_0.free(this._temp_13_0);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$41_0;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_02_0.free(this._temp_13_0);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readS32LECOROUTINE$155.$metadata$ = {
    simpleName: '$readS32LECOROUTINE$155',
    kind: 'class',
    interfaces: []
  };
  function $readS16LECOROUTINE$157(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__90 = _this_;
  }
  $readS16LECOROUTINE$157.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            var tmp_0 = this;
            tmp_0._tmp1_readSmallTempExact_00_1 = 2;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_1 = this;
            tmp_1._tmp0_allocThis_02_1 = _get_smallBytesPool_();
            this._temp_13_1 = this._tmp0_allocThis_02_1.alloc();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__90.read_30(this._temp_13_1, 0, this._tmp1_readSmallTempExact_00_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_2_3 = suspendResult;
            if (!(read_2_3 === this._tmp1_readSmallTempExact_00_1)) {
              var tmp0_error_0_4 = '' + "Couldn't read exact size=" + this._tmp1_readSmallTempExact_00_1 + ' but read=' + read_2_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4));
            }
            var tmp_2 = this;
            tmp_2._tmp$ret$05_2 = readS16LE(this._temp_13_1, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_3 = this;
            continue $sm;
          case 5:
            var tmp_4 = this._tmp$ret$05_2;
            this._tmp0_allocThis_02_1.free(this._temp_13_1);
            this._tmp$ret$41_1 = tmp_4;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_02_1.free(this._temp_13_1);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$41_1;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_02_1.free(this._temp_13_1);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readS16LECOROUTINE$157.$metadata$ = {
    simpleName: '$readS16LECOROUTINE$157',
    kind: 'class',
    interfaces: []
  };
  function $readU32LECOROUTINE$158(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__91 = _this_;
  }
  $readU32LECOROUTINE$158.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            var tmp_0 = this;
            tmp_0._tmp1_readSmallTempExact_00_2 = 4;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_1 = this;
            tmp_1._tmp0_allocThis_02_2 = _get_smallBytesPool_();
            this._temp_13_2 = this._tmp0_allocThis_02_2.alloc();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__91.read_30(this._temp_13_2, 0, this._tmp1_readSmallTempExact_00_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_2_3 = suspendResult;
            if (!(read_2_3 === this._tmp1_readSmallTempExact_00_2)) {
              var tmp0_error_0_4 = '' + "Couldn't read exact size=" + this._tmp1_readSmallTempExact_00_2 + ' but read=' + read_2_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4));
            }
            var tmp_2 = this;
            tmp_2._tmp$ret$05_3 = readU32LE(this._temp_13_2, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_3 = this;
            continue $sm;
          case 5:
            var tmp_4 = this._tmp$ret$05_3;
            this._tmp0_allocThis_02_2.free(this._temp_13_2);
            this._tmp$ret$41_2 = tmp_4;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_02_2.free(this._temp_13_2);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$41_2;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_02_2.free(this._temp_13_2);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readU32LECOROUTINE$158.$metadata$ = {
    simpleName: '$readU32LECOROUTINE$158',
    kind: 'class',
    interfaces: []
  };
  function $readSliceCOROUTINE$159(_this_, length, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__92 = _this_;
    this._length_1 = length;
  }
  $readSliceCOROUTINE$159.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this.__this__92.getPosition_5(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._start0 = suspendResult;
            this._state_1 = 2;
            suspendResult = sliceWithSize$default(this.__this__92, this._start0, this._length_1, false, 4, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._out1 = suspendResult;
            this._state_1 = 3;
            suspendResult = this.__this__92.setPosition_0(this._start0.plus_64(this._length_1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            return this._out1;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readSliceCOROUTINE$159.$metadata$ = {
    simpleName: '$readSliceCOROUTINE$159',
    kind: 'class',
    interfaces: []
  };
  function $sliceWithBoundsCOROUTINE$162(_this_, start, end, closeParent, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__93 = _this_;
    this._start = start;
    this._end = end;
    this._closeParent_0 = closeParent;
  }
  $sliceWithBoundsCOROUTINE$162.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__93.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var len = suspendResult;
            var clampedStart = clamp_4(this._start, new Long(0, 0), len);
            var clampedEnd = clamp_4(this._end, new Long(0, 0), len);
            var tmp_0;
            var tmp_1 = this.__this__93._base;
            if (tmp_1 instanceof SliceAsyncStreamBase) {
              var tmp_2 = new SliceAsyncStreamBase(this.__this__93._base._base_1, this.__this__93._base._baseStart.plus_64(clampedStart), this.__this__93._base._baseStart.plus_64(clampedEnd), this._closeParent_0);
              tmp_0 = toAsyncStream$default(tmp_2, new Long(0, 0), 1, null);
            } else {
              {
                var tmp_3 = new SliceAsyncStreamBase(this.__this__93._base, clampedStart, clampedEnd, this._closeParent_0);
                tmp_0 = toAsyncStream$default(tmp_3, new Long(0, 0), 1, null);
              }
            }

            return tmp_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sliceWithBoundsCOROUTINE$162.$metadata$ = {
    simpleName: '$sliceWithBoundsCOROUTINE$162',
    kind: 'class',
    interfaces: []
  };
  function $write32BECOROUTINE$164(_this_, v, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__94 = _this_;
    this._v_2 = v;
  }
  $write32BECOROUTINE$164.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0._tmp0_alloc_01_2 = _get_smallBytesPool_();
            this._temp_12_2 = this._tmp0_alloc_01_2.alloc();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            write32BE(this._temp_12_2, 0, this._v_2);
            this._state_1 = 4;
            suspendResult = this.__this__94.write_25(this._temp_12_2, 0, 4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._tmp$ret$04_2 = suspendResult;
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_1 = this;
            continue $sm;
          case 5:
            var tmp_2 = this;
            tmp_2._tmp$ret$40_2 = this._tmp0_alloc_01_2.free(this._temp_12_2);
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_alloc_01_2.free(this._temp_12_2);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_alloc_01_2.free(this._temp_12_2);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $write32BECOROUTINE$164.$metadata$ = {
    simpleName: '$write32BECOROUTINE$164',
    kind: 'class',
    interfaces: []
  };
  function $sliceStartCOROUTINE$165(_this_, start, closeParent, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__95 = _this_;
    this._start_0 = start;
    this._closeParent_1 = closeParent;
  }
  $sliceStartCOROUTINE$165.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__95.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_17 = suspendResult;
            this._state_1 = 2;
            suspendResult = sliceWithBounds(this.__this__95, this._start_0, this._ARGUMENT0_17, this._closeParent_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sliceStartCOROUTINE$165.$metadata$ = {
    simpleName: '$sliceStartCOROUTINE$165',
    kind: 'class',
    interfaces: []
  };
  function $readS32BECOROUTINE$166(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__96 = _this_;
  }
  $readS32BECOROUTINE$166.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            var tmp_0 = this;
            tmp_0._tmp0_readSmallTempExact_00 = 4;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_1 = this;
            tmp_1._tmp0_allocThis_0_12 = _get_smallBytesPool_();
            this._temp_1_23 = this._tmp0_allocThis_0_12.alloc();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__96.read_30(this._temp_1_23, 0, this._tmp0_readSmallTempExact_00, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_3_3 = suspendResult;
            if (!(read_3_3 === this._tmp0_readSmallTempExact_00)) {
              var tmp0_error_0_4_4 = '' + "Couldn't read exact size=" + this._tmp0_readSmallTempExact_00 + ' but read=' + read_3_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4_4));
            }
            var tmp_2 = this;
            tmp_2._tmp$ret$05_4 = readS32BE(this._temp_1_23, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_3 = this;
            continue $sm;
          case 5:
            var tmp_4 = this._tmp$ret$05_4;
            this._tmp0_allocThis_0_12.free(this._temp_1_23);
            this._tmp$ret$41_3 = tmp_4;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_0_12.free(this._temp_1_23);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$41_3;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_0_12.free(this._temp_1_23);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readS32BECOROUTINE$166.$metadata$ = {
    simpleName: '$readS32BECOROUTINE$166',
    kind: 'class',
    interfaces: []
  };
  function $readU16LECOROUTINE$167(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__97 = _this_;
  }
  $readU16LECOROUTINE$167.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            var tmp_0 = this;
            tmp_0._tmp0_readSmallTempExact_00_0 = 2;
            this._state_1 = 1;
            continue $sm;
          case 1:
            var tmp_1 = this;
            tmp_1._tmp0_allocThis_0_12_0 = _get_smallBytesPool_();
            this._temp_1_23_0 = this._tmp0_allocThis_0_12_0.alloc();
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            this._state_1 = 4;
            suspendResult = this.__this__97.read_30(this._temp_1_23_0, 0, this._tmp0_readSmallTempExact_00_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var read_3_3 = suspendResult;
            if (!(read_3_3 === this._tmp0_readSmallTempExact_00_0)) {
              var tmp0_error_0_4_4 = '' + "Couldn't read exact size=" + this._tmp0_readSmallTempExact_00_0 + ' but read=' + read_3_3;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4_4));
            }
            var tmp_2 = this;
            tmp_2._tmp$ret$05_5 = readU16LE(this._temp_1_23_0, 0);
            this._exceptionState = 9;
            this._state_1 = 5;
            var tmp_3 = this;
            continue $sm;
          case 5:
            var tmp_4 = this._tmp$ret$05_5;
            this._tmp0_allocThis_0_12_0.free(this._temp_1_23_0);
            this._tmp$ret$41_4 = tmp_4;
            this._state_1 = 7;
            continue $sm;
          case 6:
            this._tmp0_allocThis_0_12_0.free(this._temp_1_23_0);
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 7;
            continue $sm;
          case 7:
            return this._tmp$ret$41_4;
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this._tmp0_allocThis_0_12_0.free(this._temp_1_23_0);
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readU16LECOROUTINE$167.$metadata$ = {
    simpleName: '$readU16LECOROUTINE$167',
    kind: 'class',
    interfaces: []
  };
  function readQueue$factory() {
    return getPropertyCallableRef('readQueue', 1, KProperty1, function (receiver) {
      return _get_readQueue_(receiver);
    }, null);
  }
  function writeQueue$factory() {
    return getPropertyCallableRef('writeQueue', 1, KProperty1, function (receiver) {
      return _get_writeQueue_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_100() {
    var i = new _no_name_provided__129();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_101() {
    var i = new _no_name_provided__130();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_102(this$0, $buffer, $offset, $len, resultContinuation) {
    var i = new _no_name_provided__131(this$0, $buffer, $offset, $len, resultContinuation);
    var l = function ($cont) {
      return i.invoke_1005($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_103(this$0, $buffer, $offset, $len, resultContinuation) {
    var i = new _no_name_provided__132(this$0, $buffer, $offset, $len, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function FastByteArrayInputStream_init_$Init$(ba, offset, start, end, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      start = 0;
    if (!(($mask0 & 8) === 0))
      end = ba.length;
    FastByteArrayInputStream.call($this, ba, offset, start, end);
    return $this;
  }
  function FastByteArrayInputStream_init_$Create$(ba, offset, start, end, $mask0, $marker) {
    return FastByteArrayInputStream_init_$Init$(ba, offset, start, end, $mask0, $marker, Object.create(FastByteArrayInputStream.prototype));
  }
  function FastByteArrayInputStream(ba, offset, start, end) {
    this._ba = ba;
    this._start_1 = start;
    this._end_0 = end;
    this._offset_16 = offset + this._start_1 | 0;
  }
  FastByteArrayInputStream.prototype._get_position__1 = function () {
    return this._offset_16 - this._start_1 | 0;
  };
  FastByteArrayInputStream.prototype._get_available__3 = function () {
    return this._end_0 - this._offset_16 | 0;
  };
  FastByteArrayInputStream.prototype.coerceRange = function (_this__0) {
    return coerceIn(_this__0, this._start_1, this._end_0);
  };
  FastByteArrayInputStream.prototype.sliceStart = function (offset) {
    return new FastByteArrayInputStream(this._ba, 0, this.coerceRange(this._start_1 + offset | 0), this._end_0);
  };
  FastByteArrayInputStream.prototype.sliceStart$default = function (offset, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset = 0;
    return this.sliceStart(offset);
  };
  FastByteArrayInputStream.prototype.clone_8 = function () {
    return new FastByteArrayInputStream(this._ba, this._get_position__1(), this._start_1, this._end_0);
  };
  FastByteArrayInputStream.prototype.sliceWithSize = function (offset, len) {
    return new FastByteArrayInputStream(this._ba, 0, this.coerceRange(this._start_1 + offset | 0), this.coerceRange((this._start_1 + offset | 0) + len | 0));
  };
  FastByteArrayInputStream.prototype.readBytesExact = function (len) {
    var out_1 = copyOfRange(this._ba, this._offset_16, this._offset_16 + len | 0);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + len | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readAll_0 = function () {
    return this.readBytesExact(this._get_available__3());
  };
  FastByteArrayInputStream.prototype.readS8 = function () {
    var tmp0_increment_0 = 1;
    var out_1 = readS8(this._ba, this._offset_16);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + tmp0_increment_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readU8 = function () {
    var tmp0_increment_0 = 1;
    var out_1 = readU8(this._ba, this._offset_16);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + tmp0_increment_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readS16LE = function () {
    var tmp0_increment_0 = 2;
    var out_1 = readS16LE(this._ba, this._offset_16);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + tmp0_increment_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readS16BE = function () {
    var tmp0_increment_0 = 2;
    var out_1 = readS16BE(this._ba, this._offset_16);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + tmp0_increment_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readU16BE = function () {
    var tmp0_increment_0 = 2;
    var out_1 = readU16BE(this._ba, this._offset_16);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + tmp0_increment_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readS32BE = function () {
    var tmp0_increment_0 = 4;
    var out_1 = readS32BE(this._ba, this._offset_16);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + tmp0_increment_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readF32LE = function () {
    var tmp0_increment_0 = 4;
    var out_1 = readF32LE(this._ba, this._offset_16);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + tmp0_increment_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readS64BE = function () {
    var tmp0_increment_0 = 8;
    var out_1 = readS64BE(this._ba, this._offset_16);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + tmp0_increment_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readBytes_1 = function (count_0) {
    var out_1 = readByteArray(this._ba, this._offset_16, count_0);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + count_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readShortArrayBE = function (count_0) {
    var tmp0_increment_0 = imul(count_0, 2);
    var out_1 = readShortArrayBE(this._ba, this._offset_16, count_0);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + tmp0_increment_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readCharArrayBE = function (count_0) {
    var tmp0_increment_0 = imul(count_0, 2);
    var out_1 = readCharArrayBE(this._ba, this._offset_16, count_0);
    var tmp0_this_2 = this;
    tmp0_this_2._offset_16 = tmp0_this_2._offset_16 + tmp0_increment_0 | 0;
    return out_1;
  };
  FastByteArrayInputStream.prototype.readU_VL = function () {
    var result = this.readU8();
    if ((result & 128) === 0)
      return result;
    result = result & 127 | this.readU8() << 7;
    if ((result & 16384) === 0)
      return result;
    result = result & 16383 | this.readU8() << 14;
    if ((result & 2097152) === 0)
      return result;
    result = result & 2097151 | this.readU8() << 21;
    if ((result & 268435456) === 0)
      return result;
    result = result & 268435455 | this.readU8() << 28;
    return result;
  };
  FastByteArrayInputStream.prototype.readS_VL = function () {
    var v = this.readU_VL();
    var sign = !((v & 1) === 0);
    var uvalue = v >>> 1;
    return sign ? (-uvalue | 0) - 1 | 0 : uvalue;
  };
  FastByteArrayInputStream.prototype.readString_0 = function (len, charset) {
    return toString_3(this.readBytes_1(len), charset);
  };
  FastByteArrayInputStream.prototype.readString$default_0 = function (len, charset, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return this.readString_0(len, charset);
  };
  FastByteArrayInputStream.prototype.readStringz = function (len, charset) {
    var res = this.readBytes_1(len);
    var index = indexOf$default_2(res, 0, 0, 0, 0, 14, null);
    return toString_3(copyOf(res, index < 0 ? len : index), charset);
  };
  FastByteArrayInputStream.prototype.readStringz$default = function (len, charset, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return this.readStringz(len, charset);
  };
  FastByteArrayInputStream.prototype.readStringVL = function (charset) {
    return this.readString_0(this.readU_VL(), charset);
  };
  FastByteArrayInputStream.prototype.readStringVL$default = function (charset, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      charset = UTF8;
    return this.readStringVL(charset);
  };
  FastByteArrayInputStream.$metadata$ = {
    simpleName: 'FastByteArrayInputStream',
    kind: 'class',
    interfaces: []
  };
  function openFastStream(_this_, offset) {
    return FastByteArrayInputStream_init_$Create$(_this_, offset, 0, 0, 12, null);
  }
  function openFastStream$default(_this_, offset, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      offset = 0;
    return openFastStream(_this_, offset);
  }
  function openAsync(_this_, mode) {
    return toAsyncStream(new MemoryAsyncStreamBase(ByteArrayBuilder_init_$Create$(_this_, 0, true, 2, null)), new Long(0, 0));
  }
  function openAsync$default(_this_, mode, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      mode = 'r';
    return openAsync(_this_, mode);
  }
  function SyncStream(base, position_1) {
    this._base_2 = base;
    this._position_6 = position_1;
    var tmp = this;
    tmp._$$delegate_0_3 = Mixin_init_$Create$(null, 1, null);
    this._smallTemp = this._base_2._smallTemp_0;
  }
  SyncStream.prototype._get_position__1 = function () {
    return this._position_6;
  };
  SyncStream.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_3._extra = _set___;
  };
  SyncStream.prototype._get_extra__71 = function () {
    return this._$$delegate_0_3._extra;
  };
  SyncStream.prototype.read_30 = function (buffer, offset, len) {
    var read_1 = this._base_2.read_37(this._position_6, buffer, offset, len);
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._position_6;
    tmp._position_6 = tmp0_plus_0.plus_64(toLong(read_1));
    return read_1;
  };
  SyncStream.prototype.read_36 = function () {
    var size_1 = this.read_30(this._smallTemp, 0, 1);
    if (size_1 <= 0)
      return -1;
    var tmp0__get_unsigned__0 = this._smallTemp[0];
    return tmp0__get_unsigned__0 & 255;
  };
  SyncStream.prototype.write_25 = function (buffer, offset, len) {
    this._base_2.write_30(this._position_6, buffer, offset, len);
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._position_6;
    tmp._position_6 = tmp0_plus_0.plus_64(toLong(len));
  };
  SyncStream.prototype.write_26 = function (byte) {
    this._smallTemp[0] = toByte(byte);
    this.write_25(this._smallTemp, 0, 1);
  };
  SyncStream.prototype._get_length__5 = function () {
    return this._base_2._get_length__5();
  };
  SyncStream.prototype._get_available__3 = function () {
    return this._get_length__5().minus_29(this._position_6);
  };
  SyncStream.prototype.close_77 = function () {
    return this._base_2.close_77();
  };
  SyncStream.prototype.toString = function () {
    return '' + 'SyncStream(' + this._base_2 + ', ' + this._position_6 + ')';
  };
  SyncStream.$metadata$ = {
    simpleName: 'SyncStream',
    kind: 'class',
    interfaces: [Extra, Closeable, SyncInputStream, SyncPositionStream, SyncOutputStream, SyncLengthStream]
  };
  function openSync(_this_, mode) {
    return toSyncStream(new MemorySyncStreamBase(ByteArrayBuilder_init_$Create$(_this_, 0, false, 6, null)), new Long(0, 0));
  }
  function openSync$default(_this_, mode, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      mode = 'r';
    return openSync(_this_, mode);
  }
  function SyncInputStream() {
  }
  SyncInputStream.prototype.read$default_1 = function (buffer, offset, len, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      len = buffer.length - offset | 0;
    return $handler == null ? this.read_30(buffer, offset, len) : $handler(buffer, offset, len);
  };
  SyncInputStream.prototype.read_36 = function () {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_alloc_0 = _get_smallBytesPool_();
      var temp_1 = tmp0_alloc_0.alloc();
      try {
        var tmp;
        if (this.read_30(temp_1, 0, 1) > 0) {
          var tmp0__get_unsigned__0_3 = temp_1[0];
          tmp = tmp0__get_unsigned__0_3 & 255;
        } else {
          tmp = -1;
        }
        tmp$ret$0 = tmp;
        break l$ret$1;
      }finally {
        tmp0_alloc_0.free(temp_1);
      }
    }
     while (false);
    return tmp$ret$0;
  };
  SyncInputStream.$metadata$ = {
    simpleName: 'SyncInputStream',
    kind: 'interface',
    interfaces: [OptionalCloseable]
  };
  function SyncPositionStream() {
  }
  SyncPositionStream.$metadata$ = {
    simpleName: 'SyncPositionStream',
    kind: 'interface',
    interfaces: []
  };
  function SyncOutputStream() {
  }
  SyncOutputStream.prototype.write_26 = function (byte) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_alloc_0 = _get_smallBytesPool_();
      var temp_1 = tmp0_alloc_0.alloc();
      try {
        temp_1[0] = toByte(byte);
        tmp$ret$0 = this.write_25(temp_1, 0, 1);
        break l$ret$1;
      }finally {
        tmp0_alloc_0.free(temp_1);
      }
    }
     while (false);
    return tmp$ret$0;
  };
  SyncOutputStream.$metadata$ = {
    simpleName: 'SyncOutputStream',
    kind: 'interface',
    interfaces: [OptionalCloseable]
  };
  function SyncLengthStream() {
  }
  SyncLengthStream.$metadata$ = {
    simpleName: 'SyncLengthStream',
    kind: 'interface',
    interfaces: []
  };
  function SyncStreamBase() {
    this._smallTemp_0 = new Int8Array(16);
  }
  SyncStreamBase.prototype.read_37 = function (position_1, buffer, offset, len) {
    unsupported_0();
  };
  SyncStreamBase.prototype.write_30 = function (position_1, buffer, offset, len) {
    unsupported_0();
  };
  SyncStreamBase.prototype._get_length__5 = function () {
    unsupported_0();
  };
  SyncStreamBase.prototype.close_77 = function () {
    return Unit_getInstance();
  };
  SyncStreamBase.$metadata$ = {
    simpleName: 'SyncStreamBase',
    kind: 'class',
    interfaces: [Closeable, SyncRAInputStream, SyncRAOutputStream, SyncLengthStream]
  };
  function toSyncStream(_this_, position_1) {
    return new SyncStream(_this_, position_1);
  }
  function toSyncStream$default(_this_, position_1, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      position_1 = new Long(0, 0);
    return toSyncStream(_this_, position_1);
  }
  function MemorySyncStreamBase(data) {
    SyncStreamBase.call(this);
    this._data_14 = data;
  }
  MemorySyncStreamBase.prototype._get_ilength__0 = function () {
    return this._data_14._get_size__60();
  };
  MemorySyncStreamBase.prototype._get_length__5 = function () {
    return toLong(this._data_14._get_size__60());
  };
  MemorySyncStreamBase.prototype.checkPosition_0 = function (position_1) {
    var tmp;
    if (position_1.compareTo_137(new Long(0, 0)) < 0) {
      invalidOp('' + 'Invalid position ' + position_1);
    }return tmp;
  };
  MemorySyncStreamBase.prototype.read_37 = function (position_1, buffer, offset, len) {
    this.checkPosition_0(position_1);
    var ipos = position_1.toInt_8();
    if (!((new Long(0, 0)).compareTo_137(position_1) <= 0 ? position_1.compareTo_137(toLong(this._get_ilength__0())) < 0 : false))
      return 0;
    var end = min2_0(this._get_ilength__0(), ipos + len | 0);
    var actualLen = max2_1(end - ipos | 0, 0);
    arraycopy_2(this._data_14._data_8, ipos, buffer, offset, actualLen);
    return actualLen;
  };
  MemorySyncStreamBase.prototype.write_30 = function (position_1, buffer, offset, len) {
    this.checkPosition_0(position_1);
    var tmp = this._data_14;
    var tmp_0 = this._data_14._get_size__60();
    tmp._set_size__1(max2_1(tmp_0, position_1.plus_64(toLong(len)).toInt_8()));
    arraycopy_2(buffer, offset, this._data_14._data_8, position_1.toInt_8(), len);
  };
  MemorySyncStreamBase.prototype.close_77 = function () {
    return Unit_getInstance();
  };
  MemorySyncStreamBase.prototype.toString = function () {
    return '' + 'MemorySyncStreamBase(' + this._data_14._get_size__60() + ')';
  };
  MemorySyncStreamBase.$metadata$ = {
    simpleName: 'MemorySyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function SyncRAInputStream() {
  }
  SyncRAInputStream.$metadata$ = {
    simpleName: 'SyncRAInputStream',
    kind: 'interface',
    interfaces: []
  };
  function SyncRAOutputStream() {
  }
  SyncRAOutputStream.$metadata$ = {
    simpleName: 'SyncRAOutputStream',
    kind: 'interface',
    interfaces: []
  };
  function write8_1(_this_, v) {
    return _this_.write_26(v);
  }
  function MemorySyncStream(data) {
    var tmp = new MemorySyncStreamBase(ByteArrayBuilder_init_$Create$(data, 0, false, 6, null));
    return toSyncStream$default(tmp, new Long(0, 0), 1, null);
  }
  function MemorySyncStream$default(data, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      data = EMPTY_BYTE_ARRAY;
    return MemorySyncStream(data);
  }
  function MemorySyncStream_0(data) {
    var tmp = new MemorySyncStreamBase(data);
    return toSyncStream$default(tmp, new Long(0, 0), 1, null);
  }
  function readString_0(_this_, len, charset) {
    return toString_3(readBytes_0(_this_, len), charset);
  }
  function readString$default_0(_this_, len, charset, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return readString_0(_this_, len, charset);
  }
  function readU8_2(_this_) {
    return _this_.read_36();
  }
  function readU16LE_1(_this_) {
    return readU8_2(_this_) | readU8_2(_this_) << 8;
  }
  function readS16LE_1(_this_) {
    return signExtend(readU16LE_1(_this_), 16);
  }
  function readBytes_0(_this_, len) {
    var bytes = new Int8Array(len);
    return copyOf(bytes, _this_.read_30(bytes, 0, len));
  }
  function write16LE_1(_this_, v) {
    write8_1(_this_, v & 255);
    return write8_1(_this_, v >>> 8 & 255);
  }
  function writeBytes_0(_this_, data) {
    return _this_.write_25(data, 0, data.length);
  }
  function sliceStart_0(_this_, start) {
    return sliceWithBounds_0(_this_, start, _this_._get_length__5());
  }
  function sliceStart$default_0(_this_, start, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      start = new Long(0, 0);
    return sliceStart_0(_this_, start);
  }
  function readStringz(_this_, len, charset) {
    var res = readBytes_0(_this_, len);
    var index = indexOf_2(res, 0);
    return toString_3(copyOf(res, index < 0 ? len : index), charset);
  }
  function readStringz$default(_this_, len, charset, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      charset = UTF8;
    return readStringz(_this_, len, charset);
  }
  function readS32LE_1(_this_) {
    return readU8_2(_this_) | readU8_2(_this_) << 8 | readU8_2(_this_) << 16 | readU8_2(_this_) << 24;
  }
  function skip(_this_, count_0) {
    var tmp0_this = _this_;
    var tmp = tmp0_this;
    var tmp0_plus_0 = tmp0_this._position_6;
    tmp._position_6 = tmp0_plus_0.plus_64(toLong(count_0));
    return _this_;
  }
  function write32LE_0(_this_, v) {
    write8_1(_this_, v & 255);
    write8_1(_this_, v >>> 8 & 255);
    write8_1(_this_, v >>> 16 & 255);
    return write8_1(_this_, v >>> 24 & 255);
  }
  function write32BE_1(_this_, v) {
    write8_1(_this_, v >>> 24 & 255);
    write8_1(_this_, v >>> 16 & 255);
    write8_1(_this_, v >>> 8 & 255);
    return write8_1(_this_, v & 255);
  }
  function readS32BE_1(_this_) {
    return readU8_2(_this_) << 24 | readU8_2(_this_) << 16 | readU8_2(_this_) << 8 | readU8_2(_this_);
  }
  function readStream_0(_this_, length) {
    return readSlice_0(_this_, length);
  }
  function readAll_0(_this_) {
    return readBytes_0(_this_, _this_._get_available__3().toInt_8());
  }
  function _get_eof_(_this_) {
    return _this_._get_available__3().compareTo_137(new Long(0, 0)) <= 0;
  }
  function sliceWithBounds_0(_this_, start, end) {
    var len = _this_._get_length__5();
    var clampedStart = clamp_4(start, new Long(0, 0), len);
    var clampedEnd = clamp_4(end, new Long(0, 0), len);
    var tmp = _this_._base_2;
    if (tmp instanceof SliceSyncStreamBase) {
      var tmp_0 = new SliceSyncStreamBase(_this_._base_2._base_3, _this_._base_2._baseStart_0.plus_64(clampedStart), _this_._base_2._baseStart_0.plus_64(clampedEnd));
      return toSyncStream$default(tmp_0, new Long(0, 0), 1, null);
    } else {
      {
        var tmp_1 = new SliceSyncStreamBase(_this_._base_2, clampedStart, clampedEnd);
        return toSyncStream$default(tmp_1, new Long(0, 0), 1, null);
      }
    }
  }
  function readSlice_0(_this_, length) {
    var tmp0_apply_0 = sliceWithSize_0(_this_, _this_._position_6, length);
    var tmp0_this_2 = _this_;
    tmp0_this_2._position_6 = tmp0_this_2._position_6.plus_64(length);
    return tmp0_apply_0;
  }
  function clampPosition_0($this, position_1) {
    return clamp_4(position_1, $this._baseStart_0, $this._baseEnd_0);
  }
  function clampPositionLen_0($this, position_1, len) {
    if (position_1.compareTo_137(new Long(0, 0)) < 0)
      throw IllegalArgumentException_init_$Create$('Invalid position');
    var targetStartPosition = clampPosition_0($this, $this._baseStart_0.plus_64(position_1));
    var targetEndPosition = clampPosition_0($this, targetStartPosition.plus_64(toLong(len)));
    var targetLen = targetEndPosition.minus_29(targetStartPosition).toInt_8();
    return new Pair(targetStartPosition, targetLen);
  }
  function SliceSyncStreamBase(base, baseStart, baseEnd) {
    SyncStreamBase.call(this);
    this._base_3 = base;
    this._baseStart_0 = baseStart;
    this._baseEnd_0 = baseEnd;
    this._baseLength_0 = this._baseEnd_0.minus_29(this._baseStart_0);
  }
  SliceSyncStreamBase.prototype._get_length__5 = function () {
    return this._baseLength_0;
  };
  SliceSyncStreamBase.prototype.read_37 = function (position_1, buffer, offset, len) {
    var tmp0_container = clampPositionLen_0(this, position_1, len);
    var targetStartPosition = tmp0_container.component1_1();
    var targetLen = tmp0_container.component2_1();
    return this._base_3.read_37(targetStartPosition, buffer, offset, targetLen);
  };
  SliceSyncStreamBase.prototype.write_30 = function (position_1, buffer, offset, len) {
    var tmp0_container = clampPositionLen_0(this, position_1, len);
    var targetStartPosition = tmp0_container.component1_1();
    var targetLen = tmp0_container.component2_1();
    return this._base_3.write_30(targetStartPosition, buffer, offset, targetLen);
  };
  SliceSyncStreamBase.prototype.close_77 = function () {
    return Unit_getInstance();
  };
  SliceSyncStreamBase.prototype.toString = function () {
    return '' + 'SliceAsyncStreamBase(' + this._base_3 + ', ' + this._baseStart_0 + ', ' + this._baseEnd_0 + ')';
  };
  SliceSyncStreamBase.$metadata$ = {
    simpleName: 'SliceSyncStreamBase',
    kind: 'class',
    interfaces: []
  };
  function sliceWithSize_0(_this_, position_1, length) {
    return sliceWithBounds_0(_this_, position_1, position_1.plus_64(length));
  }
  function readU32LE_1(_this_) {
    return toLong(readU8_2(_this_) | readU8_2(_this_) << 8 | readU8_2(_this_) << 16 | readU8_2(_this_) << 24).and(new Long(-1, 0));
  }
  var traceTimes$delegate;
  function _no_name_provided__135() {
  }
  _no_name_provided__135.prototype.invoke_1005 = function () {
    return Environment_getInstance().get_115('TRACE_TIMES') === 'true';
  };
  _no_name_provided__135.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_104() {
    var i = new _no_name_provided__135();
    return function () {
      return i.invoke_1005();
    };
  }
  function indexOf_9(_this_, v, startOffset, endOffset, default_0) {
    var tmp$ret$0;
    l$ret$1: do {
      var inductionVariable = startOffset;
      if (inductionVariable < endOffset)
        do {
          var n_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this_[n_2] === v) {
            tmp$ret$0 = n_2;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable < endOffset);
      tmp$ret$0 = default_0;
    }
     while (false);
    return tmp$ret$0;
  }
  function indexOf$default_2(_this_, v, startOffset, endOffset, default_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startOffset = 0;
    if (!(($mask0 & 4) === 0))
      endOffset = _this_.length;
    if (!(($mask0 & 8) === 0))
      default_0 = -1;
    return indexOf_9(_this_, v, startOffset, endOffset, default_0);
  }
  function isWhitespaceFast(_this_) {
    return ((_this_.equals(new Char(32)) ? true : _this_.equals(new Char(9))) ? true : _this_.equals(new Char(13))) ? true : _this_.equals(new Char(10));
  }
  function isLetterDigitOrUnderscore(_this_) {
    return (isLetterOrDigit(_this_) ? true : _this_.equals(new Char(95))) ? true : _this_.equals(new Char(36));
  }
  function isLetterOrDigit(_this_) {
    return isLetter(_this_) ? true : isDigit(_this_);
  }
  function isLetter(_this_) {
    return (new Char(97) <= _this_ ? _this_ <= new Char(122) : false) ? true : new Char(65) <= _this_ ? _this_ <= new Char(90) : false;
  }
  function isDigit(_this_) {
    return new Char(48) <= _this_ ? _this_ <= new Char(57) : false;
  }
  function Text_1() {
  }
  Text_1.$metadata$ = {
    simpleName: 'Text',
    kind: 'interface',
    interfaces: [Action]
  };
  function Marker() {
  }
  Marker.$metadata$ = {
    simpleName: 'Marker',
    kind: 'class',
    interfaces: [Action]
  };
  function Inline(str) {
    this._str_0 = str;
  }
  Inline.prototype._get_str__1 = function () {
    return this._str_0;
  };
  Inline.prototype.toString = function () {
    return '' + 'Inline(str=' + this._str_0 + ')';
  };
  Inline.prototype.hashCode = function () {
    return getStringHashCode(this._str_0);
  };
  Inline.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Inline))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Inline ? other : THROW_CCE();
    if (!(this._str_0 === tmp0_other_with_cast._str_0))
      return false;
    return true;
  };
  Inline.$metadata$ = {
    simpleName: 'Inline',
    kind: 'class',
    interfaces: [Text_1]
  };
  function Line(str) {
    this._str_1 = str;
  }
  Line.prototype._get_str__1 = function () {
    return this._str_1;
  };
  Line.prototype.toString = function () {
    return '' + 'Line(str=' + this._str_1 + ')';
  };
  Line.prototype.hashCode = function () {
    return getStringHashCode(this._str_1);
  };
  Line.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!(this._str_1 === tmp0_other_with_cast._str_1))
      return false;
    return true;
  };
  Line.$metadata$ = {
    simpleName: 'Line',
    kind: 'class',
    interfaces: [Text_1]
  };
  function LineDeferred() {
  }
  LineDeferred.$metadata$ = {
    simpleName: 'LineDeferred',
    kind: 'class',
    interfaces: [Action]
  };
  function EmptyLineOnce() {
    EmptyLineOnce_instance = this;
  }
  EmptyLineOnce.$metadata$ = {
    simpleName: 'EmptyLineOnce',
    kind: 'object',
    interfaces: [Action]
  };
  var EmptyLineOnce_instance;
  function EmptyLineOnce_getInstance() {
    if (EmptyLineOnce_instance == null)
      new EmptyLineOnce();
    return EmptyLineOnce_instance;
  }
  function Indent() {
    Indent_instance = this;
  }
  Indent.$metadata$ = {
    simpleName: 'Indent',
    kind: 'object',
    interfaces: [Action]
  };
  var Indent_instance;
  function Indent_getInstance() {
    if (Indent_instance == null)
      new Indent();
    return Indent_instance;
  }
  function Unindent() {
    Unindent_instance = this;
  }
  Unindent.$metadata$ = {
    simpleName: 'Unindent',
    kind: 'object',
    interfaces: [Action]
  };
  var Unindent_instance;
  function Unindent_getInstance() {
    if (Unindent_instance == null)
      new Unindent();
    return Unindent_instance;
  }
  function Indenter_init_$Init$(actions, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      actions = ArrayList_init_$Create$();
    }Indenter.call($this, actions);
    return $this;
  }
  function Indenter_init_$Create$(actions, $mask0, $marker) {
    return Indenter_init_$Init$(actions, $mask0, $marker, Object.create(Indenter.prototype));
  }
  function INDENTS() {
    INDENTS_instance = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 1024;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = '';
      tmp_0 = tmp_0 + 1 | 0;
    }
    var tmp0_apply_0 = tmp_2;
    var indent_2 = StringBuilder_init_$Create$_0();
    var inductionVariable = 0;
    var last_1 = tmp0_apply_0.length;
    if (inductionVariable < last_1)
      do {
        var n_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0[n_4] = indent_2.toString();
        indent_2.append_5('\t');
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp._INDENTS = tmp0_apply_0;
  }
  INDENTS.prototype.get_137 = function (index) {
    if (index >= this._INDENTS.length) {
      var tmp0_TODO_0 = '' + 'Too much indentation ' + index;
      throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
    }return index <= 0 ? '' : this._INDENTS[index];
  };
  INDENTS.$metadata$ = {
    simpleName: 'INDENTS',
    kind: 'object',
    interfaces: []
  };
  var INDENTS_instance;
  function INDENTS_getInstance() {
    if (INDENTS_instance == null)
      new INDENTS();
    return INDENTS_instance;
  }
  function Action() {
  }
  Action.$metadata$ = {
    simpleName: 'Action',
    kind: 'interface',
    interfaces: []
  };
  function Companion_58() {
    Companion_instance_57 = this;
    var tmp = this;
    var tmp0_gen_0 = Companion_getInstance_57();
    var indenter_1 = Indenter_init_$Create$(null, 1, null);
    Unit_getInstance();
    tmp._EMPTY_4 = indenter_1;
  }
  Companion_58.prototype.invoke_219 = function (init) {
    var indenter_1 = Indenter_init_$Create$(null, 1, null);
    init(indenter_1);
    return indenter_1;
  };
  Companion_58.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_57;
  function Companion_getInstance_57() {
    if (Companion_instance_57 == null)
      new Companion_58();
    return Companion_instance_57;
  }
  function IndenterEvaluator(markHandler, indentEmptyLines, doIndent) {
    this._markHandler = markHandler;
    this._indentEmptyLines = indentEmptyLines;
    this._doIndent = doIndent;
    this._out_5 = StringBuilder_init_$Create$_0();
    this._line = 0;
    this._newLine = true;
    this._indentIndex = 0;
    this._allowEmptyLine = false;
  }
  IndenterEvaluator.prototype.outAppend = function (str) {
    return this._out_5.append_5(str);
  };
  IndenterEvaluator.prototype.outAppend_0 = function (str) {
    return this._out_5.append_2(str);
  };
  IndenterEvaluator.prototype.doLine = function () {
    if (this._doIndent) {
      this.outAppend_0(new Char(10));
      Unit_getInstance();
    }var tmp0_this = this;
    var tmp1 = tmp0_this._line;
    tmp0_this._line = tmp1 + 1 | 0;
    Unit_getInstance();
    this._newLine = true;
  };
  IndenterEvaluator.prototype.eval = function (actions) {
    var n_1 = 0;
    while (n_1 < actions._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp0__anonymous__3 = actions.get_137(tmp0_2);
      var tmp0_subject_4 = tmp0__anonymous__3;
      if (isInterface(tmp0_subject_4, Text_1)) {
        if (this._newLine) {
          var tmp;
          if (!this._indentEmptyLines) {
            var tmp0_isEmpty_0_5 = tmp0__anonymous__3._get_str__1();
            tmp = charSequenceLength(tmp0_isEmpty_0_5) === 0;
          } else {
            tmp = false;
          }
          if (tmp) {
            this.doLine();
          } else {
            {
              if (this._doIndent) {
                this.outAppend(INDENTS_getInstance().get_137(this._indentIndex));
                Unit_getInstance();
              } else {
                this.outAppend(' ');
                Unit_getInstance();
              }
            }
          }
        }this.outAppend(tmp0__anonymous__3._get_str__1());
        Unit_getInstance();
        if (tmp0__anonymous__3 instanceof Line) {
          var tmp1_this_6 = this;
          var tmp_0 = tmp1_this_6;
          var tmp_1 = tmp1_this_6._line;
          var tmp1_count_0_7 = tmp0__anonymous__3._get_str__1();
          var count_1_8 = 0;
          var indexedObject = tmp1_count_0_7;
          var inductionVariable = 0;
          var last_1 = indexedObject.length;
          while (inductionVariable < last_1) {
            var element_3_10 = charSequenceGet(indexedObject, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            if (element_3_10.equals(new Char(10))) {
              count_1_8 = count_1_8 + 1 | 0;
              Unit_getInstance();
            } else {
            }
          }
          tmp_0._line = tmp_1 + count_1_8 | 0;
          this.doLine();
        } else {
          {
            this._newLine = false;
          }
        }
        this._allowEmptyLine = true;
      } else {
        if (tmp0_subject_4 instanceof LineDeferred)
          this.eval(tmp0__anonymous__3._callback_1()._actions);
        else {
          if (equals_1(tmp0_subject_4, Indent_getInstance()) ? true : equals_1(tmp0_subject_4, Unindent_getInstance())) {
            this._allowEmptyLine = false;
            var tmp2_this_11 = this;
            tmp2_this_11._indentIndex = tmp2_this_11._indentIndex + (equals_1(tmp0__anonymous__3, Indent_getInstance()) ? 1 : -1) | 0;
          } else {
            if (equals_1(tmp0_subject_4, EmptyLineOnce_getInstance())) {
              if (this._allowEmptyLine) {
                this.doLine();
                this._allowEmptyLine = false;
              }} else {
              if (tmp0_subject_4 instanceof Marker) {
                var tmp3_safe_receiver_12 = this._markHandler;
                if (tmp3_safe_receiver_12 == null)
                  null;
                else
                  tmp3_safe_receiver_12(this._out_5, this._line, tmp0__anonymous__3._data_15);
                Unit_getInstance();
              } else {
              }
            }
          }
        }
      }
    }
  };
  IndenterEvaluator.$metadata$ = {
    simpleName: 'IndenterEvaluator',
    kind: 'class',
    interfaces: []
  };
  function Indenter(actions) {
    Companion_getInstance_57();
    this._actions = actions;
    this._indentEmptyLines_0 = true;
    this._out_6 = '';
  }
  Indenter.prototype.inline = function (str) {
    this._actions.add_39(new Inline(str));
    Unit_getInstance();
    return this;
  };
  Indenter.prototype.line = function (indenter) {
    this._actions.addAll_24(indenter._actions);
    Unit_getInstance();
    return this;
  };
  Indenter.prototype.line_0 = function (str) {
    this._actions.add_39(new Line(str));
    Unit_getInstance();
    return this;
  };
  Indenter.prototype._indent = function () {
    this._actions.add_39(Indent_getInstance());
    Unit_getInstance();
  };
  Indenter.prototype._unindent = function () {
    this._actions.add_39(Unindent_getInstance());
    Unit_getInstance();
  };
  Indenter.prototype.toString_2 = function (markHandler, doIndent) {
    var tmp0_apply_0 = new IndenterEvaluator(markHandler, this._indentEmptyLines_0, doIndent);
    tmp0_apply_0.eval(this._actions);
    return tmp0_apply_0._out_5.toString();
  };
  Indenter.prototype.toString_3 = function (doIndent, indentChunk) {
    var out = this.toString_2(null, doIndent);
    var tmp;
    if (indentChunk === '\t') {
      tmp = out;
    } else {
      tmp = replace$default_0(out, '\t', indentChunk, false, 4, null);
    }
    return tmp;
  };
  Indenter.prototype.toString = function () {
    return this.toString_2(null, true);
  };
  Indenter.$metadata$ = {
    simpleName: 'Indenter',
    kind: 'class',
    interfaces: []
  };
  function toStringDecimal(_this_, decimalPlaces, skipTrailingZeros) {
    if (isNanOrInfinite(_this_))
      return _this_.toString();
    var res = _this_.toString();
    var tmp = new Char(69);
    var containsEup = contains$default(res, tmp, false, 2, null);
    var tmp_0 = new Char(101);
    var containsElo = contains$default(res, tmp_0, false, 2, null);
    var tmp_1;
    if (containsEup ? true : containsElo) {
      var tmp_2 = charArrayOf([containsEup ? new Char(69) : new Char(101)]);
      var tmp0_container = split$default(res, tmp_2, false, 2, 2, null);
      var base = tmp0_container.get_137(0);
      var exp = tmp0_container.get_137(1);
      var tmp_3;
      if (contains$default_0(base, '.', false, 2, null)) {
        tmp_3 = base;
      } else {
        {
          tmp_3 = '' + base + '.0';
        }
      }
      var rbase = tmp_3;
      var expInt = toInt(exp);
      var zeros = repeat('0', abs(expInt) + 2 | 0);
      var part = expInt > 0 ? '' + rbase + zeros : '' + zeros + rbase;
      var pointIndex = indexOf$default_0(part, '.', 0, false, 6, null);
      var outIndex = pointIndex + expInt | 0;
      var part2 = replace$default_0(part, '.', '', false, 4, null);
      var tmp0_replace_0 = substr_0(part2, 0, outIndex) + '.' + substr_1(part2, outIndex);
      var tmp1_replace_0 = Regex_init_$Create$('^0+\\.');
      var tmp2_replace_0 = '0.';
      tmp_1 = tmp1_replace_0.replace_0(tmp0_replace_0, tmp2_replace_0);
    } else {
      tmp_1 = res;
    }
    var rez = tmp_1;
    var tmp_4 = charArrayOf([new Char(46)]);
    var parts_0 = split$default(rez, tmp_4, false, 2, 2, null);
    var tmp3_getOrElse_0 = 0;
    var tmp_5;
    if (tmp3_getOrElse_0 >= 0 ? tmp3_getOrElse_0 <= _get_lastIndex__3(parts_0) : false) {
      tmp_5 = parts_0.get_137(tmp3_getOrElse_0);
    } else {
      tmp_5 = '0';
    }
    var integral = tmp_5;
    var tmp4_getOrElse_0 = 1;
    var tmp_6;
    if (tmp4_getOrElse_0 >= 0 ? tmp4_getOrElse_0 <= _get_lastIndex__3(parts_0) : false) {
      tmp_6 = parts_0.get_137(tmp4_getOrElse_0);
    } else {
      tmp_6 = '0';
    }
    var decimal = tmp_6;
    if (decimalPlaces === 0)
      return integral;
    var out = integral + '.' + substr_0(decimal + repeat('0', decimalPlaces), 0, decimalPlaces);
    if (skipTrailingZeros) {
      $l$break: while (true) {
        var tmp_7 = out;
        var tmp_8 = new Char(48);
        if (!endsWith$default(tmp_7, tmp_8, false, 2, null)) {
          break $l$break;
        }var tmp5_substring_0 = out;
        var tmp6_substring_0 = 0;
        var tmp7_substring_0 = out.length - 1 | 0;
        out = tmp5_substring_0.substring(tmp6_substring_0, tmp7_substring_0);
      }
      var tmp_9 = out;
      var tmp_10 = new Char(46);
      if (endsWith$default(tmp_9, tmp_10, false, 2, null)) {
        var tmp8_substring_0 = out;
        var tmp9_substring_0 = 0;
        var tmp10_substring_0 = out.length - 1 | 0;
        out = tmp8_substring_0.substring(tmp9_substring_0, tmp10_substring_0);
      } else {
      }
    }return out;
  }
  function _get_niceStr__0(_this_) {
    return round(_this_) === _this_ ? '' + numberToLong(_this_) : '' + _this_;
  }
  function _get_niceStr__1(_this_) {
    var tmp;
    if (round(_this_) === _this_) {
      tmp = '' + numberToLong(_this_);
    } else {
      {
        tmp = '' + _this_;
      }
    }
    return tmp;
  }
  function NumberParser() {
    NumberParser_instance = this;
  }
  NumberParser.prototype.parseInt = function (str, start, end, radix) {
    var positive = true;
    var out = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(str, n);
        if (c.equals(new Char(45)) ? true : c.equals(new Char(43))) {
          positive = c.equals(new Char(43));
        } else {
          var value = ctypeAsInt(c);
          if (value < 0)
            break loop;
          out = imul(out, radix);
          out = out + value | 0;
        }
      }
       while (inductionVariable < end);
    return positive ? out : -out | 0;
  };
  NumberParser.prototype.parseDouble = function (str, start, end) {
    var out = 0.0;
    var frac = 1.0;
    var pointSeen = false;
    var eSeen = false;
    var negate_0 = false;
    var negateExponent = false;
    var exponent = 0;
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(str, n);
        var tmp1_subject = c;
        if (tmp1_subject.equals(new Char(101)) ? true : tmp1_subject.equals(new Char(69)))
          eSeen = true;
        else if (tmp1_subject.equals(new Char(45))) {
          if (eSeen)
            negateExponent = true;
          else
            negate_0 = true;
        } else if (tmp1_subject.equals(new Char(46)))
          pointSeen = true;
        else {
          if (eSeen) {
            exponent = imul(exponent, 10);
            exponent = exponent + ctypeAsInt(c) | 0;
          } else {
            if (pointSeen)
              frac = frac / 10;
            out = out * 10;
            out = out + ctypeAsInt(c);
          }
        }
      }
       while (inductionVariable < end);
    var tmp = out * frac;
    var tmp0_pow_0 = 10.0;
    var tmp1_pow_0 = negateExponent ? -exponent | 0 : exponent;
    var res = tmp * Math.pow(tmp0_pow_0, tmp1_pow_0);
    return negate_0 ? -res : res;
  };
  NumberParser.$metadata$ = {
    simpleName: 'NumberParser',
    kind: 'object',
    interfaces: []
  };
  var NumberParser_instance;
  function NumberParser_getInstance() {
    if (NumberParser_instance == null)
      new NumberParser();
    return NumberParser_instance;
  }
  function ctypeAsInt(_this_) {
    return (_this_.compareTo_10(new Char(48)) >= 0 ? _this_.compareTo_10(new Char(57)) <= 0 : false) ? _this_.minus(new Char(48)) : (_this_.compareTo_10(new Char(97)) >= 0 ? _this_.compareTo_10(new Char(122)) <= 0 : false) ? _this_.minus(new Char(97)) + 10 | 0 : (_this_.compareTo_10(new Char(65)) >= 0 ? _this_.compareTo_10(new Char(90)) <= 0 : false) ? _this_.minus(new Char(65)) + 10 | 0 : -1;
  }
  function _no_name_provided__136() {
  }
  _no_name_provided__136.prototype.invoke_1005 = function () {
    var tmp0_toLowerCase_0 = OS_getInstance()._get_rawName_();
    return tmp0_toLowerCase_0.toLowerCase();
  };
  _no_name_provided__136.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__137() {
  }
  _no_name_provided__137.prototype.invoke_1005 = function () {
    var tmp0_toLowerCase_0 = OS_getInstance()._get_platformName_();
    return tmp0_toLowerCase_0.toLowerCase();
  };
  _no_name_provided__137.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__138() {
  }
  _no_name_provided__138.prototype.invoke_1005 = function () {
    var tmp = OS_getInstance()._get_rawNameLC_();
    return contains$default_0(tmp, 'win', false, 2, null);
  };
  _no_name_provided__138.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__139() {
  }
  _no_name_provided__139.prototype.invoke_1005 = function () {
    var tmp;
    var tmp_0;
    var tmp_1 = OS_getInstance()._get_rawNameLC_();
    if (contains$default_0(tmp_1, 'nix', false, 2, null)) {
      tmp_0 = true;
    } else {
      {
        var tmp_2 = OS_getInstance()._get_rawNameLC_();
        tmp_0 = contains$default_0(tmp_2, 'nux', false, 2, null);
      }
    }
    if (tmp_0) {
      tmp = true;
    } else {
      {
        var tmp_3 = OS_getInstance()._get_rawNameLC_();
        tmp = contains$default_0(tmp_3, 'aix', false, 2, null);
      }
    }
    return tmp;
  };
  _no_name_provided__139.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__140() {
  }
  _no_name_provided__140.prototype.invoke_1005 = function () {
    var tmp = OS_getInstance()._get_rawNameLC_();
    return contains$default_0(tmp, 'mac', false, 2, null);
  };
  _no_name_provided__140.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__141() {
  }
  _no_name_provided__141.prototype.invoke_1005 = function () {
    var tmp = OS_getInstance()._get_rawNameLC_();
    return contains$default_0(tmp, 'ios', false, 2, null);
  };
  _no_name_provided__141.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__142() {
  }
  _no_name_provided__142.prototype.invoke_1005 = function () {
    var tmp = OS_getInstance()._get_platformNameLC_();
    return contains$default_0(tmp, 'android', false, 2, null);
  };
  _no_name_provided__142.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__143() {
  }
  _no_name_provided__143.prototype.invoke_1005 = function () {
    var tmp = OS_getInstance()._get_rawNameLC_();
    return contains$default_0(tmp, 'watchos', false, 2, null);
  };
  _no_name_provided__143.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__144() {
  }
  _no_name_provided__144.prototype.invoke_1005 = function () {
    var tmp = OS_getInstance()._get_rawNameLC_();
    return contains$default_0(tmp, 'tvos', false, 2, null);
  };
  _no_name_provided__144.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function OS() {
    OS_instance = this;
    var tmp = this;
    tmp._rawNameLC$delegate = lazy(_no_name_provided_$factory_105());
    var tmp_0 = this;
    tmp_0._platformNameLC$delegate = lazy(_no_name_provided_$factory_106());
    var tmp_1 = this;
    tmp_1._isWindows$delegate = lazy(_no_name_provided_$factory_107());
    var tmp_2 = this;
    tmp_2._isLinux$delegate = lazy(_no_name_provided_$factory_108());
    var tmp_3 = this;
    tmp_3._isMac$delegate = lazy(_no_name_provided_$factory_109());
    var tmp_4 = this;
    tmp_4._isIos$delegate = lazy(_no_name_provided_$factory_110());
    var tmp_5 = this;
    tmp_5._isAndroid$delegate = lazy(_no_name_provided_$factory_111());
    var tmp_6 = this;
    tmp_6._isWatchos$delegate = lazy(_no_name_provided_$factory_112());
    var tmp_7 = this;
    tmp_7._isTvos$delegate = lazy(_no_name_provided_$factory_113());
  }
  OS.prototype._get_rawName_ = function () {
    return _get_rawOsName_();
  };
  OS.prototype._get_rawNameLC_ = function () {
    var tmp0_getValue_0 = this._rawNameLC$delegate;
    var tmp1_getValue_0 = rawNameLC$factory();
    return tmp0_getValue_0._get_value__10();
  };
  OS.prototype._get_platformName_ = function () {
    return rawPlatformName;
  };
  OS.prototype._get_platformNameLC_ = function () {
    var tmp0_getValue_0 = this._platformNameLC$delegate;
    var tmp1_getValue_0 = platformNameLC$factory();
    return tmp0_getValue_0._get_value__10();
  };
  OS.prototype._get_isWindows_ = function () {
    var tmp0_getValue_0 = this._isWindows$delegate;
    var tmp1_getValue_0 = isWindows$factory();
    return tmp0_getValue_0._get_value__10();
  };
  OS.prototype._get_isMac_ = function () {
    var tmp0_getValue_0 = this._isMac$delegate;
    var tmp1_getValue_0 = isMac$factory();
    return tmp0_getValue_0._get_value__10();
  };
  OS.prototype._get_isNative_ = function () {
    return rawPlatformName === 'native';
  };
  OS.prototype._get_isJsNodeJs_ = function () {
    return this._get_platformNameLC_() === 'node.js';
  };
  OS.prototype._get_isJsBrowser_ = function () {
    return this._get_platformNameLC_() === 'web.js';
  };
  OS.$metadata$ = {
    simpleName: 'OS',
    kind: 'object',
    interfaces: []
  };
  var OS_instance;
  function OS_getInstance() {
    if (OS_instance == null)
      new OS();
    return OS_instance;
  }
  function rawNameLC$factory() {
    return getPropertyCallableRef('rawNameLC', 1, KProperty1, function (receiver) {
      return receiver._get_rawNameLC_();
    }, null);
  }
  function platformNameLC$factory() {
    return getPropertyCallableRef('platformNameLC', 1, KProperty1, function (receiver) {
      return receiver._get_platformNameLC_();
    }, null);
  }
  function isWindows$factory() {
    return getPropertyCallableRef('isWindows', 1, KProperty1, function (receiver) {
      return receiver._get_isWindows_();
    }, null);
  }
  function isMac$factory() {
    return getPropertyCallableRef('isMac', 1, KProperty1, function (receiver) {
      return receiver._get_isMac_();
    }, null);
  }
  function _no_name_provided_$factory_105() {
    var i = new _no_name_provided__136();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_106() {
    var i = new _no_name_provided__137();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_107() {
    var i = new _no_name_provided__138();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_108() {
    var i = new _no_name_provided__139();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_109() {
    var i = new _no_name_provided__140();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_110() {
    var i = new _no_name_provided__141();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_111() {
    var i = new _no_name_provided__142();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_112() {
    var i = new _no_name_provided__143();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_113() {
    var i = new _no_name_provided__144();
    return function () {
      return i.invoke_1005();
    };
  }
  function AsyncOnce() {
    this._promise = null;
  }
  AsyncOnce.$metadata$ = {
    simpleName: 'AsyncOnce',
    kind: 'class',
    interfaces: []
  };
  function Once() {
    this._completed = false;
  }
  Once.$metadata$ = {
    simpleName: 'Once',
    kind: 'class',
    interfaces: []
  };
  var LONG_ZERO_TO_MAX_RANGE;
  function toLongRange(_this_) {
    return toLong(_this_._get_start__0()).rangeTo_12(toLong(_this_._get_endInclusive__0()));
  }
  function Companion_59() {
    Companion_instance_58 = this;
  }
  Companion_59.prototype.fromList = function (lits) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(lits.length);
    var indexedObject = lits;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_39(item_2_3.length);
      Unit_getInstance();
    }
    var tmp0_toTypedArray_0 = distinct(reversed(sorted(tmp0_mapTo_0_1)));
    var lengths = copyToArray_0(tmp0_toTypedArray_0);
    var map_0 = LinkedHashMap_init_$Create$();
    var n_1 = 0;
    while (n_1 < lits.length) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = lits[tmp0_2];
      var tmp0_set_0_4 = true;
      map_0.put_18(tmp1__anonymous__3, tmp0_set_0_4);
      Unit_getInstance();
    }
    return new Literals(lits, map_0, lengths);
  };
  Companion_59.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_58;
  function Companion_getInstance_58() {
    if (Companion_instance_58 == null)
      new Companion_59();
    return Companion_instance_58;
  }
  function Companion_60() {
    Companion_instance_59 = this;
  }
  Companion_60.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_59;
  function Companion_getInstance_59() {
    if (Companion_instance_59 == null)
      new Companion_60();
    return Companion_instance_59;
  }
  function StrReader_init_$Init$(str, file, pos, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      file = 'file';
    if (!(($mask0 & 4) === 0))
      pos = 0;
    StrReader.call($this, str, file, pos);
    return $this;
  }
  function StrReader_init_$Create$(str, file, pos, $mask0, $marker) {
    return StrReader_init_$Init$(str, file, pos, $mask0, $marker, Object.create(StrReader.prototype));
  }
  function Companion_61() {
    Companion_instance_60 = this;
  }
  Companion_61.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_60;
  function Companion_getInstance_60() {
    if (Companion_instance_60 == null)
      new Companion_61();
    return Companion_instance_60;
  }
  function posSkip($this, count_0) {
    var out = $this._pos_0;
    var tmp0_this = $this;
    tmp0_this._pos_0 = tmp0_this._pos_0 + count_0 | 0;
    return out;
  }
  function substr_2($this, pos, length) {
    var tmp0_substring_0 = $this._str_2;
    var tmp1_substring_0 = min2_0(pos, $this._length_2);
    var tmp2_substring_0 = min2_0(pos + length | 0, $this._length_2);
    return tmp0_substring_0.substring(tmp1_substring_0, tmp2_substring_0);
  }
  function Literals(lits, map_0, lengths) {
    Companion_getInstance_58();
    this._lits = lits;
    this._map_5 = map_0;
    this._lengths = lengths;
  }
  Literals.prototype.toString = function () {
    return '' + 'Literals(' + joinToString$default(this._lits, ' ', null, null, 0, null, null, 62, null) + ')';
  };
  Literals.$metadata$ = {
    simpleName: 'Literals',
    kind: 'class',
    interfaces: []
  };
  function TRange(min, max, reader) {
    Companion_getInstance_59();
    this._min = min;
    this._max = max;
    this._reader_2 = reader;
  }
  TRange.prototype.toString = function () {
    return '' + this._min + ':' + this._max;
  };
  TRange.prototype._get_text__2 = function () {
    return this._reader_2.slice_0(this._min, this._max);
  };
  TRange.$metadata$ = {
    simpleName: 'TRange',
    kind: 'class',
    interfaces: []
  };
  function StrReader(str, file, pos) {
    Companion_getInstance_60();
    this._str_2 = str;
    this._file_2 = file;
    this._pos_0 = pos;
    this._tempCharArray = charArray(this._str_2.length);
    this._length_2 = this._str_2.length;
  }
  StrReader.prototype._get_available__3 = function () {
    return this._length_2 - this._pos_0 | 0;
  };
  StrReader.prototype._get_eof__0 = function () {
    return this._pos_0 >= this._str_2.length;
  };
  StrReader.prototype._get_hasMore__0 = function () {
    return this._pos_0 < this._str_2.length;
  };
  StrReader.prototype.createRange_0 = function (start, end) {
    return new TRange(start, end, this);
  };
  StrReader.prototype.slice_0 = function (start, end) {
    var tmp0_substring_0 = this._str_2;
    return tmp0_substring_0.substring(start, end);
  };
  StrReader.prototype.peek_3 = function (count_0) {
    return substr_2(this, this._pos_0, count_0);
  };
  StrReader.prototype.peek_4 = function () {
    return this._get_hasMore__0() ? charSequenceGet(this._str_2, this._pos_0) : new Char(0);
  };
  StrReader.prototype.peekChar_0 = function () {
    return this._get_hasMore__0() ? charSequenceGet(this._str_2, this._pos_0) : new Char(0);
  };
  StrReader.prototype.read_35 = function (count_0) {
    var tmp0_apply_0 = this.peek_3(count_0);
    this.skip(count_0);
    Unit_getInstance();
    return tmp0_apply_0;
  };
  StrReader.prototype.skipUntil = function (char) {
    var tmp = this._pos_0;
    var skipPos = indexOf$default(this._str_2, char, tmp, false, 4, null);
    this._pos_0 = skipPos >= 0 ? skipPos : this._length_2;
  };
  StrReader.prototype.skipUntilIncluded = function (char) {
    this.skipUntil(char);
    if (this._get_hasMore__0() ? this.peekChar_0().equals(char) : false) {
      this.skip(1);
      Unit_getInstance();
    }};
  StrReader.prototype.readUntil = function (char) {
    var start_1 = this._pos_0;
    this.skipUntil(char);
    var end_2 = this._pos_0;
    return end_2 > start_1 ? this.slice_0(start_1, end_2) : null;
  };
  StrReader.prototype.readUntilIncluded = function (char) {
    var start_1 = this._pos_0;
    this.skipUntilIncluded(char);
    var end_2 = this._pos_0;
    return end_2 > start_1 ? this.slice_0(start_1, end_2) : null;
  };
  StrReader.prototype.unread = function (count_0) {
    var tmp0_this = this;
    tmp0_this._pos_0 = tmp0_this._pos_0 - count_0 | 0;
    return this;
  };
  StrReader.prototype.unread$default = function (count_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      count_0 = 1;
    return this.unread(count_0);
  };
  StrReader.prototype.readChar_0 = function () {
    return this._get_hasMore__0() ? charSequenceGet(this._str_2, posSkip(this, 1)) : new Char(0);
  };
  StrReader.prototype.read_36 = function () {
    return this._get_hasMore__0() ? charSequenceGet(this._str_2, posSkip(this, 1)) : new Char(0);
  };
  StrReader.prototype.readRemaining = function () {
    return this.read_35(this._get_available__3());
  };
  StrReader.prototype.skipExpect = function (expected) {
    var readed = this.readChar_0();
    if (!readed.equals(expected))
      throw IllegalArgumentException_init_$Create$('' + "Expected '" + expected + "' but found '" + readed + "' at " + this._pos_0);
  };
  StrReader.prototype.skip = function (count_0) {
    var tmp0_this = this;
    tmp0_this._pos_0 = tmp0_this._pos_0 + count_0 | 0;
    return this;
  };
  StrReader.prototype.tryLit = function (lit) {
    if (!(substr_2(this, this._pos_0, lit.length) === lit))
      return null;
    var tmp0_this = this;
    tmp0_this._pos_0 = tmp0_this._pos_0 + lit.length | 0;
    return lit;
  };
  StrReader.prototype.skipSpaces = function () {
    $l$break: while (true) {
      var tmp;
      if (this._get_hasMore__0()) {
        var tmp0__anonymous__1_2 = this.peekChar_0();
        tmp = isWhitespaceFast(tmp0__anonymous__1_2);
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$break;
      }this.readChar_0();
      Unit_getInstance();
    }
    return this;
  };
  StrReader.prototype.matchIdentifier = function () {
    var start_1_1 = this._pos_0;
    $l$break: while (true) {
      var tmp;
      if (this._get_hasMore__0()) {
        var tmp0__anonymous__3 = this.peekChar_0();
        tmp = ((isLetterDigitOrUnderscore(tmp0__anonymous__3) ? true : tmp0__anonymous__3.equals(new Char(45))) ? true : tmp0__anonymous__3.equals(new Char(126))) ? true : tmp0__anonymous__3.equals(new Char(58));
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$break;
      }this.readChar_0();
      Unit_getInstance();
    }
    var end_2_2 = this._pos_0;
    return end_2_2 > start_1_1 ? this.slice_0(start_1_1, end_2_2) : null;
  };
  StrReader.prototype.matchSingleOrDoubleQuoteString = function () {
    var tmp0_subject = this.peekChar_0();
    var tmp;
    if (tmp0_subject.equals(new Char(39)) ? true : tmp0_subject.equals(new Char(34))) {
      var start_1 = this._pos_0;
      var quoteType_4 = this.readChar_0();
      this.readUntil(quoteType_4);
      Unit_getInstance();
      this.readChar_0();
      Unit_getInstance();
      var end_2 = this._pos_0;
      tmp = end_2 > start_1 ? this.slice_0(start_1, end_2) : null;
    } else {
      tmp = null;
    }
    return tmp;
  };
  StrReader.prototype.tryRegex = function (v) {
    var tmp0_substring_0 = this._str_2;
    var tmp1_substring_0 = this._pos_0;
    var tmp = tmp0_substring_0.substring(tmp1_substring_0);
    var tmp0_elvis_lhs = v.find$default(tmp, 0, 2, null);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var result = tmp_0;
    var m = ensureNotNull(result._get_groups__0().get_137(0))._value;
    var tmp1_this = this;
    tmp1_this._pos_0 = tmp1_this._pos_0 + m.length | 0;
    return m;
  };
  StrReader.prototype.clone_8 = function () {
    return new StrReader(this._str_2, this._file_2, this._pos_0);
  };
  StrReader.prototype.tryRead_1 = function (str) {
    if (this.peek_3(str.length) === str) {
      this.skip(str.length);
      Unit_getInstance();
      return true;
    }return false;
  };
  StrReader.prototype.readFixedSizeInt = function (count_0, radix) {
    var readCount = min2_0(this._get_available__3(), count_0);
    this.skip(readCount);
    Unit_getInstance();
    return NumberParser_getInstance().parseInt(this._str_2, this._pos_0 - readCount | 0, this._pos_0, radix);
  };
  StrReader.prototype.readStringLit = function (reportErrors) {
    var out = this._tempCharArray;
    var outp = 0;
    var quotec = this.read_36();
    var tmp0_subject = quotec;
    if (tmp0_subject.equals(new Char(34)) ? true : tmp0_subject.equals(new Char(39)))
      Unit_getInstance();
    else {
      invalidOp('Invalid string literal');
    }
    var closed = false;
    loop: while (this._get_hasMore__0()) {
      var c = this.read_36();
      if (c.equals(new Char(92))) {
        var cc = this.read_36();
        var tmp2 = outp;
        outp = tmp2 + 1 | 0;
        var tmp1_subject = cc;
        var tmp;
        if (tmp1_subject.equals(new Char(92))) {
          tmp = new Char(92);
        } else if (tmp1_subject.equals(new Char(47))) {
          tmp = new Char(47);
        } else if (tmp1_subject.equals(new Char(39))) {
          tmp = new Char(39);
        } else if (tmp1_subject.equals(new Char(34))) {
          tmp = new Char(34);
        } else if (tmp1_subject.equals(new Char(98))) {
          tmp = new Char(8);
        } else if (tmp1_subject.equals(new Char(102))) {
          tmp = new Char(12);
        } else if (tmp1_subject.equals(new Char(110))) {
          tmp = new Char(10);
        } else if (tmp1_subject.equals(new Char(114))) {
          tmp = new Char(13);
        } else if (tmp1_subject.equals(new Char(116))) {
          tmp = new Char(9);
        } else if (tmp1_subject.equals(new Char(117))) {
          tmp = numberToChar(this.readFixedSizeInt(4, 16));
        } else {
          throw new IOException('' + "Invalid char '" + cc + "'");
        }
        out[tmp2] = tmp;
      } else if (c.equals(quotec)) {
        closed = true;
        break loop;
      } else {
        var tmp3 = outp;
        outp = tmp3 + 1 | 0;
        out[tmp3] = c;
      }
    }
    if (!closed ? reportErrors : false) {
      throw RuntimeException_init_$Create$('' + "String literal not closed! '" + this._str_2 + "'");
    }return String_fromCharArray(out, 0, outp);
  };
  StrReader.prototype.readStringLit$default = function (reportErrors, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      reportErrors = true;
    return this.readStringLit(reportErrors);
  };
  StrReader.prototype.tryExpect = function (str) {
    var inductionVariable = 0;
    var last_1 = str.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!this.peekOffset(n).equals(charSequenceGet(str, n)))
          return false;
      }
       while (inductionVariable < last_1);
    this.skip(str.length);
    Unit_getInstance();
    return true;
  };
  StrReader.prototype.tryExpect_0 = function (str) {
    if (!this.peekChar_0().equals(str))
      return false;
    this.skip(1);
    Unit_getInstance();
    return true;
  };
  StrReader.prototype.peekOffset = function (offset) {
    var tmp0_getOrElse_0 = this._str_2;
    var tmp1_getOrElse_0 = this._pos_0 + offset | 0;
    var tmp;
    if (tmp1_getOrElse_0 >= 0 ? tmp1_getOrElse_0 <= _get_lastIndex__4(tmp0_getOrElse_0) : false) {
      tmp = charSequenceGet(tmp0_getOrElse_0, tmp1_getOrElse_0);
    } else {
      tmp = new Char(0);
    }
    return tmp;
  };
  StrReader.$metadata$ = {
    simpleName: 'StrReader',
    kind: 'class',
    interfaces: []
  };
  function unquote(_this_) {
    var tmp;
    if (isQuoted(_this_)) {
      var tmp0_substring_0 = 1;
      var tmp1_substring_0 = _this_.length - 1 | 0;
      tmp = unescape(_this_.substring(tmp0_substring_0, tmp1_substring_0));
    } else {
      tmp = _this_;
    }
    return tmp;
  }
  function isQuoted(_this_) {
    var tmp;
    var tmp_0 = new Char(34);
    if (startsWith$default(_this_, tmp_0, false, 2, null)) {
      var tmp_1 = new Char(34);
      tmp = endsWith$default(_this_, tmp_1, false, 2, null);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  }
  function unescape(_this_) {
    var out = StringBuilder_init_$Create$_0();
    var n = 0;
    while (n < _this_.length) {
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var c = charSequenceGet(_this_, tmp0);
      var tmp1_subject = c;
      if (tmp1_subject.equals(new Char(92))) {
        var tmp2 = n;
        n = tmp2 + 1 | 0;
        var c2 = charSequenceGet(_this_, tmp2);
        var tmp3_subject = c2;
        if (tmp3_subject.equals(new Char(92))) {
          out.append_2(new Char(92));
          Unit_getInstance();
        } else if (tmp3_subject.equals(new Char(34))) {
          out.append_2(new Char(34));
          Unit_getInstance();
        } else if (tmp3_subject.equals(new Char(110))) {
          out.append_2(new Char(10));
          Unit_getInstance();
        } else if (tmp3_subject.equals(new Char(114))) {
          out.append_2(new Char(13));
          Unit_getInstance();
        } else if (tmp3_subject.equals(new Char(116))) {
          out.append_2(new Char(9));
          Unit_getInstance();
        } else if (tmp3_subject.equals(new Char(117))) {
          var tmp0_substring_0 = n;
          var tmp1_substring_0 = n + 4 | 0;
          var chars = _this_.substring(tmp0_substring_0, tmp1_substring_0);
          n = n + 4 | 0;
          out.append_2(numberToChar(toInt_0(chars, 16)));
          Unit_getInstance();
        } else {
          out.append_5('' + '\\' + c2);
          Unit_getInstance();
        }
      } else {
        out.append_2(c);
        Unit_getInstance();
      }
    }
    return out.toString();
  }
  function substringAfterOrNull(_this_, delimiter) {
    var tmp;
    if (contains$default(_this_, delimiter, false, 2, null)) {
      tmp = substringAfter$default(_this_, delimiter, null, 2, null);
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function substringBeforeOrNull(_this_, delimiter) {
    var tmp;
    if (contains$default(_this_, delimiter, false, 2, null)) {
      tmp = substringBefore$default(_this_, delimiter, null, 2, null);
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  }
  function Adler32() {
    Adler32_instance = this;
    this._BASE = 65521;
    this._initialValue = 1;
  }
  Adler32.prototype._get_initialValue__1 = function () {
    return this._initialValue;
  };
  Adler32.prototype.update_2 = function (old, data, offset, len) {
    var s1 = old >>> 0 & 65535;
    var s2 = old >>> 16 & 65535;
    var inductionVariable = offset;
    var last_1 = offset + len | 0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        s1 = (s1 + (data[n] & 255) | 0) % 65521;
        s2 = (s2 + s1 | 0) % 65521;
      }
       while (inductionVariable < last_1);
    return s2 << 16 | s1;
  };
  Adler32.$metadata$ = {
    simpleName: 'Adler32',
    kind: 'object',
    interfaces: [SimpleChecksum]
  };
  var Adler32_instance;
  function Adler32_getInstance() {
    if (Adler32_instance == null)
      new Adler32();
    return Adler32_instance;
  }
  function CRC32() {
    CRC32_instance = this;
    this._initialValue_0 = 0;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 256;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var c = tmp_3;
      var inductionVariable = 0;
      if (inductionVariable < 8)
        do {
          var k = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          c = !((c & 1) === 0) ? -306674912 ^ c >>> 1 : c >>> 1;
        }
         while (inductionVariable < 8);
      tmp_2[tmp_3] = c;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._TABLE_0 = tmp_2;
  }
  CRC32.prototype._get_initialValue__1 = function () {
    return this._initialValue_0;
  };
  CRC32.prototype.update_2 = function (old, data, offset, len) {
    var c = ~old;
    var table = this._TABLE_0;
    var inductionVariable = offset;
    var last_1 = offset + len | 0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        c = table[(c ^ data[n] & 255) & 255] ^ c >>> 8;
      }
       while (inductionVariable < last_1);
    return ~c;
  };
  CRC32.$metadata$ = {
    simpleName: 'CRC32',
    kind: 'object',
    interfaces: [SimpleChecksum]
  };
  var CRC32_instance;
  function CRC32_getInstance() {
    if (CRC32_instance == null)
      new CRC32();
    return CRC32_instance;
  }
  function SimpleChecksum() {
  }
  SimpleChecksum.prototype.update$default_1 = function (old, data, offset, len, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      offset = 0;
    if (!(($mask0 & 8) === 0))
      len = data.length - offset | 0;
    return $handler == null ? this.update_2(old, data, offset, len) : $handler(old, data, offset, len);
  };
  SimpleChecksum.$metadata$ = {
    simpleName: 'SimpleChecksum',
    kind: 'interface',
    interfaces: []
  };
  function compute(_this_, data, offset, len) {
    return _this_.update_2(_this_._get_initialValue__1(), data, offset, len);
  }
  function compute$default(_this_, data, offset, len, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      len = data.length - offset | 0;
    return compute(_this_, data, offset, len);
  }
  function _get_Language_CURRENT_() {
    var tmp0_getValue_0 = Language_CURRENT$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = Language_CURRENT$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var Language_CURRENT$delegate;
  function _no_name_provided__145() {
  }
  _no_name_provided__145.prototype.invoke_1005 = function () {
    var tmp0_mapNotNull_0 = _get_systemLanguageStrings_();
    var tmp0_mapNotNullTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = tmp0_mapNotNull_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var element_2_3 = tmp0_iterator_1_2.next_37();
      var tmp = Companion_getInstance_61()._BY_ID;
      var tmp_0 = new Char(45);
      var tmp0_safe_receiver_2_4_4 = tmp.get_116(substringBefore$default(element_2_3, tmp_0, null, 2, null));
      if (tmp0_safe_receiver_2_4_4 == null)
        null;
      else {
        tmp0_mapNotNullTo_0_1.add_39(tmp0_safe_receiver_2_4_4);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    return tmp0_mapNotNullTo_0_1;
  };
  _no_name_provided__145.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__146() {
  }
  _no_name_provided__146.prototype.invoke_1005 = function () {
    var tmp0_elvis_lhs = firstOrNull(Companion_getInstance_61()._get_SYSTEM_LANGS_());
    return tmp0_elvis_lhs == null ? Language_ENGLISH_getInstance() : tmp0_elvis_lhs;
  };
  _no_name_provided__146.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var Language_JAPANESE_instance;
  var Language_ENGLISH_instance;
  var Language_FRENCH_instance;
  var Language_SPANISH_instance;
  var Language_GERMAN_instance;
  var Language_ITALIAN_instance;
  var Language_DUTCH_instance;
  var Language_PORTUGUESE_instance;
  var Language_RUSSIAN_instance;
  var Language_KOREAN_instance;
  var Language_CHINESE_instance;
  function Companion_62() {
    Companion_instance_61 = this;
    var tmp = this;
    var tmp0_map_0 = values_1();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0.length);
    var indexedObject = tmp0_map_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_toLowerCase_0_5 = item_2_3._get_name__50();
      tmp0_mapTo_0_1.add_39(to(tmp0_toLowerCase_0_5.toLowerCase(), item_2_3));
      Unit_getInstance();
    }
    var tmp1_map_0 = values_1();
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(tmp1_map_0.length);
    var indexedObject_0 = tmp1_map_0;
    var inductionVariable_0 = 0;
    var last_2 = indexedObject_0.length;
    while (inductionVariable_0 < last_2) {
      var item_2_3_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      tmp0_mapTo_0_1_0.add_39(to(item_2_3_0._iso6391, item_2_3_0));
      Unit_getInstance();
    }
    var tmp_0 = plus(tmp0_mapTo_0_1, tmp0_mapTo_0_1_0);
    var tmp2_map_0 = values_1();
    var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(tmp2_map_0.length);
    var indexedObject_1 = tmp2_map_0;
    var inductionVariable_1 = 0;
    var last_3 = indexedObject_1.length;
    while (inductionVariable_1 < last_3) {
      var item_2_3_1 = indexedObject_1[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      tmp0_mapTo_0_1_1.add_39(to(item_2_3_1._iso6392, item_2_3_1));
      Unit_getInstance();
    }
    tmp._BY_ID = toMap_0(plus(tmp_0, tmp0_mapTo_0_1_1));
    var tmp_1 = this;
    tmp_1._SYSTEM_LANGS$delegate = lazy(_no_name_provided_$factory_115());
    var tmp_2 = this;
    tmp_2._SYSTEM$delegate = lazy(_no_name_provided_$factory_116());
  }
  Companion_62.prototype._get_SYSTEM_LANGS_ = function () {
    var tmp0_getValue_0 = this._SYSTEM_LANGS$delegate;
    var tmp1_getValue_0 = SYSTEM_LANGS$factory();
    return tmp0_getValue_0._get_value__10();
  };
  Companion_62.prototype._get_SYSTEM_ = function () {
    var tmp0_getValue_0 = this._SYSTEM$delegate;
    var tmp1_getValue_0 = SYSTEM$factory();
    return tmp0_getValue_0._get_value__10();
  };
  Companion_62.prototype._get_CURRENT_ = function () {
    return _get_Language_CURRENT_()._get_value__10();
  };
  Companion_62.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_61;
  function Companion_getInstance_61() {
    if (Companion_instance_61 == null)
      new Companion_62();
    return Companion_instance_61;
  }
  function values_1() {
    return [Language_JAPANESE_getInstance(), Language_ENGLISH_getInstance(), Language_FRENCH_getInstance(), Language_SPANISH_getInstance(), Language_GERMAN_getInstance(), Language_ITALIAN_getInstance(), Language_DUTCH_getInstance(), Language_PORTUGUESE_getInstance(), Language_RUSSIAN_getInstance(), Language_KOREAN_getInstance(), Language_CHINESE_getInstance()];
  }
  var Language_entriesInitialized;
  function Language_initEntries() {
    if (Language_entriesInitialized)
      return Unit_getInstance();
    Language_entriesInitialized = true;
    Language_JAPANESE_instance = new Language('JAPANESE', 0, 'ja', 'jpn');
    Language_ENGLISH_instance = new Language('ENGLISH', 1, 'en', 'eng');
    Language_FRENCH_instance = new Language('FRENCH', 2, 'fr', 'fra');
    Language_SPANISH_instance = new Language('SPANISH', 3, 'es', 'spa');
    Language_GERMAN_instance = new Language('GERMAN', 4, 'de', 'deu');
    Language_ITALIAN_instance = new Language('ITALIAN', 5, 'it', 'ita');
    Language_DUTCH_instance = new Language('DUTCH', 6, 'nl', 'nld');
    Language_PORTUGUESE_instance = new Language('PORTUGUESE', 7, 'pt', 'por');
    Language_RUSSIAN_instance = new Language('RUSSIAN', 8, 'ru', 'rus');
    Language_KOREAN_instance = new Language('KOREAN', 9, 'ko', 'kor');
    Language_CHINESE_instance = new Language('CHINESE', 10, 'zh', 'zho');
    Companion_getInstance_61();
  }
  function Language(name, ordinal, iso6391, iso6392) {
    Enum.call(this, name, ordinal);
    this._iso6391 = iso6391;
    this._iso6392 = iso6392;
  }
  Language.$metadata$ = {
    simpleName: 'Language',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__147() {
  }
  _no_name_provided__147.prototype.invoke_1005 = function () {
    return KorAtomicRef_0(Companion_getInstance_61()._get_SYSTEM_());
  };
  _no_name_provided__147.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Language_JAPANESE_getInstance() {
    Language_initEntries();
    return Language_JAPANESE_instance;
  }
  function Language_ENGLISH_getInstance() {
    Language_initEntries();
    return Language_ENGLISH_instance;
  }
  function Language_FRENCH_getInstance() {
    Language_initEntries();
    return Language_FRENCH_instance;
  }
  function Language_SPANISH_getInstance() {
    Language_initEntries();
    return Language_SPANISH_instance;
  }
  function Language_GERMAN_getInstance() {
    Language_initEntries();
    return Language_GERMAN_instance;
  }
  function Language_ITALIAN_getInstance() {
    Language_initEntries();
    return Language_ITALIAN_instance;
  }
  function Language_DUTCH_getInstance() {
    Language_initEntries();
    return Language_DUTCH_instance;
  }
  function Language_PORTUGUESE_getInstance() {
    Language_initEntries();
    return Language_PORTUGUESE_instance;
  }
  function Language_RUSSIAN_getInstance() {
    Language_initEntries();
    return Language_RUSSIAN_instance;
  }
  function Language_KOREAN_getInstance() {
    Language_initEntries();
    return Language_KOREAN_instance;
  }
  function Language_CHINESE_getInstance() {
    Language_initEntries();
    return Language_CHINESE_instance;
  }
  function Language_CURRENT$factory() {
    return getPropertyCallableRef('Language_CURRENT', 0, KProperty0, function () {
      return _get_Language_CURRENT_();
    }, null);
  }
  function SYSTEM_LANGS$factory() {
    return getPropertyCallableRef('SYSTEM_LANGS', 1, KProperty1, function (receiver) {
      return receiver._get_SYSTEM_LANGS_();
    }, null);
  }
  function SYSTEM$factory() {
    return getPropertyCallableRef('SYSTEM', 1, KProperty1, function (receiver) {
      return receiver._get_SYSTEM_();
    }, null);
  }
  function _no_name_provided_$factory_114() {
    var i = new _no_name_provided__147();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_115() {
    var i = new _no_name_provided__145();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_116() {
    var i = new _no_name_provided__146();
    return function () {
      return i.invoke_1005();
    };
  }
  function _get_jsLocalStorageVfs_() {
    var tmp0_getValue_0 = jsLocalStorageVfs$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = jsLocalStorageVfs$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var jsLocalStorageVfs$delegate;
  function _no_name_provided__148() {
  }
  _no_name_provided__148.prototype.get_115 = function (key, $cont) {
    var tmp0_get_0 = localStorage;
    return tmp0_get_0[key];
  };
  _no_name_provided__148.prototype.set_16 = function (key, value, $cont) {
    var tmp0_set_0_2 = localStorage;
    return tmp0_set_0_2[key] = value;
  };
  _no_name_provided__148.$metadata$ = {
    kind: 'class',
    interfaces: [SimpleStorage]
  };
  function _no_name_provided__149() {
  }
  _no_name_provided__149.prototype.invoke_1005 = function () {
    return new MapLikeStorageVfs(new _no_name_provided__148());
  };
  _no_name_provided__149.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function jsLocalStorageVfs$factory() {
    return getPropertyCallableRef('jsLocalStorageVfs', 0, KProperty0, function () {
      return _get_jsLocalStorageVfs_();
    }, null);
  }
  function _no_name_provided_$factory_117() {
    var i = new _no_name_provided__149();
    return function () {
      return i.invoke_1005();
    };
  }
  function _get_jsbaseUrl_() {
    var tmp0_getValue_0 = jsbaseUrl$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = jsbaseUrl$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var jsbaseUrl$delegate;
  var globalDynamic;
  var global;
  function _get_isWeb_() {
    var tmp0_getValue_0 = isWeb$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = isWeb$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var isWeb$delegate;
  function _get_isWorker_() {
    var tmp0_getValue_0 = isWorker$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = isWorker$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var isWorker$delegate;
  function _get_isNodeJs_() {
    var tmp0_getValue_0 = isNodeJs$delegate_0;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = isNodeJs$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var isNodeJs$delegate_0;
  function _get_isShell_() {
    return (!_get_isWeb_() ? !_get_isNodeJs_() : false) ? !_get_isWorker_() : false;
  }
  function jsObjectKeysArray(obj) {
    var tmp = jsToArray(jsObjectKeys(obj));
    return isArray(tmp) ? tmp : THROW_CCE();
  }
  function jsToArray(obj) {
    var tmp = 0;
    var tmp_0 = obj.length;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = obj[tmp_2];
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function jsObjectKeys(obj) {
    return Object.keys(obj);
  }
  function _no_name_provided__150() {
  }
  _no_name_provided__150.prototype.invoke_1005 = function () {
    var tmp0_safe_receiver = document.location;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.href;
    var href = tmp1_elvis_lhs == null ? '.' : tmp1_elvis_lhs;
    var tmp;
    if (endsWith$default_1(href, '/', false, 2, null)) {
      tmp = href;
    } else {
      {
        var tmp_0 = new Char(47);
        tmp = substringBeforeLast$default(href, tmp_0, null, 2, null);
      }
    }
    return tmp;
  };
  _no_name_provided__150.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__151() {
  }
  _no_name_provided__151.prototype.invoke_1005 = function () {
    var tmp0_unsafeCast_0 = typeof window === 'object';
    return tmp0_unsafeCast_0;
  };
  _no_name_provided__151.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__152() {
  }
  _no_name_provided__152.prototype.invoke_1005 = function () {
    var tmp0_unsafeCast_0 = typeof importScripts === 'function';
    return tmp0_unsafeCast_0;
  };
  _no_name_provided__152.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__153() {
  }
  _no_name_provided__153.prototype.invoke_1005 = function () {
    var tmp0_unsafeCast_0 = typeof process !== 'undefined' && process.release && process.release.name.search(/node|io.js/) !== -1;
    return tmp0_unsafeCast_0;
  };
  _no_name_provided__153.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function jsbaseUrl$factory() {
    return getPropertyCallableRef('jsbaseUrl', 0, KProperty0, function () {
      return _get_jsbaseUrl_();
    }, null);
  }
  function isWeb$factory() {
    return getPropertyCallableRef('isWeb', 0, KProperty0, function () {
      return _get_isWeb_();
    }, null);
  }
  function isWorker$factory() {
    return getPropertyCallableRef('isWorker', 0, KProperty0, function () {
      return _get_isWorker_();
    }, null);
  }
  function isNodeJs$factory() {
    return getPropertyCallableRef('isNodeJs', 0, KProperty0, function () {
      return _get_isNodeJs_();
    }, null);
  }
  function _no_name_provided_$factory_118() {
    var i = new _no_name_provided__150();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_119() {
    var i = new _no_name_provided__151();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_120() {
    var i = new _no_name_provided__152();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_121() {
    var i = new _no_name_provided__153();
    return function () {
      return i.invoke_1005();
    };
  }
  function Deflate(windowBits) {
    return new DeflatePortable(windowBits);
  }
  function korAtomic(initial) {
    return new KorAtomicRef(initial, true);
  }
  function korAtomic_0(initial) {
    return new KorAtomicBoolean(initial, true);
  }
  function DynamicInternal() {
    DynamicInternal_instance = this;
    this._global = typeof global !== 'undefined' ? global : window;
  }
  DynamicInternal.prototype._get_global__4 = function () {
    return this._global;
  };
  DynamicInternal.prototype.set_17 = function (instance, key, value) {
    instance[key] = value;
  };
  DynamicInternal.$metadata$ = {
    simpleName: 'DynamicInternal',
    kind: 'object',
    interfaces: [DynApi]
  };
  var DynamicInternal_instance;
  function DynamicInternal_getInstance() {
    if (DynamicInternal_instance == null)
      new DynamicInternal();
    return DynamicInternal_instance;
  }
  function toVfs(_this_) {
    var file = _this_;
    return (new _no_name_provided__156(file)).get_115(file.name);
  }
  function openAsync_0(_this_) {
    var tmp = new BlobAsyncBaseStream(_this_);
    return buffered(toAsyncStream$default(tmp, new Long(0, 0), 1, null), 65536, 16);
  }
  function _no_name_provided__154($reader, $len, $buffer, $offset, $deferred) {
    this._$reader = $reader;
    this._$len_1 = $len;
    this._$buffer_1 = $buffer;
    this._$offset_1 = $offset;
    this._$deferred = $deferred;
  }
  _no_name_provided__154.prototype.invoke_254 = function (it) {
    var tmp0_unsafeCast_0 = this._$reader.result;
    var ab = tmp0_unsafeCast_0;
    var minLen = min2_0(ab.byteLength, this._$len_1);
    arraycopy_2(toByteArray_0(new Int8Array(ab)), 0, this._$buffer_1, this._$offset_1, minLen);
    return this._$deferred.complete_1(minLen);
  };
  _no_name_provided__154.prototype.invoke_1015 = function (p1) {
    return this.invoke_254(p1 instanceof Event ? p1 : THROW_CCE());
  };
  _no_name_provided__154.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__155($deferred, $reader) {
    this._$deferred_0 = $deferred;
    this._$reader_0 = $reader;
  }
  _no_name_provided__155.prototype.invoke_254 = function (it) {
    return this._$deferred_0.completeExceptionally_0(newThrowable('' + this._$reader_0.error, void 1));
  };
  _no_name_provided__155.prototype.invoke_1015 = function (p1) {
    return this.invoke_254(p1 instanceof Event ? p1 : THROW_CCE());
  };
  _no_name_provided__155.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BlobAsyncBaseStream(blob) {
    AsyncStreamBase.call(this);
    this._blob = blob;
  }
  BlobAsyncBaseStream.prototype.close_77 = function ($cont) {
  };
  BlobAsyncBaseStream.prototype.read_37 = function (position_1, buffer, offset, len, $cont) {
    var deferred = CompletableDeferred$default(null, 1, null);
    var reader = new FileReader();
    reader.onload = _no_name_provided_$factory_122(reader, len, buffer, offset, deferred);
    reader.onerror = _no_name_provided_$factory_123(deferred, reader);
    var tmp0_unsafeCast_0 = this._blob;
    reader.readAsArrayBuffer(tmp0_unsafeCast_0.slice(position_1.toDouble_6(), position_1.toDouble_6() + len));
    return deferred.await_3($cont);
  };
  BlobAsyncBaseStream.prototype.getLength_14 = function ($cont) {
    return numberToLong(this._blob.size);
  };
  BlobAsyncBaseStream.$metadata$ = {
    simpleName: 'BlobAsyncBaseStream',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__156($file) {
    this._$file = $file;
    Vfs.call(this);
    this._absolutePath_0 = this._$file.name;
  }
  _no_name_provided__156.prototype._get_absolutePath__9 = function () {
    return this._absolutePath_0;
  };
  _no_name_provided__156.prototype.open_10 = function (path_0, mode, $cont) {
    return openAsync_0(this._$file);
  };
  _no_name_provided__156.prototype.listSimple_9 = function (path_0, $cont) {
    var tmp;
    switch (path_0) {
      case '/':
      case '':
        tmp = listOf_0(this.get_115(this._$file.name));
        break;
      default:tmp = emptyList();
        break;
    }
    return tmp;
  };
  _no_name_provided__156.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_122($reader, $len, $buffer, $offset, $deferred) {
    var i = new _no_name_provided__154($reader, $len, $buffer, $offset, $deferred);
    return function (p1) {
      return i.invoke_254(p1);
    };
  }
  function _no_name_provided_$factory_123($deferred, $reader) {
    var i = new _no_name_provided__155($deferred, $reader);
    return function (p1) {
      return i.invoke_254(p1);
    };
  }
  var File_separatorChar;
  function _get_tmpdir_() {
    var tmp0_getValue_0 = tmpdir$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = tmpdir$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var tmpdir$delegate;
  function _get_absoluteCwd_() {
    var tmp0_getValue_0 = absoluteCwd$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = absoluteCwd$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var absoluteCwd$delegate;
  function _get_resourcesVfs_() {
    var tmp0_getValue_0 = resourcesVfs$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = resourcesVfs$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var resourcesVfs$delegate;
  function _get_rootLocalVfs_() {
    var tmp0_getValue_0 = rootLocalVfs$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = rootLocalVfs$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var rootLocalVfs$delegate;
  function _get_applicationVfs_() {
    var tmp0_getValue_0 = applicationVfs$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = applicationVfs$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var applicationVfs$delegate;
  var applicationDataVfs$delegate;
  var cacheVfs$delegate;
  var externalStorageVfs$delegate;
  var userHomeVfs$delegate;
  var tempVfs$delegate;
  function localVfs(path_0) {
    var tmp;
    {
      var tmp_0 = _get_jsbaseUrl_();
      tmp = UrlVfs$default_0(tmp_0, null, false, 6, null).get_115(path_0);
    }
    return tmp;
  }
  function _no_name_provided__157() {
  }
  _no_name_provided__157.prototype.invoke_1005 = function () {
    return '/tmp';
  };
  _no_name_provided__157.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__158() {
  }
  _no_name_provided__158.prototype.invoke_1005 = function () {
    return '.';
  };
  _no_name_provided__158.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__159() {
  }
  _no_name_provided__159.prototype.invoke_1005 = function () {
    return _get_applicationVfs_().jail();
  };
  _no_name_provided__159.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__160() {
  }
  _no_name_provided__160.prototype.invoke_1005 = function () {
    return localVfs(_get_absoluteCwd_());
  };
  _no_name_provided__160.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__161() {
  }
  _no_name_provided__161.prototype.invoke_1005 = function () {
    return localVfs(_get_absoluteCwd_());
  };
  _no_name_provided__161.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__162() {
  }
  _no_name_provided__162.prototype.invoke_1005 = function () {
    return _get_jsLocalStorageVfs_()._get_root__33();
  };
  _no_name_provided__162.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__163() {
  }
  _no_name_provided__163.prototype.invoke_1005 = function () {
    return MemoryVfs$default(null, false, 3, null);
  };
  _no_name_provided__163.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__164() {
  }
  _no_name_provided__164.prototype.invoke_1005 = function () {
    return localVfs(_get_absoluteCwd_());
  };
  _no_name_provided__164.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__165() {
  }
  _no_name_provided__165.prototype.invoke_1005 = function () {
    return localVfs(_get_absoluteCwd_());
  };
  _no_name_provided__165.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__166() {
  }
  _no_name_provided__166.prototype.invoke_1005 = function () {
    var tmp;
    if (_get_isNodeJs_()) {
      tmp = localVfs(_get_tmpdir_());
    } else {
      tmp = MemoryVfs$default(null, false, 3, null);
    }
    return tmp;
  };
  _no_name_provided__166.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function tmpdir$factory() {
    return getPropertyCallableRef('tmpdir', 0, KProperty0, function () {
      return _get_tmpdir_();
    }, null);
  }
  function absoluteCwd$factory() {
    return getPropertyCallableRef('absoluteCwd', 0, KProperty0, function () {
      return _get_absoluteCwd_();
    }, null);
  }
  function resourcesVfs$factory() {
    return getPropertyCallableRef('resourcesVfs', 0, KProperty0, function () {
      return _get_resourcesVfs_();
    }, null);
  }
  function rootLocalVfs$factory() {
    return getPropertyCallableRef('rootLocalVfs', 0, KProperty0, function () {
      return _get_rootLocalVfs_();
    }, null);
  }
  function applicationVfs$factory() {
    return getPropertyCallableRef('applicationVfs', 0, KProperty0, function () {
      return _get_applicationVfs_();
    }, null);
  }
  function _no_name_provided_$factory_124() {
    var i = new _no_name_provided__157();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_125() {
    var i = new _no_name_provided__158();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_126() {
    var i = new _no_name_provided__159();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_127() {
    var i = new _no_name_provided__160();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_128() {
    var i = new _no_name_provided__161();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_129() {
    var i = new _no_name_provided__162();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_130() {
    var i = new _no_name_provided__163();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_131() {
    var i = new _no_name_provided__164();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_132() {
    var i = new _no_name_provided__165();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_133() {
    var i = new _no_name_provided__166();
    return function () {
      return i.invoke_1005();
    };
  }
  function _get_portableSimpleName_(_this_) {
    var tmp0_elvis_lhs = _this_._get_simpleName__4();
    return tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs;
  }
  function EnvironmentInternal() {
    EnvironmentInternal_instance = this;
    var tmp = this;
    var tmp_0;
    if (OS_getInstance()._get_isJsNodeJs_()) {
      var tmp0_associate_0 = jsObjectKeysArray(process.env);
      var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associate_0.length), 16);
      var tmp1_associateTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
      var indexedObject = tmp0_associate_0;
      var inductionVariable = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable < last_1) {
        var element_2_4 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_plusAssign_0_5 = to(element_2_4, process.env[element_2_4]);
        tmp1_associateTo_0_2.put_18(tmp0_plusAssign_0_5._first, tmp0_plusAssign_0_5._second);
        Unit_getInstance();
      }
      tmp_0 = tmp1_associateTo_0_2;
    } else {
      var tmp_1 = QueryString_getInstance();
      var tmp0_safe_receiver = document.location;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.search;
      var tmp1_map_0 = tmp_1.decode_10(trimStart(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs, charArrayOf([new Char(63)])));
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp1_map_0._get_size__60());
      var tmp0_iterator_1_2 = tmp1_map_0._get_entries__10().iterator_67();
      while (tmp0_iterator_1_2.hasNext_33()) {
        var item_2_3 = tmp0_iterator_1_2.next_37();
        var tmp_2 = item_2_3._get_key__37();
        var tmp0_elvis_lhs_5 = firstOrNull(item_2_3._get_value__10());
        tmp0_mapTo_0_1.add_39(to(tmp_2, tmp0_elvis_lhs_5 == null ? item_2_3._get_key__37() : tmp0_elvis_lhs_5));
        Unit_getInstance();
      }
      tmp_0 = toMap_0(tmp0_mapTo_0_1);
    }
    tmp._allEnvs = tmp_0;
    var tmp_3 = this;
    var tmp0_map_0 = this._allEnvs;
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(tmp0_map_0._get_size__60());
    var tmp0_iterator_1_2_0 = tmp0_map_0._get_entries__10().iterator_67();
    while (tmp0_iterator_1_2_0.hasNext_33()) {
      var item_2_3_0 = tmp0_iterator_1_2_0.next_37();
      var tmp0_toUpperCase_0_5 = item_2_3_0._get_key__37();
      tmp0_mapTo_0_1_0.add_39(to(tmp0_toUpperCase_0_5.toUpperCase(), item_2_3_0._get_value__10()));
      Unit_getInstance();
    }
    tmp_3._allEnvsUpperCase = toMap_0(tmp0_mapTo_0_1_0);
  }
  EnvironmentInternal.prototype.get_115 = function (key) {
    return this._allEnvsUpperCase.get_116(key.toUpperCase());
  };
  EnvironmentInternal.$metadata$ = {
    simpleName: 'EnvironmentInternal',
    kind: 'object',
    interfaces: []
  };
  var EnvironmentInternal_instance;
  function EnvironmentInternal_getInstance() {
    if (EnvironmentInternal_instance == null)
      new EnvironmentInternal();
    return EnvironmentInternal_instance;
  }
  function FileNotFoundException(msg) {
    IOException.call(this, msg);
    captureStack(this, FileNotFoundException);
  }
  FileNotFoundException.$metadata$ = {
    simpleName: 'FileNotFoundException',
    kind: 'class',
    interfaces: []
  };
  function printStackTrace(_this_) {
    var e = _this_;
    var tmp = console;
    (function () {
      var $externalVarargReceiverTmp = tmp;
      return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].concat([e]));
    }.call(this));
    var tmp_0 = console;
    (function () {
      var $externalVarargReceiverTmp = tmp_0;
      return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].concat([e.stack]));
    }.call(this));
  }
  function IOException(msg) {
    Exception_init_$Init$_0(msg, this);
    captureStack(this, IOException);
  }
  IOException.$metadata$ = {
    simpleName: 'IOException',
    kind: 'class',
    interfaces: []
  };
  function EOFException(msg) {
    IOException.call(this, msg);
    captureStack(this, EOFException);
  }
  EOFException.$metadata$ = {
    simpleName: 'EOFException',
    kind: 'class',
    interfaces: []
  };
  function NativeThreadLocal() {
    this._value_15 = this.initialValue_1();
  }
  NativeThreadLocal.prototype.get_85 = function () {
    return this._value_15;
  };
  NativeThreadLocal.$metadata$ = {
    simpleName: 'NativeThreadLocal',
    kind: 'class',
    interfaces: []
  };
  var UTF8;
  function _no_name_provided__167() {
    UTC8CharsetBase.call(this, 'UTF-8');
    var tmp = this;
    var tmp_0;
    try {
      tmp_0 = new TextDecoder('utf-8');
    } catch ($p) {
      var tmp_1;
      {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    tmp._textDecoder = tmp_0;
    var tmp_2 = this;
    var tmp_3;
    try {
      tmp_3 = new TextEncoder('utf-8');
    } catch ($p_0) {
      var tmp_4;
      {
        tmp_4 = null;
      }
      tmp_3 = tmp_4;
    }
    tmp_2._textEncoder = tmp_3;
  }
  _no_name_provided__167.prototype.decode_13 = function (out, src, start, end) {
    if (!(this._textDecoder == null)) {
      var srcBuffer = src;
      out.append_5(this._textDecoder.decode(new Int8Array(srcBuffer.buffer, start, end - start | 0)));
      Unit_getInstance();
    } else {
      UTC8CharsetBase.prototype.decode_13.call(this, out, src, start, end);
    }
  };
  _no_name_provided__167.prototype.encode_9 = function (out, src, start, end) {
    if (!(this._textEncoder == null)) {
      var ba = this._textEncoder.encode(toString_1(charSequenceSubSequence(src, start, end)));
      var tmp0_unsafeCast_0 = new Int8Array(ba.buffer);
      var tmp = tmp0_unsafeCast_0;
      out.append$default(tmp, 0, 0, 6, null);
    } else {
      UTC8CharsetBase.prototype.encode_9.call(this, out, src, start, end);
    }
  };
  _no_name_provided__167.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UTF8$init$() {
    return new _no_name_provided__167();
  }
  var asyncSocketFactory$delegate;
  function _no_name_provided__168() {
    AsyncSocketFactory.call(this);
  }
  _no_name_provided__168.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__169() {
  }
  _no_name_provided__169.prototype.invoke_1005 = function () {
    return new _no_name_provided__168();
  };
  _no_name_provided__169.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_134() {
    var i = new _no_name_provided__169();
    return function () {
      return i.invoke_1005();
    };
  }
  function _get_httpFactory_() {
    var tmp0_getValue_0 = httpFactory$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = httpFactory$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var httpFactory$delegate;
  function _no_name_provided__170($xhr, $deferred) {
    this._$xhr = $xhr;
    this._$deferred_1 = $deferred;
  }
  _no_name_provided__170.prototype.invoke_254 = function (e) {
    var tmp0_unsafeCast_0 = this._$xhr.response;
    var tmp1_unsafeCast_0 = new Int8Array(tmp0_unsafeCast_0);
    var out = tmp1_unsafeCast_0;
    var tmp = this._$xhr.status;
    var tmp_0 = this._$xhr.statusText;
    var tmp_1 = Headers_init_$Create$_1(this._$xhr.getAllResponseHeaders());
    return this._$deferred_1.complete_1(new Response_0(tmp, tmp_0, tmp_1, openAsync$default(out, null, 1, null)));
  };
  _no_name_provided__170.prototype.invoke_1015 = function (p1) {
    return this.invoke_254(p1 instanceof Event ? p1 : THROW_CCE());
  };
  _no_name_provided__170.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__171($deferred, $xhr, $url) {
    this._$deferred_2 = $deferred;
    this._$xhr_0 = $xhr;
    this._$url = $url;
  }
  _no_name_provided__171.prototype.invoke_254 = function (e) {
    return this._$deferred_2.completeExceptionally_0(RuntimeException_init_$Create$('' + 'Error status=' + this._$xhr_0.status + ",'" + this._$xhr_0.statusText + "' opening " + this._$url));
  };
  _no_name_provided__171.prototype.invoke_1015 = function (p1) {
    return this.invoke_254(p1 instanceof Event ? p1 : THROW_CCE());
  };
  _no_name_provided__171.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__172($deferred, $xhr) {
    this._$deferred_3 = $deferred;
    this._$xhr_1 = $xhr;
  }
  _no_name_provided__172.prototype.invoke_725 = function (it) {
    if (this._$deferred_3._get_isCancelled__3()) {
      this._$xhr_1.abort();
    }};
  _no_name_provided__172.prototype.invoke_1015 = function (p1) {
    this.invoke_725((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__172.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $requestInternalCOROUTINE$170(_this_, method, url, headers, content, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__98 = _this_;
    this._method_1 = method;
    this._url_3 = url;
    this._headers_4 = headers;
    this._content_4 = content;
  }
  $requestInternalCOROUTINE$170.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            tmp_0._deferred0 = CompletableDeferred_0(Job$default(null, 1, null));
            this._xhr1 = new XMLHttpRequest();
            this._xhr1.open(this._method_1._get_name__50(), this._url_3, true);
            var tmp_1 = this;
            tmp_1._tmp0__get_ARRAYBUFFER__02 = null;
            var tmp_2 = this;
            var tmp0_asDynamic_0_2 = 'arraybuffer';
            tmp_2._tmp1_unsafeCast_0_13 = tmp0_asDynamic_0_2;
            this._xhr1.responseType = this._tmp1_unsafeCast_0_13;
            this._xhr1.onload = _no_name_provided_$factory_136(this._xhr1, this._deferred0);
            this._xhr1.onerror = _no_name_provided_$factory_137(this._deferred0, this._xhr1, this._url_3);
            var tmp0_iterator = this._headers_4.iterator_67();
            while (tmp0_iterator.hasNext_33()) {
              var header = tmp0_iterator.next_37();
              var tmp1_toLowerCase_0 = header._first;
              var tmp2_trim_0 = tmp1_toLowerCase_0.toLowerCase();
              var hnname = toString_1(trim_0(isCharSequence(tmp2_trim_0) ? tmp2_trim_0 : THROW_CCE()));
              var tmp1_subject = hnname;
              if (tmp1_subject === 'connection' ? true : tmp1_subject === Companion_getInstance_53()._ContentLength)
                Unit_getInstance();
              else
                this._xhr1.setRequestHeader(header._first, header._second);
            }

            this._deferred0.invokeOnCompletion_31(_no_name_provided_$factory_138(this._deferred0, this._xhr1));
            Unit_getInstance();
            if (!(this._content_4 == null)) {
              this._state_1 = 1;
              suspendResult = readAll(this._content_4, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._xhr1.send();
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT4_0 = suspendResult;
            this._xhr1.send(this._ARGUMENT4_0);
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._state_1 = 3;
            suspendResult = this._deferred0.await_3(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $requestInternalCOROUTINE$170.$metadata$ = {
    simpleName: '$requestInternalCOROUTINE$170',
    kind: 'class',
    interfaces: []
  };
  function HttpClientBrowserJs() {
    HttpClient.call(this);
  }
  HttpClientBrowserJs.prototype.requestInternal_0 = function (method, url, headers, content, $cont) {
    var tmp = new $requestInternalCOROUTINE$170(this, method, url, headers, content, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  HttpClientBrowserJs.$metadata$ = {
    simpleName: 'HttpClientBrowserJs',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__173() {
  }
  _no_name_provided__173.prototype.createClient_1 = function () {
    return new HttpClientBrowserJs();
  };
  _no_name_provided__173.$metadata$ = {
    kind: 'class',
    interfaces: [HttpFactory]
  };
  function _no_name_provided__174() {
  }
  _no_name_provided__174.prototype.invoke_1005 = function () {
    return new _no_name_provided__173();
  };
  _no_name_provided__174.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function httpFactory$factory() {
    return getPropertyCallableRef('httpFactory', 0, KProperty0, function () {
      return _get_httpFactory_();
    }, null);
  }
  function _no_name_provided_$factory_135() {
    var i = new _no_name_provided__174();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_136($xhr, $deferred) {
    var i = new _no_name_provided__170($xhr, $deferred);
    return function (p1) {
      return i.invoke_254(p1);
    };
  }
  function _no_name_provided_$factory_137($deferred, $xhr, $url) {
    var i = new _no_name_provided__171($deferred, $xhr, $url);
    return function (p1) {
      return i.invoke_254(p1);
    };
  }
  function _no_name_provided_$factory_138($deferred, $xhr) {
    var i = new _no_name_provided__172($deferred, $xhr);
    return function (p1) {
      i.invoke_725(p1);
      return Unit_getInstance();
    };
  }
  function toByteArray_0(_this_) {
    var tout = _this_;
    var tmp;
    if (!(tout == null) ? isByteArray(tout) : false) {
      tmp = tout;
    } else {
      {
        var out = new Int8Array(_this_.length);
        var inductionVariable = 0;
        var last_1 = out.length - 1 | 0;
        if (inductionVariable <= last_1)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            out[n] = _this_[n];
          }
           while (inductionVariable <= last_1);
        tmp = out;
      }
    }
    return tmp;
  }
  function _get_rawOsName_() {
    var tmp0_getValue_0 = rawOsName$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = rawOsName$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var rawOsName$delegate;
  var rawPlatformName;
  function _no_name_provided__175() {
  }
  _no_name_provided__175.prototype.invoke_1005 = function () {
    var tmp;
    if (_get_isNodeJs_()) {
      var tmp0_unsafeCast_0 = process.platform;
      tmp = tmp0_unsafeCast_0;
    } else {
      var tmp1_unsafeCast_0 = navigator.platform;
      tmp = tmp1_unsafeCast_0;
    }
    return tmp;
  };
  _no_name_provided__175.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function rawOsName$factory() {
    return getPropertyCallableRef('rawOsName', 0, KProperty0, function () {
      return _get_rawOsName_();
    }, null);
  }
  function _no_name_provided_$factory_139() {
    var i = new _no_name_provided__175();
    return function () {
      return i.invoke_1005();
    };
  }
  function rawPlatformName$init$() {
    return _get_isWeb_() ? 'web.js' : _get_isNodeJs_() ? 'node.js' : _get_isWorker_() ? 'worker.js' : _get_isShell_() ? 'shell.js' : 'js';
  }
  function _get_systemLanguageStrings_() {
    var tmp0_getValue_0 = systemLanguageStrings$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = systemLanguageStrings$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var systemLanguageStrings$delegate;
  function _no_name_provided__176() {
  }
  _no_name_provided__176.prototype.invoke_1005 = function () {
    var tmp;
    if (_get_isNodeJs_()) {
      var env = process.env;
      var tmp0_elvis_lhs = env.LANG;
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? env.LANGUAGE : tmp0_elvis_lhs;
      var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? env.LC_ALL : tmp1_elvis_lhs;
      var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? env.LC_MESSAGES : tmp2_elvis_lhs;
      tmp = listOf_0(tmp3_elvis_lhs == null ? 'english' : tmp3_elvis_lhs);
    } else {
      tmp = asList(window.navigator.languages);
    }
    return tmp;
  };
  _no_name_provided__176.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function systemLanguageStrings$factory() {
    return getPropertyCallableRef('systemLanguageStrings', 0, KProperty0, function () {
      return _get_systemLanguageStrings_();
    }, null);
  }
  function _no_name_provided_$factory_140() {
    var i = new _no_name_provided__176();
    return function () {
      return i.invoke_1005();
    };
  }
  var defaultAudioFormats$delegate;
  function Companion_63() {
    Companion_instance_62 = this;
  }
  Companion_63.prototype.invoke_261 = function (formats) {
    return (new AudioFormats()).register_0(formats.slice());
  };
  Companion_63.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_62;
  function Companion_getInstance_62() {
    if (Companion_instance_62 == null)
      new Companion_63();
    return Companion_instance_62;
  }
  function $tryReadInfoCOROUTINE$0(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__99 = _this_;
    this._data_16 = data;
    this._props = props;
  }
  $tryReadInfoCOROUTINE$0.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            this._tmp0_iterator0_0 = this.__this__99._formats.iterator_67();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator0_0.hasNext_33()) {
              this._state_1 = 6;
              continue $sm;
            }
            this._format1 = this._tmp0_iterator0_0.next_37();
            this._exceptionState = 4;
            this._state_1 = 2;
            suspendResult = this._format1.tryReadInfo_8(this._data_16.duplicate(), this._props, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var tmp1_elvis_lhs = suspendResult;
            var WHEN_RESULT;
            if (tmp1_elvis_lhs == null) {
              this._exceptionState = 7;
              this._state_1 = 1;
              continue $sm;
            } else {
              WHEN_RESULT = tmp1_elvis_lhs;
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            return WHEN_RESULT;
          case 4:
            this._exceptionState = 7;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              printStackTrace(e);
              this._state_1 = 5;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 5:
            this._exceptionState = 7;
            this._state_1 = 1;
            continue $sm;
          case 6:
            return null;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $tryReadInfoCOROUTINE$0.$metadata$ = {
    simpleName: '$tryReadInfoCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $decodeStreamCOROUTINE$1(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__100 = _this_;
    this._data_17 = data;
    this._props_0 = props;
  }
  $decodeStreamCOROUTINE$1.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._tmp0_iterator0_1 = this.__this__100._formats.iterator_67();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator0_1.hasNext_33()) {
              this._state_1 = 8;
              continue $sm;
            }
            this._format1_0 = this._tmp0_iterator0_1.next_37();
            this._exceptionState = 6;
            this._state_1 = 2;
            suspendResult = this._format1_0.tryReadInfo_8(this._data_17.duplicate(), Companion_getInstance_63()._FAST, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT2_1 = suspendResult;
            if (this._ARGUMENT2_1 == null) {
              this._exceptionState = 9;
              this._state_1 = 1;
              continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 3:
            this._state_1 = 4;
            suspendResult = this._format1_0.decodeStream_8(this._data_17.duplicate(), this._props_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            var tmp1_elvis_lhs = suspendResult;
            var WHEN_RESULT;
            if (tmp1_elvis_lhs == null) {
              this._exceptionState = 9;
              this._state_1 = 1;
              continue $sm;
            } else {
              WHEN_RESULT = tmp1_elvis_lhs;
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            return WHEN_RESULT;
          case 6:
            this._exceptionState = 9;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              printStackTrace(e);
              this._state_1 = 7;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 7:
            this._exceptionState = 9;
            this._state_1 = 1;
            continue $sm;
          case 8:
            return null;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeStreamCOROUTINE$1.$metadata$ = {
    simpleName: '$decodeStreamCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function $decodeStreamOrErrorCOROUTINE$2(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__101 = _this_;
    this._data_18 = data;
    this._props_1 = props;
  }
  $decodeStreamOrErrorCOROUTINE$2.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__101.decodeStream_8(this._data_18, this._props_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              var tmp0_error_0 = '' + "Can't decode audio stream [" + this.__this__101._formats + ']';
              throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            return tmp_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeStreamOrErrorCOROUTINE$2.$metadata$ = {
    simpleName: '$decodeStreamOrErrorCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function AudioFormats() {
    Companion_getInstance_62();
    AudioFormat.call(this, []);
    var tmp = this;
    tmp._formats = LinkedHashSet_init_$Create$();
  }
  AudioFormats.prototype.register_0 = function (formats) {
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._formats;
    addAll_0(tmp0_plusAssign_0_3, formats);
    Unit_getInstance();
    return this;
  };
  AudioFormats.prototype.tryReadInfo_8 = function (data, props, $cont) {
    var tmp = new $tryReadInfoCOROUTINE$0(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AudioFormats.prototype.decodeStream_8 = function (data, props, $cont) {
    var tmp = new $decodeStreamCOROUTINE$1(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AudioFormats.prototype.decodeStreamOrError = function (data, props, $cont) {
    var tmp = new $decodeStreamOrErrorCOROUTINE$2(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AudioFormats.$metadata$ = {
    simpleName: 'AudioFormats',
    kind: 'class',
    interfaces: []
  };
  function standardAudioFormats() {
    return Companion_getInstance_62().invoke_261([Companion_getInstance_68(), Companion_getInstance_67(), Companion_getInstance_64()]);
  }
  function Info_init_$Init$(duration, channels, decodingTime, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      var tmp0__get_seconds__0 = 0;
      duration = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
    }if (!(($mask0 & 2) === 0))
      channels = 2;
    if (!(($mask0 & 4) === 0))
      decodingTime = null;
    Info.call($this, duration, channels, decodingTime);
    return $this;
  }
  function Info_init_$Create$(duration, channels, decodingTime, $mask0, $marker) {
    return Info_init_$Init$(duration, channels, decodingTime, $mask0, $marker, Object.create(Info.prototype));
  }
  function Info(duration, channels, decodingTime) {
    this._duration = duration;
    this._channels = channels;
    this._decodingTime = decodingTime;
    var tmp = this;
    tmp._$$delegate_0_4 = Mixin_init_$Create$(null, 1, null);
  }
  Info.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_4._extra = _set___;
  };
  Info.prototype._get_extra__71 = function () {
    return this._$$delegate_0_4._extra;
  };
  Info.prototype.toString = function () {
    return '' + 'Info(duration=' + _get_niceStr__2(_TimeSpan___get_milliseconds__impl_(this._duration)) + 'ms, channels=' + this._channels + ')';
  };
  Info.prototype.hashCode = function () {
    var result = TimeSpan__hashCode_impl(this._duration);
    result = imul(result, 31) + this._channels | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this._decodingTime;
    if ((tmp_1 == null ? null : new TimeSpan(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      {
        tmp_0 = TimeSpan__hashCode_impl(this._decodingTime);
      }
    }
    result = tmp + tmp_0 | 0;
    return result;
  };
  Info.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Info))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Info ? other : THROW_CCE();
    if (!equals_1(new TimeSpan(this._duration), new TimeSpan(tmp0_other_with_cast._duration)))
      return false;
    if (!(this._channels === tmp0_other_with_cast._channels))
      return false;
    var tmp = this._decodingTime;
    var tmp_0 = tmp == null ? null : new TimeSpan(tmp);
    var tmp_1 = tmp0_other_with_cast._decodingTime;
    if (!equals_1(tmp_0, tmp_1 == null ? null : new TimeSpan(tmp_1)))
      return false;
    else {
    }
    return true;
  };
  Info.$metadata$ = {
    simpleName: 'Info',
    kind: 'class',
    interfaces: [Extra]
  };
  function AudioFormat(exts) {
    var tmp = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(exts.length);
    var indexedObject = exts;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_trim_0_5 = item_2_3.toLowerCase();
      tmp0_mapTo_0_1.add_39(toString_1(trim_0(isCharSequence(tmp0_trim_0_5) ? tmp0_trim_0_5 : THROW_CCE())));
      Unit_getInstance();
    }
    tmp._extensions = toSet_0(tmp0_mapTo_0_1);
  }
  AudioFormat.prototype.tryReadInfo_8 = function (data, props, $cont) {
    return null;
  };
  AudioFormat.prototype.decodeStream_8 = function (data, props, $cont) {
    return null;
  };
  AudioFormat.prototype.toString = function () {
    return '' + 'AudioFormat(' + sorted(this._extensions) + ')';
  };
  AudioFormat.$metadata$ = {
    simpleName: 'AudioFormat',
    kind: 'class',
    interfaces: []
  };
  function AudioDecodingProps_init_$Init$(exactTimings, readInMemory, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      exactTimings = null;
    if (!(($mask0 & 2) === 0))
      readInMemory = true;
    AudioDecodingProps.call($this, exactTimings, readInMemory);
    return $this;
  }
  function AudioDecodingProps_init_$Create$(exactTimings, readInMemory, $mask0, $marker) {
    return AudioDecodingProps_init_$Init$(exactTimings, readInMemory, $mask0, $marker, Object.create(AudioDecodingProps.prototype));
  }
  function Companion_64() {
    Companion_instance_63 = this;
    var tmp = this;
    tmp._DEFAULT_2 = AudioDecodingProps_init_$Create$(null, false, 3, null);
    this._FAST = new AudioDecodingProps(false, false);
  }
  Companion_64.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_63;
  function Companion_getInstance_63() {
    if (Companion_instance_63 == null)
      new Companion_64();
    return Companion_instance_63;
  }
  function AudioDecodingProps(exactTimings, readInMemory) {
    Companion_getInstance_63();
    this._exactTimings = exactTimings;
    this._readInMemory = readInMemory;
  }
  AudioDecodingProps.$metadata$ = {
    simpleName: 'AudioDecodingProps',
    kind: 'class',
    interfaces: []
  };
  function invalidAudioFormat(message) {
    throw new InvalidAudioFormatException(message);
  }
  function InvalidAudioFormatException(message) {
    RuntimeException_init_$Init$_0(message, this);
    captureStack(this, InvalidAudioFormatException);
  }
  InvalidAudioFormatException.$metadata$ = {
    simpleName: 'InvalidAudioFormatException',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__177() {
  }
  _no_name_provided__177.prototype.invoke_1005 = function () {
    return standardAudioFormats();
  };
  _no_name_provided__177.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_141() {
    var i = new _no_name_provided__177();
    return function () {
      return i.invoke_1005();
    };
  }
  function Companion_65() {
    Companion_instance_64 = this;
    MP3.call(this);
  }
  Companion_65.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_64;
  function Companion_getInstance_64() {
    if (Companion_instance_64 == null)
      new Companion_65();
    return Companion_instance_64;
  }
  function MP3() {
    Companion_getInstance_64();
    MP3Base.call(this);
  }
  MP3.$metadata$ = {
    simpleName: 'MP3',
    kind: 'class',
    interfaces: []
  };
  var ChannelMode_STEREO_instance;
  var ChannelMode_JOINT_STEREO_instance;
  var ChannelMode_DUAL_CHANNEL_instance;
  var ChannelMode_SINGLE_CHANNEL_instance;
  function Companion_66() {
    Companion_instance_65 = this;
    var tmp = this;
    var tmp0_map_0 = values_2();
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0.length);
    var indexedObject = tmp0_map_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_39(to(item_2_3._id_0, item_2_3));
      Unit_getInstance();
    }
    tmp._BY_ID_0 = toMap_0(tmp0_mapTo_0_1);
  }
  Companion_66.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_65;
  function Companion_getInstance_65() {
    if (Companion_instance_65 == null)
      new Companion_66();
    return Companion_instance_65;
  }
  function values_2() {
    return [ChannelMode_STEREO_getInstance(), ChannelMode_JOINT_STEREO_getInstance(), ChannelMode_DUAL_CHANNEL_getInstance(), ChannelMode_SINGLE_CHANNEL_getInstance()];
  }
  var ChannelMode_entriesInitialized;
  function ChannelMode_initEntries() {
    if (ChannelMode_entriesInitialized)
      return Unit_getInstance();
    ChannelMode_entriesInitialized = true;
    ChannelMode_STEREO_instance = new ChannelMode('STEREO', 0, 0, 2);
    ChannelMode_JOINT_STEREO_instance = new ChannelMode('JOINT_STEREO', 1, 1, 1);
    ChannelMode_DUAL_CHANNEL_instance = new ChannelMode('DUAL_CHANNEL', 2, 2, 2);
    ChannelMode_SINGLE_CHANNEL_instance = new ChannelMode('SINGLE_CHANNEL', 3, 3, 1);
    Companion_getInstance_65();
  }
  function ChannelMode(name, ordinal, id, channels) {
    Enum.call(this, name, ordinal);
    this._id_0 = id;
    this._channels_0 = channels;
  }
  ChannelMode.$metadata$ = {
    simpleName: 'ChannelMode',
    kind: 'class',
    interfaces: []
  };
  function Mp3Info(version, layer, bitrate, samplingRate, channelMode, frameSize, samples) {
    this._version = version;
    this._layer = layer;
    this._bitrate = bitrate;
    this._samplingRate = samplingRate;
    this._channelMode = channelMode;
    this._frameSize = frameSize;
    this._samples = samples;
  }
  Mp3Info.prototype.toString = function () {
    return '' + 'Mp3Info(version=' + this._version + ', layer=' + this._layer + ', bitrate=' + this._bitrate + ', samplingRate=' + this._samplingRate + ', channelMode=' + this._channelMode + ', frameSize=' + this._frameSize + ', samples=' + this._samples + ')';
  };
  Mp3Info.prototype.hashCode = function () {
    var result = getStringHashCode(this._version);
    result = imul(result, 31) + this._layer | 0;
    result = imul(result, 31) + this._bitrate | 0;
    result = imul(result, 31) + this._samplingRate | 0;
    result = imul(result, 31) + this._channelMode.hashCode() | 0;
    result = imul(result, 31) + this._frameSize | 0;
    result = imul(result, 31) + this._samples | 0;
    return result;
  };
  Mp3Info.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Mp3Info))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Mp3Info ? other : THROW_CCE();
    if (!(this._version === tmp0_other_with_cast._version))
      return false;
    if (!(this._layer === tmp0_other_with_cast._layer))
      return false;
    if (!(this._bitrate === tmp0_other_with_cast._bitrate))
      return false;
    if (!(this._samplingRate === tmp0_other_with_cast._samplingRate))
      return false;
    if (!this._channelMode.equals(tmp0_other_with_cast._channelMode))
      return false;
    if (!(this._frameSize === tmp0_other_with_cast._frameSize))
      return false;
    if (!(this._samples === tmp0_other_with_cast._samples))
      return false;
    return true;
  };
  Mp3Info.$metadata$ = {
    simpleName: 'Mp3Info',
    kind: 'class',
    interfaces: []
  };
  function framesize($this, layer, bitrate, sample_rate, padding_bit) {
    var tmp;
    if (layer === 1) {
      tmp = imul((imul(imul(12, bitrate), 1000) / sample_rate | 0) + padding_bit | 0, 4);
    } else {
      tmp = (imul(imul(144, bitrate), 1000) / sample_rate | 0) + padding_bit | 0;
    }
    return tmp;
  }
  function ChannelMode_STEREO_getInstance() {
    ChannelMode_initEntries();
    return ChannelMode_STEREO_instance;
  }
  function ChannelMode_JOINT_STEREO_getInstance() {
    ChannelMode_initEntries();
    return ChannelMode_JOINT_STEREO_instance;
  }
  function ChannelMode_DUAL_CHANNEL_getInstance() {
    ChannelMode_initEntries();
    return ChannelMode_DUAL_CHANNEL_instance;
  }
  function ChannelMode_SINGLE_CHANNEL_getInstance() {
    ChannelMode_initEntries();
    return ChannelMode_SINGLE_CHANNEL_instance;
  }
  function _getDuration($this, use_cbr_estimate, emit, $cont) {
    var tmp = new $_getDurationCOROUTINE$8($this, use_cbr_estimate, emit, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    var tmp_0 = tmp.doResume_275();
    if (tmp_0 === _get_COROUTINE_SUSPENDED_())
      return tmp_0;
    return tmp_0._milliseconds;
  }
  function _getDuration$default($this, use_cbr_estimate, emit, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      emit = null;
    return _getDuration($this, use_cbr_estimate, emit, $cont);
  }
  function estimateDuration($this, bitrate, channels, offset, $cont) {
    var kbps = imul(bitrate, 1000) / 8 | 0;
    var tmp0_minus_0 = $this._dataLength;
    var dataSize = tmp0_minus_0.minus_29(toLong(offset));
    var tmp1_times_0 = 2 / channels | 0;
    var tmp2_div_0 = dataSize.times_28(toLong(tmp1_times_0)).times_28(new Long(1000000, 0));
    return tmp2_div_0.div_28(toLong(kbps));
  }
  function skipID3v2Tag($this, block, $cont) {
    var tmp = new $skipID3v2TagCOROUTINE$9($this, block, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function Companion_67() {
    Companion_instance_66 = this;
    var tmp = this;
    var tmp0_arrayOf_0 = ['2.5', 'x', '2', '1'];
    tmp._versions = tmp0_arrayOf_0;
    var tmp_0 = this;
    var tmp0_intArrayOf_0 = new Int32Array([-1, 3, 2, 1]);
    tmp_0._layers = tmp0_intArrayOf_0;
    var tmp_1 = this;
    var tmp_2 = this.getBitrateKey(1, 1);
    var tmp0_intArrayOf_0_0 = new Int32Array([0, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448]);
    var tmp_3 = to(tmp_2, tmp0_intArrayOf_0_0);
    var tmp_4 = this.getBitrateKey(1, 2);
    var tmp1_intArrayOf_0 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384]);
    var tmp_5 = to(tmp_4, tmp1_intArrayOf_0);
    var tmp_6 = this.getBitrateKey(1, 3);
    var tmp2_intArrayOf_0 = new Int32Array([0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320]);
    var tmp_7 = to(tmp_6, tmp2_intArrayOf_0);
    var tmp_8 = this.getBitrateKey(2, 1);
    var tmp3_intArrayOf_0 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256]);
    var tmp_9 = to(tmp_8, tmp3_intArrayOf_0);
    var tmp_10 = this.getBitrateKey(2, 2);
    var tmp4_intArrayOf_0 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    var tmp_11 = to(tmp_10, tmp4_intArrayOf_0);
    var tmp_12 = this.getBitrateKey(2, 3);
    var tmp5_intArrayOf_0 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    tmp_1._bitrates = mapOf([tmp_3, tmp_5, tmp_7, tmp_9, tmp_11, to(tmp_12, tmp5_intArrayOf_0)]);
    var tmp_13 = this;
    var tmp0_intArrayOf_0_1 = new Int32Array([44100, 48000, 32000]);
    var tmp_14 = to('1', tmp0_intArrayOf_0_1);
    var tmp1_intArrayOf_0_0 = new Int32Array([22050, 24000, 16000]);
    var tmp_15 = to('2', tmp1_intArrayOf_0_0);
    var tmp2_intArrayOf_0_0 = new Int32Array([11025, 12000, 8000]);
    tmp_13._sampleRates = mapOf([tmp_14, tmp_15, to('2.5', tmp2_intArrayOf_0_0)]);
    this._samples_0 = mapOf([to(1, mapOf([to(1, 384), to(2, 1152), to(3, 1152)])), to(2, mapOf([to(1, 384), to(2, 1152), to(3, 576)]))]);
  }
  Companion_67.prototype.getBitrateKey = function (version, layer) {
    return imul(version, 10) + layer | 0;
  };
  Companion_67.prototype.parseFrameHeader = function (f4) {
    var b0 = UByteArrayInt__get_impl(f4, 0);
    var b1 = UByteArrayInt__get_impl(f4, 1);
    var b2 = UByteArrayInt__get_impl(f4, 2);
    var b3 = UByteArrayInt__get_impl(f4, 3);
    if (!(b0 === 255)) {
      _get_invalidOp_();
    }var version = this._versions[extract(b1, 3, 2)];
    var simple_version = version === '2.5' ? 2 : toInt(version);
    var layer = this._layers[extract(b1, 1, 2)];
    var protection_bit = extract(b1, 0, 1);
    var bitrate_key = this.getBitrateKey(simple_version, layer);
    var bitrate_idx = extract(b2, 4, 4);
    var tmp0_safe_receiver = this._bitrates.get_116(bitrate_key);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[bitrate_idx];
    var bitrate = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp2_safe_receiver = this._sampleRates.get_116(version);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver[extract(b2, 2, 2)];
    var sample_rate = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    var padding_bit = extract(b2, 1, 1);
    var private_bit = extract(b2, 0, 1);
    var channelMode = ensureNotNull(Companion_getInstance_65()._BY_ID_0.get_116(extract(b3, 6, 2)));
    var mode_extension_bits = extract(b3, 4, 2);
    var copyright_bit = extract(b3, 3, 1);
    var original_bit = extract(b3, 2, 1);
    var emphasis = extract(b3, 0, 2);
    var tmp = framesize(this, layer, bitrate, sample_rate, padding_bit);
    var tmp4_safe_receiver = this._samples_0.get_116(simple_version);
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.get_116(layer);
    return new Mp3Info(version, layer, bitrate, sample_rate, channelMode, tmp, tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs);
  };
  Companion_67.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_66;
  function Companion_getInstance_66() {
    if (Companion_instance_66 == null)
      new Companion_67();
    return Companion_instance_66;
  }
  function $_getDurationCOROUTINE$8(_this_, use_cbr_estimate, emit, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__102 = _this_;
    this._use_cbr_estimate = use_cbr_estimate;
    this._emit = emit;
  }
  $_getDurationCOROUTINE$8.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 18;
            this.__this__102._data_19._position_3 = new Long(0, 0);
            this._fd0 = this.__this__102._data_19.duplicate();
            this._state_1 = 1;
            suspendResult = this._fd0.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._len1 = suspendResult;
            this._durationMicroseconds2 = 0.0;
            this._state_1 = 2;
            suspendResult = readStream(this._fd0, 100, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT3_1 = suspendResult;
            this._state_1 = 3;
            suspendResult = skipID3v2Tag(this.__this__102, this._ARGUMENT3_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._offset4 = suspendResult;
            this._pos5 = this._offset4;
            this._info6 = null;
            this._nframes7 = 0;
            this._block28 = _UByteArrayInt___init__impl_(new Int8Array(10));
            this._fdbase9 = this._fd0._base;
            this._fdsync10 = toSyncOrNull(this._fdbase9);
            this._nreads11 = 0;
            this._nskips12 = 0;
            this._nasync13 = 0;
            this._state_1 = 4;
            continue $sm;
          case 4:
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._exceptionState = 17;
            this._state_1 = 6;
            continue $sm;
          case 6:
            if (!(this._pos5.compareTo_137(this._len1) < 0)) {
              this._state_1 = 15;
              continue $sm;
            }
            if (!(this._fdsync10 == null)) {
              this._WHEN_RESULT16 = this._fdsync10.read_37(this._pos5, _UByteArrayInt___get_bytes__impl_(this._block28), 0, 10);
              this._state_1 = 8;
              continue $sm;
            } else {
              var tmp0 = this._nasync13;
              this._nasync13 = tmp0 + 1 | 0;
              Unit_getInstance();
              this._fd0._position_3 = this._pos5;
              this._state_1 = 7;
              suspendResult = readBytesUpTo_0(this._fd0, _UByteArrayInt___get_bytes__impl_(this._block28), 0, 10, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 7:
            this._WHEN_RESULT16 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 8:
            this._block2Size17 = this._WHEN_RESULT16;
            var tmp1 = this._nreads11;
            this._nreads11 = tmp1 + 1 | 0;
            Unit_getInstance();
            if (this._block2Size17 < 10) {
              this._state_1 = 15;
              continue $sm;
            } else {
              this._state_1 = 9;
              continue $sm;
            }

            Unit_getInstance();
            break;
          case 9:
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_plus_018 = this._pos5;
            tmp_0._pos5 = this._tmp0_plus_018.plus_64(toLong(this._block2Size17));
            if (UByteArrayInt__get_impl(this._block28, 0) === 255 ? !((UByteArrayInt__get_impl(this._block28, 1) & 224) === 0) : false) {
              this._framePos19 = this._fd0._position_3;
              this._info6 = Companion_getInstance_66().parseFrameHeader(this._block28);
              var tmp2_safe_receiver = this._emit;
              if (tmp2_safe_receiver == null)
                null;
              else
                tmp2_safe_receiver(this._framePos19, this._durationMicroseconds2, this._info6);
              Unit_getInstance();
              var tmp3 = this._nframes7;
              this._nframes7 = tmp3 + 1 | 0;
              Unit_getInstance();
              this.__this__102._info = this._info6;
              if (this._info6._frameSize === 0) {
                var tmp_2 = this;
                var tmp_3 = this;
                tmp_3._tmp1__get_microseconds__020 = this._durationMicroseconds2;
                tmp_2._tmp$ret$015 = Companion_getInstance_27().fromMicroseconds(this._tmp1__get_microseconds__020);
                this._exceptionState = 18;
                this._state_1 = 14;
                continue $sm;
              } else {
                this._state_1 = 10;
                continue $sm;
              }
            } else {
              var tmp_4 = _UByteArrayInt___get_bytes__impl_(this._block28);
              var tmp_5 = openSync$default(tmp_4, null, 1, null);
              if (readString$default_0(tmp_5, 3, null, 2, null) === 'TAG') {
                var tmp_6 = this;
                var tmp6_plus_0 = this._pos5;
                var tmp7_plus_0 = 118;
                tmp_6._pos5 = tmp6_plus_0.plus_64(toLong(tmp7_plus_0));
                this._state_1 = 11;
                continue $sm;
              } else {
                {
                  var tmp_7 = this;
                  var tmp8_minus_0 = this._pos5;
                  var tmp9_minus_0 = 9;
                  tmp_7._pos5 = tmp8_minus_0.minus_29(toLong(tmp9_minus_0));
                  var tmp4 = this._nskips12;
                  this._nskips12 = tmp4 + 1 | 0;
                  Unit_getInstance();
                  this._state_1 = 11;
                  continue $sm;
                }
              }
            }

            break;
          case 10:
            var tmp_8 = this;
            var tmp_9 = this;
            tmp_9._tmp2_plus_021 = this._pos5;
            var tmp_10 = this;
            tmp_10._tmp3_plus_022 = this._info6._frameSize - 10 | 0;
            tmp_8._pos5 = this._tmp2_plus_021.plus_64(toLong(this._tmp3_plus_022));
            var tmp_11 = this;
            var tmp_12 = this._durationMicroseconds2;
            var tmp_13 = this;
            tmp_13._tmp4_div_023 = numberToLong(this._info6._samples).times_28(new Long(1000000, 0));
            var tmp_14 = this;
            tmp_14._tmp5_div_024 = this._info6._samplingRate;
            tmp_11._durationMicroseconds2 = tmp_12 + this._tmp4_div_023.div_28(toLong(this._tmp5_div_024)).toDouble_6();
            this._state_1 = 11;
            continue $sm;
          case 11:
            if (!(this._info6 == null) ? this._use_cbr_estimate : false) {
              this._state_1 = 13;
              suspendResult = estimateDuration(this.__this__102, this._info6._bitrate, this._info6._channelMode._channels_0, this._offset4.toInt_8(), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 12;
              continue $sm;
            }

            break;
          case 12:
            this._state_1 = 6;
            continue $sm;
          case 13:
            var tmp10__get_microseconds__0 = suspendResult;
            this._tmp$ret$015 = Companion_getInstance_27().fromMicroseconds(tmp10__get_microseconds__0.toDouble_6());
            this._exceptionState = 18;
            this._state_1 = 14;
            continue $sm;
          case 14:
            var tmp_15 = this._tmp$ret$015;
            return new TimeSpan(tmp_15);
          case 15:
            this._tmp$ret$214 = Unit_getInstance();
            this._exceptionState = 18;
            this._state_1 = 16;
            continue $sm;
          case 16:
            var tmp11__get_microseconds__0 = this._durationMicroseconds2;
            return new TimeSpan(Companion_getInstance_27().fromMicroseconds(tmp11__get_microseconds__0));
          case 17:
            this._exceptionState = 18;
            var t = this._exception_0;
            throw t;
          case 18:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 18) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $_getDurationCOROUTINE$8.$metadata$ = {
    simpleName: '$_getDurationCOROUTINE$8',
    kind: 'class',
    interfaces: []
  };
  function $skipID3v2TagCOROUTINE$9(_this_, block, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__103 = _this_;
    this._block_0 = block;
  }
  $skipID3v2TagCOROUTINE$9.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._b0 = this._block_0.duplicate();
            this._state_1 = 1;
            suspendResult = readString(this._b0, 3, Charsets_getInstance()._get_LATIN1_(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1_7 = suspendResult;
            if (this._ARGUMENT1_7 === 'ID3') {
              this._state_1 = 2;
              suspendResult = readBytesExact(this._b0, 7, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            var bb = suspendResult;
            var id3v2_major_version = readU8(bb, 0);
            var id3v2_minor_version = readU8(bb, 1);
            var id3v2_flags = readU8(bb, 2);
            var z0 = readU8(bb, 3);
            var z1 = readU8(bb, 4);
            var z2 = readU8(bb, 5);
            var z3 = readU8(bb, 6);
            var flag_unsynchronisation = extract_0(id3v2_flags, 7);
            var flag_extended_header = extract_0(id3v2_flags, 6);
            var flag_experimental_ind = extract_0(id3v2_flags, 5);
            var flag_footer_present = extract_0(id3v2_flags, 4);
            if ((((z0 & 128) === 0 ? (z1 & 128) === 0 : false) ? (z2 & 128) === 0 : false) ? (z3 & 128) === 0 : false) {
              var header_size = 10;
              var tag_size = ((imul(z0 & 127, 2097152) + imul(z1 & 127, 16384) | 0) + imul(z2 & 127, 128) | 0) + (z3 & 127) | 0;
              var footer_size = flag_footer_present ? 10 : 0;
              return toLong((header_size + tag_size | 0) + footer_size | 0);
            }
            this._state_1 = 3;
            continue $sm;
          case 3:
            return new Long(0, 0);
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $skipID3v2TagCOROUTINE$9.$metadata$ = {
    simpleName: '$skipID3v2TagCOROUTINE$9',
    kind: 'class',
    interfaces: []
  };
  function Parser(data, dataLength) {
    Companion_getInstance_66();
    this._data_19 = data;
    this._dataLength = dataLength;
    this._info = null;
  }
  Parser.prototype.getDurationEstimate = function ($cont) {
    return _getDuration$default(this, true, null, 4, null, $cont);
  };
  Parser.prototype.getDurationExact = function ($cont) {
    return _getDuration$default(this, false, null, 4, null, $cont);
  };
  Parser.$metadata$ = {
    simpleName: 'Parser',
    kind: 'class',
    interfaces: []
  };
  function $tryReadInfoCOROUTINE$6(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__104 = _this_;
    this._data_20 = data;
    this._props_2 = props;
  }
  $tryReadInfoCOROUTINE$6.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 10;
            this._exceptionState = 9;
            this._state_1 = 1;
            suspendResult = this._data_20.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1_8 = suspendResult;
            this._parser2 = new Parser(this._data_20, this._ARGUMENT1_8);
            this._start_13 = PerformanceCounter_getInstance()._get_microseconds_();
            this._tmp0_subject_74 = this._props_2._exactTimings;
            if (this._tmp0_subject_74 == null) {
              this._state_1 = 6;
              suspendResult = this._parser2.getDurationExact(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }this._state_1 = 7;
              continue $sm;
            } else {
              if (this._tmp0_subject_74 === true) {
                this._state_1 = 4;
                suspendResult = this._parser2.getDurationExact(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }this._state_1 = 5;
                continue $sm;
              } else {
                this._state_1 = 2;
                suspendResult = this._parser2.getDurationEstimate(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }this._state_1 = 3;
                continue $sm;
              }
              new TimeSpan(Unit_getInstance());
            }

            break;
          case 2:
            var unboxed = suspendResult._milliseconds;
            suspendResult = unboxed;
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._WHEN_RESULT5_0 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 4:
            var unboxed_0 = suspendResult._milliseconds;
            suspendResult = unboxed_0;
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._WHEN_RESULT5_0 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 6:
            var unboxed_1 = suspendResult._milliseconds;
            suspendResult = unboxed_1;
            this._state_1 = 7;
            continue $sm;
          case 7:
            this._WHEN_RESULT5_0 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 8:
            var result_2 = this._WHEN_RESULT5_0;
            var end_3 = PerformanceCounter_getInstance()._get_microseconds_();
            var tmp0__get_microseconds__0_5 = end_3 - this._start_13;
            var elapsed_4 = Companion_getInstance_27().fromMicroseconds(tmp0__get_microseconds__0_5);
            var tmp0_container = new TimedResult(new TimeSpan(result_2), elapsed_4);
            var duration = tmp0_container.component1_1()._milliseconds;
            var decodingTime = tmp0_container.component2_0();
            var tmp_0 = this;
            var tmp1_safe_receiver = this._parser2._info;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._channelMode;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._channels_0;
            tmp_0._TRY_RESULT0_2 = new Info(duration, tmp3_elvis_lhs == null ? 2 : tmp3_elvis_lhs, decodingTime);
            this._exceptionState = 10;
            this._state_1 = 11;
            continue $sm;
          case 9:
            this._exceptionState = 10;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e = this._exception_0;
              var tmp_2 = this;
              tmp_2._TRY_RESULT0_2 = null;
              this._state_1 = 11;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 10:
            throw this._exception_0;
          case 11:
            this._exceptionState = 10;
            return this._TRY_RESULT0_2;
        }
      } catch ($p) {
        if (this._exceptionState === 10) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $tryReadInfoCOROUTINE$6.$metadata$ = {
    simpleName: '$tryReadInfoCOROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function MP3Base() {
    AudioFormat.call(this, ['mp3']);
  }
  MP3Base.prototype.tryReadInfo_8 = function (data, props, $cont) {
    var tmp = new $tryReadInfoCOROUTINE$6(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  MP3Base.$metadata$ = {
    simpleName: 'MP3Base',
    kind: 'class',
    interfaces: []
  };
  function Companion_68() {
    Companion_instance_67 = this;
    OGG.call(this);
  }
  Companion_68.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_67;
  function Companion_getInstance_67() {
    if (Companion_instance_67 == null)
      new Companion_68();
    return Companion_instance_67;
  }
  function OGG() {
    Companion_getInstance_67();
    OggBase.call(this);
  }
  OGG.$metadata$ = {
    simpleName: 'OGG',
    kind: 'class',
    interfaces: []
  };
  function $tryReadInfoCOROUTINE$11(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__105 = _this_;
    this._data_21 = data;
    this._props_3 = props;
  }
  $tryReadInfoCOROUTINE$11.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__105.parse_7(this._data_21, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._TRY_RESULT0_3 = suspendResult;
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              var tmp_1 = this;
              tmp_1._TRY_RESULT0_3 = null;
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return this._TRY_RESULT0_3;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $tryReadInfoCOROUTINE$11.$metadata$ = {
    simpleName: '$tryReadInfoCOROUTINE$11',
    kind: 'class',
    interfaces: []
  };
  function $parseCOROUTINE$12(_this_, s, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__106 = _this_;
    this._s_3 = s;
  }
  $parseCOROUTINE$12.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 29;
            this._channels0 = 2;
            this._sampleRate1 = 44100;
            this._brnom2 = 160000;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._state_1 = 2;
            suspendResult = hasAvailable(this._s_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            if (!suspendResult) {
              this._state_1 = 28;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = readString$default(this._s_3, 5, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._magic3 = suspendResult;
            if (!(this._magic3 === 'OggS\x00')) {
              invalidAudioFormat('Not an OGG file');
            }
            this._state_1 = 4;
            suspendResult = readS8_0(this._s_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._type4 = suspendResult;
            this._cont5 = extract_0(this._type4, 0);
            this._bos6 = extract_0(this._type4, 1);
            this._eos7 = extract_0(this._type4, 2);
            this._state_1 = 5;
            suspendResult = readS64LE_0(this._s_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._gpos8 = suspendResult;
            this._state_1 = 6;
            suspendResult = readS32LE_0(this._s_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._sn9 = suspendResult;
            this._state_1 = 7;
            suspendResult = readS32LE_0(this._s_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._psn10 = suspendResult;
            this._state_1 = 8;
            suspendResult = readS32LE_0(this._s_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._chk11 = suspendResult;
            this._state_1 = 9;
            suspendResult = readU8_1(this._s_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._pseg12 = suspendResult;
            var tmp_0 = this;
            tmp_0._tmp0_map_013 = until(0, this._pseg12);
            var tmp_1 = this;
            tmp_1._tmp0_mapTo_0_114 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._tmp0_map_013, 10));
            this._tmp0_iterator_1_215 = this._tmp0_map_013.iterator_67();
            this._state_1 = 10;
            continue $sm;
          case 10:
            if (!this._tmp0_iterator_1_215.hasNext_33()) {
              this._state_1 = 12;
              continue $sm;
            }
            this._item_2_316 = this._tmp0_iterator_1_215.next_37();
            this._state_1 = 11;
            suspendResult = readU8_1(this._s_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._ARGUMENT17 = suspendResult;
            this._tmp0_mapTo_0_114.add_39(this._ARGUMENT17);
            Unit_getInstance();
            this._state_1 = 10;
            continue $sm;
          case 12:
            this._psizs18 = this._tmp0_mapTo_0_114;
            var tmp_2 = this;
            tmp_2._tmp0_mapTo_0_119 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._psizs18, 10));
            this._tmp0_iterator_1_220 = this._psizs18.iterator_67();
            this._state_1 = 13;
            continue $sm;
          case 13:
            if (!this._tmp0_iterator_1_220.hasNext_33()) {
              this._state_1 = 15;
              continue $sm;
            }
            this._item_2_321 = this._tmp0_iterator_1_220.next_37();
            this._state_1 = 14;
            suspendResult = readStream(this._s_3, this._item_2_321, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 14:
            this._ARGUMENT22_0 = suspendResult;
            this._tmp0_mapTo_0_119.add_39(this._ARGUMENT22_0);
            Unit_getInstance();
            this._state_1 = 13;
            continue $sm;
          case 15:
            this._pages23 = this._tmp0_mapTo_0_119;
            if (this._bos6) {
              this._info24 = this._pages23.get_137(0);
              this._state_1 = 16;
              suspendResult = readU8_1(this._info24, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 27;
              continue $sm;
            }

            break;
          case 16:
            this._packetType25 = suspendResult;
            if (this._packetType25 > 3) {
              invalidOp('Unsupported OGG vorbis file');
            }
            this._state_1 = 17;
            suspendResult = readString$default(this._info24, 6, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 17:
            this._ARGUMENT26 = suspendResult;
            this._ARGUMENT27 = this._ARGUMENT26 === 'vorbis';
            if (!this._ARGUMENT27) {
              invalidOp('Unsupported OGG vorbis file');
            } else {
              this._state_1 = 18;
              continue $sm;
            }

            break;
          case 18:
            this._tmp0_subject28 = this._packetType25;
            if (this._tmp0_subject28 === 1) {
              this._state_1 = 19;
              suspendResult = readS32LE_0(this._info24, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              if (this._tmp0_subject28 === 3) {
                Unit_getInstance();
                this._state_1 = 26;
                continue $sm;
              } else {
                if (this._tmp0_subject28 === 5) {
                  Unit_getInstance();
                  this._state_1 = 26;
                  continue $sm;
                } else {
                  this._state_1 = 26;
                  continue $sm;
                }
              }
            }

            break;
          case 19:
            this._vver29 = suspendResult;
            this._state_1 = 20;
            suspendResult = readU8_1(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 20:
            this._channels0 = suspendResult;
            this._state_1 = 21;
            suspendResult = readS32LE_0(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 21:
            this._sampleRate1 = suspendResult;
            this._state_1 = 22;
            suspendResult = readS32LE_0(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 22:
            this._brmax30 = suspendResult;
            this._state_1 = 23;
            suspendResult = readS32LE_0(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 23:
            this._brnom2 = suspendResult;
            this._state_1 = 24;
            suspendResult = readS32LE_0(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 24:
            this._brmin31 = suspendResult;
            this._state_1 = 25;
            suspendResult = readU8_1(this._info24, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 25:
            var bsinfo = suspendResult;
            this._state_1 = 26;
            continue $sm;
          case 26:
            this._state_1 = 27;
            continue $sm;
          case 27:
            if (this._eos7) {
              var tmp1__get_microseconds__0 = numberToLong(this._gpos8.toDouble_6() * 1000000.0 / this._sampleRate1);
              var tmp_3 = Companion_getInstance_27().fromMicroseconds(tmp1__get_microseconds__0.toDouble_6());
              var tmp_4 = this._channels0;
              return Info_init_$Create$(tmp_3, tmp_4, null, 4, null);
            }
            this._state_1 = 1;
            continue $sm;
          case 28:
            invalidOp('Cannot parse stream');
            break;
          case 29:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 29) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $parseCOROUTINE$12.$metadata$ = {
    simpleName: '$parseCOROUTINE$12',
    kind: 'class',
    interfaces: []
  };
  function OggBase() {
    AudioFormat.call(this, ['ogg']);
  }
  OggBase.prototype.tryReadInfo_8 = function (data, props, $cont) {
    var tmp = new $tryReadInfoCOROUTINE$11(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  OggBase.prototype.parse_7 = function (s, $cont) {
    var tmp = new $parseCOROUTINE$12(this, s, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  OggBase.$metadata$ = {
    simpleName: 'OggBase',
    kind: 'class',
    interfaces: []
  };
  function $readCOROUTINE$15(_this_, out, offset, length, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__107 = _this_;
    this._out_7 = out;
    this._offset_17 = offset;
    this._length_3 = length;
  }
  $readCOROUTINE$15.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = readBytesUpTo(this.__this__107._buffer_18, imul(imul(this._length_3, this.__this__107._bytesPerSample), this.__this__107._get_channels__2()), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._bytes0 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__107._buffer_18.eof_0(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.__this__107._finished = ARGUMENT;
            var availableSamples = (this._bytes0.length / this.__this__107._bytesPerSample | 0) / this.__this__107._get_channels__2() | 0;
            var inductionVariable = 0;
            var last_1 = this.__this__107._get_channels__2();
            if (inductionVariable < last_1)
              do {
                var channel = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp1_subject = this.__this__107._bytesPerSample;
                switch (tmp1_subject) {
                  case 1:
                    var tmp0_readBlock_0 = Companion_getInstance_68();
                    var tmp1_readBlock_0 = this.__this__107._get_channels__2();
                    var tmp2_readBlock_0 = this.__this__107._bytesPerSample;
                    var increment_1 = imul(tmp1_readBlock_0, tmp2_readBlock_0);
                    var index_2 = imul(channel, tmp2_readBlock_0);
                    var outc_3 = this._out_7.get_137(channel);
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < availableSamples)
                      do {
                        var n_5 = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        var tmp_0 = this._offset_17 + n_5 | 0;
                        var tmp3__anonymous__6 = index_2;
                        outc_3[tmp_0] = coerceToShort(imul(readU8(this._bytes0, tmp3__anonymous__6) - 128 | 0, 255));
                        index_2 = index_2 + increment_1 | 0;
                      }
                       while (inductionVariable_0 < availableSamples);
                    break;
                  case 2:
                    var tmp4_readBlock_0 = Companion_getInstance_68();
                    var tmp5_readBlock_0 = this.__this__107._get_channels__2();
                    var tmp6_readBlock_0 = this.__this__107._bytesPerSample;
                    var increment_1_0 = imul(tmp5_readBlock_0, tmp6_readBlock_0);
                    var index_2_0 = imul(channel, tmp6_readBlock_0);
                    var outc_3_0 = this._out_7.get_137(channel);
                    var inductionVariable_1 = 0;
                    if (inductionVariable_1 < availableSamples)
                      do {
                        var n_5_0 = inductionVariable_1;
                        inductionVariable_1 = inductionVariable_1 + 1 | 0;
                        var tmp_1 = this._offset_17 + n_5_0 | 0;
                        var tmp7__anonymous__6 = index_2_0;
                        outc_3_0[tmp_1] = toShort(readS16LE(this._bytes0, tmp7__anonymous__6));
                        index_2_0 = index_2_0 + increment_1_0 | 0;
                      }
                       while (inductionVariable_1 < availableSamples);
                    break;
                  case 3:
                    var tmp8_readBlock_0 = Companion_getInstance_68();
                    var tmp9_readBlock_0 = this.__this__107._get_channels__2();
                    var tmp10_readBlock_0 = this.__this__107._bytesPerSample;
                    var increment_1_1 = imul(tmp9_readBlock_0, tmp10_readBlock_0);
                    var index_2_1 = imul(channel, tmp10_readBlock_0);
                    var outc_3_1 = this._out_7.get_137(channel);
                    var inductionVariable_2 = 0;
                    if (inductionVariable_2 < availableSamples)
                      do {
                        var n_5_1 = inductionVariable_2;
                        inductionVariable_2 = inductionVariable_2 + 1 | 0;
                        var tmp_2 = this._offset_17 + n_5_1 | 0;
                        var tmp11__anonymous__6 = index_2_1;
                        outc_3_1[tmp_2] = toShort(readS24LE(this._bytes0, tmp11__anonymous__6) >>> 8);
                        index_2_1 = index_2_1 + increment_1_1 | 0;
                      }
                       while (inductionVariable_2 < availableSamples);
                    break;
                  default:invalidOp('' + 'Unsupported bytesPerSample=' + this.__this__107._bytesPerSample);
                    break;
                }
              }
               while (inductionVariable < last_1);
            return availableSamples;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readCOROUTINE$15.$metadata$ = {
    simpleName: '$readCOROUTINE$15',
    kind: 'class',
    interfaces: []
  };
  function $cloneCOROUTINE$16(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__108 = _this_;
  }
  $cloneCOROUTINE$16.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = (new WAV()).decodeStream_8(this.__this__108._data_24.duplicate(), this.__this__108._props_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ensureNotNull(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $cloneCOROUTINE$16.$metadata$ = {
    simpleName: '$cloneCOROUTINE$16',
    kind: 'class',
    interfaces: []
  };
  function Fmt_init_$Init$(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      formatTag = -1;
    if (!(($mask0 & 2) === 0))
      channels = 2;
    if (!(($mask0 & 4) === 0))
      samplesPerSec = 44100;
    if (!(($mask0 & 8) === 0))
      avgBytesPerSec = new Long(0, 0);
    if (!(($mask0 & 16) === 0))
      blockAlign = 0;
    if (!(($mask0 & 32) === 0))
      bitsPerSample = 0;
    Fmt.call($this, formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample);
    return $this;
  }
  function Fmt_init_$Create$(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, $mask0, $marker) {
    return Fmt_init_$Init$(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample, $mask0, $marker, Object.create(Fmt.prototype));
  }
  function Companion_69() {
    Companion_instance_68 = this;
    WAV.call(this);
  }
  Companion_69.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_68;
  function Companion_getInstance_68() {
    if (Companion_instance_68 == null)
      new Companion_69();
    return Companion_instance_68;
  }
  function Chunk(type, data) {
    this._type_0 = type;
    this._data_22 = data;
  }
  Chunk.prototype.component1_1 = function () {
    return this._type_0;
  };
  Chunk.prototype.component2_1 = function () {
    return this._data_22;
  };
  Chunk.prototype.toString = function () {
    return '' + 'Chunk(type=' + this._type_0 + ', data=' + this._data_22 + ')';
  };
  Chunk.prototype.hashCode = function () {
    var result = getStringHashCode(this._type_0);
    result = imul(result, 31) + hashCode(this._data_22) | 0;
    return result;
  };
  Chunk.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Chunk))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Chunk ? other : THROW_CCE();
    if (!(this._type_0 === tmp0_other_with_cast._type_0))
      return false;
    if (!equals_1(this._data_22, tmp0_other_with_cast._data_22))
      return false;
    return true;
  };
  Chunk.$metadata$ = {
    simpleName: 'Chunk',
    kind: 'class',
    interfaces: []
  };
  function ProcessedChunk(type, data, extra) {
    this._type_1 = type;
    this._data_23 = data;
    this._extra_0 = extra;
  }
  ProcessedChunk.prototype.toString = function () {
    return '' + 'ProcessedChunk(type=' + this._type_1 + ', data=' + this._data_23 + ', extra=' + this._extra_0 + ')';
  };
  ProcessedChunk.prototype.hashCode = function () {
    var result = getStringHashCode(this._type_1);
    result = imul(result, 31) + hashCode(this._data_23) | 0;
    result = imul(result, 31) + hashCode(this._extra_0) | 0;
    return result;
  };
  ProcessedChunk.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessedChunk))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProcessedChunk ? other : THROW_CCE();
    if (!(this._type_1 === tmp0_other_with_cast._type_1))
      return false;
    if (!equals_1(this._data_23, tmp0_other_with_cast._data_23))
      return false;
    if (!equals_1(this._extra_0, tmp0_other_with_cast._extra_0))
      return false;
    return true;
  };
  ProcessedChunk.$metadata$ = {
    simpleName: 'ProcessedChunk',
    kind: 'class',
    interfaces: []
  };
  function WavAudioStream(fmt, buffer, bufferLength, data, props) {
    AudioStream.call(this, fmt._samplesPerSec, fmt._channels_1);
    this._fmt = fmt;
    this._buffer_18 = buffer;
    this._bufferLength = bufferLength;
    this._data_24 = data;
    this._props_4 = props;
    this._bytesPerSample = this._fmt._get_bytesPerSample_();
    this._finished = false;
  }
  WavAudioStream.prototype._get_finished__1 = function () {
    return this._finished;
  };
  WavAudioStream.prototype._get_totalLengthInSamples__1 = function () {
    var tmp0_div_0 = this._bufferLength;
    var tmp1_div_0 = this._bytesPerSample;
    return tmp0_div_0.div_28(toLong(tmp1_div_0));
  };
  WavAudioStream.prototype._set_currentPositionInSamples__1 = function (value) {
    this._finished = false;
    var tmp = this._buffer_18;
    var tmp0_times_0_2 = this._bytesPerSample;
    tmp._position_3 = value.times_28(toLong(tmp0_times_0_2));
    return Unit_getInstance();
  };
  WavAudioStream.prototype.read_41 = function (out, offset, length, $cont) {
    var tmp = new $readCOROUTINE$15(this, out, offset, length, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  WavAudioStream.prototype.clone_8 = function ($cont) {
    var tmp = new $cloneCOROUTINE$16(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  WavAudioStream.$metadata$ = {
    simpleName: 'WavAudioStream',
    kind: 'class',
    interfaces: []
  };
  function Fmt(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample) {
    this._formatTag = formatTag;
    this._channels_1 = channels;
    this._samplesPerSec = samplesPerSec;
    this._avgBytesPerSec = avgBytesPerSec;
    this._blockAlign = blockAlign;
    this._bitsPerSample = bitsPerSample;
  }
  Fmt.prototype._get_bytesPerSample_ = function () {
    return this._bitsPerSample / 8 | 0;
  };
  Fmt.prototype.toString = function () {
    return '' + 'Fmt(formatTag=' + this._formatTag + ', channels=' + this._channels_1 + ', samplesPerSec=' + this._samplesPerSec + ', avgBytesPerSec=' + this._avgBytesPerSec + ', blockAlign=' + this._blockAlign + ', bitsPerSample=' + this._bitsPerSample + ')';
  };
  Fmt.prototype.hashCode = function () {
    var result = this._formatTag;
    result = imul(result, 31) + this._channels_1 | 0;
    result = imul(result, 31) + this._samplesPerSec | 0;
    result = imul(result, 31) + this._avgBytesPerSec.hashCode() | 0;
    result = imul(result, 31) + this._blockAlign | 0;
    result = imul(result, 31) + this._bitsPerSample | 0;
    return result;
  };
  Fmt.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Fmt))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Fmt ? other : THROW_CCE();
    if (!(this._formatTag === tmp0_other_with_cast._formatTag))
      return false;
    if (!(this._channels_1 === tmp0_other_with_cast._channels_1))
      return false;
    if (!(this._samplesPerSec === tmp0_other_with_cast._samplesPerSec))
      return false;
    if (!this._avgBytesPerSec.equals(tmp0_other_with_cast._avgBytesPerSec))
      return false;
    if (!(this._blockAlign === tmp0_other_with_cast._blockAlign))
      return false;
    if (!(this._bitsPerSample === tmp0_other_with_cast._bitsPerSample))
      return false;
    return true;
  };
  Fmt.$metadata$ = {
    simpleName: 'Fmt',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__178() {
  }
  _no_name_provided__178.prototype.invoke_265 = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__178.prototype.invoke_1015 = function (p1) {
    this.invoke_265(p1 instanceof ProcessedChunk ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__178.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__179($fmt, $buffer) {
    this._$fmt = $fmt;
    this._$buffer_2 = $buffer;
  }
  _no_name_provided__179.prototype.invoke_265 = function (it) {
    var extra = it._extra_0;
    var tmp0_subject = extra;
    if (tmp0_subject instanceof Fmt)
      this._$fmt._v = extra;
    else {
    }
    if (it._type_1 === 'data')
      this._$buffer_2._v = it._data_23;
  };
  _no_name_provided__179.prototype.invoke_1015 = function (p1) {
    this.invoke_265(p1 instanceof ProcessedChunk ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__179.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__180($fmt, $dataSize, $handle, resultContinuation) {
    this._$fmt_0 = $fmt;
    this._$dataSize = $dataSize;
    this._$handle_0 = $handle;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__180.prototype.invoke_267 = function ($this$riff, $cont) {
    var tmp = this.create_14($this$riff, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__180.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_267(p1 instanceof Chunk ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__180.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._tmp0_container0 = this._$this$riff;
            this._type1 = this._tmp0_container0.component1_1();
            this._d22 = this._tmp0_container0.component2_1();
            this._d3 = this._d22.duplicate();
            this._cdata4 = Unit_getInstance();
            this._tmp1_subject5 = this._type1;
            if (this._tmp1_subject5 === 'fmt ') {
              this._state_1 = 2;
              suspendResult = readS16LE_0(this._d3, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              if (this._tmp1_subject5 === 'data') {
                this._ARGUMENT6_1 = this._$dataSize._v;
                this._state_1 = 1;
                suspendResult = this._d3.getLength_14(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                Unit_getInstance();
                this._state_1 = 8;
                continue $sm;
              }
            }

            break;
          case 1:
            this._ARGUMENT7_1 = suspendResult;
            this._ARGUMENT8_2 = this._ARGUMENT6_1.plus_64(this._ARGUMENT7_1);
            this._$dataSize._v = this._ARGUMENT8_2;
            this._cdata4 = this._d3;
            this._state_1 = 8;
            continue $sm;
          case 2:
            this._ARGUMENT9_0 = suspendResult;
            this._$fmt_0._formatTag = this._ARGUMENT9_0;
            this._state_1 = 3;
            suspendResult = readS16LE_0(this._d3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._ARGUMENT10 = suspendResult;
            this._$fmt_0._channels_1 = this._ARGUMENT10;
            this._state_1 = 4;
            suspendResult = readS32LE_0(this._d3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._ARGUMENT11_0 = suspendResult;
            this._$fmt_0._samplesPerSec = this._ARGUMENT11_0;
            this._state_1 = 5;
            suspendResult = readU32LE_0(this._d3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._ARGUMENT12_0 = suspendResult;
            this._$fmt_0._avgBytesPerSec = this._ARGUMENT12_0;
            this._state_1 = 6;
            suspendResult = readS16LE_0(this._d3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._ARGUMENT13 = suspendResult;
            this._$fmt_0._blockAlign = this._ARGUMENT13;
            this._state_1 = 7;
            suspendResult = readS16LE_0(this._d3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            var ARGUMENT = suspendResult;
            this._$fmt_0._bitsPerSample = ARGUMENT;
            this._cdata4 = this._$fmt_0;
            this._state_1 = 8;
            continue $sm;
          case 8:
            this._$handle_0(new ProcessedChunk(this._$this$riff._type_0, this._$this$riff._data_22, this._cdata4));
            return Unit_getInstance();
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__180.prototype.create_14 = function ($this$riff, completion) {
    var i = new _no_name_provided__180(this._$fmt_0, this._$dataSize, this._$handle_0, completion);
    i._$this$riff = $this$riff;
    return i;
  };
  _no_name_provided__180.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $tryReadInfoCOROUTINE$13(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__109 = _this_;
    this._data_25 = data;
    this._props_5 = props;
  }
  $tryReadInfoCOROUTINE$13.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__109.parse_9(this._data_25, _no_name_provided_$factory_142(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._TRY_RESULT0_4 = suspendResult;
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              var tmp_1 = this;
              tmp_1._TRY_RESULT0_4 = null;
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return this._TRY_RESULT0_4;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $tryReadInfoCOROUTINE$13.$metadata$ = {
    simpleName: '$tryReadInfoCOROUTINE$13',
    kind: 'class',
    interfaces: []
  };
  function $decodeStreamCOROUTINE$14(_this_, data, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__110 = _this_;
    this._data_26 = data;
    this._props_6 = props;
  }
  $decodeStreamCOROUTINE$14.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = new Long(0, 0);
            tmp_0._fmt0 = {_v: Fmt_init_$Create$(0, 0, 0, tmp_1, 0, 0, 63, null)};
            var tmp_2 = this;
            tmp_2._buffer1 = {_v: toAsync(MemorySyncStream$default(null, 1, null))};
            this._state_1 = 1;
            suspendResult = this.__this__110.parse_9(this._data_26, _no_name_provided_$factory_143(this._fmt0, this._buffer1), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            this._ARGUMENT2_2 = this._fmt0._v;
            this._ARGUMENT3_2 = this._buffer1._v;
            this._state_1 = 2;
            suspendResult = this._buffer1._v.getLength_14(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return new WavAudioStream(this._ARGUMENT2_2, this._ARGUMENT3_2, ARGUMENT, this._data_26, this._props_6);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeStreamCOROUTINE$14.$metadata$ = {
    simpleName: '$decodeStreamCOROUTINE$14',
    kind: 'class',
    interfaces: []
  };
  function $parseCOROUTINE$18(_this_, data, handle, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__111 = _this_;
    this._data_27 = data;
    this._handle_2 = handle;
  }
  $parseCOROUTINE$18.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            var tmp_1 = new Long(0, 0);
            tmp_0._fmt0_0 = Fmt_init_$Create$(0, 0, 0, tmp_1, 0, 0, 63, null);
            this._dataSize1 = {_v: new Long(0, 0)};
            this._state_1 = 1;
            suspendResult = this.__this__111.riff_0(this._data_27, _no_name_provided_$factory_144(this._fmt0_0, this._dataSize1, this._handle_2, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            if (this._fmt0_0._formatTag < 0) {
              invalidOp("Couldn't find RIFF 'fmt ' chunk");
            }
            var tmp0_times_0 = this._dataSize1._v;
            var tmp1_times_0 = 1000;
            var tmp2_times_0 = tmp0_times_0.times_28(toLong(tmp1_times_0));
            var tmp3_times_0 = 1000;
            var tmp4__get_microseconds__0 = tmp2_times_0.times_28(toLong(tmp3_times_0)).div_28(this._fmt0_0._avgBytesPerSec);
            var tmp_2 = Companion_getInstance_27().fromMicroseconds(tmp4__get_microseconds__0.toDouble_6());
            var tmp_3 = this._fmt0_0._channels_1;
            return Info_init_$Create$(tmp_2, tmp_3, null, 4, null);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $parseCOROUTINE$18.$metadata$ = {
    simpleName: '$parseCOROUTINE$18',
    kind: 'class',
    interfaces: []
  };
  function $riffCOROUTINE$19(_this_, data, handler, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__112 = _this_;
    this._data_28 = data;
    this._handler_2 = handler;
  }
  $riffCOROUTINE$19.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 18;
            this._s20 = this._data_28.duplicate();
            this._state_1 = 1;
            suspendResult = this._s20.getAvailable(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT1_9 = suspendResult;
            if (this._ARGUMENT1_9.compareTo_137(new Long(12, 0)) < 0) {
              var tmp_0 = this;
              tmp_0._tmp0_error_02 = 'Not enough data for a RIFF file';
              throw IllegalStateException_init_$Create$_0(toString_1(this._tmp0_error_02));
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 2:
            this._state_1 = 3;
            suspendResult = readString$default(this._s20, 4, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._magic3_0 = suspendResult;
            this._state_1 = 4;
            suspendResult = readS32LE_0(this._s20, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 4:
            this._length4 = suspendResult;
            this._state_1 = 5;
            suspendResult = readString$default(this._s20, 4, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            this._magic25 = suspendResult;
            if (!(this._magic3_0 === 'RIFF')) {
              invalidAudioFormat('' + "Not a RIFF file but '" + this._magic3_0 + "'");
            }
            if (!(this._magic25 === 'WAVE')) {
              invalidAudioFormat('Not a RIFF + WAVE file');
            }
            this._state_1 = 6;
            suspendResult = readStream(this._s20, this._length4 - 4 | 0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._s6 = suspendResult;
            this._state_1 = 7;
            continue $sm;
          case 7:
            this._state_1 = 8;
            suspendResult = this._s6.eof_0(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._ARGUMENT7_2 = suspendResult;
            if (!!this._ARGUMENT7_2) {
              this._state_1 = 17;
              continue $sm;
            }
            this._state_1 = 9;
            suspendResult = this._s6.getAvailable(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            this._ARGUMENT8_3 = suspendResult;
            if (this._ARGUMENT8_3.compareTo_137(new Long(8, 0)) < 0) {
              this._state_1 = 17;
              continue $sm;
            } else {
              this._state_1 = 10;
              continue $sm;
            }

            break;
          case 10:
            this._state_1 = 11;
            suspendResult = readString$default(this._s6, 4, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            this._type9 = suspendResult;
            this._state_1 = 12;
            suspendResult = readS32LE_0(this._s6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 12:
            this._size10 = suspendResult;
            this._state_1 = 13;
            suspendResult = this._s6.getAvailable(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 13:
            this._ARGUMENT11_1 = suspendResult;
            if (this._ARGUMENT11_1.compareTo_137(toLong(this._size10)) < 0) {
              this._state_1 = 17;
              continue $sm;
            } else {
              this._state_1 = 14;
              continue $sm;
            }

            break;
          case 14:
            this._state_1 = 15;
            suspendResult = readStream(this._s6, this._size10, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 15:
            this._d12 = suspendResult;
            this._state_1 = 16;
            suspendResult = this._handler_2(new Chunk(this._type9, this._d12), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 16:
            suspendResult;
            this._state_1 = 7;
            continue $sm;
          case 17:
            return Unit_getInstance();
          case 18:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 18) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $riffCOROUTINE$19.$metadata$ = {
    simpleName: '$riffCOROUTINE$19',
    kind: 'class',
    interfaces: []
  };
  function WAV() {
    Companion_getInstance_68();
    AudioFormat.call(this, ['wav']);
  }
  WAV.prototype.tryReadInfo_8 = function (data, props, $cont) {
    var tmp = new $tryReadInfoCOROUTINE$13(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  WAV.prototype.decodeStream_8 = function (data, props, $cont) {
    var tmp = new $decodeStreamCOROUTINE$14(this, data, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  WAV.prototype.parse_9 = function (data, handle, $cont) {
    var tmp = new $parseCOROUTINE$18(this, data, handle, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  WAV.prototype.riff_0 = function (data, handler, $cont) {
    var tmp = new $riffCOROUTINE$19(this, data, handler, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  WAV.$metadata$ = {
    simpleName: 'WAV',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_142() {
    var i = new _no_name_provided__178();
    return function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_143($fmt, $buffer) {
    var i = new _no_name_provided__179($fmt, $buffer);
    return function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_144($fmt, $dataSize, $handle, resultContinuation) {
    var i = new _no_name_provided__180($fmt, $dataSize, $handle, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_267(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  var temp;
  function write(_this_, value) {
    temp[0] = value;
    _this_.write_5(temp, 0, 1);
    Unit_getInstance();
  }
  function coerceToShort(_this_) {
    return toShort(coerceIn(_this_, ShortCompanionObject_getInstance()._MIN_VALUE_3, ShortCompanionObject_getInstance()._MAX_VALUE_3));
  }
  function _get_niceStr__2(_this_) {
    var tmp;
    var tmp0_unsafeCast_0_1 = Math.floor(_this_);
    if (tmp0_unsafeCast_0_1 === _this_) {
      tmp = '' + numberToInt(_this_);
    } else {
      {
        tmp = '' + _this_;
      }
    }
    return tmp;
  }
  function SampleConvert() {
    SampleConvert_instance = this;
  }
  SampleConvert.prototype.shortToFloat = function (v) {
    return v / ShortCompanionObject_getInstance()._MAX_VALUE_3;
  };
  SampleConvert.$metadata$ = {
    simpleName: 'SampleConvert',
    kind: 'object',
    interfaces: []
  };
  var SampleConvert_instance;
  function SampleConvert_getInstance() {
    if (SampleConvert_instance == null)
      new SampleConvert();
    return SampleConvert_instance;
  }
  function min2_2(a, b) {
    return a < b ? a : b;
  }
  function _no_name_provided__181() {
  }
  _no_name_provided__181.prototype.invoke_1005 = function () {
    return new AudioData(44100, AudioSamples_init_$Create$(2, 0, null, 4, null));
  };
  _no_name_provided__181.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_70() {
    Companion_instance_69 = this;
    var tmp = this;
    tmp._DUMMY$delegate = lazy(_no_name_provided_$factory_146());
  }
  Companion_70.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_69;
  function Companion_getInstance_69() {
    if (Companion_instance_69 == null)
      new Companion_70();
    return Companion_instance_69;
  }
  function _no_name_provided__182(this$0) {
    this._this$0_37 = this$0;
  }
  _no_name_provided__182.prototype.invoke_1005 = function () {
    return interleaved$default(this._this$0_37._samples_1, null, 1, null);
  };
  _no_name_provided__182.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AudioData(rate, samples) {
    Companion_getInstance_69();
    this._rate = rate;
    this._samples_1 = samples;
    var tmp = this;
    tmp._samplesInterleaved$delegate = lazy(_no_name_provided_$factory_145(this));
  }
  AudioData.prototype._get_channels__2 = function () {
    return this._samples_1._channels_2;
  };
  AudioData.prototype._get_totalSamples_ = function () {
    return this._samples_1._totalSamples;
  };
  AudioData.prototype.toString = function () {
    return '' + 'AudioData(rate=' + this._rate + ', channels=' + this._get_channels__2() + ', samples=' + this._get_totalSamples_() + ')';
  };
  AudioData.$metadata$ = {
    simpleName: 'AudioData',
    kind: 'class',
    interfaces: []
  };
  function toStream(_this_) {
    return new AudioDataStream(_this_);
  }
  function AudioDataStream(data) {
    AudioStream.call(this, data._rate, data._get_channels__2());
    this._data_29 = data;
    this._cursor = 0;
    this._finished_0 = false;
  }
  AudioDataStream.prototype._get_finished__1 = function () {
    return this._finished_0;
  };
  AudioDataStream.prototype.read_41 = function (out, offset, length, $cont) {
    var available = this._data_29._samples_1._totalSamples - this._cursor | 0;
    var toread = min2_2(available, length);
    if (toread > 0) {
      var inductionVariable = 0;
      var last_1 = this._get_channels__2();
      if (inductionVariable < last_1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          arraycopy_3(this._data_29._samples_1.get_137(n), this._cursor, out.get_137(n), offset, toread);
        }
         while (inductionVariable < last_1);
      var tmp1_this = this;
      tmp1_this._cursor = tmp1_this._cursor + toread | 0;
    }if (toread <= 0)
      this._finished_0 = true;
    return toread;
  };
  AudioDataStream.prototype.clone_8 = function ($cont) {
    return new AudioDataStream(this._data_29);
  };
  AudioDataStream.$metadata$ = {
    simpleName: 'AudioDataStream',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_145(this$0) {
    var i = new _no_name_provided__182(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_146() {
    var i = new _no_name_provided__181();
    return function () {
      return i.invoke_1005();
    };
  }
  function AudioSamples_init_$Init$(channels, totalSamples, data, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0)) {
      var tmp = 0;
      var tmp_0 = channels;
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = new Int16Array(totalSamples);
        tmp = tmp + 1 | 0;
      }
      data = tmp_1;
    }AudioSamples.call($this, channels, totalSamples, data);
    return $this;
  }
  function AudioSamples_init_$Create$(channels, totalSamples, data, $mask0, $marker) {
    return AudioSamples_init_$Init$(channels, totalSamples, data, $mask0, $marker, Object.create(AudioSamples.prototype));
  }
  function AudioSamples(channels, totalSamples, data) {
    this._channels_2 = channels;
    this._totalSamples = totalSamples;
    this._data_30 = data;
    this._fastShortTransfer = new FastShortTransfer();
  }
  AudioSamples.prototype.get_137 = function (channel) {
    return this._data_30[channel];
  };
  AudioSamples.prototype.get_88 = function (channel, sample) {
    return this._data_30[channel][sample];
  };
  AudioSamples.prototype.hashCode = function () {
    return (this._channels_2 + imul(this._totalSamples, 32) | 0) + imul(contentDeepHashCode(this._data_30), 64) | 0;
  };
  AudioSamples.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof AudioSamples) {
      tmp_1 = this._channels_2 === other._channels_2;
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._totalSamples === other._totalSamples;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = contentDeepEquals(this._data_30, other._data_30);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  AudioSamples.prototype.toString = function () {
    return '' + 'AudioSamples(channels=' + this._channels_2 + ', totalSamples=' + this._totalSamples + ')';
  };
  AudioSamples.$metadata$ = {
    simpleName: 'AudioSamples',
    kind: 'class',
    interfaces: [IAudioSamples]
  };
  function AudioSamplesInterleaved_init_$Init$(channels, totalSamples, data, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      data = new Int16Array(imul(totalSamples, channels));
    AudioSamplesInterleaved.call($this, channels, totalSamples, data);
    return $this;
  }
  function AudioSamplesInterleaved_init_$Create$(channels, totalSamples, data, $mask0, $marker) {
    return AudioSamplesInterleaved_init_$Init$(channels, totalSamples, data, $mask0, $marker, Object.create(AudioSamplesInterleaved.prototype));
  }
  function AudioSamplesInterleaved(channels, totalSamples, data) {
    this._channels_3 = channels;
    this._totalSamples_0 = totalSamples;
    this._data_31 = data;
    this._fastShortTransfer_0 = new FastShortTransfer();
  }
  AudioSamplesInterleaved.prototype.toString = function () {
    return '' + 'AudioSamplesInterleaved(channels=' + this._channels_3 + ', totalSamples=' + this._totalSamples_0 + ')';
  };
  AudioSamplesInterleaved.$metadata$ = {
    simpleName: 'AudioSamplesInterleaved',
    kind: 'class',
    interfaces: [IAudioSamples]
  };
  function interleaved(_this_, out) {
    var tmp0_assert_0 = out._data_31.length >= imul(_this_._totalSamples, _this_._channels_2);
    if (!tmp0_assert_0)
      throw AssertionError_init_$Create$();
    var tmp0_subject = _this_._channels_2;
    switch (tmp0_subject) {
      case 1:
        arraycopy_3(_this_._data_30[0], 0, out._data_31, 0, _this_._totalSamples);
        break;
      case 2:
        arrayinterleave(out._data_31, 0, _this_._data_30[0], 0, _this_._data_30[1], 0, _this_._totalSamples, out._fastShortTransfer_0);
        break;
      default:var tmp1_use_0 = out._fastShortTransfer_0;
        var tmp2_use_0 = out._data_31;
        try {
          tmp1_use_0._ptr = tmp2_use_0;
          var channels_2 = _this_._channels_2;
          var inductionVariable = 0;
          if (inductionVariable < channels_2)
            do {
              var c_4 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var m_5 = c_4;
              var inductionVariable_0 = 0;
              var last_1 = _this_._totalSamples;
              if (inductionVariable_0 < last_1)
                do {
                  var n_7 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var tmp0_set_0_8 = m_5;
                  var tmp1_set_0_9 = _this_.get_88(c_4, n_7);
                  tmp1_use_0._ptr[tmp0_set_0_8] = tmp1_set_0_9;
                  m_5 = m_5 + channels_2 | 0;
                }
                 while (inductionVariable_0 < last_1);
            }
             while (inductionVariable < channels_2);
        }finally {
          tmp1_use_0._ptr = EmptyShortArray;
        }

        break;
    }
    return out;
  }
  function interleaved$default(_this_, out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      out = AudioSamplesInterleaved_init_$Create$(_this_._channels_2, _this_._totalSamples, null, 4, null);
    }return interleaved(_this_, out);
  }
  function IAudioSamples() {
  }
  IAudioSamples.$metadata$ = {
    simpleName: 'IAudioSamples',
    kind: 'interface',
    interfaces: []
  };
  function AudioSamplesDeque(channels) {
    this._channels_4 = channels;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this._channels_4;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = ShortArrayDeque_init_$Create$(0, 1, null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._buffer_19 = tmp_2;
    this._temp_0 = new Int16Array(1);
  }
  AudioSamplesDeque.prototype._get_availableRead__4 = function () {
    var tmp0_safe_receiver = getOrNull(this._buffer_19, 0);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_availableRead__4();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  AudioSamplesDeque.prototype._get_availableReadMax_ = function () {
    var tmp0_map_0 = this._buffer_19;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0.length);
    var indexedObject = tmp0_map_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_39(item_2_3._get_availableRead__4());
      Unit_getInstance();
    }
    var tmp0_elvis_lhs = maxOrNull(tmp0_mapTo_0_1);
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  };
  AudioSamplesDeque.prototype.write_31 = function (samples, offset, len) {
    var inductionVariable = 0;
    var last_1 = samples._channels_2;
    if (inductionVariable < last_1)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.write_32(channel, samples.get_137(channel), offset, len);
      }
       while (inductionVariable < last_1);
  };
  AudioSamplesDeque.prototype.write_32 = function (channel, data, offset, len) {
    this._buffer_19[channel].write_4(data, offset, len);
    Unit_getInstance();
  };
  AudioSamplesDeque.prototype.read_41 = function (out, offset, len) {
    var result = min2_2(len, this._get_availableRead__4());
    var inductionVariable = 0;
    var last_1 = out._channels_2;
    if (inductionVariable < last_1)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._buffer_19[channel].read_4(out.get_137(channel), offset, len);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    return result;
  };
  AudioSamplesDeque.prototype.read$default_2 = function (out, offset, len, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      offset = 0;
    if (!(($mask0 & 4) === 0))
      len = out._totalSamples - offset | 0;
    return this.read_41(out, offset, len);
  };
  AudioSamplesDeque.prototype.toString = function () {
    return '' + 'AudioSamplesDeque(channels=' + this._channels_4 + ', availableRead=' + this._get_availableRead__4() + ')';
  };
  AudioSamplesDeque.$metadata$ = {
    simpleName: 'AudioSamplesDeque',
    kind: 'class',
    interfaces: []
  };
  function Companion_71() {
    Companion_instance_70 = this;
  }
  Companion_71.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_70;
  function Companion_getInstance_70() {
    if (Companion_instance_70 == null)
      new Companion_71();
    return Companion_instance_70;
  }
  function AudioStream(rate, channels) {
    Companion_getInstance_70();
    this._rate_0 = rate;
    this._channels_5 = channels;
    this._finished_1 = false;
    this._totalLengthInSamples = null;
    this._currentPositionInSamples = new Long(0, 0);
  }
  AudioStream.prototype._get_channels__2 = function () {
    return this._channels_5;
  };
  AudioStream.prototype._get_finished__1 = function () {
    return this._finished_1;
  };
  AudioStream.prototype._get_totalLengthInSamples__1 = function () {
    return this._totalLengthInSamples;
  };
  AudioStream.prototype._get_totalLength__1 = function () {
    var tmp0_elvis_lhs = this._get_totalLengthInSamples__1();
    var tmp0__get_seconds__0 = (tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs).toDouble_6() / this._rate_0;
    return Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
  };
  AudioStream.prototype._set_currentPositionInSamples__1 = function (_set___) {
    this._currentPositionInSamples = _set___;
  };
  AudioStream.prototype._set_currentTime__1 = function (value) {
    this._set_currentPositionInSamples__1(numberToLong(_TimeSpan___get_seconds__impl_(value) * this._rate_0));
  };
  AudioStream.prototype.read_41 = function (out, offset, length, $cont) {
    return 0;
  };
  AudioStream.prototype.close_77 = function () {
    return Unit_getInstance();
  };
  AudioStream.$metadata$ = {
    simpleName: 'AudioStream',
    kind: 'class',
    interfaces: [AudioStreamable, Closeable]
  };
  function toData(_this_, maxSamples, $cont) {
    var tmp = new $toDataCOROUTINE$21(_this_, maxSamples, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function toData$default(_this_, maxSamples, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      maxSamples = 13230000;
    return toData(_this_, maxSamples, $cont);
  }
  function $toDataCOROUTINE$21(_this_, maxSamples, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__113 = _this_;
    this._maxSamples = maxSamples;
  }
  $toDataCOROUTINE$21.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._out0_0 = new AudioSamplesDeque(this.__this__113._channels_5);
            var tmp_0 = this;
            tmp_0._buffer1_0 = AudioSamples_init_$Create$(this.__this__113._channels_5, 65536, null, 4, null);
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 8;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!!this.__this__113._get_finished__1()) {
              this._state_1 = 6;
              continue $sm;
            }
            this._state_1 = 3;
            suspendResult = this.__this__113.read_41(this._buffer1_0, 0, this._buffer1_0._totalSamples, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var read_1 = suspendResult;
            if (read_1 <= 0) {
              this._state_1 = 6;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            this._out0_0.write_31(this._buffer1_0, 0, read_1);
            if (this._out0_0._get_availableRead__4() >= this._maxSamples) {
              this._state_1 = 6;
              continue $sm;
            } else {
              this._state_1 = 5;
              continue $sm;
            }

            break;
          case 5:
            this._state_1 = 2;
            continue $sm;
          case 6:
            this._tmp$ret$02_1 = Unit_getInstance();
            this._exceptionState = 9;
            this._state_1 = 7;
            continue $sm;
          case 7:
            this.__this__113.close_77();
            var maxOutSamples = this._out0_0._get_availableReadMax_();
            var tmp0_apply_0 = AudioSamples_init_$Create$(this.__this__113._channels_5, maxOutSamples, null, 4, null);
            this._out0_0.read$default_2(tmp0_apply_0, 0, 0, 6, null);
            Unit_getInstance();
            return new AudioData(this.__this__113._rate_0, tmp0_apply_0);
          case 8:
            this._exceptionState = 9;
            var t = this._exception_0;
            this.__this__113.close_77();
            throw t;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $toDataCOROUTINE$21.$metadata$ = {
    simpleName: '$toDataCOROUTINE$21',
    kind: 'class',
    interfaces: []
  };
  function AudioStreamable() {
  }
  AudioStreamable.$metadata$ = {
    simpleName: 'AudioStreamable',
    kind: 'interface',
    interfaces: []
  };
  function PlatformAudioOutput(coroutineContext, frequency) {
    this._coroutineContext_1 = coroutineContext;
    this._frequency = frequency;
    this._availableSamples = 0;
    this._pitch = 1.0;
    this._volume = 1.0;
    this._panning = 0.0;
  }
  PlatformAudioOutput.prototype._get_coroutineContext__22 = function () {
    return this._coroutineContext_1;
  };
  PlatformAudioOutput.prototype._get_availableSamples__0 = function () {
    return this._availableSamples;
  };
  PlatformAudioOutput.prototype._set_pitch__8 = function (_set___) {
    this._pitch = _set___;
  };
  PlatformAudioOutput.prototype._get_pitch__8 = function () {
    return this._pitch;
  };
  PlatformAudioOutput.prototype._set_volume__8 = function (_set___) {
    this._volume = _set___;
  };
  PlatformAudioOutput.prototype._get_volume__8 = function () {
    return this._volume;
  };
  PlatformAudioOutput.prototype._set_panning__8 = function (_set___) {
    this._panning = _set___;
  };
  PlatformAudioOutput.prototype._get_panning__8 = function () {
    return this._panning;
  };
  PlatformAudioOutput.prototype.add_43 = function (samples, offset, size_1, $cont) {
    var tmp0__get_milliseconds__0 = 100;
    return delay_0(Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0), $cont);
  };
  PlatformAudioOutput.prototype.start_23 = function () {
    return Unit_getInstance();
  };
  PlatformAudioOutput.prototype.stop_2 = function () {
    return Unit_getInstance();
  };
  PlatformAudioOutput.$metadata$ = {
    simpleName: 'PlatformAudioOutput',
    kind: 'class',
    interfaces: [Disposable, SoundProps]
  };
  function _no_name_provided__183($stream, resultContinuation) {
    this._$stream = $stream;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__183.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__183.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__183.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$stream.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__183.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__183(this._$stream, completion);
    return i;
  };
  _no_name_provided__183.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $createSoundCOROUTINE$23(_this_, data, streaming, props, name, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__114 = _this_;
    this._data_32 = data;
    this._streaming = streaming;
    this._props_7 = props;
    this._name_12 = name;
  }
  $createSoundCOROUTINE$23.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._state_1 = 1;
            var tmp_0 = this.__this__114._get_audioFormats__0();
            suspendResult = tmp_0.decodeStreamOrError(openAsync$default(this._data_32, null, 1, null), this._props_7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._stream0 = suspendResult;
            if (this._streaming) {
              this._state_1 = 4;
              suspendResult = this.__this__114.createStreamingSound$default(this._stream0, true, this._name_12, null, 8, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              suspendResult = toData$default(this._stream0, 0, 1, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 2:
            this._ARGUMENT2_3 = suspendResult;
            this._state_1 = 3;
            suspendResult = this.__this__114.createNonStreamingSound_0(this._ARGUMENT2_3, this._name_12, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._WHEN_RESULT1_5 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 4:
            this._WHEN_RESULT1_5 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._WHEN_RESULT1_5;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$23.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$23',
    kind: 'class',
    interfaces: []
  };
  function $createSoundCOROUTINE$24(_this_, vfs, path_0, streaming, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__115 = _this_;
    this._vfs_1 = vfs;
    this._path_17 = path_0;
    this._streaming_0 = streaming;
    this._props_8 = props;
  }
  $createSoundCOROUTINE$24.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            if (this._streaming_0) {
              this._vfsFile1 = this._vfs_1.file_8(this._path_17);
              if (this._props_8._readInMemory) {
                this._state_1 = 4;
                suspendResult = this._vfsFile1.readAll_0(this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                this._state_1 = 3;
                suspendResult = this._vfsFile1.open$default(null, 1, null, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            } else {
              this._state_1 = 1;
              suspendResult = this._vfs_1.file_8(this._path_17).read_36(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT3_3 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__115.createSound_3(this._ARGUMENT3_3, this._streaming_0, this._props_8, _get_baseName_(this._vfs_1.get_115(this._path_17)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._WHEN_RESULT0_0 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 3:
            this._WHEN_RESULT2_1 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 4:
            this._ARGUMENT4_1 = suspendResult;
            var tmp_0 = this;
            tmp_0._WHEN_RESULT2_1 = openAsync$default(this._ARGUMENT4_1, null, 1, null);
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._stream5 = this._WHEN_RESULT2_1;
            this._state_1 = 6;
            suspendResult = this.__this__115._get_audioFormats__0().decodeStreamOrError(this._stream5, this._props_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            this._ARGUMENT6_2 = suspendResult;
            this._state_1 = 7;
            var tmp_1 = _get_baseName_(this._vfsFile1);
            suspendResult = this.__this__115.createStreamingSound$default(this._ARGUMENT6_2, false, tmp_1, _no_name_provided_$factory_147(this._stream5, null), 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 7:
            this._WHEN_RESULT0_0 = suspendResult;
            this._state_1 = 8;
            continue $sm;
          case 8:
            return this._WHEN_RESULT0_0;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$24.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$24',
    kind: 'class',
    interfaces: []
  };
  function $createSoundCOROUTINE$25(_this_, file, streaming, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__116 = _this_;
    this._file_3 = file;
    this._streaming_1 = streaming;
    this._props_9 = props;
  }
  $createSoundCOROUTINE$25.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._file_3.getUnderlyingUnscapedFile_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_18 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__116.createSound_5(this._ARGUMENT0_18, this._streaming_1, this._props_9, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$25.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$25',
    kind: 'class',
    interfaces: []
  };
  function NativeSoundProvider() {
    this._target = 'unknown';
    this._initialized_1 = korAtomic_0(false);
    this._audioFormats = Companion_getInstance_62().invoke_261([Companion_getInstance_68()]);
  }
  NativeSoundProvider.prototype.initOnce_0 = function () {
    if (!this._initialized_1._get_value__10()) {
      this._initialized_1._set_value__2(true);
      this.init_15();
    }};
  NativeSoundProvider.prototype.createAudioStream_0 = function (coroutineContext, freq) {
    return new PlatformAudioOutput(coroutineContext, freq);
  };
  NativeSoundProvider.prototype.init_15 = function () {
    return Unit_getInstance();
  };
  NativeSoundProvider.prototype.createSound_3 = function (data, streaming, props, name, $cont) {
    var tmp = new $createSoundCOROUTINE$23(this, data, streaming, props, name, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  NativeSoundProvider.prototype._get_audioFormats__0 = function () {
    return this._audioFormats;
  };
  NativeSoundProvider.prototype.createSound_4 = function (vfs, path_0, streaming, props, $cont) {
    var tmp = new $createSoundCOROUTINE$24(this, vfs, path_0, streaming, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  NativeSoundProvider.prototype.createSound$default = function (vfs, path_0, streaming, props, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      streaming = false;
    if (!(($mask0 & 8) === 0))
      props = Companion_getInstance_63()._DEFAULT_2;
    return $handler == null ? this.createSound_4(vfs, path_0, streaming, props, $cont) : $handler(vfs, path_0, streaming, props);
  };
  NativeSoundProvider.prototype.createSound_5 = function (file, streaming, props, $cont) {
    return this.createSound_4(file._get_vfs_(), file._get_path__5(), streaming, props, $cont);
  };
  NativeSoundProvider.prototype.createSound_6 = function (file, streaming, props, $cont) {
    var tmp = new $createSoundCOROUTINE$25(this, file, streaming, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  NativeSoundProvider.prototype.createNonStreamingSound_0 = function (data, name, $cont) {
    var tmp = toStream(data);
    return this.createStreamingSound$default(tmp, true, name, null, 8, null, $cont);
  };
  NativeSoundProvider.prototype.createStreamingSound_0 = function (stream, closeStream, name, onComplete, $cont) {
    return new SoundAudioStream($cont._get_context__296(), stream, closeStream, name, onComplete);
  };
  NativeSoundProvider.prototype.createStreamingSound$default = function (stream, closeStream, name, onComplete, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      closeStream = false;
    if (!(($mask0 & 4) === 0))
      name = 'Unknown';
    if (!(($mask0 & 8) === 0))
      onComplete = null;
    return this.createStreamingSound_0(stream, closeStream, name, onComplete, $cont);
  };
  NativeSoundProvider.$metadata$ = {
    simpleName: 'NativeSoundProvider',
    kind: 'class',
    interfaces: [Disposable]
  };
  function Sound(creationCoroutineContext) {
    this._creationCoroutineContext = creationCoroutineContext;
    this._defaultCoroutineContext = this._creationCoroutineContext;
    this._name_13 = 'UnknownNativeSound';
    this._volume_0 = 1.0;
    this._panning_0 = 0.0;
    this._pitch_0 = 1.0;
    var tmp = this;
    var tmp0__get_seconds__0 = 0;
    tmp._length_4 = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
  }
  Sound.prototype._get_name__50 = function () {
    return this._name_13;
  };
  Sound.prototype._set_volume__8 = function (_set___) {
    this._volume_0 = _set___;
  };
  Sound.prototype._get_volume__8 = function () {
    return this._volume_0;
  };
  Sound.prototype._set_panning__8 = function (_set___) {
    this._panning_0 = _set___;
  };
  Sound.prototype._get_panning__8 = function () {
    return this._panning_0;
  };
  Sound.prototype._set_pitch__8 = function (_set___) {
    this._pitch_0 = _set___;
  };
  Sound.prototype._get_pitch__8 = function () {
    return this._pitch_0;
  };
  Sound.prototype._get_length__8 = function () {
    return this._length_4;
  };
  Sound.prototype.play_4 = function (coroutineContext, params) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  Sound.prototype.play_5 = function (params, $cont) {
    return this.play_4($cont._get_context__296(), params);
  };
  Sound.prototype.play$default = function (params, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      params = Companion_getInstance_71()._DEFAULT_3;
    return this.play_5(params, $cont);
  };
  Sound.prototype.toString = function () {
    return '' + "NativeSound('" + this._get_name__50() + "')";
  };
  Sound.$metadata$ = {
    simpleName: 'Sound',
    kind: 'class',
    interfaces: [SoundProps, AudioStreamable]
  };
  function PlaybackParameters_init_$Init$(times_2, startTime, bufferTime, volume, pitch, panning, onCancel, onFinish, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      var tmp0__get_playbackTimes__0 = 1;
      times_2 = _PlaybackTimes___init__impl_(tmp0__get_playbackTimes__0);
    }if (!(($mask0 & 2) === 0)) {
      var tmp0__get_seconds__0 = 0;
      startTime = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
    }if (!(($mask0 & 4) === 0)) {
      var tmp0__get_seconds__0_0 = 0.1;
      bufferTime = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0_0);
    }if (!(($mask0 & 8) === 0))
      volume = 1.0;
    if (!(($mask0 & 16) === 0))
      pitch = 1.0;
    if (!(($mask0 & 32) === 0))
      panning = 0.0;
    if (!(($mask0 & 64) === 0))
      onCancel = null;
    if (!(($mask0 & 128) === 0))
      onFinish = null;
    PlaybackParameters.call($this, times_2, startTime, bufferTime, volume, pitch, panning, onCancel, onFinish);
    return $this;
  }
  function PlaybackParameters_init_$Create$(times_2, startTime, bufferTime, volume, pitch, panning, onCancel, onFinish, $mask0, $marker) {
    return PlaybackParameters_init_$Init$(times_2, startTime, bufferTime, volume, pitch, panning, onCancel, onFinish, $mask0, $marker, Object.create(PlaybackParameters.prototype));
  }
  function Companion_72() {
    Companion_instance_71 = this;
    var tmp = this;
    var tmp0__get_playbackTimes__0 = 1;
    var tmp_0 = _PlaybackTimes___init__impl_(tmp0__get_playbackTimes__0);
    var tmp1__get_seconds__0 = 0;
    var tmp_1 = Companion_getInstance_27().fromSeconds(tmp1__get_seconds__0);
    tmp._DEFAULT_3 = PlaybackParameters_init_$Create$(tmp_0, tmp_1, null, 0.0, 0.0, 0.0, null, null, 252, null);
  }
  Companion_72.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_71;
  function Companion_getInstance_71() {
    if (Companion_instance_71 == null)
      new Companion_72();
    return Companion_instance_71;
  }
  function PlaybackParameters(times_2, startTime, bufferTime, volume, pitch, panning, onCancel, onFinish) {
    Companion_getInstance_71();
    this._times = times_2;
    this._startTime = startTime;
    this._bufferTime = bufferTime;
    this._volume_1 = volume;
    this._pitch_1 = pitch;
    this._panning_1 = panning;
    this._onCancel = onCancel;
    this._onFinish = onFinish;
  }
  PlaybackParameters.prototype._get_volume__8 = function () {
    return this._volume_1;
  };
  PlaybackParameters.prototype._get_pitch__8 = function () {
    return this._pitch_1;
  };
  PlaybackParameters.prototype._get_panning__8 = function () {
    return this._panning_1;
  };
  PlaybackParameters.prototype.toString = function () {
    return '' + 'PlaybackParameters(times=' + new PlaybackTimes(this._times) + ', startTime=' + new TimeSpan(this._startTime) + ', bufferTime=' + new TimeSpan(this._bufferTime) + ', volume=' + this._volume_1 + ', pitch=' + this._pitch_1 + ', panning=' + this._panning_1 + ', onCancel=' + this._onCancel + ', onFinish=' + this._onFinish + ')';
  };
  PlaybackParameters.prototype.hashCode = function () {
    var result = PlaybackTimes__hashCode_impl(this._times);
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._startTime) | 0;
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._bufferTime) | 0;
    result = imul(result, 31) + getNumberHashCode(this._volume_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._pitch_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._panning_1) | 0;
    result = imul(result, 31) + (this._onCancel == null ? 0 : hashCode(this._onCancel)) | 0;
    result = imul(result, 31) + (this._onFinish == null ? 0 : hashCode(this._onFinish)) | 0;
    return result;
  };
  PlaybackParameters.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaybackParameters))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PlaybackParameters ? other : THROW_CCE();
    if (!equals_1(new PlaybackTimes(this._times), new PlaybackTimes(tmp0_other_with_cast._times)))
      return false;
    if (!equals_1(new TimeSpan(this._startTime), new TimeSpan(tmp0_other_with_cast._startTime)))
      return false;
    if (!equals_1(new TimeSpan(this._bufferTime), new TimeSpan(tmp0_other_with_cast._bufferTime)))
      return false;
    if (!equals_1(this._volume_1, tmp0_other_with_cast._volume_1))
      return false;
    if (!equals_1(this._pitch_1, tmp0_other_with_cast._pitch_1))
      return false;
    if (!equals_1(this._panning_1, tmp0_other_with_cast._panning_1))
      return false;
    if (!equals_1(this._onCancel, tmp0_other_with_cast._onCancel))
      return false;
    if (!equals_1(this._onFinish, tmp0_other_with_cast._onFinish))
      return false;
    return true;
  };
  PlaybackParameters.$metadata$ = {
    simpleName: 'PlaybackParameters',
    kind: 'class',
    interfaces: [ReadonlySoundProps]
  };
  function SoundProps() {
  }
  SoundProps.$metadata$ = {
    simpleName: 'SoundProps',
    kind: 'interface',
    interfaces: [ReadonlySoundProps]
  };
  function SoundChannel(sound) {
    this._sound = sound;
    var tmp = this;
    tmp._$$delegate_0_5 = Mixin_init_$Create$(null, 1, null);
    this._startTime_0 = Companion_getInstance_18().now_2();
    this._volume_2 = 1.0;
    this._pitch_2 = 1.0;
    this._panning_2 = 0.0;
  }
  SoundChannel.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_5._extra = _set___;
  };
  SoundChannel.prototype._get_extra__71 = function () {
    return this._$$delegate_0_5._extra;
  };
  SoundChannel.prototype._set_volume__8 = function (_set___) {
    this._volume_2 = _set___;
  };
  SoundChannel.prototype._get_volume__8 = function () {
    return this._volume_2;
  };
  SoundChannel.prototype._set_pitch__8 = function (_set___) {
    this._pitch_2 = _set___;
  };
  SoundChannel.prototype._get_pitch__8 = function () {
    return this._pitch_2;
  };
  SoundChannel.prototype._set_panning__8 = function (_set___) {
    this._panning_2 = _set___;
  };
  SoundChannel.prototype._get_panning__8 = function () {
    return this._panning_2;
  };
  SoundChannel.$metadata$ = {
    simpleName: 'SoundChannel',
    kind: 'class',
    interfaces: [SoundChannelBase, Extra]
  };
  function _PlaybackTimes___init__impl_(count_0) {
    return count_0;
  }
  function _PlaybackTimes___get_count__impl_(this_0) {
    return this_0;
  }
  function Companion_73() {
    Companion_instance_72 = this;
    this._ZERO_1 = _PlaybackTimes___init__impl_(0);
    this._ONE = _PlaybackTimes___init__impl_(1);
    this._INFINITE = _PlaybackTimes___init__impl_(-1);
  }
  Companion_73.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_72;
  function Companion_getInstance_72() {
    if (Companion_instance_72 == null)
      new Companion_73();
    return Companion_instance_72;
  }
  function _PlaybackTimes___get_hasMore__impl_(this_0) {
    return !equals_1(new PlaybackTimes(this_0), new PlaybackTimes(Companion_getInstance_72()._ZERO_1));
  }
  function _PlaybackTimes___get_oneLess__impl_(this_0) {
    return equals_1(new PlaybackTimes(this_0), new PlaybackTimes(Companion_getInstance_72()._INFINITE)) ? Companion_getInstance_72()._INFINITE : _PlaybackTimes___init__impl_(_PlaybackTimes___get_count__impl_(this_0) - 1 | 0);
  }
  function PlaybackTimes__toString_impl(this_0) {
    return _PlaybackTimes___get_count__impl_(this_0) >= 0 ? '' + _PlaybackTimes___get_count__impl_(this_0) + ' times' : 'Infinite times';
  }
  function PlaybackTimes__hashCode_impl(this_0) {
    return this_0;
  }
  function PlaybackTimes__equals_impl(this_0, other) {
    if (!(other instanceof PlaybackTimes))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PlaybackTimes ? other._count_1 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function PlaybackTimes(count_0) {
    Companion_getInstance_72();
    this._count_1 = count_0;
  }
  PlaybackTimes.prototype.toString = function () {
    return PlaybackTimes__toString_impl(this._count_1);
  };
  PlaybackTimes.prototype.hashCode = function () {
    return PlaybackTimes__hashCode_impl(this._count_1);
  };
  PlaybackTimes.prototype.equals = function (other) {
    return PlaybackTimes__equals_impl(this._count_1, other);
  };
  PlaybackTimes.$metadata$ = {
    simpleName: 'PlaybackTimes',
    kind: 'class',
    interfaces: []
  };
  function ReadonlySoundProps() {
  }
  ReadonlySoundProps.$metadata$ = {
    simpleName: 'ReadonlySoundProps',
    kind: 'interface',
    interfaces: []
  };
  function SoundChannelBase() {
  }
  SoundChannelBase.$metadata$ = {
    simpleName: 'SoundChannelBase',
    kind: 'interface',
    interfaces: [SoundProps]
  };
  function copySoundPropsFrom(_this_, other) {
    _this_._set_volume__8(other._get_volume__8());
    _this_._set_pitch__8(other._get_pitch__8());
    _this_._set_panning__8(other._get_panning__8());
  }
  function readSound(_this_, props, streaming, $cont) {
    return _get_nativeSoundProvider_().createSound_6(_this_, streaming, props, $cont);
  }
  function readSound$default(_this_, props, streaming, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      props = Companion_getInstance_63()._DEFAULT_2;
    if (!(($mask0 & 2) === 0))
      streaming = false;
    return readSound(_this_, props, streaming, $cont);
  }
  function _no_name_provided_$factory_147($stream, resultContinuation) {
    var i = new _no_name_provided__183($stream, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided__184(this$0, $params, $playing, $nas, $paused, resultContinuation) {
    this._this$0_38 = this$0;
    this._$params = $params;
    this._$playing = $playing;
    this._$nas = $nas;
    this._$paused = $paused;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__184.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__184.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__184.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 22;
            this._state_1 = 1;
            suspendResult = this._this$0_38._stream_0.clone_8(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._stream0_0 = suspendResult;
            this._stream0_0._set_currentTime__1(this._$params._startTime);
            this._$playing._v = true;
            this._times1 = this._$params._times;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 16;
            this._exceptionState = 15;
            var tmp_0 = this;
            tmp_0._temp3 = AudioSamples_init_$Create$(this._stream0_0._channels_5, 1024, null, 4, null);
            this._nchannels4 = 2;
            this._minBuf5 = numberToInt(imul(this._stream0_0._rate_0, this._nchannels4) * _TimeSpan___get_seconds__impl_(this._$params._bufferTime));
            this._$nas.start_23();
            this._state_1 = 3;
            continue $sm;
          case 3:
            if (!_PlaybackTimes___get_hasMore__impl_(this._times1)) {
              this._state_1 = 14;
              continue $sm;
            }
            this._state_1 = 4;
            continue $sm;
          case 4:
            if (!!this._stream0_0._get_finished__1()) {
              this._state_1 = 13;
              continue $sm;
            }
            this._state_1 = 5;
            continue $sm;
          case 5:
            if (!this._$paused._v) {
              this._state_1 = 7;
              continue $sm;
            }
            this._state_1 = 6;
            var tmp_1 = this;
            tmp_1._tmp0__get_milliseconds__06 = 2;
            suspendResult = delay_0(Companion_getInstance_27().fromMilliseconds(this._tmp0__get_milliseconds__06), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 6:
            suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 7:
            this._state_1 = 8;
            suspendResult = this._stream0_0.read_41(this._temp3, 0, this._temp3._totalSamples, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 8:
            this._read7 = suspendResult;
            this._state_1 = 9;
            suspendResult = this._$nas.add_43(this._temp3, 0, this._read7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 9:
            suspendResult;
            this._state_1 = 10;
            continue $sm;
          case 10:
            var containsLower = this._minBuf5;
            var containsUpper = imul(this._minBuf5, 2);
            var containsArg = this._$nas._get_availableSamples__0();
            if (!(containsLower <= containsArg ? containsArg <= containsUpper : false)) {
              this._state_1 = 12;
              continue $sm;
            } else {
            }

            this._state_1 = 11;
            var tmp_2 = this;
            tmp_2._tmp1__get_milliseconds__08 = 2;
            suspendResult = delay_0(Companion_getInstance_27().fromMilliseconds(this._tmp1__get_milliseconds__08), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 11:
            suspendResult;
            this._state_1 = 10;
            continue $sm;
          case 12:
            this._state_1 = 4;
            continue $sm;
          case 13:
            this._times1 = _PlaybackTimes___get_oneLess__impl_(this._times1);
            this._stream0_0._set_currentPositionInSamples__1(new Long(0, 0));
            this._state_1 = 3;
            continue $sm;
          case 14:
            this._tmp$ret$02_2 = Unit_getInstance();
            this._exceptionState = 22;
            this._state_1 = 19;
            continue $sm;
          case 15:
            this._exceptionState = 16;
            var tmp_3 = this._exception_0;
            if (tmp_3 instanceof CancellationException) {
              this._e9 = this._exception_0;
              var tmp_4 = this;
              var tmp0_safe_receiver = this._$params._onCancel;
              if (tmp0_safe_receiver == null)
                null;
              else
                tmp0_safe_receiver();
              tmp_4._tmp$ret$02_2 = Unit_getInstance();
              this._exceptionState = 22;
              this._state_1 = 19;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 16:
            this._exceptionState = 22;
            this._t10 = this._exception_0;
            this._$nas.stop_2();
            if (this._this$0_38._closeStream_0) {
              this._stream0_0.close_77();
            }
            this._$playing._v = false;
            var tmp1_safe_receiver = this._$params._onFinish;
            if (tmp1_safe_receiver == null)
              null;
            else
              tmp1_safe_receiver();
            Unit_getInstance();
            this._tmp2_safe_receiver11 = this._this$0_38._onComplete;
            if (this._tmp2_safe_receiver11 == null) {
              this._WHEN_RESULT12 = null;
              this._state_1 = 18;
              continue $sm;
            } else {
              this._state_1 = 17;
              suspendResult = this._tmp2_safe_receiver11(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 17:
            this._WHEN_RESULT12 = suspendResult;
            this._state_1 = 18;
            continue $sm;
          case 18:
            Unit_getInstance();
            throw this._t10;
          case 19:
            this._$nas.stop_2();
            if (this._this$0_38._closeStream_0) {
              this._stream0_0.close_77();
            }
            this._$playing._v = false;
            var tmp1_safe_receiver_0 = this._$params._onFinish;
            if (tmp1_safe_receiver_0 == null)
              null;
            else
              tmp1_safe_receiver_0();
            Unit_getInstance();
            this._tmp2_safe_receiver13 = this._this$0_38._onComplete;
            if (this._tmp2_safe_receiver13 == null) {
              this._WHEN_RESULT14 = null;
              this._state_1 = 21;
              continue $sm;
            } else {
              this._state_1 = 20;
              suspendResult = this._tmp2_safe_receiver13(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 20:
            this._WHEN_RESULT14 = suspendResult;
            this._state_1 = 21;
            continue $sm;
          case 21:
            Unit_getInstance();
            return Unit_getInstance();
          case 22:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 22) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__184.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__184(this._this$0_38, this._$params, this._$playing, this._$nas, this._$paused, completion);
    return i;
  };
  _no_name_provided__184.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__185($nas, this$0, $paused, $playing, $job) {
    this._$nas_0 = $nas;
    this._this$0_39 = this$0;
    this._$paused_0 = $paused;
    this._$playing_0 = $playing;
    this._$job = $job;
    SoundChannel.call(this, this$0._nativeSound);
    this._volume$delegate = volume$factory(this._$nas_0);
    this._pitch$delegate = pitch$factory(this._$nas_0);
    this._panning$delegate = panning$factory(this._$nas_0);
  }
  _no_name_provided__185.prototype._set_volume__8 = function (_set___) {
    var tmp0_setValue_0 = this._volume$delegate;
    var tmp1_setValue_0 = volume$factory_0();
    return tmp0_setValue_0.set(_set___);
  };
  _no_name_provided__185.prototype._get_volume__8 = function () {
    var tmp0_getValue_0 = this._volume$delegate;
    var tmp1_getValue_0 = volume$factory_1();
    return tmp0_getValue_0.get();
  };
  _no_name_provided__185.prototype._set_pitch__8 = function (_set___) {
    var tmp0_setValue_0 = this._pitch$delegate;
    var tmp1_setValue_0 = pitch$factory_0();
    return tmp0_setValue_0.set(_set___);
  };
  _no_name_provided__185.prototype._get_pitch__8 = function () {
    var tmp0_getValue_0 = this._pitch$delegate;
    var tmp1_getValue_0 = pitch$factory_1();
    return tmp0_getValue_0.get();
  };
  _no_name_provided__185.prototype._set_panning__8 = function (_set___) {
    var tmp0_setValue_0 = this._panning$delegate;
    var tmp1_setValue_0 = panning$factory_0();
    return tmp0_setValue_0.set(_set___);
  };
  _no_name_provided__185.prototype._get_panning__8 = function () {
    var tmp0_getValue_0 = this._panning$delegate;
    var tmp1_getValue_0 = panning$factory_1();
    return tmp0_getValue_0.get();
  };
  _no_name_provided__185.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SoundAudioStream(coroutineContext, stream, closeStream, name, onComplete) {
    Sound.call(this, coroutineContext);
    this._stream_0 = stream;
    this._closeStream_0 = closeStream;
    this._name_14 = name;
    this._onComplete = onComplete;
    this._nativeSound = this;
  }
  SoundAudioStream.prototype._get_name__50 = function () {
    return this._name_14;
  };
  SoundAudioStream.prototype._get_length__8 = function () {
    return this._stream_0._get_totalLength__1();
  };
  SoundAudioStream.prototype.play_4 = function (coroutineContext, params) {
    var nas = _get_nativeSoundProvider_().createAudioStream_0(coroutineContext, this._stream_0._rate_0);
    copySoundPropsFrom(nas, params);
    var playing = {_v: true};
    var paused = {_v: false};
    var job = launchImmediately(coroutineContext, _no_name_provided_$factory_148(this, params, playing, nas, paused, null));
    return new _no_name_provided__185(nas, this, paused, playing, job);
  };
  SoundAudioStream.$metadata$ = {
    simpleName: 'SoundAudioStream',
    kind: 'class',
    interfaces: []
  };
  function volume$factory($b0) {
    return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
      return $b0._get_volume__8();
    }, function (value) {
      return $b0._set_volume__8(value);
    });
  }
  function pitch$factory($b0) {
    return getPropertyCallableRef('pitch', 0, KMutableProperty0, function () {
      return $b0._get_pitch__8();
    }, function (value) {
      return $b0._set_pitch__8(value);
    });
  }
  function panning$factory($b0) {
    return getPropertyCallableRef('panning', 0, KMutableProperty0, function () {
      return $b0._get_panning__8();
    }, function (value) {
      return $b0._set_panning__8(value);
    });
  }
  function volume$factory_0() {
    return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
      return receiver._get_volume__8();
    }, function (receiver_0, value) {
      return receiver_0._set_volume__8(value);
    });
  }
  function volume$factory_1() {
    return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
      return receiver._get_volume__8();
    }, function (receiver_0, value) {
      return receiver_0._set_volume__8(value);
    });
  }
  function pitch$factory_0() {
    return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
      return receiver._get_pitch__8();
    }, function (receiver_0, value) {
      return receiver_0._set_pitch__8(value);
    });
  }
  function pitch$factory_1() {
    return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
      return receiver._get_pitch__8();
    }, function (receiver_0, value) {
      return receiver_0._set_pitch__8(value);
    });
  }
  function panning$factory_0() {
    return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
      return receiver._get_panning__8();
    }, function (receiver_0, value) {
      return receiver_0._set_panning__8(value);
    });
  }
  function panning$factory_1() {
    return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
      return receiver._get_panning__8();
    }, function (receiver_0, value) {
      return receiver_0._set_panning__8(value);
    });
  }
  function _no_name_provided_$factory_148(this$0, $params, $playing, $nas, $paused, resultContinuation) {
    var i = new _no_name_provided__184(this$0, $params, $playing, $nas, $paused, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function $createSoundCOROUTINE$32(_this_, data, streaming, props, name, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__117 = _this_;
    this._data_33 = data;
    this._streaming_2 = streaming;
    this._props_10 = props;
    this._name_15 = name;
  }
  $createSoundCOROUTINE$32.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = HtmlSimpleSound_getInstance().loadSound_0(this._data_33, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = AudioBufferOrHTMLMediaElement_init_$Create$(ARGUMENT);
            return new AudioBufferSound(ARGUMENT_0, '#bytes', this._get_context__296(), this._name_15);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$32.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$32',
    kind: 'class',
    interfaces: []
  };
  function $createSoundCOROUTINE$33(_this_, vfs, path_0, streaming, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__118 = _this_;
    this._vfs_2 = vfs;
    this._path_18 = path_0;
    this._streaming_3 = streaming;
    this._props_11 = props;
  }
  $createSoundCOROUTINE$33.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._tmp0_subject0 = this._vfs_2;
            var tmp_0;
            var tmp_1 = this._tmp0_subject0;
            if (tmp_1 instanceof LocalVfs) {
              tmp_0 = true;
            } else {
              {
                var tmp_2 = this._tmp0_subject0;
                tmp_0 = tmp_2 instanceof UrlVfs_0;
              }
            }

            if (tmp_0) {
              var tmp_3 = this;
              var tmp1_subject = this._vfs_2;
              var tmp_4;
              if (tmp1_subject instanceof LocalVfs) {
                tmp_4 = this._path_18;
              } else {
                if (tmp1_subject instanceof UrlVfs_0) {
                  tmp_4 = this._vfs_2.getFullUrl(this._path_18);
                } else {
                  {
                    _get_invalidOp_();
                  }
                }
              }
              tmp_3._url2 = tmp_4;
              if (this._streaming_3) {
                var tmp_5 = this;
                var tmp_6 = AudioBufferOrHTMLMediaElement_init_$Create$_0(HtmlSimpleSound_getInstance().loadSoundBuffer(this._url2));
                var tmp_7 = this._get_context__296();
                tmp_5._WHEN_RESULT3_0 = AudioBufferSound_init_$Create$(tmp_6, this._url2, tmp_7, null, 8, null);
                this._state_1 = 4;
                continue $sm;
              } else {
                this._state_1 = 2;
                suspendResult = HtmlSimpleSound_getInstance().loadSound_1(this._url2, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            } else {
              {
                this._state_1 = 1;
                suspendResult = NativeSoundProvider.prototype.createSound$default.call(this.__this__118, this._vfs_2, this._path_18, false, null, 12, NativeSoundProvider.prototype.createSound_4.bind(this.__this__118), this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            }

            break;
          case 1:
            this._WHEN_RESULT1_6 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = AudioBufferOrHTMLMediaElement_init_$Create$(ARGUMENT);
            var tmp_8 = this;
            var tmp_9 = this._get_context__296();
            tmp_8._WHEN_RESULT3_0 = AudioBufferSound_init_$Create$(ARGUMENT_0, this._url2, tmp_9, null, 8, null);
            this._state_1 = 4;
            continue $sm;
          case 3:
            throw this._exception_0;
          case 4:
            this._WHEN_RESULT1_6 = this._WHEN_RESULT3_0;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._WHEN_RESULT1_6;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createSoundCOROUTINE$33.$metadata$ = {
    simpleName: '$createSoundCOROUTINE$33',
    kind: 'class',
    interfaces: []
  };
  function HtmlNativeSoundProvider() {
    NativeSoundProvider.call(this);
  }
  HtmlNativeSoundProvider.prototype.init_15 = function () {
    HtmlSimpleSound_getInstance().ensureUnlockStart();
  };
  HtmlNativeSoundProvider.prototype.createAudioStream_0 = function (coroutineContext, freq) {
    return new JsPlatformAudioOutput(coroutineContext, freq);
  };
  HtmlNativeSoundProvider.prototype.createSound_3 = function (data, streaming, props, name, $cont) {
    var tmp = new $createSoundCOROUTINE$32(this, data, streaming, props, name, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  HtmlNativeSoundProvider.prototype.createSound_4 = function (vfs, path_0, streaming, props, $cont) {
    var tmp = new $createSoundCOROUTINE$33(this, vfs, path_0, streaming, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  HtmlNativeSoundProvider.$metadata$ = {
    simpleName: 'HtmlNativeSoundProvider',
    kind: 'class',
    interfaces: []
  };
  function AudioBufferSound_init_$Init$(buffer, url, coroutineContext, name, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      name = 'unknown';
    AudioBufferSound.call($this, buffer, url, coroutineContext, name);
    return $this;
  }
  function AudioBufferSound_init_$Create$(buffer, url, coroutineContext, name, $mask0, $marker) {
    return AudioBufferSound_init_$Init$(buffer, url, coroutineContext, name, $mask0, $marker, Object.create(AudioBufferSound.prototype));
  }
  function _no_name_provided__186($channel) {
    this._$channel = $channel;
  }
  _no_name_provided__186.prototype.invoke_660 = function (it) {
    var tmp0_safe_receiver = this._$channel;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.play_6();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  _no_name_provided__186.prototype.invoke_1015 = function (p1) {
    this.invoke_660(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__186.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__187(this$0, $channel) {
    this._this$0_40 = this$0;
    this._$channel_0 = $channel;
    SoundChannel.call(this, this$0);
    var tmp = this;
    var tmp0_safe_receiver = this._this$0_40._buffer_20;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_duration_();
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      tmp_0 = Companion_getInstance_27().fromSeconds(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp_1;
    var tmp_2 = tmp2_elvis_lhs;
    if ((tmp_2 == null ? null : new TimeSpan(tmp_2)) == null) {
      var tmp0__get_seconds__0 = 0;
      tmp_1 = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
    } else {
      {
        tmp_1 = tmp2_elvis_lhs;
      }
    }
    tmp._total = tmp_1;
  }
  _no_name_provided__187.prototype._set_volume__8 = function (value) {
    var tmp0_safe_receiver = this._$channel_0;
    if (tmp0_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp0_safe_receiver._set_volume__8(value);
  };
  _no_name_provided__187.prototype._get_volume__8 = function () {
    var tmp0_safe_receiver = this._$channel_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._volume_3;
    return tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
  };
  _no_name_provided__187.prototype._set_pitch__8 = function (value) {
    var tmp0_safe_receiver = this._$channel_0;
    if (tmp0_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp0_safe_receiver._set_pitch__8(value);
  };
  _no_name_provided__187.prototype._get_pitch__8 = function () {
    var tmp0_safe_receiver = this._$channel_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._pitch_3;
    return tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
  };
  _no_name_provided__187.prototype._set_panning__8 = function (value) {
    var tmp0_safe_receiver = this._$channel_0;
    if (tmp0_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp0_safe_receiver._set_panning__8(value);
  };
  _no_name_provided__187.prototype._get_panning__8 = function () {
    var tmp0_safe_receiver = this._$channel_0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._panning_3;
    return tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  };
  _no_name_provided__187.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AudioBufferSound(buffer, url, coroutineContext, name) {
    Sound.call(this, coroutineContext);
    this._buffer_20 = buffer;
    this._url_4 = url;
    this._name_16 = name;
    var tmp = this;
    var tmp0_elvis_lhs = this._buffer_20._get_duration_();
    var tmp0__get_seconds__0 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    tmp._length_5 = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
  }
  AudioBufferSound.prototype._get_name__50 = function () {
    return this._name_16;
  };
  AudioBufferSound.prototype._get_length__8 = function () {
    return this._length_5;
  };
  AudioBufferSound.prototype.play_4 = function (coroutineContext, params) {
    var channel = this._buffer_20._get_isNotNull_() ? HtmlSimpleSound_getInstance().playSound(this._buffer_20, params, coroutineContext) : null;
    var tmp = HtmlSimpleSound_getInstance();
    tmp.callOnUnlocked(_no_name_provided_$factory_149(channel));
    Unit_getInstance();
    var tmp0_also_0 = new _no_name_provided__187(this, channel);
    copySoundPropsFrom(tmp0_also_0, params);
    return tmp0_also_0;
  };
  AudioBufferSound.$metadata$ = {
    simpleName: 'AudioBufferSound',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_149($channel) {
    var i = new _no_name_provided__186($channel);
    return function (p1) {
      i.invoke_660(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__188($htmlAudioElement, this$0, $audioBuffer) {
    this._$htmlAudioElement = $htmlAudioElement;
    this._this$0_41 = this$0;
    this._$audioBuffer = $audioBuffer;
  }
  _no_name_provided__188.prototype.invoke_277 = function ($this$gain) {
    if (!(this._$htmlAudioElement == null)) {
      this._this$0_41._realHtmlAudioElement = clone(this._$htmlAudioElement);
      var tmp = this._this$0_41;
      var tmp_0 = HtmlSimpleSound_getInstance();
      var tmp_1 = ensureNotNull(this._this$0_41._realHtmlAudioElement);
      tmp._sourceNode = tmp_0.source$default_0($this$gain, tmp_1, null, 2, null);
    } else if (!(this._$audioBuffer == null)) {
      var tmp_2 = this._this$0_41;
      var tmp_3 = HtmlSimpleSound_getInstance();
      tmp_2._sourceNode = tmp_3.source$default($this$gain, this._$audioBuffer, null, 2, null);
    }};
  _no_name_provided__188.prototype.invoke_1015 = function (p1) {
    this.invoke_277((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__188.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__189($deferred) {
    this._$deferred_4 = $deferred;
  }
  _no_name_provided__189.prototype.invoke_1005 = function () {
    return this._$deferred_4.complete_1(Unit_getInstance());
  };
  _no_name_provided__189.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__190($deferred) {
    this._$deferred_5 = $deferred;
  }
  _no_name_provided__190.prototype.invoke_998 = function () {
    this._$deferred_5.complete_1(Unit_getInstance());
    Unit_getInstance();
  };
  _no_name_provided__190.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__190.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__191(this$0, $htmlAudioElement, $audioBuffer) {
    this._this$0_42 = this$0;
    this._$htmlAudioElement_0 = $htmlAudioElement;
    this._$audioBuffer_0 = $audioBuffer;
  }
  _no_name_provided__191.prototype.invoke_282 = function ($this$panner) {
    var tmp = this._this$0_42;
    var tmp_0 = HtmlSimpleSound_getInstance();
    tmp._gainNode = tmp_0.gain_0($this$panner, _no_name_provided_$factory_153(this._$htmlAudioElement_0, this._this$0_42, this._$audioBuffer_0));
  };
  _no_name_provided__191.prototype.invoke_1015 = function (p1) {
    this.invoke_282((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__191.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__192(this$0, $startTime, resultContinuation) {
    this._this$0_43 = this$0;
    this._$startTime = $startTime;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__192.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__192.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__192.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._exceptionState = 7;
            this._exceptionState = 6;
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!_PlaybackTimes___get_hasMore__impl_(this._this$0_43._times_0)) {
              this._state_1 = 5;
              continue $sm;
            }
            this._this$0_43._startedAt = Companion_getInstance_18().now_2();
            this._this$0_43.createNode(this._$startTime._v._milliseconds);
            var tmp_0 = this;
            tmp_0._tmp0__get_seconds__01 = 0;
            this._$startTime._v = new TimeSpan(Companion_getInstance_27().fromSeconds(this._tmp0__get_seconds__01));
            var tmp_1 = this;
            tmp_1._deferred2 = CompletableDeferred$default(null, 1, null);
            var tmp_2;
            if (this._this$0_43._sourceNode == null) {
              tmp_2 = true;
            } else {
              var tmp0_safe_receiver = this._this$0_43._ctx;
              tmp_2 = !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.state) === 'running');
            }

            if (tmp_2) {
              var tmp_3 = window;
              var tmp_4 = _no_name_provided_$factory_154(this._deferred2);
              var tmp1_asDynamic_0 = this._this$0_43._buffer_21;
              var tmp2_unsafeCast_0 = tmp1_asDynamic_0.duration;
              (function () {
                var $externalVarargReceiverTmp = tmp_3;
                return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [tmp_4, numberToInt(tmp2_unsafeCast_0 * 1000)]);
              }.call(this));
              Unit_getInstance();
            } else {
              {
                var tmp1_safe_receiver = this._this$0_43._sourceNode;
                if (tmp1_safe_receiver == null) {
                  Unit_getInstance();
                } else {
                  tmp1_safe_receiver.onended = _no_name_provided_$factory_155(this._deferred2);
                }
              }
            }

            this._state_1 = 3;
            suspendResult = this._deferred2.await_3(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            this._this$0_43._times_0 = _PlaybackTimes___get_oneLess__impl_(this._this$0_43._times_0);
            if (!_PlaybackTimes___get_hasMore__impl_(this._this$0_43._times_0)) {
              this._state_1 = 5;
              continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 4:
            this._state_1 = 2;
            continue $sm;
          case 5:
            this._tmp$ret$00_1 = Unit_getInstance();
            this._exceptionState = 8;
            this._state_1 = 9;
            continue $sm;
          case 6:
            this._exceptionState = 7;
            var tmp_5 = this._exception_0;
            if (tmp_5 instanceof CancellationException_0) {
              var e = this._exception_0;
              var tmp_6 = this;
              var tmp2_safe_receiver = this._this$0_43._params._onCancel;
              if (tmp2_safe_receiver == null)
                null;
              else
                tmp2_safe_receiver();
              tmp_6._tmp$ret$00_1 = Unit_getInstance();
              this._exceptionState = 8;
              this._state_1 = 9;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 7:
            this._exceptionState = 8;
            var t = this._exception_0;
            this._this$0_43._running = false;
            var realHtmlAudioElement = this._this$0_43._realHtmlAudioElement;
            if (!(realHtmlAudioElement == null)) {
              realHtmlAudioElement.pause();
              realHtmlAudioElement.currentTime = 0.0;
            } else {
              var tmp3_safe_receiver = this._this$0_43._sourceNode;
              if (tmp3_safe_receiver == null)
                null;
              else {
                tmp3_safe_receiver.stop();
                Unit_getInstance();
              }
              Unit_getInstance();
            }

            this._this$0_43._gainNode = null;
            this._this$0_43._pannerNode = null;
            this._this$0_43._sourceNode = null;
            var tmp4_safe_receiver = this._this$0_43._params._onFinish;
            if (tmp4_safe_receiver == null)
              null;
            else
              tmp4_safe_receiver();
            Unit_getInstance();
            throw t;
          case 8:
            throw this._exception_0;
          case 9:
            this._this$0_43._running = false;
            var realHtmlAudioElement_0 = this._this$0_43._realHtmlAudioElement;
            if (!(realHtmlAudioElement_0 == null)) {
              realHtmlAudioElement_0.pause();
              realHtmlAudioElement_0.currentTime = 0.0;
            } else {
              var tmp3_safe_receiver_0 = this._this$0_43._sourceNode;
              if (tmp3_safe_receiver_0 == null)
                null;
              else {
                tmp3_safe_receiver_0.stop();
                Unit_getInstance();
              }
              Unit_getInstance();
            }

            this._this$0_43._gainNode = null;
            this._this$0_43._pannerNode = null;
            this._this$0_43._sourceNode = null;
            var tmp4_safe_receiver_0 = this._this$0_43._params._onFinish;
            if (tmp4_safe_receiver_0 == null)
              null;
            else
              tmp4_safe_receiver_0();
            Unit_getInstance();
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 8) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__192.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__192(this._this$0_43, this._$startTime, completion);
    return i;
  };
  _no_name_provided__192.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__193($source) {
    this._$source = $source;
  }
  _no_name_provided__193.prototype.invoke_998 = function () {
    this._$source.disconnect(0);
    HtmlSimpleSound_getInstance()._unlocked = true;
    Console_getInstance().info_1(['Web Audio was successfully unlocked']);
    HtmlSimpleSound_getInstance()._unlockDeferred.complete_1(Unit_getInstance());
    Unit_getInstance();
  };
  _no_name_provided__193.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__193.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function SimpleSoundChannel(buffer, ctx, params, coroutineContext) {
    this._buffer_21 = buffer;
    this._ctx = ctx;
    this._params = params;
    this._coroutineContext_2 = coroutineContext;
    this._gainNode = null;
    this._pannerNode = null;
    this._sourceNode = null;
    this._realHtmlAudioElement = null;
    this._startedAt = Companion_getInstance_18().now_2();
    this._times_0 = this._params._times;
    this._volume_3 = this._params._volume_1;
    this._pitch_3 = this._params._pitch_1;
    this._panning_3 = this._params._panning_1;
    this._running = true;
    this._pausedAt = null;
    this._job_2 = null;
  }
  SimpleSoundChannel.prototype.createNode = function (startTime) {
    var tmp0_safe_receiver = this._realHtmlAudioElement;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pause();
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._sourceNode;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.disconnect();
      Unit_getInstance();
    }
    Unit_getInstance();
    var htmlAudioElement = this._buffer_21._htmlAudioElement;
    var audioBuffer = this._buffer_21._audioBuffer;
    var tmp0_apply_0 = this._ctx.destination;
    var tmp = this;
    var tmp_0 = HtmlSimpleSound_getInstance();
    tmp._pannerNode = tmp_0.panner(tmp0_apply_0, _no_name_provided_$factory_151(this, htmlAudioElement, audioBuffer));
    this.updateNodes();
    Unit_getInstance();
    var realHtmlAudioElement = this._realHtmlAudioElement;
    if (!(realHtmlAudioElement == null)) {
      realHtmlAudioElement.currentTime = _TimeSpan___get_seconds__impl_(startTime);
      realHtmlAudioElement.play();
      Unit_getInstance();
    } else {
      var tmp2_safe_receiver = this._sourceNode;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.start(0.0, _TimeSpan___get_seconds__impl_(startTime));
        Unit_getInstance();
      }
      Unit_getInstance();
    }
  };
  SimpleSoundChannel.prototype.createJobAt = function (startTime) {
    if (_get_job_(this._coroutineContext_2)._get_isCompleted__16()) {
      Console_getInstance().warn_1(["Sound won't play because coroutineContext.job is completed"]);
    }this._startedAt = Companion_getInstance_18().now_2();
    var startTime_0 = {_v: new TimeSpan(startTime)};
    var tmp0_safe_receiver = this._ctx;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.resume();
      Unit_getInstance();
    }
    Unit_getInstance();
    return launchImmediately(this._coroutineContext_2, _no_name_provided_$factory_152(this, startTime_0, null));
  };
  SimpleSoundChannel.prototype._set_volume__8 = function (value) {
    this._volume_3 = value;
    return this.updateVolume();
  };
  SimpleSoundChannel.prototype._set_pitch__8 = function (value) {
    this._pitch_3 = value;
    return this.updatePitch();
  };
  SimpleSoundChannel.prototype._set_panning__8 = function (value) {
    this._panning_3 = value;
    return this.updatePanning();
  };
  SimpleSoundChannel.prototype.updateNodes = function () {
    this.updateVolume();
    this.updatePitch();
    this.updatePanning();
  };
  SimpleSoundChannel.prototype.updateVolume = function () {
    var tmp0_safe_receiver = this._gainNode;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gain;
    if (tmp1_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp1_safe_receiver.value = this._volume_3;
  };
  SimpleSoundChannel.prototype.updatePitch = function () {
  };
  SimpleSoundChannel.prototype.updatePanning = function () {
    var tmp0_safe_receiver = this._pannerNode;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.setPosition(this._panning_3, 0.0, 0.0);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._pannerNode;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.setOrientation(0.0, 1.0, 0.0);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  SimpleSoundChannel.prototype.stop_2 = function () {
    var tmp0_safe_receiver = this._job_2;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cancel$default_14(null, 1, null);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  SimpleSoundChannel.prototype.play_6 = function () {
    if (!(this._job_2 == null) ? !(this._realHtmlAudioElement == null) : false) {
      var tmp0_safe_receiver = this._realHtmlAudioElement;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.play();
      Unit_getInstance();
    } else {
      this.stop_2();
      this._job_2 = this.createJobAt(this._params._startTime);
    }
  };
  SimpleSoundChannel.$metadata$ = {
    simpleName: 'SimpleSoundChannel',
    kind: 'class',
    interfaces: []
  };
  function sam$com_soywiz_korio_lang_Cancellable$0(function_0) {
    this._function_2 = function_0;
  }
  sam$com_soywiz_korio_lang_Cancellable$0.prototype.cancel_27 = function (e) {
    return this._function_2(e);
  };
  sam$com_soywiz_korio_lang_Cancellable$0.$metadata$ = {
    simpleName: 'sam$com_soywiz_korio_lang_Cancellable$0',
    kind: 'class',
    interfaces: [Cancellable]
  };
  function _no_name_provided__194() {
  }
  _no_name_provided__194.prototype.invoke_288 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__194.prototype.invoke_1015 = function (p1) {
    this.invoke_288((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__194.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__195() {
  }
  _no_name_provided__195.prototype.invoke_290 = function ($this$null) {
    return Unit_getInstance();
  };
  _no_name_provided__195.prototype.invoke_1015 = function (p1) {
    this.invoke_290((!(p1 == null) ? isObject(p1) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__195.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__196($cancelled, $callback) {
    this._$cancelled = $cancelled;
    this._$callback_2 = $callback;
  }
  _no_name_provided__196.prototype.invoke_725 = function (it) {
    if (!this._$cancelled._v)
      this._$callback_2(Unit_getInstance());
  };
  _no_name_provided__196.prototype.invoke_1015 = function (p1) {
    this.invoke_725((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__196.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__197($cancelled) {
    this._$cancelled_0 = $cancelled;
  }
  _no_name_provided__197.prototype.invoke_903 = function (it) {
    this._$cancelled_0._v = true;
  };
  _no_name_provided__197.prototype.invoke_1015 = function (p1) {
    this.invoke_903(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__197.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__198($safe_2_2) {
    this._$safe_2_2 = $safe_2_2;
  }
  _no_name_provided__198.prototype.invoke_296 = function (data) {
    var tmp0_success_0_1_5 = Companion_getInstance_2();
    this._$safe_2_2.resumeWith_196(_Result___init__impl_(data));
  };
  _no_name_provided__198.prototype.invoke_1015 = function (p1) {
    this.invoke_296(p1 instanceof AudioBuffer ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__198.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__199($url, $safe_2_2) {
    this._$url_0 = $url;
    this._$safe_2_2_0 = $safe_2_2;
  }
  _no_name_provided__199.prototype.invoke_998 = function () {
    var tmp0_resumeWithException_0_7 = Exception_init_$Create$('' + 'error decoding ' + this._$url_0);
    var tmp0_failure_0_1_8 = Companion_getInstance_2();
    this._$safe_2_2_0.resumeWith_196(_Result___init__impl_(createFailure(tmp0_resumeWithException_0_7)));
  };
  _no_name_provided__199.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__199.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__200($unlock, $_scratchBuffer) {
    this._$unlock = $unlock;
    this._$_scratchBuffer = $_scratchBuffer;
  }
  _no_name_provided__200.prototype.invoke_564 = function (it) {
    var tmp = document;
    var tmp_0;
    if (this._$unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_0 = this._$unlock._v;
    }
    tmp.removeEventListener('keydown', tmp_0, true);
    var tmp_1 = document;
    var tmp_2;
    if (this._$unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_2 = this._$unlock._v;
    }
    tmp_1.removeEventListener('touchstart', tmp_2, true);
    var tmp_3 = document;
    var tmp_4;
    if (this._$unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_4 = this._$unlock._v;
    }
    tmp_3.removeEventListener('touchend', tmp_4, true);
    var tmp_5 = document;
    var tmp_6;
    if (this._$unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_6 = this._$unlock._v;
    }
    tmp_5.removeEventListener('mousedown', tmp_6, true);
    if (!(HtmlSimpleSound_getInstance()._ctx_0 == null)) {
      var tmp0_asDynamic_0 = window;
      var tmp1_unsafeCast_0 = tmp0_asDynamic_0.globalAudioContext;
      var tmp0_safe_receiver = tmp1_unsafeCast_0;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.resume();
        Unit_getInstance();
      }
      Unit_getInstance();
      var source = HtmlSimpleSound_getInstance()._ctx_0.createBufferSource();
      source.buffer = this._$_scratchBuffer;
      source.connect(HtmlSimpleSound_getInstance()._ctx_0.destination);
      Unit_getInstance();
      source.start(0.0);
      var tmp2_asDynamic_0 = HtmlSimpleSound_getInstance()._ctx_0;
      if (typeof tmp2_asDynamic_0.resume === 'function') {
        var tmp3_asDynamic_0 = HtmlSimpleSound_getInstance()._ctx_0;
        tmp3_asDynamic_0.resume();
      } else {
      }
      source.onended = _no_name_provided_$factory_160(source);
    }};
  _no_name_provided__200.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__200.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $loadSoundCOROUTINE$36(_this_, data, url, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__119 = _this_;
    this._data_34 = data;
    this._url_5 = url;
  }
  $loadSoundCOROUTINE$36.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            if (this.__this__119._ctx_0 == null)
              return null;
            this._state_1 = 1;
            var tmp_0 = this;
            tmp_0._tmp0__anonymous__1_10 = this;
            this._safe_2_21 = SafeContinuation_init_$Create$(intercepted(this._tmp0__anonymous__1_10));
            var tmp_1 = HtmlSimpleSound_getInstance()._ctx_0;
            var tmp_2 = _no_name_provided_$factory_161(this._safe_2_21);
            tmp_1.decodeAudioData(this._data_34, tmp_2, _no_name_provided_$factory_162(this._url_5, this._safe_2_21));
            suspendResult = this._safe_2_21.getOrThrow();
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loadSoundCOROUTINE$36.$metadata$ = {
    simpleName: '$loadSoundCOROUTINE$36',
    kind: 'class',
    interfaces: []
  };
  function $loadSoundCOROUTINE$37(_this_, url, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__120 = _this_;
    this._url_6 = url;
  }
  $loadSoundCOROUTINE$37.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = _get_uniVfs_(this._url_6).readBytes(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_19 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__120.loadSound_0(this._ARGUMENT0_19, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loadSoundCOROUTINE$37.$metadata$ = {
    simpleName: '$loadSoundCOROUTINE$37',
    kind: 'class',
    interfaces: []
  };
  function HtmlSimpleSound() {
    HtmlSimpleSound_instance = this;
    var tmp = this;
    var tmp_0;
    try {
      var tmp_1;
      var tmp0_asDynamic_0 = window;
      if (!(typeof tmp0_asDynamic_0.AudioContext === 'undefined')) {
        tmp_1 = new AudioContext();
      } else {
        var tmp1_asDynamic_0 = window;
        if (!(typeof tmp1_asDynamic_0.webkitAudioContext === 'undefined')) {
          tmp_1 = new webkitAudioContext();
        } else {
          {
            tmp_1 = null;
          }
        }
      }
      var tmp2_also_0 = tmp_1;
      var tmp0_asDynamic_0_2 = window;
      tmp0_asDynamic_0_2.globalAudioContext = tmp2_also_0;
      tmp_0 = tmp2_also_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].concat([$p]));
        }.call(this));
        tmp_2 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp_0 = tmp_2;
    }
    tmp._ctx_0 = tmp_0;
    this._unlocked = false;
    var tmp_3 = this;
    tmp_3._unlockDeferred = CompletableDeferred_0(Job$default(null, 1, null));
    var tmp_4 = this;
    var tmp_5 = this._unlockDeferred;
    tmp_4._unlock = isInterface(tmp_5, Deferred) ? tmp_5 : THROW_CCE();
    var tmp0_safe_receiver = this._ctx_0;
    var _scratchBuffer = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createBuffer(1, 1, 22050);
    var unlock = {_v: null};
    unlock._v = _no_name_provided_$factory_150(unlock, _scratchBuffer);
    var tmp_6 = document;
    var tmp_7;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_7 = unlock._v;
    }
    tmp_6.addEventListener('keydown', tmp_7, true);
    var tmp_8 = document;
    var tmp_9;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_9 = unlock._v;
    }
    tmp_8.addEventListener('touchstart', tmp_9, true);
    var tmp_10 = document;
    var tmp_11;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_11 = unlock._v;
    }
    tmp_10.addEventListener('touchend', tmp_11, true);
    var tmp_12 = document;
    var tmp_13;
    if (unlock._v == null) {
      throwUninitializedPropertyAccessException('unlock');
    } else {
      tmp_13 = unlock._v;
    }
    tmp_12.addEventListener('mousedown', tmp_13, true);
  }
  HtmlSimpleSound.prototype._get_available__3 = function () {
    return !(this._ctx_0 == null);
  };
  HtmlSimpleSound.prototype.panner = function (_this__0, callback) {
    var tmp0_elvis_lhs = this._ctx_0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var tmp_0;
    try {
      var tmp0_success_0_1 = Companion_getInstance_2();
      var tmp1_success_0_2 = ctx.createPanner();
      tmp_0 = _Result___init__impl_(tmp1_success_0_2);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var tmp2_failure_0_4 = Companion_getInstance_2();
        tmp_1 = _Result___init__impl_(createFailure($p));
      } else {
        {
          throw $p;
        }
      }
      tmp_0 = tmp_1;
    }
    var tmp0_getOrNull_0 = tmp_0;
    var tmp_2;
    if (_Result___get_isFailure__impl_(tmp0_getOrNull_0)) {
      tmp_2 = null;
    } else {
      var tmp_3 = _Result___get_value__impl_(tmp0_getOrNull_0);
      tmp_2 = (tmp_3 == null ? true : isObject(tmp_3)) ? tmp_3 : THROW_CCE();
    }
    var tmp1_elvis_lhs = tmp_2;
    var tmp_4;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_4 = tmp1_elvis_lhs;
    }
    var node = tmp_4;
    callback(node);
    node.connect(_this__0);
    Unit_getInstance();
    return node;
  };
  HtmlSimpleSound.prototype.gain_0 = function (_this__0, callback) {
    var tmp0_elvis_lhs = this._ctx_0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var node = ctx.createGain();
    callback(node);
    node.connect(_this__0);
    Unit_getInstance();
    return node;
  };
  HtmlSimpleSound.prototype.source_0 = function (_this__0, buffer, callback) {
    var tmp0_elvis_lhs = this._ctx_0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var node = ctx.createBufferSource();
    node.buffer = buffer;
    callback(node);
    node.connect(_this__0);
    Unit_getInstance();
    return node;
  };
  HtmlSimpleSound.prototype.source$default = function (_this__0, buffer, callback, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      callback = _no_name_provided_$factory_156();
    }return this.source_0(_this__0, buffer, callback);
  };
  HtmlSimpleSound.prototype.source_1 = function (_this__0, buffer, callback) {
    var tmp0_elvis_lhs = this._ctx_0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctx = tmp;
    var node = ctx.createMediaElementSource(buffer);
    callback(node);
    node.connect(_this__0);
    Unit_getInstance();
    return node;
  };
  HtmlSimpleSound.prototype.source$default_0 = function (_this__0, buffer, callback, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      callback = _no_name_provided_$factory_157();
    }return this.source_1(_this__0, buffer, callback);
  };
  HtmlSimpleSound.prototype.playSound = function (buffer, params, coroutineContext) {
    var tmp0_safe_receiver = this._ctx_0;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = new SimpleSoundChannel(buffer, tmp0_safe_receiver, params, coroutineContext);
    }
    return tmp;
  };
  HtmlSimpleSound.prototype.ensureUnlockStart = function () {
    Unit_getInstance();
  };
  HtmlSimpleSound.prototype.callOnUnlocked = function (callback) {
    var cancelled = {_v: false};
    this._unlock.invokeOnCompletion_31(_no_name_provided_$factory_158(cancelled, callback));
    Unit_getInstance();
    var tmp = _no_name_provided_$factory_159(cancelled);
    return new sam$com_soywiz_korio_lang_Cancellable$0(tmp);
  };
  HtmlSimpleSound.prototype.loadSound = function (data, url, $cont) {
    var tmp = new $loadSoundCOROUTINE$36(this, data, url, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  HtmlSimpleSound.prototype.loadSoundBuffer = function (url) {
    if (this._ctx_0 == null)
      return null;
    return createAudioElement$default(url, 0.0, false, null, 14, null);
  };
  HtmlSimpleSound.prototype.loadSound_0 = function (data, $cont) {
    return this.loadSound(data.buffer, 'ByteArray', $cont);
  };
  HtmlSimpleSound.prototype.loadSound_1 = function (url, $cont) {
    var tmp = new $loadSoundCOROUTINE$37(this, url, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  HtmlSimpleSound.$metadata$ = {
    simpleName: 'HtmlSimpleSound',
    kind: 'object',
    interfaces: []
  };
  var HtmlSimpleSound_instance;
  function HtmlSimpleSound_getInstance() {
    if (HtmlSimpleSound_instance == null)
      new HtmlSimpleSound();
    return HtmlSimpleSound_instance;
  }
  function AudioBufferOrHTMLMediaElement_init_$Init$(audioBuffer, $this) {
    AudioBufferOrHTMLMediaElement.call($this, audioBuffer, null);
    return $this;
  }
  function AudioBufferOrHTMLMediaElement_init_$Create$(audioBuffer) {
    return AudioBufferOrHTMLMediaElement_init_$Init$(audioBuffer, Object.create(AudioBufferOrHTMLMediaElement.prototype));
  }
  function AudioBufferOrHTMLMediaElement_init_$Init$_0(htmlMediaElement, $this) {
    AudioBufferOrHTMLMediaElement.call($this, null, htmlMediaElement);
    return $this;
  }
  function AudioBufferOrHTMLMediaElement_init_$Create$_0(htmlMediaElement) {
    return AudioBufferOrHTMLMediaElement_init_$Init$_0(htmlMediaElement, Object.create(AudioBufferOrHTMLMediaElement.prototype));
  }
  function AudioBufferOrHTMLMediaElement(audioBuffer, htmlAudioElement) {
    this._audioBuffer = audioBuffer;
    this._htmlAudioElement = htmlAudioElement;
  }
  AudioBufferOrHTMLMediaElement.prototype._get_isNull_ = function () {
    return this._audioBuffer == null ? this._htmlAudioElement == null : false;
  };
  AudioBufferOrHTMLMediaElement.prototype._get_isNotNull_ = function () {
    return !this._get_isNull_();
  };
  AudioBufferOrHTMLMediaElement.prototype._get_duration_ = function () {
    return !(this._audioBuffer == null) ? this._audioBuffer.duration : !(this._htmlAudioElement == null) ? this._htmlAudioElement.duration : null;
  };
  AudioBufferOrHTMLMediaElement.$metadata$ = {
    simpleName: 'AudioBufferOrHTMLMediaElement',
    kind: 'class',
    interfaces: []
  };
  function clone(_this_) {
    return createAudioElement(_this_.src, _this_.currentTime, _this_.autoplay, _this_.crossOrigin);
  }
  function createAudioElement(src, currentTime, autoplay, crossOrigin) {
    var out = new Audio(src);
    out.crossOrigin = crossOrigin;
    out.currentTime = currentTime;
    out.autoplay = autoplay;
    out.pause();
    return out;
  }
  function createAudioElement$default(src, currentTime, autoplay, crossOrigin, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      currentTime = 0.0;
    if (!(($mask0 & 4) === 0))
      autoplay = false;
    if (!(($mask0 & 8) === 0))
      crossOrigin = 'anonymous';
    return createAudioElement(src, currentTime, autoplay, crossOrigin);
  }
  function _no_name_provided_$factory_150($unlock, $_scratchBuffer) {
    var i = new _no_name_provided__200($unlock, $_scratchBuffer);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_151(this$0, $htmlAudioElement, $audioBuffer) {
    var i = new _no_name_provided__191(this$0, $htmlAudioElement, $audioBuffer);
    return function (p1) {
      i.invoke_282(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_152(this$0, $startTime, resultContinuation) {
    var i = new _no_name_provided__192(this$0, $startTime, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_153($htmlAudioElement, this$0, $audioBuffer) {
    var i = new _no_name_provided__188($htmlAudioElement, this$0, $audioBuffer);
    return function (p1) {
      i.invoke_277(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_154($deferred) {
    var i = new _no_name_provided__189($deferred);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_155($deferred) {
    var i = new _no_name_provided__190($deferred);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_156() {
    var i = new _no_name_provided__194();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_157() {
    var i = new _no_name_provided__195();
    return function (p1) {
      i.invoke_290(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_158($cancelled, $callback) {
    var i = new _no_name_provided__196($cancelled, $callback);
    return function (p1) {
      i.invoke_725(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_159($cancelled) {
    var i = new _no_name_provided__197($cancelled);
    return function (p1) {
      i.invoke_903(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_160($source) {
    var i = new _no_name_provided__193($source);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_161($safe_2_2) {
    var i = new _no_name_provided__198($safe_2_2);
    return function (p1) {
      i.invoke_296(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_162($url, $safe_2_2) {
    var i = new _no_name_provided__199($url, $safe_2_2);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function _get_nativeSoundProvider_() {
    var tmp0_getValue_0 = nativeSoundProvider$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = nativeSoundProvider$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var nativeSoundProvider$delegate;
  function _no_name_provided__201(this$0) {
    this._this$0_44 = this$0;
  }
  _no_name_provided__201.prototype.invoke_302 = function (it) {
    process_0(this._this$0_44, it);
  };
  _no_name_provided__201.prototype.invoke_1015 = function (p1) {
    this.invoke_302(p1 instanceof AudioProcessingEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__201.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_74() {
    Companion_instance_73 = this;
    this._lastId_0 = 0;
  }
  Companion_74.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_73;
  function Companion_getInstance_73() {
    if (Companion_instance_73 == null)
      new Companion_74();
    return Companion_instance_73;
  }
  function process_0($this, e) {
    var tmp = 0;
    var tmp_0 = e.outputBuffer.numberOfChannels;
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = e.outputBuffer.getChannelData(tmp_2);
      tmp = tmp + 1 | 0;
    }
    var outChannels = tmp_1;
    var hasData = true;
    var tmp0_asDynamic_0 = document;
    if (!tmp0_asDynamic_0.hidden) {
      var inductionVariable = 0;
      var last_1 = $this._nchannels;
      if (inductionVariable < last_1)
        do {
          var channel = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var deque = $this._deques[channel];
          var outChannel = outChannels[channel];
          var read_1 = deque.read$default(outChannel, 0, 0, 6, null);
          if (read_1 < outChannel.length)
            hasData = false;
        }
         while (inductionVariable < last_1);
    } else {
    }
    if (!hasData) {
      var tmp1_this = $this;
      var tmp2 = tmp1_this._missingDataCount;
      tmp1_this._missingDataCount = tmp2 + 1 | 0;
      Unit_getInstance();
    }if ($this._missingDataCount >= 500) {
      $this.stop_2();
    }}
  function ensureInit($this) {
    return $this._node_0;
  }
  function _no_name_provided__202(this$0) {
    this._this$0_45 = this$0;
  }
  _no_name_provided__202.prototype.invoke_660 = function (it) {
    var tmp = this._this$0_45;
    var tmp0_safe_receiver = HtmlSimpleSound_getInstance()._ctx_0;
    tmp._node_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createScriptProcessor(1024, 2, 2);
    var tmp1_safe_receiver = this._this$0_45._node_0;
    if (tmp1_safe_receiver == null) {
      Unit_getInstance();
    } else {
      tmp1_safe_receiver.onaudioprocess = _no_name_provided_$factory_165(this._this$0_45);
    }
    if (!(HtmlSimpleSound_getInstance()._ctx_0 == null)) {
      var tmp2_safe_receiver = this._this$0_45._node_0;
      if (tmp2_safe_receiver == null)
        null;
      else
        tmp2_safe_receiver.connect(HtmlSimpleSound_getInstance()._ctx_0.destination);
      Unit_getInstance();
    }};
  _no_name_provided__202.prototype.invoke_1015 = function (p1) {
    this.invoke_660(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__202.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $addCOROUTINE$38(_this_, samples, offset, size_1, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__121 = _this_;
    this._samples_2 = samples;
    this._offset_18 = offset;
    this._size_8 = size_1;
  }
  $addCOROUTINE$38.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            var tmp0_this = this.__this__121;
            tmp0_this._totalShorts = tmp0_this._totalShorts + this._size_8 | 0;
            if (!HtmlSimpleSound_getInstance()._get_available__3()) {
              this._sampleCount0 = this._size_8 / 2 | 0;
              this._timeSeconds1 = this._sampleCount0 / 41000.0;
              this._state_1 = 4;
              var tmp_0 = this.__this__121._get_coroutineContext__22();
              suspendResult = delay_1(tmp_0, Companion_getInstance_27().fromSeconds(this._timeSeconds1), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this.__this__121.ensureRunning();
              this._schannels2 = this._samples_2._channels_2;
              var inductionVariable = 0;
              var last_1 = this.__this__121._nchannels;
              if (inductionVariable < last_1)
                do {
                  var channel = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var sample = this._samples_2.get_137(channel % this._schannels2);
                  var deque = this.__this__121._deques[channel];
                  var inductionVariable_0 = 0;
                  var last_2 = this._size_8;
                  if (inductionVariable_0 < last_2)
                    do {
                      var n = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      write(deque, SampleConvert_getInstance().shortToFloat(sample[this._offset_18 + n | 0]));
                    }
                     while (inductionVariable_0 < last_2);
                }
                 while (inductionVariable < last_1);
              this._state_1 = 1;
              continue $sm;
            }

            break;
          case 1:
            if (!(this.__this__121._deques[0]._get_availableRead__4() > imul(this._samples_2._totalSamples, 4))) {
              this._state_1 = 3;
              continue $sm;
            }
            this._state_1 = 2;
            var tmp_1 = this.__this__121._get_coroutineContext__22();
            var tmp_2 = this;
            tmp_2._tmp0__get_milliseconds__03 = 4;
            suspendResult = delay_1(tmp_1, Companion_getInstance_27().fromMilliseconds(this._tmp0__get_milliseconds__03), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            this._state_1 = 5;
            continue $sm;
          case 4:
            suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return Unit_getInstance();
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $addCOROUTINE$38.$metadata$ = {
    simpleName: '$addCOROUTINE$38',
    kind: 'class',
    interfaces: []
  };
  function JsPlatformAudioOutput(coroutineContext, freq) {
    Companion_getInstance_73();
    PlatformAudioOutput.call(this, coroutineContext, freq);
    this._freq = freq;
    var tmp = this;
    var tmp0_this = Companion_getInstance_73();
    var tmp1 = tmp0_this._lastId_0;
    tmp0_this._lastId_0 = tmp1 + 1 | 0;
    tmp._id_1 = tmp1;
    _get_nativeSoundProvider_().initOnce_0();
    this._missingDataCount = 0;
    this._nodeRunning = false;
    this._node_0 = null;
    this._nchannels = 2;
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = this._nchannels;
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = FloatArrayDeque_init_$Create$(0, 1, null);
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._deques = tmp_3;
    this._startPromise = null;
    this._totalShorts = 0;
  }
  JsPlatformAudioOutput.prototype.start_23 = function () {
    if (this._nodeRunning)
      return Unit_getInstance();
    var tmp = this;
    var tmp_0 = HtmlSimpleSound_getInstance();
    tmp._startPromise = tmp_0.callOnUnlocked(_no_name_provided_$factory_164(this));
    this._missingDataCount = 0;
    this._nodeRunning = true;
  };
  JsPlatformAudioOutput.prototype.stop_2 = function () {
    if (!this._nodeRunning)
      return Unit_getInstance();
    var tmp0_safe_receiver = this._startPromise;
    if (tmp0_safe_receiver == null)
      null;
    else {
      cancel_0(tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._node_0;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.disconnect();
      Unit_getInstance();
    }
    Unit_getInstance();
    this._nodeRunning = false;
  };
  JsPlatformAudioOutput.prototype.ensureRunning = function () {
    ensureInit(this);
    Unit_getInstance();
    if (!this._nodeRunning) {
      this.start_23();
    }};
  JsPlatformAudioOutput.prototype._get_availableSamples__0 = function () {
    return this._totalShorts;
  };
  JsPlatformAudioOutput.prototype.add_43 = function (samples, offset, size_1, $cont) {
    var tmp = new $addCOROUTINE$38(this, samples, offset, size_1, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  JsPlatformAudioOutput.$metadata$ = {
    simpleName: 'JsPlatformAudioOutput',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__203() {
  }
  _no_name_provided__203.prototype.invoke_1005 = function () {
    return new HtmlNativeSoundProvider();
  };
  _no_name_provided__203.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function nativeSoundProvider$factory() {
    return getPropertyCallableRef('nativeSoundProvider', 0, KProperty0, function () {
      return _get_nativeSoundProvider_();
    }, null);
  }
  function _no_name_provided_$factory_163() {
    var i = new _no_name_provided__203();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_164(this$0) {
    var i = new _no_name_provided__202(this$0);
    return function (p1) {
      i.invoke_660(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_165(this$0) {
    var i = new _no_name_provided__201(this$0);
    return function (p1) {
      i.invoke_302(p1);
      return Unit_getInstance();
    };
  }
  function Companion_75() {
    Companion_instance_74 = this;
    this._TOP_LEFT = new Anchor(0.0, 0.0);
    this._TOP_CENTER = new Anchor(0.5, 0.0);
    this._TOP_RIGHT = new Anchor(1.0, 0.0);
    this._MIDDLE_LEFT = new Anchor(0.0, 0.5);
    this._MIDDLE_CENTER = new Anchor(0.5, 0.5);
    this._MIDDLE_RIGHT = new Anchor(1.0, 0.5);
    this._BOTTOM_LEFT = new Anchor(0.0, 1.0);
    this._BOTTOM_CENTER = new Anchor(0.5, 1.0);
    this._BOTTOM_RIGHT = new Anchor(1.0, 1.0);
  }
  Companion_75.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_74;
  function Companion_getInstance_74() {
    if (Companion_instance_74 == null)
      new Companion_75();
    return Companion_instance_74;
  }
  function Anchor(sx, sy) {
    Companion_getInstance_74();
    this._sx = sx;
    this._sy = sy;
  }
  Anchor.prototype.toString = function () {
    return '' + 'Anchor(sx=' + this._sx + ', sy=' + this._sy + ')';
  };
  Anchor.prototype.hashCode = function () {
    var result = getNumberHashCode(this._sx);
    result = imul(result, 31) + getNumberHashCode(this._sy) | 0;
    return result;
  };
  Anchor.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Anchor ? other : THROW_CCE();
    if (!equals_1(this._sx, tmp0_other_with_cast._sx))
      return false;
    if (!equals_1(this._sy, tmp0_other_with_cast._sy))
      return false;
    return true;
  };
  Anchor.$metadata$ = {
    simpleName: 'Anchor',
    kind: 'class',
    interfaces: [Interpolable]
  };
  function _Angle___init__impl_(radians) {
    return radians;
  }
  function _Angle___get_radians__impl_(this_0) {
    return this_0;
  }
  function Angle__toString_impl(this_0) {
    return '' + _get_degrees_(this_0) + '.degrees';
  }
  function Companion_76() {
    Companion_instance_75 = this;
    this._ZERO_2 = _Angle___init__impl_(0.0);
    this._PI2 = 6.283185307179586;
    this._DEG2RAD = 0.017453292519943295;
    this._RAD2DEG = 57.29577951308232;
    this._MAX_DEGREES = 360.0;
    this._MAX_RADIANS = 6.283185307179586;
    this._HALF_DEGREES = 180.0;
    this._HALF_RADIANS = 3.141592653589793;
  }
  Companion_76.prototype.fromRadians = function (radians) {
    return _Angle___init__impl_(radians);
  };
  Companion_76.prototype.fromDegrees = function (degrees) {
    return _Angle___init__impl_(this.degreesToRadians(degrees));
  };
  Companion_76.prototype.fromRadians_0 = function (radians) {
    return this.fromRadians(radians);
  };
  Companion_76.prototype.fromDegrees_0 = function (degrees) {
    return this.fromDegrees(degrees);
  };
  Companion_76.prototype.degreesToRadians = function (degrees) {
    return degrees * 0.017453292519943295;
  };
  Companion_76.prototype.radiansToDegrees = function (radians) {
    return radians * 57.29577951308232;
  };
  Companion_76.prototype.between = function (x0, y0, x1, y1) {
    var tmp0_atan2_0 = y1 - y0;
    var tmp1_atan2_0 = x1 - x0;
    var angle_0 = Math.atan2(tmp0_atan2_0, tmp1_atan2_0);
    return angle_0 < 0.0 ? _Angle___init__impl_(angle_0 + 6.283185307179586) : _Angle___init__impl_(angle_0);
  };
  Companion_76.prototype.between_0 = function (x0, y0, x1, y1) {
    return this.between(x0, y0, x1, y1);
  };
  Companion_76.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_75;
  function Companion_getInstance_75() {
    if (Companion_instance_75 == null)
      new Companion_76();
    return Companion_instance_75;
  }
  function Angle__compareTo_impl(this_0, other) {
    return compareTo(_Angle___get_radians__impl_(this_0), _Angle___get_radians__impl_(other));
  }
  function Angle__compareTo_impl_0(this_0, other) {
    var tmp = this_0._radians;
    return Angle__compareTo_impl(tmp, other instanceof Angle ? other._radians : THROW_CCE());
  }
  function Angle__hashCode_impl(this_0) {
    return getNumberHashCode(this_0);
  }
  function Angle__equals_impl(this_0, other) {
    if (!(other instanceof Angle))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Angle ? other._radians : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function Angle(radians) {
    Companion_getInstance_75();
    this._radians = radians;
  }
  Angle.prototype.toString = function () {
    return Angle__toString_impl(this._radians);
  };
  Angle.prototype.compareTo_36 = function (other) {
    return Angle__compareTo_impl(this._radians, other);
  };
  Angle.prototype.compareTo_71 = function (other) {
    return Angle__compareTo_impl_0(this, other);
  };
  Angle.prototype.hashCode = function () {
    return Angle__hashCode_impl(this._radians);
  };
  Angle.prototype.equals = function (other) {
    return Angle__equals_impl(this._radians, other);
  };
  Angle.$metadata$ = {
    simpleName: 'Angle',
    kind: 'class',
    interfaces: [Comparable]
  };
  function _get_degrees_(_this_) {
    return Companion_getInstance_75().radiansToDegrees(_Angle___get_radians__impl_(_this_));
  }
  function plus_5(_this_, other) {
    return _Angle___init__impl_(_Angle___get_radians__impl_(_this_) + _Angle___get_radians__impl_(other));
  }
  function _get_degrees__0(_this_) {
    return Companion_getInstance_75().fromDegrees_0(_this_);
  }
  function _get_cosine_(_this_) {
    var tmp0_cos_0_1 = _Angle___get_radians__impl_(_this_);
    return Math.cos(tmp0_cos_0_1);
  }
  function _get_sine_(_this_) {
    var tmp0_sin_0_1 = _Angle___get_radians__impl_(_this_);
    return Math.sin(tmp0_sin_0_1);
  }
  function _get_radians_(_this_) {
    return Companion_getInstance_75().fromRadians(_this_);
  }
  function _get_radians__0(_this_) {
    return Companion_getInstance_75().fromRadians_0(_this_);
  }
  function unaryMinus(_this_) {
    return _Angle___init__impl_(-_Angle___get_radians__impl_(_this_));
  }
  function minus_2(_this_, other) {
    return _Angle___init__impl_(_Angle___get_radians__impl_(_this_) - _Angle___get_radians__impl_(other));
  }
  function div(_this_, other) {
    return _Angle___get_radians__impl_(_this_) / _Angle___get_radians__impl_(other);
  }
  function _get_absoluteValue_(_this_) {
    var tmp = Companion_getInstance_75();
    var tmp0__get_absoluteValue__0 = _Angle___get_radians__impl_(_this_);
    return tmp.fromRadians(Math.abs(tmp0__get_absoluteValue__0));
  }
  function times(_this_, scale_1) {
    return _Angle___init__impl_(_Angle___get_radians__impl_(_this_) * scale_1);
  }
  function unaryPlus(_this_) {
    return _Angle___init__impl_(+_Angle___get_radians__impl_(_this_));
  }
  function times_0(_this_, scale_1) {
    return times(_this_, scale_1);
  }
  function Companion_77() {
    Companion_instance_76 = this;
    this._MIN = -Infinity;
    this._MAX = Infinity;
  }
  Companion_77.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_76;
  function Companion_getInstance_76() {
    if (Companion_instance_76 == null)
      new Companion_77();
    return Companion_instance_76;
  }
  function BoundsBuilder() {
    Companion_getInstance_76();
    this._tempRect = Companion_getInstance_83().invoke_1005();
    this._npoints = 0;
    this._xmin = Companion_getInstance_76()._MAX;
    this._xmax = Companion_getInstance_76()._MIN;
    this._ymin = Companion_getInstance_76()._MAX;
    this._ymax = Companion_getInstance_76()._MIN;
  }
  BoundsBuilder.prototype.reset_9 = function () {
    this._xmin = Companion_getInstance_76()._MAX;
    this._xmax = Companion_getInstance_76()._MIN;
    this._ymin = Companion_getInstance_76()._MAX;
    this._ymax = Companion_getInstance_76()._MIN;
    this._npoints = 0;
  };
  BoundsBuilder.prototype.add_52 = function (x, y) {
    if (x < this._xmin)
      this._xmin = x;
    if (x > this._xmax)
      this._xmax = x;
    if (y < this._ymin)
      this._ymin = y;
    if (y > this._ymax)
      this._ymax = y;
    var tmp0_this = this;
    var tmp1 = tmp0_this._npoints;
    tmp0_this._npoints = tmp1 + 1 | 0;
    Unit_getInstance();
    return this;
  };
  BoundsBuilder.prototype.add_45 = function (x, y, transform) {
    return this.add_52(transform.transformX(x, y), transform.transformY(x, y));
  };
  BoundsBuilder.prototype.add_46 = function (rect_1) {
    if (rect_1._get_isNotEmpty_()) {
      this.add_52(rect_1._get_left__4(), rect_1._get_top__4());
      Unit_getInstance();
      this.add_52(rect_1._get_right__2(), rect_1._get_bottom__2());
      Unit_getInstance();
    }return this;
  };
  BoundsBuilder.prototype.add_47 = function (rect_1, transform) {
    if (rect_1._get_isNotEmpty_()) {
      this.add_45(rect_1._get_left__4(), rect_1._get_top__4(), transform);
      Unit_getInstance();
      this.add_45(rect_1._get_right__2(), rect_1._get_bottom__2(), transform);
      Unit_getInstance();
    }return this;
  };
  BoundsBuilder.prototype.getBoundsOrNull = function (out) {
    return this._npoints === 0 ? null : out.setBounds(this._xmin, this._ymin, this._xmax, this._ymax);
  };
  BoundsBuilder.prototype.getBounds_0 = function (out) {
    if (this.getBoundsOrNull(out) == null) {
      out.setBounds_0(0, 0, 0, 0);
      Unit_getInstance();
    }return out;
  };
  BoundsBuilder.prototype.getBounds$default = function (out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      out = Companion_getInstance_83().invoke_1005();
    return this.getBounds_0(out);
  };
  BoundsBuilder.$metadata$ = {
    simpleName: 'BoundsBuilder',
    kind: 'class',
    interfaces: []
  };
  var Type_IDENTITY_instance;
  var Type_TRANSLATE_instance;
  var Type_SCALE_instance;
  var Type_SCALE_TRANSLATE_instance;
  var Type_COMPLEX_instance;
  var Type_entriesInitialized_0;
  function Type_initEntries_0() {
    if (Type_entriesInitialized_0)
      return Unit_getInstance();
    Type_entriesInitialized_0 = true;
    Type_IDENTITY_instance = new Type_0('IDENTITY', 0, 1, false, false, false);
    Type_TRANSLATE_instance = new Type_0('TRANSLATE', 1, 2, false, false, true);
    Type_SCALE_instance = new Type_0('SCALE', 2, 3, false, true, false);
    Type_SCALE_TRANSLATE_instance = new Type_0('SCALE_TRANSLATE', 3, 4, false, true, true);
    Type_COMPLEX_instance = new Type_0('COMPLEX', 4, 5, true, true, true);
  }
  function Transform_init_$Init$(x, y, scaleX, scaleY, skewX, skewY, rotation, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0.0;
    if (!(($mask0 & 2) === 0))
      y = 0.0;
    if (!(($mask0 & 4) === 0))
      scaleX = 1.0;
    if (!(($mask0 & 8) === 0))
      scaleY = 1.0;
    if (!(($mask0 & 16) === 0))
      skewX = _get_radians__0(0);
    if (!(($mask0 & 32) === 0))
      skewY = _get_radians__0(0);
    if (!(($mask0 & 64) === 0))
      rotation = _get_radians__0(0);
    Transform.call($this, x, y, scaleX, scaleY, skewX, skewY, rotation);
    return $this;
  }
  function Transform_init_$Create$(x, y, scaleX, scaleY, skewX, skewY, rotation, $mask0, $marker) {
    return Transform_init_$Init$(x, y, scaleX, scaleY, skewX, skewY, rotation, $mask0, $marker, Object.create(Transform.prototype));
  }
  function Matrix_init_$Init$(a, b, c, d, tx, ty, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      a = 1.0;
    if (!(($mask0 & 2) === 0))
      b = 0.0;
    if (!(($mask0 & 4) === 0))
      c = 0.0;
    if (!(($mask0 & 8) === 0))
      d = 1.0;
    if (!(($mask0 & 16) === 0))
      tx = 0.0;
    if (!(($mask0 & 32) === 0))
      ty = 0.0;
    Matrix.call($this, a, b, c, d, tx, ty);
    return $this;
  }
  function Matrix_init_$Create$(a, b, c, d, tx, ty, $mask0, $marker) {
    return Matrix_init_$Init$(a, b, c, d, tx, ty, $mask0, $marker, Object.create(Matrix.prototype));
  }
  function Companion_78() {
    Companion_instance_77 = this;
  }
  Companion_78.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_77;
  function Companion_getInstance_77() {
    if (Companion_instance_77 == null)
      new Companion_78();
    return Companion_instance_77;
  }
  function Type_0(name, ordinal, id, hasRotation, hasScale, hasTranslation) {
    Enum.call(this, name, ordinal);
    this._id_2 = id;
    this._hasRotation = hasRotation;
    this._hasScale = hasScale;
    this._hasTranslation = hasTranslation;
  }
  Type_0.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Transform(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    this._x_1 = x;
    this._y_1 = y;
    this._scaleX = scaleX;
    this._scaleY = scaleY;
    this._skewX = skewX;
    this._skewY = skewY;
    this._rotation = rotation;
  }
  Transform.prototype._get_x__36 = function () {
    return this._x_1;
  };
  Transform.prototype._get_y__36 = function () {
    return this._y_1;
  };
  Transform.prototype._get_xf_ = function () {
    return this._x_1;
  };
  Transform.prototype._get_yf_ = function () {
    return this._y_1;
  };
  Transform.prototype._get_scaleAvg_ = function () {
    return (this._scaleX + this._scaleY) * 0.5;
  };
  Transform.prototype.setMatrix_0 = function (matrix) {
    var PI_4 = 0.7853981633974483;
    this._x_1 = matrix._tx;
    this._y_1 = matrix._ty;
    var tmp = this;
    var tmp0_atan_0 = -matrix._c / matrix._d;
    tmp._skewX = _get_radians_(Math.atan(tmp0_atan_0));
    var tmp_0 = this;
    var tmp1_atan_0 = matrix._b / matrix._a;
    tmp_0._skewY = _get_radians_(Math.atan(tmp1_atan_0));
    if (!equals_1(new Angle(this._skewX), new Angle(this._skewX)))
      this._skewX = _get_radians_(0.0);
    if (!equals_1(new Angle(this._skewY), new Angle(this._skewY)))
      this._skewY = _get_radians_(0.0);
    var tmp_1 = this;
    var tmp_2;
    if (Angle__compareTo_impl(this._skewX, unaryMinus(_get_radians_(PI_4))) > 0 ? Angle__compareTo_impl(this._skewX, _get_radians_(PI_4)) < 0 : false) {
      var tmp_3 = matrix._d;
      var tmp2_cos_0 = this._skewX;
      var tmp0_cos_0_1 = _Angle___get_radians__impl_(tmp2_cos_0);
      tmp_2 = tmp_3 / Math.cos(tmp0_cos_0_1);
    } else {
      var tmp_4 = -matrix._c;
      var tmp3_sin_0 = this._skewX;
      var tmp0_sin_0_1 = _Angle___get_radians__impl_(tmp3_sin_0);
      tmp_2 = tmp_4 / Math.sin(tmp0_sin_0_1);
    }
    tmp_1._scaleY = tmp_2;
    var tmp_5 = this;
    var tmp_6;
    if (Angle__compareTo_impl(this._skewY, unaryMinus(_get_radians_(PI_4))) > 0 ? Angle__compareTo_impl(this._skewY, _get_radians_(PI_4)) < 0 : false) {
      var tmp_7 = matrix._a;
      var tmp4_cos_0 = this._skewY;
      var tmp0_cos_0_1_0 = _Angle___get_radians__impl_(tmp4_cos_0);
      tmp_6 = tmp_7 / Math.cos(tmp0_cos_0_1_0);
    } else {
      var tmp_8 = matrix._b;
      var tmp5_sin_0 = this._skewY;
      var tmp0_sin_0_1_0 = _Angle___get_radians__impl_(tmp5_sin_0);
      tmp_6 = tmp_8 / Math.sin(tmp0_sin_0_1_0);
    }
    tmp_5._scaleX = tmp_6;
    var tmp6_abs_0 = minus_2(this._skewX, this._skewY);
    var tmp_9 = Companion_getInstance_75();
    var tmp0__get_absoluteValue__0_1 = _Angle___get_radians__impl_(tmp6_abs_0);
    if (_Angle___get_radians__impl_(tmp_9.fromRadians(Math.abs(tmp0__get_absoluteValue__0_1))) < 1.0E-4) {
      this._rotation = this._skewX;
      this._skewX = _get_radians_(0.0);
      this._skewY = _get_radians_(0.0);
    } else {
      {
        this._rotation = _get_radians__0(0);
      }
    }
    return this;
  };
  Transform.prototype.toString = function () {
    return '' + 'Transform(x=' + this._x_1 + ', y=' + this._y_1 + ', scaleX=' + this._scaleX + ', scaleY=' + this._scaleY + ', skewX=' + new Angle(this._skewX) + ', skewY=' + new Angle(this._skewY) + ', rotation=' + new Angle(this._rotation) + ')';
  };
  Transform.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_1);
    result = imul(result, 31) + getNumberHashCode(this._y_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scaleX) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scaleY) | 0;
    result = imul(result, 31) + Angle__hashCode_impl(this._skewX) | 0;
    result = imul(result, 31) + Angle__hashCode_impl(this._skewY) | 0;
    result = imul(result, 31) + Angle__hashCode_impl(this._rotation) | 0;
    return result;
  };
  Transform.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Transform))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Transform ? other : THROW_CCE();
    if (!equals_1(this._x_1, tmp0_other_with_cast._x_1))
      return false;
    if (!equals_1(this._y_1, tmp0_other_with_cast._y_1))
      return false;
    if (!equals_1(this._scaleX, tmp0_other_with_cast._scaleX))
      return false;
    if (!equals_1(this._scaleY, tmp0_other_with_cast._scaleY))
      return false;
    if (!equals_1(new Angle(this._skewX), new Angle(tmp0_other_with_cast._skewX)))
      return false;
    if (!equals_1(new Angle(this._skewY), new Angle(tmp0_other_with_cast._skewY)))
      return false;
    if (!equals_1(new Angle(this._rotation), new Angle(tmp0_other_with_cast._rotation)))
      return false;
    return true;
  };
  Transform.$metadata$ = {
    simpleName: 'Transform',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable, XY, XYf]
  };
  function Type_IDENTITY_getInstance() {
    Type_initEntries_0();
    return Type_IDENTITY_instance;
  }
  function Type_TRANSLATE_getInstance() {
    Type_initEntries_0();
    return Type_TRANSLATE_instance;
  }
  function Type_SCALE_getInstance() {
    Type_initEntries_0();
    return Type_SCALE_instance;
  }
  function Type_SCALE_TRANSLATE_getInstance() {
    Type_initEntries_0();
    return Type_SCALE_TRANSLATE_instance;
  }
  function Type_COMPLEX_getInstance() {
    Type_initEntries_0();
    return Type_COMPLEX_instance;
  }
  function Matrix(a, b, c, d, tx, ty) {
    Companion_getInstance_77();
    this._a = a;
    this._b = b;
    this._c = c;
    this._d = d;
    this._tx = tx;
    this._ty = ty;
  }
  Matrix.prototype._get_af_ = function () {
    return this._a;
  };
  Matrix.prototype._get_bf_ = function () {
    return this._b;
  };
  Matrix.prototype._get_cf_ = function () {
    return this._c;
  };
  Matrix.prototype._get_df_ = function () {
    return this._d;
  };
  Matrix.prototype._get_txf_ = function () {
    return this._tx;
  };
  Matrix.prototype._get_tyf_ = function () {
    return this._ty;
  };
  Matrix.prototype.getType = function () {
    var hasRotation = !(this._b === 0.0) ? true : !(this._c === 0.0);
    var hasScale = !(this._a === 1.0) ? true : !(this._d === 1.0);
    var hasTranslation = !(this._tx === 0.0) ? true : !(this._ty === 0.0);
    return hasRotation ? Type_COMPLEX_getInstance() : (hasScale ? hasTranslation : false) ? Type_SCALE_TRANSLATE_getInstance() : hasScale ? Type_SCALE_getInstance() : hasTranslation ? Type_TRANSLATE_getInstance() : Type_IDENTITY_getInstance();
  };
  Matrix.prototype.setTo = function (a, b, c, d, tx, ty) {
    this._a = a;
    this._b = b;
    this._c = c;
    this._d = d;
    this._tx = tx;
    this._ty = ty;
    return this;
  };
  Matrix.prototype.copyFrom = function (that) {
    if (!(that == null)) {
      this.setTo(that._a, that._b, that._c, that._d, that._tx, that._ty);
      Unit_getInstance();
    } else {
      this.identity_0();
      Unit_getInstance();
    }
    return this;
  };
  Matrix.prototype.rotate_1 = function (angle_0) {
    var theta_2 = _Angle___get_radians__impl_(angle_0);
    var cos_3 = Math.cos(theta_2);
    var sin_4 = Math.sin(theta_2);
    var a1_5 = this._a * cos_3 - this._b * sin_4;
    this._b = this._a * sin_4 + this._b * cos_3;
    this._a = a1_5;
    var c1_6 = this._c * cos_3 - this._d * sin_4;
    this._d = this._c * sin_4 + this._d * cos_3;
    this._c = c1_6;
    var tx1_7 = this._tx * cos_3 - this._ty * sin_4;
    this._ty = this._tx * sin_4 + this._ty * cos_3;
    this._tx = tx1_7;
    return this;
  };
  Matrix.prototype.skew = function (skewX, skewY) {
    var tmp0_sin_0_1 = _Angle___get_radians__impl_(skewX);
    var sinX = Math.sin(tmp0_sin_0_1);
    var tmp0_cos_0_1 = _Angle___get_radians__impl_(skewX);
    var cosX = Math.cos(tmp0_cos_0_1);
    var tmp0_sin_0_1_0 = _Angle___get_radians__impl_(skewY);
    var sinY = Math.sin(tmp0_sin_0_1_0);
    var tmp0_cos_0_1_0 = _Angle___get_radians__impl_(skewY);
    var cosY = Math.cos(tmp0_cos_0_1_0);
    return this.setTo(this._a * cosY - this._b * sinX, this._a * sinY + this._b * cosX, this._c * cosY - this._d * sinX, this._c * sinY + this._d * cosX, this._tx * cosY - this._ty * sinX, this._tx * sinY + this._ty * cosX);
  };
  Matrix.prototype.scale_2 = function (sx, sy) {
    return this.setTo(this._a * sx, this._b * sx, this._c * sy, this._d * sy, this._tx * sx, this._ty * sy);
  };
  Matrix.prototype.scale_1 = function (sx, sy) {
    return this.scale_2(sx, sy);
  };
  Matrix.prototype.prescale = function (sx, sy) {
    return this.setTo(this._a * sx, this._b * sx, this._c * sy, this._d * sy, this._tx, this._ty);
  };
  Matrix.prototype.translate_2 = function (dx, dy) {
    var tmp0_this_2 = this;
    tmp0_this_2._tx = tmp0_this_2._tx + dx;
    var tmp1_this_3 = this;
    tmp1_this_3._ty = tmp1_this_3._ty + dy;
    return this;
  };
  Matrix.prototype.translate_1 = function (dx, dy) {
    return this.translate_2(dx, dy);
  };
  Matrix.prototype.pretranslate = function (dx, dy) {
    var tmp0_this_2 = this;
    tmp0_this_2._tx = tmp0_this_2._tx + (this._a * dx + this._c * dy);
    var tmp1_this_3 = this;
    tmp1_this_3._ty = tmp1_this_3._ty + (this._b * dx + this._d * dy);
    return this;
  };
  Matrix.prototype.prerotate = function (angle_0) {
    var m_2 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    m_2.rotate_1(angle_0);
    Unit_getInstance();
    this.premultiply(m_2);
    Unit_getInstance();
    return this;
  };
  Matrix.prototype.premultiply = function (m) {
    return this.premultiply_0(m._a, m._b, m._c, m._d, m._tx, m._ty);
  };
  Matrix.prototype.postmultiply = function (m) {
    return this.multiply_0(this, m);
  };
  Matrix.prototype.premultiply_0 = function (la, lb, lc, ld, ltx, lty) {
    return this.setTo(la * this._a + lb * this._c, la * this._b + lb * this._d, lc * this._a + ld * this._c, lc * this._b + ld * this._d, ltx * this._a + lty * this._c + this._tx, ltx * this._b + lty * this._d + this._ty);
  };
  Matrix.prototype.multiply_0 = function (l, r) {
    return this.setTo(l._a * r._a + l._b * r._c, l._a * r._b + l._b * r._d, l._c * r._a + l._d * r._c, l._c * r._b + l._d * r._d, l._tx * r._a + l._ty * r._c + r._tx, l._tx * r._b + l._ty * r._d + r._ty);
  };
  Matrix.prototype.identity_0 = function () {
    return this.setTo(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
  };
  Matrix.prototype.isIdentity_0 = function () {
    return this.getType().equals(Type_IDENTITY_getInstance());
  };
  Matrix.prototype.invert = function (matrixToInvert) {
    var src = matrixToInvert;
    var dst = this;
    var norm = src._a * src._d - src._b * src._c;
    if (norm === 0.0) {
      dst.setTo(0.0, 0.0, 0.0, 0.0, -src._tx, -src._ty);
      Unit_getInstance();
    } else {
      var inorm = 1.0 / norm;
      var d = src._a * inorm;
      var a = src._d * inorm;
      var b = src._b * -inorm;
      var c = src._c * -inorm;
      dst.setTo(a, b, c, d, -a * src._tx - c * src._ty, -b * src._tx - d * src._ty);
      Unit_getInstance();
    }
    return this;
  };
  Matrix.prototype.inverted = function (out) {
    return out.invert(this);
  };
  Matrix.prototype.inverted$default = function (out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      out = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }return this.inverted(out);
  };
  Matrix.prototype.setTransform_0 = function (x, y, scaleX, scaleY, rotation, skewX, skewY) {
    if (equals_1(new Angle(skewX), new Angle(_get_radians_(0.0))) ? equals_1(new Angle(skewY), new Angle(_get_radians_(0.0))) : false) {
      if (equals_1(new Angle(rotation), new Angle(_get_radians__0(0)))) {
        this.setTo(scaleX, 0.0, 0.0, scaleY, x, y);
        Unit_getInstance();
      } else {
        var tmp0_cos_0_1 = _Angle___get_radians__impl_(rotation);
        var cos = Math.cos(tmp0_cos_0_1);
        var tmp0_sin_0_1 = _Angle___get_radians__impl_(rotation);
        var sin = Math.sin(tmp0_sin_0_1);
        this.setTo(cos * scaleX, sin * scaleY, -sin * scaleX, cos * scaleY, x, y);
        Unit_getInstance();
      }
    } else {
      this.identity_0();
      Unit_getInstance();
      this.scale_2(scaleX, scaleY);
      Unit_getInstance();
      this.skew(skewX, skewY);
      Unit_getInstance();
      this.rotate_1(rotation);
      Unit_getInstance();
      this.translate_2(x, y);
      Unit_getInstance();
    }
    return this;
  };
  Matrix.prototype.clone_8 = function () {
    return new Matrix(this._a, this._b, this._c, this._d, this._tx, this._ty);
  };
  Matrix.prototype.toTransform = function (out) {
    return out.setMatrix_0(this);
  };
  Matrix.prototype.toTransform$default = function (out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      out = Transform_init_$Create$(0.0, 0.0, 0.0, 0.0, null, null, null, 127, null);
    }return this.toTransform(out);
  };
  Matrix.prototype.transform_3 = function (px, py, out) {
    return out.setTo_0(this.transformX(px, py), this.transformY(px, py));
  };
  Matrix.prototype.transformX = function (px, py) {
    return this._a * px + this._c * py + this._tx;
  };
  Matrix.prototype.transformY = function (px, py) {
    return this._d * py + this._b * px + this._ty;
  };
  Matrix.prototype.transformXf = function (px, py) {
    return this.transformX(px, py);
  };
  Matrix.prototype.transformYf = function (px, py) {
    return this.transformY(px, py);
  };
  Matrix.prototype.toString = function () {
    return '' + 'Matrix(a=' + this._a + ', b=' + this._b + ', c=' + this._c + ', d=' + this._d + ', tx=' + this._tx + ', ty=' + this._ty + ')';
  };
  Matrix.prototype.copy_5 = function (a, b, c, d, tx, ty) {
    return new Matrix(a, b, c, d, tx, ty);
  };
  Matrix.prototype.copy$default_4 = function (a, b, c, d, tx, ty, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      a = this._a;
    if (!(($mask0 & 2) === 0))
      b = this._b;
    if (!(($mask0 & 4) === 0))
      c = this._c;
    if (!(($mask0 & 8) === 0))
      d = this._d;
    if (!(($mask0 & 16) === 0))
      tx = this._tx;
    if (!(($mask0 & 32) === 0))
      ty = this._ty;
    return this.copy_5(a, b, c, d, tx, ty);
  };
  Matrix.prototype.hashCode = function () {
    var result = getNumberHashCode(this._a);
    result = imul(result, 31) + getNumberHashCode(this._b) | 0;
    result = imul(result, 31) + getNumberHashCode(this._c) | 0;
    result = imul(result, 31) + getNumberHashCode(this._d) | 0;
    result = imul(result, 31) + getNumberHashCode(this._tx) | 0;
    result = imul(result, 31) + getNumberHashCode(this._ty) | 0;
    return result;
  };
  Matrix.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals_1(this._a, tmp0_other_with_cast._a))
      return false;
    if (!equals_1(this._b, tmp0_other_with_cast._b))
      return false;
    if (!equals_1(this._c, tmp0_other_with_cast._c))
      return false;
    if (!equals_1(this._d, tmp0_other_with_cast._d))
      return false;
    if (!equals_1(this._tx, tmp0_other_with_cast._tx))
      return false;
    if (!equals_1(this._ty, tmp0_other_with_cast._ty))
      return false;
    return true;
  };
  Matrix.$metadata$ = {
    simpleName: 'Matrix',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable]
  };
  var tempMat3D;
  var tempVec1;
  var tempVec2;
  var tempVec3;
  var tempMat1;
  function Companion_79() {
    Companion_instance_78 = this;
    this._M00 = 0;
    this._M10 = 1;
    this._M20 = 2;
    this._M30 = 3;
    this._M01 = 4;
    this._M11 = 5;
    this._M21 = 6;
    this._M31 = 7;
    this._M02 = 8;
    this._M12 = 9;
    this._M22 = 10;
    this._M32 = 11;
    this._M03 = 12;
    this._M13 = 13;
    this._M23 = 14;
    this._M33 = 15;
  }
  Companion_79.prototype.rowMajorIndex = function (row, column) {
    return imul(row, 4) + column | 0;
  };
  Companion_79.prototype.columnMajorIndex = function (row, column) {
    return imul(column, 4) + row | 0;
  };
  Companion_79.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_78;
  function Companion_getInstance_78() {
    if (Companion_instance_78 == null)
      new Companion_79();
    return Companion_instance_78;
  }
  function Matrix3D() {
    Companion_getInstance_78();
    var tmp = this;
    var tmp0_floatArrayOf_0 = new Float32Array([1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0]);
    tmp._data_35 = tmp0_floatArrayOf_0;
  }
  Matrix3D.prototype.get_88 = function (row, column) {
    return this._data_35[Companion_getInstance_78().columnMajorIndex(row, column)];
  };
  Matrix3D.prototype.setRows = function (a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, a30, a31, a32, a33) {
    this._data_35[0] = a00;
    this._data_35[4] = a01;
    this._data_35[8] = a02;
    this._data_35[12] = a03;
    this._data_35[1] = a10;
    this._data_35[5] = a11;
    this._data_35[9] = a12;
    this._data_35[13] = a13;
    this._data_35[2] = a20;
    this._data_35[6] = a21;
    this._data_35[10] = a22;
    this._data_35[14] = a23;
    this._data_35[3] = a30;
    this._data_35[7] = a31;
    this._data_35[11] = a32;
    this._data_35[15] = a33;
    return this;
  };
  Matrix3D.prototype.setColumns = function (a00, a10, a20, a30, a01, a11, a21, a31, a02, a12, a22, a32, a03, a13, a23, a33) {
    this._data_35[0] = a00;
    this._data_35[4] = a01;
    this._data_35[8] = a02;
    this._data_35[12] = a03;
    this._data_35[1] = a10;
    this._data_35[5] = a11;
    this._data_35[9] = a12;
    this._data_35[13] = a13;
    this._data_35[2] = a20;
    this._data_35[6] = a21;
    this._data_35[10] = a22;
    this._data_35[14] = a23;
    this._data_35[3] = a30;
    this._data_35[7] = a31;
    this._data_35[11] = a32;
    this._data_35[15] = a33;
    return this;
  };
  Matrix3D.prototype.identity_0 = function () {
    return this.setColumns(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  };
  Matrix3D.prototype.copyFrom_0 = function (that) {
    var inductionVariable = 0;
    if (inductionVariable < 16)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._data_35[n] = that._data_35[n];
      }
       while (inductionVariable < 16);
    return this;
  };
  Matrix3D.prototype.setToOrtho = function (left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx = -(right + left) / (right - left);
    var ty = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return this.setRows(sx, 0.0, 0.0, tx, 0.0, sy, 0.0, ty, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  };
  Matrix3D.prototype.setToOrtho_0 = function (rect_1, near, far) {
    return this.setToOrtho_1(rect_1._get_left__4(), rect_1._get_right__2(), rect_1._get_bottom__2(), rect_1._get_top__4(), near, far);
  };
  Matrix3D.prototype.setToOrtho_1 = function (left, right, bottom, top, near, far) {
    return this.setToOrtho(left, right, bottom, top, near, far);
  };
  Matrix3D.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Matrix3D) {
      tmp = contentEquals_3(this._data_35, other._data_35);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Matrix3D.prototype.hashCode = function () {
    return contentHashCode_3(this._data_35);
  };
  Matrix3D.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_5('Matrix3D(\n');
    Unit_getInstance();
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_apply_0_1.append_5('  [ ');
        Unit_getInstance();
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col_6 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col_6 === 0)) {
              tmp0_apply_0_1.append_5(', ');
              Unit_getInstance();
            }var v_7 = this.get_88(row_4, col_6);
            if (Math.floor(v_7) === v_7) {
              tmp0_apply_0_1.append_4(numberToInt(v_7));
              Unit_getInstance();
            } else {
              {
                tmp0_apply_0_1.append_4(v_7);
                Unit_getInstance();
              }
            }
          }
           while (inductionVariable_0 < 4);
        tmp0_apply_0_1.append_5(' ],\n');
        Unit_getInstance();
      }
       while (inductionVariable < 4);
    tmp0_apply_0_1.append_5(')');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  Matrix3D.$metadata$ = {
    simpleName: 'Matrix3D',
    kind: 'class',
    interfaces: []
  };
  var MajorOrder_ROW_instance;
  var MajorOrder_COLUMN_instance;
  var MajorOrder_entriesInitialized;
  function MajorOrder_initEntries() {
    if (MajorOrder_entriesInitialized)
      return Unit_getInstance();
    MajorOrder_entriesInitialized = true;
    MajorOrder_ROW_instance = new MajorOrder('ROW', 0);
    MajorOrder_COLUMN_instance = new MajorOrder('COLUMN', 1);
  }
  function MajorOrder(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  MajorOrder.$metadata$ = {
    simpleName: 'MajorOrder',
    kind: 'class',
    interfaces: []
  };
  function setRows(_this_, a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, a30, a31, a32, a33) {
    return _this_.setRows(a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, a30, a31, a32, a33);
  }
  function copyToFloatWxH(_this_, out, rows, columns, order, offset) {
    var n = offset;
    if (order.equals(MajorOrder_ROW_getInstance())) {
      var inductionVariable = 0;
      if (inductionVariable < columns)
        do {
          var column = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < rows)
            do {
              var row = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp2 = n;
              n = tmp2 + 1 | 0;
              out[tmp2] = _this_._data_35[Companion_getInstance_78().rowMajorIndex(row, column)];
            }
             while (inductionVariable_0 < rows);
        }
         while (inductionVariable < columns);
    } else {
      var inductionVariable_1 = 0;
      if (inductionVariable_1 < columns)
        do {
          var column_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < rows)
            do {
              var row_0 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var tmp5 = n;
              n = tmp5 + 1 | 0;
              out[tmp5] = _this_._data_35[Companion_getInstance_78().columnMajorIndex(row_0, column_0)];
            }
             while (inductionVariable_2 < rows);
        }
         while (inductionVariable_1 < columns);
    }
  }
  function MajorOrder_ROW_getInstance() {
    MajorOrder_initEntries();
    return MajorOrder_ROW_instance;
  }
  function MajorOrder_COLUMN_getInstance() {
    MajorOrder_initEntries();
    return MajorOrder_COLUMN_instance;
  }
  function copyFrom(_this_, that) {
    return toMatrix3D(that, _this_);
  }
  function toMatrix3D(_this_, out) {
    return setRows(out, _this_._a, _this_._c, 0.0, _this_._tx, _this_._b, _this_._d, 0.0, _this_._ty, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  function Companion_80() {
    Companion_instance_79 = this;
  }
  Companion_80.prototype.invoke_307 = function (x, y) {
    return new Point(x, y);
  };
  Companion_80.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_79;
  function Companion_getInstance_79() {
    if (Companion_instance_79 == null)
      new Companion_80();
    return Companion_instance_79;
  }
  function IPoint() {
  }
  IPoint.$metadata$ = {
    simpleName: 'IPoint',
    kind: 'interface',
    interfaces: []
  };
  function Point_init_$Init$(x, y, $this) {
    Point.call($this, x, y);
    return $this;
  }
  function Point_init_$Create$(x, y) {
    return Point_init_$Init$(x, y, Object.create(Point.prototype));
  }
  function Point_init_$Init$_0(x, y, $this) {
    Point.call($this, x, y);
    return $this;
  }
  function Point_init_$Create$_0(x, y) {
    return Point_init_$Init$_0(x, y, Object.create(Point.prototype));
  }
  function Companion_81() {
    Companion_instance_80 = this;
    this._Zero = Companion_getInstance_79().invoke_307(0.0, 0.0);
    this._One = Companion_getInstance_79().invoke_307(1.0, 1.0);
    this._Up = Companion_getInstance_79().invoke_307(0.0, 1.0);
    this._Down = Companion_getInstance_79().invoke_307(0.0, -1.0);
    this._Left = Companion_getInstance_79().invoke_307(-1.0, 0.0);
    this._Right = Companion_getInstance_79().invoke_307(1.0, 0.0);
  }
  Companion_81.prototype.invoke_1005 = function () {
    return new Point(0.0, 0.0);
  };
  Companion_81.prototype.angle_0 = function (ax, ay, bx, by) {
    return Companion_getInstance_75().between(ax, ay, bx, by);
  };
  Companion_81.prototype.compare_7 = function (lx, ly, rx, ry) {
    var ret = compareTo(ly, ry);
    return ret === 0 ? compareTo(lx, rx) : ret;
  };
  Companion_81.prototype.distance = function (x1, y1, x2, y2) {
    var tmp0_hypot_0 = x1 - x2;
    var tmp1_hypot_0 = y1 - y2;
    return Math.hypot(tmp0_hypot_0, tmp1_hypot_0);
  };
  Companion_81.prototype.distance_0 = function (x1, y1, x2, y2) {
    return this.distance(x1, y1, x2, y2);
  };
  Companion_81.prototype.distance_1 = function (a, b) {
    return this.distance(a._x_2, a._y_2, b._x_2, b._y_2);
  };
  Companion_81.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_80;
  function Companion_getInstance_80() {
    if (Companion_instance_80 == null)
      new Companion_81();
    return Companion_instance_80;
  }
  function Point(x, y) {
    Companion_getInstance_80();
    this._x_2 = x;
    this._y_2 = y;
  }
  Point.prototype._get_x__36 = function () {
    return this._x_2;
  };
  Point.prototype._get_y__36 = function () {
    return this._y_2;
  };
  Point.prototype._set_xf_ = function (value) {
    this._x_2 = value;
  };
  Point.prototype._set_yf_ = function (value) {
    this._y_2 = value;
  };
  Point.prototype.compareTo_40 = function (other) {
    return Companion_getInstance_80().compare_7(this._x_2, this._y_2, other._get_x__36(), other._get_y__36());
  };
  Point.prototype.compareTo_71 = function (other) {
    return this.compareTo_40((!(other == null) ? isInterface(other, IPoint) : false) ? other : THROW_CCE());
  };
  Point.prototype.setTo_0 = function (x, y) {
    this._x_2 = x;
    this._y_2 = y;
    return this;
  };
  Point.prototype.setTo_1 = function (x, y) {
    this._set_xf_(x);
    this._set_yf_(y);
    return this;
  };
  Point.prototype.copyFrom_1 = function (that) {
    return this.setTo_0(that._x_2, that._y_2);
  };
  Point.prototype.setToTransform = function (mat, p) {
    return this.setToTransform_0(mat, p._x_2, p._y_2);
  };
  Point.prototype.setToTransform_0 = function (mat, x, y) {
    return this.setTo_0(mat.transformX(x, y), mat.transformY(x, y));
  };
  Point.prototype.setToAdd = function (a, b) {
    return this.setTo_0(a._x_2 + b._x_2, a._y_2 + b._y_2);
  };
  Point.prototype.setToSub = function (a, b) {
    return this.setTo_0(a._x_2 - b._x_2, a._y_2 - b._y_2);
  };
  Point.prototype.setToMul = function (a, s) {
    return this.setTo_0(a._x_2 * s, a._y_2 * s);
  };
  Point.prototype.distanceTo = function (x, y) {
    var tmp0_hypot_0 = x - this._x_2;
    var tmp1_hypot_0 = y - this._y_2;
    return Math.hypot(tmp0_hypot_0, tmp1_hypot_0);
  };
  Point.prototype.distanceTo_0 = function (that) {
    return this.distanceTo(that._x_2, that._y_2);
  };
  Point.prototype.interpolateWith = function (ratio, other) {
    return Companion_getInstance_80().invoke_1005().setToInterpolated(ratio, this, other);
  };
  Point.prototype.setToInterpolated = function (ratio, l, r) {
    return this.setToInterpolated_0(ratio, l._x_2, l._y_2, r._x_2, r._y_2);
  };
  Point.prototype.setToInterpolated_0 = function (ratio, lx, ly, rx, ry) {
    return this.setTo_0(interpolate(ratio, lx, rx), interpolate(ratio, ly, ry));
  };
  Point.prototype.toString = function () {
    return '' + '(' + _get_niceStr__3(this._x_2) + ', ' + _get_niceStr__3(this._y_2) + ')';
  };
  Point.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_2);
    result = imul(result, 31) + getNumberHashCode(this._y_2) | 0;
    return result;
  };
  Point.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Point))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Point ? other : THROW_CCE();
    if (!equals_1(this._x_2, tmp0_other_with_cast._x_2))
      return false;
    if (!equals_1(this._y_2, tmp0_other_with_cast._y_2))
      return false;
    return true;
  };
  Point.$metadata$ = {
    simpleName: 'Point',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable, Comparable, IPoint, XY, XYf]
  };
  function XY() {
  }
  XY.$metadata$ = {
    simpleName: 'XY',
    kind: 'interface',
    interfaces: [IPoint]
  };
  function XYf() {
  }
  XYf.$metadata$ = {
    simpleName: 'XYf',
    kind: 'interface',
    interfaces: []
  };
  function minus_3(_this_, that) {
    return Companion_getInstance_79().invoke_307(_this_._get_x__36() - that._get_x__36(), _this_._get_y__36() - that._get_y__36());
  }
  function angle(_this_, a, b) {
    var tmp = Companion_getInstance_75();
    var tmp0_acos_0 = dot(a, b) / (_get_length_(a) * _get_length_(b));
    return tmp.fromRadians(Math.acos(tmp0_acos_0));
  }
  function plus_6(_this_, that) {
    return Companion_getInstance_79().invoke_307(_this_._get_x__36() + that._get_x__36(), _this_._get_y__36() + that._get_y__36());
  }
  function times_1(_this_, scale_1) {
    return Companion_getInstance_79().invoke_307(_this_._get_x__36() * scale_1, _this_._get_y__36() * scale_1);
  }
  function _get_unit_(_this_) {
    return div_0(_this_, _get_length_(_this_));
  }
  function _get_length_(_this_) {
    var tmp0_hypot_0 = _this_._get_x__36();
    var tmp1_hypot_0 = _this_._get_y__36();
    return Math.hypot(tmp0_hypot_0, tmp1_hypot_0);
  }
  function dot(_this_, that) {
    return _this_._get_x__36() * that._get_x__36() + _this_._get_y__36() * that._get_y__36();
  }
  function div_0(_this_, scale_1) {
    return Companion_getInstance_79().invoke_307(_this_._get_x__36() / scale_1, _this_._get_y__36() / scale_1);
  }
  function IPointArrayList() {
  }
  IPointArrayList.$metadata$ = {
    simpleName: 'IPointArrayList',
    kind: 'interface',
    interfaces: []
  };
  function Companion_82() {
    Companion_instance_81 = this;
  }
  Companion_82.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_81;
  function Companion_getInstance_81() {
    if (Companion_instance_81 == null)
      new Companion_82();
    return Companion_instance_81;
  }
  function PointIntArrayList(capacity) {
    Companion_getInstance_81();
    this._xList = new IntArrayList(capacity);
    this._yList = new IntArrayList(capacity);
  }
  PointIntArrayList.prototype._get_size__60 = function () {
    return this._xList._get_size__60();
  };
  PointIntArrayList.prototype.isEmpty_53 = function () {
    return this._get_size__60() === 0;
  };
  PointIntArrayList.prototype.clear_33 = function () {
    this._xList.clear_33();
    this._yList.clear_33();
  };
  PointIntArrayList.prototype.add_58 = function (x, y) {
    var tmp0_this_2 = this;
    tmp0_this_2._xList.plusAssign_1(x);
    var tmp1_this_3 = this;
    tmp1_this_3._yList.plusAssign_1(y);
    return this;
  };
  PointIntArrayList.prototype.getX_2 = function (index) {
    return this._xList.getAt_0(index);
  };
  PointIntArrayList.prototype.getY_2 = function (index) {
    return this._yList.getAt_0(index);
  };
  PointIntArrayList.prototype.toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.append_2(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.getX_2(n);
        var y = this.getY_2(n);
        if (!(n === 0)) {
          sb.append_5(', ');
          Unit_getInstance();
        }sb.append_2(new Char(40));
        Unit_getInstance();
        sb.append_4(x);
        Unit_getInstance();
        sb.append_5(', ');
        Unit_getInstance();
        sb.append_4(y);
        Unit_getInstance();
        sb.append_2(new Char(41));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    sb.append_2(new Char(93));
    Unit_getInstance();
    return sb.toString();
  };
  PointIntArrayList.$metadata$ = {
    simpleName: 'PointIntArrayList',
    kind: 'class',
    interfaces: [IPointIntArrayList]
  };
  function PointArrayList_init_$Init$(capacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      capacity = 7;
    PointArrayList.call($this, capacity);
    return $this;
  }
  function PointArrayList_init_$Create$(capacity, $mask0, $marker) {
    return PointArrayList_init_$Init$(capacity, $mask0, $marker, Object.create(PointArrayList.prototype));
  }
  function Companion_83() {
    Companion_instance_82 = this;
  }
  Companion_83.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_82;
  function Companion_getInstance_82() {
    if (Companion_instance_82 == null)
      new Companion_83();
    return Companion_instance_82;
  }
  function PointArrayList(capacity) {
    Companion_getInstance_82();
    this._xList_0 = new DoubleArrayList(capacity);
    this._yList_0 = new DoubleArrayList(capacity);
  }
  PointArrayList.prototype._get_size__60 = function () {
    return this._xList_0._get_size__60();
  };
  PointArrayList.prototype.clear_19 = function () {
    this._xList_0.clear_33();
    this._yList_0.clear_33();
    return this;
  };
  PointArrayList.prototype.add_52 = function (x, y) {
    var tmp0_this_2 = this;
    tmp0_this_2._xList_0.plusAssign(x);
    var tmp1_this_3 = this;
    tmp1_this_3._yList_0.plusAssign(y);
    return this;
  };
  PointArrayList.prototype.getX_2 = function (index) {
    return this._xList_0.getAt_0(index);
  };
  PointArrayList.prototype.getY_2 = function (index) {
    return this._yList_0.getAt_0(index);
  };
  PointArrayList.prototype.toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.append_2(new Char(91));
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.getX_2(n);
        var y = this.getY_2(n);
        if (!(n === 0)) {
          sb.append_5(', ');
          Unit_getInstance();
        }sb.append_2(new Char(40));
        Unit_getInstance();
        if (x === round(x)) {
          sb.append_4(numberToInt(x));
          Unit_getInstance();
        } else {
          sb.append_4(x);
          Unit_getInstance();
        }
        sb.append_5(', ');
        Unit_getInstance();
        if (y === round(y)) {
          sb.append_4(numberToInt(y));
          Unit_getInstance();
        } else {
          sb.append_4(y);
          Unit_getInstance();
        }
        sb.append_2(new Char(41));
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    sb.append_2(new Char(93));
    Unit_getInstance();
    return sb.toString();
  };
  PointArrayList.$metadata$ = {
    simpleName: 'PointArrayList',
    kind: 'class',
    interfaces: [IPointArrayList]
  };
  function IPointIntArrayList() {
  }
  IPointIntArrayList.$metadata$ = {
    simpleName: 'IPointIntArrayList',
    kind: 'interface',
    interfaces: []
  };
  function Companion_84() {
    Companion_instance_83 = this;
  }
  Companion_84.prototype.invoke_1005 = function () {
    return new Rectangle(0.0, 0.0, 0.0, 0.0);
  };
  Companion_84.prototype.invoke_310 = function (x, y, width, height) {
    return new Rectangle(x, y, width, height);
  };
  Companion_84.prototype.fromBounds = function (left, top, right, bottom) {
    return Companion_getInstance_83().invoke_1005().setBounds(left, top, right, bottom);
  };
  Companion_84.prototype.isContainedIn = function (a, b) {
    return ((a._x_3 >= b._x_3 ? a._y_3 >= b._y_3 : false) ? a._x_3 + a._width_0 <= b._x_3 + b._width_0 : false) ? a._y_3 + a._height_0 <= b._y_3 + b._height_0 : false;
  };
  Companion_84.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_83;
  function Companion_getInstance_83() {
    if (Companion_instance_83 == null)
      new Companion_84();
    return Companion_instance_83;
  }
  function Rectangle(x, y, width, height) {
    Companion_getInstance_83();
    this._x_3 = x;
    this._y_3 = y;
    this._width_0 = width;
    this._height_0 = height;
  }
  Rectangle.prototype._get__x__0 = function () {
    return this._x_3;
  };
  Rectangle.prototype._get__y__0 = function () {
    return this._y_3;
  };
  Rectangle.prototype._get__width__0 = function () {
    return this._width_0;
  };
  Rectangle.prototype._get__height__0 = function () {
    return this._height_0;
  };
  Rectangle.prototype._get_isNotEmpty_ = function () {
    return !(this._get_area__7() === 0.0);
  };
  Rectangle.prototype._get_area__7 = function () {
    return this._width_0 * this._height_0;
  };
  Rectangle.prototype._get_left__4 = function () {
    return this._x_3;
  };
  Rectangle.prototype._set_top_ = function (value) {
    this._y_3 = value;
    return Unit_getInstance();
  };
  Rectangle.prototype._get_top__4 = function () {
    return this._y_3;
  };
  Rectangle.prototype._get_right__2 = function () {
    return this._x_3 + this._width_0;
  };
  Rectangle.prototype._get_bottom__2 = function () {
    return this._y_3 + this._height_0;
  };
  Rectangle.prototype.setTo_2 = function (x, y, width, height) {
    this._x_3 = x;
    this._y_3 = y;
    this._width_0 = width;
    this._height_0 = height;
    return this;
  };
  Rectangle.prototype.setTo_6 = function (x, y, width, height) {
    return this.setTo_2(x, y, width, height);
  };
  Rectangle.prototype.copyFrom_2 = function (that) {
    return this.setTo_2(that._x_3, that._y_3, that._width_0, that._height_0);
  };
  Rectangle.prototype.setBounds = function (left, top, right, bottom) {
    return this.setTo_2(left, top, right - left, bottom - top);
  };
  Rectangle.prototype.setBounds_0 = function (left, top, right, bottom) {
    return this.setBounds(left, top, right, bottom);
  };
  Rectangle.prototype.contains_55 = function (x, y) {
    return (x >= this._get_left__4() ? x < this._get_right__2() : false) ? y >= this._get_top__4() ? y < this._get_bottom__2() : false : false;
  };
  Rectangle.prototype.intersects = function (that) {
    return this.intersectsX(that) ? this.intersectsY(that) : false;
  };
  Rectangle.prototype.intersectsX = function (that) {
    return that._get_left__4() <= this._get_right__2() ? that._get_right__2() >= this._get_left__4() : false;
  };
  Rectangle.prototype.intersectsY = function (that) {
    return that._get_top__4() <= this._get_bottom__2() ? that._get_bottom__2() >= this._get_top__4() : false;
  };
  Rectangle.prototype.intersection = function (that, target) {
    return this.intersects(that) ? target.setBounds(max2_3(this._get_left__4(), that._get_left__4()), max2_3(this._get_top__4(), that._get_top__4()), min2_3(this._get_right__2(), that._get_right__2()), min2_3(this._get_bottom__2(), that._get_bottom__2())) : null;
  };
  Rectangle.prototype.displace = function (dx, dy) {
    return this.setTo_2(this._x_3 + dx, this._y_3 + dy, this._width_0, this._height_0);
  };
  Rectangle.prototype.inflate = function (dx, dy) {
    var tmp0_this = this;
    tmp0_this._x_3 = tmp0_this._x_3 - dx;
    var tmp1_this = this;
    tmp1_this._width_0 = tmp1_this._width_0 + 2 * dx;
    var tmp2_this = this;
    tmp2_this._y_3 = tmp2_this._y_3 - dy;
    var tmp3_this = this;
    tmp3_this._height_0 = tmp3_this._height_0 + 2 * dy;
  };
  Rectangle.prototype.clear_19 = function () {
    return this.setTo_2(0.0, 0.0, 0.0, 0.0);
  };
  Rectangle.prototype.clone_8 = function () {
    return new Rectangle(this._x_3, this._y_3, this._width_0, this._height_0);
  };
  Rectangle.prototype.toString = function () {
    return '' + 'Rectangle(x=' + _get_niceStr__3(this._x_3) + ', y=' + _get_niceStr__3(this._y_3) + ', width=' + _get_niceStr__3(this._width_0) + ', height=' + _get_niceStr__3(this._height_0) + ')';
  };
  Rectangle.prototype.toInt_3 = function () {
    return Companion_getInstance_84().invoke_313(this._x_3, this._y_3, this._width_0, this._height_0);
  };
  Rectangle.prototype.hashCode = function () {
    var result = getNumberHashCode(this._x_3);
    result = imul(result, 31) + getNumberHashCode(this._y_3) | 0;
    result = imul(result, 31) + getNumberHashCode(this._width_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._height_0) | 0;
    return result;
  };
  Rectangle.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals_1(this._x_3, tmp0_other_with_cast._x_3))
      return false;
    if (!equals_1(this._y_3, tmp0_other_with_cast._y_3))
      return false;
    if (!equals_1(this._width_0, tmp0_other_with_cast._width_0))
      return false;
    if (!equals_1(this._height_0, tmp0_other_with_cast._height_0))
      return false;
    return true;
  };
  Rectangle.$metadata$ = {
    simpleName: 'Rectangle',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable, IRectangle, Sizeable]
  };
  function IRectangle() {
  }
  IRectangle.$metadata$ = {
    simpleName: 'IRectangle',
    kind: 'interface',
    interfaces: []
  };
  function _RectangleInt___init__impl_(rect_1) {
    return rect_1;
  }
  function _RectangleInt___get_rect__impl_(this_0) {
    return this_0;
  }
  function _RectangleInt___get_x__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._x_3);
  }
  function _RectangleInt___get_y__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._y_3);
  }
  function _RectangleInt___get_width__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._width_0);
  }
  function _RectangleInt___get_height__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._height_0);
  }
  function _RectangleInt___get_left__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._get_left__4());
  }
  function _RectangleInt___get_top__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._get_top__4());
  }
  function _RectangleInt___get_right__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._get_right__2());
  }
  function _RectangleInt___get_bottom__impl_(this_0) {
    return numberToInt(_RectangleInt___get_rect__impl_(this_0)._get_bottom__2());
  }
  function Companion_85() {
    Companion_instance_84 = this;
  }
  Companion_85.prototype.invoke_311 = function () {
    return _RectangleInt___init__impl_(Companion_getInstance_83().invoke_1005());
  };
  Companion_85.prototype.invoke_312 = function (x, y, width, height) {
    return _RectangleInt___init__impl_(Companion_getInstance_83().invoke_310(x, y, width, height));
  };
  Companion_85.prototype.invoke_313 = function (x, y, width, height) {
    return _RectangleInt___init__impl_(new Rectangle(x, y, width, height));
  };
  Companion_85.prototype.fromBounds_0 = function (left, top, right, bottom) {
    return Companion_getInstance_84().invoke_312(left, top, right - left | 0, bottom - top | 0);
  };
  Companion_85.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_84;
  function Companion_getInstance_84() {
    if (Companion_instance_84 == null)
      new Companion_85();
    return Companion_instance_84;
  }
  function RectangleInt__toString_impl(this_0) {
    return '' + 'Rectangle(x=' + _RectangleInt___get_x__impl_(this_0) + ', y=' + _RectangleInt___get_y__impl_(this_0) + ', width=' + _RectangleInt___get_width__impl_(this_0) + ', height=' + _RectangleInt___get_height__impl_(this_0) + ')';
  }
  function RectangleInt__hashCode_impl(this_0) {
    return this_0.hashCode();
  }
  function RectangleInt__equals_impl(this_0, other) {
    if (!(other instanceof RectangleInt))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RectangleInt ? other._rect : THROW_CCE();
    if (!this_0.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function RectangleInt(rect_1) {
    Companion_getInstance_84();
    this._rect = rect_1;
  }
  RectangleInt.prototype._get_x__36 = function () {
    return _RectangleInt___get_x__impl_(this._rect);
  };
  RectangleInt.prototype._get_y__36 = function () {
    return _RectangleInt___get_y__impl_(this._rect);
  };
  RectangleInt.prototype._get_width__58 = function () {
    return _RectangleInt___get_width__impl_(this._rect);
  };
  RectangleInt.prototype._get_height__58 = function () {
    return _RectangleInt___get_height__impl_(this._rect);
  };
  RectangleInt.prototype.toString = function () {
    return RectangleInt__toString_impl(this._rect);
  };
  RectangleInt.prototype.hashCode = function () {
    return RectangleInt__hashCode_impl(this._rect);
  };
  RectangleInt.prototype.equals = function (other) {
    return RectangleInt__equals_impl(this._rect, other);
  };
  RectangleInt.$metadata$ = {
    simpleName: 'RectangleInt',
    kind: 'class',
    interfaces: [IRectangleInt]
  };
  function IRectangleInt() {
  }
  IRectangleInt.$metadata$ = {
    simpleName: 'IRectangleInt',
    kind: 'interface',
    interfaces: []
  };
  function _get_float_(_this_) {
    return Companion_getInstance_83().invoke_310(_this_._get_x__36(), _this_._get_y__36(), _this_._get_width__58(), _this_._get_height__58());
  }
  function _get_topLeft_(_this_) {
    return new Point(_get_left__0(_this_), _get_top_(_this_));
  }
  function _get_topRight_(_this_) {
    return new Point(_get_right__0(_this_), _get_top_(_this_));
  }
  function _get_bottomRight_(_this_) {
    return new Point(_get_right__0(_this_), _get_bottom_(_this_));
  }
  function _get_bottomLeft_(_this_) {
    return new Point(_get_left__0(_this_), _get_bottom_(_this_));
  }
  function _get_left__0(_this_) {
    return _this_._get__x__0();
  }
  function _get_right__0(_this_) {
    return _this_._get__x__0() + _this_._get__width__0();
  }
  function _get_top_(_this_) {
    return _this_._get__y__0();
  }
  function _get_bottom_(_this_) {
    return _this_._get__y__0() + _this_._get__height__0();
  }
  function _no_name_provided__204() {
  }
  _no_name_provided__204.prototype.invoke_320 = function (c, iw, ih, cw, ch) {
    var s0 = cw / iw;
    var s1 = ch / ih;
    var s = max2_3(s0, s1);
    return c === 0 ? iw * s : ih * s;
  };
  _no_name_provided__204.prototype.invoke_436 = function (p1, p2, p3, p4, p5) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    return this.invoke_320(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
  };
  _no_name_provided__204.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__205() {
  }
  _no_name_provided__205.prototype.invoke_320 = function (c, iw, ih, cw, ch) {
    var s0 = cw / iw;
    var s1 = ch / ih;
    var s = min2_3(s0, s1);
    return c === 0 ? iw * s : ih * s;
  };
  _no_name_provided__205.prototype.invoke_436 = function (p1, p2, p3, p4, p5) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    return this.invoke_320(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
  };
  _no_name_provided__205.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__206() {
  }
  _no_name_provided__206.prototype.invoke_320 = function (c, iw, ih, cw, ch) {
    return c === 0 ? cw : ch;
  };
  _no_name_provided__206.prototype.invoke_436 = function (p1, p2, p3, p4, p5) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    return this.invoke_320(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
  };
  _no_name_provided__206.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__207() {
  }
  _no_name_provided__207.prototype.invoke_320 = function (c, iw, ih, cw, ch) {
    return c === 0 ? iw : ih;
  };
  _no_name_provided__207.prototype.invoke_436 = function (p1, p2, p3, p4, p5) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    return this.invoke_320(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
  };
  _no_name_provided__207.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_86() {
    Companion_instance_85 = this;
    var tmp = this;
    tmp._COVER = new ScaleMode(_no_name_provided_$factory_166());
    var tmp_0 = this;
    tmp_0._SHOW_ALL = new ScaleMode(_no_name_provided_$factory_167());
    var tmp_1 = this;
    tmp_1._EXACT = new ScaleMode(_no_name_provided_$factory_168());
    var tmp_2 = this;
    tmp_2._NO_SCALE = new ScaleMode(_no_name_provided_$factory_169());
  }
  Companion_86.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_85;
  function Companion_getInstance_85() {
    if (Companion_instance_85 == null)
      new Companion_86();
    return Companion_instance_85;
  }
  function ScaleMode(transform) {
    Companion_getInstance_85();
    this._transform = transform;
  }
  ScaleMode.prototype.transformW = function (iw, ih, cw, ch) {
    return this._transform(0, iw, ih, cw, ch);
  };
  ScaleMode.prototype.transformH = function (iw, ih, cw, ch) {
    return this._transform(1, iw, ih, cw, ch);
  };
  ScaleMode.prototype.invoke_322 = function (item, container, target) {
    return setTo(target, numberToInt(this.transformW(_SizeInt___get_width__impl_(item), _SizeInt___get_height__impl_(item), _SizeInt___get_width__impl_(container), _SizeInt___get_height__impl_(container))), numberToInt(this.transformH(_SizeInt___get_width__impl_(item), _SizeInt___get_height__impl_(item), _SizeInt___get_width__impl_(container), _SizeInt___get_height__impl_(container))));
  };
  ScaleMode.$metadata$ = {
    simpleName: 'ScaleMode',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_166() {
    var i = new _no_name_provided__204();
    return function (p1, p2, p3, p4, p5) {
      return i.invoke_320(p1, p2, p3, p4, p5);
    };
  }
  function _no_name_provided_$factory_167() {
    var i = new _no_name_provided__205();
    return function (p1, p2, p3, p4, p5) {
      return i.invoke_320(p1, p2, p3, p4, p5);
    };
  }
  function _no_name_provided_$factory_168() {
    var i = new _no_name_provided__206();
    return function (p1, p2, p3, p4, p5) {
      return i.invoke_320(p1, p2, p3, p4, p5);
    };
  }
  function _no_name_provided_$factory_169() {
    var i = new _no_name_provided__207();
    return function (p1, p2, p3, p4, p5) {
      return i.invoke_320(p1, p2, p3, p4, p5);
    };
  }
  function Sizeable() {
  }
  Sizeable.$metadata$ = {
    simpleName: 'Sizeable',
    kind: 'interface',
    interfaces: []
  };
  function ISize() {
  }
  ISize.$metadata$ = {
    simpleName: 'ISize',
    kind: 'interface',
    interfaces: []
  };
  function _Size___init__impl_(p) {
    return p;
  }
  function _Size___get_p__impl_(this_0) {
    return this_0;
  }
  function Companion_87() {
    Companion_instance_86 = this;
  }
  Companion_87.prototype.invoke_323 = function (width, height) {
    return _Size___init__impl_(Point_init_$Create$_0(width, height));
  };
  Companion_87.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_86;
  function Companion_getInstance_86() {
    if (Companion_instance_86 == null)
      new Companion_87();
    return Companion_instance_86;
  }
  function _Size___set_width__impl_(this_0, value) {
    _Size___get_p__impl_(this_0)._x_2 = value;
    return Unit_getInstance();
  }
  function _Size___get_width__impl_(this_0) {
    return _Size___get_p__impl_(this_0)._x_2;
  }
  function _Size___set_height__impl_(this_0, value) {
    _Size___get_p__impl_(this_0)._y_2 = value;
    return Unit_getInstance();
  }
  function _Size___get_height__impl_(this_0) {
    return _Size___get_p__impl_(this_0)._y_2;
  }
  function Size__toString_impl(this_0) {
    return '' + 'Size(width=' + _get_niceStr__3(_Size___get_width__impl_(this_0)) + ', height=' + _get_niceStr__3(_Size___get_height__impl_(this_0)) + ')';
  }
  function Size__hashCode_impl(this_0) {
    return this_0.hashCode();
  }
  function Size__equals_impl(this_0, other) {
    if (!(other instanceof Size))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Size ? other._p : THROW_CCE();
    if (!this_0.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function Size(p) {
    Companion_getInstance_86();
    this._p = p;
  }
  Size.prototype.toString = function () {
    return Size__toString_impl(this._p);
  };
  Size.prototype.hashCode = function () {
    return Size__hashCode_impl(this._p);
  };
  Size.prototype.equals = function (other) {
    return Size__equals_impl(this._p, other);
  };
  Size.$metadata$ = {
    simpleName: 'Size',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable, ISize, Sizeable]
  };
  function _SizeInt___init__impl_(size_1) {
    new Size(size_1);
    return size_1;
  }
  function _SizeInt___get_size__impl_(this_0) {
    return this_0;
  }
  function Companion_88() {
    Companion_instance_87 = this;
  }
  Companion_88.prototype.invoke_324 = function () {
    return _SizeInt___init__impl_(Companion_getInstance_86().invoke_323(0, 0));
  };
  Companion_88.prototype.invoke_325 = function (x, y) {
    return _SizeInt___init__impl_(Companion_getInstance_86().invoke_323(x, y));
  };
  Companion_88.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_87;
  function Companion_getInstance_87() {
    if (Companion_instance_87 == null)
      new Companion_88();
    return Companion_instance_87;
  }
  function _SizeInt___set_width__impl_(this_0, value) {
    return _Size___set_width__impl_(_SizeInt___get_size__impl_(this_0), value);
  }
  function _SizeInt___get_width__impl_(this_0) {
    return numberToInt(_Size___get_width__impl_(_SizeInt___get_size__impl_(this_0)));
  }
  function _SizeInt___set_height__impl_(this_0, value) {
    return _Size___set_height__impl_(_SizeInt___get_size__impl_(this_0), value);
  }
  function _SizeInt___get_height__impl_(this_0) {
    return numberToInt(_Size___get_height__impl_(_SizeInt___get_size__impl_(this_0)));
  }
  function SizeInt__toString_impl(this_0) {
    return '' + 'SizeInt(width=' + _SizeInt___get_width__impl_(this_0) + ', height=' + _SizeInt___get_height__impl_(this_0) + ')';
  }
  function SizeInt__hashCode_impl(this_0) {
    return Size__hashCode_impl(this_0);
  }
  function SizeInt__equals_impl(this_0, other) {
    if (!(other instanceof SizeInt))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof SizeInt ? other._size_9 : THROW_CCE();
    if (!equals_1(new Size(this_0), new Size(tmp0_other_with_cast)))
      return false;
    return true;
  }
  function SizeInt(size_1) {
    Companion_getInstance_87();
    this._size_9 = size_1;
  }
  SizeInt.prototype.toString = function () {
    return SizeInt__toString_impl(this._size_9);
  };
  SizeInt.prototype.hashCode = function () {
    return SizeInt__hashCode_impl(this._size_9);
  };
  SizeInt.prototype.equals = function (other) {
    return SizeInt__equals_impl(this._size_9, other);
  };
  SizeInt.$metadata$ = {
    simpleName: 'SizeInt',
    kind: 'class',
    interfaces: [ISizeInt]
  };
  function setTo(_this_, width, height) {
    _SizeInt___set_width__impl_(_this_, width);
    _SizeInt___set_height__impl_(_this_, height);
    return _this_;
  }
  function ISizeInt() {
  }
  ISizeInt.$metadata$ = {
    simpleName: 'ISizeInt',
    kind: 'interface',
    interfaces: []
  };
  function Companion_89() {
    Companion_instance_88 = this;
  }
  Companion_89.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_88;
  function Companion_getInstance_88() {
    if (Companion_instance_88 == null)
      new Companion_89();
    return Companion_instance_88;
  }
  function Vector3D() {
    Companion_getInstance_88();
    var tmp = this;
    var tmp0_floatArrayOf_0 = new Float32Array([0.0, 0.0, 0.0, 1.0]);
    tmp._data_36 = tmp0_floatArrayOf_0;
  }
  Vector3D.prototype._get_x__36 = function () {
    return this._data_36[0];
  };
  Vector3D.prototype._get_y__36 = function () {
    return this._data_36[1];
  };
  Vector3D.prototype._get_z_ = function () {
    return this._data_36[2];
  };
  Vector3D.prototype._get_w_ = function () {
    return this._data_36[3];
  };
  Vector3D.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Vector3D) {
      tmp_2 = almostEquals(this._get_x__36(), other._get_x__36());
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = almostEquals(this._get_y__36(), other._get_y__36());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = almostEquals(this._get_z_(), other._get_z_());
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = almostEquals(this._get_w_(), other._get_w_());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Vector3D.prototype.hashCode = function () {
    return contentHashCode_3(this._data_36);
  };
  Vector3D.prototype.toString = function () {
    return this._get_w_() === 1.0 ? '' + '(' + _get_niceStr__4(this._get_x__36()) + ', ' + _get_niceStr__4(this._get_y__36()) + ', ' + _get_niceStr__4(this._get_z_()) + ')' : '' + '(' + _get_niceStr__4(this._get_x__36()) + ', ' + _get_niceStr__4(this._get_y__36()) + ', ' + _get_niceStr__4(this._get_z_()) + ', ' + _get_niceStr__4(this._get_w_()) + ')';
  };
  Vector3D.$metadata$ = {
    simpleName: 'Vector3D',
    kind: 'class',
    interfaces: []
  };
  function Temp() {
    this._tvalues = new Float64Array(6);
    this._xvalues = new Float64Array(8);
    this._yvalues = new Float64Array(8);
    this._tpoint0 = Companion_getInstance_80().invoke_1005();
    this._tpoint1 = Companion_getInstance_80().invoke_1005();
    this._tpoint2 = Companion_getInstance_80().invoke_1005();
    this._tpoint3 = Companion_getInstance_80().invoke_1005();
  }
  Temp.$metadata$ = {
    simpleName: 'Temp',
    kind: 'class',
    interfaces: []
  };
  function Companion_90() {
    Companion_instance_89 = this;
  }
  Companion_90.prototype.quadToCubic1 = function (v0, v1, v2) {
    return v0 + (v1 - v0) * 0.6666666666666666;
  };
  Companion_90.prototype.quadToCubic2 = function (v0, v1, v2) {
    return v2 + (v1 - v2) * 0.6666666666666666;
  };
  Companion_90.prototype.quadBounds = function (x0, y0, xc, yc, x1, y1, target, temp_0) {
    return this.cubicBounds(x0, y0, this.quadToCubic1(x0, xc, x1), this.quadToCubic1(y0, yc, y1), this.quadToCubic2(x0, xc, x1), this.quadToCubic2(y0, yc, y1), x1, y1, target, temp_0);
  };
  Companion_90.prototype.quadBounds$default = function (x0, y0, xc, yc, x1, y1, target, temp_0, $mask0, $handler) {
    if (!(($mask0 & 64) === 0))
      target = Companion_getInstance_83().invoke_1005();
    if (!(($mask0 & 128) === 0))
      temp_0 = new Temp();
    return this.quadBounds(x0, y0, xc, yc, x1, y1, target, temp_0);
  };
  Companion_90.prototype.quadCalc = function (x0, y0, xc, yc, x1, y1, t, target) {
    var t1_1 = 1 - t;
    var a_2 = t1_1 * t1_1;
    var c_3 = t * t;
    var b_4 = 2 * t1_1 * t;
    var tmp0__anonymous__5 = a_2 * x0 + b_4 * xc + c_3 * x1;
    var tmp1__anonymous__5 = a_2 * y0 + b_4 * yc + c_3 * y1;
    return target.setTo_0(tmp0__anonymous__5, tmp1__anonymous__5);
  };
  Companion_90.prototype.cubicBounds = function (x0, y0, x1, y1, x2, y2, x3, y3, target, temp_0) {
    var j = 0;
    var a;
    var b;
    var c;
    var b2ac;
    var sqrtb2ac;
    var inductionVariable = 0;
    if (inductionVariable < 2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (i === 0) {
          b = 6 * x0 - 12 * x1 + 6 * x2;
          a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
          c = 3 * x1 - 3 * x0;
        } else {
          b = 6 * y0 - 12 * y1 + 6 * y2;
          a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
          c = 3 * y1 - 3 * y0;
        }
        var tmp0_abs_0 = a;
        if (Math.abs(tmp0_abs_0) < 1.0E-12) {
          var tmp1_abs_0 = b;
          if (Math.abs(tmp1_abs_0) >= 1.0E-12) {
            var t = -c / b;
            if (0.0 < t ? t < 1.0 : false) {
              var tmp1 = j;
              j = tmp1 + 1 | 0;
              temp_0._tvalues[tmp1] = t;
            }} else {
          }
        } else {
          {
            b2ac = b * b - 4 * c * a;
            if (b2ac < 0.0)
              continue;
            var tmp2_sqrt_0 = b2ac;
            sqrtb2ac = Math.sqrt(tmp2_sqrt_0);
            var t1 = (-b + sqrtb2ac) / (2.0 * a);
            if (0.0 < t1 ? t1 < 1.0 : false) {
              var tmp2 = j;
              j = tmp2 + 1 | 0;
              temp_0._tvalues[tmp2] = t1;
            }var t2 = (-b - sqrtb2ac) / (2.0 * a);
            if (0.0 < t2 ? t2 < 1.0 : false) {
              var tmp3 = j;
              j = tmp3 + 1 | 0;
              temp_0._tvalues[tmp3] = t2;
            }}
        }
      }
       while (inductionVariable < 2);
    $l$break: while (true) {
      var tmp4 = j;
      j = tmp4 - 1 | 0;
      if (!(tmp4 > 0)) {
        break $l$break;
      }var t_0 = temp_0._tvalues[j];
      var mt = 1 - t_0;
      temp_0._xvalues[j] = mt * mt * mt * x0 + 3 * mt * mt * t_0 * x1 + 3 * mt * t_0 * t_0 * x2 + t_0 * t_0 * t_0 * x3;
      temp_0._yvalues[j] = mt * mt * mt * y0 + 3 * mt * mt * t_0 * y1 + 3 * mt * t_0 * t_0 * y2 + t_0 * t_0 * t_0 * y3;
    }
    temp_0._xvalues[temp_0._tvalues.length + 0 | 0] = x0;
    temp_0._xvalues[temp_0._tvalues.length + 1 | 0] = x3;
    temp_0._yvalues[temp_0._tvalues.length + 0 | 0] = y0;
    temp_0._yvalues[temp_0._tvalues.length + 1 | 0] = y3;
    return target.setBounds(minOrElse(temp_0._xvalues, 0.0), minOrElse(temp_0._yvalues, 0.0), maxOrElse(temp_0._xvalues, 0.0), maxOrElse(temp_0._yvalues, 0.0));
  };
  Companion_90.prototype.cubicCalc = function (x0, y0, x1, y1, x2, y2, x3, y3, t, target) {
    var cx_1 = 3.0 * (x1 - x0);
    var bx_2 = 3.0 * (x2 - x1) - cx_1;
    var ax_3 = x3 - x0 - cx_1 - bx_2;
    var cy_4 = 3.0 * (y1 - y0);
    var by_5 = 3.0 * (y2 - y1) - cy_4;
    var ay_6 = y3 - y0 - cy_4 - by_5;
    var tSquared_7 = t * t;
    var tCubed_8 = tSquared_7 * t;
    var tmp0__anonymous__9 = ax_3 * tCubed_8 + bx_2 * tSquared_7 + cx_1 * t + x0;
    var tmp1__anonymous__9 = ay_6 * tCubed_8 + by_5 * tSquared_7 + cy_4 * t + y0;
    return target.setTo_0(tmp0__anonymous__9, tmp1__anonymous__9);
  };
  Companion_90.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_89;
  function Companion_getInstance_89() {
    if (Companion_instance_89 == null)
      new Companion_90();
    return Companion_instance_89;
  }
  function Algo() {
  }
  Algo.$metadata$ = {
    simpleName: 'Algo',
    kind: 'interface',
    interfaces: []
  };
  function Companion_91() {
    Companion_instance_90 = this;
  }
  Companion_91.prototype.invoke_326 = function (width, height, algo) {
    return new BinPacker(width, height, algo);
  };
  Companion_91.prototype.invoke$default_2 = function (width, height, algo, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      algo = new MaxRects(width, height);
    return this.invoke_326(width, height, algo);
  };
  Companion_91.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_90;
  function Companion_getInstance_90() {
    if (Companion_instance_90 == null)
      new Companion_91();
    return Companion_instance_90;
  }
  function BinPacker(width, height, algo) {
    Companion_getInstance_90();
    this._width_1 = width;
    this._height_1 = height;
    this._algo = algo;
    var tmp = this;
    tmp._allocated = ArrayList_init_$Create$();
  }
  BinPacker.prototype.add_52 = function (width, height) {
    var tmp0_elvis_lhs = this.addOrNull(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('' + "Size '" + this._width_1 + 'x' + this._height_1 + "' doesn't fit in '" + this._width_1 + 'x' + this._height_1 + "'");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  BinPacker.prototype.addOrNull = function (width, height) {
    var tmp0_elvis_lhs = this._algo.add_52(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rect_1 = tmp;
    var tmp1_this = this;
    var tmp0_plusAssign_0 = tmp1_this._allocated;
    tmp0_plusAssign_0.add_39(rect_1);
    Unit_getInstance();
    return rect_1;
  };
  BinPacker.$metadata$ = {
    simpleName: 'BinPacker',
    kind: 'class',
    interfaces: []
  };
  function quickFindPositionForNewNodeBestAreaFit($this, width, height) {
    var score = 1.7976931348623157E308;
    var areaFit;
    var bestNode = Companion_getInstance_83().invoke_1005();
    var tmp0_iterator = $this._freeRectangles.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var r = tmp0_iterator.next_37();
      if (r._width_0 >= width ? r._height_0 >= height : false) {
        areaFit = r._width_0 * r._height_0 - width * height;
        if (areaFit < score) {
          bestNode._x_3 = r._x_3;
          bestNode._y_3 = r._y_3;
          bestNode._width_0 = width;
          bestNode._height_0 = height;
          score = areaFit;
        }}}
    return bestNode;
  }
  function splitFreeNode($this, freeNode, usedNode) {
    var newNode;
    if (((usedNode._get_left__4() >= freeNode._get_right__2() ? true : usedNode._get_right__2() <= freeNode._x_3) ? true : usedNode._get_top__4() >= freeNode._get_bottom__2()) ? true : usedNode._get_bottom__2() <= freeNode._get_top__4()) {
      return false;
    }if (usedNode._x_3 < freeNode._get_right__2() ? usedNode._get_right__2() > freeNode._x_3 : false) {
      if (usedNode._y_3 > freeNode._y_3 ? usedNode._y_3 < freeNode._get_bottom__2() : false) {
        newNode = freeNode.clone_8();
        newNode._height_0 = usedNode._y_3 - newNode._y_3;
        $this._freeRectangles.add_39(newNode);
        Unit_getInstance();
      }if (usedNode._get_bottom__2() < freeNode._get_bottom__2()) {
        newNode = freeNode.clone_8();
        newNode._set_top_(usedNode._get_bottom__2());
        newNode._height_0 = freeNode._get_bottom__2() - usedNode._get_bottom__2();
        $this._freeRectangles.add_39(newNode);
        Unit_getInstance();
      }}if (usedNode._y_3 < freeNode._get_bottom__2() ? usedNode._get_bottom__2() > freeNode._y_3 : false) {
      if (usedNode._x_3 > freeNode._x_3 ? usedNode._x_3 < freeNode._get_right__2() : false) {
        newNode = freeNode.clone_8();
        newNode._width_0 = usedNode._x_3 - newNode._x_3;
        $this._freeRectangles.add_39(newNode);
        Unit_getInstance();
      }if (usedNode._get_right__2() < freeNode._get_right__2()) {
        newNode = freeNode.clone_8();
        newNode._x_3 = usedNode._get_right__2();
        newNode._width_0 = freeNode._get_right__2() - usedNode._get_right__2();
        $this._freeRectangles.add_39(newNode);
        Unit_getInstance();
      }}return true;
  }
  function pruneFreeList($this) {
    var len = $this._freeRectangles._get_size__60();
    var i = 0;
    while (i < len) {
      var j = i + 1 | 0;
      var tmpRect = $this._freeRectangles.get_137(i);
      $l$break: while (j < len) {
        var tmpRect2 = $this._freeRectangles.get_137(j);
        if (Companion_getInstance_83().isContainedIn(tmpRect, tmpRect2)) {
          $this._freeRectangles.removeAt_6(i);
          Unit_getInstance();
          i = i - 1 | 0;
          Unit_getInstance();
          len = len - 1 | 0;
          Unit_getInstance();
          break $l$break;
        }if (Companion_getInstance_83().isContainedIn(tmpRect2, tmpRect)) {
          $this._freeRectangles.removeAt_6(j);
          Unit_getInstance();
          len = len - 1 | 0;
          Unit_getInstance();
          j = j - 1 | 0;
          Unit_getInstance();
        }var tmp0 = j;
        j = tmp0 + 1 | 0;
        Unit_getInstance();
      }
      var tmp1 = i;
      i = tmp1 + 1 | 0;
      Unit_getInstance();
    }
  }
  function MaxRects(maxWidth, maxHeight) {
    this._freeRectangles = arrayListOf([new Rectangle(0.0, 0.0, maxWidth, maxHeight)]);
  }
  MaxRects.prototype.add_52 = function (width, height) {
    return this.quickInsert(width, height);
  };
  MaxRects.prototype.quickInsert = function (width, height) {
    if (width <= 0.0 ? height <= 0.0 : false)
      return Companion_getInstance_83().invoke_310(0, 0, 0, 0);
    var newNode = quickFindPositionForNewNodeBestAreaFit(this, width, height);
    if (newNode._height_0 === 0.0)
      return null;
    var numRectanglesToProcess = this._freeRectangles._get_size__60();
    var i = 0;
    while (i < numRectanglesToProcess) {
      if (splitFreeNode(this, this._freeRectangles.get_137(i), newNode)) {
        this._freeRectangles.removeAt_6(i);
        Unit_getInstance();
        numRectanglesToProcess = numRectanglesToProcess - 1 | 0;
        Unit_getInstance();
        i = i - 1 | 0;
        Unit_getInstance();
      }var tmp0 = i;
      i = tmp0 + 1 | 0;
      Unit_getInstance();
    }
    pruneFreeList(this);
    return newNode;
  };
  MaxRects.$metadata$ = {
    simpleName: 'MaxRects',
    kind: 'class',
    interfaces: [Algo]
  };
  function Companion_92() {
    Companion_instance_91 = this;
  }
  Companion_92.prototype.getIntersectXY = function (a, b, out) {
    var Ax_1 = a._ax;
    var Ay_2 = a._ay;
    var Bx_3 = a._bx;
    var By_4 = a._by;
    var Cx_5 = b._ax;
    var Cy_6 = b._ay;
    var Dx_7 = b._bx;
    var Dy_8 = b._by;
    var tmp$ret$0;
    l$ret$1: do {
      var a1_1 = By_4 - Ay_2;
      var b1_2 = Ax_1 - Bx_3;
      var c1_3 = a1_1 * Ax_1 + b1_2 * Ay_2;
      var a2_4 = Dy_8 - Cy_6;
      var b2_5 = Cx_5 - Dx_7;
      var c2_6 = a2_4 * Cx_5 + b2_5 * Cy_6;
      var determinant_7 = a1_1 * b2_5 - a2_4 * b1_2;
      if (determinant_7 === 0.0) {
        tmp$ret$0 = false;
        break l$ret$1;
      }var x_8 = (b2_5 * c1_3 - b1_2 * c2_6) / determinant_7;
      var y_9 = (a1_1 * c2_6 - a2_4 * c1_3) / determinant_7;
      var tmp0__anonymous__10 = floorCeil(x_8);
      var tmp1__anonymous__10 = floorCeil(y_9);
      return out.setTo_0(tmp0__anonymous__10, tmp1__anonymous__10);
    }
     while (false);
    Unit_getInstance();
    return null;
  };
  Companion_92.prototype.angleBetween = function (a, b) {
    return minus_2(b._get_angle_(), a._get_angle_());
  };
  Companion_92.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_91;
  function Companion_getInstance_91() {
    if (Companion_instance_91 == null)
      new Companion_92();
    return Companion_instance_91;
  }
  function Edge() {
    Companion_getInstance_91();
    this._ax = 0;
    this._ay = 0;
    this._bx = 0;
    this._by = 0;
    this._wind = 0;
    this._dy = 0;
    this._dx = 0;
    this._isCoplanarX = false;
    this._isCoplanarY = false;
    this._h = 0;
  }
  Edge.prototype.getX_2 = function (n) {
    return n === 0 ? this._ax : this._bx;
  };
  Edge.prototype.getY_2 = function (n) {
    return n === 0 ? this._ay : this._by;
  };
  Edge.prototype.copyFrom_3 = function (other) {
    return this.setTo_4(other._ax, other._ay, other._bx, other._by, other._wind);
  };
  Edge.prototype.setTo_4 = function (ax, ay, bx, by, wind) {
    this._ax = ax;
    this._ay = ay;
    this._bx = bx;
    this._by = by;
    this._dx = bx - ax | 0;
    this._dy = by - ay | 0;
    this._isCoplanarX = ay === by;
    this._isCoplanarY = ax === bx;
    this._wind = wind;
    this._h = this._isCoplanarY ? 0 : ay - (imul(ax, this._dy) / this._dx | 0) | 0;
    return this;
  };
  Edge.prototype._get_minY_ = function () {
    return min2_4(this._ay, this._by);
  };
  Edge.prototype._get_maxY_ = function () {
    return max2_4(this._ay, this._by);
  };
  Edge.prototype.containsY = function (y) {
    return y >= this._ay ? y < this._by : false;
  };
  Edge.prototype.intersectX = function (y) {
    return this._isCoplanarY ? this._ax : imul(y - this._h | 0, this._dx) / this._dy | 0;
  };
  Edge.prototype._get_angle_ = function () {
    return Companion_getInstance_75().between_0(this._ax, this._ay, this._bx, this._by);
  };
  Edge.prototype.toString = function () {
    return '' + 'Edge([' + this._ax + ',' + this._ay + ']-[' + this._bx + ',' + this._by + '])';
  };
  Edge.$metadata$ = {
    simpleName: 'Edge',
    kind: 'class',
    interfaces: []
  };
  var LineCap_BUTT_instance;
  var LineCap_SQUARE_instance;
  var LineCap_ROUND_instance;
  function Companion_93() {
    Companion_instance_92 = this;
  }
  Companion_93.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_92;
  function Companion_getInstance_92() {
    if (Companion_instance_92 == null)
      new Companion_93();
    return Companion_instance_92;
  }
  var LineCap_entriesInitialized;
  function LineCap_initEntries() {
    if (LineCap_entriesInitialized)
      return Unit_getInstance();
    LineCap_entriesInitialized = true;
    LineCap_BUTT_instance = new LineCap('BUTT', 0);
    LineCap_SQUARE_instance = new LineCap('SQUARE', 1);
    LineCap_ROUND_instance = new LineCap('ROUND', 2);
    Companion_getInstance_92();
  }
  function LineCap(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  LineCap.$metadata$ = {
    simpleName: 'LineCap',
    kind: 'class',
    interfaces: []
  };
  function LineCap_BUTT_getInstance() {
    LineCap_initEntries();
    return LineCap_BUTT_instance;
  }
  function LineCap_SQUARE_getInstance() {
    LineCap_initEntries();
    return LineCap_SQUARE_instance;
  }
  function LineCap_ROUND_getInstance() {
    LineCap_initEntries();
    return LineCap_ROUND_instance;
  }
  var LineJoin_BEVEL_instance;
  var LineJoin_ROUND_instance;
  var LineJoin_MITER_instance;
  function Companion_94() {
    Companion_instance_93 = this;
    this._SQUARE = LineJoin_BEVEL_getInstance();
  }
  Companion_94.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_93;
  function Companion_getInstance_93() {
    if (Companion_instance_93 == null)
      new Companion_94();
    return Companion_instance_93;
  }
  var LineJoin_entriesInitialized;
  function LineJoin_initEntries() {
    if (LineJoin_entriesInitialized)
      return Unit_getInstance();
    LineJoin_entriesInitialized = true;
    LineJoin_BEVEL_instance = new LineJoin('BEVEL', 0);
    LineJoin_ROUND_instance = new LineJoin('ROUND', 1);
    LineJoin_MITER_instance = new LineJoin('MITER', 2);
    Companion_getInstance_93();
  }
  function LineJoin(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  LineJoin.$metadata$ = {
    simpleName: 'LineJoin',
    kind: 'class',
    interfaces: []
  };
  function LineJoin_BEVEL_getInstance() {
    LineJoin_initEntries();
    return LineJoin_BEVEL_instance;
  }
  function LineJoin_ROUND_getInstance() {
    LineJoin_initEntries();
    return LineJoin_ROUND_instance;
  }
  function LineJoin_MITER_getInstance() {
    LineJoin_initEntries();
    return LineJoin_MITER_instance;
  }
  function _no_name_provided__208() {
  }
  _no_name_provided__208.prototype.invoke_327 = function (it) {
    it.clear_19();
    Unit_getInstance();
  };
  _no_name_provided__208.prototype.invoke_1015 = function (p1) {
    this.invoke_327(p1 instanceof Bucket ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__208.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__209() {
  }
  _no_name_provided__209.prototype.invoke_874 = function (it) {
    return new Bucket();
  };
  _no_name_provided__209.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__209.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Bucket() {
    this._edges = FastArrayList_init_$Create$();
  }
  Bucket.prototype.clear_19 = function () {
    this._edges.clear_33();
    return this;
  };
  Bucket.$metadata$ = {
    simpleName: 'Bucket',
    kind: 'class',
    interfaces: []
  };
  function Buckets(pool, ySize) {
    this._pool = pool;
    this._ySize = ySize;
    this._buckets = FastIntMap();
  }
  Buckets.prototype._get_size__60 = function () {
    return _get_size_(this._buckets);
  };
  Buckets.prototype.getIndex = function (y) {
    return y / this._ySize | 0;
  };
  Buckets.prototype.getForIndex = function (index) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getOrPut_0 = this._buckets;
      var res_1 = tmp0_getOrPut_0.get(index);
      if (!(res_1 == null)) {
        tmp$ret$0 = res_1;
        break l$ret$1;
      }var out_2 = this._pool.alloc();
      tmp0_getOrPut_0.set(index, out_2);
      tmp$ret$0 = out_2;
    }
     while (false);
    return tmp$ret$0;
  };
  Buckets.prototype.getForYOrNull = function (y) {
    var tmp0_get_0 = this._buckets;
    var tmp1_get_0 = this.getIndex(y);
    return tmp0_get_0.get(tmp1_get_0);
  };
  Buckets.prototype.clear_33 = function () {
    var tmp0_fastForEach_0 = this._buckets;
    var mapIterator_1_1 = tmp0_fastForEach_0.keys();
    $l$break: while (true) {
      var v_2_2 = mapIterator_1_1.next();
      if (v_2_2.done)
        break $l$break;
      var tmp0__anonymous__3_3 = v_2_2.value;
      var tmp1__anonymous__4 = ensureNotNull(tmp0_fastForEach_0.get(tmp0__anonymous__3_3));
      this._pool.free(tmp1__anonymous__4.clear_19());
    }
    var tmp2_clear_0 = this._buckets;
    tmp2_clear_0.clear();
  };
  Buckets.prototype.addThresold = function (edge, threshold) {
    var min = this.getIndex(edge._get_minY_());
    var max = this.getIndex(edge._get_maxY_());
    if ((max - min | 0) < threshold) {
      var inductionVariable = min;
      if (inductionVariable <= max)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.getForIndex(n)._edges.add_39(edge);
          Unit_getInstance();
        }
         while (!(n === max));
      return true;
    }return false;
  };
  Buckets.prototype.addThresold$default = function (edge, threshold, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      threshold = IntCompanionObject_getInstance()._MAX_VALUE_4;
    return this.addThresold(edge, threshold);
  };
  Buckets.$metadata$ = {
    simpleName: 'Buckets',
    kind: 'class',
    interfaces: []
  };
  function AllBuckets() {
    var tmp = this;
    var tmp_0 = _no_name_provided_$factory_171();
    tmp._pool_0 = Pool_init_$Create$(tmp_0, 0, _no_name_provided_$factory_172(), 2, null);
    this._small = new Buckets(this._pool_0, 80);
    this._medium = new Buckets(this._pool_0, 320);
    this._big = new Buckets(this._pool_0, 1280);
  }
  AllBuckets.prototype.add_53 = function (edge) {
    if (this._small.addThresold(edge, 4))
      return Unit_getInstance();
    if (this._medium.addThresold(edge, 4))
      return Unit_getInstance();
    this._big.addThresold$default(edge, 0, 2, null);
    Unit_getInstance();
  };
  AllBuckets.prototype.clear_33 = function () {
    this._small.clear_33();
    this._medium.clear_33();
    this._big.clear_33();
  };
  AllBuckets.$metadata$ = {
    simpleName: 'AllBuckets',
    kind: 'class',
    interfaces: []
  };
  function addPoint($this, x, y) {
    $this._points.add_52(x, y);
    Unit_getInstance();
  }
  function addEdge($this, ax, ay, bx, by) {
    if (ax === bx ? ay === by : false)
      return Unit_getInstance();
    if (ay === by)
      return Unit_getInstance();
    var iax = $this._get_s__2(ax);
    var ibx = $this._get_s__2(bx);
    var iay = $this._get_s__2(ay);
    var iby = $this._get_s__2(by);
    var edge = ay < by ? $this._edgesPool.alloc().setTo_4(iax, iay, ibx, iby, 1) : $this._edgesPool.alloc().setTo_4(ibx, iby, iax, iay, -1);
    $this._edges_0.add_39(edge);
    Unit_getInstance();
    $this._buckets_0.add_53(edge);
    $this._boundsBuilder.add_52(ax, ay);
    Unit_getInstance();
    $this._boundsBuilder.add_52(bx, by);
    Unit_getInstance();
  }
  function XWithWind() {
    this._x_4 = new IntArrayList(1024);
    this._w_0 = new IntArrayList(1024);
  }
  XWithWind.prototype._get_size__60 = function () {
    return this._x_4._get_size__60();
  };
  XWithWind.prototype.add_62 = function (x, wind) {
    this._x_4.add_26(x);
    this._w_0.add_26(wind);
  };
  XWithWind.prototype.clear_33 = function () {
    this._x_4.clear_33();
    this._w_0.clear_33();
  };
  XWithWind.prototype.toString = function () {
    return '' + 'XWithWind(' + this._x_4 + ', ' + this._w_0 + ')';
  };
  XWithWind.$metadata$ = {
    simpleName: 'XWithWind',
    kind: 'class',
    interfaces: []
  };
  function IntArrayListSort() {
    IntArrayListSort_instance = this;
    SortOps.call(this);
  }
  IntArrayListSort.prototype.compare_8 = function (subject, l, r) {
    return compareTo(subject._x_4.getAt_0(l), subject._x_4.getAt_0(r));
  };
  IntArrayListSort.prototype.compare_9 = function (subject, l, r) {
    return this.compare_8(subject instanceof XWithWind ? subject : THROW_CCE(), l, r);
  };
  IntArrayListSort.prototype.swap_1 = function (subject, indexL, indexR) {
    subject._x_4.swap(indexL, indexR);
    subject._w_0.swap(indexL, indexR);
  };
  IntArrayListSort.prototype.swap_2 = function (subject, indexL, indexR) {
    return this.swap_1(subject instanceof XWithWind ? subject : THROW_CCE(), indexL, indexR);
  };
  IntArrayListSort.$metadata$ = {
    simpleName: 'IntArrayListSort',
    kind: 'object',
    interfaces: []
  };
  var IntArrayListSort_instance;
  function IntArrayListSort_getInstance() {
    if (IntArrayListSort_instance == null)
      new IntArrayListSort();
    return IntArrayListSort_instance;
  }
  function _no_name_provided__210() {
  }
  _no_name_provided__210.prototype.invoke_874 = function (it) {
    return new Edge();
  };
  _no_name_provided__210.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__210.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PolygonScanline() {
    RastScale.call(this);
    this._version_0 = 0;
    this._winding = Winding_NON_ZERO_getInstance();
    this._boundsBuilder = new BoundsBuilder();
    var tmp = this;
    tmp._edgesPool = Pool_init_$Create$_1(0, _no_name_provided_$factory_170(), 1, null);
    this._edges_0 = FastArrayList_init_$Create$();
    this._buckets_0 = new AllBuckets();
    this._closed = true;
    var tmp_0 = this;
    tmp_0._points = PointArrayList_init_$Create$(0, 1, null);
    this._moveToX = 0.0;
    this._moveToY = 0.0;
    this._lastX = 0.0;
    this._lastY = 0.0;
    this._lastMoveTo = false;
    this._tempXW = new XWithWind();
    this._edgesChecked = 0;
    this._ss = new IntSegmentSet();
  }
  PolygonScanline.prototype.getBounds_0 = function (out) {
    return this._boundsBuilder.getBounds_0(out);
  };
  PolygonScanline.prototype.reset_9 = function () {
    this._closed = true;
    this._boundsBuilder.reset_9();
    var tmp0_fastForEach_0 = this._edges_0;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      this._edgesPool.free(tmp1__anonymous__3);
    }
    this._edges_0.clear_33();
    this._points.clear_19();
    Unit_getInstance();
    this._buckets_0.clear_33();
    this._moveToX = 0.0;
    this._moveToY = 0.0;
    this._lastX = 0.0;
    this._lastY = 0.0;
    this._lastMoveTo = false;
  };
  PolygonScanline.prototype._get_edgesSize_ = function () {
    return this._edges_0._get_size__60();
  };
  PolygonScanline.prototype.isNotEmpty_1 = function () {
    return this._get_edgesSize_() > 0;
  };
  PolygonScanline.prototype.moveTo_9 = function (x, y) {
    this._lastX = x;
    this._lastY = y;
    this._moveToX = x;
    this._moveToY = y;
    this._lastMoveTo = true;
  };
  PolygonScanline.prototype.lineTo_9 = function (x, y) {
    if (this._lastMoveTo) {
      addPoint(this, this._lastX, this._lastY);
    }addEdge(this, this._lastX, this._lastY, x, y);
    addPoint(this, x, y);
    this._lastX = x;
    this._lastY = y;
    this._lastMoveTo = false;
  };
  PolygonScanline.prototype.add_55 = function (path_0) {
    var ix_3 = 0.0;
    var iy_4 = 0.0;
    var lx_5 = {_v: 0.0};
    var ly_6 = {_v: 0.0};
    var tmp0__anonymous__119 = false;
    if (tmp0__anonymous__119)
      this.close_77();
    var n_1_7 = 0;
    var tmp0_fastForEach_0_8 = path_0._commands;
    var n_1_9 = 0;
    while (n_1_9 < tmp0_fastForEach_0_8._get_size__60()) {
      var tmp0_2_11 = n_1_9;
      n_1_9 = tmp0_2_11 + 1 | 0;
      var tmp1__anonymous__2_3_10 = tmp0_fastForEach_0_8.getAt_0(tmp0_2_11);
      var tmp0_subject_3_4_12 = tmp1__anonymous__2_3_10;
      switch (tmp0_subject_3_4_12) {
        case 0:
          var tmp1_4_5_14 = n_1_7;
          n_1_7 = tmp1_4_5_14 + 1 | 0;
          var tmp2__anonymous__18_13 = path_0._data_37.get_137(tmp1_4_5_14);
          var tmp2_5_6_16 = n_1_7;
          n_1_7 = tmp2_5_6_16 + 1 | 0;
          var tmp3__anonymous__18_15 = path_0._data_37.get_137(tmp2_5_6_16);
          ix_3 = tmp2__anonymous__18_13;
          iy_4 = tmp3__anonymous__18_15;
          var tmp1__anonymous__120 = true;
          var tmp0_also_0_20_18 = this.add_56(tmp2__anonymous__18_13, tmp3__anonymous__18_15, tmp1__anonymous__120);
          lx_5._v = tmp2__anonymous__18_13;
          var tmp1_also_0_19_17 = tmp0_also_0_20_18;
          ly_6._v = tmp3__anonymous__18_15;
          break;
        case 1:
          var tmp3_6_7_20 = n_1_7;
          n_1_7 = tmp3_6_7_20 + 1 | 0;
          var tmp4__anonymous__21_19 = path_0._data_37.get_137(tmp3_6_7_20);
          var tmp4_7_8_22 = n_1_7;
          n_1_7 = tmp4_7_8_22 + 1 | 0;
          var tmp5__anonymous__21_21 = path_0._data_37.get_137(tmp4_7_8_22);
          var tmp2__anonymous__120 = false;
          var tmp0_also_0_23_24 = this.add_56(tmp4__anonymous__21_19, tmp5__anonymous__21_21, tmp2__anonymous__120);
          lx_5._v = tmp4__anonymous__21_19;
          var tmp1_also_0_22_23 = tmp0_also_0_23_24;
          ly_6._v = tmp5__anonymous__21_21;
          var tmp3__anonymous__2_121 = false;
          Unit_getInstance();
          break;
        case 2:
          var tmp5_8_9_26 = n_1_7;
          n_1_7 = tmp5_8_9_26 + 1 | 0;
          var tmp6__anonymous__24_25 = path_0._data_37.get_137(tmp5_8_9_26);
          var tmp6_9_10_28 = n_1_7;
          n_1_7 = tmp6_9_10_28 + 1 | 0;
          var tmp7__anonymous__24_27 = path_0._data_37.get_137(tmp6_9_10_28);
          var tmp7_10_11_30 = n_1_7;
          n_1_7 = tmp7_10_11_30 + 1 | 0;
          var tmp8__anonymous__24_29 = path_0._data_37.get_137(tmp7_10_11_30);
          var tmp8_11_12_32 = n_1_7;
          n_1_7 = tmp8_11_12_32 + 1 | 0;
          var tmp9__anonymous__24_31 = path_0._data_37.get_137(tmp8_11_12_32);
          var sum_25_33 = Companion_getInstance_80().distance(lx_5._v, ly_6._v, tmp6__anonymous__24_25, tmp7__anonymous__24_27) + Companion_getInstance_80().distance(tmp6__anonymous__24_25, tmp7__anonymous__24_27, tmp8__anonymous__24_29, tmp9__anonymous__24_31);
          var tmp0_approximateCurve_0_26_34 = numberToInt(sum_25_33);
          var rcurveSteps_1_27_35 = max2_4(tmp0_approximateCurve_0_26_34, 20);
          var dt_2_28_36 = 1.0 / rcurveSteps_1_27_35;
          var lastX_3_29_37 = {_v: 0.0};
          var lastY_4_30_38 = {_v: 0.0};
          var prevX_5_31_39 = {_v: 0.0};
          var prevY_6_32_40 = {_v: 0.0};
          var emittedCount_7_33_41 = {_v: 0};
          var tmp1__anonymous__15_34_42 = 0.0;
          var tmp0_quadCalc_0_16_35_43 = Companion_getInstance_89();
          var tmp1_quadCalc_0_17_36_44 = lx_5._v;
          var tmp2_quadCalc_0_18_37_45 = ly_6._v;
          var t1_1_19_38_46 = 1 - tmp1__anonymous__15_34_42;
          var a_2_20_39_47 = t1_1_19_38_46 * t1_1_19_38_46;
          var c_3_21_40_48 = tmp1__anonymous__15_34_42 * tmp1__anonymous__15_34_42;
          var b_4_22_41_49 = 2 * t1_1_19_38_46 * tmp1__anonymous__15_34_42;
          var tmp3__anonymous__5_23_42_50 = a_2_20_39_47 * tmp1_quadCalc_0_17_36_44 + b_4_22_41_49 * tmp6__anonymous__24_25 + c_3_21_40_48 * tmp8__anonymous__24_29;
          var tmp4__anonymous__5_24_43_51 = a_2_20_39_47 * tmp2_quadCalc_0_18_37_45 + b_4_22_41_49 * tmp7__anonymous__24_27 + c_3_21_40_48 * tmp9__anonymous__24_31;
          lastX_3_29_37._v = tmp3__anonymous__5_23_42_50;
          lastY_4_30_38._v = tmp4__anonymous__5_24_43_51;
          var inductionVariable = 1;
          if (inductionVariable < rcurveSteps_1_27_35)
            do {
              var n_10_45_53 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_11_46_54 = n_10_45_53 * dt_2_28_36;
              var tmp0_quadCalc_0_16_47_55 = Companion_getInstance_89();
              var tmp1_quadCalc_0_17_48_56 = lx_5._v;
              var tmp2_quadCalc_0_18_49_57 = ly_6._v;
              var t1_1_19_50_58 = 1 - ratio_11_46_54;
              var a_2_20_51_59 = t1_1_19_50_58 * t1_1_19_50_58;
              var c_3_21_52_60 = ratio_11_46_54 * ratio_11_46_54;
              var b_4_22_53_61 = 2 * t1_1_19_50_58 * ratio_11_46_54;
              var tmp3__anonymous__5_23_54_62 = a_2_20_51_59 * tmp1_quadCalc_0_17_48_56 + b_4_22_53_61 * tmp6__anonymous__24_25 + c_3_21_52_60 * tmp8__anonymous__24_29;
              var tmp4__anonymous__5_24_55_63 = a_2_20_51_59 * tmp2_quadCalc_0_18_49_57 + b_4_22_53_61 * tmp7__anonymous__24_27 + c_3_21_52_60 * tmp9__anonymous__24_31;
              var tmp4__anonymous__120 = false;
              this.add_56(tmp3__anonymous__5_23_54_62, tmp4__anonymous__5_24_55_63, tmp4__anonymous__120);
              var tmp0_14_2_27_56_64 = emittedCount_7_33_41._v;
              emittedCount_7_33_41._v = tmp0_14_2_27_56_64 + 1 | 0;
              Unit_getInstance();
              lastX_3_29_37._v = prevX_5_31_39._v;
              lastY_4_30_38._v = prevY_6_32_40._v;
              prevX_5_31_39._v = tmp3__anonymous__5_23_54_62;
              prevY_6_32_40._v = tmp4__anonymous__5_24_55_63;
            }
             while (inductionVariable < rcurveSteps_1_27_35);
          var tmp2_also_0_57_65 = lx_5._v = tmp8__anonymous__24_29;
          ly_6._v = tmp9__anonymous__24_31;
          var tmp5__anonymous__2_121 = false;
          Unit_getInstance();
          break;
        case 3:
          var tmp9_12_13_67 = n_1_7;
          n_1_7 = tmp9_12_13_67 + 1 | 0;
          var tmp10__anonymous__58_66 = path_0._data_37.get_137(tmp9_12_13_67);
          var tmp10_13_14_69 = n_1_7;
          n_1_7 = tmp10_13_14_69 + 1 | 0;
          var tmp11__anonymous__58_68 = path_0._data_37.get_137(tmp10_13_14_69);
          var tmp11_14_15_71 = n_1_7;
          n_1_7 = tmp11_14_15_71 + 1 | 0;
          var tmp12__anonymous__58_70 = path_0._data_37.get_137(tmp11_14_15_71);
          var tmp12_15_16_73 = n_1_7;
          n_1_7 = tmp12_15_16_73 + 1 | 0;
          var tmp13__anonymous__58_72 = path_0._data_37.get_137(tmp12_15_16_73);
          var tmp13_16_17_75 = n_1_7;
          n_1_7 = tmp13_16_17_75 + 1 | 0;
          var tmp14__anonymous__58_74 = path_0._data_37.get_137(tmp13_16_17_75);
          var tmp14_17_18_77 = n_1_7;
          n_1_7 = tmp14_17_18_77 + 1 | 0;
          var tmp15__anonymous__58_76 = path_0._data_37.get_137(tmp14_17_18_77);
          var sum_59_78 = Companion_getInstance_80().distance(lx_5._v, ly_6._v, tmp10__anonymous__58_66, tmp11__anonymous__58_68) + Companion_getInstance_80().distance(tmp10__anonymous__58_66, tmp11__anonymous__58_68, tmp12__anonymous__58_70, tmp13__anonymous__58_72) + Companion_getInstance_80().distance(tmp12__anonymous__58_70, tmp13__anonymous__58_72, tmp14__anonymous__58_74, tmp15__anonymous__58_76);
          var tmp0_approximateCurve_0_60_79 = numberToInt(sum_59_78);
          var rcurveSteps_1_61_80 = max2_4(tmp0_approximateCurve_0_60_79, 20);
          var dt_2_62_81 = 1.0 / rcurveSteps_1_61_80;
          var lastX_3_63_82 = {_v: 0.0};
          var lastY_4_64_83 = {_v: 0.0};
          var prevX_5_65_84 = {_v: 0.0};
          var prevY_6_66_85 = {_v: 0.0};
          var emittedCount_7_67_86 = {_v: 0};
          var tmp1__anonymous__15_68_87 = 0.0;
          var tmp0_cubicCalc_0_16_69_88 = Companion_getInstance_89();
          var tmp1_cubicCalc_0_17_70_89 = lx_5._v;
          var tmp2_cubicCalc_0_18_71_90 = ly_6._v;
          var cx_1_19_72_91 = 3.0 * (tmp10__anonymous__58_66 - tmp1_cubicCalc_0_17_70_89);
          var bx_2_20_73_92 = 3.0 * (tmp12__anonymous__58_70 - tmp10__anonymous__58_66) - cx_1_19_72_91;
          var ax_3_21_74_93 = tmp14__anonymous__58_74 - tmp1_cubicCalc_0_17_70_89 - cx_1_19_72_91 - bx_2_20_73_92;
          var cy_4_22_75_94 = 3.0 * (tmp11__anonymous__58_68 - tmp2_cubicCalc_0_18_71_90);
          var by_5_23_76_95 = 3.0 * (tmp13__anonymous__58_72 - tmp11__anonymous__58_68) - cy_4_22_75_94;
          var ay_6_24_77_96 = tmp15__anonymous__58_76 - tmp2_cubicCalc_0_18_71_90 - cy_4_22_75_94 - by_5_23_76_95;
          var tSquared_7_25_78_97 = tmp1__anonymous__15_68_87 * tmp1__anonymous__15_68_87;
          var tCubed_8_26_79_98 = tSquared_7_25_78_97 * tmp1__anonymous__15_68_87;
          var tmp3__anonymous__9_27_80_99 = ax_3_21_74_93 * tCubed_8_26_79_98 + bx_2_20_73_92 * tSquared_7_25_78_97 + cx_1_19_72_91 * tmp1__anonymous__15_68_87 + tmp1_cubicCalc_0_17_70_89;
          var tmp4__anonymous__9_28_81_100 = ay_6_24_77_96 * tCubed_8_26_79_98 + by_5_23_76_95 * tSquared_7_25_78_97 + cy_4_22_75_94 * tmp1__anonymous__15_68_87 + tmp2_cubicCalc_0_18_71_90;
          lastX_3_63_82._v = tmp3__anonymous__9_27_80_99;
          lastY_4_64_83._v = tmp4__anonymous__9_28_81_100;
          var inductionVariable_0 = 1;
          if (inductionVariable_0 < rcurveSteps_1_61_80)
            do {
              var n_10_83_102 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_11_84_103 = n_10_83_102 * dt_2_62_81;
              var tmp0_cubicCalc_0_16_85_104 = Companion_getInstance_89();
              var tmp1_cubicCalc_0_17_86_105 = lx_5._v;
              var tmp2_cubicCalc_0_18_87_106 = ly_6._v;
              var cx_1_19_88_107 = 3.0 * (tmp10__anonymous__58_66 - tmp1_cubicCalc_0_17_86_105);
              var bx_2_20_89_108 = 3.0 * (tmp12__anonymous__58_70 - tmp10__anonymous__58_66) - cx_1_19_88_107;
              var ax_3_21_90_109 = tmp14__anonymous__58_74 - tmp1_cubicCalc_0_17_86_105 - cx_1_19_88_107 - bx_2_20_89_108;
              var cy_4_22_91_110 = 3.0 * (tmp11__anonymous__58_68 - tmp2_cubicCalc_0_18_87_106);
              var by_5_23_92_111 = 3.0 * (tmp13__anonymous__58_72 - tmp11__anonymous__58_68) - cy_4_22_91_110;
              var ay_6_24_93_112 = tmp15__anonymous__58_76 - tmp2_cubicCalc_0_18_87_106 - cy_4_22_91_110 - by_5_23_92_111;
              var tSquared_7_25_94_113 = ratio_11_84_103 * ratio_11_84_103;
              var tCubed_8_26_95_114 = tSquared_7_25_94_113 * ratio_11_84_103;
              var tmp3__anonymous__9_27_96_115 = ax_3_21_90_109 * tCubed_8_26_95_114 + bx_2_20_89_108 * tSquared_7_25_94_113 + cx_1_19_88_107 * ratio_11_84_103 + tmp1_cubicCalc_0_17_86_105;
              var tmp4__anonymous__9_28_97_116 = ay_6_24_93_112 * tCubed_8_26_95_114 + by_5_23_92_111 * tSquared_7_25_94_113 + cy_4_22_91_110 * ratio_11_84_103 + tmp2_cubicCalc_0_18_87_106;
              var tmp6__anonymous__120 = false;
              this.add_56(tmp3__anonymous__9_27_96_115, tmp4__anonymous__9_28_97_116, tmp6__anonymous__120);
              var tmp0_14_2_31_98_117 = emittedCount_7_67_86._v;
              emittedCount_7_67_86._v = tmp0_14_2_31_98_117 + 1 | 0;
              Unit_getInstance();
              lastX_3_63_82._v = prevX_5_65_84._v;
              lastY_4_64_83._v = prevY_6_66_85._v;
              prevX_5_65_84._v = tmp3__anonymous__9_27_96_115;
              prevY_6_66_85._v = tmp4__anonymous__9_28_97_116;
            }
             while (inductionVariable_0 < rcurveSteps_1_61_80);
          var tmp2_also_0_99_118 = lx_5._v = tmp14__anonymous__58_74;
          ly_6._v = tmp15__anonymous__58_76;
          var tmp7__anonymous__2_121 = false;
          Unit_getInstance();
          break;
        case 4:
          var tmp8__anonymous__120 = ix_3;
          var tmp9__anonymous__120 = iy_4;
          var tmp10__anonymous__120 = false;
          this.add_56(tmp8__anonymous__120, tmp9__anonymous__120, tmp10__anonymous__120);
          var tmp11__anonymous__2_121 = true;
          Unit_getInstance();
          var tmp12__anonymous__119 = true;
          if (tmp12__anonymous__119)
            this.close_77();
          break;
      }
    }
    var tmp13__anonymous__119 = false;
    if (tmp13__anonymous__119)
      this.close_77();
  };
  PolygonScanline.prototype.add_56 = function (x, y, move) {
    return move ? this.moveTo_9(x, y) : this.lineTo_9(x, y);
  };
  PolygonScanline.prototype.close_77 = function () {
    this.lineTo_9(this._moveToX, this._moveToY);
  };
  PolygonScanline.prototype.scanline = function (y, winding, out) {
    this._edgesChecked = 0;
    this._tempXW.clear_33();
    out.clear_19();
    Unit_getInstance();
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._edgesChecked;
    var edgesChecked_1 = 0;
    var tmp0_fastForEachY_0_2 = this._buckets_0;
    var tmp0_fastForEachY_0_1_3 = tmp0_fastForEachY_0_2._small;
    if (tmp0_fastForEachY_0_1_3._get_size__60() > 0) {
      var tmp0_safe_receiver_1_2_4 = tmp0_fastForEachY_0_1_3.getForYOrNull(y);
      if (tmp0_safe_receiver_1_2_4 == null)
        null;
      else {
        var tmp0_fastForEach_0_1_2_3_5 = tmp0_safe_receiver_1_2_4._edges;
        var n_1_2_3_4_6 = 0;
        while (n_1_2_3_4_6 < tmp0_fastForEach_0_1_2_3_5._get_size__60()) {
          var tmp0_2_3_4_6_8 = n_1_2_3_4_6;
          n_1_2_3_4_6 = tmp0_2_3_4_6_8 + 1 | 0;
          var tmp1__anonymous__5_5_7 = tmp0_fastForEach_0_1_2_3_5.get_137(tmp0_2_3_4_6_8);
          var tmp0_20_9 = edgesChecked_1;
          edgesChecked_1 = tmp0_20_9 + 1 | 0;
          Unit_getInstance();
          if (tmp1__anonymous__5_5_7.containsY(y)) {
            if (!tmp1__anonymous__5_5_7._isCoplanarX) {
              this._tempXW.add_62(tmp1__anonymous__5_5_7.intersectX(y), tmp1__anonymous__5_5_7._wind);
            }}}
        Unit_getInstance();
      }
      Unit_getInstance();
    }var tmp2_fastForEachY_0_7_10 = tmp0_fastForEachY_0_2._medium;
    if (tmp2_fastForEachY_0_7_10._get_size__60() > 0) {
      var tmp0_safe_receiver_1_8_11 = tmp2_fastForEachY_0_7_10.getForYOrNull(y);
      if (tmp0_safe_receiver_1_8_11 == null)
        null;
      else {
        var tmp0_fastForEach_0_1_2_9_12 = tmp0_safe_receiver_1_8_11._edges;
        var n_1_2_3_10_13 = 0;
        while (n_1_2_3_10_13 < tmp0_fastForEach_0_1_2_9_12._get_size__60()) {
          var tmp0_2_3_4_12_15 = n_1_2_3_10_13;
          n_1_2_3_10_13 = tmp0_2_3_4_12_15 + 1 | 0;
          var tmp3__anonymous__5_11_14 = tmp0_fastForEach_0_1_2_9_12.get_137(tmp0_2_3_4_12_15);
          var tmp0_20_16 = edgesChecked_1;
          edgesChecked_1 = tmp0_20_16 + 1 | 0;
          Unit_getInstance();
          if (tmp3__anonymous__5_11_14.containsY(y)) {
            if (!tmp3__anonymous__5_11_14._isCoplanarX) {
              this._tempXW.add_62(tmp3__anonymous__5_11_14.intersectX(y), tmp3__anonymous__5_11_14._wind);
            }}}
        Unit_getInstance();
      }
      Unit_getInstance();
    }var tmp4_fastForEachY_0_13_17 = tmp0_fastForEachY_0_2._big;
    if (tmp4_fastForEachY_0_13_17._get_size__60() > 0) {
      var tmp0_safe_receiver_1_14_18 = tmp4_fastForEachY_0_13_17.getForYOrNull(y);
      if (tmp0_safe_receiver_1_14_18 == null)
        null;
      else {
        var tmp0_fastForEach_0_1_2_15_19 = tmp0_safe_receiver_1_14_18._edges;
        var n_1_2_3_16_20 = 0;
        while (n_1_2_3_16_20 < tmp0_fastForEach_0_1_2_15_19._get_size__60()) {
          var tmp0_2_3_4_18_22 = n_1_2_3_16_20;
          n_1_2_3_16_20 = tmp0_2_3_4_18_22 + 1 | 0;
          var tmp5__anonymous__5_17_21 = tmp0_fastForEach_0_1_2_15_19.get_137(tmp0_2_3_4_18_22);
          var tmp0_20_23 = edgesChecked_1;
          edgesChecked_1 = tmp0_20_23 + 1 | 0;
          Unit_getInstance();
          if (tmp5__anonymous__5_17_21.containsY(y)) {
            if (!tmp5__anonymous__5_17_21._isCoplanarX) {
              this._tempXW.add_62(tmp5__anonymous__5_17_21.intersectX(y), tmp5__anonymous__5_17_21._wind);
            }}}
        Unit_getInstance();
      }
      Unit_getInstance();
    }tmp._edgesChecked = tmp_0 + edgesChecked_1 | 0;
    genericSort(this._tempXW, 0, this._tempXW._get_size__60() - 1 | 0, IntArrayListSort_getInstance());
    Unit_getInstance();
    var tempX = this._tempXW._x_4;
    var tempW = this._tempXW._w_0;
    if (this._tempXW._get_size__60() >= 2) {
      var tmp1_subject = winding;
      if (tmp1_subject.equals(Winding_EVEN_ODD_getInstance())) {
        var progression = step(until(0, tempX._get_size__60() - 1 | 0), 2);
        var inductionVariable = progression._first_0;
        var last_1 = progression._last;
        var step_0 = progression._step_2;
        if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            var a = tempX.getAt_0(i);
            var b = tempX.getAt_0(i + 1 | 0);
            out.add_58(a, b);
            Unit_getInstance();
          }
           while (!(i === last_1));
      } else if (tmp1_subject.equals(Winding_NON_ZERO_getInstance())) {
        var count_0 = 0;
        var startX = 0;
        var endX = 0;
        var pending = false;
        var inductionVariable_0 = 0;
        var last_2 = tempX._get_size__60() - 1 | 0;
        if (inductionVariable_0 < last_2)
          do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a_0 = tempX.getAt_0(i_0);
            count_0 = count_0 + tempW.getAt_0(i_0) | 0;
            var b_0 = tempX.getAt_0(i_0 + 1 | 0);
            if (!(count_0 === 0)) {
              if (pending ? !(a_0 === endX) : false) {
                out.add_58(startX, endX);
                Unit_getInstance();
                startX = a_0;
                endX = b_0;
              } else {
                if (!pending) {
                  startX = a_0;
                }endX = b_0;
              }
              pending = true;
            }}
           while (inductionVariable_0 < last_2);
        if (pending) {
          out.add_58(startX, endX);
          Unit_getInstance();
        }}}return out;
  };
  PolygonScanline.prototype.containsPoint_3 = function (x, y, winding) {
    return this.containsPointInt(this._get_s__2(x), this._get_s__2(y), winding);
  };
  PolygonScanline.prototype.containsPoint$default = function (x, y, winding, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      winding = this._winding;
    return this.containsPoint_3(x, y, winding);
  };
  PolygonScanline.prototype.containsPointInt = function (x, y, winding) {
    var ss = this._ss;
    this.scanline(y, winding, ss.clear_19());
    Unit_getInstance();
    return ss.contains_56(x);
  };
  PolygonScanline.$metadata$ = {
    simpleName: 'PolygonScanline',
    kind: 'class',
    interfaces: []
  };
  function Companion_95() {
    Companion_instance_94 = this;
    this._RAST_FIXED_SCALE = 20;
    this._RAST_FIXED_SCALE_HALF = 0;
    this._RAST_SMALL_BUCKET_SIZE = 80;
    this._RAST_MEDIUM_BUCKET_SIZE = 320;
    this._RAST_BIG_BUCKET_SIZE = 1280;
  }
  Companion_95.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_94;
  function Companion_getInstance_94() {
    if (Companion_instance_94 == null)
      new Companion_95();
    return Companion_instance_94;
  }
  function RastScale() {
    Companion_getInstance_94();
  }
  RastScale.prototype._get_sscale__1 = function () {
    return 20;
  };
  RastScale.prototype._get_hscale__1 = function () {
    return 0;
  };
  RastScale.prototype._get_s__2 = function (_this__0) {
    return numberToInt(_this__0 * this._get_sscale__1()) + this._get_hscale__1() | 0;
  };
  RastScale.$metadata$ = {
    simpleName: 'RastScale',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_170() {
    var i = new _no_name_provided__210();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function _no_name_provided_$factory_171() {
    var i = new _no_name_provided__208();
    return function (p1) {
      i.invoke_327(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_172() {
    var i = new _no_name_provided__209();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  var EdgePoint_A_instance;
  var EdgePoint_B_instance;
  var EdgePoint_entriesInitialized;
  function EdgePoint_initEntries() {
    if (EdgePoint_entriesInitialized)
      return Unit_getInstance();
    EdgePoint_entriesInitialized = true;
    EdgePoint_A_instance = new EdgePoint('A', 0, 0);
    EdgePoint_B_instance = new EdgePoint('B', 1, 1);
  }
  function _get_outFill_($this) {
    var tmp = $this._outFill;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('outFill');
    }
  }
  function EdgePoint(name, ordinal, n) {
    Enum.call(this, name, ordinal);
    this._n = n;
  }
  EdgePoint.$metadata$ = {
    simpleName: 'EdgePoint',
    kind: 'class',
    interfaces: []
  };
  function EdgePoint_A_getInstance() {
    EdgePoint_initEntries();
    return EdgePoint_A_instance;
  }
  function EdgePoint_B_getInstance() {
    EdgePoint_initEntries();
    return EdgePoint_B_instance;
  }
  function StrokeToFill() {
    this._weight = 1;
    this._startCap = LineCap_BUTT_getInstance();
    this._endCap = LineCap_BUTT_getInstance();
    this._joins = LineJoin_BEVEL_getInstance();
    this._miterLimit = 4.0;
    this._strokePoints = new PointIntArrayList(1024);
    this._doJointList = new IntArrayList(1024);
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 2;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new PointIntArrayList(1024);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._fillPoints = tmp_2;
    this._fillPointsLeft = this._fillPoints[0];
    this._fillPointsRight = this._fillPoints[1];
    this._prevEdge = new Edge();
    this._prevEdgeLeft = new Edge();
    this._prevEdgeRight = new Edge();
    this._currEdge = new Edge();
    this._currEdgeLeft = new Edge();
    this._currEdgeRight = new Edge();
    this._tempP1 = Companion_getInstance_80().invoke_1005();
    this._tempP2 = Companion_getInstance_80().invoke_1005();
    this._tempP3 = Companion_getInstance_80().invoke_1005();
  }
  StrokeToFill.prototype.setEdgeDisplaced = function (_this__0, edge, width, angle_0) {
    var ldx_2 = width * _get_cosine_(angle_0);
    var ldy_3 = width * _get_sine_(angle_0);
    _this__0.setTo_4(numberToInt(edge._ax + ldx_2), numberToInt(edge._ay + ldy_3), numberToInt(edge._bx + ldx_2), numberToInt(edge._by + ldy_3), edge._wind);
    Unit_getInstance();
    return _this__0;
  };
  StrokeToFill.prototype.addEdgePointA = function (_this__0, e) {
    return _this__0.add_58(e._ax, e._ay);
  };
  StrokeToFill.prototype.addEdgePointB = function (_this__0, e) {
    return _this__0.add_58(e._bx, e._by);
  };
  StrokeToFill.prototype.add_57 = function (_this__0, e) {
    var tmp;
    if (!(e == null)) {
      _this__0.add_58(numberToInt(e._x_2), numberToInt(e._y_2));
      tmp = Unit_getInstance();
    }return tmp;
  };
  StrokeToFill.prototype.doJoin = function (out, mainPrev, mainCurr, prev, curr, join, miterLimit, scale_1, forcedMiter) {
    var rjoin = forcedMiter ? LineJoin_MITER_getInstance() : join;
    var tmp0_subject = rjoin;
    if (tmp0_subject.equals(LineJoin_MITER_getInstance())) {
      var tmp0_setTo_0 = this._tempP1;
      var tmp1_setTo_0 = mainPrev._bx;
      var tmp2_setTo_0 = mainPrev._by;
      var intersection2 = tmp0_setTo_0.setTo_0(numberToDouble(tmp1_setTo_0), numberToDouble(tmp2_setTo_0));
      var intersection = Companion_getInstance_91().getIntersectXY(prev, curr, this._tempP3);
      if (!(intersection == null)) {
        var dist = Companion_getInstance_80().distance_1(intersection, intersection2);
        if (forcedMiter ? true : dist <= miterLimit) {
          this.add_57(out, intersection);
        } else {
          this.addEdgePointB(out, prev);
          Unit_getInstance();
          this.addEdgePointA(out, curr);
          Unit_getInstance();
        }
      }} else if (tmp0_subject.equals(LineJoin_BEVEL_getInstance())) {
      this.addEdgePointB(out, prev);
      Unit_getInstance();
      this.addEdgePointA(out, curr);
      Unit_getInstance();
    } else if (tmp0_subject.equals(LineJoin_ROUND_getInstance())) {
      var i = Companion_getInstance_91().getIntersectXY(prev, curr, this._tempP3);
      if (!(i == null)) {
        var count_0 = clamp_5(numberToInt(Companion_getInstance_80().distance_0(prev._bx, prev._by, curr._ax, curr._ay) * scale_1), 4, 64);
        var inductionVariable = 0;
        if (inductionVariable <= count_0)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.add_57(out, Companion_getInstance_89().quadCalc(prev._bx, prev._by, i._x_2, i._y_2, curr._ax, curr._ay, n / count_0, this._tempP2));
          }
           while (!(n === count_0));
      } else {
        this.addEdgePointB(out, prev);
        Unit_getInstance();
        this.addEdgePointA(out, curr);
        Unit_getInstance();
      }
    }};
  StrokeToFill.prototype.doCap = function (l, r, left, right, epoint, cap, scale_1) {
    var angle_0 = epoint.equals(EdgePoint_A_getInstance()) ? unaryMinus(left._get_angle_()) : unaryPlus(left._get_angle_());
    var lx = left.getX_2(epoint._n);
    var ly = left.getY_2(epoint._n);
    var rx = right.getX_2(epoint._n);
    var ry = right.getY_2(epoint._n);
    var tmp0_subject = cap;
    if (tmp0_subject.equals(LineCap_BUTT_getInstance())) {
      l.add_58(lx, ly);
      Unit_getInstance();
      r.add_58(rx, ry);
      Unit_getInstance();
    } else if (tmp0_subject.equals(LineCap_ROUND_getInstance()) ? true : tmp0_subject.equals(LineCap_SQUARE_getInstance())) {
      var ax = numberToInt(_get_cosine_(angle_0) * this._weight / 2);
      var ay = numberToInt(_get_sine_(angle_0) * this._weight / 2);
      var lx2 = lx + ax | 0;
      var ly2 = ly + ay | 0;
      var rx2 = rx + ax | 0;
      var ry2 = ry + ay | 0;
      if (cap.equals(LineCap_SQUARE_getInstance())) {
        l.add_58(lx2, ly2);
        Unit_getInstance();
        r.add_58(rx2, ry2);
        Unit_getInstance();
      } else {
        var count_0 = clamp_5(numberToInt(Companion_getInstance_80().distance_0(lx, ly, rx, ry) * scale_1), 4, 64);
        l.add_58(lx, ly);
        Unit_getInstance();
        var inductionVariable = 0;
        if (inductionVariable <= count_0)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var m = epoint.equals(EdgePoint_A_getInstance()) ? n : count_0 - n | 0;
            var ratio = m / count_0;
            this.add_57(r, Companion_getInstance_89().cubicCalc(lx, ly, lx2, ly2, rx2, ry2, rx, ry, ratio, this._tempP2));
          }
           while (!(n === count_0));
      }
    }};
  StrokeToFill.prototype.computeStroke = function (scale_1, closed) {
    if (this._strokePoints.isEmpty_53())
      return Unit_getInstance();
    var weightD2 = this._weight / 2 | 0;
    this._fillPointsLeft.clear_33();
    this._fillPointsRight.clear_33();
    var sp = this._strokePoints;
    var nstrokePoints = sp._get_size__60();
    var inductionVariable = 0;
    if (inductionVariable < nstrokePoints)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var isFirst = n === 0;
        var isLast = n === (nstrokePoints - 1 | 0);
        var isMiddle = !isFirst ? !isLast ? true : closed : false;
        var n1 = isLast ? closed ? 1 : n : n + 1 | 0;
        this._prevEdge.copyFrom_3(this._currEdge);
        Unit_getInstance();
        this._prevEdgeLeft.copyFrom_3(this._currEdgeLeft);
        Unit_getInstance();
        this._prevEdgeRight.copyFrom_3(this._currEdgeRight);
        Unit_getInstance();
        var doJoin = !(this._doJointList.getAt_0(n) === 0);
        this._currEdge.setTo_4(sp.getX_2(n), sp.getY_2(n), sp.getX_2(n1), sp.getY_2(n1), 1);
        Unit_getInstance();
        this.setEdgeDisplaced(this._currEdgeLeft, this._currEdge, weightD2, minus_2(this._currEdge._get_angle_(), _get_degrees__0(90)));
        Unit_getInstance();
        this.setEdgeDisplaced(this._currEdgeRight, this._currEdge, weightD2, plus_5(this._currEdge._get_angle_(), _get_degrees__0(90)));
        Unit_getInstance();
        if (isFirst) {
          this.doCap(this._fillPointsLeft, this._fillPointsRight, this._currEdgeLeft, this._currEdgeRight, EdgePoint_A_getInstance(), closed ? LineCap_BUTT_getInstance() : this._startCap, scale_1);
        } else if (isMiddle) {
          var angle_0 = Companion_getInstance_91().angleBetween(this._prevEdge, this._currEdge);
          var leftAngle = Angle__compareTo_impl(angle_0, _get_degrees__0(0)) > 0;
          if (doJoin) {
            this.doJoin(this._fillPointsLeft, this._prevEdge, this._currEdge, this._prevEdgeLeft, this._currEdgeLeft, this._joins, this._miterLimit, scale_1, leftAngle);
            this.doJoin(this._fillPointsRight, this._prevEdge, this._currEdge, this._prevEdgeRight, this._currEdgeRight, this._joins, this._miterLimit, scale_1, !leftAngle);
          } else {
            this.addEdgePointA(this._fillPointsLeft, this._currEdgeLeft);
            Unit_getInstance();
            this.addEdgePointA(this._fillPointsRight, this._currEdgeRight);
            Unit_getInstance();
          }
        } else if (isLast) {
          if (closed) {
            this.doCap(this._fillPointsLeft, this._fillPointsRight, this._currEdgeLeft, this._currEdgeRight, EdgePoint_B_getInstance(), LineCap_BUTT_getInstance(), scale_1);
          } else {
            this.doCap(this._fillPointsLeft, this._fillPointsRight, this._prevEdgeLeft, this._prevEdgeRight, EdgePoint_B_getInstance(), this._endCap, scale_1);
          }
        }}
       while (inductionVariable < nstrokePoints);
    var inductionVariable_0 = 0;
    var last_1 = this._fillPointsLeft._get_size__60();
    if (inductionVariable_0 < last_1)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var x = this._fillPointsLeft.getX_2(n_0);
        var y = this._fillPointsLeft.getY_2(n_0);
        if (n_0 === 0) {
          _get_outFill_(this).moveTo_9(x * scale_1, y * scale_1);
        } else {
          _get_outFill_(this).lineTo_9(x * scale_1, y * scale_1);
        }
      }
       while (inductionVariable_0 < last_1);
    var inductionVariable_1 = 0;
    var last_2 = this._fillPointsRight._get_size__60();
    if (inductionVariable_1 < last_2)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var m = (this._fillPointsRight._get_size__60() - n_1 | 0) - 1 | 0;
        _get_outFill_(this).lineTo_9(this._fillPointsRight.getX_2(m) * scale_1, this._fillPointsRight.getY_2(m) * scale_1);
      }
       while (inductionVariable_1 < last_2);
    _get_outFill_(this).close_77();
    _get_outFill_(this)._winding_0 = Winding_NON_ZERO_getInstance();
    this._strokePoints.clear_33();
    this._doJointList.clear_33();
  };
  StrokeToFill.prototype.set_18 = function (outFill, weight, startCap, endCap, joins, miterLimit) {
    this._outFill = outFill;
    this._weight = weight;
    this._startCap = startCap;
    this._endCap = endCap;
    this._joins = joins;
    this._miterLimit = miterLimit * weight;
  };
  StrokeToFill.prototype.strokeFill = function (stroke, lineWidth, joins, startCap, endCap, miterLimit, outFill) {
    var scale_1 = 20;
    var iscale = 0.05;
    this.set_18(outFill, numberToInt(lineWidth * scale_1), startCap, endCap, joins, miterLimit);
    var ix_3 = 0.0;
    var iy_4 = 0.0;
    var lx_5 = {_v: 0.0};
    var ly_6 = {_v: 0.0};
    var tmp0__anonymous__119 = false;
    if (tmp0__anonymous__119)
      this.computeStroke(iscale, true);
    var n_1_7 = 0;
    var tmp0_fastForEach_0_8 = stroke._commands;
    var n_1_9 = 0;
    while (n_1_9 < tmp0_fastForEach_0_8._get_size__60()) {
      var tmp0_2_11 = n_1_9;
      n_1_9 = tmp0_2_11 + 1 | 0;
      var tmp1__anonymous__2_3_10 = tmp0_fastForEach_0_8.getAt_0(tmp0_2_11);
      var tmp0_subject_3_4_12 = tmp1__anonymous__2_3_10;
      switch (tmp0_subject_3_4_12) {
        case 0:
          var tmp1_4_5_14 = n_1_7;
          n_1_7 = tmp1_4_5_14 + 1 | 0;
          var tmp2__anonymous__18_13 = stroke._data_37.get_137(tmp1_4_5_14);
          var tmp2_5_6_16 = n_1_7;
          n_1_7 = tmp2_5_6_16 + 1 | 0;
          var tmp3__anonymous__18_15 = stroke._data_37.get_137(tmp2_5_6_16);
          ix_3 = tmp2__anonymous__18_13;
          iy_4 = tmp3__anonymous__18_15;
          var tmp1__anonymous__120 = true;
          if (tmp1__anonymous__120)
            this.computeStroke(iscale, false);
          this._strokePoints.add_58(numberToInt(tmp2__anonymous__18_13 * scale_1), numberToInt(tmp3__anonymous__18_15 * scale_1));
          Unit_getInstance();
          var tmp0_also_0_20_18 = this._doJointList.add_26(0);
          lx_5._v = tmp2__anonymous__18_13;
          var tmp1_also_0_19_17 = tmp0_also_0_20_18;
          ly_6._v = tmp3__anonymous__18_15;
          break;
        case 1:
          var tmp3_6_7_20 = n_1_7;
          n_1_7 = tmp3_6_7_20 + 1 | 0;
          var tmp4__anonymous__21_19 = stroke._data_37.get_137(tmp3_6_7_20);
          var tmp4_7_8_22 = n_1_7;
          n_1_7 = tmp4_7_8_22 + 1 | 0;
          var tmp5__anonymous__21_21 = stroke._data_37.get_137(tmp4_7_8_22);
          var tmp2__anonymous__120 = false;
          if (tmp2__anonymous__120)
            this.computeStroke(iscale, false);
          this._strokePoints.add_58(numberToInt(tmp4__anonymous__21_19 * scale_1), numberToInt(tmp5__anonymous__21_21 * scale_1));
          Unit_getInstance();
          var tmp0_also_0_23_24 = this._doJointList.add_26(0);
          lx_5._v = tmp4__anonymous__21_19;
          var tmp1_also_0_22_23 = tmp0_also_0_23_24;
          ly_6._v = tmp5__anonymous__21_21;
          var tmp3__anonymous__121 = false;
          this._doJointList.set_35(this._doJointList._get_size__60() - 1 | 0, 1);
          break;
        case 2:
          var tmp5_8_9_26 = n_1_7;
          n_1_7 = tmp5_8_9_26 + 1 | 0;
          var tmp6__anonymous__24_25 = stroke._data_37.get_137(tmp5_8_9_26);
          var tmp6_9_10_28 = n_1_7;
          n_1_7 = tmp6_9_10_28 + 1 | 0;
          var tmp7__anonymous__24_27 = stroke._data_37.get_137(tmp6_9_10_28);
          var tmp7_10_11_30 = n_1_7;
          n_1_7 = tmp7_10_11_30 + 1 | 0;
          var tmp8__anonymous__24_29 = stroke._data_37.get_137(tmp7_10_11_30);
          var tmp8_11_12_32 = n_1_7;
          n_1_7 = tmp8_11_12_32 + 1 | 0;
          var tmp9__anonymous__24_31 = stroke._data_37.get_137(tmp8_11_12_32);
          var sum_25_33 = Companion_getInstance_80().distance(lx_5._v, ly_6._v, tmp6__anonymous__24_25, tmp7__anonymous__24_27) + Companion_getInstance_80().distance(tmp6__anonymous__24_25, tmp7__anonymous__24_27, tmp8__anonymous__24_29, tmp9__anonymous__24_31);
          var tmp0_approximateCurve_0_26_34 = numberToInt(sum_25_33);
          var rcurveSteps_1_27_35 = max2_4(tmp0_approximateCurve_0_26_34, 20);
          var dt_2_28_36 = 1.0 / rcurveSteps_1_27_35;
          var lastX_3_29_37 = {_v: 0.0};
          var lastY_4_30_38 = {_v: 0.0};
          var prevX_5_31_39 = {_v: 0.0};
          var prevY_6_32_40 = {_v: 0.0};
          var emittedCount_7_33_41 = {_v: 0};
          var tmp1__anonymous__15_34_42 = 0.0;
          var tmp0_quadCalc_0_16_35_43 = Companion_getInstance_89();
          var tmp1_quadCalc_0_17_36_44 = lx_5._v;
          var tmp2_quadCalc_0_18_37_45 = ly_6._v;
          var t1_1_19_38_46 = 1 - tmp1__anonymous__15_34_42;
          var a_2_20_39_47 = t1_1_19_38_46 * t1_1_19_38_46;
          var c_3_21_40_48 = tmp1__anonymous__15_34_42 * tmp1__anonymous__15_34_42;
          var b_4_22_41_49 = 2 * t1_1_19_38_46 * tmp1__anonymous__15_34_42;
          var tmp3__anonymous__5_23_42_50 = a_2_20_39_47 * tmp1_quadCalc_0_17_36_44 + b_4_22_41_49 * tmp6__anonymous__24_25 + c_3_21_40_48 * tmp8__anonymous__24_29;
          var tmp4__anonymous__5_24_43_51 = a_2_20_39_47 * tmp2_quadCalc_0_18_37_45 + b_4_22_41_49 * tmp7__anonymous__24_27 + c_3_21_40_48 * tmp9__anonymous__24_31;
          lastX_3_29_37._v = tmp3__anonymous__5_23_42_50;
          lastY_4_30_38._v = tmp4__anonymous__5_24_43_51;
          var inductionVariable = 1;
          if (inductionVariable < rcurveSteps_1_27_35)
            do {
              var n_10_45_53 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_11_46_54 = n_10_45_53 * dt_2_28_36;
              var tmp0_quadCalc_0_16_47_55 = Companion_getInstance_89();
              var tmp1_quadCalc_0_17_48_56 = lx_5._v;
              var tmp2_quadCalc_0_18_49_57 = ly_6._v;
              var t1_1_19_50_58 = 1 - ratio_11_46_54;
              var a_2_20_51_59 = t1_1_19_50_58 * t1_1_19_50_58;
              var c_3_21_52_60 = ratio_11_46_54 * ratio_11_46_54;
              var b_4_22_53_61 = 2 * t1_1_19_50_58 * ratio_11_46_54;
              var tmp3__anonymous__5_23_54_62 = a_2_20_51_59 * tmp1_quadCalc_0_17_48_56 + b_4_22_53_61 * tmp6__anonymous__24_25 + c_3_21_52_60 * tmp8__anonymous__24_29;
              var tmp4__anonymous__5_24_55_63 = a_2_20_51_59 * tmp2_quadCalc_0_18_49_57 + b_4_22_53_61 * tmp7__anonymous__24_27 + c_3_21_52_60 * tmp9__anonymous__24_31;
              var tmp4__anonymous__120 = false;
              if (tmp4__anonymous__120)
                this.computeStroke(iscale, false);
              this._strokePoints.add_58(numberToInt(tmp3__anonymous__5_23_54_62 * scale_1), numberToInt(tmp4__anonymous__5_24_55_63 * scale_1));
              Unit_getInstance();
              this._doJointList.add_26(0);
              var tmp0_14_2_27_56_64 = emittedCount_7_33_41._v;
              emittedCount_7_33_41._v = tmp0_14_2_27_56_64 + 1 | 0;
              Unit_getInstance();
              lastX_3_29_37._v = prevX_5_31_39._v;
              lastY_4_30_38._v = prevY_6_32_40._v;
              prevX_5_31_39._v = tmp3__anonymous__5_23_54_62;
              prevY_6_32_40._v = tmp4__anonymous__5_24_55_63;
            }
             while (inductionVariable < rcurveSteps_1_27_35);
          var tmp2_also_0_57_65 = lx_5._v = tmp8__anonymous__24_29;
          ly_6._v = tmp9__anonymous__24_31;
          var tmp5__anonymous__121 = false;
          this._doJointList.set_35(this._doJointList._get_size__60() - 1 | 0, 1);
          break;
        case 3:
          var tmp9_12_13_67 = n_1_7;
          n_1_7 = tmp9_12_13_67 + 1 | 0;
          var tmp10__anonymous__58_66 = stroke._data_37.get_137(tmp9_12_13_67);
          var tmp10_13_14_69 = n_1_7;
          n_1_7 = tmp10_13_14_69 + 1 | 0;
          var tmp11__anonymous__58_68 = stroke._data_37.get_137(tmp10_13_14_69);
          var tmp11_14_15_71 = n_1_7;
          n_1_7 = tmp11_14_15_71 + 1 | 0;
          var tmp12__anonymous__58_70 = stroke._data_37.get_137(tmp11_14_15_71);
          var tmp12_15_16_73 = n_1_7;
          n_1_7 = tmp12_15_16_73 + 1 | 0;
          var tmp13__anonymous__58_72 = stroke._data_37.get_137(tmp12_15_16_73);
          var tmp13_16_17_75 = n_1_7;
          n_1_7 = tmp13_16_17_75 + 1 | 0;
          var tmp14__anonymous__58_74 = stroke._data_37.get_137(tmp13_16_17_75);
          var tmp14_17_18_77 = n_1_7;
          n_1_7 = tmp14_17_18_77 + 1 | 0;
          var tmp15__anonymous__58_76 = stroke._data_37.get_137(tmp14_17_18_77);
          var sum_59_78 = Companion_getInstance_80().distance(lx_5._v, ly_6._v, tmp10__anonymous__58_66, tmp11__anonymous__58_68) + Companion_getInstance_80().distance(tmp10__anonymous__58_66, tmp11__anonymous__58_68, tmp12__anonymous__58_70, tmp13__anonymous__58_72) + Companion_getInstance_80().distance(tmp12__anonymous__58_70, tmp13__anonymous__58_72, tmp14__anonymous__58_74, tmp15__anonymous__58_76);
          var tmp0_approximateCurve_0_60_79 = numberToInt(sum_59_78);
          var rcurveSteps_1_61_80 = max2_4(tmp0_approximateCurve_0_60_79, 20);
          var dt_2_62_81 = 1.0 / rcurveSteps_1_61_80;
          var lastX_3_63_82 = {_v: 0.0};
          var lastY_4_64_83 = {_v: 0.0};
          var prevX_5_65_84 = {_v: 0.0};
          var prevY_6_66_85 = {_v: 0.0};
          var emittedCount_7_67_86 = {_v: 0};
          var tmp1__anonymous__15_68_87 = 0.0;
          var tmp0_cubicCalc_0_16_69_88 = Companion_getInstance_89();
          var tmp1_cubicCalc_0_17_70_89 = lx_5._v;
          var tmp2_cubicCalc_0_18_71_90 = ly_6._v;
          var cx_1_19_72_91 = 3.0 * (tmp10__anonymous__58_66 - tmp1_cubicCalc_0_17_70_89);
          var bx_2_20_73_92 = 3.0 * (tmp12__anonymous__58_70 - tmp10__anonymous__58_66) - cx_1_19_72_91;
          var ax_3_21_74_93 = tmp14__anonymous__58_74 - tmp1_cubicCalc_0_17_70_89 - cx_1_19_72_91 - bx_2_20_73_92;
          var cy_4_22_75_94 = 3.0 * (tmp11__anonymous__58_68 - tmp2_cubicCalc_0_18_71_90);
          var by_5_23_76_95 = 3.0 * (tmp13__anonymous__58_72 - tmp11__anonymous__58_68) - cy_4_22_75_94;
          var ay_6_24_77_96 = tmp15__anonymous__58_76 - tmp2_cubicCalc_0_18_71_90 - cy_4_22_75_94 - by_5_23_76_95;
          var tSquared_7_25_78_97 = tmp1__anonymous__15_68_87 * tmp1__anonymous__15_68_87;
          var tCubed_8_26_79_98 = tSquared_7_25_78_97 * tmp1__anonymous__15_68_87;
          var tmp3__anonymous__9_27_80_99 = ax_3_21_74_93 * tCubed_8_26_79_98 + bx_2_20_73_92 * tSquared_7_25_78_97 + cx_1_19_72_91 * tmp1__anonymous__15_68_87 + tmp1_cubicCalc_0_17_70_89;
          var tmp4__anonymous__9_28_81_100 = ay_6_24_77_96 * tCubed_8_26_79_98 + by_5_23_76_95 * tSquared_7_25_78_97 + cy_4_22_75_94 * tmp1__anonymous__15_68_87 + tmp2_cubicCalc_0_18_71_90;
          lastX_3_63_82._v = tmp3__anonymous__9_27_80_99;
          lastY_4_64_83._v = tmp4__anonymous__9_28_81_100;
          var inductionVariable_0 = 1;
          if (inductionVariable_0 < rcurveSteps_1_61_80)
            do {
              var n_10_83_102 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_11_84_103 = n_10_83_102 * dt_2_62_81;
              var tmp0_cubicCalc_0_16_85_104 = Companion_getInstance_89();
              var tmp1_cubicCalc_0_17_86_105 = lx_5._v;
              var tmp2_cubicCalc_0_18_87_106 = ly_6._v;
              var cx_1_19_88_107 = 3.0 * (tmp10__anonymous__58_66 - tmp1_cubicCalc_0_17_86_105);
              var bx_2_20_89_108 = 3.0 * (tmp12__anonymous__58_70 - tmp10__anonymous__58_66) - cx_1_19_88_107;
              var ax_3_21_90_109 = tmp14__anonymous__58_74 - tmp1_cubicCalc_0_17_86_105 - cx_1_19_88_107 - bx_2_20_89_108;
              var cy_4_22_91_110 = 3.0 * (tmp11__anonymous__58_68 - tmp2_cubicCalc_0_18_87_106);
              var by_5_23_92_111 = 3.0 * (tmp13__anonymous__58_72 - tmp11__anonymous__58_68) - cy_4_22_91_110;
              var ay_6_24_93_112 = tmp15__anonymous__58_76 - tmp2_cubicCalc_0_18_87_106 - cy_4_22_91_110 - by_5_23_92_111;
              var tSquared_7_25_94_113 = ratio_11_84_103 * ratio_11_84_103;
              var tCubed_8_26_95_114 = tSquared_7_25_94_113 * ratio_11_84_103;
              var tmp3__anonymous__9_27_96_115 = ax_3_21_90_109 * tCubed_8_26_95_114 + bx_2_20_89_108 * tSquared_7_25_94_113 + cx_1_19_88_107 * ratio_11_84_103 + tmp1_cubicCalc_0_17_86_105;
              var tmp4__anonymous__9_28_97_116 = ay_6_24_93_112 * tCubed_8_26_95_114 + by_5_23_92_111 * tSquared_7_25_94_113 + cy_4_22_91_110 * ratio_11_84_103 + tmp2_cubicCalc_0_18_87_106;
              var tmp6__anonymous__120 = false;
              if (tmp6__anonymous__120)
                this.computeStroke(iscale, false);
              this._strokePoints.add_58(numberToInt(tmp3__anonymous__9_27_96_115 * scale_1), numberToInt(tmp4__anonymous__9_28_97_116 * scale_1));
              Unit_getInstance();
              this._doJointList.add_26(0);
              var tmp0_14_2_31_98_117 = emittedCount_7_67_86._v;
              emittedCount_7_67_86._v = tmp0_14_2_31_98_117 + 1 | 0;
              Unit_getInstance();
              lastX_3_63_82._v = prevX_5_65_84._v;
              lastY_4_64_83._v = prevY_6_66_85._v;
              prevX_5_65_84._v = tmp3__anonymous__9_27_96_115;
              prevY_6_66_85._v = tmp4__anonymous__9_28_97_116;
            }
             while (inductionVariable_0 < rcurveSteps_1_61_80);
          var tmp2_also_0_99_118 = lx_5._v = tmp14__anonymous__58_74;
          ly_6._v = tmp15__anonymous__58_76;
          var tmp7__anonymous__121 = false;
          this._doJointList.set_35(this._doJointList._get_size__60() - 1 | 0, 1);
          break;
        case 4:
          var tmp8__anonymous__120 = ix_3;
          var tmp9__anonymous__120 = iy_4;
          var tmp10__anonymous__120 = false;
          if (tmp10__anonymous__120)
            this.computeStroke(iscale, false);
          this._strokePoints.add_58(numberToInt(tmp8__anonymous__120 * scale_1), numberToInt(tmp9__anonymous__120 * scale_1));
          Unit_getInstance();
          this._doJointList.add_26(0);
          var tmp11__anonymous__121 = true;
          this._doJointList.set_35(this._doJointList._get_size__60() - 1 | 0, 1);
          var tmp12__anonymous__119 = true;
          if (tmp12__anonymous__119)
            this.computeStroke(iscale, true);
          break;
      }
    }
    var tmp13__anonymous__119 = false;
    if (tmp13__anonymous__119)
      this.computeStroke(iscale, true);
    this.computeStroke(iscale, false);
  };
  StrokeToFill.$metadata$ = {
    simpleName: 'StrokeToFill',
    kind: 'class',
    interfaces: []
  };
  function strokeToFill(_this_, lineWidth, joins, startCap, endCap, miterLimit, temp_0, outFill) {
    temp_0.strokeFill(_this_, lineWidth, joins, startCap, endCap, miterLimit, outFill);
    return outFill;
  }
  function moveTo(_this_, x, y) {
    return _this_.moveTo_9(x, y);
  }
  function lineTo(_this_, x, y) {
    return _this_.lineTo_9(x, y);
  }
  function quadTo(_this_, controlX, controlY, anchorX, anchorY) {
    return _this_.quadTo_7(controlX, controlY, anchorX, anchorY);
  }
  function VectorBuilder() {
  }
  VectorBuilder.prototype.quadTo_7 = function (cx, cy, ax, ay) {
    var x1 = this._get_lastX__7();
    var y1 = this._get_lastY__7();
    var x2 = ax;
    var y2 = ay;
    var tt = 0.6666666666666666;
    var cx1 = x1 + tt * (cx - x1);
    var cy1 = y1 + tt * (cy - y1);
    var cx2 = x2 + tt * (cx - x2);
    var cy2 = y2 + tt * (cy - y2);
    return this.cubicTo_7(cx1, cy1, cx2, cy2, x2, y2);
  };
  VectorBuilder.$metadata$ = {
    simpleName: 'VectorBuilder',
    kind: 'interface',
    interfaces: []
  };
  function roundRect(_this_, x, y, w, h, rx, ry) {
    if (rx === 0.0 ? ry === 0.0 : false) {
      rect(_this_, x, y, w, h);
    } else {
      var r = w < 2 * rx ? w / 2.0 : h < 2 * rx ? h / 2.0 : rx;
      _this_.moveTo_9(x + r, y);
      arcTo(_this_, x + w, y, x + w, y + h, r);
      arcTo(_this_, x + w, y + h, x, y + h, r);
      arcTo(_this_, x, y + h, x, y, r);
      arcTo(_this_, x, y, x + w, y, r);
    }
  }
  function rect(_this_, x, y, width, height) {
    _this_.moveTo_9(x, y);
    _this_.lineTo_9(x + width, y);
    _this_.lineTo_9(x + width, y + height);
    _this_.lineTo_9(x, y + height);
    _this_.close_77();
  }
  function transformed(_this_, m, block) {
    return block(transformed_0(_this_, m));
  }
  function isEmpty(_this_) {
    return _this_._get_totalPoints__7() === 0;
  }
  function roundRect_0(_this_, x, y, w, h, rx, ry) {
    return roundRect(_this_, x, y, w, h, rx, ry);
  }
  function line(_this_, x0, y0, x1, y1) {
    return line_0(_this_, x0, y0, x1, y1);
  }
  function rect_0(_this_, rect_1) {
    return rect(_this_, rect_1._x_3, rect_1._y_3, rect_1._width_0, rect_1._height_0);
  }
  function moveTo_0(_this_, p) {
    return _this_.moveTo_9(p._x_2, p._y_2);
  }
  function lineTo_0(_this_, p) {
    return _this_.lineTo_9(p._x_2, p._y_2);
  }
  function circle(_this_, point, radius) {
    return arc(_this_, point._x_2, point._y_2, radius, _get_degrees__0(0), _get_degrees__0(360));
  }
  function line_0(_this_, x0, y0, x1, y1) {
    var tmp0_also_0 = _this_.moveTo_9(x0, y0);
    _this_.lineTo_9(x1, y1);
    return tmp0_also_0;
  }
  function isNotEmpty(_this_) {
    return !(_this_._get_totalPoints__7() === 0);
  }
  function circle_0(_this_, x, y, radius) {
    return arc(_this_, x, y, radius, _get_degrees__0(0), _get_degrees__0(360));
  }
  function arcTo(_this_, ax, ay, cx, cy, r) {
    if (isEmpty(_this_))
      _this_.moveTo_9(ax, ay);
    var bx = _this_._get_lastX__7();
    var by = _this_._get_lastY__7();
    var b = Companion_getInstance_79().invoke_307(bx, by);
    var a = Companion_getInstance_79().invoke_307(ax, ay);
    var c = Companion_getInstance_79().invoke_307(cx, cy);
    var AB = minus_3(b, a);
    var AC = minus_3(c, a);
    var angle_0 = _Angle___get_radians__impl_(angle(Companion_getInstance_80(), AB, AC)) * 0.5;
    var tmp0_sin_0 = 1.5707963267948966 - angle_0;
    var tmp = r * Math.sin(tmp0_sin_0);
    var x = tmp / Math.sin(angle_0);
    var A = plus_6(a, times_1(_get_unit_(AB), x));
    var B = plus_6(a, times_1(_get_unit_(AC), x));
    _this_.lineTo_9(A._get_x__36(), A._get_y__36());
    _this_.quadTo_7(a._get_x__36(), a._get_y__36(), B._get_x__36(), B._get_y__36());
  }
  function transformed_0(_this_, m) {
    var im = m.inverted$default(null, 1, null);
    var parent = _this_;
    return new _no_name_provided__211(parent, im, m);
  }
  function arc(_this_, x, y, r, start, end) {
    var EPSILON = 1.0E-5;
    var PI_TWO = 6.283185307179586;
    var PI_OVER_TWO = 1.5707963267948966;
    var startAngle = _Angle___get_radians__impl_(start) % PI_TWO;
    var endAngle = _Angle___get_radians__impl_(end) % PI_TWO;
    var tmp0_abs_0 = endAngle - startAngle;
    var remainingAngle = min2_3(PI_TWO, Math.abs(tmp0_abs_0));
    var tmp;
    var tmp1__get_absoluteValue__0 = remainingAngle;
    if (Math.abs(tmp1__get_absoluteValue__0) < EPSILON) {
      tmp = !equals_1(new Angle(start), new Angle(end));
    } else {
      {
        tmp = false;
      }
    }
    if (tmp)
      remainingAngle = PI_TWO;
    else {
    }
    var sgn = startAngle < endAngle ? 1 : -1;
    var a1 = startAngle;
    var p1 = Companion_getInstance_80().invoke_1005();
    var p2 = Companion_getInstance_80().invoke_1005();
    var p3 = Companion_getInstance_80().invoke_1005();
    var p4 = Companion_getInstance_80().invoke_1005();
    var index = 0;
    while (remainingAngle > EPSILON) {
      var a2 = a1 + sgn * min2_3(remainingAngle, PI_OVER_TWO);
      var k = 0.5522847498;
      var a = (a2 - a1) / 2.0;
      var x4 = r * Math.cos(a);
      var y4 = r * Math.sin(a);
      var x1 = x4;
      var y1 = -y4;
      var f = k * Math.tan(a);
      var x2 = x1 + f * y4;
      var y2 = y1 + f * x4;
      var x3 = x2;
      var y3 = -y2;
      var ar = a + a1;
      var cos_ar = Math.cos(ar);
      var sin_ar = Math.sin(ar);
      var tmp2_cos_0 = a1;
      var tmp_0 = x + r * Math.cos(tmp2_cos_0);
      var tmp3_sin_0 = a1;
      p1.setTo_0(tmp_0, y + r * Math.sin(tmp3_sin_0));
      Unit_getInstance();
      p2.setTo_0(x + x2 * cos_ar - y2 * sin_ar, y + x2 * sin_ar + y2 * cos_ar);
      Unit_getInstance();
      p3.setTo_0(x + x3 * cos_ar - y3 * sin_ar, y + x3 * sin_ar + y3 * cos_ar);
      Unit_getInstance();
      var tmp_1 = x + r * Math.cos(a2);
      p4.setTo_0(tmp_1, y + r * Math.sin(a2));
      Unit_getInstance();
      if (index === 0)
        _this_.moveTo_9(p1._x_2, p1._y_2);
      _this_.cubicTo_7(p2._x_2, p2._y_2, p3._x_2, p3._y_2, p4._x_2, p4._y_2);
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      Unit_getInstance();
      var tmp_2 = remainingAngle;
      var tmp4_abs_0 = a2 - a1;
      remainingAngle = tmp_2 - Math.abs(tmp4_abs_0);
      a1 = a2;
    }
    if (startAngle === endAngle ? !(index === 0) : false) {
      _this_.close_77();
    }}
  function _no_name_provided__211($parent, $im, $m) {
    this._$parent = $parent;
    this._$im = $im;
    this._$m = $m;
    this._totalPoints = this._$parent._get_totalPoints__7();
  }
  _no_name_provided__211.prototype._get_lastX__7 = function () {
    return this._$im.transformX(this._$parent._get_lastX__7(), this._$parent._get_lastY__7());
  };
  _no_name_provided__211.prototype._get_lastY__7 = function () {
    return this._$im.transformY(this._$parent._get_lastX__7(), this._$parent._get_lastY__7());
  };
  _no_name_provided__211.prototype._get_totalPoints__7 = function () {
    return this._totalPoints;
  };
  _no_name_provided__211.prototype.tX = function (x, y) {
    return this._$m.transformX(x, y);
  };
  _no_name_provided__211.prototype.tY = function (x, y) {
    return this._$m.transformY(x, y);
  };
  _no_name_provided__211.prototype.close_77 = function () {
    return this._$parent.close_77();
  };
  _no_name_provided__211.prototype.lineTo_9 = function (x, y) {
    return this._$parent.lineTo_9(this.tX(x, y), this.tY(x, y));
  };
  _no_name_provided__211.prototype.moveTo_9 = function (x, y) {
    return this._$parent.lineTo_9(this.tX(x, y), this.tY(x, y));
  };
  _no_name_provided__211.prototype.quadTo_7 = function (cx, cy, ax, ay) {
    return this._$parent.quadTo_7(this.tX(cx, cy), this.tY(cx, cy), this.tX(ax, ay), this.tY(ax, ay));
  };
  _no_name_provided__211.prototype.cubicTo_7 = function (cx1, cy1, cx2, cy2, ax, ay) {
    return this._$parent.cubicTo_7(this.tX(cx1, cy1), this.tY(cx1, cy1), this.tX(cx2, cy2), this.tY(cx2, cy2), this.tX(ax, ay), this.tY(ax, ay));
  };
  _no_name_provided__211.$metadata$ = {
    kind: 'class',
    interfaces: [VectorBuilder]
  };
  var tempMatrix;
  var identityMatrix;
  function VectorPath_init_$Init$(commands, data, winding, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      commands = IntArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 2) === 0)) {
      data = DoubleArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 4) === 0))
      winding = Winding_EVEN_ODD_getInstance();
    VectorPath.call($this, commands, data, winding);
    return $this;
  }
  function VectorPath_init_$Create$(commands, data, winding, $mask0, $marker) {
    return VectorPath_init_$Init$(commands, data, winding, $mask0, $marker, Object.create(VectorPath.prototype));
  }
  function Companion_96() {
    Companion_instance_95 = this;
    var tmp = this;
    tmp._identityMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  }
  Companion_96.prototype.intersects_0 = function (left, leftTransform, right, rightTransform) {
    return left.intersectsWith_0(leftTransform, right, rightTransform);
  };
  Companion_96.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_95;
  function Companion_getInstance_95() {
    if (Companion_instance_95 == null)
      new Companion_96();
    return Companion_instance_95;
  }
  function ensureMoveTo($this, x, y) {
    if (isEmpty($this))
      $this.moveTo_9(x, y);
  }
  function _get_scanline_($this) {
    var tmp0_getValue_0 = $this._scanline$delegate;
    var tmp1_getValue_0 = scanline$factory();
    return tmp0_getValue_0._get_value__10();
  }
  function ensureScanline($this) {
    var tmp0_also_0 = _get_scanline_($this);
    if (!(tmp0_also_0._version_0 === $this._version_1)) {
      tmp0_also_0.reset_9();
      tmp0_also_0.add_55($this);
      tmp0_also_0._version_0 = $this._version_1;
    }return tmp0_also_0;
  }
  function _no_name_provided__212(this$0) {
    this._this$0_46 = this$0;
  }
  _no_name_provided__212.prototype.invoke_1005 = function () {
    var tmp0_also_0 = new PolygonScanline();
    tmp0_also_0.add_55(this._this$0_46);
    tmp0_also_0._version_0 = this._this$0_46._version_1;
    return tmp0_also_0;
  };
  _no_name_provided__212.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function VectorPath(commands, data, winding) {
    Companion_getInstance_95();
    this._commands = commands;
    this._data_37 = data;
    this._winding_0 = winding;
    this._version_1 = 0;
    this._lastX_0 = 0.0;
    this._lastY_0 = 0.0;
    this._bezierTemp = new Temp();
    var tmp = this;
    tmp._scanline$delegate = lazy(_no_name_provided_$factory_173(this));
  }
  VectorPath.prototype._get_commands__0 = function () {
    return this._commands;
  };
  VectorPath.prototype._get_data__2 = function () {
    return this._data_37;
  };
  VectorPath.prototype._set_winding__0 = function (_set___) {
    this._winding_0 = _set___;
  };
  VectorPath.prototype._get_winding__0 = function () {
    return this._winding_0;
  };
  VectorPath.prototype.clear_33 = function () {
    this._commands.clear_33();
    this._data_37.clear_33();
    this.lastXY_0(0.0, 0.0);
    this._version_1 = 0;
    _get_scanline_(this)._version_0 = this._version_1 - 1 | 0;
  };
  VectorPath.prototype._set_lastX__1 = function (_set___) {
    this._lastX_0 = _set___;
  };
  VectorPath.prototype._get_lastX__7 = function () {
    return this._lastX_0;
  };
  VectorPath.prototype._set_lastY__1 = function (_set___) {
    this._lastY_0 = _set___;
  };
  VectorPath.prototype._get_lastY__7 = function () {
    return this._lastY_0;
  };
  VectorPath.prototype.lastXY_0 = function (x, y) {
    this._set_lastX__1(x);
    this._set_lastY__1(y);
  };
  VectorPath.prototype.moveTo_9 = function (x, y) {
    this._commands.add_26(0);
    this._data_37.add_21(x, y);
    this.lastXY_0(x, y);
    var tmp0_this = this;
    var tmp1 = tmp0_this._version_1;
    tmp0_this._version_1 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype.lineTo_9 = function (x, y) {
    ensureMoveTo(this, x, y);
    this._commands.add_26(1);
    this._data_37.add_21(x, y);
    this.lastXY_0(x, y);
    var tmp0_this = this;
    var tmp1 = tmp0_this._version_1;
    tmp0_this._version_1 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype.quadTo_7 = function (cx, cy, ax, ay) {
    ensureMoveTo(this, cx, cy);
    this._commands.add_26(2);
    this._data_37.add_22(cx, cy, ax, ay);
    this.lastXY_0(ax, ay);
    var tmp0_this = this;
    var tmp1 = tmp0_this._version_1;
    tmp0_this._version_1 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype.cubicTo_7 = function (cx1, cy1, cx2, cy2, ax, ay) {
    ensureMoveTo(this, cx1, cy1);
    this._commands.add_26(3);
    this._data_37.add_23(cx1, cy1, cx2, cy2, ax, ay);
    this.lastXY_0(ax, ay);
    var tmp0_this = this;
    var tmp1 = tmp0_this._version_1;
    tmp0_this._version_1 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype.close_77 = function () {
    this._commands.add_26(4);
    var tmp0_this = this;
    var tmp1 = tmp0_this._version_1;
    tmp0_this._version_1 = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype._get_totalPoints__7 = function () {
    return this._data_37._get_size__60() / 2 | 0;
  };
  VectorPath.prototype.getBounds_2 = function (out, bb) {
    bb.reset_9();
    add_0(bb, this);
    return bb.getBounds_0(out);
  };
  VectorPath.prototype.getBounds$default_0 = function (out, bb, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      out = Companion_getInstance_83().invoke_1005();
    if (!(($mask0 & 2) === 0))
      bb = new BoundsBuilder();
    return this.getBounds_2(out, bb);
  };
  VectorPath.prototype.containsPoint_2 = function (x, y) {
    return this.containsPoint_3(x, y, this._winding_0);
  };
  VectorPath.prototype.containsPoint_3 = function (x, y, winding) {
    return ensureScanline(this).containsPoint_3(x, y, winding);
  };
  VectorPath.prototype.intersectsWith_0 = function (leftMatrix, right, rightMatrix) {
    var left = this;
    var leftScanline = ensureScanline(left);
    var rightScanline = ensureScanline(right);
    tempMatrix.invert(rightMatrix);
    Unit_getInstance();
    tempMatrix.premultiply(leftMatrix);
    Unit_getInstance();
    var tmp0_fastForEach_0_1 = leftScanline._points;
    var inductionVariable = 0;
    var last_1 = tmp0_fastForEach_0_1._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1__anonymous__3_4 = tmp0_fastForEach_0_1.getX_2(n_2_3);
        var tmp2__anonymous__3_5 = tmp0_fastForEach_0_1.getY_2(n_2_3);
        var tx_7 = tempMatrix.transformX(tmp1__anonymous__3_4, tmp2__anonymous__3_5);
        var ty_8 = tempMatrix.transformY(tmp1__anonymous__3_4, tmp2__anonymous__3_5);
        if (rightScanline.containsPoint$default(tx_7, ty_8, null, 4, null))
          return true;
        else {
        }
      }
       while (inductionVariable < last_1);
    tempMatrix.invert(leftMatrix);
    Unit_getInstance();
    tempMatrix.premultiply(rightMatrix);
    Unit_getInstance();
    var tmp0_fastForEach_0_1_0 = rightScanline._points;
    var inductionVariable_0 = 0;
    var last_2 = tmp0_fastForEach_0_1_0._get_size__60();
    if (inductionVariable_0 < last_2)
      do {
        var n_2_3_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp1__anonymous__3_4_0 = tmp0_fastForEach_0_1_0.getX_2(n_2_3_0);
        var tmp2__anonymous__3_5_0 = tmp0_fastForEach_0_1_0.getY_2(n_2_3_0);
        var tx_7_0 = tempMatrix.transformX(tmp1__anonymous__3_4_0, tmp2__anonymous__3_5_0);
        var ty_8_0 = tempMatrix.transformY(tmp1__anonymous__3_4_0, tmp2__anonymous__3_5_0);
        if (leftScanline.containsPoint$default(tx_7_0, ty_8_0, null, 4, null))
          return true;
        else {
        }
      }
       while (inductionVariable_0 < last_2);
    return false;
  };
  VectorPath.prototype.write_34 = function (path_0, transform) {
    var tmp0_this = this;
    tmp0_this._commands.plusAssign_2(path_0._commands);
    if (transform.isIdentity_0()) {
      var tmp1_this = this;
      tmp1_this._data_37.plusAssign_0(path_0._data_37);
      this.lastXY_0(path_0._get_lastX__7(), path_0._get_lastY__7());
    } else {
      var progression = step(until(0, path_0._data_37._get_size__60()), 2);
      var inductionVariable = progression._first_0;
      var last_1 = progression._last;
      var step_0 = progression._step_2;
      if ((step_0 > 0 ? inductionVariable <= last_1 : false) ? true : step_0 < 0 ? last_1 <= inductionVariable : false)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var x = path_0._data_37.get_137(n + 0 | 0);
          var y = path_0._data_37.get_137(n + 1 | 0);
          var tmp3_this = this;
          tmp3_this._data_37.plusAssign(transform.transformX(x, y));
          var tmp4_this = this;
          tmp4_this._data_37.plusAssign(transform.transformY(x, y));
        }
         while (!(n === last_1));
      this.lastXY_0(transform.transformX(path_0._get_lastX__7(), path_0._get_lastY__7()), transform.transformY(path_0._get_lastX__7(), path_0._get_lastY__7()));
    }
    var tmp5_this = this;
    var tmp6 = tmp5_this._version_1;
    tmp5_this._version_1 = tmp6 + 1 | 0;
    Unit_getInstance();
  };
  VectorPath.prototype.write$default = function (path_0, transform, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      transform = Companion_getInstance_95()._identityMatrix;
    return this.write_34(path_0, transform);
  };
  VectorPath.prototype.toSvgString_0 = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    var n_1_3 = 0;
    var tmp0_fastForEach_0_2_4 = this._commands;
    var n_1_3_5 = 0;
    while (n_1_3_5 < tmp0_fastForEach_0_2_4._get_size__60()) {
      var tmp0_2_5_7 = n_1_3_5;
      n_1_3_5 = tmp0_2_5_7 + 1 | 0;
      var tmp1__anonymous__3_4_6 = tmp0_fastForEach_0_2_4.getAt_0(tmp0_2_5_7);
      var tmp0_subject_4_6_8 = tmp1__anonymous__3_4_6;
      switch (tmp0_subject_4_6_8) {
        case 0:
          var tmp1_5_7_10 = n_1_3;
          n_1_3 = tmp1_5_7_10 + 1 | 0;
          var tmp0__anonymous__21_9 = this._data_37.get_137(tmp1_5_7_10);
          var tmp2_6_8_12 = n_1_3;
          n_1_3 = tmp2_6_8_12 + 1 | 0;
          var tmp1__anonymous__21_11 = this._data_37.get_137(tmp2_6_8_12);
          tmp0_apply_0_1.append_5('' + 'M' + _get_niceStr__3(tmp0__anonymous__21_9) + ',' + _get_niceStr__3(tmp1__anonymous__21_11) + ' ');
          Unit_getInstance();
          break;
        case 1:
          var tmp3_7_9_14 = n_1_3;
          n_1_3 = tmp3_7_9_14 + 1 | 0;
          var tmp2__anonymous__22_13 = this._data_37.get_137(tmp3_7_9_14);
          var tmp4_8_10_16 = n_1_3;
          n_1_3 = tmp4_8_10_16 + 1 | 0;
          var tmp3__anonymous__22_15 = this._data_37.get_137(tmp4_8_10_16);
          tmp0_apply_0_1.append_5('' + 'L' + _get_niceStr__3(tmp2__anonymous__22_13) + ',' + _get_niceStr__3(tmp3__anonymous__22_15) + ' ');
          Unit_getInstance();
          break;
        case 2:
          var tmp5_9_11_18 = n_1_3;
          n_1_3 = tmp5_9_11_18 + 1 | 0;
          var tmp4__anonymous__23_17 = this._data_37.get_137(tmp5_9_11_18);
          var tmp6_10_12_20 = n_1_3;
          n_1_3 = tmp6_10_12_20 + 1 | 0;
          var tmp5__anonymous__23_19 = this._data_37.get_137(tmp6_10_12_20);
          var tmp7_11_13_22 = n_1_3;
          n_1_3 = tmp7_11_13_22 + 1 | 0;
          var tmp6__anonymous__23_21 = this._data_37.get_137(tmp7_11_13_22);
          var tmp8_12_14_24 = n_1_3;
          n_1_3 = tmp8_12_14_24 + 1 | 0;
          var tmp7__anonymous__23_23 = this._data_37.get_137(tmp8_12_14_24);
          tmp0_apply_0_1.append_5('' + 'Q' + _get_niceStr__3(tmp4__anonymous__23_17) + ',' + _get_niceStr__3(tmp5__anonymous__23_19) + ',' + _get_niceStr__3(tmp6__anonymous__23_21) + ',' + _get_niceStr__3(tmp7__anonymous__23_23) + ' ');
          Unit_getInstance();
          break;
        case 3:
          var tmp9_13_15_26 = n_1_3;
          n_1_3 = tmp9_13_15_26 + 1 | 0;
          var tmp8__anonymous__24_25 = this._data_37.get_137(tmp9_13_15_26);
          var tmp10_14_16_28 = n_1_3;
          n_1_3 = tmp10_14_16_28 + 1 | 0;
          var tmp9__anonymous__24_27 = this._data_37.get_137(tmp10_14_16_28);
          var tmp11_15_17_30 = n_1_3;
          n_1_3 = tmp11_15_17_30 + 1 | 0;
          var tmp10__anonymous__24_29 = this._data_37.get_137(tmp11_15_17_30);
          var tmp12_16_18_32 = n_1_3;
          n_1_3 = tmp12_16_18_32 + 1 | 0;
          var tmp11__anonymous__24_31 = this._data_37.get_137(tmp12_16_18_32);
          var tmp13_17_19_34 = n_1_3;
          n_1_3 = tmp13_17_19_34 + 1 | 0;
          var tmp12__anonymous__24_33 = this._data_37.get_137(tmp13_17_19_34);
          var tmp14_18_20_36 = n_1_3;
          n_1_3 = tmp14_18_20_36 + 1 | 0;
          var tmp13__anonymous__24_35 = this._data_37.get_137(tmp14_18_20_36);
          tmp0_apply_0_1.append_5('' + 'C' + _get_niceStr__3(tmp8__anonymous__24_25) + ',' + _get_niceStr__3(tmp9__anonymous__24_27) + ',' + _get_niceStr__3(tmp10__anonymous__24_29) + ',' + _get_niceStr__3(tmp11__anonymous__24_31) + ',' + _get_niceStr__3(tmp12__anonymous__24_33) + ',' + _get_niceStr__3(tmp13__anonymous__24_35) + ' ');
          Unit_getInstance();
          break;
        case 4:
          tmp0_apply_0_1.append_5('Z ');
          Unit_getInstance();
          break;
      }
    }
    var tmp0_trimEnd_0 = tmp0_apply_0_1.toString();
    return toString_1(trimEnd_0(isCharSequence(tmp0_trimEnd_0) ? tmp0_trimEnd_0 : THROW_CCE()));
  };
  VectorPath.prototype.toString = function () {
    return '' + 'VectorPath(' + this.toSvgString_0() + ')';
  };
  VectorPath.$metadata$ = {
    simpleName: 'VectorPath',
    kind: 'class',
    interfaces: [VectorBuilder]
  };
  function path(_this_, path_0) {
    write_0(_this_, path_0);
  }
  function add_0(_this_, path_0) {
    var bb = _this_;
    var lx = 0.0;
    var ly = 0.0;
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = path_0._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__60()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_0(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      switch (tmp0_subject_4_6) {
        case 0:
          var tmp1_5_7 = n_1;
          n_1 = tmp1_5_7 + 1 | 0;
          var tmp0__anonymous__21 = path_0._data_37.get_137(tmp1_5_7);
          var tmp2_6_8 = n_1;
          n_1 = tmp2_6_8 + 1 | 0;
          var tmp1__anonymous__21 = path_0._data_37.get_137(tmp2_6_8);
          var tmp0_also_0_23 = bb.add_52(tmp0__anonymous__21, tmp1__anonymous__21);
          lx = tmp0__anonymous__21;
          var tmp1_also_0_22 = tmp0_also_0_23;
          ly = tmp1__anonymous__21;
          Unit_getInstance();
          break;
        case 1:
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__24 = path_0._data_37.get_137(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__24 = path_0._data_37.get_137(tmp4_8_10);
          var tmp0_also_0_26 = bb.add_52(tmp2__anonymous__24, tmp3__anonymous__24);
          lx = tmp2__anonymous__24;
          var tmp1_also_0_25 = tmp0_also_0_26;
          ly = tmp3__anonymous__24;
          Unit_getInstance();
          break;
        case 2:
          var tmp5_9_11 = n_1;
          n_1 = tmp5_9_11 + 1 | 0;
          var tmp4__anonymous__27 = path_0._data_37.get_137(tmp5_9_11);
          var tmp6_10_12 = n_1;
          n_1 = tmp6_10_12 + 1 | 0;
          var tmp5__anonymous__27 = path_0._data_37.get_137(tmp6_10_12);
          var tmp7_11_13 = n_1;
          n_1 = tmp7_11_13 + 1 | 0;
          var tmp6__anonymous__27 = path_0._data_37.get_137(tmp7_11_13);
          var tmp8_12_14 = n_1;
          n_1 = tmp8_12_14 + 1 | 0;
          var tmp7__anonymous__27 = path_0._data_37.get_137(tmp8_12_14);
          var tmp = Companion_getInstance_89();
          var tmp_0 = lx;
          var tmp_1 = ly;
          var tmp0_also_0_29 = bb.add_46(tmp.quadBounds$default(tmp_0, tmp_1, tmp4__anonymous__27, tmp5__anonymous__27, tmp6__anonymous__27, tmp7__anonymous__27, bb._tempRect, null, 128, null));
          lx = tmp6__anonymous__27;
          var tmp1_also_0_28 = tmp0_also_0_29;
          ly = tmp7__anonymous__27;
          Unit_getInstance();
          break;
        case 3:
          var tmp9_13_15 = n_1;
          n_1 = tmp9_13_15 + 1 | 0;
          var tmp8__anonymous__30 = path_0._data_37.get_137(tmp9_13_15);
          var tmp10_14_16 = n_1;
          n_1 = tmp10_14_16 + 1 | 0;
          var tmp9__anonymous__30 = path_0._data_37.get_137(tmp10_14_16);
          var tmp11_15_17 = n_1;
          n_1 = tmp11_15_17 + 1 | 0;
          var tmp10__anonymous__30 = path_0._data_37.get_137(tmp11_15_17);
          var tmp12_16_18 = n_1;
          n_1 = tmp12_16_18 + 1 | 0;
          var tmp11__anonymous__30 = path_0._data_37.get_137(tmp12_16_18);
          var tmp13_17_19 = n_1;
          n_1 = tmp13_17_19 + 1 | 0;
          var tmp12__anonymous__30 = path_0._data_37.get_137(tmp13_17_19);
          var tmp14_18_20 = n_1;
          n_1 = tmp14_18_20 + 1 | 0;
          var tmp13__anonymous__30 = path_0._data_37.get_137(tmp14_18_20);
          var tmp0_also_0_32 = bb.add_46(Companion_getInstance_89().cubicBounds(lx, ly, tmp8__anonymous__30, tmp9__anonymous__30, tmp10__anonymous__30, tmp11__anonymous__30, tmp12__anonymous__30, tmp13__anonymous__30, bb._tempRect, path_0._bezierTemp));
          lx = tmp12__anonymous__30;
          var tmp1_also_0_31 = tmp0_also_0_32;
          ly = tmp13__anonymous__30;
          Unit_getInstance();
          break;
        case 4:
          Unit_getInstance();
          break;
      }
    }
  }
  function write_0(_this_, path_0) {
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = path_0._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__60()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_0(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      switch (tmp0_subject_4_6) {
        case 0:
          var tmp1_5_7 = n_1;
          n_1 = tmp1_5_7 + 1 | 0;
          var tmp0__anonymous__21 = path_0._data_37.get_137(tmp1_5_7);
          var tmp2_6_8 = n_1;
          n_1 = tmp2_6_8 + 1 | 0;
          var tmp1__anonymous__21 = path_0._data_37.get_137(tmp2_6_8);
          _this_.moveTo_9(tmp0__anonymous__21, tmp1__anonymous__21);
          break;
        case 1:
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__22 = path_0._data_37.get_137(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__22 = path_0._data_37.get_137(tmp4_8_10);
          _this_.lineTo_9(tmp2__anonymous__22, tmp3__anonymous__22);
          break;
        case 2:
          var tmp5_9_11 = n_1;
          n_1 = tmp5_9_11 + 1 | 0;
          var tmp4__anonymous__23 = path_0._data_37.get_137(tmp5_9_11);
          var tmp6_10_12 = n_1;
          n_1 = tmp6_10_12 + 1 | 0;
          var tmp5__anonymous__23 = path_0._data_37.get_137(tmp6_10_12);
          var tmp7_11_13 = n_1;
          n_1 = tmp7_11_13 + 1 | 0;
          var tmp6__anonymous__23 = path_0._data_37.get_137(tmp7_11_13);
          var tmp8_12_14 = n_1;
          n_1 = tmp8_12_14 + 1 | 0;
          var tmp7__anonymous__23 = path_0._data_37.get_137(tmp8_12_14);
          _this_.quadTo_7(tmp4__anonymous__23, tmp5__anonymous__23, tmp6__anonymous__23, tmp7__anonymous__23);
          break;
        case 3:
          var tmp9_13_15 = n_1;
          n_1 = tmp9_13_15 + 1 | 0;
          var tmp8__anonymous__24 = path_0._data_37.get_137(tmp9_13_15);
          var tmp10_14_16 = n_1;
          n_1 = tmp10_14_16 + 1 | 0;
          var tmp9__anonymous__24 = path_0._data_37.get_137(tmp10_14_16);
          var tmp11_15_17 = n_1;
          n_1 = tmp11_15_17 + 1 | 0;
          var tmp10__anonymous__24 = path_0._data_37.get_137(tmp11_15_17);
          var tmp12_16_18 = n_1;
          n_1 = tmp12_16_18 + 1 | 0;
          var tmp11__anonymous__24 = path_0._data_37.get_137(tmp12_16_18);
          var tmp13_17_19 = n_1;
          n_1 = tmp13_17_19 + 1 | 0;
          var tmp12__anonymous__24 = path_0._data_37.get_137(tmp13_17_19);
          var tmp14_18_20 = n_1;
          n_1 = tmp14_18_20 + 1 | 0;
          var tmp13__anonymous__24 = path_0._data_37.get_137(tmp14_18_20);
          _this_.cubicTo_7(tmp8__anonymous__24, tmp9__anonymous__24, tmp10__anonymous__24, tmp11__anonymous__24, tmp12__anonymous__24, tmp13__anonymous__24);
          break;
        case 4:
          _this_.close_77();
          break;
      }
    }
  }
  function scanline$factory() {
    return getPropertyCallableRef('scanline', 1, KProperty1, function (receiver) {
      return _get_scanline_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_173(this$0) {
    var i = new _no_name_provided__212(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  var Winding_EVEN_ODD_instance;
  var Winding_NON_ZERO_instance;
  var Winding_entriesInitialized;
  function Winding_initEntries() {
    if (Winding_entriesInitialized)
      return Unit_getInstance();
    Winding_entriesInitialized = true;
    Winding_EVEN_ODD_instance = new Winding('EVEN_ODD', 0, 'evenOdd');
    Winding_NON_ZERO_instance = new Winding('NON_ZERO', 1, 'nonZero');
  }
  function Winding(name, ordinal, str) {
    Enum.call(this, name, ordinal);
    this._str_3 = str;
  }
  Winding.$metadata$ = {
    simpleName: 'Winding',
    kind: 'class',
    interfaces: []
  };
  function Winding_EVEN_ODD_getInstance() {
    Winding_initEntries();
    return Winding_EVEN_ODD_instance;
  }
  function Winding_NON_ZERO_getInstance() {
    Winding_initEntries();
    return Winding_NON_ZERO_instance;
  }
  function max2_3(a, b) {
    return a > b ? a : b;
  }
  function min2_3(a, b) {
    return a < b ? a : b;
  }
  function _get_niceStr__3(_this_) {
    return almostEquals_0(numberToLong(_this_).toDouble_6(), _this_) ? '' + numberToLong(_this_) : '' + _this_;
  }
  function _get_niceStr__4(_this_) {
    return almostEquals(numberToLong(_this_).toFloat_6(), _this_) ? '' + numberToLong(_this_) : '' + _this_;
  }
  function max2_4(a, b) {
    return a > b ? a : b;
  }
  function min2_4(a, b) {
    return a < b ? a : b;
  }
  function floorCeil(v) {
    var tmp;
    if (v < 0.0) {
      var tmp0_unsafeCast_0_1 = Math.ceil(v);
      tmp = tmp0_unsafeCast_0_1;
    } else {
      var tmp0_unsafeCast_0_1_0 = Math.floor(v);
      tmp = tmp0_unsafeCast_0_1_0;
    }
    return tmp;
  }
  function _no_name_provided__213() {
  }
  _no_name_provided__213.prototype.invoke_1005 = function () {
    var tmp0_associateBy_0 = values_3();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_18(element_2_4._get_name__50(), element_2_4);
      Unit_getInstance();
    }
    return tmp0_associateByTo_0_2;
  };
  _no_name_provided__213.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_97() {
    Companion_instance_96 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp._ALL$delegate = lazy_0(tmp_0, _no_name_provided_$factory_174());
  }
  Companion_97.prototype._get_EASE_IN_OUT_QUAD_ = function () {
    return Easings_EASE_IN_OUT_QUAD_getInstance();
  };
  Companion_97.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_96;
  function Companion_getInstance_96() {
    if (Companion_instance_96 == null)
      new Companion_97();
    return Companion_instance_96;
  }
  function Easing() {
  }
  Easing.$metadata$ = {
    simpleName: 'Easing',
    kind: 'interface',
    interfaces: []
  };
  function SMOOTH() {
    Easings.call(this, 'SMOOTH', -1);
    Unit_getInstance();
    Easings_SMOOTH_instance = this;
  }
  SMOOTH.prototype.invoke_358 = function (it) {
    return it * it * (3 - 2 * it);
  };
  SMOOTH.$metadata$ = {
    simpleName: 'SMOOTH',
    kind: 'class',
    interfaces: []
  };
  var Easings_SMOOTH_instance;
  function EASE_IN_ELASTIC() {
    Easings.call(this, 'EASE_IN_ELASTIC', -1);
    Unit_getInstance();
    Easings_EASE_IN_ELASTIC_instance = this;
  }
  EASE_IN_ELASTIC.prototype.invoke_358 = function (it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:var p = 0.3;
        var s = p / 4.0;
        var inv = it - 1;
        var tmp0_pow_0 = 2.0;
        var tmp1_pow_0 = 10.0 * inv;
        var tmp_0 = -1.0 * Math.pow(tmp0_pow_0, tmp1_pow_0);
        var tmp2_sin_0 = (inv - s) * 6.283185307179586 / p;
        tmp = tmp_0 * Math.sin(tmp2_sin_0);
        break;
    }
    return tmp;
  };
  EASE_IN_ELASTIC.$metadata$ = {
    simpleName: 'EASE_IN_ELASTIC',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_ELASTIC_instance;
  function EASE_OUT_ELASTIC() {
    Easings.call(this, 'EASE_OUT_ELASTIC', -1);
    Unit_getInstance();
    Easings_EASE_OUT_ELASTIC_instance = this;
  }
  EASE_OUT_ELASTIC.prototype.invoke_358 = function (it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:var p = 0.3;
        var s = p / 4.0;
        var tmp0_pow_0 = 2.0;
        var tmp1_pow_0 = -10.0 * it;
        var tmp_0 = Math.pow(tmp0_pow_0, tmp1_pow_0);
        var tmp2_sin_0 = (it - s) * 6.283185307179586 / p;
        tmp = tmp_0 * Math.sin(tmp2_sin_0) + 1;
        break;
    }
    return tmp;
  };
  EASE_OUT_ELASTIC.$metadata$ = {
    simpleName: 'EASE_OUT_ELASTIC',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_ELASTIC_instance;
  function EASE_OUT_BOUNCE() {
    Easings.call(this, 'EASE_OUT_BOUNCE', -1);
    Unit_getInstance();
    Easings_EASE_OUT_BOUNCE_instance = this;
  }
  EASE_OUT_BOUNCE.prototype.invoke_358 = function (it) {
    var s = 7.5625;
    var p = 2.75;
    var tmp;
    if (it < 1.0 / p) {
      var tmp0_pow_0 = 2.0;
      tmp = s * Math.pow(it, tmp0_pow_0);
    } else if (it < 2.0 / p) {
      var tmp1_pow_0 = it - 1.5 / p;
      var tmp2_pow_0 = 2.0;
      tmp = s * Math.pow(tmp1_pow_0, tmp2_pow_0) + 0.75;
    } else if (it < 2.5 / p) {
      var tmp3_pow_0 = it - 2.25 / p;
      var tmp4_pow_0 = 2.0;
      tmp = s * Math.pow(tmp3_pow_0, tmp4_pow_0) + 0.9375;
    } else {
      var tmp5_pow_0 = it - 2.625 / p;
      var tmp6_pow_0 = 2.0;
      tmp = s * Math.pow(tmp5_pow_0, tmp6_pow_0) + 0.984375;
    }
    return tmp;
  };
  EASE_OUT_BOUNCE.$metadata$ = {
    simpleName: 'EASE_OUT_BOUNCE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_BOUNCE_instance;
  function LINEAR() {
    Easings.call(this, 'LINEAR', -1);
    Unit_getInstance();
    Easings_LINEAR_instance = this;
  }
  LINEAR.prototype.invoke_358 = function (it) {
    return it;
  };
  LINEAR.$metadata$ = {
    simpleName: 'LINEAR',
    kind: 'class',
    interfaces: []
  };
  var Easings_LINEAR_instance;
  function EASE_IN() {
    Easings.call(this, 'EASE_IN', -1);
    Unit_getInstance();
    Easings_EASE_IN_instance = this;
  }
  EASE_IN.prototype.invoke_358 = function (it) {
    return it * it * it;
  };
  EASE_IN.$metadata$ = {
    simpleName: 'EASE_IN',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_instance;
  function EASE_OUT() {
    Easings.call(this, 'EASE_OUT', -1);
    Unit_getInstance();
    Easings_EASE_OUT_instance = this;
  }
  EASE_OUT.prototype.invoke_358 = function (it) {
    var tmp0_let_0 = it - 1.0;
    return tmp0_let_0 * tmp0_let_0 * tmp0_let_0 + 1;
  };
  EASE_OUT.$metadata$ = {
    simpleName: 'EASE_OUT',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_instance;
  function EASE_IN_OUT() {
    Easings.call(this, 'EASE_IN_OUT', -1);
    Unit_getInstance();
    Easings_EASE_IN_OUT_instance = this;
  }
  EASE_IN_OUT.prototype.invoke_358 = function (it) {
    var tmp0_combine_0 = Easings_EASE_IN_getInstance();
    var tmp1_combine_0 = Easings_EASE_OUT_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_358(it * 2.0) : 0.5 * tmp1_combine_0.invoke_358((it - 0.5) * 2.0) + 0.5;
  };
  EASE_IN_OUT.$metadata$ = {
    simpleName: 'EASE_IN_OUT',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_OUT_instance;
  function EASE_OUT_IN() {
    Easings.call(this, 'EASE_OUT_IN', -1);
    Unit_getInstance();
    Easings_EASE_OUT_IN_instance = this;
  }
  EASE_OUT_IN.prototype.invoke_358 = function (it) {
    var tmp0_combine_0 = Easings_EASE_OUT_getInstance();
    var tmp1_combine_0 = Easings_EASE_IN_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_358(it * 2.0) : 0.5 * tmp1_combine_0.invoke_358((it - 0.5) * 2.0) + 0.5;
  };
  EASE_OUT_IN.$metadata$ = {
    simpleName: 'EASE_OUT_IN',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_IN_instance;
  function EASE_IN_BACK() {
    Easings.call(this, 'EASE_IN_BACK', -1);
    Unit_getInstance();
    Easings_EASE_IN_BACK_instance = this;
  }
  EASE_IN_BACK.prototype.invoke_358 = function (it) {
    var tmp0_pow_0 = 2.0;
    return Math.pow(it, tmp0_pow_0) * (2.70158 * it - 1.70158);
  };
  EASE_IN_BACK.$metadata$ = {
    simpleName: 'EASE_IN_BACK',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_BACK_instance;
  function EASE_OUT_BACK() {
    Easings.call(this, 'EASE_OUT_BACK', -1);
    Unit_getInstance();
    Easings_EASE_OUT_BACK_instance = this;
  }
  EASE_OUT_BACK.prototype.invoke_358 = function (it) {
    var tmp0_let_0 = it - 1.0;
    var tmp0_pow_0_2 = 2.0;
    return Math.pow(tmp0_let_0, tmp0_pow_0_2) * (2.70158 * tmp0_let_0 + 1.70158) + 1.0;
  };
  EASE_OUT_BACK.$metadata$ = {
    simpleName: 'EASE_OUT_BACK',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_BACK_instance;
  function EASE_IN_OUT_BACK() {
    Easings.call(this, 'EASE_IN_OUT_BACK', -1);
    Unit_getInstance();
    Easings_EASE_IN_OUT_BACK_instance = this;
  }
  EASE_IN_OUT_BACK.prototype.invoke_358 = function (it) {
    var tmp0_combine_0 = Easings_EASE_IN_BACK_getInstance();
    var tmp1_combine_0 = Easings_EASE_OUT_BACK_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_358(it * 2.0) : 0.5 * tmp1_combine_0.invoke_358((it - 0.5) * 2.0) + 0.5;
  };
  EASE_IN_OUT_BACK.$metadata$ = {
    simpleName: 'EASE_IN_OUT_BACK',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_OUT_BACK_instance;
  function EASE_OUT_IN_BACK() {
    Easings.call(this, 'EASE_OUT_IN_BACK', -1);
    Unit_getInstance();
    Easings_EASE_OUT_IN_BACK_instance = this;
  }
  EASE_OUT_IN_BACK.prototype.invoke_358 = function (it) {
    var tmp0_combine_0 = Easings_EASE_OUT_BACK_getInstance();
    var tmp1_combine_0 = Easings_EASE_IN_BACK_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_358(it * 2.0) : 0.5 * tmp1_combine_0.invoke_358((it - 0.5) * 2.0) + 0.5;
  };
  EASE_OUT_IN_BACK.$metadata$ = {
    simpleName: 'EASE_OUT_IN_BACK',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_IN_BACK_instance;
  function EASE_IN_OUT_ELASTIC() {
    Easings.call(this, 'EASE_IN_OUT_ELASTIC', -1);
    Unit_getInstance();
    Easings_EASE_IN_OUT_ELASTIC_instance = this;
  }
  EASE_IN_OUT_ELASTIC.prototype.invoke_358 = function (it) {
    var tmp0_combine_0 = Easings_EASE_IN_ELASTIC_getInstance();
    var tmp1_combine_0 = Easings_EASE_OUT_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_358(it * 2.0) : 0.5 * tmp1_combine_0.invoke_358((it - 0.5) * 2.0) + 0.5;
  };
  EASE_IN_OUT_ELASTIC.$metadata$ = {
    simpleName: 'EASE_IN_OUT_ELASTIC',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_OUT_ELASTIC_instance;
  function EASE_OUT_IN_ELASTIC() {
    Easings.call(this, 'EASE_OUT_IN_ELASTIC', -1);
    Unit_getInstance();
    Easings_EASE_OUT_IN_ELASTIC_instance = this;
  }
  EASE_OUT_IN_ELASTIC.prototype.invoke_358 = function (it) {
    var tmp0_combine_0 = Easings_EASE_OUT_ELASTIC_getInstance();
    var tmp1_combine_0 = Easings_EASE_IN_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_358(it * 2.0) : 0.5 * tmp1_combine_0.invoke_358((it - 0.5) * 2.0) + 0.5;
  };
  EASE_OUT_IN_ELASTIC.$metadata$ = {
    simpleName: 'EASE_OUT_IN_ELASTIC',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_IN_ELASTIC_instance;
  function EASE_IN_BOUNCE() {
    Easings.call(this, 'EASE_IN_BOUNCE', -1);
    Unit_getInstance();
    Easings_EASE_IN_BOUNCE_instance = this;
  }
  EASE_IN_BOUNCE.prototype.invoke_358 = function (it) {
    return 1.0 - Easings_EASE_OUT_BOUNCE_getInstance().invoke_358(1.0 - it);
  };
  EASE_IN_BOUNCE.$metadata$ = {
    simpleName: 'EASE_IN_BOUNCE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_BOUNCE_instance;
  function EASE_IN_OUT_BOUNCE() {
    Easings.call(this, 'EASE_IN_OUT_BOUNCE', -1);
    Unit_getInstance();
    Easings_EASE_IN_OUT_BOUNCE_instance = this;
  }
  EASE_IN_OUT_BOUNCE.prototype.invoke_358 = function (it) {
    var tmp0_combine_0 = Easings_EASE_IN_BOUNCE_getInstance();
    var tmp1_combine_0 = Easings_EASE_OUT_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_358(it * 2.0) : 0.5 * tmp1_combine_0.invoke_358((it - 0.5) * 2.0) + 0.5;
  };
  EASE_IN_OUT_BOUNCE.$metadata$ = {
    simpleName: 'EASE_IN_OUT_BOUNCE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_OUT_BOUNCE_instance;
  function EASE_OUT_IN_BOUNCE() {
    Easings.call(this, 'EASE_OUT_IN_BOUNCE', -1);
    Unit_getInstance();
    Easings_EASE_OUT_IN_BOUNCE_instance = this;
  }
  EASE_OUT_IN_BOUNCE.prototype.invoke_358 = function (it) {
    var tmp0_combine_0 = Easings_EASE_OUT_BOUNCE_getInstance();
    var tmp1_combine_0 = Easings_EASE_IN_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * tmp0_combine_0.invoke_358(it * 2.0) : 0.5 * tmp1_combine_0.invoke_358((it - 0.5) * 2.0) + 0.5;
  };
  EASE_OUT_IN_BOUNCE.$metadata$ = {
    simpleName: 'EASE_OUT_IN_BOUNCE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_IN_BOUNCE_instance;
  function EASE_IN_QUAD() {
    Easings.call(this, 'EASE_IN_QUAD', -1);
    Unit_getInstance();
    Easings_EASE_IN_QUAD_instance = this;
  }
  EASE_IN_QUAD.prototype.invoke_358 = function (it) {
    return 1.0 * it * it;
  };
  EASE_IN_QUAD.$metadata$ = {
    simpleName: 'EASE_IN_QUAD',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_QUAD_instance;
  function EASE_OUT_QUAD() {
    Easings.call(this, 'EASE_OUT_QUAD', -1);
    Unit_getInstance();
    Easings_EASE_OUT_QUAD_instance = this;
  }
  EASE_OUT_QUAD.prototype.invoke_358 = function (it) {
    return -1.0 * it * (it - 2);
  };
  EASE_OUT_QUAD.$metadata$ = {
    simpleName: 'EASE_OUT_QUAD',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_OUT_QUAD_instance;
  function EASE_IN_OUT_QUAD() {
    Easings.call(this, 'EASE_IN_OUT_QUAD', -1);
    Unit_getInstance();
    Easings_EASE_IN_OUT_QUAD_instance = this;
  }
  EASE_IN_OUT_QUAD.prototype.invoke_358 = function (it) {
    var tmp0_let_0 = it * 2.0;
    var tmp;
    if (tmp0_let_0 < 1.0) {
      tmp = 0.5 * tmp0_let_0 * tmp0_let_0;
    } else {
      tmp = -0.5 * ((tmp0_let_0 - 1) * (tmp0_let_0 - 1 - 2) - 1);
    }
    return tmp;
  };
  EASE_IN_OUT_QUAD.$metadata$ = {
    simpleName: 'EASE_IN_OUT_QUAD',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_IN_OUT_QUAD_instance;
  function EASE_SINE() {
    Easings.call(this, 'EASE_SINE', -1);
    Unit_getInstance();
    Easings_EASE_SINE_instance = this;
  }
  EASE_SINE.prototype.invoke_358 = function (it) {
    var tmp0_sin_0 = it * 1.5707963267948966;
    return Math.sin(tmp0_sin_0);
  };
  EASE_SINE.$metadata$ = {
    simpleName: 'EASE_SINE',
    kind: 'class',
    interfaces: []
  };
  var Easings_EASE_SINE_instance;
  function values_3() {
    return [Easings_SMOOTH_getInstance(), Easings_EASE_IN_ELASTIC_getInstance(), Easings_EASE_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_BOUNCE_getInstance(), Easings_LINEAR_getInstance(), Easings_EASE_IN_getInstance(), Easings_EASE_OUT_getInstance(), Easings_EASE_IN_OUT_getInstance(), Easings_EASE_OUT_IN_getInstance(), Easings_EASE_IN_BACK_getInstance(), Easings_EASE_OUT_BACK_getInstance(), Easings_EASE_IN_OUT_BACK_getInstance(), Easings_EASE_OUT_IN_BACK_getInstance(), Easings_EASE_IN_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_IN_ELASTIC_getInstance(), Easings_EASE_IN_BOUNCE_getInstance(), Easings_EASE_IN_OUT_BOUNCE_getInstance(), Easings_EASE_OUT_IN_BOUNCE_getInstance(), Easings_EASE_IN_QUAD_getInstance(), Easings_EASE_OUT_QUAD_getInstance(), Easings_EASE_IN_OUT_QUAD_getInstance(), Easings_EASE_SINE_getInstance()];
  }
  var Easings_entriesInitialized;
  function Easings_initEntries() {
    if (Easings_entriesInitialized)
      return Unit_getInstance();
    Easings_entriesInitialized = true;
    Easings_SMOOTH_instance = new SMOOTH();
    Easings_EASE_IN_ELASTIC_instance = new EASE_IN_ELASTIC();
    Easings_EASE_OUT_ELASTIC_instance = new EASE_OUT_ELASTIC();
    Easings_EASE_OUT_BOUNCE_instance = new EASE_OUT_BOUNCE();
    Easings_LINEAR_instance = new LINEAR();
    Easings_EASE_IN_instance = new EASE_IN();
    Easings_EASE_OUT_instance = new EASE_OUT();
    Easings_EASE_IN_OUT_instance = new EASE_IN_OUT();
    Easings_EASE_OUT_IN_instance = new EASE_OUT_IN();
    Easings_EASE_IN_BACK_instance = new EASE_IN_BACK();
    Easings_EASE_OUT_BACK_instance = new EASE_OUT_BACK();
    Easings_EASE_IN_OUT_BACK_instance = new EASE_IN_OUT_BACK();
    Easings_EASE_OUT_IN_BACK_instance = new EASE_OUT_IN_BACK();
    Easings_EASE_IN_OUT_ELASTIC_instance = new EASE_IN_OUT_ELASTIC();
    Easings_EASE_OUT_IN_ELASTIC_instance = new EASE_OUT_IN_ELASTIC();
    Easings_EASE_IN_BOUNCE_instance = new EASE_IN_BOUNCE();
    Easings_EASE_IN_OUT_BOUNCE_instance = new EASE_IN_OUT_BOUNCE();
    Easings_EASE_OUT_IN_BOUNCE_instance = new EASE_OUT_IN_BOUNCE();
    Easings_EASE_IN_QUAD_instance = new EASE_IN_QUAD();
    Easings_EASE_OUT_QUAD_instance = new EASE_OUT_QUAD();
    Easings_EASE_IN_OUT_QUAD_instance = new EASE_IN_OUT_QUAD();
    Easings_EASE_SINE_instance = new EASE_SINE();
  }
  function Easings(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Easings.$metadata$ = {
    simpleName: 'Easings',
    kind: 'class',
    interfaces: [Easing]
  };
  function Easings_SMOOTH_getInstance() {
    Easings_initEntries();
    return Easings_SMOOTH_instance;
  }
  function Easings_EASE_IN_ELASTIC_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_ELASTIC_instance;
  }
  function Easings_EASE_OUT_ELASTIC_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_ELASTIC_instance;
  }
  function Easings_EASE_OUT_BOUNCE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_BOUNCE_instance;
  }
  function Easings_LINEAR_getInstance() {
    Easings_initEntries();
    return Easings_LINEAR_instance;
  }
  function Easings_EASE_IN_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_instance;
  }
  function Easings_EASE_OUT_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_instance;
  }
  function Easings_EASE_IN_OUT_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_OUT_instance;
  }
  function Easings_EASE_OUT_IN_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_IN_instance;
  }
  function Easings_EASE_IN_BACK_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_BACK_instance;
  }
  function Easings_EASE_OUT_BACK_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_BACK_instance;
  }
  function Easings_EASE_IN_OUT_BACK_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_OUT_BACK_instance;
  }
  function Easings_EASE_OUT_IN_BACK_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_IN_BACK_instance;
  }
  function Easings_EASE_IN_OUT_ELASTIC_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_OUT_ELASTIC_instance;
  }
  function Easings_EASE_OUT_IN_ELASTIC_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_IN_ELASTIC_instance;
  }
  function Easings_EASE_IN_BOUNCE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_BOUNCE_instance;
  }
  function Easings_EASE_IN_OUT_BOUNCE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_OUT_BOUNCE_instance;
  }
  function Easings_EASE_OUT_IN_BOUNCE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_IN_BOUNCE_instance;
  }
  function Easings_EASE_IN_QUAD_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_QUAD_instance;
  }
  function Easings_EASE_OUT_QUAD_getInstance() {
    Easings_initEntries();
    return Easings_EASE_OUT_QUAD_instance;
  }
  function Easings_EASE_IN_OUT_QUAD_getInstance() {
    Easings_initEntries();
    return Easings_EASE_IN_OUT_QUAD_instance;
  }
  function Easings_EASE_SINE_getInstance() {
    Easings_initEntries();
    return Easings_EASE_SINE_instance;
  }
  function _no_name_provided_$factory_174() {
    var i = new _no_name_provided__213();
    return function () {
      return i.invoke_1005();
    };
  }
  function MutableInterpolable() {
  }
  MutableInterpolable.$metadata$ = {
    simpleName: 'MutableInterpolable',
    kind: 'interface',
    interfaces: []
  };
  function Interpolable() {
  }
  Interpolable.$metadata$ = {
    simpleName: 'Interpolable',
    kind: 'interface',
    interfaces: []
  };
  function interpolate(_this_, l, r) {
    return l + (r - l) * _this_;
  }
  function interpolate_0(_this_, l, r) {
    return numberToInt(l + (r - l | 0) * _this_);
  }
  function minOrElse(_this_, nil) {
    if (_this_.length === 0)
      return nil;
    else {
    }
    var out = Infinity;
    var inductionVariable = 0;
    var last_1 = _get_lastIndex__1(_this_);
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = min2_3(out, _this_[i]);
      }
       while (!(i === last_1));
    return out;
  }
  function maxOrElse(_this_, nil) {
    if (_this_.length === 0)
      return nil;
    else {
    }
    var out = -Infinity;
    var inductionVariable = 0;
    var last_1 = _get_lastIndex__1(_this_);
    if (inductionVariable <= last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = max2_3(out, _this_[i]);
      }
       while (!(i === last_1));
    return out;
  }
  function almostEquals(a, b) {
    return almostZero(a - b);
  }
  function almostEquals_0(a, b) {
    return almostZero_0(a - b);
  }
  function almostZero(a) {
    return Math.abs(a) <= 1.0E-7;
  }
  function almostZero_0(a) {
    return Math.abs(a) <= 1.0E-7;
  }
  function roundDecimalPlaces(_this_, places) {
    var tmp0_pow_0 = 10.0;
    var tmp1_pow_0 = places;
    var placesFactor = Math.pow(tmp0_pow_0, tmp1_pow_0);
    return round(_this_ * placesFactor) / placesFactor;
  }
  function clamp_5(_this_, min, max) {
    return _this_ < min ? min : _this_ > max ? max : _this_;
  }
  function insertAt($this, n, min, max) {
    $this._min_0.insertAt(n, min);
    Unit_getInstance();
    $this._max_0.insertAt(n, max);
    Unit_getInstance();
  }
  function removeAt($this, n, count_0) {
    $this._min_0.removeAt_2(n, count_0);
    Unit_getInstance();
    $this._max_0.removeAt_2(n, count_0);
    Unit_getInstance();
  }
  function IntSegmentSet() {
    this._min_0 = new IntArrayList(16);
    this._max_0 = new IntArrayList(16);
  }
  IntSegmentSet.prototype._get_size__60 = function () {
    return this._min_0._get_size__60();
  };
  IntSegmentSet.prototype.isEmpty_53 = function () {
    return this._get_size__60() === 0;
  };
  IntSegmentSet.prototype.isNotEmpty_1 = function () {
    return this._get_size__60() > 0;
  };
  IntSegmentSet.prototype.clear_19 = function () {
    this._min_0.clear_33();
    this._max_0.clear_33();
    return this;
  };
  IntSegmentSet.prototype._get_minMin_ = function () {
    return this.isNotEmpty_1() ? this._min_0.getAt_0(0) : 0;
  };
  IntSegmentSet.prototype._get_maxMax_ = function () {
    return this.isNotEmpty_1() ? this._max_0.getAt_0(this._max_0._get_size__60() - 1 | 0) : 0;
  };
  IntSegmentSet.prototype.findNearIndex = function (x) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_genericBinarySearch_0 = 0;
      var tmp1_genericBinarySearch_0 = this._get_size__60();
      var low_2 = tmp0_genericBinarySearch_0;
      var high_3 = tmp1_genericBinarySearch_0 - 1 | 0;
      while (low_2 <= high_3) {
        var mid_4 = (low_2 + high_3 | 0) / 2 | 0;
        var min_7 = this._min_0.getAt_0(mid_4);
        var max_8 = this._max_0.getAt_0(mid_4);
        var mval_5 = x < min_7 ? 1 : x > max_8 ? -1 : 0;
        if (mval_5 < 0)
          low_2 = mid_4 + 1 | 0;
        else if (mval_5 > 0)
          high_3 = mid_4 - 1 | 0;
        else {
          tmp$ret$0 = mid_4;
          break l$ret$1;
        }
      }
      var tmp2__anonymous__1_9 = low_2;
      var tmp3__anonymous__1_9 = high_3;
      tmp$ret$0 = (-tmp2__anonymous__1_9 | 0) - 1 | 0;
    }
     while (false);
    return _BSearchResult___init__impl_(tmp$ret$0);
  };
  IntSegmentSet.prototype.findLeftBound = function (x) {
    var tmp2_genericBinarySearchLeft_0 = 0;
    var tmp3_genericBinarySearchLeft_0 = this._get_size__60();
    var tmp$ret$0;
    l$ret$1: do {
      var low_2 = tmp2_genericBinarySearchLeft_0;
      var high_3 = tmp3_genericBinarySearchLeft_0 - 1 | 0;
      while (low_2 <= high_3) {
        var mid_4 = (low_2 + high_3 | 0) / 2 | 0;
        var mval_5 = compareTo(this._min_0.getAt_0(mid_4), x);
        if (mval_5 < 0)
          low_2 = mid_4 + 1 | 0;
        else if (mval_5 > 0)
          high_3 = mid_4 - 1 | 0;
        else {
          tmp$ret$0 = mid_4;
          break l$ret$1;
        }
      }
      var tmp0__anonymous__1_6 = low_2;
      var tmp1__anonymous__1_6 = high_3;
      tmp$ret$0 = coerceIn(min2_4(tmp0__anonymous__1_6, tmp1__anonymous__1_6), tmp2_genericBinarySearchLeft_0, tmp3_genericBinarySearchLeft_0 - 1 | 0);
    }
     while (false);
    return coerceIn(tmp$ret$0, 0, this._get_size__60() - 1 | 0);
  };
  IntSegmentSet.prototype.findRightBound = function (x) {
    var tmp2_genericBinarySearchRight_0 = 0;
    var tmp3_genericBinarySearchRight_0 = this._get_size__60();
    var tmp$ret$0;
    l$ret$1: do {
      var low_2 = tmp2_genericBinarySearchRight_0;
      var high_3 = tmp3_genericBinarySearchRight_0 - 1 | 0;
      while (low_2 <= high_3) {
        var mid_4 = (low_2 + high_3 | 0) / 2 | 0;
        var mval_5 = compareTo(this._max_0.getAt_0(mid_4), x);
        if (mval_5 < 0)
          low_2 = mid_4 + 1 | 0;
        else if (mval_5 > 0)
          high_3 = mid_4 - 1 | 0;
        else {
          tmp$ret$0 = mid_4;
          break l$ret$1;
        }
      }
      var tmp0__anonymous__1_6 = low_2;
      var tmp1__anonymous__1_6 = high_3;
      tmp$ret$0 = coerceIn(max2_4(tmp0__anonymous__1_6, tmp1__anonymous__1_6), tmp2_genericBinarySearchRight_0, tmp3_genericBinarySearchRight_0 - 1 | 0);
    }
     while (false);
    return coerceIn(tmp$ret$0, 0, this._get_size__60() - 1 | 0);
  };
  IntSegmentSet.prototype.add_58 = function (min, max) {
    var tmp$ret$2;
    l$ret$3: do {
      var tmp0_check_0_2 = min <= max;
      if (!tmp0_check_0_2) {
        var message_2_1_3 = 'Check failed.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2_1_3));
      }if (this.isEmpty_53())
        insertAt(this, this._get_size__60(), min, max);
      else if (min === this._get_maxMax_())
        this._max_0.set_35(this._max_0._get_size__60() - 1 | 0, max);
      else if (max === this._get_minMin_())
        this._min_0.set_35(0, min);
      else {
        var removeStart_4 = -1;
        var removeCount_5 = -1;
        var tmp$ret$0;
        l$ret$1: do {
          if (this.isEmpty_53()) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }var nmin_1_6 = this.findLeftBound(min);
          var nmax_2_7 = this.findRightBound(max);
          var inductionVariable = nmin_1_6;
          if (inductionVariable <= nmax_2_7)
            do {
              var n_4_9 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp1__anonymous__5_10 = this._min_0.getAt_0(n_4_9);
              var tmp2__anonymous__5_11 = this._max_0.getAt_0(n_4_9);
              if (this.intersects_1(tmp1__anonymous__5_10, tmp2__anonymous__5_11, min, max)) {
                if (removeStart_4 === -1)
                  removeStart_4 = n_4_9;
                this._min_0.set_35(removeStart_4, min2_4(this._min_0.getAt_0(removeStart_4), min2_4(tmp1__anonymous__5_10, min)));
                this._max_0.set_35(removeStart_4, max2_4(this._max_0.getAt_0(removeStart_4), max2_4(tmp2__anonymous__5_11, max)));
                var tmp0_6_12 = removeCount_5;
                removeCount_5 = tmp0_6_12 + 1 | 0;
                Unit_getInstance();
              }}
             while (!(n_4_9 === nmax_2_7));
        }
         while (false);
        if (removeCount_5 === 0)
          Unit_getInstance();
        else if (removeCount_5 > 0)
          removeAt(this, removeStart_4 + 1 | 0, removeCount_5);
        else if (max < this._get_minMin_())
          insertAt(this, 0, min, max);
        else if (min > this._get_maxMax_())
          insertAt(this, this._get_size__60(), min, max);
        else {
          var inductionVariable_0 = coerceAtLeast(this.findLeftBound(min), 1);
          var last_1 = this.findRightBound(max);
          if (inductionVariable_0 <= last_1)
            do {
              var m_14 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var prevMax_15 = this._max_0.getAt_0(m_14 - 1 | 0);
              var currMin_16 = this._min_0.getAt_0(m_14);
              if (min > prevMax_15 ? max < currMin_16 : false) {
                insertAt(this, m_14, min, max);
                tmp$ret$2 = Unit_getInstance();
                break l$ret$3;
              }}
             while (!(m_14 === last_1));
          var tmp3_error_0_17 = 'Unexpected';
          throw IllegalStateException_init_$Create$_0(toString_1(tmp3_error_0_17));
        }
      }
    }
     while (false);
    return this;
  };
  IntSegmentSet.prototype.contains_56 = function (v) {
    return _BSearchResult___get_found__impl_(this.findNearIndex(v));
  };
  IntSegmentSet.prototype.setToIntersect = function (a, b) {
    var aSmaller_2 = a._get_size__60() < b._get_size__60();
    var av_3 = aSmaller_2 ? a : b;
    var bv_4 = aSmaller_2 ? b : a;
    var tmp0_also_0_5 = this.clear_19();
    var inductionVariable = 0;
    var last_1 = av_3._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n_2_3_7 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__anonymous__3_4_8 = av_3._min_0.getAt_0(n_2_3_7);
        var tmp1__anonymous__3_5_9 = av_3._max_0.getAt_0(n_2_3_7);
        var count_1_4_6_10 = 0;
        var tmp$ret$0;
        l$ret$1: do {
          if (bv_4.isEmpty_53()) {
            tmp$ret$0 = Unit_getInstance();
            break l$ret$1;
          }var nmin_1_2_5_7_11 = bv_4.findLeftBound(tmp0__anonymous__3_4_8);
          var nmax_2_3_6_8_12 = bv_4.findRightBound(tmp1__anonymous__3_5_9);
          var inductionVariable_0 = nmin_1_2_5_7_11;
          if (inductionVariable_0 <= nmax_2_3_6_8_12)
            do {
              var n_4_5_8_10_14 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp0__anonymous__5_6_9_11_15 = bv_4._min_0.getAt_0(n_4_5_8_10_14);
              var tmp1__anonymous__5_7_10_12_16 = bv_4._max_0.getAt_0(n_4_5_8_10_14);
              if (bv_4.intersects_1(tmp0__anonymous__5_6_9_11_15, tmp1__anonymous__5_7_10_12_16, tmp0__anonymous__3_4_8, tmp1__anonymous__3_5_9)) {
                var tmp0__anonymous__9_11_13_17 = max2_4(tmp0__anonymous__5_6_9_11_15, tmp0__anonymous__3_4_8);
                var tmp1__anonymous__9_12_14_18 = min2_4(tmp1__anonymous__5_7_10_12_16, tmp1__anonymous__3_5_9);
                this.add_58(tmp0__anonymous__9_11_13_17, tmp1__anonymous__9_12_14_18);
                Unit_getInstance();
                var tmp0_6_8_13_15_19 = count_1_4_6_10;
                count_1_4_6_10 = tmp0_6_8_13_15_19 + 1 | 0;
                Unit_getInstance();
              }}
             while (!(n_4_5_8_10_14 === nmax_2_3_6_8_12));
        }
         while (false);
        count_1_4_6_10 > 0;
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    Unit_getInstance();
    return this;
  };
  IntSegmentSet.prototype.intersects_1 = function (x1, x2, y1, y2) {
    return x2 >= y1 ? y2 >= x1 : false;
  };
  IntSegmentSet.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_5('[');
    Unit_getInstance();
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n_2_4 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0__anonymous__3_5 = this._min_0.getAt_0(n_2_4);
        var tmp1__anonymous__3_6 = this._max_0.getAt_0(n_2_4);
        var first_4_7 = n_2_4 === 0;
        if (!first_4_7) {
          tmp0_apply_0_1.append_5(', ');
          Unit_getInstance();
        }tmp0_apply_0_1.append_5('' + tmp0__anonymous__3_5 + '-' + tmp1__anonymous__3_6);
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    tmp0_apply_0_1.append_5(']');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  IntSegmentSet.$metadata$ = {
    simpleName: 'IntSegmentSet',
    kind: 'class',
    interfaces: []
  };
  function MutableAtlas_init_$Init$(binPacker, border, premultiplied, allowToGrow, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      border = 2;
    if (!(($mask0 & 4) === 0))
      premultiplied = true;
    if (!(($mask0 & 8) === 0))
      allowToGrow = true;
    MutableAtlas.call($this, binPacker, border, premultiplied, allowToGrow);
    return $this;
  }
  function MutableAtlas_init_$Init$_0(width, height, border, allowToGrow, $this) {
    var tmp = Companion_getInstance_90();
    var tmp_0 = tmp.invoke$default_2(width, height, null, 4, null);
    MutableAtlas_init_$Init$(tmp_0, border, false, false, 12, null, $this);
    return $this;
  }
  function MutableAtlas_init_$Init$_1(width, height, border, allowToGrow, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      border = 2;
    if (!(($mask0 & 8) === 0))
      allowToGrow = true;
    MutableAtlas_init_$Init$_0(width, height, border, allowToGrow, $this);
    return $this;
  }
  function MutableAtlas_init_$Create$(width, height, border, allowToGrow, $mask0, $marker) {
    return MutableAtlas_init_$Init$_1(width, height, border, allowToGrow, $mask0, $marker, Object.create(MutableAtlas.prototype));
  }
  function Entry_1(slice_1, data) {
    this._slice = slice_1;
    this._data_38 = data;
  }
  Entry_1.prototype.toString = function () {
    return '' + 'Entry(slice=' + this._slice + ', data=' + this._data_38 + ')';
  };
  Entry_1.prototype.hashCode = function () {
    var result = hashCode(this._slice);
    result = imul(result, 31) + (this._data_38 == null ? 0 : hashCode(this._data_38)) | 0;
    return result;
  };
  Entry_1.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_1))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Entry_1 ? other : THROW_CCE();
    if (!equals_1(this._slice, tmp0_other_with_cast._slice))
      return false;
    if (!equals_1(this._data_38, tmp0_other_with_cast._data_38))
      return false;
    return true;
  };
  Entry_1.$metadata$ = {
    simpleName: 'Entry',
    kind: 'class',
    interfaces: []
  };
  function MutableAtlas(binPacker, border, premultiplied, allowToGrow) {
    this._binPacker = binPacker;
    this._border = border;
    this._premultiplied = premultiplied;
    this._allowToGrow = allowToGrow;
    var tmp = this;
    var tmp_0 = this._get_width__58();
    var tmp_1 = this._get_height__58();
    tmp._bitmap = Bitmap32_init_$Create$(tmp_0, tmp_1, null, this._premultiplied, 4, null);
    var tmp_2 = this;
    tmp_2._entries = ArrayList_init_$Create$();
    this._entriesByName = LinkedHashMap_init_$Create$();
  }
  MutableAtlas.prototype._get_width__58 = function () {
    return numberToInt(this._binPacker._width_1);
  };
  MutableAtlas.prototype._get_height__58 = function () {
    return numberToInt(this._binPacker._height_1);
  };
  MutableAtlas.prototype._get_size__60 = function () {
    return this._entries._get_size__60();
  };
  MutableAtlas.prototype.reconstructWithSize = function (width, height) {
    var slices = toList_2(this._entries);
    var tmp = this;
    var tmp_0 = Companion_getInstance_90();
    tmp._binPacker = tmp_0.invoke$default_2(width, height, null, 4, null);
    var tmp_1 = this;
    tmp_1._bitmap = Bitmap32_init_$Create$(width, height, null, this._premultiplied, 4, null);
    this._entriesByName.clear_33();
    this._entries.clear_33();
    var tmp0_iterator = slices.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var entry = tmp0_iterator.next_37();
      this.add_60(entry._slice, entry._data_38, entry._slice._get_name__50());
      Unit_getInstance();
    }
  };
  MutableAtlas.prototype.add_59 = function (bmp, data, name) {
    return this.add_60(slice$default(bmp, null, '' + 'Slice' + this._get_size__60(), 1, null), data, name);
  };
  MutableAtlas.prototype.add$default_1 = function (bmp, data, name, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      name = null;
    return this.add_59(bmp, data, name);
  };
  MutableAtlas.prototype.add_60 = function (bmp, data, name) {
    try {
      var tmp0_elvis_lhs = name;
      var rname = tmp0_elvis_lhs == null ? '' + 'Slice' + this._get_size__60() : tmp0_elvis_lhs;
      var rect_1 = this._binPacker.add_52(bmp._get_width__58() + imul(this._border, 2), bmp._get_height__58() + imul(this._border, 2));
      var slice_1 = sliceWithSize_1(this._bitmap, numberToInt(rect_1._get_left__4() + this._border), numberToInt(rect_1._get_top__4() + this._border), bmp._get_width__58(), bmp._get_height__58(), rname);
      var dstX = slice_1._get_left__4();
      var dstY = slice_1._get_top__4();
      this._bitmap.draw_0(bmp, dstX, dstY);
      var entry = new Entry_1(slice_1, data);
      var tmp1_this = this;
      var tmp0_plusAssign_0 = tmp1_this._entries;
      tmp0_plusAssign_0.add_39(entry);
      Unit_getInstance();
      var tmp1_set_0 = this._entriesByName;
      tmp1_set_0.put_18(rname, entry);
      Unit_getInstance();
      var tmp2_this = this._bitmap;
      var tmp3 = tmp2_this._get_contentVersion__0();
      tmp2_this._set_contentVersion__0(tmp3 + 1 | 0);
      Unit_getInstance();
      return entry;
    } catch ($p) {
      if ($p instanceof Error) {
        if (!this._allowToGrow)
          throw $p;
        this.reconstructWithSize(imul(this._get_width__58(), 2), imul(this._get_height__58(), 2));
        return this.add_60(bmp, data, name);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  MutableAtlas.$metadata$ = {
    simpleName: 'MutableAtlas',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__214(this$0) {
    this._this$0_47 = this$0;
  }
  _no_name_provided__214.prototype.invoke_359 = function () {
    return Companion_getInstance_105().invoke_379(imul(this._this$0_47._width_2, 2));
  };
  _no_name_provided__214.prototype.invoke_1005 = function () {
    return new RgbaArray(this.invoke_359());
  };
  _no_name_provided__214.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Bitmap(width, height, bpp, premultiplied, backingArray) {
    this._width_2 = width;
    this._height_2 = height;
    this._bpp = bpp;
    this._premultiplied_0 = premultiplied;
    this._backingArray = backingArray;
    var tmp = this;
    tmp._$$delegate_0_6 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._tempRgba$delegate = lazy(_no_name_provided_$factory_175(this));
    this._contentVersion = 0;
    this._texture = null;
    this._mipmaps = false;
  }
  Bitmap.prototype._get_width__58 = function () {
    return this._width_2;
  };
  Bitmap.prototype._get_height__58 = function () {
    return this._height_2;
  };
  Bitmap.prototype._get_bpp__10 = function () {
    return this._bpp;
  };
  Bitmap.prototype._set_premultiplied__1 = function (_set___) {
    this._premultiplied_0 = _set___;
  };
  Bitmap.prototype._get_premultiplied__8 = function () {
    return this._premultiplied_0;
  };
  Bitmap.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_6._extra = _set___;
  };
  Bitmap.prototype._get_extra__71 = function () {
    return this._$$delegate_0_6._extra;
  };
  Bitmap.prototype._get_tempRgba__5 = function () {
    var tmp0_getValue_0 = this._tempRgba$delegate;
    var tmp1_getValue_0 = tempRgba$factory();
    return tmp0_getValue_0._get_value__10()._ints;
  };
  Bitmap.prototype._set_contentVersion__0 = function (_set___) {
    this._contentVersion = _set___;
  };
  Bitmap.prototype._get_contentVersion__0 = function () {
    return this._contentVersion;
  };
  Bitmap.prototype._get_stride__1 = function () {
    return imul(this._width_2, this._bpp) / 8 | 0;
  };
  Bitmap.prototype._get_area__7 = function () {
    return imul(this._width_2, this._height_2);
  };
  Bitmap.prototype.index_7 = function (x, y) {
    return imul(y, this._width_2) + x | 0;
  };
  Bitmap.prototype.lock_5 = function () {
    return Unit_getInstance();
  };
  Bitmap.prototype.unlock_5 = function (rect_1) {
    var tmp0_this = this;
    var tmp1 = tmp0_this._contentVersion;
    tmp0_this._contentVersion = tmp1 + 1 | 0;
    return tmp1;
  };
  Bitmap.prototype.readPixelsUnsafe_5 = function (x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            RgbaArray__set_impl(out, tmp2, this.getRgba_5(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  };
  Bitmap.prototype.writePixelsUnsafe_5 = function (x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var tmp2 = n;
            n = tmp2 + 1 | 0;
            this.setRgba_5(tmp, tmp_0, RgbaArray__get_impl(out, tmp2));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  };
  Bitmap.prototype.setRgba_5 = function (x, y, v) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  Bitmap.prototype.getRgba_5 = function (x, y) {
    return Colors_getInstance()._TRANSPARENT_BLACK;
  };
  Bitmap.prototype.setInt_6 = function (x, y, color_0) {
    return Unit_getInstance();
  };
  Bitmap.prototype.getInt_6 = function (x, y) {
    return 0;
  };
  Bitmap.prototype.getRgbaClamped_5 = function (x, y) {
    return this.inBounds_6(x, y) ? this.getRgba_5(x, y) : Colors_getInstance()._TRANSPARENT_BLACK;
  };
  Bitmap.prototype.getRgbaSampled_0 = function (x, y) {
    if (((x < 0.0 ? true : x >= this._width_2) ? true : y < 0.0) ? true : y >= this._height_2)
      return Colors_getInstance()._TRANSPARENT_BLACK;
    var x0 = toIntFloor(x);
    var x1 = toIntCeil(x);
    var y0 = toIntFloor(y);
    var y1 = toIntCeil(y);
    var xratio = x % 1;
    var yratio = y % 1;
    var c00 = this.getRgbaClamped_5(x0, y0);
    var c10 = this.inBounds_6(x1, y0) ? this.getRgbaClamped_5(x1, y0) : c00;
    var c01 = this.inBounds_6(x1, y1) ? this.getRgbaClamped_5(x0, y1) : c00;
    var c11 = this.inBounds_6(x1, y1) ? this.getRgbaClamped_5(x1, y1) : c01;
    var c1 = Companion_getInstance_104().mixRgba(c00, c10, xratio);
    var c2 = Companion_getInstance_104().mixRgba(c01, c11, xratio);
    return Companion_getInstance_104().mixRgba(c1, c2, yratio);
  };
  Bitmap.prototype.copy_19 = function (srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.clampWidth_5(srcX);
    var srcX1 = src.clampWidth_5(srcX + width | 0);
    var srcY0 = src.clampHeight_5(srcY);
    var srcY1 = src.clampHeight_5(srcY + height | 0);
    var dstX0 = dst.clampWidth_5(dstX);
    var dstX1 = dst.clampWidth_5(dstX + width | 0);
    var dstY0 = dst.clampHeight_5(dstY);
    var dstY1 = dst.clampHeight_5(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    var width_0 = min2_5(srcX1 - srcX0 | 0, dstX1 - dstX0 | 0);
    var height_0 = min2_5(srcY1 - srcY0 | 0, dstY1 - dstY0 | 0);
    this.copyUnchecked_5(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  };
  Bitmap.prototype.copyUnchecked_5 = function (srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.readPixelsUnsafe_5(srcX, srcY + y | 0, width, 1, this._get_tempRgba__5(), 0);
        dst.writePixelsUnsafe_5(dstX, dstY + y | 0, width, 1, this._get_tempRgba__5(), 0);
      }
       while (inductionVariable < height);
  };
  Bitmap.prototype.inBoundsX_6 = function (x) {
    return x >= 0 ? x < this._width_2 : false;
  };
  Bitmap.prototype.inBoundsY_6 = function (y) {
    return y >= 0 ? y < this._height_2 : false;
  };
  Bitmap.prototype.inBounds_6 = function (x, y) {
    return this.inBoundsX_6(x) ? this.inBoundsY_6(y) : false;
  };
  Bitmap.prototype.clampX_0 = function (x) {
    return clamp_1(x, 0, this._width_2 - 1 | 0);
  };
  Bitmap.prototype.clampY_0 = function (y) {
    return clamp_1(y, 0, this._height_2 - 1 | 0);
  };
  Bitmap.prototype.clampWidth_5 = function (x) {
    return clamp_1(x, 0, this._width_2);
  };
  Bitmap.prototype.clampHeight_5 = function (y) {
    return clamp_1(y, 0, this._height_2);
  };
  Bitmap.prototype.flipY_1 = function () {
    var inductionVariable = 0;
    var last_1 = this._height_2 / 2 | 0;
    if (inductionVariable < last_1)
      do {
        var y_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.swapRows_6(y_3, (this._height_2 - y_3 | 0) - 1 | 0);
      }
       while (inductionVariable < last_1);
    return this;
  };
  Bitmap.prototype.swapRows_6 = function (y0, y1) {
    var inductionVariable = 0;
    var last_1 = this._width_2;
    if (inductionVariable < last_1)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.getInt_6(x, y0);
        var c1 = this.getInt_6(x, y1);
        this.setInt_6(x, y0, c1);
        this.setInt_6(x, y1, c0);
      }
       while (inductionVariable < last_1);
  };
  Bitmap.prototype.getContext2d_5 = function (antialiasing) {
    throw UnsupportedOperationException_init_$Create$_0('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  };
  Bitmap.prototype.createWithThisFormat_5 = function (width, height) {
    invalidOp('' + 'Unsupported createWithThisFormat (' + this + ')');
  };
  Bitmap.prototype.toBMP32_5 = function () {
    var tmp0_also_0 = Bitmap32_init_$Create$(this._width_2, this._height_2, null, this._premultiplied_0, 4, null);
    this.readPixelsUnsafe_5(0, 0, this._width_2, this._height_2, tmp0_also_0._data_39, 0);
    return tmp0_also_0;
  };
  Bitmap.prototype.toBMP32IfRequired_5 = function () {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      {
        tmp = this.toBMP32_5();
      }
    }
    return tmp;
  };
  Bitmap.$metadata$ = {
    simpleName: 'Bitmap',
    kind: 'class',
    interfaces: [Sizeable, Extra]
  };
  function extract_1(_this_, x, y, width, height) {
    var out = createWithThisFormatTyped(_this_, width, height);
    _this_.copy_19(x, y, out, 0, 0, width, height);
    return out;
  }
  function createWithThisFormatTyped(_this_, width, height) {
    var tmp = _this_.createWithThisFormat_5(width, height);
    return tmp instanceof Bitmap ? tmp : THROW_CCE();
  }
  function mipmaps(_this_, enable) {
    _this_._mipmaps = enable;
    return _this_;
  }
  function tempRgba$factory() {
    return getPropertyCallableRef('tempRgba', 1, KProperty1, function (receiver) {
      return new RgbaArray(receiver._get_tempRgba__5());
    }, null);
  }
  function _no_name_provided_$factory_175(this$0) {
    var i = new _no_name_provided__214(this$0);
    return function () {
      return new RgbaArray(i.invoke_359());
    };
  }
  function Bitmap32_init_$Init$(width, height, data, premultiplied, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      data = Companion_getInstance_105().invoke_379(imul(width, height));
    if (!(($mask0 & 8) === 0))
      premultiplied = false;
    Bitmap32.call($this, width, height, data, premultiplied);
    return $this;
  }
  function Bitmap32_init_$Create$(width, height, data, premultiplied, $mask0, $marker) {
    return Bitmap32_init_$Init$(width, height, data, premultiplied, $mask0, $marker, Object.create(Bitmap32.prototype));
  }
  function Bitmap32_init_$Init$_0(width, height, value, premultiplied, $this) {
    Bitmap32_init_$Init$(width, height, null, premultiplied, 4, null, $this);
    RgbaArray__fill$default_impl($this._data_39, value, 0, 0, 6, null);
    return $this;
  }
  function Bitmap32_init_$Create$_0(width, height, value, premultiplied) {
    return Bitmap32_init_$Init$_0(width, height, value, premultiplied, Object.create(Bitmap32.prototype));
  }
  function Companion_98() {
    Companion_instance_97 = this;
  }
  Companion_98.prototype.invoke_361 = function (width, height, premultiplied) {
    return Bitmap32_init_$Create$_0(width, height, Colors_getInstance()._TRANSPARENT_BLACK, premultiplied);
  };
  Companion_98.prototype.copyChannel = function (src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel._shift;
    var dstShift = dstChannel._shift;
    var dstClear = dstChannel._clearMask;
    var dstData = dst._data_39;
    var srcData = src._data_39;
    var inductionVariable = 0;
    var last_1 = dst._get_area__7();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = _RgbaArray___get_ints__impl_(srcData)[n] >>> srcShift & 255;
        RgbaArray__set_impl(dstData, n, _RGBA___init__impl_(_RgbaArray___get_ints__impl_(dstData)[n] & dstClear | c << dstShift));
      }
       while (inductionVariable < last_1);
  };
  Companion_98.prototype.copyChannel_0 = function (src, dst, dstChannel) {
    var destShift = imul(dstChannel._index_11, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last_1 = dst._get_area__7();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src._get_data__2()[n] & 255;
        RgbaArray__set_impl(dst._data_39, n, _RGBA___init__impl_(_RgbaArray___get_ints__impl_(dst._data_39)[n] & destClear | c << destShift));
      }
       while (inductionVariable < last_1);
  };
  Companion_98.prototype.copyChannel_1 = function (src, srcChannel, dst) {
    var shift = srcChannel._shift;
    var inductionVariable = 0;
    var last_1 = src._get_area__7();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst._get_data__2()[n] = toByte(_RgbaArray___get_ints__impl_(src._data_39)[n] >>> shift & 255);
      }
       while (inductionVariable < last_1);
  };
  Companion_98.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_97;
  function Companion_getInstance_97() {
    if (Companion_instance_97 == null)
      new Companion_98();
    return Companion_instance_97;
  }
  function Bitmap32(width, height, data, premultiplied) {
    Companion_getInstance_97();
    Bitmap.call(this, width, height, 32, premultiplied, new RgbaArray(data));
    this._data_39 = data;
    this._dataPremult = _RgbaPremultipliedArray___init__impl_(_RgbaArray___get_ints__impl_(this._data_39));
    if (_RgbaArray___get_size__impl_(this._data_39) < imul(width, height))
      throw RuntimeException_init_$Create$('' + 'Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + _RgbaArray___get_size__impl_(this._data_39) + '), area=' + imul(width, height));
    this._temp_1 = Companion_getInstance_105().invoke_379(max2_5(width, height));
    this._bounds = new RectangleInt(Companion_getInstance_84().invoke_312(0, 0, width, height));
  }
  Bitmap32.prototype.createWithThisFormat_5 = function (width, height) {
    return Bitmap32_init_$Create$(width, height, null, this._get_premultiplied__8(), 4, null);
  };
  Bitmap32.prototype.copyUnchecked_5 = function (srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return Bitmap.prototype.copyUnchecked_5.call(this, srcX, srcY, dst, dstX, dstY, width, height);
    else {
    }
    var src = this;
    var srcArray = src._data_39;
    var dstArray = dst._data_39;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy_4(_RgbaArray___get_ints__impl_(srcArray), src.index_7(srcX, srcY + y | 0), _RgbaArray___get_ints__impl_(dstArray), dst.index_7(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  };
  Bitmap32.prototype.set_19 = function (x, y, color_0) {
    return RgbaArray__set_impl(this._data_39, this.index_7(x, y), color_0);
  };
  Bitmap32.prototype.get_89 = function (x, y) {
    return RgbaArray__get_impl(this._data_39, this.index_7(x, y));
  };
  Bitmap32.prototype.setInt_6 = function (x, y, color_0) {
    return RgbaArray__set_impl(this._data_39, this.index_7(x, y), _RGBA___init__impl_(color_0));
  };
  Bitmap32.prototype.getInt_6 = function (x, y) {
    return _RgbaArray___get_ints__impl_(this._data_39)[this.index_7(x, y)];
  };
  Bitmap32.prototype.getRgba_5 = function (x, y) {
    return RgbaArray__get_impl(this._data_39, this.index_7(x, y));
  };
  Bitmap32.prototype.setRgba_5 = function (x, y, v) {
    return RgbaArray__set_impl(this._data_39, this.index_7(x, y), v);
  };
  Bitmap32.prototype._drawUnchecked = function (src, dx, dy, sleft, stop, sright, sbottom, mix_2) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var dstData = dst._data_39;
    var srcData = src._data_39;
    var dstDataPremult = dst._dataPremult;
    var srcDataPremult = src._dataPremult;
    var dstPremultiplied = this._get_premultiplied__8();
    var srcPremultiplied = src._get_premultiplied__8();
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.index_7(dx, dy + y | 0);
        var srcOffset = src.index_7(sleft, stop + y | 0);
        if (mix_2) {
          if (dstPremultiplied ? srcPremultiplied : false) {
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < width)
              do {
                var x = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                RgbaPremultipliedArray__set_impl(dstDataPremult, dstOffset + x | 0, mix(RgbaPremultipliedArray__get_impl(dstDataPremult, dstOffset + x | 0), RgbaPremultipliedArray__get_impl(srcDataPremult, srcOffset + x | 0)));
              }
               while (inductionVariable_0 < width);
          } else if (dstPremultiplied ? !srcPremultiplied : false) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                RgbaPremultipliedArray__set_impl(dstDataPremult, dstOffset + x_0 | 0, mix(RgbaPremultipliedArray__get_impl(dstDataPremult, dstOffset + x_0 | 0), _RGBA___get_premultiplied__impl_(RgbaArray__get_impl(srcData, srcOffset + x_0 | 0))));
              }
               while (inductionVariable_1 < width);
          } else if (!dstPremultiplied ? srcPremultiplied : false) {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                RgbaArray__set_impl(dstData, dstOffset + x_1 | 0, _RGBAPremultiplied___get_depremultiplied__impl_(mix(_RGBA___get_premultiplied__impl_(RgbaArray__get_impl(dstData, dstOffset + x_1 | 0)), RgbaPremultipliedArray__get_impl(srcDataPremult, srcOffset + x_1 | 0))));
              }
               while (inductionVariable_2 < width);
          } else if (!dstPremultiplied ? !srcPremultiplied : false) {
            var inductionVariable_3 = 0;
            if (inductionVariable_3 < width)
              do {
                var x_2 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                RgbaArray__set_impl(dstData, dstOffset + x_2 | 0, _RGBAPremultiplied___get_depremultiplied__impl_(mix(_RGBA___get_premultiplied__impl_(RgbaArray__get_impl(dstData, dstOffset + x_2 | 0)), _RGBA___get_premultiplied__impl_(RgbaArray__get_impl(srcData, srcOffset + x_2 | 0)))));
              }
               while (inductionVariable_3 < width);
          }} else {
          if (dstPremultiplied === srcPremultiplied)
            arraycopy_14(srcData, srcOffset, dstData, dstOffset, width);
          else if (dstPremultiplied ? !srcPremultiplied : false) {
            var inductionVariable_4 = 0;
            if (inductionVariable_4 < width)
              do {
                var x_3 = inductionVariable_4;
                inductionVariable_4 = inductionVariable_4 + 1 | 0;
                RgbaPremultipliedArray__set_impl(dstDataPremult, dstOffset + x_3 | 0, _RGBA___get_premultiplied__impl_(RgbaArray__get_impl(srcData, srcOffset + x_3 | 0)));
              }
               while (inductionVariable_4 < width);
          } else if (!dstPremultiplied ? srcPremultiplied : false) {
            var inductionVariable_5 = 0;
            if (inductionVariable_5 < width)
              do {
                var x_4 = inductionVariable_5;
                inductionVariable_5 = inductionVariable_5 + 1 | 0;
                RgbaArray__set_impl(dstData, dstOffset + x_4 | 0, _RGBAPremultiplied___get_depremultiplied__impl_(RgbaPremultipliedArray__get_impl(srcDataPremult, srcOffset + x_4 | 0)));
              }
               while (inductionVariable_5 < width);
          }}
      }
       while (inductionVariable < height);
  };
  Bitmap32.prototype._draw = function (src, dx, dy, sleft, stop, sright, sbottom, mix_2) {
    var sleft_0 = 0;
    var stop_0 = 0;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }var availableWidth = this._get_width__58() - dx_0 | 0;
    var availableHeight = this._get_height__58() - dy_0 | 0;
    var awidth = min2_5(availableWidth, sright - sleft_0 | 0);
    var aheight = min2_5(availableHeight, sbottom - stop_0 | 0);
    this._drawUnchecked(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix_2);
  };
  Bitmap32.prototype._drawPut = function (mix_2, other, _dx, _dy) {
    this._draw(other, _dx, _dy, 0, 0, other._get_width__58(), other._get_height__58(), mix_2);
  };
  Bitmap32.prototype.fill_0 = function (color_0, x, y, width, height) {
    var x1 = this.clampX_0(x);
    var x2 = this.clampX_0((x + width | 0) - 1 | 0);
    var y1 = this.clampY_0(y);
    var y2 = this.clampY_0((y + height | 0) - 1 | 0);
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaArray__fill_impl(this._data_39, color_0, this.index_7(x1, cy), this.index_7(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  };
  Bitmap32.prototype.fill$default = function (color_0, x, y, width, height, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      x = 0;
    if (!(($mask0 & 4) === 0))
      y = 0;
    if (!(($mask0 & 8) === 0))
      width = this._get_width__58() - x | 0;
    if (!(($mask0 & 16) === 0))
      height = this._get_height__58() - y | 0;
    return this.fill_0(color_0, x, y, width, height);
  };
  Bitmap32.prototype._draw_0 = function (src, dx, dy, mix_2) {
    var b = src._get_bounds__0();
    this._draw(src._bmp, dx, dy, _RectangleInt___get_left__impl_(b), _RectangleInt___get_top__impl_(b), _RectangleInt___get_right__impl_(b), _RectangleInt___get_bottom__impl_(b), mix_2);
  };
  Bitmap32.prototype.put_10 = function (src, dx, dy) {
    return this._drawPut(false, src, dx, dy);
  };
  Bitmap32.prototype.draw = function (src, dx, dy) {
    return this._drawPut(true, src, dx, dy);
  };
  Bitmap32.prototype.draw_0 = function (src, dx, dy) {
    return this._draw_0(src, dx, dy, true);
  };
  Bitmap32.prototype.writeChannel = function (destination, input, source) {
    return Companion_getInstance_97().copyChannel(input, source, this, destination);
  };
  Bitmap32.prototype.writeChannel_0 = function (destination, input) {
    return Companion_getInstance_97().copyChannel_0(input, this, destination);
  };
  Bitmap32.prototype.extractChannel = function (channel, out) {
    Companion_getInstance_97().copyChannel_1(this, channel, out);
    return out;
  };
  Bitmap32.prototype.extractChannel$default = function (channel, out, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      var tmp = this._get_width__58();
      var tmp_0 = this._get_height__58();
      out = Bitmap8_init_$Create$(tmp, tmp_0, null, null, 12, null);
    }return this.extractChannel(channel, out);
  };
  Bitmap32.prototype.toString = function () {
    return '' + 'Bitmap32(' + this._get_width__58() + ', ' + this._get_height__58() + ')';
  };
  Bitmap32.prototype.swapRows_6 = function (y0, y1) {
    var s0 = this.index_7(0, y0);
    var s1 = this.index_7(0, y1);
    arraycopy_14(this._data_39, s0, this._temp_1, 0, this._get_width__58());
    arraycopy_14(this._data_39, s1, this._data_39, s0, this._get_width__58());
    arraycopy_14(this._temp_1, 0, this._data_39, s1, this._get_width__58());
  };
  Bitmap32.prototype.writeDecoded = function (color_0, data, offset, littleEndian) {
    decode(color_0, data, offset, this._data_39, 0, this._get_area__7(), littleEndian);
    return this;
  };
  Bitmap32.prototype.writeDecoded$default = function (color_0, data, offset, littleEndian, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      offset = 0;
    if (!(($mask0 & 8) === 0))
      littleEndian = true;
    return this.writeDecoded(color_0, data, offset, littleEndian);
  };
  Bitmap32.prototype.clone_8 = function () {
    var tmp = this._get_width__58();
    var tmp_0 = this._get_height__58();
    var tmp0_copyOf_0 = _RgbaArray___get_ints__impl_(this._data_39);
    return new Bitmap32(tmp, tmp_0, _RgbaArray___init__impl_(tmp0_copyOf_0.slice()), this._get_premultiplied__8());
  };
  Bitmap32.prototype.getContext2d_5 = function (antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  };
  Bitmap32.prototype.premultipliedIfRequired = function () {
    return this._get_premultiplied__8() ? this : this.copyPremultiplied();
  };
  Bitmap32.prototype.depremultipliedIfRequired = function () {
    return !this._get_premultiplied__8() ? this : this.depremultiplied();
  };
  Bitmap32.prototype.copyPremultiplied = function () {
    var tmp0_apply_0 = this.clone_8();
    tmp0_apply_0.premultiplyInplaceIfRequired();
    return tmp0_apply_0;
  };
  Bitmap32.prototype.depremultiplied = function () {
    var tmp0_apply_0 = this.clone_8();
    tmp0_apply_0.depremultiplyInplace();
    return tmp0_apply_0;
  };
  Bitmap32.prototype.premultiplyInplaceIfRequired = function () {
    if (this._get_premultiplied__8())
      return Unit_getInstance();
    this._set_premultiplied__1(true);
    var tmp0_updateColors_0 = 0;
    var tmp1_updateColors_0 = 0;
    var tmp2_updateColors_0 = this._get_width__58() - tmp0_updateColors_0 | 0;
    var tmp3_updateColors_0 = this._get_height__58() - tmp1_updateColors_0 | 0;
    var inductionVariable = tmp1_updateColors_0;
    var last_1 = tmp1_updateColors_0 + tmp3_updateColors_0 | 0;
    if (inductionVariable < last_1)
      do {
        var y_2_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n_3_3 = this.index_7(tmp0_updateColors_0, tmp1_updateColors_0 + y_2_2 | 0);
        var inductionVariable_0 = tmp0_updateColors_0;
        var last_2 = tmp0_updateColors_0 + tmp2_updateColors_0 | 0;
        if (inductionVariable_0 < last_2)
          do {
            var x_5_5 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2_6_7 = n_3_3;
            n_3_3 = tmp2_6_7 + 1 | 0;
            var tmp0__anonymous__7_6 = tmp2_6_7;
            var tmp4__anonymous__8 = RgbaArray__get_impl(this._data_39, tmp0__anonymous__7_6);
            RgbaArray__set_impl(this._data_39, tmp0__anonymous__7_6, asNonPremultiplied(_RGBA___get_premultiplied__impl_(tmp4__anonymous__8)));
          }
           while (inductionVariable_0 < last_2);
      }
       while (inductionVariable < last_1);
  };
  Bitmap32.prototype.depremultiplyInplace = function () {
    if (!this._get_premultiplied__8())
      return Unit_getInstance();
    this._set_premultiplied__1(false);
    var tmp0_updateColors_0 = 0;
    var tmp1_updateColors_0 = 0;
    var tmp2_updateColors_0 = this._get_width__58() - tmp0_updateColors_0 | 0;
    var tmp3_updateColors_0 = this._get_height__58() - tmp1_updateColors_0 | 0;
    var inductionVariable = tmp1_updateColors_0;
    var last_1 = tmp1_updateColors_0 + tmp3_updateColors_0 | 0;
    if (inductionVariable < last_1)
      do {
        var y_2_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n_3_3 = this.index_7(tmp0_updateColors_0, tmp1_updateColors_0 + y_2_2 | 0);
        var inductionVariable_0 = tmp0_updateColors_0;
        var last_2 = tmp0_updateColors_0 + tmp2_updateColors_0 | 0;
        if (inductionVariable_0 < last_2)
          do {
            var x_5_5 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2_6_7 = n_3_3;
            n_3_3 = tmp2_6_7 + 1 | 0;
            var tmp0__anonymous__7_6 = tmp2_6_7;
            var tmp4__anonymous__8 = RgbaArray__get_impl(this._data_39, tmp0__anonymous__7_6);
            RgbaArray__set_impl(this._data_39, tmp0__anonymous__7_6, _RGBAPremultiplied___get_depremultiplied__impl_(asPremultiplied(tmp4__anonymous__8)));
          }
           while (inductionVariable_0 < last_2);
      }
       while (inductionVariable < last_1);
  };
  Bitmap32.prototype.iterator_67 = function () {
    return RgbaArray__iterator_impl(this._data_39);
  };
  Bitmap32.prototype.setRowChunk = function (x, y, data, width, increment_0) {
    if (increment_0 === 1) {
      arraycopy_14(data, 0, this._data_39, this.index_7(x, y), width);
    } else {
      var m = this.index_7(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          _RgbaArray___get_ints__impl_(this._data_39)[m] = _RgbaArray___get_ints__impl_(data)[n];
          m = m + increment_0 | 0;
        }
         while (inductionVariable < width);
    }
  };
  Bitmap32.prototype.toBMP32_5 = function () {
    return this;
  };
  Bitmap32.$metadata$ = {
    simpleName: 'Bitmap32',
    kind: 'class',
    interfaces: [Iterable]
  };
  function Bitmap8_init_$Init$(width, height, data, palette, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      data = new Int8Array(imul(width, height));
    if (!(($mask0 & 8) === 0))
      palette = Companion_getInstance_105().invoke_379(256);
    Bitmap8.call($this, width, height, data, palette);
    return $this;
  }
  function Bitmap8_init_$Create$(width, height, data, palette, $mask0, $marker) {
    return Bitmap8_init_$Init$(width, height, data, palette, $mask0, $marker, Object.create(Bitmap8.prototype));
  }
  function Companion_99() {
    Companion_instance_98 = this;
  }
  Companion_99.prototype.copyRect = function (src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.copy_19(srcX, srcY, dst, dstX, dstY, width, height);
  };
  Companion_99.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_98;
  function Companion_getInstance_98() {
    if (Companion_instance_98 == null)
      new Companion_99();
    return Companion_instance_98;
  }
  function Bitmap8(width, height, data, palette) {
    Companion_getInstance_98();
    BitmapIndexed.call(this, 8, width, height, data, palette);
  }
  Bitmap8.prototype.createWithThisFormat_5 = function (width, height) {
    return Bitmap8_init_$Create$(width, height, null, this._get_palette__0(), 4, null);
  };
  Bitmap8.prototype.setInt_6 = function (x, y, color_0) {
    return this.setIntIndex_0(this.index_7(x, y), color_0);
  };
  Bitmap8.prototype.getInt_6 = function (x, y) {
    return UByteArrayInt__get_impl(this._get_datau__0(), this.index_7(x, y));
  };
  Bitmap8.prototype.getRgba_5 = function (x, y) {
    var tmp = this._get_palette__0();
    return RgbaArray__get_impl(tmp, this.getInt_6(x, y));
  };
  Bitmap8.prototype.getIntIndex_0 = function (n) {
    return UByteArrayInt__get_impl(this._get_datau__0(), n);
  };
  Bitmap8.prototype.setIntIndex_0 = function (n, color_0) {
    return UByteArrayInt__set_impl(this._get_datau__0(), n, color_0);
  };
  Bitmap8.prototype.copyUnchecked_5 = function (srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return BitmapIndexed.prototype.copyUnchecked_5.call(this, srcX, srcY, dst, dstX, dstY, width, height);
    else {
    }
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this._get_data__2();
        var tmp_0 = this.index_7(srcX, srcY + y | 0);
        arraycopy_2(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE())._get_data__2(), dst.index_7(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  };
  Bitmap8.prototype.toString = function () {
    return '' + 'Bitmap8(' + this._get_width__58() + ', ' + this._get_height__58() + ', palette=' + _RgbaArray___get_size__impl_(this._get_palette__0()) + ')';
  };
  Bitmap8.$metadata$ = {
    simpleName: 'Bitmap8',
    kind: 'class',
    interfaces: []
  };
  var BitmapChannel_RED_instance;
  var BitmapChannel_GREEN_instance;
  var BitmapChannel_BLUE_instance;
  var BitmapChannel_ALPHA_instance;
  function Companion_100() {
    Companion_instance_99 = this;
    this._ALL = values_4();
  }
  Companion_100.prototype.get_137 = function (index) {
    return this._ALL[index];
  };
  Companion_100.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_99;
  function Companion_getInstance_99() {
    if (Companion_instance_99 == null)
      new Companion_100();
    return Companion_instance_99;
  }
  function values_4() {
    return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
  }
  var BitmapChannel_entriesInitialized;
  function BitmapChannel_initEntries() {
    if (BitmapChannel_entriesInitialized)
      return Unit_getInstance();
    BitmapChannel_entriesInitialized = true;
    BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
    BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
    BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
    BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
    Companion_getInstance_99();
  }
  function BitmapChannel(name, ordinal, index) {
    Enum.call(this, name, ordinal);
    this._index_11 = index;
    this._shift = imul(this._index_11, 8);
    this._setMask = 255 << this._shift;
    this._clearMask = ~this._setMask;
  }
  BitmapChannel.$metadata$ = {
    simpleName: 'BitmapChannel',
    kind: 'class',
    interfaces: []
  };
  function BitmapChannel_RED_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_RED_instance;
  }
  function BitmapChannel_GREEN_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_GREEN_instance;
  }
  function BitmapChannel_BLUE_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_BLUE_instance;
  }
  function BitmapChannel_ALPHA_getInstance() {
    BitmapChannel_initEntries();
    return BitmapChannel_ALPHA_instance;
  }
  function BitmapIndexed(bpp, width, height, data, palette) {
    Bitmap.call(this, width, height, bpp, false, data);
    this._data_40 = data;
    this._palette = palette;
    if (this._data_40.length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException_init_$Create$('' + 'Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + this._data_40.length + '), area=' + imul(width, height));
    this._temp_2 = new Int8Array(max2_5(width, height));
    this._datau = _UByteArrayInt___init__impl_(this._data_40);
    this._n8_dbpp = 8 / bpp | 0;
    this._n8_dbppLog2 = ilog2_0(this._n8_dbpp);
    this._n8_dbppMask = this._n8_dbpp - 1 | 0;
  }
  BitmapIndexed.prototype._get_data__2 = function () {
    return this._data_40;
  };
  BitmapIndexed.prototype._get_palette__0 = function () {
    return this._palette;
  };
  BitmapIndexed.prototype.toString = function () {
    return '' + 'BitmapIndexed(bpp=' + this._get_bpp__10() + ', width=' + this._get_width__58() + ', height=' + this._get_height__58() + ', clut=' + _RgbaArray___get_size__impl_(this._palette) + ')';
  };
  BitmapIndexed.prototype._get_datau__0 = function () {
    return this._datau;
  };
  BitmapIndexed.prototype.getInt_6 = function (x, y) {
    return this.getIntIndex_0(this.index_7(x, y));
  };
  BitmapIndexed.prototype.setInt_6 = function (x, y, color_0) {
    return this.setIntIndex_0(this.index_7(x, y), color_0);
  };
  BitmapIndexed.prototype.getIntIndex_0 = function (n) {
    var iD = this.index_d_2(n);
    var iM = this.index_m_0(n);
    return extract(UByteArrayInt__get_impl(this._datau, iD), imul(this._get_bpp__10(), iM), this._get_bpp__10());
  };
  BitmapIndexed.prototype.setIntIndex_0 = function (n, color_0) {
    var iD = this.index_d_2(n);
    var iM = this.index_m_0(n);
    UByteArrayInt__set_impl(this._datau, iD, insert(UByteArrayInt__get_impl(this._datau, iD), color_0, imul(this._get_bpp__10(), iM), this._get_bpp__10()));
  };
  BitmapIndexed.prototype.getRgba_5 = function (x, y) {
    var tmp = this._palette;
    return RgbaArray__get_impl(tmp, this.getInt_6(x, y));
  };
  BitmapIndexed.prototype.index_d_1 = function (x, y) {
    return this.index_d_2(this.index_7(x, y));
  };
  BitmapIndexed.prototype.index_d_2 = function (n) {
    return n >>> this._n8_dbppLog2;
  };
  BitmapIndexed.prototype.index_m_0 = function (n) {
    return n & this._n8_dbppMask;
  };
  BitmapIndexed.prototype.setRow_0 = function (y, row) {
    arraycopy_2(row, 0, this._data_40, this.index_7(0, y), this._get_stride__1());
  };
  BitmapIndexed.prototype.swapRows_6 = function (y0, y1) {
    var s0 = this.index_d_1(0, y0);
    var s1 = this.index_d_1(0, y1);
    arraycopy_2(this._data_40, s0, this._temp_2, 0, this._get_stride__1());
    arraycopy_2(this._data_40, s1, this._data_40, s0, this._get_stride__1());
    arraycopy_2(this._temp_2, 0, this._data_40, s1, this._get_stride__1());
  };
  BitmapIndexed.prototype.setRowChunk_1 = function (x, y, data, width, increment_0) {
    if (increment_0 === 1) {
      arraycopy_2(data, 0, this._data_40, this.index_7(x, y), width / this._n8_dbpp | 0);
    } else {
      var m = this.index_7(x, y);
      var inductionVariable = 0;
      var last_1 = width / this._n8_dbpp | 0;
      if (inductionVariable < last_1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this._data_40[m] = data[n];
          m = m + increment_0 | 0;
        }
         while (inductionVariable < last_1);
    }
  };
  BitmapIndexed.prototype.toBMP32_5 = function () {
    var tmp = this._get_width__58();
    var tmp_0 = this._get_height__58();
    var tmp0_also_0 = Bitmap32_init_$Create$(tmp, tmp_0, null, this._get_premultiplied__8(), 4, null);
    var out_2 = _RgbaArray___get_ints__impl_(tmp0_also_0._data_39);
    var pal_3 = _RgbaArray___get_ints__impl_(this._palette);
    var inductionVariable = 0;
    var last_1 = this._get_area__7();
    if (inductionVariable < last_1)
      do {
        var n_5 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out_2[n_5] = pal_3[this.getIntIndex_0(n_5)];
      }
       while (inductionVariable < last_1);
    return tmp0_also_0;
  };
  BitmapIndexed.$metadata$ = {
    simpleName: 'BitmapIndexed',
    kind: 'class',
    interfaces: []
  };
  function BitmapSlice_init_$Init$(bmp, bounds, name, rotated, virtFrame, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      name = null;
    if (!(($mask0 & 8) === 0))
      rotated = false;
    if (!(($mask0 & 16) === 0))
      virtFrame = null;
    BitmapSlice.call($this, bmp, bounds, name, rotated, virtFrame);
    return $this;
  }
  function BitmapSlice_init_$Create$(bmp, bounds, name, rotated, virtFrame, $mask0, $marker) {
    return BitmapSlice_init_$Init$(bmp, bounds, name, rotated, virtFrame, $mask0, $marker, Object.create(BitmapSlice.prototype));
  }
  function BitmapSlice(bmp, bounds, name, rotated, virtFrame) {
    BmpSlice.call(this, bmp, bounds, name, rotated, virtFrame);
    this._bmp = bmp;
    var tmp = this;
    tmp._$$delegate_0_7 = Mixin_init_$Create$(null, 1, null);
  }
  BitmapSlice.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_7._extra = _set___;
  };
  BitmapSlice.prototype._get_extra__71 = function () {
    return this._$$delegate_0_7._extra;
  };
  BitmapSlice.prototype.extract = function () {
    return extract_1(this._bmp, _RectangleInt___get_x__impl_(this._get_bounds__0()), _RectangleInt___get_y__impl_(this._get_bounds__0()), _RectangleInt___get_width__impl_(this._get_bounds__0()), _RectangleInt___get_height__impl_(this._get_bounds__0()));
  };
  BitmapSlice.prototype.sliceWithBounds = function (left, top, right, bottom, name) {
    var tmp = _RectangleInt___get_left__impl_(this._get_bounds__0());
    var tmp_0 = _RectangleInt___get_top__impl_(this._get_bounds__0());
    var tmp_1 = _RectangleInt___get_right__impl_(this._get_bounds__0());
    var tmp_2 = _RectangleInt___get_bottom__impl_(this._get_bounds__0());
    var tmp_3 = createRectangleInt$default(tmp, tmp_0, tmp_1, tmp_2, left, top, right, bottom, false, 256, null);
    return BitmapSlice_init_$Create$(this._bmp, tmp_3, name, false, null, 24, null);
  };
  BitmapSlice.prototype.sliceWithSize_0 = function (x, y, width, height, name) {
    return this.sliceWithBounds(x, y, x + width | 0, y + height | 0, name);
  };
  BitmapSlice.prototype.sliceWithSize$default = function (x, y, width, height, name, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      name = null;
    return this.sliceWithSize_0(x, y, width, height, name);
  };
  BitmapSlice.prototype.slice_1 = function (rect_1, name) {
    return this.sliceWithBounds(_RectangleInt___get_left__impl_(rect_1), _RectangleInt___get_top__impl_(rect_1), _RectangleInt___get_right__impl_(rect_1), _RectangleInt___get_bottom__impl_(rect_1), name);
  };
  BitmapSlice.prototype.slice$default = function (rect_1, name, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      name = null;
    return this.slice_1(rect_1, name);
  };
  BitmapSlice.prototype.toString = function () {
    return '' + 'BitmapSlice(' + this._get_name__50() + ':' + new SizeInt(Companion_getInstance_87().invoke_325(_RectangleInt___get_width__impl_(this._get_bounds__0()), _RectangleInt___get_height__impl_(this._get_bounds__0()))) + ')';
  };
  BitmapSlice.$metadata$ = {
    simpleName: 'BitmapSlice',
    kind: 'class',
    interfaces: [Extra]
  };
  function BmpSlice(bmpBase, bounds, name, rotated, virtFrame) {
    this._bmpBase = bmpBase;
    this._bounds_0 = bounds;
    this._name_17 = name;
    this._rotated = rotated;
    this._virtFrame = virtFrame;
    this._bmp_0 = this._bmpBase;
    this._bmpWidth = this._bmpBase._width_2;
    this._bmpHeight = this._bmpBase._width_2;
    this._tl = Point_init_$Create$(this._get_left__4() / this._bmpBase._width_2, this._get_top__4() / this._bmpBase._height_2);
    this._br = Point_init_$Create$(this._get_right__2() / this._bmpBase._width_2, this._get_bottom__2() / this._bmpBase._height_2);
    this._tr = new Point(this._br._x_2, this._tl._y_2);
    this._bl = new Point(this._tl._x_2, this._br._y_2);
    var tmp = this;
    var tmp0_arrayOf_0 = [this._tl, this._tr, this._br, this._bl];
    tmp._points_0 = tmp0_arrayOf_0;
    this._offset_19 = this._rotated ? 1 : 0;
    this._p0 = getCyclic(this._points_0, this._offset_19 + 0 | 0);
    this._p1 = getCyclic(this._points_0, this._offset_19 + 1 | 0);
    this._p2 = getCyclic(this._points_0, this._offset_19 + 2 | 0);
    this._p3 = getCyclic(this._points_0, this._offset_19 + 3 | 0);
    var tmp_0 = this;
    var tmp_1 = this._virtFrame;
    tmp_0._trimmed = !((tmp_1 == null ? null : new RectangleInt(tmp_1)) == null);
    var tmp_2 = this;
    var tmp0_safe_receiver = this._virtFrame;
    var tmp_3;
    var tmp_4 = tmp0_safe_receiver;
    if ((tmp_4 == null ? null : new RectangleInt(tmp_4)) == null) {
      tmp_3 = null;
    } else {
      {
        tmp_3 = _RectangleInt___get_x__impl_(tmp0_safe_receiver);
      }
    }
    var tmp1_elvis_lhs = tmp_3;
    tmp_2._frameOffsetX = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp_5 = this;
    var tmp0_safe_receiver_0 = this._virtFrame;
    var tmp_6;
    var tmp_7 = tmp0_safe_receiver_0;
    if ((tmp_7 == null ? null : new RectangleInt(tmp_7)) == null) {
      tmp_6 = null;
    } else {
      {
        tmp_6 = _RectangleInt___get_y__impl_(tmp0_safe_receiver_0);
      }
    }
    var tmp1_elvis_lhs_0 = tmp_6;
    tmp_5._frameOffsetY = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
    var tmp_8 = this;
    var tmp0_safe_receiver_1 = this._virtFrame;
    var tmp_9;
    var tmp_10 = tmp0_safe_receiver_1;
    if ((tmp_10 == null ? null : new RectangleInt(tmp_10)) == null) {
      tmp_9 = null;
    } else {
      {
        tmp_9 = _RectangleInt___get_width__impl_(tmp0_safe_receiver_1);
      }
    }
    var tmp1_elvis_lhs_1 = tmp_9;
    tmp_8._frameWidth = tmp1_elvis_lhs_1 == null ? _RectangleInt___get_width__impl_(this._bounds_0) : tmp1_elvis_lhs_1;
    var tmp_11 = this;
    var tmp0_safe_receiver_2 = this._virtFrame;
    var tmp_12;
    var tmp_13 = tmp0_safe_receiver_2;
    if ((tmp_13 == null ? null : new RectangleInt(tmp_13)) == null) {
      tmp_12 = null;
    } else {
      {
        tmp_12 = _RectangleInt___get_height__impl_(tmp0_safe_receiver_2);
      }
    }
    var tmp1_elvis_lhs_2 = tmp_12;
    tmp_11._frameHeight = tmp1_elvis_lhs_2 == null ? _RectangleInt___get_height__impl_(this._bounds_0) : tmp1_elvis_lhs_2;
    this._parent_3 = null;
    this._tl_x = this._p0._x_2;
    this._tl_y = this._p0._y_2;
    this._tr_x = this._p1._x_2;
    this._tr_y = this._p1._y_2;
    this._br_x = this._p2._x_2;
    this._br_y = this._p2._y_2;
    this._bl_x = this._p3._x_2;
    this._bl_y = this._p3._y_2;
    this._rotatedAngle = 0;
  }
  BmpSlice.prototype._get_bmpBase__0 = function () {
    return this._bmpBase;
  };
  BmpSlice.prototype._get_bounds__0 = function () {
    return this._bounds_0;
  };
  BmpSlice.prototype._get_name__50 = function () {
    return this._name_17;
  };
  BmpSlice.prototype.getOrNull_4 = function () {
    return this;
  };
  BmpSlice.prototype._get_left__4 = function () {
    return _RectangleInt___get_left__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_top__4 = function () {
    return _RectangleInt___get_top__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_width__58 = function () {
    return _RectangleInt___get_width__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_height__58 = function () {
    return _RectangleInt___get_height__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_right__2 = function () {
    return _RectangleInt___get_right__impl_(this._bounds_0);
  };
  BmpSlice.prototype._get_bottom__2 = function () {
    return _RectangleInt___get_bottom__impl_(this._bounds_0);
  };
  BmpSlice.$metadata$ = {
    simpleName: 'BmpSlice',
    kind: 'class',
    interfaces: [Extra, Resourceable]
  };
  function createRectangleInt(bleft, btop, bright, bbottom, left, top, right, bottom, allowInvalidBounds) {
    return Companion_getInstance_84().fromBounds_0(clamp_1(bleft + left | 0, bleft, bright), clamp_1(btop + top | 0, btop, bbottom), clamp_1(bleft + right | 0, allowInvalidBounds ? bleft : bleft + left | 0, bright), clamp_1(btop + bottom | 0, allowInvalidBounds ? btop : btop + top | 0, bbottom));
  }
  function createRectangleInt$default(bleft, btop, bright, bbottom, left, top, right, bottom, allowInvalidBounds, $mask0, $handler) {
    if (!(($mask0 & 256) === 0))
      allowInvalidBounds = false;
    return createRectangleInt(bleft, btop, bright, bbottom, left, top, right, bottom, allowInvalidBounds);
  }
  function slice(_this_, bounds, name) {
    return BitmapSlice_init_$Create$(_this_, bounds, name, false, null, 24, null);
  }
  function slice$default(_this_, bounds, name, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      bounds = Companion_getInstance_84().invoke_312(0, 0, _this_._width_2, _this_._height_2);
    if (!(($mask0 & 2) === 0))
      name = null;
    return slice(_this_, bounds, name);
  }
  function sliceWithSize_1(_this_, x, y, width, height, name) {
    return sliceWithBounds_1(_this_, x, y, x + width | 0, y + height | 0, name);
  }
  function sliceWithSize$default_0(_this_, x, y, width, height, name, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      name = null;
    return sliceWithSize_1(_this_, x, y, width, height, name);
  }
  function sliceWithBounds_1(_this_, left, top, right, bottom, name) {
    return slice(_this_, createRectangleInt$default(0, 0, _this_._width_2, _this_._height_2, left, top, right, bottom, false, 256, null), name);
  }
  function Bitmaps() {
    Bitmaps_instance = this;
    var tmp = this;
    var tmp_0 = Bitmap32_init_$Create$(1, 1, null, false, 12, null);
    tmp._transparent = slice$default(tmp_0, null, 'transparent', 1, null);
    var tmp_1 = this;
    var tmp1_invoke_0 = Companion_getInstance_105();
    var tmp2_invoke_0 = 1;
    var tmp0_apply_0 = _RgbaArray___init__impl_(new Int32Array(tmp2_invoke_0));
    var inductionVariable = 0;
    if (inductionVariable < tmp2_invoke_0)
      do {
        var n_3_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaArray__set_impl(tmp0_apply_0, n_3_3, Colors_getInstance()._WHITE);
      }
       while (inductionVariable < tmp2_invoke_0);
    var tmp_2 = Bitmap32_init_$Create$(1, 1, tmp0_apply_0, false, 8, null);
    tmp_1._white = slice$default(tmp_2, null, 'white', 1, null);
  }
  Bitmaps.$metadata$ = {
    simpleName: 'Bitmaps',
    kind: 'object',
    interfaces: []
  };
  var Bitmaps_instance;
  function Bitmaps_getInstance() {
    if (Bitmaps_instance == null)
      new Bitmaps();
    return Bitmaps_instance;
  }
  function DistanceBitmap_init_$Init$(width, height, d, px, py, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      d = new Float32Array(imul(width, height));
    if (!(($mask0 & 8) === 0))
      px = new Int32Array(imul(width, height));
    if (!(($mask0 & 16) === 0))
      py = new Int32Array(imul(width, height));
    DistanceBitmap.call($this, width, height, d, px, py);
    return $this;
  }
  function DistanceBitmap_init_$Create$(width, height, d, px, py, $mask0, $marker) {
    return DistanceBitmap_init_$Init$(width, height, d, px, py, $mask0, $marker, Object.create(DistanceBitmap.prototype));
  }
  function Companion_101() {
    Companion_instance_100 = this;
    this._d1 = 1.0;
    this._d2 = 1.4142135;
  }
  Companion_101.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_100;
  function Companion_getInstance_100() {
    if (Companion_instance_100 == null)
      new Companion_101();
    return Companion_instance_100;
  }
  function setFromBitmap$getAlpha(_this_, x, y, min) {
    return _this_.inBounds_6(x, y) ? _RGBA___get_a__impl_(_this_.getRgba_5(x, y)) >= min : false;
  }
  function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
    if (this$0.getDist(x + dx | 0, y + dy | 0) + d < this$0.getDist(x, y)) {
      this$0.setPosXYRel(x, y, x + dx | 0, y + dy | 0);
      var tmp0_hypot_0 = x - this$0.getPosX(x, y) | 0;
      var tmp1_hypot_0 = y - this$0.getPosY(x, y) | 0;
      this$0.setDist(x, y, Math.hypot(tmp0_hypot_0, tmp1_hypot_0));
    }}
  function DistanceBitmap(width, height, d, px, py) {
    Companion_getInstance_100();
    this._width_3 = width;
    this._height_3 = height;
    this._d_0 = d;
    this._px = px;
    this._py = py;
    this._area = imul(this._width_3, this._height_3);
    var tmp0_assert_0 = this._d_0.length >= this._area;
    if (!tmp0_assert_0)
      throw AssertionError_init_$Create$();
    var tmp1_assert_0 = this._px.length >= this._area;
    if (!tmp1_assert_0)
      throw AssertionError_init_$Create$();
    var tmp2_assert_0 = this._py.length >= this._area;
    if (!tmp2_assert_0)
      throw AssertionError_init_$Create$();
  }
  DistanceBitmap.prototype.inBoundsX_6 = function (x) {
    return x >= 0 ? x < this._width_3 : false;
  };
  DistanceBitmap.prototype.inBoundsY_6 = function (y) {
    return y >= 0 ? y < this._height_3 : false;
  };
  DistanceBitmap.prototype.inBounds_6 = function (x, y) {
    return this.inBoundsX_6(x) ? this.inBoundsY_6(y) : false;
  };
  DistanceBitmap.prototype.index_7 = function (x, y) {
    return imul(y, this._width_3) + x | 0;
  };
  DistanceBitmap.prototype.getDist = function (x, y) {
    return this.inBounds_6(x, y) ? this._d_0[this.index_7(x, y)] : Infinity;
  };
  DistanceBitmap.prototype.getPosX = function (x, y) {
    return this.inBounds_6(x, y) ? this._px[this.index_7(x, y)] : -1;
  };
  DistanceBitmap.prototype.getPosY = function (x, y) {
    return this.inBounds_6(x, y) ? this._py[this.index_7(x, y)] : -1;
  };
  DistanceBitmap.prototype.setDist = function (x, y, d) {
    if (!this.inBounds_6(x, y))
      return Unit_getInstance();
    this._d_0[this.index_7(x, y)] = d;
  };
  DistanceBitmap.prototype.setPosXY = function (x, y, px, py) {
    if (!this.inBounds_6(x, y))
      return Unit_getInstance();
    var index = this.index_7(x, y);
    this._px[index] = px;
    this._py[index] = py;
  };
  DistanceBitmap.prototype.setPosXYRel = function (x, y, px, py) {
    return this.setPosXY(x, y, this.getPosX(px, py), this.getPosY(px, py));
  };
  DistanceBitmap.prototype.setFromBitmap = function (bmp, thresold) {
    var tmp0_assert_0 = this._width_3 === bmp._width_2;
    if (!tmp0_assert_0)
      throw AssertionError_init_$Create$();
    var tmp1_assert_0 = this._height_3 === bmp._height_2;
    if (!tmp1_assert_0)
      throw AssertionError_init_$Create$();
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last_1 = this._height_3;
    if (inductionVariable < last_1)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_2 = this._width_3;
        if (inductionVariable_0 < last_2)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.setDist(x, y, Infinity);
            this.setPosXY(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_2);
      }
       while (inductionVariable < last_1);
    var inductionVariable_1 = 0;
    var last_3 = this._height_3;
    if (inductionVariable_1 < last_3)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_4 = this._width_3;
        if (inductionVariable_2 < last_4)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (((!(left === cur) ? true : !(right === cur)) ? true : !(up === cur)) ? true : !(down === cur)) {
              this.setDist(x_0, y_0, 0.0);
              this.setPosXY(x_0, y_0, x_0, y_0);
            }}
           while (inductionVariable_2 < last_4);
      }
       while (inductionVariable_1 < last_3);
    var inductionVariable_3 = 0;
    var last_5 = this._height_3;
    if (inductionVariable_3 < last_5)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_6 = this._width_3;
        if (inductionVariable_4 < last_6)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_6);
      }
       while (inductionVariable_3 < last_5);
    var inductionVariable_5 = this._height_3 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this._width_3 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this._height_3 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this._width_3 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.setDist(x_3, y_3, -this.getDist(x_3, y_3));
            }}
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  };
  DistanceBitmap.$metadata$ = {
    simpleName: 'DistanceBitmap',
    kind: 'class',
    interfaces: []
  };
  function distanceMap(_this_, out, thresold) {
    out.setFromBitmap(_this_, thresold);
    return out;
  }
  function distanceMap$default(_this_, out, thresold, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      out = DistanceBitmap_init_$Create$(_this_._width_2, _this_._height_2, null, null, null, 28, null);
    }if (!(($mask0 & 2) === 0))
      thresold = 0.5;
    return distanceMap(_this_, out, thresold);
  }
  function NativeImage(width, height, data, premultiplied) {
    Bitmap.call(this, width, height, 32, premultiplied, null);
    this._data_41 = data;
    this._name_18 = 'NativeImage';
  }
  NativeImage.prototype._get_forcedTexId__2 = function () {
    return -1;
  };
  NativeImage.prototype._get_forcedTexTarget__2 = function () {
    return -1;
  };
  NativeImage.prototype._get_name__50 = function () {
    return this._name_18;
  };
  NativeImage.prototype.toBMP32_5 = function () {
    var tmp0_also_0 = Bitmap32_init_$Create$_0(this._get_width__58(), this._get_height__58(), Colors_getInstance()._TRANSPARENT_BLACK, this._get_premultiplied__8());
    this.readPixelsUnsafe_5(0, 0, this._get_width__58(), this._get_height__58(), tmp0_also_0._data_39, 0);
    return tmp0_also_0;
  };
  NativeImage.prototype.setRgba_5 = function (x, y, v) {
    RgbaArray__set_impl(this._get_tempRgba__5(), 0, v);
    this.writePixelsUnsafe_5(x, y, 1, 1, this._get_tempRgba__5(), 0);
  };
  NativeImage.prototype.getRgba_5 = function (x, y) {
    this.readPixelsUnsafe_5(x, y, 1, 1, this._get_tempRgba__5(), 0);
    return RgbaArray__get_impl(this._get_tempRgba__5(), 0);
  };
  NativeImage.prototype.setInt_6 = function (x, y, color_0) {
    return this.setRgba_5(x, y, _RGBA___init__impl_(color_0));
  };
  NativeImage.prototype.getInt_6 = function (x, y) {
    return _RGBA___get_value__impl_(this.getRgba_5(x, y));
  };
  NativeImage.prototype.swapRows_6 = function (y0, y1) {
    this.readPixelsUnsafe_5(0, y0, this._get_width__58(), 1, this._get_tempRgba__5(), 0);
    this.readPixelsUnsafe_5(0, y1, this._get_width__58(), 1, this._get_tempRgba__5(), this._get_width__58());
    this.writePixelsUnsafe_5(0, y1, this._get_width__58(), 1, this._get_tempRgba__5(), 0);
    this.writePixelsUnsafe_5(0, y0, this._get_width__58(), 1, this._get_tempRgba__5(), this._get_width__58());
  };
  NativeImage.prototype.createWithThisFormat_5 = function (width, height) {
    return NativeImage$default(width, height, null, 4, null);
  };
  NativeImage.prototype.toString = function () {
    return '' + this._get_name__50() + '(' + this._get_width__58() + ', ' + this._get_height__58() + ')';
  };
  NativeImage.$metadata$ = {
    simpleName: 'NativeImage',
    kind: 'class',
    interfaces: []
  };
  function NativeImage_0(width, height, premultiplied) {
    return nativeImageFormatProvider.create_22(width, height, premultiplied);
  }
  function NativeImage$default(width, height, premultiplied, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      premultiplied = null;
    return NativeImage_0(width, height, premultiplied);
  }
  function ensureNative(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof NativeImage) {
      tmp = _this_;
    } else {
      {
        tmp = nativeImageFormatProvider.copy_18(_this_);
      }
    }
    return tmp;
  }
  function NativeImageOrBitmap32(width, height, native, premultiplied) {
    var tmp;
    if (native) {
      tmp = NativeImage_0(width, height, premultiplied);
    } else {
      var tmp0_elvis_lhs = premultiplied;
      tmp = Bitmap32_init_$Create$(width, height, null, tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs, 4, null);
    }
    return tmp;
  }
  function NativeImageOrBitmap32$default(width, height, native, premultiplied, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      native = true;
    if (!(($mask0 & 8) === 0))
      premultiplied = null;
    return NativeImageOrBitmap32(width, height, native, premultiplied);
  }
  function applyEffect(_this_, effect) {
    var safeBorder = _get_safeBorder_(effect);
    var out = Companion_getInstance_97().invoke_361(_this_._get_width__58() + imul(safeBorder, 2) | 0, _this_._get_height__58() + imul(safeBorder, 2) | 0, _this_._get_premultiplied__8());
    out.put_10(_this_, safeBorder, safeBorder);
    applyEffectInline(out, effect);
    return out;
  }
  function _get_safeBorder_(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_safeBorder___error();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  function applyEffectInline(_this_, effect) {
    if (effect == null)
      return Unit_getInstance();
    if (!(effect.blurRadius__error === 0)) {
      blurInplace(_this_, effect.blurRadius__error);
    }if ((!(effect.dropShadowRadius__error === 0) ? true : !(effect.dropShadowX__error === 0)) ? true : !(effect.dropShadowY__error === 0)) {
      dropShadowInplace(_this_, effect.dropShadowX__error, effect.dropShadowY__error, effect.dropShadowRadius__error, effect.dropShadowColor__error);
      Unit_getInstance();
    }if (!(effect.borderSize__error === 0)) {
      borderInline(_this_, effect.borderSize__error, effect.borderColor__error);
    }}
  function blurInplace(_this_, r) {
    var r_0 = coerceAtMost(coerceAtMost(r, (_this_._get_width__58() / 2 | 0) - 1 | 0), (_this_._get_height__58() / 2 | 0) - 1 | 0);
    var tmp = _this_._get_width__58();
    var tmp_0 = _this_._get_height__58();
    var t1 = Bitmap8_init_$Create$(tmp, tmp_0, null, null, 12, null);
    var tmp_1 = _this_._get_width__58();
    var tmp_2 = _this_._get_height__58();
    var t2 = Bitmap8_init_$Create$(tmp_1, tmp_2, null, null, 12, null);
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var channel = Companion_getInstance_99().get_137(n);
        _this_.extractChannel(channel, t1);
        Unit_getInstance();
        arraycopy_2(t1._get_data__2(), 0, t2._get_data__2(), 0, t2._get_area__7());
        gaussBlur(t1._get_data__2(), t2._get_data__2(), _this_._get_width__58(), _this_._get_height__58(), r_0);
        _this_.writeChannel_0(channel, t2);
      }
       while (inductionVariable < 4);
  }
  function gaussBlur(scl, tcl, w, h, r) {
    var a = 0;
    var b = 0;
    var c = 0;
    var n_1 = 3;
    var tmp0_sqrt_0 = 12.0 * r * r / n_1 + 1;
    var wIdeal_2 = Math.sqrt(tmp0_sqrt_0);
    var wl_3 = toIntFloor(wIdeal_2);
    if (wl_3 % 2 === 0) {
      var tmp0_4 = wl_3;
      wl_3 = tmp0_4 - 1 | 0;
      Unit_getInstance();
    }var wu_5 = wl_3 + 2 | 0;
    var mIdeal_6 = (12.0 * r * r - imul(imul(n_1, wl_3), wl_3) - imul(imul(4, n_1), wl_3) - imul(3, n_1)) / (imul(-4, wl_3) - 4 | 0);
    var m_7 = round(mIdeal_6);
    var tmp1__anonymous__8 = 0.0 < m_7 ? wl_3 : wu_5;
    var tmp2__anonymous__8 = 1.0 < m_7 ? wl_3 : wu_5;
    var tmp3__anonymous__8 = 2.0 < m_7 ? wl_3 : wu_5;
    a = tmp1__anonymous__8;
    b = tmp2__anonymous__8;
    c = tmp3__anonymous__8;
    boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
    boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
    boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
  }
  function boxBlur(scl, tcl, w, h, r) {
    arraycopy_2(scl, 0, tcl, 0, scl.length);
    boxBlurH(tcl, scl, w, h, r);
    boxBlurT(scl, tcl, w, h, r);
  }
  function boxBlurH(scl, tcl, w, h, r) {
    var arr = (r + r | 0) + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < h)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ti = imul(i, w);
        var li = ti;
        var ri = ti + r | 0;
        var fv = readU8(scl, ti);
        var lv = readU8(scl, (ti + w | 0) - 1 | 0);
        var v = imul(r + 1 | 0, fv);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < r)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            v = v + readU8(scl, ti + j | 0) | 0;
          }
           while (inductionVariable_0 < r);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= r)
          do {
            var j_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp = v;
            var tmp3 = ri;
            ri = tmp3 + 1 | 0;
            v = tmp + (readU8(scl, tmp3) - fv | 0) | 0;
            var tmp4 = ti;
            ti = tmp4 + 1 | 0;
            tcl[tmp4] = toByte(v / arr | 0);
          }
           while (!(j_0 === r));
        var inductionVariable_2 = r + 1 | 0;
        var last_1 = w - r | 0;
        if (inductionVariable_2 < last_1)
          do {
            var j_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var tmp_0 = v;
            var tmp7 = ri;
            ri = tmp7 + 1 | 0;
            var tmp_1 = readU8(scl, tmp7);
            var tmp6 = li;
            li = tmp6 + 1 | 0;
            v = tmp_0 + (tmp_1 - readU8(scl, tmp6) | 0) | 0;
            var tmp8 = ti;
            ti = tmp8 + 1 | 0;
            tcl[tmp8] = toByte(v / arr | 0);
          }
           while (inductionVariable_2 < last_1);
        var inductionVariable_3 = w - r | 0;
        if (inductionVariable_3 < w)
          do {
            var j_2 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var tmp_2 = v;
            var tmp10 = li;
            li = tmp10 + 1 | 0;
            v = tmp_2 + (lv - readU8(scl, tmp10) | 0) | 0;
            var tmp11 = ti;
            ti = tmp11 + 1 | 0;
            tcl[tmp11] = toByte(v / arr | 0);
          }
           while (inductionVariable_3 < w);
      }
       while (inductionVariable < h);
  }
  function boxBlurT(scl, tcl, w, h, r) {
    var arr = (r + r | 0) + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < w)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ti = i;
        var li = ti;
        var ri = ti + imul(r, w) | 0;
        var fv = readU8(scl, ti);
        var lv = readU8(scl, ti + imul(w, h - 1 | 0) | 0);
        var v = imul(r + 1 | 0, fv);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < r)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            v = v + readU8(scl, ti + imul(j, w) | 0) | 0;
          }
           while (inductionVariable_0 < r);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= r)
          do {
            var j_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            v = v + (readU8(scl, ri) - fv | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            ri = ri + w | 0;
            ti = ti + w | 0;
          }
           while (!(j_0 === r));
        var inductionVariable_2 = r + 1 | 0;
        var last_1 = h - r | 0;
        if (inductionVariable_2 < last_1)
          do {
            var j_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            v = v + (readU8(scl, ri) - readU8(scl, li) | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            li = li + w | 0;
            ri = ri + w | 0;
            ti = ti + w | 0;
          }
           while (inductionVariable_2 < last_1);
        var inductionVariable_3 = h - r | 0;
        if (inductionVariable_3 < h)
          do {
            var j_2 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            v = v + (lv - readU8(scl, li) | 0) | 0;
            tcl[ti] = toByte(v / arr | 0);
            li = li + w | 0;
            ti = ti + w | 0;
          }
           while (inductionVariable_3 < h);
      }
       while (inductionVariable < w);
  }
  function blur(_this_, r) {
    var tmp = _this_._get_width__58() + imul(r, 2) | 0;
    var tmp_0 = _this_._get_height__58() + imul(r, 2) | 0;
    var out = Bitmap8_init_$Create$(tmp, tmp_0, null, null, 12, null);
    Companion_getInstance_98().copyRect(_this_, 0, 0, out, r, r, _this_._get_width__58(), _this_._get_height__58());
    blurInplace_0(out, r);
    return out;
  }
  function blurInplace_0(_this_, r) {
    var r_0 = coerceAtMost(coerceAtMost(r, (_this_._get_width__58() / 2 | 0) - 1 | 0), (_this_._get_height__58() / 2 | 0) - 1 | 0);
    var tmp = _this_._get_width__58();
    var tmp_0 = _this_._get_height__58();
    var t2 = Bitmap8_init_$Create$(tmp, tmp_0, null, null, 12, null);
    arraycopy_2(_this_._get_data__2(), 0, t2._get_data__2(), 0, _this_._get_area__7());
    gaussBlur(t2._get_data__2(), _this_._get_data__2(), _this_._get_width__58(), _this_._get_height__58(), r_0);
  }
  function borderInline(_this_, r, color_0) {
    var out = _this_;
    var distance = distanceMap$default(out, null, 0.0, 3, null);
    var inductionVariable = 0;
    var last_1 = out._get_height__58();
    if (inductionVariable < last_1)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_2 = out._get_width__58();
        if (inductionVariable_0 < last_2)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var dist = distance.getDist(x, y);
            if (dist < (r + 1 | 0)) {
              var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
              var rcolor = alpha === 1.0 ? color_0 : RGBA__withAf_impl(color_0, _RGBA___get_af__impl_(color_0) * alpha);
              out.set_19(x, y, Companion_getInstance_104().mix(rcolor, out.get_89(x, y)));
            }}
           while (inductionVariable_0 < last_2);
      }
       while (inductionVariable < last_1);
  }
  function dropShadowInplace(_this_, x, y, r, color_0) {
    var copy_2 = _this_.clone_8();
    var pcolor_3 = _RGBA___get_premultiplied__impl_(color_0);
    var tmp = BitmapChannel_ALPHA_getInstance();
    var tmp0_also_0_5 = blur(_this_.extractChannel$default(tmp, null, 2, null), r);
    tmp0_also_0_5._set_premultiplied__1(true);
    var inductionVariable = 0;
    if (inductionVariable < 256)
      do {
        var n_3_7 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaArray__set_impl(tmp0_also_0_5._get_palette__0(), n_3_7, Companion_getInstance_104().invoke_375(imul(_RGBAPremultiplied___get_r__impl_(pcolor_3), n_3_7) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl_(pcolor_3), n_3_7) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl_(pcolor_3), n_3_7) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl_(pcolor_3), n_3_7) / 255 | 0));
      }
       while (inductionVariable < 256);
    var shadow_4 = tmp0_also_0_5.toBMP32_5();
    var tmp_0 = Colors_getInstance()._TRANSPARENT_BLACK;
    _this_.fill$default(tmp_0, 0, 0, 0, 0, 30, null);
    _this_.draw(shadow_4, x - r | 0, y - r | 0);
    _this_.draw(copy_2, 0, 0);
    return _this_;
  }
  function BGRA() {
    BGRA_instance = this;
    var tmp = this;
    tmp._$$delegate_0_8 = new Mixin_0(32, 16, 8, 8, 8, 0, 8, 24, 8);
  }
  BGRA.prototype.getA_7 = function (v) {
    return this._$$delegate_0_8.getA_7(v);
  };
  BGRA.prototype.getB_7 = function (v) {
    return this._$$delegate_0_8.getB_7(v);
  };
  BGRA.prototype.getG_7 = function (v) {
    return this._$$delegate_0_8.getG_7(v);
  };
  BGRA.prototype.getR_7 = function (v) {
    return this._$$delegate_0_8.getR_7(v);
  };
  BGRA.prototype.pack_8 = function (r, g, b, a) {
    return this._$$delegate_0_8.pack_8(r, g, b, a);
  };
  BGRA.prototype._get_bpp__10 = function () {
    return this._$$delegate_0_8._bpp_0;
  };
  BGRA.$metadata$ = {
    simpleName: 'BGRA',
    kind: 'object',
    interfaces: [ColorFormat]
  };
  var BGRA_instance;
  function BGRA_getInstance() {
    if (BGRA_instance == null)
      new BGRA();
    return BGRA_instance;
  }
  function Mixin_0(bpp, rOffset, rSize, gOffset, gSize, bOffset, bSize, aOffset, aSize) {
    this._bpp_0 = bpp;
    this._rOffset = rOffset;
    this._rSize = rSize;
    this._gOffset = gOffset;
    this._gSize = gSize;
    this._bOffset = bOffset;
    this._bSize = bSize;
    this._aOffset = aOffset;
    this._aSize = aSize;
  }
  Mixin_0.prototype._get_bpp__10 = function () {
    return this._bpp_0;
  };
  Mixin_0.prototype.getR_7 = function (v) {
    return extractScaledFF(v, this._rOffset, this._rSize);
  };
  Mixin_0.prototype.getG_7 = function (v) {
    return extractScaledFF(v, this._gOffset, this._gSize);
  };
  Mixin_0.prototype.getB_7 = function (v) {
    return extractScaledFF(v, this._bOffset, this._bSize);
  };
  Mixin_0.prototype.getA_7 = function (v) {
    return extractScaledFFDefault(v, this._aOffset, this._aSize, 255);
  };
  Mixin_0.prototype.pack_8 = function (r, g, b, a) {
    return insertScaledFF(insertScaledFF(insertScaledFF(insertScaledFF(0, r, this._rOffset, this._rSize), g, this._gOffset, this._gSize), b, this._bOffset, this._bSize), a, this._aOffset, this._aSize);
  };
  Mixin_0.$metadata$ = {
    simpleName: 'Mixin',
    kind: 'class',
    interfaces: [ColorFormat]
  };
  function ColorFormat() {
  }
  ColorFormat.$metadata$ = {
    simpleName: 'ColorFormat',
    kind: 'interface',
    interfaces: []
  };
  function decode(_this_, data, dataOffset, out, outOffset, size_1, littleEndian) {
    var tmp0_subject = _this_._get_bpp__10();
    var tmp;
    switch (tmp0_subject) {
      case 16:
        var tmp_0;
        if (littleEndian) {
          tmp_0 = _no_name_provided_$factory_176();
        } else {
          tmp_0 = _no_name_provided_$factory_177();
        }

        tmp = tmp_0;
        break;
      case 24:
        var tmp_1;
        if (littleEndian) {
          tmp_1 = _no_name_provided_$factory_178();
        } else {
          tmp_1 = _no_name_provided_$factory_179();
        }

        tmp = tmp_1;
        break;
      case 32:
        var tmp_2;
        if (littleEndian) {
          tmp_2 = _no_name_provided_$factory_180();
        } else {
          tmp_2 = _no_name_provided_$factory_181();
        }

        tmp = tmp_2;
        break;
      default:throw IllegalArgumentException_init_$Create$('' + 'Unsupported bpp ' + _this_._get_bpp__10());
    }
    var readFunc = tmp;
    var io_1 = dataOffset;
    var oo_2 = outOffset;
    var bytesPerPixel_3 = _get_bytesPerPixel_(_this_);
    var outdata_4 = out;
    var Bpp_5 = numberToInt(bytesPerPixel_3);
    var inductionVariable = 0;
    if (inductionVariable < size_1)
      do {
        var n_7 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c_8 = readFunc(data, io_1);
        io_1 = io_1 + Bpp_5 | 0;
        var tmp1_9 = oo_2;
        oo_2 = tmp1_9 + 1 | 0;
        RgbaArray__set_impl(outdata_4, tmp1_9, Companion_getInstance_104().invoke_375(_this_.getR_7(c_8), _this_.getG_7(c_8), _this_.getB_7(c_8), _this_.getA_7(c_8)));
      }
       while (inductionVariable < size_1);
  }
  function decode$default(_this_, data, dataOffset, out, outOffset, size_1, littleEndian, $mask0, $handler) {
    if (!(($mask0 & 32) === 0))
      littleEndian = true;
    return decode(_this_, data, dataOffset, out, outOffset, size_1, littleEndian);
  }
  function encode_0(_this_, colors, colorsOffset, size_1, littleEndian) {
    var out = new Int8Array(numberToInt(size_1 * _get_bytesPerPixel_(_this_)));
    encode_1(_this_, colors, colorsOffset, out, 0, size_1, littleEndian);
    return out;
  }
  function _get_bytesPerPixel_(_this_) {
    return _this_._get_bpp__10() / 8;
  }
  function encode_1(_this_, colors, colorsOffset, out, outOffset, size_1, littleEndian) {
    var io = colorsOffset;
    var oo = outOffset;
    var Bpp = numberToInt(_get_bytesPerPixel_(_this_));
    var inductionVariable = 0;
    if (inductionVariable < size_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1 = io;
        io = tmp1 + 1 | 0;
        var c = RgbaArray__get_impl(colors, tmp1);
        var ec = _this_.pack_8(_RGBA___get_r__impl_(c), _RGBA___get_g__impl_(c), _RGBA___get_b__impl_(c), _RGBA___get_a__impl_(c));
        var tmp2_subject = _this_._get_bpp__10();
        switch (tmp2_subject) {
          case 16:
            if (littleEndian)
              write16LE(out, oo, ec);
            else
              write16BE(out, oo, ec);
            break;
          case 24:
            if (littleEndian)
              write24LE(out, oo, ec);
            else
              write24BE(out, oo, ec);
            break;
          case 32:
            if (littleEndian)
              write32LE(out, oo, ec);
            else
              write32BE(out, oo, ec);
            break;
          default:throw IllegalArgumentException_init_$Create$('' + 'Unsupported bpp ' + _this_._get_bpp__10());
        }
        oo = oo + Bpp | 0;
      }
       while (inductionVariable < size_1);
  }
  function ColorFormat24() {
    this._bpp_1 = 24;
  }
  ColorFormat24.prototype._get_bpp__10 = function () {
    return this._bpp_1;
  };
  ColorFormat24.$metadata$ = {
    simpleName: 'ColorFormat24',
    kind: 'class',
    interfaces: [ColorFormat]
  };
  function ColorFormat32() {
    this._bpp_2 = 32;
  }
  ColorFormat32.prototype._get_bpp__10 = function () {
    return this._bpp_2;
  };
  ColorFormat32.$metadata$ = {
    simpleName: 'ColorFormat32',
    kind: 'class',
    interfaces: [ColorFormat]
  };
  function _no_name_provided__215() {
  }
  _no_name_provided__215.prototype.invoke_372 = function (p0, p1) {
    return readU16LE(p0, p1);
  };
  _no_name_provided__215.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_372(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__215.prototype._get_name__50 = function () {
    return 'readU16LE';
  };
  _no_name_provided__215.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__216() {
  }
  _no_name_provided__216.prototype.invoke_372 = function (p0, p1) {
    return readU16BE(p0, p1);
  };
  _no_name_provided__216.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_372(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__216.prototype._get_name__50 = function () {
    return 'readU16BE';
  };
  _no_name_provided__216.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__217() {
  }
  _no_name_provided__217.prototype.invoke_372 = function (p0, p1) {
    return readU24LE(p0, p1);
  };
  _no_name_provided__217.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_372(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__217.prototype._get_name__50 = function () {
    return 'readU24LE';
  };
  _no_name_provided__217.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__218() {
  }
  _no_name_provided__218.prototype.invoke_372 = function (p0, p1) {
    return readU24BE(p0, p1);
  };
  _no_name_provided__218.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_372(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__218.prototype._get_name__50 = function () {
    return 'readU24BE';
  };
  _no_name_provided__218.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__219() {
  }
  _no_name_provided__219.prototype.invoke_372 = function (p0, p1) {
    return readS32LE(p0, p1);
  };
  _no_name_provided__219.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_372(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__219.prototype._get_name__50 = function () {
    return 'readS32LE';
  };
  _no_name_provided__219.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__220() {
  }
  _no_name_provided__220.prototype.invoke_372 = function (p0, p1) {
    return readS32BE(p0, p1);
  };
  _no_name_provided__220.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_372(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__220.prototype._get_name__50 = function () {
    return 'readS32BE';
  };
  _no_name_provided__220.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_176() {
    var i = new _no_name_provided__215();
    var l = function (p1, p2) {
      return i.invoke_372(p1, p2);
    };
    l.callableName = i._get_name__50();
    return l;
  }
  function _no_name_provided_$factory_177() {
    var i = new _no_name_provided__216();
    var l = function (p1, p2) {
      return i.invoke_372(p1, p2);
    };
    l.callableName = i._get_name__50();
    return l;
  }
  function _no_name_provided_$factory_178() {
    var i = new _no_name_provided__217();
    var l = function (p1, p2) {
      return i.invoke_372(p1, p2);
    };
    l.callableName = i._get_name__50();
    return l;
  }
  function _no_name_provided_$factory_179() {
    var i = new _no_name_provided__218();
    var l = function (p1, p2) {
      return i.invoke_372(p1, p2);
    };
    l.callableName = i._get_name__50();
    return l;
  }
  function _no_name_provided_$factory_180() {
    var i = new _no_name_provided__219();
    var l = function (p1, p2) {
      return i.invoke_372(p1, p2);
    };
    l.callableName = i._get_name__50();
    return l;
  }
  function _no_name_provided_$factory_181() {
    var i = new _no_name_provided__220();
    var l = function (p1, p2) {
      return i.invoke_372(p1, p2);
    };
    l.callableName = i._get_name__50();
    return l;
  }
  function Companion_102() {
    Companion_instance_101 = this;
    var tmp = this;
    var tmp0_ColorTransform_0 = 1;
    var tmp1_ColorTransform_0 = 1;
    var tmp2_ColorTransform_0 = 1;
    var tmp3_ColorTransform_0 = 1;
    var tmp4_ColorTransform_0 = 0;
    var tmp5_ColorTransform_0 = 0;
    var tmp6_ColorTransform_0 = 0;
    var tmp7_ColorTransform_0 = 0;
    tmp._identity = new ColorTransform(numberToDouble(tmp0_ColorTransform_0), numberToDouble(tmp1_ColorTransform_0), numberToDouble(tmp2_ColorTransform_0), numberToDouble(tmp3_ColorTransform_0), numberToInt(tmp4_ColorTransform_0), numberToInt(tmp5_ColorTransform_0), numberToInt(tmp6_ColorTransform_0), numberToInt(tmp7_ColorTransform_0));
  }
  Companion_102.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_101;
  function Companion_getInstance_101() {
    if (Companion_instance_101 == null)
      new Companion_102();
    return Companion_instance_101;
  }
  function computeColors($this) {
    if ($this._dirty) {
      $this._dirty = false;
      $this.__colorMul = Companion_getInstance_104().float($this.__mR, $this.__mG, $this.__mB, $this.__mA);
      $this.__colorAdd = Companion_getInstance_102().invoke_374($this.__aR, $this.__aG, $this.__aB, $this.__aA);
    }return $this;
  }
  function ColorTransform(_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA) {
    Companion_getInstance_101();
    this.__mR = _mR;
    this.__mG = _mG;
    this.__mB = _mB;
    this.__mA = _mA;
    this.__aR = _aR;
    this.__aG = _aG;
    this.__aB = _aB;
    this.__aA = _aA;
    this._dirty = true;
    this.__colorMul = Colors_getInstance()._WHITE;
    this.__colorAdd = _ColorAdd___init__impl_(0);
  }
  ColorTransform.prototype._set_colorMul__13 = function (v) {
    var mR = _RGBA___get_rd__impl_(v);
    var mG = _RGBA___get_gd__impl_(v);
    var mB = _RGBA___get_bd__impl_(v);
    var mA = _RGBA___get_ad__impl_(v);
    if (((!(this.__mR === mR) ? true : !(this.__mG === mG)) ? true : !(this.__mB === mB)) ? true : !(this.__mA === mA)) {
      this.__mR = mR;
      this.__mG = mG;
      this.__mB = mB;
      this.__mA = mA;
      this._dirty = true;
    }};
  ColorTransform.prototype._get_colorMul__21 = function () {
    return computeColors(this).__colorMul;
  };
  ColorTransform.prototype._get_colorAdd__21 = function () {
    return computeColors(this).__colorAdd;
  };
  ColorTransform.prototype._set_mR_ = function (v) {
    this.__mR = v;
    this._dirty = true;
    return Unit_getInstance();
  };
  ColorTransform.prototype._get_mR_ = function () {
    return this.__mR;
  };
  ColorTransform.prototype._set_mG_ = function (v) {
    this.__mG = v;
    this._dirty = true;
    return Unit_getInstance();
  };
  ColorTransform.prototype._get_mG_ = function () {
    return this.__mG;
  };
  ColorTransform.prototype._set_mB_ = function (v) {
    this.__mB = v;
    this._dirty = true;
    return Unit_getInstance();
  };
  ColorTransform.prototype._get_mB_ = function () {
    return this.__mB;
  };
  ColorTransform.prototype._set_mA_ = function (v) {
    this.__mA = v;
    this._dirty = true;
    return Unit_getInstance();
  };
  ColorTransform.prototype._get_mA_ = function () {
    return this.__mA;
  };
  ColorTransform.prototype._set_aR_ = function (v) {
    this.__aR = v;
    this._dirty = true;
    return Unit_getInstance();
  };
  ColorTransform.prototype._get_aR_ = function () {
    return this.__aR;
  };
  ColorTransform.prototype._set_aG_ = function (v) {
    this.__aG = v;
    this._dirty = true;
    return Unit_getInstance();
  };
  ColorTransform.prototype._get_aG_ = function () {
    return this.__aG;
  };
  ColorTransform.prototype._set_aB_ = function (v) {
    this.__aB = v;
    this._dirty = true;
    return Unit_getInstance();
  };
  ColorTransform.prototype._get_aB_ = function () {
    return this.__aB;
  };
  ColorTransform.prototype._get_aA_ = function () {
    return this.__aA;
  };
  ColorTransform.prototype.setTo_5 = function (mR, mG, mB, mA, aR, aG, aB, aA) {
    this.__mR = mR;
    this.__mG = mG;
    this.__mB = mB;
    this.__mA = mA;
    this.__aR = aR;
    this.__aG = aG;
    this.__aB = aB;
    this.__aA = aA;
    this._dirty = true;
    return this;
  };
  ColorTransform.prototype.copyFrom_4 = function (t) {
    this.__mR = t.__mR;
    this.__mG = t.__mG;
    this.__mB = t.__mB;
    this.__mA = t.__mA;
    this.__aR = t.__aR;
    this.__aG = t.__aG;
    this.__aB = t.__aB;
    this.__aA = t.__aA;
    this._dirty = t._dirty;
    this.__colorAdd = t.__colorAdd;
    this.__colorMul = t.__colorMul;
    return this;
  };
  ColorTransform.prototype.setToConcat = function (l, r) {
    return this.setTo_5(l._get_mR_() * r._get_mR_(), l._get_mG_() * r._get_mG_(), l._get_mB_() * r._get_mB_(), l._get_mA_() * r._get_mA_(), l._get_aR_() + r._get_aR_() | 0, l._get_aG_() + r._get_aG_() | 0, l._get_aB_() + r._get_aB_() | 0, l._get_aA_() + r._get_aA_() | 0);
  };
  ColorTransform.prototype.toString = function () {
    return '' + 'ColorTransform(*[' + _get_niceStr__0(this._get_mR_()) + ', ' + _get_niceStr__0(this._get_mG_()) + ', ' + _get_niceStr__0(this._get_mB_()) + ', ' + _get_niceStr__0(this._get_mA_()) + ']+[' + this._get_aR_() + ', ' + this._get_aG_() + ', ' + this._get_aB_() + ', ' + this._get_aA_() + '])';
  };
  ColorTransform.prototype.copy_11 = function (_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA) {
    return new ColorTransform(_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA);
  };
  ColorTransform.prototype.copy$default_5 = function (_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      _mR = this.__mR;
    if (!(($mask0 & 2) === 0))
      _mG = this.__mG;
    if (!(($mask0 & 4) === 0))
      _mB = this.__mB;
    if (!(($mask0 & 8) === 0))
      _mA = this.__mA;
    if (!(($mask0 & 16) === 0))
      _aR = this.__aR;
    if (!(($mask0 & 32) === 0))
      _aG = this.__aG;
    if (!(($mask0 & 64) === 0))
      _aB = this.__aB;
    if (!(($mask0 & 128) === 0))
      _aA = this.__aA;
    return this.copy_11(_mR, _mG, _mB, _mA, _aR, _aG, _aB, _aA);
  };
  ColorTransform.prototype.hashCode = function () {
    var result = getNumberHashCode(this.__mR);
    result = imul(result, 31) + getNumberHashCode(this.__mG) | 0;
    result = imul(result, 31) + getNumberHashCode(this.__mB) | 0;
    result = imul(result, 31) + getNumberHashCode(this.__mA) | 0;
    result = imul(result, 31) + this.__aR | 0;
    result = imul(result, 31) + this.__aG | 0;
    result = imul(result, 31) + this.__aB | 0;
    result = imul(result, 31) + this.__aA | 0;
    return result;
  };
  ColorTransform.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransform))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ColorTransform ? other : THROW_CCE();
    if (!equals_1(this.__mR, tmp0_other_with_cast.__mR))
      return false;
    if (!equals_1(this.__mG, tmp0_other_with_cast.__mG))
      return false;
    if (!equals_1(this.__mB, tmp0_other_with_cast.__mB))
      return false;
    if (!equals_1(this.__mA, tmp0_other_with_cast.__mA))
      return false;
    if (!(this.__aR === tmp0_other_with_cast.__aR))
      return false;
    if (!(this.__aG === tmp0_other_with_cast.__aG))
      return false;
    if (!(this.__aB === tmp0_other_with_cast.__aB))
      return false;
    if (!(this.__aA === tmp0_other_with_cast.__aA))
      return false;
    return true;
  };
  ColorTransform.$metadata$ = {
    simpleName: 'ColorTransform',
    kind: 'class',
    interfaces: [MutableInterpolable, Interpolable]
  };
  function _ColorAdd___init__impl_(value) {
    return value;
  }
  function _ColorAdd___get_value__impl_(this_0) {
    return this_0;
  }
  function _ColorAdd___get_shex__impl_(this_0) {
    return _get_shex_(_ColorAdd___get_value__impl_(this_0));
  }
  function Companion_103() {
    Companion_instance_102 = this;
    this._NEUTRAL = _ColorAdd___init__impl_(2139062143);
  }
  Companion_103.prototype.invoke_374 = function (r, g, b, a) {
    return _ColorAdd___init__impl_(this.pack_8(r, g, b, a));
  };
  Companion_103.prototype.packComponent = function (v) {
    return clamp_1(127 + (v >> 1) | 0, 0, 255);
  };
  Companion_103.prototype.pack_8 = function (r, g, b, a) {
    return Companion_getInstance_102().packComponent(r) << 0 | Companion_getInstance_102().packComponent(g) << 8 | Companion_getInstance_102().packComponent(b) << 16 | Companion_getInstance_102().packComponent(a) << 24;
  };
  Companion_103.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_102;
  function Companion_getInstance_102() {
    if (Companion_instance_102 == null)
      new Companion_103();
    return Companion_instance_102;
  }
  function ColorAdd__toString_impl(this_0) {
    return '' + 'ColorAdd(value=' + this_0 + ')';
  }
  function ColorAdd__hashCode_impl(this_0) {
    return this_0;
  }
  function ColorAdd__equals_impl(this_0, other) {
    if (!(other instanceof ColorAdd))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ColorAdd ? other._value_16 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function ColorAdd(value) {
    Companion_getInstance_102();
    this._value_16 = value;
  }
  ColorAdd.prototype.toString = function () {
    return ColorAdd__toString_impl(this._value_16);
  };
  ColorAdd.prototype.hashCode = function () {
    return ColorAdd__hashCode_impl(this._value_16);
  };
  ColorAdd.prototype.equals = function (other) {
    return ColorAdd__equals_impl(this._value_16, other);
  };
  ColorAdd.$metadata$ = {
    simpleName: 'ColorAdd',
    kind: 'class',
    interfaces: []
  };
  function Colors() {
    Colors_instance = this;
    this._WHITE = Companion_getInstance_104().invoke_375(255, 255, 255, 255);
    this._BLACK = Companion_getInstance_104().invoke_375(0, 0, 0, 255);
    this._RED = Companion_getInstance_104().invoke_375(255, 0, 0, 255);
    this._GREEN = Companion_getInstance_104().invoke_375(0, 255, 0, 255);
    this._BLUE = Companion_getInstance_104().invoke_375(0, 0, 255, 255);
    this._TRANSPARENT_BLACK = Companion_getInstance_104().invoke_375(0, 0, 0, 0);
    this._TRANSPARENT_WHITE = Companion_getInstance_104().invoke_375(255, 255, 255, 0);
    this._ALICEBLUE = Companion_getInstance_104().invoke_376(240, 248, 255);
    this._ANTIQUEWHITE = Companion_getInstance_104().invoke_376(250, 235, 215);
    this._AQUA = Companion_getInstance_104().invoke_376(0, 255, 255);
    this._AQUAMARINE = Companion_getInstance_104().invoke_376(127, 255, 212);
    this._AZURE = Companion_getInstance_104().invoke_376(240, 255, 255);
    this._BEIGE = Companion_getInstance_104().invoke_376(245, 245, 220);
    this._BISQUE = Companion_getInstance_104().invoke_376(255, 228, 196);
    this._BLANCHEDALMOND = Companion_getInstance_104().invoke_376(255, 235, 205);
    this._BLUEVIOLET = Companion_getInstance_104().invoke_376(138, 43, 226);
    this._BROWN = Companion_getInstance_104().invoke_376(165, 42, 42);
    this._BURLYWOOD = Companion_getInstance_104().invoke_376(222, 184, 135);
    this._CADETBLUE = Companion_getInstance_104().invoke_376(95, 158, 160);
    this._CHARTREUSE = Companion_getInstance_104().invoke_376(127, 255, 0);
    this._CHOCOLATE = Companion_getInstance_104().invoke_376(210, 105, 30);
    this._CORAL = Companion_getInstance_104().invoke_376(255, 127, 80);
    this._CORNFLOWERBLUE = Companion_getInstance_104().invoke_376(100, 149, 237);
    this._CORNSILK = Companion_getInstance_104().invoke_376(255, 248, 220);
    this._CRIMSON = Companion_getInstance_104().invoke_376(220, 20, 60);
    this._DARKBLUE = Companion_getInstance_104().invoke_376(0, 0, 139);
    this._CYAN = Companion_getInstance_104().invoke_376(0, 255, 255);
    this._DARKCYAN = Companion_getInstance_104().invoke_376(0, 139, 139);
    this._DARKGOLDENROD = Companion_getInstance_104().invoke_376(184, 134, 11);
    this._DARKGRAY = Companion_getInstance_104().invoke_376(169, 169, 169);
    this._DARKGREEN = Companion_getInstance_104().invoke_376(0, 100, 0);
    this._DARKGREY = Companion_getInstance_104().invoke_376(169, 169, 169);
    this._DARKKHAKI = Companion_getInstance_104().invoke_376(189, 183, 107);
    this._MAGENTA = Companion_getInstance_104().invoke_376(255, 0, 255);
    this._DARKMAGENTA = Companion_getInstance_104().invoke_376(139, 0, 139);
    this._DARKOLIVEGREEN = Companion_getInstance_104().invoke_376(85, 107, 47);
    this._DARKORANGE = Companion_getInstance_104().invoke_376(255, 140, 0);
    this._DARKORCHID = Companion_getInstance_104().invoke_376(153, 50, 204);
    this._DARKRED = Companion_getInstance_104().invoke_376(139, 0, 0);
    this._DARKSALMON = Companion_getInstance_104().invoke_376(233, 150, 122);
    this._DARKSEAGREEN = Companion_getInstance_104().invoke_376(143, 188, 143);
    this._DARKSLATEBLUE = Companion_getInstance_104().invoke_376(72, 61, 139);
    this._DARKSLATEGRAY = Companion_getInstance_104().invoke_376(47, 79, 79);
    this._DARKSLATEGREY = Companion_getInstance_104().invoke_376(47, 79, 79);
    this._DARKTURQUOISE = Companion_getInstance_104().invoke_376(0, 206, 209);
    this._DARKVIOLET = Companion_getInstance_104().invoke_376(148, 0, 211);
    this._DEEPPINK = Companion_getInstance_104().invoke_376(255, 20, 147);
    this._DEEPSKYBLUE = Companion_getInstance_104().invoke_376(0, 191, 255);
    this._DIMGRAY = Companion_getInstance_104().invoke_376(105, 105, 105);
    this._DIMGREY = Companion_getInstance_104().invoke_376(105, 105, 105);
    this._DODGERBLUE = Companion_getInstance_104().invoke_376(30, 144, 255);
    this._FIREBRICK = Companion_getInstance_104().invoke_376(178, 34, 34);
    this._FLORALWHITE = Companion_getInstance_104().invoke_376(255, 250, 240);
    this._FORESTGREEN = Companion_getInstance_104().invoke_376(34, 139, 34);
    this._FUCHSIA = Companion_getInstance_104().invoke_376(255, 0, 255);
    this._GAINSBORO = Companion_getInstance_104().invoke_376(220, 220, 220);
    this._GHOSTWHITE = Companion_getInstance_104().invoke_376(248, 248, 255);
    this._GOLD = Companion_getInstance_104().invoke_376(255, 215, 0);
    this._GOLDENROD = Companion_getInstance_104().invoke_376(218, 165, 32);
    this._GREENYELLOW = Companion_getInstance_104().invoke_376(173, 255, 47);
    this._HONEYDEW = Companion_getInstance_104().invoke_376(240, 255, 240);
    this._HOTPINK = Companion_getInstance_104().invoke_376(255, 105, 180);
    this._INDIANRED = Companion_getInstance_104().invoke_376(205, 92, 92);
    this._INDIGO = Companion_getInstance_104().invoke_376(75, 0, 130);
    this._IVORY = Companion_getInstance_104().invoke_376(255, 255, 240);
    this._KHAKI = Companion_getInstance_104().invoke_376(240, 230, 140);
    this._LAVENDER = Companion_getInstance_104().invoke_376(230, 230, 250);
    this._LAVENDERBLUSH = Companion_getInstance_104().invoke_376(255, 240, 245);
    this._LAWNGREEN = Companion_getInstance_104().invoke_376(124, 252, 0);
    this._LEMONCHIFFON = Companion_getInstance_104().invoke_376(255, 250, 205);
    this._LIGHTBLUE = Companion_getInstance_104().invoke_376(173, 216, 230);
    this._LIGHTCORAL = Companion_getInstance_104().invoke_376(240, 128, 128);
    this._LIGHTCYAN = Companion_getInstance_104().invoke_376(224, 255, 255);
    this._LIGHTGOLDENRODYELLOW = Companion_getInstance_104().invoke_376(250, 250, 210);
    this._LIGHTGRAY = Companion_getInstance_104().invoke_376(211, 211, 211);
    this._LIGHTGREEN = Companion_getInstance_104().invoke_376(144, 238, 144);
    this._LIGHTGREY = Companion_getInstance_104().invoke_376(211, 211, 211);
    this._LIGHTPINK = Companion_getInstance_104().invoke_376(255, 182, 193);
    this._LIGHTSALMON = Companion_getInstance_104().invoke_376(255, 160, 122);
    this._LIGHTSEAGREEN = Companion_getInstance_104().invoke_376(32, 178, 170);
    this._LIGHTSKYBLUE = Companion_getInstance_104().invoke_376(135, 206, 250);
    this._LIGHTSLATEGRAY = Companion_getInstance_104().invoke_376(119, 136, 153);
    this._LIGHTSLATEGREY = Companion_getInstance_104().invoke_376(119, 136, 153);
    this._LIGHTSTEELBLUE = Companion_getInstance_104().invoke_376(176, 196, 222);
    this._LIGHTYELLOW = Companion_getInstance_104().invoke_376(255, 255, 224);
    this._LIME = Companion_getInstance_104().invoke_376(0, 255, 0);
    this._LIMEGREEN = Companion_getInstance_104().invoke_376(50, 205, 50);
    this._LINEN = Companion_getInstance_104().invoke_376(250, 240, 230);
    this._MAROON = Companion_getInstance_104().invoke_376(128, 0, 0);
    this._MEDIUMAQUAMARINE = Companion_getInstance_104().invoke_376(102, 205, 170);
    this._MEDIUMBLUE = Companion_getInstance_104().invoke_376(0, 0, 205);
    this._MEDIUMORCHID = Companion_getInstance_104().invoke_376(186, 85, 211);
    this._MEDIUMPURPLE = Companion_getInstance_104().invoke_376(147, 112, 219);
    this._MEDIUMSEAGREEN = Companion_getInstance_104().invoke_376(60, 179, 113);
    this._MEDIUMSLATEBLUE = Companion_getInstance_104().invoke_376(123, 104, 238);
    this._MEDIUMSPRINGGREEN = Companion_getInstance_104().invoke_376(0, 250, 154);
    this._MEDIUMTURQUOISE = Companion_getInstance_104().invoke_376(72, 209, 204);
    this._MEDIUMVIOLETRED = Companion_getInstance_104().invoke_376(199, 21, 133);
    this._MIDNIGHTBLUE = Companion_getInstance_104().invoke_376(25, 25, 112);
    this._MINTCREAM = Companion_getInstance_104().invoke_376(245, 255, 250);
    this._MISTYROSE = Companion_getInstance_104().invoke_376(255, 228, 225);
    this._MOCCASIN = Companion_getInstance_104().invoke_376(255, 228, 181);
    this._NAVAJOWHITE = Companion_getInstance_104().invoke_376(255, 222, 173);
    this._NAVY = Companion_getInstance_104().invoke_376(0, 0, 128);
    this._OLDLACE = Companion_getInstance_104().invoke_376(253, 245, 230);
    this._OLIVE = Companion_getInstance_104().invoke_376(128, 128, 0);
    this._OLIVEDRAB = Companion_getInstance_104().invoke_376(107, 142, 35);
    this._ORANGE = Companion_getInstance_104().invoke_376(255, 165, 0);
    this._ORANGERED = Companion_getInstance_104().invoke_376(255, 69, 0);
    this._ORCHID = Companion_getInstance_104().invoke_376(218, 112, 214);
    this._PALEGOLDENROD = Companion_getInstance_104().invoke_376(238, 232, 170);
    this._PALEGREEN = Companion_getInstance_104().invoke_376(152, 251, 152);
    this._PALETURQUOISE = Companion_getInstance_104().invoke_376(175, 238, 238);
    this._PALEVIOLETRED = Companion_getInstance_104().invoke_376(219, 112, 147);
    this._PAPAYAWHIP = Companion_getInstance_104().invoke_376(255, 239, 213);
    this._PEACHPUFF = Companion_getInstance_104().invoke_376(255, 218, 185);
    this._PERU = Companion_getInstance_104().invoke_376(205, 133, 63);
    this._PINK = Companion_getInstance_104().invoke_376(255, 192, 203);
    this._PLUM = Companion_getInstance_104().invoke_376(221, 160, 221);
    this._POWDERBLUE = Companion_getInstance_104().invoke_376(176, 224, 230);
    this._PURPLE = Companion_getInstance_104().invoke_376(128, 0, 128);
    this._ROSYBROWN = Companion_getInstance_104().invoke_376(188, 143, 143);
    this._ROYALBLUE = Companion_getInstance_104().invoke_376(65, 105, 225);
    this._SADDLEBROWN = Companion_getInstance_104().invoke_376(139, 69, 19);
    this._SALMON = Companion_getInstance_104().invoke_376(250, 128, 114);
    this._SANDYBROWN = Companion_getInstance_104().invoke_376(244, 164, 96);
    this._SEAGREEN = Companion_getInstance_104().invoke_376(46, 139, 87);
    this._SEASHELL = Companion_getInstance_104().invoke_376(255, 245, 238);
    this._SIENNA = Companion_getInstance_104().invoke_376(160, 82, 45);
    this._SILVER = Companion_getInstance_104().invoke_376(192, 192, 192);
    this._SKYBLUE = Companion_getInstance_104().invoke_376(135, 206, 235);
    this._SLATEBLUE = Companion_getInstance_104().invoke_376(106, 90, 205);
    this._SLATEGRAY = Companion_getInstance_104().invoke_376(112, 128, 144);
    this._SLATEGREY = Companion_getInstance_104().invoke_376(112, 128, 144);
    this._SNOW = Companion_getInstance_104().invoke_376(255, 250, 250);
    this._SPRINGGREEN = Companion_getInstance_104().invoke_376(0, 255, 127);
    this._STEELBLUE = Companion_getInstance_104().invoke_376(70, 130, 180);
    this._TAN = Companion_getInstance_104().invoke_376(210, 180, 140);
    this._TEAL = Companion_getInstance_104().invoke_376(0, 128, 128);
    this._THISTLE = Companion_getInstance_104().invoke_376(216, 191, 216);
    this._TOMATO = Companion_getInstance_104().invoke_376(255, 99, 71);
    this._TURQUOISE = Companion_getInstance_104().invoke_376(64, 224, 208);
    this._VIOLET = Companion_getInstance_104().invoke_376(238, 130, 238);
    this._WHEAT = Companion_getInstance_104().invoke_376(245, 222, 179);
    this._WHITESMOKE = Companion_getInstance_104().invoke_376(245, 245, 245);
    this._YELLOWGREEN = Companion_getInstance_104().invoke_376(154, 205, 50);
    this._YELLOW = Companion_getInstance_104().invoke_376(255, 255, 0);
    this._colorsByName = mapOf([to('black', new RGBA(this._BLACK)), to('white', new RGBA(this._WHITE)), to('red', new RGBA(this._RED)), to('green', new RGBA(this._GREEN)), to('blue', new RGBA(this._BLUE)), to('aliceblue', new RGBA(this._ALICEBLUE)), to('antiquewhite', new RGBA(this._ANTIQUEWHITE)), to('aqua', new RGBA(this._AQUA)), to('aquamarine', new RGBA(this._AQUAMARINE)), to('azure', new RGBA(this._AZURE)), to('beige', new RGBA(this._BEIGE)), to('bisque', new RGBA(this._BISQUE)), to('blanchedalmond', new RGBA(this._BLANCHEDALMOND)), to('blueviolet', new RGBA(this._BLUEVIOLET)), to('brown', new RGBA(this._BROWN)), to('burlywood', new RGBA(this._BURLYWOOD)), to('cadetblue', new RGBA(this._CADETBLUE)), to('chartreuse', new RGBA(this._CHARTREUSE)), to('chocolate', new RGBA(this._CHOCOLATE)), to('coral', new RGBA(this._CORAL)), to('cornflowerblue', new RGBA(this._CORNFLOWERBLUE)), to('cornsilk', new RGBA(this._CORNSILK)), to('crimson', new RGBA(this._CRIMSON)), to('darkblue', new RGBA(this._DARKBLUE)), to('darkcyan', new RGBA(this._DARKCYAN)), to('darkgoldenrod', new RGBA(this._DARKGOLDENROD)), to('darkgray', new RGBA(this._DARKGRAY)), to('darkgreen', new RGBA(this._DARKGREEN)), to('darkgrey', new RGBA(this._DARKGREY)), to('darkkhaki', new RGBA(this._DARKKHAKI)), to('darkmagenta', new RGBA(this._DARKMAGENTA)), to('darkolivegreen', new RGBA(this._DARKOLIVEGREEN)), to('darkorange', new RGBA(this._DARKORANGE)), to('darkorchid', new RGBA(this._DARKORCHID)), to('darkred', new RGBA(this._DARKRED)), to('darksalmon', new RGBA(this._DARKSALMON)), to('darkseagreen', new RGBA(this._DARKSEAGREEN)), to('darkslateblue', new RGBA(this._DARKSLATEBLUE)), to('darkslategray', new RGBA(this._DARKSLATEGRAY)), to('darkslategrey', new RGBA(this._DARKSLATEGREY)), to('darkturquoise', new RGBA(this._DARKTURQUOISE)), to('darkviolet', new RGBA(this._DARKVIOLET)), to('deeppink', new RGBA(this._DEEPPINK)), to('deepskyblue', new RGBA(this._DEEPSKYBLUE)), to('dimgray', new RGBA(this._DIMGRAY)), to('dimgrey', new RGBA(this._DIMGREY)), to('dodgerblue', new RGBA(this._DODGERBLUE)), to('firebrick', new RGBA(this._FIREBRICK)), to('floralwhite', new RGBA(this._FLORALWHITE)), to('forestgreen', new RGBA(this._FORESTGREEN)), to('fuchsia', new RGBA(this._FUCHSIA)), to('gainsboro', new RGBA(this._GAINSBORO)), to('ghostwhite', new RGBA(this._GHOSTWHITE)), to('gold', new RGBA(this._GOLD)), to('goldenrod', new RGBA(this._GOLDENROD)), to('greenyellow', new RGBA(this._GREENYELLOW)), to('honeydew', new RGBA(this._HONEYDEW)), to('hotpink', new RGBA(this._HOTPINK)), to('indianred', new RGBA(this._INDIANRED)), to('indigo', new RGBA(this._INDIGO)), to('ivory', new RGBA(this._IVORY)), to('khaki', new RGBA(this._KHAKI)), to('lavender', new RGBA(this._LAVENDER)), to('lavenderblush', new RGBA(this._LAVENDERBLUSH)), to('lawngreen', new RGBA(this._LAWNGREEN)), to('lemonchiffon', new RGBA(this._LEMONCHIFFON)), to('lightblue', new RGBA(this._LIGHTBLUE)), to('lightcoral', new RGBA(this._LIGHTCORAL)), to('lightcyan', new RGBA(this._LIGHTCYAN)), to('lightgoldenrodyellow', new RGBA(this._LIGHTGOLDENRODYELLOW)), to('lightgray', new RGBA(this._LIGHTGRAY)), to('lightgreen', new RGBA(this._LIGHTGREEN)), to('lightgrey', new RGBA(this._LIGHTGREY)), to('lightpink', new RGBA(this._LIGHTPINK)), to('lightsalmon', new RGBA(this._LIGHTSALMON)), to('lightseagreen', new RGBA(this._LIGHTSEAGREEN)), to('lightskyblue', new RGBA(this._LIGHTSKYBLUE)), to('lightslategray', new RGBA(this._LIGHTSLATEGRAY)), to('lightslategrey', new RGBA(this._LIGHTSLATEGREY)), to('lightsteelblue', new RGBA(this._LIGHTSTEELBLUE)), to('lightyellow', new RGBA(this._LIGHTYELLOW)), to('lime', new RGBA(this._LIME)), to('limegreen', new RGBA(this._LIMEGREEN)), to('linen', new RGBA(this._LINEN)), to('maroon', new RGBA(this._MAROON)), to('mediumaquamarine', new RGBA(this._MEDIUMAQUAMARINE)), to('mediumblue', new RGBA(this._MEDIUMBLUE)), to('mediumorchid', new RGBA(this._MEDIUMORCHID)), to('mediumpurple', new RGBA(this._MEDIUMPURPLE)), to('mediumseagreen', new RGBA(this._MEDIUMSEAGREEN)), to('mediumslateblue', new RGBA(this._MEDIUMSLATEBLUE)), to('mediumspringgreen', new RGBA(this._MEDIUMSPRINGGREEN)), to('mediumturquoise', new RGBA(this._MEDIUMTURQUOISE)), to('mediumvioletred', new RGBA(this._MEDIUMVIOLETRED)), to('midnightblue', new RGBA(this._MIDNIGHTBLUE)), to('mintcream', new RGBA(this._MINTCREAM)), to('mistyrose', new RGBA(this._MISTYROSE)), to('moccasin', new RGBA(this._MOCCASIN)), to('navajowhite', new RGBA(this._NAVAJOWHITE)), to('navy', new RGBA(this._NAVY)), to('oldlace', new RGBA(this._OLDLACE)), to('olive', new RGBA(this._OLIVE)), to('olivedrab', new RGBA(this._OLIVEDRAB)), to('orange', new RGBA(this._ORANGE)), to('orangered', new RGBA(this._ORANGERED)), to('orchid', new RGBA(this._ORCHID)), to('palegoldenrod', new RGBA(this._PALEGOLDENROD)), to('palegreen', new RGBA(this._PALEGREEN)), to('paleturquoise', new RGBA(this._PALETURQUOISE)), to('palevioletred', new RGBA(this._PALEVIOLETRED)), to('papayawhip', new RGBA(this._PAPAYAWHIP)), to('peachpuff', new RGBA(this._PEACHPUFF)), to('peru', new RGBA(this._PERU)), to('pink', new RGBA(this._PINK)), to('plum', new RGBA(this._PLUM)), to('powderblue', new RGBA(this._POWDERBLUE)), to('purple', new RGBA(this._PURPLE)), to('rosybrown', new RGBA(this._ROSYBROWN)), to('royalblue', new RGBA(this._ROYALBLUE)), to('saddlebrown', new RGBA(this._SADDLEBROWN)), to('salmon', new RGBA(this._SALMON)), to('sandybrown', new RGBA(this._SANDYBROWN)), to('seagreen', new RGBA(this._SEAGREEN)), to('seashell', new RGBA(this._SEASHELL)), to('sienna', new RGBA(this._SIENNA)), to('silver', new RGBA(this._SILVER)), to('skyblue', new RGBA(this._SKYBLUE)), to('slateblue', new RGBA(this._SLATEBLUE)), to('slategray', new RGBA(this._SLATEGRAY)), to('slategrey', new RGBA(this._SLATEGREY)), to('snow', new RGBA(this._SNOW)), to('springgreen', new RGBA(this._SPRINGGREEN)), to('steelblue', new RGBA(this._STEELBLUE)), to('tan', new RGBA(this._TAN)), to('teal', new RGBA(this._TEAL)), to('thistle', new RGBA(this._THISTLE)), to('tomato', new RGBA(this._TOMATO)), to('turquoise', new RGBA(this._TURQUOISE)), to('violet', new RGBA(this._VIOLET)), to('wheat', new RGBA(this._WHEAT)), to('whitesmoke', new RGBA(this._WHITESMOKE)), to('yellowgreen', new RGBA(this._YELLOWGREEN)), to('yellow', new RGBA(this._YELLOW))]);
  }
  Colors.prototype.get_91 = function (str) {
    return this.get_92(str, Colors_getInstance()._TRANSPARENT_BLACK, true);
  };
  Colors.prototype.get_92 = function (str, default_0, errorOnDefault) {
    try {
      if (startsWith$default_1(str, '#', false, 2, null)) {
        var hex = substr_1(str, 1);
        if (!setOf([3, 4, 6, 8]).contains_58(hex.length))
          return this._BLACK;
        var chars = hex.length < 6 ? 1 : 2;
        var scale_1 = hex.length < 6 ? 17.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt_0(substr_0(hex, imul(0, chars), chars), 16) * scale_1);
        var g = numberToInt(toInt_0(substr_0(hex, imul(1, chars), chars), 16) * scale_1);
        var b = numberToInt(toInt_0(substr_0(hex, imul(2, chars), chars), 16) * scale_1);
        var a = hasAlpha ? numberToInt(toInt_0(substr_0(hex, imul(3, chars), chars), 16) * scale_1) : 255;
        return Companion_getInstance_104().invoke_375(r, g, b, a);
      } else {
        if (startsWith_1(str, 'RGBA(', true)) {
          var tmp = removeSuffix(removePrefix(str.toUpperCase(), 'RGBA('), ')');
          var tmp_0 = [','];
          var parts_0 = split$default_0(tmp, tmp_0, false, 0, 6, null);
          var tmp0_getOrElse_0 = 0;
          var tmp_1;
          if (tmp0_getOrElse_0 >= 0 ? tmp0_getOrElse_0 <= _get_lastIndex__3(parts_0) : false) {
            tmp_1 = parts_0.get_137(tmp0_getOrElse_0);
          } else {
            tmp_1 = '0';
          }
          var tmp0_elvis_lhs = toIntOrNull(tmp_1);
          var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          var tmp1_getOrElse_0 = 1;
          var tmp_2;
          if (tmp1_getOrElse_0 >= 0 ? tmp1_getOrElse_0 <= _get_lastIndex__3(parts_0) : false) {
            tmp_2 = parts_0.get_137(tmp1_getOrElse_0);
          } else {
            tmp_2 = '0';
          }
          var tmp1_elvis_lhs = toIntOrNull(tmp_2);
          var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
          var tmp2_getOrElse_0 = 2;
          var tmp_3;
          if (tmp2_getOrElse_0 >= 0 ? tmp2_getOrElse_0 <= _get_lastIndex__3(parts_0) : false) {
            tmp_3 = parts_0.get_137(tmp2_getOrElse_0);
          } else {
            tmp_3 = '0';
          }
          var tmp2_elvis_lhs = toIntOrNull(tmp_3);
          var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
          var tmp3_getOrElse_0 = 3;
          var tmp_4;
          if (tmp3_getOrElse_0 >= 0 ? tmp3_getOrElse_0 <= _get_lastIndex__3(parts_0) : false) {
            tmp_4 = parts_0.get_137(tmp3_getOrElse_0);
          } else {
            tmp_4 = '1.0';
          }
          var tmp3_elvis_lhs = toDoubleOrNull(tmp_4);
          var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
          return Companion_getInstance_104().invoke_375(r_0, g_0, b_0, numberToInt(af * 255));
        } else {
          {
            var tmp_5 = this._colorsByName.get_116(str.toLowerCase());
            var col = tmp_5 == null ? null : tmp_5._value_17;
            var tmp_6;
            var tmp_7 = col;
            if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
              tmp_6 = errorOnDefault;
            } else {
              {
                tmp_6 = false;
              }
            }
            if (tmp_6) {
              var tmp_8 = '' + '#' + str;
              return this.get$default(tmp_8, default_0, false, 4, null);
            } else {
            }
            var tmp4_elvis_lhs = col;
            var tmp_9;
            var tmp_10 = tmp4_elvis_lhs;
            if ((tmp_10 == null ? null : new RGBA(tmp_10)) == null) {
              tmp_9 = default_0;
            } else {
              {
                tmp_9 = tmp4_elvis_lhs;
              }
            }
            return tmp_9;
          }
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        printStackTrace($p);
        return Colors_getInstance()._RED;
      } else {
        {
          throw $p;
        }
      }
    }
  };
  Colors.prototype.get$default = function (str, default_0, errorOnDefault, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      errorOnDefault = false;
    return this.get_92(str, default_0, errorOnDefault);
  };
  Colors.$metadata$ = {
    simpleName: 'Colors',
    kind: 'object',
    interfaces: []
  };
  var Colors_instance;
  function Colors_getInstance() {
    if (Colors_instance == null)
      new Colors();
    return Colors_instance;
  }
  function Companion_104() {
    Companion_instance_103 = this;
    RGB.call(this, 0, 8, 16);
  }
  Companion_104.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_103;
  function Companion_getInstance_103() {
    if (Companion_instance_103 == null)
      new Companion_104();
    return Companion_instance_103;
  }
  function RGB(rOffset, gOffset, bOffset) {
    Companion_getInstance_103();
    ColorFormat24.call(this);
    this._rOffset_0 = rOffset;
    this._gOffset_0 = gOffset;
    this._bOffset_0 = bOffset;
  }
  RGB.prototype.getR_7 = function (v) {
    return extract8(v, this._rOffset_0);
  };
  RGB.prototype.getG_7 = function (v) {
    return extract8(v, this._gOffset_0);
  };
  RGB.prototype.getB_7 = function (v) {
    return extract8(v, this._bOffset_0);
  };
  RGB.prototype.getA_7 = function (v) {
    return 255;
  };
  RGB.prototype.pack_8 = function (r, g, b, a) {
    return insert8(insert8(insert8(0, r, this._rOffset_0), g, this._gOffset_0), b, this._bOffset_0);
  };
  RGB.$metadata$ = {
    simpleName: 'RGB',
    kind: 'class',
    interfaces: []
  };
  function BGR() {
    BGR_instance = this;
    RGB.call(this, 16, 8, 0);
  }
  BGR.$metadata$ = {
    simpleName: 'BGR',
    kind: 'object',
    interfaces: []
  };
  var BGR_instance;
  function BGR_getInstance() {
    if (BGR_instance == null)
      new BGR();
    return BGR_instance;
  }
  function blendComponent($this, c1, c2, factor) {
    return numberToInt(c1 * (1.0 - factor) + c2 * factor) & 255;
  }
  function _RGBA___init__impl_(value) {
    return value;
  }
  function _RGBA___get_value__impl_(this_0) {
    return this_0;
  }
  function _RGBA___get_color__impl_(this_0) {
    return this_0;
  }
  function _RGBA___get_r__impl_(this_0) {
    return _RGBA___get_value__impl_(this_0) >>> 0 & 255;
  }
  function _RGBA___get_g__impl_(this_0) {
    return _RGBA___get_value__impl_(this_0) >>> 8 & 255;
  }
  function _RGBA___get_b__impl_(this_0) {
    return _RGBA___get_value__impl_(this_0) >>> 16 & 255;
  }
  function _RGBA___get_a__impl_(this_0) {
    return _RGBA___get_value__impl_(this_0) >>> 24 & 255;
  }
  function _RGBA___get_rf__impl_(this_0) {
    return _RGBA___get_r__impl_(this_0) / 255.0;
  }
  function _RGBA___get_gf__impl_(this_0) {
    return _RGBA___get_g__impl_(this_0) / 255.0;
  }
  function _RGBA___get_bf__impl_(this_0) {
    return _RGBA___get_b__impl_(this_0) / 255.0;
  }
  function _RGBA___get_af__impl_(this_0) {
    return _RGBA___get_a__impl_(this_0) / 255.0;
  }
  function _RGBA___get_rd__impl_(this_0) {
    return _RGBA___get_r__impl_(this_0) / 255.0;
  }
  function _RGBA___get_gd__impl_(this_0) {
    return _RGBA___get_g__impl_(this_0) / 255.0;
  }
  function _RGBA___get_bd__impl_(this_0) {
    return _RGBA___get_b__impl_(this_0) / 255.0;
  }
  function _RGBA___get_ad__impl_(this_0) {
    return _RGBA___get_a__impl_(this_0) / 255.0;
  }
  function _RGBA___get_rgb__impl_(this_0) {
    return _RGBA___get_value__impl_(this_0) & 16777215;
  }
  function RGBA__withA_impl(this_0, v) {
    return _RGBA___init__impl_(_RGBA___get_value__impl_(this_0) & 16777215 | (v & 255) << 24);
  }
  function RGBA__withAd_impl(this_0, v) {
    return RGBA__withA_impl(this_0, d2i(v));
  }
  function RGBA__withAf_impl(this_0, v) {
    return RGBA__withA_impl(this_0, f2i(v));
  }
  function _RGBA___get_hexString__impl_(this_0) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_2(new Char(35));
    Unit_getInstance();
    appendHexByte(tmp0_apply_0_1, _RGBA___get_r__impl_(this_0));
    appendHexByte(tmp0_apply_0_1, _RGBA___get_g__impl_(this_0));
    appendHexByte(tmp0_apply_0_1, _RGBA___get_b__impl_(this_0));
    appendHexByte(tmp0_apply_0_1, _RGBA___get_a__impl_(this_0));
    return tmp0_apply_0_1.toString();
  }
  function _RGBA___get_hexStringNoAlpha__impl_(this_0) {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_2(new Char(35));
    Unit_getInstance();
    appendHexByte(tmp0_apply_0_1, _RGBA___get_r__impl_(this_0));
    appendHexByte(tmp0_apply_0_1, _RGBA___get_g__impl_(this_0));
    appendHexByte(tmp0_apply_0_1, _RGBA___get_b__impl_(this_0));
    return tmp0_apply_0_1.toString();
  }
  function _RGBA___get_htmlColor__impl_(this_0) {
    return '' + 'rgba(' + _RGBA___get_r__impl_(this_0) + ', ' + _RGBA___get_g__impl_(this_0) + ', ' + _RGBA___get_b__impl_(this_0) + ', ' + _get_niceStr__1(_RGBA___get_af__impl_(this_0)) + ')';
  }
  function _RGBA___get_htmlStringSimple__impl_(this_0) {
    return _RGBA___get_hexStringNoAlpha__impl_(this_0);
  }
  function RGBA__toString_impl(this_0) {
    return _RGBA___get_hexString__impl_(this_0);
  }
  function RGBA__compareTo_impl(this_0, other) {
    return compareTo(_RGBA___get_value__impl_(this_0), _RGBA___get_value__impl_(other));
  }
  function RGBA__compareTo_impl_0(this_0, other) {
    var tmp = this_0._value_17;
    return RGBA__compareTo_impl(tmp, other instanceof RGBA ? other._value_17 : THROW_CCE());
  }
  function _RGBA___get_premultiplied__impl_(this_0) {
    var A = _RGBA___get_a__impl_(this_0) + 1 | 0;
    var RB = imul(_RGBA___get_value__impl_(this_0) & 16711935, A) >>> 8 & 16711935;
    var G = imul(_RGBA___get_value__impl_(this_0) & 65280, A) >>> 8 & 65280;
    return _RGBAPremultiplied___init__impl_(_RGBA___get_value__impl_(this_0) & -16777216 | RB | G);
  }
  function Companion_105() {
    Companion_instance_104 = this;
    ColorFormat32.call(this);
  }
  Companion_105.prototype.float = function (r, g, b, a) {
    return this.unclamped(f2i(r), f2i(g), f2i(b), f2i(a));
  };
  Companion_105.prototype.unclamped = function (r, g, b, a) {
    return _RGBA___init__impl_(packIntUnchecked(r, g, b, a));
  };
  Companion_105.prototype.invoke_375 = function (r, g, b, a) {
    return _RGBA___init__impl_(packIntClamped(r, g, b, a));
  };
  Companion_105.prototype.invoke_376 = function (r, g, b) {
    return _RGBA___init__impl_(packIntClamped(r, g, b, 255));
  };
  Companion_105.prototype.invoke_377 = function (rgb, a) {
    return _RGBA___init__impl_(rgb & 16777215 | a << 24);
  };
  Companion_105.prototype.invoke_378 = function (rgba) {
    return rgba;
  };
  Companion_105.prototype.getR_7 = function (v) {
    return _RGBA___get_r__impl_(_RGBA___init__impl_(v));
  };
  Companion_105.prototype.getG_7 = function (v) {
    return _RGBA___get_g__impl_(_RGBA___init__impl_(v));
  };
  Companion_105.prototype.getB_7 = function (v) {
    return _RGBA___get_b__impl_(_RGBA___init__impl_(v));
  };
  Companion_105.prototype.getA_7 = function (v) {
    return _RGBA___get_a__impl_(_RGBA___init__impl_(v));
  };
  Companion_105.prototype.pack_8 = function (r, g, b, a) {
    return _RGBA___get_value__impl_(Companion_getInstance_104().invoke_375(r, g, b, a));
  };
  Companion_105.prototype.mixRgbFactor256 = function (c1, c2, factor256) {
    return _RGBA___init__impl_(this.mixRgbFactor256_0(_RGBA___get_value__impl_(c1), _RGBA___get_value__impl_(c2), factor256));
  };
  Companion_105.prototype.mixRgbFactor256_0 = function (c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8;
  };
  Companion_105.prototype.mixRgb = function (c1, c2, factor) {
    return this.mixRgbFactor256(c1, c2, numberToInt(factor * 256));
  };
  Companion_105.prototype.mixRgba = function (c1, c2, factor) {
    return Companion_getInstance_104().invoke_377(_RGBA___get_rgb__impl_(this.mixRgb(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl_(c1), _RGBA___get_a__impl_(c2), factor));
  };
  Companion_105.prototype.mix = function (dst, src) {
    var srcA = _RGBA___get_a__impl_(src);
    var iSrcA = 255 - srcA | 0;
    var tmp0_subject = srcA;
    switch (tmp0_subject) {
      case 0:
        return dst;
      case 255:
        return src;
      default:return Companion_getInstance_104().invoke_377(_RGBA___get_rgb__impl_(this.mixRgbFactor256(dst, src, srcA + 1 | 0)), clamp0_255(srcA + (imul(_RGBA___get_a__impl_(dst), iSrcA) / 255 | 0) | 0));
    }
  };
  Companion_105.prototype.interpolate = function (src, dst, ratio) {
    return Companion_getInstance_104().invoke_375(interpolate_0(ratio, _RGBA___get_r__impl_(src), _RGBA___get_r__impl_(dst)), interpolate_0(ratio, _RGBA___get_g__impl_(src), _RGBA___get_g__impl_(dst)), interpolate_0(ratio, _RGBA___get_b__impl_(src), _RGBA___get_b__impl_(dst)), interpolate_0(ratio, _RGBA___get_a__impl_(src), _RGBA___get_a__impl_(dst)));
  };
  Companion_105.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_104;
  function Companion_getInstance_104() {
    if (Companion_instance_104 == null)
      new Companion_105();
    return Companion_instance_104;
  }
  function RGBA__hashCode_impl(this_0) {
    return this_0;
  }
  function RGBA__equals_impl(this_0, other) {
    if (!(other instanceof RGBA))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RGBA ? other._value_17 : THROW_CCE();
    if (!(this_0 === tmp0_other_with_cast))
      return false;
    return true;
  }
  function RGBA(value) {
    Companion_getInstance_104();
    this._value_17 = value;
  }
  RGBA.prototype.toString = function () {
    return RGBA__toString_impl(this._value_17);
  };
  RGBA.prototype.compareTo_70 = function (other) {
    return RGBA__compareTo_impl(this._value_17, other);
  };
  RGBA.prototype.compareTo_71 = function (other) {
    return RGBA__compareTo_impl_0(this, other);
  };
  RGBA.prototype.hashCode = function () {
    return RGBA__hashCode_impl(this._value_17);
  };
  RGBA.prototype.equals = function (other) {
    return RGBA__equals_impl(this._value_17, other);
  };
  RGBA.$metadata$ = {
    simpleName: 'RGBA',
    kind: 'class',
    interfaces: [Comparable, Interpolable, Paint]
  };
  function _RgbaArray___init__impl_(ints) {
    return ints;
  }
  function _RgbaArray___get_ints__impl_(this_0) {
    return this_0;
  }
  function Companion_106() {
    Companion_instance_105 = this;
  }
  Companion_106.prototype.invoke_379 = function (size_1) {
    return _RgbaArray___init__impl_(new Int32Array(size_1));
  };
  Companion_106.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_105;
  function Companion_getInstance_105() {
    if (Companion_instance_105 == null)
      new Companion_106();
    return Companion_instance_105;
  }
  function RgbaArray__contains_impl(this_0, element) {
    return contains(_RgbaArray___get_ints__impl_(this_0), _RGBA___get_value__impl_(element));
  }
  function RgbaArray__contains_impl_0(this_0, element) {
    if (!(element instanceof RGBA))
      return false;
    else {
    }
    var tmp = this_0._ints;
    return RgbaArray__contains_impl(tmp, element instanceof RGBA ? element._value_17 : THROW_CCE());
  }
  function RgbaArray__containsAll_impl(this_0, elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_53();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37()._value_17;
        if (!RgbaArray__contains_impl(this_0, element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  }
  function RgbaArray__containsAll_impl_0(this_0, elements) {
    return RgbaArray__containsAll_impl(this_0._ints, elements);
  }
  function RgbaArray__isEmpty_impl(this_0) {
    var tmp0_isEmpty_0 = _RgbaArray___get_ints__impl_(this_0);
    return tmp0_isEmpty_0.length === 0;
  }
  function RgbaArray__iterator_impl(this_0) {
    return RgbaArray__listIterator_impl(this_0, 0);
  }
  function RgbaArray__listIterator_impl(this_0, index) {
    return new GenericListIterator(new RgbaArray(this_0), index);
  }
  function _RgbaArray___get_size__impl_(this_0) {
    return _RgbaArray___get_ints__impl_(this_0).length;
  }
  function RgbaArray__get_impl(this_0, index) {
    return _RGBA___init__impl_(_RgbaArray___get_ints__impl_(this_0)[index]);
  }
  function RgbaArray__get_impl_0(this_0, index) {
    return new RGBA(RgbaArray__get_impl(this_0._ints, index));
  }
  function RgbaArray__set_impl(this_0, index, color_0) {
    return _RgbaArray___get_ints__impl_(this_0)[index] = _RGBA___get_value__impl_(color_0);
  }
  function RgbaArray__fill_impl(this_0, value, start, end) {
    var tmp0_fill_0 = _RgbaArray___get_ints__impl_(this_0);
    var tmp1_fill_0 = _RGBA___get_value__impl_(value);
    return fill_0(tmp0_fill_0, tmp1_fill_0, start, end);
  }
  function RgbaArray__fill$default_impl(this_0, value, start, end, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      start = 0;
    if (!(($mask0 & 4) === 0))
      end = _RgbaArray___get_size__impl_(this_0);
    return RgbaArray__fill_impl(this_0, value, start, end);
  }
  function RgbaArray__toString_impl(this_0) {
    return '' + 'RgbaArray(' + _RgbaArray___get_size__impl_(this_0) + ')';
  }
  function RgbaArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function RgbaArray__equals_impl(this_0, other) {
    if (!(other instanceof RgbaArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RgbaArray ? other._ints : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function RgbaArray(ints) {
    Companion_getInstance_105();
    this._ints = ints;
  }
  RgbaArray.prototype.contains_57 = function (element) {
    return RgbaArray__contains_impl(this._ints, element);
  };
  RgbaArray.prototype.contains_58 = function (element) {
    return RgbaArray__contains_impl_0(this, element);
  };
  RgbaArray.prototype.containsAll_48 = function (elements) {
    return RgbaArray__containsAll_impl(this._ints, elements);
  };
  RgbaArray.prototype.containsAll_49 = function (elements) {
    return RgbaArray__containsAll_impl_0(this, elements);
  };
  RgbaArray.prototype.isEmpty_53 = function () {
    return RgbaArray__isEmpty_impl(this._ints);
  };
  RgbaArray.prototype.iterator_67 = function () {
    return RgbaArray__iterator_impl(this._ints);
  };
  RgbaArray.prototype.listIterator_6 = function (index) {
    return RgbaArray__listIterator_impl(this._ints, index);
  };
  RgbaArray.prototype._get_size__60 = function () {
    return _RgbaArray___get_size__impl_(this._ints);
  };
  RgbaArray.prototype.get_93 = function (index) {
    return RgbaArray__get_impl(this._ints, index);
  };
  RgbaArray.prototype.get_137 = function (index) {
    return RgbaArray__get_impl_0(this, index);
  };
  RgbaArray.prototype.toString = function () {
    return RgbaArray__toString_impl(this._ints);
  };
  RgbaArray.prototype.hashCode = function () {
    return RgbaArray__hashCode_impl(this._ints);
  };
  RgbaArray.prototype.equals = function (other) {
    return RgbaArray__equals_impl(this._ints, other);
  };
  RgbaArray.$metadata$ = {
    simpleName: 'RgbaArray',
    kind: 'class',
    interfaces: [List]
  };
  function _RGBAPremultiplied___init__impl_(value) {
    return value;
  }
  function _RGBAPremultiplied___get_value__impl_(this_0) {
    return this_0;
  }
  function _RGBAPremultiplied___init__impl__0(r, g, b, a) {
    var tmp = _RGBAPremultiplied___init__impl_(packIntClamped(r, g, b, a));
    return tmp;
  }
  function _RGBAPremultiplied___get_r__impl_(this_0) {
    return _RGBAPremultiplied___get_value__impl_(this_0) >>> 0 & 255;
  }
  function _RGBAPremultiplied___get_g__impl_(this_0) {
    return _RGBAPremultiplied___get_value__impl_(this_0) >>> 8 & 255;
  }
  function _RGBAPremultiplied___get_b__impl_(this_0) {
    return _RGBAPremultiplied___get_value__impl_(this_0) >>> 16 & 255;
  }
  function _RGBAPremultiplied___get_a__impl_(this_0) {
    return _RGBAPremultiplied___get_value__impl_(this_0) >>> 24 & 255;
  }
  function _RGBAPremultiplied___get_af__impl_(this_0) {
    return _RGBAPremultiplied___get_a__impl_(this_0) / 255.0;
  }
  function _RGBAPremultiplied___get_depremultiplied__impl_(this_0) {
    var A = _RGBAPremultiplied___get_a__impl_(this_0);
    var Af = 255.0 / A;
    var R = numberToInt(_RGBAPremultiplied___get_r__impl_(this_0) * Af);
    var G = numberToInt(_RGBAPremultiplied___get_g__impl_(this_0) * Af);
    var B = numberToInt(_RGBAPremultiplied___get_b__impl_(this_0) * Af);
    return Companion_getInstance_104().invoke_375(R, G, B, A);
  }
  function RGBAPremultiplied__scaled256_impl(this_0, s) {
    var rb = imul(_RGBAPremultiplied___get_value__impl_(this_0) & 16711935, s) >>> 8 & 16711935;
    var g = imul(_RGBAPremultiplied___get_value__impl_(this_0) & 65280, s) >>> 8 & 65280;
    var a = imul(_RGBAPremultiplied___get_value__impl_(this_0) >>> 24, s) >>> 8 << 24;
    return _RGBAPremultiplied___init__impl_(rb | g | a);
  }
  function RGBAPremultiplied__scaled_impl(this_0, alpha) {
    return RGBAPremultiplied__scaled256_impl(this_0, numberToInt(clamp01_0(alpha) * 256));
  }
  function Companion_107() {
    Companion_instance_106 = this;
    this._RB_MASK = 16711935;
    this._GA_MASK = -16711936;
  }
  Companion_107.prototype.blendAlpha = function (dst, src) {
    return _RGBAPremultiplied___init__impl_(sumPacked4MulR(_RGBAPremultiplied___get_value__impl_(src), _RGBAPremultiplied___get_value__impl_(dst), 256 - _RGBAPremultiplied___get_a__impl_(src) | 0));
  };
  Companion_107.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_106;
  function Companion_getInstance_106() {
    if (Companion_instance_106 == null)
      new Companion_107();
    return Companion_instance_106;
  }
  function _RgbaPremultipliedArray___init__impl_(ints) {
    return ints;
  }
  function _RgbaPremultipliedArray___get_ints__impl_(this_0) {
    return this_0;
  }
  function Companion_108() {
    Companion_instance_107 = this;
  }
  Companion_108.prototype.invoke_380 = function (size_1) {
    return _RgbaPremultipliedArray___init__impl_(new Int32Array(size_1));
  };
  Companion_108.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_107;
  function Companion_getInstance_107() {
    if (Companion_instance_107 == null)
      new Companion_108();
    return Companion_instance_107;
  }
  function _RgbaPremultipliedArray___get_size__impl_(this_0) {
    return _RgbaPremultipliedArray___get_ints__impl_(this_0).length;
  }
  function RgbaPremultipliedArray__get_impl(this_0, index) {
    return _RGBAPremultiplied___init__impl_(_RgbaPremultipliedArray___get_ints__impl_(this_0)[index]);
  }
  function RgbaPremultipliedArray__set_impl(this_0, index, color_0) {
    return _RgbaPremultipliedArray___get_ints__impl_(this_0)[index] = _RGBAPremultiplied___get_value__impl_(color_0);
  }
  function RgbaPremultipliedArray__fill_impl(this_0, value, start, end) {
    var tmp0_fill_0 = _RgbaPremultipliedArray___get_ints__impl_(this_0);
    var tmp1_fill_0 = _RGBAPremultiplied___get_value__impl_(value);
    return fill_0(tmp0_fill_0, tmp1_fill_0, start, end);
  }
  function RgbaPremultipliedArray__toString_impl(this_0) {
    return '' + 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl_(this_0) + ')';
  }
  function RgbaPremultipliedArray__hashCode_impl(this_0) {
    return hashCode(this_0);
  }
  function RgbaPremultipliedArray__equals_impl(this_0, other) {
    if (!(other instanceof RgbaPremultipliedArray))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other._ints_0 : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function RgbaPremultipliedArray(ints) {
    Companion_getInstance_107();
    this._ints_0 = ints;
  }
  RgbaPremultipliedArray.prototype.toString = function () {
    return RgbaPremultipliedArray__toString_impl(this._ints_0);
  };
  RgbaPremultipliedArray.prototype.hashCode = function () {
    return RgbaPremultipliedArray__hashCode_impl(this._ints_0);
  };
  RgbaPremultipliedArray.prototype.equals = function (other) {
    return RgbaPremultipliedArray__equals_impl(this._ints_0, other);
  };
  RgbaPremultipliedArray.$metadata$ = {
    simpleName: 'RgbaPremultipliedArray',
    kind: 'class',
    interfaces: []
  };
  function asPremultiplied(_this_) {
    return _RGBAPremultiplied___init__impl_(_RGBA___get_value__impl_(_this_));
  }
  function asNonPremultiplied(_this_) {
    return _RGBA___init__impl_(_RGBAPremultiplied___get_value__impl_(_this_));
  }
  function arraycopy_14(src, srcPos, dst, dstPos, size_1) {
    return arraycopy_4(_RgbaArray___get_ints__impl_(src), srcPos, _RgbaArray___get_ints__impl_(dst), dstPos, size_1);
  }
  function mix(_this_, src) {
    var dst = _this_;
    var srcAf = _RGBAPremultiplied___get_af__impl_(src);
    var oneMSrcAf = 1.0 - srcAf;
    var outA = numberToInt(_RGBAPremultiplied___get_a__impl_(src) + _RGBAPremultiplied___get_a__impl_(dst) * oneMSrcAf);
    var outR = numberToInt(_RGBAPremultiplied___get_r__impl_(src) + _RGBAPremultiplied___get_r__impl_(dst) * oneMSrcAf);
    var outG = numberToInt(_RGBAPremultiplied___get_g__impl_(src) + _RGBAPremultiplied___get_g__impl_(dst) * oneMSrcAf);
    var outB = numberToInt(_RGBAPremultiplied___get_b__impl_(src) + _RGBAPremultiplied___get_b__impl_(dst) * oneMSrcAf);
    return _RGBAPremultiplied___init__impl__0(outR, outG, outB, outA);
  }
  function mix_0(dst, dstX, src, srcX, count_0) {
    return mix_1(dst, dstX, dst, dstX, src, srcX, count_0);
  }
  function mix_1(tgt, tgtX, dst, dstX, src, srcX, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl(tgt, tgtX + n | 0, Companion_getInstance_106().blendAlpha(RgbaPremultipliedArray__get_impl(dst, dstX + n | 0), RgbaPremultipliedArray__get_impl(src, srcX + n | 0)));
      }
       while (inductionVariable < count_0);
  }
  function scale(color_0, colorOffset, alpha, alphaOffset, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var a = clamp01_0(alpha[alphaOffset + n | 0]);
        if (a === 1.0)
          continue;
        RgbaPremultipliedArray__set_impl(color_0, colorOffset + n | 0, RGBAPremultiplied__scaled_impl(RgbaPremultipliedArray__get_impl(color_0, colorOffset + n | 0), a));
      }
       while (inductionVariable < count_0);
  }
  function premultiply(src, srcN, dst, dstN, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl(dst, dstN + n | 0, _RGBA___get_premultiplied__impl_(RgbaArray__get_impl(src, srcN + n | 0)));
      }
       while (inductionVariable < count_0);
  }
  function depremultiply(src, srcN, dst, dstN, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaArray__set_impl(dst, dstN + n | 0, _RGBAPremultiplied___get_depremultiplied__impl_(RgbaPremultipliedArray__get_impl(src, srcN + n | 0)));
      }
       while (inductionVariable < count_0);
  }
  function Companion_109() {
    Companion_instance_108 = this;
  }
  Companion_109.prototype.buildKey = function (f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  };
  Companion_109.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_108;
  function Companion_getInstance_108() {
    if (Companion_instance_108 == null)
      new Companion_109();
    return Companion_instance_108;
  }
  function _no_name_provided__221(this$0) {
    this._this$0_48 = this$0;
  }
  _no_name_provided__221.prototype.invoke_1005 = function () {
    return this._this$0_48._texture_0.extract().toBMP32_5();
  };
  _no_name_provided__221.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BitmapFont_init_$Init$(fontSize, lineHeight, base, glyphs, kernings, atlas, name, $mask0, $marker, $this) {
    if (!(($mask0 & 32) === 0)) {
      var tmp0_safe_receiver = glyphs._get_values__9().iterator_67().next_37();
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._texture_0;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._get_bmpBase__0();
      atlas = tmp2_elvis_lhs == null ? Bitmaps_getInstance()._transparent._get_bmpBase__0() : tmp2_elvis_lhs;
    }if (!(($mask0 & 64) === 0))
      name = 'BitmapFont';
    BitmapFont.call($this, fontSize, lineHeight, base, glyphs, kernings, atlas, name);
    return $this;
  }
  function BitmapFont_init_$Create$(fontSize, lineHeight, base, glyphs, kernings, atlas, name, $mask0, $marker) {
    return BitmapFont_init_$Init$(fontSize, lineHeight, base, glyphs, kernings, atlas, name, $mask0, $marker, Object.create(BitmapFont.prototype));
  }
  function _get_naturalFontMetrics_($this) {
    var tmp0_getValue_0 = $this._naturalFontMetrics$delegate;
    var tmp1_getValue_0 = naturalFontMetrics$factory();
    return tmp0_getValue_0._get_value__10();
  }
  function getTextScale($this, size_1) {
    return size_1 / $this._fontSize_0;
  }
  function Kerning(first_2, second, amount) {
    Companion_getInstance_108();
    this._first_3 = first_2;
    this._second_0 = second;
    this._amount = amount;
  }
  Kerning.$metadata$ = {
    simpleName: 'Kerning',
    kind: 'class',
    interfaces: []
  };
  function Glyph(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this._fontSize = fontSize;
    this._id_3 = id;
    this._texture_0 = texture;
    this._xoffset = xoffset;
    this._yoffset = yoffset;
    this._xadvance = xadvance;
    var tmp = this;
    tmp._bmp$delegate = lazy(_no_name_provided_$factory_186(this));
    this._naturalMetrics = new GlyphMetrics(this._fontSize, true, -1, Companion_getInstance_83().invoke_310(this._xoffset, this._yoffset, this._texture_0._get_width__58(), this._texture_0._get_height__58()), this._xadvance);
  }
  Glyph.prototype._get_bmp_ = function () {
    var tmp0_getValue_0 = this._bmp$delegate;
    var tmp1_getValue_0 = bmp$factory();
    return tmp0_getValue_0._get_value__10();
  };
  Glyph.prototype.toString = function () {
    return '' + 'Glyph(fontSize=' + this._fontSize + ', id=' + this._id_3 + ', texture=' + this._texture_0 + ', xoffset=' + this._xoffset + ', yoffset=' + this._yoffset + ', xadvance=' + this._xadvance + ')';
  };
  Glyph.prototype.hashCode = function () {
    var result = getNumberHashCode(this._fontSize);
    result = imul(result, 31) + this._id_3 | 0;
    result = imul(result, 31) + hashCode(this._texture_0) | 0;
    result = imul(result, 31) + this._xoffset | 0;
    result = imul(result, 31) + this._yoffset | 0;
    result = imul(result, 31) + this._xadvance | 0;
    return result;
  };
  Glyph.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals_1(this._fontSize, tmp0_other_with_cast._fontSize))
      return false;
    if (!(this._id_3 === tmp0_other_with_cast._id_3))
      return false;
    if (!equals_1(this._texture_0, tmp0_other_with_cast._texture_0))
      return false;
    if (!(this._xoffset === tmp0_other_with_cast._xoffset))
      return false;
    if (!(this._yoffset === tmp0_other_with_cast._yoffset))
      return false;
    if (!(this._xadvance === tmp0_other_with_cast._xadvance))
      return false;
    return true;
  };
  Glyph.$metadata$ = {
    simpleName: 'Glyph',
    kind: 'class',
    interfaces: []
  };
  function Companion_110() {
    Companion_instance_109 = this;
  }
  Companion_110.prototype.invoke_382 = function (font, fontSize, chars, fontName, paint, mipmaps_0, effect) {
    var fontSize_0 = numberToDouble(fontSize);
    var fmetrics = font.getFontMetrics$default_0(fontSize_0, null, 2, null);
    var tmp0_map_0 = chars._codePoints;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(tmp0_map_0.length);
    var indexedObject = tmp0_map_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_39(font.getGlyphMetrics$default_0(fontSize_0, item_2_3, null, 4, null));
      Unit_getInstance();
    }
    var glyphMetrics = tmp0_mapTo_0_1;
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(glyphMetrics, 10));
    var tmp0_iterator_1_2 = glyphMetrics.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3_0 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1_0.add_39((item_2_3_0._get_width__58() + 4) * (fmetrics._get_lineHeight__4() + 4));
      Unit_getInstance();
    }
    var requiredArea = toIntCeil(sum(tmp0_mapTo_0_1_0));
    var tmp1_sqrt_0 = requiredArea;
    var requiredAreaSide = toIntCeil(Math.sqrt(tmp1_sqrt_0));
    var tmp = _get_nextPowerOfTwo_(requiredAreaSide);
    var tmp_0 = _get_nextPowerOfTwo_(requiredAreaSide);
    var matlas = MutableAtlas_init_$Create$(tmp, tmp_0, 0, false, 12, null);
    var border = 2;
    var indexedObject_0 = chars._codePoints;
    var inductionVariable_0 = 0;
    var last_2 = indexedObject_0.length;
    while (inductionVariable_0 < last_2) {
      var codePoint = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var result = renderGlyphToBitmap$default(font, fontSize_0, codePoint, paint, true, effect, 1, false, 64, null);
      var tmp_1 = result._bmp_1.toBMP32_5().premultipliedIfRequired();
      matlas.add$default_1(tmp_1, result, null, 4, null);
      Unit_getInstance();
    }
    var fm = first(matlas._entries)._data_38._fmetrics;
    var atlas = matlas._bitmap;
    var tmp_2 = fmetrics._get_lineHeight__4();
    var tmp_3 = fmetrics._top;
    var tmp2_associate_0 = matlas._entries;
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp2_associate_0, 10)), 16);
    var tmp1_associateTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var tmp0_iterator_1_3 = tmp2_associate_0.iterator_67();
    while (tmp0_iterator_1_3.hasNext_33()) {
      var element_2_4 = tmp0_iterator_1_3.next_37();
      var slice_7 = element_2_4._slice;
      var g_8 = first(element_2_4._data_38._glyphs_0);
      var m_9 = g_8._metrics;
      var tmp0_plusAssign_0_5 = to(g_8._codePoint, new Glyph(fontSize_0, g_8._codePoint, slice_7, -border | 0, numberToInt(border - m_9._get_height__58() - m_9._get_top__4()) + numberToInt(fm._ascent) | 0, toIntCeil(m_9._xadvance_0)));
      tmp1_associateTo_0_2.put_18(tmp0_plusAssign_0_5._first, tmp0_plusAssign_0_5._second);
      Unit_getInstance();
    }
    var tmp_4 = toIntMap(tmp1_associateTo_0_2);
    return new BitmapFont(fontSize_0, tmp_2, tmp_3, tmp_4, IntMap_init_$Create$(0, 0.0, 3, null), mipmaps(atlas, mipmaps_0), fontName);
  };
  Companion_110.prototype.invoke$default_3 = function (font, fontSize, chars, fontName, paint, mipmaps_0, effect, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      chars = Companion_getInstance_110()._LATIN_ALL;
    if (!(($mask0 & 8) === 0))
      fontName = font._get_name__50();
    if (!(($mask0 & 16) === 0))
      paint = new RGBA(Colors_getInstance()._WHITE);
    if (!(($mask0 & 32) === 0))
      mipmaps_0 = true;
    if (!(($mask0 & 64) === 0))
      effect = null;
    return this.invoke_382(font, fontSize, chars, fontName, paint, mipmaps_0, effect);
  };
  Companion_110.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_109;
  function Companion_getInstance_109() {
    if (Companion_instance_109 == null)
      new Companion_110();
    return Companion_instance_109;
  }
  function _no_name_provided__222(this$0) {
    this._this$0_49 = this$0;
  }
  _no_name_provided__222.prototype.invoke_1005 = function () {
    var ascent = this._this$0_49._base_4;
    var baseline = 0.0;
    var descent = this._this$0_49._lineHeight - this._this$0_49._base_4;
    var tmp = -descent;
    var tmp_0 = -descent;
    var width_2 = 0.0;
    var tmp0_iterator_3 = this._this$0_49._glyphs._get_values__9().iterator_67();
    while (tmp0_iterator_3.hasNext_33()) {
      var glyph_4 = tmp0_iterator_3.next_37();
      if (!(glyph_4 == null))
        width_2 = max2_6(width_2, glyph_4._texture_0._get_width__58());
    }
    return new FontMetrics(this._this$0_49._fontSize_0, ascent, ascent, baseline, tmp, tmp_0, 0.0, width_2);
  };
  _no_name_provided__222.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__223(this$0) {
    this._this$0_50 = this$0;
  }
  _no_name_provided__223.prototype.invoke_1005 = function () {
    return new Glyph(this._this$0_50._fontSize_0, -1, Bitmaps_getInstance()._transparent, 0, 0, 0);
  };
  _no_name_provided__223.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__224(this$0) {
    this._this$0_51 = this$0;
  }
  _no_name_provided__224.prototype.invoke_1005 = function () {
    var tmp0_elvis_lhs = this._this$0_51._glyphs.get_137(this._this$0_51._glyphs._get_keys__3().iterator_67().next_37());
    return tmp0_elvis_lhs == null ? this._this$0_51._get_dummyGlyph_() : tmp0_elvis_lhs;
  };
  _no_name_provided__224.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__225(this$0) {
    this._this$0_52 = this$0;
  }
  _no_name_provided__225.prototype.invoke_1005 = function () {
    return this._this$0_52._get_anyGlyph_()._texture_0._get_bmpBase__0();
  };
  _no_name_provided__225.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BitmapFont(fontSize, lineHeight, base, glyphs, kernings, atlas, name) {
    Companion_getInstance_109();
    this._fontSize_0 = fontSize;
    this._lineHeight = lineHeight;
    this._base_4 = base;
    this._glyphs = glyphs;
    this._kernings = kernings;
    this._atlas = atlas;
    this._name_19 = name;
    var tmp = this;
    tmp._$$delegate_0_9 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._naturalFontMetrics$delegate = lazy(_no_name_provided_$factory_182(this));
    this._naturalNonExistantGlyphMetrics = new GlyphMetrics(this._fontSize_0, false, 0, Companion_getInstance_83().invoke_1005(), 0.0);
    var tmp_1 = this;
    tmp_1._dummyGlyph$delegate = lazy(_no_name_provided_$factory_183(this));
    var tmp_2 = this;
    tmp_2._anyGlyph$delegate = lazy(_no_name_provided_$factory_184(this));
    var tmp_3 = this;
    tmp_3._baseBmp$delegate = lazy(_no_name_provided_$factory_185(this));
  }
  BitmapFont.prototype._get_name__50 = function () {
    return this._name_19;
  };
  BitmapFont.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_9._extra = _set___;
  };
  BitmapFont.prototype._get_extra__71 = function () {
    return this._$$delegate_0_9._extra;
  };
  BitmapFont.prototype.getOrNull_4 = function () {
    return this;
  };
  BitmapFont.prototype.getFontMetrics_1 = function (size_1, metrics) {
    return metrics.copyFromNewSize(_get_naturalFontMetrics_(this), size_1);
  };
  BitmapFont.prototype.getGlyphMetrics_3 = function (size_1, codePoint, metrics) {
    var tmp0_safe_receiver = this._glyphs.get_137(codePoint);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._naturalMetrics;
    return metrics.copyFromNewSize_0(tmp1_elvis_lhs == null ? this._naturalNonExistantGlyphMetrics : tmp1_elvis_lhs, size_1, codePoint);
  };
  BitmapFont.prototype.getKerning_3 = function (size_1, leftCodePoint, rightCodePoint) {
    var tmp = getTextScale(this, size_1);
    var tmp0_safe_receiver = this.getKerning_6(leftCodePoint, rightCodePoint);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._amount;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver;
    return tmp * (tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs);
  };
  BitmapFont.prototype.renderGlyph_2 = function (ctx, size_1, codePoint, x, y, fill_3, metrics) {
    var scale_1 = getTextScale(this, size_1);
    var tmp0_elvis_lhs = this._glyphs.get_137(codePoint);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var tmp0_takeIf_0 = this.getGlyphMetrics_3(size_1, codePoint, metrics);
    var tmp_0;
    if (tmp0_takeIf_0._existing) {
      tmp_0 = tmp0_takeIf_0;
    } else {
      {
        tmp_0 = null;
      }
    }
    var tmp1_elvis_lhs = tmp_0;
    if (tmp1_elvis_lhs == null)
      return Unit_getInstance();
    else
      tmp1_elvis_lhs;
    Unit_getInstance();
    if (metrics._get_width__58() === 0.0 ? metrics._get_height__58() === 0.0 : false)
      return Unit_getInstance();
    var texX = x + metrics._get_left__4();
    var texY = y + metrics._get_top__4();
    var swidth = metrics._get_width__58();
    var sheight = metrics._get_height__58();
    var tmp_1;
    if (equals_1(ctx._get_fillStyle_(), new RGBA(_get_DefaultPaint_()))) {
      tmp_1 = g._get_bmp_();
    } else {
      var tmp_2 = g._get_bmp_()._get_width__58();
      var tmp_3 = g._get_bmp_()._get_height__58();
      var tmp1_context2d_0 = Bitmap32_init_$Create$(tmp_2, tmp_3, null, false, 12, null);
      var tmp2_context2d_0 = true;
      var tmp0_lock_0_1 = null;
      tmp1_context2d_0.lock_5();
      try {
        var ctx_2_2 = tmp1_context2d_0.getContext2d_5(tmp2_context2d_0);
        try {
          var t_1_4 = ctx_2_2._state_4._transform_6;
          var a_2_5 = t_1_4._a;
          var b_3_6 = t_1_4._b;
          var c_4_7 = t_1_4._c;
          var d_5_8 = t_1_4._d;
          var tx_6_9 = t_1_4._tx;
          var ty_7_10 = t_1_4._ty;
          try {
            var tmp_4 = 1.0 / scale_1;
            ctx_2_2.scale$default(tmp_4, 0.0, 2, null);
            Unit_getInstance();
            ctx_2_2._set_fillStyle_(ctx._get_fillStyle_());
            var tmp0_fillRect_0_9_11 = 0;
            var tmp1_fillRect_0_10_12 = 0;
            var tmp2_fillRect_0_11_13 = ctx_2_2._get_width__58() * scale_1;
            var tmp3_fillRect_0_12_14 = ctx_2_2._get_height__58() * scale_1;
            ctx_2_2.fillRect_0(numberToDouble(tmp0_fillRect_0_9_11), numberToDouble(tmp1_fillRect_0_10_12), numberToDouble(tmp2_fillRect_0_11_13), numberToDouble(tmp3_fillRect_0_12_14));
          }finally {
            t_1_4.setTo(a_2_5, b_3_6, c_4_7, d_5_8, tx_6_9, ty_7_10);
            Unit_getInstance();
          }
        }finally {
          ctx_2_2.dispose_18();
        }
      }finally {
        tmp1_context2d_0.unlock_5(tmp0_lock_0_1);
        Unit_getInstance();
      }
      var bmpFill = tmp1_context2d_0;
      bmpFill.writeChannel(BitmapChannel_ALPHA_getInstance(), g._get_bmp_(), BitmapChannel_ALPHA_getInstance());
      tmp_1 = bmpFill;
    }
    var bmp = tmp_1;
    ctx.drawImage_1(bmp, texX, texY - metrics._get_height__58(), swidth, sheight);
  };
  BitmapFont.prototype.getKerning_6 = function (first_2, second) {
    return this._kernings.get_137(Companion_getInstance_108().buildKey(first_2, second));
  };
  BitmapFont.prototype._get_dummyGlyph_ = function () {
    var tmp0_getValue_0 = this._dummyGlyph$delegate;
    var tmp1_getValue_0 = dummyGlyph$factory();
    return tmp0_getValue_0._get_value__10();
  };
  BitmapFont.prototype._get_anyGlyph_ = function () {
    var tmp0_getValue_0 = this._anyGlyph$delegate;
    var tmp1_getValue_0 = anyGlyph$factory();
    return tmp0_getValue_0._get_value__10();
  };
  BitmapFont.prototype.get_137 = function (charCode) {
    var tmp0_elvis_lhs = this._glyphs.get_137(charCode);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this._glyphs.get_137(32) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? this._get_dummyGlyph_() : tmp1_elvis_lhs;
  };
  BitmapFont.$metadata$ = {
    simpleName: 'BitmapFont',
    kind: 'class',
    interfaces: [Font, Extra]
  };
  function readBitmapFont(_this_, imageFormat, mipmaps_0, $cont) {
    var tmp = new $readBitmapFontCOROUTINE$1(_this_, imageFormat, mipmaps_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readBitmapFontXml(content, fntFile, textures, imageFormat, mipmaps_0, $cont) {
    var tmp = new $readBitmapFontXmlCOROUTINE$2(content, fntFile, textures, imageFormat, mipmaps_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readBitmapFontTxt(content, fntFile, textures, imageFormat, mipmaps_0, $cont) {
    var tmp = new $readBitmapFontTxtCOROUTINE$3(content, fntFile, textures, imageFormat, mipmaps_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function _no_name_provided__226() {
  }
  _no_name_provided__226.prototype.invoke_387 = function (_anonymous_parameter_0_, it) {
    return Companion_getInstance_108().buildKey(it._first_3, it._second_0);
  };
  _no_name_provided__226.prototype.invoke_925 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_387(tmp, p2 instanceof Kerning ? p2 : THROW_CCE());
  };
  _no_name_provided__226.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $readBitmapFontCOROUTINE$1(_this_, imageFormat, mipmaps_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__122 = _this_;
    this._imageFormat = imageFormat;
    this._mipmaps_0 = mipmaps_0;
  }
  $readBitmapFontCOROUTINE$1.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._fntFile0 = this.__this__122;
            this._state_1 = 1;
            suspendResult = this._fntFile0.readString$default(null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_trim_01 = suspendResult;
            var tmp_0 = this;
            var tmp_1 = this._tmp0_trim_01;
            tmp_0._content2 = toString_1(trim_0(isCharSequence(tmp_1) ? tmp_1 : THROW_CCE()));
            var tmp_2 = this;
            tmp_2._textures3 = HashMap_init_$Create$();
            var tmp_3 = new Char(60);
            if (startsWith$default(this._content2, tmp_3, false, 2, null)) {
              this._state_1 = 3;
              suspendResult = readBitmapFontXml(this._content2, this._fntFile0, this._textures3, this._imageFormat, this._mipmaps_0, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                if (startsWith$default_1(this._content2, 'info', false, 2, null)) {
                  this._state_1 = 2;
                  suspendResult = readBitmapFontTxt(this._content2, this._fntFile0, this._textures3, this._imageFormat, this._mipmaps_0, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  {
                    var tmp_4 = this;
                    var tmp1_TODO_0 = '' + 'Unsupported font type starting with ' + substr_0(this._content2, 0, 16);
                    throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp1_TODO_0);
                  }
                }
                Unit_getInstance();
              }
            }

            break;
          case 2:
            this._WHEN_RESULT4 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._WHEN_RESULT4 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            return this._WHEN_RESULT4;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapFontCOROUTINE$1.$metadata$ = {
    simpleName: '$readBitmapFontCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function $readBitmapFontXmlCOROUTINE$2(content, fntFile, textures, imageFormat, mipmaps_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._content_5 = content;
    this._fntFile = fntFile;
    this._textures = textures;
    this._imageFormat_0 = imageFormat;
    this._mipmaps_1 = mipmaps_0;
  }
  $readBitmapFontXmlCOROUTINE$2.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._xml0 = Xml_0(this._content_5);
            var tmp_0 = this;
            var tmp0_safe_receiver = firstOrNull_0(this._xml0.get_115('info'));
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.double('size', 16.0);
            tmp_0._fontSize1 = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
            var tmp_1 = this;
            var tmp2_safe_receiver = firstOrNull_0(this._xml0.get_115('common'));
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.double('lineHeight', 16.0);
            tmp_1._lineHeight2 = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
            var tmp_2 = this;
            var tmp4_safe_receiver = firstOrNull_0(this._xml0.get_115('common'));
            var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.double('base', 16.0);
            tmp_2._base3 = tmp5_elvis_lhs == null ? 16.0 : tmp5_elvis_lhs;
            this._tmp6_iterator4 = get_0(this._xml0.get_115('pages'), 'page').iterator_67();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp6_iterator4.hasNext_33()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._page5 = this._tmp6_iterator4.next_37();
            var tmp_3 = this;
            tmp_3._id6 = this._page5.int$default('id', 0, 2, null);
            var tmp_4 = this;
            tmp_4._file7 = this._page5.str$default('file', null, 2, null);
            this._texFile8 = this._fntFile._get_parent__14().get_115(this._file7);
            this._state_1 = 2;
            suspendResult = readBitmap$default(this._texFile8, this._imageFormat_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = mipmaps(ARGUMENT, this._mipmaps_1);
            var tex = slice$default(ARGUMENT_0, null, null, 3, null);
            this._textures.put_18(this._id6, tex);
            Unit_getInstance();
            this._state_1 = 1;
            continue $sm;
          case 3:
            var tmp0_map_0 = get_0(this._xml0.get_115('chars'), 'char');
            var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
            var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
            while (tmp0_iterator_1_2.hasNext_33()) {
              var item_2_3 = tmp0_iterator_1_2.next_37();
              var page_5 = item_2_3.int$default('page', 0, 2, null);
              var tmp0_elvis_lhs_7 = this._textures.get_116(page_5);
              var texture_6 = tmp0_elvis_lhs_7 == null ? first_0(this._textures._get_values__9()) : tmp0_elvis_lhs_7;
              var tmp_5 = item_2_3.int$default('id', 0, 2, null);
              var tmp_6 = item_2_3.int$default('x', 0, 2, null);
              var tmp_7 = item_2_3.int$default('y', 0, 2, null);
              var tmp_8 = item_2_3.int$default('width', 0, 2, null);
              var tmp_9 = item_2_3.int$default('height', 0, 2, null);
              var tmp_10 = texture_6.sliceWithSize$default(tmp_6, tmp_7, tmp_8, tmp_9, null, 16, null);
              var tmp_11 = item_2_3.int$default('xoffset', 0, 2, null);
              var tmp_12 = item_2_3.int$default('yoffset', 0, 2, null);
              tmp0_mapTo_0_1.add_39(new Glyph(this._fontSize1, tmp_5, tmp_10, tmp_11, tmp_12, item_2_3.int$default('xadvance', 0, 2, null)));
              Unit_getInstance();
            }

            var glyphs = tmp0_mapTo_0_1;
            var tmp1_map_0 = get_0(this._xml0.get_115('kernings'), 'kerning');
            var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
            var tmp0_iterator_1_2_0 = tmp1_map_0.iterator_67();
            while (tmp0_iterator_1_2_0.hasNext_33()) {
              var item_2_3_0 = tmp0_iterator_1_2_0.next_37();
              var tmp_13 = item_2_3_0.int$default('first', 0, 2, null);
              var tmp_14 = item_2_3_0.int$default('second', 0, 2, null);
              tmp0_mapTo_0_1_0.add_39(new Kerning(tmp_13, tmp_14, item_2_3_0.int$default('amount', 0, 2, null)));
              Unit_getInstance();
            }

            var kernings = tmp0_mapTo_0_1_0;
            var tmp7_atlas = first_0(this._textures._get_values__9())._get_bmpBase__0();
            var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(glyphs, 10));
            var tmp0_iterator_1_2_1 = glyphs.iterator_67();
            while (tmp0_iterator_1_2_1.hasNext_33()) {
              var item_2_3_1 = tmp0_iterator_1_2_1.next_37();
              tmp0_mapTo_0_1_1.add_39(to(item_2_3_1._id_3, item_2_3_1));
              Unit_getInstance();
            }

            var tmp8_glyphs = toIntMap(toMap_0(tmp0_mapTo_0_1_1));
            var tmp0_mapTo_0_1_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(kernings, 10));
            var tmp0_iterator_1_2_2 = kernings.iterator_67();
            while (tmp0_iterator_1_2_2.hasNext_33()) {
              var item_2_3_2 = tmp0_iterator_1_2_2.next_37();
              tmp0_mapTo_0_1_2.add_39(to(Companion_getInstance_108().buildKey(item_2_3_2._first_3, item_2_3_2._second_0), item_2_3_2));
              Unit_getInstance();
            }

            var tmp9_kernings = toIntMap(toMap_0(tmp0_mapTo_0_1_2));
            return BitmapFont_init_$Create$(this._fontSize1, this._lineHeight2, this._base3, tmp8_glyphs, tmp9_kernings, tmp7_atlas, null, 64, null);
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapFontXmlCOROUTINE$2.$metadata$ = {
    simpleName: '$readBitmapFontXmlCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function $readBitmapFontTxtCOROUTINE$3(content, fntFile, textures, imageFormat, mipmaps_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._content_6 = content;
    this._fntFile_0 = fntFile;
    this._textures_0 = textures;
    this._imageFormat_1 = imageFormat;
    this._mipmaps_2 = mipmaps_0;
  }
  $readBitmapFontTxtCOROUTINE$3.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            var tmp_0 = this;
            tmp_0._kernings0 = ArrayList_init_$Create$();
            var tmp_1 = this;
            tmp_1._glyphs1 = ArrayList_init_$Create$();
            this._lineHeight2_0 = 16.0;
            this._fontSize3 = 16.0;
            this._base4 = null;
            this._tmp0_iterator5 = lines(this._content_6).iterator_67();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator5.hasNext_33()) {
              this._state_1 = 4;
              continue $sm;
            }
            this._rline6 = this._tmp0_iterator5.next_37();
            var tmp_2 = this;
            var tmp_3 = this._rline6;
            tmp_2._line7 = toString_1(trim_0(isCharSequence(tmp_3) ? tmp_3 : THROW_CCE()));
            this._map8 = LinkedHashMap_init_$Create$();
            var tmp_4 = charArrayOf([new Char(32)]);
            var tmp1_iterator = split$default(this._line7, tmp_4, false, 0, 6, null).iterator_67();
            while (tmp1_iterator.hasNext_33()) {
              var part = tmp1_iterator.next_37();
              var tmp_5 = charArrayOf([new Char(61)]);
              var tmp2_container = plus(split$default(part, tmp_5, false, 0, 6, null), listOf(['', '']));
              var key = tmp2_container.get_137(0);
              var value = tmp2_container.get_137(1);
              this._map8.put_18(key, value);
              Unit_getInstance();
            }

            if (startsWith$default_1(this._line7, 'info', false, 2, null)) {
              var tmp_6 = this;
              var tmp3_safe_receiver = this._map8.get_116('size');
              var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toDouble(tmp3_safe_receiver);
              tmp_6._fontSize3 = tmp4_elvis_lhs == null ? 16.0 : tmp4_elvis_lhs;
              this._state_1 = 3;
              continue $sm;
            } else {
              {
                if (startsWith$default_1(this._line7, 'page', false, 2, null)) {
                  var tmp_7 = this;
                  var tmp5_safe_receiver = this._map8.get_116('id');
                  var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : toInt(tmp5_safe_receiver);
                  tmp_7._id9 = tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs;
                  var tmp_8 = this;
                  var tmp7_safe_receiver = this._map8.get_116('file');
                  var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : unquote(tmp7_safe_receiver);
                  var tmp_9;
                  if (tmp8_elvis_lhs == null) {
                    var tmp0_error_0 = 'page without file';
                    throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
                  } else {
                    tmp_9 = tmp8_elvis_lhs;
                  }
                  tmp_8._file10 = tmp_9;
                  this._state_1 = 2;
                  var tmp_10 = this._fntFile_0._get_parent__14().get_115(this._file10);
                  suspendResult = readBitmap$default(tmp_10, this._imageFormat_1, null, 2, null, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  {
                    if (startsWith$default_1(this._line7, 'common ', false, 2, null)) {
                      var tmp_11 = this;
                      var tmp9_safe_receiver = this._map8.get_116('lineHeight');
                      var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : toDoubleOrNull(tmp9_safe_receiver);
                      tmp_11._lineHeight2_0 = tmp10_elvis_lhs == null ? 16.0 : tmp10_elvis_lhs;
                      var tmp_12 = this;
                      var tmp11_safe_receiver = this._map8.get_116('base');
                      tmp_12._base4 = tmp11_safe_receiver == null ? null : toDoubleOrNull(tmp11_safe_receiver);
                      this._state_1 = 3;
                      continue $sm;
                    } else {
                      {
                        if (startsWith$default_1(this._line7, 'char ', false, 2, null)) {
                          var tmp12_safe_receiver = this._map8.get_116('page');
                          var tmp13_elvis_lhs = tmp12_safe_receiver == null ? null : toIntOrNull(tmp12_safe_receiver);
                          var page = tmp13_elvis_lhs == null ? 0 : tmp13_elvis_lhs;
                          var tmp14_elvis_lhs = this._textures_0.get_116(page);
                          var texture = tmp14_elvis_lhs == null ? first_0(this._textures_0._get_values__9()) : tmp14_elvis_lhs;
                          var tmp2_invoke_0 = Companion_getInstance_46();
                          var tmp3__anonymous__1 = Companion_getInstance_46();
                          var id_2 = tmp3__anonymous__1._get_int__1(this._map8.get_116('id'));
                          var tmp0_xoffset_3 = tmp3__anonymous__1._get_int__1(this._map8.get_116('xoffset'));
                          var tmp1_yoffset_4 = tmp3__anonymous__1._get_int__1(this._map8.get_116('yoffset'));
                          var tmp2_xadvance_5 = tmp3__anonymous__1._get_int__1(this._map8.get_116('xadvance'));
                          var tmp3_texture_6 = texture.sliceWithSize_0(tmp3__anonymous__1._get_int__1(this._map8.get_116('x')), tmp3__anonymous__1._get_int__1(this._map8.get_116('y')), tmp3__anonymous__1._get_int__1(this._map8.get_116('width')), tmp3__anonymous__1._get_int__1(this._map8.get_116('height')), '' + 'glyph-' + numberToChar(id_2));
                          var tmp4_plusAssign_0 = new Glyph(this._fontSize3, id_2, tmp3_texture_6, tmp0_xoffset_3, tmp1_yoffset_4, tmp2_xadvance_5);
                          this._glyphs1.add_39(tmp4_plusAssign_0);
                          Unit_getInstance();
                          this._state_1 = 3;
                          continue $sm;
                        } else {
                          {
                            if (startsWith$default_1(this._line7, 'kerning ', false, 2, null)) {
                              var tmp15_safe_receiver = this._map8.get_116('first');
                              var tmp16_elvis_lhs = tmp15_safe_receiver == null ? null : toIntOrNull(tmp15_safe_receiver);
                              var tmp_13 = tmp16_elvis_lhs == null ? 0 : tmp16_elvis_lhs;
                              var tmp17_safe_receiver = this._map8.get_116('second');
                              var tmp18_elvis_lhs = tmp17_safe_receiver == null ? null : toIntOrNull(tmp17_safe_receiver);
                              var tmp_14 = tmp18_elvis_lhs == null ? 0 : tmp18_elvis_lhs;
                              var tmp19_safe_receiver = this._map8.get_116('amount');
                              var tmp20_elvis_lhs = tmp19_safe_receiver == null ? null : toIntOrNull(tmp19_safe_receiver);
                              var tmp5_plusAssign_0 = new Kerning(tmp_13, tmp_14, tmp20_elvis_lhs == null ? 0 : tmp20_elvis_lhs);
                              this._kernings0.add_39(tmp5_plusAssign_0);
                              Unit_getInstance();
                              this._state_1 = 3;
                              continue $sm;
                            } else {
                              {
                                this._state_1 = 3;
                                continue $sm;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            break;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = mipmaps(ARGUMENT, this._mipmaps_2);
            var tmp1_set_0 = slice$default(ARGUMENT_0, null, null, 3, null);
            this._textures_0.put_18(this._id9, tmp1_set_0);
            Unit_getInstance();
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._state_1 = 1;
            continue $sm;
          case 4:
            var tmp22_atlas = first_0(this._textures_0._get_values__9())._get_bmpBase__0();
            var tmp21_elvis_lhs = this._base4;
            var tmp23_base = tmp21_elvis_lhs == null ? this._lineHeight2_0 : tmp21_elvis_lhs;
            var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._glyphs1, 10));
            var tmp0_iterator_1_2 = this._glyphs1.iterator_67();
            while (tmp0_iterator_1_2.hasNext_33()) {
              var item_2_3 = tmp0_iterator_1_2.next_37();
              tmp0_mapTo_0_1.add_39(to(item_2_3._id_3, item_2_3));
              Unit_getInstance();
            }

            var tmp24_glyphs = toIntMap(toMap_0(tmp0_mapTo_0_1));
            var tmp25_kernings = associateByInt(this._kernings0, _no_name_provided_$factory_187());
            var tmp_15 = this._fontSize3;
            var tmp_16 = this._lineHeight2_0;
            return BitmapFont_init_$Create$(tmp_15, tmp_16, tmp23_base, tmp24_glyphs, tmp25_kernings, tmp22_atlas, null, 64, null);
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapFontTxtCOROUTINE$3.$metadata$ = {
    simpleName: '$readBitmapFontTxtCOROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function naturalFontMetrics$factory() {
    return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
      return _get_naturalFontMetrics_(receiver);
    }, null);
  }
  function bmp$factory() {
    return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
      return receiver._get_bmp_();
    }, null);
  }
  function dummyGlyph$factory() {
    return getPropertyCallableRef('dummyGlyph', 1, KProperty1, function (receiver) {
      return receiver._get_dummyGlyph_();
    }, null);
  }
  function anyGlyph$factory() {
    return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
      return receiver._get_anyGlyph_();
    }, null);
  }
  function _no_name_provided_$factory_182(this$0) {
    var i = new _no_name_provided__222(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_183(this$0) {
    var i = new _no_name_provided__223(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_184(this$0) {
    var i = new _no_name_provided__224(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_185(this$0) {
    var i = new _no_name_provided__225(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_186(this$0) {
    var i = new _no_name_provided__221(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_187() {
    var i = new _no_name_provided__226();
    return function (p1, p2) {
      return i.invoke_387(p1, p2);
    };
  }
  function CharacterSet_init_$Init$(chars, $this) {
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(charSequenceLength(chars));
    var indexedObject = chars;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_mapTo_0_1.add_39(item_2_3.toInt_8());
      Unit_getInstance();
    }
    CharacterSet.call($this, toIntArray(tmp0_mapTo_0_1));
    return $this;
  }
  function CharacterSet_init_$Create$(chars) {
    return CharacterSet_init_$Init$(chars, Object.create(CharacterSet.prototype));
  }
  function Companion_111() {
    Companion_instance_110 = this;
    this._SPACE = CharacterSet_init_$Create$(' ');
    var tmp = this;
    var tmp_0 = (new Char(65)).rangeTo(new Char(90));
    tmp._UPPERCASE = CharacterSet_init_$Create$(joinToString$default_0(tmp_0, '', null, null, 0, null, null, 62, null));
    var tmp_1 = this;
    var tmp_2 = (new Char(97)).rangeTo(new Char(122));
    tmp_1._LOWERCASE = CharacterSet_init_$Create$(joinToString$default_0(tmp_2, '', null, null, 0, null, null, 62, null));
    var tmp_3 = this;
    var tmp_4 = (new Char(48)).rangeTo(new Char(57));
    tmp_3._NUMBERS = CharacterSet_init_$Create$(joinToString$default_0(tmp_4, '', null, null, 0, null, null, 62, null));
    this._PUNCTUATION = CharacterSet_init_$Create$('!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}');
    this._LATIN_BASIC = CharacterSet_init_$Create$('\xE7\xC7 \xF1\xD1 \xE5\xC5 \xE6\xC6 \xFF \xA2\xA3\xA5P\xAA\xB0\xBF\xAC\xBD\xBC\xA1\xAB\xBB\xDF\xB5\xF8\xB1\xF7\xB0\xB7.\xB2 \xE1\xE9\xED\xF3\xFA\xE4\xEB\xEF\xF6\xFC\xE0\xE8\xEC\xF2\xF9\xE2\xEA\xEE\xF4\xFB \xC1\xC9\xCD\xD3\xDA\xC4\xCB\xCF\xD6\xDC\xC0\xC8\xCC\xD2\xD9\xC2\xCA\xCE\xD4\xDB');
    this._LATIN_ALL = this._SPACE.plus_30(this._UPPERCASE).plus_30(this._LOWERCASE).plus_30(this._NUMBERS).plus_30(this._PUNCTUATION).plus_30(this._LATIN_BASIC);
  }
  Companion_111.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_110;
  function Companion_getInstance_110() {
    if (Companion_instance_110 == null)
      new Companion_111();
    return Companion_instance_110;
  }
  function CharacterSet(codePoints) {
    Companion_getInstance_110();
    this._codePoints = codePoints;
  }
  CharacterSet.prototype.plus_30 = function (other) {
    var tmp0_plus_0 = this._codePoints;
    var tmp1_plus_0 = other._codePoints;
    return new CharacterSet(primitiveArrayConcat([tmp0_plus_0, tmp1_plus_0]));
  };
  CharacterSet.$metadata$ = {
    simpleName: 'CharacterSet',
    kind: 'class',
    interfaces: []
  };
  var DefaultTtfFontBytes;
  function _get_DefaultTtfFont_() {
    var tmp0_getValue_0 = DefaultTtfFont$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = DefaultTtfFont$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var DefaultTtfFont$delegate;
  function _no_name_provided__227() {
  }
  _no_name_provided__227.prototype.invoke_1005 = function () {
    var start_1 = PerformanceCounter_getInstance()._get_microseconds_();
    var result_2 = TtfFont_init_$Create$(DefaultTtfFontBytes, true, 'Default Font');
    var end_3 = PerformanceCounter_getInstance()._get_microseconds_();
    var tmp0__get_microseconds__0_5 = end_3 - start_1;
    var elapsed_4 = Companion_getInstance_27().fromMicroseconds(tmp0__get_microseconds__0_5);
    var res = new TimedResult(result_2, elapsed_4);
    return res._result_1;
  };
  _no_name_provided__227.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function DefaultTtfFont$factory() {
    return getPropertyCallableRef('DefaultTtfFont', 0, KProperty0, function () {
      return _get_DefaultTtfFont_();
    }, null);
  }
  function _no_name_provided_$factory_188() {
    var i = new _no_name_provided__227();
    return function () {
      return i.invoke_1005();
    };
  }
  function DefaultTtfFontBytes$init$() {
    var tmp = fromBase64$default('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', false, 1, null);
    var tmp_0 = Companion_getInstance_42();
    return uncompress$default(tmp, tmp_0, 0, 2, null);
  }
  function Font() {
  }
  Font.prototype.getOrNull_4 = function () {
    return this;
  };
  Font.prototype.getFontMetrics$default_0 = function (size_1, metrics, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      metrics = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
    }return $handler == null ? this.getFontMetrics_1(size_1, metrics) : $handler(size_1, metrics);
  };
  Font.prototype.getGlyphMetrics$default_0 = function (size_1, codePoint, metrics, $mask0, $handler) {
    if (!(($mask0 & 4) === 0)) {
      metrics = GlyphMetrics_init_$Create$(0.0, false, 0, null, 0.0, 31, null);
    }return $handler == null ? this.getGlyphMetrics_3(size_1, codePoint, metrics) : $handler(size_1, codePoint, metrics);
  };
  Font.$metadata$ = {
    simpleName: 'Font',
    kind: 'interface',
    interfaces: [Resourceable]
  };
  function drawText(_this_, ctx, size_1, text, paint, x, y, fill_3, renderer, placed) {
    var actions = new _no_name_provided__228(ctx, x, y, paint, size_1, placed, fill_3);
    renderer.invoke_409(actions, text, size_1, _this_);
  }
  function getTextBounds(_this_, size_1, text, out, renderer) {
    var actions = new BoundBuilderTextRendererActions();
    renderer.invoke_409(actions, text, size_1, _this_);
    actions._bb.getBounds_0(out._bounds_2);
    Unit_getInstance();
    actions._flbb.getBounds_0(out._firstLineBounds);
    Unit_getInstance();
    out._nlines = actions._get_nlines_();
    _this_.getFontMetrics_1(size_1, out._fontMetrics);
    Unit_getInstance();
    return out;
  }
  function getTextBounds$default(_this_, size_1, text, out, renderer, $mask0, $handler) {
    if (!(($mask0 & 4) === 0)) {
      out = TextMetrics_init_$Create$(null, null, null, 0, 15, null);
    }if (!(($mask0 & 8) === 0)) {
      var tmp = DefaultStringTextRenderer;
      renderer = isInterface(tmp, TextRenderer) ? tmp : THROW_CCE();
    }return getTextBounds(_this_, size_1, text, out, renderer);
  }
  function PlacedGlyph(codePoint, x, y, metrics, transform) {
    this._codePoint = codePoint;
    this._x_5 = x;
    this._y_4 = y;
    this._metrics = metrics;
    this._transform_0 = transform;
  }
  PlacedGlyph.prototype.toString = function () {
    return '' + 'PlacedGlyph(codePoint=' + this._codePoint + ', x=' + this._x_5 + ', y=' + this._y_4 + ', metrics=' + this._metrics + ', transform=' + this._transform_0 + ')';
  };
  PlacedGlyph.prototype.hashCode = function () {
    var result = this._codePoint;
    result = imul(result, 31) + getNumberHashCode(this._x_5) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y_4) | 0;
    result = imul(result, 31) + this._metrics.hashCode() | 0;
    result = imul(result, 31) + this._transform_0.hashCode() | 0;
    return result;
  };
  PlacedGlyph.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyph))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PlacedGlyph ? other : THROW_CCE();
    if (!(this._codePoint === tmp0_other_with_cast._codePoint))
      return false;
    if (!equals_1(this._x_5, tmp0_other_with_cast._x_5))
      return false;
    if (!equals_1(this._y_4, tmp0_other_with_cast._y_4))
      return false;
    if (!this._metrics.equals(tmp0_other_with_cast._metrics))
      return false;
    if (!this._transform_0.equals(tmp0_other_with_cast._transform_0))
      return false;
    return true;
  };
  PlacedGlyph.$metadata$ = {
    simpleName: 'PlacedGlyph',
    kind: 'class',
    interfaces: []
  };
  function TextToBitmapResult(bmp, fmetrics, metrics, glyphs) {
    this._bmp_1 = bmp;
    this._fmetrics = fmetrics;
    this._metrics_0 = metrics;
    this._glyphs_0 = glyphs;
  }
  TextToBitmapResult.prototype.toString = function () {
    return '' + 'TextToBitmapResult(bmp=' + this._bmp_1 + ', fmetrics=' + this._fmetrics + ', metrics=' + this._metrics_0 + ', glyphs=' + this._glyphs_0 + ')';
  };
  TextToBitmapResult.prototype.hashCode = function () {
    var result = hashCode(this._bmp_1);
    result = imul(result, 31) + this._fmetrics.hashCode() | 0;
    result = imul(result, 31) + this._metrics_0.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._glyphs_0) | 0;
    return result;
  };
  TextToBitmapResult.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals_1(this._bmp_1, tmp0_other_with_cast._bmp_1))
      return false;
    if (!this._fmetrics.equals(tmp0_other_with_cast._fmetrics))
      return false;
    if (!this._metrics_0.equals(tmp0_other_with_cast._metrics_0))
      return false;
    if (!equals_1(this._glyphs_0, tmp0_other_with_cast._glyphs_0))
      return false;
    return true;
  };
  TextToBitmapResult.$metadata$ = {
    simpleName: 'TextToBitmapResult',
    kind: 'class',
    interfaces: []
  };
  function renderTextToBitmap(_this_, size_1, text, paint, background, fill_3, border, renderer, returnGlyphs, nativeRendering, drawBorder) {
    var font = _this_;
    var bounds = getTextBounds$default(_this_, size_1, text, null, renderer, 4, null);
    var glyphs = ArrayList_init_$Create$();
    var iwidth = (toIntCeil(bounds._get_width__58()) + imul(border, 2) | 0) + 1 | 0;
    var iheight = (toIntCeil(drawBorder ? bounds._get_allLineHeight_() : bounds._get_height__58()) + imul(border, 2) | 0) + 1 | 0;
    var tmp;
    if (nativeRendering) {
      tmp = NativeImage$default(iwidth, iheight, null, 4, null);
    } else {
      tmp = Bitmap32_init_$Create$(iwidth, iheight, null, true, 4, null);
    }
    var image = tmp;
    var tmp0_context2d_0 = true;
    var tmp0_lock_0_1 = null;
    image.lock_5();
    try {
      var ctx_2_2 = image.getContext2d_5(tmp0_context2d_0);
      try {
        if (!equals_1(background, NonePaint_getInstance())) {
          var oldStyle_1_4 = ctx_2_2._get_fillStyle_();
          ctx_2_2._set_fillStyle_(background);
          try {
            var tmp0_fillRect_0_3_5 = 0;
            var tmp1_fillRect_0_4_6 = 0;
            ctx_2_2.fillRect_0(numberToDouble(tmp0_fillRect_0_3_5), numberToDouble(tmp1_fillRect_0_4_6), numberToDouble(iwidth), numberToDouble(iheight));
          }finally {
            ctx_2_2._set_fillStyle_(oldStyle_1_4);
          }
        }var tmp_0 = bounds._get_drawLeft_();
        var tmp_1 = bounds._get_ascent_();
        drawText(font, ctx_2_2, size_1, text, paint, tmp_0, tmp_1, fill_3, renderer, _no_name_provided_$factory_189(returnGlyphs, glyphs));
      }finally {
        ctx_2_2.dispose_18();
      }
    }finally {
      image.unlock_5(tmp0_lock_0_1);
      Unit_getInstance();
    }
    Unit_getInstance();
    return new TextToBitmapResult(image, bounds._fontMetrics, bounds, glyphs);
  }
  function renderTextToBitmap$default(_this_, size_1, text, paint, background, fill_3, border, renderer, returnGlyphs, nativeRendering, drawBorder, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      paint = new RGBA(_get_DefaultPaint_());
    if (!(($mask0 & 8) === 0))
      background = NonePaint_getInstance();
    if (!(($mask0 & 16) === 0))
      fill_3 = true;
    if (!(($mask0 & 32) === 0))
      border = 0;
    if (!(($mask0 & 64) === 0)) {
      var tmp = DefaultStringTextRenderer;
      renderer = isInterface(tmp, TextRenderer) ? tmp : THROW_CCE();
    }if (!(($mask0 & 128) === 0))
      returnGlyphs = true;
    if (!(($mask0 & 256) === 0))
      nativeRendering = true;
    if (!(($mask0 & 512) === 0))
      drawBorder = false;
    return renderTextToBitmap(_this_, size_1, text, paint, background, fill_3, border, renderer, returnGlyphs, nativeRendering, drawBorder);
  }
  function renderGlyphToBitmap(_this_, size_1, codePoint, paint, fill_3, effect, border, nativeRendering) {
    var font = _this_;
    var fmetrics = _this_.getFontMetrics$default_0(size_1, null, 2, null);
    var gmetrics = _this_.getGlyphMetrics$default_0(size_1, codePoint, null, 4, null);
    var gx = -gmetrics._get_left__4();
    var gy = gmetrics._get_height__58() + gmetrics._get_top__4();
    var border2 = imul(border, 2);
    var iwidth = toIntCeil(gmetrics._get_width__58()) + border2 | 0;
    var iheight = toIntCeil(gmetrics._get_height__58()) + border2 | 0;
    var tmp;
    if (nativeRendering) {
      tmp = NativeImage$default(iwidth, iheight, null, 4, null);
    } else {
      tmp = Bitmap32_init_$Create$(iwidth, iheight, null, true, 4, null);
    }
    var image = tmp;
    var tmp0_context2d_0 = true;
    var tmp0_lock_0_1 = null;
    image.lock_5();
    try {
      var ctx_2_2 = image.getContext2d_5(tmp0_context2d_0);
      try {
        ctx_2_2._set_fillStyle_(paint);
        font.renderGlyph_2(ctx_2_2, size_1, codePoint, gx + border, gy + border, true, gmetrics);
        if (fill_3)
          ctx_2_2.fill_6();
        else
          ctx_2_2.stroke_0();
      }finally {
        ctx_2_2.dispose_18();
      }
    }finally {
      image.unlock_5(tmp0_lock_0_1);
      Unit_getInstance();
    }
    Unit_getInstance();
    var imageOut = applyEffect(image.toBMP32IfRequired_5(), effect);
    var tmp_0 = TextMetrics_init_$Create$(null, null, null, 0, 15, null);
    var tmp_1 = gx + border;
    var tmp_2 = gy + border;
    return new TextToBitmapResult(imageOut, fmetrics, tmp_0, listOf_0(new PlacedGlyph(codePoint, tmp_1, tmp_2, gmetrics, Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null))));
  }
  function renderGlyphToBitmap$default(_this_, size_1, codePoint, paint, fill_3, effect, border, nativeRendering, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      paint = new RGBA(_get_DefaultPaint_());
    if (!(($mask0 & 8) === 0))
      fill_3 = true;
    if (!(($mask0 & 16) === 0))
      effect = null;
    if (!(($mask0 & 32) === 0))
      border = 1;
    if (!(($mask0 & 64) === 0))
      nativeRendering = true;
    return renderGlyphToBitmap(_this_, size_1, codePoint, paint, fill_3, effect, border, nativeRendering);
  }
  function _no_name_provided__228($ctx, $x, $y, $paint, $size, $placed, $fill) {
    this._$ctx = $ctx;
    this._$x = $x;
    this._$y = $y;
    this._$paint = $paint;
    this._$size = $size;
    this._$placed = $placed;
    this._$fill = $fill;
    TextRendererActions.call(this);
  }
  _no_name_provided__228.prototype.put_14 = function (codePoint) {
    if (!(this._$ctx == null)) {
      var t_1 = this._$ctx._state_4._transform_6;
      var a_2 = t_1._a;
      var b_3 = t_1._b;
      var c_4 = t_1._c;
      var d_5 = t_1._d;
      var tx_6 = t_1._tx;
      var ty_7 = t_1._ty;
      try {
        var m_9 = this.getGlyphMetrics_6(codePoint);
        this._$ctx.translate_2(this._get_x__36() + this._$x, this._get_y__36() + this._$y);
        Unit_getInstance();
        this._$ctx.transform_4(this._get_transform__8());
        Unit_getInstance();
        var tmp0_elvis_lhs_10 = this._get_paint__0();
        this._$ctx._set_fillStyle_(tmp0_elvis_lhs_10 == null ? this._$paint : tmp0_elvis_lhs_10);
        this._get_font__2().renderGlyph_2(this._$ctx, this._$size, codePoint, 0.0, 0.0, true, this._get_glyphMetrics__0());
        var tmp1_safe_receiver_11 = this._$placed;
        if (tmp1_safe_receiver_11 == null)
          null;
        else
          tmp1_safe_receiver_11(codePoint, this._get_x__36() + this._$x, this._get_y__36() + this._$y, this._$size, this._get_glyphMetrics__0(), this._get_transform__8());
        Unit_getInstance();
        if (this._$fill)
          this._$ctx.fill_6();
        else
          this._$ctx.stroke_0();
      }finally {
        t_1.setTo(a_2, b_3, c_4, d_5, tx_6, ty_7);
        Unit_getInstance();
      }
    } else {
      var tmp0_safe_receiver = this._$placed;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(codePoint, this._get_x__36() + this._$x, this._get_y__36() + this._$y, this._$size, this._get_glyphMetrics__0(), this._get_transform__8());
      Unit_getInstance();
    }
    return this._get_glyphMetrics__0();
  };
  _no_name_provided__228.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__229($returnGlyphs, $glyphs) {
    this._$returnGlyphs = $returnGlyphs;
    this._$glyphs = $glyphs;
  }
  _no_name_provided__229.prototype.invoke_390 = function (codePoint, x, y, size_1, metrics, transform) {
    if (this._$returnGlyphs) {
      var tmp0_plusAssign_0_8 = new PlacedGlyph(codePoint, x, y, metrics.clone_8(), transform.clone_8());
      this._$glyphs.add_39(tmp0_plusAssign_0_8);
      Unit_getInstance();
    }};
  _no_name_provided__229.prototype.invoke_391 = function (p1, p2, p3, p4, p5, p6) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    var tmp_3 = p5 instanceof GlyphMetrics ? p5 : THROW_CCE();
    this.invoke_390(tmp, tmp_0, tmp_1, tmp_2, tmp_3, p6 instanceof Matrix ? p6 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__229.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_189($returnGlyphs, $glyphs) {
    var i = new _no_name_provided__229($returnGlyphs, $glyphs);
    return function (p1, p2, p3, p4, p5, p6) {
      i.invoke_390(p1, p2, p3, p4, p5, p6);
      return Unit_getInstance();
    };
  }
  function readFont(_this_, preload, imageFormat, mipmaps_0, $cont) {
    var tmp = new $readFontCOROUTINE$4(_this_, preload, imageFormat, mipmaps_0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readFont$default(_this_, preload, imageFormat, mipmaps_0, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      preload = false;
    if (!(($mask0 & 2) === 0))
      imageFormat = RegisteredImageFormats_getInstance();
    if (!(($mask0 & 4) === 0))
      mipmaps_0 = true;
    return readFont(_this_, preload, imageFormat, mipmaps_0, $cont);
  }
  function $emit_2_8_4_4COROUTINE$6(_this_, value, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__123 = _this_;
    this._value_18 = value;
  }
  $emit_2_8_4_4COROUTINE$6.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (_get_extensionLC__0(this._value_18) === 'ttf' ? true : _get_extensionLC__0(this._value_18) === 'fnt') {
              this._state_1 = 3;
              suspendResult = this.__this__123._$collector.emit_8(this._value_18, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 2;
                continue $sm;
              }
            }

            break;
          case 2:
            if (false) {
              this._state_1 = 1;
              continue $sm;
            }
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._tmp$ret$00_2 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $emit_2_8_4_4COROUTINE$6.$metadata$ = {
    simpleName: '$emit_2_8_4_4COROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_7_3_3($collector) {
    this._$collector = $collector;
  }
  _no_name_provided__1_7_3_3.prototype.emit_2_8_4_4 = function (value, $cont) {
    var tmp = new $emit_2_8_4_4COROUTINE$6(this, value, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__1_7_3_3.prototype.emit_8 = function (value, $cont) {
    return this.emit_2_8_4_4(value instanceof VfsFile ? value : THROW_CCE(), $cont);
  };
  _no_name_provided__1_7_3_3.$metadata$ = {
    simpleName: '<no name provided>_1_7_3_3',
    kind: 'class',
    interfaces: [FlowCollector]
  };
  function $collect_2_2_2COROUTINE$5(_this_, collector, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__124 = _this_;
    this._collector_2 = collector;
  }
  $collect_2_2_2COROUTINE$5.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__124._$tmp0_filter_0.collect_6(new _no_name_provided__1_7_3_3(this._collector_2), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $collect_2_2_2COROUTINE$5.$metadata$ = {
    simpleName: '$collect_2_2_2COROUTINE$5',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1_1_1($tmp0_filter_0) {
    this._$tmp0_filter_0 = $tmp0_filter_0;
  }
  _no_name_provided__1_1_1.prototype.collect_2_2_2 = function (collector, $cont) {
    var tmp = new $collect_2_2_2COROUTINE$5(this, collector, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__1_1_1.prototype.collect_6 = function (collector, $cont) {
    return this.collect_2_2_2(collector, $cont);
  };
  _no_name_provided__1_1_1.$metadata$ = {
    simpleName: '<no name provided>_1_1_1',
    kind: 'class',
    interfaces: [Flow]
  };
  function _no_name_provided__230(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__230.prototype.invoke_392 = function (it, $cont) {
    var tmp = this.create_18(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__230.prototype.invoke_1015 = function (p1, $cont) {
    return this.invoke_392(p1 instanceof VfsFile ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__230.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            suspendResult = this._it.listRecursive$default(null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._tmp0_filter_00 = suspendResult;
            var tmp_0 = this;
            tmp_0._ARGUMENT1_10 = new _no_name_provided__1_1_1(this._tmp0_filter_00);
            this._state_1 = 2;
            suspendResult = firstOrNull_1(this._ARGUMENT1_10, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._tmp0_safe_receiver2_0 = suspendResult;
            if (this._tmp0_safe_receiver2_0 == null) {
              this._WHEN_RESULT3_1 = null;
              this._state_1 = 4;
              continue $sm;
            } else {
              this._state_1 = 3;
              suspendResult = readFont$default(this._tmp0_safe_receiver2_0, false, null, false, 7, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 3:
            this._WHEN_RESULT3_1 = suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            var tmp1_elvis_lhs = this._WHEN_RESULT3_1;
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              var tmp1_error_0 = "Can't find TTF or FNT on zip";
              throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            return tmp_1;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__230.prototype.create_18 = function (it, completion) {
    var i = new _no_name_provided__230(completion);
    i._it = it;
    return i;
  };
  _no_name_provided__230.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $readFontCOROUTINE$4(_this_, preload, imageFormat, mipmaps_0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__125 = _this_;
    this._preload = preload;
    this._imageFormat_2 = imageFormat;
    this._mipmaps_3 = mipmaps_0;
  }
  $readFontCOROUTINE$4.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._state_1 = 1;
            suspendResult = this.__this__125.readRangeBytes_0(until(0, 16), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._header0 = suspendResult;
            this._tmp0_subject1 = readS32BE(this._header0, 0);
            if (this._tmp0_subject1 === 65536) {
              this._state_1 = 4;
              suspendResult = readTtfFont(this.__this__125, this._preload, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              if (this._tmp0_subject1 === 1330926671) {
                var tmp_0 = this;
                var tmp_1 = this;
                tmp_1._tmp0_TODO_03 = 'Unsupported OpenType fonts';
                throw new NotImplementedError('' + 'An operation is not implemented: ' + this._tmp0_TODO_03);
              } else {
                if (this._tmp0_subject1 === 1347093252) {
                  this._state_1 = 3;
                  suspendResult = openAsZip$default(this.__this__125, false, _no_name_provided_$factory_190(null), 1, null, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  this._state_1 = 2;
                  suspendResult = readBitmapFont(this.__this__125, this._imageFormat_2, this._mipmaps_3, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                }
                Unit_getInstance();
              }
              Unit_getInstance();
            }

            break;
          case 2:
            this._WHEN_RESULT2_2 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 3:
            this._WHEN_RESULT2_2 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 4:
            this._WHEN_RESULT2_2 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._WHEN_RESULT2_2;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readFontCOROUTINE$4.$metadata$ = {
    simpleName: '$readFontCOROUTINE$4',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_190(resultContinuation) {
    var i = new _no_name_provided__230(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_392(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function FontRegistry() {
  }
  FontRegistry.$metadata$ = {
    simpleName: 'FontRegistry',
    kind: 'interface',
    interfaces: []
  };
  function SystemFontRegistry() {
    SystemFontRegistry_instance = this;
    DefaultFontRegistry.call(this);
    var tmp = this;
    var tmp_0 = _get_DefaultTtfFont_();
    tmp._DEFAULT_FONT = register$default(tmp_0, null, 'sans-serif', 1, null);
  }
  SystemFontRegistry.$metadata$ = {
    simpleName: 'SystemFontRegistry',
    kind: 'object',
    interfaces: []
  };
  var SystemFontRegistry_instance;
  function SystemFontRegistry_getInstance() {
    if (SystemFontRegistry_instance == null)
      new SystemFontRegistry();
    return SystemFontRegistry_instance;
  }
  function DefaultFontRegistry() {
    this._registeredFonts = new CopyOnWriteFrozenMap();
  }
  DefaultFontRegistry.prototype.normalizeName_1 = function (name) {
    var tmp0_trim_0 = name.toLowerCase();
    return toString_1(trim_0(isCharSequence(tmp0_trim_0) ? tmp0_trim_0 : THROW_CCE()));
  };
  DefaultFontRegistry.prototype.register_2 = function (font, name) {
    var tmp0_set_0_2 = this._registeredFonts;
    var tmp1_set_0_3 = this.normalizeName_1(name);
    tmp0_set_0_2.put_18(tmp1_set_0_3, font);
    Unit_getInstance();
    return font;
  };
  DefaultFontRegistry.$metadata$ = {
    simpleName: 'DefaultFontRegistry',
    kind: 'class',
    interfaces: [FontRegistry]
  };
  function register(_this_, registry, name) {
    registry.register_2(_this_, name);
    Unit_getInstance();
    return _this_;
  }
  function register$default(_this_, registry, name, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      registry = SystemFontRegistry_getInstance();
    if (!(($mask0 & 2) === 0))
      name = _this_._get_name__50();
    return register(_this_, registry, name);
  }
  function GlyphPath_init_$Init$(path_0, transform, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      path_0 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    }if (!(($mask0 & 2) === 0)) {
      transform = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }GlyphPath.call($this, path_0, transform);
    return $this;
  }
  function GlyphPath_init_$Create$(path_0, transform, $mask0, $marker) {
    return GlyphPath_init_$Init$(path_0, transform, $mask0, $marker, Object.create(GlyphPath.prototype));
  }
  function GlyphPath(path_0, transform) {
    this._path_19 = path_0;
    this._transform_1 = transform;
  }
  GlyphPath.prototype.draw_10 = function (c) {
    var t_1 = c._state_4._transform_6;
    var a_2 = t_1._a;
    var b_3 = t_1._b;
    var c_4 = t_1._c;
    var d_5 = t_1._d;
    var tx_6 = t_1._tx;
    var ty_7 = t_1._ty;
    try {
      c.beginPath_0();
      c.transform_4(this._transform_1);
      Unit_getInstance();
      c.draw_2(this._path_19);
    }finally {
      t_1.setTo(a_2, b_3, c_4, d_5, tx_6, ty_7);
      Unit_getInstance();
    }
  };
  GlyphPath.prototype.toString = function () {
    return '' + 'GlyphPath(path=' + this._path_19 + ', transform=' + this._transform_1 + ')';
  };
  GlyphPath.prototype.hashCode = function () {
    var result = hashCode(this._path_19);
    result = imul(result, 31) + this._transform_1.hashCode() | 0;
    return result;
  };
  GlyphPath.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!equals_1(this._path_19, tmp0_other_with_cast._path_19))
      return false;
    if (!this._transform_1.equals(tmp0_other_with_cast._transform_1))
      return false;
    return true;
  };
  GlyphPath.$metadata$ = {
    simpleName: 'GlyphPath',
    kind: 'class',
    interfaces: [Drawable]
  };
  function FontMetrics_init_$Init$(size_1, top, ascent, baseline, descent, bottom, leading, maxWidth, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      size_1 = 0.0;
    if (!(($mask0 & 2) === 0))
      top = 0.0;
    if (!(($mask0 & 4) === 0))
      ascent = 0.0;
    if (!(($mask0 & 8) === 0))
      baseline = 0.0;
    if (!(($mask0 & 16) === 0))
      descent = 0.0;
    if (!(($mask0 & 32) === 0))
      bottom = 0.0;
    if (!(($mask0 & 64) === 0))
      leading = 0.0;
    if (!(($mask0 & 128) === 0))
      maxWidth = 0.0;
    FontMetrics.call($this, size_1, top, ascent, baseline, descent, bottom, leading, maxWidth);
    return $this;
  }
  function FontMetrics_init_$Create$(size_1, top, ascent, baseline, descent, bottom, leading, maxWidth, $mask0, $marker) {
    return FontMetrics_init_$Init$(size_1, top, ascent, baseline, descent, bottom, leading, maxWidth, $mask0, $marker, Object.create(FontMetrics.prototype));
  }
  function FontMetrics(size_1, top, ascent, baseline, descent, bottom, leading, maxWidth) {
    this._size_10 = size_1;
    this._top = top;
    this._ascent = ascent;
    this._baseline = baseline;
    this._descent = descent;
    this._bottom = bottom;
    this._leading = leading;
    this._maxWidth = maxWidth;
  }
  FontMetrics.prototype._get_emHeight_ = function () {
    return this._ascent - this._descent;
  };
  FontMetrics.prototype._get_lineHeight__4 = function () {
    return this._top - this._bottom;
  };
  FontMetrics.prototype.copyFromNewSize = function (other, size_1) {
    return this.copyFromScaled(other, size_1 / other._size_10);
  };
  FontMetrics.prototype.copyFromScaled = function (other, scale_1) {
    this._size_10 = other._size_10 * scale_1;
    this._top = other._top * scale_1;
    this._ascent = other._ascent * scale_1;
    this._baseline = other._baseline * scale_1;
    this._descent = other._descent * scale_1;
    this._bottom = other._bottom * scale_1;
    this._leading = other._leading * scale_1;
    this._maxWidth = other._maxWidth * scale_1;
    return this;
  };
  FontMetrics.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_5('FontMetrics(');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'size=' + toIntRound(this._size_10) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'top=' + toIntRound(this._top) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'ascent=' + toIntRound(this._ascent) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'baseline=' + toIntRound(this._baseline) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'descent=' + toIntRound(this._descent) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'bottom=' + toIntRound(this._bottom) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'leading=' + toIntRound(this._leading) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'emHeight=' + toIntRound(this._get_emHeight_()) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'lineHeight=' + toIntRound(this._get_lineHeight__4()));
    Unit_getInstance();
    tmp0_apply_0_1.append_5(')');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  FontMetrics.prototype.hashCode = function () {
    var result = getNumberHashCode(this._size_10);
    result = imul(result, 31) + getNumberHashCode(this._top) | 0;
    result = imul(result, 31) + getNumberHashCode(this._ascent) | 0;
    result = imul(result, 31) + getNumberHashCode(this._baseline) | 0;
    result = imul(result, 31) + getNumberHashCode(this._descent) | 0;
    result = imul(result, 31) + getNumberHashCode(this._bottom) | 0;
    result = imul(result, 31) + getNumberHashCode(this._leading) | 0;
    result = imul(result, 31) + getNumberHashCode(this._maxWidth) | 0;
    return result;
  };
  FontMetrics.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals_1(this._size_10, tmp0_other_with_cast._size_10))
      return false;
    if (!equals_1(this._top, tmp0_other_with_cast._top))
      return false;
    if (!equals_1(this._ascent, tmp0_other_with_cast._ascent))
      return false;
    if (!equals_1(this._baseline, tmp0_other_with_cast._baseline))
      return false;
    if (!equals_1(this._descent, tmp0_other_with_cast._descent))
      return false;
    if (!equals_1(this._bottom, tmp0_other_with_cast._bottom))
      return false;
    if (!equals_1(this._leading, tmp0_other_with_cast._leading))
      return false;
    if (!equals_1(this._maxWidth, tmp0_other_with_cast._maxWidth))
      return false;
    return true;
  };
  FontMetrics.$metadata$ = {
    simpleName: 'FontMetrics',
    kind: 'class',
    interfaces: []
  };
  function GlyphMetrics_init_$Init$(size_1, existing, codePoint, bounds, xadvance, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      size_1 = 0.0;
    if (!(($mask0 & 2) === 0))
      existing = false;
    if (!(($mask0 & 4) === 0))
      codePoint = 0;
    if (!(($mask0 & 8) === 0))
      bounds = Companion_getInstance_83().invoke_1005();
    if (!(($mask0 & 16) === 0))
      xadvance = 0.0;
    GlyphMetrics.call($this, size_1, existing, codePoint, bounds, xadvance);
    return $this;
  }
  function GlyphMetrics_init_$Create$(size_1, existing, codePoint, bounds, xadvance, $mask0, $marker) {
    return GlyphMetrics_init_$Init$(size_1, existing, codePoint, bounds, xadvance, $mask0, $marker, Object.create(GlyphMetrics.prototype));
  }
  function GlyphMetrics(size_1, existing, codePoint, bounds, xadvance) {
    this._size_11 = size_1;
    this._existing = existing;
    this._codePoint_0 = codePoint;
    this._bounds_1 = bounds;
    this._xadvance_0 = xadvance;
  }
  GlyphMetrics.prototype._get_left__4 = function () {
    return this._bounds_1._get_left__4();
  };
  GlyphMetrics.prototype._get_top__4 = function () {
    return this._bounds_1._get_top__4();
  };
  GlyphMetrics.prototype._get_width__58 = function () {
    return this._bounds_1._width_0;
  };
  GlyphMetrics.prototype._get_height__58 = function () {
    return this._bounds_1._height_0;
  };
  GlyphMetrics.prototype.clone_8 = function () {
    var tmp = this._bounds_1.clone_8();
    return this.copy$default_6(0.0, false, 0, tmp, 0.0, 23, null);
  };
  GlyphMetrics.prototype.copyFromNewSize_0 = function (other, size_1, codePoint) {
    return this.copyFromScaled_0(other, size_1 / other._size_11, codePoint);
  };
  GlyphMetrics.prototype.copyFromScaled_0 = function (other, scale_1, codePoint) {
    this._size_11 = other._size_11;
    this._existing = other._existing;
    this._codePoint_0 = codePoint;
    this._bounds_1.setTo_2(other._bounds_1._x_3 * scale_1, other._bounds_1._y_3 * scale_1, other._bounds_1._width_0 * scale_1, other._bounds_1._height_0 * scale_1);
    Unit_getInstance();
    this._xadvance_0 = other._xadvance_0 * scale_1;
    return this;
  };
  GlyphMetrics.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_5('GlyphMetrics(');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'codePoint=' + this._codePoint_0 + " ('" + numberToChar(this._codePoint_0) + "'), ");
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'existing=' + this._existing + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'xadvance=' + roundToInt(this._xadvance_0) + ', ');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + 'bounds=' + new RectangleInt(this._bounds_1.toInt_3()));
    Unit_getInstance();
    tmp0_apply_0_1.append_5(')');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  GlyphMetrics.prototype.copy_12 = function (size_1, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size_1, existing, codePoint, bounds, xadvance);
  };
  GlyphMetrics.prototype.copy$default_6 = function (size_1, existing, codePoint, bounds, xadvance, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      size_1 = this._size_11;
    if (!(($mask0 & 2) === 0))
      existing = this._existing;
    if (!(($mask0 & 4) === 0))
      codePoint = this._codePoint_0;
    if (!(($mask0 & 8) === 0))
      bounds = this._bounds_1;
    if (!(($mask0 & 16) === 0))
      xadvance = this._xadvance_0;
    return this.copy_12(size_1, existing, codePoint, bounds, xadvance);
  };
  GlyphMetrics.prototype.hashCode = function () {
    var result = getNumberHashCode(this._size_11);
    result = imul(result, 31) + (this._existing | 0) | 0;
    result = imul(result, 31) + this._codePoint_0 | 0;
    result = imul(result, 31) + this._bounds_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._xadvance_0) | 0;
    return result;
  };
  GlyphMetrics.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals_1(this._size_11, tmp0_other_with_cast._size_11))
      return false;
    if (!(this._existing === tmp0_other_with_cast._existing))
      return false;
    if (!(this._codePoint_0 === tmp0_other_with_cast._codePoint_0))
      return false;
    if (!this._bounds_1.equals(tmp0_other_with_cast._bounds_1))
      return false;
    if (!equals_1(this._xadvance_0, tmp0_other_with_cast._xadvance_0))
      return false;
    return true;
  };
  GlyphMetrics.$metadata$ = {
    simpleName: 'GlyphMetrics',
    kind: 'class',
    interfaces: []
  };
  function TextMetrics_init_$Init$(bounds, firstLineBounds, fontMetrics, nlines, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      bounds = Companion_getInstance_83().invoke_1005();
    if (!(($mask0 & 2) === 0))
      firstLineBounds = Companion_getInstance_83().invoke_1005();
    if (!(($mask0 & 4) === 0)) {
      fontMetrics = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
    }if (!(($mask0 & 8) === 0))
      nlines = 0;
    TextMetrics_0.call($this, bounds, firstLineBounds, fontMetrics, nlines);
    return $this;
  }
  function TextMetrics_init_$Create$(bounds, firstLineBounds, fontMetrics, nlines, $mask0, $marker) {
    return TextMetrics_init_$Init$(bounds, firstLineBounds, fontMetrics, nlines, $mask0, $marker, Object.create(TextMetrics_0.prototype));
  }
  function TextMetrics_0(bounds, firstLineBounds, fontMetrics, nlines) {
    this._bounds_2 = bounds;
    this._firstLineBounds = firstLineBounds;
    this._fontMetrics = fontMetrics;
    this._nlines = nlines;
  }
  TextMetrics_0.prototype._get_left__4 = function () {
    return this._bounds_2._get_left__4();
  };
  TextMetrics_0.prototype._get_top__4 = function () {
    return this._bounds_2._get_top__4();
  };
  TextMetrics_0.prototype._get_width__58 = function () {
    return this._bounds_2._width_0;
  };
  TextMetrics_0.prototype._get_height__58 = function () {
    return this._bounds_2._height_0;
  };
  TextMetrics_0.prototype._get_drawLeft_ = function () {
    return -this._get_left__4();
  };
  TextMetrics_0.prototype._get_drawTop_ = function () {
    return this._firstLineBounds._height_0 + this._firstLineBounds._get_top__4();
  };
  TextMetrics_0.prototype._get_ascent_ = function () {
    return this._fontMetrics._ascent;
  };
  TextMetrics_0.prototype._get_lineHeight__4 = function () {
    return this._fontMetrics._get_lineHeight__4();
  };
  TextMetrics_0.prototype._get_allLineHeight_ = function () {
    return this._get_lineHeight__4() * this._nlines;
  };
  TextMetrics_0.prototype.toString = function () {
    return '' + 'TextMetrics[' + _get_niceStr__0(this._get_left__4()) + ', ' + _get_niceStr__0(this._get_top__4()) + ', ' + _get_niceStr__0(this._get_width__58()) + ', ' + _get_niceStr__0(this._get_height__58()) + '][' + _get_niceStr__0(this._get_drawLeft_()) + ', ' + _get_niceStr__0(this._get_drawTop_()) + ']';
  };
  TextMetrics_0.prototype.hashCode = function () {
    var result = this._bounds_2.hashCode();
    result = imul(result, 31) + this._firstLineBounds.hashCode() | 0;
    result = imul(result, 31) + this._fontMetrics.hashCode() | 0;
    result = imul(result, 31) + this._nlines | 0;
    return result;
  };
  TextMetrics_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextMetrics_0 ? other : THROW_CCE();
    if (!this._bounds_2.equals(tmp0_other_with_cast._bounds_2))
      return false;
    if (!this._firstLineBounds.equals(tmp0_other_with_cast._firstLineBounds))
      return false;
    if (!this._fontMetrics.equals(tmp0_other_with_cast._fontMetrics))
      return false;
    if (!(this._nlines === tmp0_other_with_cast._nlines))
      return false;
    return true;
  };
  TextMetrics_0.$metadata$ = {
    simpleName: 'TextMetrics',
    kind: 'class',
    interfaces: []
  };
  var linuxFolders;
  var windowsFolders;
  var macosFolders;
  function NativeSystemFontProvider() {
  }
  NativeSystemFontProvider.$metadata$ = {
    simpleName: 'NativeSystemFontProvider',
    kind: 'class',
    interfaces: []
  };
  function FallbackNativeSystemFontProvider(ttf) {
    TtfNativeSystemFontProvider.call(this);
    this._ttf = ttf;
  }
  FallbackNativeSystemFontProvider.$metadata$ = {
    simpleName: 'FallbackNativeSystemFontProvider',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__231() {
  }
  _no_name_provided__231.prototype.invoke_1005 = function () {
    return LinkedHashMap_init_$Create$();
  };
  _no_name_provided__231.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TtfNativeSystemFontProvider() {
    NativeSystemFontProvider.call(this);
    var tmp = this;
    tmp._ttfCache$delegate = lazy(_no_name_provided_$factory_191());
  }
  TtfNativeSystemFontProvider.$metadata$ = {
    simpleName: 'TtfNativeSystemFontProvider',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_191() {
    var i = new _no_name_provided__231();
    return function () {
      return i.invoke_1005();
    };
  }
  var NameId_COPYRIGHT_instance;
  var NameId_NAME_instance;
  var NameId_STYLE_instance;
  var NameId_UNAME_instance;
  var NameId_COMPLETE_NAME_instance;
  var NameId_RELEASE_VERSION_instance;
  var NameId_POSTSCRIPT_NAME_instance;
  var NameId_TRADEMARK_instance;
  var NameId_MANUFACTURER_instance;
  var NameId_DESIGNER_instance;
  var NameId_DESCRIPTION_instance;
  var NameId_URL_VENDOR_instance;
  var NameId_URL_DESIGNER_instance;
  var NameId_LICENSE_DESCRIPTION_instance;
  var NameId_LICENSE_URL_instance;
  var NameId_RESERVED_15_instance;
  var NameId_PREFERRED_FAMILY_instance;
  var NameId_PREFERRED_SUBFAMILY_instance;
  var NameId_COMPATIBLE_FULL_instance;
  var NameId_SAMPLE_TEXT_instance;
  var NameId_POSTSCRIPT_CID_instance;
  var NameId_WWS_FAMILY_NAME_instance;
  var NameId_WWS_SUBFAMILY_NAME_instance;
  var NameId_LIGHT_BACKGROUND_instance;
  var NameId_DARK_BACKGROUND_instance;
  var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
  var NameId_entriesInitialized;
  function NameId_initEntries() {
    if (NameId_entriesInitialized)
      return Unit_getInstance();
    NameId_entriesInitialized = true;
    NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
    NameId_NAME_instance = new NameId('NAME', 1, 1);
    NameId_STYLE_instance = new NameId('STYLE', 2, 2);
    NameId_UNAME_instance = new NameId('UNAME', 3, 3);
    NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
    NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
    NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
    NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
    NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
    NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
    NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
    NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
    NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
    NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
    NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
    NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
    NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
    NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
    NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
    NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
    NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
    NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
    NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
    NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
    NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
    NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
  }
  function Contour_init_$Init$(x, y, onCurve_0, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0;
    if (!(($mask0 & 2) === 0))
      y = 0;
    if (!(($mask0 & 4) === 0))
      onCurve_0 = false;
    Contour.call($this, x, y, onCurve_0);
    return $this;
  }
  function Contour_init_$Create$(x, y, onCurve_0, $mask0, $marker) {
    return Contour_init_$Init$(x, y, onCurve_0, $mask0, $marker, Object.create(Contour.prototype));
  }
  function onCurve($this, n) {
    return !(($this._flags[n] & 1) === 0);
  }
  function contour($this, n, out) {
    out._x_6 = $this._xPos[n];
    out._y_5 = $this._yPos[n];
    out._onCurve = onCurve($this, n);
    return out;
  }
  function TtfFont_init_$Init$(d, freeze, extName, $this) {
    TtfFont.call($this, openFastStream$default(d, 0, 1, null), freeze, extName);
    return $this;
  }
  function TtfFont_init_$Create$(d, freeze, extName) {
    return TtfFont_init_$Init$(d, freeze, extName, Object.create(TtfFont.prototype));
  }
  function getTextScale_0($this, size_1) {
    return size_1 / $this._unitsPerEm;
  }
  function getCharacterMapOrNull($this, key) {
    return $this._characterMaps.get_116(key);
  }
  function Table(id, checksum, offset, length) {
    this._id_4 = id;
    this._checksum = checksum;
    this._offset_20 = offset;
    this._length_6 = length;
  }
  Table.prototype._get_s__1 = function () {
    var tmp = this._s_4;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('s');
    }
  };
  Table.prototype.open_11 = function () {
    return this._get_s__1().clone_8();
  };
  Table.prototype.toString = function () {
    return '' + 'Table(id=' + this._id_4 + ', checksum=' + this._checksum + ', offset=' + this._offset_20 + ', length=' + this._length_6 + ')';
  };
  Table.prototype.hashCode = function () {
    var result = getStringHashCode(this._id_4);
    result = imul(result, 31) + this._checksum | 0;
    result = imul(result, 31) + this._offset_20 | 0;
    result = imul(result, 31) + this._length_6 | 0;
    return result;
  };
  Table.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this._id_4 === tmp0_other_with_cast._id_4))
      return false;
    if (!(this._checksum === tmp0_other_with_cast._checksum))
      return false;
    if (!(this._offset_20 === tmp0_other_with_cast._offset_20))
      return false;
    if (!(this._length_6 === tmp0_other_with_cast._length_6))
      return false;
    return true;
  };
  Table.$metadata$ = {
    simpleName: 'Table',
    kind: 'class',
    interfaces: []
  };
  function HorMetric(advanceWidth, lsb) {
    this._advanceWidth = advanceWidth;
    this._lsb = lsb;
  }
  HorMetric.prototype.toString = function () {
    return '' + 'HorMetric(advanceWidth=' + this._advanceWidth + ', lsb=' + this._lsb + ')';
  };
  HorMetric.prototype.hashCode = function () {
    var result = this._advanceWidth;
    result = imul(result, 31) + this._lsb | 0;
    return result;
  };
  HorMetric.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this._advanceWidth === tmp0_other_with_cast._advanceWidth))
      return false;
    if (!(this._lsb === tmp0_other_with_cast._lsb))
      return false;
    return true;
  };
  HorMetric.$metadata$ = {
    simpleName: 'HorMetric',
    kind: 'class',
    interfaces: []
  };
  function readHeaderTables($this) {
    var tmp0_apply_0 = $this._s_5.sliceStart$default(0, 1, null);
    var tmp0_apply_0_3 = tmp0_apply_0.readU16BE();
    if (!(tmp0_apply_0_3 === 1)) {
      invalidOp('Not a TTF file');
    }var majorVersion_2 = tmp0_apply_0_3;
    var tmp1_apply_0_5 = tmp0_apply_0.readU16BE();
    if (!(tmp1_apply_0_5 === 0)) {
      invalidOp('Not a TTF file');
    }var minorVersion_4 = tmp1_apply_0_5;
    var numTables_6 = tmp0_apply_0.readU16BE();
    var searchRange_7 = tmp0_apply_0.readU16BE();
    var entrySelector_8 = tmp0_apply_0.readU16BE();
    var rangeShift_9 = tmp0_apply_0.readU16BE();
    var tmp2_map_0_11 = until(0, numTables_6);
    var tmp0_mapTo_0_1_12 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp2_map_0_11, 10));
    var inductionVariable = tmp2_map_0_11._get_first__6();
    var last_1 = tmp2_map_0_11._get_last__6();
    if (inductionVariable <= last_1)
      do {
        var item_2_3_14 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_mapTo_0_1_12.add_39(new Table(tmp0_apply_0.readStringz$default(4, null, 2, null), tmp0_apply_0.readS32BE(), tmp0_apply_0.readS32BE(), tmp0_apply_0.readS32BE()));
        Unit_getInstance();
      }
       while (!(item_2_3_14 === last_1));
    var tables_10 = tmp0_mapTo_0_1_12;
    var tmp0_iterator_15 = tables_10.iterator_67();
    while (tmp0_iterator_15.hasNext_33()) {
      var table_16 = tmp0_iterator_15.next_37();
      table_16._s_4 = tmp0_apply_0.sliceWithSize(table_16._offset_20, table_16._length_6);
      var tmp3_set_0_17 = $this._tablesByName;
      var tmp4_set_0_18 = table_16._id_4;
      tmp3_set_0_17.put_18(tmp4_set_0_18, table_16);
      Unit_getInstance();
    }
    return tmp0_apply_0;
  }
  function NameId(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this._id_5 = id;
  }
  NameId.$metadata$ = {
    simpleName: 'NameId',
    kind: 'class',
    interfaces: []
  };
  function readNames($this) {
    var tmp0_runTableUnit_0 = 'name';
    var tmp0_safe_receiver_1 = $this.openTable(tmp0_runTableUnit_0);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var format_3 = tmp0_safe_receiver_1.readU16BE();
      var count_4 = tmp0_safe_receiver_1.readU16BE();
      var stringOffset_5 = tmp0_safe_receiver_1.readU16BE();
      var inductionVariable = 0;
      if (inductionVariable < count_4)
        do {
          var n_7 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var platformId_8 = tmp0_safe_receiver_1.readU16BE();
          var encodingId_9 = tmp0_safe_receiver_1.readU16BE();
          var languageId_10 = tmp0_safe_receiver_1.readU16BE();
          var nameId_11 = tmp0_safe_receiver_1.readU16BE();
          var length_12 = tmp0_safe_receiver_1.readU16BE();
          var offset_13 = tmp0_safe_receiver_1.readU16BE();
          var tmp1_subject_15 = encodingId_9;
          {
            var charset_14;
            switch (tmp1_subject_15) {
              case 0:
                charset_14 = UTF8;
                break;
              case 1:
                charset_14 = UTF16_BE;
                break;
              default:charset_14 = UTF16_BE;
                break;
            }
          }
          var string_16 = toString_3(tmp0_safe_receiver_1.clone_8().sliceWithSize(stringOffset_5 + offset_13 | 0, length_12).readAll_0(), charset_14);
          var tmp;
          if (platformId_8 === 0 ? languageId_10 === 0 : false) {
            tmp = true;
          } else {
            var tmp0_contains_0_17 = $this._names;
            tmp = !(isInterface(tmp0_contains_0_17, Map_0) ? tmp0_contains_0_17 : THROW_CCE()).containsKey_11(nameId_11);
          }
          if (tmp) {
            var tmp1_set_0_18 = $this._names;
            tmp1_set_0_18.put_18(nameId_11, string_16);
            Unit_getInstance();
          } else {
          }
        }
         while (inductionVariable < count_4);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readLoca($this) {
    var tmp0_runTableUnit_0 = 'loca';
    var tmp0_safe_receiver_1 = $this.openTable(tmp0_runTableUnit_0);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var tmp0_subject_4 = $this._indexToLocFormat;
      var tmp;
      switch (tmp0_subject_4) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:_get_invalidOp_();
          break;
      }
      var bytesPerEntry_3 = tmp;
      var data_5 = tmp0_safe_receiver_1.readBytesExact(imul(bytesPerEntry_3, $this._numGlyphs + 1 | 0));
      var tmp_0 = $this;
      var tmp0_run_0_6 = FastByteArrayInputStream_init_$Create$(data_5, 0, 0, 0, 14, null);
      var tmp0_subject_2_7 = $this._indexToLocFormat;
      var tmp_1;
      switch (tmp0_subject_2_7) {
        case 0:
          var tmp_3_8 = 0;
          var tmp_4_9 = $this._numGlyphs + 1 | 0;
          var tmp_5_10 = new Int32Array(tmp_4_9);
          while (tmp_3_8 < tmp_4_9) {
            var tmp_6_11 = tmp_3_8;
            tmp_5_10[tmp_6_11] = imul(tmp0_run_0_6.readU16BE(), 2);
            tmp_3_8 = tmp_3_8 + 1 | 0;
          }

          tmp_1 = tmp_5_10;
          break;
        case 1:
          var tmp_7_12 = 0;
          var tmp_8_13 = $this._numGlyphs + 1 | 0;
          var tmp_9_14 = new Int32Array(tmp_8_13);
          while (tmp_7_12 < tmp_8_13) {
            var tmp_10_15 = tmp_7_12;
            tmp_9_14[tmp_10_15] = tmp0_run_0_6.readS32BE();
            tmp_7_12 = tmp_7_12 + 1 | 0;
          }

          tmp_1 = tmp_9_14;
          break;
        default:_get_invalidOp_();
          break;
      }
      tmp_0._locs = tmp_1;
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readHead($this) {
    var tmp0_runTableUnit_0 = 'head';
    var tmp0_safe_receiver_1 = $this.openTable(tmp0_runTableUnit_0);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var tmp0_apply_0_3 = tmp0_safe_receiver_1.readU16BE();
      if (!(tmp0_apply_0_3 === 1)) {
        invalidOp('Invalid TTF');
      }Unit_getInstance();
      var tmp1_apply_0_4 = tmp0_safe_receiver_1.readU16BE();
      if (!(tmp1_apply_0_4 === 0)) {
        invalidOp('Invalid TTF');
      }Unit_getInstance();
      $this._fontRev = $this.readFixed(tmp0_safe_receiver_1);
      var checkSumAdjustment_5 = tmp0_safe_receiver_1.readS32BE();
      var tmp2_apply_0_6 = tmp0_safe_receiver_1.readS32BE();
      if (!(tmp2_apply_0_6 === 1594834165)) {
        invalidOp('' + 'Invalid magic ' + _get_hex__0(tmp2_apply_0_6));
      }Unit_getInstance();
      var flags_7 = tmp0_safe_receiver_1.readU16BE();
      $this._unitsPerEm = tmp0_safe_receiver_1.readU16BE();
      var created_8 = tmp0_safe_receiver_1.readS64BE().times_28(new Long(1000, 0));
      var modified_9 = tmp0_safe_receiver_1.readS64BE().times_28(new Long(1000, 0));
      $this._xMin_0 = tmp0_safe_receiver_1.readS16BE();
      $this._yMin_0 = tmp0_safe_receiver_1.readS16BE();
      $this._xMax_0 = tmp0_safe_receiver_1.readS16BE();
      $this._yMax_0 = tmp0_safe_receiver_1.readS16BE();
      $this._macStyle = tmp0_safe_receiver_1.readU16BE();
      $this._lowestRecPPEM = tmp0_safe_receiver_1.readU16BE();
      $this._fontDirectionHint = tmp0_safe_receiver_1.readS16BE();
      $this._indexToLocFormat = tmp0_safe_receiver_1.readS16BE();
      $this._glyphDataFormat = tmp0_safe_receiver_1.readS16BE();
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readMaxp($this) {
    var tmp0_runTableUnit_0 = 'maxp';
    var tmp0_safe_receiver_1 = $this.openTable(tmp0_runTableUnit_0);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var version_3 = $this.readFixed(tmp0_safe_receiver_1);
      $this._numGlyphs = tmp0_safe_receiver_1.readU16BE();
      $this._maxPoints = tmp0_safe_receiver_1.readU16BE();
      $this._maxContours = tmp0_safe_receiver_1.readU16BE();
      $this._maxCompositePoints = tmp0_safe_receiver_1.readU16BE();
      $this._maxCompositeContours = tmp0_safe_receiver_1.readU16BE();
      $this._maxZones = tmp0_safe_receiver_1.readU16BE();
      $this._maxTwilightPoints = tmp0_safe_receiver_1.readU16BE();
      $this._maxStorage = tmp0_safe_receiver_1.readU16BE();
      $this._maxFunctionDefs = tmp0_safe_receiver_1.readU16BE();
      $this._maxInstructionDefs = tmp0_safe_receiver_1.readU16BE();
      $this._maxStackElements = tmp0_safe_receiver_1.readU16BE();
      $this._maxSizeOfInstructions = tmp0_safe_receiver_1.readU16BE();
      $this._maxComponentElements = tmp0_safe_receiver_1.readU16BE();
      $this._maxComponentDepth = tmp0_safe_receiver_1.readU16BE();
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readHhea($this) {
    var tmp0_runTableUnit_0 = 'hhea';
    var tmp0_safe_receiver_1 = $this.openTable(tmp0_runTableUnit_0);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      $this._hheaVersion = $this.readFixed(tmp0_safe_receiver_1);
      $this._ascender = tmp0_safe_receiver_1.readS16BE();
      $this._descender = tmp0_safe_receiver_1.readS16BE();
      $this._lineGap = tmp0_safe_receiver_1.readS16BE();
      $this._advanceWidthMax = tmp0_safe_receiver_1.readU16BE();
      $this._minLeftSideBearing = tmp0_safe_receiver_1.readS16BE();
      $this._minRightSideBearing = tmp0_safe_receiver_1.readS16BE();
      $this._xMaxExtent = tmp0_safe_receiver_1.readS16BE();
      $this._caretSlopeRise = tmp0_safe_receiver_1.readS16BE();
      $this._caretSlopeRun = tmp0_safe_receiver_1.readS16BE();
      $this._caretOffset = tmp0_safe_receiver_1.readS16BE();
      tmp0_safe_receiver_1.readS16BE();
      Unit_getInstance();
      tmp0_safe_receiver_1.readS16BE();
      Unit_getInstance();
      tmp0_safe_receiver_1.readS16BE();
      Unit_getInstance();
      tmp0_safe_receiver_1.readS16BE();
      Unit_getInstance();
      $this._metricDataFormat = tmp0_safe_receiver_1.readS16BE();
      $this._numberOfHMetrics = tmp0_safe_receiver_1.readU16BE();
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readHmtx($this) {
    var tmp0_runTableUnit_0 = 'hmtx';
    var tmp0_safe_receiver_1 = $this.openTable(tmp0_runTableUnit_0);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var tmp0_map_0_4 = until(0, $this._numberOfHMetrics);
      var tmp0_mapTo_0_1_5 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_4, 10));
      var inductionVariable = tmp0_map_0_4._get_first__6();
      var last_1 = tmp0_map_0_4._get_last__6();
      if (inductionVariable <= last_1)
        do {
          var item_2_3_7 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          tmp0_mapTo_0_1_5.add_39(new HorMetric(tmp0_safe_receiver_1.readU16BE(), tmp0_safe_receiver_1.readS16BE()));
          Unit_getInstance();
        }
         while (!(item_2_3_7 === last_1));
      var firstMetrics_3 = tmp0_mapTo_0_1_5;
      var lastAdvanceWidth_8 = last(firstMetrics_3)._advanceWidth;
      var tmp1_map_0_10 = until(0, $this._numGlyphs - $this._numberOfHMetrics | 0);
      var tmp0_mapTo_0_1_11 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0_10, 10));
      var inductionVariable_0 = tmp1_map_0_10._get_first__6();
      var last_2 = tmp1_map_0_10._get_last__6();
      if (inductionVariable_0 <= last_2)
        do {
          var item_2_3_13 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          tmp0_mapTo_0_1_11.add_39(new HorMetric(lastAdvanceWidth_8, tmp0_safe_receiver_1.readS16BE()));
          Unit_getInstance();
        }
         while (!(item_2_3_13 === last_2));
      var compressedMetrics_9 = tmp0_mapTo_0_1_11;
      $this._horMetrics = plus(firstMetrics_3, compressedMetrics_9);
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function readCmap($this) {
    var tmp0_runTableUnit_0 = 'cmap';
    var tmp0_safe_receiver_1 = $this.openTable(tmp0_runTableUnit_0);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var version_3 = tmp0_safe_receiver_1.readU16BE();
      var numTables_4 = tmp0_safe_receiver_1.readU16BE();
      var tmp0_map_0_6 = until(0, numTables_4);
      var tmp0_mapTo_0_1_7 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_6, 10));
      var inductionVariable = tmp0_map_0_6._get_first__6();
      var last_1 = tmp0_map_0_6._get_last__6();
      if (inductionVariable <= last_1)
        do {
          var item_2_3_9 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          tmp0_mapTo_0_1_7.add_39(new EncodingRecord(tmp0_safe_receiver_1.readU16BE(), tmp0_safe_receiver_1.readU16BE(), tmp0_safe_receiver_1.readS32BE()));
          Unit_getInstance();
        }
         while (!(item_2_3_9 === last_1));
      var tables_5 = tmp0_mapTo_0_1_7;
      var tmp0_iterator_10 = tables_5.iterator_67();
      while (tmp0_iterator_10.hasNext_33()) {
        var table_11 = tmp0_iterator_10.next_37();
        var tmp1_run_0_12 = tmp0_safe_receiver_1.sliceStart(table_11._offset_21);
        var format_2_13 = tmp1_run_0_12.readU16BE();
        var tmp0_subject_3_14 = format_2_13;
        switch (tmp0_subject_3_14) {
          case 4:
            var length_4_15 = tmp1_run_0_12.readU16BE();
            var language_5_16 = tmp1_run_0_12.readU16BE();
            var segCount_6_17 = tmp1_run_0_12.readU16BE() / 2 | 0;
            var searchRangeS_7_18 = tmp1_run_0_12.readU16BE();
            var entrySelector_8_19 = tmp1_run_0_12.readU16BE();
            var rangeShift_9_20 = tmp1_run_0_12.readU16BE();
            var endCount_10_21 = tmp1_run_0_12.readCharArrayBE(segCount_6_17);
            tmp1_run_0_12.readU16BE();
            Unit_getInstance();
            var startCount_11_22 = tmp1_run_0_12.readCharArrayBE(segCount_6_17);
            var idDelta_12_23 = tmp1_run_0_12.readShortArrayBE(segCount_6_17);
            var rangeOffsetPos_13_24 = tmp1_run_0_12._get_position__1();
            var idRangeOffset_14_25 = tmp1_run_0_12.readCharArrayBE(segCount_6_17);
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < segCount_6_17)
              do {
                var n_16_27 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ec_17_28 = endCount_10_21[n_16_27].toInt_8();
                var sc_18_29 = startCount_11_22[n_16_27].toInt_8();
                var delta_19_30 = idDelta_12_23[n_16_27];
                var iro_20_31 = idRangeOffset_14_25[n_16_27].toInt_8();
                var inductionVariable_1 = sc_18_29;
                if (inductionVariable_1 <= ec_17_28)
                  do {
                    var c_22_33 = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var index_23_34;
                    if (!(iro_20_31 === 0)) {
                      var glyphIndexOffset_24_35 = rangeOffsetPos_13_24 + imul(n_16_27, 2) | 0;
                      glyphIndexOffset_24_35 = glyphIndexOffset_24_35 + iro_20_31 | 0;
                      glyphIndexOffset_24_35 = glyphIndexOffset_24_35 + imul(c_22_33 - sc_18_29 | 0, 2) | 0;
                      index_23_34 = tmp1_run_0_12.sliceStart(glyphIndexOffset_24_35).readU16BE();
                      if (!(index_23_34 === 0)) {
                        index_23_34 = index_23_34 + delta_19_30 | 0;
                      }} else {
                      index_23_34 = c_22_33 + delta_19_30 | 0;
                    }
                    var tmp0_set_0_25_36 = $this._characterMaps;
                    var tmp1_set_0_26_37 = index_23_34 & 65535;
                    tmp0_set_0_25_36.put_18(c_22_33, tmp1_set_0_26_37);
                    Unit_getInstance();
                  }
                   while (!(c_22_33 === ec_17_28));
              }
               while (inductionVariable_0 < segCount_6_17);
            break;
          case 12:
            tmp1_run_0_12.readU16BE();
            Unit_getInstance();
            var length_27_38 = tmp1_run_0_12.readS32BE();
            var language_28_39 = tmp1_run_0_12.readS32BE();
            var numGroups_29_40 = tmp1_run_0_12.readS32BE();
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < numGroups_29_40)
              do {
                var n_31_42 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var startCharCode_32_43 = tmp1_run_0_12.readS32BE();
                var endCharCode_33_44 = tmp1_run_0_12.readS32BE();
                var startGlyphId_34_45 = tmp1_run_0_12.readS32BE();
                var glyphId_35_46 = startGlyphId_34_45;
                var inductionVariable_3 = startCharCode_32_43;
                if (inductionVariable_3 <= endCharCode_33_44)
                  do {
                    var c_37_48 = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var tmp2_set_0_38_49 = $this._characterMaps;
                    var tmp5_40_51 = glyphId_35_46;
                    glyphId_35_46 = tmp5_40_51 + 1 | 0;
                    var tmp3_set_0_39_50 = tmp5_40_51;
                    tmp2_set_0_38_49.put_18(c_37_48, tmp3_set_0_39_50);
                    Unit_getInstance();
                  }
                   while (!(c_37_48 === endCharCode_33_44));
              }
               while (inductionVariable_2 < numGroups_29_40);
            break;
          default:break;
        }
      }
      Unit_getInstance();
    }
    return Unit_getInstance();
  }
  function Contour(x, y, onCurve_0) {
    this._x_6 = x;
    this._y_5 = y;
    this._onCurve = onCurve_0;
  }
  Contour.prototype.toString = function () {
    return '' + 'Contour(x=' + this._x_6 + ', y=' + this._y_5 + ', onCurve=' + this._onCurve + ')';
  };
  Contour.prototype.hashCode = function () {
    var result = this._x_6;
    result = imul(result, 31) + this._y_5 | 0;
    result = imul(result, 31) + (this._onCurve | 0) | 0;
    return result;
  };
  Contour.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this._x_6 === tmp0_other_with_cast._x_6))
      return false;
    if (!(this._y_5 === tmp0_other_with_cast._y_5))
      return false;
    if (!(this._onCurve === tmp0_other_with_cast._onCurve))
      return false;
    return true;
  };
  Contour.$metadata$ = {
    simpleName: 'Contour',
    kind: 'class',
    interfaces: []
  };
  function GlyphReference(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this._glyph = glyph;
    this._x_7 = x;
    this._y_6 = y;
    this._scaleX_0 = scaleX;
    this._scale01 = scale01;
    this._scale10 = scale10;
    this._scaleY_0 = scaleY;
  }
  GlyphReference.prototype.toString = function () {
    return '' + 'GlyphReference(glyph=' + this._glyph + ', x=' + this._x_7 + ', y=' + this._y_6 + ', scaleX=' + this._scaleX_0 + ', scale01=' + this._scale01 + ', scale10=' + this._scale10 + ', scaleY=' + this._scaleY_0 + ')';
  };
  GlyphReference.prototype.hashCode = function () {
    var result = hashCode(this._glyph);
    result = imul(result, 31) + this._x_7 | 0;
    result = imul(result, 31) + this._y_6 | 0;
    result = imul(result, 31) + getNumberHashCode(this._scaleX_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scale01) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scale10) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scaleY_0) | 0;
    return result;
  };
  GlyphReference.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals_1(this._glyph, tmp0_other_with_cast._glyph))
      return false;
    if (!(this._x_7 === tmp0_other_with_cast._x_7))
      return false;
    if (!(this._y_6 === tmp0_other_with_cast._y_6))
      return false;
    if (!equals_1(this._scaleX_0, tmp0_other_with_cast._scaleX_0))
      return false;
    if (!equals_1(this._scale01, tmp0_other_with_cast._scale01))
      return false;
    if (!equals_1(this._scale10, tmp0_other_with_cast._scale10))
      return false;
    if (!equals_1(this._scaleY_0, tmp0_other_with_cast._scaleY_0))
      return false;
    return true;
  };
  GlyphReference.$metadata$ = {
    simpleName: 'GlyphReference',
    kind: 'class',
    interfaces: []
  };
  function Glyph_0($outer, index, xMin, yMin, xMax, yMax, advanceWidth) {
    this._$this_9 = $outer;
    this._index_12 = index;
    this._xMin = xMin;
    this._yMin = yMin;
    this._xMax = xMax;
    this._yMax = yMax;
    this._advanceWidth_0 = advanceWidth;
    var tmp = this;
    var size_2 = this._$this_9._unitsPerEm;
    var scale_3 = getTextScale_0(this._$this_9, size_2);
    tmp._metrics1px = new GlyphMetrics(size_2, true, -1, Companion_getInstance_83().fromBounds(this._xMin * scale_3, this._yMin * scale_3, this._xMax * scale_3, this._yMax * scale_3), this._advanceWidth_0 * scale_3);
  }
  Glyph_0.prototype._get_index__0 = function () {
    return this._index_12;
  };
  Glyph_0.prototype._get_advanceWidth__1 = function () {
    return this._advanceWidth_0;
  };
  Glyph_0.$metadata$ = {
    simpleName: 'Glyph',
    kind: 'class',
    interfaces: []
  };
  function CompositeGlyph($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth) {
    this._$this_10 = $outer;
    Glyph_0.call(this, $outer, index, xMin, yMin, xMax, yMax, advanceWidth);
    this._refs = refs;
    var tmp = this;
    var commandsSize_2 = 0;
    var dataSize_3 = 0;
    var tmp0_fastForEach_0_4 = this._refs;
    var n_1_5 = 0;
    while (n_1_5 < tmp0_fastForEach_0_4._get_size__60()) {
      var tmp0_2_7 = n_1_5;
      n_1_5 = tmp0_2_7 + 1 | 0;
      var tmp1__anonymous__3_6 = tmp0_fastForEach_0_4.get_137(tmp0_2_7);
      var gpath_4_8 = tmp1__anonymous__3_6._glyph._get_path__5();
      commandsSize_2 = commandsSize_2 + gpath_4_8._get_commands__0()._get_size__60() | 0;
      dataSize_3 = dataSize_3 + gpath_4_8._get_data__2()._get_size__60() | 0;
    }
    var tmp_0 = new IntArrayList(commandsSize_2);
    var tmp_1 = new DoubleArrayList(dataSize_3);
    var tmp2_also_0_9 = GraphicsPath_init_$Create$(tmp_0, tmp_1, null, 4, null);
    var tmp0_fastForEach_0_2_10 = this._refs;
    var n_1_3_11 = 0;
    while (n_1_3_11 < tmp0_fastForEach_0_2_10._get_size__60()) {
      var tmp0_2_5_13 = n_1_3_11;
      n_1_3_11 = tmp0_2_5_13 + 1 | 0;
      var tmp1__anonymous__3_4_12 = tmp0_fastForEach_0_2_10.get_137(tmp0_2_5_13);
      var m_4_6_14 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
      m_4_6_14.translate_1(tmp1__anonymous__3_4_12._x_7, -tmp1__anonymous__3_4_12._y_6 | 0);
      Unit_getInstance();
      m_4_6_14.scale_1(tmp1__anonymous__3_4_12._scaleX_0, tmp1__anonymous__3_4_12._scaleY_0);
      Unit_getInstance();
      tmp2_also_0_9.write_34(tmp1__anonymous__3_4_12._glyph._get_path__5(), m_4_6_14);
    }
    tmp._path_20 = tmp2_also_0_9;
  }
  CompositeGlyph.prototype.toString = function () {
    return '' + 'CompositeGlyph[' + this._get_advanceWidth__1() + '](' + this._refs + ')';
  };
  CompositeGlyph.prototype._get_path__5 = function () {
    return this._path_20;
  };
  CompositeGlyph.$metadata$ = {
    simpleName: 'CompositeGlyph',
    kind: 'class',
    interfaces: []
  };
  function SimpleGlyph($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth) {
    this._$this_11 = $outer;
    Glyph_0.call(this, $outer, index, xMin, yMin, xMax, yMax, advanceWidth);
    this._contoursIndices = contoursIndices;
    this._flags = flags;
    this._xPos = xPos;
    this._yPos = yPos;
    var tmp = this;
    var commandSize_2 = 0;
    var dataSize_3 = 0;
    var inductionVariable = 0;
    var last_1 = this._contoursIndices.length - 1 | 0;
    if (inductionVariable < last_1)
      do {
        var n_2_5 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart_3_6 = this._contoursIndices[n_2_5] + 1 | 0;
        var cend_4_7 = this._contoursIndices[n_2_5 + 1 | 0];
        var csize_5_8 = (cend_4_7 - cstart_3_6 | 0) + 1 | 0;
        commandSize_2 = commandSize_2 + (1 + imul(csize_5_8, 2) | 0) | 0;
        dataSize_3 = dataSize_3 + (2 + imul(csize_5_8, 8) | 0) | 0;
      }
       while (inductionVariable < last_1);
    var tmp_0 = new IntArrayList(commandSize_2);
    var tmp_1 = new DoubleArrayList(dataSize_3);
    var tmp0_also_0_9 = GraphicsPath_init_$Create$(tmp_0, tmp_1, null, 4, null);
    var inductionVariable_0 = 0;
    var last_2 = this._contoursIndices.length - 1 | 0;
    if (inductionVariable_0 < last_2)
      do {
        var n_2_3_11 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_3_4_12 = this._contoursIndices[n_2_3_11] + 1 | 0;
        var cend_4_5_13 = this._contoursIndices[n_2_3_11 + 1 | 0];
        var csize_5_6_14 = (cend_4_5_13 - cstart_3_4_12 | 0) + 1 | 0;
        var curr_7_7_15 = contour(this, cend_4_5_13, this._$this_11._tempContours[0]);
        var next_8_8_16 = contour(this, cstart_3_4_12, this._$this_11._tempContours[1]);
        if (curr_7_7_15._onCurve)
          moveTo(tmp0_also_0_9, curr_7_7_15._x_6, -curr_7_7_15._y_5 | 0);
        else if (next_8_8_16._onCurve)
          moveTo(tmp0_also_0_9, next_8_8_16._x_6, -next_8_8_16._y_5 | 0);
        else
          moveTo(tmp0_also_0_9, imul(curr_7_7_15._x_6 + next_8_8_16._x_6 | 0, 0), -numberToInt((curr_7_7_15._y_5 + next_8_8_16._y_5 | 0) * 0.5) | 0);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_5_6_14)
          do {
            var cpos_10_10_18 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev_11_11_19 = curr_7_7_15;
            curr_7_7_15 = next_8_8_16;
            next_8_8_16 = contour(this, cstart_3_4_12 + (cpos_10_10_18 + 1 | 0) % csize_5_6_14 | 0, this._$this_11._tempContours[(cpos_10_10_18 + 2 | 0) % 3]);
            if (curr_7_7_15._onCurve) {
              lineTo(tmp0_also_0_9, curr_7_7_15._x_6, -curr_7_7_15._y_5 | 0);
            } else {
              var prev2X_12_12_20 = prev_11_11_19._x_6;
              var prev2Y_13_13_21 = prev_11_11_19._y_5;
              var next2X_14_14_22 = next_8_8_16._x_6;
              var next2Y_15_15_23 = next_8_8_16._y_5;
              if (!prev_11_11_19._onCurve) {
                prev2X_12_12_20 = numberToInt((curr_7_7_15._x_6 + prev_11_11_19._x_6 | 0) * 0.5);
                prev2Y_13_13_21 = numberToInt((curr_7_7_15._y_5 + prev_11_11_19._y_5 | 0) * 0.5);
                lineTo(tmp0_also_0_9, prev2X_12_12_20, -prev2Y_13_13_21 | 0);
              }if (!next_8_8_16._onCurve) {
                next2X_14_14_22 = numberToInt((curr_7_7_15._x_6 + next_8_8_16._x_6 | 0) * 0.5);
                next2Y_15_15_23 = numberToInt((curr_7_7_15._y_5 + next_8_8_16._y_5 | 0) * 0.5);
              }lineTo(tmp0_also_0_9, prev2X_12_12_20, -prev2Y_13_13_21 | 0);
              quadTo(tmp0_also_0_9, curr_7_7_15._x_6, -curr_7_7_15._y_5 | 0, next2X_14_14_22, -next2Y_15_15_23 | 0);
            }
          }
           while (inductionVariable_1 < csize_5_6_14);
        tmp0_also_0_9.close_77();
      }
       while (inductionVariable_0 < last_2);
    tmp._path_21 = tmp0_also_0_9;
  }
  SimpleGlyph.prototype.toString = function () {
    return '' + 'SimpleGlyph[' + this._get_advanceWidth__1() + '](' + this._get_index__0() + ') : ' + this._path_21;
  };
  SimpleGlyph.prototype._get_path__5 = function () {
    return this._path_21;
  };
  SimpleGlyph.$metadata$ = {
    simpleName: 'SimpleGlyph',
    kind: 'class',
    interfaces: []
  };
  function readF2DOT14(_this_, $this) {
    var v = _this_.readS16BE();
    var i = v >> 14;
    var f = v & 16383;
    return i + f / 16384.0;
  }
  function readMixBE(_this_, $this, signed, word) {
    var tmp;
    if (!word ? signed : false) {
      tmp = _this_.readS8();
    } else if (!word ? !signed : false) {
      tmp = _this_.readU8();
    } else if (word ? signed : false) {
      tmp = _this_.readS16BE();
    } else if (word ? !signed : false) {
      tmp = _this_.readU16BE();
    } else {
      _get_invalidOp_();
    }
    return tmp;
  }
  function readGlyph(_this_, $this, index) {
    var ncontours = _this_.readS16BE();
    var xMin = _this_.readS16BE();
    var yMin = _this_.readS16BE();
    var xMax = _this_.readS16BE();
    var yMax = _this_.readS16BE();
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      var references = ArrayList_init_$Create$();
      do {
        var flags = _this_.readU16BE();
        var glyphIndex = _this_.readU16BE();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = readMixBE(_this_, $this, signed, words);
        var y = readMixBE(_this_, $this, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = readF2DOT14(_this_, $this);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = readF2DOT14(_this_, $this);
          scaleY = readF2DOT14(_this_, $this);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = readF2DOT14(_this_, $this);
          scale01 = readF2DOT14(_this_, $this);
          scale10 = readF2DOT14(_this_, $this);
          scaleY = readF2DOT14(_this_, $this);
        }var ref = new GlyphReference(ensureNotNull($this.getGlyphByIndex$default(glyphIndex, false, 2, null)), x, y, scaleX, scale01, scale10, scaleY);
        references.add_39(ref);
        Unit_getInstance();
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      return new CompositeGlyph($this, index, xMin, yMin, xMax, yMax, references, $this._horMetrics.get_137(index)._advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this_.readU16BE();
        }
         while (!(n === ncontours));
      var instructionLength = _this_.readU16BE();
      var instructions = _this_.readBytesExact(instructionLength);
      var tmp1_safe_receiver = lastOrNull(contoursIndices);
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver + 1 | 0;
      var numPoints = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
      var flags_0 = IntArrayList_init_$Create$(0, 1, null);
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this_.readU8();
        flags_0.add_26(cf);
        if (!((cf & 8) === 0)) {
          var count_0 = _this_.readU8();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count_0)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.add_26(cf);
            }
             while (inductionVariable_0 < count_0);
          npos = npos + (count_0 + 1 | 0) | 0;
        } else {
          var tmp4 = npos;
          npos = tmp4 + 1 | 0;
          Unit_getInstance();
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy_1 === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.getAt_0(n_1);
              var b1 = !((flag >>> (1 + xy_1 | 0) & 1) === 0);
              var b2 = !((flag >>> (4 + xy_1 | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this_.readU8();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this_.readS16BE() | 0;
              }pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      return new SimpleGlyph($this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.toIntArray(), xPos, yPos, $this._horMetrics.get_137(index)._advanceWidth);
    }
  }
  function EncodingRecord(platformId, encodingId, offset) {
    this._platformId = platformId;
    this._encodingId = encodingId;
    this._offset_21 = offset;
  }
  EncodingRecord.prototype.toString = function () {
    return '' + 'EncodingRecord(platformId=' + this._platformId + ', encodingId=' + this._encodingId + ', offset=' + this._offset_21 + ')';
  };
  EncodingRecord.prototype.hashCode = function () {
    var result = this._platformId;
    result = imul(result, 31) + this._encodingId | 0;
    result = imul(result, 31) + this._offset_21 | 0;
    return result;
  };
  EncodingRecord.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EncodingRecord))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof EncodingRecord ? other : THROW_CCE();
    if (!(this._platformId === tmp0_other_with_cast._platformId))
      return false;
    if (!(this._encodingId === tmp0_other_with_cast._encodingId))
      return false;
    if (!(this._offset_21 === tmp0_other_with_cast._offset_21))
      return false;
    return true;
  };
  EncodingRecord.$metadata$ = {
    simpleName: 'EncodingRecord',
    kind: 'class',
    interfaces: []
  };
  function NameId_NAME_getInstance() {
    NameId_initEntries();
    return NameId_NAME_instance;
  }
  function NameId_COMPLETE_NAME_getInstance() {
    NameId_initEntries();
    return NameId_COMPLETE_NAME_instance;
  }
  function TtfFont(s, freeze, extName) {
    this._s_5 = s;
    this._freeze = freeze;
    this._extName = extName;
    this._names = LinkedHashMap_init_$Create$();
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 3;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Contour_init_$Create$(0, 0, false, 7, null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._tempContours = tmp_2;
    this._numGlyphs = 0;
    this._maxPoints = 0;
    this._maxContours = 0;
    this._maxCompositePoints = 0;
    this._maxCompositeContours = 0;
    this._maxZones = 0;
    this._maxTwilightPoints = 0;
    this._maxStorage = 0;
    this._maxFunctionDefs = 0;
    this._maxInstructionDefs = 0;
    this._maxStackElements = 0;
    this._maxSizeOfInstructions = 0;
    this._maxComponentElements = 0;
    this._maxComponentDepth = 0;
    this._hheaVersion = Companion_getInstance_111().invoke_395(0, 0);
    this._ascender = 0;
    this._descender = 0;
    this._lineGap = 0;
    this._advanceWidthMax = 0;
    this._minLeftSideBearing = 0;
    this._minRightSideBearing = 0;
    this._xMaxExtent = 0;
    this._caretSlopeRise = 0;
    this._caretSlopeRun = 0;
    this._caretOffset = 0;
    this._metricDataFormat = 0;
    this._numberOfHMetrics = 0;
    this._locs = new Int32Array(0);
    this._fontRev = Companion_getInstance_111().invoke_395(0, 0);
    this._unitsPerEm = 128;
    this._xMin_0 = 0;
    this._yMin_0 = 0;
    this._xMax_0 = 0;
    this._yMax_0 = 0;
    this._macStyle = 0;
    this._lowestRecPPEM = 0;
    this._fontDirectionHint = 0;
    this._indexToLocFormat = 0;
    this._glyphDataFormat = 0;
    var tmp_4 = this;
    tmp_4._horMetrics = emptyList();
    this._characterMaps = LinkedHashMap_init_$Create$();
    this._tablesByName = LinkedHashMap_init_$Create$();
    var tmp_5 = this;
    tmp_5._glyphCache = IntMap_init_$Create$(512, 0.0, 2, null);
    this._frozen = false;
    readHeaderTables(this);
    Unit_getInstance();
    readHead(this);
    readMaxp(this);
    readHhea(this);
    readNames(this);
    readLoca(this);
    readCmap(this);
    readHmtx(this);
    if (this._freeze) {
      var tmp0_fastForEach_0 = this.getAllGlyphs(true);
      var n_1 = 0;
      while (n_1 < tmp0_fastForEach_0._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
        Unit_getInstance();
        tmp1__anonymous__3._get_path__5();
        Unit_getInstance();
      }
    }this._frozen = true;
    var tmp_6 = this;
    var tmp0_also_0 = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
    var scale_2 = getTextScale_0(this, 1.0);
    tmp0_also_0._size_10 = 1.0;
    tmp0_also_0._top = this._yMax_0 * scale_2;
    tmp0_also_0._ascent = this._ascender * scale_2;
    tmp0_also_0._baseline = 0.0 * scale_2;
    tmp0_also_0._descent = this._descender * scale_2;
    tmp0_also_0._bottom = this._yMin_0 * scale_2;
    tmp0_also_0._leading = this._lineGap * scale_2;
    tmp0_also_0._maxWidth = this._advanceWidthMax * scale_2;
    tmp_6._fontMetrics1px = tmp0_also_0;
    this._nonExistantGlyphMetrics1px = new GlyphMetrics(1.0, false, 0, Companion_getInstance_83().invoke_1005(), 0.0);
  }
  TtfFont.prototype.getFontMetrics_1 = function (size_1, metrics) {
    return metrics.copyFromNewSize(this._fontMetrics1px, size_1);
  };
  TtfFont.prototype.getGlyphMetrics_3 = function (size_1, codePoint, metrics) {
    var tmp0_safe_receiver = this.getGlyphByCodePoint$default(codePoint, false, 2, null);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._metrics1px;
    return metrics.copyFromNewSize_0(tmp1_elvis_lhs == null ? this._nonExistantGlyphMetrics1px : tmp1_elvis_lhs, size_1, codePoint);
  };
  TtfFont.prototype.getKerning_3 = function (size_1, leftCodePoint, rightCodePoint) {
    return 0.0;
  };
  TtfFont.prototype.getGlyphPath_0 = function (size_1, codePoint, path_0) {
    var tmp0_elvis_lhs = this.getGlyphByCodePoint$default(codePoint, false, 2, null);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale_1 = getTextScale_0(this, size_1);
    path_0._path_19 = g._get_path__5();
    path_0._transform_1.identity_0();
    Unit_getInstance();
    path_0._transform_1.scale_2(scale_1, scale_1);
    Unit_getInstance();
    return path_0;
  };
  TtfFont.prototype._get_ttfName_ = function () {
    var tmp0_elvis_lhs = this.getName_0(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.getName_0(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  };
  TtfFont.prototype._get_name__50 = function () {
    var tmp0_elvis_lhs = this._extName;
    return tmp0_elvis_lhs == null ? this._get_ttfName_() : tmp0_elvis_lhs;
  };
  TtfFont.prototype.toString = function () {
    return '' + 'TtfFont(name=' + this._get_name__50() + ')';
  };
  TtfFont.prototype.readFixed = function (_this__0) {
    return Companion_getInstance_111().invoke_395(_this__0.readS16LE(), _this__0.readS16LE());
  };
  TtfFont.prototype.openTable = function (name) {
    var tmp0_safe_receiver = this._tablesByName.get_116(name);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.open_11();
  };
  TtfFont.prototype.getName = function (nameId) {
    return this._names.get_116(nameId);
  };
  TtfFont.prototype.getName_0 = function (nameId) {
    return this.getName(nameId._id_5);
  };
  TtfFont.prototype.getGlyphByCodePoint = function (codePoint, cache) {
    var tmp0_safe_receiver = getCharacterMapOrNull(this, codePoint);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = this.getGlyphByIndex(tmp0_safe_receiver, cache);
    }
    return tmp;
  };
  TtfFont.prototype.getGlyphByCodePoint$default = function (codePoint, cache, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      cache = true;
    return this.getGlyphByCodePoint(codePoint, cache);
  };
  TtfFont.prototype.getGlyphByIndex = function (index, cache) {
    var tmp0_elvis_lhs = getOrNull_0(this._locs, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this._locs, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size_1 = end - start | 0;
    var tmp;
    if (!(size_1 === 0)) {
      var tmp2_elvis_lhs = this._glyphCache.get_137(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp0_runTable_0 = 'glyf';
        var tmp0_safe_receiver_1 = this.openTable(tmp0_runTable_0);
        var tmp_1;
        if (tmp0_safe_receiver_1 == null) {
          tmp_1 = null;
        } else {
          var tmp1__anonymous__2 = ensureNotNull(this._tablesByName.get_116(tmp0_runTable_0));
          tmp_1 = readGlyph(tmp0_safe_receiver_1.sliceStart(start), this, index);
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      var tmp2_intArrayOf_0 = new Int32Array([]);
      var tmp3_intArrayOf_0 = new Int32Array([]);
      var tmp4_intArrayOf_0 = new Int32Array([]);
      var tmp5_intArrayOf_0 = new Int32Array([]);
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp2_intArrayOf_0, tmp3_intArrayOf_0, tmp4_intArrayOf_0, tmp5_intArrayOf_0, this._horMetrics.get_137(index)._advanceWidth);
    }
    var glyph = tmp;
    if (cache ? !this._frozen : false) {
      this._glyphCache.set_7(index, glyph);
      Unit_getInstance();
    }return glyph;
  };
  TtfFont.prototype.getGlyphByIndex$default = function (index, cache, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      cache = true;
    return this.getGlyphByIndex(index, cache);
  };
  TtfFont.prototype.getAllGlyphs = function (cache) {
    var tmp0_mapNotNull_0 = until(0, this._numGlyphs);
    var tmp0_mapNotNullTo_0_1 = ArrayList_init_$Create$();
    var inductionVariable = tmp0_mapNotNull_0._get_first__6();
    var last_1 = tmp0_mapNotNull_0._get_last__6();
    if (inductionVariable <= last_1)
      do {
        var element_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver_2_4_4 = this.getGlyphByIndex(element_2_3, cache);
        if (tmp0_safe_receiver_2_4_4 == null)
          null;
        else {
          tmp0_mapNotNullTo_0_1.add_39(tmp0_safe_receiver_2_4_4);
          Unit_getInstance();
        }
        Unit_getInstance();
      }
       while (!(element_2_3 === last_1));
    return tmp0_mapNotNullTo_0_1;
  };
  TtfFont.$metadata$ = {
    simpleName: 'TtfFont',
    kind: 'class',
    interfaces: [VectorFont]
  };
  function Companion_112() {
    Companion_instance_111 = this;
  }
  Companion_112.prototype.invoke_395 = function (num, den) {
    return insert(insert(0, num, 0, 16), den, 16, 16);
  };
  Companion_112.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_111;
  function Companion_getInstance_111() {
    if (Companion_instance_111 == null)
      new Companion_112();
    return Companion_instance_111;
  }
  function readTtfFont(_this_, preload, $cont) {
    var tmp = new $readTtfFontCOROUTINE$7(_this_, preload, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function $readTtfFontCOROUTINE$7(_this_, preload, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__126 = _this_;
    this._preload_0 = preload;
  }
  $readTtfFontCOROUTINE$7.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__126.readAll_0(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return TtfFont_init_$Create$(ARGUMENT, this._preload_0, _get_baseName_(this.__this__126));
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readTtfFontCOROUTINE$7.$metadata$ = {
    simpleName: '$readTtfFontCOROUTINE$7',
    kind: 'class',
    interfaces: []
  };
  function VectorFont() {
  }
  VectorFont.prototype.getGlyphPath$default_0 = function (size_1, codePoint, path_0, $mask0, $handler) {
    if (!(($mask0 & 4) === 0)) {
      path_0 = GlyphPath_init_$Create$(null, null, 3, null);
    }return $handler == null ? this.getGlyphPath_0(size_1, codePoint, path_0) : $handler(size_1, codePoint, path_0);
  };
  VectorFont.prototype.renderGlyph_2 = function (ctx, size_1, codePoint, x, y, fill_3, metrics) {
    this.getGlyphMetrics_3(size_1, codePoint, metrics);
    Unit_getInstance();
    var g = this.getGlyphPath$default_0(size_1, codePoint, null, 4, null);
    if (!(g == null)) {
      var t_1 = ctx._state_4._transform_6;
      var a_2 = t_1._a;
      var b_3 = t_1._b;
      var c_4 = t_1._c;
      var d_5 = t_1._d;
      var tx_6 = t_1._tx;
      var ty_7 = t_1._ty;
      try {
        ctx.translate_2(x, y);
        Unit_getInstance();
        g.draw_10(ctx);
      }finally {
        t_1.setTo(a_2, b_3, c_4, d_5, tx_6, ty_7);
        Unit_getInstance();
      }
      if (fill_3)
        ctx.fill_6();
      else
        ctx.stroke_0();
    }};
  VectorFont.$metadata$ = {
    simpleName: 'VectorFont',
    kind: 'interface',
    interfaces: [Font]
  };
  function BmImageInfo() {
    ImageInfo.call(this);
    this._flipX = false;
    this._flipY = false;
  }
  BmImageInfo.$metadata$ = {
    simpleName: 'BmImageInfo',
    kind: 'class',
    interfaces: []
  };
  function BMP() {
    BMP_instance = this;
    ImageFormat.call(this, ['bmp']);
  }
  BMP.prototype.decodeHeader_4 = function (s, props) {
    if (!(readStringz$default(s, 2, null, 2, null) === 'BM'))
      return null;
    else {
    }
    var size_1 = readS32LE_1(s);
    var reserved1 = readS16LE_1(s);
    var reserved2 = readS16LE_1(s);
    var offBits = readS32LE_1(s);
    var bsize = readS32LE_1(s);
    var width = readS32LE_1(s);
    var height = readS32LE_1(s);
    var planes = readS16LE_1(s);
    var bitcount = readS16LE_1(s);
    var tmp0_apply_0 = new BmImageInfo();
    tmp0_apply_0._flipX = width < 0;
    tmp0_apply_0._flipY = height >= 0;
    tmp0_apply_0._set_width__5(abs(width));
    tmp0_apply_0._set_height__5(abs(height));
    tmp0_apply_0._set_bitsPerPixel__0(bitcount);
    return tmp0_apply_0;
  };
  BMP.prototype.readImage_4 = function (s, props) {
    var tmp0_elvis_lhs = this.decodeHeader_4(s, props);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('Not a BMP file');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var h = tmp;
    var compression = readS32LE_1(s);
    var sizeImage = readS32LE_1(s);
    var pixelsPerMeterX = readS32LE_1(s);
    var pixelsPerMeterY = readS32LE_1(s);
    var clrUsed = readS32LE_1(s);
    var clrImportant = readS32LE_1(s);
    var tmp1_subject = h._get_bitsPerPixel__0();
    var tmp_0;
    switch (tmp1_subject) {
      case 8:
        var tmp_1 = h._get_width__58();
        var tmp_2 = h._get_height__58();
        var out = Bitmap8_init_$Create$(tmp_1, tmp_2, null, null, 12, null);
        var inductionVariable = 0;
        if (inductionVariable < 256)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            RgbaArray__set_impl(out._get_palette__0(), n, Companion_getInstance_104().invoke_377(readS32LE_1(s), 255));
          }
           while (inductionVariable < 256);
        var inductionVariable_0 = 0;
        var last_1 = h._get_height__58();
        if (inductionVariable_0 < last_1)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.setRow_0((h._get_height__58() - n_0 | 0) - 1 | 0, readBytes_0(s, h._get_width__58()));
          }
           while (inductionVariable_0 < last_1);
        var tmp_3 = listOf_0(ImageFrame_init_$Create$(out, null, 0, 0, false, 30, null));
        tmp_0 = ImageData_init_$Create$(tmp_3, 0, 0, 0, 14, null);
        break;
      case 24:
      case 32:
        var bytesPerRow = imul(h._get_width__58(), h._get_bitsPerPixel__0()) / 8 | 0;
        var tmp_4 = h._get_width__58();
        var tmp_5 = h._get_height__58();
        var out_0 = Bitmap32_init_$Create$(tmp_4, tmp_5, null, false, 12, null);
        var row = new Int8Array(bytesPerRow);
        var format_0 = h._get_bitsPerPixel__0() === 24 ? BGR_getInstance() : BGRA_getInstance();
        var padding = 4 - bytesPerRow % 4 | 0;
        var flipY = h._flipY;
        var inductionVariable_1 = 0;
        var last_2 = h._get_height__58();
        if (inductionVariable_1 < last_2)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var y = h._flipY ? (h._get_height__58() - n_1 | 0) - 1 | 0 : n_1;
            s.read$default_1(row, 0, 0, 6, null);
            Unit_getInstance();
            var tmp_6 = out_0.index_7(0, y);
            var tmp_7 = h._get_width__58();
            decode$default(format_0, row, 0, out_0._data_39, tmp_6, tmp_7, false, 32, null);
            if (!(padding === 0)) {
              skip(s, padding);
              Unit_getInstance();
            }}
           while (inductionVariable_1 < last_2);
        var tmp_8 = listOf_0(ImageFrame_init_$Create$(out_0, null, 0, 0, false, 30, null));
        tmp_0 = ImageData_init_$Create$(tmp_8, 0, 0, 0, 14, null);
        break;
      default:var tmp0_TODO_0 = '' + 'Unsupported bitsPerPixel=' + h._get_bitsPerPixel__0();
        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
    }
    return tmp_0;
  };
  BMP.prototype.writeImage_4 = function (image, s, props) {
    var bmp = image._get_mainBitmap_().toBMP32_5();
    write8_1(s, 66);
    write8_1(s, 77);
    write32LE_0(s, imul(4, bmp._get_area__7()));
    write32LE_0(s, 0);
    write32LE_0(s, 54);
    write32LE_0(s, 40);
    write32LE_0(s, bmp._get_width__58());
    write32LE_0(s, imul(bmp._get_height__58(), 2));
    write16LE_1(s, 1);
    write16LE_1(s, 32);
    write32LE_0(s, 0);
    write32LE_0(s, imul(4, bmp._get_area__7()));
    write32LE_0(s, 2834);
    write32LE_0(s, 2834);
    write32LE_0(s, 0);
    write32LE_0(s, 0);
    var inductionVariable = 0;
    var last_1 = bmp._get_height__58();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = (bmp._get_height__58() - 1 | 0) - n | 0;
        writeBytes_0(s, encode_0(BGRA_getInstance(), bmp._data_39, imul(y, bmp._get_width__58()), bmp._get_width__58(), true));
      }
       while (inductionVariable < last_1);
  };
  BMP.$metadata$ = {
    simpleName: 'BMP',
    kind: 'object',
    interfaces: []
  };
  var BMP_instance;
  function BMP_getInstance() {
    if (BMP_instance == null)
      new BMP();
    return BMP_instance;
  }
  var fourcc$delegate;
  function _no_name_provided__232() {
  }
  _no_name_provided__232.prototype.invoke_1005 = function () {
    return '    ';
  };
  _no_name_provided__232.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_192() {
    var i = new _no_name_provided__232();
    return function () {
      return i.invoke_1005();
    };
  }
  function ImageData_init_$Init$(frames, loopCount, width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      loopCount = 0;
    if (!(($mask0 & 4) === 0)) {
      var tmp0_safe_receiver = firstOrNull(frames);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_width__58();
      width = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    }if (!(($mask0 & 8) === 0)) {
      var tmp2_safe_receiver = firstOrNull(frames);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver._get_height__58();
      height = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    }ImageData_0.call($this, frames, loopCount, width, height);
    return $this;
  }
  function ImageData_init_$Create$(frames, loopCount, width, height, $mask0, $marker) {
    return ImageData_init_$Init$(frames, loopCount, width, height, $mask0, $marker, Object.create(ImageData_0.prototype));
  }
  function sam$kotlin_Comparator$0_2(function_0) {
    this._function_3 = function_0;
  }
  sam$kotlin_Comparator$0_2.prototype.compare_10 = function (a, b) {
    return this._function_3(a, b);
  };
  sam$kotlin_Comparator$0_2.prototype.compare = function (a, b) {
    return this.compare_10(a, b);
  };
  sam$kotlin_Comparator$0_2.$metadata$ = {
    simpleName: 'sam$kotlin_Comparator$0',
    kind: 'class',
    interfaces: [Comparator]
  };
  function _no_name_provided__233() {
  }
  _no_name_provided__233.prototype.invoke_397 = function (a, b) {
    var tmp;
    if (a._main) {
      tmp = IntCompanionObject_getInstance()._MAX_VALUE_4;
    } else {
      tmp = imul(imul(a._bitmap_0._width_2, a._bitmap_0._height_2), imul(a._bitmap_0._bpp, a._bitmap_0._bpp));
    }
    var tmp_0 = tmp;
    var tmp_1;
    if (b._main) {
      tmp_1 = IntCompanionObject_getInstance()._MAX_VALUE_4;
    } else {
      tmp_1 = imul(imul(b._bitmap_0._width_2, b._bitmap_0._height_2), imul(b._bitmap_0._bpp, b._bitmap_0._bpp));
    }
    return compareValues(tmp_0, tmp_1);
  };
  _no_name_provided__233.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof ImageFrame ? p1 : THROW_CCE();
    return this.invoke_397(tmp, p2 instanceof ImageFrame ? p2 : THROW_CCE());
  };
  _no_name_provided__233.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ImageData_0(frames, loopCount, width, height) {
    this._frames = frames;
    this._loopCount = loopCount;
    this._width_4 = width;
    this._height_4 = height;
    var tmp = this;
    tmp._$$delegate_0_10 = Mixin_init_$Create$(null, 1, null);
  }
  ImageData_0.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_10._extra = _set___;
  };
  ImageData_0.prototype._get_extra__71 = function () {
    return this._$$delegate_0_10._extra;
  };
  ImageData_0.prototype._get_mainBitmap_ = function () {
    var tmp0_sortedBy_0 = this._frames;
    var tmp = _no_name_provided_$factory_193();
    var tmp0_safe_receiver = firstOrNull(sortedWith(tmp0_sortedBy_0, new sam$kotlin_Comparator$0_2(tmp)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._bitmap_0;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('No bitmap found');
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  ImageData_0.prototype.toString = function () {
    return '' + 'ImageData(' + this._frames + ')';
  };
  ImageData_0.$metadata$ = {
    simpleName: 'ImageData',
    kind: 'class',
    interfaces: [Extra]
  };
  function _no_name_provided_$factory_193() {
    var i = new _no_name_provided__233();
    return function (p1, p2) {
      return i.invoke_397(p1, p2);
    };
  }
  function ImageFormat(exts) {
    var tmp = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(exts.length);
    var indexedObject = exts;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var item_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_trim_0_5 = item_2_3.toLowerCase();
      tmp0_mapTo_0_1.add_39(toString_1(trim_0(isCharSequence(tmp0_trim_0_5) ? tmp0_trim_0_5 : THROW_CCE())));
      Unit_getInstance();
    }
    tmp._extensions_0 = toSet_0(tmp0_mapTo_0_1);
  }
  ImageFormat.prototype.readImage_4 = function (s, props) {
    throw NotImplementedError_init_$Create$(null, 1, null);
  };
  ImageFormat.prototype.writeImage_4 = function (image, s, props) {
    throw UnsupportedOperationException_init_$Create$();
  };
  ImageFormat.prototype.decodeHeader_4 = function (s, props) {
    var tmp0_runIgnoringExceptions_0 = true;
    var tmp;
    try {
      var bmp_3 = this.read_47(s, props);
      var tmp0_apply_0_4 = new ImageInfo();
      tmp0_apply_0_4._width_6 = bmp_3._width_2;
      tmp0_apply_0_4._height_6 = bmp_3._height_2;
      tmp0_apply_0_4._bitsPerPixel = bmp_3._bpp;
      tmp = tmp0_apply_0_4;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        if (tmp0_runIgnoringExceptions_0)
          printStackTrace($p);
        tmp_0 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  ImageFormat.prototype.read_47 = function (s, props) {
    return this.readImage_4(s, props)._get_mainBitmap_();
  };
  ImageFormat.prototype.check_4 = function (s, props) {
    var tmp0_runIgnoringExceptions_0 = true;
    var tmp;
    try {
      tmp = !(this.decodeHeader_4(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        if (tmp0_runIgnoringExceptions_0)
          printStackTrace($p);
        tmp_0 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  };
  ImageFormat.prototype.decode_31 = function (s, props) {
    return this.read_47(openSync$default(s, null, 1, null), props);
  };
  ImageFormat.prototype.decode$default_9 = function (s, props, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      props = ImageDecodingProps_init_$Create$(null, null, null, null, 15, null);
    }return this.decode_31(s, props);
  };
  ImageFormat.prototype.encode_20 = function (frames, props) {
    var tmp0_MemorySyncStreamToByteArray_0 = imul(_get_area_(frames), 4);
    var buffer_1 = ByteArrayBuilder_init_$Create$_0(tmp0_MemorySyncStreamToByteArray_0);
    var s_2 = MemorySyncStream_0(buffer_1);
    this.writeImage_4(ImageData_init_$Create$(frames, 0, 0, 0, 14, null), s_2, props);
    return buffer_1.toByteArray();
  };
  ImageFormat.prototype.encode_21 = function (bitmap, props) {
    return this.encode_20(listOf_0(ImageFrame_init_$Create$(bitmap, null, 0, 0, false, 30, null)), props);
  };
  ImageFormat.prototype.encode$default_8 = function (bitmap, props, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      props = ImageEncodingProps_init_$Create$('unknown', 0.0, null, 6, null);
    }return this.encode_21(bitmap, props);
  };
  ImageFormat.prototype.toString = function () {
    return '' + 'ImageFormat(' + this._extensions_0 + ')';
  };
  ImageFormat.$metadata$ = {
    simpleName: 'ImageFormat',
    kind: 'class',
    interfaces: []
  };
  function ImageDecodingProps_init_$Init$(filename, width, height, extra, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      filename = 'unknown';
    if (!(($mask0 & 2) === 0))
      width = null;
    if (!(($mask0 & 4) === 0))
      height = null;
    if (!(($mask0 & 8) === 0))
      extra = null;
    ImageDecodingProps.call($this, filename, width, height, extra);
    return $this;
  }
  function ImageDecodingProps_init_$Create$(filename, width, height, extra, $mask0, $marker) {
    return ImageDecodingProps_init_$Init$(filename, width, height, extra, $mask0, $marker, Object.create(ImageDecodingProps.prototype));
  }
  function ImageDecodingProps(filename, width, height, extra) {
    this._filename = filename;
    this._width_5 = width;
    this._height_5 = height;
    this._extra_1 = extra;
  }
  ImageDecodingProps.prototype._set_extra__71 = function (_set___) {
    this._extra_1 = _set___;
  };
  ImageDecodingProps.prototype._get_extra__71 = function () {
    return this._extra_1;
  };
  ImageDecodingProps.prototype.copy_13 = function (filename, width, height, extra) {
    return new ImageDecodingProps(filename, width, height, extra);
  };
  ImageDecodingProps.prototype.copy$default_7 = function (filename, width, height, extra, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      filename = this._filename;
    if (!(($mask0 & 2) === 0))
      width = this._width_5;
    if (!(($mask0 & 4) === 0))
      height = this._height_5;
    if (!(($mask0 & 8) === 0))
      extra = this._extra_1;
    return this.copy_13(filename, width, height, extra);
  };
  ImageDecodingProps.prototype.toString = function () {
    return '' + 'ImageDecodingProps(filename=' + this._filename + ', width=' + this._width_5 + ', height=' + this._height_5 + ', extra=' + this._extra_1 + ')';
  };
  ImageDecodingProps.prototype.hashCode = function () {
    var result = getStringHashCode(this._filename);
    result = imul(result, 31) + (this._width_5 == null ? 0 : this._width_5) | 0;
    result = imul(result, 31) + (this._height_5 == null ? 0 : this._height_5) | 0;
    result = imul(result, 31) + (this._extra_1 == null ? 0 : this._extra_1.hashCode()) | 0;
    return result;
  };
  ImageDecodingProps.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this._filename === tmp0_other_with_cast._filename))
      return false;
    if (!(this._width_5 == tmp0_other_with_cast._width_5))
      return false;
    if (!(this._height_5 == tmp0_other_with_cast._height_5))
      return false;
    if (!equals_1(this._extra_1, tmp0_other_with_cast._extra_1))
      return false;
    return true;
  };
  ImageDecodingProps.$metadata$ = {
    simpleName: 'ImageDecodingProps',
    kind: 'class',
    interfaces: [Extra]
  };
  function ImageEncodingProps_init_$Init$(filename, quality, extra, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      filename = '';
    if (!(($mask0 & 2) === 0))
      quality = 0.81;
    if (!(($mask0 & 4) === 0))
      extra = null;
    ImageEncodingProps.call($this, filename, quality, extra);
    return $this;
  }
  function ImageEncodingProps_init_$Create$(filename, quality, extra, $mask0, $marker) {
    return ImageEncodingProps_init_$Init$(filename, quality, extra, $mask0, $marker, Object.create(ImageEncodingProps.prototype));
  }
  function ImageEncodingProps(filename, quality, extra) {
    this._filename_0 = filename;
    this._quality = quality;
    this._extra_2 = extra;
  }
  ImageEncodingProps.prototype._set_extra__71 = function (_set___) {
    this._extra_2 = _set___;
  };
  ImageEncodingProps.prototype._get_extra__71 = function () {
    return this._extra_2;
  };
  ImageEncodingProps.prototype.toString = function () {
    return '' + 'ImageEncodingProps(filename=' + this._filename_0 + ', quality=' + this._quality + ', extra=' + this._extra_2 + ')';
  };
  ImageEncodingProps.prototype.hashCode = function () {
    var result = getStringHashCode(this._filename_0);
    result = imul(result, 31) + getNumberHashCode(this._quality) | 0;
    result = imul(result, 31) + (this._extra_2 == null ? 0 : this._extra_2.hashCode()) | 0;
    return result;
  };
  ImageEncodingProps.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageEncodingProps))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ImageEncodingProps ? other : THROW_CCE();
    if (!(this._filename_0 === tmp0_other_with_cast._filename_0))
      return false;
    if (!equals_1(this._quality, tmp0_other_with_cast._quality))
      return false;
    if (!equals_1(this._extra_2, tmp0_other_with_cast._extra_2))
      return false;
    return true;
  };
  ImageEncodingProps.$metadata$ = {
    simpleName: 'ImageEncodingProps',
    kind: 'class',
    interfaces: [Extra]
  };
  function ImageFormats_init_$Init$(formats, $this) {
    ImageFormats.call($this, toList(formats));
    return $this;
  }
  function ImageFormats_init_$Create$(formats) {
    return ImageFormats_init_$Init$(formats, Object.create(ImageFormats.prototype));
  }
  function ImageFormats(formats) {
    ImageFormat.call(this, ['']);
    var tmp = this;
    var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = formats.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var element_2_3 = tmp0_iterator_1_2.next_37();
      var tmp_0;
      if (element_2_3 instanceof ImageFormats) {
        tmp_0 = toList_2(element_2_3._formats_0);
      } else {
        {
          tmp_0 = listOf_0(element_2_3);
        }
      }
      var list_3_4 = tmp_0;
      addAll(tmp0_flatMapTo_0_1, list_3_4);
      Unit_getInstance();
    }
    tmp._formats_0 = toSet_0(tmp0_flatMapTo_0_1);
  }
  ImageFormats.prototype.decodeHeader_4 = function (s, props) {
    var tmp0_iterator = this._formats_0.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var format_0 = tmp0_iterator.next_37();
      var tmp;
      try {
        var tmp1_elvis_lhs = format_0.decodeHeader_4(sliceStart$default_0(s, new Long(0, 0), 1, null), props);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          continue;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          continue;
        } else {
          {
            throw $p;
          }
        }
        tmp = tmp_1;
      }
      return tmp;
    }
    return null;
  };
  ImageFormats.prototype.readImage_4 = function (s, props) {
    var tmp0_iterator = this._formats_0.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var format_0 = tmp0_iterator.next_37();
      if (format_0.check_4(sliceStart$default_0(s, new Long(0, 0), 1, null), props)) {
        return format_0.readImage_4(sliceStart$default_0(s, new Long(0, 0), 1, null), props);
      } else {
      }
    }
    var tmp = 'No suitable image format : MAGIC:' + readString_0(sliceStart$default_0(s, new Long(0, 0), 1, null), 4, ASCII_getInstance()) + '(';
    var tmp_0 = tmp + _get_hex_(readBytes_0(sliceStart$default_0(s, new Long(0, 0), 1, null), 4)) + ') (';
    throw UnsupportedOperationException_init_$Create$_0(tmp_0 + toString_3(readBytes_0(sliceStart$default_0(s, new Long(0, 0), 1, null), 4), ASCII_getInstance()) + ')');
  };
  ImageFormats.prototype.writeImage_4 = function (image, s, props) {
    var ext = _get_extensionLC_(_PathInfo___init__impl_(props._filename_0));
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._formats_0;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        if (element_2._extensions_0.contains_58(ext)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_elvis_lhs = tmp$ret$0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_flatMap_0 = this._formats_0;
      var tmp0_flatMapTo_0_1 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2 = tmp1_flatMap_0.iterator_67();
      while (tmp0_iterator_1_2.hasNext_33()) {
        var element_2_3 = tmp0_iterator_1_2.next_37();
        var list_3_4 = element_2_3._extensions_0;
        addAll(tmp0_flatMapTo_0_1, list_3_4);
        Unit_getInstance();
      }
      throw UnsupportedOperationException_init_$Create$_0('' + "Don't know how to generate file for extension '" + ext + "' (supported extensions " + tmp0_flatMapTo_0_1 + ') (props ' + props + ')');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var format_0 = tmp;
    format_0.writeImage_4(image, s, props);
  };
  ImageFormats.$metadata$ = {
    simpleName: 'ImageFormats',
    kind: 'class',
    interfaces: []
  };
  function ImageFrame_init_$Init$(bitmap, time, targetX, targetY, main_0, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      var tmp0__get_seconds__0 = 0;
      time = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
    }if (!(($mask0 & 4) === 0))
      targetX = 0;
    if (!(($mask0 & 8) === 0))
      targetY = 0;
    if (!(($mask0 & 16) === 0))
      main_0 = true;
    ImageFrame.call($this, bitmap, time, targetX, targetY, main_0);
    return $this;
  }
  function ImageFrame_init_$Create$(bitmap, time, targetX, targetY, main_0, $mask0, $marker) {
    return ImageFrame_init_$Init$(bitmap, time, targetX, targetY, main_0, $mask0, $marker, Object.create(ImageFrame.prototype));
  }
  function ImageFrame(bitmap, time, targetX, targetY, main_0) {
    this._bitmap_0 = bitmap;
    this._time_2 = time;
    this._targetX = targetX;
    this._targetY = targetY;
    this._main = main_0;
    var tmp = this;
    tmp._$$delegate_0_11 = Mixin_init_$Create$(null, 1, null);
  }
  ImageFrame.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_11._extra = _set___;
  };
  ImageFrame.prototype._get_extra__71 = function () {
    return this._$$delegate_0_11._extra;
  };
  ImageFrame.prototype._get_width__58 = function () {
    return this._bitmap_0._width_2;
  };
  ImageFrame.prototype._get_height__58 = function () {
    return this._bitmap_0._height_2;
  };
  ImageFrame.prototype._get_area__7 = function () {
    return this._bitmap_0._get_area__7();
  };
  ImageFrame.prototype.toString = function () {
    return '' + 'ImageFrame(' + this._bitmap_0 + ', time=' + new TimeSpan(this._time_2) + ', targetX=' + this._targetX + ', targetY=' + this._targetY + ', main=' + this._main + ')';
  };
  ImageFrame.$metadata$ = {
    simpleName: 'ImageFrame',
    kind: 'class',
    interfaces: [Extra]
  };
  function _get_area_(_this_) {
    var sum_1 = 0;
    var tmp0_iterator_2 = _this_.iterator_67();
    while (tmp0_iterator_2.hasNext_33()) {
      var element_3 = tmp0_iterator_2.next_37();
      var tmp = sum_1;
      sum_1 = tmp + element_3._get_area__7() | 0;
    }
    return sum_1;
  }
  function ImageInfo() {
    var tmp = this;
    tmp._$$delegate_0_12 = Mixin_init_$Create$(null, 1, null);
    this._width_6 = 0;
    this._height_6 = 0;
    this._bitsPerPixel = 8;
  }
  ImageInfo.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_12._extra = _set___;
  };
  ImageInfo.prototype._get_extra__71 = function () {
    return this._$$delegate_0_12._extra;
  };
  ImageInfo.prototype._set_width__5 = function (_set___) {
    this._width_6 = _set___;
  };
  ImageInfo.prototype._get_width__58 = function () {
    return this._width_6;
  };
  ImageInfo.prototype._set_height__5 = function (_set___) {
    this._height_6 = _set___;
  };
  ImageInfo.prototype._get_height__58 = function () {
    return this._height_6;
  };
  ImageInfo.prototype._set_bitsPerPixel__0 = function (_set___) {
    this._bitsPerPixel = _set___;
  };
  ImageInfo.prototype._get_bitsPerPixel__0 = function () {
    return this._bitsPerPixel;
  };
  ImageInfo.prototype.toString = function () {
    return '' + 'ImageInfo(width=' + this._width_6 + ', height=' + this._height_6 + ', bpp=' + this._bitsPerPixel + ', extra=' + this._get_extra__71() + ')';
  };
  ImageInfo.$metadata$ = {
    simpleName: 'ImageInfo',
    kind: 'class',
    interfaces: [Extra]
  };
  var nativeImageLoadingEnabled;
  function readBitmapOptimized(_this_, formats, premultiplied, $cont) {
    var tmp = new $readBitmapOptimizedCOROUTINE$11(_this_, formats, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readBitmapOptimized$default(_this_, formats, premultiplied, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      formats = RegisteredImageFormats_getInstance();
    if (!(($mask0 & 2) === 0))
      premultiplied = true;
    return readBitmapOptimized(_this_, formats, premultiplied, $cont);
  }
  function readBitmapSlice(_this_, premultiplied, $cont) {
    var tmp = new $readBitmapSliceCOROUTINE$12(_this_, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readBitmapSlice$default(_this_, premultiplied, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      premultiplied = true;
    return readBitmapSlice(_this_, premultiplied, $cont);
  }
  function readBitmap(_this_, formats, props, $cont) {
    var tmp = new $readBitmapCOROUTINE$13(_this_, formats, props, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readBitmap$default(_this_, formats, props, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      formats = RegisteredImageFormats_getInstance();
    if (!(($mask0 & 2) === 0)) {
      props = ImageDecodingProps_init_$Create$(null, null, null, null, 15, null);
    }return readBitmap(_this_, formats, props, $cont);
  }
  function $readBitmapOptimizedCOROUTINE$11(_this_, formats, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__127 = _this_;
    this._formats_1 = formats;
    this._premultiplied_1 = premultiplied;
  }
  $readBitmapOptimizedCOROUTINE$11.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = nativeImageFormatProvider.decode_41(this.__this__127, this._premultiplied_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            this._exceptionState = 4;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              this._t0 = this._exception_0;
              printStackTrace(this._t0);
              this._state_1 = 3;
              suspendResult = readBitmap$default(this.__this__127, this._formats_1, null, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapOptimizedCOROUTINE$11.$metadata$ = {
    simpleName: '$readBitmapOptimizedCOROUTINE$11',
    kind: 'class',
    interfaces: []
  };
  function $readBitmapSliceCOROUTINE$12(_this_, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__128 = _this_;
    this._premultiplied_2 = premultiplied;
  }
  $readBitmapSliceCOROUTINE$12.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readBitmapOptimized$default(this.__this__128, null, this._premultiplied_2, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return slice$default(ARGUMENT, null, null, 3, null);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapSliceCOROUTINE$12.$metadata$ = {
    simpleName: '$readBitmapSliceCOROUTINE$12',
    kind: 'class',
    interfaces: []
  };
  function $readBitmapCOROUTINE$13(_this_, formats, props, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__129 = _this_;
    this._formats_2 = formats;
    this._props_12 = props;
  }
  $readBitmapCOROUTINE$13.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            if (nativeImageLoadingEnabled) {
              this._exceptionState = 3;
              this._state_1 = 2;
              suspendResult = nativeImageFormatProvider.decode_43(this.__this__129, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this.__this__129.read_36(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT2_4 = suspendResult;
            var tmp_0 = this;
            var tmp_1 = _get_baseName_(this.__this__129);
            tmp_0._WHEN_RESULT0_1 = this._formats_2.decode_31(this._ARGUMENT2_4, this._props_12.copy$default_7(tmp_1, null, null, null, 14, null));
            this._state_1 = 6;
            continue $sm;
          case 2:
            this._TRY_RESULT1 = suspendResult;
            this._exceptionState = 7;
            this._state_1 = 5;
            continue $sm;
          case 3:
            this._exceptionState = 7;
            var tmp_2 = this._exception_0;
            if (tmp_2 instanceof Error) {
              this._e3 = this._exception_0;
              println('' + "Couldn't read native image: " + this._e3);
              printStackTrace(this._e3);
              this._state_1 = 4;
              suspendResult = this.__this__129.read_36(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            var ARGUMENT = suspendResult;
            var tmp_3 = this;
            var tmp_4 = _get_baseName_(this.__this__129);
            tmp_3._TRY_RESULT1 = this._formats_2.decode_31(ARGUMENT, this._props_12.copy$default_7(tmp_4, null, null, null, 14, null));
            this._state_1 = 5;
            continue $sm;
          case 5:
            this._exceptionState = 7;
            this._WHEN_RESULT0_1 = this._TRY_RESULT1;
            this._state_1 = 6;
            continue $sm;
          case 6:
            return this._WHEN_RESULT0_1;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readBitmapCOROUTINE$13.$metadata$ = {
    simpleName: '$readBitmapCOROUTINE$13',
    kind: 'class',
    interfaces: []
  };
  function $decodeCOROUTINE$14(_this_, vfs, path_0, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__130 = _this_;
    this._vfs_3 = vfs;
    this._path_22 = path_0;
    this._premultiplied_3 = premultiplied;
  }
  $decodeCOROUTINE$14.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._vfs_3.file_8(this._path_22).readBytes(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_20 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__130.decode_42(this._ARGUMENT0_20, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeCOROUTINE$14.$metadata$ = {
    simpleName: '$decodeCOROUTINE$14',
    kind: 'class',
    interfaces: []
  };
  function $decodeCOROUTINE$15(_this_, file, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__131 = _this_;
    this._file_4 = file;
    this._premultiplied_4 = premultiplied;
  }
  $decodeCOROUTINE$15.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._file_4.getUnderlyingUnscapedFile_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_21 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__131.decode_40(this._ARGUMENT0_21, this._premultiplied_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeCOROUTINE$15.$metadata$ = {
    simpleName: '$decodeCOROUTINE$15',
    kind: 'class',
    interfaces: []
  };
  function NativeImageFormatProvider() {
  }
  NativeImageFormatProvider.prototype.decode_39 = function (vfs, path_0, premultiplied, $cont) {
    var tmp = new $decodeCOROUTINE$14(this, vfs, path_0, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  NativeImageFormatProvider.prototype.decode_40 = function (file, premultiplied, $cont) {
    return this.decode_39(file._get_vfs_(), file._get_path__5(), premultiplied, $cont);
  };
  NativeImageFormatProvider.prototype.decode_41 = function (file, premultiplied, $cont) {
    var tmp = new $decodeCOROUTINE$15(this, file, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  NativeImageFormatProvider.prototype.decode_42 = function (data, $cont) {
    return this.decode_38(data, true, $cont);
  };
  NativeImageFormatProvider.prototype.decode_43 = function (file, $cont) {
    return this.decode_41(file, true, $cont);
  };
  NativeImageFormatProvider.prototype.copy_18 = function (bmp) {
    var tmp0_apply_0 = this.create_22(bmp._width_2, bmp._height_2, bmp._premultiplied_0);
    var tmp0_context2d_0_2 = true;
    var tmp0_lock_0_1_3 = null;
    tmp0_apply_0.lock_5();
    try {
      var ctx_2_2_4 = tmp0_apply_0.getContext2d_5(tmp0_context2d_0_2);
      try {
        var tmp0_drawImage_0_4_5 = 0;
        var tmp1_drawImage_0_5_6 = 0;
        var tmp2_drawImage_0_6_7 = bmp._width_2;
        var tmp3_drawImage_0_7_8 = bmp._height_2;
        ctx_2_2_4.drawImage_1(bmp, numberToDouble(tmp0_drawImage_0_4_5), numberToDouble(tmp1_drawImage_0_5_6), numberToDouble(tmp2_drawImage_0_6_7), numberToDouble(tmp3_drawImage_0_7_8));
      }finally {
        ctx_2_2_4.dispose_18();
      }
    }finally {
      tmp0_apply_0.unlock_5(tmp0_lock_0_1_3);
      Unit_getInstance();
    }
    Unit_getInstance();
    return tmp0_apply_0;
  };
  NativeImageFormatProvider.$metadata$ = {
    simpleName: 'NativeImageFormatProvider',
    kind: 'class',
    interfaces: []
  };
  function $decodeCOROUTINE$16(_this_, vfs, path_0, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__132 = _this_;
    this._vfs_4 = vfs;
    this._path_23 = path_0;
    this._premultiplied_5 = premultiplied;
  }
  $decodeCOROUTINE$16.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._vfs_4.get_115(this._path_23).readBytes(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_22 = suspendResult;
            this._state_1 = 2;
            suspendResult = this.__this__132.decode_38(this._ARGUMENT0_22, this._premultiplied_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeCOROUTINE$16.$metadata$ = {
    simpleName: '$decodeCOROUTINE$16',
    kind: 'class',
    interfaces: []
  };
  function BaseNativeImageFormatProvider() {
    NativeImageFormatProvider.call(this);
  }
  BaseNativeImageFormatProvider.prototype._get_formats__1 = function () {
    return RegisteredImageFormats_getInstance();
  };
  BaseNativeImageFormatProvider.prototype.decode_38 = function (data, premultiplied, $cont) {
    var tmp = this._get_formats__1();
    return this.wrapNative_0(tmp.decode$default_9(data, null, 2, null), premultiplied);
  };
  BaseNativeImageFormatProvider.prototype.decode_39 = function (vfs, path_0, premultiplied, $cont) {
    var tmp = new $decodeCOROUTINE$16(this, vfs, path_0, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  BaseNativeImageFormatProvider.prototype.createBitmapNativeImage_0 = function (bmp) {
    return BitmapNativeImage_init_$Create$(bmp);
  };
  BaseNativeImageFormatProvider.prototype.wrapNative_0 = function (bmp, premultiplied) {
    var bmp32 = bmp.toBMP32_5();
    return this.createBitmapNativeImage_0(premultiplied ? bmp32.premultipliedIfRequired() : bmp32.depremultipliedIfRequired());
  };
  BaseNativeImageFormatProvider.prototype.create_22 = function (width, height, premultiplied) {
    var tmp0_elvis_lhs = premultiplied;
    return this.createBitmapNativeImage_0(Bitmap32_init_$Create$(width, height, null, tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs, 4, null));
  };
  BaseNativeImageFormatProvider.prototype.copy_18 = function (bmp) {
    return this.createBitmapNativeImage_0(bmp);
  };
  BaseNativeImageFormatProvider.$metadata$ = {
    simpleName: 'BaseNativeImageFormatProvider',
    kind: 'class',
    interfaces: []
  };
  function BitmapNativeImage_init_$Init$(bitmap, $this) {
    BitmapNativeImage.call($this, bitmap.toBMP32_5());
    return $this;
  }
  function BitmapNativeImage_init_$Create$(bitmap) {
    return BitmapNativeImage_init_$Init$(bitmap, Object.create(BitmapNativeImage.prototype));
  }
  function BitmapNativeImage(bitmap) {
    NativeImage.call(this, bitmap._get_width__58(), bitmap._get_height__58(), bitmap, bitmap._get_premultiplied__8());
    this._bitmap_1 = bitmap;
    this._intData = _RgbaArray___get_ints__impl_(this._bitmap_1._data_39);
  }
  BitmapNativeImage.prototype.getContext2d_5 = function (antialiasing) {
    return this._bitmap_1.getContext2d_5(antialiasing);
  };
  BitmapNativeImage.prototype.toBMP32_5 = function () {
    return this._bitmap_1;
  };
  BitmapNativeImage.prototype.readPixelsUnsafe_5 = function (x, y, width, height, out, offset) {
    return this._bitmap_1.readPixelsUnsafe_5(x, y, width, height, out, offset);
  };
  BitmapNativeImage.prototype.writePixelsUnsafe_5 = function (x, y, width, height, out, offset) {
    return this._bitmap_1.writePixelsUnsafe_5(x, y, width, height, out, offset);
  };
  BitmapNativeImage.prototype.setRgba_5 = function (x, y, v) {
    return this._bitmap_1.setRgba_5(x, y, v);
  };
  BitmapNativeImage.prototype.getRgba_5 = function (x, y) {
    return this._bitmap_1.getRgba_5(x, y);
  };
  BitmapNativeImage.$metadata$ = {
    simpleName: 'BitmapNativeImage',
    kind: 'class',
    interfaces: []
  };
  var Colorspace_GRAYSCALE_instance;
  var Colorspace_RGB_instance;
  var Colorspace_INDEXED_instance;
  var Colorspace_GRAYSCALE_ALPHA_instance;
  var Colorspace_RGBA_instance;
  function Companion_113() {
    Companion_instance_112 = this;
    var tmp = this;
    var tmp0_associateBy_0 = values_5();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_18(element_2_4._id_6, element_2_4);
      Unit_getInstance();
    }
    tmp._BY_ID_1 = tmp0_associateByTo_0_2;
  }
  Companion_113.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_112;
  function Companion_getInstance_112() {
    if (Companion_instance_112 == null)
      new Companion_113();
    return Companion_instance_112;
  }
  function values_5() {
    return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
  }
  var Colorspace_entriesInitialized;
  function Colorspace_initEntries() {
    if (Colorspace_entriesInitialized)
      return Unit_getInstance();
    Colorspace_entriesInitialized = true;
    Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0);
    Colorspace_RGB_instance = new Colorspace('RGB', 1, 2);
    Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3);
    Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4);
    Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6);
    Companion_getInstance_112();
  }
  function InterlacedPass(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this._startingRow = startingRow;
    this._startingCol = startingCol;
    this._rowIncrement = rowIncrement;
    this._colIncrement = colIncrement;
    this._blockHeight = blockHeight;
    this._blockWidth = blockWidth;
    var tmp = this;
    var tmp0_log2_0 = this._colIncrement;
    tmp._colIncrementShift = numberToInt(Math.log2(tmp0_log2_0));
  }
  InterlacedPass.prototype.toString = function () {
    return '' + 'InterlacedPass(startingRow=' + this._startingRow + ', startingCol=' + this._startingCol + ', rowIncrement=' + this._rowIncrement + ', colIncrement=' + this._colIncrement + ', blockHeight=' + this._blockHeight + ', blockWidth=' + this._blockWidth + ')';
  };
  InterlacedPass.prototype.hashCode = function () {
    var result = this._startingRow;
    result = imul(result, 31) + this._startingCol | 0;
    result = imul(result, 31) + this._rowIncrement | 0;
    result = imul(result, 31) + this._colIncrement | 0;
    result = imul(result, 31) + this._blockHeight | 0;
    result = imul(result, 31) + this._blockWidth | 0;
    return result;
  };
  InterlacedPass.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this._startingRow === tmp0_other_with_cast._startingRow))
      return false;
    if (!(this._startingCol === tmp0_other_with_cast._startingCol))
      return false;
    if (!(this._rowIncrement === tmp0_other_with_cast._rowIncrement))
      return false;
    if (!(this._colIncrement === tmp0_other_with_cast._colIncrement))
      return false;
    if (!(this._blockHeight === tmp0_other_with_cast._blockHeight))
      return false;
    if (!(this._blockWidth === tmp0_other_with_cast._blockWidth))
      return false;
    return true;
  };
  InterlacedPass.$metadata$ = {
    simpleName: 'InterlacedPass',
    kind: 'class',
    interfaces: []
  };
  function Colorspace(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this._id_6 = id;
  }
  Colorspace.$metadata$ = {
    simpleName: 'Colorspace',
    kind: 'class',
    interfaces: []
  };
  function Header(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this._width_7 = width;
    this._height_7 = height;
    this._bitsPerChannel = bitsPerChannel;
    this._colorspace = colorspace;
    this._compressionmethod = compressionmethod;
    this._filtermethod = filtermethod;
    this._interlacemethod = interlacemethod;
    var tmp = this;
    var tmp0_subject = this._colorspace;
    var tmp_0;
    if (tmp0_subject.equals(Colorspace_GRAYSCALE_getInstance())) {
      tmp_0 = 1;
    } else if (tmp0_subject.equals(Colorspace_INDEXED_getInstance())) {
      tmp_0 = 1;
    } else if (tmp0_subject.equals(Colorspace_GRAYSCALE_ALPHA_getInstance())) {
      tmp_0 = 2;
    } else if (tmp0_subject.equals(Colorspace_RGB_getInstance())) {
      tmp_0 = 3;
    } else if (tmp0_subject.equals(Colorspace_RGBA_getInstance())) {
      tmp_0 = 4;
    } else {
      noWhenBranchMatchedException();
    }
    tmp._components_0 = tmp_0;
    this._stride = imul(imul(this._width_7, this._components_0), this._bitsPerChannel) / 8 | 0;
  }
  Header.$metadata$ = {
    simpleName: 'Header',
    kind: 'class',
    interfaces: []
  };
  function readCommon($this, s, readHeader) {
    var magic = readS32BE_1(s);
    if (!(magic === -1991225785))
      throw IllegalArgumentException_init_$Create$('' + 'Invalid PNG file magic: ' + _get_hex__0(magic) + '!=' + _get_hex__0(-1991225785));
    readS32BE_1(s);
    Unit_getInstance();
    var pheader = {_v: null};
    var pngdata = ByteArrayBuilder_init_$Create$_1(0, 1, null);
    var rgbPalette = UByteArrayInt(768);
    var tmp = 0;
    var tmp_0 = 256;
    var tmp_1 = new Int8Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = -1;
      tmp = tmp + 1 | 0;
    }
    var aPalette = _UByteArrayInt___init__impl_(tmp_1);
    var paletteCount = {_v: 0};
    while (!_get_eof_(s) ? readCommon$readChunk(s, pheader, paletteCount, rgbPalette, aPalette, pngdata) : false) {
      if (readHeader ? !(pheader._v == null) : false)
        return pheader._v;
    }
    var tmp0_elvis_lhs = pheader._v;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('PNG without header!');
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    var header = tmp_3;
    var width = header._width_7;
    var height = header._height_7;
    var outputSizeHint = imul(imul(1 + width | 0, height), header._components_0);
    var tmp_4 = pngdata.toByteArray();
    var tmp_5 = Companion_getInstance_42();
    var databb = uncompress$default(tmp_4, tmp_5, 0, 2, null);
    var databbp = 0;
    var context = new DecodingContext(header);
    var bpp = context._header._components_0;
    var row32 = context._row32;
    var tmp_6;
    if (header._components_0 === 1) {
      var tmp0_map_0 = until(0, paletteCount._v);
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var inductionVariable = tmp0_map_0._get_first__6();
      var last_1 = tmp0_map_0._get_last__6();
      if (inductionVariable <= last_1)
        do {
          var item_2_3 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          tmp0_mapTo_0_1.add_39(_RGBA___get_value__impl_(Companion_getInstance_104().invoke_375(UByteArrayInt__get_impl(rgbPalette, imul(item_2_3, 3) + 0 | 0), UByteArrayInt__get_impl(rgbPalette, imul(item_2_3, 3) + 1 | 0), UByteArrayInt__get_impl(rgbPalette, imul(item_2_3, 3) + 2 | 0), UByteArrayInt__get_impl(aPalette, item_2_3))));
          Unit_getInstance();
        }
         while (!(item_2_3 === last_1));
      tmp_6 = Bitmap8_init_$Create$(width, height, null, _RgbaArray___init__impl_(toIntArray(tmp0_mapTo_0_1)), 4, null);
    } else {
      tmp_6 = Bitmap32_init_$Create$(width, height, null, false, 12, null);
    }
    var bmp = tmp_6;
    var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
    var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
    var tmp1_subject = header._interlacemethod;
    var passes = tmp1_subject === 1 ? $this._InterlacedPasses : $this._NormalPasses;
    var tmp2_iterator = passes.iterator_67();
    while (tmp2_iterator.hasNext_33()) {
      var pass = tmp2_iterator.next_37();
      var progression = step(until(pass._startingRow, height), pass._rowIncrement);
      var inductionVariable_0 = progression._first_0;
      var last_2 = progression._last;
      var step_0 = progression._step_2;
      if ((step_0 > 0 ? inductionVariable_0 <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable_0 : false)
        do {
          var row = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          var col = pass._startingCol;
          var colIncrement = pass._colIncrement;
          var pixelsInThisRow = width >>> pass._colIncrementShift;
          var bytesInThisRow = imul(imul(pixelsInThisRow, header._components_0), header._bitsPerChannel) / 8 | 0;
          var tmp4 = databbp;
          databbp = tmp4 + 1 | 0;
          var filter = databb[tmp4] & 255;
          var currentRow = context._currentRow;
          var lastRow = context._lastRow;
          arraycopy_2(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
          databbp = databbp + bytesInThisRow | 0;
          if (!(bmp8 == null)) {
            $this.applyFilter$default(filter, lastRow, currentRow, header._components_0, 0, 16, null);
            var tmp5_subject = header._bitsPerChannel;
            switch (tmp5_subject) {
              case 1:
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < width)
                  do {
                    var n = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var tmp1_set_0 = bmp;
                    var tmp2_set_0 = col + n | 0;
                    var tmp3_set_0 = extract(UByteArrayInt__get_impl(currentRow, n / 8 | 0), 7 - imul(n % 8, 1) | 0, 1);
                    tmp1_set_0.setInt_6(tmp2_set_0, row, tmp3_set_0);
                  }
                   while (inductionVariable_1 < width);
                break;
              case 2:
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < width)
                  do {
                    var n_0 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    var tmp4_set_0 = bmp;
                    var tmp5_set_0 = col + n_0 | 0;
                    var tmp6_set_0 = extract(UByteArrayInt__get_impl(currentRow, n_0 / 4 | 0), 6 - imul(n_0 % 4, 2) | 0, 2);
                    tmp4_set_0.setInt_6(tmp5_set_0, row, tmp6_set_0);
                  }
                   while (inductionVariable_2 < width);
                break;
              case 4:
                var inductionVariable_3 = 0;
                if (inductionVariable_3 < width)
                  do {
                    var n_1 = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var tmp7_set_0 = bmp;
                    var tmp8_set_0 = col + n_1 | 0;
                    var tmp9_set_0 = extract(UByteArrayInt__get_impl(currentRow, n_1 / 2 | 0), 4 - imul(n_1 % 2, 4) | 0, 4);
                    tmp7_set_0.setInt_6(tmp8_set_0, row, tmp9_set_0);
                  }
                   while (inductionVariable_3 < width);
                break;
              case 8:
                bmp8.setRowChunk_1(col, row, asByteArray(currentRow), width, colIncrement);
                break;
              default:var tmp10_error_0 = '' + 'Unsupported header.bitsPerChannel=' + header._bitsPerChannel;
                throw IllegalStateException_init_$Create$_0(toString_1(tmp10_error_0));
            }
          } else if (!(bmp32 == null)) {
            var tmp9_subject = header._bitsPerChannel;
            if (tmp9_subject === 8) {
              $this.applyFilter(filter, lastRow, currentRow, bpp, bytesInThisRow);
              var tmp10_subject = bpp;
              switch (tmp10_subject) {
                case 3:
                  var tmp_7 = Companion_getInstance_103();
                  var tmp_8 = asByteArray(currentRow);
                  decode$default(tmp_7, tmp_8, 0, row32, 0, pixelsInThisRow, false, 32, null);
                  break;
                case 4:
                  var tmp_9 = Companion_getInstance_104();
                  var tmp_10 = asByteArray(currentRow);
                  decode$default(tmp_9, tmp_10, 0, row32, 0, pixelsInThisRow, false, 32, null);
                  break;
                default:var tmp11_TODO_0 = '' + 'Bytes: ' + bpp;
                  throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp11_TODO_0);
              }
              bmp32.setRowChunk(col, row, row32, width, colIncrement);
            } else {
              var tmp12_error_0 = '' + 'Unsupported header.bitsPerChannel=' + header._bitsPerChannel;
              throw IllegalStateException_init_$Create$_0(toString_1(tmp12_error_0));
            }
          }context.swapRows_5();
        }
         while (!(row === last_2));
    }
    return bmp;
  }
  function DecodingContext(header) {
    this._header = header;
    this._lastRow = UByteArrayInt(this._header._stride);
    this._currentRow = UByteArrayInt(this._header._stride);
    this._row32 = Companion_getInstance_105().invoke_379(this._header._width_7);
  }
  DecodingContext.prototype.swapRows_5 = function () {
    var temp_0 = this._currentRow;
    this._currentRow = this._lastRow;
    this._lastRow = temp_0;
  };
  DecodingContext.$metadata$ = {
    simpleName: 'DecodingContext',
    kind: 'class',
    interfaces: []
  };
  function writeImage$writeChunk($s, name, data) {
    var nameBytes = copyOf(toByteArray$default(name, null, 1, null), 4);
    var crc = CRC32_getInstance()._initialValue_0;
    var tmp = CRC32_getInstance();
    var tmp_0 = crc;
    crc = tmp.update$default_1(tmp_0, nameBytes, 0, 0, 12, null);
    var tmp_1 = CRC32_getInstance();
    var tmp_2 = crc;
    crc = tmp_1.update$default_1(tmp_2, data, 0, 0, 12, null);
    write32BE_1($s, data.length);
    writeBytes_0($s, nameBytes);
    writeBytes_0($s, data);
    write32BE_1($s, crc);
  }
  function writeImage$compress($level, data) {
    var tmp = Companion_getInstance_42();
    var tmp_0 = new CompressionContext($level);
    return compress$default(data, tmp, tmp_0, 0, 4, null);
  }
  function writeImage$writeChunk_0($s, name, initialCapacity, callback) {
    var buffer_1 = ByteArrayBuilder_init_$Create$_0(initialCapacity);
    var s_2 = MemorySyncStream_0(buffer_1);
    callback(s_2);
    return writeImage$writeChunk($s, name, buffer_1.toByteArray());
  }
  function writeImage$writeHeader($width, $height, $s, colorspace) {
    writeImage$writeChunk_0($s, 'IHDR', 13, _no_name_provided_$factory_197($width, $height, colorspace));
  }
  function readCommon$readChunk(_this_, $pheader, $paletteCount, $rgbPalette, $aPalette, $pngdata) {
    var length = readS32BE_1(_this_);
    var type = readStringz$default(_this_, 4, null, 2, null);
    var data = readStream_0(_this_, toLong(length));
    var crc = readS32BE_1(_this_);
    var tmp0_subject = type;
    switch (tmp0_subject) {
      case 'IHDR':
        var tmp = readS32BE_1(data);
        var tmp_0 = readS32BE_1(data);
        var tmp_1 = readU8_2(data);
        var tmp0_elvis_lhs_2 = Companion_getInstance_112()._BY_ID_1.get_116(readU8_2(data));
        $pheader._v = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs_2 == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs_2, readU8_2(data), readU8_2(data), readU8_2(data));
        break;
      case 'PLTE':
        $paletteCount._v = max2_5($paletteCount._v, data._get_length__5().toInt_8() / 3 | 0);
        data.read_30(asByteArray($rgbPalette), 0, data._get_length__5().toInt_8());
        Unit_getInstance();
        break;
      case 'tRNS':
        $paletteCount._v = max2_5($paletteCount._v, data._get_length__5().toInt_8());
        data.read_30(asByteArray($aPalette), 0, data._get_length__5().toInt_8());
        Unit_getInstance();
        break;
      case 'IDAT':
        var tmp_2 = readAll_0(data);
        $pngdata.append$default(tmp_2, 0, 0, 6, null);
        break;
      case 'IEND':
        return false;
    }
    return true;
  }
  function _no_name_provided__234($bitmap) {
    this._$bitmap = $bitmap;
  }
  _no_name_provided__234.prototype.invoke_405 = function ($this$writeChunk) {
    var tmp0_iterator = RgbaArray__iterator_impl(this._$bitmap._get_palette__0());
    while (tmp0_iterator.hasNext_33()) {
      var c = tmp0_iterator.next_37()._value_17;
      write8_1($this$writeChunk, _RGBA___get_r__impl_(c));
      write8_1($this$writeChunk, _RGBA___get_g__impl_(c));
      write8_1($this$writeChunk, _RGBA___get_b__impl_(c));
    }
  };
  _no_name_provided__234.prototype.invoke_1015 = function (p1) {
    this.invoke_405(p1 instanceof SyncStream ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__234.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__235($bitmap) {
    this._$bitmap_0 = $bitmap;
  }
  _no_name_provided__235.prototype.invoke_405 = function ($this$writeChunk) {
    var tmp0_iterator = RgbaArray__iterator_impl(this._$bitmap_0._get_palette__0());
    while (tmp0_iterator.hasNext_33()) {
      var c = tmp0_iterator.next_37()._value_17;
      write8_1($this$writeChunk, _RGBA___get_a__impl_(c));
    }
  };
  _no_name_provided__235.prototype.invoke_1015 = function (p1) {
    this.invoke_405(p1 instanceof SyncStream ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__235.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__236() {
  }
  _no_name_provided__236.prototype.invoke_405 = function ($this$writeChunk) {
    return Unit_getInstance();
  };
  _no_name_provided__236.prototype.invoke_1015 = function (p1) {
    this.invoke_405(p1 instanceof SyncStream ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__236.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__237($width, $height, $colorspace) {
    this._$width = $width;
    this._$height = $height;
    this._$colorspace = $colorspace;
  }
  _no_name_provided__237.prototype.invoke_405 = function ($this$writeChunk) {
    write32BE_1($this$writeChunk, this._$width);
    write32BE_1($this$writeChunk, this._$height);
    write8_1($this$writeChunk, 8);
    write8_1($this$writeChunk, this._$colorspace._id_6);
    write8_1($this$writeChunk, 0);
    write8_1($this$writeChunk, 0);
    write8_1($this$writeChunk, 0);
  };
  _no_name_provided__237.prototype.invoke_1015 = function (p1) {
    this.invoke_405(p1 instanceof SyncStream ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__237.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Colorspace_GRAYSCALE_getInstance() {
    Colorspace_initEntries();
    return Colorspace_GRAYSCALE_instance;
  }
  function Colorspace_RGB_getInstance() {
    Colorspace_initEntries();
    return Colorspace_RGB_instance;
  }
  function Colorspace_INDEXED_getInstance() {
    Colorspace_initEntries();
    return Colorspace_INDEXED_instance;
  }
  function Colorspace_GRAYSCALE_ALPHA_getInstance() {
    Colorspace_initEntries();
    return Colorspace_GRAYSCALE_ALPHA_instance;
  }
  function Colorspace_RGBA_getInstance() {
    Colorspace_initEntries();
    return Colorspace_RGBA_instance;
  }
  function PNG() {
    PNG_instance = this;
    ImageFormat.call(this, ['png']);
    this._MAGIC1 = -1991225785;
    this._MAGIC2 = 218765834;
    this._InterlacedPasses = listOf([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    this._NormalPasses = listOf_0(new InterlacedPass(0, 0, 1, 1, 1, 1));
  }
  PNG.prototype.decodeHeader_4 = function (s, props) {
    var tmp;
    try {
      var tmp_0 = readCommon(this, s, true);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      var tmp0_apply_0 = new ImageInfo();
      tmp0_apply_0._width_6 = header._width_7;
      tmp0_apply_0._height_6 = header._height_7;
      tmp0_apply_0._bitsPerPixel = header._bitsPerChannel;
      tmp = tmp0_apply_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        tmp_1 = null;
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  };
  PNG.prototype.writeImage_4 = function (image, s, props) {
    var bitmap = image._get_mainBitmap_();
    var width = bitmap._width_2;
    var height = bitmap._height_2;
    write32BE_1(s, -1991225785);
    write32BE_1(s, 218765834);
    var level = numberToInt(convertRangeClamped(props._quality, 0.0, 1.0, 0.0, 9.0));
    var tmp0_subject = bitmap;
    if (tmp0_subject instanceof Bitmap8) {
      writeImage$writeHeader(width, height, s, Colorspace_INDEXED_getInstance());
      var tmp = imul(_RgbaArray___get_size__impl_(bitmap._get_palette__0()), 3);
      writeImage$writeChunk_0(s, 'PLTE', tmp, _no_name_provided_$factory_194(bitmap));
      var tmp_0 = imul(_RgbaArray___get_size__impl_(bitmap._get_palette__0()), 1);
      writeImage$writeChunk_0(s, 'tRNS', tmp_0, _no_name_provided_$factory_195(bitmap));
      var out = new Int8Array(height + imul(width, height) | 0);
      var pos = 0;
      var inductionVariable = 0;
      if (inductionVariable < height)
        do {
          var y = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp2 = pos;
          pos = tmp2 + 1 | 0;
          write8(out, tmp2, 0);
          var index = bitmap.index_7(0, y);
          arraycopy_2(bitmap._get_data__2(), index, out, pos, width);
          pos = pos + width | 0;
        }
         while (inductionVariable < height);
      writeImage$writeChunk(s, 'IDAT', writeImage$compress(level, out));
    } else {
      {
        var bmp = bitmap.toBMP32_5();
        writeImage$writeHeader(width, height, s, Colorspace_RGBA_getInstance());
        var out_0 = new Int8Array(height + imul(imul(width, height), 4) | 0);
        var pos_0 = 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < height)
          do {
            var y_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp4 = pos_0;
            pos_0 = tmp4 + 1 | 0;
            write8(out_0, tmp4, 0);
            var index_0 = bmp.index_7(0, y_0);
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var c = bmp._get_premultiplied__8() ? _RGBAPremultiplied___get_depremultiplied__impl_(asPremultiplied(RgbaArray__get_impl(bmp._data_39, index_0 + x | 0))) : RgbaArray__get_impl(bmp._data_39, index_0 + x | 0);
                var tmp6 = pos_0;
                pos_0 = tmp6 + 1 | 0;
                write8(out_0, tmp6, _RGBA___get_r__impl_(c));
                var tmp7 = pos_0;
                pos_0 = tmp7 + 1 | 0;
                write8(out_0, tmp7, _RGBA___get_g__impl_(c));
                var tmp8 = pos_0;
                pos_0 = tmp8 + 1 | 0;
                write8(out_0, tmp8, _RGBA___get_b__impl_(c));
                var tmp9 = pos_0;
                pos_0 = tmp9 + 1 | 0;
                write8(out_0, tmp9, _RGBA___get_a__impl_(c));
              }
               while (inductionVariable_1 < width);
          }
           while (inductionVariable_0 < height);
        writeImage$writeChunk(s, 'IDAT', writeImage$compress(level, out_0));
      }
    }
    writeImage$writeChunk_0(s, 'IEND', 0, _no_name_provided_$factory_196());
  };
  PNG.prototype.readImage_4 = function (s, props) {
    var tmp = readCommon(this, s, false);
    var tmp_0 = tmp instanceof Bitmap ? tmp : THROW_CCE();
    var tmp_1 = listOf_0(ImageFrame_init_$Create$(tmp_0, null, 0, 0, false, 30, null));
    return ImageData_init_$Create$(tmp_1, 0, 0, 0, 14, null);
  };
  PNG.prototype.paethPredictor = function (a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return (pa <= pb ? pa <= pc : false) ? a : pb <= pc ? b : c;
  };
  PNG.prototype.applyFilter = function (filter, p, c, bpp, size_1) {
    var tmp0_subject = filter;
    switch (tmp0_subject) {
      case 0:
        Unit_getInstance();
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size_1)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp2_array = c;
            var tmp3_index0 = n;
            UByteArrayInt__set_impl(tmp2_array, tmp3_index0, UByteArrayInt__get_impl(tmp2_array, tmp3_index0) + UByteArrayInt__get_impl(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size_1);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size_1)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp5_array = c;
            var tmp6_index0 = n_0;
            UByteArrayInt__set_impl(tmp5_array, tmp6_index0, UByteArrayInt__get_impl(tmp5_array, tmp6_index0) + UByteArrayInt__get_impl(p, n_0) | 0);
          }
           while (inductionVariable_0 < size_1);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp8_array = c;
            var tmp9_index0 = n_1;
            UByteArrayInt__set_impl(tmp8_array, tmp9_index0, UByteArrayInt__get_impl(tmp8_array, tmp9_index0) + (UByteArrayInt__get_impl(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size_1)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var tmp11_array = c;
            var tmp12_index0 = n_2;
            UByteArrayInt__set_impl(tmp11_array, tmp12_index0, UByteArrayInt__get_impl(tmp11_array, tmp12_index0) + ((UByteArrayInt__get_impl(c, n_2 - bpp | 0) + UByteArrayInt__get_impl(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size_1);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var tmp14_array = c;
            var tmp15_index0 = n_3;
            UByteArrayInt__set_impl(tmp14_array, tmp15_index0, UByteArrayInt__get_impl(tmp14_array, tmp15_index0) + UByteArrayInt__get_impl(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size_1)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            var tmp17_array = c;
            var tmp18_index0 = n_4;
            UByteArrayInt__set_impl(tmp17_array, tmp18_index0, UByteArrayInt__get_impl(tmp17_array, tmp18_index0) + this.paethPredictor(UByteArrayInt__get_impl(c, n_4 - bpp | 0), UByteArrayInt__get_impl(p, n_4), UByteArrayInt__get_impl(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size_1);
        break;
      default:var tmp0_TODO_0 = '' + 'Filter: ' + filter;
        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
    }
  };
  PNG.prototype.applyFilter$default = function (filter, p, c, bpp, size_1, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      size_1 = _UByteArrayInt___get_size__impl_(c);
    return this.applyFilter(filter, p, c, bpp, size_1);
  };
  PNG.$metadata$ = {
    simpleName: 'PNG',
    kind: 'object',
    interfaces: []
  };
  var PNG_instance;
  function PNG_getInstance() {
    if (PNG_instance == null)
      new PNG();
    return PNG_instance;
  }
  function _no_name_provided_$factory_194($bitmap) {
    var i = new _no_name_provided__234($bitmap);
    return function (p1) {
      i.invoke_405(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_195($bitmap) {
    var i = new _no_name_provided__235($bitmap);
    return function (p1) {
      i.invoke_405(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_196() {
    var i = new _no_name_provided__236();
    return function (p1) {
      i.invoke_405(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_197($width, $height, $colorspace) {
    var i = new _no_name_provided__237($width, $height, $colorspace);
    return function (p1) {
      i.invoke_405(p1);
      return Unit_getInstance();
    };
  }
  var RegisteredImageFormats_formats;
  function RegisteredImageFormats() {
    RegisteredImageFormats_instance = this;
    ImageFormat.call(this, []);
  }
  RegisteredImageFormats.prototype._set_formats_ = function (value) {
    RegisteredImageFormats_formats = value;
    return Unit_getInstance();
  };
  RegisteredImageFormats.prototype._get_formats__1 = function () {
    return RegisteredImageFormats_formats;
  };
  RegisteredImageFormats.prototype.register_3 = function (formats) {
    this._set_formats_(new ImageFormats(plus_2(this._get_formats__1()._formats_0, formats)));
  };
  RegisteredImageFormats.prototype.readImage_4 = function (s, props) {
    return this._get_formats__1().readImage_4(s, props);
  };
  RegisteredImageFormats.prototype.writeImage_4 = function (image, s, props) {
    return this._get_formats__1().writeImage_4(image, s, props);
  };
  RegisteredImageFormats.prototype.decodeHeader_4 = function (s, props) {
    return this._get_formats__1().decodeHeader_4(s, props);
  };
  RegisteredImageFormats.prototype.toString = function () {
    return '' + 'RegisteredImageFormats(' + this._get_formats__1() + ')';
  };
  RegisteredImageFormats.$metadata$ = {
    simpleName: 'RegisteredImageFormats',
    kind: 'object',
    interfaces: []
  };
  var RegisteredImageFormats_instance;
  function RegisteredImageFormats_getInstance() {
    if (RegisteredImageFormats_instance == null)
      new RegisteredImageFormats();
    return RegisteredImageFormats_instance;
  }
  function Info_0(width, height, flipY, bitsPerPixel) {
    this._width_8 = width;
    this._height_8 = height;
    this._flipY_0 = flipY;
    this._bitsPerPixel_0 = bitsPerPixel;
    this._area_0 = imul(this._width_8, this._height_8);
    this._bytes = this._bitsPerPixel_0 / 8 | 0;
  }
  Info_0.$metadata$ = {
    simpleName: 'Info',
    kind: 'class',
    interfaces: []
  };
  function TGA() {
    TGA_instance = this;
    ImageFormat.call(this, ['tga']);
  }
  TGA.prototype.decodeHeader_4 = function (s, props) {
    var tmp;
    try {
      var tmp0_success_0_1 = Companion_getInstance_2();
      var tmp0_apply_0_6 = new ImageInfo();
      var h_2_7 = TGA_getInstance().readHeader(s);
      tmp0_apply_0_6._width_6 = h_2_7._width_8;
      tmp0_apply_0_6._height_6 = h_2_7._height_8;
      tmp0_apply_0_6._bitsPerPixel = h_2_7._bitsPerPixel_0;
      var tmp1_success_0_2 = tmp0_apply_0_6;
      tmp = _Result___init__impl_(tmp1_success_0_2);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var tmp2_failure_0_4 = Companion_getInstance_2();
        tmp_0 = _Result___init__impl_(createFailure($p));
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var tmp0_getOrNull_0 = tmp;
    var tmp_1;
    if (_Result___get_isFailure__impl_(tmp0_getOrNull_0)) {
      tmp_1 = null;
    } else {
      var tmp_2 = _Result___get_value__impl_(tmp0_getOrNull_0);
      tmp_1 = (tmp_2 == null ? true : isObject(tmp_2)) ? tmp_2 : THROW_CCE();
    }
    return tmp_1;
  };
  TGA.prototype.readHeader = function (s) {
    var idLength = readU8_2(s);
    var colorMapType = readU8_2(s);
    var tmp0_subject = colorMapType;
    switch (tmp0_subject) {
      case 0:
      case 1:
        Unit_getInstance();
        break;
      default:var tmp0_error_0 = 'Not a TGA. Unsupported colorMapType';
        throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }
    var imageType = readU8_2(s);
    var tmp1_subject = imageType;
    switch (tmp1_subject) {
      case 1:
        var tmp1_TODO_0 = 'Unsupported indexed';
        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp1_TODO_0);
      case 2:
        Unit_getInstance();
        break;
      case 9:
      case 10:
        var tmp2_TODO_0 = 'Unsupported RLE';
        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp2_TODO_0);
      default:var tmp3_TODO_0 = 'Unknown TGA';
        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp3_TODO_0);
    }
    var firstIndexEntry = readU16LE_1(s);
    var colorMapLength = readU16LE_1(s);
    var colorMapEntrySize = readU8_2(s);
    var tmp2_this = s;
    var tmp = tmp2_this;
    var tmp4_plus_0 = tmp2_this._position_6;
    var tmp5_plus_0 = imul(colorMapLength, colorMapEntrySize);
    tmp._position_6 = tmp4_plus_0.plus_64(toLong(tmp5_plus_0));
    var xorig = readS16LE_1(s);
    var yorig = readS16LE_1(s);
    var width = readS16LE_1(s);
    var height = readS16LE_1(s);
    var pixelDepth = readU8_2(s);
    var tmp3_subject = pixelDepth;
    switch (tmp3_subject) {
      case 24:
      case 32:
        Unit_getInstance();
        break;
      default:var tmp6_TODO_0 = 'Not a RGBA tga';
        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp6_TODO_0);
    }
    if (width < 0 ? true : height < 0) {
      var tmp7_error_0 = 'Not a TGA. Invalid width/height';
      throw IllegalStateException_init_$Create$_0(toString_1(tmp7_error_0));
    }var imageDescriptor = readU8_2(s);
    var flipY = (imageDescriptor >>> 5 & 1) === 0;
    var storage = imageDescriptor >>> 6 & 3;
    readBytes_0(s, idLength);
    Unit_getInstance();
    return new Info_0(width, height, flipY, pixelDepth);
  };
  TGA.prototype.readImage_4 = function (s, props) {
    var info = this.readHeader(s);
    var tmp0_subject = info._bitsPerPixel_0;
    var tmp;
    switch (tmp0_subject) {
      case 24:
        tmp = Companion_getInstance_103();
        break;
      case 32:
        tmp = Companion_getInstance_104();
        break;
      default:var tmp0_TODO_0 = 'Not a RGBA tga';
        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
    }
    var format_0 = tmp;
    var tmp_0 = Bitmap32_init_$Create$(info._width_8, info._height_8, null, false, 12, null);
    var tmp_1 = readBytes_0(s, imul(info._area_0, info._bytes));
    var out = tmp_0.writeDecoded$default(format_0, tmp_1, 0, false, 12, null);
    if (info._flipY_0) {
      out.flipY_1();
      Unit_getInstance();
    }var tmp_2 = listOf_0(ImageFrame_init_$Create$(out, null, 0, 0, false, 30, null));
    return ImageData_init_$Create$(tmp_2, 0, 0, 0, 14, null);
  };
  TGA.prototype.writeImage_4 = function (image, s, props) {
    var bitmap = image._get_mainBitmap_();
    var tmp0_subject = bitmap;
    if (tmp0_subject instanceof Bitmap8) {
      var tmp0_TODO_0 = 'Not implemented encoding TGA Bitmap8';
      throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
    } else {
      {
        var bmp = bitmap.toBMP32_5();
        var data = new Int8Array(imul(bmp._get_area__7(), 4));
        var m = 0;
        var tmp1_iterator = RgbaArray__iterator_impl(bmp._data_39);
        while (tmp1_iterator.hasNext_33()) {
          var c = tmp1_iterator.next_37()._value_17;
          var tmp2 = m;
          m = tmp2 + 1 | 0;
          data[tmp2] = toByte(_RGBA___get_b__impl_(c));
          var tmp3 = m;
          m = tmp3 + 1 | 0;
          data[tmp3] = toByte(_RGBA___get_g__impl_(c));
          var tmp4 = m;
          m = tmp4 + 1 | 0;
          data[tmp4] = toByte(_RGBA___get_r__impl_(c));
          var tmp5 = m;
          m = tmp5 + 1 | 0;
          data[tmp5] = toByte(_RGBA___get_a__impl_(c));
        }
        write8_1(s, 0);
        write8_1(s, 0);
        write8_1(s, 2);
        write16LE_1(s, 0);
        write16LE_1(s, 0);
        write8_1(s, 0);
        write16LE_1(s, 0);
        write16LE_1(s, 0);
        write16LE_1(s, bmp._get_width__58());
        write16LE_1(s, bmp._get_height__58());
        write8_1(s, 32);
        write8_1(s, 32);
        writeBytes_0(s, data);
      }
    }
  };
  TGA.$metadata$ = {
    simpleName: 'TGA',
    kind: 'object',
    interfaces: []
  };
  var TGA_instance;
  function TGA_getInstance() {
    if (TGA_instance == null)
      new TGA();
    return TGA_instance;
  }
  function clamp0_255(_this_) {
    var n = _this_ & (-(_this_ >= 0 ? 1 : 0) | 0);
    return (n | (255 - n | 0) >> 31) & 255;
  }
  function sumPacked4MulR(a, b, mul) {
    var dstRB = imul(b & 16711935, mul) >>> 8;
    var dstGA = imul(b >>> 8 & 16711935, mul) >>> 8;
    var r = (a >>> 0 & 255) + (dstRB >>> 0 & 255) | 0;
    var g = (a >>> 8 & 255) + (dstGA >>> 0 & 255) | 0;
    var b_0 = (a >>> 16 & 255) + (dstRB >>> 16 & 255) | 0;
    var a_0 = (a >>> 24 & 255) + (dstGA >>> 16 & 255) | 0;
    return packIntClamped(r, g, b_0, a_0);
  }
  function d2i(v) {
    return numberToInt(clamp01_0(v) * 255);
  }
  function f2i(v) {
    return numberToInt(clamp01_0(v) * 255);
  }
  function packIntUnchecked(r, g, b, a) {
    return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
  }
  function packIntClamped(r, g, b, a) {
    return packIntUnchecked(clamp0_255(r), clamp0_255(g), clamp0_255(b), clamp0_255(a));
  }
  function max2_5(a, b) {
    return a > b ? a : b;
  }
  function min2_5(a, b) {
    return a < b ? a : b;
  }
  function max2_6(a, b) {
    return a > b ? a : b;
  }
  function min2_6(a, b) {
    return a < b ? a : b;
  }
  function ColorFiller() {
    BaseFiller.call(this);
    this._color_0 = _RGBA___get_premultiplied__impl_(Colors_getInstance()._RED);
  }
  ColorFiller.prototype.set_20 = function (fill_3, state) {
    this._color_0 = _RGBA___get_premultiplied__impl_(_RGBA___get_color__impl_(fill_3));
    return this;
  };
  ColorFiller.prototype.fill_5 = function (data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl(data, this._color_0, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  };
  ColorFiller.$metadata$ = {
    simpleName: 'ColorFiller',
    kind: 'class',
    interfaces: []
  };
  function _get_fill_($this) {
    var tmp = $this._fill;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fill');
    }
  }
  function stopN($this, n) {
    return numberToInt(_get_fill_($this)._stops.get_137(n) * $this._NCOLORS);
  }
  function color($this, ratio) {
    return RgbaPremultipliedArray__get_impl($this._colors, numberToInt(clamp01(ratio) * ($this._NCOLORS - 1 | 0)));
  }
  function GradientFiller() {
    BaseFiller.call(this);
    this._NCOLORS = 256;
    this._colors = Companion_getInstance_107().invoke_380(this._NCOLORS);
    var tmp = this;
    tmp._stateInv = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  }
  GradientFiller.prototype.set_21 = function (fill_3, state) {
    this._fill = fill_3;
    state._transform_6.inverted(this._stateInv);
    Unit_getInstance();
    var tmp0_subject_2 = fill_3._get_numberOfStops_();
    switch (tmp0_subject_2) {
      case 0:
      case 1:
        var color_3 = fill_3._get_numberOfStops_() === 0 ? Colors_getInstance()._FUCHSIA : _RGBA___init__impl_(first_0(fill_3._colors_0));
        var pcolor_4 = _RGBA___get_premultiplied__impl_(color_3);
        var inductionVariable = 0;
        var last_1 = this._NCOLORS;
        if (inductionVariable < last_1)
          do {
            var n_6 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            RgbaPremultipliedArray__set_impl(this._colors, n_6, pcolor_4);
          }
           while (inductionVariable < last_1);
        break;
      default:var inductionVariable_0 = 0;
        var last_2 = stopN(this, 0);
        if (inductionVariable_0 < last_2)
          do {
            var n_8 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            RgbaPremultipliedArray__set_impl(this._colors, n_8, _RGBA___get_premultiplied__impl_(_RGBA___init__impl_(first_0(fill_3._colors_0))));
          }
           while (inductionVariable_0 < last_2);
        var inductionVariable_1 = 0;
        var last_3 = fill_3._get_numberOfStops_() - 1 | 0;
        if (inductionVariable_1 < last_3)
          do {
            var n_10 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var stop0_11 = stopN(this, n_10 + 0 | 0);
            var stop1_12 = stopN(this, n_10 + 1 | 0);
            var color0_13 = _RGBA___init__impl_(fill_3._colors_0.getAt_0(n_10 + 0 | 0));
            var color1_14 = _RGBA___init__impl_(fill_3._colors_0.getAt_0(n_10 + 1 | 0));
            var inductionVariable_2 = stop0_11;
            if (inductionVariable_2 < stop1_12)
              do {
                var s_16 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var ratio_17 = (s_16 - stop0_11 | 0) / (stop1_12 - stop0_11 | 0);
                RgbaPremultipliedArray__set_impl(this._colors, s_16, _RGBA___get_premultiplied__impl_(Companion_getInstance_104().interpolate(color0_13, color1_14, ratio_17)));
              }
               while (inductionVariable_2 < stop1_12);
          }
           while (inductionVariable_1 < last_3);
        var inductionVariable_3 = stopN(this, fill_3._get_numberOfStops_() - 1 | 0);
        var last_4 = this._NCOLORS;
        if (inductionVariable_3 < last_4)
          do {
            var n_19 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            _RgbaPremultipliedArray___get_ints__impl_(this._colors)[n_19] = last_0(fill_3._colors_0);
          }
           while (inductionVariable_3 < last_4);
        break;
    }
    return this;
  };
  GradientFiller.prototype.fill_5 = function (data, offset, x0, x1, y) {
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl(data, offset + n | 0, color(this, _get_fill_(this).getRatioAt_0(n, y, this._stateInv)));
      }
       while (!(n === x1));
  };
  GradientFiller.$metadata$ = {
    simpleName: 'GradientFiller',
    kind: 'class',
    interfaces: []
  };
  function BitmapFiller() {
    BaseFiller.call(this);
    this._cycleX = CycleMethod_NO_CYCLE_getInstance();
    this._cycleY = CycleMethod_NO_CYCLE_getInstance();
    this._texture_1 = Bitmaps_getInstance()._transparent._bmp;
    var tmp = this;
    tmp._transform_2 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._linear = true;
    var tmp_0 = this;
    tmp_0._stateTrans = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_1 = this;
    tmp_1._fillTrans = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_2 = this;
    tmp_2._compTrans = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  }
  BitmapFiller.prototype.set_22 = function (fill_3, state) {
    this._cycleX = fill_3._cycleX_0;
    this._cycleY = fill_3._cycleY_0;
    this._texture_1 = fill_3._bmp32;
    this._transform_2 = fill_3._transform_4;
    this._linear = fill_3._smooth;
    state._transform_6.inverted(this._stateTrans);
    Unit_getInstance();
    fill_3._transform_4.inverted(this._fillTrans);
    Unit_getInstance();
    var tmp0_apply_0_2 = this._compTrans;
    tmp0_apply_0_2.identity_0();
    Unit_getInstance();
    tmp0_apply_0_2.multiply_0(tmp0_apply_0_2, this._stateTrans);
    Unit_getInstance();
    tmp0_apply_0_2.multiply_0(tmp0_apply_0_2, this._fillTrans);
    Unit_getInstance();
    Unit_getInstance();
    return this;
  };
  BitmapFiller.prototype.lookupLinear = function (x, y) {
    return this._texture_1.getRgbaSampled_0(x, y);
  };
  BitmapFiller.prototype.lookupNearest = function (x, y) {
    return this._texture_1.get_89(numberToInt(x), numberToInt(y));
  };
  BitmapFiller.prototype.fill_5 = function (data, offset, x0, x1, y) {
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tx = this._cycleX.apply_0(this._compTrans.transformX(n, y), this._texture_1._get_width__58());
        var ty = this._cycleY.apply_0(this._compTrans.transformY(n, y), this._texture_1._get_height__58());
        var color_0 = this._linear ? this.lookupLinear(tx, ty) : this.lookupNearest(tx, ty);
        RgbaPremultipliedArray__set_impl(data, offset + n | 0, _RGBA___get_premultiplied__impl_(color_0));
      }
       while (!(n === x1));
  };
  BitmapFiller.$metadata$ = {
    simpleName: 'BitmapFiller',
    kind: 'class',
    interfaces: []
  };
  function BaseFiller() {
  }
  BaseFiller.$metadata$ = {
    simpleName: 'BaseFiller',
    kind: 'class',
    interfaces: []
  };
  function NoneFiller() {
    NoneFiller_instance = this;
    BaseFiller.call(this);
  }
  NoneFiller.prototype.fill_5 = function (data, offset, x0, x1, y) {
    return Unit_getInstance();
  };
  NoneFiller.$metadata$ = {
    simpleName: 'NoneFiller',
    kind: 'object',
    interfaces: []
  };
  var NoneFiller_instance;
  function NoneFiller_getInstance() {
    if (NoneFiller_instance == null)
      new NoneFiller();
    return NoneFiller_instance;
  }
  function Paint() {
  }
  Paint.$metadata$ = {
    simpleName: 'Paint',
    kind: 'interface',
    interfaces: []
  };
  function _get_DefaultPaint_() {
    return Colors_getInstance()._BLACK;
  }
  function NonePaint() {
    NonePaint_instance = this;
  }
  NonePaint.$metadata$ = {
    simpleName: 'NonePaint',
    kind: 'object',
    interfaces: [Paint]
  };
  var NonePaint_instance;
  function NonePaint_getInstance() {
    if (NonePaint_instance == null)
      new NonePaint();
    return NonePaint_instance;
  }
  function GradientPaint_init_$Init$(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle_0, transform, interpolationMethod, units, $mask0, $marker, $this) {
    if (!(($mask0 & 128) === 0)) {
      stops = DoubleArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 256) === 0)) {
      colors = IntArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 512) === 0))
      cycle_0 = CycleMethod_NO_CYCLE_getInstance();
    if (!(($mask0 & 1024) === 0)) {
      transform = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }if (!(($mask0 & 2048) === 0))
      interpolationMethod = GradientInterpolationMethod_NORMAL_getInstance();
    if (!(($mask0 & 4096) === 0))
      units = GradientUnits_OBJECT_BOUNDING_BOX_getInstance();
    GradientPaint.call($this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle_0, transform, interpolationMethod, units);
    return $this;
  }
  function GradientPaint_init_$Create$(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle_0, transform, interpolationMethod, units, $mask0, $marker) {
    return GradientPaint_init_$Init$(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle_0, transform, interpolationMethod, units, $mask0, $marker, Object.create(GradientPaint.prototype));
  }
  function Companion_114() {
    Companion_instance_113 = this;
  }
  Companion_114.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_113;
  function Companion_getInstance_113() {
    if (Companion_instance_113 == null)
      new Companion_114();
    return Companion_instance_113;
  }
  function GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle_0, transform, interpolationMethod, units) {
    Companion_getInstance_113();
    this._kind_0 = kind;
    this._x0 = x0;
    this._y0 = y0;
    this._r0_0 = r0;
    this._x1 = x1;
    this._y1 = y1;
    this._r1 = r1;
    this._stops = stops;
    this._colors_0 = colors;
    this._cycle = cycle_0;
    this._transform_3 = transform;
    this._interpolationMethod = interpolationMethod;
    this._units = units;
    var tmp = this;
    var tmp0_apply_0 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    tmp0_apply_0.translate_2(-this._x0, -this._y0);
    Unit_getInstance();
    var scale_2 = 1.0 / clamp_2(Companion_getInstance_80().distance(this._x0, this._y0, this._x1, this._y1), 1.0, 16000.0);
    tmp0_apply_0.scale_2(scale_2, scale_2);
    Unit_getInstance();
    tmp0_apply_0.rotate_1(unaryMinus(Companion_getInstance_75().between(this._x0, this._y0, this._x1, this._y1)));
    Unit_getInstance();
    tmp._untransformedGradientMatrix = tmp0_apply_0;
    var tmp_0 = this;
    var tmp0_apply_0_0 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    tmp0_apply_0_0.copyFrom(this._untransformedGradientMatrix);
    Unit_getInstance();
    tmp0_apply_0_0.postmultiply(this._transform_3);
    Unit_getInstance();
    tmp_0._gradientMatrix = tmp0_apply_0_0;
    var tmp_1 = this;
    tmp_1._gradientMatrixInv = this._gradientMatrix.inverted$default(null, 1, null);
    this._r0r1_2 = 2 * this._r0_0 * this._r1;
    this._r0pow2 = this._get_pow2_(this._r0_0);
    this._r1pow2 = this._get_pow2_(this._r1);
    this._y0_y1 = this._y0 - this._y1;
    this._r0_r1 = this._r0_0 - this._r1;
    this._x0_x1 = this._x0 - this._x1;
    this._radial_scale = 1.0 / (this._get_pow2_(this._r0_0 - this._r1) - this._get_pow2_(this._x0 - this._x1) - this._get_pow2_(this._y0 - this._y1));
  }
  GradientPaint.prototype._get_transform__8 = function () {
    return this._transform_3;
  };
  GradientPaint.prototype._get_numberOfStops_ = function () {
    return this._stops._get_size__60();
  };
  GradientPaint.prototype.addColorStop_0 = function (stop, color_0) {
    return this.add_61(stop, color_0);
  };
  GradientPaint.prototype.add_61 = function (stop, color_0) {
    var tmp0_this_2 = this;
    tmp0_this_2._stops.plusAssign(stop);
    var tmp1_this_3 = this;
    tmp1_this_3._colors_0.plusAssign_1(_RGBA___get_value__impl_(color_0));
    return this;
  };
  GradientPaint.prototype.getRatioAt = function (x, y) {
    var tmp0_subject = this._kind_0;
    var tmp;
    if (tmp0_subject.equals(GradientKind_SWEEP_getInstance())) {
      tmp = div(Companion_getInstance_80().angle_0(this._x0, this._y0, x, y), _get_degrees__0(360));
    } else if (tmp0_subject.equals(GradientKind_RADIAL_getInstance())) {
      var tmp_0 = -this._r1 * this._r0_r1 + this._x0_x1 * (this._x1 - x) + this._y0_y1 * (this._y1 - y);
      var tmp0_sqrt_0 = this._r1pow2 * (this._get_pow2_(this._x0 - x) + this._get_pow2_(this._y0 - y)) - this._r0r1_2 * ((this._x0 - x) * (this._x1 - x) + (this._y0 - y) * (this._y1 - y)) + this._r0pow2 * (this._get_pow2_(this._x1 - x) + this._get_pow2_(this._y1 - y)) - this._get_pow2_(this._x1 * this._y0 - x * this._y0 - this._x0 * this._y1 + x * this._y1 + this._x0 * y - this._x1 * y);
      tmp = 1.0 - (tmp_0 - Math.sqrt(tmp0_sqrt_0)) * this._radial_scale;
    } else {
      tmp = this._gradientMatrix.transformX(x, y);
    }
    var tmp_1 = tmp;
    return this._cycle.apply$default(tmp_1, false, 2, null);
  };
  GradientPaint.prototype._get_pow2_ = function (_this__0) {
    return _this__0 * _this__0;
  };
  GradientPaint.prototype.getRatioAt_0 = function (x, y, m) {
    return this.getRatioAt(m.transformX(x, y), m.transformY(x, y));
  };
  GradientPaint.prototype.toString = function () {
    var tmp0_subject = this._kind_0;
    var tmp;
    if (tmp0_subject.equals(GradientKind_LINEAR_getInstance())) {
      tmp = '' + 'LinearGradient(' + this._x0 + ', ' + this._y0 + ', ' + this._x1 + ', ' + this._y1 + ', ' + this._stops + ', ' + this._colors_0 + ')';
    } else if (tmp0_subject.equals(GradientKind_RADIAL_getInstance())) {
      tmp = '' + 'RadialGradient(' + this._x0 + ', ' + this._y0 + ', ' + this._r0_0 + ', ' + this._x1 + ', ' + this._y1 + ', ' + this._r1 + ', ' + this._stops + ', ' + this._colors_0 + ')';
    } else if (tmp0_subject.equals(GradientKind_SWEEP_getInstance())) {
      tmp = '' + 'SweepGradient(' + this._x0 + ', ' + this._y0 + ', ' + this._stops + ', ' + this._colors_0 + ')';
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  GradientPaint.prototype.hashCode = function () {
    var result = this._kind_0.hashCode();
    result = imul(result, 31) + getNumberHashCode(this._x0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._r0_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._x1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._r1) | 0;
    result = imul(result, 31) + this._stops.hashCode() | 0;
    result = imul(result, 31) + this._colors_0.hashCode() | 0;
    result = imul(result, 31) + this._cycle.hashCode() | 0;
    result = imul(result, 31) + this._transform_3.hashCode() | 0;
    result = imul(result, 31) + this._interpolationMethod.hashCode() | 0;
    result = imul(result, 31) + this._units.hashCode() | 0;
    return result;
  };
  GradientPaint.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this._kind_0.equals(tmp0_other_with_cast._kind_0))
      return false;
    if (!equals_1(this._x0, tmp0_other_with_cast._x0))
      return false;
    if (!equals_1(this._y0, tmp0_other_with_cast._y0))
      return false;
    if (!equals_1(this._r0_0, tmp0_other_with_cast._r0_0))
      return false;
    if (!equals_1(this._x1, tmp0_other_with_cast._x1))
      return false;
    if (!equals_1(this._y1, tmp0_other_with_cast._y1))
      return false;
    if (!equals_1(this._r1, tmp0_other_with_cast._r1))
      return false;
    if (!this._stops.equals(tmp0_other_with_cast._stops))
      return false;
    if (!this._colors_0.equals(tmp0_other_with_cast._colors_0))
      return false;
    if (!this._cycle.equals(tmp0_other_with_cast._cycle))
      return false;
    if (!this._transform_3.equals(tmp0_other_with_cast._transform_3))
      return false;
    if (!this._interpolationMethod.equals(tmp0_other_with_cast._interpolationMethod))
      return false;
    if (!this._units.equals(tmp0_other_with_cast._units))
      return false;
    return true;
  };
  GradientPaint.$metadata$ = {
    simpleName: 'GradientPaint',
    kind: 'class',
    interfaces: [TransformedPaint]
  };
  function BitmapPaint_init_$Init$(bitmap, transform, cycleX, cycleY, smooth, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      cycleX = CycleMethod_NO_CYCLE_getInstance();
    if (!(($mask0 & 8) === 0))
      cycleY = CycleMethod_NO_CYCLE_getInstance();
    if (!(($mask0 & 16) === 0))
      smooth = true;
    BitmapPaint.call($this, bitmap, transform, cycleX, cycleY, smooth);
    return $this;
  }
  function BitmapPaint_init_$Create$(bitmap, transform, cycleX, cycleY, smooth, $mask0, $marker) {
    return BitmapPaint_init_$Init$(bitmap, transform, cycleX, cycleY, smooth, $mask0, $marker, Object.create(BitmapPaint.prototype));
  }
  function BitmapPaint(bitmap, transform, cycleX, cycleY, smooth) {
    this._bitmap_2 = bitmap;
    this._transform_4 = transform;
    this._cycleX_0 = cycleX;
    this._cycleY_0 = cycleY;
    this._smooth = smooth;
    this._bmp32 = this._bitmap_2.toBMP32_5();
  }
  BitmapPaint.prototype._get_transform__8 = function () {
    return this._transform_4;
  };
  BitmapPaint.prototype._get_repeatX_ = function () {
    return this._cycleX_0._get_repeating_();
  };
  BitmapPaint.prototype._get_repeatY_ = function () {
    return this._cycleY_0._get_repeating_();
  };
  BitmapPaint.$metadata$ = {
    simpleName: 'BitmapPaint',
    kind: 'class',
    interfaces: [TransformedPaint]
  };
  var GradientKind_LINEAR_instance;
  var GradientKind_RADIAL_instance;
  var GradientKind_SWEEP_instance;
  var GradientKind_entriesInitialized;
  function GradientKind_initEntries() {
    if (GradientKind_entriesInitialized)
      return Unit_getInstance();
    GradientKind_entriesInitialized = true;
    GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
    GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
    GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
  }
  function GradientKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  GradientKind.$metadata$ = {
    simpleName: 'GradientKind',
    kind: 'class',
    interfaces: []
  };
  function TransformedPaint() {
  }
  TransformedPaint.$metadata$ = {
    simpleName: 'TransformedPaint',
    kind: 'interface',
    interfaces: [Paint]
  };
  var GradientInterpolationMethod_LINEAR_instance;
  var GradientInterpolationMethod_NORMAL_instance;
  var GradientInterpolationMethod_entriesInitialized;
  function GradientInterpolationMethod_initEntries() {
    if (GradientInterpolationMethod_entriesInitialized)
      return Unit_getInstance();
    GradientInterpolationMethod_entriesInitialized = true;
    GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
    GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
  }
  function GradientInterpolationMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  GradientInterpolationMethod.$metadata$ = {
    simpleName: 'GradientInterpolationMethod',
    kind: 'class',
    interfaces: []
  };
  var GradientUnits_USER_SPACE_ON_USE_instance;
  var GradientUnits_OBJECT_BOUNDING_BOX_instance;
  var GradientUnits_entriesInitialized;
  function GradientUnits_initEntries() {
    if (GradientUnits_entriesInitialized)
      return Unit_getInstance();
    GradientUnits_entriesInitialized = true;
    GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
    GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
  }
  function GradientUnits(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  GradientUnits.$metadata$ = {
    simpleName: 'GradientUnits',
    kind: 'class',
    interfaces: []
  };
  function GradientKind_LINEAR_getInstance() {
    GradientKind_initEntries();
    return GradientKind_LINEAR_instance;
  }
  function GradientKind_RADIAL_getInstance() {
    GradientKind_initEntries();
    return GradientKind_RADIAL_instance;
  }
  function GradientKind_SWEEP_getInstance() {
    GradientKind_initEntries();
    return GradientKind_SWEEP_instance;
  }
  function GradientInterpolationMethod_NORMAL_getInstance() {
    GradientInterpolationMethod_initEntries();
    return GradientInterpolationMethod_NORMAL_instance;
  }
  function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
    GradientUnits_initEntries();
    return GradientUnits_OBJECT_BOUNDING_BOX_instance;
  }
  function _VerticalAlign___init__impl_(ratio) {
    return ratio;
  }
  function _VerticalAlign___get_ratio__impl_(this_0) {
    return this_0;
  }
  function _VerticalAlign___get_ratioFake__impl_(this_0) {
    return equals_1(new VerticalAlign(this_0), new VerticalAlign(Companion_getInstance_114()._BASELINE)) ? 1.0 : _VerticalAlign___get_ratio__impl_(this_0);
  }
  function Companion_115() {
    Companion_instance_114 = this;
    this._TOP = _VerticalAlign___init__impl_(0.0);
    this._MIDDLE = _VerticalAlign___init__impl_(0.5);
    this._BOTTOM = _VerticalAlign___init__impl_(1.0);
    this._BASELINE = _VerticalAlign___init__impl_(Infinity);
    var tmp = this;
    var tmp0_arrayOf_0 = [new VerticalAlign(this._TOP), new VerticalAlign(this._MIDDLE), new VerticalAlign(this._BASELINE), new VerticalAlign(this._BOTTOM)];
    tmp._values_0 = tmp0_arrayOf_0;
  }
  Companion_115.prototype.invoke_885 = function (str) {
    var tmp0_subject = str;
    var tmp;
    switch (tmp0_subject) {
      case 'TOP':
        tmp = this._TOP;
        break;
      case 'MIDDLE':
        tmp = this._MIDDLE;
        break;
      case 'BOTTOM':
        tmp = this._BOTTOM;
        break;
      case 'BASELINE':
        tmp = this._BASELINE;
        break;
      default:var tmp_0 = new Char(40);
        var tmp_1 = substringAfter$default(str, tmp_0, null, 2, null);
        var tmp_2 = new Char(41);
        var tmp1_elvis_lhs = toDoubleOrNull(substringBefore$default(tmp_1, tmp_2, null, 2, null));
        tmp = _VerticalAlign___init__impl_(tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs);
        break;
    }
    return tmp;
  };
  Companion_115.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_114;
  function Companion_getInstance_114() {
    if (Companion_instance_114 == null)
      new Companion_115();
    return Companion_instance_114;
  }
  function VerticalAlign__getOffsetY_impl(this_0, height, baseline) {
    var tmp0_subject = this_0;
    return equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_114()._BASELINE)) ? baseline : -height * _VerticalAlign___get_ratio__impl_(this_0);
  }
  function VerticalAlign__toString_impl(this_0) {
    var tmp0_subject = this_0;
    return equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_114()._TOP)) ? 'TOP' : equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_114()._MIDDLE)) ? 'MIDDLE' : equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_114()._BOTTOM)) ? 'BOTTOM' : equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_114()._BASELINE)) ? 'BASELINE' : '' + 'VerticalAlign(' + _VerticalAlign___get_ratio__impl_(this_0) + ')';
  }
  function VerticalAlign__hashCode_impl(this_0) {
    return getNumberHashCode(this_0);
  }
  function VerticalAlign__equals_impl(this_0, other) {
    if (!(other instanceof VerticalAlign))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VerticalAlign ? other._ratio : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function VerticalAlign(ratio) {
    Companion_getInstance_114();
    this._ratio = ratio;
  }
  VerticalAlign.prototype.toString = function () {
    return VerticalAlign__toString_impl(this._ratio);
  };
  VerticalAlign.prototype.hashCode = function () {
    return VerticalAlign__hashCode_impl(this._ratio);
  };
  VerticalAlign.prototype.equals = function (other) {
    return VerticalAlign__equals_impl(this._ratio, other);
  };
  VerticalAlign.$metadata$ = {
    simpleName: 'VerticalAlign',
    kind: 'class',
    interfaces: []
  };
  function _HorizontalAlign___init__impl_(ratio) {
    return ratio;
  }
  function _HorizontalAlign___get_ratio__impl_(this_0) {
    return this_0;
  }
  function _HorizontalAlign___get_ratioFake__impl_(this_0) {
    return equals_1(new HorizontalAlign(this_0), new HorizontalAlign(Companion_getInstance_115()._JUSTIFY)) ? 0.0 : _HorizontalAlign___get_ratio__impl_(this_0);
  }
  function Companion_116() {
    Companion_instance_115 = this;
    this._JUSTIFY = _HorizontalAlign___init__impl_(-1.0E-5);
    this._LEFT = _HorizontalAlign___init__impl_(0.0);
    this._CENTER = _HorizontalAlign___init__impl_(0.5);
    this._RIGHT = _HorizontalAlign___init__impl_(1.0);
    var tmp = this;
    var tmp0_arrayOf_0 = [new HorizontalAlign(this._LEFT), new HorizontalAlign(this._CENTER), new HorizontalAlign(this._RIGHT), new HorizontalAlign(this._JUSTIFY)];
    tmp._values_1 = tmp0_arrayOf_0;
  }
  Companion_116.prototype.invoke_889 = function (str) {
    var tmp0_subject = str;
    var tmp;
    switch (tmp0_subject) {
      case 'LEFT':
        tmp = this._LEFT;
        break;
      case 'CENTER':
        tmp = this._CENTER;
        break;
      case 'RIGHT':
        tmp = this._RIGHT;
        break;
      case 'JUSTIFY':
        tmp = this._JUSTIFY;
        break;
      default:var tmp_0 = new Char(40);
        var tmp_1 = substringAfter$default(str, tmp_0, null, 2, null);
        var tmp_2 = new Char(41);
        var tmp1_elvis_lhs = toDoubleOrNull(substringBefore$default(tmp_1, tmp_2, null, 2, null));
        tmp = _HorizontalAlign___init__impl_(tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs);
        break;
    }
    return tmp;
  };
  Companion_116.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_115;
  function Companion_getInstance_115() {
    if (Companion_instance_115 == null)
      new Companion_116();
    return Companion_instance_115;
  }
  function HorizontalAlign__getOffsetX_impl(this_0, width) {
    var tmp0_subject = this_0;
    return equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_115()._JUSTIFY)) ? 0.0 : width * _HorizontalAlign___get_ratio__impl_(this_0);
  }
  function HorizontalAlign__toString_impl(this_0) {
    var tmp0_subject = this_0;
    return equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_115()._LEFT)) ? 'LEFT' : equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_115()._CENTER)) ? 'CENTER' : equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_115()._RIGHT)) ? 'RIGHT' : equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_115()._JUSTIFY)) ? 'JUSTIFY' : '' + 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl_(this_0) + ')';
  }
  function HorizontalAlign__hashCode_impl(this_0) {
    return getNumberHashCode(this_0);
  }
  function HorizontalAlign__equals_impl(this_0, other) {
    if (!(other instanceof HorizontalAlign))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof HorizontalAlign ? other._ratio_0 : THROW_CCE();
    if (!equals_1(this_0, tmp0_other_with_cast))
      return false;
    return true;
  }
  function HorizontalAlign(ratio) {
    Companion_getInstance_115();
    this._ratio_0 = ratio;
  }
  HorizontalAlign.prototype.toString = function () {
    return HorizontalAlign__toString_impl(this._ratio_0);
  };
  HorizontalAlign.prototype.hashCode = function () {
    return HorizontalAlign__hashCode_impl(this._ratio_0);
  };
  HorizontalAlign.prototype.equals = function (other) {
    return HorizontalAlign__equals_impl(this._ratio_0, other);
  };
  HorizontalAlign.$metadata$ = {
    simpleName: 'HorizontalAlign',
    kind: 'class',
    interfaces: []
  };
  function Companion_117() {
    Companion_instance_116 = this;
    this._horizontals = listOf([new HorizontalAlign(Companion_getInstance_115()._LEFT), new HorizontalAlign(Companion_getInstance_115()._CENTER), new HorizontalAlign(Companion_getInstance_115()._RIGHT), new HorizontalAlign(Companion_getInstance_115()._JUSTIFY)]);
    var tmp = this;
    var tmp0_map_0 = this._horizontals;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37()._ratio_0;
      tmp0_mapTo_0_1.add_39(new TextAlignment(item_2_3, Companion_getInstance_114()._TOP));
      Unit_getInstance();
    }
    tmp._TOP_0 = tmp0_mapTo_0_1;
    var tmp_0 = this;
    var tmp0_map_0_0 = this._horizontals;
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_0, 10));
    var tmp0_iterator_1_2_0 = tmp0_map_0_0.iterator_67();
    while (tmp0_iterator_1_2_0.hasNext_33()) {
      var item_2_3_0 = tmp0_iterator_1_2_0.next_37()._ratio_0;
      tmp0_mapTo_0_1_0.add_39(new TextAlignment(item_2_3_0, Companion_getInstance_114()._BASELINE));
      Unit_getInstance();
    }
    tmp_0._BASELINE_0 = tmp0_mapTo_0_1_0;
    var tmp_1 = this;
    var tmp0_map_0_1 = this._horizontals;
    var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_1, 10));
    var tmp0_iterator_1_2_1 = tmp0_map_0_1.iterator_67();
    while (tmp0_iterator_1_2_1.hasNext_33()) {
      var item_2_3_1 = tmp0_iterator_1_2_1.next_37()._ratio_0;
      tmp0_mapTo_0_1_1.add_39(new TextAlignment(item_2_3_1, Companion_getInstance_114()._MIDDLE));
      Unit_getInstance();
    }
    tmp_1._MIDDLE_0 = tmp0_mapTo_0_1_1;
    var tmp_2 = this;
    var tmp0_map_0_2 = this._horizontals;
    var tmp0_mapTo_0_1_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_2, 10));
    var tmp0_iterator_1_2_2 = tmp0_map_0_2.iterator_67();
    while (tmp0_iterator_1_2_2.hasNext_33()) {
      var item_2_3_2 = tmp0_iterator_1_2_2.next_37()._ratio_0;
      tmp0_mapTo_0_1_2.add_39(new TextAlignment(item_2_3_2, Companion_getInstance_114()._BOTTOM));
      Unit_getInstance();
    }
    tmp_2._BOTTOM_0 = tmp0_mapTo_0_1_2;
    this._TOP_LEFT_0 = this._TOP_0.get_137(0);
    this._TOP_CENTER_0 = this._TOP_0.get_137(1);
    this._TOP_RIGHT_0 = this._TOP_0.get_137(2);
    this._TOP_JUSTIFIED = this._TOP_0.get_137(3);
    this._BASELINE_LEFT = this._BASELINE_0.get_137(0);
    this._BASELINE_CENTER = this._BASELINE_0.get_137(1);
    this._BASELINE_RIGHT = this._BASELINE_0.get_137(2);
    this._BASELINE_JUSTIFIED = this._BASELINE_0.get_137(3);
    this._LEFT_0 = this._TOP_0.get_137(0);
    this._CENTER_0 = this._TOP_0.get_137(1);
    this._RIGHT_0 = this._TOP_0.get_137(2);
    this._JUSTIFIED = this._TOP_0.get_137(3);
    this._MIDDLE_LEFT_0 = this._MIDDLE_0.get_137(0);
    this._MIDDLE_CENTER_0 = this._MIDDLE_0.get_137(1);
    this._MIDDLE_RIGHT_0 = this._MIDDLE_0.get_137(2);
    this._MIDDLE_JUSTIFIED = this._MIDDLE_0.get_137(3);
    this._BOTTOM_LEFT_0 = this._BOTTOM_0.get_137(0);
    this._BOTTOM_CENTER_0 = this._BOTTOM_0.get_137(1);
    this._BOTTOM_RIGHT_0 = this._BOTTOM_0.get_137(2);
    this._BOTTOM_JUSTIFIED = this._BOTTOM_0.get_137(3);
  }
  Companion_117.prototype.fromAlign = function (horizontal, vertical) {
    var tmp0_subject = horizontal;
    var tmp;
    if (equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_115()._LEFT))) {
      tmp = 0;
    } else if (equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_115()._CENTER))) {
      tmp = 1;
    } else if (equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_115()._RIGHT))) {
      tmp = 2;
    } else if (equals_1(new HorizontalAlign(tmp0_subject), new HorizontalAlign(Companion_getInstance_115()._JUSTIFY))) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    var tmp1_subject = vertical;
    return equals_1(new VerticalAlign(tmp1_subject), new VerticalAlign(Companion_getInstance_114()._TOP)) ? this._TOP_0.get_137(horizontalIndex) : equals_1(new VerticalAlign(tmp1_subject), new VerticalAlign(Companion_getInstance_114()._BASELINE)) ? this._BASELINE_0.get_137(horizontalIndex) : equals_1(new VerticalAlign(tmp1_subject), new VerticalAlign(Companion_getInstance_114()._MIDDLE)) ? this._MIDDLE_0.get_137(horizontalIndex) : equals_1(new VerticalAlign(tmp1_subject), new VerticalAlign(Companion_getInstance_114()._BOTTOM)) ? this._BOTTOM_0.get_137(horizontalIndex) : new TextAlignment(horizontal, vertical);
  };
  Companion_117.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_116;
  function Companion_getInstance_116() {
    if (Companion_instance_116 == null)
      new Companion_117();
    return Companion_instance_116;
  }
  function TextAlignment(horizontal, vertical) {
    Companion_getInstance_116();
    this._horizontal = horizontal;
    this._vertical = vertical;
    this._anchor = new Anchor(_HorizontalAlign___get_ratioFake__impl_(this._horizontal), _VerticalAlign___get_ratioFake__impl_(this._vertical));
  }
  TextAlignment.prototype.withHorizontal = function (horizontal) {
    return Companion_getInstance_116().fromAlign(horizontal, this._vertical);
  };
  TextAlignment.prototype.withVertical = function (vertical) {
    return Companion_getInstance_116().fromAlign(this._horizontal, vertical);
  };
  TextAlignment.prototype.toString = function () {
    return '' + 'TextAlignment(horizontal=' + new HorizontalAlign(this._horizontal) + ', vertical=' + new VerticalAlign(this._vertical) + ')';
  };
  TextAlignment.prototype.hashCode = function () {
    var result = HorizontalAlign__hashCode_impl(this._horizontal);
    result = imul(result, 31) + VerticalAlign__hashCode_impl(this._vertical) | 0;
    return result;
  };
  TextAlignment.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals_1(new HorizontalAlign(this._horizontal), new HorizontalAlign(tmp0_other_with_cast._horizontal)))
      return false;
    if (!equals_1(new VerticalAlign(this._vertical), new VerticalAlign(tmp0_other_with_cast._vertical)))
      return false;
    return true;
  };
  TextAlignment.$metadata$ = {
    simpleName: 'TextAlignment',
    kind: 'class',
    interfaces: []
  };
  var DefaultStringTextRenderer;
  function TextRenderer() {
  }
  TextRenderer.prototype._get_version__1 = function () {
    return 0;
  };
  TextRenderer.prototype.invoke_409 = function (actions, text, size_1, defaultFont) {
    this.run_8(actions, text, size_1, defaultFont);
    Unit_getInstance();
  };
  TextRenderer.$metadata$ = {
    simpleName: 'TextRenderer',
    kind: 'interface',
    interfaces: []
  };
  function CreateStringTextRenderer(getVersion, handler) {
    return new _no_name_provided__240(getVersion, handler);
  }
  function CreateStringTextRenderer$default(getVersion, handler, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      getVersion = _no_name_provided_$factory_199();
    }return CreateStringTextRenderer(getVersion, handler);
  }
  function TextRendererActions() {
    var tmp = this;
    tmp._glyphMetrics = GlyphMetrics_init_$Create$(0.0, false, 0, null, 0.0, 31, null);
    var tmp_0 = this;
    tmp_0._fontMetrics_0 = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
    this._fontSize_1 = 0.0;
    this._x_8 = 0.0;
    this._y_7 = 0.0;
    var tmp_1 = this;
    tmp_1._transform_5 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._paint = null;
    this._tint = Colors_getInstance()._WHITE;
  }
  TextRendererActions.prototype._get_glyphMetrics__0 = function () {
    return this._glyphMetrics;
  };
  TextRendererActions.prototype._get_lineHeight__4 = function () {
    return this._fontMetrics_0._get_lineHeight__4();
  };
  TextRendererActions.prototype._get_font__2 = function () {
    var tmp = this._font;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  };
  TextRendererActions.prototype._get_fontSize__1 = function () {
    return this._fontSize_1;
  };
  TextRendererActions.prototype.setFont_2 = function (font, size_1) {
    this._font = font;
    this._fontSize_1 = size_1;
    font.getFontMetrics_1(size_1, this._fontMetrics_0);
    Unit_getInstance();
  };
  TextRendererActions.prototype._set_x__27 = function (_set___) {
    this._x_8 = _set___;
  };
  TextRendererActions.prototype._get_x__36 = function () {
    return this._x_8;
  };
  TextRendererActions.prototype._set_y__27 = function (_set___) {
    this._y_7 = _set___;
  };
  TextRendererActions.prototype._get_y__36 = function () {
    return this._y_7;
  };
  TextRendererActions.prototype.reset_9 = function () {
    this._x_8 = 0.0;
    this._y_7 = 0.0;
  };
  TextRendererActions.prototype.getGlyphMetrics_6 = function (codePoint) {
    return this._get_font__2().getGlyphMetrics_3(this._fontSize_1, codePoint, this._glyphMetrics);
  };
  TextRendererActions.prototype._get_transform__8 = function () {
    return this._transform_5;
  };
  TextRendererActions.prototype._get_paint__0 = function () {
    return this._paint;
  };
  TextRendererActions.prototype.getKerning_6 = function (leftCodePoint, rightCodePoint) {
    return this._get_font__2().getKerning_3(this._fontSize_1, leftCodePoint, rightCodePoint);
  };
  TextRendererActions.prototype.advance_2 = function (x) {
    var tmp0_this = this;
    tmp0_this._x_8 = tmp0_this._x_8 + x;
  };
  TextRendererActions.prototype.newLine_2 = function (y) {
    this._x_8 = 0.0;
    var tmp0_this = this;
    tmp0_this._y_7 = tmp0_this._y_7 + y;
  };
  TextRendererActions.$metadata$ = {
    simpleName: 'TextRendererActions',
    kind: 'class',
    interfaces: []
  };
  function add_1($this, x, y) {
    var rx = $this._get_x__36() + $this._get_transform__8().transformX(x, y);
    var ry = $this._get_y__36() + $this._get_transform__8().transformY(x, y);
    $this._bb.add_52(rx, ry);
    Unit_getInstance();
    if ($this._currentLine === 0) {
      $this._flbb.add_52(rx, ry);
      Unit_getInstance();
    }}
  function add_2($this, rect_1) {
    var fx = rect_1._get_left__4();
    var fy = rect_1._get_top__4();
    var w = rect_1._width_0;
    var h = rect_1._height_0;
    add_1($this, fx, fy);
    add_1($this, fx + w, fy);
    add_1($this, fx + w, fy + h);
    add_1($this, fx, fy + h);
  }
  function BoundBuilderTextRendererActions() {
    TextRendererActions.call(this);
    this._flbb = new BoundsBuilder();
    this._bb = new BoundsBuilder();
    this._currentLine = 0;
  }
  BoundBuilderTextRendererActions.prototype._get_nlines_ = function () {
    return this._currentLine + 1 | 0;
  };
  BoundBuilderTextRendererActions.prototype.reset_9 = function () {
    TextRendererActions.prototype.reset_9.call(this);
    this._currentLine = 0;
    this._bb.reset_9();
    this._flbb.reset_9();
  };
  BoundBuilderTextRendererActions.prototype.put_14 = function (codePoint) {
    var g = this.getGlyphMetrics_6(codePoint);
    add_2(this, g._bounds_1);
    return g;
  };
  BoundBuilderTextRendererActions.prototype.newLine_2 = function (y) {
    TextRendererActions.prototype.newLine_2.call(this, y);
    var tmp0_this = this;
    var tmp1 = tmp0_this._currentLine;
    tmp0_this._currentLine = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  BoundBuilderTextRendererActions.$metadata$ = {
    simpleName: 'BoundBuilderTextRendererActions',
    kind: 'class',
    interfaces: []
  };
  function Entry_init_$Init$(tex, x, y, sx, sy, rot, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      tex = Bitmaps_getInstance()._transparent;
    if (!(($mask0 & 2) === 0))
      x = 0.0;
    if (!(($mask0 & 4) === 0))
      y = 0.0;
    if (!(($mask0 & 8) === 0))
      sx = 1.0;
    if (!(($mask0 & 16) === 0))
      sy = 1.0;
    if (!(($mask0 & 32) === 0))
      rot = _get_radians__0(0);
    Entry_2.call($this, tex, x, y, sx, sy, rot);
    return $this;
  }
  function Entry_init_$Create$(tex, x, y, sx, sy, rot, $mask0, $marker) {
    return Entry_init_$Init$(tex, x, y, sx, sy, rot, $mask0, $marker, Object.create(Entry_2.prototype));
  }
  function Entry_2(tex, x, y, sx, sy, rot) {
    this._tex = tex;
    this._x_9 = x;
    this._y_8 = y;
    this._sx_0 = sx;
    this._sy_0 = sy;
    this._rot = rot;
  }
  Entry_2.prototype.toString = function () {
    var tmp0_apply_0_1 = StringBuilder_init_$Create$_0();
    tmp0_apply_0_1.append_5('Entry(');
    Unit_getInstance();
    tmp0_apply_0_1.append_5('' + "'" + this._tex._name_17 + "', " + numberToInt(this._x_9) + ', ' + numberToInt(this._y_8) + ', ' + this._tex._get_width__58() + ', ' + this._tex._get_height__58());
    Unit_getInstance();
    if (!(this._sx_0 === 1.0)) {
      tmp0_apply_0_1.append_5('' + ', ' + _get_niceStr__0(this._sx_0));
      Unit_getInstance();
    }if (!(this._sy_0 === 1.0)) {
      tmp0_apply_0_1.append_5('' + ', ' + _get_niceStr__0(this._sy_0));
      Unit_getInstance();
    }if (!equals_1(new Angle(this._rot), new Angle(_get_radians__0(0)))) {
      tmp0_apply_0_1.append_5('' + ', ' + _get_niceStr__0(_get_degrees_(this._rot)));
      Unit_getInstance();
    }tmp0_apply_0_1.append_5(')');
    Unit_getInstance();
    return tmp0_apply_0_1.toString();
  };
  Entry_2.prototype.hashCode = function () {
    var result = hashCode(this._tex);
    result = imul(result, 31) + getNumberHashCode(this._x_9) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y_8) | 0;
    result = imul(result, 31) + getNumberHashCode(this._sx_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._sy_0) | 0;
    result = imul(result, 31) + Angle__hashCode_impl(this._rot) | 0;
    return result;
  };
  Entry_2.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_2))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Entry_2 ? other : THROW_CCE();
    if (!equals_1(this._tex, tmp0_other_with_cast._tex))
      return false;
    if (!equals_1(this._x_9, tmp0_other_with_cast._x_9))
      return false;
    if (!equals_1(this._y_8, tmp0_other_with_cast._y_8))
      return false;
    if (!equals_1(this._sx_0, tmp0_other_with_cast._sx_0))
      return false;
    if (!equals_1(this._sy_0, tmp0_other_with_cast._sy_0))
      return false;
    if (!equals_1(new Angle(this._rot), new Angle(tmp0_other_with_cast._rot)))
      return false;
    return true;
  };
  Entry_2.$metadata$ = {
    simpleName: 'Entry',
    kind: 'class',
    interfaces: []
  };
  function Text2TextRendererActions() {
    TextRendererActions.call(this);
    this._verticalAlign = Companion_getInstance_114()._TOP;
    this._horizontalAlign = Companion_getInstance_115()._LEFT;
    var tmp = this;
    tmp._arrayTex = ArrayList_init_$Create$();
    this._arrayX = doubleArrayListOf(new Float64Array([]));
    this._arrayY = doubleArrayListOf(new Float64Array([]));
    this._arraySX = doubleArrayListOf(new Float64Array([]));
    this._arraySY = doubleArrayListOf(new Float64Array([]));
    this._arrayRot = doubleArrayListOf(new Float64Array([]));
    var tmp_0 = this;
    tmp_0._tr_0 = Transform_init_$Create$(0.0, 0.0, 0.0, 0.0, null, null, null, 127, null);
  }
  Text2TextRendererActions.prototype._get_size__60 = function () {
    return this._arrayX._get_size__60();
  };
  Text2TextRendererActions.prototype.read_48 = function (n, out) {
    out._tex = this._arrayTex.get_137(n);
    out._x_9 = this._arrayX.get_137(n);
    out._y_8 = this._arrayY.get_137(n);
    out._sx_0 = this._arraySX.get_137(n);
    out._sy_0 = this._arraySY.get_137(n);
    out._rot = _get_radians_(this._arrayRot.get_137(n));
    return out;
  };
  Text2TextRendererActions.prototype.mreset = function () {
    this._arrayTex.clear_33();
    this._arrayX.clear_33();
    this._arrayY.clear_33();
    this._arraySX.clear_33();
    this._arraySY.clear_33();
    this._arrayRot.clear_33();
  };
  Text2TextRendererActions.prototype.put_14 = function (codePoint) {
    var tmp = this._get_font__2();
    var bf = tmp instanceof BitmapFont ? tmp : THROW_CCE();
    var m = this.getGlyphMetrics_6(codePoint);
    var g = bf.get_137(codePoint);
    var x = g._xoffset;
    var tmp_0 = g._yoffset;
    var tmp0_subject = this._verticalAlign;
    var y = tmp_0 - (equals_1(new VerticalAlign(tmp0_subject), new VerticalAlign(Companion_getInstance_114()._BASELINE)) ? bf._base_4 : bf._lineHeight * _VerticalAlign___get_ratio__impl_(this._verticalAlign));
    var fontScale = this._get_fontSize__1() / bf._fontSize_0;
    this._tr_0.setMatrix_0(this._get_transform__8());
    Unit_getInstance();
    this._arrayTex.add_39(g._texture_0);
    Unit_getInstance();
    this._arrayX.add_20(this._get_x__36() + this._get_transform__8().transformX(x, y) * fontScale);
    this._arrayY.add_20(this._get_y__36() + this._get_transform__8().transformY(x, y) * fontScale);
    this._arraySX.add_20(this._tr_0._scaleX * fontScale);
    this._arraySY.add_20(this._tr_0._scaleY * fontScale);
    this._arrayRot.add_20(_Angle___get_radians__impl_(this._tr_0._rotation));
    return m;
  };
  Text2TextRendererActions.$metadata$ = {
    simpleName: 'Text2TextRendererActions',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__238() {
  }
  _no_name_provided__238.prototype.invoke_1006 = function ($this$CreateStringTextRenderer, text, n, c, c1, g, advance) {
    $this$CreateStringTextRenderer.put_14(c);
    Unit_getInstance();
    $this$CreateStringTextRenderer.advance_2(advance);
  };
  _no_name_provided__238.prototype.invoke_1007 = function (p1, p2, p3, p4, p5, p6, p7) {
    var tmp = p1 instanceof TextRendererActions ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    var tmp_3 = (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE();
    var tmp_4 = p6 instanceof GlyphMetrics ? p6 : THROW_CCE();
    this.invoke_1006(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, (!(p7 == null) ? typeof p7 === 'number' : false) ? p7 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__238.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__239() {
  }
  _no_name_provided__239.prototype.invoke_1005 = function () {
    return 0;
  };
  _no_name_provided__239.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__240($getVersion, $handler) {
    this._$getVersion = $getVersion;
    this._$handler = $handler;
  }
  _no_name_provided__240.prototype._get_version__1 = function () {
    return this._$getVersion();
  };
  _no_name_provided__240.prototype.run_7 = function (_this__0, text, size_1, defaultFont) {
    _this__0.reset_9();
    _this__0.setFont_2(defaultFont, size_1);
    var inductionVariable = 0;
    var last_1 = charSequenceLength(text) - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(text, n).toInt_8();
        var tmp0_getOrElse_0 = n + 1 | 0;
        var tmp;
        if (tmp0_getOrElse_0 >= 0 ? tmp0_getOrElse_0 <= _get_lastIndex__4(text) : false) {
          tmp = charSequenceGet(text, tmp0_getOrElse_0);
        } else {
          tmp = new Char(0);
        }
        var c1 = tmp.toInt_8();
        if (c === 10) {
          _this__0.newLine_2(_this__0._get_lineHeight__4());
        } else {
          var g = _this__0.getGlyphMetrics_6(c);
          _this__0._transform_5.identity_0();
          Unit_getInstance();
          this._$handler(_this__0, text, n, c, c1, g, g._xadvance_0 + _this__0.getKerning_6(c, c1));
        }
      }
       while (inductionVariable <= last_1);
  };
  _no_name_provided__240.prototype.run_8 = function (_this__0, text, size_1, defaultFont) {
    return this.run_7(_this__0, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size_1, defaultFont);
  };
  _no_name_provided__240.$metadata$ = {
    kind: 'class',
    interfaces: [TextRenderer]
  };
  function _no_name_provided_$factory_198() {
    var i = new _no_name_provided__238();
    return function (p1, p2, p3, p4, p5, p6, p7) {
      i.invoke_1006(p1, p2, p3, p4, p5, p6, p7);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_199() {
    var i = new _no_name_provided__239();
    return function () {
      return i.invoke_1005();
    };
  }
  function overlaps($this, a0, a1, b0, b1) {
    var min = min2_5(a0, a0);
    var max = max2_5(a1, a1);
    var maxMinor = max2_5(a0, b0);
    var minMajor = min2_5(a1, b1);
    return (min <= maxMinor ? maxMinor <= max : false) ? true : min <= minMajor ? minMajor <= max : false;
  }
  function SegmentHandler() {
    this._xmin_0 = intArrayListOf(new Int32Array([]));
    this._xmax_0 = intArrayListOf(new Int32Array([]));
    this.reset_9();
  }
  SegmentHandler.prototype._get_size__60 = function () {
    return this._xmin_0._get_size__60();
  };
  SegmentHandler.prototype.reset_9 = function () {
    this._xmin_0.clear_33();
    this._xmax_0.clear_33();
  };
  SegmentHandler.prototype.add_62 = function (x0, x1) {
    var inductionVariable = 0;
    var last_1 = this._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this._xmin_0.getAt_0(n);
        var xmax = this._xmax_0.getAt_0(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          this._xmin_0.set_35(n, min2_5(x0, xmin));
          this._xmax_0.set_35(n, max2_5(x1, xmax));
          return Unit_getInstance();
        }}
       while (inductionVariable < last_1);
    this._xmin_0.add_26(x0);
    this._xmax_0.add_26(x1);
  };
  SegmentHandler.$metadata$ = {
    simpleName: 'SegmentHandler',
    kind: 'class',
    interfaces: []
  };
  function ScanlineWriter($outer) {
    this._$this_12 = $outer;
    this._compositeMode = _get_DEFAULT_(Companion_getInstance_117());
    this._filler = NoneFiller_getInstance();
    this._ny0 = -1;
    this._ny = -1;
    this._alpha = new Float32Array(this._get_size__60());
    this._hitbits = new Int32Array(this._get_size__60());
    this._origin = Companion_getInstance_107().invoke_380(this._get_size__60());
    this._color_1 = Companion_getInstance_107().invoke_380(this._get_size__60());
    this._segments = new SegmentHandler();
    this._subRowCount = 0;
  }
  ScanlineWriter.prototype._get_size__60 = function () {
    return this._$this_12._bmp_2._get_width__58();
  };
  ScanlineWriter.prototype._get_width1_ = function () {
    return this._$this_12._bmp_2._get_width__58() - 1 | 0;
  };
  ScanlineWriter.prototype.reset_9 = function () {
    var tmp0_forEachFast_0 = this._segments;
    var inductionVariable = 0;
    var last_1 = tmp0_forEachFast_0._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1__anonymous__3 = tmp0_forEachFast_0._xmin_0.getAt_0(n_2);
        var tmp2__anonymous__3 = tmp0_forEachFast_0._xmax_0.getAt_0(n_2);
        fill(this._alpha, 0.0, tmp1__anonymous__3, tmp2__anonymous__3 + 1 | 0);
        fill_0(this._hitbits, 0, tmp1__anonymous__3, tmp2__anonymous__3 + 1 | 0);
      }
       while (inductionVariable < last_1);
    this._subRowCount = 0;
    this._segments.reset_9();
  };
  ScanlineWriter.prototype.select_0 = function (x0, x1, y0) {
    if (this._get_width1_() < 1)
      return Unit_getInstance();
    var x0_0 = coerceIn(x0, 0, imul(this._get_width1_(), 20));
    var x1_0 = coerceIn(x1, 0, imul(this._get_width1_(), 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this._get_width1_());
    var i1 = coerceIn(b, 0, this._get_width1_());
    var i0m = x0_0 % 20;
    var i1m = x1_0 % 20;
    if (!(this._ny === y)) {
      if (y >= 0)
        this.flush_8();
      this._ny = y;
      this.reset_9();
    }if (!(this._ny0 === y0)) {
      this._ny0 = y0;
      var tmp0_this = this;
      var tmp1 = tmp0_this._subRowCount;
      tmp0_this._subRowCount = tmp1 + 1 | 0;
      Unit_getInstance();
    }if (i1 > i0) {
      this._segments.add_62(i0, i1);
      this.put_15(i0, 1.0 - i0m / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.put_15(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0))
        this.put_15(i1, i1m / 20);
    }};
  ScanlineWriter.prototype.put_15 = function (x, ratio) {
    var mask_0 = 1 << this._subRowCount;
    if ((this._hitbits[x] & mask_0) === 0) {
      this._hitbits[x] = this._hitbits[x] | mask_0;
      var tmp0_array = this._alpha;
      var tmp1_index0 = x;
      tmp0_array[tmp1_index0] = tmp0_array[tmp1_index0] + ratio;
    }};
  ScanlineWriter.prototype.flush_8 = function () {
    var containsUpper = this._$this_12._bmp_2._get_height__58();
    var containsArg = this._ny;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_getInstance();
    else {
    }
    var scale_1 = 1.0 / this._subRowCount;
    var tmp0_forEachFast_0 = this._segments;
    var inductionVariable = 0;
    var last_1 = tmp0_forEachFast_0._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1__anonymous__3 = tmp0_forEachFast_0._xmin_0.getAt_0(n_2);
        var tmp2__anonymous__3 = tmp0_forEachFast_0._xmax_0.getAt_0(n_2);
        var x_4 = tmp1__anonymous__3;
        var count_5 = (tmp2__anonymous__3 - tmp1__anonymous__3 | 0) + 1 | 0;
        this._filler.fill_5(this._color_1, 0, tmp1__anonymous__3, tmp2__anonymous__3, this._ny);
        var inductionVariable_0 = tmp1__anonymous__3;
        if (inductionVariable_0 <= tmp2__anonymous__3)
          do {
            var n_7 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp1_array_8 = this._alpha;
            var tmp2_index0_9 = n_7;
            tmp1_array_8[tmp2_index0_9] = tmp1_array_8[tmp2_index0_9] * scale_1;
          }
           while (!(n_7 === tmp2__anonymous__3));
        scale(this._color_1, tmp1__anonymous__3, this._alpha, tmp1__anonymous__3, count_5);
        var index_10 = this._$this_12._bmp_2.index_7(0, this._ny) + x_4 | 0;
        if (this._$this_12._bmp_2._get_premultiplied__8())
          arraycopy_4(_RgbaPremultipliedArray___get_ints__impl_(this._$this_12._bmp_2._dataPremult), index_10, _RgbaPremultipliedArray___get_ints__impl_(this._origin), x_4, count_5);
        else
          premultiply(this._$this_12._bmp_2._data_39, index_10, this._origin, x_4, count_5);
        this._compositeMode.blend_2(this._origin, x_4, this._color_1, x_4, count_5);
        if (this._$this_12._bmp_2._get_premultiplied__8())
          arraycopy_4(_RgbaPremultipliedArray___get_ints__impl_(this._origin), x_4, _RgbaPremultipliedArray___get_ints__impl_(this._$this_12._bmp_2._dataPremult), index_10, count_5);
        else
          depremultiply(this._origin, x_4, this._$this_12._bmp_2._data_39, index_10, count_5);
      }
       while (inductionVariable < last_1);
  };
  ScanlineWriter.$metadata$ = {
    simpleName: 'ScanlineWriter',
    kind: 'class',
    interfaces: []
  };
  function render$flush(this$0, $filler, $fillPath) {
    if (this$0._rasterizer._path_27.isNotEmpty_1()) {
      this$0._rasterizer._quality_0 = this$0._antialiasing ? 4 : 1;
      this$0._scanlineWriter._filler = $filler;
      this$0._scanlineWriter.reset_9();
      var tmp = $fillPath._winding_0;
      this$0._rasterizer.rasterizeFill$default(this$0._bounds_3, 0, null, tmp, _no_name_provided_$factory_200(this$0), 6, null);
      this$0._scanlineWriter.flush_8();
      this$0._rasterizer._path_27.reset_9();
    }}
  function _no_name_provided__241(this$0) {
    this._this$0_53 = this$0;
  }
  _no_name_provided__241.prototype.invoke_426 = function (x0, x1, y) {
    this._this$0_53._scanlineWriter.select_0(x0, x1, y);
  };
  _no_name_provided__241.prototype.invoke_704 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    this.invoke_426(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__241.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Bitmap32Context2d(bmp, antialiasing) {
    Renderer.call(this);
    this._bmp_2 = bmp;
    this._antialiasing = antialiasing;
    this._bounds_3 = _get_float_(this._bmp_2._bounds);
    this._rasterizer = new Rasterizer();
    this._colorFiller = new ColorFiller();
    this._gradientFiller = new GradientFiller();
    this._bitmapFiller = new BitmapFiller();
    this._scanlineWriter = new ScanlineWriter(this);
    var tmp = this;
    tmp._tempPath = VectorPath_init_$Create$(null, null, Winding_EVEN_ODD_getInstance(), 3, null);
    this._tempFillStrokeTemp = new StrokeToFill();
  }
  Bitmap32Context2d.prototype._get_width__58 = function () {
    return this._bmp_2._get_width__58();
  };
  Bitmap32Context2d.prototype._get_height__58 = function () {
    return this._bmp_2._get_height__58();
  };
  Bitmap32Context2d.prototype.render_1 = function (state, fill_3) {
    var style = fill_3 ? state._fillStyle : state._strokeStyle;
    var tmp0_subject = style;
    var tmp;
    if (tmp0_subject instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (tmp0_subject instanceof RGBA) {
        tmp = this._colorFiller.set_20(style._value_17, state);
      } else {
        if (tmp0_subject instanceof GradientPaint) {
          tmp = this._gradientFiller.set_21(style, state);
        } else {
          if (tmp0_subject instanceof BitmapPaint) {
            tmp = this._bitmapFiller.set_22(style, state);
          } else {
            {
              throw NotImplementedError_init_$Create$(null, 1, null);
            }
          }
        }
      }
    }
    var filler = tmp;
    this._scanlineWriter._compositeMode = state._globalCompositeOperation;
    this._rasterizer.reset_9();
    this._rasterizer._debug = this._get_debug__0();
    var doingStroke = !fill_3;
    var tmp_0;
    if (fill_3) {
      tmp_0 = state._path_24;
    } else {
      this._tempPath.clear_33();
      tmp_0 = strokeToFill(state._path_24, state._get_scaledLineWidth_(), state._lineJoin, state._startLineCap, state._endLineCap, state._miterLimit_0, this._tempFillStrokeTemp, this._tempPath);
    }
    var fillPath = tmp_0;
    if (!(state._clip == null)) {
      this._rasterizer._clip_2._winding = ensureNotNull(state._clip)._get_winding__0();
      var tmp0_emitPoints2_0 = ensureNotNull(state._clip);
      var ix_3 = 0.0;
      var iy_4 = 0.0;
      var lx_5 = {_v: 0.0};
      var ly_6 = {_v: 0.0};
      var tmp1__anonymous__119 = false;
      if (tmp1__anonymous__119)
        this._rasterizer._clip_2.close_77();
      var n_1_7 = 0;
      var tmp0_fastForEach_0_8 = tmp0_emitPoints2_0._commands;
      var n_1_9 = 0;
      while (n_1_9 < tmp0_fastForEach_0_8._get_size__60()) {
        var tmp0_2_11 = n_1_9;
        n_1_9 = tmp0_2_11 + 1 | 0;
        var tmp1__anonymous__2_3_10 = tmp0_fastForEach_0_8.getAt_0(tmp0_2_11);
        var tmp0_subject_3_4_12 = tmp1__anonymous__2_3_10;
        switch (tmp0_subject_3_4_12) {
          case 0:
            var tmp1_4_5_14 = n_1_7;
            n_1_7 = tmp1_4_5_14 + 1 | 0;
            var tmp2__anonymous__18_13 = tmp0_emitPoints2_0._data_37.get_137(tmp1_4_5_14);
            var tmp2_5_6_16 = n_1_7;
            n_1_7 = tmp2_5_6_16 + 1 | 0;
            var tmp3__anonymous__18_15 = tmp0_emitPoints2_0._data_37.get_137(tmp2_5_6_16);
            ix_3 = tmp2__anonymous__18_13;
            iy_4 = tmp3__anonymous__18_15;
            var tmp2__anonymous__120 = true;
            var tmp0_also_0_20_18 = this._rasterizer._clip_2.add_56(tmp2__anonymous__18_13, tmp3__anonymous__18_15, tmp2__anonymous__120);
            lx_5._v = tmp2__anonymous__18_13;
            var tmp1_also_0_19_17 = tmp0_also_0_20_18;
            ly_6._v = tmp3__anonymous__18_15;
            break;
          case 1:
            var tmp3_6_7_20 = n_1_7;
            n_1_7 = tmp3_6_7_20 + 1 | 0;
            var tmp4__anonymous__21_19 = tmp0_emitPoints2_0._data_37.get_137(tmp3_6_7_20);
            var tmp4_7_8_22 = n_1_7;
            n_1_7 = tmp4_7_8_22 + 1 | 0;
            var tmp5__anonymous__21_21 = tmp0_emitPoints2_0._data_37.get_137(tmp4_7_8_22);
            var tmp3__anonymous__120 = false;
            var tmp0_also_0_23_24 = this._rasterizer._clip_2.add_56(tmp4__anonymous__21_19, tmp5__anonymous__21_21, tmp3__anonymous__120);
            lx_5._v = tmp4__anonymous__21_19;
            var tmp1_also_0_22_23 = tmp0_also_0_23_24;
            ly_6._v = tmp5__anonymous__21_21;
            var tmp4__anonymous__2_121 = false;
            Unit_getInstance();
            break;
          case 2:
            var tmp5_8_9_26 = n_1_7;
            n_1_7 = tmp5_8_9_26 + 1 | 0;
            var tmp6__anonymous__24_25 = tmp0_emitPoints2_0._data_37.get_137(tmp5_8_9_26);
            var tmp6_9_10_28 = n_1_7;
            n_1_7 = tmp6_9_10_28 + 1 | 0;
            var tmp7__anonymous__24_27 = tmp0_emitPoints2_0._data_37.get_137(tmp6_9_10_28);
            var tmp7_10_11_30 = n_1_7;
            n_1_7 = tmp7_10_11_30 + 1 | 0;
            var tmp8__anonymous__24_29 = tmp0_emitPoints2_0._data_37.get_137(tmp7_10_11_30);
            var tmp8_11_12_32 = n_1_7;
            n_1_7 = tmp8_11_12_32 + 1 | 0;
            var tmp9__anonymous__24_31 = tmp0_emitPoints2_0._data_37.get_137(tmp8_11_12_32);
            var sum_25_33 = Companion_getInstance_80().distance(lx_5._v, ly_6._v, tmp6__anonymous__24_25, tmp7__anonymous__24_27) + Companion_getInstance_80().distance(tmp6__anonymous__24_25, tmp7__anonymous__24_27, tmp8__anonymous__24_29, tmp9__anonymous__24_31);
            var tmp0_approximateCurve_0_26_34 = numberToInt(sum_25_33);
            var rcurveSteps_1_27_35 = max2_4(tmp0_approximateCurve_0_26_34, 20);
            var dt_2_28_36 = 1.0 / rcurveSteps_1_27_35;
            var lastX_3_29_37 = {_v: 0.0};
            var lastY_4_30_38 = {_v: 0.0};
            var prevX_5_31_39 = {_v: 0.0};
            var prevY_6_32_40 = {_v: 0.0};
            var emittedCount_7_33_41 = {_v: 0};
            var tmp1__anonymous__15_34_42 = 0.0;
            var tmp0_quadCalc_0_16_35_43 = Companion_getInstance_89();
            var tmp1_quadCalc_0_17_36_44 = lx_5._v;
            var tmp2_quadCalc_0_18_37_45 = ly_6._v;
            var t1_1_19_38_46 = 1 - tmp1__anonymous__15_34_42;
            var a_2_20_39_47 = t1_1_19_38_46 * t1_1_19_38_46;
            var c_3_21_40_48 = tmp1__anonymous__15_34_42 * tmp1__anonymous__15_34_42;
            var b_4_22_41_49 = 2 * t1_1_19_38_46 * tmp1__anonymous__15_34_42;
            var tmp3__anonymous__5_23_42_50 = a_2_20_39_47 * tmp1_quadCalc_0_17_36_44 + b_4_22_41_49 * tmp6__anonymous__24_25 + c_3_21_40_48 * tmp8__anonymous__24_29;
            var tmp4__anonymous__5_24_43_51 = a_2_20_39_47 * tmp2_quadCalc_0_18_37_45 + b_4_22_41_49 * tmp7__anonymous__24_27 + c_3_21_40_48 * tmp9__anonymous__24_31;
            lastX_3_29_37._v = tmp3__anonymous__5_23_42_50;
            lastY_4_30_38._v = tmp4__anonymous__5_24_43_51;
            var inductionVariable = 1;
            if (inductionVariable < rcurveSteps_1_27_35)
              do {
                var n_10_45_53 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_11_46_54 = n_10_45_53 * dt_2_28_36;
                var tmp0_quadCalc_0_16_47_55 = Companion_getInstance_89();
                var tmp1_quadCalc_0_17_48_56 = lx_5._v;
                var tmp2_quadCalc_0_18_49_57 = ly_6._v;
                var t1_1_19_50_58 = 1 - ratio_11_46_54;
                var a_2_20_51_59 = t1_1_19_50_58 * t1_1_19_50_58;
                var c_3_21_52_60 = ratio_11_46_54 * ratio_11_46_54;
                var b_4_22_53_61 = 2 * t1_1_19_50_58 * ratio_11_46_54;
                var tmp3__anonymous__5_23_54_62 = a_2_20_51_59 * tmp1_quadCalc_0_17_48_56 + b_4_22_53_61 * tmp6__anonymous__24_25 + c_3_21_52_60 * tmp8__anonymous__24_29;
                var tmp4__anonymous__5_24_55_63 = a_2_20_51_59 * tmp2_quadCalc_0_18_49_57 + b_4_22_53_61 * tmp7__anonymous__24_27 + c_3_21_52_60 * tmp9__anonymous__24_31;
                var tmp5__anonymous__120 = false;
                this._rasterizer._clip_2.add_56(tmp3__anonymous__5_23_54_62, tmp4__anonymous__5_24_55_63, tmp5__anonymous__120);
                var tmp0_14_2_27_56_64 = emittedCount_7_33_41._v;
                emittedCount_7_33_41._v = tmp0_14_2_27_56_64 + 1 | 0;
                Unit_getInstance();
                lastX_3_29_37._v = prevX_5_31_39._v;
                lastY_4_30_38._v = prevY_6_32_40._v;
                prevX_5_31_39._v = tmp3__anonymous__5_23_54_62;
                prevY_6_32_40._v = tmp4__anonymous__5_24_55_63;
              }
               while (inductionVariable < rcurveSteps_1_27_35);
            var tmp2_also_0_57_65 = lx_5._v = tmp8__anonymous__24_29;
            ly_6._v = tmp9__anonymous__24_31;
            var tmp6__anonymous__2_121 = false;
            Unit_getInstance();
            break;
          case 3:
            var tmp9_12_13_67 = n_1_7;
            n_1_7 = tmp9_12_13_67 + 1 | 0;
            var tmp10__anonymous__58_66 = tmp0_emitPoints2_0._data_37.get_137(tmp9_12_13_67);
            var tmp10_13_14_69 = n_1_7;
            n_1_7 = tmp10_13_14_69 + 1 | 0;
            var tmp11__anonymous__58_68 = tmp0_emitPoints2_0._data_37.get_137(tmp10_13_14_69);
            var tmp11_14_15_71 = n_1_7;
            n_1_7 = tmp11_14_15_71 + 1 | 0;
            var tmp12__anonymous__58_70 = tmp0_emitPoints2_0._data_37.get_137(tmp11_14_15_71);
            var tmp12_15_16_73 = n_1_7;
            n_1_7 = tmp12_15_16_73 + 1 | 0;
            var tmp13__anonymous__58_72 = tmp0_emitPoints2_0._data_37.get_137(tmp12_15_16_73);
            var tmp13_16_17_75 = n_1_7;
            n_1_7 = tmp13_16_17_75 + 1 | 0;
            var tmp14__anonymous__58_74 = tmp0_emitPoints2_0._data_37.get_137(tmp13_16_17_75);
            var tmp14_17_18_77 = n_1_7;
            n_1_7 = tmp14_17_18_77 + 1 | 0;
            var tmp15__anonymous__58_76 = tmp0_emitPoints2_0._data_37.get_137(tmp14_17_18_77);
            var sum_59_78 = Companion_getInstance_80().distance(lx_5._v, ly_6._v, tmp10__anonymous__58_66, tmp11__anonymous__58_68) + Companion_getInstance_80().distance(tmp10__anonymous__58_66, tmp11__anonymous__58_68, tmp12__anonymous__58_70, tmp13__anonymous__58_72) + Companion_getInstance_80().distance(tmp12__anonymous__58_70, tmp13__anonymous__58_72, tmp14__anonymous__58_74, tmp15__anonymous__58_76);
            var tmp0_approximateCurve_0_60_79 = numberToInt(sum_59_78);
            var rcurveSteps_1_61_80 = max2_4(tmp0_approximateCurve_0_60_79, 20);
            var dt_2_62_81 = 1.0 / rcurveSteps_1_61_80;
            var lastX_3_63_82 = {_v: 0.0};
            var lastY_4_64_83 = {_v: 0.0};
            var prevX_5_65_84 = {_v: 0.0};
            var prevY_6_66_85 = {_v: 0.0};
            var emittedCount_7_67_86 = {_v: 0};
            var tmp1__anonymous__15_68_87 = 0.0;
            var tmp0_cubicCalc_0_16_69_88 = Companion_getInstance_89();
            var tmp1_cubicCalc_0_17_70_89 = lx_5._v;
            var tmp2_cubicCalc_0_18_71_90 = ly_6._v;
            var cx_1_19_72_91 = 3.0 * (tmp10__anonymous__58_66 - tmp1_cubicCalc_0_17_70_89);
            var bx_2_20_73_92 = 3.0 * (tmp12__anonymous__58_70 - tmp10__anonymous__58_66) - cx_1_19_72_91;
            var ax_3_21_74_93 = tmp14__anonymous__58_74 - tmp1_cubicCalc_0_17_70_89 - cx_1_19_72_91 - bx_2_20_73_92;
            var cy_4_22_75_94 = 3.0 * (tmp11__anonymous__58_68 - tmp2_cubicCalc_0_18_71_90);
            var by_5_23_76_95 = 3.0 * (tmp13__anonymous__58_72 - tmp11__anonymous__58_68) - cy_4_22_75_94;
            var ay_6_24_77_96 = tmp15__anonymous__58_76 - tmp2_cubicCalc_0_18_71_90 - cy_4_22_75_94 - by_5_23_76_95;
            var tSquared_7_25_78_97 = tmp1__anonymous__15_68_87 * tmp1__anonymous__15_68_87;
            var tCubed_8_26_79_98 = tSquared_7_25_78_97 * tmp1__anonymous__15_68_87;
            var tmp3__anonymous__9_27_80_99 = ax_3_21_74_93 * tCubed_8_26_79_98 + bx_2_20_73_92 * tSquared_7_25_78_97 + cx_1_19_72_91 * tmp1__anonymous__15_68_87 + tmp1_cubicCalc_0_17_70_89;
            var tmp4__anonymous__9_28_81_100 = ay_6_24_77_96 * tCubed_8_26_79_98 + by_5_23_76_95 * tSquared_7_25_78_97 + cy_4_22_75_94 * tmp1__anonymous__15_68_87 + tmp2_cubicCalc_0_18_71_90;
            lastX_3_63_82._v = tmp3__anonymous__9_27_80_99;
            lastY_4_64_83._v = tmp4__anonymous__9_28_81_100;
            var inductionVariable_0 = 1;
            if (inductionVariable_0 < rcurveSteps_1_61_80)
              do {
                var n_10_83_102 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ratio_11_84_103 = n_10_83_102 * dt_2_62_81;
                var tmp0_cubicCalc_0_16_85_104 = Companion_getInstance_89();
                var tmp1_cubicCalc_0_17_86_105 = lx_5._v;
                var tmp2_cubicCalc_0_18_87_106 = ly_6._v;
                var cx_1_19_88_107 = 3.0 * (tmp10__anonymous__58_66 - tmp1_cubicCalc_0_17_86_105);
                var bx_2_20_89_108 = 3.0 * (tmp12__anonymous__58_70 - tmp10__anonymous__58_66) - cx_1_19_88_107;
                var ax_3_21_90_109 = tmp14__anonymous__58_74 - tmp1_cubicCalc_0_17_86_105 - cx_1_19_88_107 - bx_2_20_89_108;
                var cy_4_22_91_110 = 3.0 * (tmp11__anonymous__58_68 - tmp2_cubicCalc_0_18_87_106);
                var by_5_23_92_111 = 3.0 * (tmp13__anonymous__58_72 - tmp11__anonymous__58_68) - cy_4_22_91_110;
                var ay_6_24_93_112 = tmp15__anonymous__58_76 - tmp2_cubicCalc_0_18_87_106 - cy_4_22_91_110 - by_5_23_92_111;
                var tSquared_7_25_94_113 = ratio_11_84_103 * ratio_11_84_103;
                var tCubed_8_26_95_114 = tSquared_7_25_94_113 * ratio_11_84_103;
                var tmp3__anonymous__9_27_96_115 = ax_3_21_90_109 * tCubed_8_26_95_114 + bx_2_20_89_108 * tSquared_7_25_94_113 + cx_1_19_88_107 * ratio_11_84_103 + tmp1_cubicCalc_0_17_86_105;
                var tmp4__anonymous__9_28_97_116 = ay_6_24_93_112 * tCubed_8_26_95_114 + by_5_23_92_111 * tSquared_7_25_94_113 + cy_4_22_91_110 * ratio_11_84_103 + tmp2_cubicCalc_0_18_87_106;
                var tmp7__anonymous__120 = false;
                this._rasterizer._clip_2.add_56(tmp3__anonymous__9_27_96_115, tmp4__anonymous__9_28_97_116, tmp7__anonymous__120);
                var tmp0_14_2_31_98_117 = emittedCount_7_67_86._v;
                emittedCount_7_67_86._v = tmp0_14_2_31_98_117 + 1 | 0;
                Unit_getInstance();
                lastX_3_63_82._v = prevX_5_65_84._v;
                lastY_4_64_83._v = prevY_6_66_85._v;
                prevX_5_65_84._v = tmp3__anonymous__9_27_96_115;
                prevY_6_66_85._v = tmp4__anonymous__9_28_97_116;
              }
               while (inductionVariable_0 < rcurveSteps_1_61_80);
            var tmp2_also_0_99_118 = lx_5._v = tmp14__anonymous__58_74;
            ly_6._v = tmp15__anonymous__58_76;
            var tmp8__anonymous__2_121 = false;
            Unit_getInstance();
            break;
          case 4:
            var tmp9__anonymous__120 = ix_3;
            var tmp10__anonymous__120 = iy_4;
            var tmp11__anonymous__120 = false;
            this._rasterizer._clip_2.add_56(tmp9__anonymous__120, tmp10__anonymous__120, tmp11__anonymous__120);
            var tmp12__anonymous__2_121 = true;
            Unit_getInstance();
            var tmp13__anonymous__119 = true;
            if (tmp13__anonymous__119)
              this._rasterizer._clip_2.close_77();
            break;
        }
      }
      var tmp14__anonymous__119 = false;
      if (tmp14__anonymous__119)
        this._rasterizer._clip_2.close_77();
    }this._rasterizer._path_27._winding = ensureNotNull(state._path_24)._get_winding__0();
    var ix_3_0 = 0.0;
    var iy_4_0 = 0.0;
    var lx_5_0 = {_v: 0.0};
    var ly_6_0 = {_v: 0.0};
    var tmp15__anonymous__119 = false;
    if (tmp15__anonymous__119) {
      this._rasterizer._path_27.close_77();
    }var n_1_7_0 = 0;
    var tmp0_fastForEach_0_8_0 = fillPath._commands;
    var n_1_9_0 = 0;
    while (n_1_9_0 < tmp0_fastForEach_0_8_0._get_size__60()) {
      var tmp0_2_11_0 = n_1_9_0;
      n_1_9_0 = tmp0_2_11_0 + 1 | 0;
      var tmp1__anonymous__2_3_10_0 = tmp0_fastForEach_0_8_0.getAt_0(tmp0_2_11_0);
      var tmp0_subject_3_4_12_0 = tmp1__anonymous__2_3_10_0;
      switch (tmp0_subject_3_4_12_0) {
        case 0:
          var tmp1_4_5_14_0 = n_1_7_0;
          n_1_7_0 = tmp1_4_5_14_0 + 1 | 0;
          var tmp2__anonymous__18_13_0 = fillPath._data_37.get_137(tmp1_4_5_14_0);
          var tmp2_5_6_16_0 = n_1_7_0;
          n_1_7_0 = tmp2_5_6_16_0 + 1 | 0;
          var tmp3__anonymous__18_15_0 = fillPath._data_37.get_137(tmp2_5_6_16_0);
          ix_3_0 = tmp2__anonymous__18_13_0;
          iy_4_0 = tmp3__anonymous__18_15_0;
          var tmp16__anonymous__120 = true;
          if (doingStroke) {
            if (tmp16__anonymous__120) {
              render$flush(this, filler, fillPath);
            }}
          var tmp0_also_0_20_18_0 = this._rasterizer._path_27.add_56(tmp2__anonymous__18_13_0, tmp3__anonymous__18_15_0, tmp16__anonymous__120);
          lx_5_0._v = tmp2__anonymous__18_13_0;
          var tmp1_also_0_19_17_0 = tmp0_also_0_20_18_0;
          ly_6_0._v = tmp3__anonymous__18_15_0;
          break;
        case 1:
          var tmp3_6_7_20_0 = n_1_7_0;
          n_1_7_0 = tmp3_6_7_20_0 + 1 | 0;
          var tmp4__anonymous__21_19_0 = fillPath._data_37.get_137(tmp3_6_7_20_0);
          var tmp4_7_8_22_0 = n_1_7_0;
          n_1_7_0 = tmp4_7_8_22_0 + 1 | 0;
          var tmp5__anonymous__21_21_0 = fillPath._data_37.get_137(tmp4_7_8_22_0);
          var tmp17__anonymous__120 = false;
          if (doingStroke) {
            if (tmp17__anonymous__120) {
              render$flush(this, filler, fillPath);
            }}
          var tmp0_also_0_23_24_0 = this._rasterizer._path_27.add_56(tmp4__anonymous__21_19_0, tmp5__anonymous__21_21_0, tmp17__anonymous__120);
          lx_5_0._v = tmp4__anonymous__21_19_0;
          var tmp1_also_0_22_23_0 = tmp0_also_0_23_24_0;
          ly_6_0._v = tmp5__anonymous__21_21_0;
          var tmp18__anonymous__2_121 = false;
          Unit_getInstance();
          break;
        case 2:
          var tmp5_8_9_26_0 = n_1_7_0;
          n_1_7_0 = tmp5_8_9_26_0 + 1 | 0;
          var tmp6__anonymous__24_25_0 = fillPath._data_37.get_137(tmp5_8_9_26_0);
          var tmp6_9_10_28_0 = n_1_7_0;
          n_1_7_0 = tmp6_9_10_28_0 + 1 | 0;
          var tmp7__anonymous__24_27_0 = fillPath._data_37.get_137(tmp6_9_10_28_0);
          var tmp7_10_11_30_0 = n_1_7_0;
          n_1_7_0 = tmp7_10_11_30_0 + 1 | 0;
          var tmp8__anonymous__24_29_0 = fillPath._data_37.get_137(tmp7_10_11_30_0);
          var tmp8_11_12_32_0 = n_1_7_0;
          n_1_7_0 = tmp8_11_12_32_0 + 1 | 0;
          var tmp9__anonymous__24_31_0 = fillPath._data_37.get_137(tmp8_11_12_32_0);
          var sum_25_33_0 = Companion_getInstance_80().distance(lx_5_0._v, ly_6_0._v, tmp6__anonymous__24_25_0, tmp7__anonymous__24_27_0) + Companion_getInstance_80().distance(tmp6__anonymous__24_25_0, tmp7__anonymous__24_27_0, tmp8__anonymous__24_29_0, tmp9__anonymous__24_31_0);
          var tmp0_approximateCurve_0_26_34_0 = numberToInt(sum_25_33_0);
          var rcurveSteps_1_27_35_0 = max2_4(tmp0_approximateCurve_0_26_34_0, 20);
          var dt_2_28_36_0 = 1.0 / rcurveSteps_1_27_35_0;
          var lastX_3_29_37_0 = {_v: 0.0};
          var lastY_4_30_38_0 = {_v: 0.0};
          var prevX_5_31_39_0 = {_v: 0.0};
          var prevY_6_32_40_0 = {_v: 0.0};
          var emittedCount_7_33_41_0 = {_v: 0};
          var tmp1__anonymous__15_34_42_0 = 0.0;
          var tmp0_quadCalc_0_16_35_43_0 = Companion_getInstance_89();
          var tmp1_quadCalc_0_17_36_44_0 = lx_5_0._v;
          var tmp2_quadCalc_0_18_37_45_0 = ly_6_0._v;
          var t1_1_19_38_46_0 = 1 - tmp1__anonymous__15_34_42_0;
          var a_2_20_39_47_0 = t1_1_19_38_46_0 * t1_1_19_38_46_0;
          var c_3_21_40_48_0 = tmp1__anonymous__15_34_42_0 * tmp1__anonymous__15_34_42_0;
          var b_4_22_41_49_0 = 2 * t1_1_19_38_46_0 * tmp1__anonymous__15_34_42_0;
          var tmp3__anonymous__5_23_42_50_0 = a_2_20_39_47_0 * tmp1_quadCalc_0_17_36_44_0 + b_4_22_41_49_0 * tmp6__anonymous__24_25_0 + c_3_21_40_48_0 * tmp8__anonymous__24_29_0;
          var tmp4__anonymous__5_24_43_51_0 = a_2_20_39_47_0 * tmp2_quadCalc_0_18_37_45_0 + b_4_22_41_49_0 * tmp7__anonymous__24_27_0 + c_3_21_40_48_0 * tmp9__anonymous__24_31_0;
          lastX_3_29_37_0._v = tmp3__anonymous__5_23_42_50_0;
          lastY_4_30_38_0._v = tmp4__anonymous__5_24_43_51_0;
          var inductionVariable_1 = 1;
          if (inductionVariable_1 < rcurveSteps_1_27_35_0)
            do {
              var n_10_45_53_0 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var ratio_11_46_54_0 = n_10_45_53_0 * dt_2_28_36_0;
              var tmp0_quadCalc_0_16_47_55_0 = Companion_getInstance_89();
              var tmp1_quadCalc_0_17_48_56_0 = lx_5_0._v;
              var tmp2_quadCalc_0_18_49_57_0 = ly_6_0._v;
              var t1_1_19_50_58_0 = 1 - ratio_11_46_54_0;
              var a_2_20_51_59_0 = t1_1_19_50_58_0 * t1_1_19_50_58_0;
              var c_3_21_52_60_0 = ratio_11_46_54_0 * ratio_11_46_54_0;
              var b_4_22_53_61_0 = 2 * t1_1_19_50_58_0 * ratio_11_46_54_0;
              var tmp3__anonymous__5_23_54_62_0 = a_2_20_51_59_0 * tmp1_quadCalc_0_17_48_56_0 + b_4_22_53_61_0 * tmp6__anonymous__24_25_0 + c_3_21_52_60_0 * tmp8__anonymous__24_29_0;
              var tmp4__anonymous__5_24_55_63_0 = a_2_20_51_59_0 * tmp2_quadCalc_0_18_49_57_0 + b_4_22_53_61_0 * tmp7__anonymous__24_27_0 + c_3_21_52_60_0 * tmp9__anonymous__24_31_0;
              var tmp19__anonymous__120 = false;
              if (doingStroke) {
                if (tmp19__anonymous__120) {
                  render$flush(this, filler, fillPath);
                }}this._rasterizer._path_27.add_56(tmp3__anonymous__5_23_54_62_0, tmp4__anonymous__5_24_55_63_0, tmp19__anonymous__120);
              var tmp0_14_2_27_56_64_0 = emittedCount_7_33_41_0._v;
              emittedCount_7_33_41_0._v = tmp0_14_2_27_56_64_0 + 1 | 0;
              Unit_getInstance();
              lastX_3_29_37_0._v = prevX_5_31_39_0._v;
              lastY_4_30_38_0._v = prevY_6_32_40_0._v;
              prevX_5_31_39_0._v = tmp3__anonymous__5_23_54_62_0;
              prevY_6_32_40_0._v = tmp4__anonymous__5_24_55_63_0;
            }
             while (inductionVariable_1 < rcurveSteps_1_27_35_0);
          var tmp2_also_0_57_65_0 = lx_5_0._v = tmp8__anonymous__24_29_0;
          ly_6_0._v = tmp9__anonymous__24_31_0;
          var tmp20__anonymous__2_121 = false;
          Unit_getInstance();
          break;
        case 3:
          var tmp9_12_13_67_0 = n_1_7_0;
          n_1_7_0 = tmp9_12_13_67_0 + 1 | 0;
          var tmp10__anonymous__58_66_0 = fillPath._data_37.get_137(tmp9_12_13_67_0);
          var tmp10_13_14_69_0 = n_1_7_0;
          n_1_7_0 = tmp10_13_14_69_0 + 1 | 0;
          var tmp11__anonymous__58_68_0 = fillPath._data_37.get_137(tmp10_13_14_69_0);
          var tmp11_14_15_71_0 = n_1_7_0;
          n_1_7_0 = tmp11_14_15_71_0 + 1 | 0;
          var tmp12__anonymous__58_70_0 = fillPath._data_37.get_137(tmp11_14_15_71_0);
          var tmp12_15_16_73_0 = n_1_7_0;
          n_1_7_0 = tmp12_15_16_73_0 + 1 | 0;
          var tmp13__anonymous__58_72_0 = fillPath._data_37.get_137(tmp12_15_16_73_0);
          var tmp13_16_17_75_0 = n_1_7_0;
          n_1_7_0 = tmp13_16_17_75_0 + 1 | 0;
          var tmp14__anonymous__58_74_0 = fillPath._data_37.get_137(tmp13_16_17_75_0);
          var tmp14_17_18_77_0 = n_1_7_0;
          n_1_7_0 = tmp14_17_18_77_0 + 1 | 0;
          var tmp15__anonymous__58_76_0 = fillPath._data_37.get_137(tmp14_17_18_77_0);
          var sum_59_78_0 = Companion_getInstance_80().distance(lx_5_0._v, ly_6_0._v, tmp10__anonymous__58_66_0, tmp11__anonymous__58_68_0) + Companion_getInstance_80().distance(tmp10__anonymous__58_66_0, tmp11__anonymous__58_68_0, tmp12__anonymous__58_70_0, tmp13__anonymous__58_72_0) + Companion_getInstance_80().distance(tmp12__anonymous__58_70_0, tmp13__anonymous__58_72_0, tmp14__anonymous__58_74_0, tmp15__anonymous__58_76_0);
          var tmp0_approximateCurve_0_60_79_0 = numberToInt(sum_59_78_0);
          var rcurveSteps_1_61_80_0 = max2_4(tmp0_approximateCurve_0_60_79_0, 20);
          var dt_2_62_81_0 = 1.0 / rcurveSteps_1_61_80_0;
          var lastX_3_63_82_0 = {_v: 0.0};
          var lastY_4_64_83_0 = {_v: 0.0};
          var prevX_5_65_84_0 = {_v: 0.0};
          var prevY_6_66_85_0 = {_v: 0.0};
          var emittedCount_7_67_86_0 = {_v: 0};
          var tmp1__anonymous__15_68_87_0 = 0.0;
          var tmp0_cubicCalc_0_16_69_88_0 = Companion_getInstance_89();
          var tmp1_cubicCalc_0_17_70_89_0 = lx_5_0._v;
          var tmp2_cubicCalc_0_18_71_90_0 = ly_6_0._v;
          var cx_1_19_72_91_0 = 3.0 * (tmp10__anonymous__58_66_0 - tmp1_cubicCalc_0_17_70_89_0);
          var bx_2_20_73_92_0 = 3.0 * (tmp12__anonymous__58_70_0 - tmp10__anonymous__58_66_0) - cx_1_19_72_91_0;
          var ax_3_21_74_93_0 = tmp14__anonymous__58_74_0 - tmp1_cubicCalc_0_17_70_89_0 - cx_1_19_72_91_0 - bx_2_20_73_92_0;
          var cy_4_22_75_94_0 = 3.0 * (tmp11__anonymous__58_68_0 - tmp2_cubicCalc_0_18_71_90_0);
          var by_5_23_76_95_0 = 3.0 * (tmp13__anonymous__58_72_0 - tmp11__anonymous__58_68_0) - cy_4_22_75_94_0;
          var ay_6_24_77_96_0 = tmp15__anonymous__58_76_0 - tmp2_cubicCalc_0_18_71_90_0 - cy_4_22_75_94_0 - by_5_23_76_95_0;
          var tSquared_7_25_78_97_0 = tmp1__anonymous__15_68_87_0 * tmp1__anonymous__15_68_87_0;
          var tCubed_8_26_79_98_0 = tSquared_7_25_78_97_0 * tmp1__anonymous__15_68_87_0;
          var tmp3__anonymous__9_27_80_99_0 = ax_3_21_74_93_0 * tCubed_8_26_79_98_0 + bx_2_20_73_92_0 * tSquared_7_25_78_97_0 + cx_1_19_72_91_0 * tmp1__anonymous__15_68_87_0 + tmp1_cubicCalc_0_17_70_89_0;
          var tmp4__anonymous__9_28_81_100_0 = ay_6_24_77_96_0 * tCubed_8_26_79_98_0 + by_5_23_76_95_0 * tSquared_7_25_78_97_0 + cy_4_22_75_94_0 * tmp1__anonymous__15_68_87_0 + tmp2_cubicCalc_0_18_71_90_0;
          lastX_3_63_82_0._v = tmp3__anonymous__9_27_80_99_0;
          lastY_4_64_83_0._v = tmp4__anonymous__9_28_81_100_0;
          var inductionVariable_2 = 1;
          if (inductionVariable_2 < rcurveSteps_1_61_80_0)
            do {
              var n_10_83_102_0 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio_11_84_103_0 = n_10_83_102_0 * dt_2_62_81_0;
              var tmp0_cubicCalc_0_16_85_104_0 = Companion_getInstance_89();
              var tmp1_cubicCalc_0_17_86_105_0 = lx_5_0._v;
              var tmp2_cubicCalc_0_18_87_106_0 = ly_6_0._v;
              var cx_1_19_88_107_0 = 3.0 * (tmp10__anonymous__58_66_0 - tmp1_cubicCalc_0_17_86_105_0);
              var bx_2_20_89_108_0 = 3.0 * (tmp12__anonymous__58_70_0 - tmp10__anonymous__58_66_0) - cx_1_19_88_107_0;
              var ax_3_21_90_109_0 = tmp14__anonymous__58_74_0 - tmp1_cubicCalc_0_17_86_105_0 - cx_1_19_88_107_0 - bx_2_20_89_108_0;
              var cy_4_22_91_110_0 = 3.0 * (tmp11__anonymous__58_68_0 - tmp2_cubicCalc_0_18_87_106_0);
              var by_5_23_92_111_0 = 3.0 * (tmp13__anonymous__58_72_0 - tmp11__anonymous__58_68_0) - cy_4_22_91_110_0;
              var ay_6_24_93_112_0 = tmp15__anonymous__58_76_0 - tmp2_cubicCalc_0_18_87_106_0 - cy_4_22_91_110_0 - by_5_23_92_111_0;
              var tSquared_7_25_94_113_0 = ratio_11_84_103_0 * ratio_11_84_103_0;
              var tCubed_8_26_95_114_0 = tSquared_7_25_94_113_0 * ratio_11_84_103_0;
              var tmp3__anonymous__9_27_96_115_0 = ax_3_21_90_109_0 * tCubed_8_26_95_114_0 + bx_2_20_89_108_0 * tSquared_7_25_94_113_0 + cx_1_19_88_107_0 * ratio_11_84_103_0 + tmp1_cubicCalc_0_17_86_105_0;
              var tmp4__anonymous__9_28_97_116_0 = ay_6_24_93_112_0 * tCubed_8_26_95_114_0 + by_5_23_92_111_0 * tSquared_7_25_94_113_0 + cy_4_22_91_110_0 * ratio_11_84_103_0 + tmp2_cubicCalc_0_18_87_106_0;
              var tmp21__anonymous__120 = false;
              if (doingStroke) {
                if (tmp21__anonymous__120) {
                  render$flush(this, filler, fillPath);
                }}this._rasterizer._path_27.add_56(tmp3__anonymous__9_27_96_115_0, tmp4__anonymous__9_28_97_116_0, tmp21__anonymous__120);
              var tmp0_14_2_31_98_117_0 = emittedCount_7_67_86_0._v;
              emittedCount_7_67_86_0._v = tmp0_14_2_31_98_117_0 + 1 | 0;
              Unit_getInstance();
              lastX_3_63_82_0._v = prevX_5_65_84_0._v;
              lastY_4_64_83_0._v = prevY_6_66_85_0._v;
              prevX_5_65_84_0._v = tmp3__anonymous__9_27_96_115_0;
              prevY_6_66_85_0._v = tmp4__anonymous__9_28_97_116_0;
            }
             while (inductionVariable_2 < rcurveSteps_1_61_80_0);
          var tmp2_also_0_99_118_0 = lx_5_0._v = tmp14__anonymous__58_74_0;
          ly_6_0._v = tmp15__anonymous__58_76_0;
          var tmp22__anonymous__2_121 = false;
          Unit_getInstance();
          break;
        case 4:
          var tmp23__anonymous__120 = ix_3_0;
          var tmp24__anonymous__120 = iy_4_0;
          var tmp25__anonymous__120 = false;
          if (doingStroke) {
            if (tmp25__anonymous__120) {
              render$flush(this, filler, fillPath);
            }}
          this._rasterizer._path_27.add_56(tmp23__anonymous__120, tmp24__anonymous__120, tmp25__anonymous__120);
          var tmp26__anonymous__2_121 = true;
          Unit_getInstance();
          var tmp27__anonymous__119 = true;
          if (tmp27__anonymous__119) {
            this._rasterizer._path_27.close_77();
          }
          break;
      }
    }
    var tmp28__anonymous__119 = false;
    if (tmp28__anonymous__119) {
      this._rasterizer._path_27.close_77();
    }render$flush(this, filler, fillPath);
  };
  Bitmap32Context2d.$metadata$ = {
    simpleName: 'Bitmap32Context2d',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_200(this$0) {
    var i = new _no_name_provided__241(this$0);
    return function (p1, p2, p3) {
      i.invoke_426(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function BitmapVector() {
  }
  BitmapVector.prototype._get_nativeImage_ = function () {
    var tmp0_getValue_0 = this._nativeImage$delegate;
    var tmp1_getValue_0 = nativeImage$factory();
    return tmp0_getValue_0._get_value__10();
  };
  BitmapVector.$metadata$ = {
    simpleName: 'BitmapVector',
    kind: 'class',
    interfaces: []
  };
  function nativeImage$factory() {
    return getPropertyCallableRef('nativeImage', 1, KProperty1, function (receiver) {
      return receiver._get_nativeImage_();
    }, null);
  }
  function _no_name_provided__242() {
  }
  _no_name_provided__242.prototype.invoke_423 = function (dst, dstN, src, srcN, count_0) {
    mix_0(dst, dstN, src, srcN, count_0);
  };
  _no_name_provided__242.prototype.invoke_436 = function (p1, p2, p3, p4, p5) {
    var tmp = p1 instanceof RgbaPremultipliedArray ? p1._ints_0 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof RgbaPremultipliedArray ? p3._ints_0 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_423(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__242.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__243($func) {
    this._$func_0 = $func;
  }
  _no_name_provided__243.prototype.blend_2 = function (dst, dstN, src, srcN, count_0) {
    return this._$func_0(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count_0);
  };
  _no_name_provided__243.$metadata$ = {
    kind: 'class',
    interfaces: [CompositeOperation]
  };
  function Companion_118() {
    Companion_instance_117 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_117();
    tmp._UNIMPLEMENTED = tmp_0.invoke_418(_no_name_provided_$factory_201());
  }
  Companion_118.prototype.invoke_418 = function (func) {
    return new _no_name_provided__243(func);
  };
  Companion_118.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_117;
  function Companion_getInstance_117() {
    if (Companion_instance_117 == null)
      new Companion_118();
    return Companion_instance_117;
  }
  function CompositeOperation() {
  }
  CompositeOperation.$metadata$ = {
    simpleName: 'CompositeOperation',
    kind: 'interface',
    interfaces: []
  };
  var CompositeMode_CLEAR_instance;
  var CompositeMode_COPY_instance;
  var CompositeMode_SOURCE_OVER_instance;
  var CompositeMode_DESTINATION_OVER_instance;
  var CompositeMode_SOURCE_IN_instance;
  var CompositeMode_DESTINATION_IN_instance;
  var CompositeMode_SOURCE_OUT_instance;
  var CompositeMode_DESTINATION_OUT_instance;
  var CompositeMode_SOURCE_ATOP_instance;
  var CompositeMode_DESTINATION_ATOP_instance;
  var CompositeMode_XOR_instance;
  var CompositeMode_LIGHTER_instance;
  function Companion_119() {
    Companion_instance_118 = this;
  }
  Companion_119.prototype._get_DEFAULT_ = function () {
    return CompositeMode_SOURCE_OVER_getInstance();
  };
  Companion_119.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_118;
  function Companion_getInstance_118() {
    if (Companion_instance_118 == null)
      new Companion_119();
    return Companion_instance_118;
  }
  function _no_name_provided__244() {
  }
  _no_name_provided__244.prototype.invoke_423 = function (dst, dstN, src, srcN, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = RgbaPremultipliedArray__get_impl(dst, dstN + n | 0);
        var s = RgbaPremultipliedArray__get_impl(src, srcN + n | 0);
        RgbaPremultipliedArray__set_impl(dst, dstN + n | 0, _RGBA___get_premultiplied__impl_(RGBA__withA_impl(_RGBAPremultiplied___get_depremultiplied__impl_(d), clamp0_255(_RGBAPremultiplied___get_a__impl_(d) - _RGBAPremultiplied___get_a__impl_(s) | 0))));
      }
       while (inductionVariable < count_0);
  };
  _no_name_provided__244.prototype.invoke_436 = function (p1, p2, p3, p4, p5) {
    var tmp = p1 instanceof RgbaPremultipliedArray ? p1._ints_0 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof RgbaPremultipliedArray ? p3._ints_0 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_423(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__244.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__245() {
  }
  _no_name_provided__245.prototype.invoke_423 = function (dst, dstN, src, srcN, count_0) {
    mix_1(dst, dstN, dst, dstN, src, srcN, count_0);
  };
  _no_name_provided__245.prototype.invoke_436 = function (p1, p2, p3, p4, p5) {
    var tmp = p1 instanceof RgbaPremultipliedArray ? p1._ints_0 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof RgbaPremultipliedArray ? p3._ints_0 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_423(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__245.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__246() {
  }
  _no_name_provided__246.prototype.invoke_423 = function (dst, dstN, src, srcN, count_0) {
    mix_1(dst, dstN, src, srcN, dst, dstN, count_0);
  };
  _no_name_provided__246.prototype.invoke_436 = function (p1, p2, p3, p4, p5) {
    var tmp = p1 instanceof RgbaPremultipliedArray ? p1._ints_0 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof RgbaPremultipliedArray ? p3._ints_0 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_423(tmp, tmp_0, tmp_1, tmp_2, (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__246.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  var CompositeMode_entriesInitialized;
  function CompositeMode_initEntries() {
    if (CompositeMode_entriesInitialized)
      return Unit_getInstance();
    CompositeMode_entriesInitialized = true;
    var tmp = Companion_getInstance_117();
    CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.invoke_418(_no_name_provided_$factory_202()));
    CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_117()._UNIMPLEMENTED);
    var tmp_0 = Companion_getInstance_117();
    CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.invoke_418(_no_name_provided_$factory_203()));
    var tmp_1 = Companion_getInstance_117();
    CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.invoke_418(_no_name_provided_$factory_204()));
    CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_117()._UNIMPLEMENTED);
    CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_117()._UNIMPLEMENTED);
    CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_117()._UNIMPLEMENTED);
    CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_117()._UNIMPLEMENTED);
    CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_117()._UNIMPLEMENTED);
    CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_117()._UNIMPLEMENTED);
    CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_117()._UNIMPLEMENTED);
    CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_117()._UNIMPLEMENTED);
    Companion_getInstance_118();
  }
  function CompositeMode(name, ordinal, op) {
    Enum.call(this, name, ordinal);
    this._op = op;
  }
  CompositeMode.prototype.blend_2 = function (dst, dstN, src, srcN, count_0) {
    this._op.blend_2(dst, dstN, src, srcN, count_0);
  };
  CompositeMode.$metadata$ = {
    simpleName: 'CompositeMode',
    kind: 'class',
    interfaces: [CompositeOperation]
  };
  var BlendMode_NORMAL_instance;
  var BlendMode_MULTIPLY_instance;
  var BlendMode_SCREEN_instance;
  var BlendMode_OVERLAY_instance;
  var BlendMode_DARKEN_instance;
  var BlendMode_LIGHTEN_instance;
  var BlendMode_COLOR_DODGE_instance;
  var BlendMode_COLOR_BURN_instance;
  var BlendMode_HARD_LIGHT_instance;
  var BlendMode_SOFT_LIGHT_instance;
  var BlendMode_DIFFERENCE_instance;
  var BlendMode_EXCLUSION_instance;
  var BlendMode_HUE_instance;
  var BlendMode_SATURATION_instance;
  var BlendMode_COLOR_instance;
  var BlendMode_LUMINOSITY_instance;
  var BlendMode_entriesInitialized;
  function BlendMode_initEntries() {
    if (BlendMode_entriesInitialized)
      return Unit_getInstance();
    BlendMode_entriesInitialized = true;
    BlendMode_NORMAL_instance = new BlendMode('NORMAL', 0, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_MULTIPLY_instance = new BlendMode('MULTIPLY', 1, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_SCREEN_instance = new BlendMode('SCREEN', 2, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_OVERLAY_instance = new BlendMode('OVERLAY', 3, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_DARKEN_instance = new BlendMode('DARKEN', 4, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_LIGHTEN_instance = new BlendMode('LIGHTEN', 5, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_COLOR_DODGE_instance = new BlendMode('COLOR_DODGE', 6, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_COLOR_BURN_instance = new BlendMode('COLOR_BURN', 7, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_HARD_LIGHT_instance = new BlendMode('HARD_LIGHT', 8, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_SOFT_LIGHT_instance = new BlendMode('SOFT_LIGHT', 9, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_DIFFERENCE_instance = new BlendMode('DIFFERENCE', 10, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_EXCLUSION_instance = new BlendMode('EXCLUSION', 11, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_HUE_instance = new BlendMode('HUE', 12, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_SATURATION_instance = new BlendMode('SATURATION', 13, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_COLOR_instance = new BlendMode('COLOR', 14, Companion_getInstance_117()._UNIMPLEMENTED);
    BlendMode_LUMINOSITY_instance = new BlendMode('LUMINOSITY', 15, Companion_getInstance_117()._UNIMPLEMENTED);
  }
  function BlendMode(name, ordinal, op) {
    Enum.call(this, name, ordinal);
    this._op_0 = op;
  }
  BlendMode.prototype.blend_2 = function (dst, dstN, src, srcN, count_0) {
    this._op_0.blend_2(dst, dstN, src, srcN, count_0);
  };
  BlendMode.$metadata$ = {
    simpleName: 'BlendMode',
    kind: 'class',
    interfaces: [CompositeOperation]
  };
  function _get_DEFAULT_(_this_) {
    return Companion_getInstance_118()._get_DEFAULT_();
  }
  function CompositeMode_CLEAR_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_CLEAR_instance;
  }
  function CompositeMode_COPY_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_COPY_instance;
  }
  function CompositeMode_SOURCE_OVER_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_SOURCE_OVER_instance;
  }
  function CompositeMode_DESTINATION_OVER_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_DESTINATION_OVER_instance;
  }
  function CompositeMode_SOURCE_IN_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_SOURCE_IN_instance;
  }
  function CompositeMode_DESTINATION_IN_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_DESTINATION_IN_instance;
  }
  function CompositeMode_SOURCE_OUT_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_SOURCE_OUT_instance;
  }
  function CompositeMode_DESTINATION_OUT_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_DESTINATION_OUT_instance;
  }
  function CompositeMode_SOURCE_ATOP_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_SOURCE_ATOP_instance;
  }
  function CompositeMode_DESTINATION_ATOP_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_DESTINATION_ATOP_instance;
  }
  function CompositeMode_XOR_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_XOR_instance;
  }
  function CompositeMode_LIGHTER_getInstance() {
    CompositeMode_initEntries();
    return CompositeMode_LIGHTER_instance;
  }
  function BlendMode_NORMAL_getInstance() {
    BlendMode_initEntries();
    return BlendMode_NORMAL_instance;
  }
  function BlendMode_MULTIPLY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_MULTIPLY_instance;
  }
  function BlendMode_SCREEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SCREEN_instance;
  }
  function BlendMode_OVERLAY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_OVERLAY_instance;
  }
  function BlendMode_DARKEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DARKEN_instance;
  }
  function BlendMode_LIGHTEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_LIGHTEN_instance;
  }
  function BlendMode_COLOR_DODGE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_DODGE_instance;
  }
  function BlendMode_COLOR_BURN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_BURN_instance;
  }
  function BlendMode_HARD_LIGHT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_HARD_LIGHT_instance;
  }
  function BlendMode_SOFT_LIGHT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SOFT_LIGHT_instance;
  }
  function BlendMode_DIFFERENCE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DIFFERENCE_instance;
  }
  function BlendMode_EXCLUSION_getInstance() {
    BlendMode_initEntries();
    return BlendMode_EXCLUSION_instance;
  }
  function BlendMode_HUE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_HUE_instance;
  }
  function BlendMode_SATURATION_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SATURATION_instance;
  }
  function BlendMode_COLOR_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_instance;
  }
  function BlendMode_LUMINOSITY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_LUMINOSITY_instance;
  }
  function _no_name_provided_$factory_201() {
    var i = new _no_name_provided__242();
    return function (p1, p2, p3, p4, p5) {
      i.invoke_423(p1._ints_0, p2, p3._ints_0, p4, p5);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_202() {
    var i = new _no_name_provided__244();
    return function (p1, p2, p3, p4, p5) {
      i.invoke_423(p1._ints_0, p2, p3._ints_0, p4, p5);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_203() {
    var i = new _no_name_provided__245();
    return function (p1, p2, p3, p4, p5) {
      i.invoke_423(p1._ints_0, p2, p3._ints_0, p4, p5);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_204() {
    var i = new _no_name_provided__246();
    return function (p1, p2, p3, p4, p5) {
      i.invoke_423(p1._ints_0, p2, p3._ints_0, p4, p5);
      return Unit_getInstance();
    };
  }
  function State_init_$Init$(transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      transform = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }if (!(($mask0 & 2) === 0))
      clip = null;
    if (!(($mask0 & 4) === 0)) {
      path_0 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    }if (!(($mask0 & 8) === 0))
      lineScaleMode = LineScaleMode_NORMAL_getInstance();
    if (!(($mask0 & 16) === 0))
      lineWidth = 1.0;
    if (!(($mask0 & 32) === 0))
      startLineCap = LineCap_BUTT_getInstance();
    if (!(($mask0 & 64) === 0))
      endLineCap = LineCap_BUTT_getInstance();
    if (!(($mask0 & 128) === 0))
      lineJoin = LineJoin_MITER_getInstance();
    if (!(($mask0 & 256) === 0))
      miterLimit = 4.0;
    if (!(($mask0 & 512) === 0))
      strokeStyle = new RGBA(_get_DefaultPaint_());
    if (!(($mask0 & 1024) === 0))
      fillStyle = new RGBA(_get_DefaultPaint_());
    if (!(($mask0 & 2048) === 0))
      fontRegistry = SystemFontRegistry_getInstance();
    if (!(($mask0 & 4096) === 0))
      font = SystemFontRegistry_getInstance()._DEFAULT_FONT;
    if (!(($mask0 & 8192) === 0))
      fontSize = 24.0;
    if (!(($mask0 & 16384) === 0))
      verticalAlign = Companion_getInstance_114()._BASELINE;
    if (!(($mask0 & 32768) === 0))
      horizontalAlign = Companion_getInstance_115()._LEFT;
    if (!(($mask0 & 65536) === 0))
      globalAlpha = 1.0;
    if (!(($mask0 & 131072) === 0))
      globalCompositeOperation = CompositeMode_SOURCE_OVER_getInstance();
    State.call($this, transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation);
    return $this;
  }
  function State_init_$Create$(transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, $mask0, $marker) {
    return State_init_$Init$(transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, $mask0, $marker, Object.create(State.prototype));
  }
  function _no_name_provided__247(this$0) {
    this._this$0_54 = this$0;
  }
  _no_name_provided__247.prototype.invoke_1005 = function () {
    var tmp = this._this$0_54._transform_6;
    return tmp.toTransform$default(null, 1, null);
  };
  _no_name_provided__247.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_120() {
    Companion_instance_119 = this;
  }
  Companion_120.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_119;
  function Companion_getInstance_119() {
    if (Companion_instance_119 == null)
      new Companion_120();
    return Companion_instance_119;
  }
  function State(transform, clip, path_0, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation) {
    this._transform_6 = transform;
    this._clip = clip;
    this._path_24 = path_0;
    this._lineScaleMode = lineScaleMode;
    this._lineWidth = lineWidth;
    this._startLineCap = startLineCap;
    this._endLineCap = endLineCap;
    this._lineJoin = lineJoin;
    this._miterLimit_0 = miterLimit;
    this._strokeStyle = strokeStyle;
    this._fillStyle = fillStyle;
    this._fontRegistry = fontRegistry;
    this._font_0 = font;
    this._fontSize_2 = fontSize;
    this._verticalAlign_0 = verticalAlign;
    this._horizontalAlign_0 = horizontalAlign;
    this._globalAlpha = globalAlpha;
    this._globalCompositeOperation = globalCompositeOperation;
    var tmp = this;
    tmp._transformTransform$delegate = lazy(_no_name_provided_$factory_205(this));
  }
  State.prototype._get_transformTransform_ = function () {
    var tmp0_getValue_0 = this._transformTransform$delegate;
    var tmp1_getValue_0 = transformTransform$factory();
    return tmp0_getValue_0._get_value__10();
  };
  State.prototype._get_scaledLineWidth_ = function () {
    var tmp = this._lineWidth;
    var tmp0__get_absoluteValue__0 = this._get_transformTransform_()._get_scaleAvg_();
    return tmp * Math.abs(tmp0__get_absoluteValue__0);
  };
  State.prototype._set_lineCap__0 = function (value) {
    this._startLineCap = value;
    this._endLineCap = value;
  };
  State.prototype._get_lineCap__0 = function () {
    return this._startLineCap;
  };
  State.prototype.toString = function () {
    return '' + 'State(transform=' + this._transform_6 + ', clip=' + this._clip + ', path=' + this._path_24 + ', lineScaleMode=' + this._lineScaleMode + ', lineWidth=' + this._lineWidth + ', startLineCap=' + this._startLineCap + ', endLineCap=' + this._endLineCap + ', lineJoin=' + this._lineJoin + ', miterLimit=' + this._miterLimit_0 + ', strokeStyle=' + this._strokeStyle + ', fillStyle=' + this._fillStyle + ', fontRegistry=' + this._fontRegistry + ', font=' + this._font_0 + ', fontSize=' + this._fontSize_2 + ', verticalAlign=' + new VerticalAlign(this._verticalAlign_0) + ', horizontalAlign=' + new HorizontalAlign(this._horizontalAlign_0) + ', globalAlpha=' + this._globalAlpha + ', globalCompositeOperation=' + this._globalCompositeOperation + ')';
  };
  State.prototype.hashCode = function () {
    var result = this._transform_6.hashCode();
    result = imul(result, 31) + (this._clip == null ? 0 : hashCode(this._clip)) | 0;
    result = imul(result, 31) + hashCode(this._path_24) | 0;
    result = imul(result, 31) + this._lineScaleMode.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._lineWidth) | 0;
    result = imul(result, 31) + this._startLineCap.hashCode() | 0;
    result = imul(result, 31) + this._endLineCap.hashCode() | 0;
    result = imul(result, 31) + this._lineJoin.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._miterLimit_0) | 0;
    result = imul(result, 31) + hashCode(this._strokeStyle) | 0;
    result = imul(result, 31) + hashCode(this._fillStyle) | 0;
    result = imul(result, 31) + hashCode(this._fontRegistry) | 0;
    result = imul(result, 31) + hashCode(this._font_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._fontSize_2) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl(this._verticalAlign_0) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl(this._horizontalAlign_0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._globalAlpha) | 0;
    result = imul(result, 31) + hashCode(this._globalCompositeOperation) | 0;
    return result;
  };
  State.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this._transform_6.equals(tmp0_other_with_cast._transform_6))
      return false;
    if (!equals_1(this._clip, tmp0_other_with_cast._clip))
      return false;
    if (!equals_1(this._path_24, tmp0_other_with_cast._path_24))
      return false;
    if (!this._lineScaleMode.equals(tmp0_other_with_cast._lineScaleMode))
      return false;
    if (!equals_1(this._lineWidth, tmp0_other_with_cast._lineWidth))
      return false;
    if (!this._startLineCap.equals(tmp0_other_with_cast._startLineCap))
      return false;
    if (!this._endLineCap.equals(tmp0_other_with_cast._endLineCap))
      return false;
    if (!this._lineJoin.equals(tmp0_other_with_cast._lineJoin))
      return false;
    if (!equals_1(this._miterLimit_0, tmp0_other_with_cast._miterLimit_0))
      return false;
    if (!equals_1(this._strokeStyle, tmp0_other_with_cast._strokeStyle))
      return false;
    if (!equals_1(this._fillStyle, tmp0_other_with_cast._fillStyle))
      return false;
    if (!equals_1(this._fontRegistry, tmp0_other_with_cast._fontRegistry))
      return false;
    if (!equals_1(this._font_0, tmp0_other_with_cast._font_0))
      return false;
    if (!equals_1(this._fontSize_2, tmp0_other_with_cast._fontSize_2))
      return false;
    if (!equals_1(new VerticalAlign(this._verticalAlign_0), new VerticalAlign(tmp0_other_with_cast._verticalAlign_0)))
      return false;
    if (!equals_1(new HorizontalAlign(this._horizontalAlign_0), new HorizontalAlign(tmp0_other_with_cast._horizontalAlign_0)))
      return false;
    if (!equals_1(this._globalAlpha, tmp0_other_with_cast._globalAlpha))
      return false;
    if (!equals_1(this._globalCompositeOperation, tmp0_other_with_cast._globalCompositeOperation))
      return false;
    return true;
  };
  State.$metadata$ = {
    simpleName: 'State',
    kind: 'class',
    interfaces: []
  };
  function transX($this, x, y) {
    return $this._state_4._transform_6.transformX(x, y);
  }
  function transY($this, x, y) {
    return $this._state_4._transform_6.transformY(x, y);
  }
  function Context2d(renderer) {
    Companion_getInstance_119();
    this._renderer = renderer;
    var tmp = this;
    tmp._state_4 = State_init_$Create$(null, null, null, null, 0.0, null, null, null, 0.0, null, null, null, null, 0.0, null, null, 0.0, null, 262143, null);
    this._stack = new TGenStack();
    this._moveX = 0.0;
    this._moveY = 0.0;
    this._lastX_1 = 0.0;
    this._lastY_1 = 0.0;
  }
  Context2d.prototype._get_rendererWidth_ = function () {
    return this._renderer._get_width__58();
  };
  Context2d.prototype._get_rendererHeight_ = function () {
    return this._renderer._get_height__58();
  };
  Context2d.prototype.rendererRender = function (state, fill_3) {
    return this._renderer.render_1(state, fill_3);
  };
  Context2d.prototype.rendererDrawImage = function (image, x, y, width, height, transform) {
    return this._renderer.drawImage_3(image, x, y, width, height, transform);
  };
  Context2d.prototype.rendererDispose = function () {
    return this._renderer.dispose_18();
  };
  Context2d.prototype.rendererBufferingStart = function () {
    return this._renderer.bufferingStart_1();
  };
  Context2d.prototype.rendererBufferingEnd = function () {
    return this._renderer.bufferingEnd_1();
  };
  Context2d.prototype._get_width__58 = function () {
    return this._get_rendererWidth_();
  };
  Context2d.prototype._get_height__58 = function () {
    return this._get_rendererHeight_();
  };
  Context2d.prototype.dispose_18 = function () {
    this.rendererDispose();
  };
  Context2d.prototype._rendererBufferingStart = function () {
    return this.rendererBufferingStart();
  };
  Context2d.prototype._rendererBufferingEnd = function () {
    return this.rendererBufferingEnd();
  };
  Context2d.prototype._set_lineScaleMode_ = function (value) {
    this._state_4._lineScaleMode = value;
    return Unit_getInstance();
  };
  Context2d.prototype._set_lineWidth_ = function (value) {
    this._state_4._lineWidth = value;
    return Unit_getInstance();
  };
  Context2d.prototype._set_lineCap__0 = function (value) {
    return this._state_4._set_lineCap__0(value);
  };
  Context2d.prototype._get_lineCap__0 = function () {
    return this._state_4._get_lineCap__0();
  };
  Context2d.prototype._set_lineJoin_ = function (value) {
    this._state_4._lineJoin = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_lineJoin_ = function () {
    return this._state_4._lineJoin;
  };
  Context2d.prototype._set_strokeStyle_ = function (value) {
    this._state_4._strokeStyle = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_strokeStyle_ = function () {
    return this._state_4._strokeStyle;
  };
  Context2d.prototype._set_fillStyle_ = function (value) {
    this._state_4._fillStyle = value;
    return Unit_getInstance();
  };
  Context2d.prototype._get_fillStyle_ = function () {
    return this._state_4._fillStyle;
  };
  Context2d.prototype.scale_2 = function (sx, sy) {
    return this._state_4._transform_6.prescale(sx, sy);
  };
  Context2d.prototype.scale$default = function (sx, sy, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      sy = sx;
    return this.scale_2(sx, sy);
  };
  Context2d.prototype.rotate_1 = function (angle_0) {
    return this._state_4._transform_6.prerotate(angle_0);
  };
  Context2d.prototype.translate_2 = function (tx, ty) {
    return this._state_4._transform_6.pretranslate(tx, ty);
  };
  Context2d.prototype.transform_4 = function (m) {
    return this._state_4._transform_6.premultiply(m);
  };
  Context2d.prototype._set_lastX__1 = function (_set___) {
    this._lastX_1 = _set___;
  };
  Context2d.prototype._get_lastX__7 = function () {
    return this._lastX_1;
  };
  Context2d.prototype._set_lastY__1 = function (_set___) {
    this._lastY_1 = _set___;
  };
  Context2d.prototype._get_lastY__7 = function () {
    return this._lastY_1;
  };
  Context2d.prototype._get_totalPoints__7 = function () {
    return this._state_4._path_24._get_totalPoints__7();
  };
  Context2d.prototype.close_77 = function () {
    this._state_4._path_24.close_77();
    this._set_lastX__1(this._moveX);
    this._set_lastY__1(this._moveY);
  };
  Context2d.prototype.moveTo_9 = function (x, y) {
    this._state_4._path_24.moveTo_9(transX(this, x, y), transY(this, x, y));
    this._set_lastX__1(x);
    this._set_lastY__1(y);
    this._moveX = x;
    this._moveY = y;
  };
  Context2d.prototype.lineTo_9 = function (x, y) {
    this._state_4._path_24.lineTo_9(transX(this, x, y), transY(this, x, y));
    this._set_lastX__1(x);
    this._set_lastY__1(y);
  };
  Context2d.prototype.quadTo_7 = function (cx, cy, ax, ay) {
    this._state_4._path_24.quadTo_7(transX(this, cx, cy), transY(this, cx, cy), transX(this, ax, ay), transY(this, ax, ay));
    this._set_lastX__1(ax);
    this._set_lastY__1(ay);
  };
  Context2d.prototype.cubicTo_7 = function (cx1, cy1, cx2, cy2, ax, ay) {
    this._state_4._path_24.cubicTo_7(transX(this, cx1, cy1), transY(this, cx1, cy1), transX(this, cx2, cy2), transY(this, cx2, cy2), transX(this, ax, ay), transY(this, ax, ay));
    this._set_lastX__1(ax);
    this._set_lastY__1(ay);
  };
  Context2d.prototype.path_0 = function (path_0) {
    write_1(this, path_0);
  };
  Context2d.prototype.draw_2 = function (d) {
    return d.draw_10(this);
  };
  Context2d.prototype.fillRect_0 = function (x, y, width, height) {
    this.beginPath_0();
    rect(this, x, y, width, height);
    return this.fill_6();
  };
  Context2d.prototype.beginPath_0 = function () {
    var tmp = this._state_4;
    tmp._path_24 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    return Unit_getInstance();
  };
  Context2d.prototype.stroke_0 = function () {
    return !equals_1(this._state_4._strokeStyle, NonePaint_getInstance()) ? this.rendererRender(this._state_4, false) : void 0;
  };
  Context2d.prototype.fill_6 = function () {
    return !equals_1(this._state_4._fillStyle, NonePaint_getInstance()) ? this.rendererRender(this._state_4, true) : void 0;
  };
  Context2d.prototype.fill_7 = function (paint) {
    var oldStyle_1 = this._get_fillStyle_();
    this._set_fillStyle_(paint);
    try {
      this.fill_6();
    }finally {
      this._set_fillStyle_(oldStyle_1);
    }
  };
  Context2d.prototype.stroke_1 = function (paint) {
    var oldStyle_1 = this._get_strokeStyle_();
    this._set_strokeStyle_(paint);
    try {
      this.stroke_0();
    }finally {
      this._set_strokeStyle_(oldStyle_1);
    }
  };
  Context2d.prototype.clip_0 = function (path_0, winding) {
    if (!(path_0 == null)) {
      if (this._state_4._clip == null) {
        var tmp = this._state_4;
        tmp._clip = GraphicsPath_init_$Create$(null, null, null, 7, null);
      }ensureNotNull(this._state_4._clip).clear_33();
      ensureNotNull(this._state_4._clip)._set_winding__0(winding);
      var tmp_0 = ensureNotNull(this._state_4._clip);
      tmp_0.write$default(path_0, null, 2, null);
    } else {
      this._state_4._clip = null;
    }
  };
  Context2d.prototype.clip$default = function (path_0, winding, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      path_0 = this._state_4._path_24;
    if (!(($mask0 & 2) === 0))
      winding = Winding_NON_ZERO_getInstance();
    return this.clip_0(path_0, winding);
  };
  Context2d.prototype.drawImage_1 = function (image, x, y, width, height) {
    return this.rendererDrawImage(image, x, y, width, height, this._state_4._transform_6);
  };
  Context2d.prototype.drawImage$default = function (image, x, y, width, height, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      width = image._width_2;
    if (!(($mask0 & 16) === 0))
      height = image._height_2;
    return $handler == null ? this.drawImage_1(image, x, y, width, height) : $handler(image, x, y, width, height);
  };
  Context2d.$metadata$ = {
    simpleName: 'Context2d',
    kind: 'class',
    interfaces: [Disposable, VectorBuilder]
  };
  function write_1(_this_, path_0) {
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = path_0._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__60()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_0(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      switch (tmp0_subject_4_6) {
        case 0:
          var tmp1_5_7 = n_1;
          n_1 = tmp1_5_7 + 1 | 0;
          var tmp0__anonymous__21 = path_0._data_37.get_137(tmp1_5_7);
          var tmp2_6_8 = n_1;
          n_1 = tmp2_6_8 + 1 | 0;
          var tmp1__anonymous__21 = path_0._data_37.get_137(tmp2_6_8);
          _this_.moveTo_9(tmp0__anonymous__21, tmp1__anonymous__21);
          break;
        case 1:
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__22 = path_0._data_37.get_137(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__22 = path_0._data_37.get_137(tmp4_8_10);
          _this_.lineTo_9(tmp2__anonymous__22, tmp3__anonymous__22);
          break;
        case 2:
          var tmp5_9_11 = n_1;
          n_1 = tmp5_9_11 + 1 | 0;
          var tmp4__anonymous__23 = path_0._data_37.get_137(tmp5_9_11);
          var tmp6_10_12 = n_1;
          n_1 = tmp6_10_12 + 1 | 0;
          var tmp5__anonymous__23 = path_0._data_37.get_137(tmp6_10_12);
          var tmp7_11_13 = n_1;
          n_1 = tmp7_11_13 + 1 | 0;
          var tmp6__anonymous__23 = path_0._data_37.get_137(tmp7_11_13);
          var tmp8_12_14 = n_1;
          n_1 = tmp8_12_14 + 1 | 0;
          var tmp7__anonymous__23 = path_0._data_37.get_137(tmp8_12_14);
          _this_.quadTo_7(tmp4__anonymous__23, tmp5__anonymous__23, tmp6__anonymous__23, tmp7__anonymous__23);
          break;
        case 3:
          var tmp9_13_15 = n_1;
          n_1 = tmp9_13_15 + 1 | 0;
          var tmp8__anonymous__24 = path_0._data_37.get_137(tmp9_13_15);
          var tmp10_14_16 = n_1;
          n_1 = tmp10_14_16 + 1 | 0;
          var tmp9__anonymous__24 = path_0._data_37.get_137(tmp10_14_16);
          var tmp11_15_17 = n_1;
          n_1 = tmp11_15_17 + 1 | 0;
          var tmp10__anonymous__24 = path_0._data_37.get_137(tmp11_15_17);
          var tmp12_16_18 = n_1;
          n_1 = tmp12_16_18 + 1 | 0;
          var tmp11__anonymous__24 = path_0._data_37.get_137(tmp12_16_18);
          var tmp13_17_19 = n_1;
          n_1 = tmp13_17_19 + 1 | 0;
          var tmp12__anonymous__24 = path_0._data_37.get_137(tmp13_17_19);
          var tmp14_18_20 = n_1;
          n_1 = tmp14_18_20 + 1 | 0;
          var tmp13__anonymous__24 = path_0._data_37.get_137(tmp14_18_20);
          _this_.cubicTo_7(tmp8__anonymous__24, tmp9__anonymous__24, tmp10__anonymous__24, tmp11__anonymous__24, tmp12__anonymous__24, tmp13__anonymous__24);
          break;
        case 4:
          _this_.close_77();
          break;
      }
    }
  }
  function render(_this_) {
    var tmp = render_0(_this_, true);
    return tmp instanceof NativeImage ? tmp : THROW_CCE();
  }
  function render_0(_this_, native) {
    var tmp = _this_._get_width__58();
    var tmp_0 = _this_._get_height__58();
    var tmp0_context2d_0 = NativeImageOrBitmap32$default(tmp, tmp_0, native, null, 8, null);
    var tmp1_context2d_0 = true;
    var tmp0_lock_0_1 = null;
    tmp0_context2d_0.lock_5();
    try {
      var ctx_2_2 = tmp0_context2d_0.getContext2d_5(tmp1_context2d_0);
      try {
        _this_.draw_10(ctx_2_2);
      }finally {
        ctx_2_2.dispose_18();
      }
    }finally {
      tmp0_context2d_0.unlock_5(tmp0_lock_0_1);
      Unit_getInstance();
    }
    return tmp0_context2d_0;
  }
  function transformTransform$factory() {
    return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
      return receiver._get_transformTransform_();
    }, null);
  }
  function _no_name_provided_$factory_205(this$0) {
    var i = new _no_name_provided__247(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  var CycleMethod_NO_CYCLE_instance;
  var CycleMethod_REFLECT_instance;
  var CycleMethod_REPEAT_instance;
  function Companion_121() {
    Companion_instance_120 = this;
  }
  Companion_121.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_120;
  function Companion_getInstance_120() {
    if (Companion_instance_120 == null)
      new Companion_121();
    return Companion_instance_120;
  }
  var CycleMethod_entriesInitialized;
  function CycleMethod_initEntries() {
    if (CycleMethod_entriesInitialized)
      return Unit_getInstance();
    CycleMethod_entriesInitialized = true;
    CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
    CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 1);
    CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
    Companion_getInstance_120();
  }
  function CycleMethod(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CycleMethod.prototype._get_repeating_ = function () {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance());
  };
  CycleMethod.prototype.apply = function (ratio, clamp_6) {
    var tmp0_subject = this;
    var tmp;
    if (tmp0_subject.equals(CycleMethod_NO_CYCLE_getInstance())) {
      tmp = clamp_6 ? clamp01(ratio) : ratio;
    } else if (tmp0_subject.equals(CycleMethod_REPEAT_getInstance())) {
      tmp = ratio % 1;
    } else if (tmp0_subject.equals(CycleMethod_REFLECT_getInstance())) {
      var part = ratio % 2;
      tmp = part > 1.0 ? 2.0 - part : part;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CycleMethod.prototype.apply$default = function (ratio, clamp_6, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      clamp_6 = false;
    return this.apply(ratio, clamp_6);
  };
  CycleMethod.prototype.apply_0 = function (value, size_1) {
    var tmp = value / size_1;
    return this.apply$default(tmp, false, 2, null) * size_1;
  };
  CycleMethod.$metadata$ = {
    simpleName: 'CycleMethod',
    kind: 'class',
    interfaces: []
  };
  function CycleMethod_NO_CYCLE_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_NO_CYCLE_instance;
  }
  function CycleMethod_REFLECT_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_REFLECT_instance;
  }
  function CycleMethod_REPEAT_getInstance() {
    CycleMethod_initEntries();
    return CycleMethod_REPEAT_instance;
  }
  function Drawable() {
  }
  Drawable.$metadata$ = {
    simpleName: 'Drawable',
    kind: 'interface',
    interfaces: []
  };
  function SizedDrawable() {
  }
  SizedDrawable.$metadata$ = {
    simpleName: 'SizedDrawable',
    kind: 'interface',
    interfaces: [Drawable]
  };
  function BoundsDrawable() {
  }
  BoundsDrawable.prototype._get_width__58 = function () {
    return numberToInt(this._get_bounds__5()._width_0);
  };
  BoundsDrawable.prototype._get_height__58 = function () {
    return numberToInt(this._get_bounds__5()._height_0);
  };
  BoundsDrawable.$metadata$ = {
    simpleName: 'BoundsDrawable',
    kind: 'interface',
    interfaces: [SizedDrawable]
  };
  function GraphicsPath_init_$Init$(commands, data, winding, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0)) {
      commands = IntArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 2) === 0)) {
      data = DoubleArrayList_init_$Create$(0, 1, null);
    }if (!(($mask0 & 4) === 0))
      winding = Winding_EVEN_ODD_getInstance();
    GraphicsPath.call($this, commands, data, winding);
    return $this;
  }
  function GraphicsPath_init_$Create$(commands, data, winding, $mask0, $marker) {
    return GraphicsPath_init_$Init$(commands, data, winding, $mask0, $marker, Object.create(GraphicsPath.prototype));
  }
  function GraphicsPath(commands, data, winding) {
    VectorPath.call(this, commands, data, winding);
  }
  GraphicsPath.prototype._get_width__58 = function () {
    return numberToInt(this.getBounds$default_0(null, null, 3, null)._width_0);
  };
  GraphicsPath.prototype._get_height__58 = function () {
    return numberToInt(this.getBounds$default_0(null, null, 3, null)._height_0);
  };
  GraphicsPath.prototype.draw_10 = function (c) {
    return c.path_0(this);
  };
  GraphicsPath.prototype.toString = function () {
    return '' + 'GraphicsPath("' + toSvgPathString$default(this, null, 0, 3, null) + '")';
  };
  GraphicsPath.$metadata$ = {
    simpleName: 'GraphicsPath',
    kind: 'class',
    interfaces: [SizedDrawable]
  };
  var LineScaleMode_NONE_instance;
  var LineScaleMode_HORIZONTAL_instance;
  var LineScaleMode_VERTICAL_instance;
  var LineScaleMode_NORMAL_instance;
  var LineScaleMode_entriesInitialized;
  function LineScaleMode_initEntries() {
    if (LineScaleMode_entriesInitialized)
      return Unit_getInstance();
    LineScaleMode_entriesInitialized = true;
    LineScaleMode_NONE_instance = new LineScaleMode('NONE', 0, false, false);
    LineScaleMode_HORIZONTAL_instance = new LineScaleMode('HORIZONTAL', 1, true, false);
    LineScaleMode_VERTICAL_instance = new LineScaleMode('VERTICAL', 2, false, true);
    LineScaleMode_NORMAL_instance = new LineScaleMode('NORMAL', 3, true, true);
  }
  function LineScaleMode(name, ordinal, hScale, vScale) {
    Enum.call(this, name, ordinal);
    this._hScale = hScale;
    this._vScale = vScale;
  }
  LineScaleMode.$metadata$ = {
    simpleName: 'LineScaleMode',
    kind: 'class',
    interfaces: []
  };
  function LineScaleMode_NORMAL_getInstance() {
    LineScaleMode_initEntries();
    return LineScaleMode_NORMAL_instance;
  }
  function toSvgPathString(_this_, separator, decimalPlaces) {
    var parts_0 = ArrayList_init_$Create$();
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = _this_._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__60()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_0(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      switch (tmp0_subject_4_6) {
        case 0:
          var tmp1_5_7 = n_1;
          n_1 = tmp1_5_7 + 1 | 0;
          var tmp0__anonymous__21 = _this_._data_37.get_137(tmp1_5_7);
          var tmp2_6_8 = n_1;
          n_1 = tmp2_6_8 + 1 | 0;
          var tmp1__anonymous__21 = _this_._data_37.get_137(tmp2_6_8);
          var tmp0_plusAssign_0_22 = '' + 'M' + toSvgPathString$fixX(tmp0__anonymous__21, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp1__anonymous__21, decimalPlaces);
          parts_0.add_39(tmp0_plusAssign_0_22);
          Unit_getInstance();
          break;
        case 1:
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__23 = _this_._data_37.get_137(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__23 = _this_._data_37.get_137(tmp4_8_10);
          var tmp0_plusAssign_0_24 = '' + 'L' + toSvgPathString$fixX(tmp2__anonymous__23, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp3__anonymous__23, decimalPlaces);
          parts_0.add_39(tmp0_plusAssign_0_24);
          Unit_getInstance();
          break;
        case 2:
          var tmp5_9_11 = n_1;
          n_1 = tmp5_9_11 + 1 | 0;
          var tmp4__anonymous__25 = _this_._data_37.get_137(tmp5_9_11);
          var tmp6_10_12 = n_1;
          n_1 = tmp6_10_12 + 1 | 0;
          var tmp5__anonymous__25 = _this_._data_37.get_137(tmp6_10_12);
          var tmp7_11_13 = n_1;
          n_1 = tmp7_11_13 + 1 | 0;
          var tmp6__anonymous__25 = _this_._data_37.get_137(tmp7_11_13);
          var tmp8_12_14 = n_1;
          n_1 = tmp8_12_14 + 1 | 0;
          var tmp7__anonymous__25 = _this_._data_37.get_137(tmp8_12_14);
          var tmp0_plusAssign_0_26 = '' + 'Q' + toSvgPathString$fixX(tmp4__anonymous__25, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp5__anonymous__25, decimalPlaces) + ', ' + toSvgPathString$fixX(tmp6__anonymous__25, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp7__anonymous__25, decimalPlaces);
          parts_0.add_39(tmp0_plusAssign_0_26);
          Unit_getInstance();
          break;
        case 3:
          var tmp9_13_15 = n_1;
          n_1 = tmp9_13_15 + 1 | 0;
          var tmp8__anonymous__27 = _this_._data_37.get_137(tmp9_13_15);
          var tmp10_14_16 = n_1;
          n_1 = tmp10_14_16 + 1 | 0;
          var tmp9__anonymous__27 = _this_._data_37.get_137(tmp10_14_16);
          var tmp11_15_17 = n_1;
          n_1 = tmp11_15_17 + 1 | 0;
          var tmp10__anonymous__27 = _this_._data_37.get_137(tmp11_15_17);
          var tmp12_16_18 = n_1;
          n_1 = tmp12_16_18 + 1 | 0;
          var tmp11__anonymous__27 = _this_._data_37.get_137(tmp12_16_18);
          var tmp13_17_19 = n_1;
          n_1 = tmp13_17_19 + 1 | 0;
          var tmp12__anonymous__27 = _this_._data_37.get_137(tmp13_17_19);
          var tmp14_18_20 = n_1;
          n_1 = tmp14_18_20 + 1 | 0;
          var tmp13__anonymous__27 = _this_._data_37.get_137(tmp14_18_20);
          var tmp0_plusAssign_0_28 = '' + 'C' + toSvgPathString$fixX(tmp8__anonymous__27, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp9__anonymous__27, decimalPlaces) + ', ' + toSvgPathString$fixX(tmp10__anonymous__27, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp11__anonymous__27, decimalPlaces) + ', ' + toSvgPathString$fixX(tmp12__anonymous__27, decimalPlaces) + ' ' + toSvgPathString$fixY(tmp13__anonymous__27, decimalPlaces);
          parts_0.add_39(tmp0_plusAssign_0_28);
          Unit_getInstance();
          break;
        case 4:
          var tmp0_plusAssign_0_30 = 'Z';
          parts_0.add_39(tmp0_plusAssign_0_30);
          Unit_getInstance();
          break;
      }
    }
    return joinToString$default_0(parts_0, '', null, null, 0, null, null, 62, null);
  }
  function toSvgPathString$default(_this_, separator, decimalPlaces, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ' ';
    if (!(($mask0 & 2) === 0))
      decimalPlaces = 1;
    return toSvgPathString(_this_, separator, decimalPlaces);
  }
  function Shape() {
  }
  Shape.prototype.getPath_3 = function (path_0) {
    return path_0;
  };
  Shape.prototype.getPath$default = function (path_0, $mask0, $handler) {
    if (!(($mask0 & 1) === 0)) {
      path_0 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    }return $handler == null ? this.getPath_3(path_0) : $handler(path_0);
  };
  Shape.prototype._get_bounds__5 = function () {
    var tmp0_also_0 = new BoundsBuilder();
    this.addBounds_3(tmp0_also_0);
    return tmp0_also_0.getBounds$default(null, 1, null);
  };
  Shape.$metadata$ = {
    simpleName: 'Shape',
    kind: 'interface',
    interfaces: [BoundsDrawable]
  };
  function CompoundShape(components) {
    this._components_1 = components;
  }
  CompoundShape.prototype.addBounds_3 = function (bb) {
    var tmp0_fastForEach_0_2 = this._components_1;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__60()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.get_137(tmp0_2_5);
      tmp1__anonymous__3_4.addBounds_3(bb);
    }
    return Unit_getInstance();
  };
  CompoundShape.prototype.draw_10 = function (c) {
    var tmp$ret$0;
    l$ret$1: do {
      c._rendererBufferingStart();
      Unit_getInstance();
      try {
        var tmp0_fastForEach_0_2 = this._components_1;
        var n_1_3 = 0;
        while (n_1_3 < tmp0_fastForEach_0_2._get_size__60()) {
          var tmp0_2_5 = n_1_3;
          n_1_3 = tmp0_2_5 + 1 | 0;
          var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.get_137(tmp0_2_5);
          tmp1__anonymous__3_4.draw_10(c);
        }
        tmp$ret$0 = Unit_getInstance();
        break l$ret$1;
      }finally {
        c._rendererBufferingEnd();
      }
    }
     while (false);
    return tmp$ret$0;
  };
  CompoundShape.prototype.getPath_3 = function (path_0) {
    var tmp0_fastForEach_0_2 = this._components_1;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__60()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.get_137(tmp0_2_5);
      tmp1__anonymous__3_4.getPath_3(path_0);
      Unit_getInstance();
    }
    return path_0;
  };
  CompoundShape.$metadata$ = {
    simpleName: 'CompoundShape',
    kind: 'class',
    interfaces: [Shape]
  };
  function StyledShape() {
  }
  StyledShape.prototype._get_path__5 = function () {
    return null;
  };
  StyledShape.prototype.addBounds_3 = function (bb) {
    var tmp0_safe_receiver = this._get_path__5();
    if (tmp0_safe_receiver == null)
      null;
    else {
      add_3(bb, tmp0_safe_receiver, this._get_transform__8());
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  StyledShape.prototype.getPath_3 = function (path_0) {
    var tmp0_safe_receiver_2 = this._get_path__5();
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      path_0.write$default(tmp0_safe_receiver_2, null, 2, null);
      Unit_getInstance();
    }
    Unit_getInstance();
    return path_0;
  };
  StyledShape.prototype.draw_10 = function (c) {
    var t_1 = c._state_4._transform_6;
    var a_2 = t_1._a;
    var b_3 = t_1._b;
    var c_4 = t_1._c;
    var d_5 = t_1._d;
    var tx_6 = t_1._tx;
    var ty_7 = t_1._ty;
    try {
      c.transform_4(this._get_transform__8());
      Unit_getInstance();
      c.beginPath_0();
      var tmp0_safe_receiver_9 = this._get_path__5();
      if (tmp0_safe_receiver_9 == null)
        null;
      else {
        tmp0_safe_receiver_9.draw_10(c);
        Unit_getInstance();
      }
      Unit_getInstance();
      if (!(this._get_clip__1() == null)) {
        ensureNotNull(this._get_clip__1()).draw_10(c);
        c.clip$default(null, null, 3, null);
      }this.drawInternal_1(c);
    }finally {
      t_1.setTo(a_2, b_3, c_4, d_5, tx_6, ty_7);
      Unit_getInstance();
    }
  };
  StyledShape.prototype.drawInternal_1 = function (c) {
  };
  StyledShape.$metadata$ = {
    simpleName: 'StyledShape',
    kind: 'interface',
    interfaces: [Shape]
  };
  function FillShape(path_0, clip, paint, transform) {
    this._path_25 = path_0;
    this._clip_0 = clip;
    this._paint_0 = paint;
    this._transform_7 = transform;
  }
  FillShape.prototype._get_path__5 = function () {
    return this._path_25;
  };
  FillShape.prototype._get_clip__1 = function () {
    return this._clip_0;
  };
  FillShape.prototype._get_transform__8 = function () {
    return this._transform_7;
  };
  FillShape.prototype.drawInternal_1 = function (c) {
    c.fill_7(this._paint_0);
  };
  FillShape.prototype.toString = function () {
    return '' + 'FillShape(path=' + this._path_25 + ', clip=' + this._clip_0 + ', paint=' + this._paint_0 + ', transform=' + this._transform_7 + ')';
  };
  FillShape.prototype.hashCode = function () {
    var result = hashCode(this._path_25);
    result = imul(result, 31) + (this._clip_0 == null ? 0 : hashCode(this._clip_0)) | 0;
    result = imul(result, 31) + hashCode(this._paint_0) | 0;
    result = imul(result, 31) + this._transform_7.hashCode() | 0;
    return result;
  };
  FillShape.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!equals_1(this._path_25, tmp0_other_with_cast._path_25))
      return false;
    if (!equals_1(this._clip_0, tmp0_other_with_cast._clip_0))
      return false;
    if (!equals_1(this._paint_0, tmp0_other_with_cast._paint_0))
      return false;
    if (!this._transform_7.equals(tmp0_other_with_cast._transform_7))
      return false;
    return true;
  };
  FillShape.$metadata$ = {
    simpleName: 'FillShape',
    kind: 'class',
    interfaces: [StyledShape]
  };
  function PolylineShape(path_0, clip, paint, transform, thickness, pixelHinting, scaleMode, startCaps, endCaps, lineJoin, miterLimit) {
    this._path_26 = path_0;
    this._clip_1 = clip;
    this._paint_1 = paint;
    this._transform_8 = transform;
    this._thickness = thickness;
    this._pixelHinting = pixelHinting;
    this._scaleMode = scaleMode;
    this._startCaps = startCaps;
    this._endCaps = endCaps;
    this._lineJoin_0 = lineJoin;
    this._miterLimit_1 = miterLimit;
    this._tempBB = new BoundsBuilder();
    this._tempRect_0 = Companion_getInstance_83().invoke_1005();
  }
  PolylineShape.prototype._get_path__5 = function () {
    return this._path_26;
  };
  PolylineShape.prototype._get_clip__1 = function () {
    return this._clip_1;
  };
  PolylineShape.prototype._get_transform__8 = function () {
    return this._transform_8;
  };
  PolylineShape.prototype.addBounds_3 = function (bb) {
    this._tempBB.reset_9();
    add_0(this._tempBB, this._path_26);
    this._tempBB.getBounds_0(this._tempRect_0);
    Unit_getInstance();
    var halfThickness = this._thickness / 2;
    this._tempRect_0.inflate(max2_6(halfThickness, 0.0), max2_6(halfThickness, 0.0));
    bb.add_46(this._tempRect_0);
    Unit_getInstance();
  };
  PolylineShape.prototype.drawInternal_1 = function (c) {
    c._set_lineScaleMode_(this._scaleMode);
    c._set_lineWidth_(this._thickness);
    c._set_lineCap__0(this._endCaps);
    c._set_lineJoin_(this._lineJoin_0);
    c.stroke_1(this._paint_1);
  };
  PolylineShape.prototype.toString = function () {
    return '' + 'PolylineShape(path=' + this._path_26 + ', clip=' + this._clip_1 + ', paint=' + this._paint_1 + ', transform=' + this._transform_8 + ', thickness=' + this._thickness + ', pixelHinting=' + this._pixelHinting + ', scaleMode=' + this._scaleMode + ', startCaps=' + this._startCaps + ', endCaps=' + this._endCaps + ', lineJoin=' + this._lineJoin_0 + ', miterLimit=' + this._miterLimit_1 + ')';
  };
  PolylineShape.prototype.hashCode = function () {
    var result = hashCode(this._path_26);
    result = imul(result, 31) + (this._clip_1 == null ? 0 : hashCode(this._clip_1)) | 0;
    result = imul(result, 31) + hashCode(this._paint_1) | 0;
    result = imul(result, 31) + this._transform_8.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._thickness) | 0;
    result = imul(result, 31) + (this._pixelHinting | 0) | 0;
    result = imul(result, 31) + this._scaleMode.hashCode() | 0;
    result = imul(result, 31) + this._startCaps.hashCode() | 0;
    result = imul(result, 31) + this._endCaps.hashCode() | 0;
    result = imul(result, 31) + this._lineJoin_0.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._miterLimit_1) | 0;
    return result;
  };
  PolylineShape.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!equals_1(this._path_26, tmp0_other_with_cast._path_26))
      return false;
    if (!equals_1(this._clip_1, tmp0_other_with_cast._clip_1))
      return false;
    if (!equals_1(this._paint_1, tmp0_other_with_cast._paint_1))
      return false;
    if (!this._transform_8.equals(tmp0_other_with_cast._transform_8))
      return false;
    if (!equals_1(this._thickness, tmp0_other_with_cast._thickness))
      return false;
    if (!(this._pixelHinting === tmp0_other_with_cast._pixelHinting))
      return false;
    if (!this._scaleMode.equals(tmp0_other_with_cast._scaleMode))
      return false;
    if (!this._startCaps.equals(tmp0_other_with_cast._startCaps))
      return false;
    if (!this._endCaps.equals(tmp0_other_with_cast._endCaps))
      return false;
    if (!this._lineJoin_0.equals(tmp0_other_with_cast._lineJoin_0))
      return false;
    if (!equals_1(this._miterLimit_1, tmp0_other_with_cast._miterLimit_1))
      return false;
    return true;
  };
  PolylineShape.$metadata$ = {
    simpleName: 'PolylineShape',
    kind: 'class',
    interfaces: [StyledShape]
  };
  function add_3(_this_, path_0, transform) {
    var bb = _this_;
    var lx = 0.0;
    var ly = 0.0;
    var bezierTemp = new Temp();
    var n_1 = 0;
    var tmp0_fastForEach_0_2 = path_0._commands;
    var n_1_3 = 0;
    while (n_1_3 < tmp0_fastForEach_0_2._get_size__60()) {
      var tmp0_2_5 = n_1_3;
      n_1_3 = tmp0_2_5 + 1 | 0;
      var tmp1__anonymous__3_4 = tmp0_fastForEach_0_2.getAt_0(tmp0_2_5);
      var tmp0_subject_4_6 = tmp1__anonymous__3_4;
      switch (tmp0_subject_4_6) {
        case 0:
          var tmp1_5_7 = n_1;
          n_1 = tmp1_5_7 + 1 | 0;
          var tmp0__anonymous__21 = path_0._data_37.get_137(tmp1_5_7);
          var tmp2_6_8 = n_1;
          n_1 = tmp2_6_8 + 1 | 0;
          var tmp1__anonymous__21 = path_0._data_37.get_137(tmp2_6_8);
          var tmp0_also_0_23 = bb.add_45(tmp0__anonymous__21, tmp1__anonymous__21, transform);
          lx = tmp0__anonymous__21;
          var tmp1_also_0_22 = tmp0_also_0_23;
          ly = tmp1__anonymous__21;
          Unit_getInstance();
          break;
        case 1:
          var tmp3_7_9 = n_1;
          n_1 = tmp3_7_9 + 1 | 0;
          var tmp2__anonymous__24 = path_0._data_37.get_137(tmp3_7_9);
          var tmp4_8_10 = n_1;
          n_1 = tmp4_8_10 + 1 | 0;
          var tmp3__anonymous__24 = path_0._data_37.get_137(tmp4_8_10);
          var tmp0_also_0_26 = bb.add_45(tmp2__anonymous__24, tmp3__anonymous__24, transform);
          lx = tmp2__anonymous__24;
          var tmp1_also_0_25 = tmp0_also_0_26;
          ly = tmp3__anonymous__24;
          Unit_getInstance();
          break;
        case 2:
          var tmp5_9_11 = n_1;
          n_1 = tmp5_9_11 + 1 | 0;
          var tmp4__anonymous__27 = path_0._data_37.get_137(tmp5_9_11);
          var tmp6_10_12 = n_1;
          n_1 = tmp6_10_12 + 1 | 0;
          var tmp5__anonymous__27 = path_0._data_37.get_137(tmp6_10_12);
          var tmp7_11_13 = n_1;
          n_1 = tmp7_11_13 + 1 | 0;
          var tmp6__anonymous__27 = path_0._data_37.get_137(tmp7_11_13);
          var tmp8_12_14 = n_1;
          n_1 = tmp8_12_14 + 1 | 0;
          var tmp7__anonymous__27 = path_0._data_37.get_137(tmp8_12_14);
          var tmp = Companion_getInstance_89();
          var tmp_0 = lx;
          var tmp_1 = ly;
          var tmp0_also_0_29 = bb.add_47(tmp.quadBounds$default(tmp_0, tmp_1, tmp4__anonymous__27, tmp5__anonymous__27, tmp6__anonymous__27, tmp7__anonymous__27, bb._tempRect, null, 128, null), transform);
          lx = tmp6__anonymous__27;
          var tmp1_also_0_28 = tmp0_also_0_29;
          ly = tmp7__anonymous__27;
          Unit_getInstance();
          break;
        case 3:
          var tmp9_13_15 = n_1;
          n_1 = tmp9_13_15 + 1 | 0;
          var tmp8__anonymous__30 = path_0._data_37.get_137(tmp9_13_15);
          var tmp10_14_16 = n_1;
          n_1 = tmp10_14_16 + 1 | 0;
          var tmp9__anonymous__30 = path_0._data_37.get_137(tmp10_14_16);
          var tmp11_15_17 = n_1;
          n_1 = tmp11_15_17 + 1 | 0;
          var tmp10__anonymous__30 = path_0._data_37.get_137(tmp11_15_17);
          var tmp12_16_18 = n_1;
          n_1 = tmp12_16_18 + 1 | 0;
          var tmp11__anonymous__30 = path_0._data_37.get_137(tmp12_16_18);
          var tmp13_17_19 = n_1;
          n_1 = tmp13_17_19 + 1 | 0;
          var tmp12__anonymous__30 = path_0._data_37.get_137(tmp13_17_19);
          var tmp14_18_20 = n_1;
          n_1 = tmp14_18_20 + 1 | 0;
          var tmp13__anonymous__30 = path_0._data_37.get_137(tmp14_18_20);
          var tmp0_also_0_32 = bb.add_47(Companion_getInstance_89().cubicBounds(lx, ly, tmp8__anonymous__30, tmp9__anonymous__30, tmp10__anonymous__30, tmp11__anonymous__30, tmp12__anonymous__30, tmp13__anonymous__30, bb._tempRect, bezierTemp), transform);
          lx = tmp12__anonymous__30;
          var tmp1_also_0_31 = tmp0_also_0_32;
          ly = tmp13__anonymous__30;
          Unit_getInstance();
          break;
        case 4:
          Unit_getInstance();
          break;
      }
    }
  }
  function toSvgPathString$fixX(_this_, $decimalPlaces) {
    return toStringDecimal(_this_, $decimalPlaces, true);
  }
  function toSvgPathString$fixY(_this_, $decimalPlaces) {
    return toStringDecimal(_this_, $decimalPlaces, true);
  }
  function StrokeInfo_init_$Init$(thickness, pixelHinting, scaleMode, startCap, endCap, lineJoin, miterLimit, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      thickness = 1.0;
    if (!(($mask0 & 2) === 0))
      pixelHinting = false;
    if (!(($mask0 & 4) === 0))
      scaleMode = LineScaleMode_NORMAL_getInstance();
    if (!(($mask0 & 8) === 0))
      startCap = LineCap_BUTT_getInstance();
    if (!(($mask0 & 16) === 0))
      endCap = LineCap_BUTT_getInstance();
    if (!(($mask0 & 32) === 0))
      lineJoin = LineJoin_MITER_getInstance();
    if (!(($mask0 & 64) === 0))
      miterLimit = 20.0;
    StrokeInfo.call($this, thickness, pixelHinting, scaleMode, startCap, endCap, lineJoin, miterLimit);
    return $this;
  }
  function StrokeInfo_init_$Create$(thickness, pixelHinting, scaleMode, startCap, endCap, lineJoin, miterLimit, $mask0, $marker) {
    return StrokeInfo_init_$Init$(thickness, pixelHinting, scaleMode, startCap, endCap, lineJoin, miterLimit, $mask0, $marker, Object.create(StrokeInfo.prototype));
  }
  function StrokeInfo(thickness, pixelHinting, scaleMode, startCap, endCap, lineJoin, miterLimit) {
    this._thickness_0 = thickness;
    this._pixelHinting_0 = pixelHinting;
    this._scaleMode_0 = scaleMode;
    this._startCap_0 = startCap;
    this._endCap_0 = endCap;
    this._lineJoin_1 = lineJoin;
    this._miterLimit_2 = miterLimit;
  }
  StrokeInfo.prototype.toString = function () {
    return '' + 'StrokeInfo(thickness=' + this._thickness_0 + ', pixelHinting=' + this._pixelHinting_0 + ', scaleMode=' + this._scaleMode_0 + ', startCap=' + this._startCap_0 + ', endCap=' + this._endCap_0 + ', lineJoin=' + this._lineJoin_1 + ', miterLimit=' + this._miterLimit_2 + ')';
  };
  StrokeInfo.prototype.hashCode = function () {
    var result = getNumberHashCode(this._thickness_0);
    result = imul(result, 31) + (this._pixelHinting_0 | 0) | 0;
    result = imul(result, 31) + this._scaleMode_0.hashCode() | 0;
    result = imul(result, 31) + this._startCap_0.hashCode() | 0;
    result = imul(result, 31) + this._endCap_0.hashCode() | 0;
    result = imul(result, 31) + this._lineJoin_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._miterLimit_2) | 0;
    return result;
  };
  StrokeInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StrokeInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof StrokeInfo ? other : THROW_CCE();
    if (!equals_1(this._thickness_0, tmp0_other_with_cast._thickness_0))
      return false;
    if (!(this._pixelHinting_0 === tmp0_other_with_cast._pixelHinting_0))
      return false;
    if (!this._scaleMode_0.equals(tmp0_other_with_cast._scaleMode_0))
      return false;
    if (!this._startCap_0.equals(tmp0_other_with_cast._startCap_0))
      return false;
    if (!this._endCap_0.equals(tmp0_other_with_cast._endCap_0))
      return false;
    if (!this._lineJoin_1.equals(tmp0_other_with_cast._lineJoin_1))
      return false;
    if (!equals_1(this._miterLimit_2, tmp0_other_with_cast._miterLimit_2))
      return false;
    return true;
  };
  StrokeInfo.$metadata$ = {
    simpleName: 'StrokeInfo',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__248($xmax, $xmin, this$0, $callback) {
    this._$xmax = $xmax;
    this._$xmin = $xmin;
    this._this$0_55 = this$0;
    this._$callback_3 = $callback;
  }
  _no_name_provided__248.prototype.invoke_426 = function (a, b, y) {
    if (a <= this._$xmax ? b >= this._$xmin : false) {
      var a0 = coerceIn(a, this._$xmin, this._$xmax);
      var b0 = coerceIn(b, this._$xmin, this._$xmax);
      if (this._this$0_55._debug) {
        println('' + 'RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }this._$callback_3(a0, b0, y);
    } else {
    }
  };
  _no_name_provided__248.prototype.invoke_704 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    this.invoke_426(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__248.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Rasterizer() {
    RastScale.call(this);
    this._debug = false;
    this._tempRect_1 = Companion_getInstance_83().invoke_1005();
    this._quality_0 = 2;
    this._scale = 1;
    this._path_27 = new PolygonScanline();
    this._clip_2 = new PolygonScanline();
    this._fillSegmentSet = new IntSegmentSet();
    this._clipSegmentSet = new IntSegmentSet();
    this._finalSegmentSet = new IntSegmentSet();
    this._yList_1 = new IntArrayList(1024);
  }
  Rasterizer.prototype.reset_9 = function () {
    this._path_27.reset_9();
    this._clip_2.reset_9();
  };
  Rasterizer.prototype.rasterizeFill = function (bounds, quality, stats, winding, callback) {
    var tmp0_safe_receiver = stats;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.reset_9();
      Unit_getInstance();
    }
    Unit_getInstance();
    var xmin = this._get_s__2(bounds._get_left__4());
    var xmax = this._get_s__2(bounds._get_right__2());
    this._path_27.getBounds_0(this._tempRect_1);
    Unit_getInstance();
    var startY = this._get_s__2(max2_6(bounds._get_top__4(), this._tempRect_1._get_top__4()));
    var endY = this._get_s__2(min2_6(bounds._get_bottom__2(), this._tempRect_1._get_bottom__2()));
    var func = _no_name_provided_$factory_206(xmax, xmin, this, callback);
    this._yList_1.clear_33();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this._get_sscale__1() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last_1 = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this._get_sscale__1()) / this._scale | 0) / q | 0) | 0;
        this._yList_1.add_26(y);
      }
       while (inductionVariable < last_1);
    var edgesEmitted_2 = 0;
    var edgesChecked_3 = 0;
    var tmp0_fastForEach_0_4 = this._yList_1;
    var n_1_5 = 0;
    while (n_1_5 < tmp0_fastForEach_0_4._get_size__60()) {
      var tmp0_2_7 = n_1_5;
      n_1_5 = tmp0_2_7 + 1 | 0;
      var tmp1__anonymous__3_6 = tmp0_fastForEach_0_4.getAt_0(tmp0_2_7);
      this._path_27.scanline(tmp1__anonymous__3_6, winding, this._fillSegmentSet);
      Unit_getInstance();
      edgesChecked_3 = edgesChecked_3 + this._path_27._edgesChecked | 0;
      if (this._clip_2.isNotEmpty_1()) {
        this._clip_2.scanline(tmp1__anonymous__3_6, this._clip_2._winding, this._clipSegmentSet);
        Unit_getInstance();
        edgesChecked_3 = edgesChecked_3 + this._clip_2._edgesChecked | 0;
        this._finalSegmentSet.setToIntersect(this._fillSegmentSet, this._clipSegmentSet);
        Unit_getInstance();
      }var tmp0_fastForEach_0_4_8 = this._clip_2.isNotEmpty_1() ? this._finalSegmentSet : this._fillSegmentSet;
      var inductionVariable_0 = 0;
      var last_2 = tmp0_fastForEach_0_4_8._get_size__60();
      if (inductionVariable_0 < last_2)
        do {
          var n_2_6_10 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp1__anonymous__3_7_11 = tmp0_fastForEach_0_4_8._min_0.getAt_0(n_2_6_10);
          var tmp2__anonymous__3_8_12 = tmp0_fastForEach_0_4_8._max_0.getAt_0(n_2_6_10);
          func(tmp1__anonymous__3_7_11, tmp2__anonymous__3_8_12, tmp1__anonymous__3_6);
          var tmp0_4_9_13 = edgesEmitted_2;
          edgesEmitted_2 = tmp0_4_9_13 + 1 | 0;
          Unit_getInstance();
        }
         while (inductionVariable_0 < last_2);
    }
    var tmp0_safe_receiver_14 = stats;
    if (tmp0_safe_receiver_14 == null)
      null;
    else {
      tmp0_safe_receiver_14.chunk__error(edgesChecked_3, edgesEmitted_2, yCount);
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  Rasterizer.prototype.rasterizeFill$default = function (bounds, quality, stats, winding, callback, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      quality = this._quality_0;
    if (!(($mask0 & 4) === 0))
      stats = null;
    if (!(($mask0 & 8) === 0))
      winding = Winding_NON_ZERO_getInstance();
    return this.rasterizeFill(bounds, quality, stats, winding, callback);
  };
  Rasterizer.$metadata$ = {
    simpleName: 'Rasterizer',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_206($xmax, $xmin, this$0, $callback) {
    var i = new _no_name_provided__248($xmax, $xmin, this$0, $callback);
    return function (p1, p2, p3) {
      i.invoke_426(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__249($x, $y, $width, $height) {
    this._$x_0 = $x;
    this._$y_0 = $y;
    this._$width_0 = $width;
    this._$height_0 = $height;
  }
  _no_name_provided__249.prototype.invoke_428 = function ($this$transformed) {
    rect($this$transformed, this._$x_0, this._$y_0, this._$width_0, this._$height_0);
  };
  _no_name_provided__249.prototype.invoke_1015 = function (p1) {
    this.invoke_428((!(p1 == null) ? isInterface(p1, VectorBuilder) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__249.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Renderer() {
    this._debug_0 = false;
    this._bufferingLevel = 0;
  }
  Renderer.prototype._get_debug__0 = function () {
    return this._debug_0;
  };
  Renderer.prototype.flush_8 = function () {
    return Unit_getInstance();
  };
  Renderer.prototype.bufferingStart_1 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._bufferingLevel;
    tmp0_this._bufferingLevel = tmp1 + 1 | 0;
    return tmp1;
  };
  Renderer.prototype.bufferingEnd_1 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._bufferingLevel;
    tmp0_this._bufferingLevel = tmp1 - 1 | 0;
    Unit_getInstance();
    if (this._bufferingLevel === 0) {
      this.flush_8();
    }};
  Renderer.prototype.render_1 = function (state, fill_3) {
    return Unit_getInstance();
  };
  Renderer.prototype.drawImage_3 = function (image, x, y, width, height, transform) {
    var tmp0_apply_0 = GraphicsPath_init_$Create$(null, null, null, 7, null);
    if (transform.getType().equals(Type_IDENTITY_getInstance())) {
      rect(tmp0_apply_0, x, y, width, height);
    } else {
      transformed(tmp0_apply_0, transform, _no_name_provided_$factory_207(x, y, width, height));
    }
    var tmp = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null).scale_2(width / image._width_2, height / image._height_2).translate_2(x, y);
    var tmp_0 = BitmapPaint_init_$Create$(image, tmp, null, null, false, 28, null);
    this.render_1(State_init_$Create$(transform, null, tmp0_apply_0, null, 0.0, null, null, null, 0.0, null, tmp_0, null, null, 0.0, null, null, 0.0, null, 261114, null), true);
  };
  Renderer.prototype.dispose_18 = function () {
    this.flush_8();
  };
  Renderer.$metadata$ = {
    simpleName: 'Renderer',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_207($x, $y, $width, $height) {
    var i = new _no_name_provided__249($x, $y, $width, $height);
    return function (p1) {
      i.invoke_428(p1);
      return Unit_getInstance();
    };
  }
  var nativeSystemFontProvider;
  function HtmlCanvas() {
    HtmlCanvas_instance = this;
  }
  HtmlCanvas.prototype.createCanvas = function (width, height) {
    if (OS_getInstance()._get_isJsNodeJs_()) {
      var tmp0_error_0 = 'Canvas not available on Node.JS';
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }var tmp1_unsafeCast_0 = document.createElement('canvas');
    var out = tmp1_unsafeCast_0;
    out.width = width;
    out.height = height;
    return toLike(out);
  };
  HtmlCanvas.$metadata$ = {
    simpleName: 'HtmlCanvas',
    kind: 'object',
    interfaces: []
  };
  var HtmlCanvas_instance;
  function HtmlCanvas_getInstance() {
    if (HtmlCanvas_instance == null)
      new HtmlCanvas();
    return HtmlCanvas_instance;
  }
  function toLike(_this_) {
    return _this_;
  }
  function HtmlImage() {
    HtmlImage_instance = this;
  }
  HtmlImage.prototype.createHtmlCanvas = function (width, height) {
    return HtmlCanvas_getInstance().createCanvas(width, height);
  };
  HtmlImage.prototype.renderToHtmlCanvas = function (bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl_(bmpData);
    var tmp0_unsafeCast_0 = function () {
      var $externalVarargReceiverTmp = canvas;
      return $externalVarargReceiverTmp.getContext.apply($externalVarargReceiverTmp, ['2d']);
    }.call(this);
    var ctx = tmp0_unsafeCast_0;
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl(bmpData, n);
        var tmp1 = m;
        m = tmp1 + 1 | 0;
        var tmp2_set_0 = tmp1;
        var tmp1_asDynamic_0 = _RGBA___get_r__impl_(c);
        var tmp3_set_0 = tmp1_asDynamic_0;
        idataData[tmp2_set_0] = tmp3_set_0;
        var tmp2 = m;
        m = tmp2 + 1 | 0;
        var tmp5_set_0 = tmp2;
        var tmp4_asDynamic_0 = _RGBA___get_g__impl_(c);
        var tmp6_set_0 = tmp4_asDynamic_0;
        idataData[tmp5_set_0] = tmp6_set_0;
        var tmp3 = m;
        m = tmp3 + 1 | 0;
        var tmp8_set_0 = tmp3;
        var tmp7_asDynamic_0 = _RGBA___get_b__impl_(c);
        var tmp9_set_0 = tmp7_asDynamic_0;
        idataData[tmp8_set_0] = tmp9_set_0;
        var tmp4 = m;
        m = tmp4 + 1 | 0;
        var tmp11_set_0 = tmp4;
        var tmp10_asDynamic_0 = _RGBA___get_a__impl_(c);
        var tmp12_set_0 = tmp10_asDynamic_0;
        idataData[tmp11_set_0] = tmp12_set_0;
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  };
  HtmlImage.prototype.renderToHtmlCanvas_0 = function (bmp, canvas) {
    return this.renderToHtmlCanvas(bmp.depremultipliedIfRequired()._data_39, bmp._get_width__58(), bmp._get_height__58(), canvas);
  };
  HtmlImage.prototype.bitmapToHtmlCanvas = function (bmp) {
    return this.renderToHtmlCanvas_0(bmp, this.createHtmlCanvas(bmp._get_width__58(), bmp._get_height__58()));
  };
  HtmlImage.$metadata$ = {
    simpleName: 'HtmlImage',
    kind: 'object',
    interfaces: []
  };
  var HtmlImage_instance;
  function HtmlImage_getInstance() {
    if (HtmlImage_instance == null)
      new HtmlImage();
    return HtmlImage_instance;
  }
  function toHtmlNative(_this_) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject instanceof HtmlNativeImage) {
      tmp = _this_;
    } else {
      {
        tmp = HtmlNativeImage_init_$Create$_0(HtmlImage_getInstance().bitmapToHtmlCanvas(_this_.toBMP32_5()));
      }
    }
    return tmp;
  }
  var nativeImageFormatProvider;
  var tempB;
  var tempI;
  var temp8;
  function _get_isLittleEndian_() {
    var tmp0_getValue_0 = isLittleEndian$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = isLittleEndian$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var isLittleEndian$delegate;
  function _no_name_provided__250() {
  }
  _no_name_provided__250.prototype.invoke_1005 = function () {
    var tmp0_also_0 = RegisteredImageFormats_getInstance();
    tmp0_also_0.register_3([PNG_getInstance()]);
    return tmp0_also_0;
  };
  _no_name_provided__250.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function NodeJsNativeImageFormatProvider() {
    NodeJsNativeImageFormatProvider_instance = this;
    BaseNativeImageFormatProvider.call(this);
    var tmp = this;
    tmp._formats$delegate = lazy(_no_name_provided_$factory_209());
  }
  NodeJsNativeImageFormatProvider.prototype._get_formats__1 = function () {
    var tmp0_getValue_0 = this._formats$delegate;
    var tmp1_getValue_0 = formats$factory();
    return tmp0_getValue_0._get_value__10();
  };
  NodeJsNativeImageFormatProvider.$metadata$ = {
    simpleName: 'NodeJsNativeImageFormatProvider',
    kind: 'object',
    interfaces: []
  };
  var NodeJsNativeImageFormatProvider_instance;
  function NodeJsNativeImageFormatProvider_getInstance() {
    if (NodeJsNativeImageFormatProvider_instance == null)
      new NodeJsNativeImageFormatProvider();
    return NodeJsNativeImageFormatProvider_instance;
  }
  function $decodeCOROUTINE$18(_this_, data, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__133 = _this_;
    this._data_42 = data;
    this._premultiplied_6 = premultiplied;
  }
  $decodeCOROUTINE$18.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = BrowserImage_getInstance().decodeToCanvas(this._data_42, this._premultiplied_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return HtmlNativeImage_init_$Create$_0(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeCOROUTINE$18.$metadata$ = {
    simpleName: '$decodeCOROUTINE$18',
    kind: 'class',
    interfaces: []
  };
  function $decodeCOROUTINE$19(_this_, vfs, path_0, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__134 = _this_;
    this._vfs_5 = vfs;
    this._path_28 = path_0;
    this._premultiplied_7 = premultiplied;
  }
  $decodeCOROUTINE$19.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 6;
            this._tmp0_subject0_0 = this._vfs_5;
            var tmp_0 = this._tmp0_subject0_0;
            if (tmp_0 instanceof LocalVfs) {
              this._state_1 = 4;
              var tmp_1 = BrowserImage_getInstance();
              suspendResult = tmp_1.loadImage$default(this._path_28, false, 2, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                var tmp_2 = this._tmp0_subject0_0;
                if (tmp_2 instanceof UrlVfs_0) {
                  this._jsUrl2 = this._vfs_5.getFullUrl(this._path_28);
                  this._state_1 = 3;
                  suspendResult = BrowserImage_getInstance().loadImage(this._jsUrl2, this._premultiplied_7, this);
                  if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                    return suspendResult;
                  }continue $sm;
                } else {
                  {
                    this._ARGUMENT3_4 = BrowserImage_getInstance();
                    this._state_1 = 1;
                    suspendResult = this._vfs_5.get_115(this._path_28).readAll_0(this);
                    if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                      return suspendResult;
                    }continue $sm;
                  }
                }
                Unit_getInstance();
              }
            }

            break;
          case 1:
            this._ARGUMENT4_2 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT3_4.decodeToCanvas(this._ARGUMENT4_2, this._premultiplied_7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this._WHEN_RESULT1_7 = HtmlNativeImage_init_$Create$_0(ARGUMENT);
            this._state_1 = 5;
            continue $sm;
          case 3:
            var ARGUMENT_0 = suspendResult;
            this._WHEN_RESULT1_7 = HtmlNativeImage_init_$Create$(ARGUMENT_0);
            this._state_1 = 5;
            continue $sm;
          case 4:
            var ARGUMENT_1 = suspendResult;
            this._WHEN_RESULT1_7 = HtmlNativeImage_init_$Create$(ARGUMENT_1);
            this._state_1 = 5;
            continue $sm;
          case 5:
            return this._WHEN_RESULT1_7;
          case 6:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 6) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeCOROUTINE$19.$metadata$ = {
    simpleName: '$decodeCOROUTINE$19',
    kind: 'class',
    interfaces: []
  };
  function HtmlNativeImageFormatProvider() {
    HtmlNativeImageFormatProvider_instance = this;
    NativeImageFormatProvider.call(this);
  }
  HtmlNativeImageFormatProvider.prototype.decode_38 = function (data, premultiplied, $cont) {
    var tmp = new $decodeCOROUTINE$18(this, data, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  HtmlNativeImageFormatProvider.prototype.decode_39 = function (vfs, path_0, premultiplied, $cont) {
    var tmp = new $decodeCOROUTINE$19(this, vfs, path_0, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  HtmlNativeImageFormatProvider.prototype.create_22 = function (width, height, premultiplied) {
    return HtmlNativeImage_init_$Create$_0(HtmlCanvas_getInstance().createCanvas(width, height));
  };
  HtmlNativeImageFormatProvider.prototype.copy_18 = function (bmp) {
    return HtmlNativeImage_init_$Create$_0(HtmlImage_getInstance().bitmapToHtmlCanvas(bmp.toBMP32_5()));
  };
  HtmlNativeImageFormatProvider.$metadata$ = {
    simpleName: 'HtmlNativeImageFormatProvider',
    kind: 'object',
    interfaces: []
  };
  var HtmlNativeImageFormatProvider_instance;
  function HtmlNativeImageFormatProvider_getInstance() {
    if (HtmlNativeImageFormatProvider_instance == null)
      new HtmlNativeImageFormatProvider();
    return HtmlNativeImageFormatProvider_instance;
  }
  function HtmlNativeImage_init_$Init$(img, $this) {
    HtmlNativeImage.call($this, img, img.width, img.height);
    return $this;
  }
  function HtmlNativeImage_init_$Create$(img) {
    return HtmlNativeImage_init_$Init$(img, Object.create(HtmlNativeImage.prototype));
  }
  function HtmlNativeImage_init_$Init$_0(canvas, $this) {
    HtmlNativeImage.call($this, canvas, canvas.width, canvas.height);
    return $this;
  }
  function HtmlNativeImage_init_$Create$_0(canvas) {
    return HtmlNativeImage_init_$Init$_0(canvas, Object.create(HtmlNativeImage.prototype));
  }
  function _no_name_provided__251(this$0, $width, $height) {
    this._this$0_56 = this$0;
    this._$width_1 = $width;
    this._$height_1 = $height;
  }
  _no_name_provided__251.prototype.invoke_1005 = function () {
    var tmp;
    var tmp0_asDynamic_0 = this._this$0_56._texSource;
    if (tmp0_asDynamic_0.src !== undefined) {
      var tmp_0 = BrowserImage_getInstance();
      var tmp1_unsafeCast_0 = this._this$0_56._texSource;
      tmp = tmp_0.imageToCanvas_0(tmp1_unsafeCast_0, this._$width_1, this._$height_1);
    } else {
      {
        var tmp2_unsafeCast_0 = this._this$0_56._texSource;
        tmp = tmp2_unsafeCast_0;
      }
    }
    var tmp3_also_0 = tmp;
    this._this$0_56._texSource = tmp3_also_0;
    return tmp3_also_0;
  };
  _no_name_provided__251.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__252(this$0) {
    this._this$0_57 = this$0;
  }
  _no_name_provided__252.prototype.invoke_1005 = function () {
    var tmp0_unsafeCast_0 = function () {
      var $externalVarargReceiverTmp = this._this$0_57._get_lazyCanvasElement_();
      return $externalVarargReceiverTmp.getContext.apply($externalVarargReceiverTmp, ['2d']);
    }.call(this);
    return tmp0_unsafeCast_0;
  };
  _no_name_provided__252.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function HtmlNativeImage(texSourceBase, width, height) {
    NativeImage.call(this, width, height, texSourceBase, true);
    this._texSourceBase = texSourceBase;
    this._name_20 = 'HtmlNativeImage';
    this._texSource = this._texSourceBase;
    var tmp = this;
    tmp._lazyCanvasElement$delegate = lazy(_no_name_provided_$factory_210(this, width, height));
    var tmp_0 = this;
    tmp_0._ctx$delegate = lazy(_no_name_provided_$factory_211(this));
    var tmp_1 = this;
    var tmp0__get_milliseconds__0 = 0.0;
    tmp_1._lastRefresh = Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0);
  }
  HtmlNativeImage.prototype._get_name__50 = function () {
    return this._name_20;
  };
  HtmlNativeImage.prototype._get_lazyCanvasElement_ = function () {
    var tmp0_getValue_0 = this._lazyCanvasElement$delegate;
    var tmp1_getValue_0 = lazyCanvasElement$factory();
    return tmp0_getValue_0._get_value__10();
  };
  HtmlNativeImage.prototype._get_ctx_ = function () {
    var tmp0_getValue_0 = this._ctx$delegate;
    var tmp1_getValue_0 = ctx$factory();
    return tmp0_getValue_0._get_value__10();
  };
  HtmlNativeImage.prototype.readPixelsUnsafe_5 = function (x, y, width, height, out, offset) {
    if (width <= 0 ? true : height <= 0)
      return Unit_getInstance();
    var size_1 = imul(width, height);
    var tmp = this._texSourceBase;
    if (tmp instanceof HTMLVideoElement) {
      var now = PerformanceCounter_getInstance()._get_reference_();
      var elapsedTime = TimeSpan__minus_impl(now, this._lastRefresh);
      var tmp0__get_milliseconds__0 = 16;
      if (TimeSpan__compareTo_impl(elapsedTime, Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0)) >= 0) {
        this._lastRefresh = now;
        this._get_ctx_().clearRect(0.0, 0.0, width, height);
        this._get_ctx_().drawImage(this._texSourceBase, 0.0, 0.0);
      } else {
      }
    } else {
    }
    var idata = this._get_ctx_().getImageData(x, y, width, height);
    var tmp1_unsafeCast_0 = asInt32Buffer(idata.data.buffer);
    var data = tmp1_unsafeCast_0;
    arraycopy_4(data, 0, _RgbaArray___get_ints__impl_(out), offset, size_1);
    if (_get_isBigEndian_())
      bswap32(_RgbaArray___get_ints__impl_(out), offset, size_1);
  };
  HtmlNativeImage.prototype.writePixelsUnsafe_5 = function (x, y, width, height, out, offset) {
    if (width <= 0 ? true : height <= 0)
      return Unit_getInstance();
    var size_1 = imul(width, height);
    var idata = this._get_ctx_().createImageData(width, height);
    var tmp0_unsafeCast_0 = asInt32Buffer(idata.data.buffer);
    var data = tmp0_unsafeCast_0;
    arraycopy_4(_RgbaArray___get_ints__impl_(out), offset, data, 0, size_1);
    if (_get_isBigEndian_())
      bswap32(data, 0, size_1);
    this._get_ctx_().putImageData(idata, x, y);
  };
  HtmlNativeImage.prototype.getContext2d_5 = function (antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this._get_lazyCanvasElement_()));
  };
  HtmlNativeImage.$metadata$ = {
    simpleName: 'HtmlNativeImage',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__253($img_5, $cancellable_2_2) {
    this._$img_5 = $img_5;
    this._$cancellable_2_2 = $cancellable_2_2;
  }
  _no_name_provided__253.prototype.invoke_564 = function (it) {
    var tmp0_resume_0_8 = this._$img_5;
    var tmp0_success_0_1_9 = Companion_getInstance_2();
    this._$cancellable_2_2.resumeWith_196(_Result___init__impl_(tmp0_resume_0_8));
  };
  _no_name_provided__253.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__253.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__254($jsUrl, $cancellable_2_2) {
    this._$jsUrl = $jsUrl;
    this._$cancellable_2_2_0 = $cancellable_2_2;
  }
  _no_name_provided__254.prototype.invoke_435 = function (_anonymous_parameter_0_, _anonymous_parameter_1_, _anonymous_parameter_2_, _anonymous_parameter_3_, _anonymous_parameter_4_) {
    var tmp0_resumeWithException_0_11 = RuntimeException_init_$Create$('' + 'error loading image ' + this._$jsUrl);
    var tmp0_failure_0_1_12 = Companion_getInstance_2();
    this._$cancellable_2_2_0.resumeWith_196(_Result___init__impl_(createFailure(tmp0_resumeWithException_0_11)));
  };
  _no_name_provided__254.prototype.invoke_436 = function (p1, p2, p3, p4, p5) {
    var tmp = (p1 == null ? true : p1) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    this.invoke_435(tmp, tmp_0, tmp_1, tmp_2, (p5 == null ? true : isObject(p5)) ? p5 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__254.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $decodeToCanvasCOROUTINE$20(_this_, bytes, premultiplied, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__135 = _this_;
    this._bytes_0 = bytes;
    this._premultiplied_8 = premultiplied;
  }
  $decodeToCanvasCOROUTINE$20.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            if (OS_getInstance()._get_isJsNodeJs_()) {
              var tmp_0 = this;
              tmp_0._tmp0_error_00 = 'Canvas not available on NodeJS';
              throw IllegalStateException_init_$Create$_0(toString_1(this._tmp0_error_00));
            }
            var tmp_1 = this;
            var tmp_2 = this;
            tmp_2._tmp1_arrayOf_01 = [this._bytes_0];
            var tmp_3 = this._tmp1_arrayOf_01;
            var tmp_4 = this;
            tmp_4._tmp2_BlobPropertyBag_02 = 'image/png';
            this._o_13 = {};
            this._o_13['type'] = this._tmp2_BlobPropertyBag_02;
            tmp_1._blob4 = new Blob(tmp_3, this._o_13);
            this._blobURL5 = URL.createObjectURL(this._blob4);
            this._state_1 = 1;
            continue $sm;
          case 1:
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 6;
            this._state_1 = 3;
            suspendResult = this.__this__135.loadCanvas(this._blobURL5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            this._tmp$ret$07 = suspendResult;
            this._exceptionState = 7;
            this._state_1 = 4;
            var tmp_5 = this;
            continue $sm;
          case 4:
            var tmp_6 = this._tmp$ret$07;
            URL.revokeObjectURL(this._blobURL5);
            return tmp_6;
          case 5:
            URL.revokeObjectURL(this._blobURL5);
            return Unit_getInstance();
          case 6:
            this._exceptionState = 7;
            var t = this._exception_0;
            URL.revokeObjectURL(this._blobURL5);
            throw t;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $decodeToCanvasCOROUTINE$20.$metadata$ = {
    simpleName: '$decodeToCanvasCOROUTINE$20',
    kind: 'class',
    interfaces: []
  };
  function $loadCanvasCOROUTINE$21(_this_, jsUrl, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__136 = _this_;
    this._jsUrl = jsUrl;
  }
  $loadCanvasCOROUTINE$21.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__136.loadImage$default(this._jsUrl, false, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return this.__this__136.imageToCanvas(ARGUMENT);
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loadCanvasCOROUTINE$21.$metadata$ = {
    simpleName: '$loadCanvasCOROUTINE$21',
    kind: 'class',
    interfaces: []
  };
  function BrowserImage() {
    BrowserImage_instance = this;
  }
  BrowserImage.prototype.decodeToCanvas = function (bytes, premultiplied, $cont) {
    var tmp = new $decodeToCanvasCOROUTINE$20(this, bytes, premultiplied, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  BrowserImage.prototype.imageToCanvas = function (img) {
    return this.imageToCanvas_0(img, img.width, img.height);
  };
  BrowserImage.prototype.imageToCanvas_0 = function (img, width, height) {
    var canvas = HtmlCanvas_getInstance().createCanvas(width, height);
    var tmp0_unsafeCast_0 = function () {
      var $externalVarargReceiverTmp = canvas;
      return $externalVarargReceiverTmp.getContext.apply($externalVarargReceiverTmp, ['2d']);
    }.call(this);
    var ctx = tmp0_unsafeCast_0;
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  };
  BrowserImage.prototype.loadImage = function (jsUrl, premultiplied, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_0();
    if (OS_getInstance()._get_isJsNodeJs_()) {
      var tmp0_error_0_4 = 'Canvas not available on NodeJS';
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_4));
    }var tmp1_unsafeCast_0_6 = document.createElement('img');
    var img_5 = tmp1_unsafeCast_0_6;
    img_5.onload = _no_name_provided_$factory_212(img_5, cancellable_2_2);
    img_5.onerror = _no_name_provided_$factory_213(jsUrl, cancellable_2_2);
    img_5.src = jsUrl;
    Unit_getInstance();
    return cancellable_2_2.getResult_1();
  };
  BrowserImage.prototype.loadImage$default = function (jsUrl, premultiplied, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      premultiplied = true;
    return this.loadImage(jsUrl, premultiplied, $cont);
  };
  BrowserImage.prototype.loadCanvas = function (jsUrl, $cont) {
    var tmp = new $loadCanvasCOROUTINE$21(this, jsUrl, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  BrowserImage.$metadata$ = {
    simpleName: 'BrowserImage',
    kind: 'object',
    interfaces: []
  };
  var BrowserImage_instance;
  function BrowserImage_getInstance() {
    if (BrowserImage_instance == null)
      new BrowserImage();
    return BrowserImage_instance;
  }
  function _get_isBigEndian_() {
    return !_get_isLittleEndian_();
  }
  function bswap32(v, offset, size_1) {
    var inductionVariable = offset;
    var last_1 = offset + size_1 | 0;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        v[n] = bswap32_0(v[n]);
      }
       while (inductionVariable < last_1);
  }
  function setFont($this, font, fontSize) {
    if (font._get_name__50() === $this._cachedFontName ? fontSize === $this._cachedFontSize : false)
      return Unit_getInstance();
    $this._cachedFontName = font._get_name__50();
    $this._cachedFontSize = fontSize;
    $this._ctx_1.font = '' + fontSize + "px '" + font._get_name__50() + "'";
  }
  function setState($this, state, fill_3, doSetFont) {
    $this._ctx_1.globalAlpha = state._globalAlpha;
    $this._ctx_1.globalCompositeOperation = $this.toJsStr_2(state._globalCompositeOperation);
    if (doSetFont) {
      setFont($this, state._font_0, state._fontSize_2);
    }if (fill_3) {
      $this._ctx_1.fillStyle = $this.toJsStr(state._fillStyle);
    } else {
      $this._ctx_1.lineWidth = state._lineWidth;
      var tmp0_subject = state._lineJoin;
      var tmp;
      if (tmp0_subject.equals(LineJoin_BEVEL_getInstance())) {
        var tmp0__get_BEVEL__0 = null;
        var tmp0_asDynamic_0_2 = 'bevel';
        var tmp1_unsafeCast_0_1 = tmp0_asDynamic_0_2;
        tmp = tmp1_unsafeCast_0_1;
      } else if (tmp0_subject.equals(LineJoin_MITER_getInstance())) {
        var tmp1__get_MITER__0 = null;
        var tmp0_asDynamic_0_2_0 = 'miter';
        var tmp1_unsafeCast_0_1_0 = tmp0_asDynamic_0_2_0;
        tmp = tmp1_unsafeCast_0_1_0;
      } else if (tmp0_subject.equals(LineJoin_ROUND_getInstance())) {
        var tmp2__get_ROUND__0 = null;
        var tmp0_asDynamic_0_2_1 = 'round';
        var tmp1_unsafeCast_0_1_1 = tmp0_asDynamic_0_2_1;
        tmp = tmp1_unsafeCast_0_1_1;
      } else {
        noWhenBranchMatchedException();
      }
      $this._ctx_1.lineJoin = tmp;
      var tmp1_subject = state._get_lineCap__0();
      var tmp_0;
      if (tmp1_subject.equals(LineCap_BUTT_getInstance())) {
        var tmp3__get_BUTT__0 = null;
        var tmp0_asDynamic_0_2_2 = 'butt';
        var tmp1_unsafeCast_0_1_2 = tmp0_asDynamic_0_2_2;
        tmp_0 = tmp1_unsafeCast_0_1_2;
      } else if (tmp1_subject.equals(LineCap_ROUND_getInstance())) {
        var tmp4__get_ROUND__0 = null;
        var tmp0_asDynamic_0_2_3 = 'round';
        var tmp1_unsafeCast_0_1_3 = tmp0_asDynamic_0_2_3;
        tmp_0 = tmp1_unsafeCast_0_1_3;
      } else if (tmp1_subject.equals(LineCap_SQUARE_getInstance())) {
        var tmp5__get_SQUARE__0 = null;
        var tmp0_asDynamic_0_2_4 = 'square';
        var tmp1_unsafeCast_0_1_4 = tmp0_asDynamic_0_2_4;
        tmp_0 = tmp1_unsafeCast_0_1_4;
      } else {
        noWhenBranchMatchedException();
      }
      $this._ctx_1.lineCap = tmp_0;
      $this._ctx_1.strokeStyle = $this.toJsStr(state._strokeStyle);
    }
  }
  function transformPaint($this, paint) {
    if (isInterface(paint, TransformedPaint)) {
      var m = paint._get_transform__8();
      $this._ctx_1.transform(m._a, m._b, m._c, m._d, m._tx, m._ty);
    } else {
    }
  }
  function CanvasContext2dRenderer(canvas) {
    Renderer.call(this);
    this._canvas = canvas;
    var tmp = this;
    var tmp0_unsafeCast_0 = function () {
      var $externalVarargReceiverTmp = this._canvas;
      return $externalVarargReceiverTmp.getContext.apply($externalVarargReceiverTmp, ['2d']);
    }.call(this);
    tmp._ctx_1 = tmp0_unsafeCast_0;
    this._cachedFontSize = NaN;
    this._cachedFontName = '';
  }
  CanvasContext2dRenderer.prototype._get_width__58 = function () {
    return this._canvas.width;
  };
  CanvasContext2dRenderer.prototype._get_height__58 = function () {
    return this._canvas.height;
  };
  CanvasContext2dRenderer.prototype.toJsStr = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (tmp0_subject instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl_(_RGBA___get_color__impl_(_this__0._value_17));
      } else {
        if (tmp0_subject instanceof GradientPaint) {
          var tmp1_subject = _this__0._kind_0;
          var tmp_0;
          if (tmp1_subject.equals(GradientKind_LINEAR_getInstance())) {
            var grad = this._ctx_1.createLinearGradient(_this__0._x0, _this__0._y0, _this__0._x1, _this__0._y1);
            var inductionVariable = 0;
            var last_1 = _this__0._stops._get_size__60();
            if (inductionVariable < last_1)
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var stop = _this__0._stops.getAt_0(n);
                var color_0 = _this__0._colors_0.getAt_0(n);
                grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl_(_RGBA___init__impl_(color_0)));
              }
               while (inductionVariable < last_1);
            tmp_0 = grad;
          } else if (tmp1_subject.equals(GradientKind_RADIAL_getInstance())) {
            var grad_0 = this._ctx_1.createRadialGradient(_this__0._x0, _this__0._y0, _this__0._r0_0, _this__0._x1, _this__0._y1, _this__0._r1);
            var inductionVariable_0 = 0;
            var last_2 = _this__0._stops._get_size__60();
            if (inductionVariable_0 < last_2)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var stop_0 = _this__0._stops.getAt_0(n_0);
                var color_1 = _this__0._colors_0.getAt_0(n_0);
                grad_0.addColorStop(stop_0, _RGBA___get_htmlStringSimple__impl_(_RGBA___init__impl_(color_1)));
              }
               while (inductionVariable_0 < last_2);
            tmp_0 = grad_0;
          } else if (tmp1_subject.equals(GradientKind_SWEEP_getInstance())) {
            tmp_0 = 'fuchsia';
          } else {
            noWhenBranchMatchedException();
          }
          tmp = tmp_0;
        } else {
          if (tmp0_subject instanceof BitmapPaint) {
            var tmp0_unsafeCast_0 = toHtmlNative(_this__0._bitmap_2)._texSource;
            tmp = this._ctx_1.createPattern(tmp0_unsafeCast_0, (_this__0._get_repeatX_() ? _this__0._get_repeatY_() : false) ? 'repeat' : _this__0._get_repeatX_() ? 'repeat-x' : _this__0._get_repeatY_() ? 'repeat-y' : 'no-repeat');
          } else {
            {
              tmp = 'black';
            }
          }
        }
      }
    }
    return tmp;
  };
  CanvasContext2dRenderer.prototype.toJsStr_0 = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(CompositeMode_CLEAR_getInstance())) {
      tmp = 'clear';
    } else if (tmp0_subject.equals(CompositeMode_COPY_getInstance())) {
      tmp = 'copy';
    } else if (tmp0_subject.equals(CompositeMode_SOURCE_OVER_getInstance())) {
      tmp = 'source-over';
    } else if (tmp0_subject.equals(CompositeMode_DESTINATION_OVER_getInstance())) {
      tmp = 'destination-over';
    } else if (tmp0_subject.equals(CompositeMode_SOURCE_IN_getInstance())) {
      tmp = 'source-in';
    } else if (tmp0_subject.equals(CompositeMode_DESTINATION_IN_getInstance())) {
      tmp = 'destination-in';
    } else if (tmp0_subject.equals(CompositeMode_SOURCE_OUT_getInstance())) {
      tmp = 'source-out';
    } else if (tmp0_subject.equals(CompositeMode_DESTINATION_OUT_getInstance())) {
      tmp = 'destination-out';
    } else if (tmp0_subject.equals(CompositeMode_SOURCE_ATOP_getInstance())) {
      tmp = 'source-atop';
    } else if (tmp0_subject.equals(CompositeMode_DESTINATION_ATOP_getInstance())) {
      tmp = 'destination-atop';
    } else if (tmp0_subject.equals(CompositeMode_XOR_getInstance())) {
      tmp = 'xor';
    } else if (tmp0_subject.equals(CompositeMode_LIGHTER_getInstance())) {
      tmp = 'lighter';
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CanvasContext2dRenderer.prototype.toJsStr_1 = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(BlendMode_NORMAL_getInstance())) {
      tmp = 'normal';
    } else if (tmp0_subject.equals(BlendMode_MULTIPLY_getInstance())) {
      tmp = 'multiply';
    } else if (tmp0_subject.equals(BlendMode_SCREEN_getInstance())) {
      tmp = 'screen';
    } else if (tmp0_subject.equals(BlendMode_OVERLAY_getInstance())) {
      tmp = 'overlay';
    } else if (tmp0_subject.equals(BlendMode_DARKEN_getInstance())) {
      tmp = 'darken';
    } else if (tmp0_subject.equals(BlendMode_LIGHTEN_getInstance())) {
      tmp = 'lighten';
    } else if (tmp0_subject.equals(BlendMode_COLOR_DODGE_getInstance())) {
      tmp = 'color-dodge';
    } else if (tmp0_subject.equals(BlendMode_COLOR_BURN_getInstance())) {
      tmp = 'color-burn';
    } else if (tmp0_subject.equals(BlendMode_HARD_LIGHT_getInstance())) {
      tmp = 'hard-light';
    } else if (tmp0_subject.equals(BlendMode_SOFT_LIGHT_getInstance())) {
      tmp = 'soft-light';
    } else if (tmp0_subject.equals(BlendMode_DIFFERENCE_getInstance())) {
      tmp = 'difference';
    } else if (tmp0_subject.equals(BlendMode_EXCLUSION_getInstance())) {
      tmp = 'exclusion';
    } else if (tmp0_subject.equals(BlendMode_HUE_getInstance())) {
      tmp = 'hue';
    } else if (tmp0_subject.equals(BlendMode_SATURATION_getInstance())) {
      tmp = 'saturation';
    } else if (tmp0_subject.equals(BlendMode_COLOR_getInstance())) {
      tmp = 'color';
    } else if (tmp0_subject.equals(BlendMode_LUMINOSITY_getInstance())) {
      tmp = 'luminosity';
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CanvasContext2dRenderer.prototype.toJsStr_2 = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject instanceof CompositeMode) {
      tmp = this.toJsStr_0(_this__0);
    } else {
      if (tmp0_subject instanceof BlendMode) {
        tmp = this.toJsStr_1(_this__0);
      } else {
        {
          tmp = 'source-over';
        }
      }
    }
    return tmp;
  };
  CanvasContext2dRenderer.prototype.drawImage_3 = function (image, x, y, width, height, transform) {
    this._ctx_1.save();
    try {
      this._ctx_1.setTransform(transform._a, transform._b, transform._c, transform._d, transform._tx, transform._ty);
      var tmp = ensureNative(image);
      var tmp0_unsafeCast_0 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE())._texSource;
      this._ctx_1.drawImage(tmp0_unsafeCast_0, x, y, width, height);
    }finally {
      this._ctx_1.restore();
    }
  };
  CanvasContext2dRenderer.prototype.render_1 = function (state, fill_3) {
    if (isEmpty(state._path_24))
      return Unit_getInstance();
    var tmp$ret$0;
    l$ret$1: do {
      this._ctx_1.save();
      try {
        setState(this, state, fill_3, false);
        this._ctx_1.beginPath();
        var tmp0_visitCmds_0_2 = state._path_24;
        var n_1_3 = 0;
        var tmp0_fastForEach_0_2_4 = tmp0_visitCmds_0_2._commands;
        var n_1_3_5 = 0;
        while (n_1_3_5 < tmp0_fastForEach_0_2_4._get_size__60()) {
          var tmp0_2_5_7 = n_1_3_5;
          n_1_3_5 = tmp0_2_5_7 + 1 | 0;
          var tmp1__anonymous__3_4_6 = tmp0_fastForEach_0_2_4.getAt_0(tmp0_2_5_7);
          var tmp0_subject_4_6_8 = tmp1__anonymous__3_4_6;
          switch (tmp0_subject_4_6_8) {
            case 0:
              var tmp1_5_7_10 = n_1_3;
              n_1_3 = tmp1_5_7_10 + 1 | 0;
              var tmp1__anonymous__21_9 = tmp0_visitCmds_0_2._data_37.get_137(tmp1_5_7_10);
              var tmp2_6_8_12 = n_1_3;
              n_1_3 = tmp2_6_8_12 + 1 | 0;
              var tmp2__anonymous__21_11 = tmp0_visitCmds_0_2._data_37.get_137(tmp2_6_8_12);
              this._ctx_1.moveTo(tmp1__anonymous__21_9, tmp2__anonymous__21_11);
              break;
            case 1:
              var tmp3_7_9_14 = n_1_3;
              n_1_3 = tmp3_7_9_14 + 1 | 0;
              var tmp3__anonymous__22_13 = tmp0_visitCmds_0_2._data_37.get_137(tmp3_7_9_14);
              var tmp4_8_10_16 = n_1_3;
              n_1_3 = tmp4_8_10_16 + 1 | 0;
              var tmp4__anonymous__22_15 = tmp0_visitCmds_0_2._data_37.get_137(tmp4_8_10_16);
              this._ctx_1.lineTo(tmp3__anonymous__22_13, tmp4__anonymous__22_15);
              break;
            case 2:
              var tmp5_9_11_18 = n_1_3;
              n_1_3 = tmp5_9_11_18 + 1 | 0;
              var tmp5__anonymous__23_17 = tmp0_visitCmds_0_2._data_37.get_137(tmp5_9_11_18);
              var tmp6_10_12_20 = n_1_3;
              n_1_3 = tmp6_10_12_20 + 1 | 0;
              var tmp6__anonymous__23_19 = tmp0_visitCmds_0_2._data_37.get_137(tmp6_10_12_20);
              var tmp7_11_13_22 = n_1_3;
              n_1_3 = tmp7_11_13_22 + 1 | 0;
              var tmp7__anonymous__23_21 = tmp0_visitCmds_0_2._data_37.get_137(tmp7_11_13_22);
              var tmp8_12_14_24 = n_1_3;
              n_1_3 = tmp8_12_14_24 + 1 | 0;
              var tmp8__anonymous__23_23 = tmp0_visitCmds_0_2._data_37.get_137(tmp8_12_14_24);
              this._ctx_1.quadraticCurveTo(tmp5__anonymous__23_17, tmp6__anonymous__23_19, tmp7__anonymous__23_21, tmp8__anonymous__23_23);
              break;
            case 3:
              var tmp9_13_15_26 = n_1_3;
              n_1_3 = tmp9_13_15_26 + 1 | 0;
              var tmp9__anonymous__24_25 = tmp0_visitCmds_0_2._data_37.get_137(tmp9_13_15_26);
              var tmp10_14_16_28 = n_1_3;
              n_1_3 = tmp10_14_16_28 + 1 | 0;
              var tmp10__anonymous__24_27 = tmp0_visitCmds_0_2._data_37.get_137(tmp10_14_16_28);
              var tmp11_15_17_30 = n_1_3;
              n_1_3 = tmp11_15_17_30 + 1 | 0;
              var tmp11__anonymous__24_29 = tmp0_visitCmds_0_2._data_37.get_137(tmp11_15_17_30);
              var tmp12_16_18_32 = n_1_3;
              n_1_3 = tmp12_16_18_32 + 1 | 0;
              var tmp12__anonymous__24_31 = tmp0_visitCmds_0_2._data_37.get_137(tmp12_16_18_32);
              var tmp13_17_19_34 = n_1_3;
              n_1_3 = tmp13_17_19_34 + 1 | 0;
              var tmp13__anonymous__24_33 = tmp0_visitCmds_0_2._data_37.get_137(tmp13_17_19_34);
              var tmp14_18_20_36 = n_1_3;
              n_1_3 = tmp14_18_20_36 + 1 | 0;
              var tmp14__anonymous__24_35 = tmp0_visitCmds_0_2._data_37.get_137(tmp14_18_20_36);
              this._ctx_1.bezierCurveTo(tmp9__anonymous__24_25, tmp10__anonymous__24_27, tmp11__anonymous__24_29, tmp12__anonymous__24_31, tmp13__anonymous__24_33, tmp14__anonymous__24_35);
              break;
            case 4:
              this._ctx_1.closePath();
              break;
          }
        }
        var m_37 = state._transform_6;
        this._ctx_1.transform(m_37._a, m_37._b, m_37._c, m_37._d, m_37._tx, m_37._ty);
        var tmp;
        if (fill_3) {
          transformPaint(this, state._fillStyle);
          tmp = this._ctx_1.fill(this.toCanvasFillRule(state._path_24._get_winding__0()));
        } else {
          transformPaint(this, state._strokeStyle);
          tmp = this._ctx_1.stroke();
        }
        tmp$ret$0 = tmp;
        break l$ret$1;
      }finally {
        this._ctx_1.restore();
      }
    }
     while (false);
  };
  CanvasContext2dRenderer.prototype.toCanvasFillRule = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(Winding_NON_ZERO_getInstance())) {
      var tmp0__get_NONZERO__0 = null;
      var tmp0_asDynamic_0_2 = 'nonzero';
      var tmp1_unsafeCast_0_1 = tmp0_asDynamic_0_2;
      tmp = tmp1_unsafeCast_0_1;
    } else if (tmp0_subject.equals(Winding_EVEN_ODD_getInstance())) {
      var tmp1__get_EVENODD__0 = null;
      var tmp0_asDynamic_0_2_0 = 'evenodd';
      var tmp1_unsafeCast_0_1_0 = tmp0_asDynamic_0_2_0;
      tmp = tmp1_unsafeCast_0_1_0;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  CanvasContext2dRenderer.$metadata$ = {
    simpleName: 'CanvasContext2dRenderer',
    kind: 'class',
    interfaces: []
  };
  function bswap32_0(v) {
    return (v >>> 24 | v << 24 | (v & 65280) << 8 | v >>> 8) & 65280;
  }
  function _no_name_provided__255() {
  }
  _no_name_provided__255.prototype.invoke_1005 = function () {
    var tmp0_set_0 = tempI;
    var tmp1_set_0 = 0;
    var tmp2_set_0 = 1;
    tmp0_set_0[tmp1_set_0] = tmp2_set_0;
    var tmp3_get_0 = temp8;
    var tmp4_get_0 = 0;
    return tmp3_get_0[tmp4_get_0] === 1;
  };
  _no_name_provided__255.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function isLittleEndian$factory() {
    return getPropertyCallableRef('isLittleEndian', 0, KProperty0, function () {
      return _get_isLittleEndian_();
    }, null);
  }
  function formats$factory() {
    return getPropertyCallableRef('formats', 1, KProperty1, function (receiver) {
      return receiver._get_formats__1();
    }, null);
  }
  function lazyCanvasElement$factory() {
    return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
      return receiver._get_lazyCanvasElement_();
    }, null);
  }
  function ctx$factory() {
    return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
      return receiver._get_ctx_();
    }, null);
  }
  function _no_name_provided_$factory_208() {
    var i = new _no_name_provided__255();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_209() {
    var i = new _no_name_provided__250();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_210(this$0, $width, $height) {
    var i = new _no_name_provided__251(this$0, $width, $height);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_211(this$0) {
    var i = new _no_name_provided__252(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_212($img_5, $cancellable_2_2) {
    var i = new _no_name_provided__253($img_5, $cancellable_2_2);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_213($jsUrl, $cancellable_2_2) {
    var i = new _no_name_provided__254($jsUrl, $cancellable_2_2);
    return function (p1, p2, p3, p4, p5) {
      i.invoke_435(p1, p2, p3, p4, p5);
      return Unit_getInstance();
    };
  }
  function nativeImageFormatProvider$init$() {
    return OS_getInstance()._get_isJsNodeJs_() ? NodeJsNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
  }
  function IKmlGl() {
  }
  IKmlGl.prototype.enableDisable_1 = function (cap, enable) {
    if (enable)
      this.enable_2(cap);
    else
      this.disable_2(cap);
  };
  IKmlGl.$metadata$ = {
    simpleName: 'IKmlGl',
    kind: 'interface',
    interfaces: []
  };
  function putAsciiString(_this_, str) {
    var n = 0;
    var indexedObject = str;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var c = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0__get_size__0 = _this_._mem;
      if (tmp0__get_size__0.byteLength >= n) {
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        _this_.setByte(tmp1, c.toByte_6());
      } else {
      }
    }
    var tmp1__get_size__0 = _this_._mem;
    if (tmp1__get_size__0.byteLength >= n) {
      var tmp2 = n;
      n = tmp2 + 1 | 0;
      _this_.setByte(tmp2, 0);
    } else {
    }
    return _this_;
  }
  function toAsciiString(_this_) {
    var out = '';
    var inductionVariable = 0;
    var tmp0__get_size__0 = _this_._mem;
    var last_1 = tmp0__get_size__0.byteLength;
    if (inductionVariable < last_1)
      $l$break: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b = _this_.getByte(n);
        if (b === 0)
          break $l$break;
        out = out + numberToChar(b);
      }
       while (inductionVariable < last_1);
    return out;
  }
  function _no_name_provided__256() {
  }
  _no_name_provided__256.prototype.invoke_1005 = function () {
    return null;
  };
  _no_name_provided__256.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ContextInfo() {
    var tmp = this;
    tmp._current = _no_name_provided_$factory_214();
  }
  ContextInfo.prototype.toString = function () {
    return '' + 'current=' + this._current();
  };
  ContextInfo.$metadata$ = {
    simpleName: 'ContextInfo',
    kind: 'class',
    interfaces: []
  };
  function KmlGl() {
    var tmp = this;
    tmp._$$delegate_0_13 = Mixin_init_$Create$(null, 1, null);
    this._info_0 = new ContextInfo();
    this._DEPTH_BUFFER_BIT = 256;
    this._STENCIL_BUFFER_BIT = 1024;
    this._COLOR_BUFFER_BIT = 16384;
    this._GFALSE = 0;
    this._GTRUE = 1;
    this._POINTS = 0;
    this._LINES = 1;
    this._LINE_LOOP = 2;
    this._LINE_STRIP = 3;
    this._TRIANGLES = 4;
    this._TRIANGLE_STRIP = 5;
    this._TRIANGLE_FAN = 6;
    this._ZERO_3 = 0;
    this._ONE_0 = 1;
    this._SRC_COLOR = 768;
    this._ONE_MINUS_SRC_COLOR = 769;
    this._SRC_ALPHA = 770;
    this._ONE_MINUS_SRC_ALPHA = 771;
    this._DST_ALPHA = 772;
    this._ONE_MINUS_DST_ALPHA = 773;
    this._DST_COLOR = 774;
    this._ONE_MINUS_DST_COLOR = 775;
    this._SRC_ALPHA_SATURATE = 776;
    this._FUNC_ADD = 32774;
    this._BLEND_EQUATION = 32777;
    this._BLEND_EQUATION_RGB = 32777;
    this._BLEND_EQUATION_ALPHA = 34877;
    this._FUNC_SUBTRACT = 32778;
    this._FUNC_REVERSE_SUBTRACT = 32779;
    this._BLEND_DST_RGB = 32968;
    this._BLEND_SRC_RGB = 32969;
    this._BLEND_DST_ALPHA = 32970;
    this._BLEND_SRC_ALPHA = 32971;
    this._CONSTANT_COLOR = 32769;
    this._ONE_MINUS_CONSTANT_COLOR = 32770;
    this._CONSTANT_ALPHA = 32771;
    this._ONE_MINUS_CONSTANT_ALPHA = 32772;
    this._BLEND_COLOR = 32773;
    this._ARRAY_BUFFER = 34962;
    this._ELEMENT_ARRAY_BUFFER = 34963;
    this._ARRAY_BUFFER_BINDING = 34964;
    this._ELEMENT_ARRAY_BUFFER_BINDING = 34965;
    this._STREAM_DRAW = 35040;
    this._STATIC_DRAW = 35044;
    this._DYNAMIC_DRAW = 35048;
    this._BUFFER_SIZE = 34660;
    this._BUFFER_USAGE = 34661;
    this._CURRENT_VERTEX_ATTRIB = 34342;
    this._FRONT = 1028;
    this._BACK = 1029;
    this._FRONT_AND_BACK = 1032;
    this._TEXTURE_2D = 3553;
    this._TEXTURE_3D = 32879;
    this._CULL_FACE = 2884;
    this._BLEND = 3042;
    this._DITHER = 3024;
    this._STENCIL_TEST = 2960;
    this._DEPTH_TEST = 2929;
    this._SCISSOR_TEST = 3089;
    this._POLYGON_OFFSET_FILL = 32823;
    this._SAMPLE_ALPHA_TO_COVERAGE = 32926;
    this._SAMPLE_COVERAGE = 32928;
    this._NO_ERROR = 0;
    this._INVALID_ENUM = 1280;
    this._INVALID_VALUE_0 = 1281;
    this._INVALID_OPERATION = 1282;
    this._OUT_OF_MEMORY = 1285;
    this._CW = 2304;
    this._CCW = 2305;
    this._LINE_WIDTH = 2849;
    this._ALIASED_POINT_SIZE_RANGE = 33901;
    this._ALIASED_LINE_WIDTH_RANGE = 33902;
    this._CULL_FACE_MODE = 2885;
    this._FRONT_FACE = 2886;
    this._DEPTH_RANGE = 2928;
    this._DEPTH_WRITEMASK = 2930;
    this._DEPTH_CLEAR_VALUE = 2931;
    this._DEPTH_FUNC = 2932;
    this._STENCIL_CLEAR_VALUE = 2961;
    this._STENCIL_FUNC = 2962;
    this._STENCIL_FAIL = 2964;
    this._STENCIL_PASS_DEPTH_FAIL = 2965;
    this._STENCIL_PASS_DEPTH_PASS = 2966;
    this._STENCIL_REF = 2967;
    this._STENCIL_VALUE_MASK = 2963;
    this._STENCIL_WRITEMASK = 2968;
    this._STENCIL_BACK_FUNC = 34816;
    this._STENCIL_BACK_FAIL = 34817;
    this._STENCIL_BACK_PASS_DEPTH_FAIL = 34818;
    this._STENCIL_BACK_PASS_DEPTH_PASS = 34819;
    this._STENCIL_BACK_REF = 36003;
    this._STENCIL_BACK_VALUE_MASK = 36004;
    this._STENCIL_BACK_WRITEMASK = 36005;
    this._VIEWPORT = 2978;
    this._SCISSOR_BOX = 3088;
    this._COLOR_CLEAR_VALUE = 3106;
    this._COLOR_WRITEMASK = 3107;
    this._UNPACK_ALIGNMENT = 3317;
    this._PACK_ALIGNMENT = 3333;
    this._MAX_TEXTURE_SIZE = 3379;
    this._MAX_VIEWPORT_DIMS = 3386;
    this._SUBPIXEL_BITS = 3408;
    this._RED_BITS = 3410;
    this._GREEN_BITS = 3411;
    this._BLUE_BITS = 3412;
    this._ALPHA_BITS = 3413;
    this._DEPTH_BITS = 3414;
    this._STENCIL_BITS = 3415;
    this._POLYGON_OFFSET_UNITS = 10752;
    this._POLYGON_OFFSET_FACTOR = 32824;
    this._TEXTURE_BINDING_2D = 32873;
    this._SAMPLE_BUFFERS = 32936;
    this._SAMPLES = 32937;
    this._SAMPLE_COVERAGE_VALUE = 32938;
    this._SAMPLE_COVERAGE_INVERT = 32939;
    this._NUM_COMPRESSED_TEXTURE_FORMATS = 34466;
    this._COMPRESSED_TEXTURE_FORMATS = 34467;
    this._DONT_CARE = 4352;
    this._FASTEST = 4353;
    this._NICEST = 4354;
    this._GENERATE_MIPMAP_HINT = 33170;
    this._BYTE = 5120;
    this._UNSIGNED_BYTE = 5121;
    this._SHORT = 5122;
    this._UNSIGNED_SHORT = 5123;
    this._INT = 5124;
    this._UNSIGNED_INT = 5125;
    this._FLOAT = 5126;
    this._FIXED = 5132;
    this._DEPTH_COMPONENT = 6402;
    this._ALPHA = 6406;
    this._RGB = 6407;
    this._RGBA = 6408;
    this._LUMINANCE = 6409;
    this._LUMINANCE_ALPHA = 6410;
    this._UNSIGNED_SHORT_4_4_4_4 = 32819;
    this._UNSIGNED_SHORT_5_5_5_1 = 32820;
    this._UNSIGNED_SHORT_5_6_5 = 33635;
    this._FRAGMENT_SHADER = 35632;
    this._VERTEX_SHADER = 35633;
    this._MAX_VERTEX_ATTRIBS = 34921;
    this._MAX_VERTEX_UNIFORM_VECTORS = 36347;
    this._MAX_VARYING_VECTORS = 36348;
    this._MAX_COMBINED_TEXTURE_IMAGE_UNITS = 35661;
    this._MAX_VERTEX_TEXTURE_IMAGE_UNITS = 35660;
    this._MAX_TEXTURE_IMAGE_UNITS = 34930;
    this._MAX_FRAGMENT_UNIFORM_VECTORS = 36349;
    this._SHADER_TYPE = 35663;
    this._DELETE_STATUS = 35712;
    this._LINK_STATUS = 35714;
    this._VALIDATE_STATUS = 35715;
    this._ATTACHED_SHADERS = 35717;
    this._ACTIVE_UNIFORMS = 35718;
    this._ACTIVE_UNIFORM_MAX_LENGTH = 35719;
    this._ACTIVE_ATTRIBUTES = 35721;
    this._ACTIVE_ATTRIBUTE_MAX_LENGTH = 35722;
    this._SHADING_LANGUAGE_VERSION = 35724;
    this._CURRENT_PROGRAM = 35725;
    this._NEVER = 512;
    this._LESS = 513;
    this._EQUAL = 514;
    this._LEQUAL = 515;
    this._GREATER = 516;
    this._NOTEQUAL = 517;
    this._GEQUAL = 518;
    this._ALWAYS = 519;
    this._KEEP = 7680;
    this._REPLACE = 7681;
    this._INCR = 7682;
    this._DECR = 7683;
    this._INVERT = 5386;
    this._INCR_WRAP = 34055;
    this._DECR_WRAP = 34056;
    this._VENDOR = 7936;
    this._RENDERER = 7937;
    this._VERSION = 7938;
    this._EXTENSIONS = 7939;
    this._NEAREST = 9728;
    this._LINEAR = 9729;
    this._NEAREST_MIPMAP_NEAREST = 9984;
    this._LINEAR_MIPMAP_NEAREST = 9985;
    this._NEAREST_MIPMAP_LINEAR = 9986;
    this._LINEAR_MIPMAP_LINEAR = 9987;
    this._TEXTURE_MAG_FILTER = 10240;
    this._TEXTURE_MIN_FILTER = 10241;
    this._TEXTURE_WRAP_S = 10242;
    this._TEXTURE_WRAP_T = 10243;
    this._TEXTURE_WRAP_R = 32882;
    this._TEXTURE = 5890;
    this._TEXTURE_CUBE_MAP = 34067;
    this._TEXTURE_BINDING_CUBE_MAP = 34068;
    this._TEXTURE_CUBE_MAP_POSITIVE_X = 34069;
    this._TEXTURE_CUBE_MAP_NEGATIVE_X = 34070;
    this._TEXTURE_CUBE_MAP_POSITIVE_Y = 34071;
    this._TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072;
    this._TEXTURE_CUBE_MAP_POSITIVE_Z = 34073;
    this._TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074;
    this._MAX_CUBE_MAP_TEXTURE_SIZE = 34076;
    this._TEXTURE0 = 33984;
    this._TEXTURE1 = 33985;
    this._TEXTURE2 = 33986;
    this._TEXTURE3 = 33987;
    this._TEXTURE4 = 33988;
    this._TEXTURE5 = 33989;
    this._TEXTURE6 = 33990;
    this._TEXTURE7 = 33991;
    this._TEXTURE8 = 33992;
    this._TEXTURE9 = 33993;
    this._TEXTURE10 = 33994;
    this._TEXTURE11 = 33995;
    this._TEXTURE12 = 33996;
    this._TEXTURE13 = 33997;
    this._TEXTURE14 = 33998;
    this._TEXTURE15 = 33999;
    this._TEXTURE16 = 34000;
    this._TEXTURE17 = 34001;
    this._TEXTURE18 = 34002;
    this._TEXTURE19 = 34003;
    this._TEXTURE20 = 34004;
    this._TEXTURE21 = 34005;
    this._TEXTURE22 = 34006;
    this._TEXTURE23 = 34007;
    this._TEXTURE24 = 34008;
    this._TEXTURE25 = 34009;
    this._TEXTURE26 = 34010;
    this._TEXTURE27 = 34011;
    this._TEXTURE28 = 34012;
    this._TEXTURE29 = 34013;
    this._TEXTURE30 = 34014;
    this._TEXTURE31 = 34015;
    this._ACTIVE_TEXTURE = 34016;
    this._REPEAT = 10497;
    this._CLAMP_TO_EDGE = 33071;
    this._MIRRORED_REPEAT = 33648;
    this._FLOAT_VEC2 = 35664;
    this._FLOAT_VEC3 = 35665;
    this._FLOAT_VEC4 = 35666;
    this._INT_VEC2 = 35667;
    this._INT_VEC3 = 35668;
    this._INT_VEC4 = 35669;
    this._BOOL = 35670;
    this._BOOL_VEC2 = 35671;
    this._BOOL_VEC3 = 35672;
    this._BOOL_VEC4 = 35673;
    this._FLOAT_MAT2 = 35674;
    this._FLOAT_MAT3 = 35675;
    this._FLOAT_MAT4 = 35676;
    this._SAMPLER_2D = 35678;
    this._SAMPLER_CUBE = 35680;
    this._VERTEX_ATTRIB_ARRAY_ENABLED = 34338;
    this._VERTEX_ATTRIB_ARRAY_SIZE = 34339;
    this._VERTEX_ATTRIB_ARRAY_STRIDE = 34340;
    this._VERTEX_ATTRIB_ARRAY_TYPE = 34341;
    this._VERTEX_ATTRIB_ARRAY_NORMALIZED = 34922;
    this._VERTEX_ATTRIB_ARRAY_POINTER = 34373;
    this._VERTEX_ATTRIB_ARRAY_BUFFER_BINDING = 34975;
    this._IMPLEMENTATION_COLOR_READ_TYPE = 35738;
    this._IMPLEMENTATION_COLOR_READ_FORMAT = 35739;
    this._COMPILE_STATUS = 35713;
    this._INFO_LOG_LENGTH = 35716;
    this._SHADER_SOURCE_LENGTH = 35720;
    this._SHADER_COMPILER = 36346;
    this._SHADER_BINARY_FORMATS = 36344;
    this._NUM_SHADER_BINARY_FORMATS = 36345;
    this._LOW_FLOAT = 36336;
    this._MEDIUM_FLOAT = 36337;
    this._HIGH_FLOAT = 36338;
    this._LOW_INT = 36339;
    this._MEDIUM_INT = 36340;
    this._HIGH_INT = 36341;
    this._FRAMEBUFFER = 36160;
    this._RENDERBUFFER = 36161;
    this._RGBA4 = 32854;
    this._RGB5_A1 = 32855;
    this._RGB565 = 36194;
    this._DEPTH_COMPONENT16 = 33189;
    this._STENCIL_INDEX8 = 36168;
    this._RENDERBUFFER_WIDTH = 36162;
    this._RENDERBUFFER_HEIGHT = 36163;
    this._RENDERBUFFER_INTERNAL_FORMAT = 36164;
    this._RENDERBUFFER_RED_SIZE = 36176;
    this._RENDERBUFFER_GREEN_SIZE = 36177;
    this._RENDERBUFFER_BLUE_SIZE = 36178;
    this._RENDERBUFFER_ALPHA_SIZE = 36179;
    this._RENDERBUFFER_DEPTH_SIZE = 36180;
    this._RENDERBUFFER_STENCIL_SIZE = 36181;
    this._FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE = 36048;
    this._FRAMEBUFFER_ATTACHMENT_OBJECT_NAME = 36049;
    this._FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL = 36050;
    this._FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE = 36051;
    this._COLOR_ATTACHMENT0 = 36064;
    this._DEPTH_ATTACHMENT = 36096;
    this._STENCIL_ATTACHMENT = 36128;
    this._NONE = 0;
    this._FRAMEBUFFER_COMPLETE = 36053;
    this._FRAMEBUFFER_INCOMPLETE_ATTACHMENT = 36054;
    this._FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = 36055;
    this._FRAMEBUFFER_INCOMPLETE_DIMENSIONS = 36057;
    this._FRAMEBUFFER_UNSUPPORTED = 36061;
    this._FRAMEBUFFER_BINDING = 36006;
    this._RENDERBUFFER_BINDING = 36007;
    this._MAX_RENDERBUFFER_SIZE = 34024;
    this._INVALID_FRAMEBUFFER_OPERATION = 1286;
  }
  KmlGl.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_13._extra = _set___;
  };
  KmlGl.prototype._get_extra__71 = function () {
    return this._$$delegate_0_13._extra;
  };
  KmlGl.prototype._get_root__33 = function () {
    return this;
  };
  KmlGl.prototype._get_INFO_LOG_LENGTH__0 = function () {
    return this._INFO_LOG_LENGTH;
  };
  KmlGl.$metadata$ = {
    simpleName: 'KmlGl',
    kind: 'class',
    interfaces: [Extra, IKmlGl]
  };
  function _no_name_provided_$factory_214() {
    var i = new _no_name_provided__256();
    return function () {
      return i.invoke_1005();
    };
  }
  function getIntegerv(_this_, pname) {
    var tmp0_fbuffer_0 = 4;
    var tmp0_run_0_1 = Companion_getInstance_38().invoke_874(tmp0_fbuffer_0);
    _this_.getIntegerv_0(pname, tmp0_run_0_1);
    return tmp0_run_0_1.getInt(0);
  }
  function getShaderiv(_this_, shader, type) {
    var tmp0_fbuffer_0 = 4;
    var tmp0_run_0_1 = Companion_getInstance_38().invoke_874(tmp0_fbuffer_0);
    _this_.getShaderiv_0(shader, type, tmp0_run_0_1);
    return tmp0_run_0_1.getInt(0);
  }
  function getShaderInfoLog(_this_, shader) {
    var size_1 = getShaderiv(_this_, shader, _this_._INFO_LOG_LENGTH);
    var tmp0_fbuffer_0 = 4;
    var tmp0_run_0_1 = Companion_getInstance_38().invoke_874(tmp0_fbuffer_0);
    var tmp0_run_0_1_3 = Companion_getInstance_38().invoke_874(size_1);
    _this_.getShaderInfoLog_1(shader, size_1, tmp0_run_0_1, tmp0_run_0_1_3);
    return toAsciiString(tmp0_run_0_1_3);
  }
  function min2_7(a, b) {
    return a < b ? a : b;
  }
  var BlendEquation_ADD_instance;
  var BlendEquation_SUBTRACT_instance;
  var BlendEquation_REVERSE_SUBTRACT_instance;
  var BlendEquation_entriesInitialized;
  function BlendEquation_initEntries() {
    if (BlendEquation_entriesInitialized)
      return Unit_getInstance();
    BlendEquation_entriesInitialized = true;
    BlendEquation_ADD_instance = new BlendEquation('ADD', 0);
    BlendEquation_SUBTRACT_instance = new BlendEquation('SUBTRACT', 1);
    BlendEquation_REVERSE_SUBTRACT_instance = new BlendEquation('REVERSE_SUBTRACT', 2);
  }
  var BlendFactor_DESTINATION_ALPHA_instance;
  var BlendFactor_DESTINATION_COLOR_instance;
  var BlendFactor_ONE_instance;
  var BlendFactor_ONE_MINUS_DESTINATION_ALPHA_instance;
  var BlendFactor_ONE_MINUS_DESTINATION_COLOR_instance;
  var BlendFactor_ONE_MINUS_SOURCE_ALPHA_instance;
  var BlendFactor_ONE_MINUS_SOURCE_COLOR_instance;
  var BlendFactor_SOURCE_ALPHA_instance;
  var BlendFactor_SOURCE_COLOR_instance;
  var BlendFactor_ZERO_instance;
  var BlendFactor_entriesInitialized;
  function BlendFactor_initEntries() {
    if (BlendFactor_entriesInitialized)
      return Unit_getInstance();
    BlendFactor_entriesInitialized = true;
    BlendFactor_DESTINATION_ALPHA_instance = new BlendFactor('DESTINATION_ALPHA', 0);
    BlendFactor_DESTINATION_COLOR_instance = new BlendFactor('DESTINATION_COLOR', 1);
    BlendFactor_ONE_instance = new BlendFactor('ONE', 2);
    BlendFactor_ONE_MINUS_DESTINATION_ALPHA_instance = new BlendFactor('ONE_MINUS_DESTINATION_ALPHA', 3);
    BlendFactor_ONE_MINUS_DESTINATION_COLOR_instance = new BlendFactor('ONE_MINUS_DESTINATION_COLOR', 4);
    BlendFactor_ONE_MINUS_SOURCE_ALPHA_instance = new BlendFactor('ONE_MINUS_SOURCE_ALPHA', 5);
    BlendFactor_ONE_MINUS_SOURCE_COLOR_instance = new BlendFactor('ONE_MINUS_SOURCE_COLOR', 6);
    BlendFactor_SOURCE_ALPHA_instance = new BlendFactor('SOURCE_ALPHA', 7);
    BlendFactor_SOURCE_COLOR_instance = new BlendFactor('SOURCE_COLOR', 8);
    BlendFactor_ZERO_instance = new BlendFactor('ZERO', 9);
  }
  function Blending_init_$Init$(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      srcA = srcRGB;
    if (!(($mask0 & 8) === 0))
      dstA = dstRGB;
    if (!(($mask0 & 16) === 0))
      eqRGB = BlendEquation_ADD_getInstance();
    if (!(($mask0 & 32) === 0))
      eqA = eqRGB;
    Blending.call($this, srcRGB, dstRGB, srcA, dstA, eqRGB, eqA);
    return $this;
  }
  function Blending_init_$Create$(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $mask0, $marker) {
    return Blending_init_$Init$(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $mask0, $marker, Object.create(Blending.prototype));
  }
  function Blending_init_$Init$_0(src, dst, eq, $this) {
    Blending.call($this, src, dst, src, dst, eq, eq);
    return $this;
  }
  function Blending_init_$Init$_1(src, dst, eq, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      eq = BlendEquation_ADD_getInstance();
    Blending_init_$Init$_0(src, dst, eq, $this);
    return $this;
  }
  function Blending_init_$Create$_0(src, dst, eq, $mask0, $marker) {
    return Blending_init_$Init$_1(src, dst, eq, $mask0, $marker, Object.create(Blending.prototype));
  }
  function Companion_122() {
    Companion_instance_121 = this;
    var tmp = this;
    var tmp_0 = BlendFactor_ONE_getInstance();
    var tmp_1 = BlendFactor_ZERO_getInstance();
    var tmp_2 = BlendFactor_ONE_getInstance();
    var tmp_3 = BlendFactor_ZERO_getInstance();
    tmp._NONE_0 = Blending_init_$Create$(tmp_0, tmp_1, tmp_2, tmp_3, null, null, 48, null);
    var tmp_4 = this;
    var tmp_5 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_6 = BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance();
    var tmp_7 = BlendFactor_ONE_getInstance();
    var tmp_8 = BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance();
    tmp_4._NORMAL = Blending_init_$Create$(tmp_5, tmp_6, tmp_7, tmp_8, null, null, 48, null);
    var tmp_9 = this;
    var tmp_10 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_11 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_12 = BlendFactor_ONE_getInstance();
    var tmp_13 = BlendFactor_ONE_getInstance();
    tmp_9._ADD = Blending_init_$Create$(tmp_10, tmp_11, tmp_12, tmp_13, null, null, 48, null);
  }
  Companion_122.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_121;
  function Companion_getInstance_121() {
    if (Companion_instance_121 == null)
      new Companion_122();
    return Companion_instance_121;
  }
  function _no_name_provided__257() {
  }
  _no_name_provided__257.prototype.invoke_1005 = function () {
    return null;
  };
  _no_name_provided__257.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_123() {
    Companion_instance_122 = this;
    var tmp = this;
    tmp._NIL_2 = new SyncBitmapSource(true, 0, 0, _no_name_provided_$factory_220());
  }
  Companion_123.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_122;
  function Companion_getInstance_122() {
    if (Companion_instance_122 == null)
      new Companion_123();
    return Companion_instance_122;
  }
  function _no_name_provided__258($bmp) {
    this._$bmp = $bmp;
  }
  _no_name_provided__258.prototype.invoke_1005 = function () {
    return this._$bmp;
  };
  _no_name_provided__258.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__259(this$0, $source, resultContinuation) {
    this._this$0_58 = this$0;
    this._$source_0 = $source;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__259.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__259.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__259.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$source_0._gen_2(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this._this$0_58._tempBitmap = ARGUMENT;
            this._this$0_58._generated = true;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__259.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__259(this._this$0_58, this._$source_0, completion);
    return i;
  };
  _no_name_provided__259.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function TextureUnit_init_$Init$(texture, linear, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      texture = null;
    if (!(($mask0 & 2) === 0))
      linear = true;
    TextureUnit.call($this, texture, linear);
    return $this;
  }
  function TextureUnit_init_$Create$(texture, linear, $mask0, $marker) {
    return TextureUnit_init_$Init$(texture, linear, $mask0, $marker, Object.create(TextureUnit.prototype));
  }
  var Kind_INDEX_instance;
  var Kind_VERTEX_instance;
  var Kind_entriesInitialized_1;
  function Kind_initEntries_1() {
    if (Kind_entriesInitialized_1)
      return Unit_getInstance();
    Kind_entriesInitialized_1 = true;
    Kind_INDEX_instance = new Kind_1('INDEX', 0);
    Kind_VERTEX_instance = new Kind_1('VERTEX', 1);
  }
  function Kind_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Kind_1.$metadata$ = {
    simpleName: 'Kind',
    kind: 'class',
    interfaces: []
  };
  function Kind_INDEX_getInstance() {
    Kind_initEntries_1();
    return Kind_INDEX_instance;
  }
  function Kind_VERTEX_getInstance() {
    Kind_initEntries_1();
    return Kind_VERTEX_instance;
  }
  var DrawType_POINTS_instance;
  var DrawType_LINE_STRIP_instance;
  var DrawType_LINE_LOOP_instance;
  var DrawType_LINES_instance;
  var DrawType_TRIANGLES_instance;
  var DrawType_TRIANGLE_STRIP_instance;
  var DrawType_TRIANGLE_FAN_instance;
  var DrawType_entriesInitialized;
  function DrawType_initEntries() {
    if (DrawType_entriesInitialized)
      return Unit_getInstance();
    DrawType_entriesInitialized = true;
    DrawType_POINTS_instance = new DrawType('POINTS', 0);
    DrawType_LINE_STRIP_instance = new DrawType('LINE_STRIP', 1);
    DrawType_LINE_LOOP_instance = new DrawType('LINE_LOOP', 2);
    DrawType_LINES_instance = new DrawType('LINES', 3);
    DrawType_TRIANGLES_instance = new DrawType('TRIANGLES', 4);
    DrawType_TRIANGLE_STRIP_instance = new DrawType('TRIANGLE_STRIP', 5);
    DrawType_TRIANGLE_FAN_instance = new DrawType('TRIANGLE_FAN', 6);
  }
  var IndexType_UBYTE_instance;
  var IndexType_USHORT_instance;
  var IndexType_UINT_instance;
  var IndexType_entriesInitialized;
  function IndexType_initEntries() {
    if (IndexType_entriesInitialized)
      return Unit_getInstance();
    IndexType_entriesInitialized = true;
    IndexType_UBYTE_instance = new IndexType('UBYTE', 0);
    IndexType_USHORT_instance = new IndexType('USHORT', 1);
    IndexType_UINT_instance = new IndexType('UINT', 2);
  }
  var StencilOp_DECREMENT_SATURATE_instance;
  var StencilOp_DECREMENT_WRAP_instance;
  var StencilOp_INCREMENT_SATURATE_instance;
  var StencilOp_INCREMENT_WRAP_instance;
  var StencilOp_INVERT_instance;
  var StencilOp_KEEP_instance;
  var StencilOp_SET_instance;
  var StencilOp_ZERO_instance;
  var StencilOp_entriesInitialized;
  function StencilOp_initEntries() {
    if (StencilOp_entriesInitialized)
      return Unit_getInstance();
    StencilOp_entriesInitialized = true;
    StencilOp_DECREMENT_SATURATE_instance = new StencilOp('DECREMENT_SATURATE', 0);
    StencilOp_DECREMENT_WRAP_instance = new StencilOp('DECREMENT_WRAP', 1);
    StencilOp_INCREMENT_SATURATE_instance = new StencilOp('INCREMENT_SATURATE', 2);
    StencilOp_INCREMENT_WRAP_instance = new StencilOp('INCREMENT_WRAP', 3);
    StencilOp_INVERT_instance = new StencilOp('INVERT', 4);
    StencilOp_KEEP_instance = new StencilOp('KEEP', 5);
    StencilOp_SET_instance = new StencilOp('SET', 6);
    StencilOp_ZERO_instance = new StencilOp('ZERO', 7);
  }
  var TriangleFace_FRONT_instance;
  var TriangleFace_BACK_instance;
  var TriangleFace_FRONT_AND_BACK_instance;
  var TriangleFace_NONE_instance;
  var TriangleFace_entriesInitialized;
  function TriangleFace_initEntries() {
    if (TriangleFace_entriesInitialized)
      return Unit_getInstance();
    TriangleFace_entriesInitialized = true;
    TriangleFace_FRONT_instance = new TriangleFace('FRONT', 0);
    TriangleFace_BACK_instance = new TriangleFace('BACK', 1);
    TriangleFace_FRONT_AND_BACK_instance = new TriangleFace('FRONT_AND_BACK', 2);
    TriangleFace_NONE_instance = new TriangleFace('NONE', 3);
  }
  var CompareMode_ALWAYS_instance;
  var CompareMode_EQUAL_instance;
  var CompareMode_GREATER_instance;
  var CompareMode_GREATER_EQUAL_instance;
  var CompareMode_LESS_instance;
  var CompareMode_LESS_EQUAL_instance;
  var CompareMode_NEVER_instance;
  var CompareMode_NOT_EQUAL_instance;
  var CompareMode_entriesInitialized;
  function CompareMode_initEntries() {
    if (CompareMode_entriesInitialized)
      return Unit_getInstance();
    CompareMode_entriesInitialized = true;
    CompareMode_ALWAYS_instance = new CompareMode('ALWAYS', 0);
    CompareMode_EQUAL_instance = new CompareMode('EQUAL', 1);
    CompareMode_GREATER_instance = new CompareMode('GREATER', 2);
    CompareMode_GREATER_EQUAL_instance = new CompareMode('GREATER_EQUAL', 3);
    CompareMode_LESS_instance = new CompareMode('LESS', 4);
    CompareMode_LESS_EQUAL_instance = new CompareMode('LESS_EQUAL', 5);
    CompareMode_NEVER_instance = new CompareMode('NEVER', 6);
    CompareMode_NOT_EQUAL_instance = new CompareMode('NOT_EQUAL', 7);
  }
  function ColorMaskState_init_$Init$(red, green, blue, alpha, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      red = true;
    if (!(($mask0 & 2) === 0))
      green = true;
    if (!(($mask0 & 4) === 0))
      blue = true;
    if (!(($mask0 & 8) === 0))
      alpha = true;
    ColorMaskState.call($this, red, green, blue, alpha);
    return $this;
  }
  function ColorMaskState_init_$Create$(red, green, blue, alpha, $mask0, $marker) {
    return ColorMaskState_init_$Init$(red, green, blue, alpha, $mask0, $marker, Object.create(ColorMaskState.prototype));
  }
  var FrontFace_BOTH_instance;
  var FrontFace_CW_instance;
  var FrontFace_CCW_instance;
  var FrontFace_entriesInitialized;
  function FrontFace_initEntries() {
    if (FrontFace_entriesInitialized)
      return Unit_getInstance();
    FrontFace_entriesInitialized = true;
    FrontFace_BOTH_instance = new FrontFace('BOTH', 0);
    FrontFace_CW_instance = new FrontFace('CW', 1);
    FrontFace_CCW_instance = new FrontFace('CCW', 2);
  }
  function RenderState_init_$Init$(depthFunc, depthMask, depthNear, depthFar, lineWidth, frontFace, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      depthFunc = CompareMode_ALWAYS_getInstance();
    if (!(($mask0 & 2) === 0))
      depthMask = true;
    if (!(($mask0 & 4) === 0))
      depthNear = 0.0;
    if (!(($mask0 & 8) === 0))
      depthFar = 1.0;
    if (!(($mask0 & 16) === 0))
      lineWidth = 1.0;
    if (!(($mask0 & 32) === 0))
      frontFace = FrontFace_BOTH_getInstance();
    RenderState.call($this, depthFunc, depthMask, depthNear, depthFar, lineWidth, frontFace);
    return $this;
  }
  function RenderState_init_$Create$(depthFunc, depthMask, depthNear, depthFar, lineWidth, frontFace, $mask0, $marker) {
    return RenderState_init_$Init$(depthFunc, depthMask, depthNear, depthFar, lineWidth, frontFace, $mask0, $marker, Object.create(RenderState.prototype));
  }
  function StencilState_init_$Init$(enabled, triangleFace, compareMode, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, referenceValue, readMask, writeMask, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      enabled = false;
    if (!(($mask0 & 2) === 0))
      triangleFace = TriangleFace_FRONT_AND_BACK_getInstance();
    if (!(($mask0 & 4) === 0))
      compareMode = CompareMode_ALWAYS_getInstance();
    if (!(($mask0 & 8) === 0))
      actionOnBothPass = StencilOp_KEEP_getInstance();
    if (!(($mask0 & 16) === 0))
      actionOnDepthFail = StencilOp_KEEP_getInstance();
    if (!(($mask0 & 32) === 0))
      actionOnDepthPassStencilFail = StencilOp_KEEP_getInstance();
    if (!(($mask0 & 64) === 0))
      referenceValue = 0;
    if (!(($mask0 & 128) === 0))
      readMask = 255;
    if (!(($mask0 & 256) === 0))
      writeMask = 255;
    StencilState.call($this, enabled, triangleFace, compareMode, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, referenceValue, readMask, writeMask);
    return $this;
  }
  function StencilState_init_$Create$(enabled, triangleFace, compareMode, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, referenceValue, readMask, writeMask, $mask0, $marker) {
    return StencilState_init_$Init$(enabled, triangleFace, compareMode, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, referenceValue, readMask, writeMask, $mask0, $marker, Object.create(StencilState.prototype));
  }
  function Batch_init_$Init$(vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset, blending, uniforms, stencil, colorMask, renderState, scissor, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      vertices = new Buffer(Kind_VERTEX_getInstance());
    if (!(($mask0 & 2) === 0))
      program = DefaultShaders_getInstance()._PROGRAM_DEBUG;
    if (!(($mask0 & 4) === 0))
      type = DrawType_TRIANGLES_getInstance();
    if (!(($mask0 & 8) === 0))
      vertexLayout = VertexLayout_init_$Create$([]);
    if (!(($mask0 & 16) === 0))
      vertexCount = 0;
    if (!(($mask0 & 32) === 0))
      indices = null;
    if (!(($mask0 & 64) === 0))
      indexType = IndexType_USHORT_getInstance();
    if (!(($mask0 & 128) === 0))
      offset = 0;
    if (!(($mask0 & 256) === 0))
      blending = Companion_getInstance_121()._NORMAL;
    if (!(($mask0 & 512) === 0))
      uniforms = Companion_getInstance_123()._EMPTY_5;
    if (!(($mask0 & 1024) === 0)) {
      stencil = StencilState_init_$Create$(false, null, null, null, null, null, 0, 0, 0, 511, null);
    }if (!(($mask0 & 2048) === 0)) {
      colorMask = ColorMaskState_init_$Create$(false, false, false, false, 15, null);
    }if (!(($mask0 & 4096) === 0)) {
      renderState = RenderState_init_$Create$(null, false, 0.0, 0.0, 0.0, null, 63, null);
    }if (!(($mask0 & 8192) === 0))
      scissor = null;
    Batch.call($this, vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset, blending, uniforms, stencil, colorMask, renderState, scissor);
    return $this;
  }
  function Batch_init_$Create$(vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset, blending, uniforms, stencil, colorMask, renderState, scissor, $mask0, $marker) {
    return Batch_init_$Init$(vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset, blending, uniforms, stencil, colorMask, renderState, scissor, $mask0, $marker, Object.create(Batch.prototype));
  }
  function _no_name_provided__260() {
  }
  _no_name_provided__260.prototype.invoke_664 = function ($this$VertexShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$VertexShader.setTo_7(tmp0_apply_0._v_Tex, tmp0_apply_0._a_Tex);
    $this$VertexShader.setTo_7($this$VertexShader._out_8, $this$VertexShader.vec4([tmp0_apply_0._a_Pos, $this$VertexShader._get_lit_(0.0), $this$VertexShader._get_lit_(1.0)]));
    Unit_getInstance();
  };
  _no_name_provided__260.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__260.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__261() {
  }
  _no_name_provided__261.prototype.invoke_664 = function ($this$FragmentShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$FragmentShader.setTo_7($this$FragmentShader._out_8, $this$FragmentShader.texture2D(tmp0_apply_0._u_Tex, $this$FragmentShader.get_96(tmp0_apply_0._v_Tex, 'xy')));
    Unit_getInstance();
  };
  _no_name_provided__261.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__261.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_124() {
    Companion_instance_123 = this;
    this._EMPTY_5 = new UniformValues();
  }
  Companion_124.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_123;
  function Companion_getInstance_123() {
    if (Companion_instance_123 == null)
      new Companion_124();
    return Companion_instance_123;
  }
  function UniformValues_init_$Init$(pairs, $this) {
    UniformValues.call($this);
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var pair = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      $this.put_16(pair._first, pair._second);
      Unit_getInstance();
    }
    return $this;
  }
  function UniformValues_init_$Create$(pairs) {
    return UniformValues_init_$Init$(pairs, Object.create(UniformValues.prototype));
  }
  function BlendEquation(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  BlendEquation.$metadata$ = {
    simpleName: 'BlendEquation',
    kind: 'class',
    interfaces: []
  };
  function BlendFactor(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  BlendFactor.$metadata$ = {
    simpleName: 'BlendFactor',
    kind: 'class',
    interfaces: []
  };
  function Scissor(x, y, width, height) {
    this._x_10 = x;
    this._y_9 = y;
    this._width_9 = width;
    this._height_9 = height;
    this._rect_0 = Companion_getInstance_83().invoke_1005();
  }
  Scissor.prototype._get_top__4 = function () {
    return this._y_9;
  };
  Scissor.prototype._get_left__4 = function () {
    return this._x_10;
  };
  Scissor.prototype._get_right__2 = function () {
    return this._x_10 + this._width_9 | 0;
  };
  Scissor.prototype._get_bottom__2 = function () {
    return this._y_9 + this._height_9 | 0;
  };
  Scissor.prototype.setTo_6 = function (x, y, width, height) {
    this._x_10 = x;
    this._y_9 = y;
    this._width_9 = width;
    this._height_9 = height;
    return this;
  };
  Scissor.prototype.toString = function () {
    return '' + 'Scissor(x=' + this._x_10 + ', y=' + this._y_9 + ', width=' + this._width_9 + ', height=' + this._height_9 + ')';
  };
  Scissor.prototype.hashCode = function () {
    var result = this._x_10;
    result = imul(result, 31) + this._y_9 | 0;
    result = imul(result, 31) + this._width_9 | 0;
    result = imul(result, 31) + this._height_9 | 0;
    return result;
  };
  Scissor.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Scissor))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Scissor ? other : THROW_CCE();
    if (!(this._x_10 === tmp0_other_with_cast._x_10))
      return false;
    if (!(this._y_9 === tmp0_other_with_cast._y_9))
      return false;
    if (!(this._width_9 === tmp0_other_with_cast._width_9))
      return false;
    if (!(this._height_9 === tmp0_other_with_cast._height_9))
      return false;
    return true;
  };
  Scissor.$metadata$ = {
    simpleName: 'Scissor',
    kind: 'class',
    interfaces: []
  };
  function Blending(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    Companion_getInstance_121();
    this._srcRGB = srcRGB;
    this._dstRGB = dstRGB;
    this._srcA = srcA;
    this._dstA = dstA;
    this._eqRGB = eqRGB;
    this._eqA = eqA;
  }
  Blending.prototype._get_disabled_ = function () {
    return ((this._srcRGB.equals(BlendFactor_ONE_getInstance()) ? this._dstRGB.equals(BlendFactor_ZERO_getInstance()) : false) ? this._srcA.equals(BlendFactor_ONE_getInstance()) : false) ? this._dstA.equals(BlendFactor_ZERO_getInstance()) : false;
  };
  Blending.prototype._get_enabled__3 = function () {
    return !this._get_disabled_();
  };
  Blending.prototype.toString = function () {
    return '' + 'Blending(srcRGB=' + this._srcRGB + ', dstRGB=' + this._dstRGB + ', srcA=' + this._srcA + ', dstA=' + this._dstA + ', eqRGB=' + this._eqRGB + ', eqA=' + this._eqA + ')';
  };
  Blending.prototype.hashCode = function () {
    var result = this._srcRGB.hashCode();
    result = imul(result, 31) + this._dstRGB.hashCode() | 0;
    result = imul(result, 31) + this._srcA.hashCode() | 0;
    result = imul(result, 31) + this._dstA.hashCode() | 0;
    result = imul(result, 31) + this._eqRGB.hashCode() | 0;
    result = imul(result, 31) + this._eqA.hashCode() | 0;
    return result;
  };
  Blending.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Blending))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Blending ? other : THROW_CCE();
    if (!this._srcRGB.equals(tmp0_other_with_cast._srcRGB))
      return false;
    if (!this._dstRGB.equals(tmp0_other_with_cast._dstRGB))
      return false;
    if (!this._srcA.equals(tmp0_other_with_cast._srcA))
      return false;
    if (!this._dstA.equals(tmp0_other_with_cast._dstA))
      return false;
    if (!this._eqRGB.equals(tmp0_other_with_cast._eqRGB))
      return false;
    if (!this._eqA.equals(tmp0_other_with_cast._eqA))
      return false;
    return true;
  };
  Blending.$metadata$ = {
    simpleName: 'Blending',
    kind: 'class',
    interfaces: []
  };
  function BitmapSourceBase() {
  }
  BitmapSourceBase.$metadata$ = {
    simpleName: 'BitmapSourceBase',
    kind: 'interface',
    interfaces: []
  };
  function SyncBitmapSource(rgba, width, height, gen) {
    Companion_getInstance_122();
    this._rgba = rgba;
    this._width_10 = width;
    this._height_10 = height;
    this._gen_1 = gen;
  }
  SyncBitmapSource.prototype._get_rgba__0 = function () {
    return this._rgba;
  };
  SyncBitmapSource.prototype._get_width__58 = function () {
    return this._width_10;
  };
  SyncBitmapSource.prototype._get_height__58 = function () {
    return this._height_10;
  };
  SyncBitmapSource.prototype.toString = function () {
    return '' + 'SyncBitmapSource(rgba=' + this._rgba + ', width=' + this._width_10 + ', height=' + this._height_10 + ')';
  };
  SyncBitmapSource.$metadata$ = {
    simpleName: 'SyncBitmapSource',
    kind: 'class',
    interfaces: [BitmapSourceBase]
  };
  function AsyncBitmapSource() {
  }
  AsyncBitmapSource.$metadata$ = {
    simpleName: 'AsyncBitmapSource',
    kind: 'class',
    interfaces: [BitmapSourceBase]
  };
  function Texture($outer) {
    this._$this_13 = $outer;
    this._isFbo = false;
    this._premultiplied_9 = true;
    this._requestMipmaps = false;
    this._mipmaps_4 = false;
    this._source = Companion_getInstance_122()._NIL_2;
    this._uploaded = false;
    this._generating = false;
    this._generated = false;
    this._tempBitmap = null;
    this._ready = false;
    var tmp = this;
    var tmp0_this = this._$this_13;
    var tmp1 = tmp0_this._lastTextureId;
    tmp0_this._lastTextureId = tmp1 + 1 | 0;
    tmp._texId = tmp1;
    var tmp0_this_0 = this._$this_13;
    var tmp1_0 = tmp0_this_0._createdTextureCount;
    tmp0_this_0._createdTextureCount = tmp1_0 + 1 | 0;
    Unit_getInstance();
    this._alreadyClosed = false;
  }
  Texture.prototype._get_premultiplied__8 = function () {
    return this._premultiplied_9;
  };
  Texture.prototype._set_mipmaps__0 = function (_set___) {
    this._mipmaps_4 = _set___;
  };
  Texture.prototype._get_mipmaps__0 = function () {
    return this._mipmaps_4;
  };
  Texture.prototype._get_source__0 = function () {
    return this._source;
  };
  Texture.prototype.invalidate_23 = function () {
    this._uploaded = false;
    this._generating = false;
    this._generated = false;
  };
  Texture.prototype.upload_6 = function (bmp, mipmaps_0) {
    var tmp;
    if (!(bmp == null)) {
      var tmp_0 = bmp._bpp > 8;
      tmp = new SyncBitmapSource(tmp_0, bmp._width_2, bmp._height_2, _no_name_provided_$factory_221(bmp));
    } else {
      tmp = Companion_getInstance_122()._NIL_2;
    }
    return this.upload_7(tmp, mipmaps_0);
  };
  Texture.prototype.upload_7 = function (source, mipmaps_0) {
    this._source = source;
    this.uploadedSource_1();
    this.invalidate_23();
    this._requestMipmaps = mipmaps_0;
    return this;
  };
  Texture.prototype.uploadedSource_1 = function () {
  };
  Texture.prototype.bind_2 = function () {
  };
  Texture.prototype.manualUpload_1 = function () {
    this._uploaded = true;
    return this;
  };
  Texture.prototype.bindEnsuring_1 = function () {
    this.bind_2();
    if (this._isFbo)
      return Unit_getInstance();
    var source = this._source;
    if (this._uploaded)
      return Unit_getInstance();
    if (!this._generating) {
      this._generating = true;
      var tmp0_subject = source;
      if (tmp0_subject instanceof SyncBitmapSource) {
        this._tempBitmap = source._gen_1();
        this._generated = true;
      } else {
        if (tmp0_subject instanceof AsyncBitmapSource) {
          var tmp = source._coroutineContext_3;
          launchImmediately(tmp, _no_name_provided_$factory_222(this, source, null));
          Unit_getInstance();
        } else {
        }
      }
    }if (this._generated) {
      this._uploaded = true;
      this._generating = false;
      this._generated = false;
      this.actualSyncUpload_1(source, this._tempBitmap, this._requestMipmaps);
      this._tempBitmap = null;
      this._ready = true;
    }};
  Texture.prototype.actualSyncUpload_1 = function (source, bmp, requestMipmaps) {
  };
  Texture.prototype.close_77 = function () {
    if (!this._alreadyClosed) {
      this._alreadyClosed = true;
      this._source = Companion_getInstance_122()._NIL_2;
      this._tempBitmap = null;
      var tmp0_this = this._$this_13;
      var tmp1 = tmp0_this._deletedTextureCount;
      tmp0_this._deletedTextureCount = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Texture.$metadata$ = {
    simpleName: 'Texture',
    kind: 'class',
    interfaces: [Closeable]
  };
  function TextureUnit(texture, linear) {
    this._texture_2 = texture;
    this._linear_0 = linear;
  }
  TextureUnit.prototype.toString = function () {
    return '' + 'TextureUnit(texture=' + this._texture_2 + ', linear=' + this._linear_0 + ')';
  };
  TextureUnit.prototype.hashCode = function () {
    var result = this._texture_2 == null ? 0 : hashCode(this._texture_2);
    result = imul(result, 31) + (this._linear_0 | 0) | 0;
    return result;
  };
  TextureUnit.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextureUnit))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextureUnit ? other : THROW_CCE();
    if (!equals_1(this._texture_2, tmp0_other_with_cast._texture_2))
      return false;
    if (!(this._linear_0 === tmp0_other_with_cast._linear_0))
      return false;
    return true;
  };
  TextureUnit.$metadata$ = {
    simpleName: 'TextureUnit',
    kind: 'class',
    interfaces: []
  };
  function Buffer(kind) {
    this._kind_1 = kind;
    this._dirty_0 = false;
    this._mem_0 = null;
    this._memOffset = 0;
    this._memLength = 0;
  }
  Buffer.prototype._set_dirty__7 = function (_set___) {
    this._dirty_0 = _set___;
  };
  Buffer.prototype._get_dirty__2 = function () {
    return this._dirty_0;
  };
  Buffer.prototype._get_mem__1 = function () {
    return this._mem_0;
  };
  Buffer.prototype._get_memOffset__0 = function () {
    return this._memOffset;
  };
  Buffer.prototype._get_memLength__0 = function () {
    return this._memLength;
  };
  Buffer.prototype.afterSetMem_1 = function () {
  };
  Buffer.prototype.upload_8 = function (data, offset, length) {
    this._mem_0 = data;
    this._memOffset = offset;
    this._memLength = length;
    this._dirty_0 = true;
    this.afterSetMem_1();
    return this;
  };
  Buffer.prototype.close_77 = function () {
    this._mem_0 = null;
    this._memOffset = 0;
    this._memLength = 0;
    this._dirty_0 = true;
  };
  Buffer.$metadata$ = {
    simpleName: 'Buffer',
    kind: 'class',
    interfaces: [Closeable]
  };
  function DrawType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  DrawType.$metadata$ = {
    simpleName: 'DrawType',
    kind: 'class',
    interfaces: []
  };
  function IndexType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  IndexType.$metadata$ = {
    simpleName: 'IndexType',
    kind: 'class',
    interfaces: []
  };
  function StencilOp(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  StencilOp.$metadata$ = {
    simpleName: 'StencilOp',
    kind: 'class',
    interfaces: []
  };
  function TriangleFace(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  TriangleFace.$metadata$ = {
    simpleName: 'TriangleFace',
    kind: 'class',
    interfaces: []
  };
  function CompareMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CompareMode.$metadata$ = {
    simpleName: 'CompareMode',
    kind: 'class',
    interfaces: []
  };
  function ColorMaskState(red, green, blue, alpha) {
    this._red = red;
    this._green = green;
    this._blue = blue;
    this._alpha_0 = alpha;
  }
  ColorMaskState.prototype.toString = function () {
    return '' + 'ColorMaskState(red=' + this._red + ', green=' + this._green + ', blue=' + this._blue + ', alpha=' + this._alpha_0 + ')';
  };
  ColorMaskState.prototype.hashCode = function () {
    var result = this._red | 0;
    result = imul(result, 31) + (this._green | 0) | 0;
    result = imul(result, 31) + (this._blue | 0) | 0;
    result = imul(result, 31) + (this._alpha_0 | 0) | 0;
    return result;
  };
  ColorMaskState.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorMaskState))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ColorMaskState ? other : THROW_CCE();
    if (!(this._red === tmp0_other_with_cast._red))
      return false;
    if (!(this._green === tmp0_other_with_cast._green))
      return false;
    if (!(this._blue === tmp0_other_with_cast._blue))
      return false;
    if (!(this._alpha_0 === tmp0_other_with_cast._alpha_0))
      return false;
    return true;
  };
  ColorMaskState.$metadata$ = {
    simpleName: 'ColorMaskState',
    kind: 'class',
    interfaces: []
  };
  function FrontFace(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  FrontFace.$metadata$ = {
    simpleName: 'FrontFace',
    kind: 'class',
    interfaces: []
  };
  function RenderState(depthFunc, depthMask, depthNear, depthFar, lineWidth, frontFace) {
    this._depthFunc = depthFunc;
    this._depthMask = depthMask;
    this._depthNear = depthNear;
    this._depthFar = depthFar;
    this._lineWidth_0 = lineWidth;
    this._frontFace = frontFace;
  }
  RenderState.prototype.toString = function () {
    return '' + 'RenderState(depthFunc=' + this._depthFunc + ', depthMask=' + this._depthMask + ', depthNear=' + this._depthNear + ', depthFar=' + this._depthFar + ', lineWidth=' + this._lineWidth_0 + ', frontFace=' + this._frontFace + ')';
  };
  RenderState.prototype.hashCode = function () {
    var result = this._depthFunc.hashCode();
    result = imul(result, 31) + (this._depthMask | 0) | 0;
    result = imul(result, 31) + getNumberHashCode(this._depthNear) | 0;
    result = imul(result, 31) + getNumberHashCode(this._depthFar) | 0;
    result = imul(result, 31) + getNumberHashCode(this._lineWidth_0) | 0;
    result = imul(result, 31) + this._frontFace.hashCode() | 0;
    return result;
  };
  RenderState.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RenderState))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RenderState ? other : THROW_CCE();
    if (!this._depthFunc.equals(tmp0_other_with_cast._depthFunc))
      return false;
    if (!(this._depthMask === tmp0_other_with_cast._depthMask))
      return false;
    if (!equals_1(this._depthNear, tmp0_other_with_cast._depthNear))
      return false;
    if (!equals_1(this._depthFar, tmp0_other_with_cast._depthFar))
      return false;
    if (!equals_1(this._lineWidth_0, tmp0_other_with_cast._lineWidth_0))
      return false;
    if (!this._frontFace.equals(tmp0_other_with_cast._frontFace))
      return false;
    return true;
  };
  RenderState.$metadata$ = {
    simpleName: 'RenderState',
    kind: 'class',
    interfaces: []
  };
  function StencilState(enabled, triangleFace, compareMode, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, referenceValue, readMask, writeMask) {
    this._enabled = enabled;
    this._triangleFace = triangleFace;
    this._compareMode = compareMode;
    this._actionOnBothPass = actionOnBothPass;
    this._actionOnDepthFail = actionOnDepthFail;
    this._actionOnDepthPassStencilFail = actionOnDepthPassStencilFail;
    this._referenceValue = referenceValue;
    this._readMask = readMask;
    this._writeMask = writeMask;
  }
  StencilState.prototype.toString = function () {
    return '' + 'StencilState(enabled=' + this._enabled + ', triangleFace=' + this._triangleFace + ', compareMode=' + this._compareMode + ', actionOnBothPass=' + this._actionOnBothPass + ', actionOnDepthFail=' + this._actionOnDepthFail + ', actionOnDepthPassStencilFail=' + this._actionOnDepthPassStencilFail + ', referenceValue=' + this._referenceValue + ', readMask=' + this._readMask + ', writeMask=' + this._writeMask + ')';
  };
  StencilState.prototype.hashCode = function () {
    var result = this._enabled | 0;
    result = imul(result, 31) + this._triangleFace.hashCode() | 0;
    result = imul(result, 31) + this._compareMode.hashCode() | 0;
    result = imul(result, 31) + this._actionOnBothPass.hashCode() | 0;
    result = imul(result, 31) + this._actionOnDepthFail.hashCode() | 0;
    result = imul(result, 31) + this._actionOnDepthPassStencilFail.hashCode() | 0;
    result = imul(result, 31) + this._referenceValue | 0;
    result = imul(result, 31) + this._readMask | 0;
    result = imul(result, 31) + this._writeMask | 0;
    return result;
  };
  StencilState.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StencilState))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof StencilState ? other : THROW_CCE();
    if (!(this._enabled === tmp0_other_with_cast._enabled))
      return false;
    if (!this._triangleFace.equals(tmp0_other_with_cast._triangleFace))
      return false;
    if (!this._compareMode.equals(tmp0_other_with_cast._compareMode))
      return false;
    if (!this._actionOnBothPass.equals(tmp0_other_with_cast._actionOnBothPass))
      return false;
    if (!this._actionOnDepthFail.equals(tmp0_other_with_cast._actionOnDepthFail))
      return false;
    if (!this._actionOnDepthPassStencilFail.equals(tmp0_other_with_cast._actionOnDepthPassStencilFail))
      return false;
    if (!(this._referenceValue === tmp0_other_with_cast._referenceValue))
      return false;
    if (!(this._readMask === tmp0_other_with_cast._readMask))
      return false;
    if (!(this._writeMask === tmp0_other_with_cast._writeMask))
      return false;
    return true;
  };
  StencilState.$metadata$ = {
    simpleName: 'StencilState',
    kind: 'class',
    interfaces: []
  };
  function Batch(vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset, blending, uniforms, stencil, colorMask, renderState, scissor) {
    this._vertices = vertices;
    this._program = program;
    this._type_2 = type;
    this._vertexLayout = vertexLayout;
    this._vertexCount = vertexCount;
    this._indices = indices;
    this._indexType = indexType;
    this._offset_22 = offset;
    this._blending = blending;
    this._uniforms = uniforms;
    this._stencil = stencil;
    this._colorMask = colorMask;
    this._renderState = renderState;
    this._scissor = scissor;
  }
  Batch.prototype.toString = function () {
    return '' + 'Batch(vertices=' + this._vertices + ', program=' + this._program + ', type=' + this._type_2 + ', vertexLayout=' + this._vertexLayout + ', vertexCount=' + this._vertexCount + ', indices=' + this._indices + ', indexType=' + this._indexType + ', offset=' + this._offset_22 + ', blending=' + this._blending + ', uniforms=' + this._uniforms + ', stencil=' + this._stencil + ', colorMask=' + this._colorMask + ', renderState=' + this._renderState + ', scissor=' + this._scissor + ')';
  };
  Batch.prototype.hashCode = function () {
    var result = hashCode(this._vertices);
    result = imul(result, 31) + this._program.hashCode() | 0;
    result = imul(result, 31) + this._type_2.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._vertexLayout) | 0;
    result = imul(result, 31) + this._vertexCount | 0;
    result = imul(result, 31) + (this._indices == null ? 0 : hashCode(this._indices)) | 0;
    result = imul(result, 31) + this._indexType.hashCode() | 0;
    result = imul(result, 31) + this._offset_22 | 0;
    result = imul(result, 31) + this._blending.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._uniforms) | 0;
    result = imul(result, 31) + this._stencil.hashCode() | 0;
    result = imul(result, 31) + this._colorMask.hashCode() | 0;
    result = imul(result, 31) + this._renderState.hashCode() | 0;
    result = imul(result, 31) + (this._scissor == null ? 0 : this._scissor.hashCode()) | 0;
    return result;
  };
  Batch.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Batch))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Batch ? other : THROW_CCE();
    if (!equals_1(this._vertices, tmp0_other_with_cast._vertices))
      return false;
    if (!this._program.equals(tmp0_other_with_cast._program))
      return false;
    if (!this._type_2.equals(tmp0_other_with_cast._type_2))
      return false;
    if (!equals_1(this._vertexLayout, tmp0_other_with_cast._vertexLayout))
      return false;
    if (!(this._vertexCount === tmp0_other_with_cast._vertexCount))
      return false;
    if (!equals_1(this._indices, tmp0_other_with_cast._indices))
      return false;
    if (!this._indexType.equals(tmp0_other_with_cast._indexType))
      return false;
    if (!(this._offset_22 === tmp0_other_with_cast._offset_22))
      return false;
    if (!this._blending.equals(tmp0_other_with_cast._blending))
      return false;
    if (!equals_1(this._uniforms, tmp0_other_with_cast._uniforms))
      return false;
    if (!this._stencil.equals(tmp0_other_with_cast._stencil))
      return false;
    if (!this._colorMask.equals(tmp0_other_with_cast._colorMask))
      return false;
    if (!this._renderState.equals(tmp0_other_with_cast._renderState))
      return false;
    if (!equals_1(this._scissor, tmp0_other_with_cast._scissor))
      return false;
    return true;
  };
  Batch.$metadata$ = {
    simpleName: 'Batch',
    kind: 'class',
    interfaces: []
  };
  function BaseRenderBuffer() {
  }
  BaseRenderBuffer.prototype.setSize$default_4 = function (x, y, width, height, fullWidth, fullHeight, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      fullWidth = width;
    if (!(($mask0 & 32) === 0))
      fullHeight = height;
    return $handler == null ? this.setSize_4(x, y, width, height, fullWidth, fullHeight) : $handler(x, y, width, height, fullWidth, fullHeight);
  };
  BaseRenderBuffer.prototype.init_15 = function () {
    return Unit_getInstance();
  };
  BaseRenderBuffer.prototype.set_28 = function () {
    return Unit_getInstance();
  };
  BaseRenderBuffer.prototype.unset_4 = function () {
    return Unit_getInstance();
  };
  BaseRenderBuffer.$metadata$ = {
    simpleName: 'BaseRenderBuffer',
    kind: 'interface',
    interfaces: []
  };
  function BaseRenderBufferImpl() {
    this._x_11 = 0;
    this._y_10 = 0;
    this._width_11 = 128;
    this._height_11 = 128;
    this._fullWidth = 128;
    this._fullHeight = 128;
    this.__scissor = Companion_getInstance_84().invoke_311();
    this._scissor_0 = null;
  }
  BaseRenderBufferImpl.prototype._set_x__5 = function (_set___) {
    this._x_11 = _set___;
  };
  BaseRenderBufferImpl.prototype._get_x__36 = function () {
    return this._x_11;
  };
  BaseRenderBufferImpl.prototype._set_y__5 = function (_set___) {
    this._y_10 = _set___;
  };
  BaseRenderBufferImpl.prototype._get_y__36 = function () {
    return this._y_10;
  };
  BaseRenderBufferImpl.prototype._set_width__5 = function (_set___) {
    this._width_11 = _set___;
  };
  BaseRenderBufferImpl.prototype._get_width__58 = function () {
    return this._width_11;
  };
  BaseRenderBufferImpl.prototype._set_height__5 = function (_set___) {
    this._height_11 = _set___;
  };
  BaseRenderBufferImpl.prototype._get_height__58 = function () {
    return this._height_11;
  };
  BaseRenderBufferImpl.prototype._set_fullWidth__3 = function (_set___) {
    this._fullWidth = _set___;
  };
  BaseRenderBufferImpl.prototype._get_fullWidth__4 = function () {
    return this._fullWidth;
  };
  BaseRenderBufferImpl.prototype._set_fullHeight__3 = function (_set___) {
    this._fullHeight = _set___;
  };
  BaseRenderBufferImpl.prototype._get_fullHeight__4 = function () {
    return this._fullHeight;
  };
  BaseRenderBufferImpl.prototype._get_scissor__4 = function () {
    return this._scissor_0;
  };
  BaseRenderBufferImpl.prototype.setSize_4 = function (x, y, width, height, fullWidth, fullHeight) {
    this._set_x__5(x);
    this._set_y__5(y);
    this._set_width__5(width);
    this._set_height__5(height);
    this._set_fullWidth__3(fullWidth);
    this._set_fullHeight__3(fullHeight);
  };
  BaseRenderBufferImpl.$metadata$ = {
    simpleName: 'BaseRenderBufferImpl',
    kind: 'class',
    interfaces: [BaseRenderBuffer]
  };
  function RenderBuffer($outer) {
    this._$this_14 = $outer;
    BaseRenderBufferImpl.call(this);
    this._id_7 = -1;
    this._cachedTexVersion = -1;
    this.__tex = null;
    this._dirty_1 = false;
  }
  RenderBuffer.prototype._get_tex__2 = function () {
    if (!(this._cachedTexVersion === this._$this_14._contextVersion)) {
      this._cachedTexVersion = this._$this_14._contextVersion;
      var tmp = this;
      var tmp0_apply_0 = this._$this_14.createTexture_10(true).manualUpload_1();
      tmp0_apply_0._isFbo = true;
      tmp.__tex = tmp0_apply_0;
    }return ensureNotNull(this.__tex);
  };
  RenderBuffer.prototype._set_dirty__7 = function (_set___) {
    this._dirty_1 = _set___;
  };
  RenderBuffer.prototype._get_dirty__2 = function () {
    return this._dirty_1;
  };
  RenderBuffer.prototype.setSize_4 = function (x, y, width, height, fullWidth, fullHeight) {
    BaseRenderBufferImpl.prototype.setSize_4.call(this, x, y, width, height, fullWidth, fullHeight);
    this._dirty_1 = true;
  };
  RenderBuffer.prototype.set_28 = function () {
    return Unit_getInstance();
  };
  RenderBuffer.prototype.close_77 = function () {
    return Unit_getInstance();
  };
  RenderBuffer.$metadata$ = {
    simpleName: 'RenderBuffer',
    kind: 'class',
    interfaces: [Closeable]
  };
  function TextureDrawer($outer) {
    this._$this_15 = $outer;
    this._VERTEX_COUNT = 4;
    this._vertices_0 = this._$this_15.createBuffer_5(Kind_VERTEX_getInstance());
    this._vertexLayout_0 = VertexLayout_init_$Create$([DefaultShaders_getInstance()._a_Pos, DefaultShaders_getInstance()._a_Tex]);
    this._verticesData = Companion_getInstance_38().invoke_874(imul(this._VERTEX_COUNT, this._vertexLayout_0._totalSize_2));
    var tmp = this;
    var tmp_0 = VertexShader_0(_no_name_provided_$factory_223());
    var tmp_1 = FragmentShader_0(_no_name_provided_$factory_224());
    tmp._program_0 = Program_init_$Create$(tmp_0, tmp_1, null, 4, null);
    this._uniforms_0 = new UniformValues();
  }
  TextureDrawer.$metadata$ = {
    simpleName: 'TextureDrawer',
    kind: 'class',
    interfaces: []
  };
  function UniformValues() {
    Companion_getInstance_123();
    this.__uniforms = FastArrayList_init_$Create$();
    this.__values_4 = FastArrayList_init_$Create$();
    var tmp = this;
    var tmp_0 = this.__uniforms;
    tmp._uniforms_1 = isInterface(tmp_0, List) ? tmp_0 : THROW_CCE();
    var tmp_1 = this;
    var tmp_2 = this.__values_4;
    tmp_1._values_2 = isInterface(tmp_2, List) ? tmp_2 : THROW_CCE();
  }
  UniformValues.prototype._get_keys__3 = function () {
    return this._uniforms_1;
  };
  UniformValues.prototype.put_16 = function (uniform, value) {
    var inductionVariable = 0;
    var last_1 = this.__uniforms._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.__uniforms.get_137(n)._get_name__50() === uniform._get_name__50()) {
          this.__values_4.set_8(n, value);
          Unit_getInstance();
          return this;
        }}
       while (inductionVariable < last_1);
    this.__uniforms.add_39(uniform);
    Unit_getInstance();
    this.__values_4.add_39(value);
    Unit_getInstance();
    return this;
  };
  UniformValues.prototype.toString = function () {
    var tmp0_map_0 = zip(this._get_keys__3(), this._values_2);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39('' + item_2_3._first + '=' + item_2_3._second);
      Unit_getInstance();
    }
    return '{' + joinToString$default_0(tmp0_mapTo_0_1, ', ', null, null, 0, null, null, 62, null) + '}';
  };
  UniformValues.$metadata$ = {
    simpleName: 'UniformValues',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__262(this$0) {
    this._this$0_59 = this$0;
  }
  _no_name_provided__262.prototype.invoke_1005 = function () {
    return this._this$0_59.createTexture_11();
  };
  _no_name_provided__262.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__263(this$0) {
    this._this$0_60 = this$0;
  }
  _no_name_provided__263.prototype.invoke_874 = function (it) {
    return this._this$0_60.createRenderBuffer_4();
  };
  _no_name_provided__263.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__263.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__264(this$0) {
    this._this$0_61 = this$0;
  }
  _no_name_provided__264.prototype.invoke_1005 = function () {
    return this._this$0_61.createMainRenderBuffer_4();
  };
  _no_name_provided__264.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__265(this$0) {
    this._this$0_62 = this$0;
  }
  _no_name_provided__265.prototype.invoke_1005 = function () {
    return new TextureDrawer(this._this$0_62);
  };
  _no_name_provided__265.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__266(this$0) {
    this._this$0_63 = this$0;
  }
  _no_name_provided__266.prototype.invoke_1005 = function () {
    return this._this$0_63.createTexture_11();
  };
  _no_name_provided__266.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BlendEquation_ADD_getInstance() {
    BlendEquation_initEntries();
    return BlendEquation_ADD_instance;
  }
  function BlendEquation_SUBTRACT_getInstance() {
    BlendEquation_initEntries();
    return BlendEquation_SUBTRACT_instance;
  }
  function BlendEquation_REVERSE_SUBTRACT_getInstance() {
    BlendEquation_initEntries();
    return BlendEquation_REVERSE_SUBTRACT_instance;
  }
  function BlendFactor_DESTINATION_ALPHA_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_DESTINATION_ALPHA_instance;
  }
  function BlendFactor_DESTINATION_COLOR_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_DESTINATION_COLOR_instance;
  }
  function BlendFactor_ONE_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ONE_instance;
  }
  function BlendFactor_ONE_MINUS_DESTINATION_ALPHA_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ONE_MINUS_DESTINATION_ALPHA_instance;
  }
  function BlendFactor_ONE_MINUS_DESTINATION_COLOR_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ONE_MINUS_DESTINATION_COLOR_instance;
  }
  function BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ONE_MINUS_SOURCE_ALPHA_instance;
  }
  function BlendFactor_ONE_MINUS_SOURCE_COLOR_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ONE_MINUS_SOURCE_COLOR_instance;
  }
  function BlendFactor_SOURCE_ALPHA_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_SOURCE_ALPHA_instance;
  }
  function BlendFactor_SOURCE_COLOR_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_SOURCE_COLOR_instance;
  }
  function BlendFactor_ZERO_getInstance() {
    BlendFactor_initEntries();
    return BlendFactor_ZERO_instance;
  }
  function DrawType_POINTS_getInstance() {
    DrawType_initEntries();
    return DrawType_POINTS_instance;
  }
  function DrawType_LINE_STRIP_getInstance() {
    DrawType_initEntries();
    return DrawType_LINE_STRIP_instance;
  }
  function DrawType_LINE_LOOP_getInstance() {
    DrawType_initEntries();
    return DrawType_LINE_LOOP_instance;
  }
  function DrawType_LINES_getInstance() {
    DrawType_initEntries();
    return DrawType_LINES_instance;
  }
  function DrawType_TRIANGLES_getInstance() {
    DrawType_initEntries();
    return DrawType_TRIANGLES_instance;
  }
  function DrawType_TRIANGLE_STRIP_getInstance() {
    DrawType_initEntries();
    return DrawType_TRIANGLE_STRIP_instance;
  }
  function DrawType_TRIANGLE_FAN_getInstance() {
    DrawType_initEntries();
    return DrawType_TRIANGLE_FAN_instance;
  }
  function IndexType_UBYTE_getInstance() {
    IndexType_initEntries();
    return IndexType_UBYTE_instance;
  }
  function IndexType_USHORT_getInstance() {
    IndexType_initEntries();
    return IndexType_USHORT_instance;
  }
  function IndexType_UINT_getInstance() {
    IndexType_initEntries();
    return IndexType_UINT_instance;
  }
  function StencilOp_DECREMENT_SATURATE_getInstance() {
    StencilOp_initEntries();
    return StencilOp_DECREMENT_SATURATE_instance;
  }
  function StencilOp_DECREMENT_WRAP_getInstance() {
    StencilOp_initEntries();
    return StencilOp_DECREMENT_WRAP_instance;
  }
  function StencilOp_INCREMENT_SATURATE_getInstance() {
    StencilOp_initEntries();
    return StencilOp_INCREMENT_SATURATE_instance;
  }
  function StencilOp_INCREMENT_WRAP_getInstance() {
    StencilOp_initEntries();
    return StencilOp_INCREMENT_WRAP_instance;
  }
  function StencilOp_INVERT_getInstance() {
    StencilOp_initEntries();
    return StencilOp_INVERT_instance;
  }
  function StencilOp_KEEP_getInstance() {
    StencilOp_initEntries();
    return StencilOp_KEEP_instance;
  }
  function StencilOp_SET_getInstance() {
    StencilOp_initEntries();
    return StencilOp_SET_instance;
  }
  function StencilOp_ZERO_getInstance() {
    StencilOp_initEntries();
    return StencilOp_ZERO_instance;
  }
  function TriangleFace_FRONT_AND_BACK_getInstance() {
    TriangleFace_initEntries();
    return TriangleFace_FRONT_AND_BACK_instance;
  }
  function CompareMode_ALWAYS_getInstance() {
    CompareMode_initEntries();
    return CompareMode_ALWAYS_instance;
  }
  function CompareMode_EQUAL_getInstance() {
    CompareMode_initEntries();
    return CompareMode_EQUAL_instance;
  }
  function CompareMode_GREATER_getInstance() {
    CompareMode_initEntries();
    return CompareMode_GREATER_instance;
  }
  function CompareMode_GREATER_EQUAL_getInstance() {
    CompareMode_initEntries();
    return CompareMode_GREATER_EQUAL_instance;
  }
  function CompareMode_LESS_getInstance() {
    CompareMode_initEntries();
    return CompareMode_LESS_instance;
  }
  function CompareMode_LESS_EQUAL_getInstance() {
    CompareMode_initEntries();
    return CompareMode_LESS_EQUAL_instance;
  }
  function CompareMode_NEVER_getInstance() {
    CompareMode_initEntries();
    return CompareMode_NEVER_instance;
  }
  function CompareMode_NOT_EQUAL_getInstance() {
    CompareMode_initEntries();
    return CompareMode_NOT_EQUAL_instance;
  }
  function FrontFace_BOTH_getInstance() {
    FrontFace_initEntries();
    return FrontFace_BOTH_instance;
  }
  function FrontFace_CW_getInstance() {
    FrontFace_initEntries();
    return FrontFace_CW_instance;
  }
  function AG() {
    var tmp = this;
    tmp._$$delegate_0_14 = Mixin_init_$Create$(null, 1, null);
    this._contextVersion = 0;
    this._maxTextureSize = Companion_getInstance_86().invoke_323(2048, 2048);
    this._devicePixelRatio = 1.0;
    this._lastTextureId = 0;
    this._createdTextureCount = 0;
    this._deletedTextureCount = 0;
    var tmp_0 = this;
    tmp_0._dummyTexture$delegate = lazy(_no_name_provided_$factory_215(this));
    var tmp_1 = this;
    tmp_1._dummyRenderState = RenderState_init_$Create$(null, false, 0.0, 0.0, 0.0, null, 63, null);
    var tmp_2 = this;
    tmp_2._dummyStencilState = StencilState_init_$Create$(false, null, null, null, null, null, 0, 0, 0, 511, null);
    var tmp_3 = this;
    tmp_3._dummyColorMaskState = ColorMaskState_init_$Create$(false, false, false, false, 15, null);
    var tmp_4 = this;
    tmp_4._batch = Batch_init_$Create$(null, null, null, null, 0, null, null, 0, null, null, null, null, null, null, 16383, null);
    this._frameRenderBuffers = LinkedHashSet_init_$Create$();
    var tmp_5 = this;
    tmp_5._renderBuffers = Pool_init_$Create$_1(0, _no_name_provided_$factory_216(this), 1, null);
    var tmp_6 = this;
    tmp_6._mainRenderBuffer$delegate = lazy(_no_name_provided_$factory_217(this));
    this._currentRenderBuffer = null;
    var tmp_7 = this;
    tmp_7._textureDrawer$delegate = lazy(_no_name_provided_$factory_218(this));
    this._flipRenderTexture = true;
    var tmp_8 = this;
    tmp_8._drawTempTexture$delegate = lazy(_no_name_provided_$factory_219(this));
  }
  AG.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_14._extra = _set___;
  };
  AG.prototype._get_extra__71 = function () {
    return this._$$delegate_0_14._extra;
  };
  AG.prototype._set_contextVersion__1 = function (_set___) {
    this._contextVersion = _set___;
  };
  AG.prototype._get_contextVersion__1 = function () {
    return this._contextVersion;
  };
  AG.prototype.contextLost_4 = function () {
    Console_getInstance().info_1(['AG.contextLost()', this]);
    var tmp0_this = this;
    var tmp1 = tmp0_this._contextVersion;
    tmp0_this._contextVersion = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  AG.prototype._get_devicePixelRatio__4 = function () {
    return this._devicePixelRatio;
  };
  AG.prototype.beforeDoRender_4 = function () {
  };
  AG.prototype.resized_4 = function (x, y, width, height, fullWidth, fullHeight) {
    this._get_mainRenderBuffer__4().setSize_4(x, y, width, height, fullWidth, fullHeight);
  };
  AG.prototype._get_backWidth__4 = function () {
    return this._get_mainRenderBuffer__4()._get_width__58();
  };
  AG.prototype._get_backHeight__4 = function () {
    return this._get_mainRenderBuffer__4()._get_height__58();
  };
  AG.prototype._get_realBackWidth__1 = function () {
    return this._get_mainRenderBuffer__4()._get_fullWidth__4();
  };
  AG.prototype._get_realBackHeight__1 = function () {
    return this._get_mainRenderBuffer__4()._get_fullHeight__4();
  };
  AG.prototype._get_currentWidth__4 = function () {
    var tmp0_safe_receiver = this._currentRenderBuffer;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_width__58();
    return tmp1_elvis_lhs == null ? this._get_mainRenderBuffer__4()._get_width__58() : tmp1_elvis_lhs;
  };
  AG.prototype._get_currentHeight__4 = function () {
    var tmp0_safe_receiver = this._currentRenderBuffer;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_height__58();
    return tmp1_elvis_lhs == null ? this._get_mainRenderBuffer__4()._get_height__58() : tmp1_elvis_lhs;
  };
  AG.prototype.createTexture_11 = function () {
    return this.createTexture_10(true);
  };
  AG.prototype.createTexture_10 = function (premultiplied) {
    return new Texture(this);
  };
  AG.prototype.createBuffer_5 = function (kind) {
    return new Buffer(kind);
  };
  AG.prototype.createIndexBuffer_4 = function () {
    return this.createBuffer_5(Kind_INDEX_getInstance());
  };
  AG.prototype.createVertexBuffer_4 = function () {
    return this.createBuffer_5(Kind_VERTEX_getInstance());
  };
  AG.prototype.draw_22 = function (vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset, blending, uniforms, stencil, colorMask, renderState, scissor) {
    var tmp0_also_0 = this._batch;
    tmp0_also_0._vertices = vertices;
    tmp0_also_0._program = program;
    tmp0_also_0._type_2 = type;
    tmp0_also_0._vertexLayout = vertexLayout;
    tmp0_also_0._vertexCount = vertexCount;
    tmp0_also_0._indices = indices;
    tmp0_also_0._indexType = indexType;
    tmp0_also_0._offset_22 = offset;
    tmp0_also_0._blending = blending;
    tmp0_also_0._uniforms = uniforms;
    tmp0_also_0._stencil = stencil;
    tmp0_also_0._colorMask = colorMask;
    tmp0_also_0._renderState = renderState;
    tmp0_also_0._scissor = scissor;
    return this.draw_21(tmp0_also_0);
  };
  AG.prototype.draw$default = function (vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset, blending, uniforms, stencil, colorMask, renderState, scissor, $mask0, $handler) {
    if (!(($mask0 & 32) === 0))
      indices = null;
    if (!(($mask0 & 64) === 0))
      indexType = IndexType_USHORT_getInstance();
    if (!(($mask0 & 128) === 0))
      offset = 0;
    if (!(($mask0 & 256) === 0))
      blending = Companion_getInstance_121()._NORMAL;
    if (!(($mask0 & 512) === 0))
      uniforms = Companion_getInstance_123()._EMPTY_5;
    if (!(($mask0 & 1024) === 0))
      stencil = this._dummyStencilState;
    if (!(($mask0 & 2048) === 0))
      colorMask = this._dummyColorMaskState;
    if (!(($mask0 & 4096) === 0))
      renderState = this._dummyRenderState;
    if (!(($mask0 & 8192) === 0))
      scissor = null;
    return this.draw_22(vertices, program, type, vertexLayout, vertexCount, indices, indexType, offset, blending, uniforms, stencil, colorMask, renderState, scissor);
  };
  AG.prototype.draw_21 = function (batch) {
  };
  AG.prototype.checkBuffers_1 = function (vertices, indices) {
    if (!vertices._kind_1.equals(Kind_VERTEX_getInstance())) {
      invalidOp('Not a VertexBuffer');
    }if (!(indices == null) ? !indices._kind_1.equals(Kind_INDEX_getInstance()) : false) {
      invalidOp('Not a IndexBuffer');
    }};
  AG.prototype.disposeTemporalPerFrameStuff_4 = function () {
    return Unit_getInstance();
  };
  AG.prototype._get_mainRenderBuffer__4 = function () {
    var tmp0_getValue_0 = this._mainRenderBuffer$delegate;
    var tmp1_getValue_0 = mainRenderBuffer$factory();
    return tmp0_getValue_0._get_value__10();
  };
  AG.prototype.createMainRenderBuffer_4 = function () {
    return new BaseRenderBufferImpl();
  };
  AG.prototype.createRenderBuffer_4 = function () {
    return new RenderBuffer(this);
  };
  AG.prototype.flip_4 = function () {
    this.disposeTemporalPerFrameStuff_4();
    this._renderBuffers.free_0(this._frameRenderBuffers);
    var tmp0_isNotEmpty_0 = this._frameRenderBuffers;
    if (!tmp0_isNotEmpty_0.isEmpty_53())
      this._frameRenderBuffers.clear_33();
    else {
    }
    this.flipInternal_4();
  };
  AG.prototype.flipInternal_4 = function () {
    return Unit_getInstance();
  };
  AG.prototype.startFrame_8 = function () {
  };
  AG.prototype.clear_28 = function (color_0, depth, stencil, clearColor, clearDepth, clearStencil) {
    return Unit_getInstance();
  };
  AG.prototype.clear$default = function (color_0, depth, stencil, clearColor, clearDepth, clearStencil, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      color_0 = Colors_getInstance()._TRANSPARENT_BLACK;
    if (!(($mask0 & 2) === 0))
      depth = 1.0;
    if (!(($mask0 & 4) === 0))
      stencil = 0;
    if (!(($mask0 & 8) === 0))
      clearColor = true;
    if (!(($mask0 & 16) === 0))
      clearDepth = true;
    if (!(($mask0 & 32) === 0))
      clearStencil = true;
    var tmp;
    if ($handler == null) {
      tmp = this.clear_28(color_0, depth, stencil, clearColor, clearDepth, clearStencil);
    } else {
      var tmp_0 = $handler;
      var tmp_1 = color_0;
      tmp = tmp_0(tmp_1 == null ? null : new RGBA(tmp_1), depth, stencil, clearColor, clearDepth, clearStencil);
    }
    return tmp;
  };
  AG.prototype._get_currentRenderBuffer__1 = function () {
    return this._currentRenderBuffer;
  };
  AG.prototype._get_renderingToTexture__4 = function () {
    return !(this._currentRenderBuffer === this._get_mainRenderBuffer__4()) ? !(this._currentRenderBuffer === null) : false;
  };
  AG.prototype.setRenderBuffer_4 = function (renderBuffer) {
    var old = this._currentRenderBuffer;
    var tmp0_safe_receiver = this._currentRenderBuffer;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.unset_4();
      Unit_getInstance();
    }
    Unit_getInstance();
    this._currentRenderBuffer = renderBuffer;
    var tmp1_safe_receiver = renderBuffer;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.set_28();
      Unit_getInstance();
    }
    Unit_getInstance();
    return old;
  };
  AG.$metadata$ = {
    simpleName: 'AG',
    kind: 'class',
    interfaces: [Extra]
  };
  function toRenderFboIntoBack(_this_) {
    return _this_;
  }
  function toRenderImageIntoFbo(_this_) {
    return _this_;
  }
  function AGWindow() {
  }
  AGWindow.$metadata$ = {
    simpleName: 'AGWindow',
    kind: 'interface',
    interfaces: [AGContainer]
  };
  function AGConfig_init_$Init$(antialiasHint, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      antialiasHint = true;
    AGConfig.call($this, antialiasHint);
    return $this;
  }
  function AGConfig_init_$Create$(antialiasHint, $mask0, $marker) {
    return AGConfig_init_$Init$(antialiasHint, $mask0, $marker, Object.create(AGConfig.prototype));
  }
  function AGConfig(antialiasHint) {
    this._antialiasHint = antialiasHint;
  }
  AGConfig.prototype.toString = function () {
    return '' + 'AGConfig(antialiasHint=' + this._antialiasHint + ')';
  };
  AGConfig.prototype.hashCode = function () {
    return this._antialiasHint | 0;
  };
  AGConfig.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this._antialiasHint === tmp0_other_with_cast._antialiasHint))
      return false;
    return true;
  };
  AGConfig.$metadata$ = {
    simpleName: 'AGConfig',
    kind: 'class',
    interfaces: []
  };
  function AGContainer() {
  }
  AGContainer.$metadata$ = {
    simpleName: 'AGContainer',
    kind: 'interface',
    interfaces: []
  };
  function mainRenderBuffer$factory() {
    return getPropertyCallableRef('mainRenderBuffer', 1, KProperty1, function (receiver) {
      return receiver._get_mainRenderBuffer__4();
    }, null);
  }
  function _no_name_provided_$factory_215(this$0) {
    var i = new _no_name_provided__262(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_216(this$0) {
    var i = new _no_name_provided__263(this$0);
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function _no_name_provided_$factory_217(this$0) {
    var i = new _no_name_provided__264(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_218(this$0) {
    var i = new _no_name_provided__265(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_219(this$0) {
    var i = new _no_name_provided__266(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_220() {
    var i = new _no_name_provided__257();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_221($bmp) {
    var i = new _no_name_provided__258($bmp);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_222(this$0, $source, resultContinuation) {
    var i = new _no_name_provided__259(this$0, $source, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_223() {
    var i = new _no_name_provided__260();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_224() {
    var i = new _no_name_provided__261();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__267() {
  }
  _no_name_provided__267.prototype.invoke_664 = function ($this$VertexShader) {
    $this$VertexShader.SET(DefaultShaders_getInstance()._v_Tex, DefaultShaders_getInstance()._a_Tex);
    $this$VertexShader.SET(DefaultShaders_getInstance()._v_Col, DefaultShaders_getInstance()._a_Col);
    $this$VertexShader.SET($this$VertexShader._out_8, $this$VertexShader.times_0($this$VertexShader.times_0(DefaultShaders_getInstance()._u_ProjMat, DefaultShaders_getInstance()._u_ViewMat), $this$VertexShader.vec4([DefaultShaders_getInstance()._a_Pos, $this$VertexShader._get_lit_(0.0), $this$VertexShader._get_lit_(1.0)])));
  };
  _no_name_provided__267.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__267.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__268() {
  }
  _no_name_provided__268.prototype.invoke_664 = function ($this$FragmentShader) {
    $this$FragmentShader.set_29($this$FragmentShader._out_8, $this$FragmentShader.vec4([$this$FragmentShader._get_lit_(1.0), $this$FragmentShader._get_lit_(1.0), $this$FragmentShader._get_lit_(0.0), $this$FragmentShader._get_lit_(1.0)]));
  };
  _no_name_provided__268.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__268.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__269() {
  }
  _no_name_provided__269.prototype.invoke_664 = function ($this$FragmentShader) {
    $this$FragmentShader.set_29($this$FragmentShader._out_8, DefaultShaders_getInstance()._v_Col);
  };
  _no_name_provided__269.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__269.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__270() {
  }
  _no_name_provided__270.prototype.invoke_664 = function ($this$FragmentShader) {
    $this$FragmentShader.SET($this$FragmentShader._out_8, $this$FragmentShader.times_0($this$FragmentShader.get_96($this$FragmentShader.texture2D(DefaultShaders_getInstance()._u_Tex, $this$FragmentShader.get_96(DefaultShaders_getInstance()._v_Tex, 'xy')), 'rgba'), DefaultShaders_getInstance()._v_Col));
  };
  _no_name_provided__270.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__270.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__271() {
  }
  _no_name_provided__271.prototype.invoke_664 = function ($this$FragmentShader) {
    $this$FragmentShader.SET(DefaultShaders_getInstance()._t_Temp0, $this$FragmentShader.texture2D(DefaultShaders_getInstance()._u_Tex, $this$FragmentShader.get_96(DefaultShaders_getInstance()._v_Tex, 'xy')));
    $this$FragmentShader.SET($this$FragmentShader.get_96(DefaultShaders_getInstance()._t_Temp0, 'rgb'), $this$FragmentShader.div_0($this$FragmentShader.get_96(DefaultShaders_getInstance()._t_Temp0, 'rgb'), $this$FragmentShader.get_96(DefaultShaders_getInstance()._t_Temp0, 'a')));
    $this$FragmentShader.SET($this$FragmentShader._out_8, $this$FragmentShader.times_0($this$FragmentShader.get_96(DefaultShaders_getInstance()._t_Temp0, 'rgba'), DefaultShaders_getInstance()._v_Col));
  };
  _no_name_provided__271.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__271.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__272() {
  }
  _no_name_provided__272.prototype.invoke_664 = function ($this$VertexShader) {
    $this$VertexShader.SET($this$VertexShader._out_8, $this$VertexShader.vec4([DefaultShaders_getInstance()._a_Pos, $this$VertexShader._get_lit_(0.0), $this$VertexShader._get_lit_(1.0)]));
  };
  _no_name_provided__272.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__272.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__273() {
  }
  _no_name_provided__273.prototype.invoke_664 = function ($this$FragmentShader) {
    $this$FragmentShader.set_29($this$FragmentShader._out_8, $this$FragmentShader.vec4([$this$FragmentShader._get_lit_(1.0), $this$FragmentShader._get_lit_(0.0), $this$FragmentShader._get_lit_(0.0), $this$FragmentShader._get_lit_(1.0)]));
  };
  _no_name_provided__273.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__273.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__274() {
  }
  _no_name_provided__274.prototype.invoke_664 = function ($this$VertexShader) {
    $this$VertexShader.SET($this$VertexShader._out_8, $this$VertexShader.times_0(DefaultShaders_getInstance()._u_ProjMat, $this$VertexShader.vec4([DefaultShaders_getInstance()._a_Pos, $this$VertexShader._get_lit_(0.0), $this$VertexShader._get_lit_(1.0)])));
  };
  _no_name_provided__274.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__274.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__275() {
  }
  _no_name_provided__275.prototype.invoke_664 = function ($this$FragmentShader) {
    $this$FragmentShader.SET($this$FragmentShader._out_8, $this$FragmentShader.vec4([$this$FragmentShader._get_lit_(1.0), $this$FragmentShader._get_lit_(0.0), $this$FragmentShader._get_lit_(0.0), $this$FragmentShader._get_lit_(1.0)]));
  };
  _no_name_provided__275.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__275.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__276() {
  }
  _no_name_provided__276.prototype.invoke_1005 = function () {
    return DefaultShaders_getInstance()._PROGRAM_TINTED_TEXTURE_PREMULT;
  };
  _no_name_provided__276.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function DefaultShaders() {
    DefaultShaders_instance = this;
    var tmp = this;
    var tmp_0 = VarType_TextureUnit_getInstance();
    tmp._u_Tex = Uniform_init_$Create$('u_Tex', tmp_0, null, 4, null);
    var tmp_1 = this;
    var tmp_2 = VarType_Mat4_getInstance();
    tmp_1._u_ProjMat = Uniform_init_$Create$('u_ProjMat', tmp_2, null, 4, null);
    var tmp_3 = this;
    var tmp_4 = VarType_Mat4_getInstance();
    tmp_3._u_ViewMat = Uniform_init_$Create$('u_ViewMat', tmp_4, null, 4, null);
    this._a_Pos = Attribute_init_$Create$('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance());
    this._a_Tex = Attribute_init_$Create$('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance());
    this._a_Col = Attribute_init_$Create$('a_Col', VarType_Byte4_getInstance(), true, Precision_LOW_getInstance());
    this._v_Tex = Varying_init_$Create$('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    var tmp_5 = this;
    var tmp_6 = VarType_Byte4_getInstance();
    tmp_5._v_Col = Varying_init_$Create$_0('v_Col', tmp_6, null, 4, null);
    var tmp_7 = this;
    var tmp_8 = VarType_Float4_getInstance();
    tmp_7._t_Temp0 = Temp_init_$Create$(0, tmp_8, null, 4, null);
    var tmp_9 = this;
    var tmp_10 = VarType_Float4_getInstance();
    tmp_9._t_Temp1 = Temp_init_$Create$(1, tmp_10, null, 4, null);
    var tmp_11 = this;
    tmp_11._textureUnit = TextureUnit_init_$Create$(null, false, 3, null);
    this._LAYOUT_DEFAULT = VertexLayout_init_$Create$([this._a_Pos, this._a_Tex, this._a_Col]);
    var tmp_12 = this;
    tmp_12._VERTEX_DEFAULT = VertexShader_0(_no_name_provided_$factory_225());
    var tmp_13 = this;
    tmp_13._FRAGMENT_DEBUG = FragmentShader_0(_no_name_provided_$factory_226());
    var tmp_14 = this;
    tmp_14._FRAGMENT_SOLID_COLOR = FragmentShader_0(_no_name_provided_$factory_227());
    var tmp_15 = this;
    tmp_15._PROGRAM_TINTED_TEXTURE = new Program(this._VERTEX_DEFAULT, FragmentShader_0(_no_name_provided_$factory_228()), 'PROGRAM_TINTED_TEXTURE');
    var tmp_16 = this;
    tmp_16._PROGRAM_TINTED_TEXTURE_PREMULT = new Program(this._VERTEX_DEFAULT, FragmentShader_0(_no_name_provided_$factory_229()), 'PROGRAM_TINTED_TEXTURE');
    this._PROGRAM_SOLID_COLOR = new Program(this._VERTEX_DEFAULT, this._FRAGMENT_SOLID_COLOR, 'PROGRAM_SOLID_COLOR');
    this._LAYOUT_DEBUG = VertexLayout_init_$Create$([this._a_Pos]);
    var tmp_17 = this;
    var tmp_18 = VertexShader_0(_no_name_provided_$factory_230());
    tmp_17._PROGRAM_DEBUG = new Program(tmp_18, FragmentShader_0(_no_name_provided_$factory_231()), 'PROGRAM_DEBUG');
    var tmp_19 = this;
    var tmp_20 = VertexShader_0(_no_name_provided_$factory_232());
    tmp_19._PROGRAM_DEBUG_WITH_PROJ = new Program(tmp_20, FragmentShader_0(_no_name_provided_$factory_233()), 'PROGRAM_DEBUG_WITH_PROJ');
    var tmp_21 = this;
    tmp_21._PROGRAM_DEFAULT$delegate = lazy(_no_name_provided_$factory_234());
  }
  DefaultShaders.$metadata$ = {
    simpleName: 'DefaultShaders',
    kind: 'object',
    interfaces: []
  };
  var DefaultShaders_instance;
  function DefaultShaders_getInstance() {
    if (DefaultShaders_instance == null)
      new DefaultShaders();
    return DefaultShaders_instance;
  }
  function _no_name_provided_$factory_225() {
    var i = new _no_name_provided__267();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_226() {
    var i = new _no_name_provided__268();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_227() {
    var i = new _no_name_provided__269();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_228() {
    var i = new _no_name_provided__270();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_229() {
    var i = new _no_name_provided__271();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_230() {
    var i = new _no_name_provided__272();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_231() {
    var i = new _no_name_provided__273();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_232() {
    var i = new _no_name_provided__274();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_233() {
    var i = new _no_name_provided__275();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_234() {
    var i = new _no_name_provided__276();
    return function () {
      return i.invoke_1005();
    };
  }
  function ForcedTexId() {
  }
  ForcedTexId.$metadata$ = {
    simpleName: 'ForcedTexId',
    kind: 'interface',
    interfaces: []
  };
  function ForcedTexTarget() {
  }
  ForcedTexTarget.$metadata$ = {
    simpleName: 'ForcedTexTarget',
    kind: 'interface',
    interfaces: []
  };
  function _get_versionString_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = versionString$delegate;
      var tmp1_getValue_0 = versionString$factory();
      var tmp1_safe_receiver_2 = _this_._get_extra__71();
      var tmp;
      if (tmp1_safe_receiver_2 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_3 = tmp0_getValue_0._name_1;
        tmp = tmp1_safe_receiver_2.get_116(tmp0_elvis_lhs_3 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3);
      }
      var tmp_0 = tmp;
      var res_1 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      if (res_1 == null) {
        var r_4 = tmp0_getValue_0._defaultGen_0(_this_);
        if (_this_._get_extra__71() == null)
          _this_._set_extra__71(LinkedHashMap_init_$Create$());
        var tmp1_safe_receiver_2_2_5 = _this_._get_extra__71();
        if (tmp1_safe_receiver_2_2_5 == null)
          null;
        else {
          var tmp0_elvis_lhs_3_4_7 = tmp0_getValue_0._name_1;
          var tmp0_set_0_3_6 = tmp0_elvis_lhs_3_4_7 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3_4_7;
          var tmp1_set_0_5_8 = (r_4 == null ? true : isObject(r_4)) ? r_4 : THROW_CCE();
          tmp1_safe_receiver_2_2_5.put_18(tmp0_set_0_3_6, tmp1_set_0_5_8);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_4;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var versionString$delegate;
  function _get_versionInt_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = versionInt$delegate;
      var tmp1_getValue_0 = versionInt$factory();
      var tmp1_safe_receiver_2 = _this_._get_extra__71();
      var tmp;
      if (tmp1_safe_receiver_2 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_3 = tmp0_getValue_0._name_1;
        tmp = tmp1_safe_receiver_2.get_116(tmp0_elvis_lhs_3 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3);
      }
      var tmp_0 = tmp;
      var res_1 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      if (res_1 == null) {
        var r_4 = tmp0_getValue_0._defaultGen_0(_this_);
        if (_this_._get_extra__71() == null)
          _this_._set_extra__71(LinkedHashMap_init_$Create$());
        var tmp1_safe_receiver_2_2_5 = _this_._get_extra__71();
        if (tmp1_safe_receiver_2_2_5 == null)
          null;
        else {
          var tmp0_elvis_lhs_3_4_7 = tmp0_getValue_0._name_1;
          var tmp0_set_0_3_6 = tmp0_elvis_lhs_3_4_7 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3_4_7;
          var tmp1_set_0_5_8 = (r_4 == null ? true : isObject(r_4)) ? r_4 : THROW_CCE();
          tmp1_safe_receiver_2_2_5.put_18(tmp0_set_0_3_6, tmp1_set_0_5_8);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_4;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var versionInt$delegate;
  function ensure_2($this) {
    if (!($this._cachedVersion_0 === $this._$this_17._get_contextVersion__1())) {
      var start_1 = PerformanceCounter_getInstance()._get_microseconds_();
      var oldCachedVersion_5 = $this._cachedVersion_0;
      $this._cachedVersion_0 = $this._$this_17._get_contextVersion__1();
      $this._id_9 = $this._gl_0.createProgram_1();
      if (Companion_getInstance_124()._get_DEBUG_GLSL_()) {
        Console_getInstance().warn_1(['' + 'OpenglAG: Creating program ' + $this._program_1._name_22 + ' with id ' + $this._id_9 + ' because contextVersion: ' + oldCachedVersion_5 + ' != ' + $this._$this_17._get_contextVersion__1()]);
      }var tmp0_elvis_lhs_7 = $this._$this_17._get_glSlVersion__0();
      var guessedGlSlVersion_6 = tmp0_elvis_lhs_7 == null ? _get_versionInt_($this._gl_0) : tmp0_elvis_lhs_7;
      var tmp1_safe_receiver_10 = Companion_getInstance_124()._get_FORCE_GLSL_VERSION_();
      var tmp3_elvis_lhs_9 = tmp1_safe_receiver_10 == null ? null : toIntOrNull(tmp1_safe_receiver_10);
      var tmp;
      if (tmp3_elvis_lhs_9 == null) {
        var tmp2_subject_11 = guessedGlSlVersion_6;
        tmp = tmp2_subject_11 === 460 ? 460 : (300 <= tmp2_subject_11 ? tmp2_subject_11 <= 450 : false) ? 100 : guessedGlSlVersion_6;
      } else {
        tmp = tmp3_elvis_lhs_9;
      }
      var usedGlSlVersion_8 = tmp;
      if (Companion_getInstance_124()._get_DEBUG_GLSL_()) {
        Console_getInstance().trace_0(['' + 'GLSL version: requested=' + $this._$this_17._get_glSlVersion__0() + ', guessed=' + guessedGlSlVersion_6 + ', forced=' + Companion_getInstance_124()._get_FORCE_GLSL_VERSION_() + '. used=' + usedGlSlVersion_8]);
      }var tmp_0 = $this;
      var tmp0_createShaderCompat_0_12 = $this._gl_0._FRAGMENT_SHADER;
      var tmp_1;
      try {
        var tmp1__anonymous__2_13 = true;
        tmp_1 = createShader($this, tmp0_createShaderCompat_0_12, toNewGlslStringResult($this._program_1._fragment_0, new GlslConfig($this._$this_17._get_gles__1(), usedGlSlVersion_8, tmp1__anonymous__2_13, $this._$this_17._get_android__1(), $this._programConfig))._result_4);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof ShaderException) {
          var tmp2__anonymous__2_15 = false;
          tmp_2 = createShader($this, tmp0_createShaderCompat_0_12, toNewGlslStringResult($this._program_1._fragment_0, new GlslConfig($this._$this_17._get_gles__1(), usedGlSlVersion_8, tmp2__anonymous__2_15, $this._$this_17._get_android__1(), $this._programConfig))._result_4);
        } else {
          {
            throw $p;
          }
        }
        tmp_1 = tmp_2;
      }
      tmp_0._fragmentShaderId = tmp_1;
      var tmp_3 = $this;
      var tmp3_createShaderCompat_0_16 = $this._gl_0._VERTEX_SHADER;
      var tmp_4;
      try {
        var tmp4__anonymous__2_17 = true;
        tmp_4 = createShader($this, tmp3_createShaderCompat_0_16, toNewGlslStringResult($this._program_1._vertex, new GlslConfig($this._$this_17._get_gles__1(), usedGlSlVersion_8, tmp4__anonymous__2_17, $this._$this_17._get_android__1(), $this._programConfig))._result_4);
      } catch ($p_0) {
        var tmp_5;
        if ($p_0 instanceof ShaderException) {
          var tmp5__anonymous__2_19 = false;
          tmp_5 = createShader($this, tmp3_createShaderCompat_0_16, toNewGlslStringResult($this._program_1._vertex, new GlslConfig($this._$this_17._get_gles__1(), usedGlSlVersion_8, tmp5__anonymous__2_19, $this._$this_17._get_android__1(), $this._programConfig))._result_4);
        } else {
          {
            throw $p_0;
          }
        }
        tmp_4 = tmp_5;
      }
      tmp_3._vertexShaderId = tmp_4;
      $this._gl_0.attachShader_1($this._id_9, $this._fragmentShaderId);
      $this._gl_0.attachShader_1($this._id_9, $this._vertexShaderId);
      $this._gl_0.linkProgram_1($this._id_9);
      $this._$this_17._tempBuffer1.setInt(0, 0);
      $this._gl_0.getProgramiv_0($this._id_9, $this._gl_0._LINK_STATUS, $this._$this_17._tempBuffer1);
      var end_2 = PerformanceCounter_getInstance()._get_microseconds_();
      var tmp0__get_microseconds__0_3 = end_2 - start_1;
      var time = Companion_getInstance_27().fromMicroseconds(tmp0__get_microseconds__0_3);
      if (Companion_getInstance_124()._get_DEBUG_GLSL_()) {
        Console_getInstance().info_1(['' + 'OpenglAG: Created program ' + $this._program_1._name_22 + ' with id ' + $this._id_9 + ' in time=' + new TimeSpan(time)]);
      }}}
  function createShader($this, type, str) {
    var shaderId = $this._gl_0.createShader_1(type);
    $this._gl_0.shaderSource_1(shaderId, str);
    $this._gl_0.compileShader_1(shaderId);
    var out = getShaderiv($this._gl_0, shaderId, $this._gl_0._COMPILE_STATUS);
    var errorInt = $this._gl_0.getError_1();
    if (!(out === $this._gl_0._GTRUE)) {
      var error = getShaderInfoLog($this._gl_0, shaderId);
      throw new ShaderException(str, error, errorInt, $this._gl_0);
    }return shaderId;
  }
  function setWrapST($this) {
    $this._gl_1.texParameteri_1($this._forcedTexTarget, $this._gl_1._TEXTURE_WRAP_S, $this._gl_1._CLAMP_TO_EDGE);
    $this._gl_1.texParameteri_1($this._forcedTexTarget, $this._gl_1._TEXTURE_WRAP_T, $this._gl_1._CLAMP_TO_EDGE);
  }
  function setMinMag($this, min, mag) {
    $this._gl_1.texParameteri_1($this._forcedTexTarget, $this._gl_1._TEXTURE_MIN_FILTER, min);
    $this._gl_1.texParameteri_1($this._forcedTexTarget, $this._gl_1._TEXTURE_MAG_FILTER, mag);
  }
  function ShaderException(str, error, errorInt, gl) {
    RuntimeException_init_$Init$_0('' + 'Error Compiling Shader : ' + errorInt + " : '" + error + "' : source='" + str + "', gl.versionInt=" + _get_versionInt_(gl) + ", gl.versionString='" + _get_versionString_(gl) + "', gl=" + gl, this);
    this._str_4 = str;
    this._error = error;
    this._errorInt = errorInt;
    this._gl = gl;
    captureStack(this, ShaderException);
  }
  ShaderException.$metadata$ = {
    simpleName: 'ShaderException',
    kind: 'class',
    interfaces: []
  };
  function setViewport($this, buffer) {
    $this._get_gl__0().viewport_1(buffer._get_x__36(), buffer._get_y__36(), buffer._get_width__58(), buffer._get_height__58());
  }
  function GlRenderBuffer($outer) {
    this._$this_16 = $outer;
    RenderBuffer.call(this, $outer);
    this._cachedVersion = -1;
    var tmp = this;
    var tmp0_this = this._$this_16;
    var tmp1 = tmp0_this._lastRenderContextId;
    tmp0_this._lastRenderContextId = tmp1 + 1 | 0;
    tmp._id_8 = tmp1;
    this._depth = Companion_getInstance_38().invoke_874(4);
    this._framebuffer = Companion_getInstance_38().invoke_874(4);
  }
  GlRenderBuffer.prototype._get_ftex_ = function () {
    var tmp = this._get_tex__2();
    return tmp instanceof GlTexture ? tmp : THROW_CCE();
  };
  GlRenderBuffer.prototype.set_28 = function () {
    setViewport(this._$this_16, this);
    if (this._get_dirty__2()) {
      this._set_dirty__7(false);
      this._$this_16.setSwapInterval_0(0);
      if (!(this._cachedVersion === this._$this_16._get_contextVersion__1())) {
        this._cachedVersion = this._$this_16._get_contextVersion__1();
        this._$this_16._get_gl__0().genRenderbuffers_0(1, this._depth);
        this._$this_16._get_gl__0().genFramebuffers_0(1, this._framebuffer);
      }this._$this_16._get_gl__0().bindTexture_1(this._$this_16._get_gl__0()._TEXTURE_2D, this._get_ftex_()._get_tex__2());
      this._$this_16._get_gl__0().texParameteri_1(this._$this_16._get_gl__0()._TEXTURE_2D, this._$this_16._get_gl__0()._TEXTURE_MAG_FILTER, this._$this_16._get_gl__0()._LINEAR);
      this._$this_16._get_gl__0().texParameteri_1(this._$this_16._get_gl__0()._TEXTURE_2D, this._$this_16._get_gl__0()._TEXTURE_MIN_FILTER, this._$this_16._get_gl__0()._LINEAR);
      this._$this_16._get_gl__0().texImage2D_2(this._$this_16._get_gl__0()._TEXTURE_2D, 0, this._$this_16._get_gl__0()._RGBA, this._get_width__58(), this._get_height__58(), 0, this._$this_16._get_gl__0()._RGBA, this._$this_16._get_gl__0()._UNSIGNED_BYTE, null);
      this._$this_16._get_gl__0().bindTexture_1(this._$this_16._get_gl__0()._TEXTURE_2D, 0);
      this._$this_16._get_gl__0().bindRenderbuffer_1(this._$this_16._get_gl__0()._RENDERBUFFER, this._depth.getInt(0));
      this._$this_16._get_gl__0().renderbufferStorage_1(this._$this_16._get_gl__0()._RENDERBUFFER, this._$this_16._get_gl__0()._DEPTH_COMPONENT16, this._get_width__58(), this._get_height__58());
    }this._$this_16._get_gl__0().bindFramebuffer_1(this._$this_16._get_gl__0()._FRAMEBUFFER, this._framebuffer.getInt(0));
    this._$this_16._get_gl__0().framebufferTexture2D_1(this._$this_16._get_gl__0()._FRAMEBUFFER, this._$this_16._get_gl__0()._COLOR_ATTACHMENT0, this._$this_16._get_gl__0()._TEXTURE_2D, this._get_ftex_()._get_tex__2(), 0);
    this._$this_16._get_gl__0().framebufferRenderbuffer_1(this._$this_16._get_gl__0()._FRAMEBUFFER, this._$this_16._get_gl__0()._DEPTH_ATTACHMENT, this._$this_16._get_gl__0()._RENDERBUFFER, this._depth.getInt(0));
  };
  GlRenderBuffer.prototype.close_77 = function () {
    var tmp0_apply_0 = this._$this_16._get_gl__0();
    tmp0_apply_0.deleteFramebuffers_0(1, this._framebuffer);
    tmp0_apply_0.deleteRenderbuffers_0(1, this._depth);
    this._framebuffer.setInt(0, 0);
    this._depth.setInt(0, 0);
    Unit_getInstance();
  };
  GlRenderBuffer.prototype.toString = function () {
    return '' + 'GlRenderBuffer[' + this._id_8 + '](' + this._get_width__58() + ', ' + this._get_height__58() + ')';
  };
  GlRenderBuffer.$metadata$ = {
    simpleName: 'GlRenderBuffer',
    kind: 'class',
    interfaces: []
  };
  function toGl(_this_, $this) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject.equals(BlendEquation_ADD_getInstance())) {
      tmp = $this._get_gl__0()._FUNC_ADD;
    } else if (tmp0_subject.equals(BlendEquation_SUBTRACT_getInstance())) {
      tmp = $this._get_gl__0()._FUNC_SUBTRACT;
    } else if (tmp0_subject.equals(BlendEquation_REVERSE_SUBTRACT_getInstance())) {
      tmp = $this._get_gl__0()._FUNC_REVERSE_SUBTRACT;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function toGl_0(_this_, $this) {
    var tmp0_subject = _this_;
    var tmp;
    if (tmp0_subject.equals(BlendFactor_DESTINATION_ALPHA_getInstance())) {
      tmp = $this._get_gl__0()._DST_ALPHA;
    } else if (tmp0_subject.equals(BlendFactor_DESTINATION_COLOR_getInstance())) {
      tmp = $this._get_gl__0()._DST_COLOR;
    } else if (tmp0_subject.equals(BlendFactor_ONE_getInstance())) {
      tmp = $this._get_gl__0()._ONE_0;
    } else if (tmp0_subject.equals(BlendFactor_ONE_MINUS_DESTINATION_ALPHA_getInstance())) {
      tmp = $this._get_gl__0()._ONE_MINUS_DST_ALPHA;
    } else if (tmp0_subject.equals(BlendFactor_ONE_MINUS_DESTINATION_COLOR_getInstance())) {
      tmp = $this._get_gl__0()._ONE_MINUS_DST_COLOR;
    } else if (tmp0_subject.equals(BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance())) {
      tmp = $this._get_gl__0()._ONE_MINUS_SRC_ALPHA;
    } else if (tmp0_subject.equals(BlendFactor_ONE_MINUS_SOURCE_COLOR_getInstance())) {
      tmp = $this._get_gl__0()._ONE_MINUS_SRC_COLOR;
    } else if (tmp0_subject.equals(BlendFactor_SOURCE_ALPHA_getInstance())) {
      tmp = $this._get_gl__0()._SRC_ALPHA;
    } else if (tmp0_subject.equals(BlendFactor_SOURCE_COLOR_getInstance())) {
      tmp = $this._get_gl__0()._SRC_COLOR;
    } else if (tmp0_subject.equals(BlendFactor_ZERO_getInstance())) {
      tmp = $this._get_gl__0()._ZERO_3;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  }
  function GlProgram($outer, gl, program, programConfig) {
    this._$this_17 = $outer;
    this._gl_0 = gl;
    this._program_1 = program;
    this._programConfig = programConfig;
    this._cachedVersion_0 = -1;
    this._id_9 = 0;
    this._fragmentShaderId = 0;
    this._vertexShaderId = 0;
    this._cachedAttribLocations = FastStringMap();
  }
  GlProgram.prototype.getAttribLocation_1 = function (name) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getOrPut_0 = this._cachedAttribLocations;
      var res_1 = tmp0_getOrPut_0.get(name);
      if (!(res_1 == null)) {
        tmp$ret$0 = res_1;
        break l$ret$1;
      }var out_2 = this._gl_0.getAttribLocation_2(this._id_9, name);
      tmp0_getOrPut_0.set(name, out_2);
      tmp$ret$0 = out_2;
    }
     while (false);
    return tmp$ret$0;
  };
  GlProgram.prototype.use = function () {
    ensure_2(this);
    this._gl_0.useProgram_1(this._id_9);
  };
  GlProgram.prototype.close_77 = function () {
    this._gl_0.deleteShader_1(this._fragmentShaderId);
    this._gl_0.deleteShader_1(this._vertexShaderId);
    this._gl_0.deleteProgram_1(this._id_9);
  };
  GlProgram.$metadata$ = {
    simpleName: 'GlProgram',
    kind: 'class',
    interfaces: [Closeable]
  };
  function TextureGeneric() {
  }
  TextureGeneric.prototype._get_texRef_ = function () {
    var tmp0_getValue_0 = this._texRef$delegate;
    var tmp1_getValue_0 = texRef$factory();
    return tmp0_getValue_0._get_value__10();
  };
  TextureGeneric.prototype.initialiseIfNeeded = function () {
    if (!this._initialised) {
      this._get_texRef_();
      Unit_getInstance();
      this._init(this, this._$this_18._get_gl__0());
      this._initialised = true;
    }};
  TextureGeneric.$metadata$ = {
    simpleName: 'TextureGeneric',
    kind: 'class',
    interfaces: []
  };
  function GlBuffer($outer, kind) {
    this._$this_19 = $outer;
    Buffer.call(this, kind);
    this._cachedVersion_1 = -1;
    this._id_10 = -1;
    this._glKind = kind.equals(Kind_INDEX_getInstance()) ? this._$this_19._get_gl__0()._ELEMENT_ARRAY_BUFFER : this._$this_19._get_gl__0()._ARRAY_BUFFER;
  }
  GlBuffer.prototype.afterSetMem_1 = function () {
  };
  GlBuffer.prototype.close_77 = function () {
    var tmp0_fbuffer_0 = 4;
    var tmp0_run_0_1 = Companion_getInstance_38().invoke_874(tmp0_fbuffer_0);
    tmp0_run_0_1.setInt(0, this._id_10);
    this._$this_19._get_gl__0().deleteBuffers_0(1, tmp0_run_0_1);
    this._id_10 = -1;
  };
  GlBuffer.prototype.getGlId = function (gl) {
    if (!(this._cachedVersion_1 === this._$this_19._get_contextVersion__1())) {
      this._cachedVersion_1 = this._$this_19._get_contextVersion__1();
      this._set_dirty__7(true);
      this._id_10 = -1;
    }if (this._id_10 < 0) {
      var tmp = this;
      var tmp0_fbuffer_0 = 4;
      var tmp0_run_0_1 = Companion_getInstance_38().invoke_874(tmp0_fbuffer_0);
      gl.genBuffers_0(1, tmp0_run_0_1);
      tmp._id_10 = tmp0_run_0_1.getInt(0);
    }if (this._get_dirty__2()) {
      this._bind(gl, this._id_10);
      if (!(this._get_mem__1() == null)) {
        gl.bufferData_1(this._glKind, this._get_memLength__0(), ensureNotNull(this._get_mem__1()), gl._STATIC_DRAW);
      }}return this._id_10;
  };
  GlBuffer.prototype._bind = function (gl, id) {
    gl.bindBuffer_1(this._glKind, id);
  };
  GlBuffer.prototype.bind_0 = function (gl) {
    this._bind(gl, this.getGlId(gl));
  };
  GlBuffer.$metadata$ = {
    simpleName: 'GlBuffer',
    kind: 'class',
    interfaces: []
  };
  function GlTexture($outer, gl, premultiplied) {
    this._$this_20 = $outer;
    Texture.call(this, $outer);
    this._gl_1 = gl;
    this._premultiplied_10 = premultiplied;
    this._cachedVersion_2 = -1;
    this._texIds = Companion_getInstance_38().invoke_874(4);
    this._forcedTexId = -1;
    this._forcedTexTarget = this._gl_1._TEXTURE_2D;
    this._GL_UNPACK_ALIGNMENT = 3317;
    this._GL_UNPACK_LSB_FIRST = 3313;
    this._GL_UNPACK_ROW_LENGTH = 3314;
    this._GL_UNPACK_SKIP_PIXELS = 3316;
    this._GL_UNPACK_SKIP_ROWS = 3315;
    this._GL_UNPACK_SWAP_BYTES = 3312;
    this._closed_0 = false;
  }
  GlTexture.prototype._get_premultiplied__8 = function () {
    return this._premultiplied_10;
  };
  GlTexture.prototype._get_tex__2 = function () {
    if (this._forcedTexId >= 0)
      return this._forcedTexId;
    if (!(this._cachedVersion_2 === this._$this_20._get_contextVersion__1())) {
      this._cachedVersion_2 = this._$this_20._get_contextVersion__1();
      this.invalidate_23();
      this._gl_1.genTextures_0(1, this._texIds);
    }return this._texIds.getInt(0);
  };
  GlTexture.prototype.createBufferForBitmap = function (bmp) {
    var tmp0_subject = bmp;
    var tmp;
    if (tmp0_subject == null) {
      tmp = null;
    } else {
      if (tmp0_subject instanceof NativeImage) {
        unsupported_1('Should not call createBufferForBitmap with a NativeImage');
      } else {
        if (tmp0_subject instanceof Bitmap8) {
          var mem = Companion_getInstance_38().invoke_874(bmp._get_area__7());
          arraycopy_9(bmp._get_data__2(), 0, mem._arrayByte, 0, bmp._get_area__7());
          return mem;
        } else {
          {
            var abmp = this._premultiplied_10 ? bmp.toBMP32IfRequired_5().premultipliedIfRequired() : bmp.toBMP32IfRequired_5().depremultipliedIfRequired();
            var mem_0 = Companion_getInstance_38().invoke_874(imul(abmp._get_area__7(), 4));
            arraycopy_10(_RgbaArray___get_ints__impl_(abmp._data_39), 0, mem_0._arrayInt, 0, abmp._get_area__7());
            return mem_0;
          }
        }
      }
    }
    return tmp;
  };
  GlTexture.prototype.actualSyncUpload_1 = function (source, bmp, requestMipmaps) {
    this._set_mipmaps__0(false);
    var bytesPerPixel = source._get_rgba__0() ? 4 : 1;
    var tmp;
    if (source._get_rgba__0()) {
      tmp = this._gl_1._RGBA;
    } else {
      tmp = this._gl_1._LUMINANCE;
    }
    var type = tmp;
    var tmp0_subject = bmp;
    var tmp_0;
    if (tmp0_subject instanceof BitmapVector) {
      tmp_0 = bmp._get_nativeImage_();
    } else {
      {
        tmp_0 = bmp;
      }
    }
    var bmp_0 = tmp_0;
    var tmp1_subject = bmp_0;
    if (!(tmp1_subject == null) ? isInterface(tmp1_subject, ForcedTexId) : false) {
      this._forcedTexId = bmp_0._get_forcedTexId__2();
      if (!(bmp_0 == null) ? isInterface(bmp_0, ForcedTexTarget) : false)
        this._forcedTexTarget = bmp_0._get_forcedTexTarget__2();
      else {
      }
      return Unit_getInstance();
    } else {
      if (tmp1_subject instanceof NativeImage) {
        if (!(bmp_0._get_forcedTexId__2() === -1)) {
          this._forcedTexId = bmp_0._get_forcedTexId__2();
          if (!(bmp_0._get_forcedTexTarget__2() === -1))
            this._forcedTexTarget = bmp_0._get_forcedTexTarget__2();
          return Unit_getInstance();
        }this._$this_20.prepareUploadNativeTexture_0(bmp_0);
        if (!(bmp_0._get_area__7() === 0)) {
          this.prepareTexImage2D();
          this._gl_1.texImage2D_3(this._forcedTexTarget, 0, type, type, this._gl_1._UNSIGNED_BYTE, bmp_0);
        }} else {
        {
          var buffer = this.createBufferForBitmap(bmp_0);
          if (((!(buffer == null) ? !(source._get_width__58() === 0) : false) ? !(source._get_height__58() === 0) : false) ? !(buffer._size_3 === 0) : false) {
            this.prepareTexImage2D();
            this._gl_1.texImage2D_2(this._forcedTexTarget, 0, type, source._get_width__58(), source._get_height__58(), 0, type, this._gl_1._UNSIGNED_BYTE, buffer);
          }}
      }
    }
    if ((requestMipmaps ? _get_isPowerOfTwo_(source._get_width__58()) : false) ? _get_isPowerOfTwo_(source._get_height__58()) : false) {
      this._set_mipmaps__0(true);
      this.bind_2();
      this.setFilter(true);
      setWrapST(this);
      this._gl_1.generateMipmap_1(this._forcedTexTarget);
    } else {
    }
  };
  GlTexture.prototype.prepareTexImage2D = function () {
    if (this._$this_20._get_linux__0()) {
      this._gl_1.pixelStorei_1(this._GL_UNPACK_LSB_FIRST, this._gl_1._GFALSE);
      this._gl_1.pixelStorei_1(this._GL_UNPACK_SWAP_BYTES, this._gl_1._GTRUE);
    }};
  GlTexture.prototype.bind_2 = function () {
    return this._gl_1.bindTexture_1(this._forcedTexTarget, this._get_tex__2());
  };
  GlTexture.prototype.close_77 = function () {
    Texture.prototype.close_77.call(this);
    if (!this._closed_0) {
      this._closed_0 = true;
      if (this._cachedVersion_2 === this._$this_20._get_contextVersion__1()) {
        this._gl_1.deleteTextures_0(1, this._texIds);
        this._texIds.set_35(0, -1);
      } else {
      }
    }};
  GlTexture.prototype.setFilter = function (linear) {
    var tmp;
    if (this._get_mipmaps__0()) {
      tmp = linear ? this._gl_1._LINEAR_MIPMAP_NEAREST : this._gl_1._NEAREST_MIPMAP_NEAREST;
    } else {
      tmp = linear ? this._gl_1._LINEAR : this._gl_1._NEAREST;
    }
    var minFilter = tmp;
    var magFilter = linear ? this._gl_1._LINEAR : this._gl_1._NEAREST;
    setWrapST(this);
    setMinMag(this, minFilter, magFilter);
  };
  GlTexture.$metadata$ = {
    simpleName: 'GlTexture',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__277($backBufferTextureBinding2d, this$0, $backBufferRenderBufferBinding, $backBufferFrameBufferBinding) {
    this._$backBufferTextureBinding2d = $backBufferTextureBinding2d;
    this._this$0_64 = this$0;
    this._$backBufferRenderBufferBinding = $backBufferRenderBufferBinding;
    this._$backBufferFrameBufferBinding = $backBufferFrameBufferBinding;
    BaseRenderBufferImpl.call(this);
  }
  _no_name_provided__277.prototype.init_15 = function () {
    this._$backBufferTextureBinding2d._v = getIntegerv(this._this$0_64._get_gl__0(), this._this$0_64._get_gl__0()._TEXTURE_BINDING_2D);
    this._$backBufferRenderBufferBinding._v = getIntegerv(this._this$0_64._get_gl__0(), this._this$0_64._get_gl__0()._RENDERBUFFER_BINDING);
    this._$backBufferFrameBufferBinding._v = getIntegerv(this._this$0_64._get_gl__0(), this._this$0_64._get_gl__0()._FRAMEBUFFER_BINDING);
  };
  _no_name_provided__277.prototype.set_28 = function () {
    setViewport(this._this$0_64, this);
    this._this$0_64._get_gl__0().bindTexture_1(this._this$0_64._get_gl__0()._TEXTURE_2D, this._$backBufferTextureBinding2d._v);
    this._this$0_64._get_gl__0().bindRenderbuffer_1(this._this$0_64._get_gl__0()._RENDERBUFFER, this._$backBufferRenderBufferBinding._v);
    this._this$0_64._get_gl__0().bindFramebuffer_1(this._this$0_64._get_gl__0()._FRAMEBUFFER, this._$backBufferFrameBufferBinding._v);
  };
  _no_name_provided__277.prototype.unset_4 = function () {
    this._$backBufferTextureBinding2d._v = getIntegerv(this._this$0_64._get_gl__0(), this._this$0_64._get_gl__0()._TEXTURE_BINDING_2D);
    this._$backBufferRenderBufferBinding._v = getIntegerv(this._this$0_64._get_gl__0(), this._this$0_64._get_gl__0()._RENDERBUFFER_BINDING);
    this._$backBufferFrameBufferBinding._v = getIntegerv(this._this$0_64._get_gl__0(), this._this$0_64._get_gl__0()._FRAMEBUFFER_BINDING);
  };
  _no_name_provided__277.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AGOpengl() {
    AG.call(this);
    this._isGlAvailable = true;
    this._glSlVersion = null;
    this._gles = false;
    this._linux = false;
    this._android = false;
    this._webgl = false;
    this._devicePixelRatio_0 = 1.0;
    this._lastRenderContextId = 0;
    this._TEMP_MAX_MATRICES = 1024;
    this._tempBuffer1 = Companion_getInstance_38().invoke_874(4);
    this._tempBuffer_2 = Companion_getInstance_38().invoke_874(imul(64, this._TEMP_MAX_MATRICES));
    this._tempBufferM2 = Companion_getInstance_38().allocUnaligned(16);
    this._tempBufferM3 = Companion_getInstance_38().allocUnaligned(36);
    this._tempBufferM4 = Companion_getInstance_38().allocUnaligned(64);
    var tmp = this;
    var tmp0__get_f32__0 = this._tempBuffer_2;
    tmp._tempF32 = tmp0__get_f32__0._arrayFloat;
    this._tempFloats = new Float32Array(imul(16, this._TEMP_MAX_MATRICES));
    var tmp_0 = this;
    var tmp0_arrayOf_0 = [new Matrix3D()];
    tmp_0._mat3dArray = tmp0_arrayOf_0;
    this._finalScissorBL = Companion_getInstance_83().invoke_1005();
    this._tempRect_2 = Companion_getInstance_83().invoke_1005();
    this._programs = HashMap_init_$Create$();
  }
  AGOpengl.prototype._get_glSlVersion__0 = function () {
    return this._glSlVersion;
  };
  AGOpengl.prototype._get_gles__1 = function () {
    return this._gles;
  };
  AGOpengl.prototype._get_linux__0 = function () {
    return this._linux;
  };
  AGOpengl.prototype._get_android__1 = function () {
    return this._android;
  };
  AGOpengl.prototype._get_webgl__0 = function () {
    return this._webgl;
  };
  AGOpengl.prototype._get_devicePixelRatio__4 = function () {
    return this._devicePixelRatio_0;
  };
  AGOpengl.prototype.contextLost_4 = function () {
    Console_getInstance().info_1(['AG.contextLost()', this, this._get_gl__0(), this._get_gl__0()._get_root__33()]);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_contextVersion__1();
    tmp0_this._set_contextVersion__1(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  AGOpengl.prototype.createBuffer_5 = function (kind) {
    return new GlBuffer(this, kind);
  };
  AGOpengl.prototype.setSwapInterval_0 = function (value) {
  };
  AGOpengl.prototype.createMainRenderBuffer_4 = function () {
    var backBufferTextureBinding2d = {_v: 0};
    var backBufferRenderBufferBinding = {_v: 0};
    var backBufferFrameBufferBinding = {_v: 0};
    return new _no_name_provided__277(backBufferTextureBinding2d, this, backBufferRenderBufferBinding, backBufferFrameBufferBinding);
  };
  AGOpengl.prototype.createRenderBuffer_4 = function () {
    return new GlRenderBuffer(this);
  };
  AGOpengl.prototype.toGl_1 = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(CompareMode_ALWAYS_getInstance())) {
      tmp = this._get_gl__0()._ALWAYS;
    } else if (tmp0_subject.equals(CompareMode_EQUAL_getInstance())) {
      tmp = this._get_gl__0()._EQUAL;
    } else if (tmp0_subject.equals(CompareMode_GREATER_getInstance())) {
      tmp = this._get_gl__0()._GREATER;
    } else if (tmp0_subject.equals(CompareMode_GREATER_EQUAL_getInstance())) {
      tmp = this._get_gl__0()._GEQUAL;
    } else if (tmp0_subject.equals(CompareMode_LESS_getInstance())) {
      tmp = this._get_gl__0()._LESS;
    } else if (tmp0_subject.equals(CompareMode_LESS_EQUAL_getInstance())) {
      tmp = this._get_gl__0()._LEQUAL;
    } else if (tmp0_subject.equals(CompareMode_NEVER_getInstance())) {
      tmp = this._get_gl__0()._NEVER;
    } else if (tmp0_subject.equals(CompareMode_NOT_EQUAL_getInstance())) {
      tmp = this._get_gl__0()._NOTEQUAL;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  AGOpengl.prototype.toGl_2 = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(StencilOp_DECREMENT_SATURATE_getInstance())) {
      tmp = this._get_gl__0()._DECR;
    } else if (tmp0_subject.equals(StencilOp_DECREMENT_WRAP_getInstance())) {
      tmp = this._get_gl__0()._DECR_WRAP;
    } else if (tmp0_subject.equals(StencilOp_INCREMENT_SATURATE_getInstance())) {
      tmp = this._get_gl__0()._INCR;
    } else if (tmp0_subject.equals(StencilOp_INCREMENT_WRAP_getInstance())) {
      tmp = this._get_gl__0()._INCR_WRAP;
    } else if (tmp0_subject.equals(StencilOp_INVERT_getInstance())) {
      tmp = this._get_gl__0()._INVERT;
    } else if (tmp0_subject.equals(StencilOp_KEEP_getInstance())) {
      tmp = this._get_gl__0()._KEEP;
    } else if (tmp0_subject.equals(StencilOp_SET_getInstance())) {
      tmp = this._get_gl__0()._REPLACE;
    } else if (tmp0_subject.equals(StencilOp_ZERO_getInstance())) {
      tmp = this._get_gl__0()._ZERO_3;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  AGOpengl.prototype.applyScissorState_0 = function (scissor) {
    if (this._get_currentRenderBuffer__1() == null) {
    }var tmp0_elvis_lhs = this._get_currentRenderBuffer__1();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentRenderBuffer = tmp;
    if (currentRenderBuffer === this._get_mainRenderBuffer__4()) {
      var realScissors = this._finalScissorBL;
      var tmp1_safe_receiver = realScissors;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver.setTo_2(0.0, 0.0, this._get_realBackWidth__1(), this._get_realBackHeight__1());
      Unit_getInstance();
      if (!(scissor == null)) {
        this._tempRect_2.setTo_6(currentRenderBuffer._get_x__36() + scissor._x_10 | 0, (currentRenderBuffer._get_y__36() + currentRenderBuffer._get_height__58() | 0) - (scissor._y_9 + scissor._height_9 | 0) | 0, scissor._width_9, scissor._height_9);
        Unit_getInstance();
        var tmp2_safe_receiver = realScissors;
        realScissors = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.intersection(this._tempRect_2, realScissors);
      }var renderBufferScissor = currentRenderBuffer._get_scissor__4();
      var tmp_0 = renderBufferScissor;
      if (!((tmp_0 == null ? null : new RectangleInt(tmp_0)) == null)) {
        var tmp3_safe_receiver = realScissors;
        realScissors = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.intersection(_RectangleInt___get_rect__impl_(renderBufferScissor), realScissors);
      } else {
      }
      this._get_gl__0().enable_2(this._get_gl__0()._SCISSOR_TEST);
      if (!(realScissors == null)) {
        this._get_gl__0().scissor_1(numberToInt(realScissors._x_3), numberToInt(realScissors._y_3), numberToInt(realScissors._width_0), numberToInt(realScissors._height_0));
      } else {
        this._get_gl__0().scissor_1(0, 0, 0, 0);
      }
    } else {
      this._get_gl__0().enableDisable_1(this._get_gl__0()._SCISSOR_TEST, !(scissor == null));
      if (!(scissor == null)) {
        this._get_gl__0().scissor_1(scissor._x_10, scissor._y_9, scissor._width_9, scissor._height_9);
      }}
  };
  AGOpengl.prototype.draw_21 = function (batch) {
    var vertices = batch._vertices;
    var program = batch._program;
    var type = batch._type_2;
    var vertexLayout = batch._vertexLayout;
    var vertexCount = batch._vertexCount;
    var indices = batch._indices;
    var indexType = batch._indexType;
    var offset = batch._offset_22;
    var blending = batch._blending;
    var uniforms = batch._uniforms;
    var stencil = batch._stencil;
    var colorMask = batch._colorMask;
    var renderState = batch._renderState;
    var scissor = batch._scissor;
    var vattrs = vertexLayout._attributes_6;
    var vattrspos = vertexLayout._attributePositions;
    this.applyScissorState_0(scissor);
    var useExternalSampler = false;
    var inductionVariable = 0;
    var last_1 = uniforms._uniforms_1._get_size__60();
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var uniform = uniforms._uniforms_1.get_137(n);
        var uniformType = uniform._get_type__10();
        var value = uniforms._values_2.get_137(n);
        var tmp1_subject = uniformType;
        if (tmp1_subject.equals(VarType_TextureUnit_getInstance())) {
          var unit = value instanceof TextureUnit ? value : THROW_CCE();
          var tmp = unit._texture_2;
          var tex = (tmp == null ? true : tmp instanceof GlTexture) ? tmp : THROW_CCE();
          if (!(tex == null)) {
            if (!(tex._forcedTexTarget === this._get_gl__0()._TEXTURE_2D) ? !(tex._forcedTexTarget === -1) : false) {
              useExternalSampler = true;
            }}}}
       while (inductionVariable < last_1);
    this.checkBuffers_1(vertices, indices);
    var programConfig = useExternalSampler ? Companion_getInstance_126()._EXTERNAL_TEXTURE_SAMPLER : Companion_getInstance_126()._DEFAULT_4;
    var glProgram = this.getProgram_0(program, programConfig);
    (vertices instanceof GlBuffer ? vertices : THROW_CCE()).bind_0(this._get_gl__0());
    var tmp2_safe_receiver = (indices == null ? true : indices instanceof GlBuffer) ? indices : null;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.bind_0(this._get_gl__0());
      Unit_getInstance();
    }
    Unit_getInstance();
    glProgram.use();
    var totalSize = vertexLayout._totalSize_2;
    var inductionVariable_0 = 0;
    var last_2 = vattrspos._get_size__60();
    if (inductionVariable_0 < last_2)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var att = vattrs.get_137(n_0);
        if (att._active) {
          var off = vattrspos.get_137(n_0);
          var loc = glProgram.getAttribLocation_1(att._get_name__50());
          var glElementType = this._get_glElementType__0(att._get_type__10());
          var elementCount = att._get_type__10()._elementCount;
          if (loc >= 0) {
            this._get_gl__0().enableVertexAttribArray_1(loc);
            this._get_gl__0().vertexAttribPointer_1(loc, elementCount, glElementType, att._normalized, totalSize, toLong(off));
          }}}
       while (inductionVariable_0 < last_2);
    var textureUnit = 0;
    var inductionVariable_1 = 0;
    var last_3 = uniforms._uniforms_1._get_size__60();
    if (inductionVariable_1 < last_3)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var uniform_0 = uniforms._uniforms_1.get_137(n_1);
        var uniformName = uniform_0._get_name__50();
        var uniformType_0 = uniform_0._get_type__10();
        var value_0 = uniforms._values_2.get_137(n_1);
        var location = this._get_gl__0().getUniformLocation_1(glProgram._id_9, uniformName);
        var declArrayCount = uniform_0._get_arrayCount__0();
        var stride = uniform_0._get_type__10()._elementCount;
        var tmp5_subject = uniformType_0;
        if (tmp5_subject.equals(VarType_TextureUnit_getInstance())) {
          var unit_0 = value_0 instanceof TextureUnit ? value_0 : THROW_CCE();
          this._get_gl__0().activeTexture_1(this._get_gl__0()._TEXTURE0 + textureUnit | 0);
          var tmp_0 = unit_0._texture_2;
          var tex_0 = (tmp_0 == null ? true : tmp_0 instanceof GlTexture) ? tmp_0 : THROW_CCE();
          var tmp6_safe_receiver = tex_0;
          if (tmp6_safe_receiver == null)
            null;
          else {
            tmp6_safe_receiver.bindEnsuring_1();
            Unit_getInstance();
          }
          Unit_getInstance();
          var tmp7_safe_receiver = tex_0;
          if (tmp7_safe_receiver == null)
            null;
          else {
            tmp7_safe_receiver.setFilter(unit_0._linear_0);
            Unit_getInstance();
          }
          Unit_getInstance();
          this._get_gl__0().uniform1i_1(location, textureUnit);
          var tmp8 = textureUnit;
          textureUnit = tmp8 + 1 | 0;
          Unit_getInstance();
        } else if (tmp5_subject.equals(VarType_SamplerCube_getInstance())) {
          var unit_1 = value_0 instanceof TextureUnit ? value_0 : THROW_CCE();
          this._get_gl__0().activeTexture_1(this._get_gl__0()._TEXTURE0 + textureUnit | 0);
          var tmp_1 = unit_1._texture_2;
          var tex_1 = tmp_1 instanceof TextureGeneric ? tmp_1 : THROW_CCE();
          tex_1.initialiseIfNeeded();
          tex_1.bindEnsuring_1();
          this._get_gl__0().uniform1i_1(location, textureUnit);
          var tmp9 = textureUnit;
          textureUnit = tmp9 + 1 | 0;
          Unit_getInstance();
        } else if ((tmp5_subject.equals(VarType_Mat2_getInstance()) ? true : tmp5_subject.equals(VarType_Mat3_getInstance())) ? true : tmp5_subject.equals(VarType_Mat4_getInstance())) {
          var tmp10_subject = value_0;
          var tmp_2;
          if (isArray(tmp10_subject)) {
            tmp_2 = value_0;
          } else {
            if (tmp10_subject instanceof Matrix3D) {
              var tmp0_also_0 = this._mat3dArray;
              tmp0_also_0[0].copyFrom_0(value_0);
              Unit_getInstance();
              tmp_2 = tmp0_also_0;
            } else {
              {
                var tmp1_error_0 = 'Not an array or a matrix3d';
                throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0));
              }
            }
          }
          var tmp_3 = tmp_2;
          var matArray = isArray(tmp_3) ? tmp_3 : THROW_CCE();
          var arrayCount = min2_7(declArrayCount, matArray.length);
          var tmp11_subject = uniformType_0;
          var matSize = tmp11_subject.equals(VarType_Mat2_getInstance()) ? 2 : tmp11_subject.equals(VarType_Mat3_getInstance()) ? 3 : tmp11_subject.equals(VarType_Mat4_getInstance()) ? 4 : -1;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < arrayCount)
            do {
              var n_2 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              copyToFloatWxH(matArray[n_2], this._tempFloats, matSize, matSize, MajorOrder_COLUMN_getInstance(), imul(n_2, stride));
            }
             while (inductionVariable_2 < arrayCount);
          setFloats(this._tempBuffer_2, 0, this._tempFloats, 0, imul(stride, arrayCount));
          Unit_getInstance();
          if (this._get_webgl__0()) {
            var tmp13_subject = uniformType_0;
            var tb = tmp13_subject.equals(VarType_Mat2_getInstance()) ? this._tempBufferM2 : tmp13_subject.equals(VarType_Mat3_getInstance()) ? this._tempBufferM3 : tmp13_subject.equals(VarType_Mat4_getInstance()) ? this._tempBufferM4 : this._tempBufferM4;
            var inductionVariable_3 = 0;
            if (inductionVariable_3 < arrayCount)
              do {
                var n_3 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                var itLocation = arrayCount === 1 ? location : this._get_gl__0().getUniformLocation_1(glProgram._id_9, uniform_0._get_indexNames__0()[n_3]);
                var tmp2__get_f32__0 = this._tempBuffer_2;
                var tmp_4 = imul(n_3, stride);
                arraycopy_8(tmp2__get_f32__0._arrayFloat, tmp_4, tb._arrayFloat, 0, stride);
                var tmp15_subject = uniform_0._get_type__10();
                if (tmp15_subject.equals(VarType_Mat2_getInstance()))
                  this._get_gl__0().uniformMatrix2fv_1(itLocation, 1, false, tb);
                else if (tmp15_subject.equals(VarType_Mat3_getInstance()))
                  this._get_gl__0().uniformMatrix3fv_1(itLocation, 1, false, tb);
                else if (tmp15_subject.equals(VarType_Mat4_getInstance()))
                  this._get_gl__0().uniformMatrix4fv_1(itLocation, 1, false, tb);
                else {
                  invalidOp('' + "Don't know how to set uniform matrix " + uniform_0._get_type__10());
                }
              }
               while (inductionVariable_3 < arrayCount);
          } else {
            var tmp16_subject = uniform_0._get_type__10();
            if (tmp16_subject.equals(VarType_Mat2_getInstance()))
              this._get_gl__0().uniformMatrix2fv_1(location, arrayCount, false, this._tempBuffer_2);
            else if (tmp16_subject.equals(VarType_Mat3_getInstance()))
              this._get_gl__0().uniformMatrix3fv_1(location, arrayCount, false, this._tempBuffer_2);
            else if (tmp16_subject.equals(VarType_Mat4_getInstance()))
              this._get_gl__0().uniformMatrix4fv_1(location, arrayCount, false, this._tempBuffer_2);
            else {
              invalidOp('' + "Don't know how to set uniform matrix " + uniform_0._get_type__10());
            }
          }
        } else if (((tmp5_subject.equals(VarType_Float1_getInstance()) ? true : tmp5_subject.equals(VarType_Float2_getInstance())) ? true : tmp5_subject.equals(VarType_Float3_getInstance())) ? true : tmp5_subject.equals(VarType_Float4_getInstance())) {
          var arrayCount_0 = declArrayCount;
          var tmp17_subject = value_0;
          if (isNumber(tmp17_subject))
            this._tempBuffer_2.setAlignedFloat32(0, numberToDouble(value_0));
          else {
            if (tmp17_subject instanceof Vector3D) {
              setFloats(this._tempBuffer_2, 0, value_0._data_36, 0, stride);
              Unit_getInstance();
            } else {
              if (isFloatArray(tmp17_subject)) {
                arrayCount_0 = min2_7(declArrayCount, value_0.length / stride | 0);
                setFloats(this._tempBuffer_2, 0, value_0, 0, imul(stride, arrayCount_0));
                Unit_getInstance();
              } else {
                if (isArray(tmp17_subject)) {
                  arrayCount_0 = min2_7(declArrayCount, value_0.length);
                  var inductionVariable_4 = 0;
                  var last_4 = value_0.length;
                  if (inductionVariable_4 < last_4)
                    do {
                      var n_4 = inductionVariable_4;
                      inductionVariable_4 = inductionVariable_4 + 1 | 0;
                      var tmp_5 = value_0[n_4];
                      var vector = tmp_5 instanceof Vector3D ? tmp_5 : THROW_CCE();
                      setFloats(this._tempBuffer_2, imul(n_4, stride), vector._data_36, 0, stride);
                      Unit_getInstance();
                    }
                     while (inductionVariable_4 < last_4);
                } else {
                  {
                    var tmp3_error_0 = '' + "Unknown type '" + value_0 + "'";
                    throw IllegalStateException_init_$Create$_0(toString_1(tmp3_error_0));
                  }
                }
              }
            }
          }
          if (this._get_webgl__0()) {
            var tb_0 = this._tempBufferM2;
            var inductionVariable_5 = 0;
            if (inductionVariable_5 < arrayCount_0)
              do {
                var n_5 = inductionVariable_5;
                inductionVariable_5 = inductionVariable_5 + 1 | 0;
                var itLocation_0 = arrayCount_0 === 1 ? location : this._get_gl__0().getUniformLocation_1(glProgram._id_9, uniform_0._get_indexNames__0()[n_5]);
                var f32 = tb_0._arrayFloat;
                var tmp4__get_f32__0 = this._tempBuffer_2;
                arraycopy_8(tmp4__get_f32__0._arrayFloat, 0, tb_0._arrayFloat, 0, stride);
                var tmp20_subject = uniform_0._get_type__10();
                if (tmp20_subject.equals(VarType_Float1_getInstance())) {
                  var tmp_6 = this._get_gl__0();
                  var tmp5_get_0 = 0;
                  tmp_6.uniform1f_1(itLocation_0, f32[tmp5_get_0]);
                } else if (tmp20_subject.equals(VarType_Float2_getInstance())) {
                  var tmp_7 = this._get_gl__0();
                  var tmp6_get_0 = 0;
                  var tmp_8 = f32[tmp6_get_0];
                  var tmp7_get_0 = 1;
                  tmp_7.uniform2f_1(itLocation_0, tmp_8, f32[tmp7_get_0]);
                } else if (tmp20_subject.equals(VarType_Float3_getInstance())) {
                  var tmp_9 = this._get_gl__0();
                  var tmp8_get_0 = 0;
                  var tmp_10 = f32[tmp8_get_0];
                  var tmp9_get_0 = 1;
                  var tmp_11 = f32[tmp9_get_0];
                  var tmp10_get_0 = 2;
                  tmp_9.uniform3f_1(itLocation_0, tmp_10, tmp_11, f32[tmp10_get_0]);
                } else if (tmp20_subject.equals(VarType_Float4_getInstance())) {
                  var tmp_12 = this._get_gl__0();
                  var tmp11_get_0 = 0;
                  var tmp_13 = f32[tmp11_get_0];
                  var tmp12_get_0 = 1;
                  var tmp_14 = f32[tmp12_get_0];
                  var tmp13_get_0 = 2;
                  var tmp_15 = f32[tmp13_get_0];
                  var tmp14_get_0 = 3;
                  tmp_12.uniform4f_1(itLocation_0, tmp_13, tmp_14, tmp_15, f32[tmp14_get_0]);
                } else
                  Unit_getInstance();
              }
               while (inductionVariable_5 < arrayCount_0);
          } else {
            var tmp21_subject = uniform_0._get_type__10();
            if (tmp21_subject.equals(VarType_Float1_getInstance()))
              this._get_gl__0().uniform1fv_1(location, arrayCount_0, this._tempBuffer_2);
            else if (tmp21_subject.equals(VarType_Float2_getInstance()))
              this._get_gl__0().uniform2fv_1(location, arrayCount_0, this._tempBuffer_2);
            else if (tmp21_subject.equals(VarType_Float3_getInstance()))
              this._get_gl__0().uniform3fv_1(location, arrayCount_0, this._tempBuffer_2);
            else if (tmp21_subject.equals(VarType_Float4_getInstance()))
              this._get_gl__0().uniform4fv_1(location, arrayCount_0, this._tempBuffer_2);
            else
              Unit_getInstance();
          }
        } else {
          invalidOp('' + "Don't know how to set uniform " + uniform_0._get_type__10());
        }
      }
       while (inductionVariable_1 < last_3);
    if (blending._get_enabled__3()) {
      this._get_gl__0().enable_2(this._get_gl__0()._BLEND);
      this._get_gl__0().blendEquationSeparate_1(toGl(blending._eqRGB, this), toGl(blending._eqA, this));
      this._get_gl__0().blendFuncSeparate_1(toGl_0(blending._srcRGB, this), toGl_0(blending._dstRGB, this), toGl_0(blending._srcA, this), toGl_0(blending._dstA, this));
    } else {
      this._get_gl__0().disable_2(this._get_gl__0()._BLEND);
    }
    if (renderState._frontFace.equals(FrontFace_BOTH_getInstance())) {
      this._get_gl__0().disable_2(this._get_gl__0()._CULL_FACE);
    } else {
      this._get_gl__0().enable_2(this._get_gl__0()._CULL_FACE);
      this._get_gl__0().frontFace_1(renderState._frontFace.equals(FrontFace_CW_getInstance()) ? this._get_gl__0()._CW : this._get_gl__0()._CCW);
    }
    this._get_gl__0().depthMask_1(renderState._depthMask);
    this._get_gl__0().depthRangef_0(renderState._depthNear, renderState._depthFar);
    this._get_gl__0().lineWidth_1(renderState._lineWidth_0);
    if (!renderState._depthFunc.equals(CompareMode_ALWAYS_getInstance())) {
      this._get_gl__0().enable_2(this._get_gl__0()._DEPTH_TEST);
      this._get_gl__0().depthFunc_1(this.toGl_1(renderState._depthFunc));
    } else {
      this._get_gl__0().disable_2(this._get_gl__0()._DEPTH_TEST);
    }
    this._get_gl__0().colorMask_1(colorMask._red, colorMask._green, colorMask._blue, colorMask._alpha_0);
    if (stencil._enabled) {
      this._get_gl__0().enable_2(this._get_gl__0()._STENCIL_TEST);
      this._get_gl__0().stencilFunc_1(this.toGl_1(stencil._compareMode), stencil._referenceValue, stencil._readMask);
      this._get_gl__0().stencilOp_1(this.toGl_2(stencil._actionOnDepthFail), this.toGl_2(stencil._actionOnDepthPassStencilFail), this.toGl_2(stencil._actionOnBothPass));
      this._get_gl__0().stencilMask_1(stencil._writeMask);
    } else {
      this._get_gl__0().disable_2(this._get_gl__0()._STENCIL_TEST);
      this._get_gl__0().stencilMask_1(0);
    }
    if (!(indices == null)) {
      this._get_gl__0().drawElements_1(this._get_glDrawMode__0(type), vertexCount, this._get_glIndexType__0(indexType), offset);
    } else {
      this._get_gl__0().drawArrays_1(this._get_glDrawMode__0(type), offset, vertexCount);
    }
    var inductionVariable_6 = 0;
    var last_5 = vattrs._get_size__60();
    if (inductionVariable_6 < last_5)
      do {
        var n_6 = inductionVariable_6;
        inductionVariable_6 = inductionVariable_6 + 1 | 0;
        var att_0 = vattrs.get_137(n_6);
        if (att_0._active) {
          var loc_0 = glProgram.getAttribLocation_1(att_0._get_name__50());
          if (loc_0 >= 0) {
            this._get_gl__0().disableVertexAttribArray_1(loc_0);
          }}}
       while (inductionVariable_6 < last_5);
  };
  AGOpengl.prototype._get_glDrawMode__0 = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(DrawType_POINTS_getInstance())) {
      tmp = this._get_gl__0()._POINTS;
    } else if (tmp0_subject.equals(DrawType_LINE_STRIP_getInstance())) {
      tmp = this._get_gl__0()._LINE_STRIP;
    } else if (tmp0_subject.equals(DrawType_LINE_LOOP_getInstance())) {
      tmp = this._get_gl__0()._LINE_LOOP;
    } else if (tmp0_subject.equals(DrawType_LINES_getInstance())) {
      tmp = this._get_gl__0()._LINES;
    } else if (tmp0_subject.equals(DrawType_TRIANGLE_STRIP_getInstance())) {
      tmp = this._get_gl__0()._TRIANGLE_STRIP;
    } else if (tmp0_subject.equals(DrawType_TRIANGLE_FAN_getInstance())) {
      tmp = this._get_gl__0()._TRIANGLE_FAN;
    } else if (tmp0_subject.equals(DrawType_TRIANGLES_getInstance())) {
      tmp = this._get_gl__0()._TRIANGLES;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  AGOpengl.prototype._get_glElementType__0 = function (_this__0) {
    var tmp0_subject = _this__0._kind_3;
    var tmp;
    if (tmp0_subject.equals(VarKind_TBYTE_getInstance())) {
      tmp = this._get_gl__0()._BYTE;
    } else if (tmp0_subject.equals(VarKind_TUNSIGNED_BYTE_getInstance())) {
      tmp = this._get_gl__0()._UNSIGNED_BYTE;
    } else if (tmp0_subject.equals(VarKind_TSHORT_getInstance())) {
      tmp = this._get_gl__0()._SHORT;
    } else if (tmp0_subject.equals(VarKind_TUNSIGNED_SHORT_getInstance())) {
      tmp = this._get_gl__0()._UNSIGNED_SHORT;
    } else if (tmp0_subject.equals(VarKind_TINT_getInstance())) {
      tmp = this._get_gl__0()._UNSIGNED_INT;
    } else if (tmp0_subject.equals(VarKind_TFLOAT_getInstance())) {
      tmp = this._get_gl__0()._FLOAT;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  AGOpengl.prototype._get_glIndexType__0 = function (_this__0) {
    var tmp0_subject = _this__0;
    var tmp;
    if (tmp0_subject.equals(IndexType_UBYTE_getInstance())) {
      tmp = this._get_gl__0()._UNSIGNED_BYTE;
    } else if (tmp0_subject.equals(IndexType_USHORT_getInstance())) {
      tmp = this._get_gl__0()._UNSIGNED_SHORT;
    } else if (tmp0_subject.equals(IndexType_UINT_getInstance())) {
      tmp = this._get_gl__0()._UNSIGNED_INT;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  AGOpengl.prototype.getProgram_0 = function (program, config) {
    var tmp0_getOrPut_0 = this._programs;
    var value_1 = tmp0_getOrPut_0.get_116(program);
    var tmp;
    if (value_1 == null) {
      var answer_2 = HashMap_init_$Create$();
      tmp0_getOrPut_0.put_18(program, answer_2);
      Unit_getInstance();
      tmp = answer_2;
    } else {
      tmp = value_1;
    }
    var tmp1_getOrPut_0 = tmp;
    var value_1_0 = tmp1_getOrPut_0.get_116(config);
    var tmp_0;
    if (value_1_0 == null) {
      var answer_2_0 = new GlProgram(this, this._get_gl__0(), program, config);
      tmp1_getOrPut_0.put_18(config, answer_2_0);
      Unit_getInstance();
      tmp_0 = answer_2_0;
    } else {
      tmp_0 = value_1_0;
    }
    return tmp_0;
  };
  AGOpengl.prototype.clear_28 = function (color_0, depth, stencil, clearColor, clearDepth, clearStencil) {
    var bits = 0;
    this.applyScissorState_0(null);
    if (clearColor) {
      bits = bits | this._get_gl__0()._COLOR_BUFFER_BIT;
      this._get_gl__0().clearColor_1(_RGBA___get_rf__impl_(color_0), _RGBA___get_gf__impl_(color_0), _RGBA___get_bf__impl_(color_0), _RGBA___get_af__impl_(color_0));
    }if (clearDepth) {
      bits = bits | this._get_gl__0()._DEPTH_BUFFER_BIT;
      this._get_gl__0().clearDepthf_0(depth);
    }if (clearStencil) {
      bits = bits | this._get_gl__0()._STENCIL_BUFFER_BIT;
      this._get_gl__0().stencilMask_1(-1);
      this._get_gl__0().clearStencil_1(stencil);
    }this._get_gl__0().clear_27(bits);
  };
  AGOpengl.prototype.createTexture_10 = function (premultiplied) {
    return new GlTexture(this, this._get_gl__0(), premultiplied);
  };
  AGOpengl.prototype.prepareUploadNativeTexture_0 = function (bmp) {
  };
  AGOpengl.$metadata$ = {
    simpleName: 'AGOpengl',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__278() {
  }
  _no_name_provided__278.prototype.invoke_508 = function ($this$$receiver) {
    return $this$$receiver.getString_1($this$$receiver._SHADING_LANGUAGE_VERSION);
  };
  _no_name_provided__278.prototype.invoke_1015 = function (p1) {
    return this.invoke_508(p1 instanceof KmlGl ? p1 : THROW_CCE());
  };
  _no_name_provided__278.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__279() {
  }
  _no_name_provided__279.prototype.invoke_508 = function ($this$$receiver) {
    var tmp = _get_versionString_($this$$receiver);
    var tmp0_trim_0 = replace$default_0(tmp, '.', '', false, 4, null);
    var tmp0_elvis_lhs = toIntOrNull(toString_1(trim_0(isCharSequence(tmp0_trim_0) ? tmp0_trim_0 : THROW_CCE())));
    return tmp0_elvis_lhs == null ? 100 : tmp0_elvis_lhs;
  };
  _no_name_provided__279.prototype.invoke_1015 = function (p1) {
    return this.invoke_508(p1 instanceof KmlGl ? p1 : THROW_CCE());
  };
  _no_name_provided__279.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function versionString$factory() {
    return getPropertyCallableRef('versionString', 1, KProperty1, function (receiver) {
      return _get_versionString_(receiver);
    }, null);
  }
  function versionInt$factory() {
    return getPropertyCallableRef('versionInt', 1, KProperty1, function (receiver) {
      return _get_versionInt_(receiver);
    }, null);
  }
  function texRef$factory() {
    return getPropertyCallableRef('texRef', 1, KProperty1, function (receiver) {
      return receiver._get_texRef_();
    }, null);
  }
  function _no_name_provided_$factory_235() {
    var i = new _no_name_provided__278();
    return function (p1) {
      return i.invoke_508(p1);
    };
  }
  function _no_name_provided_$factory_236() {
    var i = new _no_name_provided__279();
    return function (p1) {
      return i.invoke_508(p1);
    };
  }
  function setFloats(_this_, offset, data, dataOffset, count_0) {
    var inductionVariable = 0;
    if (inductionVariable < count_0)
      do {
        var n_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this_.setFloat(offset + n_3 | 0, data[dataOffset + n_3 | 0]);
      }
       while (inductionVariable < count_0);
    return _this_;
  }
  function PrintAG_init_$Init$(width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 640;
    if (!(($mask0 & 2) === 0))
      height = 480;
    PrintAG.call($this, width, height);
    return $this;
  }
  function PrintAG_init_$Create$(width, height, $mask0, $marker) {
    return PrintAG_init_$Init$(width, height, $mask0, $marker, Object.create(PrintAG.prototype));
  }
  function PrintAG(width, height) {
    LogBaseAG_init_$Init$(0, 0, 3, null, this);
  }
  PrintAG.prototype.log_6 = function (str) {
    println('' + 'PrintAG: ' + str);
  };
  PrintAG.$metadata$ = {
    simpleName: 'PrintAG',
    kind: 'class',
    interfaces: []
  };
  function LogAG_init_$Init$(width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 640;
    if (!(($mask0 & 2) === 0))
      height = 480;
    LogAG.call($this, width, height);
    return $this;
  }
  function LogAG_init_$Create$(width, height, $mask0, $marker) {
    return LogAG_init_$Init$(width, height, $mask0, $marker, Object.create(LogAG.prototype));
  }
  function LogAG(width, height) {
    LogBaseAG.call(this, width, height);
    var tmp = this;
    tmp._log = ArrayList_init_$Create$();
  }
  LogAG.prototype.log_6 = function (str) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._log;
    tmp0_plusAssign_0.add_39(str);
    Unit_getInstance();
  };
  LogAG.$metadata$ = {
    simpleName: 'LogAG',
    kind: 'class',
    interfaces: []
  };
  function LogBaseAG_init_$Init$(width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 640;
    if (!(($mask0 & 2) === 0))
      height = 480;
    LogBaseAG.call($this, width, height);
    return $this;
  }
  function LogTexture($outer, id, premultiplied) {
    this._$this_21 = $outer;
    Texture.call(this, $outer);
    this._id_11 = id;
    this._premultiplied_11 = premultiplied;
  }
  LogTexture.prototype._get_premultiplied__8 = function () {
    return this._premultiplied_11;
  };
  LogTexture.prototype.uploadedSource_1 = function () {
    this._$this_21.log_6('' + this + '.uploadedBitmap(' + this._get_source__0() + ', ' + this._get_source__0()._get_width__58() + ', ' + this._get_source__0()._get_height__58() + ')');
  };
  LogTexture.prototype.close_77 = function () {
    Texture.prototype.close_77.call(this);
    this._$this_21.log_6('' + this + '.close()');
  };
  LogTexture.prototype.toString = function () {
    return '' + 'Texture[' + this._id_11 + ']';
  };
  LogTexture.$metadata$ = {
    simpleName: 'LogTexture',
    kind: 'class',
    interfaces: []
  };
  function LogBuffer($outer, id, kind) {
    this._$this_22 = $outer;
    Buffer.call(this, kind);
    this._id_12 = id;
  }
  LogBuffer.prototype._get_logmem_ = function () {
    return this._get_mem__1();
  };
  LogBuffer.prototype._get_logmemOffset_ = function () {
    return this._get_memOffset__0();
  };
  LogBuffer.prototype.afterSetMem_1 = function () {
    return this._$this_22.log_6('' + this + '.afterSetMem(mem[' + ensureNotNull(this._get_mem__1())._size_3 + '])');
  };
  LogBuffer.prototype.close_77 = function () {
    return this._$this_22.log_6('' + this + '.close()');
  };
  LogBuffer.prototype.toString = function () {
    return '' + 'Buffer[' + this._id_12 + ']';
  };
  LogBuffer.$metadata$ = {
    simpleName: 'LogBuffer',
    kind: 'class',
    interfaces: []
  };
  function LogRenderBuffer($outer, id) {
    this._$this_23 = $outer;
    RenderBuffer.call(this, $outer);
    this._id_13 = id;
  }
  LogRenderBuffer.prototype.setSize_4 = function (x, y, width, height, fullWidth, fullHeight) {
    return this._$this_23.log_6('' + this + '.setSize(' + width + ', ' + height + ')');
  };
  LogRenderBuffer.prototype.set_28 = function () {
    return this._$this_23.log_6('' + this + '.set()');
  };
  LogRenderBuffer.prototype.close_77 = function () {
    return this._$this_23.log_6('' + this + '.close()');
  };
  LogRenderBuffer.prototype.toString = function () {
    return '' + 'RenderBuffer[' + this._id_13 + ']';
  };
  LogRenderBuffer.$metadata$ = {
    simpleName: 'LogRenderBuffer',
    kind: 'class',
    interfaces: []
  };
  function LogBaseAG(width, height) {
    AG.call(this);
    this._nativeComponent = new Object();
    this._backWidth = width;
    this._backHeight = height;
    this._textureId = 0;
    this._bufferId = 0;
    this._renderBufferId = 0;
  }
  LogBaseAG.prototype.log_6 = function (str) {
  };
  LogBaseAG.prototype.clear_28 = function (color_0, depth, stencil, clearColor, clearDepth, clearStencil) {
    return this.log_6('' + 'clear(' + new RGBA(color_0) + ', ' + depth + ', ' + stencil + ', ' + clearColor + ', ' + clearDepth + ', ' + clearStencil + ')');
  };
  LogBaseAG.prototype._get_backWidth__4 = function () {
    return this._backWidth;
  };
  LogBaseAG.prototype._get_backHeight__4 = function () {
    return this._backHeight;
  };
  LogBaseAG.prototype.createTexture_10 = function (premultiplied) {
    var tmp0_this = this;
    var tmp1 = tmp0_this._textureId;
    tmp0_this._textureId = tmp1 + 1 | 0;
    var tmp0_apply_0 = new LogTexture(this, tmp1, premultiplied);
    this.log_6('' + 'createTexture():' + tmp0_apply_0._id_11);
    return tmp0_apply_0;
  };
  LogBaseAG.prototype.createBuffer_5 = function (kind) {
    var tmp0_this = this;
    var tmp1 = tmp0_this._bufferId;
    tmp0_this._bufferId = tmp1 + 1 | 0;
    var tmp0_apply_0 = new LogBuffer(this, tmp1, kind);
    this.log_6('' + 'createBuffer(' + kind + '):' + tmp0_apply_0._id_12);
    return tmp0_apply_0;
  };
  LogBaseAG.prototype.draw_21 = function (batch) {
    var vertices = batch._vertices;
    var program = batch._program;
    var type = batch._type_2;
    var vertexLayout = batch._vertexLayout;
    var vertexCount = batch._vertexCount;
    var indices = batch._indices;
    var offset = batch._offset_22;
    var blending = batch._blending;
    var uniforms = batch._uniforms;
    var stencil = batch._stencil;
    var colorMask = batch._colorMask;
    var renderState = batch._renderState;
    var scissor = batch._scissor;
    try {
      this.log_6('' + 'draw(vertices=' + vertices + ', indices=' + indices + ', program=' + program + ', type=' + type + ', vertexLayout=' + vertexLayout + ', vertexCount=' + vertexCount + ', offset=' + offset + ', blending=' + blending + ', uniforms=' + uniforms + ', stencil=' + stencil + ', colorMask=' + colorMask + ')');
      var missingUniforms = minus_0(program._uniforms_4, uniforms._get_keys__3());
      var extraUniforms = minus(uniforms._get_keys__3(), program._uniforms_4);
      var missingAttributes = minus_0(toSet_0(vertexLayout._attributes_6), program._attributes_5);
      var extraAttributes = minus_0(program._attributes_5, toSet_0(vertexLayout._attributes_6));
      if (!missingUniforms.isEmpty_53())
        this.log_6('' + '::draw.ERROR.Missing:' + missingUniforms);
      else {
      }
      if (!extraUniforms.isEmpty_53())
        this.log_6('' + '::draw.ERROR.Unexpected:' + extraUniforms);
      else {
      }
      if (!missingAttributes.isEmpty_53())
        this.log_6('' + '::draw.ERROR.Missing:' + missingAttributes);
      else {
      }
      if (!extraAttributes.isEmpty_53())
        this.log_6('' + '::draw.ERROR.Unexpected:' + extraAttributes);
      else {
      }
      var vertexBuffer = vertices instanceof LogBuffer ? vertices : THROW_CCE();
      var vertexMem = ensureNotNull(vertexBuffer._get_logmem_());
      var vertexMemOffset = vertexBuffer._get_logmemOffset_();
      var indexMem = (indices instanceof LogBuffer ? indices : THROW_CCE())._get_logmem_();
      var tmp0_map_0 = until(offset, offset + vertexCount | 0);
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var inductionVariable = tmp0_map_0._get_first__6();
      var last_1 = tmp0_map_0._get_last__6();
      if (inductionVariable <= last_1)
        do {
          var item_2_3 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          tmp0_mapTo_0_1.add_39(ensureNotNull(indexMem).getAlignedInt16(item_2_3));
          Unit_getInstance();
        }
         while (!(item_2_3 === last_1));
      var _indices = tmp0_mapTo_0_1;
      this.log_6('' + '::draw.indices=' + _indices);
      var tmp0_iterator = distinct(sorted(_indices)).iterator_67();
      while (tmp0_iterator.hasNext_33()) {
        var index = tmp0_iterator.next_37();
        var os = index * vertexLayout._totalSize_2 | 0;
        var attributes = ArrayList_init_$Create$();
        var tmp1_iterator = zip(vertexLayout._attributes_6, vertexLayout._attributePositions).iterator_67();
        while (tmp1_iterator.hasNext_33()) {
          var tmp2_loop_parameter = tmp1_iterator.next_37();
          var attribute = tmp2_loop_parameter.component1_1();
          var pos = tmp2_loop_parameter.component2_1();
          var o = (os + pos | 0) + vertexMemOffset | 0;
          var tmp3_subject = attribute._get_type__10();
          var info = tmp3_subject.equals(VarType_Int1_getInstance()) ? 'int(' + vertexMem.getUnalignedInt32(o + 0 | 0) + ')' : tmp3_subject.equals(VarType_Float1_getInstance()) ? 'float(' + vertexMem.getUnalignedFloat32(o + 0 | 0) + ')' : tmp3_subject.equals(VarType_Float2_getInstance()) ? 'vec2(' + vertexMem.getUnalignedFloat32(o + 0 | 0) + ',' + vertexMem.getUnalignedFloat32(o + 4 | 0) + ')' : tmp3_subject.equals(VarType_Float3_getInstance()) ? 'vec3(' + vertexMem.getUnalignedFloat32(o + 0 | 0) + ',' + vertexMem.getUnalignedFloat32(o + 4 | 0) + ',' + vertexMem.getUnalignedFloat32(o + 8 | 0) + ')' : tmp3_subject.equals(VarType_Byte4_getInstance()) ? 'byte4(' + vertexMem.getUnalignedInt32(o + 0 | 0) + ')' : '' + 'Unsupported(' + attribute._get_type__10() + ')';
          var tmp1_plusAssign_0 = attribute._get_name__50() + '[' + info + ']';
          attributes.add_39(tmp1_plusAssign_0);
          Unit_getInstance();
        }
        var tmp = '' + '::draw.vertex[' + index + ']: ';
        this.log_6(tmp + joinToString$default_0(attributes, ', ', null, null, 0, null, null, 62, null));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        this.log_6('' + 'LogBaseAG.draw.ERROR: ' + $p.message);
        printStackTrace($p);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  LogBaseAG.prototype.disposeTemporalPerFrameStuff_4 = function () {
    return this.log_6('disposeTemporalPerFrameStuff()');
  };
  LogBaseAG.prototype.createRenderBuffer_4 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._renderBufferId;
    tmp0_this._renderBufferId = tmp1 + 1 | 0;
    var tmp0_apply_0 = new LogRenderBuffer(this, tmp1);
    this.log_6('' + 'createRenderBuffer():' + tmp0_apply_0._id_13);
    return tmp0_apply_0;
  };
  LogBaseAG.prototype.flipInternal_4 = function () {
    return this.log_6('flipInternal()');
  };
  LogBaseAG.$metadata$ = {
    simpleName: 'LogBaseAG',
    kind: 'class',
    interfaces: []
  };
  function toNewGlslStringResult(_this_, config) {
    return (new GlslGenerator(_this_._type_6, config)).generateResult(_this_._stm);
  }
  function Companion_125() {
    Companion_instance_124 = this;
    this._DEFAULT_VERSION = 100;
    this._FRAGCOLOR = 'fragColor';
    this._GL_FRAGCOLOR = 'gl_FragColor';
  }
  Companion_125.prototype._get_FORCE_GLSL_VERSION_ = function () {
    return Environment_getInstance().get_115('FORCE_GLSL_VERSION');
  };
  Companion_125.prototype._get_DEBUG_GLSL_ = function () {
    return Environment_getInstance().get_115('DEBUG_GLSL') === 'true';
  };
  Companion_125.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_124;
  function Companion_getInstance_124() {
    if (Companion_instance_124 == null)
      new Companion_125();
    return Companion_instance_124;
  }
  function errorType($this, type) {
    invalidOp('' + "Don't know how to serialize type " + type);
  }
  function Result(generator, result, attributes, uniforms, varyings) {
    this._generator = generator;
    this._result_4 = result;
    this._attributes_3 = attributes;
    this._uniforms_2 = uniforms;
    this._varyings = varyings;
  }
  Result.prototype.toString = function () {
    return '' + 'Result(generator=' + this._generator + ', result=' + this._result_4 + ', attributes=' + this._attributes_3 + ', uniforms=' + this._uniforms_2 + ', varyings=' + this._varyings + ')';
  };
  Result.prototype.hashCode = function () {
    var result = hashCode(this._generator);
    result = imul(result, 31) + getStringHashCode(this._result_4) | 0;
    result = imul(result, 31) + hashCode(this._attributes_3) | 0;
    result = imul(result, 31) + hashCode(this._uniforms_2) | 0;
    result = imul(result, 31) + hashCode(this._varyings) | 0;
    return result;
  };
  Result.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals_1(this._generator, tmp0_other_with_cast._generator))
      return false;
    if (!(this._result_4 === tmp0_other_with_cast._result_4))
      return false;
    if (!equals_1(this._attributes_3, tmp0_other_with_cast._attributes_3))
      return false;
    if (!equals_1(this._uniforms_2, tmp0_other_with_cast._uniforms_2))
      return false;
    if (!equals_1(this._varyings, tmp0_other_with_cast._varyings))
      return false;
    return true;
  };
  Result.$metadata$ = {
    simpleName: 'Result',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__280(this$0) {
    this._this$0_65 = this$0;
  }
  _no_name_provided__280.prototype.invoke_476 = function ($this$invoke) {
    if (this._this$0_65._get_gles__1()) {
      if (!this._this$0_65._get_android__1()) {
        if (this._this$0_65._get_compatibility_()) {
          $this$invoke.line_0('' + '#version ' + this._this$0_65._get_version__1() + ' compatibility');
          Unit_getInstance();
        } else {
          $this$invoke.line_0('' + '#version ' + this._this$0_65._get_version__1());
          Unit_getInstance();
        }
      }if (this._this$0_65._config_2._programConfig_0._externalTextureSampler) {
        $this$invoke.line_0('#extension GL_OES_EGL_image_external : require');
        Unit_getInstance();
      }$this$invoke.line_0('#ifdef GL_ES');
      Unit_getInstance();
      $this$invoke._indent();
      try {
        $this$invoke.line_0('precision highp float;');
        Unit_getInstance();
        $this$invoke.line_0('precision highp int;');
        Unit_getInstance();
        $this$invoke.line_0('precision lowp sampler2D;');
        Unit_getInstance();
        $this$invoke.line_0('precision lowp samplerCube;');
        Unit_getInstance();
      }finally {
        $this$invoke._unindent();
      }
      Unit_getInstance();
      $this$invoke.line_0('#else');
      Unit_getInstance();
      $this$invoke._indent();
      try {
        $this$invoke.line_0('  #define highp ');
        Unit_getInstance();
        $this$invoke.line_0('  #define mediump ');
        Unit_getInstance();
        $this$invoke.line_0('  #define lowp ');
        Unit_getInstance();
      }finally {
        $this$invoke._unindent();
      }
      Unit_getInstance();
      $this$invoke.line_0('#endif');
      Unit_getInstance();
    }var tmp0_iterator = this._this$0_65._attributes_4.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var it = tmp0_iterator.next_37();
      $this$invoke.line_0('' + this._this$0_65._IN + ' ' + this._this$0_65.precToString(it._get_precision__3()) + this._this$0_65.typeToString(it._get_type__10()) + ' ' + it._get_name__50() + this._this$0_65._get_arrayDecl_(it) + ';');
      Unit_getInstance();
    }
    var tmp1_iterator = this._this$0_65._uniforms_3.iterator_67();
    while (tmp1_iterator.hasNext_33()) {
      var it_0 = tmp1_iterator.next_37();
      $this$invoke.line_0('' + this._this$0_65._UNIFORM + ' ' + this._this$0_65.precToString(it_0._get_precision__3()) + this._this$0_65.typeToString(it_0._get_type__10()) + ' ' + it_0._get_name__50() + this._this$0_65._get_arrayDecl_(it_0) + ';');
      Unit_getInstance();
    }
    var tmp2_iterator = this._this$0_65._varyings_0.iterator_67();
    while (tmp2_iterator.hasNext_33()) {
      var it_1 = tmp2_iterator.next_37();
      if (this._this$0_65._newGlSlVersion ? it_1._get_name__50() === this._this$0_65._gl_FragColor : false) {
        $this$invoke.line_0('' + 'layout(location=0) ' + this._this$0_65._OUT + ' ' + this._this$0_65.precToString(it_1._get_precision__3()) + this._this$0_65.typeToString(it_1._get_type__10()) + ' ' + it_1._get_name__50() + ';');
        Unit_getInstance();
      } else {
        $this$invoke.line_0('' + this._this$0_65._OUT + ' ' + this._this$0_65.precToString(it_1._get_precision__3()) + this._this$0_65.typeToString(it_1._get_type__10()) + ' ' + it_1._get_name__50() + ';');
        Unit_getInstance();
      }
    }
    var tmp0_line_0 = 'void main()';
    var tmp;
    if (charSequenceLength(tmp0_line_0) === 0) {
      tmp = '{';
    } else {
      {
        tmp = '' + tmp0_line_0 + ' {';
      }
    }
    $this$invoke.line_0(tmp);
    Unit_getInstance();
    $this$invoke._indent();
    try {
      var tmp0_iterator_2 = this._this$0_65._temps.iterator_67();
      while (tmp0_iterator_2.hasNext_33()) {
        var temp_3 = tmp0_iterator_2.next_37();
        $this$invoke.line_0(this._this$0_65.precToString(temp_3._get_precision__3()) + this._this$0_65.typeToString(temp_3._get_type__10()) + ' ' + temp_3._get_name__50() + ';');
        Unit_getInstance();
      }
      $this$invoke.line(this._this$0_65._programIndenter);
      Unit_getInstance();
    }finally {
      $this$invoke._unindent();
    }
    Unit_getInstance();
    $this$invoke.line_0('}');
    Unit_getInstance();
    Unit_getInstance();
  };
  _no_name_provided__280.prototype.invoke_1015 = function (p1) {
    this.invoke_476(p1 instanceof Indenter ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__280.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__281(this$0) {
    this._this$0_66 = this$0;
  }
  _no_name_provided__281.prototype.invoke_480 = function (it) {
    return this._this$0_66.visit_24(it);
  };
  _no_name_provided__281.prototype.invoke_1015 = function (p1) {
    return this.invoke_480(p1 instanceof Operand ? p1 : THROW_CCE());
  };
  _no_name_provided__281.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__282(this$0) {
    this._this$0_67 = this$0;
  }
  _no_name_provided__282.prototype.invoke_480 = function (it) {
    return this._this$0_67.visit_24(it);
  };
  _no_name_provided__282.prototype.invoke_1015 = function (p1) {
    return this.invoke_480(p1 instanceof Operand ? p1 : THROW_CCE());
  };
  _no_name_provided__282.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GlslGenerator(kind, config) {
    Companion_getInstance_124();
    Visitor.call(this, '');
    this._kind_2 = kind;
    this._config_2 = config;
    this._newGlSlVersion = false;
    this._IN = this._newGlSlVersion ? 'in' : 'attribute';
    this._OUT = this._newGlSlVersion ? 'out' : 'varying';
    this._UNIFORM = 'uniform';
    this._gl_FragColor = this._newGlSlVersion ? Companion_getInstance_124()._FRAGCOLOR : Companion_getInstance_124()._GL_FRAGCOLOR;
    this._temps = LinkedHashSet_init_$Create$();
    this._attributes_4 = LinkedHashSet_init_$Create$();
    this._varyings_0 = LinkedHashSet_init_$Create$();
    this._uniforms_3 = LinkedHashSet_init_$Create$();
    var tmp = this;
    tmp._programIndenter = Indenter_init_$Create$(null, 1, null);
  }
  GlslGenerator.prototype._get_gles__1 = function () {
    return this._config_2._gles_0;
  };
  GlslGenerator.prototype._get_version__1 = function () {
    return this._config_2._version_2;
  };
  GlslGenerator.prototype._get_compatibility_ = function () {
    return this._config_2._compatibility;
  };
  GlslGenerator.prototype._get_android__1 = function () {
    return this._config_2._android_0;
  };
  GlslGenerator.prototype.precToString = function (prec) {
    var tmp;
    if (!this._get_gles__1()) {
      tmp = '';
    } else {
      var tmp0_subject = prec;
      var tmp_0;
      if (tmp0_subject.equals(Precision_DEFAULT_getInstance())) {
        tmp_0 = '';
      } else if (tmp0_subject.equals(Precision_LOW_getInstance())) {
        tmp_0 = 'lowp ';
      } else if (tmp0_subject.equals(Precision_MEDIUM_getInstance())) {
        tmp_0 = 'mediump ';
      } else if (tmp0_subject.equals(Precision_HIGH_getInstance())) {
        tmp_0 = 'highp ';
      } else {
        noWhenBranchMatchedException();
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  GlslGenerator.prototype.typeToString = function (type) {
    var tmp0_subject = type;
    var tmp;
    if (tmp0_subject.equals(VarType_Byte4_getInstance())) {
      tmp = 'vec4';
    } else if (tmp0_subject.equals(VarType_Mat2_getInstance())) {
      tmp = 'mat2';
    } else if (tmp0_subject.equals(VarType_Mat3_getInstance())) {
      tmp = 'mat3';
    } else if (tmp0_subject.equals(VarType_Mat4_getInstance())) {
      tmp = 'mat4';
    } else if (tmp0_subject.equals(VarType_TextureUnit_getInstance())) {
      tmp = this._config_2._programConfig_0._externalTextureSampler ? 'samplerExternalOES' : 'sampler2D';
    } else if (tmp0_subject.equals(VarType_Sampler1D_getInstance())) {
      tmp = 'sampler1d';
    } else if (tmp0_subject.equals(VarType_Sampler2D_getInstance())) {
      tmp = 'sampler2d';
    } else if (tmp0_subject.equals(VarType_Sampler3D_getInstance())) {
      tmp = 'sampler3d';
    } else if (tmp0_subject.equals(VarType_SamplerCube_getInstance())) {
      tmp = 'samplerCube';
    } else {
      var tmp1_subject = type._kind_3;
      var tmp_0;
      if ((((tmp1_subject.equals(VarKind_TBYTE_getInstance()) ? true : tmp1_subject.equals(VarKind_TUNSIGNED_BYTE_getInstance())) ? true : tmp1_subject.equals(VarKind_TSHORT_getInstance())) ? true : tmp1_subject.equals(VarKind_TUNSIGNED_SHORT_getInstance())) ? true : tmp1_subject.equals(VarKind_TFLOAT_getInstance())) {
        var tmp2_subject = type._elementCount;
        var tmp_1;
        switch (tmp2_subject) {
          case 1:
            tmp_1 = 'float';
            break;
          case 2:
            tmp_1 = 'vec2';
            break;
          case 3:
            tmp_1 = 'vec3';
            break;
          case 4:
            tmp_1 = 'vec4';
            break;
          default:errorType(this, type);
            break;
        }
        tmp_0 = tmp_1;
      } else if (tmp1_subject.equals(VarKind_TINT_getInstance())) {
        var tmp3_subject = type._elementCount;
        var tmp_2;
        switch (tmp3_subject) {
          case 1:
            tmp_2 = 'int';
            break;
          case 2:
            tmp_2 = 'ivec2';
            break;
          case 3:
            tmp_2 = 'ivec3';
            break;
          case 4:
            tmp_2 = 'ivec4';
            break;
          default:errorType(this, type);
            break;
        }
        tmp_0 = tmp_2;
      } else {
        noWhenBranchMatchedException();
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  GlslGenerator.prototype._get_arrayDecl_ = function (_this__0) {
    return !(_this__0._arrayCount === 1) ? '' + '[' + _this__0._arrayCount + ']' : '';
  };
  GlslGenerator.prototype.generateResult = function (root) {
    this._temps.clear_33();
    this._attributes_4.clear_33();
    this._varyings_0.clear_33();
    this._uniforms_3.clear_33();
    var tmp = this;
    tmp._programIndenter = Indenter_init_$Create$(null, 1, null);
    if (this._kind_2.equals(ShaderType_FRAGMENT_getInstance()) ? this._newGlSlVersion : false) {
      var tmp_0 = VarType_Float4_getInstance();
      this._varyings_0.add_39(Varying_init_$Create$_0(this._gl_FragColor, tmp_0, null, 4, null));
      Unit_getInstance();
    }this.visit_62(root);
    var tmp_1 = Companion_getInstance_57();
    var tmp0_also_0 = tmp_1.invoke_219(_no_name_provided_$factory_237(this)).toString();
    if (Companion_getInstance_124()._get_DEBUG_GLSL_()) {
      Console_getInstance().info_1(['' + 'GlSlGenerator.version: ' + this._get_version__1()]);
      Console_getInstance().debug_1(['' + 'GlSlGenerator:\n' + tmp0_also_0]);
    }var result = tmp0_also_0;
    return new Result(this, result, toList_2(this._attributes_4), toList_2(this._uniforms_3), toList_2(this._varyings_0));
  };
  GlslGenerator.prototype.visit_63 = function (stms) {
    var tmp0_iterator = stms._stms.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var stm = tmp0_iterator.next_37();
      this.visit_62(stm);
    }
  };
  GlslGenerator.prototype.visit_65 = function (stm) {
    this._programIndenter.line_0('' + this.visit_24(stm._to) + ' = ' + this.visit_24(stm._from) + ';');
    Unit_getInstance();
  };
  GlslGenerator.prototype.visit_66 = function (stm) {
    this._programIndenter.line_0('discard;');
    Unit_getInstance();
  };
  GlslGenerator.prototype.visit_35 = function (operand) {
    var tmp = this.typeToString(operand._type_3) + '(';
    return tmp + joinToString$default(operand._ops, ', ', null, null, 0, null, _no_name_provided_$factory_238(this), 30, null) + ')';
  };
  GlslGenerator.prototype.visit_32 = function (operand) {
    return '(' + this.visit_24(operand._left_1) + ' ' + operand._op_1 + ' ' + this.visit_24(operand._right_0) + ')';
  };
  GlslGenerator.prototype.visit_25 = function (func) {
    var tmp = func._name_21 + '(';
    return tmp + joinToString$default_0(func._ops_0, ', ', null, null, 0, null, _no_name_provided_$factory_239(this), 30, null) + ')';
  };
  GlslGenerator.prototype.visit_64 = function (stm) {
    var tmp0_apply_0 = this._programIndenter;
    var tmp0_line_0_2 = '' + 'if (' + this.visit_24(stm._cond) + ')';
    var tmp;
    if (charSequenceLength(tmp0_line_0_2) === 0) {
      tmp = '{';
    } else {
      {
        tmp = '' + tmp0_line_0_2 + ' {';
      }
    }
    tmp0_apply_0.line_0(tmp);
    Unit_getInstance();
    tmp0_apply_0._indent();
    try {
      this.visit_62(stm._tbody);
    }finally {
      tmp0_apply_0._unindent();
    }
    Unit_getInstance();
    tmp0_apply_0.line_0('}');
    Unit_getInstance();
    Unit_getInstance();
    if (!(stm._fbody == null)) {
      var tmp1_line_0_3 = 'else';
      var tmp_0;
      if (charSequenceLength(tmp1_line_0_3) === 0) {
        tmp_0 = '{';
      } else {
        {
          tmp_0 = '' + tmp1_line_0_3 + ' {';
        }
      }
      tmp0_apply_0.line_0(tmp_0);
      Unit_getInstance();
      tmp0_apply_0._indent();
      try {
        this.visit_62(ensureNotNull(stm._fbody));
      }finally {
        tmp0_apply_0._unindent();
      }
      Unit_getInstance();
      tmp0_apply_0.line_0('}');
      Unit_getInstance();
      Unit_getInstance();
    }Unit_getInstance();
  };
  GlslGenerator.prototype.visit_26 = function (operand) {
    Visitor.prototype.visit_26.call(this, operand);
    Unit_getInstance();
    var tmp0_subject = operand;
    var tmp;
    if (tmp0_subject instanceof Output_0) {
      var tmp1_subject = this._kind_2;
      var tmp_0;
      if (tmp1_subject.equals(ShaderType_VERTEX_getInstance())) {
        tmp_0 = 'gl_Position';
      } else if (tmp1_subject.equals(ShaderType_FRAGMENT_getInstance())) {
        tmp_0 = this._gl_FragColor;
      } else {
        noWhenBranchMatchedException();
      }
      tmp = tmp_0;
    } else {
      {
        tmp = operand._name_23;
      }
    }
    return tmp;
  };
  GlslGenerator.prototype.visit_27 = function (temp_0) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._temps;
    tmp0_plusAssign_0.add_39(temp_0);
    Unit_getInstance();
    return Visitor.prototype.visit_27.call(this, temp_0);
  };
  GlslGenerator.prototype.visit_61 = function (attribute) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._attributes_4;
    tmp0_plusAssign_0.add_39(attribute);
    Unit_getInstance();
    return Visitor.prototype.visit_61.call(this, attribute);
  };
  GlslGenerator.prototype.visit_29 = function (varying) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._varyings_0;
    tmp0_plusAssign_0.add_39(varying);
    Unit_getInstance();
    return Visitor.prototype.visit_29.call(this, varying);
  };
  GlslGenerator.prototype.visit_40 = function (uniform) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._uniforms_3;
    tmp0_plusAssign_0.add_39(uniform);
    Unit_getInstance();
    return Visitor.prototype.visit_40.call(this, uniform);
  };
  GlslGenerator.prototype.visit_31 = function (output_0) {
    return Visitor.prototype.visit_31.call(this, output_0);
  };
  GlslGenerator.prototype.visit_36 = function (operand) {
    return '' + operand._value_19;
  };
  GlslGenerator.prototype.visit_37 = function (operand) {
    var str = '' + operand._value_20;
    var tmp;
    var tmp_0 = new Char(46);
    if (contains$default(str, tmp_0, false, 2, null)) {
      tmp = str;
    } else {
      {
        tmp = '' + str + '.0';
      }
    }
    return tmp;
  };
  GlslGenerator.prototype.visit_38 = function (operand) {
    return '' + operand._value_21;
  };
  GlslGenerator.prototype.visit_33 = function (operand) {
    return this.visit_24(operand._left_2) + '.' + operand._swizzle;
  };
  GlslGenerator.prototype.visit_34 = function (operand) {
    return this.visit_24(operand._left_3) + '[' + this.visit_24(operand._index_13) + ']';
  };
  GlslGenerator.$metadata$ = {
    simpleName: 'GlslGenerator',
    kind: 'class',
    interfaces: []
  };
  function GlslConfig(gles, version, compatibility, android, programConfig) {
    this._gles_0 = gles;
    this._version_2 = version;
    this._compatibility = compatibility;
    this._android_0 = android;
    this._programConfig_0 = programConfig;
  }
  GlslConfig.prototype.toString = function () {
    return '' + 'GlslConfig(gles=' + this._gles_0 + ', version=' + this._version_2 + ', compatibility=' + this._compatibility + ', android=' + this._android_0 + ', programConfig=' + this._programConfig_0 + ')';
  };
  GlslConfig.prototype.hashCode = function () {
    var result = this._gles_0 | 0;
    result = imul(result, 31) + this._version_2 | 0;
    result = imul(result, 31) + (this._compatibility | 0) | 0;
    result = imul(result, 31) + (this._android_0 | 0) | 0;
    result = imul(result, 31) + this._programConfig_0.hashCode() | 0;
    return result;
  };
  GlslConfig.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this._gles_0 === tmp0_other_with_cast._gles_0))
      return false;
    if (!(this._version_2 === tmp0_other_with_cast._version_2))
      return false;
    if (!(this._compatibility === tmp0_other_with_cast._compatibility))
      return false;
    if (!(this._android_0 === tmp0_other_with_cast._android_0))
      return false;
    if (!this._programConfig_0.equals(tmp0_other_with_cast._programConfig_0))
      return false;
    return true;
  };
  GlslConfig.$metadata$ = {
    simpleName: 'GlslConfig',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_237(this$0) {
    var i = new _no_name_provided__280(this$0);
    return function (p1) {
      i.invoke_476(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_238(this$0) {
    var i = new _no_name_provided__281(this$0);
    return function (p1) {
      return i.invoke_480(p1);
    };
  }
  function _no_name_provided_$factory_239(this$0) {
    var i = new _no_name_provided__282(this$0);
    return function (p1) {
      return i.invoke_480(p1);
    };
  }
  function Func_init_$Init$(name, ops, $this) {
    Func.call($this, name, toList(ops));
    return $this;
  }
  function Func_init_$Create$(name, ops) {
    return Func_init_$Init$(name, ops, Object.create(Func.prototype));
  }
  function If_init_$Init$(cond, tbody, fbody, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      fbody = null;
    If.call($this, cond, tbody, fbody);
    return $this;
  }
  function If_init_$Create$(cond, tbody, fbody, $mask0, $marker) {
    return If_init_$Init$(cond, tbody, fbody, $mask0, $marker, Object.create(If.prototype));
  }
  function Stms(stms) {
    Stm.call(this);
    this._stms = stms;
  }
  Stms.prototype.toString = function () {
    return '' + 'Stms(stms=' + this._stms + ')';
  };
  Stms.prototype.hashCode = function () {
    return hashCode(this._stms);
  };
  Stms.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals_1(this._stms, tmp0_other_with_cast._stms))
      return false;
    return true;
  };
  Stms.$metadata$ = {
    simpleName: 'Stms',
    kind: 'class',
    interfaces: []
  };
  function Set_0(to_0, from) {
    Stm.call(this);
    this._to = to_0;
    this._from = from;
  }
  Set_0.prototype.toString = function () {
    return '' + 'Set(to=' + this._to + ', from=' + this._from + ')';
  };
  Set_0.prototype.hashCode = function () {
    var result = hashCode(this._to);
    result = imul(result, 31) + hashCode(this._from) | 0;
    return result;
  };
  Set_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Set_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Set_0 ? other : THROW_CCE();
    if (!equals_1(this._to, tmp0_other_with_cast._to))
      return false;
    if (!equals_1(this._from, tmp0_other_with_cast._from))
      return false;
    return true;
  };
  Set_0.$metadata$ = {
    simpleName: 'Set',
    kind: 'class',
    interfaces: []
  };
  function Discard() {
    Stm.call(this);
  }
  Discard.prototype.equals = function (other) {
    return other instanceof Discard;
  };
  Discard.prototype.hashCode = function () {
    return 1;
  };
  Discard.$metadata$ = {
    simpleName: 'Discard',
    kind: 'class',
    interfaces: []
  };
  function If(cond, tbody, fbody) {
    Stm.call(this);
    this._cond = cond;
    this._tbody = tbody;
    this._fbody = fbody;
  }
  If.prototype.toString = function () {
    return '' + 'If(cond=' + this._cond + ', tbody=' + this._tbody + ', fbody=' + this._fbody + ')';
  };
  If.prototype.hashCode = function () {
    var result = hashCode(this._cond);
    result = imul(result, 31) + hashCode(this._tbody) | 0;
    result = imul(result, 31) + (this._fbody == null ? 0 : hashCode(this._fbody)) | 0;
    return result;
  };
  If.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals_1(this._cond, tmp0_other_with_cast._cond))
      return false;
    if (!equals_1(this._tbody, tmp0_other_with_cast._tbody))
      return false;
    if (!equals_1(this._fbody, tmp0_other_with_cast._fbody))
      return false;
    return true;
  };
  If.$metadata$ = {
    simpleName: 'If',
    kind: 'class',
    interfaces: []
  };
  function Program_init_$Init$(vertex, fragment, name, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      name = 'program';
    Program.call($this, vertex, fragment, name);
    return $this;
  }
  function Program_init_$Create$(vertex, fragment, name, $mask0, $marker) {
    return Program_init_$Init$(vertex, fragment, name, $mask0, $marker, Object.create(Program.prototype));
  }
  function Binop(left, op, right) {
    Operand.call(this, left._get_type__10());
    this._left_1 = left;
    this._op_1 = op;
    this._right_0 = right;
  }
  Binop.prototype.toString = function () {
    return '' + 'Binop(left=' + this._left_1 + ', op=' + this._op_1 + ', right=' + this._right_0 + ')';
  };
  Binop.prototype.hashCode = function () {
    var result = hashCode(this._left_1);
    result = imul(result, 31) + getStringHashCode(this._op_1) | 0;
    result = imul(result, 31) + hashCode(this._right_0) | 0;
    return result;
  };
  Binop.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals_1(this._left_1, tmp0_other_with_cast._left_1))
      return false;
    if (!(this._op_1 === tmp0_other_with_cast._op_1))
      return false;
    if (!equals_1(this._right_0, tmp0_other_with_cast._right_0))
      return false;
    return true;
  };
  Binop.$metadata$ = {
    simpleName: 'Binop',
    kind: 'class',
    interfaces: []
  };
  function IntLiteral() {
  }
  IntLiteral.$metadata$ = {
    simpleName: 'IntLiteral',
    kind: 'class',
    interfaces: []
  };
  function FloatLiteral(value) {
    Operand.call(this, VarType_Float1_getInstance());
    this._value_20 = value;
  }
  FloatLiteral.prototype.toString = function () {
    return '' + 'FloatLiteral(value=' + this._value_20 + ')';
  };
  FloatLiteral.prototype.hashCode = function () {
    return getNumberHashCode(this._value_20);
  };
  FloatLiteral.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals_1(this._value_20, tmp0_other_with_cast._value_20))
      return false;
    return true;
  };
  FloatLiteral.$metadata$ = {
    simpleName: 'FloatLiteral',
    kind: 'class',
    interfaces: []
  };
  function BoolLiteral() {
  }
  BoolLiteral.$metadata$ = {
    simpleName: 'BoolLiteral',
    kind: 'class',
    interfaces: []
  };
  function Vector(type, ops) {
    Operand.call(this, type);
    this._type_3 = type;
    this._ops = ops;
  }
  Vector.prototype._get_type__10 = function () {
    return this._type_3;
  };
  Vector.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this._type_3.equals(other._type_3);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = contentEquals_11(this._ops, other._ops);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Vector.prototype.hashCode = function () {
    return imul(this._type_3.hashCode(), 7) + contentHashCode_8(this._ops) | 0;
  };
  Vector.prototype.toString = function () {
    return '' + 'Vector(type=' + this._type_3 + ', ops=' + toString_1(this._ops) + ')';
  };
  Vector.$metadata$ = {
    simpleName: 'Vector',
    kind: 'class',
    interfaces: []
  };
  function Swizzle(left, swizzle) {
    Operand.call(this, left._get_type__10());
    this._left_2 = left;
    this._swizzle = swizzle;
  }
  Swizzle.prototype.toString = function () {
    return '' + 'Swizzle(left=' + this._left_2 + ', swizzle=' + this._swizzle + ')';
  };
  Swizzle.prototype.hashCode = function () {
    var result = hashCode(this._left_2);
    result = imul(result, 31) + getStringHashCode(this._swizzle) | 0;
    return result;
  };
  Swizzle.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals_1(this._left_2, tmp0_other_with_cast._left_2))
      return false;
    if (!(this._swizzle === tmp0_other_with_cast._swizzle))
      return false;
    return true;
  };
  Swizzle.$metadata$ = {
    simpleName: 'Swizzle',
    kind: 'class',
    interfaces: []
  };
  function ArrayAccess() {
  }
  ArrayAccess.$metadata$ = {
    simpleName: 'ArrayAccess',
    kind: 'class',
    interfaces: []
  };
  function Func(name, ops) {
    Operand.call(this, VarType_Float1_getInstance());
    this._name_21 = name;
    this._ops_0 = ops;
  }
  Func.prototype.toString = function () {
    return '' + 'Func(name=' + this._name_21 + ', ops=' + this._ops_0 + ')';
  };
  Func.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_21);
    result = imul(result, 31) + hashCode(this._ops_0) | 0;
    return result;
  };
  Func.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this._name_21 === tmp0_other_with_cast._name_21))
      return false;
    if (!equals_1(this._ops_0, tmp0_other_with_cast._ops_0))
      return false;
    return true;
  };
  Func.$metadata$ = {
    simpleName: 'Func',
    kind: 'class',
    interfaces: []
  };
  function Stm() {
  }
  Stm.$metadata$ = {
    simpleName: 'Stm',
    kind: 'class',
    interfaces: []
  };
  function Builder(type) {
    this._type_4 = type;
    var tmp = this;
    tmp._outputStms = ArrayList_init_$Create$();
    this._tempLastId = 3;
    this._out_8 = Output_getInstance();
  }
  Builder.prototype.SET = function (target, expr) {
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._outputStms;
    var tmp1_plusAssign_0_4 = new Set_0(target, expr);
    tmp0_plusAssign_0_3.add_39(tmp1_plusAssign_0_4);
    return Unit_getInstance();
  };
  Builder.prototype.DISCARD = function () {
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._outputStms;
    var tmp1_plusAssign_0_4 = new Discard();
    tmp0_plusAssign_0_3.add_39(tmp1_plusAssign_0_4);
    return Unit_getInstance();
  };
  Builder.prototype.set_29 = function (_this__0, from) {
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._outputStms;
    var tmp1_plusAssign_0_4 = new Set_0(_this__0, from);
    tmp0_plusAssign_0_3.add_39(tmp1_plusAssign_0_4);
    return Unit_getInstance();
  };
  Builder.prototype.setTo_7 = function (_this__0, from) {
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._outputStms;
    var tmp1_plusAssign_0_4 = new Set_0(_this__0, from);
    tmp0_plusAssign_0_3.add_39(tmp1_plusAssign_0_4);
    return Unit_getInstance();
  };
  Builder.prototype.texture2D = function (a, b) {
    return Func_init_$Create$('texture2D', [a, b]);
  };
  Builder.prototype._get_lit_ = function (_this__0) {
    return new FloatLiteral(_this__0);
  };
  Builder.prototype.vec4 = function (ops) {
    var tmp = VarType_Float4_getInstance();
    return new Vector(tmp, isArray(ops) ? ops : THROW_CCE());
  };
  Builder.prototype.get_96 = function (_this__0, swizzle) {
    return new Swizzle(_this__0, swizzle);
  };
  Builder.prototype.minus_1 = function (_this__0, that) {
    return new Binop(_this__0, '-', that);
  };
  Builder.prototype.plus_31 = function (_this__0, that) {
    return new Binop(_this__0, '+', that);
  };
  Builder.prototype.times_0 = function (_this__0, that) {
    return new Binop(_this__0, '*', that);
  };
  Builder.prototype.div_0 = function (_this__0, that) {
    return new Binop(_this__0, '/', that);
  };
  Builder.prototype.le = function (_this__0, that) {
    return new Binop(_this__0, '<=', that);
  };
  Builder.$metadata$ = {
    simpleName: 'Builder',
    kind: 'class',
    interfaces: []
  };
  function Visitor(default_0) {
    this._default = default_0;
  }
  Visitor.prototype.visit_62 = function (stm) {
    var tmp0_subject = stm;
    var tmp;
    if (tmp0_subject instanceof Stms) {
      tmp = this.visit_63(stm);
    } else {
      if (tmp0_subject instanceof Set_0) {
        tmp = this.visit_65(stm);
      } else {
        if (tmp0_subject instanceof If) {
          tmp = this.visit_64(stm);
        } else {
          if (tmp0_subject instanceof Discard) {
            tmp = this.visit_66(stm);
          } else {
            {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
    return tmp;
  };
  Visitor.prototype.visit_63 = function (stms) {
    var tmp0_iterator = stms._stms.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var stm = tmp0_iterator.next_37();
      this.visit_62(stm);
    }
  };
  Visitor.prototype.visit_64 = function (stm) {
    this.visit_24(stm._cond);
    Unit_getInstance();
    this.visit_62(stm._tbody);
  };
  Visitor.prototype.visit_65 = function (stm) {
    this.visit_24(stm._from);
    Unit_getInstance();
    this.visit_24(stm._to);
    Unit_getInstance();
  };
  Visitor.prototype.visit_66 = function (stm) {
  };
  Visitor.prototype.visit_24 = function (operand) {
    var tmp0_subject = operand;
    var tmp;
    if (tmp0_subject instanceof Variable) {
      tmp = this.visit_26(operand);
    } else {
      if (tmp0_subject instanceof Binop) {
        tmp = this.visit_32(operand);
      } else {
        if (tmp0_subject instanceof BoolLiteral) {
          tmp = this.visit_38(operand);
        } else {
          if (tmp0_subject instanceof IntLiteral) {
            tmp = this.visit_36(operand);
          } else {
            if (tmp0_subject instanceof FloatLiteral) {
              tmp = this.visit_37(operand);
            } else {
              if (tmp0_subject instanceof Vector) {
                tmp = this.visit_35(operand);
              } else {
                if (tmp0_subject instanceof Swizzle) {
                  tmp = this.visit_33(operand);
                } else {
                  if (tmp0_subject instanceof ArrayAccess) {
                    tmp = this.visit_34(operand);
                  } else {
                    if (tmp0_subject instanceof Func) {
                      tmp = this.visit_25(operand);
                    } else {
                      {
                        invalidOp('' + "Don't know how to visit operand " + operand);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  Visitor.prototype.visit_25 = function (func) {
    var tmp0_iterator = func._ops_0.iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var op = tmp0_iterator.next_37();
      this.visit_24(op);
      Unit_getInstance();
    }
    return this._default;
  };
  Visitor.prototype.visit_26 = function (operand) {
    var tmp0_subject = operand;
    var tmp;
    if (tmp0_subject instanceof Attribute) {
      tmp = this.visit_61(operand);
    } else {
      if (tmp0_subject instanceof Varying) {
        tmp = this.visit_29(operand);
      } else {
        if (tmp0_subject instanceof Uniform) {
          tmp = this.visit_40(operand);
        } else {
          if (tmp0_subject instanceof Output_0) {
            tmp = this.visit_31(operand);
          } else {
            if (tmp0_subject instanceof Temp_0) {
              tmp = this.visit_27(operand);
            } else {
              {
                invalidOp('' + "Don't know how to visit basename " + operand);
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  Visitor.prototype.visit_27 = function (temp_0) {
    return this._default;
  };
  Visitor.prototype.visit_61 = function (attribute) {
    return this._default;
  };
  Visitor.prototype.visit_29 = function (varying) {
    return this._default;
  };
  Visitor.prototype.visit_40 = function (uniform) {
    return this._default;
  };
  Visitor.prototype.visit_31 = function (output_0) {
    return this._default;
  };
  Visitor.prototype.visit_32 = function (operand) {
    this.visit_24(operand._left_1);
    Unit_getInstance();
    this.visit_24(operand._right_0);
    Unit_getInstance();
    return this._default;
  };
  Visitor.prototype.visit_33 = function (operand) {
    this.visit_24(operand._left_2);
    Unit_getInstance();
    return this._default;
  };
  Visitor.prototype.visit_34 = function (operand) {
    this.visit_24(operand._left_3);
    Unit_getInstance();
    this.visit_24(operand._index_13);
    Unit_getInstance();
    return this._default;
  };
  Visitor.prototype.visit_35 = function (operand) {
    var indexedObject = operand._ops;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.visit_24(op);
      Unit_getInstance();
    }
    return this._default;
  };
  Visitor.prototype.visit_36 = function (operand) {
    return this._default;
  };
  Visitor.prototype.visit_37 = function (operand) {
    return this._default;
  };
  Visitor.prototype.visit_38 = function (operand) {
    return this._default;
  };
  Visitor.$metadata$ = {
    simpleName: 'Visitor',
    kind: 'class',
    interfaces: []
  };
  function Program(vertex, fragment, name) {
    this._vertex = vertex;
    this._fragment_0 = fragment;
    this._name_22 = name;
    this._uniforms_4 = plus_1(this._vertex._get_uniforms__3(), this._fragment_0._get_uniforms__3());
    this._attributes_5 = plus_1(this._vertex._get_attributes__1(), this._fragment_0._get_attributes__1());
    this._cachedHashCode = (imul(this._vertex.hashCode(), 11) + imul(this._fragment_0.hashCode(), 7) | 0) + getStringHashCode(this._name_22) | 0;
  }
  Program.prototype.hashCode = function () {
    return this._cachedHashCode;
  };
  Program.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof Program) {
      tmp_1 = this._vertex.equals(other._vertex);
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._fragment_0.equals(other._fragment_0);
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_22 === other._name_22;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Program.prototype.close_77 = function () {
  };
  Program.prototype.toString = function () {
    var tmp0_map_0 = this._attributes_5;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      tmp0_mapTo_0_1.add_39(item_2_3._get_name__50());
      Unit_getInstance();
    }
    var tmp1_map_0 = this._uniforms_4;
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
    var tmp0_iterator_1_2_0 = tmp1_map_0.iterator_67();
    while (tmp0_iterator_1_2_0.hasNext_33()) {
      var item_2_3_0 = tmp0_iterator_1_2_0.next_37();
      tmp0_mapTo_0_1_0.add_39(item_2_3_0._get_name__50());
      Unit_getInstance();
    }
    return '' + 'Program(name=' + this._name_22 + ', attributes=' + tmp0_mapTo_0_1 + ', uniforms=' + tmp0_mapTo_0_1_0 + ')';
  };
  Program.$metadata$ = {
    simpleName: 'Program',
    kind: 'class',
    interfaces: [Closeable]
  };
  function Uniform_init_$Init$(name, type, precision, $this) {
    Uniform.call($this, name, type, 1, precision);
    return $this;
  }
  function Uniform_init_$Init$_0(name, type, precision, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      precision = Precision_DEFAULT_getInstance();
    Uniform_init_$Init$(name, type, precision, $this);
    return $this;
  }
  function Uniform_init_$Create$(name, type, precision, $mask0, $marker) {
    return Uniform_init_$Init$_0(name, type, precision, $mask0, $marker, Object.create(Uniform.prototype));
  }
  function Uniform(name, type, arrayCount, precision) {
    Variable.call(this, name, type, arrayCount, precision);
  }
  Uniform.prototype.toString = function () {
    return '' + 'Uniform(' + this._get_name__50() + ')';
  };
  Uniform.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this._id_14 === other._id_14;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._get_type__10().equals(other._get_type__10());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_23 === other._name_23;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Uniform.prototype.hashCode = function () {
    return (this._id_14 + imul(this._get_type__10().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
  };
  Uniform.$metadata$ = {
    simpleName: 'Uniform',
    kind: 'class',
    interfaces: []
  };
  function Attribute_init_$Init$(name, type, normalized, precision, $this) {
    Attribute.call($this, name, type, normalized, null, true, precision);
    return $this;
  }
  function Attribute_init_$Create$(name, type, normalized, precision) {
    return Attribute_init_$Init$(name, type, normalized, precision, Object.create(Attribute.prototype));
  }
  function Attribute_init_$Init$_0(name, type, normalized, precision, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0))
      precision = Precision_DEFAULT_getInstance();
    Attribute_init_$Init$(name, type, normalized, precision, $this);
    return $this;
  }
  function Attribute_init_$Create$_0(name, type, normalized, precision, $mask0, $marker) {
    return Attribute_init_$Init$_0(name, type, normalized, precision, $mask0, $marker, Object.create(Attribute.prototype));
  }
  function Attribute(name, type, normalized, offset, active, precision) {
    Variable_init_$Init$(name, type, precision, this);
    this._normalized = normalized;
    this._offset_23 = offset;
    this._active = active;
  }
  Attribute.prototype.toString = function () {
    return '' + 'Attribute(' + this._get_name__50() + ')';
  };
  Attribute.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this._id_14 === other._id_14;
    } else {
      {
        tmp_5 = false;
      }
    }
    if (tmp_5) {
      tmp_4 = this._get_type__10().equals(other._get_type__10());
    } else {
      {
        tmp_4 = false;
      }
    }
    if (tmp_4) {
      tmp_3 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_3 = false;
      }
    }
    if (tmp_3) {
      tmp_2 = this._name_23 === other._name_23;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._normalized === (other instanceof Attribute ? other : THROW_CCE())._normalized;
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._offset_23 == other._offset_23;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._active === other._active;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Attribute.prototype.hashCode = function () {
    var out = (this._id_14 + imul(this._get_type__10().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
    out = imul(out, 7);
    out = out + (this._normalized | 0) | 0;
    out = imul(out, 7);
    var tmp = out;
    var tmp0_hashCode_0 = this._offset_23;
    var tmp0_safe_receiver_2 = tmp0_hashCode_0;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    out = tmp + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
    out = imul(out, 7);
    out = out + (this._active | 0) | 0;
    return out;
  };
  Attribute.$metadata$ = {
    simpleName: 'Attribute',
    kind: 'class',
    interfaces: []
  };
  function VarType_init_$Init$(name, ordinal, kind, elementCount, isMatrix, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0))
      isMatrix = false;
    VarType.call($this, name, ordinal, kind, elementCount, isMatrix);
    return $this;
  }
  function VarType_init_$Create$(name, ordinal, kind, elementCount, isMatrix, $mask0, $marker) {
    return VarType_init_$Init$(name, ordinal, kind, elementCount, isMatrix, $mask0, $marker, Object.create(VarType.prototype));
  }
  var VarType_TVOID_instance;
  var VarType_Mat2_instance;
  var VarType_Mat3_instance;
  var VarType_Mat4_instance;
  var VarType_TextureUnit_instance;
  var VarType_Sampler1D_instance;
  var VarType_Sampler2D_instance;
  var VarType_Sampler3D_instance;
  var VarType_SamplerCube_instance;
  var VarType_Int1_instance;
  var VarType_Float1_instance;
  var VarType_Float2_instance;
  var VarType_Float3_instance;
  var VarType_Float4_instance;
  var VarType_Short1_instance;
  var VarType_Short2_instance;
  var VarType_Short3_instance;
  var VarType_Short4_instance;
  var VarType_Bool1_instance;
  var VarType_Byte4_instance;
  var VarType_SByte1_instance;
  var VarType_SByte2_instance;
  var VarType_SByte3_instance;
  var VarType_SByte4_instance;
  var VarType_UByte1_instance;
  var VarType_UByte2_instance;
  var VarType_UByte3_instance;
  var VarType_UByte4_instance;
  var VarType_SShort1_instance;
  var VarType_SShort2_instance;
  var VarType_SShort3_instance;
  var VarType_SShort4_instance;
  var VarType_UShort1_instance;
  var VarType_UShort2_instance;
  var VarType_UShort3_instance;
  var VarType_UShort4_instance;
  var VarType_SInt1_instance;
  var VarType_SInt2_instance;
  var VarType_SInt3_instance;
  var VarType_SInt4_instance;
  function Companion_126() {
    Companion_instance_125 = this;
  }
  Companion_126.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_125;
  function Companion_getInstance_125() {
    if (Companion_instance_125 == null)
      new Companion_126();
    return Companion_instance_125;
  }
  var VarType_entriesInitialized;
  function VarType_initEntries() {
    if (VarType_entriesInitialized)
      return Unit_getInstance();
    VarType_entriesInitialized = true;
    var tmp = VarKind_TBYTE_getInstance();
    VarType_TVOID_instance = VarType_init_$Create$('TVOID', 0, tmp, 0, false, 16, null);
    VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
    VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
    VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
    var tmp_0 = VarKind_TINT_getInstance();
    VarType_TextureUnit_instance = VarType_init_$Create$('TextureUnit', 4, tmp_0, 1, false, 16, null);
    var tmp_1 = VarKind_TFLOAT_getInstance();
    VarType_Sampler1D_instance = VarType_init_$Create$('Sampler1D', 5, tmp_1, 1, false, 16, null);
    var tmp_2 = VarKind_TFLOAT_getInstance();
    VarType_Sampler2D_instance = VarType_init_$Create$('Sampler2D', 6, tmp_2, 1, false, 16, null);
    var tmp_3 = VarKind_TFLOAT_getInstance();
    VarType_Sampler3D_instance = VarType_init_$Create$('Sampler3D', 7, tmp_3, 1, false, 16, null);
    var tmp_4 = VarKind_TFLOAT_getInstance();
    VarType_SamplerCube_instance = VarType_init_$Create$('SamplerCube', 8, tmp_4, 1, false, 16, null);
    var tmp_5 = VarKind_TINT_getInstance();
    VarType_Int1_instance = VarType_init_$Create$('Int1', 9, tmp_5, 1, false, 16, null);
    var tmp_6 = VarKind_TFLOAT_getInstance();
    VarType_Float1_instance = VarType_init_$Create$('Float1', 10, tmp_6, 1, false, 16, null);
    var tmp_7 = VarKind_TFLOAT_getInstance();
    VarType_Float2_instance = VarType_init_$Create$('Float2', 11, tmp_7, 2, false, 16, null);
    var tmp_8 = VarKind_TFLOAT_getInstance();
    VarType_Float3_instance = VarType_init_$Create$('Float3', 12, tmp_8, 3, false, 16, null);
    var tmp_9 = VarKind_TFLOAT_getInstance();
    VarType_Float4_instance = VarType_init_$Create$('Float4', 13, tmp_9, 4, false, 16, null);
    var tmp_10 = VarKind_TSHORT_getInstance();
    VarType_Short1_instance = VarType_init_$Create$('Short1', 14, tmp_10, 1, false, 16, null);
    var tmp_11 = VarKind_TSHORT_getInstance();
    VarType_Short2_instance = VarType_init_$Create$('Short2', 15, tmp_11, 2, false, 16, null);
    var tmp_12 = VarKind_TSHORT_getInstance();
    VarType_Short3_instance = VarType_init_$Create$('Short3', 16, tmp_12, 3, false, 16, null);
    var tmp_13 = VarKind_TSHORT_getInstance();
    VarType_Short4_instance = VarType_init_$Create$('Short4', 17, tmp_13, 4, false, 16, null);
    var tmp_14 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_Bool1_instance = VarType_init_$Create$('Bool1', 18, tmp_14, 1, false, 16, null);
    var tmp_15 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_Byte4_instance = VarType_init_$Create$('Byte4', 19, tmp_15, 4, false, 16, null);
    var tmp_16 = VarKind_TBYTE_getInstance();
    VarType_SByte1_instance = VarType_init_$Create$('SByte1', 20, tmp_16, 1, false, 16, null);
    var tmp_17 = VarKind_TBYTE_getInstance();
    VarType_SByte2_instance = VarType_init_$Create$('SByte2', 21, tmp_17, 2, false, 16, null);
    var tmp_18 = VarKind_TBYTE_getInstance();
    VarType_SByte3_instance = VarType_init_$Create$('SByte3', 22, tmp_18, 3, false, 16, null);
    var tmp_19 = VarKind_TBYTE_getInstance();
    VarType_SByte4_instance = VarType_init_$Create$('SByte4', 23, tmp_19, 4, false, 16, null);
    var tmp_20 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_UByte1_instance = VarType_init_$Create$('UByte1', 24, tmp_20, 1, false, 16, null);
    var tmp_21 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_UByte2_instance = VarType_init_$Create$('UByte2', 25, tmp_21, 2, false, 16, null);
    var tmp_22 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_UByte3_instance = VarType_init_$Create$('UByte3', 26, tmp_22, 3, false, 16, null);
    var tmp_23 = VarKind_TUNSIGNED_BYTE_getInstance();
    VarType_UByte4_instance = VarType_init_$Create$('UByte4', 27, tmp_23, 4, false, 16, null);
    var tmp_24 = VarKind_TSHORT_getInstance();
    VarType_SShort1_instance = VarType_init_$Create$('SShort1', 28, tmp_24, 1, false, 16, null);
    var tmp_25 = VarKind_TSHORT_getInstance();
    VarType_SShort2_instance = VarType_init_$Create$('SShort2', 29, tmp_25, 2, false, 16, null);
    var tmp_26 = VarKind_TSHORT_getInstance();
    VarType_SShort3_instance = VarType_init_$Create$('SShort3', 30, tmp_26, 3, false, 16, null);
    var tmp_27 = VarKind_TSHORT_getInstance();
    VarType_SShort4_instance = VarType_init_$Create$('SShort4', 31, tmp_27, 4, false, 16, null);
    var tmp_28 = VarKind_TUNSIGNED_SHORT_getInstance();
    VarType_UShort1_instance = VarType_init_$Create$('UShort1', 32, tmp_28, 1, false, 16, null);
    var tmp_29 = VarKind_TUNSIGNED_SHORT_getInstance();
    VarType_UShort2_instance = VarType_init_$Create$('UShort2', 33, tmp_29, 2, false, 16, null);
    var tmp_30 = VarKind_TUNSIGNED_SHORT_getInstance();
    VarType_UShort3_instance = VarType_init_$Create$('UShort3', 34, tmp_30, 3, false, 16, null);
    var tmp_31 = VarKind_TUNSIGNED_SHORT_getInstance();
    VarType_UShort4_instance = VarType_init_$Create$('UShort4', 35, tmp_31, 4, false, 16, null);
    var tmp_32 = VarKind_TINT_getInstance();
    VarType_SInt1_instance = VarType_init_$Create$('SInt1', 36, tmp_32, 1, false, 16, null);
    var tmp_33 = VarKind_TINT_getInstance();
    VarType_SInt2_instance = VarType_init_$Create$('SInt2', 37, tmp_33, 2, false, 16, null);
    var tmp_34 = VarKind_TINT_getInstance();
    VarType_SInt3_instance = VarType_init_$Create$('SInt3', 38, tmp_34, 3, false, 16, null);
    var tmp_35 = VarKind_TINT_getInstance();
    VarType_SInt4_instance = VarType_init_$Create$('SInt4', 39, tmp_35, 4, false, 16, null);
    Companion_getInstance_125();
  }
  function VarType(name, ordinal, kind, elementCount, isMatrix) {
    Enum.call(this, name, ordinal);
    this._kind_3 = kind;
    this._elementCount = elementCount;
    this._isMatrix = isMatrix;
    this._bytesSize = imul(this._kind_3._bytesSize_0, this._elementCount);
  }
  VarType.$metadata$ = {
    simpleName: 'VarType',
    kind: 'class',
    interfaces: []
  };
  function Varying_init_$Init$(name, type, precision, $this) {
    Varying.call($this, name, type, 1, precision);
    return $this;
  }
  function Varying_init_$Create$(name, type, precision) {
    return Varying_init_$Init$(name, type, precision, Object.create(Varying.prototype));
  }
  function Varying_init_$Init$_0(name, type, precision, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      precision = Precision_DEFAULT_getInstance();
    Varying_init_$Init$(name, type, precision, $this);
    return $this;
  }
  function Varying_init_$Create$_0(name, type, precision, $mask0, $marker) {
    return Varying_init_$Init$_0(name, type, precision, $mask0, $marker, Object.create(Varying.prototype));
  }
  function Varying(name, type, arrayCount, precision) {
    Variable.call(this, name, type, arrayCount, precision);
  }
  Varying.prototype.toString = function () {
    return '' + 'Varying(' + this._get_name__50() + ')';
  };
  Varying.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this._id_14 === other._id_14;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._get_type__10().equals(other._get_type__10());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_23 === other._name_23;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Varying.prototype.hashCode = function () {
    return (this._id_14 + imul(this._get_type__10().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
  };
  Varying.$metadata$ = {
    simpleName: 'Varying',
    kind: 'class',
    interfaces: []
  };
  function VertexLayout_init_$Init$(attributes, $this) {
    VertexLayout.call($this, toFastList(attributes), null);
    return $this;
  }
  function VertexLayout_init_$Create$(attributes) {
    return VertexLayout_init_$Init$(attributes, Object.create(VertexLayout.prototype));
  }
  function _no_name_provided__283() {
  }
  _no_name_provided__283.prototype.invoke_482 = function (it) {
    return it._get_name__50();
  };
  _no_name_provided__283.prototype.invoke_1015 = function (p1) {
    return this.invoke_482(p1 instanceof Attribute ? p1 : THROW_CCE());
  };
  _no_name_provided__283.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function VertexLayout(attr, layoutSize) {
    this._layoutSize = layoutSize;
    this._myattr = attr;
    this._attributes_6 = attr;
    this.__lastPos = 0;
    var tmp = this;
    var tmp0_map_0 = this._myattr;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var item_2_3 = tmp0_iterator_1_2.next_37();
      var a_5 = item_2_3._get_type__10()._kind_3._bytesSize_0;
      tmp0_mapTo_0_1.add_39(a_5 <= 1 ? 1 : a_5);
      Unit_getInstance();
    }
    tmp._alignments = tmp0_mapTo_0_1;
    var tmp_0 = this;
    var tmp0_mapInt_0 = this._myattr;
    var tmp0_also_0_1 = IntArrayList_init_$Create$(0, 1, null);
    var tmp0_iterator_2_2 = tmp0_mapInt_0.iterator_67();
    while (tmp0_iterator_2_2.hasNext_33()) {
      var v_3_3 = tmp0_iterator_2_2.next_37();
      if (!(v_3_3._offset_23 == null)) {
        this.__lastPos = v_3_3._offset_23;
      } else {
        this.__lastPos = nextAlignedTo(this.__lastPos, v_3_3._get_type__10()._kind_3._bytesSize_0);
      }
      var out_5 = this.__lastPos;
      var tmp0_this_6 = this;
      tmp0_this_6.__lastPos = tmp0_this_6.__lastPos + v_3_3._get_type__10()._bytesSize | 0;
      tmp0_also_0_1.add_26(out_5);
    }
    tmp_0._attributePositions = tmp0_also_0_1;
    var tmp_1 = this;
    var tmp0_elvis_lhs = maxOrNull(this._alignments);
    tmp_1._maxAlignment = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = this;
    var tmp0_elvis_lhs_2 = this._layoutSize;
    tmp_2._totalSize_2 = tmp0_elvis_lhs_2 == null ? nextAlignedTo(this.__lastPos, this._maxAlignment) : tmp0_elvis_lhs_2;
  }
  VertexLayout.prototype.toString = function () {
    return '' + 'VertexLayout[' + joinToString$default_0(this._myattr, ', ', null, null, 0, null, _no_name_provided_$factory_240(), 30, null) + ']';
  };
  VertexLayout.$metadata$ = {
    simpleName: 'VertexLayout',
    kind: 'class',
    interfaces: []
  };
  function VertexShader(stm) {
    Shader.call(this, ShaderType_VERTEX_getInstance(), stm);
  }
  VertexShader.$metadata$ = {
    simpleName: 'VertexShader',
    kind: 'class',
    interfaces: []
  };
  function VertexShader_0(callback) {
    var builder = new Builder(ShaderType_VERTEX_getInstance());
    callback(builder);
    return new VertexShader(new Stms(builder._outputStms));
  }
  function Output_0() {
    Output_instance = this;
    var tmp = VarType_Float4_getInstance();
    Variable_init_$Init$_0('out', tmp, null, 4, null, this);
  }
  Output_0.prototype.toString = function () {
    return 'Output';
  };
  Output_0.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output_0) {
      tmp_2 = this._id_14 === other._id_14;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._get_type__10().equals(other._get_type__10());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_23 === other._name_23;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Output_0.prototype.hashCode = function () {
    return (this._id_14 + imul(this._get_type__10().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
  };
  Output_0.$metadata$ = {
    simpleName: 'Output',
    kind: 'object',
    interfaces: []
  };
  var Output_instance;
  function Output_getInstance() {
    if (Output_instance == null)
      new Output_0();
    return Output_instance;
  }
  function Operand(type) {
    this._type_5 = type;
  }
  Operand.prototype._get_type__10 = function () {
    return this._type_5;
  };
  Operand.$metadata$ = {
    simpleName: 'Operand',
    kind: 'class',
    interfaces: []
  };
  function FragmentShader(stm) {
    Shader.call(this, ShaderType_FRAGMENT_getInstance(), stm);
  }
  FragmentShader.$metadata$ = {
    simpleName: 'FragmentShader',
    kind: 'class',
    interfaces: []
  };
  function FragmentShader_0(callback) {
    var builder = new Builder(ShaderType_FRAGMENT_getInstance());
    callback(builder);
    return new FragmentShader(new Stms(builder._outputStms));
  }
  var ShaderType_VERTEX_instance;
  var ShaderType_FRAGMENT_instance;
  var ShaderType_entriesInitialized;
  function ShaderType_initEntries() {
    if (ShaderType_entriesInitialized)
      return Unit_getInstance();
    ShaderType_entriesInitialized = true;
    ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
    ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
  }
  function ShaderType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  ShaderType.$metadata$ = {
    simpleName: 'ShaderType',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__284($out) {
    this._$out = $out;
    Visitor.call(this, Unit_getInstance());
  }
  _no_name_provided__284.prototype.visit_72 = function (uniform) {
    var tmp0_plusAssign_0_2 = this._$out;
    tmp0_plusAssign_0_2.add_39(uniform);
    return Unit_getInstance();
  };
  _no_name_provided__284.prototype.visit_40 = function (uniform) {
    this.visit_72(uniform);
    return Unit_getInstance();
  };
  _no_name_provided__284.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__285($out) {
    this._$out_0 = $out;
    Visitor.call(this, Unit_getInstance());
  }
  _no_name_provided__285.prototype.visit_60 = function (attribute) {
    var tmp0_plusAssign_0_2 = this._$out_0;
    tmp0_plusAssign_0_2.add_39(attribute);
    return Unit_getInstance();
  };
  _no_name_provided__285.prototype.visit_61 = function (attribute) {
    this.visit_60(attribute);
    return Unit_getInstance();
  };
  _no_name_provided__285.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Shader(type, stm) {
    this._type_6 = type;
    this._stm = stm;
    this._stmHashCode = hashCode(this._stm);
    this._cachedHashCode_0 = imul(this._type_6.hashCode(), 17) + this._stmHashCode | 0;
    var tmp = this;
    var tmp0_also_0 = LinkedHashSet_init_$Create$();
    (new _no_name_provided__284(tmp0_also_0)).visit_62(this._stm);
    tmp._uniforms_5 = toSet_0(tmp0_also_0);
    var tmp_0 = this;
    var tmp0_also_0_0 = LinkedHashSet_init_$Create$();
    (new _no_name_provided__285(tmp0_also_0_0)).visit_62(this._stm);
    tmp_0._attributes_7 = toSet_0(tmp0_also_0_0);
  }
  Shader.prototype._get_uniforms__3 = function () {
    return this._uniforms_5;
  };
  Shader.prototype._get_attributes__1 = function () {
    return this._attributes_7;
  };
  Shader.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof Shader) {
      tmp_1 = this._type_6.equals(other._type_6);
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._stmHashCode === other._stmHashCode;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = equals_1(this._stm, other._stm);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Shader.prototype.hashCode = function () {
    return this._cachedHashCode_0;
  };
  Shader.$metadata$ = {
    simpleName: 'Shader',
    kind: 'class',
    interfaces: []
  };
  function Temp_init_$Init$(id, type, precision, $this) {
    Temp_0.call($this, id, type, 1, precision);
    return $this;
  }
  function Temp_init_$Init$_0(id, type, precision, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      precision = Precision_DEFAULT_getInstance();
    Temp_init_$Init$(id, type, precision, $this);
    return $this;
  }
  function Temp_init_$Create$(id, type, precision, $mask0, $marker) {
    return Temp_init_$Init$_0(id, type, precision, $mask0, $marker, Object.create(Temp_0.prototype));
  }
  function Temp_0(id, type, arrayCount, precision) {
    Variable.call(this, '' + 'temp' + id, type, arrayCount, precision);
  }
  Temp_0.prototype.toString = function () {
    return '' + 'Temp(' + this._get_name__50() + ')';
  };
  Temp_0.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp_0) {
      tmp_2 = this._id_14 === other._id_14;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._get_type__10().equals(other._get_type__10());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_23 === other._name_23;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Temp_0.prototype.hashCode = function () {
    return (this._id_14 + imul(this._get_type__10().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
  };
  Temp_0.$metadata$ = {
    simpleName: 'Temp',
    kind: 'class',
    interfaces: []
  };
  function Variable_init_$Init$(name, type, precision, $this) {
    Variable.call($this, name, type, 1, precision);
    return $this;
  }
  function Variable_init_$Init$_0(name, type, precision, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      precision = Precision_DEFAULT_getInstance();
    Variable_init_$Init$(name, type, precision, $this);
    return $this;
  }
  function Variable(name, type, arrayCount, precision) {
    Operand.call(this, type);
    this._name_23 = name;
    this._arrayCount = arrayCount;
    this._precision = precision;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this._arrayCount;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = '' + this._name_23 + '[' + tmp_3 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._indexNames = tmp_2;
    this._id_14 = 0;
    this._data_43 = null;
  }
  Variable.prototype._get_name__50 = function () {
    return this._name_23;
  };
  Variable.prototype._get_arrayCount__0 = function () {
    return this._arrayCount;
  };
  Variable.prototype._get_precision__3 = function () {
    return this._precision;
  };
  Variable.prototype._get_indexNames__0 = function () {
    return this._indexNames;
  };
  Variable.prototype.equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this._id_14 === other._id_14;
    } else {
      {
        tmp_2 = false;
      }
    }
    if (tmp_2) {
      tmp_1 = this._get_type__10().equals(other._get_type__10());
    } else {
      {
        tmp_1 = false;
      }
    }
    if (tmp_1) {
      tmp_0 = this._arrayCount === other._arrayCount;
    } else {
      {
        tmp_0 = false;
      }
    }
    if (tmp_0) {
      tmp = this._name_23 === other._name_23;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Variable.prototype.hashCode = function () {
    return (this._id_14 + imul(this._get_type__10().hashCode(), 7) | 0) + imul(getStringHashCode(this._name_23), 11) | 0;
  };
  Variable.$metadata$ = {
    simpleName: 'Variable',
    kind: 'class',
    interfaces: []
  };
  var Precision_DEFAULT_instance;
  var Precision_LOW_instance;
  var Precision_MEDIUM_instance;
  var Precision_HIGH_instance;
  var Precision_entriesInitialized;
  function Precision_initEntries() {
    if (Precision_entriesInitialized)
      return Unit_getInstance();
    Precision_entriesInitialized = true;
    Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
    Precision_LOW_instance = new Precision('LOW', 1);
    Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
    Precision_HIGH_instance = new Precision('HIGH', 3);
  }
  function Precision(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Precision.$metadata$ = {
    simpleName: 'Precision',
    kind: 'class',
    interfaces: []
  };
  var VarKind_TBYTE_instance;
  var VarKind_TUNSIGNED_BYTE_instance;
  var VarKind_TSHORT_instance;
  var VarKind_TUNSIGNED_SHORT_instance;
  var VarKind_TINT_instance;
  var VarKind_TFLOAT_instance;
  var VarKind_entriesInitialized;
  function VarKind_initEntries() {
    if (VarKind_entriesInitialized)
      return Unit_getInstance();
    VarKind_entriesInitialized = true;
    VarKind_TBYTE_instance = new VarKind('TBYTE', 0, 1);
    VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 1, 1);
    VarKind_TSHORT_instance = new VarKind('TSHORT', 2, 2);
    VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 3, 2);
    VarKind_TINT_instance = new VarKind('TINT', 4, 4);
    VarKind_TFLOAT_instance = new VarKind('TFLOAT', 5, 4);
  }
  function VarKind(name, ordinal, bytesSize) {
    Enum.call(this, name, ordinal);
    this._bytesSize_0 = bytesSize;
  }
  VarKind.$metadata$ = {
    simpleName: 'VarKind',
    kind: 'class',
    interfaces: []
  };
  function ProgramConfig_init_$Init$(externalTextureSampler, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      externalTextureSampler = false;
    ProgramConfig.call($this, externalTextureSampler);
    return $this;
  }
  function ProgramConfig_init_$Create$(externalTextureSampler, $mask0, $marker) {
    return ProgramConfig_init_$Init$(externalTextureSampler, $mask0, $marker, Object.create(ProgramConfig.prototype));
  }
  function Companion_127() {
    Companion_instance_126 = this;
    var tmp = this;
    tmp._DEFAULT_4 = ProgramConfig_init_$Create$(false, 1, null);
    this._EXTERNAL_TEXTURE_SAMPLER = new ProgramConfig(true);
  }
  Companion_127.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_126;
  function Companion_getInstance_126() {
    if (Companion_instance_126 == null)
      new Companion_127();
    return Companion_instance_126;
  }
  function ProgramConfig(externalTextureSampler) {
    Companion_getInstance_126();
    this._externalTextureSampler = externalTextureSampler;
  }
  ProgramConfig.prototype.toString = function () {
    return '' + 'ProgramConfig(externalTextureSampler=' + this._externalTextureSampler + ')';
  };
  ProgramConfig.prototype.hashCode = function () {
    return this._externalTextureSampler | 0;
  };
  ProgramConfig.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProgramConfig))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProgramConfig ? other : THROW_CCE();
    if (!(this._externalTextureSampler === tmp0_other_with_cast._externalTextureSampler))
      return false;
    return true;
  };
  ProgramConfig.$metadata$ = {
    simpleName: 'ProgramConfig',
    kind: 'class',
    interfaces: []
  };
  function VarType_Mat2_getInstance() {
    VarType_initEntries();
    return VarType_Mat2_instance;
  }
  function VarType_Mat3_getInstance() {
    VarType_initEntries();
    return VarType_Mat3_instance;
  }
  function VarType_Mat4_getInstance() {
    VarType_initEntries();
    return VarType_Mat4_instance;
  }
  function VarType_TextureUnit_getInstance() {
    VarType_initEntries();
    return VarType_TextureUnit_instance;
  }
  function VarType_Sampler1D_getInstance() {
    VarType_initEntries();
    return VarType_Sampler1D_instance;
  }
  function VarType_Sampler2D_getInstance() {
    VarType_initEntries();
    return VarType_Sampler2D_instance;
  }
  function VarType_Sampler3D_getInstance() {
    VarType_initEntries();
    return VarType_Sampler3D_instance;
  }
  function VarType_SamplerCube_getInstance() {
    VarType_initEntries();
    return VarType_SamplerCube_instance;
  }
  function VarType_Int1_getInstance() {
    VarType_initEntries();
    return VarType_Int1_instance;
  }
  function VarType_Float1_getInstance() {
    VarType_initEntries();
    return VarType_Float1_instance;
  }
  function VarType_Float2_getInstance() {
    VarType_initEntries();
    return VarType_Float2_instance;
  }
  function VarType_Float3_getInstance() {
    VarType_initEntries();
    return VarType_Float3_instance;
  }
  function VarType_Float4_getInstance() {
    VarType_initEntries();
    return VarType_Float4_instance;
  }
  function VarType_Byte4_getInstance() {
    VarType_initEntries();
    return VarType_Byte4_instance;
  }
  function ShaderType_VERTEX_getInstance() {
    ShaderType_initEntries();
    return ShaderType_VERTEX_instance;
  }
  function ShaderType_FRAGMENT_getInstance() {
    ShaderType_initEntries();
    return ShaderType_FRAGMENT_instance;
  }
  function Precision_DEFAULT_getInstance() {
    Precision_initEntries();
    return Precision_DEFAULT_instance;
  }
  function Precision_LOW_getInstance() {
    Precision_initEntries();
    return Precision_LOW_instance;
  }
  function Precision_MEDIUM_getInstance() {
    Precision_initEntries();
    return Precision_MEDIUM_instance;
  }
  function Precision_HIGH_getInstance() {
    Precision_initEntries();
    return Precision_HIGH_instance;
  }
  function VarKind_TBYTE_getInstance() {
    VarKind_initEntries();
    return VarKind_TBYTE_instance;
  }
  function VarKind_TUNSIGNED_BYTE_getInstance() {
    VarKind_initEntries();
    return VarKind_TUNSIGNED_BYTE_instance;
  }
  function VarKind_TSHORT_getInstance() {
    VarKind_initEntries();
    return VarKind_TSHORT_instance;
  }
  function VarKind_TUNSIGNED_SHORT_getInstance() {
    VarKind_initEntries();
    return VarKind_TUNSIGNED_SHORT_instance;
  }
  function VarKind_TINT_getInstance() {
    VarKind_initEntries();
    return VarKind_TINT_instance;
  }
  function VarKind_TFLOAT_getInstance() {
    VarKind_initEntries();
    return VarKind_TFLOAT_instance;
  }
  function _no_name_provided_$factory_240() {
    var i = new _no_name_provided__283();
    return function (p1) {
      return i.invoke_482(p1);
    };
  }
  function Event_0() {
    this._target_0 = null;
  }
  Event_0.$metadata$ = {
    simpleName: 'Event',
    kind: 'class',
    interfaces: []
  };
  function preventDefault(reason) {
    throw new PreventDefaultException(reason);
  }
  function getHandlersFor($this, clazz) {
    if ($this._handlers_0 == null)
      return null;
    var tmp0_safe_receiver = $this._handlers_0;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_116(clazz);
    return (tmp == null ? true : tmp instanceof FastArrayList) ? tmp : null;
  }
  function getHandlersForCreate($this, clazz) {
    if ($this._handlers_0 == null)
      $this._handlers_0 = LinkedHashMap_init_$Create$();
    var tmp0_getOrPut_0 = ensureNotNull($this._handlers_0);
    var value_1 = tmp0_getOrPut_0.get_116(clazz);
    var tmp;
    if (value_1 == null) {
      var answer_2 = FastArrayList_init_$Create$();
      tmp0_getOrPut_0.put_18(clazz, answer_2);
      Unit_getInstance();
      tmp = answer_2;
    } else {
      tmp = value_1;
    }
    var tmp_0 = tmp;
    return tmp_0 instanceof FastArrayList ? tmp_0 : THROW_CCE();
  }
  function _no_name_provided__286($handlers, $handler) {
    this._$handlers = $handlers;
    this._$handler_0 = $handler;
  }
  _no_name_provided__286.prototype.invoke_998 = function () {
    this._$handlers.remove_47(this._$handler_0);
    Unit_getInstance();
  };
  _no_name_provided__286.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__286.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Mixin_1() {
    this._handlers_0 = null;
  }
  Mixin_1.prototype.addEventListener_6 = function (clazz, handler) {
    var handlers = getHandlersForCreate(this, clazz);
    handlers.add_39(handler);
    Unit_getInstance();
    var tmp = Companion_getInstance_49();
    return tmp.invoke_199(_no_name_provided_$factory_241(handlers, handler));
  };
  Mixin_1.prototype.dispatch_16 = function (clazz, event) {
    if (this._handlers_0 == null)
      return Unit_getInstance();
    var tmp0_safe_receiver = getHandlersFor(this, clazz);
    if (tmp0_safe_receiver == null)
      null;
    else {
      var n_1 = 0;
      while (n_1 < tmp0_safe_receiver._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp0__anonymous__3 = tmp0_safe_receiver.get_137(tmp0_2);
        tmp0__anonymous__3(event);
      }
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  Mixin_1.$metadata$ = {
    simpleName: 'Mixin',
    kind: 'class',
    interfaces: [EventDispatcher]
  };
  function EventDispatcher() {
  }
  EventDispatcher.$metadata$ = {
    simpleName: 'EventDispatcher',
    kind: 'interface',
    interfaces: []
  };
  function PreventDefaultException(reason) {
    Exception_init_$Init$(this);
    this._reason = reason;
    captureStack(this, PreventDefaultException);
  }
  PreventDefaultException.$metadata$ = {
    simpleName: 'PreventDefaultException',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_241($handlers, $handler) {
    var i = new _no_name_provided__286($handlers, $handler);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  var Type_MOVE_instance;
  var Type_DRAG_instance;
  var Type_UP_instance;
  var Type_DOWN_instance;
  var Type_CLICK_instance;
  var Type_ENTER_instance;
  var Type_EXIT_instance;
  var Type_SCROLL_instance;
  var Type_entriesInitialized_1;
  function Type_initEntries_1() {
    if (Type_entriesInitialized_1)
      return Unit_getInstance();
    Type_entriesInitialized_1 = true;
    Type_MOVE_instance = new Type_1('MOVE', 0);
    Type_DRAG_instance = new Type_1('DRAG', 1);
    Type_UP_instance = new Type_1('UP', 2);
    Type_DOWN_instance = new Type_1('DOWN', 3);
    Type_CLICK_instance = new Type_1('CLICK', 4);
    Type_ENTER_instance = new Type_1('ENTER', 5);
    Type_EXIT_instance = new Type_1('EXIT', 6);
    Type_SCROLL_instance = new Type_1('SCROLL', 7);
  }
  function MouseEvent_init_$Init$(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_MOVE_getInstance();
    if (!(($mask0 & 2) === 0))
      id = 0;
    if (!(($mask0 & 4) === 0))
      x = 0;
    if (!(($mask0 & 8) === 0))
      y = 0;
    if (!(($mask0 & 16) === 0))
      button = MouseButton_LEFT_getInstance();
    if (!(($mask0 & 32) === 0))
      buttons = 0;
    if (!(($mask0 & 64) === 0))
      scrollDeltaX = 0.0;
    if (!(($mask0 & 128) === 0))
      scrollDeltaY = 0.0;
    if (!(($mask0 & 256) === 0))
      scrollDeltaZ = 0.0;
    if (!(($mask0 & 512) === 0))
      isShiftDown = false;
    if (!(($mask0 & 1024) === 0))
      isCtrlDown = false;
    if (!(($mask0 & 2048) === 0))
      isAltDown = false;
    if (!(($mask0 & 4096) === 0))
      isMetaDown = false;
    if (!(($mask0 & 8192) === 0))
      scaleCoords = true;
    MouseEvent_0.call($this, type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords);
    return $this;
  }
  function MouseEvent_init_$Create$(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, $mask0, $marker) {
    return MouseEvent_init_$Init$(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, $mask0, $marker, Object.create(MouseEvent_0.prototype));
  }
  function Type_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_1.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__287() {
  }
  _no_name_provided__287.prototype.invoke_998 = function () {
    return Unit_getInstance();
  };
  _no_name_provided__287.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__287.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Type_MOVE_getInstance() {
    Type_initEntries_1();
    return Type_MOVE_instance;
  }
  function Type_DRAG_getInstance() {
    Type_initEntries_1();
    return Type_DRAG_instance;
  }
  function Type_UP_getInstance() {
    Type_initEntries_1();
    return Type_UP_instance;
  }
  function Type_DOWN_getInstance() {
    Type_initEntries_1();
    return Type_DOWN_instance;
  }
  function Type_CLICK_getInstance() {
    Type_initEntries_1();
    return Type_CLICK_instance;
  }
  function Type_ENTER_getInstance() {
    Type_initEntries_1();
    return Type_ENTER_instance;
  }
  function Type_EXIT_getInstance() {
    Type_initEntries_1();
    return Type_EXIT_instance;
  }
  function Type_SCROLL_getInstance() {
    Type_initEntries_1();
    return Type_SCROLL_instance;
  }
  function MouseEvent_0(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords) {
    Event_0.call(this);
    this._type_7 = type;
    this._id_15 = id;
    this._x_12 = x;
    this._y_11 = y;
    this._button = button;
    this._buttons = buttons;
    this._scrollDeltaX = scrollDeltaX;
    this._scrollDeltaY = scrollDeltaY;
    this._scrollDeltaZ = scrollDeltaZ;
    this._isShiftDown = isShiftDown;
    this._isCtrlDown = isCtrlDown;
    this._isAltDown = isAltDown;
    this._isMetaDown = isMetaDown;
    this._scaleCoords = scaleCoords;
    this._component = null;
    var tmp = this;
    tmp._requestLock = _no_name_provided_$factory_242();
  }
  MouseEvent_0.prototype.toString = function () {
    return '' + 'MouseEvent(type=' + this._type_7 + ', id=' + this._id_15 + ', x=' + this._x_12 + ', y=' + this._y_11 + ', button=' + this._button + ', buttons=' + this._buttons + ', scrollDeltaX=' + this._scrollDeltaX + ', scrollDeltaY=' + this._scrollDeltaY + ', scrollDeltaZ=' + this._scrollDeltaZ + ', isShiftDown=' + this._isShiftDown + ', isCtrlDown=' + this._isCtrlDown + ', isAltDown=' + this._isAltDown + ', isMetaDown=' + this._isMetaDown + ', scaleCoords=' + this._scaleCoords + ')';
  };
  MouseEvent_0.prototype.hashCode = function () {
    var result = this._type_7.hashCode();
    result = imul(result, 31) + this._id_15 | 0;
    result = imul(result, 31) + this._x_12 | 0;
    result = imul(result, 31) + this._y_11 | 0;
    result = imul(result, 31) + this._button.hashCode() | 0;
    result = imul(result, 31) + this._buttons | 0;
    result = imul(result, 31) + getNumberHashCode(this._scrollDeltaX) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scrollDeltaY) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scrollDeltaZ) | 0;
    result = imul(result, 31) + (this._isShiftDown | 0) | 0;
    result = imul(result, 31) + (this._isCtrlDown | 0) | 0;
    result = imul(result, 31) + (this._isAltDown | 0) | 0;
    result = imul(result, 31) + (this._isMetaDown | 0) | 0;
    result = imul(result, 31) + (this._scaleCoords | 0) | 0;
    return result;
  };
  MouseEvent_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MouseEvent_0 ? other : THROW_CCE();
    if (!this._type_7.equals(tmp0_other_with_cast._type_7))
      return false;
    if (!(this._id_15 === tmp0_other_with_cast._id_15))
      return false;
    if (!(this._x_12 === tmp0_other_with_cast._x_12))
      return false;
    if (!(this._y_11 === tmp0_other_with_cast._y_11))
      return false;
    if (!this._button.equals(tmp0_other_with_cast._button))
      return false;
    if (!(this._buttons === tmp0_other_with_cast._buttons))
      return false;
    if (!equals_1(this._scrollDeltaX, tmp0_other_with_cast._scrollDeltaX))
      return false;
    if (!equals_1(this._scrollDeltaY, tmp0_other_with_cast._scrollDeltaY))
      return false;
    if (!equals_1(this._scrollDeltaZ, tmp0_other_with_cast._scrollDeltaZ))
      return false;
    if (!(this._isShiftDown === tmp0_other_with_cast._isShiftDown))
      return false;
    if (!(this._isCtrlDown === tmp0_other_with_cast._isCtrlDown))
      return false;
    if (!(this._isAltDown === tmp0_other_with_cast._isAltDown))
      return false;
    if (!(this._isMetaDown === tmp0_other_with_cast._isMetaDown))
      return false;
    if (!(this._scaleCoords === tmp0_other_with_cast._scaleCoords))
      return false;
    return true;
  };
  MouseEvent_0.$metadata$ = {
    simpleName: 'MouseEvent',
    kind: 'class',
    interfaces: []
  };
  function ReshapeEvent_init_$Init$(x, y, width, height, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      x = 0;
    if (!(($mask0 & 2) === 0))
      y = 0;
    if (!(($mask0 & 4) === 0))
      width = 0;
    if (!(($mask0 & 8) === 0))
      height = 0;
    ReshapeEvent.call($this, x, y, width, height);
    return $this;
  }
  function ReshapeEvent_init_$Create$(x, y, width, height, $mask0, $marker) {
    return ReshapeEvent_init_$Init$(x, y, width, height, $mask0, $marker, Object.create(ReshapeEvent.prototype));
  }
  function ReshapeEvent(x, y, width, height) {
    Event_0.call(this);
    this._x_13 = x;
    this._y_12 = y;
    this._width_12 = width;
    this._height_12 = height;
  }
  ReshapeEvent.prototype.toString = function () {
    return '' + 'ReshapeEvent(x=' + this._x_13 + ', y=' + this._y_12 + ', width=' + this._width_12 + ', height=' + this._height_12 + ')';
  };
  ReshapeEvent.prototype.hashCode = function () {
    var result = this._x_13;
    result = imul(result, 31) + this._y_12 | 0;
    result = imul(result, 31) + this._width_12 | 0;
    result = imul(result, 31) + this._height_12 | 0;
    return result;
  };
  ReshapeEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this._x_13 === tmp0_other_with_cast._x_13))
      return false;
    if (!(this._y_12 === tmp0_other_with_cast._y_12))
      return false;
    if (!(this._width_12 === tmp0_other_with_cast._width_12))
      return false;
    if (!(this._height_12 === tmp0_other_with_cast._height_12))
      return false;
    return true;
  };
  ReshapeEvent.$metadata$ = {
    simpleName: 'ReshapeEvent',
    kind: 'class',
    interfaces: []
  };
  var Type_UP_instance_0;
  var Type_DOWN_instance_0;
  var Type_TYPE_instance;
  var Type_entriesInitialized_2;
  function Type_initEntries_2() {
    if (Type_entriesInitialized_2)
      return Unit_getInstance();
    Type_entriesInitialized_2 = true;
    Type_UP_instance_0 = new Type_2('UP', 0);
    Type_DOWN_instance_0 = new Type_2('DOWN', 1);
    Type_TYPE_instance = new Type_2('TYPE', 2);
  }
  function KeyEvent_init_$Init$(type, id, key, keyCode, character, shift, ctrl, alt, meta, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_UP_getInstance_0();
    if (!(($mask0 & 2) === 0))
      id = 0;
    if (!(($mask0 & 4) === 0))
      key = Key_UP_getInstance();
    if (!(($mask0 & 8) === 0))
      keyCode = 0;
    if (!(($mask0 & 16) === 0))
      character = new Char(0);
    if (!(($mask0 & 32) === 0))
      shift = false;
    if (!(($mask0 & 64) === 0))
      ctrl = false;
    if (!(($mask0 & 128) === 0))
      alt = false;
    if (!(($mask0 & 256) === 0))
      meta = false;
    KeyEvent.call($this, type, id, key, keyCode, character, shift, ctrl, alt, meta);
    return $this;
  }
  function KeyEvent_init_$Create$(type, id, key, keyCode, character, shift, ctrl, alt, meta, $mask0, $marker) {
    return KeyEvent_init_$Init$(type, id, key, keyCode, character, shift, ctrl, alt, meta, $mask0, $marker, Object.create(KeyEvent.prototype));
  }
  function Type_2(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_2.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_UP_getInstance_0() {
    Type_initEntries_2();
    return Type_UP_instance_0;
  }
  function Type_DOWN_getInstance_0() {
    Type_initEntries_2();
    return Type_DOWN_instance_0;
  }
  function Type_TYPE_getInstance() {
    Type_initEntries_2();
    return Type_TYPE_instance;
  }
  function KeyEvent(type, id, key, keyCode, character, shift, ctrl, alt, meta) {
    Event_0.call(this);
    this._type_8 = type;
    this._id_16 = id;
    this._key_3 = key;
    this._keyCode = keyCode;
    this._character = character;
    this._shift_0 = shift;
    this._ctrl = ctrl;
    this._alt = alt;
    this._meta = meta;
    this._deltaTime = Companion_getInstance_27()._ZERO;
  }
  KeyEvent.prototype.toString = function () {
    return '' + 'KeyEvent(type=' + this._type_8 + ', id=' + this._id_16 + ', key=' + this._key_3 + ', keyCode=' + this._keyCode + ', character=' + this._character + ', shift=' + this._shift_0 + ', ctrl=' + this._ctrl + ', alt=' + this._alt + ', meta=' + this._meta + ')';
  };
  KeyEvent.prototype.hashCode = function () {
    var result = this._type_8.hashCode();
    result = imul(result, 31) + this._id_16 | 0;
    result = imul(result, 31) + this._key_3.hashCode() | 0;
    result = imul(result, 31) + this._keyCode | 0;
    result = imul(result, 31) + this._character.hashCode() | 0;
    result = imul(result, 31) + (this._shift_0 | 0) | 0;
    result = imul(result, 31) + (this._ctrl | 0) | 0;
    result = imul(result, 31) + (this._alt | 0) | 0;
    result = imul(result, 31) + (this._meta | 0) | 0;
    return result;
  };
  KeyEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this._type_8.equals(tmp0_other_with_cast._type_8))
      return false;
    if (!(this._id_16 === tmp0_other_with_cast._id_16))
      return false;
    if (!this._key_3.equals(tmp0_other_with_cast._key_3))
      return false;
    if (!(this._keyCode === tmp0_other_with_cast._keyCode))
      return false;
    if (!this._character.equals(tmp0_other_with_cast._character))
      return false;
    if (!(this._shift_0 === tmp0_other_with_cast._shift_0))
      return false;
    if (!(this._ctrl === tmp0_other_with_cast._ctrl))
      return false;
    if (!(this._alt === tmp0_other_with_cast._alt))
      return false;
    if (!(this._meta === tmp0_other_with_cast._meta))
      return false;
    return true;
  };
  KeyEvent.$metadata$ = {
    simpleName: 'KeyEvent',
    kind: 'class',
    interfaces: []
  };
  function GamePadUpdateEvent_init_$Init$(gamepadsLength, gamepads, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      gamepadsLength = 0;
    if (!(($mask0 & 2) === 0)) {
      var tmp = 0;
      var tmp_0 = 8;
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = GamepadInfo_init_$Create$(tmp_2, false, null, null, null, 0, null, 0, 0, 510, null);
        tmp = tmp + 1 | 0;
      }
      gamepads = tmp_1;
    }GamePadUpdateEvent.call($this, gamepadsLength, gamepads);
    return $this;
  }
  function GamePadUpdateEvent_init_$Create$(gamepadsLength, gamepads, $mask0, $marker) {
    return GamePadUpdateEvent_init_$Init$(gamepadsLength, gamepads, $mask0, $marker, Object.create(GamePadUpdateEvent.prototype));
  }
  function GamePadUpdateEvent(gamepadsLength, gamepads) {
    Event_0.call(this);
    this._gamepadsLength = gamepadsLength;
    this._gamepads = gamepads;
  }
  GamePadUpdateEvent.prototype.copyFrom_5 = function (that) {
    this._gamepadsLength = that._gamepadsLength;
    var inductionVariable = 0;
    var last_1 = this._gamepads.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this._gamepads[n].copyFrom_6(that._gamepads[n]);
      }
       while (inductionVariable < last_1);
  };
  GamePadUpdateEvent.prototype.toString = function () {
    var tmp0_filter_0 = this._gamepads;
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var indexedObject = tmp0_filter_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_3 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element_2_3._connected) {
        tmp0_filterTo_0_1.add_39(element_2_3);
        Unit_getInstance();
      } else {
      }
    }
    return '' + 'GamePadUpdateEvent(' + tmp0_filterTo_0_1 + ')';
  };
  GamePadUpdateEvent.prototype.hashCode = function () {
    var result = this._gamepadsLength;
    result = imul(result, 31) + hashCode(this._gamepads) | 0;
    return result;
  };
  GamePadUpdateEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this._gamepadsLength === tmp0_other_with_cast._gamepadsLength))
      return false;
    if (!equals_1(this._gamepads, tmp0_other_with_cast._gamepads))
      return false;
    return true;
  };
  GamePadUpdateEvent.$metadata$ = {
    simpleName: 'GamePadUpdateEvent',
    kind: 'class',
    interfaces: []
  };
  function GamePadStickEvent_init_$Init$(gamepad, stick, x, y, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      gamepad = 0;
    if (!(($mask0 & 2) === 0))
      stick = GameStick_LEFT_getInstance();
    if (!(($mask0 & 4) === 0))
      x = 0.0;
    if (!(($mask0 & 8) === 0))
      y = 0.0;
    GamePadStickEvent.call($this, gamepad, stick, x, y);
    return $this;
  }
  function GamePadStickEvent_init_$Create$(gamepad, stick, x, y, $mask0, $marker) {
    return GamePadStickEvent_init_$Init$(gamepad, stick, x, y, $mask0, $marker, Object.create(GamePadStickEvent.prototype));
  }
  function GamePadStickEvent(gamepad, stick, x, y) {
    Event_0.call(this);
    this._gamepad = gamepad;
    this._stick = stick;
    this._x_14 = x;
    this._y_13 = y;
  }
  GamePadStickEvent.prototype.toString = function () {
    return '' + 'GamePadStickEvent(gamepad=' + this._gamepad + ', stick=' + this._stick + ', x=' + this._x_14 + ', y=' + this._y_13 + ')';
  };
  GamePadStickEvent.prototype.hashCode = function () {
    var result = this._gamepad;
    result = imul(result, 31) + this._stick.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._x_14) | 0;
    result = imul(result, 31) + getNumberHashCode(this._y_13) | 0;
    return result;
  };
  GamePadStickEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadStickEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GamePadStickEvent ? other : THROW_CCE();
    if (!(this._gamepad === tmp0_other_with_cast._gamepad))
      return false;
    if (!this._stick.equals(tmp0_other_with_cast._stick))
      return false;
    if (!equals_1(this._x_14, tmp0_other_with_cast._x_14))
      return false;
    if (!equals_1(this._y_13, tmp0_other_with_cast._y_13))
      return false;
    return true;
  };
  GamePadStickEvent.$metadata$ = {
    simpleName: 'GamePadStickEvent',
    kind: 'class',
    interfaces: []
  };
  var Type_UP_instance_1;
  var Type_DOWN_instance_1;
  var Type_entriesInitialized_3;
  function Type_initEntries_3() {
    if (Type_entriesInitialized_3)
      return Unit_getInstance();
    Type_entriesInitialized_3 = true;
    Type_UP_instance_1 = new Type_3('UP', 0);
    Type_DOWN_instance_1 = new Type_3('DOWN', 1);
  }
  function GamePadButtonEvent_init_$Init$(type, gamepad, button, value, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_DOWN_getInstance_1();
    if (!(($mask0 & 2) === 0))
      gamepad = 0;
    if (!(($mask0 & 4) === 0))
      button = GameButton_BUTTON0_getInstance();
    if (!(($mask0 & 8) === 0))
      value = 0.0;
    GamePadButtonEvent.call($this, type, gamepad, button, value);
    return $this;
  }
  function GamePadButtonEvent_init_$Create$(type, gamepad, button, value, $mask0, $marker) {
    return GamePadButtonEvent_init_$Init$(type, gamepad, button, value, $mask0, $marker, Object.create(GamePadButtonEvent.prototype));
  }
  function Type_3(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_3.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_UP_getInstance_1() {
    Type_initEntries_3();
    return Type_UP_instance_1;
  }
  function Type_DOWN_getInstance_1() {
    Type_initEntries_3();
    return Type_DOWN_instance_1;
  }
  function GamePadButtonEvent(type, gamepad, button, value) {
    Event_0.call(this);
    this._type_9 = type;
    this._gamepad_0 = gamepad;
    this._button_0 = button;
    this._value_22 = value;
  }
  GamePadButtonEvent.prototype.toString = function () {
    return '' + 'GamePadButtonEvent(type=' + this._type_9 + ', gamepad=' + this._gamepad_0 + ', button=' + this._button_0 + ', value=' + this._value_22 + ')';
  };
  GamePadButtonEvent.prototype.hashCode = function () {
    var result = this._type_9.hashCode();
    result = imul(result, 31) + this._gamepad_0 | 0;
    result = imul(result, 31) + this._button_0.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this._value_22) | 0;
    return result;
  };
  GamePadButtonEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadButtonEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GamePadButtonEvent ? other : THROW_CCE();
    if (!this._type_9.equals(tmp0_other_with_cast._type_9))
      return false;
    if (!(this._gamepad_0 === tmp0_other_with_cast._gamepad_0))
      return false;
    if (!this._button_0.equals(tmp0_other_with_cast._button_0))
      return false;
    if (!equals_1(this._value_22, tmp0_other_with_cast._value_22))
      return false;
    return true;
  };
  GamePadButtonEvent.$metadata$ = {
    simpleName: 'GamePadButtonEvent',
    kind: 'class',
    interfaces: []
  };
  var Type_CONNECTED_instance;
  var Type_DISCONNECTED_instance;
  var Type_entriesInitialized_4;
  function Type_initEntries_4() {
    if (Type_entriesInitialized_4)
      return Unit_getInstance();
    Type_entriesInitialized_4 = true;
    Type_CONNECTED_instance = new Type_4('CONNECTED', 0);
    Type_DISCONNECTED_instance = new Type_4('DISCONNECTED', 1);
  }
  function GamePadConnectionEvent_init_$Init$(type, gamepad, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_CONNECTED_getInstance();
    if (!(($mask0 & 2) === 0))
      gamepad = 0;
    GamePadConnectionEvent.call($this, type, gamepad);
    return $this;
  }
  function GamePadConnectionEvent_init_$Create$(type, gamepad, $mask0, $marker) {
    return GamePadConnectionEvent_init_$Init$(type, gamepad, $mask0, $marker, Object.create(GamePadConnectionEvent.prototype));
  }
  function Type_4(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_4.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_CONNECTED_getInstance() {
    Type_initEntries_4();
    return Type_CONNECTED_instance;
  }
  function Type_DISCONNECTED_getInstance() {
    Type_initEntries_4();
    return Type_DISCONNECTED_instance;
  }
  function GamePadConnectionEvent(type, gamepad) {
    Event_0.call(this);
    this._type_10 = type;
    this._gamepad_1 = gamepad;
  }
  GamePadConnectionEvent.prototype.toString = function () {
    return '' + 'GamePadConnectionEvent(type=' + this._type_10 + ', gamepad=' + this._gamepad_1 + ')';
  };
  GamePadConnectionEvent.prototype.hashCode = function () {
    var result = this._type_10.hashCode();
    result = imul(result, 31) + this._gamepad_1 | 0;
    return result;
  };
  GamePadConnectionEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this._type_10.equals(tmp0_other_with_cast._type_10))
      return false;
    if (!(this._gamepad_1 === tmp0_other_with_cast._gamepad_1))
      return false;
    return true;
  };
  GamePadConnectionEvent.$metadata$ = {
    simpleName: 'GamePadConnectionEvent',
    kind: 'class',
    interfaces: []
  };
  var Type_START_instance;
  var Type_END_instance;
  var Type_MOVE_instance_0;
  var Type_HOVER_instance;
  var Type_UNKNOWN_instance;
  var Type_entriesInitialized_5;
  function Type_initEntries_5() {
    if (Type_entriesInitialized_5)
      return Unit_getInstance();
    Type_entriesInitialized_5 = true;
    Type_START_instance = new Type_5('START', 0);
    Type_END_instance = new Type_5('END', 1);
    Type_MOVE_instance_0 = new Type_5('MOVE', 2);
    Type_HOVER_instance = new Type_5('HOVER', 3);
    Type_UNKNOWN_instance = new Type_5('UNKNOWN', 4);
  }
  function TouchEvent_init_$Init$(type, screen, currentTime, scaleCoords, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_START_getInstance();
    if (!(($mask0 & 2) === 0))
      screen = 0;
    if (!(($mask0 & 4) === 0))
      currentTime = Companion_getInstance_18()._EPOCH;
    if (!(($mask0 & 8) === 0))
      scaleCoords = true;
    TouchEvent_0.call($this, type, screen, currentTime, scaleCoords);
    return $this;
  }
  function TouchEvent_init_$Create$(type, screen, currentTime, scaleCoords, $mask0, $marker) {
    return TouchEvent_init_$Init$(type, screen, currentTime, scaleCoords, $mask0, $marker, Object.create(TouchEvent_0.prototype));
  }
  function Companion_128() {
    Companion_instance_127 = this;
    this._MAX_TOUCHES = 10;
  }
  Companion_128.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_127;
  function Companion_getInstance_127() {
    if (Companion_instance_127 == null)
      new Companion_128();
    return Companion_instance_127;
  }
  function Type_5(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_5.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_START_getInstance() {
    Type_initEntries_5();
    return Type_START_instance;
  }
  function Type_END_getInstance() {
    Type_initEntries_5();
    return Type_END_instance;
  }
  function Type_MOVE_getInstance_0() {
    Type_initEntries_5();
    return Type_MOVE_instance_0;
  }
  function TouchEvent_0(type, screen, currentTime, scaleCoords) {
    Companion_getInstance_127();
    Event_0.call(this);
    this._type_11 = type;
    this._screen = screen;
    this._currentTime = currentTime;
    this._scaleCoords_0 = scaleCoords;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_getInstance_127()._MAX_TOUCHES;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Touch_init_$Create$(tmp_3, 0, 0.0, 0.0, null, 30, null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._bufferTouches = tmp_2;
    this.__touches = FastArrayList_init_$Create$();
    this._actionTouch = null;
  }
  TouchEvent_0.prototype._get_touches_ = function () {
    return this.__touches;
  };
  TouchEvent_0.prototype.startFrame_4 = function (type) {
    this._type_11 = type;
    this._currentTime = Companion_getInstance_18().now_2();
    this._actionTouch = null;
    this.__touches.clear_33();
  };
  TouchEvent_0.prototype.touch = function (id, x, y, status) {
    var touch = this._bufferTouches[this.__touches._get_size__60()];
    touch._id_17 = id;
    touch._x_15 = x;
    touch._y_14 = y;
    touch._status_1 = status;
    this.__touches.add_39(touch);
    Unit_getInstance();
    if (!status.equals(Status_KEEP_getInstance())) {
      this._actionTouch = touch;
    }};
  TouchEvent_0.prototype.touch$default = function (id, x, y, status, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      status = Status_KEEP_getInstance();
    return this.touch(id, x, y, status);
  };
  TouchEvent_0.prototype.toString = function () {
    return '' + 'TouchEvent(type=' + this._type_11 + ', screen=' + this._screen + ', currentTime=' + new DateTime(this._currentTime) + ', scaleCoords=' + this._scaleCoords_0 + ')';
  };
  TouchEvent_0.prototype.hashCode = function () {
    var result = this._type_11.hashCode();
    result = imul(result, 31) + this._screen | 0;
    result = imul(result, 31) + DateTime__hashCode_impl(this._currentTime) | 0;
    result = imul(result, 31) + (this._scaleCoords_0 | 0) | 0;
    return result;
  };
  TouchEvent_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TouchEvent_0 ? other : THROW_CCE();
    if (!this._type_11.equals(tmp0_other_with_cast._type_11))
      return false;
    if (!(this._screen === tmp0_other_with_cast._screen))
      return false;
    if (!equals_1(new DateTime(this._currentTime), new DateTime(tmp0_other_with_cast._currentTime)))
      return false;
    if (!(this._scaleCoords_0 === tmp0_other_with_cast._scaleCoords_0))
      return false;
    return true;
  };
  TouchEvent_0.$metadata$ = {
    simpleName: 'TouchEvent',
    kind: 'class',
    interfaces: []
  };
  var Status_ADD_instance;
  var Status_KEEP_instance;
  var Status_REMOVE_instance;
  var Status_entriesInitialized;
  function Status_initEntries() {
    if (Status_entriesInitialized)
      return Unit_getInstance();
    Status_entriesInitialized = true;
    Status_ADD_instance = new Status('ADD', 0);
    Status_KEEP_instance = new Status('KEEP', 1);
    Status_REMOVE_instance = new Status('REMOVE', 2);
  }
  function Touch_init_$Init$(index, id, x, y, status, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      index = -1;
    if (!(($mask0 & 2) === 0))
      id = -1;
    if (!(($mask0 & 4) === 0))
      x = 0.0;
    if (!(($mask0 & 8) === 0))
      y = 0.0;
    if (!(($mask0 & 16) === 0))
      status = Status_KEEP_getInstance();
    Touch_0.call($this, index, id, x, y, status);
    return $this;
  }
  function Touch_init_$Create$(index, id, x, y, status, $mask0, $marker) {
    return Touch_init_$Init$(index, id, x, y, status, $mask0, $marker, Object.create(Touch_0.prototype));
  }
  function Status(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Status.$metadata$ = {
    simpleName: 'Status',
    kind: 'class',
    interfaces: []
  };
  function Companion_129() {
    Companion_instance_128 = this;
    var tmp = this;
    tmp._dummy_2 = Touch_init_$Create$(-1, 0, 0.0, 0.0, null, 30, null);
  }
  Companion_129.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_128;
  function Companion_getInstance_128() {
    if (Companion_instance_128 == null)
      new Companion_129();
    return Companion_instance_128;
  }
  function Status_KEEP_getInstance() {
    Status_initEntries();
    return Status_KEEP_instance;
  }
  function Touch_0(index, id, x, y, status) {
    Companion_getInstance_128();
    this._index_14 = index;
    this._id_17 = id;
    this._x_15 = x;
    this._y_14 = y;
    this._status_1 = status;
    var tmp = this;
    tmp._$$delegate_0_15 = Mixin_init_$Create$(null, 1, null);
  }
  Touch_0.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_15._extra = _set___;
  };
  Touch_0.prototype._get_extra__71 = function () {
    return this._$$delegate_0_15._extra;
  };
  Touch_0.prototype.hashCode = function () {
    return this._index_14;
  };
  Touch_0.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Touch_0) {
      tmp = this._index_14 === other._index_14;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Touch_0.prototype.toString = function () {
    return '' + 'Touch(index=' + this._index_14 + ', id=' + this._id_17 + ', x=' + this._x_15 + ', y=' + this._y_14 + ', status=' + this._status_1 + ')';
  };
  Touch_0.$metadata$ = {
    simpleName: 'Touch',
    kind: 'class',
    interfaces: [Extra]
  };
  function ResumeEvent() {
    Event_0.call(this);
  }
  ResumeEvent.$metadata$ = {
    simpleName: 'ResumeEvent',
    kind: 'class',
    interfaces: []
  };
  function PauseEvent() {
    Event_0.call(this);
  }
  PauseEvent.$metadata$ = {
    simpleName: 'PauseEvent',
    kind: 'class',
    interfaces: []
  };
  function StopEvent() {
    Event_0.call(this);
  }
  StopEvent.$metadata$ = {
    simpleName: 'StopEvent',
    kind: 'class',
    interfaces: []
  };
  function DestroyEvent() {
    Event_0.call(this);
  }
  DestroyEvent.$metadata$ = {
    simpleName: 'DestroyEvent',
    kind: 'class',
    interfaces: []
  };
  function RenderEvent() {
    Event_0.call(this);
    this._update = true;
  }
  RenderEvent.$metadata$ = {
    simpleName: 'RenderEvent',
    kind: 'class',
    interfaces: []
  };
  function InitEvent() {
    Event_0.call(this);
  }
  InitEvent.$metadata$ = {
    simpleName: 'InitEvent',
    kind: 'class',
    interfaces: []
  };
  function DisposeEvent() {
    Event_0.call(this);
  }
  DisposeEvent.$metadata$ = {
    simpleName: 'DisposeEvent',
    kind: 'class',
    interfaces: []
  };
  function FullScreenEvent_init_$Init$(fullscreen, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      fullscreen = false;
    FullScreenEvent.call($this, fullscreen);
    return $this;
  }
  function FullScreenEvent_init_$Create$(fullscreen, $mask0, $marker) {
    return FullScreenEvent_init_$Init$(fullscreen, $mask0, $marker, Object.create(FullScreenEvent.prototype));
  }
  function FullScreenEvent(fullscreen) {
    Event_0.call(this);
    this._fullscreen = fullscreen;
  }
  FullScreenEvent.prototype.toString = function () {
    return '' + 'FullScreenEvent(fullscreen=' + this._fullscreen + ')';
  };
  FullScreenEvent.prototype.hashCode = function () {
    return this._fullscreen | 0;
  };
  FullScreenEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this._fullscreen === tmp0_other_with_cast._fullscreen))
      return false;
    return true;
  };
  FullScreenEvent.$metadata$ = {
    simpleName: 'FullScreenEvent',
    kind: 'class',
    interfaces: []
  };
  var Type_START_instance_0;
  var Type_END_instance_0;
  var Type_DROP_instance;
  var Type_entriesInitialized_6;
  function Type_initEntries_6() {
    if (Type_entriesInitialized_6)
      return Unit_getInstance();
    Type_entriesInitialized_6 = true;
    Type_START_instance_0 = new Type_6('START', 0);
    Type_END_instance_0 = new Type_6('END', 1);
    Type_DROP_instance = new Type_6('DROP', 2);
  }
  function DropFileEvent_init_$Init$(type, files, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      type = Type_START_getInstance_0();
    if (!(($mask0 & 2) === 0))
      files = null;
    DropFileEvent.call($this, type, files);
    return $this;
  }
  function DropFileEvent_init_$Create$(type, files, $mask0, $marker) {
    return DropFileEvent_init_$Init$(type, files, $mask0, $marker, Object.create(DropFileEvent.prototype));
  }
  function Type_6(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Type_6.$metadata$ = {
    simpleName: 'Type',
    kind: 'class',
    interfaces: []
  };
  function Type_START_getInstance_0() {
    Type_initEntries_6();
    return Type_START_instance_0;
  }
  function Type_END_getInstance_0() {
    Type_initEntries_6();
    return Type_END_instance_0;
  }
  function Type_DROP_getInstance() {
    Type_initEntries_6();
    return Type_DROP_instance;
  }
  function DropFileEvent(type, files) {
    Event_0.call(this);
    this._type_12 = type;
    this._files_1 = files;
  }
  DropFileEvent.prototype.toString = function () {
    return '' + 'DropFileEvent(type=' + this._type_12 + ', files=' + this._files_1 + ')';
  };
  DropFileEvent.prototype.hashCode = function () {
    var result = this._type_12.hashCode();
    result = imul(result, 31) + (this._files_1 == null ? 0 : hashCode(this._files_1)) | 0;
    return result;
  };
  DropFileEvent.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this._type_12.equals(tmp0_other_with_cast._type_12))
      return false;
    if (!equals_1(this._files_1, tmp0_other_with_cast._files_1))
      return false;
    return true;
  };
  DropFileEvent.$metadata$ = {
    simpleName: 'DropFileEvent',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_242() {
    var i = new _no_name_provided__287();
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function getButton(_this_, $this, index) {
    return extract_0(_this_, index) ? 1.0 : 0.0;
  }
  function _no_name_provided__288(this$0, $info) {
    this._this$0_68 = this$0;
    this._$info_0 = $info;
  }
  _no_name_provided__288.prototype.invoke_488 = function (it) {
    return '' + it._get_name__50() + '=' + this._this$0_68.get_105(it, this._$info_0);
  };
  _no_name_provided__288.prototype.invoke_1015 = function (p1) {
    return this.invoke_488(p1 instanceof GameButton ? p1 : THROW_CCE());
  };
  _no_name_provided__288.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function GamepadMapping() {
  }
  GamepadMapping.prototype.getRawButton_2 = function (_this__0, index) {
    return getButton(_this__0._rawButtonsPressed, this, index);
  };
  GamepadMapping.prototype.getRawAxe_2 = function (_this__0, index) {
    var tmp0_getOrElse_0 = _this__0._rawAxes;
    var tmp;
    if (index >= 0 ? index <= _get_lastIndex__1(tmp0_getOrElse_0) : false) {
      tmp = tmp0_getOrElse_0[index];
    } else {
      tmp = 0.0;
    }
    return tmp;
  };
  GamepadMapping.prototype.toString_9 = function (info) {
    var tmp = '' + this._get_id__2() + '(';
    var tmp_0 = values_6();
    return tmp + joinToString$default(tmp_0, ', ', null, null, 0, null, _no_name_provided_$factory_243(this, info), 30, null) + ')';
  };
  GamepadMapping.$metadata$ = {
    simpleName: 'GamepadMapping',
    kind: 'class',
    interfaces: []
  };
  function Companion_130() {
    Companion_instance_129 = this;
    StandardGamepadMapping.call(this);
  }
  Companion_130.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_129;
  function Companion_getInstance_129() {
    if (Companion_instance_129 == null)
      new Companion_130();
    return Companion_instance_129;
  }
  function StandardGamepadMapping() {
    Companion_getInstance_129();
    GamepadMapping.call(this);
    this._id_18 = 'Standard';
  }
  StandardGamepadMapping.prototype._get_id__2 = function () {
    return this._id_18;
  };
  StandardGamepadMapping.prototype.get_105 = function (button, info) {
    var tmp0_subject = button;
    return tmp0_subject.equals(GameButton_BUTTON0_getInstance()) ? this.getRawButton_2(info, 0) : tmp0_subject.equals(GameButton_BUTTON1_getInstance()) ? this.getRawButton_2(info, 1) : tmp0_subject.equals(GameButton_BUTTON2_getInstance()) ? this.getRawButton_2(info, 2) : tmp0_subject.equals(GameButton_BUTTON3_getInstance()) ? this.getRawButton_2(info, 3) : tmp0_subject.equals(GameButton_L1_getInstance()) ? this.getRawButton_2(info, 4) : tmp0_subject.equals(GameButton_R1_getInstance()) ? this.getRawButton_2(info, 5) : tmp0_subject.equals(GameButton_L2_getInstance()) ? this.getRawButton_2(info, 6) : tmp0_subject.equals(GameButton_R2_getInstance()) ? this.getRawButton_2(info, 7) : tmp0_subject.equals(GameButton_SELECT_getInstance()) ? this.getRawButton_2(info, 8) : tmp0_subject.equals(GameButton_START_getInstance()) ? this.getRawButton_2(info, 9) : tmp0_subject.equals(GameButton_L3_getInstance()) ? this.getRawButton_2(info, 10) : tmp0_subject.equals(GameButton_R3_getInstance()) ? this.getRawButton_2(info, 11) : tmp0_subject.equals(GameButton_UP_getInstance()) ? this.getRawButton_2(info, 12) : tmp0_subject.equals(GameButton_DOWN_getInstance()) ? this.getRawButton_2(info, 13) : tmp0_subject.equals(GameButton_LEFT_getInstance()) ? this.getRawButton_2(info, 14) : tmp0_subject.equals(GameButton_RIGHT_getInstance()) ? this.getRawButton_2(info, 15) : tmp0_subject.equals(GameButton_SYSTEM_getInstance()) ? this.getRawButton_2(info, 16) : tmp0_subject.equals(GameButton_LX_getInstance()) ? this.getRawAxe_2(info, 0) : tmp0_subject.equals(GameButton_LY_getInstance()) ? this.getRawAxe_2(info, 1) : tmp0_subject.equals(GameButton_RX_getInstance()) ? this.getRawAxe_2(info, 2) : tmp0_subject.equals(GameButton_RY_getInstance()) ? this.getRawAxe_2(info, 3) : 0.0;
  };
  StandardGamepadMapping.$metadata$ = {
    simpleName: 'StandardGamepadMapping',
    kind: 'class',
    interfaces: []
  };
  var GameButton_LEFT_instance;
  var GameButton_RIGHT_instance;
  var GameButton_UP_instance;
  var GameButton_DOWN_instance;
  var GameButton_BUTTON0_instance;
  var GameButton_BUTTON1_instance;
  var GameButton_BUTTON2_instance;
  var GameButton_BUTTON3_instance;
  var GameButton_SELECT_instance;
  var GameButton_START_instance;
  var GameButton_SYSTEM_instance;
  var GameButton_L1_instance;
  var GameButton_R1_instance;
  var GameButton_L2_instance;
  var GameButton_R2_instance;
  var GameButton_L3_instance;
  var GameButton_R3_instance;
  var GameButton_LX_instance;
  var GameButton_LY_instance;
  var GameButton_RX_instance;
  var GameButton_RY_instance;
  var GameButton_BUTTON4_instance;
  var GameButton_BUTTON5_instance;
  var GameButton_BUTTON6_instance;
  var GameButton_BUTTON7_instance;
  var GameButton_BUTTON8_instance;
  function Companion_131() {
    Companion_instance_130 = this;
    this._BUTTONS = values_6();
    this._MAX_0 = 32;
  }
  Companion_131.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_130;
  function Companion_getInstance_130() {
    if (Companion_instance_130 == null)
      new Companion_131();
    return Companion_instance_130;
  }
  function values_6() {
    return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON0_getInstance(), GameButton_BUTTON1_getInstance(), GameButton_BUTTON2_getInstance(), GameButton_BUTTON3_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance()];
  }
  var GameButton_entriesInitialized;
  function GameButton_initEntries() {
    if (GameButton_entriesInitialized)
      return Unit_getInstance();
    GameButton_entriesInitialized = true;
    GameButton_LEFT_instance = new GameButton('LEFT', 0, 0);
    GameButton_RIGHT_instance = new GameButton('RIGHT', 1, 1);
    GameButton_UP_instance = new GameButton('UP', 2, 2);
    GameButton_DOWN_instance = new GameButton('DOWN', 3, 3);
    GameButton_BUTTON0_instance = new GameButton('BUTTON0', 4, 4);
    GameButton_BUTTON1_instance = new GameButton('BUTTON1', 5, 5);
    GameButton_BUTTON2_instance = new GameButton('BUTTON2', 6, 6);
    GameButton_BUTTON3_instance = new GameButton('BUTTON3', 7, 7);
    GameButton_SELECT_instance = new GameButton('SELECT', 8, 8);
    GameButton_START_instance = new GameButton('START', 9, 9);
    GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10, 10);
    GameButton_L1_instance = new GameButton('L1', 11, 11);
    GameButton_R1_instance = new GameButton('R1', 12, 12);
    GameButton_L2_instance = new GameButton('L2', 13, 13);
    GameButton_R2_instance = new GameButton('R2', 14, 14);
    GameButton_L3_instance = new GameButton('L3', 15, 15);
    GameButton_R3_instance = new GameButton('R3', 16, 16);
    GameButton_LX_instance = new GameButton('LX', 17, 17);
    GameButton_LY_instance = new GameButton('LY', 18, 18);
    GameButton_RX_instance = new GameButton('RX', 19, 19);
    GameButton_RY_instance = new GameButton('RY', 20, 20);
    GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21, 24);
    GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22, 25);
    GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23, 26);
    GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24, 27);
    GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25, 28);
    Companion_getInstance_130();
  }
  function GameButton(name, ordinal, index) {
    Enum.call(this, name, ordinal);
    this._index_15 = index;
  }
  GameButton.$metadata$ = {
    simpleName: 'GameButton',
    kind: 'class',
    interfaces: []
  };
  function GamepadInfo_init_$Init$(index, connected, name, mapping, rawButtonsPressure, rawButtonsPressed, rawAxes, axesLength, buttonsLength, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      index = 0;
    if (!(($mask0 & 2) === 0))
      connected = false;
    if (!(($mask0 & 4) === 0))
      name = 'unknown';
    if (!(($mask0 & 8) === 0))
      mapping = Companion_getInstance_129();
    if (!(($mask0 & 16) === 0))
      rawButtonsPressure = new Float64Array(64);
    if (!(($mask0 & 32) === 0))
      rawButtonsPressed = 0;
    if (!(($mask0 & 64) === 0))
      rawAxes = new Float64Array(16);
    if (!(($mask0 & 128) === 0))
      axesLength = 0;
    if (!(($mask0 & 256) === 0))
      buttonsLength = 0;
    GamepadInfo.call($this, index, connected, name, mapping, rawButtonsPressure, rawButtonsPressed, rawAxes, axesLength, buttonsLength);
    return $this;
  }
  function GamepadInfo_init_$Create$(index, connected, name, mapping, rawButtonsPressure, rawButtonsPressed, rawAxes, axesLength, buttonsLength, $mask0, $marker) {
    return GamepadInfo_init_$Init$(index, connected, name, mapping, rawButtonsPressure, rawButtonsPressed, rawAxes, axesLength, buttonsLength, $mask0, $marker, Object.create(GamepadInfo.prototype));
  }
  function GamepadInfo(index, connected, name, mapping, rawButtonsPressure, rawButtonsPressed, rawAxes, axesLength, buttonsLength) {
    this._index_16 = index;
    this._connected = connected;
    this._name_24 = name;
    this._mapping = mapping;
    this._rawButtonsPressure = rawButtonsPressure;
    this._rawButtonsPressed = rawButtonsPressed;
    this._rawAxes = rawAxes;
    this._axesLength = axesLength;
    this._buttonsLength = buttonsLength;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = 2;
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Companion_getInstance_80().invoke_1005();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp._axesData = tmp_2;
  }
  GamepadInfo.prototype.copyFrom_6 = function (that) {
    this._index_16 = that._index_16;
    this._name_24 = that._name_24;
    this._mapping = that._mapping;
    this._rawButtonsPressed = that._rawButtonsPressed;
    this._connected = that._connected;
    this._axesLength = that._axesLength;
    this._buttonsLength = that._buttonsLength;
    arraycopy_5(that._axesData, 0, this._axesData, 0, min2_7(this._axesData.length, that._axesData.length));
    arraycopy_6(that._rawButtonsPressure, 0, this._rawButtonsPressure, 0, min2_7(this._rawButtonsPressure.length, that._rawButtonsPressure.length));
    arraycopy_6(that._rawAxes, 0, this._rawAxes, 0, min2_7(this._rawAxes.length, that._rawAxes.length));
  };
  GamepadInfo.prototype.get_100 = function (button) {
    return this._mapping.get_105(button, this);
  };
  GamepadInfo.prototype.get_101 = function (stick) {
    var tmp0_apply_0 = this._axesData[stick._id_20];
    tmp0_apply_0._x_2 = this.getX_3(stick);
    tmp0_apply_0._y_2 = this.getY_3(stick);
    return tmp0_apply_0;
  };
  GamepadInfo.prototype.getX_3 = function (stick) {
    var tmp0_subject = stick;
    var tmp;
    if (tmp0_subject.equals(GameStick_LEFT_getInstance())) {
      tmp = this.get_100(GameButton_LX_getInstance());
    } else if (tmp0_subject.equals(GameStick_RIGHT_getInstance())) {
      tmp = this.get_100(GameButton_RX_getInstance());
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  GamepadInfo.prototype.getY_3 = function (stick) {
    var tmp0_subject = stick;
    var tmp;
    if (tmp0_subject.equals(GameStick_LEFT_getInstance())) {
      tmp = this.get_100(GameButton_LY_getInstance());
    } else if (tmp0_subject.equals(GameStick_RIGHT_getInstance())) {
      tmp = this.get_100(GameButton_RY_getInstance());
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  GamepadInfo.prototype.toString = function () {
    return '' + 'Gamepad[' + this._index_16 + '][' + this._name_24 + ']' + this._mapping.toString_9(this);
  };
  GamepadInfo.$metadata$ = {
    simpleName: 'GamepadInfo',
    kind: 'class',
    interfaces: []
  };
  var MouseButton_LEFT_instance;
  var MouseButton_MIDDLE_instance;
  var MouseButton_RIGHT_instance;
  var MouseButton_BUTTON3_instance;
  var MouseButton_BUTTON4_instance;
  var MouseButton_BUTTON5_instance;
  var MouseButton_BUTTON6_instance;
  var MouseButton_BUTTON7_instance;
  var MouseButton_BUTTON_WHEEL_instance;
  var MouseButton_BUTTON_UNKNOWN_instance;
  function Companion_132() {
    Companion_instance_131 = this;
    this._MAX_1 = MouseButton_BUTTON_UNKNOWN_getInstance()._get_ordinal__2() + 1 | 0;
    this._BUTTONS_0 = values_7();
  }
  Companion_132.prototype.get_137 = function (id) {
    var tmp0_getOrElse_0 = this._BUTTONS_0;
    var tmp;
    if (id >= 0 ? id <= _get_lastIndex_(tmp0_getOrElse_0) : false) {
      tmp = tmp0_getOrElse_0[id];
    } else {
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  };
  Companion_132.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_131;
  function Companion_getInstance_131() {
    if (Companion_instance_131 == null)
      new Companion_132();
    return Companion_instance_131;
  }
  function values_7() {
    return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance()];
  }
  var MouseButton_entriesInitialized;
  function MouseButton_initEntries() {
    if (MouseButton_entriesInitialized)
      return Unit_getInstance();
    MouseButton_entriesInitialized = true;
    MouseButton_LEFT_instance = new MouseButton('LEFT', 0, 0);
    MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 1, 1);
    MouseButton_RIGHT_instance = new MouseButton('RIGHT', 2, 2);
    MouseButton_BUTTON3_instance = new MouseButton('BUTTON3', 3, 3);
    MouseButton_BUTTON4_instance = new MouseButton('BUTTON4', 4, 4);
    MouseButton_BUTTON5_instance = new MouseButton('BUTTON5', 5, 5);
    MouseButton_BUTTON6_instance = new MouseButton('BUTTON6', 6, 6);
    MouseButton_BUTTON7_instance = new MouseButton('BUTTON7', 7, 7);
    MouseButton_BUTTON_WHEEL_instance = new MouseButton('BUTTON_WHEEL', 8, 8);
    MouseButton_BUTTON_UNKNOWN_instance = new MouseButton('BUTTON_UNKNOWN', 9, 9);
    Companion_getInstance_131();
  }
  function MouseButton(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this._id_19 = id;
  }
  MouseButton.$metadata$ = {
    simpleName: 'MouseButton',
    kind: 'class',
    interfaces: []
  };
  var Key_SPACE_instance;
  var Key_APOSTROPHE_instance;
  var Key_COMMA_instance;
  var Key_MINUS_instance;
  var Key_PLUS_instance;
  var Key_PERIOD_instance;
  var Key_SLASH_instance;
  var Key_N0_instance;
  var Key_N1_instance;
  var Key_N2_instance;
  var Key_N3_instance;
  var Key_N4_instance;
  var Key_N5_instance;
  var Key_N6_instance;
  var Key_N7_instance;
  var Key_N8_instance;
  var Key_N9_instance;
  var Key_SEMICOLON_instance;
  var Key_EQUAL_instance;
  var Key_A_instance;
  var Key_B_instance;
  var Key_C_instance;
  var Key_D_instance;
  var Key_E_instance;
  var Key_F_instance;
  var Key_G_instance;
  var Key_H_instance;
  var Key_I_instance;
  var Key_J_instance;
  var Key_K_instance;
  var Key_L_instance;
  var Key_M_instance;
  var Key_N_instance;
  var Key_O_instance;
  var Key_P_instance;
  var Key_Q_instance;
  var Key_R_instance;
  var Key_S_instance;
  var Key_T_instance;
  var Key_U_instance;
  var Key_V_instance;
  var Key_W_instance;
  var Key_X_instance;
  var Key_Y_instance;
  var Key_Z_instance;
  var Key_LEFT_BRACKET_instance;
  var Key_BACKSLASH_instance;
  var Key_RIGHT_BRACKET_instance;
  var Key_GRAVE_ACCENT_instance;
  var Key_WORLD_1_instance;
  var Key_WORLD_2_instance;
  var Key_ESCAPE_instance;
  var Key_META_instance;
  var Key_ENTER_instance;
  var Key_TAB_instance;
  var Key_BACKSPACE_instance;
  var Key_INSERT_instance;
  var Key_DELETE_instance;
  var Key_RIGHT_instance;
  var Key_LEFT_instance;
  var Key_DOWN_instance;
  var Key_UP_instance;
  var Key_PAGE_UP_instance;
  var Key_PAGE_DOWN_instance;
  var Key_FUNCTION_instance;
  var Key_HELP_instance;
  var Key_MUTE_instance;
  var Key_VOLUME_DOWN_instance;
  var Key_VOLUME_UP_instance;
  var Key_HOME_instance;
  var Key_END_instance;
  var Key_CAPS_LOCK_instance;
  var Key_SCROLL_LOCK_instance;
  var Key_NUM_LOCK_instance;
  var Key_PRINT_SCREEN_instance;
  var Key_PAUSE_instance;
  var Key_F1_instance;
  var Key_F2_instance;
  var Key_F3_instance;
  var Key_F4_instance;
  var Key_F5_instance;
  var Key_F6_instance;
  var Key_F7_instance;
  var Key_F8_instance;
  var Key_F9_instance;
  var Key_F10_instance;
  var Key_F11_instance;
  var Key_F12_instance;
  var Key_F13_instance;
  var Key_F14_instance;
  var Key_F15_instance;
  var Key_F16_instance;
  var Key_F17_instance;
  var Key_F18_instance;
  var Key_F19_instance;
  var Key_F20_instance;
  var Key_F21_instance;
  var Key_F22_instance;
  var Key_F23_instance;
  var Key_F24_instance;
  var Key_F25_instance;
  var Key_KP_0_instance;
  var Key_KP_1_instance;
  var Key_KP_2_instance;
  var Key_KP_3_instance;
  var Key_KP_4_instance;
  var Key_KP_5_instance;
  var Key_KP_6_instance;
  var Key_KP_7_instance;
  var Key_KP_8_instance;
  var Key_KP_9_instance;
  var Key_KP_DECIMAL_instance;
  var Key_KP_DIVIDE_instance;
  var Key_KP_MULTIPLY_instance;
  var Key_KP_SUBTRACT_instance;
  var Key_KP_ADD_instance;
  var Key_KP_ENTER_instance;
  var Key_KP_EQUAL_instance;
  var Key_KP_SEPARATOR_instance;
  var Key_LEFT_SHIFT_instance;
  var Key_LEFT_CONTROL_instance;
  var Key_LEFT_ALT_instance;
  var Key_LEFT_SUPER_instance;
  var Key_RIGHT_SHIFT_instance;
  var Key_RIGHT_CONTROL_instance;
  var Key_RIGHT_ALT_instance;
  var Key_RIGHT_SUPER_instance;
  var Key_MENU_instance;
  var Key_BACKQUOTE_instance;
  var Key_QUOTE_instance;
  var Key_KP_UP_instance;
  var Key_KP_DOWN_instance;
  var Key_KP_LEFT_instance;
  var Key_KP_RIGHT_instance;
  var Key_UNDERLINE_instance;
  var Key_SELECT_KEY_instance;
  var Key_CANCEL_instance;
  var Key_CLEAR_instance;
  var Key_OPEN_BRACKET_instance;
  var Key_CLOSE_BRACKET_instance;
  var Key_UNDEFINED_instance;
  var Key_UNKNOWN_instance;
  function Companion_133() {
    Companion_instance_132 = this;
    this._MAX_2 = Key_UNKNOWN_getInstance()._get_ordinal__2() + 1 | 0;
    this._RETURN = Key_ENTER_getInstance();
    this._NUMPAD0 = Key_N0_getInstance();
    this._NUMPAD1 = Key_N1_getInstance();
    this._NUMPAD2 = Key_N2_getInstance();
    this._NUMPAD3 = Key_N3_getInstance();
    this._NUMPAD4 = Key_N4_getInstance();
    this._NUMPAD5 = Key_N5_getInstance();
    this._NUMPAD6 = Key_N6_getInstance();
    this._NUMPAD7 = Key_N7_getInstance();
    this._NUMPAD8 = Key_N8_getInstance();
    this._NUMPAD9 = Key_N9_getInstance();
  }
  Companion_133.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_132;
  function Companion_getInstance_132() {
    if (Companion_instance_132 == null)
      new Companion_133();
    return Companion_instance_132;
  }
  var Key_entriesInitialized;
  function Key_initEntries() {
    if (Key_entriesInitialized)
      return Unit_getInstance();
    Key_entriesInitialized = true;
    Key_SPACE_instance = new Key_5('SPACE', 0);
    Key_APOSTROPHE_instance = new Key_5('APOSTROPHE', 1);
    Key_COMMA_instance = new Key_5('COMMA', 2);
    Key_MINUS_instance = new Key_5('MINUS', 3);
    Key_PLUS_instance = new Key_5('PLUS', 4);
    Key_PERIOD_instance = new Key_5('PERIOD', 5);
    Key_SLASH_instance = new Key_5('SLASH', 6);
    Key_N0_instance = new Key_5('N0', 7);
    Key_N1_instance = new Key_5('N1', 8);
    Key_N2_instance = new Key_5('N2', 9);
    Key_N3_instance = new Key_5('N3', 10);
    Key_N4_instance = new Key_5('N4', 11);
    Key_N5_instance = new Key_5('N5', 12);
    Key_N6_instance = new Key_5('N6', 13);
    Key_N7_instance = new Key_5('N7', 14);
    Key_N8_instance = new Key_5('N8', 15);
    Key_N9_instance = new Key_5('N9', 16);
    Key_SEMICOLON_instance = new Key_5('SEMICOLON', 17);
    Key_EQUAL_instance = new Key_5('EQUAL', 18);
    Key_A_instance = new Key_5('A', 19);
    Key_B_instance = new Key_5('B', 20);
    Key_C_instance = new Key_5('C', 21);
    Key_D_instance = new Key_5('D', 22);
    Key_E_instance = new Key_5('E', 23);
    Key_F_instance = new Key_5('F', 24);
    Key_G_instance = new Key_5('G', 25);
    Key_H_instance = new Key_5('H', 26);
    Key_I_instance = new Key_5('I', 27);
    Key_J_instance = new Key_5('J', 28);
    Key_K_instance = new Key_5('K', 29);
    Key_L_instance = new Key_5('L', 30);
    Key_M_instance = new Key_5('M', 31);
    Key_N_instance = new Key_5('N', 32);
    Key_O_instance = new Key_5('O', 33);
    Key_P_instance = new Key_5('P', 34);
    Key_Q_instance = new Key_5('Q', 35);
    Key_R_instance = new Key_5('R', 36);
    Key_S_instance = new Key_5('S', 37);
    Key_T_instance = new Key_5('T', 38);
    Key_U_instance = new Key_5('U', 39);
    Key_V_instance = new Key_5('V', 40);
    Key_W_instance = new Key_5('W', 41);
    Key_X_instance = new Key_5('X', 42);
    Key_Y_instance = new Key_5('Y', 43);
    Key_Z_instance = new Key_5('Z', 44);
    Key_LEFT_BRACKET_instance = new Key_5('LEFT_BRACKET', 45);
    Key_BACKSLASH_instance = new Key_5('BACKSLASH', 46);
    Key_RIGHT_BRACKET_instance = new Key_5('RIGHT_BRACKET', 47);
    Key_GRAVE_ACCENT_instance = new Key_5('GRAVE_ACCENT', 48);
    Key_WORLD_1_instance = new Key_5('WORLD_1', 49);
    Key_WORLD_2_instance = new Key_5('WORLD_2', 50);
    Key_ESCAPE_instance = new Key_5('ESCAPE', 51);
    Key_META_instance = new Key_5('META', 52);
    Key_ENTER_instance = new Key_5('ENTER', 53);
    Key_TAB_instance = new Key_5('TAB', 54);
    Key_BACKSPACE_instance = new Key_5('BACKSPACE', 55);
    Key_INSERT_instance = new Key_5('INSERT', 56);
    Key_DELETE_instance = new Key_5('DELETE', 57);
    Key_RIGHT_instance = new Key_5('RIGHT', 58);
    Key_LEFT_instance = new Key_5('LEFT', 59);
    Key_DOWN_instance = new Key_5('DOWN', 60);
    Key_UP_instance = new Key_5('UP', 61);
    Key_PAGE_UP_instance = new Key_5('PAGE_UP', 62);
    Key_PAGE_DOWN_instance = new Key_5('PAGE_DOWN', 63);
    Key_FUNCTION_instance = new Key_5('FUNCTION', 64);
    Key_HELP_instance = new Key_5('HELP', 65);
    Key_MUTE_instance = new Key_5('MUTE', 66);
    Key_VOLUME_DOWN_instance = new Key_5('VOLUME_DOWN', 67);
    Key_VOLUME_UP_instance = new Key_5('VOLUME_UP', 68);
    Key_HOME_instance = new Key_5('HOME', 69);
    Key_END_instance = new Key_5('END', 70);
    Key_CAPS_LOCK_instance = new Key_5('CAPS_LOCK', 71);
    Key_SCROLL_LOCK_instance = new Key_5('SCROLL_LOCK', 72);
    Key_NUM_LOCK_instance = new Key_5('NUM_LOCK', 73);
    Key_PRINT_SCREEN_instance = new Key_5('PRINT_SCREEN', 74);
    Key_PAUSE_instance = new Key_5('PAUSE', 75);
    Key_F1_instance = new Key_5('F1', 76);
    Key_F2_instance = new Key_5('F2', 77);
    Key_F3_instance = new Key_5('F3', 78);
    Key_F4_instance = new Key_5('F4', 79);
    Key_F5_instance = new Key_5('F5', 80);
    Key_F6_instance = new Key_5('F6', 81);
    Key_F7_instance = new Key_5('F7', 82);
    Key_F8_instance = new Key_5('F8', 83);
    Key_F9_instance = new Key_5('F9', 84);
    Key_F10_instance = new Key_5('F10', 85);
    Key_F11_instance = new Key_5('F11', 86);
    Key_F12_instance = new Key_5('F12', 87);
    Key_F13_instance = new Key_5('F13', 88);
    Key_F14_instance = new Key_5('F14', 89);
    Key_F15_instance = new Key_5('F15', 90);
    Key_F16_instance = new Key_5('F16', 91);
    Key_F17_instance = new Key_5('F17', 92);
    Key_F18_instance = new Key_5('F18', 93);
    Key_F19_instance = new Key_5('F19', 94);
    Key_F20_instance = new Key_5('F20', 95);
    Key_F21_instance = new Key_5('F21', 96);
    Key_F22_instance = new Key_5('F22', 97);
    Key_F23_instance = new Key_5('F23', 98);
    Key_F24_instance = new Key_5('F24', 99);
    Key_F25_instance = new Key_5('F25', 100);
    Key_KP_0_instance = new Key_5('KP_0', 101);
    Key_KP_1_instance = new Key_5('KP_1', 102);
    Key_KP_2_instance = new Key_5('KP_2', 103);
    Key_KP_3_instance = new Key_5('KP_3', 104);
    Key_KP_4_instance = new Key_5('KP_4', 105);
    Key_KP_5_instance = new Key_5('KP_5', 106);
    Key_KP_6_instance = new Key_5('KP_6', 107);
    Key_KP_7_instance = new Key_5('KP_7', 108);
    Key_KP_8_instance = new Key_5('KP_8', 109);
    Key_KP_9_instance = new Key_5('KP_9', 110);
    Key_KP_DECIMAL_instance = new Key_5('KP_DECIMAL', 111);
    Key_KP_DIVIDE_instance = new Key_5('KP_DIVIDE', 112);
    Key_KP_MULTIPLY_instance = new Key_5('KP_MULTIPLY', 113);
    Key_KP_SUBTRACT_instance = new Key_5('KP_SUBTRACT', 114);
    Key_KP_ADD_instance = new Key_5('KP_ADD', 115);
    Key_KP_ENTER_instance = new Key_5('KP_ENTER', 116);
    Key_KP_EQUAL_instance = new Key_5('KP_EQUAL', 117);
    Key_KP_SEPARATOR_instance = new Key_5('KP_SEPARATOR', 118);
    Key_LEFT_SHIFT_instance = new Key_5('LEFT_SHIFT', 119);
    Key_LEFT_CONTROL_instance = new Key_5('LEFT_CONTROL', 120);
    Key_LEFT_ALT_instance = new Key_5('LEFT_ALT', 121);
    Key_LEFT_SUPER_instance = new Key_5('LEFT_SUPER', 122);
    Key_RIGHT_SHIFT_instance = new Key_5('RIGHT_SHIFT', 123);
    Key_RIGHT_CONTROL_instance = new Key_5('RIGHT_CONTROL', 124);
    Key_RIGHT_ALT_instance = new Key_5('RIGHT_ALT', 125);
    Key_RIGHT_SUPER_instance = new Key_5('RIGHT_SUPER', 126);
    Key_MENU_instance = new Key_5('MENU', 127);
    Key_BACKQUOTE_instance = new Key_5('BACKQUOTE', 128);
    Key_QUOTE_instance = new Key_5('QUOTE', 129);
    Key_KP_UP_instance = new Key_5('KP_UP', 130);
    Key_KP_DOWN_instance = new Key_5('KP_DOWN', 131);
    Key_KP_LEFT_instance = new Key_5('KP_LEFT', 132);
    Key_KP_RIGHT_instance = new Key_5('KP_RIGHT', 133);
    Key_UNDERLINE_instance = new Key_5('UNDERLINE', 134);
    Key_SELECT_KEY_instance = new Key_5('SELECT_KEY', 135);
    Key_CANCEL_instance = new Key_5('CANCEL', 136);
    Key_CLEAR_instance = new Key_5('CLEAR', 137);
    Key_OPEN_BRACKET_instance = new Key_5('OPEN_BRACKET', 138);
    Key_CLOSE_BRACKET_instance = new Key_5('CLOSE_BRACKET', 139);
    Key_UNDEFINED_instance = new Key_5('UNDEFINED', 140);
    Key_UNKNOWN_instance = new Key_5('UNKNOWN', 141);
    Companion_getInstance_132();
  }
  function Key_5(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Key_5.$metadata$ = {
    simpleName: 'Key',
    kind: 'class',
    interfaces: []
  };
  var GameStick_LEFT_instance;
  var GameStick_RIGHT_instance;
  function Companion_134() {
    Companion_instance_133 = this;
    this._STICKS = values_8();
  }
  Companion_134.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_133;
  function Companion_getInstance_133() {
    if (Companion_instance_133 == null)
      new Companion_134();
    return Companion_instance_133;
  }
  function values_8() {
    return [GameStick_LEFT_getInstance(), GameStick_RIGHT_getInstance()];
  }
  var GameStick_entriesInitialized;
  function GameStick_initEntries() {
    if (GameStick_entriesInitialized)
      return Unit_getInstance();
    GameStick_entriesInitialized = true;
    GameStick_LEFT_instance = new GameStick('LEFT', 0, 0);
    GameStick_RIGHT_instance = new GameStick('RIGHT', 1, 1);
    Companion_getInstance_133();
  }
  function GameStick(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this._id_20 = id;
  }
  GameStick.$metadata$ = {
    simpleName: 'GameStick',
    kind: 'class',
    interfaces: []
  };
  function GameButton_LEFT_getInstance() {
    GameButton_initEntries();
    return GameButton_LEFT_instance;
  }
  function GameButton_RIGHT_getInstance() {
    GameButton_initEntries();
    return GameButton_RIGHT_instance;
  }
  function GameButton_UP_getInstance() {
    GameButton_initEntries();
    return GameButton_UP_instance;
  }
  function GameButton_DOWN_getInstance() {
    GameButton_initEntries();
    return GameButton_DOWN_instance;
  }
  function GameButton_BUTTON0_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON0_instance;
  }
  function GameButton_BUTTON1_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON1_instance;
  }
  function GameButton_BUTTON2_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON2_instance;
  }
  function GameButton_BUTTON3_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON3_instance;
  }
  function GameButton_SELECT_getInstance() {
    GameButton_initEntries();
    return GameButton_SELECT_instance;
  }
  function GameButton_START_getInstance() {
    GameButton_initEntries();
    return GameButton_START_instance;
  }
  function GameButton_SYSTEM_getInstance() {
    GameButton_initEntries();
    return GameButton_SYSTEM_instance;
  }
  function GameButton_L1_getInstance() {
    GameButton_initEntries();
    return GameButton_L1_instance;
  }
  function GameButton_R1_getInstance() {
    GameButton_initEntries();
    return GameButton_R1_instance;
  }
  function GameButton_L2_getInstance() {
    GameButton_initEntries();
    return GameButton_L2_instance;
  }
  function GameButton_R2_getInstance() {
    GameButton_initEntries();
    return GameButton_R2_instance;
  }
  function GameButton_L3_getInstance() {
    GameButton_initEntries();
    return GameButton_L3_instance;
  }
  function GameButton_R3_getInstance() {
    GameButton_initEntries();
    return GameButton_R3_instance;
  }
  function GameButton_LX_getInstance() {
    GameButton_initEntries();
    return GameButton_LX_instance;
  }
  function GameButton_LY_getInstance() {
    GameButton_initEntries();
    return GameButton_LY_instance;
  }
  function GameButton_RX_getInstance() {
    GameButton_initEntries();
    return GameButton_RX_instance;
  }
  function GameButton_RY_getInstance() {
    GameButton_initEntries();
    return GameButton_RY_instance;
  }
  function GameButton_BUTTON4_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON4_instance;
  }
  function GameButton_BUTTON5_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON5_instance;
  }
  function GameButton_BUTTON6_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON6_instance;
  }
  function GameButton_BUTTON7_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON7_instance;
  }
  function GameButton_BUTTON8_getInstance() {
    GameButton_initEntries();
    return GameButton_BUTTON8_instance;
  }
  function MouseButton_LEFT_getInstance() {
    MouseButton_initEntries();
    return MouseButton_LEFT_instance;
  }
  function MouseButton_MIDDLE_getInstance() {
    MouseButton_initEntries();
    return MouseButton_MIDDLE_instance;
  }
  function MouseButton_RIGHT_getInstance() {
    MouseButton_initEntries();
    return MouseButton_RIGHT_instance;
  }
  function MouseButton_BUTTON3_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON3_instance;
  }
  function MouseButton_BUTTON4_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON4_instance;
  }
  function MouseButton_BUTTON5_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON5_instance;
  }
  function MouseButton_BUTTON6_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON6_instance;
  }
  function MouseButton_BUTTON7_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON7_instance;
  }
  function MouseButton_BUTTON_WHEEL_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON_WHEEL_instance;
  }
  function MouseButton_BUTTON_UNKNOWN_getInstance() {
    MouseButton_initEntries();
    return MouseButton_BUTTON_UNKNOWN_instance;
  }
  function Key_SPACE_getInstance() {
    Key_initEntries();
    return Key_SPACE_instance;
  }
  function Key_COMMA_getInstance() {
    Key_initEntries();
    return Key_COMMA_instance;
  }
  function Key_MINUS_getInstance() {
    Key_initEntries();
    return Key_MINUS_instance;
  }
  function Key_PLUS_getInstance() {
    Key_initEntries();
    return Key_PLUS_instance;
  }
  function Key_PERIOD_getInstance() {
    Key_initEntries();
    return Key_PERIOD_instance;
  }
  function Key_SLASH_getInstance() {
    Key_initEntries();
    return Key_SLASH_instance;
  }
  function Key_N0_getInstance() {
    Key_initEntries();
    return Key_N0_instance;
  }
  function Key_N1_getInstance() {
    Key_initEntries();
    return Key_N1_instance;
  }
  function Key_N2_getInstance() {
    Key_initEntries();
    return Key_N2_instance;
  }
  function Key_N3_getInstance() {
    Key_initEntries();
    return Key_N3_instance;
  }
  function Key_N4_getInstance() {
    Key_initEntries();
    return Key_N4_instance;
  }
  function Key_N5_getInstance() {
    Key_initEntries();
    return Key_N5_instance;
  }
  function Key_N6_getInstance() {
    Key_initEntries();
    return Key_N6_instance;
  }
  function Key_N7_getInstance() {
    Key_initEntries();
    return Key_N7_instance;
  }
  function Key_N8_getInstance() {
    Key_initEntries();
    return Key_N8_instance;
  }
  function Key_N9_getInstance() {
    Key_initEntries();
    return Key_N9_instance;
  }
  function Key_SEMICOLON_getInstance() {
    Key_initEntries();
    return Key_SEMICOLON_instance;
  }
  function Key_A_getInstance() {
    Key_initEntries();
    return Key_A_instance;
  }
  function Key_B_getInstance() {
    Key_initEntries();
    return Key_B_instance;
  }
  function Key_C_getInstance() {
    Key_initEntries();
    return Key_C_instance;
  }
  function Key_D_getInstance() {
    Key_initEntries();
    return Key_D_instance;
  }
  function Key_E_getInstance() {
    Key_initEntries();
    return Key_E_instance;
  }
  function Key_F_getInstance() {
    Key_initEntries();
    return Key_F_instance;
  }
  function Key_G_getInstance() {
    Key_initEntries();
    return Key_G_instance;
  }
  function Key_H_getInstance() {
    Key_initEntries();
    return Key_H_instance;
  }
  function Key_I_getInstance() {
    Key_initEntries();
    return Key_I_instance;
  }
  function Key_J_getInstance() {
    Key_initEntries();
    return Key_J_instance;
  }
  function Key_K_getInstance() {
    Key_initEntries();
    return Key_K_instance;
  }
  function Key_L_getInstance() {
    Key_initEntries();
    return Key_L_instance;
  }
  function Key_M_getInstance() {
    Key_initEntries();
    return Key_M_instance;
  }
  function Key_N_getInstance() {
    Key_initEntries();
    return Key_N_instance;
  }
  function Key_O_getInstance() {
    Key_initEntries();
    return Key_O_instance;
  }
  function Key_P_getInstance() {
    Key_initEntries();
    return Key_P_instance;
  }
  function Key_Q_getInstance() {
    Key_initEntries();
    return Key_Q_instance;
  }
  function Key_R_getInstance() {
    Key_initEntries();
    return Key_R_instance;
  }
  function Key_S_getInstance() {
    Key_initEntries();
    return Key_S_instance;
  }
  function Key_T_getInstance() {
    Key_initEntries();
    return Key_T_instance;
  }
  function Key_U_getInstance() {
    Key_initEntries();
    return Key_U_instance;
  }
  function Key_V_getInstance() {
    Key_initEntries();
    return Key_V_instance;
  }
  function Key_W_getInstance() {
    Key_initEntries();
    return Key_W_instance;
  }
  function Key_X_getInstance() {
    Key_initEntries();
    return Key_X_instance;
  }
  function Key_Y_getInstance() {
    Key_initEntries();
    return Key_Y_instance;
  }
  function Key_Z_getInstance() {
    Key_initEntries();
    return Key_Z_instance;
  }
  function Key_ESCAPE_getInstance() {
    Key_initEntries();
    return Key_ESCAPE_instance;
  }
  function Key_META_getInstance() {
    Key_initEntries();
    return Key_META_instance;
  }
  function Key_ENTER_getInstance() {
    Key_initEntries();
    return Key_ENTER_instance;
  }
  function Key_TAB_getInstance() {
    Key_initEntries();
    return Key_TAB_instance;
  }
  function Key_BACKSPACE_getInstance() {
    Key_initEntries();
    return Key_BACKSPACE_instance;
  }
  function Key_RIGHT_getInstance() {
    Key_initEntries();
    return Key_RIGHT_instance;
  }
  function Key_LEFT_getInstance() {
    Key_initEntries();
    return Key_LEFT_instance;
  }
  function Key_DOWN_getInstance() {
    Key_initEntries();
    return Key_DOWN_instance;
  }
  function Key_UP_getInstance() {
    Key_initEntries();
    return Key_UP_instance;
  }
  function Key_F1_getInstance() {
    Key_initEntries();
    return Key_F1_instance;
  }
  function Key_F2_getInstance() {
    Key_initEntries();
    return Key_F2_instance;
  }
  function Key_F3_getInstance() {
    Key_initEntries();
    return Key_F3_instance;
  }
  function Key_F4_getInstance() {
    Key_initEntries();
    return Key_F4_instance;
  }
  function Key_F5_getInstance() {
    Key_initEntries();
    return Key_F5_instance;
  }
  function Key_F6_getInstance() {
    Key_initEntries();
    return Key_F6_instance;
  }
  function Key_F7_getInstance() {
    Key_initEntries();
    return Key_F7_instance;
  }
  function Key_F8_getInstance() {
    Key_initEntries();
    return Key_F8_instance;
  }
  function Key_F9_getInstance() {
    Key_initEntries();
    return Key_F9_instance;
  }
  function Key_F10_getInstance() {
    Key_initEntries();
    return Key_F10_instance;
  }
  function Key_F11_getInstance() {
    Key_initEntries();
    return Key_F11_instance;
  }
  function Key_F12_getInstance() {
    Key_initEntries();
    return Key_F12_instance;
  }
  function Key_F13_getInstance() {
    Key_initEntries();
    return Key_F13_instance;
  }
  function Key_F14_getInstance() {
    Key_initEntries();
    return Key_F14_instance;
  }
  function Key_F15_getInstance() {
    Key_initEntries();
    return Key_F15_instance;
  }
  function Key_F16_getInstance() {
    Key_initEntries();
    return Key_F16_instance;
  }
  function Key_F17_getInstance() {
    Key_initEntries();
    return Key_F17_instance;
  }
  function Key_F18_getInstance() {
    Key_initEntries();
    return Key_F18_instance;
  }
  function Key_F19_getInstance() {
    Key_initEntries();
    return Key_F19_instance;
  }
  function Key_F20_getInstance() {
    Key_initEntries();
    return Key_F20_instance;
  }
  function Key_F21_getInstance() {
    Key_initEntries();
    return Key_F21_instance;
  }
  function Key_F22_getInstance() {
    Key_initEntries();
    return Key_F22_instance;
  }
  function Key_F23_getInstance() {
    Key_initEntries();
    return Key_F23_instance;
  }
  function Key_F24_getInstance() {
    Key_initEntries();
    return Key_F24_instance;
  }
  function Key_F25_getInstance() {
    Key_initEntries();
    return Key_F25_instance;
  }
  function Key_LEFT_SHIFT_getInstance() {
    Key_initEntries();
    return Key_LEFT_SHIFT_instance;
  }
  function Key_LEFT_CONTROL_getInstance() {
    Key_initEntries();
    return Key_LEFT_CONTROL_instance;
  }
  function Key_LEFT_ALT_getInstance() {
    Key_initEntries();
    return Key_LEFT_ALT_instance;
  }
  function Key_LEFT_SUPER_getInstance() {
    Key_initEntries();
    return Key_LEFT_SUPER_instance;
  }
  function Key_RIGHT_SHIFT_getInstance() {
    Key_initEntries();
    return Key_RIGHT_SHIFT_instance;
  }
  function Key_RIGHT_CONTROL_getInstance() {
    Key_initEntries();
    return Key_RIGHT_CONTROL_instance;
  }
  function Key_RIGHT_ALT_getInstance() {
    Key_initEntries();
    return Key_RIGHT_ALT_instance;
  }
  function Key_RIGHT_SUPER_getInstance() {
    Key_initEntries();
    return Key_RIGHT_SUPER_instance;
  }
  function Key_UNKNOWN_getInstance() {
    Key_initEntries();
    return Key_UNKNOWN_instance;
  }
  function GameStick_LEFT_getInstance() {
    GameStick_initEntries();
    return GameStick_LEFT_instance;
  }
  function GameStick_RIGHT_getInstance() {
    GameStick_initEntries();
    return GameStick_RIGHT_instance;
  }
  function _no_name_provided_$factory_243(this$0, $info) {
    var i = new _no_name_provided__288(this$0, $info);
    return function (p1) {
      return i.invoke_488(p1);
    };
  }
  var GLOBAL_CHECK_GL;
  var Cursor_DEFAULT_instance;
  var Cursor_CROSSHAIR_instance;
  var Cursor_TEXT_instance;
  var Cursor_HAND_instance;
  var Cursor_MOVE_instance;
  var Cursor_WAIT_instance;
  var Cursor_RESIZE_EAST_instance;
  var Cursor_RESIZE_WEST_instance;
  var Cursor_RESIZE_SOUTH_instance;
  var Cursor_RESIZE_NORTH_instance;
  var Cursor_RESIZE_NORTH_EAST_instance;
  var Cursor_RESIZE_NORTH_WEST_instance;
  var Cursor_RESIZE_SOUTH_EAST_instance;
  var Cursor_RESIZE_SOUTH_WEST_instance;
  function Companion_135() {
    Companion_instance_134 = this;
    this._ANGLE_TO_CURSOR = mapOf([to(new Angle(times_0(_get_degrees__0(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(times_0(_get_degrees__0(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(times_0(_get_degrees__0(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(times_0(_get_degrees__0(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(times_0(_get_degrees__0(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(times_0(_get_degrees__0(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(times_0(_get_degrees__0(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(times_0(_get_degrees__0(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
  Companion_135.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_134;
  function Companion_getInstance_134() {
    if (Companion_instance_134 == null)
      new Companion_135();
    return Companion_instance_134;
  }
  var Cursor_entriesInitialized;
  function Cursor_initEntries() {
    if (Cursor_entriesInitialized)
      return Unit_getInstance();
    Cursor_entriesInitialized = true;
    Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
    Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
    Cursor_TEXT_instance = new Cursor('TEXT', 2);
    Cursor_HAND_instance = new Cursor('HAND', 3);
    Cursor_MOVE_instance = new Cursor('MOVE', 4);
    Cursor_WAIT_instance = new Cursor('WAIT', 5);
    Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
    Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
    Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
    Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
    Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
    Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
    Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
    Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
    Companion_getInstance_134();
  }
  var Quality_PERFORMANCE_instance;
  var Quality_QUALITY_instance;
  var Quality_AUTOMATIC_instance;
  var Quality_entriesInitialized;
  function Quality_initEntries() {
    if (Quality_entriesInitialized)
      return Unit_getInstance();
    Quality_entriesInitialized = true;
    Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0);
    Quality_QUALITY_instance = new Quality('QUALITY', 1);
    Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2);
  }
  function Cursor(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  Cursor.$metadata$ = {
    simpleName: 'Cursor',
    kind: 'class',
    interfaces: []
  };
  function CoroutineKey() {
    CoroutineKey_instance = this;
  }
  CoroutineKey.$metadata$ = {
    simpleName: 'CoroutineKey',
    kind: 'object',
    interfaces: [Key_0]
  };
  var CoroutineKey_instance;
  function CoroutineKey_getInstance() {
    if (CoroutineKey_instance == null)
      new CoroutineKey();
    return CoroutineKey_instance;
  }
  function _get_fpsCached_($this) {
    return $this._fpsCached$delegate.getValue($this, fpsCached$factory());
  }
  function Quality(name, ordinal) {
    Enum.call(this, name, ordinal);
    this._UPPER_BOUND_RENDERED_PIXELS = 4000000;
  }
  Quality.prototype.computeTargetScale = function (width, height, devicePixelRatio, targetPixels) {
    var tmp0_subject = this;
    var tmp;
    if (tmp0_subject.equals(Quality_PERFORMANCE_getInstance())) {
      tmp = 1.0;
    } else if (tmp0_subject.equals(Quality_QUALITY_getInstance())) {
      tmp = devicePixelRatio;
    } else if (tmp0_subject.equals(Quality_AUTOMATIC_getInstance())) {
      var tmp$ret$0;
      l$ret$1: do {
        var tmp0_firstOrNull_0 = listOf([devicePixelRatio, 2.0, 1.0]);
        var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_67();
        while (tmp0_iterator_1.hasNext_33()) {
          var element_2 = tmp0_iterator_1.next_37();
          if (imul(width, height) * element_2 <= targetPixels) {
            tmp$ret$0 = element_2;
            break l$ret$1;
          } else {
          }
        }
        tmp$ret$0 = null;
      }
       while (false);
      var tmp1_elvis_lhs = tmp$ret$0;
      tmp = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
    } else {
      noWhenBranchMatchedException();
    }
    return tmp;
  };
  Quality.prototype.computeTargetScale$default = function (width, height, devicePixelRatio, targetPixels, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      targetPixels = this._UPPER_BOUND_RENDERED_PIXELS;
    return this.computeTargetScale(width, height, devicePixelRatio, targetPixels);
  };
  Quality.$metadata$ = {
    simpleName: 'Quality',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__289(this$0) {
    this._this$0_69 = this$0;
  }
  _no_name_provided__289.prototype.invoke_1005 = function () {
    return this._this$0_69.computeDisplayRefreshRate_1();
  };
  _no_name_provided__289.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__290($entry, this$0, resultContinuation) {
    this._$entry = $entry;
    this._this$0_70 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__290.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__290.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__290.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$entry(this._this$0_70, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__290.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__290(this._$entry, this._this$0_70, completion);
    return i;
  };
  _no_name_provided__290.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function Cursor_DEFAULT_getInstance() {
    Cursor_initEntries();
    return Cursor_DEFAULT_instance;
  }
  function Cursor_RESIZE_EAST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_EAST_instance;
  }
  function Cursor_RESIZE_WEST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_WEST_instance;
  }
  function Cursor_RESIZE_SOUTH_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_SOUTH_instance;
  }
  function Cursor_RESIZE_NORTH_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_NORTH_instance;
  }
  function Cursor_RESIZE_NORTH_EAST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_NORTH_EAST_instance;
  }
  function Cursor_RESIZE_NORTH_WEST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_NORTH_WEST_instance;
  }
  function Cursor_RESIZE_SOUTH_EAST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_SOUTH_EAST_instance;
  }
  function Cursor_RESIZE_SOUTH_WEST_getInstance() {
    Cursor_initEntries();
    return Cursor_RESIZE_SOUTH_WEST_instance;
  }
  function Quality_PERFORMANCE_getInstance() {
    Quality_initEntries();
    return Quality_PERFORMANCE_instance;
  }
  function Quality_QUALITY_getInstance() {
    Quality_initEntries();
    return Quality_QUALITY_instance;
  }
  function Quality_AUTOMATIC_getInstance() {
    Quality_initEntries();
    return Quality_AUTOMATIC_instance;
  }
  function $waitCloseCOROUTINE$0(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__137 = _this_;
  }
  $waitCloseCOROUTINE$0.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this.__this__137._running_0) {
              this._state_1 = 3;
              continue $sm;
            }
            this._state_1 = 2;
            var tmp_0 = this;
            tmp_0._tmp0__get_milliseconds__00 = 100;
            suspendResult = delay_1(this.__this__137, Companion_getInstance_27().fromMilliseconds(this._tmp0__get_milliseconds__00), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $waitCloseCOROUTINE$0.$metadata$ = {
    simpleName: '$waitCloseCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $loopCOROUTINE$1(_this_, entry, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__138 = _this_;
    this._entry_1 = entry;
  }
  $loopCOROUTINE$1.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            suspendResult = this.__this__138.getCoroutineDispatcherWithCurrentContext_4(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_23 = suspendResult;
            launchImmediately(this._ARGUMENT0_23, _no_name_provided_$factory_245(this._entry_1, this.__this__138, null));
            Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            if (!this.__this__138._running_0) {
              this._state_1 = 4;
              continue $sm;
            }
            this._start1 = PerformanceCounter_getInstance()._get_reference_();
            this.__this__138.frame_3();
            this._elapsed2 = TimeSpan__minus_impl(PerformanceCounter_getInstance()._get_reference_(), this._start1);
            this._available3 = TimeSpan__minus_impl(this.__this__138._get_counterTimePerFrame__1(), this._elapsed2);
            this._state_1 = 3;
            suspendResult = delay_1(this.__this__138, this._available3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loopCOROUTINE$1.$metadata$ = {
    simpleName: '$loopCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function GameWindow() {
    CoroutineKey_getInstance();
    Mixin_1.call(this);
    this._cursor_0 = Cursor_DEFAULT_getInstance();
    var tmp = this;
    tmp._ag = LogAG_init_$Create$(0, 0, 3, null);
    this._coroutineDispatcher = new GameWindowCoroutineDispatcher();
    this._pauseEvent = new PauseEvent();
    this._resumeEvent = new ResumeEvent();
    this._stopEvent = new StopEvent();
    this._destroyEvent = new DestroyEvent();
    this._renderEvent = new RenderEvent();
    this._initEvent = new InitEvent();
    this._disposeEvent = new DisposeEvent();
    var tmp_0 = this;
    tmp_0._fullScreenEvent = FullScreenEvent_init_$Create$(false, 1, null);
    var tmp_1 = this;
    tmp_1._reshapeEvent = ReshapeEvent_init_$Create$(0, 0, 0, 0, 15, null);
    var tmp_2 = this;
    var tmp_3 = new Char(0);
    tmp_2._keyEvent = KeyEvent_init_$Create$(null, 0, null, 0, tmp_3, false, false, false, false, 511, null);
    var tmp_4 = this;
    tmp_4._mouseEvent = MouseEvent_init_$Create$(null, 0, 0, 0, null, 0, 0.0, 0.0, 0.0, false, false, false, false, false, 16383, null);
    var tmp_5 = this;
    tmp_5._touchEvent = TouchEvent_init_$Create$(null, 0, null, false, 15, null);
    var tmp_6 = this;
    tmp_6._dropFileEvent = DropFileEvent_init_$Create$(null, null, 3, null);
    var tmp_7 = this;
    tmp_7._gamePadUpdateEvent = GamePadUpdateEvent_init_$Create$(0, null, 3, null);
    var tmp_8 = this;
    tmp_8._gamePadConnectionEvent = GamePadConnectionEvent_init_$Create$(null, 0, 3, null);
    var tmp_9 = this;
    var tmp0__get_milliseconds__0 = 1000;
    var tmp_10 = Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0);
    tmp_9._fpsCached$delegate = new IntTimedCache(tmp_10, _no_name_provided_$factory_244(this));
    this._width_13 = 0;
    this._height_13 = 0;
    this._vsync = true;
    this._icon = null;
    this._fullscreen_0 = false;
    this._visible = false;
    var tmp_11 = this;
    tmp_11._onDebugChanged = Signal_init_$Create$(null, 1, null);
    this._debugComponent = null;
    this._debug_1 = false;
    this._running_0 = true;
    this._closing = false;
    this._surfaceChanged = false;
    this._surfaceX = -1;
    this._surfaceY = -1;
    this._surfaceWidth = -1;
    this._surfaceHeight = -1;
    this._doInitialize = false;
    this._initialized_2 = false;
    this._contextLost = false;
    this._lastTime = PerformanceCounter_getInstance()._get_reference_();
    this._keysPresing = booleanArray(Companion_getInstance_132()._MAX_2);
    this._mouseButtons = 0;
    this._scrollDeltaX_0 = 0.0;
    this._scrollDeltaY_0 = 0.0;
    this._scrollDeltaZ_0 = 0.0;
    this._scaleCoords_1 = false;
  }
  GameWindow.prototype._get_key__37 = function () {
    return CoroutineKey_getInstance();
  };
  GameWindow.prototype._get_ag__1 = function () {
    return this._ag;
  };
  GameWindow.prototype._get_coroutineDispatcher__1 = function () {
    return this._coroutineDispatcher;
  };
  GameWindow.prototype.getCoroutineDispatcherWithCurrentContext_3 = function (coroutineContext) {
    return coroutineContext.plus_36(this._get_coroutineDispatcher__1());
  };
  GameWindow.prototype.getCoroutineDispatcherWithCurrentContext_4 = function ($cont) {
    return this.getCoroutineDispatcherWithCurrentContext_3($cont._get_context__296());
  };
  GameWindow.prototype._get_renderEvent__0 = function () {
    return this._renderEvent;
  };
  GameWindow.prototype._get_keyEvent__0 = function () {
    return this._keyEvent;
  };
  GameWindow.prototype._get_mouseEvent__0 = function () {
    return this._mouseEvent;
  };
  GameWindow.prototype._get_touchEvent__0 = function () {
    return this._touchEvent;
  };
  GameWindow.prototype._get_gamePadUpdateEvent__0 = function () {
    return this._gamePadUpdateEvent;
  };
  GameWindow.prototype._get_gamePadConnectionEvent__0 = function () {
    return this._gamePadConnectionEvent;
  };
  GameWindow.prototype.onRenderEvent_1 = function (block) {
    this.addEventListener_6(getKClass_0(RenderEvent), block);
    Unit_getInstance();
  };
  GameWindow.prototype._get_counterTimePerFrame__1 = function () {
    var tmp0__get_microseconds__0 = 1000000.0 / this._get_fps__1();
    return Companion_getInstance_27().fromMicroseconds(tmp0__get_microseconds__0);
  };
  GameWindow.prototype.computeDisplayRefreshRate_1 = function () {
    return 60;
  };
  GameWindow.prototype._get_fps__1 = function () {
    return _get_fpsCached_(this);
  };
  GameWindow.prototype._set_title__1 = function (value) {
    return Unit_getInstance();
  };
  GameWindow.prototype._get_width__58 = function () {
    return this._width_13;
  };
  GameWindow.prototype._get_height__58 = function () {
    return this._height_13;
  };
  GameWindow.prototype._set_icon__1 = function (_set___) {
    this._icon = _set___;
  };
  GameWindow.prototype._set_fullscreen__1 = function (_set___) {
    this._fullscreen_0 = _set___;
  };
  GameWindow.prototype._set_visible__4 = function (_set___) {
    this._visible = _set___;
  };
  GameWindow.prototype._set_quality__1 = function (value) {
    return Unit_getInstance();
  };
  GameWindow.prototype._set_debug__1 = function (value) {
    this._debug_1 = value;
    this._onDebugChanged.invoke_137(value);
  };
  GameWindow.prototype.setSize_7 = function (width, height) {
    return Unit_getInstance();
  };
  GameWindow.prototype.exit_1 = function () {
    return this.close_77();
  };
  GameWindow.prototype.close_77 = function () {
    if (this._closing)
      return Unit_getInstance();
    this._closing = true;
    this._running_0 = false;
    println('GameWindow.close');
    this._get_coroutineDispatcher__1().close_77();
    var tmp = this._get_coroutineDispatcher__1();
    cancelChildren$default(tmp, null, 1, null);
  };
  GameWindow.prototype.waitClose_1 = function ($cont) {
    var tmp = new $waitCloseCOROUTINE$0(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  GameWindow.prototype.loop_2 = function (entry, $cont) {
    var tmp = new $loopCOROUTINE$1(this, entry, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  GameWindow.prototype.frame_3 = function () {
    this.frame$default(true, null, 2, null);
  };
  GameWindow.prototype.frame_4 = function (doUpdate, startTime) {
    this.frameRender_1();
    if (doUpdate) {
      this.frameUpdate_1(startTime);
    }};
  GameWindow.prototype.frame$default = function (doUpdate, startTime, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startTime = PerformanceCounter_getInstance()._get_reference_();
    return this.frame_4(doUpdate, startTime);
  };
  GameWindow.prototype.frameRender_1 = function () {
    if (this._contextLost) {
      this._contextLost = false;
      this._get_ag__1().contextLost_4();
    }if (this._surfaceChanged) {
      this._surfaceChanged = false;
      var tmp = this._get_ag__1()._get_mainRenderBuffer__4();
      var tmp_0 = this._surfaceX;
      var tmp_1 = this._surfaceY;
      var tmp_2 = this._surfaceWidth;
      var tmp_3 = this._surfaceHeight;
      tmp.setSize$default_4(tmp_0, tmp_1, tmp_2, tmp_3, 0, 0, 48, null);
      this.dispatchReshapeEvent_1(this._surfaceX, this._surfaceY, this._surfaceWidth, this._surfaceHeight);
    }if (this._doInitialize) {
      this._doInitialize = false;
      println('' + '---------------- Trigger AG.initialized ag.mainRenderBuffer.setSize (' + this._get_width__58() + ', ' + this._get_height__58() + ') --------------');
      var tmp0_dispatch_0 = this._initEvent;
      this.dispatch_16(getKClass_0(InitEvent), tmp0_dispatch_0);
    }try {
      this.dispatchRenderEvent_1(false);
    } catch ($p) {
      if ($p instanceof Error) {
        println('ERROR GameWindow.frameRender:');
        println($p);
        printStackTrace($p);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  GameWindow.prototype.frameUpdate_1 = function (startTime) {
    try {
      var now = PerformanceCounter_getInstance()._get_reference_();
      var elapsed = TimeSpan__minus_impl(now, startTime);
      this._lastTime = now;
      var available = TimeSpan__minus_impl(this._get_counterTimePerFrame__1(), elapsed);
      this._get_coroutineDispatcher__1().executePending(available);
    } catch ($p) {
      if ($p instanceof Error) {
        println('ERROR GameWindow.frameRender:');
        println($p);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  GameWindow.prototype.dispatchRenderEvent_1 = function (update) {
    var tmp0_also_0 = this._renderEvent;
    tmp0_also_0._update = update;
    var tmp1_dispatch_0 = tmp0_also_0;
    return this.dispatch_16(getKClass_0(RenderEvent), tmp1_dispatch_0);
  };
  GameWindow.prototype.dispatchDropfileEvent_0 = function (type, files) {
    var tmp0_also_0 = this._dropFileEvent;
    tmp0_also_0._type_12 = type;
    tmp0_also_0._files_1 = files;
    var tmp1_dispatch_0 = tmp0_also_0;
    return this.dispatch_16(getKClass_0(DropFileEvent), tmp1_dispatch_0);
  };
  GameWindow.prototype.dispatchReshapeEvent_1 = function (x, y, width, height) {
    this.dispatchReshapeEventEx_1(x, y, width, height, width, height);
  };
  GameWindow.prototype.dispatchReshapeEventEx_1 = function (x, y, width, height, fullWidth, fullHeight) {
    this._get_ag__1().resized_4(x, y, width, height, fullWidth, fullHeight);
    var tmp0_apply_0 = this._reshapeEvent;
    tmp0_apply_0._x_13 = x;
    tmp0_apply_0._y_12 = y;
    tmp0_apply_0._width_12 = width;
    tmp0_apply_0._height_12 = height;
    var tmp1_dispatch_0 = tmp0_apply_0;
    this.dispatch_16(getKClass_0(ReshapeEvent), tmp1_dispatch_0);
  };
  GameWindow.$metadata$ = {
    simpleName: 'GameWindow',
    kind: 'class',
    interfaces: [DialogInterface, Closeable, Element_0, AGWindow]
  };
  function DialogInterface() {
  }
  DialogInterface.$metadata$ = {
    simpleName: 'DialogInterface',
    kind: 'interface',
    interfaces: []
  };
  function configure(_this_, width, height, title, icon, fullscreen) {
    _this_.setSize_7(width, height);
    if (!(title == null))
      _this_._set_title__1(title);
    _this_._set_icon__1(icon);
    if (!(fullscreen == null))
      _this_._set_fullscreen__1(fullscreen);
    _this_._set_visible__4(true);
  }
  function TimedTask(time, continuation, callback) {
    this._time_3 = time;
    this._continuation_4 = continuation;
    this._callback_2 = callback;
    this._exception_1 = null;
  }
  TimedTask.$metadata$ = {
    simpleName: 'TimedTask',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__291() {
  }
  _no_name_provided__291.prototype.invoke_493 = function (a, b) {
    return TimeSpan__compareTo_impl(a._time_3, b._time_3);
  };
  _no_name_provided__291.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof TimedTask ? p1 : THROW_CCE();
    return this.invoke_493(tmp, p2 instanceof TimedTask ? p2 : THROW_CCE());
  };
  _no_name_provided__291.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__292($task) {
    this._$task = $task;
  }
  _no_name_provided__292.prototype.invoke_725 = function (it) {
    this._$task._exception_1 = it;
  };
  _no_name_provided__292.prototype.invoke_1015 = function (p1) {
    this.invoke_725((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__292.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__293(this$0, $task) {
    this._this$0_71 = this$0;
    this._$task_0 = $task;
  }
  _no_name_provided__293.prototype.dispose_18 = function () {
    this._this$0_71._timedTasks.remove_39(this._$task_0);
    Unit_getInstance();
  };
  _no_name_provided__293.$metadata$ = {
    kind: 'class',
    interfaces: [DisposableHandle]
  };
  function GameWindowCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
    this._tasks = new TGenQueue();
    var tmp = this;
    var tmp_0 = Companion_getInstance_37();
    tmp._timedTasks = tmp_0.invoke$default(false, _no_name_provided_$factory_246(), 1, null);
  }
  GameWindowCoroutineDispatcher.prototype.dispatch_12 = function (context, block) {
    this._tasks.enqueue(block);
  };
  GameWindowCoroutineDispatcher.prototype.now_3 = function () {
    return PerformanceCounter_getInstance()._get_reference_();
  };
  GameWindowCoroutineDispatcher.prototype.scheduleResumeAfterDelay_5 = function (timeMillis, continuation) {
    var tmp0__get_milliseconds__0 = timeMillis.toDouble_6();
    this.scheduleResumeAfterDelay_6(Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0), continuation);
  };
  GameWindowCoroutineDispatcher.prototype.scheduleResumeAfterDelay_6 = function (time, continuation) {
    var task = new TimedTask(TimeSpan__plus_impl(this.now_3(), time), continuation, null);
    continuation.invokeOnCancellation_1(_no_name_provided_$factory_247(task));
    this._timedTasks.add_33(task);
    Unit_getInstance();
  };
  GameWindowCoroutineDispatcher.prototype.invokeOnTimeout_5 = function (timeMillis, block, context) {
    var tmp = this.now_3();
    var tmp0__get_milliseconds__0 = timeMillis.toDouble_6();
    var task = new TimedTask(TimeSpan__plus_impl(tmp, Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0)), null, block);
    this._timedTasks.add_33(task);
    Unit_getInstance();
    return new _no_name_provided__293(this, task);
  };
  GameWindowCoroutineDispatcher.prototype.executePending = function (availableTime) {
    try {
      var startTime = this.now_3();
      $l$break_0: while (true) {
        var tmp;
        var tmp0_isNotEmpty_0 = this._timedTasks;
        if (!tmp0_isNotEmpty_0.isEmpty_53()) {
          tmp = TimeSpan__compareTo_impl(startTime, this._timedTasks._get_head_()._time_3) >= 0;
        } else {
          {
            tmp = false;
          }
        }
        if (!tmp) {
          break $l$break_0;
        }var item = this._timedTasks.removeHead();
        if (!(item._exception_1 == null)) {
          var tmp0_safe_receiver = item._continuation_4;
          if (tmp0_safe_receiver == null)
            null;
          else {
            var tmp1_resumeWithException_0 = ensureNotNull(item._exception_1);
            var tmp0_failure_0_1 = Companion_getInstance_2();
            tmp0_safe_receiver.resumeWith_196(_Result___init__impl_(createFailure(tmp1_resumeWithException_0)));
            Unit_getInstance();
          }
          Unit_getInstance();
          if (!(item._callback_2 == null)) {
            var tmp1_safe_receiver = item._exception_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              printStackTrace(tmp1_safe_receiver);
              Unit_getInstance();
            }
            Unit_getInstance();
          }} else {
          var tmp2_safe_receiver = item._continuation_4;
          if (tmp2_safe_receiver == null)
            null;
          else {
            var tmp2_resume_0 = Unit_getInstance();
            var tmp0_success_0_1 = Companion_getInstance_2();
            tmp2_safe_receiver.resumeWith_196(_Result___init__impl_(Unit_getInstance()));
            Unit_getInstance();
          }
          Unit_getInstance();
          var tmp3_safe_receiver = item._callback_2;
          if (tmp3_safe_receiver == null)
            null;
          else {
            tmp3_safe_receiver.run_5();
            Unit_getInstance();
          }
          Unit_getInstance();
        }
        if (TimeSpan__compareTo_impl(TimeSpan__minus_impl(this.now_3(), startTime), availableTime) >= 0) {
          this.informTooMuchCallbacksToHandleInThisFrame();
          break $l$break_0;
        }}
      $l$break_2: while (true) {
        var tmp3_isNotEmpty_0 = this._tasks;
        if (!!tmp3_isNotEmpty_0.isEmpty_53()) {
          break $l$break_2;
        }var task = this._tasks.dequeue();
        var tmp4_safe_receiver = task;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.run_5();
          Unit_getInstance();
        }
        Unit_getInstance();
        if (TimeSpan__compareTo_impl(TimeSpan__minus_impl(this.now_3(), startTime), availableTime) >= 0) {
          this.informTooMuchCallbacksToHandleInThisFrame();
          break $l$break_2;
        }}
    } catch ($p) {
      if ($p instanceof Error) {
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace($p);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  GameWindowCoroutineDispatcher.prototype.informTooMuchCallbacksToHandleInThisFrame = function () {
  };
  GameWindowCoroutineDispatcher.prototype.close_77 = function () {
    var tmp0__get_seconds__0 = 1;
    this.executePending(Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0));
    println('GameWindowCoroutineDispatcher.close');
    $l$break: while (true) {
      var tmp1_isNotEmpty_0 = this._timedTasks;
      if (!!tmp1_isNotEmpty_0.isEmpty_53()) {
        break $l$break;
      }var tmp0_safe_receiver = this._timedTasks.removeHead()._continuation_4;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp2_resume_0 = Unit_getInstance();
        var tmp0_success_0_1 = Companion_getInstance_2();
        tmp0_safe_receiver.resumeWith_196(_Result___init__impl_(Unit_getInstance()));
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    $l$break_0: while (true) {
      var tmp3_isNotEmpty_0 = this._tasks;
      if (!!tmp3_isNotEmpty_0.isEmpty_53()) {
        break $l$break_0;
      }var tmp1_safe_receiver = this._tasks.dequeue();
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.run_5();
        Unit_getInstance();
      }
      Unit_getInstance();
    }
  };
  GameWindowCoroutineDispatcher.prototype.toString = function () {
    return 'GameWindowCoroutineDispatcher';
  };
  GameWindowCoroutineDispatcher.$metadata$ = {
    simpleName: 'GameWindowCoroutineDispatcher',
    kind: 'class',
    interfaces: [Delay, Closeable]
  };
  function fpsCached$factory() {
    return getPropertyCallableRef('fpsCached', 1, KProperty1, function (receiver) {
      return _get_fpsCached_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_244(this$0) {
    var i = new _no_name_provided__289(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_245($entry, this$0, resultContinuation) {
    var i = new _no_name_provided__290($entry, this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_246() {
    var i = new _no_name_provided__291();
    return function (p1, p2) {
      return i.invoke_493(p1, p2);
    };
  }
  function _no_name_provided_$factory_247($task) {
    var i = new _no_name_provided__292($task);
    return function (p1) {
      i.invoke_725(p1);
      return Unit_getInstance();
    };
  }
  function IntTimedCache(ttl, gen) {
    this._ttl = ttl;
    this._gen_3 = gen;
    this._last_4 = Companion_getInstance_18()._EPOCH;
    this._value_23 = 0;
  }
  IntTimedCache.prototype.getValue = function (obj, property) {
    var now_1 = Companion_getInstance_18().now_2();
    if (TimeSpan__compareTo_impl(DateTime__minus_impl_0(now_1, this._last_4), this._ttl) > 0) {
      this._last_4 = now_1;
      this._value_23 = this._gen_3();
    }return this._value_23;
  };
  IntTimedCache.$metadata$ = {
    simpleName: 'IntTimedCache',
    kind: 'class',
    interfaces: []
  };
  var korgwJvmEngine;
  function UiApplication() {
  }
  UiApplication.$metadata$ = {
    simpleName: 'UiApplication',
    kind: 'class',
    interfaces: [Extra]
  };
  var uiComponent$delegate;
  function UiComponent() {
  }
  UiComponent.$metadata$ = {
    simpleName: 'UiComponent',
    kind: 'class',
    interfaces: [Extra, LengthExtensions]
  };
  function _no_name_provided__294() {
  }
  _no_name_provided__294.prototype.invoke_497 = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__294.prototype.invoke_1015 = function (p1) {
    return this.invoke_497((!(p1 == null) ? isInterface(p1, NativeComponent) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__294.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_248() {
    var i = new _no_name_provided__294();
    return function (p1) {
      return i.invoke_497(p1);
    };
  }
  var layoutChildrenPadding$delegate;
  var DEFAULT_WIDTH;
  var DEFAULT_HEIGHT;
  var preferredSize$delegate;
  var minimumSize$delegate;
  var maximumSize$delegate;
  function _no_name_provided__295() {
  }
  _no_name_provided__295.prototype.invoke_1005 = function () {
    return 0;
  };
  _no_name_provided__295.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__296() {
  }
  _no_name_provided__296.prototype.invoke_506 = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__296.prototype.invoke_1015 = function (p1) {
    return this.invoke_506(p1 instanceof UiComponent ? p1 : THROW_CCE());
  };
  _no_name_provided__296.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__297() {
  }
  _no_name_provided__297.prototype.invoke_506 = function ($this$$receiver) {
    return new Size_0(null, null);
  };
  _no_name_provided__297.prototype.invoke_1015 = function (p1) {
    return this.invoke_506(p1 instanceof UiComponent ? p1 : THROW_CCE());
  };
  _no_name_provided__297.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__298() {
  }
  _no_name_provided__298.prototype.invoke_506 = function ($this$$receiver) {
    return new Size_0(null, null);
  };
  _no_name_provided__298.prototype.invoke_1015 = function (p1) {
    return this.invoke_506(p1 instanceof UiComponent ? p1 : THROW_CCE());
  };
  _no_name_provided__298.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_249() {
    var i = new _no_name_provided__295();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_250() {
    var i = new _no_name_provided__296();
    return function (p1) {
      return i.invoke_506(p1);
    };
  }
  function _no_name_provided_$factory_251() {
    var i = new _no_name_provided__297();
    return function (p1) {
      return i.invoke_506(p1);
    };
  }
  function _no_name_provided_$factory_252() {
    var i = new _no_name_provided__298();
    return function (p1) {
      return i.invoke_506(p1);
    };
  }
  function LengthExtensions() {
  }
  LengthExtensions.$metadata$ = {
    simpleName: 'LengthExtensions',
    kind: 'interface',
    interfaces: []
  };
  function Fixed() {
    Length.call(this);
  }
  Fixed.$metadata$ = {
    simpleName: 'Fixed',
    kind: 'class',
    interfaces: []
  };
  function PT(v) {
    Fixed.call(this);
    this._v_3 = v;
  }
  PT.prototype.toString = function () {
    return '' + this._v_3 + 'pt';
  };
  PT.prototype.hashCode = function () {
    return getNumberHashCode(this._v_3);
  };
  PT.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PT))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PT ? other : THROW_CCE();
    if (!equals_1(this._v_3, tmp0_other_with_cast._v_3))
      return false;
    return true;
  };
  PT.$metadata$ = {
    simpleName: 'PT',
    kind: 'class',
    interfaces: []
  };
  function Companion_136() {
    Companion_instance_135 = this;
    this._ZERO_4 = new PT(0.0);
  }
  Companion_136.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_135;
  function Companion_getInstance_135() {
    if (Companion_instance_135 == null)
      new Companion_136();
    return Companion_instance_135;
  }
  function Length() {
    Companion_getInstance_135();
  }
  Length.$metadata$ = {
    simpleName: 'Length',
    kind: 'class',
    interfaces: []
  };
  function Size_0(width, height) {
    this._width_14 = width;
    this._height_14 = height;
  }
  Size_0.prototype.toString = function () {
    return '' + 'Size(width=' + this._width_14 + ', height=' + this._height_14 + ')';
  };
  Size_0.prototype.hashCode = function () {
    var result = this._width_14 == null ? 0 : hashCode(this._width_14);
    result = imul(result, 31) + (this._height_14 == null ? 0 : hashCode(this._height_14)) | 0;
    return result;
  };
  Size_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Size_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Size_0 ? other : THROW_CCE();
    if (!equals_1(this._width_14, tmp0_other_with_cast._width_14))
      return false;
    if (!equals_1(this._height_14, tmp0_other_with_cast._height_14))
      return false;
    return true;
  };
  Size_0.$metadata$ = {
    simpleName: 'Size',
    kind: 'class',
    interfaces: []
  };
  function NativeComponent() {
  }
  NativeComponent.$metadata$ = {
    simpleName: 'NativeComponent',
    kind: 'interface',
    interfaces: [Extra]
  };
  function NativeUiFactory() {
  }
  NativeUiFactory.$metadata$ = {
    simpleName: 'NativeUiFactory',
    kind: 'interface',
    interfaces: []
  };
  function DummyUiFactory() {
    DummyUiFactory_instance = this;
  }
  DummyUiFactory.$metadata$ = {
    simpleName: 'DummyUiFactory',
    kind: 'object',
    interfaces: [NativeUiFactory]
  };
  var DummyUiFactory_instance;
  function DummyUiFactory_getInstance() {
    if (DummyUiFactory_instance == null)
      new DummyUiFactory();
    return DummyUiFactory_instance;
  }
  var reactUid$delegate;
  function _no_name_provided__299() {
  }
  _no_name_provided__299.prototype.invoke_506 = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__299.prototype.invoke_1015 = function (p1) {
    return this.invoke_506(p1 instanceof UiComponent ? p1 : THROW_CCE());
  };
  _no_name_provided__299.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_253() {
    var i = new _no_name_provided__299();
    return function (p1) {
      return i.invoke_506(p1);
    };
  }
  function alloc_0(_this_, $this) {
    if (_this_ === null)
      return 0;
    if (_this_.id === undefined) {
      if ($this._freeList.isEmpty_53()) {
        var tmp0_error_0_2 = 'KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)';
        throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_2));
      }var index_3 = $this._freeList.removeAt_6($this._freeList._get_size__60() - 1 | 0);
      $this._items_3[index_3] = _this_;
      _this_.id = index_3;
    } else {
    }
    var tmp1_unsafeCast_0_4 = _this_.id;
    return tmp1_unsafeCast_0_4;
  }
  function get_1(_this_, $this) {
    var tmp;
    if (!(_this_ === 0)) {
      var tmp0_unsafeCast_0 = $this._items_3[_this_];
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function free(_this_, $this) {
    var tmp;
    if (!(_this_ === 0)) {
      var tmp0_unsafeCast_0_3 = $this._items_3[_this_];
      var out_2 = tmp0_unsafeCast_0_3;
      var tmp0_this_4 = $this;
      var tmp1_plusAssign_0_5 = tmp0_this_4._freeList;
      tmp1_plusAssign_0_5.add_39(_this_);
      Unit_getInstance();
      $this._items_3[_this_] = null;
      tmp = out_2;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function sliceIfRequired(_this_, $this, count_0) {
    var tmp;
    if (_this_.length === count_0) {
      tmp = _this_;
    } else {
      {
        tmp = new Float32Array(_this_.buffer, 0, count_0);
      }
    }
    return tmp;
  }
  function KmlGlJsCanvas(canvas, glOpts) {
    KmlGl.call(this);
    this._canvas_0 = canvas;
    this._glOpts = glOpts;
    var tmp = this;
    var tmp0_elvis_lhs = function () {
      var $externalVarargReceiverTmp = this._canvas_0;
      return $externalVarargReceiverTmp.getContext.apply($externalVarargReceiverTmp, ['webgl'].concat([this._glOpts]));
    }.call(this);
    var tmp0_unsafeCast_0 = tmp0_elvis_lhs == null ? function () {
      var $externalVarargReceiverTmp = this._canvas_0;
      return $externalVarargReceiverTmp.getContext.apply($externalVarargReceiverTmp, ['experimental-webgl'].concat([this._glOpts]));
    }.call(this) : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = tmp0_unsafeCast_0;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      try {
        var tmp0_safe_receiver_2 = document.body;
        if (tmp0_safe_receiver_2 == null)
          null;
        else {
          var tmp_1 = document.createElement('div');
          var tmp0_apply_0_3 = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
          tmp0_apply_0_3.style.color = 'red';
          tmp0_apply_0_3.style.font = '30px Arial';
          tmp0_apply_0_3.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          (function () {
            var $externalVarargReceiverTmp = tmp0_safe_receiver_2;
            return $externalVarargReceiverTmp.prepend.apply($externalVarargReceiverTmp, [].concat([tmp0_apply_0_3]));
          }.call(this));
          Unit_getInstance();
        }
        Unit_getInstance();
      } catch ($p) {
        if ($p instanceof Error) {
          printStackTrace($p);
        } else {
          {
            throw $p;
          }
        }
      }
      var tmp1_error_0_5 = "Can't get webgl context";
      throw IllegalStateException_init_$Create$_0(toString_1(tmp1_error_0_5));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    tmp._gl_2 = tmp_0;
    var tmp_2 = this;
    var tmp0_arrayOfNulls_0 = 8192;
    tmp_2._items_3 = fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
    this._freeList = toMutableList_3(reversed_0(until(1, this._items_3.length)));
  }
  KmlGlJsCanvas.prototype.activeTexture_1 = function (texture) {
    return this._gl_2.activeTexture(texture);
  };
  KmlGlJsCanvas.prototype.attachShader_1 = function (program, shader) {
    return this._gl_2.attachShader(get_1(program, this), get_1(shader, this));
  };
  KmlGlJsCanvas.prototype.bindBuffer_1 = function (target, buffer) {
    return this._gl_2.bindBuffer(target, get_1(buffer, this));
  };
  KmlGlJsCanvas.prototype.bindFramebuffer_1 = function (target, framebuffer) {
    return this._gl_2.bindFramebuffer(target, get_1(framebuffer, this));
  };
  KmlGlJsCanvas.prototype.bindRenderbuffer_1 = function (target, renderbuffer) {
    return this._gl_2.bindRenderbuffer(target, get_1(renderbuffer, this));
  };
  KmlGlJsCanvas.prototype.bindTexture_1 = function (target, texture) {
    return this._gl_2.bindTexture(target, get_1(texture, this));
  };
  KmlGlJsCanvas.prototype.blendEquationSeparate_1 = function (modeRGB, modeAlpha) {
    return this._gl_2.blendEquationSeparate(modeRGB, modeAlpha);
  };
  KmlGlJsCanvas.prototype.blendFuncSeparate_1 = function (sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this._gl_2.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  };
  KmlGlJsCanvas.prototype.bufferData_1 = function (target, size_1, data, usage) {
    return this._gl_2.bufferData(target, new Uint8Array(_get_arrayBuffer_(data), 0, size_1), usage);
  };
  KmlGlJsCanvas.prototype.clear_27 = function (mask_0) {
    return this._gl_2.clear(mask_0);
  };
  KmlGlJsCanvas.prototype.clearColor_1 = function (red, green, blue, alpha) {
    return this._gl_2.clearColor(red, green, blue, alpha);
  };
  KmlGlJsCanvas.prototype.clearDepthf_0 = function (d) {
    return this._gl_2.clearDepth(d);
  };
  KmlGlJsCanvas.prototype.clearStencil_1 = function (s) {
    return this._gl_2.clearStencil(s);
  };
  KmlGlJsCanvas.prototype.colorMask_1 = function (red, green, blue, alpha) {
    return this._gl_2.colorMask(red, green, blue, alpha);
  };
  KmlGlJsCanvas.prototype.compileShader_1 = function (shader) {
    return this._gl_2.compileShader(get_1(shader, this));
  };
  KmlGlJsCanvas.prototype.createProgram_1 = function () {
    return alloc_0(this._gl_2.createProgram(), this);
  };
  KmlGlJsCanvas.prototype.createShader_1 = function (type) {
    return alloc_0(this._gl_2.createShader(type), this);
  };
  KmlGlJsCanvas.prototype.deleteBuffers_0 = function (n, items) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_4 = items._arrayInt;
        this._gl_2.deleteBuffer(free(tmp0_get_0_4[p_3], this));
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.deleteFramebuffers_0 = function (n, items) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_4 = items._arrayInt;
        this._gl_2.deleteFramebuffer(free(tmp0_get_0_4[p_3], this));
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.deleteProgram_1 = function (program) {
    return this._gl_2.deleteProgram(get_1(program, this));
  };
  KmlGlJsCanvas.prototype.deleteRenderbuffers_0 = function (n, items) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_4 = items._arrayInt;
        this._gl_2.deleteRenderbuffer(free(tmp0_get_0_4[p_3], this));
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.deleteShader_1 = function (shader) {
    return this._gl_2.deleteShader(get_1(shader, this));
  };
  KmlGlJsCanvas.prototype.deleteTextures_0 = function (n, items) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_get_0_4 = items._arrayInt;
        this._gl_2.deleteTexture(free(tmp0_get_0_4[p_3], this));
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.depthFunc_1 = function (func) {
    return this._gl_2.depthFunc(func);
  };
  KmlGlJsCanvas.prototype.depthMask_1 = function (flag) {
    return this._gl_2.depthMask(flag);
  };
  KmlGlJsCanvas.prototype.depthRangef_0 = function (n, f) {
    return this._gl_2.depthRange(n, f);
  };
  KmlGlJsCanvas.prototype.disable_2 = function (cap) {
    return this._gl_2.disable(cap);
  };
  KmlGlJsCanvas.prototype.disableVertexAttribArray_1 = function (index) {
    return this._gl_2.disableVertexAttribArray(index);
  };
  KmlGlJsCanvas.prototype.drawArrays_1 = function (mode, first_2, count_0) {
    return this._gl_2.drawArrays(mode, first_2, count_0);
  };
  KmlGlJsCanvas.prototype.drawElements_1 = function (mode, count_0, type, indices) {
    return this._gl_2.drawElements(mode, count_0, type, indices);
  };
  KmlGlJsCanvas.prototype.enable_2 = function (cap) {
    return this._gl_2.enable(cap);
  };
  KmlGlJsCanvas.prototype.enableVertexAttribArray_1 = function (index) {
    return this._gl_2.enableVertexAttribArray(index);
  };
  KmlGlJsCanvas.prototype.framebufferRenderbuffer_1 = function (target, attachment, renderbuffertarget, renderbuffer) {
    return this._gl_2.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_1(renderbuffer, this));
  };
  KmlGlJsCanvas.prototype.framebufferTexture2D_1 = function (target, attachment, textarget, texture, level) {
    return this._gl_2.framebufferTexture2D(target, attachment, textarget, get_1(texture, this), level);
  };
  KmlGlJsCanvas.prototype.frontFace_1 = function (mode) {
    return this._gl_2.frontFace(mode);
  };
  KmlGlJsCanvas.prototype.genBuffers_0 = function (n, buffers) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0_4 = buffers._arrayInt;
        var tmp1_set_0_5 = alloc_0(this._gl_2.createBuffer(), this);
        tmp0_set_0_4[p_3] = tmp1_set_0_5;
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.generateMipmap_1 = function (target) {
    return this._gl_2.generateMipmap(target);
  };
  KmlGlJsCanvas.prototype.genFramebuffers_0 = function (n, framebuffers) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0_4 = framebuffers._arrayInt;
        var tmp1_set_0_5 = alloc_0(this._gl_2.createFramebuffer(), this);
        tmp0_set_0_4[p_3] = tmp1_set_0_5;
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.genRenderbuffers_0 = function (n, renderbuffers) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0_4 = renderbuffers._arrayInt;
        var tmp1_set_0_5 = alloc_0(this._gl_2.createRenderbuffer(), this);
        tmp0_set_0_4[p_3] = tmp1_set_0_5;
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.genTextures_0 = function (n, textures) {
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < n) {
      do {
        var p_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_set_0_4 = textures._arrayInt;
        var tmp1_set_0_5 = alloc_0(this._gl_2.createTexture(), this);
        tmp0_set_0_4[p_3] = tmp1_set_0_5;
      }
       while (inductionVariable < n);
      tmp = Unit_getInstance();
    }return tmp;
  };
  KmlGlJsCanvas.prototype.getAttribLocation_2 = function (program, name) {
    return this._gl_2.getAttribLocation(get_1(program, this), name);
  };
  KmlGlJsCanvas.prototype.getUniformLocation_1 = function (program, name) {
    var tmp0_asDynamic_0_3 = get_1(program, this);
    var prg_2 = tmp0_asDynamic_0_3;
    if (prg_2.uniforms === undefined)
      prg_2.uniforms = {};
    if (prg_2.uniforms[name] === undefined)
      prg_2.uniforms[name] = alloc_0(this._gl_2.getUniformLocation(prg_2, name), this);
    var tmp1_unsafeCast_0_4 = prg_2.uniforms[name];
    return tmp1_unsafeCast_0_4;
  };
  KmlGlJsCanvas.prototype.getError_1 = function () {
    return this._gl_2.getError();
  };
  KmlGlJsCanvas.prototype.getIntegerv_0 = function (pname, data) {
    var tmp1_set_0_2 = data._arrayInt;
    var tmp2_set_0_3 = 0;
    var tmp0_unsafeCast_0_5 = this._gl_2.getParameter(pname);
    var tmp3_set_0_4 = tmp0_unsafeCast_0_5;
    return tmp1_set_0_2[tmp2_set_0_3] = tmp3_set_0_4;
  };
  KmlGlJsCanvas.prototype.getProgramiv_0 = function (program, pname, params) {
    var tmp0_subject_2 = pname;
    var tmp;
    if (tmp0_subject_2 === this._get_INFO_LOG_LENGTH__0()) {
      var tmp0_set_0_3 = params._arrayInt;
      var tmp1_set_0_4 = 0;
      var tmp1_safe_receiver_8 = this._gl_2.getProgramInfoLog(get_1(program, this));
      var tmp2_safe_receiver_7 = tmp1_safe_receiver_8 == null ? null : tmp1_safe_receiver_8.length;
      var tmp3_elvis_lhs_6 = tmp2_safe_receiver_7 == null ? null : tmp2_safe_receiver_7 + 1 | 0;
      var tmp2_set_0_5 = tmp3_elvis_lhs_6 == null ? 1 : tmp3_elvis_lhs_6;
      tmp = tmp0_set_0_3[tmp1_set_0_4] = tmp2_set_0_5;
    } else {
      var tmp4_set_0_9 = params._arrayInt;
      var tmp5_set_0_10 = 0;
      var tmp3_unsafeCast_0_12 = this._gl_2.getProgramParameter(get_1(program, this), pname);
      var tmp6_set_0_11 = tmp3_unsafeCast_0_12;
      tmp = tmp4_set_0_9[tmp5_set_0_10] = tmp6_set_0_11;
    }
    return tmp;
  };
  KmlGlJsCanvas.prototype.getShaderiv_0 = function (shader, pname, params) {
    var tmp0_subject_2 = pname;
    var tmp;
    if (tmp0_subject_2 === this._get_INFO_LOG_LENGTH__0()) {
      var tmp0_set_0_3 = params._arrayInt;
      var tmp1_set_0_4 = 0;
      var tmp1_safe_receiver_8 = this._gl_2.getShaderInfoLog(get_1(shader, this));
      var tmp2_safe_receiver_7 = tmp1_safe_receiver_8 == null ? null : tmp1_safe_receiver_8.length;
      var tmp3_elvis_lhs_6 = tmp2_safe_receiver_7 == null ? null : tmp2_safe_receiver_7 + 1 | 0;
      var tmp2_set_0_5 = tmp3_elvis_lhs_6 == null ? 1 : tmp3_elvis_lhs_6;
      tmp = tmp0_set_0_3[tmp1_set_0_4] = tmp2_set_0_5;
    } else {
      var tmp4_set_0_9 = params._arrayInt;
      var tmp5_set_0_10 = 0;
      var tmp3_unsafeCast_0_12 = this._gl_2.getShaderParameter(get_1(shader, this), pname);
      var tmp6_set_0_11 = tmp3_unsafeCast_0_12;
      tmp = tmp4_set_0_9[tmp5_set_0_10] = tmp6_set_0_11;
    }
    return tmp;
  };
  KmlGlJsCanvas.prototype.getShaderInfoLog_1 = function (shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs_3 = this._gl_2.getShaderInfoLog(get_1(shader, this));
    var str_2 = tmp0_elvis_lhs_3 == null ? '' : tmp0_elvis_lhs_3;
    var tmp0_set_0_4 = length._arrayInt;
    var tmp1_set_0_5 = 0;
    var tmp2_set_0_6 = str_2.length;
    tmp0_set_0_4[tmp1_set_0_5] = tmp2_set_0_6;
    putAsciiString(infoLog, str_2);
    return Unit_getInstance();
  };
  KmlGlJsCanvas.prototype.getString_1 = function (name) {
    var tmp0_unsafeCast_0 = this._gl_2.getParameter(name);
    return tmp0_unsafeCast_0;
  };
  KmlGlJsCanvas.prototype.lineWidth_1 = function (width) {
    return this._gl_2.lineWidth(width);
  };
  KmlGlJsCanvas.prototype.linkProgram_1 = function (program) {
    return this._gl_2.linkProgram(get_1(program, this));
  };
  KmlGlJsCanvas.prototype.pixelStorei_1 = function (pname, param) {
    return this._gl_2.pixelStorei(pname, param);
  };
  KmlGlJsCanvas.prototype.renderbufferStorage_1 = function (target, internalformat, width, height) {
    return this._gl_2.renderbufferStorage(target, internalformat, width, height);
  };
  KmlGlJsCanvas.prototype.scissor_1 = function (x, y, width, height) {
    return this._gl_2.scissor(x, y, width, height);
  };
  KmlGlJsCanvas.prototype.shaderSource_1 = function (shader, string) {
    return this._gl_2.shaderSource(get_1(shader, this), '' + '#ifdef GL_ES\nprecision mediump float;\n#endif\n' + string);
  };
  KmlGlJsCanvas.prototype.stencilFunc_1 = function (func, ref, mask_0) {
    return this._gl_2.stencilFunc(func, ref, mask_0);
  };
  KmlGlJsCanvas.prototype.stencilMask_1 = function (mask_0) {
    return this._gl_2.stencilMask(mask_0);
  };
  KmlGlJsCanvas.prototype.stencilOp_1 = function (fail, zfail, zpass) {
    return this._gl_2.stencilOp(fail, zfail, zpass);
  };
  KmlGlJsCanvas.prototype.texImage2D_2 = function (target, level, internalformat, width, height, border, format_0, type, pixels) {
    var tmp0_safe_receiver = pixels;
    return this._gl_2.texImage2D(target, level, internalformat, width, height, border, format_0, type, tmp0_safe_receiver == null ? null : _get_arrayUByte_(tmp0_safe_receiver));
  };
  KmlGlJsCanvas.prototype.texImage2D_3 = function (target, level, internalformat, format_0, type, data) {
    return this._gl_2.texImage2D(target, level, internalformat, format_0, type, (data instanceof HtmlNativeImage ? data : THROW_CCE())._texSource);
  };
  KmlGlJsCanvas.prototype.texParameteri_1 = function (target, pname, param) {
    return this._gl_2.texParameteri(target, pname, param);
  };
  KmlGlJsCanvas.prototype.uniform1f_1 = function (location, v0) {
    return this._gl_2.uniform1f(get_1(location, this), v0);
  };
  KmlGlJsCanvas.prototype.uniform1fv_1 = function (location, count_0, value) {
    return this._gl_2.uniform1fv(get_1(location, this), value._arrayFloat);
  };
  KmlGlJsCanvas.prototype.uniform1i_1 = function (location, v0) {
    return this._gl_2.uniform1i(get_1(location, this), v0);
  };
  KmlGlJsCanvas.prototype.uniform2f_1 = function (location, v0, v1) {
    return this._gl_2.uniform2f(get_1(location, this), v0, v1);
  };
  KmlGlJsCanvas.prototype.uniform2fv_1 = function (location, count_0, value) {
    return this._gl_2.uniform2fv(get_1(location, this), value._arrayFloat);
  };
  KmlGlJsCanvas.prototype.uniform3f_1 = function (location, v0, v1, v2) {
    return this._gl_2.uniform3f(get_1(location, this), v0, v1, v2);
  };
  KmlGlJsCanvas.prototype.uniform3fv_1 = function (location, count_0, value) {
    return this._gl_2.uniform3fv(get_1(location, this), value._arrayFloat);
  };
  KmlGlJsCanvas.prototype.uniform4f_1 = function (location, v0, v1, v2, v3) {
    return this._gl_2.uniform4f(get_1(location, this), v0, v1, v2, v3);
  };
  KmlGlJsCanvas.prototype.uniform4fv_1 = function (location, count_0, value) {
    return this._gl_2.uniform4fv(get_1(location, this), value._arrayFloat);
  };
  KmlGlJsCanvas.prototype.uniformMatrix2fv_1 = function (location, count_0, transpose, value) {
    return this._gl_2.uniformMatrix2fv(get_1(location, this), transpose, sliceIfRequired(value._arrayFloat, this, imul(imul(count_0, 2), 2)));
  };
  KmlGlJsCanvas.prototype.uniformMatrix3fv_1 = function (location, count_0, transpose, value) {
    return this._gl_2.uniformMatrix3fv(get_1(location, this), transpose, sliceIfRequired(value._arrayFloat, this, imul(imul(count_0, 3), 3)));
  };
  KmlGlJsCanvas.prototype.uniformMatrix4fv_1 = function (location, count_0, transpose, value) {
    return this._gl_2.uniformMatrix4fv(get_1(location, this), transpose, sliceIfRequired(value._arrayFloat, this, imul(imul(count_0, 4), 4)));
  };
  KmlGlJsCanvas.prototype.useProgram_1 = function (program) {
    return this._gl_2.useProgram(get_1(program, this));
  };
  KmlGlJsCanvas.prototype.vertexAttribPointer_1 = function (index, size_1, type, normalized, stride, pointer) {
    return this._gl_2.vertexAttribPointer(index, size_1, type, normalized, stride, pointer.toInt_8());
  };
  KmlGlJsCanvas.prototype.viewport_1 = function (x, y, width, height) {
    return this._gl_2.viewport(x, y, width, height);
  };
  KmlGlJsCanvas.$metadata$ = {
    simpleName: 'KmlGlJsCanvas',
    kind: 'class',
    interfaces: []
  };
  function _get_arrayBuffer_(_this_) {
    var tmp = _this_._mem;
    return tmp instanceof ArrayBuffer ? tmp : THROW_CCE();
  }
  function _get_arrayUByte_(_this_) {
    return new Uint8Array(_this_._mem);
  }
  function AGOpenglFactory() {
    AGOpenglFactory_instance = this;
  }
  AGOpenglFactory.prototype._get_isTouchDevice_ = function () {
    var tmp0_unsafeCast_0 = 'ontouchstart' in window || navigator.maxTouchPoints;
    return tmp0_unsafeCast_0;
  };
  AGOpenglFactory.$metadata$ = {
    simpleName: 'AGOpenglFactory',
    kind: 'object',
    interfaces: []
  };
  var AGOpenglFactory_instance;
  function AGOpenglFactory_getInstance() {
    if (AGOpenglFactory_instance == null)
      new AGOpenglFactory();
    return AGOpenglFactory_instance;
  }
  function AGWebgl_init_$Init$(config, glDecorator, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      glDecorator = _no_name_provided_$factory_254();
    }AGWebgl.call($this, config, glDecorator);
    return $this;
  }
  function AGWebgl_init_$Create$(config, glDecorator, $mask0, $marker) {
    return AGWebgl_init_$Init$(config, glDecorator, $mask0, $marker, Object.create(AGWebgl.prototype));
  }
  function Companion_137() {
    Companion_instance_136 = this;
    this._UNPACK_PREMULTIPLY_ALPHA_WEBGL = 37441;
  }
  Companion_137.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_136;
  function Companion_getInstance_136() {
    if (Companion_instance_136 == null)
      new Companion_137();
    return Companion_instance_136;
  }
  function _no_name_provided__300() {
  }
  _no_name_provided__300.prototype.invoke_508 = function (it) {
    return it;
  };
  _no_name_provided__300.prototype.invoke_1015 = function (p1) {
    return this.invoke_508(p1 instanceof KmlGl ? p1 : THROW_CCE());
  };
  _no_name_provided__300.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__301() {
  }
  _no_name_provided__301.prototype.invoke_564 = function (e) {
    e.preventDefault();
  };
  _no_name_provided__301.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__301.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__302(this$0) {
    this._this$0_72 = this$0;
  }
  _no_name_provided__302.prototype.invoke_564 = function (e) {
    var tmp0_this = this._this$0_72;
    var tmp1 = tmp0_this._get_contextVersion__1();
    tmp0_this._set_contextVersion__1(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  _no_name_provided__302.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__302.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AGWebgl(config, glDecorator) {
    Companion_getInstance_136();
    AGOpengl.call(this);
    this._config_3 = config;
    this._glDecorator = glDecorator;
    this._webgl_0 = true;
    this._ag_0 = this;
    var tmp = this;
    var tmp_0 = document.createElement('canvas');
    tmp._canvas_1 = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
    this._glOpts_0 = jsObject([to('premultipliedAlpha', true), to('alpha', false), to('stencil', true), to('antialias', this._config_3._antialiasHint)]);
    this._gl_3 = this._glDecorator(new KmlGlJsCanvas(this._canvas_1, this._glOpts_0));
    var tmp0_asDynamic_0 = window;
    tmp0_asDynamic_0.ag = this;
    this._nativeComponent_0 = this._canvas_1;
    this._devicePixelRatio_1 = 1.0;
    this._canvas_1.addEventListener('webglcontextlost', _no_name_provided_$factory_255(), false);
    this._canvas_1.addEventListener('webglcontextrestored', _no_name_provided_$factory_256(this), false);
  }
  AGWebgl.prototype._get_webgl__0 = function () {
    return this._webgl_0;
  };
  AGWebgl.prototype._get_gl__0 = function () {
    return this._gl_3;
  };
  AGWebgl.prototype._get_tDevicePixelRatio_ = function () {
    return window.devicePixelRatio;
  };
  AGWebgl.prototype._get_devicePixelRatio__4 = function () {
    return this._get_tDevicePixelRatio_() <= 0.0 ? 1.0 : isNaN_0(this._get_tDevicePixelRatio_()) ? 1.0 : isInfinite(this._get_tDevicePixelRatio_()) ? 1.0 : this._get_tDevicePixelRatio_();
  };
  AGWebgl.prototype.prepareUploadNativeTexture_0 = function (bmp) {
    var tmp0_toInt_0 = bmp._get_premultiplied__8();
    this._gl_3.pixelStorei_1(37441, tmp0_toInt_0 ? 1 : 0);
  };
  AGWebgl.$metadata$ = {
    simpleName: 'AGWebgl',
    kind: 'class',
    interfaces: [AGContainer]
  };
  function jsObject(pairs) {
    var out = jsEmptyObject();
    var indexedObject = pairs;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var tmp1_loop_parameter = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var k = tmp1_loop_parameter.component1_1();
      var v = tmp1_loop_parameter.component2_1();
      if (!(v == null))
        out[k] = v;
    }
    return out;
  }
  function jsEmptyObject() {
    return {};
  }
  function _no_name_provided_$factory_254() {
    var i = new _no_name_provided__300();
    return function (p1) {
      return i.invoke_508(p1);
    };
  }
  function _no_name_provided_$factory_255() {
    var i = new _no_name_provided__301();
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_256(this$0) {
    var i = new _no_name_provided__302(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  var knownControllers;
  function Nimbus_111_1420_Safari_GamepadMapping() {
    Nimbus_111_1420_Safari_GamepadMapping_instance = this;
    GamepadMapping.call(this);
    this._id_21 = '111-1420-Nimbus';
  }
  Nimbus_111_1420_Safari_GamepadMapping.prototype._get_id__2 = function () {
    return this._id_21;
  };
  Nimbus_111_1420_Safari_GamepadMapping.prototype.get_105 = function (button, info) {
    var tmp0_subject = button;
    return tmp0_subject.equals(GameButton_BUTTON0_getInstance()) ? this.getRawButton_2(info, 0) : tmp0_subject.equals(GameButton_BUTTON1_getInstance()) ? this.getRawButton_2(info, 1) : tmp0_subject.equals(GameButton_BUTTON2_getInstance()) ? this.getRawButton_2(info, 2) : tmp0_subject.equals(GameButton_BUTTON3_getInstance()) ? this.getRawButton_2(info, 3) : tmp0_subject.equals(GameButton_L1_getInstance()) ? this.getRawButton_2(info, 4) : tmp0_subject.equals(GameButton_R1_getInstance()) ? this.getRawButton_2(info, 5) : tmp0_subject.equals(GameButton_L2_getInstance()) ? this.getRawButton_2(info, 6) : tmp0_subject.equals(GameButton_R2_getInstance()) ? this.getRawButton_2(info, 7) : tmp0_subject.equals(GameButton_LEFT_getInstance()) ? this.getRawButton_2(info, 8) : tmp0_subject.equals(GameButton_DOWN_getInstance()) ? this.getRawButton_2(info, 9) : tmp0_subject.equals(GameButton_RIGHT_getInstance()) ? this.getRawButton_2(info, 10) : tmp0_subject.equals(GameButton_UP_getInstance()) ? this.getRawButton_2(info, 11) : tmp0_subject.equals(GameButton_SELECT_getInstance()) ? 0.0 : tmp0_subject.equals(GameButton_START_getInstance()) ? 0.0 : tmp0_subject.equals(GameButton_SYSTEM_getInstance()) ? 0.0 : tmp0_subject.equals(GameButton_LX_getInstance()) ? this.getRawAxe_2(info, 0) : tmp0_subject.equals(GameButton_LY_getInstance()) ? this.getRawAxe_2(info, 1) : tmp0_subject.equals(GameButton_RX_getInstance()) ? this.getRawAxe_2(info, 2) : tmp0_subject.equals(GameButton_RY_getInstance()) ? this.getRawAxe_2(info, 3) : 0.0;
  };
  Nimbus_111_1420_Safari_GamepadMapping.$metadata$ = {
    simpleName: 'Nimbus_111_1420_Safari_GamepadMapping',
    kind: 'object',
    interfaces: []
  };
  var Nimbus_111_1420_Safari_GamepadMapping_instance;
  function Nimbus_111_1420_Safari_GamepadMapping_getInstance() {
    if (Nimbus_111_1420_Safari_GamepadMapping_instance == null)
      new Nimbus_111_1420_Safari_GamepadMapping();
    return Nimbus_111_1420_Safari_GamepadMapping_instance;
  }
  function CreateDefaultGameWindow() {
    return OS_getInstance()._get_isJsNodeJs_() ? new NodeJsGameWindow() : new BrowserGameWindow();
  }
  function NodeJsGameWindow() {
    GameWindow.call(this);
  }
  NodeJsGameWindow.$metadata$ = {
    simpleName: 'NodeJsGameWindow',
    kind: 'class',
    interfaces: []
  };
  function updateGamepad($this) {
    try {
      if (navigator.getGamepads != null) {
        var tmp0_unsafeCast_0 = navigator.getGamepads();
        var gamepads = tmp0_unsafeCast_0;
        var indexedObject = $this._get_gamePadUpdateEvent__0()._gamepads;
        var inductionVariable = 0;
        var last_1 = indexedObject.length;
        while (inductionVariable < last_1) {
          var gp = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          gp._connected = false;
        }
        $this._get_gamePadUpdateEvent__0()._gamepadsLength = gamepads.length;
        var inductionVariable_0 = 0;
        var last_2 = gamepads.length;
        if (inductionVariable_0 < last_2)
          do {
            var gamepadId = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp2_elvis_lhs == null) {
              continue;
            } else {
              tmp = tmp2_elvis_lhs;
            }
            var controller = tmp;
            var tmp3_elvis_lhs = getOrNull($this._get_gamePadUpdateEvent__0()._gamepads, gamepadId);
            var tmp_0;
            if (tmp3_elvis_lhs == null) {
              continue;
            } else {
              tmp_0 = tmp3_elvis_lhs;
            }
            var gamepad = tmp_0;
            var tmp4_elvis_lhs = knownControllers.get_116(controller.id);
            var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? knownControllers.get_116(controller.mapping) : tmp4_elvis_lhs;
            var mapping = tmp5_elvis_lhs == null ? Companion_getInstance_129() : tmp5_elvis_lhs;
            gamepad._connected = controller.connected;
            gamepad._index_16 = controller.index;
            gamepad._name_24 = controller.id;
            gamepad._mapping = mapping;
            gamepad._axesLength = controller.axes.length;
            gamepad._buttonsLength = controller.buttons.length;
            gamepad._rawButtonsPressed = 0;
            var inductionVariable_1 = 0;
            var last_3 = controller.buttons.length;
            if (inductionVariable_1 < last_3)
              do {
                var n_3 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var tmp0_get_0_5 = controller.buttons;
                var button_4 = tmp0_get_0_5[n_3];
                if (button_4.pressed)
                  gamepad._rawButtonsPressed = gamepad._rawButtonsPressed | 1 << n_3;
                gamepad._rawButtonsPressure[n_3] = button_4.value;
              }
               while (inductionVariable_1 < last_3);
            var inductionVariable_2 = 0;
            var last_4 = controller.axes.length;
            if (inductionVariable_2 < last_4)
              do {
                var n_7 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var tmp1_get_0_8 = controller.axes;
                gamepad._rawAxes[n_7] = tmp1_get_0_8[n_7];
              }
               while (inductionVariable_2 < last_4);
            Unit_getInstance();
          }
           while (inductionVariable_0 < last_2);
        var tmp1_dispatch_0 = $this._get_gamePadUpdateEvent__0();
        $this.dispatch_16(getKClass_0(GamePadUpdateEvent), tmp1_dispatch_0);
      }} catch ($p) {
      (function () {
        var $externalVarargReceiverTmp = console;
        return $externalVarargReceiverTmp.error.apply($externalVarargReceiverTmp, [].concat([$p]));
      }.call(this));
    }
  }
  function onResized($this) {
    $this._isTouchDeviceCache = null;
    var tmp = $this._quality_1;
    var tmp_0 = window.innerWidth;
    var tmp_1 = window.innerHeight;
    var tmp_2 = $this._ag_1._get_devicePixelRatio__4();
    var scale_1 = tmp.computeTargetScale$default(tmp_0, tmp_1, tmp_2, 0, 8, null);
    $this._canvasRatio = scale_1;
    $this._get_canvas_().width = numberToInt(window.innerWidth * scale_1);
    $this._get_canvas_().height = numberToInt(window.innerHeight * scale_1);
    $this._get_canvas_().style.position = 'absolute';
    $this._get_canvas_().style.left = '0';
    $this._get_canvas_().style.right = '0';
    $this._get_canvas_().style.width = '' + window.innerWidth + 'px';
    $this._get_canvas_().style.height = '' + window.innerHeight + 'px';
    var tmp_3 = $this._get_canvas_();
    tmp_3.ondragenter = _no_name_provided_$factory_275($this);
    var tmp_4 = $this._get_canvas_();
    tmp_4.ondragexit = _no_name_provided_$factory_276($this);
    var tmp_5 = $this._get_canvas_();
    tmp_5.ondragleave = _no_name_provided_$factory_277($this);
    var tmp_6 = $this._get_canvas_();
    tmp_6.ondragover = _no_name_provided_$factory_278();
    var tmp_7 = $this._get_canvas_();
    tmp_7.ondragstart = _no_name_provided_$factory_279($this);
    var tmp_8 = $this._get_canvas_();
    tmp_8.ondragend = _no_name_provided_$factory_280($this);
    var tmp_9 = $this._get_canvas_();
    tmp_9.ondrop = _no_name_provided_$factory_281($this);
    $this.dispatchReshapeEvent_1(0, 0, $this._get_canvas_().width, $this._get_canvas_().height);
  }
  function doRender($this) {
    var tmp0_dispatch_0 = $this._get_renderEvent__0();
    $this.dispatch_16(getKClass_0(RenderEvent), tmp0_dispatch_0);
  }
  function keyEvent($this, me) {
    var tmp0_invoke_0 = $this._get_keyEvent__0();
    var tmp = tmp0_invoke_0;
    var tmp0_subject_2 = me.type;
    var tmp_0;
    switch (tmp0_subject_2) {
      case 'keydown':
        tmp_0 = Type_DOWN_getInstance_0();
        break;
      case 'keyup':
        tmp_0 = Type_UP_getInstance_0();
        break;
      case 'keypress':
        tmp_0 = Type_TYPE_getInstance();
        break;
      default:var tmp0_error_0_3 = '' + 'Unsupported event type ' + me.type;
        throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0_3));
    }
    tmp._type_8 = tmp_0;
    tmp0_invoke_0._id_16 = 0;
    tmp0_invoke_0._keyCode = me.keyCode;
    var tmp_1 = tmp0_invoke_0;
    var tmp1_subject_4 = me.key;
    var tmp_2;
    switch (tmp1_subject_4) {
      case '0':
        tmp_2 = Key_N0_getInstance();
        break;
      case '1':
        tmp_2 = Key_N1_getInstance();
        break;
      case '2':
        tmp_2 = Key_N2_getInstance();
        break;
      case '3':
        tmp_2 = Key_N3_getInstance();
        break;
      case '4':
        tmp_2 = Key_N4_getInstance();
        break;
      case '5':
        tmp_2 = Key_N5_getInstance();
        break;
      case '6':
        tmp_2 = Key_N6_getInstance();
        break;
      case '7':
        tmp_2 = Key_N7_getInstance();
        break;
      case '8':
        tmp_2 = Key_N8_getInstance();
        break;
      case '9':
        tmp_2 = Key_N9_getInstance();
        break;
      case 'a':
        tmp_2 = Key_A_getInstance();
        break;
      case 'b':
        tmp_2 = Key_B_getInstance();
        break;
      case 'c':
        tmp_2 = Key_C_getInstance();
        break;
      case 'd':
        tmp_2 = Key_D_getInstance();
        break;
      case 'e':
        tmp_2 = Key_E_getInstance();
        break;
      case 'f':
        tmp_2 = Key_F_getInstance();
        break;
      case 'g':
        tmp_2 = Key_G_getInstance();
        break;
      case 'h':
        tmp_2 = Key_H_getInstance();
        break;
      case 'i':
        tmp_2 = Key_I_getInstance();
        break;
      case 'j':
        tmp_2 = Key_J_getInstance();
        break;
      case 'k':
        tmp_2 = Key_K_getInstance();
        break;
      case 'l':
        tmp_2 = Key_L_getInstance();
        break;
      case 'm':
        tmp_2 = Key_M_getInstance();
        break;
      case 'n':
        tmp_2 = Key_N_getInstance();
        break;
      case 'o':
        tmp_2 = Key_O_getInstance();
        break;
      case 'p':
        tmp_2 = Key_P_getInstance();
        break;
      case 'q':
        tmp_2 = Key_Q_getInstance();
        break;
      case 'r':
        tmp_2 = Key_R_getInstance();
        break;
      case 's':
        tmp_2 = Key_S_getInstance();
        break;
      case 't':
        tmp_2 = Key_T_getInstance();
        break;
      case 'u':
        tmp_2 = Key_U_getInstance();
        break;
      case 'v':
        tmp_2 = Key_V_getInstance();
        break;
      case 'w':
        tmp_2 = Key_W_getInstance();
        break;
      case 'x':
        tmp_2 = Key_X_getInstance();
        break;
      case 'y':
        tmp_2 = Key_Y_getInstance();
        break;
      case 'z':
        tmp_2 = Key_Z_getInstance();
        break;
      case 'F1':
        tmp_2 = Key_F1_getInstance();
        break;
      case 'F2':
        tmp_2 = Key_F2_getInstance();
        break;
      case 'F3':
        tmp_2 = Key_F3_getInstance();
        break;
      case 'F4':
        tmp_2 = Key_F4_getInstance();
        break;
      case 'F5':
        tmp_2 = Key_F5_getInstance();
        break;
      case 'F6':
        tmp_2 = Key_F6_getInstance();
        break;
      case 'F7':
        tmp_2 = Key_F7_getInstance();
        break;
      case 'F8':
        tmp_2 = Key_F8_getInstance();
        break;
      case 'F9':
        tmp_2 = Key_F9_getInstance();
        break;
      case 'F10':
        tmp_2 = Key_F10_getInstance();
        break;
      case 'F11':
        tmp_2 = Key_F11_getInstance();
        break;
      case 'F12':
        tmp_2 = Key_F12_getInstance();
        break;
      case 'F13':
        tmp_2 = Key_F13_getInstance();
        break;
      case 'F14':
        tmp_2 = Key_F14_getInstance();
        break;
      case 'F15':
        tmp_2 = Key_F15_getInstance();
        break;
      case 'F16':
        tmp_2 = Key_F16_getInstance();
        break;
      case 'F17':
        tmp_2 = Key_F17_getInstance();
        break;
      case 'F18':
        tmp_2 = Key_F18_getInstance();
        break;
      case 'F19':
        tmp_2 = Key_F19_getInstance();
        break;
      case 'F20':
        tmp_2 = Key_F20_getInstance();
        break;
      case 'F21':
        tmp_2 = Key_F21_getInstance();
        break;
      case 'F22':
        tmp_2 = Key_F22_getInstance();
        break;
      case 'F23':
        tmp_2 = Key_F23_getInstance();
        break;
      case 'F24':
        tmp_2 = Key_F24_getInstance();
        break;
      case 'F25':
        tmp_2 = Key_F25_getInstance();
        break;
      case '+':
        tmp_2 = Key_PLUS_getInstance();
        break;
      case '-':
        tmp_2 = Key_MINUS_getInstance();
        break;
      default:var tmp2_subject_5 = me.code;
        switch (tmp2_subject_5) {
          case 'MetaLeft':
            tmp_2 = Key_LEFT_SUPER_getInstance();
            break;
          case 'MetaRight':
            tmp_2 = Key_RIGHT_SUPER_getInstance();
            break;
          case 'ShiftLeft':
            tmp_2 = Key_LEFT_SHIFT_getInstance();
            break;
          case 'ShiftRight':
            tmp_2 = Key_RIGHT_SHIFT_getInstance();
            break;
          case 'ControlLeft':
            tmp_2 = Key_LEFT_CONTROL_getInstance();
            break;
          case 'ControlRight':
            tmp_2 = Key_RIGHT_CONTROL_getInstance();
            break;
          case 'AltLeft':
            tmp_2 = Key_LEFT_ALT_getInstance();
            break;
          case 'AltRight':
            tmp_2 = Key_RIGHT_ALT_getInstance();
            break;
          case 'Space':
            tmp_2 = Key_SPACE_getInstance();
            break;
          case 'ArrowUp':
            tmp_2 = Key_UP_getInstance();
            break;
          case 'ArrowDown':
            tmp_2 = Key_DOWN_getInstance();
            break;
          case 'ArrowLeft':
            tmp_2 = Key_LEFT_getInstance();
            break;
          case 'ArrowRight':
            tmp_2 = Key_RIGHT_getInstance();
            break;
          case 'Enter':
            tmp_2 = Key_ENTER_getInstance();
            break;
          case 'Escape':
            tmp_2 = Key_ESCAPE_getInstance();
            break;
          case 'Backspace':
            tmp_2 = Key_BACKSPACE_getInstance();
            break;
          case 'Period':
            tmp_2 = Key_PERIOD_getInstance();
            break;
          case 'Comma':
            tmp_2 = Key_COMMA_getInstance();
            break;
          case 'Semicolon':
            tmp_2 = Key_SEMICOLON_getInstance();
            break;
          case 'Slash':
            tmp_2 = Key_SLASH_getInstance();
            break;
          case 'Tab':
            tmp_2 = Key_TAB_getInstance();
            break;
          default:tmp_2 = Key_UNKNOWN_getInstance();
            break;
        }

        break;
    }
    tmp_1._key_3 = tmp_2;
    tmp0_invoke_0._character = numberToChar(me.charCode);
    var tmp1_dispatch_0 = tmp0_invoke_0;
    $this.dispatch_16(getKClass_0(KeyEvent), tmp1_dispatch_0);
  }
  function touchEvent($this, e, type) {
    $this._get_touchEvent__0()._scaleCoords_0 = false;
    $this._get_touchEvent__0().startFrame_4(type);
    var inductionVariable = 0;
    var last_1 = e.touches.length;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_elvis_lhs = e.touches.item(n);
        var tmp;
        if (tmp1_elvis_lhs == null) {
          continue;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var touch = tmp;
        var tmp_0 = $this._get_touchEvent__0();
        var tmp_1 = touch.identifier;
        var tmp0_transformEventX_0 = touch.clientX;
        var tmp_2 = tmp0_transformEventX_0 * $this._canvasRatio;
        var tmp1_transformEventY_0 = touch.clientY;
        var tmp_3 = tmp1_transformEventY_0 * $this._canvasRatio;
        tmp_0.touch$default(tmp_1, tmp_2, tmp_3, null, 8, null);
      }
       while (inductionVariable < last_1);
    var tmp2_dispatch_0 = $this._get_touchEvent__0();
    $this.dispatch_16(getKClass_0(TouchEvent_0), tmp2_dispatch_0);
  }
  function mouseEvent($this, e, type, pressingType) {
    if (!$this.is_touch_device()) {
      var tmp0_transformEventX_0 = e.clientX;
      var tx = numberToInt(tmp0_transformEventX_0 * $this._canvasRatio);
      var tmp1_transformEventY_0 = e.clientY;
      var ty = numberToInt(tmp1_transformEventY_0 * $this._canvasRatio);
      var tmp2_invoke_0 = $this._get_mouseEvent__0();
      tmp2_invoke_0._type_7 = !(e.buttons === 0) ? pressingType : type;
      tmp2_invoke_0._scaleCoords = false;
      tmp2_invoke_0._id_15 = 0;
      tmp2_invoke_0._x_12 = tx;
      tmp2_invoke_0._y_11 = ty;
      tmp2_invoke_0._button = Companion_getInstance_131().get_137(e.button);
      tmp2_invoke_0._buttons = e.buttons;
      tmp2_invoke_0._isShiftDown = e.shiftKey;
      tmp2_invoke_0._isCtrlDown = e.ctrlKey;
      tmp2_invoke_0._isAltDown = e.altKey;
      tmp2_invoke_0._isMetaDown = e.metaKey;
      var tmp3_dispatch_0 = tmp2_invoke_0;
      $this.dispatch_16(getKClass_0(MouseEvent_0), tmp3_dispatch_0);
    }}
  function mouseEvent$default($this, e, type, pressingType, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      pressingType = type;
    return mouseEvent($this, e, type, pressingType);
  }
  function _get_jsFrame_($this) {
    var tmp = $this._jsFrame;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('jsFrame');
    }
  }
  function _no_name_provided__303(this$0) {
    this._this$0_73 = this$0;
  }
  _no_name_provided__303.prototype.invoke_526 = function (it) {
    this._this$0_73.dispatchDropfileEvent_0(Type_START_getInstance_0(), null);
  };
  _no_name_provided__303.prototype.invoke_1015 = function (p1) {
    this.invoke_526(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__303.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__304(this$0) {
    this._this$0_74 = this$0;
  }
  _no_name_provided__304.prototype.invoke_526 = function (it) {
    this._this$0_74.dispatchDropfileEvent_0(Type_END_getInstance_0(), null);
  };
  _no_name_provided__304.prototype.invoke_1015 = function (p1) {
    this.invoke_526(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__304.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__305(this$0) {
    this._this$0_75 = this$0;
  }
  _no_name_provided__305.prototype.invoke_526 = function (it) {
    this._this$0_75.dispatchDropfileEvent_0(Type_END_getInstance_0(), null);
  };
  _no_name_provided__305.prototype.invoke_1015 = function (p1) {
    this.invoke_526(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__305.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__306() {
  }
  _no_name_provided__306.prototype.invoke_526 = function (it) {
    it.preventDefault();
  };
  _no_name_provided__306.prototype.invoke_1015 = function (p1) {
    this.invoke_526(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__306.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__307(this$0) {
    this._this$0_76 = this$0;
  }
  _no_name_provided__307.prototype.invoke_526 = function (it) {
    this._this$0_76.dispatchDropfileEvent_0(Type_START_getInstance_0(), null);
  };
  _no_name_provided__307.prototype.invoke_1015 = function (p1) {
    this.invoke_526(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__307.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__308(this$0) {
    this._this$0_77 = this$0;
  }
  _no_name_provided__308.prototype.invoke_526 = function (it) {
    this._this$0_77.dispatchDropfileEvent_0(Type_END_getInstance_0(), null);
  };
  _no_name_provided__308.prototype.invoke_1015 = function (p1) {
    this.invoke_526(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__308.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__309(this$0) {
    this._this$0_78 = this$0;
  }
  _no_name_provided__309.prototype.invoke_526 = function (it) {
    it.preventDefault();
    this._this$0_78.dispatchDropfileEvent_0(Type_END_getInstance_0(), null);
    var items = ensureNotNull(it.dataTransfer).items;
    var tmp0_map_0 = until(0, items.length);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var inductionVariable = tmp0_map_0._get_first__6();
    var last_1 = tmp0_map_0._get_last__6();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver_6 = items[item_2_3];
        var tmp1_safe_receiver_5 = tmp0_safe_receiver_6 == null ? null : tmp0_safe_receiver_6.getAsFile();
        tmp0_mapTo_0_1.add_39(tmp1_safe_receiver_5 == null ? null : toVfs(tmp1_safe_receiver_5));
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    var files = filterNotNull(tmp0_mapTo_0_1);
    this._this$0_78.dispatchDropfileEvent_0(Type_DROP_getInstance(), files);
  };
  _no_name_provided__309.prototype.invoke_1015 = function (p1) {
    this.invoke_526(p1 instanceof DragEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__309.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__310(this$0, resultContinuation) {
    this._this$0_79 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__310.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__310.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__310.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._tmp0_safe_receiver0_1 = this._this$0_79._loopJob;
            if (this._tmp0_safe_receiver0_1 == null) {
              this._WHEN_RESULT1_8 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = cancelAndJoin(this._tmp0_safe_receiver0_1, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            var tmp_0 = this;
            suspendResult;
            tmp_0._WHEN_RESULT1_8 = Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            Unit_getInstance();
            window.close();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__310.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__310(this._this$0_79, completion);
    return i;
  };
  _no_name_provided__310.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__311($entry, this$0, resultContinuation) {
    this._$entry_0 = $entry;
    this._this$0_80 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__311.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__311.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__311.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$entry_0(this._this$0_80, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__311.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__311(this._$entry_0, this._this$0_80, completion);
    return i;
  };
  _no_name_provided__311.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__312(this$0) {
    this._this$0_81 = this$0;
  }
  _no_name_provided__312.prototype.invoke_564 = function (it) {
    var tmp = it;
    var tmp_0 = Type_ENTER_getInstance();
    mouseEvent$default(this._this$0_81, tmp, tmp_0, null, 8, null);
  };
  _no_name_provided__312.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__312.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__313(this$0) {
    this._this$0_82 = this$0;
  }
  _no_name_provided__313.prototype.invoke_564 = function (it) {
    var tmp = it;
    var tmp_0 = Type_EXIT_getInstance();
    mouseEvent$default(this._this$0_82, tmp, tmp_0, null, 8, null);
  };
  _no_name_provided__313.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__313.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__314(this$0) {
    this._this$0_83 = this$0;
  }
  _no_name_provided__314.prototype.invoke_564 = function (it) {
    mouseEvent(this._this$0_83, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
  };
  _no_name_provided__314.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__314.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__315(this$0) {
    this._this$0_84 = this$0;
  }
  _no_name_provided__315.prototype.invoke_564 = function (it) {
    mouseEvent(this._this$0_84, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
  };
  _no_name_provided__315.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__315.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__316(this$0) {
    this._this$0_85 = this$0;
  }
  _no_name_provided__316.prototype.invoke_564 = function (it) {
    var tmp = it;
    var tmp_0 = Type_EXIT_getInstance();
    mouseEvent$default(this._this$0_85, tmp, tmp_0, null, 8, null);
  };
  _no_name_provided__316.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__316.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__317(this$0) {
    this._this$0_86 = this$0;
  }
  _no_name_provided__317.prototype.invoke_564 = function (it) {
    var tmp = it;
    var tmp_0 = Type_UP_getInstance();
    mouseEvent$default(this._this$0_86, tmp, tmp_0, null, 8, null);
  };
  _no_name_provided__317.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__317.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__318(this$0) {
    this._this$0_87 = this$0;
  }
  _no_name_provided__318.prototype.invoke_564 = function (it) {
    var tmp = it;
    var tmp_0 = Type_DOWN_getInstance();
    mouseEvent$default(this._this$0_87, tmp, tmp_0, null, 8, null);
  };
  _no_name_provided__318.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__318.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__319(this$0) {
    this._this$0_88 = this$0;
  }
  _no_name_provided__319.prototype.invoke_564 = function (it) {
    var tmp = it;
    var tmp_0 = Type_CLICK_getInstance();
    mouseEvent$default(this._this$0_88, tmp, tmp_0, null, 8, null);
  };
  _no_name_provided__319.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__319.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__320(this$0) {
    this._this$0_89 = this$0;
  }
  _no_name_provided__320.prototype.invoke_564 = function (it) {
    touchEvent(this._this$0_89, it, Type_START_getInstance());
  };
  _no_name_provided__320.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__320.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__321(this$0) {
    this._this$0_90 = this$0;
  }
  _no_name_provided__321.prototype.invoke_564 = function (it) {
    touchEvent(this._this$0_90, it, Type_MOVE_getInstance_0());
  };
  _no_name_provided__321.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__321.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__322(this$0) {
    this._this$0_91 = this$0;
  }
  _no_name_provided__322.prototype.invoke_564 = function (it) {
    touchEvent(this._this$0_91, it, Type_END_getInstance());
  };
  _no_name_provided__322.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__322.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__323(this$0) {
    this._this$0_92 = this$0;
  }
  _no_name_provided__323.prototype.invoke_564 = function (it) {
    keyEvent(this._this$0_92, it);
  };
  _no_name_provided__323.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__323.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__324(this$0) {
    this._this$0_93 = this$0;
  }
  _no_name_provided__324.prototype.invoke_564 = function (it) {
    keyEvent(this._this$0_93, it);
  };
  _no_name_provided__324.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__324.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__325(this$0) {
    this._this$0_94 = this$0;
  }
  _no_name_provided__325.prototype.invoke_564 = function (it) {
    keyEvent(this._this$0_94, it);
  };
  _no_name_provided__325.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__325.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__326(this$0) {
    this._this$0_95 = this$0;
  }
  _no_name_provided__326.prototype.invoke_564 = function (e) {
    var e_0 = e;
    var tmp0_apply_0 = this._this$0_95._get_gamePadConnectionEvent__0();
    tmp0_apply_0._type_10 = Type_CONNECTED_getInstance();
    tmp0_apply_0._gamepad_1 = e_0.gamepad.index;
    var tmp1_dispatch_0 = tmp0_apply_0;
    this._this$0_95.dispatch_16(getKClass_0(GamePadConnectionEvent), tmp1_dispatch_0);
  };
  _no_name_provided__326.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__326.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__327(this$0) {
    this._this$0_96 = this$0;
  }
  _no_name_provided__327.prototype.invoke_564 = function (e) {
    var e_0 = e;
    var tmp0_apply_0 = this._this$0_96._get_gamePadConnectionEvent__0();
    tmp0_apply_0._type_10 = Type_DISCONNECTED_getInstance();
    tmp0_apply_0._gamepad_1 = e_0.gamepad.index;
    var tmp1_dispatch_0 = tmp0_apply_0;
    this._this$0_96.dispatch_16(getKClass_0(GamePadConnectionEvent), tmp1_dispatch_0);
  };
  _no_name_provided__327.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__327.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__328(this$0) {
    this._this$0_97 = this$0;
  }
  _no_name_provided__328.prototype.invoke_564 = function (it) {
    onResized(this._this$0_97);
  };
  _no_name_provided__328.prototype.invoke_1015 = function (p1) {
    this.invoke_564(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__328.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__329(this$0) {
    this._this$0_98 = this$0;
  }
  _no_name_provided__329.prototype.invoke_882 = function (step_0) {
    var startTime = PerformanceCounter_getInstance()._get_reference_();
    window.requestAnimationFrame(_get_jsFrame_(this._this$0_98));
    Unit_getInstance();
    updateGamepad(this._this$0_98);
    try {
      doRender(this._this$0_98);
    }finally {
      var elapsed = TimeSpan__minus_impl(PerformanceCounter_getInstance()._get_reference_(), startTime);
      var available = TimeSpan__minus_impl(this._this$0_98._get_counterTimePerFrame__1(), elapsed);
      this._this$0_98._get_coroutineDispatcher__1().executePending(available);
    }
  };
  _no_name_provided__329.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__329.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $loopCOROUTINE$2(_this_, entry, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__139 = _this_;
    this._entry_2 = entry;
  }
  $loopCOROUTINE$2.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__139.getCoroutineDispatcherWithCurrentContext_4(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = launchImmediately(ARGUMENT, _no_name_provided_$factory_283(this._entry_2, this.__this__139, null));
            this.__this__139._loopJob = ARGUMENT_0;
            _get_jsFrame_(this.__this__139)(0.0);
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $loopCOROUTINE$2.$metadata$ = {
    simpleName: '$loopCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function BrowserGameWindow() {
    GameWindow.call(this);
    var tmp = this;
    var tmp_0 = AGConfig_init_$Create$(false, 1, null);
    tmp._ag_1 = AGWebgl_init_$Create$(tmp_0, null, 2, null);
    this._isTouchDeviceCache = null;
    this._quality_1 = Quality_AUTOMATIC_getInstance();
    this._canvasRatio = 1.0;
    this._icon_0 = null;
    this._loopJob = null;
    var tmp0_asDynamic_0 = window;
    tmp0_asDynamic_0.canvas = this._get_canvas_();
    var tmp1_asDynamic_0 = window;
    tmp1_asDynamic_0.ag = this._ag_1;
    var tmp2_asDynamic_0 = window;
    tmp2_asDynamic_0.gl = this._ag_1._gl_3;
    var tmp0_safe_receiver = document.body;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.appendChild(this._get_canvas_());
    Unit_getInstance();
    var tmp1_safe_receiver = document.body;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
    if (tmp2_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp2_safe_receiver.margin = '0px';
    var tmp3_safe_receiver = document.body;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
    if (tmp4_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp4_safe_receiver.padding = '0px';
    var tmp5_safe_receiver = document.body;
    var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
    if (tmp6_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp6_safe_receiver.overflowX = 'hidden';
    var tmp7_safe_receiver = document.body;
    var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
    if (tmp8_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp8_safe_receiver.overflowY = 'hidden';
    var tmp_1 = this._get_canvas_();
    tmp_1.addEventListener('mouseenter', _no_name_provided_$factory_257(this));
    var tmp_2 = this._get_canvas_();
    tmp_2.addEventListener('mouseleave', _no_name_provided_$factory_258(this));
    var tmp_3 = this._get_canvas_();
    tmp_3.addEventListener('mouseover', _no_name_provided_$factory_259(this));
    var tmp_4 = this._get_canvas_();
    tmp_4.addEventListener('mousemove', _no_name_provided_$factory_260(this));
    var tmp_5 = this._get_canvas_();
    tmp_5.addEventListener('mouseout', _no_name_provided_$factory_261(this));
    var tmp_6 = this._get_canvas_();
    tmp_6.addEventListener('mouseup', _no_name_provided_$factory_262(this));
    var tmp_7 = this._get_canvas_();
    tmp_7.addEventListener('mousedown', _no_name_provided_$factory_263(this));
    var tmp_8 = this._get_canvas_();
    tmp_8.addEventListener('click', _no_name_provided_$factory_264(this));
    var tmp_9 = this._get_canvas_();
    tmp_9.addEventListener('touchstart', _no_name_provided_$factory_265(this));
    var tmp_10 = this._get_canvas_();
    tmp_10.addEventListener('touchmove', _no_name_provided_$factory_266(this));
    var tmp_11 = this._get_canvas_();
    tmp_11.addEventListener('touchend', _no_name_provided_$factory_267(this));
    var tmp_12 = window;
    tmp_12.addEventListener('keypress', _no_name_provided_$factory_268(this));
    var tmp_13 = window;
    tmp_13.addEventListener('keydown', _no_name_provided_$factory_269(this));
    var tmp_14 = window;
    tmp_14.addEventListener('keyup', _no_name_provided_$factory_270(this));
    var tmp_15 = window;
    tmp_15.addEventListener('gamepadconnected', _no_name_provided_$factory_271(this));
    var tmp_16 = window;
    tmp_16.addEventListener('gamepaddisconnected', _no_name_provided_$factory_272(this));
    var tmp_17 = window;
    tmp_17.addEventListener('resize', _no_name_provided_$factory_273(this));
    onResized(this);
    var tmp_18 = this;
    tmp_18._jsFrame = _no_name_provided_$factory_274(this);
  }
  BrowserGameWindow.prototype._get_ag__1 = function () {
    return this._ag_1;
  };
  BrowserGameWindow.prototype._get_canvas_ = function () {
    return this._ag_1._canvas_1;
  };
  BrowserGameWindow.prototype.is_touch_device = function () {
    if (this._isTouchDeviceCache == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        Unit_getInstance();
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        {
          tmp_1 = false;
        }
        tmp_0 = tmp_1;
      }
      tmp._isTouchDeviceCache = tmp_0;
    }return ensureNotNull(this._isTouchDeviceCache);
  };
  BrowserGameWindow.prototype._set_quality__1 = function (value) {
    if (!this._quality_1.equals(value)) {
      this._quality_1 = value;
      onResized(this);
    }};
  BrowserGameWindow.prototype._set_title__1 = function (value) {
    document.title = value;
  };
  BrowserGameWindow.prototype._get_width__58 = function () {
    return this._get_canvas_().clientWidth;
  };
  BrowserGameWindow.prototype._get_height__58 = function () {
    return this._get_canvas_().clientHeight;
  };
  BrowserGameWindow.prototype._set_icon__1 = function (value) {
    this._icon_0 = value;
    if (!(value == null)) {
      var tmp0_unsafeCast_0 = document.querySelector("link[rel*='icon']");
      var link = tmp0_unsafeCast_0;
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      var tmp = PNG_getInstance();
      link.href = 'data:image/png;base64,' + toBase64(tmp.encode$default_8(value, null, 2, null));
      var tmp1_get_0 = document.getElementsByTagName('head');
      var tmp2_get_0 = 0;
      var tmp0_safe_receiver = tmp1_get_0[tmp2_get_0];
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(link);
      Unit_getInstance();
    } else {
      var tmp1_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.remove();
        Unit_getInstance();
      }
      Unit_getInstance();
    }
  };
  BrowserGameWindow.prototype._set_fullscreen__1 = function (value) {
    if (!(this._get_fullscreen__2() === value)) {
      try {
        var tmp0_success_0_1 = Companion_getInstance_2();
        var tmp;
        if (value) {
          tmp = this._get_canvas_().requestFullscreen();
        } else {
          tmp = document.exitFullscreen();
        }
        var tmp1_success_0_2 = tmp;
        _Result___init__impl_(tmp1_success_0_2);
      } catch ($p) {
        if ($p instanceof Error) {
          var tmp2_failure_0_4 = Companion_getInstance_2();
          _Result___init__impl_(createFailure($p));
        } else {
          {
            throw $p;
          }
        }
      }
      Unit_getInstance();
    }};
  BrowserGameWindow.prototype._get_fullscreen__2 = function () {
    return !(document.fullscreenElement == null);
  };
  BrowserGameWindow.prototype._set_visible__4 = function (value) {
    return this._get_canvas_().style.visibility = value ? 'visible' : 'hidden';
  };
  BrowserGameWindow.prototype.setSize_7 = function (width, height) {
  };
  BrowserGameWindow.prototype.close_77 = function () {
    GameWindow.prototype.close_77.call(this);
    var tmp = this._get_coroutineDispatcher__1();
    launchImmediately(tmp, _no_name_provided_$factory_282(this, null));
    Unit_getInstance();
    this._loopJob = null;
  };
  BrowserGameWindow.prototype.loop_2 = function (entry, $cont) {
    var tmp = new $loopCOROUTINE$2(this, entry, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  BrowserGameWindow.$metadata$ = {
    simpleName: 'BrowserGameWindow',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_257(this$0) {
    var i = new _no_name_provided__312(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_258(this$0) {
    var i = new _no_name_provided__313(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_259(this$0) {
    var i = new _no_name_provided__314(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_260(this$0) {
    var i = new _no_name_provided__315(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_261(this$0) {
    var i = new _no_name_provided__316(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_262(this$0) {
    var i = new _no_name_provided__317(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_263(this$0) {
    var i = new _no_name_provided__318(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_264(this$0) {
    var i = new _no_name_provided__319(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_265(this$0) {
    var i = new _no_name_provided__320(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_266(this$0) {
    var i = new _no_name_provided__321(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_267(this$0) {
    var i = new _no_name_provided__322(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_268(this$0) {
    var i = new _no_name_provided__323(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_269(this$0) {
    var i = new _no_name_provided__324(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_270(this$0) {
    var i = new _no_name_provided__325(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_271(this$0) {
    var i = new _no_name_provided__326(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_272(this$0) {
    var i = new _no_name_provided__327(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_273(this$0) {
    var i = new _no_name_provided__328(this$0);
    return function (p1) {
      i.invoke_564(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_274(this$0) {
    var i = new _no_name_provided__329(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_275(this$0) {
    var i = new _no_name_provided__303(this$0);
    return function (p1) {
      i.invoke_526(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_276(this$0) {
    var i = new _no_name_provided__304(this$0);
    return function (p1) {
      i.invoke_526(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_277(this$0) {
    var i = new _no_name_provided__305(this$0);
    return function (p1) {
      i.invoke_526(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_278() {
    var i = new _no_name_provided__306();
    return function (p1) {
      i.invoke_526(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_279(this$0) {
    var i = new _no_name_provided__307(this$0);
    return function (p1) {
      i.invoke_526(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_280(this$0) {
    var i = new _no_name_provided__308(this$0);
    return function (p1) {
      i.invoke_526(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_281(this$0) {
    var i = new _no_name_provided__309(this$0);
    return function (p1) {
      i.invoke_526(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_282(this$0, resultContinuation) {
    var i = new _no_name_provided__310(this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_283($entry, this$0, resultContinuation) {
    var i = new _no_name_provided__311($entry, this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function knownControllers$init$() {
    var tmp0_associateBy_0 = listOf([Companion_getInstance_129(), Nimbus_111_1420_Safari_GamepadMapping_getInstance()]);
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateBy_0, 10)), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var tmp0_iterator_1_3 = tmp0_associateBy_0.iterator_67();
    while (tmp0_iterator_1_3.hasNext_33()) {
      var element_2_4 = tmp0_iterator_1_3.next_37();
      tmp0_associateByTo_0_2.put_18(element_2_4._get_id__2(), element_2_4);
      Unit_getInstance();
    }
    return tmp0_associateByTo_0_2;
  }
  var DEFAULT_UI_FACTORY;
  function AsyncInjector_init_$Init$(parent, level, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      parent = null;
    if (!(($mask0 & 2) === 0))
      level = 0;
    AsyncInjector.call($this, parent, level);
    return $this;
  }
  function AsyncInjector_init_$Create$(parent, level, $mask0, $marker) {
    return AsyncInjector_init_$Init$(parent, level, $mask0, $marker, Object.create(AsyncInjector.prototype));
  }
  function RequestContext(initialClazz) {
    this._initialClazz = initialClazz;
  }
  RequestContext.prototype.toString = function () {
    return '' + 'RequestContext(initialClazz=' + this._initialClazz + ')';
  };
  RequestContext.prototype.hashCode = function () {
    return this._initialClazz.hashCode();
  };
  RequestContext.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestContext))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RequestContext ? other : THROW_CCE();
    if (!this._initialClazz.equals(tmp0_other_with_cast._initialClazz))
      return false;
    return true;
  };
  RequestContext.$metadata$ = {
    simpleName: 'RequestContext',
    kind: 'class',
    interfaces: []
  };
  function NotMappedException(clazz, requestedByClass, ctx, msg) {
    RuntimeException_init_$Init$_0(msg, this);
    this._clazz = clazz;
    this._requestedByClass = requestedByClass;
    this._ctx_2 = ctx;
    this._msg_0 = msg;
    captureStack(this, NotMappedException);
  }
  NotMappedException.$metadata$ = {
    simpleName: 'NotMappedException',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__330(this$0, $clazz, $ctx, resultContinuation) {
    this._this$0_99 = this$0;
    this._$clazz = $clazz;
    this._$ctx_0 = $ctx;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__330.prototype.invoke_1005 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__330.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_99.get_108(this._$clazz, this._$ctx_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__330.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__330(this._this$0_99, this._$clazz, this._$ctx_0, completion);
    return i;
  };
  _no_name_provided__330.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__331($rexception, $rresult) {
    this._$rexception = $rexception;
    this._$rresult_0 = $rresult;
    this._context_4 = EmptyCoroutineContext_getInstance();
  }
  _no_name_provided__331.prototype._get_context__296 = function () {
    return this._context_4;
  };
  _no_name_provided__331.prototype.resumeWith_196 = function (result) {
    var exception = Result__exceptionOrNull_impl(result);
    if (!(exception == null)) {
      this._$rexception._v = exception;
    } else {
      throwOnFailure(result);
      var tmp = _Result___get_value__impl_(result);
      this._$rresult_0._v = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
    }
  };
  _no_name_provided__331.$metadata$ = {
    kind: 'class',
    interfaces: [Continuation]
  };
  function $getProviderOrNullCOROUTINE$0(_this_, clazz, ctx, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__140 = _this_;
    this._clazz_0 = clazz;
    this._ctx_3 = ctx;
  }
  $getProviderOrNullCOROUTINE$0.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            this._tmp1_elvis_lhs0_1 = this.__this__140._providersByClass.get_116(this._clazz_0);
            if (this._tmp1_elvis_lhs0_1 == null) {
              this._tmp0_safe_receiver2_1 = this.__this__140._parent_4;
              if (this._tmp0_safe_receiver2_1 == null) {
                this._WHEN_RESULT3_2 = null;
                this._state_1 = 2;
                continue $sm;
              } else {
                this._state_1 = 1;
                suspendResult = this._tmp0_safe_receiver2_1.getProviderOrNull(this._clazz_0, this._ctx_3, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            } else {
              this._WHEN_RESULT1_9 = this._tmp1_elvis_lhs0_1;
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 1:
            this._WHEN_RESULT3_2 = suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._WHEN_RESULT1_9 = this._WHEN_RESULT3_2;
            this._state_1 = 3;
            continue $sm;
          case 3:
            this._tmp4_elvis_lhs4 = this._WHEN_RESULT1_9;
            if (this._tmp4_elvis_lhs4 == null) {
              this._tmp2_safe_receiver6 = this.__this__140._get_nearestFallbackProvider_();
              if (this._tmp2_safe_receiver6 == null) {
                this._WHEN_RESULT7 = null;
                this._state_1 = 5;
                continue $sm;
              } else {
                this._state_1 = 4;
                suspendResult = this._tmp2_safe_receiver6(this._clazz_0, this._ctx_3, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              }
            } else {
              this._WHEN_RESULT5_1 = this._tmp4_elvis_lhs4;
              this._state_1 = 6;
              continue $sm;
            }

            Unit_getInstance();
            break;
          case 4:
            this._WHEN_RESULT7 = suspendResult;
            this._state_1 = 5;
            continue $sm;
          case 5:
            var tmp3_safe_receiver = this._WHEN_RESULT7;
            var tmp_0 = this;
            var tmp_1;
            if (tmp3_safe_receiver == null) {
              tmp_1 = null;
            } else {
              var tmp0_set_0_2 = this.__this__140._providersByClass;
              tmp0_set_0_2.put_18(this._clazz_0, tmp3_safe_receiver);
              Unit_getInstance();
              tmp_1 = tmp3_safe_receiver;
            }

            tmp_0._WHEN_RESULT5_1 = tmp_1;
            this._state_1 = 6;
            continue $sm;
          case 6:
            var tmp_2 = this._WHEN_RESULT5_1;
            return (tmp_2 == null ? true : isInterface(tmp_2, AsyncObjectProvider)) ? tmp_2 : null;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getProviderOrNullCOROUTINE$0.$metadata$ = {
    simpleName: '$getProviderOrNullCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $getProviderCOROUTINE$1(_this_, clazz, ctx, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__141 = _this_;
    this._clazz_1 = clazz;
    this._ctx_4 = ctx;
  }
  $getProviderCOROUTINE$1.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this.__this__141.getProviderOrNull(this._clazz_1, this._ctx_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              throw new NotMappedException(this._clazz_1, this._ctx_4._initialClazz, this._ctx_4, '' + "Class '" + this._clazz_1 + "' doesn't have constructors " + this._ctx_4);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            return tmp_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getProviderCOROUTINE$1.$metadata$ = {
    simpleName: '$getProviderCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function $getCOROUTINE$3(_this_, clazz, ctx, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__142 = _this_;
    this._clazz_2 = clazz;
    this._ctx_5 = ctx;
  }
  $getCOROUTINE$3.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__142.getProvider(this._clazz_2, this._ctx_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_24 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._ARGUMENT0_24.get_112(this.__this__142, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getCOROUTINE$3.$metadata$ = {
    simpleName: '$getCOROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function $createdCOROUTINE$5(_this_, instance, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__143 = _this_;
    this._instance = instance;
  }
  $createdCOROUTINE$5.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            var tmp_0 = this._instance;
            if (!(tmp_0 == null) ? isInterface(tmp_0, AsyncDependency) : false) {
              this._state_1 = 1;
              suspendResult = this._instance.init_15(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 2;
                continue $sm;
              }
            }

            break;
          case 1:
            suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            var tmp_1 = this._instance;
            if (!(tmp_1 == null) ? isInterface(tmp_1, InjectorAsyncDependency) : false) {
              this._state_1 = 3;
              suspendResult = this._instance.init_18(this.__this__143, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this._state_1 = 4;
                continue $sm;
              }
            }

            break;
          case 3:
            suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            return this._instance;
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createdCOROUTINE$5.$metadata$ = {
    simpleName: '$createdCOROUTINE$5',
    kind: 'class',
    interfaces: []
  };
  function $deinitCOROUTINE$6(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__144 = _this_;
  }
  $deinitCOROUTINE$6.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            var tmp_1 = this;
            tmp_1._tmp0_iterator_00_0 = this.__this__144._providersByClass;
            tmp_0._tmp0_iterator1 = this._tmp0_iterator_00_0._get_entries__10().iterator_67();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator1.hasNext_33()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._pair2 = this._tmp0_iterator1.next_37();
            this._state_1 = 2;
            suspendResult = this._pair2._get_value__10().deinit_4(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $deinitCOROUTINE$6.$metadata$ = {
    simpleName: '$deinitCOROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function AsyncInjector(parent, level) {
    this._parent_4 = parent;
    this._level_1 = level;
    this._fallbackProvider = null;
    this._providersByClass = LinkedHashMap_init_$Create$();
    var tmp = this;
    var tmp0_safe_receiver = this._parent_4;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._root_1;
    tmp._root_1 = tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
    this.mapInstance(getKClass_0(AsyncInjector), this);
    Unit_getInstance();
  }
  AsyncInjector.prototype._get_nearestFallbackProvider_ = function () {
    var tmp1_elvis_lhs = this._fallbackProvider;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = this._parent_4;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._fallbackProvider;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  AsyncInjector.prototype.child_0 = function () {
    return new AsyncInjector(this, this._level_1 + 1 | 0);
  };
  AsyncInjector.prototype.mapInstance = function (clazz, instance) {
    var tmp0_set_0_2 = this._providersByClass;
    var tmp1_set_0_3 = new InstanceAsyncObjectProvider(isObject(instance) ? instance : THROW_CCE());
    tmp0_set_0_2.put_18(clazz, tmp1_set_0_3);
    Unit_getInstance();
    return this;
  };
  AsyncInjector.prototype.mapSingleton = function (clazz, gen) {
    var tmp0_set_0_2 = this._providersByClass;
    var tmp1_set_0_3 = new SingletonAsyncObjectProvider(gen);
    tmp0_set_0_2.put_18(clazz, tmp1_set_0_3);
    Unit_getInstance();
    return this;
  };
  AsyncInjector.prototype.mapPrototype = function (clazz, gen) {
    var tmp0_set_0_2 = this._providersByClass;
    var tmp1_set_0_3 = new PrototypeAsyncObjectProvider(gen);
    tmp0_set_0_2.put_18(clazz, tmp1_set_0_3);
    Unit_getInstance();
    return this;
  };
  AsyncInjector.prototype.getProviderOrNull = function (clazz, ctx, $cont) {
    var tmp = new $getProviderOrNullCOROUTINE$0(this, clazz, ctx, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncInjector.prototype.getProvider = function (clazz, ctx, $cont) {
    var tmp = new $getProviderCOROUTINE$1(this, clazz, ctx, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncInjector.prototype.getSync = function (clazz, ctx) {
    var rresult = {_v: null};
    var rexception = {_v: null};
    var tmp0_suspend_0 = _no_name_provided_$factory_284(this, clazz, ctx, null);
    startCoroutine(tmp0_suspend_0, new _no_name_provided__331(rexception, rresult));
    if (!(rexception._v == null))
      throw ensureNotNull(rexception._v);
    try {
      var tmp;
      if (rresult._v == null) {
        throwUninitializedPropertyAccessException('rresult');
      } else {
        tmp = rresult._v;
      }
      return tmp;
    } catch ($p) {
      if ($p instanceof Error) {
        throw RuntimeException_init_$Create$_0('' + "Couldn't get instance of type " + clazz + ' synchronously', $p);
      } else {
        {
          throw $p;
        }
      }
    }
  };
  AsyncInjector.prototype.get_108 = function (clazz, ctx, $cont) {
    var tmp = new $getCOROUTINE$3(this, clazz, ctx, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncInjector.prototype.get$default_0 = function (clazz, ctx, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      ctx = new RequestContext(clazz);
    return this.get_108(clazz, ctx, $cont);
  };
  AsyncInjector.prototype.toString = function () {
    return '' + 'AsyncInjector(level=' + this._level_1 + ')';
  };
  AsyncInjector.prototype.created = function (instance, $cont) {
    var tmp = new $createdCOROUTINE$5(this, instance, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncInjector.prototype.deinit_4 = function ($cont) {
    var tmp = new $deinitCOROUTINE$6(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  AsyncInjector.$metadata$ = {
    simpleName: 'AsyncInjector',
    kind: 'class',
    interfaces: []
  };
  function InjectorAsyncDependency() {
  }
  InjectorAsyncDependency.$metadata$ = {
    simpleName: 'InjectorAsyncDependency',
    kind: 'interface',
    interfaces: []
  };
  function AsyncDependency() {
  }
  AsyncDependency.$metadata$ = {
    simpleName: 'AsyncDependency',
    kind: 'interface',
    interfaces: []
  };
  function AsyncObjectProvider() {
  }
  AsyncObjectProvider.$metadata$ = {
    simpleName: 'AsyncObjectProvider',
    kind: 'interface',
    interfaces: []
  };
  function $deinitCOROUTINE$7(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__145 = _this_;
  }
  $deinitCOROUTINE$7.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this.__this__145._instance_0;
            tmp_0._tmp0_safe_receiver0_2 = (tmp_1 == null ? true : isInterface(tmp_1, AsyncDestructor)) ? tmp_1 : null;
            if (this._tmp0_safe_receiver0_2 == null) {
              this._WHEN_RESULT1_10 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0_2.deinit_4(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            var tmp_2 = this;
            suspendResult;
            tmp_2._WHEN_RESULT1_10 = Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            Unit_getInstance();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $deinitCOROUTINE$7.$metadata$ = {
    simpleName: '$deinitCOROUTINE$7',
    kind: 'class',
    interfaces: []
  };
  function InstanceAsyncObjectProvider(instance) {
    this._instance_0 = instance;
  }
  InstanceAsyncObjectProvider.prototype.get_112 = function (injector, $cont) {
    return this._instance_0;
  };
  InstanceAsyncObjectProvider.prototype.deinit_4 = function ($cont) {
    var tmp = new $deinitCOROUTINE$7(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  InstanceAsyncObjectProvider.prototype.toString = function () {
    return '' + 'InstanceAsyncObjectProvider(' + this._instance_0 + ')';
  };
  InstanceAsyncObjectProvider.$metadata$ = {
    simpleName: 'InstanceAsyncObjectProvider',
    kind: 'class',
    interfaces: [AsyncObjectProvider]
  };
  function $getCOROUTINE$9(_this_, injector, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__146 = _this_;
    this._injector = injector;
  }
  $getCOROUTINE$9.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            if (this.__this__146._value_24 == null) {
              this._state_1 = 1;
              suspendResult = this.__this__146._generator_0(this._injector, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT0_25 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._injector.created(this._ARGUMENT0_25, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.__this__146._value_24 = ARGUMENT;
            this._state_1 = 3;
            continue $sm;
          case 3:
            return ensureNotNull(this.__this__146._value_24);
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getCOROUTINE$9.$metadata$ = {
    simpleName: '$getCOROUTINE$9',
    kind: 'class',
    interfaces: []
  };
  function $deinitCOROUTINE$10(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__147 = _this_;
  }
  $deinitCOROUTINE$10.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = this;
            var tmp_1 = this.__this__147._value_24;
            tmp_0._tmp0_safe_receiver0_3 = (tmp_1 == null ? true : isInterface(tmp_1, AsyncDestructor)) ? tmp_1 : null;
            if (this._tmp0_safe_receiver0_3 == null) {
              this._WHEN_RESULT1_11 = null;
              this._state_1 = 2;
              continue $sm;
            } else {
              this._state_1 = 1;
              suspendResult = this._tmp0_safe_receiver0_3.deinit_4(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            }

            break;
          case 1:
            var tmp_2 = this;
            suspendResult;
            tmp_2._WHEN_RESULT1_11 = Unit_getInstance();
            this._state_1 = 2;
            continue $sm;
          case 2:
            Unit_getInstance();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $deinitCOROUTINE$10.$metadata$ = {
    simpleName: '$deinitCOROUTINE$10',
    kind: 'class',
    interfaces: []
  };
  function SingletonAsyncObjectProvider(generator) {
    this._generator_0 = generator;
    this._value_24 = null;
  }
  SingletonAsyncObjectProvider.prototype.get_112 = function (injector, $cont) {
    var tmp = new $getCOROUTINE$9(this, injector, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  SingletonAsyncObjectProvider.prototype.deinit_4 = function ($cont) {
    var tmp = new $deinitCOROUTINE$10(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  SingletonAsyncObjectProvider.prototype.toString = function () {
    return '' + 'SingletonAsyncObjectProvider(' + this._value_24 + ')';
  };
  SingletonAsyncObjectProvider.$metadata$ = {
    simpleName: 'SingletonAsyncObjectProvider',
    kind: 'class',
    interfaces: [AsyncObjectProvider]
  };
  function $getCOROUTINE$11(_this_, injector, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__148 = _this_;
    this._injector_0 = injector;
  }
  $getCOROUTINE$11.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this.__this__148._generator_1(this._injector_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_26 = suspendResult;
            this._state_1 = 2;
            suspendResult = this._injector_0.created(this._ARGUMENT0_26, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $getCOROUTINE$11.$metadata$ = {
    simpleName: '$getCOROUTINE$11',
    kind: 'class',
    interfaces: []
  };
  function PrototypeAsyncObjectProvider(generator) {
    this._generator_1 = generator;
  }
  PrototypeAsyncObjectProvider.prototype.get_112 = function (injector, $cont) {
    var tmp = new $getCOROUTINE$11(this, injector, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  PrototypeAsyncObjectProvider.prototype.deinit_4 = function ($cont) {
    return Unit_getInstance();
  };
  PrototypeAsyncObjectProvider.prototype.toString = function () {
    return 'PrototypeAsyncObjectProvider()';
  };
  PrototypeAsyncObjectProvider.$metadata$ = {
    simpleName: 'PrototypeAsyncObjectProvider',
    kind: 'class',
    interfaces: [AsyncObjectProvider]
  };
  function AsyncDestructor() {
  }
  AsyncDestructor.$metadata$ = {
    simpleName: 'AsyncDestructor',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_284(this$0, $clazz, $ctx, resultContinuation) {
    var i = new _no_name_provided__330(this$0, $clazz, $ctx, resultContinuation);
    var l = function ($cont) {
      return i.invoke_1005($cont);
    };
    l.$arity = 0;
    return l;
  }
  function Companion_138() {
    Companion_instance_137 = this;
  }
  Companion_138.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: [Key_0]
  };
  var Companion_instance_137;
  function Companion_getInstance_137() {
    if (Companion_instance_137 == null)
      new Companion_138();
    return Companion_instance_137;
  }
  function AsyncInjectorContext(injector) {
    Companion_getInstance_137();
    this._injector_1 = injector;
  }
  AsyncInjectorContext.prototype._get_key__37 = function () {
    return Companion_getInstance_137();
  };
  AsyncInjectorContext.$metadata$ = {
    simpleName: 'AsyncInjectorContext',
    kind: 'class',
    interfaces: [Element_0]
  };
  var debugPrintln$delegate;
  function _no_name_provided__332() {
  }
  _no_name_provided__332.prototype.invoke_569 = function ($this$$receiver) {
    return $this$$receiver._extra_3;
  };
  _no_name_provided__332.prototype.invoke_1015 = function (p1) {
    return this.invoke_569(p1 instanceof TemplateConfig ? p1 : THROW_CCE());
  };
  _no_name_provided__332.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__333() {
  }
  _no_name_provided__333.prototype.invoke_571 = function (v) {
    println(v);
  };
  _no_name_provided__333.prototype.invoke_1015 = function (p1) {
    this.invoke_571((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__333.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__334() {
  }
  _no_name_provided__334.prototype.invoke_1005 = function () {
    return _no_name_provided_$factory_287();
  };
  _no_name_provided__334.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_285() {
    var i = new _no_name_provided__332();
    return function (p1) {
      return i.invoke_569(p1);
    };
  }
  function _no_name_provided_$factory_286() {
    var i = new _no_name_provided__334();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_287() {
    var i = new _no_name_provided__333();
    return function (p1) {
      i.invoke_571(p1);
      return Unit_getInstance();
    };
  }
  function debugPrintln$delegate$init$() {
    var tmp = _no_name_provided_$factory_285();
    return extraProperty_init_$Create$(tmp, null, _no_name_provided_$factory_286(), 2, null);
  }
  function TemplateConfig() {
  }
  TemplateConfig.$metadata$ = {
    simpleName: 'TemplateConfig',
    kind: 'class',
    interfaces: []
  };
  function ObjectMapper2() {
  }
  ObjectMapper2.$metadata$ = {
    simpleName: 'ObjectMapper2',
    kind: 'class',
    interfaces: []
  };
  var formatRegex_0;
  var charToEntity;
  function extraProperty_init_$Init$(getExtraMap, name, default_0, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      name = null;
    extraProperty.call($this, getExtraMap, name, default_0);
    return $this;
  }
  function extraProperty_init_$Create$(getExtraMap, name, default_0, $mask0, $marker) {
    return extraProperty_init_$Init$(getExtraMap, name, default_0, $mask0, $marker, Object.create(extraProperty.prototype));
  }
  function extraProperty(getExtraMap, name, default_0) {
    this._getExtraMap = getExtraMap;
    this._name_25 = name;
    this._default_0 = default_0;
  }
  extraProperty.$metadata$ = {
    simpleName: 'extraProperty',
    kind: 'class',
    interfaces: []
  };
  var Mapper2;
  function JsObjectMapper2() {
    ObjectMapper2.call(this);
  }
  JsObjectMapper2.$metadata$ = {
    simpleName: 'JsObjectMapper2',
    kind: 'class',
    interfaces: []
  };
  function Config_init_$Init$(module_0, args, imageFormats, gameWindow, sceneClass, sceneInjects, timeProvider, injector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, constructedViews, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      var tmp0_arrayOf_0 = [];
      args = tmp0_arrayOf_0;
    }if (!(($mask0 & 4) === 0))
      imageFormats = RegisteredImageFormats_getInstance();
    if (!(($mask0 & 8) === 0))
      gameWindow = null;
    if (!(($mask0 & 16) === 0))
      sceneClass = module_0._get_mainScene__1();
    if (!(($mask0 & 32) === 0)) {
      sceneInjects = emptyList();
    }if (!(($mask0 & 64) === 0))
      timeProvider = Companion_getInstance_26();
    if (!(($mask0 & 128) === 0)) {
      injector = AsyncInjector_init_$Create$(null, 0, 3, null);
    }if (!(($mask0 & 256) === 0))
      debug = false;
    if (!(($mask0 & 512) === 0))
      trace = false;
    if (!(($mask0 & 1024) === 0))
      context = null;
    if (!(($mask0 & 2048) === 0))
      fullscreen = null;
    if (!(($mask0 & 4096) === 0))
      blocking = true;
    if (!(($mask0 & 8192) === 0))
      gameId = Korge_getInstance()._DEFAULT_GAME_ID;
    if (!(($mask0 & 16384) === 0))
      settingsFolder = null;
    if (!(($mask0 & 32768) === 0))
      batchMaxQuads = Companion_getInstance_143()._DEFAULT_BATCH_QUADS;
    if (!(($mask0 & 65536) === 0)) {
      constructedViews = _no_name_provided_$factory_301();
    }Config.call($this, module_0, args, imageFormats, gameWindow, sceneClass, sceneInjects, timeProvider, injector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, constructedViews);
    return $this;
  }
  function Config_init_$Create$(module_0, args, imageFormats, gameWindow, sceneClass, sceneInjects, timeProvider, injector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, constructedViews, $mask0, $marker) {
    return Config_init_$Init$(module_0, args, imageFormats, gameWindow, sceneClass, sceneInjects, timeProvider, injector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, constructedViews, $mask0, $marker, Object.create(Config.prototype));
  }
  function _no_name_provided__335() {
  }
  _no_name_provided__335.prototype.invoke_574 = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__335.prototype.invoke_1015 = function (p1) {
    this.invoke_574(p1 instanceof Views ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__335.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__336($sc, resultContinuation) {
    this._$sc = $sc;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__336.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__336.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__336.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp1_changeTo_00 = [];
            var tmp_1 = this;
            var tmp0__get_seconds__0 = 0;
            tmp_1._tmp2_changeTo_01 = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
            var tmp_2 = this;
            tmp_2._tmp3_changeTo_02 = this._$sc._defaultTransition;
            this._state_1 = 1;
            suspendResult = this._$sc.changeTo(getKClass_0(EmptyScene), this._tmp1_changeTo_00.slice(), this._tmp2_changeTo_01, this._tmp3_changeTo_02, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__336.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__336(this._$sc, completion);
    return i;
  };
  _no_name_provided__336.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__337($entry, $views, $blocking, $gameWindow, resultContinuation) {
    this._$entry_1 = $entry;
    this._$views = $views;
    this._$blocking = $blocking;
    this._$gameWindow = $gameWindow;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__337.prototype.invoke_729 = function ($this$coroutineScope, $cont) {
    var tmp = this.create_51($this$coroutineScope, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__337.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_729((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__337.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this._$entry_1(this._$views._stage_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            if (this._$blocking) {
              this._state_1 = 2;
              suspendResult = this._$gameWindow.waitClose_1(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 3;
              continue $sm;
            }

            break;
          case 2:
            suspendResult;
            this._state_1 = 3;
            continue $sm;
          case 3:
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__337.prototype.create_51 = function ($this$coroutineScope, completion) {
    var i = new _no_name_provided__337(this._$entry_1, this._$views, this._$blocking, this._$gameWindow, completion);
    i._$this$coroutineScope = $this$coroutineScope;
    return i;
  };
  _no_name_provided__337.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__338($title, $fullscreen, $width, $height, $virtualWidth, $virtualHeight) {
    this._$title = $title;
    this._$fullscreen = $fullscreen;
    this._$width_2 = $width;
    this._$height_2 = $height;
    this._$virtualWidth = $virtualWidth;
    this._$virtualHeight = $virtualHeight;
    Module.call(this);
    this._title = this._$title;
    this._fullscreen_1 = this._$fullscreen;
    this._windowSize = Companion_getInstance_87().invoke_325(this._$width_2, this._$height_2);
    this._size_12 = Companion_getInstance_87().invoke_325(this._$virtualWidth, this._$virtualHeight);
  }
  _no_name_provided__338.prototype._get_title__1 = function () {
    return this._title;
  };
  _no_name_provided__338.prototype._get_fullscreen__2 = function () {
    return this._fullscreen_1;
  };
  _no_name_provided__338.prototype._get_windowSize__1 = function () {
    return this._windowSize;
  };
  _no_name_provided__338.prototype._get_size__61 = function () {
    return this._size_12;
  };
  _no_name_provided__338.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__339($entry, $views, $blocking, $gameWindow, resultContinuation) {
    this._$entry_2 = $entry;
    this._$views_0 = $views;
    this._$blocking_0 = $blocking;
    this._$gameWindow_0 = $gameWindow;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__339.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__339.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__339.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = coroutineScope(_no_name_provided_$factory_303(this._$entry_2, this._$views_0, this._$blocking_0, this._$gameWindow_0, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__339.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__339(this._$entry_2, this._$views_0, this._$blocking_0, this._$gameWindow_0, completion);
    return i;
  };
  _no_name_provided__339.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__340($views, resultContinuation) {
    this._$views_1 = $views;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__340.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__340.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__340.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$views_1.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__340.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__340(this._$views_1, completion);
    return i;
  };
  _no_name_provided__340.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function Config(module_0, args, imageFormats, gameWindow, sceneClass, sceneInjects, timeProvider, injector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, constructedViews) {
    this._module = module_0;
    this._args = args;
    this._imageFormats = imageFormats;
    this._gameWindow = gameWindow;
    this._sceneClass = sceneClass;
    this._sceneInjects = sceneInjects;
    this._timeProvider = timeProvider;
    this._injector_2 = injector;
    this._debug_2 = debug;
    this._trace = trace;
    this._context_5 = context;
    this._fullscreen_2 = fullscreen;
    this._blocking = blocking;
    this._gameId = gameId;
    this._settingsFolder = settingsFolder;
    this._batchMaxQuads = batchMaxQuads;
    this._constructedViews = constructedViews;
  }
  Config.prototype.toString = function () {
    return '' + 'Config(module=' + this._module + ', args=' + toString_1(this._args) + ', imageFormats=' + this._imageFormats + ', gameWindow=' + this._gameWindow + ', sceneClass=' + this._sceneClass + ', sceneInjects=' + this._sceneInjects + ', timeProvider=' + this._timeProvider + ', injector=' + this._injector_2 + ', debug=' + this._debug_2 + ', trace=' + this._trace + ', context=' + this._context_5 + ', fullscreen=' + this._fullscreen_2 + ', blocking=' + this._blocking + ', gameId=' + this._gameId + ', settingsFolder=' + this._settingsFolder + ', batchMaxQuads=' + this._batchMaxQuads + ', constructedViews=' + this._constructedViews + ')';
  };
  Config.prototype.hashCode = function () {
    var result = hashCode(this._module);
    result = imul(result, 31) + hashCode(this._args) | 0;
    result = imul(result, 31) + hashCode(this._imageFormats) | 0;
    result = imul(result, 31) + (this._gameWindow == null ? 0 : hashCode(this._gameWindow)) | 0;
    result = imul(result, 31) + this._sceneClass.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._sceneInjects) | 0;
    result = imul(result, 31) + hashCode(this._timeProvider) | 0;
    result = imul(result, 31) + hashCode(this._injector_2) | 0;
    result = imul(result, 31) + (this._debug_2 | 0) | 0;
    result = imul(result, 31) + (this._trace | 0) | 0;
    result = imul(result, 31) + (this._context_5 == null ? 0 : hashCode(this._context_5)) | 0;
    result = imul(result, 31) + (this._fullscreen_2 == null ? 0 : this._fullscreen_2 | 0) | 0;
    result = imul(result, 31) + (this._blocking | 0) | 0;
    result = imul(result, 31) + getStringHashCode(this._gameId) | 0;
    result = imul(result, 31) + (this._settingsFolder == null ? 0 : getStringHashCode(this._settingsFolder)) | 0;
    result = imul(result, 31) + this._batchMaxQuads | 0;
    result = imul(result, 31) + hashCode(this._constructedViews) | 0;
    return result;
  };
  Config.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Config))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Config ? other : THROW_CCE();
    if (!equals_1(this._module, tmp0_other_with_cast._module))
      return false;
    if (!equals_1(this._args, tmp0_other_with_cast._args))
      return false;
    if (!equals_1(this._imageFormats, tmp0_other_with_cast._imageFormats))
      return false;
    if (!equals_1(this._gameWindow, tmp0_other_with_cast._gameWindow))
      return false;
    if (!this._sceneClass.equals(tmp0_other_with_cast._sceneClass))
      return false;
    if (!equals_1(this._sceneInjects, tmp0_other_with_cast._sceneInjects))
      return false;
    if (!equals_1(this._timeProvider, tmp0_other_with_cast._timeProvider))
      return false;
    if (!equals_1(this._injector_2, tmp0_other_with_cast._injector_2))
      return false;
    if (!(this._debug_2 === tmp0_other_with_cast._debug_2))
      return false;
    if (!(this._trace === tmp0_other_with_cast._trace))
      return false;
    if (!equals_1(this._context_5, tmp0_other_with_cast._context_5))
      return false;
    if (!(this._fullscreen_2 == tmp0_other_with_cast._fullscreen_2))
      return false;
    if (!(this._blocking === tmp0_other_with_cast._blocking))
      return false;
    if (!(this._gameId === tmp0_other_with_cast._gameId))
      return false;
    if (!(this._settingsFolder == tmp0_other_with_cast._settingsFolder))
      return false;
    if (!(this._batchMaxQuads === tmp0_other_with_cast._batchMaxQuads))
      return false;
    if (!equals_1(this._constructedViews, tmp0_other_with_cast._constructedViews))
      return false;
    return true;
  };
  Config.$metadata$ = {
    simpleName: 'Config',
    kind: 'class',
    interfaces: []
  };
  function ModuleArgs(args) {
    this._args_0 = args;
  }
  ModuleArgs.prototype.toString = function () {
    return '' + 'ModuleArgs(args=' + toString_1(this._args_0) + ')';
  };
  ModuleArgs.prototype.hashCode = function () {
    return hashCode(this._args_0);
  };
  ModuleArgs.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ModuleArgs))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ModuleArgs ? other : THROW_CCE();
    if (!equals_1(this._args_0, tmp0_other_with_cast._args_0))
      return false;
    return true;
  };
  ModuleArgs.$metadata$ = {
    simpleName: 'ModuleArgs',
    kind: 'class',
    interfaces: []
  };
  function prepareViewsBase$getRealX($ag, x, scaleCoords) {
    return scaleCoords ? x * $ag._get_devicePixelRatio__4() : x;
  }
  function prepareViewsBase$getRealY($ag, y, scaleCoords) {
    return scaleCoords ? y * $ag._get_devicePixelRatio__4() : y;
  }
  function prepareViewsBase$mouseDown($views, $downPos, $downTime, type, x, y) {
    $views._input_0._mouseButtons_0 = 1;
    $views._input_0._mouse_0.setTo_0(x, y);
    Unit_getInstance();
    $views.mouseUpdated();
    $downPos.copyFrom_1($views._input_0._mouse_0);
    Unit_getInstance();
    $downTime._v = new DateTime(Companion_getInstance_18().now_2());
    $views._input_0._mouseInside = true;
  }
  function prepareViewsBase$mouseUp($views, $upPos, $upTime, $downTime, type, x, y) {
    $views._input_0._mouseButtons_0 = 0;
    $views._input_0._mouse_0.setTo_0(x, y);
    Unit_getInstance();
    $views.mouseUpdated();
    $upPos.copyFrom_1($views._input_0._mouse_0);
    Unit_getInstance();
    if (type === 'onTouchEnd') {
      $upTime._v = new DateTime(Companion_getInstance_18().now_2());
      var tmp = DateTime__minus_impl_0($downTime._v._unixMillis, $upTime._v._unixMillis);
      var tmp0__get_milliseconds__0 = 40;
      if (TimeSpan__compareTo_impl(tmp, Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0)) <= 0) {
        var tmp_0 = Type_CLICK_getInstance();
        var tmp1_dispatch_0 = MouseEvent_init_$Create$(tmp_0, 0, 0, 0, null, 0, 0.0, 0.0, 0.0, false, false, false, false, false, 16382, null);
        $views.dispatch_16(getKClass_0(MouseEvent_0), tmp1_dispatch_0);
      } else {
      }
    }}
  function prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, type, x, y, inside) {
    $views._input_0._mouse_0.setTo_0(x, y);
    Unit_getInstance();
    $views._input_0._mouseInside = inside;
    if (!inside) {
      $moveMouseOutsideInNextFrame._v = true;
    }$views.mouseUpdated();
    $moveTime._v = new DateTime(Companion_getInstance_18().now_2());
  }
  function prepareViewsBase$mouseDrag($views, $moveTime, type, x, y) {
    $views._input_0._mouse_0.setTo_0(x, y);
    Unit_getInstance();
    $views.mouseUpdated();
    $moveTime._v = new DateTime(Companion_getInstance_18().now_2());
  }
  function prepareViewsBase$touch($moveMouseOutsideInNextFrame, $views, $downPos, $downTime, $upPos, $upTime, $moveTime, e, start, end) {
    var t = first(e._get_touches_());
    var x = t._x_15;
    var y = t._y_14;
    if (start) {
      prepareViewsBase$mouseDown($views, $downPos, $downTime, 'onTouchStart', x, y);
    } else if (end) {
      prepareViewsBase$mouseUp($views, $upPos, $upTime, $downTime, 'onTouchEnd', x, y);
      $moveMouseOutsideInNextFrame._v = true;
    } else {
      prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', x, y, true);
    }
  }
  function prepareViewsBase$gamepadUpdated($input, e) {
    var tmp0_fastForEach_0 = e._gamepads;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0.length) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0[tmp0_2];
      $input._gamepads_1[tmp1__anonymous__3._index_16].copyFrom_6(tmp1__anonymous__3);
    }
    $input.updateConnectedGamepads();
  }
  function _no_name_provided__341($module, $config, resultContinuation) {
    this._$module = $module;
    this._$config = $config;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__341.prototype.invoke_584 = function ($this$invoke, $cont) {
    var tmp = this.create_32($this$invoke, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__341.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_584(p1 instanceof Stage ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__341.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            var tmp_0 = RegisteredImageFormats_getInstance();
            var tmp_1 = this;
            tmp_1._tmp0_toTypedArray_00 = this._$module._get_imageFormats__1();
            tmp_0.register_3(copyToArray_0(this._tmp0_toTypedArray_00).slice());
            this._injector1 = this._$config._injector_2;
            this._injector1.mapInstance(getKClass_0(Module), this._$module).mapInstance(getKClass_0(Config), this._$config);
            Unit_getInstance();
            this._$config._constructedViews(this._$this$invoke._views_8);
            this._state_1 = 1;
            suspendResult = this._$module.configure_1(this._injector1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            var tmp_2 = this;
            tmp_2._sc2 = SceneContainer_init_$Create$(this._$this$invoke._views_8, null, 'rootSceneContainer', 2, null);
            var tmp0_this = this._$this$invoke._views_8;
            tmp0_this._stage_0.plusAssign_12(this._sc2);
            this._state_1 = 2;
            var tmp_3 = this;
            tmp_3._tmp1_toTypedArray_03 = this._$config._sceneInjects;
            var tmp_4 = copyToArray_0(this._tmp1_toTypedArray_03).slice();
            var tmp_5 = this;
            tmp_5._tmp2__get_milliseconds__04 = 0;
            var tmp_6 = Companion_getInstance_27().fromMilliseconds(this._tmp2__get_milliseconds__04);
            suspendResult = this._sc2.changeTo$default(this._$config._sceneClass, tmp_4, tmp_6, null, 8, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            Unit_getInstance();
            this._$this$invoke._views_8.onClose(_no_name_provided_$factory_302(this._sc2, null));
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__341.prototype.create_32 = function ($this$invoke, completion) {
    var i = new _no_name_provided__341(this._$module, this._$config, completion);
    i._$this$invoke = $this$invoke;
    return i;
  };
  _no_name_provided__341.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__342($realGameWindow, $width, $height, $title, $icon, $fullscreen, $iconDrawable, $iconPath, $imageFormats, $quality, $injector, $debugAg, $timeProvider, $gameId, $settingsFolder, $batchMaxQuads, $args, $virtualWidth, $virtualHeight, $debug, $scaleAnchor, $scaleMode, $clipBorders, $targetFps, $bgcolor, $blocking, $entry, resultContinuation) {
    this._$realGameWindow = $realGameWindow;
    this._$width_3 = $width;
    this._$height_3 = $height;
    this._$title_0 = $title;
    this._$icon = $icon;
    this._$fullscreen_0 = $fullscreen;
    this._$iconDrawable = $iconDrawable;
    this._$iconPath = $iconPath;
    this._$imageFormats = $imageFormats;
    this._$quality = $quality;
    this._$injector = $injector;
    this._$debugAg = $debugAg;
    this._$timeProvider = $timeProvider;
    this._$gameId = $gameId;
    this._$settingsFolder = $settingsFolder;
    this._$batchMaxQuads = $batchMaxQuads;
    this._$args = $args;
    this._$virtualWidth_0 = $virtualWidth;
    this._$virtualHeight_0 = $virtualHeight;
    this._$debug = $debug;
    this._$scaleAnchor = $scaleAnchor;
    this._$scaleMode = $scaleMode;
    this._$clipBorders = $clipBorders;
    this._$targetFps = $targetFps;
    this._$bgcolor = $bgcolor;
    this._$blocking_1 = $blocking;
    this._$entry_3 = $entry;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__342.prototype.invoke_586 = function ($this$loop, $cont) {
    var tmp = this.create_33($this$loop, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__342.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_586(p1 instanceof GameWindow ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__342.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 8;
            this._gameWindow0 = this._$this$loop;
            if (OS_getInstance()._get_isNative_())
              println('Korui[0]');
            configure(this._$realGameWindow, this._$width_3, this._$height_3, this._$title_0, this._$icon, this._$fullscreen_0);
            this._exceptionState = 3;
            if (!(this._$iconDrawable == null)) {
              this._$this$loop._set_icon__1(render(this._$iconDrawable));
              this._state_1 = 2;
              continue $sm;
            } else {
              if (!(this._$iconPath == null)) {
                this._state_1 = 1;
                var tmp_0 = _get_resourcesVfs_().get_115(ensureNotNull(this._$iconPath));
                suspendResult = readBitmapOptimized$default(tmp_0, this._$imageFormats, false, 2, null, this);
                if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                  return suspendResult;
                }continue $sm;
              } else {
                Unit_getInstance();
                this._state_1 = 2;
                continue $sm;
              }
            }

            break;
          case 1:
            this._ARGUMENT1_11 = suspendResult;
            this._$this$loop._set_icon__1(this._ARGUMENT1_11);
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._exceptionState = 8;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._exceptionState = 8;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              this._e2 = this._exception_0;
              var tmp0_error_0 = Korge_getInstance()._logger;
              var tmp0_log_0_1 = Level_ERROR_getInstance();
              if (tmp0_error_0.isEnabled_0(tmp0_log_0_1)) {
                tmp0_error_0.actualLog(tmp0_log_0_1, "Couldn't get the application icon");
              }printStackTrace(this._e2);
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 8;
            this._$this$loop._set_quality__1(this._$quality);
            if (OS_getInstance()._get_isNative_())
              println('CanvasApplicationEx.IN[0]');
            this._input3 = new Input();
            this._stats4 = new Stats();
            var tmp_2 = this;
            var tmp_3 = this._get_context__296().plus_36(this._gameWindow0._get_coroutineDispatcher__1()).plus_36(new AsyncInjectorContext(this._$injector));
            var tmp_4 = tmp_3.plus_36(SupervisorJob$default(null, 1, null));
            var tmp_5;
            if (this._$debugAg) {
              tmp_5 = PrintAG_init_$Create$(0, 0, 3, null);
            } else {
              tmp_5 = this._$this$loop._get_ag__1();
            }

            tmp_2._views5 = new Views(tmp_4, tmp_5, this._$injector, this._input3, this._$timeProvider, this._stats4, this._gameWindow0, this._$gameId, this._$settingsFolder, this._$batchMaxQuads);
            if (OS_getInstance()._get_isJsBrowser_()) {
              var tmp_6 = this;
              tmp_6._tmp1_invoke_06 = Companion_getInstance_46();
              var tmp_7 = this;
              tmp_7._tmp2__anonymous__17 = Companion_getInstance_46();
              this._tmp2__anonymous__17.set_14(this._tmp2__anonymous__17._get_global__4(), 'views', this._views5);
            }
            var tmp3_mapInstance_0 = new ModuleArgs(this._$args);
            var tmp4_mapInstance_0 = this._$injector.mapInstance(getKClass_0(ModuleArgs), tmp3_mapInstance_0).mapInstance(getKClass_0(GameWindow), this._gameWindow0);
            var tmp5_mapInstance_0 = new _no_name_provided__338(this._$title_0, this._$fullscreen_0, this._$width_3, this._$height_3, this._$virtualWidth_0, this._$virtualHeight_0);
            tmp4_mapInstance_0.mapInstance(getKClass_0(Module), tmp5_mapInstance_0);
            Unit_getInstance();
            this._views5._debugViews = this._$debug;
            this._views5._virtualWidth_0 = this._$virtualWidth_0;
            this._views5._virtualHeight_0 = this._$virtualHeight_0;
            this._views5._scaleAnchor_1 = this._$scaleAnchor;
            this._views5._scaleMode_4 = this._$scaleMode;
            this._views5._clipBorders_1 = this._$clipBorders;
            this._views5._targetFps_1 = this._$targetFps;
            this._state_1 = 5;
            var tmp_8 = Korge_getInstance();
            var tmp_9 = this._$bgcolor;
            var tmp_10 = !((tmp_9 == null ? null : new RGBA(tmp_9)) == null);
            var tmp0_elvis_lhs = this._$bgcolor;
            var tmp_11;
            var tmp_12 = tmp0_elvis_lhs;
            if ((tmp_12 == null ? null : new RGBA(tmp_12)) == null) {
              tmp_11 = Colors_getInstance()._TRANSPARENT_BLACK;
            } else {
              {
                tmp_11 = tmp0_elvis_lhs;
              }
            }

            var tmp_13 = tmp_11;
            suspendResult = tmp_8.prepareViews$default(this._views5, this._gameWindow0, tmp_10, tmp_13, null, true, 16, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            suspendResult;
            _get_nativeSoundProvider_().initOnce_0();
            completeViews(this._views5);
            launchImmediately_0(this._views5, _no_name_provided_$factory_304(this._$entry_3, this._views5, this._$blocking_1, this._gameWindow0, null));
            Unit_getInstance();
            if (OS_getInstance()._get_isNative_())
              println('CanvasApplicationEx.IN[1]');
            if (OS_getInstance()._get_isNative_())
              println('Korui[1]');
            if (this._$blocking_1) {
              this._state_1 = 6;
              suspendResult = this._gameWindow0.waitClose_1(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 7;
              continue $sm;
            }

            break;
          case 6:
            suspendResult;
            this._gameWindow0.exit_1();
            this._state_1 = 7;
            continue $sm;
          case 7:
            return Unit_getInstance();
          case 8:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 8) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__342.prototype.create_33 = function ($this$loop, completion) {
    var i = new _no_name_provided__342(this._$realGameWindow, this._$width_3, this._$height_3, this._$title_0, this._$icon, this._$fullscreen_0, this._$iconDrawable, this._$iconPath, this._$imageFormats, this._$quality, this._$injector, this._$debugAg, this._$timeProvider, this._$gameId, this._$settingsFolder, this._$batchMaxQuads, this._$args, this._$virtualWidth_0, this._$virtualHeight_0, this._$debug, this._$scaleAnchor, this._$scaleMode, this._$clipBorders, this._$targetFps, this._$bgcolor, this._$blocking_1, this._$entry_3, completion);
    i._$this$loop = $this$loop;
    return i;
  };
  _no_name_provided__342.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__343(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__343.prototype.invoke_994 = function ($this$mapSingleton, $cont) {
    var tmp = this.create_99($this$mapSingleton, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__343.prototype.invoke_1015 = function (p1, $cont) {
    return this.invoke_994(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__343.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          return new ResourcesRoot();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__343.prototype.create_99 = function ($this$mapSingleton, completion) {
    var i = new _no_name_provided__343(completion);
    i._$this$mapSingleton = $this$mapSingleton;
    return i;
  };
  _no_name_provided__343.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__344(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__344.prototype.invoke_994 = function ($this$mapPrototype, $cont) {
    var tmp = this.create_99($this$mapPrototype, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__344.prototype.invoke_1015 = function (p1, $cont) {
    return this.invoke_994(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__344.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          return new EmptyScene();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__344.prototype.create_99 = function ($this$mapPrototype, completion) {
    var i = new _no_name_provided__344(completion);
    i._$this$mapPrototype = $this$mapPrototype;
    return i;
  };
  _no_name_provided__344.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__345($views, $ag, $downPos, $downTime, $upPos, $upTime, $moveTime, $moveMouseOutsideInNextFrame) {
    this._$views_2 = $views;
    this._$ag = $ag;
    this._$downPos = $downPos;
    this._$downTime = $downTime;
    this._$upPos = $upPos;
    this._$upTime = $upTime;
    this._$moveTime = $moveTime;
    this._$moveMouseOutsideInNextFrame = $moveMouseOutsideInNextFrame;
  }
  _no_name_provided__345.prototype.invoke_592 = function (e) {
    var tmp0_trace_0 = Korge_getInstance()._logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_0(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog(tmp0_log_0_1, '' + 'eventDispatcher.addEventListener<MouseEvent>:' + e);
    }var x = prepareViewsBase$getRealX(this._$ag, e._x_12, e._scaleCoords);
    var y = prepareViewsBase$getRealY(this._$ag, e._y_11, e._scaleCoords);
    var tmp0_subject = e._type_7;
    if (tmp0_subject.equals(Type_DOWN_getInstance())) {
      prepareViewsBase$mouseDown(this._$views_2, this._$downPos, this._$downTime, 'mouseDown', x, y);
    } else if (tmp0_subject.equals(Type_UP_getInstance())) {
      prepareViewsBase$mouseUp(this._$views_2, this._$upPos, this._$upTime, this._$downTime, 'mouseUp', x, y);
    } else if (tmp0_subject.equals(Type_DRAG_getInstance())) {
      prepareViewsBase$mouseDrag(this._$views_2, this._$moveTime, 'onMouseDrag', x, y);
    } else if (tmp0_subject.equals(Type_MOVE_getInstance()))
      prepareViewsBase$mouseMove(this._$views_2, this._$moveMouseOutsideInNextFrame, this._$moveTime, 'mouseMove', x, y, true);
    else if (tmp0_subject.equals(Type_CLICK_getInstance()))
      Unit_getInstance();
    else if (tmp0_subject.equals(Type_ENTER_getInstance()))
      prepareViewsBase$mouseMove(this._$views_2, this._$moveMouseOutsideInNextFrame, this._$moveTime, 'mouseEnter', x, y, true);
    else if (tmp0_subject.equals(Type_EXIT_getInstance()))
      prepareViewsBase$mouseMove(this._$views_2, this._$moveMouseOutsideInNextFrame, this._$moveTime, 'mouseExit', x, y, false);
    else if (tmp0_subject.equals(Type_SCROLL_getInstance()))
      Unit_getInstance();
    this._$views_2.dispatch_16(getKClass_0(MouseEvent_0), e);
  };
  _no_name_provided__345.prototype.invoke_1015 = function (p1) {
    this.invoke_592(p1 instanceof MouseEvent_0 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__345.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__346($views) {
    this._$views_3 = $views;
  }
  _no_name_provided__346.prototype.invoke_594 = function (e) {
    var tmp0_trace_0 = Korge_getInstance()._logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_0(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog(tmp0_log_0_1, '' + 'eventDispatcher.addEventListener<KeyEvent>:' + e);
    }this._$views_3.dispatch_16(getKClass_0(KeyEvent), e);
  };
  _no_name_provided__346.prototype.invoke_1015 = function (p1) {
    this.invoke_594(p1 instanceof KeyEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__346.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__347($views) {
    this._$views_4 = $views;
  }
  _no_name_provided__347.prototype.invoke_596 = function (e) {
    this._$views_4.dispatch_16(getKClass_0(ResumeEvent), e);
  };
  _no_name_provided__347.prototype.invoke_1015 = function (p1) {
    this.invoke_596(p1 instanceof ResumeEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__347.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__348($views) {
    this._$views_5 = $views;
  }
  _no_name_provided__348.prototype.invoke_598 = function (e) {
    this._$views_5.dispatch_16(getKClass_0(PauseEvent), e);
  };
  _no_name_provided__348.prototype.invoke_1015 = function (p1) {
    this.invoke_598(p1 instanceof PauseEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__348.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__349($views) {
    this._$views_6 = $views;
  }
  _no_name_provided__349.prototype.invoke_600 = function (e) {
    this._$views_6.dispatch_16(getKClass_0(StopEvent), e);
  };
  _no_name_provided__349.prototype.invoke_1015 = function (p1) {
    this.invoke_600(p1 instanceof StopEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__349.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__350($views) {
    this._$views_7 = $views;
  }
  _no_name_provided__350.prototype.invoke_602 = function (e) {
    try {
      this._$views_7.dispatch_16(getKClass_0(DestroyEvent), e);
    }finally {
      launchImmediately_0(this._$views_7, _no_name_provided_$factory_305(this._$views_7, null));
      Unit_getInstance();
    }
  };
  _no_name_provided__350.prototype.invoke_1015 = function (p1) {
    this.invoke_602(p1 instanceof DestroyEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__350.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__351($views, $ag, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $upTime, $moveTime) {
    this._$views_8 = $views;
    this._$ag_0 = $ag;
    this._$moveMouseOutsideInNextFrame_0 = $moveMouseOutsideInNextFrame;
    this._$downPos_0 = $downPos;
    this._$downTime_0 = $downTime;
    this._$upPos_0 = $upPos;
    this._$upTime_0 = $upTime;
    this._$moveTime_0 = $moveTime;
  }
  _no_name_provided__351.prototype.invoke_604 = function (e) {
    var tmp0_trace_0 = Korge_getInstance()._logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_0(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog(tmp0_log_0_1, '' + 'eventDispatcher.addEventListener<TouchEvent>:' + e);
    }var touch = first(e._get_touches_());
    var ix = numberToInt(prepareViewsBase$getRealX(this._$ag_0, touch._x_15, e._scaleCoords_0));
    var iy = numberToInt(prepareViewsBase$getRealX(this._$ag_0, touch._y_14, e._scaleCoords_0));
    var tmp0_subject = e._type_11;
    if (tmp0_subject.equals(Type_START_getInstance())) {
      prepareViewsBase$touch(this._$moveMouseOutsideInNextFrame_0, this._$views_8, this._$downPos_0, this._$downTime_0, this._$upPos_0, this._$upTime_0, this._$moveTime_0, e, true, false);
      var tmp = Type_DOWN_getInstance();
      var tmp_0 = MouseButton_LEFT_getInstance();
      var tmp1_dispatch_0 = MouseEvent_init_$Create$(tmp, 0, ix, iy, tmp_0, 1, 0.0, 0.0, 0.0, false, false, false, false, false, 16320, null);
      this._$views_8.dispatch_16(getKClass_0(MouseEvent_0), tmp1_dispatch_0);
    } else if (tmp0_subject.equals(Type_MOVE_getInstance_0())) {
      prepareViewsBase$touch(this._$moveMouseOutsideInNextFrame_0, this._$views_8, this._$downPos_0, this._$downTime_0, this._$upPos_0, this._$upTime_0, this._$moveTime_0, e, false, false);
      var tmp_1 = Type_DRAG_getInstance();
      var tmp_2 = MouseButton_LEFT_getInstance();
      var tmp2_dispatch_0 = MouseEvent_init_$Create$(tmp_1, 0, ix, iy, tmp_2, 1, 0.0, 0.0, 0.0, false, false, false, false, false, 16320, null);
      this._$views_8.dispatch_16(getKClass_0(MouseEvent_0), tmp2_dispatch_0);
    } else if (tmp0_subject.equals(Type_END_getInstance())) {
      prepareViewsBase$touch(this._$moveMouseOutsideInNextFrame_0, this._$views_8, this._$downPos_0, this._$downTime_0, this._$upPos_0, this._$upTime_0, this._$moveTime_0, e, false, true);
      var tmp_3 = Type_UP_getInstance();
      var tmp_4 = MouseButton_LEFT_getInstance();
      var tmp3_dispatch_0 = MouseEvent_init_$Create$(tmp_3, 0, ix, iy, tmp_4, 0, 0.0, 0.0, 0.0, false, false, false, false, false, 16320, null);
      this._$views_8.dispatch_16(getKClass_0(MouseEvent_0), tmp3_dispatch_0);
    }this._$views_8.dispatch_16(getKClass_0(TouchEvent_0), e);
  };
  _no_name_provided__351.prototype.invoke_1015 = function (p1) {
    this.invoke_604(p1 instanceof TouchEvent_0 ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__351.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__352($views) {
    this._$views_9 = $views;
  }
  _no_name_provided__352.prototype.invoke_606 = function (e) {
    var tmp0_trace_0 = Korge_getInstance()._logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_0(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog(tmp0_log_0_1, '' + 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e);
    }this._$views_9.dispatch_16(getKClass_0(GamePadConnectionEvent), e);
  };
  _no_name_provided__352.prototype.invoke_1015 = function (p1) {
    this.invoke_606(p1 instanceof GamePadConnectionEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__352.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__353($views, $input) {
    this._$views_10 = $views;
    this._$input_0 = $input;
  }
  _no_name_provided__353.prototype.invoke_608 = function (e) {
    prepareViewsBase$gamepadUpdated(this._$input_0, e);
    this._$views_10.dispatch_16(getKClass_0(GamePadUpdateEvent), e);
  };
  _no_name_provided__353.prototype.invoke_1015 = function (p1) {
    this.invoke_608(p1 instanceof GamePadUpdateEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__353.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__354($views, $ag) {
    this._$views_11 = $views;
    this._$ag_1 = $ag;
  }
  _no_name_provided__354.prototype.invoke_610 = function (e) {
    this._$views_11.resized_5(this._$ag_1._get_backWidth__4(), this._$ag_1._get_backHeight__4());
  };
  _no_name_provided__354.prototype.invoke_1015 = function (p1) {
    this.invoke_610(p1 instanceof ReshapeEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__354.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__355($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
    this._$views_12 = $views;
    this._$renderShown = $renderShown;
    this._$firstRenderDeferred = $firstRenderDeferred;
    this._$fixedSizeStep = $fixedSizeStep;
    this._$moveMouseOutsideInNextFrame_1 = $moveMouseOutsideInNextFrame;
  }
  _no_name_provided__355.prototype.invoke_612 = function (it) {
    var tmp0_doRender_0 = this._$views_12._ag_6;
    tmp0_doRender_0.beforeDoRender_4();
    tmp0_doRender_0._get_mainRenderBuffer__4().init_15();
    var tmp0_setRenderBufferTemporally_0_1 = tmp0_doRender_0._get_mainRenderBuffer__4();
    var old_1_2 = tmp0_doRender_0.setRenderBuffer_4(tmp0_setRenderBufferTemporally_0_1);
    try {
      if (!this._$renderShown._v) {
        this._$renderShown._v = true;
        this._$firstRenderDeferred.complete_1(Unit_getInstance());
        Unit_getInstance();
      }try {
        this._$views_12.frameUpdateAndRender(this._$fixedSizeStep);
        if (this._$moveMouseOutsideInNextFrame_1._v) {
          this._$moveMouseOutsideInNextFrame_1._v = false;
          this._$views_12._input_0._mouseInside = false;
          this._$views_12.mouseUpdated();
        }} catch ($p) {
        if ($p instanceof Error) {
          printStackTrace($p);
        } else {
          {
            throw $p;
          }
        }
      }
    }finally {
      tmp0_doRender_0.setRenderBuffer_4(old_1_2);
      Unit_getInstance();
    }
  };
  _no_name_provided__355.prototype.invoke_1015 = function (p1) {
    this.invoke_612(p1 instanceof RenderEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__355.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $invokeCOROUTINE$0(_this_, config, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__149 = _this_;
    this._config_4 = config;
  }
  $invokeCOROUTINE$0.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._module0 = this._config_4._module;
            this._windowSize1 = this._module0._get_windowSize__1();
            this._tmp0_title2 = this._module0._get_title__1();
            this._tmp1_width3 = _SizeInt___get_width__impl_(this._windowSize1);
            this._tmp2_height4 = _SizeInt___get_height__impl_(this._windowSize1);
            this._tmp3_virtualWidth5 = _SizeInt___get_width__impl_(this._module0._get_size__61());
            this._tmp4_virtualHeight6 = _SizeInt___get_height__impl_(this._module0._get_size__61());
            this._tmp5_bgcolor7 = this._module0._get_bgcolor__1();
            this._tmp6_quality8 = this._module0._get_quality__1();
            this._tmp7_iconPath9 = this._module0._get_icon__1();
            this._tmp8_iconDrawable10 = this._module0._get_iconImage__1();
            this._tmp9_imageFormats11 = new ImageFormats(this._module0._get_imageFormats__1());
            this._tmp10_targetFps12 = this._module0._get_targetFps__1();
            this._tmp11_scaleAnchor13 = this._module0._get_scaleAnchor__1();
            this._tmp12_scaleMode14 = this._module0._get_scaleMode__1();
            this._tmp13_clipBorders15 = this._module0._get_clipBorders__1();
            this._tmp14_debug16 = this._config_4._debug_2;
            this._tmp15_fullscreen17 = this._module0._get_fullscreen__2();
            this._tmp16_args18 = this._config_4._args;
            this._tmp17_gameWindow19 = this._config_4._gameWindow;
            this._tmp18_injector20 = this._config_4._injector_2;
            this._tmp19_timeProvider21 = this._config_4._timeProvider;
            this._tmp20_blocking22 = this._config_4._blocking;
            this._tmp21_gameId23 = this._config_4._gameId;
            this._tmp22_settingsFolder24 = this._config_4._settingsFolder;
            this._tmp23_batchMaxQuads25 = this._config_4._batchMaxQuads;
            this._state_1 = 1;
            var tmp_0 = Korge_getInstance();
            suspendResult = tmp_0.invoke$default_4(this._tmp0_title2, this._tmp1_width3, this._tmp2_height4, this._tmp3_virtualWidth5, this._tmp4_virtualHeight6, null, this._tmp7_iconPath9, this._tmp8_iconDrawable10, this._tmp9_imageFormats11, this._tmp6_quality8, this._tmp10_targetFps12, this._tmp11_scaleAnchor13, this._tmp12_scaleMode14, this._tmp13_clipBorders15, this._tmp5_bgcolor7, this._tmp14_debug16, this._tmp15_fullscreen17, this._tmp16_args18, this._tmp17_gameWindow19, this._tmp19_timeProvider21, this._tmp18_injector20, false, this._tmp20_blocking22, this._tmp21_gameId23, this._tmp22_settingsFolder24, this._tmp23_batchMaxQuads25, _no_name_provided_$factory_306(this._module0, this._config_4, null), 2097152, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $invokeCOROUTINE$0.$metadata$ = {
    simpleName: '$invokeCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function $invokeCOROUTINE$1(_this_, title, width, height, virtualWidth, virtualHeight, icon, iconPath, iconDrawable, imageFormats, quality, targetFps, scaleAnchor, scaleMode, clipBorders, bgcolor, debug, fullscreen, args, gameWindow, timeProvider, injector, debugAg, blocking, gameId, settingsFolder, batchMaxQuads, entry, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__150 = _this_;
    this._title_0 = title;
    this._width_15 = width;
    this._height_15 = height;
    this._virtualWidth = virtualWidth;
    this._virtualHeight = virtualHeight;
    this._icon_1 = icon;
    this._iconPath = iconPath;
    this._iconDrawable = iconDrawable;
    this._imageFormats_0 = imageFormats;
    this._quality_2 = quality;
    this._targetFps = targetFps;
    this._scaleAnchor = scaleAnchor;
    this._scaleMode_1 = scaleMode;
    this._clipBorders = clipBorders;
    this._bgcolor = bgcolor;
    this._debug_3 = debug;
    this._fullscreen_3 = fullscreen;
    this._args_1 = args;
    this._gameWindow_0 = gameWindow;
    this._timeProvider_0 = timeProvider;
    this._injector_3 = injector;
    this._debugAg = debugAg;
    this._blocking_0 = blocking;
    this._gameId_0 = gameId;
    this._settingsFolder_0 = settingsFolder;
    this._batchMaxQuads_0 = batchMaxQuads;
    this._entry_3 = entry;
  }
  $invokeCOROUTINE$1.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            if (!OS_getInstance()._get_isJsBrowser_()) {
              this._state_1 = 1;
              suspendResult = configureLoggerFromProperties(_get_localCurrentDirVfs_().get_115('klogger.properties'), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            var tmp_0 = this;
            var tmp0_elvis_lhs = this._gameWindow_0;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              tmp_1 = this._get_context__296().get_113(CoroutineKey_getInstance());
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            var tmp1_elvis_lhs = tmp_1;
            tmp_0._realGameWindow0 = tmp1_elvis_lhs == null ? CreateDefaultGameWindow() : tmp1_elvis_lhs;
            this._state_1 = 3;
            suspendResult = this._realGameWindow0.loop_2(_no_name_provided_$factory_307(this._realGameWindow0, this._width_15, this._height_15, this._title_0, this._icon_1, this._fullscreen_3, this._iconDrawable, this._iconPath, this._imageFormats_0, this._quality_2, this._injector_3, this._debugAg, this._timeProvider_0, this._gameId_0, this._settingsFolder_0, this._batchMaxQuads_0, this._args_1, this._virtualWidth, this._virtualHeight, this._debug_3, this._scaleAnchor, this._scaleMode_1, this._clipBorders, this._targetFps, this._bgcolor, this._blocking_0, this._entry_3, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $invokeCOROUTINE$1.$metadata$ = {
    simpleName: '$invokeCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function $prepareViewsCOROUTINE$3(_this_, views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__151 = _this_;
    this._views = views;
    this._eventDispatcher = eventDispatcher;
    this._clearEachFrame = clearEachFrame;
    this._bgcolor_0 = bgcolor;
    this._fixedSizeStep = fixedSizeStep;
    this._waitForFirstRender = waitForFirstRender;
  }
  $prepareViewsCOROUTINE$3.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._firstRenderDeferred0 = this.__this__151.prepareViewsBase(this._views, this._eventDispatcher, this._clearEachFrame, this._bgcolor_0, this._fixedSizeStep);
            if (this._waitForFirstRender) {
              this._state_1 = 1;
              suspendResult = this._firstRenderDeferred0.await_3(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $prepareViewsCOROUTINE$3.$metadata$ = {
    simpleName: '$prepareViewsCOROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function Korge() {
    Korge_instance = this;
    this._logger = Companion_getInstance_39().invoke_203('Korge');
    this._DEFAULT_GAME_ID = 'com.soywiz.korge.unknown';
  }
  Korge.prototype.invoke_614 = function (config, $cont) {
    var tmp = new $invokeCOROUTINE$0(this, config, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Korge.prototype.invoke_615 = function (title, width, height, virtualWidth, virtualHeight, icon, iconPath, iconDrawable, imageFormats, quality, targetFps, scaleAnchor, scaleMode, clipBorders, bgcolor, debug, fullscreen, args, gameWindow, timeProvider, injector, debugAg, blocking, gameId, settingsFolder, batchMaxQuads, entry, $cont) {
    var tmp = new $invokeCOROUTINE$1(this, title, width, height, virtualWidth, virtualHeight, icon, iconPath, iconDrawable, imageFormats, quality, targetFps, scaleAnchor, scaleMode, clipBorders, bgcolor, debug, fullscreen, args, gameWindow, timeProvider, injector, debugAg, blocking, gameId, settingsFolder, batchMaxQuads, entry, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Korge.prototype.invoke$default_4 = function (title, width, height, virtualWidth, virtualHeight, icon, iconPath, iconDrawable, imageFormats, quality, targetFps, scaleAnchor, scaleMode, clipBorders, bgcolor, debug, fullscreen, args, gameWindow, timeProvider, injector, debugAg, blocking, gameId, settingsFolder, batchMaxQuads, entry, $mask0, $handler, $cont) {
    if (!(($mask0 & 1) === 0))
      title = 'Korge';
    if (!(($mask0 & 2) === 0))
      width = 1280;
    if (!(($mask0 & 4) === 0))
      height = 720;
    if (!(($mask0 & 8) === 0))
      virtualWidth = width;
    if (!(($mask0 & 16) === 0))
      virtualHeight = height;
    if (!(($mask0 & 32) === 0))
      icon = null;
    if (!(($mask0 & 64) === 0))
      iconPath = null;
    if (!(($mask0 & 128) === 0))
      iconDrawable = null;
    if (!(($mask0 & 256) === 0))
      imageFormats = ImageFormats_init_$Create$([PNG_getInstance()]);
    if (!(($mask0 & 512) === 0))
      quality = Quality_AUTOMATIC_getInstance();
    if (!(($mask0 & 1024) === 0))
      targetFps = 0.0;
    if (!(($mask0 & 2048) === 0))
      scaleAnchor = Companion_getInstance_74()._MIDDLE_CENTER;
    if (!(($mask0 & 4096) === 0))
      scaleMode = Companion_getInstance_85()._SHOW_ALL;
    if (!(($mask0 & 8192) === 0))
      clipBorders = true;
    if (!(($mask0 & 16384) === 0))
      bgcolor = Colors_getInstance()._BLACK;
    if (!(($mask0 & 32768) === 0))
      debug = false;
    if (!(($mask0 & 65536) === 0))
      fullscreen = null;
    if (!(($mask0 & 131072) === 0)) {
      var tmp0_arrayOf_0 = [];
      args = tmp0_arrayOf_0;
    }if (!(($mask0 & 262144) === 0))
      gameWindow = null;
    if (!(($mask0 & 524288) === 0))
      timeProvider = Companion_getInstance_26();
    if (!(($mask0 & 1048576) === 0)) {
      injector = AsyncInjector_init_$Create$(null, 0, 3, null);
    }if (!(($mask0 & 2097152) === 0))
      debugAg = false;
    if (!(($mask0 & 4194304) === 0))
      blocking = true;
    if (!(($mask0 & 8388608) === 0))
      gameId = this._DEFAULT_GAME_ID;
    if (!(($mask0 & 16777216) === 0))
      settingsFolder = null;
    if (!(($mask0 & 33554432) === 0))
      batchMaxQuads = Companion_getInstance_143()._DEFAULT_BATCH_QUADS;
    return this.invoke_615(title, width, height, virtualWidth, virtualHeight, icon, iconPath, iconDrawable, imageFormats, quality, targetFps, scaleAnchor, scaleMode, clipBorders, bgcolor, debug, fullscreen, args, gameWindow, timeProvider, injector, debugAg, blocking, gameId, settingsFolder, batchMaxQuads, entry, $cont);
  };
  Korge.prototype.prepareViewsBase = function (views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep) {
    var injector = views._injector_7;
    injector.mapInstance(getKClass_0(Views), views);
    Unit_getInstance();
    var tmp0_mapInstance_0 = views._ag_6;
    injector.mapInstance(getKClass_0(AG), tmp0_mapInstance_0);
    Unit_getInstance();
    injector.mapInstance(getKClass_0(Resources), views._get_globalResources_());
    Unit_getInstance();
    var tmp = getKClass_0(ResourcesRoot);
    injector.mapSingleton(tmp, _no_name_provided_$factory_288(null));
    Unit_getInstance();
    var tmp1_mapInstance_0 = views._input_0;
    injector.mapInstance(getKClass_0(Input), tmp1_mapInstance_0);
    Unit_getInstance();
    var tmp2_mapInstance_0 = views._stats_0;
    injector.mapInstance(getKClass_0(Stats), tmp2_mapInstance_0);
    Unit_getInstance();
    injector.mapInstance(getKClass_0(CoroutineContext), views._coroutineContext_6);
    Unit_getInstance();
    var tmp_0 = getKClass_0(EmptyScene);
    injector.mapPrototype(tmp_0, _no_name_provided_$factory_289(null));
    Unit_getInstance();
    injector.mapInstance(getKClass_0(TimeProvider), views._timeProvider_1);
    Unit_getInstance();
    var input = views._input_0;
    var ag = views._ag_6;
    var downPos = Companion_getInstance_80().invoke_1005();
    var upPos = Companion_getInstance_80().invoke_1005();
    var downTime = {_v: new DateTime(Companion_getInstance_18()._EPOCH)};
    var moveTime = {_v: new DateTime(Companion_getInstance_18()._EPOCH)};
    var upTime = {_v: new DateTime(Companion_getInstance_18()._EPOCH)};
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    var tmp3_addEventListener_0 = _no_name_provided_$factory_290(views, ag, downPos, downTime, upPos, upTime, moveTime, moveMouseOutsideInNextFrame);
    eventDispatcher.addEventListener_6(getKClass_0(MouseEvent_0), tmp3_addEventListener_0);
    Unit_getInstance();
    var tmp4_addEventListener_0 = _no_name_provided_$factory_291(views);
    eventDispatcher.addEventListener_6(getKClass_0(KeyEvent), tmp4_addEventListener_0);
    Unit_getInstance();
    var tmp5_addEventListener_0 = _no_name_provided_$factory_292(views);
    eventDispatcher.addEventListener_6(getKClass_0(ResumeEvent), tmp5_addEventListener_0);
    Unit_getInstance();
    var tmp6_addEventListener_0 = _no_name_provided_$factory_293(views);
    eventDispatcher.addEventListener_6(getKClass_0(PauseEvent), tmp6_addEventListener_0);
    Unit_getInstance();
    var tmp7_addEventListener_0 = _no_name_provided_$factory_294(views);
    eventDispatcher.addEventListener_6(getKClass_0(StopEvent), tmp7_addEventListener_0);
    Unit_getInstance();
    var tmp8_addEventListener_0 = _no_name_provided_$factory_295(views);
    eventDispatcher.addEventListener_6(getKClass_0(DestroyEvent), tmp8_addEventListener_0);
    Unit_getInstance();
    var tmp9_addEventListener_0 = _no_name_provided_$factory_296(views, ag, moveMouseOutsideInNextFrame, downPos, downTime, upPos, upTime, moveTime);
    eventDispatcher.addEventListener_6(getKClass_0(TouchEvent_0), tmp9_addEventListener_0);
    Unit_getInstance();
    var tmp10_addEventListener_0 = _no_name_provided_$factory_297(views);
    eventDispatcher.addEventListener_6(getKClass_0(GamePadConnectionEvent), tmp10_addEventListener_0);
    Unit_getInstance();
    var tmp11_addEventListener_0 = _no_name_provided_$factory_298(views, input);
    eventDispatcher.addEventListener_6(getKClass_0(GamePadUpdateEvent), tmp11_addEventListener_0);
    Unit_getInstance();
    var tmp12_addEventListener_0 = _no_name_provided_$factory_299(views, ag);
    eventDispatcher.addEventListener_6(getKClass_0(ReshapeEvent), tmp12_addEventListener_0);
    Unit_getInstance();
    var tmp13_dispatch_0 = new ReshapeEvent(0, 0, views._get_nativeWidth_(), views._get_nativeHeight_());
    eventDispatcher.dispatch_16(getKClass_0(ReshapeEvent), tmp13_dispatch_0);
    var renderShown = {_v: false};
    views._clearEachFrame_1 = clearEachFrame;
    views._clearColor = bgcolor;
    var firstRenderDeferred = CompletableDeferred$default(null, 1, null);
    views._gameWindow_1.onRenderEvent_1(_no_name_provided_$factory_300(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  };
  Korge.prototype.prepareViews = function (views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, $cont) {
    var tmp = new $prepareViewsCOROUTINE$3(this, views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Korge.prototype.prepareViews$default = function (views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0))
      clearEachFrame = true;
    if (!(($mask0 & 8) === 0))
      bgcolor = Colors_getInstance()._TRANSPARENT_BLACK;
    if (!(($mask0 & 16) === 0))
      fixedSizeStep = Companion_getInstance_27()._NIL;
    if (!(($mask0 & 32) === 0))
      waitForFirstRender = true;
    return this.prepareViews(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, waitForFirstRender, $cont);
  };
  Korge.$metadata$ = {
    simpleName: 'Korge',
    kind: 'object',
    interfaces: []
  };
  var Korge_instance;
  function Korge_getInstance() {
    if (Korge_instance == null)
      new Korge();
    return Korge_instance;
  }
  function _no_name_provided_$factory_288(resultContinuation) {
    var i = new _no_name_provided__343(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_994(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_289(resultContinuation) {
    var i = new _no_name_provided__344(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_994(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_290($views, $ag, $downPos, $downTime, $upPos, $upTime, $moveTime, $moveMouseOutsideInNextFrame) {
    var i = new _no_name_provided__345($views, $ag, $downPos, $downTime, $upPos, $upTime, $moveTime, $moveMouseOutsideInNextFrame);
    return function (p1) {
      i.invoke_592(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_291($views) {
    var i = new _no_name_provided__346($views);
    return function (p1) {
      i.invoke_594(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_292($views) {
    var i = new _no_name_provided__347($views);
    return function (p1) {
      i.invoke_596(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_293($views) {
    var i = new _no_name_provided__348($views);
    return function (p1) {
      i.invoke_598(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_294($views) {
    var i = new _no_name_provided__349($views);
    return function (p1) {
      i.invoke_600(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_295($views) {
    var i = new _no_name_provided__350($views);
    return function (p1) {
      i.invoke_602(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_296($views, $ag, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $upTime, $moveTime) {
    var i = new _no_name_provided__351($views, $ag, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $upTime, $moveTime);
    return function (p1) {
      i.invoke_604(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_297($views) {
    var i = new _no_name_provided__352($views);
    return function (p1) {
      i.invoke_606(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_298($views, $input) {
    var i = new _no_name_provided__353($views, $input);
    return function (p1) {
      i.invoke_608(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_299($views, $ag) {
    var i = new _no_name_provided__354($views, $ag);
    return function (p1) {
      i.invoke_610(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_300($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
    var i = new _no_name_provided__355($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame);
    return function (p1) {
      i.invoke_612(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_301() {
    var i = new _no_name_provided__335();
    return function (p1) {
      i.invoke_574(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_302($sc, resultContinuation) {
    var i = new _no_name_provided__336($sc, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_303($entry, $views, $blocking, $gameWindow, resultContinuation) {
    var i = new _no_name_provided__337($entry, $views, $blocking, $gameWindow, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_729(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_304($entry, $views, $blocking, $gameWindow, resultContinuation) {
    var i = new _no_name_provided__339($entry, $views, $blocking, $gameWindow, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_305($views, resultContinuation) {
    var i = new _no_name_provided__340($views, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_306($module, $config, resultContinuation) {
    var i = new _no_name_provided__341($module, $config, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_584(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_307($realGameWindow, $width, $height, $title, $icon, $fullscreen, $iconDrawable, $iconPath, $imageFormats, $quality, $injector, $debugAg, $timeProvider, $gameId, $settingsFolder, $batchMaxQuads, $args, $virtualWidth, $virtualHeight, $debug, $scaleAnchor, $scaleMode, $clipBorders, $targetFps, $bgcolor, $blocking, $entry, resultContinuation) {
    var i = new _no_name_provided__342($realGameWindow, $width, $height, $title, $icon, $fullscreen, $iconDrawable, $iconPath, $imageFormats, $quality, $injector, $debugAg, $timeProvider, $gameId, $settingsFolder, $batchMaxQuads, $args, $virtualWidth, $virtualHeight, $debug, $scaleAnchor, $scaleMode, $clipBorders, $targetFps, $bgcolor, $blocking, $entry, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_586(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  var animateLibraryLoaders$delegate;
  function Companion_139() {
    Companion_instance_138 = this;
  }
  Companion_139.prototype.invoke_715 = function (views) {
    return new Context_0(views._coroutineContext_6, views._imageFormats_3);
  };
  Companion_139.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_138;
  function Companion_getInstance_138() {
    if (Companion_instance_138 == null)
      new Companion_139();
    return Companion_instance_138;
  }
  function Context_0(coroutineContext, imageFormats) {
    Companion_getInstance_138();
    this._coroutineContext_4 = coroutineContext;
    this._imageFormats_1 = imageFormats;
  }
  Context_0.prototype.copy_20 = function (coroutineContext, imageFormats) {
    return new Context_0(coroutineContext, imageFormats);
  };
  Context_0.prototype.copy$default_8 = function (coroutineContext, imageFormats, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      coroutineContext = this._coroutineContext_4;
    if (!(($mask0 & 2) === 0))
      imageFormats = this._imageFormats_1;
    return this.copy_20(coroutineContext, imageFormats);
  };
  Context_0.prototype.toString = function () {
    return '' + 'Context(coroutineContext=' + this._coroutineContext_4 + ', imageFormats=' + this._imageFormats_1 + ')';
  };
  Context_0.prototype.hashCode = function () {
    var result = hashCode(this._coroutineContext_4);
    result = imul(result, 31) + hashCode(this._imageFormats_1) | 0;
    return result;
  };
  Context_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Context_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Context_0 ? other : THROW_CCE();
    if (!equals_1(this._coroutineContext_4, tmp0_other_with_cast._coroutineContext_4))
      return false;
    if (!equals_1(this._imageFormats_1, tmp0_other_with_cast._imageFormats_1))
      return false;
    return true;
  };
  Context_0.$metadata$ = {
    simpleName: 'Context',
    kind: 'class',
    interfaces: []
  };
  function AnLibrary(context, width, height, fps) {
    this._context_6 = context;
    this._width_16 = width;
    this._height_16 = height;
    this._fps = fps;
    var tmp = this;
    tmp._$$delegate_0_16 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._fontsCatalog = FontsCatalog_init_$Create$(null, null, 2, null);
    this._msPerFrameDouble = 1000 / this._fps;
    this._msPerFrame = numberToInt(this._msPerFrameDouble);
    this._bgcolor_1 = Colors_getInstance()._WHITE;
    var tmp_1 = this;
    tmp_1._symbolsById = ArrayList_init_$Create$();
    var tmp_2 = this;
    tmp_2._symbolsByName = HashMap_init_$Create$();
    this._defaultSmoothing = true;
  }
  AnLibrary.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_16._extra = _set___;
  };
  AnLibrary.prototype._get_extra__71 = function () {
    return this._$$delegate_0_16._extra;
  };
  AnLibrary.prototype.addSymbol = function (symbol) {
    while (this._symbolsById._get_size__60() <= symbol._id_22) {
      var tmp0_this = this;
      var tmp0_plusAssign_0 = tmp0_this._symbolsById;
      var tmp1_plusAssign_0 = AnSymbolEmpty_getInstance();
      tmp0_plusAssign_0.add_39(tmp1_plusAssign_0);
      Unit_getInstance();
    }
    if (symbol._id_22 >= 0) {
      this._symbolsById.set_8(symbol._id_22, symbol);
      Unit_getInstance();
    }};
  AnLibrary.prototype.processSymbolNames = function () {
    var tmp0_fastForEach_0 = this._symbolsById;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      if (!(tmp1__anonymous__3._name_26 == null)) {
        var tmp0_set_0_4 = this._symbolsByName;
        var tmp1_set_0_5 = ensureNotNull(tmp1__anonymous__3._name_26);
        tmp0_set_0_4.put_18(tmp1_set_0_5, tmp1__anonymous__3);
        Unit_getInstance();
      }}
  };
  AnLibrary.$metadata$ = {
    simpleName: 'AnLibrary',
    kind: 'class',
    interfaces: [Extra]
  };
  function AnSymbol(id, name) {
    this._id_22 = id;
    this._name_26 = name;
    var tmp = this;
    tmp._$$delegate_0_17 = Mixin_init_$Create$(null, 1, null);
  }
  AnSymbol.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_17._extra = _set___;
  };
  AnSymbol.prototype._get_extra__71 = function () {
    return this._$$delegate_0_17._extra;
  };
  AnSymbol.prototype.toString = function () {
    return '' + 'Symbol(id=' + this._id_22 + ', name=' + this._name_26 + ')';
  };
  AnSymbol.$metadata$ = {
    simpleName: 'AnSymbol',
    kind: 'class',
    interfaces: [Extra]
  };
  function AnSymbolEmpty() {
    AnSymbolEmpty_instance = this;
    AnSymbol.call(this, -1, '');
  }
  AnSymbolEmpty.$metadata$ = {
    simpleName: 'AnSymbolEmpty',
    kind: 'object',
    interfaces: []
  };
  var AnSymbolEmpty_instance;
  function AnSymbolEmpty_getInstance() {
    if (AnSymbolEmpty_instance == null)
      new AnSymbolEmpty();
    return AnSymbolEmpty_instance;
  }
  function AnSymbolSound(id, name, inputSound, dataBytes) {
    AnSymbol.call(this, id, name);
    this._inputSound = inputSound;
    this._dataBytes = dataBytes;
    this._nativeSoundCache = new AsyncOnce();
  }
  AnSymbolSound.$metadata$ = {
    simpleName: 'AnSymbolSound',
    kind: 'class',
    interfaces: []
  };
  function AnTextFieldSymbol(id, name, initialHtml, bounds) {
    AnSymbol.call(this, id, name);
    this._initialHtml = initialHtml;
    this._bounds_4 = bounds;
  }
  AnTextFieldSymbol.$metadata$ = {
    simpleName: 'AnTextFieldSymbol',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolShape(id, name, bounds, textureWithBitmap, path_0) {
    AnSymbolBaseShape.call(this, id, name, bounds, path_0);
    this._textureWithBitmap = textureWithBitmap;
  }
  AnSymbolShape.$metadata$ = {
    simpleName: 'AnSymbolShape',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolMorphShape(id, name, bounds, texturesWithBitmap, path_0) {
    AnSymbolBaseShape.call(this, id, name, bounds, path_0);
    this._texturesWithBitmap = texturesWithBitmap;
  }
  AnSymbolMorphShape.$metadata$ = {
    simpleName: 'AnSymbolMorphShape',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolBitmap(id, name, bmp) {
    AnSymbol.call(this, id, name);
    this._bmp_3 = bmp;
  }
  AnSymbolBitmap.$metadata$ = {
    simpleName: 'AnSymbolBitmap',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolMovieClip(id, name, limits) {
    AnSymbol.call(this, id, name);
    this._limits = limits;
    this._ninePatch = null;
    var tmp = this;
    tmp._states = HashMap_init_$Create$();
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = this._limits._totalUids;
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = new AnSymbolUidDef(-1, HashMap_init_$Create$());
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._uidInfo = tmp_3;
  }
  AnSymbolMovieClip.$metadata$ = {
    simpleName: 'AnSymbolMovieClip',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolUidDef(characterId, extraProps) {
    this._characterId = characterId;
    this._extraProps = extraProps;
  }
  AnSymbolUidDef.$metadata$ = {
    simpleName: 'AnSymbolUidDef',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolBaseShape(id, name, bounds, path_0) {
    AnSymbol.call(this, id, name);
    this._bounds_5 = bounds;
    this._path_29 = path_0;
  }
  AnSymbolBaseShape.$metadata$ = {
    simpleName: 'AnSymbolBaseShape',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolLimits(totalDepths, totalFrames, totalUids, totalTime) {
    this._totalDepths = totalDepths;
    this._totalFrames = totalFrames;
    this._totalUids = totalUids;
    this._totalTime = totalTime;
  }
  AnSymbolLimits.$metadata$ = {
    simpleName: 'AnSymbolLimits',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolMovieClipState(name, subTimeline, startTime) {
    this._name_27 = name;
    this._subTimeline = subTimeline;
    this._startTime_1 = startTime;
  }
  AnSymbolMovieClipState.$metadata$ = {
    simpleName: 'AnSymbolMovieClipState',
    kind: 'class',
    interfaces: []
  };
  function AnSymbolMovieClipSubTimeline(totalDepths) {
    var tmp = this;
    var tmp0__get_milliseconds__0 = 0;
    tmp._totalTime_0 = Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = totalDepths;
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = new AnDepthTimeline(tmp_4);
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0._timelines = tmp_3;
    var tmp_5 = this;
    tmp_5._actions_0 = Timed_init_$Create$(0, 1, null);
    this._nextState_0 = null;
    this._nextStatePlay = false;
  }
  AnSymbolMovieClipSubTimeline.$metadata$ = {
    simpleName: 'AnSymbolMovieClipSubTimeline',
    kind: 'class',
    interfaces: []
  };
  function AnDepthTimeline(depth) {
    Timed_init_$Init$(0, 1, null, this);
    this._depth_0 = depth;
  }
  AnDepthTimeline.$metadata$ = {
    simpleName: 'AnDepthTimeline',
    kind: 'class',
    interfaces: []
  };
  function AnAction() {
  }
  AnAction.$metadata$ = {
    simpleName: 'AnAction',
    kind: 'interface',
    interfaces: []
  };
  function Companion_140() {
    Companion_instance_139 = this;
  }
  Companion_140.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_139;
  function Companion_getInstance_139() {
    if (Companion_instance_139 == null)
      new Companion_140();
    return Companion_instance_139;
  }
  function AnSymbolTimelineFrame(depth, uid, clipDepth, ratio, transform, name, colorTransform, blendMode) {
    Companion_getInstance_139();
    this._depth_1 = depth;
    this._uid = uid;
    this._clipDepth = clipDepth;
    this._ratio_1 = ratio;
    this._transform_9 = transform;
    this._name_28 = name;
    this._colorTransform = colorTransform;
    this._blendMode = blendMode;
  }
  AnSymbolTimelineFrame.prototype.toString = function () {
    return '' + 'AnSymbolTimelineFrame(depth=' + this._depth_1 + ', uid=' + this._uid + ', clipDepth=' + this._clipDepth + ', ratio=' + this._ratio_1 + ', transform=' + this._transform_9 + ', name=' + this._name_28 + ', colorTransform=' + this._colorTransform + ', blendMode=' + this._blendMode + ')';
  };
  AnSymbolTimelineFrame.prototype.hashCode = function () {
    var result = this._depth_1;
    result = imul(result, 31) + this._uid | 0;
    result = imul(result, 31) + this._clipDepth | 0;
    result = imul(result, 31) + getNumberHashCode(this._ratio_1) | 0;
    result = imul(result, 31) + this._transform_9.hashCode() | 0;
    result = imul(result, 31) + (this._name_28 == null ? 0 : getStringHashCode(this._name_28)) | 0;
    result = imul(result, 31) + this._colorTransform.hashCode() | 0;
    result = imul(result, 31) + this._blendMode.hashCode() | 0;
    return result;
  };
  AnSymbolTimelineFrame.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnSymbolTimelineFrame))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AnSymbolTimelineFrame ? other : THROW_CCE();
    if (!(this._depth_1 === tmp0_other_with_cast._depth_1))
      return false;
    if (!(this._uid === tmp0_other_with_cast._uid))
      return false;
    if (!(this._clipDepth === tmp0_other_with_cast._clipDepth))
      return false;
    if (!equals_1(this._ratio_1, tmp0_other_with_cast._ratio_1))
      return false;
    if (!this._transform_9.equals(tmp0_other_with_cast._transform_9))
      return false;
    if (!(this._name_28 == tmp0_other_with_cast._name_28))
      return false;
    if (!this._colorTransform.equals(tmp0_other_with_cast._colorTransform))
      return false;
    if (!this._blendMode.equals(tmp0_other_with_cast._blendMode))
      return false;
    return true;
  };
  AnSymbolTimelineFrame.$metadata$ = {
    simpleName: 'AnSymbolTimelineFrame',
    kind: 'class',
    interfaces: []
  };
  function AnPlaySoundAction(soundId) {
    this._soundId = soundId;
  }
  AnPlaySoundAction.prototype.toString = function () {
    return '' + 'AnPlaySoundAction(soundId=' + this._soundId + ')';
  };
  AnPlaySoundAction.prototype.hashCode = function () {
    return this._soundId;
  };
  AnPlaySoundAction.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnPlaySoundAction))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AnPlaySoundAction ? other : THROW_CCE();
    if (!(this._soundId === tmp0_other_with_cast._soundId))
      return false;
    return true;
  };
  AnPlaySoundAction.$metadata$ = {
    simpleName: 'AnPlaySoundAction',
    kind: 'class',
    interfaces: [AnAction]
  };
  function AnEventAction(event) {
    this._event = event;
  }
  AnEventAction.prototype.toString = function () {
    return '' + 'AnEventAction(event=' + this._event + ')';
  };
  AnEventAction.prototype.hashCode = function () {
    return getStringHashCode(this._event);
  };
  AnEventAction.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AnEventAction))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AnEventAction ? other : THROW_CCE();
    if (!(this._event === tmp0_other_with_cast._event))
      return false;
    return true;
  };
  AnEventAction.$metadata$ = {
    simpleName: 'AnEventAction',
    kind: 'class',
    interfaces: [AnAction]
  };
  function _no_name_provided__356(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__356.prototype.invoke_617 = function ($this$$receiver, content, views, $cont) {
    var tmp = this.create_36($this$$receiver, content, views, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__356.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = readAni(this._$this$$receiver, Companion_getInstance_138().invoke_715(this._views_0), this._content_7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__356.prototype.create_36 = function ($this$$receiver, content, views, completion) {
    var i = new _no_name_provided__356(completion);
    i._$this$$receiver = $this$$receiver;
    i._content_7 = content;
    i._views_0 = views;
    return i;
  };
  _no_name_provided__356.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 3
  };
  function _no_name_provided__357(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__357.prototype.invoke_618 = function (s, injector, $cont) {
    var tmp = this.create_37(s, injector, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__357.prototype.invoke_925 = function (p1, p2, $cont) {
    var tmp = p1 instanceof FastByteArrayInputStream ? p1 : THROW_CCE();
    return this.invoke_618(tmp, p2 instanceof AsyncInjector ? p2 : THROW_CCE(), $cont);
  };
  _no_name_provided__357.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          var tmp_0;
          if (this._s_6.readString$default_0(8, null, 2, null) === 'KORGEANI') {
            tmp_0 = new KorgeFileLoader('ani', _no_name_provided_$factory_310(null));
          } else {
            {
              tmp_0 = null;
            }
          }
          return tmp_0;
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__357.prototype.create_37 = function (s, injector, completion) {
    var i = new _no_name_provided__357(completion);
    i._s_6 = s;
    i._injector_4 = injector;
    return i;
  };
  _no_name_provided__357.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 2
  };
  function _no_name_provided__358() {
  }
  _no_name_provided__358.prototype.invoke_1005 = function () {
    return arrayListOf([new KorgeFileLoaderTester('core/ani', _no_name_provided_$factory_309(null))]);
  };
  _no_name_provided__358.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_308() {
    var i = new _no_name_provided__358();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_309(resultContinuation) {
    var i = new _no_name_provided__357(resultContinuation);
    var l = function (p1, p2, $cont) {
      return i.invoke_618(p1, p2, $cont);
    };
    l.$arity = 2;
    return l;
  }
  function _no_name_provided_$factory_310(resultContinuation) {
    var i = new _no_name_provided__356(resultContinuation);
    var l = function (p1, p2, p3, $cont) {
      return i.invoke_617(p1, p2, p3, $cont);
    };
    l.$arity = 3;
    return l;
  }
  function Timed_init_$Init$(initialCapacity, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      initialCapacity = 7;
    Timed.call($this, initialCapacity);
    return $this;
  }
  function Timed_init_$Create$(initialCapacity, $mask0, $marker) {
    return Timed_init_$Init$(initialCapacity, $mask0, $marker, Object.create(Timed.prototype));
  }
  function swap_0($this, a, b) {
    var tempTime = $this._times_1.get_137(b);
    var tempObject = $this._objects.get_137(b);
    $this._times_1.set_35(b, $this._times_1.get_137(a));
    $this._objects.set_8(b, $this._objects.get_137(a));
    Unit_getInstance();
    $this._times_1.set_35(a, tempTime);
    $this._objects.set_8(a, tempObject);
    Unit_getInstance();
  }
  function Timed(initialCapacity) {
    this._times_1 = new IntArrayList(initialCapacity);
    this._objects = ArrayList_init_$Create$_0(initialCapacity);
  }
  Timed.prototype._get_entries__10 = function () {
    return zip(this._times_1, this._objects);
  };
  Timed.prototype._get_int__3 = function (_this__0) {
    return _TimeSpan___get_microsecondsInt__impl_(_this__0);
  };
  Timed.prototype.add_64 = function (time, obj) {
    var time_0 = this._get_int__3(time);
    this._times_1.add_26(time_0);
    this._objects.add_39(obj);
    Unit_getInstance();
    var m = this._times_1._get_size__60() - 2 | 0;
    while (m >= 0 ? time_0 < this._times_1.get_137(m) : false) {
      swap_0(this, m, m + 1 | 0);
      var tmp0 = m;
      m = tmp0 - 1 | 0;
      Unit_getInstance();
    }
  };
  Timed.prototype.toString = function () {
    return '' + 'Timed(' + this._get_entries__10() + ')';
  };
  Timed.$metadata$ = {
    simpleName: 'Timed',
    kind: 'class',
    interfaces: []
  };
  function readAni(_this_, context, content, $cont) {
    var tmp = new $readAniCOROUTINE$6(_this_, context, content, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function ExternalReaders(atlasReader, readSound_0) {
    this._atlasReader = atlasReader;
    this._readSound = readSound_0;
  }
  ExternalReaders.$metadata$ = {
    simpleName: 'ExternalReaders',
    kind: 'class',
    interfaces: []
  };
  function readLibrary(_this_, $this, context, externalReaders, $cont) {
    var tmp = new $readLibraryCOROUTINE$7($this, _this_, context, externalReaders, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function readSymbol(_this_, $this, strings, atlases, sounds) {
    var symbolId = _this_.readU_VL();
    var symbolName = strings[_this_.readU_VL()];
    var type = _this_.readU_VL();
    var tmp0_subject = type;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = AnSymbolEmpty_getInstance();
        break;
      case 1:
        var soundId = _this_.readU_VL();
        tmp = new AnSymbolSound(symbolId, symbolName, sounds.get_137(soundId), null);
        break;
      case 2:
        var initialText = strings[_this_.readU_VL()];
        var bounds = $this.readRect(_this_);
        var tmp1_elvis_lhs = initialText;
        tmp = new AnTextFieldSymbol(symbolId, symbolName, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs, bounds);
        break;
      case 3:
        var scale_1 = _this_.readF32LE();
        var bitmapId = _this_.readU_VL();
        var atlas = atlases.get_137(bitmapId);
        var textureBounds = $this.readIRect(_this_);
        var bounds_0 = $this.readRect(_this_);
        var bitmap = atlas._first;
        var texture = atlas._second;
        var tmp2_subject = _this_.readU_VL();
        var tmp_0;
        switch (tmp2_subject) {
          case 0:
            tmp_0 = null;
            break;
          case 1:
            var cmds = new Int32Array(_this_.readU_VL());
            var inductionVariable = 0;
            var last_1 = cmds.length;
            if (inductionVariable < last_1)
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                cmds[n] = _this_.readU8();
              }
               while (inductionVariable < last_1);
            var data = new Float64Array(_this_.readU_VL());
            var inductionVariable_0 = 0;
            var last_2 = data.length;
            if (inductionVariable_0 < last_2)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                data[n_0] = _this_.readF32LE();
              }
               while (inductionVariable_0 < last_2);
            var tmp_1 = IntArrayList_init_$Create$_0(cmds.slice());
            var tmp_2 = DoubleArrayList_init_$Create$_0(data.slice());
            tmp_0 = VectorPath_init_$Create$(tmp_1, tmp_2, null, 4, null);
            break;
          default:tmp_0 = null;
            break;
        }

        var path_0 = tmp_0;
        var tmp_3 = texture.slice$default(textureBounds, null, 2, null);
        tmp = new AnSymbolShape(symbolId, symbolName, bounds_0, new TextureWithBitmapSlice(tmp_3, slice$default(bitmap, textureBounds, null, 2, null), scale_1, bounds_0), path_0);
        break;
      case 6:
        var nframes = _this_.readU_VL();
        var texturesWithBitmap = new Timed(nframes);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < nframes)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp0__get_milliseconds__0 = _this_.readU_VL();
            var ratio1000 = Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0);
            var scale_2 = _this_.readF32LE();
            var bitmapId_0 = _this_.readU_VL();
            var bounds_1 = $this.readRect(_this_);
            var textureBounds_0 = $this.readIRect(_this_);
            var atlas_0 = atlases.get_137(bitmapId_0);
            var bitmap_0 = atlas_0._first;
            var texture_0 = atlas_0._second;
            var tmp_4 = texture_0.slice$default(textureBounds_0, null, 2, null);
            texturesWithBitmap.add_64(ratio1000, new TextureWithBitmapSlice(tmp_4, slice$default(bitmap_0, textureBounds_0, null, 2, null), scale_2, bounds_1));
          }
           while (inductionVariable_1 < nframes);
        tmp = new AnSymbolMorphShape(symbolId, symbolName, Companion_getInstance_83().invoke_1005(), texturesWithBitmap, null);
        break;
      case 4:
        tmp = new AnSymbolBitmap(symbolId, symbolName, Bitmap32_init_$Create$(1, 1, null, false, 12, null));
        break;
      case 5:
        tmp = readMovieClip(_this_, $this, symbolId, symbolName, strings);
        break;
      default:var tmp1_TODO_0 = '' + 'Type: ' + type;
        throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp1_TODO_0);
    }
    var symbol = tmp;
    return symbol;
  }
  function readMovieClip(_this_, $this, symbolId, symbolName, strings) {
    var mcFlags = _this_.readU8();
    var totalDepths = _this_.readU_VL();
    var totalFrames = _this_.readU_VL();
    var tmp0__get_milliseconds__0 = _this_.readU_VL();
    var totalTime = Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0);
    var totalUids = _this_.readU_VL();
    var tmp1_map_0 = until(0, totalUids);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_map_0, 10));
    var inductionVariable = tmp1_map_0._get_first__6();
    var last_1 = tmp1_map_0._get_last__6();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var charId_5 = _this_.readU_VL();
        var extraPropsString_6 = _this_.readStringVL$default(null, 1, null);
        var tmp;
        if (charSequenceLength(extraPropsString_6) === 0) {
          tmp = LinkedHashMap_init_$Create$();
        } else {
          {
            var tmp_0 = Json_getInstance();
            var tmp_1 = tmp_0.parse$default(extraPropsString_6, null, 2, null);
            tmp = (!(tmp_1 == null) ? isInterface(tmp_1, MutableMap) : false) ? tmp_1 : THROW_CCE();
          }
        }
        var extraProps_7 = tmp;
        tmp0_mapTo_0_1.add_39(new AnSymbolUidDef(charId_5, extraProps_7));
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    var tmp2_toTypedArray_0 = tmp0_mapTo_0_1;
    var uidsToCharacterIds = copyToArray_0(tmp2_toTypedArray_0);
    var mc = new AnSymbolMovieClip(symbolId, symbolName, new AnSymbolLimits(totalDepths, totalFrames, totalUids, totalTime));
    if (extract_0(mcFlags, 0)) {
      mc._ninePatch = $this.readRect(_this_);
    }var tmp3_map_0 = until(0, _this_.readU_VL());
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map_0, 10));
    var inductionVariable_0 = tmp3_map_0._get_first__6();
    var last_2 = tmp3_map_0._get_last__6();
    if (inductionVariable_0 <= last_2)
      do {
        var item_2_3_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var ss_5 = new AnSymbolMovieClipSubTimeline(totalDepths);
        var tmp_2 = ss_5;
        var tmp0__get_microseconds__0_6 = _this_.readU_VL();
        tmp_2._totalTime_0 = Companion_getInstance_27().fromMicroseconds(tmp0__get_microseconds__0_6);
        var stateFlags_7 = _this_.readU8();
        ss_5._nextStatePlay = extract_0(stateFlags_7, 0);
        ss_5._nextState_0 = strings[_this_.readU_VL()];
        var numberOfActionFrames_8 = _this_.readU_VL();
        var tmp1__get_milliseconds__0_10 = 0;
        var lastFrameTime_9 = Companion_getInstance_27().fromMilliseconds(tmp1__get_milliseconds__0_10);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < numberOfActionFrames_8)
          do {
            var n_12 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var tmp2__get_milliseconds__0_14 = _this_.readU_VL();
            var deltaTime_13 = Companion_getInstance_27().fromMilliseconds(tmp2__get_milliseconds__0_14);
            var timeInMs_15 = TimeSpan__plus_impl(lastFrameTime_9, deltaTime_13);
            lastFrameTime_9 = timeInMs_15;
            var tmp3_map_0_17 = until(0, _this_.readU_VL());
            var tmp0_mapTo_0_1_18 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3_map_0_17, 10));
            var inductionVariable_2 = tmp3_map_0_17._get_first__6();
            var last_3 = tmp3_map_0_17._get_last__6();
            if (inductionVariable_2 <= last_3)
              do {
                var item_2_3_20 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var action_5_21 = _this_.readU8();
                var tmp0_subject_6_22 = action_5_21;
                var tmp_3;
                switch (tmp0_subject_6_22) {
                  case 0:
                    tmp_3 = new AnPlaySoundAction(_this_.readU_VL());
                    break;
                  case 1:
                    var tmp1_elvis_lhs_7_23 = strings[_this_.readU_VL()];
                    tmp_3 = new AnEventAction(tmp1_elvis_lhs_7_23 == null ? '' : tmp1_elvis_lhs_7_23);
                    break;
                  default:throw NotImplementedError_init_$Create$(null, 1, null);
                }
                tmp0_mapTo_0_1_18.add_39(tmp_3);
                Unit_getInstance();
              }
               while (!(item_2_3_20 === last_3));
            var actions_16 = tmp0_mapTo_0_1_18;
            var n_1_24 = 0;
            while (n_1_24 < actions_16._get_size__60()) {
              var tmp0_2_26 = n_1_24;
              n_1_24 = tmp0_2_26 + 1 | 0;
              var tmp4__anonymous__3_25 = actions_16.get_137(tmp0_2_26);
              ss_5._actions_0.add_64(TimeSpan__times_impl(timeInMs_15, 1000), tmp4__anonymous__3_25);
            }
          }
           while (inductionVariable_1 < numberOfActionFrames_8);
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < totalDepths)
          do {
            var depth_28 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var timeline_29 = ss_5._timelines[depth_28];
            var lastUid_30 = -1;
            var lastName_31 = null;
            var tmp5_ColorTransform_0_33 = 1;
            var tmp6_ColorTransform_0_34 = 1;
            var tmp7_ColorTransform_0_35 = 1;
            var tmp8_ColorTransform_0_36 = 1;
            var tmp9_ColorTransform_0_37 = 0;
            var tmp10_ColorTransform_0_38 = 0;
            var tmp11_ColorTransform_0_39 = 0;
            var tmp12_ColorTransform_0_40 = 0;
            var lastColorTransform_32 = new ColorTransform(numberToDouble(tmp5_ColorTransform_0_33), numberToDouble(tmp6_ColorTransform_0_34), numberToDouble(tmp7_ColorTransform_0_35), numberToDouble(tmp8_ColorTransform_0_36), numberToInt(tmp9_ColorTransform_0_37), numberToInt(tmp10_ColorTransform_0_38), numberToInt(tmp11_ColorTransform_0_39), numberToInt(tmp12_ColorTransform_0_40));
            var lastMatrix_41 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
            var lastClipDepth_42 = -1;
            var lastRatio_43 = 0.0;
            var tmp13__get_milliseconds__0_45 = 0;
            var lastFrameTime_44 = Companion_getInstance_27().fromMilliseconds(tmp13__get_milliseconds__0_45);
            var lastBlendMode_46 = BlendMode_INHERIT_getInstance();
            var inductionVariable_4 = 0;
            var last_4 = _this_.readU_VL();
            if (inductionVariable_4 < last_4)
              do {
                var frameIndex_48 = inductionVariable_4;
                inductionVariable_4 = inductionVariable_4 + 1 | 0;
                var tmp14__get_milliseconds__0_50 = _this_.readU_VL();
                var deltaFrameTime_49 = Companion_getInstance_27().fromMilliseconds(tmp14__get_milliseconds__0_50);
                var frameTime_51 = TimeSpan__plus_impl(lastFrameTime_44, deltaFrameTime_49);
                lastFrameTime_44 = frameTime_51;
                var flags_52 = _this_.readU_VL();
                var hasUid_53 = extract_0(flags_52, 0);
                var hasName_54 = extract_0(flags_52, 1);
                var hasColorTransform_55 = extract_0(flags_52, 2);
                var hasMatrix_56 = extract_0(flags_52, 3);
                var hasClipDepth_57 = extract_0(flags_52, 4);
                var hasRatio_58 = extract_0(flags_52, 5);
                var hasAlpha_59 = extract_0(flags_52, 6);
                var hasBlendMode_60 = extract_0(flags_52, 7);
                if (hasUid_53)
                  lastUid_30 = _this_.readU_VL();
                if (hasClipDepth_57)
                  lastClipDepth_42 = _this_.readS16LE();
                if (hasName_54)
                  lastName_31 = strings[_this_.readU_VL()];
                if (hasAlpha_59) {
                  var tmp_4 = lastColorTransform_32;
                  var ct_61 = tmp_4.copy$default_5(0.0, 0.0, 0.0, 0.0, 0, 0, 0, 0, 255, null);
                  ct_61._set_mA_(_this_.readU8() / 255.0);
                  lastColorTransform_32 = ct_61;
                } else if (hasColorTransform_55) {
                  var tmp_5 = lastColorTransform_32;
                  var ct_62 = tmp_5.copy$default_5(0.0, 0.0, 0.0, 0.0, 0, 0, 0, 0, 255, null);
                  var ctFlags_63 = _this_.readU8();
                  if (extract_0(ctFlags_63, 0))
                    ct_62._set_mR_(_this_.readU8() / 255.0);
                  if (extract_0(ctFlags_63, 1))
                    ct_62._set_mG_(_this_.readU8() / 255.0);
                  if (extract_0(ctFlags_63, 2))
                    ct_62._set_mB_(_this_.readU8() / 255.0);
                  if (extract_0(ctFlags_63, 3))
                    ct_62._set_mA_(_this_.readU8() / 255.0);
                  if (extract_0(ctFlags_63, 4))
                    ct_62._set_aR_(imul(_this_.readS8(), 2));
                  if (extract_0(ctFlags_63, 5))
                    ct_62._set_aG_(imul(_this_.readS8(), 2));
                  if (extract_0(ctFlags_63, 6))
                    ct_62._set_aB_(imul(_this_.readS8(), 2));
                  if (extract_0(ctFlags_63, 7))
                    ct_62._set_aR_(imul(_this_.readS8(), 2));
                  lastColorTransform_32 = ct_62;
                }if (hasMatrix_56) {
                  var tmp_6 = lastMatrix_41;
                  var lm_64 = tmp_6.copy$default_4(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
                  var matrixFlags_65 = _this_.readU8();
                  if (extract_0(matrixFlags_65, 0))
                    lm_64._a = _this_.readS_VL() / 16384.0;
                  if (extract_0(matrixFlags_65, 1))
                    lm_64._b = _this_.readS_VL() / 16384.0;
                  if (extract_0(matrixFlags_65, 2))
                    lm_64._c = _this_.readS_VL() / 16384.0;
                  if (extract_0(matrixFlags_65, 3))
                    lm_64._d = _this_.readS_VL() / 16384.0;
                  if (extract_0(matrixFlags_65, 4))
                    lm_64._tx = _this_.readS_VL() / 20.0;
                  if (extract_0(matrixFlags_65, 5))
                    lm_64._ty = _this_.readS_VL() / 20.0;
                  lastMatrix_41 = lm_64;
                }if (hasRatio_58)
                  lastRatio_43 = _this_.readU8() / 255.0;
                if (hasBlendMode_60) {
                  var tmp3_elvis_lhs_66 = Companion_getInstance_147()._BY_ORDINAL.get_116(_this_.readU8());
                  lastBlendMode_46 = tmp3_elvis_lhs_66 == null ? BlendMode_INHERIT_getInstance() : tmp3_elvis_lhs_66;
                }timeline_29.add_64(frameTime_51, new AnSymbolTimelineFrame(depth_28, lastUid_30, lastClipDepth_42, lastRatio_43, lastMatrix_41, lastName_31, lastColorTransform_32, lastBlendMode_46));
              }
               while (inductionVariable_4 < last_4);
          }
           while (inductionVariable_3 < totalDepths);
        tmp0_mapTo_0_1_0.add_39(ss_5);
        Unit_getInstance();
      }
       while (!(item_2_3_0 === last_2));
    var symbolStates = tmp0_mapTo_0_1_0;
    var inductionVariable_5 = 0;
    var last_5 = uidsToCharacterIds.length;
    if (inductionVariable_5 < last_5)
      do {
        var n = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + 1 | 0;
        mc._uidInfo[n] = uidsToCharacterIds[n];
      }
       while (inductionVariable_5 < last_5);
    var tmp1_this = mc;
    var tmp5_plusAssign_0 = tmp1_this._states;
    var tmp4_map_0 = until(0, _this_.readU_VL());
    var tmp0_mapTo_0_1_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp4_map_0, 10));
    var inductionVariable_6 = tmp4_map_0._get_first__6();
    var last_6 = tmp4_map_0._get_last__6();
    if (inductionVariable_6 <= last_6)
      do {
        var item_2_3_1 = inductionVariable_6;
        inductionVariable_6 = inductionVariable_6 + 1 | 0;
        var tmp0_elvis_lhs_6 = strings[_this_.readU_VL()];
        var name_5 = tmp0_elvis_lhs_6 == null ? '' : tmp0_elvis_lhs_6;
        var tmp0__get_milliseconds__0_8 = _this_.readU_VL();
        var startTime_7 = Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0_8);
        var stateIndex_9 = _this_.readU_VL();
        symbolStates.get_137(stateIndex_9)._actions_0.add_64(startTime_7, new AnEventAction(name_5));
        tmp0_mapTo_0_1_1.add_39(to(name_5, new AnSymbolMovieClipState(name_5, symbolStates.get_137(stateIndex_9), startTime_7)));
        Unit_getInstance();
      }
       while (!(item_2_3_1 === last_6));
    var tmp6_plusAssign_0 = toMap_0(tmp0_mapTo_0_1_1);
    tmp5_plusAssign_0.putAll_7(tmp6_plusAssign_0);
    return mc;
  }
  function $readLibraryCOROUTINE$7(_this_, _this__0, context, externalReaders, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__152 = _this_;
    this.__this__153 = _this__0;
    this._context_7 = context;
    this._externalReaders = externalReaders;
  }
  $readLibraryCOROUTINE$7.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 7;
            var tmp_0 = this;
            tmp_0._magic0 = this.__this__153.readStringz$default(8, null, 2, null);
            if (!(this._magic0 === 'KORGEANI')) {
              invalidOp('Not a KORGEANI file');
            }
            if (!(this.__this__153.readU_VL() === 16)) {
              invalidOp('Just supported KORGEANI version 16');
            }
            this._msPerFrame1 = this.__this__153.readU_VL();
            this._width2 = this.__this__153.readU_VL();
            this._height3 = this.__this__153.readU_VL();
            this._fileFlags4 = this.__this__153.readU_VL();
            this._mipmaps5 = extract_0(this._fileFlags4, 0);
            this._smoothInterpolation6 = !extract_0(this._fileFlags4, 1);
            var tmp_1 = this;
            var tmp_2 = this;
            tmp_2._tmp0_apply_07 = new AnLibrary(this._context_7, this._width2, this._height3, 1000.0 / this._msPerFrame1);
            this._tmp0_apply_07._defaultSmoothing = this._smoothInterpolation6;
            tmp_1._library8 = this._tmp0_apply_07;
            var tmp_3 = this;
            var tmp_4 = this;
            tmp_4._tmp1_arrayOf_09 = [null];
            var tmp_5 = this._tmp1_arrayOf_09;
            var tmp_6 = this;
            tmp_6._tmp2_map_010 = until(1, this.__this__153.readU_VL());
            var tmp_7 = this;
            tmp_7._tmp0_mapTo_0_111 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._tmp2_map_010, 10));
            var progression = this._tmp2_map_010;
            var inductionVariable = progression._get_first__6();
            var last_1 = progression._get_last__6();
            if (inductionVariable <= last_1)
              do {
                var item_2_3 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                this._tmp0_mapTo_0_111.add_39(this.__this__153.readStringVL$default(null, 1, null));
                Unit_getInstance();
              }
               while (!(item_2_3 === last_1));
            tmp_3._strings12 = plus_4(tmp_5, this._tmp0_mapTo_0_111);
            var tmp_8 = this;
            tmp_8._tmp3_map_013 = until(0, this.__this__153.readU_VL());
            var tmp_9 = this;
            tmp_9._tmp0_mapTo_0_114_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._tmp3_map_013, 10));
            this._tmp0_iterator_1_215_0 = this._tmp3_map_013.iterator_67();
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!this._tmp0_iterator_1_215_0.hasNext_33()) {
              this._state_1 = 3;
              continue $sm;
            }
            this._item_2_316_0 = this._tmp0_iterator_1_215_0.next_37();
            this._state_1 = 2;
            suspendResult = this._externalReaders._atlasReader(this._item_2_316_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._bmp_517 = suspendResult;
            var tmp_10 = this;
            tmp_10._ARGUMENT18 = to(this._bmp_517, slice$default(this._bmp_517, null, null, 3, null));
            this._tmp0_mapTo_0_114_0.add_39(this._ARGUMENT18);
            Unit_getInstance();
            this._state_1 = 1;
            continue $sm;
          case 3:
            this._atlases19 = this._tmp0_mapTo_0_114_0;
            var tmp_11 = this;
            tmp_11._tmp4_map_020 = until(0, this.__this__153.readU_VL());
            var tmp_12 = this;
            tmp_12._tmp0_mapTo_0_121 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this._tmp4_map_020, 10));
            this._tmp0_iterator_1_222 = this._tmp4_map_020.iterator_67();
            this._state_1 = 4;
            continue $sm;
          case 4:
            if (!this._tmp0_iterator_1_222.hasNext_33()) {
              this._state_1 = 6;
              continue $sm;
            }
            this._item_2_323 = this._tmp0_iterator_1_222.next_37();
            this._state_1 = 5;
            suspendResult = this._externalReaders._readSound(this._item_2_323, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 5:
            var ARGUMENT = suspendResult;
            this._tmp0_mapTo_0_121.add_39(ARGUMENT);
            Unit_getInstance();
            this._state_1 = 4;
            continue $sm;
          case 6:
            var sounds = this._tmp0_mapTo_0_121;
            var tmp5_map_0 = until(0, this.__this__153.readU_VL());
            var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp5_map_0, 10));
            var inductionVariable_0 = tmp5_map_0._get_first__6();
            var last_2 = tmp5_map_0._get_last__6();
            if (inductionVariable_0 <= last_2)
              do {
                var item_2_3_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                tmp0_mapTo_0_1.add_39(readSymbol(this.__this__153, AnLibraryDeserializer_getInstance(), this._strings12, this._atlases19, sounds));
                Unit_getInstance();
              }
               while (!(item_2_3_0 === last_2));
            var symbols = tmp0_mapTo_0_1;
            var n_1 = 0;
            while (n_1 < symbols._get_size__60()) {
              var tmp0_2 = n_1;
              n_1 = tmp0_2 + 1 | 0;
              var tmp6__anonymous__3 = symbols.get_137(tmp0_2);
              this._library8.addSymbol(tmp6__anonymous__3);
            }

            this._library8.processSymbolNames();
            return this._library8;
          case 7:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 7) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readLibraryCOROUTINE$7.$metadata$ = {
    simpleName: '$readLibraryCOROUTINE$7',
    kind: 'class',
    interfaces: []
  };
  function AnLibraryDeserializer() {
    AnLibraryDeserializer_instance = this;
  }
  AnLibraryDeserializer.prototype.read_49 = function (s, context, externalReaders, $cont) {
    return readLibrary(s, this, context, externalReaders, $cont);
  };
  AnLibraryDeserializer.prototype.readRect = function (_this__0) {
    return new Rectangle(_this__0.readS_VL() / 20.0, _this__0.readS_VL() / 20.0, _this__0.readS_VL() / 20.0, _this__0.readS_VL() / 20.0);
  };
  AnLibraryDeserializer.prototype.readIRect = function (_this__0) {
    return Companion_getInstance_84().invoke_312(_this__0.readS_VL(), _this__0.readS_VL(), _this__0.readS_VL(), _this__0.readS_VL());
  };
  AnLibraryDeserializer.$metadata$ = {
    simpleName: 'AnLibraryDeserializer',
    kind: 'object',
    interfaces: []
  };
  var AnLibraryDeserializer_instance;
  function AnLibraryDeserializer_getInstance() {
    if (AnLibraryDeserializer_instance == null)
      new AnLibraryDeserializer();
    return AnLibraryDeserializer_instance;
  }
  function _no_name_provided__359($file, $context, resultContinuation) {
    this._$file_0 = $file;
    this._$context_1 = $context;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__359.prototype.invoke_874 = function (index, $cont) {
    var tmp = this.create_39(index, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__359.prototype.invoke_1015 = function (p1, $cont) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__359.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = this._$file_0.withExtension('' + 'ani.' + this._index_17 + '.png');
            suspendResult = readBitmapOptimized$default(tmp_0, this._$context_1._imageFormats_1, false, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__359.prototype.create_39 = function (index, completion) {
    var i = new _no_name_provided__359(this._$file_0, this._$context_1, completion);
    i._index_17 = index;
    return i;
  };
  _no_name_provided__359.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__360($file, resultContinuation) {
    this._$file_1 = $file;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__360.prototype.invoke_874 = function (index, $cont) {
    var tmp = this.create_39(index, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__360.prototype.invoke_1015 = function (p1, $cont) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__360.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = this._$file_1.withExtension('' + 'ani.' + this._index_18 + '.mp3');
            suspendResult = readSound$default(tmp_0, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__360.prototype.create_39 = function (index, completion) {
    var i = new _no_name_provided__360(this._$file_1, completion);
    i._index_18 = index;
    return i;
  };
  _no_name_provided__360.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $readAniCOROUTINE$6(_this_, context, content, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__154 = _this_;
    this._context_8 = context;
    this._content_8 = content;
  }
  $readAniCOROUTINE$6.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._file0_0 = this.__this__154;
            this._ARGUMENT1_12 = AnLibraryDeserializer_getInstance();
            this._tmp0_elvis_lhs2 = this._content_8;
            if (this._tmp0_elvis_lhs2 == null) {
              this._state_1 = 1;
              suspendResult = this.__this__154.readBytes(this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._WHEN_RESULT3_3 = this._tmp0_elvis_lhs2;
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            this._ARGUMENT4_3 = suspendResult;
            var tmp_0 = this;
            tmp_0._WHEN_RESULT3_3 = FastByteArrayInputStream_init_$Create$(this._ARGUMENT4_3, 0, 0, 0, 14, null);
            this._state_1 = 2;
            continue $sm;
          case 2:
            this._ARGUMENT5_0 = this._WHEN_RESULT3_3;
            this._state_1 = 3;
            var tmp_1 = this._get_context__296();
            var tmp_2 = this._context_8.copy$default_8(tmp_1, null, 2, null);
            var tmp_3 = _no_name_provided_$factory_311(this._file0_0, this._context_8, null);
            suspendResult = this._ARGUMENT1_12.read_49(this._ARGUMENT5_0, tmp_2, new ExternalReaders(tmp_3, _no_name_provided_$factory_312(this._file0_0, null)), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $readAniCOROUTINE$6.$metadata$ = {
    simpleName: '$readAniCOROUTINE$6',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_311($file, $context, resultContinuation) {
    var i = new _no_name_provided__359($file, $context, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_874(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_312($file, resultContinuation) {
    var i = new _no_name_provided__360($file, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_874(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function BaseView() {
    this.__components = null;
    var tmp = this;
    tmp.__props = LinkedHashMap_init_$Create$();
  }
  BaseView.prototype._get__components__21 = function () {
    return this.__components;
  };
  BaseView.prototype._get_componentsSure__21 = function () {
    if (this.__components == null)
      this.__components = new Components();
    return ensureNotNull(this.__components);
  };
  BaseView.prototype.removeComponent_21 = function (c) {
    var tmp0_safe_receiver = this.__components;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.remove_70(c);
    Unit_getInstance();
  };
  BaseView.prototype.addComponent_43 = function (c) {
    return this._get_componentsSure__21().add_65(c);
  };
  BaseView.prototype.addComponent_44 = function (c) {
    return this._get_componentsSure__21().add_66(c);
  };
  BaseView.$metadata$ = {
    simpleName: 'BaseView',
    kind: 'class',
    interfaces: []
  };
  function drawText_0(_this_, font, textSize, str, x, y, m, colMul, colAdd, blendMode, filtering) {
    drawText_1(font, _this_, textSize, str, x, y, m, colMul, colAdd, blendMode, filtering);
  }
  function drawText$default(_this_, font, textSize, str, x, y, m, colMul, colAdd, blendMode, filtering, $mask0, $handler) {
    if (!(($mask0 & 32) === 0)) {
      m = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    }if (!(($mask0 & 64) === 0))
      colMul = Colors_getInstance()._WHITE;
    if (!(($mask0 & 128) === 0))
      colAdd = Companion_getInstance_102()._NEUTRAL;
    if (!(($mask0 & 256) === 0))
      blendMode = BlendMode_INHERIT_getInstance();
    if (!(($mask0 & 512) === 0))
      filtering = true;
    return drawText_0(_this_, font, textSize, str, x, y, m, colMul, colAdd, blendMode, filtering);
  }
  function drawText_1(_this_, ctx, textSize, str, x, y, m, colMul, colAdd, blendMode, filtering) {
    var m2 = m.clone_8();
    var scale_1 = textSize / _this_._fontSize_0;
    m2.pretranslate(x, y);
    Unit_getInstance();
    m2.prescale(scale_1, scale_1);
    Unit_getInstance();
    var dx = 0.0;
    var dy = 0.0;
    var inductionVariable = 0;
    var last_1 = charSequenceLength(str) - 1 | 0;
    if (inductionVariable <= last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1 = charSequenceGet(str, n).toInt_8();
        if (c1 === 10) {
          dx = 0.0;
          dy = dy + _this_._fontSize_0;
          continue;
        }var tmp0_getOrElse_0 = n + 1 | 0;
        var tmp;
        if (tmp0_getOrElse_0 >= 0 ? tmp0_getOrElse_0 <= _get_lastIndex__4(str) : false) {
          tmp = charSequenceGet(str, tmp0_getOrElse_0);
        } else {
          tmp = new Char(32);
        }
        var c2 = tmp.toInt_8();
        var glyph = _this_.get_137(c1);
        var tex = glyph._texture_0;
        var tmp1_tex = ctx.getTex(tex);
        var tmp2_x = dx + glyph._xoffset;
        var tmp3_y = dy + glyph._yoffset;
        var tmp4_blendFactors = blendMode._factors;
        var tmp_0 = ctx._get_batch_();
        tmp_0.drawQuad$default(tmp1_tex, tmp2_x, tmp3_y, 0.0, 0.0, m2, filtering, colMul, colAdd, tmp4_blendFactors, false, null, 3096, null);
        var tmp5_safe_receiver = _this_._kernings.get_137(Companion_getInstance_108().buildKey(c1, c2));
        var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver._amount;
        var kerningOffset = tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs;
        dx = dx + (glyph._xadvance + kerningOffset | 0);
      }
       while (inductionVariable <= last_1);
  }
  function UpdateComponentWithViews() {
  }
  UpdateComponentWithViews.$metadata$ = {
    simpleName: 'UpdateComponentWithViews',
    kind: 'interface',
    interfaces: [Component]
  };
  function GamepadComponent() {
  }
  GamepadComponent.$metadata$ = {
    simpleName: 'GamepadComponent',
    kind: 'interface',
    interfaces: [Component]
  };
  function KeyComponent() {
  }
  KeyComponent.$metadata$ = {
    simpleName: 'KeyComponent',
    kind: 'interface',
    interfaces: [Component]
  };
  function MouseComponent() {
  }
  MouseComponent.$metadata$ = {
    simpleName: 'MouseComponent',
    kind: 'interface',
    interfaces: [Component]
  };
  function attach(_this_) {
    _this_._get_view__6().addComponent_43(_this_);
    Unit_getInstance();
    return _this_;
  }
  function UpdateComponent() {
  }
  UpdateComponent.$metadata$ = {
    simpleName: 'UpdateComponent',
    kind: 'interface',
    interfaces: [Component]
  };
  function attach_0(_this_) {
    _this_._get_view__6().addComponent_44(_this_);
    Unit_getInstance();
    return _this_;
  }
  function detach(_this_) {
    _this_._get_view__6().removeComponent_21(_this_);
    return _this_;
  }
  function Components() {
    this._mouse = null;
    this._key_4 = null;
    this._gamepad_2 = null;
    this._touch = null;
    this._event_0 = null;
    this._updateWV = null;
    this._update_0 = null;
    this._resize = null;
    this._other_0 = null;
  }
  Components.prototype._get_emouse_ = function () {
    if (this._mouse == null) {
      var tmp = this;
      tmp._mouse = ArrayList_init_$Create$();
    }return ensureNotNull(this._mouse);
  };
  Components.prototype._get_ekey_ = function () {
    if (this._key_4 == null) {
      var tmp = this;
      tmp._key_4 = ArrayList_init_$Create$();
    }return ensureNotNull(this._key_4);
  };
  Components.prototype._get_egamepad_ = function () {
    if (this._gamepad_2 == null) {
      var tmp = this;
      tmp._gamepad_2 = ArrayList_init_$Create$();
    }return ensureNotNull(this._gamepad_2);
  };
  Components.prototype._get_eupdateWV_ = function () {
    if (this._updateWV == null) {
      var tmp = this;
      tmp._updateWV = ArrayList_init_$Create$();
    }return ensureNotNull(this._updateWV);
  };
  Components.prototype._get_eupdate_ = function () {
    if (this._update_0 == null) {
      var tmp = this;
      tmp._update_0 = ArrayList_init_$Create$();
    }return ensureNotNull(this._update_0);
  };
  Components.prototype.remove_70 = function (c) {
    var tmp0_safe_receiver = this._update_0;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.remove_47(c);
  };
  Components.prototype.add_65 = function (c) {
    var tmp0_plusAssign_0 = this._get_eupdateWV_();
    tmp0_plusAssign_0.add_39(c);
    Unit_getInstance();
    return c;
  };
  Components.prototype.add_66 = function (c) {
    var tmp0_plusAssign_0 = this._get_eupdate_();
    tmp0_plusAssign_0.add_39(c);
    Unit_getInstance();
    return c;
  };
  Components.prototype.findFirstComponentOfType = function (array, clazz) {
    var n_1 = 0;
    while (n_1 < array._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp0__anonymous__3 = array.get_137(tmp0_2);
      if (getKClassFromExpression_0(tmp0__anonymous__3).equals(clazz))
        return tmp0__anonymous__3;
    }
    return null;
  };
  Components.$metadata$ = {
    simpleName: 'Components',
    kind: 'class',
    interfaces: []
  };
  function Component() {
  }
  Component.$metadata$ = {
    simpleName: 'Component',
    kind: 'interface',
    interfaces: []
  };
  var lengths$delegate;
  var width$delegate;
  var height$delegate;
  var x$delegate;
  var y$delegate;
  var scale$delegate;
  var scaleX$delegate;
  var scaleY$delegate;
  function ViewWithLength(view) {
    this._view = view;
  }
  ViewWithLength.$metadata$ = {
    simpleName: 'ViewWithLength',
    kind: 'class',
    interfaces: [LengthExtensions]
  };
  function LengthDelegatedProperty(prop, horizontal, getView) {
    this._prop = prop;
    this._getView = getView;
    var tmp = this;
    var tmp0_elvis_lhs = horizontal;
    tmp._horizontal_0 = tmp0_elvis_lhs == null ? _get_isHorizontal_(this._prop) : tmp0_elvis_lhs;
  }
  LengthDelegatedProperty.$metadata$ = {
    simpleName: 'LengthDelegatedProperty',
    kind: 'class',
    interfaces: []
  };
  function ViewWithLengthProp(prop, horizontal) {
    return new LengthDelegatedProperty(prop, horizontal, _no_name_provided_$factory_314());
  }
  function ViewWithLengthProp$default(prop, horizontal, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      horizontal = null;
    return ViewWithLengthProp(prop, horizontal);
  }
  function _get_isHorizontal_(_this_) {
    var tmp0_subject = _this_.callableName;
    var tmp;
    switch (tmp0_subject) {
      case 'x':
      case 'width':
        tmp = true;
        break;
      default:var tmp_0;
        var tmp_1;
        var tmp_2;
        var tmp_3 = _this_.callableName;
        if (contains$default_0(tmp_3, 'x', false, 2, null)) {
          tmp_2 = true;
        } else {
          {
            var tmp_4 = _this_.callableName;
            tmp_2 = contains$default_0(tmp_4, 'X', false, 2, null);
          }
        }

        if (tmp_2) {
          tmp_1 = true;
        } else {
          {
            var tmp_5 = _this_.callableName;
            tmp_1 = contains$default_0(tmp_5, 'width', false, 2, null);
          }
        }

        if (tmp_1) {
          tmp_0 = true;
        } else {
          {
            var tmp_6 = _this_.callableName;
            tmp_0 = contains$default_0(tmp_6, 'Width', false, 2, null);
          }
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  }
  function _no_name_provided__361() {
  }
  _no_name_provided__361.prototype.invoke_731 = function ($this$$receiver) {
    return new ViewWithLength($this$$receiver);
  };
  _no_name_provided__361.prototype.invoke_1015 = function (p1) {
    return this.invoke_731(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__361.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__362() {
  }
  _no_name_provided__362.prototype.invoke_627 = function (it) {
    return it._view;
  };
  _no_name_provided__362.prototype.invoke_1015 = function (p1) {
    return this.invoke_627(p1 instanceof ViewWithLength ? p1 : THROW_CCE());
  };
  _no_name_provided__362.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function scaledWidth$factory() {
    return getPropertyCallableRef('scaledWidth', 1, KMutableProperty1, function (receiver) {
      return receiver._get_scaledWidth__20();
    }, function (receiver_0, value) {
      return receiver_0._set_scaledWidth__20(value);
    });
  }
  function scaledHeight$factory() {
    return getPropertyCallableRef('scaledHeight', 1, KMutableProperty1, function (receiver) {
      return receiver._get_scaledHeight__20();
    }, function (receiver_0, value) {
      return receiver_0._set_scaledHeight__20(value);
    });
  }
  function x$factory() {
    return getPropertyCallableRef('x', 1, KMutableProperty1, function (receiver) {
      return receiver._get_x__36();
    }, function (receiver_0, value) {
      return receiver_0._set_x__27(value);
    });
  }
  function y$factory() {
    return getPropertyCallableRef('y', 1, KMutableProperty1, function (receiver) {
      return receiver._get_y__36();
    }, function (receiver_0, value) {
      return receiver_0._set_y__27(value);
    });
  }
  function scale$factory() {
    return getPropertyCallableRef('scale', 1, KMutableProperty1, function (receiver) {
      return receiver._get_scale__20();
    }, function (receiver_0, value) {
      return receiver_0._set_scale__20(value);
    });
  }
  function scaleX$factory() {
    return getPropertyCallableRef('scaleX', 1, KMutableProperty1, function (receiver) {
      return receiver._get_scaleX__20();
    }, function (receiver_0, value) {
      return receiver_0._set_scaleX__20(value);
    });
  }
  function scaleY$factory() {
    return getPropertyCallableRef('scaleY', 1, KMutableProperty1, function (receiver) {
      return receiver._get_scaleY__20();
    }, function (receiver_0, value) {
      return receiver_0._set_scaleY__20(value);
    });
  }
  function _no_name_provided_$factory_313() {
    var i = new _no_name_provided__361();
    return function (p1) {
      return i.invoke_731(p1);
    };
  }
  function _no_name_provided_$factory_314() {
    var i = new _no_name_provided__362();
    return function (p1) {
      return i.invoke_627(p1);
    };
  }
  function width$delegate$init$() {
    var tmp = scaledWidth$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function height$delegate$init$() {
    var tmp = scaledHeight$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function x$delegate$init$() {
    var tmp = x$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function y$delegate$init$() {
    var tmp = y$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function scale$delegate$init$() {
    var tmp = scale$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function scaleX$delegate$init$() {
    var tmp = scaleX$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function scaleY$delegate$init$() {
    var tmp = scaleY$factory();
    return ViewWithLengthProp$default(tmp, null, 2, null);
  }
  function KorgeDebugNode() {
  }
  KorgeDebugNode.$metadata$ = {
    simpleName: 'KorgeDebugNode',
    kind: 'interface',
    interfaces: []
  };
  function FontsCatalog_init_$Init$(default_0, fonts, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0)) {
      fonts = HashMap_init_$Create$();
    }FontsCatalog.call($this, default_0, fonts);
    return $this;
  }
  function FontsCatalog_init_$Create$(default_0, fonts, $mask0, $marker) {
    return FontsCatalog_init_$Init$(default_0, fonts, $mask0, $marker, Object.create(FontsCatalog.prototype));
  }
  function FontsCatalog(default_0, fonts) {
    this._default_1 = default_0;
    this._fonts = fonts;
  }
  FontsCatalog.$metadata$ = {
    simpleName: 'FontsCatalog',
    kind: 'class',
    interfaces: [MetricsProvider]
  };
  function MetricsProvider() {
  }
  MetricsProvider.$metadata$ = {
    simpleName: 'MetricsProvider',
    kind: 'interface',
    interfaces: []
  };
  var extraLanguage$delegate;
  function _no_name_provided__363() {
  }
  _no_name_provided__363.prototype.invoke_1005 = function () {
    return Companion_getInstance_61()._get_CURRENT_();
  };
  _no_name_provided__363.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_315() {
    var i = new _no_name_provided__363();
    return function () {
      return i.invoke_1005();
    };
  }
  var gamepad$delegate;
  function GamePadEvents(view) {
    this._view_0 = view;
    var tmp = this;
    tmp._gamepads_0 = GamePadUpdateEvent_init_$Create$(0, null, 3, null);
    var tmp_0 = this;
    tmp_0._updated = Signal_init_$Create$(null, 1, null);
    var tmp_1 = this;
    tmp_1._stick_0 = Signal_init_$Create$(null, 1, null);
    var tmp_2 = this;
    tmp_2._button_1 = Signal_init_$Create$(null, 1, null);
    var tmp_3 = this;
    tmp_3._connection = Signal_init_$Create$(null, 1, null);
    var tmp_4 = this;
    tmp_4._oldGamepads = GamePadUpdateEvent_init_$Create$(0, null, 3, null);
    var tmp_5 = this;
    tmp_5._stickEvent = GamePadStickEvent_init_$Create$(0, null, 0.0, 0.0, 15, null);
    var tmp_6 = this;
    tmp_6._buttonEvent = GamePadButtonEvent_init_$Create$(null, 0, null, 0.0, 15, null);
  }
  GamePadEvents.prototype.onGamepadEvent_1 = function (views, event) {
    this._views_1 = views;
    this._gamepads_0.copyFrom_5(event);
    var inductionVariable = 0;
    var last_1 = event._gamepadsLength;
    if (inductionVariable < last_1)
      do {
        var gamepadIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var gamepad = event._gamepads[gamepadIndex];
        var oldGamepad = this._oldGamepads._gamepads[gamepadIndex];
        var tmp0_fastForEach_0 = Companion_getInstance_130()._BUTTONS;
        var n_1 = 0;
        while (n_1 < tmp0_fastForEach_0.length) {
          var tmp0_2 = n_1;
          n_1 = tmp0_2 + 1 | 0;
          var tmp1__anonymous__3 = tmp0_fastForEach_0[tmp0_2];
          if (!(gamepad.get_100(tmp1__anonymous__3) === oldGamepad.get_100(tmp1__anonymous__3))) {
            var tmp0_apply_0_4 = this._buttonEvent;
            tmp0_apply_0_4._gamepad_0 = gamepad._index_16;
            tmp0_apply_0_4._type_9 = !(gamepad.get_100(tmp1__anonymous__3) === 0.0) ? Type_DOWN_getInstance_1() : Type_UP_getInstance_1();
            tmp0_apply_0_4._button_0 = tmp1__anonymous__3;
            tmp0_apply_0_4._value_22 = gamepad.get_100(tmp1__anonymous__3);
            this._button_1.invoke_137(tmp0_apply_0_4);
          }}
        var tmp2_fastForEach_0 = Companion_getInstance_133()._STICKS;
        var n_1_0 = 0;
        while (n_1_0 < tmp2_fastForEach_0.length) {
          var tmp0_2_0 = n_1_0;
          n_1_0 = tmp0_2_0 + 1 | 0;
          var tmp3__anonymous__3 = tmp2_fastForEach_0[tmp0_2_0];
          var vector_4 = gamepad.get_101(tmp3__anonymous__3);
          if (!vector_4.equals(oldGamepad.get_101(tmp3__anonymous__3))) {
            var tmp0_apply_0_5 = this._stickEvent;
            tmp0_apply_0_5._gamepad = gamepad._index_16;
            tmp0_apply_0_5._stick = tmp3__anonymous__3;
            tmp0_apply_0_5._x_14 = vector_4._x_2;
            tmp0_apply_0_5._y_13 = vector_4._y_2;
            this._stick_0.invoke_137(tmp0_apply_0_5);
          }}
      }
       while (inductionVariable < last_1);
    this._oldGamepads.copyFrom_5(event);
    this._updated.invoke_137(event);
  };
  GamePadEvents.prototype.onGamepadEvent_2 = function (views, event) {
    this._views_1 = views;
    this._connection.invoke_137(event);
  };
  GamePadEvents.$metadata$ = {
    simpleName: 'GamePadEvents',
    kind: 'class',
    interfaces: [GamepadComponent]
  };
  function _no_name_provided__364() {
  }
  _no_name_provided__364.prototype.invoke_731 = function ($this$$receiver) {
    var tmp2_getOrCreateComponent_0_1 = $this$$receiver._get_componentsSure__21();
    var tmp3_getOrCreateComponent_0_2 = getKClass_0(GamePadEvents);
    var tmp1_getOrCreateComponent_0_3 = tmp2_getOrCreateComponent_0_1._get_egamepad_();
    var component_1_4 = tmp2_getOrCreateComponent_0_1.findFirstComponentOfType(tmp1_getOrCreateComponent_0_3, tmp3_getOrCreateComponent_0_2);
    if (component_1_4 == null) {
      component_1_4 = new GamePadEvents($this$$receiver);
      var tmp0_plusAssign_0_5 = component_1_4;
      tmp1_getOrCreateComponent_0_3.add_39(tmp0_plusAssign_0_5);
      Unit_getInstance();
    }var tmp = component_1_4;
    return tmp instanceof GamePadEvents ? tmp : THROW_CCE();
  };
  _no_name_provided__364.prototype.invoke_1015 = function (p1) {
    return this.invoke_731(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__364.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_316() {
    var i = new _no_name_provided__364();
    return function (p1) {
      return i.invoke_731(p1);
    };
  }
  function InputKeys() {
    this._pressing = booleanArray(Companion_getInstance_132()._MAX_2);
    this._pressingPrev = booleanArray(Companion_getInstance_132()._MAX_2);
    this._shift_1 = false;
    this._ctrl_0 = false;
    this._alt_0 = false;
    this._meta_0 = false;
  }
  InputKeys.prototype.get_114 = function (key) {
    return this.pressing_0(key);
  };
  InputKeys.prototype.pressing_0 = function (key) {
    return this._pressing[key._get_ordinal__2()];
  };
  InputKeys.prototype.triggerKeyEvent = function (e) {
    var tmp0_subject = e._type_8;
    if (tmp0_subject.equals(Type_UP_getInstance_0()))
      this._pressing[e._key_3._get_ordinal__2()] = false;
    else if (tmp0_subject.equals(Type_DOWN_getInstance_0()))
      this._pressing[e._key_3._get_ordinal__2()] = true;
    else
      Unit_getInstance();
    this._shift_1 = (e._shift_0 ? true : this.get_114(Key_LEFT_SHIFT_getInstance())) ? true : this.get_114(Key_RIGHT_SHIFT_getInstance());
    this._ctrl_0 = (e._ctrl ? true : this.get_114(Key_LEFT_CONTROL_getInstance())) ? true : this.get_114(Key_RIGHT_CONTROL_getInstance());
    this._alt_0 = (e._alt ? true : this.get_114(Key_LEFT_ALT_getInstance())) ? true : this.get_114(Key_RIGHT_ALT_getInstance());
    this._meta_0 = e._meta ? true : this.get_114(Key_META_getInstance());
  };
  InputKeys.prototype.startFrame_7 = function (delta_0) {
  };
  InputKeys.prototype.endFrame_0 = function (delta_0) {
    arraycopy_7(this._pressing, 0, this._pressingPrev, 0, this._pressing.length);
  };
  InputKeys.$metadata$ = {
    simpleName: 'InputKeys',
    kind: 'class',
    interfaces: []
  };
  function Companion_141() {
    Companion_instance_140 = this;
    this._KEYCODES = 256;
  }
  Companion_141.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_140;
  function Companion_getInstance_140() {
    if (Companion_instance_140 == null)
      new Companion_141();
    return Companion_instance_140;
  }
  function endFrameOldKeys($this, delta_0) {
    var inductionVariable = 0;
    var last_1 = 256;
    if (inductionVariable < last_1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var prev = $this._keysRawPrev[n];
        var curr = $this._keysRaw[n];
        $this._keysJustReleased[n] = prev ? !curr : false;
        $this._keysJustPressed[n] = !prev ? curr : false;
        if (curr) {
          var tmp1_array = $this._keysPressingTime;
          var tmp2_index0 = n;
          tmp1_array[tmp2_index0] = tmp1_array[tmp2_index0] + _TimeSpan___get_nanoseconds__impl_(delta_0);
        } else {
          $this._keysPressingTime[n] = 0.0;
          $this._keysLastTimeTriggered[n] = 0.0;
        }
        var triggerPress = false;
        var tmp0__get_nanoseconds__0 = $this._keysPressingTime[n];
        var pressingTime = Companion_getInstance_27().fromNanoseconds(tmp0__get_nanoseconds__0);
        if ($this._keysPressingTime[n] > 0.0) {
          var tmp3_subject = _TimeSpan___get_milliseconds__impl_(pressingTime);
          var tmp;
          if (0.0 <= tmp3_subject ? tmp3_subject <= 1.0 : false) {
            var tmp1__get_milliseconds__0 = 0.0;
            tmp = Companion_getInstance_27().fromMilliseconds(tmp1__get_milliseconds__0);
          } else if (1.0 <= tmp3_subject ? tmp3_subject <= 300.0 : false) {
            var tmp2__get_milliseconds__0 = 100.0;
            tmp = Companion_getInstance_27().fromMilliseconds(tmp2__get_milliseconds__0);
          } else if (300.0 <= tmp3_subject ? tmp3_subject <= 1000.0 : false) {
            var tmp3__get_milliseconds__0 = 50.0;
            tmp = Companion_getInstance_27().fromMilliseconds(tmp3__get_milliseconds__0);
          } else {
            var tmp4__get_milliseconds__0 = 20.0;
            tmp = Companion_getInstance_27().fromMilliseconds(tmp4__get_milliseconds__0);
          }
          var timeBarrier = tmp;
          var tmp5__get_nanoseconds__0 = $this._keysLastTimeTriggered[n];
          var elapsedTime = TimeSpan__minus_impl(pressingTime, Companion_getInstance_27().fromNanoseconds(tmp5__get_nanoseconds__0));
          if (TimeSpan__compareTo_impl(elapsedTime, timeBarrier) >= 0) {
            triggerPress = true;
          }}if (triggerPress) {
          $this._keysLastTimeTriggered[n] = $this._keysPressingTime[n];
        }$this._keysPressing[n] = triggerPress;
      }
       while (inductionVariable < last_1);
    arraycopy_7($this._keysRaw, 0, $this._keysRawPrev, 0, 256);
  }
  function _no_name_provided__365() {
  }
  _no_name_provided__365.prototype.invoke_1005 = function () {
    return AGOpenglFactory_getInstance()._get_isTouchDevice_();
  };
  _no_name_provided__365.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Input() {
    Companion_getInstance_140();
    var tmp = this;
    tmp._$$delegate_0_18 = Mixin_init_$Create$(null, 1, null);
    this._dummyTouch = Companion_getInstance_128()._dummy_2;
    var tmp_0 = this;
    var tmp0_map_0 = until(0, 16);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var inductionVariable = tmp0_map_0._get_first__6();
    var last_1 = tmp0_map_0._get_last__6();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_mapTo_0_1.add_39(Touch_init_$Create$(item_2_3, 0, 0.0, 0.0, null, 30, null));
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    var tmp1_toTypedArray_0 = tmp0_mapTo_0_1;
    tmp_0._touches = copyToArray_0(tmp1_toTypedArray_0);
    var tmp_1 = this;
    tmp_1._activeTouches = ArrayList_init_$Create$();
    var tmp_2 = this;
    tmp_2.__isTouchDeviceGen = _no_name_provided_$factory_317();
    this._mouse_0 = new Point(-1000.0, -1000.0);
    this._mouseButtons_0 = 0;
    this._mouseInside = true;
    this._clicked = false;
    this._keys_0 = new InputKeys();
    this._keysRaw = booleanArray(256);
    this._keysRawPrev = booleanArray(256);
    this._keysPressingTime = new Float64Array(256);
    this._keysLastTimeTriggered = new Float64Array(256);
    this._keysPressing = booleanArray(256);
    this._keysJustPressed = booleanArray(256);
    this._keysJustReleased = booleanArray(256);
    var tmp_3 = this;
    var tmp0_map_0_0 = until(0, 8);
    var tmp0_mapTo_0_1_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0_0, 10));
    var inductionVariable_0 = tmp0_map_0_0._get_first__6();
    var last_2 = tmp0_map_0_0._get_last__6();
    if (inductionVariable_0 <= last_2)
      do {
        var item_2_3_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        tmp0_mapTo_0_1_0.add_39(GamepadInfo_init_$Create$(item_2_3_0, false, null, null, null, 0, null, 0, 0, 510, null));
        Unit_getInstance();
      }
       while (!(item_2_3_0 === last_2));
    var tmp1_toTypedArray_0_0 = tmp0_mapTo_0_1_0;
    tmp_3._gamepads_1 = copyToArray_0(tmp1_toTypedArray_0_0);
    var tmp_4 = this;
    tmp_4._connectedGamepads = ArrayList_init_$Create$();
  }
  Input.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_18._extra = _set___;
  };
  Input.prototype._get_extra__71 = function () {
    return this._$$delegate_0_18._extra;
  };
  Input.prototype.updateConnectedGamepads = function () {
    this._connectedGamepads.clear_33();
    var tmp0_fastForEach_0 = this._gamepads_1;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0.length) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0[tmp0_2];
      if (tmp1__anonymous__3._connected) {
        var tmp0_this_4 = this;
        var tmp0_plusAssign_0_5 = tmp0_this_4._connectedGamepads;
        tmp0_plusAssign_0_5.add_39(tmp1__anonymous__3);
        Unit_getInstance();
      }}
  };
  Input.prototype.setKey = function (keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this._keysRaw.length - 1 | 0) : false)
      this._keysRaw[pKeyCode] = b;
  };
  Input.prototype.startFrame_7 = function (delta_0) {
    var tmp0_safe_receiver = this._get_extra__71();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.clear_33();
      Unit_getInstance();
    }
    Unit_getInstance();
    this._keys_0.startFrame_7(delta_0);
  };
  Input.prototype.endFrame_0 = function (delta_0) {
    this._clicked = false;
    this._keys_0.endFrame_0(delta_0);
    endFrameOldKeys(this, delta_0);
  };
  Input.prototype.triggerOldKeyEvent = function (e) {
    var tmp0_subject = e._type_8;
    if (tmp0_subject.equals(Type_DOWN_getInstance_0())) {
      this.setKey(e._keyCode, true);
    } else if (tmp0_subject.equals(Type_UP_getInstance_0())) {
      this.setKey(e._keyCode, false);
    } else if (tmp0_subject.equals(Type_TYPE_getInstance())) {
    }};
  Input.$metadata$ = {
    simpleName: 'Input',
    kind: 'class',
    interfaces: [Extra]
  };
  function _no_name_provided_$factory_317() {
    var i = new _no_name_provided__365();
    return function () {
      return i.invoke_1005();
    };
  }
  function _get_keys_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = keys$delegate;
      var tmp1_getValue_0 = keys$factory();
      var tmp1_safe_receiver_2 = _this_._get_extra__71();
      var tmp;
      if (tmp1_safe_receiver_2 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_3 = tmp0_getValue_0._name_1;
        tmp = tmp1_safe_receiver_2.get_116(tmp0_elvis_lhs_3 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3);
      }
      var tmp_0 = tmp;
      var res_1 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      if (res_1 == null) {
        var r_4 = tmp0_getValue_0._defaultGen_0(_this_);
        if (_this_._get_extra__71() == null)
          _this_._set_extra__71(LinkedHashMap_init_$Create$());
        var tmp1_safe_receiver_2_2_5 = _this_._get_extra__71();
        if (tmp1_safe_receiver_2_2_5 == null)
          null;
        else {
          var tmp0_elvis_lhs_3_4_7 = tmp0_getValue_0._name_1;
          var tmp0_set_0_3_6 = tmp0_elvis_lhs_3_4_7 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3_4_7;
          var tmp1_set_0_5_8 = (r_4 == null ? true : isObject(r_4)) ? r_4 : THROW_CCE();
          tmp1_safe_receiver_2_2_5.put_18(tmp0_set_0_3_6, tmp1_set_0_5_8);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_4;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var keys$delegate;
  function _no_name_provided__366(this$0, $event, resultContinuation) {
    this._this$0_100 = this$0;
    this._$event = $event;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__366.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__366.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__366.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_100._onKeyTyped.invoke_137(this._$event, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__366.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__366(this._this$0_100, this._$event, completion);
    return i;
  };
  _no_name_provided__366.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__367(this$0, $event, resultContinuation) {
    this._this$0_101 = this$0;
    this._$event_0 = $event;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__367.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__367.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__367.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_101._onKeyDown.invoke_137(this._$event_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__367.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__367(this._this$0_101, this._$event_0, completion);
    return i;
  };
  _no_name_provided__367.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__368(this$0, $event, resultContinuation) {
    this._this$0_102 = this$0;
    this._$event_1 = $event;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__368.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__368.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__368.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_102._onKeyUp.invoke_137(this._$event_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__368.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__368(this._this$0_102, this._$event_1, completion);
    return i;
  };
  _no_name_provided__368.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function KeysEvents(view) {
    this._view_1 = view;
    var tmp = this;
    tmp._onKeyDown = AsyncSignal_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._onKeyUp = AsyncSignal_init_$Create$(null, 1, null);
    var tmp_1 = this;
    tmp_1._onKeyTyped = AsyncSignal_init_$Create$(null, 1, null);
  }
  KeysEvents.prototype.onKeyEvent_0 = function (_this__0, event) {
    this._views_2 = _this__0;
    var tmp0_subject = event._type_8;
    if (tmp0_subject.equals(Type_TYPE_getInstance())) {
      launchImmediately(_this__0._views_9._coroutineContext_6, _no_name_provided_$factory_319(this, event, null));
      Unit_getInstance();
    } else if (tmp0_subject.equals(Type_DOWN_getInstance_0())) {
      launchImmediately(_this__0._views_9._coroutineContext_6, _no_name_provided_$factory_320(this, event, null));
      Unit_getInstance();
    } else if (tmp0_subject.equals(Type_UP_getInstance_0())) {
      launchImmediately(_this__0._views_9._coroutineContext_6, _no_name_provided_$factory_321(this, event, null));
      Unit_getInstance();
    }};
  KeysEvents.$metadata$ = {
    simpleName: 'KeysEvents',
    kind: 'class',
    interfaces: [KeyComponent]
  };
  function _no_name_provided__369() {
  }
  _no_name_provided__369.prototype.invoke_731 = function ($this$$receiver) {
    var tmp2_getOrCreateComponent_0_1 = $this$$receiver._get_componentsSure__21();
    var tmp3_getOrCreateComponent_0_2 = getKClass_0(KeysEvents);
    var tmp1_getOrCreateComponent_0_3 = tmp2_getOrCreateComponent_0_1._get_ekey_();
    var component_1_4 = tmp2_getOrCreateComponent_0_1.findFirstComponentOfType(tmp1_getOrCreateComponent_0_3, tmp3_getOrCreateComponent_0_2);
    if (component_1_4 == null) {
      component_1_4 = new KeysEvents($this$$receiver);
      var tmp0_plusAssign_0_5 = component_1_4;
      tmp1_getOrCreateComponent_0_3.add_39(tmp0_plusAssign_0_5);
      Unit_getInstance();
    }var tmp = component_1_4;
    return tmp instanceof KeysEvents ? tmp : THROW_CCE();
  };
  _no_name_provided__369.prototype.invoke_1015 = function (p1) {
    return this.invoke_731(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__369.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function keys$factory() {
    return getPropertyCallableRef('keys', 1, KProperty1, function (receiver) {
      return _get_keys_(receiver);
    }, null);
  }
  function _no_name_provided_$factory_318() {
    var i = new _no_name_provided__369();
    return function (p1) {
      return i.invoke_731(p1);
    };
  }
  function _no_name_provided_$factory_319(this$0, $event, resultContinuation) {
    var i = new _no_name_provided__366(this$0, $event, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_320(this$0, $event, resultContinuation) {
    var i = new _no_name_provided__367(this$0, $event, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_321(this$0, $event, resultContinuation) {
    var i = new _no_name_provided__368(this$0, $event, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _get_mouse_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = mouse$delegate;
      var tmp1_getValue_0 = mouse$factory();
      var tmp1_safe_receiver_2 = _this_._get_extra__71();
      var tmp;
      if (tmp1_safe_receiver_2 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_3 = tmp0_getValue_0._name_1;
        tmp = tmp1_safe_receiver_2.get_116(tmp0_elvis_lhs_3 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3);
      }
      var tmp_0 = tmp;
      var res_1 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      if (res_1 == null) {
        var r_4 = tmp0_getValue_0._defaultGen_0(_this_);
        if (_this_._get_extra__71() == null)
          _this_._set_extra__71(LinkedHashMap_init_$Create$());
        var tmp1_safe_receiver_2_2_5 = _this_._get_extra__71();
        if (tmp1_safe_receiver_2_2_5 == null)
          null;
        else {
          var tmp0_elvis_lhs_3_4_7 = tmp0_getValue_0._name_1;
          var tmp0_set_0_3_6 = tmp0_elvis_lhs_3_4_7 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3_4_7;
          var tmp1_set_0_5_8 = (r_4 == null ? true : isObject(r_4)) ? r_4 : THROW_CCE();
          tmp1_safe_receiver_2_2_5.put_18(tmp0_set_0_3_6, tmp1_set_0_5_8);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_4;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var mouse$delegate;
  function hitTest($this, views) {
    if (!$this._get_mouseHitSearch_(views._input_0)) {
      $this._set_mouseHitSearch_(views._input_0, true);
      $this._set_mouseHitResult_(views._input_0, views._stage_0.hitTest_20(views._get_nativeMouseX_(), views._get_nativeMouseY_()));
    }return $this._get_mouseHitResult_(views._input_0);
  }
  function _no_name_provided__370() {
  }
  _no_name_provided__370.prototype.invoke_1005 = function () {
    return false;
  };
  _no_name_provided__370.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__371() {
  }
  _no_name_provided__371.prototype.invoke_1005 = function () {
    return null;
  };
  _no_name_provided__371.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__372() {
  }
  _no_name_provided__372.prototype.invoke_1005 = function () {
    return null;
  };
  _no_name_provided__372.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__373() {
  }
  _no_name_provided__373.prototype.invoke_1005 = function () {
    return new Once();
  };
  _no_name_provided__373.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__374($views) {
    this._$views_13 = $views;
  }
  _no_name_provided__374.prototype.invoke_870 = function ($this$null, ctx) {
    var scale_2_5 = ctx._ag_5._get_devicePixelRatio__4();
    var yy_3_6 = 60.0 * scale_2_5;
    var lineHeight_4_7 = 8.0 * scale_2_5;
    var mouseHit_5_8 = hitTest(Companion_getInstance_141(), this._$views_13);
    if (!(mouseHit_5_8 == null)) {
      var bounds_6_9 = mouseHit_5_8.getLocalBounds$default_20(null, false, 3, null);
      var tmp0_tex_7_10 = ctx.getTex(Bitmaps_getInstance()._white);
      var tmp1_x_8_11 = bounds_6_9._x_3;
      var tmp2_y_9_12 = bounds_6_9._y_3;
      var tmp3_width_10_13 = bounds_6_9._width_0;
      var tmp4_height_11_14 = bounds_6_9._height_0;
      var tmp5_colorMul_12_15 = Companion_getInstance_104().invoke_375(255, 0, 0, 63);
      var tmp6_m_13_16 = mouseHit_5_8._get_globalMatrix__20();
      var tmp = $this$null._renderContext._get_batch_();
      tmp.drawQuad$default(tmp0_tex_7_10, tmp1_x_8_11, tmp2_y_9_12, tmp3_width_10_13, tmp4_height_11_14, tmp6_m_13_16, false, tmp5_colorMul_12_15, null, null, false, null, 3904, null);
      var tmp_0 = _get_debugBmpFont_();
      var tmp_1 = lineHeight_4_7;
      var tmp_2 = mouseHit_5_8.toString() + ' : ' + this._$views_13._get_nativeMouseX_() + ',' + this._$views_13._get_nativeMouseY_();
      var tmp_3 = numberToInt(yy_3_6);
      drawText$default($this$null._renderContext, tmp_0, tmp_1, tmp_2, 0, tmp_3, null, null, null, null, false, 992, null);
      yy_3_6 = yy_3_6 + lineHeight_4_7;
    }var mouseHitResultUsed_14_17 = Companion_getInstance_141()._get_mouseHitResultUsed_($this$null._input_0);
    if (!(mouseHitResultUsed_14_17 == null)) {
      var bounds_15_18 = mouseHitResultUsed_14_17.getLocalBounds$default_20(null, false, 3, null);
      var tmp7_tex_16_19 = ctx.getTex(Bitmaps_getInstance()._white);
      var tmp8_x_17_20 = bounds_15_18._x_3;
      var tmp9_y_18_21 = bounds_15_18._y_3;
      var tmp10_width_19_22 = bounds_15_18._width_0;
      var tmp11_height_20_23 = bounds_15_18._height_0;
      var tmp12_colorMul_21_24 = Companion_getInstance_104().invoke_375(0, 0, 255, 63);
      var tmp13_m_22_25 = mouseHitResultUsed_14_17._get_globalMatrix__20();
      var tmp_4 = $this$null._renderContext._get_batch_();
      tmp_4.drawQuad$default(tmp7_tex_16_19, tmp8_x_17_20, tmp9_y_18_21, tmp10_width_19_22, tmp11_height_20_23, tmp13_m_22_25, false, tmp12_colorMul_21_24, null, null, false, null, 3904, null);
      var vview_23_26 = mouseHitResultUsed_14_17;
      while (!(vview_23_26 == null)) {
        var tmp_5 = _get_debugBmpFont_();
        var tmp_6 = lineHeight_4_7;
        var tmp_7 = vview_23_26.toString();
        var tmp_8 = numberToInt(yy_3_6);
        drawText$default($this$null._renderContext, tmp_5, tmp_6, tmp_7, 0, tmp_8, null, null, null, null, false, 992, null);
        var tmp14_safe_receiver_24_27 = vview_23_26;
        vview_23_26 = tmp14_safe_receiver_24_27 == null ? null : tmp14_safe_receiver_24_27._parent_5;
        yy_3_6 = yy_3_6 + lineHeight_4_7;
      }
    }};
  _no_name_provided__374.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof Views ? p1 : THROW_CCE();
    this.invoke_870(tmp, p2 instanceof RenderContext ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__374.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Companion_142() {
    Companion_instance_141 = this;
    var tmp = this;
    tmp._mouseHitSearch$delegate = Property_init_$Create$(null, _no_name_provided_$factory_323(), 1, null);
    var tmp_0 = this;
    tmp_0._mouseHitResult$delegate = Property_init_$Create$(null, _no_name_provided_$factory_324(), 1, null);
    var tmp_1 = this;
    tmp_1._mouseHitResultUsed$delegate = Property_init_$Create$(null, _no_name_provided_$factory_325(), 1, null);
    var tmp_2 = this;
    tmp_2._mouseDebugHandlerOnce$delegate = Property_init_$Create$(null, _no_name_provided_$factory_326(), 1, null);
  }
  Companion_142.prototype._set_mouseHitSearch_ = function (_this__0, _set___) {
    var tmp0_setValue_0 = this._mouseHitSearch$delegate;
    var tmp1_setValue_0 = mouseHitSearch$factory();
    var tmp0_elvis_lhs_2_1 = tmp0_setValue_0._name_0;
    var tmp = tmp0_elvis_lhs_2_1 == null ? tmp1_setValue_0.callableName : tmp0_elvis_lhs_2_1;
    return setExtra(_this__0, tmp, isObject(_set___) ? _set___ : THROW_CCE());
  };
  Companion_142.prototype._get_mouseHitSearch_ = function (_this__0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = this._mouseHitSearch$delegate;
      var tmp1_getValue_0 = mouseHitSearch$factory_0();
      var tmp1_safe_receiver_2 = _this__0._get_extra__71();
      var tmp;
      if (tmp1_safe_receiver_2 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_3 = tmp0_getValue_0._name_0;
        tmp = tmp1_safe_receiver_2.get_116(tmp0_elvis_lhs_3 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3);
      }
      var tmp_0 = tmp;
      var res_1 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      if (res_1 == null) {
        var r_4 = tmp0_getValue_0._defaultGen();
        var tmp0_elvis_lhs_2_2_5 = tmp0_getValue_0._name_0;
        var tmp_1 = tmp0_elvis_lhs_2_2_5 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_2_2_5;
        setExtra(_this__0, tmp_1, (r_4 == null ? true : isObject(r_4)) ? r_4 : THROW_CCE());
        tmp$ret$0 = r_4;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  };
  Companion_142.prototype._set_mouseHitResult_ = function (_this__0, _set___) {
    var tmp0_setValue_0 = this._mouseHitResult$delegate;
    var tmp1_setValue_0 = mouseHitResult$factory();
    var tmp0_elvis_lhs_2_1 = tmp0_setValue_0._name_0;
    var tmp = tmp0_elvis_lhs_2_1 == null ? tmp1_setValue_0.callableName : tmp0_elvis_lhs_2_1;
    return setExtra(_this__0, tmp, (_set___ == null ? true : isObject(_set___)) ? _set___ : THROW_CCE());
  };
  Companion_142.prototype._get_mouseHitResult_ = function (_this__0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = this._mouseHitResult$delegate;
      var tmp1_getValue_0 = mouseHitResult$factory_0();
      var tmp1_safe_receiver_2 = _this__0._get_extra__71();
      var tmp;
      if (tmp1_safe_receiver_2 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_3 = tmp0_getValue_0._name_0;
        tmp = tmp1_safe_receiver_2.get_116(tmp0_elvis_lhs_3 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3);
      }
      var tmp_0 = tmp;
      var res_1 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      if (res_1 == null) {
        var r_4 = tmp0_getValue_0._defaultGen();
        var tmp0_elvis_lhs_2_2_5 = tmp0_getValue_0._name_0;
        var tmp_1 = tmp0_elvis_lhs_2_2_5 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_2_2_5;
        setExtra(_this__0, tmp_1, (r_4 == null ? true : isObject(r_4)) ? r_4 : THROW_CCE());
        tmp$ret$0 = r_4;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  };
  Companion_142.prototype._set_mouseHitResultUsed_ = function (_this__0, _set___) {
    var tmp0_setValue_0 = this._mouseHitResultUsed$delegate;
    var tmp1_setValue_0 = mouseHitResultUsed$factory();
    var tmp0_elvis_lhs_2_1 = tmp0_setValue_0._name_0;
    var tmp = tmp0_elvis_lhs_2_1 == null ? tmp1_setValue_0.callableName : tmp0_elvis_lhs_2_1;
    return setExtra(_this__0, tmp, (_set___ == null ? true : isObject(_set___)) ? _set___ : THROW_CCE());
  };
  Companion_142.prototype._get_mouseHitResultUsed_ = function (_this__0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = this._mouseHitResultUsed$delegate;
      var tmp1_getValue_0 = mouseHitResultUsed$factory_0();
      var tmp1_safe_receiver_2 = _this__0._get_extra__71();
      var tmp;
      if (tmp1_safe_receiver_2 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_3 = tmp0_getValue_0._name_0;
        tmp = tmp1_safe_receiver_2.get_116(tmp0_elvis_lhs_3 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3);
      }
      var tmp_0 = tmp;
      var res_1 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      if (res_1 == null) {
        var r_4 = tmp0_getValue_0._defaultGen();
        var tmp0_elvis_lhs_2_2_5 = tmp0_getValue_0._name_0;
        var tmp_1 = tmp0_elvis_lhs_2_2_5 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_2_2_5;
        setExtra(_this__0, tmp_1, (r_4 == null ? true : isObject(r_4)) ? r_4 : THROW_CCE());
        tmp$ret$0 = r_4;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  };
  Companion_142.prototype._set_mouseDebugHandlerOnce_ = function (_this__0, _set___) {
    var tmp0_setValue_0 = this._mouseDebugHandlerOnce$delegate;
    var tmp1_setValue_0 = mouseDebugHandlerOnce$factory();
    var tmp0_elvis_lhs_2_1 = tmp0_setValue_0._name_0;
    var tmp = tmp0_elvis_lhs_2_1 == null ? tmp1_setValue_0.callableName : tmp0_elvis_lhs_2_1;
    return setExtra(_this__0, tmp, isObject(_set___) ? _set___ : THROW_CCE());
  };
  Companion_142.prototype._get_mouseDebugHandlerOnce_ = function (_this__0) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = this._mouseDebugHandlerOnce$delegate;
      var tmp1_getValue_0 = mouseDebugHandlerOnce$factory_0();
      var tmp1_safe_receiver_2 = _this__0._get_extra__71();
      var tmp;
      if (tmp1_safe_receiver_2 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_3 = tmp0_getValue_0._name_0;
        tmp = tmp1_safe_receiver_2.get_116(tmp0_elvis_lhs_3 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3);
      }
      var tmp_0 = tmp;
      var res_1 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      if (res_1 == null) {
        var r_4 = tmp0_getValue_0._defaultGen();
        var tmp0_elvis_lhs_2_2_5 = tmp0_getValue_0._name_0;
        var tmp_1 = tmp0_elvis_lhs_2_2_5 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_2_2_5;
        setExtra(_this__0, tmp_1, (r_4 == null ? true : isObject(r_4)) ? r_4 : THROW_CCE());
        tmp$ret$0 = r_4;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  };
  Companion_142.prototype.installDebugExtensionOnce = function (views) {
    var tmp0_invoke_0 = this._get_mouseDebugHandlerOnce_(views);
    if (!tmp0_invoke_0._completed) {
      tmp0_invoke_0._completed = true;
      var tmp0_this_2 = views;
      var tmp0_plusAssign_0_3 = tmp0_this_2._debugHandlers;
      tmp0_plusAssign_0_3.add_39(_no_name_provided_$factory_327(views));
      Unit_getInstance();
    }};
  Companion_142.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_141;
  function Companion_getInstance_141() {
    if (Companion_instance_141 == null)
      new Companion_142();
    return Companion_instance_141;
  }
  function MouseEventsUpdate($outer, view) {
    this._$this_24 = $outer;
    this._view_2 = view;
    var tmp = this;
    tmp._$$delegate_0_19 = Mixin_init_$Create$(null, 1, null);
  }
  MouseEventsUpdate.prototype._get_view__6 = function () {
    return this._view_2;
  };
  MouseEventsUpdate.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_19._extra = _set___;
  };
  MouseEventsUpdate.prototype._get_extra__71 = function () {
    return this._$$delegate_0_19._extra;
  };
  MouseEventsUpdate.prototype.update_10 = function (views, dt) {
    this._$this_24.update_10(views, dt);
  };
  MouseEventsUpdate.$metadata$ = {
    simpleName: 'MouseEventsUpdate',
    kind: 'class',
    interfaces: [UpdateComponentWithViews, Extra]
  };
  function MouseEvents(view) {
    Companion_getInstance_141();
    this._view_3 = view;
    var tmp = this;
    tmp._$$delegate_0_20 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._click = Signal_init_$Create$(null, 1, null);
    var tmp_1 = this;
    tmp_1._over = Signal_init_$Create$(null, 1, null);
    var tmp_2 = this;
    tmp_2._out_9 = Signal_init_$Create$(null, 1, null);
    var tmp_3 = this;
    tmp_3._down = Signal_init_$Create$(null, 1, null);
    var tmp_4 = this;
    tmp_4._downFromOutside = Signal_init_$Create$(null, 1, null);
    var tmp_5 = this;
    tmp_5._up = Signal_init_$Create$(null, 1, null);
    var tmp_6 = this;
    tmp_6._upOutside = Signal_init_$Create$(null, 1, null);
    var tmp_7 = this;
    tmp_7._upAnywhere = Signal_init_$Create$(null, 1, null);
    var tmp_8 = this;
    tmp_8._move = Signal_init_$Create$(null, 1, null);
    var tmp_9 = this;
    tmp_9._moveAnywhere = Signal_init_$Create$(null, 1, null);
    var tmp_10 = this;
    tmp_10._moveOutside = Signal_init_$Create$(null, 1, null);
    var tmp_11 = this;
    tmp_11._exit = Signal_init_$Create$(null, 1, null);
    var tmp_12 = this;
    tmp_12._scroll = Signal_init_$Create$(null, 1, null);
    var tmp_13 = this;
    tmp_13._scrollAnywhere = Signal_init_$Create$(null, 1, null);
    var tmp_14 = this;
    tmp_14._scrollOutside = Signal_init_$Create$(null, 1, null);
    this._hitTest = null;
    this._lastOver = false;
    this._lastInside = false;
    this._lastPressing = false;
    this._CLICK_THRESHOLD = 16;
    this._downPosGlobal = Companion_getInstance_80().invoke_1005();
    this._upPosGlobal = Companion_getInstance_80().invoke_1005();
    this._startedPosGlobal = Companion_getInstance_80().invoke_1005();
    this._lastPosGlobal = Companion_getInstance_80().invoke_1005();
    this._currentPosGlobal = Companion_getInstance_80().invoke_1005();
    this.__downPosLocal = Companion_getInstance_80().invoke_1005();
    this.__upPosLocal = Companion_getInstance_80().invoke_1005();
    this.__startedPosLocal = Companion_getInstance_80().invoke_1005();
    this.__lastPosLocal = Companion_getInstance_80().invoke_1005();
    this.__currentPosLocal = Companion_getInstance_80().invoke_1005();
    this.__downPosStage = Companion_getInstance_80().invoke_1005();
    this.__upPosStage = Companion_getInstance_80().invoke_1005();
    this.__startedPosStage = Companion_getInstance_80().invoke_1005();
    this.__lastPosStage = Companion_getInstance_80().invoke_1005();
    this.__currentPosStage = Companion_getInstance_80().invoke_1005();
    this._clickedCount = 0;
    this._lastEventSet = false;
    var tmp_15 = this;
    tmp_15._lastEvent = MouseEvent_init_$Create$(null, 0, 0, 0, null, 0, 0.0, 0.0, 0.0, false, false, false, false, false, 16383, null);
    this._updater = attach(new MouseEventsUpdate(this, this._view_3));
  }
  MouseEvents.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_20._extra = _set___;
  };
  MouseEvents.prototype._get_extra__71 = function () {
    return this._$$delegate_0_20._extra;
  };
  MouseEvents.prototype._get_views__7 = function () {
    var tmp = this._views_3;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  MouseEvents.prototype._get_coroutineContext__22 = function () {
    return this._get_views__7()._coroutineContext_6;
  };
  MouseEvents.prototype._get_isOver_ = function () {
    var tmp0_safe_receiver = this._hitTest;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this._view_3);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  MouseEvents.prototype._get_pressing_ = function () {
    return !(this._get_views__7()._input_0._mouseButtons_0 === 0);
  };
  MouseEvents.prototype.toString = function () {
    return this._lastEvent.toString();
  };
  MouseEvents.prototype.onMouseEvent_0 = function (views, event) {
    this._views_3 = views;
    this._lastEvent = event;
    this._lastEventSet = true;
    var tmp0_subject = event._type_7;
    if (tmp0_subject.equals(Type_UP_getInstance())) {
      this._upPosGlobal.copyFrom_1(views._input_0._mouse_0);
      Unit_getInstance();
      if (this._upPosGlobal.distanceTo_0(this._downPosGlobal) < this._CLICK_THRESHOLD) {
        var tmp1_this = this;
        var tmp2 = tmp1_this._clickedCount;
        tmp1_this._clickedCount = tmp2 + 1 | 0;
        Unit_getInstance();
      }} else if (tmp0_subject.equals(Type_DOWN_getInstance())) {
      this._downPosGlobal.copyFrom_1(views._input_0._mouse_0);
      Unit_getInstance();
    } else if (tmp0_subject.equals(Type_CLICK_getInstance())) {
      if (this._get_isOver_()) {
        this._click.invoke_137(this);
        if (this._click._get_listenerCount__0() > 0) {
          preventDefault(this._view_3);
        }}} else if (tmp0_subject.equals(Type_SCROLL_getInstance())) {
      if (this._get_isOver_()) {
        this._scroll.invoke_137(this);
      } else {
        this._scrollOutside.invoke_137(this);
      }
      this._scrollAnywhere.invoke_137(this);
    } else {
    }
  };
  MouseEvents.prototype.update_10 = function (views, dt) {
    if (!this._view_3._get_mouseEnabled__20())
      return Unit_getInstance();
    this._views_3 = views;
    Companion_getInstance_141().installDebugExtensionOnce(views);
    this._hitTest = hitTest(Companion_getInstance_141(), views);
    var over = this._get_isOver_();
    var inside = views._input_0._mouseInside;
    if (over)
      Companion_getInstance_141()._set_mouseHitResultUsed_(views._input_0, this._view_3);
    var overChanged = !(this._lastOver === over);
    var insideChanged = !(this._lastInside === inside);
    var pressingChanged = !(this._get_pressing_() === this._lastPressing);
    this._currentPosGlobal.copyFrom_1(views._input_0._mouse_0);
    Unit_getInstance();
    if ((!overChanged ? over : false) ? !this._currentPosGlobal.equals(this._lastPosGlobal) : false)
      this._move.invoke_137(this);
    if ((!overChanged ? !over : false) ? !this._currentPosGlobal.equals(this._lastPosGlobal) : false)
      this._moveOutside.invoke_137(this);
    if (!this._currentPosGlobal.equals(this._lastPosGlobal))
      this._moveAnywhere.invoke_137(this);
    if (overChanged ? over : false)
      this._over.invoke_137(this);
    if (overChanged ? !over : false)
      this._out_9.invoke_137(this);
    if ((over ? pressingChanged : false) ? this._get_pressing_() : false) {
      this._startedPosGlobal.copyFrom_1(this._currentPosGlobal);
      Unit_getInstance();
      this._down.invoke_137(this);
    }if (overChanged ? this._get_pressing_() : false) {
      this._downFromOutside.invoke_137(this);
    }if (pressingChanged ? !this._get_pressing_() : false) {
      if (over)
        this._up.invoke_137(this);
      else
        this._upOutside.invoke_137(this);
      this._upAnywhere.invoke_137(this);
    }if (over ? this._clickedCount > 0 : false) {
    }if (insideChanged ? !inside : false) {
      this._moveOutside.invoke_137(this);
      this._out_9.invoke_137(this);
      this._upOutside.invoke_137(this);
      this._exit.invoke_137(this);
    }this._lastOver = over;
    this._lastInside = inside;
    this._lastPressing = this._get_pressing_();
    this._lastPosGlobal.copyFrom_1(this._currentPosGlobal);
    Unit_getInstance();
    this._clickedCount = 0;
  };
  MouseEvents.$metadata$ = {
    simpleName: 'MouseEvents',
    kind: 'class',
    interfaces: [MouseComponent, Extra]
  };
  function _no_name_provided__375() {
  }
  _no_name_provided__375.prototype.invoke_731 = function ($this$$receiver) {
    var tmp2_getOrCreateComponent_0_1 = $this$$receiver._get_componentsSure__21();
    var tmp3_getOrCreateComponent_0_2 = getKClass_0(MouseEvents);
    var tmp1_getOrCreateComponent_0_3 = tmp2_getOrCreateComponent_0_1._get_emouse_();
    var component_1_4 = tmp2_getOrCreateComponent_0_1.findFirstComponentOfType(tmp1_getOrCreateComponent_0_3, tmp3_getOrCreateComponent_0_2);
    if (component_1_4 == null) {
      component_1_4 = new MouseEvents($this$$receiver);
      var tmp0_plusAssign_0_5 = component_1_4;
      tmp1_getOrCreateComponent_0_3.add_39(tmp0_plusAssign_0_5);
      Unit_getInstance();
    }var tmp = component_1_4;
    return tmp instanceof MouseEvents ? tmp : THROW_CCE();
  };
  _no_name_provided__375.prototype.invoke_1015 = function (p1) {
    return this.invoke_731(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__375.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function mouse$factory() {
    return getPropertyCallableRef('mouse', 1, KProperty1, function (receiver) {
      return _get_mouse_(receiver);
    }, null);
  }
  function mouseHitSearch$factory() {
    return getPropertyCallableRef('mouseHitSearch', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitSearch_(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitSearch_(receiver2_0, value);
    });
  }
  function mouseHitSearch$factory_0() {
    return getPropertyCallableRef('mouseHitSearch', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitSearch_(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitSearch_(receiver2_0, value);
    });
  }
  function mouseHitResult$factory() {
    return getPropertyCallableRef('mouseHitResult', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitResult_(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitResult_(receiver2_0, value);
    });
  }
  function mouseHitResult$factory_0() {
    return getPropertyCallableRef('mouseHitResult', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitResult_(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitResult_(receiver2_0, value);
    });
  }
  function mouseHitResultUsed$factory() {
    return getPropertyCallableRef('mouseHitResultUsed', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitResultUsed_(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitResultUsed_(receiver2_0, value);
    });
  }
  function mouseHitResultUsed$factory_0() {
    return getPropertyCallableRef('mouseHitResultUsed', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseHitResultUsed_(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseHitResultUsed_(receiver2_0, value);
    });
  }
  function mouseDebugHandlerOnce$factory() {
    return getPropertyCallableRef('mouseDebugHandlerOnce', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseDebugHandlerOnce_(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseDebugHandlerOnce_(receiver2_0, value);
    });
  }
  function mouseDebugHandlerOnce$factory_0() {
    return getPropertyCallableRef('mouseDebugHandlerOnce', 2, KMutableProperty2, function (receiver1, receiver2) {
      return receiver1._get_mouseDebugHandlerOnce_(receiver2);
    }, function (receiver1_0, receiver2_0, value) {
      return receiver1_0._set_mouseDebugHandlerOnce_(receiver2_0, value);
    });
  }
  function _no_name_provided_$factory_322() {
    var i = new _no_name_provided__375();
    return function (p1) {
      return i.invoke_731(p1);
    };
  }
  function _no_name_provided_$factory_323() {
    var i = new _no_name_provided__370();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_324() {
    var i = new _no_name_provided__371();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_325() {
    var i = new _no_name_provided__372();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_326() {
    var i = new _no_name_provided__373();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_327($views) {
    var i = new _no_name_provided__374($views);
    return function (p1, p2) {
      i.invoke_870(p1, p2);
      return Unit_getInstance();
    };
  }
  function min2_8(a, b) {
    return a < b ? a : b;
  }
  function max2_7(a, b) {
    return a > b ? a : b;
  }
  function min2_9(a, b) {
    return a < b ? a : b;
  }
  function configureLoggerFromProperties(file, $cont) {
    var tmp = new $configureLoggerFromPropertiesCOROUTINE$9(file, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function configureLoggerFromProperties_0(str) {
    var props = Companion_getInstance_142().load_0(str);
    var tmp0_iterator = props._get_entries__10().iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var tmp1_loop_parameter = tmp0_iterator.next_37();
      var key = tmp1_loop_parameter._get_key__37();
      var value = tmp1_loop_parameter._get_value__10();
      try {
        var tmp = Companion_getInstance_39().invoke_203(key);
        tmp._set_level_(valueOf(value.toUpperCase()));
      } catch ($p) {
        if ($p instanceof Error) {
          printStackTrace($p);
        } else {
          {
            throw $p;
          }
        }
      }
    }
  }
  function Props_init_$Init$(props, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      props = LinkedHashMap_init_$Create$();
    Props.call($this, props);
    return $this;
  }
  function Props_init_$Create$(props, $mask0, $marker) {
    return Props_init_$Init$(props, $mask0, $marker, Object.create(Props.prototype));
  }
  function Companion_143() {
    Companion_instance_142 = this;
  }
  Companion_143.prototype.load_0 = function (str) {
    var tmp0_apply_0 = Props_init_$Create$(null, 1, null);
    tmp0_apply_0.deserializeNew(str);
    return tmp0_apply_0;
  };
  Companion_143.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_142;
  function Companion_getInstance_142() {
    if (Companion_instance_142 == null)
      new Companion_143();
    return Companion_instance_142;
  }
  function Props(props) {
    Companion_getInstance_142();
    this._props_13 = props;
  }
  Props.prototype.clear_33 = function () {
    this._props_13.clear_33();
  };
  Props.prototype.containsKey_10 = function (key) {
    return this._props_13.containsKey_11(key);
  };
  Props.prototype.containsKey_11 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_10((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  Props.prototype.get_115 = function (key) {
    return this._props_13.get_116(key);
  };
  Props.prototype.get_116 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_115((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  Props.prototype.isEmpty_53 = function () {
    return this._props_13.isEmpty_53();
  };
  Props.prototype.put_17 = function (key, value) {
    return this._props_13.put_18(key, value);
  };
  Props.prototype.put_18 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.put_17(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  Props.prototype.putAll_6 = function (from) {
    this._props_13.putAll_7(from);
  };
  Props.prototype.putAll_7 = function (from) {
    return this.putAll_6(from);
  };
  Props.prototype.remove_71 = function (key) {
    return this._props_13.remove_72(key);
  };
  Props.prototype.remove_72 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.remove_71((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  Props.prototype._get_entries__10 = function () {
    return this._props_13._get_entries__10();
  };
  Props.prototype._get_size__60 = function () {
    return this._props_13._get_size__60();
  };
  Props.prototype._get_values__9 = function () {
    return this._props_13._get_values__9();
  };
  Props.prototype.deserializeAdd = function (str) {
    var tmp = ['\n'];
    var tmp0_iterator = split$default_0(str, tmp, false, 0, 6, null).iterator_67();
    while (tmp0_iterator.hasNext_33()) {
      var line_1 = tmp0_iterator.next_37();
      var tmp_0 = new Char(35);
      if (startsWith$default(line_1, tmp_0, false, 2, null))
        continue;
      else {
      }
      if (isBlank(line_1))
        continue;
      var tmp_1 = charArrayOf([new Char(61)]);
      var parts_0 = split$default(line_1, tmp_1, false, 2, 2, null);
      var tmp0_trim_0 = parts_0.get_137(0);
      var key = toString_1(trim_0(isCharSequence(tmp0_trim_0) ? tmp0_trim_0 : THROW_CCE()));
      var tmp1_getOrElse_0 = 1;
      var tmp_2;
      if (tmp1_getOrElse_0 >= 0 ? tmp1_getOrElse_0 <= _get_lastIndex__3(parts_0) : false) {
        tmp_2 = parts_0.get_137(tmp1_getOrElse_0);
      } else {
        tmp_2 = ' ';
      }
      var tmp2_trim_0 = tmp_2;
      var value = toString_1(trim_0(isCharSequence(tmp2_trim_0) ? tmp2_trim_0 : THROW_CCE()));
      var tmp3_set_0 = this._props_13;
      tmp3_set_0.put_18(key, value);
      Unit_getInstance();
    }
  };
  Props.prototype.deserializeNew = function (str) {
    this.clear_33();
    this.deserializeAdd(str);
  };
  Props.$metadata$ = {
    simpleName: 'Props',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function $configureLoggerFromPropertiesCOROUTINE$9(file, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this._file_5 = file;
  }
  $configureLoggerFromPropertiesCOROUTINE$9.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._file_5.readString$default(null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            configureLoggerFromProperties_0(ARGUMENT);
            this._exceptionState = 3;
            this._state_1 = 4;
            continue $sm;
          case 2:
            this._exceptionState = 3;
            var tmp_0 = this._exception_0;
            if (tmp_0 instanceof Error) {
              var e = this._exception_0;
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            throw this._exception_0;
          case 4:
            this._exceptionState = 3;
            return Unit_getInstance();
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $configureLoggerFromPropertiesCOROUTINE$9.$metadata$ = {
    simpleName: '$configureLoggerFromPropertiesCOROUTINE$9',
    kind: 'class',
    interfaces: []
  };
  function BitmapTextureInfo() {
    this._textureBase = new Base(null, 0, 0);
    this._slices = FastIdentityMap();
  }
  BitmapTextureInfo.prototype.reset_9 = function () {
    this._textureBase._base_5 = null;
    this._textureBase._version_3 = -1;
    this._textureBase._width_17 = 0;
    this._textureBase._height_17 = 0;
    clear(this._slices);
  };
  BitmapTextureInfo.$metadata$ = {
    simpleName: 'BitmapTextureInfo',
    kind: 'class',
    interfaces: []
  };
  function getTextureInfo($this, bitmap) {
    if ($this._cachedBitmap === bitmap)
      return ensureNotNull($this._cachedBitmapTextureInfo);
    if ($this._cachedBitmap2 === bitmap)
      return ensureNotNull($this._cachedBitmapTextureInfo2);
    var tmp0_this = $this;
    var tmp0_plusAssign_0 = tmp0_this._referencedBitmapsSinceGC;
    tmp0_plusAssign_0.add_39(bitmap);
    Unit_getInstance();
    if (equals_1($this._cachedBitmap, bitmap))
      return ensureNotNull($this._cachedBitmapTextureInfo);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp1_getOrPut_0 = $this._bitmapsToTextureBase;
      var res_1 = get(tmp1_getOrPut_0, bitmap);
      if (!(res_1 == null)) {
        tmp$ret$0 = res_1;
        break l$ret$1;
      }var tmp0_also_0_4 = $this._textureInfoPool.alloc();
      var base_2_5 = tmp0_also_0_4._textureBase;
      base_2_5._version_3 = -1;
      base_2_5._base_5 = $this._ag_2.createTexture_10(bitmap._premultiplied_0);
      base_2_5._width_17 = bitmap._width_2;
      base_2_5._height_17 = bitmap._height_2;
      var out_2 = tmp0_also_0_4;
      set(tmp1_getOrPut_0, bitmap, out_2);
      tmp$ret$0 = out_2;
    }
     while (false);
    var textureInfo = tmp$ret$0;
    $this._cachedBitmap2 = $this._cachedBitmap;
    $this._cachedBitmapTextureInfo2 = $this._cachedBitmapTextureInfo;
    var base = textureInfo._textureBase;
    $this._cachedBitmap = bitmap;
    $this._cachedBitmapTextureInfo = textureInfo;
    if (!(bitmap._contentVersion === base._version_3)) {
      base._version_3 = bitmap._contentVersion;
      base.update_7(bitmap, bitmap._mipmaps);
    }return textureInfo;
  }
  function removeCache($this) {
    $this._cachedBitmap = null;
    $this._cachedBitmapTextureInfo = null;
    $this._cachedBmpSlice = null;
    $this._cachedBmpSliceTexture = null;
  }
  function _no_name_provided__376() {
  }
  _no_name_provided__376.prototype.invoke_649 = function (it) {
    it.reset_9();
  };
  _no_name_provided__376.prototype.invoke_1015 = function (p1) {
    this.invoke_649(p1 instanceof BitmapTextureInfo ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__376.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__377() {
  }
  _no_name_provided__377.prototype.invoke_874 = function (it) {
    return new BitmapTextureInfo();
  };
  _no_name_provided__377.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__377.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AgBitmapTextureManager(ag) {
    this._ag_2 = ag;
    this._referencedBitmapsSinceGC = LinkedHashSet_init_$Create$();
    this._referencedBitmaps = ArrayList_init_$Create$();
    this._framesBetweenGC = 60;
    var tmp = this;
    var tmp_0 = _no_name_provided_$factory_328();
    tmp._textureInfoPool = Pool_init_$Create$(tmp_0, 0, _no_name_provided_$factory_329(), 2, null);
    this._bitmapsToTextureBase = FastIdentityMap();
    this._cachedBitmap = null;
    this._cachedBitmapTextureInfo = null;
    this._cachedBitmap2 = null;
    this._cachedBitmapTextureInfo2 = null;
    this._cachedBmpSlice = null;
    this._cachedBmpSliceTexture = null;
    this._cachedBmpSlice2 = null;
    this._cachedBmpSliceTexture2 = null;
    this._fcount = 0;
  }
  AgBitmapTextureManager.prototype.getTexture = function (slice_1) {
    if (this._cachedBmpSlice === slice_1)
      return ensureNotNull(this._cachedBmpSliceTexture);
    if (this._cachedBmpSlice2 === slice_1)
      return ensureNotNull(this._cachedBmpSliceTexture2);
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._referencedBitmapsSinceGC;
    var tmp1_plusAssign_0 = slice_1._bmpBase;
    tmp0_plusAssign_0.add_39(tmp1_plusAssign_0);
    Unit_getInstance();
    var info = getTextureInfo(this, slice_1._bmpBase);
    var tmp$ret$0;
    l$ret$1: do {
      var tmp2_getOrPut_0 = info._slices;
      var res_1 = get(tmp2_getOrPut_0, slice_1);
      if (!(res_1 == null)) {
        tmp$ret$0 = res_1;
        break l$ret$1;
      }var tmp = ensureNotNull(info._textureBase);
      var out_2 = Texture_init_$Create$(tmp, 0, 0, 0, 0, 30, null).slice_3(Companion_getInstance_83().invoke_310(slice_1._get_left__4(), slice_1._get_top__4(), slice_1._get_width__58(), slice_1._get_height__58()));
      set(tmp2_getOrPut_0, slice_1, out_2);
      tmp$ret$0 = out_2;
    }
     while (false);
    var texture = tmp$ret$0;
    this._cachedBmpSlice2 = this._cachedBmpSlice;
    this._cachedBmpSliceTexture2 = this._cachedBmpSliceTexture;
    this._cachedBmpSlice = slice_1;
    this._cachedBmpSliceTexture = texture;
    return texture;
  };
  AgBitmapTextureManager.prototype.afterRender = function () {
    this._cachedBitmap = null;
    this._cachedBitmap2 = null;
    this._cachedBitmapTextureInfo = null;
    this._cachedBitmapTextureInfo2 = null;
    this._cachedBmpSlice = null;
    this._cachedBmpSlice2 = null;
    this._cachedBmpSliceTexture = null;
    this._cachedBmpSliceTexture2 = null;
    var tmp0_this = this;
    var tmp1 = tmp0_this._fcount;
    tmp0_this._fcount = tmp1 + 1 | 0;
    Unit_getInstance();
    if (this._fcount >= this._framesBetweenGC) {
      this._fcount = 0;
      this.gc();
    }removeCache(this);
  };
  AgBitmapTextureManager.prototype.gc = function () {
    var tmp0_fastForEach_0 = this._referencedBitmaps;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      if (!this._referencedBitmapsSinceGC.contains_58(tmp1__anonymous__3)) {
        this.removeBitmap(tmp1__anonymous__3);
      }}
    this._referencedBitmaps.clear_33();
    this._referencedBitmaps.addAll_24(this._referencedBitmapsSinceGC);
    Unit_getInstance();
    this._referencedBitmapsSinceGC.clear_33();
  };
  AgBitmapTextureManager.prototype.removeBitmap = function (bmp) {
    var tmp0_elvis_lhs = getAndRemove(this._bitmapsToTextureBase, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp1_this = this;
    var tmp0_minusAssign_0 = tmp1_this._referencedBitmapsSinceGC;
    tmp0_minusAssign_0.remove_47(bmp);
    Unit_getInstance();
    if (equals_1(this._cachedBitmapTextureInfo, info))
      removeCache(this);
    info._textureBase.close_77();
    this._textureInfoPool.free(info);
  };
  AgBitmapTextureManager.$metadata$ = {
    simpleName: 'AgBitmapTextureManager',
    kind: 'class',
    interfaces: []
  };
  function getAndRemove(_this_, key) {
    var tmp0_also_0 = get(_this_, key);
    remove_0(_this_, key);
    return tmp0_also_0;
  }
  function _no_name_provided_$factory_328() {
    var i = new _no_name_provided__376();
    return function (p1) {
      i.invoke_649(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_329() {
    var i = new _no_name_provided__377();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  var logger;
  function _no_name_provided__378() {
  }
  _no_name_provided__378.prototype.invoke_664 = function ($this$VertexShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$VertexShader.SET(tmp0_apply_0._v_Tex, tmp0_apply_0._a_Tex);
    $this$VertexShader.SET(Companion_getInstance_143()._v_ColMul, Companion_getInstance_143()._a_ColMul);
    $this$VertexShader.SET(Companion_getInstance_143()._v_ColAdd, Companion_getInstance_143()._a_ColAdd);
    $this$VertexShader.SET($this$VertexShader._out_8, $this$VertexShader.times_0($this$VertexShader.times_0(tmp0_apply_0._u_ProjMat, tmp0_apply_0._u_ViewMat), $this$VertexShader.vec4([DefaultShaders_getInstance()._a_Pos, $this$VertexShader._get_lit_(0.0), $this$VertexShader._get_lit_(1.0)])));
    Unit_getInstance();
  };
  _no_name_provided__378.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__378.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__379($premultiplied) {
    this._$premultiplied = $premultiplied;
  }
  _no_name_provided__379.prototype.invoke_664 = function ($this$FragmentShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$FragmentShader.SET($this$FragmentShader._out_8, $this$FragmentShader.texture2D(tmp0_apply_0._u_Tex, $this$FragmentShader.get_96(tmp0_apply_0._v_Tex, 'xy')));
    if (this._$premultiplied) {
      $this$FragmentShader.SET($this$FragmentShader.get_96($this$FragmentShader._out_8, 'rgb'), $this$FragmentShader.div_0($this$FragmentShader.get_96($this$FragmentShader._out_8, 'rgb'), $this$FragmentShader.get_96($this$FragmentShader._out_8, 'a')));
    }$this$FragmentShader.SET($this$FragmentShader._out_8, $this$FragmentShader.plus_31($this$FragmentShader.times_0($this$FragmentShader.get_96($this$FragmentShader._out_8, 'rgba'), $this$FragmentShader.get_96(Companion_getInstance_143()._v_ColMul, 'rgba')), $this$FragmentShader.times_0($this$FragmentShader.minus_1($this$FragmentShader.get_96(Companion_getInstance_143()._v_ColAdd, 'rgba'), $this$FragmentShader.vec4([$this$FragmentShader._get_lit_(0.5), $this$FragmentShader._get_lit_(0.5), $this$FragmentShader._get_lit_(0.5), $this$FragmentShader._get_lit_(0.5)])), $this$FragmentShader._get_lit_(2.0))));
    if (this._$premultiplied) {
      var tmp0_IF_0_2 = $this$FragmentShader.le($this$FragmentShader.get_96($this$FragmentShader._out_8, 'a'), $this$FragmentShader._get_lit_(0.0));
      var body_1_3 = new Builder($this$FragmentShader._type_4);
      body_1_3.DISCARD();
      var tmp = new Stms(body_1_3._outputStms);
      var stmIf_2_4 = If_init_$Create$(tmp0_IF_0_2, tmp, null, 4, null);
      var tmp0_this_3_5 = $this$FragmentShader;
      var tmp0_plusAssign_0_4_6 = tmp0_this_3_5._outputStms;
      tmp0_plusAssign_0_4_6.add_39(stmIf_2_4);
      Unit_getInstance();
      Unit_getInstance();
    }Unit_getInstance();
  };
  _no_name_provided__379.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__379.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
    var tmp0_set_0 = pos + 0 | 0;
    var tmp1_set_0 = toShort(i0);
    indicesI16[tmp0_set_0] = tmp1_set_0;
    var tmp2_set_0 = pos + 1 | 0;
    var tmp3_set_0 = toShort(i1);
    indicesI16[tmp2_set_0] = tmp3_set_0;
    var tmp4_set_0 = pos + 2 | 0;
    var tmp5_set_0 = toShort(i2);
    indicesI16[tmp4_set_0] = tmp5_set_0;
    var tmp6_set_0 = pos + 3 | 0;
    var tmp7_set_0 = toShort(i3);
    indicesI16[tmp6_set_0] = tmp7_set_0;
    var tmp8_set_0 = pos + 4 | 0;
    var tmp9_set_0 = toShort(i4);
    indicesI16[tmp8_set_0] = tmp9_set_0;
    var tmp10_set_0 = pos + 5 | 0;
    var tmp11_set_0 = toShort(i5);
    indicesI16[tmp10_set_0] = tmp11_set_0;
    return 6;
  }
  function checkAvailable($this, indices, vertices) {
    return ($this._indexPos + indices | 0) < $this._maxIndices ? true : ($this._vertexPos + vertices | 0) < $this._maxVertices;
  }
  function Companion_144() {
    Companion_instance_143 = this;
    this._DEFAULT_BATCH_QUADS = 4096;
    this._MAX_BATCH_QUADS = 16383;
    var tmp0_trace_0 = logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_0(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog(tmp0_log_0_1, 'BatchBuilder2D.Companion[0]');
    }this._a_ColMul = DefaultShaders_getInstance()._a_Col;
    var tmp = this;
    var tmp_0 = VarType_Byte4_getInstance();
    tmp._a_ColAdd = Attribute_init_$Create$_0('a_Col2', tmp_0, true, null, 8, null);
    var tmp0_trace_0_0 = logger;
    var tmp0_log_0_1_0 = Level_TRACE_getInstance();
    if (tmp0_trace_0_0.isEnabled_0(tmp0_log_0_1_0)) {
      tmp0_trace_0_0.actualLog(tmp0_log_0_1_0, 'BatchBuilder2D.Companion[1]');
    }this._v_ColMul = DefaultShaders_getInstance()._v_Col;
    var tmp_1 = this;
    var tmp_2 = VarType_Byte4_getInstance();
    tmp_1._v_ColAdd = Varying_init_$Create$_0('v_Col2', tmp_2, null, 4, null);
    var tmp0_trace_0_1 = logger;
    var tmp0_log_0_1_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0_1.isEnabled_0(tmp0_log_0_1_1)) {
      tmp0_trace_0_1.actualLog(tmp0_log_0_1_1, 'BatchBuilder2D.Companion[2]');
    }this._LAYOUT = VertexLayout_init_$Create$([DefaultShaders_getInstance()._a_Pos, DefaultShaders_getInstance()._a_Tex, this._a_ColMul, this._a_ColAdd]);
    var tmp_3 = this;
    tmp_3._VERTEX = VertexShader_0(_no_name_provided_$factory_332());
    var tmp0_trace_0_2 = logger;
    var tmp0_log_0_1_2 = Level_TRACE_getInstance();
    if (tmp0_trace_0_2.isEnabled_0(tmp0_log_0_1_2)) {
      tmp0_trace_0_2.actualLog(tmp0_log_0_1_2, 'BatchBuilder2D.Companion[3]');
    }this._FRAGMENT_PRE = this.buildTextureLookupFragment(true);
    this._FRAGMENT_NOPRE = this.buildTextureLookupFragment(false);
    this._PROGRAM_PRE = new Program(this._VERTEX, this._FRAGMENT_PRE, 'BatchBuilder2D.Premultiplied.Tinted');
    this._PROGRAM_NOPRE = new Program(this._VERTEX, this._FRAGMENT_NOPRE, 'BatchBuilder2D.NoPremultiplied.Tinted');
    var tmp0_trace_0_3 = logger;
    var tmp0_log_0_1_3 = Level_TRACE_getInstance();
    if (tmp0_trace_0_3.isEnabled_0(tmp0_log_0_1_3)) {
      tmp0_trace_0_3.actualLog(tmp0_log_0_1_3, 'BatchBuilder2D.Companion[4]');
    }}
  Companion_144.prototype.buildTextureLookupFragment = function (premultiplied) {
    return FragmentShader_0(_no_name_provided_$factory_333(premultiplied));
  };
  Companion_144.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_143;
  function Companion_getInstance_143() {
    if (Companion_instance_143 == null)
      new Companion_144();
    return Companion_instance_143;
  }
  function _no_name_provided__380(this$0) {
    this._this$0_103 = this$0;
  }
  _no_name_provided__380.prototype.invoke_660 = function (it) {
    this._this$0_103.flush$default(false, false, 3, null);
  };
  _no_name_provided__380.prototype.invoke_1015 = function (p1) {
    this.invoke_660(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__380.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__381(this$0) {
    this._this$0_104 = this$0;
  }
  _no_name_provided__381.prototype.invoke_1005 = function () {
    return UniformValues_init_$Create$([to(DefaultShaders_getInstance()._u_ProjMat, this._this$0_104._projMat), to(DefaultShaders_getInstance()._u_ViewMat, this._this$0_104._viewMat), to(DefaultShaders_getInstance()._u_Tex, this._this$0_104._textureUnit_0)]);
  };
  _no_name_provided__381.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function BatchBuilder2D(ctx, reqMaxQuads) {
    Companion_getInstance_143();
    this._ctx_6 = ctx;
    this._reqMaxQuads = reqMaxQuads;
    this._maxQuads = min2_8(this._reqMaxQuads, Companion_getInstance_143()._MAX_BATCH_QUADS);
    this._texManager = this._ctx_6._agBitmapTextureManager;
    this._ag_3 = this._ctx_6._ag_5;
    var tmp0_trace_0 = logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_0(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog(tmp0_log_0_1, 'BatchBuilder2D[0]');
    }this._ctx_6._flushers.add_41(_no_name_provided_$factory_330(this));
    Unit_getInstance();
    this._flipRenderTexture_0 = true;
    this._maxQuadsMargin = this._maxQuads + 9 | 0;
    this._maxVertices = imul(this._maxQuads, 4);
    this._maxIndices = imul(this._maxQuads, 6);
    var tmp0_trace_0_0 = logger;
    var tmp0_log_0_1_0 = Level_TRACE_getInstance();
    if (tmp0_trace_0_0.isEnabled_0(tmp0_log_0_1_0)) {
      tmp0_trace_0_0.actualLog(tmp0_log_0_1_0, 'BatchBuilder2D[1]');
    }this._vertices_1 = Companion_getInstance_38().alloc_0(imul(24, this._maxVertices));
    this._indices_0 = Companion_getInstance_38().alloc_0(imul(2, this._maxIndices));
    var tmp = this;
    var tmp0__get_i16__0 = this._indices_0;
    tmp._indicesI16 = tmp0__get_i16__0._arrayShort;
    var tmp_0 = this;
    var tmp0__get_i32__0 = this._vertices_1;
    tmp_0._verticesI32 = tmp0__get_i32__0._arrayInt;
    var tmp_1 = this;
    var tmp0__get_f32__0 = this._vertices_1;
    tmp_1._verticesF32 = tmp0__get_f32__0._arrayFloat;
    this._verticesData_0 = this._vertices_1._data_9;
    this._verticesFast32 = this._vertices_1._fast32;
    var tmp0_trace_0_1 = logger;
    var tmp0_log_0_1_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0_1.isEnabled_0(tmp0_log_0_1_1)) {
      tmp0_trace_0_1.actualLog(tmp0_log_0_1_1, 'BatchBuilder2D[2]');
    }this._vertexCount_0 = 0;
    this._vertexPos = 0;
    this._indexPos = 0;
    this._currentTex = null;
    this._currentSmoothing = false;
    this._currentBlendFactors = BlendMode_NORMAL_getInstance_0()._factors;
    this._currentProgram = null;
    var tmp0_trace_0_2 = logger;
    var tmp0_log_0_1_2 = Level_TRACE_getInstance();
    if (tmp0_trace_0_2.isEnabled_0(tmp0_log_0_1_2)) {
      tmp0_trace_0_2.actualLog(tmp0_log_0_1_2, 'BatchBuilder2D[3]');
    }this._vertexBuffer = this._ag_3.createVertexBuffer_4();
    this._indexBuffer = this._ag_3.createIndexBuffer_4();
    var tmp0_trace_0_3 = logger;
    var tmp0_log_0_1_3 = Level_TRACE_getInstance();
    if (tmp0_trace_0_3.isEnabled_0(tmp0_log_0_1_3)) {
      tmp0_trace_0_3.actualLog(tmp0_log_0_1_3, 'BatchBuilder2D[4]');
    }var tmp_2 = this;
    tmp_2._stencil_0 = StencilState_init_$Create$(false, null, null, null, null, null, 0, 0, 0, 511, null);
    var tmp0_trace_0_4 = logger;
    var tmp0_log_0_1_4 = Level_TRACE_getInstance();
    if (tmp0_trace_0_4.isEnabled_0(tmp0_log_0_1_4)) {
      tmp0_trace_0_4.actualLog(tmp0_log_0_1_4, 'BatchBuilder2D[5]');
    }var tmp_3 = this;
    tmp_3._colorMask_0 = ColorMaskState_init_$Create$(false, false, false, false, 15, null);
    var tmp0_trace_0_5 = logger;
    var tmp0_log_0_1_5 = Level_TRACE_getInstance();
    if (tmp0_trace_0_5.isEnabled_0(tmp0_log_0_1_5)) {
      tmp0_trace_0_5.actualLog(tmp0_log_0_1_5, 'BatchBuilder2D[6]');
    }this._scissor_1 = null;
    var tmp_4 = this;
    tmp_4._identity_0 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp0_trace_0_6 = logger;
    var tmp0_log_0_1_6 = Level_TRACE_getInstance();
    if (tmp0_trace_0_6.isEnabled_0(tmp0_log_0_1_6)) {
      tmp0_trace_0_6.actualLog(tmp0_log_0_1_6, 'BatchBuilder2D[7]');
    }this._ptt1 = Companion_getInstance_80().invoke_1005();
    this._ptt2 = Companion_getInstance_80().invoke_1005();
    this._pt1 = Companion_getInstance_80().invoke_1005();
    this._pt2 = Companion_getInstance_80().invoke_1005();
    this._pt3 = Companion_getInstance_80().invoke_1005();
    this._pt4 = Companion_getInstance_80().invoke_1005();
    this._pt5 = Companion_getInstance_80().invoke_1005();
    this._pt6 = Companion_getInstance_80().invoke_1005();
    this._pt7 = Companion_getInstance_80().invoke_1005();
    this._pt8 = Companion_getInstance_80().invoke_1005();
    var tmp0_trace_0_7 = logger;
    var tmp0_log_0_1_7 = Level_TRACE_getInstance();
    if (tmp0_trace_0_7.isEnabled_0(tmp0_log_0_1_7)) {
      tmp0_trace_0_7.actualLog(tmp0_log_0_1_7, 'BatchBuilder2D[8]');
    }this._projMat = new Matrix3D();
    this._viewMat = new Matrix3D();
    var tmp0_trace_0_8 = logger;
    var tmp0_log_0_1_8 = Level_TRACE_getInstance();
    if (tmp0_trace_0_8.isEnabled_0(tmp0_log_0_1_8)) {
      tmp0_trace_0_8.actualLog(tmp0_log_0_1_8, 'BatchBuilder2D[9]');
    }this._textureUnit_0 = new TextureUnit(null, false);
    var tmp0_trace_0_9 = logger;
    var tmp0_log_0_1_9 = Level_TRACE_getInstance();
    if (tmp0_trace_0_9.isEnabled_0(tmp0_log_0_1_9)) {
      tmp0_trace_0_9.actualLog(tmp0_log_0_1_9, 'BatchBuilder2D[10]');
    }var tmp_5 = this;
    tmp_5._uniforms$delegate = lazy(_no_name_provided_$factory_331(this));
    var tmp0_trace_0_10 = logger;
    var tmp0_log_0_1_10 = Level_TRACE_getInstance();
    if (tmp0_trace_0_10.isEnabled_0(tmp0_log_0_1_10)) {
      tmp0_trace_0_10.actualLog(tmp0_log_0_1_10, 'BatchBuilder2D[11]');
    }this._tempRect_3 = Companion_getInstance_83().invoke_1005();
    var tmp_6 = this;
    tmp_6._beforeFlush = Signal_init_$Create$(null, 1, null);
    this._tempOldUniforms = new UniformValues();
  }
  BatchBuilder2D.prototype._get_uniforms__3 = function () {
    var tmp0_getValue_0 = this._uniforms$delegate;
    var tmp1_getValue_0 = uniforms$factory();
    return tmp0_getValue_0._get_value__10();
  };
  BatchBuilder2D.prototype.addVertex = function (x, y, u, v, colorMul, colorAdd) {
    this._addVertex(x, y, u, v, _RGBA___get_value__impl_(colorMul), _ColorAdd___get_value__impl_(colorAdd));
  };
  BatchBuilder2D.prototype._addVertex = function (x, y, u, v, colorMul, colorAdd) {
    var tmp0_this = this;
    tmp0_this._vertexPos = tmp0_this._vertexPos + this._addVertex_0(this._verticesFast32, this._vertexPos, x, y, u, v, colorMul, colorAdd) | 0;
    var tmp1_this = this;
    var tmp2 = tmp1_this._vertexCount_0;
    tmp1_this._vertexCount_0 = tmp2 + 1 | 0;
    Unit_getInstance();
  };
  BatchBuilder2D.prototype._addVertex_0 = function (vd, vp, x, y, u, v, colorMul, colorAdd) {
    var tmp0_setF_0 = vp + 0 | 0;
    var tmp0_set_0_1 = vd._f32;
    tmp0_set_0_1[tmp0_setF_0] = x;
    var tmp1_setF_0 = vp + 1 | 0;
    var tmp0_set_0_1_0 = vd._f32;
    tmp0_set_0_1_0[tmp1_setF_0] = y;
    var tmp2_setF_0 = vp + 2 | 0;
    var tmp0_set_0_1_1 = vd._f32;
    tmp0_set_0_1_1[tmp2_setF_0] = u;
    var tmp3_setF_0 = vp + 3 | 0;
    var tmp0_set_0_1_2 = vd._f32;
    tmp0_set_0_1_2[tmp3_setF_0] = v;
    var tmp4_setI_0 = vp + 4 | 0;
    var tmp0_set_0_1_3 = vd._i32;
    tmp0_set_0_1_3[tmp4_setI_0] = colorMul;
    var tmp5_setI_0 = vp + 5 | 0;
    var tmp0_set_0_1_4 = vd._i32;
    tmp0_set_0_1_4[tmp5_setI_0] = colorAdd;
    return 6;
  };
  BatchBuilder2D.prototype.addIndex = function (idx) {
    var tmp0_set_0 = this._indicesI16;
    var tmp0_this = this;
    var tmp1 = tmp0_this._indexPos;
    tmp0_this._indexPos = tmp1 + 1 | 0;
    var tmp1_set_0 = tmp1;
    var tmp2_set_0 = toShort(idx);
    tmp0_set_0[tmp1_set_0] = tmp2_set_0;
  };
  BatchBuilder2D.prototype.drawQuadFast = function (x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, colorAdd, rotated) {
    this.drawQuadFast_0(x0, y0, x1, y1, x2, y2, x3, y3, tex._x0_0, tex._y0_0, tex._x1_0, tex._y1_0, colorMul, colorAdd, rotated);
  };
  BatchBuilder2D.prototype.drawQuadFast_0 = function (x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, colorMul, colorAdd, rotated) {
    this.ensure_0(6, 4);
    this.addQuadIndices$default(0, 1, null);
    if (rotated) {
      this.addQuadVerticesFastRotated(x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, colorMul, colorAdd);
    } else {
      this.addQuadVerticesFastNormal(x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, _RGBA___get_value__impl_(colorMul), _ColorAdd___get_value__impl_(colorAdd));
    }
  };
  BatchBuilder2D.prototype.addQuadIndices = function (vc) {
    var tmp0_this = this;
    tmp0_this._indexPos = tmp0_this._indexPos + _addIndices(this, this._indicesI16, this._indexPos, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  };
  BatchBuilder2D.prototype.addQuadIndices$default = function (vc, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      vc = this._vertexCount_0;
    return this.addQuadIndices(vc);
  };
  BatchBuilder2D.prototype.addQuadVerticesFastNormal = function (x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, colorMul, colorAdd) {
    this._vertexPos = this._addQuadVerticesFastNormal(this._vertexPos, this._verticesFast32, x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, colorMul, colorAdd);
    var tmp0_this = this;
    tmp0_this._vertexCount_0 = tmp0_this._vertexCount_0 + 4 | 0;
  };
  BatchBuilder2D.prototype._addQuadVerticesFastNormal = function (vp, vd, x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, colorMul, colorAdd) {
    var vp_0 = vp;
    vp_0 = vp_0 + this._addVertex_0(vd, vp_0, x0, y0, tx0, ty0, colorMul, colorAdd) | 0;
    vp_0 = vp_0 + this._addVertex_0(vd, vp_0, x1, y1, tx1, ty0, colorMul, colorAdd) | 0;
    vp_0 = vp_0 + this._addVertex_0(vd, vp_0, x2, y2, tx1, ty1, colorMul, colorAdd) | 0;
    vp_0 = vp_0 + this._addVertex_0(vd, vp_0, x3, y3, tx0, ty1, colorMul, colorAdd) | 0;
    return vp_0;
  };
  BatchBuilder2D.prototype.addQuadVerticesFastRotated = function (x0, y0, x1, y1, x2, y2, x3, y3, tx0, ty0, tx1, ty1, colorMul, colorAdd) {
    this.addVertex(x0, y0, tx0, ty0, colorMul, colorAdd);
    this.addVertex(x1, y1, tx1, ty0, colorMul, colorAdd);
    this.addVertex(x2, y2, tx1, ty1, colorMul, colorAdd);
    this.addVertex(x3, y3, tx0, ty1, colorMul, colorAdd);
  };
  BatchBuilder2D.prototype.drawVertices = function (array, vcount, icount) {
    this.ensure_0(icount, vcount);
    var inductionVariable = 0;
    var last_1 = min2_8(icount, array._isize);
    if (inductionVariable < last_1)
      do {
        var idx = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.addIndex(this._vertexCount_0 + array._indices_1[idx] | 0);
      }
       while (inductionVariable < last_1);
    Companion_getInstance_38().copy(array.__data, 0, this._vertices_1, imul(this._vertexPos, 4), imul(imul(vcount, 6), 4));
    var tmp1_this = this;
    tmp1_this._vertexCount_0 = tmp1_this._vertexCount_0 + vcount | 0;
    var tmp2_this = this;
    tmp2_this._vertexPos = tmp2_this._vertexPos + imul(vcount, 6) | 0;
  };
  BatchBuilder2D.prototype.drawVertices_0 = function (array, tex, smoothing, blendFactors, vcount, icount, program) {
    this.setStateFast(tex, smoothing, blendFactors, program);
    this.drawVertices(array, vcount, icount);
  };
  BatchBuilder2D.prototype.drawVertices$default = function (array, tex, smoothing, blendFactors, vcount, icount, program, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      vcount = array._vcount;
    if (!(($mask0 & 32) === 0))
      icount = array._isize;
    if (!(($mask0 & 64) === 0))
      program = null;
    return this.drawVertices_0(array, tex, smoothing, blendFactors, vcount, icount, program);
  };
  BatchBuilder2D.prototype.ensure_0 = function (indices, vertices) {
    if (!checkAvailable(this, indices, vertices)) {
      this.flush$default(false, false, 3, null);
    }if (!checkAvailable(this, indices, vertices)) {
      var tmp0_error_0 = 'Too much vertices';
      throw IllegalStateException_init_$Create$_0(toString_1(tmp0_error_0));
    }};
  BatchBuilder2D.prototype.setStateFast = function (tex, smoothing, blendFactors, program) {
    return this.setStateFast_0(tex._base_5, smoothing, blendFactors, program);
  };
  BatchBuilder2D.prototype.setStateFast_0 = function (tex, smoothing, blendFactors, program) {
    if (((tex === this._currentTex ? this._currentSmoothing === smoothing : false) ? this._currentBlendFactors === blendFactors : false) ? this._currentProgram === program : false)
      return Unit_getInstance();
    this.flush$default(false, false, 3, null);
    this._currentTex = tex;
    this._currentSmoothing = smoothing;
    this._currentBlendFactors = (!(tex == null) ? tex._isFbo : false) ? toRenderFboIntoBack(blendFactors) : blendFactors;
    this._currentProgram = program;
  };
  BatchBuilder2D.prototype.drawNinePatch = function (tex, x, y, width, height, posCuts, texCuts, m, filtering, colorMul, colorAdd, blendFactors, program) {
    this.setStateFast(tex._base_6, filtering, blendFactors, program);
    this.ensure_0(54, 16);
    var p_o = this._pt1.setToTransform(m, this._ptt1.setTo_1(x, y));
    var p_dU = this._pt2.setToSub(this._ptt1.setToTransform(m, this._ptt1.setTo_1(x + width, y)), p_o);
    var p_dV = this._pt3.setToSub(this._ptt1.setToTransform(m, this._ptt1.setTo_1(x, y + height)), p_o);
    var t_o = this._pt4.setTo_1(tex._x0_0, tex._y0_0);
    var t_dU = this._pt5.setToSub(this._ptt1.setTo_1(tex._x1_0, tex._y0_0), t_o);
    var t_dV = this._pt6.setToSub(this._ptt1.setTo_1(tex._x0_0, tex._y1_0), t_o);
    var start = this._vertexCount_0;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var posCutY = posCuts[cy]._y_2;
        var texCutY = texCuts[cy]._y_2;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var cx = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var posCutX = posCuts[cx]._x_2;
            var texCutX = texCuts[cx]._x_2;
            var p = this._pt7.setToAdd(p_o, this._ptt1.setToAdd(this._ptt1.setToMul(p_dU, posCutX), this._ptt2.setToMul(p_dV, posCutY)));
            var t = this._pt8.setToAdd(t_o, this._ptt1.setToAdd(this._ptt1.setToMul(t_dU, texCutX), this._ptt2.setToMul(t_dV, texCutY)));
            this.addVertex(p._x_2, p._y_2, t._x_2, t._y_2, colorMul, colorAdd);
          }
           while (inductionVariable_0 < 4);
      }
       while (inductionVariable < 4);
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < 3)
      do {
        var cy_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < 3)
          do {
            var cx_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var v0 = (start + imul(cy_0, 4) | 0) + cx_0 | 0;
            var v1 = v0 + 1 | 0;
            var v2 = v0 + 4 | 0;
            var v3 = v0 + 5 | 0;
            this.addIndex(v0);
            this.addIndex(v1);
            this.addIndex(v2);
            this.addIndex(v2);
            this.addIndex(v1);
            this.addIndex(v3);
          }
           while (inductionVariable_2 < 3);
      }
       while (inductionVariable_1 < 3);
  };
  BatchBuilder2D.prototype.drawNinePatch$default = function (tex, x, y, width, height, posCuts, texCuts, m, filtering, colorMul, colorAdd, blendFactors, program, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      x = 0.0;
    if (!(($mask0 & 4) === 0))
      y = 0.0;
    if (!(($mask0 & 8) === 0))
      width = tex._width_18;
    if (!(($mask0 & 16) === 0))
      height = tex._height_18;
    if (!(($mask0 & 128) === 0))
      m = this._identity_0;
    if (!(($mask0 & 256) === 0))
      filtering = true;
    if (!(($mask0 & 512) === 0))
      colorMul = Colors_getInstance()._WHITE;
    if (!(($mask0 & 1024) === 0))
      colorAdd = Companion_getInstance_102()._NEUTRAL;
    if (!(($mask0 & 2048) === 0))
      blendFactors = BlendMode_NORMAL_getInstance_0()._factors;
    if (!(($mask0 & 4096) === 0))
      program = null;
    return this.drawNinePatch(tex, x, y, width, height, posCuts, texCuts, m, filtering, colorMul, colorAdd, blendFactors, program);
  };
  BatchBuilder2D.prototype.drawQuad = function (tex, x, y, width, height, m, filtering, colorMul, colorAdd, blendFactors, rotated, program) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.setStateFast(tex._base_6, filtering, blendFactors, program);
    this.drawQuadFast(m.transformXf(x0, y0), m.transformYf(x0, y0), m.transformXf(x1, y0), m.transformYf(x1, y0), m.transformXf(x1, y1), m.transformYf(x1, y1), m.transformXf(x0, y1), m.transformYf(x0, y1), tex, colorMul, colorAdd, rotated);
  };
  BatchBuilder2D.prototype.drawQuad$default = function (tex, x, y, width, height, m, filtering, colorMul, colorAdd, blendFactors, rotated, program, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      x = 0.0;
    if (!(($mask0 & 4) === 0))
      y = 0.0;
    if (!(($mask0 & 8) === 0))
      width = tex._width_18;
    if (!(($mask0 & 16) === 0))
      height = tex._height_18;
    if (!(($mask0 & 32) === 0))
      m = this._identity_0;
    if (!(($mask0 & 64) === 0))
      filtering = true;
    if (!(($mask0 & 128) === 0))
      colorMul = Colors_getInstance()._WHITE;
    if (!(($mask0 & 256) === 0))
      colorAdd = Companion_getInstance_102()._NEUTRAL;
    if (!(($mask0 & 512) === 0))
      blendFactors = BlendMode_NORMAL_getInstance_0()._factors;
    if (!(($mask0 & 1024) === 0))
      rotated = false;
    if (!(($mask0 & 2048) === 0))
      program = null;
    return this.drawQuad(tex, x, y, width, height, m, filtering, colorMul, colorAdd, blendFactors, rotated, program);
  };
  BatchBuilder2D.prototype.uploadVertices = function () {
    this._vertexBuffer.upload_8(this._vertices_1, 0, imul(this._vertexPos, 4));
    Unit_getInstance();
  };
  BatchBuilder2D.prototype.uploadIndices = function () {
    this._indexBuffer.upload_8(this._indices_0, 0, imul(this._indexPos, 2));
    Unit_getInstance();
  };
  BatchBuilder2D.prototype.flush_6 = function (uploadVertices, uploadIndices) {
    if (this._vertexCount_0 > 0) {
      if (this._flipRenderTexture_0 ? this._ag_3._get_renderingToTexture__4() : false) {
        this._projMat.setToOrtho_0(this._tempRect_3.setBounds_0(0, this._ag_3._get_currentHeight__4(), this._ag_3._get_currentWidth__4(), 0), -1.0, 1.0);
        Unit_getInstance();
      } else {
        this._projMat.setToOrtho_0(this._tempRect_3.setBounds_0(0, 0, this._ag_3._get_currentWidth__4(), this._ag_3._get_currentHeight__4()), -1.0, 1.0);
        Unit_getInstance();
      }
      var factors = this._currentBlendFactors;
      if (uploadVertices)
        this.uploadVertices();
      if (uploadIndices)
        this.uploadIndices();
      this._textureUnit_0._texture_2 = this._currentTex;
      this._textureUnit_0._linear_0 = this._currentSmoothing;
      var realFactors = this._ag_3._get_renderingToTexture__4() ? toRenderImageIntoFbo(factors) : factors;
      var tmp2_vertices = this._vertexBuffer;
      var tmp3_indices = this._indexBuffer;
      var tmp1_elvis_lhs = this._currentProgram;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        var tmp_0;
        var tmp0_safe_receiver = this._currentTex;
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_premultiplied__8()) === true) {
          tmp_0 = Companion_getInstance_143()._PROGRAM_PRE;
        } else {
          {
            tmp_0 = Companion_getInstance_143()._PROGRAM_NOPRE;
          }
        }
        tmp = tmp_0;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var tmp4_program = tmp;
      var tmp5_type = DrawType_TRIANGLES_getInstance();
      var tmp6_vertexLayout = Companion_getInstance_143()._LAYOUT;
      var tmp7_vertexCount = this._indexPos;
      var tmp8_uniforms = this._get_uniforms__3();
      var tmp9_stencil = this._stencil_0;
      var tmp10_colorMask = this._colorMask_0;
      var tmp11_scissor = this._scissor_1;
      this._ag_3.draw$default(tmp2_vertices, tmp4_program, tmp5_type, tmp6_vertexLayout, tmp7_vertexCount, tmp3_indices, null, 0, realFactors, tmp8_uniforms, tmp9_stencil, tmp10_colorMask, null, tmp11_scissor, 4288, null);
      this._beforeFlush.invoke_137(this);
    }this._vertexCount_0 = 0;
    this._vertexPos = 0;
    this._indexPos = 0;
    this._currentTex = null;
  };
  BatchBuilder2D.prototype.flush$default = function (uploadVertices, uploadIndices, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      uploadVertices = true;
    if (!(($mask0 & 2) === 0))
      uploadIndices = true;
    return this.flush_6(uploadVertices, uploadIndices);
  };
  BatchBuilder2D.$metadata$ = {
    simpleName: 'BatchBuilder2D',
    kind: 'class',
    interfaces: []
  };
  function TexturedVertexArray_init_$Init$(vcount, indices, isize, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      isize = indices.length;
    TexturedVertexArray.call($this, vcount, indices, isize);
    return $this;
  }
  function TexturedVertexArray_init_$Create$(vcount, indices, isize, $mask0, $marker) {
    return TexturedVertexArray_init_$Init$(vcount, indices, isize, $mask0, $marker, Object.create(TexturedVertexArray.prototype));
  }
  function Companion_145() {
    Companion_instance_144 = this;
    this._COMPONENTS_PER_VERTEX = 6;
    var tmp = this;
    var tmp0_intArrayOf_0 = new Int32Array([0, 1, 2, 3, 0, 2]);
    tmp._QUAD_INDICES = tmp0_intArrayOf_0;
    this._EMPTY_INT_ARRAY = new Int32Array(0);
  }
  Companion_145.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_144;
  function Companion_getInstance_144() {
    if (Companion_instance_144 == null)
      new Companion_145();
    return Companion_instance_144;
  }
  function TexturedVertexArray(vcount, indices, isize) {
    Companion_getInstance_144();
    this._vcount = vcount;
    this._indices_1 = indices;
    this._isize = isize;
    this._initialVcount = this._vcount;
    this.__data = Companion_getInstance_38().allocNoDirect(imul(imul(6, this._initialVcount), 4));
    this._fast = this.__data._fast32;
    this._offset_24 = 0;
    this._bounds_6 = new BoundsBuilder();
  }
  TexturedVertexArray.prototype.quadV = function (fast, pos, x, y, u, v, colMul, colAdd) {
    var tmp0_setF_0 = pos + 0 | 0;
    var tmp0_set_0_1 = fast._f32;
    tmp0_set_0_1[tmp0_setF_0] = x;
    var tmp1_setF_0 = pos + 1 | 0;
    var tmp0_set_0_1_0 = fast._f32;
    tmp0_set_0_1_0[tmp1_setF_0] = y;
    var tmp2_setF_0 = pos + 2 | 0;
    var tmp0_set_0_1_1 = fast._f32;
    tmp0_set_0_1_1[tmp2_setF_0] = u;
    var tmp3_setF_0 = pos + 3 | 0;
    var tmp0_set_0_1_2 = fast._f32;
    tmp0_set_0_1_2[tmp3_setF_0] = v;
    var tmp4_setI_0 = pos + 4 | 0;
    var tmp0_set_0_1_3 = fast._i32;
    tmp0_set_0_1_3[tmp4_setI_0] = colMul;
    var tmp5_setI_0 = pos + 5 | 0;
    var tmp0_set_0_1_4 = fast._i32;
    tmp0_set_0_1_4[tmp5_setI_0] = colAdd;
    return 6;
  };
  TexturedVertexArray.prototype.quad = function (index, x, y, width, height, matrix, bmp, colMul, colAdd) {
    this.quad_0(index, x, y, width, height, matrix, bmp, colMul, colAdd);
  };
  TexturedVertexArray.prototype.quad_0 = function (index, x, y, width, height, matrix, bmp, colMul, colAdd) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix._get_af_();
    var cf = matrix._get_cf_();
    var txf = matrix._get_txf_();
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix._get_df_();
    var bf = matrix._get_bf_();
    var tyf = matrix._get_tyf_();
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this._fast;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl_(colMul);
    var ca = _ColorAdd___get_value__impl_(colAdd);
    pos = pos + this.quadV(fast, pos, x0, y0, bmp._tl_x, bmp._tl_y, cm, ca) | 0;
    pos = pos + this.quadV(fast, pos, x1, y1, bmp._tr_x, bmp._tr_y, cm, ca) | 0;
    pos = pos + this.quadV(fast, pos, x2, y2, bmp._br_x, bmp._br_y, cm, ca) | 0;
    pos = pos + this.quadV(fast, pos, x3, y3, bmp._bl_x, bmp._bl_y, cm, ca) | 0;
  };
  TexturedVertexArray.$metadata$ = {
    simpleName: 'TexturedVertexArray',
    kind: 'class',
    interfaces: []
  };
  function uniforms$factory() {
    return getPropertyCallableRef('uniforms', 1, KProperty1, function (receiver) {
      return receiver._get_uniforms__3();
    }, null);
  }
  function _no_name_provided_$factory_330(this$0) {
    var i = new _no_name_provided__380(this$0);
    return function (p1) {
      i.invoke_660(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_331(this$0) {
    var i = new _no_name_provided__381(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_332() {
    var i = new _no_name_provided__378();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_333($premultiplied) {
    var i = new _no_name_provided__379($premultiplied);
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _get_debugLineRenderContext_(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_getValue_0 = debugLineRenderContext$delegate;
      var tmp1_getValue_0 = debugLineRenderContext$factory();
      var tmp1_safe_receiver_2 = _this_._get_extra__71();
      var tmp;
      if (tmp1_safe_receiver_2 == null) {
        tmp = null;
      } else {
        var tmp0_elvis_lhs_3 = tmp0_getValue_0._name_1;
        tmp = tmp1_safe_receiver_2.get_116(tmp0_elvis_lhs_3 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3);
      }
      var tmp_0 = tmp;
      var res_1 = (tmp_0 == null ? true : isObject(tmp_0)) ? tmp_0 : THROW_CCE();
      if (res_1 == null) {
        var r_4 = tmp0_getValue_0._defaultGen_0(_this_);
        if (_this_._get_extra__71() == null)
          _this_._set_extra__71(LinkedHashMap_init_$Create$());
        var tmp1_safe_receiver_2_2_5 = _this_._get_extra__71();
        if (tmp1_safe_receiver_2_2_5 == null)
          null;
        else {
          var tmp0_elvis_lhs_3_4_7 = tmp0_getValue_0._name_1;
          var tmp0_set_0_3_6 = tmp0_elvis_lhs_3_4_7 == null ? tmp1_getValue_0.callableName : tmp0_elvis_lhs_3_4_7;
          var tmp1_set_0_5_8 = (r_4 == null ? true : isObject(r_4)) ? r_4 : THROW_CCE();
          tmp1_safe_receiver_2_2_5.put_18(tmp0_set_0_3_6, tmp1_set_0_5_8);
          Unit_getInstance();
        }
        Unit_getInstance();
        tmp$ret$0 = r_4;
        break l$ret$1;
      }tmp$ret$0 = res_1;
    }
     while (false);
    return tmp$ret$0;
  }
  var debugLineRenderContext$delegate;
  function addVertex($this, x, y) {
    $this._vertices_2.setAlignedFloat32($this._vertexPos_0 + 0 | 0, x);
    $this._vertices_2.setAlignedFloat32($this._vertexPos_0 + 1 | 0, y);
    $this._vertices_2.setAlignedInt32($this._vertexPos_0 + 2 | 0, _RGBA___get_value__impl_($this._color_2));
    var tmp0_this = $this;
    tmp0_this._vertexPos_0 = tmp0_this._vertexPos_0 + ($this._LAYOUT_0._totalSize_2 / 4 | 0) | 0;
    var tmp1_this = $this;
    var tmp2 = tmp1_this._vertexCount_1;
    tmp1_this._vertexCount_1 = tmp2 + 1 | 0;
    Unit_getInstance();
  }
  function _no_name_provided__382(this$0) {
    this._this$0_105 = this$0;
  }
  _no_name_provided__382.prototype.invoke_660 = function (it) {
    this._this$0_105.flush_8();
  };
  _no_name_provided__382.prototype.invoke_1015 = function (p1) {
    this.invoke_660(p1 instanceof Unit ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__382.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__383() {
  }
  _no_name_provided__383.prototype.invoke_664 = function ($this$VertexShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$VertexShader.SET($this$VertexShader._out_8, $this$VertexShader.times_0($this$VertexShader.times_0(tmp0_apply_0._u_ProjMat, tmp0_apply_0._u_ViewMat), $this$VertexShader.vec4([tmp0_apply_0._a_Pos, $this$VertexShader._get_lit_(0.0), $this$VertexShader._get_lit_(1.0)])));
    $this$VertexShader.SET(tmp0_apply_0._v_Col, tmp0_apply_0._a_Col);
    Unit_getInstance();
  };
  _no_name_provided__383.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__383.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__384() {
  }
  _no_name_provided__384.prototype.invoke_664 = function ($this$FragmentShader) {
    var tmp0_apply_0 = DefaultShaders_getInstance();
    $this$FragmentShader.set_29($this$FragmentShader._out_8, tmp0_apply_0._v_Col);
    Unit_getInstance();
  };
  _no_name_provided__384.prototype.invoke_1015 = function (p1) {
    this.invoke_664(p1 instanceof Builder ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__384.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__385(this$0) {
    this._this$0_106 = this$0;
  }
  _no_name_provided__385.prototype.invoke_1005 = function () {
    return UniformValues_init_$Create$([to(DefaultShaders_getInstance()._u_ProjMat, this._this$0_106._projMat_0), to(DefaultShaders_getInstance()._u_ViewMat, this._this$0_106._viewMat_0)]);
  };
  _no_name_provided__385.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__386() {
  }
  _no_name_provided__386.prototype.invoke_874 = function (it) {
    return new Matrix3D();
  };
  _no_name_provided__386.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__386.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function DebugLineRenderContext(ctx) {
    this._ctx_7 = ctx;
    this._ctx_7._flushers.add_41(_no_name_provided_$factory_335(this));
    Unit_getInstance();
    this._ag_4 = this._ctx_7._ag_5;
    this._color_2 = Colors_getInstance()._YELLOW;
    this._LAYOUT_0 = VertexLayout_init_$Create$([DefaultShaders_getInstance()._a_Pos, DefaultShaders_getInstance()._a_Col]);
    var tmp = this;
    tmp._VERTEX_0 = VertexShader_0(_no_name_provided_$factory_336());
    var tmp_0 = this;
    tmp_0._FRAGMENT = FragmentShader_0(_no_name_provided_$factory_337());
    var tmp_1 = this;
    tmp_1._uniforms$delegate_0 = lazy(_no_name_provided_$factory_338(this));
    this._vertexBuffer_0 = this._ag_4.createVertexBuffer_4();
    var tmp_2 = this;
    tmp_2._program_2 = Program_init_$Create$(this._VERTEX_0, this._FRAGMENT, null, 4, null);
    this._maxVertexCount = 1024;
    this._vertices_2 = Companion_getInstance_38().alloc_0(imul(24, this._maxVertexCount));
    this._tempRect_4 = Companion_getInstance_83().invoke_1005();
    this._projMat_0 = new Matrix3D();
    this._viewMat_0 = new Matrix3D();
    var tmp_3 = this;
    tmp_3._tempViewMat = Pool_init_$Create$_1(0, _no_name_provided_$factory_339(), 1, null);
    this._vertexCount_1 = 0;
    this._vertexPos_0 = 0;
  }
  DebugLineRenderContext.prototype._get_uniforms__3 = function () {
    var tmp0_getValue_0 = this._uniforms$delegate_0;
    var tmp1_getValue_0 = uniforms$factory_0();
    return tmp0_getValue_0._get_value__10();
  };
  DebugLineRenderContext.prototype.line_1 = function (x0, y0, x1, y1) {
    if (this._vertexCount_1 >= (this._maxVertexCount - 2 | 0)) {
      this.flush_8();
    }addVertex(this, x0, y0);
    addVertex(this, x1, y1);
  };
  DebugLineRenderContext.prototype.line_2 = function (x0, y0, x1, y1) {
    return this.line_1(x0, y0, x1, y1);
  };
  DebugLineRenderContext.prototype.drawVector = function (path_0) {
    var lastX = {_v: 0.0};
    var lastY = {_v: 0.0};
    var ix_3 = 0.0;
    var iy_4 = 0.0;
    var lx_5 = {_v: 0.0};
    var ly_6 = {_v: 0.0};
    var tmp0__anonymous__1_119 = false;
    Unit_getInstance();
    var n_1_7 = 0;
    var tmp0_fastForEach_0_8 = path_0._commands;
    var n_1_9 = 0;
    while (n_1_9 < tmp0_fastForEach_0_8._get_size__60()) {
      var tmp0_2_11 = n_1_9;
      n_1_9 = tmp0_2_11 + 1 | 0;
      var tmp1__anonymous__2_3_10 = tmp0_fastForEach_0_8.getAt_0(tmp0_2_11);
      var tmp0_subject_3_4_12 = tmp1__anonymous__2_3_10;
      switch (tmp0_subject_3_4_12) {
        case 0:
          var tmp1_4_5_14 = n_1_7;
          n_1_7 = tmp1_4_5_14 + 1 | 0;
          var tmp2__anonymous__18_13 = path_0._data_37.get_137(tmp1_4_5_14);
          var tmp2_5_6_16 = n_1_7;
          n_1_7 = tmp2_5_6_16 + 1 | 0;
          var tmp3__anonymous__18_15 = path_0._data_37.get_137(tmp2_5_6_16);
          ix_3 = tmp2__anonymous__18_13;
          iy_4 = tmp3__anonymous__18_15;
          var tmp1__anonymous__120 = true;
          if (!tmp1__anonymous__120) {
            this.line_2(lastX._v, lastY._v, tmp2__anonymous__18_13, tmp3__anonymous__18_15);
          }
          lastX._v = tmp2__anonymous__18_13;
          var tmp0_also_0_20_18 = lastY._v = tmp3__anonymous__18_15;
          lx_5._v = tmp2__anonymous__18_13;
          var tmp1_also_0_19_17 = tmp0_also_0_20_18;
          ly_6._v = tmp3__anonymous__18_15;
          break;
        case 1:
          var tmp3_6_7_20 = n_1_7;
          n_1_7 = tmp3_6_7_20 + 1 | 0;
          var tmp4__anonymous__21_19 = path_0._data_37.get_137(tmp3_6_7_20);
          var tmp4_7_8_22 = n_1_7;
          n_1_7 = tmp4_7_8_22 + 1 | 0;
          var tmp5__anonymous__21_21 = path_0._data_37.get_137(tmp4_7_8_22);
          var tmp2__anonymous__120 = false;
          if (!tmp2__anonymous__120) {
            this.line_2(lastX._v, lastY._v, tmp4__anonymous__21_19, tmp5__anonymous__21_21);
          }
          lastX._v = tmp4__anonymous__21_19;
          var tmp0_also_0_23_24 = lastY._v = tmp5__anonymous__21_21;
          lx_5._v = tmp4__anonymous__21_19;
          var tmp1_also_0_22_23 = tmp0_also_0_23_24;
          ly_6._v = tmp5__anonymous__21_21;
          var tmp3__anonymous__2_121 = false;
          Unit_getInstance();
          break;
        case 2:
          var tmp5_8_9_26 = n_1_7;
          n_1_7 = tmp5_8_9_26 + 1 | 0;
          var tmp6__anonymous__24_25 = path_0._data_37.get_137(tmp5_8_9_26);
          var tmp6_9_10_28 = n_1_7;
          n_1_7 = tmp6_9_10_28 + 1 | 0;
          var tmp7__anonymous__24_27 = path_0._data_37.get_137(tmp6_9_10_28);
          var tmp7_10_11_30 = n_1_7;
          n_1_7 = tmp7_10_11_30 + 1 | 0;
          var tmp8__anonymous__24_29 = path_0._data_37.get_137(tmp7_10_11_30);
          var tmp8_11_12_32 = n_1_7;
          n_1_7 = tmp8_11_12_32 + 1 | 0;
          var tmp9__anonymous__24_31 = path_0._data_37.get_137(tmp8_11_12_32);
          var sum_25_33 = Companion_getInstance_80().distance(lx_5._v, ly_6._v, tmp6__anonymous__24_25, tmp7__anonymous__24_27) + Companion_getInstance_80().distance(tmp6__anonymous__24_25, tmp7__anonymous__24_27, tmp8__anonymous__24_29, tmp9__anonymous__24_31);
          var tmp0_approximateCurve_0_26_34 = numberToInt(sum_25_33);
          var rcurveSteps_1_27_35 = max2_4(tmp0_approximateCurve_0_26_34, 20);
          var dt_2_28_36 = 1.0 / rcurveSteps_1_27_35;
          var lastX_3_29_37 = {_v: 0.0};
          var lastY_4_30_38 = {_v: 0.0};
          var prevX_5_31_39 = {_v: 0.0};
          var prevY_6_32_40 = {_v: 0.0};
          var emittedCount_7_33_41 = {_v: 0};
          var tmp1__anonymous__15_34_42 = 0.0;
          var tmp0_quadCalc_0_16_35_43 = Companion_getInstance_89();
          var tmp1_quadCalc_0_17_36_44 = lx_5._v;
          var tmp2_quadCalc_0_18_37_45 = ly_6._v;
          var t1_1_19_38_46 = 1 - tmp1__anonymous__15_34_42;
          var a_2_20_39_47 = t1_1_19_38_46 * t1_1_19_38_46;
          var c_3_21_40_48 = tmp1__anonymous__15_34_42 * tmp1__anonymous__15_34_42;
          var b_4_22_41_49 = 2 * t1_1_19_38_46 * tmp1__anonymous__15_34_42;
          var tmp3__anonymous__5_23_42_50 = a_2_20_39_47 * tmp1_quadCalc_0_17_36_44 + b_4_22_41_49 * tmp6__anonymous__24_25 + c_3_21_40_48 * tmp8__anonymous__24_29;
          var tmp4__anonymous__5_24_43_51 = a_2_20_39_47 * tmp2_quadCalc_0_18_37_45 + b_4_22_41_49 * tmp7__anonymous__24_27 + c_3_21_40_48 * tmp9__anonymous__24_31;
          lastX_3_29_37._v = tmp3__anonymous__5_23_42_50;
          lastY_4_30_38._v = tmp4__anonymous__5_24_43_51;
          var inductionVariable = 1;
          if (inductionVariable < rcurveSteps_1_27_35)
            do {
              var n_10_45_53 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_11_46_54 = n_10_45_53 * dt_2_28_36;
              var tmp0_quadCalc_0_16_47_55 = Companion_getInstance_89();
              var tmp1_quadCalc_0_17_48_56 = lx_5._v;
              var tmp2_quadCalc_0_18_49_57 = ly_6._v;
              var t1_1_19_50_58 = 1 - ratio_11_46_54;
              var a_2_20_51_59 = t1_1_19_50_58 * t1_1_19_50_58;
              var c_3_21_52_60 = ratio_11_46_54 * ratio_11_46_54;
              var b_4_22_53_61 = 2 * t1_1_19_50_58 * ratio_11_46_54;
              var tmp3__anonymous__5_23_54_62 = a_2_20_51_59 * tmp1_quadCalc_0_17_48_56 + b_4_22_53_61 * tmp6__anonymous__24_25 + c_3_21_52_60 * tmp8__anonymous__24_29;
              var tmp4__anonymous__5_24_55_63 = a_2_20_51_59 * tmp2_quadCalc_0_18_49_57 + b_4_22_53_61 * tmp7__anonymous__24_27 + c_3_21_52_60 * tmp9__anonymous__24_31;
              var tmp4__anonymous__120 = false;
              if (!tmp4__anonymous__120) {
                this.line_2(lastX._v, lastY._v, tmp3__anonymous__5_23_54_62, tmp4__anonymous__5_24_55_63);
              }lastX._v = tmp3__anonymous__5_23_54_62;
              lastY._v = tmp4__anonymous__5_24_55_63;
              var tmp0_14_2_27_56_64 = emittedCount_7_33_41._v;
              emittedCount_7_33_41._v = tmp0_14_2_27_56_64 + 1 | 0;
              Unit_getInstance();
              lastX_3_29_37._v = prevX_5_31_39._v;
              lastY_4_30_38._v = prevY_6_32_40._v;
              prevX_5_31_39._v = tmp3__anonymous__5_23_54_62;
              prevY_6_32_40._v = tmp4__anonymous__5_24_55_63;
            }
             while (inductionVariable < rcurveSteps_1_27_35);
          var tmp2_also_0_57_65 = lx_5._v = tmp8__anonymous__24_29;
          ly_6._v = tmp9__anonymous__24_31;
          var tmp5__anonymous__2_121 = false;
          Unit_getInstance();
          break;
        case 3:
          var tmp9_12_13_67 = n_1_7;
          n_1_7 = tmp9_12_13_67 + 1 | 0;
          var tmp10__anonymous__58_66 = path_0._data_37.get_137(tmp9_12_13_67);
          var tmp10_13_14_69 = n_1_7;
          n_1_7 = tmp10_13_14_69 + 1 | 0;
          var tmp11__anonymous__58_68 = path_0._data_37.get_137(tmp10_13_14_69);
          var tmp11_14_15_71 = n_1_7;
          n_1_7 = tmp11_14_15_71 + 1 | 0;
          var tmp12__anonymous__58_70 = path_0._data_37.get_137(tmp11_14_15_71);
          var tmp12_15_16_73 = n_1_7;
          n_1_7 = tmp12_15_16_73 + 1 | 0;
          var tmp13__anonymous__58_72 = path_0._data_37.get_137(tmp12_15_16_73);
          var tmp13_16_17_75 = n_1_7;
          n_1_7 = tmp13_16_17_75 + 1 | 0;
          var tmp14__anonymous__58_74 = path_0._data_37.get_137(tmp13_16_17_75);
          var tmp14_17_18_77 = n_1_7;
          n_1_7 = tmp14_17_18_77 + 1 | 0;
          var tmp15__anonymous__58_76 = path_0._data_37.get_137(tmp14_17_18_77);
          var sum_59_78 = Companion_getInstance_80().distance(lx_5._v, ly_6._v, tmp10__anonymous__58_66, tmp11__anonymous__58_68) + Companion_getInstance_80().distance(tmp10__anonymous__58_66, tmp11__anonymous__58_68, tmp12__anonymous__58_70, tmp13__anonymous__58_72) + Companion_getInstance_80().distance(tmp12__anonymous__58_70, tmp13__anonymous__58_72, tmp14__anonymous__58_74, tmp15__anonymous__58_76);
          var tmp0_approximateCurve_0_60_79 = numberToInt(sum_59_78);
          var rcurveSteps_1_61_80 = max2_4(tmp0_approximateCurve_0_60_79, 20);
          var dt_2_62_81 = 1.0 / rcurveSteps_1_61_80;
          var lastX_3_63_82 = {_v: 0.0};
          var lastY_4_64_83 = {_v: 0.0};
          var prevX_5_65_84 = {_v: 0.0};
          var prevY_6_66_85 = {_v: 0.0};
          var emittedCount_7_67_86 = {_v: 0};
          var tmp1__anonymous__15_68_87 = 0.0;
          var tmp0_cubicCalc_0_16_69_88 = Companion_getInstance_89();
          var tmp1_cubicCalc_0_17_70_89 = lx_5._v;
          var tmp2_cubicCalc_0_18_71_90 = ly_6._v;
          var cx_1_19_72_91 = 3.0 * (tmp10__anonymous__58_66 - tmp1_cubicCalc_0_17_70_89);
          var bx_2_20_73_92 = 3.0 * (tmp12__anonymous__58_70 - tmp10__anonymous__58_66) - cx_1_19_72_91;
          var ax_3_21_74_93 = tmp14__anonymous__58_74 - tmp1_cubicCalc_0_17_70_89 - cx_1_19_72_91 - bx_2_20_73_92;
          var cy_4_22_75_94 = 3.0 * (tmp11__anonymous__58_68 - tmp2_cubicCalc_0_18_71_90);
          var by_5_23_76_95 = 3.0 * (tmp13__anonymous__58_72 - tmp11__anonymous__58_68) - cy_4_22_75_94;
          var ay_6_24_77_96 = tmp15__anonymous__58_76 - tmp2_cubicCalc_0_18_71_90 - cy_4_22_75_94 - by_5_23_76_95;
          var tSquared_7_25_78_97 = tmp1__anonymous__15_68_87 * tmp1__anonymous__15_68_87;
          var tCubed_8_26_79_98 = tSquared_7_25_78_97 * tmp1__anonymous__15_68_87;
          var tmp3__anonymous__9_27_80_99 = ax_3_21_74_93 * tCubed_8_26_79_98 + bx_2_20_73_92 * tSquared_7_25_78_97 + cx_1_19_72_91 * tmp1__anonymous__15_68_87 + tmp1_cubicCalc_0_17_70_89;
          var tmp4__anonymous__9_28_81_100 = ay_6_24_77_96 * tCubed_8_26_79_98 + by_5_23_76_95 * tSquared_7_25_78_97 + cy_4_22_75_94 * tmp1__anonymous__15_68_87 + tmp2_cubicCalc_0_18_71_90;
          lastX_3_63_82._v = tmp3__anonymous__9_27_80_99;
          lastY_4_64_83._v = tmp4__anonymous__9_28_81_100;
          var inductionVariable_0 = 1;
          if (inductionVariable_0 < rcurveSteps_1_61_80)
            do {
              var n_10_83_102 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_11_84_103 = n_10_83_102 * dt_2_62_81;
              var tmp0_cubicCalc_0_16_85_104 = Companion_getInstance_89();
              var tmp1_cubicCalc_0_17_86_105 = lx_5._v;
              var tmp2_cubicCalc_0_18_87_106 = ly_6._v;
              var cx_1_19_88_107 = 3.0 * (tmp10__anonymous__58_66 - tmp1_cubicCalc_0_17_86_105);
              var bx_2_20_89_108 = 3.0 * (tmp12__anonymous__58_70 - tmp10__anonymous__58_66) - cx_1_19_88_107;
              var ax_3_21_90_109 = tmp14__anonymous__58_74 - tmp1_cubicCalc_0_17_86_105 - cx_1_19_88_107 - bx_2_20_89_108;
              var cy_4_22_91_110 = 3.0 * (tmp11__anonymous__58_68 - tmp2_cubicCalc_0_18_87_106);
              var by_5_23_92_111 = 3.0 * (tmp13__anonymous__58_72 - tmp11__anonymous__58_68) - cy_4_22_91_110;
              var ay_6_24_93_112 = tmp15__anonymous__58_76 - tmp2_cubicCalc_0_18_87_106 - cy_4_22_91_110 - by_5_23_92_111;
              var tSquared_7_25_94_113 = ratio_11_84_103 * ratio_11_84_103;
              var tCubed_8_26_95_114 = tSquared_7_25_94_113 * ratio_11_84_103;
              var tmp3__anonymous__9_27_96_115 = ax_3_21_90_109 * tCubed_8_26_95_114 + bx_2_20_89_108 * tSquared_7_25_94_113 + cx_1_19_88_107 * ratio_11_84_103 + tmp1_cubicCalc_0_17_86_105;
              var tmp4__anonymous__9_28_97_116 = ay_6_24_93_112 * tCubed_8_26_95_114 + by_5_23_92_111 * tSquared_7_25_94_113 + cy_4_22_91_110 * ratio_11_84_103 + tmp2_cubicCalc_0_18_87_106;
              var tmp6__anonymous__120 = false;
              if (!tmp6__anonymous__120) {
                this.line_2(lastX._v, lastY._v, tmp3__anonymous__9_27_96_115, tmp4__anonymous__9_28_97_116);
              }lastX._v = tmp3__anonymous__9_27_96_115;
              lastY._v = tmp4__anonymous__9_28_97_116;
              var tmp0_14_2_31_98_117 = emittedCount_7_67_86._v;
              emittedCount_7_67_86._v = tmp0_14_2_31_98_117 + 1 | 0;
              Unit_getInstance();
              lastX_3_63_82._v = prevX_5_65_84._v;
              lastY_4_64_83._v = prevY_6_66_85._v;
              prevX_5_65_84._v = tmp3__anonymous__9_27_96_115;
              prevY_6_66_85._v = tmp4__anonymous__9_28_97_116;
            }
             while (inductionVariable_0 < rcurveSteps_1_61_80);
          var tmp2_also_0_99_118 = lx_5._v = tmp14__anonymous__58_74;
          ly_6._v = tmp15__anonymous__58_76;
          var tmp7__anonymous__2_121 = false;
          Unit_getInstance();
          break;
        case 4:
          var tmp8__anonymous__120 = ix_3;
          var tmp9__anonymous__120 = iy_4;
          var tmp10__anonymous__120 = false;
          if (!tmp10__anonymous__120) {
            this.line_2(lastX._v, lastY._v, tmp8__anonymous__120, tmp9__anonymous__120);
          }
          lastX._v = tmp8__anonymous__120;
          lastY._v = tmp9__anonymous__120;
          var tmp11__anonymous__2_121 = true;
          Unit_getInstance();
          var tmp12__anonymous__1_119 = true;
          Unit_getInstance();
          break;
      }
    }
    var tmp13__anonymous__1_119 = false;
    Unit_getInstance();
  };
  DebugLineRenderContext.prototype.flush_8 = function () {
    if (this._vertexCount_1 > 0) {
      this._vertexBuffer_0.upload_8(this._vertices_2, 0, imul(this._vertexPos_0, 4));
      Unit_getInstance();
      this._projMat_0.setToOrtho_0(this._tempRect_4.setBounds_0(0, 0, this._ag_4._get_backWidth__4(), this._ag_4._get_backHeight__4()), -1.0, 1.0);
      Unit_getInstance();
      var tmp = DrawType_LINES_getInstance();
      var tmp_0 = this._vertexCount_1;
      var tmp_1 = this._get_uniforms__3();
      this._ag_4.draw$default(this._vertexBuffer_0, this._program_2, tmp, this._LAYOUT_0, tmp_0, null, null, 0, null, tmp_1, null, null, null, null, 15840, null);
    }this._vertexCount_1 = 0;
    this._vertexPos_0 = 0;
  };
  DebugLineRenderContext.$metadata$ = {
    simpleName: 'DebugLineRenderContext',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__387() {
  }
  _no_name_provided__387.prototype.invoke_669 = function ($this$$receiver) {
    return new DebugLineRenderContext($this$$receiver);
  };
  _no_name_provided__387.prototype.invoke_1015 = function (p1) {
    return this.invoke_669(p1 instanceof RenderContext ? p1 : THROW_CCE());
  };
  _no_name_provided__387.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function debugLineRenderContext$factory() {
    return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
      return _get_debugLineRenderContext_(receiver);
    }, null);
  }
  function uniforms$factory_0() {
    return getPropertyCallableRef('uniforms', 1, KProperty1, function (receiver) {
      return receiver._get_uniforms__3();
    }, null);
  }
  function _no_name_provided_$factory_334() {
    var i = new _no_name_provided__387();
    return function (p1) {
      return i.invoke_669(p1);
    };
  }
  function _no_name_provided_$factory_335(this$0) {
    var i = new _no_name_provided__382(this$0);
    return function (p1) {
      i.invoke_660(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_336() {
    var i = new _no_name_provided__383();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_337() {
    var i = new _no_name_provided__384();
    return function (p1) {
      i.invoke_664(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_338(this$0) {
    var i = new _no_name_provided__385(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_339() {
    var i = new _no_name_provided__386();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function _no_name_provided__388(this$0) {
    this._this$0_107 = this$0;
  }
  _no_name_provided__388.prototype.invoke_1005 = function () {
    return new BatchBuilder2D(this._this$0_107, this._this$0_107._batchMaxQuads_1);
  };
  _no_name_provided__388.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__389(this$0) {
    this._this$0_108 = this$0;
  }
  _no_name_provided__389.prototype.invoke_1005 = function () {
    return new RenderContext2D(this._this$0_108._get_batch_(), this._this$0_108._agBitmapTextureManager);
  };
  _no_name_provided__389.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__390() {
  }
  _no_name_provided__390.prototype.invoke_673 = function (it) {
    it.identity_0();
    Unit_getInstance();
  };
  _no_name_provided__390.prototype.invoke_1015 = function (p1) {
    this.invoke_673(p1 instanceof Matrix ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__390.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__391() {
  }
  _no_name_provided__391.prototype.invoke_874 = function (it) {
    return Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  };
  _no_name_provided__391.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__391.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__392() {
  }
  _no_name_provided__392.prototype.invoke_677 = function (it) {
    it.identity_0();
    Unit_getInstance();
  };
  _no_name_provided__392.prototype.invoke_1015 = function (p1) {
    this.invoke_677(p1 instanceof Matrix3D ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__392.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__393() {
  }
  _no_name_provided__393.prototype.invoke_874 = function (it) {
    return new Matrix3D();
  };
  _no_name_provided__393.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__393.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__394() {
  }
  _no_name_provided__394.prototype.invoke_681 = function (it) {
    var tmp0_setTo_0 = 0;
    var tmp1_setTo_0 = 0;
    it.setTo_0(numberToDouble(tmp0_setTo_0), numberToDouble(tmp1_setTo_0));
    Unit_getInstance();
  };
  _no_name_provided__394.prototype.invoke_1015 = function (p1) {
    this.invoke_681(p1 instanceof Point ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__394.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__395() {
  }
  _no_name_provided__395.prototype.invoke_874 = function (it) {
    return Companion_getInstance_80().invoke_1005();
  };
  _no_name_provided__395.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__395.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function RenderContext(ag, bp, stats, coroutineContext, batchMaxQuads) {
    this._ag_5 = ag;
    this._bp = bp;
    this._stats = stats;
    this._coroutineContext_5 = coroutineContext;
    this._batchMaxQuads_1 = batchMaxQuads;
    var tmp = this;
    tmp._$$delegate_0_21 = Mixin_init_$Create$(null, 1, null);
    this._agBitmapTextureManager = new AgBitmapTextureManager(this._ag_5);
    var tmp_0 = this;
    var tmp_1 = this._bp;
    tmp_0._views_4 = tmp_1 instanceof Views ? tmp_1 : null;
    this._debugAnnotateView = null;
    this._stencilIndex = 0;
    var tmp_2 = this;
    tmp_2._batch$delegate = lazy(_no_name_provided_$factory_340(this));
    var tmp_3 = this;
    tmp_3._ctx2d$delegate = lazy(_no_name_provided_$factory_341(this));
    var tmp_4 = this;
    tmp_4._flushers = Signal_init_$Create$(null, 1, null);
    var tmp_5 = this;
    var tmp_6 = _no_name_provided_$factory_342();
    tmp_5._matrixPool = new Pool(tmp_6, 8, _no_name_provided_$factory_343());
    var tmp_7 = this;
    var tmp_8 = _no_name_provided_$factory_344();
    tmp_7._matrix3DPool = new Pool(tmp_8, 8, _no_name_provided_$factory_345());
    var tmp_9 = this;
    var tmp_10 = _no_name_provided_$factory_346();
    tmp_9._pointPool = new Pool(tmp_10, 8, _no_name_provided_$factory_347());
    this._masksEnabled = true;
  }
  RenderContext.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_21._extra = _set___;
  };
  RenderContext.prototype._get_extra__71 = function () {
    return this._$$delegate_0_21._extra;
  };
  RenderContext.prototype._get_batch_ = function () {
    var tmp0_getValue_0 = this._batch$delegate;
    var tmp1_getValue_0 = batch$factory();
    return tmp0_getValue_0._get_value__10();
  };
  RenderContext.prototype._get_ctx2d_ = function () {
    var tmp0_getValue_0 = this._ctx2d$delegate;
    var tmp1_getValue_0 = ctx2d$factory();
    return tmp0_getValue_0._get_value__10();
  };
  RenderContext.prototype.flush_8 = function () {
    this._flushers.invoke_137(Unit_getInstance());
  };
  RenderContext.prototype.finish_0 = function () {
    this._ag_5.flip_4();
  };
  RenderContext.prototype.getTex = function (bmp) {
    return this._agBitmapTextureManager.getTexture(bmp);
  };
  RenderContext.$metadata$ = {
    simpleName: 'RenderContext',
    kind: 'class',
    interfaces: [Extra, BoundsProvider]
  };
  function batch$factory() {
    return getPropertyCallableRef('batch', 1, KProperty1, function (receiver) {
      return receiver._get_batch_();
    }, null);
  }
  function ctx2d$factory() {
    return getPropertyCallableRef('ctx2d', 1, KProperty1, function (receiver) {
      return receiver._get_ctx2d_();
    }, null);
  }
  function _no_name_provided_$factory_340(this$0) {
    var i = new _no_name_provided__388(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_341(this$0) {
    var i = new _no_name_provided__389(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_342() {
    var i = new _no_name_provided__390();
    return function (p1) {
      i.invoke_673(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_343() {
    var i = new _no_name_provided__391();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function _no_name_provided_$factory_344() {
    var i = new _no_name_provided__392();
    return function (p1) {
      i.invoke_677(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_345() {
    var i = new _no_name_provided__393();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function _no_name_provided_$factory_346() {
    var i = new _no_name_provided__394();
    return function (p1) {
      i.invoke_681(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_347() {
    var i = new _no_name_provided__395();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  var logger_0;
  function _no_name_provided__396() {
  }
  _no_name_provided__396.prototype.invoke_874 = function (it) {
    return Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  };
  _no_name_provided__396.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__396.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__397() {
  }
  _no_name_provided__397.prototype.invoke_874 = function (it) {
    return new Scissor(0, 0, 0, 0);
  };
  _no_name_provided__397.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__397.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function RenderContext2D(batch, agBitmapTextureManager) {
    this._batch_0 = batch;
    this._agBitmapTextureManager_0 = agBitmapTextureManager;
    var tmp = this;
    tmp._$$delegate_0_22 = Mixin_init_$Create$(null, 1, null);
    var tmp0_trace_0 = logger_0;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_0(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog(tmp0_log_0_1, 'RenderContext2D[0]');
    }var tmp_0 = this;
    tmp_0._mpool = Pool_init_$Create$_1(0, _no_name_provided_$factory_348(), 1, null);
    var tmp0_trace_0_0 = logger_0;
    var tmp0_log_0_1_0 = Level_TRACE_getInstance();
    if (tmp0_trace_0_0.isEnabled_0(tmp0_log_0_1_0)) {
      tmp0_trace_0_0.actualLog(tmp0_log_0_1_0, 'RenderContext2D[1]');
    }var tmp_1 = this;
    tmp_1._m = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._blendFactors = Companion_getInstance_121()._NORMAL;
    this._multiplyColor = Colors_getInstance()._WHITE;
    var tmp0_trace_0_1 = logger_0;
    var tmp0_log_0_1_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0_1.isEnabled_0(tmp0_log_0_1_1)) {
      tmp0_trace_0_1.actualLog(tmp0_log_0_1_1, 'RenderContext2D[2]');
    }var tmp_2 = this;
    tmp_2._scissorPool = Pool_init_$Create$_0(8, _no_name_provided_$factory_349());
    this._tempScissor = new Scissor(0, 0, 0, 0);
  }
  RenderContext2D.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_22._extra = _set___;
  };
  RenderContext2D.prototype._get_extra__71 = function () {
    return this._$$delegate_0_22._extra;
  };
  RenderContext2D.prototype.scissorStart = function (scissor) {
    var returnScissor = null;
    this._batch_0.flush$default(false, false, 3, null);
    if (!(scissor == null)) {
      var left = numberToInt(this._m.transformX(scissor._get_left__4(), scissor._get_top__4()));
      var top = numberToInt(this._m.transformY(scissor._get_left__4(), scissor._get_top__4()));
      var right = numberToInt(this._m.transformX(scissor._get_right__2(), scissor._get_bottom__2()));
      var bottom = numberToInt(this._m.transformY(scissor._get_right__2(), scissor._get_bottom__2()));
      returnScissor = this._scissorPool.alloc().setTo_6(left, top, right - left | 0, bottom - top | 0);
      this._batch_0._scissor_1 = returnScissor;
    } else {
      this._batch_0._scissor_1 = null;
    }
    return returnScissor;
  };
  RenderContext2D.prototype.scissorEnd = function (oldScissor, returnScissor) {
    if (!(returnScissor == null)) {
      this._scissorPool.free(returnScissor);
    }this._batch_0.flush$default(false, false, 3, null);
    this._batch_0._scissor_1 = oldScissor;
  };
  RenderContext2D.$metadata$ = {
    simpleName: 'RenderContext2D',
    kind: 'class',
    interfaces: [Extra]
  };
  function _no_name_provided_$factory_348() {
    var i = new _no_name_provided__396();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function _no_name_provided_$factory_349() {
    var i = new _no_name_provided__397();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function Texture_init_$Init$(base, left, top, right, bottom, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      left = 0;
    if (!(($mask0 & 4) === 0))
      top = 0;
    if (!(($mask0 & 8) === 0))
      right = base._width_17;
    if (!(($mask0 & 16) === 0))
      bottom = base._height_17;
    Texture_0.call($this, base, left, top, right, bottom);
    return $this;
  }
  function Texture_init_$Create$(base, left, top, right, bottom, $mask0, $marker) {
    return Texture_init_$Init$(base, left, top, right, bottom, $mask0, $marker, Object.create(Texture_0.prototype));
  }
  function Companion_146() {
    Companion_instance_145 = this;
  }
  Companion_146.prototype.invoke_689 = function (agBase, width, height) {
    return new Texture_0(new Base(agBase, width, height), 0, 0, width, height);
  };
  Companion_146.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_145;
  function Companion_getInstance_145() {
    if (Companion_instance_145 == null)
      new Companion_146();
    return Companion_instance_145;
  }
  function Base(base, width, height) {
    this._base_5 = base;
    this._width_17 = width;
    this._height_17 = height;
    this._version_3 = -1;
  }
  Base.prototype.close_77 = function () {
    var tmp0_safe_receiver = this._base_5;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.close_77();
      Unit_getInstance();
    }
    Unit_getInstance();
    this._base_5 = null;
  };
  Base.prototype.update_7 = function (bmp, mipmaps_0) {
    var tmp0_safe_receiver = this._base_5;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.upload_6(bmp, mipmaps_0);
    Unit_getInstance();
  };
  Base.$metadata$ = {
    simpleName: 'Base',
    kind: 'class',
    interfaces: [Closeable]
  };
  function Texture_0(base, left, top, right, bottom) {
    Companion_getInstance_145();
    this._base_6 = base;
    this._left_4 = left;
    this._top_0 = top;
    this._right_1 = right;
    this._bottom_0 = bottom;
    this._x_16 = this._left_4;
    this._y_15 = this._top_0;
    this._width_18 = this._right_1 - this._left_4 | 0;
    this._height_18 = this._bottom_0 - this._top_0 | 0;
    this._x0_0 = this._left_4 / this._base_6._width_17;
    this._x1_0 = this._right_1 / this._base_6._width_17;
    this._y0_0 = this._top_0 / this._base_6._height_17;
    this._y1_0 = this._bottom_0 / this._base_6._height_17;
  }
  Texture_0.prototype.slice_2 = function (x, y, width, height) {
    return this.sliceBounds(x, y, x + width | 0, y + height | 0);
  };
  Texture_0.prototype.slice_3 = function (rect_1) {
    return this.slice_2(numberToInt(rect_1._x_3), numberToInt(rect_1._y_3), numberToInt(rect_1._width_0), numberToInt(rect_1._height_0));
  };
  Texture_0.prototype.sliceBounds = function (left, top, right, bottom) {
    var tleft = clamp_1(this._x_16 + left | 0, this._left_4, this._right_1);
    var tright = clamp_1(this._x_16 + right | 0, this._left_4, this._right_1);
    var ttop = clamp_1(this._y_15 + top | 0, this._top_0, this._bottom_0);
    var tbottom = clamp_1(this._y_15 + bottom | 0, this._top_0, this._bottom_0);
    return new Texture_0(this._base_6, tleft, ttop, tright, tbottom);
  };
  Texture_0.prototype.close_77 = function () {
    return this._base_6.close_77();
  };
  Texture_0.prototype.toString = function () {
    return '' + 'Texture(' + this._base_6 + ', (x=' + this._x_16 + ', y=' + this._y_15 + ', width=' + this._width_18 + ', height=' + this._height_18 + '))';
  };
  Texture_0.$metadata$ = {
    simpleName: 'Texture',
    kind: 'class',
    interfaces: [Closeable]
  };
  function TextureWithBitmapSlice(texture, bitmapSlice, scale_1, bounds) {
    this._texture_3 = texture;
    this._bitmapSlice = bitmapSlice;
    this._scale_0 = scale_1;
    this._bounds_7 = bounds;
  }
  TextureWithBitmapSlice.prototype.toString = function () {
    return '' + 'TextureWithBitmapSlice(texture=' + this._texture_3 + ', bitmapSlice=' + this._bitmapSlice + ', scale=' + this._scale_0 + ', bounds=' + this._bounds_7 + ')';
  };
  TextureWithBitmapSlice.prototype.hashCode = function () {
    var result = hashCode(this._texture_3);
    result = imul(result, 31) + hashCode(this._bitmapSlice) | 0;
    result = imul(result, 31) + getNumberHashCode(this._scale_0) | 0;
    result = imul(result, 31) + this._bounds_7.hashCode() | 0;
    return result;
  };
  TextureWithBitmapSlice.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextureWithBitmapSlice))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextureWithBitmapSlice ? other : THROW_CCE();
    if (!equals_1(this._texture_3, tmp0_other_with_cast._texture_3))
      return false;
    if (!equals_1(this._bitmapSlice, tmp0_other_with_cast._bitmapSlice))
      return false;
    if (!equals_1(this._scale_0, tmp0_other_with_cast._scale_0))
      return false;
    if (!this._bounds_7.equals(tmp0_other_with_cast._bounds_7))
      return false;
    return true;
  };
  TextureWithBitmapSlice.$metadata$ = {
    simpleName: 'TextureWithBitmapSlice',
    kind: 'class',
    interfaces: []
  };
  function _get_root_($this) {
    var tmp = $this._root_2;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('root');
    }
  }
  function _get_mountable_($this) {
    var tmp = $this._mountable;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('mountable');
    }
  }
  function _no_name_provided__398(this$0, resultContinuation) {
    this._this$0_109 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__398.prototype.invoke_690 = function ($this$MountableVfs, $cont) {
    var tmp = this.create_43($this$MountableVfs, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__398.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_690((!(p1 == null) ? isInterface(p1, Mountable) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__398.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._this$0_109._mountable = this._$this$MountableVfs;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__398.prototype.create_43 = function ($this$MountableVfs, completion) {
    var i = new _no_name_provided__398(this._this$0_109, completion);
    i._$this$MountableVfs = $this$MountableVfs;
    return i;
  };
  _no_name_provided__398.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $initCOROUTINE$14(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__155 = _this_;
  }
  $initCOROUTINE$14.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = MountableVfs$default(false, _no_name_provided_$factory_350(this.__this__155, null), 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.__this__155._root_2 = ARGUMENT;
            this.__this__155.mount_1('/', _get_resourcesVfs_());
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $initCOROUTINE$14.$metadata$ = {
    simpleName: '$initCOROUTINE$14',
    kind: 'class',
    interfaces: []
  };
  function ResourcesRoot() {
  }
  ResourcesRoot.prototype.mount_1 = function (path_0, file) {
    _get_mountable_(this).mount_0(path_0, file);
    Unit_getInstance();
  };
  ResourcesRoot.prototype.init_15 = function ($cont) {
    var tmp = new $initCOROUTINE$14(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  ResourcesRoot.prototype.toString = function () {
    return '' + 'ResourcesRoot[' + _get_root_(this) + ']';
  };
  ResourcesRoot.$metadata$ = {
    simpleName: 'ResourcesRoot',
    kind: 'class',
    interfaces: [AsyncDependency]
  };
  function _no_name_provided_$factory_350(this$0, resultContinuation) {
    var i = new _no_name_provided__398(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_690(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _get_debugBmpFont_() {
    var tmp0_getValue_0 = debugBmpFont$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = debugBmpFont$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var debugBmpFont$delegate;
  function DebugBitmapFont() {
    DebugBitmapFont_instance = this;
    var tmp = this;
    tmp._DEBUG_FONT_BYTES = fromBase64$default('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', false, 1, null);
  }
  DebugBitmapFont.$metadata$ = {
    simpleName: 'DebugBitmapFont',
    kind: 'object',
    interfaces: []
  };
  var DebugBitmapFont_instance;
  function DebugBitmapFont_getInstance() {
    if (DebugBitmapFont_instance == null)
      new DebugBitmapFont();
    return DebugBitmapFont_instance;
  }
  function _no_name_provided__399() {
  }
  _no_name_provided__399.prototype.invoke_1005 = function () {
    var tmp = PNG_getInstance();
    var tmp_0 = DebugBitmapFont_getInstance()._DEBUG_FONT_BYTES;
    var tmp_1 = tmp.decode$default_9(tmp_0, null, 2, null).toBMP32_5().copyPremultiplied();
    var tex = slice$default(tmp_1, null, null, 3, null);
    var fntAdvance = 7.0;
    var fntWidth = 8.0;
    var fntHeight = 8.0;
    var fntBlockX = 2.0;
    var fntBlockY = 2.0;
    var fntBlockWidth = 12.0;
    var fntBlockHeight = 12.0;
    var tmp_2 = fntHeight - 1.0;
    var tmp0_associateWith_0 = until(0, 256);
    var result_1 = LinkedHashMap_init_$Create$_1(coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateWith_0, 10)), 16));
    var inductionVariable = tmp0_associateWith_0._get_first__6();
    var last_1 = tmp0_associateWith_0._get_last__6();
    if (inductionVariable <= last_1)
      do {
        var element_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x_5 = element_2_3 % 16;
        var y_6 = element_2_3 / 16 | 0;
        var tmp_3 = numberToInt(x_5 * fntBlockWidth + fntBlockX);
        var tmp_4 = numberToInt(y_6 * fntBlockHeight + fntBlockY);
        var tmp_5 = numberToInt(fntWidth);
        var tmp_6 = numberToInt(fntHeight);
        result_1.put_18(element_2_3, new Glyph(fntHeight, element_2_3, tex.sliceWithSize$default(tmp_3, tmp_4, tmp_5, tmp_6, null, 16, null), 0, 0, numberToInt(fntAdvance)));
        Unit_getInstance();
      }
       while (!(element_2_3 === last_1));
    var tmp_7 = toIntMap(result_1);
    var tmp_8 = IntMap_init_$Create$(0, 0.0, 3, null);
    return BitmapFont_init_$Create$(fntHeight, fntHeight, tmp_2, tmp_7, tmp_8, null, null, 96, null);
  };
  _no_name_provided__399.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function debugBmpFont$factory() {
    return getPropertyCallableRef('debugBmpFont', 0, KProperty0, function () {
      return _get_debugBmpFont_();
    }, null);
  }
  function _no_name_provided_$factory_351() {
    var i = new _no_name_provided__399();
    return function () {
      return i.invoke_1005();
    };
  }
  function Module() {
    this._imageFormats_2 = listOf_0(PNG_getInstance());
    this._bgcolor_2 = Colors_getInstance()._BLACK;
    this._title_1 = 'Game';
    this._icon_2 = null;
    this._iconImage = null;
    this._quality_3 = Quality_PERFORMANCE_getInstance();
    this._mainScene = getKClass_0(EmptyScene);
    this._clearEachFrame_0 = true;
    this._targetFps_0 = 0.0;
    this._scaleAnchor_0 = Companion_getInstance_74()._MIDDLE_CENTER;
    this._scaleMode_2 = Companion_getInstance_85()._SHOW_ALL;
    this._clipBorders_0 = true;
    this._fullscreen_4 = null;
  }
  Module.prototype._get_imageFormats__1 = function () {
    return this._imageFormats_2;
  };
  Module.prototype._get_bgcolor__1 = function () {
    return this._bgcolor_2;
  };
  Module.prototype._get_title__1 = function () {
    return this._title_1;
  };
  Module.prototype._get_icon__1 = function () {
    return this._icon_2;
  };
  Module.prototype._get_iconImage__1 = function () {
    return this._iconImage;
  };
  Module.prototype._get_quality__1 = function () {
    return this._quality_3;
  };
  Module.prototype._get_size__61 = function () {
    return Companion_getInstance_87().invoke_325(1280, 720);
  };
  Module.prototype._get_windowSize__1 = function () {
    return this._get_size__61();
  };
  Module.prototype._get_mainScene__1 = function () {
    return this._mainScene;
  };
  Module.prototype._get_targetFps__1 = function () {
    return this._targetFps_0;
  };
  Module.prototype._get_scaleAnchor__1 = function () {
    return this._scaleAnchor_0;
  };
  Module.prototype._get_scaleMode__1 = function () {
    return this._scaleMode_2;
  };
  Module.prototype._get_clipBorders__1 = function () {
    return this._clipBorders_0;
  };
  Module.prototype._get_fullscreen__2 = function () {
    return this._fullscreen_4;
  };
  Module.prototype.configure_1 = function (_this__0, $cont) {
    return Unit_getInstance();
  };
  Module.$metadata$ = {
    simpleName: 'Module',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__400(this$0) {
    this._this$0_110 = this$0;
  }
  _no_name_provided__400.prototype.invoke_1005 = function () {
    return this._this$0_110._get_views__7()._coroutineContext_6.plus_36(new AsyncInjectorContext(this._this$0_110._get_injector__3())).plus_36(Job_0(this._this$0_110._get_views__7()._coroutineContext_6.get_113(Key_getInstance_2())));
  };
  _no_name_provided__400.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__401(this$0) {
    this._this$0_111 = this$0;
  }
  _no_name_provided__401.prototype.invoke_1005 = function () {
    var tmp0_getSync_0 = this._this$0_111._get_injector__3();
    var tmp1_getSync_0 = new RequestContext(getKClass_0(Resources));
    return tmp0_getSync_0.getSync(getKClass_0(Resources), tmp1_getSync_0);
  };
  _no_name_provided__401.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $initCOROUTINE$17(_this_, injector, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__156 = _this_;
    this._injector_5 = injector;
  }
  $initCOROUTINE$17.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this.__this__156._injector_6 = this._injector_5;
            this._state_1 = 1;
            var tmp_0 = getKClass_0(Views);
            suspendResult = this._injector_5.get$default_0(tmp_0, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_27 = suspendResult;
            this.__this__156._set_views__3(this._ARGUMENT0_27);
            this._state_1 = 2;
            var tmp_1 = getKClass_0(SceneContainer);
            suspendResult = this._injector_5.get$default_0(tmp_1, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            this._ARGUMENT1_13 = suspendResult;
            this.__this__156._sceneContainer = this._ARGUMENT1_13;
            this._state_1 = 3;
            var tmp_2 = getKClass_0(ResourcesRoot);
            suspendResult = this._injector_5.get$default_0(tmp_2, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            this.__this__156._resourcesRoot = ARGUMENT;
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $initCOROUTINE$17.$metadata$ = {
    simpleName: '$initCOROUTINE$17',
    kind: 'class',
    interfaces: []
  };
  function $sceneAfterDestroyInternalCOROUTINE$18(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__157 = _this_;
  }
  $sceneAfterDestroyInternalCOROUTINE$18.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._state_1 = 1;
            suspendResult = this.__this__157.sceneAfterDestroy_3(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._exceptionState = 2;
            var tmp_0 = this.__this__157._get_coroutineContext__22();
            cancel$default(tmp_0, null, 1, null);
            this._exceptionState = 4;
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._exceptionState = 4;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e = this._exception_0;
              printStackTrace(e);
              this._state_1 = 3;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            this._exceptionState = 4;
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sceneAfterDestroyInternalCOROUTINE$18.$metadata$ = {
    simpleName: '$sceneAfterDestroyInternalCOROUTINE$18',
    kind: 'class',
    interfaces: []
  };
  function Scene() {
    this.__sceneViewContainer = new Container();
    this._cancellables = new CancellableGroup();
    var tmp = this;
    tmp._coroutineContext$delegate = lazy(_no_name_provided_$factory_352(this));
    var tmp_0 = this;
    var tmp0_apply_0 = this.createSceneView_3();
    var tmp0_this_2 = this;
    tmp0_this_2.__sceneViewContainer.plusAssign_12(tmp0_apply_0);
    tmp_0._sceneView = tmp0_apply_0;
    var tmp_1 = this;
    tmp_1._resources$delegate = lazy(_no_name_provided_$factory_353(this));
  }
  Scene.prototype._get_injector__3 = function () {
    var tmp = this._injector_6;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  };
  Scene.prototype._set_views__3 = function (_set___) {
    this._views_5 = _set___;
  };
  Scene.prototype._get_views__7 = function () {
    var tmp = this._views_5;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  };
  Scene.prototype._get_sceneContainer__2 = function () {
    var tmp = this._sceneContainer;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  };
  Scene.prototype._get_coroutineContext__22 = function () {
    var tmp0_getValue_0 = this._coroutineContext$delegate;
    var tmp1_getValue_0 = coroutineContext$factory();
    return tmp0_getValue_0._get_value__10();
  };
  Scene.prototype.createSceneView_3 = function () {
    return new Container();
  };
  Scene.prototype.init_18 = function (injector, $cont) {
    var tmp = new $initCOROUTINE$17(this, injector, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Scene.prototype.sceneInit_3 = function (_this__0, $cont) {
  };
  Scene.prototype.sceneMain_3 = function (_this__0, $cont) {
  };
  Scene.prototype.sceneAfterInit_3 = function ($cont) {
  };
  Scene.prototype.sceneBeforeLeaving_3 = function ($cont) {
  };
  Scene.prototype.sceneDestroy_3 = function ($cont) {
  };
  Scene.prototype.sceneDestroyInternal_3 = function ($cont) {
    cancel_0(this._cancellables);
    return this._get_injector__3().deinit_4($cont);
  };
  Scene.prototype.sceneAfterDestroy_3 = function ($cont) {
  };
  Scene.prototype.sceneAfterDestroyInternal_3 = function ($cont) {
    var tmp = new $sceneAfterDestroyInternalCOROUTINE$18(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Scene.$metadata$ = {
    simpleName: 'Scene',
    kind: 'class',
    interfaces: [InjectorAsyncDependency, ViewsContainer, CoroutineScope, KorgeDebugNode, ResourcesContainer]
  };
  function EmptyScene() {
    Scene.call(this);
  }
  EmptyScene.prototype.sceneInit_3 = function (_this__0, $cont) {
  };
  EmptyScene.$metadata$ = {
    simpleName: 'EmptyScene',
    kind: 'class',
    interfaces: []
  };
  function delay_2(_this_, time, $cont) {
    return delay_3(_this_._sceneView, time, $cont);
  }
  function coroutineContext$factory() {
    return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
      return receiver._get_coroutineContext__22();
    }, null);
  }
  function _no_name_provided_$factory_352(this$0) {
    var i = new _no_name_provided__400(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_353(this$0) {
    var i = new _no_name_provided__401(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided__402($newScene, resultContinuation) {
    this._$newScene = $newScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__402.prototype.invoke_729 = function ($this$withContext, $cont) {
    var tmp = this.create_51($this$withContext, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__402.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_729((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__402.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$newScene.sceneAfterInit_3(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__402.prototype.create_51 = function ($this$withContext, completion) {
    var i = new _no_name_provided__402(this._$newScene, completion);
    i._$this$withContext = $this$withContext;
    return i;
  };
  _no_name_provided__402.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function SceneContainer_init_$Init$(views, defaultTransition, name, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      defaultTransition = withEasing(AlphaTransition, Companion_getInstance_96()._get_EASE_IN_OUT_QUAD_());
    if (!(($mask0 & 4) === 0))
      name = 'sceneContainer';
    SceneContainer.call($this, views, defaultTransition, name);
    return $this;
  }
  function SceneContainer_init_$Create$(views, defaultTransition, name, $mask0, $marker) {
    return SceneContainer_init_$Init$(views, defaultTransition, name, $mask0, $marker, Object.create(SceneContainer.prototype));
  }
  function _changeTo($this, clazz, injects, time, transition, $cont) {
    var tmp = new $_changeToCOROUTINE$20($this, clazz, injects, time, transition, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function VisitEntry(clazz, injects) {
    this._clazz_3 = clazz;
    this._injects = injects;
  }
  VisitEntry.prototype.toString = function () {
    return '' + 'VisitEntry(clazz=' + this._clazz_3 + ', injects=' + this._injects + ')';
  };
  VisitEntry.prototype.hashCode = function () {
    var result = this._clazz_3.hashCode();
    result = imul(result, 31) + hashCode(this._injects) | 0;
    return result;
  };
  VisitEntry.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this._clazz_3.equals(tmp0_other_with_cast._clazz_3))
      return false;
    if (!equals_1(this._injects, tmp0_other_with_cast._injects))
      return false;
    return true;
  };
  VisitEntry.$metadata$ = {
    simpleName: 'VisitEntry',
    kind: 'class',
    interfaces: []
  };
  function Companion_147() {
    Companion_instance_146 = this;
    var tmp = this;
    var tmp_0 = getKClass_0(EmptyScene);
    tmp._EMPTY_VISIT_ENTRY = new VisitEntry(tmp_0, emptyList());
  }
  Companion_147.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_146;
  function Companion_getInstance_146() {
    if (Companion_instance_146 == null)
      new Companion_147();
    return Companion_instance_146;
  }
  function setCurrent($this, entry) {
    while ($this._visitStack._get_size__60() <= $this._visitPos) {
      $this._visitStack.add_39(Companion_getInstance_146()._EMPTY_VISIT_ENTRY);
      Unit_getInstance();
    }
    $this._visitStack.set_8($this._visitPos, entry);
    Unit_getInstance();
  }
  function _no_name_provided__403($newScene, resultContinuation) {
    this._$newScene_0 = $newScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__403.prototype.invoke_697 = function ($this$withContext, $cont) {
    var tmp = this.create_51($this$withContext, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__403.prototype.invoke_1015 = function (p1, $cont) {
    return this.invoke_697((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__403.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_apply_00_0 = this._$newScene_0._sceneView;
            this._state_1 = 1;
            suspendResult = this._$newScene_0.sceneInit_3(this._tmp0_apply_00_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            return this._tmp0_apply_00_0;
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__403.prototype.create_51 = function ($this$withContext, completion) {
    var i = new _no_name_provided__403(this._$newScene_0, completion);
    i._$this$withContext_0 = $this$withContext;
    return i;
  };
  _no_name_provided__403.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__404($newScene, resultContinuation) {
    this._$newScene_1 = $newScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__404.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__404.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__404.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_apply_00_1 = this._$newScene_1._sceneView;
            this._state_1 = 1;
            suspendResult = this._$newScene_1.sceneMain_3(this._tmp0_apply_00_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__404.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__404(this._$newScene_1, completion);
    return i;
  };
  _no_name_provided__404.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__405($oldScene, resultContinuation) {
    this._$oldScene = $oldScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__405.prototype.invoke_729 = function ($this$withContext, $cont) {
    var tmp = this.create_51($this$withContext, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__405.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_729((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__405.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$oldScene.sceneBeforeLeaving_3(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__405.prototype.create_51 = function ($this$withContext, completion) {
    var i = new _no_name_provided__405(this._$oldScene, completion);
    i._$this$withContext_1 = $this$withContext;
    return i;
  };
  _no_name_provided__405.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__406() {
  }
  _no_name_provided__406.prototype.invoke_703 = function (p0, p1, p2) {
    return _interpolate(p0, p1, p2);
  };
  _no_name_provided__406.prototype.invoke_704 = function (p1, p2, p3) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    return this.invoke_703(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
  };
  _no_name_provided__406.prototype._get_name__50 = function () {
    return '_interpolate';
  };
  _no_name_provided__406.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__407($oldScene, resultContinuation) {
    this._$oldScene_0 = $oldScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__407.prototype.invoke_729 = function ($this$withContext, $cont) {
    var tmp = this.create_51($this$withContext, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__407.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_729((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__407.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            suspendResult = this._$oldScene_0.sceneDestroy_3(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._state_1 = 2;
            suspendResult = this._$oldScene_0.sceneDestroyInternal_3(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__407.prototype.create_51 = function ($this$withContext, completion) {
    var i = new _no_name_provided__407(this._$oldScene_0, completion);
    i._$this$withContext_2 = $this$withContext;
    return i;
  };
  _no_name_provided__407.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__408($oldScene, resultContinuation) {
    this._$oldScene_1 = $oldScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__408.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__408.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__408.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$oldScene_1.sceneAfterDestroyInternal_3(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__408.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__408(this._$oldScene_1, completion);
    return i;
  };
  _no_name_provided__408.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__409($newScene, resultContinuation) {
    this._$newScene_2 = $newScene;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__409.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__409.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__409.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = this._$newScene_2._get_coroutineContext__22();
            suspendResult = withContext(tmp_0, _no_name_provided_$factory_354(this._$newScene_2, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__409.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__409(this._$newScene_2, completion);
    return i;
  };
  _no_name_provided__409.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $_changeToCOROUTINE$20(_this_, clazz, injects, time, transition, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__158 = _this_;
    this._clazz_4 = clazz;
    this._injects_0 = injects;
    this._time_4 = time;
    this._transition = transition;
  }
  $_changeToCOROUTINE$20.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 9;
            this._oldScene0 = this.__this__158._currentScene;
            this._sceneInjector1 = this.__this__158._views_6._injector_7.child_0().mapInstance(getKClass_0(SceneContainer), this.__this__158).mapInstance(getKClass_0(Resources), new Resources(this.__this__158._get_coroutineContext__22(), this.__this__158._views_6._get_globalResources_()._root_0, this.__this__158._views_6._get_globalResources_()));
            this._n_12 = 0;
            while (this._n_12 < this._injects_0.length) {
              var tmp0_2 = this._n_12;
              this._n_12 = tmp0_2 + 1 | 0;
              var tmp0__anonymous__3 = this._injects_0[tmp0_2];
              var tmp_0 = getKClassFromExpression_0(tmp0__anonymous__3);
              this._sceneInjector1.mapInstance(isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE(), tmp0__anonymous__3);
              Unit_getInstance();
            }

            this._state_1 = 1;
            suspendResult = this._sceneInjector1.get$default_0(this._clazz_4, null, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._newScene3 = suspendResult;
            this.__this__158._currentScene = this._newScene3;
            this.__this__158._transitionView._transition_0 = this._transition;
            this.__this__158._transitionView.startNewTransition(this._newScene3.__sceneViewContainer);
            this._state_1 = 2;
            var tmp_1 = this._newScene3._get_coroutineContext__22();
            suspendResult = withContext(tmp_1, _no_name_provided_$factory_355(this._newScene3, null), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            Unit_getInstance();
            launchImmediately_0(this._newScene3, _no_name_provided_$factory_356(this._newScene3, null));
            Unit_getInstance();
            if (!(this._oldScene0 == null)) {
              this._state_1 = 3;
              var tmp_2 = this._oldScene0._get_coroutineContext__22();
              suspendResult = withContext(tmp_2, _no_name_provided_$factory_357(this._oldScene0, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 3:
            suspendResult;
            this._state_1 = 4;
            continue $sm;
          case 4:
            var tmp_3 = this;
            tmp_3._tmp1__get_seconds__04 = 0;
            if (TimeSpan__compareTo_impl(this._time_4, Companion_getInstance_27().fromSeconds(this._tmp1__get_seconds__04)) > 0) {
              this._state_1 = 5;
              var tmp_4 = this;
              tmp_4._tmp2_get_05 = ratio$factory(this.__this__158._transitionView);
              var tmp_5 = this;
              tmp_5._tmp3_get_06 = 0.0;
              var tmp_6 = this;
              tmp_6._tmp4_get_07 = 1.0;
              var tmp_7 = _no_name_provided_$factory_358();
              var tmp_8 = [V2_init_$Create$(this._tmp2_get_05, this._tmp3_get_06, this._tmp4_get_07, tmp_7, true, null, null, 96, null)];
              suspendResult = tween$default(this.__this__158._transitionView, tmp_8, this._time_4, null, null, 12, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              {
                this.__this__158._transitionView._set_ratio__0(1.0);
                this._state_1 = 6;
                continue $sm;
              }
            }

            break;
          case 5:
            suspendResult;
            this._state_1 = 6;
            continue $sm;
          case 6:
            this.__this__158._transitionView.endTransition();
            if (!(this._oldScene0 == null)) {
              this._state_1 = 7;
              var tmp_9 = this._oldScene0._get_coroutineContext__22();
              suspendResult = withContext(tmp_9, _no_name_provided_$factory_359(this._oldScene0, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 8;
              continue $sm;
            }

            break;
          case 7:
            suspendResult;
            launchImmediately_0(this._oldScene0, _no_name_provided_$factory_360(this._oldScene0, null));
            Unit_getInstance();
            this._state_1 = 8;
            continue $sm;
          case 8:
            launchImmediately_0(this.__this__158._views_6, _no_name_provided_$factory_361(this._newScene3, null));
            Unit_getInstance();
            return this._newScene3;
          case 9:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 9) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $_changeToCOROUTINE$20.$metadata$ = {
    simpleName: '$_changeToCOROUTINE$20',
    kind: 'class',
    interfaces: []
  };
  function SceneContainer(views, defaultTransition, name) {
    Companion_getInstance_146();
    Container.call(this);
    this._views_6 = views;
    this._defaultTransition = defaultTransition;
    this._set_name__0(name);
    var tmp = this;
    var tmp0_also_0 = new TransitionView();
    this.plusAssign_12(tmp0_also_0);
    tmp._transitionView = tmp0_also_0;
    this._currentScene = null;
    this._visitStack = arrayListOf([Companion_getInstance_146()._EMPTY_VISIT_ENTRY]);
    this._visitPos = 0;
  }
  SceneContainer.prototype._get_coroutineContext__22 = function () {
    return this._views_6._coroutineContext_6;
  };
  SceneContainer.prototype.changeTo = function (clazz, injects, time, transition, $cont) {
    setCurrent(this, new VisitEntry(clazz, toList(injects)));
    return _changeTo(this, clazz, injects.slice(), time, transition, $cont);
  };
  SceneContainer.prototype.changeTo$default = function (clazz, injects, time, transition, $mask0, $handler, $cont) {
    if (!(($mask0 & 4) === 0)) {
      var tmp0__get_seconds__0 = 0;
      time = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
    }if (!(($mask0 & 8) === 0))
      transition = this._defaultTransition;
    return this.changeTo(clazz, injects, time, transition, $cont);
  };
  SceneContainer.$metadata$ = {
    simpleName: 'SceneContainer',
    kind: 'class',
    interfaces: [CoroutineScope]
  };
  function ratio$factory($b0) {
    return getPropertyCallableRef('ratio', 0, KMutableProperty0, function () {
      return $b0._get_ratio__1();
    }, function (value) {
      return $b0._set_ratio__0(value);
    });
  }
  function _no_name_provided_$factory_354($newScene, resultContinuation) {
    var i = new _no_name_provided__402($newScene, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_729(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_355($newScene, resultContinuation) {
    var i = new _no_name_provided__403($newScene, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_697(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_356($newScene, resultContinuation) {
    var i = new _no_name_provided__404($newScene, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_357($oldScene, resultContinuation) {
    var i = new _no_name_provided__405($oldScene, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_729(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_358() {
    var i = new _no_name_provided__406();
    var l = function (p1, p2, p3) {
      return i.invoke_703(p1, p2, p3);
    };
    l.callableName = i._get_name__50();
    return l;
  }
  function _no_name_provided_$factory_359($oldScene, resultContinuation) {
    var i = new _no_name_provided__407($oldScene, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_729(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_360($oldScene, resultContinuation) {
    var i = new _no_name_provided__408($oldScene, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_361($newScene, resultContinuation) {
    var i = new _no_name_provided__409($newScene, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  var AlphaTransition;
  function Transition(render_1) {
    this._render = render_1;
  }
  Transition.$metadata$ = {
    simpleName: 'Transition',
    kind: 'class',
    interfaces: []
  };
  function withEasing(_this_, easing) {
    return new Transition(_no_name_provided_$factory_363(_this_, easing));
  }
  function TransitionView() {
    Container.call(this);
    dummyView(this);
    Unit_getInstance();
    dummyView(this);
    Unit_getInstance();
    this._transition_0 = AlphaTransition;
  }
  TransitionView.prototype._get_prev_ = function () {
    return this.get_137(0);
  };
  TransitionView.prototype._get_next_ = function () {
    return this.get_137(1);
  };
  TransitionView.prototype.startNewTransition = function (next_0) {
    this._set_ratio__0(0.0);
    this.setViews(this._get_next_(), next_0);
  };
  TransitionView.prototype.endTransition = function () {
    this._set_ratio__0(1.0);
    this.setViews(dummyView(this), this._get_next_());
  };
  TransitionView.prototype.setViews = function (prev, next_0) {
    this.removeChildren_8();
    this.addChild_8(prev);
    this.addChild_8(next_0);
  };
  TransitionView.prototype.renderInternal_20 = function (ctx) {
    if (this._get_ratio__1() <= 0.0)
      this._get_prev_().render_23(ctx);
    else if (this._get_ratio__1() >= 1.0)
      this._get_next_().render_23(ctx);
    else
      this._transition_0._render(ctx, this._get_prev_(), this._get_next_(), this._get_ratio__1());
  };
  TransitionView.$metadata$ = {
    simpleName: 'TransitionView',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__410() {
  }
  _no_name_provided__410.prototype.invoke_713 = function (ctx, prev, next_0, ratio) {
    var prevAlpha = prev._get_alpha__20();
    var nextAlpha = next_0._get_alpha__20();
    try {
      prev._set_alpha__20(1.0 - ratio);
      next_0._set_alpha__20(ratio);
      prev.render_23(ctx);
      next_0.render_23(ctx);
    }finally {
      prev._set_alpha__20(prevAlpha);
      next_0._set_alpha__20(nextAlpha);
    }
  };
  _no_name_provided__410.prototype.invoke_714 = function (p1, p2, p3, p4) {
    var tmp = p1 instanceof RenderContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof View ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof View ? p3 : THROW_CCE();
    this.invoke_713(tmp, tmp_0, tmp_1, (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__410.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__411($this_withEasing, $easing) {
    this._$this_withEasing = $this_withEasing;
    this._$easing = $easing;
  }
  _no_name_provided__411.prototype.invoke_713 = function (ctx, prev, next_0, ratio) {
    this._$this_withEasing._render(ctx, prev, next_0, this._$easing.invoke_358(ratio));
  };
  _no_name_provided__411.prototype.invoke_714 = function (p1, p2, p3, p4) {
    var tmp = p1 instanceof RenderContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof View ? p2 : THROW_CCE();
    var tmp_1 = p3 instanceof View ? p3 : THROW_CCE();
    this.invoke_713(tmp, tmp_0, tmp_1, (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__411.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_362() {
    var i = new _no_name_provided__410();
    return function (p1, p2, p3, p4) {
      i.invoke_713(p1, p2, p3, p4);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_363($this_withEasing, $easing) {
    var i = new _no_name_provided__411($this_withEasing, $easing);
    return function (p1, p2, p3, p4) {
      i.invoke_713(p1, p2, p3, p4);
      return Unit_getInstance();
    };
  }
  function IStorage() {
  }
  IStorage.$metadata$ = {
    simpleName: 'IStorage',
    kind: 'interface',
    interfaces: []
  };
  var storage$delegate;
  function toMap_3(_this_) {
    var tmp0_associateWith_0 = _this_.keys_0();
    var result_1 = LinkedHashMap_init_$Create$_1(coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associateWith_0, 10)), 16));
    var tmp0_iterator_1_2 = tmp0_associateWith_0.iterator_67();
    while (tmp0_iterator_1_2.hasNext_33()) {
      var element_2_3 = tmp0_iterator_1_2.next_37();
      result_1.put_18(element_2_3, _this_.getOrNull_5(element_2_3));
      Unit_getInstance();
    }
    return result_1;
  }
  function _no_name_provided__412() {
  }
  _no_name_provided__412.prototype.invoke_715 = function ($this$$receiver) {
    return new NativeStorage($this$$receiver);
  };
  _no_name_provided__412.prototype.invoke_1015 = function (p1) {
    return this.invoke_715(p1 instanceof Views ? p1 : THROW_CCE());
  };
  _no_name_provided__412.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_364() {
    var i = new _no_name_provided__412();
    return function (p1) {
      return i.invoke_715(p1);
    };
  }
  var fadeThread$delegate;
  var changing$delegate;
  function _no_name_provided__413() {
  }
  _no_name_provided__413.prototype.invoke_1005 = function () {
    return new AsyncThread();
  };
  _no_name_provided__413.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__414() {
  }
  _no_name_provided__414.prototype.invoke_1005 = function () {
    return false;
  };
  _no_name_provided__414.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_365() {
    var i = new _no_name_provided__413();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_366() {
    var i = new _no_name_provided__414();
    return function () {
      return i.invoke_1005();
    };
  }
  function fadeThread$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_365();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function changing$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_366();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function RCollection() {
    this._list_2 = ArrayList_init_$Create$();
    this._byName = LinkedHashMap_init_$Create$();
  }
  RCollection.$metadata$ = {
    simpleName: 'RCollection',
    kind: 'class',
    interfaces: []
  };
  function Stats() {
    this._counters = new RCollection();
    this._values_3 = new RCollection();
  }
  Stats.prototype.startFrame_8 = function () {
    var tmp0_fastForEach_0 = this._counters._list_2;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      tmp1__anonymous__3.startFrame_8();
    }
    var tmp2_fastForEach_0 = this._values_3._list_2;
    var n_1_0 = 0;
    while (n_1_0 < tmp2_fastForEach_0._get_size__60()) {
      var tmp0_2_0 = n_1_0;
      n_1_0 = tmp0_2_0 + 1 | 0;
      var tmp3__anonymous__3 = tmp2_fastForEach_0.get_137(tmp0_2_0);
      tmp3__anonymous__3.startFrame_8();
    }
  };
  Stats.$metadata$ = {
    simpleName: 'Stats',
    kind: 'class',
    interfaces: []
  };
  var tilemapLog;
  var spaces;
  function addTimer($this, callback) {
    var tmp0_this = $this;
    var tmp0_plusAssign_0 = tmp0_this.__timers;
    tmp0_plusAssign_0.add_39(callback);
    Unit_getInstance();
  }
  function removeTimer($this, callback) {
    var tmp0_this = $this;
    var tmp0_minusAssign_0 = tmp0_this.__timers;
    tmp0_minusAssign_0.remove_47(callback);
    Unit_getInstance();
  }
  function _interval($this, time, repeat_0, callback) {
    var timer = {_v: null};
    var tmp0__get_milliseconds__0 = 0;
    var elapsed = {_v: new TimeSpan(Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0))};
    timer._v = _no_name_provided_$factory_368(elapsed, time, repeat_0, $this, timer, callback);
    var tmp;
    if (timer._v == null) {
      throwUninitializedPropertyAccessException('timer');
    } else {
      tmp = timer._v;
    }
    addTimer($this, tmp);
    var tmp_0 = Companion_getInstance_49();
    return tmp_0.invoke_199(_no_name_provided_$factory_369($this, timer));
  }
  function _no_name_provided__415($cancellable_2_2) {
    this._$cancellable_2_2_1 = $cancellable_2_2;
  }
  _no_name_provided__415.prototype.invoke_998 = function () {
    var tmp0_resume_0_5 = Unit_getInstance();
    var tmp0_success_0_1_6 = Companion_getInstance_2();
    this._$cancellable_2_2_1.resumeWith_196(_Result___init__impl_(Unit_getInstance()));
  };
  _no_name_provided__415.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__415.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__416($elapsed, $time, $repeat, this$0, $timer, $callback) {
    this._$elapsed = $elapsed;
    this._$time = $time;
    this._$repeat = $repeat;
    this._this$0_112 = this$0;
    this._$timer = $timer;
    this._$callback_4 = $callback;
  }
  _no_name_provided__416.prototype.invoke_721 = function (deltaMs) {
    this._$elapsed._v = new TimeSpan(TimeSpan__plus_impl(this._$elapsed._v._milliseconds, deltaMs));
    $l$break: while (TimeSpan__compareTo_impl(this._$elapsed._v._milliseconds, this._$time) >= 0) {
      if (!this._$repeat) {
        var tmp;
        if (this._$timer._v == null) {
          throwUninitializedPropertyAccessException('timer');
        } else {
          tmp = this._$timer._v;
        }
        removeTimer(this._this$0_112, tmp);
      }this._$elapsed._v = new TimeSpan(TimeSpan__minus_impl(this._$elapsed._v._milliseconds, this._$time));
      this._$callback_4();
      if (!this._$repeat)
        break $l$break;
    }
  };
  _no_name_provided__416.prototype.invoke_1015 = function (p1) {
    this.invoke_721(p1 instanceof TimeSpan ? p1._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__416.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__417(this$0, $timer) {
    this._this$0_113 = this$0;
    this._$timer_0 = $timer;
  }
  _no_name_provided__417.prototype.invoke_998 = function () {
    var tmp;
    if (this._$timer_0._v == null) {
      throwUninitializedPropertyAccessException('timer');
    } else {
      tmp = this._$timer_0._v;
    }
    removeTimer(this._this$0_113, tmp);
  };
  _no_name_provided__417.prototype.invoke_1005 = function () {
    this.invoke_998();
    return Unit_getInstance();
  };
  _no_name_provided__417.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TimerComponents(view) {
    this._view_4 = view;
    var tmp = this;
    tmp.__timers = ArrayList_init_$Create$();
  }
  TimerComponents.prototype._get_view__6 = function () {
    return this._view_4;
  };
  TimerComponents.prototype.update_13 = function (dt) {
    var tmp0_fastForEach_0 = this.__timers;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      tmp1__anonymous__3(new TimeSpan(dt));
    }
  };
  TimerComponents.prototype.wait = function (time, $cont) {
    var tmp0__anonymous__1_1 = $cont;
    var cancellable_2_2 = new CancellableContinuationImpl(intercepted(tmp0__anonymous__1_1), 1);
    cancellable_2_2.initCancellability_0();
    this.timeout_0(time, _no_name_provided_$factory_367(cancellable_2_2));
    Unit_getInstance();
    return cancellable_2_2.getResult_1();
  };
  TimerComponents.prototype.timeout_0 = function (time, callback) {
    return _interval(this, time, false, callback);
  };
  TimerComponents.$metadata$ = {
    simpleName: 'TimerComponents',
    kind: 'class',
    interfaces: [UpdateComponent]
  };
  function _get_timers_(_this_) {
    var tmp2_getOrCreateComponent_0_1 = _this_._get_componentsSure__21();
    var tmp3_getOrCreateComponent_0_2 = getKClass_0(TimerComponents);
    var tmp1_getOrCreateComponent_0_3 = tmp2_getOrCreateComponent_0_1._get_eupdate_();
    var component_1_4 = tmp2_getOrCreateComponent_0_1.findFirstComponentOfType(tmp1_getOrCreateComponent_0_3, tmp3_getOrCreateComponent_0_2);
    if (component_1_4 == null) {
      component_1_4 = new TimerComponents(_this_);
      var tmp0_plusAssign_0_5 = component_1_4;
      tmp1_getOrCreateComponent_0_3.add_39(tmp0_plusAssign_0_5);
      Unit_getInstance();
    }var tmp = component_1_4;
    return tmp instanceof TimerComponents ? tmp : THROW_CCE();
  }
  function delay_3(_this_, time, $cont) {
    return _get_timers_(_this_).wait(time, $cont);
  }
  function _no_name_provided_$factory_367($cancellable_2_2) {
    var i = new _no_name_provided__415($cancellable_2_2);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_368($elapsed, $time, $repeat, this$0, $timer, $callback) {
    var i = new _no_name_provided__416($elapsed, $time, $repeat, this$0, $timer, $callback);
    return function (p1) {
      i.invoke_721(p1._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_369(this$0, $timer) {
    var i = new _no_name_provided__417(this$0, $timer);
    return function () {
      i.invoke_998();
      return Unit_getInstance();
    };
  }
  var DEFAULT_EASING;
  var DEFAULT_TIME;
  function tween(_this_, vs, time, easing, callback, $cont) {
    var tmp = new $tweenCOROUTINE$26(_this_, vs, time, easing, callback, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function tween$default(_this_, vs, time, easing, callback, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      time = DEFAULT_TIME;
    if (!(($mask0 & 4) === 0))
      easing = DEFAULT_EASING;
    if (!(($mask0 & 8) === 0)) {
      callback = _no_name_provided_$factory_370();
    }return tween(_this_, vs, time, easing, callback, $cont);
  }
  function _no_name_provided__418(this$0) {
    this._this$0_114 = this$0;
  }
  _no_name_provided__418.prototype.invoke_725 = function (it) {
    this._this$0_114._cancelled = true;
  };
  _no_name_provided__418.prototype.invoke_1015 = function (p1) {
    this.invoke_725((p1 == null ? true : p1 instanceof Error) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__418.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function TweenComponent(view, vs, time, easing, callback, c) {
    this._view_5 = view;
    this._vs = vs;
    this._time_5 = time;
    this._easing = easing;
    this._callback_3 = callback;
    this._c_0 = c;
    var tmp = this;
    var tmp0__get_milliseconds__0 = 0.0;
    tmp._elapsed = Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0);
    var tmp_0 = this;
    var tmp_1;
    if (!equals_1(new TimeSpan(this._time_5), new TimeSpan(Companion_getInstance_27()._NIL))) {
      tmp_1 = this._time_5;
    } else {
      var tmp0_map_0 = this._vs;
      var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
      var tmp0_iterator_1_2 = tmp0_map_0.iterator_67();
      while (tmp0_iterator_1_2.hasNext_33()) {
        var item_2_3 = tmp0_iterator_1_2.next_37();
        tmp0_mapTo_0_1.add_39(_TimeSpan___get_nanoseconds__impl_(item_2_3._endTime));
        Unit_getInstance();
      }
      var tmp0_elvis_lhs = maxOrNull_0(tmp0_mapTo_0_1);
      var tmp1__get_nanoseconds__0 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
      tmp_1 = Companion_getInstance_27().fromNanoseconds(tmp1__get_nanoseconds__0);
    }
    tmp_0._hrtime = tmp_1;
    this._cancelled = false;
    this._done = false;
    this._c_0.invokeOnCancellation_1(_no_name_provided_$factory_371(this));
    var tmp0__get_milliseconds__0_0 = 0.0;
    this.update_13(Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0_0));
  }
  TweenComponent.prototype._get_view__6 = function () {
    return this._view_5;
  };
  TweenComponent.prototype.completeOnce = function () {
    if (!this._done) {
      this._done = true;
      detach(this);
      Unit_getInstance();
      var tmp0_resume_0 = this._c_0;
      var tmp1_resume_0 = Unit_getInstance();
      var tmp0_success_0_1 = Companion_getInstance_2();
      tmp0_resume_0.resumeWith_196(_Result___init__impl_(Unit_getInstance()));
    }};
  TweenComponent.prototype.update_13 = function (dt) {
    if (this._cancelled) {
      return this.completeOnce();
    }var tmp0_this = this;
    tmp0_this._elapsed = TimeSpan__plus_impl(tmp0_this._elapsed, dt);
    var ratio = clamp_2(TimeSpan__div_impl_0(this._elapsed, this._hrtime), 0.0, 1.0);
    this.setTo_8(this._elapsed);
    this._callback_3(this._easing.invoke_358(ratio));
    if (ratio >= 1.0) {
      return this.completeOnce();
    }};
  TweenComponent.prototype.setTo_8 = function (elapsed) {
    var tmp = new TimeSpan(elapsed);
    var tmp0__get_milliseconds__0 = 0;
    if (equals_1(tmp, new TimeSpan(Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0)))) {
      var tmp1_fastForEach_0 = this._vs;
      var n_1 = 0;
      while (n_1 < tmp1_fastForEach_0._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp2__anonymous__3 = tmp1_fastForEach_0.get_137(tmp0_2);
        tmp2__anonymous__3.init_15();
      }
    } else {
    }
    var tmp3_fastForEach_0 = this._vs;
    var n_1_0 = 0;
    while (n_1_0 < tmp3_fastForEach_0._get_size__60()) {
      var tmp0_2_0 = n_1_0;
      n_1_0 = tmp0_2_0 + 1 | 0;
      var tmp4__anonymous__3 = tmp3_fastForEach_0.get_137(tmp0_2_0);
      var tmp0_coalesce_0_5 = tmp4__anonymous__3._duration_0;
      var tmp_0;
      if (!equals_1(new TimeSpan(tmp0_coalesce_0_5), new TimeSpan(Companion_getInstance_27()._NIL))) {
        tmp_0 = tmp0_coalesce_0_5;
      } else {
        tmp_0 = TimeSpan__minus_impl(this._hrtime, tmp4__anonymous__3._startTime_2);
      }
      var durationInTween_4 = tmp_0;
      var tmp_1 = TimeSpan__minus_impl(elapsed, tmp4__anonymous__3._startTime_2);
      var tmp1__get_milliseconds__0_7 = 0.0;
      var elapsedInTween_6 = clamp(tmp_1, Companion_getInstance_27().fromMilliseconds(tmp1__get_milliseconds__0_7), durationInTween_4);
      var tmp_2;
      var tmp_3;
      var tmp2__get_milliseconds__0_9 = 0.0;
      if (TimeSpan__compareTo_impl(durationInTween_4, Companion_getInstance_27().fromMilliseconds(tmp2__get_milliseconds__0_9)) <= 0) {
        tmp_3 = true;
      } else {
        {
          tmp_3 = TimeSpan__compareTo_impl(elapsedInTween_6, durationInTween_4) >= 0;
        }
      }
      if (tmp_3) {
        tmp_2 = 1.0;
      } else {
        {
          tmp_2 = TimeSpan__div_impl_0(elapsedInTween_6, durationInTween_4);
        }
      }
      var ratioInTween_8 = tmp_2;
      var easedRatioInTween_10 = this._easing.invoke_358(ratioInTween_8);
      tmp4__anonymous__3.set_30(easedRatioInTween_10);
    }
  };
  TweenComponent.prototype.toString = function () {
    return '' + 'TweenComponent(' + this._view_5 + ')';
  };
  TweenComponent.$metadata$ = {
    simpleName: 'TweenComponent',
    kind: 'class',
    interfaces: [UpdateComponent]
  };
  function _no_name_provided__419() {
  }
  _no_name_provided__419.prototype.invoke_882 = function (it) {
    return Unit_getInstance();
  };
  _no_name_provided__419.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__419.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__420($this_tween, $tc, $vs, $time, $easing, $callback, resultContinuation) {
    this._$this_tween = $this_tween;
    this._$tc = $tc;
    this._$vs = $vs;
    this._$time_0 = $time;
    this._$easing_0 = $easing;
    this._$callback_5 = $callback;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__420.prototype.invoke_729 = function ($this$withTimeout, $cont) {
    var tmp = this.create_51($this$withTimeout, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__420.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_729((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__420.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = this;
            tmp_0._tmp0__anonymous__1_10_0 = this;
            this._cancellable_2_21 = new CancellableContinuationImpl(intercepted(this._tmp0__anonymous__1_10_0), 1);
            this._cancellable_2_21.initCancellability_0();
            this._view_42 = this._$this_tween;
            var tmp_1 = this;
            tmp_1._tmp0_also_0_53 = new TweenComponent(this._view_42, toList(this._$vs), this._$time_0, this._$easing_0, this._$callback_5, this._cancellable_2_21);
            attach_0(this._tmp0_also_0_53);
            Unit_getInstance();
            this._$tc._v = this._tmp0_also_0_53;
            suspendResult = this._cancellable_2_21.getResult_1();
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__420.prototype.create_51 = function ($this$withTimeout, completion) {
    var i = new _no_name_provided__420(this._$this_tween, this._$tc, this._$vs, this._$time_0, this._$easing_0, this._$callback_5, completion);
    i._$this$withTimeout = $this$withTimeout;
    return i;
  };
  _no_name_provided__420.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function $tweenCOROUTINE$26(_this_, vs, time, easing, callback, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__159 = _this_;
    this._vs_0 = vs;
    this._time_6 = time;
    this._easing_0 = easing;
    this._callback_4 = callback;
  }
  $tweenCOROUTINE$26.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            if (!(this.__this__159 == null)) {
              this._tc0 = {_v: null};
              this._exceptionState = 2;
              this._state_1 = 1;
              var tmp_0 = this;
              tmp_0._tmp0_times_01 = _TimeSpan___get_millisecondsLong__impl_(this._time_6);
              var tmp_1 = this;
              tmp_1._tmp1_times_02 = 2;
              var tmp_2 = numberToLong(300).plus_64(this._tmp0_times_01.times_28(toLong(this._tmp1_times_02)));
              suspendResult = withTimeout(tmp_2, _no_name_provided_$factory_372(this.__this__159, this._tc0, this._vs_0, this._time_6, this._easing_0, this._callback_4, null), this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 4;
              continue $sm;
            }

            break;
          case 1:
            suspendResult;
            this._exceptionState = 5;
            this._state_1 = 3;
            continue $sm;
          case 2:
            this._exceptionState = 5;
            var tmp_3 = this._exception_0;
            if (tmp_3 instanceof TimeoutCancellationException) {
              var e = this._exception_0;
              var tmp0_safe_receiver = this._tc0._v;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.setTo_8(this._time_6);
                Unit_getInstance();
              }
              Unit_getInstance();
              this._state_1 = 3;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 3:
            this._exceptionState = 5;
            this._state_1 = 4;
            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $tweenCOROUTINE$26.$metadata$ = {
    simpleName: '$tweenCOROUTINE$26',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_370() {
    var i = new _no_name_provided__419();
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_371(this$0) {
    var i = new _no_name_provided__418(this$0);
    return function (p1) {
      i.invoke_725(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_372($this_tween, $tc, $vs, $time, $easing, $callback, resultContinuation) {
    var i = new _no_name_provided__420($this_tween, $tc, $vs, $time, $easing, $callback, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_729(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function DEFAULT_TIME$init$() {
    var tmp0__get_seconds__0 = 1;
    return Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0);
  }
  function V2_init_$Init$(key, initial, end, interpolator, includeStart, startTime, duration, $mask0, $marker, $this) {
    if (!(($mask0 & 32) === 0)) {
      var tmp0__get_nanoseconds__0 = 0;
      startTime = Companion_getInstance_27().fromNanoseconds(tmp0__get_nanoseconds__0);
    }if (!(($mask0 & 64) === 0))
      duration = Companion_getInstance_27()._NIL;
    V2.call($this, key, initial, end, interpolator, includeStart, startTime, duration);
    return $this;
  }
  function V2_init_$Create$(key, initial, end, interpolator, includeStart, startTime, duration, $mask0, $marker) {
    return V2_init_$Init$(key, initial, end, interpolator, includeStart, startTime, duration, $mask0, $marker, Object.create(V2.prototype));
  }
  function V2(key, initial, end, interpolator, includeStart, startTime, duration) {
    this._key_5 = key;
    this._initial = initial;
    this._end_1 = end;
    this._interpolator = interpolator;
    this._includeStart = includeStart;
    this._startTime_2 = startTime;
    this._duration_0 = duration;
    var tmp = this;
    var tmp0_coalesce_0 = this._duration_0;
    var tmp_0;
    if (!equals_1(new TimeSpan(tmp0_coalesce_0), new TimeSpan(Companion_getInstance_27()._NIL))) {
      tmp_0 = tmp0_coalesce_0;
    } else {
      var tmp0__get_nanoseconds__0_2 = 0;
      tmp_0 = Companion_getInstance_27().fromNanoseconds(tmp0__get_nanoseconds__0_2);
    }
    tmp._endTime = TimeSpan__plus_impl(this._startTime_2, tmp_0);
  }
  V2.prototype.init_15 = function () {
    if (!this._includeStart) {
      this._initial = this._key_5.get();
    }};
  V2.prototype.set_30 = function (ratio) {
    return this._key_5.set(this._interpolator(ratio, this._initial, this._end_1));
  };
  V2.prototype.toString = function () {
    return '' + 'V2(key=' + this._key_5.callableName + ', range=[' + this._initial + '-' + this._end_1 + '], startTime=' + new TimeSpan(this._startTime_2) + ', duration=' + new TimeSpan(this._duration_0) + ')';
  };
  V2.prototype.hashCode = function () {
    var result = hashCode(this._key_5);
    result = imul(result, 31) + (this._initial == null ? 0 : hashCode(this._initial)) | 0;
    result = imul(result, 31) + (this._end_1 == null ? 0 : hashCode(this._end_1)) | 0;
    result = imul(result, 31) + hashCode(this._interpolator) | 0;
    result = imul(result, 31) + (this._includeStart | 0) | 0;
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._startTime_2) | 0;
    result = imul(result, 31) + TimeSpan__hashCode_impl(this._duration_0) | 0;
    return result;
  };
  V2.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals_1(this._key_5, tmp0_other_with_cast._key_5))
      return false;
    if (!equals_1(this._initial, tmp0_other_with_cast._initial))
      return false;
    if (!equals_1(this._end_1, tmp0_other_with_cast._end_1))
      return false;
    if (!equals_1(this._interpolator, tmp0_other_with_cast._interpolator))
      return false;
    if (!(this._includeStart === tmp0_other_with_cast._includeStart))
      return false;
    if (!equals_1(new TimeSpan(this._startTime_2), new TimeSpan(tmp0_other_with_cast._startTime_2)))
      return false;
    if (!equals_1(new TimeSpan(this._duration_0), new TimeSpan(tmp0_other_with_cast._duration_0)))
      return false;
    return true;
  };
  V2.$metadata$ = {
    simpleName: 'V2',
    kind: 'class',
    interfaces: []
  };
  function _interpolate(ratio, l, r) {
    return ratio < 0.0 ? l : ratio >= 1.0 ? r : interpolate(ratio, l, r);
  }
  var koruiComponent$delegate;
  function _no_name_provided__421() {
  }
  _no_name_provided__421.prototype.invoke_731 = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__421.prototype.invoke_1015 = function (p1) {
    return this.invoke_731(p1 instanceof View ? p1 : THROW_CCE());
  };
  _no_name_provided__421.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_373() {
    var i = new _no_name_provided__421();
    return function (p1) {
      return i.invoke_731(p1);
    };
  }
  function _no_name_provided__422($tmp0_onOver_0_3, $it, resultContinuation) {
    this._$tmp0_onOver_0_3 = $tmp0_onOver_0_3;
    this._$it = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__422.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__422.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__422.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp0_onOver_0_3(this._$it, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__422.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__422(this._$tmp0_onOver_0_3, this._$it, completion);
    return i;
  };
  _no_name_provided__422.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__423($tmp1_onOut_0_8, $it, resultContinuation) {
    this._$tmp1_onOut_0_8 = $tmp1_onOut_0_8;
    this._$it_0 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__423.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__423.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__423.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp1_onOut_0_8(this._$it_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__423.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__423(this._$tmp1_onOut_0_8, this._$it_0, completion);
    return i;
  };
  _no_name_provided__423.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__424($tmp2_onDown_0_13, $it, resultContinuation) {
    this._$tmp2_onDown_0_13 = $tmp2_onDown_0_13;
    this._$it_1 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__424.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__424.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__424.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp2_onDown_0_13(this._$it_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__424.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__424(this._$tmp2_onDown_0_13, this._$it_1, completion);
    return i;
  };
  _no_name_provided__424.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__425($tmp3_onUpAnywhere_0_18, $it, resultContinuation) {
    this._$tmp3_onUpAnywhere_0_18 = $tmp3_onUpAnywhere_0_18;
    this._$it_2 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__425.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__425.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__425.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp3_onUpAnywhere_0_18(this._$it_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__425.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__425(this._$tmp3_onUpAnywhere_0_18, this._$it_2, completion);
    return i;
  };
  _no_name_provided__425.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__426(this$0) {
    this._this$0_115 = this$0;
  }
  _no_name_provided__426.prototype.invoke_840 = function (it) {
    this._this$0_115.updateState_3();
  };
  _no_name_provided__426.prototype.invoke_1015 = function (p1) {
    this.invoke_840((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__426.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__427(this$0) {
    this._this$0_116 = this$0;
  }
  _no_name_provided__427.prototype.invoke_819 = function (it) {
    this._this$0_116.updateState_3();
  };
  _no_name_provided__427.prototype.invoke_1015 = function (p1) {
    this.invoke_819(p1 instanceof UISkin ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__427.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__428(this$0) {
    this._this$0_117 = this$0;
  }
  _no_name_provided__428.prototype.invoke_840 = function (it) {
    this._this$0_117.updateState_3();
  };
  _no_name_provided__428.prototype.invoke_1015 = function (p1) {
    this.invoke_840((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__428.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__429(this$0) {
    this._this$0_118 = this$0;
  }
  _no_name_provided__429.prototype.invoke_840 = function (it) {
    this._this$0_118.updateState_3();
  };
  _no_name_provided__429.prototype.invoke_1015 = function (p1) {
    this.invoke_840((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__429.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__430(this$0, resultContinuation) {
    this._this$0_119 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__430.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__430.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__430.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._this$0_119.simulateOver_0();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__430.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__430(this._this$0_119, completion);
    i._it_0 = it;
    return i;
  };
  _no_name_provided__430.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__431($tmp0_run_0_1, $tmp0_onOver_0_3) {
    this._$tmp0_run_0_1 = $tmp0_run_0_1;
    this._$tmp0_onOver_0_3_0 = $tmp0_onOver_0_3;
  }
  _no_name_provided__431.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp0_run_0_1._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_386(this._$tmp0_onOver_0_3_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__431.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__431.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__432(this$0, resultContinuation) {
    this._this$0_120 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__432.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__432.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__432.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._this$0_120.simulateOut_0();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__432.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__432(this._this$0_120, completion);
    i._it_1 = it;
    return i;
  };
  _no_name_provided__432.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__433($tmp0_run_0_1, $tmp1_onOut_0_8) {
    this._$tmp0_run_0_1_0 = $tmp0_run_0_1;
    this._$tmp1_onOut_0_8_0 = $tmp1_onOut_0_8;
  }
  _no_name_provided__433.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp0_run_0_1_0._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_387(this._$tmp1_onOut_0_8_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__433.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__433.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__434(this$0, resultContinuation) {
    this._this$0_121 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__434.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__434.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__434.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._this$0_121.simulateDown_0();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__434.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__434(this._this$0_121, completion);
    i._it_2 = it;
    return i;
  };
  _no_name_provided__434.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__435($tmp0_run_0_1, $tmp2_onDown_0_13) {
    this._$tmp0_run_0_1_1 = $tmp0_run_0_1;
    this._$tmp2_onDown_0_13_0 = $tmp2_onDown_0_13;
  }
  _no_name_provided__435.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp0_run_0_1_1._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_388(this._$tmp2_onDown_0_13_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__435.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__435.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__436(this$0, resultContinuation) {
    this._this$0_122 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__436.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__436.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__436.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._this$0_122.simulateUp_0();
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__436.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__436(this._this$0_122, completion);
    i._it_3 = it;
    return i;
  };
  _no_name_provided__436.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__437($tmp0_run_0_1, $tmp3_onUpAnywhere_0_18) {
    this._$tmp0_run_0_1_2 = $tmp0_run_0_1;
    this._$tmp3_onUpAnywhere_0_18_0 = $tmp3_onUpAnywhere_0_18;
  }
  _no_name_provided__437.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp0_run_0_1_2._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_389(this._$tmp3_onUpAnywhere_0_18_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__437.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__437.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UIButton(width, height, skin) {
    UIView.call(this, width, height);
    var tmp = this;
    var tmp0_uiObservable_0 = false;
    var tmp1_uiObservable_0 = _no_name_provided_$factory_374(this);
    tmp._forcePressed$delegate = new UIObservable(tmp0_uiObservable_0, tmp1_uiObservable_0);
    var tmp_0 = this;
    var tmp0_uiObservable_0_0 = _no_name_provided_$factory_375(this);
    tmp_0._skin$delegate = new UIObservable(skin, tmp0_uiObservable_0_0);
    var tmp_1 = this;
    var tmp2_ninePatch_0 = skin._normal_0;
    var tmp3_ninePatch_0 = 0.15625;
    var tmp4_ninePatch_0 = 0.15625;
    var tmp5_ninePatch_0 = 0.84375;
    var tmp6_ninePatch_0 = 0.84375;
    var tmp1_addTo_0 = new NinePatch(tmp2_ninePatch_0, width, height, tmp3_ninePatch_0, tmp4_ninePatch_0, tmp5_ninePatch_0, tmp6_ninePatch_0);
    var tmp0_apply_0 = addTo(tmp1_addTo_0, this);
    Unit_getInstance();
    tmp_1._rect_1 = tmp0_apply_0;
    var tmp_2 = this;
    var tmp0_uiObservable_0_1 = false;
    var tmp1_uiObservable_0_0 = _no_name_provided_$factory_376(this);
    tmp_2._bover$delegate = new UIObservable(tmp0_uiObservable_0_1, tmp1_uiObservable_0_0);
    var tmp_3 = this;
    var tmp0_uiObservable_0_2 = false;
    var tmp1_uiObservable_0_1 = _no_name_provided_$factory_377(this);
    tmp_3._bpressing$delegate = new UIObservable(tmp0_uiObservable_0_2, tmp1_uiObservable_0_1);
    var tmp0_run_0_1 = _get_mouse_(this);
    var tmp0_onOver_0_3 = _no_name_provided_$factory_378(this, null);
    var tmp0__mouseEvent_0_1_5 = over$factory();
    var tmp_4 = tmp0__mouseEvent_0_1_5.get(tmp0_run_0_1);
    tmp_4.add_41(_no_name_provided_$factory_379(tmp0_run_0_1, tmp0_onOver_0_3));
    Unit_getInstance();
    Unit_getInstance();
    var tmp1_onOut_0_8 = _no_name_provided_$factory_380(this, null);
    var tmp0__mouseEvent_0_1_10 = out$factory();
    var tmp_5 = tmp0__mouseEvent_0_1_10.get(tmp0_run_0_1);
    tmp_5.add_41(_no_name_provided_$factory_381(tmp0_run_0_1, tmp1_onOut_0_8));
    Unit_getInstance();
    Unit_getInstance();
    var tmp2_onDown_0_13 = _no_name_provided_$factory_382(this, null);
    var tmp0__mouseEvent_0_1_15 = down$factory();
    var tmp_6 = tmp0__mouseEvent_0_1_15.get(tmp0_run_0_1);
    tmp_6.add_41(_no_name_provided_$factory_383(tmp0_run_0_1, tmp2_onDown_0_13));
    Unit_getInstance();
    Unit_getInstance();
    var tmp3_onUpAnywhere_0_18 = _no_name_provided_$factory_384(this, null);
    var tmp0__mouseEvent_0_1_20 = upAnywhere$factory();
    var tmp_7 = tmp0__mouseEvent_0_1_20.get(tmp0_run_0_1);
    tmp_7.add_41(_no_name_provided_$factory_385(tmp0_run_0_1, tmp3_onUpAnywhere_0_18));
    Unit_getInstance();
    Unit_getInstance();
  }
  UIButton.prototype._set_forcePressed__0 = function (_set___) {
    return this._forcePressed$delegate.setValue_3(this, forcePressed$factory(), _set___);
  };
  UIButton.prototype._get_forcePressed__0 = function () {
    return this._forcePressed$delegate.getValue_0(this, forcePressed$factory_0());
  };
  UIButton.prototype._set_skin__1 = function (_set___) {
    return this._skin$delegate.setValue_3(this, skin$factory(), _set___);
  };
  UIButton.prototype._get_skin__1 = function () {
    return this._skin$delegate.getValue_0(this, skin$factory_0());
  };
  UIButton.prototype._get_rect__0 = function () {
    return this._rect_1;
  };
  UIButton.prototype._set_bover__0 = function (_set___) {
    return this._bover$delegate.setValue_3(this, bover$factory(), _set___);
  };
  UIButton.prototype._get_bover__0 = function () {
    return this._bover$delegate.getValue_0(this, bover$factory_0());
  };
  UIButton.prototype._set_bpressing__0 = function (_set___) {
    return this._bpressing$delegate.setValue_3(this, bpressing$factory(), _set___);
  };
  UIButton.prototype._get_bpressing__0 = function () {
    return this._bpressing$delegate.getValue_0(this, bpressing$factory_0());
  };
  UIButton.prototype.simulateOver_0 = function () {
    this._set_bover__0(true);
  };
  UIButton.prototype.simulateOut_0 = function () {
    this._set_bover__0(false);
  };
  UIButton.prototype.simulateDown_0 = function () {
    this._set_bpressing__0(true);
  };
  UIButton.prototype.simulateUp_0 = function () {
    this._set_bpressing__0(false);
  };
  UIButton.prototype.updateState_3 = function () {
    this._get_rect__0()._tex_0 = !this._get_enabled__3() ? this._get_skin__1()._disabled_0 : (this._get_bpressing__0() ? true : this._get_forcePressed__0()) ? this._get_skin__1()._down_1 : this._get_bover__0() ? this._get_skin__1()._over_1 : this._get_skin__1()._normal_0;
  };
  UIButton.prototype.onSizeChanged_3 = function () {
    UIView.prototype.onSizeChanged_3.call(this);
    this._get_rect__0()._width_19 = this._get_width__58();
    this._get_rect__0()._height_19 = this._get_height__58();
    this.updateState_3();
  };
  UIButton.$metadata$ = {
    simpleName: 'UIButton',
    kind: 'class',
    interfaces: []
  };
  function over$factory() {
    return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
      return receiver._over;
    }, null);
  }
  function out$factory() {
    return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
      return receiver._out_9;
    }, null);
  }
  function down$factory() {
    return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
      return receiver._down;
    }, null);
  }
  function upAnywhere$factory() {
    return getPropertyCallableRef('upAnywhere', 1, KProperty1, function (receiver) {
      return receiver._upAnywhere;
    }, null);
  }
  function forcePressed$factory() {
    return getPropertyCallableRef('forcePressed', 1, KMutableProperty1, function (receiver) {
      return receiver._get_forcePressed__0();
    }, function (receiver_0, value) {
      return receiver_0._set_forcePressed__0(value);
    });
  }
  function forcePressed$factory_0() {
    return getPropertyCallableRef('forcePressed', 1, KMutableProperty1, function (receiver) {
      return receiver._get_forcePressed__0();
    }, function (receiver_0, value) {
      return receiver_0._set_forcePressed__0(value);
    });
  }
  function skin$factory() {
    return getPropertyCallableRef('skin', 1, KMutableProperty1, function (receiver) {
      return receiver._get_skin__1();
    }, function (receiver_0, value) {
      return receiver_0._set_skin__1(value);
    });
  }
  function skin$factory_0() {
    return getPropertyCallableRef('skin', 1, KMutableProperty1, function (receiver) {
      return receiver._get_skin__1();
    }, function (receiver_0, value) {
      return receiver_0._set_skin__1(value);
    });
  }
  function bover$factory() {
    return getPropertyCallableRef('bover', 1, KMutableProperty1, function (receiver) {
      return receiver._get_bover__0();
    }, function (receiver_0, value) {
      return receiver_0._set_bover__0(value);
    });
  }
  function bover$factory_0() {
    return getPropertyCallableRef('bover', 1, KMutableProperty1, function (receiver) {
      return receiver._get_bover__0();
    }, function (receiver_0, value) {
      return receiver_0._set_bover__0(value);
    });
  }
  function bpressing$factory() {
    return getPropertyCallableRef('bpressing', 1, KMutableProperty1, function (receiver) {
      return receiver._get_bpressing__0();
    }, function (receiver_0, value) {
      return receiver_0._set_bpressing__0(value);
    });
  }
  function bpressing$factory_0() {
    return getPropertyCallableRef('bpressing', 1, KMutableProperty1, function (receiver) {
      return receiver._get_bpressing__0();
    }, function (receiver_0, value) {
      return receiver_0._set_bpressing__0(value);
    });
  }
  function _no_name_provided_$factory_374(this$0) {
    var i = new _no_name_provided__426(this$0);
    return function (p1) {
      i.invoke_840(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_375(this$0) {
    var i = new _no_name_provided__427(this$0);
    return function (p1) {
      i.invoke_819(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_376(this$0) {
    var i = new _no_name_provided__428(this$0);
    return function (p1) {
      i.invoke_840(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_377(this$0) {
    var i = new _no_name_provided__429(this$0);
    return function (p1) {
      i.invoke_840(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_378(this$0, resultContinuation) {
    var i = new _no_name_provided__430(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_379($tmp0_run_0_1, $tmp0_onOver_0_3) {
    var i = new _no_name_provided__431($tmp0_run_0_1, $tmp0_onOver_0_3);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_380(this$0, resultContinuation) {
    var i = new _no_name_provided__432(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_381($tmp0_run_0_1, $tmp1_onOut_0_8) {
    var i = new _no_name_provided__433($tmp0_run_0_1, $tmp1_onOut_0_8);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_382(this$0, resultContinuation) {
    var i = new _no_name_provided__434(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_383($tmp0_run_0_1, $tmp2_onDown_0_13) {
    var i = new _no_name_provided__435($tmp0_run_0_1, $tmp2_onDown_0_13);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_384(this$0, resultContinuation) {
    var i = new _no_name_provided__436(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_385($tmp0_run_0_1, $tmp3_onUpAnywhere_0_18) {
    var i = new _no_name_provided__437($tmp0_run_0_1, $tmp3_onUpAnywhere_0_18);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_386($tmp0_onOver_0_3, $it, resultContinuation) {
    var i = new _no_name_provided__422($tmp0_onOver_0_3, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_387($tmp1_onOut_0_8, $it, resultContinuation) {
    var i = new _no_name_provided__423($tmp1_onOut_0_8, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_388($tmp2_onDown_0_13, $it, resultContinuation) {
    var i = new _no_name_provided__424($tmp2_onDown_0_13, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_389($tmp3_onUpAnywhere_0_18, $it, resultContinuation) {
    var i = new _no_name_provided__425($tmp3_onUpAnywhere_0_18, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided__438() {
  }
  _no_name_provided__438.prototype.invoke_1005 = function () {
    return UICheckBox_init_$Create$(0.0, 0.0, false, null, null, null, null, 127, null);
  };
  _no_name_provided__438.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__439() {
  }
  _no_name_provided__439.prototype.invoke_766 = function ($this$null) {
    var tmp = text$factory_1();
    $this$null.add$default_15(tmp, null, 2, null);
    Unit_getInstance();
    var tmp_0 = checked$factory_1();
    $this$null.add$default_14(tmp_0, false, 2, null);
    Unit_getInstance();
    var tmp_1 = width$factory();
    $this$null.add$default_16(tmp_1, 0.0, 2, null);
    Unit_getInstance();
    var tmp_2 = height$factory();
    $this$null.add$default_16(tmp_2, 0.0, 2, null);
    Unit_getInstance();
  };
  _no_name_provided__439.prototype.invoke_1015 = function (p1) {
    this.invoke_766(p1 instanceof KTreeSerializerExt ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__439.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__440($tmp0_onOver_0_3, $it, resultContinuation) {
    this._$tmp0_onOver_0_3_1 = $tmp0_onOver_0_3;
    this._$it_3 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__440.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__440.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__440.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp0_onOver_0_3_1(this._$it_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__440.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__440(this._$tmp0_onOver_0_3_1, this._$it_3, completion);
    return i;
  };
  _no_name_provided__440.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__441($tmp1_onOut_0_8, $it, resultContinuation) {
    this._$tmp1_onOut_0_8_1 = $tmp1_onOut_0_8;
    this._$it_4 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__441.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__441.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__441.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp1_onOut_0_8_1(this._$it_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__441.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__441(this._$tmp1_onOut_0_8_1, this._$it_4, completion);
    return i;
  };
  _no_name_provided__441.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__442($tmp2_onDown_0_13, $it, resultContinuation) {
    this._$tmp2_onDown_0_13_1 = $tmp2_onDown_0_13;
    this._$it_5 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__442.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__442.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__442.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp2_onDown_0_13_1(this._$it_5, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__442.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__442(this._$tmp2_onDown_0_13_1, this._$it_5, completion);
    return i;
  };
  _no_name_provided__442.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__443($tmp3_onUpAnywhere_0_18, $it, resultContinuation) {
    this._$tmp3_onUpAnywhere_0_18_1 = $tmp3_onUpAnywhere_0_18;
    this._$it_6 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__443.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__443.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__443.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp3_onUpAnywhere_0_18_1(this._$it_6, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__443.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__443(this._$tmp3_onUpAnywhere_0_18_1, this._$it_6, completion);
    return i;
  };
  _no_name_provided__443.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__444($tmp4_onClick_0_23, $it, resultContinuation) {
    this._$tmp4_onClick_0_23 = $tmp4_onClick_0_23;
    this._$it_7 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__444.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__444.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__444.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp4_onClick_0_23(this._$it_7, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__444.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__444(this._$tmp4_onClick_0_23, this._$it_7, completion);
    return i;
  };
  _no_name_provided__444.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function UICheckBox_init_$Init$(width, height, checked, text, textFont, skin, checkIcon, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 120.0;
    if (!(($mask0 & 2) === 0))
      height = 32.0;
    if (!(($mask0 & 4) === 0))
      checked = false;
    if (!(($mask0 & 8) === 0))
      text = 'CheckBox';
    if (!(($mask0 & 16) === 0))
      textFont = _get_DefaultUIFont_();
    if (!(($mask0 & 32) === 0))
      skin = _get_DefaultUISkin_();
    if (!(($mask0 & 64) === 0))
      checkIcon = _get_DefaultCheckSkin_();
    UICheckBox.call($this, width, height, checked, text, textFont, skin, checkIcon);
    return $this;
  }
  function UICheckBox_init_$Create$(width, height, checked, text, textFont, skin, checkIcon, $mask0, $marker) {
    return UICheckBox_init_$Init$(width, height, checked, text, textFont, skin, checkIcon, $mask0, $marker, Object.create(UICheckBox.prototype));
  }
  function _set_over_($this, _set___) {
    return $this._over$delegate.setValue_3($this, over$factory_1(), _set___);
  }
  function _get_over_($this) {
    return $this._over$delegate.getValue_0($this, over$factory_2());
  }
  function _set_pressing_($this, _set___) {
    return $this._pressing$delegate.setValue_3($this, pressing$factory(), _set___);
  }
  function _get_pressing_($this) {
    return $this._pressing$delegate.getValue_0($this, pressing$factory_0());
  }
  function updateText($this) {
    $this._textView.setFormat($this._get_textFont__0(), $this._get_textSize__0(), $this._get_textColor__0(), Companion_getInstance_116()._MIDDLE_LEFT_0);
    $this._textView.setTextBounds(new Rectangle(0.0, 0.0, $this._get_width__58() - $this._get_height__58(), $this._get_height__58()));
    setText($this._textView, $this._get_text__2());
    position_0($this._textView, $this._get_height__58() + 8.0, 0.0);
    Unit_getInstance();
  }
  function Serializer() {
    Serializer_instance = this;
    var tmp = getKClass_0(UICheckBox);
    var tmp_0 = _no_name_provided_$factory_407();
    KTreeSerializerExt.call(this, 'UICheckBox', tmp, tmp_0, _no_name_provided_$factory_408());
  }
  Serializer.$metadata$ = {
    simpleName: 'Serializer',
    kind: 'object',
    interfaces: []
  };
  var Serializer_instance;
  function Serializer_getInstance() {
    if (Serializer_instance == null)
      new Serializer();
    return Serializer_instance;
  }
  function _no_name_provided__445(this$0) {
    this._this$0_123 = this$0;
  }
  _no_name_provided__445.prototype.invoke_840 = function (it) {
    this._this$0_123.updateState_3();
  };
  _no_name_provided__445.prototype.invoke_1015 = function (p1) {
    this.invoke_840((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__445.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__446(this$0) {
    this._this$0_124 = this$0;
  }
  _no_name_provided__446.prototype.invoke_824 = function (it) {
    updateText(this._this$0_124);
  };
  _no_name_provided__446.prototype.invoke_1015 = function (p1) {
    this.invoke_824((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__446.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__447(this$0) {
    this._this$0_125 = this$0;
  }
  _no_name_provided__447.prototype.invoke_832 = function (it) {
    updateText(this._this$0_125);
  };
  _no_name_provided__447.prototype.invoke_1015 = function (p1) {
    this.invoke_832((!(p1 == null) ? isInterface(p1, Font) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__447.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__448(this$0) {
    this._this$0_126 = this$0;
  }
  _no_name_provided__448.prototype.invoke_836 = function (it) {
    updateText(this._this$0_126);
  };
  _no_name_provided__448.prototype.invoke_1015 = function (p1) {
    this.invoke_836((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__448.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__449(this$0) {
    this._this$0_127 = this$0;
  }
  _no_name_provided__449.prototype.invoke_838 = function (it) {
    updateText(this._this$0_127);
  };
  _no_name_provided__449.prototype.invoke_1015 = function (p1) {
    this.invoke_838(p1 instanceof RGBA ? p1._value_17 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__449.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__450(this$0) {
    this._this$0_128 = this$0;
  }
  _no_name_provided__450.prototype.invoke_840 = function (it) {
    this._this$0_128.updateState_3();
  };
  _no_name_provided__450.prototype.invoke_1015 = function (p1) {
    this.invoke_840((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__450.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__451(this$0) {
    this._this$0_129 = this$0;
  }
  _no_name_provided__451.prototype.invoke_840 = function (it) {
    this._this$0_129.updateState_3();
  };
  _no_name_provided__451.prototype.invoke_1015 = function (p1) {
    this.invoke_840((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__451.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__452(this$0, resultContinuation) {
    this._this$0_130 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__452.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__452.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__452.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          _set_over_(this._this$0_130, true);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__452.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__452(this._this$0_130, completion);
    i._it_4 = it;
    return i;
  };
  _no_name_provided__452.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__453($tmp0_run_0_1, $tmp0_onOver_0_3) {
    this._$tmp0_run_0_1_3 = $tmp0_run_0_1;
    this._$tmp0_onOver_0_3_2 = $tmp0_onOver_0_3;
  }
  _no_name_provided__453.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp0_run_0_1_3._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_409(this._$tmp0_onOver_0_3_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__453.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__453.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__454(this$0, resultContinuation) {
    this._this$0_131 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__454.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__454.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__454.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          _set_over_(this._this$0_131, false);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__454.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__454(this._this$0_131, completion);
    i._it_5 = it;
    return i;
  };
  _no_name_provided__454.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__455($tmp0_run_0_1, $tmp1_onOut_0_8) {
    this._$tmp0_run_0_1_4 = $tmp0_run_0_1;
    this._$tmp1_onOut_0_8_2 = $tmp1_onOut_0_8;
  }
  _no_name_provided__455.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp0_run_0_1_4._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_410(this._$tmp1_onOut_0_8_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__455.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__455.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__456(this$0, resultContinuation) {
    this._this$0_132 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__456.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__456.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__456.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          _set_pressing_(this._this$0_132, true);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__456.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__456(this._this$0_132, completion);
    i._it_6 = it;
    return i;
  };
  _no_name_provided__456.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__457($tmp0_run_0_1, $tmp2_onDown_0_13) {
    this._$tmp0_run_0_1_5 = $tmp0_run_0_1;
    this._$tmp2_onDown_0_13_2 = $tmp2_onDown_0_13;
  }
  _no_name_provided__457.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp0_run_0_1_5._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_411(this._$tmp2_onDown_0_13_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__457.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__457.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__458(this$0, resultContinuation) {
    this._this$0_133 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__458.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__458.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__458.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          _set_pressing_(this._this$0_133, false);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__458.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__458(this._this$0_133, completion);
    i._it_7 = it;
    return i;
  };
  _no_name_provided__458.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__459($tmp0_run_0_1, $tmp3_onUpAnywhere_0_18) {
    this._$tmp0_run_0_1_6 = $tmp0_run_0_1;
    this._$tmp3_onUpAnywhere_0_18_2 = $tmp3_onUpAnywhere_0_18;
  }
  _no_name_provided__459.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp0_run_0_1_6._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_412(this._$tmp3_onUpAnywhere_0_18_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__459.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__459.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__460(this$0, resultContinuation) {
    this._this$0_134 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__460.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__460.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__460.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          if (!this._it_8._get_views__7()._editingMode) {
            this._this$0_134._set_checked_(!this._this$0_134._get_checked_());
          }return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__460.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__460(this._this$0_134, completion);
    i._it_8 = it;
    return i;
  };
  _no_name_provided__460.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__461($tmp0_run_0_1, $tmp4_onClick_0_23) {
    this._$tmp0_run_0_1_7 = $tmp0_run_0_1;
    this._$tmp4_onClick_0_23_0 = $tmp4_onClick_0_23;
  }
  _no_name_provided__461.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp0_run_0_1_7._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_413(this._$tmp4_onClick_0_23_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__461.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__461.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UICheckBox(width, height, checked, text, textFont, skin, checkIcon) {
    UIView.call(this, width, height);
    this._skin = skin;
    this._checkIcon = checkIcon;
    var tmp = this;
    var tmp0_uiObservable_0 = _no_name_provided_$factory_390(this);
    tmp._checked$delegate = new UIObservable(checked, tmp0_uiObservable_0);
    var tmp_0 = this;
    var tmp0_uiObservable_0_0 = _no_name_provided_$factory_391(this);
    tmp_0._text$delegate = new UIObservable(text, tmp0_uiObservable_0_0);
    var tmp_1 = this;
    var tmp0_uiObservable_0_1 = _no_name_provided_$factory_392(this);
    tmp_1._textFont$delegate = new UIObservable(textFont, tmp0_uiObservable_0_1);
    var tmp_2 = this;
    var tmp0_uiObservable_0_2 = 16;
    var tmp1_uiObservable_0 = _no_name_provided_$factory_393(this);
    tmp_2._textSize$delegate = new UIObservable(tmp0_uiObservable_0_2, tmp1_uiObservable_0);
    var tmp_3 = this;
    var tmp0_uiObservable_0_3 = Colors_getInstance()._WHITE;
    var tmp1_uiObservable_0_0 = _no_name_provided_$factory_394(this);
    tmp_3._textColor$delegate = new UIObservable(new RGBA(tmp0_uiObservable_0_3), tmp1_uiObservable_0_0);
    var tmp_4 = this;
    tmp_4._onChange = Signal_init_$Create$(null, 1, null);
    var tmp_5 = this;
    var tmp2_solidRect_0 = Colors_getInstance()._TRANSPARENT_BLACK;
    var tmp1_addTo_0 = new SolidRect(width, height, tmp2_solidRect_0);
    var tmp0_apply_0 = addTo(tmp1_addTo_0, this);
    Unit_getInstance();
    tmp_5._background = tmp0_apply_0;
    var tmp_6 = this;
    var tmp2_ninePatch_0 = this._skin._normal_0;
    var tmp3_ninePatch_0 = 0.15625;
    var tmp4_ninePatch_0 = 0.15625;
    var tmp5_ninePatch_0 = 0.84375;
    var tmp6_ninePatch_0 = 0.84375;
    var tmp1_addTo_0_0 = new NinePatch(tmp2_ninePatch_0, height, height, tmp3_ninePatch_0, tmp4_ninePatch_0, tmp5_ninePatch_0, tmp6_ninePatch_0);
    var tmp0_apply_0_0 = addTo(tmp1_addTo_0_0, this);
    Unit_getInstance();
    tmp_6._box = tmp0_apply_0_0;
    var tmp_7 = this;
    var tmp2_ninePatch_0_0 = this._checkIcon._normal_1;
    var tmp3_ninePatch_0_0 = calculateWidth(this._checkIcon, height);
    var tmp4_ninePatch_0_0 = calculateHeight(this._checkIcon, height);
    var tmp5_ninePatch_0_0 = 0.0;
    var tmp6_ninePatch_0_0 = 0.0;
    var tmp7_ninePatch_0 = 0.0;
    var tmp8_ninePatch_0 = 0.0;
    var tmp1_addTo_0_1 = new NinePatch(tmp2_ninePatch_0_0, tmp3_ninePatch_0_0, tmp4_ninePatch_0_0, tmp5_ninePatch_0_0, tmp6_ninePatch_0_0, tmp7_ninePatch_0, tmp8_ninePatch_0);
    var tmp0_apply_0_1 = addTo(tmp1_addTo_0_1, this);
    Unit_getInstance();
    var tmp9_also_0 = position_0(tmp0_apply_0_1, paddingLeft(this._checkIcon, height), paddingTop(this._checkIcon, height));
    tmp9_also_0._set_visible__4(false);
    tmp_7._icon_3 = tmp9_also_0;
    var tmp_8 = this;
    var tmp2_text_0 = Companion_getInstance_149()._DEFAULT_TEXT_SIZE;
    var tmp3_text_0 = Colors_getInstance()._WHITE;
    var tmp4_text_0 = _get_DefaultTtfFont_();
    var tmp5_text_0 = Companion_getInstance_116()._TOP_LEFT_0;
    var tmp6_text_0 = DefaultStringTextRenderer;
    var tmp7_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
    var tmp1_addTo_0_2 = new Text_2(text, tmp2_text_0, tmp3_text_0, tmp4_text_0, tmp5_text_0, tmp6_text_0, tmp7_text_0);
    var tmp0_apply_0_2 = addTo(tmp1_addTo_0_2, this);
    Unit_getInstance();
    tmp_8._textView = tmp0_apply_0_2;
    var tmp_9 = this;
    var tmp0_uiObservable_0_4 = false;
    var tmp1_uiObservable_0_1 = _no_name_provided_$factory_395(this);
    tmp_9._over$delegate = new UIObservable(tmp0_uiObservable_0_4, tmp1_uiObservable_0_1);
    var tmp_10 = this;
    var tmp0_uiObservable_0_5 = false;
    var tmp1_uiObservable_0_2 = _no_name_provided_$factory_396(this);
    tmp_10._pressing$delegate = new UIObservable(tmp0_uiObservable_0_5, tmp1_uiObservable_0_2);
    var tmp0_run_0_1 = _get_mouse_(this);
    var tmp0_onOver_0_3 = _no_name_provided_$factory_397(this, null);
    var tmp0__mouseEvent_0_1_5 = over$factory_0();
    var tmp_11 = tmp0__mouseEvent_0_1_5.get(tmp0_run_0_1);
    tmp_11.add_41(_no_name_provided_$factory_398(tmp0_run_0_1, tmp0_onOver_0_3));
    Unit_getInstance();
    Unit_getInstance();
    var tmp1_onOut_0_8 = _no_name_provided_$factory_399(this, null);
    var tmp0__mouseEvent_0_1_10 = out$factory_0();
    var tmp_12 = tmp0__mouseEvent_0_1_10.get(tmp0_run_0_1);
    tmp_12.add_41(_no_name_provided_$factory_400(tmp0_run_0_1, tmp1_onOut_0_8));
    Unit_getInstance();
    Unit_getInstance();
    var tmp2_onDown_0_13 = _no_name_provided_$factory_401(this, null);
    var tmp0__mouseEvent_0_1_15 = down$factory_0();
    var tmp_13 = tmp0__mouseEvent_0_1_15.get(tmp0_run_0_1);
    tmp_13.add_41(_no_name_provided_$factory_402(tmp0_run_0_1, tmp2_onDown_0_13));
    Unit_getInstance();
    Unit_getInstance();
    var tmp3_onUpAnywhere_0_18 = _no_name_provided_$factory_403(this, null);
    var tmp0__mouseEvent_0_1_20 = upAnywhere$factory_0();
    var tmp_14 = tmp0__mouseEvent_0_1_20.get(tmp0_run_0_1);
    tmp_14.add_41(_no_name_provided_$factory_404(tmp0_run_0_1, tmp3_onUpAnywhere_0_18));
    Unit_getInstance();
    Unit_getInstance();
    var tmp4_onClick_0_23 = _no_name_provided_$factory_405(this, null);
    var tmp0__mouseEvent_0_1_25 = click$factory();
    var tmp_15 = tmp0__mouseEvent_0_1_25.get(tmp0_run_0_1);
    tmp_15.add_41(_no_name_provided_$factory_406(tmp0_run_0_1, tmp4_onClick_0_23));
    Unit_getInstance();
    Unit_getInstance();
    updateText(this);
  }
  UICheckBox.prototype._set_checked_ = function (_set___) {
    return this._checked$delegate.setValue_3(this, checked$factory(), _set___);
  };
  UICheckBox.prototype._get_checked_ = function () {
    return this._checked$delegate.getValue_0(this, checked$factory_0());
  };
  UICheckBox.prototype._set_text__2 = function (_set___) {
    return this._text$delegate.setValue_3(this, text$factory(), _set___);
  };
  UICheckBox.prototype._get_text__2 = function () {
    return this._text$delegate.getValue_0(this, text$factory_0());
  };
  UICheckBox.prototype._set_textFont__0 = function (_set___) {
    return this._textFont$delegate.setValue_3(this, textFont$factory(), _set___);
  };
  UICheckBox.prototype._get_textFont__0 = function () {
    return this._textFont$delegate.getValue_0(this, textFont$factory_0());
  };
  UICheckBox.prototype._set_textSize_ = function (_set___) {
    return this._textSize$delegate.setValue_3(this, textSize$factory(), _set___);
  };
  UICheckBox.prototype._get_textSize__0 = function () {
    return this._textSize$delegate.getValue_0(this, textSize$factory_0());
  };
  UICheckBox.prototype._set_textColor__0 = function (_set___) {
    return this._textColor$delegate.setValue_3(this, textColor$factory(), new RGBA(_set___));
  };
  UICheckBox.prototype._get_textColor__0 = function () {
    return this._textColor$delegate.getValue_0(this, textColor$factory_0())._value_17;
  };
  UICheckBox.prototype.updateState_3 = function () {
    UIView.prototype.updateState_3.call(this);
    this._box._tex_0 = !this._get_enabled__3() ? this._skin._disabled_0 : _get_pressing_(this) ? this._skin._down_1 : _get_over_(this) ? this._skin._over_1 : this._skin._normal_0;
    this._icon_3._tex_0 = !this._get_enabled__3() ? this._checkIcon._disabled_1 : _get_pressing_(this) ? this._checkIcon._down_2 : _get_over_(this) ? this._checkIcon._over_2 : this._checkIcon._normal_1;
    this._icon_3._set_visible__4(this._get_checked_());
    this._onChange.invoke_137(this);
  };
  UICheckBox.prototype.onSizeChanged_3 = function () {
    UIView.prototype.onSizeChanged_3.call(this);
    size_0(this._background, this._get_width__58(), this._get_height__58());
    Unit_getInstance();
    size_0(this._box, this._get_height__58(), this._get_height__58());
    Unit_getInstance();
    this._icon_3._width_19 = calculateWidth(this._checkIcon, this._get_height__58());
    this._icon_3._height_19 = calculateHeight(this._checkIcon, this._get_height__58());
    position_0(this._textView, this._get_height__58() + 8.0, 0.0);
    Unit_getInstance();
    this._textView.setTextBounds(new Rectangle(0.0, 0.0, this._get_width__58() - this._get_height__58() - 8.0, this._get_height__58()));
  };
  UICheckBox.$metadata$ = {
    simpleName: 'UICheckBox',
    kind: 'class',
    interfaces: [ViewLeaf]
  };
  function over$factory_0() {
    return getPropertyCallableRef('over', 1, KProperty1, function (receiver) {
      return receiver._over;
    }, null);
  }
  function out$factory_0() {
    return getPropertyCallableRef('out', 1, KProperty1, function (receiver) {
      return receiver._out_9;
    }, null);
  }
  function down$factory_0() {
    return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
      return receiver._down;
    }, null);
  }
  function upAnywhere$factory_0() {
    return getPropertyCallableRef('upAnywhere', 1, KProperty1, function (receiver) {
      return receiver._upAnywhere;
    }, null);
  }
  function click$factory() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function checked$factory() {
    return getPropertyCallableRef('checked', 1, KMutableProperty1, function (receiver) {
      return receiver._get_checked_();
    }, function (receiver_0, value) {
      return receiver_0._set_checked_(value);
    });
  }
  function checked$factory_0() {
    return getPropertyCallableRef('checked', 1, KMutableProperty1, function (receiver) {
      return receiver._get_checked_();
    }, function (receiver_0, value) {
      return receiver_0._set_checked_(value);
    });
  }
  function text$factory() {
    return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
      return receiver._get_text__2();
    }, function (receiver_0, value) {
      return receiver_0._set_text__2(value);
    });
  }
  function text$factory_0() {
    return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
      return receiver._get_text__2();
    }, function (receiver_0, value) {
      return receiver_0._set_text__2(value);
    });
  }
  function textFont$factory() {
    return getPropertyCallableRef('textFont', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textFont__0();
    }, function (receiver_0, value) {
      return receiver_0._set_textFont__0(value);
    });
  }
  function textFont$factory_0() {
    return getPropertyCallableRef('textFont', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textFont__0();
    }, function (receiver_0, value) {
      return receiver_0._set_textFont__0(value);
    });
  }
  function textSize$factory() {
    return getPropertyCallableRef('textSize', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textSize__0();
    }, function (receiver_0, value) {
      return receiver_0._set_textSize_(value);
    });
  }
  function textSize$factory_0() {
    return getPropertyCallableRef('textSize', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textSize__0();
    }, function (receiver_0, value) {
      return receiver_0._set_textSize_(value);
    });
  }
  function textColor$factory() {
    return getPropertyCallableRef('textColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(receiver._get_textColor__0());
    }, function (receiver_0, value) {
      return receiver_0._set_textColor__0(value._value_17);
    });
  }
  function textColor$factory_0() {
    return getPropertyCallableRef('textColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(receiver._get_textColor__0());
    }, function (receiver_0, value) {
      return receiver_0._set_textColor__0(value._value_17);
    });
  }
  function over$factory_1() {
    return getPropertyCallableRef('over', 1, KMutableProperty1, function (receiver) {
      return _get_over_(receiver);
    }, function (receiver_0, value) {
      return _set_over_(receiver_0, value);
    });
  }
  function over$factory_2() {
    return getPropertyCallableRef('over', 1, KMutableProperty1, function (receiver) {
      return _get_over_(receiver);
    }, function (receiver_0, value) {
      return _set_over_(receiver_0, value);
    });
  }
  function pressing$factory() {
    return getPropertyCallableRef('pressing', 1, KMutableProperty1, function (receiver) {
      return _get_pressing_(receiver);
    }, function (receiver_0, value) {
      return _set_pressing_(receiver_0, value);
    });
  }
  function pressing$factory_0() {
    return getPropertyCallableRef('pressing', 1, KMutableProperty1, function (receiver) {
      return _get_pressing_(receiver);
    }, function (receiver_0, value) {
      return _set_pressing_(receiver_0, value);
    });
  }
  function text$factory_1() {
    return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
      return receiver._get_text__2();
    }, function (receiver_0, value) {
      return receiver_0._set_text__2(value);
    });
  }
  function checked$factory_1() {
    return getPropertyCallableRef('checked', 1, KMutableProperty1, function (receiver) {
      return receiver._get_checked_();
    }, function (receiver_0, value) {
      return receiver_0._set_checked_(value);
    });
  }
  function width$factory() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__58();
    }, function (receiver_0, value) {
      return receiver_0._set_width__27(value);
    });
  }
  function height$factory() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__58();
    }, function (receiver_0, value) {
      return receiver_0._set_height__27(value);
    });
  }
  function _no_name_provided_$factory_390(this$0) {
    var i = new _no_name_provided__445(this$0);
    return function (p1) {
      i.invoke_840(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_391(this$0) {
    var i = new _no_name_provided__446(this$0);
    return function (p1) {
      i.invoke_824(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_392(this$0) {
    var i = new _no_name_provided__447(this$0);
    return function (p1) {
      i.invoke_832(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_393(this$0) {
    var i = new _no_name_provided__448(this$0);
    return function (p1) {
      i.invoke_836(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_394(this$0) {
    var i = new _no_name_provided__449(this$0);
    return function (p1) {
      i.invoke_838(p1._value_17);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_395(this$0) {
    var i = new _no_name_provided__450(this$0);
    return function (p1) {
      i.invoke_840(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_396(this$0) {
    var i = new _no_name_provided__451(this$0);
    return function (p1) {
      i.invoke_840(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_397(this$0, resultContinuation) {
    var i = new _no_name_provided__452(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_398($tmp0_run_0_1, $tmp0_onOver_0_3) {
    var i = new _no_name_provided__453($tmp0_run_0_1, $tmp0_onOver_0_3);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_399(this$0, resultContinuation) {
    var i = new _no_name_provided__454(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_400($tmp0_run_0_1, $tmp1_onOut_0_8) {
    var i = new _no_name_provided__455($tmp0_run_0_1, $tmp1_onOut_0_8);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_401(this$0, resultContinuation) {
    var i = new _no_name_provided__456(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_402($tmp0_run_0_1, $tmp2_onDown_0_13) {
    var i = new _no_name_provided__457($tmp0_run_0_1, $tmp2_onDown_0_13);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_403(this$0, resultContinuation) {
    var i = new _no_name_provided__458(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_404($tmp0_run_0_1, $tmp3_onUpAnywhere_0_18) {
    var i = new _no_name_provided__459($tmp0_run_0_1, $tmp3_onUpAnywhere_0_18);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_405(this$0, resultContinuation) {
    var i = new _no_name_provided__460(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_406($tmp0_run_0_1, $tmp4_onClick_0_23) {
    var i = new _no_name_provided__461($tmp0_run_0_1, $tmp4_onClick_0_23);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_407() {
    var i = new _no_name_provided__438();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_408() {
    var i = new _no_name_provided__439();
    return function (p1) {
      i.invoke_766(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_409($tmp0_onOver_0_3, $it, resultContinuation) {
    var i = new _no_name_provided__440($tmp0_onOver_0_3, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_410($tmp1_onOut_0_8, $it, resultContinuation) {
    var i = new _no_name_provided__441($tmp1_onOut_0_8, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_411($tmp2_onDown_0_13, $it, resultContinuation) {
    var i = new _no_name_provided__442($tmp2_onDown_0_13, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_412($tmp3_onUpAnywhere_0_18, $it, resultContinuation) {
    var i = new _no_name_provided__443($tmp3_onUpAnywhere_0_18, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_413($tmp4_onClick_0_23, $it, resultContinuation) {
    var i = new _no_name_provided__444($tmp4_onClick_0_23, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function UIObservable(initial, observe) {
    this._initial_0 = initial;
    this._observe = observe;
    this._currentValue = this._initial_0;
  }
  UIObservable.prototype.getValue_0 = function (obj, prop) {
    return this._currentValue;
  };
  UIObservable.prototype.setValue_3 = function (obj, prop, value) {
    if (!equals_1(this._currentValue, value)) {
      this._currentValue = value;
      this._observe(value);
    }};
  UIObservable.$metadata$ = {
    simpleName: 'UIObservable',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__462() {
  }
  _no_name_provided__462.prototype.invoke_1005 = function () {
    return UIProgressBar_init_$Create$(0.0, 0.0, 0.0, 0.0, null, 31, null);
  };
  _no_name_provided__462.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__463() {
  }
  _no_name_provided__463.prototype.invoke_813 = function ($this$null) {
    var tmp = current$factory_1();
    $this$null.add$default_16(tmp, 0.0, 2, null);
    Unit_getInstance();
    var tmp_0 = maximum$factory_1();
    $this$null.add$default_16(tmp_0, 0.0, 2, null);
    Unit_getInstance();
    var tmp_1 = width$factory_0();
    $this$null.add$default_16(tmp_1, 0.0, 2, null);
    Unit_getInstance();
    var tmp_2 = height$factory_0();
    $this$null.add$default_16(tmp_2, 0.0, 2, null);
    Unit_getInstance();
  };
  _no_name_provided__463.prototype.invoke_1015 = function (p1) {
    this.invoke_813(p1 instanceof KTreeSerializerExt ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__463.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UIProgressBar_init_$Init$(width, height, current, maximum, skin, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 256.0;
    if (!(($mask0 & 2) === 0))
      height = 24.0;
    if (!(($mask0 & 4) === 0))
      current = 0.0;
    if (!(($mask0 & 8) === 0))
      maximum = 100.0;
    if (!(($mask0 & 16) === 0))
      skin = _get_DefaultUISkin_();
    UIProgressBar.call($this, width, height, current, maximum, skin);
    return $this;
  }
  function UIProgressBar_init_$Create$(width, height, current, maximum, skin, $mask0, $marker) {
    return UIProgressBar_init_$Init$(width, height, current, maximum, skin, $mask0, $marker, Object.create(UIProgressBar.prototype));
  }
  function Serializer_0() {
    Serializer_instance_0 = this;
    var tmp = getKClass_0(UIProgressBar);
    var tmp_0 = _no_name_provided_$factory_417();
    KTreeSerializerExt.call(this, 'UIProgressBar', tmp, tmp_0, _no_name_provided_$factory_418());
  }
  Serializer_0.$metadata$ = {
    simpleName: 'Serializer',
    kind: 'object',
    interfaces: []
  };
  var Serializer_instance_0;
  function Serializer_getInstance_0() {
    if (Serializer_instance_0 == null)
      new Serializer_0();
    return Serializer_instance_0;
  }
  function _no_name_provided__464(this$0) {
    this._this$0_135 = this$0;
  }
  _no_name_provided__464.prototype.invoke_882 = function (it) {
    this._this$0_135.updateState_3();
  };
  _no_name_provided__464.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__464.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__465(this$0) {
    this._this$0_136 = this$0;
  }
  _no_name_provided__465.prototype.invoke_882 = function (it) {
    this._this$0_136.updateState_3();
  };
  _no_name_provided__465.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__465.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__466(this$0) {
    this._this$0_137 = this$0;
  }
  _no_name_provided__466.prototype.invoke_819 = function (it) {
    this._this$0_137._background_0._set_color__1(it._backColor_0);
    this._this$0_137.onSkinChanged();
  };
  _no_name_provided__466.prototype.invoke_1015 = function (p1) {
    this.invoke_819(p1 instanceof UISkin ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__466.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UIProgressBar(width, height, current, maximum, skin) {
    UIView.call(this, width, height);
    var tmp = this;
    var tmp0_uiObservable_0 = _no_name_provided_$factory_414(this);
    tmp._current$delegate = new UIObservable(current, tmp0_uiObservable_0);
    var tmp_0 = this;
    var tmp0_uiObservable_0_0 = _no_name_provided_$factory_415(this);
    tmp_0._maximum$delegate = new UIObservable(maximum, tmp0_uiObservable_0_0);
    var tmp_1 = this;
    var tmp0_uiObservable_0_1 = _no_name_provided_$factory_416(this);
    tmp_1._skin$delegate_0 = new UIObservable(skin, tmp0_uiObservable_0_1);
    var tmp_2 = this;
    var tmp2_solidRect_0 = skin._backColor_0;
    var tmp1_addTo_0 = new SolidRect(width, height, tmp2_solidRect_0);
    var tmp0_apply_0 = addTo(tmp1_addTo_0, this);
    Unit_getInstance();
    tmp_2._background_0 = tmp0_apply_0;
    var tmp_3 = this;
    var tmp2_ninePatch_0 = skin._normal_0;
    var tmp3_ninePatch_0 = width * clamp01(current / maximum);
    var tmp4_ninePatch_0 = 0.25;
    var tmp5_ninePatch_0 = 0.25;
    var tmp6_ninePatch_0 = 0.75;
    var tmp7_ninePatch_0 = 0.75;
    var tmp1_addTo_0_0 = new NinePatch(tmp2_ninePatch_0, tmp3_ninePatch_0, height, tmp4_ninePatch_0, tmp5_ninePatch_0, tmp6_ninePatch_0, tmp7_ninePatch_0);
    var tmp0_apply_0_0 = addTo(tmp1_addTo_0_0, this);
    Unit_getInstance();
    tmp_3._progressView = tmp0_apply_0_0;
  }
  UIProgressBar.prototype._set_current_ = function (_set___) {
    return this._current$delegate.setValue_3(this, current$factory(), _set___);
  };
  UIProgressBar.prototype._get_current_ = function () {
    return this._current$delegate.getValue_0(this, current$factory_0());
  };
  UIProgressBar.prototype._set_maximum_ = function (_set___) {
    return this._maximum$delegate.setValue_3(this, maximum$factory(), _set___);
  };
  UIProgressBar.prototype._get_maximum_ = function () {
    return this._maximum$delegate.getValue_0(this, maximum$factory_0());
  };
  UIProgressBar.prototype._set_skin__1 = function (_set___) {
    return this._skin$delegate_0.setValue_3(this, skin$factory_1(), _set___);
  };
  UIProgressBar.prototype._get_skin__1 = function () {
    return this._skin$delegate_0.getValue_0(this, skin$factory_2());
  };
  UIProgressBar.prototype._get_ratio__1 = function () {
    return clamp01(this._get_current_() / this._get_maximum_());
  };
  UIProgressBar.prototype._get_progressView_ = function () {
    return this._progressView;
  };
  UIProgressBar.prototype.onSizeChanged_3 = function () {
    size_0(this._background_0, this._get_width__58(), this._get_height__58());
    Unit_getInstance();
    this.updateState_3();
  };
  UIProgressBar.prototype.updateState_3 = function () {
    size_0(this._get_progressView_(), this._get_width__58() * this._get_ratio__1(), this._get_height__58());
    Unit_getInstance();
  };
  UIProgressBar.prototype.onSkinChanged = function () {
    var tmp = this._get_progressView_();
    var tmp0_safe_receiver = tmp instanceof NinePatch ? tmp : null;
    if (tmp0_safe_receiver == null) {
      Unit_getInstance();
    } else
      tmp0_safe_receiver._tex_0 = this._get_skin__1()._normal_0;
    this._background_0._set_color__1(this._get_skin__1()._backColor_0);
  };
  UIProgressBar.$metadata$ = {
    simpleName: 'UIProgressBar',
    kind: 'class',
    interfaces: [ViewLeaf]
  };
  function current$factory() {
    return getPropertyCallableRef('current', 1, KMutableProperty1, function (receiver) {
      return receiver._get_current_();
    }, function (receiver_0, value) {
      return receiver_0._set_current_(value);
    });
  }
  function current$factory_0() {
    return getPropertyCallableRef('current', 1, KMutableProperty1, function (receiver) {
      return receiver._get_current_();
    }, function (receiver_0, value) {
      return receiver_0._set_current_(value);
    });
  }
  function maximum$factory() {
    return getPropertyCallableRef('maximum', 1, KMutableProperty1, function (receiver) {
      return receiver._get_maximum_();
    }, function (receiver_0, value) {
      return receiver_0._set_maximum_(value);
    });
  }
  function maximum$factory_0() {
    return getPropertyCallableRef('maximum', 1, KMutableProperty1, function (receiver) {
      return receiver._get_maximum_();
    }, function (receiver_0, value) {
      return receiver_0._set_maximum_(value);
    });
  }
  function skin$factory_1() {
    return getPropertyCallableRef('skin', 1, KMutableProperty1, function (receiver) {
      return receiver._get_skin__1();
    }, function (receiver_0, value) {
      return receiver_0._set_skin__1(value);
    });
  }
  function skin$factory_2() {
    return getPropertyCallableRef('skin', 1, KMutableProperty1, function (receiver) {
      return receiver._get_skin__1();
    }, function (receiver_0, value) {
      return receiver_0._set_skin__1(value);
    });
  }
  function current$factory_1() {
    return getPropertyCallableRef('current', 1, KMutableProperty1, function (receiver) {
      return receiver._get_current_();
    }, function (receiver_0, value) {
      return receiver_0._set_current_(value);
    });
  }
  function maximum$factory_1() {
    return getPropertyCallableRef('maximum', 1, KMutableProperty1, function (receiver) {
      return receiver._get_maximum_();
    }, function (receiver_0, value) {
      return receiver_0._set_maximum_(value);
    });
  }
  function width$factory_0() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__58();
    }, function (receiver_0, value) {
      return receiver_0._set_width__27(value);
    });
  }
  function height$factory_0() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__58();
    }, function (receiver_0, value) {
      return receiver_0._set_height__27(value);
    });
  }
  function _no_name_provided_$factory_414(this$0) {
    var i = new _no_name_provided__464(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_415(this$0) {
    var i = new _no_name_provided__465(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_416(this$0) {
    var i = new _no_name_provided__466(this$0);
    return function (p1) {
      i.invoke_819(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_417() {
    var i = new _no_name_provided__462();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_418() {
    var i = new _no_name_provided__463();
    return function (p1) {
      i.invoke_813(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__467() {
  }
  _no_name_provided__467.prototype.invoke_1005 = function () {
    var tmp0_also_0 = UITextButton_init_$Create$(0.0, 0.0, null, null, null, 0.0, 63, null);
    tmp0_also_0._set_text__2('Button');
    return tmp0_also_0;
  };
  _no_name_provided__467.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__468() {
  }
  _no_name_provided__468.prototype.invoke_822 = function ($this$null) {
    var tmp = text$factory_4();
    $this$null.add$default_15(tmp, null, 2, null);
    Unit_getInstance();
    var tmp_0 = textSize$factory_3();
    $this$null.add$default_16(tmp_0, 0.0, 2, null);
    Unit_getInstance();
    var tmp_1 = width$factory_1();
    $this$null.add$default_16(tmp_1, 0.0, 2, null);
    Unit_getInstance();
    var tmp_2 = height$factory_1();
    $this$null.add$default_16(tmp_2, 0.0, 2, null);
    Unit_getInstance();
  };
  _no_name_provided__468.prototype.invoke_1015 = function (p1) {
    this.invoke_822(p1 instanceof KTreeSerializerExt ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__468.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UITextButton_init_$Init$(width, height, text, skin, textFont, textSize, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      width = 128.0;
    if (!(($mask0 & 2) === 0))
      height = 64.0;
    if (!(($mask0 & 4) === 0))
      text = 'Button';
    if (!(($mask0 & 8) === 0))
      skin = _get_DefaultUISkin_();
    if (!(($mask0 & 16) === 0))
      textFont = _get_DefaultUIFont_();
    if (!(($mask0 & 32) === 0))
      textSize = 16.0;
    UITextButton.call($this, width, height, text, skin, textFont, textSize);
    return $this;
  }
  function UITextButton_init_$Create$(width, height, text, skin, textFont, textSize, $mask0, $marker) {
    return UITextButton_init_$Init$(width, height, text, skin, textFont, textSize, $mask0, $marker, Object.create(UITextButton.prototype));
  }
  function updateTextAndShadow($this) {
    updateText_0($this);
    updateShadow($this);
  }
  function updateText_0($this) {
    $this._textView_0._set_font_($this._get_textFont__0());
    $this._textView_0._set_textSize__1($this._get_textSize__0());
    $this._textView_0._set_color__1($this._get_textColor__0());
    $this._textView_0._set_alignment_($this._get_textAlignment_());
    $this._textView_0.setTextBounds(new Rectangle(0.0, 0.0, $this._get_width__58(), $this._get_height__58()));
    setText($this._textView_0, $this._get_text__2());
  }
  function updateShadow($this) {
    $this._textShadow._set_visible__4($this._get_shadowVisible_());
    $this._textShadow._set_font_($this._get_textFont__0());
    $this._textShadow._set_textSize__1($this._get_textSize__0());
    $this._textShadow._set_color__1($this._get_shadowColor_());
    $this._textShadow._set_alignment_($this._get_textAlignment_());
    $this._textShadow.setTextBounds(new Rectangle(0.0, 0.0, $this._get_width__58(), $this._get_height__58()));
    setText($this._textShadow, $this._get_text__2());
    position($this._textShadow, $this._get_shadowX_(), $this._get_shadowY_());
    Unit_getInstance();
  }
  function Serializer_1() {
    Serializer_instance_1 = this;
    var tmp = getKClass_0(UITextButton);
    var tmp_0 = _no_name_provided_$factory_428();
    KTreeSerializerExt.call(this, 'UITextButton', tmp, tmp_0, _no_name_provided_$factory_429());
  }
  Serializer_1.$metadata$ = {
    simpleName: 'Serializer',
    kind: 'object',
    interfaces: []
  };
  var Serializer_instance_1;
  function Serializer_getInstance_1() {
    if (Serializer_instance_1 == null)
      new Serializer_1();
    return Serializer_instance_1;
  }
  function _no_name_provided__469(this$0) {
    this._this$0_138 = this$0;
  }
  _no_name_provided__469.prototype.invoke_824 = function (it) {
    updateTextAndShadow(this._this$0_138);
  };
  _no_name_provided__469.prototype.invoke_1015 = function (p1) {
    this.invoke_824((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__469.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__470(this$0) {
    this._this$0_139 = this$0;
  }
  _no_name_provided__470.prototype.invoke_882 = function (it) {
    updateTextAndShadow(this._this$0_139);
  };
  _no_name_provided__470.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__470.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__471(this$0) {
    this._this$0_140 = this$0;
  }
  _no_name_provided__471.prototype.invoke_838 = function (it) {
    updateText_0(this._this$0_140);
  };
  _no_name_provided__471.prototype.invoke_1015 = function (p1) {
    this.invoke_838(p1 instanceof RGBA ? p1._value_17 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__471.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__472(this$0) {
    this._this$0_141 = this$0;
  }
  _no_name_provided__472.prototype.invoke_830 = function (it) {
    updateText_0(this._this$0_141);
  };
  _no_name_provided__472.prototype.invoke_1015 = function (p1) {
    this.invoke_830(p1 instanceof TextAlignment ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__472.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__473(this$0) {
    this._this$0_142 = this$0;
  }
  _no_name_provided__473.prototype.invoke_832 = function (it) {
    updateTextAndShadow(this._this$0_142);
  };
  _no_name_provided__473.prototype.invoke_1015 = function (p1) {
    this.invoke_832((!(p1 == null) ? isInterface(p1, Font) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__473.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__474(this$0) {
    this._this$0_143 = this$0;
  }
  _no_name_provided__474.prototype.invoke_836 = function (it) {
    updateShadow(this._this$0_143);
  };
  _no_name_provided__474.prototype.invoke_1015 = function (p1) {
    this.invoke_836((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__474.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__475(this$0) {
    this._this$0_144 = this$0;
  }
  _no_name_provided__475.prototype.invoke_836 = function (it) {
    updateShadow(this._this$0_144);
  };
  _no_name_provided__475.prototype.invoke_1015 = function (p1) {
    this.invoke_836((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__475.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__476(this$0) {
    this._this$0_145 = this$0;
  }
  _no_name_provided__476.prototype.invoke_838 = function (it) {
    updateShadow(this._this$0_145);
  };
  _no_name_provided__476.prototype.invoke_1015 = function (p1) {
    this.invoke_838(p1 instanceof RGBA ? p1._value_17 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__476.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__477(this$0) {
    this._this$0_146 = this$0;
  }
  _no_name_provided__477.prototype.invoke_840 = function (it) {
    updateShadow(this._this$0_146);
  };
  _no_name_provided__477.prototype.invoke_1015 = function (p1) {
    this.invoke_840((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__477.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UITextButton(width, height, text, skin, textFont, textSize) {
    UIButton.call(this, width, height, skin);
    var tmp = this;
    var tmp0_uiObservable_0 = _no_name_provided_$factory_419(this);
    tmp._text$delegate_0 = new UIObservable(text, tmp0_uiObservable_0);
    var tmp_0 = this;
    var tmp0_uiObservable_0_0 = _no_name_provided_$factory_420(this);
    tmp_0._textSize$delegate_0 = new UIObservable(textSize, tmp0_uiObservable_0_0);
    var tmp_1 = this;
    var tmp0_uiObservable_0_1 = Colors_getInstance()._WHITE;
    var tmp1_uiObservable_0 = _no_name_provided_$factory_421(this);
    tmp_1._textColor$delegate_0 = new UIObservable(new RGBA(tmp0_uiObservable_0_1), tmp1_uiObservable_0);
    var tmp_2 = this;
    var tmp0_uiObservable_0_2 = Companion_getInstance_116()._MIDDLE_CENTER_0;
    var tmp1_uiObservable_0_0 = _no_name_provided_$factory_422(this);
    tmp_2._textAlignment$delegate = new UIObservable(tmp0_uiObservable_0_2, tmp1_uiObservable_0_0);
    var tmp_3 = this;
    var tmp0_uiObservable_0_3 = _no_name_provided_$factory_423(this);
    tmp_3._textFont$delegate_0 = new UIObservable(textFont, tmp0_uiObservable_0_3);
    var tmp_4 = this;
    var tmp0_uiObservable_0_4 = 1;
    var tmp1_uiObservable_0_1 = _no_name_provided_$factory_424(this);
    tmp_4._shadowX$delegate = new UIObservable(tmp0_uiObservable_0_4, tmp1_uiObservable_0_1);
    var tmp_5 = this;
    var tmp0_uiObservable_0_5 = 1;
    var tmp1_uiObservable_0_2 = _no_name_provided_$factory_425(this);
    tmp_5._shadowY$delegate = new UIObservable(tmp0_uiObservable_0_5, tmp1_uiObservable_0_2);
    var tmp_6 = this;
    var tmp0_uiObservable_0_6 = RGBA__withAd_impl(Colors_getInstance()._BLACK, 0.3);
    var tmp1_uiObservable_0_3 = _no_name_provided_$factory_426(this);
    tmp_6._shadowColor$delegate = new UIObservable(new RGBA(tmp0_uiObservable_0_6), tmp1_uiObservable_0_3);
    var tmp_7 = this;
    var tmp0_uiObservable_0_7 = true;
    var tmp1_uiObservable_0_4 = _no_name_provided_$factory_427(this);
    tmp_7._shadowVisible$delegate = new UIObservable(tmp0_uiObservable_0_7, tmp1_uiObservable_0_4);
    var tmp_8 = this;
    var tmp2_text_0 = Colors_getInstance()._WHITE;
    var tmp3_text_0 = _get_DefaultTtfFont_();
    var tmp4_text_0 = Companion_getInstance_116()._TOP_LEFT_0;
    var tmp5_text_0 = DefaultStringTextRenderer;
    var tmp6_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
    var tmp1_addTo_0 = new Text_2(text, textSize, tmp2_text_0, tmp3_text_0, tmp4_text_0, tmp5_text_0, tmp6_text_0);
    var tmp0_apply_0 = addTo(tmp1_addTo_0, this);
    Unit_getInstance();
    tmp_8._textShadow = tmp0_apply_0;
    var tmp_9 = this;
    var tmp2_text_0_0 = Colors_getInstance()._WHITE;
    var tmp3_text_0_0 = _get_DefaultTtfFont_();
    var tmp4_text_0_0 = Companion_getInstance_116()._TOP_LEFT_0;
    var tmp5_text_0_0 = DefaultStringTextRenderer;
    var tmp6_text_0_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
    var tmp1_addTo_0_0 = new Text_2(text, textSize, tmp2_text_0_0, tmp3_text_0_0, tmp4_text_0_0, tmp5_text_0_0, tmp6_text_0_0);
    var tmp0_apply_0_0 = addTo(tmp1_addTo_0_0, this);
    Unit_getInstance();
    tmp_9._textView_0 = tmp0_apply_0_0;
    updateTextAndShadow(this);
  }
  UITextButton.prototype._set_text__2 = function (_set___) {
    return this._text$delegate_0.setValue_3(this, text$factory_2(), _set___);
  };
  UITextButton.prototype._get_text__2 = function () {
    return this._text$delegate_0.getValue_0(this, text$factory_3());
  };
  UITextButton.prototype._set_textSize__1 = function (_set___) {
    return this._textSize$delegate_0.setValue_3(this, textSize$factory_1(), _set___);
  };
  UITextButton.prototype._get_textSize__0 = function () {
    return this._textSize$delegate_0.getValue_0(this, textSize$factory_2());
  };
  UITextButton.prototype._set_textColor__0 = function (_set___) {
    return this._textColor$delegate_0.setValue_3(this, textColor$factory_1(), new RGBA(_set___));
  };
  UITextButton.prototype._get_textColor__0 = function () {
    return this._textColor$delegate_0.getValue_0(this, textColor$factory_2())._value_17;
  };
  UITextButton.prototype._set_textAlignment_ = function (_set___) {
    return this._textAlignment$delegate.setValue_3(this, textAlignment$factory(), _set___);
  };
  UITextButton.prototype._get_textAlignment_ = function () {
    return this._textAlignment$delegate.getValue_0(this, textAlignment$factory_0());
  };
  UITextButton.prototype._set_textFont__0 = function (_set___) {
    return this._textFont$delegate_0.setValue_3(this, textFont$factory_1(), _set___);
  };
  UITextButton.prototype._get_textFont__0 = function () {
    return this._textFont$delegate_0.getValue_0(this, textFont$factory_2());
  };
  UITextButton.prototype._set_shadowX_ = function (_set___) {
    return this._shadowX$delegate.setValue_3(this, shadowX$factory(), _set___);
  };
  UITextButton.prototype._get_shadowX_ = function () {
    return this._shadowX$delegate.getValue_0(this, shadowX$factory_0());
  };
  UITextButton.prototype._set_shadowY_ = function (_set___) {
    return this._shadowY$delegate.setValue_3(this, shadowY$factory(), _set___);
  };
  UITextButton.prototype._get_shadowY_ = function () {
    return this._shadowY$delegate.getValue_0(this, shadowY$factory_0());
  };
  UITextButton.prototype._set_shadowColor_ = function (_set___) {
    return this._shadowColor$delegate.setValue_3(this, shadowColor$factory(), new RGBA(_set___));
  };
  UITextButton.prototype._get_shadowColor_ = function () {
    return this._shadowColor$delegate.getValue_0(this, shadowColor$factory_0())._value_17;
  };
  UITextButton.prototype._set_shadowVisible_ = function (_set___) {
    return this._shadowVisible$delegate.setValue_3(this, shadowVisible$factory(), _set___);
  };
  UITextButton.prototype._get_shadowVisible_ = function () {
    return this._shadowVisible$delegate.getValue_0(this, shadowVisible$factory_0());
  };
  UITextButton.prototype.onSizeChanged_3 = function () {
    UIButton.prototype.onSizeChanged_3.call(this);
    this._textView_0.setTextBounds(new Rectangle(0.0, 0.0, this._get_width__58(), this._get_height__58()));
    this._textShadow.setTextBounds(new Rectangle(0.0, 0.0, this._get_width__58(), this._get_height__58()));
  };
  UITextButton.$metadata$ = {
    simpleName: 'UITextButton',
    kind: 'class',
    interfaces: [ViewLeaf]
  };
  function text$factory_2() {
    return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
      return receiver._get_text__2();
    }, function (receiver_0, value) {
      return receiver_0._set_text__2(value);
    });
  }
  function text$factory_3() {
    return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
      return receiver._get_text__2();
    }, function (receiver_0, value) {
      return receiver_0._set_text__2(value);
    });
  }
  function textSize$factory_1() {
    return getPropertyCallableRef('textSize', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textSize__0();
    }, function (receiver_0, value) {
      return receiver_0._set_textSize__1(value);
    });
  }
  function textSize$factory_2() {
    return getPropertyCallableRef('textSize', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textSize__0();
    }, function (receiver_0, value) {
      return receiver_0._set_textSize__1(value);
    });
  }
  function textColor$factory_1() {
    return getPropertyCallableRef('textColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(receiver._get_textColor__0());
    }, function (receiver_0, value) {
      return receiver_0._set_textColor__0(value._value_17);
    });
  }
  function textColor$factory_2() {
    return getPropertyCallableRef('textColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(receiver._get_textColor__0());
    }, function (receiver_0, value) {
      return receiver_0._set_textColor__0(value._value_17);
    });
  }
  function textAlignment$factory() {
    return getPropertyCallableRef('textAlignment', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textAlignment_();
    }, function (receiver_0, value) {
      return receiver_0._set_textAlignment_(value);
    });
  }
  function textAlignment$factory_0() {
    return getPropertyCallableRef('textAlignment', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textAlignment_();
    }, function (receiver_0, value) {
      return receiver_0._set_textAlignment_(value);
    });
  }
  function textFont$factory_1() {
    return getPropertyCallableRef('textFont', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textFont__0();
    }, function (receiver_0, value) {
      return receiver_0._set_textFont__0(value);
    });
  }
  function textFont$factory_2() {
    return getPropertyCallableRef('textFont', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textFont__0();
    }, function (receiver_0, value) {
      return receiver_0._set_textFont__0(value);
    });
  }
  function shadowX$factory() {
    return getPropertyCallableRef('shadowX', 1, KMutableProperty1, function (receiver) {
      return receiver._get_shadowX_();
    }, function (receiver_0, value) {
      return receiver_0._set_shadowX_(value);
    });
  }
  function shadowX$factory_0() {
    return getPropertyCallableRef('shadowX', 1, KMutableProperty1, function (receiver) {
      return receiver._get_shadowX_();
    }, function (receiver_0, value) {
      return receiver_0._set_shadowX_(value);
    });
  }
  function shadowY$factory() {
    return getPropertyCallableRef('shadowY', 1, KMutableProperty1, function (receiver) {
      return receiver._get_shadowY_();
    }, function (receiver_0, value) {
      return receiver_0._set_shadowY_(value);
    });
  }
  function shadowY$factory_0() {
    return getPropertyCallableRef('shadowY', 1, KMutableProperty1, function (receiver) {
      return receiver._get_shadowY_();
    }, function (receiver_0, value) {
      return receiver_0._set_shadowY_(value);
    });
  }
  function shadowColor$factory() {
    return getPropertyCallableRef('shadowColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(receiver._get_shadowColor_());
    }, function (receiver_0, value) {
      return receiver_0._set_shadowColor_(value._value_17);
    });
  }
  function shadowColor$factory_0() {
    return getPropertyCallableRef('shadowColor', 1, KMutableProperty1, function (receiver) {
      return new RGBA(receiver._get_shadowColor_());
    }, function (receiver_0, value) {
      return receiver_0._set_shadowColor_(value._value_17);
    });
  }
  function shadowVisible$factory() {
    return getPropertyCallableRef('shadowVisible', 1, KMutableProperty1, function (receiver) {
      return receiver._get_shadowVisible_();
    }, function (receiver_0, value) {
      return receiver_0._set_shadowVisible_(value);
    });
  }
  function shadowVisible$factory_0() {
    return getPropertyCallableRef('shadowVisible', 1, KMutableProperty1, function (receiver) {
      return receiver._get_shadowVisible_();
    }, function (receiver_0, value) {
      return receiver_0._set_shadowVisible_(value);
    });
  }
  function text$factory_4() {
    return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
      return receiver._get_text__2();
    }, function (receiver_0, value) {
      return receiver_0._set_text__2(value);
    });
  }
  function textSize$factory_3() {
    return getPropertyCallableRef('textSize', 1, KMutableProperty1, function (receiver) {
      return receiver._get_textSize__0();
    }, function (receiver_0, value) {
      return receiver_0._set_textSize__1(value);
    });
  }
  function width$factory_1() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__58();
    }, function (receiver_0, value) {
      return receiver_0._set_width__27(value);
    });
  }
  function height$factory_1() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__58();
    }, function (receiver_0, value) {
      return receiver_0._set_height__27(value);
    });
  }
  function _no_name_provided_$factory_419(this$0) {
    var i = new _no_name_provided__469(this$0);
    return function (p1) {
      i.invoke_824(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_420(this$0) {
    var i = new _no_name_provided__470(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_421(this$0) {
    var i = new _no_name_provided__471(this$0);
    return function (p1) {
      i.invoke_838(p1._value_17);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_422(this$0) {
    var i = new _no_name_provided__472(this$0);
    return function (p1) {
      i.invoke_830(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_423(this$0) {
    var i = new _no_name_provided__473(this$0);
    return function (p1) {
      i.invoke_832(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_424(this$0) {
    var i = new _no_name_provided__474(this$0);
    return function (p1) {
      i.invoke_836(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_425(this$0) {
    var i = new _no_name_provided__475(this$0);
    return function (p1) {
      i.invoke_836(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_426(this$0) {
    var i = new _no_name_provided__476(this$0);
    return function (p1) {
      i.invoke_838(p1._value_17);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_427(this$0) {
    var i = new _no_name_provided__477(this$0);
    return function (p1) {
      i.invoke_840(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_428() {
    var i = new _no_name_provided__467();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_429() {
    var i = new _no_name_provided__468();
    return function (p1) {
      i.invoke_822(p1);
      return Unit_getInstance();
    };
  }
  function registerUISupportOnce($this) {
    if ($this._registered)
      return Unit_getInstance();
    var tmp0_elvis_lhs = $this._get_stage__4();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stage = tmp;
    $this._registered = true;
    if (equals_1(getExtra(stage, 'uiSupport'), true))
      return Unit_getInstance();
    setExtra(stage, 'uiSupport', true);
    var tmp0_run_0_1 = _get_keys_(stage);
    Unit_getInstance();
    var tmp2_getOrCreateComponent_0_1 = stage._get_componentsSure__21();
    var tmp3_getOrCreateComponent_0_2 = getKClass_0(DummyUpdateComponentWithViews);
    var tmp1_getOrCreateComponent_0_3 = tmp2_getOrCreateComponent_0_1._get_eupdateWV_();
    var component_1_4 = tmp2_getOrCreateComponent_0_1.findFirstComponentOfType(tmp1_getOrCreateComponent_0_3, tmp3_getOrCreateComponent_0_2);
    if (component_1_4 == null) {
      component_1_4 = new DummyUpdateComponentWithViews(stage);
      var tmp0_plusAssign_0_5 = component_1_4;
      tmp1_getOrCreateComponent_0_3.add_39(tmp0_plusAssign_0_5);
      Unit_getInstance();
    }var tmp_0 = component_1_4;
    if (tmp_0 instanceof DummyUpdateComponentWithViews)
      tmp_0;
    else
      THROW_CCE();
    Unit_getInstance();
  }
  function _no_name_provided__478(this$0) {
    this._this$0_147 = this$0;
  }
  _no_name_provided__478.prototype.invoke_882 = function (it) {
    this._this$0_147.onSizeChanged_3();
  };
  _no_name_provided__478.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__478.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__479(this$0) {
    this._this$0_148 = this$0;
  }
  _no_name_provided__479.prototype.invoke_882 = function (it) {
    this._this$0_148.onSizeChanged_3();
  };
  _no_name_provided__479.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__479.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UIView(width, height) {
    Container.call(this);
    var tmp = this;
    var tmp0_uiObservable_0 = _no_name_provided_$factory_430(this);
    tmp._width$delegate = new UIObservable(width, tmp0_uiObservable_0);
    var tmp_0 = this;
    var tmp0_uiObservable_0_0 = _no_name_provided_$factory_431(this);
    tmp_0._height$delegate = new UIObservable(height, tmp0_uiObservable_0_0);
    this._registered = false;
  }
  UIView.prototype._set_width__27 = function (_set___) {
    return this._width$delegate.setValue_3(this, width$factory_2(), _set___);
  };
  UIView.prototype._get_width__58 = function () {
    return this._width$delegate.getValue_0(this, width$factory_3());
  };
  UIView.prototype._set_height__27 = function (_set___) {
    return this._height$delegate.setValue_3(this, height$factory_2(), _set___);
  };
  UIView.prototype._get_height__58 = function () {
    return this._height$delegate.getValue_0(this, height$factory_3());
  };
  UIView.prototype._get_enabled__3 = function () {
    return this._get_mouseEnabled__20();
  };
  UIView.prototype.onSizeChanged_3 = function () {
  };
  UIView.prototype.updateState_3 = function () {
  };
  UIView.prototype.renderInternal_20 = function (ctx) {
    registerUISupportOnce(this);
    Container.prototype.renderInternal_20.call(this, ctx);
  };
  UIView.$metadata$ = {
    simpleName: 'UIView',
    kind: 'class',
    interfaces: []
  };
  function DummyUpdateComponentWithViews(view) {
    this._view_6 = view;
  }
  DummyUpdateComponentWithViews.prototype._get_view__6 = function () {
    return this._view_6;
  };
  DummyUpdateComponentWithViews.prototype.update_10 = function (views, dt) {
  };
  DummyUpdateComponentWithViews.$metadata$ = {
    simpleName: 'DummyUpdateComponentWithViews',
    kind: 'class',
    interfaces: [UpdateComponentWithViews]
  };
  function width$factory_2() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__58();
    }, function (receiver_0, value) {
      return receiver_0._set_width__27(value);
    });
  }
  function width$factory_3() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__58();
    }, function (receiver_0, value) {
      return receiver_0._set_width__27(value);
    });
  }
  function height$factory_2() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__58();
    }, function (receiver_0, value) {
      return receiver_0._set_height__27(value);
    });
  }
  function height$factory_3() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__58();
    }, function (receiver_0, value) {
      return receiver_0._set_height__27(value);
    });
  }
  function _no_name_provided_$factory_430(this$0) {
    var i = new _no_name_provided__478(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_431(this$0) {
    var i = new _no_name_provided__479(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  var defaultTextSkin$delegate;
  var defaultUIFont$delegate;
  var defaultUISkin$delegate;
  var defaultCheckSkin$delegate;
  var defaultUpSkin$delegate;
  var defaultDownSkin$delegate;
  var defaultLeftSkin$delegate;
  var defaultRightSkin$delegate;
  var defaultComboBoxSkin$delegate;
  var defaultVerScrollBarSkin$delegate;
  var defaultHorScrollBarSkin$delegate;
  function _no_name_provided__480() {
  }
  _no_name_provided__480.prototype.invoke_1005 = function () {
    return _get_DefaultTextSkin_();
  };
  _no_name_provided__480.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__481() {
  }
  _no_name_provided__481.prototype.invoke_1005 = function () {
    return _get_DefaultUIFont_();
  };
  _no_name_provided__481.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__482() {
  }
  _no_name_provided__482.prototype.invoke_1005 = function () {
    return _get_DefaultUISkin_();
  };
  _no_name_provided__482.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__483() {
  }
  _no_name_provided__483.prototype.invoke_1005 = function () {
    return _get_DefaultCheckSkin_();
  };
  _no_name_provided__483.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__484() {
  }
  _no_name_provided__484.prototype.invoke_1005 = function () {
    return _get_DefaultUpSkin_();
  };
  _no_name_provided__484.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__485() {
  }
  _no_name_provided__485.prototype.invoke_1005 = function () {
    return _get_DefaultDownSkin_();
  };
  _no_name_provided__485.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__486() {
  }
  _no_name_provided__486.prototype.invoke_1005 = function () {
    return _get_DefaultLeftSkin_();
  };
  _no_name_provided__486.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__487() {
  }
  _no_name_provided__487.prototype.invoke_1005 = function () {
    return _get_DefaultRightSkin_();
  };
  _no_name_provided__487.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__488() {
  }
  _no_name_provided__488.prototype.invoke_1005 = function () {
    return _get_DefaultComboBoxSkin_();
  };
  _no_name_provided__488.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__489() {
  }
  _no_name_provided__489.prototype.invoke_1005 = function () {
    return _get_DefaultVerScrollBarSkin_();
  };
  _no_name_provided__489.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__490() {
  }
  _no_name_provided__490.prototype.invoke_1005 = function () {
    return _get_DefaultHorScrollBarSkin_();
  };
  _no_name_provided__490.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_432() {
    var i = new _no_name_provided__480();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_433() {
    var i = new _no_name_provided__481();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_434() {
    var i = new _no_name_provided__482();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_435() {
    var i = new _no_name_provided__483();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_436() {
    var i = new _no_name_provided__484();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_437() {
    var i = new _no_name_provided__485();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_438() {
    var i = new _no_name_provided__486();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_439() {
    var i = new _no_name_provided__487();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_440() {
    var i = new _no_name_provided__488();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_441() {
    var i = new _no_name_provided__489();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_442() {
    var i = new _no_name_provided__490();
    return function () {
      return i.invoke_1005();
    };
  }
  function defaultTextSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_432();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function defaultUIFont$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_433();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function defaultUISkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_434();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function defaultCheckSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_435();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function defaultUpSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_436();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function defaultDownSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_437();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function defaultLeftSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_438();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function defaultRightSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_439();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function defaultComboBoxSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_440();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function defaultVerScrollBarSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_441();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function defaultHorScrollBarSkin$delegate$init$() {
    var tmp0_extraProperty_0 = _no_name_provided_$factory_442();
    var tmp1_extraProperty_0 = null;
    return new Property(tmp1_extraProperty_0, tmp0_extraProperty_0);
  }
  function _get_DefaultTextSkin_() {
    var tmp0_getValue_0 = DefaultTextSkin$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = DefaultTextSkin$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var DefaultTextSkin$delegate;
  function _get_DEFAULT_UI_SKIN_IMG_() {
    var tmp0_getValue_0 = DEFAULT_UI_SKIN_IMG$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = DEFAULT_UI_SKIN_IMG$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var DEFAULT_UI_SKIN_IMG$delegate;
  function _get_DefaultUISkin_() {
    var tmp0_getValue_0 = DefaultUISkin$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = DefaultUISkin$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var DefaultUISkin$delegate;
  function _get_DefaultIconSkins_() {
    var tmp0_getValue_0 = DefaultIconSkins$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = DefaultIconSkins$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var DefaultIconSkins$delegate;
  function _get_DefaultComboBoxSkin_() {
    var tmp0_getValue_0 = DefaultComboBoxSkin$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = DefaultComboBoxSkin$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var DefaultComboBoxSkin$delegate;
  function _get_DefaultVerScrollBarSkin_() {
    var tmp0_getValue_0 = DefaultVerScrollBarSkin$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = DefaultVerScrollBarSkin$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var DefaultVerScrollBarSkin$delegate;
  function _get_DefaultHorScrollBarSkin_() {
    var tmp0_getValue_0 = DefaultHorScrollBarSkin$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = DefaultHorScrollBarSkin$factory();
    return tmp0_getValue_0._get_value__10();
  }
  var DefaultHorScrollBarSkin$delegate;
  function _get_DefaultUIFont_() {
    return _get_DefaultUIVectorFont_();
  }
  function _get_DefaultCheckSkin_() {
    return _get_DefaultIconSkins_().get_137(0);
  }
  function _get_DefaultUpSkin_() {
    return _get_DefaultIconSkins_().get_137(1);
  }
  function _get_DefaultDownSkin_() {
    return _get_DefaultIconSkins_().get_137(3);
  }
  function _get_DefaultLeftSkin_() {
    return _get_DefaultIconSkins_().get_137(4);
  }
  function _get_DefaultRightSkin_() {
    return _get_DefaultIconSkins_().get_137(2);
  }
  function buildDefaultButton(index) {
    var tmp0_context2d_0 = NativeImage$default(64, 64, null, 4, null);
    var tmp1_context2d_0 = true;
    var tmp0_lock_0_1 = null;
    tmp0_context2d_0.lock_5();
    try {
      var ctx_2_2 = tmp0_context2d_0.getContext2d_5(tmp1_context2d_0);
      try {
        var tmp0_subject_5 = index;
        var tmp;
        switch (tmp0_subject_5) {
          case 0:
            var tmp0_createLinearGradient_0_6 = 0;
            var tmp1_createLinearGradient_0_7 = 0;
            var tmp2_createLinearGradient_0_8 = 0;
            var tmp3_createLinearGradient_0_9 = 64;
            var tmp4_createLinearGradient_0_10 = CycleMethod_NO_CYCLE_getInstance();
            var tmp5_createLinearGradient_0_11 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
            var tmp_0 = GradientKind_LINEAR_getInstance();
            var tmp_1 = numberToDouble(tmp0_createLinearGradient_0_6);
            var tmp_2 = numberToDouble(tmp1_createLinearGradient_0_7);
            var tmp_3 = numberToDouble(tmp2_createLinearGradient_0_8);
            var tmp_4 = numberToDouble(tmp3_createLinearGradient_0_9);
            tmp = GradientPaint_init_$Create$(tmp_0, tmp_1, tmp_2, 0.0, tmp_3, tmp_4, 0.0, null, null, tmp4_createLinearGradient_0_10, tmp5_createLinearGradient_0_11, null, null, 6528, null).addColorStop_0(0.0, Colors_getInstance().get_91('#F9F9F9')).addColorStop_0(1.0, Colors_getInstance().get_91('#6C6C6C'));
            break;
          case 1:
            var tmp6_createLinearGradient_0_12 = 0;
            var tmp7_createLinearGradient_0_13 = 0;
            var tmp8_createLinearGradient_0_14 = 0;
            var tmp9_createLinearGradient_0_15 = 64;
            var tmp10_createLinearGradient_0_16 = CycleMethod_NO_CYCLE_getInstance();
            var tmp11_createLinearGradient_0_17 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
            var tmp_5 = GradientKind_LINEAR_getInstance();
            var tmp_6 = numberToDouble(tmp6_createLinearGradient_0_12);
            var tmp_7 = numberToDouble(tmp7_createLinearGradient_0_13);
            var tmp_8 = numberToDouble(tmp8_createLinearGradient_0_14);
            var tmp_9 = numberToDouble(tmp9_createLinearGradient_0_15);
            tmp = GradientPaint_init_$Create$(tmp_5, tmp_6, tmp_7, 0.0, tmp_8, tmp_9, 0.0, null, null, tmp10_createLinearGradient_0_16, tmp11_createLinearGradient_0_17, null, null, 6528, null).addColorStop_0(0.0, Colors_getInstance().get_91('#F9F9F9')).addColorStop_0(1.0, Colors_getInstance().get_91('#9E9E9E'));
            break;
          case 2:
            var tmp12_createLinearGradient_0_18 = 0;
            var tmp13_createLinearGradient_0_19 = 0;
            var tmp14_createLinearGradient_0_20 = 0;
            var tmp15_createLinearGradient_0_21 = 64;
            var tmp16_createLinearGradient_0_22 = CycleMethod_NO_CYCLE_getInstance();
            var tmp17_createLinearGradient_0_23 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
            var tmp_10 = GradientKind_LINEAR_getInstance();
            var tmp_11 = numberToDouble(tmp12_createLinearGradient_0_18);
            var tmp_12 = numberToDouble(tmp13_createLinearGradient_0_19);
            var tmp_13 = numberToDouble(tmp14_createLinearGradient_0_20);
            var tmp_14 = numberToDouble(tmp15_createLinearGradient_0_21);
            tmp = GradientPaint_init_$Create$(tmp_10, tmp_11, tmp_12, 0.0, tmp_13, tmp_14, 0.0, null, null, tmp16_createLinearGradient_0_22, tmp17_createLinearGradient_0_23, null, null, 6528, null).addColorStop_0(0.0, Colors_getInstance().get_91('#909090')).addColorStop_0(1.0, Colors_getInstance().get_91('#F5F5F5'));
            break;
          case 3:
            var tmp18_createLinearGradient_0_24 = 0;
            var tmp19_createLinearGradient_0_25 = 0;
            var tmp20_createLinearGradient_0_26 = 0;
            var tmp21_createLinearGradient_0_27 = 64;
            var tmp22_createLinearGradient_0_28 = CycleMethod_NO_CYCLE_getInstance();
            var tmp23_createLinearGradient_0_29 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
            var tmp_15 = GradientKind_LINEAR_getInstance();
            var tmp_16 = numberToDouble(tmp18_createLinearGradient_0_24);
            var tmp_17 = numberToDouble(tmp19_createLinearGradient_0_25);
            var tmp_18 = numberToDouble(tmp20_createLinearGradient_0_26);
            var tmp_19 = numberToDouble(tmp21_createLinearGradient_0_27);
            tmp = GradientPaint_init_$Create$(tmp_15, tmp_16, tmp_17, 0.0, tmp_18, tmp_19, 0.0, null, null, tmp22_createLinearGradient_0_28, tmp23_createLinearGradient_0_29, null, null, 6528, null).addColorStop_0(0.0, Colors_getInstance().get_91('#A7A7A7')).addColorStop_0(1.0, Colors_getInstance().get_91('#A7A7A7'));
            break;
          default:throw NotImplementedError_init_$Create$(null, 1, null);
        }
        var gradient_4 = tmp;
        var tmp1_subject_31 = index;
        {
          var border_30;
          switch (tmp1_subject_31) {
            case 2:
              border_30 = Companion_getInstance_104().invoke_378(Colors_getInstance().get_91('#4B4955'));
              break;
            case 3:
              border_30 = Companion_getInstance_104().invoke_378(Colors_getInstance().get_91('#6A6A6A'));
              break;
            default:border_30 = Companion_getInstance_104().invoke_378(Colors_getInstance().get_91('#3C3A44'));
              break;
          }
        }
        var tmp24_fill_0_32 = true;
        if (tmp24_fill_0_32)
          ctx_2_2.beginPath_0();
        var tmp0_stroke_0_2_33 = 8.0;
        var tmp1_stroke_0_3_34 = ctx_2_2._get_lineCap__0();
        var tmp2_stroke_0_4_35 = ctx_2_2._get_lineJoin_();
        var tmp3_stroke_0_5_36 = true;
        if (tmp3_stroke_0_5_36)
          ctx_2_2.beginPath_0();
        roundRect_0(ctx_2_2, 4, 4, 56, 56, 6, 6);
        ctx_2_2._set_lineWidth_(tmp0_stroke_0_2_33);
        ctx_2_2._set_lineCap__0(tmp1_stroke_0_3_34);
        ctx_2_2._set_lineJoin_(tmp2_stroke_0_4_35);
        ctx_2_2.stroke_1(new RGBA(border_30));
        ctx_2_2.fill_7(gradient_4);
      }finally {
        ctx_2_2.dispose_18();
      }
    }finally {
      tmp0_context2d_0.unlock_5(tmp0_lock_0_1);
      Unit_getInstance();
    }
    return tmp0_context2d_0;
  }
  function buildDefaultShape(index, enabled) {
    var color_0 = Companion_getInstance_104().invoke_378(enabled ? Colors_getInstance().get_91('#484848') : Colors_getInstance().get_91('#737373'));
    var lineWidth = 8.0;
    var tmp0_context2d_0 = NativeImage$default(64, 64, null, 4, null);
    var tmp1_context2d_0 = true;
    var tmp0_lock_0_1 = null;
    tmp0_context2d_0.lock_5();
    try {
      var ctx_2_2 = tmp0_context2d_0.getContext2d_5(tmp1_context2d_0);
      try {
        var tmp0_subject_4 = index;
        if (tmp0_subject_4 === 0) {
          var tmp0_translate_0_5 = 27;
          var tmp1_translate_0_6 = 41;
          ctx_2_2.translate_2(tmp0_translate_0_5, tmp1_translate_0_6);
          Unit_getInstance();
          ctx_2_2.rotate_1(_get_degrees__0(45));
          Unit_getInstance();
          var tmp2_stroke_0_7 = LineCap_BUTT_getInstance();
          var tmp3_stroke_0_8 = ctx_2_2._get_lineJoin_();
          var tmp4_stroke_0_9 = true;
          if (tmp4_stroke_0_9)
            ctx_2_2.beginPath_0();
          moveTo(ctx_2_2, -16, 0);
          lineTo(ctx_2_2, 0, 0);
          lineTo(ctx_2_2, 0, -32);
          ctx_2_2._set_lineWidth_(lineWidth);
          ctx_2_2._set_lineCap__0(tmp2_stroke_0_7);
          ctx_2_2._set_lineJoin_(tmp3_stroke_0_8);
          ctx_2_2.stroke_1(new RGBA(color_0));
        } else {
          var tmp5_translate_0_10 = 32;
          var tmp6_translate_0_11 = 32;
          ctx_2_2.translate_2(tmp5_translate_0_10, tmp6_translate_0_11);
          Unit_getInstance();
          ctx_2_2.rotate_1(_get_degrees__0(45 + imul(90, index - 1 | 0) | 0));
          Unit_getInstance();
          var offsetX_12 = -8;
          var offsetY_13 = -8;
          var lineLength_14 = 20;
          var tmp7_stroke_0_15 = LineCap_SQUARE_getInstance();
          var tmp8_stroke_0_16 = ctx_2_2._get_lineJoin_();
          var tmp9_stroke_0_17 = true;
          if (tmp9_stroke_0_17)
            ctx_2_2.beginPath_0();
          line(ctx_2_2, offsetX_12 + 0 | 0, offsetY_13 + 0 | 0, offsetX_12 + 0 | 0, offsetY_13 + lineLength_14 | 0);
          line(ctx_2_2, offsetX_12 + 0 | 0, offsetY_13 + 0 | 0, offsetX_12 + lineLength_14 | 0, offsetY_13 + 0 | 0);
          ctx_2_2._set_lineWidth_(lineWidth);
          ctx_2_2._set_lineCap__0(tmp7_stroke_0_15);
          ctx_2_2._set_lineJoin_(tmp8_stroke_0_16);
          ctx_2_2.stroke_1(new RGBA(color_0));
        }
      }finally {
        ctx_2_2.dispose_18();
      }
    }finally {
      tmp0_context2d_0.unlock_5(tmp0_lock_0_1);
      Unit_getInstance();
    }
    return tmp0_context2d_0;
  }
  function _get_DefaultUIVectorFont_() {
    return _get_DefaultTtfFont_();
  }
  function _no_name_provided__491() {
  }
  _no_name_provided__491.prototype.invoke_1005 = function () {
    return new TextSkin(new TextFormat(Companion_getInstance_104().invoke_376(0, 0, 0), 16, _get_DefaultUIFont_()), new TextFormat(Companion_getInstance_104().invoke_376(80, 80, 80), 16, _get_DefaultUIFont_()), new TextFormat(Companion_getInstance_104().invoke_376(120, 120, 120), 16, _get_DefaultUIFont_()), new TextFormat(Companion_getInstance_104().invoke_376(160, 160, 160), 16, _get_DefaultUIFont_()), Colors_getInstance()._WHITE);
  };
  _no_name_provided__491.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__492() {
  }
  _no_name_provided__492.prototype.invoke_1005 = function () {
    var tmp0_context2d_0 = NativeImage$default(256, 512, null, 4, null);
    var tmp1_context2d_0 = true;
    var tmp0_lock_0_1 = null;
    tmp0_context2d_0.lock_5();
    try {
      var ctx_2_2 = tmp0_context2d_0.getContext2d_5(tmp1_context2d_0);
      try {
        var inductionVariable = 0;
        if (inductionVariable < 4)
          do {
            var n_5 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0_drawImage_0_6 = buildDefaultButton(n_5);
            var tmp1_drawImage_0_7 = imul(n_5, 64);
            var tmp2_drawImage_0_8 = 0;
            var tmp3_drawImage_0_9 = tmp0_drawImage_0_6._width_2;
            var tmp4_drawImage_0_10 = tmp0_drawImage_0_6._height_2;
            ctx_2_2.drawImage_1(tmp0_drawImage_0_6, numberToDouble(tmp1_drawImage_0_7), numberToDouble(tmp2_drawImage_0_8), numberToDouble(tmp3_drawImage_0_9), numberToDouble(tmp4_drawImage_0_10));
          }
           while (inductionVariable < 4);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 5)
          do {
            var n_12 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp2_iterator_13 = listOf([false, true]).iterator_67();
            while (tmp2_iterator_13.hasNext_33()) {
              var enabled_14 = tmp2_iterator_13.next_37();
              var tmp = buildDefaultShape(n_12, enabled_14);
              var tmp_0 = 64.0 * (enabled_14 ? 0 : 1);
              var tmp_1 = 64 + 64.0 * n_12;
              ctx_2_2.drawImage$default(tmp, tmp_0, tmp_1, 0.0, 0.0, 24, null);
            }
          }
           while (inductionVariable_0 < 5);
      }finally {
        ctx_2_2.dispose_18();
      }
    }finally {
      tmp0_context2d_0.unlock_5(tmp0_lock_0_1);
      Unit_getInstance();
    }
    var tmp2_also_0 = mipmaps(tmp0_context2d_0, true).toBMP32IfRequired_5();
    Unit_getInstance();
    return tmp2_also_0;
  };
  _no_name_provided__492.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__493() {
  }
  _no_name_provided__493.prototype.invoke_1005 = function () {
    var tmp = _get_DEFAULT_UI_SKIN_IMG_();
    var tmp_0 = sliceWithSize$default_0(tmp, 0, 0, 64, 64, null, 16, null);
    var tmp_1 = _get_DEFAULT_UI_SKIN_IMG_();
    var tmp_2 = sliceWithSize$default_0(tmp_1, 64, 0, 64, 64, null, 16, null);
    var tmp_3 = _get_DEFAULT_UI_SKIN_IMG_();
    var tmp_4 = sliceWithSize$default_0(tmp_3, 128, 0, 64, 64, null, 16, null);
    var tmp_5 = _get_DEFAULT_UI_SKIN_IMG_();
    var tmp_6 = sliceWithSize$default_0(tmp_5, 192, 0, 64, 64, null, 16, null);
    return UISkin_init_$Create$(tmp_0, tmp_2, tmp_4, tmp_6, null, 16, null);
  };
  _no_name_provided__493.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__494() {
  }
  _no_name_provided__494.prototype.invoke_1005 = function () {
    var tmp0_map_0 = until(0, 5);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var inductionVariable = tmp0_map_0._get_first__6();
    var last_1 = tmp0_map_0._get_last__6();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = _get_DEFAULT_UI_SKIN_IMG_();
        var tmp_0 = imul(64, item_2_3 + 1 | 0);
        var tmp_1 = sliceWithSize$default_0(tmp, 0, tmp_0, 64, 64, null, 16, null);
        var tmp_2 = _get_DEFAULT_UI_SKIN_IMG_();
        var tmp_3 = imul(64, item_2_3 + 1 | 0);
        var tmp_4 = sliceWithSize$default_0(tmp_2, 64, tmp_3, 64, 64, null, 16, null);
        tmp0_mapTo_0_1.add_39(IconSkin_init_$Create$(tmp_1, null, null, tmp_4, 0.0, 0.0, 0.0, 0.0, 246, null));
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    return tmp0_mapTo_0_1;
  };
  _no_name_provided__494.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__495() {
  }
  _no_name_provided__495.prototype.invoke_1005 = function () {
    var tmp = _get_DefaultUISkin_();
    return ComboBoxSkin_init_$Create$(tmp, null, null, _get_DefaultDownSkin_(), _get_DefaultUpSkin_(), _get_DefaultVerScrollBarSkin_(), _get_DefaultUIFont_(), 6, null);
  };
  _no_name_provided__495.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__496() {
  }
  _no_name_provided__496.prototype.invoke_1005 = function () {
    var tmp = _get_DefaultUISkin_();
    var tmp_0 = _get_DefaultUpSkin_();
    var tmp_1 = _get_DefaultDownSkin_();
    return ScrollBarSkin_init_$Create$(tmp, null, null, tmp_0, tmp_1, null, 38, null);
  };
  _no_name_provided__496.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__497() {
  }
  _no_name_provided__497.prototype.invoke_1005 = function () {
    var tmp = _get_DefaultUISkin_();
    var tmp_0 = _get_DefaultLeftSkin_();
    var tmp_1 = _get_DefaultRightSkin_();
    return ScrollBarSkin_init_$Create$(tmp, null, null, tmp_0, tmp_1, null, 38, null);
  };
  _no_name_provided__497.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function DefaultTextSkin$factory() {
    return getPropertyCallableRef('DefaultTextSkin', 0, KProperty0, function () {
      return _get_DefaultTextSkin_();
    }, null);
  }
  function DEFAULT_UI_SKIN_IMG$factory() {
    return getPropertyCallableRef('DEFAULT_UI_SKIN_IMG', 0, KProperty0, function () {
      return _get_DEFAULT_UI_SKIN_IMG_();
    }, null);
  }
  function DefaultUISkin$factory() {
    return getPropertyCallableRef('DefaultUISkin', 0, KProperty0, function () {
      return _get_DefaultUISkin_();
    }, null);
  }
  function DefaultIconSkins$factory() {
    return getPropertyCallableRef('DefaultIconSkins', 0, KProperty0, function () {
      return _get_DefaultIconSkins_();
    }, null);
  }
  function DefaultComboBoxSkin$factory() {
    return getPropertyCallableRef('DefaultComboBoxSkin', 0, KProperty0, function () {
      return _get_DefaultComboBoxSkin_();
    }, null);
  }
  function DefaultVerScrollBarSkin$factory() {
    return getPropertyCallableRef('DefaultVerScrollBarSkin', 0, KProperty0, function () {
      return _get_DefaultVerScrollBarSkin_();
    }, null);
  }
  function DefaultHorScrollBarSkin$factory() {
    return getPropertyCallableRef('DefaultHorScrollBarSkin', 0, KProperty0, function () {
      return _get_DefaultHorScrollBarSkin_();
    }, null);
  }
  function _no_name_provided_$factory_443() {
    var i = new _no_name_provided__491();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_444() {
    var i = new _no_name_provided__492();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_445() {
    var i = new _no_name_provided__493();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_446() {
    var i = new _no_name_provided__494();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_447() {
    var i = new _no_name_provided__495();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_448() {
    var i = new _no_name_provided__496();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_449() {
    var i = new _no_name_provided__497();
    return function () {
      return i.invoke_1005();
    };
  }
  function TextSkin(normal, over, down, disabled, backColor) {
    this._normal = normal;
    this._over_0 = over;
    this._down_0 = down;
    this._disabled = disabled;
    this._backColor = backColor;
  }
  TextSkin.prototype.toString = function () {
    return '' + 'TextSkin(normal=' + this._normal + ', over=' + this._over_0 + ', down=' + this._down_0 + ', disabled=' + this._disabled + ', backColor=' + new RGBA(this._backColor) + ')';
  };
  TextSkin.prototype.hashCode = function () {
    var result = this._normal.hashCode();
    result = imul(result, 31) + this._over_0.hashCode() | 0;
    result = imul(result, 31) + this._down_0.hashCode() | 0;
    result = imul(result, 31) + this._disabled.hashCode() | 0;
    result = imul(result, 31) + RGBA__hashCode_impl(this._backColor) | 0;
    return result;
  };
  TextSkin.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextSkin))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextSkin ? other : THROW_CCE();
    if (!this._normal.equals(tmp0_other_with_cast._normal))
      return false;
    if (!this._over_0.equals(tmp0_other_with_cast._over_0))
      return false;
    if (!this._down_0.equals(tmp0_other_with_cast._down_0))
      return false;
    if (!this._disabled.equals(tmp0_other_with_cast._disabled))
      return false;
    if (!equals_1(new RGBA(this._backColor), new RGBA(tmp0_other_with_cast._backColor)))
      return false;
    return true;
  };
  TextSkin.$metadata$ = {
    simpleName: 'TextSkin',
    kind: 'class',
    interfaces: []
  };
  function UISkin_init_$Init$(normal, over, down, disabled, backColor, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      over = normal;
    if (!(($mask0 & 4) === 0))
      down = normal;
    if (!(($mask0 & 8) === 0))
      disabled = normal;
    if (!(($mask0 & 16) === 0))
      backColor = Colors_getInstance()._DARKGREY;
    UISkin.call($this, normal, over, down, disabled, backColor);
    return $this;
  }
  function UISkin_init_$Create$(normal, over, down, disabled, backColor, $mask0, $marker) {
    return UISkin_init_$Init$(normal, over, down, disabled, backColor, $mask0, $marker, Object.create(UISkin.prototype));
  }
  function UISkin(normal, over, down, disabled, backColor) {
    this._normal_0 = normal;
    this._over_1 = over;
    this._down_1 = down;
    this._disabled_0 = disabled;
    this._backColor_0 = backColor;
  }
  UISkin.prototype.toString = function () {
    return '' + 'UISkin(normal=' + this._normal_0 + ', over=' + this._over_1 + ', down=' + this._down_1 + ', disabled=' + this._disabled_0 + ', backColor=' + new RGBA(this._backColor_0) + ')';
  };
  UISkin.prototype.hashCode = function () {
    var result = hashCode(this._normal_0);
    result = imul(result, 31) + hashCode(this._over_1) | 0;
    result = imul(result, 31) + hashCode(this._down_1) | 0;
    result = imul(result, 31) + hashCode(this._disabled_0) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl(this._backColor_0) | 0;
    return result;
  };
  UISkin.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UISkin))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof UISkin ? other : THROW_CCE();
    if (!equals_1(this._normal_0, tmp0_other_with_cast._normal_0))
      return false;
    if (!equals_1(this._over_1, tmp0_other_with_cast._over_1))
      return false;
    if (!equals_1(this._down_1, tmp0_other_with_cast._down_1))
      return false;
    if (!equals_1(this._disabled_0, tmp0_other_with_cast._disabled_0))
      return false;
    if (!equals_1(new RGBA(this._backColor_0), new RGBA(tmp0_other_with_cast._backColor_0)))
      return false;
    return true;
  };
  UISkin.$metadata$ = {
    simpleName: 'UISkin',
    kind: 'class',
    interfaces: []
  };
  function IconSkin_init_$Init$(normal, over, down, disabled, indentRatioLeft, indentRatioRight, indentRatioTop, indentRatioBottom, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      over = normal;
    if (!(($mask0 & 4) === 0))
      down = normal;
    if (!(($mask0 & 8) === 0))
      disabled = normal;
    if (!(($mask0 & 16) === 0))
      indentRatioLeft = 0.0;
    if (!(($mask0 & 32) === 0))
      indentRatioRight = 0.0;
    if (!(($mask0 & 64) === 0))
      indentRatioTop = 0.0;
    if (!(($mask0 & 128) === 0))
      indentRatioBottom = 0.0;
    IconSkin.call($this, normal, over, down, disabled, indentRatioLeft, indentRatioRight, indentRatioTop, indentRatioBottom);
    return $this;
  }
  function IconSkin_init_$Create$(normal, over, down, disabled, indentRatioLeft, indentRatioRight, indentRatioTop, indentRatioBottom, $mask0, $marker) {
    return IconSkin_init_$Init$(normal, over, down, disabled, indentRatioLeft, indentRatioRight, indentRatioTop, indentRatioBottom, $mask0, $marker, Object.create(IconSkin.prototype));
  }
  function IconSkin(normal, over, down, disabled, indentRatioLeft, indentRatioRight, indentRatioTop, indentRatioBottom) {
    this._normal_1 = normal;
    this._over_2 = over;
    this._down_2 = down;
    this._disabled_1 = disabled;
    this._indentRatioLeft = indentRatioLeft;
    this._indentRatioRight = indentRatioRight;
    this._indentRatioTop = indentRatioTop;
    this._indentRatioBottom = indentRatioBottom;
  }
  IconSkin.prototype.toString = function () {
    return '' + 'IconSkin(normal=' + this._normal_1 + ', over=' + this._over_2 + ', down=' + this._down_2 + ', disabled=' + this._disabled_1 + ', indentRatioLeft=' + this._indentRatioLeft + ', indentRatioRight=' + this._indentRatioRight + ', indentRatioTop=' + this._indentRatioTop + ', indentRatioBottom=' + this._indentRatioBottom + ')';
  };
  IconSkin.prototype.hashCode = function () {
    var result = hashCode(this._normal_1);
    result = imul(result, 31) + hashCode(this._over_2) | 0;
    result = imul(result, 31) + hashCode(this._down_2) | 0;
    result = imul(result, 31) + hashCode(this._disabled_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this._indentRatioLeft) | 0;
    result = imul(result, 31) + getNumberHashCode(this._indentRatioRight) | 0;
    result = imul(result, 31) + getNumberHashCode(this._indentRatioTop) | 0;
    result = imul(result, 31) + getNumberHashCode(this._indentRatioBottom) | 0;
    return result;
  };
  IconSkin.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IconSkin))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof IconSkin ? other : THROW_CCE();
    if (!equals_1(this._normal_1, tmp0_other_with_cast._normal_1))
      return false;
    if (!equals_1(this._over_2, tmp0_other_with_cast._over_2))
      return false;
    if (!equals_1(this._down_2, tmp0_other_with_cast._down_2))
      return false;
    if (!equals_1(this._disabled_1, tmp0_other_with_cast._disabled_1))
      return false;
    if (!equals_1(this._indentRatioLeft, tmp0_other_with_cast._indentRatioLeft))
      return false;
    if (!equals_1(this._indentRatioRight, tmp0_other_with_cast._indentRatioRight))
      return false;
    if (!equals_1(this._indentRatioTop, tmp0_other_with_cast._indentRatioTop))
      return false;
    if (!equals_1(this._indentRatioBottom, tmp0_other_with_cast._indentRatioBottom))
      return false;
    return true;
  };
  IconSkin.$metadata$ = {
    simpleName: 'IconSkin',
    kind: 'class',
    interfaces: []
  };
  function ComboBoxSkin_init_$Init$(itemSkin, selectedSkin, expandSkin, showIcon, hideIcon, scrollbarSkin, textFont, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      selectedSkin = itemSkin;
    if (!(($mask0 & 4) === 0))
      expandSkin = itemSkin;
    ComboBoxSkin.call($this, itemSkin, selectedSkin, expandSkin, showIcon, hideIcon, scrollbarSkin, textFont);
    return $this;
  }
  function ComboBoxSkin_init_$Create$(itemSkin, selectedSkin, expandSkin, showIcon, hideIcon, scrollbarSkin, textFont, $mask0, $marker) {
    return ComboBoxSkin_init_$Init$(itemSkin, selectedSkin, expandSkin, showIcon, hideIcon, scrollbarSkin, textFont, $mask0, $marker, Object.create(ComboBoxSkin.prototype));
  }
  function ComboBoxSkin(itemSkin, selectedSkin, expandSkin, showIcon, hideIcon, scrollbarSkin, textFont) {
    this._itemSkin = itemSkin;
    this._selectedSkin = selectedSkin;
    this._expandSkin = expandSkin;
    this._showIcon = showIcon;
    this._hideIcon = hideIcon;
    this._scrollbarSkin = scrollbarSkin;
    this._textFont = textFont;
  }
  ComboBoxSkin.prototype.toString = function () {
    return '' + 'ComboBoxSkin(itemSkin=' + this._itemSkin + ', selectedSkin=' + this._selectedSkin + ', expandSkin=' + this._expandSkin + ', showIcon=' + this._showIcon + ', hideIcon=' + this._hideIcon + ', scrollbarSkin=' + this._scrollbarSkin + ', textFont=' + this._textFont + ')';
  };
  ComboBoxSkin.prototype.hashCode = function () {
    var result = this._itemSkin.hashCode();
    result = imul(result, 31) + this._selectedSkin.hashCode() | 0;
    result = imul(result, 31) + this._expandSkin.hashCode() | 0;
    result = imul(result, 31) + this._showIcon.hashCode() | 0;
    result = imul(result, 31) + this._hideIcon.hashCode() | 0;
    result = imul(result, 31) + this._scrollbarSkin.hashCode() | 0;
    result = imul(result, 31) + hashCode(this._textFont) | 0;
    return result;
  };
  ComboBoxSkin.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ComboBoxSkin))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ComboBoxSkin ? other : THROW_CCE();
    if (!this._itemSkin.equals(tmp0_other_with_cast._itemSkin))
      return false;
    if (!this._selectedSkin.equals(tmp0_other_with_cast._selectedSkin))
      return false;
    if (!this._expandSkin.equals(tmp0_other_with_cast._expandSkin))
      return false;
    if (!this._showIcon.equals(tmp0_other_with_cast._showIcon))
      return false;
    if (!this._hideIcon.equals(tmp0_other_with_cast._hideIcon))
      return false;
    if (!this._scrollbarSkin.equals(tmp0_other_with_cast._scrollbarSkin))
      return false;
    if (!equals_1(this._textFont, tmp0_other_with_cast._textFont))
      return false;
    return true;
  };
  ComboBoxSkin.$metadata$ = {
    simpleName: 'ComboBoxSkin',
    kind: 'class',
    interfaces: []
  };
  function ScrollBarSkin_init_$Init$(thumbSkin, upSkin, downSkin, upIcon, downIcon, backColor, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      upSkin = thumbSkin;
    if (!(($mask0 & 4) === 0))
      downSkin = thumbSkin;
    if (!(($mask0 & 32) === 0))
      backColor = Colors_getInstance()._DARKGREY;
    ScrollBarSkin.call($this, thumbSkin, upSkin, downSkin, upIcon, downIcon, backColor);
    return $this;
  }
  function ScrollBarSkin_init_$Create$(thumbSkin, upSkin, downSkin, upIcon, downIcon, backColor, $mask0, $marker) {
    return ScrollBarSkin_init_$Init$(thumbSkin, upSkin, downSkin, upIcon, downIcon, backColor, $mask0, $marker, Object.create(ScrollBarSkin.prototype));
  }
  function ScrollBarSkin(thumbSkin, upSkin, downSkin, upIcon, downIcon, backColor) {
    this._thumbSkin = thumbSkin;
    this._upSkin = upSkin;
    this._downSkin = downSkin;
    this._upIcon = upIcon;
    this._downIcon = downIcon;
    this._backColor_1 = backColor;
  }
  ScrollBarSkin.prototype.toString = function () {
    return '' + 'ScrollBarSkin(thumbSkin=' + this._thumbSkin + ', upSkin=' + this._upSkin + ', downSkin=' + this._downSkin + ', upIcon=' + this._upIcon + ', downIcon=' + this._downIcon + ', backColor=' + new RGBA(this._backColor_1) + ')';
  };
  ScrollBarSkin.prototype.hashCode = function () {
    var result = this._thumbSkin.hashCode();
    result = imul(result, 31) + this._upSkin.hashCode() | 0;
    result = imul(result, 31) + this._downSkin.hashCode() | 0;
    result = imul(result, 31) + this._upIcon.hashCode() | 0;
    result = imul(result, 31) + this._downIcon.hashCode() | 0;
    result = imul(result, 31) + RGBA__hashCode_impl(this._backColor_1) | 0;
    return result;
  };
  ScrollBarSkin.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScrollBarSkin))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ScrollBarSkin ? other : THROW_CCE();
    if (!this._thumbSkin.equals(tmp0_other_with_cast._thumbSkin))
      return false;
    if (!this._upSkin.equals(tmp0_other_with_cast._upSkin))
      return false;
    if (!this._downSkin.equals(tmp0_other_with_cast._downSkin))
      return false;
    if (!this._upIcon.equals(tmp0_other_with_cast._upIcon))
      return false;
    if (!this._downIcon.equals(tmp0_other_with_cast._downIcon))
      return false;
    if (!equals_1(new RGBA(this._backColor_1), new RGBA(tmp0_other_with_cast._backColor_1)))
      return false;
    return true;
  };
  ScrollBarSkin.$metadata$ = {
    simpleName: 'ScrollBarSkin',
    kind: 'class',
    interfaces: []
  };
  function TextFormat(color_0, size_1, font) {
    this._color_3 = color_0;
    this._size_13 = size_1;
    this._font_1 = font;
  }
  TextFormat.prototype.toString = function () {
    return '' + 'TextFormat(color=' + new RGBA(this._color_3) + ', size=' + this._size_13 + ', font=' + this._font_1 + ')';
  };
  TextFormat.prototype.hashCode = function () {
    var result = RGBA__hashCode_impl(this._color_3);
    result = imul(result, 31) + this._size_13 | 0;
    result = imul(result, 31) + (this._font_1 == null ? 0 : hashCode(this._font_1)) | 0;
    return result;
  };
  TextFormat.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextFormat))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof TextFormat ? other : THROW_CCE();
    if (!equals_1(new RGBA(this._color_3), new RGBA(tmp0_other_with_cast._color_3)))
      return false;
    if (!(this._size_13 === tmp0_other_with_cast._size_13))
      return false;
    if (!equals_1(this._font_1, tmp0_other_with_cast._font_1))
      return false;
    return true;
  };
  TextFormat.$metadata$ = {
    simpleName: 'TextFormat',
    kind: 'class',
    interfaces: []
  };
  function paddingLeft(_this_, width) {
    return width * _this_._indentRatioLeft;
  }
  function paddingTop(_this_, height) {
    return height * _this_._indentRatioTop;
  }
  function calculateWidth(_this_, parentWidth) {
    return parentWidth * (1.0 - _this_._indentRatioLeft - _this_._indentRatioRight);
  }
  function calculateHeight(_this_, parentHeight) {
    return parentHeight * (1.0 - _this_._indentRatioTop - _this_._indentRatioBottom);
  }
  function CancellableGroup() {
    var tmp = this;
    tmp._cancellables_0 = ArrayList_init_$Create$();
  }
  CancellableGroup.prototype.cancel_27 = function (e) {
    cancel_1(this._cancellables_0, e);
  };
  CancellableGroup.$metadata$ = {
    simpleName: 'CancellableGroup',
    kind: 'class',
    interfaces: [Cancellable]
  };
  function anchor(_this_, ax, ay) {
    return anchor_0(_this_, ax, ay);
  }
  function Anchorable() {
  }
  Anchorable.$metadata$ = {
    simpleName: 'Anchorable',
    kind: 'interface',
    interfaces: []
  };
  function anchor_0(_this_, ax, ay) {
    _this_._set_anchorX__8(ax);
    _this_._set_anchorY__8(ay);
    return _this_;
  }
  function BView() {
  }
  BView.$metadata$ = {
    simpleName: 'BView',
    kind: 'interface',
    interfaces: []
  };
  function createImage($this, width, height) {
    var tmp;
    if ($this._useNativeRendering) {
      tmp = NativeImage$default(width, height, null, 4, null);
    } else {
      tmp = Bitmap32_init_$Create$(width, height, null, true, 4, null);
    }
    return tmp;
  }
  function BaseGraphics(autoScaling) {
    var tmp = Bitmaps_getInstance()._transparent;
    BaseImage_init_$Init$(tmp, 0.0, 0.0, null, false, 30, null, this);
    this._autoScaling = autoScaling;
    this._useNativeRendering = true;
    var tmp_0 = this;
    tmp_0._bitmapsToRemove = ArrayList_init_$Create$();
    this._autoscaling = new InternalViewAutoscaling();
    this._dirty_2 = true;
    this._bb_0 = new BoundsBuilder();
    this._bounds_8 = Companion_getInstance_83().invoke_1005();
  }
  BaseGraphics.prototype._get_bwidth__7 = function () {
    return this._get_bitmap__5()._get_width__58() / this._autoscaling._renderedAtScaleX;
  };
  BaseGraphics.prototype._get_bheight__7 = function () {
    return this._get_bitmap__5()._get_height__58() / this._autoscaling._renderedAtScaleY;
  };
  BaseGraphics.prototype._set_dirty__7 = function (_set___) {
    this._dirty_2 = _set___;
  };
  BaseGraphics.prototype.renderInternal_20 = function (ctx) {
    var tmp0_fastForEach_0 = this._bitmapsToRemove;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      ctx._agBitmapTextureManager.removeBitmap(tmp1__anonymous__3);
    }
    this._bitmapsToRemove.clear_33();
    this.redrawIfRequired_3();
    BaseImage.prototype.renderInternal_20.call(this, ctx);
  };
  BaseGraphics.prototype.redrawIfRequired_3 = function () {
    if (this._autoscaling.onRender(this._autoScaling, this._get_globalMatrix__20())) {
      this._dirty_2 = true;
    }if (this._dirty_2) {
      this._dirty_2 = false;
      this.getLocalBoundsInternalNoAnchor_3(this._bounds_8);
      this._bitmapsToRemove.add_39(this._get_bitmap__5()._bmpBase);
      Unit_getInstance();
      var image_2 = createImage(this, coerceAtLeast(toIntCeil(this._bounds_8._width_0 * this._autoscaling._renderedAtScaleX), 1) + 1 | 0, coerceAtLeast(toIntCeil(this._bounds_8._height_0 * this._autoscaling._renderedAtScaleY), 1) + 1 | 0);
      var tmp0_context2d_0_3 = true;
      var tmp0_lock_0_1_4 = null;
      image_2.lock_5();
      try {
        var ctx_2_2_5 = image_2.getContext2d_5(tmp0_context2d_0_3);
        try {
          ctx_2_2_5.scale_2(this._autoscaling._renderedAtScaleX, this._autoscaling._renderedAtScaleY);
          Unit_getInstance();
          ctx_2_2_5.translate_2(-this._bounds_8._x_3, -this._bounds_8._y_3);
          Unit_getInstance();
          this.drawShape_3(ctx_2_2_5);
        }finally {
          ctx_2_2_5.dispose_18();
        }
      }finally {
        image_2.unlock_5(tmp0_lock_0_1_4);
        Unit_getInstance();
      }
      Unit_getInstance();
      this._set_bitmap__5(slice$default(image_2, null, null, 3, null));
    }};
  BaseGraphics.prototype._get_sLeft__7 = function () {
    var out = this._bounds_8._x_3 - this._get_anchorDispX__20();
    if (this._get_bwidth__7() < 0.0)
      out = out - this._get_bwidth__7();
    return out;
  };
  BaseGraphics.prototype._get_sTop__7 = function () {
    var out = this._bounds_8._y_3 - this._get_anchorDispY__20();
    if (this._get_bheight__7() < 0.0)
      out = out - this._get_bheight__7();
    return out;
  };
  BaseGraphics.prototype.getLocalBoundsInternalNoAnchor_3 = function (out) {
    this._bb_0.reset_9();
    this.getShapeBounds_3(this._bb_0);
    this._bb_0.getBounds_0(out);
    Unit_getInstance();
  };
  BaseGraphics.prototype.getLocalBoundsInternal_20 = function (out) {
    this.getLocalBoundsInternalNoAnchor_3(out);
    out.displace(-this._get_anchorDispX__20(), -this._get_anchorDispY__20());
    Unit_getInstance();
  };
  BaseGraphics.$metadata$ = {
    simpleName: 'BaseGraphics',
    kind: 'class',
    interfaces: []
  };
  var BlendMode_INHERIT_instance;
  var BlendMode_NONE_instance;
  var BlendMode_NORMAL_instance_0;
  var BlendMode_ADD_instance;
  var BlendMode_MULTIPLY_instance_0;
  var BlendMode_SCREEN_instance_0;
  var BlendMode_ERASE_instance;
  var BlendMode_MASK_instance;
  var BlendMode_BELOW_instance;
  var BlendMode_SUBTRACT_instance;
  var BlendMode_INVERT_instance;
  var BlendMode_LIGHTEN_instance_0;
  var BlendMode_DARKEN_instance_0;
  var BlendMode_DIFFERENCE_instance_0;
  var BlendMode_ALPHA_instance;
  var BlendMode_HARDLIGHT_instance;
  function Companion_148() {
    Companion_instance_147 = this;
    this._OVERLAY = BlendMode_NORMAL_getInstance_0();
    var tmp = this;
    var tmp0_associateBy_0 = values_9();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_18(element_2_4._get_ordinal__2(), element_2_4);
      Unit_getInstance();
    }
    tmp._BY_ORDINAL = tmp0_associateByTo_0_2;
    var tmp_0 = this;
    var tmp0_associateBy_0_0 = values_9();
    var capacity_1_0 = coerceAtLeast(mapCapacity(tmp0_associateBy_0_0.length), 16);
    var tmp0_associateByTo_0_2_0 = LinkedHashMap_init_$Create$_1(capacity_1_0);
    var indexedObject_0 = tmp0_associateBy_0_0;
    var inductionVariable_0 = 0;
    var last_2 = indexedObject_0.length;
    while (inductionVariable_0 < last_2) {
      var element_2_4_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      tmp0_associateByTo_0_2_0.put_18(element_2_4_0._get_name__50(), element_2_4_0);
      Unit_getInstance();
    }
    tmp_0._BY_NAME = tmp0_associateByTo_0_2_0;
  }
  Companion_148.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_147;
  function Companion_getInstance_147() {
    if (Companion_instance_147 == null)
      new Companion_148();
    return Companion_instance_147;
  }
  function values_9() {
    return [BlendMode_INHERIT_getInstance(), BlendMode_NONE_getInstance(), BlendMode_NORMAL_getInstance_0(), BlendMode_ADD_getInstance(), BlendMode_MULTIPLY_getInstance_0(), BlendMode_SCREEN_getInstance_0(), BlendMode_ERASE_getInstance(), BlendMode_MASK_getInstance(), BlendMode_BELOW_getInstance(), BlendMode_SUBTRACT_getInstance(), BlendMode_INVERT_getInstance(), BlendMode_LIGHTEN_getInstance_0(), BlendMode_DARKEN_getInstance_0(), BlendMode_DIFFERENCE_getInstance_0(), BlendMode_ALPHA_getInstance(), BlendMode_HARDLIGHT_getInstance()];
  }
  var BlendMode_entriesInitialized_0;
  function BlendMode_initEntries_0() {
    if (BlendMode_entriesInitialized_0)
      return Unit_getInstance();
    BlendMode_entriesInitialized_0 = true;
    BlendMode_INHERIT_instance = new BlendMode_0('INHERIT', 0, Companion_getInstance_121()._NORMAL);
    var tmp = BlendFactor_ONE_getInstance();
    var tmp_0 = BlendFactor_ZERO_getInstance();
    BlendMode_NONE_instance = new BlendMode_0('NONE', 1, Blending_init_$Create$_0(tmp, tmp_0, null, 4, null));
    BlendMode_NORMAL_instance_0 = new BlendMode_0('NORMAL', 2, Companion_getInstance_121()._NORMAL);
    BlendMode_ADD_instance = new BlendMode_0('ADD', 3, Companion_getInstance_121()._ADD);
    var tmp_1 = BlendFactor_DESTINATION_COLOR_getInstance();
    var tmp_2 = BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance();
    BlendMode_MULTIPLY_instance_0 = new BlendMode_0('MULTIPLY', 4, Blending_init_$Create$_0(tmp_1, tmp_2, null, 4, null));
    var tmp_3 = BlendFactor_ONE_getInstance();
    var tmp_4 = BlendFactor_ONE_MINUS_SOURCE_COLOR_getInstance();
    BlendMode_SCREEN_instance_0 = new BlendMode_0('SCREEN', 5, Blending_init_$Create$_0(tmp_3, tmp_4, null, 4, null));
    var tmp_5 = BlendFactor_ZERO_getInstance();
    var tmp_6 = BlendFactor_ONE_MINUS_SOURCE_ALPHA_getInstance();
    BlendMode_ERASE_instance = new BlendMode_0('ERASE', 6, Blending_init_$Create$_0(tmp_5, tmp_6, null, 4, null));
    var tmp_7 = BlendFactor_ZERO_getInstance();
    var tmp_8 = BlendFactor_SOURCE_ALPHA_getInstance();
    BlendMode_MASK_instance = new BlendMode_0('MASK', 7, Blending_init_$Create$_0(tmp_7, tmp_8, null, 4, null));
    var tmp_9 = BlendFactor_ONE_MINUS_DESTINATION_ALPHA_getInstance();
    var tmp_10 = BlendFactor_DESTINATION_ALPHA_getInstance();
    BlendMode_BELOW_instance = new BlendMode_0('BELOW', 8, Blending_init_$Create$_0(tmp_9, tmp_10, null, 4, null));
    var tmp_11 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_12 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_13 = BlendFactor_ONE_getInstance();
    var tmp_14 = BlendFactor_ONE_getInstance();
    var tmp_15 = BlendEquation_REVERSE_SUBTRACT_getInstance();
    BlendMode_SUBTRACT_instance = new BlendMode_0('SUBTRACT', 9, Blending_init_$Create$(tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, null, 32, null));
    var tmp_16 = BlendFactor_ONE_MINUS_DESTINATION_COLOR_getInstance();
    var tmp_17 = BlendFactor_ZERO_getInstance();
    BlendMode_INVERT_instance = new BlendMode_0('INVERT', 10, Blending_init_$Create$_0(tmp_16, tmp_17, null, 4, null));
    var tmp_18 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_19 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_20 = BlendFactor_ONE_getInstance();
    var tmp_21 = BlendFactor_ONE_getInstance();
    BlendMode_LIGHTEN_instance_0 = new BlendMode_0('LIGHTEN', 11, Blending_init_$Create$(tmp_18, tmp_19, tmp_20, tmp_21, null, null, 48, null));
    var tmp_22 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_23 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_24 = BlendFactor_ONE_getInstance();
    var tmp_25 = BlendFactor_ONE_getInstance();
    BlendMode_DARKEN_instance_0 = new BlendMode_0('DARKEN', 12, Blending_init_$Create$(tmp_22, tmp_23, tmp_24, tmp_25, null, null, 48, null));
    var tmp_26 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_27 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_28 = BlendFactor_ONE_getInstance();
    var tmp_29 = BlendFactor_ONE_getInstance();
    BlendMode_DIFFERENCE_instance_0 = new BlendMode_0('DIFFERENCE', 13, Blending_init_$Create$(tmp_26, tmp_27, tmp_28, tmp_29, null, null, 48, null));
    var tmp_30 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_31 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_32 = BlendFactor_ONE_getInstance();
    var tmp_33 = BlendFactor_ONE_getInstance();
    BlendMode_ALPHA_instance = new BlendMode_0('ALPHA', 14, Blending_init_$Create$(tmp_30, tmp_31, tmp_32, tmp_33, null, null, 48, null));
    var tmp_34 = BlendFactor_SOURCE_ALPHA_getInstance();
    var tmp_35 = BlendFactor_DESTINATION_ALPHA_getInstance();
    var tmp_36 = BlendFactor_ONE_getInstance();
    var tmp_37 = BlendFactor_ONE_getInstance();
    BlendMode_HARDLIGHT_instance = new BlendMode_0('HARDLIGHT', 15, Blending_init_$Create$(tmp_34, tmp_35, tmp_36, tmp_37, null, null, 48, null));
    Companion_getInstance_147();
  }
  function BlendMode_0(name, ordinal, factors) {
    Enum.call(this, name, ordinal);
    this._factors = factors;
  }
  BlendMode_0.$metadata$ = {
    simpleName: 'BlendMode',
    kind: 'class',
    interfaces: []
  };
  function BlendMode_INHERIT_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_INHERIT_instance;
  }
  function BlendMode_NONE_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_NONE_instance;
  }
  function BlendMode_NORMAL_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_NORMAL_instance_0;
  }
  function BlendMode_ADD_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_ADD_instance;
  }
  function BlendMode_MULTIPLY_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_MULTIPLY_instance_0;
  }
  function BlendMode_SCREEN_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_SCREEN_instance_0;
  }
  function BlendMode_ERASE_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_ERASE_instance;
  }
  function BlendMode_MASK_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_MASK_instance;
  }
  function BlendMode_BELOW_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_BELOW_instance;
  }
  function BlendMode_SUBTRACT_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_SUBTRACT_instance;
  }
  function BlendMode_INVERT_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_INVERT_instance;
  }
  function BlendMode_LIGHTEN_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_LIGHTEN_instance_0;
  }
  function BlendMode_DARKEN_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_DARKEN_instance_0;
  }
  function BlendMode_DIFFERENCE_getInstance_0() {
    BlendMode_initEntries_0();
    return BlendMode_DIFFERENCE_instance_0;
  }
  function BlendMode_ALPHA_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_ALPHA_instance;
  }
  function BlendMode_HARDLIGHT_getInstance() {
    BlendMode_initEntries_0();
    return BlendMode_HARDLIGHT_instance;
  }
  function Circle_init_$Init$(radius, fill_3, stroke, strokeThickness, autoScaling, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      radius = 16.0;
    if (!(($mask0 & 2) === 0))
      fill_3 = new RGBA(Colors_getInstance()._WHITE);
    if (!(($mask0 & 4) === 0))
      stroke = new RGBA(Colors_getInstance()._WHITE);
    if (!(($mask0 & 8) === 0))
      strokeThickness = 0.0;
    if (!(($mask0 & 16) === 0))
      autoScaling = true;
    Circle.call($this, radius, fill_3, stroke, strokeThickness, autoScaling);
    return $this;
  }
  function Circle_init_$Create$(radius, fill_3, stroke, strokeThickness, autoScaling, $mask0, $marker) {
    return Circle_init_$Init$(radius, fill_3, stroke, strokeThickness, autoScaling, $mask0, $marker, Object.create(Circle.prototype));
  }
  function updateGraphics($this) {
    var tmp0__anonymous__1 = $this._internalShape;
    tmp0__anonymous__1.clear_33();
    circle_0(tmp0__anonymous__1, $this._get_radius_(), $this._get_radius_(), $this._get_radius_());
    $this._set_shape__1($this._internalShape);
  }
  function _no_name_provided__498(this$0) {
    this._this$0_149 = this$0;
  }
  _no_name_provided__498.prototype.invoke_882 = function (it) {
    updateGraphics(this._this$0_149);
  };
  _no_name_provided__498.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__498.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Circle(radius, fill_3, stroke, strokeThickness, autoScaling) {
    ShapeView.call(this, VectorPath_init_$Create$(null, null, null, 7, null), fill_3, stroke, strokeThickness, autoScaling);
    var tmp = this;
    var tmp0_uiObservable_0 = _no_name_provided_$factory_450(this);
    tmp._radius$delegate = new UIObservable(radius, tmp0_uiObservable_0);
    this._set_color__1(this._get_color__0());
    updateGraphics(this);
  }
  Circle.prototype._set_radius_ = function (_set___) {
    return this._radius$delegate.setValue_3(this, radius$factory(), _set___);
  };
  Circle.prototype._get_radius_ = function () {
    return this._radius$delegate.getValue_0(this, radius$factory_0());
  };
  Circle.prototype._set_color__1 = function (value) {
    this._set_colorMul__13(value);
  };
  Circle.prototype._get_color__0 = function () {
    return this._get_colorMul__21();
  };
  Circle.prototype._get_bwidth__7 = function () {
    return this._get_radius_() * 2;
  };
  Circle.prototype._get_bheight__7 = function () {
    return this._get_radius_() * 2;
  };
  Circle.$metadata$ = {
    simpleName: 'Circle',
    kind: 'class',
    interfaces: []
  };
  function radius$factory() {
    return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
      return receiver._get_radius_();
    }, function (receiver_0, value) {
      return receiver_0._set_radius_(value);
    });
  }
  function radius$factory_0() {
    return getPropertyCallableRef('radius', 1, KMutableProperty1, function (receiver) {
      return receiver._get_radius_();
    }, function (receiver_0, value) {
      return receiver_0._set_radius_(value);
    });
  }
  function _no_name_provided_$factory_450(this$0) {
    var i = new _no_name_provided__498(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function Container() {
    View.call(this, true);
    var tmp = this;
    tmp._tempMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._bb_1 = new BoundsBuilder();
    this._tempRect_5 = Companion_getInstance_83().invoke_1005();
  }
  Container.prototype._get_childrenInternal__8 = function () {
    if (this._get__children__9() == null)
      this._set__children__9(FastArrayList_init_$Create$());
    return ensureNotNull(this._get__children__9());
  };
  Container.prototype._get_children__24 = function () {
    return this._get_childrenInternal__8();
  };
  Container.prototype._get_firstChild__8 = function () {
    var tmp0_safe_receiver = this._get__children__9();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  };
  Container.prototype._get_numChildren__8 = function () {
    var children_0 = this._get__children__9();
    if (children_0 == null)
      return 0;
    return children_0._get_size__60();
  };
  Container.prototype.swapChildren_8 = function (view1, view2) {
    if (equals_1(view1._parent_5, view2._parent_5) ? equals_1(view1._parent_5, this) : false) {
      var index1 = view1._index_19;
      var index2 = view2._index_19;
      var tmp0_safe_receiver = this._get__children__9();
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.set_8(index1, view2);
      Unit_getInstance();
      view2._index_19 = index1;
      var tmp1_safe_receiver = this._get__children__9();
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver.set_8(index2, view1);
      Unit_getInstance();
      view1._index_19 = index2;
    }};
  Container.prototype.sendChildToBack_8 = function (view) {
    if (view._parent_5 === this) {
      while (!equals_1(view, ensureNotNull(this._get_firstChild__8()))) {
        this.swapChildren_8(view, this._get_children__24().get_137(view._index_19 - 1 | 0));
      }
    }};
  Container.prototype.getChildAt_8 = function (index) {
    return this._get_childrenInternal__8().get_137(index);
  };
  Container.prototype.removeChildren_8 = function () {
    var tmp0_safe_receiver = this._get__children__9();
    if (tmp0_safe_receiver == null)
      null;
    else {
      var n_1 = 0;
      while (n_1 < tmp0_safe_receiver._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp0__anonymous__3 = tmp0_safe_receiver.get_137(tmp0_2);
        tmp0__anonymous__3._parent_5 = null;
        tmp0__anonymous__3._index_19 = -1;
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp1_safe_receiver = this._get__children__9();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.clear_33();
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  Container.prototype.addChild_8 = function (view) {
    return this.plusAssign_12(view);
  };
  Container.prototype.plusAssign_12 = function (view) {
    view.removeFromParent_20();
    view._index_19 = this._get_numChildren__8();
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._get_childrenInternal__8();
    tmp0_plusAssign_0.add_39(view);
    Unit_getInstance();
    view._parent_5 = this;
    view.invalidate_23();
  };
  Container.prototype.get_137 = function (index) {
    return this.getChildAt_8(index);
  };
  Container.prototype.renderInternal_20 = function (ctx) {
    if (!this._get_visible__20())
      return Unit_getInstance();
    var tmp0_safe_receiver_1 = this.__children;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var n_1 = 0;
      while (n_1 < tmp0_safe_receiver_1._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp0__anonymous__2 = tmp0_safe_receiver_1.get_137(tmp0_2);
        tmp0__anonymous__2.render_23(ctx);
      }
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  Container.prototype.renderDebug_20 = function (ctx) {
    var tmp0_safe_receiver_1 = this.__children;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var n_1 = 0;
      while (n_1 < tmp0_safe_receiver_1._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp0__anonymous__2 = tmp0_safe_receiver_1.get_137(tmp0_2);
        tmp0__anonymous__2.renderDebug_20(ctx);
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    View.prototype.renderDebug_20.call(this, ctx);
  };
  Container.prototype.getLocalBoundsInternal_20 = function (out) {
    this._bb_1.reset_9();
    var tmp0_safe_receiver_1 = this.__children;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      var n_1 = 0;
      while (n_1 < tmp0_safe_receiver_1._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp0__anonymous__2 = tmp0_safe_receiver_1.get_137(tmp0_2);
        tmp0__anonymous__2.getBounds$default_23(this, this._tempRect_5, false, false, 12, null);
        Unit_getInstance();
        this._bb_1.add_46(this._tempRect_5);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    this._bb_1.getBounds_0(out);
    Unit_getInstance();
  };
  Container.$metadata$ = {
    simpleName: 'Container',
    kind: 'class',
    interfaces: []
  };
  function addTo(_this_, parent) {
    parent.plusAssign_12(_this_);
    return _this_;
  }
  function DummyView() {
    View_init_$Init$(this);
  }
  DummyView.prototype.renderInternal_20 = function (ctx) {
    return Unit_getInstance();
  };
  DummyView.$metadata$ = {
    simpleName: 'DummyView',
    kind: 'class',
    interfaces: []
  };
  function dummyView(_this_) {
    var tmp0_also_0 = new DummyView();
    _this_.addChild_8(tmp0_also_0);
    return tmp0_also_0;
  }
  function installFpsDebugOverlay(_this_) {
    var longWindow = new TimeSlidingWindow(240);
    var mediumWindow = new TimeSlidingWindow(60);
    var shortWindow = new TimeSlidingWindow(10);
    var previousTime = {_v: new TimeSpan(PerformanceCounter_getInstance()._get_reference_())};
    var frames = {_v: 0};
    var batchCount = {_v: 0};
    var vertexCount = {_v: 0};
    var tmp = _this_._get_views__7()._onBeforeRender;
    tmp.invoke_133(_no_name_provided_$factory_451(batchCount, vertexCount));
    Unit_getInstance();
    var tmp_0 = _this_._get_views__7()._renderContext._get_batch_()._beforeFlush;
    tmp_0.invoke_133(_no_name_provided_$factory_452(batchCount, vertexCount));
    Unit_getInstance();
    var tmp_1 = _this_._get_views__7();
    tmp_1.addDebugRenderer(_no_name_provided_$factory_453(previousTime, frames, longWindow, mediumWindow, shortWindow, batchCount, vertexCount));
  }
  function TimeSlidingWindow(capacity) {
    this._capacity_2 = capacity;
    this._deque = new IntDeque(this._capacity_2);
    this._totalMicroseconds = 0;
  }
  TimeSlidingWindow.prototype._get_size__60 = function () {
    return this._deque._get_size__60();
  };
  TimeSlidingWindow.prototype._get_avg_ = function () {
    var tmp0__get_microseconds__0 = this._totalMicroseconds / this._deque._get_size__60();
    return Companion_getInstance_27().fromMicroseconds(tmp0__get_microseconds__0);
  };
  TimeSlidingWindow.prototype._get_avgFps_ = function () {
    var tmp0__get_seconds__0 = 1;
    return TimeSpan__div_impl_0(Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0), this._get_avg_());
  };
  TimeSlidingWindow.prototype.get_125 = function (index) {
    var tmp0__get_microseconds__0 = this._deque.get_137(index);
    return Companion_getInstance_27().fromMicroseconds(tmp0__get_microseconds__0);
  };
  TimeSlidingWindow.prototype.add_82 = function (value) {
    var intValue = _TimeSpan___get_microsecondsInt__impl_(value);
    this._deque.add_29(intValue);
    Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._totalMicroseconds = tmp0_this._totalMicroseconds + intValue | 0;
    if (this._deque._get_size__60() > this._capacity_2) {
      var tmp1_this = this;
      tmp1_this._totalMicroseconds = tmp1_this._totalMicroseconds - this._deque.removeFirst_0() | 0;
    }};
  TimeSlidingWindow.$metadata$ = {
    simpleName: 'TimeSlidingWindow',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__499($batchCount, $vertexCount) {
    this._$batchCount = $batchCount;
    this._$vertexCount = $vertexCount;
  }
  _no_name_provided__499.prototype.invoke_909 = function (it) {
    this._$batchCount._v = 0;
    this._$vertexCount._v = 0;
  };
  _no_name_provided__499.prototype.invoke_1015 = function (p1) {
    this.invoke_909(p1 instanceof RenderContext ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__499.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__500($batchCount, $vertexCount) {
    this._$batchCount_0 = $batchCount;
    this._$vertexCount_0 = $vertexCount;
  }
  _no_name_provided__500.prototype.invoke_868 = function (it) {
    var tmp0 = this._$batchCount_0._v;
    this._$batchCount_0._v = tmp0 + 1 | 0;
    Unit_getInstance();
    this._$vertexCount_0._v = this._$vertexCount_0._v + it._vertexCount_0 | 0;
  };
  _no_name_provided__500.prototype.invoke_1015 = function (p1) {
    this.invoke_868(p1 instanceof BatchBuilder2D ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__500.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function invoke$drawTextWithShadow($ctx, $fontSize, text, x, y) {
    var tmp = _get_debugBmpFont_();
    var tmp_0 = x + 1 | 0;
    var tmp_1 = y + 1 | 0;
    var tmp_2 = Colors_getInstance()._BLACK;
    drawText$default($ctx, tmp, $fontSize, text, tmp_0, tmp_1, null, tmp_2, null, null, false, 928, null);
    var tmp_3 = _get_debugBmpFont_();
    var tmp_4 = Colors_getInstance()._WHITE;
    drawText$default($ctx, tmp_3, $fontSize, text, x, y, null, tmp_4, null, null, false, 928, null);
  }
  function _no_name_provided__501($previousTime, $frames, $longWindow, $mediumWindow, $shortWindow, $batchCount, $vertexCount) {
    this._$previousTime = $previousTime;
    this._$frames = $frames;
    this._$longWindow = $longWindow;
    this._$mediumWindow = $mediumWindow;
    this._$shortWindow = $shortWindow;
    this._$batchCount_1 = $batchCount;
    this._$vertexCount_1 = $vertexCount;
  }
  _no_name_provided__501.prototype.invoke_870 = function ($this$addDebugRenderer, ctx) {
    var scale_1 = ctx._ag_5._get_devicePixelRatio__4();
    var fontSize = 8.0 * scale_1;
    var currentTime = PerformanceCounter_getInstance()._get_reference_();
    var elapsedTime = TimeSpan__minus_impl(currentTime, this._$previousTime._v._milliseconds);
    if (this._$frames._v > 3) {
      var tmp0__get_milliseconds__0 = 4;
      if (TimeSpan__compareTo_impl(elapsedTime, Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0)) > 0) {
        this._$longWindow.add_82(elapsedTime);
        this._$mediumWindow.add_82(elapsedTime);
        this._$shortWindow.add_82(elapsedTime);
      } else {
      }
    }var tmp0 = this._$frames._v;
    this._$frames._v = tmp0 + 1 | 0;
    Unit_getInstance();
    this._$previousTime._v = new TimeSpan(currentTime);
    invoke$drawTextWithShadow(ctx, fontSize, 'FPS: ' + ('' + roundDecimalPlaces(this._$shortWindow._get_avgFps_(), 1)) + ('' + ', batchCount=' + this._$batchCount_1._v + ', vertexCount=' + this._$vertexCount_1._v), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale_1;
    var overlayHeight = 30 * scale_1;
    var overlayHeightGap = 5.0;
    var tmp1_color_0 = _get_debugLineRenderContext_($this$addDebugRenderer._renderContext);
    var tmp2_color_0 = Colors_getInstance()._YELLOW;
    var oldColor_1 = tmp1_color_0._color_2;
    tmp1_color_0._color_2 = tmp2_color_0;
    try {
      _get_debugLineRenderContext_($this$addDebugRenderer._renderContext).line_1(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
      _get_debugLineRenderContext_($this$addDebugRenderer._renderContext).line_1(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
    }finally {
      tmp1_color_0._color_2 = oldColor_1;
    }
    var tmp3_color_0 = _get_debugLineRenderContext_($this$addDebugRenderer._renderContext);
    var tmp4_color_0 = Colors_getInstance()._WHITE;
    var oldColor_1_0 = tmp3_color_0._color_2;
    tmp3_color_0._color_2 = tmp4_color_0;
    try {
      var ratio_3 = this._$longWindow._get_size__60() / this._$longWindow._capacity_2;
      var totalOverlayLines_4 = coerceAtLeast(numberToInt(overlayLines * ratio_3), 1);
      if (this._$longWindow._get_size__60() > 0) {
        var previousX_5 = 0.0;
        var previousY_6 = 0.0;
        var minFps_7 = 0.0;
        var maxFps_8 = 150.0;
        var inductionVariable = 0;
        if (inductionVariable < totalOverlayLines_4)
          do {
            var n_10 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var p0_2_12 = convertRange(n_10, 0, totalOverlayLines_4, 0, coerceAtLeast(this._$longWindow._get_size__60(), 1));
            var p1_3_13 = convertRange(n_10 + 1 | 0, 0, totalOverlayLines_4, 0, coerceAtLeast(this._$longWindow._get_size__60(), 1));
            var plen_4_14 = 0;
            var tmp0__get_milliseconds__0_6_16 = 0;
            var timeSum_5_15 = Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0_6_16);
            var inductionVariable_0 = p0_2_12;
            var last_1 = coerceAtMost(p1_3_13, this._$longWindow._get_size__60());
            if (inductionVariable_0 < last_1)
              do {
                var m_8_18 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                timeSum_5_15 = TimeSpan__plus_impl(timeSum_5_15, this._$longWindow.get_125(m_8_18));
                var tmp1_9_19 = plen_4_14;
                plen_4_14 = tmp1_9_19 + 1 | 0;
                Unit_getInstance();
              }
               while (inductionVariable_0 < last_1);
            if (plen_4_14 === 0) {
              timeSum_5_15 = TimeSpan__plus_impl(timeSum_5_15, this._$longWindow.get_125(p0_2_12));
              var tmp2_10_20 = plen_4_14;
              plen_4_14 = tmp2_10_20 + 1 | 0;
              Unit_getInstance();
            }var time_11_21 = TimeSpan__div_impl(timeSum_5_15, plen_4_14);
            var fps_12_22 = _Frequency___get_hertz__impl_(toFrequency(time_11_21));
            var fps_11 = fps_12_22;
            var scaledFreq_23 = convertRange_0(fps_11, minFps_7, maxFps_8, overlayHeightGap, overlayHeight);
            var y_24 = graphTop + overlayHeight - scaledFreq_23;
            var x_25 = graphLeft + n_10 * overlayWidth / overlayLines;
            if (n_10 > 0) {
              _get_debugLineRenderContext_($this$addDebugRenderer._renderContext).line_1(previousX_5, previousY_6, x_25, y_24);
            }previousY_6 = y_24;
            previousX_5 = x_25;
          }
           while (inductionVariable < totalOverlayLines_4);
      }}finally {
      tmp3_color_0._color_2 = oldColor_1_0;
    }
  };
  _no_name_provided__501.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof Views ? p1 : THROW_CCE();
    this.invoke_870(tmp, p2 instanceof RenderContext ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__501.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_451($batchCount, $vertexCount) {
    var i = new _no_name_provided__499($batchCount, $vertexCount);
    return function (p1) {
      i.invoke_909(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_452($batchCount, $vertexCount) {
    var i = new _no_name_provided__500($batchCount, $vertexCount);
    return function (p1) {
      i.invoke_868(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_453($previousTime, $frames, $longWindow, $mediumWindow, $shortWindow, $batchCount, $vertexCount) {
    var i = new _no_name_provided__501($previousTime, $frames, $longWindow, $mediumWindow, $shortWindow, $batchCount, $vertexCount);
    return function (p1, p2) {
      i.invoke_870(p1, p2);
      return Unit_getInstance();
    };
  }
  function setStrokeInfo($this, info) {
    $this._thickness_1 = info._thickness_0;
    $this._pixelHinting_1 = info._pixelHinting_0;
    $this._scaleMode_3 = info._scaleMode_0;
    $this._startCap_1 = info._startCap_0;
    $this._endCap_1 = info._endCap_0;
    $this._lineJoin_2 = info._lineJoin_1;
    $this._miterLimit_3 = info._miterLimit_2;
  }
  function _no_name_provided__502() {
  }
  _no_name_provided__502.prototype.invoke_872 = function (it) {
    it.clear_33();
  };
  _no_name_provided__502.prototype.invoke_1015 = function (p1) {
    this.invoke_872(p1 instanceof GraphicsPath ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__502.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__503() {
  }
  _no_name_provided__503.prototype.invoke_874 = function (it) {
    return GraphicsPath_init_$Create$(null, null, null, 7, null);
  };
  _no_name_provided__503.prototype.invoke_1015 = function (p1) {
    return this.invoke_874((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__503.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Graphics(autoScaling) {
    BaseGraphics.call(this, autoScaling);
    var tmp = this;
    var tmp_0 = _no_name_provided_$factory_454();
    tmp._graphicsPathPool = Pool_init_$Create$(tmp_0, 0, _no_name_provided_$factory_455(), 2, null);
    this._shapeVersion = 0;
    var tmp_1 = this;
    tmp_1._shapes = ArrayList_init_$Create$();
    this._compoundShape = new CompoundShape(this._shapes);
    this._fill_0 = null;
    this._stroke = null;
    this._currentPath = this._graphicsPathPool.alloc();
    this._hitShapeVersion = -1;
    this._hitShapeAnchorVersion = -1;
    var tmp_2 = this;
    tmp_2._tempVectorPaths = ArrayList_init_$Create$();
    var tmp_3 = this;
    tmp_3._tempMatrix_0 = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._customHitShapes = null;
    this._thickness_1 = 1.0;
    this._pixelHinting_1 = false;
    this._scaleMode_3 = LineScaleMode_NORMAL_getInstance();
    this._startCap_1 = LineCap_BUTT_getInstance();
    this._endCap_1 = LineCap_BUTT_getInstance();
    this._lineJoin_2 = LineJoin_MITER_getInstance();
    this._miterLimit_3 = 4.0;
    this._set_hitTestUsingShapes__3(true);
  }
  Graphics.prototype._set_hitShape__8 = function (value) {
    var tmp = this;
    var tmp0_safe_receiver_2 = value;
    var tmp_0;
    if (tmp0_safe_receiver_2 == null) {
      tmp_0 = null;
    } else {
      tmp_0 = listOf_0(tmp0_safe_receiver_2);
    }
    tmp._customHitShapes = tmp_0;
    return Unit_getInstance();
  };
  Graphics.prototype._get_hitShape__20 = function () {
    var tmp0_safe_receiver = this._get_hitShapes__20();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  };
  Graphics.prototype._get_hitShapes__20 = function () {
    if (!(this._customHitShapes == null))
      return this._customHitShapes;
    if (!(this._hitShapeVersion === this._shapeVersion)) {
      this._hitShapeVersion = this._shapeVersion;
      this._tempVectorPaths.clear_33();
      var tmp0_iterator = this._shapes.iterator_67();
      while (tmp0_iterator.hasNext_33()) {
        var shape = tmp0_iterator.next_37();
        var tmp = this._tempVectorPaths;
        tmp.add_39(shape.getPath$default(null, 1, null));
        Unit_getInstance();
      }
    }return this._tempVectorPaths;
  };
  Graphics.prototype.clear_33 = function () {
    var tmp0_forEach_0 = this._shapes;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_67();
    while (tmp0_iterator_1.hasNext_33()) {
      var element_2 = tmp0_iterator_1.next_37();
      var tmp0_safe_receiver_5 = isInterface(element_2, StyledShape) ? element_2 : null;
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_5 == null ? null : tmp0_safe_receiver_5._get_path__5();
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        this._graphicsPathPool.free(tmp1_safe_receiver_4);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    this._shapes.clear_33();
    this._currentPath.clear_33();
  };
  Graphics.prototype._get_lastX__7 = function () {
    return this._currentPath._get_lastX__7();
  };
  Graphics.prototype._get_lastY__7 = function () {
    return this._currentPath._get_lastY__7();
  };
  Graphics.prototype._get_totalPoints__7 = function () {
    return this._currentPath._get_totalPoints__7();
  };
  Graphics.prototype.close_77 = function () {
    return this._currentPath.close_77();
  };
  Graphics.prototype.cubicTo_7 = function (cx1, cy1, cx2, cy2, ax, ay) {
    this._currentPath.cubicTo_7(cx1, cy1, cx2, cy2, ax, ay);
  };
  Graphics.prototype.lineTo_9 = function (x, y) {
    this._currentPath.lineTo_9(x, y);
  };
  Graphics.prototype.moveTo_9 = function (x, y) {
    this._currentPath.moveTo_9(x, y);
  };
  Graphics.prototype.quadTo_7 = function (cx, cy, ax, ay) {
    this._currentPath.quadTo_7(cx, cy, ax, ay);
  };
  Graphics.prototype.beginFill_2 = function (paint) {
    this._set_dirty__7(true);
    this._fill_0 = paint;
    this._currentPath.clear_33();
    return this;
  };
  Graphics.prototype.beginStroke_2 = function (paint, info) {
    this._set_dirty__7(true);
    setStrokeInfo(this, info);
    this._stroke = paint;
    this._currentPath.clear_33();
    return this;
  };
  Graphics.prototype.endFill_2 = function () {
    this._set_dirty__7(true);
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._shapes;
    var tmp = this._currentPath;
    var tmp1_elvis_lhs_5 = this._fill_0;
    var tmp_0 = tmp1_elvis_lhs_5 == null ? new RGBA(Companion_getInstance_104().invoke_378(Colors_getInstance()._RED)) : tmp1_elvis_lhs_5;
    var tmp1_plusAssign_0_4 = new FillShape(tmp, null, tmp_0, Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null));
    tmp0_plusAssign_0_3.add_39(tmp1_plusAssign_0_4);
    Unit_getInstance();
    this._currentPath = this._graphicsPathPool.alloc();
    var tmp2_this_6 = this;
    var tmp3_7 = tmp2_this_6._shapeVersion;
    tmp2_this_6._shapeVersion = tmp3_7 + 1 | 0;
    Unit_getInstance();
    return this;
  };
  Graphics.prototype.endStroke_2 = function () {
    this._set_dirty__7(true);
    var tmp0_this_2 = this;
    var tmp0_plusAssign_0_3 = tmp0_this_2._shapes;
    var tmp = this._currentPath;
    var tmp1_elvis_lhs_5 = this._stroke;
    var tmp_0 = tmp1_elvis_lhs_5 == null ? new RGBA(Companion_getInstance_104().invoke_378(Colors_getInstance()._RED)) : tmp1_elvis_lhs_5;
    var tmp1_plusAssign_0_4 = new PolylineShape(tmp, null, tmp_0, Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null), this._thickness_1, this._pixelHinting_1, this._scaleMode_3, this._startCap_1, this._endCap_1, this._lineJoin_2, this._miterLimit_3);
    tmp0_plusAssign_0_3.add_39(tmp1_plusAssign_0_4);
    Unit_getInstance();
    this._currentPath = this._graphicsPathPool.alloc();
    var tmp2_this_6 = this;
    var tmp3_7 = tmp2_this_6._shapeVersion;
    tmp2_this_6._shapeVersion = tmp3_7 + 1 | 0;
    Unit_getInstance();
    return this;
  };
  Graphics.prototype.drawShape_3 = function (ctx) {
    this._compoundShape.draw_10(ctx);
  };
  Graphics.prototype.getShapeBounds_3 = function (bb) {
    var tmp0_fastForEach_0 = this._shapes;
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      tmp1__anonymous__3.addBounds_3(bb);
    }
  };
  Graphics.$metadata$ = {
    simpleName: 'Graphics',
    kind: 'class',
    interfaces: [VectorBuilder]
  };
  function _no_name_provided_$factory_454() {
    var i = new _no_name_provided__502();
    return function (p1) {
      i.invoke_872(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_455() {
    var i = new _no_name_provided__503();
    return function (p1) {
      return i.invoke_874(p1);
    };
  }
  function Image_init_$Init$(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      anchorX = 0.0;
    if (!(($mask0 & 4) === 0))
      anchorY = anchorX;
    if (!(($mask0 & 8) === 0))
      hitShape = null;
    if (!(($mask0 & 16) === 0))
      smoothing = true;
    Image.call($this, bitmap, anchorX, anchorY, hitShape, smoothing);
    return $this;
  }
  function Image_init_$Create$(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker) {
    return Image_init_$Init$(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, Object.create(Image.prototype));
  }
  function Image_init_$Init$_0(bitmap, anchorX, anchorY, hitShape, smoothing, $this) {
    Image.call($this, slice$default(bitmap, null, null, 3, null), anchorX, anchorY, hitShape, smoothing);
    return $this;
  }
  function Image_init_$Init$_1(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      anchorX = 0.0;
    if (!(($mask0 & 4) === 0))
      anchorY = anchorX;
    if (!(($mask0 & 8) === 0))
      hitShape = null;
    if (!(($mask0 & 16) === 0))
      smoothing = true;
    Image_init_$Init$_0(bitmap, anchorX, anchorY, hitShape, smoothing, $this);
    return $this;
  }
  function Image_init_$Create$_0(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker) {
    return Image_init_$Init$_1(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, Object.create(Image.prototype));
  }
  function $forceLoadSourceFileCOROUTINE$28(_this_, views, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__160 = _this_;
    this._views_7 = views;
    this._currentVfs = currentVfs;
    this._sourceFile = sourceFile;
  }
  $forceLoadSourceFileCOROUTINE$28.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 5;
            this._state_1 = 1;
            suspendResult = this.__this__160.baseForceLoadSourceFile_0(this.__this__160, this._views_7, this._currentVfs, this._sourceFile, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._exceptionState = 3;
            this._state_1 = 2;
            var tmp_0 = this._currentVfs.get_115('' + this._sourceFile);
            suspendResult = readBitmapSlice$default(tmp_0, false, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.__this__160._set_bitmap__5(ARGUMENT);
            this.__this__160._set_scale__20(1.0);
            this._exceptionState = 5;
            this._state_1 = 4;
            continue $sm;
          case 3:
            this._exceptionState = 5;
            var tmp_1 = this._exception_0;
            if (tmp_1 instanceof Error) {
              var e = this._exception_0;
              this.__this__160._set_bitmap__5(Bitmaps_getInstance()._white);
              this.__this__160._set_scale__20(100.0);
              this._state_1 = 4;
              continue $sm;
            } else {
              {
                throw this._exception_0;
              }
            }

            break;
          case 4:
            this._exceptionState = 5;
            return Unit_getInstance();
          case 5:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 5) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadSourceFileCOROUTINE$28.$metadata$ = {
    simpleName: '$forceLoadSourceFileCOROUTINE$28',
    kind: 'class',
    interfaces: []
  };
  function Image(bitmap, anchorX, anchorY, hitShape, smoothing) {
    BaseImage.call(this, bitmap, anchorX, anchorY, hitShape, smoothing);
    this._$$delegate_0_23 = new Mixin_2();
  }
  Image.prototype.lazyLoadRenderInternal_0 = function (ctx, view) {
    this._$$delegate_0_23.lazyLoadRenderInternal_0(ctx, view);
  };
  Image.prototype._set_sourceFile__1 = function (_set___) {
    this._$$delegate_0_23._set_sourceFile__1(_set___);
  };
  Image.prototype._set_sourceTreeLoaded__1 = function (_set___) {
    this._$$delegate_0_23._sourceTreeLoaded = _set___;
  };
  Image.prototype.baseForceLoadSourceFile_0 = function (_this__0, views, currentVfs, sourceFile, $cont) {
    return this._$$delegate_0_23.baseForceLoadSourceFile_0(_this__0, views, currentVfs, sourceFile, $cont);
  };
  Image.prototype.renderInternal_20 = function (ctx) {
    this.lazyLoadRenderInternal_0(ctx, this);
    BaseImage.prototype.renderInternal_20.call(this, ctx);
  };
  Image.prototype.forceLoadSourceFile_1 = function (views, currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadSourceFileCOROUTINE$28(this, views, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Image.$metadata$ = {
    simpleName: 'Image',
    kind: 'class',
    interfaces: [ViewFileRef]
  };
  function BaseImage_init_$Init$(bitmap, anchorX, anchorY, hitShape, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      anchorX = 0.0;
    if (!(($mask0 & 4) === 0))
      anchorY = anchorX;
    if (!(($mask0 & 8) === 0))
      hitShape = null;
    if (!(($mask0 & 16) === 0))
      smoothing = true;
    BaseImage.call($this, bitmap, anchorX, anchorY, hitShape, smoothing);
    return $this;
  }
  function BaseImage(bitmap, anchorX, anchorY, hitShape, smoothing) {
    RectBase.call(this, anchorX, anchorY, hitShape, smoothing);
    this._setBitmapSource = false;
    this._bitmapSrc = bitmap;
    this.trySetSource_5();
  }
  BaseImage.prototype._set_bitmap__5 = function (value) {
    this._setBitmapSource = true;
    this._set_baseBitmap__6(value);
  };
  BaseImage.prototype._get_bitmap__5 = function () {
    return this._get_baseBitmap__6();
  };
  BaseImage.prototype.trySetSource_5 = function () {
    if (this._setBitmapSource)
      return Unit_getInstance();
    var source = this._bitmapSrc.getOrNull_4();
    if (!(source == null)) {
      this._setBitmapSource = true;
      this._set_baseBitmap__6(source);
    }};
  BaseImage.prototype.renderInternal_20 = function (ctx) {
    this.trySetSource_5();
    RectBase.prototype.renderInternal_20.call(this, ctx);
  };
  BaseImage.prototype._get_bwidth__7 = function () {
    return this._get_baseBitmap__6()._get_width__58();
  };
  BaseImage.prototype._get_bheight__7 = function () {
    return this._get_baseBitmap__6()._get_height__58();
  };
  BaseImage.prototype._get_anchorDispX__20 = function () {
    return this._get_anchorX__7() * this._get_baseBitmap__6()._frameWidth - this._get_baseBitmap__6()._frameOffsetX;
  };
  BaseImage.prototype._get_anchorDispY__20 = function () {
    return this._get_anchorY__7() * this._get_baseBitmap__6()._frameHeight - this._get_baseBitmap__6()._frameOffsetY;
  };
  BaseImage.prototype.toString = function () {
    return RectBase.prototype.toString.call(this) + ('' + ':bitmap=' + this._get_bitmap__5());
  };
  BaseImage.$metadata$ = {
    simpleName: 'BaseImage',
    kind: 'class',
    interfaces: []
  };
  function NinePatch(tex, width, height, left, top, right, bottom) {
    View_init_$Init$(this);
    this._tex_0 = tex;
    this._width_19 = width;
    this._height_19 = height;
    this._left_5 = left;
    this._top_1 = top;
    this._right_2 = right;
    this._bottom_1 = bottom;
    this._smoothing = true;
    this._sLeft = 0.0;
    this._sTop = 0.0;
    var tmp = this;
    var tmp0_arrayOf_0 = [Point_init_$Create$_0(0, 0), new Point(this._left_5, this._top_1), new Point(1.0 - this._right_2, 1.0 - this._bottom_1), new Point(1.0, 1.0)];
    tmp._posCuts = tmp0_arrayOf_0;
    var tmp_0 = this;
    var tmp0_arrayOf_0_0 = [Point_init_$Create$_0(0, 0), new Point(this._left_5, this._top_1), new Point(1.0 - this._right_2, 1.0 - this._bottom_1), new Point(1.0, 1.0)];
    tmp_0._texCuts = tmp0_arrayOf_0_0;
  }
  NinePatch.prototype._set_width__27 = function (_set___) {
    this._width_19 = _set___;
  };
  NinePatch.prototype._get_width__58 = function () {
    return this._width_19;
  };
  NinePatch.prototype._set_height__27 = function (_set___) {
    this._height_19 = _set___;
  };
  NinePatch.prototype._get_height__58 = function () {
    return this._height_19;
  };
  NinePatch.prototype.renderInternal_20 = function (ctx) {
    if (!this._get_visible__20())
      return Unit_getInstance();
    var texLeftWidth = this._tex_0._get_width__58() * this._left_5;
    var texTopHeight = this._tex_0._get_height__58() * this._top_1;
    var texRighttWidth = this._tex_0._get_width__58() * this._right_2;
    var texBottomHeight = this._tex_0._get_height__58() * this._bottom_1;
    var ratioX = this._width_19 < this._tex_0._get_width__58() ? this._width_19 / this._tex_0._get_width__58() : 1.0;
    var ratioY = this._height_19 < this._tex_0._get_height__58() ? this._height_19 / this._tex_0._get_height__58() : 1.0;
    var actualRatioX = min2_9(ratioX, ratioY);
    var actualRatioY = min2_9(ratioX, ratioY);
    this._posCuts[1].setTo_0(texLeftWidth * actualRatioX / this._width_19, texTopHeight * actualRatioY / this._height_19);
    Unit_getInstance();
    this._posCuts[2].setTo_0(1.0 - texRighttWidth * actualRatioX / this._width_19, 1.0 - texBottomHeight * actualRatioY / this._height_19);
    Unit_getInstance();
    var tmp0_tex = ctx.getTex(this._tex_0);
    var tmp1_x = this._sLeft;
    var tmp2_y = this._sTop;
    var tmp3_width = this._width_19;
    var tmp4_height = this._height_19;
    var tmp5_posCuts = this._posCuts;
    var tmp6_texCuts = this._texCuts;
    var tmp7_m = this._get_globalMatrix__20();
    var tmp8_colorMul = this._get_renderColorMul__20();
    var tmp9_colorAdd = this._get_renderColorAdd__20();
    var tmp10_filtering = this._smoothing;
    var tmp11_blendFactors = this._get_renderBlendMode__19()._factors;
    var tmp = ctx._get_batch_();
    tmp.drawNinePatch$default(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp5_posCuts, tmp6_texCuts, tmp7_m, tmp10_filtering, tmp8_colorMul, tmp9_colorAdd, tmp11_blendFactors, null, 4096, null);
  };
  NinePatch.prototype.getLocalBoundsInternal_20 = function (out) {
    out.setTo_2(this._sLeft, this._sTop, this._width_19, this._height_19);
    Unit_getInstance();
  };
  NinePatch.$metadata$ = {
    simpleName: 'NinePatch',
    kind: 'class',
    interfaces: []
  };
  function RectBase_init_$Init$(anchorX, anchorY, hitShape, smoothing, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      anchorX = 0.0;
    if (!(($mask0 & 2) === 0))
      anchorY = anchorX;
    if (!(($mask0 & 4) === 0))
      hitShape = null;
    if (!(($mask0 & 8) === 0))
      smoothing = true;
    RectBase.call($this, anchorX, anchorY, hitShape, smoothing);
    return $this;
  }
  function computeVertexIfRequired($this) {
    if (!$this._get_dirtyVertices__8())
      return Unit_getInstance();
    $this._set_dirtyVertices__8(false);
    $this._vertices_3.quad(0, $this._get_sLeft__7(), $this._get_sTop__7(), $this._get_bwidth__7(), $this._get_bheight__7(), $this._get_globalMatrix__20(), $this._baseBitmap, $this._get_renderColorMul__20(), $this._get_renderColorAdd__20());
  }
  function RectBase(anchorX, anchorY, hitShape, smoothing) {
    View_init_$Init$(this);
    this._smoothing_0 = smoothing;
    this._set_hitShape__8(hitShape);
    this._anchorVersion = 0;
    this._baseBitmap = Bitmaps_getInstance()._white;
    this._anchorX = anchorX;
    this._anchorY = anchorY;
    var tmp = this;
    var tmp_0 = Companion_getInstance_144()._QUAD_INDICES;
    tmp._vertices_3 = TexturedVertexArray_init_$Create$(4, tmp_0, 0, 4, null);
  }
  RectBase.prototype._set_smoothing__0 = function (_set___) {
    this._smoothing_0 = _set___;
  };
  RectBase.prototype._set_baseBitmap__6 = function (v) {
    if (!(this._baseBitmap === v)) {
      this._baseBitmap = v;
      this._set_dirtyVertices__8(true);
    }};
  RectBase.prototype._get_baseBitmap__6 = function () {
    return this._baseBitmap;
  };
  RectBase.prototype._set_anchorX__8 = function (v) {
    this._anchorX = v;
    this._set_dirtyVertices__8(true);
    var tmp0_this = this;
    var tmp1 = tmp0_this._anchorVersion;
    tmp0_this._anchorVersion = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  RectBase.prototype._get_anchorX__7 = function () {
    return this._anchorX;
  };
  RectBase.prototype._set_anchorY__8 = function (v) {
    this._anchorY = v;
    this._set_dirtyVertices__8(true);
    var tmp0_this = this;
    var tmp1 = tmp0_this._anchorVersion;
    tmp0_this._anchorVersion = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  RectBase.prototype._get_anchorY__7 = function () {
    return this._anchorY;
  };
  RectBase.prototype._get_bwidth__7 = function () {
    return 0.0;
  };
  RectBase.prototype._get_bheight__7 = function () {
    return 0.0;
  };
  RectBase.prototype._get_anchorDispX__20 = function () {
    return this._get_anchorX__7() * this._get_bwidth__7();
  };
  RectBase.prototype._get_anchorDispY__20 = function () {
    return this._get_anchorY__7() * this._get_bheight__7();
  };
  RectBase.prototype._get_sLeft__7 = function () {
    return -this._get_anchorDispX__20();
  };
  RectBase.prototype._get_sTop__7 = function () {
    return -this._get_anchorDispY__20();
  };
  RectBase.prototype.renderInternal_20 = function (ctx) {
    if (!this._get_visible__20())
      return Unit_getInstance();
    if (!(this._baseBitmap === Bitmaps_getInstance()._transparent)) {
      computeVertexIfRequired(this);
      var tmp = ctx._get_batch_();
      var tmp_0 = ctx.getTex(this._baseBitmap)._base_6;
      var tmp_1 = this._smoothing_0;
      var tmp_2 = this._get_renderBlendMode__19()._factors;
      tmp.drawVertices$default(this._vertices_3, tmp_0, tmp_1, tmp_2, 0, 0, null, 112, null);
    }};
  RectBase.prototype.getLocalBoundsInternal_20 = function (out) {
    out.setTo_2(this._get_sLeft__7(), this._get_sTop__7(), this._get_bwidth__7(), this._get_bheight__7());
    Unit_getInstance();
  };
  RectBase.prototype.toString = function () {
    var out = View.prototype.toString.call(this);
    if (!(this._get_anchorX__7() === 0.0) ? true : !(this._get_anchorY__7() === 0.0))
      out = out + ('' + ':anchor=(' + this._get_str__23(this._get_anchorX__7()) + ', ' + this._get_str__23(this._get_anchorY__7()) + ')');
    return out;
  };
  RectBase.$metadata$ = {
    simpleName: 'RectBase',
    kind: 'class',
    interfaces: [Anchorable]
  };
  function Renderable() {
  }
  Renderable.$metadata$ = {
    simpleName: 'Renderable',
    kind: 'interface',
    interfaces: []
  };
  function updateGraphics_0($this) {
    var tmp0__anonymous__1 = $this._internalShape;
    tmp0__anonymous__1.clear_33();
    roundRect(tmp0__anonymous__1, 0.0, 0.0, $this._get_width__58(), $this._get_height__58(), $this._get_rx_(), $this._get_ry_());
    $this._set_shape__1($this._internalShape);
  }
  function _no_name_provided__504(this$0) {
    this._this$0_150 = this$0;
  }
  _no_name_provided__504.prototype.invoke_882 = function (it) {
    updateGraphics_0(this._this$0_150);
  };
  _no_name_provided__504.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__504.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__505(this$0) {
    this._this$0_151 = this$0;
  }
  _no_name_provided__505.prototype.invoke_882 = function (it) {
    updateGraphics_0(this._this$0_151);
  };
  _no_name_provided__505.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__505.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__506(this$0) {
    this._this$0_152 = this$0;
  }
  _no_name_provided__506.prototype.invoke_882 = function (it) {
    updateGraphics_0(this._this$0_152);
  };
  _no_name_provided__506.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__506.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__507(this$0) {
    this._this$0_153 = this$0;
  }
  _no_name_provided__507.prototype.invoke_882 = function (it) {
    updateGraphics_0(this._this$0_153);
  };
  _no_name_provided__507.prototype.invoke_1015 = function (p1) {
    this.invoke_882((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__507.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function RoundRect(width, height, rx, ry, fill_3, stroke, strokeThickness, autoScaling) {
    ShapeView.call(this, VectorPath_init_$Create$(null, null, null, 7, null), fill_3, stroke, strokeThickness, autoScaling);
    var tmp = this;
    var tmp0_uiObservable_0 = _no_name_provided_$factory_456(this);
    tmp._width$delegate_0 = new UIObservable(width, tmp0_uiObservable_0);
    var tmp_0 = this;
    var tmp0_uiObservable_0_0 = _no_name_provided_$factory_457(this);
    tmp_0._height$delegate_0 = new UIObservable(height, tmp0_uiObservable_0_0);
    var tmp_1 = this;
    var tmp0_uiObservable_0_1 = _no_name_provided_$factory_458(this);
    tmp_1._rx$delegate = new UIObservable(rx, tmp0_uiObservable_0_1);
    var tmp_2 = this;
    var tmp0_uiObservable_0_2 = _no_name_provided_$factory_459(this);
    tmp_2._ry$delegate = new UIObservable(ry, tmp0_uiObservable_0_2);
    this._set_colorMul__13(this._get_color__0());
    updateGraphics_0(this);
  }
  RoundRect.prototype._set_width__27 = function (_set___) {
    return this._width$delegate_0.setValue_3(this, width$factory_4(), _set___);
  };
  RoundRect.prototype._get_width__58 = function () {
    return this._width$delegate_0.getValue_0(this, width$factory_5());
  };
  RoundRect.prototype._set_height__27 = function (_set___) {
    return this._height$delegate_0.setValue_3(this, height$factory_4(), _set___);
  };
  RoundRect.prototype._get_height__58 = function () {
    return this._height$delegate_0.getValue_0(this, height$factory_5());
  };
  RoundRect.prototype._get_bwidth__7 = function () {
    return this._get_width__58();
  };
  RoundRect.prototype._get_bheight__7 = function () {
    return this._get_height__58();
  };
  RoundRect.prototype._set_rx_ = function (_set___) {
    return this._rx$delegate.setValue_3(this, rx$factory(), _set___);
  };
  RoundRect.prototype._get_rx_ = function () {
    return this._rx$delegate.getValue_0(this, rx$factory_0());
  };
  RoundRect.prototype._set_ry_ = function (_set___) {
    return this._ry$delegate.setValue_3(this, ry$factory(), _set___);
  };
  RoundRect.prototype._get_ry_ = function () {
    return this._ry$delegate.getValue_0(this, ry$factory_0());
  };
  RoundRect.prototype._get_color__0 = function () {
    return this._get_colorMul__21();
  };
  RoundRect.$metadata$ = {
    simpleName: 'RoundRect',
    kind: 'class',
    interfaces: []
  };
  function width$factory_4() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__58();
    }, function (receiver_0, value) {
      return receiver_0._set_width__27(value);
    });
  }
  function width$factory_5() {
    return getPropertyCallableRef('width', 1, KMutableProperty1, function (receiver) {
      return receiver._get_width__58();
    }, function (receiver_0, value) {
      return receiver_0._set_width__27(value);
    });
  }
  function height$factory_4() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__58();
    }, function (receiver_0, value) {
      return receiver_0._set_height__27(value);
    });
  }
  function height$factory_5() {
    return getPropertyCallableRef('height', 1, KMutableProperty1, function (receiver) {
      return receiver._get_height__58();
    }, function (receiver_0, value) {
      return receiver_0._set_height__27(value);
    });
  }
  function rx$factory() {
    return getPropertyCallableRef('rx', 1, KMutableProperty1, function (receiver) {
      return receiver._get_rx_();
    }, function (receiver_0, value) {
      return receiver_0._set_rx_(value);
    });
  }
  function rx$factory_0() {
    return getPropertyCallableRef('rx', 1, KMutableProperty1, function (receiver) {
      return receiver._get_rx_();
    }, function (receiver_0, value) {
      return receiver_0._set_rx_(value);
    });
  }
  function ry$factory() {
    return getPropertyCallableRef('ry', 1, KMutableProperty1, function (receiver) {
      return receiver._get_ry_();
    }, function (receiver_0, value) {
      return receiver_0._set_ry_(value);
    });
  }
  function ry$factory_0() {
    return getPropertyCallableRef('ry', 1, KMutableProperty1, function (receiver) {
      return receiver._get_ry_();
    }, function (receiver_0, value) {
      return receiver_0._set_ry_(value);
    });
  }
  function _no_name_provided_$factory_456(this$0) {
    var i = new _no_name_provided__504(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_457(this$0) {
    var i = new _no_name_provided__505(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_458(this$0) {
    var i = new _no_name_provided__506(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_459(this$0) {
    var i = new _no_name_provided__507(this$0);
    return function (p1) {
      i.invoke_882(p1);
      return Unit_getInstance();
    };
  }
  function updateGraphics_1($this) {
    var shape = $this._shape;
    $this.clear_33();
    if (!(shape == null) ? isNotEmpty(shape) : false) {
      var tmp0_fill_0 = $this._fill_1;
      $this.beginFill_2(tmp0_fill_0);
      Unit_getInstance();
      try {
        path($this, shape);
      }finally {
        $this.endFill_2();
        Unit_getInstance();
      }
      if (!($this._strokeThickness === 0.0)) {
        var tmp1_stroke_0 = $this._stroke_0;
        var tmp = $this._strokeThickness;
        var tmp2_stroke_0 = StrokeInfo_init_$Create$(tmp, false, null, null, null, null, 0.0, 126, null);
        $this.beginStroke_2(tmp1_stroke_0, tmp2_stroke_0);
        Unit_getInstance();
        try {
          path($this, shape);
        }finally {
          $this.endStroke_2();
          Unit_getInstance();
        }
      }}}
  function ShapeView(shape, fill_3, stroke, strokeThickness, autoScaling) {
    Graphics.call(this, autoScaling);
    this._shape = shape;
    this._fill_1 = fill_3;
    this._stroke_0 = stroke;
    this._strokeThickness = strokeThickness;
    updateGraphics_1(this);
    var tmp = this;
    tmp._internalShape = VectorPath_init_$Create$(null, null, null, 7, null);
  }
  ShapeView.prototype._set_shape__1 = function (value) {
    this._shape = value;
    updateGraphics_1(this);
  };
  ShapeView.prototype._set_fill__1 = function (value) {
    if (!equals_1(this._fill_1, value)) {
      this._fill_1 = value;
      updateGraphics_1(this);
    }};
  ShapeView.prototype._get_fill__0 = function () {
    return this._fill_1;
  };
  ShapeView.prototype._set_stroke__0 = function (value) {
    if (!equals_1(this._stroke_0, value)) {
      this._stroke_0 = value;
      updateGraphics_1(this);
    }};
  ShapeView.$metadata$ = {
    simpleName: 'ShapeView',
    kind: 'class',
    interfaces: []
  };
  function SolidRect_init_$Init$(width, height, color_0, $mask0, $marker, $this) {
    if (!(($mask0 & 4) === 0))
      color_0 = Colors_getInstance()._WHITE;
    SolidRect.call($this, width, height, color_0);
    return $this;
  }
  function SolidRect_init_$Create$(width, height, color_0, $mask0, $marker) {
    return SolidRect_init_$Init$(width, height, color_0, $mask0, $marker, Object.create(SolidRect.prototype));
  }
  function Companion_149() {
    Companion_instance_148 = this;
  }
  Companion_149.prototype.invoke_884 = function (width, height, color_0) {
    return new SolidRect(width, height, color_0);
  };
  Companion_149.prototype.invoke$default_5 = function (width, height, color_0, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      color_0 = Colors_getInstance()._WHITE;
    return this.invoke_884(width, height, color_0);
  };
  Companion_149.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_148;
  function Companion_getInstance_148() {
    if (Companion_instance_148 == null)
      new Companion_149();
    return Companion_instance_148;
  }
  function SolidRect(width, height, color_0) {
    Companion_getInstance_148();
    RectBase_init_$Init$(0.0, 0.0, null, false, 15, null, this);
    this._width_20 = width;
    this._height_20 = height;
    this._set_colorMul__13(color_0);
  }
  SolidRect.prototype._set_width__27 = function (v) {
    this._width_20 = v;
    this._set_dirtyVertices__8(true);
  };
  SolidRect.prototype._get_width__58 = function () {
    return this._width_20;
  };
  SolidRect.prototype._set_height__27 = function (v) {
    this._height_20 = v;
    this._set_dirtyVertices__8(true);
  };
  SolidRect.prototype._get_height__58 = function () {
    return this._height_20;
  };
  SolidRect.prototype._get_bwidth__7 = function () {
    return this._width_20;
  };
  SolidRect.prototype._get_bheight__7 = function () {
    return this._height_20;
  };
  SolidRect.prototype._set_color__1 = function (value) {
    this._set_colorMul__13(value);
  };
  SolidRect.$metadata$ = {
    simpleName: 'SolidRect',
    kind: 'class',
    interfaces: []
  };
  function Stage(views) {
    Container.call(this);
    this._views_8 = views;
    this._$$delegate_1 = new Mixin_1();
    this._stage = this;
    this._mouseXY = new Point(0.0, 0.0);
  }
  Stage.prototype._get_views__7 = function () {
    return this._views_8;
  };
  Stage.prototype._get_coroutineContext__22 = function () {
    return this._views_8._coroutineContext_6;
  };
  Stage.prototype.addEventListener_6 = function (clazz, handler) {
    return this._$$delegate_1.addEventListener_6(clazz, handler);
  };
  Stage.prototype.dispatch_16 = function (clazz, event) {
    this._$$delegate_1.dispatch_16(clazz, event);
  };
  Stage.prototype.getLocalBoundsInternal_20 = function (out) {
    var tmp0_setTo_0 = 0.0;
    var tmp1_setTo_0 = 0.0;
    var tmp2_setTo_0 = this._views_8._virtualWidth_0;
    var tmp3_setTo_0 = this._views_8._virtualHeight_0;
    out.setTo_2(numberToDouble(tmp0_setTo_0), numberToDouble(tmp1_setTo_0), numberToDouble(tmp2_setTo_0), numberToDouble(tmp3_setTo_0));
    Unit_getInstance();
  };
  Stage.prototype.renderInternal_20 = function (ctx) {
    if (this._views_8._clipBorders_1) {
      var tmp0_scissor_0 = ctx._get_ctx2d_();
      var tmp1_scissor_0 = this._get_x__36();
      var tmp2_scissor_0 = this._get_y__36();
      var tmp3_scissor_0 = this._views_8._virtualWidth_0 * this._get_scaleX__20();
      var tmp4_scissor_0 = this._views_8._virtualHeight_0 * this._get_scaleY__20();
      var tmp0_scissor_0_1 = numberToInt(tmp1_scissor_0);
      var tmp1_scissor_0_2 = numberToInt(tmp2_scissor_0);
      var tmp2_scissor_0_3 = numberToInt(tmp3_scissor_0);
      var tmp3_scissor_0_4 = numberToInt(tmp4_scissor_0);
      var tmp0_scissor_0_1_5 = tmp0_scissor_0._tempScissor.setTo_6(tmp0_scissor_0_1, tmp1_scissor_0_2, tmp2_scissor_0_3, tmp3_scissor_0_4);
      var oldScissor_1_2_6 = tmp0_scissor_0._batch_0._scissor_1;
      var returnScissor_2_3_7 = tmp0_scissor_0.scissorStart(tmp0_scissor_0_1_5);
      try {
        Container.prototype.renderInternal_20.call(this, ctx);
      }finally {
        tmp0_scissor_0.scissorEnd(oldScissor_1_2_6, returnScissor_2_3_7);
      }
    } else {
      Container.prototype.renderInternal_20.call(this, ctx);
    }
  };
  Stage.$metadata$ = {
    simpleName: 'Stage',
    kind: 'class',
    interfaces: [Reference, CoroutineScope, EventDispatcher, ViewsContainer, ResourcesContainer]
  };
  function _no_name_provided__508() {
  }
  _no_name_provided__508.prototype.invoke_885 = function (it) {
    return Companion_getInstance_114().invoke_885(it);
  };
  _no_name_provided__508.prototype.invoke_1015 = function (p1) {
    return new VerticalAlign(this.invoke_885((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE()));
  };
  _no_name_provided__508.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__509() {
  }
  _no_name_provided__509.prototype.invoke_887 = function (it) {
    return VerticalAlign__toString_impl(it);
  };
  _no_name_provided__509.prototype.invoke_1015 = function (p1) {
    return this.invoke_887(p1 instanceof VerticalAlign ? p1._ratio : THROW_CCE());
  };
  _no_name_provided__509.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__510() {
  }
  _no_name_provided__510.prototype.invoke_889 = function (it) {
    return Companion_getInstance_115().invoke_889(it);
  };
  _no_name_provided__510.prototype.invoke_1015 = function (p1) {
    return new HorizontalAlign(this.invoke_889((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE()));
  };
  _no_name_provided__510.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__511() {
  }
  _no_name_provided__511.prototype.invoke_891 = function (it) {
    return HorizontalAlign__toString_impl(it);
  };
  _no_name_provided__511.prototype.invoke_1015 = function (p1) {
    return this.invoke_891(p1 instanceof HorizontalAlign ? p1._ratio_0 : THROW_CCE());
  };
  _no_name_provided__511.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__512() {
  }
  _no_name_provided__512.prototype.invoke_1005 = function () {
    return Text_init_$Create$('Text', 0.0, null, null, null, null, false, 126, null);
  };
  _no_name_provided__512.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__513() {
  }
  _no_name_provided__513.prototype.invoke_894 = function ($this$null) {
    $this$null.add_90(text$factory_5(), 'Text');
    Unit_getInstance();
    $this$null.add_91(fontSource$factory());
    Unit_getInstance();
    $this$null.add_92(textSize$factory_4(), Companion_getInstance_149()._DEFAULT_TEXT_SIZE);
    Unit_getInstance();
    $this$null.add_89(autoScaling$factory(), Companion_getInstance_149()._DEFAULT_AUTO_SCALING);
    Unit_getInstance();
    var tmp = verticalAlign$factory();
    var tmp_0 = _no_name_provided_$factory_462();
    $this$null.add_88(tmp, tmp_0, _no_name_provided_$factory_463());
    var tmp_1 = horizontalAlign$factory();
    var tmp_2 = _no_name_provided_$factory_464();
    $this$null.add_88(tmp_1, tmp_2, _no_name_provided_$factory_465());
  };
  _no_name_provided__513.prototype.invoke_1015 = function (p1) {
    this.invoke_894(p1 instanceof KTreeSerializerExt ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__513.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Text_init_$Init$(text, textSize, color_0, font, alignment, renderer, autoScaling, $mask0, $marker, $this) {
    if (!(($mask0 & 2) === 0))
      textSize = Companion_getInstance_149()._DEFAULT_TEXT_SIZE;
    if (!(($mask0 & 4) === 0))
      color_0 = Colors_getInstance()._WHITE;
    if (!(($mask0 & 8) === 0))
      font = _get_DefaultTtfFont_();
    if (!(($mask0 & 16) === 0))
      alignment = Companion_getInstance_116()._TOP_LEFT_0;
    if (!(($mask0 & 32) === 0))
      renderer = DefaultStringTextRenderer;
    if (!(($mask0 & 64) === 0))
      autoScaling = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
    Text_2.call($this, text, textSize, color_0, font, alignment, renderer, autoScaling);
    return $this;
  }
  function Text_init_$Create$(text, textSize, color_0, font, alignment, renderer, autoScaling, $mask0, $marker) {
    return Text_init_$Init$(text, textSize, color_0, font, alignment, renderer, autoScaling, $mask0, $marker, Object.create(Text_2.prototype));
  }
  function Companion_150() {
    Companion_instance_149 = this;
    this._DEFAULT_TEXT_SIZE = 16.0;
    this._DEFAULT_AUTO_SCALING = true;
  }
  Companion_150.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_149;
  function Companion_getInstance_149() {
    if (Companion_instance_149 == null)
      new Companion_150();
    return Companion_instance_149;
  }
  function Serializer_2() {
    Serializer_instance_2 = this;
    var tmp = getKClass_0(Text_2);
    var tmp_0 = _no_name_provided_$factory_460();
    KTreeSerializerExt.call(this, 'Text', tmp, tmp_0, _no_name_provided_$factory_461());
  }
  Serializer_2.$metadata$ = {
    simpleName: 'Serializer',
    kind: 'object',
    interfaces: []
  };
  var Serializer_instance_2;
  function Serializer_getInstance_2() {
    if (Serializer_instance_2 == null)
      new Serializer_2();
    return Serializer_instance_2;
  }
  function updateLineCount($this) {
    var tmp = $this;
    var tmp0_count_0 = $this._get_text__2();
    var count_1 = 0;
    var indexedObject = tmp0_count_0;
    var inductionVariable = 0;
    var last_1 = indexedObject.length;
    while (inductionVariable < last_1) {
      var element_3 = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (element_3.equals(new Char(10))) {
        count_1 = count_1 + 1 | 0;
        Unit_getInstance();
      } else {
      }
    }
    tmp._lineCount = count_1 + 1 | 0;
  }
  function _get_textToBitmapResult_($this) {
    var tmp = $this._textToBitmapResult;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('textToBitmapResult');
    }
  }
  function setContainerPosition($this, x, y, baseline) {
    if ($this._autoSize) {
      position_0($this._container, x, y);
      Unit_getInstance();
    } else {
      position_0($this._container, x + HorizontalAlign__getOffsetX_impl($this._alignment._horizontal, $this.__textBounds._width_0), y - VerticalAlign__getOffsetY_impl($this._alignment._vertical, $this.__textBounds._height_0, baseline));
      Unit_getInstance();
    }
  }
  function _no_name_provided__514(this$0, $ctx, $fontSource, resultContinuation) {
    this._this$0_154 = this$0;
    this._$ctx_1 = $ctx;
    this._$fontSource = $fontSource;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__514.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__514.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__514.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._this$0_154.forceLoadFontSource(ensureNotNull(this._$ctx_1._views_4)._currentVfs_1, this._$fontSource, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__514.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__514(this._this$0_154, this._$ctx_1, this._$fontSource, completion);
    return i;
  };
  _no_name_provided__514.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $forceLoadFontSourceCOROUTINE$31(_this_, currentVfs, sourceFile, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__161 = _this_;
    this._currentVfs_0 = currentVfs;
    this._sourceFile_0 = sourceFile;
  }
  $forceLoadFontSourceCOROUTINE$31.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this.__this__161._set_fontSource_(this._sourceFile_0);
            this.__this__161._fontLoaded = true;
            if (!(this._sourceFile_0 == null)) {
              this._state_1 = 1;
              var tmp_0 = this._currentVfs_0.get_115('' + this._sourceFile_0);
              suspendResult = readFont$default(tmp_0, false, null, false, 7, null, this);
              if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
                return suspendResult;
              }continue $sm;
            } else {
              this._state_1 = 2;
              continue $sm;
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            this.__this__161._set_font_(ARGUMENT);
            this._state_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $forceLoadFontSourceCOROUTINE$31.$metadata$ = {
    simpleName: '$forceLoadFontSourceCOROUTINE$31',
    kind: 'class',
    interfaces: []
  };
  function Text_2(text, textSize, color_0, font, alignment, renderer, autoScaling) {
    Companion_getInstance_149();
    Container.call(this);
    this._smoothing_1 = true;
    this._cachedVersion_3 = -1;
    this._cachedVersionRenderer = -1;
    this._version_4 = 0;
    this._lineCount = 0;
    this._text_1 = text;
    updateLineCount(this);
    this._color_4 = color_0;
    this._font_2 = font;
    this._textSize = textSize;
    this._renderer_0 = renderer;
    this._alignment = alignment;
    var tmp = this;
    var tmp1_addTo_0_2 = new Container();
    var tmp0_apply_0_3 = addTo(tmp1_addTo_0_2, this);
    Unit_getInstance();
    tmp._container = tmp0_apply_0_3;
    this._bitmapFontActions = new Text2TextRendererActions();
    this._fontLoaded = false;
    this._autoScaling_0 = autoScaling;
    this._fontSource = null;
    this.__textBounds = Companion_getInstance_83().invoke_310(0, 0, 2048, 2048);
    this._autoSize = true;
    this._boundsVersion = -1;
    var tmp_0 = this;
    tmp_0._tempBmpEntry = Entry_init_$Create$(null, 0.0, 0.0, 0.0, 0.0, null, 63, null);
    var tmp_1 = this;
    tmp_1._fontMetrics_1 = FontMetrics_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 255, null);
    var tmp_2 = this;
    tmp_2._textMetrics = TextMetrics_init_$Create$(null, null, null, 0, 15, null);
    this._lastAutoScaling = null;
    this._lastSmoothing = null;
    this._lastNativeRendering = null;
    this._useNativeRendering_0 = true;
    this._autoscaling_0 = new InternalViewAutoscaling();
    var tmp_3 = this;
    tmp_3._imagesToRemove = ArrayList_init_$Create$();
    this.__staticImage = null;
  }
  Text_2.prototype._set_text__2 = function (value) {
    if (!(this._text_1 === value)) {
      this._text_1 = value;
      updateLineCount(this);
      var tmp0_this = this;
      var tmp1 = tmp0_this._version_4;
      tmp0_this._version_4 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Text_2.prototype._get_text__2 = function () {
    return this._text_1;
  };
  Text_2.prototype._set_color__1 = function (value) {
    if (!equals_1(new RGBA(this._color_4), new RGBA(value))) {
      this._color_4 = value;
      var tmp0_this = this;
      var tmp1 = tmp0_this._version_4;
      tmp0_this._version_4 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Text_2.prototype._set_font_ = function (value) {
    if (!equals_1(this._font_2, value)) {
      this._font_2 = value;
      var tmp0_this = this;
      var tmp1 = tmp0_this._version_4;
      tmp0_this._version_4 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Text_2.prototype._set_textSize__1 = function (value) {
    if (!(this._textSize === value)) {
      this._textSize = value;
      var tmp0_this = this;
      var tmp1 = tmp0_this._version_4;
      tmp0_this._version_4 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Text_2.prototype._get_fontSize__1 = function () {
    return this._textSize;
  };
  Text_2.prototype._set_alignment_ = function (value) {
    if (!this._alignment.equals(value)) {
      this._alignment = value;
      var tmp0_this = this;
      var tmp1 = tmp0_this._version_4;
      tmp0_this._version_4 = tmp1 + 1 | 0;
      Unit_getInstance();
    }};
  Text_2.prototype._set_horizontalAlign_ = function (value) {
    return this._set_alignment_(this._alignment.withHorizontal(value));
  };
  Text_2.prototype._get_horizontalAlign_ = function () {
    return this._alignment._horizontal;
  };
  Text_2.prototype._set_verticalAlign_ = function (value) {
    return this._set_alignment_(this._alignment.withVertical(value));
  };
  Text_2.prototype._get_verticalAlign_ = function () {
    return this._alignment._vertical;
  };
  Text_2.prototype._set_fontSource_ = function (value) {
    this._fontSource = value;
    this._fontLoaded = false;
  };
  Text_2.prototype.forceLoadFontSource = function (currentVfs, sourceFile, $cont) {
    var tmp = new $forceLoadFontSourceCOROUTINE$31(this, currentVfs, sourceFile, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Text_2.prototype.setFormat = function (face, size_1, color_0, align) {
    var tmp0_elvis_lhs = face;
    this._set_font_(tmp0_elvis_lhs == null ? _get_DefaultTtfFont_() : tmp0_elvis_lhs);
    this._set_textSize__1(size_1);
    this._set_color__1(color_0);
    this._set_alignment_(align);
  };
  Text_2.prototype.setTextBounds = function (rect_1) {
    if (this.__textBounds.equals(rect_1) ? !this._autoSize : false)
      return Unit_getInstance();
    this.__textBounds.copyFrom_2(rect_1);
    Unit_getInstance();
    this._autoSize = false;
    var tmp0_this = this;
    var tmp1 = tmp0_this._boundsVersion;
    tmp0_this._boundsVersion = tmp1 + 1 | 0;
    Unit_getInstance();
    var tmp2_this = this;
    var tmp3 = tmp2_this._version_4;
    tmp2_this._version_4 = tmp3 + 1 | 0;
    Unit_getInstance();
  };
  Text_2.prototype.getLocalBoundsInternal_20 = function (out) {
    this._renderInternal(null);
    out.copyFrom_2(this.__textBounds);
    Unit_getInstance();
  };
  Text_2.prototype.renderInternal_20 = function (ctx) {
    this._renderInternal(ctx);
    $l$break: while (true) {
      var tmp0_isNotEmpty_0 = this._imagesToRemove;
      if (!!tmp0_isNotEmpty_0.isEmpty_53()) {
        break $l$break;
      }ctx._agBitmapTextureManager.removeBitmap(removeLast(this._imagesToRemove));
    }
    Container.prototype.renderInternal_20.call(this, ctx);
  };
  Text_2.prototype._renderInternal = function (ctx) {
    if (!(ctx == null)) {
      var fontSource = this._fontSource;
      if (!this._fontLoaded ? !(fontSource == null) : false) {
        this._fontLoaded = true;
        launchImmediately(ctx._coroutineContext_5, _no_name_provided_$factory_466(this, ctx, fontSource, null));
        Unit_getInstance();
      }}this._container._set_colorMul__13(this._color_4);
    var font = this._font_2.getOrNull_4();
    var tmp;
    var tmp_0;
    if (this._autoSize) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this._boundsVersion === this._version_4);
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      this._boundsVersion = this._version_4;
      var metrics = getTextBounds(font, this._textSize, this._get_text__2(), this._textMetrics, this._renderer_0);
      this.__textBounds.copyFrom_2(metrics._bounds_2);
      Unit_getInstance();
      this.__textBounds._height_0 = font.getFontMetrics_1(this._textSize, this._fontMetrics_1)._get_lineHeight__4() * this._lineCount;
      this.__textBounds._x_3 = -HorizontalAlign__getOffsetX_impl(this._alignment._horizontal, this.__textBounds._width_0) + metrics._get_left__4();
      this.__textBounds._y_3 = VerticalAlign__getOffsetY_impl(this._alignment._vertical, this.__textBounds._height_0, -metrics._get_ascent_());
    } else {
    }
    var tmp0_subject = font;
    if (tmp0_subject == null)
      Unit_getInstance();
    else {
      if (tmp0_subject instanceof BitmapFont) {
        var rversion = this._renderer_0._get_version__1();
        if ((!(this._lastSmoothing === this._smoothing_1) ? true : !(this._cachedVersion_3 === this._version_4)) ? true : !(this._cachedVersionRenderer === rversion)) {
          this._lastSmoothing = this._smoothing_1;
          this._cachedVersionRenderer = rversion;
          this._cachedVersion_3 = this._version_4;
          this.__staticImage = null;
          this._bitmapFontActions._set_x__27(0.0);
          this._bitmapFontActions._set_y__27(0.0);
          this._bitmapFontActions.mreset();
          this._bitmapFontActions._verticalAlign = this._get_verticalAlign_();
          this._bitmapFontActions._horizontalAlign = this._get_horizontalAlign_();
          this._renderer_0.invoke_409(this._bitmapFontActions, this._get_text__2(), this._textSize, font);
          while (this._container._get_numChildren__8() < this._bitmapFontActions._get_size__60()) {
            var tmp0_image_0 = this._container;
            var tmp1_image_0 = Bitmaps_getInstance()._transparent;
            var tmp2_image_0 = 0.0;
            var tmp3_image_0 = 0.0;
            var tmp0_addTo_0_2 = Image_init_$Create$(tmp1_image_0, tmp2_image_0, tmp3_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp0_image_0);
            Unit_getInstance();
            Unit_getInstance();
          }
          while (this._container._get_numChildren__8() > this._bitmapFontActions._get_size__60()) {
            this._container.get_137(this._container._get_numChildren__8() - 1 | 0).removeFromParent_20();
          }
          var textWidth = this._bitmapFontActions._get_x__36();
          var dx = -textWidth * _HorizontalAlign___get_ratio__impl_(this._get_horizontalAlign_());
          var inductionVariable = 0;
          var last_1 = this._bitmapFontActions._get_size__60();
          if (inductionVariable < last_1)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp_1 = this._container.get_137(n);
              var it = tmp_1 instanceof Image ? tmp_1 : THROW_CCE();
              anchor(it, 0, 0);
              Unit_getInstance();
              it._set_smoothing__0(this._smoothing_1);
              var entry = this._bitmapFontActions.read_48(n, this._tempBmpEntry);
              it._set_bitmap__5(entry._tex);
              it._set_x__27(entry._x_9 + dx);
              it._set_y__27(entry._y_8);
              it._set_scaleX__20(entry._sx_0);
              it._set_scaleY__20(entry._sy_0);
              it._set_rotation__0(entry._rot);
            }
             while (inductionVariable < last_1);
          setContainerPosition(this, 0.0, 0.0, font._base_4);
        }} else {
        {
          var onRenderResult = this._autoscaling_0.onRender(this._autoScaling_0, this._get_globalMatrix__20());
          var lastAutoScalingResult = !(this._lastAutoScaling === this._autoScaling_0);
          if (((onRenderResult ? true : lastAutoScalingResult) ? true : !(this._lastSmoothing === this._smoothing_1)) ? true : !(this._lastNativeRendering === this._useNativeRendering_0)) {
            var tmp2_this = this;
            var tmp3 = tmp2_this._version_4;
            tmp2_this._version_4 = tmp3 + 1 | 0;
            Unit_getInstance();
            this._lastNativeRendering = this._useNativeRendering_0;
            this._lastAutoScaling = this._autoScaling_0;
            this._lastSmoothing = this._smoothing_1;
          }if (!(this._cachedVersion_3 === this._version_4)) {
            this._cachedVersion_3 = this._version_4;
            var realTextSize = this._textSize * this._autoscaling_0._renderedAtScaleXY;
            var tmp_2 = this;
            var tmp_3 = this._get_text__2();
            var tmp_4 = new RGBA(Colors_getInstance()._WHITE);
            var tmp_5 = this._renderer_0;
            tmp_2._textToBitmapResult = renderTextToBitmap$default(font, realTextSize, tmp_3, tmp_4, null, true, 0, tmp_5, false, this._useNativeRendering_0, true, 168, null);
            var met = _get_textToBitmapResult_(this)._metrics_0;
            var x = -HorizontalAlign__getOffsetX_impl(this._get_horizontalAlign_(), met._get_width__58()) + met._get_left__4();
            var y = VerticalAlign__getOffsetY_impl(this._get_verticalAlign_(), met._get_lineHeight__4(), -met._get_ascent_());
            if (this.__staticImage == null) {
              this._container.removeChildren_8();
              var tmp_6 = this;
              var tmp4_image_0 = this._container;
              var tmp5_image_0 = _get_textToBitmapResult_(this)._bmp_1;
              var tmp6_image_0 = 0.0;
              var tmp7_image_0 = 0.0;
              var tmp0_addTo_0_2_0 = Image_init_$Create$_0(tmp5_image_0, tmp6_image_0, tmp7_image_0, null, false, 24, null);
              var tmp0_apply_0_2_3_0 = addTo(tmp0_addTo_0_2_0, tmp4_image_0);
              Unit_getInstance();
              tmp_6.__staticImage = tmp0_apply_0_2_3_0;
            } else {
              this._imagesToRemove.add_39(ensureNotNull(this.__staticImage)._get_bitmap__5()._bmpBase);
              Unit_getInstance();
              var tmp_7 = ensureNotNull(this.__staticImage);
              var tmp_8 = _get_textToBitmapResult_(this)._bmp_1;
              tmp_7._set_bitmap__5(slice$default(tmp_8, null, null, 3, null));
            }
            var mscale = 1.0 / this._autoscaling_0._renderedAtScaleXY;
            scale_0(ensureNotNull(this.__staticImage), mscale, mscale);
            Unit_getInstance();
            setContainerPosition(this, x * mscale, y * mscale, font.getFontMetrics_1(this._get_fontSize__1(), this._fontMetrics_1)._baseline);
          }var tmp4_safe_receiver = this.__staticImage;
          if (tmp4_safe_receiver == null) {
            Unit_getInstance();
          } else
            tmp4_safe_receiver._set_smoothing__0(this._smoothing_1);
        }
      }
    }
  };
  Text_2.$metadata$ = {
    simpleName: 'Text',
    kind: 'class',
    interfaces: [ViewLeaf, IText]
  };
  function text$factory_5() {
    return getPropertyCallableRef('text', 1, KMutableProperty1, function (receiver) {
      return receiver._get_text__2();
    }, function (receiver_0, value) {
      return receiver_0._set_text__2(value);
    });
  }
  function fontSource$factory() {
    return getPropertyCallableRef('fontSource', 1, KMutableProperty1, function (receiver) {
      return receiver._fontSource;
    }, function (receiver_0, value) {
      return receiver_0._set_fontSource_(value);
    });
  }
  function textSize$factory_4() {
    return getPropertyCallableRef('textSize', 1, KMutableProperty1, function (receiver) {
      return receiver._textSize;
    }, function (receiver_0, value) {
      return receiver_0._set_textSize__1(value);
    });
  }
  function autoScaling$factory() {
    return getPropertyCallableRef('autoScaling', 1, KMutableProperty1, function (receiver) {
      return receiver._autoScaling_0;
    }, function (receiver_0, value) {
      receiver_0._autoScaling_0 = value;
      return Unit_getInstance();
    });
  }
  function verticalAlign$factory() {
    return getPropertyCallableRef('verticalAlign', 1, KMutableProperty1, function (receiver) {
      return new VerticalAlign(receiver._get_verticalAlign_());
    }, function (receiver_0, value) {
      return receiver_0._set_verticalAlign_(value._ratio);
    });
  }
  function horizontalAlign$factory() {
    return getPropertyCallableRef('horizontalAlign', 1, KMutableProperty1, function (receiver) {
      return new HorizontalAlign(receiver._get_horizontalAlign_());
    }, function (receiver_0, value) {
      return receiver_0._set_horizontalAlign_(value._ratio_0);
    });
  }
  function _no_name_provided_$factory_460() {
    var i = new _no_name_provided__512();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_461() {
    var i = new _no_name_provided__513();
    return function (p1) {
      i.invoke_894(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_462() {
    var i = new _no_name_provided__508();
    return function (p1) {
      return new VerticalAlign(i.invoke_885(p1));
    };
  }
  function _no_name_provided_$factory_463() {
    var i = new _no_name_provided__509();
    return function (p1) {
      return i.invoke_887(p1._ratio);
    };
  }
  function _no_name_provided_$factory_464() {
    var i = new _no_name_provided__510();
    return function (p1) {
      return new HorizontalAlign(i.invoke_889(p1));
    };
  }
  function _no_name_provided_$factory_465() {
    var i = new _no_name_provided__511();
    return function (p1) {
      return i.invoke_891(p1._ratio_0);
    };
  }
  function _no_name_provided_$factory_466(this$0, $ctx, $fontSource, resultContinuation) {
    var i = new _no_name_provided__514(this$0, $ctx, $fontSource, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function IText() {
  }
  IText.$metadata$ = {
    simpleName: 'IText',
    kind: 'interface',
    interfaces: []
  };
  function setText(_this_, text) {
    foreachDescendant(_this_, _no_name_provided_$factory_467(text));
  }
  function _no_name_provided__515($text) {
    this._$text = $text;
  }
  _no_name_provided__515.prototype.invoke_898 = function (it) {
    if (isInterface(it, IText))
      it._set_text__2(this._$text);
    else {
    }
  };
  _no_name_provided__515.prototype.invoke_1015 = function (p1) {
    this.invoke_898(p1 instanceof View ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__515.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_467($text) {
    var i = new _no_name_provided__515($text);
    return function (p1) {
      i.invoke_898(p1);
      return Unit_getInstance();
    };
  }
  function View_init_$Init$($this) {
    View.call($this, false);
    return $this;
  }
  function Reference() {
  }
  Reference.$metadata$ = {
    simpleName: 'Reference',
    kind: 'interface',
    interfaces: []
  };
  function ColorReference() {
  }
  ColorReference.$metadata$ = {
    simpleName: 'ColorReference',
    kind: 'interface',
    interfaces: []
  };
  function Companion_151() {
    Companion_instance_150 = this;
  }
  Companion_151.prototype.commonAncestor = function (left, right) {
    var l = left;
    var r = right;
    var lCount = _get_ancestorCount_(l);
    var rCount = _get_ancestorCount_(r);
    while (lCount >= 0 ? true : rCount >= 0) {
      if (equals_1(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        var tmp0 = lCount;
        lCount = tmp0 - 1 | 0;
        Unit_getInstance();
        var tmp1_safe_receiver = l;
        l = tmp1_safe_receiver == null ? null : tmp1_safe_receiver._parent_5;
      }if (rdec) {
        var tmp2 = rCount;
        rCount = tmp2 - 1 | 0;
        Unit_getInstance();
        var tmp3_safe_receiver = r;
        r = tmp3_safe_receiver == null ? null : tmp3_safe_receiver._parent_5;
      }}
    return null;
  };
  Companion_151.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_150;
  function Companion_getInstance_150() {
    if (Companion_instance_150 == null)
      new Companion_151();
    return Companion_instance_150;
  }
  function ensureTransform($this) {
    if (!$this._validLocalProps) {
      $this._validLocalProps = true;
      var t = $this._tempTransform.setMatrix_0($this.__localMatrix);
      $this._pos_1._set_xf_(t._get_xf_());
      $this._pos_1._set_yf_(t._get_yf_());
      $this.__scaleX = t._scaleX;
      $this.__scaleY = t._scaleY;
      $this.__skewX = t._skewX;
      $this.__skewY = t._skewY;
      $this.__rotation = t._rotation;
    }return $this;
  }
  function renderFiltered($this, ctx, filter) {
    var bounds = $this.getLocalBounds$default_20(null, false, 3, null);
    var borderEffect = filter._get_border___error();
    var tmp$ret$2;
    l$ret$3: do {
      var tmp0_alloc_0 = ctx._matrixPool;
      var temp_1 = tmp0_alloc_0.alloc();
      try {
        var texWidth_3 = numberToInt(bounds._width_0) + imul(borderEffect, 2) | 0;
        var texHeight_4 = numberToInt(bounds._height_0) + imul(borderEffect, 2) | 0;
        var addx_5 = -bounds._x_3 + borderEffect;
        var addy_6 = -bounds._y_3 + borderEffect;
        ctx.flush_8();
        var tmp0_renderToTexture_0_1_7 = ctx._ag_5;
        var rb_1_2_8 = tmp0_renderToTexture_0_1_7._renderBuffers.alloc();
        var tmp0_this_2_3_9 = tmp0_renderToTexture_0_1_7;
        var tmp0_plusAssign_0_3_4_10 = tmp0_this_2_3_9._frameRenderBuffers;
        tmp0_plusAssign_0_3_4_10.add_39(rb_1_2_8);
        Unit_getInstance();
        var tmp;
        try {
          rb_1_2_8.setSize_4(0, 0, texWidth_3, texHeight_4, texWidth_3, texHeight_4);
          var old_1_4_5_11 = tmp0_renderToTexture_0_1_7.setRenderBuffer_4(rb_1_2_8);
          try {
            var tmp_0 = Colors_getInstance()._TRANSPARENT_BLACK;
            tmp0_renderToTexture_0_1_7.clear$default(tmp_0, 0.0, 0, false, false, false, 62, null);
            var oldScissors_8_6_12 = ctx._get_batch_()._scissor_1;
            ctx._get_batch_()._scissor_1 = null;
            try {
              temp_1.copyFrom($this._get_globalMatrixInv__20());
              Unit_getInstance();
              temp_1.translate_2(addx_5, addy_6);
              Unit_getInstance();
              var tmp0_setViewMatrixTemp_0_11_13 = ctx._get_batch_();
              var tmp$ret$0;
              l$ret$1: do {
                var tmp0_alloc_0_1_12_14 = tmp0_setViewMatrixTemp_0_11_13._ctx_6._matrix3DPool;
                var temp_1_2_13_15 = tmp0_alloc_0_1_12_14.alloc();
                try {
                  tmp0_setViewMatrixTemp_0_11_13.flush$default(false, false, 3, null);
                  temp_1_2_13_15.copyFrom_0(tmp0_setViewMatrixTemp_0_11_13._viewMat);
                  Unit_getInstance();
                  copyFrom(tmp0_setViewMatrixTemp_0_11_13._viewMat, temp_1);
                  Unit_getInstance();
                  var tmp_1;
                  try {
                    tmp_1 = $this.renderInternal_20(ctx);
                  }finally {
                    tmp0_setViewMatrixTemp_0_11_13.flush$default(false, false, 3, null);
                    tmp0_setViewMatrixTemp_0_11_13._viewMat.copyFrom_0(temp_1_2_13_15);
                    Unit_getInstance();
                  }
                  tmp$ret$0 = tmp_1;
                  break l$ret$1;
                }finally {
                  tmp0_alloc_0_1_12_14.free(temp_1_2_13_15);
                }
              }
               while (false);
              ctx.flush_8();
            }finally {
              ctx._get_batch_()._scissor_1 = oldScissors_8_6_12;
            }
          }finally {
            tmp0_renderToTexture_0_1_7.setRenderBuffer_4(old_1_4_5_11);
            Unit_getInstance();
          }
          var tmp1__anonymous__9_7_16 = rb_1_2_8._get_tex__2();
          var tmp0__anonymous__14_17 = Companion_getInstance_145().invoke_689(tmp1__anonymous__9_7_16, texWidth_3, texHeight_4);
          temp_1.copyFrom($this._get_globalMatrix__20());
          Unit_getInstance();
          temp_1.pretranslate(-addx_5, -addy_6);
          Unit_getInstance();
          filter.render__error(ctx, temp_1, tmp0__anonymous__14_17, texWidth_3, texHeight_4, $this._get_renderColorAdd__20(), $this._get_renderColorMul__20(), $this._blendMode_0);
          tmp = ctx.flush_8();
        }finally {
          var tmp1_this_5_8_18 = tmp0_renderToTexture_0_1_7;
          var tmp1_minusAssign_0_6_9_19 = tmp1_this_5_8_18._frameRenderBuffers;
          tmp1_minusAssign_0_6_9_19.remove_47(rb_1_2_8);
          Unit_getInstance();
          tmp0_renderToTexture_0_1_7._renderBuffers.free(rb_1_2_8);
        }
        tmp$ret$2 = tmp;
        break l$ret$3;
      }finally {
        tmp0_alloc_0.free(temp_1);
      }
    }
     while (false);
  }
  function _no_name_provided__516(this$0) {
    this._this$0_155 = this$0;
  }
  _no_name_provided__516.prototype.invoke_1005 = function () {
    return listOf_0(this._this$0_155);
  };
  _no_name_provided__516.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function View(isContainer) {
    Companion_getInstance_150();
    BaseView.call(this);
    this._isContainer = isContainer;
    this._extra_4 = null;
    var tmp = this;
    tmp._bviewAll$delegate = lazy(_no_name_provided_$factory_468(this));
    this.__children = null;
    this._propagateEvents = true;
    this._hitShape = null;
    this._hitShapes = null;
    this._ratio_2 = 0.0;
    this._index_19 = 0;
    this._speed = 1.0;
    this._parent_5 = null;
    this._name_29 = null;
    this._blendMode_0 = BlendMode_INHERIT_getInstance();
    this.__scaleX = 1.0;
    this.__scaleY = 1.0;
    this.__skewX = _get_radians_(0.0);
    this.__skewY = _get_radians_(0.0);
    this.__rotation = _get_radians_(0.0);
    this._pos_1 = Companion_getInstance_80().invoke_1005();
    var tmp_0 = this;
    tmp_0._tempTransform = Transform_init_$Create$(0.0, 0.0, 0.0, 0.0, null, null, null, 127, null);
    this._mouseEnabled = true;
    this._visible_0 = true;
    this._validLocalProps = true;
    this._validLocalMatrix = true;
    var tmp_1 = this;
    tmp_1.__localMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_2 = this;
    tmp_2.__globalMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this.__globalMatrixVersion = -1;
    var tmp_3 = this;
    tmp_3.__globalMatrixInv = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this.__globalMatrixInvVersion = -1;
    var tmp_4 = this;
    var tmp0_ColorTransform_0 = 1;
    var tmp1_ColorTransform_0 = 1;
    var tmp2_ColorTransform_0 = 1;
    var tmp3_ColorTransform_0 = 1;
    var tmp4_ColorTransform_0 = 0;
    var tmp5_ColorTransform_0 = 0;
    var tmp6_ColorTransform_0 = 0;
    var tmp7_ColorTransform_0 = 0;
    tmp_4.__colorTransform = new ColorTransform(numberToDouble(tmp0_ColorTransform_0), numberToDouble(tmp1_ColorTransform_0), numberToDouble(tmp2_ColorTransform_0), numberToDouble(tmp3_ColorTransform_0), numberToInt(tmp4_ColorTransform_0), numberToInt(tmp5_ColorTransform_0), numberToInt(tmp6_ColorTransform_0), numberToInt(tmp7_ColorTransform_0));
    this.__renderColorTransform = new ColorTransform(1.0, 1.0, 1.0, 1.0, 0, 0, 0, 0);
    this.__renderColorTransformVersion = -1;
    this.__renderBlendMode = BlendMode_INHERIT_getInstance();
    this.__renderBlendModeVersion = -1;
    this._dirtyVertices = true;
    this.__version = 0;
    this.__versionColor = 0;
    this.__requireInvalidate = false;
    this.__requireInvalidateColor = false;
    this._filter = null;
    this._debugAnnotate = false;
    this._hitTestUsingShapes = null;
    var tmp_5 = this;
    tmp_5._boundsTemp = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    this._bb_2 = new BoundsBuilder();
    this.__localBounds = Companion_getInstance_83().invoke_1005();
    this._extraBuildDebugComponent = null;
  }
  View.prototype._set_extra__71 = function (_set___) {
    this._extra_4 = _set___;
  };
  View.prototype._get_extra__71 = function () {
    return this._extra_4;
  };
  View.prototype._get_anchorDispX__20 = function () {
    return 0.0;
  };
  View.prototype._get_anchorDispY__20 = function () {
    return 0.0;
  };
  View.prototype._set__children__9 = function (_set___) {
    this.__children = _set___;
  };
  View.prototype._get__children__9 = function () {
    return this.__children;
  };
  View.prototype._set_hitShape__8 = function (_set___) {
    this._hitShape = _set___;
  };
  View.prototype._get_hitShape__20 = function () {
    return this._hitShape;
  };
  View.prototype._get_hitShapes__20 = function () {
    return this._hitShapes;
  };
  View.prototype._set_ratio__0 = function (_set___) {
    this._ratio_2 = _set___;
  };
  View.prototype._get_ratio__1 = function () {
    return this._ratio_2;
  };
  View.prototype._get_parent__14 = function () {
    return this._parent_5;
  };
  View.prototype._set_name__0 = function (_set___) {
    this._name_29 = _set___;
  };
  View.prototype._get_globalSpeed__20 = function () {
    return !(this._parent_5 == null) ? ensureNotNull(this._parent_5)._get_globalSpeed__20() * this._speed : this._speed;
  };
  View.prototype._set_x__27 = function (v) {
    ensureTransform(this);
    Unit_getInstance();
    if (!(this._pos_1._x_2 === v)) {
      this._pos_1._x_2 = v;
      this.invalidateMatrix_20();
    }};
  View.prototype._get_x__36 = function () {
    return ensureTransform(this)._pos_1._x_2;
  };
  View.prototype._set_y__27 = function (v) {
    ensureTransform(this);
    Unit_getInstance();
    if (!(this._pos_1._y_2 === v)) {
      this._pos_1._y_2 = v;
      this.invalidateMatrix_20();
    }};
  View.prototype._get_y__36 = function () {
    return ensureTransform(this)._pos_1._y_2;
  };
  View.prototype._set_scaleX__20 = function (v) {
    ensureTransform(this);
    Unit_getInstance();
    if (!(this.__scaleX === v)) {
      this.__scaleX = v;
      this.invalidateMatrix_20();
    }};
  View.prototype._get_scaleX__20 = function () {
    return ensureTransform(this).__scaleX;
  };
  View.prototype._set_scaleY__20 = function (v) {
    ensureTransform(this);
    Unit_getInstance();
    if (!(this.__scaleY === v)) {
      this.__scaleY = v;
      this.invalidateMatrix_20();
    }};
  View.prototype._get_scaleY__20 = function () {
    return ensureTransform(this).__scaleY;
  };
  View.prototype._set_scale__20 = function (v) {
    this._set_scaleX__20(v);
    this._set_scaleY__20(v);
  };
  View.prototype._get_scale__20 = function () {
    return (this._get_scaleX__20() + this._get_scaleY__20()) / 2.0;
  };
  View.prototype._get_skewX__20 = function () {
    return ensureTransform(this).__skewX;
  };
  View.prototype._get_skewY__20 = function () {
    return ensureTransform(this).__skewY;
  };
  View.prototype._set_rotation__0 = function (v) {
    ensureTransform(this);
    Unit_getInstance();
    if (!equals_1(new Angle(this.__rotation), new Angle(v))) {
      this.__rotation = v;
      this.invalidateMatrix_20();
    }};
  View.prototype._get_rotation__20 = function () {
    return ensureTransform(this).__rotation;
  };
  View.prototype._get_globalX__20 = function () {
    var tmp0_safe_receiver = this._parent_5;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.localToGlobalX_9(this._get_x__36(), this._get_y__36());
    return tmp1_elvis_lhs == null ? this._get_x__36() : tmp1_elvis_lhs;
  };
  View.prototype._get_globalY__20 = function () {
    var tmp0_safe_receiver = this._parent_5;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.localToGlobalY_9(this._get_x__36(), this._get_y__36());
    return tmp1_elvis_lhs == null ? this._get_y__36() : tmp1_elvis_lhs;
  };
  View.prototype._set_width__27 = function (value) {
    this._set_scaleX__20((this._get_scaleX__20() === 0.0 ? 1.0 : this._get_scaleX__20()) * (value / this._get_width__58()));
  };
  View.prototype._get_width__58 = function () {
    return this.getLocalBounds$default_20(null, false, 3, null)._width_0;
  };
  View.prototype._set_height__27 = function (value) {
    var tmp = this._get_scaleY__20() === 0.0 ? 1.0 : this._get_scaleY__20();
    this._set_scaleY__20(tmp * (value / this.getLocalBounds$default_20(null, false, 3, null)._height_0));
  };
  View.prototype._get_height__58 = function () {
    return this.getLocalBounds$default_20(null, false, 3, null)._height_0;
  };
  View.prototype._get_unscaledWidth__20 = function () {
    return this._get_width__58();
  };
  View.prototype._get_unscaledHeight__20 = function () {
    return this._get_height__58();
  };
  View.prototype._set_scaledWidth__20 = function (value) {
    this._set_width__27(this._get_scaleX__20() === 0.0 ? value : value / this._get_scaleX__20());
  };
  View.prototype._get_scaledWidth__20 = function () {
    return this._get_unscaledWidth__20() * this._get_scaleX__20();
  };
  View.prototype._set_scaledHeight__20 = function (value) {
    this._set_height__27(this._get_scaleY__20() === 0.0 ? value : value / this._get_scaleY__20());
  };
  View.prototype._get_scaledHeight__20 = function () {
    return this._get_unscaledHeight__20() * this._get_scaleY__20();
  };
  View.prototype._set_colorMul__13 = function (v) {
    if (!equals_1(new RGBA(v), new RGBA(this.__colorTransform._get_colorMul__21()))) {
      this.__colorTransform._set_colorMul__13(v);
      this.invalidateColorTransform_20();
    }};
  View.prototype._get_colorMul__21 = function () {
    return this.__colorTransform._get_colorMul__21();
  };
  View.prototype._get_colorAdd__21 = function () {
    return this.__colorTransform._get_colorAdd__21();
  };
  View.prototype._set_alpha__20 = function (v) {
    if (!(v === this.__colorTransform._get_mA_())) {
      this.__colorTransform._set_mA_(v);
      this.invalidateColorTransform_20();
    }};
  View.prototype._get_alpha__20 = function () {
    return this.__colorTransform._get_mA_();
  };
  View.prototype._get_root__33 = function () {
    var tmp0_safe_receiver = this._parent_5;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_root__33();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  };
  View.prototype._get_stage__4 = function () {
    var tmp = this._get_root__33();
    return tmp instanceof Stage ? tmp : null;
  };
  View.prototype._get_mouseEnabled__20 = function () {
    return this._mouseEnabled;
  };
  View.prototype._set_visible__4 = function (_set___) {
    this._visible_0 = _set___;
  };
  View.prototype._get_visible__20 = function () {
    return this._visible_0;
  };
  View.prototype._get_localMatrix__20 = function () {
    if (!this._validLocalMatrix) {
      this._validLocalMatrix = true;
      this.__requireInvalidate = true;
      this.__localMatrix.setTransform_0(this._get_x__36(), this._get_y__36(), this._get_scaleX__20(), this._get_scaleY__20(), this._get_rotation__20(), this._get_skewX__20(), this._get_skewY__20());
      Unit_getInstance();
    }return this.__localMatrix;
  };
  View.prototype._get_globalMatrix__20 = function () {
    if (!(this.__globalMatrixVersion === this.__version)) {
      this.__globalMatrixVersion = this.__version;
      this.__requireInvalidate = true;
      if (!(this._parent_5 == null)) {
        this.__globalMatrix.multiply_0(this._get_localMatrix__20(), ensureNotNull(this._parent_5)._get_globalMatrix__20());
        Unit_getInstance();
      } else {
        this.__globalMatrix.copyFrom(this._get_localMatrix__20());
        Unit_getInstance();
      }
    }return this.__globalMatrix;
  };
  View.prototype._get_globalMatrixInv__20 = function () {
    if (!(this.__globalMatrixInvVersion === this.__version)) {
      this.__globalMatrixInvVersion = this.__version;
      this.__requireInvalidate = true;
      this.__globalMatrixInv.invert(this._get_globalMatrix__20());
      Unit_getInstance();
    }return this.__globalMatrixInv;
  };
  View.prototype._get_renderColorTransform__20 = function () {
    if (!(this.__renderColorTransformVersion === this.__versionColor)) {
      this.__renderColorTransformVersion = this.__versionColor;
      this.__requireInvalidateColor = true;
      var tmp;
      if (!(this._parent_5 == null)) {
        var tmp0_safe_receiver = this._parent_5;
        tmp = !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_filter__9()) == null);
      } else {
        tmp = false;
      }
      if (tmp) {
        this.__renderColorTransform.copyFrom_4(this.__colorTransform);
        Unit_getInstance();
      } else {
        var tmp_0;
        if (!(this._parent_5 == null)) {
          tmp_0 = !isInterface(this, ColorReference);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          this.__renderColorTransform.setToConcat(this.__colorTransform, ensureNotNull(this._parent_5)._get_renderColorTransform__20());
          Unit_getInstance();
        } else {
          {
            this.__renderColorTransform.copyFrom_4(this.__colorTransform);
            Unit_getInstance();
          }
        }
      }
    }return this.__renderColorTransform;
  };
  View.prototype._get_renderBlendMode__19 = function () {
    if (!(this.__renderBlendModeVersion === this.__version)) {
      this.__renderBlendModeVersion = this.__version;
      this.__requireInvalidate = true;
      var tmp = this;
      var tmp_0;
      if (this._blendMode_0.equals(BlendMode_INHERIT_getInstance())) {
        var tmp0_safe_receiver = this._parent_5;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_renderBlendMode__19();
        tmp_0 = tmp1_elvis_lhs == null ? BlendMode_NORMAL_getInstance_0() : tmp1_elvis_lhs;
      } else {
        tmp_0 = this._blendMode_0;
      }
      tmp.__renderBlendMode = tmp_0;
    }return this.__renderBlendMode;
  };
  View.prototype._get_renderColorMul__20 = function () {
    return this._get_renderColorTransform__20()._get_colorMul__21();
  };
  View.prototype._get_renderColorAdd__20 = function () {
    return this._get_renderColorTransform__20()._get_colorAdd__21();
  };
  View.prototype.invalidateMatrix_20 = function () {
    this._validLocalMatrix = false;
    this.invalidate_23();
  };
  View.prototype._set_dirtyVertices__8 = function (_set___) {
    this._dirtyVertices = _set___;
  };
  View.prototype._get_dirtyVertices__8 = function () {
    return this._dirtyVertices;
  };
  View.prototype.invalidate_23 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.__version;
    tmp0_this.__version = tmp1 + 1 | 0;
    Unit_getInstance();
    this.__requireInvalidate = false;
    this._dirtyVertices = true;
    var tmp2_safe_receiver = this.__children;
    if (tmp2_safe_receiver == null)
      null;
    else {
      var n_1 = 0;
      while (n_1 < tmp2_safe_receiver._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp0__anonymous__3 = tmp2_safe_receiver.get_137(tmp0_2);
        if (tmp0__anonymous__3.__requireInvalidate) {
          tmp0__anonymous__3.invalidate_23();
        }}
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  View.prototype.invalidateColorTransform_20 = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.__versionColor;
    tmp0_this.__versionColor = tmp1 + 1 | 0;
    Unit_getInstance();
    this.__requireInvalidateColor = false;
    this._dirtyVertices = true;
    var tmp2_safe_receiver = this.__children;
    if (tmp2_safe_receiver == null)
      null;
    else {
      var n_1 = 0;
      while (n_1 < tmp2_safe_receiver._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp0__anonymous__3 = tmp2_safe_receiver.get_137(tmp0_2);
        if (tmp0__anonymous__3.__requireInvalidateColor) {
          tmp0__anonymous__3.invalidateColorTransform_20();
        }}
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  View.prototype._get_filter__9 = function () {
    return this._filter;
  };
  View.prototype.render_23 = function (ctx) {
    if (!this._get_visible__20())
      return Unit_getInstance();
    if (!(this._filter == null)) {
      renderFiltered(this, ctx, ensureNotNull(this._filter));
    } else {
      this.renderInternal_20(ctx);
    }
  };
  View.prototype.renderDebug_20 = function (ctx) {
    if (this._debugAnnotate ? true : this === ctx._debugAnnotateView) {
      this.renderDebugAnnotationsInternal_20(ctx);
    }};
  View.prototype.renderDebugAnnotationsInternal_20 = function (ctx) {
    var local = this.getLocalBounds$default_20(null, true, 1, null);
    var tmp0_drawVector_0 = _get_debugLineRenderContext_(ctx);
    var tmp1_drawVector_0 = Colors_getInstance()._RED;
    var oldColor_1_1 = tmp0_drawVector_0._color_2;
    tmp0_drawVector_0._color_2 = tmp1_drawVector_0;
    try {
      var tmp0_apply_0_1_3_2 = VectorPath_init_$Create$(null, null, null, 7, null);
      rect_0(tmp0_apply_0_1_3_2, this._get_windowBounds__20());
      tmp0_drawVector_0.drawVector(tmp0_apply_0_1_3_2);
    }finally {
      tmp0_drawVector_0._color_2 = oldColor_1_1;
    }
    var tmp2_drawVector_0 = _get_debugLineRenderContext_(ctx);
    var tmp3_drawVector_0 = Colors_getInstance()._WHITE;
    var oldColor_1_1_0 = tmp2_drawVector_0._color_2;
    tmp2_drawVector_0._color_2 = tmp3_drawVector_0;
    try {
      var tmp0_apply_0_1_3_2_0 = VectorPath_init_$Create$(null, null, null, 7, null);
      var tmp = new Point(local._get_left__4(), local._get_top__4());
      moveTo_0(tmp0_apply_0_1_3_2_0, this.localToGlobal$default_20(tmp, null, 2, null));
      var tmp_0 = new Point(local._get_right__2(), local._get_top__4());
      lineTo_0(tmp0_apply_0_1_3_2_0, this.localToGlobal$default_20(tmp_0, null, 2, null));
      var tmp_1 = new Point(local._get_right__2(), local._get_bottom__2());
      lineTo_0(tmp0_apply_0_1_3_2_0, this.localToGlobal$default_20(tmp_1, null, 2, null));
      var tmp_2 = new Point(local._get_left__4(), local._get_bottom__2());
      lineTo_0(tmp0_apply_0_1_3_2_0, this.localToGlobal$default_20(tmp_2, null, 2, null));
      tmp0_apply_0_1_3_2_0.close_77();
      tmp2_drawVector_0.drawVector(tmp0_apply_0_1_3_2_0);
    }finally {
      tmp2_drawVector_0._color_2 = oldColor_1_1_0;
    }
    var tmp4_drawVector_0 = _get_debugLineRenderContext_(ctx);
    var tmp5_drawVector_0 = Colors_getInstance()._YELLOW;
    var oldColor_1_1_1 = tmp4_drawVector_0._color_2;
    tmp4_drawVector_0._color_2 = tmp5_drawVector_0;
    try {
      var tmp0_apply_0_1_3_2_1 = VectorPath_init_$Create$(null, null, null, 7, null);
      var anchorSize_4 = 5.0;
      var tmp_3 = _get_topLeft_(local);
      circle(tmp0_apply_0_1_3_2_1, this.localToGlobal$default_20(tmp_3, null, 2, null), anchorSize_4);
      var tmp_4 = _get_topRight_(local);
      circle(tmp0_apply_0_1_3_2_1, this.localToGlobal$default_20(tmp_4, null, 2, null), anchorSize_4);
      var tmp_5 = _get_bottomRight_(local);
      circle(tmp0_apply_0_1_3_2_1, this.localToGlobal$default_20(tmp_5, null, 2, null), anchorSize_4);
      var tmp_6 = _get_bottomLeft_(local);
      circle(tmp0_apply_0_1_3_2_1, this.localToGlobal$default_20(tmp_6, null, 2, null), anchorSize_4);
      var tmp_7 = _get_topLeft_(local).interpolateWith(0.5, _get_topRight_(local));
      circle(tmp0_apply_0_1_3_2_1, this.localToGlobal$default_20(tmp_7, null, 2, null), anchorSize_4);
      var tmp_8 = _get_topRight_(local).interpolateWith(0.5, _get_bottomRight_(local));
      circle(tmp0_apply_0_1_3_2_1, this.localToGlobal$default_20(tmp_8, null, 2, null), anchorSize_4);
      var tmp_9 = _get_bottomRight_(local).interpolateWith(0.5, _get_bottomLeft_(local));
      circle(tmp0_apply_0_1_3_2_1, this.localToGlobal$default_20(tmp_9, null, 2, null), anchorSize_4);
      var tmp_10 = _get_bottomLeft_(local).interpolateWith(0.5, _get_topLeft_(local));
      circle(tmp0_apply_0_1_3_2_1, this.localToGlobal$default_20(tmp_10, null, 2, null), anchorSize_4);
      tmp4_drawVector_0.drawVector(tmp0_apply_0_1_3_2_1);
    }finally {
      tmp4_drawVector_0._color_2 = oldColor_1_1_1;
    }
    var tmp6_drawVector_0 = _get_debugLineRenderContext_(ctx);
    var tmp7_drawVector_0 = Colors_getInstance()._BLUE;
    var oldColor_1_1_2 = tmp6_drawVector_0._color_2;
    tmp6_drawVector_0._color_2 = tmp7_drawVector_0;
    try {
      var tmp0_apply_0_1_3_2_2 = VectorPath_init_$Create$(null, null, null, 7, null);
      var centerX_4 = this._get_globalX__20();
      var centerY_5 = this._get_globalY__20();
      line_0(tmp0_apply_0_1_3_2_2, centerX_4, centerY_5 - 5, centerX_4, centerY_5 + 5);
      line_0(tmp0_apply_0_1_3_2_2, centerX_4 - 5, centerY_5, centerX_4 + 5, centerY_5);
      tmp6_drawVector_0.drawVector(tmp0_apply_0_1_3_2_2);
    }finally {
      tmp6_drawVector_0._color_2 = oldColor_1_1_2;
    }
  };
  View.prototype.toString = function () {
    var out = _get_portableSimpleName_(getKClassFromExpression_0(this));
    if (!(this._get_x__36() === 0.0) ? true : !(this._get_y__36() === 0.0))
      out = out + ('' + ':pos=(' + this._get_str__23(this._get_x__36()) + ',' + this._get_str__23(this._get_y__36()) + ')');
    if (!(this._get_scaleX__20() === 1.0) ? true : !(this._get_scaleY__20() === 1.0))
      out = out + ('' + ':scale=(' + this._get_str__23(this._get_scaleX__20()) + ',' + this._get_str__23(this._get_scaleY__20()) + ')');
    if (!(_Angle___get_radians__impl_(this._get_skewX__20()) === 0.0) ? true : !(_Angle___get_radians__impl_(this._get_skewY__20()) === 0.0))
      out = out + ('' + ':skew=(' + this._get_str__23(_get_degrees_(this._get_skewX__20())) + ',' + this._get_str__23(_get_degrees_(this._get_skewY__20())) + ')');
    if (!equals_1(new Angle(_get_absoluteValue_(this._get_rotation__20())), new Angle(_get_radians__0(0))))
      out = out + ('' + ':rotation=(' + this._get_str__23(_get_degrees_(this._get_rotation__20())) + '\xBA)');
    if (!(this._name_29 == null))
      out = out + ('' + ':name=(' + this._name_29 + ')');
    if (!this._blendMode_0.equals(BlendMode_INHERIT_getInstance()))
      out = out + ('' + ':blendMode=(' + this._blendMode_0 + ')');
    if (!this._get_visible__20())
      out = out + ('' + ':visible=' + this._get_visible__20());
    if (!(this._get_alpha__20() === 1.0))
      out = out + ('' + ':alpha=' + this._get_alpha__20());
    if (!(_RGBA___get_rgb__impl_(this._get_colorMul__21()) === _RGBA___get_rgb__impl_(Colors_getInstance()._WHITE)))
      out = out + ('' + ':colorMul=' + _RGBA___get_hexString__impl_(this._get_colorMul__21()));
    if (!equals_1(new ColorAdd(this._get_colorAdd__21()), new ColorAdd(Companion_getInstance_102()._NEUTRAL)))
      out = out + ('' + ':colorAdd=' + _ColorAdd___get_shex__impl_(this._get_colorAdd__21()));
    return out;
  };
  View.prototype._get_str__23 = function (_this__0) {
    return toStringDecimal(_this__0, 2, true);
  };
  View.prototype.globalToLocalX_20 = function (x, y) {
    return this._get_globalMatrixInv__20().transformX(x, y);
  };
  View.prototype.globalToLocalY_20 = function (x, y) {
    return this._get_globalMatrixInv__20().transformY(x, y);
  };
  View.prototype.localToGlobal_20 = function (p, out) {
    return this.localToGlobalXY_20(p._get_x__36(), p._get_y__36(), out);
  };
  View.prototype.localToGlobal$default_20 = function (p, out, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      out = Companion_getInstance_80().invoke_1005();
    return this.localToGlobal_20(p, out);
  };
  View.prototype.localToGlobalXY_20 = function (x, y, out) {
    return this._get_globalMatrix__20().transform_3(x, y, out);
  };
  View.prototype.localToGlobalX_9 = function (x, y) {
    return this._get_globalMatrix__20().transformX(x, y);
  };
  View.prototype.localToGlobalY_9 = function (x, y) {
    return this._get_globalMatrix__20().transformY(x, y);
  };
  View.prototype.hitTest_20 = function (x, y) {
    var tmp0_safe_receiver = this.__children;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var n_1 = 0;
      while (n_1 < tmp0_safe_receiver._get_size__60()) {
        var tmp0__anonymous__3 = tmp0_safe_receiver.get_137((tmp0_safe_receiver._get_size__60() - n_1 | 0) - 1 | 0);
        if (tmp0__anonymous__3._get_visible__20()) {
          var tmp0_safe_receiver_4 = tmp0__anonymous__3.hitTest_20(x, y);
          if (tmp0_safe_receiver_4 == null)
            null;
          else {
            return tmp0_safe_receiver_4;
          }
          Unit_getInstance();
        }var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    Unit_getInstance();
    var res = this.hitTestInternal_20(x, y);
    if (!(res == null))
      return res;
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      {
        tmp = null;
      }
    }
    return tmp;
  };
  View.prototype._set_hitTestUsingShapes__3 = function (_set___) {
    this._hitTestUsingShapes = _set___;
  };
  View.prototype.hitTestInternal_20 = function (x, y) {
    var bounds = this.getLocalBounds$default_20(null, false, 3, null);
    var llx = this.globalToLocalX_20(x, y);
    var lly = this.globalToLocalY_20(x, y);
    if (!bounds.contains_55(llx, lly))
      return null;
    var anchorDispX = this._get_anchorDispX__20();
    var anchorDispY = this._get_anchorDispY__20();
    var lx = llx + anchorDispX;
    var ly = lly + anchorDispY;
    var hitShape = this._get_hitShape__20();
    var hitShapes = this._get_hitShapes__20();
    if (this._hitTestUsingShapes === true ? true : this._hitTestUsingShapes == null ? !(hitShape == null) ? true : !(hitShapes == null) : false) {
      var tmp0_safe_receiver = hitShapes;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var n_1 = 0;
        while (n_1 < tmp0_safe_receiver._get_size__60()) {
          var tmp0_2 = n_1;
          n_1 = tmp0_2 + 1 | 0;
          var tmp0__anonymous__3 = tmp0_safe_receiver.get_137(tmp0_2);
          if (tmp0__anonymous__3.containsPoint_2(lx, ly))
            return this;
        }
        Unit_getInstance();
      }
      Unit_getInstance();
      if (!(hitShape == null) ? hitShape.containsPoint_2(lx, ly) : false)
        return this;
      return null;
    } else {
      return this;
    }
  };
  View.prototype.removeFromParent_20 = function () {
    if (this._parent_5 == null)
      return Unit_getInstance();
    var p = ensureNotNull(this._parent_5);
    var inductionVariable = this._index_19 + 1 | 0;
    var last_1 = p._get_numChildren__8();
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_this = p.get_137(i);
        var tmp2 = tmp1_this._index_19;
        tmp1_this._index_19 = tmp2 - 1 | 0;
        Unit_getInstance();
      }
       while (inductionVariable < last_1);
    var tmp3_safe_receiver = p._get__children__9();
    if (tmp3_safe_receiver == null)
      null;
    else
      tmp3_safe_receiver.removeAt_6(this._index_19);
    Unit_getInstance();
    this._parent_5 = null;
    this._index_19 = -1;
  };
  View.prototype.getConcatMatrix_20 = function (target, out, inclusive) {
    if (target === this._parent_5) {
      out.copyFrom(this._get_localMatrix__20());
      Unit_getInstance();
    } else if (target === this) {
      out.identity_0();
      Unit_getInstance();
    } else {
      var commonAncestor = Companion_getInstance_150().commonAncestor(this, target);
      if (!(commonAncestor === null)) {
        if (target._parent_5 == null ? inclusive : false) {
          return out.copyFrom(this._get_globalMatrix__20());
        }out.multiply_0(this._get_globalMatrix__20(), target._get_globalMatrixInv__20());
        Unit_getInstance();
      } else {
        out.identity_0();
        Unit_getInstance();
      }
    }
    if (inclusive) {
      out.multiply_0(out, target._get_localMatrix__20());
      Unit_getInstance();
    }return out;
  };
  View.prototype._get_windowBounds__20 = function () {
    return this.getWindowBounds$default_20(null, 1, null);
  };
  View.prototype.getWindowBounds_20 = function (out) {
    var tmp = this._get_root__33();
    return this.getBounds$default_23(tmp, out, false, true, 4, null);
  };
  View.prototype.getWindowBounds$default_20 = function (out, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      out = Companion_getInstance_83().invoke_1005();
    return this.getWindowBounds_20(out);
  };
  View.prototype.getGlobalBounds_20 = function (out) {
    var tmp = this._get_root__33();
    return this.getBounds$default_23(tmp, out, false, false, 4, null);
  };
  View.prototype._getBounds_20 = function (concat, out, doAnchoring) {
    this.getLocalBounds_20(out, doAnchoring);
    Unit_getInstance();
    if (!(concat == null) ? !concat.isIdentity_0() : false) {
      var p1x = out._get_left__4();
      var p1y = out._get_top__4();
      var p2x = out._get_right__2();
      var p2y = out._get_top__4();
      var p3x = out._get_right__2();
      var p3y = out._get_bottom__2();
      var p4x = out._get_left__4();
      var p4y = out._get_bottom__2();
      this._bb_2.reset_9();
      this._bb_2.add_52(concat.transformX(p1x, p1y), concat.transformY(p1x, p1y));
      Unit_getInstance();
      this._bb_2.add_52(concat.transformX(p2x, p2y), concat.transformY(p2x, p2y));
      Unit_getInstance();
      this._bb_2.add_52(concat.transformX(p3x, p3y), concat.transformY(p3x, p3y));
      Unit_getInstance();
      this._bb_2.add_52(concat.transformX(p4x, p4y), concat.transformY(p4x, p4y));
      Unit_getInstance();
      this._bb_2.getBounds_0(out);
      Unit_getInstance();
    }return out;
  };
  View.prototype.getBounds_24 = function (target, out, doAnchoring, inclusive) {
    var tmp0_elvis_lhs = target;
    return this._getBounds_20(this.getConcatMatrix_20(tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs, this._boundsTemp, inclusive), out, doAnchoring);
  };
  View.prototype.getBounds$default_23 = function (target, out, doAnchoring, inclusive, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      target = this;
    if (!(($mask0 & 2) === 0))
      out = Companion_getInstance_83().invoke_1005();
    if (!(($mask0 & 4) === 0))
      doAnchoring = true;
    if (!(($mask0 & 8) === 0))
      inclusive = false;
    return this.getBounds_24(target, out, doAnchoring, inclusive);
  };
  View.prototype.getLocalBounds_20 = function (out, doAnchoring) {
    this.getLocalBoundsInternal_20(out);
    var it = out;
    if (!doAnchoring) {
      var tmp0_this = it;
      tmp0_this._x_3 = tmp0_this._x_3 + this._get_anchorDispX__20();
      var tmp1_this = it;
      tmp1_this._y_3 = tmp1_this._y_3 + this._get_anchorDispY__20();
    }return it;
  };
  View.prototype.getLocalBounds$default_20 = function (out, doAnchoring, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      out = Companion_getInstance_83().invoke_1005();
    if (!(($mask0 & 2) === 0))
      doAnchoring = true;
    return this.getLocalBounds_20(out, doAnchoring);
  };
  View.prototype.getLocalBoundsInternal_20 = function (out) {
    out.clear_19();
    Unit_getInstance();
  };
  View.$metadata$ = {
    simpleName: 'View',
    kind: 'class',
    interfaces: [Renderable, Extra, KorgeDebugNode, BView]
  };
  function hasAncestor(_this_, ancestor) {
    var tmp;
    if (equals_1(_this_, ancestor)) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = _this_._parent_5;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
      tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    }
    return tmp;
  }
  function _get_ancestorCount_(_this_) {
    var count_0 = 0;
    var tmp0_safe_receiver = _this_;
    var parent = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._parent_5;
    while (!(parent == null)) {
      var tmp1 = count_0;
      count_0 = tmp1 + 1 | 0;
      Unit_getInstance();
      parent = parent._get_parent__14();
    }
    return count_0;
  }
  function addUpdater(_this_, updatable) {
    var component = attach_0(new _no_name_provided__517(_this_, updatable));
    component.update_13(Companion_getInstance_27()._ZERO);
    var tmp = _no_name_provided_$factory_469(component);
    return new sam$com_soywiz_korio_lang_Cancellable$0_0(tmp);
  }
  function addFixedUpdater(_this_, time, initial, limitCallsPerFrame, updatable) {
    var tmp0__get_milliseconds__0 = 0.0;
    var accum = {_v: new TimeSpan(Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0))};
    var component = attach_0(new _no_name_provided__519(_this_, accum, time, updatable, limitCallsPerFrame));
    if (initial) {
      updatable(_this_);
    }var tmp = _no_name_provided_$factory_470(component);
    return new sam$com_soywiz_korio_lang_Cancellable$0_0(tmp);
  }
  function ViewLeaf() {
  }
  ViewLeaf.$metadata$ = {
    simpleName: 'ViewLeaf',
    kind: 'interface',
    interfaces: []
  };
  function position(_this_, x, y) {
    return xy(_this_, x, y);
  }
  function scale_0(_this_, sx, sy) {
    _this_._set_scaleX__20(sx);
    _this_._set_scaleY__20(sy);
    return _this_;
  }
  function scale$default(_this_, sx, sy, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      sy = sx;
    return scale_0(_this_, sx, sy);
  }
  function position_0(_this_, x, y) {
    return xy(_this_, x, y);
  }
  function size_0(_this_, width, height) {
    _this_._set_width__27(width);
    _this_._set_height__27(height);
    return _this_;
  }
  function foreachDescendant(_this_, handler) {
    if (!(_this_ == null)) {
      handler(_this_);
      if (_this_._isContainer) {
        var tmp0_safe_receiver_1 = _this_.__children;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          var n_1_2 = 0;
          while (n_1_2 < tmp0_safe_receiver_1._get_size__60()) {
            var tmp0_2_3 = n_1_2;
            n_1_2 = tmp0_2_3 + 1 | 0;
            var tmp0__anonymous__4 = tmp0_safe_receiver_1.get_137(tmp0_2_3);
            foreachDescendant(tmp0__anonymous__4, handler);
          }
          Unit_getInstance();
        }
        Unit_getInstance();
      }}}
  function xy(_this_, x, y) {
    _this_._set_x__27(x);
    _this_._set_y__27(y);
    return _this_;
  }
  function xy_0(_this_, x, y) {
    return xy(_this_, x, y);
  }
  function addFixedUpdater_0(_this_, timesPerSecond, initial, limitCallsPerFrame, updatable) {
    return addFixedUpdater(_this_, _Frequency___get_timeSpan__impl_(timesPerSecond), initial, limitCallsPerFrame, updatable);
  }
  function addFixedUpdater$default(_this_, timesPerSecond, initial, limitCallsPerFrame, updatable, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      initial = true;
    if (!(($mask0 & 4) === 0))
      limitCallsPerFrame = 16;
    return addFixedUpdater_0(_this_, timesPerSecond, initial, limitCallsPerFrame, updatable);
  }
  function sam$com_soywiz_korio_lang_Cancellable$0_0(function_0) {
    this._function_4 = function_0;
  }
  sam$com_soywiz_korio_lang_Cancellable$0_0.prototype.cancel_27 = function (e) {
    return this._function_4(e);
  };
  sam$com_soywiz_korio_lang_Cancellable$0_0.$metadata$ = {
    simpleName: 'sam$com_soywiz_korio_lang_Cancellable$0',
    kind: 'class',
    interfaces: [Cancellable]
  };
  function _no_name_provided__517($this_addUpdater, $updatable) {
    this._$this_addUpdater = $this_addUpdater;
    this._$updatable = $updatable;
  }
  _no_name_provided__517.prototype._get_view__6 = function () {
    return this._$this_addUpdater;
  };
  _no_name_provided__517.prototype.update_13 = function (dt) {
    this._$updatable(this._$this_addUpdater, new TimeSpan(dt));
  };
  _no_name_provided__517.$metadata$ = {
    kind: 'class',
    interfaces: [UpdateComponent]
  };
  function _no_name_provided__518($component) {
    this._$component = $component;
  }
  _no_name_provided__518.prototype.invoke_903 = function (it) {
    detach(this._$component);
    Unit_getInstance();
  };
  _no_name_provided__518.prototype.invoke_1015 = function (p1) {
    this.invoke_903(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__518.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__519($this_addFixedUpdater, $accum, $time, $updatable, $limitCallsPerFrame) {
    this._$this_addFixedUpdater = $this_addFixedUpdater;
    this._$accum = $accum;
    this._$time_1 = $time;
    this._$updatable_0 = $updatable;
    this._$limitCallsPerFrame = $limitCallsPerFrame;
  }
  _no_name_provided__519.prototype._get_view__6 = function () {
    return this._$this_addFixedUpdater;
  };
  _no_name_provided__519.prototype.update_13 = function (dt) {
    this._$accum._v = new TimeSpan(TimeSpan__plus_impl(this._$accum._v._milliseconds, dt));
    var calls = 0;
    $l$break: while (TimeSpan__compareTo_impl(this._$accum._v._milliseconds, TimeSpan__times_impl_0(this._$time_1, 0.75)) >= 0) {
      this._$accum._v = new TimeSpan(TimeSpan__minus_impl(this._$accum._v._milliseconds, this._$time_1));
      this._$updatable_0(this._$this_addFixedUpdater);
      var tmp0 = calls;
      calls = tmp0 + 1 | 0;
      Unit_getInstance();
      if (calls >= this._$limitCallsPerFrame) {
        var tmp0__get_milliseconds__0 = 0.0;
        this._$accum._v = new TimeSpan(Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0));
        break $l$break;
      }}
    if (calls > 0) {
      if (TimeSpan__compareTo_impl(this._$accum._v._milliseconds, TimeSpan__times_impl_0(this._$time_1, 0.25)) < 0) {
        var tmp1__get_milliseconds__0 = 0.0;
        this._$accum._v = new TimeSpan(Companion_getInstance_27().fromMilliseconds(tmp1__get_milliseconds__0));
      }}};
  _no_name_provided__519.$metadata$ = {
    kind: 'class',
    interfaces: [UpdateComponent]
  };
  function _no_name_provided__520($component) {
    this._$component_0 = $component;
  }
  _no_name_provided__520.prototype.invoke_903 = function (it) {
    detach(this._$component_0);
    Unit_getInstance();
  };
  _no_name_provided__520.prototype.invoke_1015 = function (p1) {
    this.invoke_903(p1 instanceof Error ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__520.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_468(this$0) {
    var i = new _no_name_provided__516(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_469($component) {
    var i = new _no_name_provided__518($component);
    return function (p1) {
      i.invoke_903(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_470($component) {
    var i = new _no_name_provided__520($component);
    return function (p1) {
      i.invoke_903(p1);
      return Unit_getInstance();
    };
  }
  function _get_collisionContext_() {
    var tmp0_getValue_0 = collisionContext$delegate;
    var tmp1_getValue_0 = null;
    var tmp2_getValue_0 = collisionContext$factory();
    return tmp0_getValue_0._local.get_85();
  }
  var collisionContext$delegate;
  function ViewCollisionContext() {
    this._tempRect1 = Companion_getInstance_83().invoke_1005();
    this._tempRect2 = Companion_getInstance_83().invoke_1005();
    var tmp = this;
    tmp._tempVectorPath1 = listOf_0(VectorPath_init_$Create$(null, null, null, 7, null));
    var tmp_0 = this;
    tmp_0._tempVectorPath2 = listOf_0(VectorPath_init_$Create$(null, null, null, 7, null));
    var tmp_1 = this;
    tmp_1._ident = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_2 = this;
    tmp_2._lmat = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
    var tmp_3 = this;
    tmp_3._rmat = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  }
  ViewCollisionContext.prototype.getVectorPath = function (view, out) {
    var hitShape = view._get_hitShape__20();
    var hitShapes = view._get_hitShapes__20();
    if (!(hitShapes == null))
      return hitShapes;
    if (!(hitShape == null))
      return listOf_0(hitShape);
    view.getLocalBounds$default_20(this._tempRect1, false, 2, null);
    Unit_getInstance();
    out.get_137(0).clear_33();
    var dispX = view._get_anchorDispX__20();
    var dispY = view._get_anchorDispY__20();
    rect(out.get_137(0), this._tempRect1._x_3 + dispX, this._tempRect1._y_3 + dispY, this._tempRect1._width_0, this._tempRect1._height_0);
    return out;
  };
  ViewCollisionContext.prototype.getGlobalMatrix = function (view, out) {
    out.copyFrom(view._get_localMatrix__20());
    Unit_getInstance();
    out.pretranslate(-view._get_anchorDispX__20(), -view._get_anchorDispY__20());
    Unit_getInstance();
    var tmp0_safe_receiver = view._parent_5;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_globalMatrix__20();
    out.multiply_0(out, tmp1_elvis_lhs == null ? this._ident : tmp1_elvis_lhs);
    Unit_getInstance();
    return out;
  };
  ViewCollisionContext.prototype.collidesWith = function (left, right, kind) {
    left.getGlobalBounds_20(this._tempRect1);
    Unit_getInstance();
    right.getGlobalBounds_20(this._tempRect2);
    Unit_getInstance();
    if (!this._tempRect1.intersects(this._tempRect2))
      return false;
    if (kind.equals(CollisionKind_SHAPE_getInstance())) {
      var leftPaths = this.getVectorPath(left, this._tempVectorPath1);
      var rightPaths = this.getVectorPath(right, this._tempVectorPath2);
      var n_1 = 0;
      while (n_1 < leftPaths._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp0__anonymous__3 = leftPaths.get_137(tmp0_2);
        var n_1_4 = 0;
        while (n_1_4 < rightPaths._get_size__60()) {
          var tmp0_2_6 = n_1_4;
          n_1_4 = tmp0_2_6 + 1 | 0;
          var tmp0__anonymous__3_5 = rightPaths.get_137(tmp0_2_6);
          if (Companion_getInstance_95().intersects_0(tmp0__anonymous__3, this.getGlobalMatrix(left, this._lmat), tmp0__anonymous__3_5, this.getGlobalMatrix(right, this._rmat)))
            return true;
        }
      }
      return false;
    }return true;
  };
  ViewCollisionContext.$metadata$ = {
    simpleName: 'ViewCollisionContext',
    kind: 'class',
    interfaces: []
  };
  var CollisionKind_GLOBAL_RECT_instance;
  var CollisionKind_SHAPE_instance;
  var CollisionKind_entriesInitialized;
  function CollisionKind_initEntries() {
    if (CollisionKind_entriesInitialized)
      return Unit_getInstance();
    CollisionKind_entriesInitialized = true;
    CollisionKind_GLOBAL_RECT_instance = new CollisionKind('GLOBAL_RECT', 0);
    CollisionKind_SHAPE_instance = new CollisionKind('SHAPE', 1);
  }
  function CollisionKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  CollisionKind.$metadata$ = {
    simpleName: 'CollisionKind',
    kind: 'class',
    interfaces: []
  };
  function collidesWith(_this_, other, kind) {
    return _get_collisionContext_().collidesWith(_this_, other, kind);
  }
  function collidesWith$default(_this_, other, kind, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      kind = CollisionKind_GLOBAL_RECT_getInstance();
    return collidesWith(_this_, other, kind);
  }
  function _no_name_provided__521() {
  }
  _no_name_provided__521.prototype.invoke_1005 = function () {
    return new ViewCollisionContext();
  };
  _no_name_provided__521.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function CollisionKind_GLOBAL_RECT_getInstance() {
    CollisionKind_initEntries();
    return CollisionKind_GLOBAL_RECT_instance;
  }
  function CollisionKind_SHAPE_getInstance() {
    CollisionKind_initEntries();
    return CollisionKind_SHAPE_instance;
  }
  function collisionContext$factory() {
    return getPropertyCallableRef('collisionContext', 0, KProperty0, function () {
      return _get_collisionContext_();
    }, null);
  }
  function _no_name_provided_$factory_471() {
    var i = new _no_name_provided__521();
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided__522($view, $ctx, this$0, resultContinuation) {
    this._$view = $view;
    this._$ctx_2 = $ctx;
    this._this$0_156 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__522.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__522.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__522.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = ensureNotNull(this._$ctx_2._views_4);
            suspendResult = this._$view.forceLoadSourceFile$default_1(tmp_0, null, this._this$0_156._sourceFile_1, 2, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__522.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__522(this._$view, this._$ctx_2, this._this$0_156, completion);
    return i;
  };
  _no_name_provided__522.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function Mixin_2() {
    this._sourceTreeLoaded = true;
    this._sourceFile_1 = null;
  }
  Mixin_2.prototype._set_sourceTreeLoaded__1 = function (_set___) {
    this._sourceTreeLoaded = _set___;
  };
  Mixin_2.prototype._set_sourceFile__1 = function (value) {
    println('' + 'SET sourceFile=' + value);
    this._sourceTreeLoaded = false;
    this._sourceFile_1 = value;
  };
  Mixin_2.prototype.baseForceLoadSourceFile_0 = function (_this__0, views, currentVfs, sourceFile, $cont) {
    _this__0._set_sourceFile__1(sourceFile);
    _this__0._set_sourceTreeLoaded__1(true);
  };
  Mixin_2.prototype.forceLoadSourceFile_1 = function (views, currentVfs, sourceFile, $cont) {
    var tmp0_TODO_0 = 'Must override this';
    throw new NotImplementedError('' + 'An operation is not implemented: ' + tmp0_TODO_0);
  };
  Mixin_2.prototype.lazyLoadRenderInternal_0 = function (ctx, view) {
    if (!this._sourceTreeLoaded ? !(this._sourceFile_1 == null) : false) {
      this._sourceTreeLoaded = true;
      launchImmediately(ctx._coroutineContext_5, _no_name_provided_$factory_472(view, ctx, this, null));
      Unit_getInstance();
    }};
  Mixin_2.$metadata$ = {
    simpleName: 'Mixin',
    kind: 'class',
    interfaces: [ViewFileRef]
  };
  function ViewFileRef() {
  }
  ViewFileRef.prototype.forceLoadSourceFile$default_1 = function (views, currentVfs, sourceFile, $mask0, $handler, $cont) {
    if (!(($mask0 & 2) === 0))
      currentVfs = views._currentVfs_1;
    if (!(($mask0 & 4) === 0))
      sourceFile = null;
    return $handler == null ? this.forceLoadSourceFile_1(views, currentVfs, sourceFile, $cont) : $handler(views, currentVfs, sourceFile);
  };
  ViewFileRef.$metadata$ = {
    simpleName: 'ViewFileRef',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided_$factory_472($view, $ctx, this$0, resultContinuation) {
    var i = new _no_name_provided__522($view, $ctx, this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  var views$delegate;
  function KorgeFileLoaderTester(name, tester) {
    this._name_30 = name;
    this._tester = tester;
  }
  KorgeFileLoaderTester.prototype.toString = function () {
    return '' + 'KorgeFileTester("' + this._name_30 + '")';
  };
  KorgeFileLoaderTester.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_30);
    result = imul(result, 31) + hashCode(this._tester) | 0;
    return result;
  };
  KorgeFileLoaderTester.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeFileLoaderTester))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof KorgeFileLoaderTester ? other : THROW_CCE();
    if (!(this._name_30 === tmp0_other_with_cast._name_30))
      return false;
    if (!equals_1(this._tester, tmp0_other_with_cast._tester))
      return false;
    return true;
  };
  KorgeFileLoaderTester.$metadata$ = {
    simpleName: 'KorgeFileLoaderTester',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__523(this$0) {
    this._this$0_157 = this$0;
  }
  _no_name_provided__523.prototype.invoke_1005 = function () {
    return !(this._this$0_157._settingsFolder_1 == null) ? ensureNotNull(this._this$0_157._settingsFolder_1) : OS_getInstance()._get_isMac_() ? '' + '/Users/' + Environment_getInstance().get_115('USER') + '/Library/Preferences/' + this._this$0_157._get_gameIdFolder_() : OS_getInstance()._get_isWindows_() ? '' + Environment_getInstance().get_115('APPDATA') + '/' + this._this$0_157._get_gameIdFolder_() : '' + Environment_getInstance().get_115('HOME') + '/.config/' + this._this$0_157._get_gameIdFolder_();
  };
  _no_name_provided__523.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__524($callback) {
    this._$callback_6 = $callback;
  }
  _no_name_provided__524.prototype.close_77 = function ($cont) {
    return this._$callback_6($cont);
  };
  _no_name_provided__524.$metadata$ = {
    kind: 'class',
    interfaces: [AsyncCloseable]
  };
  function _no_name_provided__525(this$0) {
    this._this$0_158 = this$0;
  }
  _no_name_provided__525.prototype.invoke_909 = function (it) {
    this._this$0_158._renderContext.flush_8();
    this._this$0_158._renderContext.finish_0();
    this._this$0_158._agBitmapTextureManager_1.afterRender();
  };
  _no_name_provided__525.prototype.invoke_1015 = function (p1) {
    this.invoke_909(p1 instanceof RenderContext ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__525.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $closeCOROUTINE$34(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__162 = _this_;
  }
  $closeCOROUTINE$34.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            var tmp_0 = this;
            tmp_0._tmp0_fastForEach_00_0 = this.__this__162._closeables;
            this._n_11_0 = 0;
            this._state_1 = 1;
            continue $sm;
          case 1:
            if (!(this._n_11_0 < this._tmp0_fastForEach_00_0._get_size__60())) {
              this._state_1 = 3;
              continue $sm;
            }
            var tmp_1 = this;
            var tmp0_2 = this._n_11_0;
            this._n_11_0 = tmp0_2 + 1 | 0;
            tmp_1._tmp1__anonymous__32_0 = this._tmp0_fastForEach_00_0.get_137(tmp0_2);
            this._state_1 = 2;
            suspendResult = this._tmp1__anonymous__32_0.close_77(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            this._state_1 = 1;
            continue $sm;
          case 3:
            this.__this__162._closeables.clear_33();
            cancel$default(this.__this__162._coroutineContext_6, null, 1, null);
            this.__this__162._gameWindow_1.close_77();
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $closeCOROUTINE$34.$metadata$ = {
    simpleName: '$closeCOROUTINE$34',
    kind: 'class',
    interfaces: []
  };
  function Views(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads) {
    this._coroutineContext_6 = coroutineContext;
    this._ag_6 = ag;
    this._injector_7 = injector;
    this._input_0 = input;
    this._timeProvider_1 = timeProvider;
    this._stats_0 = stats;
    this._gameWindow_1 = gameWindow;
    this._gameId_1 = gameId;
    this._settingsFolder_1 = settingsFolder;
    this._batchMaxQuads_2 = batchMaxQuads;
    var tmp = this;
    tmp._$$delegate_0_24 = Mixin_init_$Create$(null, 1, null);
    this._$$delegate_1_0 = new Mixin_1();
    this._views_9 = this;
    this._serializer = new KTreeSerializer(this);
    var tmp_0 = this;
    tmp_0._realSettingsFolder$delegate = lazy(_no_name_provided_$factory_474(this));
    this._name_31 = null;
    this._currentVfs_1 = _get_resourcesVfs_();
    this._imageFormats_3 = RegisteredImageFormats_getInstance();
    this._renderContext = new RenderContext(this._ag_6, this, this._stats_0, this._coroutineContext_6, this._batchMaxQuads_2);
    this._agBitmapTextureManager_1 = this._renderContext._agBitmapTextureManager;
    this._clearEachFrame_1 = true;
    this._clearColor = Colors_getInstance()._BLACK;
    var tmp_1 = this;
    tmp_1._propsTriggers = HashMap_init_$Create$();
    var tmp_2 = this;
    var tmp0__get_milliseconds__0 = 100.0;
    tmp_2._clampElapsedTimeTo = Companion_getInstance_27().fromMilliseconds(tmp0__get_milliseconds__0);
    var tmp_3 = this;
    var tmp_4 = this._currentVfs_1;
    tmp_3._resources = Resources_init_$Create$(this._coroutineContext_6, tmp_4, null, 4, null);
    this._editingMode = false;
    this._virtualWidth_0 = 1280;
    this._virtualHeight_0 = 720;
    this._actualVirtualLeft = 0;
    this._actualVirtualTop = 0;
    this._actualVirtualWidth = 1280;
    this._actualVirtualHeight = 720;
    var tmp_5 = this;
    tmp_5._closeables = ArrayList_init_$Create$();
    this._scaleMode_4 = Companion_getInstance_85()._SHOW_ALL;
    this._scaleAnchor_1 = Companion_getInstance_74()._MIDDLE_CENTER;
    this._clipBorders_1 = true;
    var tmp_6 = this;
    tmp_6._resizedEvent = ReshapeEvent_init_$Create$(0, 0, 0, 0, 12, null);
    this._stage_0 = new Stage(this);
    this._root_3 = this._stage_0;
    this._supportTogglingDebug = true;
    this._debugViews = false;
    this._debugHandlers = FastArrayList_init_$Create$();
    this._lastTime_0 = this._timeProvider_1.now_2();
    this._tempViews = FastArrayList_init_$Create$();
    this._virtualSize = Companion_getInstance_87().invoke_324();
    this._actualSize = Companion_getInstance_87().invoke_324();
    this._targetSize = Companion_getInstance_87().invoke_324();
    var tmp_7 = this;
    tmp_7._onBeforeRender = Signal_init_$Create$(null, 1, null);
    var tmp_8 = this;
    tmp_8._onAfterRender = Signal_init_$Create$(null, 1, null);
    this._targetFps_1 = -1.0;
    this._injector_7.mapInstance(getKClass_0(CoroutineContext), this._coroutineContext_6);
    Unit_getInstance();
    this._injector_7.mapInstance(getKClass_0(AG), this._ag_6);
    Unit_getInstance();
    this._injector_7.mapInstance(getKClass_0(Views), this);
    Unit_getInstance();
    this._onAfterRender.invoke_133(_no_name_provided_$factory_475(this));
    Unit_getInstance();
    installFpsDebugOverlay(this);
    var tmp_9 = this;
    tmp_9._debugHighlighters = Signal_init_$Create$(null, 1, null);
    var tmp_10 = this;
    tmp_10._debugSavedHandlers = Signal_init_$Create$(null, 1, null);
    var tmp_11 = this;
    tmp_11._completedEditing = Signal_init_$Create$(null, 1, null);
    var tmp_12 = this;
    tmp_12._viewExtraBuildDebugComponent = ArrayList_init_$Create$();
  }
  Views.prototype._get_coroutineContext__22 = function () {
    return this._coroutineContext_6;
  };
  Views.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_24._extra = _set___;
  };
  Views.prototype._get_extra__71 = function () {
    return this._$$delegate_0_24._extra;
  };
  Views.prototype.addEventListener_6 = function (clazz, handler) {
    return this._$$delegate_1_0.addEventListener_6(clazz, handler);
  };
  Views.prototype._get_views__7 = function () {
    return this._views_9;
  };
  Views.prototype._get_gameIdFolder_ = function () {
    var tmp = replace$default_0(this._gameId_1, '\\', '', false, 4, null);
    var tmp_0 = replace$default_0(tmp, '/', '', false, 4, null);
    return replace$default_0(tmp_0, '..', '', false, 4, null);
  };
  Views.prototype._get_globalResources_ = function () {
    return this._resources;
  };
  Views.prototype._get_nativeWidth_ = function () {
    return this._ag_6._get_mainRenderBuffer__4()._get_width__58();
  };
  Views.prototype._get_nativeHeight_ = function () {
    return this._ag_6._get_mainRenderBuffer__4()._get_height__58();
  };
  Views.prototype.onClose = function (callback) {
    var tmp0_this = this;
    var tmp0_plusAssign_0 = tmp0_this._closeables;
    var tmp1_plusAssign_0 = new _no_name_provided__524(callback);
    tmp0_plusAssign_0.add_39(tmp1_plusAssign_0);
    Unit_getInstance();
  };
  Views.prototype.close_77 = function ($cont) {
    var tmp = new $closeCOROUTINE$34(this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Views.prototype._get_nativeMouseX_ = function () {
    return this._input_0._mouse_0._x_2;
  };
  Views.prototype._get_nativeMouseY_ = function () {
    return this._input_0._mouse_0._y_2;
  };
  Views.prototype.addDebugRenderer = function (block) {
    this._debugHandlers.add_39(block);
    Unit_getInstance();
  };
  Views.prototype.dispatch_16 = function (clazz, event) {
    var e = event;
    try {
      this._stage_0.dispatch_16(clazz, event);
      var stagedViews = getAllDescendantViews(this._stage_0, this._tempViews, true);
      var tmp0_subject = e;
      if (tmp0_subject instanceof MouseEvent_0) {
        var n_1 = 0;
        while (n_1 < stagedViews._get_size__60()) {
          var tmp0_2 = n_1;
          n_1 = tmp0_2 + 1 | 0;
          var tmp0__anonymous__3 = stagedViews.get_137(tmp0_2);
          var tmp0_safe_receiver_5 = tmp0__anonymous__3._get__components__21();
          var tmp1_safe_receiver_4 = tmp0_safe_receiver_5 == null ? null : tmp0_safe_receiver_5._mouse;
          if (tmp1_safe_receiver_4 == null)
            null;
          else {
            var n_1_6 = 0;
            while (n_1_6 < tmp1_safe_receiver_4._get_size__60()) {
              var tmp0_2_8 = n_1_6;
              n_1_6 = tmp0_2_8 + 1 | 0;
              var tmp0__anonymous__3_7 = tmp1_safe_receiver_4.get_137(tmp0_2_8);
              tmp0__anonymous__3_7.onMouseEvent_0(this._views_9, e);
            }
            Unit_getInstance();
          }
          Unit_getInstance();
        }
      } else {
        if (tmp0_subject instanceof TouchEvent_0) {
          var n_1_0 = 0;
          while (n_1_0 < stagedViews._get_size__60()) {
            var tmp0_2_0 = n_1_0;
            n_1_0 = tmp0_2_0 + 1 | 0;
            var tmp1__anonymous__3 = stagedViews.get_137(tmp0_2_0);
            var tmp0_safe_receiver_5_0 = tmp1__anonymous__3._get__components__21();
            var tmp1_safe_receiver_4_0 = tmp0_safe_receiver_5_0 == null ? null : tmp0_safe_receiver_5_0._touch;
            if (tmp1_safe_receiver_4_0 == null)
              null;
            else {
              var n_1_6_0 = 0;
              while (n_1_6_0 < tmp1_safe_receiver_4_0._get_size__60()) {
                var tmp0_2_8_0 = n_1_6_0;
                n_1_6_0 = tmp0_2_8_0 + 1 | 0;
                var tmp0__anonymous__3_7_0 = tmp1_safe_receiver_4_0.get_137(tmp0_2_8_0);
                tmp0__anonymous__3_7_0.onTouchEvent__error(this._views_9, e);
              }
              Unit_getInstance();
            }
            Unit_getInstance();
          }
        } else {
          if (tmp0_subject instanceof ReshapeEvent) {
            var n_1_1 = 0;
            while (n_1_1 < stagedViews._get_size__60()) {
              var tmp0_2_1 = n_1_1;
              n_1_1 = tmp0_2_1 + 1 | 0;
              var tmp2__anonymous__3 = stagedViews.get_137(tmp0_2_1);
              var tmp0_safe_receiver_5_1 = tmp2__anonymous__3._get__components__21();
              var tmp1_safe_receiver_4_1 = tmp0_safe_receiver_5_1 == null ? null : tmp0_safe_receiver_5_1._resize;
              if (tmp1_safe_receiver_4_1 == null)
                null;
              else {
                var n_1_6_1 = 0;
                while (n_1_6_1 < tmp1_safe_receiver_4_1._get_size__60()) {
                  var tmp0_2_8_1 = n_1_6_1;
                  n_1_6_1 = tmp0_2_8_1 + 1 | 0;
                  var tmp0__anonymous__3_7_1 = tmp1_safe_receiver_4_1.get_137(tmp0_2_8_1);
                  tmp0__anonymous__3_7_1.resized__error(this._views_9, e._width_12, e._height_12);
                }
                Unit_getInstance();
              }
              Unit_getInstance();
            }
          } else {
            if (tmp0_subject instanceof KeyEvent) {
              this._input_0.triggerOldKeyEvent(e);
              this._input_0._keys_0.triggerKeyEvent(e);
              if ((e._type_8.equals(Type_UP_getInstance_0()) ? this._supportTogglingDebug : false) ? e._key_3.equals(Key_F12_getInstance()) ? true : e._key_3.equals(Key_F7_getInstance()) : false) {
                this._debugViews = !this._debugViews;
                this._gameWindow_1._set_debug__1(this._debugViews);
              }var n_1_2 = 0;
              while (n_1_2 < stagedViews._get_size__60()) {
                var tmp0_2_2 = n_1_2;
                n_1_2 = tmp0_2_2 + 1 | 0;
                var tmp3__anonymous__3 = stagedViews.get_137(tmp0_2_2);
                var tmp0_safe_receiver_5_2 = tmp3__anonymous__3._get__components__21();
                var tmp1_safe_receiver_4_2 = tmp0_safe_receiver_5_2 == null ? null : tmp0_safe_receiver_5_2._key_4;
                if (tmp1_safe_receiver_4_2 == null)
                  null;
                else {
                  var n_1_6_2 = 0;
                  while (n_1_6_2 < tmp1_safe_receiver_4_2._get_size__60()) {
                    var tmp0_2_8_2 = n_1_6_2;
                    n_1_6_2 = tmp0_2_8_2 + 1 | 0;
                    var tmp0__anonymous__3_7_2 = tmp1_safe_receiver_4_2.get_137(tmp0_2_8_2);
                    tmp0__anonymous__3_7_2.onKeyEvent_0(this._views_9, e);
                    Unit_getInstance();
                  }
                  Unit_getInstance();
                }
                Unit_getInstance();
              }
            } else {
              if (tmp0_subject instanceof GamePadConnectionEvent) {
                var n_1_3 = 0;
                while (n_1_3 < stagedViews._get_size__60()) {
                  var tmp0_2_3 = n_1_3;
                  n_1_3 = tmp0_2_3 + 1 | 0;
                  var tmp4__anonymous__3 = stagedViews.get_137(tmp0_2_3);
                  var tmp0_safe_receiver_5_3 = tmp4__anonymous__3._get__components__21();
                  var tmp1_safe_receiver_4_3 = tmp0_safe_receiver_5_3 == null ? null : tmp0_safe_receiver_5_3._gamepad_2;
                  if (tmp1_safe_receiver_4_3 == null)
                    null;
                  else {
                    var n_1_6_3 = 0;
                    while (n_1_6_3 < tmp1_safe_receiver_4_3._get_size__60()) {
                      var tmp0_2_8_3 = n_1_6_3;
                      n_1_6_3 = tmp0_2_8_3 + 1 | 0;
                      var tmp0__anonymous__3_7_3 = tmp1_safe_receiver_4_3.get_137(tmp0_2_8_3);
                      tmp0__anonymous__3_7_3.onGamepadEvent_2(this._views_9, e);
                    }
                    Unit_getInstance();
                  }
                  Unit_getInstance();
                }
              } else {
                if (tmp0_subject instanceof GamePadUpdateEvent) {
                  var n_1_4 = 0;
                  while (n_1_4 < stagedViews._get_size__60()) {
                    var tmp0_2_4 = n_1_4;
                    n_1_4 = tmp0_2_4 + 1 | 0;
                    var tmp5__anonymous__3 = stagedViews.get_137(tmp0_2_4);
                    var tmp0_safe_receiver_5_4 = tmp5__anonymous__3._get__components__21();
                    var tmp1_safe_receiver_4_4 = tmp0_safe_receiver_5_4 == null ? null : tmp0_safe_receiver_5_4._gamepad_2;
                    if (tmp1_safe_receiver_4_4 == null)
                      null;
                    else {
                      var n_1_6_4 = 0;
                      while (n_1_6_4 < tmp1_safe_receiver_4_4._get_size__60()) {
                        var tmp0_2_8_4 = n_1_6_4;
                        n_1_6_4 = tmp0_2_8_4 + 1 | 0;
                        var tmp0__anonymous__3_7_4 = tmp1_safe_receiver_4_4.get_137(tmp0_2_8_4);
                        tmp0__anonymous__3_7_4.onGamepadEvent_1(this._views_9, e);
                      }
                      Unit_getInstance();
                    }
                    Unit_getInstance();
                  }
                } else {
                  {
                    var n_1_5 = 0;
                    while (n_1_5 < stagedViews._get_size__60()) {
                      var tmp0_2_5 = n_1_5;
                      n_1_5 = tmp0_2_5 + 1 | 0;
                      var tmp6__anonymous__3 = stagedViews.get_137(tmp0_2_5);
                      var tmp0_safe_receiver_5_5 = tmp6__anonymous__3._get__components__21();
                      var tmp1_safe_receiver_4_5 = tmp0_safe_receiver_5_5 == null ? null : tmp0_safe_receiver_5_5._event_0;
                      if (tmp1_safe_receiver_4_5 == null)
                        null;
                      else {
                        var n_1_6_5 = 0;
                        while (n_1_6_5 < tmp1_safe_receiver_4_5._get_size__60()) {
                          var tmp0_2_8_5 = n_1_6_5;
                          n_1_6_5 = tmp0_2_8_5 + 1 | 0;
                          var tmp0__anonymous__3_7_5 = tmp1_safe_receiver_4_5.get_137(tmp0_2_8_5);
                          tmp0__anonymous__3_7_5.onEvent__error(e);
                        }
                        Unit_getInstance();
                      }
                      Unit_getInstance();
                    }
                  }
                }
              }
            }
          }
        }
      }
    } catch ($p) {
      if ($p instanceof PreventDefaultException) {
      } else {
        {
          throw $p;
        }
      }
    }
  };
  Views.prototype.render_24 = function () {
    this._ag_6.startFrame_8();
    if (this._clearEachFrame_1) {
      var tmp0_color = this._clearColor;
      this._ag_6.clear_28(tmp0_color, 1.0, 0, true, true, true);
    }this._onBeforeRender.invoke_137(this._renderContext);
    this._stage_0.render_23(this._renderContext);
    this._renderContext.flush_8();
    this._stage_0.renderDebug_20(this._renderContext);
    if (this._debugViews) {
      var tmp0_fastForEach_0 = this._debugHandlers;
      var n_1 = 0;
      while (n_1 < tmp0_fastForEach_0._get_size__60()) {
        var tmp0_2 = n_1;
        n_1 = tmp0_2 + 1 | 0;
        var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
        tmp1__anonymous__3(this, this._renderContext);
      }
    }this._onAfterRender.invoke_137(this._renderContext);
    this._renderContext.flush_8();
  };
  Views.prototype.frameUpdateAndRender = function (fixedSizeStep) {
    var currentTime = this._timeProvider_1.now_2();
    this._views_9._stats_0.startFrame_8();
    var tmp0_trace_0 = Korge_getInstance()._logger;
    var tmp0_log_0_1 = Level_TRACE_getInstance();
    if (tmp0_trace_0.isEnabled_0(tmp0_log_0_1)) {
      tmp0_trace_0.actualLog(tmp0_log_0_1, 'ag.onRender');
    }var delta_0 = DateTime__minus_impl_0(currentTime, this._lastTime_0);
    var adelta = TimeSpan__compareTo_impl(delta_0, this._views_9._clampElapsedTimeTo) > 0 ? this._views_9._clampElapsedTimeTo : delta_0;
    this._lastTime_0 = currentTime;
    if (!equals_1(new TimeSpan(fixedSizeStep), new TimeSpan(Companion_getInstance_27()._NIL))) {
      this.update_13(fixedSizeStep);
    } else {
      this.update_13(adelta);
    }
    this.render_24();
  };
  Views.prototype.update_13 = function (elapsed) {
    this._input_0.startFrame_7(elapsed);
    updateSingleViewWithViewsAll(this._stage_0, this, elapsed, this._tempViews);
    this._input_0.endFrame_0(elapsed);
  };
  Views.prototype.mouseUpdated = function () {
  };
  Views.prototype.resized_5 = function (width, height) {
    var actualWidth = width;
    var actualHeight = height;
    setTo(this._actualSize, actualWidth, actualHeight);
    Unit_getInstance();
    this.resized_6();
  };
  Views.prototype.resized_6 = function () {
    var virtualWidth = this._virtualWidth_0;
    var virtualHeight = this._virtualHeight_0;
    var anchor_1 = this._scaleAnchor_1;
    setTo(this._virtualSize, virtualWidth, virtualHeight);
    Unit_getInstance();
    this._scaleMode_4.invoke_322(this._virtualSize, this._actualSize, this._targetSize);
    Unit_getInstance();
    var ratioX = _SizeInt___get_width__impl_(this._targetSize) / virtualWidth;
    var ratioY = _SizeInt___get_height__impl_(this._targetSize) / virtualHeight;
    this._actualVirtualWidth = toIntRound(_SizeInt___get_width__impl_(this._actualSize) / ratioX);
    this._actualVirtualHeight = toIntRound(_SizeInt___get_height__impl_(this._actualSize) / ratioY);
    this._stage_0._set_scaleX__20(ratioX);
    this._stage_0._set_scaleY__20(ratioY);
    this._stage_0._set_x__27(toIntRound((this._actualVirtualWidth - virtualWidth | 0) * anchor_1._sx * ratioX));
    this._stage_0._set_y__27(toIntRound((this._actualVirtualHeight - virtualHeight | 0) * anchor_1._sy * ratioY));
    this._actualVirtualLeft = -toIntRound(this._stage_0._get_x__36() / ratioX) | 0;
    this._actualVirtualTop = -toIntRound(this._stage_0._get_y__36() / ratioY) | 0;
    var tmp0_apply_0 = this._resizedEvent;
    tmp0_apply_0._width_12 = _SizeInt___get_width__impl_(this._actualSize);
    tmp0_apply_0._height_12 = _SizeInt___get_height__impl_(this._actualSize);
    Unit_getInstance();
    var tmp1_dispatch_0 = this._stage_0;
    var tmp2_dispatch_0 = this._resizedEvent;
    tmp1_dispatch_0.dispatch_16(getKClass_0(ReshapeEvent), tmp2_dispatch_0);
    var tmp3_dispatch_0 = this._resizedEvent;
    this.dispatch_16(getKClass_0(ReshapeEvent), tmp3_dispatch_0);
    this._stage_0.invalidate_23();
  };
  Views.$metadata$ = {
    simpleName: 'Views',
    kind: 'class',
    interfaces: [Extra, EventDispatcher, CoroutineScope, ViewsContainer, BoundsProvider, DialogInterface, AsyncCloseable, KTreeSerializerHolder, ResourcesContainer]
  };
  function KorgeFileLoader(name, loader) {
    this._name_32 = name;
    this._loader = loader;
  }
  KorgeFileLoader.prototype.toString = function () {
    return '' + 'KorgeFileLoader("' + this._name_32 + '")';
  };
  KorgeFileLoader.prototype.hashCode = function () {
    var result = getStringHashCode(this._name_32);
    result = imul(result, 31) + hashCode(this._loader) | 0;
    return result;
  };
  KorgeFileLoader.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeFileLoader))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof KorgeFileLoader ? other : THROW_CCE();
    if (!(this._name_32 === tmp0_other_with_cast._name_32))
      return false;
    if (!equals_1(this._loader, tmp0_other_with_cast._loader))
      return false;
    return true;
  };
  KorgeFileLoader.$metadata$ = {
    simpleName: 'KorgeFileLoader',
    kind: 'class',
    interfaces: []
  };
  function BoundsProvider() {
  }
  BoundsProvider.$metadata$ = {
    simpleName: 'BoundsProvider',
    kind: 'interface',
    interfaces: []
  };
  function ViewsContainer() {
  }
  ViewsContainer.$metadata$ = {
    simpleName: 'ViewsContainer',
    kind: 'interface',
    interfaces: []
  };
  function getAllDescendantViews(view, out, reversed_2) {
    out.clear_33();
    var pos = getAllDescendantViewsBase(view, out, reversed_2, 0);
    while (out._get_size__60() > pos) {
      out.removeAt_6(out._get_size__60() - 1 | 0);
      Unit_getInstance();
    }
    return out;
  }
  function getAllDescendantViews$default(view, out, reversed_2, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      out = FastArrayList_init_$Create$();
    if (!(($mask0 & 4) === 0))
      reversed_2 = true;
    return getAllDescendantViews(view, out, reversed_2);
  }
  function updateSingleViewWithViewsAll(_this_, views, delta_0, tempViews) {
    var tmp0_fastForEach_0 = getAllDescendantViews$default(_this_, tempViews, false, 4, null);
    var n_1 = 0;
    while (n_1 < tmp0_fastForEach_0._get_size__60()) {
      var tmp0_2 = n_1;
      n_1 = tmp0_2 + 1 | 0;
      var tmp1__anonymous__3 = tmp0_fastForEach_0.get_137(tmp0_2);
      var tmp0_safe_receiver_5 = tmp1__anonymous__3._get__components__21();
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_5 == null ? null : tmp0_safe_receiver_5._updateWV;
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        var n_1_6 = 0;
        while (n_1_6 < tmp1_safe_receiver_4._get_size__60()) {
          var tmp0_2_8 = n_1_6;
          n_1_6 = tmp0_2_8 + 1 | 0;
          var tmp0__anonymous__3_7 = tmp1_safe_receiver_4.get_137(tmp0_2_8);
          tmp0__anonymous__3_7.update_10(views, TimeSpan__times_impl_0(delta_0, tmp1__anonymous__3._get_globalSpeed__20()));
        }
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp2_safe_receiver_10 = tmp1__anonymous__3._get__components__21();
      var tmp3_safe_receiver_9 = tmp2_safe_receiver_10 == null ? null : tmp2_safe_receiver_10._update_0;
      if (tmp3_safe_receiver_9 == null)
        null;
      else {
        var n_1_11 = 0;
        while (n_1_11 < tmp3_safe_receiver_9._get_size__60()) {
          var tmp0_2_13 = n_1_11;
          n_1_11 = tmp0_2_13 + 1 | 0;
          var tmp1__anonymous__3_12 = tmp3_safe_receiver_9.get_137(tmp0_2_13);
          tmp1__anonymous__3_12.update_13(TimeSpan__times_impl_0(delta_0, tmp1__anonymous__3._get_globalSpeed__20()));
        }
        Unit_getInstance();
      }
      Unit_getInstance();
    }
  }
  function getAllDescendantViewsBase(view, out, reversed_2, cursor) {
    var pos = cursor;
    if (reversed_2) {
      var tmp0_safe_receiver_1 = view.__children;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        var n_1_2 = 0;
        while (n_1_2 < tmp0_safe_receiver_1._get_size__60()) {
          var tmp0__anonymous__4 = tmp0_safe_receiver_1.get_137((tmp0_safe_receiver_1._get_size__60() - n_1_2 | 0) - 1 | 0);
          pos = getAllDescendantViewsBase(tmp0__anonymous__4, out, reversed_2, pos);
          var tmp0_2_3 = n_1_2;
          n_1_2 = tmp0_2_3 + 1 | 0;
          Unit_getInstance();
        }
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp0 = pos;
      pos = tmp0 + 1 | 0;
      replaceOrAdd(out, tmp0, view);
    } else {
      var tmp1 = pos;
      pos = tmp1 + 1 | 0;
      replaceOrAdd(out, tmp1, view);
      var tmp0_safe_receiver_1_0 = view.__children;
      if (tmp0_safe_receiver_1_0 == null)
        null;
      else {
        var n_1_2_0 = 0;
        while (n_1_2_0 < tmp0_safe_receiver_1_0._get_size__60()) {
          var tmp0_2_3_0 = n_1_2_0;
          n_1_2_0 = tmp0_2_3_0 + 1 | 0;
          var tmp1__anonymous__4 = tmp0_safe_receiver_1_0.get_137(tmp0_2_3_0);
          pos = getAllDescendantViewsBase(tmp1__anonymous__4, out, reversed_2, pos);
        }
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    return pos;
  }
  function replaceOrAdd(_this_, pos, value) {
    if (pos >= _this_._get_size__60()) {
      _this_.add_39(value);
      Unit_getInstance();
    } else {
      _this_.set_8(pos, value);
      Unit_getInstance();
    }
  }
  function _no_name_provided__526() {
  }
  _no_name_provided__526.prototype.invoke_911 = function ($this$$receiver) {
    return null;
  };
  _no_name_provided__526.prototype.invoke_1015 = function (p1) {
    return this.invoke_911(p1 instanceof UiApplication ? p1 : THROW_CCE());
  };
  _no_name_provided__526.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_473() {
    var i = new _no_name_provided__526();
    return function (p1) {
      return i.invoke_911(p1);
    };
  }
  function _no_name_provided_$factory_474(this$0) {
    var i = new _no_name_provided__523(this$0);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_475(this$0) {
    var i = new _no_name_provided__525(this$0);
    return function (p1) {
      i.invoke_909(p1);
      return Unit_getInstance();
    };
  }
  var registerFilterSerialization$delegate;
  function _no_name_provided__527() {
  }
  _no_name_provided__527.prototype.invoke_1005 = function () {
    return false;
  };
  _no_name_provided__527.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_476() {
    var i = new _no_name_provided__527();
    return function () {
      return i.invoke_1005();
    };
  }
  function InternalViewAutoscaling() {
    this._renderedAtScaleX = 1.0;
    this._renderedAtScaleY = 1.0;
    this._renderedAtScaleXY = 1.0;
    var tmp = this;
    tmp._matrixTransform = Transform_init_$Create$(0.0, 0.0, 0.0, 0.0, null, null, null, 127, null);
  }
  InternalViewAutoscaling.prototype.onRender = function (autoScaling, globalMatrix) {
    if (autoScaling) {
      this._matrixTransform.setMatrix_0(globalMatrix);
      Unit_getInstance();
      var tmp0_abs_0 = this._matrixTransform._scaleX;
      var sx = Math.abs(tmp0_abs_0);
      var tmp1_abs_0 = this._matrixTransform._scaleY;
      var sy = Math.abs(tmp1_abs_0);
      var sxy = max2_7(sx, sy);
      var tmp2_abs_0 = sx / this._renderedAtScaleX - 1.0;
      var diffX = Math.abs(tmp2_abs_0);
      var tmp3_abs_0 = sy / this._renderedAtScaleY - 1.0;
      var diffY = Math.abs(tmp3_abs_0);
      if (diffX >= 0.1 ? true : diffY >= 0.1) {
        this._renderedAtScaleX = sx;
        this._renderedAtScaleY = sy;
        this._renderedAtScaleXY = sxy;
        return true;
      }} else {
      this._renderedAtScaleX = 1.0;
      this._renderedAtScaleY = 1.0;
      this._renderedAtScaleXY = 1.0;
    }
    return false;
  };
  InternalViewAutoscaling.$metadata$ = {
    simpleName: 'InternalViewAutoscaling',
    kind: 'class',
    interfaces: []
  };
  function KTreeSerializerHolder() {
  }
  KTreeSerializerHolder.$metadata$ = {
    simpleName: 'KTreeSerializerHolder',
    kind: 'interface',
    interfaces: []
  };
  function Companion_152() {
    Companion_instance_151 = this;
    this.___ex_ = '__ex_';
  }
  Companion_152.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_151;
  function Companion_getInstance_151() {
    if (Companion_instance_151 == null)
      new Companion_152();
    return Companion_instance_151;
  }
  function KTreeSerializer(views) {
    Companion_getInstance_151();
    this._views_10 = views;
    var tmp = this;
    tmp._$$delegate_0_25 = Mixin_init_$Create$(null, 1, null);
    var tmp_0 = this;
    tmp_0._registrationsExt = LinkedHashSet_init_$Create$();
    this._registrationsByClass = LinkedHashMap_init_$Create$();
    this._registrationsByNameLC = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    tmp_1._registrations = LinkedHashSet_init_$Create$();
    var tmp_2 = this;
    tmp_2._extensions_1 = LinkedHashSet_init_$Create$();
    this._extensionsByName = LinkedHashMap_init_$Create$();
    this.register_4(Serializer_getInstance_1());
    this.register_4(Serializer_getInstance_2());
    this.register_4(Serializer_getInstance_0());
    this.register_4(Serializer_getInstance());
  }
  KTreeSerializer.prototype._set_extra__71 = function (_set___) {
    this._$$delegate_0_25._extra = _set___;
  };
  KTreeSerializer.prototype._get_extra__71 = function () {
    return this._$$delegate_0_25._extra;
  };
  KTreeSerializer.prototype.register_4 = function (registration) {
    this._registrationsExt.add_39(registration);
    Unit_getInstance();
    var tmp0_set_0 = this._registrationsByClass;
    var tmp1_set_0 = registration._clazz_5;
    tmp0_set_0.put_18(tmp1_set_0, registration);
    Unit_getInstance();
    var tmp2_set_0 = this._registrationsByNameLC;
    var tmp3_set_0 = registration._nameLC_1;
    tmp2_set_0.put_18(tmp3_set_0, registration);
    Unit_getInstance();
  };
  KTreeSerializer.$metadata$ = {
    simpleName: 'KTreeSerializer',
    kind: 'class',
    interfaces: [KTreeSerializerHolder, Extra]
  };
  function Prop(prop, default_0) {
    this._prop_0 = prop;
    this._default_2 = default_0;
  }
  Prop.prototype.toString = function () {
    return '' + 'Prop(prop=' + this._prop_0 + ', default=' + this._default_2 + ')';
  };
  Prop.prototype.hashCode = function () {
    var result = hashCode(this._prop_0);
    result = imul(result, 31) + (this._default_2 == null ? 0 : hashCode(this._default_2)) | 0;
    return result;
  };
  Prop.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Prop))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Prop ? other : THROW_CCE();
    if (!equals_1(this._prop_0, tmp0_other_with_cast._prop_0))
      return false;
    if (!equals_1(this._default_2, tmp0_other_with_cast._default_2))
      return false;
    return true;
  };
  Prop.$metadata$ = {
    simpleName: 'Prop',
    kind: 'class',
    interfaces: []
  };
  function CustomProp(prop, serialize, deserialize) {
    this._prop_1 = prop;
    this._serialize = serialize;
    this._deserialize = deserialize;
  }
  CustomProp.prototype.toString = function () {
    return '' + 'CustomProp(prop=' + this._prop_1 + ', serialize=' + this._serialize + ', deserialize=' + this._deserialize + ')';
  };
  CustomProp.prototype.hashCode = function () {
    var result = hashCode(this._prop_1);
    result = imul(result, 31) + hashCode(this._serialize) | 0;
    result = imul(result, 31) + hashCode(this._deserialize) | 0;
    return result;
  };
  CustomProp.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CustomProp))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof CustomProp ? other : THROW_CCE();
    if (!equals_1(this._prop_1, tmp0_other_with_cast._prop_1))
      return false;
    if (!equals_1(this._serialize, tmp0_other_with_cast._serialize))
      return false;
    if (!equals_1(this._deserialize, tmp0_other_with_cast._deserialize))
      return false;
    return true;
  };
  CustomProp.$metadata$ = {
    simpleName: 'CustomProp',
    kind: 'class',
    interfaces: []
  };
  function KTreeSerializerExt(name, clazz, factory, block) {
    this._name_33 = name;
    this._clazz_5 = clazz;
    this._factory = factory;
    this._block_1 = block;
    var tmp = this;
    var tmp0_toLowerCase_0 = this._name_33;
    tmp._nameLC_1 = tmp0_toLowerCase_0.toLowerCase();
    var tmp_0 = this;
    tmp_0._propsBoolean = ArrayList_init_$Create$();
    var tmp_1 = this;
    tmp_1._propsString = ArrayList_init_$Create$();
    var tmp_2 = this;
    tmp_2._propsStringNull = ArrayList_init_$Create$();
    var tmp_3 = this;
    tmp_3._propsDouble = ArrayList_init_$Create$();
    var tmp_4 = this;
    tmp_4._propsInt = ArrayList_init_$Create$();
    var tmp_5 = this;
    tmp_5._propsRGBA = ArrayList_init_$Create$();
    var tmp_6 = this;
    tmp_6._propsCustom = ArrayList_init_$Create$();
    this._allPropsList = listOf([this._propsBoolean, this._propsString, this._propsStringNull, this._propsDouble, this._propsInt, this._propsRGBA]);
    this._block_1(this);
  }
  KTreeSerializerExt.prototype.add_88 = function (prop, serialize, deserialize) {
    this._propsCustom.add_39(new CustomProp(prop, serialize, deserialize));
    Unit_getInstance();
  };
  KTreeSerializerExt.prototype.add_89 = function (prop, default_0) {
    return this._propsBoolean.add_39(new Prop(prop, default_0));
  };
  KTreeSerializerExt.prototype.add$default_14 = function (prop, default_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      default_0 = false;
    return this.add_89(prop, default_0);
  };
  KTreeSerializerExt.prototype.add_90 = function (prop, default_0) {
    return this._propsString.add_39(new Prop(prop, default_0));
  };
  KTreeSerializerExt.prototype.add$default_15 = function (prop, default_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      default_0 = '';
    return this.add_90(prop, default_0);
  };
  KTreeSerializerExt.prototype.add_91 = function (prop) {
    return this._propsStringNull.add_39(new Prop(prop, null));
  };
  KTreeSerializerExt.prototype.add_92 = function (prop, default_0) {
    return this._propsDouble.add_39(new Prop(prop, default_0));
  };
  KTreeSerializerExt.prototype.add$default_16 = function (prop, default_0, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      default_0 = 0.0;
    return this.add_92(prop, default_0);
  };
  KTreeSerializerExt.$metadata$ = {
    simpleName: 'KTreeSerializerExt',
    kind: 'class',
    interfaces: []
  };
  var vector3DTemps;
  function Vector3DTemps() {
    this._pos_2 = 0;
    this._items_4 = arrayListOf([new Vector3D(), new Vector3D(), new Vector3D()]);
  }
  Vector3DTemps.$metadata$ = {
    simpleName: 'Vector3DTemps',
    kind: 'class',
    interfaces: []
  };
  function completeViews(views) {
  }
  function NativeStorage(views) {
    this._views_11 = views;
  }
  NativeStorage.prototype.toString = function () {
    return '' + 'NativeStorage(' + toMap_3(this) + ')';
  };
  NativeStorage.prototype.keys_0 = function () {
    var keys = Object.keys();
    var tmp0_map_0 = until(0, keys.length);
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var inductionVariable = tmp0_map_0._get_first__6();
    var last_1 = tmp0_map_0._get_last__6();
    if (inductionVariable <= last_1)
      do {
        var item_2_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_mapTo_0_1.add_39(keys.get(item_2_3));
        Unit_getInstance();
      }
       while (!(item_2_3 === last_1));
    return tmp0_mapTo_0_1;
  };
  NativeStorage.prototype.getOrNull_5 = function (key) {
    return localStorage.getItem(key);
  };
  NativeStorage.$metadata$ = {
    simpleName: 'NativeStorage',
    kind: 'class',
    interfaces: [IStorage]
  };
  function _no_name_provided__528($tmp10_onClick_0, $it, resultContinuation) {
    this._$tmp10_onClick_0 = $tmp10_onClick_0;
    this._$it_8 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__528.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__528.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__528.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp10_onClick_0(this._$it_8, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__528.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__528(this._$tmp10_onClick_0, this._$it_8, completion);
    return i;
  };
  _no_name_provided__528.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__529($tmp59_onClick_0, $it, resultContinuation) {
    this._$tmp59_onClick_0 = $tmp59_onClick_0;
    this._$it_9 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__529.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__529.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__529.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp59_onClick_0(this._$it_9, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__529.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__529(this._$tmp59_onClick_0, this._$it_9, completion);
    return i;
  };
  _no_name_provided__529.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__530($tmp60_onClick_0, $it, resultContinuation) {
    this._$tmp60_onClick_0 = $tmp60_onClick_0;
    this._$it_10 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__530.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__530.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__530.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp60_onClick_0(this._$it_10, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__530.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__530(this._$tmp60_onClick_0, this._$it_10, completion);
    return i;
  };
  _no_name_provided__530.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__531($tmp7_onClick_0, $it, resultContinuation) {
    this._$tmp7_onClick_0 = $tmp7_onClick_0;
    this._$it_11 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__531.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__531.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__531.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp7_onClick_0(this._$it_11, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__531.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__531(this._$tmp7_onClick_0, this._$it_11, completion);
    return i;
  };
  _no_name_provided__531.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__532($tmp21_onClick_0, $it, resultContinuation) {
    this._$tmp21_onClick_0 = $tmp21_onClick_0;
    this._$it_12 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__532.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__532.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__532.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp21_onClick_0(this._$it_12, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__532.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__532(this._$tmp21_onClick_0, this._$it_12, completion);
    return i;
  };
  _no_name_provided__532.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function initPlayer($this) {
    var horizontal = {_v: 1.0 * $this._moveIntensity};
    var vertical = {_v: 0.0};
    var tmp = $this;
    var tmp0_circle_0 = $this._mainContainer;
    var tmp1_circle_0 = 25.0;
    var tmp2_circle_0 = Colors_getInstance()._WHITE;
    var tmp3_circle_0 = Colors_getInstance()._WHITE;
    var tmp4_circle_0 = 0.0;
    var tmp5_circle_0 = true;
    var tmp1_addTo_0_2 = new Circle(tmp1_circle_0, new RGBA(tmp2_circle_0), new RGBA(tmp3_circle_0), tmp4_circle_0, tmp5_circle_0);
    var tmp0_apply_0_3 = addTo(tmp1_addTo_0_2, tmp0_circle_0);
    Unit_getInstance();
    tmp._player = xy_0(tmp0_apply_0_3, 256, 700);
    var tmp6_onClick_0 = $this._player;
    var tmp7_onClick_0 = _no_name_provided_$factory_477($this, null);
    var tmp0_doMouseEvent_0_1 = click$factory_0();
    var tmp0_safe_receiver_2_3 = tmp6_onClick_0;
    var tmp1_safe_receiver_1_2 = tmp0_safe_receiver_2_3 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3);
    if (tmp1_safe_receiver_1_2 == null)
      null;
    else {
      var tmp_0 = tmp0_doMouseEvent_0_1.get(tmp1_safe_receiver_1_2);
      tmp_0.add_41(_no_name_provided_$factory_478(tmp1_safe_receiver_1_2, tmp7_onClick_0));
    }
    Unit_getInstance();
    Unit_getInstance();
    var tmp_1 = $this._player;
    var tmp_2 = _Frequency___init__impl_(60.0);
    addFixedUpdater$default(tmp_1, tmp_2, false, 0, _no_name_provided_$factory_479(vertical, $this, horizontal), 6, null);
    Unit_getInstance();
  }
  function playBounceSound($this) {
    launchImmediately_0($this, _no_name_provided_$factory_480($this, null));
    Unit_getInstance();
  }
  function handleGameOver($this) {
    var tmp0_solidRect_0 = $this._mainContainer;
    var tmp1_solidRect_0 = 512.0;
    var tmp2_solidRect_0 = 1080.0;
    var tmp3_solidRect_0 = Colors_getInstance().get_91('#000000');
    var tmp0_addTo_0_2 = new SolidRect(tmp1_solidRect_0, tmp2_solidRect_0, tmp3_solidRect_0);
    var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp0_solidRect_0);
    Unit_getInstance();
    xy_0(tmp0_apply_0_2_3, 0, 0);
    Unit_getInstance();
    var tmp4_text_0 = $this._mainContainer;
    var tmp5_text_0 = 'Restart Game';
    var tmp6_text_0 = 32.0;
    var tmp7_text_0 = Companion_getInstance_116()._CENTER_0;
    var tmp8_text_0 = Colors_getInstance()._WHITE;
    var tmp9_text_0 = _get_DefaultTtfFont_();
    var tmp10_text_0 = DefaultStringTextRenderer;
    var tmp11_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
    var tmp0_addTo_0_2_0 = new Text_2(tmp5_text_0, tmp6_text_0, tmp8_text_0, tmp9_text_0, tmp7_text_0, tmp10_text_0, tmp11_text_0);
    var tmp0_apply_0_2_3_0 = addTo(tmp0_addTo_0_2_0, tmp4_text_0);
    Unit_getInstance();
    position(tmp0_apply_0_2_3_0, 256, 530);
    Unit_getInstance();
    var tmp12_roundRect_0 = $this._mainContainer;
    var tmp13_roundRect_0 = 400.0;
    var tmp14_roundRect_0 = 100.0;
    var tmp15_roundRect_0 = 5.0;
    var tmp16_roundRect_0 = 5.0;
    var tmp17_roundRect_0 = Colors_getInstance()._TRANSPARENT_BLACK;
    var tmp18_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp19_roundRect_0 = 4.0;
    var tmp20_roundRect_0 = true;
    var tmp0_addTo_0_2_1 = new RoundRect(tmp13_roundRect_0, tmp14_roundRect_0, tmp15_roundRect_0, tmp16_roundRect_0, new RGBA(tmp17_roundRect_0), new RGBA(tmp18_roundRect_0), tmp19_roundRect_0, tmp20_roundRect_0);
    var tmp0_apply_0_2_3_1 = addTo(tmp0_addTo_0_2_1, tmp12_roundRect_0);
    Unit_getInstance();
    var restartButton = xy_0(tmp0_apply_0_2_3_1, 56, 500);
    var tmp21_onClick_0 = _no_name_provided_$factory_481($this, null);
    var tmp0_doMouseEvent_0_1 = click$factory_1();
    var tmp0_safe_receiver_2_3 = restartButton;
    var tmp1_safe_receiver_1_2 = tmp0_safe_receiver_2_3 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3);
    if (tmp1_safe_receiver_1_2 == null)
      null;
    else {
      var tmp = tmp0_doMouseEvent_0_1.get(tmp1_safe_receiver_1_2);
      tmp.add_41(_no_name_provided_$factory_482(tmp1_safe_receiver_1_2, tmp21_onClick_0));
    }
    Unit_getInstance();
    Unit_getInstance();
    var tmp_0 = Companion_getInstance_109();
    var tmp_1 = _get_DefaultTtfFont_();
    var tmp_2 = new RGBA(Colors_getInstance()._WHITE);
    var font = tmp_0.invoke$default_3(tmp_1, 64.0, null, null, tmp_2, false, null, 108, null);
    var tmp0_alignment = Companion_getInstance_116()._CENTER_0;
    var tmp22_text_0 = $this._mainContainer;
    var tmp23_text_0 = 'Game Over!';
    var tmp24_text_0 = 64.0;
    var tmp25_text_0 = Colors_getInstance()._WHITE;
    var tmp26_text_0 = DefaultStringTextRenderer;
    var tmp27_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
    var tmp0_addTo_0_2_2 = new Text_2(tmp23_text_0, tmp24_text_0, tmp25_text_0, font, tmp0_alignment, tmp26_text_0, tmp27_text_0);
    var tmp0_apply_0_2_3_2 = addTo(tmp0_addTo_0_2_2, tmp22_text_0);
    Unit_getInstance();
    position(tmp0_apply_0_2_3_2, 256, 300);
    Unit_getInstance();
    var tmp1_text = 'Pixel Highscore: ' + numberToInt(-1 * ($this._pixeldepth + 1048 - $this._player._get_y__36())).toString();
    var tmp2_alignment = Companion_getInstance_116()._CENTER_0;
    var tmp28_text_0 = $this._mainContainer;
    var tmp29_text_0 = 32.0;
    var tmp30_text_0 = Colors_getInstance()._WHITE;
    var tmp31_text_0 = DefaultStringTextRenderer;
    var tmp32_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
    var tmp0_addTo_0_2_3 = new Text_2(tmp1_text, tmp29_text_0, tmp30_text_0, font, tmp2_alignment, tmp31_text_0, tmp32_text_0);
    var tmp0_apply_0_2_3_3 = addTo(tmp0_addTo_0_2_3, tmp28_text_0);
    Unit_getInstance();
    position(tmp0_apply_0_2_3_3, 256, 400);
    Unit_getInstance();
  }
  function activateRandomPowerUp($this) {
    var powerUpNumber = Default_getInstance().nextInt_6(8);
    var tmp0_subject = powerUpNumber;
    switch (tmp0_subject) {
      case 1:
        setText($this._infotext, 'Gravity decreased');
        var tmp1_this = $this;
        tmp1_this._gravity = tmp1_this._gravity - 0.005;
        break;
      case 2:
        setText($this._infotext, 'Gravity increased');
        var tmp2_this = $this;
        tmp2_this._gravity = tmp2_this._gravity + 0.02;
        break;
      case 3:
        setText($this._infotext, 'Sideway speed increased');
        var tmp3_this = $this;
        tmp3_this._moveIntensity = tmp3_this._moveIntensity + 0.5;
        break;
      case 4:
        setText($this._infotext, 'Sideway speed decreased');
        var tmp4_this = $this;
        tmp4_this._moveIntensity = tmp4_this._moveIntensity - 0.5;
        break;
      case 5:
        setText($this._infotext, 'Jumping decreased');
        var tmp5_this = $this;
        tmp5_this._jumpIntensity = tmp5_this._jumpIntensity - 0.5;
        break;
      case 6:
        setText($this._infotext, 'Gravity inverted');
        $this._gravity = -0.05;
        break;
      case 7:
        setText($this._infotext, 'Color invert');
        var tmp0_forEach_0 = $this._groundObjects;
        var tmp0_iterator_1 = tmp0_forEach_0.iterator_67();
        while (tmp0_iterator_1.hasNext_33()) {
          var element_2 = tmp0_iterator_1.next_37();
          element_2._set_color__1(Colors_getInstance().get_91('#000000'));
        }

        var tmp1_solidRect_0 = $this._mainContainer;
        var tmp2_solidRect_0 = 512;
        var tmp3_solidRect_0 = 1080;
        var tmp4_solidRect_0 = Colors_getInstance()._WHITE;
        var tmp0_addTo_0_2 = new SolidRect(tmp2_solidRect_0, tmp3_solidRect_0, tmp4_solidRect_0);
        var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp1_solidRect_0);
        Unit_getInstance();
        var rect_1 = tmp0_apply_0_2_3;
        $this._mainContainer.sendChildToBack_8(rect_1);
        $this._player._set_fill__1(new RGBA(Colors_getInstance()._BLACK));
        launchImmediately_0($this, _no_name_provided_$factory_483($this, rect_1, null));
        Unit_getInstance();
        break;
      case 8:
        setText($this._infotext, 'Speed increased');
        var tmp6_this = $this;
        tmp6_this._jumpIntensity = tmp6_this._jumpIntensity + 8.0;
        var tmp7_this = $this;
        tmp7_this._moveIntensity = tmp7_this._moveIntensity + 8.0;
        var tmp8_this = $this;
        tmp8_this._maxSpeed = tmp8_this._maxSpeed + 4.0;
        break;
      default:setText($this._infotext, 'Jumping Intensity increased');
        var tmp9_this = $this;
        tmp9_this._jumpIntensity = tmp9_this._jumpIntensity + 0.5;
        break;
    }
    $this._powerUpActive = true;
    $this._powerUpTime = 300;
  }
  function deleteAllPowerUps($this) {
    var tmp0_this = $this;
    tmp0_this._multiplikator = tmp0_this._multiplikator + 0.001;
    var tmp1_this = $this;
    tmp1_this._multiplikator2 = tmp1_this._multiplikator2 + 5.0E-5;
    $this._jumpIntensity = 4.0 * $this._multiplikator2;
    $this._moveIntensity = 2.0 * $this._multiplikator2;
    $this._maxSpeed = 8.0 * $this._multiplikator;
    $this._gravity = 0.05;
  }
  function changeButtonColor($this, rect_1, rect2) {
    if (equals_1(rect_1._get_fill__0(), new RGBA(Colors_getInstance().get_91('#000000')))) {
      rect_1._set_fill__1(new RGBA(Colors_getInstance().get_91('#FFFFFF')));
      rect_1._set_stroke__0(new RGBA(Colors_getInstance().get_91('#000000')));
      rect2._set_fill__1(new RGBA(Colors_getInstance().get_91('#000000')));
      rect2._set_stroke__0(new RGBA(Colors_getInstance().get_91('#FFFFFF')));
    } else {
      rect_1._set_fill__1(new RGBA(Colors_getInstance().get_91('#000000')));
      rect_1._set_stroke__0(new RGBA(Colors_getInstance().get_91('#FFFFFF')));
      rect2._set_fill__1(new RGBA(Colors_getInstance().get_91('#FFFFFF')));
      rect2._set_stroke__0(new RGBA(Colors_getInstance().get_91('#000000')));
    }
  }
  function createGroundObjects($this) {
    var tmp0_solidRect_0 = $this._mainContainer;
    var tmp1_solidRect_0 = 1000.0;
    var tmp2_solidRect_0 = 50.0;
    var tmp3_solidRect_0 = Colors_getInstance()._WHITE;
    var tmp0_addTo_0_2 = new SolidRect(tmp1_solidRect_0, tmp2_solidRect_0, tmp3_solidRect_0);
    var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp0_solidRect_0);
    Unit_getInstance();
    var baseground = xy_0(tmp0_apply_0_2_3, 0, 900);
    var ground0 = nextPlattform($this, xy_0(SolidRect_init_$Create$(0.0, 50.0, null, 4, null), 256, 900));
    var ground1 = nextPlattform($this, ground0);
    var ground2 = nextPlattform($this, ground1);
    var ground3 = nextPlattform($this, ground2);
    var ground4 = nextPlattform($this, ground3);
    var ground5 = nextPlattform($this, ground4);
    var ground6 = nextPlattform($this, ground5);
    var ground7 = nextPlattform($this, ground6);
    var ground8 = nextPlattform($this, ground7);
    var ground9 = nextPlattform($this, ground8);
    return mutableListOf([baseground, ground0, ground1, ground2, ground3, ground4, ground5, ground6, ground7, ground8, ground9]);
  }
  function nextPlattform($this, lastPlattform) {
    var tmp = Companion_getInstance_148();
    var newPlattform = {_v: tmp.invoke$default_5(0, 0, null, 4, null)};
    do {
      var start = Default_getInstance().nextDouble_6(412.0);
      var tmp0_min_0 = Default_getInstance().nextDouble_6(412.0) + 100;
      var tmp1_min_0 = 512 - start;
      var width = function () {
        var $externalVarargReceiverTmp = Math;
        return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp0_min_0, tmp1_min_0]))));
      }.call(this);
      newPlattform._v.removeFromParent_20();
      var tmp2_solidRect_0 = $this._mainContainer;
      var tmp3_solidRect_0 = 50.0;
      var tmp4_solidRect_0 = Colors_getInstance()._WHITE;
      var tmp0_addTo_0_2 = new SolidRect(width, tmp3_solidRect_0, tmp4_solidRect_0);
      var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp2_solidRect_0);
      Unit_getInstance();
      newPlattform._v = xy_0(tmp0_apply_0_2_3, numberToInt(start), numberToInt(lastPlattform._get_y__36() - $this._plattformGap));
    }
     while (!(newPlattform._v._get_x__36() - lastPlattform._get_x__36() > 0.0 ? newPlattform._v._get_x__36() > 80.0 : false) ? !(lastPlattform._get_x__36() + lastPlattform._width_20 - (newPlattform._v._get_x__36() + newPlattform._v._width_20) > 0.0 ? newPlattform._v._get_x__36() + newPlattform._v._width_20 < 432.0 : false) : false);
    if (Default_getInstance().nextInt_6(5) === 0) {
      launchImmediately_0($this, _no_name_provided_$factory_484($this, newPlattform, lastPlattform, null));
      Unit_getInstance();
    }$this._mainContainer.sendChildToBack_8(newPlattform._v);
    return newPlattform._v;
  }
  function updateShapePositions($this) {
    if ($this._player._get_y__36() < 540.0) {
      var difference = $this._player._get_y__36() - 540.0;
      var tmp0_this = $this._player;
      tmp0_this._set_y__27(tmp0_this._get_y__36() - difference);
      var tmp0_forEach_0 = $this._groundObjects;
      var tmp0_iterator_1 = tmp0_forEach_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        var tmp0_this_4 = element_2;
        tmp0_this_4._set_y__27(tmp0_this_4._get_y__36() - difference);
      }
      var tmp1_forEach_0 = $this._treasureObjects;
      var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_67();
      while (tmp0_iterator_1_0.hasNext_33()) {
        var element_2_0 = tmp0_iterator_1_0.next_37();
        var tmp0_this_4_0 = element_2_0;
        tmp0_this_4_0._set_y__27(tmp0_this_4_0._get_y__36() - difference);
      }
      var tmp1_this = $this;
      tmp1_this._pixeldepth = tmp1_this._pixeldepth + difference;
    }}
  function collidingPowerUps($this) {
    var tmp0_forEach_0 = $this._treasureObjects;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_67();
    while (tmp0_iterator_1.hasNext_33()) {
      var element_2 = tmp0_iterator_1.next_37();
      var tmp = $this._player;
      if (collidesWith$default(tmp, element_2, null, 2, null)) {
        element_2.removeFromParent_20();
        return true;
      } else {
      }
    }
    return false;
  }
  function collidingGround($this) {
    var tmp0_forEach_0 = $this._groundObjects;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_67();
    while (tmp0_iterator_1.hasNext_33()) {
      var element_2 = tmp0_iterator_1.next_37();
      var tmp = $this._player;
      if (collidesWith$default(tmp, element_2, null, 2, null)) {
        if (!$this._soundPlaying ? $this._playerIsAlive : false) {
          playBounceSound($this);
        }if ($this._player._get_y__36() < element_2._get_y__36()) {
          return 1;
        } else
          return -1;
      } else {
      }
    }
    return 0;
  }
  function _no_name_provided__533(this$0) {
    this._this$0_159 = this$0;
  }
  _no_name_provided__533.prototype.invoke_924 = function ($this$addUpdater, it) {
    var inductionVariable = 1;
    var last_1 = this._this$0_159._groundObjects._get_size__60();
    if (inductionVariable < last_1)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this._this$0_159._groundObjects.get_137(i)._get_y__36() > 1000.0) {
          var index = ((i - 1 | 0) + this._this$0_159._groundObjects._get_size__60() | 0) % this._this$0_159._groundObjects._get_size__60();
          if (index === 0)
            index = this._this$0_159._groundObjects._get_size__60() - 1 | 0;
          this._this$0_159._groundObjects.get_137(i).removeFromParent_20();
          this._this$0_159._groundObjects.set_8(i, nextPlattform(this._this$0_159, this._this$0_159._groundObjects.get_137(index)));
          Unit_getInstance();
        }}
       while (inductionVariable < last_1);
  };
  _no_name_provided__533.prototype.invoke_925 = function (p1, p2) {
    var tmp = p1 instanceof SolidRect ? p1 : THROW_CCE();
    this.invoke_924(tmp, p2 instanceof TimeSpan ? p2._milliseconds : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__533.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__534(this$0, resultContinuation) {
    this._this$0_160 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__534.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__534.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__534.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_changeTo_00 = this._this$0_160._get_sceneContainer__2();
            var tmp_1 = this;
            tmp_1._tmp1_changeTo_01 = [];
            var tmp_2 = this;
            var tmp0__get_seconds__0_1 = 0;
            tmp_2._tmp2_changeTo_02 = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0_1);
            var tmp_3 = this;
            tmp_3._tmp3_changeTo_03 = this._tmp0_changeTo_00._defaultTransition;
            this._state_1 = 1;
            suspendResult = this._tmp0_changeTo_00.changeTo(getKClass_0(Scene1), this._tmp1_changeTo_01.slice(), this._tmp2_changeTo_02, this._tmp3_changeTo_03, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__534.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__534(this._this$0_160, completion);
    i._it_9 = it;
    return i;
  };
  _no_name_provided__534.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__535($tmp1_safe_receiver_1_2, $tmp10_onClick_0) {
    this._$tmp1_safe_receiver_1_2 = $tmp1_safe_receiver_1_2;
    this._$tmp10_onClick_0_0 = $tmp10_onClick_0;
  }
  _no_name_provided__535.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_485(this._$tmp10_onClick_0_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__535.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__535.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__536(this$0, $buttonRight, $buttonLeft, resultContinuation) {
    this._this$0_161 = this$0;
    this._$buttonRight = $buttonRight;
    this._$buttonLeft = $buttonLeft;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__536.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__536.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__536.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          changeButtonColor(this._this$0_161, this._$buttonRight, this._$buttonLeft);
          this._this$0_161._leftWalk = !this._this$0_161._leftWalk;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__536.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__536(this._this$0_161, this._$buttonRight, this._$buttonLeft, completion);
    i._it_10 = it;
    return i;
  };
  _no_name_provided__536.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__537($tmp1_safe_receiver_1_2, $tmp59_onClick_0) {
    this._$tmp1_safe_receiver_1_2_0 = $tmp1_safe_receiver_1_2;
    this._$tmp59_onClick_0_0 = $tmp59_onClick_0;
  }
  _no_name_provided__537.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_0._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_486(this._$tmp59_onClick_0_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__537.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__537.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__538(this$0, $buttonRight, $buttonLeft, resultContinuation) {
    this._this$0_162 = this$0;
    this._$buttonRight_0 = $buttonRight;
    this._$buttonLeft_0 = $buttonLeft;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__538.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__538.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__538.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          changeButtonColor(this._this$0_162, this._$buttonRight_0, this._$buttonLeft_0);
          this._this$0_162._leftWalk = !this._this$0_162._leftWalk;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__538.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__538(this._this$0_162, this._$buttonRight_0, this._$buttonLeft_0, completion);
    i._it_11 = it;
    return i;
  };
  _no_name_provided__538.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__539($tmp1_safe_receiver_1_2, $tmp60_onClick_0) {
    this._$tmp1_safe_receiver_1_2_1 = $tmp1_safe_receiver_1_2;
    this._$tmp60_onClick_0_0 = $tmp60_onClick_0;
  }
  _no_name_provided__539.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_1._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_487(this._$tmp60_onClick_0_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__539.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__539.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__540(this$0, resultContinuation) {
    this._this$0_163 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__540.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__540.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__540.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._this$0_163._player._set_color__1(Colors_getInstance()._BLACK);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__540.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__540(this._this$0_163, completion);
    i._it_12 = it;
    return i;
  };
  _no_name_provided__540.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__541($tmp1_safe_receiver_1_2, $tmp7_onClick_0) {
    this._$tmp1_safe_receiver_1_2_2 = $tmp1_safe_receiver_1_2;
    this._$tmp7_onClick_0_0 = $tmp7_onClick_0;
  }
  _no_name_provided__541.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_2._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_488(this._$tmp7_onClick_0_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__541.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__541.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__542($vertical, this$0, $horizontal) {
    this._$vertical = $vertical;
    this._this$0_164 = this$0;
    this._$horizontal = $horizontal;
  }
  _no_name_provided__542.prototype.invoke_980 = function ($this$addFixedUpdater) {
    this._$vertical._v = this._$vertical._v - this._this$0_164._gravity;
    if (this._this$0_164._player._get_x__36() < 10.0 ? true : this._this$0_164._player._get_x__36() > 502 - this._this$0_164._player._get_radius_() * 2) {
      this._$horizontal._v = this._$horizontal._v - this._$horizontal._v * 2;
    }if (this._this$0_164._powerUpActive) {
      var tmp0_this = this._this$0_164;
      var tmp1 = tmp0_this._powerUpTime;
      tmp0_this._powerUpTime = tmp1 - 1 | 0;
      Unit_getInstance();
    }if (this._this$0_164._powerUpTime <= 0) {
      setText(this._this$0_164._infotext, '');
      this._this$0_164._powerUpActive = false;
      deleteAllPowerUps(this._this$0_164);
    }var collission = collidingGround(this._this$0_164);
    if (!(collission === 0)) {
      this._$vertical._v = collission * this._this$0_164._jumpIntensity;
    }if (collidingPowerUps(this._this$0_164)) {
      activateRandomPowerUp(this._this$0_164);
    }var tmp0_min_0 = this._$horizontal._v * this._$vertical._v;
    var tmp1_min_0 = this._this$0_164._maxSpeed;
    this._$vertical._v = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp0_min_0, tmp1_min_0]))));
    }.call(this) / this._$horizontal._v;
    if (this._this$0_164._leftWalk) {
      xy(this._this$0_164._player, this._this$0_164._player._get_x__36() - this._$horizontal._v, this._this$0_164._player._get_y__36() - this._$vertical._v);
      Unit_getInstance();
    } else {
      xy(this._this$0_164._player, this._this$0_164._player._get_x__36() + this._$horizontal._v, this._this$0_164._player._get_y__36() - this._$vertical._v);
      Unit_getInstance();
    }
    updateShapePositions(this._this$0_164);
    if (this._this$0_164._player._get_y__36() > 950.0 ? this._this$0_164._playerIsAlive : false) {
      this._this$0_164._playerIsAlive = false;
      handleGameOver(this._this$0_164);
    }};
  _no_name_provided__542.prototype.invoke_1015 = function (p1) {
    this.invoke_980(p1 instanceof Circle ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__542.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__543(this$0, resultContinuation) {
    this._this$0_165 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__543.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__543.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__543.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._this$0_165._soundPlaying = true;
            this._state_1 = 1;
            var tmp_0 = _get_resourcesVfs_().get_115('bounce.mp3');
            suspendResult = readSound$default(tmp_0, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._sound0 = suspendResult;
            this._sound0._set_volume__8(2000.0);
            this._state_1 = 2;
            suspendResult = this._sound0.play$default(null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 3;
            suspendResult = delay_2(this._this$0_165, this._sound0._get_length__8(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            this._this$0_165._soundPlaying = false;
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__543.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__543(this._this$0_165, completion);
    return i;
  };
  _no_name_provided__543.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__544(this$0, resultContinuation) {
    this._this$0_166 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__544.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__544.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__544.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._this$0_166._playerIsAlive = true;
            var tmp_0 = this;
            tmp_0._tmp0_changeTo_00_0 = this._this$0_166._get_sceneContainer__2();
            var tmp_1 = this;
            tmp_1._tmp1_changeTo_01_0 = [];
            var tmp_2 = this;
            var tmp0__get_seconds__0_1 = 0;
            tmp_2._tmp2_changeTo_02_0 = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0_1);
            var tmp_3 = this;
            tmp_3._tmp3_changeTo_03_0 = this._tmp0_changeTo_00_0._defaultTransition;
            this._state_1 = 1;
            suspendResult = this._tmp0_changeTo_00_0.changeTo(getKClass_0(Scene3), this._tmp1_changeTo_01_0.slice(), this._tmp2_changeTo_02_0, this._tmp3_changeTo_03_0, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__544.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__544(this._this$0_166, completion);
    i._it_13 = it;
    return i;
  };
  _no_name_provided__544.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__545($tmp1_safe_receiver_1_2, $tmp21_onClick_0) {
    this._$tmp1_safe_receiver_1_2_3 = $tmp1_safe_receiver_1_2;
    this._$tmp21_onClick_0_0 = $tmp21_onClick_0;
  }
  _no_name_provided__545.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_3._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_489(this._$tmp21_onClick_0_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__545.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__545.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__546(this$0, $rect, resultContinuation) {
    this._this$0_167 = this$0;
    this._$rect = $rect;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__546.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__546.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__546.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = this;
            tmp_0._tmp0__get_seconds__00 = 5;
            suspendResult = delay_2(this._this$0_167, Companion_getInstance_27().fromSeconds(this._tmp0__get_seconds__00), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._$rect.removeFromParent_20();
            var tmp1_forEach_0 = this._this$0_167._groundObjects;
            var tmp0_iterator_1 = tmp1_forEach_0.iterator_67();
            while (tmp0_iterator_1.hasNext_33()) {
              var element_2 = tmp0_iterator_1.next_37();
              element_2._set_color__1(Colors_getInstance().get_91('#FFFFFF'));
            }

            this._this$0_167._player._set_fill__1(new RGBA(Colors_getInstance()._WHITE));
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__546.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__546(this._this$0_167, this._$rect, completion);
    return i;
  };
  _no_name_provided__546.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__547(this$0, $newPlattform, $lastPlattform, resultContinuation) {
    this._this$0_168 = this$0;
    this._$newPlattform = $newPlattform;
    this._$lastPlattform = $lastPlattform;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__547.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__547.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__547.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = _get_resourcesVfs_().get_115('chest_white.png');
            suspendResult = readBitmap$default(tmp_0, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var bitmap = suspendResult;
            var tmp0_image_0 = this._this$0_168._mainContainer;
            var tmp1_image_0 = 0.0;
            var tmp2_image_0 = 0.0;
            var tmp0_addTo_0_2 = Image_init_$Create$_0(bitmap, tmp1_image_0, tmp2_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp0_image_0);
            Unit_getInstance();
            var tmp_1 = scale$default(tmp0_apply_0_2_3, 0.4, 0.0, 2, null);
            var tmp_2 = Default_getInstance();
            var tmp3_max_0 = this._$newPlattform._v._width_20;
            var tmp4_max_0 = 1.0;
            var image = position(tmp_1, tmp_2.nextInt_6(numberToInt(function () {
              var $externalVarargReceiverTmp = Math;
              return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp3_max_0, tmp4_max_0]))));
            }.call(this))) + numberToInt(this._$newPlattform._v._get_x__36()) | 0, numberToInt(this._$lastPlattform._get_y__36() - this._this$0_168._plattformGap - 45));
            this._this$0_168._treasureObjects.add_39(image);
            Unit_getInstance();
            this._this$0_168._mainContainer.sendChildToBack_8(image);
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__547.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__547(this._this$0_168, this._$newPlattform, this._$lastPlattform, completion);
    return i;
  };
  _no_name_provided__547.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $sceneInitCOROUTINE$0(_this_, _this__0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__163 = _this_;
    this.__this__164 = _this__0;
  }
  $sceneInitCOROUTINE$0.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this.__this__163._mainContainer = this.__this__164;
            this.__this__163._groundObjects = createGroundObjects(this.__this__163);
            var tmp_0 = this.__this__163._groundObjects.get_137(0);
            addUpdater(tmp_0, _no_name_provided_$factory_490(this.__this__163));
            Unit_getInstance();
            initPlayer(this.__this__163);
            var tmp_1 = this;
            tmp_1._tmp0_roundRect_00 = 49.0;
            var tmp_2 = this;
            tmp_2._tmp1_roundRect_01 = 49.0;
            var tmp_3 = this;
            tmp_3._tmp2_roundRect_02 = 5.0;
            var tmp_4 = this;
            tmp_4._tmp3_roundRect_03 = 5.0;
            var tmp_5 = this;
            tmp_5._tmp4_roundRect_04 = Colors_getInstance()._BLACK;
            var tmp_6 = this;
            tmp_6._tmp5_roundRect_05 = Colors_getInstance()._WHITE;
            var tmp_7 = this;
            tmp_7._tmp6_roundRect_06 = 0.0;
            var tmp_8 = this;
            tmp_8._tmp7_roundRect_07 = true;
            var tmp_9 = this;
            tmp_9._tmp0_addTo_0_28 = new RoundRect(this._tmp0_roundRect_00, this._tmp1_roundRect_01, this._tmp2_roundRect_02, this._tmp3_roundRect_03, new RGBA(this._tmp4_roundRect_04), new RGBA(this._tmp5_roundRect_05), this._tmp6_roundRect_06, this._tmp7_roundRect_07);
            var tmp_10 = this;
            tmp_10._tmp0_apply_0_2_39 = addTo(this._tmp0_addTo_0_28, this.__this__164);
            Unit_getInstance();
            xy_0(this._tmp0_apply_0_2_39, 20, 0);
            Unit_getInstance();
            this._state_1 = 1;
            var tmp_11 = _get_resourcesVfs_().get_115('exit.png');
            suspendResult = readBitmap$default(tmp_11, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var exitBitmap = suspendResult;
            var tmp8_image_0 = 0.0;
            var tmp9_image_0 = 0.0;
            var tmp0_addTo_0_2 = Image_init_$Create$_0(exitBitmap, tmp8_image_0, tmp9_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, this.__this__164);
            Unit_getInstance();
            var exitButton = position(scale$default(tmp0_apply_0_2_3, 0.01, 0.0, 2, null), 28, 8);
            var tmp10_onClick_0 = _no_name_provided_$factory_491(this.__this__163, null);
            var tmp0_doMouseEvent_0_1 = click$factory_2();
            var tmp0_safe_receiver_2_3 = exitButton;
            var tmp1_safe_receiver_1_2 = tmp0_safe_receiver_2_3 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3);
            if (tmp1_safe_receiver_1_2 == null)
              null;
            else {
              var tmp_12 = tmp0_doMouseEvent_0_1.get(tmp1_safe_receiver_1_2);
              tmp_12.add_41(_no_name_provided_$factory_492(tmp1_safe_receiver_1_2, tmp10_onClick_0));
            }

            Unit_getInstance();
            Unit_getInstance();
            var tmp11_roundRect_0 = 452.0;
            var tmp12_roundRect_0 = 50.0;
            var tmp13_roundRect_0 = 5.0;
            var tmp14_roundRect_0 = 5.0;
            var tmp15_roundRect_0 = Colors_getInstance()._TRANSPARENT_BLACK;
            var tmp16_roundRect_0 = Colors_getInstance()._WHITE;
            var tmp17_roundRect_0 = 0.0;
            var tmp18_roundRect_0 = true;
            var tmp0_addTo_0_2_0 = new RoundRect(tmp11_roundRect_0, tmp12_roundRect_0, tmp13_roundRect_0, tmp14_roundRect_0, new RGBA(tmp15_roundRect_0), new RGBA(tmp16_roundRect_0), tmp17_roundRect_0, tmp18_roundRect_0);
            var tmp0_apply_0_2_3_0 = addTo(tmp0_addTo_0_2_0, this.__this__164);
            Unit_getInstance();
            xy_0(tmp0_apply_0_2_3_0, 60, 0);
            Unit_getInstance();
            var tmp19_roundRect_0 = 10.0;
            var tmp20_roundRect_0 = 1080.0;
            var tmp21_roundRect_0 = 0.0;
            var tmp22_roundRect_0 = 0.0;
            var tmp23_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp24_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp25_roundRect_0 = 0.0;
            var tmp26_roundRect_0 = true;
            var tmp0_addTo_0_2_1 = new RoundRect(tmp19_roundRect_0, tmp20_roundRect_0, tmp21_roundRect_0, tmp22_roundRect_0, new RGBA(tmp23_roundRect_0), new RGBA(tmp24_roundRect_0), tmp25_roundRect_0, tmp26_roundRect_0);
            var tmp0_apply_0_2_3_1 = addTo(tmp0_addTo_0_2_1, this.__this__164);
            Unit_getInstance();
            xy_0(tmp0_apply_0_2_3_1, 0, 0);
            Unit_getInstance();
            var tmp27_roundRect_0 = 10.0;
            var tmp28_roundRect_0 = 1080.0;
            var tmp29_roundRect_0 = 0.0;
            var tmp30_roundRect_0 = 0.0;
            var tmp31_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp32_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp33_roundRect_0 = 0.0;
            var tmp34_roundRect_0 = true;
            var tmp0_addTo_0_2_2 = new RoundRect(tmp27_roundRect_0, tmp28_roundRect_0, tmp29_roundRect_0, tmp30_roundRect_0, new RGBA(tmp31_roundRect_0), new RGBA(tmp32_roundRect_0), tmp33_roundRect_0, tmp34_roundRect_0);
            var tmp0_apply_0_2_3_2 = addTo(tmp0_addTo_0_2_2, this.__this__164);
            Unit_getInstance();
            xy_0(tmp0_apply_0_2_3_2, 502, 0);
            Unit_getInstance();
            var tmp35_roundRect_0 = 1000.0;
            var tmp36_roundRect_0 = 200.0;
            var tmp37_roundRect_0 = 0.0;
            var tmp38_roundRect_0 = 0.0;
            var tmp39_roundRect_0 = Colors_getInstance().get_91('#000000');
            var tmp40_roundRect_0 = Colors_getInstance().get_91('#000000');
            var tmp41_roundRect_0 = 0.0;
            var tmp42_roundRect_0 = true;
            var tmp0_addTo_0_2_3 = new RoundRect(tmp35_roundRect_0, tmp36_roundRect_0, tmp37_roundRect_0, tmp38_roundRect_0, new RGBA(tmp39_roundRect_0), new RGBA(tmp40_roundRect_0), tmp41_roundRect_0, tmp42_roundRect_0);
            var tmp0_apply_0_2_3_3 = addTo(tmp0_addTo_0_2_3, this.__this__164);
            Unit_getInstance();
            xy_0(tmp0_apply_0_2_3_3, 0, 949);
            Unit_getInstance();
            var tmp43_roundRect_0 = 150.0;
            var tmp44_roundRect_0 = 70.0;
            var tmp45_roundRect_0 = 0.0;
            var tmp46_roundRect_0 = 0.0;
            var tmp47_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp48_roundRect_0 = Colors_getInstance().get_91('#000000');
            var tmp49_roundRect_0 = 4.0;
            var tmp50_roundRect_0 = true;
            var tmp0_addTo_0_2_4 = new RoundRect(tmp43_roundRect_0, tmp44_roundRect_0, tmp45_roundRect_0, tmp46_roundRect_0, new RGBA(tmp47_roundRect_0), new RGBA(tmp48_roundRect_0), tmp49_roundRect_0, tmp50_roundRect_0);
            var tmp0_apply_0_2_3_4 = addTo(tmp0_addTo_0_2_4, this.__this__164);
            Unit_getInstance();
            var buttonLeft = xy_0(tmp0_apply_0_2_3_4, 256, 980);
            var tmp51_roundRect_0 = 150.0;
            var tmp52_roundRect_0 = 70.0;
            var tmp53_roundRect_0 = 0.0;
            var tmp54_roundRect_0 = 0.0;
            var tmp55_roundRect_0 = Colors_getInstance().get_91('#000000');
            var tmp56_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp57_roundRect_0 = 4.0;
            var tmp58_roundRect_0 = true;
            var tmp0_addTo_0_2_5 = new RoundRect(tmp51_roundRect_0, tmp52_roundRect_0, tmp53_roundRect_0, tmp54_roundRect_0, new RGBA(tmp55_roundRect_0), new RGBA(tmp56_roundRect_0), tmp57_roundRect_0, tmp58_roundRect_0);
            var tmp0_apply_0_2_3_5 = addTo(tmp0_addTo_0_2_5, this.__this__164);
            Unit_getInstance();
            var buttonRight = xy_0(tmp0_apply_0_2_3_5, 106, 980);
            var tmp59_onClick_0 = _no_name_provided_$factory_493(this.__this__163, buttonRight, buttonLeft, null);
            var tmp0_doMouseEvent_0_1_0 = click$factory_3();
            var tmp0_safe_receiver_2_3_0 = buttonRight;
            var tmp1_safe_receiver_1_2_0 = tmp0_safe_receiver_2_3_0 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3_0);
            if (tmp1_safe_receiver_1_2_0 == null)
              null;
            else {
              var tmp_13 = tmp0_doMouseEvent_0_1_0.get(tmp1_safe_receiver_1_2_0);
              tmp_13.add_41(_no_name_provided_$factory_494(tmp1_safe_receiver_1_2_0, tmp59_onClick_0));
            }

            Unit_getInstance();
            Unit_getInstance();
            var tmp60_onClick_0 = _no_name_provided_$factory_495(this.__this__163, buttonRight, buttonLeft, null);
            var tmp0_doMouseEvent_0_1_1 = click$factory_4();
            var tmp0_safe_receiver_2_3_1 = buttonLeft;
            var tmp1_safe_receiver_1_2_1 = tmp0_safe_receiver_2_3_1 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3_1);
            if (tmp1_safe_receiver_1_2_1 == null)
              null;
            else {
              var tmp_14 = tmp0_doMouseEvent_0_1_1.get(tmp1_safe_receiver_1_2_1);
              tmp_14.add_41(_no_name_provided_$factory_496(tmp1_safe_receiver_1_2_1, tmp60_onClick_0));
            }

            Unit_getInstance();
            Unit_getInstance();
            var tmp_15 = this.__this__163;
            var tmp_16 = Companion_getInstance_109();
            var tmp_17 = _get_DefaultTtfFont_();
            var tmp_18 = new RGBA(Colors_getInstance()._WHITE);
            var tmp0_font = tmp_16.invoke$default_3(tmp_17, 32.0, null, null, tmp_18, false, null, 108, null);
            var tmp1_alignment = Companion_getInstance_116()._CENTER_0;
            var tmp61_text_0 = this.__this__163._mainContainer;
            var tmp62_text_0 = '';
            var tmp63_text_0 = 32.0;
            var tmp64_text_0 = Colors_getInstance()._WHITE;
            var tmp65_text_0 = DefaultStringTextRenderer;
            var tmp66_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
            var tmp0_addTo_0_2_6 = new Text_2(tmp62_text_0, tmp63_text_0, tmp64_text_0, tmp0_font, tmp1_alignment, tmp65_text_0, tmp66_text_0);
            var tmp0_apply_0_2_3_6 = addTo(tmp0_addTo_0_2_6, tmp61_text_0);
            Unit_getInstance();
            tmp_15._infotext = tmp0_apply_0_2_3_6;
            position(this.__this__163._infotext, 256, 0);
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sceneInitCOROUTINE$0.$metadata$ = {
    simpleName: '$sceneInitCOROUTINE$0',
    kind: 'class',
    interfaces: []
  };
  function Scene3() {
    Scene.call(this);
    this._multiplikator = 1.0;
    this._multiplikator2 = 1.0;
    this._jumpIntensity = 4.0;
    this._moveIntensity = 2.0;
    this._maxSpeed = 9.0;
    this._gravity = 0.05;
    this._plattformGap = 150;
    this._pixeldepth = 0.0;
    this._powerUpTime = 300;
    this._powerUpActive = false;
    this._soundPlaying = false;
    this._leftWalk = false;
    this._playerIsAlive = true;
    this._mainContainer = new Container();
    var tmp = this;
    tmp._player = Circle_init_$Create$(0.0, null, null, 0.0, false, 31, null);
    var tmp_0 = this;
    tmp_0._groundObjects = ArrayList_init_$Create$();
    var tmp_1 = this;
    tmp_1._treasureObjects = ArrayList_init_$Create$();
    var tmp_2 = this;
    tmp_2._infotext = Text_init_$Create$('', 0.0, null, null, null, null, false, 126, null);
  }
  Scene3.prototype.sceneInit_3 = function (_this__0, $cont) {
    var tmp = new $sceneInitCOROUTINE$0(this, _this__0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Scene3.$metadata$ = {
    simpleName: 'Scene3',
    kind: 'class',
    interfaces: []
  };
  function click$factory_0() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function click$factory_1() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function click$factory_2() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function click$factory_3() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function click$factory_4() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function _no_name_provided_$factory_477(this$0, resultContinuation) {
    var i = new _no_name_provided__540(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_478($tmp1_safe_receiver_1_2, $tmp7_onClick_0) {
    var i = new _no_name_provided__541($tmp1_safe_receiver_1_2, $tmp7_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_479($vertical, this$0, $horizontal) {
    var i = new _no_name_provided__542($vertical, this$0, $horizontal);
    return function (p1) {
      i.invoke_980(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_480(this$0, resultContinuation) {
    var i = new _no_name_provided__543(this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_481(this$0, resultContinuation) {
    var i = new _no_name_provided__544(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_482($tmp1_safe_receiver_1_2, $tmp21_onClick_0) {
    var i = new _no_name_provided__545($tmp1_safe_receiver_1_2, $tmp21_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_483(this$0, $rect, resultContinuation) {
    var i = new _no_name_provided__546(this$0, $rect, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_484(this$0, $newPlattform, $lastPlattform, resultContinuation) {
    var i = new _no_name_provided__547(this$0, $newPlattform, $lastPlattform, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_485($tmp10_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__528($tmp10_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_486($tmp59_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__529($tmp59_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_487($tmp60_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__530($tmp60_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_488($tmp7_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__531($tmp7_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_489($tmp21_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__532($tmp21_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_490(this$0) {
    var i = new _no_name_provided__533(this$0);
    return function (p1, p2) {
      i.invoke_924(p1, p2._milliseconds);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_491(this$0, resultContinuation) {
    var i = new _no_name_provided__534(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_492($tmp1_safe_receiver_1_2, $tmp10_onClick_0) {
    var i = new _no_name_provided__535($tmp1_safe_receiver_1_2, $tmp10_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_493(this$0, $buttonRight, $buttonLeft, resultContinuation) {
    var i = new _no_name_provided__536(this$0, $buttonRight, $buttonLeft, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_494($tmp1_safe_receiver_1_2, $tmp59_onClick_0) {
    var i = new _no_name_provided__537($tmp1_safe_receiver_1_2, $tmp59_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_495(this$0, $buttonRight, $buttonLeft, resultContinuation) {
    var i = new _no_name_provided__538(this$0, $buttonRight, $buttonLeft, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_496($tmp1_safe_receiver_1_2, $tmp60_onClick_0) {
    var i = new _no_name_provided__539($tmp1_safe_receiver_1_2, $tmp60_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided__548($tmp10_onClick_0, $it, resultContinuation) {
    this._$tmp10_onClick_0_1 = $tmp10_onClick_0;
    this._$it_13 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__548.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__548.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__548.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp10_onClick_0_1(this._$it_13, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__548.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__548(this._$tmp10_onClick_0_1, this._$it_13, completion);
    return i;
  };
  _no_name_provided__548.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__549($tmp59_onClick_0, $it, resultContinuation) {
    this._$tmp59_onClick_0_1 = $tmp59_onClick_0;
    this._$it_14 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__549.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__549.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__549.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp59_onClick_0_1(this._$it_14, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__549.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__549(this._$tmp59_onClick_0_1, this._$it_14, completion);
    return i;
  };
  _no_name_provided__549.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__550($tmp60_onClick_0, $it, resultContinuation) {
    this._$tmp60_onClick_0_1 = $tmp60_onClick_0;
    this._$it_15 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__550.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__550.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__550.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp60_onClick_0_1(this._$it_15, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__550.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__550(this._$tmp60_onClick_0_1, this._$it_15, completion);
    return i;
  };
  _no_name_provided__550.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__551($tmp7_onClick_0, $it, resultContinuation) {
    this._$tmp7_onClick_0_1 = $tmp7_onClick_0;
    this._$it_16 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__551.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__551.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__551.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp7_onClick_0_1(this._$it_16, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__551.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__551(this._$tmp7_onClick_0_1, this._$it_16, completion);
    return i;
  };
  _no_name_provided__551.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__552($tmp21_onClick_0, $it, resultContinuation) {
    this._$tmp21_onClick_0_1 = $tmp21_onClick_0;
    this._$it_17 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__552.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__552.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__552.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp21_onClick_0_1(this._$it_17, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__552.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__552(this._$tmp21_onClick_0_1, this._$it_17, completion);
    return i;
  };
  _no_name_provided__552.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function initPlayer_0($this) {
    var horizontal = {_v: 1.0 * $this._moveIntensity_0};
    var vertical = {_v: 0.0};
    var tmp = $this;
    var tmp0_circle_0 = $this._mainContainer_0;
    var tmp1_circle_0 = 25.0;
    var tmp2_circle_0 = Colors_getInstance()._WHITE;
    var tmp3_circle_0 = Colors_getInstance()._WHITE;
    var tmp4_circle_0 = 0.0;
    var tmp5_circle_0 = true;
    var tmp1_addTo_0_2 = new Circle(tmp1_circle_0, new RGBA(tmp2_circle_0), new RGBA(tmp3_circle_0), tmp4_circle_0, tmp5_circle_0);
    var tmp0_apply_0_3 = addTo(tmp1_addTo_0_2, tmp0_circle_0);
    Unit_getInstance();
    tmp._player_0 = xy_0(tmp0_apply_0_3, 256, 700);
    var tmp6_onClick_0 = $this._player_0;
    var tmp7_onClick_0 = _no_name_provided_$factory_497($this, null);
    var tmp0_doMouseEvent_0_1 = click$factory_5();
    var tmp0_safe_receiver_2_3 = tmp6_onClick_0;
    var tmp1_safe_receiver_1_2 = tmp0_safe_receiver_2_3 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3);
    if (tmp1_safe_receiver_1_2 == null)
      null;
    else {
      var tmp_0 = tmp0_doMouseEvent_0_1.get(tmp1_safe_receiver_1_2);
      tmp_0.add_41(_no_name_provided_$factory_498(tmp1_safe_receiver_1_2, tmp7_onClick_0));
    }
    Unit_getInstance();
    Unit_getInstance();
    var tmp_1 = $this._player_0;
    var tmp_2 = _Frequency___init__impl_(60.0);
    addFixedUpdater$default(tmp_1, tmp_2, false, 0, _no_name_provided_$factory_499(vertical, $this, horizontal), 6, null);
    Unit_getInstance();
  }
  function playBounceSound_0($this) {
    launchImmediately_0($this, _no_name_provided_$factory_500($this, null));
    Unit_getInstance();
  }
  function handleGameOver_0($this, text) {
    var tmp0_solidRect_0 = $this._mainContainer_0;
    var tmp1_solidRect_0 = 512.0;
    var tmp2_solidRect_0 = 1080.0;
    var tmp3_solidRect_0 = Colors_getInstance().get_91('#000000');
    var tmp0_addTo_0_2 = new SolidRect(tmp1_solidRect_0, tmp2_solidRect_0, tmp3_solidRect_0);
    var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp0_solidRect_0);
    Unit_getInstance();
    xy_0(tmp0_apply_0_2_3, 0, 0);
    Unit_getInstance();
    var tmp4_text_0 = $this._mainContainer_0;
    var tmp5_text_0 = 'Restart Game';
    var tmp6_text_0 = 32.0;
    var tmp7_text_0 = Companion_getInstance_116()._CENTER_0;
    var tmp8_text_0 = Colors_getInstance()._WHITE;
    var tmp9_text_0 = _get_DefaultTtfFont_();
    var tmp10_text_0 = DefaultStringTextRenderer;
    var tmp11_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
    var tmp0_addTo_0_2_0 = new Text_2(tmp5_text_0, tmp6_text_0, tmp8_text_0, tmp9_text_0, tmp7_text_0, tmp10_text_0, tmp11_text_0);
    var tmp0_apply_0_2_3_0 = addTo(tmp0_addTo_0_2_0, tmp4_text_0);
    Unit_getInstance();
    position(tmp0_apply_0_2_3_0, 256, 530);
    Unit_getInstance();
    var tmp12_roundRect_0 = $this._mainContainer_0;
    var tmp13_roundRect_0 = 400.0;
    var tmp14_roundRect_0 = 100.0;
    var tmp15_roundRect_0 = 5.0;
    var tmp16_roundRect_0 = 5.0;
    var tmp17_roundRect_0 = Colors_getInstance()._TRANSPARENT_BLACK;
    var tmp18_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp19_roundRect_0 = 4.0;
    var tmp20_roundRect_0 = true;
    var tmp0_addTo_0_2_1 = new RoundRect(tmp13_roundRect_0, tmp14_roundRect_0, tmp15_roundRect_0, tmp16_roundRect_0, new RGBA(tmp17_roundRect_0), new RGBA(tmp18_roundRect_0), tmp19_roundRect_0, tmp20_roundRect_0);
    var tmp0_apply_0_2_3_1 = addTo(tmp0_addTo_0_2_1, tmp12_roundRect_0);
    Unit_getInstance();
    var restartButton = xy_0(tmp0_apply_0_2_3_1, 56, 500);
    var tmp21_onClick_0 = _no_name_provided_$factory_501($this, null);
    var tmp0_doMouseEvent_0_1 = click$factory_6();
    var tmp0_safe_receiver_2_3 = restartButton;
    var tmp1_safe_receiver_1_2 = tmp0_safe_receiver_2_3 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3);
    if (tmp1_safe_receiver_1_2 == null)
      null;
    else {
      var tmp = tmp0_doMouseEvent_0_1.get(tmp1_safe_receiver_1_2);
      tmp.add_41(_no_name_provided_$factory_502(tmp1_safe_receiver_1_2, tmp21_onClick_0));
    }
    Unit_getInstance();
    Unit_getInstance();
    var tmp_0 = Companion_getInstance_109();
    var tmp_1 = _get_DefaultTtfFont_();
    var tmp_2 = new RGBA(Colors_getInstance()._WHITE);
    var font = tmp_0.invoke$default_3(tmp_1, 64.0, null, null, tmp_2, false, null, 108, null);
    var tmp0_alignment = Companion_getInstance_116()._CENTER_0;
    var tmp22_text_0 = $this._mainContainer_0;
    var tmp23_text_0 = 64.0;
    var tmp24_text_0 = Colors_getInstance()._WHITE;
    var tmp25_text_0 = DefaultStringTextRenderer;
    var tmp26_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
    var tmp0_addTo_0_2_2 = new Text_2(text, tmp23_text_0, tmp24_text_0, font, tmp0_alignment, tmp25_text_0, tmp26_text_0);
    var tmp0_apply_0_2_3_2 = addTo(tmp0_addTo_0_2_2, tmp22_text_0);
    Unit_getInstance();
    position(tmp0_apply_0_2_3_2, 256, 300);
    Unit_getInstance();
    var tmp1_text = 'Pixel Highscore: ' + numberToInt(-1 * ($this._pixeldepth_0 + 1048 - $this._player_0._get_y__36())).toString();
    var tmp2_alignment = Companion_getInstance_116()._CENTER_0;
    var tmp27_text_0 = $this._mainContainer_0;
    var tmp28_text_0 = 32.0;
    var tmp29_text_0 = Colors_getInstance()._WHITE;
    var tmp30_text_0 = DefaultStringTextRenderer;
    var tmp31_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
    var tmp0_addTo_0_2_3 = new Text_2(tmp1_text, tmp28_text_0, tmp29_text_0, font, tmp2_alignment, tmp30_text_0, tmp31_text_0);
    var tmp0_apply_0_2_3_3 = addTo(tmp0_addTo_0_2_3, tmp27_text_0);
    Unit_getInstance();
    position(tmp0_apply_0_2_3_3, 256, 400);
    Unit_getInstance();
  }
  function activateRandomPowerUp_0($this) {
    var powerUpNumber = imul(Default_getInstance().nextInt_9(), 8);
    var tmp0_subject = powerUpNumber;
    switch (tmp0_subject) {
      case 1:
        setText($this._infotext_0, 'Gravity decreased');
        var tmp1_this = $this;
        tmp1_this._gravity_0 = tmp1_this._gravity_0 - 0.005;
        break;
      case 2:
        setText($this._infotext_0, 'Gravity increased');
        var tmp2_this = $this;
        tmp2_this._gravity_0 = tmp2_this._gravity_0 + 0.02;
        break;
      case 3:
        setText($this._infotext_0, 'Sideway speed increased');
        var tmp3_this = $this;
        tmp3_this._moveIntensity_0 = tmp3_this._moveIntensity_0 + 0.75;
        break;
      case 4:
        setText($this._infotext_0, 'Sideway speed decreased');
        var tmp4_this = $this;
        tmp4_this._moveIntensity_0 = tmp4_this._moveIntensity_0 - 0.5;
        break;
      case 5:
        setText($this._infotext_0, 'Jumping decreased');
        var tmp5_this = $this;
        tmp5_this._jumpIntensity_0 = tmp5_this._jumpIntensity_0 - 0.5;
        break;
      case 6:
        setText($this._infotext_0, 'Gravity inverted');
        $this._gravity_0 = -0.05;
        break;
      case 7:
        setText($this._infotext_0, 'color invert');
        var tmp0_forEach_0 = $this._groundObjects_0;
        var tmp0_iterator_1 = tmp0_forEach_0.iterator_67();
        while (tmp0_iterator_1.hasNext_33()) {
          var element_2 = tmp0_iterator_1.next_37();
          element_2._set_fill__1(new RGBA(Colors_getInstance().get_91('#000000')));
        }

        var tmp1_solidRect_0 = $this._mainContainer_0;
        var tmp2_solidRect_0 = 512;
        var tmp3_solidRect_0 = 1080;
        var tmp4_solidRect_0 = Colors_getInstance()._WHITE;
        var tmp0_addTo_0_2 = new SolidRect(tmp2_solidRect_0, tmp3_solidRect_0, tmp4_solidRect_0);
        var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp1_solidRect_0);
        Unit_getInstance();
        var rect_1 = tmp0_apply_0_2_3;
        $this._mainContainer_0.sendChildToBack_8(rect_1);
        $this._player_0._set_fill__1(new RGBA(Colors_getInstance()._BLACK));
        launchImmediately_0($this, _no_name_provided_$factory_503($this, rect_1, null));
        Unit_getInstance();
        break;
      case 8:
        setText($this._infotext_0, 'Speed increased');
        var tmp6_this = $this;
        tmp6_this._jumpIntensity_0 = tmp6_this._jumpIntensity_0 + 8.0;
        var tmp7_this = $this;
        tmp7_this._moveIntensity_0 = tmp7_this._moveIntensity_0 + 8.0;
        var tmp8_this = $this;
        tmp8_this._maxSpeed_0 = tmp8_this._maxSpeed_0 + 4.0;
        break;
      default:setText($this._infotext_0, 'Jumping increased');
        var tmp9_this = $this;
        tmp9_this._jumpIntensity_0 = tmp9_this._jumpIntensity_0 + 1.0;
        break;
    }
    $this._powerUpActive_0 = true;
    $this._powerUpTime_0 = 300;
  }
  function deleteAllPowerUps_0($this) {
    var tmp0_this = $this;
    tmp0_this._multiplikator_0 = tmp0_this._multiplikator_0 + 0.001;
    var tmp1_this = $this;
    tmp1_this._multiplikator2_0 = tmp1_this._multiplikator2_0 + 5.0E-5;
    $this._jumpIntensity_0 = 4.0 * $this._multiplikator2_0;
    $this._moveIntensity_0 = 2.0 * $this._multiplikator2_0;
    $this._maxSpeed_0 = 8.0 * $this._multiplikator_0;
    $this._gravity_0 = 0.05;
  }
  function changeButtonColor_0($this, bool, rect_1, rect2) {
    if (bool) {
      rect_1._set_fill__1(new RGBA(Colors_getInstance().get_91('#FFFFFF')));
      rect_1._set_stroke__0(new RGBA(Colors_getInstance().get_91('#000000')));
      rect2._set_fill__1(new RGBA(Colors_getInstance().get_91('#000000')));
      rect2._set_stroke__0(new RGBA(Colors_getInstance().get_91('#FFFFFF')));
    } else {
      rect_1._set_fill__1(new RGBA(Colors_getInstance().get_91('#000000')));
      rect_1._set_stroke__0(new RGBA(Colors_getInstance().get_91('#FFFFFF')));
      rect2._set_fill__1(new RGBA(Colors_getInstance().get_91('#FFFFFF')));
      rect2._set_stroke__0(new RGBA(Colors_getInstance().get_91('#000000')));
    }
  }
  function createGroundObjects_0($this) {
    var tmp0_roundRect_0 = $this._mainContainer_0;
    var tmp1_roundRect_0 = 1000.0;
    var tmp2_roundRect_0 = 50.0;
    var tmp3_roundRect_0 = 0.0;
    var tmp4_roundRect_0 = 0.0;
    var tmp5_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp6_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp7_roundRect_0 = 0.0;
    var tmp8_roundRect_0 = true;
    var tmp0_addTo_0_2 = new RoundRect(tmp1_roundRect_0, tmp2_roundRect_0, tmp3_roundRect_0, tmp4_roundRect_0, new RGBA(tmp5_roundRect_0), new RGBA(tmp6_roundRect_0), tmp7_roundRect_0, tmp8_roundRect_0);
    var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp0_roundRect_0);
    Unit_getInstance();
    var baseground = xy_0(tmp0_apply_0_2_3, 0, 900);
    var tmp9_roundRect_0 = $this._mainContainer_0;
    var tmp10_roundRect_0 = 200.0;
    var tmp11_roundRect_0 = 50.0;
    var tmp12_roundRect_0 = 0.0;
    var tmp13_roundRect_0 = 0.0;
    var tmp14_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp15_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp16_roundRect_0 = 0.0;
    var tmp17_roundRect_0 = true;
    var tmp0_addTo_0_2_0 = new RoundRect(tmp10_roundRect_0, tmp11_roundRect_0, tmp12_roundRect_0, tmp13_roundRect_0, new RGBA(tmp14_roundRect_0), new RGBA(tmp15_roundRect_0), tmp16_roundRect_0, tmp17_roundRect_0);
    var tmp0_apply_0_2_3_0 = addTo(tmp0_addTo_0_2_0, tmp9_roundRect_0);
    Unit_getInstance();
    var ground1 = xy_0(tmp0_apply_0_2_3_0, 0, 750);
    var tmp18_roundRect_0 = $this._mainContainer_0;
    var tmp19_roundRect_0 = 200.0;
    var tmp20_roundRect_0 = 50.0;
    var tmp21_roundRect_0 = 0.0;
    var tmp22_roundRect_0 = 0.0;
    var tmp23_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp24_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp25_roundRect_0 = 0.0;
    var tmp26_roundRect_0 = true;
    var tmp0_addTo_0_2_1 = new RoundRect(tmp19_roundRect_0, tmp20_roundRect_0, tmp21_roundRect_0, tmp22_roundRect_0, new RGBA(tmp23_roundRect_0), new RGBA(tmp24_roundRect_0), tmp25_roundRect_0, tmp26_roundRect_0);
    var tmp0_apply_0_2_3_1 = addTo(tmp0_addTo_0_2_1, tmp18_roundRect_0);
    Unit_getInstance();
    var ground2 = xy_0(tmp0_apply_0_2_3_1, 312, 650);
    var tmp27_roundRect_0 = $this._mainContainer_0;
    var tmp28_roundRect_0 = 100.0;
    var tmp29_roundRect_0 = 50.0;
    var tmp30_roundRect_0 = 0.0;
    var tmp31_roundRect_0 = 0.0;
    var tmp32_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp33_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp34_roundRect_0 = 0.0;
    var tmp35_roundRect_0 = true;
    var tmp0_addTo_0_2_2 = new RoundRect(tmp28_roundRect_0, tmp29_roundRect_0, tmp30_roundRect_0, tmp31_roundRect_0, new RGBA(tmp32_roundRect_0), new RGBA(tmp33_roundRect_0), tmp34_roundRect_0, tmp35_roundRect_0);
    var tmp0_apply_0_2_3_2 = addTo(tmp0_addTo_0_2_2, tmp27_roundRect_0);
    Unit_getInstance();
    var ground3 = xy_0(tmp0_apply_0_2_3_2, 162, 500);
    var tmp36_roundRect_0 = $this._mainContainer_0;
    var tmp37_roundRect_0 = 250.0;
    var tmp38_roundRect_0 = 50.0;
    var tmp39_roundRect_0 = 0.0;
    var tmp40_roundRect_0 = 0.0;
    var tmp41_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp42_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp43_roundRect_0 = 0.0;
    var tmp44_roundRect_0 = true;
    var tmp0_addTo_0_2_3 = new RoundRect(tmp37_roundRect_0, tmp38_roundRect_0, tmp39_roundRect_0, tmp40_roundRect_0, new RGBA(tmp41_roundRect_0), new RGBA(tmp42_roundRect_0), tmp43_roundRect_0, tmp44_roundRect_0);
    var tmp0_apply_0_2_3_3 = addTo(tmp0_addTo_0_2_3, tmp36_roundRect_0);
    Unit_getInstance();
    var ground4 = xy_0(tmp0_apply_0_2_3_3, 262, 300);
    var tmp45_roundRect_0 = $this._mainContainer_0;
    var tmp46_roundRect_0 = 150.0;
    var tmp47_roundRect_0 = 50.0;
    var tmp48_roundRect_0 = 0.0;
    var tmp49_roundRect_0 = 0.0;
    var tmp50_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp51_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp52_roundRect_0 = 0.0;
    var tmp53_roundRect_0 = true;
    var tmp0_addTo_0_2_4 = new RoundRect(tmp46_roundRect_0, tmp47_roundRect_0, tmp48_roundRect_0, tmp49_roundRect_0, new RGBA(tmp50_roundRect_0), new RGBA(tmp51_roundRect_0), tmp52_roundRect_0, tmp53_roundRect_0);
    var tmp0_apply_0_2_3_4 = addTo(tmp0_addTo_0_2_4, tmp45_roundRect_0);
    Unit_getInstance();
    var ground5 = xy_0(tmp0_apply_0_2_3_4, 0, 400);
    var tmp54_roundRect_0 = $this._mainContainer_0;
    var tmp55_roundRect_0 = 150.0;
    var tmp56_roundRect_0 = 50.0;
    var tmp57_roundRect_0 = 0.0;
    var tmp58_roundRect_0 = 0.0;
    var tmp59_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp60_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp61_roundRect_0 = 0.0;
    var tmp62_roundRect_0 = true;
    var tmp0_addTo_0_2_5 = new RoundRect(tmp55_roundRect_0, tmp56_roundRect_0, tmp57_roundRect_0, tmp58_roundRect_0, new RGBA(tmp59_roundRect_0), new RGBA(tmp60_roundRect_0), tmp61_roundRect_0, tmp62_roundRect_0);
    var tmp0_apply_0_2_3_5 = addTo(tmp0_addTo_0_2_5, tmp54_roundRect_0);
    Unit_getInstance();
    var ground6 = xy_0(tmp0_apply_0_2_3_5, 262, 50);
    var tmp63_roundRect_0 = $this._mainContainer_0;
    var tmp64_roundRect_0 = 250.0;
    var tmp65_roundRect_0 = 50.0;
    var tmp66_roundRect_0 = 0.0;
    var tmp67_roundRect_0 = 0.0;
    var tmp68_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp69_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp70_roundRect_0 = 0.0;
    var tmp71_roundRect_0 = true;
    var tmp0_addTo_0_2_6 = new RoundRect(tmp64_roundRect_0, tmp65_roundRect_0, tmp66_roundRect_0, tmp67_roundRect_0, new RGBA(tmp68_roundRect_0), new RGBA(tmp69_roundRect_0), tmp70_roundRect_0, tmp71_roundRect_0);
    var tmp0_apply_0_2_3_6 = addTo(tmp0_addTo_0_2_6, tmp63_roundRect_0);
    Unit_getInstance();
    var ground7 = xy_0(tmp0_apply_0_2_3_6, 0, 150);
    var tmp72_roundRect_0 = $this._mainContainer_0;
    var tmp73_roundRect_0 = 200.0;
    var tmp74_roundRect_0 = 50.0;
    var tmp75_roundRect_0 = 0.0;
    var tmp76_roundRect_0 = 0.0;
    var tmp77_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp78_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp79_roundRect_0 = 0.0;
    var tmp80_roundRect_0 = true;
    var tmp0_addTo_0_2_7 = new RoundRect(tmp73_roundRect_0, tmp74_roundRect_0, tmp75_roundRect_0, tmp76_roundRect_0, new RGBA(tmp77_roundRect_0), new RGBA(tmp78_roundRect_0), tmp79_roundRect_0, tmp80_roundRect_0);
    var tmp0_apply_0_2_3_7 = addTo(tmp0_addTo_0_2_7, tmp72_roundRect_0);
    Unit_getInstance();
    var ground8 = xy_0(tmp0_apply_0_2_3_7, 112, -100);
    var tmp81_roundRect_0 = $this._mainContainer_0;
    var tmp82_roundRect_0 = 150.0;
    var tmp83_roundRect_0 = 50.0;
    var tmp84_roundRect_0 = 0.0;
    var tmp85_roundRect_0 = 0.0;
    var tmp86_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp87_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp88_roundRect_0 = 0.0;
    var tmp89_roundRect_0 = true;
    var tmp0_addTo_0_2_8 = new RoundRect(tmp82_roundRect_0, tmp83_roundRect_0, tmp84_roundRect_0, tmp85_roundRect_0, new RGBA(tmp86_roundRect_0), new RGBA(tmp87_roundRect_0), tmp88_roundRect_0, tmp89_roundRect_0);
    var tmp0_apply_0_2_3_8 = addTo(tmp0_addTo_0_2_8, tmp81_roundRect_0);
    Unit_getInstance();
    var ground9 = xy_0(tmp0_apply_0_2_3_8, 362, 100);
    var tmp90_roundRect_0 = $this._mainContainer_0;
    var tmp91_roundRect_0 = 250.0;
    var tmp92_roundRect_0 = 50.0;
    var tmp93_roundRect_0 = 0.0;
    var tmp94_roundRect_0 = 0.0;
    var tmp95_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp96_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp97_roundRect_0 = 0.0;
    var tmp98_roundRect_0 = true;
    var tmp0_addTo_0_2_9 = new RoundRect(tmp91_roundRect_0, tmp92_roundRect_0, tmp93_roundRect_0, tmp94_roundRect_0, new RGBA(tmp95_roundRect_0), new RGBA(tmp96_roundRect_0), tmp97_roundRect_0, tmp98_roundRect_0);
    var tmp0_apply_0_2_3_9 = addTo(tmp0_addTo_0_2_9, tmp90_roundRect_0);
    Unit_getInstance();
    var ground10 = xy_0(tmp0_apply_0_2_3_9, 0, -350);
    var tmp99_roundRect_0 = $this._mainContainer_0;
    var tmp100_roundRect_0 = 80.0;
    var tmp101_roundRect_0 = 50.0;
    var tmp102_roundRect_0 = 0.0;
    var tmp103_roundRect_0 = 0.0;
    var tmp104_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp105_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp106_roundRect_0 = 0.0;
    var tmp107_roundRect_0 = true;
    var tmp0_addTo_0_2_10 = new RoundRect(tmp100_roundRect_0, tmp101_roundRect_0, tmp102_roundRect_0, tmp103_roundRect_0, new RGBA(tmp104_roundRect_0), new RGBA(tmp105_roundRect_0), tmp106_roundRect_0, tmp107_roundRect_0);
    var tmp0_apply_0_2_3_10 = addTo(tmp0_addTo_0_2_10, tmp99_roundRect_0);
    Unit_getInstance();
    var ground11 = xy_0(tmp0_apply_0_2_3_10, 432, -500);
    var tmp108_roundRect_0 = $this._mainContainer_0;
    var tmp109_roundRect_0 = 150.0;
    var tmp110_roundRect_0 = 50.0;
    var tmp111_roundRect_0 = 0.0;
    var tmp112_roundRect_0 = 0.0;
    var tmp113_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp114_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp115_roundRect_0 = 0.0;
    var tmp116_roundRect_0 = true;
    var tmp0_addTo_0_2_11 = new RoundRect(tmp109_roundRect_0, tmp110_roundRect_0, tmp111_roundRect_0, tmp112_roundRect_0, new RGBA(tmp113_roundRect_0), new RGBA(tmp114_roundRect_0), tmp115_roundRect_0, tmp116_roundRect_0);
    var tmp0_apply_0_2_3_11 = addTo(tmp0_addTo_0_2_11, tmp108_roundRect_0);
    Unit_getInstance();
    var ground12 = xy_0(tmp0_apply_0_2_3_11, 362, -200);
    var tmp117_roundRect_0 = $this._mainContainer_0;
    var tmp118_roundRect_0 = 100.0;
    var tmp119_roundRect_0 = 50.0;
    var tmp120_roundRect_0 = 0.0;
    var tmp121_roundRect_0 = 0.0;
    var tmp122_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp123_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp124_roundRect_0 = 0.0;
    var tmp125_roundRect_0 = true;
    var tmp0_addTo_0_2_12 = new RoundRect(tmp118_roundRect_0, tmp119_roundRect_0, tmp120_roundRect_0, tmp121_roundRect_0, new RGBA(tmp122_roundRect_0), new RGBA(tmp123_roundRect_0), tmp124_roundRect_0, tmp125_roundRect_0);
    var tmp0_apply_0_2_3_12 = addTo(tmp0_addTo_0_2_12, tmp117_roundRect_0);
    Unit_getInstance();
    var ground13 = xy_0(tmp0_apply_0_2_3_12, 112, -600);
    var tmp126_roundRect_0 = $this._mainContainer_0;
    var tmp127_roundRect_0 = 100.0;
    var tmp128_roundRect_0 = 50.0;
    var tmp129_roundRect_0 = 0.0;
    var tmp130_roundRect_0 = 0.0;
    var tmp131_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp132_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp133_roundRect_0 = 0.0;
    var tmp134_roundRect_0 = true;
    var tmp0_addTo_0_2_13 = new RoundRect(tmp127_roundRect_0, tmp128_roundRect_0, tmp129_roundRect_0, tmp130_roundRect_0, new RGBA(tmp131_roundRect_0), new RGBA(tmp132_roundRect_0), tmp133_roundRect_0, tmp134_roundRect_0);
    var tmp0_apply_0_2_3_13 = addTo(tmp0_addTo_0_2_13, tmp126_roundRect_0);
    Unit_getInstance();
    var ground14 = xy_0(tmp0_apply_0_2_3_13, 412, -750);
    var tmp135_roundRect_0 = $this._mainContainer_0;
    var tmp136_roundRect_0 = 100.0;
    var tmp137_roundRect_0 = 50.0;
    var tmp138_roundRect_0 = 0.0;
    var tmp139_roundRect_0 = 0.0;
    var tmp140_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp141_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp142_roundRect_0 = 0.0;
    var tmp143_roundRect_0 = true;
    var tmp0_addTo_0_2_14 = new RoundRect(tmp136_roundRect_0, tmp137_roundRect_0, tmp138_roundRect_0, tmp139_roundRect_0, new RGBA(tmp140_roundRect_0), new RGBA(tmp141_roundRect_0), tmp142_roundRect_0, tmp143_roundRect_0);
    var tmp0_apply_0_2_3_14 = addTo(tmp0_addTo_0_2_14, tmp135_roundRect_0);
    Unit_getInstance();
    var ground15 = xy_0(tmp0_apply_0_2_3_14, 0, -750);
    var tmp144_roundRect_0 = $this._mainContainer_0;
    var tmp145_roundRect_0 = 200.0;
    var tmp146_roundRect_0 = 50.0;
    var tmp147_roundRect_0 = 0.0;
    var tmp148_roundRect_0 = 0.0;
    var tmp149_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp150_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp151_roundRect_0 = 0.0;
    var tmp152_roundRect_0 = true;
    var tmp0_addTo_0_2_15 = new RoundRect(tmp145_roundRect_0, tmp146_roundRect_0, tmp147_roundRect_0, tmp148_roundRect_0, new RGBA(tmp149_roundRect_0), new RGBA(tmp150_roundRect_0), tmp151_roundRect_0, tmp152_roundRect_0);
    var tmp0_apply_0_2_3_15 = addTo(tmp0_addTo_0_2_15, tmp144_roundRect_0);
    Unit_getInstance();
    var ground16 = xy_0(tmp0_apply_0_2_3_15, 0, -850);
    var tmp153_roundRect_0 = $this._mainContainer_0;
    var tmp154_roundRect_0 = 150.0;
    var tmp155_roundRect_0 = 50.0;
    var tmp156_roundRect_0 = 0.0;
    var tmp157_roundRect_0 = 0.0;
    var tmp158_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp159_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp160_roundRect_0 = 0.0;
    var tmp161_roundRect_0 = true;
    var tmp0_addTo_0_2_16 = new RoundRect(tmp154_roundRect_0, tmp155_roundRect_0, tmp156_roundRect_0, tmp157_roundRect_0, new RGBA(tmp158_roundRect_0), new RGBA(tmp159_roundRect_0), tmp160_roundRect_0, tmp161_roundRect_0);
    var tmp0_apply_0_2_3_16 = addTo(tmp0_addTo_0_2_16, tmp153_roundRect_0);
    Unit_getInstance();
    var ground17 = xy_0(tmp0_apply_0_2_3_16, 362, -1000);
    var tmp162_roundRect_0 = $this._mainContainer_0;
    var tmp163_roundRect_0 = 200.0;
    var tmp164_roundRect_0 = 50.0;
    var tmp165_roundRect_0 = 0.0;
    var tmp166_roundRect_0 = 0.0;
    var tmp167_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp168_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp169_roundRect_0 = 0.0;
    var tmp170_roundRect_0 = true;
    var tmp0_addTo_0_2_17 = new RoundRect(tmp163_roundRect_0, tmp164_roundRect_0, tmp165_roundRect_0, tmp166_roundRect_0, new RGBA(tmp167_roundRect_0), new RGBA(tmp168_roundRect_0), tmp169_roundRect_0, tmp170_roundRect_0);
    var tmp0_apply_0_2_3_17 = addTo(tmp0_addTo_0_2_17, tmp162_roundRect_0);
    Unit_getInstance();
    var ground18 = xy_0(tmp0_apply_0_2_3_17, 0, -1150);
    var tmp171_roundRect_0 = $this._mainContainer_0;
    var tmp172_roundRect_0 = 200.0;
    var tmp173_roundRect_0 = 50.0;
    var tmp174_roundRect_0 = 0.0;
    var tmp175_roundRect_0 = 0.0;
    var tmp176_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp177_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp178_roundRect_0 = 0.0;
    var tmp179_roundRect_0 = true;
    var tmp0_addTo_0_2_18 = new RoundRect(tmp172_roundRect_0, tmp173_roundRect_0, tmp174_roundRect_0, tmp175_roundRect_0, new RGBA(tmp176_roundRect_0), new RGBA(tmp177_roundRect_0), tmp178_roundRect_0, tmp179_roundRect_0);
    var tmp0_apply_0_2_3_18 = addTo(tmp0_addTo_0_2_18, tmp171_roundRect_0);
    Unit_getInstance();
    var ground19 = xy_0(tmp0_apply_0_2_3_18, 312, -1350);
    var tmp180_roundRect_0 = $this._mainContainer_0;
    var tmp181_roundRect_0 = 230.0;
    var tmp182_roundRect_0 = 50.0;
    var tmp183_roundRect_0 = 0.0;
    var tmp184_roundRect_0 = 0.0;
    var tmp185_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp186_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp187_roundRect_0 = 0.0;
    var tmp188_roundRect_0 = true;
    var tmp0_addTo_0_2_19 = new RoundRect(tmp181_roundRect_0, tmp182_roundRect_0, tmp183_roundRect_0, tmp184_roundRect_0, new RGBA(tmp185_roundRect_0), new RGBA(tmp186_roundRect_0), tmp187_roundRect_0, tmp188_roundRect_0);
    var tmp0_apply_0_2_3_19 = addTo(tmp0_addTo_0_2_19, tmp180_roundRect_0);
    Unit_getInstance();
    var ground20 = xy_0(tmp0_apply_0_2_3_19, 162, -1300);
    var tmp189_roundRect_0 = $this._mainContainer_0;
    var tmp190_roundRect_0 = 100.0;
    var tmp191_roundRect_0 = 50.0;
    var tmp192_roundRect_0 = 0.0;
    var tmp193_roundRect_0 = 0.0;
    var tmp194_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp195_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp196_roundRect_0 = 0.0;
    var tmp197_roundRect_0 = true;
    var tmp0_addTo_0_2_20 = new RoundRect(tmp190_roundRect_0, tmp191_roundRect_0, tmp192_roundRect_0, tmp193_roundRect_0, new RGBA(tmp194_roundRect_0), new RGBA(tmp195_roundRect_0), tmp196_roundRect_0, tmp197_roundRect_0);
    var tmp0_apply_0_2_3_20 = addTo(tmp0_addTo_0_2_20, tmp189_roundRect_0);
    Unit_getInstance();
    var ground21 = xy_0(tmp0_apply_0_2_3_20, 412, -1500);
    var tmp198_roundRect_0 = $this._mainContainer_0;
    var tmp199_roundRect_0 = 80.0;
    var tmp200_roundRect_0 = 50.0;
    var tmp201_roundRect_0 = 0.0;
    var tmp202_roundRect_0 = 0.0;
    var tmp203_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp204_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp205_roundRect_0 = 0.0;
    var tmp206_roundRect_0 = true;
    var tmp0_addTo_0_2_21 = new RoundRect(tmp199_roundRect_0, tmp200_roundRect_0, tmp201_roundRect_0, tmp202_roundRect_0, new RGBA(tmp203_roundRect_0), new RGBA(tmp204_roundRect_0), tmp205_roundRect_0, tmp206_roundRect_0);
    var tmp0_apply_0_2_3_21 = addTo(tmp0_addTo_0_2_21, tmp198_roundRect_0);
    Unit_getInstance();
    var ground22 = xy_0(tmp0_apply_0_2_3_21, 432, -1650);
    var tmp207_roundRect_0 = $this._mainContainer_0;
    var tmp208_roundRect_0 = 50.0;
    var tmp209_roundRect_0 = 50.0;
    var tmp210_roundRect_0 = 0.0;
    var tmp211_roundRect_0 = 0.0;
    var tmp212_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp213_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp214_roundRect_0 = 0.0;
    var tmp215_roundRect_0 = true;
    var tmp0_addTo_0_2_22 = new RoundRect(tmp208_roundRect_0, tmp209_roundRect_0, tmp210_roundRect_0, tmp211_roundRect_0, new RGBA(tmp212_roundRect_0), new RGBA(tmp213_roundRect_0), tmp214_roundRect_0, tmp215_roundRect_0);
    var tmp0_apply_0_2_3_22 = addTo(tmp0_addTo_0_2_22, tmp207_roundRect_0);
    Unit_getInstance();
    var ground23 = xy_0(tmp0_apply_0_2_3_22, 462, -1800);
    var tmp216_roundRect_0 = $this._mainContainer_0;
    var tmp217_roundRect_0 = 80.0;
    var tmp218_roundRect_0 = 50.0;
    var tmp219_roundRect_0 = 0.0;
    var tmp220_roundRect_0 = 0.0;
    var tmp221_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp222_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp223_roundRect_0 = 0.0;
    var tmp224_roundRect_0 = true;
    var tmp0_addTo_0_2_23 = new RoundRect(tmp217_roundRect_0, tmp218_roundRect_0, tmp219_roundRect_0, tmp220_roundRect_0, new RGBA(tmp221_roundRect_0), new RGBA(tmp222_roundRect_0), tmp223_roundRect_0, tmp224_roundRect_0);
    var tmp0_apply_0_2_3_23 = addTo(tmp0_addTo_0_2_23, tmp216_roundRect_0);
    Unit_getInstance();
    var ground24 = xy_0(tmp0_apply_0_2_3_23, 62, -1850);
    var tmp225_roundRect_0 = $this._mainContainer_0;
    var tmp226_roundRect_0 = 50.0;
    var tmp227_roundRect_0 = 50.0;
    var tmp228_roundRect_0 = 0.0;
    var tmp229_roundRect_0 = 0.0;
    var tmp230_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp231_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp232_roundRect_0 = 0.0;
    var tmp233_roundRect_0 = true;
    var tmp0_addTo_0_2_24 = new RoundRect(tmp226_roundRect_0, tmp227_roundRect_0, tmp228_roundRect_0, tmp229_roundRect_0, new RGBA(tmp230_roundRect_0), new RGBA(tmp231_roundRect_0), tmp232_roundRect_0, tmp233_roundRect_0);
    var tmp0_apply_0_2_3_24 = addTo(tmp0_addTo_0_2_24, tmp225_roundRect_0);
    Unit_getInstance();
    var ground25 = xy_0(tmp0_apply_0_2_3_24, 462, -1950);
    var tmp234_roundRect_0 = $this._mainContainer_0;
    var tmp235_roundRect_0 = 300.0;
    var tmp236_roundRect_0 = 50.0;
    var tmp237_roundRect_0 = 0.0;
    var tmp238_roundRect_0 = 0.0;
    var tmp239_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp240_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp241_roundRect_0 = 0.0;
    var tmp242_roundRect_0 = true;
    var tmp0_addTo_0_2_25 = new RoundRect(tmp235_roundRect_0, tmp236_roundRect_0, tmp237_roundRect_0, tmp238_roundRect_0, new RGBA(tmp239_roundRect_0), new RGBA(tmp240_roundRect_0), tmp241_roundRect_0, tmp242_roundRect_0);
    var tmp0_apply_0_2_3_25 = addTo(tmp0_addTo_0_2_25, tmp234_roundRect_0);
    Unit_getInstance();
    var ground26 = xy_0(tmp0_apply_0_2_3_25, 0, -2100);
    var tmp243_roundRect_0 = $this._mainContainer_0;
    var tmp244_roundRect_0 = 100.0;
    var tmp245_roundRect_0 = 50.0;
    var tmp246_roundRect_0 = 0.0;
    var tmp247_roundRect_0 = 0.0;
    var tmp248_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp249_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp250_roundRect_0 = 0.0;
    var tmp251_roundRect_0 = true;
    var tmp0_addTo_0_2_26 = new RoundRect(tmp244_roundRect_0, tmp245_roundRect_0, tmp246_roundRect_0, tmp247_roundRect_0, new RGBA(tmp248_roundRect_0), new RGBA(tmp249_roundRect_0), tmp250_roundRect_0, tmp251_roundRect_0);
    var tmp0_apply_0_2_3_26 = addTo(tmp0_addTo_0_2_26, tmp243_roundRect_0);
    Unit_getInstance();
    var ground27 = xy_0(tmp0_apply_0_2_3_26, 312, -2250);
    var tmp252_roundRect_0 = $this._mainContainer_0;
    var tmp253_roundRect_0 = 50.0;
    var tmp254_roundRect_0 = 50.0;
    var tmp255_roundRect_0 = 0.0;
    var tmp256_roundRect_0 = 0.0;
    var tmp257_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp258_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp259_roundRect_0 = 0.0;
    var tmp260_roundRect_0 = true;
    var tmp0_addTo_0_2_27 = new RoundRect(tmp253_roundRect_0, tmp254_roundRect_0, tmp255_roundRect_0, tmp256_roundRect_0, new RGBA(tmp257_roundRect_0), new RGBA(tmp258_roundRect_0), tmp259_roundRect_0, tmp260_roundRect_0);
    var tmp0_apply_0_2_3_27 = addTo(tmp0_addTo_0_2_27, tmp252_roundRect_0);
    Unit_getInstance();
    var ground28 = xy_0(tmp0_apply_0_2_3_27, 462, -2400);
    var tmp261_roundRect_0 = $this._mainContainer_0;
    var tmp262_roundRect_0 = 350.0;
    var tmp263_roundRect_0 = 50.0;
    var tmp264_roundRect_0 = 0.0;
    var tmp265_roundRect_0 = 0.0;
    var tmp266_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp267_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp268_roundRect_0 = 0.0;
    var tmp269_roundRect_0 = true;
    var tmp0_addTo_0_2_28 = new RoundRect(tmp262_roundRect_0, tmp263_roundRect_0, tmp264_roundRect_0, tmp265_roundRect_0, new RGBA(tmp266_roundRect_0), new RGBA(tmp267_roundRect_0), tmp268_roundRect_0, tmp269_roundRect_0);
    var tmp0_apply_0_2_3_28 = addTo(tmp0_addTo_0_2_28, tmp261_roundRect_0);
    Unit_getInstance();
    var ground29 = xy_0(tmp0_apply_0_2_3_28, 0, -2550);
    var tmp270_roundRect_0 = $this._mainContainer_0;
    var tmp271_roundRect_0 = 425.0;
    var tmp272_roundRect_0 = 50.0;
    var tmp273_roundRect_0 = 0.0;
    var tmp274_roundRect_0 = 0.0;
    var tmp275_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp276_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp277_roundRect_0 = 0.0;
    var tmp278_roundRect_0 = true;
    var tmp0_addTo_0_2_29 = new RoundRect(tmp271_roundRect_0, tmp272_roundRect_0, tmp273_roundRect_0, tmp274_roundRect_0, new RGBA(tmp275_roundRect_0), new RGBA(tmp276_roundRect_0), tmp277_roundRect_0, tmp278_roundRect_0);
    var tmp0_apply_0_2_3_29 = addTo(tmp0_addTo_0_2_29, tmp270_roundRect_0);
    Unit_getInstance();
    var ground30 = xy_0(tmp0_apply_0_2_3_29, 87, -2650);
    var tmp279_roundRect_0 = $this._mainContainer_0;
    var tmp280_roundRect_0 = 50.0;
    var tmp281_roundRect_0 = 50.0;
    var tmp282_roundRect_0 = 0.0;
    var tmp283_roundRect_0 = 0.0;
    var tmp284_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp285_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp286_roundRect_0 = 0.0;
    var tmp287_roundRect_0 = true;
    var tmp0_addTo_0_2_30 = new RoundRect(tmp280_roundRect_0, tmp281_roundRect_0, tmp282_roundRect_0, tmp283_roundRect_0, new RGBA(tmp284_roundRect_0), new RGBA(tmp285_roundRect_0), tmp286_roundRect_0, tmp287_roundRect_0);
    var tmp0_apply_0_2_3_30 = addTo(tmp0_addTo_0_2_30, tmp279_roundRect_0);
    Unit_getInstance();
    var ground31 = xy_0(tmp0_apply_0_2_3_30, 462, -2750);
    var tmp288_roundRect_0 = $this._mainContainer_0;
    var tmp289_roundRect_0 = 150.0;
    var tmp290_roundRect_0 = 50.0;
    var tmp291_roundRect_0 = 0.0;
    var tmp292_roundRect_0 = 0.0;
    var tmp293_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp294_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp295_roundRect_0 = 0.0;
    var tmp296_roundRect_0 = true;
    var tmp0_addTo_0_2_31 = new RoundRect(tmp289_roundRect_0, tmp290_roundRect_0, tmp291_roundRect_0, tmp292_roundRect_0, new RGBA(tmp293_roundRect_0), new RGBA(tmp294_roundRect_0), tmp295_roundRect_0, tmp296_roundRect_0);
    var tmp0_apply_0_2_3_31 = addTo(tmp0_addTo_0_2_31, tmp288_roundRect_0);
    Unit_getInstance();
    var ground32 = xy_0(tmp0_apply_0_2_3_31, 150, -2750);
    var tmp297_roundRect_0 = $this._mainContainer_0;
    var tmp298_roundRect_0 = 250.0;
    var tmp299_roundRect_0 = 50.0;
    var tmp300_roundRect_0 = 0.0;
    var tmp301_roundRect_0 = 0.0;
    var tmp302_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp303_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp304_roundRect_0 = 0.0;
    var tmp305_roundRect_0 = true;
    var tmp0_addTo_0_2_32 = new RoundRect(tmp298_roundRect_0, tmp299_roundRect_0, tmp300_roundRect_0, tmp301_roundRect_0, new RGBA(tmp302_roundRect_0), new RGBA(tmp303_roundRect_0), tmp304_roundRect_0, tmp305_roundRect_0);
    var tmp0_apply_0_2_3_32 = addTo(tmp0_addTo_0_2_32, tmp297_roundRect_0);
    Unit_getInstance();
    var ground33 = xy_0(tmp0_apply_0_2_3_32, 100, -2800);
    var tmp306_roundRect_0 = $this._mainContainer_0;
    var tmp307_roundRect_0 = 250.0;
    var tmp308_roundRect_0 = 50.0;
    var tmp309_roundRect_0 = 0.0;
    var tmp310_roundRect_0 = 0.0;
    var tmp311_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp312_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp313_roundRect_0 = 0.0;
    var tmp314_roundRect_0 = true;
    var tmp0_addTo_0_2_33 = new RoundRect(tmp307_roundRect_0, tmp308_roundRect_0, tmp309_roundRect_0, tmp310_roundRect_0, new RGBA(tmp311_roundRect_0), new RGBA(tmp312_roundRect_0), tmp313_roundRect_0, tmp314_roundRect_0);
    var tmp0_apply_0_2_3_33 = addTo(tmp0_addTo_0_2_33, tmp306_roundRect_0);
    Unit_getInstance();
    var ground34 = xy_0(tmp0_apply_0_2_3_33, 100, -2850);
    var tmp315_roundRect_0 = $this._mainContainer_0;
    var tmp316_roundRect_0 = 250.0;
    var tmp317_roundRect_0 = 50.0;
    var tmp318_roundRect_0 = 0.0;
    var tmp319_roundRect_0 = 0.0;
    var tmp320_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp321_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp322_roundRect_0 = 0.0;
    var tmp323_roundRect_0 = true;
    var tmp0_addTo_0_2_34 = new RoundRect(tmp316_roundRect_0, tmp317_roundRect_0, tmp318_roundRect_0, tmp319_roundRect_0, new RGBA(tmp320_roundRect_0), new RGBA(tmp321_roundRect_0), tmp322_roundRect_0, tmp323_roundRect_0);
    var tmp0_apply_0_2_3_34 = addTo(tmp0_addTo_0_2_34, tmp315_roundRect_0);
    Unit_getInstance();
    var ground35 = xy_0(tmp0_apply_0_2_3_34, 100, -2900);
    var tmp324_roundRect_0 = $this._mainContainer_0;
    var tmp325_roundRect_0 = 150.0;
    var tmp326_roundRect_0 = 50.0;
    var tmp327_roundRect_0 = 0.0;
    var tmp328_roundRect_0 = 0.0;
    var tmp329_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp330_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp331_roundRect_0 = 0.0;
    var tmp332_roundRect_0 = true;
    var tmp0_addTo_0_2_35 = new RoundRect(tmp325_roundRect_0, tmp326_roundRect_0, tmp327_roundRect_0, tmp328_roundRect_0, new RGBA(tmp329_roundRect_0), new RGBA(tmp330_roundRect_0), tmp331_roundRect_0, tmp332_roundRect_0);
    var tmp0_apply_0_2_3_35 = addTo(tmp0_addTo_0_2_35, tmp324_roundRect_0);
    Unit_getInstance();
    var ground36 = xy_0(tmp0_apply_0_2_3_35, 150, -2950);
    var tmp333_roundRect_0 = $this._mainContainer_0;
    var tmp334_roundRect_0 = 50.0;
    var tmp335_roundRect_0 = 50.0;
    var tmp336_roundRect_0 = 0.0;
    var tmp337_roundRect_0 = 0.0;
    var tmp338_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp339_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp340_roundRect_0 = 0.0;
    var tmp341_roundRect_0 = true;
    var tmp0_addTo_0_2_36 = new RoundRect(tmp334_roundRect_0, tmp335_roundRect_0, tmp336_roundRect_0, tmp337_roundRect_0, new RGBA(tmp338_roundRect_0), new RGBA(tmp339_roundRect_0), tmp340_roundRect_0, tmp341_roundRect_0);
    var tmp0_apply_0_2_3_36 = addTo(tmp0_addTo_0_2_36, tmp333_roundRect_0);
    Unit_getInstance();
    var ground37 = xy_0(tmp0_apply_0_2_3_36, 200, -3000);
    var tmp342_roundRect_0 = $this._mainContainer_0;
    var tmp343_roundRect_0 = 512.0;
    var tmp344_roundRect_0 = 50.0;
    var tmp345_roundRect_0 = 0.0;
    var tmp346_roundRect_0 = 0.0;
    var tmp347_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp348_roundRect_0 = Colors_getInstance()._WHITE;
    var tmp349_roundRect_0 = 0.0;
    var tmp350_roundRect_0 = true;
    var tmp0_addTo_0_2_37 = new RoundRect(tmp343_roundRect_0, tmp344_roundRect_0, tmp345_roundRect_0, tmp346_roundRect_0, new RGBA(tmp347_roundRect_0), new RGBA(tmp348_roundRect_0), tmp349_roundRect_0, tmp350_roundRect_0);
    var tmp0_apply_0_2_3_37 = addTo(tmp0_addTo_0_2_37, tmp342_roundRect_0);
    Unit_getInstance();
    var ground38 = xy_0(tmp0_apply_0_2_3_37, 0, -3400);
    return mutableListOf([baseground, ground1, ground2, ground3, ground4, ground5, ground6, ground7, ground8, ground9, ground10, ground11, ground12, ground13, ground14, ground15, ground16, ground17, ground18, ground19, ground20, ground21, ground22, ground23, ground24, ground25, ground26, ground27, ground28, ground29, ground30, ground31, ground32, ground33, ground34, ground35, ground36, ground37, ground38]);
  }
  function createTreasureObjects($this, $cont) {
    var tmp = new $createTreasureObjectsCOROUTINE$2($this, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  }
  function updateShapePositions_0($this) {
    if ($this._player_0._get_y__36() < 540.0) {
      var difference = $this._player_0._get_y__36() - 540.0;
      var tmp0_this = $this._player_0;
      tmp0_this._set_y__27(tmp0_this._get_y__36() - difference);
      var tmp0_forEach_0 = $this._groundObjects_0;
      var tmp0_iterator_1 = tmp0_forEach_0.iterator_67();
      while (tmp0_iterator_1.hasNext_33()) {
        var element_2 = tmp0_iterator_1.next_37();
        var tmp0_this_4 = element_2;
        tmp0_this_4._set_y__27(tmp0_this_4._get_y__36() - difference);
      }
      var tmp1_forEach_0 = $this._treasureObjects_0;
      var tmp0_iterator_1_0 = tmp1_forEach_0.iterator_67();
      while (tmp0_iterator_1_0.hasNext_33()) {
        var element_2_0 = tmp0_iterator_1_0.next_37();
        var tmp0_this_4_0 = element_2_0;
        tmp0_this_4_0._set_y__27(tmp0_this_4_0._get_y__36() - difference);
      }
      var tmp1_this = $this;
      tmp1_this._pixeldepth_0 = tmp1_this._pixeldepth_0 + difference;
    }}
  function collidingPowerUps_0($this) {
    var tmp0_forEach_0 = $this._treasureObjects_0;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_67();
    while (tmp0_iterator_1.hasNext_33()) {
      var element_2 = tmp0_iterator_1.next_37();
      var tmp = $this._player_0;
      if (collidesWith$default(tmp, element_2, null, 2, null)) {
        element_2.removeFromParent_20();
        return true;
      } else {
      }
    }
    return false;
  }
  function collidingGround_0($this) {
    var tmp0_forEach_0 = $this._groundObjects_0;
    var tmp0_iterator_1 = tmp0_forEach_0.iterator_67();
    while (tmp0_iterator_1.hasNext_33()) {
      var element_2 = tmp0_iterator_1.next_37();
      var tmp = $this._player_0;
      if (collidesWith$default(tmp, element_2, null, 2, null)) {
        if (!$this._soundPlaying_0 ? $this._playerIsAlive_0 : false) {
          playBounceSound_0($this);
        }if ($this._player_0._get_y__36() < element_2._get_y__36()) {
          return 1.0;
        } else
          return -0.5;
      } else {
      }
    }
    return 0.0;
  }
  function _no_name_provided__553(this$0, resultContinuation) {
    this._this$0_169 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__553.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__553.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__553.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_changeTo_00_1 = this._this$0_169._get_sceneContainer__2();
            var tmp_1 = this;
            tmp_1._tmp1_changeTo_01_1 = [];
            var tmp_2 = this;
            var tmp0__get_seconds__0_1 = 0;
            tmp_2._tmp2_changeTo_02_1 = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0_1);
            var tmp_3 = this;
            tmp_3._tmp3_changeTo_03_1 = this._tmp0_changeTo_00_1._defaultTransition;
            this._state_1 = 1;
            suspendResult = this._tmp0_changeTo_00_1.changeTo(getKClass_0(Scene3), this._tmp1_changeTo_01_1.slice(), this._tmp2_changeTo_02_1, this._tmp3_changeTo_03_1, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__553.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__553(this._this$0_169, completion);
    i._it_14 = it;
    return i;
  };
  _no_name_provided__553.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__554($tmp1_safe_receiver_1_2, $tmp10_onClick_0) {
    this._$tmp1_safe_receiver_1_2_4 = $tmp1_safe_receiver_1_2;
    this._$tmp10_onClick_0_2 = $tmp10_onClick_0;
  }
  _no_name_provided__554.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_4._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_504(this._$tmp10_onClick_0_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__554.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__554.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__555(this$0, $buttonRight, $buttonLeft, resultContinuation) {
    this._this$0_170 = this$0;
    this._$buttonRight_1 = $buttonRight;
    this._$buttonLeft_1 = $buttonLeft;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__555.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__555.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__555.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          changeButtonColor_0(this._this$0_170, this._this$0_170._leftWalk_0, this._$buttonRight_1, this._$buttonLeft_1);
          this._this$0_170._leftWalk_0 = !this._this$0_170._leftWalk_0;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__555.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__555(this._this$0_170, this._$buttonRight_1, this._$buttonLeft_1, completion);
    i._it_15 = it;
    return i;
  };
  _no_name_provided__555.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__556($tmp1_safe_receiver_1_2, $tmp59_onClick_0) {
    this._$tmp1_safe_receiver_1_2_5 = $tmp1_safe_receiver_1_2;
    this._$tmp59_onClick_0_2 = $tmp59_onClick_0;
  }
  _no_name_provided__556.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_5._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_505(this._$tmp59_onClick_0_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__556.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__556.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__557(this$0, $buttonRight, $buttonLeft, resultContinuation) {
    this._this$0_171 = this$0;
    this._$buttonRight_2 = $buttonRight;
    this._$buttonLeft_2 = $buttonLeft;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__557.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__557.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__557.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          changeButtonColor_0(this._this$0_171, this._this$0_171._leftWalk_0, this._$buttonRight_2, this._$buttonLeft_2);
          this._this$0_171._leftWalk_0 = !this._this$0_171._leftWalk_0;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__557.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__557(this._this$0_171, this._$buttonRight_2, this._$buttonLeft_2, completion);
    i._it_16 = it;
    return i;
  };
  _no_name_provided__557.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__558($tmp1_safe_receiver_1_2, $tmp60_onClick_0) {
    this._$tmp1_safe_receiver_1_2_6 = $tmp1_safe_receiver_1_2;
    this._$tmp60_onClick_0_2 = $tmp60_onClick_0;
  }
  _no_name_provided__558.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_6._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_506(this._$tmp60_onClick_0_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__558.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__558.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__559(this$0, resultContinuation) {
    this._this$0_172 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__559.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__559.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__559.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          this._this$0_172._player_0._set_color__1(Colors_getInstance()._BLACK);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__559.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__559(this._this$0_172, completion);
    i._it_17 = it;
    return i;
  };
  _no_name_provided__559.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__560($tmp1_safe_receiver_1_2, $tmp7_onClick_0) {
    this._$tmp1_safe_receiver_1_2_7 = $tmp1_safe_receiver_1_2;
    this._$tmp7_onClick_0_2 = $tmp7_onClick_0;
  }
  _no_name_provided__560.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_7._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_507(this._$tmp7_onClick_0_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__560.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__560.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__561($vertical, this$0, $horizontal) {
    this._$vertical_0 = $vertical;
    this._this$0_173 = this$0;
    this._$horizontal_0 = $horizontal;
  }
  _no_name_provided__561.prototype.invoke_980 = function ($this$addFixedUpdater) {
    this._$vertical_0._v = this._$vertical_0._v - this._this$0_173._gravity_0;
    if (this._this$0_173._player_0._get_x__36() < 10.0 ? true : this._this$0_173._player_0._get_x__36() > 502 - this._this$0_173._player_0._get_radius_() * 2) {
      this._$horizontal_0._v = this._$horizontal_0._v - this._$horizontal_0._v * 2;
    }if (this._this$0_173._powerUpActive_0) {
      var tmp0_this = this._this$0_173;
      var tmp1 = tmp0_this._powerUpTime_0;
      tmp0_this._powerUpTime_0 = tmp1 - 1 | 0;
      Unit_getInstance();
    }if (this._this$0_173._powerUpTime_0 <= 0) {
      setText(this._this$0_173._infotext_0, '');
      this._this$0_173._powerUpActive_0 = false;
      deleteAllPowerUps_0(this._this$0_173);
    }var collission = collidingGround_0(this._this$0_173);
    if (!(collission === 0.0)) {
      this._$vertical_0._v = collission * this._this$0_173._jumpIntensity_0;
    }if (collidingPowerUps_0(this._this$0_173)) {
      activateRandomPowerUp_0(this._this$0_173);
    }var tmp0_min_0 = this._$horizontal_0._v * this._$vertical_0._v;
    var tmp1_min_0 = this._this$0_173._maxSpeed_0;
    this._$vertical_0._v = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp0_min_0, tmp1_min_0]))));
    }.call(this) / this._$horizontal_0._v;
    if (this._this$0_173._leftWalk_0) {
      xy(this._this$0_173._player_0, this._this$0_173._player_0._get_x__36() - this._$horizontal_0._v, this._this$0_173._player_0._get_y__36() - this._$vertical_0._v);
      Unit_getInstance();
    } else {
      xy(this._this$0_173._player_0, this._this$0_173._player_0._get_x__36() + this._$horizontal_0._v, this._this$0_173._player_0._get_y__36() - this._$vertical_0._v);
      Unit_getInstance();
    }
    updateShapePositions_0(this._this$0_173);
    if (this._this$0_173._player_0._get_y__36() > 950.0 ? this._this$0_173._playerIsAlive_0 : false) {
      this._this$0_173._playerIsAlive_0 = false;
      handleGameOver_0(this._this$0_173, 'Game Over!');
    }if (((this._this$0_173._player_0._get_x__36() > 220.0 ? this._this$0_173._player_0._get_x__36() < 230.0 : false) ? this._this$0_173._player_0._get_y__36() < this._this$0_173._treasureObjects_0.get_137(this._this$0_173._treasureObjects_0._get_size__60() - 1 | 0)._get_y__36() : false) ? this._this$0_173._playerIsAlive_0 : false) {
      this._this$0_173._playerIsAlive_0 = false;
      handleGameOver_0(this._this$0_173, 'You Win!');
    }};
  _no_name_provided__561.prototype.invoke_1015 = function (p1) {
    this.invoke_980(p1 instanceof Circle ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__561.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__562(this$0, resultContinuation) {
    this._this$0_174 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__562.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__562.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__562.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 4;
            this._this$0_174._soundPlaying_0 = true;
            this._state_1 = 1;
            var tmp_0 = _get_resourcesVfs_().get_115('bounce.mp3');
            suspendResult = readSound$default(tmp_0, null, false, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._sound0_0 = suspendResult;
            this._sound0_0._set_volume__8(2000.0);
            this._state_1 = 2;
            suspendResult = this._sound0_0.play$default(null, 1, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            suspendResult;
            Unit_getInstance();
            this._state_1 = 3;
            suspendResult = delay_2(this._this$0_174, this._sound0_0._get_length__8(), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 3:
            suspendResult;
            this._this$0_174._soundPlaying_0 = false;
            return Unit_getInstance();
          case 4:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 4) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__562.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__562(this._this$0_174, completion);
    return i;
  };
  _no_name_provided__562.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__563(this$0, resultContinuation) {
    this._this$0_175 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__563.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__563.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__563.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._this$0_175._playerIsAlive_0 = true;
            var tmp_0 = this;
            tmp_0._tmp0_changeTo_00_2 = this._this$0_175._get_sceneContainer__2();
            var tmp_1 = this;
            tmp_1._tmp1_changeTo_01_2 = [];
            var tmp_2 = this;
            var tmp0__get_seconds__0_1 = 0;
            tmp_2._tmp2_changeTo_02_2 = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0_1);
            var tmp_3 = this;
            tmp_3._tmp3_changeTo_03_2 = this._tmp0_changeTo_00_2._defaultTransition;
            this._state_1 = 1;
            suspendResult = this._tmp0_changeTo_00_2.changeTo(getKClass_0(Scene2), this._tmp1_changeTo_01_2.slice(), this._tmp2_changeTo_02_2, this._tmp3_changeTo_03_2, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__563.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__563(this._this$0_175, completion);
    i._it_18 = it;
    return i;
  };
  _no_name_provided__563.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__564($tmp1_safe_receiver_1_2, $tmp21_onClick_0) {
    this._$tmp1_safe_receiver_1_2_8 = $tmp1_safe_receiver_1_2;
    this._$tmp21_onClick_0_2 = $tmp21_onClick_0;
  }
  _no_name_provided__564.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_8._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_508(this._$tmp21_onClick_0_2, it, null));
    Unit_getInstance();
  };
  _no_name_provided__564.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__564.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__565(this$0, $rect, resultContinuation) {
    this._this$0_176 = this$0;
    this._$rect_0 = $rect;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__565.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__565.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__565.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            var tmp_0 = this;
            tmp_0._tmp0__get_seconds__00_0 = 5;
            suspendResult = delay_2(this._this$0_176, Companion_getInstance_27().fromSeconds(this._tmp0__get_seconds__00_0), this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            this._$rect_0.removeFromParent_20();
            var tmp1_forEach_0 = this._this$0_176._groundObjects_0;
            var tmp0_iterator_1 = tmp1_forEach_0.iterator_67();
            while (tmp0_iterator_1.hasNext_33()) {
              var element_2 = tmp0_iterator_1.next_37();
              element_2._set_fill__1(new RGBA(Colors_getInstance().get_91('#FFFFFF')));
            }

            this._this$0_176._player_0._set_fill__1(new RGBA(Colors_getInstance()._WHITE));
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__565.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__565(this._this$0_176, this._$rect_0, completion);
    return i;
  };
  _no_name_provided__565.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function $sceneInitCOROUTINE$1(_this_, _this__0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__165 = _this_;
    this.__this__166 = _this__0;
  }
  $sceneInitCOROUTINE$1.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this.__this__165._mainContainer_0 = this.__this__166;
            this.__this__165._groundObjects_0 = createGroundObjects_0(this.__this__165);
            this._state_1 = 1;
            suspendResult = createTreasureObjects(this.__this__165, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._ARGUMENT0_28 = suspendResult;
            this.__this__165._treasureObjects_0 = this._ARGUMENT0_28;
            initPlayer_0(this.__this__165);
            var tmp_0 = this;
            tmp_0._tmp0_roundRect_01 = 49.0;
            var tmp_1 = this;
            tmp_1._tmp1_roundRect_02 = 49.0;
            var tmp_2 = this;
            tmp_2._tmp2_roundRect_03 = 5.0;
            var tmp_3 = this;
            tmp_3._tmp3_roundRect_04 = 5.0;
            var tmp_4 = this;
            tmp_4._tmp4_roundRect_05 = Colors_getInstance()._BLACK;
            var tmp_5 = this;
            tmp_5._tmp5_roundRect_06 = Colors_getInstance()._WHITE;
            var tmp_6 = this;
            tmp_6._tmp6_roundRect_07 = 0.0;
            var tmp_7 = this;
            tmp_7._tmp7_roundRect_08 = true;
            var tmp_8 = this;
            tmp_8._tmp0_addTo_0_29 = new RoundRect(this._tmp0_roundRect_01, this._tmp1_roundRect_02, this._tmp2_roundRect_03, this._tmp3_roundRect_04, new RGBA(this._tmp4_roundRect_05), new RGBA(this._tmp5_roundRect_06), this._tmp6_roundRect_07, this._tmp7_roundRect_08);
            var tmp_9 = this;
            tmp_9._tmp0_apply_0_2_310 = addTo(this._tmp0_addTo_0_29, this.__this__166);
            Unit_getInstance();
            xy_0(this._tmp0_apply_0_2_310, 20, 0);
            Unit_getInstance();
            this._state_1 = 2;
            var tmp_10 = _get_resourcesVfs_().get_115('exit.png');
            suspendResult = readBitmap$default(tmp_10, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var exitBitmap = suspendResult;
            var tmp8_image_0 = 0.0;
            var tmp9_image_0 = 0.0;
            var tmp0_addTo_0_2 = Image_init_$Create$_0(exitBitmap, tmp8_image_0, tmp9_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, this.__this__166);
            Unit_getInstance();
            var exitButton = position(scale$default(tmp0_apply_0_2_3, 0.01, 0.0, 2, null), 28, 8);
            var tmp10_onClick_0 = _no_name_provided_$factory_509(this.__this__165, null);
            var tmp0_doMouseEvent_0_1 = click$factory_7();
            var tmp0_safe_receiver_2_3 = exitButton;
            var tmp1_safe_receiver_1_2 = tmp0_safe_receiver_2_3 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3);
            if (tmp1_safe_receiver_1_2 == null)
              null;
            else {
              var tmp_11 = tmp0_doMouseEvent_0_1.get(tmp1_safe_receiver_1_2);
              tmp_11.add_41(_no_name_provided_$factory_510(tmp1_safe_receiver_1_2, tmp10_onClick_0));
            }

            Unit_getInstance();
            Unit_getInstance();
            var tmp11_roundRect_0 = 452.0;
            var tmp12_roundRect_0 = 50.0;
            var tmp13_roundRect_0 = 5.0;
            var tmp14_roundRect_0 = 5.0;
            var tmp15_roundRect_0 = Colors_getInstance()._TRANSPARENT_BLACK;
            var tmp16_roundRect_0 = Colors_getInstance()._WHITE;
            var tmp17_roundRect_0 = 0.0;
            var tmp18_roundRect_0 = true;
            var tmp0_addTo_0_2_0 = new RoundRect(tmp11_roundRect_0, tmp12_roundRect_0, tmp13_roundRect_0, tmp14_roundRect_0, new RGBA(tmp15_roundRect_0), new RGBA(tmp16_roundRect_0), tmp17_roundRect_0, tmp18_roundRect_0);
            var tmp0_apply_0_2_3_0 = addTo(tmp0_addTo_0_2_0, this.__this__166);
            Unit_getInstance();
            xy_0(tmp0_apply_0_2_3_0, 60, 0);
            Unit_getInstance();
            var tmp19_roundRect_0 = 10.0;
            var tmp20_roundRect_0 = 1080.0;
            var tmp21_roundRect_0 = 0.0;
            var tmp22_roundRect_0 = 0.0;
            var tmp23_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp24_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp25_roundRect_0 = 0.0;
            var tmp26_roundRect_0 = true;
            var tmp0_addTo_0_2_1 = new RoundRect(tmp19_roundRect_0, tmp20_roundRect_0, tmp21_roundRect_0, tmp22_roundRect_0, new RGBA(tmp23_roundRect_0), new RGBA(tmp24_roundRect_0), tmp25_roundRect_0, tmp26_roundRect_0);
            var tmp0_apply_0_2_3_1 = addTo(tmp0_addTo_0_2_1, this.__this__166);
            Unit_getInstance();
            xy_0(tmp0_apply_0_2_3_1, 0, 0);
            Unit_getInstance();
            var tmp27_roundRect_0 = 10.0;
            var tmp28_roundRect_0 = 1080.0;
            var tmp29_roundRect_0 = 0.0;
            var tmp30_roundRect_0 = 0.0;
            var tmp31_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp32_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp33_roundRect_0 = 0.0;
            var tmp34_roundRect_0 = true;
            var tmp0_addTo_0_2_2 = new RoundRect(tmp27_roundRect_0, tmp28_roundRect_0, tmp29_roundRect_0, tmp30_roundRect_0, new RGBA(tmp31_roundRect_0), new RGBA(tmp32_roundRect_0), tmp33_roundRect_0, tmp34_roundRect_0);
            var tmp0_apply_0_2_3_2 = addTo(tmp0_addTo_0_2_2, this.__this__166);
            Unit_getInstance();
            xy_0(tmp0_apply_0_2_3_2, 502, 0);
            Unit_getInstance();
            var tmp35_roundRect_0 = 1000.0;
            var tmp36_roundRect_0 = 200.0;
            var tmp37_roundRect_0 = 0.0;
            var tmp38_roundRect_0 = 0.0;
            var tmp39_roundRect_0 = Colors_getInstance().get_91('#000000');
            var tmp40_roundRect_0 = Colors_getInstance().get_91('#000000');
            var tmp41_roundRect_0 = 0.0;
            var tmp42_roundRect_0 = true;
            var tmp0_addTo_0_2_3 = new RoundRect(tmp35_roundRect_0, tmp36_roundRect_0, tmp37_roundRect_0, tmp38_roundRect_0, new RGBA(tmp39_roundRect_0), new RGBA(tmp40_roundRect_0), tmp41_roundRect_0, tmp42_roundRect_0);
            var tmp0_apply_0_2_3_3 = addTo(tmp0_addTo_0_2_3, this.__this__166);
            Unit_getInstance();
            xy_0(tmp0_apply_0_2_3_3, 0, 949);
            Unit_getInstance();
            var tmp43_roundRect_0 = 150.0;
            var tmp44_roundRect_0 = 70.0;
            var tmp45_roundRect_0 = 0.0;
            var tmp46_roundRect_0 = 0.0;
            var tmp47_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp48_roundRect_0 = Colors_getInstance().get_91('#000000');
            var tmp49_roundRect_0 = 4.0;
            var tmp50_roundRect_0 = true;
            var tmp0_addTo_0_2_4 = new RoundRect(tmp43_roundRect_0, tmp44_roundRect_0, tmp45_roundRect_0, tmp46_roundRect_0, new RGBA(tmp47_roundRect_0), new RGBA(tmp48_roundRect_0), tmp49_roundRect_0, tmp50_roundRect_0);
            var tmp0_apply_0_2_3_4 = addTo(tmp0_addTo_0_2_4, this.__this__166);
            Unit_getInstance();
            var buttonLeft = xy_0(tmp0_apply_0_2_3_4, 256, 980);
            var tmp51_roundRect_0 = 150.0;
            var tmp52_roundRect_0 = 70.0;
            var tmp53_roundRect_0 = 0.0;
            var tmp54_roundRect_0 = 0.0;
            var tmp55_roundRect_0 = Colors_getInstance().get_91('#000000');
            var tmp56_roundRect_0 = Colors_getInstance().get_91('#FFFFFF');
            var tmp57_roundRect_0 = 4.0;
            var tmp58_roundRect_0 = true;
            var tmp0_addTo_0_2_5 = new RoundRect(tmp51_roundRect_0, tmp52_roundRect_0, tmp53_roundRect_0, tmp54_roundRect_0, new RGBA(tmp55_roundRect_0), new RGBA(tmp56_roundRect_0), tmp57_roundRect_0, tmp58_roundRect_0);
            var tmp0_apply_0_2_3_5 = addTo(tmp0_addTo_0_2_5, this.__this__166);
            Unit_getInstance();
            var buttonRight = xy_0(tmp0_apply_0_2_3_5, 106, 980);
            var tmp59_onClick_0 = _no_name_provided_$factory_511(this.__this__165, buttonRight, buttonLeft, null);
            var tmp0_doMouseEvent_0_1_0 = click$factory_8();
            var tmp0_safe_receiver_2_3_0 = buttonRight;
            var tmp1_safe_receiver_1_2_0 = tmp0_safe_receiver_2_3_0 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3_0);
            if (tmp1_safe_receiver_1_2_0 == null)
              null;
            else {
              var tmp_12 = tmp0_doMouseEvent_0_1_0.get(tmp1_safe_receiver_1_2_0);
              tmp_12.add_41(_no_name_provided_$factory_512(tmp1_safe_receiver_1_2_0, tmp59_onClick_0));
            }

            Unit_getInstance();
            Unit_getInstance();
            var tmp60_onClick_0 = _no_name_provided_$factory_513(this.__this__165, buttonRight, buttonLeft, null);
            var tmp0_doMouseEvent_0_1_1 = click$factory_9();
            var tmp0_safe_receiver_2_3_1 = buttonLeft;
            var tmp1_safe_receiver_1_2_1 = tmp0_safe_receiver_2_3_1 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3_1);
            if (tmp1_safe_receiver_1_2_1 == null)
              null;
            else {
              var tmp_13 = tmp0_doMouseEvent_0_1_1.get(tmp1_safe_receiver_1_2_1);
              tmp_13.add_41(_no_name_provided_$factory_514(tmp1_safe_receiver_1_2_1, tmp60_onClick_0));
            }

            Unit_getInstance();
            Unit_getInstance();
            var tmp_14 = this.__this__165;
            var tmp_15 = Companion_getInstance_109();
            var tmp_16 = _get_DefaultTtfFont_();
            var tmp_17 = new RGBA(Colors_getInstance()._WHITE);
            var tmp0_font = tmp_15.invoke$default_3(tmp_16, 32.0, null, null, tmp_17, false, null, 108, null);
            var tmp1_alignment = Companion_getInstance_116()._CENTER_0;
            var tmp61_text_0 = this.__this__165._mainContainer_0;
            var tmp62_text_0 = '';
            var tmp63_text_0 = 32.0;
            var tmp64_text_0 = Colors_getInstance()._WHITE;
            var tmp65_text_0 = DefaultStringTextRenderer;
            var tmp66_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
            var tmp0_addTo_0_2_6 = new Text_2(tmp62_text_0, tmp63_text_0, tmp64_text_0, tmp0_font, tmp1_alignment, tmp65_text_0, tmp66_text_0);
            var tmp0_apply_0_2_3_6 = addTo(tmp0_addTo_0_2_6, tmp61_text_0);
            Unit_getInstance();
            tmp_14._infotext_0 = tmp0_apply_0_2_3_6;
            position(this.__this__165._infotext_0, 256, 0);
            Unit_getInstance();
            return Unit_getInstance();
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sceneInitCOROUTINE$1.$metadata$ = {
    simpleName: '$sceneInitCOROUTINE$1',
    kind: 'class',
    interfaces: []
  };
  function $createTreasureObjectsCOROUTINE$2(_this_, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__167 = _this_;
  }
  $createTreasureObjectsCOROUTINE$2.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 3;
            this._state_1 = 1;
            var tmp_0 = _get_resourcesVfs_().get_115('chest_white.png');
            suspendResult = readBitmap$default(tmp_0, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            this._bitmap0 = suspendResult;
            this._state_1 = 2;
            var tmp_1 = _get_resourcesVfs_().get_115('goal_white.png');
            suspendResult = readBitmap$default(tmp_1, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 2:
            var bitmap2 = suspendResult;
            var tmp0_image_0 = this.__this__167._mainContainer_0;
            var tmp1_image_0 = 0.0;
            var tmp2_image_0 = 0.0;
            var tmp0_addTo_0_2 = Image_init_$Create$_0(this._bitmap0, tmp1_image_0, tmp2_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, tmp0_image_0);
            Unit_getInstance();
            var image1 = position(scale$default(tmp0_apply_0_2_3, 0.4, 0.0, 2, null), 52, 705);
            var tmp3_image_0 = this.__this__167._mainContainer_0;
            var tmp4_image_0 = 0.0;
            var tmp5_image_0 = 0.0;
            var tmp0_addTo_0_2_0 = Image_init_$Create$_0(this._bitmap0, tmp4_image_0, tmp5_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3_0 = addTo(tmp0_addTo_0_2_0, tmp3_image_0);
            Unit_getInstance();
            var image2 = position(scale$default(tmp0_apply_0_2_3_0, 0.4, 0.0, 2, null), 450, 55);
            var tmp6_image_0 = this.__this__167._mainContainer_0;
            var tmp7_image_0 = 0.0;
            var tmp8_image_0 = 0.0;
            var tmp0_addTo_0_2_1 = Image_init_$Create$_0(this._bitmap0, tmp7_image_0, tmp8_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3_1 = addTo(tmp0_addTo_0_2_1, tmp6_image_0);
            Unit_getInstance();
            var image3 = position(scale$default(tmp0_apply_0_2_3_1, 0.4, 0.0, 2, null), 5, -795);
            var tmp9_image_0 = this.__this__167._mainContainer_0;
            var tmp10_image_0 = 0.0;
            var tmp11_image_0 = 0.0;
            var tmp0_addTo_0_2_2 = Image_init_$Create$_0(this._bitmap0, tmp10_image_0, tmp11_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3_2 = addTo(tmp0_addTo_0_2_2, tmp9_image_0);
            Unit_getInstance();
            var image4 = position(scale$default(tmp0_apply_0_2_3_2, 0.4, 0.0, 2, null), 65, -1895);
            var tmp12_image_0 = this.__this__167._mainContainer_0;
            var tmp13_image_0 = 0.0;
            var tmp14_image_0 = 0.0;
            var tmp0_addTo_0_2_3 = Image_init_$Create$_0(bitmap2, tmp13_image_0, tmp14_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3_3 = addTo(tmp0_addTo_0_2_3, tmp12_image_0);
            Unit_getInstance();
            var image5 = position(scale$default(tmp0_apply_0_2_3_3, 0.4, 0.0, 2, null), 200, -3045);
            return mutableListOf([image1, image2, image3, image4, image5]);
          case 3:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 3) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $createTreasureObjectsCOROUTINE$2.$metadata$ = {
    simpleName: '$createTreasureObjectsCOROUTINE$2',
    kind: 'class',
    interfaces: []
  };
  function Scene2() {
    Scene.call(this);
    this._jumpIntensity_0 = 4.0;
    this._multiplikator_0 = 1.0;
    this._multiplikator2_0 = 1.0;
    this._moveIntensity_0 = 2.0;
    this._maxSpeed_0 = 8.0;
    this._gravity_0 = 0.05;
    this._pixeldepth_0 = 0.0;
    this._powerUpTime_0 = 300;
    this._powerUpActive_0 = false;
    this._soundPlaying_0 = false;
    this._leftWalk_0 = false;
    this._playerIsAlive_0 = true;
    this._mainContainer_0 = new Container();
    var tmp = this;
    tmp._player_0 = Circle_init_$Create$(0.0, null, null, 0.0, false, 31, null);
    var tmp_0 = this;
    tmp_0._groundObjects_0 = ArrayList_init_$Create$();
    var tmp_1 = this;
    tmp_1._treasureObjects_0 = ArrayList_init_$Create$();
    var tmp_2 = this;
    tmp_2._infotext_0 = Text_init_$Create$('', 0.0, null, null, null, null, false, 126, null);
  }
  Scene2.prototype.sceneInit_3 = function (_this__0, $cont) {
    var tmp = new $sceneInitCOROUTINE$1(this, _this__0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Scene2.$metadata$ = {
    simpleName: 'Scene2',
    kind: 'class',
    interfaces: []
  };
  function click$factory_5() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function click$factory_6() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function click$factory_7() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function click$factory_8() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function click$factory_9() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function _no_name_provided_$factory_497(this$0, resultContinuation) {
    var i = new _no_name_provided__559(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_498($tmp1_safe_receiver_1_2, $tmp7_onClick_0) {
    var i = new _no_name_provided__560($tmp1_safe_receiver_1_2, $tmp7_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_499($vertical, this$0, $horizontal) {
    var i = new _no_name_provided__561($vertical, this$0, $horizontal);
    return function (p1) {
      i.invoke_980(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_500(this$0, resultContinuation) {
    var i = new _no_name_provided__562(this$0, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_501(this$0, resultContinuation) {
    var i = new _no_name_provided__563(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_502($tmp1_safe_receiver_1_2, $tmp21_onClick_0) {
    var i = new _no_name_provided__564($tmp1_safe_receiver_1_2, $tmp21_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_503(this$0, $rect, resultContinuation) {
    var i = new _no_name_provided__565(this$0, $rect, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_504($tmp10_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__548($tmp10_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_505($tmp59_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__549($tmp59_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_506($tmp60_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__550($tmp60_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_507($tmp7_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__551($tmp7_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_508($tmp21_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__552($tmp21_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_509(this$0, resultContinuation) {
    var i = new _no_name_provided__553(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_510($tmp1_safe_receiver_1_2, $tmp10_onClick_0) {
    var i = new _no_name_provided__554($tmp1_safe_receiver_1_2, $tmp10_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_511(this$0, $buttonRight, $buttonLeft, resultContinuation) {
    var i = new _no_name_provided__555(this$0, $buttonRight, $buttonLeft, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_512($tmp1_safe_receiver_1_2, $tmp59_onClick_0) {
    var i = new _no_name_provided__556($tmp1_safe_receiver_1_2, $tmp59_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_513(this$0, $buttonRight, $buttonLeft, resultContinuation) {
    var i = new _no_name_provided__557(this$0, $buttonRight, $buttonLeft, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_514($tmp1_safe_receiver_1_2, $tmp60_onClick_0) {
    var i = new _no_name_provided__558($tmp1_safe_receiver_1_2, $tmp60_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function main($cont) {
    var tmp = Korge_getInstance();
    var tmp_0 = ConfigModule_getInstance();
    return tmp.invoke_614(Config_init_$Create$(tmp_0, null, null, null, null, null, null, null, false, false, null, null, false, null, null, 0, null, 131070, null), $cont);
  }
  function _no_name_provided__566(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__566.prototype.invoke_994 = function ($this$mapPrototype, $cont) {
    var tmp = this.create_99($this$mapPrototype, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__566.prototype.invoke_1015 = function (p1, $cont) {
    return this.invoke_994(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__566.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          return new Scene1();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__566.prototype.create_99 = function ($this$mapPrototype, completion) {
    var i = new _no_name_provided__566(completion);
    i._$this$mapPrototype_0 = $this$mapPrototype;
    return i;
  };
  _no_name_provided__566.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__567(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__567.prototype.invoke_994 = function ($this$mapPrototype, $cont) {
    var tmp = this.create_99($this$mapPrototype, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__567.prototype.invoke_1015 = function (p1, $cont) {
    return this.invoke_994(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__567.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          return new Scene2();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__567.prototype.create_99 = function ($this$mapPrototype, completion) {
    var i = new _no_name_provided__567(completion);
    i._$this$mapPrototype_1 = $this$mapPrototype;
    return i;
  };
  _no_name_provided__567.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__568(resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__568.prototype.invoke_994 = function ($this$mapPrototype, $cont) {
    var tmp = this.create_99($this$mapPrototype, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__568.prototype.invoke_1015 = function (p1, $cont) {
    return this.invoke_994(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $cont);
  };
  _no_name_provided__568.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        if (tmp === 0) {
          this._exceptionState = 1;
          return new Scene3();
        } else if (tmp === 1) {
          throw this._exception_0;
        }} catch ($p) {
        throw $p;
      }
     while (true);
  };
  _no_name_provided__568.prototype.create_99 = function ($this$mapPrototype, completion) {
    var i = new _no_name_provided__568(completion);
    i._$this$mapPrototype_2 = $this$mapPrototype;
    return i;
  };
  _no_name_provided__568.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function ConfigModule() {
    ConfigModule_instance = this;
    Module.call(this);
    this._bgcolor_3 = Colors_getInstance().get_91('#000000');
    this._size_14 = Companion_getInstance_87().invoke_325(512, 1080);
    this._mainScene_0 = getKClass_0(Scene1);
  }
  ConfigModule.prototype._get_bgcolor__1 = function () {
    return this._bgcolor_3;
  };
  ConfigModule.prototype._get_size__61 = function () {
    return this._size_14;
  };
  ConfigModule.prototype._get_mainScene__1 = function () {
    return this._mainScene_0;
  };
  ConfigModule.prototype._get_title__1 = function () {
    return '1Bit Jam';
  };
  ConfigModule.prototype.configure_1 = function (_this__0, $cont) {
    var tmp0_mapPrototype_0 = _no_name_provided_$factory_515(null);
    _this__0.mapPrototype(getKClass_0(Scene1), tmp0_mapPrototype_0);
    Unit_getInstance();
    var tmp1_mapPrototype_0 = _no_name_provided_$factory_516(null);
    _this__0.mapPrototype(getKClass_0(Scene2), tmp1_mapPrototype_0);
    Unit_getInstance();
    var tmp2_mapPrototype_0 = _no_name_provided_$factory_517(null);
    _this__0.mapPrototype(getKClass_0(Scene3), tmp2_mapPrototype_0);
    Unit_getInstance();
  };
  ConfigModule.$metadata$ = {
    simpleName: 'ConfigModule',
    kind: 'object',
    interfaces: []
  };
  var ConfigModule_instance;
  function ConfigModule_getInstance() {
    if (ConfigModule_instance == null)
      new ConfigModule();
    return ConfigModule_instance;
  }
  function _no_name_provided_$factory_515(resultContinuation) {
    var i = new _no_name_provided__566(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_994(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_516(resultContinuation) {
    var i = new _no_name_provided__567(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_994(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_517(resultContinuation) {
    var i = new _no_name_provided__568(resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_994(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided__569($tmp27_onClick_0, $it, resultContinuation) {
    this._$tmp27_onClick_0 = $tmp27_onClick_0;
    this._$it_18 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__569.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__569.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__569.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp27_onClick_0(this._$it_18, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__569.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__569(this._$tmp27_onClick_0, this._$it_18, completion);
    return i;
  };
  _no_name_provided__569.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__570($tmp33_onClick_0, $it, resultContinuation) {
    this._$tmp33_onClick_0 = $tmp33_onClick_0;
    this._$it_19 = $it;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__570.prototype.invoke_998 = function ($cont) {
    var tmp = this.create_101($cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__570.prototype.invoke_1005 = function ($cont) {
    this.invoke_998($cont);
    return Unit_getInstance();
  };
  _no_name_provided__570.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            this._state_1 = 1;
            suspendResult = this._$tmp33_onClick_0(this._$it_19, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__570.prototype.create_101 = function (completion) {
    var i = new _no_name_provided__570(this._$tmp33_onClick_0, this._$it_19, completion);
    return i;
  };
  _no_name_provided__570.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 0
  };
  function _no_name_provided__571($offset) {
    this._$offset_2 = $offset;
  }
  _no_name_provided__571.prototype.invoke_1000 = function ($this$addFixedUpdater) {
    this._$offset_2._v = new Angle(plus_5(this._$offset_2._v._radians, _get_degrees__0(10)));
  };
  _no_name_provided__571.prototype.invoke_1015 = function (p1) {
    this.invoke_1000(p1 instanceof Container ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__571.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__572($version) {
    this._$version = $version;
  }
  _no_name_provided__572.prototype.invoke_1005 = function () {
    var tmp0 = this._$version._v;
    this._$version._v = tmp0 + 1 | 0;
    return tmp0;
  };
  _no_name_provided__572.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__573($offset) {
    this._$offset_3 = $offset;
  }
  _no_name_provided__573.prototype.invoke_1006 = function ($this$CreateStringTextRenderer, text, n, c, c1, g, advance) {
    $this$CreateStringTextRenderer._transform_5.identity_0();
    Unit_getInstance();
    var tmp0_sin_0 = plus_5(this._$offset_3._v._radians, _get_degrees__0(imul(n, 360) / text.length | 0));
    var tmp0_sin_0_1 = _Angle___get_radians__impl_(tmp0_sin_0);
    var sin = Math.sin(tmp0_sin_0_1);
    $this$CreateStringTextRenderer._transform_5.translate_2(0.0, sin * 8);
    Unit_getInstance();
    $this$CreateStringTextRenderer._transform_5.scale_2(1.0, 1.0 + sin * 0.1);
    Unit_getInstance();
    $this$CreateStringTextRenderer.put_14(c);
    Unit_getInstance();
    $this$CreateStringTextRenderer.advance_2(advance);
  };
  _no_name_provided__573.prototype.invoke_1007 = function (p1, p2, p3, p4, p5, p6, p7) {
    var tmp = p1 instanceof TextRendererActions ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    var tmp_3 = (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE();
    var tmp_4 = p6 instanceof GlyphMetrics ? p6 : THROW_CCE();
    this.invoke_1006(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, (!(p7 == null) ? typeof p7 === 'number' : false) ? p7 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__573.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__574($version) {
    this._$version_0 = $version;
  }
  _no_name_provided__574.prototype.invoke_1005 = function () {
    var tmp0 = this._$version_0._v;
    this._$version_0._v = tmp0 + 1 | 0;
    return tmp0;
  };
  _no_name_provided__574.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__575($offset) {
    this._$offset_4 = $offset;
  }
  _no_name_provided__575.prototype.invoke_1006 = function ($this$CreateStringTextRenderer, text, n, c, c1, g, advance) {
    $this$CreateStringTextRenderer._transform_5.identity_0();
    Unit_getInstance();
    var tmp0_sin_0 = plus_5(this._$offset_4._v._radians, _get_degrees__0(imul(n, 360) / text.length | 0));
    var tmp0_sin_0_1 = _Angle___get_radians__impl_(tmp0_sin_0);
    var sin = Math.sin(tmp0_sin_0_1);
    $this$CreateStringTextRenderer._transform_5.translate_2(0.0, sin * 8);
    Unit_getInstance();
    $this$CreateStringTextRenderer._transform_5.scale_2(1.0, 1.0 + sin * 0.1);
    Unit_getInstance();
    $this$CreateStringTextRenderer.put_14(c);
    Unit_getInstance();
    $this$CreateStringTextRenderer.advance_2(advance);
  };
  _no_name_provided__575.prototype.invoke_1007 = function (p1, p2, p3, p4, p5, p6, p7) {
    var tmp = p1 instanceof TextRendererActions ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE();
    var tmp_2 = (!(p4 == null) ? typeof p4 === 'number' : false) ? p4 : THROW_CCE();
    var tmp_3 = (!(p5 == null) ? typeof p5 === 'number' : false) ? p5 : THROW_CCE();
    var tmp_4 = p6 instanceof GlyphMetrics ? p6 : THROW_CCE();
    this.invoke_1006(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, (!(p7 == null) ? typeof p7 === 'number' : false) ? p7 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__575.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__576(this$0, resultContinuation) {
    this._this$0_177 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__576.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__576.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__576.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_changeTo_00_3 = this._this$0_177._get_sceneContainer__2();
            var tmp_1 = this;
            tmp_1._tmp1_changeTo_01_3 = [];
            var tmp_2 = this;
            var tmp0__get_seconds__0_1 = 0;
            tmp_2._tmp2_changeTo_02_3 = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0_1);
            var tmp_3 = this;
            tmp_3._tmp3_changeTo_03_3 = this._tmp0_changeTo_00_3._defaultTransition;
            this._state_1 = 1;
            suspendResult = this._tmp0_changeTo_00_3.changeTo(getKClass_0(Scene2), this._tmp1_changeTo_01_3.slice(), this._tmp2_changeTo_02_3, this._tmp3_changeTo_03_3, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__576.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__576(this._this$0_177, completion);
    i._it_19 = it;
    return i;
  };
  _no_name_provided__576.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__577($tmp1_safe_receiver_1_2, $tmp27_onClick_0) {
    this._$tmp1_safe_receiver_1_2_9 = $tmp1_safe_receiver_1_2;
    this._$tmp27_onClick_0_0 = $tmp27_onClick_0;
  }
  _no_name_provided__577.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_9._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_518(this._$tmp27_onClick_0_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__577.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__577.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__578(this$0, resultContinuation) {
    this._this$0_178 = this$0;
    CoroutineImpl_0.call(this, resultContinuation);
  }
  _no_name_provided__578.prototype.invoke_1014 = function (it, $cont) {
    var tmp = this.create_103(it, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  _no_name_provided__578.prototype.invoke_1015 = function (p1, $cont) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $cont);
    return Unit_getInstance();
  };
  _no_name_provided__578.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            tmp_0._tmp0_changeTo_00_4 = this._this$0_178._get_sceneContainer__2();
            var tmp_1 = this;
            tmp_1._tmp1_changeTo_01_4 = [];
            var tmp_2 = this;
            var tmp0__get_seconds__0_1 = 0;
            tmp_2._tmp2_changeTo_02_4 = Companion_getInstance_27().fromSeconds(tmp0__get_seconds__0_1);
            var tmp_3 = this;
            tmp_3._tmp3_changeTo_03_4 = this._tmp0_changeTo_00_4._defaultTransition;
            this._state_1 = 1;
            suspendResult = this._tmp0_changeTo_00_4.changeTo(getKClass_0(Scene3), this._tmp1_changeTo_01_4.slice(), this._tmp2_changeTo_02_4, this._tmp3_changeTo_03_4, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            suspendResult;
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  _no_name_provided__578.prototype.create_103 = function (it, completion) {
    var i = new _no_name_provided__578(this._this$0_178, completion);
    i._it_20 = it;
    return i;
  };
  _no_name_provided__578.$metadata$ = {
    kind: 'class',
    interfaces: [],
    suspendArity: 1
  };
  function _no_name_provided__579($tmp1_safe_receiver_1_2, $tmp33_onClick_0) {
    this._$tmp1_safe_receiver_1_2_10 = $tmp1_safe_receiver_1_2;
    this._$tmp33_onClick_0_0 = $tmp33_onClick_0;
  }
  _no_name_provided__579.prototype.invoke_1014 = function (it) {
    var tmp = this._$tmp1_safe_receiver_1_2_10._get_coroutineContext__22();
    launchImmediately(tmp, _no_name_provided_$factory_519(this._$tmp33_onClick_0_0, it, null));
    Unit_getInstance();
  };
  _no_name_provided__579.prototype.invoke_1015 = function (p1) {
    this.invoke_1014(p1 instanceof MouseEvents ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__579.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function $sceneInitCOROUTINE$3(_this_, _this__0, resultContinuation) {
    CoroutineImpl_0.call(this, resultContinuation);
    this.__this__168 = _this_;
    this.__this__169 = _this__0;
  }
  $sceneInitCOROUTINE$3.prototype.doResume_275 = function () {
    var suspendResult = this._result_0;
    $sm: do
      try {
        var tmp = this._state_1;
        switch (tmp) {
          case 0:
            this._exceptionState = 2;
            var tmp_0 = this;
            var tmp_1 = Companion_getInstance_109();
            var tmp_2 = _get_DefaultTtfFont_();
            var tmp_3 = new RGBA(Colors_getInstance()._WHITE);
            tmp_0._font0 = tmp_1.invoke$default_3(tmp_2, 128.0, null, null, tmp_3, false, null, 108, null);
            this._offset1 = {_v: new Angle(_get_degrees__0(0))};
            var tmp_4 = _get_timesPerSecond_(60);
            addFixedUpdater$default(this.__this__169, tmp_4, false, 0, _no_name_provided_$factory_520(this._offset1), 6, null);
            Unit_getInstance();
            this._version2 = {_v: 0};
            var tmp0_alignment = Companion_getInstance_116()._BASELINE_LEFT;
            var tmp_5 = _no_name_provided_$factory_521(this._version2);
            var tmp1_renderer = CreateStringTextRenderer(tmp_5, _no_name_provided_$factory_522(this._offset1));
            var tmp0_text_0 = '1Pixel';
            var tmp1_text_0 = 128.0;
            var tmp2_text_0 = Colors_getInstance()._WHITE;
            var tmp3_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
            var tmp0_addTo_0_2 = new Text_2(tmp0_text_0, tmp1_text_0, tmp2_text_0, this._font0, tmp0_alignment, tmp1_renderer, tmp3_text_0);
            var tmp0_apply_0_2_3 = addTo(tmp0_addTo_0_2, this.__this__169);
            Unit_getInstance();
            position(tmp0_apply_0_2_3, 130, 250);
            Unit_getInstance();
            var tmp2_alignment = Companion_getInstance_116()._BASELINE_LEFT;
            var tmp_6 = _no_name_provided_$factory_523(this._version2);
            var tmp3_renderer = CreateStringTextRenderer(tmp_6, _no_name_provided_$factory_524(this._offset1));
            var tmp4_text_0 = 'JAM';
            var tmp5_text_0 = 128.0;
            var tmp6_text_0 = Colors_getInstance()._WHITE;
            var tmp7_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
            var tmp0_addTo_0_2_0 = new Text_2(tmp4_text_0, tmp5_text_0, tmp6_text_0, this._font0, tmp2_alignment, tmp3_renderer, tmp7_text_0);
            var tmp0_apply_0_2_3_0 = addTo(tmp0_addTo_0_2_0, this.__this__169);
            Unit_getInstance();
            position(tmp0_apply_0_2_3_0, 150, 350);
            Unit_getInstance();
            var tmp4_alignment = Companion_getInstance_116()._MIDDLE_RIGHT_0;
            var tmp8_text_0 = 'trial';
            var tmp9_text_0 = 48.0;
            var tmp10_text_0 = Colors_getInstance()._WHITE;
            var tmp11_text_0 = DefaultStringTextRenderer;
            var tmp12_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
            var tmp0_addTo_0_2_1 = new Text_2(tmp8_text_0, tmp9_text_0, tmp10_text_0, this._font0, tmp4_alignment, tmp11_text_0, tmp12_text_0);
            var tmp0_apply_0_2_3_1 = addTo(tmp0_addTo_0_2_1, this.__this__169);
            Unit_getInstance();
            position(tmp0_apply_0_2_3_1, 210, 500);
            Unit_getInstance();
            var tmp5_alignment = Companion_getInstance_116()._MIDDLE_LEFT_0;
            var tmp13_text_0 = 'endless';
            var tmp14_text_0 = 48.0;
            var tmp15_text_0 = Colors_getInstance()._WHITE;
            var tmp16_text_0 = DefaultStringTextRenderer;
            var tmp17_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
            var tmp0_addTo_0_2_2 = new Text_2(tmp13_text_0, tmp14_text_0, tmp15_text_0, this._font0, tmp5_alignment, tmp16_text_0, tmp17_text_0);
            var tmp0_apply_0_2_3_2 = addTo(tmp0_addTo_0_2_2, this.__this__169);
            Unit_getInstance();
            position(tmp0_apply_0_2_3_2, 275, 500);
            Unit_getInstance();
            this._state_1 = 1;
            var tmp_7 = _get_resourcesVfs_().get_115('arrow_white.png');
            suspendResult = readBitmap$default(tmp_7, null, null, 3, null, this);
            if (suspendResult === _get_COROUTINE_SUSPENDED_()) {
              return suspendResult;
            }
            continue $sm;
          case 1:
            var bitmap = suspendResult;
            var tmp18_image_0 = 0.0;
            var tmp19_image_0 = 0.0;
            var tmp0_addTo_0_2_3 = Image_init_$Create$_0(bitmap, tmp18_image_0, tmp19_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3_3 = addTo(tmp0_addTo_0_2_3, this.__this__169);
            Unit_getInstance();
            var image = position(scale$default(tmp0_apply_0_2_3_3, 0.03, 0.0, 2, null), 155, 555);
            var tmp20_image_0 = 0.0;
            var tmp21_image_0 = 0.0;
            var tmp0_addTo_0_2_4 = Image_init_$Create$_0(bitmap, tmp20_image_0, tmp21_image_0, null, false, 24, null);
            var tmp0_apply_0_2_3_4 = addTo(tmp0_addTo_0_2_4, this.__this__169);
            Unit_getInstance();
            var image2 = position(scale$default(tmp0_apply_0_2_3_4, 0.03, 0.0, 2, null), 330, 555);
            var tmp22_circle_0 = 50.0;
            var tmp23_circle_0 = Colors_getInstance()._WHITE;
            var tmp24_circle_0 = Colors_getInstance()._WHITE;
            var tmp25_circle_0 = 0.0;
            var tmp26_circle_0 = true;
            var tmp1_addTo_0_2 = new Circle(tmp22_circle_0, new RGBA(tmp23_circle_0), new RGBA(tmp24_circle_0), tmp25_circle_0, tmp26_circle_0);
            var tmp0_apply_0_3 = addTo(tmp1_addTo_0_2, this.__this__169);
            Unit_getInstance();
            var challengeCircle = xy_0(tmp0_apply_0_3, 125, 707);
            var tmp27_onClick_0 = _no_name_provided_$factory_525(this.__this__168, null);
            var tmp0_doMouseEvent_0_1 = click$factory_10();
            var tmp0_safe_receiver_2_3 = challengeCircle;
            var tmp1_safe_receiver_1_2 = tmp0_safe_receiver_2_3 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3);
            if (tmp1_safe_receiver_1_2 == null)
              null;
            else {
              var tmp_8 = tmp0_doMouseEvent_0_1.get(tmp1_safe_receiver_1_2);
              tmp_8.add_41(_no_name_provided_$factory_526(tmp1_safe_receiver_1_2, tmp27_onClick_0));
            }

            Unit_getInstance();
            Unit_getInstance();
            var tmp28_circle_0 = 50.0;
            var tmp29_circle_0 = Colors_getInstance()._WHITE;
            var tmp30_circle_0 = Colors_getInstance()._WHITE;
            var tmp31_circle_0 = 0.0;
            var tmp32_circle_0 = true;
            var tmp1_addTo_0_2_0 = new Circle(tmp28_circle_0, new RGBA(tmp29_circle_0), new RGBA(tmp30_circle_0), tmp31_circle_0, tmp32_circle_0);
            var tmp0_apply_0_3_0 = addTo(tmp1_addTo_0_2_0, this.__this__169);
            Unit_getInstance();
            var endlessCircle = xy_0(tmp0_apply_0_3_0, 300, 707);
            var tmp33_onClick_0 = _no_name_provided_$factory_527(this.__this__168, null);
            var tmp0_doMouseEvent_0_1_0 = click$factory_11();
            var tmp0_safe_receiver_2_3_0 = endlessCircle;
            var tmp1_safe_receiver_1_2_0 = tmp0_safe_receiver_2_3_0 == null ? null : _get_mouse_(tmp0_safe_receiver_2_3_0);
            if (tmp1_safe_receiver_1_2_0 == null)
              null;
            else {
              var tmp_9 = tmp0_doMouseEvent_0_1_0.get(tmp1_safe_receiver_1_2_0);
              tmp_9.add_41(_no_name_provided_$factory_528(tmp1_safe_receiver_1_2_0, tmp33_onClick_0));
            }

            Unit_getInstance();
            Unit_getInstance();
            var tmp34_roundRect_0 = 350.0;
            var tmp35_roundRect_0 = 70.0;
            var tmp36_roundRect_0 = 5.0;
            var tmp37_roundRect_0 = 5.0;
            var tmp38_roundRect_0 = Colors_getInstance()._TRANSPARENT_BLACK;
            var tmp39_roundRect_0 = Colors_getInstance()._WHITE;
            var tmp40_roundRect_0 = 4.0;
            var tmp41_roundRect_0 = true;
            var tmp0_addTo_0_2_5 = new RoundRect(tmp34_roundRect_0, tmp35_roundRect_0, tmp36_roundRect_0, tmp37_roundRect_0, new RGBA(tmp38_roundRect_0), new RGBA(tmp39_roundRect_0), tmp40_roundRect_0, tmp41_roundRect_0);
            var tmp0_apply_0_2_3_5 = addTo(tmp0_addTo_0_2_5, this.__this__169);
            Unit_getInstance();
            xy_0(tmp0_apply_0_2_3_5, 90, 807);
            Unit_getInstance();
            var tmp6_alignment = Companion_getInstance_116()._TOP_CENTER_0;
            var tmp42_text_0 = 'Made by';
            var tmp43_text_0 = 20.0;
            var tmp44_text_0 = Colors_getInstance()._WHITE;
            var tmp45_text_0 = DefaultStringTextRenderer;
            var tmp46_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
            var tmp0_addTo_0_2_6 = new Text_2(tmp42_text_0, tmp43_text_0, tmp44_text_0, this._font0, tmp6_alignment, tmp45_text_0, tmp46_text_0);
            var tmp0_apply_0_2_3_6 = addTo(tmp0_addTo_0_2_6, this.__this__169);
            Unit_getInstance();
            position(tmp0_apply_0_2_3_6, 265, 815);
            Unit_getInstance();
            var tmp7_alignment = Companion_getInstance_116()._TOP_CENTER_0;
            var tmp47_text_0 = 'Luciano Jung & Maria Lorenz';
            var tmp48_text_0 = 24.0;
            var tmp49_text_0 = Colors_getInstance()._WHITE;
            var tmp50_text_0 = DefaultStringTextRenderer;
            var tmp51_text_0 = Companion_getInstance_149()._DEFAULT_AUTO_SCALING;
            var tmp0_addTo_0_2_7 = new Text_2(tmp47_text_0, tmp48_text_0, tmp49_text_0, this._font0, tmp7_alignment, tmp50_text_0, tmp51_text_0);
            var tmp0_apply_0_2_3_7 = addTo(tmp0_addTo_0_2_7, this.__this__169);
            Unit_getInstance();
            position(tmp0_apply_0_2_3_7, 265, 835);
            Unit_getInstance();
            return Unit_getInstance();
          case 2:
            throw this._exception_0;
        }
      } catch ($p) {
        if (this._exceptionState === 2) {
          throw $p;
        } else {
          this._state_1 = this._exceptionState;
          this._exception_0 = $p;
        }
      }
     while (true);
  };
  $sceneInitCOROUTINE$3.$metadata$ = {
    simpleName: '$sceneInitCOROUTINE$3',
    kind: 'class',
    interfaces: []
  };
  function Scene1() {
    Scene.call(this);
  }
  Scene1.prototype.sceneInit_3 = function (_this__0, $cont) {
    var tmp = new $sceneInitCOROUTINE$3(this, _this__0, $cont);
    tmp._result_0 = Unit_getInstance();
    tmp._exception_0 = null;
    return tmp.doResume_275();
  };
  Scene1.$metadata$ = {
    simpleName: 'Scene1',
    kind: 'class',
    interfaces: []
  };
  function click$factory_10() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function click$factory_11() {
    return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
      return receiver._click;
    }, null);
  }
  function _no_name_provided_$factory_518($tmp27_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__569($tmp27_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_519($tmp33_onClick_0, $it, resultContinuation) {
    var i = new _no_name_provided__570($tmp33_onClick_0, $it, resultContinuation);
    var l = function ($cont) {
      return i.invoke_998($cont);
    };
    l.$arity = 0;
    return l;
  }
  function _no_name_provided_$factory_520($offset) {
    var i = new _no_name_provided__571($offset);
    return function (p1) {
      i.invoke_1000(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_521($version) {
    var i = new _no_name_provided__572($version);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_522($offset) {
    var i = new _no_name_provided__573($offset);
    return function (p1, p2, p3, p4, p5, p6, p7) {
      i.invoke_1006(p1, p2, p3, p4, p5, p6, p7);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_523($version) {
    var i = new _no_name_provided__574($version);
    return function () {
      return i.invoke_1005();
    };
  }
  function _no_name_provided_$factory_524($offset) {
    var i = new _no_name_provided__575($offset);
    return function (p1, p2, p3, p4, p5, p6, p7) {
      i.invoke_1006(p1, p2, p3, p4, p5, p6, p7);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_525(this$0, resultContinuation) {
    var i = new _no_name_provided__576(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_526($tmp1_safe_receiver_1_2, $tmp27_onClick_0) {
    var i = new _no_name_provided__577($tmp1_safe_receiver_1_2, $tmp27_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_527(this$0, resultContinuation) {
    var i = new _no_name_provided__578(this$0, resultContinuation);
    var l = function (p1, $cont) {
      return i.invoke_1014(p1, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function _no_name_provided_$factory_528($tmp1_safe_receiver_1_2, $tmp33_onClick_0) {
    var i = new _no_name_provided__579($tmp1_safe_receiver_1_2, $tmp33_onClick_0);
    return function (p1) {
      i.invoke_1014(p1);
      return Unit_getInstance();
    };
  }
  AbstractMap.prototype._get_entries__10 = Map_0.prototype._get_entries__10;
  CombinedContext.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  AbstractCoroutineContextElement.prototype.get_113 = Element_0.prototype.get_113;
  AbstractCoroutineContextElement.prototype.fold_34 = Element_0.prototype.fold_34;
  AbstractCoroutineContextElement.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  AbstractCoroutineContextElement.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  UByteIterator.prototype.hasNext_33 = Iterator_3.prototype.hasNext_33;
  UIntIterator.prototype.hasNext_33 = Iterator_3.prototype.hasNext_33;
  ULongIterator.prototype.hasNext_33 = Iterator_3.prototype.hasNext_33;
  UShortIterator.prototype.hasNext_33 = Iterator_3.prototype.hasNext_33;
  IntIterator.prototype.hasNext_33 = Iterator_3.prototype.hasNext_33;
  LongIterator.prototype.hasNext_33 = Iterator_3.prototype.hasNext_33;
  CharIterator.prototype.hasNext_33 = Iterator_3.prototype.hasNext_33;
  AbstractMutableList.prototype.get_137 = List.prototype.get_137;
  AbstractMutableMap.prototype._get_entries__10 = MutableMap.prototype._get_entries__10;
  InternalHashCodeMap.prototype.createJsMap_0 = InternalMap.prototype.createJsMap_0;
  KClassImpl.prototype._get_simpleName__4 = KClass.prototype._get_simpleName__4;
  BaseConsole.prototype.appendAnsiScape_1 = AnsiEscape.prototype.appendAnsiScape_1;
  BaseConsole.prototype.appendAnsiScape$default_1 = AnsiEscape.prototype.appendAnsiScape$default_1;
  BaseConsole.prototype.appendReset_1 = AnsiEscape.prototype.appendReset_1;
  BaseConsole.prototype.appendFgColor_1 = AnsiEscape.prototype.appendFgColor_1;
  BaseConsole.prototype.appendFgColor$default_1 = AnsiEscape.prototype.appendFgColor$default_1;
  Console_0.prototype.appendAnsiScape_1 = AnsiEscape.prototype.appendAnsiScape_1;
  Console_0.prototype.appendAnsiScape$default_1 = AnsiEscape.prototype.appendAnsiScape$default_1;
  Console_0.prototype.appendReset_1 = AnsiEscape.prototype.appendReset_1;
  Console_0.prototype.appendFgColor_1 = AnsiEscape.prototype.appendFgColor_1;
  Console_0.prototype.appendFgColor$default_1 = AnsiEscape.prototype.appendFgColor$default_1;
  JobSupport.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  JobSupport.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  JobSupport.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  JobSupport.prototype.get_113 = Element_0.prototype.get_113;
  JobSupport.prototype.fold_34 = Element_0.prototype.fold_34;
  JobSupport.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  AbstractCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  AbstractCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  AbstractCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  AbstractCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  AbstractCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  AbstractCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  StandaloneCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  StandaloneCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  StandaloneCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  StandaloneCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  StandaloneCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  StandaloneCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  LazyStandaloneCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  LazyStandaloneCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  LazyStandaloneCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  LazyStandaloneCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  LazyStandaloneCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  LazyStandaloneCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  DeferredCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  DeferredCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  DeferredCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  DeferredCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  DeferredCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  DeferredCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  LazyDeferredCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  LazyDeferredCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  LazyDeferredCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  LazyDeferredCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  LazyDeferredCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  LazyDeferredCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  ScopeCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  ScopeCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  ScopeCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  ScopeCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  ScopeCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  ScopeCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  DispatchedCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  DispatchedCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  DispatchedCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  DispatchedCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  DispatchedCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  DispatchedCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  SchedulerTask.prototype.run_5 = Runnable.prototype.run_5;
  CompletableDeferredImpl.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  CompletableDeferredImpl.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  CompletableDeferredImpl.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  CompletableDeferredImpl.prototype.get_113 = Element_0.prototype.get_113;
  CompletableDeferredImpl.prototype.fold_34 = Element_0.prototype.fold_34;
  CompletableDeferredImpl.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  CoroutineDispatcher.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  CoroutineDispatcher.prototype.fold_34 = Element_0.prototype.fold_34;
  CoroutineDispatcher.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  CoroutineDispatcher.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  EventLoop.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  EventLoop.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  EventLoop.prototype.fold_34 = Element_0.prototype.fold_34;
  EventLoop.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  JobImpl.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  JobImpl.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  JobImpl.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  JobImpl.prototype.get_113 = Element_0.prototype.get_113;
  JobImpl.prototype.fold_34 = Element_0.prototype.fold_34;
  JobImpl.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  MainCoroutineDispatcher.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  MainCoroutineDispatcher.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  MainCoroutineDispatcher.prototype.fold_34 = Element_0.prototype.fold_34;
  MainCoroutineDispatcher.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  SupervisorJobImpl.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  SupervisorJobImpl.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  SupervisorJobImpl.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  SupervisorJobImpl.prototype.get_113 = Element_0.prototype.get_113;
  SupervisorJobImpl.prototype.fold_34 = Element_0.prototype.fold_34;
  SupervisorJobImpl.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  TimeoutCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  TimeoutCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  TimeoutCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  TimeoutCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  TimeoutCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  TimeoutCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  Unconfined.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  Unconfined.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  Unconfined.prototype.fold_34 = Element_0.prototype.fold_34;
  Unconfined.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  Receive.prototype.tryResumeReceive_3 = ReceiveOrClosed.prototype.tryResumeReceive_3;
  Receive.prototype.completeResumeReceive_3 = ReceiveOrClosed.prototype.completeResumeReceive_3;
  AbstractSendChannel.prototype.close$default_7 = SendChannel.prototype.close$default_7;
  AbstractChannel.prototype.close$default_7 = SendChannel.prototype.close$default_7;
  ArrayChannel.prototype.close$default_7 = SendChannel.prototype.close$default_7;
  ChannelCoroutine.prototype.close$default_7 = SendChannel.prototype.close$default_7;
  ChannelCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  ChannelCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  ChannelCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  ChannelCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  ChannelCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  ChannelCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  ConflatedChannel.prototype.close$default_7 = SendChannel.prototype.close$default_7;
  LinkedListChannel.prototype.close$default_7 = SendChannel.prototype.close$default_7;
  ProducerCoroutine.prototype.close$default_7 = SendChannel.prototype.close$default_7;
  ProducerCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  ProducerCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  ProducerCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  ProducerCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  ProducerCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  ProducerCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  RendezvousChannel.prototype.close$default_7 = SendChannel.prototype.close$default_7;
  UndispatchedCoroutine.prototype.invokeOnCompletion$default_14 = Job.prototype.invokeOnCompletion$default_14;
  UndispatchedCoroutine.prototype.cancel$default_14 = Job.prototype.cancel$default_14;
  UndispatchedCoroutine.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  UndispatchedCoroutine.prototype.get_113 = Element_0.prototype.get_113;
  UndispatchedCoroutine.prototype.fold_34 = Element_0.prototype.fold_34;
  UndispatchedCoroutine.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  JsMainDispatcher.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  JsMainDispatcher.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  JsMainDispatcher.prototype.fold_34 = Element_0.prototype.fold_34;
  JsMainDispatcher.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  UnconfinedEventLoop.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  UnconfinedEventLoop.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  UnconfinedEventLoop.prototype.fold_34 = Element_0.prototype.fold_34;
  UnconfinedEventLoop.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  SetTimeoutBasedDispatcher.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  SetTimeoutBasedDispatcher.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  SetTimeoutBasedDispatcher.prototype.fold_34 = Element_0.prototype.fold_34;
  SetTimeoutBasedDispatcher.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  NodeDispatcher.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  NodeDispatcher.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  NodeDispatcher.prototype.fold_34 = Element_0.prototype.fold_34;
  NodeDispatcher.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  SetTimeoutDispatcher.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  SetTimeoutDispatcher.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  SetTimeoutDispatcher.prototype.fold_34 = Element_0.prototype.fold_34;
  SetTimeoutDispatcher.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  WindowDispatcher.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  WindowDispatcher.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  WindowDispatcher.prototype.fold_34 = Element_0.prototype.fold_34;
  WindowDispatcher.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  _no_name_provided__79.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  _no_name_provided__79.prototype.fold_34 = Element_0.prototype.fold_34;
  _no_name_provided__79.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  _no_name_provided__79.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  _no_name_provided__79.prototype.releaseInterceptedContinuation_11 = ContinuationInterceptor.prototype.releaseInterceptedContinuation_11;
  _no_name_provided__79.prototype.invokeOnTimeout_5 = Delay.prototype.invokeOnTimeout_5;
  _no_name_provided__85.prototype.write_26 = AsyncOutputStream.prototype.write_26;
  BitReader.prototype.read_36 = AsyncInputStream.prototype.read_36;
  AsyncStream.prototype.read_36 = AsyncInputStream.prototype.read_36;
  AsyncStream.prototype.write_26 = AsyncOutputStream.prototype.write_26;
  _no_name_provided__133.prototype.read_36 = AsyncInputStream.prototype.read_36;
  _no_name_provided__134.prototype.write_26 = AsyncOutputStream.prototype.write_26;
  SyncStream.prototype.read$default_1 = SyncInputStream.prototype.read$default_1;
  Adler32.prototype.update$default_1 = SimpleChecksum.prototype.update$default_1;
  CRC32.prototype.update$default_1 = SimpleChecksum.prototype.update$default_1;
  Easings.prototype.invoke_358 = Easing.prototype.invoke_358;
  BmpSlice.prototype._set_extra__71 = Extra.prototype._set_extra__71;
  BmpSlice.prototype._get_extra__71 = Extra.prototype._get_extra__71;
  ColorFormat24.prototype.getR_7 = ColorFormat.prototype.getR_7;
  ColorFormat24.prototype.getG_7 = ColorFormat.prototype.getG_7;
  ColorFormat24.prototype.getB_7 = ColorFormat.prototype.getB_7;
  ColorFormat24.prototype.getA_7 = ColorFormat.prototype.getA_7;
  ColorFormat24.prototype.pack_8 = ColorFormat.prototype.pack_8;
  ColorFormat32.prototype.getR_7 = ColorFormat.prototype.getR_7;
  ColorFormat32.prototype.getG_7 = ColorFormat.prototype.getG_7;
  ColorFormat32.prototype.getB_7 = ColorFormat.prototype.getB_7;
  ColorFormat32.prototype.getA_7 = ColorFormat.prototype.getA_7;
  ColorFormat32.prototype.pack_8 = ColorFormat.prototype.pack_8;
  BitmapFont.prototype.getFontMetrics$default_0 = Font.prototype.getFontMetrics$default_0;
  BitmapFont.prototype.getGlyphMetrics$default_0 = Font.prototype.getGlyphMetrics$default_0;
  TtfFont.prototype.getFontMetrics$default_0 = Font.prototype.getFontMetrics$default_0;
  TtfFont.prototype.getGlyphMetrics$default_0 = Font.prototype.getGlyphMetrics$default_0;
  TtfFont.prototype.getGlyphPath$default_0 = VectorFont.prototype.getGlyphPath$default_0;
  TtfFont.prototype.renderGlyph_2 = VectorFont.prototype.renderGlyph_2;
  TtfFont.prototype.getOrNull_4 = Font.prototype.getOrNull_4;
  _no_name_provided__240.prototype.invoke_409 = TextRenderer.prototype.invoke_409;
  CompoundShape.prototype.getPath$default = Shape.prototype.getPath$default;
  CompoundShape.prototype._get_bounds__5 = Shape.prototype._get_bounds__5;
  CompoundShape.prototype._get_width__58 = BoundsDrawable.prototype._get_width__58;
  CompoundShape.prototype._get_height__58 = BoundsDrawable.prototype._get_height__58;
  FillShape.prototype.addBounds_3 = StyledShape.prototype.addBounds_3;
  FillShape.prototype.getPath_3 = StyledShape.prototype.getPath_3;
  FillShape.prototype.getPath$default = Shape.prototype.getPath$default;
  FillShape.prototype.draw_10 = StyledShape.prototype.draw_10;
  FillShape.prototype._get_bounds__5 = Shape.prototype._get_bounds__5;
  FillShape.prototype._get_width__58 = BoundsDrawable.prototype._get_width__58;
  FillShape.prototype._get_height__58 = BoundsDrawable.prototype._get_height__58;
  PolylineShape.prototype.getPath_3 = StyledShape.prototype.getPath_3;
  PolylineShape.prototype.getPath$default = Shape.prototype.getPath$default;
  PolylineShape.prototype.draw_10 = StyledShape.prototype.draw_10;
  PolylineShape.prototype._get_bounds__5 = Shape.prototype._get_bounds__5;
  PolylineShape.prototype._get_width__58 = BoundsDrawable.prototype._get_width__58;
  PolylineShape.prototype._get_height__58 = BoundsDrawable.prototype._get_height__58;
  KmlGl.prototype.activeTexture_1 = IKmlGl.prototype.activeTexture_1;
  KmlGl.prototype.attachShader_1 = IKmlGl.prototype.attachShader_1;
  KmlGl.prototype.bindBuffer_1 = IKmlGl.prototype.bindBuffer_1;
  KmlGl.prototype.bindFramebuffer_1 = IKmlGl.prototype.bindFramebuffer_1;
  KmlGl.prototype.bindRenderbuffer_1 = IKmlGl.prototype.bindRenderbuffer_1;
  KmlGl.prototype.bindTexture_1 = IKmlGl.prototype.bindTexture_1;
  KmlGl.prototype.blendEquationSeparate_1 = IKmlGl.prototype.blendEquationSeparate_1;
  KmlGl.prototype.blendFuncSeparate_1 = IKmlGl.prototype.blendFuncSeparate_1;
  KmlGl.prototype.bufferData_1 = IKmlGl.prototype.bufferData_1;
  KmlGl.prototype.clear_27 = IKmlGl.prototype.clear_27;
  KmlGl.prototype.clearColor_1 = IKmlGl.prototype.clearColor_1;
  KmlGl.prototype.clearDepthf_0 = IKmlGl.prototype.clearDepthf_0;
  KmlGl.prototype.clearStencil_1 = IKmlGl.prototype.clearStencil_1;
  KmlGl.prototype.colorMask_1 = IKmlGl.prototype.colorMask_1;
  KmlGl.prototype.compileShader_1 = IKmlGl.prototype.compileShader_1;
  KmlGl.prototype.createProgram_1 = IKmlGl.prototype.createProgram_1;
  KmlGl.prototype.createShader_1 = IKmlGl.prototype.createShader_1;
  KmlGl.prototype.deleteBuffers_0 = IKmlGl.prototype.deleteBuffers_0;
  KmlGl.prototype.deleteFramebuffers_0 = IKmlGl.prototype.deleteFramebuffers_0;
  KmlGl.prototype.deleteProgram_1 = IKmlGl.prototype.deleteProgram_1;
  KmlGl.prototype.deleteRenderbuffers_0 = IKmlGl.prototype.deleteRenderbuffers_0;
  KmlGl.prototype.deleteShader_1 = IKmlGl.prototype.deleteShader_1;
  KmlGl.prototype.deleteTextures_0 = IKmlGl.prototype.deleteTextures_0;
  KmlGl.prototype.depthFunc_1 = IKmlGl.prototype.depthFunc_1;
  KmlGl.prototype.depthMask_1 = IKmlGl.prototype.depthMask_1;
  KmlGl.prototype.depthRangef_0 = IKmlGl.prototype.depthRangef_0;
  KmlGl.prototype.disable_2 = IKmlGl.prototype.disable_2;
  KmlGl.prototype.disableVertexAttribArray_1 = IKmlGl.prototype.disableVertexAttribArray_1;
  KmlGl.prototype.drawArrays_1 = IKmlGl.prototype.drawArrays_1;
  KmlGl.prototype.drawElements_1 = IKmlGl.prototype.drawElements_1;
  KmlGl.prototype.enable_2 = IKmlGl.prototype.enable_2;
  KmlGl.prototype.enableVertexAttribArray_1 = IKmlGl.prototype.enableVertexAttribArray_1;
  KmlGl.prototype.framebufferRenderbuffer_1 = IKmlGl.prototype.framebufferRenderbuffer_1;
  KmlGl.prototype.framebufferTexture2D_1 = IKmlGl.prototype.framebufferTexture2D_1;
  KmlGl.prototype.frontFace_1 = IKmlGl.prototype.frontFace_1;
  KmlGl.prototype.genBuffers_0 = IKmlGl.prototype.genBuffers_0;
  KmlGl.prototype.generateMipmap_1 = IKmlGl.prototype.generateMipmap_1;
  KmlGl.prototype.genFramebuffers_0 = IKmlGl.prototype.genFramebuffers_0;
  KmlGl.prototype.genRenderbuffers_0 = IKmlGl.prototype.genRenderbuffers_0;
  KmlGl.prototype.genTextures_0 = IKmlGl.prototype.genTextures_0;
  KmlGl.prototype.getAttribLocation_2 = IKmlGl.prototype.getAttribLocation_2;
  KmlGl.prototype.getUniformLocation_1 = IKmlGl.prototype.getUniformLocation_1;
  KmlGl.prototype.getError_1 = IKmlGl.prototype.getError_1;
  KmlGl.prototype.getIntegerv_0 = IKmlGl.prototype.getIntegerv_0;
  KmlGl.prototype.getProgramiv_0 = IKmlGl.prototype.getProgramiv_0;
  KmlGl.prototype.getShaderiv_0 = IKmlGl.prototype.getShaderiv_0;
  KmlGl.prototype.getShaderInfoLog_1 = IKmlGl.prototype.getShaderInfoLog_1;
  KmlGl.prototype.getString_1 = IKmlGl.prototype.getString_1;
  KmlGl.prototype.lineWidth_1 = IKmlGl.prototype.lineWidth_1;
  KmlGl.prototype.linkProgram_1 = IKmlGl.prototype.linkProgram_1;
  KmlGl.prototype.pixelStorei_1 = IKmlGl.prototype.pixelStorei_1;
  KmlGl.prototype.renderbufferStorage_1 = IKmlGl.prototype.renderbufferStorage_1;
  KmlGl.prototype.scissor_1 = IKmlGl.prototype.scissor_1;
  KmlGl.prototype.shaderSource_1 = IKmlGl.prototype.shaderSource_1;
  KmlGl.prototype.stencilFunc_1 = IKmlGl.prototype.stencilFunc_1;
  KmlGl.prototype.stencilMask_1 = IKmlGl.prototype.stencilMask_1;
  KmlGl.prototype.stencilOp_1 = IKmlGl.prototype.stencilOp_1;
  KmlGl.prototype.texImage2D_2 = IKmlGl.prototype.texImage2D_2;
  KmlGl.prototype.texImage2D_3 = IKmlGl.prototype.texImage2D_3;
  KmlGl.prototype.texParameteri_1 = IKmlGl.prototype.texParameteri_1;
  KmlGl.prototype.uniform1f_1 = IKmlGl.prototype.uniform1f_1;
  KmlGl.prototype.uniform1fv_1 = IKmlGl.prototype.uniform1fv_1;
  KmlGl.prototype.uniform1i_1 = IKmlGl.prototype.uniform1i_1;
  KmlGl.prototype.uniform2f_1 = IKmlGl.prototype.uniform2f_1;
  KmlGl.prototype.uniform2fv_1 = IKmlGl.prototype.uniform2fv_1;
  KmlGl.prototype.uniform3f_1 = IKmlGl.prototype.uniform3f_1;
  KmlGl.prototype.uniform3fv_1 = IKmlGl.prototype.uniform3fv_1;
  KmlGl.prototype.uniform4f_1 = IKmlGl.prototype.uniform4f_1;
  KmlGl.prototype.uniform4fv_1 = IKmlGl.prototype.uniform4fv_1;
  KmlGl.prototype.uniformMatrix2fv_1 = IKmlGl.prototype.uniformMatrix2fv_1;
  KmlGl.prototype.uniformMatrix3fv_1 = IKmlGl.prototype.uniformMatrix3fv_1;
  KmlGl.prototype.uniformMatrix4fv_1 = IKmlGl.prototype.uniformMatrix4fv_1;
  KmlGl.prototype.useProgram_1 = IKmlGl.prototype.useProgram_1;
  KmlGl.prototype.vertexAttribPointer_1 = IKmlGl.prototype.vertexAttribPointer_1;
  KmlGl.prototype.viewport_1 = IKmlGl.prototype.viewport_1;
  KmlGl.prototype.enableDisable_1 = IKmlGl.prototype.enableDisable_1;
  BaseRenderBufferImpl.prototype.setSize$default_4 = BaseRenderBuffer.prototype.setSize$default_4;
  BaseRenderBufferImpl.prototype.init_15 = BaseRenderBuffer.prototype.init_15;
  BaseRenderBufferImpl.prototype.set_28 = BaseRenderBuffer.prototype.set_28;
  BaseRenderBufferImpl.prototype.unset_4 = BaseRenderBuffer.prototype.unset_4;
  RenderBuffer.prototype.setSize$default_4 = BaseRenderBuffer.prototype.setSize$default_4;
  RenderBuffer.prototype.init_15 = BaseRenderBuffer.prototype.init_15;
  RenderBuffer.prototype.unset_4 = BaseRenderBuffer.prototype.unset_4;
  GlRenderBuffer.prototype.setSize$default_4 = BaseRenderBuffer.prototype.setSize$default_4;
  GlRenderBuffer.prototype.init_15 = BaseRenderBuffer.prototype.init_15;
  GlRenderBuffer.prototype.unset_4 = BaseRenderBuffer.prototype.unset_4;
  _no_name_provided__277.prototype.setSize$default_4 = BaseRenderBuffer.prototype.setSize$default_4;
  LogRenderBuffer.prototype.setSize$default_4 = BaseRenderBuffer.prototype.setSize$default_4;
  LogRenderBuffer.prototype.init_15 = BaseRenderBuffer.prototype.init_15;
  LogRenderBuffer.prototype.unset_4 = BaseRenderBuffer.prototype.unset_4;
  GameWindow.prototype.get_113 = Element_0.prototype.get_113;
  GameWindow.prototype.fold_34 = Element_0.prototype.fold_34;
  GameWindow.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  GameWindow.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  GameWindowCoroutineDispatcher.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  GameWindowCoroutineDispatcher.prototype.get_113 = ContinuationInterceptor.prototype.get_113;
  GameWindowCoroutineDispatcher.prototype.fold_34 = Element_0.prototype.fold_34;
  GameWindowCoroutineDispatcher.prototype.minusKey_35 = ContinuationInterceptor.prototype.minusKey_35;
  KmlGlJsCanvas.prototype.enableDisable_1 = IKmlGl.prototype.enableDisable_1;
  NodeJsGameWindow.prototype.get_113 = Element_0.prototype.get_113;
  NodeJsGameWindow.prototype.fold_34 = Element_0.prototype.fold_34;
  NodeJsGameWindow.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  NodeJsGameWindow.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  BrowserGameWindow.prototype.get_113 = Element_0.prototype.get_113;
  BrowserGameWindow.prototype.fold_34 = Element_0.prototype.fold_34;
  BrowserGameWindow.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  BrowserGameWindow.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  AsyncInjectorContext.prototype.get_113 = Element_0.prototype.get_113;
  AsyncInjectorContext.prototype.fold_34 = Element_0.prototype.fold_34;
  AsyncInjectorContext.prototype.minusKey_35 = Element_0.prototype.minusKey_35;
  AsyncInjectorContext.prototype.plus_36 = CoroutineContext.prototype.plus_36;
  Image.prototype.forceLoadSourceFile$default_1 = ViewFileRef.prototype.forceLoadSourceFile$default_1;
  Mixin_2.prototype.forceLoadSourceFile$default_1 = ViewFileRef.prototype.forceLoadSourceFile$default_1;
  _stableSortingIsSupported = null;
  output = output$init$();
  EmptyContinuation = EmptyContinuation$init$();
  INV_2_26 = INV_2_26$init$();
  INV_2_53 = INV_2_53$init$();
  functionClasses = functionClasses$init$();
  buf = new ArrayBuffer(8);
  bufFloat64 = bufFloat64$init$();
  bufFloat32 = bufFloat32$init$();
  bufInt32 = bufInt32$init$();
  lowIndex = lowIndex$init$();
  highIndex = 1 - lowIndex | 0;
  ZERO = fromInt(0);
  ONE = fromInt(1);
  NEG_ONE = fromInt(-1);
  MAX_VALUE = new Long(-1, 2147483647);
  MIN_VALUE = new Long(0, -2147483648);
  TWO_PWR_24_ = fromInt(16777216);
  propertyRefClassMetadataCache = propertyRefClassMetadataCache$init$();
  KlockLocale_default = Companion_getInstance_21();
  ExtendedTimezoneNames = ExtendedTimezoneNames$init$();
  klockIsKotlinNative = false;
  isNode = typeof window === 'undefined';
  initialHrTime$delegate = klockAtomicLazy(_no_name_provided_$factory_34());
  CONCURRENCY_COUNT = 1;
  KmemGC = KmemGC$init$();
  EmptyByteArray = new Int8Array(1);
  EmptyShortArray = new Int16Array(1);
  EmptyIntArray = new Int32Array(1);
  EmptyFloatArray = new Float32Array(1);
  randomUnittesting = false;
  isNodeJs$delegate = lazy(_no_name_provided_$factory_41());
  _global = typeof global !== 'undefined' ? global : self;
  isNative = false;
  RESUME_TOKEN = new Symbol('RESUME_TOKEN');
  COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
  COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
  COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
  TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
  SEALED = new Symbol('SEALED');
  EMPTY_NEW = new Empty(false);
  EMPTY_ACTIVE = new Empty(true);
  EMPTY = new Symbol('EMPTY');
  OFFER_SUCCESS = new Symbol('OFFER_SUCCESS');
  OFFER_FAILED = new Symbol('OFFER_FAILED');
  POLL_FAILED = new Symbol('POLL_FAILED');
  ENQUEUE_FAILED = new Symbol('ENQUEUE_FAILED');
  HANDLER_INVOKED = new Symbol('ON_CLOSE_HANDLER_INVOKED');
  UNDEFINED = new Symbol('UNDEFINED');
  REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
  counter = 0;
  DEBUG = false;
  DEFAULT_SUSPEND_TEST_TIMEOUT = DEFAULT_SUSPEND_TEST_TIMEOUT$init$();
  Deflate$delegate = lazy(_no_name_provided_$factory_62());
  defaultDynApi = DynamicInternal_getInstance();
  dynApi = DynamicInternal_getInstance();
  Mapper = new ObjectMapper();
  resourcesVfsDebug = false;
  defaultUniSchema = defaultUniSchema$init$();
  bytesTempPool$delegate = new threadLocal(_no_name_provided_$factory_87());
  smallBytesPool$delegate = new threadLocal(_no_name_provided_$factory_88());
  LATIN1 = ISO_8859_1_getInstance();
  UTF16_LE = new UTF16Charset(true);
  UTF16_BE = new UTF16Charset(false);
  customEnvironments = null;
  formatRegex = Regex_init_$Create$('%([-]?\\d+)?(\\w)');
  replaceNonPrintableCharactersRegex$delegate = lazy(_no_name_provided_$factory_91());
  MimeType_byExtensions$delegate = lazy(_no_name_provided_$factory_92());
  _defaultHttpFactory$delegate = lazy(_no_name_provided_$factory_97());
  EMPTY_BYTE_ARRAY = new Int8Array(0);
  traceTimes$delegate = lazy(_no_name_provided_$factory_104());
  LONG_ZERO_TO_MAX_RANGE = (new Long(0, 0)).rangeTo_12(new Long(-1, 2147483647));
  Language_CURRENT$delegate = lazy(_no_name_provided_$factory_114());
  jsLocalStorageVfs$delegate = lazy(_no_name_provided_$factory_117());
  jsbaseUrl$delegate = lazy(_no_name_provided_$factory_118());
  globalDynamic = typeof global !== 'undefined' ? global : self;
  global = globalDynamic;
  isWeb$delegate = lazy(_no_name_provided_$factory_119());
  isWorker$delegate = lazy(_no_name_provided_$factory_120());
  isNodeJs$delegate_0 = lazy(_no_name_provided_$factory_121());
  File_separatorChar = new Char(47);
  tmpdir$delegate = lazy(_no_name_provided_$factory_124());
  absoluteCwd$delegate = lazy(_no_name_provided_$factory_125());
  resourcesVfs$delegate = lazy(_no_name_provided_$factory_126());
  rootLocalVfs$delegate = lazy(_no_name_provided_$factory_127());
  applicationVfs$delegate = lazy(_no_name_provided_$factory_128());
  applicationDataVfs$delegate = lazy(_no_name_provided_$factory_129());
  cacheVfs$delegate = lazy(_no_name_provided_$factory_130());
  externalStorageVfs$delegate = lazy(_no_name_provided_$factory_131());
  userHomeVfs$delegate = lazy(_no_name_provided_$factory_132());
  tempVfs$delegate = lazy(_no_name_provided_$factory_133());
  UTF8 = UTF8$init$();
  asyncSocketFactory$delegate = lazy(_no_name_provided_$factory_134());
  httpFactory$delegate = lazy(_no_name_provided_$factory_135());
  rawOsName$delegate = lazy(_no_name_provided_$factory_139());
  rawPlatformName = rawPlatformName$init$();
  systemLanguageStrings$delegate = lazy(_no_name_provided_$factory_140());
  defaultAudioFormats$delegate = lazy(_no_name_provided_$factory_141());
  temp = new Float32Array(1);
  nativeSoundProvider$delegate = lazy(_no_name_provided_$factory_163());
  tempMat3D = new Matrix3D();
  tempVec1 = new Vector3D();
  tempVec2 = new Vector3D();
  tempVec3 = new Vector3D();
  tempMat1 = new Matrix3D();
  tempMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  identityMatrix = Matrix_init_$Create$(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 63, null);
  DefaultTtfFontBytes = DefaultTtfFontBytes$init$();
  DefaultTtfFont$delegate = lazy(_no_name_provided_$factory_188());
  linuxFolders = listOf(['/usr/share/fonts', '/usr/local/share/fonts', '~/.fonts']);
  windowsFolders = listOf_0('%WINDIR%\\Fonts');
  macosFolders = listOf(['/System/Library/Fonts/', '/Library/Fonts/', '~/Library/Fonts/', '/Network/Library/Fonts/']);
  fourcc$delegate = Property_init_$Create$(null, _no_name_provided_$factory_192(), 1, null);
  nativeImageLoadingEnabled = true;
  RegisteredImageFormats_formats = ImageFormats_init_$Create$([BMP_getInstance(), TGA_getInstance()]);
  DefaultStringTextRenderer = CreateStringTextRenderer$default(null, _no_name_provided_$factory_198(), 1, null);
  nativeSystemFontProvider = new FallbackNativeSystemFontProvider(_get_DefaultTtfFont_());
  nativeImageFormatProvider = nativeImageFormatProvider$init$();
  tempB = new ArrayBuffer(4);
  tempI = new Int32Array(tempB);
  temp8 = new Uint8Array(tempB);
  isLittleEndian$delegate = lazy(_no_name_provided_$factory_208());
  versionString$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_235(), 1, null);
  versionInt$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_236(), 1, null);
  GLOBAL_CHECK_GL = false;
  korgwJvmEngine = null;
  uiComponent$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_248(), 1, null);
  layoutChildrenPadding$delegate = Property_init_$Create$(null, _no_name_provided_$factory_249(), 1, null);
  DEFAULT_WIDTH = new PT(128.0);
  DEFAULT_HEIGHT = new PT(32.0);
  preferredSize$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_250(), 1, null);
  minimumSize$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_251(), 1, null);
  maximumSize$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_252(), 1, null);
  reactUid$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_253(), 1, null);
  knownControllers = knownControllers$init$();
  DEFAULT_UI_FACTORY = DummyUiFactory_getInstance();
  debugPrintln$delegate = debugPrintln$delegate$init$();
  formatRegex_0 = Regex_init_$Create$('%([-]?\\d+)?(\\w)');
  charToEntity = linkedMapOf([to(new Char(34), '&quot;'), to(new Char(39), '&apos;'), to(new Char(60), '&lt;'), to(new Char(62), '&gt;'), to(new Char(38), '&amp;')]);
  Mapper2 = new JsObjectMapper2();
  animateLibraryLoaders$delegate = Property_init_$Create$(null, _no_name_provided_$factory_308(), 1, null);
  lengths$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_313(), 1, null);
  width$delegate = width$delegate$init$();
  height$delegate = height$delegate$init$();
  x$delegate = x$delegate$init$();
  y$delegate = y$delegate$init$();
  scale$delegate = scale$delegate$init$();
  scaleX$delegate = scaleX$delegate$init$();
  scaleY$delegate = scaleY$delegate$init$();
  extraLanguage$delegate = Property_init_$Create$(null, _no_name_provided_$factory_315(), 1, null);
  gamepad$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_316(), 1, null);
  keys$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_318(), 1, null);
  mouse$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_322(), 1, null);
  logger = Companion_getInstance_39().invoke_203('BatchBuilder2D');
  debugLineRenderContext$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_334(), 1, null);
  logger_0 = Companion_getInstance_39().invoke_203('RenderContext2D');
  debugBmpFont$delegate = lazy(_no_name_provided_$factory_351());
  AlphaTransition = new Transition(_no_name_provided_$factory_362());
  storage$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_364(), 1, null);
  fadeThread$delegate = fadeThread$delegate$init$();
  changing$delegate = changing$delegate$init$();
  tilemapLog = Companion_getInstance_39().invoke_203('tilemap');
  spaces = Regex_init_$Create$('\\s+');
  DEFAULT_EASING = Companion_getInstance_96()._get_EASE_IN_OUT_QUAD_();
  DEFAULT_TIME = DEFAULT_TIME$init$();
  koruiComponent$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_373(), 1, null);
  defaultTextSkin$delegate = defaultTextSkin$delegate$init$();
  defaultUIFont$delegate = defaultUIFont$delegate$init$();
  defaultUISkin$delegate = defaultUISkin$delegate$init$();
  defaultCheckSkin$delegate = defaultCheckSkin$delegate$init$();
  defaultUpSkin$delegate = defaultUpSkin$delegate$init$();
  defaultDownSkin$delegate = defaultDownSkin$delegate$init$();
  defaultLeftSkin$delegate = defaultLeftSkin$delegate$init$();
  defaultRightSkin$delegate = defaultRightSkin$delegate$init$();
  defaultComboBoxSkin$delegate = defaultComboBoxSkin$delegate$init$();
  defaultVerScrollBarSkin$delegate = defaultVerScrollBarSkin$delegate$init$();
  defaultHorScrollBarSkin$delegate = defaultHorScrollBarSkin$delegate$init$();
  DefaultTextSkin$delegate = lazy(_no_name_provided_$factory_443());
  DEFAULT_UI_SKIN_IMG$delegate = lazy(_no_name_provided_$factory_444());
  DefaultUISkin$delegate = lazy(_no_name_provided_$factory_445());
  DefaultIconSkins$delegate = lazy(_no_name_provided_$factory_446());
  DefaultComboBoxSkin$delegate = lazy(_no_name_provided_$factory_447());
  DefaultVerScrollBarSkin$delegate = lazy(_no_name_provided_$factory_448());
  DefaultHorScrollBarSkin$delegate = lazy(_no_name_provided_$factory_449());
  collisionContext$delegate = new threadLocal(_no_name_provided_$factory_471());
  views$delegate = PropertyThis_init_$Create$(null, _no_name_provided_$factory_473(), 1, null);
  registerFilterSerialization$delegate = Property_init_$Create$(null, _no_name_provided_$factory_476(), 1, null);
  vector3DTemps = new Vector3DTemps();
  main(_get_EmptyContinuation_());
  return _;
}));
